
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $c631c755fc42cf75$exports = {};
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


(function webpackUniversalModuleDefinition(root, factory) {
    $c631c755fc42cf75$exports = factory();
})($c631c755fc42cf75$exports, ()=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ 50792: /***/ (module1)=>{
                "use strict";
                var has = Object.prototype.hasOwnProperty, prefix = '~';
                /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
                //
                // We try to not inherit from `Object.prototype`. In some engines creating an
                // instance in this way is faster than calling `Object.create(null)` directly.
                // If `Object.create(null)` is not supported we prefix the event names with a
                // character to make sure that the built-in object properties are not
                // overridden or used as an attack vector.
                //
                if (Object.create) {
                    Events.prototype = Object.create(null);
                    //
                    // This hack is needed because the `__proto__` property is still inherited in
                    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                    //
                    if (!new Events().__proto__) prefix = false;
                }
                /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
                    this.fn = fn;
                    this.context = context;
                    this.once = once || false;
                }
                /**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
                    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
                    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
                    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
                    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
                    else emitter._events[evt] = [
                        emitter._events[evt],
                        listener
                    ];
                    return emitter;
                }
                /**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
                    if (--emitter._eventsCount === 0) emitter._events = new Events();
                    else delete emitter._events[evt];
                }
                /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                    var names = [], events, name;
                    if (this._eventsCount === 0) return names;
                    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                    return names;
                };
                /**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
                    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
                    if (!handlers) return [];
                    if (handlers.fn) return [
                        handlers.fn
                    ];
                    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
                    return ee;
                };
                /**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
                    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
                    if (!listeners) return 0;
                    if (listeners.fn) return 1;
                    return listeners.length;
                };
                /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                    var evt = prefix ? prefix + event : event;
                    if (!this._events[evt]) return false;
                    var listeners = this._events[evt], len = arguments.length, args, i;
                    if (listeners.fn) {
                        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                        switch(len){
                            case 1:
                                return listeners.fn.call(listeners.context), true;
                            case 2:
                                return listeners.fn.call(listeners.context, a1), true;
                            case 3:
                                return listeners.fn.call(listeners.context, a1, a2), true;
                            case 4:
                                return listeners.fn.call(listeners.context, a1, a2, a3), true;
                            case 5:
                                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                            case 6:
                                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                        }
                        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                        listeners.fn.apply(listeners.context, args);
                    } else {
                        var length = listeners.length, j;
                        for(i = 0; i < length; i++){
                            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                            switch(len){
                                case 1:
                                    listeners[i].fn.call(listeners[i].context);
                                    break;
                                case 2:
                                    listeners[i].fn.call(listeners[i].context, a1);
                                    break;
                                case 3:
                                    listeners[i].fn.call(listeners[i].context, a1, a2);
                                    break;
                                case 4:
                                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                    break;
                                default:
                                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                    listeners[i].fn.apply(listeners[i].context, args);
                            }
                        }
                    }
                    return true;
                };
                /**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                    return addListener(this, event, fn, context, false);
                };
                /**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                    return addListener(this, event, fn, context, true);
                };
                /**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                    var evt = prefix ? prefix + event : event;
                    if (!this._events[evt]) return this;
                    if (!fn) {
                        clearEvent(this, evt);
                        return this;
                    }
                    var listeners = this._events[evt];
                    if (listeners.fn) {
                        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
                    } else {
                        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                        //
                        // Reset the array, or remove it completely if we have no more listeners.
                        //
                        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                        else clearEvent(this, evt);
                    }
                    return this;
                };
                /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                    var evt;
                    if (event) {
                        evt = prefix ? prefix + event : event;
                        if (this._events[evt]) clearEvent(this, evt);
                    } else {
                        this._events = new Events();
                        this._eventsCount = 0;
                    }
                    return this;
                };
                //
                // Alias methods names because people roll like that.
                //
                EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                EventEmitter.prototype.addListener = EventEmitter.prototype.on;
                //
                // Expose the prefix.
                //
                EventEmitter.prefixed = prefix;
                //
                // Allow `EventEmitter` to be imported as module namespace.
                //
                EventEmitter.EventEmitter = EventEmitter;
                module1.exports = EventEmitter;
            /***/ },
            /***/ 11517: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var QuickSet = __webpack_require__(38829);
                /**
 * Takes an array of Game Objects and aligns them next to each other.
 *
 * The alignment position is controlled by the `position` parameter, which should be one
 * of the Phaser.Display.Align constants, such as `Phaser.Display.Align.TOP_LEFT`,
 * `Phaser.Display.Align.TOP_CENTER`, etc.
 *
 * The first item isn't moved. The second item is aligned next to the first,
 * then the third next to the second, and so on.
 *
 * @function Phaser.Actions.AlignTo
 * @since 3.22.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} position - The position to align the items with. This is an align constant, such as `Phaser.Display.Align.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var AlignTo = function(items, position, offsetX, offsetY) {
                    var target = items[0];
                    for(var i = 1; i < items.length; i++){
                        var item = items[i];
                        QuickSet(item, target, position, offsetX, offsetY);
                        target = item;
                    }
                    return items;
                };
                module1.exports = AlignTo;
            /***/ },
            /***/ 80318: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have a public `angle` property,
 * and then adds the given value to each of their `angle` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `Angle(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.Angle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `angle` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var Angle = function(items, value, step, index, direction) {
                    return PropertyValueInc(items, 'angle', value, step, index, direction);
                };
                module1.exports = Angle;
            /***/ },
            /***/ 60757: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and passes each of them to the given callback.
 *
 * @function Phaser.Actions.Call
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {Phaser.Types.Actions.CallCallback} callback - The callback to be invoked. It will be passed just one argument: the item from the array.
 * @param {*} context - The scope in which the callback will be invoked.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that was passed to this Action.
 */ var Call = function(items, callback, context) {
                    for(var i = 0; i < items.length; i++){
                        var item = items[i];
                        callback.call(context, item);
                    }
                    return items;
                };
                module1.exports = Call;
            /***/ },
            /***/ 69927: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and returns the first element in the array that has properties which match
 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
 * then it would return the first item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
 *
 * To use this with a Group: `GetFirst(group.getChildren(), compare, index)`
 *
 * @function Phaser.Actions.GetFirst
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 *
 * @return {?(object|Phaser.GameObjects.GameObject)} The first object in the array that matches the comparison object, or `null` if no match was found.
 */ var GetFirst = function(items, compare, index) {
                    if (index === undefined) index = 0;
                    for(var i = index; i < items.length; i++){
                        var item = items[i];
                        var match = true;
                        for(var property in compare)if (item[property] !== compare[property]) match = false;
                        if (match) return item;
                    }
                    return null;
                };
                module1.exports = GetFirst;
            /***/ },
            /***/ 32265: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and returns the last element in the array that has properties which match
 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
 * then it would return the last item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
 *
 * To use this with a Group: `GetLast(group.getChildren(), compare, index)`
 *
 * @function Phaser.Actions.GetLast
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 *
 * @return {?(object|Phaser.GameObjects.GameObject)} The last object in the array that matches the comparison object, or `null` if no match was found.
 */ var GetLast = function(items, compare, index) {
                    if (index === undefined) index = 0;
                    for(var i = items.length - 1; i >= index; i--){
                        var item = items[i];
                        var match = true;
                        for(var property in compare)if (item[property] !== compare[property]) match = false;
                        if (match) return item;
                    }
                    return null;
                };
                module1.exports = GetLast;
            /***/ },
            /***/ 94420: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AlignIn = __webpack_require__(11879);
                var CONST = __webpack_require__(60461);
                var GetFastValue = __webpack_require__(95540);
                var NOOP = __webpack_require__(29747);
                var Zone = __webpack_require__(41481);
                var tempZone = new Zone({
                    sys: {
                        queueDepthSort: NOOP,
                        events: {
                            once: NOOP
                        }
                    }
                }, 0, 0, 1, 1).setOrigin(0, 0);
                /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
 * and then aligns them based on the grid configuration given to this action.
 *
 * @function Phaser.Actions.GridAlign
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {Phaser.Types.Actions.GridAlignConfig} options - The GridAlign Configuration object.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var GridAlign = function(items, options) {
                    if (options === undefined) options = {};
                    var widthSet = options.hasOwnProperty('width');
                    var heightSet = options.hasOwnProperty('height');
                    var width = GetFastValue(options, 'width', -1);
                    var height = GetFastValue(options, 'height', -1);
                    var cellWidth = GetFastValue(options, 'cellWidth', 1);
                    var cellHeight = GetFastValue(options, 'cellHeight', cellWidth);
                    var position = GetFastValue(options, 'position', CONST.TOP_LEFT);
                    var x = GetFastValue(options, 'x', 0);
                    var y = GetFastValue(options, 'y', 0);
                    var cx = 0;
                    var cy = 0;
                    var w = width * cellWidth;
                    var h = height * cellHeight;
                    tempZone.setPosition(x, y);
                    tempZone.setSize(cellWidth, cellHeight);
                    for(var i = 0; i < items.length; i++){
                        AlignIn(items[i], tempZone, position);
                        if (widthSet && width === -1) //  We keep laying them out horizontally until we've done them all
                        tempZone.x += cellWidth;
                        else if (heightSet && height === -1) //  We keep laying them out vertically until we've done them all
                        tempZone.y += cellHeight;
                        else if (heightSet && !widthSet) {
                            //  We keep laying them out until we hit the column limit
                            cy += cellHeight;
                            tempZone.y += cellHeight;
                            if (cy === h) {
                                cy = 0;
                                cx += cellWidth;
                                tempZone.y = y;
                                tempZone.x += cellWidth;
                                if (cx === w) break;
                            }
                        } else {
                            //  We keep laying them out until we hit the column limit
                            cx += cellWidth;
                            tempZone.x += cellWidth;
                            if (cx === w) {
                                cx = 0;
                                cy += cellHeight;
                                tempZone.x = x;
                                tempZone.y += cellHeight;
                                if (cy === h) break;
                            }
                        }
                    }
                    return items;
                };
                module1.exports = GridAlign;
            /***/ },
            /***/ 41721: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have a public `alpha` property,
 * and then adds the given value to each of their `alpha` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncAlpha(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncAlpha
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `alpha` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncAlpha = function(items, value, step, index, direction) {
                    return PropertyValueInc(items, 'alpha', value, step, index, direction);
                };
                module1.exports = IncAlpha;
            /***/ },
            /***/ 67285: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have a public `x` property,
 * and then adds the given value to each of their `x` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `x` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncX = function(items, value, step, index, direction) {
                    return PropertyValueInc(items, 'x', value, step, index, direction);
                };
                module1.exports = IncX;
            /***/ },
            /***/ 9074: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
 * and then adds the given value to each of them.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncXY(group.getChildren(), x, y, stepX, stepY)`
 *
 * @function Phaser.Actions.IncXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} x - The amount to be added to the `x` property.
 * @param {number} [y=x] - The amount to be added to the `y` property. If `undefined` or `null` it uses the `x` value.
 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncXY = function(items, x, y, stepX, stepY, index, direction) {
                    if (y === undefined || y === null) y = x;
                    PropertyValueInc(items, 'x', x, stepX, index, direction);
                    return PropertyValueInc(items, 'y', y, stepY, index, direction);
                };
                module1.exports = IncXY;
            /***/ },
            /***/ 75222: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have a public `y` property,
 * and then adds the given value to each of their `y` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `y` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncY = function(items, value, step, index, direction) {
                    return PropertyValueInc(items, 'y', value, step, index, direction);
                };
                module1.exports = IncY;
            /***/ },
            /***/ 22983: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of a Circle.
 *
 * If you wish to pass a `Phaser.GameObjects.Circle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnCircle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Circle} circle - The Circle to position the Game Objects on.
 * @param {number} [startAngle=0] - Optional angle to start position from, in radians.
 * @param {number} [endAngle=6.28] - Optional angle to stop position at, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnCircle = function(items, circle, startAngle, endAngle) {
                    if (startAngle === undefined) startAngle = 0;
                    if (endAngle === undefined) endAngle = 6.28;
                    var angle = startAngle;
                    var angleStep = (endAngle - startAngle) / items.length;
                    var cx = circle.x;
                    var cy = circle.y;
                    var radius = circle.radius;
                    for(var i = 0; i < items.length; i++){
                        items[i].x = cx + radius * Math.cos(angle);
                        items[i].y = cy + radius * Math.sin(angle);
                        angle += angleStep;
                    }
                    return items;
                };
                module1.exports = PlaceOnCircle;
            /***/ },
            /***/ 95253: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of an Ellipse.
 * 
 * If you wish to pass a `Phaser.GameObjects.Ellipse` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnEllipse
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to position the Game Objects on.
 * @param {number} [startAngle=0] - Optional angle to start position from, in radians.
 * @param {number} [endAngle=6.28] - Optional angle to stop position at, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnEllipse = function(items, ellipse, startAngle, endAngle) {
                    if (startAngle === undefined) startAngle = 0;
                    if (endAngle === undefined) endAngle = 6.28;
                    var angle = startAngle;
                    var angleStep = (endAngle - startAngle) / items.length;
                    var a = ellipse.width / 2;
                    var b = ellipse.height / 2;
                    for(var i = 0; i < items.length; i++){
                        items[i].x = ellipse.x + a * Math.cos(angle);
                        items[i].y = ellipse.y + b * Math.sin(angle);
                        angle += angleStep;
                    }
                    return items;
                };
                module1.exports = PlaceOnEllipse;
            /***/ },
            /***/ 88505: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetPoints = __webpack_require__(15258);
                var GetEasedPoints = __webpack_require__(26708);
                /**
 * Positions an array of Game Objects on evenly spaced points of a Line.
 * If the ease parameter is supplied, it will space the points based on that easing function along the line.
 *
 * @function Phaser.Actions.PlaceOnLine
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Line} line - The Line to position the Game Objects on.
 * @param {(string|function)} [ease] - An optional ease to use. This can be either a string from the EaseMap, or a custom function.
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnLine = function(items, line, ease) {
                    var points;
                    if (ease) points = GetEasedPoints(line, ease, items.length);
                    else points = GetPoints(line, items.length);
                    for(var i = 0; i < items.length; i++){
                        var item = items[i];
                        var point = points[i];
                        item.x = point.x;
                        item.y = point.y;
                    }
                    return items;
                };
                module1.exports = PlaceOnLine;
            /***/ },
            /***/ 41346: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MarchingAnts = __webpack_require__(14649);
                var RotateLeft = __webpack_require__(86003);
                var RotateRight = __webpack_require__(49498);
                /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of a Rectangle.
 * 
 * Placement starts from the top-left of the rectangle, and proceeds in a clockwise direction.
 * If the `shift` parameter is given you can offset where placement begins.
 *
 * @function Phaser.Actions.PlaceOnRectangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to position the Game Objects on.
 * @param {number} [shift=0] - An optional positional offset.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnRectangle = function(items, rect, shift) {
                    if (shift === undefined) shift = 0;
                    var points = MarchingAnts(rect, false, items.length);
                    if (shift > 0) RotateLeft(points, shift);
                    else if (shift < 0) RotateRight(points, Math.abs(shift));
                    for(var i = 0; i < items.length; i++){
                        items[i].x = points[i].x;
                        items[i].y = points[i].y;
                    }
                    return items;
                };
                module1.exports = PlaceOnRectangle;
            /***/ },
            /***/ 11575: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BresenhamPoints = __webpack_require__(84993);
                /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the edges of a Triangle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Triangle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnTriangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to position the Game Objects on.
 * @param {number} [stepRate=1] - An optional step rate, to increase or decrease the packing of the Game Objects on the lines.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnTriangle = function(items, triangle, stepRate) {
                    var p1 = BresenhamPoints({
                        x1: triangle.x1,
                        y1: triangle.y1,
                        x2: triangle.x2,
                        y2: triangle.y2
                    }, stepRate);
                    var p2 = BresenhamPoints({
                        x1: triangle.x2,
                        y1: triangle.y2,
                        x2: triangle.x3,
                        y2: triangle.y3
                    }, stepRate);
                    var p3 = BresenhamPoints({
                        x1: triangle.x3,
                        y1: triangle.y3,
                        x2: triangle.x1,
                        y2: triangle.y1
                    }, stepRate);
                    //  Remove overlaps
                    p1.pop();
                    p2.pop();
                    p3.pop();
                    p1 = p1.concat(p2, p3);
                    var step = p1.length / items.length;
                    var p = 0;
                    for(var i = 0; i < items.length; i++){
                        var item = items[i];
                        var point = p1[Math.floor(p)];
                        item.x = point.x;
                        item.y = point.y;
                        p += step;
                    }
                    return items;
                };
                module1.exports = PlaceOnTriangle;
            /***/ },
            /***/ 29953: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Play an animation on all Game Objects in the array that have an Animation component.
 *
 * You can pass either an animation key, or an animation configuration object for more control over the playback.
 *
 * @function Phaser.Actions.PlayAnimation
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
 * @param {boolean} [ignoreIfPlaying=false] - If this animation is already playing then ignore this call.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlayAnimation = function(items, key, ignoreIfPlaying) {
                    for(var i = 0; i < items.length; i++){
                        var gameObject = items[i];
                        if (gameObject.anims) gameObject.anims.play(key, ignoreIfPlaying);
                    }
                    return items;
                };
                module1.exports = PlayAnimation;
            /***/ },
            /***/ 66979: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
 * and then adds the given value to it.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `PropertyValueInc(group.getChildren(), key, value, step)`
 *
 * @function Phaser.Actions.PropertyValueInc
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {string} key - The property to be updated.
 * @param {number} value - The amount to be added to the property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var PropertyValueInc = function(items, key, value, step, index, direction) {
                    if (step === undefined) step = 0;
                    if (index === undefined) index = 0;
                    if (direction === undefined) direction = 1;
                    var i;
                    var t = 0;
                    var end = items.length;
                    if (direction === 1) //  Start to End
                    for(i = index; i < end; i++){
                        items[i][key] += value + t * step;
                        t++;
                    }
                    else //  End to Start
                    for(i = index; i >= 0; i--){
                        items[i][key] += value + t * step;
                        t++;
                    }
                    return items;
                };
                module1.exports = PropertyValueInc;
            /***/ },
            /***/ 43967: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `PropertyValueSet(group.getChildren(), key, value, step)`
 *
 * @function Phaser.Actions.PropertyValueSet
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {string} key - The property to be updated.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var PropertyValueSet = function(items, key, value, step, index, direction) {
                    if (step === undefined) step = 0;
                    if (index === undefined) index = 0;
                    if (direction === undefined) direction = 1;
                    var i;
                    var t = 0;
                    var end = items.length;
                    if (direction === 1) //  Start to End
                    for(i = index; i < end; i++){
                        items[i][key] = value + t * step;
                        t++;
                    }
                    else //  End to Start
                    for(i = index; i >= 0; i--){
                        items[i][key] = value + t * step;
                        t++;
                    }
                    return items;
                };
                module1.exports = PropertyValueSet;
            /***/ },
            /***/ 88926: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(28176);
                /**
 * Takes an array of Game Objects and positions them at random locations within the Circle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Circle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomCircle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Circle} circle - The Circle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomCircle = function(items, circle) {
                    for(var i = 0; i < items.length; i++)Random(circle, items[i]);
                    return items;
                };
                module1.exports = RandomCircle;
            /***/ },
            /***/ 33286: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(24820);
                /**
 * Takes an array of Game Objects and positions them at random locations within the Ellipse.
 * 
 * If you wish to pass a `Phaser.GameObjects.Ellipse` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomEllipse
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomEllipse = function(items, ellipse) {
                    for(var i = 0; i < items.length; i++)Random(ellipse, items[i]);
                    return items;
                };
                module1.exports = RandomEllipse;
            /***/ },
            /***/ 96000: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(65822);
                /**
 * Takes an array of Game Objects and positions them at random locations on the Line.
 * 
 * If you wish to pass a `Phaser.GameObjects.Line` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomLine
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Line} line - The Line to position the Game Objects randomly on.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomLine = function(items, line) {
                    for(var i = 0; i < items.length; i++)Random(line, items[i]);
                    return items;
                };
                module1.exports = RandomLine;
            /***/ },
            /***/ 28789: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(26597);
                /**
 * Takes an array of Game Objects and positions them at random locations within the Rectangle.
 *
 * @function Phaser.Actions.RandomRectangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomRectangle = function(items, rect) {
                    for(var i = 0; i < items.length; i++)Random(rect, items[i]);
                    return items;
                };
                module1.exports = RandomRectangle;
            /***/ },
            /***/ 97154: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(90260);
                /**
 * Takes an array of Game Objects and positions them at random locations within the Triangle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Triangle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomTriangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomTriangle = function(items, triangle) {
                    for(var i = 0; i < items.length; i++)Random(triangle, items[i]);
                    return items;
                };
                module1.exports = RandomTriangle;
            /***/ },
            /***/ 20510: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have a public `rotation` property,
 * and then adds the given value to each of their `rotation` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `Rotate(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `rotation` property (in radians).
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var Rotate = function(items, value, step, index, direction) {
                    return PropertyValueInc(items, 'rotation', value, step, index, direction);
                };
                module1.exports = Rotate;
            /***/ },
            /***/ 91051: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundDistance = __webpack_require__(1163);
                var DistanceBetween = __webpack_require__(20339);
                /**
 * Rotates each item around the given point by the given angle.
 *
 * @function Phaser.Actions.RotateAround
 * @since 3.0.0
 * @see Phaser.Math.RotateAroundDistance
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {object} point - Any object with public `x` and `y` properties.
 * @param {number} angle - The angle to rotate by, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RotateAround = function(items, point, angle) {
                    var x = point.x;
                    var y = point.y;
                    for(var i = 0; i < items.length; i++){
                        var item = items[i];
                        RotateAroundDistance(item, x, y, angle, Math.max(1, DistanceBetween(item.x, item.y, x, y)));
                    }
                    return items;
                };
                module1.exports = RotateAround;
            /***/ },
            /***/ 76332: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathRotateAroundDistance = __webpack_require__(1163);
                /**
 * Rotates an array of Game Objects around a point by the given angle and distance.
 *
 * @function Phaser.Actions.RotateAroundDistance
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {object} point - Any object with public `x` and `y` properties.
 * @param {number} angle - The angle to rotate by, in radians.
 * @param {number} distance - The distance from the point of rotation in pixels.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RotateAroundDistance = function(items, point, angle, distance) {
                    var x = point.x;
                    var y = point.y;
                    //  There's nothing to do
                    if (distance === 0) return items;
                    for(var i = 0; i < items.length; i++)MathRotateAroundDistance(items[i], x, y, angle, distance);
                    return items;
                };
                module1.exports = RotateAroundDistance;
            /***/ },
            /***/ 61619: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have a public `scaleX` property,
 * and then adds the given value to each of their `scaleX` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.ScaleX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `scaleX` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleX = function(items, value, step, index, direction) {
                    return PropertyValueInc(items, 'scaleX', value, step, index, direction);
                };
                module1.exports = ScaleX;
            /***/ },
            /***/ 94868: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have public `scaleX` and `scaleY` properties,
 * and then adds the given value to each of them.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleXY(group.getChildren(), scaleX, scaleY, stepX, stepY)`
 *
 * @function Phaser.Actions.ScaleXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scaleX - The amount to be added to the `scaleX` property.
 * @param {number} [scaleY] - The amount to be added to the `scaleY` property. If `undefined` or `null` it uses the `scaleX` value.
 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleXY = function(items, scaleX, scaleY, stepX, stepY, index, direction) {
                    if (scaleY === undefined || scaleY === null) scaleY = scaleX;
                    PropertyValueInc(items, 'scaleX', scaleX, stepX, index, direction);
                    return PropertyValueInc(items, 'scaleY', scaleY, stepY, index, direction);
                };
                module1.exports = ScaleXY;
            /***/ },
            /***/ 95532: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(66979);
                /**
 * Takes an array of Game Objects, or any objects that have a public `scaleY` property,
 * and then adds the given value to each of their `scaleY` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.ScaleY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `scaleY` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleY = function(items, value, step, index, direction) {
                    return PropertyValueInc(items, 'scaleY', value, step, index, direction);
                };
                module1.exports = ScaleY;
            /***/ },
            /***/ 8689: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `alpha`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetAlpha(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetAlpha
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetAlpha = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'alpha', value, step, index, direction);
                };
                module1.exports = SetAlpha;
            /***/ },
            /***/ 2645: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `blendMode`
 * and then sets it to the given value.
 *
 * To use this with a Group: `SetBlendMode(group.getChildren(), value)`
 *
 * @function Phaser.Actions.SetBlendMode
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {(Phaser.BlendModes|string|number)} value - The Blend Mode to be set.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetBlendMode = function(items, value, index, direction) {
                    return PropertyValueSet(items, 'blendMode', value, 0, index, direction);
                };
                module1.exports = SetBlendMode;
            /***/ },
            /***/ 32372: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `depth`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetDepth(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetDepth
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetDepth = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'depth', value, step, index, direction);
                };
                module1.exports = SetDepth;
            /***/ },
            /***/ 85373: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Passes all provided Game Objects to the Input Manager to enable them for input with identical areas and callbacks.
 *
 * @see {@link Phaser.GameObjects.GameObject#setInteractive}
 *
 * @function Phaser.Actions.SetHitArea
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not given it will try to create a Rectangle based on the texture frame.
 * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The callback that determines if the pointer is within the Hit Area shape or not. If you provide a shape you must also provide a callback.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SetHitArea = function(items, hitArea, hitAreaCallback) {
                    for(var i = 0; i < items.length; i++)items[i].setInteractive(hitArea, hitAreaCallback);
                    return items;
                };
                module1.exports = SetHitArea;
            /***/ },
            /***/ 81583: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public properties `originX` and `originY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetOrigin(group.getChildren(), originX, originY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetOrigin
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} originX - The amount to set the `originX` property to.
 * @param {number} [originY] - The amount to set the `originY` property to. If `undefined` or `null` it uses the `originX` value.
 * @param {number} [stepX=0] - This is added to the `originX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `originY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetOrigin = function(items, originX, originY, stepX, stepY, index, direction) {
                    if (originY === undefined || originY === null) originY = originX;
                    PropertyValueSet(items, 'originX', originX, stepX, index, direction);
                    PropertyValueSet(items, 'originY', originY, stepY, index, direction);
                    items.forEach(function(item) {
                        item.updateDisplayOrigin();
                    });
                    return items;
                };
                module1.exports = SetOrigin;
            /***/ },
            /***/ 79939: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `rotation`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetRotation(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetRotation
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetRotation = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'rotation', value, step, index, direction);
                };
                module1.exports = SetRotation;
            /***/ },
            /***/ 2699: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public properties `scaleX` and `scaleY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScale(group.getChildren(), scaleX, scaleY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetScale
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scaleX - The amount to set the `scaleX` property to.
 * @param {number} [scaleY] - The amount to set the `scaleY` property to. If `undefined` or `null` it uses the `scaleX` value.
 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScale = function(items, scaleX, scaleY, stepX, stepY, index, direction) {
                    if (scaleY === undefined || scaleY === null) scaleY = scaleX;
                    PropertyValueSet(items, 'scaleX', scaleX, stepX, index, direction);
                    return PropertyValueSet(items, 'scaleY', scaleY, stepY, index, direction);
                };
                module1.exports = SetScale;
            /***/ },
            /***/ 98739: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `scaleX`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScaleX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScaleX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScaleX = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'scaleX', value, step, index, direction);
                };
                module1.exports = SetScaleX;
            /***/ },
            /***/ 98476: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `scaleY`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScaleY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScaleY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScaleY = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'scaleY', value, step, index, direction);
                };
                module1.exports = SetScaleY;
            /***/ },
            /***/ 6207: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public properties `scrollFactorX` and `scrollFactorY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactor(group.getChildren(), scrollFactorX, scrollFactorY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetScrollFactor
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scrollFactorX - The amount to set the `scrollFactorX` property to.
 * @param {number} [scrollFactorY] - The amount to set the `scrollFactorY` property to. If `undefined` or `null` it uses the `scrollFactorX` value.
 * @param {number} [stepX=0] - This is added to the `scrollFactorX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scrollFactorY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactor = function(items, scrollFactorX, scrollFactorY, stepX, stepY, index, direction) {
                    if (scrollFactorY === undefined || scrollFactorY === null) scrollFactorY = scrollFactorX;
                    PropertyValueSet(items, 'scrollFactorX', scrollFactorX, stepX, index, direction);
                    return PropertyValueSet(items, 'scrollFactorY', scrollFactorY, stepY, index, direction);
                };
                module1.exports = SetScrollFactor;
            /***/ },
            /***/ 6607: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `scrollFactorX`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactorX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScrollFactorX
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactorX = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'scrollFactorX', value, step, index, direction);
                };
                module1.exports = SetScrollFactorX;
            /***/ },
            /***/ 72248: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `scrollFactorY`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactorY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScrollFactorY
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactorY = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'scrollFactorY', value, step, index, direction);
                };
                module1.exports = SetScrollFactorY;
            /***/ },
            /***/ 14036: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have the public method setTint() and then updates it to the given value(s). You can specify tint color per corner or provide only one color value for `topLeft` parameter, in which case whole item will be tinted with that color.
 *
 * @function Phaser.Actions.SetTint
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {number} topLeft - The tint being applied to top-left corner of item. If other parameters are given no value, this tint will be applied to whole item.
 * @param {number} [topRight] - The tint to be applied to top-right corner of item.
 * @param {number} [bottomLeft] - The tint to be applied to the bottom-left corner of item.
 * @param {number} [bottomRight] - The tint to be applied to the bottom-right corner of item.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SetTint = function(items, topLeft, topRight, bottomLeft, bottomRight) {
                    for(var i = 0; i < items.length; i++)items[i].setTint(topLeft, topRight, bottomLeft, bottomRight);
                    return items;
                };
                module1.exports = SetTint;
            /***/ },
            /***/ 50159: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `visible`
 * and then sets it to the given value.
 *
 * To use this with a Group: `SetVisible(group.getChildren(), value)`
 *
 * @function Phaser.Actions.SetVisible
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {boolean} value - The value to set the property to.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetVisible = function(items, value, index, direction) {
                    return PropertyValueSet(items, 'visible', value, 0, index, direction);
                };
                module1.exports = SetVisible;
            /***/ },
            /***/ 77597: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `x`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetX = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'x', value, step, index, direction);
                };
                module1.exports = SetX;
            /***/ },
            /***/ 83194: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public properties `x` and `y`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetXY(group.getChildren(), x, y, stepX, stepY)`
 *
 * @function Phaser.Actions.SetXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} x - The amount to set the `x` property to.
 * @param {number} [y=x] - The amount to set the `y` property to. If `undefined` or `null` it uses the `x` value.
 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetXY = function(items, x, y, stepX, stepY, index, direction) {
                    if (y === undefined || y === null) y = x;
                    PropertyValueSet(items, 'x', x, stepX, index, direction);
                    return PropertyValueSet(items, 'y', y, stepY, index, direction);
                };
                module1.exports = SetXY;
            /***/ },
            /***/ 67678: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(43967);
                /**
 * Takes an array of Game Objects, or any objects that have the public property `y`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetY = function(items, value, step, index, direction) {
                    return PropertyValueSet(items, 'y', value, step, index, direction);
                };
                module1.exports = SetY;
            /***/ },
            /***/ 35850: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Takes an array of items, such as Game Objects, or any objects with public `x` and
 * `y` properties and then iterates through them. As this function iterates, it moves
 * the position of the current element to be that of the previous entry in the array.
 * This repeats until all items have been moved.
 *
 * The direction controls the order of iteration. A value of 0 (the default) assumes
 * that the final item in the array is the 'head' item.
 *
 * A direction value of 1 assumes that the first item in the array is the 'head' item.
 *
 * The position of the 'head' item is set to the x/y values given to this function.
 * Every other item in the array is then updated, in sequence, to be that of the
 * previous (or next) entry in the array.
 *
 * The final x/y coords are returned, or set in the 'output' Vector2.
 *
 * Think of it as being like the game Snake, where the 'head' is moved and then
 * each body piece is moved into the space of the previous piece.
 *
 * @function Phaser.Actions.ShiftPosition
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 * @generic {Phaser.Math.Vector2} O - [output,$return]
 *
 * @param {(Phaser.Types.Math.Vector2Like[]|Phaser.GameObjects.GameObject[])} items - An array of Game Objects, or objects with public x and y positions. The contents of this array are updated by this Action.
 * @param {number} x - The x coordinate to place the head item at.
 * @param {number} y - The y coordinate to place the head item at.
 * @param {number} [direction=0] - The iteration direction. 0 = first to last and 1 = last to first.
 * @param {Phaser.Types.Math.Vector2Like} [output] - An optional Vec2Like object to store the final position in.
 *
 * @return {Phaser.Types.Math.Vector2Like} The output vector.
 */ var ShiftPosition = function(items, x, y, direction, output) {
                    if (direction === undefined) direction = 0;
                    if (output === undefined) output = new Vector2();
                    var px;
                    var py;
                    var len = items.length;
                    if (len === 1) {
                        px = items[0].x;
                        py = items[0].y;
                        items[0].x = x;
                        items[0].y = y;
                    } else {
                        var i = 1;
                        var pos = 0;
                        if (direction === 0) {
                            pos = len - 1;
                            i = len - 2;
                        }
                        px = items[pos].x;
                        py = items[pos].y;
                        //  Update the head item to the new x/y coordinates
                        items[pos].x = x;
                        items[pos].y = y;
                        for(var c = 0; c < len; c++){
                            if (i >= len || i === -1) continue;
                            //  Current item
                            var cur = items[i];
                            //  Get current item x/y, to be passed to the next item in the list
                            var cx = cur.x;
                            var cy = cur.y;
                            //  Set current item to the previous items x/y
                            cur.x = px;
                            cur.y = py;
                            //  Set current as previous
                            px = cx;
                            py = cy;
                            if (direction === 0) i--;
                            else i++;
                        }
                    }
                    //  Return the final set of coordinates as they're effectively lost from the shift and may be needed
                    output.x = px;
                    output.y = py;
                    return output;
                };
                module1.exports = ShiftPosition;
            /***/ },
            /***/ 8628: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayShuffle = __webpack_require__(33680);
                /**
 * Shuffles the array in place. The shuffled array is both modified and returned.
 *
 * @function Phaser.Actions.Shuffle
 * @since 3.0.0
 * @see Phaser.Utils.Array.Shuffle
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var Shuffle = function(items) {
                    return ArrayShuffle(items);
                };
                module1.exports = Shuffle;
            /***/ },
            /***/ 21837: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathSmoothStep = __webpack_require__(7602);
                /**
 * Smoothstep is a sigmoid-like interpolation and clamping function.
 *
 * The function depends on three parameters, the input x, the "left edge"
 * and the "right edge", with the left edge being assumed smaller than the right edge.
 *
 * The function receives a real number x as an argument and returns 0 if x is less than
 * or equal to the left edge, 1 if x is greater than or equal to the right edge, and smoothly
 * interpolates, using a Hermite polynomial, between 0 and 1 otherwise. The slope of the
 * smoothstep function is zero at both edges.
 *
 * This is convenient for creating a sequence of transitions using smoothstep to interpolate
 * each segment as an alternative to using more sophisticated or expensive interpolation techniques.
 *
 * @function Phaser.Actions.SmoothStep
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to interpolate.
 * @param {number} min - The minimum interpolation value.
 * @param {number} max - The maximum interpolation value.
 * @param {boolean} [inc=false] - Should the property value be incremented (`true`) or set (`false`)?
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SmoothStep = function(items, property, min, max, inc) {
                    if (inc === undefined) inc = false;
                    var step = Math.abs(max - min) / items.length;
                    var i;
                    if (inc) for(i = 0; i < items.length; i++)items[i][property] += MathSmoothStep(i * step, min, max);
                    else for(i = 0; i < items.length; i++)items[i][property] = MathSmoothStep(i * step, min, max);
                    return items;
                };
                module1.exports = SmoothStep;
            /***/ },
            /***/ 21910: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathSmootherStep = __webpack_require__(54261);
                /**
 * Smootherstep is a sigmoid-like interpolation and clamping function.
 * 
 * The function depends on three parameters, the input x, the "left edge" and the "right edge", with the left edge being assumed smaller than the right edge. The function receives a real number x as an argument and returns 0 if x is less than or equal to the left edge, 1 if x is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial, between 0 and 1 otherwise. The slope of the smoothstep function is zero at both edges. This is convenient for creating a sequence of transitions using smoothstep to interpolate each segment as an alternative to using more sophisticated or expensive interpolation techniques.
 *
 * @function Phaser.Actions.SmootherStep
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to interpolate.
 * @param {number} min - The minimum interpolation value.
 * @param {number} max - The maximum interpolation value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SmootherStep = function(items, property, min, max, inc) {
                    if (inc === undefined) inc = false;
                    var step = Math.abs(max - min) / items.length;
                    var i;
                    if (inc) for(i = 0; i < items.length; i++)items[i][property] += MathSmootherStep(i * step, min, max);
                    else for(i = 0; i < items.length; i++)items[i][property] = MathSmootherStep(i * step, min, max);
                    return items;
                };
                module1.exports = SmootherStep;
            /***/ },
            /***/ 62054: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and then modifies their `property` so the value equals, or is incremented, by the
 * calculated spread value.
 * 
 * The spread value is derived from the given `min` and `max` values and the total number of items in the array.
 * 
 * For example, to cause an array of Sprites to change in alpha from 0 to 1 you could call:
 * 
 * ```javascript
 * Phaser.Actions.Spread(itemsArray, 'alpha', 0, 1);
 * ```
 *
 * @function Phaser.Actions.Spread
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to spread.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that were passed to this Action.
 */ var Spread = function(items, property, min, max, inc) {
                    if (inc === undefined) inc = false;
                    if (items.length === 0) return items;
                    if (items.length === 1) {
                        if (inc) items[0][property] += (max + min) / 2;
                        else items[0][property] = (max + min) / 2;
                        return items;
                    }
                    var step = Math.abs(max - min) / (items.length - 1);
                    var i;
                    if (inc) for(i = 0; i < items.length; i++)items[i][property] += i * step + min;
                    else for(i = 0; i < items.length; i++)items[i][property] = i * step + min;
                    return items;
                };
                module1.exports = Spread;
            /***/ },
            /***/ 79815: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and toggles the visibility of each one.
 * Those previously `visible = false` will become `visible = true`, and vice versa.
 *
 * @function Phaser.Actions.ToggleVisible
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var ToggleVisible = function(items) {
                    for(var i = 0; i < items.length; i++)items[i].visible = !items[i].visible;
                    return items;
                };
                module1.exports = ToggleVisible;
            /***/ },
            /***/ 39665: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       samme <samme.npm@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Wrap = __webpack_require__(15994);
                /**
 * Iterates through the given array and makes sure that each objects x and y
 * properties are wrapped to keep them contained within the given Rectangles
 * area.
 *
 * @function Phaser.Actions.WrapInRectangle
 * @since 3.0.0
 * @see Phaser.Math.Wrap
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle which the objects will be wrapped to remain within.
 * @param {number} [padding=0] - An amount added to each side of the rectangle during the operation.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var WrapInRectangle = function(items, rect, padding) {
                    if (padding === undefined) padding = 0;
                    for(var i = 0; i < items.length; i++){
                        var item = items[i];
                        item.x = Wrap(item.x, rect.left - padding, rect.right + padding);
                        item.y = Wrap(item.y, rect.top - padding, rect.bottom + padding);
                    }
                    return items;
                };
                module1.exports = WrapInRectangle;
            /***/ },
            /***/ 61061: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Actions
 */ module1.exports = {
                    AlignTo: __webpack_require__(11517),
                    Angle: __webpack_require__(80318),
                    Call: __webpack_require__(60757),
                    GetFirst: __webpack_require__(69927),
                    GetLast: __webpack_require__(32265),
                    GridAlign: __webpack_require__(94420),
                    IncAlpha: __webpack_require__(41721),
                    IncX: __webpack_require__(67285),
                    IncXY: __webpack_require__(9074),
                    IncY: __webpack_require__(75222),
                    PlaceOnCircle: __webpack_require__(22983),
                    PlaceOnEllipse: __webpack_require__(95253),
                    PlaceOnLine: __webpack_require__(88505),
                    PlaceOnRectangle: __webpack_require__(41346),
                    PlaceOnTriangle: __webpack_require__(11575),
                    PlayAnimation: __webpack_require__(29953),
                    PropertyValueInc: __webpack_require__(66979),
                    PropertyValueSet: __webpack_require__(43967),
                    RandomCircle: __webpack_require__(88926),
                    RandomEllipse: __webpack_require__(33286),
                    RandomLine: __webpack_require__(96000),
                    RandomRectangle: __webpack_require__(28789),
                    RandomTriangle: __webpack_require__(97154),
                    Rotate: __webpack_require__(20510),
                    RotateAround: __webpack_require__(91051),
                    RotateAroundDistance: __webpack_require__(76332),
                    ScaleX: __webpack_require__(61619),
                    ScaleXY: __webpack_require__(94868),
                    ScaleY: __webpack_require__(95532),
                    SetAlpha: __webpack_require__(8689),
                    SetBlendMode: __webpack_require__(2645),
                    SetDepth: __webpack_require__(32372),
                    SetHitArea: __webpack_require__(85373),
                    SetOrigin: __webpack_require__(81583),
                    SetRotation: __webpack_require__(79939),
                    SetScale: __webpack_require__(2699),
                    SetScaleX: __webpack_require__(98739),
                    SetScaleY: __webpack_require__(98476),
                    SetScrollFactor: __webpack_require__(6207),
                    SetScrollFactorX: __webpack_require__(6607),
                    SetScrollFactorY: __webpack_require__(72248),
                    SetTint: __webpack_require__(14036),
                    SetVisible: __webpack_require__(50159),
                    SetX: __webpack_require__(77597),
                    SetXY: __webpack_require__(83194),
                    SetY: __webpack_require__(67678),
                    ShiftPosition: __webpack_require__(35850),
                    Shuffle: __webpack_require__(8628),
                    SmootherStep: __webpack_require__(21910),
                    SmoothStep: __webpack_require__(21837),
                    Spread: __webpack_require__(62054),
                    ToggleVisible: __webpack_require__(79815),
                    WrapInRectangle: __webpack_require__(39665)
                };
            /***/ },
            /***/ 42099: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(74943);
                var FindClosestInSorted = __webpack_require__(81957);
                var Frame = __webpack_require__(41138);
                var GetValue = __webpack_require__(35154);
                var SortByDigits = __webpack_require__(90126);
                /**
 * @classdesc
 * A Frame based Animation.
 *
 * Animations in Phaser consist of a sequence of `AnimationFrame` objects, which are managed by
 * this class, along with properties that impact playback, such as the animations frame rate
 * or delay.
 *
 * This class contains all of the properties and methods needed to handle playback of the animation
 * directly to an `AnimationState` instance, which is owned by a Sprite, or similar Game Object.
 *
 * You don't typically create an instance of this class directly, but instead go via
 * either the `AnimationManager` or the `AnimationState` and use their `create` methods,
 * depending on if you need a global animation, or local to a specific Sprite.
 *
 * @class Animation
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Animations.AnimationManager} manager - A reference to the global Animation Manager
 * @param {string} key - The unique identifying string for this animation.
 * @param {Phaser.Types.Animations.Animation} config - The Animation configuration.
 */ var Animation = new Class({
                    initialize: function Animation(manager, key, config) {
                        /**
         * A reference to the global Animation Manager.
         *
         * @name Phaser.Animations.Animation#manager
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.manager = manager;
                        /**
         * The unique identifying string for this animation.
         *
         * @name Phaser.Animations.Animation#key
         * @type {string}
         * @since 3.0.0
         */ this.key = key;
                        /**
         * A frame based animation (as opposed to a bone based animation)
         *
         * @name Phaser.Animations.Animation#type
         * @type {string}
         * @default frame
         * @since 3.0.0
         */ this.type = 'frame';
                        /**
         * Extract all the frame data into the frames array.
         *
         * @name Phaser.Animations.Animation#frames
         * @type {Phaser.Animations.AnimationFrame[]}
         * @since 3.0.0
         */ this.frames = this.getFrames(manager.textureManager, GetValue(config, 'frames', []), GetValue(config, 'defaultTextureKey', null), GetValue(config, 'sortFrames', true));
                        /**
         * The frame rate of playback in frames per second (default 24 if duration is null)
         *
         * @name Phaser.Animations.Animation#frameRate
         * @type {number}
         * @default 24
         * @since 3.0.0
         */ this.frameRate = GetValue(config, 'frameRate', null);
                        /**
         * How long the animation should play for, in milliseconds.
         * If the `frameRate` property has been set then it overrides this value,
         * otherwise the `frameRate` is derived from `duration`.
         *
         * @name Phaser.Animations.Animation#duration
         * @type {number}
         * @since 3.0.0
         */ this.duration = GetValue(config, 'duration', null);
                        /**
         * How many ms per frame, not including frame specific modifiers.
         *
         * @name Phaser.Animations.Animation#msPerFrame
         * @type {number}
         * @since 3.0.0
         */ this.msPerFrame;
                        /**
         * Skip frames if the time lags, or always advanced anyway?
         *
         * @name Phaser.Animations.Animation#skipMissedFrames
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.skipMissedFrames = GetValue(config, 'skipMissedFrames', true);
                        /**
         * The delay in ms before the playback will begin.
         *
         * @name Phaser.Animations.Animation#delay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delay = GetValue(config, 'delay', 0);
                        /**
         * Number of times to repeat the animation. Set to -1 to repeat forever.
         *
         * @name Phaser.Animations.Animation#repeat
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeat = GetValue(config, 'repeat', 0);
                        /**
         * The delay in ms before the a repeat play starts.
         *
         * @name Phaser.Animations.Animation#repeatDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatDelay = GetValue(config, 'repeatDelay', 0);
                        /**
         * Should the animation yoyo (reverse back down to the start) before repeating?
         *
         * @name Phaser.Animations.Animation#yoyo
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.yoyo = GetValue(config, 'yoyo', false);
                        /**
         * If the animation has a delay set, before playback will begin, this
         * controls when the first frame is set on the Sprite. If this property
         * is 'false' then the frame is set only after the delay has expired.
         * This is the default behavior.
         *
         * @name Phaser.Animations.Animation#showBeforeDelay
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.showBeforeDelay = GetValue(config, 'showBeforeDelay', false);
                        /**
         * Should the GameObject's `visible` property be set to `true` when the animation starts to play?
         *
         * @name Phaser.Animations.Animation#showOnStart
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.showOnStart = GetValue(config, 'showOnStart', false);
                        /**
         * Should the GameObject's `visible` property be set to `false` when the animation finishes?
         *
         * @name Phaser.Animations.Animation#hideOnComplete
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.hideOnComplete = GetValue(config, 'hideOnComplete', false);
                        /**
         * Start playback of this animation from a random frame?
         *
         * @name Phaser.Animations.Animation#randomFrame
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.randomFrame = GetValue(config, 'randomFrame', false);
                        /**
         * Global pause. All Game Objects using this Animation instance are impacted by this property.
         *
         * @name Phaser.Animations.Animation#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                        this.calculateDuration(this, this.getTotalFrames(), this.duration, this.frameRate);
                        if (this.manager.on) {
                            this.manager.on(Events.PAUSE_ALL, this.pause, this);
                            this.manager.on(Events.RESUME_ALL, this.resume, this);
                        }
                    },
                    /**
     * Gets the total number of frames in this animation.
     *
     * @method Phaser.Animations.Animation#getTotalFrames
     * @since 3.50.0
     *
     * @return {number} The total number of frames in this animation.
     */ getTotalFrames: function() {
                        return this.frames.length;
                    },
                    /**
     * Calculates the duration, frame rate and msPerFrame values.
     *
     * @method Phaser.Animations.Animation#calculateDuration
     * @since 3.50.0
     *
     * @param {Phaser.Animations.Animation} target - The target to set the values on.
     * @param {number} totalFrames - The total number of frames in the animation.
     * @param {?number} [duration] - The duration to calculate the frame rate from. Pass `null` if you wish to set the `frameRate` instead.
     * @param {?number} [frameRate] - The frame rate to calculate the duration from.
     */ calculateDuration: function(target, totalFrames, duration, frameRate) {
                        if (duration === null && frameRate === null) {
                            //  No duration or frameRate given, use default frameRate of 24fps
                            target.frameRate = 24;
                            target.duration = 24 / totalFrames * 1000;
                        } else if (duration && frameRate === null) {
                            //  Duration given but no frameRate, so set the frameRate based on duration
                            //  I.e. 12 frames in the animation, duration = 4000 ms
                            //  So frameRate is 12 / (4000 / 1000) = 3 fps
                            target.duration = duration;
                            target.frameRate = totalFrames / (duration / 1000);
                        } else {
                            //  frameRate given, derive duration from it (even if duration also specified)
                            //  I.e. 15 frames in the animation, frameRate = 30 fps
                            //  So duration is 15 / 30 = 0.5 * 1000 (half a second, or 500ms)
                            target.frameRate = frameRate;
                            target.duration = totalFrames / frameRate * 1000;
                        }
                        target.msPerFrame = 1000 / target.frameRate;
                    },
                    /**
     * Add frames to the end of the animation.
     *
     * @method Phaser.Animations.Animation#addFrame
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} config - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     *
     * @return {this} This Animation object.
     */ addFrame: function(config) {
                        return this.addFrameAt(this.frames.length, config);
                    },
                    /**
     * Add frame/s into the animation.
     *
     * @method Phaser.Animations.Animation#addFrameAt
     * @since 3.0.0
     *
     * @param {number} index - The index to insert the frame at within the animation.
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} config - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     *
     * @return {this} This Animation object.
     */ addFrameAt: function(index, config) {
                        var newFrames = this.getFrames(this.manager.textureManager, config);
                        if (newFrames.length > 0) {
                            if (index === 0) this.frames = newFrames.concat(this.frames);
                            else if (index === this.frames.length) this.frames = this.frames.concat(newFrames);
                            else {
                                var pre = this.frames.slice(0, index);
                                var post = this.frames.slice(index);
                                this.frames = pre.concat(newFrames, post);
                            }
                            this.updateFrameSequence();
                        }
                        return this;
                    },
                    /**
     * Check if the given frame index is valid.
     *
     * @method Phaser.Animations.Animation#checkFrame
     * @since 3.0.0
     *
     * @param {number} index - The index to be checked.
     *
     * @return {boolean} `true` if the index is valid, otherwise `false`.
     */ checkFrame: function(index) {
                        return index >= 0 && index < this.frames.length;
                    },
                    /**
     * Called internally when this Animation first starts to play.
     * Sets the accumulator and nextTick properties.
     *
     * @method Phaser.Animations.Animation#getFirstTick
     * @protected
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ getFirstTick: function(state) {
                        //  When is the first update due?
                        state.accumulator = 0;
                        state.nextTick = state.msPerFrame || state.currentFrame.duration;
                    },
                    /**
     * Returns the AnimationFrame at the provided index
     *
     * @method Phaser.Animations.Animation#getFrameAt
     * @since 3.0.0
     *
     * @param {number} index - The index in the AnimationFrame array
     *
     * @return {Phaser.Animations.AnimationFrame} The frame at the index provided from the animation sequence
     */ getFrameAt: function(index) {
                        return this.frames[index];
                    },
                    /**
     * Creates AnimationFrame instances based on the given frame data.
     *
     * @method Phaser.Animations.Animation#getFrames
     * @since 3.0.0
     *
     * @param {Phaser.Textures.TextureManager} textureManager - A reference to the global Texture Manager.
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} frames - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     * @param {string} [defaultTextureKey] - The key to use if no key is set in the frame configuration object.
     *
     * @return {Phaser.Animations.AnimationFrame[]} An array of newly created AnimationFrame instances.
     */ getFrames: function(textureManager, frames, defaultTextureKey, sortFrames) {
                        if (sortFrames === undefined) sortFrames = true;
                        var out = [];
                        var prev;
                        var animationFrame;
                        var index = 1;
                        var i;
                        var textureKey;
                        //  if frames is a string, we'll get all the frames from the texture manager as if it's a sprite sheet
                        if (typeof frames === 'string') {
                            textureKey = frames;
                            if (!textureManager.exists(textureKey)) {
                                console.warn('Texture "%s" not found', textureKey);
                                return out;
                            }
                            var texture = textureManager.get(textureKey);
                            var frameKeys = texture.getFrameNames();
                            if (sortFrames) SortByDigits(frameKeys);
                            frames = [];
                            frameKeys.forEach(function(value) {
                                frames.push({
                                    key: textureKey,
                                    frame: value
                                });
                            });
                        }
                        if (!Array.isArray(frames) || frames.length === 0) return out;
                        for(i = 0; i < frames.length; i++){
                            var item = frames[i];
                            var key = GetValue(item, 'key', defaultTextureKey);
                            if (!key) continue;
                            //  Could be an integer or a string
                            var frame = GetValue(item, 'frame', 0);
                            //  The actual texture frame
                            var textureFrame = textureManager.getFrame(key, frame);
                            if (!textureFrame) {
                                console.warn('Texture "%s" not found', key);
                                continue;
                            }
                            animationFrame = new Frame(key, frame, index, textureFrame);
                            animationFrame.duration = GetValue(item, 'duration', 0);
                            animationFrame.isFirst = !prev;
                            //  The previously created animationFrame
                            if (prev) {
                                prev.nextFrame = animationFrame;
                                animationFrame.prevFrame = prev;
                            }
                            out.push(animationFrame);
                            prev = animationFrame;
                            index++;
                        }
                        if (out.length > 0) {
                            animationFrame.isLast = true;
                            //  Link them end-to-end, so they loop
                            animationFrame.nextFrame = out[0];
                            out[0].prevFrame = animationFrame;
                            //  Generate the progress data
                            var slice = 1 / (out.length - 1);
                            for(i = 0; i < out.length; i++)out[i].progress = i * slice;
                        }
                        return out;
                    },
                    /**
     * Called internally. Sets the accumulator and nextTick values of the current Animation.
     *
     * @method Phaser.Animations.Animation#getNextTick
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ getNextTick: function(state) {
                        state.accumulator -= state.nextTick;
                        state.nextTick = state.msPerFrame || state.currentFrame.duration;
                    },
                    /**
     * Returns the frame closest to the given progress value between 0 and 1.
     *
     * @method Phaser.Animations.Animation#getFrameByProgress
     * @since 3.4.0
     *
     * @param {number} value - A value between 0 and 1.
     *
     * @return {Phaser.Animations.AnimationFrame} The frame closest to the given progress value.
     */ getFrameByProgress: function(value) {
                        value = Clamp(value, 0, 1);
                        return FindClosestInSorted(value, this.frames, 'progress');
                    },
                    /**
     * Advance the animation frame.
     *
     * @method Phaser.Animations.Animation#nextFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State to advance.
     */ nextFrame: function(state) {
                        var frame = state.currentFrame;
                        if (frame.isLast) {
                            //  We're at the end of the animation
                            //  Yoyo? (happens before repeat)
                            if (state.yoyo) this.handleYoyoFrame(state, false);
                            else if (state.repeatCounter > 0) {
                                //  Repeat (happens before complete)
                                if (state.inReverse && state.forward) state.forward = false;
                                else this.repeatAnimation(state);
                            } else state.complete();
                        } else this.updateAndGetNextTick(state, frame.nextFrame);
                    },
                    /**
     * Handle the yoyo functionality in nextFrame and previousFrame methods.
     *
     * @method Phaser.Animations.Animation#handleYoyoFrame
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State to advance.
     * @param {boolean} isReverse - Is animation in reverse mode? (Default: false)
     */ handleYoyoFrame: function(state, isReverse) {
                        if (!isReverse) isReverse = false;
                        if (state.inReverse === !isReverse && state.repeatCounter > 0) {
                            if (state.repeatDelay === 0 || state.pendingRepeat) state.forward = isReverse;
                            this.repeatAnimation(state);
                            return;
                        }
                        if (state.inReverse !== isReverse && state.repeatCounter === 0) {
                            state.complete();
                            return;
                        }
                        state.forward = isReverse;
                        var frame = isReverse ? state.currentFrame.nextFrame : state.currentFrame.prevFrame;
                        this.updateAndGetNextTick(state, frame);
                    },
                    /**
     * Returns the animation last frame.
     *
     * @method Phaser.Animations.Animation#getLastFrame
     * @since 3.12.0
     *
     * @return {Phaser.Animations.AnimationFrame} The last Animation Frame.
     */ getLastFrame: function() {
                        return this.frames[this.frames.length - 1];
                    },
                    /**
     * Called internally when the Animation is playing backwards.
     * Sets the previous frame, causing a yoyo, repeat, complete or update, accordingly.
     *
     * @method Phaser.Animations.Animation#previousFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ previousFrame: function(state) {
                        var frame = state.currentFrame;
                        if (frame.isFirst) {
                            //  We're at the start of the animation
                            if (state.yoyo) this.handleYoyoFrame(state, true);
                            else if (state.repeatCounter > 0) {
                                if (state.inReverse && !state.forward) this.repeatAnimation(state);
                                else {
                                    //  Repeat (happens before complete)
                                    state.forward = true;
                                    this.repeatAnimation(state);
                                }
                            } else state.complete();
                        } else this.updateAndGetNextTick(state, frame.prevFrame);
                    },
                    /**
     * Update Frame and Wait next tick.
     *
     * @method Phaser.Animations.Animation#updateAndGetNextTick
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State.
     * @param {Phaser.Animations.AnimationFrame} frame - An Animation frame.
     */ updateAndGetNextTick: function(state, frame) {
                        state.setCurrentFrame(frame);
                        this.getNextTick(state);
                    },
                    /**
     * Removes the given AnimationFrame from this Animation instance.
     * This is a global action. Any Game Object using this Animation will be impacted by this change.
     *
     * @method Phaser.Animations.Animation#removeFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The AnimationFrame to be removed.
     *
     * @return {this} This Animation object.
     */ removeFrame: function(frame) {
                        var index = this.frames.indexOf(frame);
                        if (index !== -1) this.removeFrameAt(index);
                        return this;
                    },
                    /**
     * Removes a frame from the AnimationFrame array at the provided index
     * and updates the animation accordingly.
     *
     * @method Phaser.Animations.Animation#removeFrameAt
     * @since 3.0.0
     *
     * @param {number} index - The index in the AnimationFrame array
     *
     * @return {this} This Animation object.
     */ removeFrameAt: function(index) {
                        this.frames.splice(index, 1);
                        this.updateFrameSequence();
                        return this;
                    },
                    /**
     * Called internally during playback. Forces the animation to repeat, providing there are enough counts left
     * in the repeat counter.
     *
     * @method Phaser.Animations.Animation#repeatAnimation
     * @fires Phaser.Animations.Events#ANIMATION_REPEAT
     * @fires Phaser.Animations.Events#SPRITE_ANIMATION_REPEAT
     * @fires Phaser.Animations.Events#SPRITE_ANIMATION_KEY_REPEAT
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ repeatAnimation: function(state) {
                        if (state._pendingStop === 2) {
                            if (state._pendingStopValue === 0) return state.stop();
                            else state._pendingStopValue--;
                        }
                        if (state.repeatDelay > 0 && !state.pendingRepeat) {
                            state.pendingRepeat = true;
                            state.accumulator -= state.nextTick;
                            state.nextTick += state.repeatDelay;
                        } else {
                            state.repeatCounter--;
                            if (state.forward) state.setCurrentFrame(state.currentFrame.nextFrame);
                            else state.setCurrentFrame(state.currentFrame.prevFrame);
                            if (state.isPlaying) {
                                this.getNextTick(state);
                                state.handleRepeat();
                            }
                        }
                    },
                    /**
     * Converts the animation data to JSON.
     *
     * @method Phaser.Animations.Animation#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Animations.JSONAnimation} The resulting JSONAnimation formatted object.
     */ toJSON: function() {
                        var output = {
                            key: this.key,
                            type: this.type,
                            frames: [],
                            frameRate: this.frameRate,
                            duration: this.duration,
                            skipMissedFrames: this.skipMissedFrames,
                            delay: this.delay,
                            repeat: this.repeat,
                            repeatDelay: this.repeatDelay,
                            yoyo: this.yoyo,
                            showBeforeDelay: this.showBeforeDelay,
                            showOnStart: this.showOnStart,
                            randomFrame: this.randomFrame,
                            hideOnComplete: this.hideOnComplete
                        };
                        this.frames.forEach(function(frame) {
                            output.frames.push(frame.toJSON());
                        });
                        return output;
                    },
                    /**
     * Called internally whenever frames are added to, or removed from, this Animation.
     *
     * @method Phaser.Animations.Animation#updateFrameSequence
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ updateFrameSequence: function() {
                        var len = this.frames.length;
                        var slice = 1 / (len - 1);
                        var frame;
                        for(var i = 0; i < len; i++){
                            frame = this.frames[i];
                            frame.index = i + 1;
                            frame.isFirst = false;
                            frame.isLast = false;
                            frame.progress = i * slice;
                            if (i === 0) {
                                frame.isFirst = true;
                                if (len === 1) {
                                    frame.isLast = true;
                                    frame.nextFrame = frame;
                                    frame.prevFrame = frame;
                                } else {
                                    frame.isLast = false;
                                    frame.prevFrame = this.frames[len - 1];
                                    frame.nextFrame = this.frames[i + 1];
                                }
                            } else if (i === len - 1 && len > 1) {
                                frame.isLast = true;
                                frame.prevFrame = this.frames[len - 2];
                                frame.nextFrame = this.frames[0];
                            } else if (len > 1) {
                                frame.prevFrame = this.frames[i - 1];
                                frame.nextFrame = this.frames[i + 1];
                            }
                        }
                        return this;
                    },
                    /**
     * Pauses playback of this Animation. The paused state is set immediately.
     *
     * @method Phaser.Animations.Animation#pause
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ pause: function() {
                        this.paused = true;
                        return this;
                    },
                    /**
     * Resumes playback of this Animation. The paused state is reset immediately.
     *
     * @method Phaser.Animations.Animation#resume
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ resume: function() {
                        this.paused = false;
                        return this;
                    },
                    /**
     * Destroys this Animation instance. It will remove all event listeners,
     * remove this animation and its key from the global Animation Manager,
     * and then destroy all Animation Frames in turn.
     *
     * @method Phaser.Animations.Animation#destroy
     * @since 3.0.0
     */ destroy: function() {
                        if (this.manager.off) {
                            this.manager.off(Events.PAUSE_ALL, this.pause, this);
                            this.manager.off(Events.RESUME_ALL, this.resume, this);
                        }
                        this.manager.remove(this.key);
                        for(var i = 0; i < this.frames.length; i++)this.frames[i].destroy();
                        this.frames = [];
                        this.manager = null;
                    }
                });
                module1.exports = Animation;
            /***/ },
            /***/ 41138: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A single frame in an Animation sequence.
 *
 * An AnimationFrame consists of a reference to the Texture it uses for rendering, references to other
 * frames in the animation, and index data. It also has the ability to modify the animation timing.
 *
 * AnimationFrames are generated automatically by the Animation class.
 *
 * @class AnimationFrame
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {string} textureKey - The key of the Texture this AnimationFrame uses.
 * @param {(string|number)} textureFrame - The key of the Frame within the Texture that this AnimationFrame uses.
 * @param {number} index - The index of this AnimationFrame within the Animation sequence.
 * @param {Phaser.Textures.Frame} frame - A reference to the Texture Frame this AnimationFrame uses for rendering.
 * @param {boolean} [isKeyFrame=false] - Is this Frame a Keyframe within the Animation?
 */ var AnimationFrame = new Class({
                    initialize: function AnimationFrame(textureKey, textureFrame, index, frame, isKeyFrame) {
                        if (isKeyFrame === undefined) isKeyFrame = false;
                        /**
         * The key of the Texture this AnimationFrame uses.
         *
         * @name Phaser.Animations.AnimationFrame#textureKey
         * @type {string}
         * @since 3.0.0
         */ this.textureKey = textureKey;
                        /**
         * The key of the Frame within the Texture that this AnimationFrame uses.
         *
         * @name Phaser.Animations.AnimationFrame#textureFrame
         * @type {(string|number)}
         * @since 3.0.0
         */ this.textureFrame = textureFrame;
                        /**
         * The index of this AnimationFrame within the Animation sequence.
         *
         * @name Phaser.Animations.AnimationFrame#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                        /**
         * A reference to the Texture Frame this AnimationFrame uses for rendering.
         *
         * @name Phaser.Animations.AnimationFrame#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.frame = frame;
                        /**
         * Is this the first frame in an animation sequence?
         *
         * @name Phaser.Animations.AnimationFrame#isFirst
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isFirst = false;
                        /**
         * Is this the last frame in an animation sequence?
         *
         * @name Phaser.Animations.AnimationFrame#isLast
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isLast = false;
                        /**
         * A reference to the AnimationFrame that comes before this one in the animation, if any.
         *
         * @name Phaser.Animations.AnimationFrame#prevFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.prevFrame = null;
                        /**
         * A reference to the AnimationFrame that comes after this one in the animation, if any.
         *
         * @name Phaser.Animations.AnimationFrame#nextFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.nextFrame = null;
                        /**
         * The duration, in ms, of this frame of the animation.
         *
         * @name Phaser.Animations.AnimationFrame#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                        /**
         * What % through the animation does this frame come?
         * This value is generated when the animation is created and cached here.
         *
         * @name Phaser.Animations.AnimationFrame#progress
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.progress = 0;
                        /**
         * Is this Frame a KeyFrame within the Animation?
         *
         * @name Phaser.Animations.AnimationFrame#isKeyFrame
         * @type {boolean}
         * @since 3.50.0
         */ this.isKeyFrame = isKeyFrame;
                    },
                    /**
     * Generates a JavaScript object suitable for converting to JSON.
     *
     * @method Phaser.Animations.AnimationFrame#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Animations.JSONAnimationFrame} The AnimationFrame data.
     */ toJSON: function() {
                        return {
                            key: this.textureKey,
                            frame: this.textureFrame,
                            duration: this.duration,
                            keyframe: this.isKeyFrame
                        };
                    },
                    /**
     * Destroys this object by removing references to external resources and callbacks.
     *
     * @method Phaser.Animations.AnimationFrame#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.frame = undefined;
                    }
                });
                module1.exports = AnimationFrame;
            /***/ },
            /***/ 60848: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Animation = __webpack_require__(42099);
                var Class = __webpack_require__(83419);
                var CustomMap = __webpack_require__(90330);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(74943);
                var GameEvents = __webpack_require__(8443);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var MATH_CONST = __webpack_require__(36383);
                var NumberArray = __webpack_require__(20283);
                var Pad = __webpack_require__(41836);
                /**
 * @classdesc
 * The Animation Manager.
 *
 * Animations are managed by the global Animation Manager. This is a singleton class that is
 * responsible for creating and delivering animations and their corresponding data to all Game Objects.
 * Unlike plugins it is owned by the Game instance, not the Scene.
 *
 * Sprites and other Game Objects get the data they need from the AnimationManager.
 *
 * @class AnimationManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance.
 */ var AnimationManager = new Class({
                    Extends: EventEmitter,
                    initialize: function AnimationManager(game) {
                        EventEmitter.call(this);
                        /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Animations.AnimationManager#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.0.0
         */ this.game = game;
                        /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.Animations.AnimationManager#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @protected
         * @since 3.0.0
         */ this.textureManager = null;
                        /**
         * The global time scale of the Animation Manager.
         *
         * This scales the time delta between two frames, thus influencing the speed of time for the Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#globalTimeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.globalTimeScale = 1;
                        /**
         * The Animations registered in the Animation Manager.
         *
         * This map should be modified with the {@link #add} and {@link #create} methods of the Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#anims
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @protected
         * @since 3.0.0
         */ this.anims = new CustomMap();
                        /**
         * A list of animation mix times.
         *
         * See the {@link #setMix} method for more details.
         *
         * @name Phaser.Animations.AnimationManager#mixes
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @since 3.50.0
         */ this.mixes = new CustomMap();
                        /**
         * Whether the Animation Manager is paused along with all of its Animations.
         *
         * @name Phaser.Animations.AnimationManager#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                        /**
         * The name of this Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#name
         * @type {string}
         * @since 3.0.0
         */ this.name = 'AnimationManager';
                        game.events.once(GameEvents.BOOT, this.boot, this);
                    },
                    /**
     * Registers event listeners after the Game boots.
     *
     * @method Phaser.Animations.AnimationManager#boot
     * @listens Phaser.Core.Events#DESTROY
     * @since 3.0.0
     */ boot: function() {
                        this.textureManager = this.game.textures;
                        this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * Adds a mix between two animations.
     *
     * Mixing allows you to specify a unique delay between a pairing of animations.
     *
     * When playing Animation A on a Game Object, if you then play Animation B, and a
     * mix exists, it will wait for the specified delay to be over before playing Animation B.
     *
     * This allows you to customise smoothing between different types of animation, such
     * as blending between an idle and a walk state, or a running and a firing state.
     *
     * Note that mixing is only applied if you use the `Sprite.play` method. If you opt to use
     * `playAfterRepeat` or `playAfterDelay` instead, those will take priority and the mix
     * delay will not be used.
     *
     * To update an existing mix, just call this method with the new delay.
     *
     * To remove a mix pairing, see the `removeMix` method.
     *
     * @method Phaser.Animations.AnimationManager#addMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} animB - The string-based key, or instance of, Animation B.
     * @param {number} delay - The delay, in milliseconds, to wait when transitioning from Animation A to B.
     *
     * @return {this} This Animation Manager.
     */ addMix: function(animA, animB, delay) {
                        var anims = this.anims;
                        var mixes = this.mixes;
                        var keyA = typeof animA === 'string' ? animA : animA.key;
                        var keyB = typeof animB === 'string' ? animB : animB.key;
                        if (anims.has(keyA) && anims.has(keyB)) {
                            var mixObj = mixes.get(keyA);
                            if (!mixObj) mixObj = {};
                            mixObj[keyB] = delay;
                            mixes.set(keyA, mixObj);
                        }
                        return this;
                    },
                    /**
     * Removes a mix between two animations.
     *
     * Mixing allows you to specify a unique delay between a pairing of animations.
     *
     * Calling this method lets you remove those pairings. You can either remove
     * it between `animA` and `animB`, or if you do not provide the `animB` parameter,
     * it will remove all `animA` mixes.
     *
     * If you wish to update an existing mix instead, call the `addMix` method with the
     * new delay.
     *
     * @method Phaser.Animations.AnimationManager#removeMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} [animB] - The string-based key, or instance of, Animation B. If not given, all mixes for Animation A will be removed.
     *
     * @return {this} This Animation Manager.
     */ removeMix: function(animA, animB) {
                        var mixes = this.mixes;
                        var keyA = typeof animA === 'string' ? animA : animA.key;
                        var mixObj = mixes.get(keyA);
                        if (mixObj) {
                            if (animB) {
                                var keyB = typeof animB === 'string' ? animB : animB.key;
                                if (mixObj.hasOwnProperty(keyB)) //  Remove just this pairing
                                delete mixObj[keyB];
                            } else if (!animB) //  Remove everything for animA
                            mixes.delete(keyA);
                        }
                        return this;
                    },
                    /**
     * Returns the mix delay between two animations.
     *
     * If no mix has been set-up, this method will return zero.
     *
     * If you wish to create, or update, a new mix, call the `addMix` method.
     * If you wish to remove a mix, call the `removeMix` method.
     *
     * @method Phaser.Animations.AnimationManager#getMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} animB - The string-based key, or instance of, Animation B.
     *
     * @return {number} The mix duration, or zero if no mix exists.
     */ getMix: function(animA, animB) {
                        var mixes = this.mixes;
                        var keyA = typeof animA === 'string' ? animA : animA.key;
                        var keyB = typeof animB === 'string' ? animB : animB.key;
                        var mixObj = mixes.get(keyA);
                        if (mixObj && mixObj.hasOwnProperty(keyB)) return mixObj[keyB];
                        else return 0;
                    },
                    /**
     * Adds an existing Animation to the Animation Manager.
     *
     * @method Phaser.Animations.AnimationManager#add
     * @fires Phaser.Animations.Events#ADD_ANIMATION
     * @since 3.0.0
     *
     * @param {string} key - The key under which the Animation should be added. The Animation will be updated with it. Must be unique.
     * @param {Phaser.Animations.Animation} animation - The Animation which should be added to the Animation Manager.
     *
     * @return {this} This Animation Manager.
     */ add: function(key, animation) {
                        if (this.anims.has(key)) {
                            console.warn('Animation key exists: ' + key);
                            return this;
                        }
                        animation.key = key;
                        this.anims.set(key, animation);
                        this.emit(Events.ADD_ANIMATION, key, animation);
                        return this;
                    },
                    /**
     * Checks to see if the given key is already in use within the Animation Manager or not.
     *
     * Animations are global. Keys created in one scene can be used from any other Scene in your game. They are not Scene specific.
     *
     * @method Phaser.Animations.AnimationManager#exists
     * @since 3.16.0
     *
     * @param {string} key - The key of the Animation to check.
     *
     * @return {boolean} `true` if the Animation already exists in the Animation Manager, or `false` if the key is available.
     */ exists: function(key) {
                        return this.anims.has(key);
                    },
                    /**
     * Create one, or more animations from a loaded Aseprite JSON file.
     *
     * Aseprite is a powerful animated sprite editor and pixel art tool.
     *
     * You can find more details at https://www.aseprite.org/
     *
     * To export a compatible JSON file in Aseprite, please do the following:
     *
     * 1. Go to "File - Export Sprite Sheet"
     *
     * 2. On the **Layout** tab:
     * 2a. Set the "Sheet type" to "Packed"
     * 2b. Set the "Constraints" to "None"
     * 2c. Check the "Merge Duplicates" checkbox
     *
     * 3. On the **Sprite** tab:
     * 3a. Set "Layers" to "Visible layers"
     * 3b. Set "Frames" to "All frames", unless you only wish to export a sub-set of tags
     *
     * 4. On the **Borders** tab:
     * 4a. Check the "Trim Sprite" and "Trim Cells" options
     * 4b. Ensure "Border Padding", "Spacing" and "Inner Padding" are all > 0 (1 is usually enough)
     *
     * 5. On the **Output** tab:
     * 5a. Check "Output File", give your image a name and make sure you choose "png files" as the file type
     * 5b. Check "JSON Data" and give your json file a name
     * 5c. The JSON Data type can be either a Hash or Array, Phaser doesn't mind.
     * 5d. Make sure "Tags" is checked in the Meta options
     * 5e. In the "Item Filename" input box, make sure it says just "{frame}" and nothing more.
     *
     * 6. Click export
     *
     * This was tested with Aseprite 1.2.25.
     *
     * This will export a png and json file which you can load using the Aseprite Loader, i.e.:
     *
     * ```javascript
     * function preload ()
     * {
     *     this.load.path = 'assets/animations/aseprite/';
     *     this.load.aseprite('paladin', 'paladin.png', 'paladin.json');
     * }
     * ```
     *
     * Once loaded, you can call this method from within a Scene with the 'atlas' key:
     *
     * ```javascript
     * this.anims.createFromAseprite('paladin');
     * ```
     *
     * Any animations defined in the JSON will now be available to use in Phaser and you play them
     * via their Tag name. For example, if you have an animation called 'War Cry' on your Aseprite timeline,
     * you can play it in Phaser using that Tag name:
     *
     * ```javascript
     * this.add.sprite(400, 300).play('War Cry');
     * ```
     *
     * When calling this method you can optionally provide an array of tag names, and only those animations
     * will be created. For example:
     *
     * ```javascript
     * this.anims.createFromAseprite('paladin', [ 'step', 'War Cry', 'Magnum Break' ]);
     * ```
     *
     * This will only create the 3 animations defined. Note that the tag names are case-sensitive.
     *
     * @method Phaser.Animations.AnimationManager#createFromAseprite
     * @since 3.50.0
     *
     * @param {string} key - The key of the loaded Aseprite atlas. It must have been loaded prior to calling this method.
     * @param {string[]} [tags] - An array of Tag names. If provided, only animations found in this array will be created.
     * @param {(Phaser.Animations.AnimationManager|Phaser.GameObjects.GameObject)} [target] - Create the animations on this target Sprite. If not given, they will be created globally in this Animation Manager.
     *
     * @return {Phaser.Animations.Animation[]} An array of Animation instances that were successfully created.
     */ createFromAseprite: function(key, tags, target) {
                        var output = [];
                        var data = this.game.cache.json.get(key);
                        if (!data) {
                            console.warn('No Aseprite data found for: ' + key);
                            return output;
                        }
                        var _this = this;
                        var meta = GetValue(data, 'meta', null);
                        var frames = GetValue(data, 'frames', null);
                        if (meta && frames) {
                            var frameTags = GetValue(meta, 'frameTags', []);
                            frameTags.forEach(function(tag) {
                                var animFrames = [];
                                var name = GetFastValue(tag, 'name', null);
                                var from = GetFastValue(tag, 'from', 0);
                                var to = GetFastValue(tag, 'to', 0);
                                var direction = GetFastValue(tag, 'direction', 'forward');
                                if (!name) //  Skip if no name
                                return;
                                if (!tags || tags && tags.indexOf(name) > -1) {
                                    //  Get all the frames for this tag and calculate the total duration in milliseconds.
                                    var totalDuration = 0;
                                    for(var i = from; i <= to; i++){
                                        var frameKey = i.toString();
                                        var frame = frames[frameKey];
                                        if (frame) {
                                            var frameDuration = GetFastValue(frame, 'duration', MATH_CONST.MAX_SAFE_INTEGER);
                                            animFrames.push({
                                                key: key,
                                                frame: frameKey,
                                                duration: frameDuration
                                            });
                                            totalDuration += frameDuration;
                                        }
                                    }
                                    if (direction === 'reverse') animFrames = animFrames.reverse();
                                    //  Create the animation
                                    var createConfig = {
                                        key: name,
                                        frames: animFrames,
                                        duration: totalDuration,
                                        yoyo: direction === 'pingpong'
                                    };
                                    var result;
                                    if (target) {
                                        if (target.anims) result = target.anims.create(createConfig);
                                    } else result = _this.create(createConfig);
                                    if (result) output.push(result);
                                }
                            });
                        }
                        return output;
                    },
                    /**
     * Creates a new Animation and adds it to the Animation Manager.
     *
     * Animations are global. Once created, you can use them in any Scene in your game. They are not Scene specific.
     *
     * If an invalid key is given this method will return `false`.
     *
     * If you pass the key of an animation that already exists in the Animation Manager, that animation will be returned.
     *
     * A brand new animation is only created if the key is valid and not already in use.
     *
     * If you wish to re-use an existing key, call `AnimationManager.remove` first, then this method.
     *
     * @method Phaser.Animations.AnimationManager#create
     * @fires Phaser.Animations.Events#ADD_ANIMATION
     * @since 3.0.0
     *
     * @param {Phaser.Types.Animations.Animation} config - The configuration settings for the Animation.
     *
     * @return {(Phaser.Animations.Animation|false)} The Animation that was created, or `false` if the key is already in use.
     */ create: function(config) {
                        var key = config.key;
                        var anim = false;
                        if (key) {
                            anim = this.get(key);
                            if (!anim) {
                                anim = new Animation(this, key, config);
                                this.anims.set(key, anim);
                                this.emit(Events.ADD_ANIMATION, key, anim);
                            } else console.warn('AnimationManager key already exists: ' + key);
                        }
                        return anim;
                    },
                    /**
     * Loads this Animation Manager's Animations and settings from a JSON object.
     *
     * @method Phaser.Animations.AnimationManager#fromJSON
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.JSONAnimations|Phaser.Types.Animations.JSONAnimation)} data - The JSON object to parse.
     * @param {boolean} [clearCurrentAnimations=false] - If set to `true`, the current animations will be removed (`anims.clear()`). If set to `false` (default), the animations in `data` will be added.
     *
     * @return {Phaser.Animations.Animation[]} An array containing all of the Animation objects that were created as a result of this call.
     */ fromJSON: function(data, clearCurrentAnimations) {
                        if (clearCurrentAnimations === undefined) clearCurrentAnimations = false;
                        if (clearCurrentAnimations) this.anims.clear();
                        //  Do we have a String (i.e. from JSON, or an Object?)
                        if (typeof data === 'string') data = JSON.parse(data);
                        var output = [];
                        //  Array of animations, or a single animation?
                        if (data.hasOwnProperty('anims') && Array.isArray(data.anims)) {
                            for(var i = 0; i < data.anims.length; i++)output.push(this.create(data.anims[i]));
                            if (data.hasOwnProperty('globalTimeScale')) this.globalTimeScale = data.globalTimeScale;
                        } else if (data.hasOwnProperty('key') && data.type === 'frame') output.push(this.create(data));
                        return output;
                    },
                    /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with string based frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNames}.
     *
     * It's a helper method, designed to make it easier for you to extract all of the frame names from texture atlases.
     *
     * If you're working with a sprite sheet, see the `generateFrameNumbers` method instead.
     *
     * Example:
     *
     * If you have a texture atlases loaded called `gems` and it contains 6 frames called `ruby_0001`, `ruby_0002`, and so on,
     * then you can call this method using: `this.anims.generateFrameNames('gems', { prefix: 'ruby_', start: 1, end: 6, zeroPad: 4 })`.
     *
     * The `end` value tells it to select frames 1 through 6, incrementally numbered, all starting with the prefix `ruby_`. The `zeroPad`
     * value tells it how many zeroes pad out the numbers. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'ruby',
     *   repeat: -1,
     *   frames: this.anims.generateFrameNames('gems', {
     *     prefix: 'ruby_',
     *     end: 6,
     *     zeroPad: 4
     *   })
     * });
     * ```
     *
     * Please see the animation examples for further details.
     *
     * @method Phaser.Animations.AnimationManager#generateFrameNames
     * @since 3.0.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNames} [config] - The configuration object for the animation frame names.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNames: function(key, config) {
                        var prefix = GetValue(config, 'prefix', '');
                        var start = GetValue(config, 'start', 0);
                        var end = GetValue(config, 'end', 0);
                        var suffix = GetValue(config, 'suffix', '');
                        var zeroPad = GetValue(config, 'zeroPad', 0);
                        var out = GetValue(config, 'outputArray', []);
                        var frames = GetValue(config, 'frames', false);
                        if (!this.textureManager.exists(key)) {
                            console.warn('Texture "%s" not found', key);
                            return out;
                        }
                        var texture = this.textureManager.get(key);
                        if (!texture) return out;
                        var i;
                        if (!config) {
                            //  Use every frame in the atlas
                            frames = texture.getFrameNames();
                            for(i = 0; i < frames.length; i++)out.push({
                                key: key,
                                frame: frames[i]
                            });
                        } else {
                            if (!frames) frames = NumberArray(start, end);
                            for(i = 0; i < frames.length; i++){
                                var frame = prefix + Pad(frames[i], zeroPad, '0', 1) + suffix;
                                if (texture.has(frame)) out.push({
                                    key: key,
                                    frame: frame
                                });
                                else console.warn('Frame "%s" not found in texture "%s"', frame, key);
                            }
                        }
                        return out;
                    },
                    /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with numbered frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNumbers}.
     *
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * It's a helper method, designed to make it easier for you to extract frames from sprite sheets.
     *
     * Example:
     *
     * If you have a sprite sheet loaded called `explosion` and it contains 12 frames, then you can call this method using:
     *
     * `this.anims.generateFrameNumbers('explosion', { start: 0, end: 11 })`.
     *
     * The `end` value of 11 tells it to stop after the 12th frame has been added, because it started at zero.
     *
     * To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'boom',
     *   frames: this.anims.generateFrameNumbers('explosion', {
     *     start: 0,
     *     end: 11
     *   })
     * });
     * ```
     *
     * Note that `start` is optional and you don't need to include it if the animation starts from frame 0.
     *
     * To specify an animation in reverse, swap the `start` and `end` values.
     *
     * If the frames are not sequential, you may pass an array of frame numbers instead, for example:
     *
     * `this.anims.generateFrameNumbers('explosion', { frames: [ 0, 1, 2, 1, 2, 3, 4, 0, 1, 2 ] })`
     *
     * Please see the animation examples and `GenerateFrameNumbers` config docs for further details.
     *
     * @method Phaser.Animations.AnimationManager#generateFrameNumbers
     * @since 3.0.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNumbers} [config] - The configuration object for the animation frames.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNumbers: function(key, config) {
                        var start = GetValue(config, 'start', 0);
                        var end = GetValue(config, 'end', -1);
                        var first = GetValue(config, 'first', false);
                        var out = GetValue(config, 'outputArray', []);
                        var frames = GetValue(config, 'frames', false);
                        if (!this.textureManager.exists(key)) {
                            console.warn('Texture "%s" not found', key);
                            return out;
                        }
                        var texture = this.textureManager.get(key);
                        if (!texture) return out;
                        if (first && texture.has(first)) out.push({
                            key: key,
                            frame: first
                        });
                        //  No 'frames' array? Then generate one automatically
                        if (!frames) {
                            if (end === -1) //  -1 because of __BASE, which we don't want in our results
                            //  and -1 because frames are zero based
                            end = texture.frameTotal - 2;
                            frames = NumberArray(start, end);
                        }
                        for(var i = 0; i < frames.length; i++){
                            var frameName = frames[i];
                            if (texture.has(frameName)) out.push({
                                key: key,
                                frame: frameName
                            });
                            else console.warn('Frame "%s" not found in texture "%s"', frameName, key);
                        }
                        return out;
                    },
                    /**
     * Get an Animation.
     *
     * @method Phaser.Animations.AnimationManager#get
     * @since 3.0.0
     *
     * @param {string} key - The key of the Animation to retrieve.
     *
     * @return {Phaser.Animations.Animation} The Animation.
     */ get: function(key) {
                        return this.anims.get(key);
                    },
                    /**
     * Returns an array of all Animation keys that are using the given
     * Texture. Only Animations that have at least one AnimationFrame
     * entry using this texture will be included in the result.
     *
     * @method Phaser.Animations.AnimationManager#getAnimsFromTexture
     * @since 3.60.0
     *
     * @param {(string|Phaser.Textures.Texture|Phaser.Textures.Frame)} key - The unique string-based key of the Texture, or a Texture, or Frame instance.
     *
     * @return {string[]} An array of Animation keys that feature the given Texture.
     */ getAnimsFromTexture: function(key) {
                        var texture = this.textureManager.get(key);
                        var match = texture.key;
                        var anims = this.anims.getArray();
                        var out = [];
                        for(var i = 0; i < anims.length; i++){
                            var anim = anims[i];
                            var frames = anim.frames;
                            for(var c = 0; c < frames.length; c++)if (frames[c].textureKey === match) {
                                out.push(anim.key);
                                break;
                            }
                        }
                        return out;
                    },
                    /**
     * Pause all animations.
     *
     * @method Phaser.Animations.AnimationManager#pauseAll
     * @fires Phaser.Animations.Events#PAUSE_ALL
     * @since 3.0.0
     *
     * @return {this} This Animation Manager.
     */ pauseAll: function() {
                        if (!this.paused) {
                            this.paused = true;
                            this.emit(Events.PAUSE_ALL);
                        }
                        return this;
                    },
                    /**
     * Play an animation on the given Game Objects that have an Animation Component.
     *
     * @method Phaser.Animations.AnimationManager#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} children - An array of Game Objects to play the animation on. They must have an Animation Component.
     *
     * @return {this} This Animation Manager.
     */ play: function(key, children) {
                        if (!Array.isArray(children)) children = [
                            children
                        ];
                        for(var i = 0; i < children.length; i++)children[i].anims.play(key);
                        return this;
                    },
                    /**
     * Takes an array of Game Objects that have an Animation Component and then
     * starts the given animation playing on them. The start time of each Game Object
     * is offset, incrementally, by the `stagger` amount.
     *
     * For example, if you pass an array with 4 children and a stagger time of 1000,
     * the delays will be:
     *
     * child 1: 1000ms delay
     * child 2: 2000ms delay
     * child 3: 3000ms delay
     * child 4: 4000ms delay
     *
     * If you set the `staggerFirst` parameter to `false` they would be:
     *
     * child 1: 0ms delay
     * child 2: 1000ms delay
     * child 3: 2000ms delay
     * child 4: 3000ms delay
     *
     * You can also set `stagger` to be a negative value. If it was -1000, the above would be:
     *
     * child 1: 3000ms delay
     * child 2: 2000ms delay
     * child 3: 1000ms delay
     * child 4: 0ms delay
     *
     * @method Phaser.Animations.AnimationManager#staggerPlay
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} children - An array of Game Objects to play the animation on. They must have an Animation Component.
     * @param {number} stagger - The amount of time, in milliseconds, to offset each play time by. If a negative value is given, it's applied to the children in reverse order.
     * @param {boolean} [staggerFirst=true] -Should the first child be staggered as well?
     *
     * @return {this} This Animation Manager.
     */ staggerPlay: function(key, children, stagger, staggerFirst) {
                        if (stagger === undefined) stagger = 0;
                        if (staggerFirst === undefined) staggerFirst = true;
                        if (!Array.isArray(children)) children = [
                            children
                        ];
                        var len = children.length;
                        if (!staggerFirst) len--;
                        for(var i = 0; i < children.length; i++){
                            var time = stagger < 0 ? Math.abs(stagger) * (len - i) : stagger * i;
                            children[i].anims.playAfterDelay(key, time);
                        }
                        return this;
                    },
                    /**
     * Removes an Animation from this Animation Manager, based on the given key.
     *
     * This is a global action. Once an Animation has been removed, no Game Objects
     * can carry on using it.
     *
     * @method Phaser.Animations.AnimationManager#remove
     * @fires Phaser.Animations.Events#REMOVE_ANIMATION
     * @since 3.0.0
     *
     * @param {string} key - The key of the animation to remove.
     *
     * @return {Phaser.Animations.Animation} The Animation instance that was removed from the Animation Manager.
     */ remove: function(key) {
                        var anim = this.get(key);
                        if (anim) {
                            this.emit(Events.REMOVE_ANIMATION, key, anim);
                            this.anims.delete(key);
                            this.removeMix(key);
                        }
                        return anim;
                    },
                    /**
     * Resume all paused animations.
     *
     * @method Phaser.Animations.AnimationManager#resumeAll
     * @fires Phaser.Animations.Events#RESUME_ALL
     * @since 3.0.0
     *
     * @return {this} This Animation Manager.
     */ resumeAll: function() {
                        if (this.paused) {
                            this.paused = false;
                            this.emit(Events.RESUME_ALL);
                        }
                        return this;
                    },
                    /**
     * Returns the Animation data as JavaScript object based on the given key.
     * Or, if not key is defined, it will return the data of all animations as array of objects.
     *
     * @method Phaser.Animations.AnimationManager#toJSON
     * @since 3.0.0
     *
     * @param {string} [key] - The animation to get the JSONAnimation data from. If not provided, all animations are returned as an array.
     *
     * @return {Phaser.Types.Animations.JSONAnimations} The resulting JSONAnimations formatted object.
     */ toJSON: function(key) {
                        var output = {
                            anims: [],
                            globalTimeScale: this.globalTimeScale
                        };
                        if (key !== undefined && key !== '') output.anims.push(this.anims.get(key).toJSON());
                        else this.anims.each(function(animationKey, animation) {
                            output.anims.push(animation.toJSON());
                        });
                        return output;
                    },
                    /**
     * Destroy this Animation Manager and clean up animation definitions and references to other objects.
     * This method should not be called directly. It will be called automatically as a response to a `destroy` event from the Phaser.Game instance.
     *
     * @method Phaser.Animations.AnimationManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.anims.clear();
                        this.mixes.clear();
                        this.textureManager = null;
                        this.game = null;
                    }
                });
                module1.exports = AnimationManager;
            /***/ },
            /***/ 9674: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Animation = __webpack_require__(42099);
                var Between = __webpack_require__(30976);
                var Class = __webpack_require__(83419);
                var CustomMap = __webpack_require__(90330);
                var Events = __webpack_require__(74943);
                var GetFastValue = __webpack_require__(95540);
                /**
 * @classdesc
 * The Animation State Component.
 *
 * This component provides features to apply animations to Game Objects. It is responsible for
 * loading, queuing animations for later playback, mixing between animations and setting
 * the current animation frame to the Game Object that owns this component.
 *
 * This component lives as an instance within any Game Object that has it defined, such as Sprites.
 *
 * You can access its properties and methods via the `anims` property, i.e. `Sprite.anims`.
 *
 * As well as playing animations stored in the global Animation Manager, this component
 * can also create animations that are stored locally within it. See the `create` method
 * for more details.
 *
 * Prior to Phaser 3.50 this component was called just `Animation` and lived in the
 * `Phaser.GameObjects.Components` namespace. It was renamed to `AnimationState`
 * in 3.50 to help better identify its true purpose when browsing the documentation.
 *
 * @class AnimationState
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} parent - The Game Object to which this animation component belongs.
 */ var AnimationState = new Class({
                    initialize: function AnimationState(parent) {
                        /**
         * The Game Object to which this animation component belongs.
         *
         * You can typically access this component from the Game Object
         * via the `this.anims` property.
         *
         * @name Phaser.Animations.AnimationState#parent
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.parent = parent;
                        /**
         * A reference to the global Animation Manager.
         *
         * @name Phaser.Animations.AnimationState#animationManager
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.animationManager = parent.scene.sys.anims;
                        this.animationManager.on(Events.REMOVE_ANIMATION, this.globalRemove, this);
                        /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.Animations.AnimationState#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @protected
         * @since 3.50.0
         */ this.textureManager = this.animationManager.textureManager;
                        /**
         * The Animations stored locally in this Animation component.
         *
         * Do not modify the contents of this Map directly, instead use the
         * `add`, `create` and `remove` methods of this class instead.
         *
         * @name Phaser.Animations.AnimationState#anims
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @protected
         * @since 3.50.0
         */ this.anims = null;
                        /**
         * Is an animation currently playing or not?
         *
         * @name Phaser.Animations.AnimationState#isPlaying
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isPlaying = false;
                        /**
         * Has the current animation started playing, or is it waiting for a delay to expire?
         *
         * @name Phaser.Animations.AnimationState#hasStarted
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.hasStarted = false;
                        /**
         * The current Animation loaded into this Animation component.
         *
         * Will be `null` if no animation is yet loaded.
         *
         * @name Phaser.Animations.AnimationState#currentAnim
         * @type {?Phaser.Animations.Animation}
         * @default null
         * @since 3.0.0
         */ this.currentAnim = null;
                        /**
         * The current AnimationFrame being displayed by this Animation component.
         *
         * Will be `null` if no animation is yet loaded.
         *
         * @name Phaser.Animations.AnimationState#currentFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @since 3.0.0
         */ this.currentFrame = null;
                        /**
         * The key, instance, or config of the next Animation to be loaded into this Animation component
         * when the current animation completes.
         *
         * Will be `null` if no animation has been queued.
         *
         * @name Phaser.Animations.AnimationState#nextAnim
         * @type {?(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)}
         * @default null
         * @since 3.16.0
         */ this.nextAnim = null;
                        /**
         * A queue of Animations to be loaded into this Animation component when the current animation completes.
         *
         * Populate this queue via the `chain` method.
         *
         * @name Phaser.Animations.AnimationState#nextAnimsQueue
         * @type {array}
         * @since 3.24.0
         */ this.nextAnimsQueue = [];
                        /**
         * The Time Scale factor.
         *
         * You can adjust this value to modify the passage of time for the animation that is currently
         * playing. For example, setting it to 2 will make the animation play twice as fast. Or setting
         * it to 0.5 will slow the animation down.
         *
         * You can change this value at run-time, or set it via the `PlayAnimationConfig`.
         *
         * Prior to Phaser 3.50 this property was private and called `_timeScale`.
         *
         * @name Phaser.Animations.AnimationState#timeScale
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.timeScale = 1;
                        /**
         * The frame rate of playback, of the current animation, in frames per second.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the frame rate, provide a new value in the `PlayAnimationConfig` object.
         *
         * @name Phaser.Animations.AnimationState#frameRate
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.frameRate = 0;
                        /**
         * The duration of the current animation, in milliseconds.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the duration, provide a new value in the `PlayAnimationConfig` object.
         *
         * @name Phaser.Animations.AnimationState#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                        /**
         * The number of milliseconds per frame, not including frame specific modifiers that may be present in the
         * Animation data.
         *
         * This value is calculated when a new animation is loaded into this component and should
         * be treated as read-only. Changing it will not alter playback speed.
         *
         * @name Phaser.Animations.AnimationState#msPerFrame
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.msPerFrame = 0;
                        /**
         * Skip frames if the time lags, or always advanced anyway?
         *
         * @name Phaser.Animations.AnimationState#skipMissedFrames
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.skipMissedFrames = true;
                        /**
         * Start playback of this animation from a random frame?
         *
         * @name Phaser.Animations.AnimationState#randomFrame
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.randomFrame = false;
                        /**
         * The delay before starting playback of the current animation, in milliseconds.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the delay, provide a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_delay`.
         *
         * @name Phaser.Animations.AnimationState#delay
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.delay = 0;
                        /**
         * The number of times to repeat playback of the current animation.
         *
         * If -1, it means the animation will repeat forever.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the number of repeats, provide a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_repeat`.
         *
         * @name Phaser.Animations.AnimationState#repeat
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.repeat = 0;
                        /**
         * The number of milliseconds to wait before starting the repeat playback of the current animation.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * You can change the repeat delay by providing a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_repeatDelay`.
         *
         * @name Phaser.Animations.AnimationState#repeatDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatDelay = 0;
                        /**
         * Should the current animation yoyo? An animation that yoyos will play in reverse, from the end
         * to the start, before then repeating or completing. An animation that does not yoyo will just
         * play from the start to the end.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * You can change the yoyo by providing a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_yoyo`.
         *
         * @name Phaser.Animations.AnimationState#yoyo
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.yoyo = false;
                        /**
         * If the animation has a delay set, before playback will begin, this
         * controls when the first frame is set on the Sprite. If this property
         * is 'false' then the frame is set only after the delay has expired.
         * This is the default behavior.
         *
         * If this property is 'true' then the first frame of this animation
         * is set immediately, and then when the delay expires, playback starts.
         *
         * @name Phaser.Animations.AnimationState#showBeforeDelay
         * @type {boolean}
         * @since 3.60.0
         */ this.showBeforeDelay = false;
                        /**
         * Should the GameObject's `visible` property be set to `true` when the animation starts to play?
         *
         * This will happen _after_ any delay that may have been set.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time, assuming the animation is currently delayed.
         *
         * @name Phaser.Animations.AnimationState#showOnStart
         * @type {boolean}
         * @since 3.50.0
         */ this.showOnStart = false;
                        /**
         * Should the GameObject's `visible` property be set to `false` when the animation completes?
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time, assuming the animation is still actively playing.
         *
         * @name Phaser.Animations.AnimationState#hideOnComplete
         * @type {boolean}
         * @since 3.50.0
         */ this.hideOnComplete = false;
                        /**
         * Is the playhead moving forwards (`true`) or in reverse (`false`) ?
         *
         * @name Phaser.Animations.AnimationState#forward
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.forward = true;
                        /**
         * An internal trigger that tells the component if it should plays the animation
         * in reverse mode ('true') or not ('false'). This is used because `forward` can
         * be changed by the `yoyo` feature.
         *
         * Prior to Phaser 3.50 this property was private and called `_reverse`.
         *
         * @name Phaser.Animations.AnimationState#inReverse
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.inReverse = false;
                        /**
         * Internal time overflow accumulator.
         *
         * This has the `delta` time added to it as part of the `update` step.
         *
         * @name Phaser.Animations.AnimationState#accumulator
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accumulator = 0;
                        /**
         * The time point at which the next animation frame will change.
         *
         * This value is compared against the `accumulator` as part of the `update` step.
         *
         * @name Phaser.Animations.AnimationState#nextTick
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.nextTick = 0;
                        /**
         * A counter keeping track of how much delay time, in milliseconds, is left before playback begins.
         *
         * This is set via the `playAfterDelay` method, although it can be modified at run-time
         * if required, as long as the animation has not already started playing.
         *
         * @name Phaser.Animations.AnimationState#delayCounter
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.delayCounter = 0;
                        /**
         * A counter that keeps track of how many repeats are left to run.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * @name Phaser.Animations.AnimationState#repeatCounter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatCounter = 0;
                        /**
         * An internal flag keeping track of pending repeats.
         *
         * @name Phaser.Animations.AnimationState#pendingRepeat
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pendingRepeat = false;
                        /**
         * Is the Animation paused?
         *
         * @name Phaser.Animations.AnimationState#_paused
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._paused = false;
                        /**
         * Was the animation previously playing before being paused?
         *
         * @name Phaser.Animations.AnimationState#_wasPlaying
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._wasPlaying = false;
                        /**
         * Internal property tracking if this Animation is waiting to stop.
         *
         * 0 = No
         * 1 = Waiting for ms to pass
         * 2 = Waiting for repeat
         * 3 = Waiting for specific frame
         *
         * @name Phaser.Animations.AnimationState#_pendingStop
         * @type {number}
         * @private
         * @since 3.4.0
         */ this._pendingStop = 0;
                        /**
         * Internal property used by _pendingStop.
         *
         * @name Phaser.Animations.AnimationState#_pendingStopValue
         * @type {any}
         * @private
         * @since 3.4.0
         */ this._pendingStopValue;
                    },
                    /**
     * Sets an animation, or an array of animations, to be played in the future, after the current one completes or stops.
     *
     * The current animation must enter a 'completed' state for this to happen, i.e. finish all of its repeats, delays, etc,
     * or have one of the `stop` methods called.
     *
     * An animation set to repeat forever will never enter a completed state unless stopped.
     *
     * You can chain a new animation at any point, including before the current one starts playing, during it, or when it ends (via its `animationcomplete` event).
     *
     * Chained animations are specific to a Game Object, meaning different Game Objects can have different chained animations without impacting the global animation they're playing.
     *
     * Call this method with no arguments to reset all currently chained animations.
     *
     * @method Phaser.Animations.AnimationState#chain
     * @since 3.16.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig|string[]|Phaser.Animations.Animation[]|Phaser.Types.Animations.PlayAnimationConfig[])} [key] - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object, or an array of them.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ chain: function(key) {
                        var parent = this.parent;
                        if (key === undefined) {
                            this.nextAnimsQueue.length = 0;
                            this.nextAnim = null;
                            return parent;
                        }
                        if (!Array.isArray(key)) key = [
                            key
                        ];
                        for(var i = 0; i < key.length; i++){
                            var anim = key[i];
                            if (!this.nextAnim) this.nextAnim = anim;
                            else this.nextAnimsQueue.push(anim);
                        }
                        return this.parent;
                    },
                    /**
     * Returns the key of the animation currently loaded into this component.
     *
     * Prior to Phaser 3.50 this method was called `getCurrentKey`.
     *
     * @method Phaser.Animations.AnimationState#getName
     * @since 3.50.0
     *
     * @return {string} The key of the Animation currently loaded into this component, or an empty string if none loaded.
     */ getName: function() {
                        return this.currentAnim ? this.currentAnim.key : '';
                    },
                    /**
     * Returns the key of the animation frame currently displayed by this component.
     *
     * @method Phaser.Animations.AnimationState#getFrameName
     * @since 3.50.0
     *
     * @return {string} The key of the Animation Frame currently displayed by this component, or an empty string if no animation has been loaded.
     */ getFrameName: function() {
                        return this.currentFrame ? this.currentFrame.textureFrame : '';
                    },
                    /**
     * Internal method used to load an animation into this component.
     *
     * @method Phaser.Animations.AnimationState#load
     * @protected
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or a `PlayAnimationConfig` object.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ load: function(key) {
                        if (this.isPlaying) this.stop();
                        var manager = this.animationManager;
                        var animKey = typeof key === 'string' ? key : GetFastValue(key, 'key', null);
                        //  Get the animation, first from the local map and, if not found, from the Animation Manager
                        var anim = this.exists(animKey) ? this.get(animKey) : manager.get(animKey);
                        if (!anim) console.warn('Missing animation: ' + animKey);
                        else {
                            this.currentAnim = anim;
                            //  And now override the animation values, if set in the config.
                            var totalFrames = anim.getTotalFrames();
                            var frameRate = GetFastValue(key, 'frameRate', anim.frameRate);
                            var duration = GetFastValue(key, 'duration', anim.duration);
                            anim.calculateDuration(this, totalFrames, duration, frameRate);
                            this.delay = GetFastValue(key, 'delay', anim.delay);
                            this.repeat = GetFastValue(key, 'repeat', anim.repeat);
                            this.repeatDelay = GetFastValue(key, 'repeatDelay', anim.repeatDelay);
                            this.yoyo = GetFastValue(key, 'yoyo', anim.yoyo);
                            this.showBeforeDelay = GetFastValue(key, 'showBeforeDelay', anim.showBeforeDelay);
                            this.showOnStart = GetFastValue(key, 'showOnStart', anim.showOnStart);
                            this.hideOnComplete = GetFastValue(key, 'hideOnComplete', anim.hideOnComplete);
                            this.skipMissedFrames = GetFastValue(key, 'skipMissedFrames', anim.skipMissedFrames);
                            this.randomFrame = GetFastValue(key, 'randomFrame', anim.randomFrame);
                            this.timeScale = GetFastValue(key, 'timeScale', this.timeScale);
                            var startFrame = GetFastValue(key, 'startFrame', 0);
                            if (startFrame > totalFrames) startFrame = 0;
                            if (this.randomFrame) startFrame = Between(0, totalFrames - 1);
                            var frame = anim.frames[startFrame];
                            if (startFrame === 0 && !this.forward) frame = anim.getLastFrame();
                            this.currentFrame = frame;
                        }
                        return this.parent;
                    },
                    /**
     * Pause the current animation and set the `isPlaying` property to `false`.
     * You can optionally pause it at a specific frame.
     *
     * @method Phaser.Animations.AnimationState#pause
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} [atFrame] - An optional frame to set after pausing the animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ pause: function(atFrame) {
                        if (!this._paused) {
                            this._paused = true;
                            this._wasPlaying = this.isPlaying;
                            this.isPlaying = false;
                        }
                        if (atFrame !== undefined) this.setCurrentFrame(atFrame);
                        return this.parent;
                    },
                    /**
     * Resumes playback of a paused animation and sets the `isPlaying` property to `true`.
     * You can optionally tell it to start playback from a specific frame.
     *
     * @method Phaser.Animations.AnimationState#resume
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} [fromFrame] - An optional frame to set before restarting playback.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ resume: function(fromFrame) {
                        if (this._paused) {
                            this._paused = false;
                            this.isPlaying = this._wasPlaying;
                        }
                        if (fromFrame !== undefined) this.setCurrentFrame(fromFrame);
                        return this.parent;
                    },
                    /**
     * Waits for the specified delay, in milliseconds, then starts playback of the given animation.
     *
     * If the animation _also_ has a delay value set in its config, it will be **added** to the delay given here.
     *
     * If an animation is already running and a new animation is given to this method, it will wait for
     * the given delay before starting the new animation.
     *
     * If no animation is currently running, the given one begins after the delay.
     *
     * Prior to Phaser 3.50 this method was called 'delayedPlay' and the parameters were in the reverse order.
     *
     * @method Phaser.Animations.AnimationState#playAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} delay - The delay, in milliseconds, to wait before starting the animation playing.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playAfterDelay: function(key, delay) {
                        if (!this.isPlaying) {
                            this.delayCounter = delay;
                            this.play(key, true);
                        } else {
                            //  If we've got a nextAnim, move it to the queue
                            var nextAnim = this.nextAnim;
                            var queue = this.nextAnimsQueue;
                            if (nextAnim) queue.unshift(nextAnim);
                            this.nextAnim = key;
                            this._pendingStop = 1;
                            this._pendingStopValue = delay;
                        }
                        return this.parent;
                    },
                    /**
     * Waits for the current animation to complete the `repeatCount` number of repeat cycles, then starts playback
     * of the given animation.
     *
     * You can use this to ensure there are no harsh jumps between two sets of animations, i.e. going from an
     * idle animation to a walking animation, by making them blend smoothly into each other.
     *
     * If no animation is currently running, the given one will start immediately.
     *
     * @method Phaser.Animations.AnimationState#playAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} [repeatCount=1] - How many times should the animation repeat before the next one starts?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playAfterRepeat: function(key, repeatCount) {
                        if (repeatCount === undefined) repeatCount = 1;
                        if (!this.isPlaying) this.play(key);
                        else {
                            //  If we've got a nextAnim, move it to the queue
                            var nextAnim = this.nextAnim;
                            var queue = this.nextAnimsQueue;
                            if (nextAnim) queue.unshift(nextAnim);
                            if (this.repeatCounter !== -1 && repeatCount > this.repeatCounter) repeatCount = this.repeatCounter;
                            this.nextAnim = key;
                            this._pendingStop = 2;
                            this._pendingStopValue = repeatCount;
                        }
                        return this.parent;
                    },
                    /**
     * Start playing the given animation on this Sprite.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).play('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).play({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.Animations.AnimationState#play
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If this animation is already playing then ignore this call.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ play: function(key, ignoreIfPlaying) {
                        if (ignoreIfPlaying === undefined) ignoreIfPlaying = false;
                        var currentAnim = this.currentAnim;
                        var parent = this.parent;
                        //  Must be either an Animation instance, or a PlayAnimationConfig object
                        var animKey = typeof key === 'string' ? key : key.key;
                        if (ignoreIfPlaying && this.isPlaying && currentAnim.key === animKey) return parent;
                        //  Are we mixing?
                        if (currentAnim && this.isPlaying) {
                            var mix = this.animationManager.getMix(currentAnim.key, key);
                            if (mix > 0) return this.playAfterDelay(key, mix);
                        }
                        this.forward = true;
                        this.inReverse = false;
                        this._paused = false;
                        this._wasPlaying = true;
                        return this.startAnimation(key);
                    },
                    /**
     * Start playing the given animation on this Sprite, in reverse.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.Animations.AnimationState#playReverse
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.12.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playReverse: function(key, ignoreIfPlaying) {
                        if (ignoreIfPlaying === undefined) ignoreIfPlaying = false;
                        //  Must be either an Animation instance, or a PlayAnimationConfig object
                        var animKey = typeof key === 'string' ? key : key.key;
                        if (ignoreIfPlaying && this.isPlaying && this.currentAnim.key === animKey) return this.parent;
                        this.forward = false;
                        this.inReverse = true;
                        this._paused = false;
                        this._wasPlaying = true;
                        return this.startAnimation(key);
                    },
                    /**
     * Load the animation based on the key and set-up all of the internal values
     * needed for playback to start. If there is no delay, it will also fire the start events.
     *
     * @method Phaser.Animations.AnimationState#startAnimation
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or a `PlayAnimationConfig` object.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ startAnimation: function(key) {
                        this.load(key);
                        var anim = this.currentAnim;
                        var gameObject = this.parent;
                        if (!anim) return gameObject;
                        //  Should give us 9,007,199,254,740,991 safe repeats
                        this.repeatCounter = this.repeat === -1 ? Number.MAX_VALUE : this.repeat;
                        anim.getFirstTick(this);
                        this.isPlaying = true;
                        this.pendingRepeat = false;
                        this.hasStarted = false;
                        this._pendingStop = 0;
                        this._pendingStopValue = 0;
                        this._paused = false;
                        //  Add any delay the animation itself may have had as well
                        this.delayCounter += this.delay;
                        if (this.delayCounter === 0) this.handleStart();
                        else if (this.showBeforeDelay) //  We have a delay, but still need to set the frame
                        this.setCurrentFrame(this.currentFrame);
                        return gameObject;
                    },
                    /**
     * Handles the start of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleStart
     * @private
     * @since 3.50.0
     */ handleStart: function() {
                        if (this.showOnStart) this.parent.setVisible(true);
                        this.setCurrentFrame(this.currentFrame);
                        this.hasStarted = true;
                        this.emitEvents(Events.ANIMATION_START);
                    },
                    /**
     * Handles the repeat of an animation.
     *
     * @method Phaser.Animations.AnimationState#handleRepeat
     * @private
     * @since 3.50.0
     */ handleRepeat: function() {
                        this.pendingRepeat = false;
                        this.emitEvents(Events.ANIMATION_REPEAT);
                    },
                    /**
     * Handles the stop of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleStop
     * @private
     * @since 3.50.0
     */ handleStop: function() {
                        this._pendingStop = 0;
                        this.isPlaying = false;
                        this.emitEvents(Events.ANIMATION_STOP);
                    },
                    /**
     * Handles the completion of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleComplete
     * @private
     * @since 3.50.0
     */ handleComplete: function() {
                        this._pendingStop = 0;
                        this.isPlaying = false;
                        if (this.hideOnComplete) this.parent.setVisible(false);
                        this.emitEvents(Events.ANIMATION_COMPLETE, Events.ANIMATION_COMPLETE_KEY);
                    },
                    /**
     * Fires the given animation event.
     *
     * @method Phaser.Animations.AnimationState#emitEvents
     * @private
     * @since 3.50.0
     *
     * @param {string} event - The Animation Event to dispatch.
     */ emitEvents: function(event, keyEvent) {
                        var anim = this.currentAnim;
                        if (anim) {
                            var frame = this.currentFrame;
                            var gameObject = this.parent;
                            var frameKey = frame.textureFrame;
                            gameObject.emit(event, anim, frame, gameObject, frameKey);
                            if (keyEvent) gameObject.emit(keyEvent + anim.key, anim, frame, gameObject, frameKey);
                        }
                    },
                    /**
     * Reverse the Animation that is already playing on the Game Object.
     *
     * @method Phaser.Animations.AnimationState#reverse
     * @since 3.12.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ reverse: function() {
                        if (this.isPlaying) {
                            this.inReverse = !this.inReverse;
                            this.forward = !this.forward;
                        }
                        return this.parent;
                    },
                    /**
     * Returns a value between 0 and 1 indicating how far this animation is through, ignoring repeats and yoyos.
     *
     * The value is based on the current frame and how far that is in the animation, it is not based on
     * the duration of the animation.
     *
     * @method Phaser.Animations.AnimationState#getProgress
     * @since 3.4.0
     *
     * @return {number} The progress of the current animation in frames, between 0 and 1.
     */ getProgress: function() {
                        var frame = this.currentFrame;
                        if (!frame) return 0;
                        var p = frame.progress;
                        if (this.inReverse) p *= -1;
                        return p;
                    },
                    /**
     * Takes a value between 0 and 1 and uses it to set how far this animation is through playback.
     *
     * Does not factor in repeats or yoyos, but does handle playing forwards or backwards.
     *
     * The value is based on the current frame and how far that is in the animation, it is not based on
     * the duration of the animation.
     *
     * @method Phaser.Animations.AnimationState#setProgress
     * @since 3.4.0
     *
     * @param {number} [value=0] - The progress value, between 0 and 1.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ setProgress: function(value) {
                        if (!this.forward) value = 1 - value;
                        this.setCurrentFrame(this.currentAnim.getFrameByProgress(value));
                        return this.parent;
                    },
                    /**
     * Sets the number of times that the animation should repeat after its first play through.
     * For example, if repeat is 1, the animation will play a total of twice: the initial play plus 1 repeat.
     *
     * To repeat indefinitely, use -1.
     * The value should always be an integer.
     *
     * Calling this method only works if the animation is already running. Otherwise, any
     * value specified here will be overwritten when the next animation loads in. To avoid this,
     * use the `repeat` property of the `PlayAnimationConfig` object instead.
     *
     * @method Phaser.Animations.AnimationState#setRepeat
     * @since 3.4.0
     *
     * @param {number} value - The number of times that the animation should repeat.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ setRepeat: function(value) {
                        this.repeatCounter = value === -1 ? Number.MAX_VALUE : value;
                        return this.parent;
                    },
                    /**
     * Handle the removal of an animation from the Animation Manager.
     *
     * @method Phaser.Animations.AnimationState#globalRemove
     * @since 3.50.0
     *
     * @param {string} [key] - The key of the removed Animation.
     * @param {Phaser.Animations.Animation} [animation] - The removed Animation.
     */ globalRemove: function(key, animation) {
                        if (animation === undefined) animation = this.currentAnim;
                        if (this.isPlaying && animation.key === this.currentAnim.key) {
                            this.stop();
                            this.setCurrentFrame(this.currentAnim.frames[0]);
                        }
                    },
                    /**
     * Restarts the current animation from its beginning.
     *
     * You can optionally reset the delay and repeat counters as well.
     *
     * Calling this will fire the `ANIMATION_RESTART` event immediately.
     *
     * If you `includeDelay` then it will also fire the `ANIMATION_START` event once
     * the delay has expired, otherwise, playback will just begin immediately.
     *
     * @method Phaser.Animations.AnimationState#restart
     * @fires Phaser.Animations.Events#ANIMATION_RESTART
     * @since 3.0.0
     *
     * @param {boolean} [includeDelay=false] - Whether to include the delay value of the animation when restarting.
     * @param {boolean} [resetRepeats=false] - Whether to reset the repeat counter or not?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ restart: function(includeDelay, resetRepeats) {
                        if (includeDelay === undefined) includeDelay = false;
                        if (resetRepeats === undefined) resetRepeats = false;
                        var anim = this.currentAnim;
                        var gameObject = this.parent;
                        if (!anim) return gameObject;
                        if (resetRepeats) this.repeatCounter = this.repeat === -1 ? Number.MAX_VALUE : this.repeat;
                        anim.getFirstTick(this);
                        this.emitEvents(Events.ANIMATION_RESTART);
                        this.isPlaying = true;
                        this.pendingRepeat = false;
                        //  Set this to `true` if there is no delay to include, so it skips the `hasStarted` check in `update`.
                        this.hasStarted = !includeDelay;
                        this._pendingStop = 0;
                        this._pendingStopValue = 0;
                        this._paused = false;
                        this.setCurrentFrame(anim.frames[0]);
                        return this.parent;
                    },
                    /**
     * The current animation has completed. This dispatches the `ANIMATION_COMPLETE` event.
     *
     * This method is called by the Animation instance and should not usually be invoked directly.
     *
     * If no animation is loaded, no events will be dispatched.
     *
     * If another animation has been queued for playback, it will be started after the events fire.
     *
     * @method Phaser.Animations.AnimationState#complete
     * @fires Phaser.Animations.Events#ANIMATION_COMPLETE
     * @since 3.50.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ complete: function() {
                        this._pendingStop = 0;
                        this.isPlaying = false;
                        if (this.currentAnim) this.handleComplete();
                        if (this.nextAnim) {
                            var key = this.nextAnim;
                            this.nextAnim = this.nextAnimsQueue.length > 0 ? this.nextAnimsQueue.shift() : null;
                            this.play(key);
                        }
                        return this.parent;
                    },
                    /**
     * Immediately stops the current animation from playing and dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing.
     *
     * @method Phaser.Animations.AnimationState#stop
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stop: function() {
                        this._pendingStop = 0;
                        this.isPlaying = false;
                        this.delayCounter = 0;
                        if (this.currentAnim) this.handleStop();
                        if (this.nextAnim) {
                            var key = this.nextAnim;
                            this.nextAnim = this.nextAnimsQueue.shift();
                            this.play(key);
                        }
                        return this.parent;
                    },
                    /**
     * Stops the current animation from playing after the specified time delay, given in milliseconds.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.Animations.AnimationState#stopAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {number} delay - The number of milliseconds to wait before stopping this animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopAfterDelay: function(delay) {
                        this._pendingStop = 1;
                        this._pendingStopValue = delay;
                        return this.parent;
                    },
                    /**
     * Stops the current animation from playing when it next repeats.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * Prior to Phaser 3.50 this method was called `stopOnRepeat` and had no parameters.
     *
     * @method Phaser.Animations.AnimationState#stopAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} [repeatCount=1] - How many times should the animation repeat before stopping?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopAfterRepeat: function(repeatCount) {
                        if (repeatCount === undefined) repeatCount = 1;
                        if (this.repeatCounter !== -1 && repeatCount > this.repeatCounter) repeatCount = this.repeatCounter;
                        this._pendingStop = 2;
                        this._pendingStopValue = repeatCount;
                        return this.parent;
                    },
                    /**
     * Stops the current animation from playing when it next sets the given frame.
     * If this frame doesn't exist within the animation it will not stop it from playing.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.Animations.AnimationState#stopOnFrame
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The frame to check before stopping this animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopOnFrame: function(frame) {
                        this._pendingStop = 3;
                        this._pendingStopValue = frame;
                        return this.parent;
                    },
                    /**
     * Returns the total number of frames in this animation, or returns zero if no
     * animation has been loaded.
     *
     * @method Phaser.Animations.AnimationState#getTotalFrames
     * @since 3.4.0
     *
     * @return {number} The total number of frames in the current animation, or zero if no animation has been loaded.
     */ getTotalFrames: function() {
                        return this.currentAnim ? this.currentAnim.getTotalFrames() : 0;
                    },
                    /**
     * The internal update loop for the AnimationState Component.
     *
     * This is called automatically by the `Sprite.preUpdate` method.
     *
     * @method Phaser.Animations.AnimationState#update
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        var anim = this.currentAnim;
                        if (!this.isPlaying || !anim || anim.paused) return;
                        this.accumulator += delta * this.timeScale * this.animationManager.globalTimeScale;
                        if (this._pendingStop === 1) {
                            this._pendingStopValue -= delta;
                            if (this._pendingStopValue <= 0) return this.stop();
                        }
                        if (!this.hasStarted) {
                            if (this.accumulator >= this.delayCounter) {
                                this.accumulator -= this.delayCounter;
                                this.handleStart();
                            }
                        } else if (this.accumulator >= this.nextTick) {
                            //  Process one frame advance as standard
                            if (this.forward) anim.nextFrame(this);
                            else anim.previousFrame(this);
                            //  And only do more if we're skipping frames and have time left
                            if (this.isPlaying && this._pendingStop === 0 && this.skipMissedFrames && this.accumulator > this.nextTick) {
                                var safetyNet = 0;
                                do {
                                    if (this.forward) anim.nextFrame(this);
                                    else anim.previousFrame(this);
                                    safetyNet++;
                                }while (this.isPlaying && this.accumulator > this.nextTick && safetyNet < 60);
                            }
                        }
                    },
                    /**
     * Sets the given Animation Frame as being the current frame
     * and applies it to the parent Game Object, adjusting size and origin as needed.
     *
     * @method Phaser.Animations.AnimationState#setCurrentFrame
     * @fires Phaser.Animations.Events#ANIMATION_UPDATE
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {Phaser.Animations.AnimationFrame} animationFrame - The animation frame to change to.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ setCurrentFrame: function(animationFrame) {
                        var gameObject = this.parent;
                        this.currentFrame = animationFrame;
                        gameObject.texture = animationFrame.frame.texture;
                        gameObject.frame = animationFrame.frame;
                        if (gameObject.isCropped) gameObject.frame.updateCropUVs(gameObject._crop, gameObject.flipX, gameObject.flipY);
                        if (animationFrame.setAlpha) gameObject.alpha = animationFrame.alpha;
                        gameObject.setSizeToFrame();
                        if (gameObject._originComponent) {
                            if (animationFrame.frame.customPivot) gameObject.setOrigin(animationFrame.frame.pivotX, animationFrame.frame.pivotY);
                            else gameObject.updateDisplayOrigin();
                        }
                        if (this.isPlaying && this.hasStarted) {
                            this.emitEvents(Events.ANIMATION_UPDATE);
                            if (this._pendingStop === 3 && this._pendingStopValue === animationFrame) this.stop();
                        }
                        return gameObject;
                    },
                    /**
     * Advances the animation to the next frame, regardless of the time or animation state.
     * If the animation is set to repeat, or yoyo, this will still take effect.
     *
     * Calling this does not change the direction of the animation. I.e. if it was currently
     * playing in reverse, calling this method doesn't then change the direction to forwards.
     *
     * @method Phaser.Animations.AnimationState#nextFrame
     * @since 3.16.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ nextFrame: function() {
                        if (this.currentAnim) this.currentAnim.nextFrame(this);
                        return this.parent;
                    },
                    /**
     * Advances the animation to the previous frame, regardless of the time or animation state.
     * If the animation is set to repeat, or yoyo, this will still take effect.
     *
     * Calling this does not change the direction of the animation. I.e. if it was currently
     * playing in forwards, calling this method doesn't then change the direction to backwards.
     *
     * @method Phaser.Animations.AnimationState#previousFrame
     * @since 3.16.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ previousFrame: function() {
                        if (this.currentAnim) this.currentAnim.previousFrame(this);
                        return this.parent;
                    },
                    /**
     * Get an Animation instance that has been created locally on this Sprite.
     *
     * See the `create` method for more details.
     *
     * @method Phaser.Animations.AnimationState#get
     * @since 3.50.0
     *
     * @param {string} key - The key of the Animation to retrieve.
     *
     * @return {Phaser.Animations.Animation} The Animation, or `null` if the key is invalid.
     */ get: function(key) {
                        return this.anims ? this.anims.get(key) : null;
                    },
                    /**
     * Checks to see if the given key is already used locally within the animations stored on this Sprite.
     *
     * @method Phaser.Animations.AnimationState#exists
     * @since 3.50.0
     *
     * @param {string} key - The key of the Animation to check.
     *
     * @return {boolean} `true` if the Animation exists locally, or `false` if the key is available, or there are no local animations.
     */ exists: function(key) {
                        return this.anims ? this.anims.has(key) : false;
                    },
                    /**
     * Creates a new Animation that is local specifically to this Sprite.
     *
     * When a Sprite owns an animation, it is kept out of the global Animation Manager, which means
     * you're free to use keys that may be already defined there. Unless you specifically need a Sprite
     * to have a unique animation, you should favor using global animations instead, as they allow for
     * the same animation to be used across multiple Sprites, saving on memory. However, if this Sprite
     * is the only one to use this animation, it's sensible to create it here.
     *
     * If an invalid key is given this method will return `false`.
     *
     * If you pass the key of an animation that already exists locally, that animation will be returned.
     *
     * A brand new animation is only created if the key is valid and not already in use by this Sprite.
     *
     * If you wish to re-use an existing key, call the `remove` method first, then this method.
     *
     * @method Phaser.Animations.AnimationState#create
     * @since 3.50.0
     *
     * @param {Phaser.Types.Animations.Animation} config - The configuration settings for the Animation.
     *
     * @return {(Phaser.Animations.Animation|false)} The Animation that was created, or `false` if the key is already in use.
     */ create: function(config) {
                        var key = config.key;
                        var anim = false;
                        if (key) {
                            anim = this.get(key);
                            if (!anim) {
                                anim = new Animation(this, key, config);
                                if (!this.anims) this.anims = new CustomMap();
                                this.anims.set(key, anim);
                            } else console.warn('Animation key already exists: ' + key);
                        }
                        return anim;
                    },
                    /**
     * Create one, or more animations from a loaded Aseprite JSON file.
     *
     * Aseprite is a powerful animated sprite editor and pixel art tool.
     *
     * You can find more details at https://www.aseprite.org/
     *
     * To export a compatible JSON file in Aseprite, please do the following:
     *
     * 1. Go to "File - Export Sprite Sheet"
     *
     * 2. On the **Layout** tab:
     * 2a. Set the "Sheet type" to "Packed"
     * 2b. Set the "Constraints" to "None"
     * 2c. Check the "Merge Duplicates" checkbox
     *
     * 3. On the **Sprite** tab:
     * 3a. Set "Layers" to "Visible layers"
     * 3b. Set "Frames" to "All frames", unless you only wish to export a sub-set of tags
     *
     * 4. On the **Borders** tab:
     * 4a. Check the "Trim Sprite" and "Trim Cells" options
     * 4b. Ensure "Border Padding", "Spacing" and "Inner Padding" are all > 0 (1 is usually enough)
     *
     * 5. On the **Output** tab:
     * 5a. Check "Output File", give your image a name and make sure you choose "png files" as the file type
     * 5b. Check "JSON Data" and give your json file a name
     * 5c. The JSON Data type can be either a Hash or Array, Phaser doesn't mind.
     * 5d. Make sure "Tags" is checked in the Meta options
     * 5e. In the "Item Filename" input box, make sure it says just "{frame}" and nothing more.
     *
     * 6. Click export
     *
     * This was tested with Aseprite 1.2.25.
     *
     * This will export a png and json file which you can load using the Aseprite Loader, i.e.:
     *
     * ```javascript
     * function preload ()
     * {
     *     this.load.path = 'assets/animations/aseprite/';
     *     this.load.aseprite('paladin', 'paladin.png', 'paladin.json');
     * }
     * ```
     *
     * Once loaded, you can call this method on a Sprite with the 'atlas' key:
     *
     * ```javascript
     * const sprite = this.add.sprite(400, 300);
     *
     * sprite.anims.createFromAseprite('paladin');
     * ```
     *
     * Any animations defined in the JSON will now be available to use on this Sprite and you play them
     * via their Tag name. For example, if you have an animation called 'War Cry' on your Aseprite timeline,
     * you can play it on the Sprite using that Tag name:
     *
     * ```javascript
     * const sprite = this.add.sprite(400, 300);
     *
     * sprite.anims.createFromAseprite('paladin');
     *
     * sprite.play('War Cry');
     * ```
     *
     * When calling this method you can optionally provide an array of tag names, and only those animations
     * will be created. For example:
     *
     * ```javascript
     * sprite.anims.createFromAseprite('paladin', [ 'step', 'War Cry', 'Magnum Break' ]);
     * ```
     *
     * This will only create the 3 animations defined. Note that the tag names are case-sensitive.
     *
     * @method Phaser.Animations.AnimationState#createFromAseprite
     * @since 3.60.0
     *
     * @param {string} key - The key of the loaded Aseprite atlas. It must have been loaded prior to calling this method.
     * @param {string[]} [tags] - An array of Tag names. If provided, only animations found in this array will be created.
     *
     * @return {Phaser.Animations.Animation[]} An array of Animation instances that were successfully created.
     */ createFromAseprite: function(key, tags) {
                        return this.animationManager.createFromAseprite(key, tags, this.parent);
                    },
                    /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with string based frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNames}.
     *
     * It's a helper method, designed to make it easier for you to extract all of the frame names from texture atlases.
     * If you're working with a sprite sheet, see the `generateFrameNumbers` method instead.
     *
     * Example:
     *
     * If you have a texture atlases loaded called `gems` and it contains 6 frames called `ruby_0001`, `ruby_0002`, and so on,
     * then you can call this method using: `this.anims.generateFrameNames('gems', { prefix: 'ruby_', end: 6, zeroPad: 4 })`.
     *
     * The `end` value tells it to look for 6 frames, incrementally numbered, all starting with the prefix `ruby_`. The `zeroPad`
     * value tells it how many zeroes pad out the numbers. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'ruby',
     *   repeat: -1,
     *   frames: this.anims.generateFrameNames('gems', {
     *     prefix: 'ruby_',
     *     end: 6,
     *     zeroPad: 4
     *   })
     * });
     * ```
     *
     * Please see the animation examples for further details.
     *
     * @method Phaser.Animations.AnimationState#generateFrameNames
     * @since 3.50.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNames} [config] - The configuration object for the animation frame names.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNames: function(key, config) {
                        return this.animationManager.generateFrameNames(key, config);
                    },
                    /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with numbered frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNumbers}.
     *
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * It's a helper method, designed to make it easier for you to extract frames from sprite sheets.
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * Example:
     *
     * If you have a sprite sheet loaded called `explosion` and it contains 12 frames, then you can call this method using:
     * `this.anims.generateFrameNumbers('explosion', { start: 0, end: 11 })`.
     *
     * The `end` value tells it to stop after 12 frames. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'boom',
     *   frames: this.anims.generateFrameNumbers('explosion', {
     *     start: 0,
     *     end: 11
     *   })
     * });
     * ```
     *
     * Note that `start` is optional and you don't need to include it if the animation starts from frame 0.
     *
     * To specify an animation in reverse, swap the `start` and `end` values.
     *
     * If the frames are not sequential, you may pass an array of frame numbers instead, for example:
     *
     * `this.anims.generateFrameNumbers('explosion', { frames: [ 0, 1, 2, 1, 2, 3, 4, 0, 1, 2 ] })`
     *
     * Please see the animation examples and `GenerateFrameNumbers` config docs for further details.
     *
     * @method Phaser.Animations.AnimationState#generateFrameNumbers
     * @since 3.50.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNumbers} [config] - The configuration object for the animation frames.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNumbers: function(key, config) {
                        return this.animationManager.generateFrameNumbers(key, config);
                    },
                    /**
     * Removes a locally created Animation from this Sprite, based on the given key.
     *
     * Once an Animation has been removed, this Sprite cannot play it again without re-creating it.
     *
     * @method Phaser.Animations.AnimationState#remove
     * @since 3.50.0
     *
     * @param {string} key - The key of the animation to remove.
     *
     * @return {Phaser.Animations.Animation} The Animation instance that was removed from this Sprite, if the key was valid.
     */ remove: function(key) {
                        var anim = this.get(key);
                        if (anim) {
                            if (this.currentAnim === anim) this.stop();
                            this.anims.delete(key);
                        }
                        return anim;
                    },
                    /**
     * Destroy this Animation component.
     *
     * Unregisters event listeners and cleans up its references.
     *
     * @method Phaser.Animations.AnimationState#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.animationManager.off(Events.REMOVE_ANIMATION, this.globalRemove, this);
                        if (this.anims) this.anims.clear();
                        this.animationManager = null;
                        this.parent = null;
                        this.nextAnim = null;
                        this.nextAnimsQueue.length = 0;
                        this.currentAnim = null;
                        this.currentFrame = null;
                    },
                    /**
     * `true` if the current animation is paused, otherwise `false`.
     *
     * @name Phaser.Animations.AnimationState#isPaused
     * @readonly
     * @type {boolean}
     * @since 3.4.0
     */ isPaused: {
                        get: function() {
                            return this._paused;
                        }
                    }
                });
                module1.exports = AnimationState;
            /***/ },
            /***/ 57090: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Add Animation Event.
 *
 * This event is dispatched when a new animation is added to the global Animation Manager.
 *
 * This can happen either as a result of an animation instance being added to the Animation Manager,
 * or the Animation Manager creating a new animation directly.
 *
 * @event Phaser.Animations.Events#ADD_ANIMATION
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the Animation that was added to the global Animation Manager.
 * @param {Phaser.Animations.Animation} animation - An instance of the newly created Animation.
 */ module1.exports = 'add';
            /***/ },
            /***/ 25312: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Complete Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it completes playback.
 * This happens when the animation gets to the end of its sequence, factoring in any delays
 * or repeats it may have to process.
 *
 * An animation that is set to loop, or repeat forever, will never fire this event, because
 * it never actually completes. If you need to handle this, listen for the `ANIMATION_STOP`
 * event instead, as this is emitted when the animation is stopped directly.
 *
 * Listen for it on the Sprite using `sprite.on('animationcomplete', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_COMPLETE
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that completed.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationcomplete';
            /***/ },
            /***/ 89580: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Complete Dynamic Key Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it completes playback.
 * This happens when the animation gets to the end of its sequence, factoring in any delays
 * or repeats it may have to process.
 *
 * An animation that is set to loop, or repeat forever, will never fire this event, because
 * it never actually completes. If you need to handle this, listen for the `ANIMATION_STOP`
 * event instead, as this is emitted when the animation is stopped directly.
 *
 * The difference between this and the `ANIMATION_COMPLETE` event is that this one has a
 * dynamic event name that contains the name of the animation within it. For example,
 * if you had an animation called `explode` you could listen for the completion of that
 * specific animation by using: `sprite.on('animationcomplete-explode', listener)`. Or, if you
 * wish to use types: `sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'explode', listener)`.
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_COMPLETE_KEY
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that completed.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationcomplete-';
            /***/ },
            /***/ 52860: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Repeat Event.
 *
 * This event is dispatched by a Sprite when an animation repeats playing on it.
 * This happens if the animation was created, or played, with a `repeat` value specified.
 *
 * An animation will repeat when it reaches the end of its sequence.
 *
 * Listen for it on the Sprite using `sprite.on('animationrepeat', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_REPEAT
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has repeated.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation repeated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationrepeat';
            /***/ },
            /***/ 63850: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Restart Event.
 *
 * This event is dispatched by a Sprite when an animation restarts playing on it.
 * This only happens when the `Sprite.anims.restart` method is called.
 *
 * Listen for it on the Sprite using `sprite.on('animationrestart', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_RESTART
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has restarted.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation restarted.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationrestart';
            /***/ },
            /***/ 99085: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Start Event.
 *
 * This event is dispatched by a Sprite when an animation starts playing on it.
 * This happens when the animation is played, factoring in any delay that may have been specified.
 * This event happens after the delay has expired and prior to the first update event.
 *
 * Listen for it on the Sprite using `sprite.on('animationstart', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_START
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has started.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation started.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationstart';
            /***/ },
            /***/ 28087: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Stop Event.
 *
 * This event is dispatched by a Sprite when an animation is stopped on it. An animation
 * will only be stopeed if a method such as `Sprite.stop` or `Sprite.anims.stopAfterDelay`
 * is called. It can also be emitted if a new animation is started before the current one completes.
 *
 * Listen for it on the Sprite using `sprite.on('animationstop', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_STOP
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has stopped.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation stopped.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationstop';
            /***/ },
            /***/ 1794: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Update Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it updates. This happens when the animation changes frame.
 * An animation will change frame based on the frame rate and other factors like `timeScale` and `delay`. It can also change
 * frame when stopped or restarted.
 *
 * Listen for it on the Sprite using `sprite.on('animationupdate', listener)`
 *
 * If an animation is playing faster than the game frame-rate can handle, it's entirely possible for it to emit several
 * update events in a single game frame, so please be aware of this in your code. The **final** event received that frame
 * is the one that is rendered to the game.
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_UPDATE
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has updated.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationupdate';
            /***/ },
            /***/ 52562: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pause All Animations Event.
 *
 * This event is dispatched when the global Animation Manager is told to pause.
 *
 * When this happens all current animations will stop updating, although it doesn't necessarily mean
 * that the game has paused as well.
 *
 * @event Phaser.Animations.Events#PAUSE_ALL
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'pauseall';
            /***/ },
            /***/ 57953: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Remove Animation Event.
 *
 * This event is dispatched when an animation is removed from the global Animation Manager.
 *
 * @event Phaser.Animations.Events#REMOVE_ANIMATION
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the Animation that was removed from the global Animation Manager.
 * @param {Phaser.Animations.Animation} animation - An instance of the removed Animation.
 */ module1.exports = 'remove';
            /***/ },
            /***/ 68339: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Resume All Animations Event.
 *
 * This event is dispatched when the global Animation Manager resumes, having been previously paused.
 *
 * When this happens all current animations will continue updating again.
 *
 * @event Phaser.Animations.Events#RESUME_ALL
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'resumeall';
            /***/ },
            /***/ 74943: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Animations.Events
 */ module1.exports = {
                    ADD_ANIMATION: __webpack_require__(57090),
                    ANIMATION_COMPLETE: __webpack_require__(25312),
                    ANIMATION_COMPLETE_KEY: __webpack_require__(89580),
                    ANIMATION_REPEAT: __webpack_require__(52860),
                    ANIMATION_RESTART: __webpack_require__(63850),
                    ANIMATION_START: __webpack_require__(99085),
                    ANIMATION_STOP: __webpack_require__(28087),
                    ANIMATION_UPDATE: __webpack_require__(1794),
                    PAUSE_ALL: __webpack_require__(52562),
                    REMOVE_ANIMATION: __webpack_require__(57953),
                    RESUME_ALL: __webpack_require__(68339)
                };
            /***/ },
            /***/ 60421: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Animations
 */ module1.exports = {
                    Animation: __webpack_require__(42099),
                    AnimationFrame: __webpack_require__(41138),
                    AnimationManager: __webpack_require__(60848),
                    AnimationState: __webpack_require__(9674),
                    Events: __webpack_require__(74943)
                };
            /***/ },
            /***/ 2161: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CustomMap = __webpack_require__(90330);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(24736);
                /**
 * @classdesc
 * The BaseCache is a base Cache class that can be used for storing references to any kind of data.
 *
 * Data can be added, retrieved and removed based on the given keys.
 *
 * Keys are string-based.
 *
 * @class BaseCache
 * @memberof Phaser.Cache
 * @constructor
 * @since 3.0.0
 */ var BaseCache = new Class({
                    initialize: function BaseCache() {
                        /**
         * The Map in which the cache objects are stored.
         *
         * You can query the Map directly or use the BaseCache methods.
         *
         * @name Phaser.Cache.BaseCache#entries
         * @type {Phaser.Structs.Map.<String, *>}
         * @since 3.0.0
         */ this.entries = new CustomMap();
                        /**
         * An instance of EventEmitter used by the cache to emit related events.
         *
         * @name Phaser.Cache.BaseCache#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                    },
                    /**
     * Adds an item to this cache. The item is referenced by a unique string, which you are responsible
     * for setting and keeping track of. The item can only be retrieved by using this string.
     *
     * @method Phaser.Cache.BaseCache#add
     * @fires Phaser.Cache.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique key by which the data added to the cache will be referenced.
     * @param {*} data - The data to be stored in the cache.
     *
     * @return {this} This BaseCache object.
     */ add: function(key, data) {
                        this.entries.set(key, data);
                        this.events.emit(Events.ADD, this, key, data);
                        return this;
                    },
                    /**
     * Checks if this cache contains an item matching the given key.
     * This performs the same action as `BaseCache.exists`.
     *
     * @method Phaser.Cache.BaseCache#has
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to be checked in this cache.
     *
     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
     */ has: function(key) {
                        return this.entries.has(key);
                    },
                    /**
     * Checks if this cache contains an item matching the given key.
     * This performs the same action as `BaseCache.has` and is called directly by the Loader.
     *
     * @method Phaser.Cache.BaseCache#exists
     * @since 3.7.0
     *
     * @param {string} key - The unique key of the item to be checked in this cache.
     *
     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
     */ exists: function(key) {
                        return this.entries.has(key);
                    },
                    /**
     * Gets an item from this cache based on the given key.
     *
     * @method Phaser.Cache.BaseCache#get
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to be retrieved from this cache.
     *
     * @return {*} The item in the cache, or `null` if no item matching the given key was found.
     */ get: function(key) {
                        return this.entries.get(key);
                    },
                    /**
     * Removes and item from this cache based on the given key.
     *
     * If an entry matching the key is found it is removed from the cache and a `remove` event emitted.
     * No additional checks are done on the item removed. If other systems or parts of your game code
     * are relying on this item, it is up to you to sever those relationships prior to removing the item.
     *
     * @method Phaser.Cache.BaseCache#remove
     * @fires Phaser.Cache.Events#REMOVE
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to remove from the cache.
     *
     * @return {this} This BaseCache object.
     */ remove: function(key) {
                        var entry = this.get(key);
                        if (entry) {
                            this.entries.delete(key);
                            this.events.emit(Events.REMOVE, this, key, entry.data);
                        }
                        return this;
                    },
                    /**
     * Returns all keys in use in this cache.
     *
     * @method Phaser.Cache.BaseCache#getKeys
     * @since 3.17.0
     *
     * @return {string[]} Array containing all the keys.
     */ getKeys: function() {
                        return this.entries.keys();
                    },
                    /**
     * Destroys this cache and all items within it.
     *
     * @method Phaser.Cache.BaseCache#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.entries.clear();
                        this.events.removeAllListeners();
                        this.entries = null;
                        this.events = null;
                    }
                });
                module1.exports = BaseCache;
            /***/ },
            /***/ 24047: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCache = __webpack_require__(2161);
                var Class = __webpack_require__(83419);
                var GameEvents = __webpack_require__(8443);
                /**
 * @classdesc
 * The Cache Manager is the global cache owned and maintained by the Game instance.
 *
 * Various systems, such as the file Loader, rely on this cache in order to store the files
 * it has loaded. The manager itself doesn't store any files, but instead owns multiple BaseCache
 * instances, one per type of file. You can also add your own custom caches.
 *
 * @class CacheManager
 * @memberof Phaser.Cache
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this CacheManager.
 */ var CacheManager = new Class({
                    initialize: function CacheManager(game) {
                        /**
         * A reference to the Phaser.Game instance that owns this CacheManager.
         *
         * @name Phaser.Cache.CacheManager#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.0.0
         */ this.game = game;
                        /**
         * A Cache storing all binary files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#binary
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.binary = new BaseCache();
                        /**
         * A Cache storing all bitmap font data files, typically added via the Loader.
         * Only the font data is stored in this cache, the textures are part of the Texture Manager.
         *
         * @name Phaser.Cache.CacheManager#bitmapFont
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.bitmapFont = new BaseCache();
                        /**
         * A Cache storing all JSON data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#json
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.json = new BaseCache();
                        /**
         * A Cache storing all physics data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#physics
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.physics = new BaseCache();
                        /**
         * A Cache storing all shader source files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#shader
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.shader = new BaseCache();
                        /**
         * A Cache storing all non-streaming audio files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#audio
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.audio = new BaseCache();
                        /**
         * A Cache storing all non-streaming video files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#video
         * @type {Phaser.Cache.BaseCache}
         * @since 3.20.0
         */ this.video = new BaseCache();
                        /**
         * A Cache storing all text files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#text
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.text = new BaseCache();
                        /**
         * A Cache storing all html files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#html
         * @type {Phaser.Cache.BaseCache}
         * @since 3.12.0
         */ this.html = new BaseCache();
                        /**
         * A Cache storing all WaveFront OBJ files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#obj
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.obj = new BaseCache();
                        /**
         * A Cache storing all tilemap data files, typically added via the Loader.
         * Only the data is stored in this cache, the textures are part of the Texture Manager.
         *
         * @name Phaser.Cache.CacheManager#tilemap
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.tilemap = new BaseCache();
                        /**
         * A Cache storing all xml data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#xml
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.xml = new BaseCache();
                        /**
         * An object that contains your own custom BaseCache entries.
         * Add to this via the `addCustom` method.
         *
         * @name Phaser.Cache.CacheManager#custom
         * @type {Object.<Phaser.Cache.BaseCache>}
         * @since 3.0.0
         */ this.custom = {};
                        this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * Add your own custom Cache for storing your own files.
     * The cache will be available under `Cache.custom.key`.
     * The cache will only be created if the key is not already in use.
     *
     * @method Phaser.Cache.CacheManager#addCustom
     * @since 3.0.0
     *
     * @param {string} key - The unique key of your custom cache.
     *
     * @return {Phaser.Cache.BaseCache} A reference to the BaseCache that was created. If the key was already in use, a reference to the existing cache is returned instead.
     */ addCustom: function(key) {
                        if (!this.custom.hasOwnProperty(key)) this.custom[key] = new BaseCache();
                        return this.custom[key];
                    },
                    /**
     * Removes all entries from all BaseCaches and destroys all custom caches.
     *
     * @method Phaser.Cache.CacheManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        var keys = [
                            'binary',
                            'bitmapFont',
                            'json',
                            'physics',
                            'shader',
                            'audio',
                            'video',
                            'text',
                            'html',
                            'obj',
                            'tilemap',
                            'xml'
                        ];
                        for(var i = 0; i < keys.length; i++){
                            this[keys[i]].destroy();
                            this[keys[i]] = null;
                        }
                        for(var key in this.custom)this.custom[key].destroy();
                        this.custom = null;
                        this.game = null;
                    }
                });
                module1.exports = CacheManager;
            /***/ },
            /***/ 51464: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Cache Add Event.
 *
 * This event is dispatched by any Cache that extends the BaseCache each time a new object is added to it.
 *
 * @event Phaser.Cache.Events#ADD
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Cache.BaseCache} cache - The cache to which the object was added.
 * @param {string} key - The key of the object added to the cache.
 * @param {*} object - A reference to the object that was added to the cache.
 */ module1.exports = 'add';
            /***/ },
            /***/ 59261: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Cache Remove Event.
 *
 * This event is dispatched by any Cache that extends the BaseCache each time an object is removed from it.
 *
 * @event Phaser.Cache.Events#REMOVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Cache.BaseCache} cache - The cache from which the object was removed.
 * @param {string} key - The key of the object removed from the cache.
 * @param {*} object - A reference to the object that was removed from the cache.
 */ module1.exports = 'remove';
            /***/ },
            /***/ 24736: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cache.Events
 */ module1.exports = {
                    ADD: __webpack_require__(51464),
                    REMOVE: __webpack_require__(59261)
                };
            /***/ },
            /***/ 83388: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cache
 */ module1.exports = {
                    BaseCache: __webpack_require__(2161),
                    CacheManager: __webpack_require__(24047),
                    Events: __webpack_require__(24736)
                };
            /***/ },
            /***/ 71911: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var DegToRad = __webpack_require__(39506);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(19715);
                var Rectangle = __webpack_require__(87841);
                var TransformMatrix = __webpack_require__(61340);
                var ValueToColor = __webpack_require__(80333);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Base Camera class.
 *
 * The Camera is the way in which all games are rendered in Phaser. They provide a view into your game world,
 * and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis.
 *
 * The Base Camera is extended by the Camera class, which adds in special effects including Fade,
 * Flash and Camera Shake, as well as the ability to follow Game Objects.
 *
 * The Base Camera was introduced in Phaser 3.12. It was split off from the Camera class, to allow
 * you to isolate special effects as needed. Therefore the 'since' values for properties of this class relate
 * to when they were added to the Camera class.
 *
 * @class BaseCamera
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.12.0
 *
 * @extends Phaser.Events.EventEmitter
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {number} x - The x position of the Camera, relative to the top-left of the game canvas.
 * @param {number} y - The y position of the Camera, relative to the top-left of the game canvas.
 * @param {number} width - The width of the Camera, in pixels.
 * @param {number} height - The height of the Camera, in pixels.
 */ var BaseCamera = new Class({
                    Extends: EventEmitter,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.Visible
                    ],
                    initialize: function BaseCamera(x, y, width, height) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 0;
                        if (height === undefined) height = 0;
                        EventEmitter.call(this);
                        /**
         * A reference to the Scene this camera belongs to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene;
                        /**
         * A reference to the Game Scene Manager.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#sceneManager
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.12.0
         */ this.sceneManager;
                        /**
         * A reference to the Game Scale Manager.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#scaleManager
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scaleManager;
                        /**
         * A reference to the Scene's Camera Manager to which this Camera belongs.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#cameraManager
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.17.0
         */ this.cameraManager;
                        /**
         * The Camera ID. Assigned by the Camera Manager and used to handle camera exclusion.
         * This value is a bitmask.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#id
         * @type {number}
         * @readonly
         * @since 3.11.0
         */ this.id = 0;
                        /**
         * The name of the Camera. This is left empty for your own use.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = '';
                        /**
         * Should this camera round its pixel values to integers?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#roundPixels
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.roundPixels = false;
                        /**
         * Is this Camera visible or not?
         *
         * A visible camera will render and perform input tests.
         * An invisible camera will not render anything and will skip input tests.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#visible
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ /**
         * Is this Camera using a bounds to restrict scrolling movement?
         *
         * Set this property along with the bounds via `Camera.setBounds`.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#useBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.useBounds = false;
                        /**
         * The World View is a Rectangle that defines the area of the 'world' the Camera is currently looking at.
         * This factors in the Camera viewport size, zoom and scroll position and is updated in the Camera preRender step.
         * If you have enabled Camera bounds the worldview will be clamped to those bounds accordingly.
         * You can use it for culling or intersection checks.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#worldView
         * @type {Phaser.Geom.Rectangle}
         * @readonly
         * @since 3.11.0
         */ this.worldView = new Rectangle();
                        /**
         * Is this Camera dirty?
         *
         * A dirty Camera has had either its viewport size, bounds, scroll, rotation or zoom levels changed since the last frame.
         *
         * This flag is cleared during the `postRenderCamera` method of the renderer.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#dirty
         * @type {boolean}
         * @default true
         * @since 3.11.0
         */ this.dirty = true;
                        /**
         * The x position of the Camera viewport, relative to the top-left of the game canvas.
         * The viewport is the area into which the camera renders.
         * To adjust the position the camera is looking at in the game world, see the `scrollX` value.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_x
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._x = x;
                        /**
         * The y position of the Camera, relative to the top-left of the game canvas.
         * The viewport is the area into which the camera renders.
         * To adjust the position the camera is looking at in the game world, see the `scrollY` value.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_y
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._y = y;
                        /**
         * The width of the Camera viewport, in pixels.
         *
         * The viewport is the area into which the Camera renders. Setting the viewport does
         * not restrict where the Camera can scroll to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_width
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._width = width;
                        /**
         * The height of the Camera viewport, in pixels.
         *
         * The viewport is the area into which the Camera renders. Setting the viewport does
         * not restrict where the Camera can scroll to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_height
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._height = height;
                        /**
         * The bounds the camera is restrained to during scrolling.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_bounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.0.0
         */ this._bounds = new Rectangle();
                        /**
         * The horizontal scroll position of this Camera.
         *
         * Change this value to cause the Camera to scroll around your Scene.
         *
         * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
         * will automatically adjust the Camera scroll values accordingly.
         *
         * You can set the bounds within which the Camera can scroll via the `setBounds` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_scrollX
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._scrollX = 0;
                        /**
         * The vertical scroll position of this Camera.
         *
         * Change this value to cause the Camera to scroll around your Scene.
         *
         * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
         * will automatically adjust the Camera scroll values accordingly.
         *
         * You can set the bounds within which the Camera can scroll via the `setBounds` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_scrollY
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._scrollY = 0;
                        /**
         * The Camera horizontal zoom value. Change this value to zoom in, or out of, a Scene.
         *
         * A value of 0.5 would zoom the Camera out, so you can now see twice as much
         * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
         * now takes up 2 pixels when rendered.
         *
         * Set to 1 to return to the default zoom level.
         *
         * Be careful to never set this value to zero.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_zoomX
         * @type {number}
         * @private
         * @default 1
         * @since 3.50.0
         */ this._zoomX = 1;
                        /**
         * The Camera vertical zoom value. Change this value to zoom in, or out of, a Scene.
         *
         * A value of 0.5 would zoom the Camera out, so you can now see twice as much
         * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
         * now takes up 2 pixels when rendered.
         *
         * Set to 1 to return to the default zoom level.
         *
         * Be careful to never set this value to zero.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_zoomY
         * @type {number}
         * @private
         * @default 1
         * @since 3.50.0
         */ this._zoomY = 1;
                        /**
         * The rotation of the Camera in radians.
         *
         * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
         * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
         *
         * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
         * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_rotation
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._rotation = 0;
                        /**
         * A local transform matrix used for internal calculations.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#matrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.0.0
         */ this.matrix = new TransformMatrix();
                        /**
         * Does this Camera have a transparent background?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#transparent
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.transparent = true;
                        /**
         * The background color of this Camera. Only used if `transparent` is `false`.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#backgroundColor
         * @type {Phaser.Display.Color}
         * @since 3.0.0
         */ this.backgroundColor = ValueToColor('rgba(0,0,0,0)');
                        /**
         * The Camera alpha value. Setting this property impacts every single object that this Camera
         * renders. You can either set the property directly, i.e. via a Tween, to fade a Camera in or out,
         * or via the chainable `setAlpha` method instead.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#alpha
         * @type {number}
         * @default 1
         * @since 3.11.0
         */ /**
         * Should the camera cull Game Objects before checking them for input hit tests?
         * In some special cases it may be beneficial to disable this.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#disableCull
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.disableCull = false;
                        /**
         * A temporary array of culled objects.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#culledObjects
         * @type {Phaser.GameObjects.GameObject[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.culledObjects = [];
                        /**
         * The mid-point of the Camera in 'world' coordinates.
         *
         * Use it to obtain exactly where in the world the center of the camera is currently looking.
         *
         * This value is updated in the preRender method, after the scroll values and follower
         * have been processed.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#midPoint
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.11.0
         */ this.midPoint = new Vector2(width / 2, height / 2);
                        /**
         * The horizontal origin of rotation for this Camera.
         *
         * By default the camera rotates around the center of the viewport.
         *
         * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
         * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
         *
         * See `setOrigin` to set both origins in a single, chainable call.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#originX
         * @type {number}
         * @default 0.5
         * @since 3.11.0
         */ this.originX = 0.5;
                        /**
         * The vertical origin of rotation for this Camera.
         *
         * By default the camera rotates around the center of the viewport.
         *
         * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
         * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
         *
         * See `setOrigin` to set both origins in a single, chainable call.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#originY
         * @type {number}
         * @default 0.5
         * @since 3.11.0
         */ this.originY = 0.5;
                        /**
         * Does this Camera have a custom viewport?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_customViewport
         * @type {boolean}
         * @private
         * @default false
         * @since 3.12.0
         */ this._customViewport = false;
                        /**
         * The Mask this Camera is using during render.
         * Set the mask using the `setMask` method. Remove the mask using the `clearMask` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#mask
         * @type {?(Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask)}
         * @since 3.17.0
         */ this.mask = null;
                        /**
         * The Camera that this Camera uses for translation during masking.
         *
         * If the mask is fixed in position this will be a reference to
         * the CameraManager.default instance. Otherwise, it'll be a reference
         * to itself.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_maskCamera
         * @type {?Phaser.Cameras.Scene2D.BaseCamera}
         * @private
         * @since 3.17.0
         */ this._maskCamera = null;
                        /**
         * This array is populated with all of the Game Objects that this Camera has rendered
         * in the previous (or current, depending on when you inspect it) frame.
         *
         * It is cleared at the start of `Camera.preUpdate`, or if the Camera is destroyed.
         *
         * You should not modify this array as it is used internally by the input system,
         * however you can read it as required. Note that Game Objects may appear in this
         * list multiple times if they belong to multiple non-exclusive Containers.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#renderList
         * @type {Phaser.GameObjects.GameObject[]}
         * @since 3.52.0
         */ this.renderList = [];
                        /**
         * Is this Camera a Scene Camera? (which is the default), or a Camera
         * belonging to a Texture?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#isSceneCamera
         * @type {boolean}
         * @default true
         * @since 3.60.0
         */ this.isSceneCamera = true;
                        /**
         * Can this Camera render rounded pixel values?
         * 
         * This property is updated during the `preRender` method and should not be
         * set directly. It is set based on the `roundPixels` property of the Camera
         * combined with the zoom level. If the zoom is an integer then the WebGL
         * Renderer can apply rounding during rendering.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#renderRoundPixels
         * @type {boolean}
         * @readonly
         * @default true
         * @since 3.86.0
         */ this.renderRoundPixels = true;
                    },
                    /**
     * Adds the given Game Object to this cameras render list.
     *
     * This is invoked during the rendering stage. Only objects that are actually rendered
     * will appear in the render list.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#addToRenderList
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add to the render list.
     */ addToRenderList: function(child) {
                        this.renderList.push(child);
                    },
                    /**
     * Set the Alpha level of this Camera. The alpha controls the opacity of the Camera as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setAlpha
     * @since 3.11.0
     *
     * @param {number} [value=1] - The Camera alpha value.
     *
     * @return {this} This Camera instance.
     */ /**
     * Sets the rotation origin of this Camera.
     *
     * The values are given in the range 0 to 1 and are only used when calculating Camera rotation.
     *
     * By default the camera rotates around the center of the viewport.
     *
     * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
     * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setOrigin
     * @since 3.11.0
     *
     * @param {number} [x=0.5] - The horizontal origin value.
     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Camera instance.
     */ setOrigin: function(x, y) {
                        if (x === undefined) x = 0.5;
                        if (y === undefined) y = x;
                        this.originX = x;
                        this.originY = y;
                        return this;
                    },
                    /**
     * Calculates what the Camera.scrollX and scrollY values would need to be in order to move
     * the Camera so it is centered on the given x and y coordinates, without actually moving
     * the Camera there. The results are clamped based on the Camera bounds, if set.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getScroll
     * @since 3.11.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     * @param {number} y - The vertical coordinate to center on.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 to store the values in. If not given a new Vector2 is created.
     *
     * @return {Phaser.Math.Vector2} The scroll coordinates stored in the `x` and `y` properties.
     */ getScroll: function(x, y, out) {
                        if (out === undefined) out = new Vector2();
                        var originX = this.width * 0.5;
                        var originY = this.height * 0.5;
                        out.x = x - originX;
                        out.y = y - originY;
                        if (this.useBounds) {
                            out.x = this.clampX(out.x);
                            out.y = this.clampY(out.y);
                        }
                        return out;
                    },
                    /**
     * Moves the Camera horizontally so that it is centered on the given x coordinate, bounds allowing.
     * Calling this does not change the scrollY value.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOnX
     * @since 3.16.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOnX: function(x) {
                        var originX = this.width * 0.5;
                        this.midPoint.x = x;
                        this.scrollX = x - originX;
                        if (this.useBounds) this.scrollX = this.clampX(this.scrollX);
                        return this;
                    },
                    /**
     * Moves the Camera vertically so that it is centered on the given y coordinate, bounds allowing.
     * Calling this does not change the scrollX value.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOnY
     * @since 3.16.0
     *
     * @param {number} y - The vertical coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOnY: function(y) {
                        var originY = this.height * 0.5;
                        this.midPoint.y = y;
                        this.scrollY = y - originY;
                        if (this.useBounds) this.scrollY = this.clampY(this.scrollY);
                        return this;
                    },
                    /**
     * Moves the Camera so that it is centered on the given coordinates, bounds allowing.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOn
     * @since 3.11.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     * @param {number} y - The vertical coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOn: function(x, y) {
                        this.centerOnX(x);
                        this.centerOnY(y);
                        return this;
                    },
                    /**
     * Moves the Camera so that it is looking at the center of the Camera Bounds, if enabled.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerToBounds
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ centerToBounds: function() {
                        if (this.useBounds) {
                            var bounds = this._bounds;
                            var originX = this.width * 0.5;
                            var originY = this.height * 0.5;
                            this.midPoint.set(bounds.centerX, bounds.centerY);
                            this.scrollX = bounds.centerX - originX;
                            this.scrollY = bounds.centerY - originY;
                        }
                        return this;
                    },
                    /**
     * Moves the Camera so that it is re-centered based on its viewport size.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerToSize
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ centerToSize: function() {
                        this.scrollX = this.width * 0.5;
                        this.scrollY = this.height * 0.5;
                        return this;
                    },
                    /**
     * Takes an array of Game Objects and returns a new array featuring only those objects
     * visible by this camera.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#cull
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject[]} G - [renderableObjects,$return]
     *
     * @param {Phaser.GameObjects.GameObject[]} renderableObjects - An array of Game Objects to cull.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of Game Objects visible to this Camera.
     */ cull: function(renderableObjects) {
                        if (this.disableCull) return renderableObjects;
                        var cameraMatrix = this.matrix.matrix;
                        var mva = cameraMatrix[0];
                        var mvb = cameraMatrix[1];
                        var mvc = cameraMatrix[2];
                        var mvd = cameraMatrix[3];
                        /* First Invert Matrix */ var determinant = mva * mvd - mvb * mvc;
                        if (!determinant) return renderableObjects;
                        var mve = cameraMatrix[4];
                        var mvf = cameraMatrix[5];
                        var scrollX = this.scrollX;
                        var scrollY = this.scrollY;
                        var cameraW = this.width;
                        var cameraH = this.height;
                        var cullTop = this.y;
                        var cullBottom = cullTop + cameraH;
                        var cullLeft = this.x;
                        var cullRight = cullLeft + cameraW;
                        var culledObjects = this.culledObjects;
                        var length = renderableObjects.length;
                        determinant = 1 / determinant;
                        culledObjects.length = 0;
                        for(var index = 0; index < length; ++index){
                            var object = renderableObjects[index];
                            if (!object.hasOwnProperty('width') || object.parentContainer) {
                                culledObjects.push(object);
                                continue;
                            }
                            var objectW = object.width;
                            var objectH = object.height;
                            var objectX = object.x - scrollX * object.scrollFactorX - objectW * object.originX;
                            var objectY = object.y - scrollY * object.scrollFactorY - objectH * object.originY;
                            var tx = objectX * mva + objectY * mvc + mve;
                            var ty = objectX * mvb + objectY * mvd + mvf;
                            var tw = (objectX + objectW) * mva + (objectY + objectH) * mvc + mve;
                            var th = (objectX + objectW) * mvb + (objectY + objectH) * mvd + mvf;
                            if (tw > cullLeft && tx < cullRight && th > cullTop && ty < cullBottom) culledObjects.push(object);
                        }
                        return culledObjects;
                    },
                    /**
     * Converts the given `x` and `y` coordinates into World space, based on this Cameras transform.
     * You can optionally provide a Vector2, or similar object, to store the results in.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getWorldPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {number} x - The x position to convert to world space.
     * @param {number} y - The y position to convert to world space.
     * @param {(object|Phaser.Math.Vector2)} [output] - An optional object to store the results in. If not provided a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} An object holding the converted values in its `x` and `y` properties.
     */ getWorldPoint: function(x, y, output) {
                        if (output === undefined) output = new Vector2();
                        var cameraMatrix = this.matrix.matrix;
                        var mva = cameraMatrix[0];
                        var mvb = cameraMatrix[1];
                        var mvc = cameraMatrix[2];
                        var mvd = cameraMatrix[3];
                        var mve = cameraMatrix[4];
                        var mvf = cameraMatrix[5];
                        //  Invert Matrix
                        var determinant = mva * mvd - mvb * mvc;
                        if (!determinant) {
                            output.x = x;
                            output.y = y;
                            return output;
                        }
                        determinant = 1 / determinant;
                        var ima = mvd * determinant;
                        var imb = -mvb * determinant;
                        var imc = -mvc * determinant;
                        var imd = mva * determinant;
                        var ime = (mvc * mvf - mvd * mve) * determinant;
                        var imf = (mvb * mve - mva * mvf) * determinant;
                        var c = Math.cos(this.rotation);
                        var s = Math.sin(this.rotation);
                        var zoomX = this.zoomX;
                        var zoomY = this.zoomY;
                        var scrollX = this.scrollX;
                        var scrollY = this.scrollY;
                        var sx = x + (scrollX * c - scrollY * s) * zoomX;
                        var sy = y + (scrollX * s + scrollY * c) * zoomY;
                        //  Apply transform to point
                        output.x = sx * ima + sy * imc + ime;
                        output.y = sx * imb + sy * imd + imf;
                        return output;
                    },
                    /**
     * Given a Game Object, or an array of Game Objects, it will update all of their camera filter settings
     * so that they are ignored by this Camera. This means they will not be rendered by this Camera.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#ignore
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Layer|Phaser.GameObjects.Layer[])} entries - The Game Object, or array of Game Objects, to be ignored by this Camera.
     *
     * @return {this} This Camera instance.
     */ ignore: function(entries) {
                        var id = this.id;
                        if (!Array.isArray(entries)) entries = [
                            entries
                        ];
                        for(var i = 0; i < entries.length; i++){
                            var entry = entries[i];
                            if (Array.isArray(entry)) this.ignore(entry);
                            else if (entry.isParent) this.ignore(entry.getChildren());
                            else entry.cameraFilter |= id;
                        }
                        return this;
                    },
                    /**
     * Takes an x value and checks it's within the range of the Camera bounds, adjusting if required.
     * Do not call this method if you are not using camera bounds.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clampX
     * @since 3.11.0
     *
     * @param {number} x - The value to horizontally scroll clamp.
     *
     * @return {number} The adjusted value to use as scrollX.
     */ clampX: function(x) {
                        var bounds = this._bounds;
                        var dw = this.displayWidth;
                        var bx = bounds.x + (dw - this.width) / 2;
                        var bw = Math.max(bx, bx + bounds.width - dw);
                        if (x < bx) x = bx;
                        else if (x > bw) x = bw;
                        return x;
                    },
                    /**
     * Takes a y value and checks it's within the range of the Camera bounds, adjusting if required.
     * Do not call this method if you are not using camera bounds.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clampY
     * @since 3.11.0
     *
     * @param {number} y - The value to vertically scroll clamp.
     *
     * @return {number} The adjusted value to use as scrollY.
     */ clampY: function(y) {
                        var bounds = this._bounds;
                        var dh = this.displayHeight;
                        var by = bounds.y + (dh - this.height) / 2;
                        var bh = Math.max(by, by + bounds.height - dh);
                        if (y < by) y = by;
                        else if (y > bh) y = bh;
                        return y;
                    },
                    /*
        var gap = this._zoomInversed;
        return gap * Math.round((src.x - this.scrollX * src.scrollFactorX) / gap);
    */ /**
     * If this Camera has previously had movement bounds set on it, this will remove them.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#removeBounds
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ removeBounds: function() {
                        this.useBounds = false;
                        this.dirty = true;
                        this._bounds.setEmpty();
                        return this;
                    },
                    /**
     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
     *
     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setAngle
     * @since 3.0.0
     *
     * @param {number} [value=0] - The cameras angle of rotation, given in degrees.
     *
     * @return {this} This Camera instance.
     */ setAngle: function(value) {
                        if (value === undefined) value = 0;
                        this.rotation = DegToRad(value);
                        return this;
                    },
                    /**
     * Sets the background color for this Camera.
     *
     * By default a Camera has a transparent background but it can be given a solid color, with any level
     * of transparency, via this method.
     *
     * The color value can be specified using CSS color notation, hex or numbers.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setBackgroundColor
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Types.Display.InputColorObject)} [color='rgba(0,0,0,0)'] - The color value. In CSS, hex or numeric color notation.
     *
     * @return {this} This Camera instance.
     */ setBackgroundColor: function(color) {
                        if (color === undefined) color = 'rgba(0,0,0,0)';
                        this.backgroundColor = ValueToColor(color);
                        this.transparent = this.backgroundColor.alpha === 0;
                        return this;
                    },
                    /**
     * Set the bounds of the Camera. The bounds are an axis-aligned rectangle.
     *
     * The Camera bounds controls where the Camera can scroll to, stopping it from scrolling off the
     * edges and into blank space. It does not limit the placement of Game Objects, or where
     * the Camera viewport can be positioned.
     *
     * Temporarily disable the bounds by changing the boolean `Camera.useBounds`.
     *
     * Clear the bounds entirely by calling `Camera.removeBounds`.
     *
     * If you set bounds that are smaller than the viewport it will stop the Camera from being
     * able to scroll. The bounds can be positioned where-ever you wish. By default they are from
     * 0x0 to the canvas width x height. This means that the coordinate 0x0 is the top left of
     * the Camera bounds. However, you can position them anywhere. So if you wanted a game world
     * that was 2048x2048 in size, with 0x0 being the center of it, you can set the bounds x/y
     * to be -1024, -1024, with a width and height of 2048. Depending on your game you may find
     * it easier for 0x0 to be the top-left of the bounds, or you may wish 0x0 to be the middle.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setBounds
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the bounds.
     * @param {number} y - The top-left y coordinate of the bounds.
     * @param {number} width - The width of the bounds, in pixels.
     * @param {number} height - The height of the bounds, in pixels.
     * @param {boolean} [centerOn=false] - If `true` the Camera will automatically be centered on the new bounds.
     *
     * @return {this} This Camera instance.
     */ setBounds: function(x, y, width, height, centerOn) {
                        if (centerOn === undefined) centerOn = false;
                        this._bounds.setTo(x, y, width, height);
                        this.dirty = true;
                        this.useBounds = true;
                        if (centerOn) this.centerToBounds();
                        else {
                            this.scrollX = this.clampX(this.scrollX);
                            this.scrollY = this.clampY(this.scrollY);
                        }
                        return this;
                    },
                    /**
     * Returns a rectangle containing the bounds of the Camera.
     *
     * If the Camera does not have any bounds the rectangle will be empty.
     *
     * The rectangle is a copy of the bounds, so is safe to modify.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getBounds
     * @since 3.16.0
     *
     * @param {Phaser.Geom.Rectangle} [out] - An optional Rectangle to store the bounds in. If not given, a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} A rectangle containing the bounds of this Camera.
     */ getBounds: function(out) {
                        if (out === undefined) out = new Rectangle();
                        var source = this._bounds;
                        out.setTo(source.x, source.y, source.width, source.height);
                        return out;
                    },
                    /**
     * Sets the name of this Camera.
     * This value is for your own use and isn't used internally.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setName
     * @since 3.0.0
     *
     * @param {string} [value=''] - The name of the Camera.
     *
     * @return {this} This Camera instance.
     */ setName: function(value) {
                        if (value === undefined) value = '';
                        this.name = value;
                        return this;
                    },
                    /**
     * Set the position of the Camera viewport within the game.
     *
     * This does not change where the camera is 'looking'. See `setScroll` to control that.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the Camera viewport.
     * @param {number} [y=x] - The top-left y coordinate of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setPosition: function(x, y) {
                        if (y === undefined) y = x;
                        this.x = x;
                        this.y = y;
                        return this;
                    },
                    /**
     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
     *
     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setRotation
     * @since 3.0.0
     *
     * @param {number} [value=0] - The rotation of the Camera, in radians.
     *
     * @return {this} This Camera instance.
     */ setRotation: function(value) {
                        if (value === undefined) value = 0;
                        this.rotation = value;
                        return this;
                    },
                    /**
     * Should the Camera round pixel values to whole integers when rendering Game Objects?
     *
     * In some types of game, especially with pixel art, this is required to prevent sub-pixel aliasing.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setRoundPixels
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to round Camera pixels, `false` to not.
     *
     * @return {this} This Camera instance.
     */ setRoundPixels: function(value) {
                        this.roundPixels = value;
                        return this;
                    },
                    /**
     * Sets the Scene the Camera is bound to.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setScene
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene the camera is bound to.
     * @param {boolean} [isSceneCamera=true] - Is this Camera being used for a Scene (true) or a Texture? (false)
     *
     * @return {this} This Camera instance.
     */ setScene: function(scene, isSceneCamera) {
                        if (isSceneCamera === undefined) isSceneCamera = true;
                        if (this.scene && this._customViewport) this.sceneManager.customViewports--;
                        this.scene = scene;
                        this.isSceneCamera = isSceneCamera;
                        var sys = scene.sys;
                        this.sceneManager = sys.game.scene;
                        this.scaleManager = sys.scale;
                        this.cameraManager = sys.cameras;
                        this.updateSystem();
                        return this;
                    },
                    /**
     * Set the position of where the Camera is looking within the game.
     * You can also modify the properties `Camera.scrollX` and `Camera.scrollY` directly.
     * Use this method, or the scroll properties, to move your camera around the game world.
     *
     * This does not change where the camera viewport is placed. See `setPosition` to control that.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setScroll
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the Camera in the game world.
     * @param {number} [y=x] - The y coordinate of the Camera in the game world.
     *
     * @return {this} This Camera instance.
     */ setScroll: function(x, y) {
                        if (y === undefined) y = x;
                        this.scrollX = x;
                        this.scrollY = y;
                        return this;
                    },
                    /**
     * Set the size of the Camera viewport.
     *
     * By default a Camera is the same size as the game, but can be made smaller via this method,
     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
     * viewport within your game.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the Camera viewport.
     * @param {number} [height=width] - The height of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setSize: function(width, height) {
                        if (height === undefined) height = width;
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * This method sets the position and size of the Camera viewport in a single call.
     *
     * If you're trying to change where the Camera is looking at in your game, then see
     * the method `Camera.setScroll` instead. This method is for changing the viewport
     * itself, not what the camera can see.
     *
     * By default a Camera is the same size as the game, but can be made smaller via this method,
     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
     * viewport within your game.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setViewport
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the Camera viewport.
     * @param {number} y - The top-left y coordinate of the Camera viewport.
     * @param {number} width - The width of the Camera viewport.
     * @param {number} [height=width] - The height of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setViewport: function(x, y, width, height) {
                        this.x = x;
                        this.y = y;
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Set the zoom value of the Camera.
     *
     * Changing to a smaller value, such as 0.5, will cause the camera to 'zoom out'.
     * Changing to a larger value, such as 2, will cause the camera to 'zoom in'.
     *
     * A value of 1 means 'no zoom' and is the default.
     *
     * Changing the zoom does not impact the Camera viewport in any way, it is only applied during rendering.
     *
     * As of Phaser 3.50 you can now set the horizontal and vertical zoom values independently.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setZoom
     * @since 3.0.0
     *
     * @param {number} [x=1] - The horizontal zoom value of the Camera. The minimum it can be is 0.001.
     * @param {number} [y=x] - The vertical zoom value of the Camera. The minimum it can be is 0.001.
     *
     * @return {this} This Camera instance.
     */ setZoom: function(x, y) {
                        if (x === undefined) x = 1;
                        if (y === undefined) y = x;
                        if (x === 0) x = 0.001;
                        if (y === 0) y = 0.001;
                        this.zoomX = x;
                        this.zoomY = y;
                        return this;
                    },
                    /**
     * Sets the mask to be applied to this Camera during rendering.
     *
     * The mask must have been previously created and can be either a GeometryMask or a BitmapMask.
     *
     * Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * If a mask is already set on this Camera it will be immediately replaced.
     *
     * Masks have no impact on physics or input detection. They are purely a rendering component
     * that allows you to limit what is visible during the render pass.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setMask
     * @since 3.17.0
     *
     * @param {(Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask)} mask - The mask this Camera will use when rendering.
     * @param {boolean} [fixedPosition=true] - Should the mask translate along with the Camera, or be fixed in place and not impacted by the Cameras transform?
     *
     * @return {this} This Camera instance.
     */ setMask: function(mask, fixedPosition) {
                        if (fixedPosition === undefined) fixedPosition = true;
                        this.mask = mask;
                        this._maskCamera = fixedPosition ? this.cameraManager.default : this;
                        return this;
                    },
                    /**
     * Clears the mask that this Camera was using.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clearMask
     * @since 3.17.0
     *
     * @param {boolean} [destroyMask=false] - Destroy the mask before clearing it?
     *
     * @return {this} This Camera instance.
     */ clearMask: function(destroyMask) {
                        if (destroyMask === undefined) destroyMask = false;
                        if (destroyMask && this.mask) this.mask.destroy();
                        this.mask = null;
                        return this;
                    },
                    /**
     * Sets the visibility of this Camera.
     *
     * An invisible Camera will skip rendering and input tests of everything it can see.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setVisible
     * @since 3.10.0
     *
     * @param {boolean} value - The visible state of the Camera.
     *
     * @return {this} This Camera instance.
     */ /**
     * Returns an Object suitable for JSON storage containing all of the Camera viewport and rendering properties.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Cameras.Scene2D.JSONCamera} A well-formed object suitable for conversion to JSON.
     */ toJSON: function() {
                        var output = {
                            name: this.name,
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            zoom: this.zoom,
                            rotation: this.rotation,
                            roundPixels: this.roundPixels,
                            scrollX: this.scrollX,
                            scrollY: this.scrollY,
                            backgroundColor: this.backgroundColor.rgba
                        };
                        if (this.useBounds) output['bounds'] = {
                            x: this._bounds.x,
                            y: this._bounds.y,
                            width: this._bounds.width,
                            height: this._bounds.height
                        };
                        return output;
                    },
                    /**
     * Internal method called automatically by the Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function() {
                    //  NOOP
                    },
                    /**
     * Set if this Camera is being used as a Scene Camera, or a Texture
     * Camera.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setIsSceneCamera
     * @since 3.60.0
     *
     * @param {boolean} value - Is this being used as a Scene Camera, or a Texture camera?
     */ setIsSceneCamera: function(value) {
                        this.isSceneCamera = value;
                        return this;
                    },
                    /**
     * Internal method called automatically when the viewport changes.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#updateSystem
     * @private
     * @since 3.12.0
     */ updateSystem: function() {
                        if (!this.scaleManager || !this.isSceneCamera) return;
                        var custom = this._x !== 0 || this._y !== 0 || this.scaleManager.width !== this._width || this.scaleManager.height !== this._height;
                        var sceneManager = this.sceneManager;
                        if (custom && !this._customViewport) //  We need a custom viewport for this Camera
                        sceneManager.customViewports++;
                        else if (!custom && this._customViewport) //  We're turning off a custom viewport for this Camera
                        sceneManager.customViewports--;
                        this.dirty = true;
                        this._customViewport = custom;
                    },
                    /**
     * Destroys this Camera instance and its internal properties and references.
     * Once destroyed you cannot use this Camera again, even if re-added to a Camera Manager.
     *
     * This method is called automatically by `CameraManager.remove` if that methods `runDestroy` argument is `true`, which is the default.
     *
     * Unless you have a specific reason otherwise, always use `CameraManager.remove` and allow it to handle the camera destruction,
     * rather than calling this method directly.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#destroy
     * @fires Phaser.Cameras.Scene2D.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                        this.emit(Events.DESTROY, this);
                        this.removeAllListeners();
                        this.matrix.destroy();
                        this.culledObjects = [];
                        if (this._customViewport) //  We're turning off a custom viewport for this Camera
                        this.sceneManager.customViewports--;
                        this.renderList = [];
                        this._bounds = null;
                        this.scene = null;
                        this.scaleManager = null;
                        this.sceneManager = null;
                        this.cameraManager = null;
                    },
                    /**
     * The x position of the Camera viewport, relative to the top-left of the game canvas.
     * The viewport is the area into which the camera renders.
     * To adjust the position the camera is looking at in the game world, see the `scrollX` value.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this._x;
                        },
                        set: function(value) {
                            this._x = value;
                            this.updateSystem();
                        }
                    },
                    /**
     * The y position of the Camera viewport, relative to the top-left of the game canvas.
     * The viewport is the area into which the camera renders.
     * To adjust the position the camera is looking at in the game world, see the `scrollY` value.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this._y;
                        },
                        set: function(value) {
                            this._y = value;
                            this.updateSystem();
                        }
                    },
                    /**
     * The width of the Camera viewport, in pixels.
     *
     * The viewport is the area into which the Camera renders. Setting the viewport does
     * not restrict where the Camera can scroll to.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#width
     * @type {number}
     * @since 3.0.0
     */ width: {
                        get: function() {
                            return this._width;
                        },
                        set: function(value) {
                            this._width = value;
                            this.updateSystem();
                        }
                    },
                    /**
     * The height of the Camera viewport, in pixels.
     *
     * The viewport is the area into which the Camera renders. Setting the viewport does
     * not restrict where the Camera can scroll to.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#height
     * @type {number}
     * @since 3.0.0
     */ height: {
                        get: function() {
                            return this._height;
                        },
                        set: function(value) {
                            this._height = value;
                            this.updateSystem();
                        }
                    },
                    /**
     * The horizontal scroll position of this Camera.
     *
     * Change this value to cause the Camera to scroll around your Scene.
     *
     * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
     * will automatically adjust the Camera scroll values accordingly.
     *
     * You can set the bounds within which the Camera can scroll via the `setBounds` method.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#scrollX
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ scrollX: {
                        get: function() {
                            return this._scrollX;
                        },
                        set: function(value) {
                            if (value !== this._scrollX) {
                                this._scrollX = value;
                                this.dirty = true;
                            }
                        }
                    },
                    /**
     * The vertical scroll position of this Camera.
     *
     * Change this value to cause the Camera to scroll around your Scene.
     *
     * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
     * will automatically adjust the Camera scroll values accordingly.
     *
     * You can set the bounds within which the Camera can scroll via the `setBounds` method.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#scrollY
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ scrollY: {
                        get: function() {
                            return this._scrollY;
                        },
                        set: function(value) {
                            if (value !== this._scrollY) {
                                this._scrollY = value;
                                this.dirty = true;
                            }
                        }
                    },
                    /**
     * The Camera zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoom
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ zoom: {
                        get: function() {
                            return (this._zoomX + this._zoomY) / 2;
                        },
                        set: function(value) {
                            this._zoomX = value;
                            this._zoomY = value;
                            this.dirty = true;
                        }
                    },
                    /**
     * The Camera horizontal zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoomX
     * @type {number}
     * @default 1
     * @since 3.50.0
     */ zoomX: {
                        get: function() {
                            return this._zoomX;
                        },
                        set: function(value) {
                            this._zoomX = value;
                            this.dirty = true;
                        }
                    },
                    /**
     * The Camera vertical zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoomY
     * @type {number}
     * @default 1
     * @since 3.50.0
     */ zoomY: {
                        get: function() {
                            return this._zoomY;
                        },
                        set: function(value) {
                            this._zoomY = value;
                            this.dirty = true;
                        }
                    },
                    /**
     * The rotation of the Camera in radians.
     *
     * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
     * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
     *
     * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
     * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#rotation
     * @type {number}
     * @private
     * @default 0
     * @since 3.11.0
     */ rotation: {
                        get: function() {
                            return this._rotation;
                        },
                        set: function(value) {
                            this._rotation = value;
                            this.dirty = true;
                        }
                    },
                    /**
     * The horizontal position of the center of the Camera's viewport, relative to the left of the game canvas.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#centerX
     * @type {number}
     * @readonly
     * @since 3.10.0
     */ centerX: {
                        get: function() {
                            return this.x + 0.5 * this.width;
                        }
                    },
                    /**
     * The vertical position of the center of the Camera's viewport, relative to the top of the game canvas.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#centerY
     * @type {number}
     * @readonly
     * @since 3.10.0
     */ centerY: {
                        get: function() {
                            return this.y + 0.5 * this.height;
                        }
                    },
                    /**
     * The displayed width of the camera viewport, factoring in the camera zoom level.
     *
     * If a camera has a viewport width of 800 and a zoom of 0.5 then its display width
     * would be 1600, as it's displaying twice as many pixels as zoom level 1.
     *
     * Equally, a camera with a width of 800 and zoom of 2 would have a display width
     * of 400 pixels.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#displayWidth
     * @type {number}
     * @readonly
     * @since 3.11.0
     */ displayWidth: {
                        get: function() {
                            return this.width / this.zoomX;
                        }
                    },
                    /**
     * The displayed height of the camera viewport, factoring in the camera zoom level.
     *
     * If a camera has a viewport height of 600 and a zoom of 0.5 then its display height
     * would be 1200, as it's displaying twice as many pixels as zoom level 1.
     *
     * Equally, a camera with a height of 600 and zoom of 2 would have a display height
     * of 300 pixels.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#displayHeight
     * @type {number}
     * @readonly
     * @since 3.11.0
     */ displayHeight: {
                        get: function() {
                            return this.height / this.zoomY;
                        }
                    }
                });
                module1.exports = BaseCamera;
            /***/ },
            /***/ 38058: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCamera = __webpack_require__(71911);
                var CenterOn = __webpack_require__(67502);
                var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var Effects = __webpack_require__(20052);
                var Events = __webpack_require__(19715);
                var Linear = __webpack_require__(28915);
                var Rectangle = __webpack_require__(87841);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Camera.
 *
 * The Camera is the way in which all games are rendered in Phaser. They provide a view into your game world,
 * and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis.
 *
 * A Camera also has built-in special effects including Fade, Flash and Camera Shake.
 *
 * @class Camera
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Cameras.Scene2D.BaseCamera
 * @extends Phaser.GameObjects.Components.PostPipeline
 *
 * @param {number} x - The x position of the Camera, relative to the top-left of the game canvas.
 * @param {number} y - The y position of the Camera, relative to the top-left of the game canvas.
 * @param {number} width - The width of the Camera, in pixels.
 * @param {number} height - The height of the Camera, in pixels.
 */ var Camera = new Class({
                    Extends: BaseCamera,
                    Mixins: [
                        Components.PostPipeline
                    ],
                    initialize: function Camera(x, y, width, height) {
                        BaseCamera.call(this, x, y, width, height);
                        this.initPostPipeline();
                        /**
         * Does this Camera allow the Game Objects it renders to receive input events?
         *
         * @name Phaser.Cameras.Scene2D.Camera#inputEnabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.inputEnabled = true;
                        /**
         * The Camera Fade effect handler.
         * To fade this camera see the `Camera.fade` methods.
         *
         * @name Phaser.Cameras.Scene2D.Camera#fadeEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Fade}
         * @since 3.5.0
         */ this.fadeEffect = new Effects.Fade(this);
                        /**
         * The Camera Flash effect handler.
         * To flash this camera see the `Camera.flash` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#flashEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Flash}
         * @since 3.5.0
         */ this.flashEffect = new Effects.Flash(this);
                        /**
         * The Camera Shake effect handler.
         * To shake this camera see the `Camera.shake` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#shakeEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Shake}
         * @since 3.5.0
         */ this.shakeEffect = new Effects.Shake(this);
                        /**
         * The Camera Pan effect handler.
         * To pan this camera see the `Camera.pan` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#panEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Pan}
         * @since 3.11.0
         */ this.panEffect = new Effects.Pan(this);
                        /**
         * The Camera Rotate To effect handler.
         * To rotate this camera see the `Camera.rotateTo` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#rotateToEffect
         * @type {Phaser.Cameras.Scene2D.Effects.RotateTo}
         * @since 3.23.0
         */ this.rotateToEffect = new Effects.RotateTo(this);
                        /**
         * The Camera Zoom effect handler.
         * To zoom this camera see the `Camera.zoom` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#zoomEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Zoom}
         * @since 3.11.0
         */ this.zoomEffect = new Effects.Zoom(this);
                        /**
         * The linear interpolation value to use when following a target.
         *
         * Can also be set via `setLerp` or as part of the `startFollow` call.
         *
         * The default values of 1 means the camera will instantly snap to the target coordinates.
         * A lower value, such as 0.1 means the camera will more slowly track the target, giving
         * a smooth transition. You can set the horizontal and vertical values independently, and also
         * adjust this value in real-time during your game.
         *
         * Be sure to keep the value between 0 and 1. A value of zero will disable tracking on that axis.
         *
         * @name Phaser.Cameras.Scene2D.Camera#lerp
         * @type {Phaser.Math.Vector2}
         * @since 3.9.0
         */ this.lerp = new Vector2(1, 1);
                        /**
         * The values stored in this property are subtracted from the Camera targets position, allowing you to
         * offset the camera from the actual target x/y coordinates by this amount.
         * Can also be set via `setFollowOffset` or as part of the `startFollow` call.
         *
         * @name Phaser.Cameras.Scene2D.Camera#followOffset
         * @type {Phaser.Math.Vector2}
         * @since 3.9.0
         */ this.followOffset = new Vector2();
                        /**
         * The Camera dead zone.
         *
         * The deadzone is only used when the camera is following a target.
         *
         * It defines a rectangular region within which if the target is present, the camera will not scroll.
         * If the target moves outside of this area, the camera will begin scrolling in order to follow it.
         *
         * The `lerp` values that you can set for a follower target also apply when using a deadzone.
         *
         * You can directly set this property to be an instance of a Rectangle. Or, you can use the
         * `setDeadzone` method for a chainable approach.
         *
         * The rectangle you provide can have its dimensions adjusted dynamically, however, please
         * note that its position is updated every frame, as it is constantly re-centered on the cameras mid point.
         *
         * Calling `setDeadzone` with no arguments will reset an active deadzone, as will setting this property
         * to `null`.
         *
         * @name Phaser.Cameras.Scene2D.Camera#deadzone
         * @type {?Phaser.Geom.Rectangle}
         * @since 3.11.0
         */ this.deadzone = null;
                        /**
         * Internal follow target reference.
         *
         * @name Phaser.Cameras.Scene2D.Camera#_follow
         * @type {?any}
         * @private
         * @default null
         * @since 3.0.0
         */ this._follow = null;
                    },
                    /**
     * Sets the Camera dead zone.
     *
     * The deadzone is only used when the camera is following a target.
     *
     * It defines a rectangular region within which if the target is present, the camera will not scroll.
     * If the target moves outside of this area, the camera will begin scrolling in order to follow it.
     *
     * The deadzone rectangle is re-positioned every frame so that it is centered on the mid-point
     * of the camera. This allows you to use the object for additional game related checks, such as
     * testing if an object is within it or not via a Rectangle.contains call.
     *
     * The `lerp` values that you can set for a follower target also apply when using a deadzone.
     *
     * Calling this method with no arguments will reset an active deadzone.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setDeadzone
     * @since 3.11.0
     *
     * @param {number} [width] - The width of the deadzone rectangle in pixels. If not specified the deadzone is removed.
     * @param {number} [height] - The height of the deadzone rectangle in pixels.
     *
     * @return {this} This Camera instance.
     */ setDeadzone: function(width, height) {
                        if (width === undefined) this.deadzone = null;
                        else {
                            if (this.deadzone) {
                                this.deadzone.width = width;
                                this.deadzone.height = height;
                            } else this.deadzone = new Rectangle(0, 0, width, height);
                            if (this._follow) {
                                var originX = this.width / 2;
                                var originY = this.height / 2;
                                var fx = this._follow.x - this.followOffset.x;
                                var fy = this._follow.y - this.followOffset.y;
                                this.midPoint.set(fx, fy);
                                this.scrollX = fx - originX;
                                this.scrollY = fy - originY;
                            }
                            CenterOn(this.deadzone, this.midPoint.x, this.midPoint.y);
                        }
                        return this;
                    },
                    /**
     * Fades the Camera in from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeIn
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @since 3.3.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeIn: function(duration, red, green, blue, callback, context) {
                        return this.fadeEffect.start(false, duration, red, green, blue, true, callback, context);
                    },
                    /**
     * Fades the Camera out to the given color over the duration specified.
     * This is an alias for Camera.fade that forces the fade to start, regardless of existing fades.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeOut
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.3.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeOut: function(duration, red, green, blue, callback, context) {
                        return this.fadeEffect.start(true, duration, red, green, blue, true, callback, context);
                    },
                    /**
     * Fades the Camera from the given color to transparent over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeFrom
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeFrom: function(duration, red, green, blue, force, callback, context) {
                        return this.fadeEffect.start(false, duration, red, green, blue, force, callback, context);
                    },
                    /**
     * Fades the Camera from transparent to the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fade
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fade: function(duration, red, green, blue, force, callback, context) {
                        return this.fadeEffect.start(true, duration, red, green, blue, force, callback, context);
                    },
                    /**
     * Flashes the Camera by setting it to the given color immediately and then fading it away again quickly over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#flash
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_START
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=250] - The duration of the effect in milliseconds.
     * @param {number} [red=255] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=255] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=255] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ flash: function(duration, red, green, blue, force, callback, context) {
                        return this.flashEffect.start(duration, red, green, blue, force, callback, context);
                    },
                    /**
     * Shakes the Camera by the given intensity over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#shake
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_START
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=100] - The duration of the effect in milliseconds.
     * @param {(number|Phaser.Math.Vector2)} [intensity=0.05] - The intensity of the shake.
     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ shake: function(duration, intensity, force, callback, context) {
                        return this.shakeEffect.start(duration, intensity, force, callback, context);
                    },
                    /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#pan
     * @fires Phaser.Cameras.Scene2D.Events#PAN_START
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     *
     * @param {number} x - The destination x coordinate to scroll the center of the Camera viewport to.
     * @param {number} y - The destination y coordinate to scroll the center of the Camera viewport to.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ pan: function(x, y, duration, ease, force, callback, context) {
                        return this.panEffect.start(x, y, duration, ease, force, callback, context);
                    },
                    /**
     * This effect will rotate the Camera so that the viewport finishes at the given angle in radians,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#rotateTo
     * @since 3.23.0
     *
     * @param {number} radians - The destination angle in radians to rotate the Camera viewport to. If the angle is positive then the rotation is clockwise else anticlockwise
     * @param {boolean} [shortestPath=false] - If shortest path is set to true the camera will rotate in the quickest direction clockwise or anti-clockwise.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the rotation. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the rotation effect to start immediately, even if already running.
     * @param {CameraRotateCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera rotation angle in radians.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
     */ rotateTo: function(radians, shortestPath, duration, ease, force, callback, context) {
                        return this.rotateToEffect.start(radians, shortestPath, duration, ease, force, callback, context);
                    },
                    /**
     * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#zoomTo
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_START
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     *
     * @param {number} zoom - The target Camera zoom value.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ zoomTo: function(zoom, duration, ease, force, callback, context) {
                        return this.zoomEffect.start(zoom, duration, ease, force, callback, context);
                    },
                    /**
     * Updates camera matrix. Also resets any active effects on this Camera (such as shake, flash and fade) and quickly clears them all.
     *
     * @method Phaser.Cameras.Scene2D.Camera#preRender
     * @since 3.0.0
     */ preRender: function() {
                        this.renderList.length = 0;
                        var width = this.width;
                        var height = this.height;
                        var halfWidth = width * 0.5;
                        var halfHeight = height * 0.5;
                        var zoomX = this.zoomX;
                        var zoomY = this.zoomY;
                        var matrix = this.matrix;
                        this.renderRoundPixels = this.roundPixels && Number.isInteger(zoomX) && Number.isInteger(zoomY);
                        var originX = width * this.originX;
                        var originY = height * this.originY;
                        var follow = this._follow;
                        var deadzone = this.deadzone;
                        var sx = this.scrollX;
                        var sy = this.scrollY;
                        if (deadzone) CenterOn(deadzone, this.midPoint.x, this.midPoint.y);
                        var emitFollowEvent = false;
                        if (follow && !this.panEffect.isRunning) {
                            var lerp = this.lerp;
                            var fx = follow.x - this.followOffset.x;
                            var fy = follow.y - this.followOffset.y;
                            if (deadzone) {
                                if (fx < deadzone.x) sx = Linear(sx, sx - (deadzone.x - fx), lerp.x);
                                else if (fx > deadzone.right) sx = Linear(sx, sx + (fx - deadzone.right), lerp.x);
                                if (fy < deadzone.y) sy = Linear(sy, sy - (deadzone.y - fy), lerp.y);
                                else if (fy > deadzone.bottom) sy = Linear(sy, sy + (fy - deadzone.bottom), lerp.y);
                            } else {
                                sx = Linear(sx, fx - originX, lerp.x);
                                sy = Linear(sy, fy - originY, lerp.y);
                            }
                            emitFollowEvent = true;
                        }
                        if (this.roundPixels) {
                            sx = Math.floor(sx);
                            sy = Math.floor(sy);
                        }
                        if (this.useBounds) {
                            sx = this.clampX(sx);
                            sy = this.clampY(sy);
                        }
                        //  Values are in pixels and not impacted by zooming the Camera
                        this.scrollX = sx;
                        this.scrollY = sy;
                        //  Don't round the midPoint, otherwise it breaks things like smooth zoom
                        var midX = sx + halfWidth;
                        var midY = sy + halfHeight;
                        //  The center of the camera, in world space, so taking zoom into account
                        //  Basically the pixel value of what it's looking at in the middle of the cam
                        this.midPoint.set(midX, midY);
                        var displayWidth = Math.floor(width / zoomX + 0.5);
                        var displayHeight = Math.floor(height / zoomY + 0.5);
                        var vwx = Math.floor(midX - displayWidth / 2 + 0.5);
                        var vwy = Math.floor(midY - displayHeight / 2 + 0.5);
                        this.worldView.setTo(vwx, vwy, displayWidth, displayHeight);
                        matrix.applyITRS(Math.floor(this.x + originX + 0.5), Math.floor(this.y + originY + 0.5), this.rotation, zoomX, zoomY);
                        matrix.translate(-originX, -originY);
                        this.shakeEffect.preRender();
                        if (emitFollowEvent) this.emit(Events.FOLLOW_UPDATE, this, follow);
                    },
                    /**
     * Sets the linear interpolation value to use when following a target.
     *
     * The default values of 1 means the camera will instantly snap to the target coordinates.
     * A lower value, such as 0.1 means the camera will more slowly track the target, giving
     * a smooth transition. You can set the horizontal and vertical values independently, and also
     * adjust this value in real-time during your game.
     *
     * Be sure to keep the value between 0 and 1. A value of zero will disable tracking on that axis.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setLerp
     * @since 3.9.0
     *
     * @param {number} [x=1] - The amount added to the horizontal linear interpolation of the follow target.
     * @param {number} [y=1] - The amount added to the vertical linear interpolation of the follow target.
     *
     * @return {this} This Camera instance.
     */ setLerp: function(x, y) {
                        if (x === undefined) x = 1;
                        if (y === undefined) y = x;
                        this.lerp.set(x, y);
                        return this;
                    },
                    /**
     * Sets the horizontal and vertical offset of the camera from its follow target.
     * The values are subtracted from the targets position during the Cameras update step.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setFollowOffset
     * @since 3.9.0
     *
     * @param {number} [x=0] - The horizontal offset from the camera follow target.x position.
     * @param {number} [y=0] - The vertical offset from the camera follow target.y position.
     *
     * @return {this} This Camera instance.
     */ setFollowOffset: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        this.followOffset.set(x, y);
                        return this;
                    },
                    /**
     * Sets the Camera to follow a Game Object.
     *
     * When enabled the Camera will automatically adjust its scroll position to keep the target Game Object
     * in its center.
     *
     * You can set the linear interpolation value used in the follow code.
     * Use low lerp values (such as 0.1) to automatically smooth the camera motion.
     *
     * If you find you're getting a slight "jitter" effect when following an object it's probably to do with sub-pixel
     * rendering of the targets position. This can be rounded by setting the `roundPixels` argument to `true` to
     * force full pixel rounding rendering. Note that this can still be broken if you have specified a non-integer zoom
     * value on the camera. So be sure to keep the camera zoom to integers.
     *
     * @method Phaser.Cameras.Scene2D.Camera#startFollow
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|object)} target - The target for the Camera to follow.
     * @param {boolean} [roundPixels=false] - Round the camera position to whole integers to avoid sub-pixel rendering?
     * @param {number} [lerpX=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when horizontally tracking the target. The closer the value to 1, the faster the camera will track.
     * @param {number} [lerpY=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when vertically tracking the target. The closer the value to 1, the faster the camera will track.
     * @param {number} [offsetX=0] - The horizontal offset from the camera follow target.x position.
     * @param {number} [offsetY=0] - The vertical offset from the camera follow target.y position.
     *
     * @return {this} This Camera instance.
     */ startFollow: function(target, roundPixels, lerpX, lerpY, offsetX, offsetY) {
                        if (roundPixels === undefined) roundPixels = false;
                        if (lerpX === undefined) lerpX = 1;
                        if (lerpY === undefined) lerpY = lerpX;
                        if (offsetX === undefined) offsetX = 0;
                        if (offsetY === undefined) offsetY = offsetX;
                        this._follow = target;
                        this.roundPixels = roundPixels;
                        lerpX = Clamp(lerpX, 0, 1);
                        lerpY = Clamp(lerpY, 0, 1);
                        this.lerp.set(lerpX, lerpY);
                        this.followOffset.set(offsetX, offsetY);
                        var originX = this.width / 2;
                        var originY = this.height / 2;
                        var fx = target.x - offsetX;
                        var fy = target.y - offsetY;
                        this.midPoint.set(fx, fy);
                        this.scrollX = fx - originX;
                        this.scrollY = fy - originY;
                        if (this.useBounds) {
                            this.scrollX = this.clampX(this.scrollX);
                            this.scrollY = this.clampY(this.scrollY);
                        }
                        return this;
                    },
                    /**
     * Stops a Camera from following a Game Object, if previously set via `Camera.startFollow`.
     *
     * @method Phaser.Cameras.Scene2D.Camera#stopFollow
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ stopFollow: function() {
                        this._follow = null;
                        return this;
                    },
                    /**
     * Resets any active FX, such as a fade, flash or shake. Useful to call after a fade in order to
     * remove the fade.
     *
     * @method Phaser.Cameras.Scene2D.Camera#resetFX
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ resetFX: function() {
                        this.rotateToEffect.reset();
                        this.panEffect.reset();
                        this.shakeEffect.reset();
                        this.flashEffect.reset();
                        this.fadeEffect.reset();
                        return this;
                    },
                    /**
     * Internal method called automatically by the Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.Camera#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (this.visible) {
                            this.rotateToEffect.update(time, delta);
                            this.panEffect.update(time, delta);
                            this.zoomEffect.update(time, delta);
                            this.shakeEffect.update(time, delta);
                            this.flashEffect.update(time, delta);
                            this.fadeEffect.update(time, delta);
                        }
                    },
                    /**
     * Destroys this Camera instance. You rarely need to call this directly.
     *
     * Called by the Camera Manager. If you wish to destroy a Camera please use `CameraManager.remove` as
     * cameras are stored in a pool, ready for recycling later, and calling this directly will prevent that.
     *
     * @method Phaser.Cameras.Scene2D.Camera#destroy
     * @fires Phaser.Cameras.Scene2D.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                        this.resetFX();
                        BaseCamera.prototype.destroy.call(this);
                        this._follow = null;
                        this.deadzone = null;
                    }
                });
                module1.exports = Camera;
            /***/ },
            /***/ 32743: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Camera = __webpack_require__(38058);
                var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var PluginCache = __webpack_require__(37277);
                var RectangleContains = __webpack_require__(37303);
                var ScaleEvents = __webpack_require__(97480);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * The Camera Manager is a plugin that belongs to a Scene and is responsible for managing all of the Scene Cameras.
 *
 * By default you can access the Camera Manager from within a Scene using `this.cameras`, although this can be changed
 * in your game config.
 *
 * Create new Cameras using the `add` method. Or extend the Camera class with your own addition code and then add
 * the new Camera in using the `addExisting` method.
 *
 * Cameras provide a view into your game world, and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis. The Camera Manager can manage up to 31 unique
 * 'Game Object ignore capable' Cameras. Any Cameras beyond 31 that you create will all be given a Camera ID of
 * zero, meaning that they cannot be used for Game Object exclusion. This means if you need your Camera to ignore
 * Game Objects, make sure it's one of the first 31 created.
 *
 * A Camera also has built-in special effects including Fade, Flash, Camera Shake, Pan and Zoom.
 *
 * @class CameraManager
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that owns the Camera Manager plugin.
 */ var CameraManager = new Class({
                    initialize: function CameraManager(scene) {
                        /**
         * The Scene that owns the Camera Manager plugin.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene.Systems handler for the Scene that owns the Camera Manager.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * All Cameras created by, or added to, this Camera Manager, will have their `roundPixels`
         * property set to match this value. By default it is set to match the value set in the
         * game configuration, but can be changed at any point. Equally, individual cameras can
         * also be changed as needed.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#roundPixels
         * @type {boolean}
         * @since 3.11.0
         */ this.roundPixels = scene.sys.game.config.roundPixels;
                        /**
         * An Array of the Camera objects being managed by this Camera Manager.
         * The Cameras are updated and rendered in the same order in which they appear in this array.
         * Do not directly add or remove entries to this array. However, you can move the contents
         * around the array should you wish to adjust the display order.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#cameras
         * @type {Phaser.Cameras.Scene2D.Camera[]}
         * @since 3.0.0
         */ this.cameras = [];
                        /**
         * A handy reference to the 'main' camera. By default this is the first Camera the
         * Camera Manager creates. You can also set it directly, or use the `makeMain` argument
         * in the `add` and `addExisting` methods. It allows you to access it from your game:
         *
         * ```javascript
         * var cam = this.cameras.main;
         * ```
         *
         * Also see the properties `camera1`, `camera2` and so on.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#main
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.0.0
         */ this.main;
                        /**
         * A default un-transformed Camera that doesn't exist on the camera list and doesn't
         * count towards the total number of cameras being managed. It exists for other
         * systems, as well as your own code, should they require a basic un-transformed
         * camera instance from which to calculate a view matrix.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#default
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.17.0
         */ this.default;
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#boot
     * @private
     * @listens Phaser.Scenes.Events#DESTROY
     * @since 3.5.1
     */ boot: function() {
                        var sys = this.systems;
                        if (sys.settings.cameras) //  We have cameras to create
                        this.fromJSON(sys.settings.cameras);
                        else //  Make one
                        this.add();
                        this.main = this.cameras[0];
                        //  Create a default camera
                        this.default = new Camera(0, 0, sys.scale.width, sys.scale.height).setScene(this.scene);
                        sys.game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                        this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#start
     * @private
     * @listens Phaser.Scenes.Events#UPDATE
     * @listens Phaser.Scenes.Events#SHUTDOWN
     * @since 3.5.0
     */ start: function() {
                        if (!this.main) {
                            var sys = this.systems;
                            if (sys.settings.cameras) //  We have cameras to create
                            this.fromJSON(sys.settings.cameras);
                            else //  Make one
                            this.add();
                            this.main = this.cameras[0];
                        }
                        var eventEmitter = this.systems.events;
                        eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                        eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Adds a new Camera into the Camera Manager. The Camera Manager can support up to 31 different Cameras.
     *
     * Each Camera has its own viewport, which controls the size of the Camera and its position within the canvas.
     *
     * Use the `Camera.scrollX` and `Camera.scrollY` properties to change where the Camera is looking, or the
     * Camera methods such as `centerOn`. Cameras also have built in special effects, such as fade, flash, shake,
     * pan and zoom.
     *
     * By default Cameras are transparent and will render anything that they can see based on their `scrollX`
     * and `scrollY` values. Game Objects can be set to be ignored by a Camera by using the `Camera.ignore` method.
     *
     * The Camera will have its `roundPixels` property set to whatever `CameraManager.roundPixels` is. You can change
     * it after creation if required.
     *
     * See the Camera class documentation for more details.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#add
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the Camera viewport.
     * @param {number} [y=0] - The vertical position of the Camera viewport.
     * @param {number} [width] - The width of the Camera viewport. If not given it'll be the game config size.
     * @param {number} [height] - The height of the Camera viewport. If not given it'll be the game config size.
     * @param {boolean} [makeMain=false] - Set this Camera as being the 'main' camera. This just makes the property `main` a reference to it.
     * @param {string} [name=''] - The name of the Camera.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The newly created Camera.
     */ add: function(x, y, width, height, makeMain, name) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.scene.sys.scale.width;
                        if (height === undefined) height = this.scene.sys.scale.height;
                        if (makeMain === undefined) makeMain = false;
                        if (name === undefined) name = '';
                        var camera = new Camera(x, y, width, height);
                        camera.setName(name);
                        camera.setScene(this.scene);
                        camera.setRoundPixels(this.roundPixels);
                        camera.id = this.getNextID();
                        this.cameras.push(camera);
                        if (makeMain) this.main = camera;
                        return camera;
                    },
                    /**
     * Adds an existing Camera into the Camera Manager.
     *
     * The Camera should either be a `Phaser.Cameras.Scene2D.Camera` instance, or a class that extends from it.
     *
     * The Camera will have its `roundPixels` property set to whatever `CameraManager.roundPixels` is. You can change
     * it after addition if required.
     *
     * The Camera will be assigned an ID, which is used for Game Object exclusion and then added to the
     * manager. As long as it doesn't already exist in the manager it will be added then returned.
     *
     * If this method returns `null` then the Camera already exists in this Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#addExisting
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to be added to the Camera Manager.
     * @param {boolean} [makeMain=false] - Set this Camera as being the 'main' camera. This just makes the property `main` a reference to it.
     *
     * @return {?Phaser.Cameras.Scene2D.Camera} The Camera that was added to the Camera Manager, or `null` if it couldn't be added.
     */ addExisting: function(camera, makeMain) {
                        if (makeMain === undefined) makeMain = false;
                        var index = this.cameras.indexOf(camera);
                        if (index === -1) {
                            camera.id = this.getNextID();
                            camera.setRoundPixels(this.roundPixels);
                            this.cameras.push(camera);
                            if (makeMain) this.main = camera;
                            return camera;
                        }
                        return null;
                    },
                    /**
     * Gets the next available Camera ID number.
     *
     * The Camera Manager supports up to 31 unique cameras, after which the ID returned will always be zero.
     * You can create additional cameras beyond 31, but they cannot be used for Game Object exclusion.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getNextID
     * @private
     * @since 3.11.0
     *
     * @return {number} The next available Camera ID, or 0 if they're all already in use.
     */ getNextID: function() {
                        var cameras = this.cameras;
                        var testID = 1;
                        //  Find the first free camera ID we can use
                        for(var t = 0; t < 32; t++){
                            var found = false;
                            for(var i = 0; i < cameras.length; i++){
                                var camera = cameras[i];
                                if (camera && camera.id === testID) {
                                    found = true;
                                    continue;
                                }
                            }
                            if (found) testID = testID << 1;
                            else return testID;
                        }
                        return 0;
                    },
                    /**
     * Gets the total number of Cameras in this Camera Manager.
     *
     * If the optional `isVisible` argument is set it will only count Cameras that are currently visible.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getTotal
     * @since 3.11.0
     *
     * @param {boolean} [isVisible=false] - Set the `true` to only include visible Cameras in the total.
     *
     * @return {number} The total number of Cameras in this Camera Manager.
     */ getTotal: function(isVisible) {
                        if (isVisible === undefined) isVisible = false;
                        var total = 0;
                        var cameras = this.cameras;
                        for(var i = 0; i < cameras.length; i++){
                            var camera = cameras[i];
                            if (!isVisible || isVisible && camera.visible) total++;
                        }
                        return total;
                    },
                    /**
     * Populates this Camera Manager based on the given configuration object, or an array of config objects.
     *
     * See the `Phaser.Types.Cameras.Scene2D.CameraConfig` documentation for details of the object structure.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#fromJSON
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Cameras.Scene2D.CameraConfig|Phaser.Types.Cameras.Scene2D.CameraConfig[])} config - A Camera configuration object, or an array of them, to be added to this Camera Manager.
     *
     * @return {this} This Camera Manager instance.
     */ fromJSON: function(config) {
                        if (!Array.isArray(config)) config = [
                            config
                        ];
                        var gameWidth = this.scene.sys.scale.width;
                        var gameHeight = this.scene.sys.scale.height;
                        for(var i = 0; i < config.length; i++){
                            var cameraConfig = config[i];
                            var x = GetFastValue(cameraConfig, 'x', 0);
                            var y = GetFastValue(cameraConfig, 'y', 0);
                            var width = GetFastValue(cameraConfig, 'width', gameWidth);
                            var height = GetFastValue(cameraConfig, 'height', gameHeight);
                            var camera = this.add(x, y, width, height);
                            //  Direct properties
                            camera.name = GetFastValue(cameraConfig, 'name', '');
                            camera.zoom = GetFastValue(cameraConfig, 'zoom', 1);
                            camera.rotation = GetFastValue(cameraConfig, 'rotation', 0);
                            camera.scrollX = GetFastValue(cameraConfig, 'scrollX', 0);
                            camera.scrollY = GetFastValue(cameraConfig, 'scrollY', 0);
                            camera.roundPixels = GetFastValue(cameraConfig, 'roundPixels', false);
                            camera.visible = GetFastValue(cameraConfig, 'visible', true);
                            // Background Color
                            var backgroundColor = GetFastValue(cameraConfig, 'backgroundColor', false);
                            if (backgroundColor) camera.setBackgroundColor(backgroundColor);
                            //  Bounds
                            var boundsConfig = GetFastValue(cameraConfig, 'bounds', null);
                            if (boundsConfig) {
                                var bx = GetFastValue(boundsConfig, 'x', 0);
                                var by = GetFastValue(boundsConfig, 'y', 0);
                                var bwidth = GetFastValue(boundsConfig, 'width', gameWidth);
                                var bheight = GetFastValue(boundsConfig, 'height', gameHeight);
                                camera.setBounds(bx, by, bwidth, bheight);
                            }
                        }
                        return this;
                    },
                    /**
     * Gets a Camera based on its name.
     *
     * Camera names are optional and don't have to be set, so this method is only of any use if you
     * have given your Cameras unique names.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getCamera
     * @since 3.0.0
     *
     * @param {string} name - The name of the Camera.
     *
     * @return {?Phaser.Cameras.Scene2D.Camera} The first Camera with a name matching the given string, otherwise `null`.
     */ getCamera: function(name) {
                        var cameras = this.cameras;
                        for(var i = 0; i < cameras.length; i++){
                            if (cameras[i].name === name) return cameras[i];
                        }
                        return null;
                    },
                    /**
     * Returns an array of all cameras below the given Pointer.
     *
     * The first camera in the array is the top-most camera in the camera list.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getCamerasBelowPointer
     * @since 3.10.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against.
     *
     * @return {Phaser.Cameras.Scene2D.Camera[]} An array of cameras below the Pointer.
     */ getCamerasBelowPointer: function(pointer) {
                        var cameras = this.cameras;
                        var x = pointer.x;
                        var y = pointer.y;
                        var output = [];
                        for(var i = 0; i < cameras.length; i++){
                            var camera = cameras[i];
                            if (camera.visible && camera.inputEnabled && RectangleContains(camera, x, y)) //  So the top-most camera is at the top of the search array
                            output.unshift(camera);
                        }
                        return output;
                    },
                    /**
     * Removes the given Camera, or an array of Cameras, from this Camera Manager.
     *
     * If found in the Camera Manager it will be immediately removed from the local cameras array.
     * If also currently the 'main' camera, 'main' will be reset to be camera 0.
     *
     * The removed Cameras are automatically destroyed if the `runDestroy` argument is `true`, which is the default.
     * If you wish to re-use the cameras then set this to `false`, but know that they will retain their references
     * and internal data until destroyed or re-added to a Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#remove
     * @since 3.0.0
     *
     * @param {(Phaser.Cameras.Scene2D.Camera|Phaser.Cameras.Scene2D.Camera[])} camera - The Camera, or an array of Cameras, to be removed from this Camera Manager.
     * @param {boolean} [runDestroy=true] - Automatically call `Camera.destroy` on each Camera removed from this Camera Manager.
     *
     * @return {number} The total number of Cameras removed.
     */ remove: function(camera, runDestroy) {
                        if (runDestroy === undefined) runDestroy = true;
                        if (!Array.isArray(camera)) camera = [
                            camera
                        ];
                        var total = 0;
                        var cameras = this.cameras;
                        for(var i = 0; i < camera.length; i++){
                            var index = cameras.indexOf(camera[i]);
                            if (index !== -1) {
                                if (runDestroy) cameras[index].destroy();
                                else cameras[index].renderList = [];
                                cameras.splice(index, 1);
                                total++;
                            }
                        }
                        if (!this.main && cameras[0]) this.main = cameras[0];
                        return total;
                    },
                    /**
     * The internal render method. This is called automatically by the Scene and should not be invoked directly.
     *
     * It will iterate through all local cameras and render them in turn, as long as they're visible and have
     * an alpha level > 0.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#render
     * @protected
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Renderer that will render the children to this camera.
     * @param {Phaser.GameObjects.DisplayList} displayList - The Display List for the Scene.
     */ render: function(renderer, displayList) {
                        var scene = this.scene;
                        var cameras = this.cameras;
                        for(var i = 0; i < cameras.length; i++){
                            var camera = cameras[i];
                            if (camera.visible && camera.alpha > 0) {
                                camera.preRender();
                                var visibleChildren = this.getVisibleChildren(displayList.getChildren(), camera);
                                renderer.render(scene, visibleChildren, camera);
                            }
                        }
                    },
                    /**
     * Takes an array of Game Objects and a Camera and returns a new array
     * containing only those Game Objects that pass the `willRender` test
     * against the given Camera.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getVisibleChildren
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject[]} children - An array of Game Objects to be checked against the camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to filter the Game Objects against.
     *
     * @return {Phaser.GameObjects.GameObject[]} A filtered list of only Game Objects within the Scene that will render against the given Camera.
     */ getVisibleChildren: function(children, camera) {
                        return children.filter(function(child) {
                            return child.willRender(camera);
                        });
                    },
                    /**
     * Resets this Camera Manager.
     *
     * This will iterate through all current Cameras, destroying them all, then it will reset the
     * cameras array, reset the ID counter and create 1 new single camera using the default values.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#resetAll
     * @since 3.0.0
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The freshly created main Camera.
     */ resetAll: function() {
                        for(var i = 0; i < this.cameras.length; i++)this.cameras[i].destroy();
                        this.cameras = [];
                        this.main = this.add();
                        return this.main;
                    },
                    /**
     * The main update loop. Called automatically when the Scene steps.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        for(var i = 0; i < this.cameras.length; i++)this.cameras[i].update(time, delta);
                    },
                    /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#onResize
     * @since 3.18.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize, displaySize, previousWidth, previousHeight) {
                        for(var i = 0; i < this.cameras.length; i++){
                            var cam = this.cameras[i];
                            //  if camera is at 0x0 and was the size of the previous game size, then we can safely assume it
                            //  should be updated to match the new game size too
                            if (cam._x === 0 && cam._y === 0 && cam._width === previousWidth && cam._height === previousHeight) cam.setSize(baseSize.width, baseSize.height);
                        }
                    },
                    /**
     * Resizes all cameras to the given dimensions.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#resize
     * @since 3.2.0
     *
     * @param {number} width - The new width of the camera.
     * @param {number} height - The new height of the camera.
     */ resize: function(width, height) {
                        for(var i = 0; i < this.cameras.length; i++)this.cameras[i].setSize(width, height);
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        this.main = undefined;
                        for(var i = 0; i < this.cameras.length; i++)this.cameras[i].destroy();
                        this.cameras = [];
                        var eventEmitter = this.systems.events;
                        eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                        eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.default.destroy();
                        this.systems.events.off(SceneEvents.START, this.start, this);
                        this.systems.events.off(SceneEvents.DESTROY, this.destroy, this);
                        this.systems.game.scale.off(ScaleEvents.RESIZE, this.onResize, this);
                        this.scene = null;
                        this.systems = null;
                    }
                });
                PluginCache.register('CameraManager', CameraManager, 'cameras');
                module1.exports = CameraManager;
            /***/ },
            /***/ 5020: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(19715);
                /**
 * @classdesc
 * A Camera Fade effect.
 *
 * This effect will fade the camera viewport to the given color, over the duration specified.
 *
 * Only the camera viewport is faded. None of the objects it is displaying are impacted, i.e. their colors do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect, if required.
 *
 * @class Fade
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Fade = new Class({
                    initialize: function Fade(camera) {
                        /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                        /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                        /**
         * Has this effect finished running?
         *
         * This is different from `isRunning` because it remains set to `true` when the effect is over,
         * until the effect is either reset or started again.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#isComplete
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isComplete = false;
                        /**
         * The direction of the fade.
         * `true` = fade out (transparent to color), `false` = fade in (color to transparent)
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#direction
         * @type {boolean}
         * @readonly
         * @since 3.5.0
         */ this.direction = true;
                        /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                        /**
         * The value of the red color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#red
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.red = 0;
                        /**
         * The value of the green color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#green
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.green = 0;
                        /**
         * The value of the blue color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#blue
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.blue = 0;
                        /**
         * The value of the alpha channel used during the fade effect.
         * A value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#alpha
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.alpha = 0;
                        /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                        /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                        /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraFadeCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                        /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                    },
                    /**
     * Fades the Camera to or from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#start
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @since 3.5.0
     *
     * @param {boolean} [direction=true] - The direction of the fade. `true` = fade out (transparent to color), `false` = fade in (color to transparent)
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraFadeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(direction, duration, red, green, blue, force, callback, context) {
                        if (direction === undefined) direction = true;
                        if (duration === undefined) duration = 1000;
                        if (red === undefined) red = 0;
                        if (green === undefined) green = 0;
                        if (blue === undefined) blue = 0;
                        if (force === undefined) force = false;
                        if (callback === undefined) callback = null;
                        if (context === undefined) context = this.camera.scene;
                        if (!force && this.isRunning) return this.camera;
                        this.isRunning = true;
                        this.isComplete = false;
                        this.duration = duration;
                        this.direction = direction;
                        this.progress = 0;
                        this.red = red;
                        this.green = green;
                        this.blue = blue;
                        this.alpha = direction ? Number.MIN_VALUE : 1;
                        this._elapsed = 0;
                        this._onUpdate = callback;
                        this._onUpdateScope = context;
                        var eventName = direction ? Events.FADE_OUT_START : Events.FADE_IN_START;
                        this.camera.emit(eventName, this.camera, this, duration, red, green, blue);
                        return this.camera;
                    },
                    /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (!this.isRunning) return;
                        this._elapsed += delta;
                        this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                        if (this._elapsed < this.duration) this.alpha = this.direction ? this.progress : 1 - this.progress;
                        else {
                            this.alpha = this.direction ? 1 : 0;
                            this.effectComplete();
                        }
                    },
                    /**
     * Called internally by the Canvas Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderCanvas
     * @since 3.5.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderCanvas: function(ctx) {
                        if (!this.isRunning && !this.isComplete) return false;
                        var camera = this.camera;
                        ctx.fillStyle = 'rgba(' + this.red + ',' + this.green + ',' + this.blue + ',' + this.alpha + ')';
                        ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
                        return true;
                    },
                    /**
     * Called internally by the WebGL Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderWebGL
     * @since 3.5.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} pipeline - The WebGL Pipeline to render to. Must provide the `drawFillRect` method.
     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderWebGL: function(pipeline, getTintFunction) {
                        if (!this.isRunning && !this.isComplete) return false;
                        var camera = this.camera;
                        var red = this.red / 255;
                        var green = this.green / 255;
                        var blue = this.blue / 255;
                        pipeline.drawFillRect(camera.x, camera.y, camera.width, camera.height, getTintFunction(blue, green, red, 1), this.alpha);
                        return true;
                    },
                    /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                        this.isRunning = false;
                        this.isComplete = true;
                        var eventName = this.direction ? Events.FADE_OUT_COMPLETE : Events.FADE_IN_COMPLETE;
                        this.camera.emit(eventName, this.camera, this);
                    },
                    /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#reset
     * @since 3.5.0
     */ reset: function() {
                        this.isRunning = false;
                        this.isComplete = false;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                    },
                    /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#destroy
     * @since 3.5.0
     */ destroy: function() {
                        this.reset();
                        this.camera = null;
                    }
                });
                module1.exports = Fade;
            /***/ },
            /***/ 10662: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(19715);
                /**
 * @classdesc
 * A Camera Flash effect.
 *
 * This effect will flash the camera viewport to the given color, over the duration specified.
 *
 * Only the camera viewport is flashed. None of the objects it is displaying are impacted, i.e. their colors do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect, if required.
 *
 * @class Flash
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Flash = new Class({
                    initialize: function Flash(camera) {
                        /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                        /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                        /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                        /**
         * The value of the red color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#red
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.red = 0;
                        /**
         * The value of the green color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#green
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.green = 0;
                        /**
         * The value of the blue color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#blue
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.blue = 0;
                        /**
         * The value of the alpha channel used during the flash effect.
         * A value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#alpha
         * @type {number}
         * @since 3.5.0
         */ this.alpha = 1;
                        /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                        /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                        /**
         * This is an internal copy of the initial value of `this.alpha`, used to calculate the current alpha value of the fade effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_alpha
         * @type {number}
         * @private
         * @readonly
         * @since 3.60.0
         */ this._alpha;
                        /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraFlashCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                        /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                    },
                    /**
     * Flashes the Camera to or from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#start
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_START
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=250] - The duration of the effect in milliseconds.
     * @param {number} [red=255] - The amount to flash the red channel towards. A value between 0 and 255.
     * @param {number} [green=255] - The amount to flash the green channel towards. A value between 0 and 255.
     * @param {number} [blue=255] - The amount to flash the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraFlashCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(duration, red, green, blue, force, callback, context) {
                        if (duration === undefined) duration = 250;
                        if (red === undefined) red = 255;
                        if (green === undefined) green = 255;
                        if (blue === undefined) blue = 255;
                        if (force === undefined) force = false;
                        if (callback === undefined) callback = null;
                        if (context === undefined) context = this.camera.scene;
                        if (!force && this.isRunning) return this.camera;
                        this.isRunning = true;
                        this.duration = duration;
                        this.progress = 0;
                        this.red = red;
                        this.green = green;
                        this.blue = blue;
                        this._alpha = this.alpha;
                        this._elapsed = 0;
                        this._onUpdate = callback;
                        this._onUpdateScope = context;
                        this.camera.emit(Events.FLASH_START, this.camera, this, duration, red, green, blue);
                        return this.camera;
                    },
                    /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (!this.isRunning) return;
                        this._elapsed += delta;
                        this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                        if (this._elapsed < this.duration) this.alpha = this._alpha * (1 - this.progress);
                        else this.effectComplete();
                    },
                    /**
     * Called internally by the Canvas Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderCanvas
     * @since 3.5.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderCanvas: function(ctx) {
                        if (!this.isRunning) return false;
                        var camera = this.camera;
                        ctx.fillStyle = 'rgba(' + this.red + ',' + this.green + ',' + this.blue + ',' + this.alpha + ')';
                        ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
                        return true;
                    },
                    /**
     * Called internally by the WebGL Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderWebGL
     * @since 3.5.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} pipeline - The WebGL Pipeline to render to. Must provide the `drawFillRect` method.
     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderWebGL: function(pipeline, getTintFunction) {
                        if (!this.isRunning) return false;
                        var camera = this.camera;
                        var red = this.red / 255;
                        var green = this.green / 255;
                        var blue = this.blue / 255;
                        pipeline.drawFillRect(camera.x, camera.y, camera.width, camera.height, getTintFunction(blue, green, red, 1), this.alpha);
                        return true;
                    },
                    /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                        this.alpha = this._alpha;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                        this.isRunning = false;
                        this.camera.emit(Events.FLASH_COMPLETE, this.camera, this);
                    },
                    /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#reset
     * @since 3.5.0
     */ reset: function() {
                        this.isRunning = false;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                    },
                    /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#destroy
     * @since 3.5.0
     */ destroy: function() {
                        this.reset();
                        this.camera = null;
                    }
                });
                module1.exports = Flash;
            /***/ },
            /***/ 20359: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var EaseMap = __webpack_require__(62640);
                var Events = __webpack_require__(19715);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Camera Pan effect.
 *
 * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
 * over the duration and with the ease specified.
 *
 * Only the camera scroll is moved. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Pan
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.11.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Pan = new Class({
                    initialize: function Pan(camera) {
                        /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.11.0
         */ this.camera = camera;
                        /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.11.0
         */ this.isRunning = false;
                        /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.11.0
         */ this.duration = 0;
                        /**
         * The starting scroll coordinates to pan the camera from.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#source
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.source = new Vector2();
                        /**
         * The constantly updated value based on zoom.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#current
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.current = new Vector2();
                        /**
         * The destination scroll coordinates to pan the camera to.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#destination
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.destination = new Vector2();
                        /**
         * The ease function to use during the pan.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#ease
         * @type {function}
         * @since 3.11.0
         */ this.ease;
                        /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#progress
         * @type {number}
         * @since 3.11.0
         */ this.progress = 0;
                        /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_elapsed
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._elapsed = 0;
                        /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraPanCallback}
         * @private
         * @default null
         * @since 3.11.0
         */ this._onUpdate;
                        /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.11.0
         */ this._onUpdateScope;
                    },
                    /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#start
     * @fires Phaser.Cameras.Scene2D.Events#PAN_START
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     *
     * @param {number} x - The destination x coordinate to scroll the center of the Camera viewport to.
     * @param {number} y - The destination y coordinate to scroll the center of the Camera viewport to.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(x, y, duration, ease, force, callback, context) {
                        if (duration === undefined) duration = 1000;
                        if (ease === undefined) ease = EaseMap.Linear;
                        if (force === undefined) force = false;
                        if (callback === undefined) callback = null;
                        if (context === undefined) context = this.camera.scene;
                        var cam = this.camera;
                        if (!force && this.isRunning) return cam;
                        this.isRunning = true;
                        this.duration = duration;
                        this.progress = 0;
                        //  Starting from
                        this.source.set(cam.scrollX, cam.scrollY);
                        //  Destination
                        this.destination.set(x, y);
                        //  Zoom factored version
                        cam.getScroll(x, y, this.current);
                        //  Using this ease
                        if (typeof ease === 'string' && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                        else if (typeof ease === 'function') this.ease = ease;
                        this._elapsed = 0;
                        this._onUpdate = callback;
                        this._onUpdateScope = context;
                        this.camera.emit(Events.PAN_START, this.camera, this, duration, x, y);
                        return cam;
                    },
                    /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#update
     * @since 3.11.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (!this.isRunning) return;
                        this._elapsed += delta;
                        var progress = Clamp(this._elapsed / this.duration, 0, 1);
                        this.progress = progress;
                        var cam = this.camera;
                        if (this._elapsed < this.duration) {
                            var v = this.ease(progress);
                            cam.getScroll(this.destination.x, this.destination.y, this.current);
                            var x = this.source.x + (this.current.x - this.source.x) * v;
                            var y = this.source.y + (this.current.y - this.source.y) * v;
                            cam.setScroll(x, y);
                            if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, x, y);
                        } else {
                            cam.centerOn(this.destination.x, this.destination.y);
                            if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, cam.scrollX, cam.scrollY);
                            this.effectComplete();
                        }
                    },
                    /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     */ effectComplete: function() {
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                        this.isRunning = false;
                        this.camera.emit(Events.PAN_COMPLETE, this.camera, this);
                    },
                    /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#reset
     * @since 3.11.0
     */ reset: function() {
                        this.isRunning = false;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                    },
                    /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#destroy
     * @since 3.11.0
     */ destroy: function() {
                        this.reset();
                        this.camera = null;
                        this.source = null;
                        this.destination = null;
                    }
                });
                module1.exports = Pan;
            /***/ },
            /***/ 34208: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Jason Nicholls <nicholls.jason@gmail.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(19715);
                var EaseMap = __webpack_require__(62640);
                /**
 * @classdesc
 * A Camera Rotate effect.
 *
 * This effect will rotate the Camera so that the its viewport finishes at the given angle in radians,
 * over the duration and with the ease specified.
 * 
 * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
 * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
 *
 * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
 * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
 *
 * Only the camera is rotates. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class RotateTo
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.23.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var RotateTo = new Class({
                    initialize: function RotateTo(camera) {
                        /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.23.0
         */ this.camera = camera;
                        /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.23.0
         */ this.isRunning = false;
                        /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.23.0
         */ this.duration = 0;
                        /**
         * The starting angle to rotate the camera from.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#source
         * @type {number}
         * @since 3.23.0
         */ this.source = 0;
                        /**
         * The constantly updated value based on the force.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#current
         * @type {number}
         * @since 3.23.0
         */ this.current = 0;
                        /**
         * The destination angle in radians to rotate the camera to.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#destination
         * @type {number}
         * @since 3.23.0
         */ this.destination = 0;
                        /**
         * The ease function to use during the Rotate.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#ease
         * @type {function}
         * @since 3.23.0
         */ this.ease;
                        /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#progress
         * @type {number}
         * @since 3.23.0
         */ this.progress = 0;
                        /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_elapsed
         * @type {number}
         * @private
         * @since 3.23.0
         */ this._elapsed = 0;
                        /**
         * @callback CameraRotateCallback
         *
         * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera on which the effect is running.
         * @param {number} progress - The progress of the effect. A value between 0 and 1.
         * @param {number} angle - The Camera's new angle in radians.
         */ /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_onUpdate
         * @type {?CameraRotateCallback}
         * @private
         * @default null
         * @since 3.23.0
         */ this._onUpdate;
                        /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.23.0
         */ this._onUpdateScope;
                        /**
         * The direction of the rotation.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#clockwise
         * @type {boolean}
         * @since 3.23.0
         */ this.clockwise = true;
                        /**
         * The shortest direction to the target rotation.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#shortestPath
         * @type {boolean}
         * @since 3.23.0
         */ this.shortestPath = false;
                    },
                    /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given angle,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#start
     * @fires Phaser.Cameras.Scene2D.Events#ROTATE_START
     * @fires Phaser.Cameras.Scene2D.Events#ROTATE_COMPLETE
     * @since 3.23.0
     *
     * @param {number} radians - The destination angle in radians to rotate the Camera viewport to. If the angle is positive then the rotation is clockwise else anticlockwise
     * @param {boolean} [shortestPath=false] - If shortest path is set to true the camera will rotate in the quickest direction clockwise or anti-clockwise.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the Rotate. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the rotation effect to start immediately, even if already running.
     * @param {CameraRotateCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(radians, shortestPath, duration, ease, force, callback, context) {
                        if (duration === undefined) duration = 1000;
                        if (ease === undefined) ease = EaseMap.Linear;
                        if (force === undefined) force = false;
                        if (callback === undefined) callback = null;
                        if (context === undefined) context = this.camera.scene;
                        if (shortestPath === undefined) shortestPath = false;
                        this.shortestPath = shortestPath;
                        var tmpDestination = radians;
                        if (radians < 0) {
                            tmpDestination = -1 * radians;
                            this.clockwise = false;
                        } else this.clockwise = true;
                        var maxRad = 360 * Math.PI / 180;
                        tmpDestination = tmpDestination - Math.floor(tmpDestination / maxRad) * maxRad;
                        var cam = this.camera;
                        if (!force && this.isRunning) return cam;
                        this.isRunning = true;
                        this.duration = duration;
                        this.progress = 0;
                        //  Starting from
                        this.source = cam.rotation;
                        //  Destination
                        this.destination = tmpDestination;
                        //  Using this ease
                        if (typeof ease === 'string' && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                        else if (typeof ease === 'function') this.ease = ease;
                        this._elapsed = 0;
                        this._onUpdate = callback;
                        this._onUpdateScope = context;
                        if (this.shortestPath) {
                            // The shortest path is true so calculate the quickest direction
                            var cwDist = 0;
                            var acwDist = 0;
                            if (this.destination > this.source) cwDist = Math.abs(this.destination - this.source);
                            else cwDist = Math.abs(this.destination + maxRad) - this.source;
                            if (this.source > this.destination) acwDist = Math.abs(this.source - this.destination);
                            else acwDist = Math.abs(this.source + maxRad) - this.destination;
                            if (cwDist < acwDist) this.clockwise = true;
                            else if (cwDist > acwDist) this.clockwise = false;
                        }
                        this.camera.emit(Events.ROTATE_START, this.camera, this, duration, tmpDestination);
                        return cam;
                    },
                    /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#update
     * @since 3.23.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (!this.isRunning) return;
                        this._elapsed += delta;
                        var progress = Clamp(this._elapsed / this.duration, 0, 1);
                        this.progress = progress;
                        var cam = this.camera;
                        if (this._elapsed < this.duration) {
                            var v = this.ease(progress);
                            this.current = cam.rotation;
                            var distance = 0;
                            var maxRad = 360 * Math.PI / 180;
                            var target = this.destination;
                            var current = this.current;
                            if (this.clockwise === false) {
                                target = this.current;
                                current = this.destination;
                            }
                            if (target >= current) distance = Math.abs(target - current);
                            else distance = Math.abs(target + maxRad) - current;
                            var r = 0;
                            if (this.clockwise) r = cam.rotation + distance * v;
                            else r = cam.rotation - distance * v;
                            cam.rotation = r;
                            if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, r);
                        } else {
                            cam.rotation = this.destination;
                            if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, this.destination);
                            this.effectComplete();
                        }
                    },
                    /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#effectComplete
     * @since 3.23.0
     */ effectComplete: function() {
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                        this.isRunning = false;
                        this.camera.emit(Events.ROTATE_COMPLETE, this.camera, this);
                    },
                    /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#reset
     * @since 3.23.0
     */ reset: function() {
                        this.isRunning = false;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                    },
                    /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#destroy
     * @since 3.23.0
     */ destroy: function() {
                        this.reset();
                        this.camera = null;
                        this.source = null;
                        this.destination = null;
                    }
                });
                module1.exports = RotateTo;
            /***/ },
            /***/ 30330: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(19715);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Camera Shake effect.
 *
 * This effect will shake the camera viewport by a random amount, bounded by the specified intensity, each frame.
 *
 * Only the camera viewport is moved. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Shake
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Shake = new Class({
                    initialize: function Shake(camera) {
                        /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                        /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                        /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                        /**
         * The intensity of the effect. Use small float values. The default when the effect starts is 0.05.
         * This is a Vector2 object, allowing you to control the shake intensity independently across x and y.
         * You can modify this value while the effect is active to create more varied shake effects.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#intensity
         * @type {Phaser.Math.Vector2}
         * @since 3.5.0
         */ this.intensity = new Vector2();
                        /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                        /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                        /**
         * How much to offset the camera by horizontally.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetX
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._offsetX = 0;
                        /**
         * How much to offset the camera by vertically.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetY
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._offsetY = 0;
                        /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraShakeCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                        /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                    },
                    /**
     * Shakes the Camera by the given intensity over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#start
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_START
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=100] - The duration of the effect in milliseconds.
     * @param {(number|Phaser.Math.Vector2)} [intensity=0.05] - The intensity of the shake.
     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraShakeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(duration, intensity, force, callback, context) {
                        if (duration === undefined) duration = 100;
                        if (intensity === undefined) intensity = 0.05;
                        if (force === undefined) force = false;
                        if (callback === undefined) callback = null;
                        if (context === undefined) context = this.camera.scene;
                        if (!force && this.isRunning) return this.camera;
                        this.isRunning = true;
                        this.duration = duration;
                        this.progress = 0;
                        if (typeof intensity === 'number') this.intensity.set(intensity);
                        else this.intensity.set(intensity.x, intensity.y);
                        this._elapsed = 0;
                        this._offsetX = 0;
                        this._offsetY = 0;
                        this._onUpdate = callback;
                        this._onUpdateScope = context;
                        this.camera.emit(Events.SHAKE_START, this.camera, this, duration, intensity);
                        return this.camera;
                    },
                    /**
     * The pre-render step for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#preRender
     * @since 3.5.0
     */ preRender: function() {
                        if (this.isRunning) this.camera.matrix.translate(this._offsetX, this._offsetY);
                    },
                    /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (!this.isRunning) return;
                        this._elapsed += delta;
                        this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                        if (this._elapsed < this.duration) {
                            var intensity = this.intensity;
                            var width = this.camera.width;
                            var height = this.camera.height;
                            var zoom = this.camera.zoom;
                            this._offsetX = (Math.random() * intensity.x * width * 2 - intensity.x * width) * zoom;
                            this._offsetY = (Math.random() * intensity.y * height * 2 - intensity.y * height) * zoom;
                            if (this.camera.roundPixels) {
                                this._offsetX = Math.round(this._offsetX);
                                this._offsetY = Math.round(this._offsetY);
                            }
                        } else this.effectComplete();
                    },
                    /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                        this._offsetX = 0;
                        this._offsetY = 0;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                        this.isRunning = false;
                        this.camera.emit(Events.SHAKE_COMPLETE, this.camera, this);
                    },
                    /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#reset
     * @since 3.5.0
     */ reset: function() {
                        this.isRunning = false;
                        this._offsetX = 0;
                        this._offsetY = 0;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                    },
                    /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#destroy
     * @since 3.5.0
     */ destroy: function() {
                        this.reset();
                        this.camera = null;
                        this.intensity = null;
                    }
                });
                module1.exports = Shake;
            /***/ },
            /***/ 45641: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var EaseMap = __webpack_require__(62640);
                var Events = __webpack_require__(19715);
                /**
 * @classdesc
 * A Camera Zoom effect.
 *
 * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Zoom
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.11.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Zoom = new Class({
                    initialize: function Zoom(camera) {
                        /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.11.0
         */ this.camera = camera;
                        /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.11.0
         */ this.isRunning = false;
                        /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.11.0
         */ this.duration = 0;
                        /**
         * The starting zoom value;
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#source
         * @type {number}
         * @since 3.11.0
         */ this.source = 1;
                        /**
         * The destination zoom value.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#destination
         * @type {number}
         * @since 3.11.0
         */ this.destination = 1;
                        /**
         * The ease function to use during the zoom.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#ease
         * @type {function}
         * @since 3.11.0
         */ this.ease;
                        /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#progress
         * @type {number}
         * @since 3.11.0
         */ this.progress = 0;
                        /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_elapsed
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._elapsed = 0;
                        /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraZoomCallback}
         * @private
         * @default null
         * @since 3.11.0
         */ this._onUpdate;
                        /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.11.0
         */ this._onUpdateScope;
                    },
                    /**
     * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#start
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_START
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     *
     * @param {number} zoom - The target Camera zoom value.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the Zoom. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the zoom effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraZoomCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent three arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * and the current camera zoom value.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(zoom, duration, ease, force, callback, context) {
                        if (duration === undefined) duration = 1000;
                        if (ease === undefined) ease = EaseMap.Linear;
                        if (force === undefined) force = false;
                        if (callback === undefined) callback = null;
                        if (context === undefined) context = this.camera.scene;
                        var cam = this.camera;
                        if (!force && this.isRunning) return cam;
                        this.isRunning = true;
                        this.duration = duration;
                        this.progress = 0;
                        //  Starting from
                        this.source = cam.zoom;
                        //  Zooming to
                        this.destination = zoom;
                        //  Using this ease
                        if (typeof ease === 'string' && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                        else if (typeof ease === 'function') this.ease = ease;
                        this._elapsed = 0;
                        this._onUpdate = callback;
                        this._onUpdateScope = context;
                        this.camera.emit(Events.ZOOM_START, this.camera, this, duration, zoom);
                        return cam;
                    },
                    /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#update
     * @since 3.11.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (!this.isRunning) return;
                        this._elapsed += delta;
                        this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                        if (this._elapsed < this.duration) {
                            this.camera.zoom = this.source + (this.destination - this.source) * this.ease(this.progress);
                            if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.camera.zoom);
                        } else {
                            this.camera.zoom = this.destination;
                            if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.destination);
                            this.effectComplete();
                        }
                    },
                    /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     */ effectComplete: function() {
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                        this.isRunning = false;
                        this.camera.emit(Events.ZOOM_COMPLETE, this.camera, this);
                    },
                    /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#reset
     * @since 3.11.0
     */ reset: function() {
                        this.isRunning = false;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                    },
                    /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#destroy
     * @since 3.11.0
     */ destroy: function() {
                        this.reset();
                        this.camera = null;
                    }
                });
                module1.exports = Zoom;
            /***/ },
            /***/ 20052: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D.Effects
 */ module1.exports = {
                    Fade: __webpack_require__(5020),
                    Flash: __webpack_require__(10662),
                    Pan: __webpack_require__(20359),
                    Shake: __webpack_require__(30330),
                    RotateTo: __webpack_require__(34208),
                    Zoom: __webpack_require__(45641)
                };
            /***/ },
            /***/ 16438: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Destroy Camera Event.
 *
 * This event is dispatched by a Camera instance when it is destroyed by the Camera Manager.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('cameradestroy', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.DESTROY, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#DESTROY
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that was destroyed.
 */ module1.exports = 'cameradestroy';
            /***/ },
            /***/ 32726: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade In Complete Event.
 *
 * This event is dispatched by a Camera instance when the Fade In Effect completes.
 *
 * Listen to it from a Camera instance using `Camera.on('camerafadeincomplete', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 */ module1.exports = 'camerafadeincomplete';
            /***/ },
            /***/ 87807: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade In Start Event.
 *
 * This event is dispatched by a Camera instance when the Fade In Effect starts.
 *
 * Listen to it from a Camera instance using `Camera.on('camerafadeinstart', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_IN_START
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = 'camerafadeinstart';
            /***/ },
            /***/ 45917: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade Out Complete Event.
 *
 * This event is dispatched by a Camera instance when the Fade Out Effect completes.
 *
 * Listen to it from a Camera instance using `Camera.on('camerafadeoutcomplete', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 */ module1.exports = 'camerafadeoutcomplete';
            /***/ },
            /***/ 95666: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade Out Start Event.
 *
 * This event is dispatched by a Camera instance when the Fade Out Effect starts.
 *
 * Listen to it from a Camera instance using `Camera.on('camerafadeoutstart', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_OUT_START
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = 'camerafadeoutstart';
            /***/ },
            /***/ 47056: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Flash Complete Event.
 *
 * This event is dispatched by a Camera instance when the Flash Effect completes.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('cameraflashcomplete', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.FLASH_COMPLETE, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
 */ module1.exports = 'cameraflashcomplete';
            /***/ },
            /***/ 91261: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Flash Start Event.
 *
 * This event is dispatched by a Camera instance when the Flash Effect starts.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('cameraflashstart', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.FLASH_START, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#FLASH_START
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = 'cameraflashstart';
            /***/ },
            /***/ 45047: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Follower Update Event.
 *
 * This event is dispatched by a Camera instance when it is following a
 * Game Object and the Camera position has been updated as a result of
 * that following.
 *
 * Listen to it from a Camera instance using: `camera.on('followupdate', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FOLLOW_UPDATE
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that emitted the event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the camera is following.
 */ module1.exports = 'followupdate';
            /***/ },
            /***/ 81927: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pan Complete Event.
 *
 * This event is dispatched by a Camera instance when the Pan Effect completes.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerapancomplete', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.PAN_COMPLETE, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Pan} effect - A reference to the effect instance.
 */ module1.exports = 'camerapancomplete';
            /***/ },
            /***/ 74264: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pan Start Event.
 *
 * This event is dispatched by a Camera instance when the Pan Effect starts.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerapanstart', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.PAN_START, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#PAN_START
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Pan} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} x - The destination scroll x coordinate.
 * @param {number} y - The destination scroll y coordinate.
 */ module1.exports = 'camerapanstart';
            /***/ },
            /***/ 54419: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Post-Render Event.
 *
 * This event is dispatched by a Camera instance after is has finished rendering.
 * It is only dispatched if the Camera is rendering to a texture.
 *
 * Listen to it from a Camera instance using: `camera.on('postrender', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#POST_RENDER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that has finished rendering to a texture.
 */ module1.exports = 'postrender';
            /***/ },
            /***/ 79330: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pre-Render Event.
 *
 * This event is dispatched by a Camera instance when it is about to render.
 * It is only dispatched if the Camera is rendering to a texture.
 *
 * Listen to it from a Camera instance using: `camera.on('prerender', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#PRE_RENDER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that is about to render to a texture.
 */ module1.exports = 'prerender';
            /***/ },
            /***/ 93183: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Rotate Complete Event.
 *
 * This event is dispatched by a Camera instance when the Rotate Effect completes.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerarotatecomplete', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.ROTATE_COMPLETE, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#ROTATE_COMPLETE
 * @type {string}
 * @since 3.23.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.RotateTo} effect - A reference to the effect instance.
 */ module1.exports = 'camerarotatecomplete';
            /***/ },
            /***/ 80112: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Rotate Start Event.
 *
 * This event is dispatched by a Camera instance when the Rotate Effect starts.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerarotatestart', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.ROTATE_START, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#ROTATE_START
 * @type {string}
 * @since 3.23.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.RotateTo} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} destination - The destination value.
 */ module1.exports = 'camerarotatestart';
            /***/ },
            /***/ 62252: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Shake Complete Event.
 *
 * This event is dispatched by a Camera instance when the Shake Effect completes.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerashakecomplete', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.SHAKE_COMPLETE, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
 */ module1.exports = 'camerashakecomplete';
            /***/ },
            /***/ 86017: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Shake Start Event.
 *
 * This event is dispatched by a Camera instance when the Shake Effect starts.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerashakestart', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.SHAKE_START, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#SHAKE_START
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} intensity - The intensity of the effect.
 */ module1.exports = 'camerashakestart';
            /***/ },
            /***/ 539: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Zoom Complete Event.
 *
 * This event is dispatched by a Camera instance when the Zoom Effect completes.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerazoomcomplete', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.ZOOM_COMPLETE, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Zoom} effect - A reference to the effect instance.
 */ module1.exports = 'camerazoomcomplete';
            /***/ },
            /***/ 51892: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Zoom Start Event.
 *
 * This event is dispatched by a Camera instance when the Zoom Effect starts.
 *
 * Listen for it via either of the following:
 *
 * ```js
 * this.cameras.main.on('camerazoomstart', () => {});
 * ```
 *
 * or use the constant, to avoid having to remember the correct event string:
 *
 * ```js
 * this.cameras.main.on(Phaser.Cameras.Scene2D.Events.ZOOM_START, () => {});
 * ```
 *
 * @event Phaser.Cameras.Scene2D.Events#ZOOM_START
 * @type {string}
 * @since 3.3.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Zoom} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} zoom - The destination zoom value.
 */ module1.exports = 'camerazoomstart';
            /***/ },
            /***/ 19715: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D.Events
 */ module1.exports = {
                    DESTROY: __webpack_require__(16438),
                    FADE_IN_COMPLETE: __webpack_require__(32726),
                    FADE_IN_START: __webpack_require__(87807),
                    FADE_OUT_COMPLETE: __webpack_require__(45917),
                    FADE_OUT_START: __webpack_require__(95666),
                    FLASH_COMPLETE: __webpack_require__(47056),
                    FLASH_START: __webpack_require__(91261),
                    FOLLOW_UPDATE: __webpack_require__(45047),
                    PAN_COMPLETE: __webpack_require__(81927),
                    PAN_START: __webpack_require__(74264),
                    POST_RENDER: __webpack_require__(54419),
                    PRE_RENDER: __webpack_require__(79330),
                    ROTATE_COMPLETE: __webpack_require__(93183),
                    ROTATE_START: __webpack_require__(80112),
                    SHAKE_COMPLETE: __webpack_require__(62252),
                    SHAKE_START: __webpack_require__(86017),
                    ZOOM_COMPLETE: __webpack_require__(539),
                    ZOOM_START: __webpack_require__(51892)
                };
            /***/ },
            /***/ 87969: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D
 */ module1.exports = {
                    Camera: __webpack_require__(38058),
                    BaseCamera: __webpack_require__(71911),
                    CameraManager: __webpack_require__(32743),
                    Effects: __webpack_require__(20052),
                    Events: __webpack_require__(19715)
                };
            /***/ },
            /***/ 63091: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetValue = __webpack_require__(35154);
                /**
 * @classdesc
 * A Fixed Key Camera Control.
 *
 * This allows you to control the movement and zoom of a camera using the defined keys.
 *
 * ```javascript
 * var camControl = new FixedKeyControl({
 *     camera: this.cameras.main,
 *     left: cursors.left,
 *     right: cursors.right,
 *     speed: float OR { x: 0, y: 0 }
 * });
 * ```
 *
 * Movement is precise and has no 'smoothing' applied to it.
 *
 * You must call the `update` method of this controller every frame.
 *
 * @class FixedKeyControl
 * @memberof Phaser.Cameras.Controls
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Cameras.Controls.FixedKeyControlConfig} config - The Fixed Key Control configuration object.
 */ var FixedKeyControl = new Class({
                    initialize: function FixedKeyControl(config) {
                        /**
         * The Camera that this Control will update.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#camera
         * @type {?Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = GetValue(config, 'camera', null);
                        /**
         * The Key to be pressed that will move the Camera left.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#left
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.left = GetValue(config, 'left', null);
                        /**
         * The Key to be pressed that will move the Camera right.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#right
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.right = GetValue(config, 'right', null);
                        /**
         * The Key to be pressed that will move the Camera up.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#up
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.up = GetValue(config, 'up', null);
                        /**
         * The Key to be pressed that will move the Camera down.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#down
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.down = GetValue(config, 'down', null);
                        /**
         * The Key to be pressed that will zoom the Camera in.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomIn
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomIn = GetValue(config, 'zoomIn', null);
                        /**
         * The Key to be pressed that will zoom the Camera out.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomOut
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomOut = GetValue(config, 'zoomOut', null);
                        /**
         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomSpeed
         * @type {number}
         * @default 0.01
         * @since 3.0.0
         */ this.zoomSpeed = GetValue(config, 'zoomSpeed', 0.01);
                        /**
         * The smallest zoom value the camera will reach when zoomed out.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#minZoom
         * @type {number}
         * @default 0.001
         * @since 3.53.0
         */ this.minZoom = GetValue(config, 'minZoom', 0.001);
                        /**
         * The largest zoom value the camera will reach when zoomed in.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#maxZoom
         * @type {number}
         * @default 1000
         * @since 3.53.0
         */ this.maxZoom = GetValue(config, 'maxZoom', 1000);
                        /**
         * The horizontal speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#speedX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speedX = 0;
                        /**
         * The vertical speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#speedY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speedY = 0;
                        var speed = GetValue(config, 'speed', null);
                        if (typeof speed === 'number') {
                            this.speedX = speed;
                            this.speedY = speed;
                        } else {
                            this.speedX = GetValue(config, 'speed.x', 0);
                            this.speedY = GetValue(config, 'speed.y', 0);
                        }
                        /**
         * Internal property to track the current zoom level.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#_zoom
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._zoom = 0;
                        /**
         * A flag controlling if the Controls will update the Camera or not.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = this.camera !== null;
                    },
                    /**
     * Starts the Key Control running, providing it has been linked to a camera.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#start
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ start: function() {
                        this.active = this.camera !== null;
                        return this;
                    },
                    /**
     * Stops this Key Control from running. Call `start` to start it again.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#stop
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ stop: function() {
                        this.active = false;
                        return this;
                    },
                    /**
     * Binds this Key Control to a camera.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#setCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
     *
     * @return {this} This Key Control instance.
     */ setCamera: function(camera) {
                        this.camera = camera;
                        return this;
                    },
                    /**
     * Applies the results of pressing the control keys to the Camera.
     *
     * You must call this every step, it is not called automatically.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(delta) {
                        if (!this.active) return;
                        if (delta === undefined) delta = 1;
                        var cam = this.camera;
                        if (this.up && this.up.isDown) cam.scrollY -= this.speedY * delta | 0;
                        else if (this.down && this.down.isDown) cam.scrollY += this.speedY * delta | 0;
                        if (this.left && this.left.isDown) cam.scrollX -= this.speedX * delta | 0;
                        else if (this.right && this.right.isDown) cam.scrollX += this.speedX * delta | 0;
                        //  Camera zoom
                        if (this.zoomIn && this.zoomIn.isDown) {
                            cam.zoom -= this.zoomSpeed;
                            if (cam.zoom < this.minZoom) cam.zoom = this.minZoom;
                        } else if (this.zoomOut && this.zoomOut.isDown) {
                            cam.zoom += this.zoomSpeed;
                            if (cam.zoom > this.maxZoom) cam.zoom = this.maxZoom;
                        }
                    },
                    /**
     * Destroys this Key Control.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.camera = null;
                        this.left = null;
                        this.right = null;
                        this.up = null;
                        this.down = null;
                        this.zoomIn = null;
                        this.zoomOut = null;
                    }
                });
                module1.exports = FixedKeyControl;
            /***/ },
            /***/ 58818: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetValue = __webpack_require__(35154);
                /**
 * @classdesc
 * A Smoothed Key Camera Control.
 *
 * This allows you to control the movement and zoom of a camera using the defined keys.
 * Unlike the Fixed Camera Control you can also provide physics values for acceleration, drag and maxSpeed for smoothing effects.
 *
 * ```javascript
 * var controlConfig = {
 *     camera: this.cameras.main,
 *     left: cursors.left,
 *     right: cursors.right,
 *     up: cursors.up,
 *     down: cursors.down,
 *     zoomIn: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.Q),
 *     zoomOut: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.E),
 *     zoomSpeed: 0.02,
 *     acceleration: 0.06,
 *     drag: 0.0005,
 *     maxSpeed: 1.0
 * };
 * ```
 *
 * You must call the `update` method of this controller every frame.
 *
 * @class SmoothedKeyControl
 * @memberof Phaser.Cameras.Controls
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Cameras.Controls.SmoothedKeyControlConfig} config - The Smoothed Key Control configuration object.
 */ var SmoothedKeyControl = new Class({
                    initialize: function SmoothedKeyControl(config) {
                        /**
         * The Camera that this Control will update.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#camera
         * @type {?Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = GetValue(config, 'camera', null);
                        /**
         * The Key to be pressed that will move the Camera left.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#left
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.left = GetValue(config, 'left', null);
                        /**
         * The Key to be pressed that will move the Camera right.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#right
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.right = GetValue(config, 'right', null);
                        /**
         * The Key to be pressed that will move the Camera up.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#up
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.up = GetValue(config, 'up', null);
                        /**
         * The Key to be pressed that will move the Camera down.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#down
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.down = GetValue(config, 'down', null);
                        /**
         * The Key to be pressed that will zoom the Camera in.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomIn
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomIn = GetValue(config, 'zoomIn', null);
                        /**
         * The Key to be pressed that will zoom the Camera out.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomOut
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomOut = GetValue(config, 'zoomOut', null);
                        /**
         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomSpeed
         * @type {number}
         * @default 0.01
         * @since 3.0.0
         */ this.zoomSpeed = GetValue(config, 'zoomSpeed', 0.01);
                        /**
         * The smallest zoom value the camera will reach when zoomed out.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#minZoom
         * @type {number}
         * @default 0.001
         * @since 3.53.0
         */ this.minZoom = GetValue(config, 'minZoom', 0.001);
                        /**
         * The largest zoom value the camera will reach when zoomed in.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxZoom
         * @type {number}
         * @default 1000
         * @since 3.53.0
         */ this.maxZoom = GetValue(config, 'maxZoom', 1000);
                        /**
         * The horizontal acceleration the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelX = 0;
                        /**
         * The vertical acceleration the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelY = 0;
                        var accel = GetValue(config, 'acceleration', null);
                        if (typeof accel === 'number') {
                            this.accelX = accel;
                            this.accelY = accel;
                        } else {
                            this.accelX = GetValue(config, 'acceleration.x', 0);
                            this.accelY = GetValue(config, 'acceleration.y', 0);
                        }
                        /**
         * The horizontal drag applied to the camera when it is moving.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragX = 0;
                        /**
         * The vertical drag applied to the camera when it is moving.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragY = 0;
                        var drag = GetValue(config, 'drag', null);
                        if (typeof drag === 'number') {
                            this.dragX = drag;
                            this.dragY = drag;
                        } else {
                            this.dragX = GetValue(config, 'drag.x', 0);
                            this.dragY = GetValue(config, 'drag.y', 0);
                        }
                        /**
         * The maximum horizontal speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxSpeedX = 0;
                        /**
         * The maximum vertical speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxSpeedY = 0;
                        var maxSpeed = GetValue(config, 'maxSpeed', null);
                        if (typeof maxSpeed === 'number') {
                            this.maxSpeedX = maxSpeed;
                            this.maxSpeedY = maxSpeed;
                        } else {
                            this.maxSpeedX = GetValue(config, 'maxSpeed.x', 0);
                            this.maxSpeedY = GetValue(config, 'maxSpeed.y', 0);
                        }
                        /**
         * Internal property to track the speed of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedX
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._speedX = 0;
                        /**
         * Internal property to track the speed of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedY
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._speedY = 0;
                        /**
         * Internal property to track the zoom of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_zoom
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._zoom = 0;
                        /**
         * A flag controlling if the Controls will update the Camera or not.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = this.camera !== null;
                    },
                    /**
     * Starts the Key Control running, providing it has been linked to a camera.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#start
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ start: function() {
                        this.active = this.camera !== null;
                        return this;
                    },
                    /**
     * Stops this Key Control from running. Call `start` to start it again.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#stop
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ stop: function() {
                        this.active = false;
                        return this;
                    },
                    /**
     * Binds this Key Control to a camera.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#setCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
     *
     * @return {this} This Key Control instance.
     */ setCamera: function(camera) {
                        this.camera = camera;
                        return this;
                    },
                    /**
     * Applies the results of pressing the control keys to the Camera.
     *
     * You must call this every step, it is not called automatically.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(delta) {
                        if (!this.active) return;
                        if (delta === undefined) delta = 1;
                        var cam = this.camera;
                        //  Apply Deceleration
                        if (this._speedX > 0) {
                            this._speedX -= this.dragX * delta;
                            if (this._speedX < 0) this._speedX = 0;
                        } else if (this._speedX < 0) {
                            this._speedX += this.dragX * delta;
                            if (this._speedX > 0) this._speedX = 0;
                        }
                        if (this._speedY > 0) {
                            this._speedY -= this.dragY * delta;
                            if (this._speedY < 0) this._speedY = 0;
                        } else if (this._speedY < 0) {
                            this._speedY += this.dragY * delta;
                            if (this._speedY > 0) this._speedY = 0;
                        }
                        //  Check for keys
                        if (this.up && this.up.isDown) {
                            this._speedY += this.accelY;
                            if (this._speedY > this.maxSpeedY) this._speedY = this.maxSpeedY;
                        } else if (this.down && this.down.isDown) {
                            this._speedY -= this.accelY;
                            if (this._speedY < -this.maxSpeedY) this._speedY = -this.maxSpeedY;
                        }
                        if (this.left && this.left.isDown) {
                            this._speedX += this.accelX;
                            if (this._speedX > this.maxSpeedX) this._speedX = this.maxSpeedX;
                        } else if (this.right && this.right.isDown) {
                            this._speedX -= this.accelX;
                            if (this._speedX < -this.maxSpeedX) this._speedX = -this.maxSpeedX;
                        }
                        //  Camera zoom
                        if (this.zoomIn && this.zoomIn.isDown) this._zoom = -this.zoomSpeed;
                        else if (this.zoomOut && this.zoomOut.isDown) this._zoom = this.zoomSpeed;
                        else this._zoom = 0;
                        //  Apply to Camera
                        if (this._speedX !== 0) cam.scrollX -= this._speedX * delta | 0;
                        if (this._speedY !== 0) cam.scrollY -= this._speedY * delta | 0;
                        if (this._zoom !== 0) {
                            cam.zoom += this._zoom;
                            if (cam.zoom < this.minZoom) cam.zoom = this.minZoom;
                            else if (cam.zoom > this.maxZoom) cam.zoom = this.maxZoom;
                        }
                    },
                    /**
     * Destroys this Key Control.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.camera = null;
                        this.left = null;
                        this.right = null;
                        this.up = null;
                        this.down = null;
                        this.zoomIn = null;
                        this.zoomOut = null;
                    }
                });
                module1.exports = SmoothedKeyControl;
            /***/ },
            /***/ 38865: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Controls
 */ module1.exports = {
                    FixedKeyControl: __webpack_require__(63091),
                    SmoothedKeyControl: __webpack_require__(58818)
                };
            /***/ },
            /***/ 26638: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras
 */ /**
 * @namespace Phaser.Types.Cameras
 */ module1.exports = {
                    Controls: __webpack_require__(38865),
                    Scene2D: __webpack_require__(87969)
                };
            /***/ },
            /***/ 8054: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Global constants.
 *
 * @ignore
 */ var CONST = {
                    /**
     * Phaser Release Version
     *
     * @name Phaser.VERSION
     * @const
     * @type {string}
     * @since 3.0.0
     */ VERSION: '3.88.2',
                    /**
     * Phaser Release Version as displayed in the console.log header URL.
     *
     * @name Phaser.LOG_VERSION
     * @const
     * @type {string}
     * @since 3.87.0
     */ LOG_VERSION: 'v388',
                    BlendModes: __webpack_require__(10312),
                    ScaleModes: __webpack_require__(29795),
                    /**
     * This setting will auto-detect if the browser is capable of suppporting WebGL.
     * If it is, it will use the WebGL Renderer. If not, it will fall back to the Canvas Renderer.
     *
     * @name Phaser.AUTO
     * @const
     * @type {number}
     * @since 3.0.0
     */ AUTO: 0,
                    /**
     * Forces Phaser to only use the Canvas Renderer, regardless if the browser supports
     * WebGL or not.
     *
     * @name Phaser.CANVAS
     * @const
     * @type {number}
     * @since 3.0.0
     */ CANVAS: 1,
                    /**
     * Forces Phaser to use the WebGL Renderer. If the browser does not support it, there is
     * no fallback to Canvas with this setting, so you should trap it and display a suitable
     * message to the user.
     *
     * @name Phaser.WEBGL
     * @const
     * @type {number}
     * @since 3.0.0
     */ WEBGL: 2,
                    /**
     * A Headless Renderer doesn't create either a Canvas or WebGL Renderer. However, it still
     * absolutely relies on the DOM being present and available. This mode is meant for unit testing,
     * not for running Phaser on the server, which is something you really shouldn't do.
     *
     * @name Phaser.HEADLESS
     * @const
     * @type {number}
     * @since 3.0.0
     */ HEADLESS: 3,
                    /**
     * In Phaser the value -1 means 'forever' in lots of cases, this const allows you to use it instead
     * to help you remember what the value is doing in your code.
     *
     * @name Phaser.FOREVER
     * @const
     * @type {number}
     * @since 3.0.0
     */ FOREVER: -1,
                    /**
     * Direction constant.
     *
     * @name Phaser.NONE
     * @const
     * @type {number}
     * @since 3.0.0
     */ NONE: 4,
                    /**
     * Direction constant.
     *
     * @name Phaser.UP
     * @const
     * @type {number}
     * @since 3.0.0
     */ UP: 5,
                    /**
     * Direction constant.
     *
     * @name Phaser.DOWN
     * @const
     * @type {number}
     * @since 3.0.0
     */ DOWN: 6,
                    /**
     * Direction constant.
     *
     * @name Phaser.LEFT
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT: 7,
                    /**
     * Direction constant.
     *
     * @name Phaser.RIGHT
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 8
                };
                module1.exports = CONST;
            /***/ },
            /***/ 69547: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(8054);
                var DefaultPlugins = __webpack_require__(42363);
                var Device = __webpack_require__(82264);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var IsPlainObject = __webpack_require__(41212);
                var NOOP = __webpack_require__(29747);
                var PhaserMath = __webpack_require__(75508);
                var PIPELINE_CONST = __webpack_require__(36060);
                var ValueToColor = __webpack_require__(80333);
                /**
 * @classdesc
 * The active game configuration settings, parsed from a {@link Phaser.Types.Core.GameConfig} object.
 *
 * @class Config
 * @memberof Phaser.Core
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Core.GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
 *
 * @see Phaser.Game#config
 */ var Config = new Class({
                    initialize: function Config(config) {
                        if (config === undefined) config = {};
                        var defaultBannerColor = [
                            '#ff0000',
                            '#ffff00',
                            '#00ff00',
                            '#00ffff',
                            '#000000'
                        ];
                        var defaultBannerTextColor = '#ffffff';
                        //  Scale Manager - Anything set in here over-rides anything set in the core game config
                        var scaleConfig = GetValue(config, 'scale', null);
                        /**
         * @const {(number|string)} Phaser.Core.Config#width - The width of the underlying canvas, in pixels.
         */ this.width = GetValue(scaleConfig, 'width', 1024, config);
                        /**
         * @const {(number|string)} Phaser.Core.Config#height - The height of the underlying canvas, in pixels.
         */ this.height = GetValue(scaleConfig, 'height', 768, config);
                        /**
         * @const {(Phaser.Scale.ZoomType|number)} Phaser.Core.Config#zoom - The zoom factor, as used by the Scale Manager.
         */ this.zoom = GetValue(scaleConfig, 'zoom', 1, config);
                        /**
         * @const {?*} Phaser.Core.Config#parent - A parent DOM element into which the canvas created by the renderer will be injected.
         */ this.parent = GetValue(scaleConfig, 'parent', undefined, config);
                        /**
         * @const {Phaser.Scale.ScaleModeType} Phaser.Core.Config#scaleMode - The scale mode as used by the Scale Manager. The default is zero, which is no scaling.
         */ this.scaleMode = GetValue(scaleConfig, scaleConfig ? 'mode' : 'scaleMode', 0, config);
                        /**
         * @const {boolean} Phaser.Core.Config#expandParent - Is the Scale Manager allowed to adjust the CSS height property of the parent to be 100%?
         */ this.expandParent = GetValue(scaleConfig, 'expandParent', true, config);
                        /**
         * @const {boolean} Phaser.Core.Config#autoRound - Automatically round the display and style sizes of the canvas. This can help with performance in lower-powered devices.
         */ this.autoRound = GetValue(scaleConfig, 'autoRound', false, config);
                        /**
         * @const {Phaser.Scale.CenterType} Phaser.Core.Config#autoCenter - Automatically center the canvas within the parent?
         */ this.autoCenter = GetValue(scaleConfig, 'autoCenter', 0, config);
                        /**
         * @const {number} Phaser.Core.Config#resizeInterval - How many ms should elapse before checking if the browser size has changed?
         */ this.resizeInterval = GetValue(scaleConfig, 'resizeInterval', 500, config);
                        /**
         * @const {?(HTMLElement|string)} Phaser.Core.Config#fullscreenTarget - The DOM element that will be sent into full screen mode, or its `id`. If undefined Phaser will create its own div and insert the canvas into it when entering fullscreen mode.
         */ this.fullscreenTarget = GetValue(scaleConfig, 'fullscreenTarget', null, config);
                        /**
         * @const {number} Phaser.Core.Config#minWidth - The minimum width, in pixels, the canvas will scale down to. A value of zero means no minimum.
         */ this.minWidth = GetValue(scaleConfig, 'min.width', 0, config);
                        /**
         * @const {number} Phaser.Core.Config#maxWidth - The maximum width, in pixels, the canvas will scale up to. A value of zero means no maximum.
         */ this.maxWidth = GetValue(scaleConfig, 'max.width', 0, config);
                        /**
         * @const {number} Phaser.Core.Config#minHeight - The minimum height, in pixels, the canvas will scale down to. A value of zero means no minimum.
         */ this.minHeight = GetValue(scaleConfig, 'min.height', 0, config);
                        /**
         * @const {number} Phaser.Core.Config#maxHeight - The maximum height, in pixels, the canvas will scale up to. A value of zero means no maximum.
         */ this.maxHeight = GetValue(scaleConfig, 'max.height', 0, config);
                        /**
         * @const {number} Phaser.Core.Config#snapWidth - The horizontal amount to snap the canvas by when the Scale Manager is resizing. A value of zero means no snapping.
         */ this.snapWidth = GetValue(scaleConfig, 'snap.width', 0, config);
                        /**
         * @const {number} Phaser.Core.Config#snapHeight - The vertical amount to snap the canvas by when the Scale Manager is resizing. A value of zero means no snapping.
         */ this.snapHeight = GetValue(scaleConfig, 'snap.height', 0, config);
                        /**
         * @const {number} Phaser.Core.Config#renderType - Force Phaser to use a specific renderer. Can be `CONST.CANVAS`, `CONST.WEBGL`, `CONST.HEADLESS` or `CONST.AUTO` (default)
         */ this.renderType = GetValue(config, 'type', CONST.AUTO);
                        /**
         * @const {?HTMLCanvasElement} Phaser.Core.Config#canvas - Force Phaser to use your own Canvas element instead of creating one.
         */ this.canvas = GetValue(config, 'canvas', null);
                        /**
         * @const {?(CanvasRenderingContext2D|WebGLRenderingContext)} Phaser.Core.Config#context - Force Phaser to use your own Canvas context instead of creating one.
         */ this.context = GetValue(config, 'context', null);
                        /**
         * @const {?string} Phaser.Core.Config#canvasStyle - Optional CSS attributes to be set on the canvas object created by the renderer.
         */ this.canvasStyle = GetValue(config, 'canvasStyle', null);
                        /**
         * @const {boolean} Phaser.Core.Config#customEnvironment - Is Phaser running under a custom (non-native web) environment? If so, set this to `true` to skip internal Feature detection. If `true` the `renderType` cannot be left as `AUTO`.
         */ this.customEnvironment = GetValue(config, 'customEnvironment', false);
                        /**
         * @const {?object} Phaser.Core.Config#sceneConfig - The default Scene configuration object.
         */ this.sceneConfig = GetValue(config, 'scene', null);
                        /**
         * @const {string[]} Phaser.Core.Config#seed - A seed which the Random Data Generator will use. If not given, a dynamic seed based on the time is used.
         */ this.seed = GetValue(config, 'seed', [
                            (Date.now() * Math.random()).toString()
                        ]);
                        PhaserMath.RND = new PhaserMath.RandomDataGenerator(this.seed);
                        /**
         * @const {string} Phaser.Core.Config#gameTitle - The title of the game.
         */ this.gameTitle = GetValue(config, 'title', '');
                        /**
         * @const {string} Phaser.Core.Config#gameURL - The URL of the game.
         */ this.gameURL = GetValue(config, 'url', 'https://phaser.io/' + CONST.LOG_VERSION);
                        /**
         * @const {string} Phaser.Core.Config#gameVersion - The version of the game.
         */ this.gameVersion = GetValue(config, 'version', '');
                        /**
         * @const {boolean} Phaser.Core.Config#autoFocus - If `true` the window will automatically be given focus immediately and on any future mousedown event.
         */ this.autoFocus = GetValue(config, 'autoFocus', true);
                        /**
         * @const {(number|boolean)} Phaser.Core.Config#stableSort - `false` or `0` = Use the built-in StableSort (needed for older browsers), `true` or `1` = Rely on ES2019 Array.sort being stable (modern browsers only), or `-1` = Try and determine this automatically based on browser inspection (not guaranteed to work, errs on side of caution).
         */ this.stableSort = GetValue(config, 'stableSort', -1);
                        if (this.stableSort === -1) this.stableSort = Device.browser.es2019 ? 1 : 0;
                        Device.features.stableSort = this.stableSort;
                        //  DOM Element Container
                        /**
         * @const {?boolean} Phaser.Core.Config#domCreateContainer - Should the game create a div element to act as a DOM Container? Only enable if you're using DOM Element objects. You must provide a parent object if you use this feature.
         */ this.domCreateContainer = GetValue(config, 'dom.createContainer', false);
                        /**
         * @const {?string} Phaser.Core.Config#domPointerEvents - The default `pointerEvents` attribute set on the DOM Container.
         */ this.domPointerEvents = GetValue(config, 'dom.pointerEvents', 'none');
                        //  Input
                        /**
         * @const {boolean} Phaser.Core.Config#inputKeyboard - Enable the Keyboard Plugin. This can be disabled in games that don't need keyboard input.
         */ this.inputKeyboard = GetValue(config, 'input.keyboard', true);
                        /**
         * @const {*} Phaser.Core.Config#inputKeyboardEventTarget - The DOM Target to listen for keyboard events on. Defaults to `window` if not specified.
         */ this.inputKeyboardEventTarget = GetValue(config, 'input.keyboard.target', window);
                        /**
         * @const {?number[]} Phaser.Core.Config#inputKeyboardCapture - `preventDefault` will be called on every non-modified key which has a key code in this array. By default, it is empty.
         */ this.inputKeyboardCapture = GetValue(config, 'input.keyboard.capture', []);
                        /**
         * @const {(boolean|object)} Phaser.Core.Config#inputMouse - Enable the Mouse Plugin. This can be disabled in games that don't need mouse input.
         */ this.inputMouse = GetValue(config, 'input.mouse', true);
                        /**
         * @const {?*} Phaser.Core.Config#inputMouseEventTarget - The DOM Target to listen for mouse events on. Defaults to the game canvas if not specified.
         */ this.inputMouseEventTarget = GetValue(config, 'input.mouse.target', null);
                        /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultDown - Should `mousedown` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultDown = GetValue(config, 'input.mouse.preventDefaultDown', true);
                        /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultUp - Should `mouseup` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultUp = GetValue(config, 'input.mouse.preventDefaultUp', true);
                        /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultMove - Should `mousemove` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultMove = GetValue(config, 'input.mouse.preventDefaultMove', true);
                        /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultWheel - Should `wheel` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultWheel = GetValue(config, 'input.mouse.preventDefaultWheel', true);
                        /**
         * @const {boolean} Phaser.Core.Config#inputTouch - Enable the Touch Plugin. This can be disabled in games that don't need touch input.
         */ this.inputTouch = GetValue(config, 'input.touch', Device.input.touch);
                        /**
         * @const {?*} Phaser.Core.Config#inputTouchEventTarget - The DOM Target to listen for touch events on. Defaults to the game canvas if not specified.
         */ this.inputTouchEventTarget = GetValue(config, 'input.touch.target', null);
                        /**
         * @const {boolean} Phaser.Core.Config#inputTouchCapture - Should touch events be captured? I.e. have prevent default called on them.
         */ this.inputTouchCapture = GetValue(config, 'input.touch.capture', true);
                        /**
         * @const {number} Phaser.Core.Config#inputActivePointers - The number of Pointer objects created by default. In a mouse-only, or non-multi touch game, you can leave this as 1.
         */ this.inputActivePointers = GetValue(config, 'input.activePointers', 1);
                        /**
         * @const {number} Phaser.Core.Config#inputSmoothFactor - The smoothing factor to apply during Pointer movement. See {@link Phaser.Input.Pointer#smoothFactor}.
         */ this.inputSmoothFactor = GetValue(config, 'input.smoothFactor', 0);
                        /**
         * @const {boolean} Phaser.Core.Config#inputWindowEvents - Should Phaser listen for input events on the Window? If you disable this, events like 'POINTER_UP_OUTSIDE' will no longer fire.
         */ this.inputWindowEvents = GetValue(config, 'input.windowEvents', true);
                        /**
         * @const {boolean} Phaser.Core.Config#inputGamepad - Enable the Gamepad Plugin. This can be disabled in games that don't need gamepad input.
         */ this.inputGamepad = GetValue(config, 'input.gamepad', false);
                        /**
         * @const {*} Phaser.Core.Config#inputGamepadEventTarget - The DOM Target to listen for gamepad events on. Defaults to `window` if not specified.
         */ this.inputGamepadEventTarget = GetValue(config, 'input.gamepad.target', window);
                        /**
         * @const {boolean} Phaser.Core.Config#disableContextMenu - Set to `true` to disable the right-click context menu.
         */ this.disableContextMenu = GetValue(config, 'disableContextMenu', false);
                        /**
         * @const {Phaser.Types.Core.AudioConfig} Phaser.Core.Config#audio - The Audio Configuration object.
         */ this.audio = GetValue(config, 'audio', {});
                        //  If you do: { banner: false } it won't display any banner at all
                        /**
         * @const {boolean} Phaser.Core.Config#hideBanner - Don't write the banner line to the console.log. See `Phaser.Types.Core.BannerConfig` for details of this object.
         */ this.hideBanner = GetValue(config, 'banner', null) === false;
                        /**
         * @const {boolean} Phaser.Core.Config#hidePhaser - Omit Phaser's name and version from the banner.
         */ this.hidePhaser = GetValue(config, 'banner.hidePhaser', false);
                        /**
         * @const {string} Phaser.Core.Config#bannerTextColor - The color of the banner text.
         */ this.bannerTextColor = GetValue(config, 'banner.text', defaultBannerTextColor);
                        /**
         * @const {string[]} Phaser.Core.Config#bannerBackgroundColor - The background colors of the banner.
         */ this.bannerBackgroundColor = GetValue(config, 'banner.background', defaultBannerColor);
                        if (this.gameTitle === '' && this.hidePhaser) this.hideBanner = true;
                        /**
         * @const {Phaser.Types.Core.FPSConfig} Phaser.Core.Config#fps - The Frame Rate Configuration object, as parsed by the Timestep class.
         */ this.fps = GetValue(config, 'fps', null);
                        /**
         * @const {boolean} Phaser.Core.Config#disablePreFX - Disables the automatic creation of the Pre FX Pipelines. If disabled, you cannot use the built-in Pre FX on Game Objects.
         */ this.disablePreFX = GetValue(config, 'disablePreFX', false);
                        /**
         * @const {boolean} Phaser.Core.Config#disablePostFX - Disables the automatic creation of the Post FX Pipelines. If disabled, you cannot use the built-in Post FX on Game Objects.
         */ this.disablePostFX = GetValue(config, 'disablePostFX', false);
                        //  Render Settings - Anything set in here over-rides anything set in the core game config
                        var renderConfig = GetValue(config, 'render', null);
                        /**
         * @const {Phaser.Types.Core.PipelineConfig} Phaser.Core.Config#pipeline - An object mapping WebGL names to WebGLPipeline classes. These should be class constructors, not instances.
         */ this.pipeline = GetValue(renderConfig, 'pipeline', null, config);
                        /**
         * @const {boolean} Phaser.Core.Config#autoMobilePipeline - Automatically enable the Mobile Pipeline if iOS or Android detected?
         */ this.autoMobilePipeline = GetValue(renderConfig, 'autoMobilePipeline', true, config);
                        /**
         * @const {string} Phaser.Core.Config#defaultPipeline - The WebGL Pipeline that Game Objects will use by default. Set to 'MultiPipeline' as standard. See also 'autoMobilePipeline'.
         */ this.defaultPipeline = GetValue(renderConfig, 'defaultPipeline', PIPELINE_CONST.MULTI_PIPELINE, config);
                        /**
         * @const {boolean} Phaser.Core.Config#antialias - When set to `true`, WebGL uses linear interpolation to draw scaled or rotated textures, giving a smooth appearance. When set to `false`, WebGL uses nearest-neighbor interpolation, giving a crisper appearance. `false` also disables antialiasing of the game canvas itself, if the browser supports it, when the game canvas is scaled.
         */ this.antialias = GetValue(renderConfig, 'antialias', true, config);
                        /**
         * @const {boolean} Phaser.Core.Config#antialiasGL - Sets the `antialias` property when the WebGL context is created. Setting this value does not impact any subsequent textures that are created, or the canvas style attributes.
         */ this.antialiasGL = GetValue(renderConfig, 'antialiasGL', true, config);
                        /**
         * @const {string} Phaser.Core.Config#mipmapFilter - Sets the mipmap magFilter to be used when creating WebGL textures. Don't set unless you wish to create mipmaps. Set to one of the following: 'NEAREST', 'LINEAR', 'NEAREST_MIPMAP_NEAREST', 'LINEAR_MIPMAP_NEAREST', 'NEAREST_MIPMAP_LINEAR' or 'LINEAR_MIPMAP_LINEAR'.
         */ this.mipmapFilter = GetValue(renderConfig, 'mipmapFilter', '', config);
                        /**
         * @const {boolean} Phaser.Core.Config#desynchronized - When set to `true` it will create a desynchronized context for both 2D and WebGL. See https://developers.google.com/web/updates/2019/05/desynchronized for details.
         */ this.desynchronized = GetValue(renderConfig, 'desynchronized', false, config);
                        /**
         * @const {boolean} Phaser.Core.Config#roundPixels - Draw texture-based Game Objects at only whole-integer positions. Game Objects without textures, like Graphics, ignore this property.
         */ this.roundPixels = GetValue(renderConfig, 'roundPixels', false, config);
                        /**
         * @const {boolean} Phaser.Core.Config#pixelArt - Prevent pixel art from becoming blurred when scaled. It will remain crisp (tells the WebGL renderer to automatically create textures using a linear filter mode).
         */ this.pixelArt = GetValue(renderConfig, 'pixelArt', this.zoom !== 1, config);
                        if (this.pixelArt) {
                            this.antialias = false;
                            this.antialiasGL = false;
                            this.roundPixels = true;
                        }
                        /**
         * @const {boolean} Phaser.Core.Config#transparent - Whether the game canvas will have a transparent background.
         */ this.transparent = GetValue(renderConfig, 'transparent', false, config);
                        /**
         * @const {boolean} Phaser.Core.Config#clearBeforeRender - Whether the game canvas will be cleared between each rendering frame. You can disable this if you have a full-screen background image or game object.
         */ this.clearBeforeRender = GetValue(renderConfig, 'clearBeforeRender', true, config);
                        /**
         * @const {boolean} Phaser.Core.Config#preserveDrawingBuffer - If the value is true the WebGL buffers will not be cleared and will preserve their values until cleared or overwritten by the author.
         */ this.preserveDrawingBuffer = GetValue(renderConfig, 'preserveDrawingBuffer', false, config);
                        /**
         * @const {boolean} Phaser.Core.Config#premultipliedAlpha - In WebGL mode, sets the drawing buffer to contain colors with pre-multiplied alpha.
         */ this.premultipliedAlpha = GetValue(renderConfig, 'premultipliedAlpha', true, config);
                        /**
         * @const {boolean} Phaser.Core.Config#failIfMajorPerformanceCaveat - Let the browser abort creating a WebGL context if it judges performance would be unacceptable.
         */ this.failIfMajorPerformanceCaveat = GetValue(renderConfig, 'failIfMajorPerformanceCaveat', false, config);
                        /**
         * @const {string} Phaser.Core.Config#powerPreference - "high-performance", "low-power" or "default". A hint to the browser on how much device power the game might use.
         */ this.powerPreference = GetValue(renderConfig, 'powerPreference', 'default', config);
                        /**
         * @const {number} Phaser.Core.Config#batchSize - The default WebGL Batch size. Represents the number of _quads_ that can be added to a single batch.
         */ this.batchSize = GetValue(renderConfig, 'batchSize', 4096, config);
                        /**
         * @const {number} Phaser.Core.Config#maxTextures - When in WebGL mode, this sets the maximum number of GPU Textures to use. The default, -1, will use all available units. The WebGL1 spec says all browsers should provide a minimum of 8.
         */ this.maxTextures = GetValue(renderConfig, 'maxTextures', -1, config);
                        /**
         * @const {number} Phaser.Core.Config#maxLights - The maximum number of lights allowed to be visible within range of a single Camera in the LightManager.
         */ this.maxLights = GetValue(renderConfig, 'maxLights', 10, config);
                        var bgc = GetValue(config, 'backgroundColor', 0);
                        /**
         * @const {Phaser.Display.Color} Phaser.Core.Config#backgroundColor - The background color of the game canvas. The default is black. This value is ignored if `transparent` is set to `true`.
         */ this.backgroundColor = ValueToColor(bgc);
                        if (this.transparent) {
                            this.backgroundColor = ValueToColor(0x000000);
                            this.backgroundColor.alpha = 0;
                        }
                        /**
         * @const {Phaser.Types.Core.BootCallback} Phaser.Core.Config#preBoot - Called before Phaser boots. Useful for initializing anything not related to Phaser that Phaser may require while booting.
         */ this.preBoot = GetValue(config, 'callbacks.preBoot', NOOP);
                        /**
         * @const {Phaser.Types.Core.BootCallback} Phaser.Core.Config#postBoot - A function to run at the end of the boot sequence. At this point, all the game systems have started and plugins have been loaded.
         */ this.postBoot = GetValue(config, 'callbacks.postBoot', NOOP);
                        /**
         * @const {Phaser.Types.Core.PhysicsConfig} Phaser.Core.Config#physics - The Physics Configuration object.
         */ this.physics = GetValue(config, 'physics', {});
                        /**
         * @const {(boolean|string)} Phaser.Core.Config#defaultPhysicsSystem - The default physics system. It will be started for each scene. Either 'arcade', 'impact' or 'matter'.
         */ this.defaultPhysicsSystem = GetValue(this.physics, 'default', false);
                        /**
         * @const {string} Phaser.Core.Config#loaderBaseURL - A URL used to resolve paths given to the loader. Example: 'http://labs.phaser.io/assets/'.
         */ this.loaderBaseURL = GetValue(config, 'loader.baseURL', '');
                        /**
         * @const {string} Phaser.Core.Config#loaderPath - A URL path used to resolve relative paths given to the loader. Example: 'images/sprites/'.
         */ this.loaderPath = GetValue(config, 'loader.path', '');
                        /**
         * @const {number} Phaser.Core.Config#loaderMaxParallelDownloads - Maximum parallel downloads allowed for resources (Default to 32).
         */ this.loaderMaxParallelDownloads = GetValue(config, 'loader.maxParallelDownloads', Device.os.android ? 6 : 32);
                        /**
         * @const {(string|undefined)} Phaser.Core.Config#loaderCrossOrigin - 'anonymous', 'use-credentials', or `undefined`. If you're not making cross-origin requests, leave this as `undefined`. See {@link https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes}.
         */ this.loaderCrossOrigin = GetValue(config, 'loader.crossOrigin', undefined);
                        /**
         * @const {string} Phaser.Core.Config#loaderResponseType - The response type of the XHR request, e.g. `blob`, `text`, etc.
         */ this.loaderResponseType = GetValue(config, 'loader.responseType', '');
                        /**
         * @const {boolean} Phaser.Core.Config#loaderAsync - Should the XHR request use async or not?
         */ this.loaderAsync = GetValue(config, 'loader.async', true);
                        /**
         * @const {string} Phaser.Core.Config#loaderUser - Optional username for all XHR requests.
         */ this.loaderUser = GetValue(config, 'loader.user', '');
                        /**
         * @const {string} Phaser.Core.Config#loaderPassword - Optional password for all XHR requests.
         */ this.loaderPassword = GetValue(config, 'loader.password', '');
                        /**
         * @const {number} Phaser.Core.Config#loaderTimeout - Optional XHR timeout value, in ms.
         */ this.loaderTimeout = GetValue(config, 'loader.timeout', 0);
                        /**
         * @const {number} Phaser.Core.Config#loaderMaxRetries - The number of times to retry a file load if it fails.
         */ this.loaderMaxRetries = GetValue(config, 'loader.maxRetries', 2);
                        /**
         * @const {boolean} Phaser.Core.Config#loaderWithCredentials - Optional XHR withCredentials value.
         */ this.loaderWithCredentials = GetValue(config, 'loader.withCredentials', false);
                        /**
         * @const {string} Phaser.Core.Config#loaderImageLoadType - Optional load type for image, `XHR` is default, or `HTMLImageElement` for a lightweight way.
         */ this.loaderImageLoadType = GetValue(config, 'loader.imageLoadType', 'XHR');
                        // On iOS, Capacitor often runs on a capacitor:// protocol, meaning local files are served from capacitor:// rather than file://
                        // See: https://github.com/photonstorm/phaser/issues/5685
                        /**
         * @const {string[]} Phaser.Core.Config#loaderLocalScheme - An array of schemes that the Loader considers as being 'local' files. Defaults to: `[ 'file://', 'capacitor://' ]`.
         */ this.loaderLocalScheme = GetValue(config, 'loader.localScheme', [
                            'file://',
                            'capacitor://'
                        ]);
                        /**
         * @const {number} Phaser.Core.Config#glowFXQuality - The quality of the Glow FX (defaults to 0.1)
         */ this.glowFXQuality = GetValue(config, 'fx.glow.quality', 0.1);
                        /**
         * @const {number} Phaser.Core.Config#glowFXDistance - The distance of the Glow FX (defaults to 10)
         */ this.glowFXDistance = GetValue(config, 'fx.glow.distance', 10);
                        /*
         * Allows `plugins` property to either be an array, in which case it just replaces
         * the default plugins like previously, or a config object.
         *
         * plugins: {
         *    global: [
         *        { key: 'TestPlugin', plugin: TestPlugin, start: true, data: { msg: 'The plugin is alive' } },
         *    ],
         *    scene: [
         *        { key: 'WireFramePlugin', plugin: WireFramePlugin, systemKey: 'wireFramePlugin', sceneKey: 'wireframe' }
         *    ],
         *    default: [], OR
         *    defaultMerge: [
         *        'ModPlayer'
         *    ]
         * }
         */ /**
         * @const {any} Phaser.Core.Config#installGlobalPlugins - An array of global plugins to be installed.
         */ this.installGlobalPlugins = [];
                        /**
         * @const {any} Phaser.Core.Config#installScenePlugins - An array of Scene level plugins to be installed.
         */ this.installScenePlugins = [];
                        var plugins = GetValue(config, 'plugins', null);
                        var defaultPlugins = DefaultPlugins.DefaultScene;
                        if (plugins) {
                            //  Old 3.7 array format?
                            if (Array.isArray(plugins)) this.defaultPlugins = plugins;
                            else if (IsPlainObject(plugins)) {
                                this.installGlobalPlugins = GetFastValue(plugins, 'global', []);
                                this.installScenePlugins = GetFastValue(plugins, 'scene', []);
                                if (Array.isArray(plugins.default)) defaultPlugins = plugins.default;
                                else if (Array.isArray(plugins.defaultMerge)) defaultPlugins = defaultPlugins.concat(plugins.defaultMerge);
                            }
                        }
                        /**
         * @const {any} Phaser.Core.Config#defaultPlugins - The plugins installed into every Scene (in addition to CoreScene and Global).
         */ this.defaultPlugins = defaultPlugins;
                        //  Default / Missing Images
                        var pngPrefix = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAg';
                        /**
         * @const {string} Phaser.Core.Config#defaultImage - A base64 encoded PNG that will be used as the default blank texture.
         */ this.defaultImage = GetValue(config, 'images.default', pngPrefix + 'AQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg==');
                        /**
         * @const {string} Phaser.Core.Config#missingImage - A base64 encoded PNG that will be used as the default texture when a texture is assigned that is missing or not loaded.
         */ this.missingImage = GetValue(config, 'images.missing', pngPrefix + 'CAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg==');
                        /**
         * @const {string} Phaser.Core.Config#whiteImage - A base64 encoded PNG that will be used as the default texture when a texture is assigned that is white or not loaded.
         */ this.whiteImage = GetValue(config, 'images.white', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABdJREFUeNpi/P//PwMMMDEgAdwcgAADAJZuAwXJYZOzAAAAAElFTkSuQmCC');
                        if (window) {
                            if (window.FORCE_WEBGL) this.renderType = CONST.WEBGL;
                            else if (window.FORCE_CANVAS) this.renderType = CONST.CANVAS;
                        }
                    }
                });
                module1.exports = Config;
            /***/ },
            /***/ 86054: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasInterpolation = __webpack_require__(20623);
                var CanvasPool = __webpack_require__(27919);
                var CONST = __webpack_require__(8054);
                var Features = __webpack_require__(89357);
                /**
 * Called automatically by Phaser.Game and responsible for creating the renderer it will use.
 *
 * Relies upon two webpack global flags to be defined: `WEBGL_RENDERER` and `CANVAS_RENDERER` during build time, but not at run-time.
 *
 * @function Phaser.Core.CreateRenderer
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance on which the renderer will be set.
 */ var CreateRenderer = function(game) {
                    var config = game.config;
                    if ((config.customEnvironment || config.canvas) && config.renderType === CONST.AUTO) throw new Error('Must set explicit renderType in custom environment');
                    //  Not a custom environment, didn't provide their own canvas and not headless, so determine the renderer:
                    if (!config.customEnvironment && !config.canvas && config.renderType !== CONST.HEADLESS) {
                        if (config.renderType === CONST.AUTO) config.renderType = Features.webGL ? CONST.WEBGL : CONST.CANVAS;
                        if (config.renderType === CONST.WEBGL) {
                            if (!Features.webGL) throw new Error('Cannot create WebGL context, aborting.');
                        } else if (config.renderType === CONST.CANVAS) {
                            if (!Features.canvas) throw new Error('Cannot create Canvas context, aborting.');
                        } else throw new Error('Unknown value for renderer type: ' + config.renderType);
                    }
                    //  Pixel Art mode?
                    if (!config.antialias) CanvasPool.disableSmoothing();
                    var baseSize = game.scale.baseSize;
                    var width = baseSize.width;
                    var height = baseSize.height;
                    //  Does the game config provide its own canvas element to use?
                    if (config.canvas) {
                        game.canvas = config.canvas;
                        game.canvas.width = width;
                        game.canvas.height = height;
                    } else game.canvas = CanvasPool.create(game, width, height, config.renderType);
                    //  Does the game config provide some canvas css styles to use?
                    if (config.canvasStyle) game.canvas.style = config.canvasStyle;
                    //  Pixel Art mode?
                    if (!config.antialias) CanvasInterpolation.setCrisp(game.canvas);
                    if (config.renderType === CONST.HEADLESS) //  Nothing more to do here
                    return;
                    var CanvasRenderer;
                    var WebGLRenderer;
                    CanvasRenderer = __webpack_require__(68627);
                    WebGLRenderer = __webpack_require__(74797);
                    //  Let the config pick the renderer type, as both are included
                    if (config.renderType === CONST.WEBGL) game.renderer = new WebGLRenderer(game);
                    else {
                        game.renderer = new CanvasRenderer(game);
                        game.context = game.renderer.gameContext;
                    }
                };
                module1.exports = CreateRenderer;
            /***/ },
            /***/ 96391: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(8054);
                /**
 * Called automatically by Phaser.Game and responsible for creating the console.log debug header.
 *
 * You can customize or disable the header via the Game Config object.
 *
 * @function Phaser.Core.DebugHeader
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance which will output this debug header.
 */ var DebugHeader = function(game) {
                    var config = game.config;
                    if (config.hideBanner) return;
                    var renderType = 'WebGL';
                    if (config.renderType === CONST.CANVAS) renderType = 'Canvas';
                    else if (config.renderType === CONST.HEADLESS) renderType = 'Headless';
                    var audioConfig = config.audio;
                    var deviceAudio = game.device.audio;
                    var audioType;
                    if (deviceAudio.webAudio && !audioConfig.disableWebAudio) audioType = 'Web Audio';
                    else if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) audioType = 'No Audio';
                    else audioType = 'HTML5 Audio';
                    if (!game.device.browser.ie) {
                        var c = '';
                        var args = [
                            c
                        ];
                        if (Array.isArray(config.bannerBackgroundColor)) {
                            var lastColor;
                            config.bannerBackgroundColor.forEach(function(color) {
                                c = c.concat('%c ');
                                args.push('background: ' + color);
                                lastColor = color;
                            });
                            //  inject the text color
                            args[args.length - 1] = 'color: ' + config.bannerTextColor + '; background: ' + lastColor;
                        } else {
                            c = c.concat('%c ');
                            args.push('color: ' + config.bannerTextColor + '; background: ' + config.bannerBackgroundColor);
                        }
                        //  URL link background color (always transparent to support different browser themes)
                        args.push('background: transparent');
                        if (config.gameTitle) {
                            c = c.concat(config.gameTitle);
                            if (config.gameVersion) c = c.concat(' v' + config.gameVersion);
                            if (!config.hidePhaser) c = c.concat(' / ');
                        }
                        var fb = '';
                        if (!config.hidePhaser) c = c.concat('Phaser v' + CONST.VERSION + fb + ' (' + renderType + ' | ' + audioType + ')');
                        c = c.concat(' %c ' + config.gameURL);
                        //  Inject the new string back into the args array
                        args[0] = c;
                        console.log.apply(console, args);
                    } else if (window['console']) console.log('Phaser v' + CONST.VERSION + ' / https://phaser.io');
                };
                module1.exports = DebugHeader;
            /***/ },
            /***/ 50127: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(40366);
                var AnimationManager = __webpack_require__(60848);
                var CacheManager = __webpack_require__(24047);
                var CanvasPool = __webpack_require__(27919);
                var Class = __webpack_require__(83419);
                var Config = __webpack_require__(69547);
                var CreateDOMContainer = __webpack_require__(83719);
                var CreateRenderer = __webpack_require__(86054);
                var DataManager = __webpack_require__(45893);
                var DebugHeader = __webpack_require__(96391);
                var Device = __webpack_require__(82264);
                var DOMContentLoaded = __webpack_require__(57264);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(8443);
                var InputManager = __webpack_require__(7003);
                var PluginCache = __webpack_require__(37277);
                var PluginManager = __webpack_require__(77332);
                var ScaleManager = __webpack_require__(76531);
                var SceneManager = __webpack_require__(60903);
                var TextureEvents = __webpack_require__(69442);
                var TextureManager = __webpack_require__(17130);
                var TimeStep = __webpack_require__(65898);
                var VisibilityHandler = __webpack_require__(51085);
                var SoundManagerCreator = __webpack_require__(14747);
                var FacebookInstantGamesPlugin;
                /**
 * @classdesc
 * The Phaser.Game instance is the main controller for the entire Phaser game. It is responsible
 * for handling the boot process, parsing the configuration values, creating the renderer,
 * and setting-up all of the global Phaser systems, such as sound and input.
 * Once that is complete it will start the Scene Manager and then begin the main game loop.
 *
 * You should generally avoid accessing any of the systems created by Game, and instead use those
 * made available to you via the Phaser.Scene Systems class instead.
 *
 * @class Game
 * @memberof Phaser
 * @constructor
 * @fires Phaser.Core.Events#BLUR
 * @fires Phaser.Core.Events#FOCUS
 * @fires Phaser.Core.Events#HIDDEN
 * @fires Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 *
 * @param {Phaser.Types.Core.GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
 */ var Game = new Class({
                    initialize: function Game(config) {
                        /**
         * The parsed Game Configuration object.
         *
         * The values stored within this object are read-only and should not be changed at run-time.
         *
         * @name Phaser.Game#config
         * @type {Phaser.Core.Config}
         * @readonly
         * @since 3.0.0
         */ this.config = new Config(config);
                        /**
         * A reference to either the Canvas or WebGL Renderer that this Game is using.
         *
         * @name Phaser.Game#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.0.0
         */ this.renderer = null;
                        /**
         * A reference to an HTML Div Element used as the DOM Element Container.
         *
         * Only set if `createDOMContainer` is `true` in the game config (by default it is `false`) and
         * if you provide a parent element to insert the Phaser Game inside.
         *
         * See the DOM Element Game Object for more details.
         *
         * @name Phaser.Game#domContainer
         * @type {HTMLDivElement}
         * @since 3.17.0
         */ this.domContainer = null;
                        /**
         * A reference to the HTML Canvas Element that Phaser uses to render the game.
         * This is created automatically by Phaser unless you provide a `canvas` property
         * in your Game Config.
         *
         * @name Phaser.Game#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = null;
                        /**
         * A reference to the Rendering Context belonging to the Canvas Element this game is rendering to.
         * If the game is running under Canvas it will be a 2d Canvas Rendering Context.
         * If the game is running under WebGL it will be a WebGL Rendering Context.
         * This context is created automatically by Phaser unless you provide a `context` property
         * in your Game Config.
         *
         * @name Phaser.Game#context
         * @type {(CanvasRenderingContext2D|WebGLRenderingContext)}
         * @since 3.0.0
         */ this.context = null;
                        /**
         * A flag indicating when this Game instance has finished its boot process.
         *
         * @name Phaser.Game#isBooted
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.isBooted = false;
                        /**
         * A flag indicating if this Game is currently running its game step or not.
         *
         * @name Phaser.Game#isRunning
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.isRunning = false;
                        /**
         * An Event Emitter which is used to broadcast game-level events from the global systems.
         *
         * @name Phaser.Game#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                        /**
         * An instance of the Animation Manager.
         *
         * The Animation Manager is a global system responsible for managing all animations used within your game.
         *
         * @name Phaser.Game#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims = new AnimationManager(this);
                        /**
         * An instance of the Texture Manager.
         *
         * The Texture Manager is a global system responsible for managing all textures being used by your game.
         *
         * @name Phaser.Game#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures = new TextureManager(this);
                        /**
         * An instance of the Cache Manager.
         *
         * The Cache Manager is a global system responsible for caching, accessing and releasing external game assets.
         *
         * @name Phaser.Game#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache = new CacheManager(this);
                        /**
         * An instance of the Data Manager. This is a global manager, available from any Scene
         * and allows you to share and exchange your own game-level data or events without having
         * to use an internal event system.
         *
         * @name Phaser.Game#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry = new DataManager(this, new EventEmitter());
                        /**
         * An instance of the Input Manager.
         *
         * The Input Manager is a global system responsible for the capture of browser-level input events.
         *
         * @name Phaser.Game#input
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.input = new InputManager(this, this.config);
                        /**
         * An instance of the Scene Manager.
         *
         * The Scene Manager is a global system responsible for creating, modifying and updating the Scenes in your game.
         *
         * @name Phaser.Game#scene
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.0.0
         */ this.scene = new SceneManager(this, this.config.sceneConfig);
                        /**
         * A reference to the Device inspector.
         *
         * Contains information about the device running this game, such as OS, browser vendor and feature support.
         * Used by various systems to determine capabilities and code paths.
         *
         * @name Phaser.Game#device
         * @type {Phaser.DeviceConf}
         * @since 3.0.0
         */ this.device = Device;
                        /**
         * An instance of the Scale Manager.
         *
         * The Scale Manager is a global system responsible for handling scaling of the game canvas.
         *
         * @name Phaser.Game#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scale = new ScaleManager(this, this.config);
                        /**
         * An instance of the base Sound Manager.
         *
         * The Sound Manager is a global system responsible for the playback and updating of all audio in your game.
         *
         * You can disable the inclusion of the Sound Manager in your build by toggling the webpack `FEATURE_SOUND` flag.
         *
         * @name Phaser.Game#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound = null;
                        this.sound = SoundManagerCreator.create(this);
                        /**
         * An instance of the Time Step.
         *
         * The Time Step is a global system responsible for setting-up and responding to the browser frame events, processing
         * them and calculating delta values. It then automatically calls the game step.
         *
         * @name Phaser.Game#loop
         * @type {Phaser.Core.TimeStep}
         * @since 3.0.0
         */ this.loop = new TimeStep(this, this.config.fps);
                        /**
         * An instance of the Plugin Manager.
         *
         * The Plugin Manager is a global system that allows plugins to register themselves with it, and can then install
         * those plugins into Scenes as required.
         *
         * @name Phaser.Game#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins = new PluginManager(this, this.config);
                        /**
         * Is this Game pending destruction at the start of the next frame?
         *
         * @name Phaser.Game#pendingDestroy
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this.pendingDestroy = false;
                        /**
         * Remove the Canvas once the destroy is over?
         *
         * @name Phaser.Game#removeCanvas
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this.removeCanvas = false;
                        /**
         * Remove everything when the game is destroyed.
         * You cannot create a new Phaser instance on the same web page after doing this.
         *
         * @name Phaser.Game#noReturn
         * @type {boolean}
         * @private
         * @since 3.12.0
         */ this.noReturn = false;
                        /**
         * Does the window the game is running in currently have focus or not?
         * This is modified by the VisibilityHandler.
         *
         * @name Phaser.Game#hasFocus
         * @type {boolean}
         * @readonly
         * @since 3.9.0
         */ this.hasFocus = false;
                        /**
         * Is the Game currently paused? This will stop everything from updating,
         * except the `TimeStep` and related RequestAnimationFrame or setTimeout.
         * Those will continue stepping, but the core Game step will be skipped.
         *
         * @name Phaser.Game#isPaused
         * @type {boolean}
         * @since 3.60.0
         */ this.isPaused = false;
                        //  Wait for the DOM Ready event, then call boot.
                        DOMContentLoaded(this.boot.bind(this));
                    },
                    /**
     * This method is called automatically when the DOM is ready. It is responsible for creating the renderer,
     * displaying the Debug Header, adding the game canvas to the DOM and emitting the 'boot' event.
     * It listens for a 'ready' event from the base systems and once received it will call `Game.start`.
     *
     * @method Phaser.Game#boot
     * @protected
     * @fires Phaser.Core.Events#BOOT
     * @listens Phaser.Textures.Events#READY
     * @since 3.0.0
     */ boot: function() {
                        if (!PluginCache.hasCore('EventEmitter')) {
                            console.warn('Aborting. Core Plugins missing.');
                            return;
                        }
                        this.isBooted = true;
                        this.config.preBoot(this);
                        this.scale.preBoot();
                        CreateRenderer(this);
                        CreateDOMContainer(this);
                        DebugHeader(this);
                        AddToDOM(this.canvas, this.config.parent);
                        //  The Texture Manager has to wait on a couple of non-blocking events before it's fully ready.
                        //  So it will emit this internal event when done:
                        this.textures.once(TextureEvents.READY, this.texturesReady, this);
                        this.events.emit(Events.BOOT);
                    },
                    /**
     * Called automatically when the Texture Manager has finished setting up and preparing the
     * default textures.
     *
     * @method Phaser.Game#texturesReady
     * @private
     * @fires Phaser.Game#READY
     * @since 3.12.0
     */ texturesReady: function() {
                        //  Start all the other systems
                        this.events.emit(Events.READY);
                        this.start();
                    },
                    /**
     * Called automatically by Game.boot once all of the global systems have finished setting themselves up.
     * By this point the Game is now ready to start the main loop running.
     * It will also enable the Visibility Handler.
     *
     * @method Phaser.Game#start
     * @protected
     * @since 3.0.0
     */ start: function() {
                        this.isRunning = true;
                        this.config.postBoot(this);
                        if (this.renderer) this.loop.start(this.step.bind(this));
                        else this.loop.start(this.headlessStep.bind(this));
                        VisibilityHandler(this);
                        var eventEmitter = this.events;
                        eventEmitter.on(Events.HIDDEN, this.onHidden, this);
                        eventEmitter.on(Events.VISIBLE, this.onVisible, this);
                        eventEmitter.on(Events.BLUR, this.onBlur, this);
                        eventEmitter.on(Events.FOCUS, this.onFocus, this);
                    },
                    /**
     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
     * Request Animation Frame, or Set Timeout on very old browsers.)
     *
     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
     *
     * It will then render each Scene in turn, via the Renderer. This process emits `prerender` and `postrender` events.
     *
     * @method Phaser.Game#step
     * @fires Phaser.Core.Events#PRE_STEP
     * @fires Phaser.Core.Events#STEP
     * @fires Phaser.Core.Events#POST_STEP
     * @fires Phaser.Core.Events#PRE_RENDER
     * @fires Phaser.Core.Events#POST_RENDER
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ step: function(time, delta) {
                        if (this.pendingDestroy) return this.runDestroy();
                        if (this.isPaused) return;
                        var eventEmitter = this.events;
                        //  Global Managers like Input and Sound update in the prestep
                        eventEmitter.emit(Events.PRE_STEP, time, delta);
                        //  This is mostly meant for user-land code and plugins
                        eventEmitter.emit(Events.STEP, time, delta);
                        //  Update the Scene Manager and all active Scenes
                        this.scene.update(time, delta);
                        //  Our final event before rendering starts
                        eventEmitter.emit(Events.POST_STEP, time, delta);
                        var renderer = this.renderer;
                        //  Run the Pre-render (clearing the canvas, setting background colors, etc)
                        renderer.preRender();
                        eventEmitter.emit(Events.PRE_RENDER, renderer, time, delta);
                        //  The main render loop. Iterates all Scenes and all Cameras in those scenes, rendering to the renderer instance.
                        this.scene.render(renderer);
                        //  The Post-Render call. Tidies up loose end, takes snapshots, etc.
                        renderer.postRender();
                        //  The final event before the step repeats. Your last chance to do anything to the canvas before it all starts again.
                        eventEmitter.emit(Events.POST_RENDER, renderer, time, delta);
                    },
                    /**
     * A special version of the Game Step for the HEADLESS renderer only.
     *
     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
     * Request Animation Frame, or Set Timeout on very old browsers.)
     *
     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
     *
     * This process emits `prerender` and `postrender` events, even though nothing actually displays.
     *
     * @method Phaser.Game#headlessStep
     * @fires Phaser.Game#PRE_RENDER
     * @fires Phaser.Game#POST_RENDER
     * @since 3.2.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ headlessStep: function(time, delta) {
                        if (this.pendingDestroy) return this.runDestroy();
                        if (this.isPaused) return;
                        var eventEmitter = this.events;
                        //  Global Managers like Input and Sound update in the prestep
                        eventEmitter.emit(Events.PRE_STEP, time, delta);
                        //  This is mostly meant for user-land code and plugins
                        eventEmitter.emit(Events.STEP, time, delta);
                        //  Update the Scene Manager and all active Scenes
                        this.scene.update(time, delta);
                        //  Our final event before rendering starts
                        eventEmitter.emit(Events.POST_STEP, time, delta);
                        //  Render
                        this.scene.isProcessing = false;
                        eventEmitter.emit(Events.PRE_RENDER, null, time, delta);
                        eventEmitter.emit(Events.POST_RENDER, null, time, delta);
                    },
                    /**
     * Called automatically by the Visibility Handler.
     * This will pause the main loop and then emit a pause event.
     *
     * @method Phaser.Game#onHidden
     * @protected
     * @fires Phaser.Core.Events#PAUSE
     * @since 3.0.0
     */ onHidden: function() {
                        this.loop.pause();
                        this.events.emit(Events.PAUSE);
                    },
                    /**
     * This will pause the entire game and emit a `PAUSE` event.
     *
     * All of Phaser's internal systems will be paused and the game will not re-render.
     *
     * Note that it does not pause any Loader requests that are currently in-flight.
     *
     * @method Phaser.Game#pause
     * @fires Phaser.Core.Events#PAUSE
     * @since 3.60.0
     */ pause: function() {
                        var wasPaused = this.isPaused;
                        this.isPaused = true;
                        if (!wasPaused) this.events.emit(Events.PAUSE);
                    },
                    /**
     * Called automatically by the Visibility Handler.
     * This will resume the main loop and then emit a resume event.
     *
     * @method Phaser.Game#onVisible
     * @protected
     * @fires Phaser.Core.Events#RESUME
     * @since 3.0.0
     */ onVisible: function() {
                        this.loop.resume();
                        this.events.emit(Events.RESUME, this.loop.pauseDuration);
                    },
                    /**
     * This will resume the entire game and emit a `RESUME` event.
     *
     * All of Phaser's internal systems will be resumed and the game will start rendering again.
     *
     * @method Phaser.Game#resume
     * @fires Phaser.Core.Events#RESUME
     * @since 3.60.0
     */ resume: function() {
                        var wasPaused = this.isPaused;
                        this.isPaused = false;
                        if (wasPaused) this.events.emit(Events.RESUME, 0);
                    },
                    /**
     * Called automatically by the Visibility Handler.
     * This will set the main loop into a 'blurred' state, which pauses it.
     *
     * @method Phaser.Game#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                        this.hasFocus = false;
                        this.loop.blur();
                    },
                    /**
     * Called automatically by the Visibility Handler.
     * This will set the main loop into a 'focused' state, which resumes it.
     *
     * @method Phaser.Game#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                        this.hasFocus = true;
                        this.loop.focus();
                    },
                    /**
     * Returns the current game frame.
     *
     * When the game starts running, the frame is incremented every time Request Animation Frame, or Set Timeout, fires.
     *
     * @method Phaser.Game#getFrame
     * @since 3.16.0
     *
     * @return {number} The current game frame.
     */ getFrame: function() {
                        return this.loop.frame;
                    },
                    /**
     * Returns the time that the current game step started at, as based on `performance.now`.
     *
     * @method Phaser.Game#getTime
     * @since 3.16.0
     *
     * @return {number} The current game timestamp.
     */ getTime: function() {
                        return this.loop.now;
                    },
                    /**
     * Flags this Game instance as needing to be destroyed on the _next frame_, making this an asynchronous operation.
     *
     * It will wait until the current frame has completed and then call `runDestroy` internally.
     *
     * If you need to react to the games eventual destruction, listen for the `DESTROY` event.
     *
     * If you **do not** need to run Phaser again on the same web page you can set the `noReturn` argument to `true` and it will free-up
     * memory being held by the core Phaser plugins. If you do need to create another game instance on the same page, leave this as `false`.
     *
     * @method Phaser.Game#destroy
     * @fires Phaser.Core.Events#DESTROY
     * @since 3.0.0
     *
     * @param {boolean} removeCanvas - Set to `true` if you would like the parent canvas element removed from the DOM, or `false` to leave it in place.
     * @param {boolean} [noReturn=false] - If `true` all the core Phaser plugins are destroyed. You cannot create another instance of Phaser on the same web page if you do this.
     */ destroy: function(removeCanvas, noReturn) {
                        if (noReturn === undefined) noReturn = false;
                        this.pendingDestroy = true;
                        this.removeCanvas = removeCanvas;
                        this.noReturn = noReturn;
                    },
                    /**
     * Destroys this Phaser.Game instance, all global systems, all sub-systems and all Scenes.
     *
     * @method Phaser.Game#runDestroy
     * @private
     * @since 3.5.0
     */ runDestroy: function() {
                        this.scene.destroy();
                        this.events.emit(Events.DESTROY);
                        this.events.removeAllListeners();
                        if (this.renderer) this.renderer.destroy();
                        if (this.removeCanvas && this.canvas) {
                            CanvasPool.remove(this.canvas);
                            if (this.canvas.parentNode) this.canvas.parentNode.removeChild(this.canvas);
                        }
                        if (this.domContainer && this.domContainer.parentNode) this.domContainer.parentNode.removeChild(this.domContainer);
                        this.loop.destroy();
                        this.pendingDestroy = false;
                    }
                });
                module1.exports = Game;
            /**
 * "Computers are good at following instructions, but not at reading your mind." - Donald Knuth
 */ /***/ },
            /***/ 65898: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetValue = __webpack_require__(35154);
                var NOOP = __webpack_require__(29747);
                var RequestAnimationFrame = __webpack_require__(43092);
                // http://www.testufo.com/#test=animation-time-graph
                /**
 * @classdesc
 * The core runner class that Phaser uses to handle the game loop. It can use either Request Animation Frame,
 * or SetTimeout, based on browser support and config settings, to create a continuous loop within the browser.
 *
 * Each time the loop fires, `TimeStep.step` is called and this is then passed onto the core Game update loop,
 * it is the core heartbeat of your game. It will fire as often as Request Animation Frame is capable of handling
 * on the target device.
 *
 * Note that there are lots of situations where a browser will stop updating your game. Such as if the player
 * switches tabs, or covers up the browser window with another application. In these cases, the 'heartbeat'
 * of your game will pause, and only resume when focus is returned to it by the player. There is no way to avoid
 * this situation, all you can do is use the visibility events the browser, and Phaser, provide to detect when
 * it has happened and then gracefully recover.
 *
 * @class TimeStep
 * @memberof Phaser.Core
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this Time Step.
 * @param {Phaser.Types.Core.FPSConfig} config
 */ var TimeStep = new Class({
                    initialize: function TimeStep(game, config) {
                        /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Core.TimeStep#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                        /**
         * The Request Animation Frame DOM Event handler.
         *
         * @name Phaser.Core.TimeStep#raf
         * @type {Phaser.DOM.RequestAnimationFrame}
         * @readonly
         * @since 3.0.0
         */ this.raf = new RequestAnimationFrame();
                        /**
         * A flag that is set once the TimeStep has started running and toggled when it stops.
         *
         * @name Phaser.Core.TimeStep#started
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.started = false;
                        /**
         * A flag that is set once the TimeStep has started running and toggled when it stops.
         * The difference between this value and `started` is that `running` is toggled when
         * the TimeStep is sent to sleep, where-as `started` remains `true`, only changing if
         * the TimeStep is actually stopped, not just paused.
         *
         * @name Phaser.Core.TimeStep#running
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.running = false;
                        /**
         * The minimum fps rate you want the Time Step to run at.
         *
         * Setting this cannot guarantee the browser runs at this rate, it merely influences
         * the internal timing values to help the Timestep know when it has gone out of sync.
         *
         * @name Phaser.Core.TimeStep#minFps
         * @type {number}
         * @default 5
         * @since 3.0.0
         */ this.minFps = GetValue(config, 'min', 5);
                        /**
         * The target fps rate for the Time Step to run at.
         *
         * Setting this value will not actually change the speed at which the browser runs, that is beyond
         * the control of Phaser. Instead, it allows you to determine performance issues and if the Time Step
         * is spiraling out of control.
         *
         * @name Phaser.Core.TimeStep#targetFps
         * @type {number}
         * @default 60
         * @since 3.0.0
         */ this.targetFps = GetValue(config, 'target', 60);
                        /**
         * Enforce a frame rate limit. This forces how often the Game step will run. By default it is zero,
         * which means it will run at whatever limit the browser (via RequestAnimationFrame) can handle, which
         * is the optimum rate for fast-action or responsive games.
         *
         * However, if you are building a non-game app, like a graphics generator, or low-intensity game that doesn't
         * require 60fps, then you can lower the step rate via this Game Config value:
         *
         * ```js
         * fps: {
         *   limit: 30
         * }
         * ```
         *
         * Setting this _beyond_ the rate of RequestAnimationFrame will make no difference at all.
         *
         * Use it purely to _restrict_ updates in low-intensity situations only.
         *
         * @name Phaser.Core.TimeStep#fpsLimit
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.fpsLimit = GetValue(config, 'limit', 0);
                        /**
         * Is the FPS rate limited?
         *
         * This is set by setting the Game Config `limit` value to a value above zero.
         *
         * Consider this property as read-only.
         *
         * @name Phaser.Core.TimeStep#hasFpsLimit
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.hasFpsLimit = this.fpsLimit > 0;
                        /**
         * Internal value holding the fps rate limit in ms.
         *
         * @name Phaser.Core.TimeStep#_limitRate
         * @type {number}
         * @private
         * @since 3.60.0
         */ this._limitRate = this.hasFpsLimit ? 1000 / this.fpsLimit : 0;
                        /**
         * The minimum fps value in ms.
         *
         * Defaults to 200ms between frames (i.e. super slow!)
         *
         * @name Phaser.Core.TimeStep#_min
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._min = 1000 / this.minFps;
                        /**
         * The target fps value in ms.
         *
         * Defaults to 16.66ms between frames (i.e. normal)
         *
         * @name Phaser.Core.TimeStep#_target
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._target = 1000 / this.targetFps;
                        /**
         * An exponential moving average of the frames per second.
         *
         * @name Phaser.Core.TimeStep#actualFps
         * @type {number}
         * @readonly
         * @default 60
         * @since 3.0.0
         */ this.actualFps = this.targetFps;
                        /**
         * The time at which the next fps rate update will take place.
         *
         * When an fps update happens, the `framesThisSecond` value is reset.
         *
         * @name Phaser.Core.TimeStep#nextFpsUpdate
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.nextFpsUpdate = 0;
                        /**
         * The number of frames processed this second.
         *
         * @name Phaser.Core.TimeStep#framesThisSecond
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.framesThisSecond = 0;
                        /**
         * A callback to be invoked each time the TimeStep steps.
         *
         * @name Phaser.Core.TimeStep#callback
         * @type {Phaser.Types.Core.TimeStepCallback}
         * @default NOOP
         * @since 3.0.0
         */ this.callback = NOOP;
                        /**
         * You can force the TimeStep to use SetTimeOut instead of Request Animation Frame by setting
         * the `forceSetTimeOut` property to `true` in the Game Configuration object. It cannot be changed at run-time.
         *
         * @name Phaser.Core.TimeStep#forceSetTimeOut
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.forceSetTimeOut = GetValue(config, 'forceSetTimeOut', false);
                        /**
         * The time, updated each step by adding the elapsed delta time to the previous value.
         *
         * This differs from the `TimeStep.now` value, which is the high resolution time value
         * as provided by Request Animation Frame.
         *
         * @name Phaser.Core.TimeStep#time
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.time = 0;
                        /**
         * The time at which the game started running.
         *
         * This value is adjusted if the game is then paused and resumes.
         *
         * @name Phaser.Core.TimeStep#startTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                        /**
         * The time of the previous step.
         *
         * This is typically a high resolution timer value, as provided by Request Animation Frame.
         *
         * @name Phaser.Core.TimeStep#lastTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lastTime = 0;
                        /**
         * The current frame the game is on. This counter is incremented once every game step, regardless of how much
         * time has passed and is unaffected by delta smoothing.
         *
         * @name Phaser.Core.TimeStep#frame
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.frame = 0;
                        /**
         * Is the browser currently considered in focus by the Page Visibility API?
         *
         * This value is set in the `blur` method, which is called automatically by the Game instance.
         *
         * @name Phaser.Core.TimeStep#inFocus
         * @type {boolean}
         * @readonly
         * @default true
         * @since 3.0.0
         */ this.inFocus = true;
                        /**
         * The duration of the most recent game pause, if any, in ms.
         *
         * @name Phaser.Core.TimeStep#pauseDuration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.85.0
         */ this.pauseDuration = 0;
                        /**
         * The timestamp at which the game became paused, as determined by the Page Visibility API.
         *
         * @name Phaser.Core.TimeStep#_pauseTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pauseTime = 0;
                        /**
         * An internal counter to allow for the browser 'cooling down' after coming back into focus.
         *
         * @name Phaser.Core.TimeStep#_coolDown
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._coolDown = 0;
                        /**
         * The delta time, in ms, since the last game step. This is a clamped and smoothed average value.
         *
         * @name Phaser.Core.TimeStep#delta
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delta = 0;
                        /**
         * Internal index of the delta history position.
         *
         * @name Phaser.Core.TimeStep#deltaIndex
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.deltaIndex = 0;
                        /**
         * Internal array holding the previous delta values, used for delta smoothing.
         *
         * @name Phaser.Core.TimeStep#deltaHistory
         * @type {number[]}
         * @since 3.0.0
         */ this.deltaHistory = [];
                        /**
         * The maximum number of delta values that are retained in order to calculate a smoothed moving average.
         *
         * This can be changed in the Game Config via the `fps.deltaHistory` property. The default is 10.
         *
         * @name Phaser.Core.TimeStep#deltaSmoothingMax
         * @type {number}
         * @default 10
         * @since 3.0.0
         */ this.deltaSmoothingMax = GetValue(config, 'deltaHistory', 10);
                        /**
         * The number of frames that the cooldown is set to after the browser panics over the FPS rate, usually
         * as a result of switching tabs and regaining focus.
         *
         * This can be changed in the Game Config via the `fps.panicMax` property. The default is 120.
         *
         * @name Phaser.Core.TimeStep#panicMax
         * @type {number}
         * @default 120
         * @since 3.0.0
         */ this.panicMax = GetValue(config, 'panicMax', 120);
                        /**
         * The actual elapsed time in ms between one update and the next.
         *
         * Unlike with `delta`, no smoothing, capping, or averaging is applied to this value.
         * So please be careful when using this value in math calculations.
         *
         * @name Phaser.Core.TimeStep#rawDelta
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.rawDelta = 0;
                        /**
         * The time, set at the start of the current step.
         *
         * This is typically a high resolution timer value, as provided by Request Animation Frame.
         *
         * This can differ from the `time` value in that it isn't calculated based on the delta value.
         *
         * @name Phaser.Core.TimeStep#now
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.now = 0;
                        /**
         * Apply smoothing to the delta value used within Phasers internal calculations?
         *
         * This can be changed in the Game Config via the `fps.smoothStep` property. The default is `true`.
         *
         * Smoothing helps settle down the delta values after browser tab switches, or other situations
         * which could cause significant delta spikes or dips. By default it has been enabled in Phaser 3
         * since the first version, but is now exposed under this property (and the corresponding game config
         * `smoothStep` value), to allow you to easily disable it, should you require.
         *
         * @name Phaser.Core.TimeStep#smoothStep
         * @type {boolean}
         * @since 3.22.0
         */ this.smoothStep = GetValue(config, 'smoothStep', true);
                    },
                    /**
     * Called by the Game instance when the DOM window.onBlur event triggers.
     *
     * @method Phaser.Core.TimeStep#blur
     * @since 3.0.0
     */ blur: function() {
                        this.inFocus = false;
                    },
                    /**
     * Called by the Game instance when the DOM window.onFocus event triggers.
     *
     * @method Phaser.Core.TimeStep#focus
     * @since 3.0.0
     */ focus: function() {
                        this.inFocus = true;
                        this.resetDelta();
                    },
                    /**
     * Called when the visibility API says the game is 'hidden' (tab switch out of view, etc)
     *
     * @method Phaser.Core.TimeStep#pause
     * @since 3.0.0
     */ pause: function() {
                        this._pauseTime = window.performance.now();
                    },
                    /**
     * Called when the visibility API says the game is 'visible' again (tab switch back into view, etc)
     *
     * @method Phaser.Core.TimeStep#resume
     * @since 3.0.0
     */ resume: function() {
                        this.resetDelta();
                        this.pauseDuration = this.time - this._pauseTime;
                        this.startTime += this.pauseDuration;
                    },
                    /**
     * Resets the time, lastTime, fps averages and delta history.
     * Called automatically when a browser sleeps them resumes.
     *
     * @method Phaser.Core.TimeStep#resetDelta
     * @since 3.0.0
     */ resetDelta: function() {
                        var now = window.performance.now();
                        this.time = now;
                        this.lastTime = now;
                        this.nextFpsUpdate = now + 1000;
                        this.framesThisSecond = 0;
                        //  Pre-populate smoothing array
                        for(var i = 0; i < this.deltaSmoothingMax; i++)this.deltaHistory[i] = Math.min(this._target, this.deltaHistory[i]);
                        this.delta = 0;
                        this.deltaIndex = 0;
                        this._coolDown = this.panicMax;
                    },
                    /**
     * Starts the Time Step running, if it is not already doing so.
     * Called automatically by the Game Boot process.
     *
     * @method Phaser.Core.TimeStep#start
     * @since 3.0.0
     *
     * @param {Phaser.Types.Core.TimeStepCallback} callback - The callback to be invoked each time the Time Step steps.
     */ start: function(callback) {
                        if (this.started) return this;
                        this.started = true;
                        this.running = true;
                        for(var i = 0; i < this.deltaSmoothingMax; i++)this.deltaHistory[i] = this._target;
                        this.resetDelta();
                        this.startTime = window.performance.now();
                        this.callback = callback;
                        var step = this.hasFpsLimit ? this.stepLimitFPS.bind(this) : this.step.bind(this);
                        this.raf.start(step, this.forceSetTimeOut, this._target);
                    },
                    /**
     * Takes the delta value and smooths it based on the previous frames.
     *
     * Called automatically as part of the step.
     *
     * @method Phaser.Core.TimeStep#smoothDelta
     * @since 3.60.0
     *
     * @param {number} delta - The delta value for this step.
     *
     * @return {number} The smoothed delta value.
     */ smoothDelta: function(delta) {
                        var idx = this.deltaIndex;
                        var history = this.deltaHistory;
                        var max = this.deltaSmoothingMax;
                        if (this._coolDown > 0 || !this.inFocus) {
                            this._coolDown--;
                            delta = Math.min(delta, this._target);
                        }
                        if (delta > this._min) {
                            //  Probably super bad start time or browser tab context loss,
                            //  so use the last 'sane' delta value
                            delta = history[idx];
                            //  Clamp delta to min (in case history has become corrupted somehow)
                            delta = Math.min(delta, this._min);
                        }
                        //  Smooth out the delta over the previous X frames
                        //  add the delta to the smoothing array
                        history[idx] = delta;
                        //  adjusts the delta history array index based on the smoothing count
                        //  this stops the array growing beyond the size of deltaSmoothingMax
                        this.deltaIndex++;
                        if (this.deltaIndex >= max) this.deltaIndex = 0;
                        //  Loop the history array, adding the delta values together
                        var avg = 0;
                        for(var i = 0; i < max; i++)avg += history[i];
                        //  Then divide by the array length to get the average delta
                        avg /= max;
                        return avg;
                    },
                    /**
     * Update the estimate of the frame rate, `fps`. Every second, the number
     * of frames that occurred in that second are included in an exponential
     * moving average of all frames per second, with an alpha of 0.25. This
     * means that more recent seconds affect the estimated frame rate more than
     * older seconds.
     *
     * When a browser window is NOT minimized, but is covered up (i.e. you're using
     * another app which has spawned a window over the top of the browser), then it
     * will start to throttle the raf callback time. It waits for a while, and then
     * starts to drop the frame rate at 1 frame per second until it's down to just over 1fps.
     * So if the game was running at 60fps, and the player opens a new window, then
     * after 60 seconds (+ the 'buffer time') it'll be down to 1fps, so rafin'g at 1Hz.
     *
     * When they make the game visible again, the frame rate is increased at a rate of
     * approx. 8fps, back up to 60fps (or the max it can obtain)
     *
     * There is no easy way to determine if this drop in frame rate is because the
     * browser is throttling raf, or because the game is struggling with performance
     * because you're asking it to do too much on the device.
     *
     * Compute the new exponential moving average with an alpha of 0.25.
     *
     * @method Phaser.Core.TimeStep#updateFPS
     * @since 3.60.0
     *
     * @param {number} time - The timestamp passed in from RequestAnimationFrame or setTimeout.
     */ updateFPS: function(time) {
                        this.actualFps = 0.25 * this.framesThisSecond + 0.75 * this.actualFps;
                        this.nextFpsUpdate = time + 1000;
                        this.framesThisSecond = 0;
                    },
                    /**
     * The main step method with an fps limiter. This is called each time the browser updates, either by Request Animation Frame,
     * or by Set Timeout. It is responsible for calculating the delta values, frame totals, cool down history and more.
     * You generally should never call this method directly.
     *
     * @method Phaser.Core.TimeStep#stepLimitFPS
     * @since 3.60.0
     *
     * @param {number} time - The timestamp passed in from RequestAnimationFrame or setTimeout.
     */ stepLimitFPS: function(time) {
                        this.now = time;
                        //  delta time (time is in ms)
                        //  Math.max because Chrome will sometimes give negative deltas
                        var delta = Math.max(0, time - this.lastTime);
                        this.rawDelta = delta;
                        //  Real-world timer advance
                        this.time += this.rawDelta;
                        if (this.smoothStep) delta = this.smoothDelta(delta);
                        //  Set as the world delta value (after smoothing, if applied)
                        this.delta += delta;
                        if (time >= this.nextFpsUpdate) this.updateFPS(time);
                        this.framesThisSecond++;
                        if (this.delta >= this._limitRate) {
                            this.callback(time, this.delta);
                            this.delta = 0;
                        }
                        //  Shift time value over
                        this.lastTime = time;
                        this.frame++;
                    },
                    /**
     * The main step method. This is called each time the browser updates, either by Request Animation Frame,
     * or by Set Timeout. It is responsible for calculating the delta values, frame totals, cool down history and more.
     * You generally should never call this method directly.
     *
     * @method Phaser.Core.TimeStep#step
     * @since 3.0.0
     *
     * @param {number} time - The timestamp passed in from RequestAnimationFrame or setTimeout.
     */ step: function(time) {
                        this.now = time;
                        //  delta time (time is in ms)
                        //  Math.max because Chrome will sometimes give negative deltas
                        var delta = Math.max(0, time - this.lastTime);
                        this.rawDelta = delta;
                        //  Real-world timer advance
                        this.time += this.rawDelta;
                        if (this.smoothStep) delta = this.smoothDelta(delta);
                        //  Set as the world delta value (after smoothing, if applied)
                        this.delta = delta;
                        if (time >= this.nextFpsUpdate) this.updateFPS(time);
                        this.framesThisSecond++;
                        this.callback(time, delta);
                        //  Shift time value over
                        this.lastTime = time;
                        this.frame++;
                    },
                    /**
     * Manually calls `TimeStep.step`.
     *
     * @method Phaser.Core.TimeStep#tick
     * @since 3.0.0
     */ tick: function() {
                        var now = window.performance.now();
                        if (this.hasFpsLimit) this.stepLimitFPS(now);
                        else this.step(now);
                    },
                    /**
     * Sends the TimeStep to sleep, stopping Request Animation Frame (or SetTimeout) and toggling the `running` flag to false.
     *
     * @method Phaser.Core.TimeStep#sleep
     * @since 3.0.0
     */ sleep: function() {
                        if (this.running) {
                            this.raf.stop();
                            this.running = false;
                        }
                    },
                    /**
     * Wakes-up the TimeStep, restarting Request Animation Frame (or SetTimeout) and toggling the `running` flag to true.
     * The `seamless` argument controls if the wake-up should adjust the start time or not.
     *
     * @method Phaser.Core.TimeStep#wake
     * @since 3.0.0
     *
     * @param {boolean} [seamless=false] - Adjust the startTime based on the lastTime values.
     */ wake: function(seamless) {
                        if (seamless === undefined) seamless = false;
                        var now = window.performance.now();
                        if (this.running) return;
                        else if (seamless) this.startTime += -this.lastTime + (this.lastTime + now);
                        var step = this.hasFpsLimit ? this.stepLimitFPS.bind(this) : this.step.bind(this);
                        this.raf.start(step, this.forceSetTimeOut, this._target);
                        this.running = true;
                        this.nextFpsUpdate = now + 1000;
                        this.framesThisSecond = 0;
                        this.fpsLimitTriggered = false;
                        this.tick();
                    },
                    /**
     * Gets the duration which the game has been running, in seconds.
     *
     * @method Phaser.Core.TimeStep#getDuration
     * @since 3.17.0
     *
     * @return {number} The duration in seconds.
     */ getDuration: function() {
                        return Math.round(this.lastTime - this.startTime) / 1000;
                    },
                    /**
     * Gets the duration which the game has been running, in ms.
     *
     * @method Phaser.Core.TimeStep#getDurationMS
     * @since 3.17.0
     *
     * @return {number} The duration in ms.
     */ getDurationMS: function() {
                        return Math.round(this.lastTime - this.startTime);
                    },
                    /**
     * Stops the TimeStep running.
     *
     * @method Phaser.Core.TimeStep#stop
     * @since 3.0.0
     *
     * @return {this} The TimeStep object.
     */ stop: function() {
                        this.running = false;
                        this.started = false;
                        this.raf.stop();
                        return this;
                    },
                    /**
     * Destroys the TimeStep. This will stop Request Animation Frame, stop the step, clear the callbacks and null
     * any objects.
     *
     * @method Phaser.Core.TimeStep#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.stop();
                        this.raf.destroy();
                        this.raf = null;
                        this.game = null;
                        this.callback = null;
                    }
                });
                module1.exports = TimeStep;
            /***/ },
            /***/ 51085: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Events = __webpack_require__(8443);
                /**
 * The Visibility Handler is responsible for listening out for document level visibility change events.
 * This includes `visibilitychange` if the browser supports it, and blur and focus events. It then uses
 * the provided Event Emitter and fires the related events.
 *
 * @function Phaser.Core.VisibilityHandler
 * @fires Phaser.Core.Events#BLUR
 * @fires Phaser.Core.Events#FOCUS
 * @fires Phaser.Core.Events#HIDDEN
 * @fires Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance this Visibility Handler is working on.
 */ var VisibilityHandler = function(game) {
                    var hiddenVar;
                    var eventEmitter = game.events;
                    if (document.hidden !== undefined) hiddenVar = 'visibilitychange';
                    else {
                        var vendors = [
                            'webkit',
                            'moz',
                            'ms'
                        ];
                        vendors.forEach(function(prefix) {
                            if (document[prefix + 'Hidden'] !== undefined) {
                                document.hidden = function() {
                                    return document[prefix + 'Hidden'];
                                };
                                hiddenVar = prefix + 'visibilitychange';
                            }
                        });
                    }
                    var onChange = function(event) {
                        if (document.hidden || event.type === 'pause') eventEmitter.emit(Events.HIDDEN);
                        else eventEmitter.emit(Events.VISIBLE);
                    };
                    if (hiddenVar) document.addEventListener(hiddenVar, onChange, false);
                    window.onblur = function() {
                        eventEmitter.emit(Events.BLUR);
                    };
                    window.onfocus = function() {
                        eventEmitter.emit(Events.FOCUS);
                    };
                    //  Automatically give the window focus unless config says otherwise
                    if (window.focus && game.config.autoFocus) window.focus();
                };
                module1.exports = VisibilityHandler;
            /***/ },
            /***/ 97217: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Blur Event.
 *
 * This event is dispatched by the Game Visibility Handler when the window in which the Game instance is embedded
 * enters a blurred state. The blur event is raised when the window loses focus. This can happen if a user swaps
 * tab, or if they simply remove focus from the browser to another app.
 *
 * @event Phaser.Core.Events#BLUR
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'blur';
            /***/ },
            /***/ 47548: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Boot Event.
 *
 * This event is dispatched when the Phaser Game instance has finished booting, but before it is ready to start running.
 * The global systems use this event to know when to set themselves up, dispatching their own `ready` events as required.
 *
 * @event Phaser.Core.Events#BOOT
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'boot';
            /***/ },
            /***/ 19814: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Context Lost Event.
 *
 * This event is dispatched by the Game if the WebGL Renderer it is using encounters a WebGL Context Lost event from the browser.
 *
 * The renderer halts all rendering and cannot resume after this happens.
 *
 * @event Phaser.Core.Events#CONTEXT_LOST
 * @type {string}
 * @since 3.19.0
 */ module1.exports = 'contextlost';
            /***/ },
            /***/ 68446: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Destroy Event.
 *
 * This event is dispatched when the game instance has been told to destroy itself.
 * Lots of internal systems listen to this event in order to clear themselves out.
 * Custom plugins and game code should also do the same.
 *
 * @event Phaser.Core.Events#DESTROY
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'destroy';
            /***/ },
            /***/ 41700: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Focus Event.
 *
 * This event is dispatched by the Game Visibility Handler when the window in which the Game instance is embedded
 * enters a focused state. The focus event is raised when the window re-gains focus, having previously lost it.
 *
 * @event Phaser.Core.Events#FOCUS
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'focus';
            /***/ },
            /***/ 25432: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Hidden Event.
 *
 * This event is dispatched by the Game Visibility Handler when the document in which the Game instance is embedded
 * enters a hidden state. Only browsers that support the Visibility API will cause this event to be emitted.
 *
 * In most modern browsers, when the document enters a hidden state, the Request Animation Frame and setTimeout, which
 * control the main game loop, will automatically pause. There is no way to stop this from happening. It is something
 * your game should account for in its own code, should the pause be an issue (i.e. for multiplayer games)
 *
 * @event Phaser.Core.Events#HIDDEN
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'hidden';
            /***/ },
            /***/ 65942: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pause Event.
 *
 * This event is dispatched when the Game loop enters a paused state, usually as a result of the Visibility Handler.
 *
 * @event Phaser.Core.Events#PAUSE
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'pause';
            /***/ },
            /***/ 59211: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Post-Render Event.
 *
 * This event is dispatched right at the end of the render process.
 *
 * Every Scene will have rendered and been drawn to the canvas by the time this event is fired.
 * Use it for any last minute post-processing before the next game step begins.
 *
 * @event Phaser.Core.Events#POST_RENDER
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer being used by the Game instance.
 */ module1.exports = 'postrender';
            /***/ },
            /***/ 47789: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Post-Step Event.
 *
 * This event is dispatched after the Scene Manager has updated.
 * Hook into it from plugins or systems that need to do things before the render starts.
 *
 * @event Phaser.Core.Events#POST_STEP
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'poststep';
            /***/ },
            /***/ 39066: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pre-Render Event.
 *
 * This event is dispatched immediately before any of the Scenes have started to render.
 *
 * The renderer will already have been initialized this frame, clearing itself and preparing to receive the Scenes for rendering, but it won't have actually drawn anything yet.
 *
 * @event Phaser.Core.Events#PRE_RENDER
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer being used by the Game instance.
 */ module1.exports = 'prerender';
            /***/ },
            /***/ 460: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pre-Step Event.
 *
 * This event is dispatched before the main Game Step starts. By this point in the game cycle none of the Scene updates have yet happened.
 * Hook into it from plugins or systems that need to update before the Scene Manager does.
 *
 * @event Phaser.Core.Events#PRE_STEP
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'prestep';
            /***/ },
            /***/ 16175: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Ready Event.
 *
 * This event is dispatched when the Phaser Game instance has finished booting, the Texture Manager is fully ready,
 * and all local systems are now able to start.
 *
 * @event Phaser.Core.Events#READY
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'ready';
            /***/ },
            /***/ 42331: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Resume Event.
 *
 * This event is dispatched when the game loop leaves a paused state and resumes running.
 *
 * @event Phaser.Core.Events#RESUME
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} pauseDuration - The duration, in ms, that the game was paused for, or 0 if {@link Phaser.Game#resume} was called.
 */ module1.exports = 'resume';
            /***/ },
            /***/ 11966: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Step Event.
 *
 * This event is dispatched after the Game Pre-Step and before the Scene Manager steps.
 * Hook into it from plugins or systems that need to update before the Scene Manager does, but after the core Systems have.
 *
 * @event Phaser.Core.Events#STEP
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'step';
            /***/ },
            /***/ 32969: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This event is dispatched when the Scene Manager has created the System Scene,
 * which other plugins and systems may use to initialize themselves.
 *
 * This event is dispatched just once by the Game instance.
 *
 * @event Phaser.Core.Events#SYSTEM_READY
 * @type {string}
 * @since 3.70.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = 'systemready';
            /***/ },
            /***/ 94830: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Visible Event.
 *
 * This event is dispatched by the Game Visibility Handler when the document in which the Game instance is embedded
 * enters a visible state, previously having been hidden.
 *
 * Only browsers that support the Visibility API will cause this event to be emitted.
 *
 * @event Phaser.Core.Events#VISIBLE
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'visible';
            /***/ },
            /***/ 8443: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Core.Events
 */ module1.exports = {
                    BLUR: __webpack_require__(97217),
                    BOOT: __webpack_require__(47548),
                    CONTEXT_LOST: __webpack_require__(19814),
                    DESTROY: __webpack_require__(68446),
                    FOCUS: __webpack_require__(41700),
                    HIDDEN: __webpack_require__(25432),
                    PAUSE: __webpack_require__(65942),
                    POST_RENDER: __webpack_require__(59211),
                    POST_STEP: __webpack_require__(47789),
                    PRE_RENDER: __webpack_require__(39066),
                    PRE_STEP: __webpack_require__(460),
                    READY: __webpack_require__(16175),
                    RESUME: __webpack_require__(42331),
                    STEP: __webpack_require__(11966),
                    SYSTEM_READY: __webpack_require__(32969),
                    VISIBLE: __webpack_require__(94830)
                };
            /***/ },
            /***/ 42857: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Core
 */ module1.exports = {
                    Config: __webpack_require__(69547),
                    CreateRenderer: __webpack_require__(86054),
                    DebugHeader: __webpack_require__(96391),
                    Events: __webpack_require__(8443),
                    TimeStep: __webpack_require__(65898),
                    VisibilityHandler: __webpack_require__(51085)
                };
            /***/ },
            /***/ 99584: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Arne16 = __webpack_require__(5290);
                var CanvasPool = __webpack_require__(27919);
                var GetValue = __webpack_require__(35154);
                /**
 * Generates a texture based on the given Create configuration object.
 *
 * The texture is drawn using a fixed-size indexed palette of 16 colors, where the hex value in the
 * data cells map to a single color. For example, if the texture config looked like this:
 *
 * ```javascript
 * var star = [
 *   '.....828.....',
 *   '....72227....',
 *   '....82228....',
 *   '...7222227...',
 *   '2222222222222',
 *   '8222222222228',
 *   '.72222222227.',
 *   '..787777787..',
 *   '..877777778..',
 *   '.78778887787.',
 *   '.27887.78872.',
 *   '.787.....787.'
 * ];
 *
 * this.textures.generate('star', { data: star, pixelWidth: 4 });
 * ```
 *
 * Then it would generate a texture that is 52 x 48 pixels in size, because each cell of the data array
 * represents 1 pixel multiplied by the `pixelWidth` value. The cell values, such as `8`, maps to color
 * number 8 in the palette. If a cell contains a period character `.` then it is transparent.
 *
 * The default palette is Arne16, but you can specify your own using the `palette` property.
 *
 * @function Phaser.Create.GenerateTexture
 * @since 3.0.0
 *
 * @param {Phaser.Types.Create.GenerateTextureConfig} config - The Generate Texture Configuration object.
 *
 * @return {HTMLCanvasElement} An HTMLCanvasElement which contains the generated texture drawn to it.
 */ var GenerateTexture = function(config) {
                    var data = GetValue(config, 'data', []);
                    var canvas = GetValue(config, 'canvas', null);
                    var palette = GetValue(config, 'palette', Arne16);
                    var pixelWidth = GetValue(config, 'pixelWidth', 1);
                    var pixelHeight = GetValue(config, 'pixelHeight', pixelWidth);
                    var resizeCanvas = GetValue(config, 'resizeCanvas', true);
                    var clearCanvas = GetValue(config, 'clearCanvas', true);
                    var preRender = GetValue(config, 'preRender', null);
                    var postRender = GetValue(config, 'postRender', null);
                    var width = Math.floor(Math.abs(data[0].length * pixelWidth));
                    var height = Math.floor(Math.abs(data.length * pixelHeight));
                    if (!canvas) {
                        canvas = CanvasPool.create2D(this, width, height);
                        resizeCanvas = false;
                        clearCanvas = false;
                    }
                    if (resizeCanvas) {
                        canvas.width = width;
                        canvas.height = height;
                    }
                    var ctx = canvas.getContext('2d', {
                        willReadFrequently: true
                    });
                    if (clearCanvas) ctx.clearRect(0, 0, width, height);
                    //  preRender Callback?
                    if (preRender) preRender(canvas, ctx);
                    //  Draw it
                    for(var y = 0; y < data.length; y++){
                        var row = data[y];
                        for(var x = 0; x < row.length; x++){
                            var d = row[x];
                            if (d !== '.' && d !== ' ') {
                                ctx.fillStyle = palette[d];
                                ctx.fillRect(x * pixelWidth, y * pixelHeight, pixelWidth, pixelHeight);
                            }
                        }
                    }
                    //  postRender Callback?
                    if (postRender) postRender(canvas, ctx);
                    return canvas;
                };
                module1.exports = GenerateTexture;
            /***/ },
            /***/ 15822: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Create
 */ module1.exports = {
                    GenerateTexture: __webpack_require__(99584),
                    Palettes: __webpack_require__(57763)
                };
            /***/ },
            /***/ 5290: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.ARNE16
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                    0: '#000',
                    1: '#9D9D9D',
                    2: '#FFF',
                    3: '#BE2633',
                    4: '#E06F8B',
                    5: '#493C2B',
                    6: '#A46422',
                    7: '#EB8931',
                    8: '#F7E26B',
                    9: '#2F484E',
                    A: '#44891A',
                    B: '#A3CE27',
                    C: '#1B2632',
                    D: '#005784',
                    E: '#31A2F2',
                    F: '#B2DCEF'
                };
            /***/ },
            /***/ 23816: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette inspired by the Commodore 64.
 *
 * @name Phaser.Create.Palettes.C64
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                    0: '#000',
                    1: '#fff',
                    2: '#8b4131',
                    3: '#7bbdc5',
                    4: '#8b41ac',
                    5: '#6aac41',
                    6: '#3931a4',
                    7: '#d5de73',
                    8: '#945a20',
                    9: '#5a4100',
                    A: '#bd736a',
                    B: '#525252',
                    C: '#838383',
                    D: '#acee8b',
                    E: '#7b73de',
                    F: '#acacac'
                };
            /***/ },
            /***/ 9866: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color CGA inspired palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.CGA
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                    0: '#000',
                    1: '#2234d1',
                    2: '#0c7e45',
                    3: '#44aacc',
                    4: '#8a3622',
                    5: '#5c2e78',
                    6: '#aa5c3d',
                    7: '#b5b5b5',
                    8: '#5e606e',
                    9: '#4c81fb',
                    A: '#6cd947',
                    B: '#7be2f9',
                    C: '#eb8a60',
                    D: '#e23d69',
                    E: '#ffd93f',
                    F: '#fff'
                };
            /***/ },
            /***/ 77552: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color JMP palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.JMP
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                    0: '#000',
                    1: '#191028',
                    2: '#46af45',
                    3: '#a1d685',
                    4: '#453e78',
                    5: '#7664fe',
                    6: '#833129',
                    7: '#9ec2e8',
                    8: '#dc534b',
                    9: '#e18d79',
                    A: '#d6b97b',
                    B: '#e9d8a1',
                    C: '#216c4b',
                    D: '#d365c8',
                    E: '#afaab9',
                    F: '#f5f4eb'
                };
            /***/ },
            /***/ 92259: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette inspired by Japanese computers like the MSX.
 *
 * @name Phaser.Create.Palettes.MSX
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                    0: '#000',
                    1: '#191028',
                    2: '#46af45',
                    3: '#a1d685',
                    4: '#453e78',
                    5: '#7664fe',
                    6: '#833129',
                    7: '#9ec2e8',
                    8: '#dc534b',
                    9: '#e18d79',
                    A: '#d6b97b',
                    B: '#e9d8a1',
                    C: '#216c4b',
                    D: '#d365c8',
                    E: '#afaab9',
                    F: '#fff'
                };
            /***/ },
            /***/ 57763: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Create.Palettes
 */ module1.exports = {
                    ARNE16: __webpack_require__(5290),
                    C64: __webpack_require__(23816),
                    CGA: __webpack_require__(9866),
                    JMP: __webpack_require__(77552),
                    MSX: __webpack_require__(92259)
                };
            /***/ },
            /***/ 46728: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
                var Class = __webpack_require__(83419);
                var CubicBezier = __webpack_require__(36316);
                var Curve = __webpack_require__(80021);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A higher-order Bézier curve constructed of four points.
 *
 * @class CubicBezier
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2|Phaser.Math.Vector2[])} p0 - Start point, or an array of point pairs.
 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
 * @param {Phaser.Math.Vector2} p3 - End Point.
 */ var CubicBezierCurve = new Class({
                    Extends: Curve,
                    initialize: function CubicBezierCurve(p0, p1, p2, p3) {
                        Curve.call(this, 'CubicBezierCurve');
                        if (Array.isArray(p0)) {
                            p3 = new Vector2(p0[6], p0[7]);
                            p2 = new Vector2(p0[4], p0[5]);
                            p1 = new Vector2(p0[2], p0[3]);
                            p0 = new Vector2(p0[0], p0[1]);
                        }
                        /**
         * The start point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = p0;
                        /**
         * The first control point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p1 = p1;
                        /**
         * The second control point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p2
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p2 = p2;
                        /**
         * The end point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p3
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p3 = p3;
                    },
                    /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.CubicBezier#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return out.copy(this.p0);
                    },
                    /**
     * Returns the resolution of this curve.
     *
     * @method Phaser.Curves.CubicBezier#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - The amount of divisions used by this curve.
     *
     * @return {number} The resolution of the curve.
     */ getResolution: function(divisions) {
                        return divisions;
                    },
                    /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.CubicBezier#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        var p0 = this.p0;
                        var p1 = this.p1;
                        var p2 = this.p2;
                        var p3 = this.p3;
                        return out.set(CubicBezier(t, p0.x, p1.x, p2.x, p3.x), CubicBezier(t, p0.y, p1.y, p2.y, p3.y));
                    },
                    /**
     * Draws this curve to the specified graphics object.
     *
     * @method Phaser.Curves.CubicBezier#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The graphics object this curve should be drawn to.
     * @param {number} [pointsTotal=32] - The number of intermediary points that make up this curve. A higher number of points will result in a smoother curve.
     *
     * @return {Phaser.GameObjects.Graphics} The graphics object this curve was drawn to. Useful for method chaining.
     */ draw: function(graphics, pointsTotal) {
                        if (pointsTotal === undefined) pointsTotal = 32;
                        var points = this.getPoints(pointsTotal);
                        graphics.beginPath();
                        graphics.moveTo(this.p0.x, this.p0.y);
                        for(var i = 1; i < points.length; i++)graphics.lineTo(points[i].x, points[i].y);
                        graphics.strokePath();
                        //  So you can chain graphics calls
                        return graphics;
                    },
                    /**
     * Returns a JSON object that describes this curve.
     *
     * @method Phaser.Curves.CubicBezier#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                        return {
                            type: this.type,
                            points: [
                                this.p0.x,
                                this.p0.y,
                                this.p1.x,
                                this.p1.y,
                                this.p2.x,
                                this.p2.y,
                                this.p3.x,
                                this.p3.y
                            ]
                        };
                    }
                });
                /**
 * Generates a curve from a JSON object.
 *
 * @function Phaser.Curves.CubicBezier.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.CubicBezier} The curve generated from the JSON object.
 */ CubicBezierCurve.fromJSON = function(data) {
                    var points = data.points;
                    var p0 = new Vector2(points[0], points[1]);
                    var p1 = new Vector2(points[2], points[3]);
                    var p2 = new Vector2(points[4], points[5]);
                    var p3 = new Vector2(points[6], points[7]);
                    return new CubicBezierCurve(p0, p1, p2, p3);
                };
                module1.exports = CubicBezierCurve;
            /***/ },
            /***/ 80021: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FromPoints = __webpack_require__(19217);
                var Rectangle = __webpack_require__(87841);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Base Curve class, which all other curve types extend.
 *
 * Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
 *
 * @class Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {string} type - The curve type.
 */ var Curve = new Class({
                    initialize: function Curve(type) {
                        /**
         * String based identifier for the type of curve.
         *
         * @name Phaser.Curves.Curve#type
         * @type {string}
         * @since 3.0.0
         */ this.type = type;
                        /**
         * The default number of divisions within the curve.
         *
         * @name Phaser.Curves.Curve#defaultDivisions
         * @type {number}
         * @default 5
         * @since 3.0.0
         */ this.defaultDivisions = 5;
                        /**
         * The quantity of arc length divisions within the curve.
         *
         * @name Phaser.Curves.Curve#arcLengthDivisions
         * @type {number}
         * @default 100
         * @since 3.0.0
         */ this.arcLengthDivisions = 100;
                        /**
         * An array of cached arc length values.
         *
         * @name Phaser.Curves.Curve#cacheArcLengths
         * @type {number[]}
         * @default []
         * @since 3.0.0
         */ this.cacheArcLengths = [];
                        /**
         * Does the data of this curve need updating?
         *
         * @name Phaser.Curves.Curve#needsUpdate
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.needsUpdate = true;
                        /**
         * For a curve on a Path, `false` means the Path will ignore this curve.
         *
         * @name Phaser.Curves.Curve#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                        /**
         * A temporary calculation Vector.
         *
         * @name Phaser.Curves.Curve#_tmpVec2A
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2A = new Vector2();
                        /**
         * A temporary calculation Vector.
         *
         * @name Phaser.Curves.Curve#_tmpVec2B
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2B = new Vector2();
                    },
                    /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.strokePoints` so will be drawn at whatever the present Graphics stroke color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.Curve#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
     * @param {number} [pointsTotal=32] - The resolution of the curve. The higher the value the smoother it will render, at the cost of rendering performance.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
     */ draw: function(graphics, pointsTotal) {
                        if (pointsTotal === undefined) pointsTotal = 32;
                        //  So you can chain graphics calls
                        return graphics.strokePoints(this.getPoints(pointsTotal));
                    },
                    /**
     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
     *
     * You can control the accuracy of the bounds. The value given is used to work out how many points
     * to plot across the curve. Higher values are more accurate at the cost of calculation speed.
     *
     * @method Phaser.Curves.Curve#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the bounds in. If falsey a new object will be created.
     * @param {number} [accuracy=16] - The accuracy of the bounds calculations.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
     */ getBounds: function(out, accuracy) {
                        if (!out) out = new Rectangle();
                        if (accuracy === undefined) accuracy = 16;
                        var len = this.getLength();
                        if (accuracy > len) accuracy = len / 2;
                        //  The length of the curve in pixels
                        //  So we'll have 1 spaced point per 'accuracy' pixels
                        var spaced = Math.max(1, Math.round(len / accuracy));
                        return FromPoints(this.getSpacedPoints(spaced), out);
                    },
                    /**
     * Returns an array of points, spaced out X distance pixels apart.
     * The smaller the distance, the larger the array will be.
     *
     * @method Phaser.Curves.Curve#getDistancePoints
     * @since 3.0.0
     *
     * @param {number} distance - The distance, in pixels, between each point along the curve.
     *
     * @return {Phaser.Geom.Point[]} An Array of Point objects.
     */ getDistancePoints: function(distance) {
                        var len = this.getLength();
                        var spaced = Math.max(1, len / distance);
                        return this.getSpacedPoints(spaced);
                    },
                    /**
     * Get a point at the end of the curve.
     *
     * @method Phaser.Curves.Curve#getEndPoint
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} [out] - Optional Vector object to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector2 containing the coordinates of the curves end point.
     */ getEndPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return this.getPointAt(1, out);
                    },
                    /**
     * Get total curve arc length
     *
     * @method Phaser.Curves.Curve#getLength
     * @since 3.0.0
     *
     * @return {number} The total length of the curve.
     */ getLength: function() {
                        var lengths = this.getLengths();
                        return lengths[lengths.length - 1];
                    },
                    /**
     * Get a list of cumulative segment lengths.
     *
     * These lengths are
     *
     * - [0] 0
     * - [1] The first segment
     * - [2] The first and second segment
     * - ...
     * - [divisions] All segments
     *
     * @method Phaser.Curves.Curve#getLengths
     * @since 3.0.0
     *
     * @param {number} [divisions] - The number of divisions or segments.
     *
     * @return {number[]} An array of cumulative lengths.
     */ getLengths: function(divisions) {
                        if (divisions === undefined) divisions = this.arcLengthDivisions;
                        if (this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
                        this.needsUpdate = false;
                        var cache = [];
                        var current;
                        var last = this.getPoint(0, this._tmpVec2A);
                        var sum = 0;
                        cache.push(0);
                        for(var p = 1; p <= divisions; p++){
                            current = this.getPoint(p / divisions, this._tmpVec2B);
                            sum += current.distance(last);
                            cache.push(sum);
                            last.copy(current);
                        }
                        this.cacheArcLengths = cache;
                        return cache; // { sums: cache, sum:sum }; Sum is in the last element.
                    },
                    // Get point at relative position in curve according to arc length
                    // - u [0 .. 1]
                    /**
     * Get a point at a relative position on the curve, by arc length.
     *
     * @method Phaser.Curves.Curve#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The relative position, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A point to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getPointAt: function(u, out) {
                        var t = this.getUtoTmapping(u);
                        return this.getPoint(t, out);
                    },
                    // Get sequence of points using getPoint( t )
                    /**
     * Get a sequence of evenly spaced points from the curve.
     *
     * You can pass `divisions`, `stepRate`, or neither.
     *
     * The number of divisions will be
     *
     * 1. `divisions`, if `divisions` > 0; or
     * 2. `this.getLength / stepRate`, if `stepRate` > 0; or
     * 3. `this.defaultDivisions`
     *
     * `1 + divisions` points will be returned.
     *
     * @method Phaser.Curves.Curve#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2[]} O - [out,$return]
     *
     * @param {number} [divisions] - The number of divisions to make.
     * @param {number} [stepRate] - The curve distance between points, implying `divisions`.
     * @param {(array|Phaser.Math.Vector2[])} [out] - An optional array to store the points in.
     *
     * @return {(array|Phaser.Math.Vector2[])} An array of Points from the curve.
     */ getPoints: function(divisions, stepRate, out) {
                        if (out === undefined) out = [];
                        //  If divisions is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                        if (!divisions) {
                            if (!stepRate) divisions = this.defaultDivisions;
                            else divisions = this.getLength() / stepRate;
                        }
                        for(var d = 0; d <= divisions; d++)out.push(this.getPoint(d / divisions));
                        return out;
                    },
                    /**
     * Get a random point from the curve.
     *
     * @method Phaser.Curves.Curve#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A point object to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getRandomPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return this.getPoint(Math.random(), out);
                    },
                    // Get sequence of points using getPointAt( u )
                    /**
     * Get a sequence of equally spaced points (by arc distance) from the curve.
     *
     * `1 + divisions` points will be returned.
     *
     * @method Phaser.Curves.Curve#getSpacedPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=this.defaultDivisions] - The number of divisions to make.
     * @param {number} [stepRate] - Step between points. Used to calculate the number of points to return when divisions is falsy. Ignored if divisions is positive.
     * @param {(array|Phaser.Math.Vector2[])} [out] - An optional array to store the points in.
     *
     * @return {Phaser.Math.Vector2[]} An array of points.
     */ getSpacedPoints: function(divisions, stepRate, out) {
                        if (out === undefined) out = [];
                        //  If divisions is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                        if (!divisions) {
                            if (!stepRate) divisions = this.defaultDivisions;
                            else divisions = this.getLength() / stepRate;
                        }
                        for(var d = 0; d <= divisions; d++){
                            var t = this.getUtoTmapping(d / divisions, null, divisions);
                            out.push(this.getPoint(t));
                        }
                        return out;
                    },
                    /**
     * Get a point at the start of the curve.
     *
     * @method Phaser.Curves.Curve#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A point to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getStartPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return this.getPointAt(0, out);
                    },
                    /**
     * Get a unit vector tangent at a relative position on the curve.
     * In case any sub curve does not implement its tangent derivation,
     * 2 points a small delta apart will be used to find its gradient
     * which seems to give a reasonable approximation
     *
     * @method Phaser.Curves.Curve#getTangent
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The relative position on the curve, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector approximating the tangent line at the point t (delta +/- 0.0001)
     */ getTangent: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        var delta = 0.0001;
                        var t1 = t - delta;
                        var t2 = t + delta;
                        // Capping in case of danger
                        if (t1 < 0) t1 = 0;
                        if (t2 > 1) t2 = 1;
                        this.getPoint(t1, this._tmpVec2A);
                        this.getPoint(t2, out);
                        return out.subtract(this._tmpVec2A).normalize();
                    },
                    /**
     * Get a unit vector tangent at a relative position on the curve, by arc length.
     *
     * @method Phaser.Curves.Curve#getTangentAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The relative position on the curve, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} The tangent vector.
     */ getTangentAt: function(u, out) {
                        var t = this.getUtoTmapping(u);
                        return this.getTangent(t, out);
                    },
                    /**
     * Given a distance in pixels, get a t to find p.
     *
     * @method Phaser.Curves.Curve#getTFromDistance
     * @since 3.0.0
     *
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The distance.
     */ getTFromDistance: function(distance, divisions) {
                        if (distance <= 0) return 0;
                        return this.getUtoTmapping(0, distance, divisions);
                    },
                    /**
     * Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant.
     *
     * @method Phaser.Curves.Curve#getUtoTmapping
     * @since 3.0.0
     *
     * @param {number} u - A float between 0 and 1.
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The equidistant value.
     */ getUtoTmapping: function(u, distance, divisions) {
                        var arcLengths = this.getLengths(divisions);
                        var i = 0;
                        var il = arcLengths.length;
                        var targetArcLength; // The targeted u distance value to get
                        if (distance) //  Cannot overshoot the curve
                        targetArcLength = Math.min(distance, arcLengths[il - 1]);
                        else targetArcLength = u * arcLengths[il - 1];
                        // binary search for the index with largest value smaller than target u distance
                        var low = 0;
                        var high = il - 1;
                        var comparison;
                        while(low <= high){
                            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
                            comparison = arcLengths[i] - targetArcLength;
                            if (comparison < 0) low = i + 1;
                            else if (comparison > 0) high = i - 1;
                            else {
                                high = i;
                                break;
                            }
                        }
                        i = high;
                        if (arcLengths[i] === targetArcLength) return i / (il - 1);
                        // we could get finer grain at lengths, or use simple interpolation between two points
                        var lengthBefore = arcLengths[i];
                        var lengthAfter = arcLengths[i + 1];
                        var segmentLength = lengthAfter - lengthBefore;
                        // determine where we are between the 'before' and 'after' points
                        var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
                        // add that fractional amount to t
                        return (i + segmentFraction) / (il - 1);
                    },
                    /**
     * Calculate and cache the arc lengths.
     *
     * @method Phaser.Curves.Curve#updateArcLengths
     * @since 3.0.0
     *
     * @see Phaser.Curves.Curve#getLengths()
     */ updateArcLengths: function() {
                        this.needsUpdate = true;
                        this.getLengths();
                    }
                });
                module1.exports = Curve;
            /***/ },
            /***/ 73825: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
                var Class = __webpack_require__(83419);
                var Curve = __webpack_require__(80021);
                var DegToRad = __webpack_require__(39506);
                var GetValue = __webpack_require__(35154);
                var RadToDeg = __webpack_require__(43396);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * An Elliptical Curve derived from the Base Curve class.
 * 
 * See https://en.wikipedia.org/wiki/Elliptic_curve for more details.
 *
 * @class Ellipse
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(number|Phaser.Types.Curves.EllipseCurveConfig)} [x=0] - The x coordinate of the ellipse, or an Ellipse Curve configuration object.
 * @param {number} [y=0] - The y coordinate of the ellipse.
 * @param {number} [xRadius=0] - The horizontal radius of ellipse.
 * @param {number} [yRadius=0] - The vertical radius of ellipse.
 * @param {number} [startAngle=0] - The start angle of the ellipse, in degrees.
 * @param {number} [endAngle=360] - The end angle of the ellipse, in degrees.
 * @param {boolean} [clockwise=false] - Whether the ellipse angles are given as clockwise (`true`) or counter-clockwise (`false`).
 * @param {number} [rotation=0] - The rotation of the ellipse, in degrees.
 */ var EllipseCurve = new Class({
                    Extends: Curve,
                    initialize: function EllipseCurve(x, y, xRadius, yRadius, startAngle, endAngle, clockwise, rotation) {
                        if (typeof x === 'object') {
                            var config = x;
                            x = GetValue(config, 'x', 0);
                            y = GetValue(config, 'y', 0);
                            xRadius = GetValue(config, 'xRadius', 0);
                            yRadius = GetValue(config, 'yRadius', xRadius);
                            startAngle = GetValue(config, 'startAngle', 0);
                            endAngle = GetValue(config, 'endAngle', 360);
                            clockwise = GetValue(config, 'clockwise', false);
                            rotation = GetValue(config, 'rotation', 0);
                        } else {
                            if (yRadius === undefined) yRadius = xRadius;
                            if (startAngle === undefined) startAngle = 0;
                            if (endAngle === undefined) endAngle = 360;
                            if (clockwise === undefined) clockwise = false;
                            if (rotation === undefined) rotation = 0;
                        }
                        Curve.call(this, 'EllipseCurve');
                        //  Center point
                        /**
         * The center point of the ellipse. Used for calculating rotation.
         *
         * @name Phaser.Curves.Ellipse#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = new Vector2(x, y);
                        /**
         * The horizontal radius of the ellipse.
         *
         * @name Phaser.Curves.Ellipse#_xRadius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._xRadius = xRadius;
                        /**
         * The vertical radius of the ellipse.
         *
         * @name Phaser.Curves.Ellipse#_yRadius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._yRadius = yRadius;
                        //  Radians
                        /**
         * The starting angle of the ellipse in radians.
         *
         * @name Phaser.Curves.Ellipse#_startAngle
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._startAngle = DegToRad(startAngle);
                        /**
         * The end angle of the ellipse in radians.
         *
         * @name Phaser.Curves.Ellipse#_endAngle
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._endAngle = DegToRad(endAngle);
                        /**
         * Anti-clockwise direction.
         *
         * @name Phaser.Curves.Ellipse#_clockwise
         * @type {boolean}
         * @private
         * @since 3.0.0
         */ this._clockwise = clockwise;
                        /**
         * The rotation of the arc.
         *
         * @name Phaser.Curves.Ellipse#_rotation
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._rotation = DegToRad(rotation);
                    },
                    /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Ellipse#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return this.getPoint(0, out);
                    },
                    /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.Ellipse#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                        return divisions * 2;
                    },
                    /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Ellipse#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        var twoPi = Math.PI * 2;
                        var deltaAngle = this._endAngle - this._startAngle;
                        var samePoints = Math.abs(deltaAngle) < Number.EPSILON;
                        // ensures that deltaAngle is 0 .. 2 PI
                        while(deltaAngle < 0)deltaAngle += twoPi;
                        while(deltaAngle > twoPi)deltaAngle -= twoPi;
                        if (deltaAngle < Number.EPSILON) {
                            if (samePoints) deltaAngle = 0;
                            else deltaAngle = twoPi;
                        }
                        if (this._clockwise && !samePoints) {
                            if (deltaAngle === twoPi) deltaAngle = -twoPi;
                            else deltaAngle = deltaAngle - twoPi;
                        }
                        var angle = this._startAngle + t * deltaAngle;
                        var x = this.p0.x + this._xRadius * Math.cos(angle);
                        var y = this.p0.y + this._yRadius * Math.sin(angle);
                        if (this._rotation !== 0) {
                            var cos = Math.cos(this._rotation);
                            var sin = Math.sin(this._rotation);
                            var tx = x - this.p0.x;
                            var ty = y - this.p0.y;
                            // Rotate the point about the center of the ellipse.
                            x = tx * cos - ty * sin + this.p0.x;
                            y = tx * sin + ty * cos + this.p0.y;
                        }
                        return out.set(x, y);
                    },
                    /**
     * Sets the horizontal radius of this curve.
     *
     * @method Phaser.Curves.Ellipse#setXRadius
     * @since 3.0.0
     *
     * @param {number} value - The horizontal radius of this curve.
     *
     * @return {this} This curve object.
     */ setXRadius: function(value) {
                        this.xRadius = value;
                        return this;
                    },
                    /**
     * Sets the vertical radius of this curve.
     *
     * @method Phaser.Curves.Ellipse#setYRadius
     * @since 3.0.0
     *
     * @param {number} value - The vertical radius of this curve.
     *
     * @return {this} This curve object.
     */ setYRadius: function(value) {
                        this.yRadius = value;
                        return this;
                    },
                    /**
     * Sets the width of this curve.
     *
     * @method Phaser.Curves.Ellipse#setWidth
     * @since 3.0.0
     *
     * @param {number} value - The width of this curve.
     *
     * @return {this} This curve object.
     */ setWidth: function(value) {
                        this.xRadius = value / 2;
                        return this;
                    },
                    /**
     * Sets the height of this curve.
     *
     * @method Phaser.Curves.Ellipse#setHeight
     * @since 3.0.0
     *
     * @param {number} value - The height of this curve.
     *
     * @return {this} This curve object.
     */ setHeight: function(value) {
                        this.yRadius = value / 2;
                        return this;
                    },
                    /**
     * Sets the start angle of this curve.
     *
     * @method Phaser.Curves.Ellipse#setStartAngle
     * @since 3.0.0
     *
     * @param {number} value - The start angle of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setStartAngle: function(value) {
                        this.startAngle = value;
                        return this;
                    },
                    /**
     * Sets the end angle of this curve.
     *
     * @method Phaser.Curves.Ellipse#setEndAngle
     * @since 3.0.0
     *
     * @param {number} value - The end angle of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setEndAngle: function(value) {
                        this.endAngle = value;
                        return this;
                    },
                    /**
     * Sets if this curve extends clockwise or anti-clockwise.
     *
     * @method Phaser.Curves.Ellipse#setClockwise
     * @since 3.0.0
     *
     * @param {boolean} value - The clockwise state of this curve.
     *
     * @return {this} This curve object.
     */ setClockwise: function(value) {
                        this.clockwise = value;
                        return this;
                    },
                    /**
     * Sets the rotation of this curve.
     *
     * @method Phaser.Curves.Ellipse#setRotation
     * @since 3.0.0
     *
     * @param {number} value - The rotation of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setRotation: function(value) {
                        this.rotation = value;
                        return this;
                    },
                    /**
     * The x coordinate of the center of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this.p0.x;
                        },
                        set: function(value) {
                            this.p0.x = value;
                        }
                    },
                    /**
     * The y coordinate of the center of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this.p0.y;
                        },
                        set: function(value) {
                            this.p0.y = value;
                        }
                    },
                    /**
     * The horizontal radius of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#xRadius
     * @type {number}
     * @since 3.0.0
     */ xRadius: {
                        get: function() {
                            return this._xRadius;
                        },
                        set: function(value) {
                            this._xRadius = value;
                        }
                    },
                    /**
     * The vertical radius of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#yRadius
     * @type {number}
     * @since 3.0.0
     */ yRadius: {
                        get: function() {
                            return this._yRadius;
                        },
                        set: function(value) {
                            this._yRadius = value;
                        }
                    },
                    /**
     * The start angle of the ellipse in degrees.
     *
     * @name Phaser.Curves.Ellipse#startAngle
     * @type {number}
     * @since 3.0.0
     */ startAngle: {
                        get: function() {
                            return RadToDeg(this._startAngle);
                        },
                        set: function(value) {
                            this._startAngle = DegToRad(value);
                        }
                    },
                    /**
     * The end angle of the ellipse in degrees.
     *
     * @name Phaser.Curves.Ellipse#endAngle
     * @type {number}
     * @since 3.0.0
     */ endAngle: {
                        get: function() {
                            return RadToDeg(this._endAngle);
                        },
                        set: function(value) {
                            this._endAngle = DegToRad(value);
                        }
                    },
                    /**
     * `true` if the ellipse rotation is clockwise or `false` if anti-clockwise.
     *
     * @name Phaser.Curves.Ellipse#clockwise
     * @type {boolean}
     * @since 3.0.0
     */ clockwise: {
                        get: function() {
                            return this._clockwise;
                        },
                        set: function(value) {
                            this._clockwise = value;
                        }
                    },
                    /**
     * The rotation of the ellipse, relative to the center, in degrees.
     *
     * @name Phaser.Curves.Ellipse#angle
     * @type {number}
     * @since 3.14.0
     */ angle: {
                        get: function() {
                            return RadToDeg(this._rotation);
                        },
                        set: function(value) {
                            this._rotation = DegToRad(value);
                        }
                    },
                    /**
     * The rotation of the ellipse, relative to the center, in radians.
     *
     * @name Phaser.Curves.Ellipse#rotation
     * @type {number}
     * @since 3.0.0
     */ rotation: {
                        get: function() {
                            return this._rotation;
                        },
                        set: function(value) {
                            this._rotation = value;
                        }
                    },
                    /**
     * JSON serialization of the curve.
     *
     * @method Phaser.Curves.Ellipse#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONEllipseCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                        return {
                            type: this.type,
                            x: this.p0.x,
                            y: this.p0.y,
                            xRadius: this._xRadius,
                            yRadius: this._yRadius,
                            startAngle: RadToDeg(this._startAngle),
                            endAngle: RadToDeg(this._endAngle),
                            clockwise: this._clockwise,
                            rotation: RadToDeg(this._rotation)
                        };
                    }
                });
                /**
 * Creates a curve from the provided Ellipse Curve Configuration object.
 *
 * @function Phaser.Curves.Ellipse.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONEllipseCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Ellipse} The ellipse curve constructed from the configuration object.
 */ EllipseCurve.fromJSON = function(data) {
                    return new EllipseCurve(data);
                };
                module1.exports = EllipseCurve;
            /***/ },
            /***/ 33951: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
                var Class = __webpack_require__(83419);
                var Curve = __webpack_require__(80021);
                var FromPoints = __webpack_require__(19217);
                var Rectangle = __webpack_require__(87841);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A LineCurve is a "curve" comprising exactly two points (a line segment).
 *
 * @class Line
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2|number[])} p0 - The first endpoint.
 * @param {Phaser.Math.Vector2} [p1] - The second endpoint.
 */ var LineCurve = new Class({
                    Extends: Curve,
                    initialize: //  vec2s or array
                    function LineCurve(p0, p1) {
                        Curve.call(this, 'LineCurve');
                        if (Array.isArray(p0)) {
                            p1 = new Vector2(p0[2], p0[3]);
                            p0 = new Vector2(p0[0], p0[1]);
                        }
                        /**
         * The first endpoint.
         *
         * @name Phaser.Curves.Line#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = p0;
                        /**
         * The second endpoint.
         *
         * @name Phaser.Curves.Line#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p1 = p1;
                        //  Override default Curve.arcLengthDivisions
                        /**
         * The quantity of arc length divisions within the curve.
         *
         * @name Phaser.Curves.Line#arcLengthDivisions
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.arcLengthDivisions = 1;
                    },
                    /**
     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
     *
     * @method Phaser.Curves.Line#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Rectangle} O - [out,$return]
     *
     * @param {Phaser.Geom.Rectangle} [out] - A Rectangle object to store the bounds in. If not given a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
     */ getBounds: function(out) {
                        if (out === undefined) out = new Rectangle();
                        return FromPoints([
                            this.p0,
                            this.p1
                        ], out);
                    },
                    /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Line#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return out.copy(this.p0);
                    },
                    /**
     * Gets the resolution of the line.
     *
     * @method Phaser.Curves.Line#getResolution
     * @since 3.0.0
     *
     * @param {number} [divisions=1] - The number of divisions to consider.
     *
     * @return {number} The resolution. Equal to the number of divisions.
     */ getResolution: function(divisions) {
                        if (divisions === undefined) divisions = 1;
                        return divisions;
                    },
                    /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Line#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        if (t === 1) return out.copy(this.p1);
                        out.copy(this.p1).subtract(this.p0).scale(t).add(this.p0);
                        return out;
                    },
                    // Line curve is linear, so we can overwrite default getPointAt
                    /**
     * Gets a point at a given position on the line.
     *
     * @method Phaser.Curves.Line#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPointAt: function(u, out) {
                        return this.getPoint(u, out);
                    },
                    /**
     * Gets the slope of the line as a unit vector.
     *
     * @method Phaser.Curves.Line#getTangent
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} [t] - The relative position on the line, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} The tangent vector.
     */ getTangent: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        out.copy(this.p1).subtract(this.p0).normalize();
                        return out;
                    },
                    /**
     * Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant.
     *
     * @method Phaser.Curves.Line#getUtoTmapping
     * @since 3.0.0
     *
     * @param {number} u - A float between 0 and 1.
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The equidistant value.
     */ getUtoTmapping: function(u, distance, divisions) {
                        var t;
                        if (distance) {
                            var arcLengths = this.getLengths(divisions);
                            var lineLength = arcLengths[arcLengths.length - 1];
                            //  Cannot overshoot the curve
                            var targetLineLength = Math.min(distance, lineLength);
                            t = targetLineLength / lineLength;
                        } else t = u;
                        return t;
                    },
                    //  Override default Curve.draw because this is better than calling getPoints on a line!
                    /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.lineBetween` so will be drawn at whatever the present Graphics line color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.Line#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
     */ draw: function(graphics) {
                        graphics.lineBetween(this.p0.x, this.p0.y, this.p1.x, this.p1.y);
                        //  So you can chain graphics calls
                        return graphics;
                    },
                    /**
     * Gets a JSON representation of the line.
     *
     * @method Phaser.Curves.Line#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                        return {
                            type: this.type,
                            points: [
                                this.p0.x,
                                this.p0.y,
                                this.p1.x,
                                this.p1.y
                            ]
                        };
                    }
                });
                /**
 * Configures this line from a JSON representation.
 *
 * @function Phaser.Curves.Line.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Line} A new LineCurve object.
 */ LineCurve.fromJSON = function(data) {
                    var points = data.points;
                    var p0 = new Vector2(points[0], points[1]);
                    var p1 = new Vector2(points[2], points[3]);
                    return new LineCurve(p0, p1);
                };
                module1.exports = LineCurve;
            /***/ },
            /***/ 14744: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Curve = __webpack_require__(80021);
                var QuadraticBezierInterpolation = __webpack_require__(32112);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A quadratic Bézier curve constructed from two control points.
 *
 * @class QuadraticBezier
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.2.0
 *
 * @param {(Phaser.Math.Vector2|number[])} p0 - Start point, or an array of point pairs.
 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
 */ var QuadraticBezier = new Class({
                    Extends: Curve,
                    initialize: function QuadraticBezier(p0, p1, p2) {
                        Curve.call(this, 'QuadraticBezierCurve');
                        if (Array.isArray(p0)) {
                            p2 = new Vector2(p0[4], p0[5]);
                            p1 = new Vector2(p0[2], p0[3]);
                            p0 = new Vector2(p0[0], p0[1]);
                        }
                        /**
         * The start point.
         *
         * @name Phaser.Curves.QuadraticBezier#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p0 = p0;
                        /**
         * The first control point.
         *
         * @name Phaser.Curves.QuadraticBezier#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p1 = p1;
                        /**
         * The second control point.
         *
         * @name Phaser.Curves.QuadraticBezier#p2
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p2 = p2;
                    },
                    /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.QuadraticBezier#getStartPoint
     * @since 3.2.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return out.copy(this.p0);
                    },
                    /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.QuadraticBezier#getResolution
     * @since 3.2.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                        return divisions;
                    },
                    /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.QuadraticBezier#getPoint
     * @since 3.2.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        var p0 = this.p0;
                        var p1 = this.p1;
                        var p2 = this.p2;
                        return out.set(QuadraticBezierInterpolation(t, p0.x, p1.x, p2.x), QuadraticBezierInterpolation(t, p0.y, p1.y, p2.y));
                    },
                    /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.strokePoints` so will be drawn at whatever the present Graphics stroke color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.QuadraticBezier#draw
     * @since 3.2.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - `Graphics` object to draw onto.
     * @param {number} [pointsTotal=32] - Number of points to be used for drawing the curve. Higher numbers result in smoother curve but require more processing.
     *
     * @return {Phaser.GameObjects.Graphics} `Graphics` object that was drawn to.
     */ draw: function(graphics, pointsTotal) {
                        if (pointsTotal === undefined) pointsTotal = 32;
                        var points = this.getPoints(pointsTotal);
                        graphics.beginPath();
                        graphics.moveTo(this.p0.x, this.p0.y);
                        for(var i = 1; i < points.length; i++)graphics.lineTo(points[i].x, points[i].y);
                        graphics.strokePath();
                        //  So you can chain graphics calls
                        return graphics;
                    },
                    /**
     * Converts the curve into a JSON compatible object.
     *
     * @method Phaser.Curves.QuadraticBezier#toJSON
     * @since 3.2.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                        return {
                            type: this.type,
                            points: [
                                this.p0.x,
                                this.p0.y,
                                this.p1.x,
                                this.p1.y,
                                this.p2.x,
                                this.p2.y
                            ]
                        };
                    }
                });
                /**
 * Creates a curve from a JSON object, e. g. created by `toJSON`.
 *
 * @function Phaser.Curves.QuadraticBezier.fromJSON
 * @since 3.2.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.QuadraticBezier} The created curve instance.
 */ QuadraticBezier.fromJSON = function(data) {
                    var points = data.points;
                    var p0 = new Vector2(points[0], points[1]);
                    var p1 = new Vector2(points[2], points[3]);
                    var p2 = new Vector2(points[4], points[5]);
                    return new QuadraticBezier(p0, p1, p2);
                };
                module1.exports = QuadraticBezier;
            /***/ },
            /***/ 42534: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
                var CatmullRom = __webpack_require__(87842);
                var Class = __webpack_require__(83419);
                var Curve = __webpack_require__(80021);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * Create a smooth 2d spline curve from a series of points.
 *
 * @class Spline
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2[]|number[]|number[][])} [points] - The points that configure the curve.
 */ var SplineCurve = new Class({
                    Extends: Curve,
                    initialize: function SplineCurve(points) {
                        if (points === undefined) points = [];
                        Curve.call(this, 'SplineCurve');
                        /**
         * The Vector2 points that configure the curve.
         *
         * @name Phaser.Curves.Spline#points
         * @type {Phaser.Math.Vector2[]}
         * @default []
         * @since 3.0.0
         */ this.points = [];
                        this.addPoints(points);
                    },
                    /**
     * Add a list of points to the current list of Vector2 points of the curve.
     *
     * @method Phaser.Curves.Spline#addPoints
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2[]|number[]|number[][])} points - The points that configure the curve.
     *
     * @return {this} This curve object.
     */ addPoints: function(points) {
                        for(var i = 0; i < points.length; i++){
                            var p = new Vector2();
                            if (typeof points[i] === 'number') {
                                p.x = points[i];
                                p.y = points[i + 1];
                                i++;
                            } else if (Array.isArray(points[i])) {
                                //  An array of arrays?
                                p.x = points[i][0];
                                p.y = points[i][1];
                            } else {
                                p.x = points[i].x;
                                p.y = points[i].y;
                            }
                            this.points.push(p);
                        }
                        return this;
                    },
                    /**
     * Add a point to the current list of Vector2 points of the curve.
     *
     * @method Phaser.Curves.Spline#addPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of this curve
     * @param {number} y - The y coordinate of this curve
     *
     * @return {Phaser.Math.Vector2} The new Vector2 added to the curve
     */ addPoint: function(x, y) {
                        var vec = new Vector2(x, y);
                        this.points.push(vec);
                        return vec;
                    },
                    /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Spline#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return out.copy(this.points[0]);
                    },
                    /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.Spline#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                        return divisions * this.points.length;
                    },
                    /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Spline#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        var points = this.points;
                        var point = (points.length - 1) * t;
                        var intPoint = Math.floor(point);
                        var weight = point - intPoint;
                        var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
                        var p1 = points[intPoint];
                        var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
                        var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
                        return out.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
                    },
                    /**
     * Exports a JSON object containing this curve data.
     *
     * @method Phaser.Curves.Spline#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                        var points = [];
                        for(var i = 0; i < this.points.length; i++){
                            points.push(this.points[i].x);
                            points.push(this.points[i].y);
                        }
                        return {
                            type: this.type,
                            points: points
                        };
                    }
                });
                /**
 * Imports a JSON object containing this curve data.
 *
 * @function Phaser.Curves.Spline.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Spline} The spline curve created.
 */ SplineCurve.fromJSON = function(data) {
                    return new SplineCurve(data.points);
                };
                module1.exports = SplineCurve;
            /***/ },
            /***/ 25410: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Curves
 */ module1.exports = {
                    Path: __webpack_require__(46669),
                    MoveTo: __webpack_require__(68618),
                    CubicBezier: __webpack_require__(46728),
                    Curve: __webpack_require__(80021),
                    Ellipse: __webpack_require__(73825),
                    Line: __webpack_require__(33951),
                    QuadraticBezier: __webpack_require__(14744),
                    Spline: __webpack_require__(42534)
                };
            /***/ },
            /***/ 68618: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A MoveTo Curve is a very simple curve consisting of only a single point.
 * Its intended use is to move the ending point in a Path.
 *
 * @class MoveTo
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - `x` pixel coordinate.
 * @param {number} [y=0] - `y` pixel coordinate.
 */ var MoveTo = new Class({
                    initialize: function MoveTo(x, y) {
                        /**
         * Denotes that this Curve does not influence the bounds, points, and drawing of its parent Path. Must be `false` or some methods in the parent Path will throw errors.
         *
         * @name Phaser.Curves.MoveTo#active
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.active = false;
                        /**
         * The lone point which this curve consists of.
         *
         * @name Phaser.Curves.MoveTo#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = new Vector2(x, y);
                    },
                    /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.MoveTo#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        return out.copy(this.p0);
                    },
                    /**
     * Retrieves the point at given position in the curve. This will always return this curve's only point.
     *
     * @method Phaser.Curves.MoveTo#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The position in the path to retrieve, between 0 and 1. Not used.
     * @param {Phaser.Math.Vector2} [out] - An optional vector in which to store the point.
     *
     * @return {Phaser.Math.Vector2} The modified `out` vector, or a new `Vector2` if none was provided.
     */ getPointAt: function(u, out) {
                        return this.getPoint(u, out);
                    },
                    /**
     * Gets the resolution of this curve.
     *
     * @method Phaser.Curves.MoveTo#getResolution
     * @since 3.0.0
     *
     * @return {number} The resolution of this curve. For a MoveTo the value is always 1.
     */ getResolution: function() {
                        return 1;
                    },
                    /**
     * Gets the length of this curve.
     *
     * @method Phaser.Curves.MoveTo#getLength
     * @since 3.0.0
     *
     * @return {number} The length of this curve. For a MoveTo the value is always 0.
     */ getLength: function() {
                        return 0;
                    },
                    /**
     * Converts this curve into a JSON-serializable object.
     *
     * @method Phaser.Curves.MoveTo#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} A primitive object with the curve's type and only point.
     */ toJSON: function() {
                        return {
                            type: 'MoveTo',
                            points: [
                                this.p0.x,
                                this.p0.y
                            ]
                        };
                    }
                });
                module1.exports = MoveTo;
            /***/ },
            /***/ 46669: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
                var Class = __webpack_require__(83419);
                var CubicBezierCurve = __webpack_require__(46728);
                var EllipseCurve = __webpack_require__(73825);
                var GameObjectFactory = __webpack_require__(39429);
                var LineCurve = __webpack_require__(33951);
                var MovePathTo = __webpack_require__(68618);
                var QuadraticBezierCurve = __webpack_require__(14744);
                var Rectangle = __webpack_require__(87841);
                var SplineCurve = __webpack_require__(42534);
                var Vector2 = __webpack_require__(26099);
                var MATH_CONST = __webpack_require__(36383);
                /**
 * @classdesc
 * A Path combines multiple Curves into one continuous compound curve.
 * It does not matter how many Curves are in the Path or what type they are.
 *
 * A Curve in a Path does not have to start where the previous Curve ends - that is to say, a Path does not
 * have to be an uninterrupted curve. Only the order of the Curves influences the actual points on the Path.
 *
 * @class Path
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The X coordinate of the Path's starting point or a {@link Phaser.Types.Curves.JSONPath}.
 * @param {number} [y=0] - The Y coordinate of the Path's starting point.
 */ var Path = new Class({
                    initialize: function Path(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        /**
         * The name of this Path.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.Curves.Path#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = '';
                        /**
         * The default number of divisions within a curve.
         *
         * @name Phaser.Curves.Path#defaultDivisions
         * @type {number}
         * @default 12
         * @since 3.70.0
         */ this.defaultDivisions = 12;
                        /**
         * The list of Curves which make up this Path.
         *
         * @name Phaser.Curves.Path#curves
         * @type {Phaser.Curves.Curve[]}
         * @default []
         * @since 3.0.0
         */ this.curves = [];
                        /**
         * The cached length of each Curve in the Path.
         *
         * Used internally by {@link #getCurveLengths}.
         *
         * @name Phaser.Curves.Path#cacheLengths
         * @type {number[]}
         * @default []
         * @since 3.0.0
         */ this.cacheLengths = [];
                        /**
         * Automatically closes the path.
         *
         * @name Phaser.Curves.Path#autoClose
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.autoClose = false;
                        /**
         * The starting point of the Path.
         *
         * This is not necessarily equivalent to the starting point of the first Curve in the Path. In an empty Path, it's also treated as the ending point.
         *
         * @name Phaser.Curves.Path#startPoint
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.startPoint = new Vector2();
                        /**
         * A temporary vector used to avoid object creation when adding a Curve to the Path.
         *
         * @name Phaser.Curves.Path#_tmpVec2A
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2A = new Vector2();
                        /**
         * A temporary vector used to avoid object creation when adding a Curve to the Path.
         *
         * @name Phaser.Curves.Path#_tmpVec2B
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2B = new Vector2();
                        if (typeof x === 'object') this.fromJSON(x);
                        else this.startPoint.set(x, y);
                    },
                    /**
     * Appends a Curve to the end of the Path.
     *
     * The Curve does not have to start where the Path ends or, for an empty Path, at its defined starting point.
     *
     * @method Phaser.Curves.Path#add
     * @since 3.0.0
     *
     * @param {Phaser.Curves.Curve} curve - The Curve to append.
     *
     * @return {this} This Path object.
     */ add: function(curve) {
                        this.curves.push(curve);
                        return this;
                    },
                    /**
     * Creates a circular Ellipse Curve positioned at the end of the Path.
     *
     * @method Phaser.Curves.Path#circleTo
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the circle.
     * @param {boolean} [clockwise=false] - `true` to create a clockwise circle as opposed to a counter-clockwise circle.
     * @param {number} [rotation=0] - The rotation of the circle in degrees.
     *
     * @return {this} This Path object.
     */ circleTo: function(radius, clockwise, rotation) {
                        if (clockwise === undefined) clockwise = false;
                        return this.ellipseTo(radius, radius, 0, 360, clockwise, rotation);
                    },
                    /**
     * Ensures that the Path is closed.
     *
     * A closed Path starts and ends at the same point. If the Path is not closed, a straight Line Curve will be created from the ending point directly to the starting point. During the check, the actual starting point of the Path, i.e. the starting point of the first Curve, will be used as opposed to the Path's defined {@link startPoint}, which could differ.
     *
     * Calling this method on an empty Path will result in an error.
     *
     * @method Phaser.Curves.Path#closePath
     * @since 3.0.0
     *
     * @return {this} This Path object.
     */ closePath: function() {
                        // Add a line curve if start and end of lines are not connected
                        var startPoint = this.curves[0].getPoint(0);
                        var endPoint = this.curves[this.curves.length - 1].getPoint(1);
                        if (!startPoint.equals(endPoint)) //  This will copy a reference to the vectors, which probably isn't sensible
                        this.curves.push(new LineCurve(endPoint, startPoint));
                        return this;
                    },
                    /**
     * Creates a cubic bezier curve starting at the previous end point and ending at p3, using p1 and p2 as control points.
     *
     * @method Phaser.Curves.Path#cubicBezierTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2)} x - The x coordinate of the end point. Or, if a Vector2, the p1 value.
     * @param {(number|Phaser.Math.Vector2)} y - The y coordinate of the end point. Or, if a Vector2, the p2 value.
     * @param {(number|Phaser.Math.Vector2)} control1X - The x coordinate of the first control point. Or, if a Vector2, the p3 value.
     * @param {number} [control1Y] - The y coordinate of the first control point. Not used if Vector2s are provided as the first 3 arguments.
     * @param {number} [control2X] - The x coordinate of the second control point. Not used if Vector2s are provided as the first 3 arguments.
     * @param {number} [control2Y] - The y coordinate of the second control point. Not used if Vector2s are provided as the first 3 arguments.
     *
     * @return {this} This Path object.
     */ cubicBezierTo: function(x, y, control1X, control1Y, control2X, control2Y) {
                        var p0 = this.getEndPoint();
                        var p1;
                        var p2;
                        var p3;
                        //  Assume they're all Vector2s
                        if (x instanceof Vector2) {
                            p1 = x;
                            p2 = y;
                            p3 = control1X;
                        } else {
                            p1 = new Vector2(control1X, control1Y);
                            p2 = new Vector2(control2X, control2Y);
                            p3 = new Vector2(x, y);
                        }
                        return this.add(new CubicBezierCurve(p0, p1, p2, p3));
                    },
                    //  Creates a quadratic bezier curve starting at the previous end point and ending at p2, using p1 as a control point
                    /**
     * Creates a Quadratic Bezier Curve starting at the ending point of the Path.
     *
     * @method Phaser.Curves.Path#quadraticBezierTo
     * @since 3.2.0
     *
     * @param {(number|Phaser.Math.Vector2[])} x - The X coordinate of the second control point or, if it's a `Vector2`, the first control point.
     * @param {number} [y] - The Y coordinate of the second control point or, if `x` is a `Vector2`, the second control point.
     * @param {number} [controlX] - If `x` is not a `Vector2`, the X coordinate of the first control point.
     * @param {number} [controlY] - If `x` is not a `Vector2`, the Y coordinate of the first control point.
     *
     * @return {this} This Path object.
     */ quadraticBezierTo: function(x, y, controlX, controlY) {
                        var p0 = this.getEndPoint();
                        var p1;
                        var p2;
                        //  Assume they're all Vector2s
                        if (x instanceof Vector2) {
                            p1 = x;
                            p2 = y;
                        } else {
                            p1 = new Vector2(controlX, controlY);
                            p2 = new Vector2(x, y);
                        }
                        return this.add(new QuadraticBezierCurve(p0, p1, p2));
                    },
                    /**
     * Draws all Curves in the Path to a Graphics Game Object.
     *
     * @method Phaser.Curves.Path#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [out,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics Game Object to draw to.
     * @param {number} [pointsTotal=32] - The number of points to draw for each Curve. Higher numbers result in a smoother curve but require more processing.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object which was drawn to.
     */ draw: function(graphics, pointsTotal) {
                        for(var i = 0; i < this.curves.length; i++){
                            var curve = this.curves[i];
                            if (!curve.active) continue;
                            curve.draw(graphics, pointsTotal);
                        }
                        return graphics;
                    },
                    /**
     * Creates an ellipse curve positioned at the previous end point, using the given parameters.
     *
     * @method Phaser.Curves.Path#ellipseTo
     * @since 3.0.0
     *
     * @param {number} [xRadius=0] - The horizontal radius of ellipse.
     * @param {number} [yRadius=0] - The vertical radius of ellipse.
     * @param {number} [startAngle=0] - The start angle of the ellipse, in degrees.
     * @param {number} [endAngle=360] - The end angle of the ellipse, in degrees.
     * @param {boolean} [clockwise=false] - Whether the ellipse angles are given as clockwise (`true`) or counter-clockwise (`false`).
     * @param {number} [rotation=0] - The rotation of the ellipse, in degrees.
     *
     * @return {this} This Path object.
     */ ellipseTo: function(xRadius, yRadius, startAngle, endAngle, clockwise, rotation) {
                        var ellipse = new EllipseCurve(0, 0, xRadius, yRadius, startAngle, endAngle, clockwise, rotation);
                        var end = this.getEndPoint(this._tmpVec2A);
                        //  Calculate where to center the ellipse
                        var start = ellipse.getStartPoint(this._tmpVec2B);
                        end.subtract(start);
                        ellipse.x = end.x;
                        ellipse.y = end.y;
                        return this.add(ellipse);
                    },
                    /**
     * Creates a Path from a Path Configuration object.
     *
     * The provided object should be a {@link Phaser.Types.Curves.JSONPath}, as returned by {@link #toJSON}. Providing a malformed object may cause errors.
     *
     * @method Phaser.Curves.Path#fromJSON
     * @since 3.0.0
     *
     * @param {Phaser.Types.Curves.JSONPath} data - The JSON object containing the Path data.
     *
     * @return {this} This Path object.
     */ fromJSON: function(data) {
                        //  data should be an object matching the Path.toJSON object structure.
                        this.curves = [];
                        this.cacheLengths = [];
                        this.startPoint.set(data.x, data.y);
                        this.autoClose = data.autoClose;
                        for(var i = 0; i < data.curves.length; i++){
                            var curve = data.curves[i];
                            switch(curve.type){
                                case 'LineCurve':
                                    this.add(LineCurve.fromJSON(curve));
                                    break;
                                case 'EllipseCurve':
                                    this.add(EllipseCurve.fromJSON(curve));
                                    break;
                                case 'SplineCurve':
                                    this.add(SplineCurve.fromJSON(curve));
                                    break;
                                case 'CubicBezierCurve':
                                    this.add(CubicBezierCurve.fromJSON(curve));
                                    break;
                                case 'QuadraticBezierCurve':
                                    this.add(QuadraticBezierCurve.fromJSON(curve));
                                    break;
                            }
                        }
                        return this;
                    },
                    /**
     * Returns a Rectangle with a position and size matching the bounds of this Path.
     *
     * @method Phaser.Curves.Path#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the bounds in.
     * @param {number} [accuracy=16] - The accuracy of the bounds calculations. Higher values are more accurate at the cost of calculation speed.
     *
     * @return {Phaser.Geom.Rectangle} The modified `out` Rectangle, or a new Rectangle if none was provided.
     */ getBounds: function(out, accuracy) {
                        if (out === undefined) out = new Rectangle();
                        if (accuracy === undefined) accuracy = 16;
                        out.x = Number.MAX_VALUE;
                        out.y = Number.MAX_VALUE;
                        var bounds = new Rectangle();
                        var maxRight = MATH_CONST.MIN_SAFE_INTEGER;
                        var maxBottom = MATH_CONST.MIN_SAFE_INTEGER;
                        for(var i = 0; i < this.curves.length; i++){
                            var curve = this.curves[i];
                            if (!curve.active) continue;
                            curve.getBounds(bounds, accuracy);
                            out.x = Math.min(out.x, bounds.x);
                            out.y = Math.min(out.y, bounds.y);
                            maxRight = Math.max(maxRight, bounds.right);
                            maxBottom = Math.max(maxBottom, bounds.bottom);
                        }
                        out.right = maxRight;
                        out.bottom = maxBottom;
                        return out;
                    },
                    /**
     * Returns an array containing the length of the Path at the end of each Curve.
     *
     * The result of this method will be cached to avoid recalculating it in subsequent calls. The cache is only invalidated when the {@link #curves} array changes in length, leading to potential inaccuracies if a Curve in the Path is changed, or if a Curve is removed and another is added in its place.
     *
     * @method Phaser.Curves.Path#getCurveLengths
     * @since 3.0.0
     *
     * @return {number[]} An array containing the length of the Path at the end of each one of its Curves.
     */ getCurveLengths: function() {
                        // We use cache values if curves and cache array are same length
                        if (this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                        // Get length of sub-curve
                        // Push sums into cached array
                        var lengths = [];
                        var sums = 0;
                        for(var i = 0; i < this.curves.length; i++){
                            sums += this.curves[i].getLength();
                            lengths.push(sums);
                        }
                        this.cacheLengths = lengths;
                        return lengths;
                    },
                    /**
     * Returns the Curve that forms the Path at the given normalized location (between 0 and 1).
     *
     * @method Phaser.Curves.Path#getCurveAt
     * @since 3.60.0
     *
     * @param {number} t - The normalized location on the Path, between 0 and 1.
     *
     * @return {?Phaser.Curves.Curve} The Curve that is part of this Path at a given location, or `null` if no curve was found.
     */ getCurveAt: function(t) {
                        var d = t * this.getLength();
                        var curveLengths = this.getCurveLengths();
                        var i = 0;
                        while(i < curveLengths.length){
                            if (curveLengths[i] >= d) return this.curves[i];
                            i++;
                        }
                        return null;
                    },
                    /**
     * Returns the ending point of the Path.
     *
     * A Path's ending point is equivalent to the ending point of the last Curve in the Path. For an empty Path, the ending point is at the Path's defined {@link #startPoint}.
     *
     * @method Phaser.Curves.Path#getEndPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - The object to store the point in.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new Vector2 if none was provided.
     */ getEndPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        if (this.curves.length > 0) this.curves[this.curves.length - 1].getPoint(1, out);
                        else out.copy(this.startPoint);
                        return out;
                    },
                    /**
     * Returns the total length of the Path.
     *
     * @see {@link #getCurveLengths}
     *
     * @method Phaser.Curves.Path#getLength
     * @since 3.0.0
     *
     * @return {number} The total length of the Path.
     */ getLength: function() {
                        var lens = this.getCurveLengths();
                        return lens[lens.length - 1];
                    },
                    // To get accurate point with reference to
                    // entire path distance at time t,
                    // following has to be done:
                    // 1. Length of each sub path have to be known
                    // 2. Locate and identify type of curve
                    // 3. Get t for the curve
                    // 4. Return curve.getPointAt(t')
                    /**
     * Calculates the coordinates of the point at the given normalized location (between 0 and 1) on the Path.
     *
     * The location is relative to the entire Path, not to an individual Curve. A location of 0.5 is always in the middle of the Path and is thus an equal distance away from both its starting and ending points. In a Path with one Curve, it would be in the middle of the Curve; in a Path with two Curves, it could be anywhere on either one of them depending on their lengths.
     *
     * @method Phaser.Curves.Path#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The location of the point to return, between 0 and 1.
     * @param {Phaser.Math.Vector2} [out] - The object in which to store the calculated point.
     *
     * @return {?Phaser.Math.Vector2} The modified `out` object, or a new `Vector2` if none was provided.
     */ getPoint: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        var d = t * this.getLength();
                        var curveLengths = this.getCurveLengths();
                        var i = 0;
                        while(i < curveLengths.length){
                            if (curveLengths[i] >= d) {
                                var diff = curveLengths[i] - d;
                                var curve = this.curves[i];
                                var segmentLength = curve.getLength();
                                var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                                return curve.getPointAt(u, out);
                            }
                            i++;
                        }
                        // loop where sum != 0, sum > d , sum+1 <d
                        return null;
                    },
                    /**
     * Get a sequence of points on the path.
     *
     * @method Phaser.Curves.Path#getPoints
     * @since 3.0.0
     *
     * @param {number} [divisions] - The number of divisions to make per resolution per curve.
     * @param {number} [stepRate] - The curve distance between points per curve, implying `divisions`.
     *
     * @return {Phaser.Math.Vector2[]} An array of Vector2 objects that containing the points along the Path.
     */ getPoints: function(divisions, stepRate) {
                        //  If divisions and stepRate are falsey values (false, null, 0, undefined, etc) then we use the default divisions value.
                        if (!divisions && !stepRate) divisions = this.defaultDivisions;
                        var points = [];
                        var last;
                        for(var i = 0; i < this.curves.length; i++){
                            var curve = this.curves[i];
                            if (!curve.active) continue;
                            var resolution = curve.getResolution(divisions);
                            var pts = curve.getPoints(resolution, stepRate);
                            for(var j = 0; j < pts.length; j++){
                                var point = pts[j];
                                if (last && last.equals(point)) continue;
                                points.push(point);
                                last = point;
                            }
                        }
                        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
                        return points;
                    },
                    /**
     * Returns a randomly chosen point anywhere on the path. This follows the same rules as `getPoint` in that it may return a point on any Curve inside this path.
     *
     * When calling this method multiple times, the points are not guaranteed to be equally spaced spatially.
     *
     * @method Phaser.Curves.Path#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - `Vector2` instance that should be used for storing the result. If `undefined` a new `Vector2` will be created.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new `Vector2` if none was provided.
     */ getRandomPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return this.getPoint(Math.random(), out);
                    },
                    /**
     * Divides this Path into a set of equally spaced points,
     *
     * The resulting points are equally spaced with respect to the points' position on the path, but not necessarily equally spaced spatially.
     *
     * @method Phaser.Curves.Path#getSpacedPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=40] - The amount of points to divide this Path into.
     *
     * @return {Phaser.Math.Vector2[]} A list of the points this path was subdivided into.
     */ getSpacedPoints: function(divisions) {
                        if (divisions === undefined) divisions = 40;
                        var points = [];
                        for(var i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
                        if (this.autoClose) points.push(points[0]);
                        return points;
                    },
                    /**
     * Returns the starting point of the Path.
     *
     * @method Phaser.Curves.Path#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - `Vector2` instance that should be used for storing the result. If `undefined` a new `Vector2` will be created.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new Vector2 if none was provided.
     */ getStartPoint: function(out) {
                        if (out === undefined) out = new Vector2();
                        return out.copy(this.startPoint);
                    },
                    /**
     * Gets a unit vector tangent at a relative position on the path.
     *
     * @method Phaser.Curves.Path#getTangent
     * @since 3.23.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The relative position on the path, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector approximating the tangent line at the point t (delta +/- 0.0001)
     */ getTangent: function(t, out) {
                        if (out === undefined) out = new Vector2();
                        var d = t * this.getLength();
                        var curveLengths = this.getCurveLengths();
                        var i = 0;
                        while(i < curveLengths.length){
                            if (curveLengths[i] >= d) {
                                var diff = curveLengths[i] - d;
                                var curve = this.curves[i];
                                var segmentLength = curve.getLength();
                                var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                                return curve.getTangentAt(u, out);
                            }
                            i++;
                        }
                        return null;
                    },
                    /**
     * Creates a line curve from the previous end point to x/y.
     *
     * @method Phaser.Curves.Path#lineTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2|Phaser.Types.Math.Vector2Like)} x - The X coordinate of the line's end point, or a `Vector2` / `Vector2Like` containing the entire end point.
     * @param {number} [y] - The Y coordinate of the line's end point, if a number was passed as the X parameter.
     *
     * @return {this} This Path object.
     */ lineTo: function(x, y) {
                        if (x instanceof Vector2) this._tmpVec2B.copy(x);
                        else if (typeof x === 'object') this._tmpVec2B.setFromObject(x);
                        else this._tmpVec2B.set(x, y);
                        var end = this.getEndPoint(this._tmpVec2A);
                        return this.add(new LineCurve([
                            end.x,
                            end.y,
                            this._tmpVec2B.x,
                            this._tmpVec2B.y
                        ]));
                    },
                    /**
     * Creates a spline curve starting at the previous end point, using the given points on the curve.
     *
     * @method Phaser.Curves.Path#splineTo
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2[]} points - The points the newly created spline curve should consist of.
     *
     * @return {this} This Path object.
     */ splineTo: function(points) {
                        points.unshift(this.getEndPoint());
                        return this.add(new SplineCurve(points));
                    },
                    /**
     * Creates a "gap" in this path from the path's current end point to the given coordinates.
     *
     * After calling this function, this Path's end point will be equal to the given coordinates
     *
     * @method Phaser.Curves.Path#moveTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2|Phaser.Types.Math.Vector2Like)} x - The X coordinate of the position to move the path's end point to, or a `Vector2` / `Vector2Like` containing the entire new end point.
     * @param {number} [y] - The Y coordinate of the position to move the path's end point to, if a number was passed as the X coordinate.
     *
     * @return {this} This Path object.
     */ moveTo: function(x, y) {
                        if (x instanceof Vector2) return this.add(new MovePathTo(x.x, x.y));
                        else return this.add(new MovePathTo(x, y));
                    },
                    /**
     * Converts this Path to a JSON object containing the path information and its constituent curves.
     *
     * @method Phaser.Curves.Path#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONPath} The JSON object containing this path's data.
     */ toJSON: function() {
                        var out = [];
                        for(var i = 0; i < this.curves.length; i++)out.push(this.curves[i].toJSON());
                        return {
                            type: 'Path',
                            x: this.startPoint.x,
                            y: this.startPoint.y,
                            autoClose: this.autoClose,
                            curves: out
                        };
                    },
                    /**
     * cacheLengths must be recalculated.
     *
     * @method Phaser.Curves.Path#updateArcLengths
     * @since 3.0.0
     */ updateArcLengths: function() {
                        this.cacheLengths = [];
                        this.getCurveLengths();
                    },
                    /**
     * Disposes of this Path, clearing its internal references to objects so they can be garbage-collected.
     *
     * @method Phaser.Curves.Path#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.curves.length = 0;
                        this.cacheLengths.length = 0;
                        this.startPoint = undefined;
                    }
                });
                /**
 * Creates a new Path Object.
 *
 * @method Phaser.GameObjects.GameObjectFactory#path
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Path.
 * @param {number} y - The vertical position of this Path.
 *
 * @return {Phaser.Curves.Path} The Path Object that was created.
 */ GameObjectFactory.register('path', function(x, y) {
                    return new Path(x, y);
                });
                //  When registering a factory function 'this' refers to the GameObjectFactory context.
                //
                //  There are several properties available to use:
                //
                //  this.scene - a reference to the Scene that owns the GameObjectFactory
                //  this.displayList - a reference to the Display List the Scene owns
                //  this.updateList - a reference to the Update List the Scene owns
                module1.exports = Path;
            /***/ },
            /***/ 45893: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Events = __webpack_require__(24882);
                /**
 * @callback DataEachCallback
 *
 * @param {*} parent - The parent object of the DataManager.
 * @param {string} key - The key of the value.
 * @param {*} value - The value.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
 */ /**
 * @classdesc
 * The Data Manager Component features a means to store pieces of data specific to a Game Object, System or Plugin.
 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
 * or have a property called `events` that is an instance of it.
 *
 * @class DataManager
 * @memberof Phaser.Data
 * @constructor
 * @since 3.0.0
 *
 * @param {object} parent - The object that this DataManager belongs to.
 * @param {Phaser.Events.EventEmitter} [eventEmitter] - The DataManager's event emitter.
 */ var DataManager = new Class({
                    initialize: function DataManager(parent, eventEmitter) {
                        /**
         * The object that this DataManager belongs to.
         *
         * @name Phaser.Data.DataManager#parent
         * @type {*}
         * @since 3.0.0
         */ this.parent = parent;
                        /**
         * The DataManager's event emitter.
         *
         * @name Phaser.Data.DataManager#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = eventEmitter;
                        if (!eventEmitter) this.events = parent.events ? parent.events : parent;
                        /**
         * The data list.
         *
         * @name Phaser.Data.DataManager#list
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.0.0
         */ this.list = {};
                        /**
         * The public values list. You can use this to access anything you have stored
         * in this Data Manager. For example, if you set a value called `gold` you can
         * access it via:
         *
         * ```javascript
         * this.data.values.gold;
         * ```
         *
         * You can also modify it directly:
         *
         * ```javascript
         * this.data.values.gold += 1000;
         * ```
         *
         * Doing so will emit a `setdata` event from the parent of this Data Manager.
         *
         * Do not modify this object directly. Adding properties directly to this object will not
         * emit any events. Always use `DataManager.set` to create new items the first time around.
         *
         * @name Phaser.Data.DataManager#values
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.10.0
         */ this.values = {};
                        /**
         * Whether setting data is frozen for this DataManager.
         *
         * @name Phaser.Data.DataManager#_frozen
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._frozen = false;
                        if (!parent.hasOwnProperty('sys') && this.events) this.events.once(Events.DESTROY, this.destroy, this);
                    },
                    /**
     * Retrieves the value for the given key, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * this.data.get('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * this.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * this.data.get([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.Data.DataManager#get
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ get: function(key) {
                        var list = this.list;
                        if (Array.isArray(key)) {
                            var output = [];
                            for(var i = 0; i < key.length; i++)output.push(list[key[i]]);
                            return output;
                        } else return list[key];
                    },
                    /**
     * Retrieves all data values in a new object.
     *
     * @method Phaser.Data.DataManager#getAll
     * @since 3.0.0
     *
     * @return {Object.<string, *>} All data values.
     */ getAll: function() {
                        var results = {};
                        for(var key in this.list)if (this.list.hasOwnProperty(key)) results[key] = this.list[key];
                        return results;
                    },
                    /**
     * Queries the DataManager for the values of keys matching the given regular expression.
     *
     * @method Phaser.Data.DataManager#query
     * @since 3.0.0
     *
     * @param {RegExp} search - A regular expression object. If a non-RegExp object obj is passed, it is implicitly converted to a RegExp by using new RegExp(obj).
     *
     * @return {Object.<string, *>} The values of the keys matching the search string.
     */ query: function(search) {
                        var results = {};
                        for(var key in this.list)if (this.list.hasOwnProperty(key) && key.match(search)) results[key] = this.list[key];
                        return results;
                    },
                    /**
     * Sets a value for the given key. If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * data.set('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * data.set({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `get`:
     *
     * ```javascript
     * data.get('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.Data.DataManager#set
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.0.0
     *
     * @generic {any} T
     * @genericUse {(string|T)} - [key]
     *
     * @param {(string|object)} key - The key to set the value for. Or an object of key value pairs. If an object the `data` argument is ignored.
     * @param {*} [data] - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This Data Manager instance.
     */ set: function(key, data) {
                        if (this._frozen) return this;
                        if (typeof key === 'string') return this.setValue(key, data);
                        else for(var entry in key)this.setValue(entry, key[entry]);
                        return this;
                    },
                    /**
     * Increase a value for the given key. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * @method Phaser.Data.DataManager#inc
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.23.0
     *
     * @param {string} key - The key to change the value for.
     * @param {number} [amount=1] - The amount to increase the given key by. Pass a negative value to decrease the key.
     *
     * @return {this} This Data Manager instance.
     */ inc: function(key, amount) {
                        if (this._frozen) return this;
                        if (amount === undefined) amount = 1;
                        var value = this.get(key);
                        if (value === undefined) value = 0;
                        this.set(key, value + amount);
                        return this;
                    },
                    /**
     * Toggle a boolean value for the given key. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * @method Phaser.Data.DataManager#toggle
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.23.0
     *
     * @param {string} key - The key to toggle the value for.
     *
     * @return {this} This Data Manager instance.
     */ toggle: function(key) {
                        if (this._frozen) return this;
                        this.set(key, !this.get(key));
                        return this;
                    },
                    /**
     * Internal value setter, called automatically by the `set` method.
     *
     * @method Phaser.Data.DataManager#setValue
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @private
     * @since 3.10.0
     *
     * @param {string} key - The key to set the value for.
     * @param {*} data - The value to set.
     *
     * @return {this} This Data Manager instance.
     */ setValue: function(key, data) {
                        if (this._frozen) return this;
                        if (this.has(key)) //  Hit the key getter, which will in turn emit the events.
                        this.values[key] = data;
                        else {
                            var _this = this;
                            var list = this.list;
                            var events = this.events;
                            var parent = this.parent;
                            Object.defineProperty(this.values, key, {
                                enumerable: true,
                                configurable: true,
                                get: function() {
                                    return list[key];
                                },
                                set: function(value) {
                                    if (!_this._frozen) {
                                        var previousValue = list[key];
                                        list[key] = value;
                                        events.emit(Events.CHANGE_DATA, parent, key, value, previousValue);
                                        events.emit(Events.CHANGE_DATA_KEY + key, parent, value, previousValue);
                                    }
                                }
                            });
                            list[key] = data;
                            events.emit(Events.SET_DATA, parent, key, data);
                        }
                        return this;
                    },
                    /**
     * Passes all data entries to the given callback.
     *
     * @method Phaser.Data.DataManager#each
     * @since 3.0.0
     *
     * @param {DataEachCallback} callback - The function to call.
     * @param {*} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
     *
     * @return {this} This Data Manager instance.
     */ each: function(callback, context) {
                        var args = [
                            this.parent,
                            null,
                            undefined
                        ];
                        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                        for(var key in this.list){
                            args[1] = key;
                            args[2] = this.list[key];
                            callback.apply(context, args);
                        }
                        return this;
                    },
                    /**
     * Merge the given object of key value pairs into this DataManager.
     *
     * Any newly created values will emit a `setdata` event. Any updated values (see the `overwrite` argument)
     * will emit a `changedata` event.
     *
     * @method Phaser.Data.DataManager#merge
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.0.0
     *
     * @param {Object.<string, *>} data - The data to merge.
     * @param {boolean} [overwrite=true] - Whether to overwrite existing data. Defaults to true.
     *
     * @return {this} This Data Manager instance.
     */ merge: function(data, overwrite) {
                        if (overwrite === undefined) overwrite = true;
                        //  Merge data from another component into this one
                        for(var key in data)if (data.hasOwnProperty(key) && (overwrite || !overwrite && !this.has(key))) this.setValue(key, data[key]);
                        return this;
                    },
                    /**
     * Remove the value for the given key.
     *
     * If the key is found in this Data Manager it is removed from the internal lists and a
     * `removedata` event is emitted.
     *
     * You can also pass in an array of keys, in which case all keys in the array will be removed:
     *
     * ```javascript
     * this.data.remove([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * @method Phaser.Data.DataManager#remove
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key to remove, or an array of keys to remove.
     *
     * @return {this} This Data Manager instance.
     */ remove: function(key) {
                        if (this._frozen) return this;
                        if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.removeValue(key[i]);
                        else return this.removeValue(key);
                        return this;
                    },
                    /**
     * Internal value remover, called automatically by the `remove` method.
     *
     * @method Phaser.Data.DataManager#removeValue
     * @private
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.10.0
     *
     * @param {string} key - The key to set the value for.
     *
     * @return {this} This Data Manager instance.
     */ removeValue: function(key) {
                        if (this.has(key)) {
                            var data = this.list[key];
                            delete this.list[key];
                            delete this.values[key];
                            this.events.emit(Events.REMOVE_DATA, this.parent, key, data);
                        }
                        return this;
                    },
                    /**
     * Retrieves the data associated with the given 'key', deletes it from this Data Manager, then returns it.
     *
     * @method Phaser.Data.DataManager#pop
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.0.0
     *
     * @param {string} key - The key of the value to retrieve and delete.
     *
     * @return {*} The value of the given key.
     */ pop: function(key) {
                        var data = undefined;
                        if (!this._frozen && this.has(key)) {
                            data = this.list[key];
                            delete this.list[key];
                            delete this.values[key];
                            this.events.emit(Events.REMOVE_DATA, this.parent, key, data);
                        }
                        return data;
                    },
                    /**
     * Determines whether the given key is set in this Data Manager.
     *
     * Please note that the keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.Data.DataManager#has
     * @since 3.0.0
     *
     * @param {string} key - The key to check.
     *
     * @return {boolean} Returns `true` if the key exists, otherwise `false`.
     */ has: function(key) {
                        return this.list.hasOwnProperty(key);
                    },
                    /**
     * Freeze or unfreeze this Data Manager. A frozen Data Manager will block all attempts
     * to create new values or update existing ones.
     *
     * @method Phaser.Data.DataManager#setFreeze
     * @since 3.0.0
     *
     * @param {boolean} value - Whether to freeze or unfreeze the Data Manager.
     *
     * @return {this} This Data Manager instance.
     */ setFreeze: function(value) {
                        this._frozen = value;
                        return this;
                    },
                    /**
     * Delete all data in this Data Manager and unfreeze it.
     *
     * @method Phaser.Data.DataManager#reset
     * @since 3.0.0
     *
     * @return {this} This Data Manager instance.
     */ reset: function() {
                        for(var key in this.list){
                            delete this.list[key];
                            delete this.values[key];
                        }
                        this._frozen = false;
                        return this;
                    },
                    /**
     * Destroy this data manager.
     *
     * @method Phaser.Data.DataManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.reset();
                        this.events.off(Events.CHANGE_DATA);
                        this.events.off(Events.SET_DATA);
                        this.events.off(Events.REMOVE_DATA);
                        this.parent = null;
                    },
                    /**
     * Gets or sets the frozen state of this Data Manager.
     * A frozen Data Manager will block all attempts to create new values or update existing ones.
     *
     * @name Phaser.Data.DataManager#freeze
     * @type {boolean}
     * @since 3.0.0
     */ freeze: {
                        get: function() {
                            return this._frozen;
                        },
                        set: function(value) {
                            this._frozen = value ? true : false;
                        }
                    },
                    /**
     * Return the total number of entries in this Data Manager.
     *
     * @name Phaser.Data.DataManager#count
     * @type {number}
     * @since 3.0.0
     */ count: {
                        get: function() {
                            var i = 0;
                            for(var key in this.list)if (this.list[key] !== undefined) i++;
                            return i;
                        }
                    }
                });
                module1.exports = DataManager;
            /***/ },
            /***/ 63646: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var DataManager = __webpack_require__(45893);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * The Data Component features a means to store pieces of data specific to a Game Object, System or Plugin.
 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
 * or have a property called `events` that is an instance of it.
 *
 * @class DataManagerPlugin
 * @extends Phaser.Data.DataManager
 * @memberof Phaser.Data
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that this DataManager belongs to.
 */ var DataManagerPlugin = new Class({
                    Extends: DataManager,
                    initialize: function DataManagerPlugin(scene) {
                        DataManager.call(this, scene, scene.sys.events);
                        /**
         * A reference to the Scene that this DataManager belongs to.
         *
         * @name Phaser.Data.DataManagerPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene's Systems.
         *
         * @name Phaser.Data.DataManagerPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Data.DataManagerPlugin#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.events = this.systems.events;
                        this.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Data.DataManagerPlugin#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Data.DataManagerPlugin#shutdown
     * @private
     * @since 3.5.0
     */ shutdown: function() {
                        this.systems.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Data.DataManagerPlugin#destroy
     * @since 3.5.0
     */ destroy: function() {
                        DataManager.prototype.destroy.call(this);
                        this.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                    }
                });
                PluginCache.register('DataManagerPlugin', DataManagerPlugin, 'data');
                module1.exports = DataManagerPlugin;
            /***/ },
            /***/ 10700: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Change Data Event.
 *
 * This event is dispatched by a Data Manager when an item in the data store is changed.
 *
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * a change data event from a Game Object you would use: `sprite.on('changedata', listener)`.
 *
 * This event is dispatched for all items that change in the Data Manager.
 * To listen for the change of a specific item, use the `CHANGE_DATA_KEY_EVENT` event.
 *
 * @event Phaser.Data.Events#CHANGE_DATA
 * @type {string}
 * @since 3.0.0
 *
 * @param {any} parent - A reference to the object that the Data Manager responsible for this event belongs to.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} value - The new value of the item in the Data Manager.
 * @param {any} previousValue - The previous value of the item in the Data Manager.
 */ module1.exports = 'changedata';
            /***/ },
            /***/ 93608: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Change Data Key Event.
 *
 * This event is dispatched by a Data Manager when an item in the data store is changed.
 *
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the change of a specific data item from a Game Object you would use: `sprite.on('changedata-key', listener)`,
 * where `key` is the unique string key of the data item. For example, if you have a data item stored called `gold`
 * then you can listen for `sprite.on('changedata-gold')`.
 *
 * @event Phaser.Data.Events#CHANGE_DATA_KEY
 * @type {string}
 * @since 3.16.1
 *
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {any} value - The item that was updated in the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 * @param {any} previousValue - The previous item that was updated in the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = 'changedata-';
            /***/ },
            /***/ 60883: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Data Manager Destroy Event.
 *
 * The Data Manager will listen for the destroy event from its parent, and then close itself down.
 *
 * @event Phaser.Data.Events#DESTROY
 * @type {string}
 * @since 3.50.0
 */ module1.exports = 'destroy';
            /***/ },
            /***/ 69780: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Remove Data Event.
 *
 * This event is dispatched by a Data Manager when an item is removed from it.
 *
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the removal of a data item on a Game Object you would use: `sprite.on('removedata', listener)`.
 *
 * @event Phaser.Data.Events#REMOVE_DATA
 * @type {string}
 * @since 3.0.0
 *
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} data - The item that was removed from the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = 'removedata';
            /***/ },
            /***/ 22166: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Set Data Event.
 *
 * This event is dispatched by a Data Manager when a new item is added to the data store.
 *
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the addition of a new data item on a Game Object you would use: `sprite.on('setdata', listener)`.
 *
 * @event Phaser.Data.Events#SET_DATA
 * @type {string}
 * @since 3.0.0
 *
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} data - The item that was added to the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = 'setdata';
            /***/ },
            /***/ 24882: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Data.Events
 */ module1.exports = {
                    CHANGE_DATA: __webpack_require__(10700),
                    CHANGE_DATA_KEY: __webpack_require__(93608),
                    DESTROY: __webpack_require__(60883),
                    REMOVE_DATA: __webpack_require__(69780),
                    SET_DATA: __webpack_require__(22166)
                };
            /***/ },
            /***/ 44965: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Data
 */ module1.exports = {
                    DataManager: __webpack_require__(45893),
                    DataManagerPlugin: __webpack_require__(63646),
                    Events: __webpack_require__(24882)
                };
            /***/ },
            /***/ 7098: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Browser = __webpack_require__(84148);
                /**
 * Determines the audio playback capabilities of the device running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.audio` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Audio
 * @since 3.0.0
 *
 * @property {boolean} audioData - Can this device play HTML Audio tags?
 * @property {boolean} dolby - Can this device play EC-3 Dolby Digital Plus files?
 * @property {boolean} m4a - Can this device can play m4a files.
 * @property {boolean} aac - Can this device can play aac files.
 * @property {boolean} flac - Can this device can play flac files.
 * @property {boolean} mp3 - Can this device play mp3 files?
 * @property {boolean} ogg - Can this device play ogg files?
 * @property {boolean} opus - Can this device play opus files?
 * @property {boolean} wav - Can this device play wav files?
 * @property {boolean} webAudio - Does this device have the Web Audio API?
 * @property {boolean} webm - Can this device play webm files?
 */ var Audio1 = {
                    flac: false,
                    aac: false,
                    audioData: false,
                    dolby: false,
                    m4a: false,
                    mp3: false,
                    ogg: false,
                    opus: false,
                    wav: false,
                    webAudio: false,
                    webm: false
                };
                function init() {
                    if (typeof importScripts === 'function') return Audio1;
                    Audio1.audioData = !!window['Audio'];
                    Audio1.webAudio = !!(window['AudioContext'] || window['webkitAudioContext']);
                    var audioElement = document.createElement('audio');
                    var result = !!audioElement.canPlayType;
                    try {
                        if (result) {
                            var CanPlay = function(type1, type2) {
                                var canPlayType1 = audioElement.canPlayType('audio/' + type1).replace(/^no$/, '');
                                if (type2) return Boolean(canPlayType1 || audioElement.canPlayType('audio/' + type2).replace(/^no$/, ''));
                                else return Boolean(canPlayType1);
                            };
                            //  wav Mimetypes accepted:
                            //  developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
                            Audio1.ogg = CanPlay('ogg; codecs="vorbis"');
                            Audio1.opus = CanPlay('ogg; codecs="opus"', 'opus');
                            Audio1.mp3 = CanPlay('mpeg');
                            Audio1.wav = CanPlay('wav');
                            Audio1.m4a = CanPlay('x-m4a');
                            Audio1.aac = CanPlay('aac');
                            Audio1.flac = CanPlay('flac', 'x-flac');
                            Audio1.webm = CanPlay('webm; codecs="vorbis"');
                            if (audioElement.canPlayType('audio/mp4; codecs="ec-3"') !== '') {
                                if (Browser.edge) Audio1.dolby = true;
                                else if (Browser.safari && Browser.safariVersion >= 9) {
                                    if (/Mac OS X (\d+)_(\d+)/.test(navigator.userAgent)) {
                                        var major = parseInt(RegExp.$1, 10);
                                        var minor = parseInt(RegExp.$2, 10);
                                        if (major === 10 && minor >= 11 || major > 10) Audio1.dolby = true;
                                    }
                                }
                            }
                        }
                    } catch (e) {
                    //  Nothing to do here
                    }
                    return Audio1;
                }
                module1.exports = init();
            /***/ },
            /***/ 84148: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(25892);
                /**
 * Determines the browser type and version running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.browser` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Browser
 * @since 3.0.0
 *
 * @property {boolean} chrome - Set to true if running in Chrome.
 * @property {boolean} edge - Set to true if running in Microsoft Edge browser.
 * @property {boolean} firefox - Set to true if running in Firefox.
 * @property {boolean} ie - Set to true if running in Internet Explorer 11 or less (not Edge).
 * @property {boolean} mobileSafari - Set to true if running in Mobile Safari.
 * @property {boolean} opera - Set to true if running in Opera.
 * @property {boolean} safari - Set to true if running in Safari.
 * @property {boolean} silk - Set to true if running in the Silk browser (as used on the Amazon Kindle)
 * @property {boolean} trident - Set to true if running a Trident version of Internet Explorer (IE11+)
 * @property {number} chromeVersion - If running in Chrome this will contain the major version number.
 * @property {number} firefoxVersion - If running in Firefox this will contain the major version number.
 * @property {number} ieVersion - If running in Internet Explorer this will contain the major version number. Beyond IE10 you should use Browser.trident and Browser.tridentVersion.
 * @property {number} safariVersion - If running in Safari this will contain the major version number.
 * @property {number} tridentVersion - If running in Internet Explorer 11 this will contain the major version number. See {@link http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx}
 */ var Browser = {
                    chrome: false,
                    chromeVersion: 0,
                    edge: false,
                    firefox: false,
                    firefoxVersion: 0,
                    ie: false,
                    ieVersion: 0,
                    mobileSafari: false,
                    opera: false,
                    safari: false,
                    safariVersion: 0,
                    silk: false,
                    trident: false,
                    tridentVersion: 0,
                    es2019: false
                };
                function init() {
                    var ua = navigator.userAgent;
                    if (/Edg\/\d+/.test(ua)) {
                        Browser.edge = true;
                        Browser.es2019 = true;
                    } else if (/OPR/.test(ua)) {
                        Browser.opera = true;
                        Browser.es2019 = true;
                    } else if (/Chrome\/(\d+)/.test(ua) && !OS.windowsPhone) {
                        Browser.chrome = true;
                        Browser.chromeVersion = parseInt(RegExp.$1, 10);
                        Browser.es2019 = Browser.chromeVersion > 69;
                    } else if (/Firefox\D+(\d+)/.test(ua)) {
                        Browser.firefox = true;
                        Browser.firefoxVersion = parseInt(RegExp.$1, 10);
                        Browser.es2019 = Browser.firefoxVersion > 10;
                    } else if (/AppleWebKit\/(?!.*CriOS)/.test(ua) && OS.iOS) {
                        Browser.mobileSafari = true;
                        Browser.es2019 = true;
                    } else if (/MSIE (\d+\.\d+);/.test(ua)) {
                        Browser.ie = true;
                        Browser.ieVersion = parseInt(RegExp.$1, 10);
                    } else if (/Version\/(\d+\.\d+(\.\d+)?) Safari/.test(ua) && !OS.windowsPhone) {
                        Browser.safari = true;
                        Browser.safariVersion = parseInt(RegExp.$1, 10);
                        Browser.es2019 = Browser.safariVersion > 10;
                    } else if (/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(ua)) {
                        Browser.ie = true;
                        Browser.trident = true;
                        Browser.tridentVersion = parseInt(RegExp.$1, 10);
                        Browser.ieVersion = parseInt(RegExp.$3, 10);
                    }
                    //  Silk gets its own if clause because its ua also contains 'Safari'
                    if (/Silk/.test(ua)) Browser.silk = true;
                    return Browser;
                }
                module1.exports = init();
            /***/ },
            /***/ 89289: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(27919);
                /**
 * Determines the canvas features of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.canvasFeatures` from within any Scene.
 *
 * @typedef {object} Phaser.Device.CanvasFeatures
 * @since 3.0.0
 *
 * @property {boolean} supportInverseAlpha - Set to true if the browser supports inversed alpha.
 * @property {boolean} supportNewBlendModes - Set to true if the browser supports new canvas blend modes.
 */ var CanvasFeatures = {
                    supportInverseAlpha: false,
                    supportNewBlendModes: false
                };
                function checkBlendMode() {
                    var pngHead = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABAQMAAADD8p2OAAAAA1BMVEX/';
                    var pngEnd = 'AAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
                    var magenta = new Image();
                    magenta.onload = function() {
                        var yellow = new Image();
                        yellow.onload = function() {
                            var canvas = CanvasPool.create2D(yellow, 6);
                            var context = canvas.getContext('2d', {
                                willReadFrequently: true
                            });
                            context.globalCompositeOperation = 'multiply';
                            context.drawImage(magenta, 0, 0);
                            context.drawImage(yellow, 2, 0);
                            if (!context.getImageData(2, 0, 1, 1)) return false;
                            var data = context.getImageData(2, 0, 1, 1).data;
                            CanvasPool.remove(yellow);
                            CanvasFeatures.supportNewBlendModes = data[0] === 255 && data[1] === 0 && data[2] === 0;
                        };
                        yellow.src = pngHead + '/wCKxvRF' + pngEnd;
                    };
                    magenta.src = pngHead + 'AP804Oa6' + pngEnd;
                    return false;
                }
                function checkInverseAlpha() {
                    var canvas = CanvasPool.create2D(this, 2);
                    var context = canvas.getContext('2d', {
                        willReadFrequently: true
                    });
                    context.fillStyle = 'rgba(10, 20, 30, 0.5)';
                    //  Draw a single pixel
                    context.fillRect(0, 0, 1, 1);
                    //  Get the color values
                    var s1 = context.getImageData(0, 0, 1, 1);
                    if (s1 === null) return false;
                    //  Plot them to x2
                    context.putImageData(s1, 1, 0);
                    //  Get those values
                    var s2 = context.getImageData(1, 0, 1, 1);
                    var result = s2.data[0] === s1.data[0] && s2.data[1] === s1.data[1] && s2.data[2] === s1.data[2] && s2.data[3] === s1.data[3];
                    CanvasPool.remove(this);
                    //  Compare and return
                    return result;
                }
                function init() {
                    if (typeof importScripts !== 'function' && document !== undefined) {
                        CanvasFeatures.supportNewBlendModes = checkBlendMode();
                        CanvasFeatures.supportInverseAlpha = checkInverseAlpha();
                    }
                    return CanvasFeatures;
                }
                module1.exports = init();
            /***/ },
            /***/ 89357: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(25892);
                var Browser = __webpack_require__(84148);
                var CanvasPool = __webpack_require__(27919);
                /**
 * Determines the features of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.features` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Features
 * @since 3.0.0
 *
 * @property {boolean} canvas - Is canvas available?
 * @property {?boolean} canvasBitBltShift - True if canvas supports a 'copy' bitblt onto itself when the source and destination regions overlap.
 * @property {boolean} file - Is file available?
 * @property {boolean} fileSystem - Is fileSystem available?
 * @property {boolean} getUserMedia - Does the device support the getUserMedia API?
 * @property {boolean} littleEndian - Is the device big or little endian? (only detected if the browser supports TypedArrays)
 * @property {boolean} localStorage - Is localStorage available?
 * @property {boolean} pointerLock - Is Pointer Lock available?
 * @property {boolean} stableSort - Is Array.sort stable?
 * @property {boolean} support32bit - Does the device context support 32bit pixel manipulation using array buffer views?
 * @property {boolean} vibration - Does the device support the Vibration API?
 * @property {boolean} webGL - Is webGL available?
 * @property {boolean} worker - Is worker available?
 */ var Features = {
                    canvas: false,
                    canvasBitBltShift: null,
                    file: false,
                    fileSystem: false,
                    getUserMedia: true,
                    littleEndian: false,
                    localStorage: false,
                    pointerLock: false,
                    stableSort: false,
                    support32bit: false,
                    vibration: false,
                    webGL: false,
                    worker: false
                };
                // Check Little or Big Endian system.
                // @author Matt DesLauriers (@mattdesl)
                function checkIsLittleEndian() {
                    var a = new ArrayBuffer(4);
                    var b = new Uint8Array(a);
                    var c = new Uint32Array(a);
                    b[0] = 0xa1;
                    b[1] = 0xb2;
                    b[2] = 0xc3;
                    b[3] = 0xd4;
                    if (c[0] === 0xd4c3b2a1) return true;
                    if (c[0] === 0xa1b2c3d4) return false;
                    else //  Could not determine endianness
                    return null;
                }
                function init() {
                    if (typeof importScripts === 'function') return Features;
                    Features.canvas = !!window['CanvasRenderingContext2D'];
                    try {
                        Features.localStorage = !!localStorage.getItem;
                    } catch (error) {
                        Features.localStorage = false;
                    }
                    Features.file = !!window['File'] && !!window['FileReader'] && !!window['FileList'] && !!window['Blob'];
                    Features.fileSystem = !!window['requestFileSystem'];
                    var isUint8 = false;
                    var testWebGL = function() {
                        if (window['WebGLRenderingContext']) try {
                            var canvas = CanvasPool.createWebGL(this);
                            var ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
                            var canvas2D = CanvasPool.create2D(this);
                            var ctx2D = canvas2D.getContext('2d', {
                                willReadFrequently: true
                            });
                            //  Can't be done on a webgl context
                            var image = ctx2D.createImageData(1, 1);
                            //  Test to see if ImageData uses CanvasPixelArray or Uint8ClampedArray.
                            //  @author Matt DesLauriers (@mattdesl)
                            isUint8 = image.data instanceof Uint8ClampedArray;
                            CanvasPool.remove(canvas);
                            CanvasPool.remove(canvas2D);
                            return !!ctx;
                        } catch (e) {
                            return false;
                        }
                        return false;
                    };
                    Features.webGL = testWebGL();
                    Features.worker = !!window['Worker'];
                    Features.pointerLock = 'pointerLockElement' in document || 'mozPointerLockElement' in document || 'webkitPointerLockElement' in document;
                    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
                    window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    Features.getUserMedia = Features.getUserMedia && !!navigator.getUserMedia && !!window.URL;
                    // Older versions of firefox (< 21) apparently claim support but user media does not actually work
                    if (Browser.firefox && Browser.firefoxVersion < 21) Features.getUserMedia = false;
                    // Excludes iOS versions as they generally wrap UIWebView (eg. Safari WebKit) and it
                    // is safer to not try and use the fast copy-over method.
                    if (!OS.iOS && (Browser.ie || Browser.firefox || Browser.chrome)) Features.canvasBitBltShift = true;
                    // Known not to work
                    if (Browser.safari || Browser.mobileSafari) Features.canvasBitBltShift = false;
                    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
                    if (navigator.vibrate) Features.vibration = true;
                    if (typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint32Array !== 'undefined') Features.littleEndian = checkIsLittleEndian();
                    Features.support32bit = typeof ArrayBuffer !== 'undefined' && typeof Uint8ClampedArray !== 'undefined' && typeof Int32Array !== 'undefined' && Features.littleEndian !== null && isUint8;
                    return Features;
                }
                module1.exports = init();
            /***/ },
            /***/ 91639: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines the full screen support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.fullscreen` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Fullscreen
 * @since 3.0.0
 *
 * @property {boolean} available - Does the browser support the Full Screen API?
 * @property {boolean} keyboard - Does the browser support access to the Keyboard during Full Screen mode?
 * @property {string} cancel - If the browser supports the Full Screen API this holds the call you need to use to cancel it.
 * @property {string} request - If the browser supports the Full Screen API this holds the call you need to use to activate it.
 */ var Fullscreen = {
                    available: false,
                    cancel: '',
                    keyboard: false,
                    request: ''
                };
                /**
* Checks for support of the Full Screen API.
*
* @ignore
*/ function init() {
                    if (typeof importScripts === 'function') return Fullscreen;
                    var i;
                    var suffix1 = 'Fullscreen';
                    var suffix2 = 'FullScreen';
                    var fs = [
                        'request' + suffix1,
                        'request' + suffix2,
                        'webkitRequest' + suffix1,
                        'webkitRequest' + suffix2,
                        'msRequest' + suffix1,
                        'msRequest' + suffix2,
                        'mozRequest' + suffix2,
                        'mozRequest' + suffix1
                    ];
                    for(i = 0; i < fs.length; i++)if (document.documentElement[fs[i]]) {
                        Fullscreen.available = true;
                        Fullscreen.request = fs[i];
                        break;
                    }
                    var cfs = [
                        'cancel' + suffix2,
                        'exit' + suffix1,
                        'webkitCancel' + suffix2,
                        'webkitExit' + suffix1,
                        'msCancel' + suffix2,
                        'msExit' + suffix1,
                        'mozCancel' + suffix2,
                        'mozExit' + suffix1
                    ];
                    if (Fullscreen.available) {
                        for(i = 0; i < cfs.length; i++)if (document[cfs[i]]) {
                            Fullscreen.cancel = cfs[i];
                            break;
                        }
                    }
                    //  Keyboard Input?
                    //  Safari 5.1 says it supports fullscreen keyboard, but is lying.
                    if (window['Element'] && Element['ALLOW_KEYBOARD_INPUT'] && !/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) Fullscreen.keyboard = true;
                    Object.defineProperty(Fullscreen, 'active', {
                        get: function() {
                            return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
                        }
                    });
                    return Fullscreen;
                }
                module1.exports = init();
            /***/ },
            /***/ 31784: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Browser = __webpack_require__(84148);
                /**
 * Determines the input support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.input` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Input
 * @since 3.0.0
 *
 * @property {?string} wheelType - The newest type of Wheel/Scroll event supported: 'wheel', 'mousewheel', 'DOMMouseScroll'
 * @property {boolean} gamepads - Is navigator.getGamepads available?
 * @property {boolean} mspointer - Is mspointer available?
 * @property {boolean} touch - Is touch available?
 */ var Input = {
                    gamepads: false,
                    mspointer: false,
                    touch: false,
                    wheelEvent: null
                };
                function init() {
                    if (typeof importScripts === 'function') return Input;
                    if ('ontouchstart' in document.documentElement || navigator.maxTouchPoints && navigator.maxTouchPoints >= 1) Input.touch = true;
                    if (navigator.msPointerEnabled || navigator.pointerEnabled) Input.mspointer = true;
                    if (navigator.getGamepads) Input.gamepads = true;
                    // See https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                    if ('onwheel' in window || Browser.ie && 'WheelEvent' in window) // DOM3 Wheel Event: FF 17+, IE 9+, Chrome 31+, Safari 7+
                    Input.wheelEvent = 'wheel';
                    else if ('onmousewheel' in window) // Non-FF legacy: IE 6-9, Chrome 1-31, Safari 5-7.
                    Input.wheelEvent = 'mousewheel';
                    else if (Browser.firefox && 'MouseScrollEvent' in window) // FF prior to 17. This should probably be scrubbed.
                    Input.wheelEvent = 'DOMMouseScroll';
                    return Input;
                }
                module1.exports = init();
            /***/ },
            /***/ 25892: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines the operating system of the device running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.os` from within any Scene.
 *
 * @typedef {object} Phaser.Device.OS
 * @since 3.0.0
 *
 * @property {boolean} android - Is running on android?
 * @property {boolean} chromeOS - Is running on chromeOS?
 * @property {boolean} cordova - Is the game running under Apache Cordova?
 * @property {boolean} crosswalk - Is the game running under the Intel Crosswalk XDK?
 * @property {boolean} desktop - Is running on a desktop?
 * @property {boolean} ejecta - Is the game running under Ejecta?
 * @property {boolean} electron - Is the game running under GitHub Electron?
 * @property {boolean} iOS - Is running on iOS?
 * @property {boolean} iPad - Is running on iPad?
 * @property {boolean} iPhone - Is running on iPhone?
 * @property {boolean} kindle - Is running on an Amazon Kindle?
 * @property {boolean} linux - Is running on linux?
 * @property {boolean} macOS - Is running on macOS?
 * @property {boolean} node - Is the game running under Node.js?
 * @property {boolean} nodeWebkit - Is the game running under Node-Webkit?
 * @property {boolean} webApp - Set to true if running as a WebApp, i.e. within a WebView
 * @property {boolean} windows - Is running on windows?
 * @property {boolean} windowsPhone - Is running on a Windows Phone?
 * @property {number} iOSVersion - If running in iOS this will contain the major version number.
 * @property {number} pixelRatio - PixelRatio of the host device?
 */ var OS = {
                    android: false,
                    chromeOS: false,
                    cordova: false,
                    crosswalk: false,
                    desktop: false,
                    ejecta: false,
                    electron: false,
                    iOS: false,
                    iOSVersion: 0,
                    iPad: false,
                    iPhone: false,
                    kindle: false,
                    linux: false,
                    macOS: false,
                    node: false,
                    nodeWebkit: false,
                    pixelRatio: 1,
                    webApp: false,
                    windows: false,
                    windowsPhone: false
                };
                function init() {
                    if (typeof importScripts === 'function') return OS;
                    var ua = navigator.userAgent;
                    if (/Windows/.test(ua)) OS.windows = true;
                    else if (/Mac OS/.test(ua) && !/like Mac OS/.test(ua)) {
                        //  Because iOS 13 identifies as Mac OS:
                        if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
                            OS.iOS = true;
                            OS.iPad = true;
                            navigator.appVersion.match(/Version\/(\d+)/);
                            OS.iOSVersion = parseInt(RegExp.$1, 10);
                        } else OS.macOS = true;
                    } else if (/Android/.test(ua)) OS.android = true;
                    else if (/Linux/.test(ua)) OS.linux = true;
                    else if (/iP[ao]d|iPhone/i.test(ua)) {
                        OS.iOS = true;
                        navigator.appVersion.match(/OS (\d+)/);
                        OS.iOSVersion = parseInt(RegExp.$1, 10);
                        OS.iPhone = ua.toLowerCase().indexOf('iphone') !== -1;
                        OS.iPad = ua.toLowerCase().indexOf('ipad') !== -1;
                    } else if (/Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk.*Mobile Safari/.test(ua)) OS.kindle = true;
                    else if (/CrOS/.test(ua)) OS.chromeOS = true;
                    if (/Windows Phone/i.test(ua) || /IEMobile/i.test(ua)) {
                        OS.android = false;
                        OS.iOS = false;
                        OS.macOS = false;
                        OS.windows = true;
                        OS.windowsPhone = true;
                    }
                    var silk = /Silk/.test(ua);
                    if (OS.windows || OS.macOS || OS.linux && !silk || OS.chromeOS) OS.desktop = true;
                    //  Windows Phone / Table reset
                    if (OS.windowsPhone || /Windows NT/i.test(ua) && /Touch/i.test(ua)) OS.desktop = false;
                    //  WebApp mode in iOS
                    if (navigator.standalone) OS.webApp = true;
                    if (typeof importScripts !== 'function') {
                        if (window.cordova !== undefined) OS.cordova = true;
                        if (window.ejecta !== undefined) OS.ejecta = true;
                    }
                    if (OS.node && typeof $cfae44f0dfdf62c0$exports.versions === 'object') {
                        OS.nodeWebkit = !!$cfae44f0dfdf62c0$exports.versions['node-webkit'];
                        OS.electron = !!$cfae44f0dfdf62c0$exports.versions.electron;
                    }
                    if (/Crosswalk/.test(ua)) OS.crosswalk = true;
                    OS.pixelRatio = window['devicePixelRatio'] || 1;
                    return OS;
                }
                module1.exports = init();
            /***/ },
            /***/ 43267: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                /**
 * Determines the video support of the browser running this Phaser Game instance.
 *
 * These values are read-only and populated during the boot sequence of the game.
 *
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.video` from within any Scene.
 *
 * In Phaser 3.20 the properties were renamed to drop the 'Video' suffix.
 *
 * @typedef {object} Phaser.Device.Video
 * @since 3.0.0
 *
 * @property {boolean} h264 - Can this device play h264 mp4 video files?
 * @property {boolean} hls - Can this device play hls video files?
 * @property {boolean} mp4 - Can this device play h264 mp4 video files?
 * @property {boolean} m4v - Can this device play m4v (typically mp4) video files?
 * @property {boolean} ogg - Can this device play ogg video files?
 * @property {boolean} vp9 - Can this device play vp9 video files?
 * @property {boolean} webm - Can this device play webm video files?
 * @property {function} getVideoURL - Returns the first video URL that can be played by this browser.
 */ var Video = {
                    h264: false,
                    hls: false,
                    mp4: false,
                    m4v: false,
                    ogg: false,
                    vp9: false,
                    webm: false,
                    hasRequestVideoFrame: false
                };
                function init() {
                    if (typeof importScripts === 'function') return Video;
                    var videoElement = document.createElement('video');
                    var result = !!videoElement.canPlayType;
                    var no = /^no$/;
                    try {
                        if (result) {
                            if (videoElement.canPlayType('video/ogg; codecs="theora"').replace(no, '')) Video.ogg = true;
                            if (videoElement.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(no, '')) {
                                // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
                                Video.h264 = true;
                                Video.mp4 = true;
                            }
                            if (videoElement.canPlayType('video/x-m4v').replace(no, '')) Video.m4v = true;
                            if (videoElement.canPlayType('video/webm; codecs="vp8, vorbis"').replace(no, '')) Video.webm = true;
                            if (videoElement.canPlayType('video/webm; codecs="vp9"').replace(no, '')) Video.vp9 = true;
                            if (videoElement.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(no, '')) Video.hls = true;
                        }
                    } catch (e) {
                    //  Nothing to do
                    }
                    if (videoElement.parentNode) videoElement.parentNode.removeChild(videoElement);
                    Video.getVideoURL = function(urls) {
                        if (!Array.isArray(urls)) urls = [
                            urls
                        ];
                        for(var i = 0; i < urls.length; i++){
                            var url = GetFastValue(urls[i], 'url', urls[i]);
                            if (url.indexOf('blob:') === 0) return {
                                url: url,
                                type: ''
                            };
                            var videoType;
                            if (url.indexOf('data:') === 0) videoType = url.split(',')[0].match(/\/(.*?);/);
                            else videoType = url.match(/\.([a-zA-Z0-9]+)($|\?)/);
                            videoType = GetFastValue(urls[i], 'type', videoType ? videoType[1] : '').toLowerCase();
                            if (Video[videoType]) return {
                                url: url,
                                type: videoType
                            };
                        }
                        return null;
                    };
                    return Video;
                }
                module1.exports = init();
            /***/ },
            /***/ 82264: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  This singleton is instantiated as soon as Phaser loads,
                //  before a Phaser.Game instance has even been created.
                //  Which means all instances of Phaser Games can share it,
                //  without having to re-poll the device all over again
                /**
 * @namespace Phaser.Device
 * @since 3.0.0
 */ /**
 * @typedef {object} Phaser.DeviceConf
 *
 * @property {Phaser.Device.OS} os - The OS Device functions.
 * @property {Phaser.Device.Browser} browser - The Browser Device functions.
 * @property {Phaser.Device.Features} features - The Features Device functions.
 * @property {Phaser.Device.Input} input - The Input Device functions.
 * @property {Phaser.Device.Audio} audio - The Audio Device functions.
 * @property {Phaser.Device.Video} video - The Video Device functions.
 * @property {Phaser.Device.Fullscreen} fullscreen - The Fullscreen Device functions.
 * @property {Phaser.Device.CanvasFeatures} canvasFeatures - The Canvas Device functions.
 */ module1.exports = {
                    os: __webpack_require__(25892),
                    browser: __webpack_require__(84148),
                    features: __webpack_require__(89357),
                    input: __webpack_require__(31784),
                    audio: __webpack_require__(7098),
                    video: __webpack_require__(43267),
                    fullscreen: __webpack_require__(91639),
                    canvasFeatures: __webpack_require__(89289)
                };
            /***/ },
            /***/ 89422: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var tempMatrix = new Float32Array(20);
                /**
 * @classdesc
 * The ColorMatrix class creates a 5x4 matrix that can be used in shaders and graphics
 * operations. It provides methods required to modify the color values, such as adjusting
 * the brightness, setting a sepia tone, hue rotation and more.
 *
 * Use the method `getData` to return a Float32Array containing the current color values.
 *
 * @class ColorMatrix
 * @memberof Phaser.Display
 * @constructor
 * @since 3.50.0
 */ var ColorMatrix = new Class({
                    initialize: function ColorMatrix() {
                        /**
         * Internal ColorMatrix array.
         *
         * @name Phaser.Display.ColorMatrix#_matrix
         * @type {Float32Array}
         * @private
         * @since 3.50.0
         */ this._matrix = new Float32Array(20);
                        /**
         * The value that determines how much of the original color is used
         * when mixing the colors. A value between 0 (all original) and 1 (all final)
         *
         * @name Phaser.Display.ColorMatrix#alpha
         * @type {number}
         * @since 3.50.0
         */ this.alpha = 1;
                        /**
         * Is the ColorMatrix array dirty?
         *
         * @name Phaser.Display.ColorMatrix#_dirty
         * @type {boolean}
         * @private
         * @since 3.50.0
         */ this._dirty = true;
                        /**
         * The matrix data as a Float32Array.
         *
         * Returned by the `getData` method.
         *
         * @name Phaser.Display.ColorMatrix#data
         * @type {Float32Array}
         * @private
         * @since 3.50.0
         */ this._data = new Float32Array(20);
                        this.reset();
                    },
                    /**
     * Sets this ColorMatrix from the given array of color values.
     *
     * @method Phaser.Display.ColorMatrix#set
     * @since 3.50.0
     *
     * @param {(number[]|Float32Array)} value - The ColorMatrix values to set. Must have 20 elements.
     *
     * @return {this} This ColorMatrix instance.
     */ set: function(value) {
                        this._matrix.set(value);
                        this._dirty = true;
                        return this;
                    },
                    /**
     * Resets the ColorMatrix to default values and also resets
     * the `alpha` property back to 1.
     *
     * @method Phaser.Display.ColorMatrix#reset
     * @since 3.50.0
     *
     * @return {this} This ColorMatrix instance.
     */ reset: function() {
                        var m = this._matrix;
                        m.fill(0);
                        m[0] = 1;
                        m[6] = 1;
                        m[12] = 1;
                        m[18] = 1;
                        this.alpha = 1;
                        this._dirty = true;
                        return this;
                    },
                    /**
     * Gets the ColorMatrix as a Float32Array.
     *
     * Can be used directly as a 1fv shader uniform value.
     *
     * @method Phaser.Display.ColorMatrix#getData
     * @since 3.50.0
     *
     * @return {Float32Array} The ColorMatrix as a Float32Array.
     */ getData: function() {
                        var data = this._data;
                        if (this._dirty) {
                            data.set(this._matrix);
                            data[4] /= 255;
                            data[9] /= 255;
                            data[14] /= 255;
                            data[19] /= 255;
                            this._dirty = false;
                        }
                        return data;
                    },
                    /**
     * Changes the brightness of this ColorMatrix by the given amount.
     *
     * @method Phaser.Display.ColorMatrix#brightness
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of brightness to apply to this ColorMatrix. Between 0 (black) and 1.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ brightness: function(value, multiply) {
                        if (value === undefined) value = 0;
                        if (multiply === undefined) multiply = false;
                        var b = value;
                        return this.multiply([
                            b,
                            0,
                            0,
                            0,
                            0,
                            0,
                            b,
                            0,
                            0,
                            0,
                            0,
                            0,
                            b,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0
                        ], multiply);
                    },
                    /**
     * Changes the saturation of this ColorMatrix by the given amount.
     *
     * @method Phaser.Display.ColorMatrix#saturate
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of saturation to apply to this ColorMatrix.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ saturate: function(value, multiply) {
                        if (value === undefined) value = 0;
                        if (multiply === undefined) multiply = false;
                        var x = value * 2 / 3 + 1;
                        var y = (x - 1) * -0.5;
                        return this.multiply([
                            x,
                            y,
                            y,
                            0,
                            0,
                            y,
                            x,
                            y,
                            0,
                            0,
                            y,
                            y,
                            x,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0
                        ], multiply);
                    },
                    /**
     * Desaturates this ColorMatrix (removes color from it).
     *
     * @method Phaser.Display.ColorMatrix#saturation
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ desaturate: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.saturate(-1, multiply);
                    },
                    /**
     * Rotates the hues of this ColorMatrix by the value given.
     *
     * @method Phaser.Display.ColorMatrix#hue
     * @since 3.50.0
     *
     * @param {number} [rotation=0] - The amount of hue rotation to apply to this ColorMatrix, in degrees.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ hue: function(rotation, multiply) {
                        if (rotation === undefined) rotation = 0;
                        if (multiply === undefined) multiply = false;
                        rotation = rotation / 180 * Math.PI;
                        var cos = Math.cos(rotation);
                        var sin = Math.sin(rotation);
                        var lumR = 0.213;
                        var lumG = 0.715;
                        var lumB = 0.072;
                        return this.multiply([
                            lumR + cos * (1 - lumR) + sin * -lumR,
                            lumG + cos * -lumG + sin * -lumG,
                            lumB + cos * -lumB + sin * (1 - lumB),
                            0,
                            0,
                            lumR + cos * -lumR + sin * 0.143,
                            lumG + cos * (1 - lumG) + sin * 0.140,
                            lumB + cos * -lumB + sin * -0.283,
                            0,
                            0,
                            lumR + cos * -lumR + sin * -(1 - lumR),
                            lumG + cos * -lumG + sin * lumG,
                            lumB + cos * (1 - lumB) + sin * lumB,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0
                        ], multiply);
                    },
                    /**
     * Sets this ColorMatrix to be grayscale.
     *
     * @method Phaser.Display.ColorMatrix#grayscale
     * @since 3.50.0
     *
     * @param {number} [value=1] - The grayscale scale (0 is black).
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ grayscale: function(value, multiply) {
                        if (value === undefined) value = 1;
                        if (multiply === undefined) multiply = false;
                        return this.saturate(-value, multiply);
                    },
                    /**
     * Sets this ColorMatrix to be black and white.
     *
     * @method Phaser.Display.ColorMatrix#blackWhite
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ blackWhite: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.BLACK_WHITE, multiply);
                    },
                    /**
     * Change the contrast of this ColorMatrix by the amount given.
     *
     * @method Phaser.Display.ColorMatrix#contrast
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of contrast to apply to this ColorMatrix.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ contrast: function(value, multiply) {
                        if (value === undefined) value = 0;
                        if (multiply === undefined) multiply = false;
                        var v = value + 1;
                        var o = -0.5 * (v - 1);
                        return this.multiply([
                            v,
                            0,
                            0,
                            0,
                            o,
                            0,
                            v,
                            0,
                            0,
                            o,
                            0,
                            0,
                            v,
                            0,
                            o,
                            0,
                            0,
                            0,
                            1,
                            0
                        ], multiply);
                    },
                    /**
     * Converts this ColorMatrix to have negative values.
     *
     * @method Phaser.Display.ColorMatrix#negative
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ negative: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.NEGATIVE, multiply);
                    },
                    /**
     * Apply a desaturated luminance to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#desaturateLuminance
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ desaturateLuminance: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.DESATURATE_LUMINANCE, multiply);
                    },
                    /**
     * Applies a sepia tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#sepia
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ sepia: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.SEPIA, multiply);
                    },
                    /**
     * Applies a night vision tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#night
     * @since 3.50.0
     *
     * @param {number} [intensity=0.1] - The intensity of this effect.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ night: function(intensity, multiply) {
                        if (intensity === undefined) intensity = 0.1;
                        if (multiply === undefined) multiply = false;
                        return this.multiply([
                            intensity * -2,
                            -intensity,
                            0,
                            0,
                            0,
                            -intensity,
                            0,
                            intensity,
                            0,
                            0,
                            0,
                            intensity,
                            intensity * 2.0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0
                        ], multiply);
                    },
                    /**
     * Applies a trippy color tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#lsd
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ lsd: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.LSD, multiply);
                    },
                    /**
     * Applies a brown tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#brown
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ brown: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.BROWN, multiply);
                    },
                    /**
     * Applies a vintage pinhole color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#vintagePinhole
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ vintagePinhole: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.VINTAGE, multiply);
                    },
                    /**
     * Applies a kodachrome color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#kodachrome
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ kodachrome: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.KODACHROME, multiply);
                    },
                    /**
     * Applies a technicolor color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#technicolor
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ technicolor: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.TECHNICOLOR, multiply);
                    },
                    /**
     * Applies a polaroid color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#polaroid
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ polaroid: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.POLAROID, multiply);
                    },
                    /**
     * Shifts the values of this ColorMatrix into BGR order.
     *
     * @method Phaser.Display.ColorMatrix#shiftToBGR
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ shiftToBGR: function(multiply) {
                        if (multiply === undefined) multiply = false;
                        return this.multiply(ColorMatrix.SHIFT_BGR, multiply);
                    },
                    /**
     * Multiplies the two given matrices.
     *
     * @method Phaser.Display.ColorMatrix#multiply
     * @since 3.50.0
     *
     * @param {number[]} a - The 5x4 array to multiply with ColorMatrix._matrix.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ multiply: function(a, multiply) {
                        if (multiply === undefined) multiply = false;
                        //  Duplicate _matrix into c
                        if (!multiply) this.reset();
                        var m = this._matrix;
                        var c = tempMatrix;
                        //  copy _matrix to tempMatrox
                        c.set(m);
                        m.set([
                            //  R
                            c[0] * a[0] + c[1] * a[5] + c[2] * a[10] + c[3] * a[15],
                            c[0] * a[1] + c[1] * a[6] + c[2] * a[11] + c[3] * a[16],
                            c[0] * a[2] + c[1] * a[7] + c[2] * a[12] + c[3] * a[17],
                            c[0] * a[3] + c[1] * a[8] + c[2] * a[13] + c[3] * a[18],
                            c[0] * a[4] + c[1] * a[9] + c[2] * a[14] + c[3] * a[19] + c[4],
                            //  G
                            c[5] * a[0] + c[6] * a[5] + c[7] * a[10] + c[8] * a[15],
                            c[5] * a[1] + c[6] * a[6] + c[7] * a[11] + c[8] * a[16],
                            c[5] * a[2] + c[6] * a[7] + c[7] * a[12] + c[8] * a[17],
                            c[5] * a[3] + c[6] * a[8] + c[7] * a[13] + c[8] * a[18],
                            c[5] * a[4] + c[6] * a[9] + c[7] * a[14] + c[8] * a[19] + c[9],
                            //  B
                            c[10] * a[0] + c[11] * a[5] + c[12] * a[10] + c[13] * a[15],
                            c[10] * a[1] + c[11] * a[6] + c[12] * a[11] + c[13] * a[16],
                            c[10] * a[2] + c[11] * a[7] + c[12] * a[12] + c[13] * a[17],
                            c[10] * a[3] + c[11] * a[8] + c[12] * a[13] + c[13] * a[18],
                            c[10] * a[4] + c[11] * a[9] + c[12] * a[14] + c[13] * a[19] + c[14],
                            //  A
                            c[15] * a[0] + c[16] * a[5] + c[17] * a[10] + c[18] * a[15],
                            c[15] * a[1] + c[16] * a[6] + c[17] * a[11] + c[18] * a[16],
                            c[15] * a[2] + c[16] * a[7] + c[17] * a[12] + c[18] * a[17],
                            c[15] * a[3] + c[16] * a[8] + c[17] * a[13] + c[18] * a[18],
                            c[15] * a[4] + c[16] * a[9] + c[17] * a[14] + c[18] * a[19] + c[19]
                        ]);
                        this._dirty = true;
                        return this;
                    }
                });
                /**
 * A constant array used by the ColorMatrix class for black_white operations.
 *
 * @name Phaser.Display.ColorMatrix.BLACK_WHITE
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.BLACK_WHITE = [
                    0.3,
                    0.6,
                    0.1,
                    0,
                    0,
                    0.3,
                    0.6,
                    0.1,
                    0,
                    0,
                    0.3,
                    0.6,
                    0.1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for negative operations.
 *
 * @name Phaser.Display.ColorMatrix.NEGATIVE
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.NEGATIVE = [
                    -1,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    -1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for desatured luminance operations.
 *
 * @name Phaser.Display.ColorMatrix.DESATURATE_LUMINANCE
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.DESATURATE_LUMINANCE = [
                    0.2764723,
                    0.9297080,
                    0.0938197,
                    0,
                    -37.1,
                    0.2764723,
                    0.9297080,
                    0.0938197,
                    0,
                    -37.1,
                    0.2764723,
                    0.9297080,
                    0.0938197,
                    0,
                    -37.1,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for sepia operations.
 *
 * @name Phaser.Display.ColorMatrix.SEPIA
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.SEPIA = [
                    0.393,
                    0.7689999,
                    0.18899999,
                    0,
                    0,
                    0.349,
                    0.6859999,
                    0.16799999,
                    0,
                    0,
                    0.272,
                    0.5339999,
                    0.13099999,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for lsd operations.
 *
 * @name Phaser.Display.ColorMatrix.LSD
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.LSD = [
                    2,
                    -0.4,
                    0.5,
                    0,
                    0,
                    -0.5,
                    2,
                    -0.4,
                    0,
                    0,
                    -0.4,
                    -0.5,
                    3,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for brown operations.
 *
 * @name Phaser.Display.ColorMatrix.BROWN
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.BROWN = [
                    0.5997023498159715,
                    0.34553243048391263,
                    -0.2708298674538042,
                    0,
                    47.43192855600873,
                    -0.037703249837783157,
                    0.8609577587992641,
                    0.15059552388459913,
                    0,
                    -36.96841498319127,
                    0.24113635128153335,
                    -0.07441037908422492,
                    0.44972182064877153,
                    0,
                    -7.562075277591283,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for vintage pinhole operations.
 *
 * @name Phaser.Display.ColorMatrix.VINTAGE
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.VINTAGE = [
                    0.6279345635605994,
                    0.3202183420819367,
                    -0.03965408211312453,
                    0,
                    9.651285835294123,
                    0.02578397704808868,
                    0.6441188644374771,
                    0.03259127616149294,
                    0,
                    7.462829176470591,
                    0.0466055556782719,
                    -0.0851232987247891,
                    0.5241648018700465,
                    0,
                    5.159190588235296,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for kodachrome operations.
 *
 * @name Phaser.Display.ColorMatrix.KODACHROME
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.KODACHROME = [
                    1.1285582396593525,
                    -0.3967382283601348,
                    -0.03992559172921793,
                    0,
                    63.72958762196502,
                    -0.16404339962244616,
                    1.0835251566291304,
                    -0.05498805115633132,
                    0,
                    24.732407896706203,
                    -0.16786010706155763,
                    -0.5603416277695248,
                    1.6014850761964943,
                    0,
                    35.62982807460946,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for technicolor operations.
 *
 * @name Phaser.Display.ColorMatrix.TECHNICOLOR
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.TECHNICOLOR = [
                    1.9125277891456083,
                    -0.8545344976951645,
                    -0.09155508482755585,
                    0,
                    11.793603434377337,
                    -0.3087833385928097,
                    1.7658908555458428,
                    -0.10601743074722245,
                    0,
                    -70.35205161461398,
                    -0.231103377548616,
                    -0.7501899197440212,
                    1.847597816108189,
                    0,
                    30.950940869491138,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for polaroid shift operations.
 *
 * @name Phaser.Display.ColorMatrix.POLAROID
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.POLAROID = [
                    1.438,
                    -0.062,
                    -0.062,
                    0,
                    0,
                    -0.122,
                    1.378,
                    -0.122,
                    0,
                    0,
                    -0.016,
                    -0.016,
                    1.483,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                /**
 * A constant array used by the ColorMatrix class for shift BGR operations.
 *
 * @name Phaser.Display.ColorMatrix.SHIFT_BGR
 * @const
 * @type {number[]}
 * @since 3.60.0
 */ ColorMatrix.SHIFT_BGR = [
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                module1.exports = ColorMatrix;
            /***/ },
            /***/ 51767: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var NOOP = __webpack_require__(29747);
                /**
 * @classdesc
 * The RGB class holds a single color value and allows for easy modification and reading of it,
 * with optional on-change callback notification and a dirty flag.
 *
 * @class RGB
 * @memberof Phaser.Display
 * @constructor
 * @since 3.50.0
 *
 * @param {number} [red=0] - The red color value. A number between 0 and 1.
 * @param {number} [green=0] - The green color value. A number between 0 and 1.
 * @param {number} [blue=0] - The blue color value. A number between 0 and 1.
 */ var RGB = new Class({
                    initialize: function RGB(red, green, blue) {
                        /**
         * Cached RGB values.
         *
         * @name Phaser.Display.RGB#_rgb
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this._rgb = [
                            0,
                            0,
                            0
                        ];
                        /**
         * This callback will be invoked each time one of the RGB color values change.
         *
         * The callback is sent the new color values as the parameters.
         *
         * @name Phaser.Display.RGB#onChangeCallback
         * @type {function}
         * @since 3.50.0
         */ this.onChangeCallback = NOOP;
                        /**
         * Is this color dirty?
         *
         * @name Phaser.Display.RGB#dirty
         * @type {boolean}
         * @since 3.50.0
         */ this.dirty = false;
                        this.set(red, green, blue);
                    },
                    /**
     * Sets the red, green and blue values of this RGB object, flags it as being
     * dirty and then invokes the `onChangeCallback`, if set.
     *
     * @method Phaser.Display.RGB#set
     * @since 3.50.0
     *
     * @param {number} [red=0] - The red color value. A number between 0 and 1.
     * @param {number} [green=0] - The green color value. A number between 0 and 1.
     * @param {number} [blue=0] - The blue color value. A number between 0 and 1.
     *
     * @return {this} This RGB instance.
     */ set: function(red, green, blue) {
                        if (red === undefined) red = 0;
                        if (green === undefined) green = 0;
                        if (blue === undefined) blue = 0;
                        this._rgb = [
                            red,
                            green,
                            blue
                        ];
                        this.onChange();
                        return this;
                    },
                    /**
     * Compares the given rgb parameters with those in this object and returns
     * a boolean `true` value if they are equal, otherwise it returns `false`.
     *
     * @method Phaser.Display.RGB#equals
     * @since 3.50.0
     *
     * @param {number} red - The red value to compare with this object.
     * @param {number} green - The green value to compare with this object.
     * @param {number} blue - The blue value to compare with this object.
     *
     * @return {boolean} `true` if the given values match those in this object, otherwise `false`.
     */ equals: function(red, green, blue) {
                        var rgb = this._rgb;
                        return rgb[0] === red && rgb[1] === green && rgb[2] === blue;
                    },
                    /**
     * Internal on change handler. Sets this object as being dirty and
     * then invokes the `onChangeCallback`, if set, passing in the
     * new RGB values.
     *
     * @method Phaser.Display.RGB#onChange
     * @since 3.50.0
     */ onChange: function() {
                        this.dirty = true;
                        var rgb = this._rgb;
                        this.onChangeCallback.call(this, rgb[0], rgb[1], rgb[2]);
                    },
                    /**
     * The red color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#r
     * @type {number}
     * @since 3.50.0
     */ r: {
                        get: function() {
                            return this._rgb[0];
                        },
                        set: function(value) {
                            this._rgb[0] = value;
                            this.onChange();
                        }
                    },
                    /**
     * The green color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#g
     * @type {number}
     * @since 3.50.0
     */ g: {
                        get: function() {
                            return this._rgb[1];
                        },
                        set: function(value) {
                            this._rgb[1] = value;
                            this.onChange();
                        }
                    },
                    /**
     * The blue color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#b
     * @type {number}
     * @since 3.50.0
     */ b: {
                        get: function() {
                            return this._rgb[2];
                        },
                        set: function(value) {
                            this._rgb[2] = value;
                            this.onChange();
                        }
                    },
                    /**
     * Nulls any external references this object contains.
     *
     * @method Phaser.Display.RGB#destroy
     * @since 3.50.0
     */ destroy: function() {
                        this.onChangeCallback = null;
                    }
                });
                module1.exports = RGB;
            /***/ },
            /***/ 60461: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = {
                    /**
    * A constant representing a top-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_LEFT
    * @since 3.0.0
    * @type {number}
    */ TOP_LEFT: 0,
                    /**
    * A constant representing a top-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_CENTER
    * @since 3.0.0
    * @type {number}
    */ TOP_CENTER: 1,
                    /**
    * A constant representing a top-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_RIGHT
    * @since 3.0.0
    * @type {number}
    */ TOP_RIGHT: 2,
                    /**
    * A constant representing a left-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_TOP
    * @since 3.0.0
    * @type {number}
    */ LEFT_TOP: 3,
                    /**
    * A constant representing a left-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_CENTER
    * @since 3.0.0
    * @type {number}
    */ LEFT_CENTER: 4,
                    /**
    * A constant representing a left-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_BOTTOM
    * @since 3.0.0
    * @type {number}
    */ LEFT_BOTTOM: 5,
                    /**
    * A constant representing a center alignment or position.
    * @constant
    * @name Phaser.Display.Align.CENTER
    * @since 3.0.0
    * @type {number}
    */ CENTER: 6,
                    /**
    * A constant representing a right-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_TOP
    * @since 3.0.0
    * @type {number}
    */ RIGHT_TOP: 7,
                    /**
    * A constant representing a right-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_CENTER
    * @since 3.0.0
    * @type {number}
    */ RIGHT_CENTER: 8,
                    /**
    * A constant representing a right-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_BOTTOM
    * @since 3.0.0
    * @type {number}
    */ RIGHT_BOTTOM: 9,
                    /**
    * A constant representing a bottom-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_LEFT
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_LEFT: 10,
                    /**
    * A constant representing a bottom-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_CENTER
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_CENTER: 11,
                    /**
    * A constant representing a bottom-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_RIGHT
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_RIGHT: 12
                };
                module1.exports = ALIGN_CONST;
            /***/ },
            /***/ 54312: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetCenterX = __webpack_require__(35893);
                var SetBottom = __webpack_require__(86327);
                var SetCenterX = __webpack_require__(88417);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom center of the other.
 *
 * @function Phaser.Display.Align.In.BottomCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomCenter = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
                    SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                    return gameObject;
                };
                module1.exports = BottomCenter;
            /***/ },
            /***/ 46768: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetLeft = __webpack_require__(26541);
                var SetBottom = __webpack_require__(86327);
                var SetLeft = __webpack_require__(385);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom left of the other.
 *
 * @function Phaser.Display.Align.In.BottomLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomLeft = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                    SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                    return gameObject;
                };
                module1.exports = BottomLeft;
            /***/ },
            /***/ 35827: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetRight = __webpack_require__(54380);
                var SetBottom = __webpack_require__(86327);
                var SetRight = __webpack_require__(40136);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom right of the other.
 *
 * @function Phaser.Display.Align.In.BottomRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomRight = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetRight(alignIn) + offsetX);
                    SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                    return gameObject;
                };
                module1.exports = BottomRight;
            /***/ },
            /***/ 46871: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CenterOn = __webpack_require__(66786);
                var GetCenterX = __webpack_require__(35893);
                var GetCenterY = __webpack_require__(7702);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the center of the other.
 *
 * @function Phaser.Display.Align.In.Center
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var Center = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    CenterOn(gameObject, GetCenterX(alignIn) + offsetX, GetCenterY(alignIn) + offsetY);
                    return gameObject;
                };
                module1.exports = Center;
            /***/ },
            /***/ 5198: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(7702);
                var GetLeft = __webpack_require__(26541);
                var SetCenterY = __webpack_require__(20786);
                var SetLeft = __webpack_require__(385);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the left center of the other.
 *
 * @function Phaser.Display.Align.In.LeftCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftCenter = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                    SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
                    return gameObject;
                };
                module1.exports = LeftCenter;
            /***/ },
            /***/ 11879: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(60461);
                var AlignInMap = [];
                AlignInMap[ALIGN_CONST.BOTTOM_CENTER] = __webpack_require__(54312);
                AlignInMap[ALIGN_CONST.BOTTOM_LEFT] = __webpack_require__(46768);
                AlignInMap[ALIGN_CONST.BOTTOM_RIGHT] = __webpack_require__(35827);
                AlignInMap[ALIGN_CONST.CENTER] = __webpack_require__(46871);
                AlignInMap[ALIGN_CONST.LEFT_CENTER] = __webpack_require__(5198);
                AlignInMap[ALIGN_CONST.RIGHT_CENTER] = __webpack_require__(80503);
                AlignInMap[ALIGN_CONST.TOP_CENTER] = __webpack_require__(89698);
                AlignInMap[ALIGN_CONST.TOP_LEFT] = __webpack_require__(922);
                AlignInMap[ALIGN_CONST.TOP_RIGHT] = __webpack_require__(21373);
                AlignInMap[ALIGN_CONST.LEFT_BOTTOM] = AlignInMap[ALIGN_CONST.BOTTOM_LEFT];
                AlignInMap[ALIGN_CONST.LEFT_TOP] = AlignInMap[ALIGN_CONST.TOP_LEFT];
                AlignInMap[ALIGN_CONST.RIGHT_BOTTOM] = AlignInMap[ALIGN_CONST.BOTTOM_RIGHT];
                AlignInMap[ALIGN_CONST.RIGHT_TOP] = AlignInMap[ALIGN_CONST.TOP_RIGHT];
                /**
 * Takes given Game Object and aligns it so that it is positioned relative to the other.
 * The alignment used is based on the `position` argument, which is an `ALIGN_CONST` value, such as `LEFT_CENTER` or `TOP_RIGHT`.
 *
 * @function Phaser.Display.Align.In.QuickSet
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
 *
 * @param {Phaser.GameObjects.GameObject} child - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} position - The position to align the Game Object with. This is an align constant, such as `ALIGN_CONST.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var QuickSet = function(child, alignIn, position, offsetX, offsetY) {
                    return AlignInMap[position](child, alignIn, offsetX, offsetY);
                };
                module1.exports = QuickSet;
            /***/ },
            /***/ 80503: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(7702);
                var GetRight = __webpack_require__(54380);
                var SetCenterY = __webpack_require__(20786);
                var SetRight = __webpack_require__(40136);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the right center of the other.
 *
 * @function Phaser.Display.Align.In.RightCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightCenter = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetRight(alignIn) + offsetX);
                    SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
                    return gameObject;
                };
                module1.exports = RightCenter;
            /***/ },
            /***/ 89698: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterX = __webpack_require__(35893);
                var GetTop = __webpack_require__(17717);
                var SetCenterX = __webpack_require__(88417);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the top center of the other.
 *
 * @function Phaser.Display.Align.In.TopCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopCenter = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
                    SetTop(gameObject, GetTop(alignIn) - offsetY);
                    return gameObject;
                };
                module1.exports = TopCenter;
            /***/ },
            /***/ 922: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(26541);
                var GetTop = __webpack_require__(17717);
                var SetLeft = __webpack_require__(385);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the top left of the other.
 *
 * @function Phaser.Display.Align.In.TopLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopLeft = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                    SetTop(gameObject, GetTop(alignIn) - offsetY);
                    return gameObject;
                };
                module1.exports = TopLeft;
            /***/ },
            /***/ 21373: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(54380);
                var GetTop = __webpack_require__(17717);
                var SetRight = __webpack_require__(40136);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned in the top right of the other.
 *
 * @function Phaser.Display.Align.In.TopRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopRight = function(gameObject, alignIn, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetRight(alignIn) + offsetX);
                    SetTop(gameObject, GetTop(alignIn) - offsetY);
                    return gameObject;
                };
                module1.exports = TopRight;
            /***/ },
            /***/ 91660: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Align.In
 */ module1.exports = {
                    BottomCenter: __webpack_require__(54312),
                    BottomLeft: __webpack_require__(46768),
                    BottomRight: __webpack_require__(35827),
                    Center: __webpack_require__(46871),
                    LeftCenter: __webpack_require__(5198),
                    QuickSet: __webpack_require__(11879),
                    RightCenter: __webpack_require__(80503),
                    TopCenter: __webpack_require__(89698),
                    TopLeft: __webpack_require__(922),
                    TopRight: __webpack_require__(21373)
                };
            /***/ },
            /***/ 71926: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(60461);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Display.Align
 */ var Align = {
                    In: __webpack_require__(91660),
                    To: __webpack_require__(16694)
                };
                //   Merge in the consts
                Align = Extend(false, Align, CONST);
                module1.exports = Align;
            /***/ },
            /***/ 21578: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetCenterX = __webpack_require__(35893);
                var SetCenterX = __webpack_require__(88417);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom center position of the other.
 *
 * @function Phaser.Display.Align.To.BottomCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomCenter = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
                    SetTop(gameObject, GetBottom(alignTo) + offsetY);
                    return gameObject;
                };
                module1.exports = BottomCenter;
            /***/ },
            /***/ 10210: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetLeft = __webpack_require__(26541);
                var SetLeft = __webpack_require__(385);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom left position of the other.
 *
 * @function Phaser.Display.Align.To.BottomLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomLeft = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetLeft(alignTo) - offsetX);
                    SetTop(gameObject, GetBottom(alignTo) + offsetY);
                    return gameObject;
                };
                module1.exports = BottomLeft;
            /***/ },
            /***/ 82341: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetRight = __webpack_require__(54380);
                var SetRight = __webpack_require__(40136);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom right position of the other.
 *
 * @function Phaser.Display.Align.To.BottomRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomRight = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetRight(alignTo) + offsetX);
                    SetTop(gameObject, GetBottom(alignTo) + offsetY);
                    return gameObject;
                };
                module1.exports = BottomRight;
            /***/ },
            /***/ 87958: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetLeft = __webpack_require__(26541);
                var SetBottom = __webpack_require__(86327);
                var SetRight = __webpack_require__(40136);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the left bottom position of the other.
 *
 * @function Phaser.Display.Align.To.LeftBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftBottom = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetLeft(alignTo) - offsetX);
                    SetBottom(gameObject, GetBottom(alignTo) + offsetY);
                    return gameObject;
                };
                module1.exports = LeftBottom;
            /***/ },
            /***/ 40080: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(7702);
                var GetLeft = __webpack_require__(26541);
                var SetCenterY = __webpack_require__(20786);
                var SetRight = __webpack_require__(40136);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the left center position of the other.
 *
 * @function Phaser.Display.Align.To.LeftCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftCenter = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetLeft(alignTo) - offsetX);
                    SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
                    return gameObject;
                };
                module1.exports = LeftCenter;
            /***/ },
            /***/ 88466: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(26541);
                var GetTop = __webpack_require__(17717);
                var SetRight = __webpack_require__(40136);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the left top position of the other.
 *
 * @function Phaser.Display.Align.To.LeftTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftTop = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetLeft(alignTo) - offsetX);
                    SetTop(gameObject, GetTop(alignTo) - offsetY);
                    return gameObject;
                };
                module1.exports = LeftTop;
            /***/ },
            /***/ 38829: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(60461);
                var AlignToMap = [];
                AlignToMap[ALIGN_CONST.BOTTOM_CENTER] = __webpack_require__(21578);
                AlignToMap[ALIGN_CONST.BOTTOM_LEFT] = __webpack_require__(10210);
                AlignToMap[ALIGN_CONST.BOTTOM_RIGHT] = __webpack_require__(82341);
                AlignToMap[ALIGN_CONST.LEFT_BOTTOM] = __webpack_require__(87958);
                AlignToMap[ALIGN_CONST.LEFT_CENTER] = __webpack_require__(40080);
                AlignToMap[ALIGN_CONST.LEFT_TOP] = __webpack_require__(88466);
                AlignToMap[ALIGN_CONST.RIGHT_BOTTOM] = __webpack_require__(19211);
                AlignToMap[ALIGN_CONST.RIGHT_CENTER] = __webpack_require__(34609);
                AlignToMap[ALIGN_CONST.RIGHT_TOP] = __webpack_require__(48741);
                AlignToMap[ALIGN_CONST.TOP_CENTER] = __webpack_require__(49440);
                AlignToMap[ALIGN_CONST.TOP_LEFT] = __webpack_require__(81288);
                AlignToMap[ALIGN_CONST.TOP_RIGHT] = __webpack_require__(61323);
                /**
 * Takes a Game Object and aligns it next to another, at the given position.
 * The alignment used is based on the `position` argument, which is a `Phaser.Display.Align` property such as `LEFT_CENTER` or `TOP_RIGHT`.
 *
 * @function Phaser.Display.Align.To.QuickSet
 * @since 3.22.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
 *
 * @param {Phaser.GameObjects.GameObject} child - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} position - The position to align the Game Object with. This is an align constant, such as `Phaser.Display.Align.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var QuickSet = function(child, alignTo, position, offsetX, offsetY) {
                    return AlignToMap[position](child, alignTo, offsetX, offsetY);
                };
                module1.exports = QuickSet;
            /***/ },
            /***/ 19211: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetRight = __webpack_require__(54380);
                var SetBottom = __webpack_require__(86327);
                var SetLeft = __webpack_require__(385);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the right bottom position of the other.
 *
 * @function Phaser.Display.Align.To.RightBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightBottom = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetRight(alignTo) + offsetX);
                    SetBottom(gameObject, GetBottom(alignTo) + offsetY);
                    return gameObject;
                };
                module1.exports = RightBottom;
            /***/ },
            /***/ 34609: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(7702);
                var GetRight = __webpack_require__(54380);
                var SetCenterY = __webpack_require__(20786);
                var SetLeft = __webpack_require__(385);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the right center position of the other.
 *
 * @function Phaser.Display.Align.To.RightCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightCenter = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetRight(alignTo) + offsetX);
                    SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
                    return gameObject;
                };
                module1.exports = RightCenter;
            /***/ },
            /***/ 48741: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(54380);
                var GetTop = __webpack_require__(17717);
                var SetLeft = __webpack_require__(385);
                var SetTop = __webpack_require__(66737);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the right top position of the other.
 *
 * @function Phaser.Display.Align.To.RightTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightTop = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetRight(alignTo) + offsetX);
                    SetTop(gameObject, GetTop(alignTo) - offsetY);
                    return gameObject;
                };
                module1.exports = RightTop;
            /***/ },
            /***/ 49440: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterX = __webpack_require__(35893);
                var GetTop = __webpack_require__(17717);
                var SetBottom = __webpack_require__(86327);
                var SetCenterX = __webpack_require__(88417);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the top center position of the other.
 *
 * @function Phaser.Display.Align.To.TopCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopCenter = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
                    SetBottom(gameObject, GetTop(alignTo) - offsetY);
                    return gameObject;
                };
                module1.exports = TopCenter;
            /***/ },
            /***/ 81288: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(26541);
                var GetTop = __webpack_require__(17717);
                var SetBottom = __webpack_require__(86327);
                var SetLeft = __webpack_require__(385);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the top left position of the other.
 *
 * @function Phaser.Display.Align.To.TopLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopLeft = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetLeft(gameObject, GetLeft(alignTo) - offsetX);
                    SetBottom(gameObject, GetTop(alignTo) - offsetY);
                    return gameObject;
                };
                module1.exports = TopLeft;
            /***/ },
            /***/ 61323: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(54380);
                var GetTop = __webpack_require__(17717);
                var SetBottom = __webpack_require__(86327);
                var SetRight = __webpack_require__(40136);
                /**
 * Takes given Game Object and aligns it so that it is positioned next to the top right position of the other.
 *
 * @function Phaser.Display.Align.To.TopRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopRight = function(gameObject, alignTo, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    SetRight(gameObject, GetRight(alignTo) + offsetX);
                    SetBottom(gameObject, GetTop(alignTo) - offsetY);
                    return gameObject;
                };
                module1.exports = TopRight;
            /***/ },
            /***/ 16694: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Align.To
 */ module1.exports = {
                    BottomCenter: __webpack_require__(21578),
                    BottomLeft: __webpack_require__(10210),
                    BottomRight: __webpack_require__(82341),
                    LeftBottom: __webpack_require__(87958),
                    LeftCenter: __webpack_require__(40080),
                    LeftTop: __webpack_require__(88466),
                    QuickSet: __webpack_require__(38829),
                    RightBottom: __webpack_require__(19211),
                    RightCenter: __webpack_require__(34609),
                    RightTop: __webpack_require__(48741),
                    TopCenter: __webpack_require__(49440),
                    TopLeft: __webpack_require__(81288),
                    TopRight: __webpack_require__(61323)
                };
            /***/ },
            /***/ 66786: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetCenterX = __webpack_require__(88417);
                var SetCenterY = __webpack_require__(20786);
                /**
 * Positions the Game Object so that it is centered on the given coordinates.
 *
 * @function Phaser.Display.Bounds.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} x - The horizontal coordinate to position the Game Object on.
 * @param {number} y - The vertical coordinate to position the Game Object on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var CenterOn = function(gameObject, x, y) {
                    SetCenterX(gameObject, x);
                    return SetCenterY(gameObject, y);
                };
                module1.exports = CenterOn;
            /***/ },
            /***/ 62235: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the bottom coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetBottom
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The bottom coordinate of the bounds of the Game Object.
 */ var GetBottom = function(gameObject) {
                    return gameObject.y + gameObject.height - gameObject.height * gameObject.originY;
                };
                module1.exports = GetBottom;
            /***/ },
            /***/ 72873: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(62235);
                var GetLeft = __webpack_require__(26541);
                var GetRight = __webpack_require__(54380);
                var GetTop = __webpack_require__(17717);
                var Rectangle = __webpack_require__(87841);
                /**
 * Returns the unrotated bounds of the Game Object as a rectangle.
 *
 * @function Phaser.Display.Bounds.GetBounds
 * @since 3.24.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 * @param {(Phaser.Geom.Rectangle|object)} [output] - An object to store the values in. If not provided a new Rectangle will be created.
 *
 * @return {(Phaser.Geom.Rectangle|object)} - The bounds of the Game Object.
 */ var GetBounds = function(gameObject, output) {
                    if (output === undefined) output = new Rectangle();
                    var left = GetLeft(gameObject);
                    var top = GetTop(gameObject);
                    output.x = left;
                    output.y = top;
                    output.width = GetRight(gameObject) - left;
                    output.height = GetBottom(gameObject) - top;
                    return output;
                };
                module1.exports = GetBounds;
            /***/ },
            /***/ 35893: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the center x coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetCenterX
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The center x coordinate of the bounds of the Game Object.
 */ var GetCenterX = function(gameObject) {
                    return gameObject.x - gameObject.width * gameObject.originX + gameObject.width * 0.5;
                };
                module1.exports = GetCenterX;
            /***/ },
            /***/ 7702: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the center y coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetCenterY
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The center y coordinate of the bounds of the Game Object.
 */ var GetCenterY = function(gameObject) {
                    return gameObject.y - gameObject.height * gameObject.originY + gameObject.height * 0.5;
                };
                module1.exports = GetCenterY;
            /***/ },
            /***/ 26541: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the left coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetLeft
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The left coordinate of the bounds of the Game Object.
 */ var GetLeft = function(gameObject) {
                    return gameObject.x - gameObject.width * gameObject.originX;
                };
                module1.exports = GetLeft;
            /***/ },
            /***/ 87431: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the amount the Game Object is visually offset from its x coordinate.
 * This is the same as `width * origin.x`.
 * This value will only be > 0 if `origin.x` is not equal to zero.
 *
 * @function Phaser.Display.Bounds.GetOffsetX
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The horizontal offset of the Game Object.
 */ var GetOffsetX = function(gameObject) {
                    return gameObject.width * gameObject.originX;
                };
                module1.exports = GetOffsetX;
            /***/ },
            /***/ 46928: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the amount the Game Object is visually offset from its y coordinate.
 * This is the same as `width * origin.y`.
 * This value will only be > 0 if `origin.y` is not equal to zero.
 *
 * @function Phaser.Display.Bounds.GetOffsetY
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The vertical offset of the Game Object.
 */ var GetOffsetY = function(gameObject) {
                    return gameObject.height * gameObject.originY;
                };
                module1.exports = GetOffsetY;
            /***/ },
            /***/ 54380: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the right coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetRight
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The right coordinate of the bounds of the Game Object.
 */ var GetRight = function(gameObject) {
                    return gameObject.x + gameObject.width - gameObject.width * gameObject.originX;
                };
                module1.exports = GetRight;
            /***/ },
            /***/ 17717: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the top coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetTop
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The top coordinate of the bounds of the Game Object.
 */ var GetTop = function(gameObject) {
                    return gameObject.y - gameObject.height * gameObject.originY;
                };
                module1.exports = GetTop;
            /***/ },
            /***/ 86327: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the bottom of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetBottom = function(gameObject, value) {
                    gameObject.y = value - gameObject.height + gameObject.height * gameObject.originY;
                    return gameObject;
                };
                module1.exports = SetBottom;
            /***/ },
            /***/ 88417: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetCenterX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} x - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetCenterX = function(gameObject, x) {
                    var offsetX = gameObject.width * gameObject.originX;
                    gameObject.x = x + offsetX - gameObject.width * 0.5;
                    return gameObject;
                };
                module1.exports = SetCenterX;
            /***/ },
            /***/ 20786: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetCenterY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} y - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetCenterY = function(gameObject, y) {
                    var offsetY = gameObject.height * gameObject.originY;
                    gameObject.y = y + offsetY - gameObject.height * 0.5;
                    return gameObject;
                };
                module1.exports = SetCenterY;
            /***/ },
            /***/ 385: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetLeft = function(gameObject, value) {
                    gameObject.x = value + gameObject.width * gameObject.originX;
                    return gameObject;
                };
                module1.exports = SetLeft;
            /***/ },
            /***/ 40136: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetRight = function(gameObject, value) {
                    gameObject.x = value - gameObject.width + gameObject.width * gameObject.originX;
                    return gameObject;
                };
                module1.exports = SetRight;
            /***/ },
            /***/ 66737: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetTop = function(gameObject, value) {
                    gameObject.y = value + gameObject.height * gameObject.originY;
                    return gameObject;
                };
                module1.exports = SetTop;
            /***/ },
            /***/ 58724: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Bounds
 */ module1.exports = {
                    CenterOn: __webpack_require__(66786),
                    GetBottom: __webpack_require__(62235),
                    GetBounds: __webpack_require__(72873),
                    GetCenterX: __webpack_require__(35893),
                    GetCenterY: __webpack_require__(7702),
                    GetLeft: __webpack_require__(26541),
                    GetOffsetX: __webpack_require__(87431),
                    GetOffsetY: __webpack_require__(46928),
                    GetRight: __webpack_require__(54380),
                    GetTop: __webpack_require__(17717),
                    SetBottom: __webpack_require__(86327),
                    SetCenterX: __webpack_require__(88417),
                    SetCenterY: __webpack_require__(20786),
                    SetLeft: __webpack_require__(385),
                    SetRight: __webpack_require__(40136),
                    SetTop: __webpack_require__(66737)
                };
            /***/ },
            /***/ 20623: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Canvas.CanvasInterpolation
 * @since 3.0.0
 */ var CanvasInterpolation = {
                    /**
     * Sets the CSS image-rendering property on the given canvas to be 'crisp' (aka 'optimize contrast' on webkit).
     *
     * @function Phaser.Display.Canvas.CanvasInterpolation.setCrisp
     * @since 3.0.0
     * 
     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
     * 
     * @return {HTMLCanvasElement} The canvas.
     */ setCrisp: function(canvas) {
                        var types = [
                            'optimizeSpeed',
                            '-moz-crisp-edges',
                            '-o-crisp-edges',
                            '-webkit-optimize-contrast',
                            'optimize-contrast',
                            'crisp-edges',
                            'pixelated'
                        ];
                        types.forEach(function(type) {
                            canvas.style['image-rendering'] = type;
                        });
                        canvas.style.msInterpolationMode = 'nearest-neighbor';
                        return canvas;
                    },
                    /**
     * Sets the CSS image-rendering property on the given canvas to be 'bicubic' (aka 'auto').
     *
     * @function Phaser.Display.Canvas.CanvasInterpolation.setBicubic
     * @since 3.0.0
     * 
     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
     * 
     * @return {HTMLCanvasElement} The canvas.
     */ setBicubic: function(canvas) {
                        canvas.style['image-rendering'] = 'auto';
                        canvas.style.msInterpolationMode = 'bicubic';
                        return canvas;
                    }
                };
                module1.exports = CanvasInterpolation;
            /***/ },
            /***/ 27919: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(8054);
                var Smoothing = __webpack_require__(68703);
                // The pool into which the canvas elements are placed.
                var pool = [];
                //  Automatically apply smoothing(false) to created Canvas elements
                var _disableContextSmoothing = false;
                /**
 * The CanvasPool is a global static object, that allows Phaser to recycle and pool 2D Context Canvas DOM elements.
 * It does not pool WebGL Contexts, because once the context options are set they cannot be modified again,
 * which is useless for some of the Phaser pipelines / renderer.
 *
 * This singleton is instantiated as soon as Phaser loads, before a Phaser.Game instance has even been created.
 * Which means all instances of Phaser Games on the same page can share the one single pool.
 *
 * @namespace Phaser.Display.Canvas.CanvasPool
 * @since 3.0.0
 */ var CanvasPool = function() {
                    /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.create
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     * @param {number} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
     * @param {boolean} [selfParent=false] - Use the generated Canvas element as the parent?
     *
     * @return {HTMLCanvasElement} The canvas element that was created or pulled from the pool
     */ var create = function(parent, width, height, canvasType, selfParent) {
                        if (width === undefined) width = 1;
                        if (height === undefined) height = 1;
                        if (canvasType === undefined) canvasType = CONST.CANVAS;
                        if (selfParent === undefined) selfParent = false;
                        var canvas;
                        var container = first(canvasType);
                        if (container === null) {
                            container = {
                                parent: parent,
                                canvas: document.createElement('canvas'),
                                type: canvasType
                            };
                            if (canvasType === CONST.CANVAS) pool.push(container);
                            canvas = container.canvas;
                        } else {
                            container.parent = parent;
                            canvas = container.canvas;
                        }
                        if (selfParent) container.parent = canvas;
                        canvas.width = width;
                        canvas.height = height;
                        if (_disableContextSmoothing && canvasType === CONST.CANVAS) Smoothing.disable(canvas.getContext('2d', {
                            willReadFrequently: false
                        }));
                        return canvas;
                    };
                    /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.create2D
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     *
     * @return {HTMLCanvasElement} The created canvas.
     */ var create2D = function(parent, width, height) {
                        return create(parent, width, height, CONST.CANVAS);
                    };
                    /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.createWebGL
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     *
     * @return {HTMLCanvasElement} The created WebGL canvas.
     */ var createWebGL = function(parent, width, height) {
                        return create(parent, width, height, CONST.WEBGL);
                    };
                    /**
     * Gets the first free canvas index from the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.first
     * @since 3.0.0
     *
     * @param {number} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
     *
     * @return {HTMLCanvasElement} The first free canvas, or `null` if a WebGL canvas was requested or if the pool doesn't have free canvases.
     */ var first = function(canvasType) {
                        if (canvasType === undefined) canvasType = CONST.CANVAS;
                        if (canvasType === CONST.WEBGL) return null;
                        for(var i = 0; i < pool.length; i++){
                            var container = pool[i];
                            if (!container.parent && container.type === canvasType) return container;
                        }
                        return null;
                    };
                    /**
     * Looks up a canvas based on its parent, and if found puts it back in the pool, freeing it up for re-use.
     * The canvas has its width and height set to 1, and its parent attribute nulled.
     *
     * @function Phaser.Display.Canvas.CanvasPool.remove
     * @since 3.0.0
     *
     * @param {*} parent - The canvas or the parent of the canvas to free.
     */ var remove = function(parent) {
                        //  Check to see if the parent is a canvas object
                        var isCanvas = parent instanceof HTMLCanvasElement;
                        pool.forEach(function(container) {
                            if (isCanvas && container.canvas === parent || !isCanvas && container.parent === parent) {
                                container.parent = null;
                                container.canvas.width = 1;
                                container.canvas.height = 1;
                            }
                        });
                    };
                    /**
     * Gets the total number of used canvas elements in the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.total
     * @since 3.0.0
     *
     * @return {number} The number of used canvases.
     */ var total = function() {
                        var c = 0;
                        pool.forEach(function(container) {
                            if (container.parent) c++;
                        });
                        return c;
                    };
                    /**
     * Gets the total number of free canvas elements in the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.free
     * @since 3.0.0
     *
     * @return {number} The number of free canvases.
     */ var free = function() {
                        return pool.length - total();
                    };
                    /**
     * Disable context smoothing on any new Canvas element created.
     *
     * @function Phaser.Display.Canvas.CanvasPool.disableSmoothing
     * @since 3.0.0
     */ var disableSmoothing = function() {
                        _disableContextSmoothing = true;
                    };
                    /**
     * Enable context smoothing on any new Canvas element created.
     *
     * @function Phaser.Display.Canvas.CanvasPool.enableSmoothing
     * @since 3.0.0
     */ var enableSmoothing = function() {
                        _disableContextSmoothing = false;
                    };
                    return {
                        create2D: create2D,
                        create: create,
                        createWebGL: createWebGL,
                        disableSmoothing: disableSmoothing,
                        enableSmoothing: enableSmoothing,
                        first: first,
                        free: free,
                        pool: pool,
                        remove: remove,
                        total: total
                    };
                };
                //  If we export the called function here, it'll only be invoked once (not every time it's required).
                module1.exports = CanvasPool();
            /***/ },
            /***/ 68703: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Browser specific prefix, so not going to change between contexts, only between browsers
                var prefix = '';
                /**
 * @namespace Phaser.Display.Canvas.Smoothing
 * @since 3.0.0
 */ var Smoothing = function() {
                    /**
     * Gets the Smoothing Enabled vendor prefix being used on the given context, or null if not set.
     *
     * @function Phaser.Display.Canvas.Smoothing.getPrefix
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The canvas context to check.
     *
     * @return {string} The name of the property on the context which controls image smoothing (either `imageSmoothingEnabled` or a vendor-prefixed version thereof), or `null` if not supported.
     */ var getPrefix = function(context) {
                        var vendors = [
                            'i',
                            'webkitI',
                            'msI',
                            'mozI',
                            'oI'
                        ];
                        for(var i = 0; i < vendors.length; i++){
                            var s = vendors[i] + 'mageSmoothingEnabled';
                            if (s in context) return s;
                        }
                        return null;
                    };
                    /**
     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
     * drawn to the context will be affected. This sets the property across all current browsers but support is
     * patchy on earlier browsers, especially on mobile.
     *
     * @function Phaser.Display.Canvas.Smoothing.enable
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context on which to enable smoothing.
     *
     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} The provided context.
     */ var enable = function(context) {
                        if (prefix === '') prefix = getPrefix(context);
                        if (prefix) context[prefix] = true;
                        return context;
                    };
                    /**
     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
     * drawn to the context will be affected. This sets the property across all current browsers but support is
     * patchy on earlier browsers, especially on mobile.
     *
     * @function Phaser.Display.Canvas.Smoothing.disable
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context on which to disable smoothing.
     *
     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} The provided context.
     */ var disable = function(context) {
                        if (prefix === '') prefix = getPrefix(context);
                        if (prefix) context[prefix] = false;
                        return context;
                    };
                    /**
     * Returns `true` if the given context has image smoothing enabled, otherwise returns `false`.
     * Returns null if no smoothing prefix is available.
     *
     * @function Phaser.Display.Canvas.Smoothing.isEnabled
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context to check.
     *
     * @return {?boolean} `true` if smoothing is enabled on the context, otherwise `false`. `null` if not supported.
     */ var isEnabled = function(context) {
                        return prefix !== null ? context[prefix] : null;
                    };
                    return {
                        disable: disable,
                        enable: enable,
                        getPrefix: getPrefix,
                        isEnabled: isEnabled
                    };
                };
                module1.exports = Smoothing();
            /***/ },
            /***/ 65208: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the touch-action property on the canvas style. Can be used to disable default browser touch actions.
 *
 * @function Phaser.Display.Canvas.TouchAction
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
 * @param {string} [value='none'] - The touch action value to set on the canvas. Set to `none` to disable touch actions.
 *
 * @return {HTMLCanvasElement} The canvas element.
 */ var TouchAction = function(canvas, value) {
                    if (value === undefined) value = 'none';
                    canvas.style['msTouchAction'] = value;
                    canvas.style['ms-touch-action'] = value;
                    canvas.style['touch-action'] = value;
                    return canvas;
                };
                module1.exports = TouchAction;
            /***/ },
            /***/ 91610: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the user-select property on the canvas style. Can be used to disable default browser selection actions.
 *
 * @function Phaser.Display.Canvas.UserSelect
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
 * @param {string} [value='none'] - The touch callout value to set on the canvas. Set to `none` to disable touch callouts.
 *
 * @return {HTMLCanvasElement} The canvas element.
 */ var UserSelect = function(canvas, value) {
                    if (value === undefined) value = 'none';
                    var vendors = [
                        '-webkit-',
                        '-khtml-',
                        '-moz-',
                        '-ms-',
                        ''
                    ];
                    vendors.forEach(function(vendor) {
                        canvas.style[vendor + 'user-select'] = value;
                    });
                    canvas.style['-webkit-touch-callout'] = value;
                    canvas.style['-webkit-tap-highlight-color'] = 'rgba(0, 0, 0, 0)';
                    return canvas;
                };
                module1.exports = UserSelect;
            /***/ },
            /***/ 26253: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Canvas
 */ module1.exports = {
                    CanvasInterpolation: __webpack_require__(20623),
                    CanvasPool: __webpack_require__(27919),
                    Smoothing: __webpack_require__(68703),
                    TouchAction: __webpack_require__(65208),
                    UserSelect: __webpack_require__(91610)
                };
            /***/ },
            /***/ 40987: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetColor = __webpack_require__(37589);
                var GetColor32 = __webpack_require__(1000);
                var HSVToRGB = __webpack_require__(7537);
                var RGBToHSV = __webpack_require__(87837);
                /**
 * @namespace Phaser.Display.Color
 */ /**
 * @classdesc
 * The Color class holds a single color value and allows for easy modification and reading of it.
 *
 * @class Color
 * @memberof Phaser.Display
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [red=0] - The red color value. A number between 0 and 255.
 * @param {number} [green=0] - The green color value. A number between 0 and 255.
 * @param {number} [blue=0] - The blue color value. A number between 0 and 255.
 * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
 */ var Color = new Class({
                    initialize: function Color(red, green, blue, alpha) {
                        if (red === undefined) red = 0;
                        if (green === undefined) green = 0;
                        if (blue === undefined) blue = 0;
                        if (alpha === undefined) alpha = 255;
                        /**
         * The internal red color value.
         *
         * @name Phaser.Display.Color#r
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.r = 0;
                        /**
         * The internal green color value.
         *
         * @name Phaser.Display.Color#g
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.g = 0;
                        /**
         * The internal blue color value.
         *
         * @name Phaser.Display.Color#b
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.b = 0;
                        /**
         * The internal alpha color value.
         *
         * @name Phaser.Display.Color#a
         * @type {number}
         * @private
         * @default 255
         * @since 3.0.0
         */ this.a = 255;
                        /**
         * The hue color value. A number between 0 and 1.
         * This is the base color.
         *
         * @name Phaser.Display.Color#_h
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._h = 0;
                        /**
         * The saturation color value. A number between 0 and 1.
         * This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
         *
         * @name Phaser.Display.Color#_s
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._s = 0;
                        /**
         * The lightness color value. A number between 0 and 1.
         * This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
         *
         * @name Phaser.Display.Color#_v
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._v = 0;
                        /**
         * Is this color update locked?
         *
         * @name Phaser.Display.Color#_locked
         * @type {boolean}
         * @private
         * @since 3.13.0
         */ this._locked = false;
                        /**
         * An array containing the calculated color values for WebGL use.
         *
         * @name Phaser.Display.Color#gl
         * @type {number[]}
         * @since 3.0.0
         */ this.gl = [
                            0,
                            0,
                            0,
                            1
                        ];
                        /**
         * Pre-calculated internal color value.
         *
         * @name Phaser.Display.Color#_color
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._color = 0;
                        /**
         * Pre-calculated internal color32 value.
         *
         * @name Phaser.Display.Color#_color32
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._color32 = 0;
                        /**
         * Pre-calculated internal color rgb string value.
         *
         * @name Phaser.Display.Color#_rgba
         * @type {string}
         * @private
         * @default ''
         * @since 3.0.0
         */ this._rgba = '';
                        this.setTo(red, green, blue, alpha);
                    },
                    /**
     * Sets this color to be transparent. Sets all values to zero.
     *
     * @method Phaser.Display.Color#transparent
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ transparent: function() {
                        this._locked = true;
                        this.red = 0;
                        this.green = 0;
                        this.blue = 0;
                        this.alpha = 0;
                        this._locked = false;
                        return this.update(true);
                    },
                    /**
     * Sets the color of this Color component.
     *
     * @method Phaser.Display.Color#setTo
     * @since 3.0.0
     *
     * @param {number} red - The red color value. A number between 0 and 255.
     * @param {number} green - The green color value. A number between 0 and 255.
     * @param {number} blue - The blue color value. A number between 0 and 255.
     * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
     * @param {boolean} [updateHSV=true] - Update the HSV values after setting the RGB values?
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setTo: function(red, green, blue, alpha, updateHSV) {
                        if (alpha === undefined) alpha = 255;
                        if (updateHSV === undefined) updateHSV = true;
                        this._locked = true;
                        this.red = red;
                        this.green = green;
                        this.blue = blue;
                        this.alpha = alpha;
                        this._locked = false;
                        return this.update(updateHSV);
                    },
                    /**
     * Sets the red, green, blue and alpha GL values of this Color component.
     *
     * @method Phaser.Display.Color#setGLTo
     * @since 3.0.0
     *
     * @param {number} red - The red color value. A number between 0 and 1.
     * @param {number} green - The green color value. A number between 0 and 1.
     * @param {number} blue - The blue color value. A number between 0 and 1.
     * @param {number} [alpha=1] - The alpha value. A number between 0 and 1.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setGLTo: function(red, green, blue, alpha) {
                        if (alpha === undefined) alpha = 1;
                        this._locked = true;
                        this.redGL = red;
                        this.greenGL = green;
                        this.blueGL = blue;
                        this.alphaGL = alpha;
                        this._locked = false;
                        return this.update(true);
                    },
                    /**
     * Sets the color based on the color object given.
     *
     * @method Phaser.Display.Color#setFromRGB
     * @since 3.0.0
     *
     * @param {Phaser.Types.Display.InputColorObject} color - An object containing `r`, `g`, `b` and optionally `a` values in the range 0 to 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setFromRGB: function(color) {
                        this._locked = true;
                        this.red = color.r;
                        this.green = color.g;
                        this.blue = color.b;
                        if (color.hasOwnProperty('a')) this.alpha = color.a;
                        this._locked = false;
                        return this.update(true);
                    },
                    /**
     * Sets the color based on the hue, saturation and lightness values given.
     *
     * @method Phaser.Display.Color#setFromHSV
     * @since 3.13.0
     *
     * @param {number} h - The hue, in the range 0 - 1. This is the base color.
     * @param {number} s - The saturation, in the range 0 - 1. This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
     * @param {number} v - The value, in the range 0 - 1. This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setFromHSV: function(h, s, v) {
                        return HSVToRGB(h, s, v, this);
                    },
                    /**
     * Updates the internal cache values.
     *
     * @method Phaser.Display.Color#update
     * @private
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ update: function(updateHSV) {
                        if (updateHSV === undefined) updateHSV = false;
                        if (this._locked) return this;
                        var r = this.r;
                        var g = this.g;
                        var b = this.b;
                        var a = this.a;
                        this._color = GetColor(r, g, b);
                        this._color32 = GetColor32(r, g, b, a);
                        this._rgba = 'rgba(' + r + ',' + g + ',' + b + ',' + a / 255 + ')';
                        if (updateHSV) RGBToHSV(r, g, b, this);
                        return this;
                    },
                    /**
     * Updates the internal hsv cache values.
     *
     * @method Phaser.Display.Color#updateHSV
     * @private
     * @since 3.13.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ updateHSV: function() {
                        var r = this.r;
                        var g = this.g;
                        var b = this.b;
                        RGBToHSV(r, g, b, this);
                        return this;
                    },
                    /**
     * Returns a new Color component using the values from this one.
     *
     * @method Phaser.Display.Color#clone
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} A new Color object.
     */ clone: function() {
                        return new Color(this.r, this.g, this.b, this.a);
                    },
                    /**
     * Sets this Color object to be grayscaled based on the shade value given.
     *
     * @method Phaser.Display.Color#gray
     * @since 3.13.0
     * 
     * @param {number} shade - A value between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ gray: function(shade) {
                        return this.setTo(shade, shade, shade);
                    },
                    /**
     * Sets this Color object to be a random color between the `min` and `max` values given.
     *
     * @method Phaser.Display.Color#random
     * @since 3.13.0
     * 
     * @param {number} [min=0] - The minimum random color value. Between 0 and 255.
     * @param {number} [max=255] - The maximum random color value. Between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ random: function(min, max) {
                        if (min === undefined) min = 0;
                        if (max === undefined) max = 255;
                        var r = Math.floor(min + Math.random() * (max - min));
                        var g = Math.floor(min + Math.random() * (max - min));
                        var b = Math.floor(min + Math.random() * (max - min));
                        return this.setTo(r, g, b);
                    },
                    /**
     * Sets this Color object to be a random grayscale color between the `min` and `max` values given.
     *
     * @method Phaser.Display.Color#randomGray
     * @since 3.13.0
     * 
     * @param {number} [min=0] - The minimum random color value. Between 0 and 255.
     * @param {number} [max=255] - The maximum random color value. Between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ randomGray: function(min, max) {
                        if (min === undefined) min = 0;
                        if (max === undefined) max = 255;
                        var s = Math.floor(min + Math.random() * (max - min));
                        return this.setTo(s, s, s);
                    },
                    /**
     * Increase the saturation of this Color by the percentage amount given.
     * The saturation is the amount of the base color in the hue.
     *
     * @method Phaser.Display.Color#saturate
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ saturate: function(amount) {
                        this.s += amount / 100;
                        return this;
                    },
                    /**
     * Decrease the saturation of this Color by the percentage amount given.
     * The saturation is the amount of the base color in the hue.
     *
     * @method Phaser.Display.Color#desaturate
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ desaturate: function(amount) {
                        this.s -= amount / 100;
                        return this;
                    },
                    /**
     * Increase the lightness of this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#lighten
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ lighten: function(amount) {
                        this.v += amount / 100;
                        return this;
                    },
                    /**
     * Decrease the lightness of this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#darken
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ darken: function(amount) {
                        this.v -= amount / 100;
                        return this;
                    },
                    /**
     * Brighten this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#brighten
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ brighten: function(amount) {
                        var r = this.r;
                        var g = this.g;
                        var b = this.b;
                        r = Math.max(0, Math.min(255, r - Math.round(255 * -(amount / 100))));
                        g = Math.max(0, Math.min(255, g - Math.round(255 * -(amount / 100))));
                        b = Math.max(0, Math.min(255, b - Math.round(255 * -(amount / 100))));
                        return this.setTo(r, g, b);
                    },
                    /**
     * The color of this Color component, not including the alpha channel.
     *
     * @name Phaser.Display.Color#color
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ color: {
                        get: function() {
                            return this._color;
                        }
                    },
                    /**
     * The color of this Color component, including the alpha channel.
     *
     * @name Phaser.Display.Color#color32
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ color32: {
                        get: function() {
                            return this._color32;
                        }
                    },
                    /**
     * The color of this Color component as a string which can be used in CSS color values.
     *
     * @name Phaser.Display.Color#rgba
     * @type {string}
     * @readonly
     * @since 3.0.0
     */ rgba: {
                        get: function() {
                            return this._rgba;
                        }
                    },
                    /**
     * The red color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#redGL
     * @type {number}
     * @since 3.0.0
     */ redGL: {
                        get: function() {
                            return this.gl[0];
                        },
                        set: function(value) {
                            this.gl[0] = Math.min(Math.abs(value), 1);
                            this.r = Math.floor(this.gl[0] * 255);
                            this.update(true);
                        }
                    },
                    /**
     * The green color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#greenGL
     * @type {number}
     * @since 3.0.0
     */ greenGL: {
                        get: function() {
                            return this.gl[1];
                        },
                        set: function(value) {
                            this.gl[1] = Math.min(Math.abs(value), 1);
                            this.g = Math.floor(this.gl[1] * 255);
                            this.update(true);
                        }
                    },
                    /**
     * The blue color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#blueGL
     * @type {number}
     * @since 3.0.0
     */ blueGL: {
                        get: function() {
                            return this.gl[2];
                        },
                        set: function(value) {
                            this.gl[2] = Math.min(Math.abs(value), 1);
                            this.b = Math.floor(this.gl[2] * 255);
                            this.update(true);
                        }
                    },
                    /**
     * The alpha color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#alphaGL
     * @type {number}
     * @since 3.0.0
     */ alphaGL: {
                        get: function() {
                            return this.gl[3];
                        },
                        set: function(value) {
                            this.gl[3] = Math.min(Math.abs(value), 1);
                            this.a = Math.floor(this.gl[3] * 255);
                            this.update();
                        }
                    },
                    /**
     * The red color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#red
     * @type {number}
     * @since 3.0.0
     */ red: {
                        get: function() {
                            return this.r;
                        },
                        set: function(value) {
                            value = Math.floor(Math.abs(value));
                            this.r = Math.min(value, 255);
                            this.gl[0] = value / 255;
                            this.update(true);
                        }
                    },
                    /**
     * The green color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#green
     * @type {number}
     * @since 3.0.0
     */ green: {
                        get: function() {
                            return this.g;
                        },
                        set: function(value) {
                            value = Math.floor(Math.abs(value));
                            this.g = Math.min(value, 255);
                            this.gl[1] = value / 255;
                            this.update(true);
                        }
                    },
                    /**
     * The blue color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#blue
     * @type {number}
     * @since 3.0.0
     */ blue: {
                        get: function() {
                            return this.b;
                        },
                        set: function(value) {
                            value = Math.floor(Math.abs(value));
                            this.b = Math.min(value, 255);
                            this.gl[2] = value / 255;
                            this.update(true);
                        }
                    },
                    /**
     * The alpha color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                        get: function() {
                            return this.a;
                        },
                        set: function(value) {
                            value = Math.floor(Math.abs(value));
                            this.a = Math.min(value, 255);
                            this.gl[3] = value / 255;
                            this.update();
                        }
                    },
                    /**
     * The hue color value. A number between 0 and 1.
     * This is the base color.
     *
     * @name Phaser.Display.Color#h
     * @type {number}
     * @since 3.13.0
     */ h: {
                        get: function() {
                            return this._h;
                        },
                        set: function(value) {
                            this._h = value;
                            HSVToRGB(value, this._s, this._v, this);
                        }
                    },
                    /**
     * The saturation color value. A number between 0 and 1.
     * This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
     *
     * @name Phaser.Display.Color#s
     * @type {number}
     * @since 3.13.0
     */ s: {
                        get: function() {
                            return this._s;
                        },
                        set: function(value) {
                            this._s = value;
                            HSVToRGB(this._h, value, this._v, this);
                        }
                    },
                    /**
     * The lightness color value. A number between 0 and 1.
     * This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
     *
     * @name Phaser.Display.Color#v
     * @type {number}
     * @since 3.13.0
     */ v: {
                        get: function() {
                            return this._v;
                        },
                        set: function(value) {
                            this._v = value;
                            HSVToRGB(this._h, this._s, value, this);
                        }
                    }
                });
                module1.exports = Color;
            /***/ },
            /***/ 92728: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(37589);
                /**
 * Return an array of Colors in a Color Spectrum.
 *
 * The spectrum colors flow in the order: red, yellow, green, blue.
 *
 * By default this function will return an array with 1024 elements in.
 *
 * However, you can reduce this to a smaller quantity if needed, by specitying the `limit` parameter.
 *
 * @function Phaser.Display.Color.ColorSpectrum
 * @since 3.50.0
 *
 * @param {number} [limit=1024] - How many colors should be returned? The maximum is 1024 but you can set a smaller quantity if required.
 *
 * @return {Phaser.Types.Display.ColorObject[]} An array containing `limit` parameter number of elements, where each contains a Color Object.
 */ var ColorSpectrum = function(limit) {
                    if (limit === undefined) limit = 1024;
                    var colors = [];
                    var range = 255;
                    var i;
                    var r = 255;
                    var g = 0;
                    var b = 0;
                    //  Red to Yellow
                    for(i = 0; i <= range; i++)colors.push({
                        r: r,
                        g: i,
                        b: b,
                        color: GetColor(r, i, b)
                    });
                    g = 255;
                    //  Yellow to Green
                    for(i = range; i >= 0; i--)colors.push({
                        r: i,
                        g: g,
                        b: b,
                        color: GetColor(i, g, b)
                    });
                    r = 0;
                    //  Green to Blue
                    for(i = 0; i <= range; i++, g--)colors.push({
                        r: r,
                        g: g,
                        b: i,
                        color: GetColor(r, g, i)
                    });
                    g = 0;
                    b = 255;
                    //  Blue to Red
                    for(i = 0; i <= range; i++, b--, r++)colors.push({
                        r: r,
                        g: g,
                        b: b,
                        color: GetColor(r, g, b)
                    });
                    if (limit === 1024) return colors;
                    else {
                        var out = [];
                        var t = 0;
                        var inc = 1024 / limit;
                        for(i = 0; i < limit; i++){
                            out.push(colors[Math.floor(t)]);
                            t += inc;
                        }
                        return out;
                    }
                };
                module1.exports = ColorSpectrum;
            /***/ },
            /***/ 91588: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts the given color value into an Object containing r,g,b and a properties.
 *
 * @function Phaser.Display.Color.ColorToRGBA
 * @since 3.0.0
 *
 * @param {number} color - A color value, optionally including the alpha value.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the parsed color values.
 */ var ColorToRGBA = function(color) {
                    var output = {
                        r: color >> 16 & 0xFF,
                        g: color >> 8 & 0xFF,
                        b: color & 0xFF,
                        a: 255
                    };
                    if (color > 16777215) output.a = color >>> 24;
                    return output;
                };
                module1.exports = ColorToRGBA;
            /***/ },
            /***/ 62957: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a string containing a hex representation of the given color component.
 *
 * @function Phaser.Display.Color.ComponentToHex
 * @since 3.0.0
 *
 * @param {number} color - The color channel to get the hex value for, must be a value between 0 and 255.
 *
 * @return {string} A string of length 2 characters, i.e. 255 = ff, 100 = 64.
 */ var ComponentToHex = function(color) {
                    var hex = color.toString(16);
                    return hex.length === 1 ? '0' + hex : hex;
                };
                module1.exports = ComponentToHex;
            /***/ },
            /***/ 37589: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given 3 separate color values this will return an integer representation of it.
 *
 * @function Phaser.Display.Color.GetColor
 * @since 3.0.0
 *
 * @param {number} red - The red color value. A number between 0 and 255.
 * @param {number} green - The green color value. A number between 0 and 255.
 * @param {number} blue - The blue color value. A number between 0 and 255.
 *
 * @return {number} The combined color value.
 */ var GetColor = function(red, green, blue) {
                    return red << 16 | green << 8 | blue;
                };
                module1.exports = GetColor;
            /***/ },
            /***/ 1000: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given an alpha and 3 color values this will return an integer representation of it.
 *
 * @function Phaser.Display.Color.GetColor32
 * @since 3.0.0
 *
 * @param {number} red - The red color value. A number between 0 and 255.
 * @param {number} green - The green color value. A number between 0 and 255.
 * @param {number} blue - The blue color value. A number between 0 and 255.
 * @param {number} alpha - The alpha color value. A number between 0 and 255.
 *
 * @return {number} The combined color value.
 */ var GetColor32 = function(red, green, blue, alpha) {
                    return alpha << 24 | red << 16 | green << 8 | blue;
                };
                module1.exports = GetColor32;
            /***/ },
            /***/ 62183: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(40987);
                var HueToComponent = __webpack_require__(89528);
                /**
 * Converts HSL (hue, saturation and lightness) values to a Phaser Color object.
 *
 * @function Phaser.Display.Color.HSLToColor
 * @since 3.0.0
 *
 * @param {number} h - The hue value in the range 0 to 1.
 * @param {number} s - The saturation value in the range 0 to 1.
 * @param {number} l - The lightness value in the range 0 to 1.
 *
 * @return {Phaser.Display.Color} A Color object created from the results of the h, s and l values.
 */ var HSLToColor = function(h, s, l) {
                    // achromatic by default
                    var r = l;
                    var g = l;
                    var b = l;
                    if (s !== 0) {
                        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                        var p = 2 * l - q;
                        r = HueToComponent(p, q, h + 1 / 3);
                        g = HueToComponent(p, q, h);
                        b = HueToComponent(p, q, h - 1 / 3);
                    }
                    var color = new Color();
                    return color.setGLTo(r, g, b, 1);
                };
                module1.exports = HSLToColor;
            /***/ },
            /***/ 27939: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HSVToRGB = __webpack_require__(7537);
                /**
 * Generates an HSV color wheel which is an array of 360 Color objects, for each step of the wheel.
 *
 * @function Phaser.Display.Color.HSVColorWheel
 * @since 3.0.0
 *
 * @param {number} [s=1] - The saturation, in the range 0 - 1.
 * @param {number} [v=1] - The value, in the range 0 - 1.
 *
 * @return {Phaser.Types.Display.ColorObject[]} An array containing 360 ColorObject elements, where each element contains a Color object corresponding to the color at that point in the HSV color wheel.
 */ var HSVColorWheel = function(s, v) {
                    if (s === undefined) s = 1;
                    if (v === undefined) v = 1;
                    var colors = [];
                    for(var c = 0; c <= 359; c++)colors.push(HSVToRGB(c / 359, s, v));
                    return colors;
                };
                module1.exports = HSVColorWheel;
            /***/ },
            /***/ 7537: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(37589);
                /**
 * RGB space conversion.
 *
 * @ignore
 *
 * @param {number} n - The value to convert.
 * @param {number} h - The h value.
 * @param {number} s - The s value.
 * @param {number} v - The v value.
 *
 * @return {number} The converted value.
 */ function ConvertValue(n, h, s, v) {
                    var k = (n + h * 6) % 6;
                    var min = Math.min(k, 4 - k, 1);
                    return Math.round(255 * (v - v * s * Math.max(0, min)));
                }
                /**
 * Converts a HSV (hue, saturation and value) color set to RGB.
 *
 * Conversion formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 *
 * Assumes HSV values are contained in the set [0, 1].
 *
 * @function Phaser.Display.Color.HSVToRGB
 * @since 3.0.0
 *
 * @param {number} h - The hue, in the range 0 - 1. This is the base color.
 * @param {number} s - The saturation, in the range 0 - 1. This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
 * @param {number} v - The value, in the range 0 - 1. This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
 * @param {(Phaser.Types.Display.ColorObject|Phaser.Display.Color)} [out] - A Color object to store the results in. If not given a new ColorObject will be created.
 *
 * @return {(Phaser.Types.Display.ColorObject|Phaser.Display.Color)} An object with the red, green and blue values set in the r, g and b properties.
 */ var HSVToRGB = function(h, s, v, out) {
                    if (s === undefined) s = 1;
                    if (v === undefined) v = 1;
                    var r = ConvertValue(5, h, s, v);
                    var g = ConvertValue(3, h, s, v);
                    var b = ConvertValue(1, h, s, v);
                    if (!out) return {
                        r: r,
                        g: g,
                        b: b,
                        color: GetColor(r, g, b)
                    };
                    else if (out.setTo) return out.setTo(r, g, b, out.alpha, true);
                    else {
                        out.r = r;
                        out.g = g;
                        out.b = b;
                        out.color = GetColor(r, g, b);
                        return out;
                    }
                };
                module1.exports = HSVToRGB;
            /***/ },
            /***/ 70238: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(40987);
                /**
 * Converts a hex string into a Phaser Color object.
 * 
 * The hex string can supplied as `'#0033ff'` or the short-hand format of `'#03f'`; it can begin with an optional "#" or "0x", or be unprefixed.
 *
 * An alpha channel is _not_ supported.
 *
 * @function Phaser.Display.Color.HexStringToColor
 * @since 3.0.0
 *
 * @param {string} hex - The hex color value to convert, such as `#0033ff` or the short-hand format: `#03f`.
 *
 * @return {Phaser.Display.Color} A Color object populated by the values of the given string.
 */ var HexStringToColor = function(hex) {
                    var color = new Color();
                    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
                    hex = hex.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
                        return r + r + g + g + b + b;
                    });
                    var result = /^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                    if (result) {
                        var r = parseInt(result[1], 16);
                        var g = parseInt(result[2], 16);
                        var b = parseInt(result[3], 16);
                        color.setTo(r, g, b);
                    }
                    return color;
                };
                module1.exports = HexStringToColor;
            /***/ },
            /***/ 89528: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts a hue to an RGB color.
 * Based on code by Michael Jackson (https://github.com/mjijackson)
 *
 * @function Phaser.Display.Color.HueToComponent
 * @since 3.0.0
 *
 * @param {number} p
 * @param {number} q
 * @param {number} t
 *
 * @return {number} The combined color value.
 */ var HueToComponent = function(p, q, t) {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 0.5) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };
                module1.exports = HueToComponent;
            /***/ },
            /***/ 30100: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(40987);
                var IntegerToRGB = __webpack_require__(90664);
                /**
 * Converts the given color value into an instance of a Color object.
 *
 * @function Phaser.Display.Color.IntegerToColor
 * @since 3.0.0
 *
 * @param {number} input - The color value to convert into a Color object.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var IntegerToColor = function(input) {
                    var rgb = IntegerToRGB(input);
                    return new Color(rgb.r, rgb.g, rgb.b, rgb.a);
                };
                module1.exports = IntegerToColor;
            /***/ },
            /***/ 90664: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Return the component parts of a color as an Object with the properties alpha, red, green, blue.
 *
 * Alpha will only be set if it exists in the given color (0xAARRGGBB)
 *
 * @function Phaser.Display.Color.IntegerToRGB
 * @since 3.0.0
 *
 * @param {number} input - The color value to convert into a Color object.
 *
 * @return {Phaser.Types.Display.ColorObject} An object with the red, green and blue values set in the r, g and b properties.
 */ var IntegerToRGB = function(color) {
                    if (color > 16777215) //  The color value has an alpha component
                    return {
                        a: color >>> 24,
                        r: color >> 16 & 0xFF,
                        g: color >> 8 & 0xFF,
                        b: color & 0xFF
                    };
                    else return {
                        a: 255,
                        r: color >> 16 & 0xFF,
                        g: color >> 8 & 0xFF,
                        b: color & 0xFF
                    };
                };
                module1.exports = IntegerToRGB;
            /***/ },
            /***/ 13699: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Linear = __webpack_require__(28915);
                var GetColor = __webpack_require__(37589);
                /**
 * @namespace Phaser.Display.Color.Interpolate
 * @memberof Phaser.Display.Color
 * @since 3.0.0
 */ /**
 * Interpolates between the two given color ranges over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.RGBWithRGB
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {number} r1 - Red value.
 * @param {number} g1 - Blue value.
 * @param {number} b1 - Green value.
 * @param {number} r2 - Red value.
 * @param {number} g2 - Blue value.
 * @param {number} b2 - Green value.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var RGBWithRGB = function(r1, g1, b1, r2, g2, b2, length, index) {
                    if (length === undefined) length = 100;
                    if (index === undefined) index = 0;
                    var t = index / length;
                    var r = Linear(r1, r2, t);
                    var g = Linear(g1, g2, t);
                    var b = Linear(b1, b2, t);
                    return {
                        r: r,
                        g: g,
                        b: b,
                        a: 255,
                        color: GetColor(r, g, b)
                    };
                };
                /**
 * Interpolates between the two given color objects over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.ColorWithColor
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {Phaser.Display.Color} color1 - The first Color object.
 * @param {Phaser.Display.Color} color2 - The second Color object.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var ColorWithColor = function(color1, color2, length, index) {
                    if (length === undefined) length = 100;
                    if (index === undefined) index = 0;
                    return RGBWithRGB(color1.r, color1.g, color1.b, color2.r, color2.g, color2.b, length, index);
                };
                /**
 * Interpolates between the Color object and color values over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.ColorWithRGB
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {Phaser.Display.Color} color1 - The first Color object.
 * @param {number} r - Red value.
 * @param {number} g - Blue value.
 * @param {number} b - Green value.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var ColorWithRGB = function(color, r, g, b, length, index) {
                    if (length === undefined) length = 100;
                    if (index === undefined) index = 0;
                    return RGBWithRGB(color.r, color.g, color.b, r, g, b, length, index);
                };
                module1.exports = {
                    RGBWithRGB: RGBWithRGB,
                    ColorWithRGB: ColorWithRGB,
                    ColorWithColor: ColorWithColor
                };
            /***/ },
            /***/ 68957: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(40987);
                /**
 * Converts an object containing `r`, `g`, `b` and `a` properties into a Color class instance.
 *
 * @function Phaser.Display.Color.ObjectToColor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Display.InputColorObject} input - An object containing `r`, `g`, `b` and `a` properties in the range 0 to 255.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var ObjectToColor = function(input) {
                    return new Color(input.r, input.g, input.b, input.a);
                };
                module1.exports = ObjectToColor;
            /***/ },
            /***/ 87388: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(40987);
                /**
 * Converts a CSS 'web' string into a Phaser Color object.
 * 
 * The web string can be in the format `'rgb(r,g,b)'` or `'rgba(r,g,b,a)'` where r/g/b are in the range [0..255] and a is in the range [0..1].
 *
 * @function Phaser.Display.Color.RGBStringToColor
 * @since 3.0.0
 *
 * @param {string} rgb - The CSS format color string, using the `rgb` or `rgba` format.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var RGBStringToColor = function(rgb) {
                    var color = new Color();
                    var result = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(rgb.toLowerCase());
                    if (result) {
                        var r = parseInt(result[1], 10);
                        var g = parseInt(result[2], 10);
                        var b = parseInt(result[3], 10);
                        var a = result[4] !== undefined ? parseFloat(result[4]) : 1;
                        color.setTo(r, g, b, a * 255);
                    }
                    return color;
                };
                module1.exports = RGBStringToColor;
            /***/ },
            /***/ 87837: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts an RGB color value to HSV (hue, saturation and value).
 * Conversion formula from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes RGB values are contained in the set [0, 255] and returns h, s and v in the set [0, 1].
 * Based on code by Michael Jackson (https://github.com/mjijackson)
 *
 * @function Phaser.Display.Color.RGBToHSV
 * @since 3.0.0
 *
 * @param {number} r - The red color value. A number between 0 and 255.
 * @param {number} g - The green color value. A number between 0 and 255.
 * @param {number} b - The blue color value. A number between 0 and 255.
 * @param {(Phaser.Types.Display.HSVColorObject|Phaser.Display.Color)} [out] - An object to store the color values in. If not given an HSV Color Object will be created.
 *
 * @return {(Phaser.Types.Display.HSVColorObject|Phaser.Display.Color)} An object with the properties `h`, `s` and `v` set.
 */ var RGBToHSV = function(r, g, b, out) {
                    if (out === undefined) out = {
                        h: 0,
                        s: 0,
                        v: 0
                    };
                    r /= 255;
                    g /= 255;
                    b /= 255;
                    var min = Math.min(r, g, b);
                    var max = Math.max(r, g, b);
                    var d = max - min;
                    // achromatic by default
                    var h = 0;
                    var s = max === 0 ? 0 : d / max;
                    var v = max;
                    if (max !== min) {
                        if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
                        else if (max === g) h = (b - r) / d + 2;
                        else if (max === b) h = (r - g) / d + 4;
                        h /= 6;
                    }
                    if (out.hasOwnProperty('_h')) {
                        out._h = h;
                        out._s = s;
                        out._v = v;
                    } else {
                        out.h = h;
                        out.s = s;
                        out.v = v;
                    }
                    return out;
                };
                module1.exports = RGBToHSV;
            /***/ },
            /***/ 75723: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ComponentToHex = __webpack_require__(62957);
                /**
 * Converts the color values into an HTML compatible color string, prefixed with either `#` or `0x`.
 *
 * @function Phaser.Display.Color.RGBToString
 * @since 3.0.0
 *
 * @param {number} r - The red color value. A number between 0 and 255.
 * @param {number} g - The green color value. A number between 0 and 255.
 * @param {number} b - The blue color value. A number between 0 and 255.
 * @param {number} [a=255] - The alpha value. A number between 0 and 255.
 * @param {string} [prefix=#] - The prefix of the string. Either `#` or `0x`.
 *
 * @return {string} A string-based representation of the color values.
 */ var RGBToString = function(r, g, b, a, prefix) {
                    if (a === undefined) a = 255;
                    if (prefix === undefined) prefix = '#';
                    if (prefix === '#') return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1, 7);
                    else return '0x' + ComponentToHex(a) + ComponentToHex(r) + ComponentToHex(g) + ComponentToHex(b);
                };
                module1.exports = RGBToString;
            /***/ },
            /***/ 85386: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(30976);
                var Color = __webpack_require__(40987);
                /**
 * Creates a new Color object where the r, g, and b values have been set to random values
 * based on the given min max values.
 *
 * @function Phaser.Display.Color.RandomRGB
 * @since 3.0.0
 *
 * @param {number} [min=0] - The minimum value to set the random range from (between 0 and 255)
 * @param {number} [max=255] - The maximum value to set the random range from (between 0 and 255)
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var RandomRGB = function(min, max) {
                    if (min === undefined) min = 0;
                    if (max === undefined) max = 255;
                    return new Color(Between(min, max), Between(min, max), Between(min, max));
                };
                module1.exports = RandomRGB;
            /***/ },
            /***/ 80333: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HexStringToColor = __webpack_require__(70238);
                var IntegerToColor = __webpack_require__(30100);
                var ObjectToColor = __webpack_require__(68957);
                var RGBStringToColor = __webpack_require__(87388);
                /**
 * Converts the given source color value into an instance of a Color class.
 * The value can be either a string, prefixed with `rgb` or a hex string, a number or an Object.
 *
 * @function Phaser.Display.Color.ValueToColor
 * @since 3.0.0
 *
 * @param {(string|number|Phaser.Types.Display.InputColorObject)} input - The source color value to convert.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var ValueToColor = function(input) {
                    var t = typeof input;
                    switch(t){
                        case 'string':
                            if (input.substr(0, 3).toLowerCase() === 'rgb') return RGBStringToColor(input);
                            else return HexStringToColor(input);
                        case 'number':
                            return IntegerToColor(input);
                        case 'object':
                            return ObjectToColor(input);
                    }
                };
                module1.exports = ValueToColor;
            /***/ },
            /***/ 3956: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(40987);
                Color.ColorSpectrum = __webpack_require__(92728);
                Color.ColorToRGBA = __webpack_require__(91588);
                Color.ComponentToHex = __webpack_require__(62957);
                Color.GetColor = __webpack_require__(37589);
                Color.GetColor32 = __webpack_require__(1000);
                Color.HexStringToColor = __webpack_require__(70238);
                Color.HSLToColor = __webpack_require__(62183);
                Color.HSVColorWheel = __webpack_require__(27939);
                Color.HSVToRGB = __webpack_require__(7537);
                Color.HueToComponent = __webpack_require__(89528);
                Color.IntegerToColor = __webpack_require__(30100);
                Color.IntegerToRGB = __webpack_require__(90664);
                Color.Interpolate = __webpack_require__(13699);
                Color.ObjectToColor = __webpack_require__(68957);
                Color.RandomRGB = __webpack_require__(85386);
                Color.RGBStringToColor = __webpack_require__(87388);
                Color.RGBToHSV = __webpack_require__(87837);
                Color.RGBToString = __webpack_require__(75723);
                Color.ValueToColor = __webpack_require__(80333);
                module1.exports = Color;
            /***/ },
            /***/ 27460: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display
 */ module1.exports = {
                    Align: __webpack_require__(71926),
                    BaseShader: __webpack_require__(73894),
                    Bounds: __webpack_require__(58724),
                    Canvas: __webpack_require__(26253),
                    Color: __webpack_require__(3956),
                    ColorMatrix: __webpack_require__(89422),
                    Masks: __webpack_require__(69781),
                    RGB: __webpack_require__(51767)
                };
            /***/ },
            /***/ 6858: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * @classdesc
 * A Bitmap Mask combines the alpha (opacity) of a masked pixel with the alpha of another pixel.
 * Unlike the Geometry Mask, which is a clipping path, a Bitmap Mask behaves like an alpha mask,
 * not a clipping path. It is only available when using the WebGL Renderer.
 *
 * A Bitmap Mask can use any Game Object or Dynamic Texture to determine the alpha of each pixel of the masked Game Object(s).
 * For any given point of a masked Game Object's texture, the pixel's alpha will be multiplied by the alpha
 * of the pixel at the same position in the Bitmap Mask's Game Object. The color of the pixel from the
 * Bitmap Mask doesn't matter.
 *
 * For example, if a pure blue pixel with an alpha of 0.95 is masked with a pure red pixel with an
 * alpha of 0.5, the resulting pixel will be pure blue with an alpha of 0.475. Naturally, this means
 * that a pixel in the mask with an alpha of 0 will hide the corresponding pixel in all masked Game Objects.
 * A pixel with an alpha of 1 in the masked Game Object will receive the same alpha as the
 * corresponding pixel in the mask.
 *
 * Note: You cannot combine Bitmap Masks and Blend Modes on the same Game Object. You can, however,
 * combine Geometry Masks and Blend Modes together.
 *
 * The Bitmap Mask's location matches the location of its Game Object, not the location of the
 * masked objects. Moving or transforming the underlying Game Object will change the mask
 * (and affect the visibility of any masked objects), whereas moving or transforming a masked object
 * will not affect the mask.
 *
 * The Bitmap Mask will not render its Game Object by itself. If the Game Object is not in a
 * Scene's display list, it will only be used for the mask and its full texture will not be directly
 * visible. Adding the underlying Game Object to a Scene will not cause any problems - it will
 * render as a normal Game Object and will also serve as a mask.
 *
 * @class BitmapMask
 * @memberof Phaser.Display.Masks
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this mask is being added.
 * @param {(Phaser.GameObjects.GameObject|Phaser.Textures.DynamicTexture)} [maskObject] - The Game Object or Dynamic Texture that will be used as the mask. If `null` it will generate an Image Game Object using the rest of the arguments.
 * @param {number} [x] - If creating a Game Object, the horizontal position in the world.
 * @param {number} [y] - If creating a Game Object, the vertical position in the world.
 * @param {(string|Phaser.Textures.Texture)} [texture] - If creating a Game Object, the key, or instance of the Texture it will use to render with, as stored in the Texture Manager.
 * @param {(string|number|Phaser.Textures.Frame)} [frame] - If creating a Game Object, an optional frame from the Texture this Game Object is rendering with.
 */ var BitmapMask = new Class({
                    initialize: function BitmapMask(scene, maskObject, x, y, texture, frame) {
                        if (!maskObject) maskObject = scene.sys.make.image({
                            x: x,
                            y: y,
                            key: texture,
                            frame: frame,
                            add: false
                        });
                        /**
         * The Game Object that is used as the mask. Must use a texture, such as a Sprite.
         *
         * @name Phaser.Display.Masks.BitmapMask#bitmapMask
         * @type {(Phaser.GameObjects.GameObject|Phaser.Textures.DynamicTexture)}
         * @since 3.0.0
         */ this.bitmapMask = maskObject;
                        /**
         * Whether to invert the masks alpha.
         *
         * If `true`, the alpha of the masking pixel will be inverted before it's multiplied with the masked pixel.
         *
         * Essentially, this means that a masked area will be visible only if the corresponding area in the mask is invisible.
         *
         * @name Phaser.Display.Masks.BitmapMask#invertAlpha
         * @type {boolean}
         * @since 3.1.2
         */ this.invertAlpha = false;
                        /**
         * Is this mask a stencil mask? This is false by default and should not be changed.
         *
         * @name Phaser.Display.Masks.BitmapMask#isStencil
         * @type {boolean}
         * @readonly
         * @since 3.17.0
         */ this.isStencil = false;
                    },
                    /**
     * Sets a new Game Object or Dynamic Texture for this Bitmap Mask to use.
     *
     * If a Game Object it must have a texture, such as a Sprite.
     *
     * You can update the source of the mask as often as you like.
     *
     * @method Phaser.Display.Masks.BitmapMask#setBitmap
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Textures.DynamicTexture)} maskObject - The Game Object or Dynamic Texture that will be used as the mask. If a Game Object, it must have a texture, such as a Sprite.
     */ setBitmap: function(maskObject) {
                        this.bitmapMask = maskObject;
                    },
                    /**
     * Prepares the WebGL Renderer to render a Game Object with this mask applied.
     *
     * This renders the masking Game Object to the mask framebuffer and switches to the main framebuffer so that the masked Game Object will be rendered to it instead of being rendered directly to the frame.
     *
     * @method Phaser.Display.Masks.BitmapMask#preRenderWebGL
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The WebGL Renderer to prepare.
     * @param {Phaser.GameObjects.GameObject} maskedObject - The masked Game Object which will be drawn.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     */ preRenderWebGL: function(renderer, maskedObject, camera) {
                        renderer.pipelines.BITMAPMASK_PIPELINE.beginMask(this, maskedObject, camera);
                    },
                    /**
     * Finalizes rendering of a masked Game Object.
     *
     * This resets the previously bound framebuffer and switches the WebGL Renderer to the Bitmap Mask Pipeline, which uses a special fragment shader to apply the masking effect.
     *
     * @method Phaser.Display.Masks.BitmapMask#postRenderWebGL
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The WebGL Renderer to clean up.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [renderTarget] - Optional WebGL RenderTarget.
     */ postRenderWebGL: function(renderer, camera, renderTarget) {
                        renderer.pipelines.BITMAPMASK_PIPELINE.endMask(this, camera, renderTarget);
                    },
                    /**
     * This is a NOOP method. Bitmap Masks are not supported by the Canvas Renderer.
     *
     * @method Phaser.Display.Masks.BitmapMask#preRenderCanvas
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Canvas Renderer which would be rendered to.
     * @param {Phaser.GameObjects.GameObject} mask - The masked Game Object which would be rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     */ preRenderCanvas: function() {
                    // NOOP
                    },
                    /**
     * This is a NOOP method. Bitmap Masks are not supported by the Canvas Renderer.
     *
     * @method Phaser.Display.Masks.BitmapMask#postRenderCanvas
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Canvas Renderer which would be rendered to.
     */ postRenderCanvas: function() {
                    // NOOP
                    },
                    /**
     * Destroys this BitmapMask and nulls any references it holds.
     *
     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
     *
     * @method Phaser.Display.Masks.BitmapMask#destroy
     * @since 3.7.0
     */ destroy: function() {
                        this.bitmapMask = null;
                    }
                });
                /**
 * A Bitmap Mask combines the alpha (opacity) of a masked pixel with the alpha of another pixel.
 * Unlike the Geometry Mask, which is a clipping path, a Bitmap Mask behaves like an alpha mask,
 * not a clipping path. It is only available when using the WebGL Renderer.
 *
 * A Bitmap Mask can use any Game Object, or Dynamic Texture, to determine the alpha of each pixel of the masked Game Object(s).
 * For any given point of a masked Game Object's texture, the pixel's alpha will be multiplied by the alpha
 * of the pixel at the same position in the Bitmap Mask's Game Object. The color of the pixel from the
 * Bitmap Mask doesn't matter.
 *
 * For example, if a pure blue pixel with an alpha of 0.95 is masked with a pure red pixel with an
 * alpha of 0.5, the resulting pixel will be pure blue with an alpha of 0.475. Naturally, this means
 * that a pixel in the mask with an alpha of 0 will hide the corresponding pixel in all masked Game Objects
 *  A pixel with an alpha of 1 in the masked Game Object will receive the same alpha as the
 * corresponding pixel in the mask.
 *
 * Note: You cannot combine Bitmap Masks and Blend Modes on the same Game Object. You can, however,
 * combine Geometry Masks and Blend Modes together.
 *
 * The Bitmap Mask's location matches the location of its Game Object, not the location of the
 * masked objects. Moving or transforming the underlying Game Object will change the mask
 * (and affect the visibility of any masked objects), whereas moving or transforming a masked object
 * will not affect the mask.
 *
 * The Bitmap Mask will not render its Game Object by itself. If the Game Object is not in a
 * Scene's display list, it will only be used for the mask and its full texture will not be directly
 * visible. Adding the underlying Game Object to a Scene will not cause any problems - it will
 * render as a normal Game Object and will also serve as a mask.
 *
 * @method Phaser.GameObjects.GameObjectFactory#bitmapMask
 * @since 3.60.0
 *
 * @param {(Phaser.GameObjects.GameObject|Phaser.Textures.DynamicTexture)} [maskObject] - The Game Object or Texture that will be used as the mask. If `null` it will generate an Image Game Object using the rest of the arguments.
 * @param {number} [x] - If creating a Game Object, the horizontal position in the world.
 * @param {number} [y] - If creating a Game Object, the vertical position in the world.
 * @param {(string|Phaser.Textures.Texture)} [texture] - If creating a Game Object, the key, or instance of the Texture it will use to render with, as stored in the Texture Manager.
 * @param {(string|number|Phaser.Textures.Frame)} [frame] - If creating a Game Object, an optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.Display.Masks.BitmapMask} The Bitmap Mask that was created.
 */ GameObjectFactory.register('bitmapMask', function(maskObject, x, y, key, frame) {
                    return new BitmapMask(this.scene, maskObject, x, y, key, frame);
                });
                module1.exports = BitmapMask;
            /***/ },
            /***/ 80661: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A Geometry Mask can be applied to a Game Object to hide any pixels of it which don't intersect
 * a visible pixel from the geometry mask. The mask is essentially a clipping path which can only
 * make a masked pixel fully visible or fully invisible without changing its alpha (opacity).
 *
 * A Geometry Mask uses a Graphics Game Object to determine which pixels of the masked Game Object(s)
 * should be clipped. For any given point of a masked Game Object's texture, the pixel will only be displayed
 * if the Graphics Game Object of the Geometry Mask has a visible pixel at the same position. The color and
 * alpha of the pixel from the Geometry Mask do not matter.
 *
 * The Geometry Mask's location matches the location of its Graphics object, not the location of the masked objects.
 * Moving or transforming the underlying Graphics object will change the mask (and affect the visibility
 * of any masked objects), whereas moving or transforming a masked object will not affect the mask.
 * You can think of the Geometry Mask (or rather, of its Graphics object) as an invisible curtain placed
 * in front of all masked objects which has its own visual properties and, naturally, respects the camera's
 * visual properties, but isn't affected by and doesn't follow the masked objects by itself.
 *
 * @class GeometryMask
 * @memberof Phaser.Display.Masks
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - This parameter is not used.
 * @param {Phaser.GameObjects.Graphics} graphicsGeometry - The Graphics Game Object to use for the Geometry Mask. Doesn't have to be in the Display List.
 */ var GeometryMask = new Class({
                    initialize: function GeometryMask(scene, graphicsGeometry) {
                        /**
         * The Graphics object which describes the Geometry Mask.
         *
         * @name Phaser.Display.Masks.GeometryMask#geometryMask
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.geometryMask = graphicsGeometry;
                        /**
         * Similar to the BitmapMasks invertAlpha setting this to true will then hide all pixels
         * drawn to the Geometry Mask.
         *
         * This is a WebGL only feature.
         *
         * @name Phaser.Display.Masks.GeometryMask#invertAlpha
         * @type {boolean}
         * @since 3.16.0
         */ this.invertAlpha = false;
                        /**
         * Is this mask a stencil mask?
         *
         * @name Phaser.Display.Masks.GeometryMask#isStencil
         * @type {boolean}
         * @readonly
         * @since 3.17.0
         */ this.isStencil = true;
                        /**
         * The current stencil level. This can change dynamically at runtime
         * and is set in the applyStencil method.
         *
         * @name Phaser.Display.Masks.GeometryMask#level
         * @type {boolean}
         * @since 3.17.0
         */ this.level = 0;
                    },
                    /**
     * Sets a new Graphics object for the Geometry Mask.
     *
     * @method Phaser.Display.Masks.GeometryMask#setShape
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphicsGeometry - The Graphics object which will be used for the Geometry Mask.
     *
     * @return {this} This Geometry Mask
     */ setShape: function(graphicsGeometry) {
                        this.geometryMask = graphicsGeometry;
                        return this;
                    },
                    /**
     * Sets the `invertAlpha` property of this Geometry Mask.
     *
     * Inverting the alpha essentially flips the way the mask works.
     *
     * This is a WebGL only feature.
     *
     * @method Phaser.Display.Masks.GeometryMask#setInvertAlpha
     * @since 3.17.0
     *
     * @param {boolean} [value=true] - Invert the alpha of this mask?
     *
     * @return {this} This Geometry Mask
     */ setInvertAlpha: function(value) {
                        if (value === undefined) value = true;
                        this.invertAlpha = value;
                        return this;
                    },
                    /**
     * Renders the Geometry Mask's underlying Graphics object to the OpenGL stencil buffer and enables the stencil test, which clips rendered pixels according to the mask.
     *
     * @method Phaser.Display.Masks.GeometryMask#preRenderWebGL
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw to.
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     */ preRenderWebGL: function(renderer, child, camera) {
                        var gl = renderer.gl;
                        //  Force flushing before drawing to stencil buffer
                        renderer.flush();
                        if (renderer.maskStack.length === 0) {
                            gl.enable(gl.STENCIL_TEST);
                            gl.clear(gl.STENCIL_BUFFER_BIT);
                            renderer.maskCount = 0;
                        }
                        if (renderer.currentCameraMask.mask !== this) renderer.currentMask.mask = this;
                        renderer.maskStack.push({
                            mask: this,
                            camera: camera
                        });
                        this.applyStencil(renderer, camera, true);
                        renderer.maskCount++;
                    },
                    /**
     * Applies the current stencil mask to the renderer.
     *
     * @method Phaser.Display.Masks.GeometryMask#applyStencil
     * @since 3.17.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw to.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     * @param {boolean} inc - Is this an INCR stencil or a DECR stencil?
     */ applyStencil: function(renderer, camera, inc) {
                        var gl = renderer.gl;
                        var geometryMask = this.geometryMask;
                        var level = renderer.maskCount;
                        var mask = 0xff;
                        gl.colorMask(false, false, false, false);
                        if (inc) {
                            gl.stencilFunc(gl.EQUAL, level, mask);
                            gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
                            //  Do this _after_ we set the stencilFunc
                            level++;
                        } else {
                            gl.stencilFunc(gl.EQUAL, level + 1, mask);
                            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
                        }
                        this.level = level;
                        //  Write stencil buffer
                        geometryMask.renderWebGL(renderer, geometryMask, camera);
                        renderer.flush();
                        gl.colorMask(true, true, true, true);
                        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
                        if (this.invertAlpha) gl.stencilFunc(gl.NOTEQUAL, level, mask);
                        else gl.stencilFunc(gl.EQUAL, level, mask);
                    },
                    /**
     * Flushes all rendered pixels and disables the stencil test of a WebGL context, thus disabling the mask for it.
     *
     * @method Phaser.Display.Masks.GeometryMask#postRenderWebGL
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw flush.
     */ postRenderWebGL: function(renderer) {
                        var gl = renderer.gl;
                        renderer.maskStack.pop();
                        renderer.maskCount--;
                        //  Force flush before disabling stencil test
                        renderer.flush();
                        var current = renderer.currentMask;
                        if (renderer.maskStack.length === 0) {
                            //  If this is the only mask in the stack, flush and disable
                            current.mask = null;
                            gl.disable(gl.STENCIL_TEST);
                        } else {
                            var prev = renderer.maskStack[renderer.maskStack.length - 1];
                            prev.mask.applyStencil(renderer, prev.camera, false);
                            if (renderer.currentCameraMask.mask !== prev.mask) {
                                current.mask = prev.mask;
                                current.camera = prev.camera;
                            } else current.mask = null;
                        }
                    },
                    /**
     * Sets the clipping path of a 2D canvas context to the Geometry Mask's underlying Graphics object.
     *
     * @method Phaser.Display.Masks.GeometryMask#preRenderCanvas
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - The Canvas Renderer instance to set the clipping path on.
     * @param {Phaser.GameObjects.GameObject} mask - The Game Object being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     */ preRenderCanvas: function(renderer, mask, camera) {
                        var geometryMask = this.geometryMask;
                        renderer.currentContext.save();
                        geometryMask.renderCanvas(renderer, geometryMask, camera, null, null, true);
                        renderer.currentContext.clip();
                    },
                    /**
     * Restore the canvas context's previous clipping path, thus turning off the mask for it.
     *
     * @method Phaser.Display.Masks.GeometryMask#postRenderCanvas
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - The Canvas Renderer instance being restored.
     */ postRenderCanvas: function(renderer) {
                        renderer.currentContext.restore();
                    },
                    /**
     * Destroys this GeometryMask and nulls any references it holds.
     *
     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
     *
     * @method Phaser.Display.Masks.GeometryMask#destroy
     * @since 3.7.0
     */ destroy: function() {
                        this.geometryMask = null;
                    }
                });
                module1.exports = GeometryMask;
            /***/ },
            /***/ 69781: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Masks
 */ module1.exports = {
                    BitmapMask: __webpack_require__(6858),
                    GeometryMask: __webpack_require__(80661)
                };
            /***/ },
            /***/ 73894: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A BaseShader is a small resource class that contains the data required for a WebGL Shader to be created.
 *
 * It contains the raw source code to the fragment and vertex shader, as well as an object that defines
 * the uniforms the shader requires, if any.
 *
 * BaseShaders are stored in the Shader Cache, available in a Scene via `this.cache.shaders` and are referenced
 * by a unique key-based string. Retrieve them via `this.cache.shaders.get(key)`.
 *
 * BaseShaders are created automatically by the GLSL File Loader when loading an external shader resource.
 * They can also be created at runtime, allowing you to use dynamically generated shader source code.
 *
 * Default fragment and vertex source is used if not provided in the constructor, setting-up a basic shader,
 * suitable for debug rendering.
 *
 * @class BaseShader
 * @memberof Phaser.Display
 * @constructor
 * @since 3.17.0
 *
 * @param {string} key - The key of this shader. Must be unique within the shader cache.
 * @param {string} [fragmentSrc] - The fragment source for the shader.
 * @param {string} [vertexSrc] - The vertex source for the shader.
 * @param {any} [uniforms] - Optional object defining the uniforms the shader uses.
 */ var BaseShader = new Class({
                    initialize: function BaseShader(key, fragmentSrc, vertexSrc, uniforms) {
                        if (!fragmentSrc || fragmentSrc === '') fragmentSrc = [
                            'precision mediump float;',
                            'uniform vec2 resolution;',
                            'varying vec2 fragCoord;',
                            'void main () {',
                            '    vec2 uv = fragCoord / resolution.xy;',
                            '    gl_FragColor = vec4(uv.xyx, 1.0);',
                            '}'
                        ].join('\n');
                        if (!vertexSrc || vertexSrc === '') vertexSrc = [
                            'precision mediump float;',
                            'uniform mat4 uProjectionMatrix;',
                            'uniform mat4 uViewMatrix;',
                            'uniform vec2 uResolution;',
                            'attribute vec2 inPosition;',
                            'varying vec2 fragCoord;',
                            'varying vec2 outTexCoord;',
                            'void main () {',
                            '   gl_Position = uProjectionMatrix * uViewMatrix * vec4(inPosition, 1.0, 1.0);',
                            '   fragCoord = vec2(inPosition.x, uResolution.y - inPosition.y);',
                            '   outTexCoord = vec2(inPosition.x / uResolution.x, fragCoord.y / uResolution.y);',
                            '}'
                        ].join('\n');
                        if (uniforms === undefined) uniforms = null;
                        /**
         * The key of this shader, unique within the shader cache of this Phaser game instance.
         *
         * @name Phaser.Display.BaseShader#key
         * @type {string}
         * @since 3.17.0
         */ this.key = key;
                        /**
         * The source code, as a string, of the fragment shader being used.
         *
         * @name Phaser.Display.BaseShader#fragmentSrc
         * @type {string}
         * @since 3.17.0
         */ this.fragmentSrc = fragmentSrc;
                        /**
         * The source code, as a string, of the vertex shader being used.
         *
         * @name Phaser.Display.BaseShader#vertexSrc
         * @type {string}
         * @since 3.17.0
         */ this.vertexSrc = vertexSrc;
                        /**
         * The default uniforms for this shader.
         *
         * @name Phaser.Display.BaseShader#uniforms
         * @type {?any}
         * @since 3.17.0
         */ this.uniforms = uniforms;
                    }
                });
                module1.exports = BaseShader;
            /***/ },
            /***/ 40366: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given element to the DOM. If a parent is provided the element is added as a child of the parent, providing it was able to access it.
 * If no parent was given it falls back to using `document.body`.
 *
 * @function Phaser.DOM.AddToDOM
 * @since 3.0.0
 *
 * @param {HTMLElement} element - The element to be added to the DOM. Usually a Canvas object.
 * @param {(string|HTMLElement)} [parent] - The parent in which to add the element. Can be a string which is passed to `getElementById` or an actual DOM object.
 *
 * @return {HTMLElement} The element that was added to the DOM.
 */ var AddToDOM = function(element, parent) {
                    var target;
                    if (parent) {
                        if (typeof parent === 'string') //  Hopefully an element ID
                        target = document.getElementById(parent);
                        else if (typeof parent === 'object' && parent.nodeType === 1) //  Quick test for a HTMLElement
                        target = parent;
                    } else if (element.parentElement || parent === null) return element;
                    //  Fallback, covers an invalid ID and a non HTMLElement object
                    if (!target) target = document.body;
                    target.appendChild(element);
                    return element;
                };
                module1.exports = AddToDOM;
            /***/ },
            /***/ 83719: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(40366);
                var CreateDOMContainer = function(game) {
                    var config = game.config;
                    if (!config.parent || !config.domCreateContainer) return;
                    //  DOM Element Container
                    var div = document.createElement('div');
                    div.style.cssText = [
                        'display: block;',
                        'width: ' + game.scale.width + 'px;',
                        'height: ' + game.scale.height + 'px;',
                        'padding: 0; margin: 0;',
                        'position: absolute;',
                        'overflow: hidden;',
                        'pointer-events: ' + config.domPointerEvents + ';',
                        'transform: scale(1);',
                        'transform-origin: left top;'
                    ].join(' ');
                    game.domContainer = div;
                    AddToDOM(div, config.parent);
                };
                module1.exports = CreateDOMContainer;
            /***/ },
            /***/ 57264: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(25892);
                /**
 * @callback ContentLoadedCallback
 */ /**
 * Inspects the readyState of the document. If the document is already complete then it invokes the given callback.
 * If not complete it sets up several event listeners such as `deviceready`, and once those fire, it invokes the callback.
 * Called automatically by the Phaser.Game instance. Should not usually be accessed directly.
 *
 * @function Phaser.DOM.DOMContentLoaded
 * @since 3.0.0
 *
 * @param {ContentLoadedCallback} callback - The callback to be invoked when the device is ready and the DOM content is loaded.
 */ var DOMContentLoaded = function(callback) {
                    if (document.readyState === 'complete' || document.readyState === 'interactive') {
                        callback();
                        return;
                    }
                    var check = function() {
                        document.removeEventListener('deviceready', check, true);
                        document.removeEventListener('DOMContentLoaded', check, true);
                        window.removeEventListener('load', check, true);
                        callback();
                    };
                    if (!document.body) window.setTimeout(check, 20);
                    else if (OS.cordova) //  Ref. http://docs.phonegap.com/en/3.5.0/cordova_events_events.md.html#deviceready
                    document.addEventListener('deviceready', check, false);
                    else {
                        document.addEventListener('DOMContentLoaded', check, true);
                        window.addEventListener('load', check, true);
                    }
                };
                module1.exports = DOMContentLoaded;
            /***/ },
            /***/ 57811: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to determine the document inner height across iOS and standard devices.
 * Based on code by @tylerjpeterson
 *
 * @function Phaser.DOM.GetInnerHeight
 * @since 3.16.0
 *
 * @param {boolean} iOS - Is this running on iOS?
 *
 * @return {number} The inner height value.
 */ var GetInnerHeight = function(iOS) {
                    if (!iOS) return window.innerHeight;
                    var axis = Math.abs(window.orientation);
                    var size = {
                        w: 0,
                        h: 0
                    };
                    var ruler = document.createElement('div');
                    ruler.setAttribute('style', 'position: fixed; height: 100vh; width: 0; top: 0');
                    document.documentElement.appendChild(ruler);
                    size.w = axis === 90 ? ruler.offsetHeight : window.innerWidth;
                    size.h = axis === 90 ? window.innerWidth : ruler.offsetHeight;
                    document.documentElement.removeChild(ruler);
                    ruler = null;
                    if (Math.abs(window.orientation) !== 90) return size.h;
                    else return size.w;
                };
                module1.exports = GetInnerHeight;
            /***/ },
            /***/ 45818: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(13560);
                /**
 * Attempts to determine the screen orientation using the Orientation API.
 *
 * @function Phaser.DOM.GetScreenOrientation
 * @since 3.16.0
 *
 * @param {number} width - The width of the viewport.
 * @param {number} height - The height of the viewport.
 *
 * @return {string} The orientation.
 */ var GetScreenOrientation = function(width, height) {
                    var screen1 = window.screen;
                    var orientation = screen1 ? screen1.orientation || screen1.mozOrientation || screen1.msOrientation : false;
                    if (orientation && typeof orientation.type === 'string') //  Screen Orientation API specification
                    return orientation.type;
                    else if (typeof orientation === 'string') //  moz / ms-orientation are strings
                    return orientation;
                    if (typeof window.orientation === 'number') //  Do this check first, as iOS supports this, but also has an incomplete window.screen implementation
                    //  This may change by device based on "natural" orientation.
                    return window.orientation === 0 || window.orientation === 180 ? CONST.ORIENTATION.PORTRAIT : CONST.ORIENTATION.LANDSCAPE;
                    else if (window.matchMedia) {
                        if (window.matchMedia('(orientation: portrait)').matches) return CONST.ORIENTATION.PORTRAIT;
                        else if (window.matchMedia('(orientation: landscape)').matches) return CONST.ORIENTATION.LANDSCAPE;
                    } else return height > width ? CONST.ORIENTATION.PORTRAIT : CONST.ORIENTATION.LANDSCAPE;
                };
                module1.exports = GetScreenOrientation;
            /***/ },
            /***/ 74403: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to get the target DOM element based on the given value, which can be either
 * a string, in which case it will be looked-up by ID, or an element node. If nothing
 * can be found it will return a reference to the document.body.
 *
 * @function Phaser.DOM.GetTarget
 * @since 3.16.0
 *
 * @param {HTMLElement} element - The DOM element to look-up.
 */ var GetTarget = function(element) {
                    var target;
                    if (element !== '') {
                        if (typeof element === 'string') //  Hopefully an element ID
                        target = document.getElementById(element);
                        else if (element && element.nodeType === 1) //  Quick test for a HTMLElement
                        target = element;
                    }
                    //  Fallback to the document body. Covers an invalid ID and a non HTMLElement object.
                    if (!target) //  Use the full window
                    target = document.body;
                    return target;
                };
                module1.exports = GetTarget;
            /***/ },
            /***/ 56836: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given data string and parses it as XML.
 * First tries to use the window.DOMParser and reverts to the Microsoft.XMLDOM if that fails.
 * The parsed XML object is returned, or `null` if there was an error while parsing the data.
 *
 * @function Phaser.DOM.ParseXML
 * @since 3.0.0
 *
 * @param {string} data - The XML source stored in a string.
 *
 * @return {?(DOMParser|ActiveXObject)} The parsed XML data, or `null` if the data could not be parsed.
 */ var ParseXML = function(data) {
                    var xml = '';
                    try {
                        if (window['DOMParser']) {
                            var domparser = new DOMParser();
                            xml = domparser.parseFromString(data, 'text/xml');
                        } else {
                            xml = new ActiveXObject('Microsoft.XMLDOM');
                            xml.loadXML(data);
                        }
                    } catch (e) {
                        xml = null;
                    }
                    if (!xml || !xml.documentElement || xml.getElementsByTagName('parsererror').length) return null;
                    else return xml;
                };
                module1.exports = ParseXML;
            /***/ },
            /***/ 35846: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to remove the element from its parentNode in the DOM.
 *
 * @function Phaser.DOM.RemoveFromDOM
 * @since 3.0.0
 *
 * @param {HTMLElement} element - The DOM element to remove from its parent node.
 */ var RemoveFromDOM = function(element) {
                    if (element.parentNode) element.parentNode.removeChild(element);
                };
                module1.exports = RemoveFromDOM;
            /***/ },
            /***/ 43092: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var NOOP = __webpack_require__(29747);
                /**
 * @classdesc
 * Abstracts away the use of RAF or setTimeOut for the core game update loop.
 *
 * This is invoked automatically by the Phaser.Game instance.
 *
 * @class RequestAnimationFrame
 * @memberof Phaser.DOM
 * @constructor
 * @since 3.0.0
 */ var RequestAnimationFrame = new Class({
                    initialize: function RequestAnimationFrame() {
                        /**
         * True if RequestAnimationFrame is running, otherwise false.
         *
         * @name Phaser.DOM.RequestAnimationFrame#isRunning
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isRunning = false;
                        /**
         * The callback to be invoked each step.
         *
         * @name Phaser.DOM.RequestAnimationFrame#callback
         * @type {FrameRequestCallback}
         * @since 3.0.0
         */ this.callback = NOOP;
                        /**
         * True if the step is using setTimeout instead of RAF.
         *
         * @name Phaser.DOM.RequestAnimationFrame#isSetTimeOut
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isSetTimeOut = false;
                        /**
         * The setTimeout or RAF callback ID used when canceling them.
         *
         * @name Phaser.DOM.RequestAnimationFrame#timeOutID
         * @type {?number}
         * @default null
         * @since 3.0.0
         */ this.timeOutID = null;
                        /**
         * The delay rate in ms for setTimeOut.
         *
         * @name Phaser.DOM.RequestAnimationFrame#delay
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.delay = 0;
                        var _this = this;
                        /**
         * The RAF step function.
         *
         * Invokes the callback and schedules another call to requestAnimationFrame.
         *
         * @name Phaser.DOM.RequestAnimationFrame#step
         * @type {FrameRequestCallback}
         * @since 3.0.0
         *
         * @param {number} time - The timestamp passed in from RequestAnimationFrame.
         */ this.step = function step(time) {
                            _this.callback(time);
                            if (_this.isRunning) _this.timeOutID = window.requestAnimationFrame(step);
                        };
                        /**
         * The SetTimeout step function.
         *
         * Invokes the callback and schedules another call to setTimeout.
         *
         * @name Phaser.DOM.RequestAnimationFrame#stepTimeout
         * @type {function}
         * @since 3.0.0
         */ this.stepTimeout = function stepTimeout() {
                            if (_this.isRunning) //  Make the next request before the callback, so that timing is maintained
                            _this.timeOutID = window.setTimeout(stepTimeout, _this.delay);
                            _this.callback(window.performance.now());
                        };
                    },
                    /**
     * Starts the requestAnimationFrame or setTimeout process running.
     *
     * @method Phaser.DOM.RequestAnimationFrame#start
     * @since 3.0.0
     *
     * @param {FrameRequestCallback} callback - The callback to invoke each step.
     * @param {boolean} forceSetTimeOut - Should it use SetTimeout, even if RAF is available?
     * @param {number} delay - The setTimeout delay rate in ms.
     */ start: function(callback, forceSetTimeOut, delay) {
                        if (this.isRunning) return;
                        this.callback = callback;
                        this.isSetTimeOut = forceSetTimeOut;
                        this.delay = delay;
                        this.isRunning = true;
                        this.timeOutID = forceSetTimeOut ? window.setTimeout(this.stepTimeout, 0) : window.requestAnimationFrame(this.step);
                    },
                    /**
     * Stops the requestAnimationFrame or setTimeout from running.
     *
     * @method Phaser.DOM.RequestAnimationFrame#stop
     * @since 3.0.0
     */ stop: function() {
                        this.isRunning = false;
                        if (this.isSetTimeOut) clearTimeout(this.timeOutID);
                        else window.cancelAnimationFrame(this.timeOutID);
                    },
                    /**
     * Stops the step from running and clears the callback reference.
     *
     * @method Phaser.DOM.RequestAnimationFrame#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.stop();
                        this.callback = NOOP;
                    }
                });
                module1.exports = RequestAnimationFrame;
            /***/ },
            /***/ 84902: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.DOM
 */ var Dom = {
                    AddToDOM: __webpack_require__(40366),
                    DOMContentLoaded: __webpack_require__(57264),
                    GetInnerHeight: __webpack_require__(57811),
                    GetScreenOrientation: __webpack_require__(45818),
                    GetTarget: __webpack_require__(74403),
                    ParseXML: __webpack_require__(56836),
                    RemoveFromDOM: __webpack_require__(35846),
                    RequestAnimationFrame: __webpack_require__(43092)
                };
                module1.exports = Dom;
            /***/ },
            /***/ 47565: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EE = __webpack_require__(50792);
                var PluginCache = __webpack_require__(37277);
                /**
 * @classdesc
 * EventEmitter is a Scene Systems plugin compatible version of eventemitter3.
 *
 * @class EventEmitter
 * @memberof Phaser.Events
 * @constructor
 * @since 3.0.0
 */ var EventEmitter = new Class({
                    Extends: EE,
                    initialize: function EventEmitter() {
                        EE.call(this);
                    },
                    /**
     * Removes all listeners.
     *
     * @method Phaser.Events.EventEmitter#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        this.removeAllListeners();
                    },
                    /**
     * Removes all listeners.
     *
     * @method Phaser.Events.EventEmitter#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.removeAllListeners();
                    }
                });
                /**
 * Return an array listing the events for which the emitter has registered listeners.
 *
 * @method Phaser.Events.EventEmitter#eventNames
 * @since 3.0.0
 *
 * @return {Array.<string|symbol>}
 */ /**
 * Return the listeners registered for a given event.
 *
 * @method Phaser.Events.EventEmitter#listeners
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 *
 * @return {Function[]} The registered listeners.
 */ /**
 * Return the number of listeners listening to a given event.
 *
 * @method Phaser.Events.EventEmitter#listenerCount
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 *
 * @return {number} The number of listeners.
 */ /**
 * Calls each of the listeners registered for a given event.
 *
 * @method Phaser.Events.EventEmitter#emit
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {...*} [args] - Additional arguments that will be passed to the event handler.
 *
 * @return {boolean} `true` if the event had listeners, else `false`.
 */ /**
 * Add a listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#on
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Add a listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#addListener
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Add a one-time listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#once
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Remove the listeners of a given event.
 *
 * @method Phaser.Events.EventEmitter#removeListener
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} [fn] - Only remove the listeners that match this function.
 * @param {*} [context] - Only remove the listeners that have this context.
 * @param {boolean} [once] - Only remove one-time listeners.
 *
 * @return {this} `this`.
 */ /**
 * Remove the listeners of a given event.
 *
 * @method Phaser.Events.EventEmitter#off
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} [fn] - Only remove the listeners that match this function.
 * @param {*} [context] - Only remove the listeners that have this context.
 * @param {boolean} [once] - Only remove one-time listeners.
 *
 * @return {this} `this`.
 */ /**
 * Remove all listeners, or those of the specified event.
 *
 * @method Phaser.Events.EventEmitter#removeAllListeners
 * @since 3.0.0
 *
 * @param {(string|symbol)} [event] - The event name.
 *
 * @return {this} `this`.
 */ PluginCache.register('EventEmitter', EventEmitter, 'events');
                module1.exports = EventEmitter;
            /***/ },
            /***/ 93055: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Events
 */ module1.exports = {
                    EventEmitter: __webpack_require__(47565)
                };
            /***/ },
            /***/ 20122: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Barrel FX Controller.
 *
 * This FX controller manages the barrel distortion effect for a Game Object.
 *
 * A barrel effect allows you to apply either a 'pinch' or 'expand' distortion to
 * a Game Object. The amount of the effect can be modified in real-time.
 *
 * A Barrel effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addBarrel();
 * sprite.postFX.addBarrel();
 * ```
 *
 * @class Barrel
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [amount=1] - The amount of distortion applied to the barrel effect. A value of 1 is no distortion. Typically keep this within +- 1.
 */ var Barrel = new Class({
                    Extends: Controller,
                    initialize: function Barrel(gameObject, amount) {
                        if (amount === undefined) amount = 1;
                        Controller.call(this, FX_CONST.BARREL, gameObject);
                        /**
         * The amount of distortion applied to the barrel effect.
         *
         * Typically keep this within the range 1 (no distortion) to +- 1.
         *
         * @name Phaser.FX.Barrel#amount
         * @type {number}
         * @since 3.60.0
         */ this.amount = amount;
                    }
                });
                module1.exports = Barrel;
            /***/ },
            /***/ 32251: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Bloom FX Controller.
 *
 * This FX controller manages the bloom effect for a Game Object.
 *
 * Bloom is an effect used to reproduce an imaging artifact of real-world cameras.
 * The effect produces fringes of light extending from the borders of bright areas in an image,
 * contributing to the illusion of an extremely bright light overwhelming the
 * camera or eye capturing the scene.
 *
 * A Bloom effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addBloom();
 * sprite.postFX.addBloom();
 * ```
 *
 * @class Bloom
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [color=0xffffff] - The color of the Bloom, as a hex value.
 * @param {number} [offsetX=1] - The horizontal offset of the bloom effect.
 * @param {number} [offsetY=1] - The vertical offset of the bloom effect.
 * @param {number} [blurStrength=1] - The strength of the blur process of the bloom effect.
 * @param {number} [strength=1] - The strength of the blend process of the bloom effect.
 * @param {number} [steps=4] - The number of steps to run the Bloom effect for. This value should always be an integer.
 */ var Bloom = new Class({
                    Extends: Controller,
                    initialize: function Bloom(gameObject, color, offsetX, offsetY, blurStrength, strength, steps) {
                        if (offsetX === undefined) offsetX = 1;
                        if (offsetY === undefined) offsetY = 1;
                        if (blurStrength === undefined) blurStrength = 1;
                        if (strength === undefined) strength = 1;
                        if (steps === undefined) steps = 4;
                        Controller.call(this, FX_CONST.BLOOM, gameObject);
                        /**
         * The number of steps to run the Bloom effect for.
         *
         * This value should always be an integer.
         *
         * It defaults to 4. The higher the value, the smoother the Bloom,
         * but at the cost of exponentially more gl operations.
         *
         * Keep this to the lowest possible number you can have it, while
         * still looking correct for your game.
         *
         * @name Phaser.FX.Bloom#steps
         * @type {number}
         * @since 3.60.0
         */ this.steps = steps;
                        /**
         * The horizontal offset of the bloom effect.
         *
         * @name Phaser.FX.Bloom#offsetX
         * @type {number}
         * @since 3.60.0
         */ this.offsetX = offsetX;
                        /**
         * The vertical offset of the bloom effect.
         *
         * @name Phaser.FX.Bloom#offsetY
         * @type {number}
         * @since 3.60.0
         */ this.offsetY = offsetY;
                        /**
         * The strength of the blur process of the bloom effect.
         *
         * @name Phaser.FX.Bloom#blurStrength
         * @type {number}
         * @since 3.60.0
         */ this.blurStrength = blurStrength;
                        /**
         * The strength of the blend process of the bloom effect.
         *
         * @name Phaser.FX.Bloom#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = strength;
                        /**
         * The internal gl color array.
         *
         * @name Phaser.FX.Bloom#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            1,
                            1
                        ];
                        if (color !== undefined && color !== null) this.color = color;
                    },
                    /**
     * The color of the bloom as a number value.
     *
     * @name Phaser.FX.Bloom#color
     * @type {number}
     * @since 3.60.0
     */ color: {
                        get: function() {
                            var color = this.glcolor;
                            return (color[0] * 255 << 16) + (color[1] * 255 << 8) + (color[2] * 255 | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor;
                            color[0] = (value >> 16 & 0xFF) / 255;
                            color[1] = (value >> 8 & 0xFF) / 255;
                            color[2] = (value & 0xFF) / 255;
                        }
                    }
                });
                module1.exports = Bloom;
            /***/ },
            /***/ 9047: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Blur FX Controller.
 *
 * This FX controller manages the blur effect for a Game Object.
 *
 * A Gaussian blur is the result of blurring an image by a Gaussian function. It is a widely used effect,
 * typically to reduce image noise and reduce detail. The visual effect of this blurring technique is a
 * smooth blur resembling that of viewing the image through a translucent screen, distinctly different
 * from the bokeh effect produced by an out-of-focus lens or the shadow of an object under usual illumination.
 *
 * A Blur effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addBlur();
 * sprite.postFX.addBlur();
 * ```
 *
 * @class Blur
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [quality=0] - The quality of the blur effect. Can be either 0 for Low Quality, 1 for Medium Quality or 2 for High Quality.
 * @param {number} [x=2] - The horizontal offset of the blur effect.
 * @param {number} [y=2] - The vertical offset of the blur effect.
 * @param {number} [strength=1] - The strength of the blur effect.
 * @param {number} [color=0xffffff] - The color of the blur, as a hex value.
 * @param {number} [steps=4] - The number of steps to run the blur effect for. This value should always be an integer.
 */ var Blur = new Class({
                    Extends: Controller,
                    initialize: function Blur(gameObject, quality, x, y, strength, color, steps) {
                        if (quality === undefined) quality = 0;
                        if (x === undefined) x = 2;
                        if (y === undefined) y = 2;
                        if (strength === undefined) strength = 1;
                        if (steps === undefined) steps = 4;
                        Controller.call(this, FX_CONST.BLUR, gameObject);
                        /**
         * The quality of the blur effect.
         *
         * This can be:
         *
         * 0 for Low Quality
         * 1 for Medium Quality
         * 2 for High Quality
         *
         * The higher the quality, the more complex shader is used
         * and the more processing time is spent on the GPU calculating
         * the final blur. This value is used in conjunction with the
         * `steps` value, as one has a direct impact on the other.
         *
         * Keep this value as low as you can, while still achieving the
         * desired effect you need for your game.
         *
         * @name Phaser.FX.Blur#quality
         * @type {number}
         * @since 3.60.0
         */ this.quality = quality;
                        /**
         * The horizontal offset of the blur effect.
         *
         * @name Phaser.FX.Blur#x
         * @type {number}
         * @since 3.60.0
         */ this.x = x;
                        /**
         * The vertical offset of the blur effect.
         *
         * @name Phaser.FX.Blur#y
         * @type {number}
         * @since 3.60.0
         */ this.y = y;
                        /**
         * The number of steps to run the Blur effect for.
         *
         * This value should always be an integer.
         *
         * It defaults to 4. The higher the value, the smoother the blur,
         * but at the cost of exponentially more gl operations.
         *
         * Keep this to the lowest possible number you can have it, while
         * still looking correct for your game.
         *
         * @name Phaser.FX.Blur#steps
         * @type {number}
         * @since 3.60.0
         */ this.steps = steps;
                        /**
         * The strength of the blur effect.
         *
         * @name Phaser.FX.Blur#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = strength;
                        /**
         * The internal gl color array.
         *
         * @name Phaser.FX.Blur#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            1,
                            1
                        ];
                        if (color !== undefined && color !== null) this.color = color;
                    },
                    /**
     * The color of the blur as a number value.
     *
     * @name Phaser.FX.Blur#color
     * @type {number}
     * @since 3.60.0
     */ color: {
                        get: function() {
                            var color = this.glcolor;
                            return (color[0] * 255 << 16) + (color[1] * 255 << 8) + (color[2] * 255 | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor;
                            color[0] = (value >> 16 & 0xFF) / 255;
                            color[1] = (value >> 8 & 0xFF) / 255;
                            color[2] = (value & 0xFF) / 255;
                        }
                    }
                });
                module1.exports = Blur;
            /***/ },
            /***/ 27885: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Bokeh FX Controller.
 *
 * This FX controller manages the bokeh effect for a Game Object.
 *
 * Bokeh refers to a visual effect that mimics the photographic technique of creating a shallow depth of field.
 * This effect is used to emphasize the game's main subject or action, by blurring the background or foreground
 * elements, resulting in a more immersive and visually appealing experience. It is achieved through rendering
 * techniques that simulate the out-of-focus areas, giving a sense of depth and realism to the game's graphics.
 *
 * This effect can also be used to generate a Tilt Shift effect, which is a technique used to create a miniature
 * effect by blurring everything except a small area of the image. This effect is achieved by blurring the
 * top and bottom elements, while keeping the center area in focus.
 *
 * A Bokeh effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addBokeh();
 * sprite.postFX.addBokeh();
 * ```
 *
 * @class Bokeh
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [radius=0.5] - The radius of the bokeh effect.
 * @param {number} [amount=1] - The amount of the bokeh effect.
 * @param {number} [contrast=0.2] - The color contrast of the bokeh effect.
 * @param {boolean} [isTiltShift=false] - Is this a bokeh or Tile Shift effect?
 * @param {number} [blurX=1] - If Tilt Shift, the amount of horizontal blur.
 * @param {number} [blurY=1] - If Tilt Shift, the amount of vertical blur.
 * @param {number} [strength=1] - If Tilt Shift, the strength of the blur.
 */ var Bokeh = new Class({
                    Extends: Controller,
                    initialize: function Bokeh(gameObject, radius, amount, contrast, isTiltShift, blurX, blurY, strength) {
                        if (radius === undefined) radius = 0.5;
                        if (amount === undefined) amount = 1;
                        if (contrast === undefined) contrast = 0.2;
                        if (isTiltShift === undefined) isTiltShift = false;
                        if (blurX === undefined) blurX = 1;
                        if (blurY === undefined) blurY = 1;
                        if (strength === undefined) strength = 1;
                        Controller.call(this, FX_CONST.BOKEH, gameObject);
                        /**
         * The radius of the bokeh effect.
         *
         * This is a float value, where a radius of 0 will result in no effect being applied,
         * and a radius of 1 will result in a strong bokeh. However, you can exceed this value
         * for even stronger effects.
         *
         * @name Phaser.FX.Bokeh#radius
         * @type {number}
         * @since 3.60.0
         */ this.radius = radius;
                        /**
         * The amount, or strength, of the bokeh effect. Defaults to 1.
         *
         * @name Phaser.FX.Bokeh#amount
         * @type {number}
         * @since 3.60.0
         */ this.amount = amount;
                        /**
         * The color contrast, or brightness, of the bokeh effect. Defaults to 0.2.
         *
         * @name Phaser.FX.Bokeh#contrast
         * @type {number}
         * @since 3.60.0
         */ this.contrast = contrast;
                        /**
         * Is this a Tilt Shift effect or a standard bokeh effect?
         *
         * @name Phaser.FX.Bokeh#isTiltShift
         * @type {boolean}
         * @since 3.60.0
         */ this.isTiltShift = isTiltShift;
                        /**
         * If a Tilt Shift effect this controls the strength of the blur.
         *
         * Setting this value on a non-Tilt Shift effect will have no effect.
         *
         * @name Phaser.FX.Bokeh#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = strength;
                        /**
         * If a Tilt Shift effect this controls the amount of horizontal blur.
         *
         * Setting this value on a non-Tilt Shift effect will have no effect.
         *
         * @name Phaser.FX.Bokeh#blurX
         * @type {number}
         * @since 3.60.0
         */ this.blurX = blurX;
                        /**
         * If a Tilt Shift effect this controls the amount of vertical blur.
         *
         * Setting this value on a non-Tilt Shift effect will have no effect.
         *
         * @name Phaser.FX.Bokeh#blurY
         * @type {number}
         * @since 3.60.0
         */ this.blurY = blurY;
                    }
                });
                module1.exports = Bokeh;
            /***/ },
            /***/ 12578: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Circle FX Controller.
 *
 * This FX controller manages the circle effect for a Game Object.
 *
 * This effect will draw a circle around the texture of the Game Object, effectively masking off
 * any area outside of the circle without the need for an actual mask. You can control the thickness
 * of the circle, the color of the circle and the color of the background, should the texture be
 * transparent. You can also control the feathering applied to the circle, allowing for a harsh or soft edge.
 *
 * Please note that adding this effect to a Game Object will not change the input area or physics body of
 * the Game Object, should it have one.
 *
 * A Circle effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addCircle();
 * sprite.postFX.addCircle();
 * ```
 *
 * @class Circle
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [thickness=8] - The width of the circle around the texture, in pixels.
 * @param {number} [color=0xfeedb6] - The color of the circular ring, given as a number value.
 * @param {number} [backgroundColor=0xff0000] - The color of the background, behind the texture, given as a number value.
 * @param {number} [scale=1] - The scale of the circle. The default scale is 1, which is a circle the full size of the underlying texture.
 * @param {number} [feather=0.005] - The amount of feathering to apply to the circle from the ring.
 */ var Circle = new Class({
                    Extends: Controller,
                    initialize: function Circle(gameObject, thickness, color, backgroundColor, scale, feather) {
                        if (thickness === undefined) thickness = 8;
                        if (scale === undefined) scale = 1;
                        if (feather === undefined) feather = 0.005;
                        Controller.call(this, FX_CONST.CIRCLE, gameObject);
                        /**
         * The scale of the circle. The default scale is 1, which is a circle
         * the full size of the underlying texture. Reduce this value to create
         * a smaller circle, or increase it to create a circle that extends off
         * the edges of the texture.
         *
         * @name Phaser.FX.Circle#scale
         * @type {number}
         * @since 3.60.0
         */ this.scale = scale;
                        /**
         * The amount of feathering to apply to the circle from the ring,
         * extending into the middle of the circle. The default is 0.005,
         * which is a very low amount of feathering just making sure the ring
         * has a smooth edge. Increase this amount to a value such as 0.5
         * or 0.025 for larger amounts of feathering.
         *
         * @name Phaser.FX.Circle#feather
         * @type {number}
         * @since 3.60.0
         */ this.feather = feather;
                        /**
         * The width of the circle around the texture, in pixels. This value
         * doesn't factor in the feather, which can extend the thickness
         * internally depending on its value.
         *
         * @name Phaser.FX.Circle#thickness
         * @type {number}
         * @since 3.60.0
         */ this.thickness = thickness;
                        /**
         * The internal gl color array for the ring color.
         *
         * @name Phaser.FX.Circle#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            0.2,
                            0.7
                        ];
                        /**
         * The internal gl color array for the background color.
         *
         * @name Phaser.FX.Circle#glcolor2
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor2 = [
                            1,
                            0,
                            0,
                            0.4
                        ];
                        if (color !== undefined && color !== null) this.color = color;
                        if (backgroundColor !== undefined && backgroundColor !== null) this.backgroundColor = backgroundColor;
                    },
                    /**
     * The color of the circular ring, given as a number value.
     *
     * @name Phaser.FX.Circle#color
     * @type {number}
     * @since 3.60.0
     */ color: {
                        get: function() {
                            var color = this.glcolor;
                            return (color[0] * 255 << 16) + (color[1] * 255 << 8) + (color[2] * 255 | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor;
                            color[0] = (value >> 16 & 0xFF) / 255;
                            color[1] = (value >> 8 & 0xFF) / 255;
                            color[2] = (value & 0xFF) / 255;
                        }
                    },
                    /**
     * The color of the background, behind the texture, given as a number value.
     *
     * @name Phaser.FX.Circle#backgroundColor
     * @type {number}
     * @since 3.60.0
     */ backgroundColor: {
                        get: function() {
                            var color = this.glcolor2;
                            return (color[0] * 255 << 16) + (color[1] * 255 << 8) + (color[2] * 255 | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor2;
                            color[0] = (value >> 16 & 0xFF) / 255;
                            color[1] = (value >> 8 & 0xFF) / 255;
                            color[2] = (value & 0xFF) / 255;
                        }
                    },
                    /**
     * The alpha of the background, behind the texture, given as a number value.
     *
     * @name Phaser.FX.Circle#backgroundAlpha
     * @type {number}
     * @since 3.70.0
     */ backgroundAlpha: {
                        get: function() {
                            return this.glcolor2[3];
                        },
                        set: function(value) {
                            this.glcolor2[3] = value;
                        }
                    }
                });
                module1.exports = Circle;
            /***/ },
            /***/ 15802: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var BaseColorMatrix = __webpack_require__(89422);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The ColorMatrix FX Controller.
 *
 * This FX controller manages the color matrix effect for a Game Object.
 *
 * The color matrix effect is a visual technique that involves manipulating the colors of an image
 * or scene using a mathematical matrix. This process can adjust hue, saturation, brightness, and contrast,
 * allowing developers to create various stylistic appearances or mood settings within the game.
 * Common applications include simulating different lighting conditions, applying color filters,
 * or achieving a specific visual style.
 *
 * A ColorMatrix effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addColorMatrix();
 * sprite.postFX.addColorMatrix();
 * ```
 *
 * @class ColorMatrix
 * @extends Phaser.Display.ColorMatrix
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 */ var ColorMatrix = new Class({
                    Extends: BaseColorMatrix,
                    initialize: function ColorMatrix(gameObject) {
                        BaseColorMatrix.call(this);
                        /**
         * The FX_CONST type of this effect.
         *
         * @name Phaser.FX.ColorMatrix#type
         * @type {number}
         * @since 3.60.0
         */ this.type = FX_CONST.COLOR_MATRIX;
                        /**
         * A reference to the Game Object that owns this effect.
         *
         * @name Phaser.FX.ColorMatrix#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.60.0
         */ this.gameObject = gameObject;
                        /**
         * Toggle this boolean to enable or disable this effect,
         * without removing and adding it from the Game Object.
         *
         * @name Phaser.FX.ColorMatrix#active
         * @type {boolean}
         * @since 3.60.0
         */ this.active = true;
                    },
                    destroy: function() {
                        this.gameObject = null;
                        this._matrix = null;
                        this._data = null;
                    }
                });
                module1.exports = ColorMatrix;
            /***/ },
            /***/ 72898: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * FX Controller is the base class that all built-in FX use.
 *
 * You should not normally create an instance of this class directly, but instead use one of the built-in FX that extend it.
 *
 * @class Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {number} type - The FX Type constant.
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 */ var Controller = new Class({
                    initialize: function Controller(type, gameObject) {
                        /**
         * The FX_CONST type of this effect.
         *
         * @name Phaser.FX.Controller#type
         * @type {number}
         * @since 3.60.0
         */ this.type = type;
                        /**
         * A reference to the Game Object that owns this effect.
         *
         * @name Phaser.FX.Controller#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.60.0
         */ this.gameObject = gameObject;
                        /**
         * Toggle this boolean to enable or disable this effect,
         * without removing and adding it from the Game Object.
         *
         * Only works for Pre FX.
         *
         * Post FX are always active.
         *
         * @name Phaser.FX.Controller#active
         * @type {boolean}
         * @since 3.60.0
         */ this.active = true;
                    },
                    /**
     * Sets the active state of this FX Controller.
     *
     * A disabled FX Controller will not be updated.
     *
     * @method Phaser.FX.Controller#setActive
     * @since 3.60.0
     *
     * @param {boolean} value - `true` to enable this FX Controller, or `false` to disable it.
     *
     * @return {this} This FX Controller instance.
     */ setActive: function(value) {
                        this.active = value;
                        return this;
                    },
                    /**
     * Destroys this FX Controller.
     *
     * @method Phaser.FX.Controller#destroy
     * @since 3.60.0
     */ destroy: function() {
                        this.gameObject = null;
                        this.active = false;
                    }
                });
                module1.exports = Controller;
            /***/ },
            /***/ 44553: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Displacement FX Controller.
 *
 * This FX controller manages the displacement effect for a Game Object.
 *
 * The displacement effect is a visual technique that alters the position of pixels in an image
 * or texture based on the values of a displacement map. This effect is used to create the illusion
 * of depth, surface irregularities, or distortion in otherwise flat elements. It can be applied to
 * characters, objects, or backgrounds to enhance realism, convey movement, or achieve various
 * stylistic appearances.
 *
 * A Displacement effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addDisplacement();
 * sprite.postFX.addDisplacement();
 * ```
 *
 * @class Displacement
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {string} [texture='__WHITE'] - The unique string-based key of the texture to use for displacement, which must exist in the Texture Manager.
 * @param {number} [x=0.005] - The amount of horizontal displacement to apply. A very small float number, such as 0.005.
 * @param {number} [y=0.005] - The amount of vertical displacement to apply. A very small float number, such as 0.005.
 */ var Displacement = new Class({
                    Extends: Controller,
                    initialize: function Displacement(gameObject, texture, x, y) {
                        if (texture === undefined) texture = '__WHITE';
                        if (x === undefined) x = 0.005;
                        if (y === undefined) y = 0.005;
                        Controller.call(this, FX_CONST.DISPLACEMENT, gameObject);
                        /**
         * The amount of horizontal displacement to apply.
         *
         * @name Phaser.FX.Displacement#x
         * @type {number}
         * @since 3.60.0
         */ this.x = x;
                        /**
         * The amount of vertical displacement to apply.
         *
         * @name Phaser.FX.Displacement#y
         * @type {number}
         * @since 3.60.0
         */ this.y = y;
                        /**
         * The underlying texture used for displacement.
         *
         * @name Phaser.FX.Displacement#glTexture
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @since 3.60.0
         */ this.glTexture;
                        this.setTexture(texture);
                    },
                    /**
     * Sets the Texture to be used for the displacement effect.
     *
     * You can only use a whole texture, not a frame from a texture atlas or sprite sheet.
     *
     * @method Phaser.FX.Displacement#setTexture
     * @since 3.60.0
     *
     * @param {string} [texture='__WHITE'] - The unique string-based key of the texture to use for displacement, which must exist in the Texture Manager.
     *
     * @return {this} This FX Controller.
     */ setTexture: function(texture) {
                        var phaserTexture = this.gameObject.scene.sys.textures.getFrame(texture);
                        if (phaserTexture) this.glTexture = phaserTexture.glTexture;
                        return this;
                    }
                });
                module1.exports = Displacement;
            /***/ },
            /***/ 68531: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Glow FX Controller.
 *
 * This FX controller manages the glow effect for a Game Object.
 *
 * The glow effect is a visual technique that creates a soft, luminous halo around game objects,
 * characters, or UI elements. This effect is used to emphasize importance, enhance visual appeal,
 * or convey a sense of energy, magic, or otherworldly presence. The effect can also be set on
 * the inside of the Game Object. The color and strength of the glow can be modified.
 *
 * A Glow effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addGlow();
 * sprite.postFX.addGlow();
 * ```
 *
 * @class Glow
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [color=0xffffff] - The color of the glow effect as a number value.
 * @param {number} [outerStrength=4] - The strength of the glow outward from the edge of the Sprite.
 * @param {number} [innerStrength=0] - The strength of the glow inward from the edge of the Sprite.
 * @param {boolean} [knockout=false] - If `true` only the glow is drawn, not the texture itself.
 */ var Glow = new Class({
                    Extends: Controller,
                    initialize: function Glow(gameObject, color, outerStrength, innerStrength, knockout) {
                        if (outerStrength === undefined) outerStrength = 4;
                        if (innerStrength === undefined) innerStrength = 0;
                        if (knockout === undefined) knockout = false;
                        Controller.call(this, FX_CONST.GLOW, gameObject);
                        /**
         * The strength of the glow outward from the edge of the Sprite.
         *
         * @name Phaser.FX.Glow#outerStrength
         * @type {number}
         * @since 3.60.0
         */ this.outerStrength = outerStrength;
                        /**
         * The strength of the glow inward from the edge of the Sprite.
         *
         * @name Phaser.FX.Glow#innerStrength
         * @type {number}
         * @since 3.60.0
         */ this.innerStrength = innerStrength;
                        /**
         * If `true` only the glow is drawn, not the texture itself.
         *
         * @name Phaser.FX.Glow#knockout
         * @type {number}
         * @since 3.60.0
         */ this.knockout = knockout;
                        /**
         * A 4 element array of gl color values.
         *
         * @name Phaser.FX.Glow#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            1,
                            1,
                            1
                        ];
                        if (color !== undefined) this.color = color;
                    },
                    /**
     * The color of the glow as a number value.
     *
     * @name Phaser.FX.Glow#color
     * @type {number}
     * @since 3.60.0
     */ color: {
                        get: function() {
                            var color = this.glcolor;
                            return (color[0] * 255 << 16) + (color[1] * 255 << 8) + (color[2] * 255 | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor;
                            color[0] = (value >> 16 & 0xFF) / 255;
                            color[1] = (value >> 8 & 0xFF) / 255;
                            color[2] = (value & 0xFF) / 255;
                        }
                    }
                });
                module1.exports = Glow;
            /***/ },
            /***/ 37102: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Gradient FX Controller.
 *
 * This FX controller manages the gradient effect for a Game Object.
 *
 * The gradient overlay effect is a visual technique where a smooth color transition is applied over Game Objects,
 * such as sprites or UI components. This effect is used to enhance visual appeal, emphasize depth, or create
 * stylistic and atmospheric variations. It can also be utilized to convey information, such as representing
 * progress or health status through color changes.
 *
 * A Gradient effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addGradient();
 * sprite.postFX.addGradient();
 * ```
 *
 * @class Gradient
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [color1=0xff0000] - The first gradient color, given as a number value.
 * @param {number} [color2=0x00ff00] - The second gradient color, given as a number value.
 * @param {number} [alpha=0.2] - The alpha value of the gradient effect.
 * @param {number} [fromX=0] - The horizontal position the gradient will start from. This value is normalized, between 0 and 1, and is not in pixels.
 * @param {number} [fromY=0] - The vertical position the gradient will start from. This value is normalized, between 0 and 1, and is not in pixels.
 * @param {number} [toX=0] - The horizontal position the gradient will end at. This value is normalized, between 0 and 1, and is not in pixels.
 * @param {number} [toY=1] - The vertical position the gradient will end at. This value is normalized, between 0 and 1, and is not in pixels.
 * @param {number} [size=0] - How many 'chunks' the gradient is divided in to, as spread over the entire height of the texture. Leave this at zero for a smooth gradient, or set higher for a more retro chunky effect.
 */ var Gradient = new Class({
                    Extends: Controller,
                    initialize: function Gradient(gameObject, color1, color2, alpha, fromX, fromY, toX, toY, size) {
                        if (alpha === undefined) alpha = 0.2;
                        if (fromX === undefined) fromX = 0;
                        if (fromY === undefined) fromY = 0;
                        if (toX === undefined) toX = 0;
                        if (toY === undefined) toY = 1;
                        if (size === undefined) size = 0;
                        Controller.call(this, FX_CONST.GRADIENT, gameObject);
                        /**
         * The alpha value of the gradient effect.
         *
         * @name Phaser.FX.Gradient#alpha
         * @type {number}
         * @since 3.60.0
         */ this.alpha = alpha;
                        /**
         * Sets how many 'chunks' the gradient is divided in to, as spread over the
         * entire height of the texture. Leave this at zero for a smooth gradient,
         * or set to a higher number to split the gradient into that many sections, giving
         * a more banded 'retro' effect.
         *
         * @name Phaser.FX.Gradient#size
         * @type {number}
         * @since 3.60.0
         */ this.size = size;
                        /**
         * The horizontal position the gradient will start from. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.FX.Gradient#fromX
         * @type {number}
         * @since 3.60.0
         */ this.fromX = fromX;
                        /**
         * The vertical position the gradient will start from. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.FX.Gradient#fromY
         * @type {number}
         * @since 3.60.0
         */ this.fromY = fromY;
                        /**
         * The horizontal position the gradient will end. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.FX.Gradient#toX
         * @type {number}
         * @since 3.60.0
         */ this.toX = toX;
                        /**
         * The vertical position the gradient will end. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.FX.Gradient#toY
         * @type {number}
         * @since 3.60.0
         */ this.toY = toY;
                        /**
         * The internal gl color array for the starting color.
         *
         * @name Phaser.FX.Gradient#glcolor1
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor1 = [
                            255,
                            0,
                            0
                        ];
                        /**
         * The internal gl color array for the ending color.
         *
         * @name Phaser.FX.Gradient#glcolor2
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor2 = [
                            0,
                            255,
                            0
                        ];
                        if (color1 !== undefined && color1 !== null) this.color1 = color1;
                        if (color2 !== undefined && color2 !== null) this.color2 = color2;
                    },
                    /**
     * The first gradient color, given as a number value.
     *
     * @name Phaser.FX.Gradient#color1
     * @type {number}
     * @since 3.60.0
     */ color1: {
                        get: function() {
                            var color = this.glcolor1;
                            return (color[0] << 16) + (color[1] << 8) + (color[2] | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor1;
                            color[0] = value >> 16 & 0xFF;
                            color[1] = value >> 8 & 0xFF;
                            color[2] = value & 0xFF;
                        }
                    },
                    /**
     * The second gradient color, given as a number value.
     *
     * @name Phaser.FX.Gradient#color2
     * @type {number}
     * @since 3.60.0
     */ color2: {
                        get: function() {
                            var color = this.glcolor2;
                            return (color[0] << 16) + (color[1] << 8) + (color[2] | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor2;
                            color[0] = value >> 16 & 0xFF;
                            color[1] = value >> 8 & 0xFF;
                            color[2] = value & 0xFF;
                        }
                    }
                });
                module1.exports = Gradient;
            /***/ },
            /***/ 86886: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Pixelate FX Controller.
 *
 * This FX controller manages the pixelate effect for a Game Object.
 *
 * The pixelate effect is a visual technique that deliberately reduces the resolution or detail of an image,
 * creating a blocky or mosaic appearance composed of large, visible pixels. This effect can be used for stylistic
 * purposes, as a homage to retro gaming, or as a means to obscure certain elements within the game, such as
 * during a transition or to censor specific content.
 *
 * A Pixelate effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addPixelate();
 * sprite.postFX.addPixelate();
 * ```
 *
 * @class Pixelate
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [amount=1] - The amount of pixelation to apply.
 */ var Pixelate = new Class({
                    Extends: Controller,
                    initialize: function Pixelate(gameObject, amount) {
                        if (amount === undefined) amount = 1;
                        Controller.call(this, FX_CONST.PIXELATE, gameObject);
                        /**
         * The amount of pixelation to apply.
         *
         * @name Phaser.FX.Pixelate#amount
         * @type {number}
         * @since 3.60.0
         */ this.amount = amount;
                    }
                });
                module1.exports = Pixelate;
            /***/ },
            /***/ 92322: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Shadow FX Controller.
 *
 * This FX controller manages the shadow effect for a Game Object.
 *
 * The shadow effect is a visual technique used to create the illusion of depth and realism by adding darker,
 * offset silhouettes or shapes beneath game objects, characters, or environments. These simulated shadows
 * help to enhance the visual appeal and immersion, making the 2D game world appear more dynamic and three-dimensional.
 *
 * A Shadow effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addShadow();
 * sprite.postFX.addShadow();
 * ```
 *
 * @class Shadow
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [x=0] - The horizontal offset of the shadow effect.
 * @param {number} [y=0] - The vertical offset of the shadow effect.
 * @param {number} [decay=0.1] - The amount of decay for shadow effect.
 * @param {number} [power=1] - The power of the shadow effect.
 * @param {number} [color=0x000000] - The color of the shadow.
 * @param {number} [samples=6] - The number of samples that the shadow effect will run for. An integer between 1 and 12.
 * @param {number} [intensity=1] - The intensity of the shadow effect.
 */ var Shadow = new Class({
                    Extends: Controller,
                    initialize: function Shadow(gameObject, x, y, decay, power, color, samples, intensity) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (decay === undefined) decay = 0.1;
                        if (power === undefined) power = 1;
                        if (samples === undefined) samples = 6;
                        if (intensity === undefined) intensity = 1;
                        Controller.call(this, FX_CONST.SHADOW, gameObject);
                        /**
         * The horizontal offset of the shadow effect.
         *
         * @name Phaser.FX.Shadow#x
         * @type {number}
         * @since 3.60.0
         */ this.x = x;
                        /**
         * The vertical offset of the shadow effect.
         *
         * @name Phaser.FX.Shadow#y
         * @type {number}
         * @since 3.60.0
         */ this.y = y;
                        /**
         * The amount of decay for the shadow effect.
         *
         * @name Phaser.FX.Shadow#decay
         * @type {number}
         * @since 3.60.0
         */ this.decay = decay;
                        /**
         * The power of the shadow effect.
         *
         * @name Phaser.FX.Shadow#power
         * @type {number}
         * @since 3.60.0
         */ this.power = power;
                        /**
         * The internal gl color array.
         *
         * @name Phaser.FX.Shadow#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            0,
                            0,
                            0,
                            1
                        ];
                        /**
         * The number of samples that the shadow effect will run for.
         *
         * This should be an integer with a minimum value of 1 and a maximum of 12.
         *
         * @name Phaser.FX.Shadow#samples
         * @type {number}
         * @since 3.60.0
         */ this.samples = samples;
                        /**
         * The intensity of the shadow effect.
         *
         * @name Phaser.FX.Shadow#intensity
         * @type {number}
         * @since 3.60.0
         */ this.intensity = intensity;
                        if (color !== undefined) this.color = color;
                    },
                    /**
     * The color of the shadow.
     *
     * @name Phaser.FX.Shadow#color
     * @type {number}
     * @since 3.60.0
     */ color: {
                        get: function() {
                            var color = this.glcolor;
                            return (color[0] * 255 << 16) + (color[1] * 255 << 8) + (color[2] * 255 | 0);
                        },
                        set: function(value) {
                            var color = this.glcolor;
                            color[0] = (value >> 16 & 0xFF) / 255;
                            color[1] = (value >> 8 & 0xFF) / 255;
                            color[2] = (value & 0xFF) / 255;
                        }
                    }
                });
                module1.exports = Shadow;
            /***/ },
            /***/ 39563: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Shine FX Controller.
 *
 * This FX controller manages the shift effect for a Game Object.
 *
 * The shine effect is a visual technique that simulates the appearance of reflective
 * or glossy surfaces by passing a light beam across a Game Object. This effect is used to
 * enhance visual appeal, emphasize certain features, and create a sense of depth or
 * material properties.
 *
 * A Shine effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addShine();
 * sprite.postFX.addShine();
 * ```
 *
 * @class Shine
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [speed=0.5] - The speed of the Shine effect.
 * @param {number} [lineWidth=0.5] - The line width of the Shine effect.
 * @param {number} [gradient=3] - The gradient of the Shine effect.
 * @param {boolean} [reveal=false] - Does this Shine effect reveal or get added to its target?
 */ var Shine = new Class({
                    Extends: Controller,
                    initialize: function Shine(gameObject, speed, lineWidth, gradient, reveal) {
                        if (speed === undefined) speed = 0.5;
                        if (lineWidth === undefined) lineWidth = 0.5;
                        if (gradient === undefined) gradient = 3;
                        if (reveal === undefined) reveal = false;
                        Controller.call(this, FX_CONST.SHINE, gameObject);
                        /**
         * The speed of the Shine effect.
         *
         * @name Phaser.FX.Shine#speed
         * @type {number}
         * @since 3.60.0
         */ this.speed = speed;
                        /**
         * The line width of the Shine effect.
         *
         * @name Phaser.FX.Shine#lineWidth
         * @type {number}
         * @since 3.60.0
         */ this.lineWidth = lineWidth;
                        /**
         * The gradient of the Shine effect.
         *
         * @name Phaser.FX.Shine#gradient
         * @type {number}
         * @since 3.60.0
         */ this.gradient = gradient;
                        /**
         * Does this Shine effect reveal or get added to its target?
         *
         * @name Phaser.FX.Shine#reveal
         * @type {boolean}
         * @since 3.60.0
         */ this.reveal = reveal;
                    }
                });
                module1.exports = Shine;
            /***/ },
            /***/ 56448: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Vignette FX Controller.
 *
 * This FX controller manages the vignette effect for a Game Object.
 *
 * The vignette effect is a visual technique where the edges of the screen, or a Game Object, gradually darken or blur,
 * creating a frame-like appearance. This effect is used to draw the player's focus towards the central action or subject,
 * enhance immersion, and provide a cinematic or artistic quality to the game's visuals.
 *
 * A Vignette effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addVignette();
 * sprite.postFX.addVignette();
 * ```
 *
 * @class Vignette
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [x=0.5] - The horizontal offset of the vignette effect. This value is normalized to the range 0 to 1.
 * @param {number} [y=0.5] - The vertical offset of the vignette effect. This value is normalized to the range 0 to 1.
 * @param {number} [radius=0.5] - The radius of the vignette effect. This value is normalized to the range 0 to 1.
 * @param {number} [strength=0.5] - The strength of the vignette effect.
 */ var Vignette = new Class({
                    Extends: Controller,
                    initialize: function Vignette(gameObject, x, y, radius, strength) {
                        if (x === undefined) x = 0.5;
                        if (y === undefined) y = 0.5;
                        if (radius === undefined) radius = 0.5;
                        if (strength === undefined) strength = 0.5;
                        Controller.call(this, FX_CONST.VIGNETTE, gameObject);
                        /**
         * The horizontal offset of the vignette effect. This value is normalized to the range 0 to 1.
         *
         * @name Phaser.FX.Vignette#x
         * @type {number}
         * @since 3.60.0
         */ this.x = x;
                        /**
         * The vertical offset of the vignette effect. This value is normalized to the range 0 to 1.
         *
         * @name Phaser.FX.Vignette#y
         * @type {number}
         * @since 3.60.0
         */ this.y = y;
                        /**
         * The radius of the vignette effect. This value is normalized to the range 0 to 1.
         *
         * @name Phaser.FX.Vignette#radius
         * @type {number}
         * @since 3.60.0
         */ this.radius = radius;
                        /**
         * The strength of the vignette effect.
         *
         * @name Phaser.FX.Vignette#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = strength;
                    }
                });
                module1.exports = Vignette;
            /***/ },
            /***/ 38433: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Controller = __webpack_require__(72898);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @classdesc
 * The Wipe FX Controller.
 *
 * This FX controller manages the wipe effect for a Game Object.
 *
 * The wipe or reveal effect is a visual technique that gradually uncovers or conceals elements
 * in the game, such as images, text, or scene transitions. This effect is often used to create
 * a sense of progression, reveal hidden content, or provide a smooth and visually appealing transition
 * between game states.
 *
 * You can set both the direction and the axis of the wipe effect. The following combinations are possible:
 *
 * * left to right: direction 0, axis 0
 * * right to left: direction 1, axis 0
 * * top to bottom: direction 1, axis 1
 * * bottom to top: direction 1, axis 0
 *
 * It is up to you to set the `progress` value yourself, i.e. via a Tween, in order to transition the effect.
 *
 * A Wipe effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.preFX.addWipe();
 * sprite.postFX.addWipe();
 * sprite.preFX.addReveal();
 * sprite.postFX.addReveal();
 * ```
 *
 * @class Wipe
 * @extends Phaser.FX.Controller
 * @memberof Phaser.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that has this fx.
 * @param {number} [wipeWidth=0.1] - The width of the wipe effect. This value is normalized in the range 0 to 1.
 * @param {number} [direction=0] - The direction of the wipe effect. Either 0 or 1. Set in conjunction with the axis property.
 * @param {number} [axis=0] - The axis of the wipe effect. Either 0 or 1. Set in conjunction with the direction property.
 * @param {boolean} [reveal=false] - Is this a reveal (true) or a fade (false) effect?
 */ var Wipe = new Class({
                    Extends: Controller,
                    initialize: function Wipe(gameObject, wipeWidth, direction, axis, reveal) {
                        if (wipeWidth === undefined) wipeWidth = 0.1;
                        if (direction === undefined) direction = 0;
                        if (axis === undefined) axis = 0;
                        if (reveal === undefined) reveal = false;
                        Controller.call(this, FX_CONST.WIPE, gameObject);
                        /**
         * The progress of the Wipe effect. This value is normalized to the range 0 to 1.
         *
         * Adjust this value to make the wipe transition (i.e. via a Tween)
         *
         * @name Phaser.FX.Wipe#progress
         * @type {number}
         * @since 3.60.0
         */ this.progress = 0;
                        /**
         * The width of the wipe effect. This value is normalized in the range 0 to 1.
         *
         * @name Phaser.FX.Wipe#wipeWidth
         * @type {number}
         * @since 3.60.0
         */ this.wipeWidth = wipeWidth;
                        /**
         * The direction of the wipe effect. Either 0 or 1. Set in conjunction with the axis property.
         *
         * @name Phaser.FX.Wipe#direction
         * @type {number}
         * @since 3.60.0
         */ this.direction = direction;
                        /**
         * The axis of the wipe effect. Either 0 or 1. Set in conjunction with the direction property.
         *
         * @name Phaser.FX.Wipe#axis
         * @type {number}
         * @since 3.60.0
         */ this.axis = axis;
                        /**
         * Is this a reveal (true) or a fade (false) effect?
         *
         * @name Phaser.FX.Wipe#reveal
         * @type {boolean}
         * @since 3.60.0
         */ this.reveal = reveal;
                    }
                });
                module1.exports = Wipe;
            /***/ },
            /***/ 14811: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FX_CONST = {
                    /**
     * The Glow FX.
     *
     * @name Phaser.FX.GLOW
     * @type {number}
     * @const
     * @since 3.60.0
     */ GLOW: 4,
                    /**
     * The Shadow FX.
     *
     * @name Phaser.FX.SHADOW
     * @type {number}
     * @const
     * @since 3.60.0
     */ SHADOW: 5,
                    /**
     * The Pixelate FX.
     *
     * @name Phaser.FX.PIXELATE
     * @type {number}
     * @const
     * @since 3.60.0
     */ PIXELATE: 6,
                    /**
     * The Vignette FX.
     *
     * @name Phaser.FX.VIGNETTE
     * @type {number}
     * @const
     * @since 3.60.0
     */ VIGNETTE: 7,
                    /**
     * The Shine FX.
     *
     * @name Phaser.FX.SHINE
     * @type {number}
     * @const
     * @since 3.60.0
     */ SHINE: 8,
                    /**
     * The Blur FX.
     *
     * @name Phaser.FX.BLUR
     * @type {number}
     * @const
     * @since 3.60.0
     */ BLUR: 9,
                    /**
     * The Gradient FX.
     *
     * @name Phaser.FX.GRADIENT
     * @type {number}
     * @const
     * @since 3.60.0
     */ GRADIENT: 12,
                    /**
     * The Bloom FX.
     *
     * @name Phaser.FX.BLOOM
     * @type {number}
     * @const
     * @since 3.60.0
     */ BLOOM: 13,
                    /**
     * The Color Matrix FX.
     *
     * @name Phaser.FX.COLOR_MATRIX
     * @type {number}
     * @const
     * @since 3.60.0
     */ COLOR_MATRIX: 14,
                    /**
     * The Circle FX.
     *
     * @name Phaser.FX.CIRCLE
     * @type {number}
     * @const
     * @since 3.60.0
     */ CIRCLE: 15,
                    /**
     * The Barrel FX.
     *
     * @name Phaser.FX.BARREL
     * @type {number}
     * @const
     * @since 3.60.0
     */ BARREL: 16,
                    /**
     * The Displacement FX.
     *
     * @name Phaser.FX.DISPLACEMENT
     * @type {number}
     * @const
     * @since 3.60.0
     */ DISPLACEMENT: 17,
                    /**
     * The Wipe FX.
     *
     * @name Phaser.FX.WIPE
     * @type {number}
     * @const
     * @since 3.60.0
     */ WIPE: 18,
                    /**
     * The Bokeh and Tilt Shift FX.
     *
     * @name Phaser.FX.BOKEH
     * @type {number}
     * @const
     * @since 3.60.0
     */ BOKEH: 19
                };
                module1.exports = FX_CONST;
            /***/ },
            /***/ 66064: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(79291);
                var FX_CONST = __webpack_require__(14811);
                /**
 * @namespace Phaser.FX
 */ var FX = {
                    Barrel: __webpack_require__(20122),
                    Controller: __webpack_require__(72898),
                    Bloom: __webpack_require__(32251),
                    Blur: __webpack_require__(9047),
                    Bokeh: __webpack_require__(27885),
                    Circle: __webpack_require__(12578),
                    ColorMatrix: __webpack_require__(15802),
                    Displacement: __webpack_require__(44553),
                    Glow: __webpack_require__(68531),
                    Gradient: __webpack_require__(37102),
                    Pixelate: __webpack_require__(86886),
                    Shadow: __webpack_require__(92322),
                    Shine: __webpack_require__(39563),
                    Vignette: __webpack_require__(56448),
                    Wipe: __webpack_require__(38433)
                };
                FX = Extend(false, FX, FX_CONST);
                module1.exports = FX;
            /***/ },
            /***/ 25305: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(10312);
                var GetAdvancedValue = __webpack_require__(23568);
                /**
 * Builds a Game Object using the provided configuration object.
 *
 * @function Phaser.GameObjects.BuildGameObject
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene.
 * @param {Phaser.GameObjects.GameObject} gameObject - The initial GameObject.
 * @param {Phaser.Types.GameObjects.GameObjectConfig} config - The config to build the GameObject with.
 *
 * @return {Phaser.GameObjects.GameObject} The built Game Object.
 */ var BuildGameObject = function(scene, gameObject, config) {
                    //  Position
                    gameObject.x = GetAdvancedValue(config, 'x', 0);
                    gameObject.y = GetAdvancedValue(config, 'y', 0);
                    gameObject.depth = GetAdvancedValue(config, 'depth', 0);
                    //  Flip
                    gameObject.flipX = GetAdvancedValue(config, 'flipX', false);
                    gameObject.flipY = GetAdvancedValue(config, 'flipY', false);
                    //  Scale
                    //  Either: { scale: 2 } or { scale: { x: 2, y: 2 }}
                    var scale = GetAdvancedValue(config, 'scale', null);
                    if (typeof scale === 'number') gameObject.setScale(scale);
                    else if (scale !== null) {
                        gameObject.scaleX = GetAdvancedValue(scale, 'x', 1);
                        gameObject.scaleY = GetAdvancedValue(scale, 'y', 1);
                    }
                    //  ScrollFactor
                    //  Either: { scrollFactor: 2 } or { scrollFactor: { x: 2, y: 2 }}
                    var scrollFactor = GetAdvancedValue(config, 'scrollFactor', null);
                    if (typeof scrollFactor === 'number') gameObject.setScrollFactor(scrollFactor);
                    else if (scrollFactor !== null) {
                        gameObject.scrollFactorX = GetAdvancedValue(scrollFactor, 'x', 1);
                        gameObject.scrollFactorY = GetAdvancedValue(scrollFactor, 'y', 1);
                    }
                    //  Rotation
                    gameObject.rotation = GetAdvancedValue(config, 'rotation', 0);
                    var angle = GetAdvancedValue(config, 'angle', null);
                    if (angle !== null) gameObject.angle = angle;
                    //  Alpha
                    gameObject.alpha = GetAdvancedValue(config, 'alpha', 1);
                    //  Origin
                    //  Either: { origin: 0.5 } or { origin: { x: 0.5, y: 0.5 }}
                    var origin = GetAdvancedValue(config, 'origin', null);
                    if (typeof origin === 'number') gameObject.setOrigin(origin);
                    else if (origin !== null) {
                        var ox = GetAdvancedValue(origin, 'x', 0.5);
                        var oy = GetAdvancedValue(origin, 'y', 0.5);
                        gameObject.setOrigin(ox, oy);
                    }
                    //  BlendMode
                    gameObject.blendMode = GetAdvancedValue(config, 'blendMode', BlendModes.NORMAL);
                    //  Visible
                    gameObject.visible = GetAdvancedValue(config, 'visible', true);
                    //  Add to Scene
                    var add = GetAdvancedValue(config, 'add', true);
                    if (add) scene.sys.displayList.add(gameObject);
                    if (gameObject.preUpdate) scene.sys.updateList.add(gameObject);
                    return gameObject;
                };
                module1.exports = BuildGameObject;
            /***/ },
            /***/ 13059: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAdvancedValue = __webpack_require__(23568);
                /**
 * Adds an Animation component to a Sprite and populates it based on the given config.
 *
 * @function Phaser.GameObjects.BuildGameObjectAnimation
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Sprite} sprite - The sprite to add an Animation component to.
 * @param {object} config - The animation config.
 *
 * @return {Phaser.GameObjects.Sprite} The updated Sprite.
 */ var BuildGameObjectAnimation = function(sprite, config) {
                    var animConfig = GetAdvancedValue(config, 'anims', null);
                    if (animConfig === null) return sprite;
                    if (typeof animConfig === 'string') //  { anims: 'key' }
                    sprite.anims.play(animConfig);
                    else if (typeof animConfig === 'object') {
                        //  { anims: {
                        //              key: string
                        //              startFrame: [string|number]
                        //              delay: [float]
                        //              repeat: [integer]
                        //              repeatDelay: [float]
                        //              yoyo: [boolean]
                        //              play: [boolean]
                        //              delayedPlay: [boolean]
                        //           }
                        //  }
                        var anims = sprite.anims;
                        var key = GetAdvancedValue(animConfig, 'key', undefined);
                        if (key) {
                            var startFrame = GetAdvancedValue(animConfig, 'startFrame', undefined);
                            var delay = GetAdvancedValue(animConfig, 'delay', 0);
                            var repeat = GetAdvancedValue(animConfig, 'repeat', 0);
                            var repeatDelay = GetAdvancedValue(animConfig, 'repeatDelay', 0);
                            var yoyo = GetAdvancedValue(animConfig, 'yoyo', false);
                            var play = GetAdvancedValue(animConfig, 'play', false);
                            var delayedPlay = GetAdvancedValue(animConfig, 'delayedPlay', 0);
                            var playConfig = {
                                key: key,
                                delay: delay,
                                repeat: repeat,
                                repeatDelay: repeatDelay,
                                yoyo: yoyo,
                                startFrame: startFrame
                            };
                            if (play) anims.play(playConfig);
                            else if (delayedPlay > 0) anims.playAfterDelay(playConfig, delayedPlay);
                            else anims.load(playConfig);
                        }
                    }
                    return sprite;
                };
                module1.exports = BuildGameObjectAnimation;
            /***/ },
            /***/ 8050: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var List = __webpack_require__(73162);
                var PluginCache = __webpack_require__(37277);
                var GameObjectEvents = __webpack_require__(51708);
                var SceneEvents = __webpack_require__(44594);
                var StableSort = __webpack_require__(19186);
                /**
 * @classdesc
 * The Display List plugin.
 *
 * Display Lists belong to a Scene and maintain the list of Game Objects to render every frame.
 *
 * Some of these Game Objects may also be part of the Scene's [Update List]{@link Phaser.GameObjects.UpdateList}, for updating.
 *
 * @class DisplayList
 * @extends Phaser.Structs.List.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Display List belongs to.
 */ var DisplayList = new Class({
                    Extends: List,
                    initialize: function DisplayList(scene) {
                        List.call(this, scene);
                        /**
         * The flag the determines whether Game Objects should be sorted when `depthSort()` is called.
         *
         * @name Phaser.GameObjects.DisplayList#sortChildrenFlag
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.sortChildrenFlag = false;
                        /**
         * The Scene that this Display List belongs to.
         *
         * @name Phaser.GameObjects.DisplayList#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * The Scene's Systems.
         *
         * @name Phaser.GameObjects.DisplayList#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * The Scene's Event Emitter.
         *
         * @name Phaser.GameObjects.DisplayList#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.50.0
         */ this.events = scene.sys.events;
                        //  Set the List callbacks
                        this.addCallback = this.addChildCallback;
                        this.removeCallback = this.removeChildCallback;
                        this.events.once(SceneEvents.BOOT, this.boot, this);
                        this.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.DisplayList#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * Internal method called from `List.addCallback`.
     *
     * @method Phaser.GameObjects.DisplayList#addChildCallback
     * @private
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the list.
     */ addChildCallback: function(gameObject) {
                        if (gameObject.displayList && gameObject.displayList !== this) gameObject.removeFromDisplayList();
                        if (gameObject.parentContainer) gameObject.parentContainer.remove(gameObject);
                        if (!gameObject.displayList) {
                            this.queueDepthSort();
                            gameObject.displayList = this;
                            gameObject.emit(GameObjectEvents.ADDED_TO_SCENE, gameObject, this.scene);
                            this.events.emit(SceneEvents.ADDED_TO_SCENE, gameObject, this.scene);
                        }
                    },
                    /**
     * Internal method called from `List.removeCallback`.
     *
     * @method Phaser.GameObjects.DisplayList#removeChildCallback
     * @private
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the list.
     */ removeChildCallback: function(gameObject) {
                        this.queueDepthSort();
                        gameObject.displayList = null;
                        gameObject.emit(GameObjectEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                        this.events.emit(SceneEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.DisplayList#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Force a sort of the display list on the next call to depthSort.
     *
     * @method Phaser.GameObjects.DisplayList#queueDepthSort
     * @since 3.0.0
     */ queueDepthSort: function() {
                        this.sortChildrenFlag = true;
                    },
                    /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.GameObjects.DisplayList#depthSort
     * @since 3.0.0
     */ depthSort: function() {
                        if (this.sortChildrenFlag) {
                            StableSort(this.list, this.sortByDepth);
                            this.sortChildrenFlag = false;
                        }
                    },
                    /**
     * Compare the depth of two Game Objects.
     *
     * @method Phaser.GameObjects.DisplayList#sortByDepth
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object.
     *
     * @return {number} The difference between the depths of each Game Object.
     */ sortByDepth: function(childA, childB) {
                        return childA._depth - childB._depth;
                    },
                    /**
     * Returns an array which contains all objects currently on the Display List.
     * This is a reference to the main list array, not a copy of it, so be careful not to modify it.
     *
     * @method Phaser.GameObjects.DisplayList#getChildren
     * @since 3.12.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                        return this.list;
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.DisplayList#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        var list = this.list;
                        var i = list.length;
                        while(i--)list[i].destroy(true);
                        list.length = 0;
                        this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.DisplayList#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                        this.events = null;
                    }
                });
                PluginCache.register('DisplayList', DisplayList, 'displayList');
                module1.exports = DisplayList;
            /***/ },
            /***/ 95643: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var ComponentsToJSON = __webpack_require__(53774);
                var DataManager = __webpack_require__(45893);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(51708);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * The base class that all Game Objects extend.
 * You don't create GameObjects directly and they cannot be added to the display list.
 * Instead, use them as the base for your own custom classes.
 *
 * @class GameObject
 * @memberof Phaser.GameObjects
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {string} type - A textual representation of the type of Game Object, i.e. `sprite`.
 */ var GameObject = new Class({
                    Extends: EventEmitter,
                    initialize: function GameObject(scene, type) {
                        EventEmitter.call(this);
                        /**
         * A reference to the Scene to which this Game Object belongs.
         *
         * Game Objects can only belong to one Scene.
         *
         * You should consider this property as being read-only. You cannot move a
         * Game Object to another Scene by simply changing it.
         *
         * @name Phaser.GameObjects.GameObject#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * Holds a reference to the Display List that contains this Game Object.
         *
         * This is set automatically when this Game Object is added to a Scene or Layer.
         *
         * You should treat this property as being read-only.
         *
         * @name Phaser.GameObjects.GameObject#displayList
         * @type {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)}
         * @default null
         * @since 3.50.0
         */ this.displayList = null;
                        /**
         * A textual representation of this Game Object, i.e. `sprite`.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.GameObject#type
         * @type {string}
         * @since 3.0.0
         */ this.type = type;
                        /**
         * The current state of this Game Object.
         *
         * Phaser itself will never modify this value, although plugins may do so.
         *
         * Use this property to track the state of a Game Object during its lifetime. For example, it could change from
         * a state of 'moving', to 'attacking', to 'dead'. The state value should be an integer (ideally mapped to a constant
         * in your game code), or a string. These are recommended to keep it light and simple, with fast comparisons.
         * If you need to store complex data about your Game Object, look at using the Data Component instead.
         *
         * @name Phaser.GameObjects.GameObject#state
         * @type {(number|string)}
         * @since 3.16.0
         */ this.state = 0;
                        /**
         * The parent Container of this Game Object, if it has one.
         *
         * @name Phaser.GameObjects.GameObject#parentContainer
         * @type {Phaser.GameObjects.Container}
         * @since 3.4.0
         */ this.parentContainer = null;
                        /**
         * The name of this Game Object.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.GameObject#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = '';
                        /**
         * The active state of this Game Object.
         * A Game Object with an active state of `true` is processed by the Scenes UpdateList, if added to it.
         * An active object is one which is having its logic and internal systems updated.
         *
         * @name Phaser.GameObjects.GameObject#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                        /**
         * The Tab Index of the Game Object.
         * Reserved for future use by plugins and the Input Manager.
         *
         * @name Phaser.GameObjects.GameObject#tabIndex
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.tabIndex = -1;
                        /**
         * A Data Manager.
         * It allows you to store, query and get key/value paired information specific to this Game Object.
         * `null` by default. Automatically created if you use `getData` or `setData` or `setDataEnabled`.
         *
         * @name Phaser.GameObjects.GameObject#data
         * @type {Phaser.Data.DataManager}
         * @default null
         * @since 3.0.0
         */ this.data = null;
                        /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.GameObject#renderFlags
         * @type {number}
         * @default 15
         * @since 3.0.0
         */ this.renderFlags = 15;
                        /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.GameObject#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cameraFilter = 0;
                        /**
         * If this Game Object is enabled for input then this property will contain an InteractiveObject instance.
         * Not usually set directly. Instead call `GameObject.setInteractive()`.
         *
         * @name Phaser.GameObjects.GameObject#input
         * @type {?Phaser.Types.Input.InteractiveObject}
         * @default null
         * @since 3.0.0
         */ this.input = null;
                        /**
         * If this Game Object is enabled for Arcade or Matter Physics then this property will contain a reference to a Physics Body.
         *
         * @name Phaser.GameObjects.GameObject#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|MatterJS.BodyType)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                        /**
         * This Game Object will ignore all calls made to its destroy method if this flag is set to `true`.
         * This includes calls that may come from a Group, Container or the Scene itself.
         * While it allows you to persist a Game Object across Scenes, please understand you are entirely
         * responsible for managing references to and from this Game Object.
         *
         * @name Phaser.GameObjects.GameObject#ignoreDestroy
         * @type {boolean}
         * @default false
         * @since 3.5.0
         */ this.ignoreDestroy = false;
                        this.on(Events.ADDED_TO_SCENE, this.addedToScene, this);
                        this.on(Events.REMOVED_FROM_SCENE, this.removedFromScene, this);
                        //  Tell the Scene to re-sort the children
                        scene.sys.queueDepthSort();
                    },
                    /**
     * Sets the `active` property of this Game Object and returns this Game Object for further chaining.
     * A Game Object with its `active` property set to `true` will be updated by the Scenes UpdateList.
     *
     * @method Phaser.GameObjects.GameObject#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - True if this Game Object should be set as active, false if not.
     *
     * @return {this} This GameObject.
     */ setActive: function(value) {
                        this.active = value;
                        return this;
                    },
                    /**
     * Sets the `name` property of this Game Object and returns this Game Object for further chaining.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.GameObject#setName
     * @since 3.0.0
     *
     * @param {string} value - The name to be given to this Game Object.
     *
     * @return {this} This GameObject.
     */ setName: function(value) {
                        this.name = value;
                        return this;
                    },
                    /**
     * Sets the current state of this Game Object.
     *
     * Phaser itself will never modify the State of a Game Object, although plugins may do so.
     *
     * For example, a Game Object could change from a state of 'moving', to 'attacking', to 'dead'.
     * The state value should typically be an integer (ideally mapped to a constant
     * in your game code), but could also be a string. It is recommended to keep it light and simple.
     * If you need to store complex data about your Game Object, look at using the Data Component instead.
     *
     * @method Phaser.GameObjects.GameObject#setState
     * @since 3.16.0
     *
     * @param {(number|string)} value - The state of the Game Object.
     *
     * @return {this} This GameObject.
     */ setState: function(value) {
                        this.state = value;
                        return this;
                    },
                    /**
     * Adds a Data Manager component to this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#setDataEnabled
     * @since 3.0.0
     * @see Phaser.Data.DataManager
     *
     * @return {this} This GameObject.
     */ setDataEnabled: function() {
                        if (!this.data) this.data = new DataManager(this);
                        return this;
                    },
                    /**
     * Allows you to store a key value pair within this Game Objects Data Manager.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * sprite.setData('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * sprite.setData({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `getData`:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * sprite.data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.GameObjects.GameObject#setData
     * @since 3.0.0
     *
     * @generic {any} T
     * @genericUse {(string|T)} - [key]
     *
     * @param {(string|object)} key - The key to set the value for. Or an object of key value pairs. If an object the `data` argument is ignored.
     * @param {*} [data] - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This GameObject.
     */ setData: function(key, value) {
                        if (!this.data) this.data = new DataManager(this);
                        this.data.set(key, value);
                        return this;
                    },
                    /**
     * Increase a value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#incData
     * @since 3.23.0
     *
     * @param {string} key - The key to change the value for.
     * @param {number} [amount=1] - The amount to increase the given key by. Pass a negative value to decrease the key.
     *
     * @return {this} This GameObject.
     */ incData: function(key, amount) {
                        if (!this.data) this.data = new DataManager(this);
                        this.data.inc(key, amount);
                        return this;
                    },
                    /**
     * Toggle a boolean value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#toggleData
     * @since 3.23.0
     *
     * @param {string} key - The key to toggle the value for.
     *
     * @return {this} This GameObject.
     */ toggleData: function(key) {
                        if (!this.data) this.data = new DataManager(this);
                        this.data.toggle(key);
                        return this;
                    },
                    /**
     * Retrieves the value for the given key in this Game Objects Data Manager, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * sprite.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * sprite.getData([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.GameObjects.GameObject#getData
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ getData: function(key) {
                        if (!this.data) this.data = new DataManager(this);
                        return this.data.get(key);
                    },
                    /**
     * Pass this Game Object to the Input Manager to enable it for Input.
     *
     * Input works by using hit areas, these are nearly always geometric shapes, such as rectangles or circles, that act as the hit area
     * for the Game Object. However, you can provide your own hit area shape and callback, should you wish to handle some more advanced
     * input detection.
     *
     * If no arguments are provided it will try and create a rectangle hit area based on the texture frame the Game Object is using. If
     * this isn't a texture-bound object, such as a Graphics or BitmapText object, this will fail, and you'll need to provide a specific
     * shape for it to use.
     *
     * You can also provide an Input Configuration Object as the only argument to this method.
     *
     * @example
     * sprite.setInteractive();
     *
     * @example
     * sprite.setInteractive(new Phaser.Geom.Circle(45, 46, 45), Phaser.Geom.Circle.Contains);
     *
     * @example
     * graphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, 128, 128), Phaser.Geom.Rectangle.Contains);
     *
     * @method Phaser.GameObjects.GameObject#setInteractive
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not given it will try to create a Rectangle based on the texture frame.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The callback that determines if the pointer is within the Hit Area shape or not. If you provide a shape you must also provide a callback.
     * @param {boolean} [dropZone=false] - Should this Game Object be treated as a drop zone target?
     *
     * @return {this} This GameObject.
     */ setInteractive: function(hitArea, hitAreaCallback, dropZone) {
                        this.scene.sys.input.enable(this, hitArea, hitAreaCallback, dropZone);
                        return this;
                    },
                    /**
     * If this Game Object has previously been enabled for input, this will disable it.
     *
     * An object that is disabled for input stops processing or being considered for
     * input events, but can be turned back on again at any time by simply calling
     * `setInteractive()` with no arguments provided.
     *
     * If want to completely remove interaction from this Game Object then use `removeInteractive` instead.
     *
     * @method Phaser.GameObjects.GameObject#disableInteractive
     * @since 3.7.0
     * 
     * @param {boolean} [resetCursor=false] - Should the currently active Input cursor, if any, be reset to the default cursor?
     *
     * @return {this} This GameObject.
     */ disableInteractive: function(resetCursor) {
                        if (resetCursor === undefined) resetCursor = false;
                        this.scene.sys.input.disable(this, resetCursor);
                        return this;
                    },
                    /**
     * If this Game Object has previously been enabled for input, this will queue it
     * for removal, causing it to no longer be interactive. The removal happens on
     * the next game step, it is not immediate.
     *
     * The Interactive Object that was assigned to this Game Object will be destroyed,
     * removed from the Input Manager and cleared from this Game Object.
     *
     * If you wish to re-enable this Game Object at a later date you will need to
     * re-create its InteractiveObject by calling `setInteractive` again.
     *
     * If you wish to only temporarily stop an object from receiving input then use
     * `disableInteractive` instead, as that toggles the interactive state, where-as
     * this erases it completely.
     *
     * If you wish to resize a hit area, don't remove and then set it as being
     * interactive. Instead, access the hitarea object directly and resize the shape
     * being used. I.e.: `sprite.input.hitArea.setSize(width, height)` (assuming the
     * shape is a Rectangle, which it is by default.)
     *
     * @method Phaser.GameObjects.GameObject#removeInteractive
     * @since 3.7.0
     * 
     * @param {boolean} [resetCursor=false] - Should the currently active Input cursor, if any, be reset to the default cursor?
     *
     * @return {this} This GameObject.
     */ removeInteractive: function(resetCursor) {
                        if (resetCursor === undefined) resetCursor = false;
                        this.scene.sys.input.clear(this);
                        if (resetCursor) this.scene.sys.input.resetCursor();
                        this.input = undefined;
                        return this;
                    },
                    /**
     * This callback is invoked when this Game Object is added to a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to add themselves into the Update List.
     *
     * You can also listen for the `ADDED_TO_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#addedToScene
     * @since 3.50.0
     */ addedToScene: function() {},
                    /**
     * This callback is invoked when this Game Object is removed from a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to removed themselves from the Update List.
     *
     * You can also listen for the `REMOVED_FROM_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#removedFromScene
     * @since 3.50.0
     */ removedFromScene: function() {},
                    /**
     * To be overridden by custom GameObjects. Allows base objects to be used in a Pool.
     *
     * @method Phaser.GameObjects.GameObject#update
     * @since 3.0.0
     *
     * @param {...*} [args] - args
     */ update: function() {},
                    /**
     * Returns a JSON representation of the Game Object.
     *
     * @method Phaser.GameObjects.GameObject#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                        return ComponentsToJSON(this);
                    },
                    /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.GameObject#willRender
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                        var listWillRender = this.displayList && this.displayList.active ? this.displayList.willRender(camera) : true;
                        return !(!listWillRender || GameObject.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                    },
                    /**
     * Returns an array containing the display list index of either this Game Object, or if it has one,
     * its parent Container. It then iterates up through all of the parent containers until it hits the
     * root of the display list (which is index 0 in the returned array).
     *
     * Used internally by the InputPlugin but also useful if you wish to find out the display depth of
     * this Game Object and all of its ancestors.
     *
     * @method Phaser.GameObjects.GameObject#getIndexList
     * @since 3.4.0
     *
     * @return {number[]} An array of display list position indexes.
     */ getIndexList: function() {
                        // eslint-disable-next-line consistent-this
                        var child = this;
                        var parent = this.parentContainer;
                        var indexes = [];
                        while(parent){
                            indexes.unshift(parent.getIndex(child));
                            child = parent;
                            if (!parent.parentContainer) break;
                            else parent = parent.parentContainer;
                        }
                        if (this.displayList) indexes.unshift(this.displayList.getIndex(child));
                        else indexes.unshift(this.scene.sys.displayList.getIndex(child));
                        return indexes;
                    },
                    /**
     * Adds this Game Object to the given Display List.
     *
     * If no Display List is specified, it will default to the Display List owned by the Scene to which
     * this Game Object belongs.
     *
     * A Game Object can only exist on one Display List at any given time, but may move freely between them.
     *
     * If this Game Object is already on another Display List when this method is called, it will first
     * be removed from it, before being added to the new list.
     *
     * You can query which list it is on by looking at the `Phaser.GameObjects.GameObject#displayList` property.
     *
     * If a Game Object isn't on any display list, it will not be rendered. If you just wish to temporarly
     * disable it from rendering, consider using the `setVisible` method, instead.
     *
     * @method Phaser.GameObjects.GameObject#addToDisplayList
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.53.0
     *
     * @param {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)} [displayList] - The Display List to add to. Defaults to the Scene Display List.
     *
     * @return {this} This Game Object.
     */ addToDisplayList: function(displayList) {
                        if (displayList === undefined) displayList = this.scene.sys.displayList;
                        if (this.displayList && this.displayList !== displayList) this.removeFromDisplayList();
                        //  Don't repeat if it's already on this list
                        if (!displayList.exists(this)) {
                            this.displayList = displayList;
                            displayList.add(this, true);
                            displayList.queueDepthSort();
                            this.emit(Events.ADDED_TO_SCENE, this, this.scene);
                            displayList.events.emit(SceneEvents.ADDED_TO_SCENE, this, this.scene);
                        }
                        return this;
                    },
                    /**
     * Adds this Game Object to the Update List belonging to the Scene.
     *
     * When a Game Object is added to the Update List it will have its `preUpdate` method called
     * every game frame. This method is passed two parameters: `delta` and `time`.
     *
     * If you wish to run your own logic within `preUpdate` then you should always call
     * `super.preUpdate(delta, time)` within it, or it may fail to process required operations,
     * such as Sprite animations.
     *
     * @method Phaser.GameObjects.GameObject#addToUpdateList
     * @since 3.53.0
     *
     * @return {this} This Game Object.
     */ addToUpdateList: function() {
                        if (this.scene && this.preUpdate) this.scene.sys.updateList.add(this);
                        return this;
                    },
                    /**
     * Removes this Game Object from the Display List it is currently on.
     *
     * A Game Object can only exist on one Display List at any given time, but may move freely removed
     * and added back at a later stage.
     *
     * You can query which list it is on by looking at the `Phaser.GameObjects.GameObject#displayList` property.
     *
     * If a Game Object isn't on any Display List, it will not be rendered. If you just wish to temporarly
     * disable it from rendering, consider using the `setVisible` method, instead.
     *
     * @method Phaser.GameObjects.GameObject#removeFromDisplayList
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.53.0
     *
     * @return {this} This Game Object.
     */ removeFromDisplayList: function() {
                        var displayList = this.displayList || this.scene.sys.displayList;
                        if (displayList && displayList.exists(this)) {
                            displayList.remove(this, true);
                            displayList.queueDepthSort();
                            this.displayList = null;
                            this.emit(Events.REMOVED_FROM_SCENE, this, this.scene);
                            displayList.events.emit(SceneEvents.REMOVED_FROM_SCENE, this, this.scene);
                        }
                        return this;
                    },
                    /**
     * Removes this Game Object from the Scene's Update List.
     *
     * When a Game Object is on the Update List, it will have its `preUpdate` method called
     * every game frame. Calling this method will remove it from the list, preventing this.
     *
     * Removing a Game Object from the Update List will stop most internal functions working.
     * For example, removing a Sprite from the Update List will prevent it from being able to
     * run animations.
     *
     * @method Phaser.GameObjects.GameObject#removeFromUpdateList
     * @since 3.53.0
     *
     * @return {this} This Game Object.
     */ removeFromUpdateList: function() {
                        if (this.scene && this.preUpdate) this.scene.sys.updateList.remove(this);
                        return this;
                    },
                    /**
     * Returns a reference to the underlying display list _array_ that contains this Game Object,
     * which will be either the Scene's Display List or the internal list belonging
     * to its parent Container, if it has one.
     * 
     * If this Game Object is not on a display list or in a container, it will return `null`.
     * 
     * You should be very careful with this method, and understand that it returns a direct reference to the
     * internal array used by the Display List. Mutating this array directly can cause all kinds of subtle
     * and difficult to debug issues in your game.
     *
     * @method Phaser.GameObjects.GameObject#getDisplayList
     * @since 3.85.0
     *
     * @return {?Phaser.GameObjects.GameObject[]} The internal Display List array of Game Objects, or `null`.
     */ getDisplayList: function() {
                        var list = null;
                        if (this.parentContainer) list = this.parentContainer.list;
                        else if (this.displayList) list = this.displayList.list;
                        return list;
                    },
                    /**
     * Destroys this Game Object removing it from the Display List and Update List and
     * severing all ties to parent resources.
     *
     * Also removes itself from the Input Manager and Physics Manager if previously enabled.
     *
     * Use this to remove a Game Object from your game if you don't ever plan to use it again.
     * As long as no reference to it exists within your own code it should become free for
     * garbage collection by the browser.
     *
     * If you just want to temporarily disable an object then look at using the
     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
     *
     * @method Phaser.GameObjects.GameObject#destroy
     * @fires Phaser.GameObjects.Events#DESTROY
     * @since 3.0.0
     *
     * @param {boolean} [fromScene=false] - `True` if this Game Object is being destroyed by the Scene, `false` if not.
     */ destroy: function(fromScene) {
                        //  This Game Object has already been destroyed
                        if (!this.scene || this.ignoreDestroy) return;
                        if (fromScene === undefined) fromScene = false;
                        if (this.preDestroy) this.preDestroy.call(this);
                        this.emit(Events.DESTROY, this, fromScene);
                        this.removeAllListeners();
                        if (this.postPipelines) this.resetPostPipeline(true);
                        this.removeFromDisplayList();
                        this.removeFromUpdateList();
                        if (this.input) {
                            this.scene.sys.input.clear(this);
                            this.input = undefined;
                        }
                        if (this.data) {
                            this.data.destroy();
                            this.data = undefined;
                        }
                        if (this.body) {
                            this.body.destroy();
                            this.body = undefined;
                        }
                        if (this.preFX) {
                            this.preFX.destroy();
                            this.preFX = undefined;
                        }
                        if (this.postFX) {
                            this.postFX.destroy();
                            this.postFX = undefined;
                        }
                        this.active = false;
                        this.visible = false;
                        this.scene = undefined;
                        this.parentContainer = undefined;
                    }
                });
                /**
 * The bitmask that `GameObject.renderFlags` is compared against to determine if the Game Object will render or not.
 *
 * @constant {number} RENDER_MASK
 * @memberof Phaser.GameObjects.GameObject
 * @default
 */ GameObject.RENDER_MASK = 15;
                module1.exports = GameObject;
            /***/ },
            /***/ 44603: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * The Game Object Creator is a Scene plugin that allows you to quickly create many common
 * types of Game Objects and return them using a configuration object, rather than
 * having to specify a limited set of parameters such as with the GameObjectFactory.
 *
 * Game Objects made via this class are automatically added to the Scene and Update List
 * unless you explicitly set the `add` property in the configuration object to `false`.
 *
 * @class GameObjectCreator
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
 */ var GameObjectCreator = new Class({
                    initialize: function GameObjectCreator(scene) {
                        /**
         * The Scene to which this Game Object Creator belongs.
         *
         * @name Phaser.GameObjects.GameObjectCreator#scene
         * @type {Phaser.Scene}
         * @protected
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene.Systems.
         *
         * @name Phaser.GameObjects.GameObjectCreator#systems
         * @type {Phaser.Scenes.Systems}
         * @protected
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.GameObjectCreator#events
         * @type {Phaser.Events.EventEmitter}
         * @protected
         * @since 3.50.0
         */ this.events = scene.sys.events;
                        /**
         * A reference to the Scene Display List.
         *
         * @name Phaser.GameObjects.GameObjectCreator#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @protected
         * @since 3.0.0
         */ this.displayList;
                        /**
         * A reference to the Scene Update List.
         *
         * @name Phaser.GameObjects.GameObjectCreator#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @protected
         * @since 3.0.0
         */ this.updateList;
                        this.events.once(SceneEvents.BOOT, this.boot, this);
                        this.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectCreator#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.displayList = this.systems.displayList;
                        this.updateList = this.systems.updateList;
                        this.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectCreator#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.GameObjectCreator#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.GameObjectCreator#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                        this.events = null;
                        this.displayList = null;
                        this.updateList = null;
                    }
                });
                /**
 * Static method called directly by the Game Object creator functions.
 * With this method you can register a custom GameObject factory in the GameObjectCreator,
 * providing a name (`factoryType`) and the constructor (`factoryFunction`) in order
 * to be called when you invoke Phaser.Scene.make[ factoryType ] method.
 *
 * @method Phaser.GameObjects.GameObjectCreator.register
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you will use to call to Phaser.Scene.make[ factoryType ] method.
 * @param {function} factoryFunction - The constructor function to be called when you invoke to the Phaser.Scene.make method.
 */ GameObjectCreator.register = function(factoryType, factoryFunction) {
                    if (!GameObjectCreator.prototype.hasOwnProperty(factoryType)) GameObjectCreator.prototype[factoryType] = factoryFunction;
                };
                /**
 * Static method called directly by the Game Object Creator functions.
 *
 * With this method you can remove a custom Game Object Creator that has been previously
 * registered in the Game Object Creator. Pass in its `factoryType` in order to remove it.
 *
 * @method Phaser.GameObjects.GameObjectCreator.remove
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you want to remove from the GameObjectCreator.
 */ GameObjectCreator.remove = function(factoryType) {
                    if (GameObjectCreator.prototype.hasOwnProperty(factoryType)) delete GameObjectCreator.prototype[factoryType];
                };
                PluginCache.register('GameObjectCreator', GameObjectCreator, 'make');
                module1.exports = GameObjectCreator;
            /***/ },
            /***/ 39429: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * The Game Object Factory is a Scene plugin that allows you to quickly create many common
 * types of Game Objects and have them automatically registered with the Scene.
 *
 * Game Objects directly register themselves with the Factory and inject their own creation
 * methods into the class.
 *
 * @class GameObjectFactory
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
 */ var GameObjectFactory = new Class({
                    initialize: function GameObjectFactory(scene) {
                        /**
         * The Scene to which this Game Object Factory belongs.
         *
         * @name Phaser.GameObjects.GameObjectFactory#scene
         * @type {Phaser.Scene}
         * @protected
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene.Systems.
         *
         * @name Phaser.GameObjects.GameObjectFactory#systems
         * @type {Phaser.Scenes.Systems}
         * @protected
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.GameObjectFactory#events
         * @type {Phaser.Events.EventEmitter}
         * @protected
         * @since 3.50.0
         */ this.events = scene.sys.events;
                        /**
         * A reference to the Scene Display List.
         *
         * @name Phaser.GameObjects.GameObjectFactory#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @protected
         * @since 3.0.0
         */ this.displayList;
                        /**
         * A reference to the Scene Update List.
         *
         * @name Phaser.GameObjects.GameObjectFactory#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @protected
         * @since 3.0.0
         */ this.updateList;
                        this.events.once(SceneEvents.BOOT, this.boot, this);
                        this.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectFactory#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.displayList = this.systems.displayList;
                        this.updateList = this.systems.updateList;
                        this.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectFactory#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Adds an existing Game Object to this Scene.
     *
     * If the Game Object renders, it will be added to the Display List.
     * If it has a `preUpdate` method, it will be added to the Update List.
     *
     * @method Phaser.GameObjects.GameObjectFactory#existing
     * @since 3.0.0
     *
     * @generic {(Phaser.GameObjects.GameObject|Phaser.GameObjects.Group|Phaser.GameObjects.Layer)} G - [child,$return]
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.Group|Phaser.GameObjects.Layer)} child - The child to be added to this Scene.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that was added.
     */ existing: function(child) {
                        if (child.renderCanvas || child.renderWebGL) this.displayList.add(child);
                        //  For when custom objects have overridden `preUpdate` but don't hook into the ADDED_TO_SCENE event:
                        //  Adding to the list multiple times is safe, as it won't add duplicates into the list anyway.
                        if (child.preUpdate) this.updateList.add(child);
                        return child;
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.GameObjectFactory#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.GameObjectFactory#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                        this.events = null;
                        this.displayList = null;
                        this.updateList = null;
                    }
                });
                /**
 * Static method called directly by the Game Object factory functions.
 * With this method you can register a custom GameObject factory in the GameObjectFactory,
 * providing a name (`factoryType`) and the constructor (`factoryFunction`) in order
 * to be called when you call to Phaser.Scene.add[ factoryType ] method.
 *
 * @method Phaser.GameObjects.GameObjectFactory.register
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you will use to call to Phaser.Scene.add[ factoryType ] method.
 * @param {function} factoryFunction - The constructor function to be called when you invoke to the Phaser.Scene.add method.
 */ GameObjectFactory.register = function(factoryType, factoryFunction) {
                    if (!GameObjectFactory.prototype.hasOwnProperty(factoryType)) GameObjectFactory.prototype[factoryType] = factoryFunction;
                };
                /**
 * Static method called directly by the Game Object factory functions.
 * With this method you can remove a custom GameObject factory registered in the GameObjectFactory,
 * providing a its `factoryType`.
 *
 * @method Phaser.GameObjects.GameObjectFactory.remove
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you want to remove from the GameObjectFactory.
 */ GameObjectFactory.remove = function(factoryType) {
                    if (GameObjectFactory.prototype.hasOwnProperty(factoryType)) delete GameObjectFactory.prototype[factoryType];
                };
                PluginCache.register('GameObjectFactory', GameObjectFactory, 'add');
                module1.exports = GameObjectFactory;
            /***/ },
            /***/ 91296: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(61340);
                var tempMatrix1 = new TransformMatrix();
                var tempMatrix2 = new TransformMatrix();
                var tempMatrix3 = new TransformMatrix();
                var result = {
                    camera: tempMatrix1,
                    sprite: tempMatrix2,
                    calc: tempMatrix3
                };
                /**
 * Calculates the Transform Matrix of the given Game Object and Camera, factoring in
 * the parent matrix if provided.
 *
 * Note that the object this results contains _references_ to the Transform Matrices,
 * not new instances of them. Therefore, you should use their values immediately, or
 * copy them to your own matrix, as they will be replaced as soon as another Game
 * Object is rendered.
 *
 * @function Phaser.GameObjects.GetCalcMatrix
 * @memberof Phaser.GameObjects
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} src - The Game Object to calculate the transform matrix for.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera being used to render the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - The transform matrix of the parent container, if any.
 *
 * @return {Phaser.Types.GameObjects.GetCalcMatrixResults} The results object containing the updated transform matrices.
 */ var GetCalcMatrix = function(src, camera, parentMatrix) {
                    var camMatrix = tempMatrix1;
                    var spriteMatrix = tempMatrix2;
                    var calcMatrix = tempMatrix3;
                    spriteMatrix.applyITRS(src.x, src.y, src.rotation, src.scaleX, src.scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    if (parentMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                        //  Undo the camera scroll
                        spriteMatrix.e = src.x;
                        spriteMatrix.f = src.y;
                    } else {
                        spriteMatrix.e -= camera.scrollX * src.scrollFactorX;
                        spriteMatrix.f -= camera.scrollY * src.scrollFactorY;
                    }
                    //  Multiply by the Sprite matrix, store result in calcMatrix
                    camMatrix.multiply(spriteMatrix, calcMatrix);
                    return result;
                };
                module1.exports = GetCalcMatrix;
            /***/ },
            /***/ 45027: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var ProcessQueue = __webpack_require__(25774);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * The Update List plugin.
 *
 * Update Lists belong to a Scene and maintain the list Game Objects to be updated every frame.
 *
 * Some or all of these Game Objects may also be part of the Scene's [Display List]{@link Phaser.GameObjects.DisplayList}, for Rendering.
 *
 * @class UpdateList
 * @extends Phaser.Structs.ProcessQueue.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that the Update List belongs to.
 */ var UpdateList = new Class({
                    Extends: ProcessQueue,
                    initialize: function UpdateList(scene) {
                        ProcessQueue.call(this);
                        //  No duplicates in this list
                        this.checkQueue = true;
                        /**
         * The Scene that the Update List belongs to.
         *
         * @name Phaser.GameObjects.UpdateList#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * The Scene's Systems.
         *
         * @name Phaser.GameObjects.UpdateList#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * The `pending` list is a selection of items which are due to be made 'active' in the next update.
         *
         * @name Phaser.GameObjects.UpdateList#_pending
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The `active` list is a selection of items which are considered active and should be updated.
         *
         * @name Phaser.GameObjects.UpdateList#_active
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
         *
         * @name Phaser.GameObjects.UpdateList#_destroy
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The total number of items awaiting processing.
         *
         * @name Phaser.GameObjects.UpdateList#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.UpdateList#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.UpdateList#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        var eventEmitter = this.systems.events;
                        eventEmitter.on(SceneEvents.PRE_UPDATE, this.update, this);
                        eventEmitter.on(SceneEvents.UPDATE, this.sceneUpdate, this);
                        eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The update step.
     *
     * Pre-updates every active Game Object in the list.
     *
     * @method Phaser.GameObjects.UpdateList#sceneUpdate
     * @since 3.20.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ sceneUpdate: function(time, delta) {
                        var list = this._active;
                        var length = list.length;
                        for(var i = 0; i < length; i++){
                            var gameObject = list[i];
                            if (gameObject.active) gameObject.preUpdate.call(gameObject, time, delta);
                        }
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.UpdateList#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        var i = this._active.length;
                        while(i--)this._active[i].destroy(true);
                        i = this._pending.length;
                        while(i--)this._pending[i].destroy(true);
                        i = this._destroy.length;
                        while(i--)this._destroy[i].destroy(true);
                        this._toProcess = 0;
                        this._pending = [];
                        this._active = [];
                        this._destroy = [];
                        this.removeAllListeners();
                        var eventEmitter = this.systems.events;
                        eventEmitter.off(SceneEvents.PRE_UPDATE, this.update, this);
                        eventEmitter.off(SceneEvents.UPDATE, this.sceneUpdate, this);
                        eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     *
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.UpdateList#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.systems.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                    }
                });
                PluginCache.register('UpdateList', UpdateList, 'updateList');
                module1.exports = UpdateList;
            /***/ },
            /***/ 3217: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders one character of the Bitmap Text to the WebGL Pipeline.
 *
 * @function BatchChar
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGLPipeline. Must have a `batchQuad` method.
 * @param {Phaser.GameObjects.BitmapText} src - The BitmapText Game Object.
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextCharacter} char - The character to render.
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapFontCharacterData} glyph - The character glyph.
 * @param {number} offsetX - The x offset.
 * @param {number} offsetY - The y offset.
 * @param {Phaser.GameObjects.Components.TransformMatrix} calcMatrix - The transform matrix.
 * @param {boolean} roundPixels - Round the transform values or not?
 * @param {number} tintTL - Top-left tint value.
 * @param {number} tintTR - Top-right tint value.
 * @param {number} tintBL - Bottom-left tint value.
 * @param {number} tintBR - Bottom-right tint value.
 * @param {number} tintEffect - The tint effect mode.
 * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - The texture.
 * @param {number} textureUnit - The texture unit.
 */ var BatchChar = function(pipeline, src, char, glyph, offsetX, offsetY, calcMatrix, roundPixels, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit) {
                    var x = char.x - src.displayOriginX + offsetX;
                    var y = char.y - src.displayOriginY + offsetY;
                    var xw = x + char.w;
                    var yh = y + char.h;
                    var a = calcMatrix.a;
                    var b = calcMatrix.b;
                    var c = calcMatrix.c;
                    var d = calcMatrix.d;
                    var e = calcMatrix.e;
                    var f = calcMatrix.f;
                    var tx0 = x * a + y * c + e;
                    var ty0 = x * b + y * d + f;
                    var tx1 = x * a + yh * c + e;
                    var ty1 = x * b + yh * d + f;
                    var tx2 = xw * a + yh * c + e;
                    var ty2 = xw * b + yh * d + f;
                    var tx3 = xw * a + y * c + e;
                    var ty3 = xw * b + y * d + f;
                    if (roundPixels) {
                        tx0 = Math.round(tx0);
                        ty0 = Math.round(ty0);
                        tx1 = Math.round(tx1);
                        ty1 = Math.round(ty1);
                        tx2 = Math.round(tx2);
                        ty2 = Math.round(ty2);
                        tx3 = Math.round(tx3);
                        ty3 = Math.round(ty3);
                    }
                    pipeline.batchQuad(src, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, glyph.u0, glyph.v0, glyph.u1, glyph.v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                };
                module1.exports = BatchChar;
            /***/ },
            /***/ 53048: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the full bounds, in local and world space, of a BitmapText Game Object.
 *
 * Returns a BitmapTextSize object that contains global and local variants of the Game Objects x and y coordinates and
 * its width and height. Also includes an array of the line lengths and all word positions.
 *
 * The global position and size take into account the Game Object's position and scale.
 *
 * The local position and size just takes into account the font data.
 *
 * @function GetBitmapTextSize
 * @since 3.0.0
 * @private
 *
 * @param {(Phaser.GameObjects.DynamicBitmapText|Phaser.GameObjects.BitmapText)} src - The BitmapText to calculate the bounds values for.
 * @param {boolean} [round=false] - Whether to round the positions to the nearest integer.
 * @param {boolean} [updateOrigin=false] - Whether to update the origin of the BitmapText after bounds calculations?
 * @param {object} [out] - Object to store the results in, to save constant object creation. If not provided an empty object is returned.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextSize} The calculated bounds values of the BitmapText.
 */ var GetBitmapTextSize = function(src, round, updateOrigin, out) {
                    if (updateOrigin === undefined) updateOrigin = false;
                    if (out === undefined) {
                        out = {
                            local: {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            },
                            global: {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            },
                            lines: {
                                shortest: 0,
                                longest: 0,
                                lengths: null,
                                height: 0
                            },
                            wrappedText: '',
                            words: [],
                            characters: [],
                            scaleX: 0,
                            scaleY: 0
                        };
                        return out;
                    }
                    var text = src.text;
                    var textLength = text.length;
                    var maxWidth = src.maxWidth;
                    var wordWrapCharCode = src.wordWrapCharCode;
                    var bx = Number.MAX_VALUE;
                    var by = Number.MAX_VALUE;
                    var bw = 0;
                    var bh = 0;
                    var chars = src.fontData.chars;
                    var lineHeight = src.fontData.lineHeight;
                    var letterSpacing = src.letterSpacing;
                    var lineSpacing = src.lineSpacing;
                    var xAdvance = 0;
                    var yAdvance = 0;
                    var charCode = 0;
                    var glyph = null;
                    var align = src._align;
                    var x = 0;
                    var y = 0;
                    var scale = src.fontSize / src.fontData.size;
                    var sx = scale * src.scaleX;
                    var sy = scale * src.scaleY;
                    var lastGlyph = null;
                    var lastCharCode = 0;
                    var lineWidths = [];
                    var shortestLine = Number.MAX_VALUE;
                    var longestLine = 0;
                    var currentLine = 0;
                    var currentLineWidth = 0;
                    var i;
                    var j;
                    var lines;
                    var words = [];
                    var characters = [];
                    var current = null;
                    // Measure the width of the text
                    var measureTextWidth = function(text, fontData) {
                        var width = 0;
                        for(var i = 0; i < text.length; i++){
                            var charCode = text.charCodeAt(i);
                            var glyph = fontData.chars[charCode];
                            if (glyph) width += glyph.xAdvance;
                        }
                        return width * sx;
                    };
                    //  Scan for breach of maxWidth and insert carriage-returns
                    if (maxWidth > 0) {
                        // Split the text into lines
                        lines = text.split('\n');
                        var wrappedLines = [];
                        // Loop through each line
                        for(i = 0; i < lines.length; i++){
                            var line = lines[i];
                            var word = '';
                            var wrappedLine = '';
                            var lineToCheck = '';
                            var lineWithWord = '';
                            // Loop through each character in a line
                            for(j = 0; j < line.length; j++){
                                charCode = line.charCodeAt(j);
                                word += line[j];
                                // White space or end of line?
                                if (charCode === wordWrapCharCode || j === line.length - 1) {
                                    lineWithWord = lineToCheck + word;
                                    var textWidth = measureTextWidth(lineWithWord, src.fontData);
                                    if (textWidth <= maxWidth) lineToCheck = lineWithWord;
                                    else {
                                        // If the current word is too long to fit on a line, wrap it
                                        // Remove trailing word wrap char to keep text length the same
                                        wrappedLine = wrappedLine.slice(0, -1);
                                        wrappedLine += (wrappedLine ? '\n' : '') + lineToCheck;
                                        lineToCheck = word;
                                    }
                                    word = '';
                                }
                            }
                            wrappedLine = wrappedLine.slice(0, -1);
                            wrappedLine += (wrappedLine ? '\n' : '') + lineToCheck;
                            wrappedLines.push(wrappedLine);
                        }
                        text = wrappedLines.join('\n');
                        out.wrappedText = text;
                        textLength = text.length;
                    }
                    var charIndex = 0;
                    for(i = 0; i < textLength; i++){
                        charCode = text.charCodeAt(i);
                        if (charCode === 10) {
                            if (current !== null) {
                                words.push({
                                    word: current.word,
                                    i: current.i,
                                    x: current.x * sx,
                                    y: current.y * sy,
                                    w: current.w * sx,
                                    h: current.h * sy
                                });
                                current = null;
                            }
                            lastGlyph = null;
                            lineWidths[currentLine] = currentLineWidth;
                            if (currentLineWidth > longestLine) longestLine = currentLineWidth;
                            if (currentLineWidth < shortestLine) shortestLine = currentLineWidth;
                            currentLine++;
                            currentLineWidth = 0;
                            xAdvance = 0;
                            yAdvance = (lineHeight + lineSpacing) * currentLine;
                            continue;
                        }
                        glyph = chars[charCode];
                        if (!glyph) continue;
                        x = xAdvance;
                        y = yAdvance;
                        if (lastGlyph !== null) {
                            var kerningOffset = glyph.kerning[lastCharCode];
                            x += kerningOffset !== undefined ? kerningOffset : 0;
                        }
                        if (bx > x) bx = x;
                        if (by > y) by = y;
                        var gw = x + glyph.xAdvance;
                        var gh = y + lineHeight;
                        if (bw < gw) bw = gw;
                        if (bh < gh) bh = gh;
                        var charWidth = glyph.xOffset + glyph.xAdvance + (kerningOffset !== undefined ? kerningOffset : 0);
                        if (charCode === wordWrapCharCode) {
                            if (current !== null) {
                                words.push({
                                    word: current.word,
                                    i: current.i,
                                    x: current.x * sx,
                                    y: current.y * sy,
                                    w: current.w * sx,
                                    h: current.h * sy
                                });
                                current = null;
                            }
                        } else {
                            if (current === null) //  We're starting a new word, recording the starting index, etc
                            current = {
                                word: '',
                                i: charIndex,
                                x: xAdvance,
                                y: yAdvance,
                                w: 0,
                                h: lineHeight
                            };
                            current.word = current.word.concat(text[i]);
                            current.w += charWidth;
                        }
                        characters.push({
                            i: charIndex,
                            idx: i,
                            char: text[i],
                            code: charCode,
                            x: (glyph.xOffset + x) * scale,
                            y: (glyph.yOffset + yAdvance) * scale,
                            w: glyph.width * scale,
                            h: glyph.height * scale,
                            t: yAdvance * scale,
                            r: gw * scale,
                            b: lineHeight * scale,
                            line: currentLine,
                            glyph: glyph
                        });
                        xAdvance += glyph.xAdvance + letterSpacing + (kerningOffset !== undefined ? kerningOffset : 0);
                        lastGlyph = glyph;
                        lastCharCode = charCode;
                        currentLineWidth = gw * scale;
                        charIndex++;
                    }
                    //  Last word
                    if (current !== null) words.push({
                        word: current.word,
                        i: current.i,
                        x: current.x * sx,
                        y: current.y * sy,
                        w: current.w * sx,
                        h: current.h * sy
                    });
                    lineWidths[currentLine] = currentLineWidth;
                    if (currentLineWidth > longestLine) longestLine = currentLineWidth;
                    if (currentLineWidth < shortestLine) shortestLine = currentLineWidth;
                    //  Adjust all of the character positions based on alignment
                    if (align > 0) for(var c = 0; c < characters.length; c++){
                        var currentChar = characters[c];
                        if (align === 1) {
                            var ax1 = (longestLine - lineWidths[currentChar.line]) / 2;
                            currentChar.x += ax1;
                            currentChar.r += ax1;
                        } else if (align === 2) {
                            var ax2 = longestLine - lineWidths[currentChar.line];
                            currentChar.x += ax2;
                            currentChar.r += ax2;
                        }
                    }
                    var local = out.local;
                    var global = out.global;
                    lines = out.lines;
                    local.x = bx * scale;
                    local.y = by * scale;
                    local.width = bw * scale;
                    local.height = bh * scale;
                    global.x = src.x - src._displayOriginX + bx * sx;
                    global.y = src.y - src._displayOriginY + by * sy;
                    global.width = bw * sx;
                    global.height = bh * sy;
                    lines.shortest = shortestLine;
                    lines.longest = longestLine;
                    lines.lengths = lineWidths;
                    if (round) {
                        local.x = Math.ceil(local.x);
                        local.y = Math.ceil(local.y);
                        local.width = Math.ceil(local.width);
                        local.height = Math.ceil(local.height);
                        global.x = Math.ceil(global.x);
                        global.y = Math.ceil(global.y);
                        global.width = Math.ceil(global.width);
                        global.height = Math.ceil(global.height);
                        lines.shortest = Math.ceil(shortestLine);
                        lines.longest = Math.ceil(longestLine);
                    }
                    if (updateOrigin) {
                        src._displayOriginX = src.originX * local.width;
                        src._displayOriginY = src.originY * local.height;
                        global.x = src.x - src._displayOriginX * src.scaleX;
                        global.y = src.y - src._displayOriginY * src.scaleY;
                        if (round) {
                            global.x = Math.ceil(global.x);
                            global.y = Math.ceil(global.y);
                        }
                    }
                    out.words = words;
                    out.characters = characters;
                    out.lines.height = lineHeight;
                    out.scale = scale;
                    out.scaleX = src.scaleX;
                    out.scaleY = src.scaleY;
                    return out;
                };
                module1.exports = GetBitmapTextSize;
            /***/ },
            /***/ 61327: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ParseXMLBitmapFont = __webpack_require__(21859);
                /**
 * Parse an XML Bitmap Font from an Atlas.
 *
 * Adds the parsed Bitmap Font data to the cache with the `fontName` key.
 *
 * @function ParseFromAtlas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Scene} scene - The Scene to parse the Bitmap Font for.
 * @param {string} fontName - The key of the font to add to the Bitmap Font cache.
 * @param {string} textureKey - The key of the BitmapFont's texture.
 * @param {string} frameKey - The key of the BitmapFont texture's frame.
 * @param {string} xmlKey - The key of the XML data of the font to parse.
 * @param {number} [xSpacing] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing] - The y-axis spacing to add to the line height.
 *
 * @return {boolean} Whether the parsing was successful or not.
 */ var ParseFromAtlas = function(scene, fontName, textureKey, frameKey, xmlKey, xSpacing, ySpacing) {
                    var texture = scene.sys.textures.get(textureKey);
                    var frame = texture.get(frameKey);
                    var xml = scene.sys.cache.xml.get(xmlKey);
                    if (frame && xml) {
                        var data = ParseXMLBitmapFont(xml, frame, xSpacing, ySpacing, texture);
                        scene.sys.cache.bitmapFont.add(fontName, {
                            data: data,
                            texture: textureKey,
                            frame: frameKey,
                            fromAtlas: true
                        });
                        return true;
                    } else return false;
                };
                module1.exports = ParseFromAtlas;
            /***/ },
            /***/ 6925: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(35154);
                /**
 * Parses a Retro Font configuration object so you can pass it to the BitmapText constructor
 * and create a BitmapText object using a fixed-width retro font.
 *
 * @function Phaser.GameObjects.RetroFont.Parse
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Phaser Scene.
 * @param {Phaser.Types.GameObjects.BitmapText.RetroFontConfig} config - The font configuration object.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapFontData} A parsed Bitmap Font data entry for the Bitmap Font cache.
 */ var ParseRetroFont = function(scene, config) {
                    var w = config.width;
                    var h = config.height;
                    var cx = Math.floor(w / 2);
                    var cy = Math.floor(h / 2);
                    var letters = GetValue(config, 'chars', '');
                    if (letters === '') return;
                    var key = GetValue(config, 'image', '');
                    var frame = scene.sys.textures.getFrame(key);
                    var textureX = frame.cutX;
                    var textureY = frame.cutY;
                    var textureWidth = frame.source.width;
                    var textureHeight = frame.source.height;
                    var offsetX = GetValue(config, 'offset.x', 0);
                    var offsetY = GetValue(config, 'offset.y', 0);
                    var spacingX = GetValue(config, 'spacing.x', 0);
                    var spacingY = GetValue(config, 'spacing.y', 0);
                    var lineSpacing = GetValue(config, 'lineSpacing', 0);
                    var charsPerRow = GetValue(config, 'charsPerRow', null);
                    if (charsPerRow === null) {
                        charsPerRow = textureWidth / w;
                        if (charsPerRow > letters.length) charsPerRow = letters.length;
                    }
                    var x = offsetX;
                    var y = offsetY;
                    var data = {
                        retroFont: true,
                        font: key,
                        size: w,
                        lineHeight: h + lineSpacing,
                        chars: {}
                    };
                    var r = 0;
                    for(var i = 0; i < letters.length; i++){
                        var charCode = letters.charCodeAt(i);
                        var u0 = (textureX + x) / textureWidth;
                        var v0 = (textureY + y) / textureHeight;
                        var u1 = (textureX + x + w) / textureWidth;
                        var v1 = (textureY + y + h) / textureHeight;
                        data.chars[charCode] = {
                            x: x,
                            y: y,
                            width: w,
                            height: h,
                            centerX: cx,
                            centerY: cy,
                            xOffset: 0,
                            yOffset: 0,
                            xAdvance: w,
                            data: {},
                            kerning: {},
                            u0: u0,
                            v0: v0,
                            u1: u1,
                            v1: v1
                        };
                        r++;
                        if (r === charsPerRow) {
                            r = 0;
                            x = offsetX;
                            y += h + spacingY;
                        } else x += w + spacingX;
                    }
                    var entry = {
                        data: data,
                        frame: null,
                        texture: key
                    };
                    return entry;
                };
                module1.exports = ParseRetroFont;
            /***/ },
            /***/ 21859: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Read an integer value from an XML Node.
 *
 * @function getValue
 * @since 3.0.0
 * @private
 *
 * @param {Node} node - The XML Node.
 * @param {string} attribute - The attribute to read.
 *
 * @return {number} The parsed value.
 */ function getValue(node, attribute) {
                    return parseInt(node.getAttribute(attribute), 10);
                }
                /**
 * Parse an XML font to Bitmap Font data for the Bitmap Font cache.
 *
 * @function ParseXMLBitmapFont
 * @since 3.0.0
 * @private
 *
 * @param {XMLDocument} xml - The XML Document to parse the font from.
 * @param {Phaser.Textures.Frame} frame - The texture frame to take into account when creating the uv data.
 * @param {number} [xSpacing=0] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing=0] - The y-axis spacing to add to the line height.
 * @param {Phaser.Textures.Texture} [texture] - If provided, each glyph in the Bitmap Font will be added to this texture as a frame.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapFontData} The parsed Bitmap Font data.
 */ var ParseXMLBitmapFont = function(xml, frame, xSpacing, ySpacing, texture) {
                    if (xSpacing === undefined) xSpacing = 0;
                    if (ySpacing === undefined) ySpacing = 0;
                    var textureX = frame.cutX;
                    var textureY = frame.cutY;
                    var textureWidth = frame.source.width;
                    var textureHeight = frame.source.height;
                    var sourceIndex = frame.sourceIndex;
                    var data = {};
                    var info = xml.getElementsByTagName('info')[0];
                    var common = xml.getElementsByTagName('common')[0];
                    data.font = info.getAttribute('face');
                    data.size = getValue(info, 'size');
                    data.lineHeight = getValue(common, 'lineHeight') + ySpacing;
                    data.chars = {};
                    var letters = xml.getElementsByTagName('char');
                    var adjustForTrim = frame !== undefined && frame.trimmed;
                    if (adjustForTrim) {
                        var top = frame.height;
                        var left = frame.width;
                    }
                    for(var i = 0; i < letters.length; i++){
                        var node = letters[i];
                        var charCode = getValue(node, 'id');
                        var letter = String.fromCharCode(charCode);
                        var gx = getValue(node, 'x');
                        var gy = getValue(node, 'y');
                        var gw = getValue(node, 'width');
                        var gh = getValue(node, 'height');
                        //  Handle frame trim issues
                        if (adjustForTrim) {
                            if (gx < left) left = gx;
                            if (gy < top) top = gy;
                        }
                        if (adjustForTrim && top !== 0 && left !== 0) {
                            //  Now we know the top and left coordinates of the glyphs in the original data
                            //  so we can work out how much to adjust the glyphs by
                            gx -= frame.x;
                            gy -= frame.y;
                        }
                        var u0 = (textureX + gx) / textureWidth;
                        var v0 = (textureY + gy) / textureHeight;
                        var u1 = (textureX + gx + gw) / textureWidth;
                        var v1 = (textureY + gy + gh) / textureHeight;
                        data.chars[charCode] = {
                            x: gx,
                            y: gy,
                            width: gw,
                            height: gh,
                            centerX: Math.floor(gw / 2),
                            centerY: Math.floor(gh / 2),
                            xOffset: getValue(node, 'xoffset'),
                            yOffset: getValue(node, 'yoffset'),
                            xAdvance: getValue(node, 'xadvance') + xSpacing,
                            data: {},
                            kerning: {},
                            u0: u0,
                            v0: v0,
                            u1: u1,
                            v1: v1
                        };
                        if (texture && gw !== 0 && gh !== 0) {
                            var charFrame = texture.add(letter, sourceIndex, gx, gy, gw, gh);
                            if (charFrame) charFrame.setUVs(gw, gh, u0, v0, u1, v1);
                        }
                    }
                    var kernings = xml.getElementsByTagName('kerning');
                    for(i = 0; i < kernings.length; i++){
                        var kern = kernings[i];
                        var first = getValue(kern, 'first');
                        var second = getValue(kern, 'second');
                        var amount = getValue(kern, 'amount');
                        data.chars[second].kerning[first] = amount;
                    }
                    return data;
                };
                module1.exports = ParseXMLBitmapFont;
            /***/ },
            /***/ 196: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RETRO_FONT_CONST = __webpack_require__(87662);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.GameObjects.RetroFont
 * @since 3.6.0
 */ var RetroFont = {
                    Parse: __webpack_require__(6925)
                };
                //   Merge in the consts
                RetroFont = Extend(false, RetroFont, RETRO_FONT_CONST);
                module1.exports = RetroFont;
            /***/ },
            /***/ 87662: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RETRO_FONT_CONST = {
                    /**
     * Text Set 1 =  !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET1
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET1: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~',
                    /**
     * Text Set 2 =  !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET2
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET2: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                    /**
     * Text Set 3 = ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET3
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET3: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ',
                    /**
     * Text Set 4 = ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET4
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET4: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789',
                    /**
     * Text Set 5 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET5
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET5: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() \'!?-*:0123456789',
                    /**
     * Text Set 6 = ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.' 
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET6
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET6: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.\' ',
                    /**
     * Text Set 7 = AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-'39
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET7
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET7: 'AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-\'39',
                    /**
     * Text Set 8 = 0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET8
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET8: '0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                    /**
     * Text Set 9 = ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'"?!
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET9
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET9: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,\'"?!',
                    /**
     * Text Set 10 = ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET10
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET10: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                    /**
     * Text Set 11 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()':;0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET11
     * @since 3.6.0
     * @type {string}
     */ TEXT_SET11: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()\':;0123456789'
                };
                module1.exports = RETRO_FONT_CONST;
            /***/ },
            /***/ 2638: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(22186);
                var Class = __webpack_require__(83419);
                var Render = __webpack_require__(12310);
                /**
 * @classdesc
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 *
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 *
 * Dynamic Bitmap Text objects are different from Static Bitmap Text in that they invoke a callback for each
 * letter being rendered during the render pass. This callback allows you to manipulate the properties of
 * each letter being rendered, such as its position, scale or tint, allowing you to create interesting effects
 * like jiggling text, which can't be done with Static text. This means that Dynamic Text takes more processing
 * time, so only use them if you require the callback ability they have.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): {@link http://www.angelcode.com/products/bmfont/|http://www.angelcode.com/products/bmfont/}
 * Glyph Designer (OS X, commercial): {@link http://www.71squared.com/en/glyphdesigner|http://www.71squared.com/en/glyphdesigner}
 * Snow BMF (Web-based, free): {@link https://snowb.org//|https://snowb.org/}
 * Littera (Flash-based, free): {@link http://kvazars.com/littera/|http://kvazars.com/littera/}
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: {@link http://codebeautify.org/xmltojson|http://codebeautify.org/xmltojson}
 *
 * @class DynamicBitmapText
 * @extends Phaser.GameObjects.BitmapText
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} x - The x coordinate of this Game Object in world space.
 * @param {number} y - The y coordinate of this Game Object in world space.
 * @param {string} font - The key of the font to use from the Bitmap Font cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size of this Bitmap Text.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 */ var DynamicBitmapText = new Class({
                    Extends: BitmapText,
                    Mixins: [
                        Render
                    ],
                    initialize: function DynamicBitmapText(scene, x, y, font, text, size, align) {
                        BitmapText.call(this, scene, x, y, font, text, size, align);
                        this.type = 'DynamicBitmapText';
                        /**
         * The horizontal scroll position of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#scrollX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.scrollX = 0;
                        /**
         * The vertical scroll position of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#scrollY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.scrollY = 0;
                        /**
         * The crop width of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#cropWidth
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cropWidth = 0;
                        /**
         * The crop height of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#cropHeight
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cropHeight = 0;
                        /**
         * A callback that alters how each character of the Bitmap Text is rendered.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#displayCallback
         * @type {Phaser.Types.GameObjects.BitmapText.DisplayCallback}
         * @since 3.0.0
         */ this.displayCallback;
                        /**
         * The data object that is populated during rendering, then passed to the displayCallback.
         * You should modify this object then return it back from the callback. It's updated values
         * will be used to render the specific glyph.
         *
         * Please note that if you need a reference to this object locally in your game code then you
         * should shallow copy it, as it's updated and re-used for every glyph in the text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#callbackData
         * @type {Phaser.Types.GameObjects.BitmapText.DisplayCallbackConfig}
         * @since 3.11.0
         */ this.callbackData = {
                            parent: this,
                            color: 0,
                            tint: {
                                topLeft: 0,
                                topRight: 0,
                                bottomLeft: 0,
                                bottomRight: 0
                            },
                            index: 0,
                            charCode: 0,
                            x: 0,
                            y: 0,
                            scale: 0,
                            rotation: 0,
                            data: 0
                        };
                    },
                    /**
     * Set the crop size of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the crop.
     * @param {number} height - The height of the crop.
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height) {
                        this.cropWidth = width;
                        this.cropHeight = height;
                        return this;
                    },
                    /**
     * Set a callback that alters how each character of the Bitmap Text is rendered.
     *
     * The callback receives a {@link Phaser.Types.GameObjects.BitmapText.DisplayCallbackConfig} object that contains information about the character that's
     * about to be rendered.
     *
     * It should return an object with `x`, `y`, `scale` and `rotation` properties that will be used instead of the
     * usual values when rendering.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setDisplayCallback
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.BitmapText.DisplayCallback} callback - The display callback to set.
     *
     * @return {this} This Game Object.
     */ setDisplayCallback: function(callback) {
                        this.displayCallback = callback;
                        return this;
                    },
                    /**
     * Set the horizontal scroll position of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setScrollX
     * @since 3.0.0
     *
     * @param {number} value - The horizontal scroll position to set.
     *
     * @return {this} This Game Object.
     */ setScrollX: function(value) {
                        this.scrollX = value;
                        return this;
                    },
                    /**
     * Set the vertical scroll position of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setScrollY
     * @since 3.0.0
     *
     * @param {number} value - The vertical scroll position to set.
     *
     * @return {this} This Game Object.
     */ setScrollY: function(value) {
                        this.scrollY = value;
                        return this;
                    }
                });
                module1.exports = DynamicBitmapText;
            /***/ },
            /***/ 86741: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DynamicBitmapText#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.DynamicBitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DynamicBitmapTextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    var text = src._text;
                    var textLength = text.length;
                    var ctx = renderer.currentContext;
                    if (textLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                    camera.addToRenderList(src);
                    var textureFrame = src.fromAtlas ? src.frame : src.texture.frames['__BASE'];
                    var displayCallback = src.displayCallback;
                    var callbackData = src.callbackData;
                    var chars = src.fontData.chars;
                    var lineHeight = src.fontData.lineHeight;
                    var letterSpacing = src._letterSpacing;
                    var xAdvance = 0;
                    var yAdvance = 0;
                    var charCode = 0;
                    var glyph = null;
                    var glyphX = 0;
                    var glyphY = 0;
                    var glyphW = 0;
                    var glyphH = 0;
                    var x = 0;
                    var y = 0;
                    var lastGlyph = null;
                    var lastCharCode = 0;
                    var image = src.frame.source.image;
                    var textureX = textureFrame.cutX;
                    var textureY = textureFrame.cutY;
                    var rotation = 0;
                    var scale = 0;
                    var baseScale = src._fontSize / src.fontData.size;
                    var align = src._align;
                    var currentLine = 0;
                    var lineOffsetX = 0;
                    //  Update the bounds - skipped internally if not dirty
                    src.getTextBounds(false);
                    var lineData = src._bounds.lines;
                    if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                    else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                    ctx.translate(-src.displayOriginX, -src.displayOriginY);
                    var roundPixels = camera.roundPixels;
                    if (src.cropWidth > 0 && src.cropHeight > 0) {
                        ctx.beginPath();
                        ctx.rect(0, 0, src.cropWidth, src.cropHeight);
                        ctx.clip();
                    }
                    for(var i = 0; i < textLength; i++){
                        //  Reset the scale (in case the callback changed it)
                        scale = baseScale;
                        rotation = 0;
                        charCode = text.charCodeAt(i);
                        if (charCode === 10) {
                            currentLine++;
                            if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                            else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                            xAdvance = 0;
                            yAdvance += lineHeight;
                            lastGlyph = null;
                            continue;
                        }
                        glyph = chars[charCode];
                        if (!glyph) continue;
                        glyphX = textureX + glyph.x;
                        glyphY = textureY + glyph.y;
                        glyphW = glyph.width;
                        glyphH = glyph.height;
                        x = glyph.xOffset + xAdvance - src.scrollX;
                        y = glyph.yOffset + yAdvance - src.scrollY;
                        if (lastGlyph !== null) {
                            var kerningOffset = glyph.kerning[lastCharCode];
                            x += kerningOffset !== undefined ? kerningOffset : 0;
                        }
                        if (displayCallback) {
                            callbackData.index = i;
                            callbackData.charCode = charCode;
                            callbackData.x = x;
                            callbackData.y = y;
                            callbackData.scale = scale;
                            callbackData.rotation = rotation;
                            callbackData.data = glyph.data;
                            var output = displayCallback(callbackData);
                            x = output.x;
                            y = output.y;
                            scale = output.scale;
                            rotation = output.rotation;
                        }
                        x *= scale;
                        y *= scale;
                        x += lineOffsetX;
                        xAdvance += glyph.xAdvance + letterSpacing + (kerningOffset !== undefined ? kerningOffset : 0);
                        lastGlyph = glyph;
                        lastCharCode = charCode;
                        //  Nothing to render or a space? Then skip to the next glyph
                        if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                        if (roundPixels) {
                            x = Math.round(x);
                            y = Math.round(y);
                        }
                        ctx.save();
                        ctx.translate(x, y);
                        ctx.rotate(rotation);
                        ctx.scale(scale, scale);
                        ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
                        ctx.restore();
                    }
                    ctx.restore();
                };
                module1.exports = DynamicBitmapTextCanvasRenderer;
            /***/ },
            /***/ 11164: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(2638);
                var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                /**
 * Creates a new Dynamic Bitmap Text Game Object and returns it.
 *
 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#dynamicBitmapText
 * @since 3.0.0
 *²
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
 */ GameObjectCreator.register('dynamicBitmapText', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var font = GetAdvancedValue(config, 'font', '');
                    var text = GetAdvancedValue(config, 'text', '');
                    var size = GetAdvancedValue(config, 'size', false);
                    var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, bitmapText, config);
                    return bitmapText;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 72566: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DynamicBitmapText = __webpack_require__(2638);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Dynamic Bitmap Text Game Object and adds it to the Scene.
 * 
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 * 
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 * 
 * Dynamic Bitmap Text objects are different from Static Bitmap Text in that they invoke a callback for each
 * letter being rendered during the render pass. This callback allows you to manipulate the properties of
 * each letter being rendered, such as its position, scale or tint, allowing you to create interesting effects
 * like jiggling text, which can't be done with Static text. This means that Dynamic Text takes more processing
 * time, so only use them if you require the callback ability they have.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
 * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
 * Littera (Web-based, free): http://kvazars.com/littera/
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: http://codebeautify.org/xmltojson
 *
 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#dynamicBitmapText
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} font - The key of the font to use from the BitmapFont cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size to set.
 *
 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
 */ GameObjectFactory.register('dynamicBitmapText', function(x, y, font, text, size) {
                    return this.displayList.add(new DynamicBitmapText(this.scene, x, y, font, text, size));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 12310: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(73482);
                renderCanvas = __webpack_require__(86741);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 73482: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var TransformMatrix = __webpack_require__(61340);
                var Utils = __webpack_require__(70554);
                var tempMatrix = new TransformMatrix();
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DynamicBitmapText#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.DynamicBitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DynamicBitmapTextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    var text = src.text;
                    var textLength = text.length;
                    if (textLength === 0) return;
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    //  This causes a flush if the BitmapText has a Post Pipeline
                    renderer.pipelines.preBatch(src);
                    var spriteMatrix = result.sprite;
                    var calcMatrix = result.calc;
                    var fontMatrix = tempMatrix;
                    var crop = src.cropWidth > 0 || src.cropHeight > 0;
                    if (crop) {
                        pipeline.flush();
                        renderer.pushScissor(calcMatrix.tx, calcMatrix.ty, src.cropWidth * calcMatrix.scaleX, src.cropHeight * calcMatrix.scaleY);
                    }
                    var frame = src.frame;
                    var texture = frame.glTexture;
                    var tintEffect = src.tintFill;
                    var tintTL = Utils.getTintAppendFloatAlpha(src.tintTopLeft, camera.alpha * src._alphaTL);
                    var tintTR = Utils.getTintAppendFloatAlpha(src.tintTopRight, camera.alpha * src._alphaTR);
                    var tintBL = Utils.getTintAppendFloatAlpha(src.tintBottomLeft, camera.alpha * src._alphaBL);
                    var tintBR = Utils.getTintAppendFloatAlpha(src.tintBottomRight, camera.alpha * src._alphaBR);
                    var textureUnit = pipeline.setGameObject(src);
                    var xAdvance = 0;
                    var yAdvance = 0;
                    var charCode = 0;
                    var lastCharCode = 0;
                    var letterSpacing = src.letterSpacing;
                    var glyph;
                    var glyphW = 0;
                    var glyphH = 0;
                    var lastGlyph;
                    var scrollX = src.scrollX;
                    var scrollY = src.scrollY;
                    var fontData = src.fontData;
                    var chars = fontData.chars;
                    var lineHeight = fontData.lineHeight;
                    var scale = src.fontSize / fontData.size;
                    var rotation = 0;
                    var align = src._align;
                    var currentLine = 0;
                    var lineOffsetX = 0;
                    //  Update the bounds - skipped internally if not dirty
                    var bounds = src.getTextBounds(false);
                    //  In case the method above changed it (word wrapping)
                    if (src.maxWidth > 0) {
                        text = bounds.wrappedText;
                        textLength = text.length;
                    }
                    var lineData = src._bounds.lines;
                    if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                    else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                    var roundPixels = camera.roundPixels;
                    var displayCallback = src.displayCallback;
                    var callbackData = src.callbackData;
                    for(var i = 0; i < textLength; i++){
                        charCode = text.charCodeAt(i);
                        //  Carriage-return
                        if (charCode === 10) {
                            currentLine++;
                            if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                            else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                            xAdvance = 0;
                            yAdvance += lineHeight;
                            lastGlyph = null;
                            continue;
                        }
                        glyph = chars[charCode];
                        if (!glyph) continue;
                        glyphW = glyph.width;
                        glyphH = glyph.height;
                        var x = glyph.xOffset + xAdvance - scrollX;
                        var y = glyph.yOffset + yAdvance - scrollY;
                        if (lastGlyph !== null) {
                            var kerningOffset = glyph.kerning[lastCharCode] || 0;
                            x += kerningOffset;
                            xAdvance += kerningOffset;
                        }
                        xAdvance += glyph.xAdvance + letterSpacing;
                        lastGlyph = glyph;
                        lastCharCode = charCode;
                        //  Nothing to render or a space? Then skip to the next glyph
                        if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                        scale = src.fontSize / src.fontData.size;
                        rotation = 0;
                        if (displayCallback) {
                            callbackData.color = 0;
                            callbackData.tint.topLeft = tintTL;
                            callbackData.tint.topRight = tintTR;
                            callbackData.tint.bottomLeft = tintBL;
                            callbackData.tint.bottomRight = tintBR;
                            callbackData.index = i;
                            callbackData.charCode = charCode;
                            callbackData.x = x;
                            callbackData.y = y;
                            callbackData.scale = scale;
                            callbackData.rotation = rotation;
                            callbackData.data = glyph.data;
                            var output = displayCallback(callbackData);
                            x = output.x;
                            y = output.y;
                            scale = output.scale;
                            rotation = output.rotation;
                            if (output.color) {
                                tintTL = output.color;
                                tintTR = output.color;
                                tintBL = output.color;
                                tintBR = output.color;
                            } else {
                                tintTL = output.tint.topLeft;
                                tintTR = output.tint.topRight;
                                tintBL = output.tint.bottomLeft;
                                tintBR = output.tint.bottomRight;
                            }
                            tintTL = Utils.getTintAppendFloatAlpha(tintTL, camera.alpha * src._alphaTL);
                            tintTR = Utils.getTintAppendFloatAlpha(tintTR, camera.alpha * src._alphaTR);
                            tintBL = Utils.getTintAppendFloatAlpha(tintBL, camera.alpha * src._alphaBL);
                            tintBR = Utils.getTintAppendFloatAlpha(tintBR, camera.alpha * src._alphaBR);
                        }
                        x *= scale;
                        y *= scale;
                        x -= src.displayOriginX;
                        y -= src.displayOriginY;
                        x += lineOffsetX;
                        fontMatrix.applyITRS(x, y, rotation, scale, scale);
                        calcMatrix.multiply(fontMatrix, spriteMatrix);
                        var u0 = glyph.u0;
                        var v0 = glyph.v0;
                        var u1 = glyph.u1;
                        var v1 = glyph.v1;
                        var xw = glyphW;
                        var yh = glyphH;
                        var tx0 = spriteMatrix.e;
                        var ty0 = spriteMatrix.f;
                        var tx1 = yh * spriteMatrix.c + spriteMatrix.e;
                        var ty1 = yh * spriteMatrix.d + spriteMatrix.f;
                        var tx2 = xw * spriteMatrix.a + yh * spriteMatrix.c + spriteMatrix.e;
                        var ty2 = xw * spriteMatrix.b + yh * spriteMatrix.d + spriteMatrix.f;
                        var tx3 = xw * spriteMatrix.a + spriteMatrix.e;
                        var ty3 = xw * spriteMatrix.b + spriteMatrix.f;
                        if (roundPixels) {
                            tx0 = Math.round(tx0);
                            ty0 = Math.round(ty0);
                            tx1 = Math.round(tx1);
                            ty1 = Math.round(ty1);
                            tx2 = Math.round(tx2);
                            ty2 = Math.round(ty2);
                            tx3 = Math.round(tx3);
                            ty3 = Math.round(ty3);
                        }
                        if (pipeline.shouldFlush(6)) {
                            pipeline.flush();
                            textureUnit = pipeline.setGameObject(src);
                        }
                        pipeline.batchQuad(src, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                    }
                    if (crop) {
                        pipeline.flush();
                        renderer.popScissor();
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = DynamicBitmapTextWebGLRenderer;
            /***/ },
            /***/ 22186: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Clamp = __webpack_require__(45319);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var GetBitmapTextSize = __webpack_require__(53048);
                var ParseFromAtlas = __webpack_require__(61327);
                var ParseXMLBitmapFont = __webpack_require__(21859);
                var Rectangle = __webpack_require__(87841);
                var Render = __webpack_require__(18658);
                /**
 * @classdesc
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 *
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): {@link http://www.angelcode.com/products/bmfont/|http://www.angelcode.com/products/bmfont/}
 * Glyph Designer (OS X, commercial): {@link http://www.71squared.com/en/glyphdesigner|http://www.71squared.com/en/glyphdesigner}
 * Snow BMF (Web-based, free): {@link https://snowb.org//|https://snowb.org/}
 * Littera (Flash-based, free): {@link http://kvazars.com/littera/|http://kvazars.com/littera/}
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: {@link http://codebeautify.org/xmltojson|http://codebeautify.org/xmltojson}
 *
 * @class BitmapText
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} x - The x coordinate of this Game Object in world space.
 * @param {number} y - The y coordinate of this Game Object in world space.
 * @param {string} font - The key of the font to use from the Bitmap Font cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size of this Bitmap Text.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 */ var BitmapText = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.Depth,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Texture,
                        Components.Tint,
                        Components.Transform,
                        Components.Visible,
                        Render
                    ],
                    initialize: function BitmapText(scene, x, y, font, text, size, align) {
                        if (text === undefined) text = '';
                        if (align === undefined) align = 0;
                        GameObject.call(this, scene, 'BitmapText');
                        /**
         * The key of the Bitmap Font used by this Bitmap Text.
         * To change the font after creation please use `setFont`.
         *
         * @name Phaser.GameObjects.BitmapText#font
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.font = font;
                        var entry = this.scene.sys.cache.bitmapFont.get(font);
                        if (!entry) throw new Error('Invalid BitmapText key: ' + font);
                        /**
         * The data of the Bitmap Font used by this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#fontData
         * @type {Phaser.Types.GameObjects.BitmapText.BitmapFontData}
         * @readonly
         * @since 3.0.0
         */ this.fontData = entry.data;
                        /**
         * The text that this Bitmap Text object displays.
         *
         * @name Phaser.GameObjects.BitmapText#_text
         * @type {string}
         * @private
         * @since 3.0.0
         */ this._text = '';
                        /**
         * The font size of this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#_fontSize
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._fontSize = size || this.fontData.size;
                        /**
         * Adds / Removes spacing between characters.
         *
         * Can be a negative or positive number.
         *
         * @name Phaser.GameObjects.BitmapText#_letterSpacing
         * @type {number}
         * @private
         * @since 3.4.0
         */ this._letterSpacing = 0;
                        /**
         * Adds / Removes line spacing in a multiline BitmapText object.
         *
         * Can be a negative or positive number.
         *
         * @name Phaser.GameObjects.BitmapText#_lineSpacing
         * @type {number}
         * @private
         * @since 3.60.0
         */ this._lineSpacing = 0;
                        /**
         * Controls the alignment of each line of text in this BitmapText object.
         * Only has any effect when this BitmapText contains multiple lines of text, split with carriage-returns.
         * Has no effect with single-lines of text.
         *
         * See the methods `setLeftAlign`, `setCenterAlign` and `setRightAlign`.
         *
         * 0 = Left aligned (default)
         * 1 = Middle aligned
         * 2 = Right aligned
         *
         * The alignment position is based on the longest line of text.
         *
         * @name Phaser.GameObjects.BitmapText#_align
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._align = align;
                        /**
         * An object that describes the size of this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#_bounds
         * @type {Phaser.Types.GameObjects.BitmapText.BitmapTextSize}
         * @private
         * @since 3.0.0
         */ this._bounds = GetBitmapTextSize();
                        /**
         * An internal dirty flag for bounds calculation.
         *
         * @name Phaser.GameObjects.BitmapText#_dirty
         * @type {boolean}
         * @private
         * @since 3.11.0
         */ this._dirty = true;
                        /**
         * Internal cache var holding the maxWidth.
         *
         * @name Phaser.GameObjects.BitmapText#_maxWidth
         * @type {number}
         * @private
         * @since 3.21.0
         */ this._maxWidth = 0;
                        /**
         * The character code used to detect for word wrapping.
         * Defaults to 32 (a space character).
         *
         * @name Phaser.GameObjects.BitmapText#wordWrapCharCode
         * @type {number}
         * @since 3.21.0
         */ this.wordWrapCharCode = 32;
                        /**
         * Internal array holding the character tint color data.
         *
         * @name Phaser.GameObjects.BitmapText#charColors
         * @type {array}
         * @private
         * @since 3.50.0
         */ this.charColors = [];
                        /**
         * The horizontal offset of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowX
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowX = 0;
                        /**
         * The vertical offset of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowY
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowY = 0;
                        /**
         * The color of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowColor
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowColor = 0x000000;
                        /**
         * The alpha value of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowAlpha
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowAlpha = 0.5;
                        /**
         * Indicates whether the font texture is from an atlas or not.
         *
         * @name Phaser.GameObjects.BitmapText#fromAtlas
         * @type {boolean}
         * @since 3.54.0
         * @readonly
         */ this.fromAtlas = entry.fromAtlas;
                        this.setTexture(entry.texture, entry.frame);
                        this.setPosition(x, y);
                        this.setOrigin(0, 0);
                        this.initPipeline();
                        this.initPostPipeline();
                        this.setText(text);
                    },
                    /**
     * Set the lines of text in this BitmapText to be left-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setLeftAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setLeftAlign: function() {
                        this._align = BitmapText.ALIGN_LEFT;
                        this._dirty = true;
                        return this;
                    },
                    /**
     * Set the lines of text in this BitmapText to be center-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setCenterAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setCenterAlign: function() {
                        this._align = BitmapText.ALIGN_CENTER;
                        this._dirty = true;
                        return this;
                    },
                    /**
     * Set the lines of text in this BitmapText to be right-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setRightAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setRightAlign: function() {
                        this._align = BitmapText.ALIGN_RIGHT;
                        this._dirty = true;
                        return this;
                    },
                    /**
     * Set the font size of this Bitmap Text.
     *
     * @method Phaser.GameObjects.BitmapText#setFontSize
     * @since 3.0.0
     *
     * @param {number} size - The font size to set.
     *
     * @return {this} This BitmapText Object.
     */ setFontSize: function(size) {
                        this._fontSize = size;
                        this._dirty = true;
                        return this;
                    },
                    /**
     * Sets the letter spacing between each character of this Bitmap Text.
     * Can be a positive value to increase the space, or negative to reduce it.
     * Spacing is applied after the kerning values have been set.
     *
     * @method Phaser.GameObjects.BitmapText#setLetterSpacing
     * @since 3.4.0
     *
     * @param {number} [spacing=0] - The amount of horizontal space to add between each character.
     *
     * @return {this} This BitmapText Object.
     */ setLetterSpacing: function(spacing) {
                        if (spacing === undefined) spacing = 0;
                        this._letterSpacing = spacing;
                        this._dirty = true;
                        return this;
                    },
                    /**
     * Sets the line spacing value. This value is added to the font height to
     * calculate the overall line height.
     *
     * Spacing can be a negative or positive number.
     *
     * Only has an effect if this BitmapText object contains multiple lines of text.
     *
     * @method Phaser.GameObjects.BitmapText#setLineSpacing
     * @since 3.60.0
     *
     * @param {number} [spacing=0] - The amount of space to add between each line in multi-line text.
     *
     * @return {this} This BitmapText Object.
     */ setLineSpacing: function(spacing) {
                        if (spacing === undefined) spacing = 0;
                        this.lineSpacing = spacing;
                        return this;
                    },
                    /**
     * Set the textual content of this BitmapText.
     *
     * An array of strings will be converted into multi-line text. Use the align methods to change multi-line alignment.
     *
     * @method Phaser.GameObjects.BitmapText#setText
     * @since 3.0.0
     *
     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this BitmapText.
     *
     * @return {this} This BitmapText Object.
     */ setText: function(value) {
                        if (!value && value !== 0) value = '';
                        if (Array.isArray(value)) value = value.join('\n');
                        if (value !== this.text) {
                            this._text = value.toString();
                            this._dirty = true;
                            this.updateDisplayOrigin();
                        }
                        return this;
                    },
                    /**
     * Sets a drop shadow effect on this Bitmap Text.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * You can set the vertical and horizontal offset of the shadow, as well as the color and alpha.
     *
     * Once a shadow has been enabled you can modify the `dropShadowX` and `dropShadowY` properties of this
     * Bitmap Text directly to adjust the position of the shadow in real-time.
     *
     * If you wish to clear the shadow, call this method with no parameters specified.
     *
     * @method Phaser.GameObjects.BitmapText#setDropShadow
     * @webglOnly
     * @since 3.50.0
     *
     * @param {number} [x=0] - The horizontal offset of the drop shadow.
     * @param {number} [y=0] - The vertical offset of the drop shadow.
     * @param {number} [color=0x000000] - The color of the drop shadow, given as a hex value, i.e. `0x000000` for black.
     * @param {number} [alpha=0.5] - The alpha of the drop shadow, given as a float between 0 and 1. This is combined with the Bitmap Text alpha as well.
     *
     * @return {this} This BitmapText Object.
     */ setDropShadow: function(x, y, color, alpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (color === undefined) color = 0x000000;
                        if (alpha === undefined) alpha = 0.5;
                        this.dropShadowX = x;
                        this.dropShadowY = y;
                        this.dropShadowColor = color;
                        this.dropShadowAlpha = alpha;
                        return this;
                    },
                    /**
     * Sets a tint on a range of characters in this Bitmap Text, starting from the `start` parameter index
     * and running for `length` quantity of characters.
     *
     * The `start` parameter can be negative. In this case, it starts at the end of the text and counts
     * backwards `start` places.
     *
     * You can also pass in -1 as the `length` and it will tint all characters from `start`
     * up until the end of the string.

     * Remember that spaces and punctuation count as characters.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * The tint works by taking the pixel color values from the Bitmap Text texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole character will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the character range.
     *
     * To swap this from being an additive tint to a fill based tint, set the `tintFill` parameter to `true`.
     *
     * To modify the tint color once set, call this method again with new color values.
     *
     * Using `setWordTint` can override tints set by this function, and vice versa.
     *
     * To remove a tint call this method with just the `start`, and optionally, the `length` parameters defined.
     *
     * @method Phaser.GameObjects.BitmapText#setCharacterTint
     * @webglOnly
     * @since 3.50.0
     *
     * @param {number} [start=0] - The starting character to begin the tint at. If negative, it counts back from the end of the text.
     * @param {number} [length=1] - The number of characters to tint. Remember that spaces count as a character too. Pass -1 to tint all characters from `start` onwards.
     * @param {boolean} [tintFill=false] - Use a fill-based tint (true), or an additive tint (false)
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the character. If not other values are given this value is applied evenly, tinting the whole character.
     * @param {number} [topRight] - The tint being applied to the top-right of the character.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the character.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the character.
     *
     * @return {this} This BitmapText Object.
     */ setCharacterTint: function(start, length, tintFill, topLeft, topRight, bottomLeft, bottomRight) {
                        if (start === undefined) start = 0;
                        if (length === undefined) length = 1;
                        if (tintFill === undefined) tintFill = false;
                        if (topLeft === undefined) topLeft = -1;
                        if (topRight === undefined) {
                            topRight = topLeft;
                            bottomLeft = topLeft;
                            bottomRight = topLeft;
                        }
                        var len = this.text.length;
                        if (length === -1) length = len;
                        if (start < 0) start = len + start;
                        start = Clamp(start, 0, len - 1);
                        var end = Clamp(start + length, start, len);
                        var charColors = this.charColors;
                        for(var i = start; i < end; i++){
                            var color = charColors[i];
                            if (topLeft === -1) charColors[i] = null;
                            else {
                                var tintEffect = tintFill ? 1 : 0;
                                if (color) {
                                    color.tintEffect = tintEffect;
                                    color.tintTL = topLeft;
                                    color.tintTR = topRight;
                                    color.tintBL = bottomLeft;
                                    color.tintBR = bottomRight;
                                } else charColors[i] = {
                                    tintEffect: tintEffect,
                                    tintTL: topLeft,
                                    tintTR: topRight,
                                    tintBL: bottomLeft,
                                    tintBR: bottomRight
                                };
                            }
                        }
                        return this;
                    },
                    /**
     * Sets a tint on a matching word within this Bitmap Text.
     *
     * The `word` parameter can be either a string or a number.
     *
     * If a string, it will run a string comparison against the text contents, and if matching,
     * it will tint the whole word.
     *
     * If a number, if till that word, based on its offset within the text contents.
     *
     * The `count` parameter controls how many words are replaced. Pass in -1 to replace them all.
     *
     * This parameter is ignored if you pass a number as the `word` to be searched for.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * The tint works by taking the pixel color values from the Bitmap Text texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole character will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the character range.
     *
     * To swap this from being an additive tint to a fill based tint, set the `tintFill` parameter to `true`.
     *
     * To modify the tint color once set, call this method again with new color values.
     *
     * Using `setCharacterTint` can override tints set by this function, and vice versa.
     *
     * @method Phaser.GameObjects.BitmapText#setWordTint
     * @webglOnly
     * @since 3.50.0
     *
     * @param {(string|number)} word - The word to search for. Either a string, or an index of the word in the words array.
     * @param {number} [count=1] - The number of matching words to tint. Pass -1 to tint all matching words.
     * @param {boolean} [tintFill=false] - Use a fill-based tint (true), or an additive tint (false)
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the word. If not other values are given this value is applied evenly, tinting the whole word.
     * @param {number} [topRight] - The tint being applied to the top-right of the word.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the word.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the word.
     *
     * @return {this} This BitmapText Object.
     */ setWordTint: function(word, count, tintFill, topLeft, topRight, bottomLeft, bottomRight) {
                        if (count === undefined) count = 1;
                        var bounds = this.getTextBounds();
                        var words = bounds.words;
                        var wordIsNumber = typeof word === 'number';
                        var total = 0;
                        for(var i = 0; i < words.length; i++){
                            var lineword = words[i];
                            if (wordIsNumber && i === word || !wordIsNumber && lineword.word === word) {
                                this.setCharacterTint(lineword.i, lineword.word.length, tintFill, topLeft, topRight, bottomLeft, bottomRight);
                                total++;
                                if (total === count) return this;
                            }
                        }
                        return this;
                    },
                    /**
     * Calculate the bounds of this Bitmap Text.
     *
     * An object is returned that contains the position, width and height of the Bitmap Text in local and global
     * contexts.
     *
     * Local size is based on just the font size and a [0, 0] position.
     *
     * Global size takes into account the Game Object's scale, world position and display origin.
     *
     * Also in the object is data regarding the length of each line, should this be a multi-line BitmapText.
     *
     * @method Phaser.GameObjects.BitmapText#getTextBounds
     * @since 3.0.0
     *
     * @param {boolean} [round=false] - Whether to round the results up to the nearest integer.
     *
     * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextSize} An object that describes the size of this Bitmap Text.
     */ getTextBounds: function(round) {
                        //  local = The BitmapText based on fontSize and 0x0 coords
                        //  global = The BitmapText, taking into account scale and world position
                        //  lines = The BitmapText line data
                        var bounds = this._bounds;
                        if (this._dirty || round || this.scaleX !== bounds.scaleX || this.scaleY !== bounds.scaleY) {
                            GetBitmapTextSize(this, round, true, bounds);
                            this._dirty = false;
                        }
                        return bounds;
                    },
                    /**
     * Gets the character located at the given x/y coordinate within this Bitmap Text.
     *
     * The coordinates you pass in are translated into the local space of the
     * Bitmap Text, however, it is up to you to first translate the input coordinates to world space.
     *
     * If you wish to use this in combination with an input event, be sure
     * to pass in `Pointer.worldX` and `worldY` so they are in world space.
     *
     * In some cases, based on kerning, characters can overlap. When this happens,
     * the first character in the word is returned.
     *
     * Note that this does not work for DynamicBitmapText if you have changed the
     * character positions during render. It will only scan characters in their un-translated state.
     *
     * @method Phaser.GameObjects.BitmapText#getCharacterAt
     * @since 3.50.0
     *
     * @param {number} x - The x position to check.
     * @param {number} y - The y position to check.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera which is being tested against. If not given will use the Scene default camera.
     *
     * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextCharacter} The character object at the given position, or `null`.
     */ getCharacterAt: function(x, y, camera) {
                        var point = this.getLocalPoint(x, y, null, camera);
                        var bounds = this.getTextBounds();
                        var chars = bounds.characters;
                        var tempRect = new Rectangle();
                        for(var i = 0; i < chars.length; i++){
                            var char = chars[i];
                            tempRect.setTo(char.x, char.t, char.r - char.x, char.b);
                            if (tempRect.contains(point.x, point.y)) return char;
                        }
                        return null;
                    },
                    /**
     * Updates the Display Origin cached values internally stored on this Game Object.
     * You don't usually call this directly, but it is exposed for edge-cases where you may.
     *
     * @method Phaser.GameObjects.BitmapText#updateDisplayOrigin
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ updateDisplayOrigin: function() {
                        this._dirty = true;
                        this.getTextBounds(false);
                        return this;
                    },
                    /**
     * Changes the font this BitmapText is using to render.
     *
     * The new texture is loaded and applied to the BitmapText. The existing text, size and alignment are preserved,
     * unless overridden via the arguments.
     *
     * @method Phaser.GameObjects.BitmapText#setFont
     * @since 3.11.0
     *
     * @param {string} font - The key of the font to use from the Bitmap Font cache.
     * @param {number} [size] - The font size of this Bitmap Text. If not specified the current size will be used.
     * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object. If not specified the current alignment will be used.
     *
     * @return {this} This BitmapText Object.
     */ setFont: function(key, size, align) {
                        if (size === undefined) size = this._fontSize;
                        if (align === undefined) align = this._align;
                        var entry = this.scene.sys.cache.bitmapFont.get(key);
                        if (entry) {
                            this.font = key;
                            this.fontData = entry.data;
                            this._fontSize = size;
                            this._align = align;
                            this.fromAtlas = entry.fromAtlas === true;
                            this.setTexture(entry.texture, entry.frame);
                            GetBitmapTextSize(this, false, true, this._bounds);
                        }
                        return this;
                    },
                    /**
     * Sets the maximum display width of this BitmapText in pixels.
     *
     * If `BitmapText.text` is longer than `maxWidth` then the lines will be automatically wrapped
     * based on the previous whitespace character found in the line.
     *
     * If no whitespace was found then no wrapping will take place and consequently the `maxWidth` value will not be honored.
     *
     * Disable maxWidth by setting the value to 0.
     *
     * You can set the whitespace character to be searched for by setting the `wordWrapCharCode` parameter or property.
     *
     * @method Phaser.GameObjects.BitmapText#setMaxWidth
     * @since 3.21.0
     *
     * @param {number} value - The maximum display width of this BitmapText in pixels. Set to zero to disable.
     * @param {number} [wordWrapCharCode] - The character code to check for when word wrapping. Defaults to 32 (the space character).
     *
     * @return {this} This BitmapText Object.
     */ setMaxWidth: function(value, wordWrapCharCode) {
                        this._maxWidth = value;
                        this._dirty = true;
                        if (wordWrapCharCode !== undefined) this.wordWrapCharCode = wordWrapCharCode;
                        return this;
                    },
                    /**
     * Controls the alignment of each line of text in this BitmapText object.
     *
     * Only has any effect when this BitmapText contains multiple lines of text, split with carriage-returns.
     * Has no effect with single-lines of text.
     *
     * See the methods `setLeftAlign`, `setCenterAlign` and `setRightAlign`.
     *
     * 0 = Left aligned (default)
     * 1 = Middle aligned
     * 2 = Right aligned
     *
     * The alignment position is based on the longest line of text.
     *
     * @name Phaser.GameObjects.BitmapText#align
     * @type {number}
     * @since 3.11.0
     */ align: {
                        set: function(value) {
                            this._align = value;
                            this._dirty = true;
                        },
                        get: function() {
                            return this._align;
                        }
                    },
                    /**
     * The text that this Bitmap Text object displays.
     *
     * You can also use the method `setText` if you want a chainable way to change the text content.
     *
     * @name Phaser.GameObjects.BitmapText#text
     * @type {string}
     * @since 3.0.0
     */ text: {
                        set: function(value) {
                            this.setText(value);
                        },
                        get: function() {
                            return this._text;
                        }
                    },
                    /**
     * The font size of this Bitmap Text.
     *
     * You can also use the method `setFontSize` if you want a chainable way to change the font size.
     *
     * @name Phaser.GameObjects.BitmapText#fontSize
     * @type {number}
     * @since 3.0.0
     */ fontSize: {
                        set: function(value) {
                            this._fontSize = value;
                            this._dirty = true;
                        },
                        get: function() {
                            return this._fontSize;
                        }
                    },
                    /**
     * Adds / Removes spacing between characters.
     *
     * Can be a negative or positive number.
     *
     * You can also use the method `setLetterSpacing` if you want a chainable way to change the letter spacing.
     *
     * @name Phaser.GameObjects.BitmapText#letterSpacing
     * @type {number}
     * @since 3.0.0
     */ letterSpacing: {
                        set: function(value) {
                            this._letterSpacing = value;
                            this._dirty = true;
                        },
                        get: function() {
                            return this._letterSpacing;
                        }
                    },
                    /**
     * Adds / Removes spacing between lines.
     *
     * Can be a negative or positive number.
     *
     * You can also use the method `setLineSpacing` if you want a chainable way to change the line spacing.
     *
     * @name Phaser.GameObjects.BitmapText#lineSpacing
     * @type {number}
     * @since 3.60.0
     */ lineSpacing: {
                        set: function(value) {
                            this._lineSpacing = value;
                            this._dirty = true;
                        },
                        get: function() {
                            return this._lineSpacing;
                        }
                    },
                    /**
     * The maximum display width of this BitmapText in pixels.
     *
     * If BitmapText.text is longer than maxWidth then the lines will be automatically wrapped
     * based on the last whitespace character found in the line.
     *
     * If no whitespace was found then no wrapping will take place and consequently the maxWidth value will not be honored.
     *
     * Disable maxWidth by setting the value to 0.
     *
     * @name Phaser.GameObjects.BitmapText#maxWidth
     * @type {number}
     * @since 3.21.0
     */ maxWidth: {
                        set: function(value) {
                            this._maxWidth = value;
                            this._dirty = true;
                        },
                        get: function() {
                            return this._maxWidth;
                        }
                    },
                    /**
     * The width of this Bitmap Text.
     *
     * This property is read-only.
     *
     * @name Phaser.GameObjects.BitmapText#width
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ width: {
                        get: function() {
                            this.getTextBounds(false);
                            return this._bounds.global.width;
                        }
                    },
                    /**
     * The height of this Bitmap text.
     *
     * This property is read-only.
     *
     * @name Phaser.GameObjects.BitmapText#height
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ height: {
                        get: function() {
                            this.getTextBounds(false);
                            return this._bounds.global.height;
                        }
                    },
                    /**
     * The displayed width of this Bitmap Text.
     *
     * This value takes into account the scale factor.
     *
     * This property is read-only.
     *
     * @name Phaser.GameObjects.BitmapText#displayWidth
     * @type {number}
     * @readonly
     * @since 3.60.0
     */ displayWidth: {
                        get: function() {
                            return this.width;
                        }
                    },
                    /**
     * The displayed height of this Bitmap Text.
     *
     * This value takes into account the scale factor.
     *
     * This property is read-only.
     *
     * @name Phaser.GameObjects.BitmapText#displayHeight
     * @type {number}
     * @readonly
     * @since 3.60.0
     */ displayHeight: {
                        get: function() {
                            return this.height;
                        }
                    },
                    /**
     * Build a JSON representation of this Bitmap Text.
     *
     * @method Phaser.GameObjects.BitmapText#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.BitmapText.JSONBitmapText} A JSON representation of this Bitmap Text.
     */ toJSON: function() {
                        var out = Components.ToJSON(this);
                        //  Extra data is added here
                        var data = {
                            font: this.font,
                            text: this.text,
                            fontSize: this.fontSize,
                            letterSpacing: this.letterSpacing,
                            lineSpacing: this.lineSpacing,
                            align: this.align
                        };
                        out.data = data;
                        return out;
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.BitmapText#preDestroy
     * @protected
     * @since 3.50.0
     */ preDestroy: function() {
                        this.charColors.length = 0;
                        this._bounds = null;
                        this.fontData = null;
                    }
                });
                /**
 * Left align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_LEFT
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_LEFT = 0;
                /**
 * Center align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_CENTER
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_CENTER = 1;
                /**
 * Right align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_RIGHT
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_RIGHT = 2;
                /**
 * Parse an XML Bitmap Font from an Atlas.
 *
 * Adds the parsed Bitmap Font data to the cache with the `fontName` key.
 *
 * @method Phaser.GameObjects.BitmapText.ParseFromAtlas
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to parse the Bitmap Font for.
 * @param {string} fontName - The key of the font to add to the Bitmap Font cache.
 * @param {string} textureKey - The key of the BitmapFont's texture.
 * @param {string} frameKey - The key of the BitmapFont texture's frame.
 * @param {string} xmlKey - The key of the XML data of the font to parse.
 * @param {number} [xSpacing] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing] - The y-axis spacing to add to the line height.
 *
 * @return {boolean} Whether the parsing was successful or not.
 */ BitmapText.ParseFromAtlas = ParseFromAtlas;
                /**
 * Parse an XML font to Bitmap Font data for the Bitmap Font cache.
 *
 * @method Phaser.GameObjects.BitmapText.ParseXMLBitmapFont
 * @since 3.17.0
 *
 * @param {XMLDocument} xml - The XML Document to parse the font from.
 * @param {Phaser.Textures.Frame} frame - The texture frame to take into account when creating the uv data.
 * @param {number} [xSpacing=0] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing=0] - The y-axis spacing to add to the line height.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapFontData} The parsed Bitmap Font data.
 */ BitmapText.ParseXMLBitmapFont = ParseXMLBitmapFont;
                module1.exports = BitmapText;
            /***/ },
            /***/ 37289: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.BitmapText#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.BitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BitmapTextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    var text = src._text;
                    var textLength = text.length;
                    var ctx = renderer.currentContext;
                    if (textLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                    camera.addToRenderList(src);
                    var textureFrame = src.fromAtlas ? src.frame : src.texture.frames['__BASE'];
                    var chars = src.fontData.chars;
                    var lineHeight = src.fontData.lineHeight;
                    var letterSpacing = src._letterSpacing;
                    var lineSpacing = src._lineSpacing;
                    var xAdvance = 0;
                    var yAdvance = 0;
                    var charCode = 0;
                    var glyph = null;
                    var glyphX = 0;
                    var glyphY = 0;
                    var glyphW = 0;
                    var glyphH = 0;
                    var x = 0;
                    var y = 0;
                    var lastGlyph = null;
                    var lastCharCode = 0;
                    var image = textureFrame.source.image;
                    var textureX = textureFrame.cutX;
                    var textureY = textureFrame.cutY;
                    var scale = src._fontSize / src.fontData.size;
                    var align = src._align;
                    var currentLine = 0;
                    var lineOffsetX = 0;
                    //  Update the bounds - skipped internally if not dirty
                    var bounds = src.getTextBounds(false);
                    //  In case the method above changed it (word wrapping)
                    if (src.maxWidth > 0) {
                        text = bounds.wrappedText;
                        textLength = text.length;
                    }
                    var lineData = src._bounds.lines;
                    if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                    else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                    ctx.translate(-src.displayOriginX, -src.displayOriginY);
                    var roundPixels = camera.roundPixels;
                    for(var i = 0; i < textLength; i++){
                        charCode = text.charCodeAt(i);
                        if (charCode === 10) {
                            currentLine++;
                            if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                            else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                            xAdvance = 0;
                            yAdvance += lineHeight + lineSpacing;
                            lastGlyph = null;
                            continue;
                        }
                        glyph = chars[charCode];
                        if (!glyph) continue;
                        glyphX = textureX + glyph.x;
                        glyphY = textureY + glyph.y;
                        glyphW = glyph.width;
                        glyphH = glyph.height;
                        x = glyph.xOffset + xAdvance;
                        y = glyph.yOffset + yAdvance;
                        if (lastGlyph !== null) {
                            var kerningOffset = glyph.kerning[lastCharCode];
                            x += kerningOffset !== undefined ? kerningOffset : 0;
                        }
                        x *= scale;
                        y *= scale;
                        x += lineOffsetX;
                        xAdvance += glyph.xAdvance + letterSpacing + (kerningOffset !== undefined ? kerningOffset : 0);
                        lastGlyph = glyph;
                        lastCharCode = charCode;
                        //  Nothing to render or a space? Then skip to the next glyph
                        if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                        if (roundPixels) {
                            x = Math.round(x);
                            y = Math.round(y);
                        }
                        ctx.save();
                        ctx.translate(x, y);
                        ctx.scale(scale, scale);
                        ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
                        ctx.restore();
                    }
                    ctx.restore();
                };
                module1.exports = BitmapTextCanvasRenderer;
            /***/ },
            /***/ 57336: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(22186);
                var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetValue = __webpack_require__(35154);
                /**
 * Creates a new Bitmap Text Game Object and returns it.
 *
 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#bitmapText
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 * 
 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
 */ GameObjectCreator.register('bitmapText', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var font = GetValue(config, 'font', '');
                    var text = GetAdvancedValue(config, 'text', '');
                    var size = GetAdvancedValue(config, 'size', false);
                    var align = GetValue(config, 'align', 0);
                    var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size, align);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, bitmapText, config);
                    return bitmapText;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 34914: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(22186);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Bitmap Text Game Object and adds it to the Scene.
 * 
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 * 
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 * 
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
 * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
 * Littera (Web-based, free): http://kvazars.com/littera/
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: http://codebeautify.org/xmltojson
 *
 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#bitmapText
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} font - The key of the font to use from the BitmapFont cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size to set.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 *
 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
 */ GameObjectFactory.register('bitmapText', function(x, y, font, text, size, align) {
                    return this.displayList.add(new BitmapText(this.scene, x, y, font, text, size, align));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 18658: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(33590);
                renderCanvas = __webpack_require__(37289);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 33590: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BatchChar = __webpack_require__(3217);
                var GetCalcMatrix = __webpack_require__(91296);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.BitmapText#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.BitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BitmapTextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    var text = src._text;
                    var textLength = text.length;
                    if (textLength === 0) return;
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    //  This causes a flush if the BitmapText has a Post Pipeline
                    renderer.pipelines.preBatch(src);
                    var roundPixels = camera.roundPixels;
                    var cameraAlpha = camera.alpha;
                    var charColors = src.charColors;
                    var tintEffect = src.tintFill;
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var tintTL = getTint(src.tintTopLeft, cameraAlpha * src._alphaTL);
                    var tintTR = getTint(src.tintTopRight, cameraAlpha * src._alphaTR);
                    var tintBL = getTint(src.tintBottomLeft, cameraAlpha * src._alphaBL);
                    var tintBR = getTint(src.tintBottomRight, cameraAlpha * src._alphaBR);
                    var texture = src.frame.glTexture;
                    var textureUnit = pipeline.setGameObject(src);
                    //  Update the bounds - skipped internally if not dirty
                    var bounds = src.getTextBounds(false);
                    var i;
                    var char;
                    var glyph;
                    var characters = bounds.characters;
                    var dropShadowX = src.dropShadowX;
                    var dropShadowY = src.dropShadowY;
                    var dropShadow = dropShadowX !== 0 || dropShadowY !== 0;
                    if (dropShadow) {
                        var srcShadowColor = src.dropShadowColor;
                        var srcShadowAlpha = src.dropShadowAlpha;
                        var shadowTL = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaTL);
                        var shadowTR = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaTR);
                        var shadowBL = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaBL);
                        var shadowBR = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaBR);
                        for(i = 0; i < characters.length; i++){
                            char = characters[i];
                            glyph = char.glyph;
                            if (char.code === 32 || glyph.width === 0 || glyph.height === 0) continue;
                            BatchChar(pipeline, src, char, glyph, dropShadowX, dropShadowY, calcMatrix, roundPixels, shadowTL, shadowTR, shadowBL, shadowBR, 1, texture, textureUnit);
                        }
                    }
                    for(i = 0; i < characters.length; i++){
                        char = characters[i];
                        glyph = char.glyph;
                        if (char.code === 32 || glyph.width === 0 || glyph.height === 0) continue;
                        if (pipeline.shouldFlush(6)) {
                            pipeline.flush();
                            textureUnit = pipeline.setGameObject(src);
                        }
                        if (charColors[char.i]) {
                            var color = charColors[char.i];
                            var charTintEffect = color.tintEffect;
                            var charTintTL = getTint(color.tintTL, cameraAlpha * src._alphaTL);
                            var charTintTR = getTint(color.tintTR, cameraAlpha * src._alphaTR);
                            var charTintBL = getTint(color.tintBL, cameraAlpha * src._alphaBL);
                            var charTintBR = getTint(color.tintBR, cameraAlpha * src._alphaBR);
                            BatchChar(pipeline, src, char, glyph, 0, 0, calcMatrix, roundPixels, charTintTL, charTintTR, charTintBL, charTintBR, charTintEffect, texture, textureUnit);
                        } else BatchChar(pipeline, src, char, glyph, 0, 0, calcMatrix, roundPixels, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                    //  Debug test if the characters are in the correct place when rendered:
                    // pipeline.drawFillRect(tx0, ty0, tx2 - tx0, ty2 - ty0, 0x00ff00, 0.5);
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = BitmapTextWebGLRenderer;
            /***/ },
            /***/ 6107: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlitterRender = __webpack_require__(48011);
                var Bob = __webpack_require__(46590);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var Frame = __webpack_require__(4327);
                var GameObject = __webpack_require__(95643);
                var List = __webpack_require__(73162);
                /**
 * @callback CreateCallback
 *
 * @param {Phaser.GameObjects.Bob} bob - The Bob that was created by the Blitter.
 * @param {number} index - The position of the Bob within the Blitter display list.
 */ /**
 * @classdesc
 * A Blitter Game Object.
 *
 * The Blitter Game Object is a special kind of container that creates, updates and manages Bob objects.
 * Bobs are designed for rendering speed rather than flexibility. They consist of a texture, or frame from a texture,
 * a position and an alpha value. You cannot scale or rotate them. They use a batched drawing method for speed
 * during rendering.
 *
 * A Blitter Game Object has one texture bound to it. Bobs created by the Blitter can use any Frame from this
 * Texture to render with, but they cannot use any other Texture. It is this single texture-bind that allows
 * them their speed.
 *
 * If you have a need to blast a large volume of frames around the screen then Blitter objects are well worth
 * investigating. They are especially useful for using as a base for your own special effects systems.
 *
 * @class Blitter
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} [x=0] - The x coordinate of this Game Object in world space.
 * @param {number} [y=0] - The y coordinate of this Game Object in world space.
 * @param {string} [texture='__DEFAULT'] - The key of the texture this Game Object will use for rendering. The Texture must already exist in the Texture Manager.
 * @param {(string|number)} [frame=0] - The Frame of the Texture that this Game Object will use. Only set if the Texture has multiple frames, such as a Texture Atlas or Sprite Sheet.
 */ var Blitter = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Mask,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Size,
                        Components.Texture,
                        Components.Transform,
                        Components.Visible,
                        BlitterRender
                    ],
                    initialize: function Blitter(scene, x, y, texture, frame) {
                        GameObject.call(this, scene, 'Blitter');
                        this.setTexture(texture, frame);
                        this.setPosition(x, y);
                        this.initPipeline();
                        this.initPostPipeline();
                        /**
         * The children of this Blitter.
         * This List contains all of the Bob objects created by the Blitter.
         *
         * @name Phaser.GameObjects.Blitter#children
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Bob>}
         * @since 3.0.0
         */ this.children = new List();
                        /**
         * A transient array that holds all of the Bobs that will be rendered this frame.
         * The array is re-populated whenever the dirty flag is set.
         *
         * @name Phaser.GameObjects.Blitter#renderList
         * @type {Phaser.GameObjects.Bob[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.renderList = [];
                        /**
         * Is the Blitter considered dirty?
         * A 'dirty' Blitter has had its child count changed since the last frame.
         *
         * @name Phaser.GameObjects.Blitter#dirty
         * @type {boolean}
         * @since 3.0.0
         */ this.dirty = false;
                    },
                    /**
     * Creates a new Bob in this Blitter.
     *
     * The Bob is created at the given coordinates, relative to the Blitter and uses the given frame.
     * A Bob can use any frame belonging to the texture bound to the Blitter.
     *
     * @method Phaser.GameObjects.Blitter#create
     * @since 3.0.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The Frame the Bob will use. It _must_ be part of the Texture the parent Blitter object is using.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     * @param {number} [index] - The position in the Blitters Display List to add the new Bob at. Defaults to the top of the list.
     *
     * @return {Phaser.GameObjects.Bob} The newly created Bob object.
     */ create: function(x, y, frame, visible, index) {
                        if (visible === undefined) visible = true;
                        if (index === undefined) index = this.children.length;
                        if (frame === undefined) frame = this.frame;
                        else if (!(frame instanceof Frame)) frame = this.texture.get(frame);
                        var bob = new Bob(this, x, y, frame, visible);
                        this.children.addAt(bob, index, false);
                        this.dirty = true;
                        return bob;
                    },
                    /**
     * Creates multiple Bob objects within this Blitter and then passes each of them to the specified callback.
     *
     * @method Phaser.GameObjects.Blitter#createFromCallback
     * @since 3.0.0
     *
     * @param {CreateCallback} callback - The callback to invoke after creating a bob. It will be sent two arguments: The Bob and the index of the Bob.
     * @param {number} quantity - The quantity of Bob objects to create.
     * @param {(string|number|Phaser.Textures.Frame|string[]|number[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that were created.
     */ createFromCallback: function(callback, quantity, frame, visible) {
                        var bobs = this.createMultiple(quantity, frame, visible);
                        for(var i = 0; i < bobs.length; i++){
                            var bob = bobs[i];
                            callback.call(this, bob, i);
                        }
                        return bobs;
                    },
                    /**
     * Creates multiple Bobs in one call.
     *
     * The amount created is controlled by a combination of the `quantity` argument and the number of frames provided.
     *
     * If the quantity is set to 10 and you provide 2 frames, then 20 Bobs will be created. 10 with the first
     * frame and 10 with the second.
     *
     * @method Phaser.GameObjects.Blitter#createMultiple
     * @since 3.0.0
     *
     * @param {number} quantity - The quantity of Bob objects to create.
     * @param {(string|number|Phaser.Textures.Frame|string[]|number[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that were created.
     */ createMultiple: function(quantity, frame, visible) {
                        if (frame === undefined) frame = this.frame.name;
                        if (visible === undefined) visible = true;
                        if (!Array.isArray(frame)) frame = [
                            frame
                        ];
                        var bobs = [];
                        var _this = this;
                        frame.forEach(function(singleFrame) {
                            for(var i = 0; i < quantity; i++)bobs.push(_this.create(0, 0, singleFrame, visible));
                        });
                        return bobs;
                    },
                    /**
     * Checks if the given child can render or not, by checking its `visible` and `alpha` values.
     *
     * @method Phaser.GameObjects.Blitter#childCanRender
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Bob} child - The Bob to check for rendering.
     *
     * @return {boolean} Returns `true` if the given child can render, otherwise `false`.
     */ childCanRender: function(child) {
                        return child.visible && child.alpha > 0;
                    },
                    /**
     * Returns an array of Bobs to be rendered.
     * If the Blitter is dirty then a new list is generated and stored in `renderList`.
     *
     * @method Phaser.GameObjects.Blitter#getRenderList
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that will be rendered this frame.
     */ getRenderList: function() {
                        if (this.dirty) {
                            this.renderList = this.children.list.filter(this.childCanRender, this);
                            this.dirty = false;
                        }
                        return this.renderList;
                    },
                    /**
     * Removes all Bobs from the children List and clears the dirty flag.
     *
     * @method Phaser.GameObjects.Blitter#clear
     * @since 3.0.0
     */ clear: function() {
                        this.children.removeAll();
                        this.dirty = true;
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Blitter#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                        this.children.destroy();
                        this.renderList = [];
                    }
                });
                module1.exports = Blitter;
            /***/ },
            /***/ 72396: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Blitter#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Blitter} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BlitterCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    var list = src.getRenderList();
                    if (list.length === 0) return;
                    var ctx = renderer.currentContext;
                    var alpha = camera.alpha * src.alpha;
                    if (alpha === 0) //  Nothing to see, so abort early
                    return;
                    camera.addToRenderList(src);
                    //  Blend Mode + Scale Mode
                    ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
                    ctx.imageSmoothingEnabled = !src.frame.source.scaleMode;
                    var cameraScrollX = src.x - camera.scrollX * src.scrollFactorX;
                    var cameraScrollY = src.y - camera.scrollY * src.scrollFactorY;
                    ctx.save();
                    if (parentMatrix) parentMatrix.copyToContext(ctx);
                    var roundPixels = camera.roundPixels;
                    //  Render bobs
                    for(var i = 0; i < list.length; i++){
                        var bob = list[i];
                        var flip = bob.flipX || bob.flipY;
                        var frame = bob.frame;
                        var cd = frame.canvasData;
                        var dx = frame.x;
                        var dy = frame.y;
                        var fx = 1;
                        var fy = 1;
                        var bobAlpha = bob.alpha * alpha;
                        if (bobAlpha === 0) continue;
                        ctx.globalAlpha = bobAlpha;
                        if (!flip) {
                            if (roundPixels) {
                                dx = Math.round(dx);
                                dy = Math.round(dy);
                            }
                            if (cd.width > 0 && cd.height > 0) ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, dx + bob.x + cameraScrollX, dy + bob.y + cameraScrollY, cd.width, cd.height);
                        } else {
                            if (bob.flipX) {
                                fx = -1;
                                dx -= cd.width;
                            }
                            if (bob.flipY) {
                                fy = -1;
                                dy -= cd.height;
                            }
                            if (cd.width > 0 && cd.height > 0) {
                                ctx.save();
                                ctx.translate(bob.x + cameraScrollX, bob.y + cameraScrollY);
                                ctx.scale(fx, fy);
                                ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, dx, dy, cd.width, cd.height);
                                ctx.restore();
                            }
                        }
                    }
                    ctx.restore();
                };
                module1.exports = BlitterCanvasRenderer;
            /***/ },
            /***/ 9403: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Blitter = __webpack_require__(6107);
                var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                /**
 * Creates a new Blitter Game Object and returns it.
 *
 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#blitter
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
 */ GameObjectCreator.register('blitter', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var frame = GetAdvancedValue(config, 'frame', null);
                    var blitter = new Blitter(this.scene, 0, 0, key, frame);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, blitter, config);
                    return blitter;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 12709: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Blitter = __webpack_require__(6107);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Blitter Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#blitter
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - The default Frame children of the Blitter will use.
 *
 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
 */ GameObjectFactory.register('blitter', function(x, y, texture, frame) {
                    return this.displayList.add(new Blitter(this.scene, x, y, texture, frame));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 48011: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(99485);
                renderCanvas = __webpack_require__(72396);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 99485: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(61340);
                var Utils = __webpack_require__(70554);
                var tempMatrix = new TransformMatrix();
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Blitter#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Blitter} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BlitterWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    var list = src.getRenderList();
                    var alpha = camera.alpha * src.alpha;
                    if (list.length === 0 || alpha === 0) //  Nothing to see, so abort early
                    return;
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(this.pipeline, src);
                    var cameraScrollX = camera.scrollX * src.scrollFactorX;
                    var cameraScrollY = camera.scrollY * src.scrollFactorY;
                    var calcMatrix = tempMatrix.copyFrom(camera.matrix);
                    if (parentMatrix) {
                        calcMatrix.multiplyWithOffset(parentMatrix, -cameraScrollX, -cameraScrollY);
                        cameraScrollX = 0;
                        cameraScrollY = 0;
                    }
                    var blitterX = src.x - cameraScrollX;
                    var blitterY = src.y - cameraScrollY;
                    var prevTextureSourceIndex = -1;
                    var tintEffect = false;
                    var roundPixels = camera.roundPixels;
                    renderer.pipelines.preBatch(src);
                    for(var i = 0; i < list.length; i++){
                        var bob = list[i];
                        var frame = bob.frame;
                        var bobAlpha = bob.alpha * alpha;
                        if (bobAlpha === 0) continue;
                        var width = frame.width;
                        var height = frame.height;
                        var x = blitterX + bob.x + frame.x;
                        var y = blitterY + bob.y + frame.y;
                        if (bob.flipX) {
                            width *= -1;
                            x += frame.width;
                        }
                        if (bob.flipY) {
                            height *= -1;
                            y += frame.height;
                        }
                        var quad = calcMatrix.setQuad(x, y, x + width, y + height, roundPixels);
                        var tint = Utils.getTintAppendFloatAlpha(bob.tint, bobAlpha);
                        //  Bind texture only if the Texture Source is different from before
                        if (frame.sourceIndex !== prevTextureSourceIndex) {
                            var textureUnit = pipeline.setGameObject(src, frame);
                            prevTextureSourceIndex = frame.sourceIndex;
                        }
                        if (pipeline.batchQuad(src, quad[0], quad[1], quad[2], quad[3], quad[4], quad[5], quad[6], quad[7], frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, tintEffect, frame.glTexture, textureUnit)) prevTextureSourceIndex = -1;
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = BlitterWebGLRenderer;
            /***/ },
            /***/ 46590: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Frame = __webpack_require__(4327);
                /**
 * @classdesc
 * A Bob Game Object.
 *
 * A Bob belongs to a Blitter Game Object. The Blitter is responsible for managing and rendering this object.
 *
 * A Bob has a position, alpha value and a frame from a texture that it uses to render with. You can also toggle
 * the flipped and visible state of the Bob. The Frame the Bob uses to render can be changed dynamically, but it
 * must be a Frame within the Texture used by the parent Blitter.
 *
 * Bob positions are relative to the Blitter parent. So if you move the Blitter parent, all Bob children will
 * have their positions impacted by this change as well.
 *
 * You can manipulate Bob objects directly from your game code, but the creation and destruction of them should be
 * handled via the Blitter parent.
 *
 * @class Bob
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Blitter} blitter - The parent Blitter object is responsible for updating this Bob.
 * @param {number} x - The horizontal position of this Game Object in the world, relative to the parent Blitter position.
 * @param {number} y - The vertical position of this Game Object in the world, relative to the parent Blitter position.
 * @param {(string|number)} frame - The Frame this Bob will render with, as defined in the Texture the parent Blitter is using.
 * @param {boolean} visible - Should the Bob render visible or not to start with?
 */ var Bob = new Class({
                    initialize: function Bob(blitter, x, y, frame, visible) {
                        /**
         * The Blitter object that this Bob belongs to.
         *
         * @name Phaser.GameObjects.Bob#parent
         * @type {Phaser.GameObjects.Blitter}
         * @since 3.0.0
         */ this.parent = blitter;
                        /**
         * The x position of this Bob, relative to the x position of the Blitter.
         *
         * @name Phaser.GameObjects.Bob#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                        /**
         * The y position of this Bob, relative to the y position of the Blitter.
         *
         * @name Phaser.GameObjects.Bob#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                        /**
         * The frame that the Bob uses to render with.
         * To change the frame use the `Bob.setFrame` method.
         *
         * @name Phaser.GameObjects.Bob#frame
         * @type {Phaser.Textures.Frame}
         * @protected
         * @since 3.0.0
         */ this.frame = frame;
                        /**
         * A blank object which can be used to store data related to this Bob in.
         *
         * @name Phaser.GameObjects.Bob#data
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.data = {};
                        /**
         * The tint value of this Bob.
         *
         * @name Phaser.GameObjects.Bob#tint
         * @type {number}
         * @default 0xffffff
         * @since 3.20.0
         */ this.tint = 0xffffff;
                        /**
         * The visible state of this Bob.
         *
         * @name Phaser.GameObjects.Bob#_visible
         * @type {boolean}
         * @private
         * @since 3.0.0
         */ this._visible = visible;
                        /**
         * The alpha value of this Bob.
         *
         * @name Phaser.GameObjects.Bob#_alpha
         * @type {number}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._alpha = 1;
                        /**
         * The horizontally flipped state of the Bob.
         * A Bob that is flipped horizontally will render inversed on the horizontal axis.
         * Flipping always takes place from the middle of the texture.
         *
         * @name Phaser.GameObjects.Bob#flipX
         * @type {boolean}
         * @since 3.0.0
         */ this.flipX = false;
                        /**
         * The vertically flipped state of the Bob.
         * A Bob that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
         * Flipping always takes place from the middle of the texture.
         *
         * @name Phaser.GameObjects.Bob#flipY
         * @type {boolean}
         * @since 3.0.0
         */ this.flipY = false;
                        /**
         * Private read-only property used to allow Bobs to have physics bodies.
         *
         * @name Phaser.GameObjects.Bob#hasTransformComponent
         * @type {boolean}
         * @private
         * @readonly
         * @since 3.60.0
         */ this.hasTransformComponent = true;
                    },
                    /**
     * Changes the Texture Frame being used by this Bob.
     * The frame must be part of the Texture the parent Blitter is using.
     * If no value is given it will use the default frame of the Blitter parent.
     *
     * @method Phaser.GameObjects.Bob#setFrame
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The frame to be used during rendering.
     *
     * @return {this} This Bob Game Object.
     */ setFrame: function(frame) {
                        if (frame === undefined) this.frame = this.parent.frame;
                        else if (frame instanceof Frame && frame.texture === this.parent.texture) this.frame = frame;
                        else this.frame = this.parent.texture.get(frame);
                        return this;
                    },
                    /**
     * Resets the horizontal and vertical flipped state of this Bob back to their default un-flipped state.
     *
     * @method Phaser.GameObjects.Bob#resetFlip
     * @since 3.0.0
     *
     * @return {this} This Bob Game Object.
     */ resetFlip: function() {
                        this.flipX = false;
                        this.flipY = false;
                        return this;
                    },
                    /**
     * Resets this Bob.
     *
     * Changes the position to the values given, and optionally changes the frame.
     *
     * Also resets the flipX and flipY values, sets alpha back to 1 and visible to true.
     *
     * @method Phaser.GameObjects.Bob#reset
     * @since 3.0.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The Frame the Bob will use. It _must_ be part of the Texture the parent Blitter object is using.
     *
     * @return {this} This Bob Game Object.
     */ reset: function(x, y, frame) {
                        this.x = x;
                        this.y = y;
                        this.flipX = false;
                        this.flipY = false;
                        this._alpha = 1;
                        this._visible = true;
                        this.parent.dirty = true;
                        if (frame) this.setFrame(frame);
                        return this;
                    },
                    /**
     * Changes the position of this Bob to the values given.
     *
     * @method Phaser.GameObjects.Bob#setPosition
     * @since 3.20.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     *
     * @return {this} This Bob Game Object.
     */ setPosition: function(x, y) {
                        this.x = x;
                        this.y = y;
                        return this;
                    },
                    /**
     * Sets the horizontal flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlipX
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlipX: function(value) {
                        this.flipX = value;
                        return this;
                    },
                    /**
     * Sets the vertical flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlipY
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlipY: function(value) {
                        this.flipY = value;
                        return this;
                    },
                    /**
     * Sets the horizontal and vertical flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlip
     * @since 3.0.0
     *
     * @param {boolean} x - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * @param {boolean} y - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlip: function(x, y) {
                        this.flipX = x;
                        this.flipY = y;
                        return this;
                    },
                    /**
     * Sets the visibility of this Bob.
     *
     * An invisible Bob will skip rendering.
     *
     * @method Phaser.GameObjects.Bob#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible state of the Game Object.
     *
     * @return {this} This Bob Game Object.
     */ setVisible: function(value) {
                        this.visible = value;
                        return this;
                    },
                    /**
     * Set the Alpha level of this Bob. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * A Bob with alpha 0 will skip rendering.
     *
     * @method Phaser.GameObjects.Bob#setAlpha
     * @since 3.0.0
     *
     * @param {number} value - The alpha value used for this Bob. Between 0 and 1.
     *
     * @return {this} This Bob Game Object.
     */ setAlpha: function(value) {
                        this.alpha = value;
                        return this;
                    },
                    /**
     * Sets the tint of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setTint
     * @since 3.20.0
     *
     * @param {number} value - The tint value used for this Bob. Between 0 and 0xffffff.
     *
     * @return {this} This Bob Game Object.
     */ setTint: function(value) {
                        this.tint = value;
                        return this;
                    },
                    /**
     * Destroys this Bob instance.
     * Removes itself from the Blitter and clears the parent, frame and data properties.
     *
     * @method Phaser.GameObjects.Bob#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.parent.dirty = true;
                        this.parent.children.remove(this);
                        this.parent = undefined;
                        this.frame = undefined;
                        this.data = undefined;
                    },
                    /**
     * The visible state of the Bob.
     *
     * An invisible Bob will skip rendering.
     *
     * @name Phaser.GameObjects.Bob#visible
     * @type {boolean}
     * @since 3.0.0
     */ visible: {
                        get: function() {
                            return this._visible;
                        },
                        set: function(value) {
                            this.parent.dirty |= this._visible !== value;
                            this._visible = value;
                        }
                    },
                    /**
     * The alpha value of the Bob, between 0 and 1.
     *
     * A Bob with alpha 0 will skip rendering.
     *
     * @name Phaser.GameObjects.Bob#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                        get: function() {
                            return this._alpha;
                        },
                        set: function(value) {
                            this.parent.dirty |= this._alpha > 0 !== value > 0;
                            this._alpha = value;
                        }
                    }
                });
                module1.exports = Bob;
            /***/ },
            /***/ 16005: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                //  bitmask flag for GameObject.renderMask
                var _FLAG = 2; // 0010
                /**
 * Provides methods used for setting the alpha properties of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Alpha
 * @since 3.0.0
 */ var Alpha = {
                    /**
     * Private internal value. Holds the global alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alpha
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alpha: 1,
                    /**
     * Private internal value. Holds the top-left alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaTL
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaTL: 1,
                    /**
     * Private internal value. Holds the top-right alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaTR
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaTR: 1,
                    /**
     * Private internal value. Holds the bottom-left alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaBL
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaBL: 1,
                    /**
     * Private internal value. Holds the bottom-right alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaBR
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaBR: 1,
                    /**
     * Clears all alpha values associated with this Game Object.
     *
     * Immediately sets the alpha levels back to 1 (fully opaque).
     *
     * @method Phaser.GameObjects.Components.Alpha#clearAlpha
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearAlpha: function() {
                        return this.setAlpha(1);
                    },
                    /**
     * Set the Alpha level of this Game Object. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * If your game is running under WebGL you can optionally specify four different alpha values, each of which
     * correspond to the four corners of the Game Object. Under Canvas only the `topLeft` value given is used.
     *
     * @method Phaser.GameObjects.Components.Alpha#setAlpha
     * @since 3.0.0
     *
     * @param {number} [topLeft=1] - The alpha value used for the top-left of the Game Object. If this is the only value given it's applied across the whole Game Object.
     * @param {number} [topRight] - The alpha value used for the top-right of the Game Object. WebGL only.
     * @param {number} [bottomLeft] - The alpha value used for the bottom-left of the Game Object. WebGL only.
     * @param {number} [bottomRight] - The alpha value used for the bottom-right of the Game Object. WebGL only.
     *
     * @return {this} This Game Object instance.
     */ setAlpha: function(topLeft, topRight, bottomLeft, bottomRight) {
                        if (topLeft === undefined) topLeft = 1;
                        //  Treat as if there is only one alpha value for the whole Game Object
                        if (topRight === undefined) this.alpha = topLeft;
                        else {
                            this._alphaTL = Clamp(topLeft, 0, 1);
                            this._alphaTR = Clamp(topRight, 0, 1);
                            this._alphaBL = Clamp(bottomLeft, 0, 1);
                            this._alphaBR = Clamp(bottomRight, 0, 1);
                        }
                        return this;
                    },
                    /**
     * The alpha value of the Game Object.
     *
     * This is a global value, impacting the entire Game Object, not just a region of it.
     *
     * @name Phaser.GameObjects.Components.Alpha#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                        get: function() {
                            return this._alpha;
                        },
                        set: function(value) {
                            var v = Clamp(value, 0, 1);
                            this._alpha = v;
                            this._alphaTL = v;
                            this._alphaTR = v;
                            this._alphaBL = v;
                            this._alphaBR = v;
                            if (v === 0) this.renderFlags &= ~_FLAG;
                            else this.renderFlags |= _FLAG;
                        }
                    },
                    /**
     * The alpha value starting from the top-left of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaTopLeft
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaTopLeft: {
                        get: function() {
                            return this._alphaTL;
                        },
                        set: function(value) {
                            var v = Clamp(value, 0, 1);
                            this._alphaTL = v;
                            if (v !== 0) this.renderFlags |= _FLAG;
                        }
                    },
                    /**
     * The alpha value starting from the top-right of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaTopRight
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaTopRight: {
                        get: function() {
                            return this._alphaTR;
                        },
                        set: function(value) {
                            var v = Clamp(value, 0, 1);
                            this._alphaTR = v;
                            if (v !== 0) this.renderFlags |= _FLAG;
                        }
                    },
                    /**
     * The alpha value starting from the bottom-left of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaBottomLeft
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaBottomLeft: {
                        get: function() {
                            return this._alphaBL;
                        },
                        set: function(value) {
                            var v = Clamp(value, 0, 1);
                            this._alphaBL = v;
                            if (v !== 0) this.renderFlags |= _FLAG;
                        }
                    },
                    /**
     * The alpha value starting from the bottom-right of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaBottomRight
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaBottomRight: {
                        get: function() {
                            return this._alphaBR;
                        },
                        set: function(value) {
                            var v = Clamp(value, 0, 1);
                            this._alphaBR = v;
                            if (v !== 0) this.renderFlags |= _FLAG;
                        }
                    }
                };
                module1.exports = Alpha;
            /***/ },
            /***/ 88509: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                //  bitmask flag for GameObject.renderMask
                var _FLAG = 2; // 0010
                /**
 * Provides methods used for setting the alpha property of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.AlphaSingle
 * @since 3.22.0
 */ var AlphaSingle = {
                    /**
     * Private internal value. Holds the global alpha value.
     *
     * @name Phaser.GameObjects.Components.AlphaSingle#_alpha
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alpha: 1,
                    /**
     * Clears all alpha values associated with this Game Object.
     *
     * Immediately sets the alpha levels back to 1 (fully opaque).
     *
     * @method Phaser.GameObjects.Components.AlphaSingle#clearAlpha
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearAlpha: function() {
                        return this.setAlpha(1);
                    },
                    /**
     * Set the Alpha level of this Game Object. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * @method Phaser.GameObjects.Components.AlphaSingle#setAlpha
     * @since 3.0.0
     *
     * @param {number} [value=1] - The alpha value applied across the whole Game Object.
     *
     * @return {this} This Game Object instance.
     */ setAlpha: function(value) {
                        if (value === undefined) value = 1;
                        this.alpha = value;
                        return this;
                    },
                    /**
     * The alpha value of the Game Object.
     *
     * This is a global value, impacting the entire Game Object, not just a region of it.
     *
     * @name Phaser.GameObjects.Components.AlphaSingle#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                        get: function() {
                            return this._alpha;
                        },
                        set: function(value) {
                            var v = Clamp(value, 0, 1);
                            this._alpha = v;
                            if (v === 0) this.renderFlags &= ~_FLAG;
                            else this.renderFlags |= _FLAG;
                        }
                    }
                };
                module1.exports = AlphaSingle;
            /***/ },
            /***/ 90065: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(10312);
                /**
 * Provides methods used for setting the blend mode of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.BlendMode
 * @since 3.0.0
 */ var BlendMode = {
                    /**
     * Private internal value. Holds the current blend mode.
     *
     * @name Phaser.GameObjects.Components.BlendMode#_blendMode
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _blendMode: BlendModes.NORMAL,
                    /**
     * Sets the Blend Mode being used by this Game Object.
     *
     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
     *
     * Under WebGL only the following Blend Modes are available:
     *
     * * NORMAL
     * * ADD
     * * MULTIPLY
     * * SCREEN
     * * ERASE
     *
     * Canvas has more available depending on browser support.
     *
     * You can also create your own custom Blend Modes in WebGL.
     *
     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
     * reasons try to be careful about the construction of your Scene and the frequency of which blend modes
     * are used.
     *
     * @name Phaser.GameObjects.Components.BlendMode#blendMode
     * @type {(Phaser.BlendModes|string|number)}
     * @since 3.0.0
     */ blendMode: {
                        get: function() {
                            return this._blendMode;
                        },
                        set: function(value) {
                            if (typeof value === 'string') value = BlendModes[value];
                            value |= 0;
                            if (value >= -1) this._blendMode = value;
                        }
                    },
                    /**
     * Sets the Blend Mode being used by this Game Object.
     *
     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
     *
     * Under WebGL only the following Blend Modes are available:
     *
     * * NORMAL
     * * ADD
     * * MULTIPLY
     * * SCREEN
     * * ERASE (only works when rendering to a framebuffer, like a Render Texture)
     *
     * Canvas has more available depending on browser support.
     *
     * You can also create your own custom Blend Modes in WebGL.
     *
     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
     * reasons try to be careful about the construction of your Scene and the frequency in which blend modes
     * are used.
     *
     * @method Phaser.GameObjects.Components.BlendMode#setBlendMode
     * @since 3.0.0
     *
     * @param {(string|Phaser.BlendModes|number)} value - The BlendMode value. Either a string, a CONST or a number.
     *
     * @return {this} This Game Object instance.
     */ setBlendMode: function(value) {
                        this.blendMode = value;
                        return this;
                    }
                };
                module1.exports = BlendMode;
            /***/ },
            /***/ 94215: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for calculating and setting the size of a non-Frame based Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.ComputedSize
 * @since 3.0.0
 */ var ComputedSize = {
                    /**
     * The native (un-scaled) width of this Game Object.
     *
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayWidth` property.
     *
     * @name Phaser.GameObjects.Components.ComputedSize#width
     * @type {number}
     * @since 3.0.0
     */ width: 0,
                    /**
     * The native (un-scaled) height of this Game Object.
     *
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayHeight` property.
     *
     * @name Phaser.GameObjects.Components.ComputedSize#height
     * @type {number}
     * @since 3.0.0
     */ height: 0,
                    /**
     * The displayed width of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Components.ComputedSize#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                        get: function() {
                            return this.scaleX * this.width;
                        },
                        set: function(value) {
                            this.scaleX = value / this.width;
                        }
                    },
                    /**
     * The displayed height of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Components.ComputedSize#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                        get: function() {
                            return this.scaleY * this.height;
                        },
                        set: function(value) {
                            this.scaleY = value / this.height;
                        }
                    },
                    /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Components.ComputedSize#setSize
     * @since 3.4.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Sets the display size of this Game Object.
     *
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.Components.ComputedSize#setDisplaySize
     * @since 3.4.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setDisplaySize: function(width, height) {
                        this.displayWidth = width;
                        this.displayHeight = height;
                        return this;
                    }
                };
                module1.exports = ComputedSize;
            /***/ },
            /***/ 61683: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Crop
 * @since 3.12.0
 */ var Crop = {
                    /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Crop#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                    /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Crop#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                    /**
     * A boolean flag indicating if this Game Object is being cropped or not.
     * You can toggle this at any time after `setCrop` has been called, to turn cropping on or off.
     * Equally, calling `setCrop` with no arguments will reset the crop and disable it.
     *
     * @name Phaser.GameObjects.Components.Crop#isCropped
     * @type {boolean}
     * @since 3.11.0
     */ isCropped: false,
                    /**
     * Applies a crop to a texture based Game Object, such as a Sprite or Image.
     *
     * The crop is a rectangle that limits the area of the texture frame that is visible during rendering.
     *
     * Cropping a Game Object does not change its size, dimensions, physics body or hit area, it just
     * changes what is shown when rendered.
     *
     * The crop size as well as coordinates can not exceed the the size of the texture frame.
     *
     * The crop coordinates are relative to the texture frame, not the Game Object, meaning 0 x 0 is the top-left.
     *
     * Therefore, if you had a Game Object that had an 800x600 sized texture, and you wanted to show only the left
     * half of it, you could call `setCrop(0, 0, 400, 600)`.
     *
     * It is also scaled to match the Game Object scale automatically. Therefore a crop rectangle of 100x50 would crop
     * an area of 200x100 when applied to a Game Object that had a scale factor of 2.
     *
     * You can either pass in numeric values directly, or you can provide a single Rectangle object as the first argument.
     *
     * Call this method with no arguments at all to reset the crop, or toggle the property `isCropped` to `false`.
     *
     * You should do this if the crop rectangle becomes the same size as the frame itself, as it will allow
     * the renderer to skip several internal calculations.
     *
     * @method Phaser.GameObjects.Components.Crop#setCrop
     * @since 3.11.0
     *
     * @param {(number|Phaser.Geom.Rectangle)} [x] - The x coordinate to start the crop from. Cannot be negative or exceed the Frame width. Or a Phaser.Geom.Rectangle object, in which case the rest of the arguments are ignored.
     * @param {number} [y] - The y coordinate to start the crop from. Cannot be negative or exceed the Frame height.
     * @param {number} [width] - The width of the crop rectangle in pixels. Cannot exceed the Frame width.
     * @param {number} [height] - The height of the crop rectangle in pixels. Cannot exceed the Frame height.
     *
     * @return {this} This Game Object instance.
     */ setCrop: function(x, y, width, height) {
                        if (x === undefined) this.isCropped = false;
                        else if (this.frame) {
                            if (typeof x === 'number') this.frame.setCropUVs(this._crop, x, y, width, height, this.flipX, this.flipY);
                            else {
                                var rect = x;
                                this.frame.setCropUVs(this._crop, rect.x, rect.y, rect.width, rect.height, this.flipX, this.flipY);
                            }
                            this.isCropped = true;
                        }
                        return this;
                    },
                    /**
     * Internal method that returns a blank, well-formed crop object for use by a Game Object.
     *
     * @method Phaser.GameObjects.Components.Crop#resetCropObject
     * @private
     * @since 3.12.0
     *
     * @return {object} The crop object.
     */ resetCropObject: function() {
                        return {
                            u0: 0,
                            v0: 0,
                            u1: 0,
                            v1: 0,
                            width: 0,
                            height: 0,
                            x: 0,
                            y: 0,
                            flipX: false,
                            flipY: false,
                            cx: 0,
                            cy: 0,
                            cw: 0,
                            ch: 0
                        };
                    }
                };
                module1.exports = Crop;
            /***/ },
            /***/ 89272: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the depth of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Depth
 * @since 3.0.0
 */ var ArrayUtils = __webpack_require__(37105);
                var Depth = {
                    /**
     * Private internal value. Holds the depth of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Depth#_depth
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _depth: 0,
                    /**
     * The depth of this Game Object within the Scene. Ensure this value is only ever set to a number data-type.
     *
     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
     * of Game Objects, without actually moving their position in the display list.
     *
     * The default depth is zero. A Game Object with a higher depth
     * value will always render in front of one with a lower value.
     *
     * Setting the depth will queue a depth sort event within the Scene.
     *
     * @name Phaser.GameObjects.Components.Depth#depth
     * @type {number}
     * @since 3.0.0
     */ depth: {
                        get: function() {
                            return this._depth;
                        },
                        set: function(value) {
                            if (this.displayList) this.displayList.queueDepthSort();
                            this._depth = value;
                        }
                    },
                    /**
     * The depth of this Game Object within the Scene.
     *
     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
     * of Game Objects, without actually moving their position in the display list.
     *
     * The default depth is zero. A Game Object with a higher depth
     * value will always render in front of one with a lower value.
     *
     * Setting the depth will queue a depth sort event within the Scene.
     *
     * @method Phaser.GameObjects.Components.Depth#setDepth
     * @since 3.0.0
     *
     * @param {number} value - The depth of this Game Object. Ensure this value is only ever a number data-type.
     *
     * @return {this} This Game Object instance.
     */ setDepth: function(value) {
                        if (value === undefined) value = 0;
                        this.depth = value;
                        return this;
                    },
                    /**
     * Sets this Game Object to be at the top of the display list, or the top of its parent container.
     * 
     * Being at the top means it will render on-top of everything else.
     * 
     * This method does not change this Game Objects `depth` value, it simply alters its list position.
     *
     * @method Phaser.GameObjects.Components.Depth#setToTop
     * @since 3.85.0
     * 
     * @return {this} This Game Object instance.
     */ setToTop: function() {
                        var list = this.getDisplayList();
                        if (list) ArrayUtils.BringToTop(list, this);
                        return this;
                    },
                    /**
     * Sets this Game Object to the back of the display list, or the back of its parent container.
     * 
     * Being at the back means it will render below everything else.
     * 
     * This method does not change this Game Objects `depth` value, it simply alters its list position.
     *
     * @method Phaser.GameObjects.Components.Depth#setToBack
     * @since 3.85.0
     * 
     * @return {this} This Game Object instance.
     */ setToBack: function() {
                        var list = this.getDisplayList();
                        if (list) ArrayUtils.SendToBack(list, this);
                        return this;
                    },
                    /**
     * Move this Game Object so that it appears above the given Game Object.
     * 
     * This means it will render immediately after the other object in the display list.
     * 
     * Both objects must belong to the same display list, or parent container.
     * 
     * This method does not change this Game Objects `depth` value, it simply alters its list position.
     *
     * @method Phaser.GameObjects.Components.Depth#setAbove
     * @since 3.85.0
     * 
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that this Game Object will be moved to be above.
     * 
     * @return {this} This Game Object instance.
     */ setAbove: function(gameObject) {
                        var list = this.getDisplayList();
                        if (list && gameObject) ArrayUtils.MoveAbove(list, this, gameObject);
                        return this;
                    },
                    /**
     * Move this Game Object so that it appears below the given Game Object.
     * 
     * This means it will render immediately under the other object in the display list.
     * 
     * Both objects must belong to the same display list, or parent container.
     * 
     * This method does not change this Game Objects `depth` value, it simply alters its list position.
     *
     * @method Phaser.GameObjects.Components.Depth#setBelow
     * @since 3.85.0
     * 
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that this Game Object will be moved to be below.
     * 
     * @return {this} This Game Object instance.
     */ setBelow: function(gameObject) {
                        var list = this.getDisplayList();
                        if (list && gameObject) ArrayUtils.MoveBelow(list, this, gameObject);
                        return this;
                    }
                };
                module1.exports = Depth;
            /***/ },
            /***/ 47059: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Effects = __webpack_require__(66064);
                var SpliceOne = __webpack_require__(19133);
                /**
 * @classdesc
 * The FX Component features a set of methods used for applying a range of special built-in effects to a Game Object.
 *
 * The effects include the following:
 *
 * * Barrel Distortion
 * * Bloom
 * * Blur
 * * Bokeh / Tilt Shift
 * * Circle Outline
 * * Color Matrix
 * * Glow
 * * Displacement
 * * Gradient
 * * Pixelate
 * * Shine
 * * Shadow
 * * Vignette
 * * Wipe / Reveal
 *
 * All Game Objects support Post FX. These are effects applied after the Game Object has been rendered.
 *
 * Texture-based Game Objects also support Pre FX, including:
 *
 * * Image
 * * Sprite
 * * TileSprite
 * * Text
 * * RenderTexture
 * * Video
 *
 * And any Game Object that extends the above.
 *
 * The difference between Pre FX and Post FX are that all Post FX take place in a canvas (renderer) sized frame buffer,
 * after the Game Object has been rendered. Pre FX, however, take place in a texture sized frame buffer, which is sized
 * based on the Game Object itself. The end result is then composited back to the main game canvas. For intensive effects,
 * such as blur, bloom or glow, which can require many iterations, this is a much more efficient way to apply the effect,
 * as only it only has to work on a Game Object sized texture and not all pixels in the canvas.
 *
 * In short, you should always try and use a Pre FX if you can.
 *
 * Due to the way that FX work they can be stacked-up. For example, you can apply a blur to a Game Object, then apply
 * a bloom effect to the same Game Object. The bloom effect will be applied to the blurred texture, not the original.
 * Keep the order in mind when stacking effects.
 *
 * All effects are WebGL only and do not have canvas counterparts.
 *
 * As you can appreciate, some effects are more expensive than others. For example, a bloom effect is going to be more
 * expensive than a simple color matrix effect, so please consider using them wisely and performance test your target
 * platforms early on in production.
 *
 * This component is created automatically by the `PostPipeline` class and does not need to be instantiated directly.
 *
 * @class FX
 * @memberof Phaser.GameObjects.Components
 * @constructor
 * @since 3.60.0
 * @webglOnly
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - A reference to the Game Object that owns this FX Component.
 * @param {boolean} isPost - Is this a Pre or Post FX Component?
 */ var FX = new Class({
                    initialize: function FX(gameObject, isPost) {
                        /**
         * A reference to the Game Object that owns this FX Component.
         *
         * @name Phaser.GameObjects.Components.FX#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @readonly
         * @since 3.60.0
         */ this.gameObject = gameObject;
                        /**
         * Is this a Post FX Controller? or a Pre FX Controller?
         *
         * @name Phaser.GameObjects.Components.FX#isPost
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isPost = isPost;
                        /**
         * Has this FX Component been enabled?
         *
         * You should treat this property as read-only, although it is toggled
         * automaticaly during internal use.
         *
         * @name Phaser.GameObjects.Components.FX#enabled
         * @type {boolean}
         * @since 3.60.0
         */ this.enabled = false;
                        /**
         * An array containing all of the Pre FX Controllers that
         * have been added to this FX Component. They are processed in
         * the order they are added.
         *
         * This array is empty if this is a Post FX Component.
         *
         * @name Phaser.GameObjects.Components.FX#list
         * @type {Phaser.FX.Controller[]}
         * @since 3.60.0
         */ this.list = [];
                        /**
         * The amount of extra padding to be applied to this Game Object
         * when it is being rendered by a PreFX Pipeline.
         *
         * Lots of FX require additional spacing added to the texture the
         * Game Object uses, for example a glow or shadow effect, and this
         * method allows you to control how much extra padding is included
         * in addition to the texture size.
         *
         * You do not need to set this if you're only using Post FX.
         *
         * @name Phaser.GameObjects.Components.FX#padding
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.padding = 0;
                    },
                    /**
     * Sets the amount of extra padding to be applied to this Game Object
     * when it is being rendered by a PreFX Pipeline.
     *
     * Lots of FX require additional spacing added to the texture the
     * Game Object uses, for example a glow or shadow effect, and this
     * method allows you to control how much extra padding is included
     * in addition to the texture size.
     *
     * You do not need to set this if you're only using Post FX.
     *
     * @method Phaser.GameObjects.Components.FX#setPadding
     * @webglOnly
     * @since 3.60.0
     *
     * @param {number} [padding=0] - The amount of padding to add to this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setPadding: function(padding) {
                        if (padding === undefined) padding = 0;
                        this.padding = padding;
                        return this.gameObject;
                    },
                    /**
     * This callback is invoked when this Game Object is copied by a PreFX Pipeline.
     *
     * This happens when the pipeline uses its `copySprite` method.
     *
     * It's invoked prior to the copy, allowing you to set shader uniforms, etc on the pipeline.
     *
     * @method Phaser.GameObjects.Components.FX#onFXCopy
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.PreFXPipeline} pipeline - The PreFX Pipeline that invoked this callback.
     */ onFXCopy: function() {},
                    /**
     * This callback is invoked when this Game Object is rendered by a PreFX Pipeline.
     *
     * This happens when the pipeline uses its `drawSprite` method.
     *
     * It's invoked prior to the draw, allowing you to set shader uniforms, etc on the pipeline.
     *
     * @method Phaser.GameObjects.Components.FX#onFX
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.PreFXPipeline} pipeline - The PreFX Pipeline that invoked this callback.
     */ onFX: function() {},
                    /**
     * Enables this FX Component and applies the FXPipeline to the parent Game Object.
     *
     * This is called automatically whenever you call a method such as `addBloom`, etc.
     *
     * You can check the `enabled` property to see if the Game Object is already enabled, or not.
     *
     * This only applies to Pre FX. Post FX are always enabled.
     *
     * @method Phaser.GameObjects.Components.FX#enable
     * @since 3.60.0
     *
     * @param {number} [padding=0] - The amount of padding to add to this Game Object.
     */ enable: function(padding) {
                        if (this.isPost) return;
                        var renderer = this.gameObject.scene.sys.renderer;
                        if (renderer && renderer.pipelines) {
                            this.gameObject.pipeline = renderer.pipelines.FX_PIPELINE;
                            if (padding !== undefined) this.padding = padding;
                            this.enabled = true;
                        } else this.enabled = false;
                    },
                    /**
     * Destroys and removes all FX Controllers that are part of this FX Component,
     * then disables it.
     *
     * If this is a Pre FX Component it will only remove Pre FX.
     * If this is a Post FX Component it will only remove Post FX.
     *
     * To remove both at once use the `GameObject.clearFX` method instead.
     *
     * @method Phaser.GameObjects.Components.FX#clear
     * @since 3.60.0
     *
     * @return {this} This Game Object instance.
     */ clear: function() {
                        if (this.isPost) this.gameObject.resetPostPipeline(true);
                        else {
                            var list = this.list;
                            for(var i = 0; i < list.length; i++)list[i].destroy();
                            this.list = [];
                        }
                        this.enabled = false;
                        return this.gameObject;
                    },
                    /**
     * Searches for the given FX Controller within this FX Component.
     *
     * If found, the controller is removed from this component and then destroyed.
     *
     * @method Phaser.GameObjects.Components.FX#remove
     * @since 3.60.0
     *
     * @generic {Phaser.FX.Controller} T
     * @genericUse {T} - [fx]
     *
     * @param {Phaser.FX.Controller} fx - The FX Controller to remove from this FX Component.
     *
     * @return {this} This Game Object instance.
     */ remove: function(fx) {
                        var i;
                        if (this.isPost) {
                            var pipelines = this.gameObject.getPostPipeline(String(fx.type));
                            if (!Array.isArray(pipelines)) pipelines = [
                                pipelines
                            ];
                            for(i = 0; i < pipelines.length; i++){
                                var pipeline = pipelines[i];
                                if (pipeline.controller === fx) {
                                    this.gameObject.removePostPipeline(pipeline);
                                    fx.destroy();
                                    break;
                                }
                            }
                        } else {
                            var list = this.list;
                            for(i = 0; i < list.length; i++)if (list[i] === fx) {
                                SpliceOne(list, i);
                                fx.destroy();
                            }
                        }
                        return this.gameObject;
                    },
                    /**
     * Disables this FX Component.
     *
     * This will reset the pipeline on the Game Object that owns this component back to its
     * default and flag this component as disabled.
     *
     * You can re-enable it again by calling `enable` for Pre FX or by adding an FX for Post FX.
     *
     * Optionally, set `clear` to destroy all current FX Controllers.
     *
     * @method Phaser.GameObjects.Components.FX#disable
     * @since 3.60.0
     *
     * @param {boolean} [clear=false] - Destroy and remove all FX Controllers that are part of this component.
     *
     * @return {this} This Game Object instance.
     */ disable: function(clear) {
                        if (clear === undefined) clear = false;
                        if (!this.isPost) this.gameObject.resetPipeline();
                        this.enabled = false;
                        if (clear) this.clear();
                        return this.gameObject;
                    },
                    /**
     * Adds the given FX Controler to this FX Component.
     *
     * Note that adding an FX Controller does not remove any existing FX. They all stack-up
     * on-top of each other. If you don't want this, make sure to call either `remove` or
     * `clear` first.
     *
     * @method Phaser.GameObjects.Components.FX#add
     * @since 3.60.0
     *
     * @generic {Phaser.FX.Controller} T
     * @genericUse {T} - [fx]
     *
     * @param {Phaser.FX.Controller} fx - The FX Controller to add to this FX Component.
     * @param {object} [config] - Optional configuration object that is passed to the pipeline during instantiation.
     *
     * @return {Phaser.FX.Controller} The FX Controller.
     */ add: function(fx, config) {
                        if (this.isPost) {
                            var type = String(fx.type);
                            this.gameObject.setPostPipeline(type, config);
                            var pipeline = this.gameObject.getPostPipeline(type);
                            if (pipeline) {
                                if (Array.isArray(pipeline)) pipeline = pipeline.pop();
                                if (pipeline) pipeline.controller = fx;
                                return fx;
                            }
                        } else {
                            if (!this.enabled) this.enable();
                            this.list.push(fx);
                            return fx;
                        }
                    },
                    /**
     * Adds a Glow effect.
     *
     * The glow effect is a visual technique that creates a soft, luminous halo around game objects,
     * characters, or UI elements. This effect is used to emphasize importance, enhance visual appeal,
     * or convey a sense of energy, magic, or otherworldly presence. The effect can also be set on
     * the inside of the Game Object. The color and strength of the glow can be modified.
     *
     * @method Phaser.GameObjects.Components.FX#addGlow
     * @since 3.60.0
     *
     * @param {number} [color=0xffffff] - The color of the glow effect as a number value.
     * @param {number} [outerStrength=4] - The strength of the glow outward from the edge of the Sprite.
     * @param {number} [innerStrength=0] - The strength of the glow inward from the edge of the Sprite.
     * @param {boolean} [knockout=false] - If `true` only the glow is drawn, not the texture itself.
     * @param {number} [quality=0.1] - Only available for PostFX. Sets the quality of this Glow effect. Default is 0.1. Cannot be changed post-creation.
     * @param {number} [distance=10] - Only available for PostFX. Sets the distance of this Glow effect. Default is 10. Cannot be changed post-creation.
     *
     * @return {Phaser.FX.Glow} The Glow FX Controller.
     */ addGlow: function(color, outerStrength, innerStrength, knockout, quality, distance) {
                        return this.add(new Effects.Glow(this.gameObject, color, outerStrength, innerStrength, knockout), {
                            quality: quality,
                            distance: distance
                        });
                    },
                    /**
     * Adds a Shadow effect.
     *
     * The shadow effect is a visual technique used to create the illusion of depth and realism by adding darker,
     * offset silhouettes or shapes beneath game objects, characters, or environments. These simulated shadows
     * help to enhance the visual appeal and immersion, making the 2D game world appear more dynamic and three-dimensional.
     *
     * @method Phaser.GameObjects.Components.FX#addShadow
     * @since 3.60.0
     *
     * @param {number} [x=0] - The horizontal offset of the shadow effect.
     * @param {number} [y=0] - The vertical offset of the shadow effect.
     * @param {number} [decay=0.1] - The amount of decay for shadow effect.
     * @param {number} [power=1] - The power of the shadow effect.
     * @param {number} [color=0x000000] - The color of the shadow.
     * @param {number} [samples=6] - The number of samples that the shadow effect will run for. An integer between 1 and 12.
     * @param {number} [intensity=1] - The intensity of the shadow effect.
     *
     * @return {Phaser.FX.Shadow} The Shadow FX Controller.
     */ addShadow: function(x, y, decay, power, color, samples, intensity) {
                        return this.add(new Effects.Shadow(this.gameObject, x, y, decay, power, color, samples, intensity));
                    },
                    /**
     * Adds a Pixelate effect.
     *
     * The pixelate effect is a visual technique that deliberately reduces the resolution or detail of an image,
     * creating a blocky or mosaic appearance composed of large, visible pixels. This effect can be used for stylistic
     * purposes, as a homage to retro gaming, or as a means to obscure certain elements within the game, such as
     * during a transition or to censor specific content.
     *
     * @method Phaser.GameObjects.Components.FX#addPixelate
     * @since 3.60.0
     *
     * @param {number} [amount=1] - The amount of pixelation to apply.
     *
     * @return {Phaser.FX.Pixelate} The Pixelate FX Controller.
     */ addPixelate: function(amount) {
                        return this.add(new Effects.Pixelate(this.gameObject, amount));
                    },
                    /**
     * Adds a Vignette effect.
     *
     * The vignette effect is a visual technique where the edges of the screen, or a Game Object, gradually darken or blur,
     * creating a frame-like appearance. This effect is used to draw the player's focus towards the central action or subject,
     * enhance immersion, and provide a cinematic or artistic quality to the game's visuals.
     *
     * @method Phaser.GameObjects.Components.FX#addVignette
     * @since 3.60.0
     *
     * @param {number} [x=0.5] - The horizontal offset of the vignette effect. This value is normalized to the range 0 to 1.
     * @param {number} [y=0.5] - The vertical offset of the vignette effect. This value is normalized to the range 0 to 1.
     * @param {number} [radius=0.5] - The radius of the vignette effect. This value is normalized to the range 0 to 1.
     * @param {number} [strength=0.5] - The strength of the vignette effect.
     *
     * @return {Phaser.FX.Vignette} The Vignette FX Controller.
     */ addVignette: function(x, y, radius, strength) {
                        return this.add(new Effects.Vignette(this.gameObject, x, y, radius, strength));
                    },
                    /**
     * Adds a Shine effect.
     *
     * The shine effect is a visual technique that simulates the appearance of reflective
     * or glossy surfaces by passing a light beam across a Game Object. This effect is used to
     * enhance visual appeal, emphasize certain features, and create a sense of depth or
     * material properties.
     *
     * @method Phaser.GameObjects.Components.FX#addShine
     * @since 3.60.0
     *
     * @param {number} [speed=0.5] - The speed of the Shine effect.
     * @param {number} [lineWidth=0.5] - The line width of the Shine effect.
     * @param {number} [gradient=3] - The gradient of the Shine effect.
     * @param {boolean} [reveal=false] - Does this Shine effect reveal or get added to its target?
     *
     * @return {Phaser.FX.Shine} The Shine FX Controller.
     */ addShine: function(speed, lineWidth, gradient, reveal) {
                        return this.add(new Effects.Shine(this.gameObject, speed, lineWidth, gradient, reveal));
                    },
                    /**
     * Adds a Blur effect.
     *
     * A Gaussian blur is the result of blurring an image by a Gaussian function. It is a widely used effect,
     * typically to reduce image noise and reduce detail. The visual effect of this blurring technique is a
     * smooth blur resembling that of viewing the image through a translucent screen, distinctly different
     * from the bokeh effect produced by an out-of-focus lens or the shadow of an object under usual illumination.
     *
     * @method Phaser.GameObjects.Components.FX#addBlur
     * @since 3.60.0
     *
     * @param {number} [quality=0] - The quality of the blur effect. Can be either 0 for Low Quality, 1 for Medium Quality or 2 for High Quality.
     * @param {number} [x=2] - The horizontal offset of the blur effect.
     * @param {number} [y=2] - The vertical offset of the blur effect.
     * @param {number} [strength=1] - The strength of the blur effect.
     * @param {number} [color=0xffffff] - The color of the blur, as a hex value.
     * @param {number} [steps=4] - The number of steps to run the blur effect for. This value should always be an integer.
     *
     * @return {Phaser.FX.Blur} The Blur FX Controller.
     */ addBlur: function(quality, x, y, strength, color, steps) {
                        return this.add(new Effects.Blur(this.gameObject, quality, x, y, strength, color, steps));
                    },
                    /**
     * Adds a Gradient effect.
     *
     * The gradient overlay effect is a visual technique where a smooth color transition is applied over Game Objects,
     * such as sprites or UI components. This effect is used to enhance visual appeal, emphasize depth, or create
     * stylistic and atmospheric variations. It can also be utilized to convey information, such as representing
     * progress or health status through color changes.
     *
     * @method Phaser.GameObjects.Components.FX#addGradient
     * @since 3.60.0
     *
     * @param {number} [color1=0xff0000] - The first gradient color, given as a number value.
     * @param {number} [color2=0x00ff00] - The second gradient color, given as a number value.
     * @param {number} [alpha=0.2] - The alpha value of the gradient effect.
     * @param {number} [fromX=0] - The horizontal position the gradient will start from. This value is normalized, between 0 and 1, and is not in pixels.
     * @param {number} [fromY=0] - The vertical position the gradient will start from. This value is normalized, between 0 and 1, and is not in pixels.
     * @param {number} [toX=0] - The horizontal position the gradient will end at. This value is normalized, between 0 and 1, and is not in pixels.
     * @param {number} [toY=1] - The vertical position the gradient will end at. This value is normalized, between 0 and 1, and is not in pixels.
     * @param {number} [size=0] - How many 'chunks' the gradient is divided in to, as spread over the entire height of the texture. Leave this at zero for a smooth gradient, or set higher for a more retro chunky effect.
     *
     * @return {Phaser.FX.Gradient} The Gradient FX Controller.
     */ addGradient: function(color1, color2, alpha, fromX, fromY, toX, toY, size) {
                        return this.add(new Effects.Gradient(this.gameObject, color1, color2, alpha, fromX, fromY, toX, toY, size));
                    },
                    /**
     * Adds a Bloom effect.
     *
     * Bloom is an effect used to reproduce an imaging artifact of real-world cameras.
     * The effect produces fringes of light extending from the borders of bright areas in an image,
     * contributing to the illusion of an extremely bright light overwhelming the
     * camera or eye capturing the scene.
     *
     * @method Phaser.GameObjects.Components.FX#addBloom
     * @since 3.60.0
     *
     * @param {number} [color] - The color of the Bloom, as a hex value.
     * @param {number} [offsetX=1] - The horizontal offset of the bloom effect.
     * @param {number} [offsetY=1] - The vertical offset of the bloom effect.
     * @param {number} [blurStrength=1] - The strength of the blur process of the bloom effect.
     * @param {number} [strength=1] - The strength of the blend process of the bloom effect.
     * @param {number} [steps=4] - The number of steps to run the Bloom effect for. This value should always be an integer.
     *
     * @return {Phaser.FX.Bloom} The Bloom FX Controller.
     */ addBloom: function(color, offsetX, offsetY, blurStrength, strength, steps) {
                        return this.add(new Effects.Bloom(this.gameObject, color, offsetX, offsetY, blurStrength, strength, steps));
                    },
                    /**
     * Adds a ColorMatrix effect.
     *
     * The color matrix effect is a visual technique that involves manipulating the colors of an image
     * or scene using a mathematical matrix. This process can adjust hue, saturation, brightness, and contrast,
     * allowing developers to create various stylistic appearances or mood settings within the game.
     * Common applications include simulating different lighting conditions, applying color filters,
     * or achieving a specific visual style.
     *
     * @method Phaser.GameObjects.Components.FX#addColorMatrix
     * @since 3.60.0
     *
     * @return {Phaser.FX.ColorMatrix} The ColorMatrix FX Controller.
     */ addColorMatrix: function() {
                        return this.add(new Effects.ColorMatrix(this.gameObject));
                    },
                    /**
     * Adds a Circle effect.
     *
     * This effect will draw a circle around the texture of the Game Object, effectively masking off
     * any area outside of the circle without the need for an actual mask. You can control the thickness
     * of the circle, the color of the circle and the color of the background, should the texture be
     * transparent. You can also control the feathering applied to the circle, allowing for a harsh or soft edge.
     *
     * Please note that adding this effect to a Game Object will not change the input area or physics body of
     * the Game Object, should it have one.
     *
     * @method Phaser.GameObjects.Components.FX#addCircle
     * @since 3.60.0
     *
     * @param {number} [thickness=8] - The width of the circle around the texture, in pixels.
     * @param {number} [color=0xfeedb6] - The color of the circular ring, given as a number value.
     * @param {number} [backgroundColor=0xff0000] - The color of the background, behind the texture, given as a number value.
     * @param {number} [scale=1] - The scale of the circle. The default scale is 1, which is a circle the full size of the underlying texture.
     * @param {number} [feather=0.005] - The amount of feathering to apply to the circle from the ring.
     *
     * @return {Phaser.FX.Circle} The Circle FX Controller.
     */ addCircle: function(thickness, color, backgroundColor, scale, feather) {
                        return this.add(new Effects.Circle(this.gameObject, thickness, color, backgroundColor, scale, feather));
                    },
                    /**
     * Adds a Barrel effect.
     *
     * A barrel effect allows you to apply either a 'pinch' or 'expand' distortion to
     * a Game Object. The amount of the effect can be modified in real-time.
     *
     * @method Phaser.GameObjects.Components.FX#addBarrel
     * @since 3.60.0
     *
     * @param {number} [amount=1] - The amount of distortion applied to the barrel effect. A value of 1 is no distortion. Typically keep this within +- 1.
     *
     * @return {Phaser.FX.Barrel} The Barrel FX Controller.
     */ addBarrel: function(amount) {
                        return this.add(new Effects.Barrel(this.gameObject, amount));
                    },
                    /**
     * Adds a Displacement effect.
     *
     * The displacement effect is a visual technique that alters the position of pixels in an image
     * or texture based on the values of a displacement map. This effect is used to create the illusion
     * of depth, surface irregularities, or distortion in otherwise flat elements. It can be applied to
     * characters, objects, or backgrounds to enhance realism, convey movement, or achieve various
     * stylistic appearances.
     *
     * @method Phaser.GameObjects.Components.FX#addDisplacement
     * @since 3.60.0
     *
     * @param {string} [texture='__WHITE'] - The unique string-based key of the texture to use for displacement, which must exist in the Texture Manager.
     * @param {number} [x=0.005] - The amount of horizontal displacement to apply. A very small float number, such as 0.005.
     * @param {number} [y=0.005] - The amount of vertical displacement to apply. A very small float number, such as 0.005.
     *
     * @return {Phaser.FX.Displacement} The Displacement FX Controller.
     */ addDisplacement: function(texture, x, y) {
                        return this.add(new Effects.Displacement(this.gameObject, texture, x, y));
                    },
                    /**
     * Adds a Wipe effect.
     *
     * The wipe or reveal effect is a visual technique that gradually uncovers or conceals elements
     * in the game, such as images, text, or scene transitions. This effect is often used to create
     * a sense of progression, reveal hidden content, or provide a smooth and visually appealing transition
     * between game states.
     *
     * You can set both the direction and the axis of the wipe effect. The following combinations are possible:
     *
     * * left to right: direction 0, axis 0
     * * right to left: direction 1, axis 0
     * * top to bottom: direction 1, axis 1
     * * bottom to top: direction 1, axis 0
     *
     * It is up to you to set the `progress` value yourself, i.e. via a Tween, in order to transition the effect.
     *
     * @method Phaser.GameObjects.Components.FX#addWipe
     * @since 3.60.0
     *
     * @param {number} [wipeWidth=0.1] - The width of the wipe effect. This value is normalized in the range 0 to 1.
     * @param {number} [direction=0] - The direction of the wipe effect. Either 0 or 1. Set in conjunction with the axis property.
     * @param {number} [axis=0] - The axis of the wipe effect. Either 0 or 1. Set in conjunction with the direction property.
     *
     * @return {Phaser.FX.Wipe} The Wipe FX Controller.
     */ addWipe: function(wipeWidth, direction, axis) {
                        return this.add(new Effects.Wipe(this.gameObject, wipeWidth, direction, axis));
                    },
                    /**
     * Adds a Reveal Wipe effect.
     *
     * The wipe or reveal effect is a visual technique that gradually uncovers or conceals elements
     * in the game, such as images, text, or scene transitions. This effect is often used to create
     * a sense of progression, reveal hidden content, or provide a smooth and visually appealing transition
     * between game states.
     *
     * You can set both the direction and the axis of the wipe effect. The following combinations are possible:
     *
     * * left to right: direction 0, axis 0
     * * right to left: direction 1, axis 0
     * * top to bottom: direction 1, axis 1
     * * bottom to top: direction 1, axis 0
     *
     * It is up to you to set the `progress` value yourself, i.e. via a Tween, in order to transition the effect.
     *
     * @method Phaser.GameObjects.Components.FX#addReveal
     * @since 3.60.0
     *
     * @param {number} [wipeWidth=0.1] - The width of the wipe effect. This value is normalized in the range 0 to 1.
     * @param {number} [direction=0] - The direction of the wipe effect. Either 0 or 1. Set in conjunction with the axis property.
     * @param {number} [axis=0] - The axis of the wipe effect. Either 0 or 1. Set in conjunction with the direction property.
     *
     * @return {Phaser.FX.Wipe} The Wipe FX Controller.
     */ addReveal: function(wipeWidth, direction, axis) {
                        return this.add(new Effects.Wipe(this.gameObject, wipeWidth, direction, axis, true));
                    },
                    /**
     * Adds a Bokeh effect.
     *
     * Bokeh refers to a visual effect that mimics the photographic technique of creating a shallow depth of field.
     * This effect is used to emphasize the game's main subject or action, by blurring the background or foreground
     * elements, resulting in a more immersive and visually appealing experience. It is achieved through rendering
     * techniques that simulate the out-of-focus areas, giving a sense of depth and realism to the game's graphics.
     *
     * See also Tilt Shift.
     *
     * @method Phaser.GameObjects.Components.FX#addBokeh
     * @since 3.60.0
     *
     * @param {number} [radius=0.5] - The radius of the bokeh effect.
     * @param {number} [amount=1] - The amount of the bokeh effect.
     * @param {number} [contrast=0.2] - The color contrast of the bokeh effect.
     *
     * @return {Phaser.FX.Bokeh} The Bokeh FX Controller.
     */ addBokeh: function(radius, amount, contrast) {
                        return this.add(new Effects.Bokeh(this.gameObject, radius, amount, contrast));
                    },
                    /**
     * Adds a Tilt Shift effect.
     *
     * This Bokeh effect can also be used to generate a Tilt Shift effect, which is a technique used to create a miniature
     * effect by blurring everything except a small area of the image. This effect is achieved by blurring the
     * top and bottom elements, while keeping the center area in focus.
     *
     * See also Bokeh.
     *
     * @method Phaser.GameObjects.Components.FX#addTiltShift
     * @since 3.60.0
     *
     * @param {number} [radius=0.5] - The radius of the bokeh effect.
     * @param {number} [amount=1] - The amount of the bokeh effect.
     * @param {number} [contrast=0.2] - The color contrast of the bokeh effect.
     * @param {number} [blurX=1] - The amount of horizontal blur.
     * @param {number} [blurY=1] - The amount of vertical blur.
     * @param {number} [strength=1] - The strength of the blur.
     *
     * @return {Phaser.FX.Bokeh} The Bokeh TiltShift FX Controller.
     */ addTiltShift: function(radius, amount, contrast, blurX, blurY, strength) {
                        return this.add(new Effects.Bokeh(this.gameObject, radius, amount, contrast, true, blurX, blurY, strength));
                    },
                    /**
     * Destroys this FX Component.
     *
     * Called automatically when Game Objects are destroyed.
     *
     * @method Phaser.GameObjects.Components.FX#destroy
     * @since 3.60.0
     */ destroy: function() {
                        this.clear();
                        this.gameObject = null;
                    }
                });
                module1.exports = FX;
            /***/ },
            /***/ 54434: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for visually flipping a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Flip
 * @since 3.0.0
 */ var Flip = {
                    /**
     * The horizontally flipped state of the Game Object.
     *
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Components.Flip#flipX
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ flipX: false,
                    /**
     * The vertically flipped state of the Game Object.
     *
     * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Components.Flip#flipY
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ flipY: false,
                    /**
     * Toggles the horizontal flipped state of this Game Object.
     *
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @method Phaser.GameObjects.Components.Flip#toggleFlipX
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ toggleFlipX: function() {
                        this.flipX = !this.flipX;
                        return this;
                    },
                    /**
     * Toggles the vertical flipped state of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Flip#toggleFlipY
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ toggleFlipY: function() {
                        this.flipY = !this.flipY;
                        return this;
                    },
                    /**
     * Sets the horizontal flipped state of this Game Object.
     *
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @method Phaser.GameObjects.Components.Flip#setFlipX
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Game Object instance.
     */ setFlipX: function(value) {
                        this.flipX = value;
                        return this;
                    },
                    /**
     * Sets the vertical flipped state of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Flip#setFlipY
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Game Object instance.
     */ setFlipY: function(value) {
                        this.flipY = value;
                        return this;
                    },
                    /**
     * Sets the horizontal and vertical flipped state of this Game Object.
     *
     * A Game Object that is flipped will render inversed on the flipped axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @method Phaser.GameObjects.Components.Flip#setFlip
     * @since 3.0.0
     *
     * @param {boolean} x - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * @param {boolean} y - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Game Object instance.
     */ setFlip: function(x, y) {
                        this.flipX = x;
                        this.flipY = y;
                        return this;
                    },
                    /**
     * Resets the horizontal and vertical flipped state of this Game Object back to their default un-flipped state.
     *
     * @method Phaser.GameObjects.Components.Flip#resetFlip
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ resetFlip: function() {
                        this.flipX = false;
                        this.flipY = false;
                        return this;
                    }
                };
                module1.exports = Flip;
            /***/ },
            /***/ 8004: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                var RotateAround = __webpack_require__(11520);
                var Vector2 = __webpack_require__(26099);
                /**
 * Provides methods used for obtaining the bounds of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.GetBounds
 * @since 3.0.0
 */ var GetBounds = {
                    /**
     * Processes the bounds output vector before returning it.
     *
     * @method Phaser.GameObjects.Components.GetBounds#prepareBoundsOutput
     * @private
     * @since 3.18.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} output - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ prepareBoundsOutput: function(output, includeParent) {
                        if (includeParent === undefined) includeParent = false;
                        if (this.rotation !== 0) RotateAround(output, this.x, this.y, this.rotation);
                        if (includeParent && this.parentContainer) {
                            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                            parentMatrix.transformPoint(output.x, output.y, output);
                        }
                        return output;
                    },
                    /**
     * Gets the center coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getCenter
     * @since 3.0.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getCenter: function(output, includeParent) {
                        if (output === undefined) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                        output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the top-left corner coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopLeft
     * @since 3.0.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getTopLeft: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX;
                        output.y = this.y - this.displayHeight * this.originY;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the top-center coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getTopCenter: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                        output.y = this.y - this.displayHeight * this.originY;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the top-right corner coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopRight
     * @since 3.0.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getTopRight: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                        output.y = this.y - this.displayHeight * this.originY;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the left-center coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getLeftCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getLeftCenter: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX;
                        output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the right-center coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getRightCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getRightCenter: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                        output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the bottom-left corner coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomLeft
     * @since 3.0.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getBottomLeft: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX;
                        output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the bottom-center coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getBottomCenter: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                        output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the bottom-right corner coordinate of this Game Object, regardless of origin.
     *
     * The returned point is calculated in local space and does not factor in any parent Containers,
     * unless the `includeParent` argument is set to `true`.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomRight
     * @since 3.0.0
     *
     * @generic {Phaser.Types.Math.Vector2Like} O - [output,$return]
     *
     * @param {Phaser.Types.Math.Vector2Like} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {Phaser.Types.Math.Vector2Like} The values stored in the output object.
     */ getBottomRight: function(output, includeParent) {
                        if (!output) output = new Vector2();
                        output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                        output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                        return this.prepareBoundsOutput(output, includeParent);
                    },
                    /**
     * Gets the bounds of this Game Object, regardless of origin.
     *
     * The values are stored and returned in a Rectangle, or Rectangle-like, object.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Rectangle} O - [output,$return]
     *
     * @param {(Phaser.Geom.Rectangle|object)} [output] - An object to store the values in. If not provided a new Rectangle will be created.
     *
     * @return {(Phaser.Geom.Rectangle|object)} The values stored in the output object.
     */ getBounds: function(output) {
                        if (output === undefined) output = new Rectangle();
                        //  We can use the output object to temporarily store the x/y coords in:
                        var TLx, TLy, TRx, TRy, BLx, BLy, BRx, BRy;
                        // Instead of doing a check if parent container is
                        // defined per corner we only do it once.
                        if (this.parentContainer) {
                            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                            this.getTopLeft(output);
                            parentMatrix.transformPoint(output.x, output.y, output);
                            TLx = output.x;
                            TLy = output.y;
                            this.getTopRight(output);
                            parentMatrix.transformPoint(output.x, output.y, output);
                            TRx = output.x;
                            TRy = output.y;
                            this.getBottomLeft(output);
                            parentMatrix.transformPoint(output.x, output.y, output);
                            BLx = output.x;
                            BLy = output.y;
                            this.getBottomRight(output);
                            parentMatrix.transformPoint(output.x, output.y, output);
                            BRx = output.x;
                            BRy = output.y;
                        } else {
                            this.getTopLeft(output);
                            TLx = output.x;
                            TLy = output.y;
                            this.getTopRight(output);
                            TRx = output.x;
                            TRy = output.y;
                            this.getBottomLeft(output);
                            BLx = output.x;
                            BLy = output.y;
                            this.getBottomRight(output);
                            BRx = output.x;
                            BRy = output.y;
                        }
                        output.x = Math.min(TLx, TRx, BLx, BRx);
                        output.y = Math.min(TLy, TRy, BLy, BRy);
                        output.width = Math.max(TLx, TRx, BLx, BRx) - output.x;
                        output.height = Math.max(TLy, TRy, BLy, BRy) - output.y;
                        return output;
                    }
                };
                module1.exports = GetBounds;
            /***/ },
            /***/ 8573: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapMask = __webpack_require__(6858);
                var GeometryMask = __webpack_require__(80661);
                /**
 * Provides methods used for getting and setting the mask of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Mask
 * @since 3.0.0
 */ var Mask = {
                    /**
     * The Mask this Game Object is using during render.
     *
     * @name Phaser.GameObjects.Components.Mask#mask
     * @type {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask}
     * @since 3.0.0
     */ mask: null,
                    /**
     * Sets the mask that this Game Object will use to render with.
     *
     * The mask must have been previously created and can be either a GeometryMask or a BitmapMask.
     * Note: Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * If a mask is already set on this Game Object it will be immediately replaced.
     *
     * Masks are positioned in global space and are not relative to the Game Object to which they
     * are applied. The reason for this is that multiple Game Objects can all share the same mask.
     *
     * Masks have no impact on physics or input detection. They are purely a rendering component
     * that allows you to limit what is visible during the render pass.
     *
     * @method Phaser.GameObjects.Components.Mask#setMask
     * @since 3.6.2
     *
     * @param {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask} mask - The mask this Game Object will use when rendering.
     *
     * @return {this} This Game Object instance.
     */ setMask: function(mask) {
                        this.mask = mask;
                        return this;
                    },
                    /**
     * Clears the mask that this Game Object was using.
     *
     * @method Phaser.GameObjects.Components.Mask#clearMask
     * @since 3.6.2
     *
     * @param {boolean} [destroyMask=false] - Destroy the mask before clearing it?
     *
     * @return {this} This Game Object instance.
     */ clearMask: function(destroyMask) {
                        if (destroyMask === undefined) destroyMask = false;
                        if (destroyMask && this.mask) this.mask.destroy();
                        this.mask = null;
                        return this;
                    },
                    /**
     * Creates and returns a Bitmap Mask. This mask can be used by any Game Object,
     * including this one, or a Dynamic Texture.
     *
     * Note: Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * To create the mask you need to pass in a reference to a renderable Game Object.
     * A renderable Game Object is one that uses a texture to render with, such as an
     * Image, Sprite, Render Texture or BitmapText.
     *
     * If you do not provide a renderable object, and this Game Object has a texture,
     * it will use itself as the object. This means you can call this method to create
     * a Bitmap Mask from any renderable texture-based Game Object.
     *
     * @method Phaser.GameObjects.Components.Mask#createBitmapMask
     * @since 3.6.2
     *
     * @generic {Phaser.GameObjects.GameObject} G
     * @generic {Phaser.Textures.DynamicTexture} T
     * @genericUse {(G|T|null)} [maskObject]
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Textures.DynamicTexture)} [maskObject] - The Game Object or Dynamic Texture that will be used as the mask. If `null` it will generate an Image Game Object using the rest of the arguments.
     * @param {number} [x] - If creating a Game Object, the horizontal position in the world.
     * @param {number} [y] - If creating a Game Object, the vertical position in the world.
     * @param {(string|Phaser.Textures.Texture)} [texture] - If creating a Game Object, the key, or instance of the Texture it will use to render with, as stored in the Texture Manager.
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - If creating a Game Object, an optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Display.Masks.BitmapMask} This Bitmap Mask that was created.
     */ createBitmapMask: function(maskObject, x, y, texture, frame) {
                        if (maskObject === undefined && (this.texture || this.shader || this.geom)) // eslint-disable-next-line consistent-this
                        maskObject = this;
                        return new BitmapMask(this.scene, maskObject, x, y, texture, frame);
                    },
                    /**
     * Creates and returns a Geometry Mask. This mask can be used by any Game Object,
     * including this one.
     *
     * To create the mask you need to pass in a reference to a Graphics Game Object.
     *
     * If you do not provide a graphics object, and this Game Object is an instance
     * of a Graphics object, then it will use itself to create the mask.
     *
     * This means you can call this method to create a Geometry Mask from any Graphics Game Object.
     *
     * @method Phaser.GameObjects.Components.Mask#createGeometryMask
     * @since 3.6.2
     *
     * @generic {Phaser.GameObjects.Graphics} G
     * @generic {Phaser.GameObjects.Shape} S
     * @genericUse {(G|S)} [graphics]
     *
     * @param {Phaser.GameObjects.Graphics|Phaser.GameObjects.Shape} [graphics] - A Graphics Game Object, or any kind of Shape Game Object. The geometry within it will be used as the mask.
     *
     * @return {Phaser.Display.Masks.GeometryMask} This Geometry Mask that was created.
     */ createGeometryMask: function(graphics) {
                        if (graphics === undefined && (this.type === 'Graphics' || this.geom)) // eslint-disable-next-line consistent-this
                        graphics = this;
                        return new GeometryMask(this.scene, graphics);
                    }
                };
                module1.exports = Mask;
            /***/ },
            /***/ 27387: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the origin of a Game Object.
 * Values are normalized, given in the range 0 to 1.
 * Display values contain the calculated pixel values.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Origin
 * @since 3.0.0
 */ var Origin = {
                    /**
     * A property indicating that a Game Object has this component.
     *
     * @name Phaser.GameObjects.Components.Origin#_originComponent
     * @type {boolean}
     * @private
     * @default true
     * @since 3.2.0
     */ _originComponent: true,
                    /**
     * The horizontal origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the left of the Game Object.
     * Set this value with `setOrigin()`.
     *
     * @name Phaser.GameObjects.Components.Origin#originX
     * @type {number}
     * @readonly
     * @default 0.5
     * @since 3.0.0
     */ originX: 0.5,
                    /**
     * The vertical origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the top of the Game Object.
     * Set this value with `setOrigin()`.
     *
     * @name Phaser.GameObjects.Components.Origin#originY
     * @type {number}
     * @readonly
     * @default 0.5
     * @since 3.0.0
     */ originY: 0.5,
                    //  private + read only
                    _displayOriginX: 0,
                    _displayOriginY: 0,
                    /**
     * The horizontal display origin of this Game Object.
     * The origin is a normalized value between 0 and 1.
     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
     *
     * @name Phaser.GameObjects.Components.Origin#displayOriginX
     * @type {number}
     * @since 3.0.0
     */ displayOriginX: {
                        get: function() {
                            return this._displayOriginX;
                        },
                        set: function(value) {
                            this._displayOriginX = value;
                            this.originX = value / this.width;
                        }
                    },
                    /**
     * The vertical display origin of this Game Object.
     * The origin is a normalized value between 0 and 1.
     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
     *
     * @name Phaser.GameObjects.Components.Origin#displayOriginY
     * @type {number}
     * @since 3.0.0
     */ displayOriginY: {
                        get: function() {
                            return this._displayOriginY;
                        },
                        set: function(value) {
                            this._displayOriginY = value;
                            this.originY = value / this.height;
                        }
                    },
                    /**
     * Sets the origin of this Game Object.
     *
     * The values are given in the range 0 to 1.
     *
     * @method Phaser.GameObjects.Components.Origin#setOrigin
     * @since 3.0.0
     *
     * @param {number} [x=0.5] - The horizontal origin value.
     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Game Object instance.
     */ setOrigin: function(x, y) {
                        if (x === undefined) x = 0.5;
                        if (y === undefined) y = x;
                        this.originX = x;
                        this.originY = y;
                        return this.updateDisplayOrigin();
                    },
                    /**
     * Sets the origin of this Game Object based on the Pivot values in its Frame.
     *
     * @method Phaser.GameObjects.Components.Origin#setOriginFromFrame
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ setOriginFromFrame: function() {
                        if (!this.frame || !this.frame.customPivot) return this.setOrigin();
                        else {
                            this.originX = this.frame.pivotX;
                            this.originY = this.frame.pivotY;
                        }
                        return this.updateDisplayOrigin();
                    },
                    /**
     * Sets the display origin of this Game Object.
     * The difference between this and setting the origin is that you can use pixel values for setting the display origin.
     *
     * @method Phaser.GameObjects.Components.Origin#setDisplayOrigin
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal display origin value.
     * @param {number} [y=x] - The vertical display origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Game Object instance.
     */ setDisplayOrigin: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = x;
                        this.displayOriginX = x;
                        this.displayOriginY = y;
                        return this;
                    },
                    /**
     * Updates the Display Origin cached values internally stored on this Game Object.
     * You don't usually call this directly, but it is exposed for edge-cases where you may.
     *
     * @method Phaser.GameObjects.Components.Origin#updateDisplayOrigin
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ updateDisplayOrigin: function() {
                        this._displayOriginX = this.originX * this.width;
                        this._displayOriginY = this.originY * this.height;
                        return this;
                    }
                };
                module1.exports = Origin;
            /***/ },
            /***/ 37640: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DegToRad = __webpack_require__(39506);
                var GetBoolean = __webpack_require__(57355);
                var GetValue = __webpack_require__(35154);
                var TWEEN_CONST = __webpack_require__(86353);
                var Vector2 = __webpack_require__(26099);
                /**
 * Provides methods used for managing a Game Object following a Path.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.PathFollower
 * @since 3.17.0
 */ var PathFollower = {
                    /**
     * The Path this PathFollower is following. It can only follow one Path at a time.
     *
     * @name Phaser.GameObjects.Components.PathFollower#path
     * @type {Phaser.Curves.Path}
     * @since 3.0.0
     */ path: null,
                    /**
     * Should the PathFollower automatically rotate to point in the direction of the Path?
     *
     * @name Phaser.GameObjects.Components.PathFollower#rotateToPath
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ rotateToPath: false,
                    /**
     * If the PathFollower is rotating to match the Path (@see Phaser.GameObjects.PathFollower#rotateToPath)
     * this value is added to the rotation value. This allows you to rotate objects to a path but control
     * the angle of the rotation as well.
     *
     * @name Phaser.GameObjects.PathFollower#pathRotationOffset
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ pathRotationOffset: 0,
                    /**
     * An additional vector to add to the PathFollowers position, allowing you to offset it from the
     * Path coordinates.
     *
     * @name Phaser.GameObjects.PathFollower#pathOffset
     * @type {Phaser.Math.Vector2}
     * @since 3.0.0
     */ pathOffset: null,
                    /**
     * A Vector2 that stores the current point of the path the follower is on.
     *
     * @name Phaser.GameObjects.PathFollower#pathVector
     * @type {Phaser.Math.Vector2}
     * @since 3.0.0
     */ pathVector: null,
                    /**
     * The distance the follower has traveled from the previous point to the current one, at the last update.
     *
     * @name Phaser.GameObjects.PathFollower#pathDelta
     * @type {Phaser.Math.Vector2}
     * @since 3.23.0
     */ pathDelta: null,
                    /**
     * The Tween used for following the Path.
     *
     * @name Phaser.GameObjects.PathFollower#pathTween
     * @type {Phaser.Tweens.Tween}
     * @since 3.0.0
     */ pathTween: null,
                    /**
     * Settings for the PathFollower.
     *
     * @name Phaser.GameObjects.PathFollower#pathConfig
     * @type {?Phaser.Types.GameObjects.PathFollower.PathConfig}
     * @default null
     * @since 3.0.0
     */ pathConfig: null,
                    /**
     * Records the direction of the follower so it can change direction.
     *
     * @name Phaser.GameObjects.PathFollower#_prevDirection
     * @type {number}
     * @private
     * @since 3.0.0
     */ _prevDirection: TWEEN_CONST.PLAYING_FORWARD,
                    /**
     * Set the Path that this PathFollower should follow.
     *
     * Optionally accepts {@link Phaser.Types.GameObjects.PathFollower.PathConfig} settings.
     *
     * @method Phaser.GameObjects.Components.PathFollower#setPath
     * @since 3.0.0
     *
     * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
     * @param {(number|Phaser.Types.GameObjects.PathFollower.PathConfig|Phaser.Types.Tweens.NumberTweenBuilderConfig)} [config] - Settings for the PathFollower.
     *
     * @return {this} This Game Object.
     */ setPath: function(path, config) {
                        if (config === undefined) config = this.pathConfig;
                        var tween = this.pathTween;
                        if (tween && tween.isPlaying()) tween.stop();
                        this.path = path;
                        if (config) this.startFollow(config);
                        return this;
                    },
                    /**
     * Set whether the PathFollower should automatically rotate to point in the direction of the Path.
     *
     * @method Phaser.GameObjects.Components.PathFollower#setRotateToPath
     * @since 3.0.0
     *
     * @param {boolean} value - Whether the PathFollower should automatically rotate to point in the direction of the Path.
     * @param {number} [offset=0] - Rotation offset in degrees.
     *
     * @return {this} This Game Object.
     */ setRotateToPath: function(value, offset) {
                        if (offset === undefined) offset = 0;
                        this.rotateToPath = value;
                        this.pathRotationOffset = offset;
                        return this;
                    },
                    /**
     * Is this PathFollower actively following a Path or not?
     *
     * To be considered as `isFollowing` it must be currently moving on a Path, and not paused.
     *
     * @method Phaser.GameObjects.Components.PathFollower#isFollowing
     * @since 3.0.0
     *
     * @return {boolean} `true` is this PathFollower is actively following a Path, otherwise `false`.
     */ isFollowing: function() {
                        var tween = this.pathTween;
                        return tween && tween.isPlaying();
                    },
                    /**
     * Starts this PathFollower following its given Path.
     *
     * @method Phaser.GameObjects.Components.PathFollower#startFollow
     * @since 3.3.0
     *
     * @param {(number|Phaser.Types.GameObjects.PathFollower.PathConfig|Phaser.Types.Tweens.NumberTweenBuilderConfig)} [config={}] - The duration of the follow, or a PathFollower config object.
     * @param {number} [startAt=0] - Optional start position of the follow, between 0 and 1.
     *
     * @return {this} This Game Object.
     */ startFollow: function(config, startAt) {
                        if (config === undefined) config = {};
                        if (startAt === undefined) startAt = 0;
                        var tween = this.pathTween;
                        if (tween && tween.isPlaying()) tween.stop();
                        if (typeof config === 'number') config = {
                            duration: config
                        };
                        //  Override in case they've been specified in the config
                        config.from = GetValue(config, 'from', 0);
                        config.to = GetValue(config, 'to', 1);
                        var positionOnPath = GetBoolean(config, 'positionOnPath', false);
                        this.rotateToPath = GetBoolean(config, 'rotateToPath', false);
                        this.pathRotationOffset = GetValue(config, 'rotationOffset', 0);
                        //  This works, but it's not an ideal way of doing it as the follower jumps position
                        var seek = GetValue(config, 'startAt', startAt);
                        if (seek) config.onStart = function(tween) {
                            var tweenData = tween.data[0];
                            tweenData.progress = seek;
                            tweenData.elapsed = tweenData.duration * seek;
                            var v = tweenData.ease(tweenData.progress);
                            tweenData.current = tweenData.start + (tweenData.end - tweenData.start) * v;
                            tweenData.setTargetValue();
                        };
                        if (!this.pathOffset) this.pathOffset = new Vector2(this.x, this.y);
                        if (!this.pathVector) this.pathVector = new Vector2();
                        if (!this.pathDelta) this.pathDelta = new Vector2();
                        this.pathDelta.reset();
                        config.persist = true;
                        this.pathTween = this.scene.sys.tweens.addCounter(config);
                        //  The starting point of the path, relative to this follower
                        this.path.getStartPoint(this.pathOffset);
                        if (positionOnPath) {
                            this.x = this.pathOffset.x;
                            this.y = this.pathOffset.y;
                        }
                        this.pathOffset.x = this.x - this.pathOffset.x;
                        this.pathOffset.y = this.y - this.pathOffset.y;
                        this._prevDirection = TWEEN_CONST.PLAYING_FORWARD;
                        if (this.rotateToPath) {
                            //  Set the rotation now (in case the tween has a delay on it, etc)
                            var nextPoint = this.path.getPoint(0.1);
                            this.rotation = Math.atan2(nextPoint.y - this.y, nextPoint.x - this.x) + DegToRad(this.pathRotationOffset);
                        }
                        this.pathConfig = config;
                        return this;
                    },
                    /**
     * Pauses this PathFollower. It will still continue to render, but it will remain motionless at the
     * point on the Path at which you paused it.
     *
     * @method Phaser.GameObjects.Components.PathFollower#pauseFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ pauseFollow: function() {
                        var tween = this.pathTween;
                        if (tween && tween.isPlaying()) tween.pause();
                        return this;
                    },
                    /**
     * Resumes a previously paused PathFollower.
     *
     * If the PathFollower was not paused this has no effect.
     *
     * @method Phaser.GameObjects.Components.PathFollower#resumeFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ resumeFollow: function() {
                        var tween = this.pathTween;
                        if (tween && tween.isPaused()) tween.resume();
                        return this;
                    },
                    /**
     * Stops this PathFollower from following the path any longer.
     *
     * This will invoke any 'stop' conditions that may exist on the Path, or for the follower.
     *
     * @method Phaser.GameObjects.Components.PathFollower#stopFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ stopFollow: function() {
                        var tween = this.pathTween;
                        if (tween && tween.isPlaying()) tween.stop();
                        return this;
                    },
                    /**
     * Internal update handler that advances this PathFollower along the path.
     *
     * Called automatically by the Scene step, should not typically be called directly.
     *
     * @method Phaser.GameObjects.Components.PathFollower#pathUpdate
     * @since 3.17.0
     */ pathUpdate: function() {
                        var tween = this.pathTween;
                        if (tween && tween.data) {
                            var tweenData = tween.data[0];
                            var pathDelta = this.pathDelta;
                            var pathVector = this.pathVector;
                            pathDelta.copy(pathVector).negate();
                            if (tweenData.state === TWEEN_CONST.COMPLETE) {
                                this.path.getPoint(tweenData.end, pathVector);
                                pathDelta.add(pathVector);
                                pathVector.add(this.pathOffset);
                                this.setPosition(pathVector.x, pathVector.y);
                                return;
                            } else if (tweenData.state !== TWEEN_CONST.PLAYING_FORWARD && tweenData.state !== TWEEN_CONST.PLAYING_BACKWARD) //  If delayed, etc then bail out
                            return;
                            this.path.getPoint(tween.getValue(), pathVector);
                            pathDelta.add(pathVector);
                            pathVector.add(this.pathOffset);
                            var oldX = this.x;
                            var oldY = this.y;
                            this.setPosition(pathVector.x, pathVector.y);
                            var speedX = this.x - oldX;
                            var speedY = this.y - oldY;
                            if (speedX === 0 && speedY === 0) //  Bail out early
                            return;
                            if (tweenData.state !== this._prevDirection) {
                                //  We've changed direction, so don't do a rotate this frame
                                this._prevDirection = tweenData.state;
                                return;
                            }
                            if (this.rotateToPath) this.rotation = Math.atan2(speedY, speedX) + DegToRad(this.pathRotationOffset);
                        }
                    }
                };
                module1.exports = PathFollower;
            /***/ },
            /***/ 72699: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DeepCopy = __webpack_require__(62644);
                /**
 * Provides methods used for setting the WebGL rendering pipeline of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Pipeline
 * @webglOnly
 * @since 3.0.0
 */ var Pipeline = {
                    /**
     * The initial WebGL pipeline of this Game Object.
     *
     * If you call `resetPipeline` on this Game Object, the pipeline is reset to this default.
     *
     * @name Phaser.GameObjects.Components.Pipeline#defaultPipeline
     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
     * @default null
     * @webglOnly
     * @since 3.0.0
     */ defaultPipeline: null,
                    /**
     * The current WebGL pipeline of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Pipeline#pipeline
     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
     * @default null
     * @webglOnly
     * @since 3.0.0
     */ pipeline: null,
                    /**
     * An object to store pipeline specific data in, to be read by the pipelines this Game Object uses.
     *
     * @name Phaser.GameObjects.Components.Pipeline#pipelineData
     * @type {object}
     * @webglOnly
     * @since 3.50.0
     */ pipelineData: null,
                    /**
     * Sets the initial WebGL Pipeline of this Game Object.
     *
     * This should only be called during the instantiation of the Game Object. After that, use `setPipeline`.
     *
     * @method Phaser.GameObjects.Components.Pipeline#initPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} [pipeline] - Either the string-based name of the pipeline, or a pipeline instance to set.
     *
     * @return {boolean} `true` if the pipeline was set successfully, otherwise `false`.
     */ initPipeline: function(pipeline) {
                        this.pipelineData = {};
                        var renderer = this.scene.sys.renderer;
                        if (!renderer) return false;
                        var pipelines = renderer.pipelines;
                        if (pipelines) {
                            if (pipeline === undefined) pipeline = pipelines.default;
                            var instance = pipelines.get(pipeline);
                            if (instance) {
                                this.defaultPipeline = instance;
                                this.pipeline = instance;
                                return true;
                            }
                        }
                        return false;
                    },
                    /**
     * Sets the main WebGL Pipeline of this Game Object.
     *
     * Also sets the `pipelineData` property, if the parameter is given.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline, or a pipeline instance to set.
     * @param {object} [pipelineData] - Optional pipeline data object that is set in to the `pipelineData` property of this Game Object.
     * @param {boolean} [copyData=true] - Should the pipeline data object be _deep copied_ into the `pipelineData` property of this Game Object? If `false` it will be set by reference instead.
     *
     * @return {this} This Game Object instance.
     */ setPipeline: function(pipeline, pipelineData, copyData) {
                        var renderer = this.scene.sys.renderer;
                        if (!renderer) return this;
                        var pipelines = renderer.pipelines;
                        if (pipelines) {
                            var instance = pipelines.get(pipeline);
                            if (instance) this.pipeline = instance;
                            if (pipelineData) this.pipelineData = copyData ? DeepCopy(pipelineData) : pipelineData;
                        }
                        return this;
                    },
                    /**
     * Adds an entry to the `pipelineData` object belonging to this Game Object.
     *
     * If the 'key' already exists, its value is updated. If it doesn't exist, it is created.
     *
     * If `value` is undefined, and `key` exists, `key` is removed from the data object.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPipelineData
     * @webglOnly
     * @since 3.50.0
     *
     * @param {string} key - The key of the pipeline data to set, update, or delete.
     * @param {any} [value] - The value to be set with the key. If `undefined` then `key` will be deleted from the object.
     *
     * @return {this} This Game Object instance.
     */ setPipelineData: function(key, value) {
                        var data = this.pipelineData;
                        if (value === undefined) delete data[key];
                        else data[key] = value;
                        return this;
                    },
                    /**
     * Resets the WebGL Pipeline of this Game Object back to the default it was created with.
     *
     * @method Phaser.GameObjects.Components.Pipeline#resetPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {boolean} [resetData=false] - Reset the `pipelineData` object to being an empty object?
     *
     * @return {boolean} `true` if the pipeline was reset successfully, otherwise `false`.
     */ resetPipeline: function(resetData) {
                        if (resetData === undefined) resetData = false;
                        this.pipeline = this.defaultPipeline;
                        if (resetData) this.pipelineData = {};
                        return this.pipeline !== null;
                    },
                    /**
     * Gets the name of the WebGL Pipeline this Game Object is currently using.
     *
     * @method Phaser.GameObjects.Components.Pipeline#getPipelineName
     * @webglOnly
     * @since 3.0.0
     *
     * @return {?string} The string-based name of the pipeline being used by this Game Object, or null.
     */ getPipelineName: function() {
                        return this.pipeline === null ? null : this.pipeline.name;
                    }
                };
                module1.exports = Pipeline;
            /***/ },
            /***/ 17581: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DeepCopy = __webpack_require__(62644);
                var FX = __webpack_require__(47059);
                var SpliceOne = __webpack_require__(19133);
                /**
 * Provides methods used for setting the WebGL rendering post pipeline of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.PostPipeline
 * @webglOnly
 * @since 3.60.0
 */ var PostPipeline = {
                    /**
     * Does this Game Object have any Post Pipelines set?
     *
     * @name Phaser.GameObjects.Components.PostPipeline#hasPostPipeline
     * @type {boolean}
     * @webglOnly
     * @since 3.60.0
     */ hasPostPipeline: false,
                    /**
     * The WebGL Post FX Pipelines this Game Object uses for post-render effects.
     *
     * The pipelines are processed in the order in which they appear in this array.
     *
     * If you modify this array directly, be sure to set the
     * `hasPostPipeline` property accordingly.
     *
     * @name Phaser.GameObjects.Components.PostPipeline#postPipelines
     * @type {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[]}
     * @webglOnly
     * @since 3.60.0
     */ postPipelines: null,
                    /**
     * An object to store pipeline specific data in, to be read by the pipelines this Game Object uses.
     *
     * @name Phaser.GameObjects.Components.PostPipeline#postPipelineData
     * @type {object}
     * @webglOnly
     * @since 3.60.0
     */ postPipelineData: null,
                    /**
     * The Pre FX component of this Game Object.
     *
     * This component allows you to apply a variety of built-in effects to this Game Object, such
     * as glow, blur, bloom, displacements, vignettes and more. You access them via this property,
     * for example:
     *
     * ```js
     * const player = this.add.sprite();
     * player.preFX.addBloom();
     * ```
     *
     * Only the following Game Objects support Pre FX:
     *
     * * Image
     * * Sprite
     * * TileSprite
     * * Text
     * * RenderTexture
     * * Video
     *
     * All FX are WebGL only and do not have Canvas counterparts.
     *
     * Please see the FX Class for more details and available methods.
     *
     * @name Phaser.GameObjects.Components.PostPipeline#preFX
     * @type {?Phaser.GameObjects.Components.FX}
     * @webglOnly
     * @since 3.60.0
     */ preFX: null,
                    /**
     * The Post FX component of this Game Object.
     *
     * This component allows you to apply a variety of built-in effects to this Game Object, such
     * as glow, blur, bloom, displacements, vignettes and more. You access them via this property,
     * for example:
     *
     * ```js
     * const player = this.add.sprite();
     * player.postFX.addBloom();
     * ```
     *
     * All FX are WebGL only and do not have Canvas counterparts.
     *
     * Please see the FX Class for more details and available methods.
     *
     * This property is always `null` until the `initPostPipeline` method is called.
     *
     * @name Phaser.GameObjects.Components.PostPipeline#postFX
     * @type {Phaser.GameObjects.Components.FX}
     * @webglOnly
     * @since 3.60.0
     */ postFX: null,
                    /**
     * This should only be called during the instantiation of the Game Object.
     *
     * It is called by default by all core Game Objects and doesn't need
     * calling again.
     *
     * After that, use `setPostPipeline`.
     *
     * @method Phaser.GameObjects.Components.PostPipeline#initPostPipeline
     * @webglOnly
     * @since 3.60.0
     *
     * @param {boolean} [preFX=false] - Does this Game Object support Pre FX?
     */ initPostPipeline: function(preFX) {
                        this.postPipelines = [];
                        this.postPipelineData = {};
                        this.postFX = new FX(this, true);
                        if (preFX) this.preFX = new FX(this, false);
                    },
                    /**
     * Sets one, or more, Post Pipelines on this Game Object.
     *
     * Post Pipelines are invoked after this Game Object has rendered to its target and
     * are commonly used for post-fx.
     *
     * The post pipelines are appended to the `postPipelines` array belonging to this
     * Game Object. When the renderer processes this Game Object, it iterates through the post
     * pipelines in the order in which they appear in the array. If you are stacking together
     * multiple effects, be aware that the order is important.
     *
     * If you call this method multiple times, the new pipelines will be appended to any existing
     * post pipelines already set. Use the `resetPostPipeline` method to clear them first, if required.
     *
     * You can optionally also set the `postPipelineData` property, if the parameter is given.
     *
     * @method Phaser.GameObjects.Components.PostPipeline#setPostPipeline
     * @webglOnly
     * @since 3.60.0
     *
     * @param {(string|string[]|function|function[]|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[])} pipelines - Either the string-based name of the pipeline, or a pipeline instance, or class, or an array of them.
     * @param {object} [pipelineData] - Optional pipeline data object that is set in to the `postPipelineData` property of this Game Object.
     * @param {boolean} [copyData=true] - Should the pipeline data object be _deep copied_ into the `postPipelineData` property of this Game Object? If `false` it will be set by reference instead.
     *
     * @return {this} This Game Object instance.
     */ setPostPipeline: function(pipelines, pipelineData, copyData) {
                        var renderer = this.scene.sys.renderer;
                        if (!renderer) return this;
                        var pipelineManager = renderer.pipelines;
                        if (pipelineManager) {
                            if (!Array.isArray(pipelines)) pipelines = [
                                pipelines
                            ];
                            for(var i = 0; i < pipelines.length; i++){
                                var instance = pipelineManager.getPostPipeline(pipelines[i], this, pipelineData);
                                if (instance) this.postPipelines.push(instance);
                            }
                            if (pipelineData) this.postPipelineData = copyData ? DeepCopy(pipelineData) : pipelineData;
                        }
                        this.hasPostPipeline = this.postPipelines.length > 0;
                        return this;
                    },
                    /**
     * Adds an entry to the `postPipelineData` object belonging to this Game Object.
     *
     * If the 'key' already exists, its value is updated. If it doesn't exist, it is created.
     *
     * If `value` is undefined, and `key` exists, `key` is removed from the data object.
     *
     * @method Phaser.GameObjects.Components.PostPipeline#setPostPipelineData
     * @webglOnly
     * @since 3.60.0
     *
     * @param {string} key - The key of the pipeline data to set, update, or delete.
     * @param {any} [value] - The value to be set with the key. If `undefined` then `key` will be deleted from the object.
     *
     * @return {this} This Game Object instance.
     */ setPostPipelineData: function(key, value) {
                        var data = this.postPipelineData;
                        if (value === undefined) delete data[key];
                        else data[key] = value;
                        return this;
                    },
                    /**
     * Gets a Post Pipeline instance from this Game Object, based on the given name, and returns it.
     *
     * @method Phaser.GameObjects.Components.PostPipeline#getPostPipeline
     * @webglOnly
     * @since 3.60.0
     *
     * @param {(string|function|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline)} pipeline - The string-based name of the pipeline, or a pipeline class.
     *
     * @return {(Phaser.Renderer.WebGL.Pipelines.PostFXPipeline|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[])} An array of all the Post Pipelines matching the name. This array will be empty if there was no match. If there was only one single match, that pipeline is returned directly, not in an array.
     */ getPostPipeline: function(pipeline) {
                        var isString = typeof pipeline === 'string';
                        var pipelines = this.postPipelines;
                        var results = [];
                        for(var i = 0; i < pipelines.length; i++){
                            var instance = pipelines[i];
                            if (isString && instance.name === pipeline || !isString && instance instanceof pipeline) results.push(instance);
                        }
                        return results.length === 1 ? results[0] : results;
                    },
                    /**
     * Resets the WebGL Post Pipelines of this Game Object. It does this by calling
     * the `destroy` method on each post pipeline and then clearing the local array.
     *
     * @method Phaser.GameObjects.Components.PostPipeline#resetPostPipeline
     * @webglOnly
     * @since 3.60.0
     *
     * @param {boolean} [resetData=false] - Reset the `postPipelineData` object to being an empty object?
     */ resetPostPipeline: function(resetData) {
                        if (resetData === undefined) resetData = false;
                        var pipelines = this.postPipelines;
                        for(var i = 0; i < pipelines.length; i++)pipelines[i].destroy();
                        this.postPipelines = [];
                        this.hasPostPipeline = false;
                        if (resetData) this.postPipelineData = {};
                    },
                    /**
     * Removes a type of Post Pipeline instances from this Game Object, based on the given name, and destroys them.
     *
     * If you wish to remove all Post Pipelines use the `resetPostPipeline` method instead.
     *
     * @method Phaser.GameObjects.Components.PostPipeline#removePostPipeline
     * @webglOnly
     * @since 3.60.0
     *
     * @param {string|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} pipeline - The string-based name of the pipeline, or a pipeline class.
     *
     * @return {this} This Game Object.
     */ removePostPipeline: function(pipeline) {
                        var isString = typeof pipeline === 'string';
                        var pipelines = this.postPipelines;
                        for(var i = pipelines.length - 1; i >= 0; i--){
                            var instance = pipelines[i];
                            if (isString && instance.name === pipeline || !isString && instance === pipeline) {
                                instance.destroy();
                                SpliceOne(pipelines, i);
                            }
                        }
                        this.hasPostPipeline = this.postPipelines.length > 0;
                        return this;
                    },
                    /**
     * Removes all Pre and Post FX Controllers from this Game Object.
     *
     * If you wish to remove a single controller, use the `preFX.remove(fx)` or `postFX.remove(fx)` methods instead.
     *
     * If you wish to clear a single controller, use the `preFX.clear()` or `postFX.clear()` methods instead.
     *
     * @method Phaser.GameObjects.Components.PostPipeline#clearFX
     * @webglOnly
     * @since 3.60.0
     *
     * @return {this} This Game Object.
     */ clearFX: function() {
                        if (this.preFX) this.preFX.clear();
                        if (this.postFX) this.postFX.clear();
                        return this;
                    }
                };
                module1.exports = PostPipeline;
            /***/ },
            /***/ 80227: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the Scroll Factor of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.ScrollFactor
 * @since 3.0.0
 */ var ScrollFactor = {
                    /**
     * The horizontal scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     *
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorX
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scrollFactorX: 1,
                    /**
     * The vertical scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     *
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorY
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scrollFactorY: 1,
                    /**
     * Sets the scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     *
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @method Phaser.GameObjects.Components.ScrollFactor#setScrollFactor
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scroll factor of this Game Object.
     * @param {number} [y=x] - The vertical scroll factor of this Game Object. If not set it will use the `x` value.
     *
     * @return {this} This Game Object instance.
     */ setScrollFactor: function(x, y) {
                        if (y === undefined) y = x;
                        this.scrollFactorX = x;
                        this.scrollFactorY = y;
                        return this;
                    }
                };
                module1.exports = ScrollFactor;
            /***/ },
            /***/ 16736: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the size of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Size
 * @since 3.0.0
 */ var Size = {
                    /**
     * A property indicating that a Game Object has this component.
     *
     * @name Phaser.GameObjects.Components.Size#_sizeComponent
     * @type {boolean}
     * @private
     * @default true
     * @since 3.2.0
     */ _sizeComponent: true,
                    /**
     * The native (un-scaled) width of this Game Object.
     *
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayWidth` property.
     *
     * @name Phaser.GameObjects.Components.Size#width
     * @type {number}
     * @since 3.0.0
     */ width: 0,
                    /**
     * The native (un-scaled) height of this Game Object.
     *
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayHeight` property.
     *
     * @name Phaser.GameObjects.Components.Size#height
     * @type {number}
     * @since 3.0.0
     */ height: 0,
                    /**
     * The displayed width of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Components.Size#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                        get: function() {
                            return Math.abs(this.scaleX * this.frame.realWidth);
                        },
                        set: function(value) {
                            this.scaleX = value / this.frame.realWidth;
                        }
                    },
                    /**
     * The displayed height of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Components.Size#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                        get: function() {
                            return Math.abs(this.scaleY * this.frame.realHeight);
                        },
                        set: function(value) {
                            this.scaleY = value / this.frame.realHeight;
                        }
                    },
                    /**
     * Sets the size of this Game Object to be that of the given Frame.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Components.Size#setSizeToFrame
     * @since 3.0.0
     *
     * @param {Phaser.Textures.Frame|boolean} [frame] - The frame to base the size of this Game Object on.
     *
     * @return {this} This Game Object instance.
     */ setSizeToFrame: function(frame) {
                        if (!frame) frame = this.frame;
                        this.width = frame.realWidth;
                        this.height = frame.realHeight;
                        var input = this.input;
                        if (input && !input.customHitArea) {
                            input.hitArea.width = this.width;
                            input.hitArea.height = this.height;
                        }
                        return this;
                    },
                    /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Components.Size#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Sets the display size of this Game Object.
     *
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.Components.Size#setDisplaySize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setDisplaySize: function(width, height) {
                        this.displayWidth = width;
                        this.displayHeight = height;
                        return this;
                    }
                };
                module1.exports = Size;
            /***/ },
            /***/ 37726: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Frame = __webpack_require__(4327);
                //  bitmask flag for GameObject.renderMask
                var _FLAG = 8; // 1000
                /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Texture
 * @since 3.0.0
 */ var Texture = {
                    /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Texture#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                    /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Texture#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                    /**
     * Internal flag. Not to be set by this Game Object.
     *
     * @name Phaser.GameObjects.Components.Texture#isCropped
     * @type {boolean}
     * @private
     * @since 3.11.0
     */ isCropped: false,
                    /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * Calling this method will modify the `width` and `height` properties of your Game Object.
     *
     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
     *
     * @method Phaser.GameObjects.Components.Texture#setTexture
     * @since 3.0.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The key of the texture to be used, as stored in the Texture Manager, or a Texture instance.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
     * @param {boolean} [updateOrigin=true] - Should this call change the origin of the Game Object?
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame, updateSize, updateOrigin) {
                        this.texture = this.scene.sys.textures.get(key);
                        return this.setFrame(frame, updateSize, updateOrigin);
                    },
                    /**
     * Sets the frame this Game Object will use to render with.
     *
     * If you pass a string or index then the Frame has to belong to the current Texture being used
     * by this Game Object.
     *
     * If you pass a Frame instance, then the Texture being used by this Game Object will also be updated.
     *
     * Calling `setFrame` will modify the `width` and `height` properties of your Game Object.
     *
     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
     *
     * @method Phaser.GameObjects.Components.Texture#setFrame
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Textures.Frame)} frame - The name or index of the frame within the Texture, or a Frame instance.
     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
     * @param {boolean} [updateOrigin=true] - Should this call adjust the origin of the Game Object?
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame, updateSize, updateOrigin) {
                        if (updateSize === undefined) updateSize = true;
                        if (updateOrigin === undefined) updateOrigin = true;
                        if (frame instanceof Frame) {
                            this.texture = this.scene.sys.textures.get(frame.texture.key);
                            this.frame = frame;
                        } else this.frame = this.texture.get(frame);
                        if (!this.frame.cutWidth || !this.frame.cutHeight) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                        if (this._sizeComponent && updateSize) this.setSizeToFrame();
                        if (this._originComponent && updateOrigin) {
                            if (this.frame.customPivot) this.setOrigin(this.frame.pivotX, this.frame.pivotY);
                            else this.updateDisplayOrigin();
                        }
                        return this;
                    }
                };
                module1.exports = Texture;
            /***/ },
            /***/ 79812: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Frame = __webpack_require__(4327);
                //  bitmask flag for GameObject.renderMask
                var _FLAG = 8; // 1000
                /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.TextureCrop
 * @since 3.0.0
 */ var TextureCrop = {
                    /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                    /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                    /**
     * A boolean flag indicating if this Game Object is being cropped or not.
     * You can toggle this at any time after `setCrop` has been called, to turn cropping on or off.
     * Equally, calling `setCrop` with no arguments will reset the crop and disable it.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#isCropped
     * @type {boolean}
     * @since 3.11.0
     */ isCropped: false,
                    /**
     * Applies a crop to a texture based Game Object, such as a Sprite or Image.
     *
     * The crop is a rectangle that limits the area of the texture frame that is visible during rendering.
     *
     * Cropping a Game Object does not change its size, dimensions, physics body or hit area, it just
     * changes what is shown when rendered.
     *
     * The crop size as well as coordinates can not exceed the the size of the texture frame.
     *
     * The crop coordinates are relative to the texture frame, not the Game Object, meaning 0 x 0 is the top-left.
     *
     * Therefore, if you had a Game Object that had an 800x600 sized texture, and you wanted to show only the left
     * half of it, you could call `setCrop(0, 0, 400, 600)`.
     *
     * It is also scaled to match the Game Object scale automatically. Therefore a crop rectangle of 100x50 would crop
     * an area of 200x100 when applied to a Game Object that had a scale factor of 2.
     *
     * You can either pass in numeric values directly, or you can provide a single Rectangle object as the first argument.
     *
     * Call this method with no arguments at all to reset the crop, or toggle the property `isCropped` to `false`.
     *
     * You should do this if the crop rectangle becomes the same size as the frame itself, as it will allow
     * the renderer to skip several internal calculations.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setCrop
     * @since 3.11.0
     *
     * @param {(number|Phaser.Geom.Rectangle)} [x] - The x coordinate to start the crop from. Cannot be negative or exceed the Frame width. Or a Phaser.Geom.Rectangle object, in which case the rest of the arguments are ignored.
     * @param {number} [y] - The y coordinate to start the crop from. Cannot be negative or exceed the Frame height.
     * @param {number} [width] - The width of the crop rectangle in pixels. Cannot exceed the Frame width.
     * @param {number} [height] - The height of the crop rectangle in pixels. Cannot exceed the Frame height.
     *
     * @return {this} This Game Object instance.
     */ setCrop: function(x, y, width, height) {
                        if (x === undefined) this.isCropped = false;
                        else if (this.frame) {
                            if (typeof x === 'number') this.frame.setCropUVs(this._crop, x, y, width, height, this.flipX, this.flipY);
                            else {
                                var rect = x;
                                this.frame.setCropUVs(this._crop, rect.x, rect.y, rect.width, rect.height, this.flipX, this.flipY);
                            }
                            this.isCropped = true;
                        }
                        return this;
                    },
                    /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                        this.texture = this.scene.sys.textures.get(key);
                        return this.setFrame(frame);
                    },
                    /**
     * Sets the frame this Game Object will use to render with.
     *
     * If you pass a string or index then the Frame has to belong to the current Texture being used
     * by this Game Object.
     *
     * If you pass a Frame instance, then the Texture being used by this Game Object will also be updated.
     *
     * Calling `setFrame` will modify the `width` and `height` properties of your Game Object.
     *
     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setFrame
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Textures.Frame)} frame - The name or index of the frame within the Texture, or a Frame instance.
     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
     * @param {boolean} [updateOrigin=true] - Should this call adjust the origin of the Game Object?
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame, updateSize, updateOrigin) {
                        if (updateSize === undefined) updateSize = true;
                        if (updateOrigin === undefined) updateOrigin = true;
                        if (frame instanceof Frame) {
                            this.texture = this.scene.sys.textures.get(frame.texture.key);
                            this.frame = frame;
                        } else this.frame = this.texture.get(frame);
                        if (!this.frame.cutWidth || !this.frame.cutHeight) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                        if (this._sizeComponent && updateSize) this.setSizeToFrame();
                        if (this._originComponent && updateOrigin) {
                            if (this.frame.customPivot) this.setOrigin(this.frame.pivotX, this.frame.pivotY);
                            else this.updateDisplayOrigin();
                        }
                        if (this.isCropped) this.frame.updateCropUVs(this._crop, this.flipX, this.flipY);
                        return this;
                    },
                    /**
     * Internal method that returns a blank, well-formed crop object for use by a Game Object.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#resetCropObject
     * @private
     * @since 3.12.0
     *
     * @return {object} The crop object.
     */ resetCropObject: function() {
                        return {
                            u0: 0,
                            v0: 0,
                            u1: 0,
                            v1: 0,
                            width: 0,
                            height: 0,
                            x: 0,
                            y: 0,
                            flipX: false,
                            flipY: false,
                            cx: 0,
                            cy: 0,
                            cw: 0,
                            ch: 0
                        };
                    }
                };
                module1.exports = TextureCrop;
            /***/ },
            /***/ 27472: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the tint of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Tint
 * @webglOnly
 * @since 3.0.0
 */ var Tint = {
                    /**
     * The tint value being applied to the top-left vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintTopLeft
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintTopLeft: 0xffffff,
                    /**
     * The tint value being applied to the top-right vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintTopRight
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintTopRight: 0xffffff,
                    /**
     * The tint value being applied to the bottom-left vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintBottomLeft
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintBottomLeft: 0xffffff,
                    /**
     * The tint value being applied to the bottom-right vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintBottomRight
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintBottomRight: 0xffffff,
                    /**
     * The tint fill mode.
     *
     * `false` = An additive tint (the default), where vertices colors are blended with the texture.
     * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
     *
     * @name Phaser.GameObjects.Components.Tint#tintFill
     * @type {boolean}
     * @default false
     * @since 3.11.0
     */ tintFill: false,
                    /**
     * Clears all tint values associated with this Game Object.
     *
     * Immediately sets the color values back to 0xffffff and the tint type to 'additive',
     * which results in no visible change to the texture.
     *
     * @method Phaser.GameObjects.Components.Tint#clearTint
     * @webglOnly
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearTint: function() {
                        this.setTint(0xffffff);
                        return this;
                    },
                    /**
     * Sets an additive tint on this Game Object.
     *
     * The tint works by taking the pixel color values from the Game Objects texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole Game Object will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the Game Object.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property to set all colors at once. Or, use the properties `tintTopLeft`, `tintTopRight,
     * `tintBottomLeft` and `tintBottomRight` to set the corner color values independently.
     *
     * To remove a tint call `clearTint`.
     *
     * To swap this from being an additive tint to a fill based tint set the property `tintFill` to `true`.
     *
     * @method Phaser.GameObjects.Components.Tint#setTint
     * @webglOnly
     * @since 3.0.0
     *
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the Game Object. If no other values are given this value is applied evenly, tinting the whole Game Object.
     * @param {number} [topRight] - The tint being applied to the top-right of the Game Object.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the Game Object.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTint: function(topLeft, topRight, bottomLeft, bottomRight) {
                        if (topLeft === undefined) topLeft = 0xffffff;
                        if (topRight === undefined) {
                            topRight = topLeft;
                            bottomLeft = topLeft;
                            bottomRight = topLeft;
                        }
                        this.tintTopLeft = topLeft;
                        this.tintTopRight = topRight;
                        this.tintBottomLeft = bottomLeft;
                        this.tintBottomRight = bottomRight;
                        this.tintFill = false;
                        return this;
                    },
                    /**
     * Sets a fill-based tint on this Game Object.
     *
     * Unlike an additive tint, a fill-tint literally replaces the pixel colors from the texture
     * with those in the tint. You can use this for effects such as making a player flash 'white'
     * if hit by something. You can provide either one color value, in which case the whole
     * Game Object will be rendered in that color. Or you can provide a color per corner. The colors
     * are blended together across the extent of the Game Object.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property to set all colors at once. Or, use the properties `tintTopLeft`, `tintTopRight,
     * `tintBottomLeft` and `tintBottomRight` to set the corner color values independently.
     *
     * To remove a tint call `clearTint`.
     *
     * To swap this from being a fill-tint to an additive tint set the property `tintFill` to `false`.
     *
     * @method Phaser.GameObjects.Components.Tint#setTintFill
     * @webglOnly
     * @since 3.11.0
     *
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the Game Object. If not other values are given this value is applied evenly, tinting the whole Game Object.
     * @param {number} [topRight] - The tint being applied to the top-right of the Game Object.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the Game Object.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTintFill: function(topLeft, topRight, bottomLeft, bottomRight) {
                        this.setTint(topLeft, topRight, bottomLeft, bottomRight);
                        this.tintFill = true;
                        return this;
                    },
                    /**
     * The tint value being applied to the whole of the Game Object.
     * Return `tintTopLeft` when read this tint property.
     *
     * @name Phaser.GameObjects.Components.Tint#tint
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ tint: {
                        get: function() {
                            return this.tintTopLeft;
                        },
                        set: function(value) {
                            this.setTint(value, value, value, value);
                        }
                    },
                    /**
     * Does this Game Object have a tint applied?
     *
     * It checks to see if the 4 tint properties are set to the value 0xffffff
     * and that the `tintFill` property is `false`. This indicates that a Game Object isn't tinted.
     *
     * @name Phaser.GameObjects.Components.Tint#isTinted
     * @type {boolean}
     * @webglOnly
     * @readonly
     * @since 3.11.0
     */ isTinted: {
                        get: function() {
                            var white = 0xffffff;
                            return this.tintFill || this.tintTopLeft !== white || this.tintTopRight !== white || this.tintBottomLeft !== white || this.tintBottomRight !== white;
                        }
                    }
                };
                module1.exports = Tint;
            /***/ },
            /***/ 53774: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Build a JSON representation of the given Game Object.
 *
 * This is typically extended further by Game Object specific implementations.
 *
 * @method Phaser.GameObjects.Components.ToJSON
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to export as JSON.
 *
 * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
 */ var ToJSON = function(gameObject) {
                    var out = {
                        name: gameObject.name,
                        type: gameObject.type,
                        x: gameObject.x,
                        y: gameObject.y,
                        depth: gameObject.depth,
                        scale: {
                            x: gameObject.scaleX,
                            y: gameObject.scaleY
                        },
                        origin: {
                            x: gameObject.originX,
                            y: gameObject.originY
                        },
                        flipX: gameObject.flipX,
                        flipY: gameObject.flipY,
                        rotation: gameObject.rotation,
                        alpha: gameObject.alpha,
                        visible: gameObject.visible,
                        blendMode: gameObject.blendMode,
                        textureKey: '',
                        frameKey: '',
                        data: {}
                    };
                    if (gameObject.texture) {
                        out.textureKey = gameObject.texture.key;
                        out.frameKey = gameObject.frame.name;
                    }
                    return out;
                };
                module1.exports = ToJSON;
            /***/ },
            /***/ 16901: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(36383);
                var TransformMatrix = __webpack_require__(61340);
                var TransformXY = __webpack_require__(85955);
                var WrapAngle = __webpack_require__(86554);
                var WrapAngleDegrees = __webpack_require__(30954);
                var Vector2 = __webpack_require__(26099);
                //  global bitmask flag for GameObject.renderMask (used by Scale)
                var _FLAG = 4; // 0100
                /**
 * Provides methods used for getting and setting the position, scale and rotation of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Transform
 * @since 3.0.0
 */ var Transform = {
                    /**
     * A property indicating that a Game Object has this component.
     *
     * @name Phaser.GameObjects.Components.Transform#hasTransformComponent
     * @type {boolean}
     * @readonly
     * @default true
     * @since 3.60.0
     */ hasTransformComponent: true,
                    /**
     * Private internal value. Holds the horizontal scale value.
     *
     * @name Phaser.GameObjects.Components.Transform#_scaleX
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _scaleX: 1,
                    /**
     * Private internal value. Holds the vertical scale value.
     *
     * @name Phaser.GameObjects.Components.Transform#_scaleY
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _scaleY: 1,
                    /**
     * Private internal value. Holds the rotation value in radians.
     *
     * @name Phaser.GameObjects.Components.Transform#_rotation
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _rotation: 0,
                    /**
     * The x position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#x
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ x: 0,
                    /**
     * The y position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#y
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ y: 0,
                    /**
     * The z position of this Game Object.
     *
     * Note: The z position does not control the rendering order of 2D Game Objects. Use
     * {@link Phaser.GameObjects.Components.Depth#depth} instead.
     *
     * @name Phaser.GameObjects.Components.Transform#z
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ z: 0,
                    /**
     * The w position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#w
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ w: 0,
                    /**
     * This is a special setter that allows you to set both the horizontal and vertical scale of this Game Object
     * to the same value, at the same time. When reading this value the result returned is `(scaleX + scaleY) / 2`.
     *
     * Use of this property implies you wish the horizontal and vertical scales to be equal to each other. If this
     * isn't the case, use the `scaleX` or `scaleY` properties instead.
     *
     * @name Phaser.GameObjects.Components.Transform#scale
     * @type {number}
     * @default 1
     * @since 3.18.0
     */ scale: {
                        get: function() {
                            return (this._scaleX + this._scaleY) / 2;
                        },
                        set: function(value) {
                            this._scaleX = value;
                            this._scaleY = value;
                            if (value === 0) this.renderFlags &= ~_FLAG;
                            else this.renderFlags |= _FLAG;
                        }
                    },
                    /**
     * The horizontal scale of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#scaleX
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scaleX: {
                        get: function() {
                            return this._scaleX;
                        },
                        set: function(value) {
                            this._scaleX = value;
                            if (value === 0) this.renderFlags &= ~_FLAG;
                            else if (this._scaleY !== 0) this.renderFlags |= _FLAG;
                        }
                    },
                    /**
     * The vertical scale of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#scaleY
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scaleY: {
                        get: function() {
                            return this._scaleY;
                        },
                        set: function(value) {
                            this._scaleY = value;
                            if (value === 0) this.renderFlags &= ~_FLAG;
                            else if (this._scaleX !== 0) this.renderFlags |= _FLAG;
                        }
                    },
                    /**
     * The angle of this Game Object as expressed in degrees.
     *
     * Phaser uses a right-hand clockwise rotation system, where 0 is right, 90 is down, 180/-180 is left
     * and -90 is up.
     *
     * If you prefer to work in radians, see the `rotation` property instead.
     *
     * @name Phaser.GameObjects.Components.Transform#angle
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ angle: {
                        get: function() {
                            return WrapAngleDegrees(this._rotation * MATH_CONST.RAD_TO_DEG);
                        },
                        set: function(value) {
                            //  value is in degrees
                            this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
                        }
                    },
                    /**
     * The angle of this Game Object in radians.
     *
     * Phaser uses a right-hand clockwise rotation system, where 0 is right, PI/2 is down, +-PI is left
     * and -PI/2 is up.
     *
     * If you prefer to work in degrees, see the `angle` property instead.
     *
     * @name Phaser.GameObjects.Components.Transform#rotation
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ rotation: {
                        get: function() {
                            return this._rotation;
                        },
                        set: function(value) {
                            //  value is in radians
                            this._rotation = WrapAngle(value);
                        }
                    },
                    /**
     * Sets the position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of this Game Object.
     * @param {number} [y=x] - The y position of this Game Object. If not set it will use the `x` value.
     * @param {number} [z=0] - The z position of this Game Object.
     * @param {number} [w=0] - The w position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setPosition: function(x, y, z, w) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = x;
                        if (z === undefined) z = 0;
                        if (w === undefined) w = 0;
                        this.x = x;
                        this.y = y;
                        this.z = z;
                        this.w = w;
                        return this;
                    },
                    /**
     * Copies an object's coordinates to this Game Object's position.
     *
     * @method Phaser.GameObjects.Components.Transform#copyPosition
     * @since 3.50.0
     *
     * @param {(Phaser.Types.Math.Vector2Like|Phaser.Types.Math.Vector3Like|Phaser.Types.Math.Vector4Like)} source - An object with numeric 'x', 'y', 'z', or 'w' properties. Undefined values are not copied.
     *
     * @return {this} This Game Object instance.
     */ copyPosition: function(source) {
                        if (source.x !== undefined) this.x = source.x;
                        if (source.y !== undefined) this.y = source.y;
                        if (source.z !== undefined) this.z = source.z;
                        if (source.w !== undefined) this.w = source.w;
                        return this;
                    },
                    /**
     * Sets the position of this Game Object to be a random position within the confines of
     * the given area.
     *
     * If no area is specified a random position between 0 x 0 and the game width x height is used instead.
     *
     * The position does not factor in the size of this Game Object, meaning that only the origin is
     * guaranteed to be within the area.
     *
     * @method Phaser.GameObjects.Components.Transform#setRandomPosition
     * @since 3.8.0
     *
     * @param {number} [x=0] - The x position of the top-left of the random area.
     * @param {number} [y=0] - The y position of the top-left of the random area.
     * @param {number} [width] - The width of the random area.
     * @param {number} [height] - The height of the random area.
     *
     * @return {this} This Game Object instance.
     */ setRandomPosition: function(x, y, width, height) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.scene.sys.scale.width;
                        if (height === undefined) height = this.scene.sys.scale.height;
                        this.x = x + Math.random() * width;
                        this.y = y + Math.random() * height;
                        return this;
                    },
                    /**
     * Sets the rotation of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setRotation
     * @since 3.0.0
     *
     * @param {number} [radians=0] - The rotation of this Game Object, in radians.
     *
     * @return {this} This Game Object instance.
     */ setRotation: function(radians) {
                        if (radians === undefined) radians = 0;
                        this.rotation = radians;
                        return this;
                    },
                    /**
     * Sets the angle of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setAngle
     * @since 3.0.0
     *
     * @param {number} [degrees=0] - The rotation of this Game Object, in degrees.
     *
     * @return {this} This Game Object instance.
     */ setAngle: function(degrees) {
                        if (degrees === undefined) degrees = 0;
                        this.angle = degrees;
                        return this;
                    },
                    /**
     * Sets the scale of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setScale
     * @since 3.0.0
     *
     * @param {number} [x=1] - The horizontal scale of this Game Object.
     * @param {number} [y=x] - The vertical scale of this Game Object. If not set it will use the `x` value.
     *
     * @return {this} This Game Object instance.
     */ setScale: function(x, y) {
                        if (x === undefined) x = 1;
                        if (y === undefined) y = x;
                        this.scaleX = x;
                        this.scaleY = y;
                        return this;
                    },
                    /**
     * Sets the x position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setX
     * @since 3.0.0
     *
     * @param {number} [value=0] - The x position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setX: function(value) {
                        if (value === undefined) value = 0;
                        this.x = value;
                        return this;
                    },
                    /**
     * Sets the y position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setY
     * @since 3.0.0
     *
     * @param {number} [value=0] - The y position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setY: function(value) {
                        if (value === undefined) value = 0;
                        this.y = value;
                        return this;
                    },
                    /**
     * Sets the z position of this Game Object.
     *
     * Note: The z position does not control the rendering order of 2D Game Objects. Use
     * {@link Phaser.GameObjects.Components.Depth#setDepth} instead.
     *
     * @method Phaser.GameObjects.Components.Transform#setZ
     * @since 3.0.0
     *
     * @param {number} [value=0] - The z position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setZ: function(value) {
                        if (value === undefined) value = 0;
                        this.z = value;
                        return this;
                    },
                    /**
     * Sets the w position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setW
     * @since 3.0.0
     *
     * @param {number} [value=0] - The w position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setW: function(value) {
                        if (value === undefined) value = 0;
                        this.w = value;
                        return this;
                    },
                    /**
     * Gets the local transform matrix for this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#getLocalTransformMatrix
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
     */ getLocalTransformMatrix: function(tempMatrix) {
                        if (tempMatrix === undefined) tempMatrix = new TransformMatrix();
                        return tempMatrix.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
                    },
                    /**
     * Gets the world transform matrix for this Game Object, factoring in any parent Containers.
     *
     * @method Phaser.GameObjects.Components.Transform#getWorldTransformMatrix
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - A temporary matrix to hold parent values during the calculations.
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
     */ getWorldTransformMatrix: function(tempMatrix, parentMatrix) {
                        if (tempMatrix === undefined) tempMatrix = new TransformMatrix();
                        var parent = this.parentContainer;
                        if (!parent) return this.getLocalTransformMatrix(tempMatrix);
                        var destroyParentMatrix = false;
                        if (!parentMatrix) {
                            parentMatrix = new TransformMatrix();
                            destroyParentMatrix = true;
                        }
                        tempMatrix.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
                        while(parent){
                            parentMatrix.applyITRS(parent.x, parent.y, parent._rotation, parent._scaleX, parent._scaleY);
                            parentMatrix.multiply(tempMatrix, tempMatrix);
                            parent = parent.parentContainer;
                        }
                        if (destroyParentMatrix) parentMatrix.destroy();
                        return tempMatrix;
                    },
                    /**
     * Takes the given `x` and `y` coordinates and converts them into local space for this
     * Game Object, taking into account parent and local transforms, and the Display Origin.
     *
     * The returned Vector2 contains the translated point in its properties.
     *
     * A Camera needs to be provided in order to handle modified scroll factors. If no
     * camera is specified, it will use the `main` camera from the Scene to which this
     * Game Object belongs.
     *
     * @method Phaser.GameObjects.Components.Transform#getLocalPoint
     * @since 3.50.0
     *
     * @param {number} x - The x position to translate.
     * @param {number} y - The y position to translate.
     * @param {Phaser.Math.Vector2} [point] - A Vector2, or point-like object, to store the results in.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera which is being tested against. If not given will use the Scene default camera.
     *
     * @return {Phaser.Math.Vector2} The translated point.
     */ getLocalPoint: function(x, y, point, camera) {
                        if (!point) point = new Vector2();
                        if (!camera) camera = this.scene.sys.cameras.main;
                        var csx = camera.scrollX;
                        var csy = camera.scrollY;
                        var px = x + csx * this.scrollFactorX - csx;
                        var py = y + csy * this.scrollFactorY - csy;
                        if (this.parentContainer) this.getWorldTransformMatrix().applyInverse(px, py, point);
                        else TransformXY(px, py, this.x, this.y, this.rotation, this.scaleX, this.scaleY, point);
                        //  Normalize origin
                        if (this._originComponent) {
                            point.x += this._displayOriginX;
                            point.y += this._displayOriginY;
                        }
                        return point;
                    },
                    /**
     * Gets the world position of this Game Object, factoring in any parent Containers.
     *
     * @method Phaser.GameObjects.Components.Transform#getWorldPoint
     * @since 3.88.0
     *
     * @param {Phaser.Math.Vector2} [point] - A Vector2, or point-like object, to store the result in.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - A temporary matrix to hold the Game Object's values.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - A temporary matrix to hold parent values.
     *
     * @return {Phaser.Math.Vector2} The world position of this Game Object.
     */ getWorldPoint: function(point, tempMatrix, parentMatrix) {
                        if (point === undefined) point = new Vector2();
                        var parent = this.parentContainer;
                        if (!parent) {
                            point.x = this.x;
                            point.y = this.y;
                            return point;
                        }
                        var worldTransform = this.getWorldTransformMatrix(tempMatrix, parentMatrix);
                        point.x = worldTransform.tx;
                        point.y = worldTransform.ty;
                        return point;
                    },
                    /**
     * Gets the sum total rotation of all of this Game Objects parent Containers.
     *
     * The returned value is in radians and will be zero if this Game Object has no parent container.
     *
     * @method Phaser.GameObjects.Components.Transform#getParentRotation
     * @since 3.18.0
     *
     * @return {number} The sum total rotation, in radians, of all parent containers of this Game Object.
     */ getParentRotation: function() {
                        var rotation = 0;
                        var parent = this.parentContainer;
                        while(parent){
                            rotation += parent.rotation;
                            parent = parent.parentContainer;
                        }
                        return rotation;
                    }
                };
                module1.exports = Transform;
            /***/ },
            /***/ 61340: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var MATH_CONST = __webpack_require__(36383);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Matrix used for display transformations for rendering.
 *
 * It is represented like so:
 *
 * ```
 * | a | c | tx |
 * | b | d | ty |
 * | 0 | 0 | 1  |
 * ```
 *
 * @class TransformMatrix
 * @memberof Phaser.GameObjects.Components
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [a=1] - The Scale X value.
 * @param {number} [b=0] - The Skew Y value.
 * @param {number} [c=0] - The Skew X value.
 * @param {number} [d=1] - The Scale Y value.
 * @param {number} [tx=0] - The Translate X value.
 * @param {number} [ty=0] - The Translate Y value.
 */ var TransformMatrix = new Class({
                    initialize: function TransformMatrix(a, b, c, d, tx, ty) {
                        if (a === undefined) a = 1;
                        if (b === undefined) b = 0;
                        if (c === undefined) c = 0;
                        if (d === undefined) d = 1;
                        if (tx === undefined) tx = 0;
                        if (ty === undefined) ty = 0;
                        /**
         * The matrix values.
         *
         * @name Phaser.GameObjects.Components.TransformMatrix#matrix
         * @type {Float32Array}
         * @since 3.0.0
         */ this.matrix = new Float32Array([
                            a,
                            b,
                            c,
                            d,
                            tx,
                            ty,
                            0,
                            0,
                            1
                        ]);
                        /**
         * The decomposed matrix.
         *
         * @name Phaser.GameObjects.Components.TransformMatrix#decomposedMatrix
         * @type {object}
         * @since 3.0.0
         */ this.decomposedMatrix = {
                            translateX: 0,
                            translateY: 0,
                            scaleX: 1,
                            scaleY: 1,
                            rotation: 0
                        };
                        /**
         * The temporary quad value cache.
         *
         * @name Phaser.GameObjects.Components.TransformMatrix#quad
         * @type {Float32Array}
         * @since 3.60.0
         */ this.quad = new Float32Array(8);
                    },
                    /**
     * The Scale X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#a
     * @type {number}
     * @since 3.4.0
     */ a: {
                        get: function() {
                            return this.matrix[0];
                        },
                        set: function(value) {
                            this.matrix[0] = value;
                        }
                    },
                    /**
     * The Skew Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#b
     * @type {number}
     * @since 3.4.0
     */ b: {
                        get: function() {
                            return this.matrix[1];
                        },
                        set: function(value) {
                            this.matrix[1] = value;
                        }
                    },
                    /**
     * The Skew X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#c
     * @type {number}
     * @since 3.4.0
     */ c: {
                        get: function() {
                            return this.matrix[2];
                        },
                        set: function(value) {
                            this.matrix[2] = value;
                        }
                    },
                    /**
     * The Scale Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#d
     * @type {number}
     * @since 3.4.0
     */ d: {
                        get: function() {
                            return this.matrix[3];
                        },
                        set: function(value) {
                            this.matrix[3] = value;
                        }
                    },
                    /**
     * The Translate X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#e
     * @type {number}
     * @since 3.11.0
     */ e: {
                        get: function() {
                            return this.matrix[4];
                        },
                        set: function(value) {
                            this.matrix[4] = value;
                        }
                    },
                    /**
     * The Translate Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#f
     * @type {number}
     * @since 3.11.0
     */ f: {
                        get: function() {
                            return this.matrix[5];
                        },
                        set: function(value) {
                            this.matrix[5] = value;
                        }
                    },
                    /**
     * The Translate X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#tx
     * @type {number}
     * @since 3.4.0
     */ tx: {
                        get: function() {
                            return this.matrix[4];
                        },
                        set: function(value) {
                            this.matrix[4] = value;
                        }
                    },
                    /**
     * The Translate Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#ty
     * @type {number}
     * @since 3.4.0
     */ ty: {
                        get: function() {
                            return this.matrix[5];
                        },
                        set: function(value) {
                            this.matrix[5] = value;
                        }
                    },
                    /**
     * The rotation of the Matrix. Value is in radians.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#rotation
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ rotation: {
                        get: function() {
                            return Math.acos(this.a / this.scaleX) * (Math.atan(-this.c / this.a) < 0 ? -1 : 1);
                        }
                    },
                    /**
     * The rotation of the Matrix, normalized to be within the Phaser right-handed
     * clockwise rotation space. Value is in radians.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#rotationNormalized
     * @type {number}
     * @readonly
     * @since 3.19.0
     */ rotationNormalized: {
                        get: function() {
                            var matrix = this.matrix;
                            var a = matrix[0];
                            var b = matrix[1];
                            var c = matrix[2];
                            var d = matrix[3];
                            if (a || b) // var r = Math.sqrt(a * a + b * b);
                            return b > 0 ? Math.acos(a / this.scaleX) : -Math.acos(a / this.scaleX);
                            else if (c || d) // var s = Math.sqrt(c * c + d * d);
                            return MATH_CONST.TAU - (d > 0 ? Math.acos(-c / this.scaleY) : -Math.acos(c / this.scaleY));
                            else return 0;
                        }
                    },
                    /**
     * The decomposed horizontal scale of the Matrix. This value is always positive.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#scaleX
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ scaleX: {
                        get: function() {
                            return Math.sqrt(this.a * this.a + this.b * this.b);
                        }
                    },
                    /**
     * The decomposed vertical scale of the Matrix. This value is always positive.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#scaleY
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ scaleY: {
                        get: function() {
                            return Math.sqrt(this.c * this.c + this.d * this.d);
                        }
                    },
                    /**
     * Reset the Matrix to an identity matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#loadIdentity
     * @since 3.0.0
     *
     * @return {this} This TransformMatrix.
     */ loadIdentity: function() {
                        var matrix = this.matrix;
                        matrix[0] = 1;
                        matrix[1] = 0;
                        matrix[2] = 0;
                        matrix[3] = 1;
                        matrix[4] = 0;
                        matrix[5] = 0;
                        return this;
                    },
                    /**
     * Translate the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#translate
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation value.
     * @param {number} y - The vertical translation value.
     *
     * @return {this} This TransformMatrix.
     */ translate: function(x, y) {
                        var matrix = this.matrix;
                        matrix[4] = matrix[0] * x + matrix[2] * y + matrix[4];
                        matrix[5] = matrix[1] * x + matrix[3] * y + matrix[5];
                        return this;
                    },
                    /**
     * Scale the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#scale
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale value.
     * @param {number} y - The vertical scale value.
     *
     * @return {this} This TransformMatrix.
     */ scale: function(x, y) {
                        var matrix = this.matrix;
                        matrix[0] *= x;
                        matrix[1] *= x;
                        matrix[2] *= y;
                        matrix[3] *= y;
                        return this;
                    },
                    /**
     * Rotate the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#rotate
     * @since 3.0.0
     *
     * @param {number} angle - The angle of rotation in radians.
     *
     * @return {this} This TransformMatrix.
     */ rotate: function(angle) {
                        var sin = Math.sin(angle);
                        var cos = Math.cos(angle);
                        var matrix = this.matrix;
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        matrix[0] = a * cos + c * sin;
                        matrix[1] = b * cos + d * sin;
                        matrix[2] = a * -sin + c * cos;
                        matrix[3] = b * -sin + d * cos;
                        return this;
                    },
                    /**
     * Multiply this Matrix by the given Matrix.
     *
     * If an `out` Matrix is given then the results will be stored in it.
     * If it is not given, this matrix will be updated in place instead.
     * Use an `out` Matrix if you do not wish to mutate this matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#multiply
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} rhs - The Matrix to multiply by.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [out] - An optional Matrix to store the results in.
     *
     * @return {(this|Phaser.GameObjects.Components.TransformMatrix)} Either this TransformMatrix, or the `out` Matrix, if given in the arguments.
     */ multiply: function(rhs, out) {
                        var matrix = this.matrix;
                        var source = rhs.matrix;
                        var localA = matrix[0];
                        var localB = matrix[1];
                        var localC = matrix[2];
                        var localD = matrix[3];
                        var localE = matrix[4];
                        var localF = matrix[5];
                        var sourceA = source[0];
                        var sourceB = source[1];
                        var sourceC = source[2];
                        var sourceD = source[3];
                        var sourceE = source[4];
                        var sourceF = source[5];
                        var destinationMatrix = out === undefined ? matrix : out.matrix;
                        destinationMatrix[0] = sourceA * localA + sourceB * localC;
                        destinationMatrix[1] = sourceA * localB + sourceB * localD;
                        destinationMatrix[2] = sourceC * localA + sourceD * localC;
                        destinationMatrix[3] = sourceC * localB + sourceD * localD;
                        destinationMatrix[4] = sourceE * localA + sourceF * localC + localE;
                        destinationMatrix[5] = sourceE * localB + sourceF * localD + localF;
                        return destinationMatrix;
                    },
                    /**
     * Multiply this Matrix by the matrix given, including the offset.
     *
     * The offsetX is added to the tx value: `offsetX * a + offsetY * c + tx`.
     * The offsetY is added to the ty value: `offsetY * b + offsetY * d + ty`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#multiplyWithOffset
     * @since 3.11.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} src - The source Matrix to copy from.
     * @param {number} offsetX - Horizontal offset to factor in to the multiplication.
     * @param {number} offsetY - Vertical offset to factor in to the multiplication.
     *
     * @return {this} This TransformMatrix.
     */ multiplyWithOffset: function(src, offsetX, offsetY) {
                        var matrix = this.matrix;
                        var otherMatrix = src.matrix;
                        var a0 = matrix[0];
                        var b0 = matrix[1];
                        var c0 = matrix[2];
                        var d0 = matrix[3];
                        var tx0 = matrix[4];
                        var ty0 = matrix[5];
                        var pse = offsetX * a0 + offsetY * c0 + tx0;
                        var psf = offsetX * b0 + offsetY * d0 + ty0;
                        var a1 = otherMatrix[0];
                        var b1 = otherMatrix[1];
                        var c1 = otherMatrix[2];
                        var d1 = otherMatrix[3];
                        var tx1 = otherMatrix[4];
                        var ty1 = otherMatrix[5];
                        matrix[0] = a1 * a0 + b1 * c0;
                        matrix[1] = a1 * b0 + b1 * d0;
                        matrix[2] = c1 * a0 + d1 * c0;
                        matrix[3] = c1 * b0 + d1 * d0;
                        matrix[4] = tx1 * a0 + ty1 * c0 + pse;
                        matrix[5] = tx1 * b0 + ty1 * d0 + psf;
                        return this;
                    },
                    /**
     * Transform the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#transform
     * @since 3.0.0
     *
     * @param {number} a - The Scale X value.
     * @param {number} b - The Shear Y value.
     * @param {number} c - The Shear X value.
     * @param {number} d - The Scale Y value.
     * @param {number} tx - The Translate X value.
     * @param {number} ty - The Translate Y value.
     *
     * @return {this} This TransformMatrix.
     */ transform: function(a, b, c, d, tx, ty) {
                        var matrix = this.matrix;
                        var a0 = matrix[0];
                        var b0 = matrix[1];
                        var c0 = matrix[2];
                        var d0 = matrix[3];
                        var tx0 = matrix[4];
                        var ty0 = matrix[5];
                        matrix[0] = a * a0 + b * c0;
                        matrix[1] = a * b0 + b * d0;
                        matrix[2] = c * a0 + d * c0;
                        matrix[3] = c * b0 + d * d0;
                        matrix[4] = tx * a0 + ty * c0 + tx0;
                        matrix[5] = tx * b0 + ty * d0 + ty0;
                        return this;
                    },
                    /**
     * Transform a point in to the local space of this Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#transformPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point to transform.
     * @param {number} y - The y coordinate of the point to transform.
     * @param {Phaser.Types.Math.Vector2Like} [point] - Optional Point object to store the transformed coordinates in.
     *
     * @return {Phaser.Types.Math.Vector2Like} The Point containing the transformed coordinates.
     */ transformPoint: function(x, y, point) {
                        if (point === undefined) point = {
                            x: 0,
                            y: 0
                        };
                        var matrix = this.matrix;
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        var tx = matrix[4];
                        var ty = matrix[5];
                        point.x = x * a + y * c + tx;
                        point.y = x * b + y * d + ty;
                        return point;
                    },
                    /**
     * Invert the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#invert
     * @since 3.0.0
     *
     * @return {this} This TransformMatrix.
     */ invert: function() {
                        var matrix = this.matrix;
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        var tx = matrix[4];
                        var ty = matrix[5];
                        var n = a * d - b * c;
                        matrix[0] = d / n;
                        matrix[1] = -b / n;
                        matrix[2] = -c / n;
                        matrix[3] = a / n;
                        matrix[4] = (c * ty - d * tx) / n;
                        matrix[5] = -(a * ty - b * tx) / n;
                        return this;
                    },
                    /**
     * Set the values of this Matrix to copy those of the matrix given.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyFrom
     * @since 3.11.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} src - The source Matrix to copy from.
     *
     * @return {this} This TransformMatrix.
     */ copyFrom: function(src) {
                        var matrix = this.matrix;
                        matrix[0] = src.a;
                        matrix[1] = src.b;
                        matrix[2] = src.c;
                        matrix[3] = src.d;
                        matrix[4] = src.e;
                        matrix[5] = src.f;
                        return this;
                    },
                    /**
     * Set the values of this Matrix to copy those of the array given.
     * Where array indexes 0, 1, 2, 3, 4 and 5 are mapped to a, b, c, d, e and f.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyFromArray
     * @since 3.11.0
     *
     * @param {array} src - The array of values to set into this matrix.
     *
     * @return {this} This TransformMatrix.
     */ copyFromArray: function(src) {
                        var matrix = this.matrix;
                        matrix[0] = src[0];
                        matrix[1] = src[1];
                        matrix[2] = src[2];
                        matrix[3] = src[3];
                        matrix[4] = src[4];
                        matrix[5] = src[5];
                        return this;
                    },
                    /**
     * Copy the values from this Matrix to the given Canvas Rendering Context.
     * This will use the Context.transform method.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyToContext
     * @since 3.12.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas Rendering Context to copy the matrix values to.
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context.
     */ copyToContext: function(ctx) {
                        var matrix = this.matrix;
                        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        return ctx;
                    },
                    /**
     * Copy the values from this Matrix to the given Canvas Rendering Context.
     * This will use the Context.setTransform method.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#setToContext
     * @since 3.12.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas Rendering Context to copy the matrix values to.
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context.
     */ setToContext: function(ctx) {
                        // using old way for old browser compatibility #6965
                        ctx.setTransform(this.a, this.b, this.c, this.d, this.e, this.f);
                        return ctx;
                    },
                    /**
     * Copy the values in this Matrix to the array given.
     *
     * Where array indexes 0, 1, 2, 3, 4 and 5 are mapped to a, b, c, d, e and f.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyToArray
     * @since 3.12.0
     *
     * @param {array} [out] - The array to copy the matrix values in to.
     *
     * @return {array} An array where elements 0 to 5 contain the values from this matrix.
     */ copyToArray: function(out) {
                        var matrix = this.matrix;
                        if (out === undefined) out = [
                            matrix[0],
                            matrix[1],
                            matrix[2],
                            matrix[3],
                            matrix[4],
                            matrix[5]
                        ];
                        else {
                            out[0] = matrix[0];
                            out[1] = matrix[1];
                            out[2] = matrix[2];
                            out[3] = matrix[3];
                            out[4] = matrix[4];
                            out[5] = matrix[5];
                        }
                        return out;
                    },
                    /**
     * Set the values of this Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#setTransform
     * @since 3.0.0
     *
     * @param {number} a - The Scale X value.
     * @param {number} b - The Shear Y value.
     * @param {number} c - The Shear X value.
     * @param {number} d - The Scale Y value.
     * @param {number} tx - The Translate X value.
     * @param {number} ty - The Translate Y value.
     *
     * @return {this} This TransformMatrix.
     */ setTransform: function(a, b, c, d, tx, ty) {
                        var matrix = this.matrix;
                        matrix[0] = a;
                        matrix[1] = b;
                        matrix[2] = c;
                        matrix[3] = d;
                        matrix[4] = tx;
                        matrix[5] = ty;
                        return this;
                    },
                    /**
     * Decompose this Matrix into its translation, scale and rotation values using QR decomposition.
     *
     * The result must be applied in the following order to reproduce the current matrix:
     *
     * translate -> rotate -> scale
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#decomposeMatrix
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.DecomposeMatrixResults} The decomposed Matrix.
     */ decomposeMatrix: function() {
                        var decomposedMatrix = this.decomposedMatrix;
                        var matrix = this.matrix;
                        //  a = scale X (1)
                        //  b = shear Y (0)
                        //  c = shear X (0)
                        //  d = scale Y (1)
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        var determ = a * d - b * c;
                        decomposedMatrix.translateX = matrix[4];
                        decomposedMatrix.translateY = matrix[5];
                        if (a || b) {
                            var r = Math.sqrt(a * a + b * b);
                            decomposedMatrix.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
                            decomposedMatrix.scaleX = r;
                            decomposedMatrix.scaleY = determ / r;
                        } else if (c || d) {
                            var s = Math.sqrt(c * c + d * d);
                            decomposedMatrix.rotation = Math.PI * 0.5 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
                            decomposedMatrix.scaleX = determ / s;
                            decomposedMatrix.scaleY = s;
                        } else {
                            decomposedMatrix.rotation = 0;
                            decomposedMatrix.scaleX = 0;
                            decomposedMatrix.scaleY = 0;
                        }
                        return decomposedMatrix;
                    },
                    /**
     * Apply the identity, translate, rotate and scale operations on the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#applyITRS
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation.
     * @param {number} y - The vertical translation.
     * @param {number} rotation - The angle of rotation in radians.
     * @param {number} scaleX - The horizontal scale.
     * @param {number} scaleY - The vertical scale.
     *
     * @return {this} This TransformMatrix.
     */ applyITRS: function(x, y, rotation, scaleX, scaleY) {
                        var matrix = this.matrix;
                        var radianSin = Math.sin(rotation);
                        var radianCos = Math.cos(rotation);
                        // Translate
                        matrix[4] = x;
                        matrix[5] = y;
                        // Rotate and Scale
                        matrix[0] = radianCos * scaleX;
                        matrix[1] = radianSin * scaleX;
                        matrix[2] = -radianSin * scaleY;
                        matrix[3] = radianCos * scaleY;
                        return this;
                    },
                    /**
     * Takes the `x` and `y` values and returns a new position in the `output` vector that is the inverse of
     * the current matrix with its transformation applied.
     *
     * Can be used to translate points from world to local space.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#applyInverse
     * @since 3.12.0
     *
     * @param {number} x - The x position to translate.
     * @param {number} y - The y position to translate.
     * @param {Phaser.Math.Vector2} [output] - A Vector2, or point-like object, to store the results in.
     *
     * @return {Phaser.Math.Vector2} The coordinates, inverse-transformed through this matrix.
     */ applyInverse: function(x, y, output) {
                        if (output === undefined) output = new Vector2();
                        var matrix = this.matrix;
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        var tx = matrix[4];
                        var ty = matrix[5];
                        var id = 1 / (a * d + c * -b);
                        output.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
                        output.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
                        return output;
                    },
                    /**
     * Performs the 8 calculations required to create the vertices of
     * a quad based on this matrix and the given x/y/xw/yh values.
     *
     * The result is stored in `TransformMatrix.quad`, which is returned
     * from this method.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#setQuad
     * @since 3.60.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {number} xw - The xw value.
     * @param {number} yh - The yh value.
     * @param {boolean} [roundPixels=false] - Pass the results via Math.round?
     * @param {Float32Array} [quad] - Optional Float32Array to store the results in. Otherwises uses the local quad array.
     *
     * @return {Float32Array} The quad Float32Array.
     */ setQuad: function(x, y, xw, yh, roundPixels, quad) {
                        if (roundPixels === undefined) roundPixels = false;
                        if (quad === undefined) quad = this.quad;
                        var matrix = this.matrix;
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        var e = matrix[4];
                        var f = matrix[5];
                        // Compute the unrounded positions for the quad
                        var x0 = x * a + y * c + e;
                        var y0 = x * b + y * d + f;
                        var x1 = x * a + yh * c + e;
                        var y1 = x * b + yh * d + f;
                        var x2 = xw * a + yh * c + e;
                        var y2 = xw * b + yh * d + f;
                        var x3 = xw * a + y * c + e;
                        var y3 = xw * b + y * d + f;
                        if (roundPixels) {
                            // Round the top-left corner
                            var rx0 = Math.floor(x0 + 0.5);
                            var ry0 = Math.floor(y0 + 0.5);
                            // Calculate the offset caused by rounding
                            var dx = rx0 - x0;
                            var dy = ry0 - y0;
                            // Adjust the other corners by the same offset
                            quad[0] = rx0;
                            quad[1] = ry0;
                            quad[2] = x1 + dx;
                            quad[3] = y1 + dy;
                            quad[4] = x2 + dx;
                            quad[5] = y2 + dy;
                            quad[6] = x3 + dx;
                            quad[7] = y3 + dy;
                        } else {
                            quad[0] = x0;
                            quad[1] = y0;
                            quad[2] = x1;
                            quad[3] = y1;
                            quad[4] = x2;
                            quad[5] = y2;
                            quad[6] = x3;
                            quad[7] = y3;
                        }
                        return quad;
                    },
                    /**
     * Returns the X component of this matrix multiplied by the given values.
     * This is the same as `x * a + y * c + e`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getX
     * @since 3.12.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     *
     * @return {number} The calculated x value.
     */ getX: function(x, y) {
                        return x * this.a + y * this.c + this.e;
                    },
                    /**
     * Returns the Y component of this matrix multiplied by the given values.
     * This is the same as `x * b + y * d + f`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getY
     * @since 3.12.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     *
     * @return {number} The calculated y value.
     */ getY: function(x, y) {
                        return x * this.b + y * this.d + this.f;
                    },
                    /**
     * Returns the X component of this matrix multiplied by the given values.
     *
     * This is the same as `x * a + y * c + e`, optionally passing via `Math.round`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getXRound
     * @since 3.50.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {boolean} [round=false] - Math.round the resulting value?
     *
     * @return {number} The calculated x value.
     */ getXRound: function(x, y, round) {
                        var v = this.getX(x, y);
                        if (round) v = Math.floor(v + 0.5);
                        return v;
                    },
                    /**
     * Returns the Y component of this matrix multiplied by the given values.
     *
     * This is the same as `x * b + y * d + f`, optionally passing via `Math.round`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getYRound
     * @since 3.50.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {boolean} [round=false] - Math.round the resulting value?
     *
     * @return {number} The calculated y value.
     */ getYRound: function(x, y, round) {
                        var v = this.getY(x, y);
                        if (round) v = Math.floor(v + 0.5);
                        return v;
                    },
                    /**
     * Returns a string that can be used in a CSS Transform call as a `matrix` property.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getCSSMatrix
     * @since 3.12.0
     *
     * @return {string} A string containing the CSS Transform matrix values.
     */ getCSSMatrix: function() {
                        var m = this.matrix;
                        return 'matrix(' + m[0] + ',' + m[1] + ',' + m[2] + ',' + m[3] + ',' + m[4] + ',' + m[5] + ')';
                    },
                    /**
     * Destroys this Transform Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#destroy
     * @since 3.4.0
     */ destroy: function() {
                        this.matrix = null;
                        this.quad = null;
                        this.decomposedMatrix = null;
                    }
                });
                module1.exports = TransformMatrix;
            /***/ },
            /***/ 59715: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  bitmask flag for GameObject.renderMask
                var _FLAG = 1; // 0001
                /**
 * Provides methods used for setting the visibility of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Visible
 * @since 3.0.0
 */ var Visible = {
                    /**
     * Private internal value. Holds the visible value.
     *
     * @name Phaser.GameObjects.Components.Visible#_visible
     * @type {boolean}
     * @private
     * @default true
     * @since 3.0.0
     */ _visible: true,
                    /**
     * The visible state of the Game Object.
     *
     * An invisible Game Object will skip rendering, but will still process update logic.
     *
     * @name Phaser.GameObjects.Components.Visible#visible
     * @type {boolean}
     * @since 3.0.0
     */ visible: {
                        get: function() {
                            return this._visible;
                        },
                        set: function(value) {
                            if (value) {
                                this._visible = true;
                                this.renderFlags |= _FLAG;
                            } else {
                                this._visible = false;
                                this.renderFlags &= ~_FLAG;
                            }
                        }
                    },
                    /**
     * Sets the visibility of this Game Object.
     *
     * An invisible Game Object will skip rendering, but will still process update logic.
     *
     * @method Phaser.GameObjects.Components.Visible#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible state of the Game Object.
     *
     * @return {this} This Game Object instance.
     */ setVisible: function(value) {
                        this.visible = value;
                        return this;
                    }
                };
                module1.exports = Visible;
            /***/ },
            /***/ 31401: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Components
 */ module1.exports = {
                    Alpha: __webpack_require__(16005),
                    AlphaSingle: __webpack_require__(88509),
                    BlendMode: __webpack_require__(90065),
                    ComputedSize: __webpack_require__(94215),
                    Crop: __webpack_require__(61683),
                    Depth: __webpack_require__(89272),
                    Flip: __webpack_require__(54434),
                    FX: __webpack_require__(47059),
                    GetBounds: __webpack_require__(8004),
                    Mask: __webpack_require__(8573),
                    Origin: __webpack_require__(27387),
                    PathFollower: __webpack_require__(37640),
                    Pipeline: __webpack_require__(72699),
                    PostPipeline: __webpack_require__(17581),
                    ScrollFactor: __webpack_require__(80227),
                    Size: __webpack_require__(16736),
                    Texture: __webpack_require__(37726),
                    TextureCrop: __webpack_require__(79812),
                    Tint: __webpack_require__(27472),
                    ToJSON: __webpack_require__(53774),
                    Transform: __webpack_require__(16901),
                    TransformMatrix: __webpack_require__(61340),
                    Visible: __webpack_require__(59715)
                };
            /***/ },
            /***/ 31559: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayUtils = __webpack_require__(37105);
                var BlendModes = __webpack_require__(10312);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var Events = __webpack_require__(51708);
                var GameObject = __webpack_require__(95643);
                var Rectangle = __webpack_require__(87841);
                var Render = __webpack_require__(29959);
                var Union = __webpack_require__(36899);
                var Vector2 = __webpack_require__(26099);
                var tempTransformMatrix = new Components.TransformMatrix();
                /**
 * @classdesc
 * A Container Game Object.
 *
 * A Container, as the name implies, can 'contain' other types of Game Object.
 * When a Game Object is added to a Container, the Container becomes responsible for the rendering of it.
 * By default it will be removed from the Display List and instead added to the Containers own internal list.
 *
 * The position of the Game Object automatically becomes relative to the position of the Container.
 *
 * The transform point of a Container is 0x0 (in local space) and that cannot be changed. The children you add to the
 * Container should be positioned with this value in mind. I.e. you should treat 0x0 as being the center of
 * the Container, and position children positively and negative around it as required.
 *
 * When the Container is rendered, all of its children are rendered as well, in the order in which they exist
 * within the Container. Container children can be repositioned using methods such as `MoveUp`, `MoveDown` and `SendToBack`.
 *
 * If you modify a transform property of the Container, such as `Container.x` or `Container.rotation` then it will
 * automatically influence all children as well.
 *
 * Containers can include other Containers for deeply nested transforms.
 *
 * Containers can have masks set on them and can be used as a mask too. However, Container children cannot be masked.
 * The masks do not 'stack up'. Only a Container on the root of the display list will use its mask.
 *
 * Containers can be enabled for input. Because they do not have a texture you need to provide a shape for them
 * to use as their hit area. Container children can also be enabled for input, independent of the Container.
 *
 * If input enabling a _child_ you should not set both the `origin` and a **negative** scale factor on the child,
 * or the input area will become misaligned.
 *
 * Containers can be given a physics body for either Arcade Physics, Impact Physics or Matter Physics. However,
 * if Container _children_ are enabled for physics you may get unexpected results, such as offset bodies,
 * if the Container itself, or any of its ancestors, is positioned anywhere other than at 0 x 0. Container children
 * with physics do not factor in the Container due to the excessive extra calculations needed. Please structure
 * your game to work around this.
 *
 * It's important to understand the impact of using Containers. They add additional processing overhead into
 * every one of their children. The deeper you nest them, the more the cost escalates. This is especially true
 * for input events. You also lose the ability to set the display depth of Container children in the same
 * flexible manner as those not within them. In short, don't use them for the sake of it. You pay a small cost
 * every time you create one, try to structure your game around avoiding that where possible.
 *
 * @class Container
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.4.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
 */ var Container = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.ComputedSize,
                        Components.Depth,
                        Components.Mask,
                        Components.PostPipeline,
                        Components.Transform,
                        Components.Visible,
                        Render
                    ],
                    initialize: function Container(scene, x, y, children) {
                        GameObject.call(this, scene, 'Container');
                        /**
         * An array holding the children of this Container.
         *
         * @name Phaser.GameObjects.Container#list
         * @type {Phaser.GameObjects.GameObject[]}
         * @since 3.4.0
         */ this.list = [];
                        /**
         * Does this Container exclusively manage its children?
         *
         * The default is `true` which means a child added to this Container cannot
         * belong in another Container, which includes the Scene display list.
         *
         * If you disable this then this Container will no longer exclusively manage its children.
         * This allows you to create all kinds of interesting graphical effects, such as replicating
         * Game Objects without reparenting them all over the Scene.
         * However, doing so will prevent children from receiving any kind of input event or have
         * their physics bodies work by default, as they're no longer a single entity on the
         * display list, but are being replicated where-ever this Container is.
         *
         * @name Phaser.GameObjects.Container#exclusive
         * @type {boolean}
         * @default true
         * @since 3.4.0
         */ this.exclusive = true;
                        /**
         * Containers can have an optional maximum size. If set to anything above 0 it
         * will constrict the addition of new Game Objects into the Container, capping off
         * the maximum limit the Container can grow in size to.
         *
         * @name Phaser.GameObjects.Container#maxSize
         * @type {number}
         * @default -1
         * @since 3.4.0
         */ this.maxSize = -1;
                        /**
         * The cursor position.
         *
         * @name Phaser.GameObjects.Container#position
         * @type {number}
         * @since 3.4.0
         */ this.position = 0;
                        /**
         * Internal Transform Matrix used for local space conversion.
         *
         * @name Phaser.GameObjects.Container#localTransform
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.4.0
         */ this.localTransform = new Components.TransformMatrix();
                        /**
         * The property key to sort by.
         *
         * @name Phaser.GameObjects.Container#_sortKey
         * @type {string}
         * @private
         * @since 3.4.0
         */ this._sortKey = '';
                        /**
         * A reference to the Scene Systems Event Emitter.
         *
         * @name Phaser.GameObjects.Container#_sysEvents
         * @type {Phaser.Events.EventEmitter}
         * @private
         * @since 3.9.0
         */ this._sysEvents = scene.sys.events;
                        /**
         * The horizontal scroll factor of this Container.
         *
         * The scroll factor controls the influence of the movement of a Camera upon this Container.
         *
         * When a camera scrolls it will change the location at which this Container is rendered on-screen.
         * It does not change the Containers actual position values.
         *
         * For a Container, setting this value will only update the Container itself, not its children.
         * If you wish to change the scrollFactor of the children as well, use the `setScrollFactor` method.
         *
         * A value of 1 means it will move exactly in sync with a camera.
         * A value of 0 means it will not move at all, even if the camera moves.
         * Other values control the degree to which the camera movement is mapped to this Container.
         *
         * Please be aware that scroll factor values other than 1 are not taken in to consideration when
         * calculating physics collisions. Bodies always collide based on their world position, but changing
         * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
         * them from physics bodies if not accounted for in your code.
         *
         * @name Phaser.GameObjects.Container#scrollFactorX
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.scrollFactorX = 1;
                        /**
         * The vertical scroll factor of this Container.
         *
         * The scroll factor controls the influence of the movement of a Camera upon this Container.
         *
         * When a camera scrolls it will change the location at which this Container is rendered on-screen.
         * It does not change the Containers actual position values.
         *
         * For a Container, setting this value will only update the Container itself, not its children.
         * If you wish to change the scrollFactor of the children as well, use the `setScrollFactor` method.
         *
         * A value of 1 means it will move exactly in sync with a camera.
         * A value of 0 means it will not move at all, even if the camera moves.
         * Other values control the degree to which the camera movement is mapped to this Container.
         *
         * Please be aware that scroll factor values other than 1 are not taken in to consideration when
         * calculating physics collisions. Bodies always collide based on their world position, but changing
         * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
         * them from physics bodies if not accounted for in your code.
         *
         * @name Phaser.GameObjects.Container#scrollFactorY
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.scrollFactorY = 1;
                        this.initPostPipeline();
                        this.setPosition(x, y);
                        this.setBlendMode(BlendModes.SKIP_CHECK);
                        if (children) this.add(children);
                    },
                    /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#originX
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ originX: {
                        get: function() {
                            return 0.5;
                        }
                    },
                    /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#originY
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ originY: {
                        get: function() {
                            return 0.5;
                        }
                    },
                    /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#displayOriginX
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ displayOriginX: {
                        get: function() {
                            return this.width * 0.5;
                        }
                    },
                    /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#displayOriginY
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ displayOriginY: {
                        get: function() {
                            return this.height * 0.5;
                        }
                    },
                    /**
     * Does this Container exclusively manage its children?
     *
     * The default is `true` which means a child added to this Container cannot
     * belong in another Container, which includes the Scene display list.
     *
     * If you disable this then this Container will no longer exclusively manage its children.
     * This allows you to create all kinds of interesting graphical effects, such as replicating
     * Game Objects without reparenting them all over the Scene.
     * However, doing so will prevent children from receiving any kind of input event or have
     * their physics bodies work by default, as they're no longer a single entity on the
     * display list, but are being replicated where-ever this Container is.
     *
     * @method Phaser.GameObjects.Container#setExclusive
     * @since 3.4.0
     *
     * @param {boolean} [value=true] - The exclusive state of this Container.
     *
     * @return {this} This Container.
     */ setExclusive: function(value) {
                        if (value === undefined) value = true;
                        this.exclusive = value;
                        return this;
                    },
                    /**
     * Gets the bounds of this Container. It works by iterating all children of the Container,
     * getting their respective bounds, and then working out a min-max rectangle from that.
     * It does not factor in if the children render or not, all are included.
     *
     * Some children are unable to return their bounds, such as Graphics objects, in which case
     * they are skipped.
     *
     * Depending on the quantity of children in this Container it could be a really expensive call,
     * so cache it and only poll it as needed.
     *
     * The values are stored and returned in a Rectangle object.
     *
     * @method Phaser.GameObjects.Container#getBounds
     * @since 3.4.0
     *
     * @param {Phaser.Geom.Rectangle} [output] - A Geom.Rectangle object to store the values in. If not provided a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} The values stored in the output object.
     */ getBounds: function(output) {
                        if (output === undefined) output = new Rectangle();
                        output.setTo(this.x, this.y, 0, 0);
                        if (this.parentContainer) {
                            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                            var transformedPosition = parentMatrix.transformPoint(this.x, this.y);
                            output.setTo(transformedPosition.x, transformedPosition.y, 0, 0);
                        }
                        if (this.list.length > 0) {
                            var children = this.list;
                            var tempRect = new Rectangle();
                            var hasSetFirst = false;
                            output.setEmpty();
                            for(var i = 0; i < children.length; i++){
                                var entry = children[i];
                                if (entry.getBounds) {
                                    entry.getBounds(tempRect);
                                    if (!hasSetFirst) {
                                        output.setTo(tempRect.x, tempRect.y, tempRect.width, tempRect.height);
                                        hasSetFirst = true;
                                    } else Union(tempRect, output, output);
                                }
                            }
                        }
                        return output;
                    },
                    /**
     * Internal add handler.
     *
     * @method Phaser.GameObjects.Container#addHandler
     * @private
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just added to this Container.
     */ addHandler: function(gameObject) {
                        gameObject.once(Events.DESTROY, this.onChildDestroyed, this);
                        if (this.exclusive) {
                            if (gameObject.parentContainer) gameObject.parentContainer.remove(gameObject);
                            gameObject.parentContainer = this;
                            gameObject.removeFromDisplayList();
                            gameObject.addedToScene();
                        }
                    },
                    /**
     * Internal remove handler.
     *
     * @method Phaser.GameObjects.Container#removeHandler
     * @private
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just removed from this Container.
     */ removeHandler: function(gameObject) {
                        gameObject.off(Events.DESTROY, this.remove, this);
                        if (this.exclusive) {
                            gameObject.parentContainer = null;
                            gameObject.removedFromScene();
                            gameObject.addToDisplayList();
                        }
                    },
                    /**
     * Takes a Point-like object, such as a Vector2, Geom.Point or object with public x and y properties,
     * and transforms it into the space of this Container, then returns it in the output object.
     *
     * @method Phaser.GameObjects.Container#pointToContainer
     * @since 3.4.0
     *
     * @param {Phaser.Types.Math.Vector2Like} source - The Source Point to be transformed.
     * @param {Phaser.Types.Math.Vector2Like} [output] - A destination object to store the transformed point in. If none given a Vector2 will be created and returned.
     *
     * @return {Phaser.Types.Math.Vector2Like} The transformed point.
     */ pointToContainer: function(source, output) {
                        if (output === undefined) output = new Vector2();
                        if (this.parentContainer) this.parentContainer.pointToContainer(source, output);
                        else {
                            output.x = source.x;
                            output.y = source.y;
                        }
                        var tempMatrix = tempTransformMatrix;
                        //  No need to loadIdentity because applyITRS overwrites every value anyway
                        tempMatrix.applyITRS(this.x, this.y, this.rotation, this.scaleX, this.scaleY);
                        tempMatrix.invert();
                        tempMatrix.transformPoint(source.x, source.y, output);
                        return output;
                    },
                    /**
     * Returns the world transform matrix as used for Bounds checks.
     *
     * The returned matrix is temporal and shouldn't be stored.
     *
     * @method Phaser.GameObjects.Container#getBoundsTransformMatrix
     * @since 3.4.0
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The world transform matrix.
     */ getBoundsTransformMatrix: function() {
                        return this.getWorldTransformMatrix(tempTransformMatrix, this.localTransform);
                    },
                    /**
     * Adds the given Game Object, or array of Game Objects, to this Container.
     *
     * Each Game Object must be unique within the Container.
     *
     * @method Phaser.GameObjects.Container#add
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {(T|T[])} - [child]
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
     *
     * @return {this} This Container instance.
     */ add: function(child) {
                        ArrayUtils.Add(this.list, child, this.maxSize, this.addHandler, this);
                        return this;
                    },
                    /**
     * Adds the given Game Object, or array of Game Objects, to this Container at the specified position.
     *
     * Existing Game Objects in the Container are shifted up.
     *
     * Each Game Object must be unique within the Container.
     *
     * @method Phaser.GameObjects.Container#addAt
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {(T|T[])} - [child]
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
     * @param {number} [index=0] - The position to insert the Game Object/s at.
     *
     * @return {this} This Container instance.
     */ addAt: function(child, index) {
                        ArrayUtils.AddAt(this.list, child, index, this.maxSize, this.addHandler, this);
                        return this;
                    },
                    /**
     * Returns the Game Object at the given position in this Container.
     *
     * @method Phaser.GameObjects.Container#getAt
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The position to get the Game Object from.
     *
     * @return {?Phaser.GameObjects.GameObject} The Game Object at the specified index, or `null` if none found.
     */ getAt: function(index) {
                        return this.list[index];
                    },
                    /**
     * Returns the index of the given Game Object in this Container.
     *
     * @method Phaser.GameObjects.Container#getIndex
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child]
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to search for in this Container.
     *
     * @return {number} The index of the Game Object in this Container, or -1 if not found.
     */ getIndex: function(child) {
                        return this.list.indexOf(child);
                    },
                    /**
     * Sort the contents of this Container so the items are in order based on the given property.
     * For example: `sort('alpha')` would sort the elements based on the value of their `alpha` property.
     *
     * @method Phaser.GameObjects.Container#sort
     * @since 3.4.0
     *
     * @param {string} property - The property to lexically sort by.
     * @param {function} [handler] - Provide your own custom handler function. Will receive 2 children which it should compare and return a boolean.
     *
     * @return {this} This Container instance.
     */ sort: function(property, handler) {
                        if (!property) return this;
                        if (handler === undefined) handler = function(childA, childB) {
                            return childA[property] - childB[property];
                        };
                        ArrayUtils.StableSort(this.list, handler);
                        return this;
                    },
                    /**
     * Searches for the first instance of a child with its `name` property matching the given argument.
     * Should more than one child have the same name only the first is returned.
     *
     * @method Phaser.GameObjects.Container#getByName
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [$return]
     *
     * @param {string} name - The name to search for.
     *
     * @return {?Phaser.GameObjects.GameObject} The first child with a matching name, or `null` if none were found.
     */ getByName: function(name) {
                        return ArrayUtils.GetFirst(this.list, 'name', name);
                    },
                    /**
     * Returns a random Game Object from this Container.
     *
     * @method Phaser.GameObjects.Container#getRandom
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [$return]
     *
     * @param {number} [startIndex=0] - An optional start index.
     * @param {number} [length] - An optional length, the total number of elements (from the startIndex) to choose from.
     *
     * @return {?Phaser.GameObjects.GameObject} A random child from the Container, or `null` if the Container is empty.
     */ getRandom: function(startIndex, length) {
                        return ArrayUtils.GetRandom(this.list, startIndex, length);
                    },
                    /**
     * Gets the first Game Object in this Container.
     *
     * You can also specify a property and value to search for, in which case it will return the first
     * Game Object in this Container with a matching property and / or value.
     *
     * For example: `getFirst('visible', true)` would return the first Game Object that had its `visible` property set.
     *
     * You can limit the search to the `startIndex` - `endIndex` range.
     *
     * @method Phaser.GameObjects.Container#getFirst
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [$return]
     *
     * @param {string} property - The property to test on each Game Object in the Container.
     * @param {*} value - The value to test the property against. Must pass a strict (`===`) comparison check.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {?Phaser.GameObjects.GameObject} The first matching Game Object, or `null` if none was found.
     */ getFirst: function(property, value, startIndex, endIndex) {
                        return ArrayUtils.GetFirst(this.list, property, value, startIndex, endIndex);
                    },
                    /**
     * Returns all Game Objects in this Container.
     *
     * You can optionally specify a matching criteria using the `property` and `value` arguments.
     *
     * For example: `getAll('body')` would return only Game Objects that have a body property.
     *
     * You can also specify a value to compare the property to:
     *
     * `getAll('visible', true)` would return only Game Objects that have their visible property set to `true`.
     *
     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 Game Objects.
     *
     * @method Phaser.GameObjects.Container#getAll
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T[]} - [$return]
     *
     * @param {string} [property] - The property to test on each Game Object in the Container.
     * @param {any} [value] - If property is set then the `property` must strictly equal this value to be included in the results.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of matching Game Objects from this Container.
     */ getAll: function(property, value, startIndex, endIndex) {
                        return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
                    },
                    /**
     * Returns the total number of Game Objects in this Container that have a property
     * matching the given value.
     *
     * For example: `count('visible', true)` would count all the elements that have their visible property set.
     *
     * You can optionally limit the operation to the `startIndex` - `endIndex` range.
     *
     * @method Phaser.GameObjects.Container#count
     * @since 3.4.0
     *
     * @param {string} property - The property to check.
     * @param {any} value - The value to check.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {number} The total number of Game Objects in this Container with a property matching the given value.
     */ count: function(property, value, startIndex, endIndex) {
                        return ArrayUtils.CountAllMatching(this.list, property, value, startIndex, endIndex);
                    },
                    /**
     * Swaps the position of two Game Objects in this Container.
     * Both Game Objects must belong to this Container.
     *
     * @method Phaser.GameObjects.Container#swap
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child1,child2]
     *
     * @param {Phaser.GameObjects.GameObject} child1 - The first Game Object to swap.
     * @param {Phaser.GameObjects.GameObject} child2 - The second Game Object to swap.
     *
     * @return {this} This Container instance.
     */ swap: function(child1, child2) {
                        ArrayUtils.Swap(this.list, child1, child2);
                        return this;
                    },
                    /**
     * Moves a Game Object to a new position within this Container.
     *
     * The Game Object must already be a child of this Container.
     *
     * The Game Object is removed from its old position and inserted into the new one.
     * Therefore the Container size does not change. Other children will change position accordingly.
     *
     * @method Phaser.GameObjects.Container#moveTo
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child]
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to move.
     * @param {number} index - The new position of the Game Object in this Container.
     *
     * @return {this} This Container instance.
     */ moveTo: function(child, index) {
                        ArrayUtils.MoveTo(this.list, child, index);
                        return this;
                    },
                    /**
     * Moves a Game Object above another one within this Container.
     * If the Game Object is already above the other, it isn't moved.
     *
     * These 2 Game Objects must already be children of this Container.
     *
     * @method Phaser.GameObjects.Container#moveAbove
     * @since 3.55.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child1,child2]
     *
     * @param {Phaser.GameObjects.GameObject} child1 - The Game Object to move above base Game Object.
     * @param {Phaser.GameObjects.GameObject} child2 - The base Game Object.
     *
     * @return {this} This Container instance.
     */ moveAbove: function(child1, child2) {
                        ArrayUtils.MoveAbove(this.list, child1, child2);
                        return this;
                    },
                    /**
     * Moves a Game Object below another one within this Container.
     * If the Game Object is already below the other, it isn't moved.
     *
     * These 2 Game Objects must already be children of this Container.
     *
     * @method Phaser.GameObjects.Container#moveBelow
     * @since 3.55.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child1,child2]
     *
     * @param {Phaser.GameObjects.GameObject} child1 - The Game Object to move below base Game Object.
     * @param {Phaser.GameObjects.GameObject} child2 - The base Game Object.
     *
     * @return {this} This Container instance.
     */ moveBelow: function(child1, child2) {
                        ArrayUtils.MoveBelow(this.list, child1, child2);
                        return this;
                    },
                    /**
     * Removes the given Game Object, or array of Game Objects, from this Container.
     *
     * The Game Objects must already be children of this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#remove
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {(T|T[])} - [child]
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to be removed from the Container.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each child successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ remove: function(child, destroyChild) {
                        var removed = ArrayUtils.Remove(this.list, child, this.removeHandler, this);
                        if (destroyChild && removed) {
                            if (!Array.isArray(removed)) removed = [
                                removed
                            ];
                            for(var i = 0; i < removed.length; i++)removed[i].destroy();
                        }
                        return this;
                    },
                    /**
     * Removes the Game Object at the given position in this Container.
     *
     * You can also optionally call `destroy` on the Game Object, if one is found.
     *
     * @method Phaser.GameObjects.Container#removeAt
     * @since 3.4.0
     *
     * @param {number} index - The index of the Game Object to be removed.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeAt: function(index, destroyChild) {
                        var removed = ArrayUtils.RemoveAt(this.list, index, this.removeHandler, this);
                        if (destroyChild && removed) removed.destroy();
                        return this;
                    },
                    /**
     * Removes the Game Objects between the given positions in this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#removeBetween
     * @since 3.4.0
     *
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeBetween: function(startIndex, endIndex, destroyChild) {
                        var removed = ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeHandler, this);
                        if (destroyChild) for(var i = 0; i < removed.length; i++)removed[i].destroy();
                        return this;
                    },
                    /**
     * Removes all Game Objects from this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#removeAll
     * @since 3.4.0
     *
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeAll: function(destroyChild) {
                        var list = this.list;
                        if (destroyChild) {
                            for(var i = 0; i < list.length; i++)if (list[i] && list[i].scene) {
                                list[i].off(Events.DESTROY, this.onChildDestroyed, this);
                                list[i].destroy();
                            }
                            this.list = [];
                        } else ArrayUtils.RemoveBetween(list, 0, list.length, this.removeHandler, this);
                        return this;
                    },
                    /**
     * Brings the given Game Object to the top of this Container.
     * This will cause it to render on-top of any other objects in the Container.
     *
     * @method Phaser.GameObjects.Container#bringToTop
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child]
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to bring to the top of the Container.
     *
     * @return {this} This Container instance.
     */ bringToTop: function(child) {
                        ArrayUtils.BringToTop(this.list, child);
                        return this;
                    },
                    /**
     * Sends the given Game Object to the bottom of this Container.
     * This will cause it to render below any other objects in the Container.
     *
     * @method Phaser.GameObjects.Container#sendToBack
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child]
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to send to the bottom of the Container.
     *
     * @return {this} This Container instance.
     */ sendToBack: function(child) {
                        ArrayUtils.SendToBack(this.list, child);
                        return this;
                    },
                    /**
     * Moves the given Game Object up one place in this Container, unless it's already at the top.
     *
     * @method Phaser.GameObjects.Container#moveUp
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child]
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
     *
     * @return {this} This Container instance.
     */ moveUp: function(child) {
                        ArrayUtils.MoveUp(this.list, child);
                        return this;
                    },
                    /**
     * Moves the given Game Object down one place in this Container, unless it's already at the bottom.
     *
     * @method Phaser.GameObjects.Container#moveDown
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child]
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
     *
     * @return {this} This Container instance.
     */ moveDown: function(child) {
                        ArrayUtils.MoveDown(this.list, child);
                        return this;
                    },
                    /**
     * Reverses the order of all Game Objects in this Container.
     *
     * @method Phaser.GameObjects.Container#reverse
     * @since 3.4.0
     *
     * @return {this} This Container instance.
     */ reverse: function() {
                        this.list.reverse();
                        return this;
                    },
                    /**
     * Shuffles the all Game Objects in this Container using the Fisher-Yates implementation.
     *
     * @method Phaser.GameObjects.Container#shuffle
     * @since 3.4.0
     *
     * @return {this} This Container instance.
     */ shuffle: function() {
                        ArrayUtils.Shuffle(this.list);
                        return this;
                    },
                    /**
     * Replaces a Game Object in this Container with the new Game Object.
     * The new Game Object cannot already be a child of this Container.
     *
     * @method Phaser.GameObjects.Container#replace
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [oldChild,newChild]
     *
     * @param {Phaser.GameObjects.GameObject} oldChild - The Game Object in this Container that will be replaced.
     * @param {Phaser.GameObjects.GameObject} newChild - The Game Object to be added to this Container.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ replace: function(oldChild, newChild, destroyChild) {
                        var moved = ArrayUtils.Replace(this.list, oldChild, newChild);
                        if (moved) {
                            this.addHandler(newChild);
                            this.removeHandler(oldChild);
                            if (destroyChild) oldChild.destroy();
                        }
                        return this;
                    },
                    /**
     * Returns `true` if the given Game Object is a direct child of this Container.
     *
     * This check does not scan nested Containers.
     *
     * @method Phaser.GameObjects.Container#exists
     * @since 3.4.0
     *
     * @generic {Phaser.GameObjects.GameObject} T
     * @genericUse {T} - [child]
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to check for within this Container.
     *
     * @return {boolean} True if the Game Object is an immediate child of this Container, otherwise false.
     */ exists: function(child) {
                        return this.list.indexOf(child) > -1;
                    },
                    /**
     * Sets the property to the given value on all Game Objects in this Container.
     *
     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 Game Objects.
     *
     * @method Phaser.GameObjects.Container#setAll
     * @since 3.4.0
     *
     * @param {string} property - The property that must exist on the Game Object.
     * @param {any} value - The value to get the property to.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {this} This Container instance.
     */ setAll: function(property, value, startIndex, endIndex) {
                        ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
                        return this;
                    },
                    /**
     * @callback EachContainerCallback
     * @generic I - [item]
     *
     * @param {*} item - The child Game Object of the Container.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ /**
     * Passes all Game Objects in this Container to the given callback.
     *
     * A copy of the Container is made before passing each entry to your callback.
     * This protects against the callback itself modifying the Container.
     *
     * If you know for sure that the callback will not change the size of this Container
     * then you can use the more performant `Container.iterate` method instead.
     *
     * @method Phaser.GameObjects.Container#each
     * @since 3.4.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {this} This Container instance.
     */ each: function(callback, context) {
                        var args = [
                            null
                        ];
                        var i;
                        var temp = this.list.slice();
                        var len = temp.length;
                        for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
                        for(i = 0; i < len; i++){
                            args[0] = temp[i];
                            callback.apply(context, args);
                        }
                        return this;
                    },
                    /**
     * Passes all Game Objects in this Container to the given callback.
     *
     * Only use this method when you absolutely know that the Container will not be modified during
     * the iteration, i.e. by removing or adding to its contents.
     *
     * @method Phaser.GameObjects.Container#iterate
     * @since 3.4.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {this} This Container instance.
     */ iterate: function(callback, context) {
                        var args = [
                            null
                        ];
                        var i;
                        for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
                        for(i = 0; i < this.list.length; i++){
                            args[0] = this.list[i];
                            callback.apply(context, args);
                        }
                        return this;
                    },
                    /**
     * Sets the scroll factor of this Container and optionally all of its children.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     *
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @method Phaser.GameObjects.Container#setScrollFactor
     * @since 3.4.0
     *
     * @param {number} x - The horizontal scroll factor of this Game Object.
     * @param {number} [y=x] - The vertical scroll factor of this Game Object. If not set it will use the `x` value.
     * @param {boolean} [updateChildren=false] - Apply this scrollFactor to all Container children as well?
     *
     * @return {this} This Game Object instance.
     */ setScrollFactor: function(x, y, updateChildren) {
                        if (y === undefined) y = x;
                        if (updateChildren === undefined) updateChildren = false;
                        this.scrollFactorX = x;
                        this.scrollFactorY = y;
                        if (updateChildren) {
                            ArrayUtils.SetAll(this.list, 'scrollFactorX', x);
                            ArrayUtils.SetAll(this.list, 'scrollFactorY', y);
                        }
                        return this;
                    },
                    /**
     * The number of Game Objects inside this Container.
     *
     * @name Phaser.GameObjects.Container#length
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ length: {
                        get: function() {
                            return this.list.length;
                        }
                    },
                    /**
     * Returns the first Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#first
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ first: {
                        get: function() {
                            this.position = 0;
                            if (this.list.length > 0) return this.list[0];
                            else return null;
                        }
                    },
                    /**
     * Returns the last Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#last
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ last: {
                        get: function() {
                            if (this.list.length > 0) {
                                this.position = this.list.length - 1;
                                return this.list[this.position];
                            } else return null;
                        }
                    },
                    /**
     * Returns the next Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#next
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ next: {
                        get: function() {
                            if (this.position < this.list.length) {
                                this.position++;
                                return this.list[this.position];
                            } else return null;
                        }
                    },
                    /**
     * Returns the previous Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#previous
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ previous: {
                        get: function() {
                            if (this.position > 0) {
                                this.position--;
                                return this.list[this.position];
                            } else return null;
                        }
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Container#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                        this.removeAll(!!this.exclusive);
                        this.localTransform.destroy();
                        this.list = [];
                    },
                    /**
     * Internal handler, called when a child is destroyed.
     *
     * @method Phaser.GameObjects.Container#onChildDestroyed
     * @protected
     * @since 3.80.0
     */ onChildDestroyed: function(gameObject) {
                        ArrayUtils.Remove(this.list, gameObject);
                        if (this.exclusive) {
                            gameObject.parentContainer = null;
                            gameObject.removedFromScene();
                        }
                    }
                });
                module1.exports = Container;
            /***/ },
            /***/ 53584: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Container#renderCanvas
 * @since 3.4.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ContainerCanvasRenderer = function(renderer, container, camera, parentMatrix) {
                    camera.addToRenderList(container);
                    var children = container.list;
                    if (children.length === 0) return;
                    var transformMatrix = container.localTransform;
                    if (parentMatrix) {
                        transformMatrix.loadIdentity();
                        transformMatrix.multiply(parentMatrix);
                        transformMatrix.translate(container.x, container.y);
                        transformMatrix.rotate(container.rotation);
                        transformMatrix.scale(container.scaleX, container.scaleY);
                    } else transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
                    var containerHasBlendMode = container.blendMode !== -1;
                    if (!containerHasBlendMode) //  If Container is SKIP_TEST then set blend mode to be Normal
                    renderer.setBlendMode(0);
                    var alpha = container._alpha;
                    var scrollFactorX = container.scrollFactorX;
                    var scrollFactorY = container.scrollFactorY;
                    if (container.mask) container.mask.preRenderCanvas(renderer, null, camera);
                    for(var i = 0; i < children.length; i++){
                        var child = children[i];
                        if (!child.willRender(camera)) continue;
                        var childAlpha = child.alpha;
                        var childScrollFactorX = child.scrollFactorX;
                        var childScrollFactorY = child.scrollFactorY;
                        if (!containerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Container doesn't have its own blend mode, then a child can have one
                        renderer.setBlendMode(child.blendMode);
                        //  Set parent values
                        child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
                        child.setAlpha(childAlpha * alpha);
                        //  Render
                        child.renderCanvas(renderer, child, camera, transformMatrix);
                        //  Restore original values
                        child.setAlpha(childAlpha);
                        child.setScrollFactor(childScrollFactorX, childScrollFactorY);
                    }
                    if (container.mask) container.mask.postRenderCanvas(renderer);
                };
                module1.exports = ContainerCanvasRenderer;
            /***/ },
            /***/ 77143: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var Container = __webpack_require__(31559);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetFastValue = __webpack_require__(95540);
                /**
 * Creates a new Container Game Object and returns it.
 *
 * Note: This method will only be available if the Container Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#container
 * @since 3.4.0
 *
 * @param {Phaser.Types.GameObjects.Container.ContainerConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Container} The Game Object that was created.
 */ GameObjectCreator.register('container', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var x = GetAdvancedValue(config, 'x', 0);
                    var y = GetAdvancedValue(config, 'y', 0);
                    var children = GetFastValue(config, 'children', null);
                    var container = new Container(this.scene, x, y, children);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, container, config);
                    return container;
                });
            /***/ },
            /***/ 24961: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Container = __webpack_require__(31559);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Container Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Container Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#container
 * @since 3.4.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
 *
 * @return {Phaser.GameObjects.Container} The Game Object that was created.
 */ GameObjectFactory.register('container', function(x, y, children) {
                    return this.displayList.add(new Container(this.scene, x, y, children));
                });
            /***/ },
            /***/ 29959: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(72249);
                renderCanvas = __webpack_require__(53584);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 72249: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Container#renderWebGL
 * @since 3.4.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ContainerWebGLRenderer = function(renderer, container, camera, parentMatrix) {
                    camera.addToRenderList(container);
                    var children = container.list;
                    var childCount = children.length;
                    if (childCount === 0) return;
                    var transformMatrix = container.localTransform;
                    if (parentMatrix) {
                        transformMatrix.loadIdentity();
                        transformMatrix.multiply(parentMatrix);
                        transformMatrix.translate(container.x, container.y);
                        transformMatrix.rotate(container.rotation);
                        transformMatrix.scale(container.scaleX, container.scaleY);
                    } else transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
                    renderer.pipelines.preBatch(container);
                    var containerHasBlendMode = container.blendMode !== -1;
                    if (!containerHasBlendMode) //  If Container is SKIP_TEST then set blend mode to be Normal
                    renderer.setBlendMode(0);
                    var alpha = container.alpha;
                    var scrollFactorX = container.scrollFactorX;
                    var scrollFactorY = container.scrollFactorY;
                    for(var i = 0; i < childCount; i++){
                        var child = children[i];
                        if (!child.willRender(camera)) continue;
                        var childAlphaTopLeft;
                        var childAlphaTopRight;
                        var childAlphaBottomLeft;
                        var childAlphaBottomRight;
                        if (child.alphaTopLeft !== undefined) {
                            childAlphaTopLeft = child.alphaTopLeft;
                            childAlphaTopRight = child.alphaTopRight;
                            childAlphaBottomLeft = child.alphaBottomLeft;
                            childAlphaBottomRight = child.alphaBottomRight;
                        } else {
                            var childAlpha = child.alpha;
                            childAlphaTopLeft = childAlpha;
                            childAlphaTopRight = childAlpha;
                            childAlphaBottomLeft = childAlpha;
                            childAlphaBottomRight = childAlpha;
                        }
                        var childScrollFactorX = child.scrollFactorX;
                        var childScrollFactorY = child.scrollFactorY;
                        if (!containerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Container doesn't have its own blend mode, then a child can have one
                        renderer.setBlendMode(child.blendMode);
                        var mask = child.mask;
                        if (mask) mask.preRenderWebGL(renderer, child, camera);
                        var type = child.type;
                        if (type !== renderer.currentType) {
                            renderer.newType = true;
                            renderer.currentType = type;
                        }
                        renderer.nextTypeMatch = i < childCount - 1 ? children[i + 1].type === renderer.currentType : false;
                        //  Set parent values
                        child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
                        child.setAlpha(childAlphaTopLeft * alpha, childAlphaTopRight * alpha, childAlphaBottomLeft * alpha, childAlphaBottomRight * alpha);
                        //  Render
                        child.renderWebGL(renderer, child, camera, transformMatrix, container);
                        //  Restore original values
                        child.setAlpha(childAlphaTopLeft, childAlphaTopRight, childAlphaBottomLeft, childAlphaBottomRight);
                        child.setScrollFactor(childScrollFactorX, childScrollFactorY);
                        if (mask) mask.postRenderWebGL(renderer, camera);
                        renderer.newType = false;
                    }
                    renderer.pipelines.postBatch(container);
                };
                module1.exports = ContainerWebGLRenderer;
            /***/ },
            /***/ 47407: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Blend Modes to CSS Blend Modes Map.
 *
 * @name Phaser.CSSBlendModes
 * @ignore
 * @enum {string}
 * @memberof Phaser
 * @readonly
 * @since 3.12.0
 */ module1.exports = [
                    'normal',
                    'multiply',
                    'multiply',
                    'screen',
                    'overlay',
                    'darken',
                    'lighten',
                    'color-dodge',
                    'color-burn',
                    'hard-light',
                    'soft-light',
                    'difference',
                    'exclusion',
                    'hue',
                    'saturation',
                    'color',
                    'luminosity'
                ];
            /***/ },
            /***/ 3069: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var DOMElementRender = __webpack_require__(441);
                var GameObject = __webpack_require__(95643);
                var IsPlainObject = __webpack_require__(41212);
                var RemoveFromDOM = __webpack_require__(35846);
                var SCENE_EVENTS = __webpack_require__(44594);
                var Vector4 = __webpack_require__(61369);
                /**
 * @classdesc
 * DOM Element Game Objects are a way to control and manipulate HTML Elements over the top of your game.
 *
 * In order for DOM Elements to display you have to enable them by adding the following to your game
 * configuration object:
 *
 * ```javascript
 * dom {
 *   createContainer: true
 * }
 * ```
 *
 * You must also have a parent container for Phaser. This is specified by the `parent` property in the
 * game config.
 *
 * When these two things are added, Phaser will automatically create a DOM Container div that is positioned
 * over the top of the game canvas. This div is sized to match the canvas, and if the canvas size changes,
 * as a result of settings within the Scale Manager, the dom container is resized accordingly.
 *
 * If you have not already done so, you have to provide a `parent` in the Game Configuration, or the DOM
 * Container will fail to be created.
 *
 * You can create a DOM Element by either passing in DOMStrings, or by passing in a reference to an existing
 * Element that you wish to be placed under the control of Phaser. For example:
 *
 * ```javascript
 * this.add.dom(x, y, 'div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
 * ```
 *
 * The above code will insert a div element into the DOM Container at the given x/y coordinate. The DOMString in
 * the 4th argument sets the initial CSS style of the div and the final argument is the inner text. In this case,
 * it will create a lime colored div that is 220px by 100px in size with the text Phaser in it, in an Arial font.
 *
 * You should nearly always, without exception, use explicitly sized HTML Elements, in order to fully control
 * alignment and positioning of the elements next to regular game content.
 *
 * Rather than specify the CSS and HTML directly you can use the `load.html` File Loader to load it into the
 * cache and then use the `createFromCache` method instead. You can also use `createFromHTML` and various other
 * methods available in this class to help construct your elements.
 *
 * Once the element has been created you can then control it like you would any other Game Object. You can set its
 * position, scale, rotation, alpha and other properties. It will move as the main Scene Camera moves and be clipped
 * at the edge of the canvas. It's important to remember some limitations of DOM Elements: The obvious one is that
 * they appear above or below your game canvas. You cannot blend them into the display list, meaning you cannot have
 * a DOM Element, then a Sprite, then another DOM Element behind it.
 *
 * They also cannot be enabled for input. To do that, you have to use the `addListener` method to add native event
 * listeners directly. The final limitation is to do with cameras. The DOM Container is sized to match the game canvas
 * entirely and clipped accordingly. DOM Elements respect camera scrolling and scrollFactor settings, but if you
 * change the size of the camera so it no longer matches the size of the canvas, they won't be clipped accordingly.
 *
 * DOM Game Objects can be added to a Phaser Container, however you should only nest them **one level deep**.
 * Any further down the chain and they will ignore all root container properties.
 *
 * Also, all DOM Elements are inserted into the same DOM Container, regardless of which Scene they are created in.
 *
 * Note that you should only have DOM Elements in a Scene with a _single_ Camera. If you require multiple cameras,
 * use parallel scenes to achieve this.
 *
 * DOM Elements are a powerful way to align native HTML with your Phaser Game Objects. For example, you can insert
 * a login form for a multiplayer game directly into your title screen. Or a text input box for a highscore table.
 * Or a banner ad from a 3rd party service. Or perhaps you'd like to use them for high resolution text display and
 * UI. The choice is up to you, just remember that you're dealing with standard HTML and CSS floating over the top
 * of your game, and should treat it accordingly.
 *
 * @class DOMElement
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.17.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this DOM Element in the world.
 * @param {number} [y=0] - The vertical position of this DOM Element in the world.
 * @param {(Element|string)} [element] - An existing DOM element, or a string. If a string starting with a # it will do a `getElementById` look-up on the string (minus the hash). Without a hash, it represents the type of element to create, i.e. 'div'.
 * @param {(string|any)} [style] - If a string, will be set directly as the elements `style` property value. If a plain object, will be iterated and the values transferred. In both cases the values replacing whatever CSS styles may have been previously set.
 * @param {string} [innerText] - If given, will be set directly as the elements `innerText` property value, replacing whatever was there before.
 */ var DOMElement = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Origin,
                        Components.ScrollFactor,
                        Components.Transform,
                        Components.Visible,
                        DOMElementRender
                    ],
                    initialize: function DOMElement(scene, x, y, element, style, innerText) {
                        GameObject.call(this, scene, 'DOMElement');
                        /**
         * A reference to the parent DOM Container that the Game instance created when it started.
         *
         * @name Phaser.GameObjects.DOMElement#parent
         * @type {Element}
         * @since 3.17.0
         */ this.parent = scene.sys.game.domContainer;
                        /**
         * A reference to the HTML Cache.
         *
         * @name Phaser.GameObjects.DOMElement#cache
         * @type {Phaser.Cache.BaseCache}
         * @since 3.17.0
         */ this.cache = scene.sys.cache.html;
                        /**
         * The actual DOM Element that this Game Object is bound to. For example, if you've created a `<div>`
         * then this property is a direct reference to that element within the dom.
         *
         * @name Phaser.GameObjects.DOMElement#node
         * @type {Element}
         * @since 3.17.0
         */ this.node;
                        /**
         * By default a DOM Element will have its transform, display, opacity, zIndex and blend mode properties
         * updated when its rendered. If, for some reason, you don't want any of these changed other than the
         * CSS transform, then set this flag to `true`. When `true` only the CSS Transform is applied and it's
         * up to you to keep track of and set the other properties as required.
         *
         * This can be handy if, for example, you've a nested DOM Element and you don't want the opacity to be
         * picked-up by any of its children.
         *
         * @name Phaser.GameObjects.DOMElement#transformOnly
         * @type {boolean}
         * @since 3.17.0
         */ this.transformOnly = false;
                        /**
         * The angle, in radians, by which to skew the DOM Element on the horizontal axis.
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform
         *
         * @name Phaser.GameObjects.DOMElement#skewX
         * @type {number}
         * @since 3.17.0
         */ this.skewX = 0;
                        /**
         * The angle, in radians, by which to skew the DOM Element on the vertical axis.
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform
         *
         * @name Phaser.GameObjects.DOMElement#skewY
         * @type {number}
         * @since 3.17.0
         */ this.skewY = 0;
                        /**
         * A Vector4 that contains the 3D rotation of this DOM Element around a fixed axis in 3D space.
         *
         * All values in the Vector4 are treated as degrees, unless the `rotate3dAngle` property is changed.
         *
         * For more details see the following MDN page:
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate3d
         *
         * @name Phaser.GameObjects.DOMElement#rotate3d
         * @type {Phaser.Math.Vector4}
         * @since 3.17.0
         */ this.rotate3d = new Vector4();
                        /**
         * The unit that represents the 3D rotation values. By default this is `deg` for degrees, but can
         * be changed to any supported unit. See this page for further details:
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate3d
         *
         * @name Phaser.GameObjects.DOMElement#rotate3dAngle
         * @type {string}
         * @since 3.17.0
         */ this.rotate3dAngle = 'deg';
                        /**
         * Sets the CSS `pointerEvents` attribute on the DOM Element during rendering.
         *
         * This is 'auto' by default. Changing it may have unintended side-effects with
         * internal Phaser input handling, such as dragging, so only change this if you
         * understand the implications.
         *
         * @name Phaser.GameObjects.DOMElement#pointerEvents
         * @type {string}
         * @since 3.55.0
         */ this.pointerEvents = 'auto';
                        /**
         * The native (un-scaled) width of this Game Object.
         *
         * For a DOM Element this property is read-only.
         *
         * The property `displayWidth` holds the computed bounds of this DOM Element, factoring in scaling.
         *
         * @name Phaser.GameObjects.DOMElement#width
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.width = 0;
                        /**
         * The native (un-scaled) height of this Game Object.
         *
         * For a DOM Element this property is read-only.
         *
         * The property `displayHeight` holds the computed bounds of this DOM Element, factoring in scaling.
         *
         * @name Phaser.GameObjects.DOMElement#height
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.height = 0;
                        /**
         * The computed display width of this Game Object, based on the `getBoundingClientRect` DOM call.
         *
         * The property `width` holds the un-scaled width of this DOM Element.
         *
         * @name Phaser.GameObjects.DOMElement#displayWidth
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.displayWidth = 0;
                        /**
         * The computed display height of this Game Object, based on the `getBoundingClientRect` DOM call.
         *
         * The property `height` holds the un-scaled height of this DOM Element.
         *
         * @name Phaser.GameObjects.DOMElement#displayHeight
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.displayHeight = 0;
                        /**
         * Internal native event handler.
         *
         * @name Phaser.GameObjects.DOMElement#handler
         * @type {number}
         * @private
         * @since 3.17.0
         */ this.handler = this.dispatchNativeEvent.bind(this);
                        this.setPosition(x, y);
                        if (typeof element === 'string') {
                            //  hash?
                            if (element[0] === '#') this.setElement(element.substr(1), style, innerText);
                            else this.createElement(element, style, innerText);
                        } else if (element) this.setElement(element, style, innerText);
                        scene.sys.events.on(SCENE_EVENTS.SLEEP, this.handleSceneEvent, this);
                        scene.sys.events.on(SCENE_EVENTS.WAKE, this.handleSceneEvent, this);
                        scene.sys.events.on(SCENE_EVENTS.PRE_RENDER, this.preRender, this);
                    },
                    /**
     * Handles a Scene Sleep and Wake event.
     *
     * @method Phaser.GameObjects.DOMElement#handleSceneEvent
     * @private
     * @since 3.22.0
     *
     * @param {Phaser.Scenes.Systems} sys - The Scene Systems.
     */ handleSceneEvent: function(sys) {
                        var node = this.node;
                        var style = node.style;
                        if (node) style.display = sys.settings.visible ? 'block' : 'none';
                    },
                    /**
     * Sets the horizontal and vertical skew values of this DOM Element.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/transform
     *
     * @method Phaser.GameObjects.DOMElement#setSkew
     * @since 3.17.0
     *
     * @param {number} [x=0] - The angle, in radians, by which to skew the DOM Element on the horizontal axis.
     * @param {number} [y=x] - The angle, in radians, by which to skew the DOM Element on the vertical axis.
     *
     * @return {this} This DOM Element instance.
     */ setSkew: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = x;
                        this.skewX = x;
                        this.skewY = y;
                        return this;
                    },
                    /**
     * Sets the perspective CSS property of the _parent DOM Container_. This determines the distance between the z=0
     * plane and the user in order to give a 3D-positioned element some perspective. Each 3D element with
     * z > 0 becomes larger; each 3D-element with z < 0 becomes smaller. The strength of the effect is determined
     * by the value of this property.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/perspective
     *
     * **Changing this value changes it globally for all DOM Elements, as they all share the same parent container.**
     *
     * @method Phaser.GameObjects.DOMElement#setPerspective
     * @since 3.17.0
     *
     * @param {number} value - The perspective value, in pixels, that determines the distance between the z plane and the user.
     *
     * @return {this} This DOM Element instance.
     */ setPerspective: function(value) {
                        this.parent.style.perspective = value + 'px';
                        return this;
                    },
                    /**
     * The perspective CSS property value of the _parent DOM Container_. This determines the distance between the z=0
     * plane and the user in order to give a 3D-positioned element some perspective. Each 3D element with
     * z > 0 becomes larger; each 3D-element with z < 0 becomes smaller. The strength of the effect is determined
     * by the value of this property.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/perspective
     *
     * **Changing this value changes it globally for all DOM Elements, as they all share the same parent container.**
     *
     * @name Phaser.GameObjects.DOMElement#perspective
     * @type {number}
     * @since 3.17.0
     */ perspective: {
                        get: function() {
                            return parseFloat(this.parent.style.perspective);
                        },
                        set: function(value) {
                            this.parent.style.perspective = value + 'px';
                        }
                    },
                    /**
     * Adds one or more native DOM event listeners onto the underlying Element of this Game Object.
     * The event is then dispatched via this Game Objects standard event emitter.
     *
     * For example:
     *
     * ```javascript
     * var div = this.add.dom(x, y, element);
     *
     * div.addListener('click');
     *
     * div.on('click', handler);
     * ```
     *
     * @method Phaser.GameObjects.DOMElement#addListener
     * @since 3.17.0
     *
     * @param {string} events - The DOM event/s to listen for. You can specify multiple events by separating them with spaces.
     *
     * @return {this} This DOM Element instance.
     */ addListener: function(events) {
                        if (this.node) {
                            events = events.split(' ');
                            for(var i = 0; i < events.length; i++)this.node.addEventListener(events[i], this.handler, false);
                        }
                        return this;
                    },
                    /**
     * Removes one or more native DOM event listeners from the underlying Element of this Game Object.
     *
     * @method Phaser.GameObjects.DOMElement#removeListener
     * @since 3.17.0
     *
     * @param {string} events - The DOM event/s to stop listening for. You can specify multiple events by separating them with spaces.
     *
     * @return {this} This DOM Element instance.
     */ removeListener: function(events) {
                        if (this.node) {
                            events = events.split(' ');
                            for(var i = 0; i < events.length; i++)this.node.removeEventListener(events[i], this.handler);
                        }
                        return this;
                    },
                    /**
     * Internal event proxy to dispatch native DOM Events via this Game Object.
     *
     * @method Phaser.GameObjects.DOMElement#dispatchNativeEvent
     * @private
     * @since 3.17.0
     *
     * @param {any} event - The native DOM event.
     */ dispatchNativeEvent: function(event) {
                        this.emit(event.type, event);
                    },
                    /**
     * Creates a native DOM Element, adds it to the parent DOM Container and then binds it to this Game Object,
     * so you can control it. The `tagName` should be a string and is passed to `document.createElement`:
     *
     * ```javascript
     * this.add.dom().createElement('div');
     * ```
     *
     * For more details on acceptable tag names see: https://developer.mozilla.org/en-US/docs/Web/API/Document/createElement
     *
     * You can also pass in a DOMString or style object to set the CSS on the created element, and an optional `innerText`
     * value as well. Here is an example of a DOMString:
     *
     * ```javascript
     * this.add.dom().createElement('div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
     * ```
     *
     * And using a style object:
     *
     * ```javascript
     * var style = {
     *   'background-color': 'lime';
     *   'width': '200px';
     *   'height': '100px';
     *   'font': '48px Arial';
     * };
     *
     * this.add.dom().createElement('div', style, 'Phaser');
     * ```
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createElement
     * @since 3.17.0
     *
     * @param {string} tagName - A string that specifies the type of element to be created. The nodeName of the created element is initialized with the value of tagName. Don't use qualified names (like "html:a") with this method.
     * @param {(string|any)} [style] - Either a DOMString that holds the CSS styles to be applied to the created element, or an object the styles will be ready from.
     * @param {string} [innerText] - A DOMString that holds the text that will be set as the innerText of the created element.
     *
     * @return {this} This DOM Element instance.
     */ createElement: function(tagName, style, innerText) {
                        return this.setElement(document.createElement(tagName), style, innerText);
                    },
                    /**
     * Binds a new DOM Element to this Game Object. If this Game Object already has an Element it is removed from the DOM
     * entirely first. Any event listeners you may have previously created will need to be re-created on the new element.
     *
     * The `element` argument you pass to this method can be either a string tagName:
     *
     * ```javascript
     * <h1 id="heading">Phaser</h1>
     *
     * this.add.dom().setElement('heading');
     * ```
     *
     * Or a reference to an Element instance:
     *
     * ```javascript
     * <h1 id="heading">Phaser</h1>
     *
     * var h1 = document.getElementById('heading');
     *
     * this.add.dom().setElement(h1);
     * ```
     *
     * You can also pass in a DOMString or style object to set the CSS on the created element, and an optional `innerText`
     * value as well. Here is an example of a DOMString:
     *
     * ```javascript
     * this.add.dom().setElement(h1, 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
     * ```
     *
     * And using a style object:
     *
     * ```javascript
     * var style = {
     *   'background-color': 'lime';
     *   'width': '200px';
     *   'height': '100px';
     *   'font': '48px Arial';
     * };
     *
     * this.add.dom().setElement(h1, style, 'Phaser');
     * ```
     *
     * @method Phaser.GameObjects.DOMElement#setElement
     * @since 3.17.0
     *
     * @param {(string|Element)} element - If a string it is passed to `getElementById()`, or it should be a reference to an existing Element.
     * @param {(string|any)} [style] - Either a DOMString that holds the CSS styles to be applied to the created element, or an object the styles will be ready from.
     * @param {string} [innerText] - A DOMString that holds the text that will be set as the innerText of the created element.
     *
     * @return {this} This DOM Element instance.
     */ setElement: function(element, style, innerText) {
                        //  Already got an element? Remove it first
                        this.removeElement();
                        var target;
                        if (typeof element === 'string') {
                            //  hash?
                            if (element[0] === '#') element = element.substr(1);
                            target = document.getElementById(element);
                        } else if (typeof element === 'object' && element.nodeType === 1) target = element;
                        if (!target) return this;
                        this.node = target;
                        //  style can be empty, a string or a plain object
                        if (style && IsPlainObject(style)) for(var key in style)target.style[key] = style[key];
                        else if (typeof style === 'string') target.style = style;
                        //  Add / Override the values we need
                        target.style.zIndex = '0';
                        target.style.display = 'inline';
                        target.style.position = 'absolute';
                        //  Node handler
                        target.phaser = this;
                        if (this.parent) this.parent.appendChild(target);
                        //  InnerText
                        if (innerText) target.innerText = innerText;
                        return this.updateSize();
                    },
                    /**
     * Takes a block of html from the HTML Cache, that has previously been preloaded into the game, and then
     * creates a DOM Element from it. The loaded HTML is set as the `innerHTML` property of the created
     * element.
     *
     * Assume the following html is stored in a file called `loginform.html`:
     *
     * ```html
     * <input type="text" name="nameField" placeholder="Enter your name" style="font-size: 32px">
     * <input type="button" name="playButton" value="Let's Play" style="font-size: 32px">
     * ```
     *
     * Which is loaded into your game using the cache key 'login':
     *
     * ```javascript
     * this.load.html('login', 'assets/loginform.html');
     * ```
     *
     * You can create a DOM Element from it using the cache key:
     *
     * ```javascript
     * this.add.dom().createFromCache('login');
     * ```
     *
     * The optional `elementType` argument controls the container that is created, into which the loaded html is inserted.
     * The default is a plain `div` object, but any valid tagName can be given.
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createFromCache
     * @since 3.17.0
     *
     * @param {string} The key of the html cache entry to use for this DOM Element.
     * @param {string} [tagName='div'] - The tag name of the element into which all of the loaded html will be inserted. Defaults to a plain div tag.
     *
     * @return {this} This DOM Element instance.
     */ createFromCache: function(key, tagName) {
                        var html = this.cache.get(key);
                        if (html) this.createFromHTML(html, tagName);
                        return this;
                    },
                    /**
     * Takes a string of html and then creates a DOM Element from it. The HTML is set as the `innerHTML`
     * property of the created element.
     *
     * ```javascript
     * let form = `
     * <input type="text" name="nameField" placeholder="Enter your name" style="font-size: 32px">
     * <input type="button" name="playButton" value="Let's Play" style="font-size: 32px">
     * `;
     * ```
     *
     * You can create a DOM Element from it using the string:
     *
     * ```javascript
     * this.add.dom().createFromHTML(form);
     * ```
     *
     * The optional `elementType` argument controls the type of container that is created, into which the html is inserted.
     * The default is a plain `div` object, but any valid tagName can be given.
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createFromHTML
     * @since 3.17.0
     *
     * @param {string} html - A string of html to be set as the `innerHTML` property of the created element.
     * @param {string} [tagName='div'] - The tag name of the element into which all of the html will be inserted. Defaults to a plain div tag.
     *
     * @return {this} This DOM Element instance.
     */ createFromHTML: function(html, tagName) {
                        if (tagName === undefined) tagName = 'div';
                        //  Already got an element? Remove it first
                        this.removeElement();
                        var element = document.createElement(tagName);
                        this.node = element;
                        element.style.zIndex = '0';
                        element.style.display = 'inline';
                        element.style.position = 'absolute';
                        //  Node handler
                        element.phaser = this;
                        if (this.parent) this.parent.appendChild(element);
                        element.innerHTML = html;
                        return this.updateSize();
                    },
                    /**
     * Removes the current DOM Element bound to this Game Object from the DOM entirely and resets the
     * `node` property of this Game Object to be `null`.
     *
     * @method Phaser.GameObjects.DOMElement#removeElement
     * @since 3.17.0
     *
     * @return {this} This DOM Element instance.
     */ removeElement: function() {
                        if (this.node) {
                            RemoveFromDOM(this.node);
                            this.node = null;
                        }
                        return this;
                    },
                    /**
     * Internal method that sets the `displayWidth` and `displayHeight` properties, and the `clientWidth` 
     * and `clientHeight` values into the `width` and `height` properties respectively.
     *
     * This is called automatically whenever a new element is created or set.
     *
     * @method Phaser.GameObjects.DOMElement#updateSize
     * @since 3.17.0
     *
     * @return {this} This DOM Element instance.
     */ updateSize: function() {
                        var node = this.node;
                        this.width = node.clientWidth;
                        this.height = node.clientHeight;
                        this.displayWidth = this.width * this.scaleX;
                        this.displayHeight = this.height * this.scaleY;
                        return this;
                    },
                    /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a property matching the given key and value. It then returns this child
     * if found, or `null` if not.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByProperty
     * @since 3.17.0
     *
     * @param {string} property - The property to search the children for.
     * @param {string} value - The value the property must strictly equal.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByProperty: function(property, value) {
                        if (this.node) {
                            var children = this.node.querySelectorAll('*');
                            for(var i = 0; i < children.length; i++){
                                if (children[i][property] === value) return children[i];
                            }
                        }
                        return null;
                    },
                    /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a matching id. It then returns this child if found, or `null` if not.
     *
     * Be aware that class and id names are case-sensitive.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByID
     * @since 3.17.0
     *
     * @param {string} id - The id to search the children for.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByID: function(id) {
                        return this.getChildByProperty('id', id);
                    },
                    /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a matching name. It then returns this child if found, or `null` if not.
     *
     * Be aware that class and id names are case-sensitive.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByName
     * @since 3.17.0
     *
     * @param {string} name - The name to search the children for.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByName: function(name) {
                        return this.getChildByProperty('name', name);
                    },
                    /**
     * Sets the `className` property of the DOM Element node and updates the internal sizes.
     *
     * @method Phaser.GameObjects.DOMElement#setClassName
     * @since 3.17.0
     *
     * @param {string} className - A string representing the class or space-separated classes of the element.
     *
     * @return {this} This DOM Element instance.
     */ setClassName: function(className) {
                        if (this.node) {
                            this.node.className = className;
                            this.updateSize();
                        }
                        return this;
                    },
                    /**
     * Sets the `innerText` property of the DOM Element node and updates the internal sizes.
     *
     * Note that only certain types of Elements can have `innerText` set on them.
     *
     * @method Phaser.GameObjects.DOMElement#setText
     * @since 3.17.0
     *
     * @param {string} text - A DOMString representing the rendered text content of the element.
     *
     * @return {this} This DOM Element instance.
     */ setText: function(text) {
                        if (this.node) {
                            this.node.innerText = text;
                            this.updateSize();
                        }
                        return this;
                    },
                    /**
     * Sets the `innerHTML` property of the DOM Element node and updates the internal sizes.
     *
     * @method Phaser.GameObjects.DOMElement#setHTML
     * @since 3.17.0
     *
     * @param {string} html - A DOMString of html to be set as the `innerHTML` property of the element.
     *
     * @return {this} This DOM Element instance.
     */ setHTML: function(html) {
                        if (this.node) {
                            this.node.innerHTML = html;
                            this.updateSize();
                        }
                        return this;
                    },
                    /**
     * Runs internal update tasks.
     *
     * @method Phaser.GameObjects.DOMElement#preRender
     * @private
     * @since 3.60.0
     */ preRender: function() {
                        var parent = this.parentContainer;
                        var node = this.node;
                        if (node && parent && !parent.willRender()) node.style.display = 'none';
                    },
                    /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     *
     * DOMElements always return `true` as they need to still set values during the render pass, even if not visible.
     *
     * @method Phaser.GameObjects.DOMElement#willRender
     * @since 3.17.0
     *
     * @return {boolean} `true` if the Game Object should be rendered, otherwise `false`.
     */ willRender: function() {
                        return true;
                    },
                    /**
     * Handles the pre-destroy step for the DOM Element, which removes the underlying node from the DOM.
     *
     * @method Phaser.GameObjects.DOMElement#preDestroy
     * @private
     * @since 3.17.0
     */ preDestroy: function() {
                        this.removeElement();
                        this.scene.sys.events.off(SCENE_EVENTS.SLEEP, this.handleSceneEvent, this);
                        this.scene.sys.events.off(SCENE_EVENTS.WAKE, this.handleSceneEvent, this);
                        this.scene.sys.events.off(SCENE_EVENTS.PRE_RENDER, this.preRender, this);
                    }
                });
                module1.exports = DOMElement;
            /***/ },
            /***/ 49381: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CSSBlendModes = __webpack_require__(47407);
                var GameObject = __webpack_require__(95643);
                var TransformMatrix = __webpack_require__(61340);
                var tempMatrix1 = new TransformMatrix();
                var tempMatrix2 = new TransformMatrix();
                var tempMatrix3 = new TransformMatrix();
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DOMElement#renderWebGL
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active renderer.
 * @param {Phaser.GameObjects.DOMElement} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DOMElementCSSRenderer = function(renderer, src, camera, parentMatrix) {
                    if (!src.node) return;
                    var style = src.node.style;
                    var settings = src.scene.sys.settings;
                    if (!style || !settings.visible || GameObject.RENDER_MASK !== src.renderFlags || src.cameraFilter !== 0 && src.cameraFilter & camera.id || src.parentContainer && !src.parentContainer.willRender()) {
                        style.display = 'none';
                        return;
                    }
                    var parent = src.parentContainer;
                    var alpha = camera.alpha * src.alpha;
                    if (parent) alpha *= parent.alpha;
                    var camMatrix = tempMatrix1;
                    var srcMatrix = tempMatrix2;
                    var calcMatrix = tempMatrix3;
                    var dx = 0;
                    var dy = 0;
                    var tx = '0%';
                    var ty = '0%';
                    if (parentMatrix) {
                        dx = src.width * src.scaleX * src.originX;
                        dy = src.height * src.scaleY * src.originY;
                        srcMatrix.applyITRS(src.x - dx, src.y - dy, src.rotation, src.scaleX, src.scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                        //  Undo the camera scroll
                        srcMatrix.e = src.x - dx;
                        srcMatrix.f = src.y - dy;
                        //  Multiply by the src matrix, store result in calcMatrix
                        camMatrix.multiply(srcMatrix, calcMatrix);
                    } else {
                        dx = src.width * src.originX;
                        dy = src.height * src.originY;
                        srcMatrix.applyITRS(src.x, src.y, src.rotation, src.scaleX, src.scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        tx = 100 * src.originX + '%';
                        ty = 100 * src.originY + '%';
                        srcMatrix.e -= camera.scrollX * src.scrollFactorX;
                        srcMatrix.f -= camera.scrollY * src.scrollFactorY;
                        //  Multiply by the src matrix, store result in calcMatrix
                        camMatrix.multiply(srcMatrix, calcMatrix);
                        calcMatrix.e -= dx;
                        calcMatrix.f -= dy;
                    }
                    if (!src.transformOnly) {
                        style.display = 'block';
                        style.opacity = alpha;
                        style.zIndex = src._depth;
                        style.pointerEvents = src.pointerEvents;
                        style.mixBlendMode = CSSBlendModes[src._blendMode];
                    }
                    // https://developer.mozilla.org/en-US/docs/Web/CSS/transform
                    style.transform = calcMatrix.getCSSMatrix() + ' skew(' + src.skewX + 'rad, ' + src.skewY + 'rad)' + ' rotate3d(' + src.rotate3d.x + ',' + src.rotate3d.y + ',' + src.rotate3d.z + ',' + src.rotate3d.w + src.rotate3dAngle + ')';
                    style.transformOrigin = tx + ' ' + ty;
                };
                module1.exports = DOMElementCSSRenderer;
            /***/ },
            /***/ 2611: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DOMElement = __webpack_require__(3069);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * DOM Element Game Objects are a way to control and manipulate HTML Elements over the top of your game.
 *
 * In order for DOM Elements to display you have to enable them by adding the following to your game
 * configuration object:
 *
 * ```javascript
 * dom {
 *   createContainer: true
 * }
 * ```
 *
 * When this is added, Phaser will automatically create a DOM Container div that is positioned over the top
 * of the game canvas. This div is sized to match the canvas, and if the canvas size changes, as a result of
 * settings within the Scale Manager, the dom container is resized accordingly.
 *
 * You can create a DOM Element by either passing in DOMStrings, or by passing in a reference to an existing
 * Element that you wish to be placed under the control of Phaser. For example:
 *
 * ```javascript
 * this.add.dom(x, y, 'div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
 * ```
 *
 * The above code will insert a div element into the DOM Container at the given x/y coordinate. The DOMString in
 * the 4th argument sets the initial CSS style of the div and the final argument is the inner text. In this case,
 * it will create a lime colored div that is 220px by 100px in size with the text Phaser in it, in an Arial font.
 *
 * You should nearly always, without exception, use explicitly sized HTML Elements, in order to fully control
 * alignment and positioning of the elements next to regular game content.
 *
 * Rather than specify the CSS and HTML directly you can use the `load.html` File Loader to load it into the
 * cache and then use the `createFromCache` method instead. You can also use `createFromHTML` and various other
 * methods available in this class to help construct your elements.
 *
 * Once the element has been created you can then control it like you would any other Game Object. You can set its
 * position, scale, rotation, alpha and other properties. It will move as the main Scene Camera moves and be clipped
 * at the edge of the canvas. It's important to remember some limitations of DOM Elements: The obvious one is that
 * they appear above or below your game canvas. You cannot blend them into the display list, meaning you cannot have
 * a DOM Element, then a Sprite, then another DOM Element behind it.
 *
 * They also cannot be enabled for input. To do that, you have to use the `addListener` method to add native event
 * listeners directly. The final limitation is to do with cameras. The DOM Container is sized to match the game canvas
 * entirely and clipped accordingly. DOM Elements respect camera scrolling and scrollFactor settings, but if you
 * change the size of the camera so it no longer matches the size of the canvas, they won't be clipped accordingly.
 *
 * Also, all DOM Elements are inserted into the same DOM Container, regardless of which Scene they are created in.
 *
 * DOM Elements are a powerful way to align native HTML with your Phaser Game Objects. For example, you can insert
 * a login form for a multiplayer game directly into your title screen. Or a text input box for a highscore table.
 * Or a banner ad from a 3rd party service. Or perhaps you'd like to use them for high resolution text display and
 * UI. The choice is up to you, just remember that you're dealing with standard HTML and CSS floating over the top
 * of your game, and should treat it accordingly.
 *
 * Note: This method will only be available if the DOM Element Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#dom
 * @since 3.17.0
 *
 * @param {number} x - The horizontal position of this DOM Element in the world.
 * @param {number} y - The vertical position of this DOM Element in the world.
 * @param {(HTMLElement|string)} [element] - An existing DOM element, or a string. If a string starting with a # it will do a `getElementById` look-up on the string (minus the hash). Without a hash, it represents the type of element to create, i.e. 'div'.
 * @param {(string|any)} [style] - If a string, will be set directly as the elements `style` property value. If a plain object, will be iterated and the values transferred. In both cases the values replacing whatever CSS styles may have been previously set.
 * @param {string} [innerText] - If given, will be set directly as the elements `innerText` property value, replacing whatever was there before.
 *
 * @return {Phaser.GameObjects.DOMElement} The Game Object that was created.
 */ GameObjectFactory.register('dom', function(x, y, element, style, innerText) {
                    var gameObject = new DOMElement(this.scene, x, y, element, style, innerText);
                    this.displayList.add(gameObject);
                    return gameObject;
                });
            /***/ },
            /***/ 441: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(49381);
                renderCanvas = __webpack_require__(49381);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 62980: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Added to Scene Event.
 *
 * This event is dispatched when a Game Object is added to a Scene.
 *
 * Listen for it on a Game Object instance using `GameObject.on('addedtoscene', listener)`.
 *
 * @event Phaser.GameObjects.Events#ADDED_TO_SCENE
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the Scene.
 * @param {Phaser.Scene} scene - The Scene to which the Game Object was added.
 */ module1.exports = 'addedtoscene';
            /***/ },
            /***/ 41337: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Destroy Event.
 *
 * This event is dispatched when a Game Object instance is being destroyed.
 *
 * Listen for it on a Game Object instance using `GameObject.on('destroy', listener)`.
 *
 * @event Phaser.GameObjects.Events#DESTROY
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object which is being destroyed.
 * @param {boolean} fromScene - `True` if this Game Object is being destroyed by the Scene, `false` if not.
 */ module1.exports = 'destroy';
            /***/ },
            /***/ 44947: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Removed from Scene Event.
 *
 * This event is dispatched when a Game Object is removed from a Scene.
 *
 * Listen for it on a Game Object instance using `GameObject.on('removedfromscene', listener)`.
 *
 * @event Phaser.GameObjects.Events#REMOVED_FROM_SCENE
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the Scene.
 * @param {Phaser.Scene} scene - The Scene from which the Game Object was removed.
 */ module1.exports = 'removedfromscene';
            /***/ },
            /***/ 49358: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Complete Event.
 *
 * This event is dispatched when a Video finishes playback by reaching the end of its duration. It
 * is also dispatched if a video marker sequence is being played and reaches the end.
 *
 * Note that not all videos can fire this event. Live streams, for example, have no fixed duration,
 * so never technically 'complete'.
 *
 * If a video is stopped from playback, via the `Video.stop` method, it will emit the
 * `VIDEO_STOP` event instead of this one.
 *
 * Listen for it from a Video Game Object instance using `Video.on('complete', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_COMPLETE
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which completed playback.
 */ module1.exports = 'complete';
            /***/ },
            /***/ 35163: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Created Event.
 *
 * This event is dispatched when the texture for a Video has been created. This happens
 * when enough of the video source has been loaded that the browser is able to render a
 * frame from it.
 *
 * Listen for it from a Video Game Object instance using `Video.on('created', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_CREATED
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which raised the event.
 * @param {number} width - The width of the video.
 * @param {number} height - The height of the video.
 */ module1.exports = 'created';
            /***/ },
            /***/ 97249: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Error Event.
 *
 * This event is dispatched when a Video tries to play a source that does not exist, or is the wrong file type.
 *
 * Listen for it from a Video Game Object instance using `Video.on('error', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_ERROR
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which threw the error.
 * @param {DOMException|string} event - The native DOM event the browser raised during playback.
 */ module1.exports = 'error';
            /***/ },
            /***/ 19483: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Locked Event.
 *
 * This event is dispatched when a Video was attempted to be played, but the browser prevented it
 * from doing so due to the Media Engagement Interaction policy.
 *
 * If you get this event you will need to wait for the user to interact with the browser before
 * the video will play. This is a browser security measure to prevent autoplaying videos with
 * audio. An interaction includes a mouse click, a touch, or a key press.
 *
 * Listen for it from a Video Game Object instance using `Video.on('locked', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_LOCKED
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which raised the event.
 */ module1.exports = 'locked';
            /***/ },
            /***/ 56059: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Loop Event.
 *
 * This event is dispatched when a Video that is currently playing has looped. This only
 * happens if the `loop` parameter was specified, or the `setLoop` method was called,
 * and if the video has a fixed duration. Video streams, for example, cannot loop, as
 * they have no duration.
 *
 * Looping is based on the result of the Video `timeupdate` event. This event is not
 * frame-accurate, due to the way browsers work, so please do not rely on this loop
 * event to be time or frame precise.
 *
 * Listen for it from a Video Game Object instance using `Video.on('loop', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_LOOP
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which has looped.
 */ module1.exports = 'loop';
            /***/ },
            /***/ 26772: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Metadata Event.
 *
 * This event is dispatched when a Video has access to the metadata.
 *
 * Listen for it from a Video Game Object instance using `Video.on('metadata', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_METADATA
 * @type {string}
 * @since 3.80.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which fired the event.
 * @param {DOMException|string} event - The native DOM event the browser raised during playback.
 */ module1.exports = 'metadata';
            /***/ },
            /***/ 64437: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Playing Event.
 *
 * The playing event is fired after playback is first started,
 * and whenever it is restarted. For example it is fired when playback
 * resumes after having been paused or delayed due to lack of data.
 *
 * Listen for it from a Video Game Object instance using `Video.on('playing', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_PLAYING
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started playback.
 */ module1.exports = 'playing';
            /***/ },
            /***/ 83411: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Play Event.
 *
 * This event is dispatched when a Video begins playback. For videos that do not require
 * interaction unlocking, this is usually as soon as the `Video.play` method is called.
 * However, for videos that require unlocking, it is fired once playback begins after
 * they've been unlocked.
 *
 * Listen for it from a Video Game Object instance using `Video.on('play', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_PLAY
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started playback.
 */ module1.exports = 'play';
            /***/ },
            /***/ 75780: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Seeked Event.
 *
 * This event is dispatched when a Video completes seeking to a new point in its timeline.
 *
 * Listen for it from a Video Game Object instance using `Video.on('seeked', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_SEEKED
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which completed seeking.
 */ module1.exports = 'seeked';
            /***/ },
            /***/ 67799: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Seeking Event.
 *
 * This event is dispatched when a Video _begins_ seeking to a new point in its timeline.
 * When the seek is complete, it will dispatch the `VIDEO_SEEKED` event to conclude.
 *
 * Listen for it from a Video Game Object instance using `Video.on('seeking', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_SEEKING
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started seeking.
 */ module1.exports = 'seeking';
            /***/ },
            /***/ 63500: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Stalled Event.
 *
 * This event is dispatched by a Video Game Object when the video playback stalls.
 *
 * This can happen if the video is buffering.
 *
 * If will fire for any of the following native DOM events:
 *
 * `stalled`
 * `suspend`
 * `waiting`
 *
 * Listen for it from a Video Game Object instance using `Video.on('stalled', listener)`.
 *
 * Note that being stalled isn't always a negative thing. A video can be stalled if it
 * has downloaded enough data in to its buffer to not need to download any more until
 * the current batch of frames have rendered.
 *
 * @event Phaser.GameObjects.Events#VIDEO_STALLED
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which threw the error.
 * @param {Event} event - The native DOM event the browser raised during playback.
 */ module1.exports = 'stalled';
            /***/ },
            /***/ 55541: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Stopped Event.
 *
 * This event is dispatched when a Video is stopped from playback via a call to the `Video.stop` method,
 * either directly via game code, or indirectly as the result of changing a video source or destroying it.
 *
 * Listen for it from a Video Game Object instance using `Video.on('stop', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_STOP
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which stopped playback.
 */ module1.exports = 'stop';
            /***/ },
            /***/ 53208: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Texture Ready Event.
 *
 * This event is dispatched by a Video Game Object when it has finished creating its texture.
 *
 * This happens when the video has finished loading enough data for its first frame.
 *
 * If you wish to use the Video texture elsewhere in your game, such as as a Sprite texture,
 * then you should listen for this event first, before creating the Sprites that use it.
 *
 * Listen for it from a Video Game Object instance using `Video.on('textureready', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_TEXTURE
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object that emitted the event.
 * @param {Phaser.Textures.Texture} texture - The Texture that was created.
 */ module1.exports = 'textureready';
            /***/ },
            /***/ 4992: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Unlocked Event.
 *
 * This event is dispatched when a Video that was prevented from playback due to the browsers
 * Media Engagement Interaction policy, is unlocked by a user gesture.
 *
 * Listen for it from a Video Game Object instance using `Video.on('unlocked', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_UNLOCKED
 * @type {string}
 * @since 3.20.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which raised the event.
 */ module1.exports = 'unlocked';
            /***/ },
            /***/ 12: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Unsupported Event.
 *
 * This event is dispatched by a Video Game Object if the media source
 * (which may be specified as a MediaStream, MediaSource, Blob, or File,
 * for example) doesn't represent a supported media format.
 *
 * Listen for it from a Video Game Object instance using `Video.on('unsupported', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_UNSUPPORTED
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started playback.
 * @param {DOMException|string} event - The native DOM event the browser raised during playback.
 */ module1.exports = 'unsupported';
            /***/ },
            /***/ 51708: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Events
 */ module1.exports = {
                    ADDED_TO_SCENE: __webpack_require__(62980),
                    DESTROY: __webpack_require__(41337),
                    REMOVED_FROM_SCENE: __webpack_require__(44947),
                    VIDEO_COMPLETE: __webpack_require__(49358),
                    VIDEO_CREATED: __webpack_require__(35163),
                    VIDEO_ERROR: __webpack_require__(97249),
                    VIDEO_LOCKED: __webpack_require__(19483),
                    VIDEO_LOOP: __webpack_require__(56059),
                    VIDEO_METADATA: __webpack_require__(26772),
                    VIDEO_PLAY: __webpack_require__(83411),
                    VIDEO_PLAYING: __webpack_require__(64437),
                    VIDEO_SEEKED: __webpack_require__(75780),
                    VIDEO_SEEKING: __webpack_require__(67799),
                    VIDEO_STALLED: __webpack_require__(63500),
                    VIDEO_STOP: __webpack_require__(55541),
                    VIDEO_TEXTURE: __webpack_require__(53208),
                    VIDEO_UNLOCKED: __webpack_require__(4992),
                    VIDEO_UNSUPPORTED: __webpack_require__(12)
                };
            /***/ },
            /***/ 42421: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var ExternRender = __webpack_require__(64993);
                /**
 * @classdesc
 * An Extern Game Object is a special type of Game Object that allows you to pass
 * rendering off to a 3rd party.
 *
 * When you create an Extern and place it in the display list of a Scene, the renderer will
 * process the list as usual. When it finds an Extern it will flush the current batch,
 * clear down the pipeline and prepare a transform matrix which your render function can
 * take advantage of, if required.
 *
 * The WebGL context is then left in a 'clean' state, ready for you to bind your own shaders,
 * or draw to it, whatever you wish to do. This should all take place in the `render` method.
 * The correct way to deploy an Extern object is to create a class that extends it, then
 * override the `render` (and optionally `preUpdate`) methods and pass off control to your
 * 3rd party libraries or custom WebGL code there.
 *
 * Once you've finished, you should free-up any of your resources.
 * The Extern will then rebind the Phaser pipeline and carry on rendering the display list.
 *
 * Although this object has lots of properties such as Alpha, Blend Mode and Tint, none of
 * them are used during rendering unless you take advantage of them in your own render code.
 *
 * @class Extern
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.16.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 */ var Extern = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Flip,
                        Components.Origin,
                        Components.ScrollFactor,
                        Components.Size,
                        Components.Texture,
                        Components.Tint,
                        Components.Transform,
                        Components.Visible,
                        ExternRender
                    ],
                    initialize: function Extern(scene) {
                        GameObject.call(this, scene, 'Extern');
                    },
                    //  Overrides Game Object method
                    addedToScene: function() {
                        this.scene.sys.updateList.add(this);
                    },
                    //  Overrides Game Object method
                    removedFromScene: function() {
                        this.scene.sys.updateList.remove(this);
                    },
                    preUpdate: function() {
                    //  override this!
                    //  Arguments: time, delta
                    },
                    render: function() {
                    //  override this!
                    //  Arguments: renderer, camera, calcMatrix
                    }
                });
                module1.exports = Extern;
            /***/ },
            /***/ 70217: /***/ ()=>{
            /***/ },
            /***/ 56315: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extern = __webpack_require__(42421);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Extern Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Extern Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#extern
 * @since 3.16.0
 *
 * @return {Phaser.GameObjects.Extern} The Game Object that was created.
 */ GameObjectFactory.register('extern', function() {
                    var extern = new Extern(this.scene);
                    this.displayList.add(extern);
                    return extern;
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 64993: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(80287);
                renderCanvas = __webpack_require__(70217);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 80287: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Extern#renderWebGL
 * @since 3.16.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Extern} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ExternWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    renderer.pipelines.clear();
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    src.render.call(src, renderer, camera, calcMatrix);
                    renderer.pipelines.rebind();
                };
                module1.exports = ExternWebGLRenderer;
            /***/ },
            /***/ 85592: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ module1.exports = {
                    ARC: 0,
                    BEGIN_PATH: 1,
                    CLOSE_PATH: 2,
                    FILL_RECT: 3,
                    LINE_TO: 4,
                    MOVE_TO: 5,
                    LINE_STYLE: 6,
                    FILL_STYLE: 7,
                    FILL_PATH: 8,
                    STROKE_PATH: 9,
                    FILL_TRIANGLE: 10,
                    STROKE_TRIANGLE: 11,
                    SAVE: 14,
                    RESTORE: 15,
                    TRANSLATE: 16,
                    SCALE: 17,
                    ROTATE: 18,
                    GRADIENT_FILL_STYLE: 21,
                    GRADIENT_LINE_STYLE: 22
                };
            /***/ },
            /***/ 43831: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCamera = __webpack_require__(71911);
                var Class = __webpack_require__(83419);
                var Commands = __webpack_require__(85592);
                var Components = __webpack_require__(31401);
                var Ellipse = __webpack_require__(8497);
                var GameObject = __webpack_require__(95643);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var MATH_CONST = __webpack_require__(36383);
                var Render = __webpack_require__(84503);
                /**
 * @classdesc
 * A Graphics object is a way to draw primitive shapes to your game. Primitives include forms of geometry, such as
 * Rectangles, Circles, and Polygons. They also include lines, arcs and curves. When you initially create a Graphics
 * object it will be empty.
 *
 * To draw to it you must first specify a line style or fill style (or both), draw shapes using paths, and finally
 * fill or stroke them. For example:
 *
 * ```javascript
 * graphics.lineStyle(5, 0xFF00FF, 1.0);
 * graphics.beginPath();
 * graphics.moveTo(100, 100);
 * graphics.lineTo(200, 200);
 * graphics.closePath();
 * graphics.strokePath();
 * ```
 *
 * There are also many helpful methods that draw and fill/stroke common shapes for you.
 *
 * ```javascript
 * graphics.lineStyle(5, 0xFF00FF, 1.0);
 * graphics.fillStyle(0xFFFFFF, 1.0);
 * graphics.fillRect(50, 50, 400, 200);
 * graphics.strokeRect(50, 50, 400, 200);
 * ```
 *
 * When a Graphics object is rendered it will render differently based on if the game is running under Canvas or WebGL.
 * Under Canvas it will use the HTML Canvas context drawing operations to draw the path.
 * Under WebGL the graphics data is decomposed into polygons. Both of these are expensive processes, especially with
 * complex shapes.
 *
 * If your Graphics object doesn't change much (or at all) once you've drawn your shape to it, then you will help
 * performance by calling {@link Phaser.GameObjects.Graphics#generateTexture}. This will 'bake' the Graphics object into
 * a Texture, and return it. You can then use this Texture for Sprites or other display objects. If your Graphics object
 * updates frequently then you should avoid doing this, as it will constantly generate new textures, which will consume
 * memory.
 *
 * As you can tell, Graphics objects are a bit of a trade-off. While they are extremely useful, you need to be careful
 * in their complexity and quantity of them in your game.
 *
 * @class Graphics
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Graphics object belongs.
 * @param {Phaser.Types.GameObjects.Graphics.Options} [options] - Options that set the position and default style of this Graphics object.
 */ var Graphics = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Mask,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.Transform,
                        Components.Visible,
                        Components.ScrollFactor,
                        Render
                    ],
                    initialize: function Graphics(scene, options) {
                        var x = GetValue(options, 'x', 0);
                        var y = GetValue(options, 'y', 0);
                        GameObject.call(this, scene, 'Graphics');
                        this.setPosition(x, y);
                        this.initPipeline();
                        this.initPostPipeline();
                        /**
         * The horizontal display origin of the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#displayOriginX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.displayOriginX = 0;
                        /**
         * The vertical display origin of the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#displayOriginY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.displayOriginY = 0;
                        /**
         * The array of commands used to render the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#commandBuffer
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.commandBuffer = [];
                        /**
         * The default fill color for shapes rendered by this Graphics object.
         * Set this value with `setDefaultStyles()`.
         *
         * @name Phaser.GameObjects.Graphics#defaultFillColor
         * @type {number}
         * @readonly
         * @default -1
         * @since 3.0.0
         */ this.defaultFillColor = -1;
                        /**
         * The default fill alpha for shapes rendered by this Graphics object.
         * Set this value with `setDefaultStyles()`.
         *
         * @name Phaser.GameObjects.Graphics#defaultFillAlpha
         * @type {number}
         * @readonly
         * @default 1
         * @since 3.0.0
         */ this.defaultFillAlpha = 1;
                        /**
         * The default stroke width for shapes rendered by this Graphics object.
         * Set this value with `setDefaultStyles()`.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeWidth
         * @type {number}
         * @readonly
         * @default 1
         * @since 3.0.0
         */ this.defaultStrokeWidth = 1;
                        /**
         * The default stroke color for shapes rendered by this Graphics object.
         * Set this value with `setDefaultStyles()`.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeColor
         * @type {number}
         * @readonly
         * @default -1
         * @since 3.0.0
         */ this.defaultStrokeColor = -1;
                        /**
         * The default stroke alpha for shapes rendered by this Graphics object.
         * Set this value with `setDefaultStyles()`.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeAlpha
         * @type {number}
         * @readonly
         * @default 1
         * @since 3.0.0
         */ this.defaultStrokeAlpha = 1;
                        /**
         * Internal property that keeps track of the line width style setting.
         *
         * @name Phaser.GameObjects.Graphics#_lineWidth
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._lineWidth = 1;
                        this.lineStyle(1, 0, 0);
                        this.fillStyle(0, 0);
                        this.setDefaultStyles(options);
                    },
                    /**
     * Set the default style settings for this Graphics object.
     *
     * @method Phaser.GameObjects.Graphics#setDefaultStyles
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Graphics.Styles} options - The styles to set as defaults.
     *
     * @return {this} This Game Object.
     */ setDefaultStyles: function(options) {
                        if (GetValue(options, 'lineStyle', null)) {
                            this.defaultStrokeWidth = GetValue(options, 'lineStyle.width', 1);
                            this.defaultStrokeColor = GetValue(options, 'lineStyle.color', 0xffffff);
                            this.defaultStrokeAlpha = GetValue(options, 'lineStyle.alpha', 1);
                            this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
                        }
                        if (GetValue(options, 'fillStyle', null)) {
                            this.defaultFillColor = GetValue(options, 'fillStyle.color', 0xffffff);
                            this.defaultFillAlpha = GetValue(options, 'fillStyle.alpha', 1);
                            this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
                        }
                        return this;
                    },
                    /**
     * Set the current line style. Used for all 'stroke' related functions.
     *
     * @method Phaser.GameObjects.Graphics#lineStyle
     * @since 3.0.0
     *
     * @param {number} lineWidth - The stroke width.
     * @param {number} color - The stroke color.
     * @param {number} [alpha=1] - The stroke alpha.
     *
     * @return {this} This Game Object.
     */ lineStyle: function(lineWidth, color, alpha) {
                        if (alpha === undefined) alpha = 1;
                        this.commandBuffer.push(Commands.LINE_STYLE, lineWidth, color, alpha);
                        this._lineWidth = lineWidth;
                        return this;
                    },
                    /**
     * Set the current fill style. Used for all 'fill' related functions.
     *
     * @method Phaser.GameObjects.Graphics#fillStyle
     * @since 3.0.0
     *
     * @param {number} color - The fill color.
     * @param {number} [alpha=1] - The fill alpha.
     *
     * @return {this} This Game Object.
     */ fillStyle: function(color, alpha) {
                        if (alpha === undefined) alpha = 1;
                        this.commandBuffer.push(Commands.FILL_STYLE, color, alpha);
                        return this;
                    },
                    /**
     * Sets a gradient fill style. This is a WebGL only feature.
     *
     * The gradient color values represent the 4 corners of an untransformed rectangle.
     * The gradient is used to color all filled shapes and paths drawn after calling this method.
     * If you wish to turn a gradient off, call `fillStyle` and provide a new single fill color.
     *
     * When filling a triangle only the first 3 color values provided are used for the 3 points of a triangle.
     *
     * This feature is best used only on rectangles and triangles. All other shapes will give strange results.
     *
     * Note that for objects such as arcs or ellipses, or anything which is made out of triangles, each triangle used
     * will be filled with a gradient on its own. There is no ability to gradient fill a shape or path as a single
     * entity at this time.
     *
     * @method Phaser.GameObjects.Graphics#fillGradientStyle
     * @webglOnly
     * @since 3.12.0
     *
     * @param {number} topLeft - The top left fill color.
     * @param {number} topRight - The top right fill color.
     * @param {number} bottomLeft - The bottom left fill color.
     * @param {number} bottomRight - The bottom right fill color. Not used when filling triangles.
     * @param {number} [alphaTopLeft=1] - The top left alpha value. If you give only this value, it's used for all corners.
     * @param {number} [alphaTopRight=1] - The top right alpha value.
     * @param {number} [alphaBottomLeft=1] - The bottom left alpha value.
     * @param {number} [alphaBottomRight=1] - The bottom right alpha value.
     *
     * @return {this} This Game Object.
     */ fillGradientStyle: function(topLeft, topRight, bottomLeft, bottomRight, alphaTopLeft, alphaTopRight, alphaBottomLeft, alphaBottomRight) {
                        if (alphaTopLeft === undefined) alphaTopLeft = 1;
                        if (alphaTopRight === undefined) alphaTopRight = alphaTopLeft;
                        if (alphaBottomLeft === undefined) alphaBottomLeft = alphaTopLeft;
                        if (alphaBottomRight === undefined) alphaBottomRight = alphaTopLeft;
                        this.commandBuffer.push(Commands.GRADIENT_FILL_STYLE, alphaTopLeft, alphaTopRight, alphaBottomLeft, alphaBottomRight, topLeft, topRight, bottomLeft, bottomRight);
                        return this;
                    },
                    /**
     * Sets a gradient line style. This is a WebGL only feature.
     *
     * The gradient color values represent the 4 corners of an untransformed rectangle.
     * The gradient is used to color all stroked shapes and paths drawn after calling this method.
     * If you wish to turn a gradient off, call `lineStyle` and provide a new single line color.
     *
     * This feature is best used only on single lines. All other shapes will give strange results.
     *
     * Note that for objects such as arcs or ellipses, or anything which is made out of triangles, each triangle used
     * will be filled with a gradient on its own. There is no ability to gradient stroke a shape or path as a single
     * entity at this time.
     *
     * @method Phaser.GameObjects.Graphics#lineGradientStyle
     * @webglOnly
     * @since 3.12.0
     *
     * @param {number} lineWidth - The stroke width.
     * @param {number} topLeft - The tint being applied to the top-left of the Game Object.
     * @param {number} topRight - The tint being applied to the top-right of the Game Object.
     * @param {number} bottomLeft - The tint being applied to the bottom-left of the Game Object.
     * @param {number} bottomRight - The tint being applied to the bottom-right of the Game Object.
     * @param {number} [alpha=1] - The fill alpha.
     *
     * @return {this} This Game Object.
     */ lineGradientStyle: function(lineWidth, topLeft, topRight, bottomLeft, bottomRight, alpha) {
                        if (alpha === undefined) alpha = 1;
                        this.commandBuffer.push(Commands.GRADIENT_LINE_STYLE, lineWidth, alpha, topLeft, topRight, bottomLeft, bottomRight);
                        return this;
                    },
                    /**
     * Start a new shape path.
     *
     * @method Phaser.GameObjects.Graphics#beginPath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ beginPath: function() {
                        this.commandBuffer.push(Commands.BEGIN_PATH);
                        return this;
                    },
                    /**
     * Close the current path.
     *
     * @method Phaser.GameObjects.Graphics#closePath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ closePath: function() {
                        this.commandBuffer.push(Commands.CLOSE_PATH);
                        return this;
                    },
                    /**
     * Fill the current path.
     *
     * @method Phaser.GameObjects.Graphics#fillPath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ fillPath: function() {
                        this.commandBuffer.push(Commands.FILL_PATH);
                        return this;
                    },
                    /**
     * Fill the current path.
     *
     * This is an alias for `Graphics.fillPath` and does the same thing.
     * It was added to match the CanvasRenderingContext 2D API.
     *
     * @method Phaser.GameObjects.Graphics#fill
     * @since 3.16.0
     *
     * @return {this} This Game Object.
     */ fill: function() {
                        this.commandBuffer.push(Commands.FILL_PATH);
                        return this;
                    },
                    /**
     * Stroke the current path.
     *
     * @method Phaser.GameObjects.Graphics#strokePath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ strokePath: function() {
                        this.commandBuffer.push(Commands.STROKE_PATH);
                        return this;
                    },
                    /**
     * Stroke the current path.
     *
     * This is an alias for `Graphics.strokePath` and does the same thing.
     * It was added to match the CanvasRenderingContext 2D API.
     *
     * @method Phaser.GameObjects.Graphics#stroke
     * @since 3.16.0
     *
     * @return {this} This Game Object.
     */ stroke: function() {
                        this.commandBuffer.push(Commands.STROKE_PATH);
                        return this;
                    },
                    /**
     * Fill the given circle.
     *
     * @method Phaser.GameObjects.Graphics#fillCircleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Circle} circle - The circle to fill.
     *
     * @return {this} This Game Object.
     */ fillCircleShape: function(circle) {
                        return this.fillCircle(circle.x, circle.y, circle.radius);
                    },
                    /**
     * Stroke the given circle.
     *
     * @method Phaser.GameObjects.Graphics#strokeCircleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Circle} circle - The circle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeCircleShape: function(circle) {
                        return this.strokeCircle(circle.x, circle.y, circle.radius);
                    },
                    /**
     * Fill a circle with the given position and radius.
     *
     * @method Phaser.GameObjects.Graphics#fillCircle
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     *
     * @return {this} This Game Object.
     */ fillCircle: function(x, y, radius) {
                        this.beginPath();
                        this.arc(x, y, radius, 0, MATH_CONST.PI2);
                        this.fillPath();
                        return this;
                    },
                    /**
     * Stroke a circle with the given position and radius.
     *
     * @method Phaser.GameObjects.Graphics#strokeCircle
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     *
     * @return {this} This Game Object.
     */ strokeCircle: function(x, y, radius) {
                        this.beginPath();
                        this.arc(x, y, radius, 0, MATH_CONST.PI2);
                        this.strokePath();
                        return this;
                    },
                    /**
     * Fill the given rectangle.
     *
     * @method Phaser.GameObjects.Graphics#fillRectShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} rect - The rectangle to fill.
     *
     * @return {this} This Game Object.
     */ fillRectShape: function(rect) {
                        return this.fillRect(rect.x, rect.y, rect.width, rect.height);
                    },
                    /**
     * Stroke the given rectangle.
     *
     * @method Phaser.GameObjects.Graphics#strokeRectShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} rect - The rectangle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeRectShape: function(rect) {
                        return this.strokeRect(rect.x, rect.y, rect.width, rect.height);
                    },
                    /**
     * Fill a rectangle with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#fillRect
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     *
     * @return {this} This Game Object.
     */ fillRect: function(x, y, width, height) {
                        this.commandBuffer.push(Commands.FILL_RECT, x, y, width, height);
                        return this;
                    },
                    /**
     * Stroke a rectangle with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#strokeRect
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     *
     * @return {this} This Game Object.
     */ strokeRect: function(x, y, width, height) {
                        var lineWidthHalf = this._lineWidth / 2;
                        var minx = x - lineWidthHalf;
                        var maxx = x + lineWidthHalf;
                        this.beginPath();
                        this.moveTo(x, y);
                        this.lineTo(x, y + height);
                        this.strokePath();
                        this.beginPath();
                        this.moveTo(x + width, y);
                        this.lineTo(x + width, y + height);
                        this.strokePath();
                        this.beginPath();
                        this.moveTo(minx, y);
                        this.lineTo(maxx + width, y);
                        this.strokePath();
                        this.beginPath();
                        this.moveTo(minx, y + height);
                        this.lineTo(maxx + width, y + height);
                        this.strokePath();
                        return this;
                    },
                    /**
     * Fill a rounded rectangle with the given position, size and radius.
     *
     * @method Phaser.GameObjects.Graphics#fillRoundedRect
     * @since 3.11.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {(Phaser.Types.GameObjects.Graphics.RoundedRectRadius|number)} [radius=20] - The corner radius; It can also be an object to specify different radius for corners.
     *
     * @return {this} This Game Object.
     */ fillRoundedRect: function(x, y, width, height, radius) {
                        if (radius === undefined) radius = 20;
                        var tl = radius;
                        var tr = radius;
                        var bl = radius;
                        var br = radius;
                        if (typeof radius !== 'number') {
                            tl = GetFastValue(radius, 'tl', 20);
                            tr = GetFastValue(radius, 'tr', 20);
                            bl = GetFastValue(radius, 'bl', 20);
                            br = GetFastValue(radius, 'br', 20);
                        }
                        var convexTL = tl >= 0;
                        var convexTR = tr >= 0;
                        var convexBL = bl >= 0;
                        var convexBR = br >= 0;
                        tl = Math.abs(tl);
                        tr = Math.abs(tr);
                        bl = Math.abs(bl);
                        br = Math.abs(br);
                        this.beginPath();
                        this.moveTo(x + tl, y);
                        this.lineTo(x + width - tr, y);
                        if (convexTR) this.arc(x + width - tr, y + tr, tr, -MATH_CONST.TAU, 0);
                        else this.arc(x + width, y, tr, Math.PI, MATH_CONST.TAU, true);
                        this.lineTo(x + width, y + height - br);
                        if (convexBR) this.arc(x + width - br, y + height - br, br, 0, MATH_CONST.TAU);
                        else this.arc(x + width, y + height, br, -MATH_CONST.TAU, Math.PI, true);
                        this.lineTo(x + bl, y + height);
                        if (convexBL) this.arc(x + bl, y + height - bl, bl, MATH_CONST.TAU, Math.PI);
                        else this.arc(x, y + height, bl, 0, -MATH_CONST.TAU, true);
                        this.lineTo(x, y + tl);
                        if (convexTL) this.arc(x + tl, y + tl, tl, -Math.PI, -MATH_CONST.TAU);
                        else this.arc(x, y, tl, MATH_CONST.TAU, 0, true);
                        this.fillPath();
                        return this;
                    },
                    /**
     * Stroke a rounded rectangle with the given position, size and radius.
     *
     * @method Phaser.GameObjects.Graphics#strokeRoundedRect
     * @since 3.11.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {(Phaser.Types.GameObjects.Graphics.RoundedRectRadius|number)} [radius=20] - The corner radius; It can also be an object to specify different radii for corners.
     *
     * @return {this} This Game Object.
     */ strokeRoundedRect: function(x, y, width, height, radius) {
                        if (radius === undefined) radius = 20;
                        var tl = radius;
                        var tr = radius;
                        var bl = radius;
                        var br = radius;
                        var maxRadius = Math.min(width, height) / 2;
                        if (typeof radius !== 'number') {
                            tl = GetFastValue(radius, 'tl', 20);
                            tr = GetFastValue(radius, 'tr', 20);
                            bl = GetFastValue(radius, 'bl', 20);
                            br = GetFastValue(radius, 'br', 20);
                        }
                        var convexTL = tl >= 0;
                        var convexTR = tr >= 0;
                        var convexBL = bl >= 0;
                        var convexBR = br >= 0;
                        tl = Math.min(Math.abs(tl), maxRadius);
                        tr = Math.min(Math.abs(tr), maxRadius);
                        bl = Math.min(Math.abs(bl), maxRadius);
                        br = Math.min(Math.abs(br), maxRadius);
                        this.beginPath();
                        this.moveTo(x + tl, y);
                        this.lineTo(x + width - tr, y);
                        this.moveTo(x + width - tr, y);
                        if (convexTR) this.arc(x + width - tr, y + tr, tr, -MATH_CONST.TAU, 0);
                        else this.arc(x + width, y, tr, Math.PI, MATH_CONST.TAU, true);
                        this.lineTo(x + width, y + height - br);
                        this.moveTo(x + width, y + height - br);
                        if (convexBR) this.arc(x + width - br, y + height - br, br, 0, MATH_CONST.TAU);
                        else this.arc(x + width, y + height, br, -MATH_CONST.TAU, Math.PI, true);
                        this.lineTo(x + bl, y + height);
                        this.moveTo(x + bl, y + height);
                        if (convexBL) this.arc(x + bl, y + height - bl, bl, MATH_CONST.TAU, Math.PI);
                        else this.arc(x, y + height, bl, 0, -MATH_CONST.TAU, true);
                        this.lineTo(x, y + tl);
                        this.moveTo(x, y + tl);
                        if (convexTL) this.arc(x + tl, y + tl, tl, -Math.PI, -MATH_CONST.TAU);
                        else this.arc(x, y, tl, MATH_CONST.TAU, 0, true);
                        this.strokePath();
                        return this;
                    },
                    /**
     * Fill the given point.
     *
     * Draws a square at the given position, 1 pixel in size by default.
     *
     * @method Phaser.GameObjects.Graphics#fillPointShape
     * @since 3.0.0
     *
     * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} point - The point to fill.
     * @param {number} [size=1] - The size of the square to draw.
     *
     * @return {this} This Game Object.
     */ fillPointShape: function(point, size) {
                        return this.fillPoint(point.x, point.y, size);
                    },
                    /**
     * Fill a point at the given position.
     *
     * Draws a square at the given position, 1 pixel in size by default.
     *
     * @method Phaser.GameObjects.Graphics#fillPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point.
     * @param {number} y - The y coordinate of the point.
     * @param {number} [size=1] - The size of the square to draw.
     *
     * @return {this} This Game Object.
     */ fillPoint: function(x, y, size) {
                        if (!size || size < 1) size = 1;
                        else {
                            x -= size / 2;
                            y -= size / 2;
                        }
                        this.commandBuffer.push(Commands.FILL_RECT, x, y, size, size);
                        return this;
                    },
                    /**
     * Fill the given triangle.
     *
     * @method Phaser.GameObjects.Graphics#fillTriangleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Triangle} triangle - The triangle to fill.
     *
     * @return {this} This Game Object.
     */ fillTriangleShape: function(triangle) {
                        return this.fillTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
                    },
                    /**
     * Stroke the given triangle.
     *
     * @method Phaser.GameObjects.Graphics#strokeTriangleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Triangle} triangle - The triangle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeTriangleShape: function(triangle) {
                        return this.strokeTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
                    },
                    /**
     * Fill a triangle with the given points.
     *
     * @method Phaser.GameObjects.Graphics#fillTriangle
     * @since 3.0.0
     *
     * @param {number} x0 - The x coordinate of the first point.
     * @param {number} y0 - The y coordinate of the first point.
     * @param {number} x1 - The x coordinate of the second point.
     * @param {number} y1 - The y coordinate of the second point.
     * @param {number} x2 - The x coordinate of the third point.
     * @param {number} y2 - The y coordinate of the third point.
     *
     * @return {this} This Game Object.
     */ fillTriangle: function(x0, y0, x1, y1, x2, y2) {
                        this.commandBuffer.push(Commands.FILL_TRIANGLE, x0, y0, x1, y1, x2, y2);
                        return this;
                    },
                    /**
     * Stroke a triangle with the given points.
     *
     * @method Phaser.GameObjects.Graphics#strokeTriangle
     * @since 3.0.0
     *
     * @param {number} x0 - The x coordinate of the first point.
     * @param {number} y0 - The y coordinate of the first point.
     * @param {number} x1 - The x coordinate of the second point.
     * @param {number} y1 - The y coordinate of the second point.
     * @param {number} x2 - The x coordinate of the third point.
     * @param {number} y2 - The y coordinate of the third point.
     *
     * @return {this} This Game Object.
     */ strokeTriangle: function(x0, y0, x1, y1, x2, y2) {
                        this.commandBuffer.push(Commands.STROKE_TRIANGLE, x0, y0, x1, y1, x2, y2);
                        return this;
                    },
                    /**
     * Draw the given line.
     *
     * @method Phaser.GameObjects.Graphics#strokeLineShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Line} line - The line to stroke.
     *
     * @return {this} This Game Object.
     */ strokeLineShape: function(line) {
                        return this.lineBetween(line.x1, line.y1, line.x2, line.y2);
                    },
                    /**
     * Draw a line between the given points.
     *
     * @method Phaser.GameObjects.Graphics#lineBetween
     * @since 3.0.0
     *
     * @param {number} x1 - The x coordinate of the start point of the line.
     * @param {number} y1 - The y coordinate of the start point of the line.
     * @param {number} x2 - The x coordinate of the end point of the line.
     * @param {number} y2 - The y coordinate of the end point of the line.
     *
     * @return {this} This Game Object.
     */ lineBetween: function(x1, y1, x2, y2) {
                        this.beginPath();
                        this.moveTo(x1, y1);
                        this.lineTo(x2, y2);
                        this.strokePath();
                        return this;
                    },
                    /**
     * Draw a line from the current drawing position to the given position.
     *
     * Moves the current drawing position to the given position.
     *
     * @method Phaser.GameObjects.Graphics#lineTo
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to draw the line to.
     * @param {number} y - The y coordinate to draw the line to.
     *
     * @return {this} This Game Object.
     */ lineTo: function(x, y) {
                        this.commandBuffer.push(Commands.LINE_TO, x, y);
                        return this;
                    },
                    /**
     * Move the current drawing position to the given position.
     *
     * @method Phaser.GameObjects.Graphics#moveTo
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to move to.
     * @param {number} y - The y coordinate to move to.
     *
     * @return {this} This Game Object.
     */ moveTo: function(x, y) {
                        this.commandBuffer.push(Commands.MOVE_TO, x, y);
                        return this;
                    },
                    /**
     * Stroke the shape represented by the given array of points.
     *
     * Pass `closeShape` to automatically close the shape by joining the last to the first point.
     *
     * Pass `closePath` to automatically close the path before it is stroked.
     *
     * @method Phaser.GameObjects.Graphics#strokePoints
     * @since 3.0.0
     *
     * @param {(array|Phaser.Geom.Point[])} points - The points to stroke.
     * @param {boolean} [closeShape=false] - When `true`, the shape is closed by joining the last point to the first point.
     * @param {boolean} [closePath=false] - When `true`, the path is closed before being stroked.
     * @param {number} [endIndex] - The index of `points` to stop drawing at. Defaults to `points.length`.
     *
     * @return {this} This Game Object.
     */ strokePoints: function(points, closeShape, closePath, endIndex) {
                        if (closeShape === undefined) closeShape = false;
                        if (closePath === undefined) closePath = false;
                        if (endIndex === undefined) endIndex = points.length;
                        this.beginPath();
                        this.moveTo(points[0].x, points[0].y);
                        for(var i = 1; i < endIndex; i++)this.lineTo(points[i].x, points[i].y);
                        if (closeShape) this.lineTo(points[0].x, points[0].y);
                        if (closePath) this.closePath();
                        this.strokePath();
                        return this;
                    },
                    /**
     * Fill the shape represented by the given array of points.
     *
     * Pass `closeShape` to automatically close the shape by joining the last to the first point.
     *
     * Pass `closePath` to automatically close the path before it is filled.
     *
     * @method Phaser.GameObjects.Graphics#fillPoints
     * @since 3.0.0
     *
     * @param {(array|Phaser.Geom.Point[])} points - The points to fill.
     * @param {boolean} [closeShape=false] - When `true`, the shape is closed by joining the last point to the first point.
     * @param {boolean} [closePath=false] - When `true`, the path is closed before being stroked.
     * @param {number} [endIndex] - The index of `points` to stop at. Defaults to `points.length`.
     *
     * @return {this} This Game Object.
     */ fillPoints: function(points, closeShape, closePath, endIndex) {
                        if (closeShape === undefined) closeShape = false;
                        if (closePath === undefined) closePath = false;
                        if (endIndex === undefined) endIndex = points.length;
                        this.beginPath();
                        this.moveTo(points[0].x, points[0].y);
                        for(var i = 1; i < endIndex; i++)this.lineTo(points[i].x, points[i].y);
                        if (closeShape) this.lineTo(points[0].x, points[0].y);
                        if (closePath) this.closePath();
                        this.fillPath();
                        return this;
                    },
                    /**
     * Stroke the given ellipse.
     *
     * @method Phaser.GameObjects.Graphics#strokeEllipseShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Ellipse} ellipse - The ellipse to stroke.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ strokeEllipseShape: function(ellipse, smoothness) {
                        if (smoothness === undefined) smoothness = 32;
                        var points = ellipse.getPoints(smoothness);
                        return this.strokePoints(points, true);
                    },
                    /**
     * Stroke an ellipse with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#strokeEllipse
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the ellipse.
     * @param {number} y - The y coordinate of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ strokeEllipse: function(x, y, width, height, smoothness) {
                        if (smoothness === undefined) smoothness = 32;
                        var ellipse = new Ellipse(x, y, width, height);
                        var points = ellipse.getPoints(smoothness);
                        return this.strokePoints(points, true);
                    },
                    /**
     * Fill the given ellipse.
     *
     * @method Phaser.GameObjects.Graphics#fillEllipseShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Ellipse} ellipse - The ellipse to fill.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ fillEllipseShape: function(ellipse, smoothness) {
                        if (smoothness === undefined) smoothness = 32;
                        var points = ellipse.getPoints(smoothness);
                        return this.fillPoints(points, true);
                    },
                    /**
     * Fill an ellipse with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#fillEllipse
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the ellipse.
     * @param {number} y - The y coordinate of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ fillEllipse: function(x, y, width, height, smoothness) {
                        if (smoothness === undefined) smoothness = 32;
                        var ellipse = new Ellipse(x, y, width, height);
                        var points = ellipse.getPoints(smoothness);
                        return this.fillPoints(points, true);
                    },
                    /**
     * Draw an arc.
     *
     * This method can be used to create circles, or parts of circles.
     *
     * Make sure you call `beginPath` before starting the arc unless you wish for the arc to automatically
     * close when filled or stroked.
     *
     * Use the optional `overshoot` argument increase the number of iterations that take place when
     * the arc is rendered in WebGL. This is useful if you're drawing an arc with an especially thick line,
     * as it will allow the arc to fully join-up. Try small values at first, i.e. 0.01.
     *
     * Call {@link Phaser.GameObjects.Graphics#fillPath} or {@link Phaser.GameObjects.Graphics#strokePath} after calling
     * this method to draw the arc.
     *
     * @method Phaser.GameObjects.Graphics#arc
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     * @param {number} startAngle - The starting angle, in radians.
     * @param {number} endAngle - The ending angle, in radians.
     * @param {boolean} [anticlockwise=false] - Whether the drawing should be anticlockwise or clockwise.
     * @param {number} [overshoot=0] - This value allows you to increase the segment iterations in WebGL rendering. Useful if the arc has a thick stroke and needs to overshoot to join-up cleanly. Use small numbers such as 0.01 to start with and increase as needed.
     *
     * @return {this} This Game Object.
     */ arc: function(x, y, radius, startAngle, endAngle, anticlockwise, overshoot) {
                        if (anticlockwise === undefined) anticlockwise = false;
                        if (overshoot === undefined) overshoot = 0;
                        this.commandBuffer.push(Commands.ARC, x, y, radius, startAngle, endAngle, anticlockwise, overshoot);
                        return this;
                    },
                    /**
     * Creates a pie-chart slice shape centered at `x`, `y` with the given radius.
     * You must define the start and end angle of the slice.
     *
     * Setting the `anticlockwise` argument to `true` creates a shape similar to Pacman.
     * Setting it to `false` creates a shape like a slice of pie.
     *
     * This method will begin a new path and close the path at the end of it.
     * To display the actual slice you need to call either `strokePath` or `fillPath` after it.
     *
     * @method Phaser.GameObjects.Graphics#slice
     * @since 3.4.0
     *
     * @param {number} x - The horizontal center of the slice.
     * @param {number} y - The vertical center of the slice.
     * @param {number} radius - The radius of the slice.
     * @param {number} startAngle - The start angle of the slice, given in radians.
     * @param {number} endAngle - The end angle of the slice, given in radians.
     * @param {boolean} [anticlockwise=false] - Whether the drawing should be anticlockwise or clockwise.
     * @param {number} [overshoot=0] - This value allows you to overshoot the endAngle by this amount. Useful if the arc has a thick stroke and needs to overshoot to join-up cleanly.
     *
     * @return {this} This Game Object.
     */ slice: function(x, y, radius, startAngle, endAngle, anticlockwise, overshoot) {
                        if (anticlockwise === undefined) anticlockwise = false;
                        if (overshoot === undefined) overshoot = 0;
                        this.commandBuffer.push(Commands.BEGIN_PATH);
                        this.commandBuffer.push(Commands.MOVE_TO, x, y);
                        this.commandBuffer.push(Commands.ARC, x, y, radius, startAngle, endAngle, anticlockwise, overshoot);
                        this.commandBuffer.push(Commands.CLOSE_PATH);
                        return this;
                    },
                    /**
     * Saves the state of the Graphics by pushing the current state onto a stack.
     *
     * The most recently saved state can then be restored with {@link Phaser.GameObjects.Graphics#restore}.
     *
     * @method Phaser.GameObjects.Graphics#save
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ save: function() {
                        this.commandBuffer.push(Commands.SAVE);
                        return this;
                    },
                    /**
     * Restores the most recently saved state of the Graphics by popping from the state stack.
     *
     * Use {@link Phaser.GameObjects.Graphics#save} to save the current state, and call this afterwards to restore that state.
     *
     * If there is no saved state, this command does nothing.
     *
     * @method Phaser.GameObjects.Graphics#restore
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ restore: function() {
                        this.commandBuffer.push(Commands.RESTORE);
                        return this;
                    },
                    /**
     * Inserts a translation command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be translated
     * by the given amount.
     *
     * This does not change the position of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#translateCanvas
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation to apply.
     * @param {number} y - The vertical translation to apply.
     *
     * @return {this} This Game Object.
     */ translateCanvas: function(x, y) {
                        this.commandBuffer.push(Commands.TRANSLATE, x, y);
                        return this;
                    },
                    /**
     * Inserts a scale command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be scaled
     * by the given amount.
     *
     * This does not change the scale of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#scaleCanvas
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale to apply.
     * @param {number} y - The vertical scale to apply.
     *
     * @return {this} This Game Object.
     */ scaleCanvas: function(x, y) {
                        this.commandBuffer.push(Commands.SCALE, x, y);
                        return this;
                    },
                    /**
     * Inserts a rotation command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be rotated
     * by the given amount.
     *
     * This does not change the rotation of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#rotateCanvas
     * @since 3.0.0
     *
     * @param {number} radians - The rotation angle, in radians.
     *
     * @return {this} This Game Object.
     */ rotateCanvas: function(radians) {
                        this.commandBuffer.push(Commands.ROTATE, radians);
                        return this;
                    },
                    /**
     * Clear the command buffer and reset the fill style and line style to their defaults.
     *
     * @method Phaser.GameObjects.Graphics#clear
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ clear: function() {
                        this.commandBuffer.length = 0;
                        if (this.defaultFillColor > -1) this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
                        if (this.defaultStrokeColor > -1) this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
                        return this;
                    },
                    /**
     * Generate a texture from this Graphics object.
     *
     * If `key` is a string it'll generate a new texture using it and add it into the
     * Texture Manager (assuming no key conflict happens).
     *
     * If `key` is a Canvas it will draw the texture to that canvas context. Note that it will NOT
     * automatically upload it to the GPU in WebGL mode.
     *
     * Please understand that the texture is created via the Canvas API of the browser, therefore some
     * Graphics features, such as `fillGradientStyle`, will not appear on the resulting texture,
     * as they're unsupported by the Canvas API.
     *
     * @method Phaser.GameObjects.Graphics#generateTexture
     * @since 3.0.0
     *
     * @param {(string|HTMLCanvasElement)} key - The key to store the texture with in the Texture Manager, or a Canvas to draw to.
     * @param {number} [width] - The width of the graphics to generate.
     * @param {number} [height] - The height of the graphics to generate.
     *
     * @return {this} This Game Object.
     */ generateTexture: function(key, width, height) {
                        var sys = this.scene.sys;
                        var renderer = sys.game.renderer;
                        if (width === undefined) width = sys.scale.width;
                        if (height === undefined) height = sys.scale.height;
                        Graphics.TargetCamera.setScene(this.scene);
                        Graphics.TargetCamera.setViewport(0, 0, width, height);
                        Graphics.TargetCamera.scrollX = this.x;
                        Graphics.TargetCamera.scrollY = this.y;
                        var texture;
                        var ctx;
                        var willRead = {
                            willReadFrequently: true
                        };
                        if (typeof key === 'string') {
                            if (sys.textures.exists(key)) {
                                //  Key is a string, it DOES exist in the Texture Manager AND is a canvas, so draw to it
                                texture = sys.textures.get(key);
                                var src = texture.getSourceImage();
                                if (src instanceof HTMLCanvasElement) ctx = src.getContext('2d', willRead);
                            } else {
                                //  Key is a string and doesn't exist in the Texture Manager, so generate and save it
                                texture = sys.textures.createCanvas(key, width, height);
                                ctx = texture.getSourceImage().getContext('2d', willRead);
                            }
                        } else if (key instanceof HTMLCanvasElement) //  Key is a Canvas, so draw to it
                        ctx = key.getContext('2d', willRead);
                        if (ctx) {
                            // var GraphicsCanvasRenderer = function (renderer, src, camera, parentMatrix, renderTargetCtx, allowClip)
                            this.renderCanvas(renderer, this, Graphics.TargetCamera, null, ctx, false);
                            if (texture) texture.refresh();
                        }
                        return this;
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Graphics#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                        this.commandBuffer = [];
                    }
                });
                /**
 * A Camera used specifically by the Graphics system for rendering to textures.
 *
 * @name Phaser.GameObjects.Graphics.TargetCamera
 * @type {Phaser.Cameras.Scene2D.Camera}
 * @since 3.1.0
 */ Graphics.TargetCamera = new BaseCamera();
                module1.exports = Graphics;
            /***/ },
            /***/ 32768: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Commands = __webpack_require__(85592);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Graphics#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Graphics} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 * @param {CanvasRenderingContext2D} [renderTargetCtx] - The target rendering context.
 * @param {boolean} allowClip - If `true` then path operations will be used instead of fill operations.
 */ var GraphicsCanvasRenderer = function(renderer, src, camera, parentMatrix, renderTargetCtx, allowClip) {
                    var commandBuffer = src.commandBuffer;
                    var commandBufferLength = commandBuffer.length;
                    var ctx = renderTargetCtx || renderer.currentContext;
                    if (commandBufferLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                    camera.addToRenderList(src);
                    var lineAlpha = 1;
                    var fillAlpha = 1;
                    var lineColor = 0;
                    var fillColor = 0;
                    var lineWidth = 1;
                    var red = 0;
                    var green = 0;
                    var blue = 0;
                    //  Reset any currently active paths
                    ctx.beginPath();
                    for(var index = 0; index < commandBufferLength; ++index){
                        var commandID = commandBuffer[index];
                        switch(commandID){
                            case Commands.ARC:
                                ctx.arc(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4], commandBuffer[index + 5], commandBuffer[index + 6]);
                                //  +7 because overshoot is the 7th value, not used in Canvas
                                index += 7;
                                break;
                            case Commands.LINE_STYLE:
                                lineWidth = commandBuffer[index + 1];
                                lineColor = commandBuffer[index + 2];
                                lineAlpha = commandBuffer[index + 3];
                                red = (lineColor & 0xFF0000) >>> 16;
                                green = (lineColor & 0xFF00) >>> 8;
                                blue = lineColor & 0xFF;
                                ctx.strokeStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + lineAlpha + ')';
                                ctx.lineWidth = lineWidth;
                                index += 3;
                                break;
                            case Commands.FILL_STYLE:
                                fillColor = commandBuffer[index + 1];
                                fillAlpha = commandBuffer[index + 2];
                                red = (fillColor & 0xFF0000) >>> 16;
                                green = (fillColor & 0xFF00) >>> 8;
                                blue = fillColor & 0xFF;
                                ctx.fillStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + fillAlpha + ')';
                                index += 2;
                                break;
                            case Commands.BEGIN_PATH:
                                ctx.beginPath();
                                break;
                            case Commands.CLOSE_PATH:
                                ctx.closePath();
                                break;
                            case Commands.FILL_PATH:
                                if (!allowClip) ctx.fill();
                                break;
                            case Commands.STROKE_PATH:
                                if (!allowClip) ctx.stroke();
                                break;
                            case Commands.FILL_RECT:
                                if (!allowClip) ctx.fillRect(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4]);
                                else ctx.rect(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4]);
                                index += 4;
                                break;
                            case Commands.FILL_TRIANGLE:
                                ctx.beginPath();
                                ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                                ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
                                ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
                                ctx.closePath();
                                if (!allowClip) ctx.fill();
                                index += 6;
                                break;
                            case Commands.STROKE_TRIANGLE:
                                ctx.beginPath();
                                ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                                ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
                                ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
                                ctx.closePath();
                                if (!allowClip) ctx.stroke();
                                index += 6;
                                break;
                            case Commands.LINE_TO:
                                ctx.lineTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                                index += 2;
                                break;
                            case Commands.MOVE_TO:
                                ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                                index += 2;
                                break;
                            case Commands.LINE_FX_TO:
                                ctx.lineTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                                index += 5;
                                break;
                            case Commands.MOVE_FX_TO:
                                ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                                index += 5;
                                break;
                            case Commands.SAVE:
                                ctx.save();
                                break;
                            case Commands.RESTORE:
                                ctx.restore();
                                break;
                            case Commands.TRANSLATE:
                                ctx.translate(commandBuffer[index + 1], commandBuffer[index + 2]);
                                index += 2;
                                break;
                            case Commands.SCALE:
                                ctx.scale(commandBuffer[index + 1], commandBuffer[index + 2]);
                                index += 2;
                                break;
                            case Commands.ROTATE:
                                ctx.rotate(commandBuffer[index + 1]);
                                index += 1;
                                break;
                            case Commands.GRADIENT_FILL_STYLE:
                                index += 5;
                                break;
                            case Commands.GRADIENT_LINE_STYLE:
                                index += 6;
                                break;
                        }
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                };
                module1.exports = GraphicsCanvasRenderer;
            /***/ },
            /***/ 87079: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(44603);
                var Graphics = __webpack_require__(43831);
                /**
 * Creates a new Graphics Game Object and returns it.
 *
 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#graphics
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Graphics.Options} [config] - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
 */ GameObjectCreator.register('graphics', function(config, addToScene) {
                    if (config === undefined) config = {};
                    if (addToScene !== undefined) config.add = addToScene;
                    var graphics = new Graphics(this.scene, config);
                    if (config.add) this.scene.sys.displayList.add(graphics);
                    return graphics;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 1201: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Graphics = __webpack_require__(43831);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Graphics Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#graphics
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Graphics.Options} [config] - The Graphics configuration.
 *
 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
 */ GameObjectFactory.register('graphics', function(config) {
                    return this.displayList.add(new Graphics(this.scene, config));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 84503: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(77545);
                //  Needed for Graphics.generateTexture
                renderCanvas = __webpack_require__(32768);
                renderCanvas = __webpack_require__(32768);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 77545: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Commands = __webpack_require__(85592);
                var GetCalcMatrix = __webpack_require__(91296);
                var TransformMatrix = __webpack_require__(61340);
                var Utils = __webpack_require__(70554);
                var Point = function(x, y, width) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                };
                var Path = function(x, y, width) {
                    this.points = [];
                    this.pointsLength = 1;
                    this.points[0] = new Point(x, y, width);
                };
                var matrixStack = [];
                var tempMatrix = new TransformMatrix();
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Graphics#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Graphics} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GraphicsWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    if (src.commandBuffer.length === 0) return;
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    renderer.pipelines.preBatch(src);
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    var currentMatrix = tempMatrix.loadIdentity();
                    var commands = src.commandBuffer;
                    var alpha = camera.alpha * src.alpha;
                    var lineWidth = 1;
                    var fillTint = pipeline.fillTint;
                    var strokeTint = pipeline.strokeTint;
                    var tx = 0;
                    var ty = 0;
                    var ta = 0;
                    var iterStep = 0.01;
                    var PI2 = Math.PI * 2;
                    var cmd;
                    var path = [];
                    var pathIndex = 0;
                    var pathOpen = true;
                    var lastPath = null;
                    var getTint = Utils.getTintAppendFloatAlpha;
                    for(var cmdIndex = 0; cmdIndex < commands.length; cmdIndex++){
                        cmd = commands[cmdIndex];
                        switch(cmd){
                            case Commands.BEGIN_PATH:
                                path.length = 0;
                                lastPath = null;
                                pathOpen = true;
                                break;
                            case Commands.CLOSE_PATH:
                                pathOpen = false;
                                if (lastPath && lastPath.points.length) lastPath.points.push(lastPath.points[0]);
                                break;
                            case Commands.FILL_PATH:
                                for(pathIndex = 0; pathIndex < path.length; pathIndex++)pipeline.batchFillPath(path[pathIndex].points, currentMatrix, calcMatrix);
                                break;
                            case Commands.STROKE_PATH:
                                for(pathIndex = 0; pathIndex < path.length; pathIndex++)pipeline.batchStrokePath(path[pathIndex].points, lineWidth, pathOpen, currentMatrix, calcMatrix);
                                break;
                            case Commands.LINE_STYLE:
                                lineWidth = commands[++cmdIndex];
                                var strokeColor = commands[++cmdIndex];
                                var strokeAlpha = commands[++cmdIndex] * alpha;
                                var strokeTintColor = getTint(strokeColor, strokeAlpha);
                                strokeTint.TL = strokeTintColor;
                                strokeTint.TR = strokeTintColor;
                                strokeTint.BL = strokeTintColor;
                                strokeTint.BR = strokeTintColor;
                                break;
                            case Commands.FILL_STYLE:
                                var fillColor = commands[++cmdIndex];
                                var fillAlpha = commands[++cmdIndex] * alpha;
                                var fillTintColor = getTint(fillColor, fillAlpha);
                                fillTint.TL = fillTintColor;
                                fillTint.TR = fillTintColor;
                                fillTint.BL = fillTintColor;
                                fillTint.BR = fillTintColor;
                                break;
                            case Commands.GRADIENT_FILL_STYLE:
                                var alphaTL = commands[++cmdIndex] * alpha;
                                var alphaTR = commands[++cmdIndex] * alpha;
                                var alphaBL = commands[++cmdIndex] * alpha;
                                var alphaBR = commands[++cmdIndex] * alpha;
                                fillTint.TL = getTint(commands[++cmdIndex], alphaTL);
                                fillTint.TR = getTint(commands[++cmdIndex], alphaTR);
                                fillTint.BL = getTint(commands[++cmdIndex], alphaBL);
                                fillTint.BR = getTint(commands[++cmdIndex], alphaBR);
                                break;
                            case Commands.GRADIENT_LINE_STYLE:
                                lineWidth = commands[++cmdIndex];
                                var gradientLineAlpha = commands[++cmdIndex] * alpha;
                                strokeTint.TL = getTint(commands[++cmdIndex], gradientLineAlpha);
                                strokeTint.TR = getTint(commands[++cmdIndex], gradientLineAlpha);
                                strokeTint.BL = getTint(commands[++cmdIndex], gradientLineAlpha);
                                strokeTint.BR = getTint(commands[++cmdIndex], gradientLineAlpha);
                                break;
                            case Commands.ARC:
                                var iteration = 0;
                                var x = commands[++cmdIndex];
                                var y = commands[++cmdIndex];
                                var radius = commands[++cmdIndex];
                                var startAngle = commands[++cmdIndex];
                                var endAngle = commands[++cmdIndex];
                                var anticlockwise = commands[++cmdIndex];
                                var overshoot = commands[++cmdIndex];
                                endAngle -= startAngle;
                                if (anticlockwise) {
                                    if (endAngle < -PI2) endAngle = -PI2;
                                    else if (endAngle > 0) endAngle = -PI2 + endAngle % PI2;
                                } else if (endAngle > PI2) endAngle = PI2;
                                else if (endAngle < 0) endAngle = PI2 + endAngle % PI2;
                                if (lastPath === null) {
                                    lastPath = new Path(x + Math.cos(startAngle) * radius, y + Math.sin(startAngle) * radius, lineWidth);
                                    path.push(lastPath);
                                    iteration += iterStep;
                                }
                                while(iteration < 1 + overshoot){
                                    ta = endAngle * iteration + startAngle;
                                    tx = x + Math.cos(ta) * radius;
                                    ty = y + Math.sin(ta) * radius;
                                    lastPath.points.push(new Point(tx, ty, lineWidth));
                                    iteration += iterStep;
                                }
                                ta = endAngle + startAngle;
                                tx = x + Math.cos(ta) * radius;
                                ty = y + Math.sin(ta) * radius;
                                lastPath.points.push(new Point(tx, ty, lineWidth));
                                break;
                            case Commands.FILL_RECT:
                                pipeline.batchFillRect(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], currentMatrix, calcMatrix);
                                break;
                            case Commands.FILL_TRIANGLE:
                                pipeline.batchFillTriangle(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], currentMatrix, calcMatrix);
                                break;
                            case Commands.STROKE_TRIANGLE:
                                pipeline.batchStrokeTriangle(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], lineWidth, currentMatrix, calcMatrix);
                                break;
                            case Commands.LINE_TO:
                                if (lastPath !== null) lastPath.points.push(new Point(commands[++cmdIndex], commands[++cmdIndex], lineWidth));
                                else {
                                    lastPath = new Path(commands[++cmdIndex], commands[++cmdIndex], lineWidth);
                                    path.push(lastPath);
                                }
                                break;
                            case Commands.MOVE_TO:
                                lastPath = new Path(commands[++cmdIndex], commands[++cmdIndex], lineWidth);
                                path.push(lastPath);
                                break;
                            case Commands.SAVE:
                                matrixStack.push(currentMatrix.copyToArray());
                                break;
                            case Commands.RESTORE:
                                currentMatrix.copyFromArray(matrixStack.pop());
                                break;
                            case Commands.TRANSLATE:
                                x = commands[++cmdIndex];
                                y = commands[++cmdIndex];
                                currentMatrix.translate(x, y);
                                break;
                            case Commands.SCALE:
                                x = commands[++cmdIndex];
                                y = commands[++cmdIndex];
                                currentMatrix.scale(x, y);
                                break;
                            case Commands.ROTATE:
                                currentMatrix.rotate(commands[++cmdIndex]);
                                break;
                        }
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = GraphicsWebGLRenderer;
            /***/ },
            /***/ 26479: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Actions = __webpack_require__(61061);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(51708);
                var EventEmitter = __webpack_require__(50792);
                var GetAll = __webpack_require__(46710);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var HasValue = __webpack_require__(97022);
                var IsPlainObject = __webpack_require__(41212);
                var Range = __webpack_require__(88492);
                var Set = __webpack_require__(35072);
                var Sprite = __webpack_require__(68287);
                /**
 * @classdesc
 * A Group is a way for you to create, manipulate, or recycle similar Game Objects.
 *
 * Group membership is non-exclusive. A Game Object can belong to several groups, one group, or none.
 *
 * Groups themselves aren't displayable, and can't be positioned, rotated, scaled, or hidden.
 *
 * @class Group
 * @memberof Phaser.GameObjects
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group. If `key` is set, Phaser.GameObjects.Group#createMultiple is also called with these settings.
 *
 * @see Phaser.Physics.Arcade.Group
 * @see Phaser.Physics.Arcade.StaticGroup
 */ var Group = new Class({
                    Extends: EventEmitter,
                    initialize: function Group(scene, children, config) {
                        EventEmitter.call(this);
                        //  They can pass in any of the following as the first argument:
                        //  1) A single child
                        //  2) An array of children
                        //  3) A config object
                        //  4) An array of config objects
                        //  Or they can pass in a child, or array of children AND a config object
                        if (config) //  config has been set, are the children an array?
                        {
                            if (children && !Array.isArray(children)) children = [
                                children
                            ];
                        } else if (Array.isArray(children)) //  No config, so let's check the children argument
                        {
                            if (IsPlainObject(children[0])) {
                                //  It's an array of plain config objects
                                config = children;
                                children = null;
                            }
                        } else if (IsPlainObject(children)) {
                            //  Children isn't an array. Is it a config object though?
                            config = children;
                            children = null;
                        }
                        /**
         * This scene this group belongs to.
         *
         * @name Phaser.GameObjects.Group#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * Members of this group.
         *
         * @name Phaser.GameObjects.Group#children
         * @type {Phaser.Structs.Set.<Phaser.GameObjects.GameObject>}
         * @since 3.0.0
         */ this.children = new Set();
                        /**
         * A flag identifying this object as a group.
         *
         * @name Phaser.GameObjects.Group#isParent
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isParent = true;
                        /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.Group#type
         * @type {string}
         * @default 'Group'
         * @since 3.21.0
         */ this.type = 'Group';
                        /**
         * The class to create new group members from.
         *
         * @name Phaser.GameObjects.Group#classType
         * @type {function}
         * @since 3.0.0
         * @default Phaser.GameObjects.Sprite
         * @see Phaser.Types.GameObjects.Group.GroupClassTypeConstructor
         */ this.classType = GetFastValue(config, 'classType', Sprite);
                        /**
         * The name of this group.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Group#name
         * @type {string}
         * @default ''
         * @since 3.18.0
         */ this.name = GetFastValue(config, 'name', '');
                        /**
         * Whether this group runs its {@link Phaser.GameObjects.Group#preUpdate} method (which may update any members).
         *
         * @name Phaser.GameObjects.Group#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = GetFastValue(config, 'active', true);
                        /**
         * The maximum size of this group, if used as a pool. -1 is no limit.
         *
         * @name Phaser.GameObjects.Group#maxSize
         * @type {number}
         * @since 3.0.0
         * @default -1
         */ this.maxSize = GetFastValue(config, 'maxSize', -1);
                        /**
         * A default texture key to use when creating new group members.
         *
         * This is used in {@link Phaser.GameObjects.Group#create}
         * but not in {@link Phaser.GameObjects.Group#createMultiple}.
         *
         * @name Phaser.GameObjects.Group#defaultKey
         * @type {string}
         * @since 3.0.0
         */ this.defaultKey = GetFastValue(config, 'defaultKey', null);
                        /**
         * A default texture frame to use when creating new group members.
         *
         * @name Phaser.GameObjects.Group#defaultFrame
         * @type {(string|number)}
         * @since 3.0.0
         */ this.defaultFrame = GetFastValue(config, 'defaultFrame', null);
                        /**
         * Whether to call the update method of any members.
         *
         * @name Phaser.GameObjects.Group#runChildUpdate
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Group#preUpdate
         */ this.runChildUpdate = GetFastValue(config, 'runChildUpdate', false);
                        /**
         * A function to be called when adding or creating group members.
         *
         * @name Phaser.GameObjects.Group#createCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @since 3.0.0
         */ this.createCallback = GetFastValue(config, 'createCallback', null);
                        /**
         * A function to be called when removing group members.
         *
         * @name Phaser.GameObjects.Group#removeCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @since 3.0.0
         */ this.removeCallback = GetFastValue(config, 'removeCallback', null);
                        /**
         * A function to be called when creating several group members at once.
         *
         * @name Phaser.GameObjects.Group#createMultipleCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupMultipleCreateCallback}
         * @since 3.0.0
         */ this.createMultipleCallback = GetFastValue(config, 'createMultipleCallback', null);
                        /**
         * A function to be called when adding or creating group members.
         * For internal use only by a Group, or any class that extends it.
         *
         * @name Phaser.GameObjects.Group#internalCreateCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @private
         * @since 3.22.0
         */ this.internalCreateCallback = GetFastValue(config, 'internalCreateCallback', null);
                        /**
         * A function to be called when removing group members.
         * For internal use only by a Group, or any class that extends it.
         *
         * @name Phaser.GameObjects.Group#internalRemoveCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @private
         * @since 3.22.0
         */ this.internalRemoveCallback = GetFastValue(config, 'internalRemoveCallback', null);
                        if (children) this.addMultiple(children);
                        if (config) this.createMultiple(config);
                        this.on(Events.ADDED_TO_SCENE, this.addedToScene, this);
                        this.on(Events.REMOVED_FROM_SCENE, this.removedFromScene, this);
                    },
                    //  Overrides Game Object method
                    addedToScene: function() {
                        this.scene.sys.updateList.add(this);
                    },
                    //  Overrides Game Object method
                    removedFromScene: function() {
                        this.scene.sys.updateList.remove(this);
                    },
                    /**
     * Creates a new Game Object and adds it to this group, unless the group {@link Phaser.GameObjects.Group#isFull is full}.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#create
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the new Game Object in the world.
     * @param {number} [y=0] - The vertical position of the new Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key of the new Game Object.
     * @param {(string|number)} [frame=defaultFrame] - The texture frame of the new Game Object.
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of the new Game Object.
     * @param {boolean} [active=true] - The {@link Phaser.GameObjects.GameObject#active} state of the new Game Object.
     *
     * @return {any} The new Game Object (usually a Sprite, etc.).
     */ create: function(x, y, key, frame, visible, active) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (key === undefined) key = this.defaultKey;
                        if (frame === undefined) frame = this.defaultFrame;
                        if (visible === undefined) visible = true;
                        if (active === undefined) active = true;
                        //  Pool?
                        if (this.isFull()) return null;
                        var child = new this.classType(this.scene, x, y, key, frame);
                        child.addToDisplayList(this.scene.sys.displayList);
                        child.addToUpdateList();
                        child.visible = visible;
                        child.setActive(active);
                        this.add(child);
                        return child;
                    },
                    /**
     * Creates several Game Objects and adds them to this group.
     *
     * If the group becomes {@link Phaser.GameObjects.Group#isFull}, no further Game Objects are created.
     *
     * Calls {@link Phaser.GameObjects.Group#createMultipleCallback} and {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#createMultiple
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Group.GroupCreateConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig[]} config - Creation settings. This can be a single configuration object or an array of such objects, which will be applied in turn.
     *
     * @return {any[]} The newly created Game Objects.
     */ createMultiple: function(config) {
                        if (this.isFull()) return [];
                        if (!Array.isArray(config)) config = [
                            config
                        ];
                        var output = [];
                        if (config[0].key) for(var i = 0; i < config.length; i++){
                            var entries = this.createFromConfig(config[i]);
                            output = output.concat(entries);
                        }
                        return output;
                    },
                    /**
     * A helper for {@link Phaser.GameObjects.Group#createMultiple}.
     *
     * @method Phaser.GameObjects.Group#createFromConfig
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Group.GroupCreateConfig} options - Creation settings.
     *
     * @return {any[]} The newly created Game Objects.
     */ createFromConfig: function(options) {
                        if (this.isFull()) return [];
                        this.classType = GetFastValue(options, 'classType', this.classType);
                        var key = GetFastValue(options, 'key', undefined);
                        var frame = GetFastValue(options, 'frame', null);
                        var visible = GetFastValue(options, 'visible', true);
                        var active = GetFastValue(options, 'active', true);
                        var entries = [];
                        //  Can't do anything without at least a key
                        if (key === undefined) return entries;
                        else {
                            if (!Array.isArray(key)) key = [
                                key
                            ];
                            if (!Array.isArray(frame)) frame = [
                                frame
                            ];
                        }
                        //  Build an array of key frame pairs to loop through
                        var repeat = GetFastValue(options, 'repeat', 0);
                        var randomKey = GetFastValue(options, 'randomKey', false);
                        var randomFrame = GetFastValue(options, 'randomFrame', false);
                        var yoyo = GetFastValue(options, 'yoyo', false);
                        var quantity = GetFastValue(options, 'quantity', false);
                        var frameQuantity = GetFastValue(options, 'frameQuantity', 1);
                        var max = GetFastValue(options, 'max', 0);
                        //  If a quantity value is set we use that to override the frameQuantity
                        var range = Range(key, frame, {
                            max: max,
                            qty: quantity ? quantity : frameQuantity,
                            random: randomKey,
                            randomB: randomFrame,
                            repeat: repeat,
                            yoyo: yoyo
                        });
                        if (options.createCallback) this.createCallback = options.createCallback;
                        if (options.removeCallback) this.removeCallback = options.removeCallback;
                        if (options.internalCreateCallback) this.internalCreateCallback = options.internalCreateCallback;
                        if (options.internalRemoveCallback) this.internalRemoveCallback = options.internalRemoveCallback;
                        for(var c = 0; c < range.length; c++){
                            var created = this.create(0, 0, range[c].a, range[c].b, visible, active);
                            if (!created) break;
                            entries.push(created);
                        }
                        //  Post-creation options (applied only to those items created in this call):
                        if (HasValue(options, 'setXY')) {
                            var x = GetValue(options, 'setXY.x', 0);
                            var y = GetValue(options, 'setXY.y', 0);
                            var stepX = GetValue(options, 'setXY.stepX', 0);
                            var stepY = GetValue(options, 'setXY.stepY', 0);
                            Actions.SetXY(entries, x, y, stepX, stepY);
                        }
                        if (HasValue(options, 'setRotation')) {
                            var rotation = GetValue(options, 'setRotation.value', 0);
                            var stepRotation = GetValue(options, 'setRotation.step', 0);
                            Actions.SetRotation(entries, rotation, stepRotation);
                        }
                        if (HasValue(options, 'setScale')) {
                            var scaleX = GetValue(options, 'setScale.x', 1);
                            var scaleY = GetValue(options, 'setScale.y', scaleX);
                            var stepScaleX = GetValue(options, 'setScale.stepX', 0);
                            var stepScaleY = GetValue(options, 'setScale.stepY', 0);
                            Actions.SetScale(entries, scaleX, scaleY, stepScaleX, stepScaleY);
                        }
                        if (HasValue(options, 'setOrigin')) {
                            var originX = GetValue(options, 'setOrigin.x', 0.5);
                            var originY = GetValue(options, 'setOrigin.y', originX);
                            var stepOriginX = GetValue(options, 'setOrigin.stepX', 0);
                            var stepOriginY = GetValue(options, 'setOrigin.stepY', 0);
                            Actions.SetOrigin(entries, originX, originY, stepOriginX, stepOriginY);
                        }
                        if (HasValue(options, 'setAlpha')) {
                            var alpha = GetValue(options, 'setAlpha.value', 1);
                            var stepAlpha = GetValue(options, 'setAlpha.step', 0);
                            Actions.SetAlpha(entries, alpha, stepAlpha);
                        }
                        if (HasValue(options, 'setDepth')) {
                            var depth = GetValue(options, 'setDepth.value', 0);
                            var stepDepth = GetValue(options, 'setDepth.step', 0);
                            Actions.SetDepth(entries, depth, stepDepth);
                        }
                        if (HasValue(options, 'setScrollFactor')) {
                            var scrollFactorX = GetValue(options, 'setScrollFactor.x', 1);
                            var scrollFactorY = GetValue(options, 'setScrollFactor.y', scrollFactorX);
                            var stepScrollFactorX = GetValue(options, 'setScrollFactor.stepX', 0);
                            var stepScrollFactorY = GetValue(options, 'setScrollFactor.stepY', 0);
                            Actions.SetScrollFactor(entries, scrollFactorX, scrollFactorY, stepScrollFactorX, stepScrollFactorY);
                        }
                        var hitArea = GetFastValue(options, 'hitArea', null);
                        var hitAreaCallback = GetFastValue(options, 'hitAreaCallback', null);
                        if (hitArea) Actions.SetHitArea(entries, hitArea, hitAreaCallback);
                        var grid = GetFastValue(options, 'gridAlign', false);
                        if (grid) Actions.GridAlign(entries, grid);
                        if (this.createMultipleCallback) this.createMultipleCallback.call(this, entries);
                        return entries;
                    },
                    /**
     * Updates any group members, if {@link Phaser.GameObjects.Group#runChildUpdate} is enabled.
     *
     * @method Phaser.GameObjects.Group#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                        if (!this.runChildUpdate || this.children.size === 0) return;
                        //  Because a Group child may mess with the length of the Group during its update
                        var temp = this.children.entries.slice();
                        for(var i = 0; i < temp.length; i++){
                            var item = temp[i];
                            if (item.active) item.update(time, delta);
                        }
                    },
                    /**
     * Adds a Game Object to this group.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#add
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
     * @param {boolean} [addToScene=false] - Also add the Game Object to the scene.
     *
     * @return {this} This Group object.
     */ add: function(child, addToScene) {
                        if (addToScene === undefined) addToScene = false;
                        if (this.isFull()) return this;
                        this.children.set(child);
                        if (this.internalCreateCallback) this.internalCreateCallback.call(this, child);
                        if (this.createCallback) this.createCallback.call(this, child);
                        if (addToScene) {
                            child.addToDisplayList(this.scene.sys.displayList);
                            child.addToUpdateList();
                        }
                        child.on(Events.DESTROY, this.remove, this);
                        return this;
                    },
                    /**
     * Adds several Game Objects to this group.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#addMultiple
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} children - The Game Objects to add.
     * @param {boolean} [addToScene=false] - Also add the Game Objects to the scene.
     *
     * @return {this} This group.
     */ addMultiple: function(children, addToScene) {
                        if (addToScene === undefined) addToScene = false;
                        if (Array.isArray(children)) for(var i = 0; i < children.length; i++)this.add(children[i], addToScene);
                        return this;
                    },
                    /**
     * Removes a member of this Group and optionally removes it from the Scene and / or destroys it.
     *
     * Calls {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * @method Phaser.GameObjects.Group#remove
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
     * @param {boolean} [removeFromScene=false] - Optionally remove the Group member from the Scene it belongs to.
     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group member.
     *
     * @return {this} This Group object.
     */ remove: function(child, removeFromScene, destroyChild) {
                        if (removeFromScene === undefined) removeFromScene = false;
                        if (destroyChild === undefined) destroyChild = false;
                        if (!this.children.contains(child)) return this;
                        this.children.delete(child);
                        if (this.internalRemoveCallback) this.internalRemoveCallback.call(this, child);
                        if (this.removeCallback) this.removeCallback.call(this, child);
                        child.off(Events.DESTROY, this.remove, this);
                        if (destroyChild) child.destroy();
                        else if (removeFromScene) {
                            child.removeFromDisplayList();
                            child.removeFromUpdateList();
                        }
                        return this;
                    },
                    /**
     * Removes all members of this Group and optionally removes them from the Scene and / or destroys them.
     *
     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * @method Phaser.GameObjects.Group#clear
     * @since 3.0.0
     *
     * @param {boolean} [removeFromScene=false] - Optionally remove each Group member from the Scene.
     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group members.
     *
     * @return {this} This group.
     */ clear: function(removeFromScene, destroyChild) {
                        if (removeFromScene === undefined) removeFromScene = false;
                        if (destroyChild === undefined) destroyChild = false;
                        var children = this.children;
                        for(var i = 0; i < children.size; i++){
                            var gameObject = children.entries[i];
                            gameObject.off(Events.DESTROY, this.remove, this);
                            if (destroyChild) gameObject.destroy();
                            else if (removeFromScene) {
                                gameObject.removeFromDisplayList();
                                gameObject.removeFromUpdateList();
                            }
                        }
                        this.children.clear();
                        return this;
                    },
                    /**
     * Tests if a Game Object is a member of this group.
     *
     * @method Phaser.GameObjects.Group#contains
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - A Game Object.
     *
     * @return {boolean} True if the Game Object is a member of this group.
     */ contains: function(child) {
                        return this.children.contains(child);
                    },
                    /**
     * All members of the group.
     *
     * @method Phaser.GameObjects.Group#getChildren
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                        return this.children.entries;
                    },
                    /**
     * The number of members of the group.
     *
     * @method Phaser.GameObjects.Group#getLength
     * @since 3.0.0
     *
     * @return {number}
     */ getLength: function() {
                        return this.children.size;
                    },
                    /**
     * Returns all children in this Group that match the given criteria based on the `property` and `value` arguments.
     *
     * For example: `getMatching('visible', true)` would return only children that have their `visible` property set.
     *
     * Optionally, you can specify a start and end index. For example if the Group has 100 elements,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50.
     *
     * @method Phaser.GameObjects.Group#getMatching
     * @since 3.50.0
     *
     * @param {string} [property] - The property to test on each array element.
     * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
     * @param {number} [startIndex] - An optional start index to search from.
     * @param {number} [endIndex] - An optional end index to search to.
     *
     * @return {any[]} An array of matching Group members. The array will be empty if nothing matched.
     */ getMatching: function(property, value, startIndex, endIndex) {
                        return GetAll(this.children.entries, property, value, startIndex, endIndex);
                    },
                    /**
     * Scans the Group, from top to bottom, for the first member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirst
     * @since 3.0.0
     *
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getFirst: function(state, createIfNull, x, y, key, frame, visible) {
                        return this.getHandler(true, 1, state, createIfNull, x, y, key, frame, visible);
                    },
                    /**
     * Scans the Group, from top to bottom, for the nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstNth
     * @since 3.6.0
     *
     * @param {number} nth - The nth matching Group member to search for.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getFirstNth: function(nth, state, createIfNull, x, y, key, frame, visible) {
                        return this.getHandler(true, nth, state, createIfNull, x, y, key, frame, visible);
                    },
                    /**
     * Scans the Group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getLast
     * @since 3.6.0
     *
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getLast: function(state, createIfNull, x, y, key, frame, visible) {
                        return this.getHandler(false, 1, state, createIfNull, x, y, key, frame, visible);
                    },
                    /**
     * Scans the Group for the last nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getLastNth
     * @since 3.6.0
     *
     * @param {number} nth - The nth matching Group member to search for.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getLastNth: function(nth, state, createIfNull, x, y, key, frame, visible) {
                        return this.getHandler(false, nth, state, createIfNull, x, y, key, frame, visible);
                    },
                    /**
     * Scans the group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getHandler
     * @private
     * @since 3.6.0
     *
     * @param {boolean} forwards - Search front to back or back to front?
     * @param {number} nth - Stop matching after nth successful matches.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getHandler: function(forwards, nth, state, createIfNull, x, y, key, frame, visible) {
                        if (state === undefined) state = false;
                        if (createIfNull === undefined) createIfNull = false;
                        var gameObject;
                        var i;
                        var total = 0;
                        var children = this.children.entries;
                        if (forwards) for(i = 0; i < children.length; i++){
                            gameObject = children[i];
                            if (gameObject.active === state) {
                                total++;
                                if (total === nth) break;
                            } else gameObject = null;
                        }
                        else for(i = children.length - 1; i >= 0; i--){
                            gameObject = children[i];
                            if (gameObject.active === state) {
                                total++;
                                if (total === nth) break;
                            } else gameObject = null;
                        }
                        if (gameObject) {
                            if (typeof x === 'number') gameObject.x = x;
                            if (typeof y === 'number') gameObject.y = y;
                            return gameObject;
                        }
                        //  Got this far? We need to create or bail
                        if (createIfNull) return this.create(x, y, key, frame, visible);
                        else return null;
                    },
                    /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no inactive member is found and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * The new Game Object will have its active state set to `true`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#get
     * @since 3.0.0
     *
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first inactive group member, or a newly created member, or null.
     */ get: function(x, y, key, frame, visible) {
                        return this.getFirst(false, true, x, y, key, frame, visible);
                    },
                    /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `true`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no active member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstAlive
     * @since 3.0.0
     *
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {any} The first active group member, or a newly created member, or null.
     */ getFirstAlive: function(createIfNull, x, y, key, frame, visible) {
                        return this.getFirst(true, createIfNull, x, y, key, frame, visible);
                    },
                    /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no inactive member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
     * The new Game Object will have an active state set to `true`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstDead
     * @since 3.0.0
     *
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {any} The first inactive group member, or a newly created member, or null.
     */ getFirstDead: function(createIfNull, x, y, key, frame, visible) {
                        return this.getFirst(false, createIfNull, x, y, key, frame, visible);
                    },
                    /**
     * {@link Phaser.Animations.AnimationState#play Plays} an animation for all members of this group.
     *
     * @method Phaser.GameObjects.Group#playAnimation
     * @since 3.0.0
     *
     * @param {string} key - The string-based key of the animation to play.
     * @param {string} [startFrame=0] - Optionally start the animation playing from this frame index.
     *
     * @return {this} This Group object.
     */ playAnimation: function(key, startFrame) {
                        Actions.PlayAnimation(this.children.entries, key, startFrame);
                        return this;
                    },
                    /**
     * Whether this group's size at its {@link Phaser.GameObjects.Group#maxSize maximum}.
     *
     * @method Phaser.GameObjects.Group#isFull
     * @since 3.0.0
     *
     * @return {boolean} True if the number of members equals {@link Phaser.GameObjects.Group#maxSize}.
     */ isFull: function() {
                        if (this.maxSize === -1) return false;
                        else return this.children.size >= this.maxSize;
                    },
                    /**
     * Counts the number of active (or inactive) group members.
     *
     * @method Phaser.GameObjects.Group#countActive
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Count active (true) or inactive (false) group members.
     *
     * @return {number} The number of group members with an active state matching the `active` argument.
     */ countActive: function(value) {
                        if (value === undefined) value = true;
                        var total = 0;
                        for(var i = 0; i < this.children.size; i++)if (this.children.entries[i].active === value) total++;
                        return total;
                    },
                    /**
     * Counts the number of in-use (active) group members.
     *
     * @method Phaser.GameObjects.Group#getTotalUsed
     * @since 3.0.0
     *
     * @return {number} The number of group members with an active state of true.
     */ getTotalUsed: function() {
                        return this.countActive();
                    },
                    /**
     * The difference of {@link Phaser.GameObjects.Group#maxSize} and the number of active group members.
     *
     * This represents the number of group members that could be created or reactivated before reaching the size limit.
     *
     * @method Phaser.GameObjects.Group#getTotalFree
     * @since 3.0.0
     *
     * @return {number} maxSize minus the number of active group numbers; or a large number (if maxSize is -1).
     */ getTotalFree: function() {
                        var used = this.getTotalUsed();
                        var capacity = this.maxSize === -1 ? 999999999999 : this.maxSize;
                        return capacity - used;
                    },
                    /**
     * Sets the `active` property of this Group.
     * When active, this Group runs its `preUpdate` method.
     *
     * @method Phaser.GameObjects.Group#setActive
     * @since 3.24.0
     *
     * @param {boolean} value - True if this Group should be set as active, false if not.
     *
     * @return {this} This Group object.
     */ setActive: function(value) {
                        this.active = value;
                        return this;
                    },
                    /**
     * Sets the `name` property of this Group.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.Group#setName
     * @since 3.24.0
     *
     * @param {string} value - The name to be given to this Group.
     *
     * @return {this} This Group object.
     */ setName: function(value) {
                        this.name = value;
                        return this;
                    },
                    /**
     * Sets the property as defined in `key` of each group member to the given value.
     *
     * @method Phaser.GameObjects.Group#propertyValueSet
     * @since 3.21.0
     *
     * @param {string} key - The property to be updated.
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ propertyValueSet: function(key, value, step, index, direction) {
                        Actions.PropertyValueSet(this.children.entries, key, value, step, index, direction);
                        return this;
                    },
                    /**
     * Adds the given value to the property as defined in `key` of each group member.
     *
     * @method Phaser.GameObjects.Group#propertyValueInc
     * @since 3.21.0
     *
     * @param {string} key - The property to be updated.
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ propertyValueInc: function(key, value, step, index, direction) {
                        Actions.PropertyValueInc(this.children.entries, key, value, step, index, direction);
                        return this;
                    },
                    /**
     * Sets the x of each group member.
     *
     * @method Phaser.GameObjects.Group#setX
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setX: function(value, step) {
                        Actions.SetX(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Sets the y of each group member.
     *
     * @method Phaser.GameObjects.Group#setY
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setY: function(value, step) {
                        Actions.SetY(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Sets the x, y of each group member.
     *
     * @method Phaser.GameObjects.Group#setXY
     * @since 3.21.0
     *
     * @param {number} x - The amount to set the `x` property to.
     * @param {number} [y=x] - The amount to set the `y` property to. If `undefined` or `null` it uses the `x` value.
     * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setXY: function(x, y, stepX, stepY) {
                        Actions.SetXY(this.children.entries, x, y, stepX, stepY);
                        return this;
                    },
                    /**
     * Adds the given value to the x of each group member.
     *
     * @method Phaser.GameObjects.Group#incX
     * @since 3.21.0
     *
     * @param {number} value - The amount to be added to the `x` property.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incX: function(value, step) {
                        Actions.IncX(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Adds the given value to the y of each group member.
     *
     * @method Phaser.GameObjects.Group#incY
     * @since 3.21.0
     *
     * @param {number} value - The amount to be added to the `y` property.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incY: function(value, step) {
                        Actions.IncY(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Adds the given value to the x, y of each group member.
     *
     * @method Phaser.GameObjects.Group#incXY
     * @since 3.21.0
     *
     * @param {number} x - The amount to be added to the `x` property.
     * @param {number} [y=x] - The amount to be added to the `y` property. If `undefined` or `null` it uses the `x` value.
     * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incXY: function(x, y, stepX, stepY) {
                        Actions.IncXY(this.children.entries, x, y, stepX, stepY);
                        return this;
                    },
                    /**
     * Iterate through the group members changing the position of each element to be that of the element that came before
     * it in the array (or after it if direction = 1)
     *
     * The first group member position is set to x/y.
     *
     * @method Phaser.GameObjects.Group#shiftPosition
     * @since 3.21.0
     *
     * @param {number} x - The x coordinate to place the first item in the array at.
     * @param {number} y - The y coordinate to place the first item in the array at.
     * @param {number} [direction=0] - The iteration direction. 0 = first to last and 1 = last to first.
     *
     * @return {this} This Group object.
     */ shiftPosition: function(x, y, direction) {
                        Actions.ShiftPosition(this.children.entries, x, y, direction);
                        return this;
                    },
                    /**
     * Sets the angle of each group member.
     *
     * @method Phaser.GameObjects.Group#angle
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the angle to, in degrees.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ angle: function(value, step) {
                        Actions.Angle(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Sets the rotation of each group member.
     *
     * @method Phaser.GameObjects.Group#rotate
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the rotation to, in radians.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ rotate: function(value, step) {
                        Actions.Rotate(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Rotates each group member around the given point by the given angle.
     *
     * @method Phaser.GameObjects.Group#rotateAround
     * @since 3.21.0
     *
     * @param {Phaser.Types.Math.Vector2Like} point - Any object with public `x` and `y` properties.
     * @param {number} angle - The angle to rotate by, in radians.
     *
     * @return {this} This Group object.
     */ rotateAround: function(point, angle) {
                        Actions.RotateAround(this.children.entries, point, angle);
                        return this;
                    },
                    /**
     * Rotates each group member around the given point by the given angle and distance.
     *
     * @method Phaser.GameObjects.Group#rotateAroundDistance
     * @since 3.21.0
     *
     * @param {Phaser.Types.Math.Vector2Like} point - Any object with public `x` and `y` properties.
     * @param {number} angle - The angle to rotate by, in radians.
     * @param {number} distance - The distance from the point of rotation in pixels.
     *
     * @return {this} This Group object.
     */ rotateAroundDistance: function(point, angle, distance) {
                        Actions.RotateAroundDistance(this.children.entries, point, angle, distance);
                        return this;
                    },
                    /**
     * Sets the alpha of each group member.
     *
     * @method Phaser.GameObjects.Group#setAlpha
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the alpha to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setAlpha: function(value, step) {
                        Actions.SetAlpha(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Sets the tint of each group member.
     *
     * @method Phaser.GameObjects.Group#setTint
     * @since 3.21.0
     *
     * @param {number} topLeft - The tint being applied to top-left corner of item. If other parameters are given no value, this tint will be applied to whole item.
     * @param {number} [topRight] - The tint to be applied to top-right corner of item.
     * @param {number} [bottomLeft] - The tint to be applied to the bottom-left corner of item.
     * @param {number} [bottomRight] - The tint to be applied to the bottom-right corner of item.
     *
     * @return {this} This Group object.
     */ setTint: function(topLeft, topRight, bottomLeft, bottomRight) {
                        Actions.SetTint(this.children.entries, topLeft, topRight, bottomLeft, bottomRight);
                        return this;
                    },
                    /**
     * Sets the originX, originY of each group member.
     *
     * @method Phaser.GameObjects.Group#setOrigin
     * @since 3.21.0
     *
     * @param {number} originX - The amount to set the `originX` property to.
     * @param {number} [originY] - The amount to set the `originY` property to. If `undefined` or `null` it uses the `originX` value.
     * @param {number} [stepX=0] - This is added to the `originX` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `originY` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setOrigin: function(originX, originY, stepX, stepY) {
                        Actions.SetOrigin(this.children.entries, originX, originY, stepX, stepY);
                        return this;
                    },
                    /**
     * Sets the scaleX of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleX
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleX: function(value, step) {
                        Actions.ScaleX(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Sets the scaleY of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleY
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleY: function(value, step) {
                        Actions.ScaleY(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Sets the scaleX, scaleY of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleXY
     * @since 3.21.0
     *
     * @param {number} scaleX - The amount to be added to the `scaleX` property.
     * @param {number} [scaleY] - The amount to be added to the `scaleY` property. If `undefined` or `null` it uses the `scaleX` value.
     * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleXY: function(scaleX, scaleY, stepX, stepY) {
                        Actions.ScaleXY(this.children.entries, scaleX, scaleY, stepX, stepY);
                        return this;
                    },
                    /**
     * Sets the depth of each group member.
     *
     * @method Phaser.GameObjects.Group#setDepth
     * @since 3.0.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setDepth: function(value, step) {
                        Actions.SetDepth(this.children.entries, value, step);
                        return this;
                    },
                    /**
     * Sets the blendMode of each group member.
     *
     * @method Phaser.GameObjects.Group#setBlendMode
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     *
     * @return {this} This Group object.
     */ setBlendMode: function(value) {
                        Actions.SetBlendMode(this.children.entries, value);
                        return this;
                    },
                    /**
     * Passes all group members to the Input Manager to enable them for input with identical areas and callbacks.
     *
     * @method Phaser.GameObjects.Group#setHitArea
     * @since 3.21.0
     *
     * @param {*} hitArea - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - A callback to be invoked when the Game Object is interacted with. If you provide a shape you must also provide a callback.
     *
     * @return {this} This Group object.
     */ setHitArea: function(hitArea, hitAreaCallback) {
                        Actions.SetHitArea(this.children.entries, hitArea, hitAreaCallback);
                        return this;
                    },
                    /**
     * Shuffles the group members in place.
     *
     * @method Phaser.GameObjects.Group#shuffle
     * @since 3.21.0
     *
     * @return {this} This Group object.
     */ shuffle: function() {
                        Actions.Shuffle(this.children.entries);
                        return this;
                    },
                    /**
     * Deactivates a member of this group.
     *
     * @method Phaser.GameObjects.Group#kill
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
     */ kill: function(gameObject) {
                        if (this.children.contains(gameObject)) gameObject.setActive(false);
                    },
                    /**
     * Deactivates and hides a member of this group.
     *
     * @method Phaser.GameObjects.Group#killAndHide
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
     */ killAndHide: function(gameObject) {
                        if (this.children.contains(gameObject)) {
                            gameObject.setActive(false);
                            gameObject.setVisible(false);
                        }
                    },
                    /**
     * Sets the visible of each group member.
     *
     * @method Phaser.GameObjects.Group#setVisible
     * @since 3.21.0
     *
     * @param {boolean} value - The value to set the property to.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ setVisible: function(value, index, direction) {
                        Actions.SetVisible(this.children.entries, value, index, direction);
                        return this;
                    },
                    /**
     * Toggles (flips) the visible state of each member of this group.
     *
     * @method Phaser.GameObjects.Group#toggleVisible
     * @since 3.0.0
     *
     * @return {this} This Group object.
     */ toggleVisible: function() {
                        Actions.ToggleVisible(this.children.entries);
                        return this;
                    },
                    /**
     * Empties this Group of all children and removes it from the Scene.
     *
     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * Children of this Group will _not_ be removed from the Scene by calling this method
     * unless you specify the `removeFromScene` parameter.
     *
     * Children of this Group will also _not_ be destroyed by calling this method
     * unless you specify the `destroyChildren` parameter.
     *
     * @method Phaser.GameObjects.Group#destroy
     * @since 3.0.0
     *
     * @param {boolean} [destroyChildren=false] - Also {@link Phaser.GameObjects.GameObject#destroy} each Group member.
     * @param {boolean} [removeFromScene=false] - Optionally remove each Group member from the Scene.
     */ destroy: function(destroyChildren, removeFromScene) {
                        if (destroyChildren === undefined) destroyChildren = false;
                        if (removeFromScene === undefined) removeFromScene = false;
                        //  This Game Object had already been destroyed
                        if (!this.scene || this.ignoreDestroy) return;
                        this.emit(Events.DESTROY, this);
                        this.removeAllListeners();
                        this.scene.sys.updateList.remove(this);
                        this.clear(removeFromScene, destroyChildren);
                        this.scene = undefined;
                        this.children = undefined;
                    }
                });
                module1.exports = Group;
            /***/ },
            /***/ 94975: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(44603);
                var Group = __webpack_require__(26479);
                /**
 * Creates a new Group Game Object and returns it.
 *
 * Note: This method will only be available if the Group Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#group
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} config - The configuration object this Game Object will use to create itself.
 *
 * @return {Phaser.GameObjects.Group} The Game Object that was created.
 */ GameObjectCreator.register('group', function(config) {
                    return new Group(this.scene, null, config);
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 3385: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Group = __webpack_require__(26479);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Group Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Group Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#group
 * @since 3.0.0
 *
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupConfig[]|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this Group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - A Group Configuration object.
 *
 * @return {Phaser.GameObjects.Group} The Game Object that was created.
 */ GameObjectFactory.register('group', function(children, config) {
                    return this.updateList.add(new Group(this.scene, children, config));
                });
            /***/ },
            /***/ 88571: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var ImageRender = __webpack_require__(59819);
                /**
 * @classdesc
 * An Image Game Object.
 *
 * An Image is a light-weight Game Object useful for the display of static images in your game,
 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
 *
 * @class Image
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var Image1 = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Flip,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Size,
                        Components.TextureCrop,
                        Components.Tint,
                        Components.Transform,
                        Components.Visible,
                        ImageRender
                    ],
                    initialize: function Image1(scene, x, y, texture, frame) {
                        GameObject.call(this, scene, 'Image');
                        /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Image#_crop
         * @type {object}
         * @private
         * @since 3.11.0
         */ this._crop = this.resetCropObject();
                        this.setTexture(texture, frame);
                        this.setPosition(x, y);
                        this.setSizeToFrame();
                        this.setOriginFromFrame();
                        this.initPipeline();
                        this.initPostPipeline(true);
                    }
                });
                module1.exports = Image1;
            /***/ },
            /***/ 40652: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Image#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ImageCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    renderer.batchSprite(src, src.frame, camera, parentMatrix);
                };
                module1.exports = ImageCanvasRenderer;
            /***/ },
            /***/ 82459: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var Image1 = __webpack_require__(88571);
                /**
 * Creates a new Image Game Object and returns it.
 *
 * Note: This method will only be available if the Image Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#image
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Image} The Game Object that was created.
 */ GameObjectCreator.register('image', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var frame = GetAdvancedValue(config, 'frame', null);
                    var image = new Image1(this.scene, 0, 0, key, frame);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, image, config);
                    return image;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 2117: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Image1 = __webpack_require__(88571);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Image Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Image Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#image
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.Image} The Game Object that was created.
 */ GameObjectFactory.register('image', function(x, y, texture, frame) {
                    return this.displayList.add(new Image1(this.scene, x, y, texture, frame));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 59819: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(99517);
                renderCanvas = __webpack_require__(40652);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 99517: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Image#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ImageWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    this.pipeline.batchSprite(src, camera, parentMatrix);
                };
                module1.exports = ImageWebGLRenderer;
            /***/ },
            /***/ 77856: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects
 */ var GameObjects = {
                    Events: __webpack_require__(51708),
                    DisplayList: __webpack_require__(8050),
                    GameObjectCreator: __webpack_require__(44603),
                    GameObjectFactory: __webpack_require__(39429),
                    UpdateList: __webpack_require__(45027),
                    Components: __webpack_require__(31401),
                    GetCalcMatrix: __webpack_require__(91296),
                    BuildGameObject: __webpack_require__(25305),
                    BuildGameObjectAnimation: __webpack_require__(13059),
                    GameObject: __webpack_require__(95643),
                    BitmapText: __webpack_require__(22186),
                    Blitter: __webpack_require__(6107),
                    Bob: __webpack_require__(46590),
                    Container: __webpack_require__(31559),
                    DOMElement: __webpack_require__(3069),
                    DynamicBitmapText: __webpack_require__(2638),
                    Extern: __webpack_require__(42421),
                    Graphics: __webpack_require__(43831),
                    Group: __webpack_require__(26479),
                    Image: __webpack_require__(88571),
                    Layer: __webpack_require__(93595),
                    Particles: __webpack_require__(18404),
                    PathFollower: __webpack_require__(1159),
                    RenderTexture: __webpack_require__(591),
                    RetroFont: __webpack_require__(196),
                    Rope: __webpack_require__(77757),
                    Sprite: __webpack_require__(68287),
                    Text: __webpack_require__(50171),
                    GetTextSize: __webpack_require__(14220),
                    MeasureText: __webpack_require__(79557),
                    TextStyle: __webpack_require__(35762),
                    TileSprite: __webpack_require__(20839),
                    Zone: __webpack_require__(41481),
                    Video: __webpack_require__(18471),
                    //  Shapes
                    Shape: __webpack_require__(17803),
                    Arc: __webpack_require__(23629),
                    Curve: __webpack_require__(89),
                    Ellipse: __webpack_require__(19921),
                    Grid: __webpack_require__(30479),
                    IsoBox: __webpack_require__(61475),
                    IsoTriangle: __webpack_require__(16933),
                    Line: __webpack_require__(57847),
                    Polygon: __webpack_require__(24949),
                    Rectangle: __webpack_require__(74561),
                    Star: __webpack_require__(55911),
                    Triangle: __webpack_require__(36931),
                    //  Game Object Factories
                    Factories: {
                        Blitter: __webpack_require__(12709),
                        Container: __webpack_require__(24961),
                        DOMElement: __webpack_require__(2611),
                        DynamicBitmapText: __webpack_require__(72566),
                        Extern: __webpack_require__(56315),
                        Graphics: __webpack_require__(1201),
                        Group: __webpack_require__(3385),
                        Image: __webpack_require__(2117),
                        Layer: __webpack_require__(20005),
                        Particles: __webpack_require__(676),
                        PathFollower: __webpack_require__(90145),
                        RenderTexture: __webpack_require__(60505),
                        Rope: __webpack_require__(96819),
                        Sprite: __webpack_require__(46409),
                        StaticBitmapText: __webpack_require__(34914),
                        Text: __webpack_require__(68005),
                        TileSprite: __webpack_require__(91681),
                        Zone: __webpack_require__(84175),
                        Video: __webpack_require__(89025),
                        //  Shapes
                        Arc: __webpack_require__(42563),
                        Curve: __webpack_require__(40511),
                        Ellipse: __webpack_require__(1543),
                        Grid: __webpack_require__(34137),
                        IsoBox: __webpack_require__(3933),
                        IsoTriangle: __webpack_require__(49803),
                        Line: __webpack_require__(2481),
                        Polygon: __webpack_require__(64827),
                        Rectangle: __webpack_require__(87959),
                        Star: __webpack_require__(93697),
                        Triangle: __webpack_require__(45245)
                    },
                    Creators: {
                        Blitter: __webpack_require__(9403),
                        Container: __webpack_require__(77143),
                        DynamicBitmapText: __webpack_require__(11164),
                        Graphics: __webpack_require__(87079),
                        Group: __webpack_require__(94975),
                        Image: __webpack_require__(82459),
                        Layer: __webpack_require__(25179),
                        Particles: __webpack_require__(92730),
                        RenderTexture: __webpack_require__(34495),
                        Rope: __webpack_require__(26209),
                        Sprite: __webpack_require__(15567),
                        StaticBitmapText: __webpack_require__(57336),
                        Text: __webpack_require__(71259),
                        TileSprite: __webpack_require__(14167),
                        Zone: __webpack_require__(95261),
                        Video: __webpack_require__(11511)
                    }
                };
                GameObjects.Shader = __webpack_require__(20071);
                GameObjects.Mesh = __webpack_require__(4703);
                GameObjects.NineSlice = __webpack_require__(28103);
                GameObjects.PointLight = __webpack_require__(80321);
                GameObjects.Plane = __webpack_require__(33663);
                GameObjects.Factories.Shader = __webpack_require__(74177);
                GameObjects.Factories.Mesh = __webpack_require__(9225);
                GameObjects.Factories.NineSlice = __webpack_require__(47521);
                GameObjects.Factories.PointLight = __webpack_require__(71255);
                GameObjects.Factories.Plane = __webpack_require__(30985);
                GameObjects.Creators.Shader = __webpack_require__(54935);
                GameObjects.Creators.Mesh = __webpack_require__(20527);
                GameObjects.Creators.NineSlice = __webpack_require__(28279);
                GameObjects.Creators.PointLight = __webpack_require__(39829);
                GameObjects.Creators.Plane = __webpack_require__(56015);
                GameObjects.Light = __webpack_require__(41432);
                GameObjects.LightsManager = __webpack_require__(61356);
                GameObjects.LightsPlugin = __webpack_require__(88992);
                module1.exports = GameObjects;
            /***/ },
            /***/ 93595: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(10312);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var ComponentsToJSON = __webpack_require__(53774);
                var DataManager = __webpack_require__(45893);
                var EventEmitter = __webpack_require__(50792);
                var GameObjectEvents = __webpack_require__(51708);
                var List = __webpack_require__(73162);
                var Render = __webpack_require__(33963);
                var SceneEvents = __webpack_require__(44594);
                var StableSort = __webpack_require__(19186);
                /**
 * @classdesc
 * A Layer Game Object.
 *
 * A Layer is a special type of Game Object that acts as a Display List. You can add any type of Game Object
 * to a Layer, just as you would to a Scene. Layers can be used to visually group together 'layers' of Game
 * Objects:
 *
 * ```javascript
 * const spaceman = this.add.sprite(150, 300, 'spaceman');
 * const bunny = this.add.sprite(400, 300, 'bunny');
 * const elephant = this.add.sprite(650, 300, 'elephant');
 *
 * const layer = this.add.layer();
 *
 * layer.add([ spaceman, bunny, elephant ]);
 * ```
 *
 * The 3 sprites in the example above will now be managed by the Layer they were added to. Therefore,
 * if you then set `layer.setVisible(false)` they would all vanish from the display.
 *
 * You can also control the depth of the Game Objects within the Layer. For example, calling the
 * `setDepth` method of a child of a Layer will allow you to adjust the depth of that child _within the
 * Layer itself_, rather than the whole Scene. The Layer, too, can have its depth set as well.
 *
 * The Layer class also offers many different methods for manipulating the list, such as the
 * methods `moveUp`, `moveDown`, `sendToBack`, `bringToTop` and so on. These allow you to change the
 * display list position of the Layers children, causing it to adjust the order in which they are
 * rendered. Using `setDepth` on a child allows you to override this.
 *
 * Layers can have Post FX Pipelines set, which allows you to easily enable a post pipeline across
 * a whole range of children, which, depending on the effect, can often be far more efficient that doing so
 * on a per-child basis.
 *
 * Layers have no position or size within the Scene. This means you cannot enable a Layer for
 * physics or input, or change the position, rotation or scale of a Layer. They also have no scroll
 * factor, texture, tint, origin, crop or bounds.
 *
 * If you need those kind of features then you should use a Container instead. Containers can be added
 * to Layers, but Layers cannot be added to Containers.
 *
 * However, you can set the Alpha, Blend Mode, Depth, Mask and Visible state of a Layer. These settings
 * will impact all children being rendered by the Layer.
 *
 * @class Layer
 * @extends Phaser.Structs.List.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Layer.
 */ var Layer = new Class({
                    Extends: List,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Mask,
                        Components.PostPipeline,
                        Components.Visible,
                        EventEmitter,
                        Render
                    ],
                    initialize: function Layer(scene, children) {
                        List.call(this, scene);
                        EventEmitter.call(this);
                        /**
         * A reference to the Scene to which this Game Object belongs.
         *
         * Game Objects can only belong to one Scene.
         *
         * You should consider this property as being read-only. You cannot move a
         * Game Object to another Scene by simply changing it.
         *
         * @name Phaser.GameObjects.Layer#scene
         * @type {Phaser.Scene}
         * @since 3.50.0
         */ this.scene = scene;
                        /**
         * Holds a reference to the Display List that contains this Game Object.
         *
         * This is set automatically when this Game Object is added to a Scene or Layer.
         *
         * You should treat this property as being read-only.
         *
         * @name Phaser.GameObjects.Layer#displayList
         * @type {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)}
         * @default null
         * @since 3.50.0
         */ this.displayList = null;
                        /**
         * A textual representation of this Game Object, i.e. `sprite`.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.Layer#type
         * @type {string}
         * @since 3.50.0
         */ this.type = 'Layer';
                        /**
         * The current state of this Game Object.
         *
         * Phaser itself will never modify this value, although plugins may do so.
         *
         * Use this property to track the state of a Game Object during its lifetime. For example, it could change from
         * a state of 'moving', to 'attacking', to 'dead'. The state value should be an integer (ideally mapped to a constant
         * in your game code), or a string. These are recommended to keep it light and simple, with fast comparisons.
         * If you need to store complex data about your Game Object, look at using the Data Component instead.
         *
         * @name Phaser.GameObjects.Layer#state
         * @type {(number|string)}
         * @since 3.50.0
         */ this.state = 0;
                        /**
         * A Layer cannot be placed inside a Container.
         *
         * This property is kept purely so a Layer has the same
         * shape as a Game Object.
         *
         * @name Phaser.GameObjects.Layer#parentContainer
         * @type {Phaser.GameObjects.Container}
         * @since 3.51.0
         */ this.parentContainer = null;
                        /**
         * The name of this Game Object.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Layer#name
         * @type {string}
         * @default ''
         * @since 3.50.0
         */ this.name = '';
                        /**
         * The active state of this Game Object.
         * A Game Object with an active state of `true` is processed by the Scenes UpdateList, if added to it.
         * An active object is one which is having its logic and internal systems updated.
         *
         * @name Phaser.GameObjects.Layer#active
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.active = true;
                        /**
         * The Tab Index of the Game Object.
         * Reserved for future use by plugins and the Input Manager.
         *
         * @name Phaser.GameObjects.Layer#tabIndex
         * @type {number}
         * @default -1
         * @since 3.51.0
         */ this.tabIndex = -1;
                        /**
         * A Data Manager.
         * It allows you to store, query and get key/value paired information specific to this Game Object.
         * `null` by default. Automatically created if you use `getData` or `setData` or `setDataEnabled`.
         *
         * @name Phaser.GameObjects.Layer#data
         * @type {Phaser.Data.DataManager}
         * @default null
         * @since 3.50.0
         */ this.data = null;
                        /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.Layer#renderFlags
         * @type {number}
         * @default 15
         * @since 3.50.0
         */ this.renderFlags = 15;
                        /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.Layer#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.cameraFilter = 0;
                        /**
         * This property is kept purely so a Layer has the same
         * shape as a Game Object. You cannot input enable a Layer.
         *
         * @name Phaser.GameObjects.Layer#input
         * @type {?Phaser.Types.Input.InteractiveObject}
         * @default null
         * @since 3.51.0
         */ this.input = null;
                        /**
         * This property is kept purely so a Layer has the same
         * shape as a Game Object. You cannot give a Layer a physics body.
         *
         * @name Phaser.GameObjects.Layer#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|MatterJS.BodyType)}
         * @default null
         * @since 3.51.0
         */ this.body = null;
                        /**
         * This Game Object will ignore all calls made to its destroy method if this flag is set to `true`.
         * This includes calls that may come from a Group, Container or the Scene itself.
         * While it allows you to persist a Game Object across Scenes, please understand you are entirely
         * responsible for managing references to and from this Game Object.
         *
         * @name Phaser.GameObjects.Layer#ignoreDestroy
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.ignoreDestroy = false;
                        /**
         * A reference to the Scene Systems.
         *
         * @name Phaser.GameObjects.Layer#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.50.0
         */ this.systems = scene.sys;
                        /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.Layer#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.50.0
         */ this.events = scene.sys.events;
                        /**
         * The flag the determines whether Game Objects should be sorted when `depthSort()` is called.
         *
         * @name Phaser.GameObjects.Layer#sortChildrenFlag
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.sortChildrenFlag = false;
                        //  Set the List callbacks
                        this.addCallback = this.addChildCallback;
                        this.removeCallback = this.removeChildCallback;
                        this.initPostPipeline();
                        this.clearAlpha();
                        this.setBlendMode(BlendModes.SKIP_CHECK);
                        if (children) this.add(children);
                        //  Tell the Scene to re-sort the children
                        scene.sys.queueDepthSort();
                    },
                    /**
     * Sets the `active` property of this Game Object and returns this Game Object for further chaining.
     * A Game Object with its `active` property set to `true` will be updated by the Scenes UpdateList.
     *
     * @method Phaser.GameObjects.Layer#setActive
     * @since 3.50.0
     *
     * @param {boolean} value - True if this Game Object should be set as active, false if not.
     *
     * @return {this} This GameObject.
     */ setActive: function(value) {
                        this.active = value;
                        return this;
                    },
                    /**
     * Sets the `name` property of this Game Object and returns this Game Object for further chaining.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.Layer#setName
     * @since 3.50.0
     *
     * @param {string} value - The name to be given to this Game Object.
     *
     * @return {this} This GameObject.
     */ setName: function(value) {
                        this.name = value;
                        return this;
                    },
                    /**
     * Sets the current state of this Game Object.
     *
     * Phaser itself will never modify the State of a Game Object, although plugins may do so.
     *
     * For example, a Game Object could change from a state of 'moving', to 'attacking', to 'dead'.
     * The state value should typically be an integer (ideally mapped to a constant
     * in your game code), but could also be a string. It is recommended to keep it light and simple.
     * If you need to store complex data about your Game Object, look at using the Data Component instead.
     *
     * @method Phaser.GameObjects.Layer#setState
     * @since 3.50.0
     *
     * @param {(number|string)} value - The state of the Game Object.
     *
     * @return {this} This GameObject.
     */ setState: function(value) {
                        this.state = value;
                        return this;
                    },
                    /**
     * Adds a Data Manager component to this Game Object.
     *
     * @method Phaser.GameObjects.Layer#setDataEnabled
     * @since 3.50.0
     * @see Phaser.Data.DataManager
     *
     * @return {this} This GameObject.
     */ setDataEnabled: function() {
                        if (!this.data) this.data = new DataManager(this);
                        return this;
                    },
                    /**
     * Allows you to store a key value pair within this Game Objects Data Manager.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * sprite.setData('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * sprite.setData({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `getData`:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * sprite.data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.GameObjects.Layer#setData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to set the value for. Or an object of key value pairs. If an object the `data` argument is ignored.
     * @param {*} [data] - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This GameObject.
     */ setData: function(key, value) {
                        if (!this.data) this.data = new DataManager(this);
                        this.data.set(key, value);
                        return this;
                    },
                    /**
     * Increase a value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#incData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to increase the value for.
     * @param {*} [data] - The value to increase for the given key.
     *
     * @return {this} This GameObject.
     */ incData: function(key, value) {
                        if (!this.data) this.data = new DataManager(this);
                        this.data.inc(key, value);
                        return this;
                    },
                    /**
     * Toggle a boolean value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#toggleData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to toggle the value for.
     *
     * @return {this} This GameObject.
     */ toggleData: function(key) {
                        if (!this.data) this.data = new DataManager(this);
                        this.data.toggle(key);
                        return this;
                    },
                    /**
     * Retrieves the value for the given key in this Game Objects Data Manager, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * sprite.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * sprite.getData([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.GameObjects.Layer#getData
     * @since 3.50.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ getData: function(key) {
                        if (!this.data) this.data = new DataManager(this);
                        return this.data.get(key);
                    },
                    /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#setInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ setInteractive: function() {
                        return this;
                    },
                    /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#disableInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ disableInteractive: function() {
                        return this;
                    },
                    /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#removeInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ removeInteractive: function() {
                        return this;
                    },
                    /**
     * This callback is invoked when this Game Object is added to a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to add themselves into the Update List.
     *
     * You can also listen for the `ADDED_TO_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#addedToScene
     * @since 3.50.0
     */ addedToScene: function() {},
                    /**
     * This callback is invoked when this Game Object is removed from a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to removed themselves from the Update List.
     *
     * You can also listen for the `REMOVED_FROM_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#removedFromScene
     * @since 3.50.0
     */ removedFromScene: function() {},
                    /**
     * To be overridden by custom GameObjects. Allows base objects to be used in a Pool.
     *
     * @method Phaser.GameObjects.Layer#update
     * @since 3.50.0
     *
     * @param {...*} [args] - args
     */ update: function() {},
                    /**
     * Returns a JSON representation of the Game Object.
     *
     * @method Phaser.GameObjects.Layer#toJSON
     * @since 3.50.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                        return ComponentsToJSON(this);
                    },
                    /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Layer#willRender
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                        return !(this.renderFlags !== 15 || this.list.length === 0 || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                    },
                    /**
     * Returns an array containing the display list index of either this Game Object, or if it has one,
     * its parent Container. It then iterates up through all of the parent containers until it hits the
     * root of the display list (which is index 0 in the returned array).
     *
     * Used internally by the InputPlugin but also useful if you wish to find out the display depth of
     * this Game Object and all of its ancestors.
     *
     * @method Phaser.GameObjects.Layer#getIndexList
     * @since 3.51.0
     *
     * @return {number[]} An array of display list position indexes.
     */ getIndexList: function() {
                        // eslint-disable-next-line consistent-this
                        var child = this;
                        var parent = this.parentContainer;
                        var indexes = [];
                        while(parent){
                            indexes.unshift(parent.getIndex(child));
                            child = parent;
                            if (!parent.parentContainer) break;
                            else parent = parent.parentContainer;
                        }
                        indexes.unshift(this.displayList.getIndex(child));
                        return indexes;
                    },
                    /**
     * Internal method called from `List.addCallback`.
     *
     * @method Phaser.GameObjects.Layer#addChildCallback
     * @private
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the list.
     */ addChildCallback: function(gameObject) {
                        var displayList = gameObject.displayList;
                        if (displayList && displayList !== this) gameObject.removeFromDisplayList();
                        if (!gameObject.displayList) {
                            this.queueDepthSort();
                            gameObject.displayList = this;
                            gameObject.emit(GameObjectEvents.ADDED_TO_SCENE, gameObject, this.scene);
                            this.events.emit(SceneEvents.ADDED_TO_SCENE, gameObject, this.scene);
                        }
                    },
                    /**
     * Internal method called from `List.removeCallback`.
     *
     * @method Phaser.GameObjects.Layer#removeChildCallback
     * @private
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the list.
     */ removeChildCallback: function(gameObject) {
                        this.queueDepthSort();
                        gameObject.displayList = null;
                        gameObject.emit(GameObjectEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                        this.events.emit(SceneEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                    },
                    /**
     * Force a sort of the display list on the next call to depthSort.
     *
     * @method Phaser.GameObjects.Layer#queueDepthSort
     * @since 3.50.0
     */ queueDepthSort: function() {
                        this.sortChildrenFlag = true;
                    },
                    /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.GameObjects.Layer#depthSort
     * @since 3.50.0
     */ depthSort: function() {
                        if (this.sortChildrenFlag) {
                            StableSort(this.list, this.sortByDepth);
                            this.sortChildrenFlag = false;
                        }
                    },
                    /**
     * Compare the depth of two Game Objects.
     *
     * @method Phaser.GameObjects.Layer#sortByDepth
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object.
     *
     * @return {number} The difference between the depths of each Game Object.
     */ sortByDepth: function(childA, childB) {
                        return childA._depth - childB._depth;
                    },
                    /**
     * Returns a reference to the array which contains all Game Objects in this Layer.
     *
     * This is a reference, not a copy of it, so be very careful not to mutate it.
     *
     * @method Phaser.GameObjects.Layer#getChildren
     * @since 3.50.0
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of Game Objects within this Layer.
     */ getChildren: function() {
                        return this.list;
                    },
                    /**
     * Adds this Layer to the given Display List.
     *
     * If no Display List is specified, it will default to the Display List owned by the Scene to which
     * this Layer belongs.
     *
     * A Layer can only exist on one Display List at any given time, but may move freely between them.
     *
     * If this Layer is already on another Display List when this method is called, it will first
     * be removed from it, before being added to the new list.
     *
     * You can query which list it is on by looking at the `Phaser.GameObjects.Layer#displayList` property.
     *
     * If a Layer isn't on any display list, it will not be rendered. If you just wish to temporarily
     * disable it from rendering, consider using the `setVisible` method, instead.
     *
     * @method Phaser.GameObjects.Layer#addToDisplayList
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.60.0
     *
     * @param {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)} [displayList] - The Display List to add to. Defaults to the Scene Display List.
     *
     * @return {this} This Layer instance.
     */ addToDisplayList: function(displayList) {
                        if (displayList === undefined) displayList = this.scene.sys.displayList;
                        if (this.displayList && this.displayList !== displayList) this.removeFromDisplayList();
                        //  Don't repeat if it's already on this list
                        if (!displayList.exists(this)) {
                            this.displayList = displayList;
                            displayList.add(this, true);
                            displayList.queueDepthSort();
                            this.emit(GameObjectEvents.ADDED_TO_SCENE, this, this.scene);
                            displayList.events.emit(SceneEvents.ADDED_TO_SCENE, this, this.scene);
                        }
                        return this;
                    },
                    /**
     * Removes this Layer from the Display List it is currently on.
     *
     * A Layer can only exist on one Display List at any given time, but may move freely removed
     * and added back at a later stage.
     *
     * You can query which list it is on by looking at the `Phaser.GameObjects.GameObject#displayList` property.
     *
     * If a Layer isn't on any Display List, it will not be rendered. If you just wish to temporarily
     * disable it from rendering, consider using the `setVisible` method, instead.
     *
     * @method Phaser.GameObjects.Layer#removeFromDisplayList
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.60.0
     *
     * @return {this} This Layer instance.
     */ removeFromDisplayList: function() {
                        var displayList = this.displayList || this.scene.sys.displayList;
                        if (displayList.exists(this)) {
                            displayList.remove(this, true);
                            displayList.queueDepthSort();
                            this.displayList = null;
                            this.emit(GameObjectEvents.REMOVED_FROM_SCENE, this, this.scene);
                            displayList.events.emit(SceneEvents.REMOVED_FROM_SCENE, this, this.scene);
                        }
                        return this;
                    },
                    /**
     * Returns a reference to the underlying display list _array_ that contains this Game Object,
     * which will be either the Scene's Display List or the internal list belonging
     * to its parent Container, if it has one.
     * 
     * If this Game Object is not on a display list or in a container, it will return `null`.
     * 
     * You should be very careful with this method, and understand that it returns a direct reference to the
     * internal array used by the Display List. Mutating this array directly can cause all kinds of subtle
     * and difficult to debug issues in your game.
     *
     * @method Phaser.GameObjects.Layer#getDisplayList
     * @since 3.88.0
     *
     * @return {?Phaser.GameObjects.GameObject[]} The internal Display List array of Game Objects, or `null`.
     */ getDisplayList: function() {
                        var list = null;
                        if (this.parentContainer) list = this.parentContainer.list;
                        else if (this.displayList) list = this.displayList.list;
                        return list;
                    },
                    /**
     * Destroys this Layer removing it from the Display List and Update List and
     * severing all ties to parent resources.
     *
     * Also destroys all children of this Layer. If you do not wish for the
     * children to be destroyed, you should move them from this Layer first.
     *
     * Use this to remove this Layer from your game if you don't ever plan to use it again.
     * As long as no reference to it exists within your own code it should become free for
     * garbage collection by the browser.
     *
     * If you just want to temporarily disable an object then look at using the
     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
     *
     * @method Phaser.GameObjects.Layer#destroy
     * @fires Phaser.GameObjects.Events#DESTROY
     * @since 3.50.0
     *
     * @param {boolean} [fromScene=false] - `True` if this Game Object is being destroyed by the Scene, `false` if not.
     */ destroy: function(fromScene) {
                        //  This Game Object has already been destroyed
                        if (!this.scene || this.ignoreDestroy) return;
                        this.emit(GameObjectEvents.DESTROY, this);
                        var list = this.list;
                        while(list.length)list[0].destroy(fromScene);
                        this.removeAllListeners();
                        this.resetPostPipeline(true);
                        if (this.displayList) {
                            this.displayList.remove(this, true, false);
                            this.displayList.queueDepthSort();
                        }
                        if (this.data) {
                            this.data.destroy();
                            this.data = undefined;
                        }
                        this.active = false;
                        this.visible = false;
                        this.list = undefined;
                        this.scene = undefined;
                        this.displayList = undefined;
                        this.systems = undefined;
                        this.events = undefined;
                    }
                });
                module1.exports = Layer;
            /***/ },
            /***/ 2956: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Layer#renderCanvas
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Layer} layer - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var LayerCanvasRenderer = function(renderer, layer, camera) {
                    var children = layer.list;
                    if (children.length === 0) return;
                    layer.depthSort();
                    var layerHasBlendMode = layer.blendMode !== -1;
                    if (!layerHasBlendMode) //  If Layer is SKIP_TEST then set blend mode to be Normal
                    renderer.setBlendMode(0);
                    var alpha = layer._alpha;
                    if (layer.mask) layer.mask.preRenderCanvas(renderer, null, camera);
                    for(var i = 0; i < children.length; i++){
                        var child = children[i];
                        if (!child.willRender(camera)) continue;
                        var childAlpha = child.alpha;
                        if (!layerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Layer doesn't have its own blend mode, then a child can have one
                        renderer.setBlendMode(child.blendMode);
                        //  Set parent values
                        child.setAlpha(childAlpha * alpha);
                        //  Render
                        child.renderCanvas(renderer, child, camera);
                        //  Restore original values
                        child.setAlpha(childAlpha);
                    }
                    if (layer.mask) layer.mask.postRenderCanvas(renderer);
                };
                module1.exports = LayerCanvasRenderer;
            /***/ },
            /***/ 25179: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var Layer = __webpack_require__(93595);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                /**
 * Creates a new Layer Game Object and returns it.
 *
 * Note: This method will only be available if the Layer Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#layer
 * @since 3.50.0
 *
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Layer} The Game Object that was created.
 */ GameObjectCreator.register('layer', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var children = GetAdvancedValue(config, 'children', null);
                    var layer = new Layer(this.scene, children);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, layer, config);
                    return layer;
                });
            /***/ },
            /***/ 20005: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Layer = __webpack_require__(93595);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Layer Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Layer Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#layer
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Layer.
 *
 * @return {Phaser.GameObjects.Layer} The Game Object that was created.
 */ GameObjectFactory.register('layer', function(children) {
                    return this.displayList.add(new Layer(this.scene, children));
                });
            /***/ },
            /***/ 33963: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(15869);
                renderCanvas = __webpack_require__(2956);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 15869: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Layer#renderWebGL
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Layer} layer - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var LayerWebGLRenderer = function(renderer, layer, camera) {
                    var children = layer.list;
                    var childCount = children.length;
                    if (childCount === 0) return;
                    layer.depthSort();
                    renderer.pipelines.preBatch(layer);
                    var layerHasBlendMode = layer.blendMode !== -1;
                    if (!layerHasBlendMode) //  If Layer is SKIP_TEST then set blend mode to be Normal
                    renderer.setBlendMode(0);
                    var alpha = layer.alpha;
                    for(var i = 0; i < childCount; i++){
                        var child = children[i];
                        if (!child.willRender(camera)) continue;
                        var childAlphaTopLeft;
                        var childAlphaTopRight;
                        var childAlphaBottomLeft;
                        var childAlphaBottomRight;
                        if (child.alphaTopLeft !== undefined) {
                            childAlphaTopLeft = child.alphaTopLeft;
                            childAlphaTopRight = child.alphaTopRight;
                            childAlphaBottomLeft = child.alphaBottomLeft;
                            childAlphaBottomRight = child.alphaBottomRight;
                        } else {
                            var childAlpha = child.alpha;
                            childAlphaTopLeft = childAlpha;
                            childAlphaTopRight = childAlpha;
                            childAlphaBottomLeft = childAlpha;
                            childAlphaBottomRight = childAlpha;
                        }
                        if (!layerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Layer doesn't have its own blend mode, then a child can have one
                        renderer.setBlendMode(child.blendMode);
                        var mask = child.mask;
                        if (mask) mask.preRenderWebGL(renderer, child, camera);
                        var type = child.type;
                        if (type !== renderer.currentType) {
                            renderer.newType = true;
                            renderer.currentType = type;
                        }
                        renderer.nextTypeMatch = i < childCount - 1 ? children[i + 1].type === renderer.currentType : false;
                        child.setAlpha(childAlphaTopLeft * alpha, childAlphaTopRight * alpha, childAlphaBottomLeft * alpha, childAlphaBottomRight * alpha);
                        //  Render
                        child.renderWebGL(renderer, child, camera);
                        //  Restore original values
                        child.setAlpha(childAlphaTopLeft, childAlphaTopRight, childAlphaBottomLeft, childAlphaBottomRight);
                        if (mask) mask.postRenderWebGL(renderer, camera);
                        renderer.newType = false;
                    }
                    renderer.pipelines.postBatch(layer);
                };
                module1.exports = LayerWebGLRenderer;
            /***/ },
            /***/ 41432: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(96503);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var RGB = __webpack_require__(51767);
                var Utils = __webpack_require__(70554);
                /**
 * @classdesc
 * A 2D Light.
 *
 * These are created by the {@link Phaser.GameObjects.LightsManager}, available from within a scene via `this.lights`.
 *
 * Any Game Objects using the Light2D pipeline will then be affected by these Lights as long as they have a normal map.
 *
 * They can also simply be used to represent a point light for your own purposes.
 *
 * Lights cannot be added to Containers. They are designed to exist in the root of a Scene.
 *
 * @class Light
 * @extends Phaser.Geom.Circle
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {number} x - The horizontal position of the light.
 * @param {number} y - The vertical position of the light.
 * @param {number} radius - The radius of the light.
 * @param {number} r - The red color of the light. A value between 0 and 1.
 * @param {number} g - The green color of the light. A value between 0 and 1.
 * @param {number} b - The blue color of the light. A value between 0 and 1.
 * @param {number} intensity - The intensity of the light.
 */ var Light = new Class({
                    Extends: Circle,
                    Mixins: [
                        Components.Origin,
                        Components.ScrollFactor,
                        Components.Visible
                    ],
                    initialize: function Light(x, y, radius, r, g, b, intensity) {
                        Circle.call(this, x, y, radius);
                        /**
         * The color of the light.
         *
         * @name Phaser.GameObjects.Light#color
         * @type {Phaser.Display.RGB}
         * @since 3.50.0
         */ this.color = new RGB(r, g, b);
                        /**
         * The intensity of the light.
         *
         * @name Phaser.GameObjects.Light#intensity
         * @type {number}
         * @since 3.50.0
         */ this.intensity = intensity;
                        /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.Light#renderFlags
         * @type {number}
         * @default 15
         * @since 3.0.0
         */ this.renderFlags = 15;
                        /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.Light#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cameraFilter = 0;
                        this.setScrollFactor(1, 1);
                        this.setOrigin();
                        this.setDisplayOrigin(radius);
                    },
                    /**
     * The width of this Light Game Object. This is the same as `Light.diameter`.
     *
     * @name Phaser.GameObjects.Light#displayWidth
     * @type {number}
     * @since 3.60.0
     */ displayWidth: {
                        get: function() {
                            return this.diameter;
                        },
                        set: function(value) {
                            this.diameter = value;
                        }
                    },
                    /**
     * The height of this Light Game Object. This is the same as `Light.diameter`.
     *
     * @name Phaser.GameObjects.Light#displayHeight
     * @type {number}
     * @since 3.60.0
     */ displayHeight: {
                        get: function() {
                            return this.diameter;
                        },
                        set: function(value) {
                            this.diameter = value;
                        }
                    },
                    /**
     * The width of this Light Game Object. This is the same as `Light.diameter`.
     *
     * @name Phaser.GameObjects.Light#width
     * @type {number}
     * @since 3.60.0
     */ width: {
                        get: function() {
                            return this.diameter;
                        },
                        set: function(value) {
                            this.diameter = value;
                        }
                    },
                    /**
     * The height of this Light Game Object. This is the same as `Light.diameter`.
     *
     * @name Phaser.GameObjects.Light#height
     * @type {number}
     * @since 3.60.0
     */ height: {
                        get: function() {
                            return this.diameter;
                        },
                        set: function(value) {
                            this.diameter = value;
                        }
                    },
                    /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Light#willRender
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                        return !(Light.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                    },
                    /**
     * Set the color of the light from a single integer RGB value.
     *
     * @method Phaser.GameObjects.Light#setColor
     * @since 3.0.0
     *
     * @param {number} rgb - The integer RGB color of the light.
     *
     * @return {this} This Light object.
     */ setColor: function(rgb) {
                        var color = Utils.getFloatsFromUintRGB(rgb);
                        this.color.set(color[0], color[1], color[2]);
                        return this;
                    },
                    /**
     * Set the intensity of the light.
     *
     * @method Phaser.GameObjects.Light#setIntensity
     * @since 3.0.0
     *
     * @param {number} intensity - The intensity of the light.
     *
     * @return {this} This Light object.
     */ setIntensity: function(intensity) {
                        this.intensity = intensity;
                        return this;
                    },
                    /**
     * Set the radius of the light.
     *
     * @method Phaser.GameObjects.Light#setRadius
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the light.
     *
     * @return {this} This Light object.
     */ setRadius: function(radius) {
                        this.radius = radius;
                        return this;
                    }
                });
                /**
 * The bitmask that `GameObject.renderFlags` is compared against to determine if the Game Object will render or not.
 *
 * @constant {number} RENDER_MASK
 * @memberof Phaser.GameObjects.Light
 * @default
 */ Light.RENDER_MASK = 15;
                module1.exports = Light;
            /***/ },
            /***/ 61356: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircleToRectangle = __webpack_require__(81491);
                var Class = __webpack_require__(83419);
                var DistanceBetween = __webpack_require__(20339);
                var Light = __webpack_require__(41432);
                var PointLight = __webpack_require__(80321);
                var RGB = __webpack_require__(51767);
                var SpliceOne = __webpack_require__(19133);
                var StableSort = __webpack_require__(19186);
                var Utils = __webpack_require__(70554);
                /**
 * @callback LightForEach
 *
 * @param {Phaser.GameObjects.Light} light - The Light.
 */ /**
 * @classdesc
 * Manages Lights for a Scene.
 *
 * Affects the rendering of Game Objects using the `Light2D` pipeline.
 *
 * @class LightsManager
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 */ var LightsManager = new Class({
                    initialize: function LightsManager() {
                        /**
         * The Lights in the Scene.
         *
         * @name Phaser.GameObjects.LightsManager#lights
         * @type {Phaser.GameObjects.Light[]}
         * @default []
         * @since 3.0.0
         */ this.lights = [];
                        /**
         * The ambient color.
         *
         * @name Phaser.GameObjects.LightsManager#ambientColor
         * @type {Phaser.Display.RGB}
         * @since 3.50.0
         */ this.ambientColor = new RGB(0.1, 0.1, 0.1);
                        /**
         * Whether the Lights Manager is enabled.
         *
         * @name Phaser.GameObjects.LightsManager#active
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.active = false;
                        /**
         * The maximum number of lights that a single Camera and the lights shader can process.
         * Change this via the `maxLights` property in your game config, as it cannot be changed at runtime.
         *
         * @name Phaser.GameObjects.LightsManager#maxLights
         * @type {number}
         * @readonly
         * @since 3.15.0
         */ this.maxLights = -1;
                        /**
         * The number of lights that the LightPipeline processed in the _previous_ frame.
         *
         * @name Phaser.GameObjects.LightsManager#visibleLights
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.visibleLights = 0;
                    },
                    /**
     * Creates a new Point Light Game Object and adds it to the Scene.
     *
     * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
     *
     * The Point Light Game Object provides a way to add a point light effect into your game,
     * without the expensive shader processing requirements of the traditional Light Game Object.
     *
     * The difference is that the Point Light renders using a custom shader, designed to give the
     * impression of a point light source, of variable radius, intensity and color, in your game.
     * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
     * normal maps for calcuations. This makes them extremely fast to render compared to Lights
     * and perfect for special effects, such as flickering torches or muzzle flashes.
     *
     * For maximum performance you should batch Point Light Game Objects together. This means
     * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
     * Game Object and then add just Point Lights to it, so that it can batch together the rendering
     * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
     * your game then it's perfectly safe to mix them into the display list as normal. However, if
     * you're using a large number of them, please consider how they are mixed into the display list.
     *
     * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
     * with the Camera will be skipped in the rendering list. This happens automatically and the
     * culled state is refreshed every frame, for every camera.
     *
     * The origin of a Point Light is always 0.5 and it cannot be changed.
     *
     * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
     *
     * @method Phaser.GameObjects.LightsManager#addPointLight
     * @since 3.50.0
     *
     * @param {number} x - The horizontal position of this Point Light in the world.
     * @param {number} y - The vertical position of this Point Light in the world.
     * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
     * @param {number} [radius=128] - The radius of the Point Light.
     * @param {number} [intensity=1] - The intensity, or color blend, of the Point Light.
     * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
     *
     * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
     */ addPointLight: function(x, y, color, radius, intensity, attenuation) {
                        return this.systems.displayList.add(new PointLight(this.scene, x, y, color, radius, intensity, attenuation));
                    },
                    /**
     * Enable the Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#enable
     * @since 3.0.0
     *
     * @return {this} This Lights Manager instance.
     */ enable: function() {
                        if (this.maxLights === -1) this.maxLights = this.systems.renderer.config.maxLights;
                        this.active = true;
                        return this;
                    },
                    /**
     * Disable the Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#disable
     * @since 3.0.0
     *
     * @return {this} This Lights Manager instance.
     */ disable: function() {
                        this.active = false;
                        return this;
                    },
                    /**
     * Get all lights that can be seen by the given Camera.
     *
     * It will automatically cull lights that are outside the world view of the Camera.
     *
     * If more lights are returned than supported by the pipeline, the lights are then culled
     * based on the distance from the center of the camera. Only those closest are rendered.
     *
     * @method Phaser.GameObjects.LightsManager#getLights
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to cull Lights for.
     *
     * @return {Phaser.GameObjects.Light[]} The culled Lights.
     */ getLights: function(camera) {
                        var lights = this.lights;
                        var worldView = camera.worldView;
                        var visibleLights = [];
                        for(var i = 0; i < lights.length; i++){
                            var light = lights[i];
                            if (light.willRender(camera) && CircleToRectangle(light, worldView)) visibleLights.push({
                                light: light,
                                distance: DistanceBetween(light.x, light.y, worldView.centerX, worldView.centerY)
                            });
                        }
                        if (visibleLights.length > this.maxLights) {
                            //  We've got too many lights, so sort by distance from camera and cull those far away
                            //  This isn't ideal because it doesn't factor in the radius of the lights, but it'll do for now
                            //  and is significantly better than we had before!
                            StableSort(visibleLights, this.sortByDistance);
                            visibleLights = visibleLights.slice(0, this.maxLights);
                        }
                        this.visibleLights = visibleLights.length;
                        return visibleLights;
                    },
                    sortByDistance: function(a, b) {
                        return a.distance >= b.distance;
                    },
                    /**
     * Set the ambient light color.
     *
     * @method Phaser.GameObjects.LightsManager#setAmbientColor
     * @since 3.0.0
     *
     * @param {number} rgb - The integer RGB color of the ambient light.
     *
     * @return {this} This Lights Manager instance.
     */ setAmbientColor: function(rgb) {
                        var color = Utils.getFloatsFromUintRGB(rgb);
                        this.ambientColor.set(color[0], color[1], color[2]);
                        return this;
                    },
                    /**
     * Returns the maximum number of Lights allowed to appear at once.
     *
     * @method Phaser.GameObjects.LightsManager#getMaxVisibleLights
     * @since 3.0.0
     *
     * @return {number} The maximum number of Lights allowed to appear at once.
     */ getMaxVisibleLights: function() {
                        return this.maxLights;
                    },
                    /**
     * Get the number of Lights managed by this Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#getLightCount
     * @since 3.0.0
     *
     * @return {number} The number of Lights managed by this Lights Manager.
     */ getLightCount: function() {
                        return this.lights.length;
                    },
                    /**
     * Add a Light.
     *
     * @method Phaser.GameObjects.LightsManager#addLight
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the Light.
     * @param {number} [y=0] - The vertical position of the Light.
     * @param {number} [radius=128] - The radius of the Light.
     * @param {number} [rgb=0xffffff] - The integer RGB color of the light.
     * @param {number} [intensity=1] - The intensity of the Light.
     *
     * @return {Phaser.GameObjects.Light} The Light that was added.
     */ addLight: function(x, y, radius, rgb, intensity) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (radius === undefined) radius = 128;
                        if (rgb === undefined) rgb = 0xffffff;
                        if (intensity === undefined) intensity = 1;
                        var color = Utils.getFloatsFromUintRGB(rgb);
                        var light = new Light(x, y, radius, color[0], color[1], color[2], intensity);
                        this.lights.push(light);
                        return light;
                    },
                    /**
     * Remove a Light.
     *
     * @method Phaser.GameObjects.LightsManager#removeLight
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Light} light - The Light to remove.
     *
     * @return {this} This Lights Manager instance.
     */ removeLight: function(light) {
                        var index = this.lights.indexOf(light);
                        if (index >= 0) SpliceOne(this.lights, index);
                        return this;
                    },
                    /**
     * Shut down the Lights Manager.
     *
     * Recycles all active Lights into the Light pool, resets ambient light color and clears the lists of Lights and
     * culled Lights.
     *
     * @method Phaser.GameObjects.LightsManager#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        this.lights.length = 0;
                    },
                    /**
     * Destroy the Lights Manager.
     *
     * Cleans up all references by calling {@link Phaser.GameObjects.LightsManager#shutdown}.
     *
     * @method Phaser.GameObjects.LightsManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                    }
                });
                module1.exports = LightsManager;
            /***/ },
            /***/ 88992: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var LightsManager = __webpack_require__(61356);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * A Scene plugin that provides a {@link Phaser.GameObjects.LightsManager} for the Light2D pipeline.
 *
 * Available from within a Scene via `this.lights`.
 *
 * Add Lights using the {@link Phaser.GameObjects.LightsManager#addLight} method:
 *
 * ```javascript
 * // Enable the Lights Manager because it is disabled by default
 * this.lights.enable();
 *
 * // Create a Light at [400, 300] with a radius of 200
 * this.lights.addLight(400, 300, 200);
 * ```
 *
 * For Game Objects to be affected by the Lights when rendered, you will need to set them to use the `Light2D` pipeline like so:
 *
 * ```javascript
 * sprite.setPipeline('Light2D');
 * ```
 *
 * Note that you cannot use this pipeline on Graphics Game Objects or Shape Game Objects.
 *
 * @class LightsPlugin
 * @extends Phaser.GameObjects.LightsManager
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Lights Plugin belongs to.
 */ var LightsPlugin = new Class({
                    Extends: LightsManager,
                    initialize: function LightsPlugin(scene) {
                        /**
         * A reference to the Scene that this Lights Plugin belongs to.
         *
         * @name Phaser.GameObjects.LightsPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene's systems.
         *
         * @name Phaser.GameObjects.LightsPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        if (!scene.sys.settings.isBooted) scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        LightsManager.call(this);
                    },
                    /**
     * Boot the Lights Plugin.
     *
     * @method Phaser.GameObjects.LightsPlugin#boot
     * @since 3.0.0
     */ boot: function() {
                        var eventEmitter = this.systems.events;
                        eventEmitter.on(SceneEvents.SHUTDOWN, this.shutdown, this);
                        eventEmitter.on(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * Destroy the Lights Plugin.
     *
     * Cleans up all references.
     *
     * @method Phaser.GameObjects.LightsPlugin#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.scene = undefined;
                        this.systems = undefined;
                    }
                });
                PluginCache.register('LightsPlugin', LightsPlugin, 'lights');
                module1.exports = LightsPlugin;
            /***/ },
            /***/ 4703: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var DegToRad = __webpack_require__(39506);
                var Face = __webpack_require__(83997);
                var GameObject = __webpack_require__(95643);
                var GenerateObjVerts = __webpack_require__(34684);
                var GenerateVerts = __webpack_require__(92515);
                var GetCalcMatrix = __webpack_require__(91296);
                var Matrix4 = __webpack_require__(37867);
                var MeshRender = __webpack_require__(29807);
                var RadToDeg = __webpack_require__(43396);
                var StableSort = __webpack_require__(19186);
                var Vector3 = __webpack_require__(25836);
                var Vertex = __webpack_require__(39318);
                /**
 * @classdesc
 * A Mesh Game Object.
 *
 * The Mesh Game Object allows you to render a group of textured vertices and manipulate
 * the view of those vertices, such as rotation, translation or scaling.
 *
 * Support for generating mesh data from grids, model data or Wavefront OBJ Files is included.
 *
 * Although you can use this to render 3D objects, its primary use is for displaying more complex
 * Sprites, or Sprites where you need fine-grained control over the vertex positions in order to
 * achieve special effects in your games. Note that rendering still takes place using Phaser's
 * orthographic camera (after being transformed via `projectionMesh`, see `setPerspective`,
 * `setOrtho`, and `panZ` methods). As a result, all depth and face tests are done in an eventually
 * orthographic space.
 *
 * The rendering process will iterate through the faces of this Mesh and render out each face
 * that is considered as being in view of the camera. No depth buffer is used, and because of this,
 * you should be careful not to use model data with too many vertices, or overlapping geometry,
 * or you'll probably encounter z-depth fighting. The Mesh was designed to allow for more advanced
 * 2D layouts, rather than displaying 3D objects, even though it can do this to a degree.
 *
 * In short, if you want to remake Crysis, use a 3D engine, not a Mesh. However, if you want
 * to easily add some small fun 3D elements into your game, or create some special effects involving
 * vertex warping, this is the right object for you. Mesh data becomes part of the WebGL batch,
 * just like standard Sprites, so doesn't introduce any additional shader overhead. Because
 * the Mesh just generates vertices into the WebGL batch, like any other Sprite, you can use all of
 * the common Game Object components on a Mesh too, such as a custom pipeline, mask, blend mode
 * or texture.
 *
 * Note that the Mesh object is WebGL only and does not have a Canvas counterpart.
 *
 * The Mesh origin is always 0.5 x 0.5 and cannot be changed.
 *
 * @class Mesh
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x] - The horizontal position of this Game Object in the world.
 * @param {number} [y] - The vertical position of this Game Object in the world.
 * @param {string|Phaser.Textures.Texture} [texture] - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {string|number} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {number[]} [vertices] - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true` (but see note).
 * @param {number[]} [uvs] - The UVs pairs array.
 * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
 * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component? Note: If not, it will be assumed `z=0`, see method `panZ` or `setOrtho`.
 * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
 * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
 * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
 */ var Mesh = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Mask,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Size,
                        Components.Texture,
                        Components.Transform,
                        Components.Visible,
                        MeshRender
                    ],
                    initialize: function Mesh(scene, x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (texture === undefined) texture = '__WHITE';
                        GameObject.call(this, scene, 'Mesh');
                        /**
         * An array containing the Face instances belonging to this Mesh.
         *
         * A Face consists of 3 Vertex objects.
         *
         * This array is populated during calls such as `addVertices` or `addOBJ`.
         *
         * @name Phaser.GameObjects.Mesh#faces
         * @type {Phaser.Geom.Mesh.Face[]}
         * @since 3.50.0
         */ this.faces = [];
                        /**
         * An array containing Vertex instances. One instance per vertex in this Mesh.
         *
         * This array is populated during calls such as `addVertex` or `addOBJ`.
         *
         * @name Phaser.GameObjects.Mesh#vertices
         * @type {Phaser.Geom.Mesh.Vertex[]}
         * @since 3.50.0
         */ this.vertices = [];
                        /**
         * The tint fill mode.
         *
         * `false` = An additive tint (the default), where vertices colors are blended with the texture.
         * `true` = A fill tint, where the vertex colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.Mesh#tintFill
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.tintFill = false;
                        /**
         * You can optionally choose to render the vertices of this Mesh to a Graphics instance.
         *
         * Achieve this by setting the `debugCallback` and the `debugGraphic` properties.
         *
         * You can do this in a single call via the `Mesh.setDebug` method, which will use the
         * built-in debug function. You can also set it to your own callback. The callback
         * will be invoked _once per render_ and sent the following parameters:
         *
         * `debugCallback(src, meshLength, verts)`
         *
         * `src` is the Mesh instance being debugged.
         * `meshLength` is the number of mesh vertices in total.
         * `verts` is an array of the translated vertex coordinates.
         *
         * To disable rendering, set this property back to `null`.
         *
         * Please note that high vertex count Meshes will struggle to debug properly.
         *
         * @name Phaser.GameObjects.Mesh#debugCallback
         * @type {function}
         * @since 3.50.0
         */ this.debugCallback = null;
                        /**
         * The Graphics instance that the debug vertices will be drawn to, if `setDebug` has
         * been called.
         *
         * @name Phaser.GameObjects.Mesh#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.50.0
         */ this.debugGraphic = null;
                        /**
         * When rendering, skip any Face that isn't counter clockwise?
         *
         * Enable this to hide backward-facing Faces during rendering.
         *
         * Disable it to render all Faces.
         *
         * @name Phaser.GameObjects.Mesh#hideCCW
         * @type {boolean}
         * @since 3.50.0
         */ this.hideCCW = true;
                        /**
         * A Vector3 containing the 3D position of the vertices in this Mesh.
         *
         * Modifying the components of this property will allow you to reposition where
         * the vertices are rendered within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * You can also adjust the 'view' by using the `pan` methods.
         *
         * @name Phaser.GameObjects.Mesh#modelPosition
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelPosition = new Vector3();
                        /**
         * A Vector3 containing the 3D scale of the vertices in this Mesh.
         *
         * Modifying the components of this property will allow you to scale
         * the vertices within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#modelScale
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelScale = new Vector3(1, 1, 1);
                        /**
         * A Vector3 containing the 3D rotation of the vertices in this Mesh.
         *
         * The values should be given in radians, i.e. to rotate the vertices by 90
         * degrees you can use `modelRotation.x = Phaser.Math.DegToRad(90)`.
         *
         * Modifying the components of this property will allow you to rotate
         * the vertices within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#modelRotation
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelRotation = new Vector3();
                        /**
         * An internal cache, used to compare position, rotation, scale and face data
         * each frame, to avoid math calculations in `preUpdate`.
         *
         * Cache structure = position xyz | rotation xyz | scale xyz | face count | view | ortho
         *
         * @name Phaser.GameObjects.Mesh#dirtyCache
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.dirtyCache = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ];
                        /**
         * The transformation matrix for this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#transformMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.transformMatrix = new Matrix4();
                        /**
         * The view position for this Mesh.
         *
         * Use the methods`panX`, `panY` and `panZ` to adjust the view.
         *
         * @name Phaser.GameObjects.Mesh#viewPosition
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.viewPosition = new Vector3();
                        /**
         * The view matrix for this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#viewMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.viewMatrix = new Matrix4();
                        /**
         * The projection matrix for this Mesh.
         *
         * Update it with the `setPerspective` or `setOrtho` methods.
         *
         * @name Phaser.GameObjects.Mesh#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix = new Matrix4();
                        /**
         * How many faces were rendered by this Mesh Game Object in the last
         * draw? This is reset in the `preUpdate` method and then incremented
         * each time a face is drawn. Note that in multi-camera Scenes this
         * value may exceed that found in `Mesh.getFaceCount` due to
         * cameras drawing the same faces more than once.
         *
         * @name Phaser.GameObjects.Mesh#totalRendered
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.totalRendered = 0;
                        /**
         * Internal cache var for the total number of faces rendered this frame.
         *
         * See `totalRendered` instead for the actual value.
         *
         * @name Phaser.GameObjects.Mesh#totalFrame
         * @type {number}
         * @private
         * @since 3.50.0
         */ this.totalFrame = 0;
                        /**
         * By default, the Mesh will check to see if its model or view transform has
         * changed each frame and only recalculate the vertex positions if they have.
         *
         * This avoids lots of additional math in the `preUpdate` step when not required.
         *
         * However, if you are performing per-Face or per-Vertex manipulation on this Mesh,
         * such as tweening a Face, or moving it without moving the rest of the Mesh,
         * then you may need to disable the dirty cache in order for the Mesh to re-render
         * correctly. You can toggle this property to do that. Please note that leaving
         * this set to `true` will cause the Mesh to recalculate the position of every single
         * vertex in it, every single frame. So only really do this if you know you
         * need it.
         *
         * @name Phaser.GameObjects.Mesh#ignoreDirtyCache
         * @type {boolean}
         * @since 3.50.0
         */ this.ignoreDirtyCache = false;
                        /**
         * The Camera fov (field of view) in degrees.
         *
         * This is set automatically as part of the `Mesh.setPerspective` call, but exposed
         * here for additional math.
         *
         * Do not modify this property directly, doing so will not change the fov. For that,
         * call the respective Mesh methods.
         *
         * @name Phaser.GameObjects.Mesh#fov
         * @type {number}
         * @readonly
         * @since 3.60.0
         */ this.fov;
                        //  Set these to allow setInteractive to work
                        this.displayOriginX = 0;
                        this.displayOriginY = 0;
                        var renderer = scene.sys.renderer;
                        this.setPosition(x, y);
                        this.setTexture(texture, frame);
                        this.setSize(renderer.width, renderer.height);
                        this.initPipeline();
                        this.initPostPipeline();
                        this.setPerspective(renderer.width, renderer.height);
                        if (vertices) this.addVertices(vertices, uvs, indicies, containsZ, normals, colors, alphas);
                    },
                    //  Overrides Game Object method
                    addedToScene: function() {
                        this.scene.sys.updateList.add(this);
                    },
                    //  Overrides Game Object method
                    removedFromScene: function() {
                        this.scene.sys.updateList.remove(this);
                    },
                    /**
     * Translates the view position of this Mesh on the x axis by the given amount.
     *
     * @method Phaser.GameObjects.Mesh#panX
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panX: function(v) {
                        this.viewPosition.addScale(Vector3.LEFT, v);
                        this.dirtyCache[10] = 1;
                        return this;
                    },
                    /**
     * Translates the view position of this Mesh on the y axis by the given amount.
     *
     * @method Phaser.GameObjects.Mesh#panY
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panY: function(v) {
                        this.viewPosition.y += Vector3.DOWN.y * v;
                        this.dirtyCache[10] = 1;
                        return this;
                    },
                    /**
     * Translates the view position of this Mesh on the z axis by the given amount.
     *
     * As the default `panZ` value is 0, vertices with `z=0` (the default) need special
     * care or else they will not display as they are "behind" the camera.
     *
     * Consider using `mesh.panZ(mesh.height / (2 * Math.tan(Math.PI / 16)))`,
     * which will interpret vertex geometry 1:1 with pixel geometry (or see `setOrtho`).
     *
     * @method Phaser.GameObjects.Mesh#panZ
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panZ: function(amount) {
                        this.viewPosition.z += amount;
                        this.dirtyCache[10] = 1;
                        return this;
                    },
                    /**
     * Builds a new perspective projection matrix from the given values.
     *
     * These are also the initial projection matrix and parameters for `Mesh` (see `Mesh.panZ` for more discussion).
     *
     * See also `setOrtho`.
     *
     * @method Phaser.GameObjects.Mesh#setPerspective
     * @since 3.50.0
     *
     * @param {number} width - The width of the projection matrix. Typically the same as the Mesh and/or Renderer.
     * @param {number} height - The height of the projection matrix. Typically the same as the Mesh and/or Renderer.
     * @param {number} [fov=45] - The field of view, in degrees.
     * @param {number} [near=0.01] - The near value of the view.
     * @param {number} [far=1000] - The far value of the view.
     */ setPerspective: function(width, height, fov, near, far) {
                        if (fov === undefined) fov = 45;
                        if (near === undefined) near = 0.01;
                        if (far === undefined) far = 1000;
                        this.fov = fov;
                        this.projectionMatrix.perspective(DegToRad(fov), width / height, near, far);
                        this.dirtyCache[10] = 1;
                        this.dirtyCache[11] = 0;
                        return this;
                    },
                    /**
     * Builds a new orthographic projection matrix from the given values.
     *
     * If using this mode you will often need to set `Mesh.hideCCW` to `false` as well.
     *
     * By default, calling this method with no parameters will set the scaleX value to
     * match the renderer's aspect ratio. If you would like to render vertex positions 1:1
     * to pixel positions, consider calling as `mesh.setOrtho(mesh.width, mesh.height)`.
     *
     * See also `setPerspective`.
     *
     * @method Phaser.GameObjects.Mesh#setOrtho
     * @since 3.50.0
     *
     * @param {number} [scaleX=1] - The default horizontal scale in relation to the Mesh / Renderer dimensions.
     * @param {number} [scaleY=1] - The default vertical scale in relation to the Mesh / Renderer dimensions.
     * @param {number} [near=-1000] - The near value of the view.
     * @param {number} [far=1000] - The far value of the view.
     */ setOrtho: function(scaleX, scaleY, near, far) {
                        if (scaleX === undefined) scaleX = this.scene.sys.renderer.getAspectRatio();
                        if (scaleY === undefined) scaleY = 1;
                        if (near === undefined) near = -1000;
                        if (far === undefined) far = 1000;
                        this.fov = 0;
                        this.projectionMatrix.ortho(-scaleX, scaleX, -scaleY, scaleY, near, far);
                        this.dirtyCache[10] = 1;
                        this.dirtyCache[11] = 1;
                        return this;
                    },
                    /**
     * Iterates and destroys all current Faces in this Mesh, then resets the
     * `faces` and `vertices` arrays.
     *
     * @method Phaser.GameObjects.Mesh#clear
     * @since 3.50.0
     *
     * @return {this} This Mesh Game Object.
     */ clear: function() {
                        this.faces.forEach(function(face) {
                            face.destroy();
                        });
                        this.faces = [];
                        this.vertices = [];
                        return this;
                    },
                    /**
     * This method will add the data from a triangulated Wavefront OBJ model file to this Mesh.
     *
     * The data should have been loaded via the OBJFile:
     *
     * ```javascript
     * this.load.obj(key, url);
     * ```
     *
     * Then use the same `key` as the first parameter to this method.
     *
     * Multiple Mesh Game Objects can use the same model data without impacting on each other.
     *
     * Make sure your 3D package has triangulated the model data prior to exporting it.
     *
     * You can add multiple models to a single Mesh, although they will act as one when
     * moved or rotated. You can scale the model data, should it be too small, or too large, to see.
     * You can also offset the vertices of the model via the `x`, `y` and `z` parameters.
     *
     * @method Phaser.GameObjects.Mesh#addVerticesFromObj
     * @since 3.50.0
     *
     * @param {string} key - The key of the model data in the OBJ Cache to add to this Mesh.
     * @param {number} [scale=1] - An amount to scale the model data by. Use this if the model has exported too small, or large, to see.
     * @param {number} [x=0] - Translate the model x position by this amount.
     * @param {number} [y=0] - Translate the model y position by this amount.
     * @param {number} [z=0] - Translate the model z position by this amount.
     * @param {number} [rotateX=0] - Rotate the model on the x axis by this amount, in radians.
     * @param {number} [rotateY=0] - Rotate the model on the y axis by this amount, in radians.
     * @param {number} [rotateZ=0] - Rotate the model on the z axis by this amount, in radians.
     * @param {boolean} [zIsUp=true] - Is the z axis up (true), or is y axis up (false)?
     *
     * @return {this} This Mesh Game Object.
     */ addVerticesFromObj: function(key, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp) {
                        var data = this.scene.sys.cache.obj.get(key);
                        var parsedData;
                        if (data) parsedData = GenerateObjVerts(data, this, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp);
                        if (!parsedData || parsedData.verts.length === 0) console.warn('Mesh.addVerticesFromObj data empty:', key);
                        return this;
                    },
                    /**
     * Compare the depth of two Faces.
     *
     * @method Phaser.GameObjects.Mesh#sortByDepth
     * @since 3.50.0
     *
     * @param {Phaser.Geom.Mesh.Face} faceA - The first Face.
     * @param {Phaser.Geom.Mesh.Face} faceB - The second Face.
     *
     * @return {number} The difference between the depths of each Face.
     */ sortByDepth: function(faceA, faceB) {
                        return faceA.depth - faceB.depth;
                    },
                    /**
     * Runs a depth sort across all Faces in this Mesh, comparing their averaged depth.
     *
     * This is called automatically if you use any of the `rotate` methods, but you can
     * also invoke it to sort the Faces should you manually position them.
     *
     * @method Phaser.GameObjects.Mesh#depthSort
     * @since 3.50.0
     *
     * @return {this} This Mesh Game Object.
     */ depthSort: function() {
                        StableSort(this.faces, this.sortByDepth);
                        return this;
                    },
                    /**
     * Adds a new Vertex into the vertices array of this Mesh.
     *
     * Just adding a vertex isn't enough to render it. You need to also
     * make it part of a Face, with 3 Vertex instances per Face.
     *
     * @method Phaser.GameObjects.Mesh#addVertex
     * @since 3.50.0
     *
     * @param {number} x - The x position of the vertex.
     * @param {number} y - The y position of the vertex.
     * @param {number} z - The z position of the vertex.
     * @param {number} u - The UV u coordinate of the vertex.
     * @param {number} v - The UV v coordinate of the vertex.
     * @param {number} [color=0xffffff] - The color value of the vertex.
     * @param {number} [alpha=1] - The alpha value of the vertex.
     *
     * @return {this} This Mesh Game Object.
     */ addVertex: function(x, y, z, u, v, color, alpha) {
                        var vert = new Vertex(x, y, z, u, v, color, alpha);
                        this.vertices.push(vert);
                        return vert;
                    },
                    /**
     * Adds a new Face into the faces array of this Mesh.
     *
     * A Face consists of references to 3 Vertex instances, which must be provided.
     *
     * @method Phaser.GameObjects.Mesh#addFace
     * @since 3.50.0
     *
     * @param {Phaser.Geom.Mesh.Vertex} vertex1 - The first vertex of the Face.
     * @param {Phaser.Geom.Mesh.Vertex} vertex2 - The second vertex of the Face.
     * @param {Phaser.Geom.Mesh.Vertex} vertex3 - The third vertex of the Face.
     *
     * @return {this} This Mesh Game Object.
     */ addFace: function(vertex1, vertex2, vertex3) {
                        var face = new Face(vertex1, vertex2, vertex3);
                        this.faces.push(face);
                        this.dirtyCache[9] = -1;
                        return face;
                    },
                    /**
     * Adds new vertices to this Mesh by parsing the given data.
     *
     * This method will take vertex data in one of two formats, based on the `containsZ` parameter.
     *
     * If your vertex data are `x`, `y` pairs, then `containsZ` should be `false` (this is the default, and will result in `z=0` for each vertex).
     *
     * If your vertex data is groups of `x`, `y` and `z` values, then the `containsZ` parameter must be true.
     *
     * The `uvs` parameter is a numeric array consisting of `u` and `v` pairs.
     *
     * The `normals` parameter is a numeric array consisting of `x`, `y` vertex normal values and, if `containsZ` is true, `z` values as well.
     *
     * The `indicies` parameter is an optional array that, if given, is an indexed list of vertices to be added.
     *
     * The `colors` parameter is an optional array, or single value, that if given sets the color of each vertex created.
     *
     * The `alphas` parameter is an optional array, or single value, that if given sets the alpha of each vertex created.
     *
     * When providing indexed data it is assumed that _all_ of the arrays are indexed, not just the vertices.
     *
     * The following example will create a 256 x 256 sized quad using an index array:
     *
     * ```javascript
     * let mesh = new Mesh(this);  // Assuming `this` is a scene!
     * const vertices = [
     *   -128, 128,
     *   128, 128,
     *   -128, -128,
     *   128, -128
     * ];
     *
     * const uvs = [
     *   0, 1,
     *   1, 1,
     *   0, 0,
     *   1, 0
     * ];
     *
     * const indices = [ 0, 2, 1, 2, 3, 1 ];
     *
     * mesh.addVertices(vertices, uvs, indicies);
     * // Note: Otherwise the added points will be "behind" the camera! This value will project vertex `x` & `y` values 1:1 to pixel values.
     * mesh.hideCCW = false;
     * mesh.setOrtho(mesh.width, mesh.height);
     * ```
     *
     * If the data is not indexed, it's assumed that the arrays all contain sequential data.
     *
     * @method Phaser.GameObjects.Mesh#addVertices
     * @since 3.50.0
     *
     * @param {number[]} vertices - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true`.
     * @param {number[]} uvs - The UVs pairs array.
     * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
     * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component? If not, it will be assumed `z=0`, see methods `panZ` or `setOrtho`.
     * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
     * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
     * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
     *
     * @return {this} This Mesh Game Object.
     */ addVertices: function(vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                        var result = GenerateVerts(vertices, uvs, indicies, containsZ, normals, colors, alphas);
                        if (result) {
                            this.faces = this.faces.concat(result.faces);
                            this.vertices = this.vertices.concat(result.vertices);
                        } else console.warn('Mesh.addVertices data empty or invalid');
                        this.dirtyCache[9] = -1;
                        return this;
                    },
                    /**
     * Returns the total number of Faces in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getFaceCount
     * @since 3.50.0
     *
     * @return {number} The number of Faces in this Mesh Game Object.
     */ getFaceCount: function() {
                        return this.faces.length;
                    },
                    /**
     * Returns the total number of Vertices in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getVertexCount
     * @since 3.50.0
     *
     * @return {number} The number of Vertices in this Mesh Game Object.
     */ getVertexCount: function() {
                        return this.vertices.length;
                    },
                    /**
     * Returns the Face at the given index in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getFace
     * @since 3.50.0
     *
     * @param {number} index - The index of the Face to get.
     *
     * @return {Phaser.Geom.Mesh.Face} The Face at the given index, or `undefined` if index out of range.
     */ getFace: function(index) {
                        return this.faces[index];
                    },
                    /**
     * Tests to see if _any_ face in this Mesh intersects with the given coordinates.
     *
     * The given position is translated through the matrix of this Mesh and the given Camera,
     * before being compared against the vertices.
     *
     * @method Phaser.GameObjects.Mesh#hasFaceAt
     * @since 3.60.0
     *
     * @param {number} x - The x position to check against.
     * @param {number} y - The y position to check against.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The camera to pass the coordinates through. If not give, the default Scene Camera is used.
     *
     * @return {boolean} Returns `true` if _any_ face of this Mesh intersects with the given coordinate, otherwise `false`.
     */ hasFaceAt: function(x, y, camera) {
                        if (camera === undefined) camera = this.scene.sys.cameras.main;
                        var calcMatrix = GetCalcMatrix(this, camera).calc;
                        var faces = this.faces;
                        for(var i = 0; i < faces.length; i++){
                            var face = faces[i];
                            if (face.contains(x, y, calcMatrix)) return true;
                        }
                        return false;
                    },
                    /**
     * Return an array of Face objects from this Mesh that intersect with the given coordinates.
     *
     * The given position is translated through the matrix of this Mesh and the given Camera,
     * before being compared against the vertices.
     *
     * If more than one Face intersects, they will all be returned in the array, but the array will
     * be depth sorted first, so the first element will always be that closest to the camera.
     *
     * @method Phaser.GameObjects.Mesh#getFaceAt
     * @since 3.50.0
     *
     * @param {number} x - The x position to check against.
     * @param {number} y - The y position to check against.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The camera to pass the coordinates through. If not give, the default Scene Camera is used.
     *
     * @return {Phaser.Geom.Mesh.Face[]} An array of Face objects that intersect with the given point, ordered by depth.
     */ getFaceAt: function(x, y, camera) {
                        if (camera === undefined) camera = this.scene.sys.cameras.main;
                        var calcMatrix = GetCalcMatrix(this, camera).calc;
                        var faces = this.faces;
                        var results = [];
                        for(var i = 0; i < faces.length; i++){
                            var face = faces[i];
                            if (face.contains(x, y, calcMatrix)) results.push(face);
                        }
                        return StableSort(results, this.sortByDepth);
                    },
                    /**
     * This method enables rendering of the Mesh vertices to the given Graphics instance.
     *
     * If you enable this feature, you **must** call `Graphics.clear()` in your Scene `update`,
     * otherwise the Graphics instance you provide to debug will fill-up with draw calls,
     * eventually crashing the browser. This is not done automatically to allow you to debug
     * draw multiple Mesh objects to a single Graphics instance.
     *
     * The Mesh class has a built-in debug rendering callback `Mesh.renderDebug`, however
     * you can also provide your own callback to be used instead. Do this by setting the `callback` parameter.
     *
     * The callback is invoked _once per render_ and sent the following parameters:
     *
     * `callback(src, faces)`
     *
     * `src` is the Mesh instance being debugged.
     * `faces` is an array of the Faces that were rendered.
     *
     * You can get the final drawn vertex position from a Face object like this:
     *
     * ```javascript
     * let face = faces[i];
     *
     * let x0 = face.vertex1.tx;
     * let y0 = face.vertex1.ty;
     * let x1 = face.vertex2.tx;
     * let y1 = face.vertex2.ty;
     * let x2 = face.vertex3.tx;
     * let y2 = face.vertex3.ty;
     *
     * graphic.strokeTriangle(x0, y0, x1, y1, x2, y2);
     * ```
     *
     * If using your own callback you do not have to provide a Graphics instance to this method.
     *
     * To disable debug rendering, to either your own callback or the built-in one, call this method
     * with no arguments.
     *
     * @method Phaser.GameObjects.Mesh#setDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Graphics} [graphic] - The Graphic instance to render to if using the built-in callback.
     * @param {function} [callback] - The callback to invoke during debug render. Leave as undefined to use the built-in callback.
     *
     * @return {this} This Game Object instance.
     */ setDebug: function(graphic, callback) {
                        this.debugGraphic = graphic;
                        if (!graphic && !callback) this.debugCallback = null;
                        else if (!callback) this.debugCallback = this.renderDebug;
                        else this.debugCallback = callback;
                        return this;
                    },
                    /**
     * Checks if the transformation data in this mesh is dirty.
     *
     * This is used internally by the `preUpdate` step to determine if the vertices should
     * be recalculated or not.
     *
     * @method Phaser.GameObjects.Mesh#isDirty
     * @since 3.50.0
     *
     * @return {boolean} Returns `true` if the data of this mesh is dirty, otherwise `false`.
     */ isDirty: function() {
                        var position = this.modelPosition;
                        var rotation = this.modelRotation;
                        var scale = this.modelScale;
                        var dirtyCache = this.dirtyCache;
                        var px = position.x;
                        var py = position.y;
                        var pz = position.z;
                        var rx = rotation.x;
                        var ry = rotation.y;
                        var rz = rotation.z;
                        var sx = scale.x;
                        var sy = scale.y;
                        var sz = scale.z;
                        var faces = this.getFaceCount();
                        var pxCached = dirtyCache[0];
                        var pyCached = dirtyCache[1];
                        var pzCached = dirtyCache[2];
                        var rxCached = dirtyCache[3];
                        var ryCached = dirtyCache[4];
                        var rzCached = dirtyCache[5];
                        var sxCached = dirtyCache[6];
                        var syCached = dirtyCache[7];
                        var szCached = dirtyCache[8];
                        var fCached = dirtyCache[9];
                        dirtyCache[0] = px;
                        dirtyCache[1] = py;
                        dirtyCache[2] = pz;
                        dirtyCache[3] = rx;
                        dirtyCache[4] = ry;
                        dirtyCache[5] = rz;
                        dirtyCache[6] = sx;
                        dirtyCache[7] = sy;
                        dirtyCache[8] = sz;
                        dirtyCache[9] = faces;
                        return pxCached !== px || pyCached !== py || pzCached !== pz || rxCached !== rx || ryCached !== ry || rzCached !== rz || sxCached !== sx || syCached !== sy || szCached !== sz || fCached !== faces;
                    },
                    /**
     * The Mesh update loop. The following takes place in this method:
     *
     * First, the `totalRendered` and `totalFrame` properties are set.
     *
     * If the view matrix of this Mesh isn't dirty, and the model position, rotate or scale properties are
     * all clean, then the method returns at this point.
     *
     * Otherwise, if the viewPosition is dirty (i.e. from calling a method like `panZ`), then it will
     * refresh the viewMatrix.
     *
     * After this, a new transformMatrix is built and it then iterates through all Faces in this
     * Mesh, calling `transformCoordinatesLocal` on all of them. Internally, this updates every
     * vertex, calculating its new transformed position, based on the new transform matrix.
     *
     * Finally, the faces are depth sorted.
     *
     * @method Phaser.GameObjects.Mesh#preUpdate
     * @protected
     * @since 3.50.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function() {
                        this.totalRendered = this.totalFrame;
                        this.totalFrame = 0;
                        var dirty = this.dirtyCache;
                        if (!this.ignoreDirtyCache && !dirty[10] && !this.isDirty()) //  If neither the view or the mesh is dirty we can bail out and save lots of math
                        return;
                        var width = this.width;
                        var height = this.height;
                        var viewMatrix = this.viewMatrix;
                        var viewPosition = this.viewPosition;
                        if (dirty[10]) {
                            viewMatrix.identity();
                            viewMatrix.translate(viewPosition);
                            viewMatrix.invert();
                            dirty[10] = 0;
                        }
                        var transformMatrix = this.transformMatrix;
                        transformMatrix.setWorldMatrix(this.modelRotation, this.modelPosition, this.modelScale, this.viewMatrix, this.projectionMatrix);
                        var z = viewPosition.z;
                        var faces = this.faces;
                        for(var i = 0; i < faces.length; i++)faces[i].transformCoordinatesLocal(transformMatrix, width, height, z);
                        this.depthSort();
                    },
                    /**
     * The built-in Mesh debug rendering method.
     *
     * See `Mesh.setDebug` for more details.
     *
     * @method Phaser.GameObjects.Mesh#renderDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Mesh} src - The Mesh object being rendered.
     * @param {Phaser.Geom.Mesh.Face[]} faces - An array of Faces.
     */ renderDebug: function(src, faces) {
                        var graphic = src.debugGraphic;
                        for(var i = 0; i < faces.length; i++){
                            var face = faces[i];
                            var x0 = face.vertex1.tx;
                            var y0 = face.vertex1.ty;
                            var x1 = face.vertex2.tx;
                            var y1 = face.vertex2.ty;
                            var x2 = face.vertex3.tx;
                            var y2 = face.vertex3.ty;
                            graphic.strokeTriangle(x0, y0, x1, y1, x2, y2);
                        }
                    },
                    /**
     * Handles the pre-destroy step for the Mesh, which removes the vertices and debug callbacks.
     *
     * @method Phaser.GameObjects.Mesh#preDestroy
     * @private
     * @since 3.50.0
     */ preDestroy: function() {
                        this.clear();
                        this.debugCallback = null;
                        this.debugGraphic = null;
                    },
                    /**
     * Clears all tint values associated with this Game Object.
     *
     * Immediately sets the color values back to 0xffffff on all vertices,
     * which results in no visible change to the texture.
     *
     * @method Phaser.GameObjects.Mesh#clearTint
     * @webglOnly
     * @since 3.60.0
     *
     * @return {this} This Game Object instance.
     */ clearTint: function() {
                        return this.setTint();
                    },
                    /**
     * Pass this Mesh Game Object to the Input Manager to enable it for Input.
     *
     * Unlike other Game Objects, the Mesh Game Object uses its own special hit area callback, which you cannot override.
     *
     * @example
     * mesh.setInteractive();
     * 
     * @example
     * mesh.setInteractive({ useHandCursor: true });
     *
     * @method Phaser.GameObjects.Mesh#setInteractive
     * @since 3.60.0
     * 
     * @param {(Phaser.Types.Input.InputConfiguration)} [config] - An input configuration object but it will ignore hitArea, hitAreaCallback and pixelPerfect with associated alphaTolerance properties.
     *
     * @return {this} This GameObject.
     */ setInteractive: function(config) {
                        if (config === undefined) config = {};
                        var hitAreaCallback = (function(area, x, y) {
                            var faces = this.faces;
                            for(var i = 0; i < faces.length; i++){
                                var face = faces[i];
                                //  Don't pass a calcMatrix, as the x/y are already transformed
                                if (face.contains(x, y)) return true;
                            }
                            return false;
                        }).bind(this);
                        this.scene.sys.input.enable(this, config, hitAreaCallback);
                        return this;
                    },
                    /**
     * Sets an additive tint on all vertices of this Mesh Game Object.
     *
     * The tint works by taking the pixel color values from the Game Objects texture, and then
     * multiplying it by the color value of the tint.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property to set all colors at once.
     *
     * To remove a tint call `clearTint`.
     *
     * @method Phaser.GameObjects.Mesh#setTint
     * @webglOnly
     * @since 3.60.0
     *
     * @param {number} [tint=0xffffff] - The tint being applied to all vertices of this Mesh Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTint: function(tint) {
                        if (tint === undefined) tint = 0xffffff;
                        var vertices = this.vertices;
                        for(var i = 0; i < vertices.length; i++)vertices[i].color = tint;
                        return this;
                    },
                    /**
     * Scrolls the UV texture coordinates of all faces in this Mesh by
     * adding the given x/y amounts to them.
     *
     * If you only wish to scroll one coordinate, pass a value of zero
     * to the other.
     *
     * Use small values for scrolling. UVs are set from the range 0
     * to 1, so you should increment (or decrement) them by suitably
     * small values, such as 0.01.
     *
     * Due to a limitation in WebGL1 you can only UV scroll textures
     * that are a power-of-two in size. Scrolling NPOT textures will
     * work but will result in clamping the pixels to the edges.
     *
     * Note that if this Mesh is using a _frame_ from a texture atlas
     * then you will be unable to UV scroll its texture.
     *
     * @method Phaser.GameObjects.Mesh#uvScroll
     * @webglOnly
     * @since 3.60.0
     *
     * @param {number} x - The amount to horizontally shift the UV coordinates by.
     * @param {number} y - The amount to vertically shift the UV coordinates by.
     *
     * @return {this} This Game Object instance.
     */ uvScroll: function(x, y) {
                        var faces = this.faces;
                        for(var i = 0; i < faces.length; i++)faces[i].scrollUV(x, y);
                        return this;
                    },
                    /**
     * Scales the UV texture coordinates of all faces in this Mesh by
     * the exact given amounts.
     *
     * If you only wish to scale one coordinate, pass a value of one
     * to the other.
     *
     * Due to a limitation in WebGL1 you can only UV scale textures
     * that are a power-of-two in size. Scaling NPOT textures will
     * work but will result in clamping the pixels to the edges if
     * you scale beyond a value of 1. Scaling below 1 will work
     * regardless of texture size.
     *
     * Note that if this Mesh is using a _frame_ from a texture atlas
     * then you will be unable to UV scale its texture.
     *
     * @method Phaser.GameObjects.Mesh#uvScale
     * @webglOnly
     * @since 3.60.0
     *
     * @param {number} x - The amount to horizontally scale the UV coordinates by.
     * @param {number} y - The amount to vertically scale the UV coordinates by.
     *
     * @return {this} This Game Object instance.
     */ uvScale: function(x, y) {
                        var faces = this.faces;
                        for(var i = 0; i < faces.length; i++)faces[i].scaleUV(x, y);
                        return this;
                    },
                    /**
     * The tint value being applied to the whole of the Game Object.
     * This property is a setter-only.
     *
     * @method Phaser.GameObjects.Mesh#tint
     * @type {number}
     * @webglOnly
     * @since 3.60.0
     */ tint: {
                        set: function(value) {
                            this.setTint(value);
                        }
                    },
                    /**
     * The x rotation of the Model in 3D space, as specified in degrees.
     *
     * If you need the value in radians use the `modelRotation.x` property directly.
     *
     * @method Phaser.GameObjects.Mesh#rotateX
     * @type {number}
     * @since 3.60.0
     */ rotateX: {
                        get: function() {
                            return RadToDeg(this.modelRotation.x);
                        },
                        set: function(value) {
                            this.modelRotation.x = DegToRad(value);
                        }
                    },
                    /**
     * The y rotation of the Model in 3D space, as specified in degrees.
     *
     * If you need the value in radians use the `modelRotation.y` property directly.
     *
     * @method Phaser.GameObjects.Mesh#rotateY
     * @type {number}
     * @since 3.60.0
     */ rotateY: {
                        get: function() {
                            return RadToDeg(this.modelRotation.y);
                        },
                        set: function(value) {
                            this.modelRotation.y = DegToRad(value);
                        }
                    },
                    /**
     * The z rotation of the Model in 3D space, as specified in degrees.
     *
     * If you need the value in radians use the `modelRotation.z` property directly.
     *
     * @method Phaser.GameObjects.Mesh#rotateZ
     * @type {number}
     * @since 3.60.0
     */ rotateZ: {
                        get: function() {
                            return RadToDeg(this.modelRotation.z);
                        },
                        set: function(value) {
                            this.modelRotation.z = DegToRad(value);
                        }
                    }
                });
                module1.exports = Mesh;
            /***/ },
            /***/ 36488: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Mesh.Render. There is no Canvas renderer for Mesh objects.
 *
 * @method Phaser.GameObjects.Mesh#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var MeshCanvasRenderer = function() {};
                module1.exports = MeshCanvasRenderer;
            /***/ },
            /***/ 20527: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetValue = __webpack_require__(35154);
                var Mesh = __webpack_require__(4703);
                /**
 * Creates a new Mesh Game Object and returns it.
 *
 * Note: This method will only be available if the Mesh Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#mesh
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Mesh.MeshConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Mesh} The Game Object that was created.
 */ GameObjectCreator.register('mesh', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var frame = GetAdvancedValue(config, 'frame', null);
                    var vertices = GetValue(config, 'vertices', []);
                    var uvs = GetValue(config, 'uvs', []);
                    var indicies = GetValue(config, 'indicies', []);
                    var containsZ = GetValue(config, 'containsZ', false);
                    var normals = GetValue(config, 'normals', []);
                    var colors = GetValue(config, 'colors', 0xffffff);
                    var alphas = GetValue(config, 'alphas', 1);
                    var mesh = new Mesh(this.scene, 0, 0, key, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, mesh, config);
                    return mesh;
                });
            /***/ },
            /***/ 9225: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Mesh = __webpack_require__(4703);
                var GameObjectFactory = __webpack_require__(39429);
                GameObjectFactory.register('mesh', function(x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                    return this.displayList.add(new Mesh(this.scene, x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas));
                });
            /***/ },
            /***/ 29807: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(48833);
                renderCanvas = __webpack_require__(36488);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 48833: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Mesh#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var MeshWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    var faces = src.faces;
                    var totalFaces = faces.length;
                    if (totalFaces === 0) return;
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    //  This causes a flush if the Mesh has a Post Pipeline
                    renderer.pipelines.preBatch(src);
                    var textureUnit = pipeline.setGameObject(src);
                    var F32 = pipeline.vertexViewF32;
                    var U32 = pipeline.vertexViewU32;
                    var vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                    var tintEffect = src.tintFill;
                    var debugFaces = [];
                    var debugCallback = src.debugCallback;
                    var a = calcMatrix.a;
                    var b = calcMatrix.b;
                    var c = calcMatrix.c;
                    var d = calcMatrix.d;
                    var e = calcMatrix.e;
                    var f = calcMatrix.f;
                    var z = src.viewPosition.z;
                    var hideCCW = src.hideCCW;
                    var roundPixels = camera.roundPixels;
                    var alpha = camera.alpha * src.alpha;
                    var totalFacesRendered = 0;
                    for(var i = 0; i < totalFaces; i++){
                        var face = faces[i];
                        //  If face has alpha <= 0, or hideCCW + clockwise, or isn't in camera view, then don't draw it
                        if (!face.isInView(camera, hideCCW, z, alpha, a, b, c, d, e, f, roundPixels)) continue;
                        if (pipeline.shouldFlush(3)) {
                            pipeline.flush();
                            textureUnit = pipeline.setGameObject(src);
                            vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                        }
                        vertexOffset = face.load(F32, U32, vertexOffset, textureUnit, tintEffect);
                        totalFacesRendered++;
                        pipeline.vertexCount += 3;
                        pipeline.currentBatch.count = pipeline.vertexCount - pipeline.currentBatch.start;
                        if (debugCallback) debugFaces.push(face);
                    }
                    src.totalFrame += totalFacesRendered;
                    if (debugCallback) debugCallback.call(src, src, debugFaces);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = MeshWebGLRenderer;
            /***/ },
            /***/ 28103: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var NineSliceRender = __webpack_require__(78023);
                var Vertex = __webpack_require__(39318);
                /**
 * @classdesc
 * A Nine Slice Game Object allows you to display a texture-based object that
 * can be stretched both horizontally and vertically, but that retains
 * fixed-sized corners. The dimensions of the corners are set via the
 * parameters to this class.
 *
 * This is extremely useful for UI and button like elements, where you need
 * them to expand to accommodate the content without distorting the texture.
 *
 * The texture you provide for this Game Object should be based on the
 * following layout structure:
 *
 * ```
 *      A                          B
 *    +---+----------------------+---+
 *  C | 1 |          2           | 3 |
 *    +---+----------------------+---+
 *    |   |                      |   |
 *    | 4 |          5           | 6 |
 *    |   |                      |   |
 *    +---+----------------------+---+
 *  D | 7 |          8           | 9 |
 *    +---+----------------------+---+
 * ```
 *
 * When changing this objects width and / or height:
 *
 *     areas 1, 3, 7 and 9 (the corners) will remain unscaled
 *     areas 2 and 8 will be stretched horizontally only
 *     areas 4 and 6 will be stretched vertically only
 *     area 5 will be stretched both horizontally and vertically
 *
 * You can also create a 3 slice Game Object:
 *
 * This works in a similar way, except you can only stretch it horizontally.
 * Therefore, it requires less configuration:
 *
 * ```
 *      A                          B
 *    +---+----------------------+---+
 *    |   |                      |   |
 *  C | 1 |          2           | 3 |
 *    |   |                      |   |
 *    +---+----------------------+---+
 * ```
 *
 * When changing this objects width (you cannot change its height)
 *
 *     areas 1 and 3 will remain unscaled
 *     area 2 will be stretched horizontally
 *
 * The above configuration concept is adapted from the Pixi NineSlicePlane.
 *
 * To specify a 3 slice object instead of a 9 slice you should only
 * provide the `leftWidth` and `rightWidth` parameters. To create a 9 slice
 * you must supply all parameters.
 *
 * The _minimum_ width this Game Object can be is the total of
 * `leftWidth` + `rightWidth`.  The _minimum_ height this Game Object
 * can be is the total of `topHeight` + `bottomHeight`.
 * If you need to display this object at a smaller size, you can scale it.
 *
 * In terms of performance, using a 3 slice Game Object is the equivalent of
 * having 3 Sprites in a row. Using a 9 slice Game Object is the equivalent
 * of having 9 Sprites in a row. The vertices of this object are all batched
 * together and can co-exist with other Sprites and graphics on the display
 * list, without incurring any additional overhead.
 *
 * As of Phaser 3.60 this Game Object is WebGL only.
 *
 * As of Phaser 3.70 this Game Object can now populate its values automatically
 * if they have been set within Texture Packer 7.1.0 or above and exported with
 * the atlas json. If this is the case, you can just call this method without
 * specifying anything more than the texture key and frame and it will pull the
 * area data from the atlas.
 *
 * @class NineSlice
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.60.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of the center of this Game Object in the world.
 * @param {number} y - The vertical position of the center of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {number} [width=256] - The width of the Nine Slice Game Object. You can adjust the width post-creation.
 * @param {number} [height=256] - The height of the Nine Slice Game Object. If this is a 3 slice object the height will be fixed to the height of the texture and cannot be changed.
 * @param {number} [leftWidth=10] - The size of the left vertical column (A).
 * @param {number} [rightWidth=10] - The size of the right vertical column (B).
 * @param {number} [topHeight=0] - The size of the top horizontal row (C). Set to zero or undefined to create a 3 slice object.
 * @param {number} [bottomHeight=0] - The size of the bottom horizontal row (D). Set to zero or undefined to create a 3 slice object.
 */ var NineSlice = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Texture,
                        Components.Transform,
                        Components.Visible,
                        NineSliceRender
                    ],
                    initialize: function NineSlice(scene, x, y, texture, frame, width, height, leftWidth, rightWidth, topHeight, bottomHeight) {
                        // if (width === undefined) { width = 256; }
                        // if (height === undefined) { height = 256; }
                        // if (leftWidth === undefined) { leftWidth = 10; }
                        // if (rightWidth === undefined) { rightWidth = 10; }
                        // if (topHeight === undefined) { topHeight = 0; }
                        // if (bottomHeight === undefined) { bottomHeight = 0; }
                        GameObject.call(this, scene, 'NineSlice');
                        /**
         * Internal width value. Do not modify this property directly.
         *
         * @name Phaser.GameObjects.NineSlice#_width
         * @private
         * @type {number}
         * @since 3.60.0
         */ this._width;
                        /**
         * Internal height value. Do not modify this property directly.
         *
         * @name Phaser.GameObjects.NineSlice#_height
         * @private
         * @type {number}
         * @since 3.60.0
         */ this._height;
                        /**
         * Internal originX value. Do not modify this property directly.
         *
         * @name Phaser.GameObjects.NineSlice#_originX
         * @private
         * @type {number}
         * @since 3.60.0
         */ this._originX = 0.5;
                        /**
         * Internal originY value. Do not modify this property directly.
         *
         * @name Phaser.GameObjects.NineSlice#_originY
         * @private
         * @type {number}
         * @since 3.60.0
         */ this._originY = 0.5;
                        /**
         * Internal component value. Do not modify this property directly.
         *
         * @name Phaser.GameObjects.NineSlice#_sizeComponent
         * @private
         * @type {boolean}
         * @since 3.60.0
         */ this._sizeComponent = true;
                        /**
         * An array of Vertex objects that correspond to the quads that make-up
         * this Nine Slice Game Object. They are stored in the following order:
         *
         * Top Left - Indexes 0 - 5
         * Top Center - Indexes 6 - 11
         * Top Right - Indexes 12 - 17
         * Center Left - Indexes 18 - 23
         * Center - Indexes 24 - 29
         * Center Right - Indexes 30 - 35
         * Bottom Left - Indexes 36 - 41
         * Bottom Center - Indexes 42 - 47
         * Bottom Right - Indexes 48 - 53
         *
         * Each quad is represented by 6 Vertex instances.
         *
         * This array will contain 18 elements for a 3 slice object
         * and 54 for a nine slice object.
         *
         * You should never modify this array once it has been populated.
         *
         * @name Phaser.GameObjects.NineSlice#vertices
         * @type {Phaser.Geom.Mesh.Vertex[]}
         * @since 3.60.0
         */ this.vertices = [];
                        /**
         * The size of the left vertical bar (A).
         *
         * @name Phaser.GameObjects.NineSlice#leftWidth
         * @type {number}
         * @readonly
         * @since 3.60.0
         */ this.leftWidth;
                        /**
         * The size of the right vertical bar (B).
         *
         * @name Phaser.GameObjects.NineSlice#rightWidth
         * @type {number}
         * @readonly
         * @since 3.60.0
         */ this.rightWidth;
                        /**
         * The size of the top horizontal bar (C).
         *
         * If this is a 3 slice object this property will be set to the
         * height of the texture being used.
         *
         * @name Phaser.GameObjects.NineSlice#topHeight
         * @type {number}
         * @readonly
         * @since 3.60.0
         */ this.topHeight;
                        /**
         * The size of the bottom horizontal bar (D).
         *
         * If this is a 3 slice object this property will be set to zero.
         *
         * @name Phaser.GameObjects.NineSlice#bottomHeight
         * @type {number}
         * @readonly
         * @since 3.60.0
         */ this.bottomHeight;
                        /**
         * The tint value being applied to the top-left vertice of the Game Object.
         * This value is interpolated from the corner to the center of the Game Object.
         * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
         *
         * @name Phaser.GameObjects.NineSlice#tint
         * @type {number}
         * @default 0xffffff
         * @since 3.60.0
         */ this.tint = 0xffffff;
                        /**
         * The tint fill mode.
         *
         * `false` = An additive tint (the default), where vertices colors are blended with the texture.
         * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.NineSlice#tintFill
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.tintFill = false;
                        var textureFrame = scene.textures.getFrame(texture, frame);
                        /**
         * This property is `true` if this Nine Slice Game Object was configured
         * with just `leftWidth` and `rightWidth` values, making it a 3-slice
         * instead of a 9-slice object.
         *
         * @name Phaser.GameObjects.NineSlice#is3Slice
         * @type {boolean}
         * @since 3.60.0
         */ this.is3Slice = !topHeight && !bottomHeight;
                        if (textureFrame && textureFrame.scale9) //  If we're using the scale9 data from the frame, override the values from above
                        this.is3Slice = textureFrame.is3Slice;
                        var size = this.is3Slice ? 18 : 54;
                        for(var i = 0; i < size; i++)this.vertices.push(new Vertex());
                        this.setPosition(x, y);
                        this.setTexture(texture, frame);
                        this.setSlices(width, height, leftWidth, rightWidth, topHeight, bottomHeight, false);
                        this.updateDisplayOrigin();
                        this.initPipeline();
                        this.initPostPipeline();
                    },
                    /**
     * Resets the width, height and slices for this NineSlice Game Object.
     *
     * This allows you to modify the texture being used by this object and then reset the slice configuration,
     * to avoid having to destroy this Game Object in order to use it for a different game element.
     *
     * Please note that you cannot change a 9-slice to a 3-slice or vice versa.
     *
     * @method Phaser.GameObjects.NineSlice#setSlices
     * @since 3.60.0
     *
     * @param {number} [width=256] - The width of the Nine Slice Game Object. You can adjust the width post-creation.
     * @param {number} [height=256] - The height of the Nine Slice Game Object. If this is a 3 slice object the height will be fixed to the height of the texture and cannot be changed.
     * @param {number} [leftWidth=10] - The size of the left vertical column (A).
     * @param {number} [rightWidth=10] - The size of the right vertical column (B).
     * @param {number} [topHeight=0] - The size of the top horizontal row (C). Set to zero or undefined to create a 3 slice object.
     * @param {number} [bottomHeight=0] - The size of the bottom horizontal row (D). Set to zero or undefined to create a 3 slice object.
     * @param {boolean} [skipScale9=false] -If this Nine Slice was created from Texture Packer scale9 atlas data, set this property to use the given column sizes instead of those specified in the JSON.
     *
     * @return {this} This Game Object instance.
     */ setSlices: function(width, height, leftWidth, rightWidth, topHeight, bottomHeight, skipScale9) {
                        if (leftWidth === undefined) leftWidth = 10;
                        if (rightWidth === undefined) rightWidth = 10;
                        if (topHeight === undefined) topHeight = 0;
                        if (bottomHeight === undefined) bottomHeight = 0;
                        if (skipScale9 === undefined) skipScale9 = false;
                        var frame = this.frame;
                        var sliceChange = false;
                        if (this.is3Slice && skipScale9 && topHeight !== 0 && bottomHeight !== 0) sliceChange = true;
                        if (sliceChange) console.warn('Cannot change 9 slice to 3 slice');
                        else {
                            if (frame && frame.scale9 && !skipScale9) {
                                var data = frame.data.scale9Borders;
                                var x = data.x;
                                var y = data.y;
                                leftWidth = x;
                                rightWidth = frame.width - data.w - x;
                                topHeight = y;
                                bottomHeight = frame.height - data.h - y;
                                if (width === undefined) width = frame.width;
                                if (height === undefined) height = frame.height;
                            } else {
                                if (width === undefined) width = 256;
                                if (height === undefined) height = 256;
                            }
                            this._width = width;
                            this._height = height;
                            this.leftWidth = leftWidth;
                            this.rightWidth = rightWidth;
                            this.topHeight = topHeight;
                            this.bottomHeight = bottomHeight;
                            if (this.is3Slice) {
                                height = frame.height;
                                this._height = height;
                                this.topHeight = height;
                                this.bottomHeight = 0;
                            }
                            this.updateVertices();
                            this.updateUVs();
                        }
                        return this;
                    },
                    /**
     * Updates all of the vertice UV coordinates. This is called automatically
     * when the NineSlice Game Object is created, or if the texture frame changes.
     *
     * Unlike with the `updateVertice` method, you do not need to call this
     * method if the Nine Slice changes size. Only if it changes texture frame.
     *
     * @method Phaser.GameObjects.NineSlice#updateUVs
     * @since 3.60.0
     */ updateUVs: function() {
                        var left = this.leftWidth;
                        var right = this.rightWidth;
                        var top = this.topHeight;
                        var bot = this.bottomHeight;
                        var width = this.frame.width;
                        var height = this.frame.height;
                        this.updateQuadUVs(0, 0, 0, left / width, top / height);
                        this.updateQuadUVs(6, left / width, 0, 1 - right / width, top / height);
                        this.updateQuadUVs(12, 1 - right / width, 0, 1, top / height);
                        if (!this.is3Slice) {
                            this.updateQuadUVs(18, 0, top / height, left / width, 1 - bot / height);
                            this.updateQuadUVs(24, left / width, top / height, 1 - right / width, 1 - bot / height);
                            this.updateQuadUVs(30, 1 - right / width, top / height, 1, 1 - bot / height);
                            this.updateQuadUVs(36, 0, 1 - bot / height, left / width, 1);
                            this.updateQuadUVs(42, left / width, 1 - bot / height, 1 - right / width, 1);
                            this.updateQuadUVs(48, 1 - right / width, 1 - bot / height, 1, 1);
                        }
                    },
                    /**
     * Recalculates all of the vertices in this Nine Slice Game Object
     * based on the `leftWidth`, `rightWidth`, `topHeight` and `bottomHeight`
     * properties, combined with the Game Object size.
     *
     * This method is called automatically when this object is created
     * or if it's origin is changed.
     *
     * You should not typically need to call this method directly, but it
     * is left public should you find a need to modify one of those properties
     * after creation.
     *
     * @method Phaser.GameObjects.NineSlice#updateVertices
     * @since 3.60.0
     */ updateVertices: function() {
                        var left = this.leftWidth;
                        var right = this.rightWidth;
                        var top = this.topHeight;
                        var bot = this.bottomHeight;
                        var width = this.width;
                        var height = this.height;
                        this.updateQuad(0, -0.5, 0.5, -0.5 + left / width, 0.5 - top / height);
                        this.updateQuad(6, -0.5 + left / width, 0.5, 0.5 - right / width, 0.5 - top / height);
                        this.updateQuad(12, 0.5 - right / width, 0.5, 0.5, 0.5 - top / height);
                        if (!this.is3Slice) {
                            this.updateQuad(18, -0.5, 0.5 - top / height, -0.5 + left / width, -0.5 + bot / height);
                            this.updateQuad(24, -0.5 + left / width, 0.5 - top / height, 0.5 - right / width, -0.5 + bot / height);
                            this.updateQuad(30, 0.5 - right / width, 0.5 - top / height, 0.5, -0.5 + bot / height);
                            this.updateQuad(36, -0.5, -0.5 + bot / height, -0.5 + left / width, -0.5);
                            this.updateQuad(42, -0.5 + left / width, -0.5 + bot / height, 0.5 - right / width, -0.5);
                            this.updateQuad(48, 0.5 - right / width, -0.5 + bot / height, 0.5, -0.5);
                        }
                    },
                    /**
     * Internally updates the position coordinates across all vertices of the
     * given quad offset.
     *
     * You should not typically need to call this method directly, but it
     * is left public should an extended class require it.
     *
     * @method Phaser.GameObjects.NineSlice#updateQuad
     * @since 3.60.0
     *
     * @param {number} offset - The offset in the vertices array of the quad to update.
     * @param {number} x1 - The top-left quad coordinate.
     * @param {number} y1 - The top-left quad coordinate.
     * @param {number} x2 - The bottom-right quad coordinate.
     * @param {number} y2 - The bottom-right quad coordinate.
     */ updateQuad: function(offset, x1, y1, x2, y2) {
                        var width = this.width;
                        var height = this.height;
                        var originX = this.originX;
                        var originY = this.originY;
                        var verts = this.vertices;
                        verts[offset + 0].resize(x1, y1, width, height, originX, originY);
                        verts[offset + 1].resize(x1, y2, width, height, originX, originY);
                        verts[offset + 2].resize(x2, y1, width, height, originX, originY);
                        verts[offset + 3].resize(x1, y2, width, height, originX, originY);
                        verts[offset + 4].resize(x2, y2, width, height, originX, originY);
                        verts[offset + 5].resize(x2, y1, width, height, originX, originY);
                    },
                    /**
     * Internally updates the UV coordinates across all vertices of the
     * given quad offset, based on the frame size.
     *
     * You should not typically need to call this method directly, but it
     * is left public should an extended class require it.
     *
     * @method Phaser.GameObjects.NineSlice#updateQuadUVs
     * @since 3.60.0
     *
     * @param {number} offset - The offset in the vertices array of the quad to update.
     * @param {number} u1 - The top-left UV coordinate.
     * @param {number} v1 - The top-left UV coordinate.
     * @param {number} u2 - The bottom-right UV coordinate.
     * @param {number} v2 - The bottom-right UV coordinate.
     */ updateQuadUVs: function(offset, u1, v1, u2, v2) {
                        var verts = this.vertices;
                        //  Adjust for frame offset
                        //  Incoming values will always be in the range 0-1
                        var frame = this.frame;
                        var fu1 = frame.u0;
                        var fv1 = frame.v0;
                        var fu2 = frame.u1;
                        var fv2 = frame.v1;
                        if (fu1 !== 0 || fu2 !== 1) {
                            //  adjust horizontal
                            var udiff = fu2 - fu1;
                            u1 = fu1 + u1 * udiff;
                            u2 = fu1 + u2 * udiff;
                        }
                        if (fv1 !== 0 || fv2 !== 1) {
                            //  adjust vertical
                            var vdiff = fv2 - fv1;
                            v1 = fv1 + v1 * vdiff;
                            v2 = fv1 + v2 * vdiff;
                        }
                        verts[offset + 0].setUVs(u1, v1);
                        verts[offset + 1].setUVs(u1, v2);
                        verts[offset + 2].setUVs(u2, v1);
                        verts[offset + 3].setUVs(u1, v2);
                        verts[offset + 4].setUVs(u2, v2);
                        verts[offset + 5].setUVs(u2, v1);
                    },
                    /**
     * Clears all tint values associated with this Game Object.
     *
     * Immediately sets the color values back to 0xffffff and the tint type to 'additive',
     * which results in no visible change to the texture.
     *
     * @method Phaser.GameObjects.NineSlice#clearTint
     * @webglOnly
     * @since 3.60.0
     *
     * @return {this} This Game Object instance.
     */ clearTint: function() {
                        this.setTint(0xffffff);
                        return this;
                    },
                    /**
     * Sets an additive tint on this Game Object.
     *
     * The tint works by taking the pixel color values from the Game Objects texture, and then
     * multiplying it by the color value of the tint.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property.
     *
     * To remove a tint call `clearTint`, or call this method with no parameters.
     *
     * To swap this from being an additive tint to a fill based tint set the property `tintFill` to `true`.
     *
     * @method Phaser.GameObjects.NineSlice#setTint
     * @webglOnly
     * @since 3.60.0
     *
     * @param {number} [color=0xffffff] - The tint being applied to the entire Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTint: function(color) {
                        if (color === undefined) color = 0xffffff;
                        this.tint = color;
                        this.tintFill = false;
                        return this;
                    },
                    /**
     * Sets a fill-based tint on this Game Object.
     *
     * Unlike an additive tint, a fill-tint literally replaces the pixel colors from the texture
     * with those in the tint. You can use this for effects such as making a player flash 'white'
     * if hit by something. The whole Game Object will be rendered in the given color.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property.
     *
     * To remove a tint call `clearTint`, or call this method with no parameters.
     *
     * To swap this from being a fill-tint to an additive tint set the property `tintFill` to `false`.
     *
     * @method Phaser.GameObjects.NineSlice#setTintFill
     * @webglOnly
     * @since 3.60.0
     *
     * @param {number} [color=0xffffff] - The tint being applied to the entire Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTintFill: function(color) {
                        this.setTint(color);
                        this.tintFill = true;
                        return this;
                    },
                    /**
     * Does this Game Object have a tint applied?
     *
     * It checks to see if the tint property is set to a value other than 0xffffff.
     * This indicates that a Game Object is tinted.
     *
     * @name Phaser.GameObjects.NineSlice#isTinted
     * @type {boolean}
     * @webglOnly
     * @readonly
     * @since 3.60.0
     */ isTinted: {
                        get: function() {
                            return this.tint !== 0xffffff;
                        }
                    },
                    /**
     * The displayed width of this Game Object.
     *
     * Setting this value will adjust the way in which this Nine Slice
     * object scales horizontally, if configured to do so.
     *
     * The _minimum_ width this Game Object can be is the total of
     * `leftWidth` + `rightWidth`. If you need to display this object
     * at a smaller size, you can also scale it.
     *
     * @name Phaser.GameObjects.NineSlice#width
     * @type {number}
     * @since 3.60.0
     */ width: {
                        get: function() {
                            return this._width;
                        },
                        set: function(value) {
                            this._width = Math.max(value, this.leftWidth + this.rightWidth);
                            this.updateVertices();
                        }
                    },
                    /**
     * The displayed height of this Game Object.
     *
     * Setting this value will adjust the way in which this Nine Slice
     * object scales vertically, if configured to do so.
     *
     * The _minimum_ height this Game Object can be is the total of
     * `topHeight` + `bottomHeight`. If you need to display this object
     * at a smaller size, you can also scale it.
     *
     * If this is a 3-slice object, you can only stretch it horizontally
     * and changing the height will be ignored.
     *
     * @name Phaser.GameObjects.NineSlice#height
     * @type {number}
     * @since 3.60.0
     */ height: {
                        get: function() {
                            return this._height;
                        },
                        set: function(value) {
                            if (!this.is3Slice) {
                                this._height = Math.max(value, this.topHeight + this.bottomHeight);
                                this.updateVertices();
                            }
                        }
                    },
                    /**
     * The displayed width of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.NineSlice#displayWidth
     * @type {number}
     * @since 3.60.0
     */ displayWidth: {
                        get: function() {
                            return this.scaleX * this.width;
                        },
                        set: function(value) {
                            this.scaleX = value / this.width;
                        }
                    },
                    /**
     * The displayed height of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.NineSlice#displayHeight
     * @type {number}
     * @since 3.60.0
     */ displayHeight: {
                        get: function() {
                            return this.scaleY * this.height;
                        },
                        set: function(value) {
                            this.scaleY = value / this.height;
                        }
                    },
                    /**
     * Sets the size of this Game Object.
     *
     * For a Nine Slice Game Object this means it will be stretched (or shrunk) horizontally
     * and vertically depending on the dimensions given to this method, in accordance with
     * how it has been configured for the various corner sizes.
     *
     * If this is a 3-slice object, you can only stretch it horizontally
     * and changing the height will be ignored.
     *
     * If you have enabled this Game Object for input, changing the size will also change the
     * size of the hit area.
     *
     * @method Phaser.GameObjects.NineSlice#setSize
     * @since 3.60.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        this.updateDisplayOrigin();
                        var input = this.input;
                        if (input && !input.customHitArea) {
                            input.hitArea.width = this.width;
                            input.hitArea.height = this.height;
                        }
                        return this;
                    },
                    /**
     * Sets the display size of this Game Object.
     *
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.NineSlice#setDisplaySize
     * @since 3.60.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setDisplaySize: function(width, height) {
                        this.displayWidth = width;
                        this.displayHeight = height;
                        return this;
                    },
                    /**
     * The horizontal origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the left of the Game Object.
     *
     * @name Phaser.GameObjects.NineSlice#originX
     * @type {number}
     * @since 3.60.0
     */ originX: {
                        get: function() {
                            return this._originX;
                        },
                        set: function(value) {
                            this._originX = value;
                            this.updateVertices();
                        }
                    },
                    /**
     * The vertical origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the top of the Game Object.
     *
     * @name Phaser.GameObjects.NineSlice#originY
     * @type {number}
     * @since 3.60.0
     */ originY: {
                        get: function() {
                            return this._originY;
                        },
                        set: function(value) {
                            this._originY = value;
                            this.updateVertices();
                        }
                    },
                    /**
     * Sets the origin of this Game Object.
     *
     * The values are given in the range 0 to 1.
     *
     * @method Phaser.GameObjects.NineSlice#setOrigin
     * @since 3.60.0
     *
     * @param {number} [x=0.5] - The horizontal origin value.
     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Game Object instance.
     */ setOrigin: function(x, y) {
                        if (x === undefined) x = 0.5;
                        if (y === undefined) y = x;
                        this._originX = x;
                        this._originY = y;
                        this.updateVertices();
                        return this.updateDisplayOrigin();
                    },
                    /**
     * This method is included but does nothing for the Nine Slice Game Object,
     * because the size of the object isn't based on the texture frame.
     *
     * You should not call this method.
     *
     * @method Phaser.GameObjects.NineSlice#setSizeToFrame
     * @since 3.60.0
     *
     * @return {this} This Game Object instance.
     */ setSizeToFrame: function() {
                        if (this.is3Slice) {
                            var height = this.frame.height;
                            this._height = height;
                            this.topHeight = height;
                            this.bottomHeight = 0;
                        }
                        this.updateUVs();
                        return this;
                    },
                    /**
     * Handles the pre-destroy step for the Nine Slice, which removes the vertices.
     *
     * @method Phaser.GameObjects.NineSlice#preDestroy
     * @private
     * @since 3.60.0
     */ preDestroy: function() {
                        this.vertices = [];
                    }
                });
                module1.exports = NineSlice;
            /***/ },
            /***/ 28279: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetValue = __webpack_require__(35154);
                var NineSlice = __webpack_require__(28103);
                /**
 * Creates a new Nine Slice Game Object and returns it.
 *
 * Note: This method will only be available if the Nine Slice Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#nineslice
 * @since 3.60.0
 *
 * @param {Phaser.Types.GameObjects.NineSlice.NineSliceConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.NineSlice} The Game Object that was created.
 */ GameObjectCreator.register('nineslice', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var frame = GetAdvancedValue(config, 'frame', null);
                    var width = GetValue(config, 'width', 256);
                    var height = GetValue(config, 'height', 256);
                    var leftWidth = GetValue(config, 'leftWidth', 10);
                    var rightWidth = GetValue(config, 'rightWidth', 10);
                    var topHeight = GetValue(config, 'topHeight', 0);
                    var bottomHeight = GetValue(config, 'bottomHeight', 0);
                    var nineslice = new NineSlice(this.scene, 0, 0, key, frame, width, height, leftWidth, rightWidth, topHeight, bottomHeight);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, nineslice, config);
                    return nineslice;
                });
            /***/ },
            /***/ 47521: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NineSlice = __webpack_require__(28103);
                var GameObjectFactory = __webpack_require__(39429);
                GameObjectFactory.register('nineslice', function(x, y, texture, frame, width, height, leftWidth, rightWidth, topHeight, bottomHeight) {
                    return this.displayList.add(new NineSlice(this.scene, x, y, texture, frame, width, height, leftWidth, rightWidth, topHeight, bottomHeight));
                });
            /***/ },
            /***/ 78023: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(52230);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 52230: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Mesh#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var NineSliceWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    var verts = src.vertices;
                    var totalVerts = verts.length;
                    if (totalVerts === 0) return;
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix, false).calc;
                    //  This causes a flush if the NineSlice has a Post Pipeline
                    renderer.pipelines.preBatch(src);
                    var textureUnit = pipeline.setGameObject(src);
                    var F32 = pipeline.vertexViewF32;
                    var U32 = pipeline.vertexViewU32;
                    var vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                    var roundPixels = camera.roundPixels;
                    var tintEffect = src.tintFill;
                    var alpha = camera.alpha * src.alpha;
                    var color = Utils.getTintAppendFloatAlpha(src.tint, alpha);
                    var available = pipeline.vertexAvailable();
                    var flushCount = -1;
                    if (available < totalVerts) flushCount = available;
                    for(var i = 0; i < totalVerts; i++){
                        var vert = verts[i];
                        if (i === flushCount) {
                            pipeline.flush();
                            textureUnit = pipeline.setGameObject(src);
                            vertexOffset = 0;
                        }
                        F32[++vertexOffset] = calcMatrix.getXRound(vert.vx, vert.vy, roundPixels);
                        F32[++vertexOffset] = calcMatrix.getYRound(vert.vx, vert.vy, roundPixels);
                        F32[++vertexOffset] = vert.u;
                        F32[++vertexOffset] = vert.v;
                        F32[++vertexOffset] = textureUnit;
                        F32[++vertexOffset] = tintEffect;
                        U32[++vertexOffset] = color;
                        pipeline.vertexCount++;
                        pipeline.currentBatch.count = pipeline.vertexCount - pipeline.currentBatch.start;
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = NineSliceWebGLRenderer;
            /***/ },
            /***/ 76472: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EmitterOp = __webpack_require__(44777);
                var GetColor = __webpack_require__(37589);
                var GetEaseFunction = __webpack_require__(6113);
                var GetInterpolationFunction = __webpack_require__(91389);
                var IntegerToRGB = __webpack_require__(90664);
                /**
 * @classdesc
 * This class is responsible for taking control over the color property
 * in the Particle class and managing its emission and updating functions.
 *
 * See the `ParticleEmitter` class for more details on emitter op configuration.
 *
 * @class EmitterColorOp
 * @extends Phaser.GameObjects.Particles.EmitterOp
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.60.0
 *
 * @param {string} key - The name of the property.
 */ var EmitterColorOp = new Class({
                    Extends: EmitterOp,
                    initialize: function EmitterColorOp(key) {
                        EmitterOp.call(this, key, null, false);
                        this.active = false;
                        this.easeName = 'Linear';
                        /**
         * An array containing the red color values.
         *
         * Populated during the `setMethods` method.
         *
         * @name Phaser.GameObjects.Particles.EmitterColorOp#r
         * @type {number[]}
         * @since 3.60.0
         */ this.r = [];
                        /**
         * An array containing the green color values.
         *
         * Populated during the `setMethods` method.
         *
         * @name Phaser.GameObjects.Particles.EmitterColorOp#g
         * @type {number[]}
         * @since 3.60.0
         */ this.g = [];
                        /**
         * An array containing the blue color values.
         *
         * Populated during the `setMethods` method.
         *
         * @name Phaser.GameObjects.Particles.EmitterColorOp#b
         * @type {number[]}
         * @since 3.60.0
         */ this.b = [];
                    },
                    /**
     * Checks the type of `EmitterOp.propertyValue` to determine which
     * method is required in order to return values from this op function.
     *
     * @method Phaser.GameObjects.Particles.EmitterColorOp#getMethod
     * @since 3.60.0
     *
     * @return {number} A number between 0 and 9 which should be passed to `setMethods`.
     */ getMethod: function() {
                        return this.propertyValue === null ? 0 : 9;
                    },
                    /**
     * Sets the EmitterColorOp method values, if in use.
     *
     * @method Phaser.GameObjects.Particles.EmitterColorOp#setMethods
     * @since 3.60.0
     *
     * @return {this} This Emitter Op object.
     */ setMethods: function() {
                        var value = this.propertyValue;
                        var current = value;
                        var onEmit = this.defaultEmit;
                        var onUpdate = this.defaultUpdate;
                        if (this.method === 9) {
                            this.start = value[0];
                            this.ease = GetEaseFunction('Linear');
                            this.interpolation = GetInterpolationFunction('linear');
                            onEmit = this.easedValueEmit;
                            onUpdate = this.easeValueUpdate;
                            current = value[0];
                            this.active = true;
                            //  Populate the r,g,b arrays
                            for(var i = 0; i < value.length; i++){
                                //  in hex format 0xff0000
                                var color = IntegerToRGB(value[i]);
                                this.r.push(color.r);
                                this.g.push(color.g);
                                this.b.push(color.b);
                            }
                        }
                        this.onEmit = onEmit;
                        this.onUpdate = onUpdate;
                        this.current = current;
                        return this;
                    },
                    /**
     * Sets the Ease function to use for Color interpolation.
     *
     * @method Phaser.GameObjects.Particles.EmitterColorOp#setEase
     * @since 3.60.0
     *
     * @param {string} ease - The string-based name of the Ease function to use.
     */ setEase: function(value) {
                        this.easeName = value;
                        this.ease = GetEaseFunction(value);
                    },
                    /**
     * An `onEmit` callback for an eased property.
     *
     * It prepares the particle for easing by {@link Phaser.GameObjects.Particles.EmitterColorOp#easeValueUpdate}.
     *
     * @method Phaser.GameObjects.Particles.EmitterColorOp#easedValueEmit
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     *
     * @return {number} {@link Phaser.GameObjects.Particles.EmitterColorOp#start}, as the new value of the property.
     */ easedValueEmit: function() {
                        this.current = this.start;
                        return this.start;
                    },
                    /**
     * An `onUpdate` callback that returns an eased value between the
     * {@link Phaser.GameObjects.Particles.EmitterColorOp#start} and {@link Phaser.GameObjects.Particles.EmitterColorOp#end}
     * range.
     *
     * @method Phaser.GameObjects.Particles.EmitterColorOp#easeValueUpdate
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The current normalized lifetime of the particle, between 0 (birth) and 1 (death).
     *
     * @return {number} The new value of the property.
     */ easeValueUpdate: function(particle, key, t) {
                        var v = this.ease(t);
                        var r = this.interpolation(this.r, v);
                        var g = this.interpolation(this.g, v);
                        var b = this.interpolation(this.b, v);
                        var current = GetColor(r, g, b);
                        this.current = current;
                        return current;
                    }
                });
                module1.exports = EmitterColorOp;
            /***/ },
            /***/ 44777: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(30976);
                var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var FloatBetween = __webpack_require__(99472);
                var GetEaseFunction = __webpack_require__(6113);
                var GetFastValue = __webpack_require__(95540);
                var GetInterpolationFunction = __webpack_require__(91389);
                var SnapTo = __webpack_require__(77720);
                var Wrap = __webpack_require__(15994);
                /**
 * @classdesc
 * This class is responsible for taking control over a single property
 * in the Particle class and managing its emission and updating functions.
 *
 * Particles properties such as `x`, `y`, `scaleX`, `lifespan` and others all use
 * EmitterOp instances to manage them, as they can be given in a variety of
 * formats: from simple values, to functions, to dynamic callbacks.
 *
 * See the `ParticleEmitter` class for more details on emitter op configuration.
 *
 * @class EmitterOp
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {string} key - The name of the property.
 * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType} defaultValue - The default value of the property.
 * @param {boolean} [emitOnly=false] - Whether the property can only be modified when a Particle is emitted.
 */ var EmitterOp = new Class({
                    initialize: function EmitterOp(key, defaultValue, emitOnly) {
                        if (emitOnly === undefined) emitOnly = false;
                        /**
         * The name of this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#propertyKey
         * @type {string}
         * @since 3.0.0
         */ this.propertyKey = key;
                        /**
         * The current value of this property.
         *
         * This can be a simple value, an array, a function or an onEmit
         * configuration object.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#propertyValue
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType}
         * @since 3.0.0
         */ this.propertyValue = defaultValue;
                        /**
         * The default value of this property.
         *
         * This can be a simple value, an array, a function or an onEmit
         * configuration object.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#defaultValue
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType}
         * @since 3.0.0
         */ this.defaultValue = defaultValue;
                        /**
         * The number of steps for stepped easing between {@link Phaser.GameObjects.Particles.EmitterOp#start} and
         * {@link Phaser.GameObjects.Particles.EmitterOp#end} values, per emit.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#steps
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.steps = 0;
                        /**
         * The step counter for stepped easing, per emit.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#counter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.counter = 0;
                        /**
         * When the step counter reaches it's maximum, should it then
         * yoyo back to the start again, or flip over to it?
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#yoyo
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.yoyo = false;
                        /**
         * The counter direction. 0 for up and 1 for down.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#direction
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.direction = 0;
                        /**
         * The start value for this property to ease between.
         *
         * If an interpolation this holds a reference to the number data array.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#start
         * @type {number|number[]}
         * @default 0
         * @since 3.0.0
         */ this.start = 0;
                        /**
         * The most recently calculated value. Updated every time an
         * emission or update method is called. Treat as read-only.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#current
         * @type {number}
         * @since 3.60.0
         */ this.current = 0;
                        /**
         * The end value for this property to ease between.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#end
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.end = 0;
                        /**
         * The easing function to use for updating this property, if any.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#ease
         * @type {?function}
         * @since 3.0.0
         */ this.ease = null;
                        /**
         * The interpolation function to use for updating this property, if any.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#interpolation
         * @type {?function}
         * @since 3.60.0
         */ this.interpolation = null;
                        /**
         * Whether this property can only be modified when a Particle is emitted.
         *
         * Set to `true` to allow only {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} callbacks to be set and
         * affect this property.
         *
         * Set to `false` to allow both {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} and
         * {@link Phaser.GameObjects.Particles.EmitterOp#onUpdate} callbacks to be set and affect this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#emitOnly
         * @type {boolean}
         * @since 3.0.0
         */ this.emitOnly = emitOnly;
                        /**
         * The callback to run for Particles when they are emitted from the Particle Emitter.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#onEmit
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitCallback}
         * @since 3.0.0
         */ this.onEmit = this.defaultEmit;
                        /**
         * The callback to run for Particles when they are updated.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#onUpdate
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateCallback}
         * @since 3.0.0
         */ this.onUpdate = this.defaultUpdate;
                        /**
         * Set to `false` to disable this EmitterOp.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#active
         * @type {boolean}
         * @since 3.60.0
         */ this.active = true;
                        /**
         * The onEmit method type of this EmitterOp.
         *
         * Set as part of `setMethod` and cached here to avoid
         * re-setting when only the value changes.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#method
         * @type {number}
         * @since 3.60.0
         */ this.method = 0;
                        /**
         * The callback to run for Particles when they are emitted from the Particle Emitter.
         * This is set during `setMethods` and used by `proxyEmit`.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#_onEmit
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitCallback}
         * @private
         * @since 3.60.0
         */ this._onEmit;
                        /**
         * The callback to run for Particles when they are updated.
         * This is set during `setMethods` and used by `proxyUpdate`.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#_onUpdate
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateCallback}
         * @private
         * @since 3.60.0
         */ this._onUpdate;
                    },
                    /**
     * Load the property from a Particle Emitter configuration object.
     *
     * Optionally accepts a new property key to use, replacing the current one.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#loadConfig
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} [config] - Settings for the Particle Emitter that owns this property.
     * @param {string} [newKey] - The new key to use for this property, if any.
     */ loadConfig: function(config, newKey) {
                        if (config === undefined) config = {};
                        if (newKey) this.propertyKey = newKey;
                        this.propertyValue = GetFastValue(config, this.propertyKey, this.defaultValue);
                        this.method = this.getMethod();
                        this.setMethods();
                        if (this.emitOnly) //  Reset it back again
                        this.onUpdate = this.defaultUpdate;
                    },
                    /**
     * Build a JSON representation of this Particle Emitter property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#toJSON
     * @since 3.0.0
     *
     * @return {object} A JSON representation of this Particle Emitter property.
     */ toJSON: function() {
                        return JSON.stringify(this.propertyValue);
                    },
                    /**
     * Change the current value of the property and update its callback methods.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#onChange
     * @since 3.0.0
     *
     * @param {number} value - The new numeric value of this property.
     *
     * @return {this} This Emitter Op object.
     */ onChange: function(value) {
                        var current;
                        switch(this.method){
                            //  Number
                            //  Custom Callback (onEmit only)
                            //  Custom onEmit and/or onUpdate callbacks
                            case 1:
                            case 3:
                            case 8:
                                current = value;
                                break;
                            //  Random Array
                            case 2:
                                if (this.propertyValue.indexOf(value) >= 0) current = value;
                                break;
                            //  Stepped start/end
                            case 4:
                                var step = (this.end - this.start) / this.steps;
                                current = SnapTo(value, step);
                                this.counter = current;
                                break;
                            //  Eased start/end
                            //  min/max (random float or int)
                            //  Random object (random integer)
                            case 5:
                            case 6:
                            case 7:
                                current = Clamp(value, this.start, this.end);
                                break;
                            //  Interpolation
                            case 9:
                                current = this.start[0];
                                break;
                        }
                        this.current = current;
                        return this;
                    },
                    /**
     * Checks the type of `EmitterOp.propertyValue` to determine which
     * method is required in order to return values from this op function.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#getMethod
     * @since 3.60.0
     *
     * @return {number} A number between 0 and 9 which should be passed to `setMethods`.
     */ getMethod: function() {
                        var value = this.propertyValue;
                        //  `moveToX` and `moveToY` are null by default
                        if (value === null) return 0;
                        var t = typeof value;
                        if (t === 'number') //  Number
                        return 1;
                        else if (Array.isArray(value)) //  Random Array
                        return 2;
                        else if (t === 'function') //  Custom Callback
                        return 3;
                        else if (t === 'object') {
                            if (this.hasBoth(value, 'start', 'end')) {
                                if (this.has(value, 'steps')) //  Stepped start/end
                                return 4;
                                else //  Eased start/end
                                return 5;
                            } else if (this.hasBoth(value, 'min', 'max')) //  min/max
                            return 6;
                            else if (this.has(value, 'random')) //  Random object
                            return 7;
                            else if (this.hasEither(value, 'onEmit', 'onUpdate')) //  Custom onEmit onUpdate
                            return 8;
                            else if (this.hasEither(value, 'values', 'interpolation')) //  Interpolation
                            return 9;
                        }
                        return 0;
                    },
                    /**
     * Update the {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} and
     * {@link Phaser.GameObjects.Particles.EmitterOp#onUpdate} callbacks based on the method returned
     * from `getMethod`. The method is stored in the `EmitterOp.method` property
     * and is a number between 0 and 9 inclusively.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#setMethods
     * @since 3.0.0
     *
     * @return {this} This Emitter Op object.
     */ setMethods: function() {
                        var value = this.propertyValue;
                        var current = value;
                        var onEmit = this.defaultEmit;
                        var onUpdate = this.defaultUpdate;
                        switch(this.method){
                            //  Number
                            case 1:
                                onEmit = this.staticValueEmit;
                                break;
                            //  Random Array
                            case 2:
                                onEmit = this.randomStaticValueEmit;
                                current = value[0];
                                break;
                            //  Custom Callback (onEmit only)
                            case 3:
                                this._onEmit = value;
                                onEmit = this.proxyEmit;
                                current = this.defaultValue;
                                break;
                            //  Stepped start/end
                            case 4:
                                this.start = value.start;
                                this.end = value.end;
                                this.steps = value.steps;
                                this.counter = this.start;
                                this.yoyo = this.has(value, 'yoyo') ? value.yoyo : false;
                                this.direction = 0;
                                onEmit = this.steppedEmit;
                                current = this.start;
                                break;
                            //  Eased start/end
                            case 5:
                                this.start = value.start;
                                this.end = value.end;
                                var easeType = this.has(value, 'ease') ? value.ease : 'Linear';
                                this.ease = GetEaseFunction(easeType, value.easeParams);
                                onEmit = this.has(value, 'random') && value.random ? this.randomRangedValueEmit : this.easedValueEmit;
                                onUpdate = this.easeValueUpdate;
                                current = this.start;
                                break;
                            //  min/max (random float or int)
                            case 6:
                                this.start = value.min;
                                this.end = value.max;
                                onEmit = this.has(value, 'int') && value.int ? this.randomRangedIntEmit : this.randomRangedValueEmit;
                                current = this.start;
                                break;
                            //  Random object (random integer)
                            case 7:
                                var rnd = value.random;
                                if (Array.isArray(rnd)) {
                                    this.start = rnd[0];
                                    this.end = rnd[1];
                                }
                                onEmit = this.randomRangedIntEmit;
                                current = this.start;
                                break;
                            //  Custom onEmit and/or onUpdate callbacks
                            case 8:
                                this._onEmit = this.has(value, 'onEmit') ? value.onEmit : this.defaultEmit;
                                this._onUpdate = this.has(value, 'onUpdate') ? value.onUpdate : this.defaultUpdate;
                                onEmit = this.proxyEmit;
                                onUpdate = this.proxyUpdate;
                                current = this.defaultValue;
                                break;
                            //  Interpolation
                            case 9:
                                this.start = value.values;
                                var easeTypeI = this.has(value, 'ease') ? value.ease : 'Linear';
                                this.ease = GetEaseFunction(easeTypeI, value.easeParams);
                                this.interpolation = GetInterpolationFunction(value.interpolation);
                                onEmit = this.easedValueEmit;
                                onUpdate = this.easeValueUpdate;
                                current = this.start[0];
                                break;
                        }
                        this.onEmit = onEmit;
                        this.onUpdate = onUpdate;
                        this.current = current;
                        return this;
                    },
                    /**
     * Check whether an object has the given property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#has
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key - The key of the property to look for in the object.
     *
     * @return {boolean} `true` if the property exists in the object, `false` otherwise.
     */ has: function(object, key) {
                        return object.hasOwnProperty(key);
                    },
                    /**
     * Check whether an object has both of the given properties.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#hasBoth
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key1 - The key of the first property to check the object for.
     * @param {string} key2 - The key of the second property to check the object for.
     *
     * @return {boolean} `true` if both properties exist in the object, `false` otherwise.
     */ hasBoth: function(object, key1, key2) {
                        return object.hasOwnProperty(key1) && object.hasOwnProperty(key2);
                    },
                    /**
     * Check whether an object has at least one of the given properties.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#hasEither
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key1 - The key of the first property to check the object for.
     * @param {string} key2 - The key of the second property to check the object for.
     *
     * @return {boolean} `true` if at least one of the properties exists in the object, `false` if neither exist.
     */ hasEither: function(object, key1, key2) {
                        return object.hasOwnProperty(key1) || object.hasOwnProperty(key2);
                    },
                    /**
     * The returned value sets what the property will be at the START of the particles life, on emit.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#defaultEmit
     * @since 3.0.0
     *
     * @return {number} The new value of the property.
     */ defaultEmit: function() {
                        return this.defaultValue;
                    },
                    /**
     * The returned value updates the property for the duration of the particles life.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#defaultUpdate
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The current normalized lifetime of the particle, between 0 (birth) and 1 (death).
     * @param {number} value - The current value of the property.
     *
     * @return {number} The new value of the property.
     */ defaultUpdate: function(particle, key, t, value) {
                        return value;
                    },
                    /**
     * The returned value sets what the property will be at the START of the particles life, on emit.
     *
     * This method is only used when you have provided a custom emit callback.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#proxyEmit
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} [value] - The current value of the property.
     *
     * @return {number} The new value of the property.
     */ proxyEmit: function(particle, key, value) {
                        var result = this._onEmit(particle, key, value);
                        this.current = result;
                        return result;
                    },
                    /**
     * The returned value updates the property for the duration of the particles life.
     *
     * This method is only used when you have provided a custom update callback.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#proxyUpdate
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The current normalized lifetime of the particle, between 0 (birth) and 1 (death).
     * @param {number} value - The current value of the property.
     *
     * @return {number} The new value of the property.
     */ proxyUpdate: function(particle, key, t, value) {
                        var result = this._onUpdate(particle, key, t, value);
                        this.current = result;
                        return result;
                    },
                    /**
     * An `onEmit` callback that returns the current value of the property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueEmit
     * @since 3.0.0
     *
     * @return {number} The current value of the property.
     */ staticValueEmit: function() {
                        return this.current;
                    },
                    /**
     * An `onUpdate` callback that returns the current value of the property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueUpdate
     * @since 3.0.0
     *
     * @return {number} The current value of the property.
     */ staticValueUpdate: function() {
                        return this.current;
                    },
                    /**
     * An `onEmit` callback that returns a random value from the current value array.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#randomStaticValueEmit
     * @since 3.0.0
     *
     * @return {number} The new value of the property.
     */ randomStaticValueEmit: function() {
                        var randomIndex = Math.floor(Math.random() * this.propertyValue.length);
                        this.current = this.propertyValue[randomIndex];
                        return this.current;
                    },
                    /**
     * An `onEmit` callback that returns a value between the {@link Phaser.GameObjects.Particles.EmitterOp#start} and
     * {@link Phaser.GameObjects.Particles.EmitterOp#end} range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#randomRangedValueEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The key of the property.
     *
     * @return {number} The new value of the property.
     */ randomRangedValueEmit: function(particle, key) {
                        var value = FloatBetween(this.start, this.end);
                        if (particle && particle.data[key]) {
                            particle.data[key].min = value;
                            particle.data[key].max = this.end;
                        }
                        this.current = value;
                        return value;
                    },
                    /**
     * An `onEmit` callback that returns a value between the {@link Phaser.GameObjects.Particles.EmitterOp#start} and
     * {@link Phaser.GameObjects.Particles.EmitterOp#end} range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#randomRangedIntEmit
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The key of the property.
     *
     * @return {number} The new value of the property.
     */ randomRangedIntEmit: function(particle, key) {
                        var value = Between(this.start, this.end);
                        if (particle && particle.data[key]) {
                            particle.data[key].min = value;
                            particle.data[key].max = this.end;
                        }
                        this.current = value;
                        return value;
                    },
                    /**
     * An `onEmit` callback that returns a stepped value between the
     * {@link Phaser.GameObjects.Particles.EmitterOp#start} and {@link Phaser.GameObjects.Particles.EmitterOp#end}
     * range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#steppedEmit
     * @since 3.0.0
     *
     * @return {number} The new value of the property.
     */ steppedEmit: function() {
                        var current = this.counter;
                        var next = current;
                        var step = (this.end - this.start) / this.steps;
                        if (this.yoyo) {
                            var over;
                            if (this.direction === 0) {
                                //  Add step to the current value
                                next += step;
                                if (next >= this.end) {
                                    over = next - this.end;
                                    next = this.end - over;
                                    this.direction = 1;
                                }
                            } else {
                                //  Down
                                next -= step;
                                if (next <= this.start) {
                                    over = this.start - next;
                                    next = this.start + over;
                                    this.direction = 0;
                                }
                            }
                            this.counter = next;
                        } else this.counter = Wrap(next + step, this.start, this.end);
                        this.current = current;
                        return current;
                    },
                    /**
     * An `onEmit` callback for an eased property.
     *
     * It prepares the particle for easing by {@link Phaser.GameObjects.Particles.EmitterOp#easeValueUpdate}.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#easedValueEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     *
     * @return {number} {@link Phaser.GameObjects.Particles.EmitterOp#start}, as the new value of the property.
     */ easedValueEmit: function(particle, key) {
                        if (particle && particle.data[key]) {
                            var data = particle.data[key];
                            data.min = this.start;
                            data.max = this.end;
                        }
                        this.current = this.start;
                        return this.start;
                    },
                    /**
     * An `onUpdate` callback that returns an eased value between the
     * {@link Phaser.GameObjects.Particles.EmitterOp#start} and {@link Phaser.GameObjects.Particles.EmitterOp#end}
     * range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#easeValueUpdate
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The current normalized lifetime of the particle, between 0 (birth) and 1 (death).
     *
     * @return {number} The new value of the property.
     */ easeValueUpdate: function(particle, key, t) {
                        var data = particle.data[key];
                        var current;
                        var v = this.ease(t);
                        if (this.interpolation) current = this.interpolation(this.start, v);
                        else current = (data.max - data.min) * v + data.min;
                        this.current = current;
                        return current;
                    },
                    /**
     * Destroys this EmitterOp instance and all of its references.
     *
     * Called automatically when the ParticleEmitter that owns this
     * EmitterOp is destroyed.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#destroy
     * @since 3.60.0
     */ destroy: function() {
                        this.propertyValue = null;
                        this.defaultValue = null;
                        this.ease = null;
                        this.interpolation = null;
                        this._onEmit = null;
                        this._onUpdate = null;
                    }
                });
                module1.exports = EmitterOp;
            /***/ },
            /***/ 24502: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var ParticleProcessor = __webpack_require__(20286);
                /**
 * @classdesc
 * The Gravity Well Particle Processor applies a force on the particles to draw
 * them towards, or repel them from, a single point.
 *
 * The force applied is inversely proportional to the square of the distance
 * from the particle to the point, in accordance with Newton's law of gravity.
 *
 * This simulates the effect of gravity over large distances (as between planets, for example).
 *
 * @class GravityWell
 * @extends Phaser.GameObjects.Particles.ParticleProcessor
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {(number|Phaser.Types.GameObjects.Particles.GravityWellConfig)} [x=0] - The x coordinate of the Gravity Well, in world space.
 * @param {number} [y=0] - The y coordinate of the Gravity Well, in world space.
 * @param {number} [power=0] - The strength of the gravity force - larger numbers produce a stronger force.
 * @param {number} [epsilon=100] - The minimum distance for which the gravity force is calculated.
 * @param {number} [gravity=50] - The gravitational force of this Gravity Well.
 */ var GravityWell = new Class({
                    Extends: ParticleProcessor,
                    initialize: function GravityWell(x, y, power, epsilon, gravity) {
                        if (typeof x === 'object') {
                            var config = x;
                            x = GetFastValue(config, 'x', 0);
                            y = GetFastValue(config, 'y', 0);
                            power = GetFastValue(config, 'power', 0);
                            epsilon = GetFastValue(config, 'epsilon', 100);
                            gravity = GetFastValue(config, 'gravity', 50);
                        } else {
                            if (x === undefined) x = 0;
                            if (y === undefined) y = 0;
                            if (power === undefined) power = 0;
                            if (epsilon === undefined) epsilon = 100;
                            if (gravity === undefined) gravity = 50;
                        }
                        ParticleProcessor.call(this, x, y, true);
                        /**
         * Internal gravity value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_gravity
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._gravity = gravity;
                        /**
         * Internal power value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_power
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._power = power * gravity;
                        /**
         * Internal epsilon value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_epsilon
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._epsilon = epsilon * epsilon;
                    },
                    /**
     * Takes a Particle and updates it based on the properties of this Gravity Well.
     *
     * @method Phaser.GameObjects.Particles.GravityWell#update
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to update.
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     */ update: function(particle, delta) {
                        var x = this.x - particle.x;
                        var y = this.y - particle.y;
                        var dSq = x * x + y * y;
                        if (dSq === 0) return;
                        var d = Math.sqrt(dSq);
                        if (dSq < this._epsilon) dSq = this._epsilon;
                        var factor = this._power * delta / (dSq * d) * 100;
                        particle.velocityX += x * factor;
                        particle.velocityY += y * factor;
                    },
                    /**
     * The minimum distance for which the gravity force is calculated.
     *
     * Defaults to 100.
     *
     * @name Phaser.GameObjects.Particles.GravityWell#epsilon
     * @type {number}
     * @since 3.0.0
     */ epsilon: {
                        get: function() {
                            return Math.sqrt(this._epsilon);
                        },
                        set: function(value) {
                            this._epsilon = value * value;
                        }
                    },
                    /**
     * The strength of the gravity force - larger numbers produce a stronger force.
     *
     * Defaults to 0.
     *
     * @name Phaser.GameObjects.Particles.GravityWell#power
     * @type {number}
     * @since 3.0.0
     */ power: {
                        get: function() {
                            return this._power / this._gravity;
                        },
                        set: function(value) {
                            this._power = value * this._gravity;
                        }
                    },
                    /**
     * The gravitational force of this Gravity Well.
     *
     * Defaults to 50.
     *
     * @name Phaser.GameObjects.Particles.GravityWell#gravity
     * @type {number}
     * @since 3.0.0
     */ gravity: {
                        get: function() {
                            return this._gravity;
                        },
                        set: function(value) {
                            var pwr = this.power;
                            this._gravity = value;
                            this.power = pwr;
                        }
                    }
                });
                module1.exports = GravityWell;
            /***/ },
            /***/ 56480: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(9674);
                var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var DegToRad = __webpack_require__(39506);
                var Rectangle = __webpack_require__(87841);
                var RotateAround = __webpack_require__(11520);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Particle is a simple object owned and controlled by a Particle Emitter.
 *
 * It encapsulates all of the properties required to move and update according
 * to the Emitters operations.
 *
 * @class Particle
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter to which this Particle belongs.
 */ var Particle = new Class({
                    initialize: function Particle(emitter) {
                        /**
         * The Emitter to which this Particle belongs.
         *
         * A Particle can only belong to a single Emitter and is created, updated and destroyed by it.
         *
         * @name Phaser.GameObjects.Particles.Particle#emitter
         * @type {Phaser.GameObjects.Particles.ParticleEmitter}
         * @since 3.0.0
         */ this.emitter = emitter;
                        /**
         * The texture used by this Particle when it renders.
         *
         * @name Phaser.GameObjects.Particles.Particle#texture
         * @type {Phaser.Textures.Texture}
         * @default null
         * @since 3.60.0
         */ this.texture = null;
                        /**
         * The texture frame used by this Particle when it renders.
         *
         * @name Phaser.GameObjects.Particles.Particle#frame
         * @type {Phaser.Textures.Frame}
         * @default null
         * @since 3.0.0
         */ this.frame = null;
                        /**
         * The x coordinate of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                        /**
         * The y coordinate of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                        /**
         * The coordinates of this Particle in world space.
         *
         * Updated as part of `computeVelocity`.
         *
         * @name Phaser.GameObjects.Particles.Particle#worldPosition
         * @type {Phaser.Math.Vector2}
         * @since 3.60.0
         */ this.worldPosition = new Vector2();
                        /**
         * The x velocity of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#velocityX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.velocityX = 0;
                        /**
         * The y velocity of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#velocityY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.velocityY = 0;
                        /**
         * The x acceleration of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#accelerationX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelerationX = 0;
                        /**
         * The y acceleration of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#accelerationY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelerationY = 0;
                        /**
         * The maximum horizontal velocity this Particle can travel at.
         *
         * @name Phaser.GameObjects.Particles.Particle#maxVelocityX
         * @type {number}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityX = 10000;
                        /**
         * The maximum vertical velocity this Particle can travel at.
         *
         * @name Phaser.GameObjects.Particles.Particle#maxVelocityY
         * @type {number}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityY = 10000;
                        /**
         * The bounciness, or restitution, of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#bounce
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.bounce = 0;
                        /**
         * The horizontal scale of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#scaleX
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.scaleX = 1;
                        /**
         * The vertical scale of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#scaleY
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.scaleY = 1;
                        /**
         * The alpha value of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#alpha
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.alpha = 1;
                        /**
         * The angle of this Particle in degrees.
         *
         * @name Phaser.GameObjects.Particles.Particle#angle
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angle = 0;
                        /**
         * The angle of this Particle in radians.
         *
         * @name Phaser.GameObjects.Particles.Particle#rotation
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.rotation = 0;
                        /**
         * The tint applied to this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#tint
         * @type {number}
         * @webglOnly
         * @since 3.0.0
         */ this.tint = 0xffffff;
                        /**
         * The lifespan of this Particle in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#life
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.life = 1000;
                        /**
         * The current life of this Particle in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#lifeCurrent
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.lifeCurrent = 1000;
                        /**
         * The delay applied to this Particle upon emission, in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#delayCurrent
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delayCurrent = 0;
                        /**
         * The hold applied to this Particle before it expires, in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#holdCurrent
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.holdCurrent = 0;
                        /**
         * The normalized lifespan T value, where 0 is the start and 1 is the end.
         *
         * @name Phaser.GameObjects.Particles.Particle#lifeT
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lifeT = 0;
                        /**
         * The data used by the ease equation.
         *
         * @name Phaser.GameObjects.Particles.Particle#data
         * @type {Phaser.Types.GameObjects.Particles.ParticleData}
         * @since 3.0.0
         */ this.data = {
                            tint: {
                                min: 0xffffff,
                                max: 0xffffff
                            },
                            alpha: {
                                min: 1,
                                max: 1
                            },
                            rotate: {
                                min: 0,
                                max: 0
                            },
                            scaleX: {
                                min: 1,
                                max: 1
                            },
                            scaleY: {
                                min: 1,
                                max: 1
                            },
                            x: {
                                min: 0,
                                max: 0
                            },
                            y: {
                                min: 0,
                                max: 0
                            },
                            accelerationX: {
                                min: 0,
                                max: 0
                            },
                            accelerationY: {
                                min: 0,
                                max: 0
                            },
                            maxVelocityX: {
                                min: 0,
                                max: 0
                            },
                            maxVelocityY: {
                                min: 0,
                                max: 0
                            },
                            moveToX: {
                                min: 0,
                                max: 0
                            },
                            moveToY: {
                                min: 0,
                                max: 0
                            },
                            bounce: {
                                min: 0,
                                max: 0
                            }
                        };
                        /**
         * Internal private value.
         *
         * @name Phaser.GameObjects.Particles.Particle#isCropped
         * @type {boolean}
         * @private
         * @readonly
         * @since 3.60.0
         */ this.isCropped = false;
                        /**
         * A reference to the Scene to which this Game Object belongs.
         *
         * Game Objects can only belong to one Scene.
         *
         * You should consider this property as being read-only. You cannot move a
         * Game Object to another Scene by simply changing it.
         *
         * @name Phaser.GameObjects.Particles.Particle#scene
         * @type {Phaser.Scene}
         * @since 3.60.0
         */ this.scene = emitter.scene;
                        /**
         * The Animation State component of this Particle.
         *
         * This component provides features to apply animations to this Particle.
         * It is responsible for playing, loading, queuing animations for later playback,
         * mixing between animations and setting the current animation frame to this Particle.
         *
         * It is created only if the Particle's Emitter has at least one Animation.
         *
         * @name Phaser.GameObjects.Particles.Particle#anims
         * @type {?Phaser.Animations.AnimationState}
         * @since 3.60.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAnim
         */ this.anims = null;
                        if (this.emitter.anims.length > 0) this.anims = new AnimationState(this);
                        /**
         * A rectangle that holds the bounds of this Particle after a call to
         * the `Particle.getBounds` method has been made.
         *
         * @name Phaser.GameObjects.Particles.Particle#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.60.0
         */ this.bounds = new Rectangle();
                    },
                    /**
     * The Event Emitter proxy.
     *
     * Passes on all parameters to the `ParticleEmitter` to emit directly.
     *
     * @method Phaser.GameObjects.Particles.Particle#emit
     * @since 3.60.0
     *
     * @param {(string|Symbol)} event - The event name.
     * @param {any} [a1] - Optional argument 1.
     * @param {any} [a2] - Optional argument 2.
     * @param {any} [a3] - Optional argument 3.
     * @param {any} [a4] - Optional argument 4.
     * @param {any} [a5] - Optional argument 5.
     *
     * @return {boolean} `true` if the event had listeners, else `false`.
     */ emit: function(event, a1, a2, a3, a4, a5) {
                        return this.emitter.emit(event, a1, a2, a3, a4, a5);
                    },
                    /**
     * Checks to see if this Particle is alive and updating.
     *
     * @method Phaser.GameObjects.Particles.Particle#isAlive
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Particle is alive and updating, otherwise `false`.
     */ isAlive: function() {
                        return this.lifeCurrent > 0;
                    },
                    /**
     * Kills this particle. This sets the `lifeCurrent` value to 0, which forces
     * the Particle to be removed the next time its parent Emitter runs an update.
     *
     * @method Phaser.GameObjects.Particles.Particle#kill
     * @since 3.60.0
     */ kill: function() {
                        this.lifeCurrent = 0;
                    },
                    /**
     * Sets the position of this particle to the given x/y coordinates.
     *
     * If the parameters are left undefined, it resets the particle back to 0x0.
     *
     * @method Phaser.GameObjects.Particles.Particle#setPosition
     * @since 3.60.0
     *
     * @param {number} [x=0] - The x coordinate to set this Particle to.
     * @param {number} [y=0] - The y coordinate to set this Particle to.
     */ setPosition: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        this.x = x;
                        this.y = y;
                    },
                    /**
     * Starts this Particle from the given coordinates.
     *
     * @method Phaser.GameObjects.Particles.Particle#fire
     * @since 3.0.0
     *
     * @param {number} [x] - The x coordinate to launch this Particle from.
     * @param {number} [y] - The y coordinate to launch this Particle from.
     *
     * @return {boolean} `true` if the Particle is alive, or `false` if it was spawned inside a DeathZone.
     */ fire: function(x, y) {
                        var emitter = this.emitter;
                        var ops = emitter.ops;
                        var anim = emitter.getAnim();
                        if (anim) this.anims.play(anim);
                        else {
                            this.frame = emitter.getFrame();
                            this.texture = this.frame.texture;
                        }
                        if (!this.frame) throw new Error('Particle has no texture frame');
                        //  Updates particle.x and particle.y during this call
                        emitter.getEmitZone(this);
                        if (x === undefined) this.x += ops.x.onEmit(this, 'x');
                        else if (ops.x.steps > 0) //  EmitterOp is stepped but x was forced (follower?) so use it
                        this.x += x + ops.x.onEmit(this, 'x');
                        else this.x += x;
                        if (y === undefined) this.y += ops.y.onEmit(this, 'y');
                        else if (ops.y.steps > 0) //  EmitterOp is stepped but y was forced (follower?) so use it
                        this.y += y + ops.y.onEmit(this, 'y');
                        else this.y += y;
                        this.life = ops.lifespan.onEmit(this, 'lifespan');
                        this.lifeCurrent = this.life;
                        this.lifeT = 0;
                        this.delayCurrent = ops.delay.onEmit(this, 'delay');
                        this.holdCurrent = ops.hold.onEmit(this, 'hold');
                        this.scaleX = ops.scaleX.onEmit(this, 'scaleX');
                        this.scaleY = ops.scaleY.active ? ops.scaleY.onEmit(this, 'scaleY') : this.scaleX;
                        this.angle = ops.rotate.onEmit(this, 'rotate');
                        this.rotation = DegToRad(this.angle);
                        emitter.worldMatrix.transformPoint(this.x, this.y, this.worldPosition);
                        //  Check we didn't spawn in the middle of a DeathZone
                        if (this.delayCurrent === 0 && emitter.getDeathZone(this)) {
                            this.lifeCurrent = 0;
                            return false;
                        }
                        var sx = ops.speedX.onEmit(this, 'speedX');
                        var sy = ops.speedY.active ? ops.speedY.onEmit(this, 'speedY') : sx;
                        if (emitter.radial) {
                            var rad = DegToRad(ops.angle.onEmit(this, 'angle'));
                            this.velocityX = Math.cos(rad) * Math.abs(sx);
                            this.velocityY = Math.sin(rad) * Math.abs(sy);
                        } else if (emitter.moveTo) {
                            var mx = ops.moveToX.onEmit(this, 'moveToX');
                            var my = ops.moveToY.onEmit(this, 'moveToY');
                            var lifeS = this.life / 1000;
                            this.velocityX = (mx - this.x) / lifeS;
                            this.velocityY = (my - this.y) / lifeS;
                        } else {
                            this.velocityX = sx;
                            this.velocityY = sy;
                        }
                        if (emitter.acceleration) {
                            this.accelerationX = ops.accelerationX.onEmit(this, 'accelerationX');
                            this.accelerationY = ops.accelerationY.onEmit(this, 'accelerationY');
                        }
                        this.maxVelocityX = ops.maxVelocityX.onEmit(this, 'maxVelocityX');
                        this.maxVelocityY = ops.maxVelocityY.onEmit(this, 'maxVelocityY');
                        this.bounce = ops.bounce.onEmit(this, 'bounce');
                        this.alpha = ops.alpha.onEmit(this, 'alpha');
                        if (ops.color.active) this.tint = ops.color.onEmit(this, 'tint');
                        else this.tint = ops.tint.onEmit(this, 'tint');
                        return true;
                    },
                    /**
     * The main update method for this Particle.
     *
     * Updates its life values, computes the velocity and repositions the Particle.
     *
     * @method Phaser.GameObjects.Particles.Particle#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     * @param {Phaser.GameObjects.Particles.ParticleProcessor[]} processors - An array of all active Particle Processors.
     *
     * @return {boolean} Returns `true` if this Particle has now expired and should be removed, otherwise `false` if still active.
     */ update: function(delta, step, processors) {
                        if (this.lifeCurrent <= 0) {
                            //  Particle is dead via `Particle.kill` method, or being held
                            if (this.holdCurrent > 0) {
                                this.holdCurrent -= delta;
                                return this.holdCurrent <= 0;
                            } else return true;
                        }
                        if (this.delayCurrent > 0) {
                            this.delayCurrent -= delta;
                            return false;
                        }
                        if (this.anims) this.anims.update(0, delta);
                        var emitter = this.emitter;
                        var ops = emitter.ops;
                        //  How far along in life is this particle? (t = 0 to 1)
                        var t = 1 - this.lifeCurrent / this.life;
                        this.lifeT = t;
                        this.x = ops.x.onUpdate(this, 'x', t, this.x);
                        this.y = ops.y.onUpdate(this, 'y', t, this.y);
                        if (emitter.moveTo) {
                            var mx = ops.moveToX.onUpdate(this, 'moveToX', t, emitter.moveToX);
                            var my = ops.moveToY.onUpdate(this, 'moveToY', t, emitter.moveToY);
                            var lifeS = this.lifeCurrent / 1000;
                            this.velocityX = (mx - this.x) / lifeS;
                            this.velocityY = (my - this.y) / lifeS;
                        }
                        this.computeVelocity(emitter, delta, step, processors, t);
                        this.scaleX = ops.scaleX.onUpdate(this, 'scaleX', t, this.scaleX);
                        if (ops.scaleY.active) this.scaleY = ops.scaleY.onUpdate(this, 'scaleY', t, this.scaleY);
                        else this.scaleY = this.scaleX;
                        this.angle = ops.rotate.onUpdate(this, 'rotate', t, this.angle);
                        this.rotation = DegToRad(this.angle);
                        if (emitter.getDeathZone(this)) {
                            this.lifeCurrent = 0;
                            //  No need to go any further, particle has been killed
                            return true;
                        }
                        this.alpha = Clamp(ops.alpha.onUpdate(this, 'alpha', t, this.alpha), 0, 1);
                        if (ops.color.active) this.tint = ops.color.onUpdate(this, 'color', t, this.tint);
                        else this.tint = ops.tint.onUpdate(this, 'tint', t, this.tint);
                        this.lifeCurrent -= delta;
                        return this.lifeCurrent <= 0 && this.holdCurrent <= 0;
                    },
                    /**
     * An internal method that calculates the velocity of the Particle and
     * its world position. It also runs it against any active Processors
     * that are set on the Emitter.
     *
     * @method Phaser.GameObjects.Particles.Particle#computeVelocity
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter that is updating this Particle.
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     * @param {Phaser.GameObjects.Particles.ParticleProcessor[]} processors - An array of all active Particle Processors.
     * @param {number} t - The current normalized lifetime of the particle, between 0 (birth) and 1 (death).
     */ computeVelocity: function(emitter, delta, step, processors, t) {
                        var ops = emitter.ops;
                        var vx = this.velocityX;
                        var vy = this.velocityY;
                        var ax = ops.accelerationX.onUpdate(this, 'accelerationX', t, this.accelerationX);
                        var ay = ops.accelerationY.onUpdate(this, 'accelerationY', t, this.accelerationY);
                        var mx = ops.maxVelocityX.onUpdate(this, 'maxVelocityX', t, this.maxVelocityX);
                        var my = ops.maxVelocityY.onUpdate(this, 'maxVelocityY', t, this.maxVelocityY);
                        this.bounce = ops.bounce.onUpdate(this, 'bounce', t, this.bounce);
                        vx += emitter.gravityX * step + ax * step;
                        vy += emitter.gravityY * step + ay * step;
                        vx = Clamp(vx, -mx, mx);
                        vy = Clamp(vy, -my, my);
                        this.velocityX = vx;
                        this.velocityY = vy;
                        //  Integrate back in to the position
                        this.x += vx * step;
                        this.y += vy * step;
                        emitter.worldMatrix.transformPoint(this.x, this.y, this.worldPosition);
                        //  Apply any additional processors (these can update velocity and/or position)
                        for(var i = 0; i < processors.length; i++){
                            var processor = processors[i];
                            if (processor.active) processor.update(this, delta, step, t);
                        }
                    },
                    /**
     * This is a NOOP method and does nothing when called.
     *
     * @method Phaser.GameObjects.Particles.Particle#setSizeToFrame
     * @since 3.60.0
     */ setSizeToFrame: function() {
                    //  NOOP
                    },
                    /**
     * Gets the bounds of this particle as a Geometry Rectangle, factoring in any
     * transforms of the parent emitter and anything else above it in the display list.
     *
     * Once calculated the bounds can be accessed via the `Particle.bounds` property.
     *
     * @method Phaser.GameObjects.Particles.Particle#getBounds
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [matrix] - Optional transform matrix to apply to this particle.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle containing the transformed bounds of this particle.
     */ getBounds: function(matrix) {
                        if (matrix === undefined) matrix = this.emitter.getWorldTransformMatrix();
                        var sx = Math.abs(matrix.scaleX) * this.scaleX;
                        var sy = Math.abs(matrix.scaleY) * this.scaleY;
                        var x = this.x;
                        var y = this.y;
                        var rotation = this.rotation;
                        var width = this.frame.width * sx / 2;
                        var height = this.frame.height * sy / 2;
                        var bounds = this.bounds;
                        var topLeft = new Vector2(x - width, y - height);
                        var topRight = new Vector2(x + width, y - height);
                        var bottomLeft = new Vector2(x - width, y + height);
                        var bottomRight = new Vector2(x + width, y + height);
                        if (rotation !== 0) {
                            RotateAround(topLeft, x, y, rotation);
                            RotateAround(topRight, x, y, rotation);
                            RotateAround(bottomLeft, x, y, rotation);
                            RotateAround(bottomRight, x, y, rotation);
                        }
                        matrix.transformPoint(topLeft.x, topLeft.y, topLeft);
                        matrix.transformPoint(topRight.x, topRight.y, topRight);
                        matrix.transformPoint(bottomLeft.x, bottomLeft.y, bottomLeft);
                        matrix.transformPoint(bottomRight.x, bottomRight.y, bottomRight);
                        bounds.x = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
                        bounds.y = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
                        bounds.width = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x) - bounds.x;
                        bounds.height = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y) - bounds.y;
                        return bounds;
                    },
                    /**
     * Destroys this Particle.
     *
     * @method Phaser.GameObjects.Particles.Particle#destroy
     * @since 3.60.0
     */ destroy: function() {
                        if (this.anims) this.anims.destroy();
                        this.anims = null;
                        this.emitter = null;
                        this.texture = null;
                        this.frame = null;
                        this.scene = null;
                    }
                });
                module1.exports = Particle;
            /***/ },
            /***/ 69601: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var ParticleProcessor = __webpack_require__(20286);
                var Rectangle = __webpack_require__(87841);
                /**
 * @classdesc
 * The Particle Bounds Processor.
 *
 * Defines a rectangular region, in world space, within which particle movement
 * is restrained.
 *
 * Use the properties `collideLeft`, `collideRight`, `collideTop` and
 * `collideBottom` to control if a particle will rebound off the sides
 * of this boundary, or not.
 *
 * This happens when the particles worldPosition x/y coordinate hits the boundary.
 *
 * The strength of the rebound is determined by the `Particle.bounce` property.
 *
 * @class ParticleBounds
 * @extends Phaser.GameObjects.Particles.ParticleProcessor
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.60.0
 *
 * @param {number} x - The x position (top-left) of the bounds, in world space.
 * @param {number} y - The y position (top-left) of the bounds, in world space.
 * @param {number} width - The width of the bounds.
 * @param {number} height - The height of the bounds.
 * @param {boolean} [collideLeft=true] - Whether particles interact with the left edge of the bounds.
 * @param {boolean} [collideRight=true] - Whether particles interact with the right edge of the bounds.
 * @param {boolean} [collideTop=true] - Whether particles interact with the top edge of the bounds.
 * @param {boolean} [collideBottom=true] - Whether particles interact with the bottom edge of the bounds.
 */ var ParticleBounds = new Class({
                    Extends: ParticleProcessor,
                    initialize: function ParticleBounds(x, y, width, height, collideLeft, collideRight, collideTop, collideBottom) {
                        if (collideLeft === undefined) collideLeft = true;
                        if (collideRight === undefined) collideRight = true;
                        if (collideTop === undefined) collideTop = true;
                        if (collideBottom === undefined) collideBottom = true;
                        ParticleProcessor.call(this, x, y, true);
                        /**
         * A rectangular boundary constraining particle movement. Use the Emitter properties `collideLeft`,
         * `collideRight`, `collideTop` and `collideBottom` to control if a particle will rebound off
         * the sides of this boundary, or not. This happens when the particles x/y coordinate hits
         * the boundary.
         *
         * @name Phaser.GameObjects.Particles.ParticleBounds#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.60.0
         */ this.bounds = new Rectangle(x, y, width, height);
                        /**
         * Whether particles interact with the left edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleBounds#collideLeft
         * @type {boolean}
         * @default true
         * @since 3.60.0
         */ this.collideLeft = collideLeft;
                        /**
         * Whether particles interact with the right edge of the emitter {@link Phaser.GameObjects.Particles.ParticleBounds#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleBounds#collideRight
         * @type {boolean}
         * @default true
         * @since 3.60.0
         */ this.collideRight = collideRight;
                        /**
         * Whether particles interact with the top edge of the emitter {@link Phaser.GameObjects.Particles.ParticleBounds#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleBounds#collideTop
         * @type {boolean}
         * @default true
         * @since 3.60.0
         */ this.collideTop = collideTop;
                        /**
         * Whether particles interact with the bottom edge of the emitter {@link Phaser.GameObjects.Particles.ParticleBounds#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleBounds#collideBottom
         * @type {boolean}
         * @default true
         * @since 3.60.0
         */ this.collideBottom = collideBottom;
                    },
                    /**
     * Takes a Particle and updates it against the bounds.
     *
     * @method Phaser.GameObjects.Particles.ParticleBounds#update
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to update.
     */ update: function(particle) {
                        var bounds = this.bounds;
                        var bounce = -particle.bounce;
                        var pos = particle.worldPosition;
                        if (pos.x < bounds.x && this.collideLeft) {
                            particle.x += bounds.x - pos.x;
                            particle.velocityX *= bounce;
                        } else if (pos.x > bounds.right && this.collideRight) {
                            particle.x -= pos.x - bounds.right;
                            particle.velocityX *= bounce;
                        }
                        if (pos.y < bounds.y && this.collideTop) {
                            particle.y += bounds.y - pos.y;
                            particle.velocityY *= bounce;
                        } else if (pos.y > bounds.bottom && this.collideBottom) {
                            particle.y -= pos.y - bounds.bottom;
                            particle.velocityY *= bounce;
                        }
                    }
                });
                module1.exports = ParticleBounds;
            /***/ },
            /***/ 31600: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var ComponentsToJSON = __webpack_require__(53774);
                var CopyFrom = __webpack_require__(43459);
                var DeathZone = __webpack_require__(26388);
                var EdgeZone = __webpack_require__(19909);
                var EmitterColorOp = __webpack_require__(76472);
                var EmitterOp = __webpack_require__(44777);
                var Events = __webpack_require__(20696);
                var GameObject = __webpack_require__(95643);
                var GetFastValue = __webpack_require__(95540);
                var GetRandom = __webpack_require__(26546);
                var GravityWell = __webpack_require__(24502);
                var HasAny = __webpack_require__(1985);
                var HasValue = __webpack_require__(97022);
                var Inflate = __webpack_require__(86091);
                var List = __webpack_require__(73162);
                var MergeRect = __webpack_require__(20074);
                var MergeRight = __webpack_require__(269);
                var Particle = __webpack_require__(56480);
                var ParticleBounds = __webpack_require__(69601);
                var RandomZone = __webpack_require__(68875);
                var Rectangle = __webpack_require__(87841);
                var RectangleToRectangle = __webpack_require__(59996);
                var Remove = __webpack_require__(72905);
                var Render = __webpack_require__(90668);
                var StableSort = __webpack_require__(19186);
                var TransformMatrix = __webpack_require__(61340);
                var Vector2 = __webpack_require__(26099);
                var Wrap = __webpack_require__(15994);
                /**
 * Names of simple configuration properties.
 *
 * @ignore
 */ var configFastMap = [
                    'active',
                    'advance',
                    'blendMode',
                    'colorEase',
                    'deathCallback',
                    'deathCallbackScope',
                    'duration',
                    'emitCallback',
                    'emitCallbackScope',
                    'follow',
                    'frequency',
                    'gravityX',
                    'gravityY',
                    'maxAliveParticles',
                    'maxParticles',
                    'name',
                    'emitting',
                    'particleBringToTop',
                    'particleClass',
                    'radial',
                    'sortCallback',
                    'sortOrderAsc',
                    'sortProperty',
                    'stopAfter',
                    'tintFill',
                    'timeScale',
                    'trackVisible',
                    'visible'
                ];
                /**
 * Names of complex configuration properties.
 *
 * @ignore
 */ var configOpMap = [
                    'accelerationX',
                    'accelerationY',
                    'alpha',
                    'angle',
                    'bounce',
                    'color',
                    'delay',
                    'hold',
                    'lifespan',
                    'maxVelocityX',
                    'maxVelocityY',
                    'moveToX',
                    'moveToY',
                    'quantity',
                    'rotate',
                    'scaleX',
                    'scaleY',
                    'speedX',
                    'speedY',
                    'tint',
                    'x',
                    'y'
                ];
                /**
 * @classdesc
 * A Particle Emitter is a special kind of Game Object that controls a pool of {@link Phaser.GameObjects.Particles.Particle Particles}.
 *
 * Particle Emitters are created via a configuration object. The properties of this object
 * can be specified in a variety of formats, given you plenty of scope over the values they
 * return, leading to complex visual effects. Here are the different forms of configuration
 * value you can give:
 *
 * ## An explicit static value:
 *
 * ```js
 * x: 400
 * ```
 *
 * The x value will always be 400 when the particle is spawned.
 *
 * ## A random value:
 *
 * ```js
 * x: [ 100, 200, 300, 400 ]
 * ```
 *
 * The x value will be one of the 4 elements in the given array, picked at random on emission.
 *
 * ## A custom callback:
 *
 * ```js
 * x: (particle, key, t, value) => {
 *   return value + 50;
 * }
 * ```
 *
 * The x value is the result of calling this function. This is only used when the
 * particle is emitted, so it provides it's initial starting value. It is not used
 * when the particle is updated (see the onUpdate callback for that)
 *
 * ## A start / end object:
 *
 * This allows you to control the change in value between the given start and
 * end parameters over the course of the particles lifetime:
 *
 * ```js
 * scale: { start: 0, end: 1 }
 * ```
 *
 * The particle scale will start at 0 when emitted and ease to a scale of 1
 * over the course of its lifetime. You can also specify the ease function
 * used for this change (the default is Linear):
 *
 * ```js
 * scale: { start: 0, end: 1, ease: 'bounce.out' }
 * ```
 *
 * ## A start / end random object:
 *
 * The start and end object can have an optional `random` parameter.
 * This forces it to pick a random value between the two values and use
 * this as the starting value, then easing to the 'end' parameter over
 * its lifetime.
 *
 * ```js
 * scale: { start: 4, end: 0.5, random: true }
 * ```
 *
 * The particle will start with a random scale between 0.5 and 4 and then
 * scale to the end value over its lifetime. You can combine the above
 * with the `ease` parameter as well to control the value easing.
 *
 * ## An interpolation object:
 *
 * You can provide an array of values which will be used for interpolation
 * during the particles lifetime. You can also define the interpolation
 * function to be used. There are three provided: `linear` (the default),
 * `bezier` and `catmull`, or you can provide your own function.
 *
 * ```js
 * x: { values: [ 50, 500, 200, 800 ], interpolation: 'catmull' }
 * ```
 *
 * The particle scale will interpolate from 50 when emitted to 800 via the other
 * points over the course of its lifetime. You can also specify an ease function
 * used to control the rate of change through the values (the default is Linear):
 *
 * ```js
 * x: { values: [ 50, 500, 200, 800 ], interpolation: 'catmull', ease: 'bounce.out }
 * ```
 *
 * ## A stepped emitter object:
 *
 * The `steps` parameter allows you to control the placement of sequential
 * particles across the start-end range:
 *
 * ```js
 * x: { steps: 32, start: 0, end: 576 }
 * ```
 *
 * Here we have a range of 576 (start to end). This is divided into 32 steps.
 *
 * The first particle will emit at the x position of 0. The next will emit
 * at the next 'step' along, which would be 18. The following particle will emit
 * at the next step, which is 36, and so on. Because the range of 576 has been
 * divided by 32, creating 18 pixels steps. When a particle reaches the 'end'
 * value the next one will start from the beginning again.
 *
 * ## A stepped emitter object with yoyo:
 *
 * You can add the optional `yoyo` property to a stepped object:
 *
 * ```js
 * x: { steps: 32, start: 0, end: 576, yoyo: true }
 * ```
 *
 * As with the stepped emitter, particles are emitted in sequence, from 'start'
 * to 'end' in step sized jumps. Normally, when a stepped emitter reaches the
 * end it snaps around to the start value again. However, if you provide the 'yoyo'
 * parameter then when it reaches the end it will reverse direction and start
 * emitting back down to 'start' again. Depending on the effect you require this
 * can often look better.
 *
 * ## A min / max object:
 *
 * This allows you to pick a random float value between the min and max properties:
 *
 * ```js
 * x: { min: 100, max: 700 }
 * ```
 *
 * The x value will be a random float between min and max.
 *
 * You can force it select an integer by setting the 'int' flag:
 *
 * ```js
 * x: { min: 100, max: 700, int: true }
 * ```
 *
 * Or, you could use the 'random' array approach (see below)
 *
 * ## A random object:
 *
 * This allows you to pick a random integer value between the first and second array elements:
 *
 * ```js
 * x: { random: [ 100, 700 ] }
 * ```
 *
 * The x value will be a random integer between 100 and 700 as it takes the first
 * element in the 'random' array as the 'min' value and the 2nd element as the 'max' value.
 *
 * ## Custom onEmit and onUpdate callbacks:
 *
 * If the above won't give you the effect you're after, you can provide your own
 * callbacks that will be used when the particle is both emitted and updated:
 *
 * ```js
 * x: {
 *   onEmit: (particle, key, t, value) => {
 *     return value;
 *   },
 *   onUpdate: (particle, key, t, value) => {
 *     return value;
 *   }
 * }
 * ```
 *
 * You can provide either one or both functions. The `onEmit` is called at the
 * start of the particles life and defines the value of the property on birth.
 *
 * The `onUpdate` function is called every time the Particle Emitter updates
 * until the particle dies. Both must return a value.
 *
 * The properties are:
 *
 * particle - A reference to the Particle instance.
 * key - The string based key of the property, i.e. 'x' or 'lifespan'.
 * t - The current normalized lifetime of the particle, between 0 (birth) and 1 (death).
 * value - The current property value. At a minimum you should return this.
 *
 * By using the above configuration options you have an unlimited about of
 * control over how your particles behave.
 *
 * ## v3.55 Differences
 *
 * Prior to v3.60 Phaser used a `ParticleEmitterManager`. This was removed in v3.60
 * and now calling `this.add.particles` returns a `ParticleEmitter` instance instead.
 *
 * In order to streamline memory and the display list we have removed the
 * `ParticleEmitterManager` entirely. When you call `this.add.particles` you're now
 * creating a `ParticleEmitter` instance, which is being added directly to the
 * display list and can be manipulated just like any other Game Object, i.e.
 * scaled, rotated, positioned, added to a Container, etc. It now extends the
 * `GameObject` base class, meaning it's also an event emitter, which allowed us
 * to create some handy new events for particles.
 *
 * So, to create an emitter, you now give it an xy coordinate, a texture and an
 * emitter configuration object (you can also set this later, but most commonly
 * you'd do it on creation). I.e.:
 *
 * ```js
 * const emitter = this.add.particles(100, 300, 'flares', {
 *   frame: 'red',
 *   angle: { min: -30, max: 30 },
 *   speed: 150
 * });
 * ```
 *
 * This will create a 'red flare' emitter at 100 x 300.
 *
 * Please update your code to ensure it adheres to the new function signatures.
 *
 * @class ParticleEmitter
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.60.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x] - The horizontal position of this Game Object in the world.
 * @param {number} [y] - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} [texture] - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} [config] - Settings for this emitter.
 */ var ParticleEmitter = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Mask,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Texture,
                        Components.Transform,
                        Components.Visible,
                        Render
                    ],
                    initialize: function ParticleEmitter(scene, x, y, texture, config) {
                        GameObject.call(this, scene, 'ParticleEmitter');
                        /**
         * The Particle Class which will be emitted by this Emitter.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleClass
         * @type {function}
         * @default Phaser.GameObjects.Particles.Particle
         * @since 3.0.0
         * @see Phaser.Types.GameObjects.Particles.ParticleClassConstructor
         */ this.particleClass = Particle;
                        /**
         * An internal object holding the configuration for the Emitter.
         *
         * These are populated as part of the Emitter configuration parsing.
         *
         * You typically do not access them directly, but instead use the
         * `ParticleEmitter.setConfig` or `ParticleEmitter.updateConfig` methods.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#config
         * @type {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig}
         * @since 3.85.0
         */ this.config = null;
                        /**
         * An internal object holding all of the EmitterOp instances.
         *
         * These are populated as part of the Emitter configuration parsing.
         *
         * You typically do not access them directly, but instead use the
         * provided getters and setters on this class, such as `ParticleEmitter.speedX` etc.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#ops
         * @type {Phaser.Types.GameObjects.Particles.ParticleEmitterOps}
         * @since 3.60.0
         */ this.ops = {
                            accelerationX: new EmitterOp('accelerationX', 0),
                            accelerationY: new EmitterOp('accelerationY', 0),
                            alpha: new EmitterOp('alpha', 1),
                            angle: new EmitterOp('angle', {
                                min: 0,
                                max: 360
                            }, true),
                            bounce: new EmitterOp('bounce', 0),
                            color: new EmitterColorOp('color'),
                            delay: new EmitterOp('delay', 0, true),
                            hold: new EmitterOp('hold', 0, true),
                            lifespan: new EmitterOp('lifespan', 1000, true),
                            maxVelocityX: new EmitterOp('maxVelocityX', 10000),
                            maxVelocityY: new EmitterOp('maxVelocityY', 10000),
                            moveToX: new EmitterOp('moveToX', 0),
                            moveToY: new EmitterOp('moveToY', 0),
                            quantity: new EmitterOp('quantity', 1, true),
                            rotate: new EmitterOp('rotate', 0),
                            scaleX: new EmitterOp('scaleX', 1),
                            scaleY: new EmitterOp('scaleY', 1),
                            speedX: new EmitterOp('speedX', 0, true),
                            speedY: new EmitterOp('speedY', 0, true),
                            tint: new EmitterOp('tint', 0xffffff),
                            x: new EmitterOp('x', 0),
                            y: new EmitterOp('y', 0)
                        };
                        /**
         * A radial emitter will emit particles in all directions between angle min and max,
         * using {@link Phaser.GameObjects.Particles.ParticleEmitter#speed} as the value. If set to false then this acts as a point Emitter.
         * A point emitter will emit particles only in the direction derived from the speedX and speedY values.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#radial
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setRadial
         */ this.radial = true;
                        /**
         * Horizontal acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityX
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
         */ this.gravityX = 0;
                        /**
         * Vertical acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityY
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
         */ this.gravityY = 0;
                        /**
         * Whether accelerationX and accelerationY are non-zero. Set automatically during configuration.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#acceleration
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.acceleration = false;
                        /**
         * Whether moveToX and moveToY are set. Set automatically during configuration.
         *
         * When true the particles move toward the moveToX and moveToY coordinates and arrive at the end of their life.
         * Emitter angle, speedX, and speedY are ignored.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveTo
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.moveTo = false;
                        /**
         * A function to call when a particle is emitted.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallback
         * @type {?Phaser.Types.GameObjects.Particles.ParticleEmitterCallback}
         * @default null
         * @since 3.0.0
         */ this.emitCallback = null;
                        /**
         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#emitCallback}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallbackScope
         * @type {?*}
         * @default null
         * @since 3.0.0
         */ this.emitCallbackScope = null;
                        /**
         * A function to call when a particle dies.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallback
         * @type {?Phaser.Types.GameObjects.Particles.ParticleDeathCallback}
         * @default null
         * @since 3.0.0
         */ this.deathCallback = null;
                        /**
         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#deathCallback}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallbackScope
         * @type {?*}
         * @default null
         * @since 3.0.0
         */ this.deathCallbackScope = null;
                        /**
         * Set to hard limit the amount of particle objects this emitter is allowed to create
         * in total. This is the number of `Particle` instances it can create, not the number
         * of 'alive' particles.
         *
         * 0 means unlimited.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxParticles
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxParticles = 0;
                        /**
         * The maximum number of alive and rendering particles this emitter will update.
         * When this limit is reached, a particle needs to die before another can be emitted.
         *
         * 0 means no limits.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxAliveParticles
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.maxAliveParticles = 0;
                        /**
         * If set, either via the Emitter config, or by directly setting this property,
         * the Particle Emitter will stop emitting particles once this total has been
         * reached. It will then enter a 'stopped' state, firing the `STOP`
         * event. Note that entering a stopped state doesn't mean all the particles
         * have finished, just that it's not emitting any further ones.
         *
         * To know when the final particle expires, listen for the COMPLETE event.
         *
         * Use this if you wish to launch an exact number of particles and then stop
         * your emitter afterwards.
         *
         * The counter is reset each time the `ParticleEmitter.start` method is called.
         *
         * 0 means the emitter will not stop based on total emitted particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#stopAfter
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.stopAfter = 0;
                        /**
         * The number of milliseconds this emitter will emit particles for when in flow mode,
         * before it stops emission. A value of 0 (the default) means there is no duration.
         *
         * When the duration expires the `STOP` event is emitted. Note that entering a
         * stopped state doesn't mean all the particles have finished, just that it's
         * not emitting any further ones.
         *
         * To know when the final particle expires, listen for the COMPLETE event.
         *
         * The counter is reset each time the `ParticleEmitter.start` method is called.
         *
         * 0 means the emitter will not stop based on duration.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#duration
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.duration = 0;
                        /**
         * For a flow emitter, the time interval (>= 0) between particle flow cycles in ms.
         * A value of 0 means there is one particle flow cycle for each logic update (the maximum flow frequency). This is the default setting.
         * For an exploding emitter, this value will be -1.
         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} also puts the emitter in flow mode (frequency >= 0).
         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} also puts the emitter in explode mode (frequency = -1).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frequency
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
         */ this.frequency = 0;
                        /**
         * Controls if the emitter is currently emitting a particle flow (when frequency >= 0).
         *
         * Already alive particles will continue to update until they expire.
         *
         * Controlled by {@link Phaser.GameObjects.Particles.ParticleEmitter#start} and {@link Phaser.GameObjects.Particles.ParticleEmitter#stop}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitting
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.emitting = true;
                        /**
         * Newly emitted particles are added to the top of the particle list, i.e. rendered above those already alive.
         *
         * Set to false to send them to the back.
         *
         * Also see the `sortOrder` property for more complex particle sorting.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleBringToTop
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.particleBringToTop = true;
                        /**
         * The time rate applied to active particles, affecting lifespan, movement, and tweens. Values larger than 1 are faster than normal.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                        /**
         * An array containing Particle Emission Zones. These can be either EdgeZones or RandomZones.
         *
         * Particles are emitted from a randomly selected zone from this array.
         *
         * Prior to Phaser v3.60 an Emitter could only have one single Emission Zone.
         * In 3.60 they can now have an array of Emission Zones.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitZones
         * @type {Phaser.Types.GameObjects.Particles.EmitZoneObject[]}
         * @since 3.60.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
         */ this.emitZones = [];
                        /**
         * An array containing Particle Death Zone objects. A particle is immediately killed as soon as its x/y coordinates
         * intersect with any of the configured Death Zones.
         *
         * Prior to Phaser v3.60 an Emitter could only have one single Death Zone.
         * In 3.60 they can now have an array of Death Zones.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathZones
         * @type {Phaser.GameObjects.Particles.Zones.DeathZone[]}
         * @since 3.60.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setDeathZone
         */ this.deathZones = [];
                        /**
         * An optional Rectangle object that is used during rendering to cull Particles from
         * display. For example, if your particles are limited to only move within a 300x300
         * sized area from their origin, then you can set this Rectangle to those dimensions.
         *
         * The renderer will check to see if the `viewBounds` Rectangle intersects with the
         * Camera bounds during the render step and if not it will skip rendering the Emitter
         * entirely.
         *
         * This allows you to create many emitters in a Scene without the cost of
         * rendering if the contents aren't visible.
         *
         * Note that the Emitter will not perform any checks to see if the Particles themselves
         * are outside of these bounds, or not. It will simply check the bounds against the
         * camera. Use the `getBounds` method with the `advance` parameter to help define
         * the location and placement of the view bounds.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#viewBounds
         * @type {?Phaser.Geom.Rectangle}
         * @default null
         * @since 3.60.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setViewBounds
         */ this.viewBounds = null;
                        /**
         * A Game Object whose position is used as the particle origin.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#follow
         * @type {?Phaser.Types.Math.Vector2Like}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         * @see Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
         */ this.follow = null;
                        /**
         * The offset of the particle origin from the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#followOffset
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         */ this.followOffset = new Vector2();
                        /**
         * Whether the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#visible} state will track
         * the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target's visibility state.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#trackVisible
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         */ this.trackVisible = false;
                        /**
         * The texture frames assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frames
         * @type {Phaser.Textures.Frame[]}
         * @since 3.0.0
         */ this.frames = [];
                        /**
         * Whether texture {@link Phaser.GameObjects.Particles.ParticleEmitter#frames} are selected at random.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#randomFrame
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setEmitterFrame
         */ this.randomFrame = true;
                        /**
         * The number of consecutive particles that receive a single texture frame (per frame cycle).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity
         * @type {number}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setEmitterFrame
         */ this.frameQuantity = 1;
                        /**
         * The animations assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#anims
         * @type {string[]}
         * @since 3.60.0
         */ this.anims = [];
                        /**
         * Whether animations {@link Phaser.GameObjects.Particles.ParticleEmitter#anims} are selected at random.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#randomAnim
         * @type {boolean}
         * @default true
         * @since 3.60.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAnim
         */ this.randomAnim = true;
                        /**
         * The number of consecutive particles that receive a single animation (per frame cycle).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#animQuantity
         * @type {number}
         * @default 1
         * @since 3.60.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAnim
         */ this.animQuantity = 1;
                        /**
         * An array containing all currently inactive Particle instances.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#dead
         * @type {Phaser.GameObjects.Particles.Particle[]}
         * @private
         * @since 3.0.0
         */ this.dead = [];
                        /**
         * An array containing all currently live and rendering Particle instances.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#alive
         * @type {Phaser.GameObjects.Particles.Particle[]}
         * @private
         * @since 3.0.0
         */ this.alive = [];
                        /**
         * Internal array that holds counter data:
         *
         * 0 - flowCounter - The time until next flow cycle.
         * 1 - frameCounter - Counts up to {@link Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity}.
         * 2 - animCounter - Counts up to animQuantity.
         * 3 - elapsed - The time remaining until the `duration` limit is reached.
         * 4 - stopCounter - The number of particles remaining until `stopAfter` limit is reached.
         * 5 - completeFlag - Has the COMPLETE event been emitted?
         * 6 - zoneIndex - The emit zone index counter.
         * 7 - zoneTotal - The emit zone total counter.
         * 8 - currentFrame - The current texture frame, as an index of {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
         * 9 - currentAnim - The current animation, as an index of {@link Phaser.GameObjects.Particles.ParticleEmitter#anims}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#counters
         * @type {Float32Array}
         * @private
         * @since 3.60.0
         */ this.counters = new Float32Array(10);
                        /**
         * An internal property used to tell when the emitter is in fast-forwarc mode.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#skipping
         * @type {boolean}
         * @default true
         * @since 3.60.0
         */ this.skipping = false;
                        /**
         * An internal Transform Matrix used to cache this emitters world matrix.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#worldMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.60.0
         */ this.worldMatrix = new TransformMatrix();
                        /**
         * Optionally sort the particles before they render based on this
         * property. The property must exist on the `Particle` class, such
         * as `y`, `lifeT`, `scaleX`, etc.
         *
         * When set this overrides the `particleBringToTop` setting.
         *
         * To reset this and disable sorting, so this property to an empty string.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#sortProperty
         * @type {string}
         * @since 3.60.0
         */ this.sortProperty = '';
                        /**
         * When `sortProperty` is defined this controls the sorting order,
         * either ascending or descending. Toggle to control the visual effect.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#sortOrderAsc
         * @type {boolean}
         * @since 3.60.0
         */ this.sortOrderAsc = true;
                        /**
         * The callback used to sort the particles. Only used if `sortProperty`
         * has been set. Set this via the `setSortCallback` method.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#sortCallback
         * @type {?Phaser.Types.GameObjects.Particles.ParticleSortCallback}
         * @since 3.60.0
         */ this.sortCallback = this.depthSortCallback;
                        /**
         * A list of Particle Processors being managed by this Emitter.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#processors
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Particles.ParticleProcessor>}
         * @since 3.60.0
         */ this.processors = new List(this);
                        /**
         * The tint fill mode used by the Particles in this Emitter.
         *
         * `false` = An additive tint (the default), where vertices colors are blended with the texture.
         * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#tintFill
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.tintFill = false;
                        this.initPipeline();
                        this.initPostPipeline();
                        this.setPosition(x, y);
                        this.setTexture(texture);
                        if (config) this.setConfig(config);
                    },
                    //  Overrides Game Object method
                    addedToScene: function() {
                        this.scene.sys.updateList.add(this);
                    },
                    //  Overrides Game Object method
                    removedFromScene: function() {
                        this.scene.sys.updateList.remove(this);
                    },
                    /**
     * Takes an Emitter Configuration file and resets this Emitter, using any
     * properties defined in the config to then set it up again.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setConfig
     * @since 3.60.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for this emitter.
     *
     * @return {this} This Particle Emitter.
     */ setConfig: function(config) {
                        if (!config) return this;
                        this.config = config;
                        var i = 0;
                        var key = '';
                        var ops = this.ops;
                        for(i = 0; i < configOpMap.length; i++){
                            key = configOpMap[i];
                            ops[key].loadConfig(config);
                        }
                        for(i = 0; i < configFastMap.length; i++){
                            key = configFastMap[i];
                            //  Only update properties from their current state if they exist in the given config
                            if (HasValue(config, key)) this[key] = GetFastValue(config, key);
                        }
                        this.acceleration = this.accelerationX !== 0 || this.accelerationY !== 0;
                        this.moveTo = this.moveToX !== 0 && this.moveToY !== 0;
                        //  Special 'speed' override
                        if (HasValue(config, 'speed')) {
                            ops.speedX.loadConfig(config, 'speed');
                            ops.speedY.active = false;
                        }
                        //  If you specify speedX, speedY or moveTo then it changes the emitter from radial to a point emitter
                        if (HasAny(config, [
                            'speedX',
                            'speedY'
                        ]) || this.moveTo) this.radial = false;
                        //  Special 'scale' override
                        if (HasValue(config, 'scale')) {
                            ops.scaleX.loadConfig(config, 'scale');
                            ops.scaleY.active = false;
                        }
                        if (HasValue(config, 'callbackScope')) {
                            var callbackScope = GetFastValue(config, 'callbackScope', null);
                            this.emitCallbackScope = callbackScope;
                            this.deathCallbackScope = callbackScope;
                        }
                        if (HasValue(config, 'emitZone')) this.addEmitZone(config.emitZone);
                        if (HasValue(config, 'deathZone')) this.addDeathZone(config.deathZone);
                        if (HasValue(config, 'bounds')) {
                            var bounds = this.addParticleBounds(config.bounds);
                            bounds.collideLeft = GetFastValue(config, 'collideLeft', true);
                            bounds.collideRight = GetFastValue(config, 'collideRight', true);
                            bounds.collideTop = GetFastValue(config, 'collideTop', true);
                            bounds.collideBottom = GetFastValue(config, 'collideBottom', true);
                        }
                        if (HasValue(config, 'followOffset')) this.followOffset.setFromObject(GetFastValue(config, 'followOffset', 0));
                        if (HasValue(config, 'texture')) this.setTexture(config.texture);
                        if (HasValue(config, 'frame')) this.setEmitterFrame(config.frame);
                        else if (HasValue(config, 'anim')) this.setAnim(config.anim);
                        if (HasValue(config, 'reserve')) this.reserve(config.reserve);
                        if (HasValue(config, 'advance')) this.fastForward(config.advance);
                        this.resetCounters(this.frequency, this.emitting);
                        if (this.emitting) this.emit(Events.START, this);
                        return this;
                    },
                    /**
     * Takes an existing Emitter Configuration file and updates this Emitter.
     * Existing properties are overriden while new properties are added. The
     * updated configuration is then passed to the `setConfig` method to reset
     * the Emitter with the updated configuration.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#updateConfig
     * @since 3.85.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for this emitter.
     *
     * @return {this} This Particle Emitter.
     */ updateConfig: function(config) {
                        if (config) {
                            if (!this.config) this.setConfig(config);
                            else this.setConfig(MergeRight(this.config, config));
                        }
                        return this;
                    },
                    /**
     * Creates a description of this emitter suitable for JSON serialization.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                        var output = ComponentsToJSON(this);
                        var i = 0;
                        var key = '';
                        for(i = 0; i < configFastMap.length; i++){
                            key = configFastMap[i];
                            output[key] = this[key];
                        }
                        var ops = this.ops;
                        for(i = 0; i < configOpMap.length; i++){
                            key = configOpMap[i];
                            if (ops[key]) output[key] = ops[key].toJSON();
                        }
                        //  special handlers
                        if (!ops.speedY.active) {
                            delete output.speedX;
                            output.speed = ops.speedX.toJSON();
                        }
                        if (this.scaleX === this.scaleY) {
                            delete output.scaleX;
                            delete output.scaleY;
                            output.scale = ops.scaleX.toJSON();
                        }
                        return output;
                    },
                    /**
     * Resets the internal counter trackers.
     *
     * You shouldn't ever need to call this directly.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#resetCounters
     * @since 3.60.0
     *
     * @param {number} frequency - The frequency counter.
     * @param {boolean} on - Set the complete flag.
     */ resetCounters: function(frequency, on) {
                        var counters = this.counters;
                        counters.fill(0);
                        counters[0] = frequency;
                        if (on) counters[5] = 1;
                    },
                    /**
     * Continuously moves the particle origin to follow a Game Object's position.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#startFollow
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} target - The Object to follow.
     * @param {number} [offsetX=0] - Horizontal offset of the particle origin from the Game Object.
     * @param {number} [offsetY=0] - Vertical offset of the particle origin from the Game Object.
     * @param {boolean} [trackVisible=false] - Whether the emitter's visible state will track the target's visible state.
     *
     * @return {this} This Particle Emitter.
     */ startFollow: function(target, offsetX, offsetY, trackVisible) {
                        if (offsetX === undefined) offsetX = 0;
                        if (offsetY === undefined) offsetY = 0;
                        if (trackVisible === undefined) trackVisible = false;
                        this.follow = target;
                        this.followOffset.set(offsetX, offsetY);
                        this.trackVisible = trackVisible;
                        return this;
                    },
                    /**
     * Stops following a Game Object.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ stopFollow: function() {
                        this.follow = null;
                        this.followOffset.set(0, 0);
                        this.trackVisible = false;
                        return this;
                    },
                    /**
     * Chooses a texture frame from {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getFrame
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} The texture frame.
     */ getFrame: function() {
                        var frames = this.frames;
                        var len = frames.length;
                        var current;
                        if (len === 1) current = frames[0];
                        else if (this.randomFrame) current = GetRandom(frames);
                        else {
                            current = frames[this.currentFrame];
                            this.frameCounter++;
                            if (this.frameCounter === this.frameQuantity) {
                                this.frameCounter = 0;
                                this.currentFrame++;
                                if (this.currentFrame === len) this.currentFrame = 0;
                            }
                        }
                        return this.texture.get(current);
                    },
                    /**
     * Sets a pattern for assigning texture frames to emitted particles. The `frames` configuration can be any of:
     *
     * frame: 0
     * frame: 'red'
     * frame: [ 0, 1, 2, 3 ]
     * frame: [ 'red', 'green', 'blue', 'pink', 'white' ]
     * frame: { frames: [ 'red', 'green', 'blue', 'pink', 'white' ], [cycle: bool], [quantity: int] }
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitterFrame
     * @since 3.0.0
     *
     * @param {(array|string|number|Phaser.Types.GameObjects.Particles.ParticleEmitterFrameConfig)} frames - One or more texture frames, or a configuration object.
     * @param {boolean} [pickRandom=true] - Whether frames should be assigned at random from `frames`.
     * @param {number} [quantity=1] - The number of consecutive particles that will receive each frame.
     *
     * @return {this} This Particle Emitter.
     */ setEmitterFrame: function(frames, pickRandom, quantity) {
                        if (pickRandom === undefined) pickRandom = true;
                        if (quantity === undefined) quantity = 1;
                        this.randomFrame = pickRandom;
                        this.frameQuantity = quantity;
                        this.currentFrame = 0;
                        var t = typeof frames;
                        this.frames.length = 0;
                        if (Array.isArray(frames)) this.frames = this.frames.concat(frames);
                        else if (t === 'string' || t === 'number') this.frames.push(frames);
                        else if (t === 'object') {
                            var frameConfig = frames;
                            frames = GetFastValue(frameConfig, 'frames', null);
                            if (frames) this.frames = this.frames.concat(frames);
                            var isCycle = GetFastValue(frameConfig, 'cycle', false);
                            this.randomFrame = isCycle ? false : true;
                            this.frameQuantity = GetFastValue(frameConfig, 'quantity', quantity);
                        }
                        if (this.frames.length === 1) {
                            this.frameQuantity = 1;
                            this.randomFrame = false;
                        }
                        return this;
                    },
                    /**
     * Chooses an animation from {@link Phaser.GameObjects.Particles.ParticleEmitter#anims}, if populated.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getAnim
     * @since 3.60.0
     *
     * @return {string} The animation to play, or `null` if there aren't any.
     */ getAnim: function() {
                        var anims = this.anims;
                        var len = anims.length;
                        if (len === 0) return null;
                        else if (len === 1) return anims[0];
                        else if (this.randomAnim) return GetRandom(anims);
                        else {
                            var anim = anims[this.currentAnim];
                            this.animCounter++;
                            if (this.animCounter >= this.animQuantity) {
                                this.animCounter = 0;
                                this.currentAnim = Wrap(this.currentAnim + 1, 0, len);
                            }
                            return anim;
                        }
                    },
                    /**
     * Sets a pattern for assigning animations to emitted particles. The `anims` configuration can be any of:
     *
     * anim: 'red'
     * anim: [ 'red', 'green', 'blue', 'pink', 'white' ]
     * anim: { anims: [ 'red', 'green', 'blue', 'pink', 'white' ], [cycle: bool], [quantity: int] }
     *
     * Call this method at least once before any particles are created, or set `anim` in the Particle Emitter's configuration when creating the Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setAnim
     * @since 3.60.0
     *
     * @param {(string|string[]|Phaser.Types.GameObjects.Particles.ParticleEmitterAnimConfig)} anims - One or more animations, or a configuration object.
     * @param {boolean} [pickRandom=true] - Whether animations should be assigned at random from `anims`. If a config object is given, this parameter is ignored.
     * @param {number} [quantity=1] - The number of consecutive particles that will receive each animation. If a config object is given, this parameter is ignored.
     *
     * @return {this} This Particle Emitter.
     */ setAnim: function(anims, pickRandom, quantity) {
                        if (pickRandom === undefined) pickRandom = true;
                        if (quantity === undefined) quantity = 1;
                        this.randomAnim = pickRandom;
                        this.animQuantity = quantity;
                        this.currentAnim = 0;
                        var t = typeof anims;
                        this.anims.length = 0;
                        if (Array.isArray(anims)) this.anims = this.anims.concat(anims);
                        else if (t === 'string') this.anims.push(anims);
                        else if (t === 'object') {
                            var animConfig = anims;
                            anims = GetFastValue(animConfig, 'anims', null);
                            if (anims) this.anims = this.anims.concat(anims);
                            var isCycle = GetFastValue(animConfig, 'cycle', false);
                            this.randomAnim = isCycle ? false : true;
                            this.animQuantity = GetFastValue(animConfig, 'quantity', quantity);
                        }
                        if (this.anims.length === 1) {
                            this.animQuantity = 1;
                            this.randomAnim = false;
                        }
                        return this;
                    },
                    /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle movement on or off.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setRadial
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Radial mode (true) or point mode (true).
     *
     * @return {this} This Particle Emitter.
     */ setRadial: function(value) {
                        if (value === undefined) value = true;
                        this.radial = value;
                        return this;
                    },
                    /**
     * Creates a Particle Bounds processor and adds it to this Emitter.
     *
     * This processor will check to see if any of the active Particles hit
     * the defined boundary, as specified by a Rectangle shape in world-space.
     *
     * If so, they are 'rebounded' back again by having their velocity adjusted.
     *
     * The strength of the rebound is controlled by the `Particle.bounce`
     * property.
     *
     * You should be careful to ensure that you emit particles within a bounds,
     * if set, otherwise it will lead to unpredictable visual results as the
     * particles are hastily repositioned.
     *
     * The Particle Bounds processor is returned from this method. If you wish
     * to modify the area you can directly change its `bounds` property, along
     * with the `collideLeft` etc values.
     *
     * To disable the bounds you can either set its `active` property to `false`,
     * or if you no longer require it, call `ParticleEmitter.removeParticleProcessor`.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#addParticleBounds
     * @since 3.60.0
     *
     * @param {(number|Phaser.Types.GameObjects.Particles.ParticleEmitterBounds|Phaser.Types.GameObjects.Particles.ParticleEmitterBoundsAlt)} x - The x-coordinate of the left edge of the boundary, or an object representing a rectangle.
     * @param {number} [y] - The y-coordinate of the top edge of the boundary.
     * @param {number} [width] - The width of the boundary.
     * @param {number} [height] - The height of the boundary.
     * @param {boolean} [collideLeft=true] - Whether particles interact with the left edge of the bounds.
     * @param {boolean} [collideRight=true] - Whether particles interact with the right edge of the bounds.
     * @param {boolean} [collideTop=true] - Whether particles interact with the top edge of the bounds.
     * @param {boolean} [collideBottom=true] - Whether particles interact with the bottom edge of the bounds.
     *
     * @return {Phaser.GameObjects.Particles.ParticleBounds} The Particle Bounds processor.
     */ addParticleBounds: function(x, y, width, height, collideLeft, collideRight, collideTop, collideBottom) {
                        if (typeof x === 'object') {
                            var obj = x;
                            x = obj.x;
                            y = obj.y;
                            width = HasValue(obj, 'w') ? obj.w : obj.width;
                            height = HasValue(obj, 'h') ? obj.h : obj.height;
                        }
                        return this.addParticleProcessor(new ParticleBounds(x, y, width, height, collideLeft, collideRight, collideTop, collideBottom));
                    },
                    /**
     * Sets the initial radial speed of emitted particles.
     *
     * Changes the emitter to radial mode.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setParticleSpeed
     * @since 3.60.0
     *
     * @param {number} x - The horizontal speed of the emitted Particles.
     * @param {number} [y=x] - The vertical speed of emitted Particles. If not set it will use the `x` value.
     *
     * @return {this} This Particle Emitter.
     */ setParticleSpeed: function(x, y) {
                        if (y === undefined) y = x;
                        this.ops.speedX.onChange(x);
                        if (x === y) this.ops.speedY.active = false;
                        else this.ops.speedY.onChange(y);
                        //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
                        this.radial = true;
                        return this;
                    },
                    /**
     * Sets the vertical and horizontal scale of the emitted particles.
     *
     * You can also set the scale of the entire emitter via `setScale`.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setParticleScale
     * @since 3.60.0
     *
     * @param {number} [x=1] - The horizontal scale of the emitted Particles.
     * @param {number} [y=x] - The vertical scale of emitted Particles. If not set it will use the `x` value.
     *
     * @return {this} This Particle Emitter.
     */ setParticleScale: function(x, y) {
                        if (x === undefined) x = 1;
                        if (y === undefined) y = x;
                        this.ops.scaleX.onChange(x);
                        this.ops.scaleY.onChange(y);
                        return this;
                    },
                    /**
     * Sets the gravity applied to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setParticleGravity
     * @since 3.60.0
     *
     * @param {number} x - Horizontal acceleration due to gravity, in pixels per second squared. Set to zero for no gravity.
     * @param {number} y - Vertical acceleration due to gravity, in pixels per second squared. Set to zero for no gravity.
     *
     * @return {this} This Particle Emitter.
     */ setParticleGravity: function(x, y) {
                        this.gravityX = x;
                        this.gravityY = y;
                        return this;
                    },
                    /**
     * Sets the opacity (alpha) of emitted particles.
     *
     * You can also set the alpha of the entire emitter via `setAlpha`.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setParticleAlpha
     * @since 3.60.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - A value between 0 (transparent) and 1 (opaque).
     *
     * @return {this} This Particle Emitter.
     */ setParticleAlpha: function(value) {
                        this.ops.alpha.onChange(value);
                        return this;
                    },
                    /**
     * Sets the color tint of emitted particles.
     *
     * This is a WebGL only feature.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setParticleTint
     * @since 3.60.0
     * @webglOnly
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - A value between 0 and 0xffffff.
     *
     * @return {this} This Particle Emitter.
     */ setParticleTint: function(value) {
                        this.ops.tint.onChange(value);
                        return this;
                    },
                    /**
     * Sets the angle of a {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle stream.
     *
     * The value is given in degrees using Phaser's right-handed coordinate system.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitterAngle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The angle of the initial velocity of emitted particles, in degrees.
     *
     * @return {this} This Particle Emitter.
     */ setEmitterAngle: function(value) {
                        this.ops.angle.onChange(value);
                        return this;
                    },
                    /**
     * Sets the lifespan of newly emitted particles in milliseconds.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setParticleLifespan
     * @since 3.60.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The lifespan of a particle, in ms.
     *
     * @return {this} This Particle Emitter.
     */ setParticleLifespan: function(value) {
                        this.ops.lifespan.onChange(value);
                        return this;
                    },
                    /**
     * Sets the number of particles released at each flow cycle or explosion.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} quantity - The number of particles to release at each flow cycle or explosion.
     *
     * @return {this} This Particle Emitter.
     */ setQuantity: function(quantity) {
                        this.quantity = quantity;
                        return this;
                    },
                    /**
     * Sets the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#frequency}
     * and {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
     * @since 3.0.0
     *
     * @param {number} frequency - The time interval (>= 0) of each flow cycle, in ms; or -1 to put the emitter in explosion mode.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} [quantity] - The number of particles to release at each flow cycle or explosion.
     *
     * @return {this} This Particle Emitter.
     */ setFrequency: function(frequency, quantity) {
                        this.frequency = frequency;
                        this.flowCounter = frequency > 0 ? frequency : 0;
                        if (quantity) this.quantity = quantity;
                        return this;
                    },
                    /**
     * Adds a new Particle Death Zone to this Emitter.
     *
     * A particle is immediately killed as soon as its x/y coordinates intersect
     * with any of the configured Death Zones.
     *
     * The `source` can be a Geometry Shape, such as a Circle, Rectangle or Triangle.
     * Any valid object from the `Phaser.Geometry` namespace is allowed, as long as
     * it supports a `contains` function. You can set the `type` to be either `onEnter`
     * or `onLeave`.
     *
     * A single Death Zone instance can only exist once within this Emitter, but can belong
     * to multiple Emitters.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#addDeathZone
     * @since 3.60.0
     *
     * @param {Phaser.Types.GameObjects.Particles.DeathZoneObject|Phaser.Types.GameObjects.Particles.DeathZoneObject[]} config - A Death Zone configuration object, a Death Zone instance, a valid Geometry object or an array of them.
     *
     * @return {Phaser.GameObjects.Particles.Zones.DeathZone[]} An array of the Death Zones that were added to this Emitter.
     */ addDeathZone: function(config) {
                        if (!Array.isArray(config)) config = [
                            config
                        ];
                        var zone;
                        var output = [];
                        for(var i = 0; i < config.length; i++){
                            zone = config[i];
                            if (zone instanceof DeathZone) output.push(zone);
                            else if (typeof zone.contains === 'function') {
                                zone = new DeathZone(zone, true);
                                output.push(zone);
                            } else {
                                var type = GetFastValue(zone, 'type', 'onEnter');
                                var source = GetFastValue(zone, 'source', null);
                                if (source && typeof source.contains === 'function') {
                                    var killOnEnter = type === 'onEnter' ? true : false;
                                    zone = new DeathZone(source, killOnEnter);
                                    output.push(zone);
                                }
                            }
                        }
                        this.deathZones = this.deathZones.concat(output);
                        return output;
                    },
                    /**
     * Removes the given Particle Death Zone from this Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#removeDeathZone
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Zones.DeathZone} zone - The Death Zone that should be removed from this Emitter.
     *
     * @return {this} This Particle Emitter.
     */ removeDeathZone: function(zone) {
                        Remove(this.deathZones, zone);
                        return this;
                    },
                    /**
     * Clear all Death Zones from this Particle Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#clearDeathZones
     * @since 3.70.0
     *
     * @return {this} This Particle Emitter.
     */ clearDeathZones: function() {
                        this.deathZones.length = 0;
                        return this;
                    },
                    /**
     * Adds a new Particle Emission Zone to this Emitter.
     *
     * An {@link Phaser.Types.GameObjects.Particles.ParticleEmitterEdgeZoneConfig EdgeZone} places particles on its edges.
     * Its {@link Phaser.Types.GameObjects.Particles.EdgeZoneSource source} can be a Curve, Path, Circle, Ellipse, Line, Polygon, Rectangle, or Triangle;
     * or any object with a suitable {@link Phaser.Types.GameObjects.Particles.EdgeZoneSourceCallback getPoints} method.
     *
     * A {@link Phaser.Types.GameObjects.Particles.ParticleEmitterRandomZoneConfig RandomZone} places the particles randomly within its interior.
     * Its {@link Phaser.GameObjects.Particles.Zones.RandomZone#source source} can be a Circle, Ellipse, Line, Polygon, Rectangle, or Triangle; or any object with a suitable {@link Phaser.Types.GameObjects.Particles.RandomZoneSourceCallback getRandomPoint} method.
     *
     * An Emission Zone can only exist once within this Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#addEmitZone
     * @since 3.60.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitZoneData|Phaser.Types.GameObjects.Particles.EmitZoneData[]} zone - An Emission Zone configuration object, a RandomZone or EdgeZone instance, or an array of them.
     *
     * @return {Phaser.Types.GameObjects.Particles.EmitZoneObject[]} An array of the Emission Zones that were added to this Emitter.
     */ addEmitZone: function(config) {
                        if (!Array.isArray(config)) config = [
                            config
                        ];
                        var zone;
                        var output = [];
                        for(var i = 0; i < config.length; i++){
                            zone = config[i];
                            if (zone instanceof RandomZone || zone instanceof EdgeZone) output.push(zone);
                            else {
                                //  Where source = Geom like Circle, or a Path or Curve
                                //  emitZone: { type: 'random', source: X }
                                //  emitZone: { type: 'edge', source: X, quantity: 32, [stepRate=0], [yoyo=false], [seamless=true], [total=1] }
                                var source = GetFastValue(zone, 'source', null);
                                if (source) {
                                    var type = GetFastValue(zone, 'type', 'random');
                                    if (type === 'random' && typeof source.getRandomPoint === 'function') {
                                        zone = new RandomZone(source);
                                        output.push(zone);
                                    } else if (type === 'edge' && typeof source.getPoints === 'function') {
                                        var quantity = GetFastValue(zone, 'quantity', 1);
                                        var stepRate = GetFastValue(zone, 'stepRate', 0);
                                        var yoyo = GetFastValue(zone, 'yoyo', false);
                                        var seamless = GetFastValue(zone, 'seamless', true);
                                        var total = GetFastValue(zone, 'total', -1);
                                        zone = new EdgeZone(source, quantity, stepRate, yoyo, seamless, total);
                                        output.push(zone);
                                    }
                                }
                            }
                        }
                        this.emitZones = this.emitZones.concat(output);
                        return output;
                    },
                    /**
     * Removes the given Particle Emission Zone from this Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#removeEmitZone
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Zones.EdgeZone|Phaser.GameObjects.Particles.Zones.RandomZone} zone - The Emission Zone that should be removed from this Emitter.
     *
     * @return {this} This Particle Emitter.
     */ removeEmitZone: function(zone) {
                        Remove(this.emitZones, zone);
                        this.zoneIndex = 0;
                        return this;
                    },
                    /**
     * Clear all Emission Zones from this Particle Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#clearEmitZones
     * @since 3.70.0
     *
     * @return {this} This Particle Emitter.
     */ clearEmitZones: function() {
                        this.emitZones.length = 0;
                        this.zoneIndex = 0;
                        return this;
                    },
                    /**
     * Takes the given particle and sets its x/y coordinates to match the next available
     * emission zone, if any have been configured. This method is called automatically
     * as part of the `Particle.fire` process.
     *
     * The Emit Zones are iterated in sequence. Once a zone has had a particle emitted
     * from it, then the next zone is used and so on, in a loop.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getEmitZone
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle to set the emission zone for.
     */ getEmitZone: function(particle) {
                        var zones = this.emitZones;
                        var len = zones.length;
                        if (len === 0) return;
                        else {
                            var zone = zones[this.zoneIndex];
                            zone.getPoint(particle);
                            if (zone.total > -1) {
                                this.zoneTotal++;
                                if (this.zoneTotal === zone.total) {
                                    this.zoneTotal = 0;
                                    this.zoneIndex++;
                                    if (this.zoneIndex === len) this.zoneIndex = 0;
                                }
                            }
                        }
                    },
                    /**
     * Takes the given particle and checks to see if any of the configured Death Zones
     * will kill it and returns the result. This method is called automatically as part
     * of the `Particle.update` process.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getDeathZone
     * @fires Phaser.GameObjects.Particles.Events#DEATH_ZONE
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle to test against the Death Zones.
     *
     * @return {boolean} `true` if the particle should be killed, otherwise `false`.
     */ getDeathZone: function(particle) {
                        var zones = this.deathZones;
                        for(var i = 0; i < zones.length; i++){
                            var zone = zones[i];
                            if (zone.willKill(particle)) {
                                this.emit(Events.DEATH_ZONE, this, particle, zone);
                                return true;
                            }
                        }
                        return false;
                    },
                    /**
     * Changes the currently active Emission Zone. The zones should have already
     * been added to this Emitter either via the emitter config, or the
     * `addEmitZone` method.
     *
     * Call this method by passing either a numeric zone index value, or
     * the zone instance itself.
     *
     * Prior to v3.60 an Emitter could only have a single Emit Zone and this
     * method was how you set it. From 3.60 and up it now performs a different
     * function and swaps between all available active zones.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
     * @since 3.0.0
     *
     * @param {number|Phaser.GameObjects.Particles.Zones.EdgeZone|Phaser.GameObjects.Particles.Zones.RandomZone} zone - The Emit Zone to set as the active zone.
     *
     * @return {this} This Particle Emitter.
     */ setEmitZone: function(zone) {
                        var index;
                        if (isFinite(zone)) index = zone;
                        else index = this.emitZones.indexOf(zone);
                        if (index >= 0) this.zoneIndex = index;
                        return this;
                    },
                    /**
     * Adds a Particle Processor, such as a Gravity Well, to this Emitter.
     *
     * It will start processing particles from the next update as long as its `active`
     * property is set.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#addParticleProcessor
     * @since 3.60.0
     *
     * @generic {Phaser.GameObjects.Particles.ParticleProcessor} T
     * @param {T} processor - The Particle Processor to add to this Emitter Manager.
     *
     * @return {T} The Particle Processor that was added to this Emitter Manager.
     */ addParticleProcessor: function(processor) {
                        if (!this.processors.exists(processor)) {
                            if (processor.emitter) processor.emitter.removeParticleProcessor(processor);
                            this.processors.add(processor);
                            processor.emitter = this;
                        }
                        return processor;
                    },
                    /**
     * Removes a Particle Processor from this Emitter.
     *
     * The Processor must belong to this Emitter to be removed.
     *
     * It is not destroyed when removed, allowing you to move it to another Emitter Manager,
     * so if you no longer require it you should call its `destroy` method directly.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#removeParticleProcessor
     * @since 3.60.0
     *
     * @generic {Phaser.GameObjects.Particles.ParticleProcessor} T
     * @param {T} processor - The Particle Processor to remove from this Emitter Manager.
     *
     * @return {?T} The Particle Processor that was removed, or null if it could not be found.
     */ removeParticleProcessor: function(processor) {
                        if (this.processors.exists(processor)) {
                            this.processors.remove(processor, true);
                            processor.emitter = null;
                        }
                        return processor;
                    },
                    /**
     * Gets all active Particle Processors.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getProcessors
     * @since 3.60.0
     *
     * @return {Phaser.GameObjects.Particles.ParticleProcessor[]} - An array of active Particle Processors.
     */ getProcessors: function() {
                        return this.processors.getAll('active', true);
                    },
                    /**
     * Creates a new Gravity Well, adds it to this Emitter and returns a reference to it.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#createGravityWell
     * @since 3.60.0
     *
     * @param {Phaser.Types.GameObjects.Particles.GravityWellConfig} config - Configuration settings for the Gravity Well to create.
     *
     * @return {Phaser.GameObjects.Particles.GravityWell} The Gravity Well that was created.
     */ createGravityWell: function(config) {
                        return this.addParticleProcessor(new GravityWell(config));
                    },
                    /**
     * Creates inactive particles and adds them to this emitter's pool.
     *
     * If `ParticleEmitter.maxParticles` is set it will limit the
     * value passed to this method to make sure it's not exceeded.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#reserve
     * @since 3.0.0
     *
     * @param {number} count - The number of particles to create.
     *
     * @return {this} This Particle Emitter.
     */ reserve: function(count) {
                        var dead = this.dead;
                        if (this.maxParticles > 0) {
                            var total = this.getParticleCount();
                            if (total + count > this.maxParticles) count = this.maxParticles - (total + count);
                        }
                        for(var i = 0; i < count; i++)dead.push(new this.particleClass(this));
                        return this;
                    },
                    /**
     * Gets the number of active (in-use) particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getAliveParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles with `active=true`.
     */ getAliveParticleCount: function() {
                        return this.alive.length;
                    },
                    /**
     * Gets the number of inactive (available) particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getDeadParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles with `active=false`.
     */ getDeadParticleCount: function() {
                        return this.dead.length;
                    },
                    /**
     * Gets the total number of particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles, including both alive and dead.
     */ getParticleCount: function() {
                        return this.getAliveParticleCount() + this.getDeadParticleCount();
                    },
                    /**
     * Whether this emitter is at either its hard-cap limit (maxParticles), if set, or
     * the max allowed number of 'alive' particles (maxAliveParticles).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#atLimit
     * @since 3.0.0
     *
     * @return {boolean} Returns `true` if this Emitter is at its limit, or `false` if no limit, or below the `maxParticles` level.
     */ atLimit: function() {
                        if (this.maxParticles > 0 && this.getParticleCount() >= this.maxParticles) return true;
                        return this.maxAliveParticles > 0 && this.getAliveParticleCount() >= this.maxAliveParticles;
                    },
                    /**
     * Sets a function to call for each newly emitted particle.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleEmit
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} [context] - The calling context.
     *
     * @return {this} This Particle Emitter.
     */ onParticleEmit: function(callback, context) {
                        if (callback === undefined) {
                            //  Clear any previously set callback
                            this.emitCallback = null;
                            this.emitCallbackScope = null;
                        } else if (typeof callback === 'function') {
                            this.emitCallback = callback;
                            if (context) this.emitCallbackScope = context;
                        }
                        return this;
                    },
                    /**
     * Sets a function to call for each particle death.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleDeath
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleDeathCallback} callback - The function.
     * @param {*} [context] - The function's calling context.
     *
     * @return {this} This Particle Emitter.
     */ onParticleDeath: function(callback, context) {
                        if (callback === undefined) {
                            //  Clear any previously set callback
                            this.deathCallback = null;
                            this.deathCallbackScope = null;
                        } else if (typeof callback === 'function') {
                            this.deathCallback = callback;
                            if (context) this.deathCallbackScope = context;
                        }
                        return this;
                    },
                    /**
     * Deactivates every particle in this emitter immediately.
     *
     * This particles are killed but do not emit an event or callback.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#killAll
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ killAll: function() {
                        var dead = this.dead;
                        var alive = this.alive;
                        while(alive.length > 0)dead.push(alive.pop());
                        return this;
                    },
                    /**
     * Calls a function for each active particle in this emitter. The function is
     * sent two parameters: a reference to the Particle instance and to this Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachAlive
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} context - The functions calling context.
     *
     * @return {this} This Particle Emitter.
     */ forEachAlive: function(callback, context) {
                        var alive = this.alive;
                        var length = alive.length;
                        for(var i = 0; i < length; i++)//  Sends the Particle and the Emitter
                        callback.call(context, alive[i], this);
                        return this;
                    },
                    /**
     * Calls a function for each inactive particle in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachDead
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} context - The functions calling context.
     *
     * @return {this} This Particle Emitter.
     */ forEachDead: function(callback, context) {
                        var dead = this.dead;
                        var length = dead.length;
                        for(var i = 0; i < length; i++)callback.call(context, dead[i], this);
                        return this;
                    },
                    /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#on} the emitter and resets the flow counter.
     *
     * If this emitter is in flow mode (frequency >= 0; the default), the particle flow will start (or restart).
     *
     * If this emitter is in explode mode (frequency = -1), nothing will happen.
     * Use {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} or {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} instead.
     *
     * Calling this method will emit the `START` event.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#start
     * @fires Phaser.GameObjects.Particles.Events#START
     * @since 3.0.0
     *
     * @param {number} [advance=0] - Advance this number of ms in time through the emitter.
     * @param {number} [duration=0] - Limit this emitter to only emit particles for the given number of ms. Setting this parameter will override any duration already set in the Emitter configuration object.
     *
     * @return {this} This Particle Emitter.
     */ start: function(advance, duration) {
                        if (advance === undefined) advance = 0;
                        if (!this.emitting) {
                            if (advance > 0) this.fastForward(advance);
                            this.emitting = true;
                            this.resetCounters(this.frequency, true);
                            if (duration !== undefined) this.duration = Math.abs(duration);
                            this.emit(Events.START, this);
                        }
                        return this;
                    },
                    /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#emitting off} the emitter and
     * stops it from emitting further particles. Currently alive particles will remain
     * active until they naturally expire unless you set the `kill` parameter to `true`.
     *
     * Calling this method will emit the `STOP` event. When the final particle has
     * expired the `COMPLETE` event will be emitted.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#stop
     * @fires Phaser.GameObjects.Particles.Events#STOP
     * @since 3.11.0
     *
     * @param {boolean} [kill=false] - Kill all particles immediately (true), or leave them to die after their lifespan expires? (false, the default)
     *
     * @return {this} This Particle Emitter.
     */ stop: function(kill) {
                        if (kill === undefined) kill = false;
                        if (this.emitting) {
                            this.emitting = false;
                            if (kill) this.killAll();
                            this.emit(Events.STOP, this);
                        }
                        return this;
                    },
                    /**
     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Deactivates} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#pause
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ pause: function() {
                        this.active = false;
                        return this;
                    },
                    /**
     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Activates} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#resume
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ resume: function() {
                        this.active = true;
                        return this;
                    },
                    /**
     * Set the property by which active particles are sorted prior to be rendered.
     *
     * It allows you to control the rendering order of the particles.
     *
     * This can be any valid property of the `Particle` class, such as `y`, `alpha`
     * or `lifeT`.
     *
     * The 'alive' particles array is sorted in place each game frame. Setting a
     * sort property will override the `particleBringToTop` setting.
     *
     * If you wish to use your own sorting function, see `setSortCallback` instead.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSortProperty
     * @since 3.60.0
     *
     * @param {string} [property] - The property on the `Particle` class to sort by.
     * @param {boolean} [ascending=true] - Should the particles be sorted in ascending or descending order?
     *
     * @return {this} This Particle Emitter.
     */ setSortProperty: function(property, ascending) {
                        if (property === undefined) property = '';
                        if (ascending === undefined) ascending = this.true;
                        this.sortProperty = property;
                        this.sortOrderAsc = ascending;
                        this.sortCallback = this.depthSortCallback;
                        return this;
                    },
                    /**
     * Sets a callback to be used to sort the particles before rendering each frame.
     *
     * This allows you to define your own logic and behavior in the callback.
     *
     * The callback will be sent two parameters: the two Particles being compared,
     * and must adhere to the criteria of the `compareFn` in `Array.sort`:
     *
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#description
     *
     * Call this method with no parameters to reset the sort callback.
     *
     * Setting your own callback will override both the `particleBringToTop` and
     * `sortProperty` settings of this Emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSortCallback
     * @since 3.60.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleSortCallback} [callback] - The callback to invoke when the particles are sorted. Leave undefined to reset to the default.
     *
     * @return {this} This Particle Emitter.
     */ setSortCallback: function(callback) {
                        if (this.sortProperty !== '') callback = this.depthSortCallback;
                        else callback = null;
                        this.sortCallback = callback;
                        return this;
                    },
                    /**
     * Sorts active particles with {@link Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSort
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ depthSort: function() {
                        StableSort(this.alive, this.sortCallback.bind(this));
                        return this;
                    },
                    /**
     * Calculates the difference of two particles, for sorting them by depth.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback
     * @since 3.0.0
     *
     * @param {object} a - The first particle.
     * @param {object} b - The second particle.
     *
     * @return {number} The difference of a and b's y coordinates.
     */ depthSortCallback: function(a, b) {
                        var key = this.sortProperty;
                        if (this.sortOrderAsc) return a[key] - b[key];
                        else return b[key] - a[key];
                    },
                    /**
     * Puts the emitter in flow mode (frequency >= 0) and starts (or restarts) a particle flow.
     *
     * To resume a flow at the current frequency and quantity, use {@link Phaser.GameObjects.Particles.ParticleEmitter#start} instead.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#flow
     * @fires Phaser.GameObjects.Particles.Events#START
     * @since 3.0.0
     *
     * @param {number} frequency - The time interval (>= 0) of each flow cycle, in ms.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} [count=1] - The number of particles to emit at each flow cycle.
     * @param {number} [stopAfter] - Stop this emitter from firing any more particles once this value is reached. Set to zero for unlimited. Setting this parameter will override any `stopAfter` value already set in the Emitter configuration object.
     *
     * @return {this} This Particle Emitter.
     */ flow: function(frequency, count, stopAfter) {
                        if (count === undefined) count = 1;
                        this.emitting = false;
                        this.frequency = frequency;
                        this.quantity = count;
                        if (stopAfter !== undefined) this.stopAfter = stopAfter;
                        return this.start();
                    },
                    /**
     * Puts the emitter in explode mode (frequency = -1), stopping any current particle flow, and emits several particles all at once.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#explode
     * @fires Phaser.GameObjects.Particles.Events#EXPLODE
     * @since 3.0.0
     *
     * @param {number} [count=this.quantity] - The number of Particles to emit.
     * @param {number} [x=this.x] - The x coordinate to emit the Particles from.
     * @param {number} [y=this.x] - The y coordinate to emit the Particles from.
     *
     * @return {(Phaser.GameObjects.Particles.Particle|undefined)} The most recently emitted Particle, or `undefined` if the emitter is at its limit.
     */ explode: function(count, x, y) {
                        this.frequency = -1;
                        this.resetCounters(-1, true);
                        var particle = this.emitParticle(count, x, y);
                        this.emit(Events.EXPLODE, this, particle);
                        return particle;
                    },
                    /**
     * Emits particles at the given position. If no position is given, it will
     * emit from this Emitters current location.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticleAt
     * @since 3.0.0
     *
     * @param {number} [x=this.x] - The x coordinate to emit the Particles from.
     * @param {number} [y=this.x] - The y coordinate to emit the Particles from.
     * @param {number} [count=this.quantity] - The number of Particles to emit.
     *
     * @return {(Phaser.GameObjects.Particles.Particle|undefined)} The most recently emitted Particle, or `undefined` if the emitter is at its limit.
     */ emitParticleAt: function(x, y, count) {
                        return this.emitParticle(count, x, y);
                    },
                    /**
     * Emits particles at a given position (or the emitters current position).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticle
     * @since 3.0.0
     *
     * @param {number} [count=this.quantity] - The number of Particles to emit.
     * @param {number} [x=this.x] - The x coordinate to emit the Particles from.
     * @param {number} [y=this.x] - The y coordinate to emit the Particles from.
     *
     * @return {(Phaser.GameObjects.Particles.Particle|undefined)} The most recently emitted Particle, or `undefined` if the emitter is at its limit.
     *
     * @see Phaser.GameObjects.Particles.Particle#fire
     */ emitParticle: function(count, x, y) {
                        if (this.atLimit()) return;
                        if (count === undefined) count = this.ops.quantity.onEmit();
                        var dead = this.dead;
                        var stopAfter = this.stopAfter;
                        var followX = this.follow ? this.follow.x + this.followOffset.x : x;
                        var followY = this.follow ? this.follow.y + this.followOffset.y : y;
                        for(var i = 0; i < count; i++){
                            var particle = dead.pop();
                            if (!particle) particle = new this.particleClass(this);
                            if (particle.fire(followX, followY)) {
                                if (this.particleBringToTop) this.alive.push(particle);
                                else this.alive.unshift(particle);
                                if (this.emitCallback) this.emitCallback.call(this.emitCallbackScope, particle, this);
                            } else this.dead.push(particle);
                            if (stopAfter > 0) {
                                this.stopCounter++;
                                if (this.stopCounter >= stopAfter) break;
                            }
                            if (this.atLimit()) break;
                        }
                        return particle;
                    },
                    /**
     * Fast forwards this Particle Emitter and all of its particles.
     *
     * Works by running the Emitter `preUpdate` handler in a loop until the `time`
     * has been reached at `delta` steps per loop.
     *
     * All callbacks and emitter related events that would normally be fired
     * will still be invoked.
     *
     * You can make an emitter 'fast forward' via the emitter config using the
     * `advance` property. Set this value to the number of ms you wish the
     * emitter to be fast-forwarded by. Or, call this method post-creation.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#fastForward
     * @since 3.60.0
     *
     * @param {number} time - The number of ms to advance the Particle Emitter by.
     * @param {number} [delta] - The amount of delta to use for each step. Defaults to 1000 / 60.
     *
     * @return {this} This Particle Emitter.
     */ fastForward: function(time, delta) {
                        if (delta === undefined) delta = 1000 / 60;
                        var total = 0;
                        this.skipping = true;
                        while(total < Math.abs(time)){
                            this.preUpdate(0, delta);
                            total += delta;
                        }
                        this.skipping = false;
                        return this;
                    },
                    /**
     * Updates this emitter and its particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#preUpdate
     * @fires Phaser.GameObjects.Particles.Events#COMPLETE
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                        //  Scale the delta
                        delta *= this.timeScale;
                        var step = delta / 1000;
                        if (this.trackVisible) this.visible = this.follow.visible;
                        this.getWorldTransformMatrix(this.worldMatrix);
                        //  Any particle processors?
                        var processors = this.getProcessors();
                        var particles = this.alive;
                        var dead = this.dead;
                        var i = 0;
                        var rip = [];
                        var length = particles.length;
                        for(i = 0; i < length; i++){
                            var particle = particles[i];
                            //  update returns `true` if the particle is now dead (lifeCurrent <= 0)
                            if (particle.update(delta, step, processors)) rip.push({
                                index: i,
                                particle: particle
                            });
                        }
                        //  Move dead particles to the dead array
                        length = rip.length;
                        if (length > 0) {
                            var deathCallback = this.deathCallback;
                            var deathCallbackScope = this.deathCallbackScope;
                            for(i = length - 1; i >= 0; i--){
                                var entry = rip[i];
                                //  Remove from particles array
                                particles.splice(entry.index, 1);
                                //  Add to dead array
                                dead.push(entry.particle);
                                //  Callback
                                if (deathCallback) deathCallback.call(deathCallbackScope, entry.particle);
                                entry.particle.setPosition();
                            }
                        }
                        if (!this.emitting && !this.skipping) {
                            if (this.completeFlag === 1 && particles.length === 0) {
                                this.completeFlag = 0;
                                this.emit(Events.COMPLETE, this);
                            }
                            return;
                        }
                        if (this.frequency === 0) this.emitParticle();
                        else if (this.frequency > 0) {
                            this.flowCounter -= delta;
                            while(this.flowCounter <= 0){
                                //  Emits the 'quantity' number of particles
                                this.emitParticle();
                                //  counter = frequency - remainder from previous delta
                                this.flowCounter += this.frequency;
                            }
                        }
                        //  Duration or stopAfter set?
                        if (!this.skipping) {
                            if (this.duration > 0) {
                                //  elapsed
                                this.elapsed += delta;
                                if (this.elapsed >= this.duration) this.stop();
                            }
                            if (this.stopAfter > 0 && this.stopCounter >= this.stopAfter) this.stop();
                        }
                    },
                    /**
     * Takes either a Rectangle Geometry object or an Arcade Physics Body and tests
     * to see if it intersects with any currently alive Particle in this Emitter.
     *
     * Overlapping particles are returned in an array, where you can perform further
     * processing on them. If nothing overlaps then the array will be empty.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#overlap
     * @since 3.60.0
     *
     * @param {(Phaser.Geom.Rectangle|Phaser.Physics.Arcade.Body)} target - A Rectangle or Arcade Physics Body to check for intersection against all alive particles.
     *
     * @return {Phaser.GameObjects.Particles.Particle[]} An array of Particles that overlap with the given target.
     */ overlap: function(target) {
                        var matrix = this.getWorldTransformMatrix();
                        var alive = this.alive;
                        var length = alive.length;
                        var output = [];
                        for(var i = 0; i < length; i++){
                            var particle = alive[i];
                            if (RectangleToRectangle(target, particle.getBounds(matrix))) output.push(particle);
                        }
                        return output;
                    },
                    /**
     * Returns a bounds Rectangle calculated from the bounds of all currently
     * _active_ Particles in this Emitter. If this Emitter has only just been
     * created and not yet rendered, then calling this method will return a Rectangle
     * with a max safe integer for dimensions. Use the `advance` parameter to
     * avoid this.
     *
     * Typically it takes a few seconds for a flow Emitter to 'warm up'. You can
     * use the `advance` and `delta` parameters to force the Emitter to
     * 'fast forward' in time to try and allow the bounds to be more accurate,
     * as it will calculate the bounds based on the particle bounds across all
     * timesteps, giving a better result.
     *
     * You can also use the `padding` parameter to increase the size of the
     * bounds. Emitters with a lot of randomness in terms of direction or lifespan
     * can often return a bounds smaller than their possible maximum. By using
     * the `padding` (and `advance` if needed) you can help limit this.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getBounds
     * @since 3.60.0
     *
     * @param {number} [padding] - The amount of padding, in pixels, to add to the bounds Rectangle.
     * @param {number} [advance] - The number of ms to advance the Particle Emitter by. Defaults to 0, i.e. not used.
     * @param {number} [delta] - The amount of delta to use for each step. Defaults to 1000 / 60.
     * @param {Phaser.Geom.Rectangle} [output] - The Rectangle to store the results in. If not given a new one will be created.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle containing the calculated bounds of this Emitter.
     */ getBounds: function(padding, advance, delta, output) {
                        if (padding === undefined) padding = 0;
                        if (advance === undefined) advance = 0;
                        if (delta === undefined) delta = 1000 / 60;
                        if (output === undefined) output = new Rectangle();
                        var matrix = this.getWorldTransformMatrix();
                        var i;
                        var bounds;
                        var alive = this.alive;
                        var setFirst = false;
                        output.setTo(0, 0, 0, 0);
                        if (advance > 0) {
                            var total = 0;
                            this.skipping = true;
                            while(total < Math.abs(advance)){
                                this.preUpdate(0, delta);
                                for(i = 0; i < alive.length; i++){
                                    bounds = alive[i].getBounds(matrix);
                                    if (!setFirst) {
                                        setFirst = true;
                                        CopyFrom(bounds, output);
                                    } else MergeRect(output, bounds);
                                }
                                total += delta;
                            }
                            this.skipping = false;
                        } else for(i = 0; i < alive.length; i++){
                            bounds = alive[i].getBounds(matrix);
                            if (!setFirst) {
                                setFirst = true;
                                CopyFrom(bounds, output);
                            } else MergeRect(output, bounds);
                        }
                        if (padding > 0) Inflate(output, padding, padding);
                        return output;
                    },
                    /**
     * Prints a warning to the console if you mistakenly call this function
     * thinking it works the same way as Phaser v3.55.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#createEmitter
     * @since 3.60.0
     */ createEmitter: function() {
                        throw new Error('createEmitter removed. See ParticleEmitter docs for info');
                    },
                    /**
     * The x coordinate the particles are emitted from.
     *
     * This is relative to the Emitters x coordinate and that of any parent.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleX
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType}
     * @since 3.60.0
     */ particleX: {
                        get: function() {
                            return this.ops.x.current;
                        },
                        set: function(value) {
                            this.ops.x.onChange(value);
                        }
                    },
                    /**
     * The y coordinate the particles are emitted from.
     *
     * This is relative to the Emitters x coordinate and that of any parent.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleY
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType}
     * @since 3.60.0
     */ particleY: {
                        get: function() {
                            return this.ops.y.current;
                        },
                        set: function(value) {
                            this.ops.y.onChange(value);
                        }
                    },
                    /**
     * The horizontal acceleration applied to emitted particles, in pixels per second squared.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationX
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ accelerationX: {
                        get: function() {
                            return this.ops.accelerationX.current;
                        },
                        set: function(value) {
                            this.ops.accelerationX.onChange(value);
                        }
                    },
                    /**
     * The vertical acceleration applied to emitted particles, in pixels per second squared.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationY
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ accelerationY: {
                        get: function() {
                            return this.ops.accelerationY.current;
                        },
                        set: function(value) {
                            this.ops.accelerationY.onChange(value);
                        }
                    },
                    /**
     * The maximum horizontal velocity emitted particles can reach, in pixels per second squared.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityX
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     * @default 10000
     */ maxVelocityX: {
                        get: function() {
                            return this.ops.maxVelocityX.current;
                        },
                        set: function(value) {
                            this.ops.maxVelocityX.onChange(value);
                        }
                    },
                    /**
     * The maximum vertical velocity emitted particles can reach, in pixels per second squared.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityY
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     * @default 10000
     */ maxVelocityY: {
                        get: function() {
                            return this.ops.maxVelocityY.current;
                        },
                        set: function(value) {
                            this.ops.maxVelocityY.onChange(value);
                        }
                    },
                    /**
     * The initial speed of emitted particles, in pixels per second.
     *
     * If using this as a getter it will return the `speedX` value.
     *
     * If using it as a setter it will update both `speedX` and `speedY` to the
     * given value.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#speed
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ speed: {
                        get: function() {
                            return this.ops.speedX.current;
                        },
                        set: function(value) {
                            this.ops.speedX.onChange(value);
                            this.ops.speedY.onChange(value);
                        }
                    },
                    /**
     * The initial horizontal speed of emitted particles, in pixels per second.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#speedX
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ speedX: {
                        get: function() {
                            return this.ops.speedX.current;
                        },
                        set: function(value) {
                            this.ops.speedX.onChange(value);
                        }
                    },
                    /**
     * The initial vertical speed of emitted particles, in pixels per second.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#speedY
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ speedY: {
                        get: function() {
                            return this.ops.speedY.current;
                        },
                        set: function(value) {
                            this.ops.speedY.onChange(value);
                        }
                    },
                    /**
     * The x coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToX
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ moveToX: {
                        get: function() {
                            return this.ops.moveToX.current;
                        },
                        set: function(value) {
                            this.ops.moveToX.onChange(value);
                        }
                    },
                    /**
     * The y coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToY
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ moveToY: {
                        get: function() {
                            return this.ops.moveToY.current;
                        },
                        set: function(value) {
                            this.ops.moveToY.onChange(value);
                        }
                    },
                    /**
     * The amount of velocity particles will use when rebounding off the
     * emitter bounds, if set. A value of 0 means no bounce. A value of 1
     * means a full rebound.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#bounce
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ bounce: {
                        get: function() {
                            return this.ops.bounce.current;
                        },
                        set: function(value) {
                            this.ops.bounce.onChange(value);
                        }
                    },
                    /**
     * The horizontal scale of emitted particles.
     *
     * This is relative to the Emitters scale and that of any parent.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleScaleX
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ particleScaleX: {
                        get: function() {
                            return this.ops.scaleX.current;
                        },
                        set: function(value) {
                            this.ops.scaleX.onChange(value);
                        }
                    },
                    /**
     * The vertical scale of emitted particles.
     *
     * This is relative to the Emitters scale and that of any parent.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleScaleY
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ particleScaleY: {
                        get: function() {
                            return this.ops.scaleY.current;
                        },
                        set: function(value) {
                            this.ops.scaleY.onChange(value);
                        }
                    },
                    /**
     * A color tint value that is applied to the texture of the emitted
     * particle. The value should be given in hex format, i.e. 0xff0000
     * for a red tint, and should not include the alpha channel.
     *
     * Tints are additive, meaning a tint value of white (0xffffff) will
     * effectively reset the tint to nothing.
     *
     * Modify the `ParticleEmitter.tintFill` property to change between
     * an additive and replacement tint mode.
     *
     * When you define the color via the Emitter config you should give
     * it as an array of color values. The Particle will then interpolate
     * through these colors over the course of its lifespan. Setting this
     * will override any `tint` value that may also be given.
     *
     * This is a WebGL only feature.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleColor
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ particleColor: {
                        get: function() {
                            return this.ops.color.current;
                        },
                        set: function(value) {
                            this.ops.color.onChange(value);
                        }
                    },
                    /**
     * Controls the easing function used when you have created an
     * Emitter that uses the `color` property to interpolate the
     * tint of Particles over their lifetime.
     *
     * Setting this has no effect if you haven't also applied a
     * `particleColor` to this Emitter.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#colorEase
     * @type {string}
     * @since 3.60.0
     */ colorEase: {
                        get: function() {
                            return this.ops.color.easeName;
                        },
                        set: function(value) {
                            this.ops.color.setEase(value);
                        }
                    },
                    /**
     * A color tint value that is applied to the texture of the emitted
     * particle. The value should be given in hex format, i.e. 0xff0000
     * for a red tint, and should not include the alpha channel.
     *
     * Tints are additive, meaning a tint value of white (0xffffff) will
     * effectively reset the tint to nothing.
     *
     * Modify the `ParticleEmitter.tintFill` property to change between
     * an additive and replacement tint mode.
     *
     * The `tint` value will be overriden if a `color` array is provided.
     *
     * This is a WebGL only feature.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleTint
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ particleTint: {
                        get: function() {
                            return this.ops.tint.current;
                        },
                        set: function(value) {
                            this.ops.tint.onChange(value);
                        }
                    },
                    /**
     * The alpha value of the emitted particles. This is a value
     * between 0 and 1. Particles with alpha zero are invisible
     * and are therefore not rendered, but are still processed
     * by the Emitter.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleAlpha
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ particleAlpha: {
                        get: function() {
                            return this.ops.alpha.current;
                        },
                        set: function(value) {
                            this.ops.alpha.onChange(value);
                        }
                    },
                    /**
     * The lifespan of the emitted particles. This value is given
     * in milliseconds and defaults to 1000ms (1 second). When a
     * particle reaches this amount it is killed.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#lifespan
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ lifespan: {
                        get: function() {
                            return this.ops.lifespan.current;
                        },
                        set: function(value) {
                            this.ops.lifespan.onChange(value);
                        }
                    },
                    /**
     * The angle at which the particles are emitted. The values are
     * given in degrees. This allows you to control the direction
     * of the emitter. If you wish instead to change the rotation
     * of the particles themselves, see the `particleRotate` property.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleAngle
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ particleAngle: {
                        get: function() {
                            return this.ops.angle.current;
                        },
                        set: function(value) {
                            this.ops.angle.onChange(value);
                        }
                    },
                    /**
     * The rotation (or angle) of each particle when it is emitted.
     * The value is given in degrees and uses a right-handed
     * coordinate system, where 0 degrees points to the right, 90 degrees
     * points down and -90 degrees points up.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#particleRotate
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ particleRotate: {
                        get: function() {
                            return this.ops.rotate.current;
                        },
                        set: function(value) {
                            this.ops.rotate.onChange(value);
                        }
                    },
                    /**
     * The number of particles that are emitted each time an emission
     * occurs, i.e. from one 'explosion' or each frame in a 'flow' cycle.
     *
     * The default is 1.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#quantity
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
     * @see Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
     * @since 3.60.0
     */ quantity: {
                        get: function() {
                            return this.ops.quantity.current;
                        },
                        set: function(value) {
                            this.ops.quantity.onChange(value);
                        }
                    },
                    /**
     * The number of milliseconds to wait after emission before
     * the particles start updating. This allows you to emit particles
     * that appear 'static' or still on-screen and then, after this value,
     * begin to move.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#delay
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ delay: {
                        get: function() {
                            return this.ops.delay.current;
                        },
                        set: function(value) {
                            this.ops.delay.onChange(value);
                        }
                    },
                    /**
     * The number of milliseconds to wait after a particle has finished
     * its life before it will be removed. This allows you to 'hold' a
     * particle on the screen once it has reached its final state
     * before it then vanishes.
     *
     * Note that all particle updates will cease, including changing
     * alpha, scale, movement or animation.
     *
     * Accessing this property should typically return a number.
     * However, it can be set to any valid EmitterOp onEmit type.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#hold
     * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType}
     * @since 3.60.0
     */ hold: {
                        get: function() {
                            return this.ops.hold.current;
                        },
                        set: function(value) {
                            this.ops.hold.onChange(value);
                        }
                    },
                    /**
     * The internal flow counter.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#flowCounter
     * @type {number}
     * @since 3.60.0
     */ flowCounter: {
                        get: function() {
                            return this.counters[0];
                        },
                        set: function(value) {
                            this.counters[0] = value;
                        }
                    },
                    /**
     * The internal frame counter.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#frameCounter
     * @type {number}
     * @since 3.60.0
     */ frameCounter: {
                        get: function() {
                            return this.counters[1];
                        },
                        set: function(value) {
                            this.counters[1] = value;
                        }
                    },
                    /**
     * The internal animation counter.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#animCounter
     * @type {number}
     * @since 3.60.0
     */ animCounter: {
                        get: function() {
                            return this.counters[2];
                        },
                        set: function(value) {
                            this.counters[2] = value;
                        }
                    },
                    /**
     * The internal elasped counter.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#elapsed
     * @type {number}
     * @since 3.60.0
     */ elapsed: {
                        get: function() {
                            return this.counters[3];
                        },
                        set: function(value) {
                            this.counters[3] = value;
                        }
                    },
                    /**
     * The internal stop counter.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#stopCounter
     * @type {number}
     * @since 3.60.0
     */ stopCounter: {
                        get: function() {
                            return this.counters[4];
                        },
                        set: function(value) {
                            this.counters[4] = value;
                        }
                    },
                    /**
     * The internal complete flag.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#completeFlag
     * @type {boolean}
     * @since 3.60.0
     */ completeFlag: {
                        get: function() {
                            return this.counters[5];
                        },
                        set: function(value) {
                            this.counters[5] = value;
                        }
                    },
                    /**
     * The internal zone index.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#zoneIndex
     * @type {number}
     * @since 3.60.0
     */ zoneIndex: {
                        get: function() {
                            return this.counters[6];
                        },
                        set: function(value) {
                            this.counters[6] = value;
                        }
                    },
                    /**
     * The internal zone total.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#zoneTotal
     * @type {number}
     * @since 3.60.0
     */ zoneTotal: {
                        get: function() {
                            return this.counters[7];
                        },
                        set: function(value) {
                            this.counters[7] = value;
                        }
                    },
                    /**
     * The current frame index.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#currentFrame
     * @type {number}
     * @since 3.60.0
     */ currentFrame: {
                        get: function() {
                            return this.counters[8];
                        },
                        set: function(value) {
                            this.counters[8] = value;
                        }
                    },
                    /**
     * The current animation index.
     *
     * Treat this property as read-only.
     *
     * @name Phaser.GameObjects.Particles.ParticleEmitter#currentAnim
     * @type {number}
     * @since 3.60.0
     */ currentAnim: {
                        get: function() {
                            return this.counters[9];
                        },
                        set: function(value) {
                            this.counters[9] = value;
                        }
                    },
                    /**
     * Destroys this Particle Emitter and all Particles it owns.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#preDestroy
     * @since 3.60.0
     */ preDestroy: function() {
                        this.texture = null;
                        this.frames = null;
                        this.anims = null;
                        this.emitCallback = null;
                        this.emitCallbackScope = null;
                        this.deathCallback = null;
                        this.deathCallbackScope = null;
                        this.emitZones = null;
                        this.deathZones = null;
                        this.bounds = null;
                        this.follow = null;
                        this.counters = null;
                        var i;
                        var ops = this.ops;
                        for(i = 0; i < configOpMap.length; i++){
                            var key = configOpMap[i];
                            ops[key].destroy();
                        }
                        for(i = 0; i < this.alive.length; i++)this.alive[i].destroy();
                        for(i = 0; i < this.dead.length; i++)this.dead[i].destroy();
                        this.ops = null;
                        this.alive = [];
                        this.dead = [];
                        this.worldMatrix.destroy();
                    }
                });
                module1.exports = ParticleEmitter;
            /***/ },
            /***/ 9871: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RectangleToRectangle = __webpack_require__(59996);
                var TransformMatrix = __webpack_require__(61340);
                var tempMatrix1 = new TransformMatrix();
                var tempMatrix2 = new TransformMatrix();
                var tempMatrix3 = new TransformMatrix();
                var tempMatrix4 = new TransformMatrix();
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Particles.Emitter#renderCanvas
 * @since 3.60.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ParticleEmitterCanvasRenderer = function(renderer, emitter, camera, parentMatrix) {
                    var camMatrix = tempMatrix1;
                    var calcMatrix = tempMatrix2;
                    var particleMatrix = tempMatrix3;
                    var managerMatrix = tempMatrix4;
                    if (parentMatrix) {
                        managerMatrix.loadIdentity();
                        managerMatrix.multiply(parentMatrix);
                        managerMatrix.translate(emitter.x, emitter.y);
                        managerMatrix.rotate(emitter.rotation);
                        managerMatrix.scale(emitter.scaleX, emitter.scaleY);
                    } else managerMatrix.applyITRS(emitter.x, emitter.y, emitter.rotation, emitter.scaleX, emitter.scaleY);
                    var ctx = renderer.currentContext;
                    var roundPixels = camera.roundPixels;
                    var camerAlpha = camera.alpha;
                    var emitterAlpha = emitter.alpha;
                    var particles = emitter.alive;
                    var particleCount = particles.length;
                    var viewBounds = emitter.viewBounds;
                    if (!emitter.visible || particleCount === 0 || viewBounds && !RectangleToRectangle(viewBounds, camera.worldView)) return;
                    if (emitter.sortCallback) emitter.depthSort();
                    camera.addToRenderList(emitter);
                    var scrollFactorX = emitter.scrollFactorX;
                    var scrollFactorY = emitter.scrollFactorY;
                    ctx.save();
                    ctx.globalCompositeOperation = renderer.blendModes[emitter.blendMode];
                    for(var i = 0; i < particleCount; i++){
                        var particle = particles[i];
                        var alpha = particle.alpha * emitterAlpha * camerAlpha;
                        if (alpha <= 0 || particle.scaleX === 0 || particle.scaleY === 0) continue;
                        particleMatrix.applyITRS(particle.x, particle.y, particle.rotation, particle.scaleX, particle.scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        camMatrix.multiplyWithOffset(managerMatrix, -camera.scrollX * scrollFactorX, -camera.scrollY * scrollFactorY);
                        //  Undo the camera scroll
                        particleMatrix.e = particle.x;
                        particleMatrix.f = particle.y;
                        //  Multiply by the particle matrix, store result in calcMatrix
                        camMatrix.multiply(particleMatrix, calcMatrix);
                        var frame = particle.frame;
                        var cd = frame.canvasData;
                        if (cd.width > 0 && cd.height > 0) {
                            var x = -frame.halfWidth;
                            var y = -frame.halfHeight;
                            ctx.globalAlpha = alpha;
                            ctx.save();
                            calcMatrix.setToContext(ctx);
                            if (roundPixels) {
                                x = Math.round(x);
                                y = Math.round(y);
                            }
                            ctx.imageSmoothingEnabled = !frame.source.scaleMode;
                            ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, x, y, cd.width, cd.height);
                            ctx.restore();
                        }
                    }
                    ctx.restore();
                };
                module1.exports = ParticleEmitterCanvasRenderer;
            /***/ },
            /***/ 92730: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetFastValue = __webpack_require__(95540);
                var ParticleEmitter = __webpack_require__(31600);
                /**
 * Creates a new Particle Emitter Game Object and returns it.
 *
 * Prior to Phaser v3.60 this function would create a `ParticleEmitterManager`. These were removed
 * in v3.60 and replaced with creating a `ParticleEmitter` instance directly. Please see the
 * updated function parameters and class documentation for more details.
 *
 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#particles
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCreatorConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Game Object that was created.
 */ GameObjectCreator.register('particles', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var emitterConfig = GetFastValue(config, 'config', null);
                    var emitter = new ParticleEmitter(this.scene, 0, 0, key);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, emitter, config);
                    if (emitterConfig) emitter.setConfig(emitterConfig);
                    return emitter;
                });
            /***/ },
            /***/ 676: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var ParticleEmitter = __webpack_require__(31600);
                /**
 * Creates a new Particle Emitter Game Object and adds it to the Scene.
 *
 * If you wish to configure the Emitter after creating it, use the `ParticleEmitter.setConfig` method.
 *
 * Prior to Phaser v3.60 this function would create a `ParticleEmitterManager`. These were removed
 * in v3.60 and replaced with creating a `ParticleEmitter` instance directly. Please see the
 * updated function parameters and class documentation for more details.
 *
 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#particles
 * @since 3.60.0
 *
 * @param {number} [x] - The horizontal position of this Game Object in the world.
 * @param {number} [y] - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} [texture] - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} [config] - Configuration settings for the Particle Emitter.
 *
 * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Game Object that was created.
 */ GameObjectFactory.register('particles', function(x, y, texture, config) {
                    if (x !== undefined && typeof x === 'string') console.warn('ParticleEmitterManager was removed in Phaser 3.60. See documentation for details');
                    return this.displayList.add(new ParticleEmitter(this.scene, x, y, texture, config));
                });
            /***/ },
            /***/ 90668: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(21188);
                renderCanvas = __webpack_require__(9871);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 21188: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RectangleToRectangle = __webpack_require__(59996);
                var TransformMatrix = __webpack_require__(61340);
                var Utils = __webpack_require__(70554);
                var tempMatrix1 = new TransformMatrix();
                var tempMatrix2 = new TransformMatrix();
                var tempMatrix3 = new TransformMatrix();
                var tempMatrix4 = new TransformMatrix();
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Particles.Emitter#renderWebGL
 * @since 3.60.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ParticleEmitterWebGLRenderer = function(renderer, emitter, camera, parentMatrix) {
                    var pipeline = renderer.pipelines.set(emitter.pipeline);
                    var camMatrix = tempMatrix1;
                    var calcMatrix = tempMatrix2;
                    var particleMatrix = tempMatrix3;
                    var managerMatrix = tempMatrix4;
                    if (parentMatrix) {
                        managerMatrix.loadIdentity();
                        managerMatrix.multiply(parentMatrix);
                        managerMatrix.translate(emitter.x, emitter.y);
                        managerMatrix.rotate(emitter.rotation);
                        managerMatrix.scale(emitter.scaleX, emitter.scaleY);
                    } else managerMatrix.applyITRS(emitter.x, emitter.y, emitter.rotation, emitter.scaleX, emitter.scaleY);
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var camerAlpha = camera.alpha;
                    var emitterAlpha = emitter.alpha;
                    renderer.pipelines.preBatch(emitter);
                    var particles = emitter.alive;
                    var particleCount = particles.length;
                    var viewBounds = emitter.viewBounds;
                    if (particleCount === 0 || viewBounds && !RectangleToRectangle(viewBounds, camera.worldView)) return;
                    if (emitter.sortCallback) emitter.depthSort();
                    camera.addToRenderList(emitter);
                    camMatrix.copyFrom(camera.matrix);
                    camMatrix.multiplyWithOffset(managerMatrix, -camera.scrollX * emitter.scrollFactorX, -camera.scrollY * emitter.scrollFactorY);
                    renderer.setBlendMode(emitter.blendMode);
                    if (emitter.mask) {
                        emitter.mask.preRenderWebGL(renderer, emitter, camera);
                        renderer.pipelines.set(emitter.pipeline);
                    }
                    var tintEffect = emitter.tintFill;
                    var textureUnit;
                    var glTexture;
                    for(var i = 0; i < particleCount; i++){
                        var particle = particles[i];
                        var alpha = particle.alpha * emitterAlpha * camerAlpha;
                        if (alpha <= 0 || particle.scaleX === 0 || particle.scaleY === 0) continue;
                        particleMatrix.applyITRS(particle.x, particle.y, particle.rotation, particle.scaleX, particle.scaleY);
                        //  Undo the camera scroll
                        particleMatrix.e = particle.x;
                        particleMatrix.f = particle.y;
                        //  Multiply by the particle matrix, store result in calcMatrix
                        camMatrix.multiply(particleMatrix, calcMatrix);
                        var frame = particle.frame;
                        if (frame.glTexture !== glTexture) {
                            glTexture = frame.glTexture;
                            textureUnit = pipeline.setGameObject(emitter, frame);
                        }
                        var x = -frame.halfWidth;
                        var y = -frame.halfHeight;
                        var quad = calcMatrix.setQuad(x, y, x + frame.width, y + frame.height);
                        var tint = getTint(particle.tint, alpha);
                        if (pipeline.shouldFlush(6)) {
                            pipeline.flush();
                            textureUnit = pipeline.setGameObject(emitter, frame);
                        }
                        pipeline.batchQuad(emitter, quad[0], quad[1], quad[2], quad[3], quad[4], quad[5], quad[6], quad[7], frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, tintEffect, glTexture, textureUnit);
                    }
                    if (emitter.mask) emitter.mask.postRenderWebGL(renderer, camera);
                    renderer.pipelines.postBatch(emitter);
                };
                module1.exports = ParticleEmitterWebGLRenderer;
            /***/ },
            /***/ 20286: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * This class provides the structured required for all Particle Processors.
 *
 * You should extend it and add the functionality required for your processor,
 * including tidying up any resources this may create in the `destroy` method.
 *
 * See the GravityWell for an example of a processor.
 *
 * @class ParticleProcessor
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.60.0
 *
 * @param {number} [x=0] - The x coordinate of the Particle Processor, in world space.
 * @param {number} [y=0] - The y coordinate of the Particle Processor, in world space.
 * @param {boolean} [active=true] - The active state of this Particle Processor.
 */ var ParticleProcessor = new Class({
                    initialize: function ParticleProcessor(x, y, active) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (active === undefined) active = true;
                        /**
         * A reference to the Particle Emitter that owns this Processor.
         * This is set automatically when the Processor is added to an Emitter
         * and nulled when removed or destroyed.
         *
         * @name Phaser.GameObjects.Particles.ParticleProcessor#manager
         * @type {Phaser.GameObjects.Particles.ParticleEmitter}
         * @since 3.60.0
         */ this.emitter;
                        /**
         * The x coordinate of the Particle Processor, in world space.
         *
         * @name Phaser.GameObjects.Particles.ParticleProcessor#x
         * @type {number}
         * @since 3.60.0
         */ this.x = x;
                        /**
         * The y coordinate of the Particle Processor, in world space.
         *
         * @name Phaser.GameObjects.Particles.ParticleProcessor#y
         * @type {number}
         * @since 3.60.0
         */ this.y = y;
                        /**
         * The active state of the Particle Processor.
         *
         * An inactive Particle Processor will be skipped for processing by
         * its parent Emitter.
         *
         * @name Phaser.GameObjects.Particles.ParticleProcessor#active
         * @type {boolean}
         * @since 3.60.0
         */ this.active = active;
                    },
                    /**
     * The Particle Processor update method should be overriden by your own
     * method and handle the processing of the particles, typically modifying
     * their velocityX/Y values based on the criteria of this processor.
     *
     * @method Phaser.GameObjects.Particles.ParticleProcessor#update
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to update.
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     * @param {number} t - The current normalized lifetime of the particle, between 0 (birth) and 1 (death).
     */ update: function() {},
                    /**
     * Destroys this Particle Processor by removing all external references.
     *
     * This is called automatically when the owning Particle Emitter is destroyed.
     *
     * @method Phaser.GameObjects.Particles.ParticleProcessor#destroy
     * @since 3.60.0
     */ destroy: function() {
                        this.emitter = null;
                    }
                });
                module1.exports = ParticleProcessor;
            /***/ },
            /***/ 9774: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Particle Emitter Complete Event.
 *
 * This event is dispatched when the final particle, emitted from a Particle Emitter that
 * has been stopped, dies. Upon receipt of this event you know that no particles are
 * still rendering at this point in time.
 *
 * Listen for it on a Particle Emitter instance using `ParticleEmitter.on('complete', listener)`.
 *
 * @event Phaser.GameObjects.Particles.Events#COMPLETE
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - A reference to the Particle Emitter that just completed.
 */ module1.exports = 'complete';
            /***/ },
            /***/ 812: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Particle Emitter Death Zone Event.
 *
 * This event is dispatched when a Death Zone kills a Particle instance.
 *
 * Listen for it on a Particle Emitter instance using `ParticleEmitter.on('deathzone', listener)`.
 *
 * If you wish to know when the final particle is killed, see the `COMPLETE` event.
 *
 * @event Phaser.GameObjects.Particles.Events#DEATH_ZONE
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - A reference to the Particle Emitter that owns the Particle and Death Zone.
 * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle that has been killed.
 * @param {Phaser.GameObjects.Particles.Zones.DeathZone} zone - The Death Zone that killed the particle.
 */ module1.exports = 'deathzone';
            /***/ },
            /***/ 30522: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Particle Emitter Explode Event.
 *
 * This event is dispatched when a Particle Emitter explodes a set of particles.
 *
 * Listen for it on a Particle Emitter instance using `ParticleEmitter.on('explode', listener)`.
 *
 * @event Phaser.GameObjects.Particles.Events#EXPLODE
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - A reference to the Particle Emitter that just completed.
 * @param {Phaser.GameObjects.Particles.Particle} particle - The most recently emitted Particle.
 */ module1.exports = 'explode';
            /***/ },
            /***/ 96695: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Particle Emitter Start Event.
 *
 * This event is dispatched when a Particle Emitter starts emission of particles.
 *
 * Listen for it on a Particle Emitter instance using `ParticleEmitter.on('start', listener)`.
 *
 * @event Phaser.GameObjects.Particles.Events#START
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - A reference to the Particle Emitter that just completed.
 */ module1.exports = 'start';
            /***/ },
            /***/ 18677: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Particle Emitter Stop Event.
 *
 * This event is dispatched when a Particle Emitter is stopped. This can happen either
 * when you directly call the `ParticleEmitter.stop` method, or if the emitter has
 * been configured to stop after a set time via the `duration` property, or after a
 * set number of particles via the `stopAfter` property.
 *
 * Listen for it on a Particle Emitter instance using `ParticleEmitter.on('stop', listener)`.
 *
 * Note that just because the emitter has stopped, that doesn't mean there aren't still
 * particles alive and rendering. It just means the emitter has stopped emitting particles.
 *
 * If you wish to know when the final particle is killed, see the `COMPLETE` event.
 *
 * @event Phaser.GameObjects.Particles.Events#STOP
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - A reference to the Particle Emitter that just completed.
 */ module1.exports = 'stop';
            /***/ },
            /***/ 20696: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Particles.Events
 */ module1.exports = {
                    COMPLETE: __webpack_require__(9774),
                    DEATH_ZONE: __webpack_require__(812),
                    EXPLODE: __webpack_require__(30522),
                    START: __webpack_require__(96695),
                    STOP: __webpack_require__(18677)
                };
            /***/ },
            /***/ 18404: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Particles
 */ module1.exports = {
                    EmitterColorOp: __webpack_require__(76472),
                    EmitterOp: __webpack_require__(44777),
                    Events: __webpack_require__(20696),
                    GravityWell: __webpack_require__(24502),
                    Particle: __webpack_require__(56480),
                    ParticleBounds: __webpack_require__(69601),
                    ParticleEmitter: __webpack_require__(31600),
                    ParticleProcessor: __webpack_require__(20286),
                    Zones: __webpack_require__(21024)
                };
            /***/ },
            /***/ 26388: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A Death Zone.
 *
 * A Death Zone is a special type of zone that will kill a Particle as soon as it either enters, or leaves, the zone.
 *
 * The zone consists of a `source` which could be a Geometric shape, such as a Rectangle or Ellipse, or your own
 * object as long as it includes a `contains` method for which the Particles can be tested against.
 *
 * @class DeathZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.DeathZoneSource} source - An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
 * @param {boolean} killOnEnter - Should the Particle be killed when it enters the zone? `true` or leaves it? `false`
 */ var DeathZone = new Class({
                    initialize: function DeathZone(source, killOnEnter) {
                        /**
         * An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
         * This could be a Geometry shape, such as `Phaser.Geom.Circle`, or your own custom object.
         *
         * @name Phaser.GameObjects.Particles.Zones.DeathZone#source
         * @type {Phaser.Types.GameObjects.Particles.DeathZoneSource}
         * @since 3.0.0
         */ this.source = source;
                        /**
         * Set to `true` if the Particle should be killed if it enters this zone.
         * Set to `false` to kill the Particle if it leaves this zone.
         *
         * @name Phaser.GameObjects.Particles.Zones.DeathZone#killOnEnter
         * @type {boolean}
         * @since 3.0.0
         */ this.killOnEnter = killOnEnter;
                    },
                    /**
     * Checks if the given Particle will be killed or not by this zone.
     *
     * @method Phaser.GameObjects.Particles.Zones.DeathZone#willKill
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle to test against this Death Zones.
     *
     * @return {boolean} Return `true` if the Particle is to be killed, otherwise return `false`.
     */ willKill: function(particle) {
                        var pos = particle.worldPosition;
                        var withinZone = this.source.contains(pos.x, pos.y);
                        return withinZone && this.killOnEnter || !withinZone && !this.killOnEnter;
                    }
                });
                module1.exports = DeathZone;
            /***/ },
            /***/ 19909: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A zone that places particles on a shape's edges.
 *
 * @class EdgeZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.EdgeZoneSource} source - An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
 * @param {number} quantity - The number of particles to place on the source edge. Set to 0 to use `stepRate` instead.
 * @param {number} [stepRate] - The distance between each particle. When set, `quantity` is implied and should be set to 0.
 * @param {boolean} [yoyo=false] - Whether particles are placed from start to end and then end to start.
 * @param {boolean} [seamless=true] - Whether one endpoint will be removed if it's identical to the other.
 * @param {number} [total=-1] - The total number of particles this zone will emit before passing over to the next emission zone in the Emitter. -1 means it will never pass over and you must use `setEmitZone` to change it.
 */ var EdgeZone = new Class({
                    initialize: function EdgeZone(source, quantity, stepRate, yoyo, seamless, total) {
                        if (yoyo === undefined) yoyo = false;
                        if (seamless === undefined) seamless = true;
                        if (total === undefined) total = -1;
                        /**
         * An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#source
         * @type {Phaser.Types.GameObjects.Particles.EdgeZoneSource|Phaser.Types.GameObjects.Particles.RandomZoneSource}
         * @since 3.0.0
         */ this.source = source;
                        /**
         * The points placed on the source edge.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#points
         * @type {Phaser.Geom.Point[]}
         * @default []
         * @since 3.0.0
         */ this.points = [];
                        /**
         * The number of particles to place on the source edge. Set to 0 to use `stepRate` instead.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#quantity
         * @type {number}
         * @since 3.0.0
         */ this.quantity = quantity;
                        /**
         * The distance between each particle. When set, `quantity` is implied and should be set to 0.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#stepRate
         * @type {number}
         * @since 3.0.0
         */ this.stepRate = stepRate;
                        /**
         * Whether particles are placed from start to end and then end to start.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#yoyo
         * @type {boolean}
         * @since 3.0.0
         */ this.yoyo = yoyo;
                        /**
         * The counter used for iterating the EdgeZone's points.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#counter
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.counter = -1;
                        /**
         * Whether one endpoint will be removed if it's identical to the other.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#seamless
         * @type {boolean}
         * @since 3.0.0
         */ this.seamless = seamless;
                        /**
         * An internal count of the points belonging to this EdgeZone.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_length
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._length = 0;
                        /**
         * An internal value used to keep track of the current iteration direction for the EdgeZone's points.
         *
         * 0 = forwards, 1 = backwards
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_direction
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._direction = 0;
                        /**
         * The total number of particles this zone will emit before the Emitter
         * transfers control over to the next zone in its emission zone list.
         *
         * By default this is -1, meaning it will never pass over from this
         * zone to another one. You can call the `ParticleEmitter.setEmitZone`
         * method to change it, or set this value to something else via the
         * config, or directly at runtime.
         *
         * A value of 1 would mean the zones rotate in order, but it can
         * be set to any integer value.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#total
         * @type {number}
         * @since 3.60.0
         */ this.total = total;
                        this.updateSource();
                    },
                    /**
     * Update the {@link Phaser.GameObjects.Particles.Zones.EdgeZone#points} from the EdgeZone's
     * {@link Phaser.GameObjects.Particles.Zones.EdgeZone#source}.
     *
     * Also updates internal properties.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#updateSource
     * @since 3.0.0
     *
     * @return {this} This Edge Zone.
     */ updateSource: function() {
                        this.points = this.source.getPoints(this.quantity, this.stepRate);
                        //  Remove ends?
                        if (this.seamless) {
                            var a = this.points[0];
                            var b = this.points[this.points.length - 1];
                            if (a.x === b.x && a.y === b.y) this.points.pop();
                        }
                        var oldLength = this._length;
                        this._length = this.points.length;
                        //  Adjust counter if we now have less points than before
                        if (this._length < oldLength && this.counter > this._length) this.counter = this._length - 1;
                        return this;
                    },
                    /**
     * Change the source of the EdgeZone.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#changeSource
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EdgeZoneSource} source - An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
     *
     * @return {this} This Edge Zone.
     */ changeSource: function(source) {
                        this.source = source;
                        return this.updateSource();
                    },
                    /**
     * Get the next point in the Zone and set its coordinates on the given Particle.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#getPoint
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle.
     */ getPoint: function(particle) {
                        if (this._direction === 0) {
                            this.counter++;
                            if (this.counter >= this._length) {
                                if (this.yoyo) {
                                    this._direction = 1;
                                    this.counter = this._length - 1;
                                } else this.counter = 0;
                            }
                        } else {
                            this.counter--;
                            if (this.counter === -1) {
                                if (this.yoyo) {
                                    this._direction = 0;
                                    this.counter = 0;
                                } else this.counter = this._length - 1;
                            }
                        }
                        var point = this.points[this.counter];
                        if (point) {
                            particle.x = point.x;
                            particle.y = point.y;
                        }
                    }
                });
                module1.exports = EdgeZone;
            /***/ },
            /***/ 68875: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A zone that places particles randomly within a shapes area.
 *
 * @class RandomZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.RandomZoneSource} source - An object instance with a `getRandomPoint(point)` method.
 */ var RandomZone = new Class({
                    initialize: function RandomZone(source) {
                        /**
         * An object instance with a `getRandomPoint(point)` method.
         *
         * @name Phaser.GameObjects.Particles.Zones.RandomZone#source
         * @type {Phaser.Types.GameObjects.Particles.RandomZoneSource}
         * @since 3.0.0
         */ this.source = source;
                        /**
         * Internal calculation vector.
         *
         * @name Phaser.GameObjects.Particles.Zones.RandomZone#_tempVec
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec = new Vector2();
                        /**
         * The total number of particles this zone will emit before the Emitter
         * transfers control over to the next zone in its emission zone list.
         *
         * By default this is -1, meaning it will never pass over from this
         * zone to another one. You can call the `ParticleEmitter.setEmitZone`
         * method to change it, or set this value to something else via the
         * config, or directly at runtime.
         *
         * A value of 1 would mean the zones rotate in order, but it can
         * be set to any integer value.
         *
         * @name Phaser.GameObjects.Particles.Zones.RandomZone#total
         * @type {number}
         * @since 3.60.0
         */ this.total = -1;
                    },
                    /**
     * Get the next point in the Zone and set its coordinates on the given Particle.
     *
     * @method Phaser.GameObjects.Particles.Zones.RandomZone#getPoint
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle.
     */ getPoint: function(particle) {
                        var vec = this._tempVec;
                        this.source.getRandomPoint(vec);
                        particle.x = vec.x;
                        particle.y = vec.y;
                    }
                });
                module1.exports = RandomZone;
            /***/ },
            /***/ 21024: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Particles.Zones
 */ module1.exports = {
                    DeathZone: __webpack_require__(26388),
                    EdgeZone: __webpack_require__(19909),
                    RandomZone: __webpack_require__(68875)
                };
            /***/ },
            /***/ 1159: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var Sprite = __webpack_require__(68287);
                /**
 * @classdesc
 * A PathFollower Game Object.
 *
 * A PathFollower is a Sprite Game Object with some extra helpers to allow it to follow a Path automatically.
 *
 * Anything you can do with a standard Sprite can be done with this PathFollower, such as animate it, tint it,
 * scale it and so on.
 *
 * PathFollowers are bound to a single Path at any one time and can traverse the length of the Path, from start
 * to finish, forwards or backwards, or from any given point on the Path to its end. They can optionally rotate
 * to face the direction of the path, be offset from the path coordinates or rotate independently of the Path.
 *
 * @class PathFollower
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.PathFollower
 *
 * @param {Phaser.Scene} scene - The Scene to which this PathFollower belongs.
 * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var PathFollower = new Class({
                    Extends: Sprite,
                    Mixins: [
                        Components.PathFollower
                    ],
                    initialize: function PathFollower(scene, path, x, y, texture, frame) {
                        Sprite.call(this, scene, x, y, texture, frame);
                        this.path = path;
                    },
                    /**
     * Internal update handler that advances this PathFollower along the path.
     *
     * Called automatically by the Scene step, should not typically be called directly.
     *
     * @method Phaser.GameObjects.PathFollower#preUpdate
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                        this.anims.update(time, delta);
                        this.pathUpdate(time);
                    }
                });
                module1.exports = PathFollower;
            /***/ },
            /***/ 90145: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var PathFollower = __webpack_require__(1159);
                /**
 * Creates a new PathFollower Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the PathFollower Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#follower
 * @since 3.0.0
 *
 * @param {Phaser.Curves.Path} path - The Path this PathFollower is connected to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.PathFollower} The Game Object that was created.
 */ GameObjectFactory.register('follower', function(path, x, y, key, frame) {
                    var sprite = new PathFollower(this.scene, path, x, y, key, frame);
                    this.displayList.add(sprite);
                    this.updateList.add(sprite);
                    return sprite;
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 33663: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(9674);
                var Class = __webpack_require__(83419);
                var GenerateGridVerts = __webpack_require__(48803);
                var IntegerToRGB = __webpack_require__(90664);
                var Mesh = __webpack_require__(4703);
                var UUID = __webpack_require__(45650);
                /**
 * @classdesc
 * A Plane Game Object.
 *
 * The Plane Game Object is a helper class that takes the Mesh Game Object and extends it,
 * allowing for fast and easy creation of Planes. A Plane is a one-sided grid of cells,
 * where you specify the number of cells in each dimension. The Plane can have a texture
 * that is either repeated (tiled) across each cell, or applied to the full Plane.
 *
 * The Plane can then be manipulated in 3D space, with rotation across all 3 axis.
 *
 * This allows you to create effects not possible with regular Sprites, such as perspective
 * distortion. You can also adjust the vertices on a per-vertex basis. Plane data becomes
 * part of the WebGL batch, just like standard Sprites, so doesn't introduce any additional
 * shader overhead. Because the Plane just generates vertices into the WebGL batch, like any
 * other Sprite, you can use all of the common Game Object components on a Plane too,
 * such as a custom pipeline, mask, blend mode or texture.
 *
 * You can use the `uvScroll` and `uvScale` methods to adjust the placement and scaling
 * of the texture if this Plane is using a single texture, and not a frame from a texture
 * atlas or sprite sheet.
 *
 * The Plane Game Object also has the Animation component, allowing you to play animations
 * across the Plane just as you would with a Sprite. The animation frame size must be fixed
 * as the first frame will be the size of the entire animation, for example use a `SpriteSheet`.
 *
 * Note that the Plane object is WebGL only and does not have a Canvas counterpart.
 *
 * The Plane origin is always 0.5 x 0.5 and cannot be changed.
 *
 * @class Plane
 * @extends Phaser.GameObjects.Mesh
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Plane belongs. A Plane can only belong to one Scene at a time.
 * @param {number} [x] - The horizontal position of this Plane in the world.
 * @param {number} [y] - The vertical position of this Plane in the world.
 * @param {string|Phaser.Textures.Texture} [texture] - The key, or instance of the Texture this Plane will use to render with, as stored in the Texture Manager.
 * @param {string|number} [frame] - An optional frame from the Texture this Plane is rendering with.
 * @param {number} [width=8] - The width of this Plane, in cells, not pixels.
 * @param {number} [height=8] - The height of this Plane, in cells, not pixels.
 * @param {boolean} [tile=false] - Is the texture tiled? I.e. repeated across each cell.
 */ var Plane = new Class({
                    Extends: Mesh,
                    initialize: function Plane(scene, x, y, texture, frame, width, height, tile) {
                        if (!texture) texture = '__DEFAULT';
                        Mesh.call(this, scene, x, y, texture, frame);
                        this.type = 'Plane';
                        /**
         * The Animation State component of this Sprite.
         *
         * This component provides features to apply animations to this Sprite.
         * It is responsible for playing, loading, queuing animations for later playback,
         * mixing between animations and setting the current animation frame to this Sprite.
         *
         * @name Phaser.GameObjects.Plane#anims
         * @type {Phaser.Animations.AnimationState}
         * @since 3.60.0
         */ this.anims = new AnimationState(this);
                        /**
         * The width of this Plane in cells, not pixels.
         *
         * This value is read-only. To adjust it, see the `setGridSize` method.
         *
         * @name Phaser.GameObjects.Plane#gridWidth
         * @type {number}
         * @readonly
         * @since 3.60.0
         */ this.gridWidth;
                        /**
         * The height of this Plane in cells, not pixels.
         *
         * This value is read-only. To adjust it, see the `setGridSize` method.
         *
         * @name Phaser.GameObjects.Plane#gridHeight
         * @type {number}
         * @readonly
         * @since 3.60.0
         */ this.gridHeight;
                        /**
         * Is the texture of this Plane tiled across all cells, or not?
         *
         * This value is read-only. To adjust it, see the `setGridSize` method.
         *
         * @name Phaser.GameObjects.Plane#isTiled
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isTiled;
                        /**
         * If this Plane has a checkboard texture, this is a reference to
         * the WebGLTexture being used. Otherwise, it's null.
         *
         * @name Phaser.GameObjects.Plane#_checkerboard
         * @type {?WebGLTexture}
         * @private
         * @since 3.60.0
         */ this._checkerboard = null;
                        this.hideCCW = false;
                        this.setGridSize(width, height, tile);
                        this.setSizeToFrame(false);
                        this.setViewHeight();
                    },
                    /**
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Plane#originX
     * @type {number}
     * @readonly
     * @override
     * @since 3.70.0
     */ originX: {
                        get: function() {
                            return 0.5;
                        }
                    },
                    /**
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Plane#originY
     * @type {number}
     * @readonly
     * @override
     * @since 3.70.0
     */ originY: {
                        get: function() {
                            return 0.5;
                        }
                    },
                    /**
     * Modifies the layout of this Plane by adjusting the grid dimensions to the
     * given width and height. The values are given in cells, not pixels.
     *
     * The `tile` parameter allows you to control if the texture is tiled, or
     * applied across the entire Plane? A tiled texture will repeat with one
     * iteration per cell. A non-tiled texture will be applied across the whole
     * Plane.
     *
     * Note that if this Plane is using a single texture, not from a texture atlas
     * or sprite sheet, then you can use the `Plane.uvScale` method to have much
     * more fine-grained control over the texture tiling.
     *
     * @method Phaser.GameObjects.Plane#preDestroy
     * @since 3.60.0
     *
     * @param {number} [width=8] - The width of this Plane, in cells, not pixels.
     * @param {number} [height=8] - The height of this Plane, in cells, not pixels.
     * @param {boolean} [tile=false] - Is the texture tiled? I.e. repeated across each cell.
     */ setGridSize: function(width, height, tile) {
                        if (width === undefined) width = 8;
                        if (height === undefined) height = 8;
                        if (tile === undefined) tile = false;
                        var flipY = false;
                        if (tile) flipY = true;
                        this.gridWidth = width;
                        this.gridHeight = height;
                        this.isTiled = tile;
                        this.clear();
                        GenerateGridVerts({
                            mesh: this,
                            widthSegments: width,
                            heightSegments: height,
                            isOrtho: false,
                            tile: tile,
                            flipY: flipY
                        });
                        return this;
                    },
                    /**
     * An internal method that resets the perspective projection for this Plane
     * when it changes texture or frame, and also resets the cell UV coordinates,
     * if required.
     *
     * @method Phaser.GameObjects.Plane#setSizeToFrame
     * @since 3.60.0
     * @override
     *
     * @param {boolean} [resetUV=true] - Reset all of the cell UV coordinates?
     *
     * @return {this} This Game Object instance.
     */ setSizeToFrame: function(resetUV) {
                        if (resetUV === undefined) resetUV = true;
                        var frame = this.frame;
                        this.setPerspective(this.width / frame.width, this.height / frame.height);
                        if (this._checkerboard && this._checkerboard !== this.texture) this.removeCheckerboard();
                        if (!resetUV) return this;
                        //  Reset UV coordinates if frame has changed
                        var gridX = this.gridWidth;
                        var gridY = this.gridHeight;
                        var verts = this.vertices;
                        var frameU0 = frame.u0;
                        var frameU1 = frame.u1;
                        var frameV0 = frame.v0;
                        var frameV1 = frame.v1;
                        var x;
                        var y;
                        var i = 0;
                        if (this.isTiled) {
                            //  flipY
                            frameV0 = frame.v1;
                            frameV1 = frame.v0;
                            for(y = 0; y < gridY; y++)for(x = 0; x < gridX; x++){
                                verts[i++].setUVs(frameU0, frameV1);
                                verts[i++].setUVs(frameU0, frameV0);
                                verts[i++].setUVs(frameU1, frameV1);
                                verts[i++].setUVs(frameU0, frameV0);
                                verts[i++].setUVs(frameU1, frameV0);
                                verts[i++].setUVs(frameU1, frameV1);
                            }
                        } else {
                            var gridX1 = gridX + 1;
                            var gridY1 = gridY + 1;
                            var frameU = frameU1 - frameU0;
                            var frameV = frameV1 - frameV0;
                            var uvs = [];
                            for(y = 0; y < gridY1; y++)for(x = 0; x < gridX1; x++){
                                var tu = frameU0 + frameU * (x / gridX);
                                var tv = frameV0 + frameV * (y / gridY);
                                uvs.push(tu, tv);
                            }
                            for(y = 0; y < gridY; y++)for(x = 0; x < gridX; x++){
                                var a = (x + gridX1 * y) * 2;
                                var b = (x + gridX1 * (y + 1)) * 2;
                                var c = (x + 1 + gridX1 * (y + 1)) * 2;
                                var d = (x + 1 + gridX1 * y) * 2;
                                verts[i++].setUVs(uvs[a], uvs[a + 1]);
                                verts[i++].setUVs(uvs[b], uvs[b + 1]);
                                verts[i++].setUVs(uvs[d], uvs[d + 1]);
                                verts[i++].setUVs(uvs[b], uvs[b + 1]);
                                verts[i++].setUVs(uvs[c], uvs[c + 1]);
                                verts[i++].setUVs(uvs[d], uvs[d + 1]);
                            }
                        }
                        return this;
                    },
                    /**
     * Sets the height of this Plane to match the given value, in pixels.
     *
     * This adjusts the `Plane.viewPosition.z` value to achieve this.
     *
     * If no `value` parameter is given, it will set the view height to match
     * that of the current texture frame the Plane is using.
     *
     * @method Phaser.GameObjects.Plane#setViewHeight
     * @since 3.60.0
     *
     * @param {number} [value] - The height, in pixels, to set this Plane view height to.
     */ setViewHeight: function(value) {
                        if (value === undefined) value = this.frame.height;
                        var vFOV = this.fov * (Math.PI / 180);
                        this.viewPosition.z = this.height / value / Math.tan(vFOV / 2);
                        this.dirtyCache[10] = 1;
                    },
                    /**
     * Creates a checkerboard style texture, based on the given colors and alpha
     * values and applies it to this Plane, replacing any current texture it may
     * have.
     *
     * The colors are used in an alternating pattern, like a chess board.
     *
     * Calling this method generates a brand new 16x16 pixel WebGLTexture internally
     * and applies it to this Plane. While quite fast to do, you should still be
     * mindful of calling this method either extensively, or in tight parts of
     * your game.
     *
     * @method Phaser.GameObjects.Plane#createCheckerboard
     * @since 3.60.0
     *
     * @param {number} [color1=0xffffff] - The odd cell color, specified as a hex value.
     * @param {number} [color2=0x0000ff] - The even cell color, specified as a hex value.
     * @param {number} [alpha1=255] - The odd cell alpha value, specified as a number between 0 and 255.
     * @param {number} [alpha2=255] - The even cell alpha value, specified as a number between 0 and 255.
     * @param {number} [height=128] - The view height of the Plane after creation, in pixels.
     */ createCheckerboard: function(color1, color2, alpha1, alpha2, height) {
                        if (color1 === undefined) color1 = 0xffffff;
                        if (color2 === undefined) color2 = 0x0000ff;
                        if (alpha1 === undefined) alpha1 = 255;
                        if (alpha2 === undefined) alpha2 = 255;
                        if (height === undefined) height = 128;
                        //  Let's assume 16x16 for our texture size and 8x8 cell size
                        var c1 = IntegerToRGB(color1);
                        var c2 = IntegerToRGB(color2);
                        var colors = [];
                        for(var h = 0; h < 16; h++){
                            for(var w = 0; w < 16; w++)if (h < 8 && w < 8 || h > 7 && w > 7) colors.push(c1.r, c1.g, c1.b, alpha1);
                            else colors.push(c2.r, c2.g, c2.b, alpha2);
                        }
                        var texture = this.scene.sys.textures.addUint8Array(UUID(), new Uint8Array(colors), 16, 16);
                        this.removeCheckerboard();
                        this.setTexture(texture);
                        this.setSizeToFrame();
                        this.setViewHeight(height);
                        return this;
                    },
                    /**
     * If this Plane has a Checkerboard Texture, this method will destroy it
     * and reset the internal flag for it.
     *
     * @method Phaser.GameObjects.Plane#removeCheckerboard
     * @since 3.60.0
     */ removeCheckerboard: function() {
                        if (this._checkerboard) {
                            this._checkerboard.destroy();
                            this._checkerboard = null;
                        }
                    },
                    /**
     * Start playing the given animation on this Plane.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Plane.
     *
     * The benefit of a global animation is that multiple Game Objects can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any animating Game Object.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Plane, and this Plane alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Plane.
     *
     * With the animation created, either globally or locally, you can now play it on this Plane:
     *
     * ```javascript
     * const plane = this.add.plane(...);
     * plane.play('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * const plane = this.add.plane(...);
     * plane.play({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Plane it will first check to see if it can find a matching key
     * locally within the Plane. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Plane to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Plane#play
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.60.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ play: function(key, ignoreIfPlaying) {
                        return this.anims.play(key, ignoreIfPlaying);
                    },
                    /**
     * Start playing the given animation on this Plane, in reverse.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to a Game Object.
     *
     * The benefit of a global animation is that multiple Game Objects can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any animating Game Object.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Game Object, and this Game Object alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Game Object.
     *
     * With the animation created, either globally or locally, you can now play it on this Game Object:
     *
     * ```javascript
     * const plane = this.add.plane(...);
     * plane.playReverse('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * const plane = this.add.plane(...);
     * plane.playReverse({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Game Object it will first check to see if it can find a matching key
     * locally within the Game Object. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Game Object to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Plane#playReverse
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.60.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ playReverse: function(key, ignoreIfPlaying) {
                        return this.anims.playReverse(key, ignoreIfPlaying);
                    },
                    /**
     * Waits for the specified delay, in milliseconds, then starts playback of the given animation.
     *
     * If the animation _also_ has a delay value set in its config, it will be **added** to the delay given here.
     *
     * If an animation is already running and a new animation is given to this method, it will wait for
     * the given delay before starting the new animation.
     *
     * If no animation is currently running, the given one begins after the delay.
     *
     * When playing an animation on a Game Object it will first check to see if it can find a matching key
     * locally within the Game Object. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Plane#playAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.60.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} delay - The delay, in milliseconds, to wait before starting the animation playing.
     *
     * @return {this} This Game Object.
     */ playAfterDelay: function(key, delay) {
                        return this.anims.playAfterDelay(key, delay);
                    },
                    /**
     * Waits for the current animation to complete the `repeatCount` number of repeat cycles, then starts playback
     * of the given animation.
     *
     * You can use this to ensure there are no harsh jumps between two sets of animations, i.e. going from an
     * idle animation to a walking animation, by making them blend smoothly into each other.
     *
     * If no animation is currently running, the given one will start immediately.
     *
     * When playing an animation on a Game Object it will first check to see if it can find a matching key
     * locally within the Game Object. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Plane#playAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.60.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} [repeatCount=1] - How many times should the animation repeat before the next one starts?
     *
     * @return {this} This Game Object.
     */ playAfterRepeat: function(key, repeatCount) {
                        return this.anims.playAfterRepeat(key, repeatCount);
                    },
                    /**
     * Immediately stops the current animation from playing and dispatches the `ANIMATION_STOP` events.
     *
     * If no animation is playing, no event will be dispatched.
     *
     * If there is another animation queued (via the `chain` method) then it will start playing immediately.
     *
     * @method Phaser.GameObjects.Plane#stop
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.60.0
     *
     * @return {this} This Game Object.
     */ stop: function() {
                        return this.anims.stop();
                    },
                    /**
     * Stops the current animation from playing after the specified time delay, given in milliseconds.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Plane#stopAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.60.0
     *
     * @param {number} delay - The number of milliseconds to wait before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopAfterDelay: function(delay) {
                        return this.anims.stopAfterDelay(delay);
                    },
                    /**
     * Stops the current animation from playing after the given number of repeats.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Plane#stopAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.60.0
     *
     * @param {number} [repeatCount=1] - How many times should the animation repeat before stopping?
     *
     * @return {this} This Game Object.
     */ stopAfterRepeat: function(repeatCount) {
                        return this.anims.stopAfterRepeat(repeatCount);
                    },
                    /**
     * Stops the current animation from playing when it next sets the given frame.
     * If this frame doesn't exist within the animation it will not stop it from playing.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Plane#stopOnFrame
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.60.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The frame to check before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopOnFrame: function(frame) {
                        return this.anims.stopOnFrame(frame);
                    },
                    /**
     * Runs the preUpdate for this Plane, which will check its Animation State,
     * if one is playing, and refresh view / model matrices, if updated.
     *
     * @method Phaser.GameObjects.Plane#preUpdate
     * @protected
     * @since 3.60.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                        Mesh.prototype.preUpdate.call(this, time, delta);
                        this.anims.update(time, delta);
                    },
                    /**
     * Handles the pre-destroy step for the Plane, which removes the vertices and debug callbacks.
     *
     * @method Phaser.GameObjects.Plane#preDestroy
     * @private
     * @since 3.60.0
     */ preDestroy: function() {
                        this.clear();
                        this.removeCheckerboard();
                        this.anims.destroy();
                        this.anims = undefined;
                        this.debugCallback = null;
                        this.debugGraphic = null;
                    }
                });
                module1.exports = Plane;
            /***/ },
            /***/ 56015: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var BuildGameObjectAnimation = __webpack_require__(13059);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetValue = __webpack_require__(35154);
                var Plane = __webpack_require__(33663);
                /**
 * Creates a new Plane Game Object and returns it.
 *
 * Note: This method will only be available if the Plane Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#plane
 * @since 3.60.0
 *
 * @param {Phaser.Types.GameObjects.Plane.PlaneConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Plane} The Game Object that was created.
 */ GameObjectCreator.register('plane', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var frame = GetAdvancedValue(config, 'frame', null);
                    var width = GetValue(config, 'width', 8);
                    var height = GetValue(config, 'height', 8);
                    var tile = GetValue(config, 'tile', false);
                    var plane = new Plane(this.scene, 0, 0, key, frame, width, height, tile);
                    if (addToScene !== undefined) config.add = addToScene;
                    var checkerboard = GetValue(config, 'checkerboard', null);
                    if (checkerboard) {
                        var color1 = GetValue(checkerboard, 'color1', 0xffffff);
                        var color2 = GetValue(checkerboard, 'color2', 0x0000ff);
                        var alpha1 = GetValue(checkerboard, 'alpha1', 255);
                        var alpha2 = GetValue(checkerboard, 'alpha2', 255);
                        var checkheight = GetValue(checkerboard, 'height', 128);
                        plane.createCheckerboard(color1, color2, alpha1, alpha2, checkheight);
                    }
                    BuildGameObject(this.scene, plane, config);
                    BuildGameObjectAnimation(plane, config);
                    return plane;
                });
            /***/ },
            /***/ 30985: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Plane = __webpack_require__(33663);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Plane Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Plane Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#plane
 * @since 3.60.0
 *
 * @param {number} [x] - The horizontal position of this Plane in the world.
 * @param {number} [y] - The vertical position of this Plane in the world.
 * @param {string|Phaser.Textures.Texture} [texture] - The key, or instance of the Texture this Plane will use to render with, as stored in the Texture Manager.
 * @param {string|number} [frame] - An optional frame from the Texture this Plane is rendering with.
 * @param {number} [width=8] - The width of this Plane, in cells, not pixels.
 * @param {number} [height=8] - The height of this Plane, in cells, not pixels.
 * @param {boolean} [tile=false] - Is the texture tiled? I.e. repeated across each cell.
 *
 * @return {Phaser.GameObjects.Plane} The Plane Game Object that was created.
 */ GameObjectFactory.register('plane', function(x, y, texture, frame, width, height, tile) {
                    return this.displayList.add(new Plane(this.scene, x, y, texture, frame, width, height, tile));
                });
            /***/ },
            /***/ 80321: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var IntegerToColor = __webpack_require__(30100);
                var PIPELINES_CONST = __webpack_require__(36060);
                var Render = __webpack_require__(67277);
                /**
 * @classdesc
 * The Point Light Game Object provides a way to add a point light effect into your game,
 * without the expensive shader processing requirements of the traditional Light Game Object.
 *
 * The difference is that the Point Light renders using a custom shader, designed to give the
 * impression of a point light source, of variable radius, intensity and color, in your game.
 * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
 * normal maps for calcuations. This makes them extremely fast to render compared to Lights
 * and perfect for special effects, such as flickering torches or muzzle flashes.
 *
 * For maximum performance you should batch Point Light Game Objects together. This means
 * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
 * Game Object and then add just Point Lights to it, so that it can batch together the rendering
 * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
 * your game then it's perfectly safe to mix them into the display list as normal. However, if
 * you're using a large number of them, please consider how they are mixed into the display list.
 *
 * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
 * with the Camera will be skipped in the rendering list. This happens automatically and the
 * culled state is refreshed every frame, for every camera.
 *
 * The origin of a Point Light is always 0.5 and it cannot be changed.
 *
 * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
 *
 * @class PointLight
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Point Light belongs. A Point Light can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Point Light in the world.
 * @param {number} y - The vertical position of this Point Light in the world.
 * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
 * @param {number} [radius=128] - The radius of the Point Light.
 * @param {number} [intensity=1] - The intensity, or color blend, of the Point Light.
 * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
 */ var PointLight = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Mask,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Transform,
                        Components.Visible,
                        Render
                    ],
                    initialize: function PointLight(scene, x, y, color, radius, intensity, attenuation) {
                        if (color === undefined) color = 0xffffff;
                        if (radius === undefined) radius = 128;
                        if (intensity === undefined) intensity = 1;
                        if (attenuation === undefined) attenuation = 0.1;
                        GameObject.call(this, scene, 'PointLight');
                        this.initPipeline(PIPELINES_CONST.POINTLIGHT_PIPELINE);
                        this.initPostPipeline();
                        this.setPosition(x, y);
                        /**
         * The color of this Point Light. This property is an instance of a
         * Color object, so you can use the methods within it, such as `setTo(r, g, b)`
         * to change the color value.
         *
         * @name Phaser.GameObjects.PointLight#color
         * @type {Phaser.Display.Color}
         * @since 3.50.0
         */ this.color = IntegerToColor(color);
                        /**
         * The intensity of the Point Light.
         *
         * The colors of the light are multiplied by this value during rendering.
         *
         * @name Phaser.GameObjects.PointLight#intensity
         * @type {number}
         * @since 3.50.0
         */ this.intensity = intensity;
                        /**
         * The attenuation of the Point Light.
         *
         * This value controls the force with which the light falls-off from the center of the light.
         *
         * Use small float-based values, i.e. 0.1.
         *
         * @name Phaser.GameObjects.PointLight#attenuation
         * @type {number}
         * @since 3.50.0
         */ this.attenuation = attenuation;
                        //  read only:
                        this.width = radius * 2;
                        this.height = radius * 2;
                        this._radius = radius;
                    },
                    /**
     * The radius of the Point Light.
     *
     * @name Phaser.GameObjects.PointLight#radius
     * @type {number}
     * @since 3.50.0
     */ radius: {
                        get: function() {
                            return this._radius;
                        },
                        set: function(value) {
                            this._radius = value;
                            this.width = value * 2;
                            this.height = value * 2;
                        }
                    },
                    originX: {
                        get: function() {
                            return 0.5;
                        }
                    },
                    originY: {
                        get: function() {
                            return 0.5;
                        }
                    },
                    displayOriginX: {
                        get: function() {
                            return this._radius;
                        }
                    },
                    displayOriginY: {
                        get: function() {
                            return this._radius;
                        }
                    }
                });
                module1.exports = PointLight;
            /***/ },
            /***/ 39829: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var PointLight = __webpack_require__(80321);
                /**
 * Creates a new Point Light Game Object and returns it.
 *
 * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#pointlight
 * @since 3.50.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
 */ GameObjectCreator.register('pointlight', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var color = GetAdvancedValue(config, 'color', 0xffffff);
                    var radius = GetAdvancedValue(config, 'radius', 128);
                    var intensity = GetAdvancedValue(config, 'intensity', 1);
                    var attenuation = GetAdvancedValue(config, 'attenuation', 0.1);
                    var layer = new PointLight(this.scene, 0, 0, color, radius, intensity, attenuation);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, layer, config);
                    return layer;
                });
            /***/ },
            /***/ 71255: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var PointLight = __webpack_require__(80321);
                /**
 * Creates a new Point Light Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
 *
 * The Point Light Game Object provides a way to add a point light effect into your game,
 * without the expensive shader processing requirements of the traditional Light Game Object.
 *
 * The difference is that the Point Light renders using a custom shader, designed to give the
 * impression of a point light source, of variable radius, intensity and color, in your game.
 * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
 * normal maps for calcuations. This makes them extremely fast to render compared to Lights
 * and perfect for special effects, such as flickering torches or muzzle flashes.
 *
 * For maximum performance you should batch Point Light Game Objects together. This means
 * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
 * Game Object and then add just Point Lights to it, so that it can batch together the rendering
 * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
 * your game then it's perfectly safe to mix them into the display list as normal. However, if
 * you're using a large number of them, please consider how they are mixed into the display list.
 *
 * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
 * with the Camera will be skipped in the rendering list. This happens automatically and the
 * culled state is refreshed every frame, for every camera.
 *
 * The origin of a Point Light is always 0.5 and it cannot be changed.
 *
 * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
 *
 * @method Phaser.GameObjects.GameObjectFactory#pointlight
 * @since 3.50.0
 *
 * @param {number} x - The horizontal position of this Point Light in the world.
 * @param {number} y - The vertical position of this Point Light in the world.
 * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
 * @param {number} [radius=128] - The radius of the Point Light.
 * @param {number} [intensity=1] - The intensity, or color blend, of the Point Light.
 * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
 *
 * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
 */ GameObjectFactory.register('pointlight', function(x, y, color, radius, intensity, attenuation) {
                    return this.displayList.add(new PointLight(this.scene, x, y, color, radius, intensity, attenuation));
                });
            /***/ },
            /***/ 67277: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(57787);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 57787: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.PointLight#renderWebGL
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.PointLight} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PointLightWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    var width = src.width;
                    var height = src.height;
                    var x = -src._radius;
                    var y = -src._radius;
                    var xw = x + width;
                    var yh = y + height;
                    var lightX = calcMatrix.getX(0, 0);
                    var lightY = calcMatrix.getY(0, 0);
                    var tx0 = calcMatrix.getX(x, y);
                    var ty0 = calcMatrix.getY(x, y);
                    var tx1 = calcMatrix.getX(x, yh);
                    var ty1 = calcMatrix.getY(x, yh);
                    var tx2 = calcMatrix.getX(xw, yh);
                    var ty2 = calcMatrix.getY(xw, yh);
                    var tx3 = calcMatrix.getX(xw, y);
                    var ty3 = calcMatrix.getY(xw, y);
                    renderer.pipelines.preBatch(src);
                    pipeline.batchPointLight(src, camera, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, lightX, lightY);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = PointLightWebGLRenderer;
            /***/ },
            /***/ 591: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var DynamicTexture = __webpack_require__(81320);
                var Image1 = __webpack_require__(88571);
                /**
 * @classdesc
 * A Render Texture is a combination of Dynamic Texture and an Image Game Object, that uses the
 * Dynamic Texture to display itself with.
 *
 * A Dynamic Texture is a special texture that allows you to draw textures, frames and most kind of
 * Game Objects directly to it.
 *
 * You can take many complex objects and draw them to this one texture, which can then be used as the
 * base texture for other Game Objects, such as Sprites. Should you then update this texture, all
 * Game Objects using it will instantly be updated as well, reflecting the changes immediately.
 *
 * It's a powerful way to generate dynamic textures at run-time that are WebGL friendly and don't invoke
 * expensive GPU uploads on each change.
 *
 * In versions of Phaser before 3.60 a Render Texture was the only way you could create a texture
 * like this, that had the ability to be drawn on. But in 3.60 we split the core functions out to
 * the Dynamic Texture class as it made a lot more sense for them to reside in there. As a result,
 * the Render Texture is now a light-weight shim that sits on-top of an Image Game Object and offers
 * proxy methods to the features available from a Dynamic Texture.
 *
 * **When should you use a Render Texture vs. a Dynamic Texture?**
 *
 * You should use a Dynamic Texture if the texture is going to be used by multiple Game Objects,
 * or you want to use it across multiple Scenes, because textures are globally stored.
 *
 * You should use a Dynamic Texture if the texture isn't going to be displayed in-game, but is
 * instead going to be used for something like a mask or shader.
 *
 * You should use a Render Texture if you need to display the texture in-game on a single Game Object,
 * as it provides the convenience of wrapping an Image and Dynamic Texture together for you.
 *
 * Under WebGL1, a FrameBuffer, which is what this Dynamic Texture uses internally, cannot be anti-aliased.
 * This means that when drawing objects such as Shapes or Graphics instances to this texture, they may appear
 * to be drawn with no aliasing around the edges. This is a technical limitation of WebGL1. To get around it,
 * create your shape as a texture in an art package, then draw that to this texture.
 *
 * @class RenderTexture
 * @extends Phaser.GameObjects.Image
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.2.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=32] - The width of the Render Texture.
 * @param {number} [height=32] - The height of the Render Texture.
 * @param {boolean} [forceEven=true] - Force the given width and height to be rounded to even values. This significantly improves the rendering quality. Set to false if you know you need an odd sized texture.
 */ var RenderTexture = new Class({
                    Extends: Image1,
                    initialize: function RenderTexture(scene, x, y, width, height, forceEven) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 32;
                        if (height === undefined) height = 32;
                        if (forceEven === undefined) forceEven = true;
                        var dynamicTexture = new DynamicTexture(scene.sys.textures, '', width, height, forceEven);
                        Image1.call(this, scene, x, y, dynamicTexture);
                        this.type = 'RenderTexture';
                        /**
         * An internal Camera that can be used to move around this Render Texture.
         *
         * Control it just like you would any Scene Camera. The difference is that it only impacts
         * the placement of Game Objects that you then draw to this texture.
         *
         * You can scroll, zoom and rotate this Camera.
         *
         * This property is a reference to `RenderTexture.texture.camera`.
         *
         * @name Phaser.GameObjects.RenderTexture#camera
         * @type {Phaser.Cameras.Scene2D.BaseCamera}
         * @since 3.12.0
         */ this.camera = this.texture.camera;
                        /**
         * Internal saved texture flag.
         *
         * @name Phaser.GameObjects.RenderTexture#_saved
         * @type {boolean}
         * @private
         * @since 3.12.0
         */ this._saved = false;
                    },
                    /**
     * Sets the internal size of this Render Texture, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values. You could also call the `resize` method, as that
     * will resize the underlying texture.
     *
     * If you have enabled this Game Object for input, changing the size will also change the
     * size of the hit area, unless you have defined a custom hit area.
     *
     * @method Phaser.GameObjects.RenderTexture#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        this.updateDisplayOrigin();
                        var input = this.input;
                        if (input && !input.customHitArea) {
                            input.hitArea.width = width;
                            input.hitArea.height = height;
                        }
                        return this;
                    },
                    /**
     * Resizes the Render Texture to the new dimensions given.
     *
     * In WebGL it will destroy and then re-create the frame buffer being used by the Render Texture.
     * In Canvas it will resize the underlying canvas element.
     *
     * Both approaches will erase everything currently drawn to the Render Texture.
     * 
     * Calling this will then invoke the `setSize` method, setting the internal size of this Game Object
     * to the values given to this method.
     *
     * If the dimensions given are the same as those already being used, calling this method will do nothing.
     *
     * @method Phaser.GameObjects.RenderTexture#resize
     * @since 3.10.0
     *
     * @param {number} width - The new width of the Render Texture.
     * @param {number} [height=width] - The new height of the Render Texture. If not specified, will be set the same as the `width`.
     * @param {boolean} [forceEven=true] - Force the given width and height to be rounded to even values. This significantly improves the rendering quality. Set to false if you know you need an odd sized texture.
     *
     * @return {this} This Render Texture.
     */ resize: function(width, height, forceEven) {
                        this.texture.setSize(width, height, forceEven);
                        this.setSize(this.texture.width, this.texture.height);
                        return this;
                    },
                    /**
     * Stores a copy of this Render Texture in the Texture Manager using the given key.
     *
     * After doing this, any texture based Game Object, such as a Sprite, can use the contents of this
     * Render Texture by using the texture key:
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 128, 128);
     *
     * // Draw something to the Render Texture
     *
     * rt.saveTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Updating the contents of this Render Texture will automatically update _any_ Game Object
     * that is using it as a texture. Calling `saveTexture` again will not save another copy
     * of the same texture, it will just rename the key of the existing copy.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame from a Render Texture.
     *
     * If you destroy this Render Texture, any Game Object using it via the Texture Manager will
     * stop rendering. Ensure you remove the texture from the Texture Manager and any Game Objects
     * using it first, before destroying this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#saveTexture
     * @since 3.12.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     *
     * @return {Phaser.Textures.DynamicTexture} The Texture that was saved.
     */ saveTexture: function(key) {
                        var texture = this.texture;
                        texture.key = key;
                        if (texture.manager.addDynamicTexture(texture)) this._saved = true;
                        return texture;
                    },
                    /**
     * Fills this Render Texture with the given color.
     *
     * By default it will fill the entire texture, however you can set it to fill a specific
     * rectangular area by using the x, y, width and height arguments.
     *
     * The color should be given in hex format, i.e. 0xff0000 for red, 0x00ff00 for green, etc.
     *
     * @method Phaser.GameObjects.RenderTexture#fill
     * @since 3.2.0
     *
     * @param {number} rgb - The color to fill this Render Texture with, such as 0xff0000 for red.
     * @param {number} [alpha=1] - The alpha value used by the fill.
     * @param {number} [x=0] - The left coordinate of the fill rectangle.
     * @param {number} [y=0] - The top coordinate of the fill rectangle.
     * @param {number} [width=this.width] - The width of the fill rectangle.
     * @param {number} [height=this.height] - The height of the fill rectangle.
     *
     * @return {this} This Render Texture instance.
     */ fill: function(rgb, alpha, x, y, width, height) {
                        this.texture.fill(rgb, alpha, x, y, width, height);
                        return this;
                    },
                    /**
     * Fully clears this Render Texture, erasing everything from it and resetting it back to
     * a blank, transparent, texture.
     *
     * @method Phaser.GameObjects.RenderTexture#clear
     * @since 3.2.0
     *
     * @return {this} This Render Texture instance.
     */ clear: function() {
                        this.texture.clear();
                        return this;
                    },
                    /**
     * Takes the given texture key and frame and then stamps it at the given
     * x and y coordinates. You can use the optional 'config' argument to provide
     * lots more options about how the stamp is applied, including the alpha,
     * tint, angle, scale and origin.
     *
     * By default, the frame will stamp on the x/y coordinates based on its center.
     *
     * If you wish to stamp from the top-left, set the config `originX` and
     * `originY` properties both to zero.
     *
     * @method Phaser.GameObjects.RenderTexture#stamp
     * @since 3.60.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture. Set to `null` to skip this argument if not required.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {Phaser.Types.Textures.StampConfig} [config] - The stamp configuration object, allowing you to set the alpha, tint, angle, scale and origin of the stamp.
     *
     * @return {this} This Render Texture instance.
     */ stamp: function(key, frame, x, y, config) {
                        this.texture.stamp(key, frame, x, y, config);
                        return this;
                    },
                    /**
     * Draws the given object, or an array of objects, to this Render Texture using a blend mode of ERASE.
     * This has the effect of erasing any filled pixels present in the objects from this texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Dynamic Texture, or a Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up the texture from the Texture Manager.
     *
     * Note: You cannot erase a Render Texture from itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * @method Phaser.GameObjects.RenderTexture#erase
     * @since 3.16.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, Render Texture, Texture Frame, or an array of any of these.
     * @param {number} [x=0] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y=0] - The y position to draw the Frame at, or the offset applied to the object.
     *
     * @return {this} This Render Texture instance.
     */ erase: function(entries, x, y) {
                        this.texture.erase(entries, x, y);
                        return this;
                    },
                    /**
     * Draws the given object, or an array of objects, to this Render Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Dynamic Texture, or a Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up the texture from the Texture Manager.
     *
     * Note 1: You cannot draw a Render Texture to itself.
     *
     * Note 2: For Game Objects that have Post FX Pipelines, the pipeline _cannot_ be
     * used when drawn to this texture.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * @method Phaser.GameObjects.RenderTexture#draw
     * @since 3.2.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x=0] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y=0] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     *
     * @return {this} This Render Texture instance.
     */ draw: function(entries, x, y, alpha, tint) {
                        this.texture.draw(entries, x, y, alpha, tint);
                        return this;
                    },
                    /**
     * Draws the Texture Frame to the Render Texture at the given position.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 800, 600);
     * rt.drawFrame(key, frame);
     * ```
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * Calling this method will cause a batch flush, so if you've got a stack of things to draw
     * in a tight loop, try using the `draw` method instead.
     *
     * If you need to draw a Sprite to this Render Texture, use the `draw` method instead.
     *
     * @method Phaser.GameObjects.RenderTexture#drawFrame
     * @since 3.12.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture. Set to `null` to skip this argument if not required.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. WebGL only.
     *
     * @return {this} This Render Texture instance.
     */ drawFrame: function(key, frame, x, y, alpha, tint) {
                        this.texture.drawFrame(key, frame, x, y, alpha, tint);
                        return this;
                    },
                    /**
     * Takes the given Texture Frame and draws it to this Render Texture as a fill pattern,
     * i.e. in a grid-layout based on the frame dimensions.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * You can optionally provide a position, width, height, alpha and tint value to apply to
     * the frames before they are drawn. The position controls the top-left where the repeating
     * fill will start from. The width and height control the size of the filled area.
     *
     * The position can be negative if required, but the dimensions cannot.
     *
     * Calling this method will cause a batch flush by default. Use the `skipBatch` argument
     * to disable this if this call is part of a larger batch draw.
     *
     * @method Phaser.GameObjects.RenderTexture#repeat
     * @since 3.60.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture. Set to `null` to skip this argument if not required.
     * @param {number} [x=0] - The x position to start drawing the frames from (can be negative to offset).
     * @param {number} [y=0] - The y position to start drawing the frames from (can be negative to offset).
     * @param {number} [width=this.width] - The width of the area to repeat the frame within. Defaults to the width of this Dynamic Texture.
     * @param {number} [height=this.height] - The height of the area to repeat the frame within. Defaults to the height of this Dynamic Texture.
     * @param {number} [alpha=1] - The alpha to use. Defaults to 1, no alpha.
     * @param {number} [tint=0xffffff] - WebGL only. The tint color to use. Leave as undefined, or 0xffffff to have no tint.
     * @param {boolean} [skipBatch=false] - Skip beginning and ending a batch with this call. Use if this is part of a bigger batched draw.
     *
     * @return {this} This Render Texture instance.
     */ repeat: function(key, frame, x, y, width, height, alpha, tint, skipBatch) {
                        this.texture.repeat(key, frame, x, y, width, height, alpha, tint, skipBatch);
                        return this;
                    },
                    /**
     * Use this method if you need to batch draw a large number of Game Objects to
     * this Render Texture in a single pass, or on a frequent basis. This is especially
     * useful under WebGL, however, if your game is using Canvas only, it will not make
     * any speed difference in that situation.
     *
     * This method starts the beginning of a batched draw, unless one is already open.
     *
     * Batched drawing is faster than calling `draw` in loop, but you must be careful
     * to manage the flow of code and remember to call `endDraw()` when you're finished.
     *
     * If you don't need to draw large numbers of objects it's much safer and easier
     * to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `RenderTexture.texture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * @method Phaser.GameObjects.RenderTexture#beginDraw
     * @since 3.50.0
     *
     * @return {this} This Render Texture instance.
     */ beginDraw: function() {
                        this.texture.beginDraw();
                        return this;
                    },
                    /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of objects to this Render Texture.
     *
     * This method batches the drawing of the given objects to this texture,
     * without causing a WebGL bind or batch flush for each one.
     *
     * It is faster than calling `draw`, but you must be careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `RenderTexture.texture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * This method can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Dynamic Texture or Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot draw a Render Texture to itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * @method Phaser.GameObjects.RenderTexture#batchDraw
     * @since 3.50.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Dynamic or Texture, Texture Frame or an array of any of these.
     * @param {number} [x=0] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y=0] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     *
     * @return {this} This Render Texture instance.
     */ batchDraw: function(entries, x, y, alpha, tint) {
                        this.texture.batchDraw(entries, x, y, alpha, tint);
                        return this;
                    },
                    /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of texture frames to this Render Texture.
     *
     * This method batches the drawing of the given frames to this Render Texture,
     * without causing a WebGL bind or batch flush for each one.
     *
     * It is faster than calling `drawFrame`, but you must be careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of frames it's much safer and easier to use the `drawFrame` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `RenderTexture.texture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * @method Phaser.GameObjects.RenderTexture#batchDrawFrame
     * @since 3.50.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     *
     * @return {this} This Render Texture instance.
     */ batchDrawFrame: function(key, frame, x, y, alpha, tint) {
                        this.texture.batchDrawFrame(key, frame, x, y, alpha, tint);
                        return this;
                    },
                    /**
     * Use this method to finish batch drawing to this Render Texture.
     *
     * Doing so will stop the WebGL Renderer from capturing draws and then blit the
     * framebuffer to the Render Target owned by this texture.
     *
     * Calling this method without first calling `beginDraw` will have no effect.
     *
     * Batch drawing is faster than calling `draw`, but you must be careful to manage the
     * flow of code and remember to call `endDraw()` when you're finished.
     *
     * If you don't need to draw large numbers of objects it's much safer and easier
     * to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `RenderTexture.texture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * @method Phaser.GameObjects.RenderTexture#endDraw
     * @since 3.50.0
     *
     * @param {boolean} [erase=false] - Draws all objects in this batch using a blend mode of ERASE. This has the effect of erasing any filled pixels in the objects being drawn.
     *
     * @return {this} This Render Texture instance.
     */ endDraw: function(erase) {
                        this.texture.endDraw(erase);
                        return this;
                    },
                    /**
     * Takes a snapshot of the given area of this Render Texture.
     *
     * The snapshot is taken immediately, but the results are returned via the given callback.
     *
     * To capture the whole Render Texture see the `snapshot` method.
     * To capture just a specific pixel, see the `snapshotPixel` method.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer
     * into an ArrayBufferView. It then parses this, copying the contents to a temporary Canvas and finally
     * creating an Image object from it, which is the image returned to the callback provided.
     *
     * All in all, this is a computationally expensive and blocking process, which gets more expensive
     * the larger the resolution this Render Texture has, so please be careful how you employ this in your game.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshotArea
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Render Texture instance.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                        this.texture.snapshotArea(x, y, width, height, callback, type, encoderOptions);
                        return this;
                    },
                    /**
     * Takes a snapshot of the whole of this Render Texture.
     *
     * The snapshot is taken immediately, but the results are returned via the given callback.
     *
     * To capture a portion of this Render Texture see the `snapshotArea` method.
     * To capture just a specific pixel, see the `snapshotPixel` method.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer
     * into an ArrayBufferView. It then parses this, copying the contents to a temporary Canvas and finally
     * creating an Image object from it, which is the image returned to the callback provided.
     *
     * All in all, this is a computationally expensive and blocking process, which gets more expensive
     * the larger the resolution this Render Texture has, so please be careful how you employ this in your game.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshot
     * @since 3.19.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Render Texture instance.
     */ snapshot: function(callback, type, encoderOptions) {
                        return this.snapshotArea(0, 0, this.width, this.height, callback, type, encoderOptions);
                    },
                    /**
     * Takes a snapshot of the given pixel from this Render Texture.
     *
     * The snapshot is taken immediately, but the results are returned via the given callback.
     *
     * To capture the whole Render Texture see the `snapshot` method.
     * To capture a portion of this Render Texture see the `snapshotArea` method.
     *
     * Unlike the two other snapshot methods, this one will send your callback a `Color` object
     * containing the color data for the requested pixel. It doesn't need to create an internal
     * Canvas or Image object, so is a lot faster to execute, using less memory than the other snapshot methods.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshotPixel
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This Render Texture instance.
     */ snapshotPixel: function(x, y, callback) {
                        return this.snapshotArea(x, y, 1, 1, callback, 'pixel');
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.RenderTexture#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                        this.camera = null;
                        if (!this._saved) this.texture.destroy();
                    }
                });
                module1.exports = RenderTexture;
            /***/ },
            /***/ 34495: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var RenderTexture = __webpack_require__(591);
                /**
 * Creates a new Render Texture Game Object and returns it.
 *
 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
 *
 * A Render Texture is a combination of Dynamic Texture and an Image Game Object, that uses the
 * Dynamic Texture to display itself with.
 *
 * A Dynamic Texture is a special texture that allows you to draw textures, frames and most kind of
 * Game Objects directly to it.
 *
 * You can take many complex objects and draw them to this one texture, which can then be used as the
 * base texture for other Game Objects, such as Sprites. Should you then update this texture, all
 * Game Objects using it will instantly be updated as well, reflecting the changes immediately.
 *
 * It's a powerful way to generate dynamic textures at run-time that are WebGL friendly and don't invoke
 * expensive GPU uploads on each change.
 *
 * @method Phaser.GameObjects.GameObjectCreator#renderTexture
 * @since 3.2.0
 *
 * @param {Phaser.Types.GameObjects.RenderTexture.RenderTextureConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
 */ GameObjectCreator.register('renderTexture', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var x = GetAdvancedValue(config, 'x', 0);
                    var y = GetAdvancedValue(config, 'y', 0);
                    var width = GetAdvancedValue(config, 'width', 32);
                    var height = GetAdvancedValue(config, 'height', 32);
                    var renderTexture = new RenderTexture(this.scene, x, y, width, height);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, renderTexture, config);
                    return renderTexture;
                });
            /***/ },
            /***/ 60505: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var RenderTexture = __webpack_require__(591);
                /**
 * Creates a new Render Texture Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
 *
 * A Render Texture is a combination of Dynamic Texture and an Image Game Object, that uses the
 * Dynamic Texture to display itself with.
 *
 * A Dynamic Texture is a special texture that allows you to draw textures, frames and most kind of
 * Game Objects directly to it.
 *
 * You can take many complex objects and draw them to this one texture, which can then be used as the
 * base texture for other Game Objects, such as Sprites. Should you then update this texture, all
 * Game Objects using it will instantly be updated as well, reflecting the changes immediately.
 *
 * It's a powerful way to generate dynamic textures at run-time that are WebGL friendly and don't invoke
 * expensive GPU uploads on each change.
 *
 * @method Phaser.GameObjects.GameObjectFactory#renderTexture
 * @since 3.2.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=32] - The width of the Render Texture.
 * @param {number} [height=32] - The height of the Render Texture.
 *
 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
 */ GameObjectFactory.register('renderTexture', function(x, y, width, height) {
                    return this.displayList.add(new RenderTexture(this.scene, x, y, width, height));
                });
            /***/ },
            /***/ 77757: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(9674);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var PIPELINE_CONST = __webpack_require__(36060);
                var RopeRender = __webpack_require__(38745);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Rope Game Object.
 *
 * The Rope object is WebGL only and does not have a Canvas counterpart.
 *
 * A Rope is a special kind of Game Object that has a texture is stretched along its entire length.
 *
 * Unlike a Sprite, it isn't restricted to using just a quad and can have as many vertices as you define
 * when creating it. The vertices can be arranged in a horizontal or vertical strip and have their own
 * color and alpha values as well.
 *
 * A Ropes origin is always 0.5 x 0.5 and cannot be changed.
 *
 * @class Rope
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.23.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {string} [texture] - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager. If not given, `__DEFAULT` is used.
 * @param {(string|number|null)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {(number|Phaser.Types.Math.Vector2Like[])} [points=2] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided a simple quad is created. See `setPoints` to set this post-creation.
 * @param {boolean} [horizontal=true] - Should the vertices of this Rope be aligned horizontally (`true`), or vertically (`false`)?
 * @param {number[]} [colors] - An optional array containing the color data for this Rope. You should provide one color value per pair of vertices.
 * @param {number[]} [alphas] - An optional array containing the alpha data for this Rope. You should provide one alpha value per pair of vertices.
 */ var Rope = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Flip,
                        Components.Mask,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.Size,
                        Components.Texture,
                        Components.Transform,
                        Components.Visible,
                        Components.ScrollFactor,
                        RopeRender
                    ],
                    initialize: function Rope(scene, x, y, texture, frame, points, horizontal, colors, alphas) {
                        if (texture === undefined) texture = '__DEFAULT';
                        if (points === undefined) points = 2;
                        if (horizontal === undefined) horizontal = true;
                        GameObject.call(this, scene, 'Rope');
                        /**
         * The Animation State of this Rope.
         *
         * @name Phaser.GameObjects.Rope#anims
         * @type {Phaser.Animations.AnimationState}
         * @since 3.23.0
         */ this.anims = new AnimationState(this);
                        /**
         * An array containing the points data for this Rope.
         *
         * Each point should be given as a Vector2Like object (i.e. a Vector2, Geom.Point or object with public x/y properties).
         *
         * The point coordinates are given in local space, where 0 x 0 is the start of the Rope strip.
         *
         * You can modify the contents of this array directly in real-time to create interesting effects.
         * If you do so, be sure to call `setDirty` _after_ modifying this array, so that the vertices data is
         * updated before the next render. Alternatively, you can use the `setPoints` method instead.
         *
         * Should you need to change the _size_ of this array, then you should always use the `setPoints` method.
         *
         * @name Phaser.GameObjects.Rope#points
         * @type {Phaser.Types.Math.Vector2Like[]}
         * @since 3.23.0
         */ this.points = points;
                        /**
         * An array containing the vertices data for this Rope.
         *
         * This data is calculated automatically in the `updateVertices` method, based on the points provided.
         *
         * @name Phaser.GameObjects.Rope#vertices
         * @type {Float32Array}
         * @since 3.23.0
         */ this.vertices;
                        /**
         * An array containing the uv data for this Rope.
         *
         * This data is calculated automatically in the `setPoints` method, based on the points provided.
         *
         * @name Phaser.GameObjects.Rope#uv
         * @type {Float32Array}
         * @since 3.23.0
         */ this.uv;
                        /**
         * An array containing the color data for this Rope.
         *
         * Colors should be given as numeric RGB values, such as 0xff0000.
         * You should provide _two_ color values for every point in the Rope, one for the top and one for the bottom of each quad.
         *
         * You can modify the contents of this array directly in real-time, however, should you need to change the _size_
         * of the array, then you should use the `setColors` method instead.
         *
         * @name Phaser.GameObjects.Rope#colors
         * @type {Uint32Array}
         * @since 3.23.0
         */ this.colors;
                        /**
         * An array containing the alpha data for this Rope.
         *
         * Alphas should be given as float values, such as 0.5.
         * You should provide _two_ alpha values for every point in the Rope, one for the top and one for the bottom of each quad.
         *
         * You can modify the contents of this array directly in real-time, however, should you need to change the _size_
         * of the array, then you should use the `setAlphas` method instead.
         *
         * @name Phaser.GameObjects.Rope#alphas
         * @type {Float32Array}
         * @since 3.23.0
         */ this.alphas;
                        /**
         * The tint fill mode.
         *
        * `false` = An additive tint (the default), where vertices colors are blended with the texture.
        * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.Rope#tintFill
         * @type {boolean}
         * @since 3.23.0
         */ this.tintFill = texture === '__DEFAULT' ? true : false;
                        /**
         * If the Rope is marked as `dirty` it will automatically recalculate its vertices
         * the next time it renders. You can also force this by calling `updateVertices`.
         *
         * @name Phaser.GameObjects.Rope#dirty
         * @type {boolean}
         * @since 3.23.0
         */ this.dirty = false;
                        /**
         * Are the Rope vertices aligned horizontally, in a strip, or vertically, in a column?
         *
         * This property is set during instantiation and cannot be changed directly.
         * See the `setVertical` and `setHorizontal` methods.
         *
         * @name Phaser.GameObjects.Rope#horizontal
         * @type {boolean}
         * @readonly
         * @since 3.23.0
         */ this.horizontal = horizontal;
                        /**
         * The horizontally flipped state of the Game Object.
         *
         * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
         * Flipping always takes place from the middle of the texture and does not impact the scale value.
         * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
         *
         * @name Phaser.GameObjects.Rope#_flipX
         * @type {boolean}
         * @default false
         * @private
         * @since 3.23.0
         */ this._flipX = false;
                        /**
         * The vertically flipped state of the Game Object.
         *
         * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
         * Flipping always takes place from the middle of the texture and does not impact the scale value.
         * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
         *
         * @name Phaser.GameObjects.Rope#_flipY
         * @type {boolean}
         * @default false
         * @private
         * @since 3.23.0
         */ this._flipY = false;
                        /**
         * Internal Vector2 used for vertices updates.
         *
         * @name Phaser.GameObjects.Rope#_perp
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.23.0
         */ this._perp = new Vector2();
                        /**
         * You can optionally choose to render the vertices of this Rope to a Graphics instance.
         *
         * Achieve this by setting the `debugCallback` and the `debugGraphic` properties.
         *
         * You can do this in a single call via the `Rope.setDebug` method, which will use the
         * built-in debug function. You can also set it to your own callback. The callback
         * will be invoked _once per render_ and sent the following parameters:
         *
         * `debugCallback(src, meshLength, verts)`
         *
         * `src` is the Rope instance being debugged.
         * `meshLength` is the number of mesh vertices in total.
         * `verts` is an array of the translated vertex coordinates.
         *
         * To disable rendering, set this property back to `null`.
         *
         * @name Phaser.GameObjects.Rope#debugCallback
         * @type {function}
         * @since 3.23.0
         */ this.debugCallback = null;
                        /**
         * The Graphics instance that the debug vertices will be drawn to, if `setDebug` has
         * been called.
         *
         * @name Phaser.GameObjects.Rope#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.23.0
         */ this.debugGraphic = null;
                        this.setTexture(texture, frame);
                        this.setPosition(x, y);
                        this.setSizeToFrame();
                        this.initPipeline(PIPELINE_CONST.ROPE_PIPELINE);
                        this.initPostPipeline();
                        if (Array.isArray(points)) this.resizeArrays(points.length);
                        this.setPoints(points, colors, alphas);
                        this.updateVertices();
                    },
                    //  Overrides Game Object method
                    addedToScene: function() {
                        this.scene.sys.updateList.add(this);
                    },
                    //  Overrides Game Object method
                    removedFromScene: function() {
                        this.scene.sys.updateList.remove(this);
                    },
                    /**
     * The Rope update loop.
     *
     * @method Phaser.GameObjects.Rope#preUpdate
     * @protected
     * @since 3.23.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                        var prevFrame = this.anims.currentFrame;
                        this.anims.update(time, delta);
                        if (this.anims.currentFrame !== prevFrame) {
                            this.updateUVs();
                            this.updateVertices();
                        }
                    },
                    /**
     * Start playing the given animation.
     *
     * @method Phaser.GameObjects.Rope#play
     * @since 3.23.0
     *
     * @param {string} key - The string-based key of the animation to play.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     * @param {number} [startFrame=0] - Optionally start the animation playing from this frame index.
     *
     * @return {this} This Game Object.
     */ play: function(key, ignoreIfPlaying, startFrame) {
                        this.anims.play(key, ignoreIfPlaying, startFrame);
                        return this;
                    },
                    /**
     * Flags this Rope as being dirty. A dirty rope will recalculate all of its vertices data
     * the _next_ time it renders. You should set this rope as dirty if you update the points
     * array directly.
     *
     * @method Phaser.GameObjects.Rope#setDirty
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ setDirty: function() {
                        this.dirty = true;
                        return this;
                    },
                    /**
     * Sets the alignment of the points in this Rope to be horizontal, in a strip format.
     *
     * Calling this method will reset this Rope. The current points, vertices, colors and alpha
     * values will be reset to thoes values given as parameters.
     *
     * @method Phaser.GameObjects.Rope#setHorizontal
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided the current points length is used.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setHorizontal: function(points, colors, alphas) {
                        if (points === undefined) points = this.points.length;
                        if (this.horizontal) return this;
                        this.horizontal = true;
                        return this.setPoints(points, colors, alphas);
                    },
                    /**
     * Sets the alignment of the points in this Rope to be vertical, in a column format.
     *
     * Calling this method will reset this Rope. The current points, vertices, colors and alpha
     * values will be reset to thoes values given as parameters.
     *
     * @method Phaser.GameObjects.Rope#setVertical
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided the current points length is used.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setVertical: function(points, colors, alphas) {
                        if (points === undefined) points = this.points.length;
                        if (!this.horizontal) return this;
                        this.horizontal = false;
                        return this.setPoints(points, colors, alphas);
                    },
                    /**
     * Sets the tint fill mode.
     *
     * Mode 0 (`false`) is an additive tint, the default, which blends the vertices colors with the texture.
     * This mode respects the texture alpha.
     *
     * Mode 1 (`true`) is a fill tint. Unlike an additive tint, a fill-tint literally replaces the pixel colors
     * from the texture with those in the tint. You can use this for effects such as making a player flash 'white'
     * if hit by something. This mode respects the texture alpha.
     *
     * See the `setColors` method for details of how to color each of the vertices.
     *
     * @method Phaser.GameObjects.Rope#setTintFill
     * @webglOnly
     * @since 3.23.0
     *
     * @param {boolean} [value=false] - Set to `false` for an Additive tint or `true` fill tint with alpha.
     *
     * @return {this} This Game Object instance.
     */ setTintFill: function(value) {
                        if (value === undefined) value = false;
                        this.tintFill = value;
                        return this;
                    },
                    /**
     * Set the alpha values used by the Rope during rendering.
     *
     * You can provide the values in a number of ways:
     *
     * 1) One single numeric value: `setAlphas(0.5)` - This will set a single alpha for the whole Rope.
     * 2) Two numeric value: `setAlphas(1, 0.5)` - This will set a 'top' and 'bottom' alpha value across the whole Rope.
     * 3) An array of values: `setAlphas([ 1, 0.5, 0.2 ])`
     *
     * If you provide an array of values and the array has exactly the same number of values as `points` in the Rope, it
     * will use each alpha value per rope segment.
     *
     * If the provided array has a different number of values than `points` then it will use the values in order, from
     * the first Rope segment and on, until it runs out of values. This allows you to control the alpha values at all
     * vertices in the Rope.
     *
     * Note this method is called `setAlphas` (plural) and not `setAlpha`.
     *
     * @method Phaser.GameObjects.Rope#setAlphas
     * @since 3.23.0
     *
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values. If nothing is provided alpha is reset to 1.
     * @param {number} [bottomAlpha] - An optional bottom alpha value. See the method description for details.
     *
     * @return {this} This Game Object instance.
     */ setAlphas: function(alphas, bottomAlpha) {
                        var total = this.points.length;
                        if (total < 1) return this;
                        var currentAlphas = this.alphas;
                        if (alphas === undefined) alphas = [
                            1
                        ];
                        else if (!Array.isArray(alphas) && bottomAlpha === undefined) alphas = [
                            alphas
                        ];
                        var i;
                        var index = 0;
                        if (bottomAlpha !== undefined) //  Top / Bottom alpha pair
                        for(i = 0; i < total; i++){
                            index = i * 2;
                            currentAlphas[index] = alphas;
                            currentAlphas[index + 1] = bottomAlpha;
                        }
                        else if (alphas.length === total) //  If there are exactly the same number of alphas as points, we'll combine the alphas
                        for(i = 0; i < total; i++){
                            index = i * 2;
                            currentAlphas[index] = alphas[i];
                            currentAlphas[index + 1] = alphas[i];
                        }
                        else {
                            var prevAlpha = alphas[0];
                            for(i = 0; i < total; i++){
                                index = i * 2;
                                if (alphas.length > index) prevAlpha = alphas[index];
                                currentAlphas[index] = prevAlpha;
                                if (alphas.length > index + 1) prevAlpha = alphas[index + 1];
                                currentAlphas[index + 1] = prevAlpha;
                            }
                        }
                        return this;
                    },
                    /**
     * Set the color values used by the Rope during rendering.
     *
     * Colors are used to control the level of tint applied across the Rope texture.
     *
     * You can provide the values in a number of ways:
     *
     * * One single numeric value: `setColors(0xff0000)` - This will set a single color tint for the whole Rope.
     * * An array of values: `setColors([ 0xff0000, 0x00ff00, 0x0000ff ])`
     *
     * If you provide an array of values and the array has exactly the same number of values as `points` in the Rope, it
     * will use each color per rope segment.
     *
     * If the provided array has a different number of values than `points` then it will use the values in order, from
     * the first Rope segment and on, until it runs out of values. This allows you to control the color values at all
     * vertices in the Rope.
     *
     * @method Phaser.GameObjects.Rope#setColors
     * @since 3.23.0
     *
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values. If nothing is provided color is reset to 0xffffff.
     *
     * @return {this} This Game Object instance.
     */ setColors: function(colors) {
                        var total = this.points.length;
                        if (total < 1) return this;
                        var currentColors = this.colors;
                        if (colors === undefined) colors = [
                            0xffffff
                        ];
                        else if (!Array.isArray(colors)) colors = [
                            colors
                        ];
                        var i;
                        var index = 0;
                        if (colors.length === total) //  If there are exactly the same number of colors as points, we'll combine the colors
                        for(i = 0; i < total; i++){
                            index = i * 2;
                            currentColors[index] = colors[i];
                            currentColors[index + 1] = colors[i];
                        }
                        else {
                            var prevColor = colors[0];
                            for(i = 0; i < total; i++){
                                index = i * 2;
                                if (colors.length > index) prevColor = colors[index];
                                currentColors[index] = prevColor;
                                if (colors.length > index + 1) prevColor = colors[index + 1];
                                currentColors[index + 1] = prevColor;
                            }
                        }
                        return this;
                    },
                    /**
     * Sets the points used by this Rope.
     *
     * The points should be provided as an array of Vector2, or vector2-like objects (i.e. those with public x/y properties).
     *
     * Each point corresponds to one segment of the Rope. The more points in the array, the more segments the rope has.
     *
     * Point coordinates are given in local-space, not world-space, and are directly related to the size of the texture
     * this Rope object is using.
     *
     * For example, a Rope using a 512 px wide texture, split into 4 segments (128px each) would use the following points:
     *
     * ```javascript
     * rope.setPoints([
     *   { x: 0, y: 0 },
     *   { x: 128, y: 0 },
     *   { x: 256, y: 0 },
     *   { x: 384, y: 0 }
     * ]);
     * ```
     *
     * Or, you can provide an integer to do the same thing:
     *
     * ```javascript
     * rope.setPoints(4);
     * ```
     *
     * Which will divide the Rope into 4 equally sized segments based on the frame width.
     *
     * Note that calling this method with a different number of points than the Rope has currently will
     * _reset_ the color and alpha values, unless you provide them as arguments to this method.
     *
     * @method Phaser.GameObjects.Rope#setPoints
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points=2] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided a simple quad is created.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setPoints: function(points, colors, alphas) {
                        if (points === undefined) points = 2;
                        if (typeof points === 'number') {
                            //  Generate an array based on the points
                            var segments = points;
                            if (segments < 2) segments = 2;
                            points = [];
                            var s;
                            var frameSegment;
                            var offset;
                            if (this.horizontal) {
                                offset = -this.frame.halfWidth;
                                frameSegment = this.frame.width / (segments - 1);
                                for(s = 0; s < segments; s++)points.push({
                                    x: offset + s * frameSegment,
                                    y: 0
                                });
                            } else {
                                offset = -this.frame.halfHeight;
                                frameSegment = this.frame.height / (segments - 1);
                                for(s = 0; s < segments; s++)points.push({
                                    x: 0,
                                    y: offset + s * frameSegment
                                });
                            }
                        }
                        var total = points.length;
                        var currentTotal = this.points.length;
                        if (total < 1) {
                            console.warn('Rope: Not enough points given');
                            return this;
                        } else if (total === 1) {
                            points.unshift({
                                x: 0,
                                y: 0
                            });
                            total++;
                        }
                        if (currentTotal !== total) this.resizeArrays(total);
                        this.dirty = true;
                        this.points = points;
                        this.updateUVs();
                        if (colors !== undefined && colors !== null) this.setColors(colors);
                        if (alphas !== undefined && alphas !== null) this.setAlphas(alphas);
                        return this;
                    },
                    /**
     * Updates all of the UVs based on the Rope.points and `flipX` and `flipY` settings.
     *
     * @method Phaser.GameObjects.Rope#updateUVs
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ updateUVs: function() {
                        var currentUVs = this.uv;
                        var total = this.points.length;
                        var u0 = this.frame.u0;
                        var v0 = this.frame.v0;
                        var u1 = this.frame.u1;
                        var v1 = this.frame.v1;
                        var partH = (u1 - u0) / (total - 1);
                        var partV = (v1 - v0) / (total - 1);
                        for(var i = 0; i < total; i++){
                            var index = i * 4;
                            var uv0;
                            var uv1;
                            var uv2;
                            var uv3;
                            if (this.horizontal) {
                                if (this._flipX) {
                                    uv0 = u1 - i * partH;
                                    uv2 = u1 - i * partH;
                                } else {
                                    uv0 = u0 + i * partH;
                                    uv2 = u0 + i * partH;
                                }
                                if (this._flipY) {
                                    uv1 = v1;
                                    uv3 = v0;
                                } else {
                                    uv1 = v0;
                                    uv3 = v1;
                                }
                            } else {
                                if (this._flipX) {
                                    uv0 = u0;
                                    uv2 = u1;
                                } else {
                                    uv0 = u1;
                                    uv2 = u0;
                                }
                                if (this._flipY) {
                                    uv1 = v1 - i * partV;
                                    uv3 = v1 - i * partV;
                                } else {
                                    uv1 = v0 + i * partV;
                                    uv3 = v0 + i * partV;
                                }
                            }
                            currentUVs[index + 0] = uv0;
                            currentUVs[index + 1] = uv1;
                            currentUVs[index + 2] = uv2;
                            currentUVs[index + 3] = uv3;
                        }
                        return this;
                    },
                    /**
     * Resizes all of the internal arrays: `vertices`, `uv`, `colors` and `alphas` to the new
     * given Rope segment total.
     *
     * @method Phaser.GameObjects.Rope#resizeArrays
     * @since 3.23.0
     *
     * @param {number} newSize - The amount of segments to split the Rope in to.
     *
     * @return {this} This Game Object instance.
     */ resizeArrays: function(newSize) {
                        var colors = this.colors;
                        var alphas = this.alphas;
                        this.vertices = new Float32Array(newSize * 4);
                        this.uv = new Float32Array(newSize * 4);
                        colors = new Uint32Array(newSize * 2);
                        alphas = new Float32Array(newSize * 2);
                        for(var i = 0; i < newSize * 2; i++){
                            colors[i] = 0xffffff;
                            alphas[i] = 1;
                        }
                        this.colors = colors;
                        this.alphas = alphas;
                        //  updateVertices during next render
                        this.dirty = true;
                        return this;
                    },
                    /**
     * Updates the vertices based on the Rope points.
     *
     * This method is called automatically during rendering if `Rope.dirty` is `true`, which is set
     * by the `setPoints` and `setDirty` methods. You should flag the Rope as being dirty if you modify
     * the Rope points directly.
     *
     * @method Phaser.GameObjects.Rope#updateVertices
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ updateVertices: function() {
                        var perp = this._perp;
                        var points = this.points;
                        var vertices = this.vertices;
                        var total = points.length;
                        this.dirty = false;
                        if (total < 1) return;
                        var nextPoint;
                        var lastPoint = points[0];
                        var frameSize = this.horizontal ? this.frame.halfHeight : this.frame.halfWidth;
                        for(var i = 0; i < total; i++){
                            var point = points[i];
                            var index = i * 4;
                            if (i < total - 1) nextPoint = points[i + 1];
                            else nextPoint = point;
                            perp.x = nextPoint.y - lastPoint.y;
                            perp.y = -(nextPoint.x - lastPoint.x);
                            var perpLength = perp.length();
                            perp.x /= perpLength;
                            perp.y /= perpLength;
                            perp.x *= frameSize;
                            perp.y *= frameSize;
                            vertices[index] = point.x + perp.x;
                            vertices[index + 1] = point.y + perp.y;
                            vertices[index + 2] = point.x - perp.x;
                            vertices[index + 3] = point.y - perp.y;
                            lastPoint = point;
                        }
                        return this;
                    },
                    /**
     * This method enables rendering of the Rope vertices to the given Graphics instance.
     *
     * If you enable this feature, you **must** call `Graphics.clear()` in your Scene `update`,
     * otherwise the Graphics instance you provide to debug will fill-up with draw calls,
     * eventually crashing the browser. This is not done automatically to allow you to debug
     * draw multiple Rope objects to a single Graphics instance.
     *
     * The Rope class has a built-in debug rendering callback `Rope.renderDebugVerts`, however
     * you can also provide your own callback to be used instead. Do this by setting the `callback` parameter.
     *
     * The callback is invoked _once per render_ and sent the following parameters:
     *
     * `callback(src, meshLength, verts)`
     *
     * `src` is the Rope instance being debugged.
     * `meshLength` is the number of mesh vertices in total.
     * `verts` is an array of the translated vertex coordinates.
     *
     * If using your own callback you do not have to provide a Graphics instance to this method.
     *
     * To disable debug rendering, to either your own callback or the built-in one, call this method
     * with no arguments.
     *
     * @method Phaser.GameObjects.Rope#setDebug
     * @since 3.23.0
     *
     * @param {Phaser.GameObjects.Graphics} [graphic] - The Graphic instance to render to if using the built-in callback.
     * @param {function} [callback] - The callback to invoke during debug render. Leave as undefined to use the built-in callback.
     *
     * @return {this} This Game Object instance.
     */ setDebug: function(graphic, callback) {
                        this.debugGraphic = graphic;
                        if (!graphic && !callback) this.debugCallback = null;
                        else if (!callback) this.debugCallback = this.renderDebugVerts;
                        else this.debugCallback = callback;
                        return this;
                    },
                    /**
     * The built-in Rope vertices debug rendering method.
     *
     * See `Rope.setDebug` for more details.
     *
     * @method Phaser.GameObjects.Rope#renderDebugVerts
     * @since 3.23.0
     *
     * @param {Phaser.GameObjects.Rope} src - The Rope object being rendered.
     * @param {number} meshLength - The number of vertices in the mesh.
     * @param {number[]} verts - An array of translated vertex coordinates.
     */ renderDebugVerts: function(src, meshLength, verts) {
                        var graphic = src.debugGraphic;
                        var px0 = verts[0];
                        var py0 = verts[1];
                        var px1 = verts[2];
                        var py1 = verts[3];
                        graphic.lineBetween(px0, py0, px1, py1);
                        for(var i = 4; i < meshLength; i += 4){
                            var x0 = verts[i + 0];
                            var y0 = verts[i + 1];
                            var x1 = verts[i + 2];
                            var y1 = verts[i + 3];
                            graphic.lineBetween(px0, py0, x0, y0);
                            graphic.lineBetween(px1, py1, x1, y1);
                            graphic.lineBetween(px1, py1, x0, y0);
                            graphic.lineBetween(x0, y0, x1, y1);
                            px0 = x0;
                            py0 = y0;
                            px1 = x1;
                            py1 = y1;
                        }
                    },
                    /**
     * Handles the pre-destroy step for the Rope, which removes the Animation component and typed arrays.
     *
     * @method Phaser.GameObjects.Rope#preDestroy
     * @private
     * @since 3.23.0
     */ preDestroy: function() {
                        this.anims.destroy();
                        this.anims = undefined;
                        this.points = null;
                        this.vertices = null;
                        this.uv = null;
                        this.colors = null;
                        this.alphas = null;
                        this.debugCallback = null;
                        this.debugGraphic = null;
                    },
                    /**
     * The horizontally flipped state of the Game Object.
     *
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Rope#flipX
     * @type {boolean}
     * @default false
     * @since 3.23.0
     */ flipX: {
                        get: function() {
                            return this._flipX;
                        },
                        set: function(value) {
                            this._flipX = value;
                            return this.updateUVs();
                        }
                    },
                    /**
     * The vertically flipped state of the Game Object.
     *
     * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Rope#flipY
     * @type {boolean}
     * @default false
     * @since 3.23.0
     */ flipY: {
                        get: function() {
                            return this._flipY;
                        },
                        set: function(value) {
                            this._flipY = value;
                            return this.updateUVs();
                        }
                    }
                });
                module1.exports = Rope;
            /***/ },
            /***/ 95262: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Rope.Render. There is no Canvas renderer for Rope objects.
 *
 * @method Phaser.GameObjects.Rope#renderCanvas
 * @since 3.23.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Rope} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var RopeCanvasRenderer = function() {};
                module1.exports = RopeCanvasRenderer;
            /***/ },
            /***/ 26209: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetValue = __webpack_require__(35154);
                var Rope = __webpack_require__(77757);
                /**
 * Creates a new Rope Game Object and returns it.
 *
 * Note: This method will only be available if the Rope Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#rope
 * @since 3.23.0
 *
 * @param {Phaser.Types.GameObjects.Rope.RopeConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Rope} The Game Object that was created.
 */ GameObjectCreator.register('rope', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var frame = GetAdvancedValue(config, 'frame', null);
                    var horizontal = GetAdvancedValue(config, 'horizontal', true);
                    var points = GetValue(config, 'points', undefined);
                    var colors = GetValue(config, 'colors', undefined);
                    var alphas = GetValue(config, 'alphas', undefined);
                    var rope = new Rope(this.scene, 0, 0, key, frame, points, horizontal, colors, alphas);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, rope, config);
                    return rope;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 96819: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rope = __webpack_require__(77757);
                var GameObjectFactory = __webpack_require__(39429);
                GameObjectFactory.register('rope', function(x, y, texture, frame, points, horizontal, colors, alphas) {
                    return this.displayList.add(new Rope(this.scene, x, y, texture, frame, points, horizontal, colors, alphas));
                });
            /***/ },
            /***/ 38745: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(20439);
                renderCanvas = __webpack_require__(95262);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 20439: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rope#renderWebGL
 * @since 3.23.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Rope} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RopeWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    var vertices = src.vertices;
                    var uvs = src.uv;
                    var colors = src.colors;
                    var alphas = src.alphas;
                    var alpha = src.alpha;
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var roundPixels = camera.roundPixels;
                    var meshVerticesLength = vertices.length;
                    var vertexCount = Math.floor(meshVerticesLength * 0.5);
                    //  Because it's a triangle strip and we don't want lots of degenerate triangles joining things up
                    pipeline.flush();
                    renderer.pipelines.preBatch(src);
                    var textureUnit = pipeline.setGameObject(src);
                    var vertexViewF32 = pipeline.vertexViewF32;
                    var vertexViewU32 = pipeline.vertexViewU32;
                    var vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                    var colorIndex = 0;
                    var tintEffect = src.tintFill;
                    if (src.dirty) src.updateVertices();
                    var debugCallback = src.debugCallback;
                    var debugVerts = [];
                    for(var i = 0; i < meshVerticesLength; i += 2){
                        var x = vertices[i + 0];
                        var y = vertices[i + 1];
                        var tx = x * calcMatrix.a + y * calcMatrix.c + calcMatrix.e;
                        var ty = x * calcMatrix.b + y * calcMatrix.d + calcMatrix.f;
                        if (roundPixels) {
                            tx = Math.round(tx);
                            ty = Math.round(ty);
                        }
                        vertexViewF32[++vertexOffset] = tx;
                        vertexViewF32[++vertexOffset] = ty;
                        vertexViewF32[++vertexOffset] = uvs[i + 0];
                        vertexViewF32[++vertexOffset] = uvs[i + 1];
                        vertexViewF32[++vertexOffset] = textureUnit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = getTint(colors[colorIndex], camera.alpha * (alphas[colorIndex] * alpha));
                        colorIndex++;
                        if (debugCallback) {
                            debugVerts[i + 0] = tx;
                            debugVerts[i + 1] = ty;
                        }
                    }
                    if (debugCallback) debugCallback.call(src, src, meshVerticesLength, debugVerts);
                    pipeline.vertexCount += vertexCount;
                    pipeline.currentBatch.count = pipeline.vertexCount - pipeline.currentBatch.start;
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = RopeWebGLRenderer;
            /***/ },
            /***/ 20071: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var GetFastValue = __webpack_require__(95540);
                var Extend = __webpack_require__(79291);
                var SetValue = __webpack_require__(61622);
                var ShaderRender = __webpack_require__(25479);
                var TransformMatrix = __webpack_require__(61340);
                var ArrayEach = __webpack_require__(95428);
                var RenderEvents = __webpack_require__(92503);
                /**
 * @classdesc
 * A Shader Game Object.
 *
 * This Game Object allows you to easily add a quad with its own shader into the display list, and manipulate it
 * as you would any other Game Object, including scaling, rotating, positioning and adding to Containers. Shaders
 * can be masked with either Bitmap or Geometry masks and can also be used as a Bitmap Mask for a Camera or other
 * Game Object. They can also be made interactive and used for input events.
 *
 * It works by taking a reference to a `Phaser.Display.BaseShader` instance, as found in the Shader Cache. These can
 * be created dynamically at runtime, or loaded in via the GLSL File Loader:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.glsl('fire', 'shaders/fire.glsl.js');
 * }
 *
 * function create ()
 * {
 *     this.add.shader('fire', 400, 300, 512, 512);
 * }
 * ```
 *
 * Please see the Phaser 3 Examples GitHub repo for examples of loading and creating shaders dynamically.
 *
 * Due to the way in which they work, you cannot directly change the alpha or blend mode of a Shader. This should
 * be handled via exposed uniforms in the shader code itself.
 *
 * By default a Shader will be created with a standard set of uniforms. These were added to match those
 * found on sites such as ShaderToy or GLSLSandbox, and provide common functionality a shader may need,
 * such as the timestamp, resolution or pointer position. You can replace them by specifying your own uniforms
 * in the Base Shader.
 *
 * These Shaders work by halting the current pipeline during rendering, creating a viewport matched to the
 * size of this Game Object and then renders a quad using the bound shader. At the end, the pipeline is restored.
 *
 * Because it blocks the pipeline it means it will interrupt any batching that is currently going on, so you should
 * use these Game Objects sparingly. If you need to have a fully batched custom shader, then please look at using
 * a custom pipeline instead. However, for background or special masking effects, they are extremely effective.
 *
 * @class Shader
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.17.0
 *
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {(string|Phaser.Display.BaseShader)} key - The key of the shader to use from the shader cache, or a BaseShader instance.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the Game Object.
 * @param {number} [height=128] - The height of the Game Object.
 * @param {string[]} [textures] - Optional array of texture keys to bind to the iChannel0...3 uniforms. The textures must already exist in the Texture Manager.
 * @param {any} [textureData] - Additional texture data if you want to create shader with none NPOT textures.
 */ var Shader = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.ComputedSize,
                        Components.Depth,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.ScrollFactor,
                        Components.Transform,
                        Components.Visible,
                        ShaderRender
                    ],
                    initialize: function Shader(scene, key, x, y, width, height, textures, textureData) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 128;
                        if (height === undefined) height = 128;
                        GameObject.call(this, scene, 'Shader');
                        /**
         * This Game Object cannot have a blend mode, so skip all checks.
         *
         * @name Phaser.GameObjects.Shader#blendMode
         * @type {number}
         * @private
         * @since 3.17.0
         */ this.blendMode = -1;
                        /**
         * The underlying shader object being used.
         * Empty by default and set during a call to the `setShader` method.
         *
         * @name Phaser.GameObjects.Shader#shader
         * @type {Phaser.Display.BaseShader}
         * @since 3.17.0
         */ this.shader;
                        var renderer = scene.sys.renderer;
                        /**
         * A reference to the current renderer.
         * Shaders only work with the WebGL Renderer.
         *
         * @name Phaser.GameObjects.Shader#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.17.0
         */ this.renderer = renderer;
                        /**
         * The WebGL context belonging to the renderer.
         *
         * @name Phaser.GameObjects.Shader#gl
         * @type {WebGLRenderingContext}
         * @since 3.17.0
         */ this.gl = renderer.gl;
                        /**
         * Raw byte buffer of vertices this Shader uses.
         *
         * @name Phaser.GameObjects.Shader#vertexData
         * @type {ArrayBuffer}
         * @since 3.17.0
         */ this.vertexData = new ArrayBuffer(6 * (Float32Array.BYTES_PER_ELEMENT * 2));
                        /**
         * The WebGL vertex buffer object this shader uses.
         *
         * @name Phaser.GameObjects.Shader#vertexBuffer
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper}
         * @since 3.17.0
         */ this.vertexBuffer = renderer.createVertexBuffer(this.vertexData.byteLength, this.gl.STREAM_DRAW);
                        /**
         * Internal property: whether the shader needs to be created,
         * and if so, the key and textures to use for the shader.
         *
         * @name Phaser.GameObjects.Shader#_deferSetShader
         * @type {?{ key: string, textures: string[]|undefined, textureData: any|undefined }}
         * @private
         * @since 3.80.0
         */ this._deferSetShader = null;
                        /**
         * Internal property: whether the projection matrix needs to be set,
         * and if so, the data to use for the orthographic projection.
         *
         * @name Phaser.GameObjects.Shader#_deferProjOrtho
         * @type {?{ left: number, right: number, bottom: number, top: number }}
         * @private
         * @since 3.80.0
         */ this._deferProjOrtho = null;
                        /**
         * The WebGL shader program this shader uses.
         *
         * @name Phaser.GameObjects.Shader#program
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper}
         * @since 3.17.0
         */ this.program = null;
                        /**
         * Uint8 view to the vertex raw buffer. Used for uploading vertex buffer resources to the GPU.
         *
         * @name Phaser.GameObjects.Shader#bytes
         * @type {Uint8Array}
         * @since 3.17.0
         */ this.bytes = new Uint8Array(this.vertexData);
                        /**
         * Float32 view of the array buffer containing the shaders vertices.
         *
         * @name Phaser.GameObjects.Shader#vertexViewF32
         * @type {Float32Array}
         * @since 3.17.0
         */ this.vertexViewF32 = new Float32Array(this.vertexData);
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix1 = new TransformMatrix();
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix2 = new TransformMatrix();
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix3 = new TransformMatrix();
                        /**
         * The view matrix the shader uses during rendering.
         *
         * @name Phaser.GameObjects.Shader#viewMatrix
         * @type {Float32Array}
         * @readonly
         * @since 3.17.0
         */ this.viewMatrix = new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]);
                        /**
         * The projection matrix the shader uses during rendering.
         *
         * @name Phaser.GameObjects.Shader#projectionMatrix
         * @type {Float32Array}
         * @readonly
         * @since 3.17.0
         */ this.projectionMatrix = new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]);
                        /**
         * The default uniform mappings. These can be added to (or replaced) by specifying your own uniforms when
         * creating this shader game object. The uniforms are updated automatically during the render step.
         *
         * The defaults are:
         *
         * `resolution` (2f) - Set to the size of this shader.
         * `time` (1f) - The elapsed game time, in seconds.
         * `mouse` (2f) - If a pointer has been bound (with `setPointer`), this uniform contains its position each frame.
         * `date` (4fv) - A vec4 containing the year, month, day and time in seconds.
         * `sampleRate` (1f) - Sound sample rate. 44100 by default.
         * `iChannel0...3` (sampler2D) - Input channels 0 to 3. `null` by default.
         *
         * @name Phaser.GameObjects.Shader#uniforms
         * @type {any}
         * @since 3.17.0
         */ this.uniforms = {};
                        /**
         * The pointer bound to this shader, if any.
         * Set via the chainable `setPointer` method, or by modifying this property directly.
         *
         * @name Phaser.GameObjects.Shader#pointer
         * @type {Phaser.Input.Pointer}
         * @since 3.17.0
         */ this.pointer = null;
                        /**
         * The cached width of the renderer.
         *
         * @name Phaser.GameObjects.Shader#_rendererWidth
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._rendererWidth = renderer.width;
                        /**
         * The cached height of the renderer.
         *
         * @name Phaser.GameObjects.Shader#_rendererHeight
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._rendererHeight = renderer.height;
                        /**
         * Internal texture count tracker.
         *
         * @name Phaser.GameObjects.Shader#_textureCount
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._textureCount = 0;
                        /**
         * A reference to the GL Frame Buffer this Shader is drawing to.
         * This property is only set if you have called `Shader.setRenderToTexture`.
         *
         * @name Phaser.GameObjects.Shader#framebuffer
         * @type {?Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper}
         * @since 3.19.0
         */ this.framebuffer = null;
                        /**
         * A reference to the WebGLTextureWrapper this Shader is rendering to.
         * This property is only set if you have called `Shader.setRenderToTexture`.
         *
         * @name Phaser.GameObjects.Shader#glTexture
         * @type {?Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @since 3.19.0
         */ this.glTexture = null;
                        /**
         * A flag that indicates if this Shader has been set to render to a texture instead of the display list.
         *
         * This property is `true` if you have called `Shader.setRenderToTexture`, otherwise it's `false`.
         *
         * A Shader that is rendering to a texture _does not_ appear on the display list.
         *
         * @name Phaser.GameObjects.Shader#renderToTexture
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.renderToTexture = false;
                        /**
         * A reference to the Phaser.Textures.Texture that has been stored in the Texture Manager for this Shader.
         *
         * This property is only set if you have called `Shader.setRenderToTexture` with a key, otherwise it is `null`.
         *
         * @name Phaser.GameObjects.Shader#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.19.0
         */ this.texture = null;
                        this.setPosition(x, y);
                        this.setSize(width, height);
                        this.setOrigin(0.5, 0.5);
                        this.setShader(key, textures, textureData);
                        this.renderer.on(RenderEvents.RESTORE_WEBGL, this.onContextRestored, this);
                    },
                    /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Shader#willRender
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                        if (this.renderToTexture) return true;
                        else return !(GameObject.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                    },
                    /**
     * Changes this Shader so instead of rendering to the display list it renders to a
     * WebGL Framebuffer and WebGL Texture instead. This allows you to use the output
     * of this shader as an input for another shader, by mapping a sampler2D uniform
     * to it.
     *
     * After calling this method the `Shader.framebuffer` and `Shader.glTexture` properties
     * are populated.
     *
     * Additionally, you can provide a key to this method. Doing so will create a Phaser Texture
     * from this Shader and save it into the Texture Manager, allowing you to then use it for
     * any texture-based Game Object, such as a Sprite or Image:
     *
     * ```javascript
     * var shader = this.add.shader('myShader', x, y, width, height);
     *
     * shader.setRenderToTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Note that it stores an active reference to this Shader. That means as this shader updates,
     * so does the texture and any object using it to render with. Also, if you destroy this
     * shader, be sure to clear any objects that may have been using it as a texture too.
     *
     * You can access the Phaser Texture that is created via the `Shader.texture` property.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame from a Render Texture.
     *
     * @method Phaser.GameObjects.Shader#setRenderToTexture
     * @since 3.19.0
     *
     * @param {string} [key] - The unique key to store the texture as within the global Texture Manager.
     * @param {boolean} [flipY=false] - Does this texture need vertically flipping before rendering? This should usually be set to `true` if being fed from a buffer.
     *
     * @return {this} This Shader instance.
     */ setRenderToTexture: function(key, flipY) {
                        if (flipY === undefined) flipY = false;
                        if (!this.renderToTexture) {
                            var width = this.width;
                            var height = this.height;
                            var renderer = this.renderer;
                            this.glTexture = renderer.createTextureFromSource(null, width, height, 0);
                            this.framebuffer = renderer.createFramebuffer(width, height, this.glTexture, false);
                            this._rendererWidth = width;
                            this._rendererHeight = height;
                            this.renderToTexture = true;
                            this.projOrtho(0, this.width, this.height, 0);
                            if (key) this.texture = this.scene.sys.textures.addGLTexture(key, this.glTexture);
                        }
                        //  And now render at least once, so our texture isn't blank on the first update
                        if (this.shader) {
                            renderer.pipelines.clear();
                            this.load();
                            this.flush();
                            renderer.pipelines.rebind();
                        }
                        return this;
                    },
                    /**
     * Sets the fragment and, optionally, the vertex shader source code that this Shader will use.
     * This will immediately delete the active shader program, if set, and then create a new one
     * with the given source. Finally, the shader uniforms are initialized.
     *
     * @method Phaser.GameObjects.Shader#setShader
     * @since 3.17.0
     *
     * @param {(string|Phaser.Display.BaseShader)} key - The key of the shader to use from the shader cache, or a BaseShader instance.
     * @param {string[]} [textures] - Optional array of texture keys to bind to the iChannel0...3 uniforms. The textures must already exist in the Texture Manager.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setShader: function(key, textures, textureData) {
                        if (this.renderer.contextLost) {
                            this._deferSetShader = {
                                key: key,
                                textures: textures,
                                textureData: textureData
                            };
                            return this;
                        }
                        if (textures === undefined) textures = [];
                        if (typeof key === 'string') {
                            var cache = this.scene.sys.cache.shader;
                            if (!cache.has(key)) {
                                console.warn('Shader missing: ' + key);
                                return this;
                            }
                            this.shader = cache.get(key);
                        } else this.shader = key;
                        var gl = this.gl;
                        var renderer = this.renderer;
                        if (this.program) renderer.deleteProgram(this.program);
                        var program = renderer.createProgram(this.shader.vertexSrc, this.shader.fragmentSrc);
                        //  The default uniforms available within the vertex shader
                        gl.uniformMatrix4fv(gl.getUniformLocation(program.webGLProgram, 'uViewMatrix'), false, this.viewMatrix);
                        gl.uniformMatrix4fv(gl.getUniformLocation(program.webGLProgram, 'uProjectionMatrix'), false, this.projectionMatrix);
                        gl.uniform2f(gl.getUniformLocation(program.webGLProgram, 'uResolution'), this.width, this.height);
                        this.program = program;
                        var d = new Date();
                        //  The default uniforms available within the fragment shader
                        var defaultUniforms = {
                            resolution: {
                                type: '2f',
                                value: {
                                    x: this.width,
                                    y: this.height
                                }
                            },
                            time: {
                                type: '1f',
                                value: 0
                            },
                            mouse: {
                                type: '2f',
                                value: {
                                    x: this.width / 2,
                                    y: this.height / 2
                                }
                            },
                            date: {
                                type: '4fv',
                                value: [
                                    d.getFullYear(),
                                    d.getMonth(),
                                    d.getDate(),
                                    d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds()
                                ]
                            },
                            sampleRate: {
                                type: '1f',
                                value: 44100.0
                            },
                            iChannel0: {
                                type: 'sampler2D',
                                value: null,
                                textureData: {
                                    repeat: true
                                }
                            },
                            iChannel1: {
                                type: 'sampler2D',
                                value: null,
                                textureData: {
                                    repeat: true
                                }
                            },
                            iChannel2: {
                                type: 'sampler2D',
                                value: null,
                                textureData: {
                                    repeat: true
                                }
                            },
                            iChannel3: {
                                type: 'sampler2D',
                                value: null,
                                textureData: {
                                    repeat: true
                                }
                            }
                        };
                        if (this.shader.uniforms) this.uniforms = Extend(true, {}, this.shader.uniforms, defaultUniforms);
                        else this.uniforms = defaultUniforms;
                        for(var i = 0; i < 4; i++)if (textures[i]) this.setSampler2D('iChannel' + i, textures[i], i, textureData);
                        this.initUniforms();
                        this.projOrtho(0, this._rendererWidth, this._rendererHeight, 0);
                        return this;
                    },
                    /**
     * Binds a Phaser Pointer object to this Shader.
     *
     * The screen position of the pointer will be set in to the shaders `mouse` uniform
     * automatically every frame. Call this method with no arguments to unbind the pointer.
     *
     * @method Phaser.GameObjects.Shader#setPointer
     * @since 3.17.0
     *
     * @param {Phaser.Input.Pointer} [pointer] - The Pointer to bind to this shader.
     *
     * @return {this} This Shader instance.
     */ setPointer: function(pointer) {
                        this.pointer = pointer;
                        return this;
                    },
                    /**
     * Sets this shader to use an orthographic projection matrix.
     * This matrix is stored locally in the `projectionMatrix` property,
     * as well as being bound to the `uProjectionMatrix` uniform.
     *
     * @method Phaser.GameObjects.Shader#projOrtho
     * @since 3.17.0
     *
     * @param {number} left - The left value.
     * @param {number} right - The right value.
     * @param {number} bottom - The bottom value.
     * @param {number} top - The top value.
     */ projOrtho: function(left, right, bottom, top) {
                        if (this.renderer.contextLost) {
                            this._deferProjOrtho = {
                                left: left,
                                right: right,
                                bottom: bottom,
                                top: top
                            };
                            return;
                        }
                        var near = -1000;
                        var far = 1000;
                        var leftRight = 1 / (left - right);
                        var bottomTop = 1 / (bottom - top);
                        var nearFar = 1 / (near - far);
                        var pm = this.projectionMatrix;
                        pm[0] = -2 * leftRight;
                        pm[5] = -2 * bottomTop;
                        pm[10] = 2 * nearFar;
                        pm[12] = (left + right) * leftRight;
                        pm[13] = (top + bottom) * bottomTop;
                        pm[14] = (far + near) * nearFar;
                        var program = this.program;
                        var gl = this.gl;
                        var renderer = this.renderer;
                        renderer.setProgram(program);
                        gl.uniformMatrix4fv(gl.getUniformLocation(program.webGLProgram, 'uProjectionMatrix'), false, this.projectionMatrix);
                        this._rendererWidth = right;
                        this._rendererHeight = bottom;
                    },
                    // Uniforms are specified in the GLSL_ES Specification: http://www.khronos.org/registry/webgl/specs/latest/1.0/
                    // http://www.khronos.org/registry/gles/specs/2.0/GLSL_ES_Specification_1.0.17.pdf
                    /**
     * Initializes all of the uniforms this shader uses.
     *
     * @method Phaser.GameObjects.Shader#initUniforms
     * @private
     * @since 3.17.0
     */ initUniforms: function() {
                        var map = this.renderer.glFuncMap;
                        var program = this.program;
                        this._textureCount = 0;
                        for(var key in this.uniforms){
                            var uniform = this.uniforms[key];
                            var type = uniform.type;
                            var data = map[type];
                            uniform.uniformLocation = this.renderer.createUniformLocation(program, key);
                            if (type !== 'sampler2D') {
                                uniform.glMatrix = data.matrix;
                                uniform.glValueLength = data.length;
                                uniform.glFunc = data.func;
                            }
                        }
                    },
                    /**
     * Sets a sampler2D uniform on this shader where the source texture is a WebGLTextureBuffer.
     *
     * This allows you to feed the output from one Shader into another:
     *
     * ```javascript
     * let shader1 = this.add.shader(baseShader1, 0, 0, 512, 512).setRenderToTexture();
     * let shader2 = this.add.shader(baseShader2, 0, 0, 512, 512).setRenderToTexture('output');
     *
     * shader1.setSampler2DBuffer('iChannel0', shader2.glTexture, 512, 512);
     * shader2.setSampler2DBuffer('iChannel0', shader1.glTexture, 512, 512);
     * ```
     *
     * In the above code, the result of baseShader1 is fed into Shader2 as the `iChannel0` sampler2D uniform.
     * The result of baseShader2 is then fed back into shader1 again, creating a feedback loop.
     *
     * If you wish to use an image from the Texture Manager as a sampler2D input for this shader,
     * see the `Shader.setSampler2D` method.
     *
     * @method Phaser.GameObjects.Shader#setSampler2DBuffer
     * @since 3.19.0
     *
     * @param {string} uniformKey - The key of the sampler2D uniform to be updated, i.e. `iChannel0`.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - A texture reference.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {number} [textureIndex=0] - The texture index.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setSampler2DBuffer: function(uniformKey, texture, width, height, textureIndex, textureData) {
                        if (textureIndex === undefined) textureIndex = 0;
                        if (textureData === undefined) textureData = {};
                        var uniform = this.uniforms[uniformKey];
                        uniform.value = texture;
                        textureData.width = width;
                        textureData.height = height;
                        uniform.textureData = textureData;
                        this._textureCount = textureIndex;
                        this.initSampler2D(uniform);
                        return this;
                    },
                    /**
     * Sets a sampler2D uniform on this shader.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * If you wish to use another Shader as a sampler2D input for this shader, see the `Shader.setSampler2DBuffer` method.
     *
     * @method Phaser.GameObjects.Shader#setSampler2D
     * @since 3.17.0
     *
     * @param {string} uniformKey - The key of the sampler2D uniform to be updated, i.e. `iChannel0`.
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {number} [textureIndex=0] - The texture index.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setSampler2D: function(uniformKey, textureKey, textureIndex, textureData) {
                        if (textureIndex === undefined) textureIndex = 0;
                        var textureManager = this.scene.sys.textures;
                        if (textureManager.exists(textureKey)) {
                            var frame = textureManager.getFrame(textureKey);
                            if (frame.glTexture && frame.glTexture.isRenderTexture) return this.setSampler2DBuffer(uniformKey, frame.glTexture, frame.width, frame.height, textureIndex, textureData);
                            var uniform = this.uniforms[uniformKey];
                            var source = frame.source;
                            uniform.textureKey = textureKey;
                            uniform.source = source.image;
                            uniform.value = frame.glTexture;
                            if (source.isGLTexture) {
                                if (!textureData) textureData = {};
                                textureData.width = source.width;
                                textureData.height = source.height;
                            }
                            if (textureData) uniform.textureData = textureData;
                            this._textureCount = textureIndex;
                            this.initSampler2D(uniform);
                        }
                        return this;
                    },
                    /**
     * Sets a property of a uniform already present on this shader.
     *
     * To modify the value of a uniform such as a 1f or 1i use the `value` property directly:
     *
     * ```javascript
     * shader.setUniform('size.value', 16);
     * ```
     *
     * You can use dot notation to access deeper values, for example:
     *
     * ```javascript
     * shader.setUniform('resolution.value.x', 512);
     * ```
     *
     * The change to the uniform will take effect the next time the shader is rendered.
     *
     * @method Phaser.GameObjects.Shader#setUniform
     * @since 3.17.0
     *
     * @param {string} key - The key of the uniform to modify. Use dots for deep properties, i.e. `resolution.value.x`.
     * @param {any} value - The value to set into the uniform.
     *
     * @return {this} This Shader instance.
     */ setUniform: function(key, value) {
                        SetValue(this.uniforms, key, value);
                        return this;
                    },
                    /**
     * Returns the uniform object for the given key, or `null` if the uniform couldn't be found.
     *
     * @method Phaser.GameObjects.Shader#getUniform
     * @since 3.17.0
     *
     * @param {string} key - The key of the uniform to return the value for.
     *
     * @return {any} A reference to the uniform object. This is not a copy, so modifying it will update the original object also.
     */ getUniform: function(key) {
                        return GetFastValue(this.uniforms, key, null);
                    },
                    /**
     * A short-cut method that will directly set the texture being used by the `iChannel0` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel0
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel0: function(textureKey, textureData) {
                        return this.setSampler2D('iChannel0', textureKey, 0, textureData);
                    },
                    /**
     * A short-cut method that will directly set the texture being used by the `iChannel1` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel1
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel1: function(textureKey, textureData) {
                        return this.setSampler2D('iChannel1', textureKey, 1, textureData);
                    },
                    /**
     * A short-cut method that will directly set the texture being used by the `iChannel2` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel2
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel2: function(textureKey, textureData) {
                        return this.setSampler2D('iChannel2', textureKey, 2, textureData);
                    },
                    /**
     * A short-cut method that will directly set the texture being used by the `iChannel3` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel3
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel3: function(textureKey, textureData) {
                        return this.setSampler2D('iChannel3', textureKey, 3, textureData);
                    },
                    /**
     * Internal method that takes a sampler2D uniform and prepares it for use by setting the
     * gl texture parameters.
     *
     * @method Phaser.GameObjects.Shader#initSampler2D
     * @private
     * @since 3.17.0
     *
     * @param {any} uniform - The sampler2D uniform to process.
     */ initSampler2D: function(uniform) {
                        if (!uniform.value) return;
                        //  Extended texture data
                        var data = uniform.textureData;
                        if (data && !uniform.value.isRenderTexture) {
                            var gl = this.gl;
                            var wrapper = uniform.value;
                            // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/texImage2D
                            //  mag / minFilter can be: gl.LINEAR, gl.LINEAR_MIPMAP_LINEAR or gl.NEAREST
                            //  wrapS/T can be: gl.CLAMP_TO_EDGE or gl.REPEAT
                            //  format can be: gl.LUMINANCE or gl.RGBA
                            var magFilter = gl[GetFastValue(data, 'magFilter', 'linear').toUpperCase()];
                            var minFilter = gl[GetFastValue(data, 'minFilter', 'linear').toUpperCase()];
                            var wrapS = gl[GetFastValue(data, 'wrapS', 'repeat').toUpperCase()];
                            var wrapT = gl[GetFastValue(data, 'wrapT', 'repeat').toUpperCase()];
                            var format = gl[GetFastValue(data, 'format', 'rgba').toUpperCase()];
                            var flipY = GetFastValue(data, 'flipY', false);
                            var width = GetFastValue(data, 'width', wrapper.width);
                            var height = GetFastValue(data, 'height', wrapper.height);
                            var source = GetFastValue(data, 'source', wrapper.pixels);
                            if (data.repeat) {
                                wrapS = gl.REPEAT;
                                wrapT = gl.REPEAT;
                            }
                            if (data.width) // If the uniform has resolution, use a blank texture.
                            source = null;
                            wrapper.update(source, width, height, flipY, wrapS, wrapT, minFilter, magFilter, format);
                        }
                        this.renderer.setProgram(this.program);
                        this._textureCount++;
                    },
                    /**
     * Synchronizes all of the uniforms this shader uses.
     * Each uniforms gl function is called in turn.
     *
     * @method Phaser.GameObjects.Shader#syncUniforms
     * @private
     * @since 3.17.0
     */ syncUniforms: function() {
                        var gl = this.gl;
                        var uniforms = this.uniforms;
                        var uniform;
                        var length;
                        var glFunc;
                        var location;
                        var value;
                        var textureCount = 0;
                        for(var key in uniforms){
                            uniform = uniforms[key];
                            glFunc = uniform.glFunc;
                            length = uniform.glValueLength;
                            location = uniform.uniformLocation;
                            value = uniform.value;
                            if (value === null) continue;
                            if (length === 1) {
                                if (uniform.glMatrix) glFunc.call(gl, location.webGLUniformLocation, uniform.transpose, value);
                                else glFunc.call(gl, location.webGLUniformLocation, value);
                            } else if (length === 2) glFunc.call(gl, location.webGLUniformLocation, value.x, value.y);
                            else if (length === 3) glFunc.call(gl, location.webGLUniformLocation, value.x, value.y, value.z);
                            else if (length === 4) glFunc.call(gl, location.webGLUniformLocation, value.x, value.y, value.z, value.w);
                            else if (uniform.type === 'sampler2D') {
                                gl.activeTexture(gl.TEXTURE0 + textureCount);
                                gl.bindTexture(gl.TEXTURE_2D, value.webGLTexture);
                                gl.uniform1i(location.webGLUniformLocation, textureCount);
                                textureCount++;
                            }
                        }
                    },
                    /**
     * Called automatically during render.
     *
     * This method performs matrix ITRS and then stores the resulting value in the `uViewMatrix` uniform.
     * It then sets up the vertex buffer and shader, updates and syncs the uniforms ready
     * for flush to be called.
     *
     * @method Phaser.GameObjects.Shader#load
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [matrix2D] - The transform matrix to use during rendering.
     */ load: function(matrix2D) {
                        //  ITRS
                        var gl = this.gl;
                        var width = this.width;
                        var height = this.height;
                        var renderer = this.renderer;
                        var program = this.program;
                        var vm = this.viewMatrix;
                        if (!this.renderToTexture) {
                            var x = -this._displayOriginX;
                            var y = -this._displayOriginY;
                            vm[0] = matrix2D[0];
                            vm[1] = matrix2D[1];
                            vm[4] = matrix2D[2];
                            vm[5] = matrix2D[3];
                            vm[8] = matrix2D[4];
                            vm[9] = matrix2D[5];
                            vm[12] = vm[0] * x + vm[4] * y;
                            vm[13] = vm[1] * x + vm[5] * y;
                        }
                        //  Update vertex shader uniforms
                        gl.useProgram(program.webGLProgram);
                        gl.uniformMatrix4fv(gl.getUniformLocation(program.webGLProgram, 'uViewMatrix'), false, vm);
                        gl.uniformMatrix4fv(gl.getUniformLocation(program.webGLProgram, 'uProjectionMatrix'), false, this.projectionMatrix);
                        gl.uniform2f(gl.getUniformLocation(program.webGLProgram, 'uResolution'), this.width, this.height);
                        //  Update fragment shader uniforms
                        var uniforms = this.uniforms;
                        var res = uniforms.resolution;
                        res.value.x = width;
                        res.value.y = height;
                        uniforms.time.value = renderer.game.loop.getDuration();
                        var pointer = this.pointer;
                        if (pointer) {
                            var mouse = uniforms.mouse;
                            var px = pointer.x / width;
                            var py = 1 - pointer.y / height;
                            mouse.value.x = px.toFixed(2);
                            mouse.value.y = py.toFixed(2);
                        }
                        this.syncUniforms();
                    },
                    /**
     * Called automatically during render.
     *
     * Sets the active shader, loads the vertex buffer and then draws.
     *
     * @method Phaser.GameObjects.Shader#flush
     * @since 3.17.0
     */ flush: function() {
                        //  Bind
                        var width = this.width;
                        var height = this.height;
                        var program = this.program;
                        var gl = this.gl;
                        var vertexBuffer = this.vertexBuffer;
                        var renderer = this.renderer;
                        var vertexSize = Float32Array.BYTES_PER_ELEMENT * 2;
                        if (this.renderToTexture) {
                            renderer.setFramebuffer(this.framebuffer);
                            gl.clearColor(0, 0, 0, 0);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                        gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer.webGLBuffer);
                        var location = gl.getAttribLocation(program.webGLProgram, 'inPosition');
                        if (location !== -1) {
                            gl.enableVertexAttribArray(location);
                            gl.vertexAttribPointer(location, 2, gl.FLOAT, false, vertexSize, 0);
                        }
                        //  Draw
                        var vf = this.vertexViewF32;
                        vf[3] = height;
                        vf[4] = width;
                        vf[5] = height;
                        vf[8] = width;
                        vf[9] = height;
                        vf[10] = width;
                        //  Flush
                        var vertexCount = 6;
                        gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
                        gl.drawArrays(gl.TRIANGLES, 0, vertexCount);
                        if (this.renderToTexture) renderer.setFramebuffer(null, false);
                    },
                    /**
     * A NOOP method so you can pass a Shader to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Shader#setAlpha
     * @private
     * @since 3.17.0
     */ setAlpha: function() {},
                    /**
     * A NOOP method so you can pass a Shader to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Shader#setBlendMode
     * @private
     * @since 3.17.0
     */ setBlendMode: function() {},
                    /**
     * Run any logic that was deferred during context loss.
     * 
     * @method Phaser.GameObjects.Shader#onContextRestored
     * @since 3.80.0
     */ onContextRestored: function() {
                        if (this._deferSetShader !== null) {
                            var key = this._deferSetShader.key;
                            var textures = this._deferSetShader.textures;
                            var textureData = this._deferSetShader.textureData;
                            this._deferSetShader = null;
                            this.setShader(key, textures, textureData);
                        }
                        if (this._deferProjOrtho !== null) {
                            var left = this._deferProjOrtho.left;
                            var right = this._deferProjOrtho.right;
                            var bottom = this._deferProjOrtho.bottom;
                            var top = this._deferProjOrtho.top;
                            this._deferProjOrtho = null;
                            this.projOrtho(left, right, bottom, top);
                        }
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Shader#preDestroy
     * @protected
     * @since 3.17.0
     */ preDestroy: function() {
                        var renderer = this.renderer;
                        renderer.off(RenderEvents.RESTORE_WEBGL, this.onContextRestored, this);
                        renderer.deleteProgram(this.program);
                        renderer.deleteBuffer(this.vertexBuffer);
                        if (this.renderToTexture) {
                            renderer.deleteFramebuffer(this.framebuffer);
                            this.texture.destroy();
                            this.framebuffer = null;
                            this.glTexture = null;
                            this.texture = null;
                        }
                        ArrayEach(this.uniforms, function(uniform) {
                            renderer.deleteUniformLocation(uniform.uniformLocation);
                            uniform.uniformLocation = null;
                        });
                    }
                });
                module1.exports = Shader;
            /***/ },
            /***/ 80464: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Shader.Render. There is no Canvas renderer for Shader objects.
 *
 * @method Phaser.GameObjects.Shader#renderCanvas
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Shader} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var ShaderCanvasRenderer = function() {};
                module1.exports = ShaderCanvasRenderer;
            /***/ },
            /***/ 54935: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var Shader = __webpack_require__(20071);
                /**
 * Creates a new Shader Game Object and returns it.
 *
 * Note: This method will only be available if the Shader Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#shader
 * @since 3.17.0
 *
 * @param {Phaser.Types.GameObjects.Shader.ShaderConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Shader} The Game Object that was created.
 */ GameObjectCreator.register('shader', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var x = GetAdvancedValue(config, 'x', 0);
                    var y = GetAdvancedValue(config, 'y', 0);
                    var width = GetAdvancedValue(config, 'width', 128);
                    var height = GetAdvancedValue(config, 'height', 128);
                    var shader = new Shader(this.scene, key, x, y, width, height);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, shader, config);
                    return shader;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 74177: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Shader = __webpack_require__(20071);
                var GameObjectFactory = __webpack_require__(39429);
                GameObjectFactory.register('shader', function(key, x, y, width, height, textures, textureData) {
                    return this.displayList.add(new Shader(this.scene, key, x, y, width, height, textures, textureData));
                });
            /***/ },
            /***/ 25479: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(19257);
                renderCanvas = __webpack_require__(80464);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 19257: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Shader#renderWebGL
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Shader} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ShaderWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    if (!src.shader) return;
                    camera.addToRenderList(src);
                    renderer.pipelines.clear();
                    if (src.renderToTexture) {
                        src.load();
                        src.flush();
                    } else {
                        var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                        //  Renderer size changed?
                        if (renderer.width !== src._rendererWidth || renderer.height !== src._rendererHeight) src.projOrtho(0, renderer.width, renderer.height, 0);
                        src.load(calcMatrix.matrix);
                        src.flush();
                    }
                    renderer.pipelines.rebind();
                };
                module1.exports = ShaderWebGLRenderer;
            /***/ },
            /***/ 10441: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(70554);
                /**
 * Renders a filled path for the given Shape.
 *
 * @method Phaser.GameObjects.Shape#FillPathWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGL Pipeline used to render this Shape.
 * @param {Phaser.GameObjects.Components.TransformMatrix} calcMatrix - The transform matrix used to get the position values.
 * @param {Phaser.GameObjects.Shape} src - The Game Object shape being rendered in this call.
 * @param {number} alpha - The base alpha value.
 * @param {number} dx - The source displayOriginX.
 * @param {number} dy - The source displayOriginY.
 */ var FillPathWebGL = function(pipeline, calcMatrix, src, alpha, dx, dy) {
                    var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                    var path = src.pathData;
                    var pathIndexes = src.pathIndexes;
                    for(var i = 0; i < pathIndexes.length; i += 3){
                        var p0 = pathIndexes[i] * 2;
                        var p1 = pathIndexes[i + 1] * 2;
                        var p2 = pathIndexes[i + 2] * 2;
                        var x0 = path[p0 + 0] - dx;
                        var y0 = path[p0 + 1] - dy;
                        var x1 = path[p1 + 0] - dx;
                        var y1 = path[p1 + 1] - dy;
                        var x2 = path[p2 + 0] - dx;
                        var y2 = path[p2 + 1] - dy;
                        var tx0 = calcMatrix.getX(x0, y0);
                        var ty0 = calcMatrix.getY(x0, y0);
                        var tx1 = calcMatrix.getX(x1, y1);
                        var ty1 = calcMatrix.getY(x1, y1);
                        var tx2 = calcMatrix.getX(x2, y2);
                        var ty2 = calcMatrix.getY(x2, y2);
                        pipeline.batchTri(src, tx0, ty0, tx1, ty1, tx2, ty2, 0, 0, 1, 1, fillTintColor, fillTintColor, fillTintColor, 2);
                    }
                };
                module1.exports = FillPathWebGL;
            /***/ },
            /***/ 65960: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the fillStyle on the target context based on the given Shape.
 *
 * @method Phaser.GameObjects.Shape#FillStyleCanvas
 * @since 3.13.0
 * @private
 *
 * @param {CanvasRenderingContext2D} ctx - The context to set the fill style on.
 * @param {Phaser.GameObjects.Shape} src - The Game Object to set the fill style from.
 * @param {number} [altColor] - An alternative color to render with.
 * @param {number} [altAlpha] - An alternative alpha to render with.
 */ var FillStyleCanvas = function(ctx, src, altColor, altAlpha) {
                    var fillColor = altColor ? altColor : src.fillColor;
                    var fillAlpha = altAlpha ? altAlpha : src.fillAlpha;
                    var red = (fillColor & 0xFF0000) >>> 16;
                    var green = (fillColor & 0xFF00) >>> 8;
                    var blue = fillColor & 0xFF;
                    ctx.fillStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + fillAlpha + ')';
                };
                module1.exports = FillStyleCanvas;
            /***/ },
            /***/ 75177: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the strokeStyle and lineWidth on the target context based on the given Shape.
 *
 * @method Phaser.GameObjects.Shape#LineStyleCanvas
 * @since 3.13.0
 * @private
 *
 * @param {CanvasRenderingContext2D} ctx - The context to set the stroke style on.
 * @param {Phaser.GameObjects.Shape} src - The Game Object to set the stroke style from.
 * @param {number} [altColor] - An alternative color to render with.
 * @param {number} [altAlpha] - An alternative alpha to render with.
 */ var LineStyleCanvas = function(ctx, src, altColor, altAlpha) {
                    var strokeColor = altColor ? altColor : src.strokeColor;
                    var strokeAlpha = altAlpha ? altAlpha : src.strokeAlpha;
                    var red = (strokeColor & 0xFF0000) >>> 16;
                    var green = (strokeColor & 0xFF00) >>> 8;
                    var blue = strokeColor & 0xFF;
                    ctx.strokeStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + strokeAlpha + ')';
                    ctx.lineWidth = src.lineWidth;
                };
                module1.exports = LineStyleCanvas;
            /***/ },
            /***/ 17803: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var Line = __webpack_require__(23031);
                /**
 * @classdesc
 * The Shape Game Object is a base class for the various different shapes, such as the Arc, Star or Polygon.
 * You cannot add a Shape directly to your Scene, it is meant as a base for your own custom Shape classes.
 *
 * @class Shape
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {string} [type] - The internal type of the Shape.
 * @param {any} [data] - The data of the source shape geometry, if any.
 */ var Shape = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.AlphaSingle,
                        Components.BlendMode,
                        Components.Depth,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Transform,
                        Components.Visible
                    ],
                    initialize: function Shape(scene, type, data) {
                        if (type === undefined) type = 'Shape';
                        GameObject.call(this, scene, type);
                        /**
         * The source Shape data. Typically a geometry object.
         * You should not manipulate this directly.
         *
         * @name Phaser.GameObjects.Shape#geom
         * @type {any}
         * @readonly
         * @since 3.13.0
         */ this.geom = data;
                        /**
         * Holds the polygon path data for filled rendering.
         *
         * @name Phaser.GameObjects.Shape#pathData
         * @type {number[]}
         * @readonly
         * @since 3.13.0
         */ this.pathData = [];
                        /**
         * Holds the earcut polygon path index data for filled rendering.
         *
         * @name Phaser.GameObjects.Shape#pathIndexes
         * @type {number[]}
         * @readonly
         * @since 3.13.0
         */ this.pathIndexes = [];
                        /**
         * The fill color used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#fillColor
         * @type {number}
         * @since 3.13.0
         */ this.fillColor = 0xffffff;
                        /**
         * The fill alpha value used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#fillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.fillAlpha = 1;
                        /**
         * The stroke color used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#strokeColor
         * @type {number}
         * @since 3.13.0
         */ this.strokeColor = 0xffffff;
                        /**
         * The stroke alpha value used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#strokeAlpha
         * @type {number}
         * @since 3.13.0
         */ this.strokeAlpha = 1;
                        /**
         * The stroke line width used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#lineWidth
         * @type {number}
         * @since 3.13.0
         */ this.lineWidth = 1;
                        /**
         * Controls if this Shape is filled or not.
         * Note that some Shapes do not support being filled (such as Line shapes)
         *
         * @name Phaser.GameObjects.Shape#isFilled
         * @type {boolean}
         * @since 3.13.0
         */ this.isFilled = false;
                        /**
         * Controls if this Shape is stroked or not.
         * Note that some Shapes do not support being stroked (such as Iso Box shapes)
         *
         * @name Phaser.GameObjects.Shape#isStroked
         * @type {boolean}
         * @since 3.13.0
         */ this.isStroked = false;
                        /**
         * Controls if this Shape path is closed during rendering when stroked.
         * Note that some Shapes are always closed when stroked (such as Ellipse shapes)
         *
         * @name Phaser.GameObjects.Shape#closePath
         * @type {boolean}
         * @since 3.13.0
         */ this.closePath = true;
                        /**
         * Private internal value.
         * A Line used when parsing internal path data to avoid constant object re-creation.
         *
         * @name Phaser.GameObjects.Shape#_tempLine
         * @type {Phaser.Geom.Line}
         * @private
         * @since 3.13.0
         */ this._tempLine = new Line();
                        /**
         * The native (un-scaled) width of this Game Object.
         *
         * Changing this value will not change the size that the Game Object is rendered in-game.
         * For that you need to either set the scale of the Game Object (`setScale`) or use
         * the `displayWidth` property.
         *
         * @name Phaser.GameObjects.Shape#width
         * @type {number}
         * @since 3.13.0
         */ this.width = 0;
                        /**
         * The native (un-scaled) height of this Game Object.
         *
         * Changing this value will not change the size that the Game Object is rendered in-game.
         * For that you need to either set the scale of the Game Object (`setScale`) or use
         * the `displayHeight` property.
         *
         * @name Phaser.GameObjects.Shape#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                        this.initPipeline();
                        this.initPostPipeline();
                    },
                    /**
     * Sets the fill color and alpha for this Shape.
     *
     * If you wish for the Shape to not be filled then call this method with no arguments, or just set `isFilled` to `false`.
     *
     * Note that some Shapes do not support fill colors, such as the Line shape.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [color] - The color used to fill this shape. If not provided the Shape will not be filled.
     * @param {number} [alpha=1] - The alpha value used when filling this shape, if a fill color is given.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(color, alpha) {
                        if (alpha === undefined) alpha = 1;
                        if (color === undefined) this.isFilled = false;
                        else {
                            this.fillColor = color;
                            this.fillAlpha = alpha;
                            this.isFilled = true;
                        }
                        return this;
                    },
                    /**
     * Sets the stroke color and alpha for this Shape.
     *
     * If you wish for the Shape to not be stroked then call this method with no arguments, or just set `isStroked` to `false`.
     *
     * Note that some Shapes do not support being stroked, such as the Iso Box shape.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setStrokeStyle
     * @since 3.13.0
     *
     * @param {number} [lineWidth] - The width of line to stroke with. If not provided or undefined the Shape will not be stroked.
     * @param {number} [color] - The color used to stroke this shape. If not provided the Shape will not be stroked.
     * @param {number} [alpha=1] - The alpha value used when stroking this shape, if a stroke color is given.
     *
     * @return {this} This Game Object instance.
     */ setStrokeStyle: function(lineWidth, color, alpha) {
                        if (alpha === undefined) alpha = 1;
                        if (lineWidth === undefined) this.isStroked = false;
                        else {
                            this.lineWidth = lineWidth;
                            this.strokeColor = color;
                            this.strokeAlpha = alpha;
                            this.isStroked = true;
                        }
                        return this;
                    },
                    /**
     * Sets if this Shape path is closed during rendering when stroked.
     * Note that some Shapes are always closed when stroked (such as Ellipse shapes)
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setClosePath
     * @since 3.13.0
     *
     * @param {boolean} value - Set to `true` if the Shape should be closed when stroked, otherwise `false`.
     *
     * @return {this} This Game Object instance.
     */ setClosePath: function(value) {
                        this.closePath = value;
                        return this;
                    },
                    /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Shape#setSize
     * @private
     * @since 3.13.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Sets the display size of this Shape.
     *
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.Shape#setDisplaySize
     * @since 3.53.0
     *
     * @param {number} width - The display width of this Shape.
     * @param {number} height - The display height of this Shape.
     *
     * @return {this} This Shape instance.
     */ setDisplaySize: function(width, height) {
                        this.displayWidth = width;
                        this.displayHeight = height;
                        return this;
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Shape#preDestroy
     * @protected
     * @since 3.13.0
     */ preDestroy: function() {
                        this.geom = null;
                        this._tempLine = null;
                        this.pathData = [];
                        this.pathIndexes = [];
                    },
                    /**
     * The displayed width of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Shape#displayWidth
     * @type {number}
     * @since 3.13.0
     */ displayWidth: {
                        get: function() {
                            return this.scaleX * this.width;
                        },
                        set: function(value) {
                            this.scaleX = value / this.width;
                        }
                    },
                    /**
     * The displayed height of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Shape#displayHeight
     * @type {number}
     * @since 3.13.0
     */ displayHeight: {
                        get: function() {
                            return this.scaleY * this.height;
                        },
                        set: function(value) {
                            this.scaleY = value / this.height;
                        }
                    }
                });
                module1.exports = Shape;
            /***/ },
            /***/ 34682: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(70554);
                /**
 * Renders a stroke outline around the given Shape.
 *
 * @method Phaser.GameObjects.Shape#StrokePathWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGL Pipeline used to render this Shape.
 * @param {Phaser.GameObjects.Shape} src - The Game Object shape being rendered in this call.
 * @param {number} alpha - The base alpha value.
 * @param {number} dx - The source displayOriginX.
 * @param {number} dy - The source displayOriginY.
 */ var StrokePathWebGL = function(pipeline, src, alpha, dx, dy) {
                    var strokeTint = pipeline.strokeTint;
                    var strokeTintColor = Utils.getTintAppendFloatAlpha(src.strokeColor, src.strokeAlpha * alpha);
                    strokeTint.TL = strokeTintColor;
                    strokeTint.TR = strokeTintColor;
                    strokeTint.BL = strokeTintColor;
                    strokeTint.BR = strokeTintColor;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var lineWidth = src.lineWidth;
                    var halfLineWidth = lineWidth / 2;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        pipeline.batchLine(px1, py1, px2, py2, halfLineWidth, halfLineWidth, lineWidth, i - 2, src.closePath ? i === pathLength - 1 : false);
                        px1 = px2;
                        py1 = py2;
                    }
                };
                module1.exports = StrokePathWebGL;
            /***/ },
            /***/ 23629: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcRender = __webpack_require__(13609);
                var Class = __webpack_require__(83419);
                var DegToRad = __webpack_require__(39506);
                var Earcut = __webpack_require__(94811);
                var GeomCircle = __webpack_require__(96503);
                var MATH_CONST = __webpack_require__(36383);
                var Shape = __webpack_require__(17803);
                /**
 * @classdesc
 * The Arc Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * When it renders it displays an arc shape. You can control the start and end angles of the arc,
 * as well as if the angles are winding clockwise or anti-clockwise. With the default settings
 * it renders as a complete circle. By changing the angles you can create other arc shapes,
 * such as half-circles.
 *
 * Arcs also have an `iterations` property and corresponding `setIterations` method. This allows
 * you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction.
 *
 * @class Arc
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the arc.
 * @param {number} [startAngle=0] - The start angle of the arc, in degrees.
 * @param {number} [endAngle=360] - The end angle of the arc, in degrees.
 * @param {boolean} [anticlockwise=false] - The winding order of the start and end angles.
 * @param {number} [fillColor] - The color the arc will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the arc will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Arc = new Class({
                    Extends: Shape,
                    Mixins: [
                        ArcRender
                    ],
                    initialize: function Arc(scene, x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (radius === undefined) radius = 128;
                        if (startAngle === undefined) startAngle = 0;
                        if (endAngle === undefined) endAngle = 360;
                        if (anticlockwise === undefined) anticlockwise = false;
                        Shape.call(this, scene, 'Arc', new GeomCircle(0, 0, radius));
                        /**
         * Private internal value. Holds the start angle in degrees.
         *
         * @name Phaser.GameObjects.Arc#_startAngle
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._startAngle = startAngle;
                        /**
         * Private internal value. Holds the end angle in degrees.
         *
         * @name Phaser.GameObjects.Arc#_endAngle
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._endAngle = endAngle;
                        /**
         * Private internal value. Holds the winding order of the start and end angles.
         *
         * @name Phaser.GameObjects.Arc#_anticlockwise
         * @type {boolean}
         * @private
         * @since 3.13.0
         */ this._anticlockwise = anticlockwise;
                        /**
         * Private internal value. Holds the number of iterations used when drawing the arc.
         *
         * @name Phaser.GameObjects.Arc#_iterations
         * @type {number}
         * @default 0.01
         * @private
         * @since 3.13.0
         */ this._iterations = 0.01;
                        this.setPosition(x, y);
                        var diameter = this.geom.radius * 2;
                        this.setSize(diameter, diameter);
                        if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                        this.updateDisplayOrigin();
                        this.updateData();
                    },
                    /**
     * The number of iterations used when drawing the arc.
     * Increase this value for smoother arcs, at the cost of more polygons being rendered.
     * Modify this value by small amounts, such as 0.01.
     *
     * @name Phaser.GameObjects.Arc#iterations
     * @type {number}
     * @default 0.01
     * @since 3.13.0
     */ iterations: {
                        get: function() {
                            return this._iterations;
                        },
                        set: function(value) {
                            this._iterations = value;
                            this.updateData();
                        }
                    },
                    /**
     * The radius of the arc.
     *
     * @name Phaser.GameObjects.Arc#radius
     * @type {number}
     * @since 3.13.0
     */ radius: {
                        get: function() {
                            return this.geom.radius;
                        },
                        set: function(value) {
                            this.geom.radius = value;
                            var diameter = value * 2;
                            this.setSize(diameter, diameter);
                            this.updateDisplayOrigin();
                            this.updateData();
                        }
                    },
                    /**
     * The start angle of the arc, in degrees.
     *
     * @name Phaser.GameObjects.Arc#startAngle
     * @type {number}
     * @since 3.13.0
     */ startAngle: {
                        get: function() {
                            return this._startAngle;
                        },
                        set: function(value) {
                            this._startAngle = value;
                            this.updateData();
                        }
                    },
                    /**
     * The end angle of the arc, in degrees.
     *
     * @name Phaser.GameObjects.Arc#endAngle
     * @type {number}
     * @since 3.13.0
     */ endAngle: {
                        get: function() {
                            return this._endAngle;
                        },
                        set: function(value) {
                            this._endAngle = value;
                            this.updateData();
                        }
                    },
                    /**
     * The winding order of the start and end angles.
     *
     * @name Phaser.GameObjects.Arc#anticlockwise
     * @type {boolean}
     * @since 3.13.0
     */ anticlockwise: {
                        get: function() {
                            return this._anticlockwise;
                        },
                        set: function(value) {
                            this._anticlockwise = value;
                            this.updateData();
                        }
                    },
                    /**
     * Sets the radius of the arc.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setRadius
     * @since 3.13.0
     *
     * @param {number} value - The value to set the radius to.
     *
     * @return {this} This Game Object instance.
     */ setRadius: function(value) {
                        this.radius = value;
                        return this;
                    },
                    /**
     * Sets the number of iterations used when drawing the arc.
     * Increase this value for smoother arcs, at the cost of more polygons being rendered.
     * Modify this value by small amounts, such as 0.01.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setIterations
     * @since 3.13.0
     *
     * @param {number} value - The value to set the iterations to.
     *
     * @return {this} This Game Object instance.
     */ setIterations: function(value) {
                        if (value === undefined) value = 0.01;
                        this.iterations = value;
                        return this;
                    },
                    /**
     * Sets the starting angle of the arc, in degrees.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setStartAngle
     * @since 3.13.0
     *
     * @param {number} value - The value to set the starting angle to.
     *
     * @return {this} This Game Object instance.
     */ setStartAngle: function(angle, anticlockwise) {
                        this._startAngle = angle;
                        if (anticlockwise !== undefined) this._anticlockwise = anticlockwise;
                        return this.updateData();
                    },
                    /**
     * Sets the ending angle of the arc, in degrees.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setEndAngle
     * @since 3.13.0
     *
     * @param {number} value - The value to set the ending angle to.
     *
     * @return {this} This Game Object instance.
     */ setEndAngle: function(angle, anticlockwise) {
                        this._endAngle = angle;
                        if (anticlockwise !== undefined) this._anticlockwise = anticlockwise;
                        return this.updateData();
                    },
                    /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Arc#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                        var step = this._iterations;
                        var iteration = step;
                        var radius = this.geom.radius;
                        var startAngle = DegToRad(this._startAngle);
                        var endAngle = DegToRad(this._endAngle);
                        var anticlockwise = this._anticlockwise;
                        var x = radius;
                        var y = radius;
                        endAngle -= startAngle;
                        if (anticlockwise) {
                            if (endAngle < -MATH_CONST.PI2) endAngle = -MATH_CONST.PI2;
                            else if (endAngle > 0) endAngle = -MATH_CONST.PI2 + endAngle % MATH_CONST.PI2;
                        } else if (endAngle > MATH_CONST.PI2) endAngle = MATH_CONST.PI2;
                        else if (endAngle < 0) endAngle = MATH_CONST.PI2 + endAngle % MATH_CONST.PI2;
                        var path = [
                            x + Math.cos(startAngle) * radius,
                            y + Math.sin(startAngle) * radius
                        ];
                        var ta;
                        while(iteration < 1){
                            ta = endAngle * iteration + startAngle;
                            path.push(x + Math.cos(ta) * radius, y + Math.sin(ta) * radius);
                            iteration += step;
                        }
                        ta = endAngle + startAngle;
                        path.push(x + Math.cos(ta) * radius, y + Math.sin(ta) * radius);
                        path.push(x + Math.cos(startAngle) * radius, y + Math.sin(startAngle) * radius);
                        this.pathIndexes = Earcut(path);
                        this.pathData = path;
                        return this;
                    }
                });
                module1.exports = Arc;
            /***/ },
            /***/ 42542: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DegToRad = __webpack_require__(39506);
                var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Arc#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Arc} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ArcCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var radius = src.radius;
                        ctx.beginPath();
                        ctx.arc(radius - src.originX * (radius * 2), radius - src.originY * (radius * 2), radius, DegToRad(src._startAngle), DegToRad(src._endAngle), src.anticlockwise);
                        if (src.closePath) ctx.closePath();
                        if (src.isFilled) {
                            FillStyleCanvas(ctx, src);
                            ctx.fill();
                        }
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = ArcCanvasRenderer;
            /***/ },
            /***/ 42563: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Arc = __webpack_require__(23629);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Arc Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Arc Game Object has been built into Phaser.
 *
 * The Arc Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * When it renders it displays an arc shape. You can control the start and end angles of the arc,
 * as well as if the angles are winding clockwise or anti-clockwise. With the default settings
 * it renders as a complete circle. By changing the angles you can create other arc shapes,
 * such as half-circles.
 *
 * @method Phaser.GameObjects.GameObjectFactory#arc
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the arc.
 * @param {number} [startAngle=0] - The start angle of the arc, in degrees.
 * @param {number} [endAngle=360] - The end angle of the arc, in degrees.
 * @param {boolean} [anticlockwise=false] - The winding order of the start and end angles.
 * @param {number} [fillColor] - The color the arc will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the arc will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Arc} The Game Object that was created.
 */ GameObjectFactory.register('arc', function(x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha) {
                    return this.displayList.add(new Arc(this.scene, x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha));
                });
                /**
 * Creates a new Circle Shape Game Object and adds it to the Scene.
 *
 * A Circle is an Arc with no defined start and end angle, making it render as a complete circle.
 *
 * Note: This method will only be available if the Arc Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#circle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the circle.
 * @param {number} [fillColor] - The color the circle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the circle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Arc} The Game Object that was created.
 */ GameObjectFactory.register('circle', function(x, y, radius, fillColor, fillAlpha) {
                    return this.displayList.add(new Arc(this.scene, x, y, radius, 0, 360, false, fillColor, fillAlpha));
                });
            /***/ },
            /***/ 13609: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(41447);
                renderCanvas = __webpack_require__(42542);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 41447: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var FillPathWebGL = __webpack_require__(10441);
                var StrokePathWebGL = __webpack_require__(34682);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Arc#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Arc} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ArcWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                    if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = ArcWebGLRenderer;
            /***/ },
            /***/ 89: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CurveRender = __webpack_require__(33141);
                var Earcut = __webpack_require__(94811);
                var Rectangle = __webpack_require__(87841);
                var Shape = __webpack_require__(17803);
                /**
 * @classdesc
 * The Curve Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * To render a Curve Shape you must first create a `Phaser.Curves.Curve` object, then pass it to
 * the Curve Shape in the constructor.
 *
 * The Curve shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @class Curve
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.Curves.Curve} [curve] - The Curve object to use to create the Shape.
 * @param {number} [fillColor] - The color the curve will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the curve will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Curve = new Class({
                    Extends: Shape,
                    Mixins: [
                        CurveRender
                    ],
                    initialize: function Curve(scene, x, y, curve, fillColor, fillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        Shape.call(this, scene, 'Curve', curve);
                        /**
         * Private internal value.
         * The number of points used to draw the curve. Higher values create smoother renders at the cost of more triangles being drawn.
         *
         * @name Phaser.GameObjects.Curve#_smoothness
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._smoothness = 32;
                        /**
         * Private internal value.
         * The Curve bounds rectangle.
         *
         * @name Phaser.GameObjects.Curve#_curveBounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.13.0
         */ this._curveBounds = new Rectangle();
                        this.closePath = false;
                        this.setPosition(x, y);
                        if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                        this.updateData();
                    },
                    /**
     * The smoothness of the curve. The number of points used when rendering it.
     * Increase this value for smoother curves, at the cost of more polygons being rendered.
     *
     * @name Phaser.GameObjects.Curve#smoothness
     * @type {number}
     * @default 32
     * @since 3.13.0
     */ smoothness: {
                        get: function() {
                            return this._smoothness;
                        },
                        set: function(value) {
                            this._smoothness = value;
                            this.updateData();
                        }
                    },
                    /**
     * Sets the smoothness of the curve. The number of points used when rendering it.
     * Increase this value for smoother curves, at the cost of more polygons being rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Curve#setSmoothness
     * @since 3.13.0
     *
     * @param {number} value - The value to set the smoothness to.
     *
     * @return {this} This Game Object instance.
     */ setSmoothness: function(value) {
                        this._smoothness = value;
                        return this.updateData();
                    },
                    /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Curve#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                        var bounds = this._curveBounds;
                        var smoothness = this._smoothness;
                        //  Update the bounds in case the underlying data has changed
                        this.geom.getBounds(bounds, smoothness);
                        this.setSize(bounds.width, bounds.height);
                        this.updateDisplayOrigin();
                        var path = [];
                        var points = this.geom.getPoints(smoothness);
                        for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                        path.push(points[0].x, points[0].y);
                        this.pathIndexes = Earcut(path);
                        this.pathData = path;
                        return this;
                    }
                });
                module1.exports = Curve;
            /***/ },
            /***/ 3170: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Curve#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Curve} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var CurveCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = src._displayOriginX + src._curveBounds.x;
                        var dy = src._displayOriginY + src._curveBounds.y;
                        var path = src.pathData;
                        var pathLength = path.length - 1;
                        var px1 = path[0] - dx;
                        var py1 = path[1] - dy;
                        ctx.beginPath();
                        ctx.moveTo(px1, py1);
                        if (!src.closePath) pathLength -= 2;
                        for(var i = 2; i < pathLength; i += 2){
                            var px2 = path[i] - dx;
                            var py2 = path[i + 1] - dy;
                            ctx.lineTo(px2, py2);
                        }
                        if (src.closePath) ctx.closePath();
                        if (src.isFilled) {
                            FillStyleCanvas(ctx, src);
                            ctx.fill();
                        }
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = CurveCanvasRenderer;
            /***/ },
            /***/ 40511: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var Curve = __webpack_require__(89);
                /**
 * Creates a new Curve Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Curve Game Object has been built into Phaser.
 *
 * The Curve Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * To render a Curve Shape you must first create a `Phaser.Curves.Curve` object, then pass it to
 * the Curve Shape in the constructor.
 *
 * The Curve shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#curve
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.Curves.Curve} [curve] - The Curve object to use to create the Shape.
 * @param {number} [fillColor] - The color the curve will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the curve will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Curve} The Game Object that was created.
 */ GameObjectFactory.register('curve', function(x, y, curve, fillColor, fillAlpha) {
                    return this.displayList.add(new Curve(this.scene, x, y, curve, fillColor, fillAlpha));
                });
            /***/ },
            /***/ 33141: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(53987);
                renderCanvas = __webpack_require__(3170);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 53987: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(10441);
                var GetCalcMatrix = __webpack_require__(91296);
                var StrokePathWebGL = __webpack_require__(34682);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Curve#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Curve} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var CurveWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX + src._curveBounds.x;
                    var dy = src._displayOriginY + src._curveBounds.y;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                    if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = CurveWebGLRenderer;
            /***/ },
            /***/ 19921: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Earcut = __webpack_require__(94811);
                var EllipseRender = __webpack_require__(54205);
                var GeomEllipse = __webpack_require__(8497);
                var Shape = __webpack_require__(17803);
                /**
 * @classdesc
 * The Ellipse Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * When it renders it displays an ellipse shape. You can control the width and height of the ellipse.
 * If the width and height match it will render as a circle. If the width is less than the height,
 * it will look more like an egg shape.
 *
 * The Ellipse shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @class Ellipse
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [height=128] - The height of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [fillColor] - The color the ellipse will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the ellipse will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Ellipse = new Class({
                    Extends: Shape,
                    Mixins: [
                        EllipseRender
                    ],
                    initialize: function Ellipse(scene, x, y, width, height, fillColor, fillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 128;
                        if (height === undefined) height = 128;
                        Shape.call(this, scene, 'Ellipse', new GeomEllipse(width / 2, height / 2, width, height));
                        /**
         * Private internal value.
         * The number of points used to draw the curve. Higher values create smoother renders at the cost of more triangles being drawn.
         *
         * @name Phaser.GameObjects.Ellipse#_smoothness
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._smoothness = 64;
                        this.setPosition(x, y);
                        this.width = width;
                        this.height = height;
                        if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                        this.updateDisplayOrigin();
                        this.updateData();
                    },
                    /**
     * The smoothness of the ellipse. The number of points used when rendering it.
     * Increase this value for a smoother ellipse, at the cost of more polygons being rendered.
     *
     * @name Phaser.GameObjects.Ellipse#smoothness
     * @type {number}
     * @default 64
     * @since 3.13.0
     */ smoothness: {
                        get: function() {
                            return this._smoothness;
                        },
                        set: function(value) {
                            this._smoothness = value;
                            this.updateData();
                        }
                    },
                    /**
     * Sets the size of the ellipse by changing the underlying geometry data, rather than scaling the object.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Ellipse#setSize
     * @since 3.13.0
     *
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        this.geom.setPosition(width / 2, height / 2);
                        this.geom.setSize(width, height);
                        this.updateDisplayOrigin();
                        return this.updateData();
                    },
                    /**
     * Sets the smoothness of the ellipse. The number of points used when rendering it.
     * Increase this value for a smoother ellipse, at the cost of more polygons being rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Ellipse#setSmoothness
     * @since 3.13.0
     *
     * @param {number} value - The value to set the smoothness to.
     *
     * @return {this} This Game Object instance.
     */ setSmoothness: function(value) {
                        this._smoothness = value;
                        return this.updateData();
                    },
                    /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Ellipse#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                        var path = [];
                        var points = this.geom.getPoints(this._smoothness);
                        for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                        path.push(points[0].x, points[0].y);
                        this.pathIndexes = Earcut(path);
                        this.pathData = path;
                        return this;
                    }
                });
                module1.exports = Ellipse;
            /***/ },
            /***/ 7930: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Ellipse#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Ellipse} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var EllipseCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = src._displayOriginX;
                        var dy = src._displayOriginY;
                        var path = src.pathData;
                        var pathLength = path.length - 1;
                        var px1 = path[0] - dx;
                        var py1 = path[1] - dy;
                        ctx.beginPath();
                        ctx.moveTo(px1, py1);
                        if (!src.closePath) pathLength -= 2;
                        for(var i = 2; i < pathLength; i += 2){
                            var px2 = path[i] - dx;
                            var py2 = path[i + 1] - dy;
                            ctx.lineTo(px2, py2);
                        }
                        ctx.closePath();
                        if (src.isFilled) {
                            FillStyleCanvas(ctx, src);
                            ctx.fill();
                        }
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = EllipseCanvasRenderer;
            /***/ },
            /***/ 1543: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(19921);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Ellipse Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Ellipse Game Object has been built into Phaser.
 *
 * The Ellipse Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * When it renders it displays an ellipse shape. You can control the width and height of the ellipse.
 * If the width and height match it will render as a circle. If the width is less than the height,
 * it will look more like an egg shape.
 *
 * The Ellipse shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#ellipse
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [height=128] - The height of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [fillColor] - The color the ellipse will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the ellipse will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Ellipse} The Game Object that was created.
 */ GameObjectFactory.register('ellipse', function(x, y, width, height, fillColor, fillAlpha) {
                    return this.displayList.add(new Ellipse(this.scene, x, y, width, height, fillColor, fillAlpha));
                });
            /***/ },
            /***/ 54205: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(19467);
                renderCanvas = __webpack_require__(7930);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 19467: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(10441);
                var GetCalcMatrix = __webpack_require__(91296);
                var StrokePathWebGL = __webpack_require__(34682);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Ellipse#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Ellipse} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var EllipseWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                    if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = EllipseWebGLRenderer;
            /***/ },
            /***/ 30479: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Shape = __webpack_require__(17803);
                var GridRender = __webpack_require__(26015);
                /**
 * @classdesc
 * The Grid Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * A Grid Shape allows you to display a grid in your game, where you can control the size of the
 * grid as well as the width and height of the grid cells. You can set a fill color for each grid
 * cell as well as an alternate fill color. When the alternate fill color is set then the grid
 * cells will alternate the fill colors as they render, creating a chess-board effect. You can
 * also optionally have an outline fill color. If set, this draws lines between the grid cells
 * in the given color. If you specify an outline color with an alpha of zero, then it will draw
 * the cells spaced out, but without the lines between them.
 *
 * @class Grid
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the grid.
 * @param {number} [height=128] - The height of the grid.
 * @param {number} [cellWidth=32] - The width of one cell in the grid.
 * @param {number} [cellHeight=32] - The height of one cell in the grid.
 * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 * @param {number} [outlineFillColor] - The color of the lines between the grid cells. See the `setOutline` method.
 * @param {number} [outlineFillAlpha] - The alpha of the lines between the grid cells.
 */ var Grid = new Class({
                    Extends: Shape,
                    Mixins: [
                        GridRender
                    ],
                    initialize: function Grid(scene, x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 128;
                        if (height === undefined) height = 128;
                        if (cellWidth === undefined) cellWidth = 32;
                        if (cellHeight === undefined) cellHeight = 32;
                        Shape.call(this, scene, 'Grid', null);
                        /**
         * The width of each grid cell.
         * Must be a positive value.
         *
         * @name Phaser.GameObjects.Grid#cellWidth
         * @type {number}
         * @since 3.13.0
         */ this.cellWidth = cellWidth;
                        /**
         * The height of each grid cell.
         * Must be a positive value.
         *
         * @name Phaser.GameObjects.Grid#cellHeight
         * @type {number}
         * @since 3.13.0
         */ this.cellHeight = cellHeight;
                        /**
         * Will the grid render its cells in the `fillColor`?
         *
         * @name Phaser.GameObjects.Grid#showCells
         * @type {boolean}
         * @since 3.13.0
         */ this.showCells = true;
                        /**
         * The color of the lines between each grid cell.
         *
         * @name Phaser.GameObjects.Grid#outlineFillColor
         * @type {number}
         * @since 3.13.0
         */ this.outlineFillColor = 0;
                        /**
         * The alpha value for the color of the lines between each grid cell.
         *
         * @name Phaser.GameObjects.Grid#outlineFillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.outlineFillAlpha = 0;
                        /**
         * Will the grid display the lines between each cell when it renders?
         *
         * @name Phaser.GameObjects.Grid#showOutline
         * @type {boolean}
         * @since 3.13.0
         */ this.showOutline = true;
                        /**
         * Will the grid render the alternating cells in the `altFillColor`?
         *
         * @name Phaser.GameObjects.Grid#showAltCells
         * @type {boolean}
         * @since 3.13.0
         */ this.showAltCells = false;
                        /**
         * The color the alternating grid cells will be filled with, i.e. 0xff0000 for red.
         *
         * @name Phaser.GameObjects.Grid#altFillColor
         * @type {number}
         * @since 3.13.0
         */ this.altFillColor;
                        /**
         * The alpha the alternating grid cells will be filled with.
         * You can also set the alpha of the overall Shape using its `alpha` property.
         *
         * @name Phaser.GameObjects.Grid#altFillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.altFillAlpha;
                        this.setPosition(x, y);
                        this.setSize(width, height);
                        this.setFillStyle(fillColor, fillAlpha);
                        if (outlineFillColor !== undefined) this.setOutlineStyle(outlineFillColor, outlineFillAlpha);
                        this.updateDisplayOrigin();
                    },
                    /**
     * Sets the fill color and alpha level the grid cells will use when rendering.
     *
     * If this method is called with no values then the grid cells will not be rendered,
     * however the grid lines and alternating cells may still be.
     *
     * Also see the `setOutlineStyle` and `setAltFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillColor, fillAlpha) {
                        if (fillAlpha === undefined) fillAlpha = 1;
                        if (fillColor === undefined) this.showCells = false;
                        else {
                            this.fillColor = fillColor;
                            this.fillAlpha = fillAlpha;
                            this.showCells = true;
                        }
                        return this;
                    },
                    /**
     * Sets the fill color and alpha level that the alternating grid cells will use.
     *
     * If this method is called with no values then alternating grid cells will not be rendered in a different color.
     *
     * Also see the `setOutlineStyle` and `setFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setAltFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the alternating grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the alternating grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setAltFillStyle: function(fillColor, fillAlpha) {
                        if (fillAlpha === undefined) fillAlpha = 1;
                        if (fillColor === undefined) this.showAltCells = false;
                        else {
                            this.altFillColor = fillColor;
                            this.altFillAlpha = fillAlpha;
                            this.showAltCells = true;
                        }
                        return this;
                    },
                    /**
     * Sets the fill color and alpha level that the lines between each grid cell will use.
     *
     * If this method is called with no values then the grid lines will not be rendered at all, however
     * the cells themselves may still be if they have colors set.
     *
     * Also see the `setFillStyle` and `setAltFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setOutlineStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the lines between the grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the lines between the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setOutlineStyle: function(fillColor, fillAlpha) {
                        if (fillAlpha === undefined) fillAlpha = 1;
                        if (fillColor === undefined) this.showOutline = false;
                        else {
                            this.outlineFillColor = fillColor;
                            this.outlineFillAlpha = fillAlpha;
                            this.showOutline = true;
                        }
                        return this;
                    }
                });
                module1.exports = Grid;
            /***/ },
            /***/ 49912: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Grid#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Grid} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GridCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = -src._displayOriginX;
                        var dy = -src._displayOriginY;
                        var alpha = camera.alpha * src.alpha;
                        //  Work out the grid size
                        var width = src.width;
                        var height = src.height;
                        var cellWidth = src.cellWidth;
                        var cellHeight = src.cellHeight;
                        var gridWidth = Math.ceil(width / cellWidth);
                        var gridHeight = Math.ceil(height / cellHeight);
                        var cellWidthA = cellWidth;
                        var cellHeightA = cellHeight;
                        var cellWidthB = cellWidth - (gridWidth * cellWidth - width);
                        var cellHeightB = cellHeight - (gridHeight * cellHeight - height);
                        var showCells = src.showCells;
                        var showAltCells = src.showAltCells;
                        var showOutline = src.showOutline;
                        var x = 0;
                        var y = 0;
                        var r = 0;
                        var cw = 0;
                        var ch = 0;
                        if (showOutline) {
                            //  To make room for the grid lines (in case alpha < 1)
                            cellWidthA--;
                            cellHeightA--;
                            if (cellWidthB === cellWidth) cellWidthB--;
                            if (cellHeightB === cellHeight) cellHeightB--;
                        }
                        if (showCells && src.fillAlpha > 0) {
                            FillStyleCanvas(ctx, src);
                            for(y = 0; y < gridHeight; y++){
                                if (showAltCells) r = y % 2;
                                for(x = 0; x < gridWidth; x++){
                                    if (showAltCells && r) {
                                        r = 0;
                                        continue;
                                    }
                                    r++;
                                    cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                    ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                    ctx.fillRect(dx + x * cellWidth, dy + y * cellHeight, cw, ch);
                                }
                            }
                        }
                        if (showAltCells && src.altFillAlpha > 0) {
                            FillStyleCanvas(ctx, src, src.altFillColor, src.altFillAlpha * alpha);
                            for(y = 0; y < gridHeight; y++){
                                if (showAltCells) r = y % 2;
                                for(x = 0; x < gridWidth; x++){
                                    if (showAltCells && !r) {
                                        r = 1;
                                        continue;
                                    }
                                    r = 0;
                                    cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                    ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                    ctx.fillRect(dx + x * cellWidth, dy + y * cellHeight, cw, ch);
                                }
                            }
                        }
                        if (showOutline && src.outlineFillAlpha > 0) {
                            LineStyleCanvas(ctx, src, src.outlineFillColor, src.outlineFillAlpha * alpha);
                            for(x = 1; x < gridWidth; x++){
                                var x1 = x * cellWidth;
                                ctx.beginPath();
                                ctx.moveTo(x1 + dx, dy);
                                ctx.lineTo(x1 + dx, height + dy);
                                ctx.stroke();
                            }
                            for(y = 1; y < gridHeight; y++){
                                var y1 = y * cellHeight;
                                ctx.beginPath();
                                ctx.moveTo(dx, y1 + dy);
                                ctx.lineTo(dx + width, y1 + dy);
                                ctx.stroke();
                            }
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = GridCanvasRenderer;
            /***/ },
            /***/ 34137: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var Grid = __webpack_require__(30479);
                /**
 * Creates a new Grid Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Grid Game Object has been built into Phaser.
 *
 * The Grid Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * A Grid Shape allows you to display a grid in your game, where you can control the size of the
 * grid as well as the width and height of the grid cells. You can set a fill color for each grid
 * cell as well as an alternate fill color. When the alternate fill color is set then the grid
 * cells will alternate the fill colors as they render, creating a chess-board effect. You can
 * also optionally have an outline fill color. If set, this draws lines between the grid cells
 * in the given color. If you specify an outline color with an alpha of zero, then it will draw
 * the cells spaced out, but without the lines between them.
 *
 * @method Phaser.GameObjects.GameObjectFactory#grid
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the grid.
 * @param {number} [height=128] - The height of the grid.
 * @param {number} [cellWidth=32] - The width of one cell in the grid.
 * @param {number} [cellHeight=32] - The height of one cell in the grid.
 * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 * @param {number} [outlineFillColor] - The color of the lines between the grid cells.
 * @param {number} [outlineFillAlpha] - The alpha of the lines between the grid cells.
 *
 * @return {Phaser.GameObjects.Grid} The Game Object that was created.
 */ GameObjectFactory.register('grid', function(x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha) {
                    return this.displayList.add(new Grid(this.scene, x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha));
                });
            /***/ },
            /***/ 26015: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(46161);
                renderCanvas = __webpack_require__(49912);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 46161: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Grid#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Grid} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GridWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    calcMatrix.translate(-src._displayOriginX, -src._displayOriginY);
                    var alpha = camera.alpha * src.alpha;
                    //  Work out the grid size
                    var width = src.width;
                    var height = src.height;
                    var cellWidth = src.cellWidth;
                    var cellHeight = src.cellHeight;
                    var gridWidth = Math.ceil(width / cellWidth);
                    var gridHeight = Math.ceil(height / cellHeight);
                    var cellWidthA = cellWidth;
                    var cellHeightA = cellHeight;
                    var cellWidthB = cellWidth - (gridWidth * cellWidth - width);
                    var cellHeightB = cellHeight - (gridHeight * cellHeight - height);
                    var fillTint;
                    var fillTintColor;
                    var showCells = src.showCells;
                    var showAltCells = src.showAltCells;
                    var showOutline = src.showOutline;
                    var x = 0;
                    var y = 0;
                    var r = 0;
                    var cw = 0;
                    var ch = 0;
                    if (showOutline) {
                        //  To make room for the grid lines (in case alpha < 1)
                        cellWidthA--;
                        cellHeightA--;
                        if (cellWidthB === cellWidth) cellWidthB--;
                        if (cellHeightB === cellHeight) cellHeightB--;
                    }
                    renderer.pipelines.preBatch(src);
                    if (showCells && src.fillAlpha > 0) {
                        fillTint = pipeline.fillTint;
                        fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                        fillTint.TL = fillTintColor;
                        fillTint.TR = fillTintColor;
                        fillTint.BL = fillTintColor;
                        fillTint.BR = fillTintColor;
                        for(y = 0; y < gridHeight; y++){
                            if (showAltCells) r = y % 2;
                            for(x = 0; x < gridWidth; x++){
                                if (showAltCells && r) {
                                    r = 0;
                                    continue;
                                }
                                r++;
                                cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                pipeline.batchFillRect(x * cellWidth, y * cellHeight, cw, ch);
                            }
                        }
                    }
                    if (showAltCells && src.altFillAlpha > 0) {
                        fillTint = pipeline.fillTint;
                        fillTintColor = Utils.getTintAppendFloatAlpha(src.altFillColor, src.altFillAlpha * alpha);
                        fillTint.TL = fillTintColor;
                        fillTint.TR = fillTintColor;
                        fillTint.BL = fillTintColor;
                        fillTint.BR = fillTintColor;
                        for(y = 0; y < gridHeight; y++){
                            if (showAltCells) r = y % 2;
                            for(x = 0; x < gridWidth; x++){
                                if (showAltCells && !r) {
                                    r = 1;
                                    continue;
                                }
                                r = 0;
                                cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                pipeline.batchFillRect(x * cellWidth, y * cellHeight, cw, ch);
                            }
                        }
                    }
                    if (showOutline && src.outlineFillAlpha > 0) {
                        var strokeTint = pipeline.strokeTint;
                        var color = Utils.getTintAppendFloatAlpha(src.outlineFillColor, src.outlineFillAlpha * alpha);
                        strokeTint.TL = color;
                        strokeTint.TR = color;
                        strokeTint.BL = color;
                        strokeTint.BR = color;
                        for(x = 1; x < gridWidth; x++){
                            var x1 = x * cellWidth;
                            pipeline.batchLine(x1, 0, x1, height, 1, 1, 1, 0, false);
                        }
                        for(y = 1; y < gridHeight; y++){
                            var y1 = y * cellHeight;
                            pipeline.batchLine(0, y1, width, y1, 1, 1, 1, 0, false);
                        }
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = GridWebGLRenderer;
            /***/ },
            /***/ 61475: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsoBoxRender = __webpack_require__(99651);
                var Class = __webpack_require__(83419);
                var Shape = __webpack_require__(17803);
                /**
 * @classdesc
 * The IsoBox Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * An IsoBox is an 'isometric' rectangle. Each face of it has a different fill color. You can set
 * the color of the top, left and right faces of the rectangle respectively. You can also choose
 * which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 *
 * You cannot view an IsoBox from under-neath, however you can change the 'angle' by setting
 * the `projection` property.
 *
 * @class IsoBox
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso box in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso box. The left and right faces will be this tall. The overall height of the isobox will be this value plus half the `size` value.
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso box.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso box.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso box.
 */ var IsoBox = new Class({
                    Extends: Shape,
                    Mixins: [
                        IsoBoxRender
                    ],
                    initialize: function IsoBox(scene, x, y, size, height, fillTop, fillLeft, fillRight) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (size === undefined) size = 48;
                        if (height === undefined) height = 32;
                        if (fillTop === undefined) fillTop = 0xeeeeee;
                        if (fillLeft === undefined) fillLeft = 0x999999;
                        if (fillRight === undefined) fillRight = 0xcccccc;
                        Shape.call(this, scene, 'IsoBox', null);
                        /**
         * The projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
         *
         * @name Phaser.GameObjects.IsoBox#projection
         * @type {number}
         * @default 4
         * @since 3.13.0
         */ this.projection = 4;
                        /**
         * The color used to fill in the top of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillTop
         * @type {number}
         * @since 3.13.0
         */ this.fillTop = fillTop;
                        /**
         * The color used to fill in the left-facing side of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillLeft
         * @type {number}
         * @since 3.13.0
         */ this.fillLeft = fillLeft;
                        /**
         * The color used to fill in the right-facing side of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillRight
         * @type {number}
         * @since 3.13.0
         */ this.fillRight = fillRight;
                        /**
         * Controls if the top-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showTop
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showTop = true;
                        /**
         * Controls if the left-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showLeft
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showLeft = true;
                        /**
         * Controls if the right-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showRight
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showRight = true;
                        this.isFilled = true;
                        this.setPosition(x, y);
                        this.setSize(size, height);
                        this.updateDisplayOrigin();
                    },
                    /**
     * Sets the projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setProjection
     * @since 3.13.0
     *
     * @param {number} value - The value to set the projection to.
     *
     * @return {this} This Game Object instance.
     */ setProjection: function(value) {
                        this.projection = value;
                        return this;
                    },
                    /**
     * Sets which faces of the iso box will be rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setFaces
     * @since 3.13.0
     *
     * @param {boolean} [showTop=true] - Show the top-face of the iso box.
     * @param {boolean} [showLeft=true] - Show the left-face of the iso box.
     * @param {boolean} [showRight=true] - Show the right-face of the iso box.
     *
     * @return {this} This Game Object instance.
     */ setFaces: function(showTop, showLeft, showRight) {
                        if (showTop === undefined) showTop = true;
                        if (showLeft === undefined) showLeft = true;
                        if (showRight === undefined) showRight = true;
                        this.showTop = showTop;
                        this.showLeft = showLeft;
                        this.showRight = showRight;
                        return this;
                    },
                    /**
     * Sets the fill colors for each face of the iso box.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillTop] - The color used to fill the top of the iso box.
     * @param {number} [fillLeft] - The color used to fill in the left-facing side of the iso box.
     * @param {number} [fillRight] - The color used to fill in the right-facing side of the iso box.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillTop, fillLeft, fillRight) {
                        this.fillTop = fillTop;
                        this.fillLeft = fillLeft;
                        this.fillRight = fillRight;
                        this.isFilled = true;
                        return this;
                    }
                });
                module1.exports = IsoBox;
            /***/ },
            /***/ 11508: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoBox#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.IsoBox} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoBoxCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix) && src.isFilled) {
                        var size = src.width;
                        var height = src.height;
                        var sizeA = size / 2;
                        var sizeB = size / src.projection;
                        //  Top Face
                        if (src.showTop) {
                            FillStyleCanvas(ctx, src, src.fillTop);
                            ctx.beginPath();
                            ctx.moveTo(-sizeA, -height);
                            ctx.lineTo(0, -sizeB - height);
                            ctx.lineTo(sizeA, -height);
                            ctx.lineTo(sizeA, -1);
                            ctx.lineTo(0, sizeB - 1);
                            ctx.lineTo(-sizeA, -1);
                            ctx.lineTo(-sizeA, -height);
                            ctx.fill();
                        }
                        //  Left Face
                        if (src.showLeft) {
                            FillStyleCanvas(ctx, src, src.fillLeft);
                            ctx.beginPath();
                            ctx.moveTo(-sizeA, 0);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                            ctx.lineTo(-sizeA, -height);
                            ctx.lineTo(-sizeA, 0);
                            ctx.fill();
                        }
                        //  Right Face
                        if (src.showRight) {
                            FillStyleCanvas(ctx, src, src.fillRight);
                            ctx.beginPath();
                            ctx.moveTo(sizeA, 0);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                            ctx.lineTo(sizeA, -height);
                            ctx.lineTo(sizeA, 0);
                            ctx.fill();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = IsoBoxCanvasRenderer;
            /***/ },
            /***/ 3933: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var IsoBox = __webpack_require__(61475);
                /**
 * Creates a new IsoBox Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the IsoBox Game Object has been built into Phaser.
 *
 * The IsoBox Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * An IsoBox is an 'isometric' rectangle. Each face of it has a different fill color. You can set
 * the color of the top, left and right faces of the rectangle respectively. You can also choose
 * which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 *
 * You cannot view an IsoBox from under-neath, however you can change the 'angle' by setting
 * the `projection` property.
 *
 * @method Phaser.GameObjects.GameObjectFactory#isobox
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso box in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso box. The left and right faces will be this tall. The overall height of the isobox will be this value plus half the `size` value.
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso box.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso box.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso box.
 *
 * @return {Phaser.GameObjects.IsoBox} The Game Object that was created.
 */ GameObjectFactory.register('isobox', function(x, y, size, height, fillTop, fillLeft, fillRight) {
                    return this.displayList.add(new IsoBox(this.scene, x, y, size, height, fillTop, fillLeft, fillRight));
                });
            /***/ },
            /***/ 99651: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(68149);
                renderCanvas = __webpack_require__(11508);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 68149: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoBox#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.IsoBox} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoBoxWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    var size = src.width;
                    var height = src.height;
                    var sizeA = size / 2;
                    var sizeB = size / src.projection;
                    var alpha = camera.alpha * src.alpha;
                    if (!src.isFilled) return;
                    var tint;
                    var x0;
                    var y0;
                    var x1;
                    var y1;
                    var x2;
                    var y2;
                    var x3;
                    var y3;
                    renderer.pipelines.preBatch(src);
                    //  Top Face
                    if (src.showTop) {
                        tint = Utils.getTintAppendFloatAlpha(src.fillTop, alpha);
                        x0 = calcMatrix.getX(-sizeA, -height);
                        y0 = calcMatrix.getY(-sizeA, -height);
                        x1 = calcMatrix.getX(0, -sizeB - height);
                        y1 = calcMatrix.getY(0, -sizeB - height);
                        x2 = calcMatrix.getX(sizeA, -height);
                        y2 = calcMatrix.getY(sizeA, -height);
                        x3 = calcMatrix.getX(0, sizeB - height);
                        y3 = calcMatrix.getY(0, sizeB - height);
                        pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                    }
                    //  Left Face
                    if (src.showLeft) {
                        tint = Utils.getTintAppendFloatAlpha(src.fillLeft, alpha);
                        x0 = calcMatrix.getX(-sizeA, 0);
                        y0 = calcMatrix.getY(-sizeA, 0);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                        x3 = calcMatrix.getX(-sizeA, -height);
                        y3 = calcMatrix.getY(-sizeA, -height);
                        pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                    }
                    //  Right Face
                    if (src.showRight) {
                        tint = Utils.getTintAppendFloatAlpha(src.fillRight, alpha);
                        x0 = calcMatrix.getX(sizeA, 0);
                        y0 = calcMatrix.getY(sizeA, 0);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                        x3 = calcMatrix.getX(sizeA, -height);
                        y3 = calcMatrix.getY(sizeA, -height);
                        pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = IsoBoxWebGLRenderer;
            /***/ },
            /***/ 16933: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var IsoTriangleRender = __webpack_require__(60561);
                var Shape = __webpack_require__(17803);
                /**
 * @classdesc
 * The IsoTriangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * An IsoTriangle is an 'isometric' triangle. Think of it like a pyramid. Each face has a different
 * fill color. You can set the color of the top, left and right faces of the triangle respectively
 * You can also choose which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 *
 * You cannot view an IsoTriangle from under-neath, however you can change the 'angle' by setting
 * the `projection` property. The `reversed` property controls if the IsoTriangle is rendered upside
 * down or not.
 *
 * @class IsoTriangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso triangle in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso triangle. The left and right faces will be this tall. The overall height of the iso triangle will be this value plus half the `size` value.
 * @param {boolean} [reversed=false] - Is the iso triangle upside down?
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso triangle.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso triangle.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso triangle.
 */ var IsoTriangle = new Class({
                    Extends: Shape,
                    Mixins: [
                        IsoTriangleRender
                    ],
                    initialize: function IsoTriangle(scene, x, y, size, height, reversed, fillTop, fillLeft, fillRight) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (size === undefined) size = 48;
                        if (height === undefined) height = 32;
                        if (reversed === undefined) reversed = false;
                        if (fillTop === undefined) fillTop = 0xeeeeee;
                        if (fillLeft === undefined) fillLeft = 0x999999;
                        if (fillRight === undefined) fillRight = 0xcccccc;
                        Shape.call(this, scene, 'IsoTriangle', null);
                        /**
         * The projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
         *
         * @name Phaser.GameObjects.IsoTriangle#projection
         * @type {number}
         * @default 4
         * @since 3.13.0
         */ this.projection = 4;
                        /**
         * The color used to fill in the top of the iso triangle. This is only used if the triangle is reversed.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillTop
         * @type {number}
         * @since 3.13.0
         */ this.fillTop = fillTop;
                        /**
         * The color used to fill in the left-facing side of the iso triangle.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillLeft
         * @type {number}
         * @since 3.13.0
         */ this.fillLeft = fillLeft;
                        /**
         * The color used to fill in the right-facing side of the iso triangle.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillRight
         * @type {number}
         * @since 3.13.0
         */ this.fillRight = fillRight;
                        /**
         * Controls if the top-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showTop
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showTop = true;
                        /**
         * Controls if the left-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showLeft
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showLeft = true;
                        /**
         * Controls if the right-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showRight
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showRight = true;
                        /**
         * Sets if the iso triangle will be rendered upside down or not.
         *
         * @name Phaser.GameObjects.IsoTriangle#isReversed
         * @type {boolean}
         * @default false
         * @since 3.13.0
         */ this.isReversed = reversed;
                        this.isFilled = true;
                        this.setPosition(x, y);
                        this.setSize(size, height);
                        this.updateDisplayOrigin();
                    },
                    /**
     * Sets the projection level of the iso triangle. Change this to change the 'angle' at which you are looking at the pyramid.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setProjection
     * @since 3.13.0
     *
     * @param {number} value - The value to set the projection to.
     *
     * @return {this} This Game Object instance.
     */ setProjection: function(value) {
                        this.projection = value;
                        return this;
                    },
                    /**
     * Sets if the iso triangle will be rendered upside down or not.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setReversed
     * @since 3.13.0
     *
     * @param {boolean} reversed - Sets if the iso triangle will be rendered upside down or not.
     *
     * @return {this} This Game Object instance.
     */ setReversed: function(reversed) {
                        this.isReversed = reversed;
                        return this;
                    },
                    /**
     * Sets which faces of the iso triangle will be rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setFaces
     * @since 3.13.0
     *
     * @param {boolean} [showTop=true] - Show the top-face of the iso triangle (only if `reversed` is true)
     * @param {boolean} [showLeft=true] - Show the left-face of the iso triangle.
     * @param {boolean} [showRight=true] - Show the right-face of the iso triangle.
     *
     * @return {this} This Game Object instance.
     */ setFaces: function(showTop, showLeft, showRight) {
                        if (showTop === undefined) showTop = true;
                        if (showLeft === undefined) showLeft = true;
                        if (showRight === undefined) showRight = true;
                        this.showTop = showTop;
                        this.showLeft = showLeft;
                        this.showRight = showRight;
                        return this;
                    },
                    /**
     * Sets the fill colors for each face of the iso triangle.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillTop] - The color used to fill the top of the iso triangle.
     * @param {number} [fillLeft] - The color used to fill in the left-facing side of the iso triangle.
     * @param {number} [fillRight] - The color used to fill in the right-facing side of the iso triangle.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillTop, fillLeft, fillRight) {
                        this.fillTop = fillTop;
                        this.fillLeft = fillLeft;
                        this.fillRight = fillRight;
                        this.isFilled = true;
                        return this;
                    }
                });
                module1.exports = IsoTriangle;
            /***/ },
            /***/ 79590: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoTriangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.IsoTriangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoTriangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix) && src.isFilled) {
                        var size = src.width;
                        var height = src.height;
                        var sizeA = size / 2;
                        var sizeB = size / src.projection;
                        var reversed = src.isReversed;
                        //  Top Face
                        if (src.showTop && reversed) {
                            FillStyleCanvas(ctx, src, src.fillTop);
                            ctx.beginPath();
                            ctx.moveTo(-sizeA, -height);
                            ctx.lineTo(0, -sizeB - height);
                            ctx.lineTo(sizeA, -height);
                            ctx.lineTo(0, sizeB - height);
                            ctx.fill();
                        }
                        //  Left Face
                        if (src.showLeft) {
                            FillStyleCanvas(ctx, src, src.fillLeft);
                            ctx.beginPath();
                            if (reversed) {
                                ctx.moveTo(-sizeA, -height);
                                ctx.lineTo(0, sizeB);
                                ctx.lineTo(0, sizeB - height);
                            } else {
                                ctx.moveTo(-sizeA, 0);
                                ctx.lineTo(0, sizeB);
                                ctx.lineTo(0, sizeB - height);
                            }
                            ctx.fill();
                        }
                        //  Right Face
                        if (src.showRight) {
                            FillStyleCanvas(ctx, src, src.fillRight);
                            ctx.beginPath();
                            if (reversed) {
                                ctx.moveTo(sizeA, -height);
                                ctx.lineTo(0, sizeB);
                                ctx.lineTo(0, sizeB - height);
                            } else {
                                ctx.moveTo(sizeA, 0);
                                ctx.lineTo(0, sizeB);
                                ctx.lineTo(0, sizeB - height);
                            }
                            ctx.fill();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = IsoTriangleCanvasRenderer;
            /***/ },
            /***/ 49803: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var IsoTriangle = __webpack_require__(16933);
                /**
 * Creates a new IsoTriangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the IsoTriangle Game Object has been built into Phaser.
 *
 * The IsoTriangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * An IsoTriangle is an 'isometric' triangle. Think of it like a pyramid. Each face has a different
 * fill color. You can set the color of the top, left and right faces of the triangle respectively
 * You can also choose which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 *
 * You cannot view an IsoTriangle from under-neath, however you can change the 'angle' by setting
 * the `projection` property. The `reversed` property controls if the IsoTriangle is rendered upside
 * down or not.
 *
 * @method Phaser.GameObjects.GameObjectFactory#isotriangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso triangle in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso triangle. The left and right faces will be this tall. The overall height of the iso triangle will be this value plus half the `size` value.
 * @param {boolean} [reversed=false] - Is the iso triangle upside down?
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso triangle.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso triangle.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso triangle.
 *
 * @return {Phaser.GameObjects.IsoTriangle} The Game Object that was created.
 */ GameObjectFactory.register('isotriangle', function(x, y, size, height, reversed, fillTop, fillLeft, fillRight) {
                    return this.displayList.add(new IsoTriangle(this.scene, x, y, size, height, reversed, fillTop, fillLeft, fillRight));
                });
            /***/ },
            /***/ 60561: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(51503);
                renderCanvas = __webpack_require__(79590);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 51503: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoTriangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.IsoTriangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoTriangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    var size = src.width;
                    var height = src.height;
                    var sizeA = size / 2;
                    var sizeB = size / src.projection;
                    var reversed = src.isReversed;
                    var alpha = camera.alpha * src.alpha;
                    if (!src.isFilled) return;
                    renderer.pipelines.preBatch(src);
                    var tint;
                    var x0;
                    var y0;
                    var x1;
                    var y1;
                    var x2;
                    var y2;
                    //  Top Face
                    if (src.showTop && reversed) {
                        tint = Utils.getTintAppendFloatAlpha(src.fillTop, alpha);
                        x0 = calcMatrix.getX(-sizeA, -height);
                        y0 = calcMatrix.getY(-sizeA, -height);
                        x1 = calcMatrix.getX(0, -sizeB - height);
                        y1 = calcMatrix.getY(0, -sizeB - height);
                        x2 = calcMatrix.getX(sizeA, -height);
                        y2 = calcMatrix.getY(sizeA, -height);
                        var x3 = calcMatrix.getX(0, sizeB - height);
                        var y3 = calcMatrix.getY(0, sizeB - height);
                        pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                    }
                    //  Left Face
                    if (src.showLeft) {
                        tint = Utils.getTintAppendFloatAlpha(src.fillLeft, alpha);
                        if (reversed) {
                            x0 = calcMatrix.getX(-sizeA, -height);
                            y0 = calcMatrix.getY(-sizeA, -height);
                            x1 = calcMatrix.getX(0, sizeB);
                            y1 = calcMatrix.getY(0, sizeB);
                            x2 = calcMatrix.getX(0, sizeB - height);
                            y2 = calcMatrix.getY(0, sizeB - height);
                        } else {
                            x0 = calcMatrix.getX(-sizeA, 0);
                            y0 = calcMatrix.getY(-sizeA, 0);
                            x1 = calcMatrix.getX(0, sizeB);
                            y1 = calcMatrix.getY(0, sizeB);
                            x2 = calcMatrix.getX(0, sizeB - height);
                            y2 = calcMatrix.getY(0, sizeB - height);
                        }
                        pipeline.batchTri(src, x0, y0, x1, y1, x2, y2, 0, 0, 1, 1, tint, tint, tint, 2);
                    }
                    //  Right Face
                    if (src.showRight) {
                        tint = Utils.getTintAppendFloatAlpha(src.fillRight, alpha);
                        if (reversed) {
                            x0 = calcMatrix.getX(sizeA, -height);
                            y0 = calcMatrix.getY(sizeA, -height);
                            x1 = calcMatrix.getX(0, sizeB);
                            y1 = calcMatrix.getY(0, sizeB);
                            x2 = calcMatrix.getX(0, sizeB - height);
                            y2 = calcMatrix.getY(0, sizeB - height);
                        } else {
                            x0 = calcMatrix.getX(sizeA, 0);
                            y0 = calcMatrix.getY(sizeA, 0);
                            x1 = calcMatrix.getX(0, sizeB);
                            y1 = calcMatrix.getY(0, sizeB);
                            x2 = calcMatrix.getX(0, sizeB - height);
                            y2 = calcMatrix.getY(0, sizeB - height);
                        }
                        pipeline.batchTri(src, x0, y0, x1, y1, x2, y2, 0, 0, 1, 1, tint, tint, tint, 2);
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = IsoTriangleWebGLRenderer;
            /***/ },
            /***/ 57847: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Shape = __webpack_require__(17803);
                var GeomLine = __webpack_require__(23031);
                var LineRender = __webpack_require__(36823);
                /**
 * @classdesc
 * The Line Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only stroke colors and cannot be filled.
 *
 * A Line Shape allows you to draw a line between two points in your game. You can control the
 * stroke color and thickness of the line. In WebGL only you can also specify a different
 * thickness for the start and end of the line, allowing you to render lines that taper-off.
 *
 * If you need to draw multiple lines in a sequence you may wish to use the Polygon Shape instead.
 *
 * Be aware that as with all Game Objects the default origin is 0.5. If you need to draw a Line
 * between two points and want the x1/y1 values to match the x/y values, then set the origin to 0.
 *
 * @class Line
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the start of the line.
 * @param {number} [y1=0] - The vertical position of the start of the line.
 * @param {number} [x2=128] - The horizontal position of the end of the line.
 * @param {number} [y2=0] - The vertical position of the end of the line.
 * @param {number} [strokeColor] - The color the line will be drawn in, i.e. 0xff0000 for red.
 * @param {number} [strokeAlpha] - The alpha the line will be drawn in. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Line = new Class({
                    Extends: Shape,
                    Mixins: [
                        LineRender
                    ],
                    initialize: function Line(scene, x, y, x1, y1, x2, y2, strokeColor, strokeAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (x1 === undefined) x1 = 0;
                        if (y1 === undefined) y1 = 0;
                        if (x2 === undefined) x2 = 128;
                        if (y2 === undefined) y2 = 0;
                        Shape.call(this, scene, 'Line', new GeomLine(x1, y1, x2, y2));
                        var width = Math.max(1, this.geom.right - this.geom.left);
                        var height = Math.max(1, this.geom.bottom - this.geom.top);
                        /**
         * The width (or thickness) of the line.
         * See the setLineWidth method for extra details on changing this on WebGL.
         *
         * @name Phaser.GameObjects.Line#lineWidth
         * @type {number}
         * @since 3.13.0
         */ this.lineWidth = 1;
                        /**
         * Private internal value. Holds the start width of the line.
         *
         * @name Phaser.GameObjects.Line#_startWidth
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._startWidth = 1;
                        /**
         * Private internal value. Holds the end width of the line.
         *
         * @name Phaser.GameObjects.Line#_endWidth
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._endWidth = 1;
                        this.setPosition(x, y);
                        this.setSize(width, height);
                        if (strokeColor !== undefined) this.setStrokeStyle(1, strokeColor, strokeAlpha);
                        this.updateDisplayOrigin();
                    },
                    /**
     * Sets the width of the line.
     *
     * When using the WebGL renderer you can have different start and end widths.
     * When using the Canvas renderer only the `startWidth` value is used. The `endWidth` is ignored.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Line#setLineWidth
     * @since 3.13.0
     *
     * @param {number} startWidth - The start width of the line.
     * @param {number} [endWidth] - The end width of the line. Only used in WebGL.
     *
     * @return {this} This Game Object instance.
     */ setLineWidth: function(startWidth, endWidth) {
                        if (endWidth === undefined) endWidth = startWidth;
                        this._startWidth = startWidth;
                        this._endWidth = endWidth;
                        this.lineWidth = startWidth;
                        return this;
                    },
                    /**
     * Sets the start and end coordinates of this Line.
     *
     * @method Phaser.GameObjects.Line#setTo
     * @since 3.13.0
     *
     * @param {number} [x1=0] - The horizontal position of the start of the line.
     * @param {number} [y1=0] - The vertical position of the start of the line.
     * @param {number} [x2=0] - The horizontal position of the end of the line.
     * @param {number} [y2=0] - The vertical position of the end of the line.
     *
     * @return {this} This Line object.
     */ setTo: function(x1, y1, x2, y2) {
                        this.geom.setTo(x1, y1, x2, y2);
                        return this;
                    }
                });
                module1.exports = Line;
            /***/ },
            /***/ 17440: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Line#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Line} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LineCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = src._displayOriginX;
                        var dy = src._displayOriginY;
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.beginPath();
                            ctx.moveTo(src.geom.x1 - dx, src.geom.y1 - dy);
                            ctx.lineTo(src.geom.x2 - dx, src.geom.y2 - dy);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = LineCanvasRenderer;
            /***/ },
            /***/ 2481: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var Line = __webpack_require__(57847);
                /**
 * Creates a new Line Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Line Game Object has been built into Phaser.
 *
 * The Line Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only stroke colors and cannot be filled.
 *
 * A Line Shape allows you to draw a line between two points in your game. You can control the
 * stroke color and thickness of the line. In WebGL only you can also specify a different
 * thickness for the start and end of the line, allowing you to render lines that taper-off.
 *
 * If you need to draw multiple lines in a sequence you may wish to use the Polygon Shape instead.
 *
 * @method Phaser.GameObjects.GameObjectFactory#line
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the start of the line.
 * @param {number} [y1=0] - The vertical position of the start of the line.
 * @param {number} [x2=128] - The horizontal position of the end of the line.
 * @param {number} [y2=0] - The vertical position of the end of the line.
 * @param {number} [strokeColor] - The color the line will be drawn in, i.e. 0xff0000 for red.
 * @param {number} [strokeAlpha] - The alpha the line will be drawn in. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Line} The Game Object that was created.
 */ GameObjectFactory.register('line', function(x, y, x1, y1, x2, y2, strokeColor, strokeAlpha) {
                    return this.displayList.add(new Line(this.scene, x, y, x1, y1, x2, y2, strokeColor, strokeAlpha));
                });
            /***/ },
            /***/ 36823: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(77385);
                renderCanvas = __webpack_require__(17440);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 77385: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Line#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Line} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LineWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isStroked) {
                        var strokeTint = pipeline.strokeTint;
                        var color = Utils.getTintAppendFloatAlpha(src.strokeColor, src.strokeAlpha * alpha);
                        strokeTint.TL = color;
                        strokeTint.TR = color;
                        strokeTint.BL = color;
                        strokeTint.BR = color;
                        pipeline.batchLine(src.geom.x1 - dx, src.geom.y1 - dy, src.geom.x2 - dx, src.geom.y2 - dy, src._startWidth / 2, src._endWidth / 2, 1, 0, false, result.sprite, result.camera);
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = LineWebGLRenderer;
            /***/ },
            /***/ 24949: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PolygonRender = __webpack_require__(90273);
                var Class = __webpack_require__(83419);
                var Earcut = __webpack_require__(94811);
                var GetAABB = __webpack_require__(13829);
                var GeomPolygon = __webpack_require__(25717);
                var Shape = __webpack_require__(17803);
                var Smooth = __webpack_require__(5469);
                /**
 * @classdesc
 * The Polygon Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * The Polygon Shape is created by providing a list of points, which are then used to create an
 * internal Polygon geometry object. The points can be set from a variety of formats:
 *
 * - A string containing paired values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
 * - An array of Point or Vector2 objects: `[new Phaser.Math.Vector2(x1, y1), ...]`
 * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 *
 * By default the `x` and `y` coordinates of this Shape refer to the center of it. However, depending
 * on the coordinates of the points provided, the final shape may be rendered offset from its origin.
 *
 * Note: The method `getBounds` will return incorrect bounds if any of the points in the Polygon are negative.
 * If this is the case, please use the function `Phaser.Geom.Polygon.GetAABB(polygon.geom)` instead and then
 * adjust the returned Rectangle position accordingly.
 *
 * @class Polygon
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {any} [points] - The points that make up the polygon.
 * @param {number} [fillColor] - The color the polygon will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the polygon will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Polygon = new Class({
                    Extends: Shape,
                    Mixins: [
                        PolygonRender
                    ],
                    initialize: function Polygon(scene, x, y, points, fillColor, fillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        Shape.call(this, scene, 'Polygon', new GeomPolygon(points));
                        var bounds = GetAABB(this.geom);
                        this.setPosition(x, y);
                        this.setSize(bounds.width, bounds.height);
                        if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                        this.updateDisplayOrigin();
                        this.updateData();
                    },
                    /**
     * Smooths the polygon over the number of iterations specified.
     * The base polygon data will be updated and replaced with the smoothed values.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Polygon#smooth
     * @since 3.13.0
     *
     * @param {number} [iterations=1] - The number of times to apply the polygon smoothing.
     *
     * @return {this} This Game Object instance.
     */ smooth: function(iterations) {
                        if (iterations === undefined) iterations = 1;
                        for(var i = 0; i < iterations; i++)Smooth(this.geom);
                        return this.updateData();
                    },
                    /**
     * Sets this Polygon to the given points.
     *
     * The points can be set from a variety of formats:
     *
     * - A string containing paired values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
     * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
     * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
     * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
     * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
     *
     * Calling this method will reset the size (width, height) and display origin of this Shape.
     *
     * It also runs both GetAABB and EarCut on the given points, so please be careful not to do this
     * at a high frequency, or with too many points.
     *
     * @method Phaser.GameObjects.Polygon#setTo
     * @since 3.60.0
     *
     * @param {(string|number[]|Phaser.Types.Math.Vector2Like[])} [points] - Points defining the perimeter of this polygon. Please check function description above for the different supported formats.
     *
     * @return {this} This Game Object instance.
     */ setTo: function(points) {
                        this.geom.setTo(points);
                        var bounds = GetAABB(this.geom);
                        this.setSize(bounds.width, bounds.height);
                        this.updateDisplayOrigin();
                        return this.updateData();
                    },
                    /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Polygon#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                        var path = [];
                        var points = this.geom.points;
                        for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                        path.push(points[0].x, points[0].y);
                        this.pathIndexes = Earcut(path);
                        this.pathData = path;
                        return this;
                    }
                });
                module1.exports = Polygon;
            /***/ },
            /***/ 38710: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Polygon#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Polygon} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PolygonCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = src._displayOriginX;
                        var dy = src._displayOriginY;
                        var path = src.pathData;
                        var pathLength = path.length - 1;
                        var px1 = path[0] - dx;
                        var py1 = path[1] - dy;
                        ctx.beginPath();
                        ctx.moveTo(px1, py1);
                        if (!src.closePath) pathLength -= 2;
                        for(var i = 2; i < pathLength; i += 2){
                            var px2 = path[i] - dx;
                            var py2 = path[i + 1] - dy;
                            ctx.lineTo(px2, py2);
                        }
                        if (src.closePath) ctx.closePath();
                        if (src.isFilled) {
                            FillStyleCanvas(ctx, src);
                            ctx.fill();
                        }
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = PolygonCanvasRenderer;
            /***/ },
            /***/ 64827: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var Polygon = __webpack_require__(24949);
                /**
 * Creates a new Polygon Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Polygon Game Object has been built into Phaser.
 *
 * The Polygon Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * The Polygon Shape is created by providing a list of points, which are then used to create an
 * internal Polygon geometry object. The points can be set from a variety of formats:
 *
 * - An array of Point or Vector2 objects: `[new Phaser.Math.Vector2(x1, y1), ...]`
 * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 *
 * By default the `x` and `y` coordinates of this Shape refer to the center of it. However, depending
 * on the coordinates of the points provided, the final shape may be rendered offset from its origin.
 *
 * @method Phaser.GameObjects.GameObjectFactory#polygon
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {any} [points] - The points that make up the polygon.
 * @param {number} [fillColor] - The color the polygon will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the polygon will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Polygon} The Game Object that was created.
 */ GameObjectFactory.register('polygon', function(x, y, points, fillColor, fillAlpha) {
                    return this.displayList.add(new Polygon(this.scene, x, y, points, fillColor, fillAlpha));
                });
            /***/ },
            /***/ 90273: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(73695);
                renderCanvas = __webpack_require__(38710);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 73695: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(10441);
                var GetCalcMatrix = __webpack_require__(91296);
                var StrokePathWebGL = __webpack_require__(34682);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Polygon#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Polygon} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PolygonWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                    if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = PolygonWebGLRenderer;
            /***/ },
            /***/ 74561: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GeomRectangle = __webpack_require__(87841);
                var Shape = __webpack_require__(17803);
                var RectangleRender = __webpack_require__(95597);
                /**
 * @classdesc
 * The Rectangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * You can change the size of the rectangle by changing the `width` and `height` properties.
 *
 * @class Rectangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the rectangle.
 * @param {number} [height=128] - The height of the rectangle.
 * @param {number} [fillColor] - The color the rectangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the rectangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Rectangle = new Class({
                    Extends: Shape,
                    Mixins: [
                        RectangleRender
                    ],
                    initialize: function Rectangle(scene, x, y, width, height, fillColor, fillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 128;
                        if (height === undefined) height = 128;
                        Shape.call(this, scene, 'Rectangle', new GeomRectangle(0, 0, width, height));
                        this.setPosition(x, y);
                        this.setSize(width, height);
                        if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                        this.updateDisplayOrigin();
                        this.updateData();
                    },
                    /**
     * Sets the internal size of this Rectangle, as used for frame or physics body creation.
     *
     * If you have assigned a custom input hit area for this Rectangle, changing the Rectangle size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Rectangle#setSize
     * @since 3.13.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        this.geom.setSize(width, height);
                        this.updateData();
                        this.updateDisplayOrigin();
                        var input = this.input;
                        if (input && !input.customHitArea) {
                            input.hitArea.width = width;
                            input.hitArea.height = height;
                        }
                        return this;
                    },
                    /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Rectangle#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                        var path = [];
                        var rect = this.geom;
                        var line = this._tempLine;
                        rect.getLineA(line);
                        path.push(line.x1, line.y1, line.x2, line.y2);
                        rect.getLineB(line);
                        path.push(line.x2, line.y2);
                        rect.getLineC(line);
                        path.push(line.x2, line.y2);
                        rect.getLineD(line);
                        path.push(line.x2, line.y2);
                        this.pathData = path;
                        return this;
                    }
                });
                module1.exports = Rectangle;
            /***/ },
            /***/ 48682: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rectangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Rectangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RectangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = src._displayOriginX;
                        var dy = src._displayOriginY;
                        if (src.isFilled) {
                            FillStyleCanvas(ctx, src);
                            ctx.fillRect(-dx, -dy, src.width, src.height);
                        }
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.beginPath();
                            ctx.rect(-dx, -dy, src.width, src.height);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = RectangleCanvasRenderer;
            /***/ },
            /***/ 87959: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var Rectangle = __webpack_require__(74561);
                /**
 * Creates a new Rectangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Rectangle Game Object has been built into Phaser.
 *
 * The Rectangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * You can change the size of the rectangle by changing the `width` and `height` properties.
 *
 * @method Phaser.GameObjects.GameObjectFactory#rectangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the rectangle.
 * @param {number} [height=128] - The height of the rectangle.
 * @param {number} [fillColor] - The color the rectangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the rectangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Rectangle} The Game Object that was created.
 */ GameObjectFactory.register('rectangle', function(x, y, width, height, fillColor, fillAlpha) {
                    return this.displayList.add(new Rectangle(this.scene, x, y, width, height, fillColor, fillAlpha));
                });
            /***/ },
            /***/ 95597: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(52059);
                renderCanvas = __webpack_require__(48682);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 52059: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var StrokePathWebGL = __webpack_require__(34682);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rectangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Rectangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RectangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isFilled) {
                        var fillTint = pipeline.fillTint;
                        var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                        fillTint.TL = fillTintColor;
                        fillTint.TR = fillTintColor;
                        fillTint.BL = fillTintColor;
                        fillTint.BR = fillTintColor;
                        pipeline.batchFillRect(-dx, -dy, src.width, src.height);
                    }
                    if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = RectangleWebGLRenderer;
            /***/ },
            /***/ 55911: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var StarRender = __webpack_require__(81991);
                var Class = __webpack_require__(83419);
                var Earcut = __webpack_require__(94811);
                var Shape = __webpack_require__(17803);
                /**
 * @classdesc
 * The Star Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * As the name implies, the Star shape will display a star in your game. You can control several
 * aspects of it including the number of points that constitute the star. The default is 5. If
 * you change it to 4 it will render as a diamond. If you increase them, you'll get a more spiky
 * star shape.
 *
 * You can also control the inner and outer radius, which is how 'long' each point of the star is.
 * Modify these values to create more interesting shapes.
 *
 * @class Star
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [points=5] - The number of points on the star.
 * @param {number} [innerRadius=32] - The inner radius of the star.
 * @param {number} [outerRadius=64] - The outer radius of the star.
 * @param {number} [fillColor] - The color the star will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the star will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Star = new Class({
                    Extends: Shape,
                    Mixins: [
                        StarRender
                    ],
                    initialize: function Star(scene, x, y, points, innerRadius, outerRadius, fillColor, fillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (points === undefined) points = 5;
                        if (innerRadius === undefined) innerRadius = 32;
                        if (outerRadius === undefined) outerRadius = 64;
                        Shape.call(this, scene, 'Star', null);
                        /**
         * Private internal value.
         * The number of points in the star.
         *
         * @name Phaser.GameObjects.Star#_points
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._points = points;
                        /**
         * Private internal value.
         * The inner radius of the star.
         *
         * @name Phaser.GameObjects.Star#_innerRadius
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._innerRadius = innerRadius;
                        /**
         * Private internal value.
         * The outer radius of the star.
         *
         * @name Phaser.GameObjects.Star#_outerRadius
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._outerRadius = outerRadius;
                        this.setPosition(x, y);
                        this.setSize(outerRadius * 2, outerRadius * 2);
                        if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                        this.updateDisplayOrigin();
                        this.updateData();
                    },
                    /**
     * Sets the number of points that make up the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setPoints
     * @since 3.13.0
     *
     * @param {number} value - The amount of points the Star will have.
     *
     * @return {this} This Game Object instance.
     */ setPoints: function(value) {
                        this._points = value;
                        return this.updateData();
                    },
                    /**
     * Sets the inner radius of the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setInnerRadius
     * @since 3.13.0
     *
     * @param {number} value - The amount to set the inner radius to.
     *
     * @return {this} This Game Object instance.
     */ setInnerRadius: function(value) {
                        this._innerRadius = value;
                        return this.updateData();
                    },
                    /**
     * Sets the outer radius of the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setOuterRadius
     * @since 3.13.0
     *
     * @param {number} value - The amount to set the outer radius to.
     *
     * @return {this} This Game Object instance.
     */ setOuterRadius: function(value) {
                        this._outerRadius = value;
                        return this.updateData();
                    },
                    /**
     * The number of points that make up the Star shape.
     *
     * @name Phaser.GameObjects.Star#points
     * @type {number}
     * @default 5
     * @since 3.13.0
     */ points: {
                        get: function() {
                            return this._points;
                        },
                        set: function(value) {
                            this._points = value;
                            this.updateData();
                        }
                    },
                    /**
     * The inner radius of the Star shape.
     *
     * @name Phaser.GameObjects.Star#innerRadius
     * @type {number}
     * @default 32
     * @since 3.13.0
     */ innerRadius: {
                        get: function() {
                            return this._innerRadius;
                        },
                        set: function(value) {
                            this._innerRadius = value;
                            this.updateData();
                        }
                    },
                    /**
     * The outer radius of the Star shape.
     *
     * @name Phaser.GameObjects.Star#outerRadius
     * @type {number}
     * @default 64
     * @since 3.13.0
     */ outerRadius: {
                        get: function() {
                            return this._outerRadius;
                        },
                        set: function(value) {
                            this._outerRadius = value;
                            this.updateData();
                        }
                    },
                    /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Star#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                        var path = [];
                        var points = this._points;
                        var innerRadius = this._innerRadius;
                        var outerRadius = this._outerRadius;
                        var rot = Math.PI / 2 * 3;
                        var step = Math.PI / points;
                        //  So origin 0.5 = the center of the star
                        var x = outerRadius;
                        var y = outerRadius;
                        path.push(x, y + -outerRadius);
                        for(var i = 0; i < points; i++){
                            path.push(x + Math.cos(rot) * outerRadius, y + Math.sin(rot) * outerRadius);
                            rot += step;
                            path.push(x + Math.cos(rot) * innerRadius, y + Math.sin(rot) * innerRadius);
                            rot += step;
                        }
                        path.push(x, y + -outerRadius);
                        this.pathIndexes = Earcut(path);
                        this.pathData = path;
                        return this;
                    }
                });
                module1.exports = Star;
            /***/ },
            /***/ 64272: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Star#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Star} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var StarCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = src._displayOriginX;
                        var dy = src._displayOriginY;
                        var path = src.pathData;
                        var pathLength = path.length - 1;
                        var px1 = path[0] - dx;
                        var py1 = path[1] - dy;
                        ctx.beginPath();
                        ctx.moveTo(px1, py1);
                        if (!src.closePath) pathLength -= 2;
                        for(var i = 2; i < pathLength; i += 2){
                            var px2 = path[i] - dx;
                            var py2 = path[i + 1] - dy;
                            ctx.lineTo(px2, py2);
                        }
                        ctx.closePath();
                        if (src.isFilled) {
                            FillStyleCanvas(ctx, src);
                            ctx.fill();
                        }
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = StarCanvasRenderer;
            /***/ },
            /***/ 93697: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Star = __webpack_require__(55911);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Star Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Star Game Object has been built into Phaser.
 *
 * The Star Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * As the name implies, the Star shape will display a star in your game. You can control several
 * aspects of it including the number of points that constitute the star. The default is 5. If
 * you change it to 4 it will render as a diamond. If you increase them, you'll get a more spiky
 * star shape.
 *
 * You can also control the inner and outer radius, which is how 'long' each point of the star is.
 * Modify these values to create more interesting shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#star
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [points=5] - The number of points on the star.
 * @param {number} [innerRadius=32] - The inner radius of the star.
 * @param {number} [outerRadius=64] - The outer radius of the star.
 * @param {number} [fillColor] - The color the star will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the star will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Star} The Game Object that was created.
 */ GameObjectFactory.register('star', function(x, y, points, innerRadius, outerRadius, fillColor, fillAlpha) {
                    return this.displayList.add(new Star(this.scene, x, y, points, innerRadius, outerRadius, fillColor, fillAlpha));
                });
            /***/ },
            /***/ 81991: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(57017);
                renderCanvas = __webpack_require__(64272);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 57017: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(10441);
                var GetCalcMatrix = __webpack_require__(91296);
                var StrokePathWebGL = __webpack_require__(34682);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Star#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Star} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var StarWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                    if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = StarWebGLRenderer;
            /***/ },
            /***/ 36931: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Shape = __webpack_require__(17803);
                var GeomTriangle = __webpack_require__(16483);
                var TriangleRender = __webpack_require__(96195);
                /**
 * @classdesc
 * The Triangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * The Triangle consists of 3 lines, joining up to form a triangular shape. You can control the
 * position of each point of these lines. The triangle is always closed and cannot have an open
 * face. If you require that, consider using a Polygon instead.
 *
 * @class Triangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
 * @param {number} [y1=128] - The vertical position of the first point in the triangle.
 * @param {number} [x2=64] - The horizontal position of the second point in the triangle.
 * @param {number} [y2=0] - The vertical position of the second point in the triangle.
 * @param {number} [x3=128] - The horizontal position of the third point in the triangle.
 * @param {number} [y3=128] - The vertical position of the third point in the triangle.
 * @param {number} [fillColor] - The color the triangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the triangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Triangle = new Class({
                    Extends: Shape,
                    Mixins: [
                        TriangleRender
                    ],
                    initialize: function Triangle(scene, x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (x1 === undefined) x1 = 0;
                        if (y1 === undefined) y1 = 128;
                        if (x2 === undefined) x2 = 64;
                        if (y2 === undefined) y2 = 0;
                        if (x3 === undefined) x3 = 128;
                        if (y3 === undefined) y3 = 128;
                        Shape.call(this, scene, 'Triangle', new GeomTriangle(x1, y1, x2, y2, x3, y3));
                        var width = this.geom.right - this.geom.left;
                        var height = this.geom.bottom - this.geom.top;
                        this.setPosition(x, y);
                        this.setSize(width, height);
                        if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                        this.updateDisplayOrigin();
                        this.updateData();
                    },
                    /**
     * Sets the data for the lines that make up this Triangle shape.
     *
     * @method Phaser.GameObjects.Triangle#setTo
     * @since 3.13.0
     *
     * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
     * @param {number} [y1=0] - The vertical position of the first point in the triangle.
     * @param {number} [x2=0] - The horizontal position of the second point in the triangle.
     * @param {number} [y2=0] - The vertical position of the second point in the triangle.
     * @param {number} [x3=0] - The horizontal position of the third point in the triangle.
     * @param {number} [y3=0] - The vertical position of the third point in the triangle.
     *
     * @return {this} This Game Object instance.
     */ setTo: function(x1, y1, x2, y2, x3, y3) {
                        this.geom.setTo(x1, y1, x2, y2, x3, y3);
                        return this.updateData();
                    },
                    /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Triangle#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                        var path = [];
                        var tri = this.geom;
                        var line = this._tempLine;
                        tri.getLineA(line);
                        path.push(line.x1, line.y1, line.x2, line.y2);
                        tri.getLineB(line);
                        path.push(line.x2, line.y2);
                        tri.getLineC(line);
                        path.push(line.x2, line.y2);
                        this.pathData = path;
                        return this;
                    }
                });
                module1.exports = Triangle;
            /***/ },
            /***/ 85172: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(65960);
                var LineStyleCanvas = __webpack_require__(75177);
                var SetTransform = __webpack_require__(20926);
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Triangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Triangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TriangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var ctx = renderer.currentContext;
                    if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                        var dx = src._displayOriginX;
                        var dy = src._displayOriginY;
                        var x1 = src.geom.x1 - dx;
                        var y1 = src.geom.y1 - dy;
                        var x2 = src.geom.x2 - dx;
                        var y2 = src.geom.y2 - dy;
                        var x3 = src.geom.x3 - dx;
                        var y3 = src.geom.y3 - dy;
                        ctx.beginPath();
                        ctx.moveTo(x1, y1);
                        ctx.lineTo(x2, y2);
                        ctx.lineTo(x3, y3);
                        ctx.closePath();
                        if (src.isFilled) {
                            FillStyleCanvas(ctx, src);
                            ctx.fill();
                        }
                        if (src.isStroked) {
                            LineStyleCanvas(ctx, src);
                            ctx.stroke();
                        }
                        //  Restore the context saved in SetTransform
                        ctx.restore();
                    }
                };
                module1.exports = TriangleCanvasRenderer;
            /***/ },
            /***/ 45245: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var Triangle = __webpack_require__(36931);
                /**
 * Creates a new Triangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Triangle Game Object has been built into Phaser.
 *
 * The Triangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * The Triangle consists of 3 lines, joining up to form a triangular shape. You can control the
 * position of each point of these lines. The triangle is always closed and cannot have an open
 * face. If you require that, consider using a Polygon instead.
 *
 * @method Phaser.GameObjects.GameObjectFactory#triangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
 * @param {number} [y1=128] - The vertical position of the first point in the triangle.
 * @param {number} [x2=64] - The horizontal position of the second point in the triangle.
 * @param {number} [y2=0] - The vertical position of the second point in the triangle.
 * @param {number} [x3=128] - The horizontal position of the third point in the triangle.
 * @param {number} [y3=128] - The vertical position of the third point in the triangle.
 * @param {number} [fillColor] - The color the triangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the triangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Triangle} The Game Object that was created.
 */ GameObjectFactory.register('triangle', function(x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha) {
                    return this.displayList.add(new Triangle(this.scene, x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha));
                });
            /***/ },
            /***/ 96195: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(83253);
                renderCanvas = __webpack_require__(85172);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 83253: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                var StrokePathWebGL = __webpack_require__(34682);
                var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Triangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Triangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TriangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    var pipeline = renderer.pipelines.set(src.pipeline);
                    var result = GetCalcMatrix(src, camera, parentMatrix);
                    pipeline.calcMatrix.copyFrom(result.calc);
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    renderer.pipelines.preBatch(src);
                    if (src.isFilled) {
                        var fillTint = pipeline.fillTint;
                        var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                        fillTint.TL = fillTintColor;
                        fillTint.TR = fillTintColor;
                        fillTint.BL = fillTintColor;
                        fillTint.BR = fillTintColor;
                        var x1 = src.geom.x1 - dx;
                        var y1 = src.geom.y1 - dy;
                        var x2 = src.geom.x2 - dx;
                        var y2 = src.geom.y2 - dy;
                        var x3 = src.geom.x3 - dx;
                        var y3 = src.geom.y3 - dy;
                        pipeline.batchFillTriangle(x1, y1, x2, y2, x3, y3, result.sprite, result.camera);
                    }
                    if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = TriangleWebGLRenderer;
            /***/ },
            /***/ 68287: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(9674);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var SpriteRender = __webpack_require__(92751);
                /**
 * @classdesc
 * A Sprite Game Object.
 *
 * A Sprite Game Object is used for the display of both static and animated images in your game.
 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
 * and animated.
 *
 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var Sprite = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.Depth,
                        Components.Flip,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Size,
                        Components.TextureCrop,
                        Components.Tint,
                        Components.Transform,
                        Components.Visible,
                        SpriteRender
                    ],
                    initialize: function Sprite(scene, x, y, texture, frame) {
                        GameObject.call(this, scene, 'Sprite');
                        /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Sprite#_crop
         * @type {object}
         * @private
         * @since 3.11.0
         */ this._crop = this.resetCropObject();
                        /**
         * The Animation State component of this Sprite.
         *
         * This component provides features to apply animations to this Sprite.
         * It is responsible for playing, loading, queuing animations for later playback,
         * mixing between animations and setting the current animation frame to this Sprite.
         *
         * @name Phaser.GameObjects.Sprite#anims
         * @type {Phaser.Animations.AnimationState}
         * @since 3.0.0
         */ this.anims = new AnimationState(this);
                        this.setTexture(texture, frame);
                        this.setPosition(x, y);
                        this.setSizeToFrame();
                        this.setOriginFromFrame();
                        this.initPipeline();
                        this.initPostPipeline(true);
                    },
                    //  Overrides Game Object method
                    addedToScene: function() {
                        this.scene.sys.updateList.add(this);
                    },
                    //  Overrides Game Object method
                    removedFromScene: function() {
                        this.scene.sys.updateList.remove(this);
                    },
                    /**
     * Update this Sprite's animations.
     *
     * @method Phaser.GameObjects.Sprite#preUpdate
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                        this.anims.update(time, delta);
                    },
                    /**
     * Start playing the given animation on this Sprite.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).play('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).play({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Sprite#play
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ play: function(key, ignoreIfPlaying) {
                        return this.anims.play(key, ignoreIfPlaying);
                    },
                    /**
     * Start playing the given animation on this Sprite, in reverse.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Sprite#playReverse
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ playReverse: function(key, ignoreIfPlaying) {
                        return this.anims.playReverse(key, ignoreIfPlaying);
                    },
                    /**
     * Waits for the specified delay, in milliseconds, then starts playback of the given animation.
     *
     * If the animation _also_ has a delay value set in its config, it will be **added** to the delay given here.
     *
     * If an animation is already running and a new animation is given to this method, it will wait for
     * the given delay before starting the new animation.
     *
     * If no animation is currently running, the given one begins after the delay.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * Prior to Phaser 3.50 this method was called 'delayedPlay'.
     *
     * @method Phaser.GameObjects.Sprite#playAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} delay - The delay, in milliseconds, to wait before starting the animation playing.
     *
     * @return {this} This Game Object.
     */ playAfterDelay: function(key, delay) {
                        return this.anims.playAfterDelay(key, delay);
                    },
                    /**
     * Waits for the current animation to complete the `repeatCount` number of repeat cycles, then starts playback
     * of the given animation.
     *
     * You can use this to ensure there are no harsh jumps between two sets of animations, i.e. going from an
     * idle animation to a walking animation, by making them blend smoothly into each other.
     *
     * If no animation is currently running, the given one will start immediately.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Sprite#playAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} [repeatCount=1] - How many times should the animation repeat before the next one starts?
     *
     * @return {this} This Game Object.
     */ playAfterRepeat: function(key, repeatCount) {
                        return this.anims.playAfterRepeat(key, repeatCount);
                    },
                    /**
     * Sets an animation, or an array of animations, to be played immediately after the current one completes or stops.
     *
     * The current animation must enter a 'completed' state for this to happen, i.e. finish all of its repeats, delays, etc,
     * or have the `stop` method called directly on it.
     *
     * An animation set to repeat forever will never enter a completed state.
     *
     * You can chain a new animation at any point, including before the current one starts playing, during it,
     * or when it ends (via its `animationcomplete` event).
     *
     * Chained animations are specific to a Game Object, meaning different Game Objects can have different chained
     * animations without impacting the animation they're playing.
     *
     * Call this method with no arguments to reset all currently chained animations.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Sprite#chain
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig|string[]|Phaser.Animations.Animation[]|Phaser.Types.Animations.PlayAnimationConfig[])} [key] - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object, or an array of them.
     *
     * @return {this} This Game Object.
     */ chain: function(key) {
                        return this.anims.chain(key);
                    },
                    /**
     * Immediately stops the current animation from playing and dispatches the `ANIMATION_STOP` events.
     *
     * If no animation is playing, no event will be dispatched.
     *
     * If there is another animation queued (via the `chain` method) then it will start playing immediately.
     *
     * @method Phaser.GameObjects.Sprite#stop
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @return {this} This Game Object.
     */ stop: function() {
                        return this.anims.stop();
                    },
                    /**
     * Stops the current animation from playing after the specified time delay, given in milliseconds.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} delay - The number of milliseconds to wait before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopAfterDelay: function(delay) {
                        return this.anims.stopAfterDelay(delay);
                    },
                    /**
     * Stops the current animation from playing after the given number of repeats.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} [repeatCount=1] - How many times should the animation repeat before stopping?
     *
     * @return {this} This Game Object.
     */ stopAfterRepeat: function(repeatCount) {
                        return this.anims.stopAfterRepeat(repeatCount);
                    },
                    /**
     * Stops the current animation from playing when it next sets the given frame.
     * If this frame doesn't exist within the animation it will not stop it from playing.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopOnFrame
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The frame to check before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopOnFrame: function(frame) {
                        return this.anims.stopOnFrame(frame);
                    },
                    /**
     * Build a JSON representation of this Sprite.
     *
     * @method Phaser.GameObjects.Sprite#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                        return Components.ToJSON(this);
                    },
                    /**
     * Handles the pre-destroy step for the Sprite, which removes the Animation component.
     *
     * @method Phaser.GameObjects.Sprite#preDestroy
     * @private
     * @since 3.14.0
     */ preDestroy: function() {
                        this.anims.destroy();
                        this.anims = undefined;
                    }
                });
                module1.exports = Sprite;
            /***/ },
            /***/ 76552: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Sprite#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var SpriteCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    renderer.batchSprite(src, src.frame, camera, parentMatrix);
                };
                module1.exports = SpriteCanvasRenderer;
            /***/ },
            /***/ 15567: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var BuildGameObjectAnimation = __webpack_require__(13059);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var Sprite = __webpack_require__(68287);
                /**
 * Creates a new Sprite Game Object and returns it.
 *
 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#sprite
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene=true] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
 */ GameObjectCreator.register('sprite', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var frame = GetAdvancedValue(config, 'frame', null);
                    var sprite = new Sprite(this.scene, 0, 0, key, frame);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, sprite, config);
                    //  Sprite specific config options:
                    BuildGameObjectAnimation(sprite, config);
                    return sprite;
                });
            /***/ },
            /***/ 46409: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var Sprite = __webpack_require__(68287);
                /**
 * Creates a new Sprite Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#sprite
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
 */ GameObjectFactory.register('sprite', function(x, y, texture, frame) {
                    return this.displayList.add(new Sprite(this.scene, x, y, texture, frame));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 92751: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(9409);
                renderCanvas = __webpack_require__(76552);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 9409: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Sprite#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var SpriteWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    camera.addToRenderList(src);
                    src.pipeline.batchSprite(src, camera, parentMatrix);
                };
                module1.exports = SpriteWebGLRenderer;
            /***/ },
            /***/ 14220: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns an object containing dimensions of the Text object.
 *
 * @function Phaser.GameObjects.GetTextSize
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Text} text - The Text object to calculate the size from.
 * @param {Phaser.Types.GameObjects.Text.TextMetrics} size - The Text metrics to use when calculating the size.
 * @param {string[]} lines - The lines of text to calculate the size from.
 *
 * @return {Phaser.Types.GameObjects.Text.GetTextSizeObject} An object containing dimensions of the Text object.
 */ var GetTextSize = function(text, size, lines) {
                    var canvas = text.canvas;
                    var context = text.context;
                    var style = text.style;
                    var lineWidths = [];
                    var maxLineWidth = 0;
                    var drawnLines = lines.length;
                    if (style.maxLines > 0 && style.maxLines < lines.length) drawnLines = style.maxLines;
                    style.syncFont(canvas, context);
                    //  Text Width
                    var letterSpacing = text.letterSpacing;
                    for(var i = 0; i < drawnLines; i++){
                        var lineWidth = style.strokeThickness;
                        if (letterSpacing === 0) lineWidth += context.measureText(lines[i]).width;
                        else {
                            var line = lines[i];
                            for(var j = 0; j < line.length; j++)lineWidth += context.measureText(line[j]).width;
                            if (line.length > 1) lineWidth += letterSpacing * (line.length - 1);
                        }
                        // Adjust for wrapped text
                        if (style.wordWrap) lineWidth -= context.measureText(' ').width;
                        lineWidths[i] = Math.ceil(lineWidth);
                        maxLineWidth = Math.max(maxLineWidth, lineWidths[i]);
                    }
                    //  Text Height
                    var lineHeight = size.fontSize + style.strokeThickness;
                    var height = lineHeight * drawnLines;
                    var lineSpacing = text.lineSpacing;
                    //  Adjust for line spacing
                    if (drawnLines > 1) height += lineSpacing * (drawnLines - 1);
                    return {
                        width: maxLineWidth,
                        height: height,
                        lines: drawnLines,
                        lineWidths: lineWidths,
                        lineSpacing: lineSpacing,
                        lineHeight: lineHeight
                    };
                };
                module1.exports = GetTextSize;
            /***/ },
            /***/ 79557: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(27919);
                /**
 * Calculates the ascent, descent and fontSize of a given font style.
 *
 * @function Phaser.GameObjects.MeasureText
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.TextStyle} textStyle - The TextStyle object to measure.
 *
 * @return {Phaser.Types.GameObjects.Text.TextMetrics} An object containing the ascent, descent and fontSize of the TextStyle.
 */ var MeasureText = function(textStyle) {
                    var canvas = CanvasPool.create(this);
                    var context = canvas.getContext('2d', {
                        willReadFrequently: true
                    });
                    textStyle.syncFont(canvas, context);
                    var metrics = context.measureText(textStyle.testString);
                    if ('actualBoundingBoxAscent' in metrics) {
                        var ascent = metrics.actualBoundingBoxAscent;
                        var descent = metrics.actualBoundingBoxDescent;
                        CanvasPool.remove(canvas);
                        return {
                            ascent: ascent,
                            descent: descent,
                            fontSize: ascent + descent
                        };
                    }
                    var width = Math.ceil(metrics.width * textStyle.baselineX);
                    var baseline = width;
                    var height = 2 * baseline;
                    baseline = baseline * textStyle.baselineY | 0;
                    canvas.width = width;
                    canvas.height = height;
                    context.fillStyle = '#f00';
                    context.fillRect(0, 0, width, height);
                    context.font = textStyle._font;
                    context.textBaseline = 'alphabetic';
                    context.fillStyle = '#000';
                    context.fillText(textStyle.testString, 0, baseline);
                    var output = {
                        ascent: 0,
                        descent: 0,
                        fontSize: 0
                    };
                    var imagedata = context.getImageData(0, 0, width, height);
                    if (!imagedata) {
                        output.ascent = baseline;
                        output.descent = baseline + 6;
                        output.fontSize = output.ascent + output.descent;
                        CanvasPool.remove(canvas);
                        return output;
                    }
                    var pixels = imagedata.data;
                    var numPixels = pixels.length;
                    var line = width * 4;
                    var i;
                    var j;
                    var idx = 0;
                    var stop = false;
                    // ascent. scan from top to bottom until we find a non red pixel
                    for(i = 0; i < baseline; i++){
                        for(j = 0; j < line; j += 4)if (pixels[idx + j] !== 255) {
                            stop = true;
                            break;
                        }
                        if (!stop) idx += line;
                        else break;
                    }
                    output.ascent = baseline - i;
                    idx = numPixels - line;
                    stop = false;
                    // descent. scan from bottom to top until we find a non red pixel
                    for(i = height; i > baseline; i--){
                        for(j = 0; j < line; j += 4)if (pixels[idx + j] !== 255) {
                            stop = true;
                            break;
                        }
                        if (!stop) idx -= line;
                        else break;
                    }
                    output.descent = i - baseline;
                    output.fontSize = output.ascent + output.descent;
                    CanvasPool.remove(canvas);
                    return output;
                };
                module1.exports = MeasureText;
            /***/ },
            /***/ 50171: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(40366);
                var CanvasPool = __webpack_require__(27919);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var GetTextSize = __webpack_require__(14220);
                var GetValue = __webpack_require__(35154);
                var RemoveFromDOM = __webpack_require__(35846);
                var TextRender = __webpack_require__(61771);
                var TextStyle = __webpack_require__(35762);
                var UUID = __webpack_require__(45650);
                /**
 * @classdesc
 * A Text Game Object.
 *
 * Text objects work by creating their own internal hidden Canvas and then renders text to it using
 * the standard Canvas `fillText` API. It then creates a texture from this canvas which is rendered
 * to your game during the render pass.
 *
 * Because it uses the Canvas API you can take advantage of all the features this offers, such as
 * applying gradient fills to the text, or strokes, shadows and more. You can also use custom fonts
 * loaded externally, such as Google or TypeKit Web fonts.
 *
 * **Important:** The font name must be quoted if it contains certain combinations of digits or
 * special characters, either when creating the Text object, or when setting the font via `setFont`
 * or `setFontFamily`, e.g.:
 *
 * ```javascript
 * this.add.text(0, 0, 'Hello World', { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif' });
 * ```
 *
 * ```javascript
 * this.add.text(0, 0, 'Hello World', { font: '"Press Start 2P"' });
 * ```
 *
 * You can only display fonts that are currently loaded and available to the browser: therefore fonts must
 * be pre-loaded. Phaser does not do this for you, so you will require the use of a 3rd party font loader,
 * or have the fonts ready available in the CSS on the page in which your Phaser game resides.
 *
 * See {@link http://www.jordanm.co.uk/tinytype this compatibility table} for the available default fonts
 * across mobile browsers.
 *
 * A note on performance: Every time the contents of a Text object changes, i.e. changing the text being
 * displayed, or the style of the text, it needs to remake the Text canvas, and if on WebGL, re-upload the
 * new texture to the GPU. This can be an expensive operation if used often, or with large quantities of
 * Text objects in your game. If you run into performance issues you would be better off using Bitmap Text
 * instead, as it benefits from batching and avoids expensive Canvas API calls.
 *
 * @class Text
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|string[])} text - The text this Text object will display.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The text style configuration object.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
 */ var Text = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.ComputedSize,
                        Components.Crop,
                        Components.Depth,
                        Components.Flip,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Tint,
                        Components.Transform,
                        Components.Visible,
                        TextRender
                    ],
                    initialize: function Text(scene, x, y, text, style) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        GameObject.call(this, scene, 'Text');
                        /**
         * The renderer in use by this Text object.
         *
         * @name Phaser.GameObjects.Text#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.12.0
         */ this.renderer = scene.sys.renderer;
                        this.setPosition(x, y);
                        this.setOrigin(0, 0);
                        this.initPipeline();
                        this.initPostPipeline(true);
                        /**
         * The canvas element that the text is rendered to.
         *
         * @name Phaser.GameObjects.Text#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = CanvasPool.create(this);
                        /**
         * The context of the canvas element that the text is rendered to.
         *
         * @name Phaser.GameObjects.Text#context
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.context;
                        /**
         * The Text Style object.
         *
         * Manages the style of this Text object.
         *
         * @name Phaser.GameObjects.Text#style
         * @type {Phaser.GameObjects.TextStyle}
         * @since 3.0.0
         */ this.style = new TextStyle(this, style);
                        /**
         * Whether to automatically round line positions.
         *
         * @name Phaser.GameObjects.Text#autoRound
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.autoRound = true;
                        /**
         * The Regular Expression that is used to split the text up into lines, in
         * multi-line text. By default this is `/(?:\r\n|\r|\n)/`.
         * You can change this RegExp to be anything else that you may need.
         *
         * @name Phaser.GameObjects.Text#splitRegExp
         * @type {object}
         * @since 3.0.0
         */ this.splitRegExp = /(?:\r\n|\r|\n)/;
                        /**
         * The text to display.
         *
         * @name Phaser.GameObjects.Text#_text
         * @type {string}
         * @private
         * @since 3.12.0
         */ this._text = undefined;
                        /**
         * Specify a padding value which is added to the line width and height when calculating the Text size.
         * Allows you to add extra spacing if the browser is unable to accurately determine the true font dimensions.
         *
         * @name Phaser.GameObjects.Text#padding
         * @type {Phaser.Types.GameObjects.Text.TextPadding}
         * @since 3.0.0
         */ this.padding = {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        };
                        /**
         * The width of this Text object.
         *
         * @name Phaser.GameObjects.Text#width
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.width = 1;
                        /**
         * The height of this Text object.
         *
         * @name Phaser.GameObjects.Text#height
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.height = 1;
                        /**
         * The line spacing value.
         * This value is added to the font height to calculate the overall line height.
         * Only has an effect if this Text object contains multiple lines of text.
         *
         * If you update this property directly, instead of using the `setLineSpacing` method, then
         * be sure to call `updateText` after, or you won't see the change reflected in the Text object.
         *
         * @name Phaser.GameObjects.Text#lineSpacing
         * @type {number}
         * @since 3.13.0
         */ this.lineSpacing = 0;
                        /**
         * Adds / Removes spacing between characters.
         * Can be a negative or positive number.
         *
         * If you update this property directly, instead of using the `setLetterSpacing` method, then
         * be sure to call `updateText` after, or you won't see the change reflected in the Text object.
         *
         * @name Phaser.GameObjects.Text#letterSpacing
         * @type {number}
         * @since 3.60.0
         */ this.letterSpacing = 0;
                        //  If resolution wasn't set, force it to 1
                        if (this.style.resolution === 0) this.style.resolution = 1;
                        /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Text#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                        /**
         * The internal unique key to refer to the texture in the TextureManager.
         *
         * @name Phaser.GameObjects.Text#_textureKey
         * @type {string}
         * @private
         * @since 3.80.0
         */ this._textureKey = UUID();
                        //  Create a Texture for this Text object
                        this.texture = scene.sys.textures.addCanvas(this._textureKey, this.canvas);
                        //  Set the context to be the CanvasTexture context
                        this.context = this.texture.context;
                        //  Get the frame
                        this.frame = this.texture.get();
                        //  Set the resolution
                        this.frame.source.resolution = this.style.resolution;
                        if (this.renderer && this.renderer.gl) {
                            //  Clear the default 1x1 glTexture, as we override it later
                            this.renderer.deleteTexture(this.frame.source.glTexture);
                            this.frame.source.glTexture = null;
                        }
                        this.initRTL();
                        this.setText(text);
                        if (style && style.padding) this.setPadding(style.padding);
                        if (style && style.lineSpacing) this.setLineSpacing(style.lineSpacing);
                        if (style && style.letterSpacing) this.setLetterSpacing(style.letterSpacing);
                    },
                    /**
     * Initialize right to left text.
     *
     * @method Phaser.GameObjects.Text#initRTL
     * @since 3.0.0
     */ initRTL: function() {
                        if (!this.style.rtl) return;
                        //  Here is where the crazy starts.
                        //
                        //  Due to browser implementation issues, you cannot fillText BiDi text to a canvas
                        //  that is not part of the DOM. It just completely ignores the direction property.
                        this.canvas.dir = 'rtl';
                        //  Experimental atm, but one day ...
                        this.context.direction = 'rtl';
                        //  Add it to the DOM, but hidden within the parent canvas.
                        this.canvas.style.display = 'none';
                        AddToDOM(this.canvas, this.scene.sys.canvas);
                        //  And finally we set the x origin
                        this.originX = 1;
                    },
                    /**
     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds.
     *
     * @method Phaser.GameObjects.Text#runWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     *
     * @return {string} The text after wrapping has been applied.
     */ runWordWrap: function(text) {
                        var style = this.style;
                        if (style.wordWrapCallback) {
                            var wrappedLines = style.wordWrapCallback.call(style.wordWrapCallbackScope, text, this);
                            if (Array.isArray(wrappedLines)) wrappedLines = wrappedLines.join('\n');
                            return wrappedLines;
                        } else if (style.wordWrapWidth) {
                            if (style.wordWrapUseAdvanced) return this.advancedWordWrap(text, this.context, this.style.wordWrapWidth);
                            else return this.basicWordWrap(text, this.context, this.style.wordWrapWidth);
                        } else return text;
                    },
                    /**
     * Advanced wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds. Consecutive spaces will be collapsed and replaced with a single space. Lines will be
     * trimmed of white space before processing. Throws an error if wordWrapWidth is less than a
     * single character.
     *
     * @method Phaser.GameObjects.Text#advancedWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {number} wordWrapWidth - The word wrap width.
     *
     * @return {string} The wrapped text.
     */ advancedWordWrap: function(text, context, wordWrapWidth) {
                        var output = '';
                        // Condense consecutive spaces and split into lines
                        var lines = text.replace(/ +/gi, ' ').split(this.splitRegExp);
                        var linesCount = lines.length;
                        for(var i = 0; i < linesCount; i++){
                            var line = lines[i];
                            var out = '';
                            // Trim whitespace
                            line = line.replace(/^ *|\s*$/gi, '');
                            // If entire line is less than wordWrapWidth append the entire line and exit early
                            var lineLetterSpacingWidth = line.length * this.letterSpacing;
                            var lineWidth = context.measureText(line).width + lineLetterSpacingWidth;
                            if (lineWidth < wordWrapWidth) {
                                output += line + '\n';
                                continue;
                            }
                            // Otherwise, calculate new lines
                            var currentLineWidth = wordWrapWidth;
                            // Split into words
                            var words = line.split(' ');
                            for(var j = 0; j < words.length; j++){
                                var word = words[j];
                                var wordWithSpace = word + ' ';
                                var letterSpacingWidth = wordWithSpace.length * this.letterSpacing;
                                var wordWidth = context.measureText(wordWithSpace).width + letterSpacingWidth;
                                console.log(words.length, word);
                                if (wordWidth > currentLineWidth) {
                                    // Break word
                                    if (j === 0) {
                                        // Shave off letters from word until it's small enough
                                        var newWord = wordWithSpace;
                                        while(newWord.length){
                                            newWord = newWord.slice(0, -1);
                                            var newLetterSpacingWidth = newWord.length * this.letterSpacing;
                                            wordWidth = context.measureText(newWord).width + newLetterSpacingWidth;
                                            if (wordWidth <= currentLineWidth) break;
                                        }
                                        // If wordWrapWidth is too small for even a single letter, shame user
                                        // failure with a fatal error
                                        if (!newWord.length) throw new Error('wordWrapWidth < a single character');
                                        // Replace current word in array with remainder
                                        var secondPart = word.substr(newWord.length);
                                        words[j] = secondPart;
                                        // Append first piece to output
                                        out += newWord;
                                    }
                                    // If existing word length is 0, don't include it
                                    var offset = words[j].length ? j : j + 1;
                                    // Collapse rest of sentence and remove any trailing white space
                                    var remainder = words.slice(offset).join(' ').replace(/[ \n]*$/gi, '');
                                    // Prepend remainder to next line
                                    lines.splice(i + 1, 0, remainder);
                                    linesCount = lines.length;
                                    break; // Processing on this line
                                // Append word with space to output
                                } else {
                                    out += wordWithSpace;
                                    currentLineWidth -= wordWidth;
                                }
                            }
                            // Append processed line to output
                            output += out.replace(/[ \n]*$/gi, '') + '\n';
                        }
                        // Trim the end of the string
                        output = output.replace(/[\s|\n]*$/gi, '');
                        return output;
                    },
                    /**
     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds. Spaces are not collapsed and whitespace is not trimmed.
     *
     * @method Phaser.GameObjects.Text#basicWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {number} wordWrapWidth - The word wrap width.
     *
     * @return {string} The wrapped text.
     */ basicWordWrap: function(text, context, wordWrapWidth) {
                        var result = '';
                        var lines = text.split(this.splitRegExp);
                        var lastLineIndex = lines.length - 1;
                        var whiteSpaceWidth = context.measureText(' ').width;
                        for(var i = 0; i <= lastLineIndex; i++){
                            var spaceLeft = wordWrapWidth;
                            var words = lines[i].split(' ');
                            var lastWordIndex = words.length - 1;
                            for(var j = 0; j <= lastWordIndex; j++){
                                var word = words[j];
                                var letterSpacingWidth = word.length * this.letterSpacing;
                                var wordWidth = context.measureText(word).width + letterSpacingWidth;
                                var wordWidthWithSpace = wordWidth;
                                if (j < lastWordIndex) wordWidthWithSpace += whiteSpaceWidth;
                                if (wordWidthWithSpace > spaceLeft) // Skip printing the newline if it's the first word of the line that is greater
                                // than the word wrap width.
                                {
                                    if (j > 0) {
                                        result += '\n';
                                        spaceLeft = wordWrapWidth;
                                    }
                                }
                                result += word;
                                if (j < lastWordIndex) {
                                    result += ' ';
                                    spaceLeft -= wordWidthWithSpace;
                                } else spaceLeft -= wordWidth;
                            }
                            if (i < lastLineIndex) result += '\n';
                        }
                        return result;
                    },
                    /**
     * Runs the given text through this Text objects word wrapping and returns the results as an
     * array, where each element of the array corresponds to a wrapped line of text.
     *
     * @method Phaser.GameObjects.Text#getWrappedText
     * @since 3.0.0
     *
     * @param {string} [text] - The text for which the wrapping will be calculated. If unspecified, the Text objects current text will be used.
     *
     * @return {string[]} An array of strings with the pieces of wrapped text.
     */ getWrappedText: function(text) {
                        if (text === undefined) text = this._text;
                        this.style.syncFont(this.canvas, this.context);
                        var wrappedLines = this.runWordWrap(text);
                        return wrappedLines.split(this.splitRegExp);
                    },
                    /**
     * Set the text to display.
     *
     * An array of strings will be joined with `\n` line breaks.
     *
     * @method Phaser.GameObjects.Text#setText
     * @since 3.0.0
     *
     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this Text object.
     *
     * @return {this} This Text object.
     */ setText: function(value) {
                        if (!value && value !== 0) value = '';
                        if (Array.isArray(value)) value = value.join('\n');
                        if (value !== this._text) {
                            this._text = value.toString();
                            this.updateText();
                        }
                        return this;
                    },
                    /**
     * Appends the given text to the content already being displayed by this Text object.
     *
     * An array of strings will be joined with `\n` line breaks.
     *
     * @method Phaser.GameObjects.Text#appendText
     * @since 3.60.0
     *
     * @param {(string|string[])} value - The string, or array of strings, to be appended to the existing content of this Text object.
     * @param {boolean} [addCR=true] - Insert a carriage-return before the string value.
     *
     * @return {this} This Text object.
     */ appendText: function(value, addCR) {
                        if (addCR === undefined) addCR = true;
                        if (!value && value !== 0) value = '';
                        if (Array.isArray(value)) value = value.join('\n');
                        value = value.toString();
                        var newText = this._text.concat(addCR ? '\n' + value : value);
                        if (newText !== this._text) {
                            this._text = newText;
                            this.updateText();
                        }
                        return this;
                    },
                    /**
     * Set the text style.
     *
     * @example
     * text.setStyle({
     *     fontSize: '64px',
     *     fontFamily: 'Arial',
     *     color: '#ffffff',
     *     align: 'center',
     *     backgroundColor: '#ff00ff'
     * });
     *
     * @method Phaser.GameObjects.Text#setStyle
     * @since 3.0.0
     *
     * @param {object} style - The style settings to set.
     *
     * @return {this} This Text object.
     */ setStyle: function(style) {
                        return this.style.setStyle(style);
                    },
                    /**
     * Set the font.
     *
     * If a string is given, the font family is set.
     *
     * If an object is given, the `fontFamily`, `fontSize` and `fontStyle`
     * properties of that object are set.
     *
     * **Important:** The font name must be quoted if it contains certain combinations of digits or
     * special characters:
     *
     * ```javascript
     * Text.setFont('"Press Start 2P"');
     * ```
     *
     * Equally, if you wish to provide a list of fallback fonts, then you should ensure they are all
     * quoted properly, too:
     *
     * ```javascript
     * Text.setFont('Georgia, "Goudy Bookletter 1911", Times, serif');
     * ```
     *
     * @method Phaser.GameObjects.Text#setFont
     * @since 3.0.0
     *
     * @param {string} font - The font family or font settings to set.
     *
     * @return {this} This Text object.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
     */ setFont: function(font) {
                        return this.style.setFont(font);
                    },
                    /**
     * Set the font family.
     *
     * **Important:** The font name must be quoted if it contains certain combinations of digits or
     * special characters:
     *
     * ```javascript
     * Text.setFont('"Press Start 2P"');
     * ```
     *
     * Equally, if you wish to provide a list of fallback fonts, then you should ensure they are all
     * quoted properly, too:
     *
     * ```javascript
     * Text.setFont('Georgia, "Goudy Bookletter 1911", Times, serif');
     * ```
     *
     * @method Phaser.GameObjects.Text#setFontFamily
     * @since 3.0.0
     *
     * @param {string} family - The font family.
     *
     * @return {this} This Text object.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
     */ setFontFamily: function(family) {
                        return this.style.setFontFamily(family);
                    },
                    /**
     * Set the font size. Can be a string with a valid CSS unit, i.e. `16px`, or a number.
     *
     * @method Phaser.GameObjects.Text#setFontSize
     * @since 3.0.0
     *
     * @param {(string|number)} size - The font size.
     *
     * @return {this} This Text object.
     */ setFontSize: function(size) {
                        return this.style.setFontSize(size);
                    },
                    /**
     * Set the font style.
     *
     * @method Phaser.GameObjects.Text#setFontStyle
     * @since 3.0.0
     *
     * @param {string} style - The font style.
     *
     * @return {this} This Text object.
     */ setFontStyle: function(style) {
                        return this.style.setFontStyle(style);
                    },
                    /**
     * Set a fixed width and height for the text.
     *
     * Pass in `0` for either of these parameters to disable fixed width or height respectively.
     *
     * @method Phaser.GameObjects.Text#setFixedSize
     * @since 3.0.0
     *
     * @param {number} width - The fixed width to set. `0` disables fixed width.
     * @param {number} height - The fixed height to set. `0` disables fixed height.
     *
     * @return {this} This Text object.
     */ setFixedSize: function(width, height) {
                        return this.style.setFixedSize(width, height);
                    },
                    /**
     * Set the background color.
     *
     * @method Phaser.GameObjects.Text#setBackgroundColor
     * @since 3.0.0
     *
     * @param {string} color - The background color.
     *
     * @return {this} This Text object.
     */ setBackgroundColor: function(color) {
                        return this.style.setBackgroundColor(color);
                    },
                    /**
     * Set the fill style to be used by the Text object.
     *
     * This can be any valid CanvasRenderingContext2D fillStyle value, such as
     * a color (in hex, rgb, rgba, hsl or named values), a gradient or a pattern.
     *
     * See the [MDN fillStyle docs](https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle) for more details.
     *
     * @method Phaser.GameObjects.Text#setFill
     * @since 3.0.0
     *
     * @param {(string|CanvasGradient|CanvasPattern)} color - The text fill style. Can be any valid CanvasRenderingContext `fillStyle` value.
     *
     * @return {this} This Text object.
     */ setFill: function(fillStyle) {
                        return this.style.setFill(fillStyle);
                    },
                    /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.Text#setColor
     * @since 3.0.0
     *
     * @param {(string|CanvasGradient|CanvasPattern)} color - The text fill color.
     *
     * @return {this} This Text object.
     */ setColor: function(color) {
                        return this.style.setColor(color);
                    },
                    /**
     * Set the stroke settings.
     *
     * @method Phaser.GameObjects.Text#setStroke
     * @since 3.0.0
     *
     * @param {(string|CanvasGradient|CanvasPattern)} color - The stroke color.
     * @param {number} thickness - The stroke thickness.
     *
     * @return {this} This Text object.
     */ setStroke: function(color, thickness) {
                        return this.style.setStroke(color, thickness);
                    },
                    /**
     * Set the shadow settings.
     *
     * @method Phaser.GameObjects.Text#setShadow
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     * @param {string} [color='#000'] - The shadow color.
     * @param {number} [blur=0] - The shadow blur radius.
     * @param {boolean} [shadowStroke=false] - Whether to stroke the shadow.
     * @param {boolean} [shadowFill=true] - Whether to fill the shadow.
     *
     * @return {this} This Text object.
     */ setShadow: function(x, y, color, blur, shadowStroke, shadowFill) {
                        return this.style.setShadow(x, y, color, blur, shadowStroke, shadowFill);
                    },
                    /**
     * Set the shadow offset.
     *
     * @method Phaser.GameObjects.Text#setShadowOffset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal shadow offset.
     * @param {number} y - The vertical shadow offset.
     *
     * @return {this} This Text object.
     */ setShadowOffset: function(x, y) {
                        return this.style.setShadowOffset(x, y);
                    },
                    /**
     * Set the shadow color.
     *
     * @method Phaser.GameObjects.Text#setShadowColor
     * @since 3.0.0
     *
     * @param {string} color - The shadow color.
     *
     * @return {this} This Text object.
     */ setShadowColor: function(color) {
                        return this.style.setShadowColor(color);
                    },
                    /**
     * Set the shadow blur radius.
     *
     * @method Phaser.GameObjects.Text#setShadowBlur
     * @since 3.0.0
     *
     * @param {number} blur - The shadow blur radius.
     *
     * @return {this} This Text object.
     */ setShadowBlur: function(blur) {
                        return this.style.setShadowBlur(blur);
                    },
                    /**
     * Enable or disable shadow stroke.
     *
     * @method Phaser.GameObjects.Text#setShadowStroke
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow stroke is enabled or not.
     *
     * @return {this} This Text object.
     */ setShadowStroke: function(enabled) {
                        return this.style.setShadowStroke(enabled);
                    },
                    /**
     * Enable or disable shadow fill.
     *
     * @method Phaser.GameObjects.Text#setShadowFill
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow fill is enabled or not.
     *
     * @return {this} This Text object.
     */ setShadowFill: function(enabled) {
                        return this.style.setShadowFill(enabled);
                    },
                    /**
     * Set the width (in pixels) to use for wrapping lines. Pass in null to remove wrapping by width.
     *
     * @method Phaser.GameObjects.Text#setWordWrapWidth
     * @since 3.0.0
     *
     * @param {number | null} width - The maximum width of a line in pixels. Set to null to remove wrapping.
     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
     * spaces and whitespace are left as is.
     *
     * @return {this} This Text object.
     */ setWordWrapWidth: function(width, useAdvancedWrap) {
                        return this.style.setWordWrapWidth(width, useAdvancedWrap);
                    },
                    /**
     * Set a custom callback for wrapping lines. Pass in null to remove wrapping by callback.
     *
     * @method Phaser.GameObjects.Text#setWordWrapCallback
     * @since 3.0.0
     *
     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
     * instance). It should return the wrapped lines either as an array of lines or as a string with
     * newline characters in place to indicate where breaks should happen.
     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
     *
     * @return {this} This Text object.
     */ setWordWrapCallback: function(callback, scope) {
                        return this.style.setWordWrapCallback(callback, scope);
                    },
                    /**
     * Set the alignment of the text in this Text object.
     *
     * The argument can be one of: `left`, `right`, `center` or `justify`.
     *
     * Alignment only works if the Text object has more than one line of text.
     *
     * @method Phaser.GameObjects.Text#setAlign
     * @since 3.0.0
     *
     * @param {string} [align='left'] - The text alignment for multi-line text.
     *
     * @return {this} This Text object.
     */ setAlign: function(align) {
                        return this.style.setAlign(align);
                    },
                    /**
     * Set the resolution used by this Text object.
     *
     * It allows for much clearer text on High DPI devices, at the cost of memory because it uses larger
     * internal Canvas textures for the Text.
     *
     * Therefore, please use with caution, as the more high res Text you have, the more memory it uses.
     *
     * @method Phaser.GameObjects.Text#setResolution
     * @since 3.12.0
     *
     * @param {number} value - The resolution for this Text object to use.
     *
     * @return {this} This Text object.
     */ setResolution: function(value) {
                        return this.style.setResolution(value);
                    },
                    /**
     * Sets the line spacing value.
     *
     * This value is _added_ to the height of the font when calculating the overall line height.
     * This only has an effect if this Text object consists of multiple lines of text.
     *
     * @method Phaser.GameObjects.Text#setLineSpacing
     * @since 3.13.0
     *
     * @param {number} value - The amount to add to the font height to achieve the overall line height.
     *
     * @return {this} This Text object.
     */ setLineSpacing: function(value) {
                        this.lineSpacing = value;
                        return this.updateText();
                    },
                    /**
     * Sets the letter spacing value.
     *
     * This will add, or remove spacing between each character of this Text Game Object. The value can be
     * either positive or negative. Positive values increase the space between each character, whilst negative
     * values decrease it. Note that some fonts are spaced naturally closer together than others.
     *
     * Please understand that enabling this feature will cause Phaser to render each character in this Text object
     * one by one, rather than use a draw for the whole string. This makes it extremely expensive when used with
     * either long strings, or lots of strings in total. You will be better off creating bitmap font text if you
     * need to display large quantities of characters with fine control over the letter spacing.
     *
     * @method Phaser.GameObjects.Text#setLetterSpacing
     * @since 3.70.0
     *
     * @param {number} value - The amount to add to the letter width. Set to zero to disable.
     *
     * @return {this} This Text object.
     */ setLetterSpacing: function(value) {
                        this.letterSpacing = value;
                        return this.updateText();
                    },
                    /**
     * Set the text padding.
     *
     * 'left' can be an object.
     *
     * If only 'left' and 'top' are given they are treated as 'x' and 'y'.
     *
     * @method Phaser.GameObjects.Text#setPadding
     * @since 3.0.0
     *
     * @param {(number|Phaser.Types.GameObjects.Text.TextPadding)} left - The left padding value, or a padding config object.
     * @param {number} [top] - The top padding value.
     * @param {number} [right] - The right padding value.
     * @param {number} [bottom] - The bottom padding value.
     *
     * @return {this} This Text object.
     */ setPadding: function(left, top, right, bottom) {
                        if (typeof left === 'object') {
                            var config = left;
                            //  If they specify x and/or y this applies to all
                            var x = GetValue(config, 'x', null);
                            if (x !== null) {
                                left = x;
                                right = x;
                            } else {
                                left = GetValue(config, 'left', 0);
                                right = GetValue(config, 'right', left);
                            }
                            var y = GetValue(config, 'y', null);
                            if (y !== null) {
                                top = y;
                                bottom = y;
                            } else {
                                top = GetValue(config, 'top', 0);
                                bottom = GetValue(config, 'bottom', top);
                            }
                        } else {
                            if (left === undefined) left = 0;
                            if (top === undefined) top = left;
                            if (right === undefined) right = left;
                            if (bottom === undefined) bottom = top;
                        }
                        this.padding.left = left;
                        this.padding.top = top;
                        this.padding.right = right;
                        this.padding.bottom = bottom;
                        return this.updateText();
                    },
                    /**
     * Set the maximum number of lines to draw.
     *
     * @method Phaser.GameObjects.Text#setMaxLines
     * @since 3.0.0
     *
     * @param {number} [max=0] - The maximum number of lines to draw.
     *
     * @return {this} This Text object.
     */ setMaxLines: function(max) {
                        return this.style.setMaxLines(max);
                    },
                    /**
     * Render text from right-to-left or left-to-right.
     *
     * @method Phaser.GameObjects.Text#setRTL
     * @since 3.70.0
     *
     * @param {boolean} [rtl=true] - Set to `true` to render from right-to-left.
     *
     * @return {this} This Text object.
     */ setRTL: function(rtl) {
                        if (rtl === undefined) rtl = true;
                        var style = this.style;
                        if (style.rtl === rtl) return this;
                        style.rtl = rtl;
                        if (rtl) {
                            this.canvas.dir = 'rtl';
                            this.context.direction = 'rtl';
                            this.canvas.style.display = 'none';
                            AddToDOM(this.canvas, this.scene.sys.canvas);
                        } else {
                            this.canvas.dir = 'ltr';
                            this.context.direction = 'ltr';
                        }
                        if (style.align === 'left') style.align = 'right';
                        else if (style.align === 'right') style.align = 'left';
                        return this;
                    },
                    /**
     * Update the displayed text.
     *
     * @method Phaser.GameObjects.Text#updateText
     * @since 3.0.0
     *
     * @return {this} This Text object.
     */ updateText: function() {
                        var canvas = this.canvas;
                        var context = this.context;
                        var style = this.style;
                        var resolution = style.resolution;
                        var size = style.metrics;
                        style.syncFont(canvas, context);
                        var outputText = this._text;
                        if (style.wordWrapWidth || style.wordWrapCallback) outputText = this.runWordWrap(this._text);
                        //  Split text into lines
                        var lines = outputText.split(this.splitRegExp);
                        var textSize = GetTextSize(this, size, lines);
                        var padding = this.padding;
                        var textWidth;
                        if (style.fixedWidth === 0) {
                            this.width = textSize.width + padding.left + padding.right;
                            textWidth = textSize.width;
                        } else {
                            this.width = style.fixedWidth;
                            textWidth = this.width - padding.left - padding.right;
                            if (textWidth < textSize.width) textWidth = textSize.width;
                        }
                        if (style.fixedHeight === 0) this.height = textSize.height + padding.top + padding.bottom;
                        else this.height = style.fixedHeight;
                        var w = this.width;
                        var h = this.height;
                        this.updateDisplayOrigin();
                        w *= resolution;
                        h *= resolution;
                        w = Math.max(w, 1);
                        h = Math.max(h, 1);
                        if (canvas.width !== w || canvas.height !== h) {
                            canvas.width = w;
                            canvas.height = h;
                            this.frame.setSize(w, h);
                            //  Because resizing the canvas resets the context
                            style.syncFont(canvas, context);
                            if (style.rtl) context.direction = 'rtl';
                        } else context.clearRect(0, 0, w, h);
                        context.save();
                        context.scale(resolution, resolution);
                        if (style.backgroundColor) {
                            context.fillStyle = style.backgroundColor;
                            context.fillRect(0, 0, w, h);
                        }
                        style.syncStyle(canvas, context);
                        //  Apply padding
                        context.translate(padding.left, padding.top);
                        var linePositionX;
                        var linePositionY;
                        //  Draw text line by line
                        for(var i = 0; i < textSize.lines; i++){
                            linePositionX = style.strokeThickness / 2;
                            linePositionY = style.strokeThickness / 2 + i * textSize.lineHeight + size.ascent;
                            if (i > 0) linePositionY += textSize.lineSpacing * i;
                            if (style.rtl) linePositionX = w - linePositionX - padding.left - padding.right;
                            else if (style.align === 'right') linePositionX += textWidth - textSize.lineWidths[i];
                            else if (style.align === 'center') linePositionX += (textWidth - textSize.lineWidths[i]) / 2;
                            else if (style.align === 'justify') {
                                //  To justify text line its width must be no less than 85% of defined width
                                var minimumLengthToApplyJustification = 0.85;
                                if (textSize.lineWidths[i] / textSize.width >= minimumLengthToApplyJustification) {
                                    var extraSpace = textSize.width - textSize.lineWidths[i];
                                    var spaceSize = context.measureText(' ').width;
                                    var trimmedLine = lines[i].trim();
                                    var array = trimmedLine.split(' ');
                                    extraSpace += (lines[i].length - trimmedLine.length) * spaceSize;
                                    var extraSpaceCharacters = Math.floor(extraSpace / spaceSize);
                                    var idx = 0;
                                    while(extraSpaceCharacters > 0){
                                        array[idx] += ' ';
                                        idx = (idx + 1) % (array.length - 1 || 1);
                                        --extraSpaceCharacters;
                                    }
                                    lines[i] = array.join(' ');
                                }
                            }
                            if (this.autoRound) {
                                linePositionX = Math.round(linePositionX);
                                linePositionY = Math.round(linePositionY);
                            }
                            var letterSpacing = this.letterSpacing;
                            // Apply stroke to the whole line only if there's no custom letter spacing
                            if (style.strokeThickness && letterSpacing === 0) {
                                style.syncShadow(context, style.shadowStroke);
                                context.strokeText(lines[i], linePositionX, linePositionY);
                            }
                            if (style.color) {
                                style.syncShadow(context, style.shadowFill);
                                // Looping fillText could be an expensive operation, we should ignore it if it is not needed
                                if (letterSpacing !== 0) {
                                    var charPositionX = 0;
                                    var line = lines[i].split('');
                                    //  Draw text letter by letter
                                    for(var l = 0; l < line.length; l++){
                                        if (style.strokeThickness) {
                                            style.syncShadow(context, style.shadowStroke);
                                            context.strokeText(line[l], linePositionX + charPositionX, linePositionY);
                                            style.syncShadow(context, style.shadowFill);
                                        }
                                        context.fillText(line[l], linePositionX + charPositionX, linePositionY);
                                        charPositionX += context.measureText(line[l]).width + letterSpacing;
                                    }
                                } else context.fillText(lines[i], linePositionX, linePositionY);
                            }
                        }
                        context.restore();
                        if (this.renderer && this.renderer.gl) this.frame.source.glTexture = this.renderer.canvasToTexture(canvas, this.frame.source.glTexture, true);
                        var input = this.input;
                        if (input && !input.customHitArea) {
                            input.hitArea.width = this.width;
                            input.hitArea.height = this.height;
                        }
                        return this;
                    },
                    /**
     * Get the current text metrics.
     *
     * @method Phaser.GameObjects.Text#getTextMetrics
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.Text.TextMetrics} The text metrics.
     */ getTextMetrics: function() {
                        return this.style.getTextMetrics();
                    },
                    /**
     * The text string being rendered by this Text Game Object.
     *
     * @name Phaser.GameObjects.Text#text
     * @type {string}
     * @since 3.0.0
     */ text: {
                        get: function() {
                            return this._text;
                        },
                        set: function(value) {
                            this.setText(value);
                        }
                    },
                    /**
     * Build a JSON representation of the Text object.
     *
     * @method Phaser.GameObjects.Text#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Text object.
     */ toJSON: function() {
                        var out = Components.ToJSON(this);
                        //  Extra Text data is added here
                        var data = {
                            autoRound: this.autoRound,
                            text: this._text,
                            style: this.style.toJSON(),
                            padding: {
                                left: this.padding.left,
                                right: this.padding.right,
                                top: this.padding.top,
                                bottom: this.padding.bottom
                            }
                        };
                        out.data = data;
                        return out;
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Text#preDestroy
     * @protected
     * @since 3.0.0
     */ preDestroy: function() {
                        RemoveFromDOM(this.canvas);
                        CanvasPool.remove(this.canvas);
                        var texture = this.texture;
                        if (texture) texture.destroy();
                    }
                });
                module1.exports = Text;
            /***/ },
            /***/ 79724: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    if (src.width === 0 || src.height === 0) return;
                    camera.addToRenderList(src);
                    renderer.batchSprite(src, src.frame, camera, parentMatrix);
                };
                module1.exports = TextCanvasRenderer;
            /***/ },
            /***/ 71259: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var Text = __webpack_require__(50171);
                /**
 * Creates a new Text Game Object and returns it.
 *
 * Note: This method will only be available if the Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#text
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Text.TextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Text} The Game Object that was created.
 */ GameObjectCreator.register('text', function(config, addToScene) {
                    if (config === undefined) config = {};
                    // style Object = {
                    //     font: [ 'font', '16px Courier' ],
                    //     backgroundColor: [ 'backgroundColor', null ],
                    //     fill: [ 'fill', '#fff' ],
                    //     stroke: [ 'stroke', '#fff' ],
                    //     strokeThickness: [ 'strokeThickness', 0 ],
                    //     shadowOffsetX: [ 'shadow.offsetX', 0 ],
                    //     shadowOffsetY: [ 'shadow.offsetY', 0 ],
                    //     shadowColor: [ 'shadow.color', '#000' ],
                    //     shadowBlur: [ 'shadow.blur', 0 ],
                    //     shadowStroke: [ 'shadow.stroke', false ],
                    //     shadowFill: [ 'shadow.fill', false ],
                    //     align: [ 'align', 'left' ],
                    //     maxLines: [ 'maxLines', 0 ],
                    //     fixedWidth: [ 'fixedWidth', false ],
                    //     fixedHeight: [ 'fixedHeight', false ],
                    //     rtl: [ 'rtl', false ]
                    // }
                    var content = GetAdvancedValue(config, 'text', '');
                    var style = GetAdvancedValue(config, 'style', null);
                    //  Padding
                    //      { padding: 2 }
                    //      { padding: { x: , y: }}
                    //      { padding: { left: , top: }}
                    //      { padding: { left: , right: , top: , bottom: }}
                    var padding = GetAdvancedValue(config, 'padding', null);
                    if (padding !== null) style.padding = padding;
                    var text = new Text(this.scene, 0, 0, content, style);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, text, config);
                    //  Text specific config options:
                    text.autoRound = GetAdvancedValue(config, 'autoRound', true);
                    text.resolution = GetAdvancedValue(config, 'resolution', 1);
                    return text;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 68005: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Text = __webpack_require__(50171);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Text Game Object and adds it to the Scene.
 *
 * A Text Game Object.
 *
 * Text objects work by creating their own internal hidden Canvas and then renders text to it using
 * the standard Canvas `fillText` API. It then creates a texture from this canvas which is rendered
 * to your game during the render pass.
 *
 * Because it uses the Canvas API you can take advantage of all the features this offers, such as
 * applying gradient fills to the text, or strokes, shadows and more. You can also use custom fonts
 * loaded externally, such as Google or TypeKit Web fonts.
 *
 * You can only display fonts that are currently loaded and available to the browser: therefore fonts must
 * be pre-loaded. Phaser does not do this for you, so you will require the use of a 3rd party font loader,
 * or have the fonts ready available in the CSS on the page in which your Phaser game resides.
 *
 * See {@link http://www.jordanm.co.uk/tinytype this compatibility table} for the available default fonts
 * across mobile browsers.
 *
 * A note on performance: Every time the contents of a Text object changes, i.e. changing the text being
 * displayed, or the style of the text, it needs to remake the Text canvas, and if on WebGL, re-upload the
 * new texture to the GPU. This can be an expensive operation if used often, or with large quantities of
 * Text objects in your game. If you run into performance issues you would be better off using Bitmap Text
 * instead, as it benefits from batching and avoids expensive Canvas API calls.
 *
 * Note: This method will only be available if the Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#text
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|string[])} text - The text this Text object will display.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} [style] - The Text style configuration object.
 *
 * @return {Phaser.GameObjects.Text} The Game Object that was created.
 */ GameObjectFactory.register('text', function(x, y, text, style) {
                    return this.displayList.add(new Text(this.scene, x, y, text, style));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 61771: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(34397);
                renderCanvas = __webpack_require__(79724);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 35762: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetValue = __webpack_require__(35154);
                var MeasureText = __webpack_require__(79557);
                //  Key: [ Object Key, Default Value ]
                var propertyMap = {
                    fontFamily: [
                        'fontFamily',
                        'Courier'
                    ],
                    fontSize: [
                        'fontSize',
                        '16px'
                    ],
                    fontStyle: [
                        'fontStyle',
                        ''
                    ],
                    backgroundColor: [
                        'backgroundColor',
                        null
                    ],
                    color: [
                        'color',
                        '#fff'
                    ],
                    stroke: [
                        'stroke',
                        '#fff'
                    ],
                    strokeThickness: [
                        'strokeThickness',
                        0
                    ],
                    shadowOffsetX: [
                        'shadow.offsetX',
                        0
                    ],
                    shadowOffsetY: [
                        'shadow.offsetY',
                        0
                    ],
                    shadowColor: [
                        'shadow.color',
                        '#000'
                    ],
                    shadowBlur: [
                        'shadow.blur',
                        0
                    ],
                    shadowStroke: [
                        'shadow.stroke',
                        false
                    ],
                    shadowFill: [
                        'shadow.fill',
                        false
                    ],
                    align: [
                        'align',
                        'left'
                    ],
                    maxLines: [
                        'maxLines',
                        0
                    ],
                    fixedWidth: [
                        'fixedWidth',
                        0
                    ],
                    fixedHeight: [
                        'fixedHeight',
                        0
                    ],
                    resolution: [
                        'resolution',
                        0
                    ],
                    rtl: [
                        'rtl',
                        false
                    ],
                    testString: [
                        'testString',
                        "|M\xc3\u2030qgy"
                    ],
                    baselineX: [
                        'baselineX',
                        1.2
                    ],
                    baselineY: [
                        'baselineY',
                        1.4
                    ],
                    wordWrapWidth: [
                        'wordWrap.width',
                        null
                    ],
                    wordWrapCallback: [
                        'wordWrap.callback',
                        null
                    ],
                    wordWrapCallbackScope: [
                        'wordWrap.callbackScope',
                        null
                    ],
                    wordWrapUseAdvanced: [
                        'wordWrap.useAdvancedWrap',
                        false
                    ]
                };
                /**
 * @classdesc
 * A TextStyle class manages all of the style settings for a Text object.
 *
 * Text Game Objects create a TextStyle instance automatically, which is
 * accessed via the `Text.style` property. You do not normally need to
 * instantiate one yourself.
 *
 * @class TextStyle
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Text} text - The Text object that this TextStyle is styling.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The style settings to set.
 */ var TextStyle = new Class({
                    initialize: function TextStyle(text, style) {
                        /**
         * The Text object that this TextStyle is styling.
         *
         * @name Phaser.GameObjects.TextStyle#parent
         * @type {Phaser.GameObjects.Text}
         * @since 3.0.0
         */ this.parent = text;
                        /**
         * The font family.
         *
         * @name Phaser.GameObjects.TextStyle#fontFamily
         * @type {string}
         * @default 'Courier'
         * @since 3.0.0
         */ this.fontFamily;
                        /**
         * The font size.
         *
         * @name Phaser.GameObjects.TextStyle#fontSize
         * @type {(string|number)}
         * @default '16px'
         * @since 3.0.0
         */ this.fontSize;
                        /**
         * The font style.
         *
         * @name Phaser.GameObjects.TextStyle#fontStyle
         * @type {string}
         * @since 3.0.0
         */ this.fontStyle;
                        /**
         * The background color.
         *
         * @name Phaser.GameObjects.TextStyle#backgroundColor
         * @type {string}
         * @since 3.0.0
         */ this.backgroundColor;
                        /**
         * The text fill color.
         *
         * @name Phaser.GameObjects.TextStyle#color
         * @type {(string|CanvasGradient|CanvasPattern)}
         * @default '#fff'
         * @since 3.0.0
         */ this.color;
                        /**
         * The text stroke color.
         *
         * @name Phaser.GameObjects.TextStyle#stroke
         * @type {(string|CanvasGradient|CanvasPattern)}
         * @default '#fff'
         * @since 3.0.0
         */ this.stroke;
                        /**
         * The text stroke thickness.
         *
         * @name Phaser.GameObjects.TextStyle#strokeThickness
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.strokeThickness;
                        /**
         * The horizontal shadow offset.
         *
         * @name Phaser.GameObjects.TextStyle#shadowOffsetX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowOffsetX;
                        /**
         * The vertical shadow offset.
         *
         * @name Phaser.GameObjects.TextStyle#shadowOffsetY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowOffsetY;
                        /**
         * The shadow color.
         *
         * @name Phaser.GameObjects.TextStyle#shadowColor
         * @type {string}
         * @default '#000'
         * @since 3.0.0
         */ this.shadowColor;
                        /**
         * The shadow blur radius.
         *
         * @name Phaser.GameObjects.TextStyle#shadowBlur
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowBlur;
                        /**
         * Whether shadow stroke is enabled or not.
         *
         * @name Phaser.GameObjects.TextStyle#shadowStroke
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shadowStroke;
                        /**
         * Whether shadow fill is enabled or not.
         *
         * @name Phaser.GameObjects.TextStyle#shadowFill
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shadowFill;
                        /**
         * The text alignment.
         *
         * @name Phaser.GameObjects.TextStyle#align
         * @type {string}
         * @default 'left'
         * @since 3.0.0
         */ this.align;
                        /**
         * The maximum number of lines to draw.
         *
         * @name Phaser.GameObjects.TextStyle#maxLines
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxLines;
                        /**
         * The fixed width of the text.
         *
         * `0` means no fixed with.
         *
         * @name Phaser.GameObjects.TextStyle#fixedWidth
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.fixedWidth;
                        /**
         * The fixed height of the text.
         *
         * `0` means no fixed height.
         *
         * @name Phaser.GameObjects.TextStyle#fixedHeight
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.fixedHeight;
                        /**
         * The resolution the text is rendered to its internal canvas at.
         * The default is 0, which means it will use the resolution set in the Game Config.
         *
         * @name Phaser.GameObjects.TextStyle#resolution
         * @type {number}
         * @default 0
         * @since 3.12.0
         */ this.resolution;
                        /**
         * Whether the text should render right to left.
         *
         * @name Phaser.GameObjects.TextStyle#rtl
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.rtl;
                        /**
         * The test string to use when measuring the font.
         *
         * @name Phaser.GameObjects.TextStyle#testString
         * @type {string}
         * @default '|MÉqgy'
         * @since 3.0.0
         */ this.testString;
                        /**
         * The amount of horizontal padding added to the width of the text when calculating the font metrics.
         *
         * @name Phaser.GameObjects.TextStyle#baselineX
         * @type {number}
         * @default 1.2
         * @since 3.3.0
         */ this.baselineX;
                        /**
         * The amount of vertical padding added to the height of the text when calculating the font metrics.
         *
         * @name Phaser.GameObjects.TextStyle#baselineY
         * @type {number}
         * @default 1.4
         * @since 3.3.0
         */ this.baselineY;
                        /**
         * The maximum width of a line of text in pixels. Null means no line wrapping. Setting this
         * property directly will not re-run the word wrapping algorithm. To change the width and
         * re-wrap, use {@link Phaser.GameObjects.TextStyle#setWordWrapWidth}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapWidth
         * @type {number | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapWidth;
                        /**
         * A custom function that will be responsible for wrapping the text. It will receive two
         * arguments: text (the string to wrap), textObject (this Text instance). It should return
         * the wrapped lines either as an array of lines or as a string with newline characters in
         * place to indicate where breaks should happen. Setting this directly will not re-run the
         * word wrapping algorithm. To change the callback and re-wrap, use
         * {@link Phaser.GameObjects.TextStyle#setWordWrapCallback}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapCallback
         * @type {TextStyleWordWrapCallback | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapCallback;
                        /**
         * The scope that will be applied when the wordWrapCallback is invoked. Setting this directly will not re-run the
         * word wrapping algorithm. To change the callback and re-wrap, use
         * {@link Phaser.GameObjects.TextStyle#setWordWrapCallback}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapCallbackScope
         * @type {object | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapCallbackScope;
                        /**
         * Whether or not to use the advanced wrapping algorithm. If true, spaces are collapsed and
         * whitespace is trimmed from lines. If false, spaces and whitespace are left as is. Setting
         * this property directly will not re-run the word wrapping algorithm. To change the
         * advanced setting and re-wrap, use {@link Phaser.GameObjects.TextStyle#setWordWrapWidth}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapUseAdvanced
         * @type {boolean}
         * @default false
         * @since 3.24.0
         */ this.wordWrapUseAdvanced;
                        /**
         * The font style, size and family.
         *
         * @name Phaser.GameObjects.TextStyle#_font
         * @type {string}
         * @private
         * @since 3.0.0
         */ this._font;
                        //  Set to defaults + user style
                        this.setStyle(style, false, true);
                    },
                    /**
     * Set the text style.
     *
     * @example
     * text.setStyle({
     *     fontSize: '64px',
     *     fontFamily: 'Arial',
     *     color: '#ffffff',
     *     align: 'center',
     *     backgroundColor: '#ff00ff'
     * });
     *
     * @method Phaser.GameObjects.TextStyle#setStyle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The style settings to set.
     * @param {boolean} [updateText=true] - Whether to update the text immediately.
     * @param {boolean} [setDefaults=false] - Use the default values if not set, or the local values.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setStyle: function(style, updateText, setDefaults) {
                        if (updateText === undefined) updateText = true;
                        if (setDefaults === undefined) setDefaults = false;
                        for(var key in propertyMap){
                            var value = setDefaults ? propertyMap[key][1] : this[key];
                            if (key === 'wordWrapCallback' || key === 'wordWrapCallbackScope') // Callback & scope should be set without processing the values
                            this[key] = GetValue(style, propertyMap[key][0], value);
                            else if (style && key === 'fontSize' && typeof style.fontSize === 'number') this[key] = style.fontSize.toString() + 'px';
                            else this[key] = GetAdvancedValue(style, propertyMap[key][0], value);
                        }
                        //  Allow for 'font' override
                        var font = GetValue(style, 'font', null);
                        if (font !== null) this.setFont(font, false);
                        this._font = [
                            this.fontStyle,
                            this.fontSize,
                            this.fontFamily
                        ].join(' ').trim();
                        //  Allow for 'fill' to be used in place of 'color'
                        var fill = GetValue(style, 'fill', null);
                        if (fill !== null) this.color = fill;
                        var metrics = GetValue(style, 'metrics', false);
                        //  Provide optional TextMetrics in the style object to avoid the canvas look-up / scanning
                        //  Doing this is reset if you then change the font of this TextStyle after creation
                        if (metrics) this.metrics = {
                            ascent: GetValue(metrics, 'ascent', 0),
                            descent: GetValue(metrics, 'descent', 0),
                            fontSize: GetValue(metrics, 'fontSize', 0)
                        };
                        else if (updateText || !this.metrics) this.metrics = MeasureText(this);
                        if (updateText) return this.parent.updateText();
                        else return this.parent;
                    },
                    /**
     * Synchronize the font settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncFont
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} canvas - The Canvas Element.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     */ syncFont: function(canvas, context) {
                        context.font = this._font;
                    },
                    /**
     * Synchronize the text style settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncStyle
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} canvas - The Canvas Element.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     */ syncStyle: function(canvas, context) {
                        context.textBaseline = 'alphabetic';
                        context.fillStyle = this.color;
                        context.strokeStyle = this.stroke;
                        context.lineWidth = this.strokeThickness;
                        context.lineCap = 'round';
                        context.lineJoin = 'round';
                    },
                    /**
     * Synchronize the shadow settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncShadow
     * @since 3.0.0
     *
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {boolean} enabled - Whether shadows are enabled or not.
     */ syncShadow: function(context, enabled) {
                        if (enabled) {
                            context.shadowOffsetX = this.shadowOffsetX;
                            context.shadowOffsetY = this.shadowOffsetY;
                            context.shadowColor = this.shadowColor;
                            context.shadowBlur = this.shadowBlur;
                        } else {
                            context.shadowOffsetX = 0;
                            context.shadowOffsetY = 0;
                            context.shadowColor = 0;
                            context.shadowBlur = 0;
                        }
                    },
                    /**
     * Update the style settings for the parent Text object.
     *
     * @method Phaser.GameObjects.TextStyle#update
     * @since 3.0.0
     *
     * @param {boolean} recalculateMetrics - Whether to recalculate font and text metrics.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ update: function(recalculateMetrics) {
                        if (recalculateMetrics) {
                            this._font = [
                                this.fontStyle,
                                this.fontSize,
                                this.fontFamily
                            ].join(' ').trim();
                            this.metrics = MeasureText(this);
                        }
                        return this.parent.updateText();
                    },
                    /**
     * Set the font.
     *
     * If a string is given, the font family is set.
     *
     * If an object is given, the `fontFamily`, `fontSize` and `fontStyle`
     * properties of that object are set.
     *
     * @method Phaser.GameObjects.TextStyle#setFont
     * @since 3.0.0
     *
     * @param {(string|object)} font - The font family or font settings to set.
     * @param {boolean} [updateText=true] - Whether to update the text immediately.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFont: function(font, updateText) {
                        if (updateText === undefined) updateText = true;
                        var fontFamily = font;
                        var fontSize = '';
                        var fontStyle = '';
                        if (typeof font !== 'string') {
                            fontFamily = GetValue(font, 'fontFamily', 'Courier');
                            fontSize = GetValue(font, 'fontSize', '16px');
                            fontStyle = GetValue(font, 'fontStyle', '');
                        } else {
                            var fontSplit = font.split(' ');
                            var i = 0;
                            fontStyle = fontSplit.length > 2 ? fontSplit[i++] : '';
                            fontSize = fontSplit[i++] || '16px';
                            fontFamily = fontSplit[i++] || 'Courier';
                        }
                        if (fontFamily !== this.fontFamily || fontSize !== this.fontSize || fontStyle !== this.fontStyle) {
                            this.fontFamily = fontFamily;
                            this.fontSize = fontSize;
                            this.fontStyle = fontStyle;
                            if (updateText) this.update(true);
                        }
                        return this.parent;
                    },
                    /**
     * Set the font family.
     *
     * @method Phaser.GameObjects.TextStyle#setFontFamily
     * @since 3.0.0
     *
     * @param {string} family - The font family.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontFamily: function(family) {
                        if (this.fontFamily !== family) {
                            this.fontFamily = family;
                            this.update(true);
                        }
                        return this.parent;
                    },
                    /**
     * Set the font style.
     *
     * @method Phaser.GameObjects.TextStyle#setFontStyle
     * @since 3.0.0
     *
     * @param {string} style - The font style.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontStyle: function(style) {
                        if (this.fontStyle !== style) {
                            this.fontStyle = style;
                            this.update(true);
                        }
                        return this.parent;
                    },
                    /**
     * Set the font size. Can be a string with a valid CSS unit, i.e. `16px`, or a number.
     *
     * @method Phaser.GameObjects.TextStyle#setFontSize
     * @since 3.0.0
     *
     * @param {(number|string)} size - The font size.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontSize: function(size) {
                        if (typeof size === 'number') size = size.toString() + 'px';
                        if (this.fontSize !== size) {
                            this.fontSize = size;
                            this.update(true);
                        }
                        return this.parent;
                    },
                    /**
     * Set the test string to use when measuring the font.
     *
     * @method Phaser.GameObjects.TextStyle#setTestString
     * @since 3.0.0
     *
     * @param {string} string - The test string to use when measuring the font.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setTestString: function(string) {
                        this.testString = string;
                        return this.update(true);
                    },
                    /**
     * Set a fixed width and height for the text.
     *
     * Pass in `0` for either of these parameters to disable fixed width or height respectively.
     *
     * @method Phaser.GameObjects.TextStyle#setFixedSize
     * @since 3.0.0
     *
     * @param {number} width - The fixed width to set.
     * @param {number} height - The fixed height to set.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFixedSize: function(width, height) {
                        this.fixedWidth = width;
                        this.fixedHeight = height;
                        if (width) this.parent.width = width;
                        if (height) this.parent.height = height;
                        return this.update(false);
                    },
                    /**
     * Set the background color.
     *
     * @method Phaser.GameObjects.TextStyle#setBackgroundColor
     * @since 3.0.0
     *
     * @param {string} color - The background color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setBackgroundColor: function(color) {
                        this.backgroundColor = color;
                        return this.update(false);
                    },
                    /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.TextStyle#setFill
     * @since 3.0.0
     *
     * @param {(string|CanvasGradient|CanvasPattern)} color - The text fill color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFill: function(color) {
                        this.color = color;
                        return this.update(false);
                    },
                    /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.TextStyle#setColor
     * @since 3.0.0
     *
     * @param {(string|CanvasGradient|CanvasPattern)} color - The text fill color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setColor: function(color) {
                        this.color = color;
                        return this.update(false);
                    },
                    /**
     * Set the resolution used by the Text object.
     *
     * It allows for much clearer text on High DPI devices, at the cost of memory because
     * it uses larger internal Canvas textures for the Text.
     *
     * Please use with caution, as the more high res Text you have, the more memory it uses up.
     *
     * @method Phaser.GameObjects.TextStyle#setResolution
     * @since 3.12.0
     *
     * @param {number} value - The resolution for this Text object to use.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setResolution: function(value) {
                        this.resolution = value;
                        return this.update(false);
                    },
                    /**
     * Set the stroke settings.
     *
     * @method Phaser.GameObjects.TextStyle#setStroke
     * @since 3.0.0
     *
     * @param {(string|CanvasGradient|CanvasPattern)} color - The stroke color.
     * @param {number} thickness - The stroke thickness.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setStroke: function(color, thickness) {
                        if (thickness === undefined) thickness = this.strokeThickness;
                        if (color === undefined && this.strokeThickness !== 0) {
                            //  Reset the stroke to zero (disabling it)
                            this.strokeThickness = 0;
                            this.update(true);
                        } else if (this.stroke !== color || this.strokeThickness !== thickness) {
                            this.stroke = color;
                            this.strokeThickness = thickness;
                            this.update(true);
                        }
                        return this.parent;
                    },
                    /**
     * Set the shadow settings.
     *
     * Calling this method always re-measures the parent Text object,
     * so only call it when you actually change the shadow settings.
     *
     * @method Phaser.GameObjects.TextStyle#setShadow
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     * @param {string} [color='#000'] - The shadow color.
     * @param {number} [blur=0] - The shadow blur radius.
     * @param {boolean} [shadowStroke=false] - Whether to stroke the shadow.
     * @param {boolean} [shadowFill=true] - Whether to fill the shadow.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadow: function(x, y, color, blur, shadowStroke, shadowFill) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (color === undefined) color = '#000';
                        if (blur === undefined) blur = 0;
                        if (shadowStroke === undefined) shadowStroke = false;
                        if (shadowFill === undefined) shadowFill = true;
                        this.shadowOffsetX = x;
                        this.shadowOffsetY = y;
                        this.shadowColor = color;
                        this.shadowBlur = blur;
                        this.shadowStroke = shadowStroke;
                        this.shadowFill = shadowFill;
                        return this.update(false);
                    },
                    /**
     * Set the shadow offset.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowOffset
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowOffset: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = x;
                        this.shadowOffsetX = x;
                        this.shadowOffsetY = y;
                        return this.update(false);
                    },
                    /**
     * Set the shadow color.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowColor
     * @since 3.0.0
     *
     * @param {string} [color='#000'] - The shadow color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowColor: function(color) {
                        if (color === undefined) color = '#000';
                        this.shadowColor = color;
                        return this.update(false);
                    },
                    /**
     * Set the shadow blur radius.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowBlur
     * @since 3.0.0
     *
     * @param {number} [blur=0] - The shadow blur radius.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowBlur: function(blur) {
                        if (blur === undefined) blur = 0;
                        this.shadowBlur = blur;
                        return this.update(false);
                    },
                    /**
     * Enable or disable shadow stroke.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowStroke
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow stroke is enabled or not.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowStroke: function(enabled) {
                        this.shadowStroke = enabled;
                        return this.update(false);
                    },
                    /**
     * Enable or disable shadow fill.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowFill
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow fill is enabled or not.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowFill: function(enabled) {
                        this.shadowFill = enabled;
                        return this.update(false);
                    },
                    /**
     * Set the width (in pixels) to use for wrapping lines.
     *
     * Pass in null to remove wrapping by width.
     *
     * @method Phaser.GameObjects.TextStyle#setWordWrapWidth
     * @since 3.0.0
     *
     * @param {number | null} width - The maximum width of a line in pixels. Set to null to remove wrapping.
     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
     * spaces and whitespace are left as is.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setWordWrapWidth: function(width, useAdvancedWrap) {
                        if (useAdvancedWrap === undefined) useAdvancedWrap = false;
                        this.wordWrapWidth = width;
                        this.wordWrapUseAdvanced = useAdvancedWrap;
                        return this.update(false);
                    },
                    /**
     * Set a custom callback for wrapping lines.
     *
     * Pass in null to remove wrapping by callback.
     *
     * @method Phaser.GameObjects.TextStyle#setWordWrapCallback
     * @since 3.0.0
     *
     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
     * instance). It should return the wrapped lines either as an array of lines or as a string with
     * newline characters in place to indicate where breaks should happen.
     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setWordWrapCallback: function(callback, scope) {
                        if (scope === undefined) scope = null;
                        this.wordWrapCallback = callback;
                        this.wordWrapCallbackScope = scope;
                        return this.update(false);
                    },
                    /**
     * Set the alignment of the text in this Text object.
     *
     * The argument can be one of: `left`, `right`, `center` or `justify`.
     *
     * Alignment only works if the Text object has more than one line of text.
     *
     * @method Phaser.GameObjects.TextStyle#setAlign
     * @since 3.0.0
     *
     * @param {string} [align='left'] - The text alignment for multi-line text.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setAlign: function(align) {
                        if (align === undefined) align = 'left';
                        this.align = align;
                        return this.update(false);
                    },
                    /**
     * Set the maximum number of lines to draw.
     *
     * @method Phaser.GameObjects.TextStyle#setMaxLines
     * @since 3.0.0
     *
     * @param {number} [max=0] - The maximum number of lines to draw.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setMaxLines: function(max) {
                        if (max === undefined) max = 0;
                        this.maxLines = max;
                        return this.update(false);
                    },
                    /**
     * Get the current text metrics.
     *
     * @method Phaser.GameObjects.TextStyle#getTextMetrics
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.Text.TextMetrics} The text metrics.
     */ getTextMetrics: function() {
                        var metrics = this.metrics;
                        return {
                            ascent: metrics.ascent,
                            descent: metrics.descent,
                            fontSize: metrics.fontSize
                        };
                    },
                    /**
     * Build a JSON representation of this Text Style.
     *
     * @method Phaser.GameObjects.TextStyle#toJSON
     * @since 3.0.0
     *
     * @return {object} A JSON representation of this Text Style.
     */ toJSON: function() {
                        var output = {};
                        for(var key in propertyMap)output[key] = this[key];
                        output.metrics = this.getTextMetrics();
                        return output;
                    },
                    /**
     * Destroy this Text Style.
     *
     * @method Phaser.GameObjects.TextStyle#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.parent = undefined;
                    }
                });
                module1.exports = TextStyle;
            /***/ },
            /***/ 34397: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    if (src.width === 0 || src.height === 0) return;
                    camera.addToRenderList(src);
                    var frame = src.frame;
                    var width = frame.width;
                    var height = frame.height;
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var textureUnit = pipeline.setTexture2D(frame.glTexture, src);
                    pipeline.batchTexture(src, frame.glTexture, width, height, src.x, src.y, width / src.style.resolution, height / src.style.resolution, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.displayOriginX, src.displayOriginY, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, 0, 0, camera, parentMatrix, false, textureUnit);
                };
                module1.exports = TextWebGLRenderer;
            /***/ },
            /***/ 20839: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(27919);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var GetPowerOfTwo = __webpack_require__(98439);
                var Smoothing = __webpack_require__(68703);
                var TileSpriteRender = __webpack_require__(56295);
                var UUID = __webpack_require__(45650);
                var Vector2 = __webpack_require__(26099);
                //  bitmask flag for GameObject.renderMask
                var _FLAG = 8; // 1000
                /**
 * @classdesc
 * A TileSprite is a Sprite that has a repeating texture.
 *
 * The texture can be scrolled and scaled independently of the TileSprite itself. Textures will automatically wrap and
 * are designed so that you can create game backdrops using seamless textures as a source.
 *
 * You shouldn't ever create a TileSprite any larger than your actual canvas size. If you want to create a large repeating background
 * that scrolls across the whole map of your game, then you create a TileSprite that fits the canvas size and then use the `tilePosition`
 * property to scroll the texture as the player moves. If you create a TileSprite that is thousands of pixels in size then it will
 * consume huge amounts of memory and cause performance issues. Remember: use `tilePosition` to scroll your texture and `tileScale` to
 * adjust the scale of the texture - don't resize the sprite itself or make it larger than it needs.
 *
 * An important note about Tile Sprites and NPOT textures: Internally, TileSprite textures use GL_REPEAT to provide
 * seamless repeating of the textures. This, combined with the way in which the textures are handled in WebGL, means
 * they need to be POT (power-of-two) sizes in order to wrap. If you provide a NPOT (non power-of-two) texture to a
 * TileSprite it will generate a POT sized canvas and draw your texture to it, scaled up to the POT size. It's then
 * scaled back down again during rendering to the original dimensions. While this works, in that it allows you to use
 * any size texture for a Tile Sprite, it does mean that NPOT textures are going to appear anti-aliased when rendered,
 * due to the interpolation that took place when it was resized into a POT texture. This is especially visible in
 * pixel art graphics. If you notice it and it becomes an issue, the only way to avoid it is to ensure that you
 * provide POT textures for Tile Sprites.
 *
 * @class TileSprite
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object. If zero it will use the size of the texture frame.
 * @param {number} height - The height of the Game Object. If zero it will use the size of the texture frame.
 * @param {string} textureKey - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager. Cannot be a DynamicTexture.
 * @param {(string|number)} [frameKey] - An optional frame from the Texture this Game Object is rendering with.
 */ var TileSprite = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.ComputedSize,
                        Components.Crop,
                        Components.Depth,
                        Components.Flip,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.Tint,
                        Components.Transform,
                        Components.Visible,
                        TileSpriteRender
                    ],
                    initialize: function TileSprite(scene, x, y, width, height, textureKey, frameKey) {
                        var renderer = scene.sys.renderer;
                        GameObject.call(this, scene, 'TileSprite');
                        var displayTexture = scene.sys.textures.get(textureKey);
                        var displayFrame = displayTexture.get(frameKey);
                        if (displayFrame.source.compressionAlgorithm) {
                            console.warn('TileSprite cannot use compressed texture');
                            displayTexture = scene.sys.textures.get('__MISSING');
                            displayFrame = displayTexture.get();
                        }
                        if (displayTexture.type === 'DynamicTexture') {
                            console.warn('TileSprite cannot use Dynamic Texture');
                            displayTexture = scene.sys.textures.get('__MISSING');
                            displayFrame = displayTexture.get();
                        }
                        if (!width || !height) {
                            width = width ? width : displayFrame.width;
                            height = height ? height : displayFrame.height;
                        } else {
                            width = Math.floor(width);
                            height = Math.floor(height);
                        }
                        /**
         * Internal tile position vector.
         *
         * @name Phaser.GameObjects.TileSprite#_tilePosition
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.12.0
         */ this._tilePosition = new Vector2();
                        /**
         * Internal tile scale vector.
         *
         * @name Phaser.GameObjects.TileSprite#_tileScale
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.12.0
         */ this._tileScale = new Vector2(1, 1);
                        /**
         * Whether the Tile Sprite has changed in some way, requiring an re-render of its tile texture.
         *
         * Such changes include the texture frame and scroll position of the Tile Sprite.
         *
         * @name Phaser.GameObjects.TileSprite#dirty
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.dirty = false;
                        /**
         * The renderer in use by this Tile Sprite.
         *
         * @name Phaser.GameObjects.TileSprite#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.0.0
         */ this.renderer = renderer;
                        /**
         * The Canvas element that the TileSprite renders its fill pattern in to.
         * Only used in Canvas mode.
         *
         * @name Phaser.GameObjects.TileSprite#canvas
         * @type {?HTMLCanvasElement}
         * @since 3.12.0
         */ this.canvas = CanvasPool.create(this, width, height);
                        /**
         * The Context of the Canvas element that the TileSprite renders its fill pattern in to.
         * Only used in Canvas mode.
         *
         * @name Phaser.GameObjects.TileSprite#context
         * @type {CanvasRenderingContext2D}
         * @since 3.12.0
         */ this.context = this.canvas.getContext('2d', {
                            willReadFrequently: false
                        });
                        /**
         * The Texture the TileSprite is using as its fill pattern.
         *
         * @name Phaser.GameObjects.TileSprite#displayTexture
         * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
         * @private
         * @since 3.12.0
         */ this.displayTexture = displayTexture;
                        /**
         * The Frame the TileSprite is using as its fill pattern.
         *
         * @name Phaser.GameObjects.TileSprite#displayFrame
         * @type {Phaser.Textures.Frame}
         * @private
         * @since 3.12.0
         */ this.displayFrame = displayFrame;
                        /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.TileSprite#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                        /**
         * The internal unique key to refer to the texture in the TextureManager.
         *
         * @name Phaser.GameObjects.TileSprite#_textureKey
         * @type {string}
         * @private
         * @since 3.80.0
         */ this._textureKey = UUID();
                        /**
         * The Texture this Game Object is using to render with.
         *
         * @name Phaser.GameObjects.TileSprite#texture
         * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
         * @since 3.0.0
         */ this.texture = scene.sys.textures.addCanvas(this._textureKey, this.canvas);
                        /**
         * The Texture Frame this Game Object is using to render with.
         *
         * @name Phaser.GameObjects.TileSprite#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.frame = this.texture.get();
                        /**
         * The next power of two value from the width of the Fill Pattern frame.
         *
         * @name Phaser.GameObjects.TileSprite#potWidth
         * @type {number}
         * @since 3.0.0
         */ this.potWidth = GetPowerOfTwo(displayFrame.width);
                        /**
         * The next power of two value from the height of the Fill Pattern frame.
         *
         * @name Phaser.GameObjects.TileSprite#potHeight
         * @type {number}
         * @since 3.0.0
         */ this.potHeight = GetPowerOfTwo(displayFrame.height);
                        /**
         * The Canvas that the TileSprites texture is rendered to.
         * This is used to create a WebGL texture from.
         *
         * @name Phaser.GameObjects.TileSprite#fillCanvas
         * @type {HTMLCanvasElement}
         * @since 3.12.0
         */ this.fillCanvas = CanvasPool.create2D(this, this.potWidth, this.potHeight);
                        /**
         * The Canvas Context used to render the TileSprites texture.
         *
         * @name Phaser.GameObjects.TileSprite#fillContext
         * @type {CanvasRenderingContext2D}
         * @since 3.12.0
         */ this.fillContext = this.fillCanvas.getContext('2d', {
                            willReadFrequently: false
                        });
                        /**
         * The texture that the Tile Sprite is rendered to, which is then rendered to a Scene.
         * In WebGL this is a WebGLTextureWrapper. In Canvas it's a Canvas Fill Pattern.
         *
         * @name Phaser.GameObjects.TileSprite#fillPattern
         * @type {?(Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper|CanvasPattern)}
         * @since 3.12.0
         */ this.fillPattern = null;
                        this.setPosition(x, y);
                        this.setSize(width, height);
                        this.setFrame(frameKey);
                        this.setOriginFromFrame();
                        this.initPipeline();
                        this.initPostPipeline(true);
                    },
                    /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.TileSprite#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                        this.displayTexture = this.scene.sys.textures.get(key);
                        return this.setFrame(frame);
                    },
                    /**
     * Sets the frame this Game Object will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * @method Phaser.GameObjects.TileSprite#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} frame - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame) {
                        var newFrame = this.displayTexture.get(frame);
                        this.potWidth = GetPowerOfTwo(newFrame.width);
                        this.potHeight = GetPowerOfTwo(newFrame.height);
                        //  So updateCanvas is triggered
                        this.canvas.width = 0;
                        if (!newFrame.cutWidth || !newFrame.cutHeight) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                        this.displayFrame = newFrame;
                        this.dirty = true;
                        this.updateTileTexture();
                        return this;
                    },
                    /**
     * Sets {@link Phaser.GameObjects.TileSprite#tilePositionX} and {@link Phaser.GameObjects.TileSprite#tilePositionY}.
     *
     * @method Phaser.GameObjects.TileSprite#setTilePosition
     * @since 3.3.0
     *
     * @param {number} [x] - The x position of this sprite's tiling texture.
     * @param {number} [y] - The y position of this sprite's tiling texture.
     *
     * @return {this} This Tile Sprite instance.
     */ setTilePosition: function(x, y) {
                        if (x !== undefined) this.tilePositionX = x;
                        if (y !== undefined) this.tilePositionY = y;
                        return this;
                    },
                    /**
     * Sets {@link Phaser.GameObjects.TileSprite#tileScaleX} and {@link Phaser.GameObjects.TileSprite#tileScaleY}.
     *
     * @method Phaser.GameObjects.TileSprite#setTileScale
     * @since 3.12.0
     *
     * @param {number} [x] - The horizontal scale of the tiling texture. If not given it will use the current `tileScaleX` value.
     * @param {number} [y=x] - The vertical scale of the tiling texture. If not given it will use the `x` value.
     *
     * @return {this} This Tile Sprite instance.
     */ setTileScale: function(x, y) {
                        if (x === undefined) x = this.tileScaleX;
                        if (y === undefined) y = x;
                        this.tileScaleX = x;
                        this.tileScaleY = y;
                        return this;
                    },
                    /**
     * Render the tile texture if it is dirty, or if the frame has changed.
     *
     * @method Phaser.GameObjects.TileSprite#updateTileTexture
     * @private
     * @since 3.0.0
     */ updateTileTexture: function() {
                        if (!this.dirty || !this.renderer) return;
                        //  Draw the displayTexture to our fillCanvas
                        var frame = this.displayFrame;
                        if (frame.source.isRenderTexture || frame.source.isGLTexture) {
                            console.warn('TileSprites can only use Image or Canvas based textures');
                            this.dirty = false;
                            return;
                        }
                        var ctx = this.fillContext;
                        var canvas = this.fillCanvas;
                        var fw = this.potWidth;
                        var fh = this.potHeight;
                        if (!this.renderer || !this.renderer.gl) {
                            fw = frame.cutWidth;
                            fh = frame.cutHeight;
                        }
                        ctx.clearRect(0, 0, fw, fh);
                        canvas.width = fw;
                        canvas.height = fh;
                        ctx.drawImage(frame.source.image, frame.cutX, frame.cutY, frame.cutWidth, frame.cutHeight, 0, 0, fw, fh);
                        if (this.renderer && this.renderer.gl) this.fillPattern = this.renderer.canvasToTexture(canvas, this.fillPattern);
                        else this.fillPattern = ctx.createPattern(canvas, 'repeat');
                        this.updateCanvas();
                        this.dirty = false;
                    },
                    /**
     * Draw the fill pattern to the internal canvas.
     *
     * @method Phaser.GameObjects.TileSprite#updateCanvas
     * @private
     * @since 3.12.0
     */ updateCanvas: function() {
                        var canvas = this.canvas;
                        if (canvas.width !== this.width || canvas.height !== this.height) {
                            canvas.width = this.width;
                            canvas.height = this.height;
                            this.frame.setSize(this.width, this.height);
                            this.updateDisplayOrigin();
                            this.dirty = true;
                        }
                        if (!this.dirty || this.renderer && this.renderer.gl) {
                            this.dirty = false;
                            return;
                        }
                        var ctx = this.context;
                        if (!this.scene.sys.game.config.antialias) Smoothing.disable(ctx);
                        var scaleX = this._tileScale.x;
                        var scaleY = this._tileScale.y;
                        var positionX = this._tilePosition.x;
                        var positionY = this._tilePosition.y;
                        ctx.clearRect(0, 0, this.width, this.height);
                        ctx.save();
                        ctx.scale(scaleX, scaleY);
                        ctx.translate(-positionX, -positionY);
                        ctx.fillStyle = this.fillPattern;
                        ctx.fillRect(positionX, positionY, this.width / scaleX, this.height / scaleY);
                        ctx.restore();
                        this.dirty = false;
                    },
                    /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.TileSprite#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                        if (this.renderer && this.renderer.gl) this.renderer.deleteTexture(this.fillPattern);
                        CanvasPool.remove(this.canvas);
                        CanvasPool.remove(this.fillCanvas);
                        this.fillPattern = null;
                        this.fillContext = null;
                        this.fillCanvas = null;
                        this.displayTexture = null;
                        this.displayFrame = null;
                        var texture = this.texture;
                        if (texture) texture.destroy();
                        this.renderer = null;
                    },
                    /**
     * The horizontal scroll position of the Tile Sprite.
     *
     * @name Phaser.GameObjects.TileSprite#tilePositionX
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ tilePositionX: {
                        get: function() {
                            return this._tilePosition.x;
                        },
                        set: function(value) {
                            this._tilePosition.x = value;
                            this.dirty = true;
                        }
                    },
                    /**
     * The vertical scroll position of the Tile Sprite.
     *
     * @name Phaser.GameObjects.TileSprite#tilePositionY
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ tilePositionY: {
                        get: function() {
                            return this._tilePosition.y;
                        },
                        set: function(value) {
                            this._tilePosition.y = value;
                            this.dirty = true;
                        }
                    },
                    /**
     * The horizontal scale of the Tile Sprite texture.
     *
     * @name Phaser.GameObjects.TileSprite#tileScaleX
     * @type {number}
     * @default 1
     * @since 3.11.0
     */ tileScaleX: {
                        get: function() {
                            return this._tileScale.x;
                        },
                        set: function(value) {
                            this._tileScale.x = value;
                            this.dirty = true;
                        }
                    },
                    /**
     * The vertical scale of the Tile Sprite texture.
     *
     * @name Phaser.GameObjects.TileSprite#tileScaleY
     * @type {number}
     * @default 1
     * @since 3.11.0
     */ tileScaleY: {
                        get: function() {
                            return this._tileScale.y;
                        },
                        set: function(value) {
                            this._tileScale.y = value;
                            this.dirty = true;
                        }
                    }
                });
                module1.exports = TileSprite;
            /***/ },
            /***/ 46992: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.TileSprite#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TileSpriteCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    src.updateCanvas();
                    camera.addToRenderList(src);
                    renderer.batchSprite(src, src.frame, camera, parentMatrix);
                };
                module1.exports = TileSpriteCanvasRenderer;
            /***/ },
            /***/ 14167: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var TileSprite = __webpack_require__(20839);
                /**
 * Creates a new TileSprite Game Object and returns it.
 *
 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tileSprite
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.TileSprite.TileSpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
 */ GameObjectCreator.register('tileSprite', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var x = GetAdvancedValue(config, 'x', 0);
                    var y = GetAdvancedValue(config, 'y', 0);
                    var width = GetAdvancedValue(config, 'width', 512);
                    var height = GetAdvancedValue(config, 'height', 512);
                    var key = GetAdvancedValue(config, 'key', '');
                    var frame = GetAdvancedValue(config, 'frame', '');
                    var tile = new TileSprite(this.scene, x, y, width, height, key, frame);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, tile, config);
                    return tile;
                });
            /***/ },
            /***/ 91681: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileSprite = __webpack_require__(20839);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new TileSprite Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tileSprite
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object. If zero it will use the size of the texture frame.
 * @param {number} height - The height of the Game Object. If zero it will use the size of the texture frame.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager. Cannot be a DynamicTexture.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
 */ GameObjectFactory.register('tileSprite', function(x, y, width, height, texture, frame) {
                    return this.displayList.add(new TileSprite(this.scene, x, y, width, height, texture, frame));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 56295: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(18553);
                renderCanvas = __webpack_require__(46992);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 18553: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.TileSprite#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TileSpriteWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    src.updateCanvas();
                    var width = src.width;
                    var height = src.height;
                    if (width === 0 || height === 0) return;
                    camera.addToRenderList(src);
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var textureUnit = pipeline.setTexture2D(src.fillPattern, src);
                    pipeline.batchTexture(src, src.fillPattern, src.displayFrame.width * src.tileScaleX, src.displayFrame.height * src.tileScaleY, src.x, src.y, width, height, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.originX * width, src.originY * height, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, src.tilePositionX % src.displayFrame.width / src.displayFrame.width, src.tilePositionY % src.displayFrame.height / src.displayFrame.height, camera, parentMatrix, false, textureUnit);
                };
                module1.exports = TileSpriteWebGLRenderer;
            /***/ },
            /***/ 18471: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var Events = __webpack_require__(51708);
                var GameEvents = __webpack_require__(8443);
                var GameObject = __webpack_require__(95643);
                var MATH_CONST = __webpack_require__(36383);
                var SoundEvents = __webpack_require__(14463);
                var UUID = __webpack_require__(45650);
                var VideoRender = __webpack_require__(10247);
                /**
 * @classdesc
 * A Video Game Object.
 *
 * This Game Object is capable of handling playback of a video file, video stream or media stream.
 *
 * You can optionally 'preload' the video into the Phaser Video Cache:
 *
 * ```javascript
 * preload () {
 *   this.load.video('ripley', 'assets/aliens.mp4');
 * }
 *
 * create () {
 *   this.add.video(400, 300, 'ripley');
 * }
 * ```
 *
 * You don't have to 'preload' the video. You can also play it directly from a URL:
 *
 * ```javascript
 * create () {
 *   this.add.video(400, 300).loadURL('assets/aliens.mp4');
 * }
 * ```
 *
 * To all intents and purposes, a video is a standard Game Object, just like a Sprite. And as such, you can do
 * all the usual things to it, such as scaling, rotating, cropping, tinting, making interactive, giving a
 * physics body, etc.
 *
 * Transparent videos are also possible via the WebM file format. Providing the video file has was encoded with
 * an alpha channel, and providing the browser supports WebM playback (not all of them do), then it will render
 * in-game with full transparency.
 *
 * Playback is handled entirely via the Request Video Frame API, which is supported by most modern browsers.
 * A polyfill is provided for older browsers.
 *
 * ### Autoplaying Videos
 *
 * Videos can only autoplay if the browser has been unlocked with an interaction, or satisfies the MEI settings.
 * The policies that control autoplaying are vast and vary between browser. You can, and should, read more about
 * it here: https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
 *
 * If your video doesn't contain any audio, then set the `noAudio` parameter to `true` when the video is _loaded_,
 * and it will often allow the video to play immediately:
 *
 * ```javascript
 * preload () {
 *   this.load.video('pixar', 'nemo.mp4', true);
 * }
 * ```
 *
 * The 3rd parameter in the load call tells Phaser that the video doesn't contain any audio tracks. Video without
 * audio can autoplay without requiring a user interaction. Video with audio cannot do this unless it satisfies
 * the browsers MEI settings. See the MDN Autoplay Guide for further details.
 *
 * Or:
 *
 * ```javascript
 * create () {
 *   this.add.video(400, 300).loadURL('assets/aliens.mp4', true);
 * }
 * ```
 *
 * You can set the `noAudio` parameter to `true` even if the video does contain audio. It will still allow the video
 * to play immediately, but the audio will not start.
 *
 * Note that due to a bug in IE11 you cannot play a video texture to a Sprite in WebGL. For IE11 force Canvas mode.
 *
 * More details about video playback and the supported media formats can be found on MDN:
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
 * https://developer.mozilla.org/en-US/docs/Web/Media/Formats
 *
 * @class Video
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.20.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {string} [key] - Optional key of the Video this Game Object will play, as stored in the Video Cache.
 */ var Video = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.ComputedSize,
                        Components.Depth,
                        Components.Flip,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.ScrollFactor,
                        Components.TextureCrop,
                        Components.Tint,
                        Components.Transform,
                        Components.Visible,
                        VideoRender
                    ],
                    initialize: function Video(scene, x, y, key) {
                        GameObject.call(this, scene, 'Video');
                        /**
         * A reference to the HTML Video Element this Video Game Object is playing.
         *
         * Will be `undefined` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#video
         * @type {?HTMLVideoElement}
         * @since 3.20.0
         */ this.video;
                        /**
         * The Phaser Texture this Game Object is using to render the video to.
         *
         * Will be `undefined` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#videoTexture
         * @type {?Phaser.Textures.Texture}
         * @since 3.20.0
         */ this.videoTexture;
                        /**
         * A reference to the TextureSource backing the `videoTexture` Texture object.
         *
         * Will be `undefined` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#videoTextureSource
         * @type {?Phaser.Textures.TextureSource}
         * @since 3.20.0
         */ this.videoTextureSource;
                        /**
         * A Phaser `CanvasTexture` instance that holds the most recent snapshot taken from the video.
         *
         * This will only be set if the `snapshot` or `snapshotArea` methods have been called.
         *
         * Until those methods are called, this property will be `undefined`.
         *
         * @name Phaser.GameObjects.Video#snapshotTexture
         * @type {?Phaser.Textures.CanvasTexture}
         * @since 3.20.0
         */ this.snapshotTexture;
                        /**
         * If you have saved this video to a texture via the `saveTexture` method, this controls if the video
         * is rendered with `flipY` in WebGL or not. You often need to set this if you wish to use the video texture
         * as the input source for a shader. If you find your video is appearing upside down within a shader or
         * custom pipeline, flip this property.
         *
         * @name Phaser.GameObjects.Video#flipY
         * @type {boolean}
         * @since 3.20.0
         */ this.flipY = false;
                        /**
         * The key used by the texture as stored in the Texture Manager.
         *
         * @name Phaser.GameObjects.Video#_key
         * @type {string}
         * @private
         * @since 3.20.0
         */ this._key = UUID();
                        /**
         * An internal flag holding the current state of the video lock, should document interaction be required
         * before playback can begin.
         *
         * @name Phaser.GameObjects.Video#touchLocked
         * @type {boolean}
         * @readonly
         * @since 3.20.0
         */ this.touchLocked = false;
                        /**
         * Should the video auto play when document interaction is required and happens?
         *
         * @name Phaser.GameObjects.Video#playWhenUnlocked
         * @type {boolean}
         * @since 3.20.0
         */ this.playWhenUnlocked = false;
                        /**
         * Has the video created its texture and populated it with the first frame of video?
         *
         * @name Phaser.GameObjects.Video#frameReady
         * @type {boolean}
         * @since 3.60.0
         */ this.frameReady = false;
                        /**
         * This read-only property returns `true` if the video is currently stalled, i.e. it has stopped
         * playing due to a lack of data, or too much data, but hasn't yet reached the end of the video.
         *
         * This is set if the Video DOM element emits any of the following events:
         *
         * `stalled`
         * `suspend`
         * `waiting`
         *
         * And is cleared if the Video DOM element emits the `playing` event, or handles
         * a requestVideoFrame call.
         *
         * Listen for the Phaser Event `VIDEO_STALLED` to be notified and inspect the event
         * to see which DOM event caused it.
         *
         * Note that being stalled isn't always a negative thing. A video can be stalled if it
         * has downloaded enough data in to its buffer to not need to download any more until
         * the current batch of frames have rendered.
         *
         * @name Phaser.GameObjects.Video#isStalled
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isStalled = false;
                        /**
         * Records the number of times the video has failed to play,
         * typically because the user hasn't interacted with the page yet.
         *
         * @name Phaser.GameObjects.Video#failedPlayAttempts
         * @type {number}
         * @since 3.60.0
         */ this.failedPlayAttempts = 0;
                        /**
         * If the browser supports the Request Video Frame API then this
         * property will hold the metadata that is returned from
         * the callback each time it is invoked.
         *
         * See https://wicg.github.io/video-rvfc/#video-frame-metadata-callback
         * for a complete list of all properties that will be in this object.
         * Likely of most interest is the `mediaTime` property:
         *
         * The media presentation timestamp (PTS) in seconds of the frame presented
         * (e.g. its timestamp on the video.currentTime timeline). MAY have a zero
         * value for live-streams or WebRTC applications.
         *
         * If the browser doesn't support the API then this property will be undefined.
         *
         * @name Phaser.GameObjects.Video#metadata
         * @type {VideoFrameCallbackMetadata}
         * @since 3.60.0
         */ this.metadata;
                        /**
         * The current retry elapsed time.
         *
         * @name Phaser.GameObjects.Video#retry
         * @type {number}
         * @since 3.20.0
         */ this.retry = 0;
                        /**
         * If a video fails to play due to a lack of user interaction, this is the
         * amount of time, in ms, that the video will wait before trying again to
         * play. The default is 500ms.
         *
         * @name Phaser.GameObjects.Video#retryInterval
         * @type {number}
         * @since 3.20.0
         */ this.retryInterval = 500;
                        /**
         * The video was muted due to a system event, such as the game losing focus.
         *
         * @name Phaser.GameObjects.Video#_systemMuted
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._systemMuted = false;
                        /**
         * The video was muted due to game code, not a system event.
         *
         * @name Phaser.GameObjects.Video#_codeMuted
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._codeMuted = false;
                        /**
         * The video was paused due to a system event, such as the game losing focus.
         *
         * @name Phaser.GameObjects.Video#_systemPaused
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._systemPaused = false;
                        /**
         * The video was paused due to game code, not a system event.
         *
         * @name Phaser.GameObjects.Video#_codePaused
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._codePaused = false;
                        /**
         * The locally bound event callback handlers.
         *
         * @name Phaser.GameObjects.Video#_callbacks
         * @type {any}
         * @private
         * @since 3.20.0
         */ this._callbacks = {
                            ended: this.completeHandler.bind(this),
                            legacy: this.legacyPlayHandler.bind(this),
                            playing: this.playingHandler.bind(this),
                            seeked: this.seekedHandler.bind(this),
                            seeking: this.seekingHandler.bind(this),
                            stalled: this.stalledHandler.bind(this),
                            suspend: this.stalledHandler.bind(this),
                            waiting: this.stalledHandler.bind(this)
                        };
                        /**
         * The locally bound callback handler specifically for load and load error events.
         *
         * @name Phaser.GameObjects.Video#_loadCallbackHandler
         * @type {function}
         * @private
         * @since 3.60.0
         */ this._loadCallbackHandler = this.loadErrorHandler.bind(this);
                        /**
         * The locally bound callback handler specifically for the loadedmetadata event.
         *
         * @name Phaser.GameObjects.Video#_metadataCallbackHandler
         * @type {function}
         * @private
         * @since 3.80.0
         */ this._metadataCallbackHandler = this.metadataHandler.bind(this);
                        /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Video#_crop
         * @type {object}
         * @private
         * @since 3.20.0
         */ this._crop = this.resetCropObject();
                        /**
         * An object containing in and out markers for sequence playback.
         *
         * @name Phaser.GameObjects.Video#markers
         * @type {any}
         * @since 3.20.0
         */ this.markers = {};
                        /**
         * The in marker.
         *
         * @name Phaser.GameObjects.Video#_markerIn
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._markerIn = 0;
                        /**
         * The out marker.
         *
         * @name Phaser.GameObjects.Video#_markerOut
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._markerOut = 0;
                        /**
         * Are we playing a marked segment of the video?
         *
         * @name Phaser.GameObjects.Video#_playingMarker
         * @type {boolean}
         * @private
         * @since 3.60.0
         */ this._playingMarker = false;
                        /**
         * The previous frames mediaTime.
         *
         * @name Phaser.GameObjects.Video#_lastUpdate
         * @type {number}
         * @private
         * @since 3.60.0
        */ this._lastUpdate = 0;
                        /**
         * The key of the current video as stored in the Video cache.
         *
         * If the video did not come from the cache this will be an empty string.
         *
         * @name Phaser.GameObjects.Video#cacheKey
         * @type {string}
         * @readonly
         * @since 3.60.0
         */ this.cacheKey = '';
                        /**
         * Is the video currently seeking?
         *
         * This is set to `true` when the `seeking` event is fired,
         * and set to `false` when the `seeked` event is fired.
         *
         * @name Phaser.GameObjects.Video#isSeeking
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isSeeking = false;
                        /**
         * Has Video.play been called? This is reset if a new Video is loaded.
         *
         * @name Phaser.GameObjects.Video#_playCalled
         * @type {boolean}
         * @private
         * @since 3.60.0
         */ this._playCalled = false;
                        /**
         * Has Video.getFirstFrame been called? This is reset if a new Video is loaded or played.
         *
         * @name Phaser.GameObjects.Video#_getFrame
         * @type {boolean}
         * @private
         * @since 3.85.0
         */ this._getFrame = false;
                        /**
         * The Callback ID returned by Request Video Frame.
         *
         * @name Phaser.GameObjects.Video#_rfvCallbackId
         * @type {number}
         * @private
         * @since 3.60.0
         */ this._rfvCallbackId = 0;
                        var game = scene.sys.game;
                        /**
         * A reference to Device.Video.
         *
         * @name Phaser.GameObjects.Video#_device
         * @type {string[]}
         * @private
         * @since 3.60.0
         */ this._device = game.device.video;
                        this.setPosition(x, y);
                        this.setSize(256, 256);
                        this.initPipeline();
                        this.initPostPipeline(true);
                        game.events.on(GameEvents.PAUSE, this.globalPause, this);
                        game.events.on(GameEvents.RESUME, this.globalResume, this);
                        var sound = scene.sys.sound;
                        if (sound) sound.on(SoundEvents.GLOBAL_MUTE, this.globalMute, this);
                        if (key) this.load(key);
                    },
                    //  Overrides Game Object method
                    addedToScene: function() {
                        this.scene.sys.updateList.add(this);
                    },
                    //  Overrides Game Object method
                    removedFromScene: function() {
                        this.scene.sys.updateList.remove(this);
                    },
                    /**
     * Loads a Video from the Video Cache, ready for playback with the `Video.play` method.
     *
     * If a video is already playing, this method allows you to change the source of the current video element.
     * It works by first stopping the current video and then starts playback of the new source through the existing video element.
     *
     * The reason you may wish to do this is because videos that require interaction to unlock, remain in an unlocked
     * state, even if you change the source of the video. By changing the source to a new video you avoid having to
     * go through the unlock process again.
     *
     * @method Phaser.GameObjects.Video#load
     * @since 3.60.0
     *
     * @param {string} key - The key of the Video this Game Object will play, as stored in the Video Cache.
     *
     * @return {this} This Video Game Object for method chaining.
     */ load: function(key) {
                        var video = this.scene.sys.cache.video.get(key);
                        if (video) {
                            this.cacheKey = key;
                            this.loadHandler(video.url, video.noAudio, video.crossOrigin);
                        } else console.warn('No video in cache for key: ' + key);
                        return this;
                    },
                    /**
     * This method allows you to change the source of the current video element. It works by first stopping the
     * current video, if playing. Then deleting the video texture, if one has been created. Finally, it makes a
     * new video texture and starts playback of the new source through the existing video element.
     *
     * The reason you may wish to do this is because videos that require interaction to unlock, remain in an unlocked
     * state, even if you change the source of the video. By changing the source to a new video you avoid having to
     * go through the unlock process again.
     *
     * @method Phaser.GameObjects.Video#changeSource
     * @since 3.20.0
     *
     * @param {string} key - The key of the Video this Game Object will swap to playing, as stored in the Video Cache.
     * @param {boolean} [autoplay=true] - Should the video start playing immediately, once the swap is complete?
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     * @param {number} [markerIn] - Optional in marker time, in seconds, for playback of a sequence of the video.
     * @param {number} [markerOut] - Optional out marker time, in seconds, for playback of a sequence of the video.
     *
     * @return {this} This Video Game Object for method chaining.
     */ changeSource: function(key, autoplay, loop, markerIn, markerOut) {
                        if (autoplay === undefined) autoplay = true;
                        if (loop === undefined) loop = false;
                        if (this.cacheKey !== key) {
                            this.load(key);
                            if (autoplay) this.play(loop, markerIn, markerOut);
                        }
                    },
                    /**
     * Returns the key of the currently played video, as stored in the Video Cache.
     *
     * If the video did not come from the cache this will return an empty string.
     *
     * @method Phaser.GameObjects.Video#getVideoKey
     * @since 3.20.0
     *
     * @return {string} The key of the video being played from the Video Cache, if any.
     */ getVideoKey: function() {
                        return this.cacheKey;
                    },
                    /**
     * Loads a Video from the given URL, ready for playback with the `Video.play` method.
     *
     * If a video is already playing, this method allows you to change the source of the current video element.
     * It works by first stopping the current video and then starts playback of the new source through the existing video element.
     *
     * The reason you may wish to do this is because videos that require interaction to unlock, remain in an unlocked
     * state, even if you change the source of the video. By changing the source to a new video you avoid having to
     * go through the unlock process again.
     *
     * @method Phaser.GameObjects.Video#loadURL
     * @since 3.60.0
     *
     * @param {(string|string[]|Phaser.Types.Loader.FileTypes.VideoFileURLConfig|Phaser.Types.Loader.FileTypes.VideoFileURLConfig[])} [urls] - The absolute or relative URL to load the video files from.
     * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
     * @param {string} [crossOrigin] - The value to use for the `crossOrigin` property in the video load request.  Either undefined, `anonymous` or `use-credentials`. If no value is given, `crossorigin` will not be set in the request.
     *
     * @return {this} This Video Game Object for method chaining.
     */ loadURL: function(urls, noAudio, crossOrigin) {
                        if (noAudio === undefined) noAudio = false;
                        var urlConfig = this._device.getVideoURL(urls);
                        if (!urlConfig) console.warn('No supported video format found for ' + urls);
                        else {
                            this.cacheKey = '';
                            this.loadHandler(urlConfig.url, noAudio, crossOrigin);
                        }
                        return this;
                    },
                    /**
     * Loads a Video from the given MediaStream object, ready for playback with the `Video.play` method.
     *
     * @method Phaser.GameObjects.Video#loadMediaStream
     * @since 3.50.0
     *
     * @param {MediaStream} stream - The MediaStream object.
     * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
     * @param {string} [crossOrigin] - The value to use for the `crossOrigin` property in the video load request.  Either undefined, `anonymous` or `use-credentials`. If no value is given, `crossorigin` will not be set in the request.
     *
     * @return {this} This Video Game Object for method chaining.
     */ loadMediaStream: function(stream, noAudio, crossOrigin) {
                        return this.loadHandler(null, noAudio, crossOrigin, stream);
                    },
                    /**
     * Internal method that loads a Video from the given URL, ready for playback with the
     * `Video.play` method.
     *
     * Normally you don't call this method directly, but instead use the `Video.loadURL` method,
     * or the `Video.load` method if you have preloaded the video.
     *
     * Calling this method will skip checking if the browser supports the given format in
     * the URL, where-as the other two methods enforce these checks.
     *
     * @method Phaser.GameObjects.Video#loadHandler
     * @since 3.60.0
     *
     * @param {string} [url] - The absolute or relative URL to load the video file from. Set to `null` if passing in a MediaStream object.
     * @param {boolean} [noAudio] - Does the video have an audio track? If not you can enable auto-playing on it.
     * @param {string} [crossOrigin] - The value to use for the `crossOrigin` property in the video load request.  Either undefined, `anonymous` or `use-credentials`. If no value is given, `crossorigin` will not be set in the request.
     * @param {string} [stream] - A MediaStream object if this is playing a stream instead of a file.
     *
     * @return {this} This Video Game Object for method chaining.
     */ loadHandler: function(url, noAudio, crossOrigin, stream) {
                        if (!noAudio) noAudio = false;
                        var video = this.video;
                        if (video) {
                            //  Re-use the existing video element
                            this.removeLoadEventHandlers();
                            this.stop();
                        } else {
                            video = document.createElement('video');
                            video.controls = false;
                            video.setAttribute('playsinline', 'playsinline');
                            video.setAttribute('preload', 'auto');
                            video.setAttribute('disablePictureInPicture', 'true');
                        }
                        if (noAudio) {
                            video.muted = true;
                            video.defaultMuted = true;
                            video.setAttribute('autoplay', 'autoplay');
                        } else {
                            video.muted = false;
                            video.defaultMuted = false;
                            video.removeAttribute('autoplay');
                        }
                        if (!crossOrigin) video.removeAttribute('crossorigin');
                        else video.setAttribute('crossorigin', crossOrigin);
                        if (stream) {
                            if ('srcObject' in video) try {
                                video.srcObject = stream;
                            } catch (err) {
                                if (err.name !== 'TypeError') throw err;
                                video.src = URL.createObjectURL(stream);
                            }
                            else video.src = URL.createObjectURL(stream);
                        } else video.src = url;
                        this.retry = 0;
                        this.video = video;
                        this._playCalled = false;
                        video.load();
                        this.addLoadEventHandlers();
                        var texture = this.scene.sys.textures.get(this._key);
                        this.setTexture(texture);
                        return this;
                    },
                    /**
     * This method handles the Request Video Frame callback.
     *
     * It is called by the browser when a new video frame is ready to be displayed.
     *
     * It's also responsible for the creation of the video texture, if it doesn't
     * already exist. If it does, it updates the texture as required.
     *
     * For more details about the Request Video Frame callback, see:
     * https://web.dev/requestvideoframecallback-rvfc
     *
     * @method Phaser.GameObjects.Video#requestVideoFrame
     * @fires Phaser.GameObjects.Events#VIDEO_CREATED
     * @fires Phaser.GameObjects.Events#VIDEO_LOOP
     * @fires Phaser.GameObjects.Events#VIDEO_COMPLETE
     * @fires Phaser.GameObjects.Events#VIDEO_PLAY
     * @fires Phaser.GameObjects.Events#VIDEO_TEXTURE
     * @since 3.60.0
     *
     * @param {DOMHighResTimeStamp} now - The current time in milliseconds.
     * @param {VideoFrameCallbackMetadata} metadata - Useful metadata about the video frame that was most recently presented for composition. See https://wicg.github.io/video-rvfc/#video-frame-metadata-callback
     */ requestVideoFrame: function(now, metadata) {
                        var video = this.video;
                        if (!video) return;
                        var width = metadata.width;
                        var height = metadata.height;
                        var texture = this.videoTexture;
                        var textureSource = this.videoTextureSource;
                        var newVideo = !texture || textureSource.source !== video;
                        if (newVideo) {
                            //  First frame of a new video
                            this._codePaused = video.paused;
                            this._codeMuted = video.muted;
                            if (!texture) {
                                texture = this.scene.sys.textures.create(this._key, video, width, height);
                                texture.add('__BASE', 0, 0, 0, width, height);
                                this.setTexture(texture);
                                this.videoTexture = texture;
                                this.videoTextureSource = texture.source[0];
                                this.videoTextureSource.setFlipY(this.flipY);
                                this.emit(Events.VIDEO_TEXTURE, this, texture);
                            } else {
                                //  Re-use the existing texture
                                textureSource.source = video;
                                textureSource.width = width;
                                textureSource.height = height;
                                //  Resize base frame
                                texture.get().setSize(width, height);
                            }
                            this.setSizeToFrame();
                            this.updateDisplayOrigin();
                        } else textureSource.update();
                        this.isStalled = false;
                        this.metadata = metadata;
                        var currentTime = metadata.mediaTime;
                        if (newVideo) {
                            this._lastUpdate = currentTime;
                            this.emit(Events.VIDEO_CREATED, this, width, height);
                            if (!this.frameReady) {
                                this.frameReady = true;
                                this.emit(Events.VIDEO_PLAY, this);
                            }
                        }
                        if (this._playingMarker) {
                            if (currentTime >= this._markerOut) {
                                if (video.loop) {
                                    video.currentTime = this._markerIn;
                                    this.emit(Events.VIDEO_LOOP, this);
                                } else {
                                    this.stop(false);
                                    this.emit(Events.VIDEO_COMPLETE, this);
                                }
                            }
                        } else if (currentTime < this._lastUpdate) this.emit(Events.VIDEO_LOOP, this);
                        this._lastUpdate = currentTime;
                        if (this._getFrame) {
                            this.removeEventHandlers();
                            video.pause();
                            this._getFrame = false;
                        } else this._rfvCallbackId = this.video.requestVideoFrameCallback(this.requestVideoFrame.bind(this));
                    },
                    /**
     * Starts this video playing.
     *
     * If the video is already playing, or has been queued to play with `changeSource` then this method just returns.
     *
     * Videos can only autoplay if the browser has been unlocked. This happens if you have interacted with the browser, i.e.
     * by clicking on it or pressing a key, or due to server settings. The policies that control autoplaying are vast and
     * vary between browser. You can read more here: https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
     *
     * If your video doesn't contain any audio, then set the `noAudio` parameter to `true` when the video is loaded,
     * and it will often allow the video to play immediately:
     *
     * ```javascript
     * preload () {
     *   this.load.video('pixar', 'nemo.mp4', true);
     * }
     * ```
     *
     * The 3rd parameter in the load call tells Phaser that the video doesn't contain any audio tracks. Video without
     * audio can autoplay without requiring a user interaction. Video with audio cannot do this unless it satisfies
     * the browsers MEI settings. See the MDN Autoplay Guide for details.
     *
     * If you need audio in your videos, then you'll have to consider the fact that the video cannot start playing until the
     * user has interacted with the browser, into your game flow.
     *
     * @method Phaser.GameObjects.Video#play
     * @since 3.20.0
     *
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     * @param {number} [markerIn] - Optional in marker time, in seconds, for playback of a sequence of the video.
     * @param {number} [markerOut] - Optional out marker time, in seconds, for playback of a sequence of the video.
     *
     * @return {this} This Video Game Object for method chaining.
     */ play: function(loop, markerIn, markerOut) {
                        if (markerIn === undefined) markerIn = -1;
                        if (markerOut === undefined) markerOut = MATH_CONST.MAX_SAFE_INTEGER;
                        var video = this.video;
                        if (!video || this.isPlaying()) {
                            if (!video) console.warn('Video not loaded');
                            return this;
                        }
                        //  We can reset these each time play is called, even if the video hasn't started yet
                        if (loop === undefined) loop = video.loop;
                        video.loop = loop;
                        this._markerIn = markerIn;
                        this._markerOut = markerOut;
                        this._playingMarker = markerIn > -1 && markerOut > markerIn && markerOut < MATH_CONST.MAX_SAFE_INTEGER;
                        //  But we go no further if play has already been called
                        if (!this._playCalled) {
                            this._getFrame = false;
                            this._rfvCallbackId = video.requestVideoFrameCallback(this.requestVideoFrame.bind(this));
                            this._playCalled = true;
                            this.createPlayPromise();
                        }
                        return this;
                    },
                    /**
     * Attempts to get the first frame of the video by running the `requestVideoFrame` callback once,
     * then stopping. This is useful if you need to grab the first frame of the video to display behind
     * a 'play' button, without actually calling the 'play' method.
     *
     * If the video is already playing, or has been queued to play with `changeSource` then this method just returns.
     *
     * @method Phaser.GameObjects.Video#getFirstFrame
     * @since 3.85.0
     *
     * @return {this} This Video Game Object for method chaining.
     */ getFirstFrame: function() {
                        var video = this.video;
                        if (!video || this.isPlaying()) {
                            if (!video) console.warn('Video not loaded');
                            return this;
                        }
                        if (!this._playCalled) {
                            this._getFrame = true;
                            this._rfvCallbackId = video.requestVideoFrameCallback(this.requestVideoFrame.bind(this));
                            this.createPlayPromise();
                        }
                        return this;
                    },
                    /**
     * Adds the loading specific event handlers to the video element.
     *
     * @method Phaser.GameObjects.Video#addLoadEventHandlers
     * @since 3.60.0
     */ addLoadEventHandlers: function() {
                        var video = this.video;
                        if (video) {
                            video.addEventListener('error', this._loadCallbackHandler);
                            video.addEventListener('abort', this._loadCallbackHandler);
                            video.addEventListener('loadedmetadata', this._metadataCallbackHandler);
                        }
                    },
                    /**
     * Removes the loading specific event handlers from the video element.
     *
     * @method Phaser.GameObjects.Video#removeLoadEventHandlers
     * @since 3.60.0
     */ removeLoadEventHandlers: function() {
                        var video = this.video;
                        if (video) {
                            video.removeEventListener('error', this._loadCallbackHandler);
                            video.removeEventListener('abort', this._loadCallbackHandler);
                        }
                    },
                    /**
     * Adds the playback specific event handlers to the video element.
     *
     * @method Phaser.GameObjects.Video#addEventHandlers
     * @since 3.60.0
     */ addEventHandlers: function() {
                        var video = this.video;
                        //  Set these _after_ calling `video.play` or they don't fire
                        //  (really useful, thanks browsers!)
                        if (video) {
                            var callbacks = this._callbacks;
                            for(var callback in callbacks)video.addEventListener(callback, callbacks[callback]);
                        }
                    },
                    /**
     * Removes the playback specific event handlers from the video element.
     *
     * @method Phaser.GameObjects.Video#removeEventHandlers
     * @since 3.60.0
     */ removeEventHandlers: function() {
                        var video = this.video;
                        if (video) {
                            var callbacks = this._callbacks;
                            for(var callback in callbacks)video.removeEventListener(callback, callbacks[callback]);
                        }
                    },
                    /**
     * Creates the video.play promise and adds the success and error handlers to it.
     *
     * Not all browsers support the video.play promise, so this method will fall back to
     * the old-school way of handling the video.play call.
     *
     * See https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play#browser_compatibility for details.
     *
     * @method Phaser.GameObjects.Video#createPlayPromise
     * @since 3.60.0
     *
     * @param {boolean} [catchError=true] - Should the error be caught and the video marked as failed to play?
     */ createPlayPromise: function(catchError) {
                        if (catchError === undefined) catchError = true;
                        var video = this.video;
                        var playPromise = video.play();
                        if (playPromise !== undefined) {
                            var success = this.playSuccess.bind(this);
                            var error = this.playError.bind(this);
                            if (!catchError) {
                                var _this = this;
                                error = function() {
                                    _this.failedPlayAttempts++;
                                };
                            }
                            playPromise.then(success).catch(error);
                        } else {
                            //  Old-school fallback here for pre-2019 browsers
                            video.addEventListener('playing', this._callbacks.legacy);
                            if (!catchError) this.failedPlayAttempts++;
                        }
                    },
                    /**
     * Adds a sequence marker to this video.
     *
     * Markers allow you to split a video up into sequences, delineated by a start and end time, given in seconds.
     *
     * You can then play back specific markers via the `playMarker` method.
     *
     * Note that marker timing is _not_ frame-perfect. You should construct your videos in such a way that you allow for
     * plenty of extra padding before and after each sequence to allow for discrepancies in browser seek and currentTime accuracy.
     *
     * See https://github.com/w3c/media-and-entertainment/issues/4 for more details about this issue.
     *
     * @method Phaser.GameObjects.Video#addMarker
     * @since 3.20.0
     *
     * @param {string} key - A unique name to give this marker.
     * @param {number} markerIn - The time, in seconds, representing the start of this marker.
     * @param {number} markerOut - The time, in seconds, representing the end of this marker.
     *
     * @return {this} This Video Game Object for method chaining.
     */ addMarker: function(key, markerIn, markerOut) {
                        if (!isNaN(markerIn) && markerIn >= 0 && !isNaN(markerOut) && markerOut > markerIn) this.markers[key] = [
                            markerIn,
                            markerOut
                        ];
                        return this;
                    },
                    /**
     * Plays a pre-defined sequence in this video.
     *
     * Markers allow you to split a video up into sequences, delineated by a start and end time, given in seconds and
     * specified via the `addMarker` method.
     *
     * Note that marker timing is _not_ frame-perfect. You should construct your videos in such a way that you allow for
     * plenty of extra padding before and after each sequence to allow for discrepancies in browser seek and currentTime accuracy.
     *
     * See https://github.com/w3c/media-and-entertainment/issues/4 for more details about this issue.
     *
     * @method Phaser.GameObjects.Video#playMarker
     * @since 3.20.0
     *
     * @param {string} key - The name of the marker sequence to play.
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     *
     * @return {this} This Video Game Object for method chaining.
     */ playMarker: function(key, loop) {
                        var marker = this.markers[key];
                        if (marker) this.play(loop, marker[0], marker[1]);
                        return this;
                    },
                    /**
     * Removes a previously set marker from this video.
     *
     * If the marker is currently playing it will _not_ stop playback.
     *
     * @method Phaser.GameObjects.Video#removeMarker
     * @since 3.20.0
     *
     * @param {string} key - The name of the marker to remove.
     *
     * @return {this} This Video Game Object for method chaining.
     */ removeMarker: function(key) {
                        delete this.markers[key];
                        return this;
                    },
                    /**
     * Takes a snapshot of the current frame of the video and renders it to a CanvasTexture object,
     * which is then returned. You can optionally resize the grab by passing a width and height.
     *
     * This method returns a reference to the `Video.snapshotTexture` object. Calling this method
     * multiple times will overwrite the previous snapshot with the most recent one.
     *
     * @method Phaser.GameObjects.Video#snapshot
     * @since 3.20.0
     *
     * @param {number} [width] - The width of the resulting CanvasTexture.
     * @param {number} [height] - The height of the resulting CanvasTexture.
     *
     * @return {Phaser.Textures.CanvasTexture}
     */ snapshot: function(width, height) {
                        if (width === undefined) width = this.width;
                        if (height === undefined) height = this.height;
                        return this.snapshotArea(0, 0, this.width, this.height, width, height);
                    },
                    /**
     * Takes a snapshot of the specified area of the current frame of the video and renders it to a CanvasTexture object,
     * which is then returned. You can optionally resize the grab by passing a different `destWidth` and `destHeight`.
     *
     * This method returns a reference to the `Video.snapshotTexture` object. Calling this method
     * multiple times will overwrite the previous snapshot with the most recent one.
     *
     * @method Phaser.GameObjects.Video#snapshotArea
     * @since 3.20.0
     *
     * @param {number} [x=0] - The horizontal location of the top-left of the area to grab from.
     * @param {number} [y=0] - The vertical location of the top-left of the area to grab from.
     * @param {number} [srcWidth] - The width of area to grab from the video. If not given it will grab the full video dimensions.
     * @param {number} [srcHeight] - The height of area to grab from the video. If not given it will grab the full video dimensions.
     * @param {number} [destWidth] - The destination width of the grab, allowing you to resize it.
     * @param {number} [destHeight] - The destination height of the grab, allowing you to resize it.
     *
     * @return {Phaser.Textures.CanvasTexture}
     */ snapshotArea: function(x, y, srcWidth, srcHeight, destWidth, destHeight) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (srcWidth === undefined) srcWidth = this.width;
                        if (srcHeight === undefined) srcHeight = this.height;
                        if (destWidth === undefined) destWidth = srcWidth;
                        if (destHeight === undefined) destHeight = srcHeight;
                        var video = this.video;
                        var snap = this.snapshotTexture;
                        if (!snap) {
                            snap = this.scene.sys.textures.createCanvas(UUID(), destWidth, destHeight);
                            this.snapshotTexture = snap;
                            if (video) snap.context.drawImage(video, x, y, srcWidth, srcHeight, 0, 0, destWidth, destHeight);
                        } else {
                            snap.setSize(destWidth, destHeight);
                            if (video) snap.context.drawImage(video, x, y, srcWidth, srcHeight, 0, 0, destWidth, destHeight);
                        }
                        return snap.update();
                    },
                    /**
     * Stores a copy of this Videos `snapshotTexture` in the Texture Manager using the given key.
     *
     * This texture is created when the `snapshot` or `snapshotArea` methods are called.
     *
     * After doing this, any texture based Game Object, such as a Sprite, can use the contents of the
     * snapshot by using the texture key:
     *
     * ```javascript
     * var vid = this.add.video(0, 0, 'intro');
     *
     * vid.snapshot();
     *
     * vid.saveSnapshotTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Updating the contents of the `snapshotTexture`, for example by calling `snapshot` again,
     * will automatically update _any_ Game Object that is using it as a texture.
     * Calling `saveSnapshotTexture` again will not save another copy of the same texture,
     * it will just rename the existing one.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame.
     *
     * @method Phaser.GameObjects.Video#saveSnapshotTexture
     * @since 3.20.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     *
     * @return {Phaser.Textures.CanvasTexture} The Texture that was saved.
     */ saveSnapshotTexture: function(key) {
                        if (this.snapshotTexture) this.scene.sys.textures.renameTexture(this.snapshotTexture.key, key);
                        else this.snapshotTexture = this.scene.sys.textures.createCanvas(key, this.width, this.height);
                        return this.snapshotTexture;
                    },
                    /**
     * This internal method is called automatically if the playback Promise resolves successfully.
     *
     * @method Phaser.GameObjects.Video#playSuccess
     * @fires Phaser.GameObjects.Events#VIDEO_UNLOCKED
     * @since 3.60.0
     */ playSuccess: function() {
                        if (!this._playCalled) //  The stop method has been called but the Promise has resolved
                        //  after this, so we need to just abort.
                        return;
                        this.addEventHandlers();
                        this._codePaused = false;
                        if (this.touchLocked) {
                            this.touchLocked = false;
                            this.emit(Events.VIDEO_UNLOCKED, this);
                        }
                        var sound = this.scene.sys.sound;
                        if (sound && sound.mute) //  Mute will be set based on the global mute state of the Sound Manager (if there is one)
                        this.setMute(true);
                        if (this._markerIn > -1) this.video.currentTime = this._markerIn;
                    },
                    /**
     * This internal method is called automatically if the playback Promise fails to resolve.
     *
     * @method Phaser.GameObjects.Video#playError
     * @fires Phaser.GameObjects.Events#VIDEO_ERROR
     * @fires Phaser.GameObjects.Events#VIDEO_UNSUPPORTED
     * @fires Phaser.GameObjects.Events#VIDEO_LOCKED
     * @since 3.60.0
     *
     * @param {DOMException} error - The Promise DOM Exception error.
     */ playError: function(error) {
                        var name = error.name;
                        if (name === 'NotAllowedError') {
                            this.touchLocked = true;
                            this.playWhenUnlocked = true;
                            this.failedPlayAttempts = 1;
                            this.emit(Events.VIDEO_LOCKED, this);
                        } else if (name === 'NotSupportedError') {
                            this.stop(false);
                            this.emit(Events.VIDEO_UNSUPPORTED, this, error);
                        } else {
                            this.stop(false);
                            this.emit(Events.VIDEO_ERROR, this, error);
                        }
                    },
                    /**
     * Called when the video emits a `playing` event.
     *
     * This is the legacy handler for browsers that don't support Promise based playback.
     *
     * @method Phaser.GameObjects.Video#legacyPlayHandler
     * @since 3.60.0
     */ legacyPlayHandler: function() {
                        var video = this.video;
                        if (video) {
                            this.playSuccess();
                            video.removeEventListener('playing', this._callbacks.legacy);
                        }
                    },
                    /**
     * Called when the video emits a `playing` event.
     *
     * @method Phaser.GameObjects.Video#playingHandler
     * @fires Phaser.GameObjects.Events#VIDEO_PLAYING
     * @since 3.60.0
     */ playingHandler: function() {
                        this.isStalled = false;
                        this.emit(Events.VIDEO_PLAYING, this);
                    },
                    /**
     * This internal method is called automatically if the video fails to load.
     *
     * @method Phaser.GameObjects.Video#loadErrorHandler
     * @fires Phaser.GameObjects.Events#VIDEO_ERROR
     * @since 3.20.0
     *
     * @param {Event} event - The error Event.
     */ loadErrorHandler: function(event) {
                        this.stop(false);
                        this.emit(Events.VIDEO_ERROR, this, event);
                    },
                    /**
     * This internal method is called automatically when the video metadata is available.
     *
     * @method Phaser.GameObjects.Video#metadataHandler
     * @fires Phaser.GameObjects.Events#VIDEO_METADATA
     * @since 3.80.0
     *
     * @param {Event} event - The loadedmetadata Event.
     */ metadataHandler: function(event) {
                        this.emit(Events.VIDEO_METADATA, this, event);
                    },
                    /**
     * Sets the size of this Game Object to be that of the given Frame.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Video#setSizeToFrame
     * @since 3.0.0
     *
     * @param {Phaser.Textures.Frame|boolean} [frame] - The frame to base the size of this Game Object on.
     *
     * @return {this} This Game Object instance.
     */ setSizeToFrame: function(frame) {
                        if (!frame) frame = this.frame;
                        this.width = frame.realWidth;
                        this.height = frame.realHeight;
                        if (this.scaleX !== 1) this.scaleX = this.displayWidth / this.width;
                        if (this.scaleY !== 1) this.scaleY = this.displayHeight / this.height;
                        var input = this.input;
                        if (input && !input.customHitArea) {
                            input.hitArea.width = this.width;
                            input.hitArea.height = this.height;
                        }
                        return this;
                    },
                    /**
     * This internal method is called automatically if the video stalls, for whatever reason.
     *
     * @method Phaser.GameObjects.Video#stalledHandler
     * @fires Phaser.GameObjects.Events#VIDEO_STALLED
     * @since 3.60.0
     *
     * @param {Event} event - The error Event.
     */ stalledHandler: function(event) {
                        this.isStalled = true;
                        this.emit(Events.VIDEO_STALLED, this, event);
                    },
                    /**
     * Called when the video completes playback, i.e. reaches an `ended` state.
     *
     * This will never happen if the video is coming from a live stream, where the duration is `Infinity`.
     *
     * @method Phaser.GameObjects.Video#completeHandler
     * @fires Phaser.GameObjects.Events#VIDEO_COMPLETE
     * @since 3.20.0
     */ completeHandler: function() {
                        this._playCalled = false;
                        this.emit(Events.VIDEO_COMPLETE, this);
                    },
                    /**
     * The internal update step.
     *
     * @method Phaser.GameObjects.Video#preUpdate
     * @private
     * @since 3.20.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time in ms since the last frame.
     */ preUpdate: function(time, delta) {
                        var video = this.video;
                        if (!video || !this._playCalled) return;
                        if (this.touchLocked && this.playWhenUnlocked) {
                            this.retry += delta;
                            if (this.retry >= this.retryInterval) {
                                this.createPlayPromise(false);
                                this.retry = 0;
                            }
                        }
                    },
                    /**
     * Seeks to a given point in the video. The value is given as a float between 0 and 1,
     * where 0 represents the start of the video and 1 represents the end.
     *
     * Seeking only works if the video has a duration, so will not work for live streams.
     *
     * When seeking begins, this video will emit a `seeking` event. When the video completes
     * seeking (i.e. reaches its designated timestamp) it will emit a `seeked` event.
     *
     * If you wish to seek based on time instead, use the `Video.setCurrentTime` method.
     *
     * Unfortunately, the DOM video element does not guarantee frame-accurate seeking.
     * This has been an ongoing subject of discussion: https://github.com/w3c/media-and-entertainment/issues/4
     *
     * @method Phaser.GameObjects.Video#seekTo
     * @since 3.20.0
     *
     * @param {number} value - The point in the video to seek to. A value between 0 and 1.
     *
     * @return {this} This Video Game Object for method chaining.
     */ seekTo: function(value) {
                        var video = this.video;
                        if (video) {
                            var duration = video.duration;
                            if (duration !== Infinity && !isNaN(duration)) {
                                var seekTime = duration * value;
                                this.setCurrentTime(seekTime);
                            }
                        }
                        return this;
                    },
                    /**
     * A double-precision floating-point value indicating the current playback time in seconds.
     *
     * If the media has not started to play and has not been seeked, this value is the media's initial playback time.
     *
     * For a more accurate value, use the `Video.metadata.mediaTime` property instead.
     *
     * @method Phaser.GameObjects.Video#getCurrentTime
     * @since 3.20.0
     *
     * @return {number} A double-precision floating-point value indicating the current playback time in seconds.
     */ getCurrentTime: function() {
                        return this.video ? this.video.currentTime : 0;
                    },
                    /**
     * Seeks to a given playback time in the video. The value is given in _seconds_ or as a string.
     *
     * Seeking only works if the video has a duration, so will not work for live streams.
     *
     * When seeking begins, this video will emit a `seeking` event. When the video completes
     * seeking (i.e. reaches its designated timestamp) it will emit a `seeked` event.
     *
     * You can provide a string prefixed with either a `+` or a `-`, such as `+2.5` or `-2.5`.
     * In this case it will seek to +/- the value given, relative to the _current time_.
     *
     * If you wish to seek based on a duration percentage instead, use the `Video.seekTo` method.
     *
     * @method Phaser.GameObjects.Video#setCurrentTime
     * @since 3.20.0
     *
     * @param {(string|number)} value - The playback time to seek to in seconds. Can be expressed as a string, such as `+2` to seek 2 seconds ahead from the current time.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setCurrentTime: function(value) {
                        var video = this.video;
                        if (video) {
                            if (typeof value === 'string') {
                                var op = value[0];
                                var num = parseFloat(value.substr(1));
                                if (op === '+') value = video.currentTime + num;
                                else if (op === '-') value = video.currentTime - num;
                            }
                            video.currentTime = value;
                        }
                        return this;
                    },
                    /**
     * Internal seeking handler.
     *
     * @method Phaser.GameObjects.Video#seekingHandler
     * @fires Phaser.GameObjects.Events#VIDEO_SEEKING
     * @private
     * @since 3.20.0
     */ seekingHandler: function() {
                        this.isSeeking = true;
                        this.emit(Events.VIDEO_SEEKING, this);
                    },
                    /**
     * Internal seeked handler.
     *
     * @method Phaser.GameObjects.Video#seekedHandler
     * @fires Phaser.GameObjects.Events#VIDEO_SEEKED
     * @private
     * @since 3.20.0
     */ seekedHandler: function() {
                        this.isSeeking = false;
                        this.emit(Events.VIDEO_SEEKED, this);
                    },
                    /**
     * Returns the current progress of the video as a float.
     *
     * Progress is defined as a value between 0 (the start) and 1 (the end).
     *
     * Progress can only be returned if the video has a duration. Some videos,
     * such as those coming from a live stream, do not have a duration. In this
     * case the method will return -1.
     *
     * @method Phaser.GameObjects.Video#getProgress
     * @since 3.20.0
     *
     * @return {number} The current progress of playback. If the video has no duration, will always return -1.
     */ getProgress: function() {
                        var video = this.video;
                        if (video) {
                            var duration = video.duration;
                            if (duration !== Infinity && !isNaN(duration)) return video.currentTime / duration;
                        }
                        return -1;
                    },
                    /**
     * A double-precision floating-point value which indicates the duration (total length) of the media in seconds,
     * on the media's timeline. If no media is present on the element, or the media is not valid, the returned value is NaN.
     *
     * If the media has no known end (such as for live streams of unknown duration, web radio, media incoming from WebRTC,
     * and so forth), this value is +Infinity.
     *
     * If no video has been loaded, this method will return 0.
     *
     * @method Phaser.GameObjects.Video#getDuration
     * @since 3.20.0
     *
     * @return {number} A double-precision floating-point value indicating the duration of the media in seconds.
     */ getDuration: function() {
                        return this.video ? this.video.duration : 0;
                    },
                    /**
     * Sets the muted state of the currently playing video, if one is loaded.
     *
     * @method Phaser.GameObjects.Video#setMute
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - The mute value. `true` if the video should be muted, otherwise `false`.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setMute: function(value) {
                        if (value === undefined) value = true;
                        this._codeMuted = value;
                        var video = this.video;
                        if (video) video.muted = this._systemMuted ? true : value;
                        return this;
                    },
                    /**
     * Returns a boolean indicating if this Video is currently muted.
     *
     * @method Phaser.GameObjects.Video#isMuted
     * @since 3.20.0
     *
     * @return {boolean} A boolean indicating if this Video is currently muted, or not.
     */ isMuted: function() {
                        return this._codeMuted;
                    },
                    /**
     * Internal global mute handler. Will mute the video, if playing, if the global sound system mutes.
     *
     * @method Phaser.GameObjects.Video#globalMute
     * @private
     * @since 3.20.0
     *
     * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the Sound Manager that emitted the event.
     * @param {boolean} mute - The mute value. `true` if the Sound Manager is now muted, otherwise `false`.
     */ globalMute: function(soundManager, value) {
                        this._systemMuted = value;
                        var video = this.video;
                        if (video) video.muted = this._codeMuted ? true : value;
                    },
                    /**
     * Internal global pause handler. Will pause the video if the Game itself pauses.
     *
     * @method Phaser.GameObjects.Video#globalPause
     * @private
     * @since 3.20.0
     */ globalPause: function() {
                        this._systemPaused = true;
                        if (this.video && !this.video.ended) {
                            this.removeEventHandlers();
                            this.video.pause();
                        }
                    },
                    /**
     * Internal global resume handler. Will resume a paused video if the Game itself resumes.
     *
     * @method Phaser.GameObjects.Video#globalResume
     * @private
     * @since 3.20.0
     */ globalResume: function() {
                        this._systemPaused = false;
                        if (this.video && !this._codePaused && !this.video.ended) this.createPlayPromise();
                    },
                    /**
     * Sets the paused state of the currently loaded video.
     *
     * If the video is playing, calling this method with `true` will pause playback.
     * If the video is paused, calling this method with `false` will resume playback.
     *
     * If no video is loaded, this method does nothing.
     *
     * If the video has not yet been played, `Video.play` will be called with no parameters.
     *
     * If the video has ended, this method will do nothing.
     *
     * @method Phaser.GameObjects.Video#setPaused
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - The paused value. `true` if the video should be paused, `false` to resume it.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setPaused: function(value) {
                        if (value === undefined) value = true;
                        var video = this.video;
                        this._codePaused = value;
                        if (video && !video.ended) {
                            if (value) {
                                if (!video.paused) {
                                    this.removeEventHandlers();
                                    video.pause();
                                }
                            } else if (!value) {
                                if (!this._playCalled) this.play();
                                else if (video.paused && !this._systemPaused) this.createPlayPromise();
                            }
                        }
                        return this;
                    },
                    /**
     * Pauses the current Video, if one is playing.
     *
     * If no video is loaded, this method does nothing.
     *
     * Call `Video.resume` to resume playback.
     *
     * @method Phaser.GameObjects.Video#pause
     * @since 3.60.0
     *
     * @return {this} This Video Game Object for method chaining.
     */ pause: function() {
                        return this.setPaused(true);
                    },
                    /**
     * Resumes the current Video, if one was previously playing and has been paused.
     *
     * If no video is loaded, this method does nothing.
     *
     * Call `Video.pause` to pause playback.
     *
     * @method Phaser.GameObjects.Video#resume
     * @since 3.60.0
     *
     * @return {this} This Video Game Object for method chaining.
     */ resume: function() {
                        return this.setPaused(false);
                    },
                    /**
     * Returns a double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @method Phaser.GameObjects.Video#getVolume
     * @since 3.20.0
     *
     * @return {number} A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     */ getVolume: function() {
                        return this.video ? this.video.volume : 1;
                    },
                    /**
     * Sets the volume of the currently playing video.
     *
     * The value given is a double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @method Phaser.GameObjects.Video#setVolume
     * @since 3.20.0
     *
     * @param {number} [value=1] - A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @return {this} This Video Game Object for method chaining.
     */ setVolume: function(value) {
                        if (value === undefined) value = 1;
                        if (this.video) this.video.volume = Clamp(value, 0, 1);
                        return this;
                    },
                    /**
     * Returns a double that indicates the rate at which the media is being played back.
     *
     * @method Phaser.GameObjects.Video#getPlaybackRate
     * @since 3.20.0
     *
     * @return {number} A double that indicates the rate at which the media is being played back.
     */ getPlaybackRate: function() {
                        return this.video ? this.video.playbackRate : 1;
                    },
                    /**
     * Sets the playback rate of the current video.
     *
     * The value given is a double that indicates the rate at which the media is being played back.
     *
     * @method Phaser.GameObjects.Video#setPlaybackRate
     * @since 3.20.0
     *
     * @param {number} [rate] - A double that indicates the rate at which the media is being played back.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setPlaybackRate: function(rate) {
                        if (this.video) this.video.playbackRate = rate;
                        return this;
                    },
                    /**
     * Returns a boolean which indicates whether the media element should start over when it reaches the end.
     *
     * @method Phaser.GameObjects.Video#getLoop
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the media element will start over when it reaches the end.
     */ getLoop: function() {
                        return this.video ? this.video.loop : false;
                    },
                    /**
     * Sets the loop state of the current video.
     *
     * The value given is a boolean which indicates whether the media element will start over when it reaches the end.
     *
     * Not all videos can loop, for example live streams.
     *
     * Please note that not all browsers support _seamless_ video looping for all encoding formats.
     *
     * @method Phaser.GameObjects.Video#setLoop
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - A boolean which indicates whether the media element will start over when it reaches the end.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setLoop: function(value) {
                        if (value === undefined) value = true;
                        if (this.video) this.video.loop = value;
                        return this;
                    },
                    /**
     * Returns a boolean which indicates whether the video is currently playing.
     *
     * @method Phaser.GameObjects.Video#isPlaying
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the video is playing, or not.
     */ isPlaying: function() {
                        return this.video ? !(this.video.paused || this.video.ended) : false;
                    },
                    /**
     * Returns a boolean which indicates whether the video is currently paused.
     *
     * @method Phaser.GameObjects.Video#isPaused
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the video is paused, or not.
     */ isPaused: function() {
                        return this.video && this._playCalled && this.video.paused || this._codePaused || this._systemPaused;
                    },
                    /**
     * Stores this Video in the Texture Manager using the given key as a dynamic texture,
     * which any texture-based Game Object, such as a Sprite, can use as its source:
     *
     * ```javascript
     * const vid = this.add.video(0, 0, 'intro');
     *
     * vid.play();
     *
     * vid.saveTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * If the video is not yet playing then you need to listen for the `TEXTURE_READY` event before
     * you can use this texture on a Game Object:
     *
     * ```javascript
     * const vid = this.add.video(0, 0, 'intro');
     *
     * vid.play();
     *
     * vid.once('textureready', (video, texture, key) => {
     *
     *     this.add.image(400, 300, key);
     *
     * });
     *
     * vid.saveTexture('doodle');
     * ```
     *
     * The saved texture is automatically updated as the video plays. If you pause this video,
     * or change its source, then the saved texture updates instantly.
     *
     * Calling `saveTexture` again will not save another copy of the same texture, it will just rename the existing one.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame.
     *
     * If you intend to save the texture so you can use it as the input for a Shader, you may need to set the
     * `flipY` parameter to `true` if you find the video renders upside down in your shader.
     *
     * @method Phaser.GameObjects.Video#saveTexture
     * @since 3.20.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y` during upload?
     *
     * @return {boolean} Returns `true` if the texture is available immediately, otherwise returns `false` and you should listen for the `TEXTURE_READY` event.
     */ saveTexture: function(key, flipY) {
                        if (flipY === undefined) flipY = false;
                        if (this.videoTexture) {
                            this.scene.sys.textures.renameTexture(this._key, key);
                            this.videoTextureSource.setFlipY(flipY);
                        }
                        this._key = key;
                        this.flipY = flipY;
                        return this.videoTexture ? true : false;
                    },
                    /**
     * Stops the video playing and clears all internal event listeners.
     *
     * If you only wish to pause playback of the video, and resume it a later time, use the `Video.pause` method instead.
     *
     * If the video hasn't finished downloading, calling this method will not abort the download. To do that you need to
     * call `destroy` instead.
     *
     * @method Phaser.GameObjects.Video#stop
     * @fires Phaser.GameObjects.Events#VIDEO_STOP
     * @since 3.20.0
     *
     * @param {boolean} [emitStopEvent=true] - Should the `VIDEO_STOP` event be emitted?
     *
     * @return {this} This Video Game Object for method chaining.
     */ stop: function(emitStopEvent) {
                        if (emitStopEvent === undefined) emitStopEvent = true;
                        var video = this.video;
                        if (video) {
                            this.removeEventHandlers();
                            video.cancelVideoFrameCallback(this._rfvCallbackId);
                            video.pause();
                        }
                        this.retry = 0;
                        this._playCalled = false;
                        if (emitStopEvent) this.emit(Events.VIDEO_STOP, this);
                        return this;
                    },
                    /**
     * Removes the Video element from the DOM by calling parentNode.removeChild on itself.
     *
     * Also removes the autoplay and src attributes and nulls the `Video.video` reference.
     *
     * If you loaded an external video via `Video.loadURL` then you should call this function
     * to clear up once you are done with the instance, but don't want to destroy this
     * Video Game Object.
     *
     * This method is called automatically by `Video.destroy`.
     *
     * @method Phaser.GameObjects.Video#removeVideoElement
     * @since 3.20.0
     */ removeVideoElement: function() {
                        var video = this.video;
                        if (!video) return;
                        if (video.parentNode) video.parentNode.removeChild(video);
                        while(video.hasChildNodes())video.removeChild(video.firstChild);
                        video.removeAttribute('autoplay');
                        video.removeAttribute('src');
                        this.video = null;
                    },
                    /**
     * Handles the pre-destroy step for the Video object.
     *
     * This calls `Video.stop` and optionally `Video.removeVideoElement`.
     *
     * If any Sprites are using this Video as their texture it is up to you to manage those.
     *
     * @method Phaser.GameObjects.Video#preDestroy
     * @private
     * @since 3.21.0
     */ preDestroy: function() {
                        this.stop(false);
                        this.removeLoadEventHandlers();
                        this.removeVideoElement();
                        var game = this.scene.sys.game.events;
                        game.off(GameEvents.PAUSE, this.globalPause, this);
                        game.off(GameEvents.RESUME, this.globalResume, this);
                        var sound = this.scene.sys.sound;
                        if (sound) sound.off(SoundEvents.GLOBAL_MUTE, this.globalMute, this);
                    }
                });
                module1.exports = Video;
            /***/ },
            /***/ 58352: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Video#renderCanvas
 * @since 3.20.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Video} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var VideoCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    if (src.videoTexture) {
                        camera.addToRenderList(src);
                        renderer.batchSprite(src, src.frame, camera, parentMatrix);
                    }
                };
                module1.exports = VideoCanvasRenderer;
            /***/ },
            /***/ 11511: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(25305);
                var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var Video = __webpack_require__(18471);
                /**
 * Creates a new Video Game Object and returns it.
 *
 * Note: This method will only be available if the Video Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#video
 * @since 3.20.0
 *
 * @param {Phaser.Types.GameObjects.Video.VideoConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Video} The Game Object that was created.
 */ GameObjectCreator.register('video', function(config, addToScene) {
                    if (config === undefined) config = {};
                    var key = GetAdvancedValue(config, 'key', null);
                    var video = new Video(this.scene, 0, 0, key);
                    if (addToScene !== undefined) config.add = addToScene;
                    BuildGameObject(this.scene, video, config);
                    return video;
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 89025: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Video = __webpack_require__(18471);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Video Game Object and adds it to the Scene.
 *
 * This Game Object is capable of handling playback of a video file, video stream or media stream.
 *
 * You can optionally 'preload' the video into the Phaser Video Cache:
 *
 * ```javascript
 * preload () {
 *   this.load.video('ripley', 'assets/aliens.mp4');
 * }
 *
 * create () {
 *   this.add.video(400, 300, 'ripley');
 * }
 * ```
 *
 * You don't have to 'preload' the video. You can also play it directly from a URL:
 *
 * ```javascript
 * create () {
 *   this.add.video(400, 300).loadURL('assets/aliens.mp4');
 * }
 * ```
 *
 * To all intents and purposes, a video is a standard Game Object, just like a Sprite. And as such, you can do
 * all the usual things to it, such as scaling, rotating, cropping, tinting, making interactive, giving a
 * physics body, etc.
 *
 * Transparent videos are also possible via the WebM file format. Providing the video file has was encoded with
 * an alpha channel, and providing the browser supports WebM playback (not all of them do), then it will render
 * in-game with full transparency.
 *
 * ### Autoplaying Videos
 *
 * Videos can only autoplay if the browser has been unlocked with an interaction, or satisfies the MEI settings.
 * The policies that control autoplaying are vast and vary between browser. You can, and should, read more about
 * it here: https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
 *
 * If your video doesn't contain any audio, then set the `noAudio` parameter to `true` when the video is _loaded_,
 * and it will often allow the video to play immediately:
 *
 * ```javascript
 * preload () {
 *   this.load.video('pixar', 'nemo.mp4', true);
 * }
 * ```
 *
 * The 3rd parameter in the load call tells Phaser that the video doesn't contain any audio tracks. Video without
 * audio can autoplay without requiring a user interaction. Video with audio cannot do this unless it satisfies
 * the browsers MEI settings. See the MDN Autoplay Guide for further details.
 *
 * Or:
 *
 * ```javascript
 * create () {
 *   this.add.video(400, 300).loadURL('assets/aliens.mp4', true);
 * }
 * ```
 *
 * You can set the `noAudio` parameter to `true` even if the video does contain audio. It will still allow the video
 * to play immediately, but the audio will not start.
 *
 * Note that due to a bug in IE11 you cannot play a video texture to a Sprite in WebGL. For IE11 force Canvas mode.
 *
 * More details about video playback and the supported media formats can be found on MDN:
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
 * https://developer.mozilla.org/en-US/docs/Web/Media/Formats
 *
 * Note: This method will only be available if the Video Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#video
 * @since 3.20.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {string} [key] - Optional key of the Video this Game Object will play, as stored in the Video Cache.
 *
 * @return {Phaser.GameObjects.Video} The Game Object that was created.
 */ GameObjectFactory.register('video', function(x, y, key) {
                    return this.displayList.add(new Video(this.scene, x, y, key));
                });
            /***/ },
            /***/ 10247: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(29849);
                renderCanvas = __webpack_require__(58352);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 29849: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Video#renderWebGL
 * @since 3.20.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Video} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var VideoWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                    if (src.videoTexture) {
                        camera.addToRenderList(src);
                        src.pipeline.batchSprite(src, camera, parentMatrix);
                    }
                };
                module1.exports = VideoWebGLRenderer;
            /***/ },
            /***/ 41481: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(10312);
                var Circle = __webpack_require__(96503);
                var CircleContains = __webpack_require__(87902);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var Rectangle = __webpack_require__(87841);
                var RectangleContains = __webpack_require__(37303);
                /**
 * @classdesc
 * A Zone Game Object.
 *
 * A Zone is a non-rendering rectangular Game Object that has a position and size.
 * It has no texture and never displays, but does live on the display list and
 * can be moved, scaled and rotated like any other Game Object.
 *
 * Its primary use is for creating Drop Zones and Input Hit Areas and it has a couple of helper methods
 * specifically for this. It is also useful for object overlap checks, or as a base for your own
 * non-displaying Game Objects.

 * The default origin is 0.5, the center of the Zone, the same as with Game Objects.
 *
 * @class Zone
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=1] - The width of the Game Object.
 * @param {number} [height=1] - The height of the Game Object.
 */ var Zone = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Depth,
                        Components.GetBounds,
                        Components.Origin,
                        Components.Transform,
                        Components.ScrollFactor,
                        Components.Visible
                    ],
                    initialize: function Zone(scene, x, y, width, height) {
                        if (width === undefined) width = 1;
                        if (height === undefined) height = width;
                        GameObject.call(this, scene, 'Zone');
                        this.setPosition(x, y);
                        /**
         * The native (un-scaled) width of this Game Object.
         *
         * @name Phaser.GameObjects.Zone#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                        /**
         * The native (un-scaled) height of this Game Object.
         *
         * @name Phaser.GameObjects.Zone#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                        /**
         * The Blend Mode of the Game Object.
         * Although a Zone never renders, it still has a blend mode to allow it to fit seamlessly into
         * display lists without causing a batch flush.
         *
         * @name Phaser.GameObjects.Zone#blendMode
         * @type {number}
         * @since 3.0.0
         */ this.blendMode = BlendModes.NORMAL;
                        this.updateDisplayOrigin();
                    },
                    /**
     * The displayed width of this Game Object.
     * This value takes into account the scale factor.
     *
     * @name Phaser.GameObjects.Zone#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                        get: function() {
                            return this.scaleX * this.width;
                        },
                        set: function(value) {
                            this.scaleX = value / this.width;
                        }
                    },
                    /**
     * The displayed height of this Game Object.
     * This value takes into account the scale factor.
     *
     * @name Phaser.GameObjects.Zone#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                        get: function() {
                            return this.scaleY * this.height;
                        },
                        set: function(value) {
                            this.scaleY = value / this.height;
                        }
                    },
                    /**
     * Sets the size of this Game Object.
     *
     * @method Phaser.GameObjects.Zone#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * @param {boolean} [resizeInput=true] - If this Zone has a Rectangle for a hit area this argument will resize the hit area as well.
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height, resizeInput) {
                        if (resizeInput === undefined) resizeInput = true;
                        this.width = width;
                        this.height = height;
                        this.updateDisplayOrigin();
                        var input = this.input;
                        if (resizeInput && input && !input.customHitArea) {
                            input.hitArea.width = width;
                            input.hitArea.height = height;
                        }
                        return this;
                    },
                    /**
     * Sets the display size of this Game Object.
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.Zone#setDisplaySize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object.
     */ setDisplaySize: function(width, height) {
                        this.displayWidth = width;
                        this.displayHeight = height;
                        return this;
                    },
                    /**
     * Sets this Zone to be a Circular Drop Zone.
     * The circle is centered on this Zones `x` and `y` coordinates.
     *
     * @method Phaser.GameObjects.Zone#setCircleDropZone
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the Circle that will form the Drop Zone.
     *
     * @return {this} This Game Object.
     */ setCircleDropZone: function(radius) {
                        return this.setDropZone(new Circle(0, 0, radius), CircleContains);
                    },
                    /**
     * Sets this Zone to be a Rectangle Drop Zone.
     * The rectangle is centered on this Zones `x` and `y` coordinates.
     *
     * @method Phaser.GameObjects.Zone#setRectangleDropZone
     * @since 3.0.0
     *
     * @param {number} width - The width of the rectangle drop zone.
     * @param {number} height - The height of the rectangle drop zone.
     *
     * @return {this} This Game Object.
     */ setRectangleDropZone: function(width, height) {
                        return this.setDropZone(new Rectangle(0, 0, width, height), RectangleContains);
                    },
                    /**
     * Allows you to define your own Geometry shape to be used as a Drop Zone.
     *
     * @method Phaser.GameObjects.Zone#setDropZone
     * @since 3.0.0
     *
     * @param {object} [hitArea] - A Geometry shape instance, such as Phaser.Geom.Ellipse, or your own custom shape. If not given it will try to create a Rectangle based on the size of this zone.
     * @param {Phaser.Types.Input.HitAreaCallback} [hitAreaCallback] - A function that will return `true` if the given x/y coords it is sent are within the shape. If you provide a shape you must also provide a callback.
     *
     * @return {this} This Game Object.
     */ setDropZone: function(hitArea, hitAreaCallback) {
                        if (!this.input) this.setInteractive(hitArea, hitAreaCallback, true);
                        return this;
                    },
                    /**
     * A NOOP method so you can pass a Zone to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Zone#setAlpha
     * @private
     * @since 3.11.0
     */ setAlpha: function() {},
                    /**
     * A NOOP method so you can pass a Zone to a Container in Canvas.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Zone#setBlendMode
     * @private
     * @since 3.16.2
     */ setBlendMode: function() {},
                    /**
     * A Zone does not render.
     *
     * @method Phaser.GameObjects.Zone#renderCanvas
     * @private
     * @since 3.53.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
     * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
     */ renderCanvas: function(renderer, src, camera) {
                        camera.addToRenderList(src);
                    },
                    /**
     * A Zone does not render.
     *
     * @method Phaser.GameObjects.Zone#renderWebGL
     * @private
     * @since 3.53.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
     * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
     */ renderWebGL: function(renderer, src, camera) {
                        camera.addToRenderList(src);
                    }
                });
                module1.exports = Zone;
            /***/ },
            /***/ 95261: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(44603);
                var GetAdvancedValue = __webpack_require__(23568);
                var Zone = __webpack_require__(41481);
                /**
 * Creates a new Zone Game Object and returns it.
 *
 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#zone
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Zone.ZoneConfig} config - The configuration object this Game Object will use to create itself.
 *
 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
 */ GameObjectCreator.register('zone', function(config) {
                    var x = GetAdvancedValue(config, 'x', 0);
                    var y = GetAdvancedValue(config, 'y', 0);
                    var width = GetAdvancedValue(config, 'width', 1);
                    var height = GetAdvancedValue(config, 'height', width);
                    return new Zone(this.scene, x, y, width, height);
                });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            /***/ },
            /***/ 84175: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Zone = __webpack_require__(41481);
                var GameObjectFactory = __webpack_require__(39429);
                /**
 * Creates a new Zone Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#zone
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object.
 * @param {number} height - The height of the Game Object.
 *
 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
 */ GameObjectFactory.register('zone', function(x, y, width, height) {
                    return this.displayList.add(new Zone(this.scene, x, y, width, height));
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 95166: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the circle.
 *
 * @function Phaser.Geom.Circle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the area of.
 *
 * @return {number} The area of the Circle.
 */ var Area = function(circle) {
                    return circle.radius > 0 ? Math.PI * circle.radius * circle.radius : 0;
                };
                module1.exports = Area;
            /***/ },
            /***/ 96503: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Contains = __webpack_require__(87902);
                var GetPoint = __webpack_require__(26241);
                var GetPoints = __webpack_require__(79124);
                var GEOM_CONST = __webpack_require__(23777);
                var Random = __webpack_require__(28176);
                /**
 * @classdesc
 * A Circle object.
 *
 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render a Circle you should look at the capabilities of the Graphics class.
 *
 * @class Circle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x position of the center of the circle.
 * @param {number} [y=0] - The y position of the center of the circle.
 * @param {number} [radius=0] - The radius of the circle.
 */ var Circle = new Class({
                    initialize: function Circle(x, y, radius) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (radius === undefined) radius = 0;
                        /**
         * The geometry constant type of this object: `GEOM_CONST.CIRCLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Circle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.CIRCLE;
                        /**
         * The x position of the center of the circle.
         *
         * @name Phaser.Geom.Circle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                        /**
         * The y position of the center of the circle.
         *
         * @name Phaser.Geom.Circle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                        /**
         * The internal radius of the circle.
         *
         * @name Phaser.Geom.Circle#_radius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._radius = radius;
                        /**
         * The internal diameter of the circle.
         *
         * @name Phaser.Geom.Circle#_diameter
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._diameter = radius * 2;
                    },
                    /**
     * Check to see if the Circle contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Circle#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the circle.
     * @param {number} y - The y coordinate to check within the circle.
     *
     * @return {boolean} True if the coordinates are within the circle, otherwise false.
     */ contains: function(x, y) {
                        return Contains(this, x, y);
                    },
                    /**
     * Returns a Point object containing the coordinates of a point on the circumference of the Circle
     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
     * at 180 degrees around the circle.
     *
     * @method Phaser.Geom.Circle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [out,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
     */ getPoint: function(position, point) {
                        return GetPoint(this, position, point);
                    },
                    /**
     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Circle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the circle.
     */ getPoints: function(quantity, stepRate, output) {
                        return GetPoints(this, quantity, stepRate, output);
                    },
                    /**
     * Returns a uniformly distributed random point from anywhere within the Circle.
     *
     * @method Phaser.Geom.Circle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
     *
     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
     */ getRandomPoint: function(point) {
                        return Random(this, point);
                    },
                    /**
     * Sets the x, y and radius of this circle.
     *
     * @method Phaser.Geom.Circle#setTo
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of the center of the circle.
     * @param {number} [y=0] - The y position of the center of the circle.
     * @param {number} [radius=0] - The radius of the circle.
     *
     * @return {this} This Circle object.
     */ setTo: function(x, y, radius) {
                        this.x = x;
                        this.y = y;
                        this._radius = radius;
                        this._diameter = radius * 2;
                        return this;
                    },
                    /**
     * Sets this Circle to be empty with a radius of zero.
     * Does not change its position.
     *
     * @method Phaser.Geom.Circle#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Circle object.
     */ setEmpty: function() {
                        this._radius = 0;
                        this._diameter = 0;
                        return this;
                    },
                    /**
     * Sets the position of this Circle.
     *
     * @method Phaser.Geom.Circle#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of the center of the circle.
     * @param {number} [y=0] - The y position of the center of the circle.
     *
     * @return {this} This Circle object.
     */ setPosition: function(x, y) {
                        if (y === undefined) y = x;
                        this.x = x;
                        this.y = y;
                        return this;
                    },
                    /**
     * Checks to see if the Circle is empty: has a radius of zero.
     *
     * @method Phaser.Geom.Circle#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} True if the Circle is empty, otherwise false.
     */ isEmpty: function() {
                        return this._radius <= 0;
                    },
                    /**
     * The radius of the Circle.
     *
     * @name Phaser.Geom.Circle#radius
     * @type {number}
     * @since 3.0.0
     */ radius: {
                        get: function() {
                            return this._radius;
                        },
                        set: function(value) {
                            this._radius = value;
                            this._diameter = value * 2;
                        }
                    },
                    /**
     * The diameter of the Circle.
     *
     * @name Phaser.Geom.Circle#diameter
     * @type {number}
     * @since 3.0.0
     */ diameter: {
                        get: function() {
                            return this._diameter;
                        },
                        set: function(value) {
                            this._diameter = value;
                            this._radius = value * 0.5;
                        }
                    },
                    /**
     * The left position of the Circle.
     *
     * @name Phaser.Geom.Circle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                        get: function() {
                            return this.x - this._radius;
                        },
                        set: function(value) {
                            this.x = value + this._radius;
                        }
                    },
                    /**
     * The right position of the Circle.
     *
     * @name Phaser.Geom.Circle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                        get: function() {
                            return this.x + this._radius;
                        },
                        set: function(value) {
                            this.x = value - this._radius;
                        }
                    },
                    /**
     * The top position of the Circle.
     *
     * @name Phaser.Geom.Circle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                        get: function() {
                            return this.y - this._radius;
                        },
                        set: function(value) {
                            this.y = value + this._radius;
                        }
                    },
                    /**
     * The bottom position of the Circle.
     *
     * @name Phaser.Geom.Circle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                        get: function() {
                            return this.y + this._radius;
                        },
                        set: function(value) {
                            this.y = value - this._radius;
                        }
                    }
                });
                module1.exports = Circle;
            /***/ },
            /***/ 71562: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the circumference of the given Circle.
 *
 * @function Phaser.Geom.Circle.Circumference
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference of.
 *
 * @return {number} The circumference of the Circle.
 */ var Circumference = function(circle) {
                    return 2 * (Math.PI * circle.radius);
                };
                module1.exports = Circumference;
            /***/ },
            /***/ 92110: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Circle based on the given angle.
 *
 * @function Phaser.Geom.Circle.CircumferencePoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
 * @param {number} angle - The angle from the center of the Circle to the circumference to return the point from. Given in radians.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
 */ var CircumferencePoint = function(circle, angle, out) {
                    if (out === undefined) out = new Point();
                    out.x = circle.x + circle.radius * Math.cos(angle);
                    out.y = circle.y + circle.radius * Math.sin(angle);
                    return out;
                };
                module1.exports = CircumferencePoint;
            /***/ },
            /***/ 42250: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(96503);
                /**
 * Creates a new Circle instance based on the values contained in the given source.
 *
 * @function Phaser.Geom.Circle.Clone
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Circle|object)} source - The Circle to be cloned. Can be an instance of a Circle or a circle-like object, with x, y and radius properties.
 *
 * @return {Phaser.Geom.Circle} A clone of the source Circle.
 */ var Clone = function(source) {
                    return new Circle(source.x, source.y, source.radius);
                };
                module1.exports = Clone;
            /***/ },
            /***/ 87902: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check to see if the Circle contains the given x / y coordinates.
 *
 * @function Phaser.Geom.Circle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {number} x - The x coordinate to check within the circle.
 * @param {number} y - The y coordinate to check within the circle.
 *
 * @return {boolean} True if the coordinates are within the circle, otherwise false.
 */ var Contains = function(circle, x, y) {
                    //  Check if x/y are within the bounds first
                    if (circle.radius > 0 && x >= circle.left && x <= circle.right && y >= circle.top && y <= circle.bottom) {
                        var dx = (circle.x - x) * (circle.x - x);
                        var dy = (circle.y - y) * (circle.y - y);
                        return dx + dy <= circle.radius * circle.radius;
                    } else return false;
                };
                module1.exports = Contains;
            /***/ },
            /***/ 5698: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(87902);
                /**
 * Check to see if the Circle contains the given Point object.
 *
 * @function Phaser.Geom.Circle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
 *
 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
 */ var ContainsPoint = function(circle, point) {
                    return Contains(circle, point.x, point.y);
                };
                module1.exports = ContainsPoint;
            /***/ },
            /***/ 70588: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(87902);
                /**
 * Check to see if the Circle contains all four points of the given Rectangle object.
 *
 * @function Phaser.Geom.Circle.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Circle or not.
 *
 * @return {boolean} True if all of the Rectangle coordinates are within the circle, otherwise false.
 */ var ContainsRect = function(circle, rect) {
                    return Contains(circle, rect.x, rect.y) && Contains(circle, rect.right, rect.y) && Contains(circle, rect.x, rect.bottom) && Contains(circle, rect.right, rect.bottom);
                };
                module1.exports = ContainsRect;
            /***/ },
            /***/ 26394: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copies the `x`, `y` and `radius` properties from the `source` Circle
 * into the given `dest` Circle, then returns the `dest` Circle.
 *
 * @function Phaser.Geom.Circle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Circle} source - The source Circle to copy the values from.
 * @param {Phaser.Geom.Circle} dest - The destination Circle to copy the values to.
 *
 * @return {Phaser.Geom.Circle} The destination Circle.
 */ var CopyFrom = function(source, dest) {
                    return dest.setTo(source.x, source.y, source.radius);
                };
                module1.exports = CopyFrom;
            /***/ },
            /***/ 76278: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y` and `radius` properties of the two given Circles.
 * Returns `true` if they all match, otherwise returns `false`.
 *
 * @function Phaser.Geom.Circle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The first Circle to compare.
 * @param {Phaser.Geom.Circle} toCompare - The second Circle to compare.
 *
 * @return {boolean} `true` if the two Circles equal each other, otherwise `false`.
 */ var Equals = function(circle, toCompare) {
                    return circle.x === toCompare.x && circle.y === toCompare.y && circle.radius === toCompare.radius;
                };
                module1.exports = Equals;
            /***/ },
            /***/ 2074: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                /**
 * Returns the bounds of the Circle object.
 *
 * @function Phaser.Geom.Circle.GetBounds
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the bounds from.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the circle bounds in. If not given a new Rectangle will be created.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Circles bounds.
 */ var GetBounds = function(circle, out) {
                    if (out === undefined) out = new Rectangle();
                    out.x = circle.left;
                    out.y = circle.top;
                    out.width = circle.diameter;
                    out.height = circle.diameter;
                    return out;
                };
                module1.exports = GetBounds;
            /***/ },
            /***/ 26241: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircumferencePoint = __webpack_require__(92110);
                var FromPercent = __webpack_require__(62945);
                var MATH_CONST = __webpack_require__(36383);
                var Point = __webpack_require__(2141);
                /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Circle
 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
 * at 180 degrees around the circle.
 *
 * @function Phaser.Geom.Circle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
 * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
 */ var GetPoint = function(circle, position, out) {
                    if (out === undefined) out = new Point();
                    var angle = FromPercent(position, 0, MATH_CONST.PI2);
                    return CircumferencePoint(circle, angle, out);
                };
                module1.exports = GetPoint;
            /***/ },
            /***/ 79124: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circumference = __webpack_require__(71562);
                var CircumferencePoint = __webpack_require__(92110);
                var FromPercent = __webpack_require__(62945);
                var MATH_CONST = __webpack_require__(36383);
                /**
 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Circle.GetPoints
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
 * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the circumference of the circle.
 */ var GetPoints = function(circle, quantity, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!quantity && stepRate > 0) quantity = Circumference(circle) / stepRate;
                    for(var i = 0; i < quantity; i++){
                        var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
                        out.push(CircumferencePoint(circle, angle));
                    }
                    return out;
                };
                module1.exports = GetPoints;
            /***/ },
            /***/ 50884: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Circle by the values given.
 *
 * @function Phaser.Geom.Circle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [circle,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
 * @param {number} x - The amount to horizontally offset the Circle by.
 * @param {number} y - The amount to vertically offset the Circle by.
 *
 * @return {Phaser.Geom.Circle} The Circle that was offset.
 */ var Offset = function(circle, x, y) {
                    circle.x += x;
                    circle.y += y;
                    return circle;
                };
                module1.exports = Offset;
            /***/ },
            /***/ 39212: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Circle by the values given in the `x` and `y` properties of the Point object.
 *
 * @function Phaser.Geom.Circle.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [circle,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Circle by.
 *
 * @return {Phaser.Geom.Circle} The Circle that was offset.
 */ var OffsetPoint = function(circle, point) {
                    circle.x += point.x;
                    circle.y += point.y;
                    return circle;
                };
                module1.exports = OffsetPoint;
            /***/ },
            /***/ 28176: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns a uniformly distributed random point from anywhere within the given Circle.
 *
 * @function Phaser.Geom.Circle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get a random point from.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
 */ var Random = function(circle, out) {
                    if (out === undefined) out = new Point();
                    var t = 2 * Math.PI * Math.random();
                    var u = Math.random() + Math.random();
                    var r = u > 1 ? 2 - u : u;
                    var x = r * Math.cos(t);
                    var y = r * Math.sin(t);
                    out.x = circle.x + x * circle.radius;
                    out.y = circle.y + y * circle.radius;
                    return out;
                };
                module1.exports = Random;
            /***/ },
            /***/ 88911: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(96503);
                Circle.Area = __webpack_require__(95166);
                Circle.Circumference = __webpack_require__(71562);
                Circle.CircumferencePoint = __webpack_require__(92110);
                Circle.Clone = __webpack_require__(42250);
                Circle.Contains = __webpack_require__(87902);
                Circle.ContainsPoint = __webpack_require__(5698);
                Circle.ContainsRect = __webpack_require__(70588);
                Circle.CopyFrom = __webpack_require__(26394);
                Circle.Equals = __webpack_require__(76278);
                Circle.GetBounds = __webpack_require__(2074);
                Circle.GetPoint = __webpack_require__(26241);
                Circle.GetPoints = __webpack_require__(79124);
                Circle.Offset = __webpack_require__(50884);
                Circle.OffsetPoint = __webpack_require__(39212);
                Circle.Random = __webpack_require__(28176);
                module1.exports = Circle;
            /***/ },
            /***/ 23777: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GEOM_CONST = {
                    /**
     * A Circle Geometry object type.
     *
     * @name Phaser.Geom.CIRCLE
     * @type {number}
     * @since 3.19.0
     */ CIRCLE: 0,
                    /**
     * An Ellipse Geometry object type.
     *
     * @name Phaser.Geom.ELLIPSE
     * @type {number}
     * @since 3.19.0
     */ ELLIPSE: 1,
                    /**
     * A Line Geometry object type.
     *
     * @name Phaser.Geom.LINE
     * @type {number}
     * @since 3.19.0
     */ LINE: 2,
                    /**
     * A Point Geometry object type.
     *
     * @name Phaser.Geom.POINT
     * @type {number}
     * @since 3.19.0
     */ POINT: 3,
                    /**
     * A Polygon Geometry object type.
     *
     * @name Phaser.Geom.POLYGON
     * @type {number}
     * @since 3.19.0
     */ POLYGON: 4,
                    /**
     * A Rectangle Geometry object type.
     *
     * @name Phaser.Geom.RECTANGLE
     * @type {number}
     * @since 3.19.0
     */ RECTANGLE: 5,
                    /**
     * A Triangle Geometry object type.
     *
     * @name Phaser.Geom.TRIANGLE
     * @type {number}
     * @since 3.19.0
     */ TRIANGLE: 6
                };
                module1.exports = GEOM_CONST;
            /***/ },
            /***/ 78874: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the area of.
 *
 * @return {number} The area of the Ellipse.
 */ var Area = function(ellipse) {
                    if (ellipse.isEmpty()) return 0;
                    //  units squared
                    return ellipse.getMajorRadius() * ellipse.getMinorRadius() * Math.PI;
                };
                module1.exports = Area;
            /***/ },
            /***/ 92990: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the circumference of the given Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Circumference
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference of.
 *
 * @return {number} The circumference of th Ellipse.
 */ var Circumference = function(ellipse) {
                    var rx = ellipse.width / 2;
                    var ry = ellipse.height / 2;
                    var h = Math.pow(rx - ry, 2) / Math.pow(rx + ry, 2);
                    return Math.PI * (rx + ry) * (1 + 3 * h / (10 + Math.sqrt(4 - 3 * h)));
                };
                module1.exports = Circumference;
            /***/ },
            /***/ 79522: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse based on the given angle.
 *
 * @function Phaser.Geom.Ellipse.CircumferencePoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
 * @param {number} angle - The angle from the center of the Ellipse to the circumference to return the point from. Given in radians.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
 */ var CircumferencePoint = function(ellipse, angle, out) {
                    if (out === undefined) out = new Point();
                    var halfWidth = ellipse.width / 2;
                    var halfHeight = ellipse.height / 2;
                    out.x = ellipse.x + halfWidth * Math.cos(angle);
                    out.y = ellipse.y + halfHeight * Math.sin(angle);
                    return out;
                };
                module1.exports = CircumferencePoint;
            /***/ },
            /***/ 58102: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(8497);
                /**
 * Creates a new Ellipse instance based on the values contained in the given source.
 *
 * @function Phaser.Geom.Ellipse.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} source - The Ellipse to be cloned. Can be an instance of an Ellipse or a ellipse-like object, with x, y, width and height properties.
 *
 * @return {Phaser.Geom.Ellipse} A clone of the source Ellipse.
 */ var Clone = function(source) {
                    return new Ellipse(source.x, source.y, source.width, source.height);
                };
                module1.exports = Clone;
            /***/ },
            /***/ 81154: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check to see if the Ellipse contains the given x / y coordinates.
 *
 * @function Phaser.Geom.Ellipse.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {number} x - The x coordinate to check within the ellipse.
 * @param {number} y - The y coordinate to check within the ellipse.
 *
 * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
 */ var Contains = function(ellipse, x, y) {
                    if (ellipse.width <= 0 || ellipse.height <= 0) return false;
                    //  Normalize the coords to an ellipse with center 0,0 and a radius of 0.5
                    var normx = (x - ellipse.x) / ellipse.width;
                    var normy = (y - ellipse.y) / ellipse.height;
                    normx *= normx;
                    normy *= normy;
                    return normx + normy < 0.25;
                };
                module1.exports = Contains;
            /***/ },
            /***/ 46662: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(81154);
                /**
 * Check to see if the Ellipse contains the given Point object.
 *
 * @function Phaser.Geom.Ellipse.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
 *
 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
 */ var ContainsPoint = function(ellipse, point) {
                    return Contains(ellipse, point.x, point.y);
                };
                module1.exports = ContainsPoint;
            /***/ },
            /***/ 1632: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(81154);
                /**
 * Check to see if the Ellipse contains all four points of the given Rectangle object.
 *
 * @function Phaser.Geom.Ellipse.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Ellipse or not.
 *
 * @return {boolean} True if all of the Rectangle coordinates are within the ellipse, otherwise false.
 */ var ContainsRect = function(ellipse, rect) {
                    return Contains(ellipse, rect.x, rect.y) && Contains(ellipse, rect.right, rect.y) && Contains(ellipse, rect.x, rect.bottom) && Contains(ellipse, rect.right, rect.bottom);
                };
                module1.exports = ContainsRect;
            /***/ },
            /***/ 65534: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copies the `x`, `y`, `width` and `height` properties from the `source` Ellipse
 * into the given `dest` Ellipse, then returns the `dest` Ellipse.
 *
 * @function Phaser.Geom.Ellipse.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [dest,$return]
 *
 * @param {Phaser.Geom.Ellipse} source - The source Ellipse to copy the values from.
 * @param {Phaser.Geom.Ellipse} dest - The destination Ellipse to copy the values to.
 *
 * @return {Phaser.Geom.Ellipse} The destination Ellipse.
 */ var CopyFrom = function(source, dest) {
                    return dest.setTo(source.x, source.y, source.width, source.height);
                };
                module1.exports = CopyFrom;
            /***/ },
            /***/ 8497: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Contains = __webpack_require__(81154);
                var GetPoint = __webpack_require__(90549);
                var GetPoints = __webpack_require__(48320);
                var GEOM_CONST = __webpack_require__(23777);
                var Random = __webpack_require__(24820);
                /**
 * @classdesc
 * An Ellipse object.
 *
 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render an Ellipse you should look at the capabilities of the Graphics class.
 *
 * @class Ellipse
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x position of the center of the ellipse.
 * @param {number} [y=0] - The y position of the center of the ellipse.
 * @param {number} [width=0] - The width of the ellipse.
 * @param {number} [height=0] - The height of the ellipse.
 */ var Ellipse = new Class({
                    initialize: function Ellipse(x, y, width, height) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 0;
                        if (height === undefined) height = 0;
                        /**
         * The geometry constant type of this object: `GEOM_CONST.ELLIPSE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Ellipse#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.ELLIPSE;
                        /**
         * The x position of the center of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                        /**
         * The y position of the center of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                        /**
         * The width of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#width
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.width = width;
                        /**
         * The height of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#height
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.height = height;
                    },
                    /**
     * Check to see if the Ellipse contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Ellipse#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the ellipse.
     * @param {number} y - The y coordinate to check within the ellipse.
     *
     * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
     */ contains: function(x, y) {
                        return Contains(this, x, y);
                    },
                    /**
     * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
     * at 180 degrees around the circle.
     *
     * @method Phaser.Geom.Ellipse#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [out,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
     */ getPoint: function(position, point) {
                        return GetPoint(this, position, point);
                    },
                    /**
     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Ellipse#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the ellipse.
     */ getPoints: function(quantity, stepRate, output) {
                        return GetPoints(this, quantity, stepRate, output);
                    },
                    /**
     * Returns a uniformly distributed random point from anywhere within the given Ellipse.
     *
     * @method Phaser.Geom.Ellipse#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
     *
     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
     */ getRandomPoint: function(point) {
                        return Random(this, point);
                    },
                    /**
     * Sets the x, y, width and height of this ellipse.
     *
     * @method Phaser.Geom.Ellipse#setTo
     * @since 3.0.0
     *
     * @param {number} x - The x position of the center of the ellipse.
     * @param {number} y - The y position of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setTo: function(x, y, width, height) {
                        this.x = x;
                        this.y = y;
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Sets this Ellipse to be empty with a width and height of zero.
     * Does not change its position.
     *
     * @method Phaser.Geom.Ellipse#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Ellipse object.
     */ setEmpty: function() {
                        this.width = 0;
                        this.height = 0;
                        return this;
                    },
                    /**
     * Sets the position of this Ellipse.
     *
     * @method Phaser.Geom.Ellipse#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The x position of the center of the ellipse.
     * @param {number} y - The y position of the center of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setPosition: function(x, y) {
                        if (y === undefined) y = x;
                        this.x = x;
                        this.y = y;
                        return this;
                    },
                    /**
     * Sets the size of this Ellipse.
     * Does not change its position.
     *
     * @method Phaser.Geom.Ellipse#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the ellipse.
     * @param {number} [height=width] - The height of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setSize: function(width, height) {
                        if (height === undefined) height = width;
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Checks to see if the Ellipse is empty: has a width or height equal to zero.
     *
     * @method Phaser.Geom.Ellipse#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} True if the Ellipse is empty, otherwise false.
     */ isEmpty: function() {
                        return this.width <= 0 || this.height <= 0;
                    },
                    /**
     * Returns the minor radius of the ellipse. Also known as the Semi Minor Axis.
     *
     * @method Phaser.Geom.Ellipse#getMinorRadius
     * @since 3.0.0
     *
     * @return {number} The minor radius.
     */ getMinorRadius: function() {
                        return Math.min(this.width, this.height) / 2;
                    },
                    /**
     * Returns the major radius of the ellipse. Also known as the Semi Major Axis.
     *
     * @method Phaser.Geom.Ellipse#getMajorRadius
     * @since 3.0.0
     *
     * @return {number} The major radius.
     */ getMajorRadius: function() {
                        return Math.max(this.width, this.height) / 2;
                    },
                    /**
     * The left position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                        get: function() {
                            return this.x - this.width / 2;
                        },
                        set: function(value) {
                            this.x = value + this.width / 2;
                        }
                    },
                    /**
     * The right position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                        get: function() {
                            return this.x + this.width / 2;
                        },
                        set: function(value) {
                            this.x = value - this.width / 2;
                        }
                    },
                    /**
     * The top position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                        get: function() {
                            return this.y - this.height / 2;
                        },
                        set: function(value) {
                            this.y = value + this.height / 2;
                        }
                    },
                    /**
     * The bottom position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                        get: function() {
                            return this.y + this.height / 2;
                        },
                        set: function(value) {
                            this.y = value - this.height / 2;
                        }
                    }
                });
                module1.exports = Ellipse;
            /***/ },
            /***/ 36146: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y`, `width` and `height` properties of the two given Ellipses.
 * Returns `true` if they all match, otherwise returns `false`.
 *
 * @function Phaser.Geom.Ellipse.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The first Ellipse to compare.
 * @param {Phaser.Geom.Ellipse} toCompare - The second Ellipse to compare.
 *
 * @return {boolean} `true` if the two Ellipse equal each other, otherwise `false`.
 */ var Equals = function(ellipse, toCompare) {
                    return ellipse.x === toCompare.x && ellipse.y === toCompare.y && ellipse.width === toCompare.width && ellipse.height === toCompare.height;
                };
                module1.exports = Equals;
            /***/ },
            /***/ 23694: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                /**
 * Returns the bounds of the Ellipse object.
 *
 * @function Phaser.Geom.Ellipse.GetBounds
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the bounds from.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the ellipse bounds in. If not given a new Rectangle will be created.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Ellipse bounds.
 */ var GetBounds = function(ellipse, out) {
                    if (out === undefined) out = new Rectangle();
                    out.x = ellipse.left;
                    out.y = ellipse.top;
                    out.width = ellipse.width;
                    out.height = ellipse.height;
                    return out;
                };
                module1.exports = GetBounds;
            /***/ },
            /***/ 90549: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircumferencePoint = __webpack_require__(79522);
                var FromPercent = __webpack_require__(62945);
                var MATH_CONST = __webpack_require__(36383);
                var Point = __webpack_require__(2141);
                /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
 * at 180 degrees around the circle.
 *
 * @function Phaser.Geom.Ellipse.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
 * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
 */ var GetPoint = function(ellipse, position, out) {
                    if (out === undefined) out = new Point();
                    var angle = FromPercent(position, 0, MATH_CONST.PI2);
                    return CircumferencePoint(ellipse, angle, out);
                };
                module1.exports = GetPoint;
            /***/ },
            /***/ 48320: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circumference = __webpack_require__(92990);
                var CircumferencePoint = __webpack_require__(79522);
                var FromPercent = __webpack_require__(62945);
                var MATH_CONST = __webpack_require__(36383);
                /**
 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Ellipse.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the ellipse.
 */ var GetPoints = function(ellipse, quantity, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!quantity && stepRate > 0) quantity = Circumference(ellipse) / stepRate;
                    for(var i = 0; i < quantity; i++){
                        var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
                        out.push(CircumferencePoint(ellipse, angle));
                    }
                    return out;
                };
                module1.exports = GetPoints;
            /***/ },
            /***/ 73424: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Ellipse by the values given.
 *
 * @function Phaser.Geom.Ellipse.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
 * @param {number} x - The amount to horizontally offset the Ellipse by.
 * @param {number} y - The amount to vertically offset the Ellipse by.
 *
 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
 */ var Offset = function(ellipse, x, y) {
                    ellipse.x += x;
                    ellipse.y += y;
                    return ellipse;
                };
                module1.exports = Offset;
            /***/ },
            /***/ 44808: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Ellipse by the values given in the `x` and `y` properties of the Point object.
 *
 * @function Phaser.Geom.Ellipse.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Ellipse by.
 *
 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
 */ var OffsetPoint = function(ellipse, point) {
                    ellipse.x += point.x;
                    ellipse.y += point.y;
                    return ellipse;
                };
                module1.exports = OffsetPoint;
            /***/ },
            /***/ 24820: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns a uniformly distributed random point from anywhere within the given Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get a random point from.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
 */ var Random = function(ellipse, out) {
                    if (out === undefined) out = new Point();
                    var p = Math.random() * Math.PI * 2;
                    var s = Math.sqrt(Math.random());
                    out.x = ellipse.x + s * Math.cos(p) * ellipse.width / 2;
                    out.y = ellipse.y + s * Math.sin(p) * ellipse.height / 2;
                    return out;
                };
                module1.exports = Random;
            /***/ },
            /***/ 49203: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(8497);
                Ellipse.Area = __webpack_require__(78874);
                Ellipse.Circumference = __webpack_require__(92990);
                Ellipse.CircumferencePoint = __webpack_require__(79522);
                Ellipse.Clone = __webpack_require__(58102);
                Ellipse.Contains = __webpack_require__(81154);
                Ellipse.ContainsPoint = __webpack_require__(46662);
                Ellipse.ContainsRect = __webpack_require__(1632);
                Ellipse.CopyFrom = __webpack_require__(65534);
                Ellipse.Equals = __webpack_require__(36146);
                Ellipse.GetBounds = __webpack_require__(23694);
                Ellipse.GetPoint = __webpack_require__(90549);
                Ellipse.GetPoints = __webpack_require__(48320);
                Ellipse.Offset = __webpack_require__(73424);
                Ellipse.OffsetPoint = __webpack_require__(44808);
                Ellipse.Random = __webpack_require__(24820);
                module1.exports = Ellipse;
            /***/ },
            /***/ 55738: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(23777);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Geom
 */ var Geom = {
                    Circle: __webpack_require__(88911),
                    Ellipse: __webpack_require__(49203),
                    Intersects: __webpack_require__(91865),
                    Line: __webpack_require__(2529),
                    Mesh: __webpack_require__(73090),
                    Point: __webpack_require__(43711),
                    Polygon: __webpack_require__(58423),
                    Rectangle: __webpack_require__(93232),
                    Triangle: __webpack_require__(84435)
                };
                //   Merge in the consts
                Geom = Extend(false, Geom, CONST);
                module1.exports = Geom;
            /***/ },
            /***/ 2044: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DistanceBetween = __webpack_require__(20339);
                /**
 * Checks if two Circles intersect.
 *
 * @function Phaser.Geom.Intersects.CircleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circleA - The first Circle to check for intersection.
 * @param {Phaser.Geom.Circle} circleB - The second Circle to check for intersection.
 *
 * @return {boolean} `true` if the two Circles intersect, otherwise `false`.
 */ var CircleToCircle = function(circleA, circleB) {
                    return DistanceBetween(circleA.x, circleA.y, circleB.x, circleB.y) <= circleA.radius + circleB.radius;
                };
                module1.exports = CircleToCircle;
            /***/ },
            /***/ 81491: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between a circle and a rectangle.
 *
 * @function Phaser.Geom.Intersects.CircleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The circle to be checked.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to be checked.
 *
 * @return {boolean} `true` if the two objects intersect, otherwise `false`.
 */ var CircleToRectangle = function(circle, rect) {
                    var halfWidth = rect.width / 2;
                    var halfHeight = rect.height / 2;
                    var cx = Math.abs(circle.x - rect.x - halfWidth);
                    var cy = Math.abs(circle.y - rect.y - halfHeight);
                    var xDist = halfWidth + circle.radius;
                    var yDist = halfHeight + circle.radius;
                    if (cx > xDist || cy > yDist) return false;
                    else if (cx <= halfWidth || cy <= halfHeight) return true;
                    else {
                        var xCornerDist = cx - halfWidth;
                        var yCornerDist = cy - halfHeight;
                        var xCornerDistSq = xCornerDist * xCornerDist;
                        var yCornerDistSq = yCornerDist * yCornerDist;
                        var maxCornerDistSq = circle.radius * circle.radius;
                        return xCornerDistSq + yCornerDistSq <= maxCornerDistSq;
                    }
                };
                module1.exports = CircleToRectangle;
            /***/ },
            /***/ 63376: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                var CircleToCircle = __webpack_require__(2044);
                /**
 * Checks if two Circles intersect and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetCircleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circleA - The first Circle to check for intersection.
 * @param {Phaser.Geom.Circle} circleB - The second Circle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetCircleToCircle = function(circleA, circleB, out) {
                    if (out === undefined) out = [];
                    if (CircleToCircle(circleA, circleB)) {
                        var x0 = circleA.x;
                        var y0 = circleA.y;
                        var r0 = circleA.radius;
                        var x1 = circleB.x;
                        var y1 = circleB.y;
                        var r1 = circleB.radius;
                        var coefficientA, coefficientB, coefficientC, lambda, x;
                        if (y0 === y1) {
                            x = (r1 * r1 - r0 * r0 - x1 * x1 + x0 * x0) / (2 * (x0 - x1));
                            coefficientA = 1;
                            coefficientB = -2 * y1;
                            coefficientC = x1 * x1 + x * x - 2 * x1 * x + y1 * y1 - r1 * r1;
                            lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                            if (lambda === 0) out.push(new Point(x, -coefficientB / (2 * coefficientA)));
                            else if (lambda > 0) {
                                out.push(new Point(x, (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA)));
                                out.push(new Point(x, (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA)));
                            }
                        } else {
                            var v1 = (x0 - x1) / (y0 - y1);
                            var n = (r1 * r1 - r0 * r0 - x1 * x1 + x0 * x0 - y1 * y1 + y0 * y0) / (2 * (y0 - y1));
                            coefficientA = v1 * v1 + 1;
                            coefficientB = 2 * y0 * v1 - 2 * n * v1 - 2 * x0;
                            coefficientC = x0 * x0 + y0 * y0 + n * n - r0 * r0 - 2 * y0 * n;
                            lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                            if (lambda === 0) {
                                x = -coefficientB / (2 * coefficientA);
                                out.push(new Point(x, n - x * v1));
                            } else if (lambda > 0) {
                                x = (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA);
                                out.push(new Point(x, n - x * v1));
                                x = (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA);
                                out.push(new Point(x, n - x * v1));
                            }
                        }
                    }
                    return out;
                };
                module1.exports = GetCircleToCircle;
            /***/ },
            /***/ 97439: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToCircle = __webpack_require__(4042);
                var CircleToRectangle = __webpack_require__(81491);
                /**
 * Checks for intersection between a circle and a rectangle,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetCircleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The circle to be checked.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to be checked.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetCircleToRectangle = function(circle, rect, out) {
                    if (out === undefined) out = [];
                    if (CircleToRectangle(circle, rect)) {
                        var lineA = rect.getLineA();
                        var lineB = rect.getLineB();
                        var lineC = rect.getLineC();
                        var lineD = rect.getLineD();
                        GetLineToCircle(lineA, circle, out);
                        GetLineToCircle(lineB, circle, out);
                        GetLineToCircle(lineC, circle, out);
                        GetLineToCircle(lineD, circle, out);
                    }
                    return out;
                };
                module1.exports = GetCircleToRectangle;
            /***/ },
            /***/ 4042: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                var LineToCircle = __webpack_require__(80462);
                /**
 * Checks for intersection between the line segment and circle,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetLineToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Circle} circle - The circle to check against the line.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetLineToCircle = function(line, circle, out) {
                    if (out === undefined) out = [];
                    if (LineToCircle(line, circle)) {
                        var lx1 = line.x1;
                        var ly1 = line.y1;
                        var lx2 = line.x2;
                        var ly2 = line.y2;
                        var cx = circle.x;
                        var cy = circle.y;
                        var cr = circle.radius;
                        var lDirX = lx2 - lx1;
                        var lDirY = ly2 - ly1;
                        var oDirX = lx1 - cx;
                        var oDirY = ly1 - cy;
                        var coefficientA = lDirX * lDirX + lDirY * lDirY;
                        var coefficientB = 2 * (lDirX * oDirX + lDirY * oDirY);
                        var coefficientC = oDirX * oDirX + oDirY * oDirY - cr * cr;
                        var lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                        var x, y;
                        if (lambda === 0) {
                            var root = -coefficientB / (2 * coefficientA);
                            x = lx1 + root * lDirX;
                            y = ly1 + root * lDirY;
                            if (root >= 0 && root <= 1) out.push(new Point(x, y));
                        } else if (lambda > 0) {
                            var root1 = (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA);
                            x = lx1 + root1 * lDirX;
                            y = ly1 + root1 * lDirY;
                            if (root1 >= 0 && root1 <= 1) out.push(new Point(x, y));
                            var root2 = (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA);
                            x = lx1 + root2 * lDirX;
                            y = ly1 + root2 * lDirY;
                            if (root2 >= 0 && root2 <= 1) out.push(new Point(x, y));
                        }
                    }
                    return out;
                };
                module1.exports = GetLineToCircle;
            /***/ },
            /***/ 36100: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(25836);
                /**
 * Checks for intersection between the two line segments, or a ray and a line segment,
 * and returns the intersection point as a Vector3, or `null` if the lines are parallel, or do not intersect.
 *
 * The `z` property of the Vector3 contains the intersection distance, which can be used to find
 * the closest intersecting point from a group of line segments.
 *
 * @function Phaser.Geom.Intersects.GetLineToLine
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line1 - The first line segment, or a ray, to check.
 * @param {Phaser.Geom.Line} line2 - The second line segment to check.
 * @param {boolean} [isRay=false] - Is `line1` a ray or a line segment?
 * @param {Phaser.Math.Vector3} [out] - A Vector3 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector3} A Vector3 containing the intersection results, or `null`.
 */ var GetLineToLine = function(line1, line2, isRay, out) {
                    if (isRay === undefined) isRay = false;
                    var x1 = line1.x1;
                    var y1 = line1.y1;
                    var x2 = line1.x2;
                    var y2 = line1.y2;
                    var x3 = line2.x1;
                    var y3 = line2.y1;
                    var x4 = line2.x2;
                    var y4 = line2.y2;
                    var dx1 = x2 - x1;
                    var dy1 = y2 - y1;
                    var dx2 = x4 - x3;
                    var dy2 = y4 - y3;
                    var denom = dx1 * dy2 - dy1 * dx2;
                    //  Add co-linear check
                    //  Make sure there is not a division by zero - this also indicates that the lines are parallel.
                    //  If numA and numB were both equal to zero the lines would be on top of each other (coincidental).
                    //  This check is not done because it is not necessary for this implementation (the parallel check accounts for this).
                    if (denom === 0) return null;
                    var t;
                    var u;
                    var s;
                    if (isRay) {
                        t = (dx1 * (y3 - y1) + dy1 * (x1 - x3)) / (dx2 * dy1 - dy2 * dx1);
                        if (dx1 !== 0) u = (x3 + dx2 * t - x1) / dx1;
                        else if (dy1 !== 0) u = (y3 + dy2 * t - y1) / dy1;
                        else return null; // degenerate line segment
                        //  Intersects?
                        if (u < 0 || t < 0 || t > 1) return null;
                        s = u;
                    } else {
                        t = ((x3 - x1) * dy2 - (y3 - y1) * dx2) / denom;
                        u = ((y1 - y3) * dx1 - (x1 - x3) * dy1) / denom;
                        //  Intersects?
                        if (t < 0 || t > 1 || u < 0 || u > 1) return null;
                        s = t;
                    }
                    if (out === undefined) out = new Vector3();
                    return out.set(x1 + dx1 * s, y1 + dy1 * s, s);
                };
                module1.exports = GetLineToLine;
            /***/ },
            /***/ 3073: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToLine = __webpack_require__(36100);
                var Line = __webpack_require__(23031);
                var Vector3 = __webpack_require__(25836);
                //  Temp calculation segment
                var segment = new Line();
                //  Temp vec3
                var tempIntersect = new Vector3();
                /**
 * Checks for the closest point of intersection between a line segment and an array of points, where each pair
 * of points are converted to line segments for the intersection tests.
 *
 * If no intersection is found, this function returns `null`.
 *
 * If intersection was found, a Vector3 is returned with the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the closest distance.
 *
 * @function Phaser.Geom.Intersects.GetLineToPoints
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line - The line segment, or ray, to check. If a ray, set the `isRay` parameter to `true`.
 * @param {Phaser.Math.Vector2[] | Phaser.Geom.Point[]} points - An array of points to check.
 * @param {boolean} [isRay=false] - Is `line` a ray or a line segment?
 * @param {Phaser.Math.Vector3} [out] - A Vector3 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector3} A Vector3 containing the intersection results, or `null`.
 */ var GetLineToPoints = function(line, points, isRay, out) {
                    if (isRay === undefined) isRay = false;
                    if (out === undefined) out = new Vector3();
                    var closestIntersect = false;
                    //  Reset our vec3s
                    out.set();
                    tempIntersect.set();
                    var prev = points[points.length - 1];
                    for(var i = 0; i < points.length; i++){
                        var current = points[i];
                        segment.setTo(prev.x, prev.y, current.x, current.y);
                        prev = current;
                        if (GetLineToLine(line, segment, isRay, tempIntersect)) {
                            if (!closestIntersect || tempIntersect.z < out.z) {
                                out.copy(tempIntersect);
                                closestIntersect = true;
                            }
                        }
                    }
                    return closestIntersect ? out : null;
                };
                module1.exports = GetLineToPoints;
            /***/ },
            /***/ 56362: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(25836);
                var Vector4 = __webpack_require__(61369);
                var GetLineToPoints = __webpack_require__(3073);
                //  Temp vec3
                var tempIntersect = new Vector3();
                /**
 * Checks for the closest point of intersection between a line segment and an array of polygons.
 *
 * If no intersection is found, this function returns `null`.
 *
 * If intersection was found, a Vector4 is returned with the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the closest distance.
 * The `w` component contains the index of the polygon, in the given array, that triggered the intersection.
 *
 * @function Phaser.Geom.Intersects.GetLineToPolygon
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line - The line segment, or ray, to check. If a ray, set the `isRay` parameter to `true`.
 * @param {Phaser.Geom.Polygon | Phaser.Geom.Polygon[]} polygons - A single polygon, or array of polygons, to check.
 * @param {boolean} [isRay=false] - Is `line` a ray or a line segment?
 * @param {Phaser.Math.Vector4} [out] - A Vector4 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector4} A Vector4 containing the intersection results, or `null`.
 */ var GetLineToPolygon = function(line, polygons, isRay, out) {
                    if (out === undefined) out = new Vector4();
                    if (!Array.isArray(polygons)) polygons = [
                        polygons
                    ];
                    var closestIntersect = false;
                    //  Reset our vec4s
                    out.set();
                    tempIntersect.set();
                    for(var i = 0; i < polygons.length; i++){
                        if (GetLineToPoints(line, polygons[i].points, isRay, tempIntersect)) {
                            if (!closestIntersect || tempIntersect.z < out.z) {
                                out.set(tempIntersect.x, tempIntersect.y, tempIntersect.z, i);
                                closestIntersect = true;
                            }
                        }
                    }
                    return closestIntersect ? out : null;
                };
                module1.exports = GetLineToPolygon;
            /***/ },
            /***/ 60646: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                var LineToLine = __webpack_require__(76112);
                var LineToRectangle = __webpack_require__(92773);
                /**
 * Checks for intersection between the Line and a Rectangle shape,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetLineToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line to check for intersection.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetLineToRectangle = function(line, rect, out) {
                    if (out === undefined) out = [];
                    if (LineToRectangle(line, rect)) {
                        var lineA = rect.getLineA();
                        var lineB = rect.getLineB();
                        var lineC = rect.getLineC();
                        var lineD = rect.getLineD();
                        var output = [
                            new Point(),
                            new Point(),
                            new Point(),
                            new Point()
                        ];
                        var result = [
                            LineToLine(lineA, line, output[0]),
                            LineToLine(lineB, line, output[1]),
                            LineToLine(lineC, line, output[2]),
                            LineToLine(lineD, line, output[3])
                        ];
                        for(var i = 0; i < 4; i++)if (result[i]) out.push(output[i]);
                    }
                    return out;
                };
                module1.exports = GetLineToRectangle;
            /***/ },
            /***/ 71147: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector4 = __webpack_require__(61369);
                var GetLineToPolygon = __webpack_require__(56362);
                var Line = __webpack_require__(23031);
                //  Temp calculation segment
                var segment = new Line();
                /**
 * @ignore
 */ function CheckIntersects(angle, x, y, polygons, intersects) {
                    var dx = Math.cos(angle);
                    var dy = Math.sin(angle);
                    segment.setTo(x, y, x + dx, y + dy);
                    var closestIntersect = GetLineToPolygon(segment, polygons, true);
                    if (closestIntersect) intersects.push(new Vector4(closestIntersect.x, closestIntersect.y, angle, closestIntersect.w));
                }
                /**
 * @ignore
 */ function SortIntersects(a, b) {
                    return a.z - b.z;
                }
                /**
 * Projects rays out from the given point to each line segment of the polygons.
 *
 * If the rays intersect with the polygons, the points of intersection are returned in an array.
 *
 * If no intersections are found, the returned array will be empty.
 *
 * Each Vector4 intersection result has the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the angle of intersection.
 * The `w` component contains the index of the polygon, in the given array, that triggered the intersection.
 *
 * @function Phaser.Geom.Intersects.GetRaysFromPointToPolygon
 * @since 3.50.0
 *
 * @param {number} x - The x coordinate to project the rays from.
 * @param {number} y - The y coordinate to project the rays from.
 * @param {Phaser.Geom.Polygon | Phaser.Geom.Polygon[]} polygons - A single polygon, or array of polygons, to check against the rays.
 *
 * @return {Phaser.Math.Vector4[]} An array containing all intersections in Vector4s.
 */ var GetRaysFromPointToPolygon = function(x, y, polygons) {
                    if (!Array.isArray(polygons)) polygons = [
                        polygons
                    ];
                    var intersects = [];
                    var angles = [];
                    for(var i = 0; i < polygons.length; i++){
                        var points = polygons[i].points;
                        for(var p = 0; p < points.length; p++){
                            var angle = Math.atan2(points[p].y - y, points[p].x - x);
                            if (angles.indexOf(angle) === -1) {
                                //  +- 0.00001 rads to catch lines behind segment corners
                                CheckIntersects(angle, x, y, polygons, intersects);
                                CheckIntersects(angle - 0.00001, x, y, polygons, intersects);
                                CheckIntersects(angle + 0.00001, x, y, polygons, intersects);
                                angles.push(angle);
                            }
                        }
                    }
                    return intersects.sort(SortIntersects);
                };
                module1.exports = GetRaysFromPointToPolygon;
            /***/ },
            /***/ 68389: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                var RectangleToRectangle = __webpack_require__(59996);
                /**
 * Checks if two Rectangle shapes intersect and returns the area of this intersection as Rectangle object.
 *
 * If optional `output` parameter is omitted, new Rectangle object is created and returned. If there is intersection, it will contain intersection area. If there is no intersection, it wil be empty Rectangle (all values set to zero).
 *
 * If Rectangle object is passed as `output` and there is intersection, then intersection area data will be loaded into it and it will be returned. If there is no intersection, it will be returned without any change.
 *
 * @function Phaser.Geom.Intersects.GetRectangleIntersection
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [output,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle object.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle object.
 * @param {Phaser.Geom.Rectangle} [output] - Optional Rectangle object. If given, the intersection data will be loaded into it (in case of no intersection, it will be left unchanged). Otherwise, new Rectangle object will be created and returned with either intersection data or empty (all values set to zero), if there is no intersection.
 *
 * @return {Phaser.Geom.Rectangle} A rectangle object with intersection data.
 */ var GetRectangleIntersection = function(rectA, rectB, output) {
                    if (output === undefined) output = new Rectangle();
                    if (RectangleToRectangle(rectA, rectB)) {
                        output.x = Math.max(rectA.x, rectB.x);
                        output.y = Math.max(rectA.y, rectB.y);
                        output.width = Math.min(rectA.right, rectB.right) - output.x;
                        output.height = Math.min(rectA.bottom, rectB.bottom) - output.y;
                    }
                    return output;
                };
                module1.exports = GetRectangleIntersection;
            /***/ },
            /***/ 52784: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToRectangle = __webpack_require__(60646);
                var RectangleToRectangle = __webpack_require__(59996);
                /**
 * Checks if two Rectangles intersect and returns the intersection points as a Point object array.
 *
 * A Rectangle intersects another Rectangle if any part of its bounds is within the other Rectangle's bounds. As such, the two Rectangles are considered "solid". A Rectangle with no width or no height will never intersect another Rectangle.
 *
 * @function Phaser.Geom.Intersects.GetRectangleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check for intersection.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetRectangleToRectangle = function(rectA, rectB, out) {
                    if (out === undefined) out = [];
                    if (RectangleToRectangle(rectA, rectB)) {
                        var lineA = rectA.getLineA();
                        var lineB = rectA.getLineB();
                        var lineC = rectA.getLineC();
                        var lineD = rectA.getLineD();
                        GetLineToRectangle(lineA, rectB, out);
                        GetLineToRectangle(lineB, rectB, out);
                        GetLineToRectangle(lineC, rectB, out);
                        GetLineToRectangle(lineD, rectB, out);
                    }
                    return out;
                };
                module1.exports = GetRectangleToRectangle;
            /***/ },
            /***/ 26341: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RectangleToTriangle = __webpack_require__(89265);
                var GetLineToRectangle = __webpack_require__(60646);
                /**
 * Checks for intersection between Rectangle shape and Triangle shape,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetRectangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle object to test.
 * @param {Phaser.Geom.Triangle} triangle - Triangle object to test.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetRectangleToTriangle = function(rect, triangle, out) {
                    if (out === undefined) out = [];
                    if (RectangleToTriangle(rect, triangle)) {
                        var lineA = triangle.getLineA();
                        var lineB = triangle.getLineB();
                        var lineC = triangle.getLineC();
                        GetLineToRectangle(lineA, rect, out);
                        GetLineToRectangle(lineB, rect, out);
                        GetLineToRectangle(lineC, rect, out);
                    }
                    return out;
                };
                module1.exports = GetRectangleToTriangle;
            /***/ },
            /***/ 38720: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToCircle = __webpack_require__(4042);
                var TriangleToCircle = __webpack_require__(67636);
                /**
 * Checks if a Triangle and a Circle intersect, and returns the intersection points as a Point object array.
 *
 * A Circle intersects a Triangle if its center is located within it or if any of the Triangle's sides intersect the Circle. As such, the Triangle and the Circle are considered "solid" for the intersection.
 *
 * @function Phaser.Geom.Intersects.GetTriangleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check for intersection.
 * @param {Phaser.Geom.Circle} circle - The Circle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToCircle = function(triangle, circle, out) {
                    if (out === undefined) out = [];
                    if (TriangleToCircle(triangle, circle)) {
                        var lineA = triangle.getLineA();
                        var lineB = triangle.getLineB();
                        var lineC = triangle.getLineC();
                        GetLineToCircle(lineA, circle, out);
                        GetLineToCircle(lineB, circle, out);
                        GetLineToCircle(lineC, circle, out);
                    }
                    return out;
                };
                module1.exports = GetTriangleToCircle;
            /***/ },
            /***/ 13882: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                var TriangleToLine = __webpack_require__(2822);
                var LineToLine = __webpack_require__(76112);
                /**
 * Checks if a Triangle and a Line intersect, and returns the intersection points as a Point object array.
 *
 * The Line intersects the Triangle if it starts inside of it, ends inside of it, or crosses any of the Triangle's sides. Thus, the Triangle is considered "solid".
 *
 * @function Phaser.Geom.Intersects.GetTriangleToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check with.
 * @param {Phaser.Geom.Line} line - The Line to check with.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToLine = function(triangle, line, out) {
                    if (out === undefined) out = [];
                    if (TriangleToLine(triangle, line)) {
                        var lineA = triangle.getLineA();
                        var lineB = triangle.getLineB();
                        var lineC = triangle.getLineC();
                        var output = [
                            new Point(),
                            new Point(),
                            new Point()
                        ];
                        var result = [
                            LineToLine(lineA, line, output[0]),
                            LineToLine(lineB, line, output[1]),
                            LineToLine(lineC, line, output[2])
                        ];
                        for(var i = 0; i < 3; i++)if (result[i]) out.push(output[i]);
                    }
                    return out;
                };
                module1.exports = GetTriangleToLine;
            /***/ },
            /***/ 75636: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TriangleToTriangle = __webpack_require__(82944);
                var GetTriangleToLine = __webpack_require__(13882);
                /**
 * Checks if two Triangles intersect, and returns the intersection points as a Point object array.
 *
 * A Triangle intersects another Triangle if any pair of their lines intersects or if any point of one Triangle is within the other Triangle. Thus, the Triangles are considered "solid".
 *
 * @function Phaser.Geom.Intersects.GetTriangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangleA - The first Triangle to check for intersection.
 * @param {Phaser.Geom.Triangle} triangleB - The second Triangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToTriangle = function(triangleA, triangleB, out) {
                    if (out === undefined) out = [];
                    if (TriangleToTriangle(triangleA, triangleB)) {
                        var lineA = triangleB.getLineA();
                        var lineB = triangleB.getLineB();
                        var lineC = triangleB.getLineC();
                        GetTriangleToLine(triangleA, lineA, out);
                        GetTriangleToLine(triangleA, lineB, out);
                        GetTriangleToLine(triangleA, lineC, out);
                    }
                    return out;
                };
                module1.exports = GetTriangleToTriangle;
            /***/ },
            /***/ 80462: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(87902);
                var Point = __webpack_require__(2141);
                var tmp = new Point();
                /**
 * Checks for intersection between the line segment and circle.
 *
 * Based on code by [Matt DesLauriers](https://github.com/mattdesl/line-circle-collision/blob/master/LICENSE.md).
 *
 * @function Phaser.Geom.Intersects.LineToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Circle} circle - The circle to check against the line.
 * @param {(Phaser.Geom.Point|any)} [nearest] - An optional Point-like object. If given the closest point on the Line where the circle intersects will be stored in this object.
 *
 * @return {boolean} `true` if the two objects intersect, otherwise `false`.
 */ var LineToCircle = function(line, circle, nearest) {
                    if (nearest === undefined) nearest = tmp;
                    if (Contains(circle, line.x1, line.y1)) {
                        nearest.x = line.x1;
                        nearest.y = line.y1;
                        return true;
                    }
                    if (Contains(circle, line.x2, line.y2)) {
                        nearest.x = line.x2;
                        nearest.y = line.y2;
                        return true;
                    }
                    var dx = line.x2 - line.x1;
                    var dy = line.y2 - line.y1;
                    var lcx = circle.x - line.x1;
                    var lcy = circle.y - line.y1;
                    //  project lc onto d, resulting in vector p
                    var dLen2 = dx * dx + dy * dy;
                    var px = dx;
                    var py = dy;
                    if (dLen2 > 0) {
                        var dp = (lcx * dx + lcy * dy) / dLen2;
                        px *= dp;
                        py *= dp;
                    }
                    nearest.x = line.x1 + px;
                    nearest.y = line.y1 + py;
                    //  len2 of p
                    var pLen2 = px * px + py * py;
                    return pLen2 <= dLen2 && px * dx + py * dy >= 0 && Contains(circle, nearest.x, nearest.y);
                };
                module1.exports = LineToCircle;
            /***/ },
            /***/ 76112: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  This is based off an explanation and expanded math presented by Paul Bourke:
                //  See http://paulbourke.net/geometry/pointlineplane/
                /**
 * Checks if two Lines intersect. If the Lines are identical, they will be treated as parallel and thus non-intersecting.
 *
 * @function Phaser.Geom.Intersects.LineToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line1 - The first Line to check.
 * @param {Phaser.Geom.Line} line2 - The second Line to check.
 * @param {Phaser.Types.Math.Vector2Like} [out] - An optional point-like object in which to store the coordinates of intersection, if needed.
 *
 * @return {boolean} `true` if the two Lines intersect, and the `out` object will be populated, if given. Otherwise, `false`.
 */ var LineToLine = function(line1, line2, out) {
                    var x1 = line1.x1;
                    var y1 = line1.y1;
                    var x2 = line1.x2;
                    var y2 = line1.y2;
                    var x3 = line2.x1;
                    var y3 = line2.y1;
                    var x4 = line2.x2;
                    var y4 = line2.y2;
                    //  Check that none of the lines are length zero
                    if (x1 === x2 && y1 === y2 || x3 === x4 && y3 === y4) return false;
                    var denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
                    //  Make sure there is not a division by zero - this also indicates that the lines are parallel.
                    //  If numA and numB were both equal to zero the lines would be on top of each other (coincidental).
                    //  This check is not done because it is not necessary for this implementation (the parallel check accounts for this).
                    if (denom === 0) //  Lines are parallel
                    return false;
                    //  Calculate the intermediate fractional point that the lines potentially intersect.
                    var ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denom;
                    var ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denom;
                    //  The fractional point will be between 0 and 1 inclusive if the lines intersect.
                    //  If the fractional calculation is larger than 1 or smaller than 0 the lines would need to be longer to intersect.
                    if (ua < 0 || ua > 1 || ub < 0 || ub > 1) return false;
                    else {
                        if (out) {
                            out.x = x1 + ua * (x2 - x1);
                            out.y = y1 + ua * (y2 - y1);
                        }
                        return true;
                    }
                };
                module1.exports = LineToLine;
            /***/ },
            /***/ 92773: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between the Line and a Rectangle shape, or a rectangle-like
 * object, with public `x`, `y`, `right` and `bottom` properties, such as a Sprite or Body.
 *
 * An intersection is considered valid if:
 *
 * The line starts within, or ends within, the Rectangle.
 * The line segment intersects one of the 4 rectangle edges.
 *
 * The for the purposes of this function rectangles are considered 'solid'.
 *
 * @function Phaser.Geom.Intersects.LineToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line to check for intersection.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle to check for intersection.
 *
 * @return {boolean} `true` if the Line and the Rectangle intersect, `false` otherwise.
 */ var LineToRectangle = function(line, rect) {
                    var x1 = line.x1;
                    var y1 = line.y1;
                    var x2 = line.x2;
                    var y2 = line.y2;
                    var bx1 = rect.x;
                    var by1 = rect.y;
                    var bx2 = rect.right;
                    var by2 = rect.bottom;
                    var t = 0;
                    //  If the start or end of the line is inside the rect then we assume
                    //  collision, as rects are solid for our use-case.
                    if (x1 >= bx1 && x1 <= bx2 && y1 >= by1 && y1 <= by2 || x2 >= bx1 && x2 <= bx2 && y2 >= by1 && y2 <= by2) return true;
                    if (x1 < bx1 && x2 >= bx1) {
                        //  Left edge
                        t = y1 + (y2 - y1) * (bx1 - x1) / (x2 - x1);
                        if (t > by1 && t <= by2) return true;
                    } else if (x1 > bx2 && x2 <= bx2) {
                        //  Right edge
                        t = y1 + (y2 - y1) * (bx2 - x1) / (x2 - x1);
                        if (t >= by1 && t <= by2) return true;
                    }
                    if (y1 < by1 && y2 >= by1) {
                        //  Top edge
                        t = x1 + (x2 - x1) * (by1 - y1) / (y2 - y1);
                        if (t >= bx1 && t <= bx2) return true;
                    } else if (y1 > by2 && y2 <= by2) {
                        //  Bottom edge
                        t = x1 + (x2 - x1) * (by2 - y1) / (y2 - y1);
                        if (t >= bx1 && t <= bx2) return true;
                    }
                    return false;
                };
                module1.exports = LineToRectangle;
            /***/ },
            /***/ 16204: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Florian Mertens
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the a Point falls between the two end-points of a Line, based on the given line thickness.
 *
 * Assumes that the line end points are circular, not square.
 *
 * @function Phaser.Geom.Intersects.PointToLine
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Point|any)} point - The point, or point-like object to check.
 * @param {Phaser.Geom.Line} line - The line segment to test for intersection on.
 * @param {number} [lineThickness=1] - The line thickness. Assumes that the line end points are circular.
 *
 * @return {boolean} `true` if the Point falls on the Line, otherwise `false`.
 */ var PointToLine = function(point, line, lineThickness) {
                    if (lineThickness === undefined) lineThickness = 1;
                    var x1 = line.x1;
                    var y1 = line.y1;
                    var x2 = line.x2;
                    var y2 = line.y2;
                    var px = point.x;
                    var py = point.y;
                    var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                    if (L2 === 0) return false;
                    var r = ((px - x1) * (x2 - x1) + (py - y1) * (y2 - y1)) / L2;
                    //  Assume line thickness is circular
                    if (r < 0) //  Outside line1
                    return Math.sqrt((x1 - px) * (x1 - px) + (y1 - py) * (y1 - py)) <= lineThickness;
                    else if (r >= 0 && r <= 1) {
                        //  On the line segment
                        var s = ((y1 - py) * (x2 - x1) - (x1 - px) * (y2 - y1)) / L2;
                        return Math.abs(s) * Math.sqrt(L2) <= lineThickness;
                    } else //  Outside line2
                    return Math.sqrt((x2 - px) * (x2 - px) + (y2 - py) * (y2 - py)) <= lineThickness;
                };
                module1.exports = PointToLine;
            /***/ },
            /***/ 14199: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PointToLine = __webpack_require__(16204);
                /**
 * Checks if a Point is located on the given line segment.
 *
 * @function Phaser.Geom.Intersects.PointToLineSegment
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The Point to check for intersection.
 * @param {Phaser.Geom.Line} line - The line segment to check for intersection.
 *
 * @return {boolean} `true` if the Point is on the given line segment, otherwise `false`.
 */ var PointToLineSegment = function(point, line) {
                    if (!PointToLine(point, line)) return false;
                    var xMin = Math.min(line.x1, line.x2);
                    var xMax = Math.max(line.x1, line.x2);
                    var yMin = Math.min(line.y1, line.y2);
                    var yMax = Math.max(line.y1, line.y2);
                    return point.x >= xMin && point.x <= xMax && point.y >= yMin && point.y <= yMax;
                };
                module1.exports = PointToLineSegment;
            /***/ },
            /***/ 59996: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if two Rectangles intersect.
 *
 * A Rectangle intersects another Rectangle if any part of its bounds is within the other Rectangle's bounds.
 * As such, the two Rectangles are considered "solid".
 * A Rectangle with no width or no height will never intersect another Rectangle.
 *
 * @function Phaser.Geom.Intersects.RectangleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check for intersection.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check for intersection.
 *
 * @return {boolean} `true` if the two Rectangles intersect, otherwise `false`.
 */ var RectangleToRectangle = function(rectA, rectB) {
                    if (rectA.width <= 0 || rectA.height <= 0 || rectB.width <= 0 || rectB.height <= 0) return false;
                    return !(rectA.right < rectB.x || rectA.bottom < rectB.y || rectA.x > rectB.right || rectA.y > rectB.bottom);
                };
                module1.exports = RectangleToRectangle;
            /***/ },
            /***/ 89265: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToLine = __webpack_require__(76112);
                var Contains = __webpack_require__(37303);
                var ContainsArray = __webpack_require__(48653);
                var Decompose = __webpack_require__(77493);
                /**
 * Checks for intersection between Rectangle shape and Triangle shape.
 *
 * @function Phaser.Geom.Intersects.RectangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle object to test.
 * @param {Phaser.Geom.Triangle} triangle - Triangle object to test.
 *
 * @return {boolean} A value of `true` if objects intersect; otherwise `false`.
 */ var RectangleToTriangle = function(rect, triangle) {
                    //  First the cheapest ones:
                    if (triangle.left > rect.right || triangle.right < rect.left || triangle.top > rect.bottom || triangle.bottom < rect.top) return false;
                    var triA = triangle.getLineA();
                    var triB = triangle.getLineB();
                    var triC = triangle.getLineC();
                    //  Are any of the triangle points within the rectangle?
                    if (Contains(rect, triA.x1, triA.y1) || Contains(rect, triA.x2, triA.y2)) return true;
                    if (Contains(rect, triB.x1, triB.y1) || Contains(rect, triB.x2, triB.y2)) return true;
                    if (Contains(rect, triC.x1, triC.y1) || Contains(rect, triC.x2, triC.y2)) return true;
                    //  Cheap tests over, now to see if any of the lines intersect ...
                    var rectA = rect.getLineA();
                    var rectB = rect.getLineB();
                    var rectC = rect.getLineC();
                    var rectD = rect.getLineD();
                    if (LineToLine(triA, rectA) || LineToLine(triA, rectB) || LineToLine(triA, rectC) || LineToLine(triA, rectD)) return true;
                    if (LineToLine(triB, rectA) || LineToLine(triB, rectB) || LineToLine(triB, rectC) || LineToLine(triB, rectD)) return true;
                    if (LineToLine(triC, rectA) || LineToLine(triC, rectB) || LineToLine(triC, rectC) || LineToLine(triC, rectD)) return true;
                    //  None of the lines intersect, so are any rectangle points within the triangle?
                    var points = Decompose(rect);
                    var within = ContainsArray(triangle, points, true);
                    return within.length > 0;
                };
                module1.exports = RectangleToTriangle;
            /***/ },
            /***/ 84411: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if rectangle intersects with values.
 *
 * @function Phaser.Geom.Intersects.RectangleToValues
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle object
 * @param {number} left - The x coordinate of the left of the Rectangle.
 * @param {number} right - The x coordinate of the right of the Rectangle.
 * @param {number} top - The y coordinate of the top of the Rectangle.
 * @param {number} bottom - The y coordinate of the bottom of the Rectangle.
 * @param {number} [tolerance=0] - Tolerance allowed in the calculation, expressed in pixels.
 *
 * @return {boolean} Returns true if there is an intersection.
 */ var RectangleToValues = function(rect, left, right, top, bottom, tolerance) {
                    if (tolerance === undefined) tolerance = 0;
                    return !(left > rect.right + tolerance || right < rect.left - tolerance || top > rect.bottom + tolerance || bottom < rect.top - tolerance);
                };
                module1.exports = RectangleToValues;
            /***/ },
            /***/ 67636: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToCircle = __webpack_require__(80462);
                var Contains = __webpack_require__(10690);
                /**
 * Checks if a Triangle and a Circle intersect.
 *
 * A Circle intersects a Triangle if its center is located within it or if any of the Triangle's sides intersect the Circle. As such, the Triangle and the Circle are considered "solid" for the intersection.
 *
 * @function Phaser.Geom.Intersects.TriangleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check for intersection.
 * @param {Phaser.Geom.Circle} circle - The Circle to check for intersection.
 *
 * @return {boolean} `true` if the Triangle and the `Circle` intersect, otherwise `false`.
 */ var TriangleToCircle = function(triangle, circle) {
                    //  First the cheapest ones:
                    if (triangle.left > circle.right || triangle.right < circle.left || triangle.top > circle.bottom || triangle.bottom < circle.top) return false;
                    if (Contains(triangle, circle.x, circle.y)) return true;
                    if (LineToCircle(triangle.getLineA(), circle)) return true;
                    if (LineToCircle(triangle.getLineB(), circle)) return true;
                    if (LineToCircle(triangle.getLineC(), circle)) return true;
                    return false;
                };
                module1.exports = TriangleToCircle;
            /***/ },
            /***/ 2822: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToLine = __webpack_require__(76112);
                /**
 * Checks if a Triangle and a Line intersect.
 *
 * The Line intersects the Triangle if it starts inside of it, ends inside of it, or crosses any of the Triangle's sides. Thus, the Triangle is considered "solid".
 *
 * @function Phaser.Geom.Intersects.TriangleToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check with.
 * @param {Phaser.Geom.Line} line - The Line to check with.
 *
 * @return {boolean} `true` if the Triangle and the Line intersect, otherwise `false`.
 */ var TriangleToLine = function(triangle, line) {
                    //  If the Triangle contains either the start or end point of the line, it intersects
                    if (triangle.contains(line.x1, line.y1) || triangle.contains(line.x2, line.y2)) return true;
                    //  Now check the line against each line of the Triangle
                    if (LineToLine(triangle.getLineA(), line)) return true;
                    if (LineToLine(triangle.getLineB(), line)) return true;
                    if (LineToLine(triangle.getLineC(), line)) return true;
                    return false;
                };
                module1.exports = TriangleToLine;
            /***/ },
            /***/ 82944: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ContainsArray = __webpack_require__(48653);
                var Decompose = __webpack_require__(71694);
                var LineToLine = __webpack_require__(76112);
                /**
 * Checks if two Triangles intersect.
 *
 * A Triangle intersects another Triangle if any pair of their lines intersects or if any point of one Triangle is within the other Triangle. Thus, the Triangles are considered "solid".
 *
 * @function Phaser.Geom.Intersects.TriangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangleA - The first Triangle to check for intersection.
 * @param {Phaser.Geom.Triangle} triangleB - The second Triangle to check for intersection.
 *
 * @return {boolean} `true` if the Triangles intersect, otherwise `false`.
 */ var TriangleToTriangle = function(triangleA, triangleB) {
                    //  First the cheapest ones:
                    if (triangleA.left > triangleB.right || triangleA.right < triangleB.left || triangleA.top > triangleB.bottom || triangleA.bottom < triangleB.top) return false;
                    var lineAA = triangleA.getLineA();
                    var lineAB = triangleA.getLineB();
                    var lineAC = triangleA.getLineC();
                    var lineBA = triangleB.getLineA();
                    var lineBB = triangleB.getLineB();
                    var lineBC = triangleB.getLineC();
                    //  Now check the lines against each line of TriangleB
                    if (LineToLine(lineAA, lineBA) || LineToLine(lineAA, lineBB) || LineToLine(lineAA, lineBC)) return true;
                    if (LineToLine(lineAB, lineBA) || LineToLine(lineAB, lineBB) || LineToLine(lineAB, lineBC)) return true;
                    if (LineToLine(lineAC, lineBA) || LineToLine(lineAC, lineBB) || LineToLine(lineAC, lineBC)) return true;
                    //  Nope, so check to see if any of the points of triangleA are within triangleB
                    var points = Decompose(triangleA);
                    var within = ContainsArray(triangleB, points, true);
                    if (within.length > 0) return true;
                    //  Finally check to see if any of the points of triangleB are within triangleA
                    points = Decompose(triangleB);
                    within = ContainsArray(triangleA, points, true);
                    if (within.length > 0) return true;
                    return false;
                };
                module1.exports = TriangleToTriangle;
            /***/ },
            /***/ 91865: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Geom.Intersects
 */ module1.exports = {
                    CircleToCircle: __webpack_require__(2044),
                    CircleToRectangle: __webpack_require__(81491),
                    GetCircleToCircle: __webpack_require__(63376),
                    GetCircleToRectangle: __webpack_require__(97439),
                    GetLineToCircle: __webpack_require__(4042),
                    GetLineToLine: __webpack_require__(36100),
                    GetLineToPoints: __webpack_require__(3073),
                    GetLineToPolygon: __webpack_require__(56362),
                    GetLineToRectangle: __webpack_require__(60646),
                    GetRaysFromPointToPolygon: __webpack_require__(71147),
                    GetRectangleIntersection: __webpack_require__(68389),
                    GetRectangleToRectangle: __webpack_require__(52784),
                    GetRectangleToTriangle: __webpack_require__(26341),
                    GetTriangleToCircle: __webpack_require__(38720),
                    GetTriangleToLine: __webpack_require__(13882),
                    GetTriangleToTriangle: __webpack_require__(75636),
                    LineToCircle: __webpack_require__(80462),
                    LineToLine: __webpack_require__(76112),
                    LineToRectangle: __webpack_require__(92773),
                    PointToLine: __webpack_require__(16204),
                    PointToLineSegment: __webpack_require__(14199),
                    RectangleToRectangle: __webpack_require__(59996),
                    RectangleToTriangle: __webpack_require__(89265),
                    RectangleToValues: __webpack_require__(84411),
                    TriangleToCircle: __webpack_require__(67636),
                    TriangleToLine: __webpack_require__(2822),
                    TriangleToTriangle: __webpack_require__(82944)
                };
            /***/ },
            /***/ 91938: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the angle of the line in radians.
 *
 * @function Phaser.Geom.Line.Angle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the angle of.
 *
 * @return {number} The angle of the line, in radians.
 */ var Angle = function(line) {
                    return Math.atan2(line.y2 - line.y1, line.x2 - line.x1);
                };
                module1.exports = Angle;
            /***/ },
            /***/ 84993: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Using Bresenham's line algorithm this will return an array of all coordinates on this line.
 *
 * The `start` and `end` points are rounded before this runs as the algorithm works on integers.
 *
 * @function Phaser.Geom.Line.BresenhamPoints
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} [stepRate=1] - The optional step rate for the points on the line.
 * @param {Phaser.Types.Math.Vector2Like[]} [results] - An optional array to push the resulting coordinates into.
 *
 * @return {Phaser.Types.Math.Vector2Like[]} The array of coordinates on the line.
 */ var BresenhamPoints = function(line, stepRate, results) {
                    if (stepRate === undefined) stepRate = 1;
                    if (results === undefined) results = [];
                    var x1 = Math.round(line.x1);
                    var y1 = Math.round(line.y1);
                    var x2 = Math.round(line.x2);
                    var y2 = Math.round(line.y2);
                    var dx = Math.abs(x2 - x1);
                    var dy = Math.abs(y2 - y1);
                    var sx = x1 < x2 ? 1 : -1;
                    var sy = y1 < y2 ? 1 : -1;
                    var err = dx - dy;
                    results.push({
                        x: x1,
                        y: y1
                    });
                    var i = 1;
                    while(!(x1 === x2 && y1 === y2)){
                        var e2 = err << 1;
                        if (e2 > -dy) {
                            err -= dy;
                            x1 += sx;
                        }
                        if (e2 < dx) {
                            err += dx;
                            y1 += sy;
                        }
                        if (i % stepRate === 0) results.push({
                            x: x1,
                            y: y1
                        });
                        i++;
                    }
                    return results;
                };
                module1.exports = BresenhamPoints;
            /***/ },
            /***/ 36469: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Center a line on the given coordinates.
 *
 * @function Phaser.Geom.Line.CenterOn
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to center.
 * @param {number} x - The horizontal coordinate to center the line on.
 * @param {number} y - The vertical coordinate to center the line on.
 *
 * @return {Phaser.Geom.Line} The centered line.
 */ var CenterOn = function(line, x, y) {
                    var tx = x - (line.x1 + line.x2) / 2;
                    var ty = y - (line.y1 + line.y2) / 2;
                    line.x1 += tx;
                    line.y1 += ty;
                    line.x2 += tx;
                    line.y2 += ty;
                    return line;
                };
                module1.exports = CenterOn;
            /***/ },
            /***/ 31116: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Line = __webpack_require__(23031);
                /**
 * Clone the given line.
 *
 * @function Phaser.Geom.Line.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} source - The source line to clone.
 *
 * @return {Phaser.Geom.Line} The cloned line.
 */ var Clone = function(source) {
                    return new Line(source.x1, source.y1, source.x2, source.y2);
                };
                module1.exports = Clone;
            /***/ },
            /***/ 59944: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one line to a destination line.
 *
 * @function Phaser.Geom.Line.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [dest,$return]
 *
 * @param {Phaser.Geom.Line} source - The source line to copy the values from.
 * @param {Phaser.Geom.Line} dest - The destination line to copy the values to.
 *
 * @return {Phaser.Geom.Line} The destination line.
 */ var CopyFrom = function(source, dest) {
                    return dest.setTo(source.x1, source.y1, source.x2, source.y2);
                };
                module1.exports = CopyFrom;
            /***/ },
            /***/ 59220: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compare two lines for strict equality.
 *
 * @function Phaser.Geom.Line.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The first line to compare.
 * @param {Phaser.Geom.Line} toCompare - The second line to compare.
 *
 * @return {boolean} Whether the two lines are equal.
 */ var Equals = function(line, toCompare) {
                    return line.x1 === toCompare.x1 && line.y1 === toCompare.y1 && line.x2 === toCompare.x2 && line.y2 === toCompare.y2;
                };
                module1.exports = Equals;
            /***/ },
            /***/ 78177: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(35001);
                /**
 * Extends the start and end points of a Line by the given amounts.
 *
 * The amounts can be positive or negative. Positive points will increase the length of the line,
 * while negative ones will decrease it.
 *
 * If no `right` value is provided it will extend the length of the line equally in both directions.
 *
 * Pass a value of zero to leave the start or end point unchanged.
 *
 * @function Phaser.Geom.Line.Extend
 * @since 3.16.0
 *
 * @param {Phaser.Geom.Line} line - The line instance to extend.
 * @param {number} left - The amount to extend the start of the line by.
 * @param {number} [right] - The amount to extend the end of the line by. If not given it will be set to the `left` value.
 *
 * @return {Phaser.Geom.Line} The modified Line instance.
 */ var Extend = function(line, left, right) {
                    if (right === undefined) right = left;
                    var length = Length(line);
                    var slopX = line.x2 - line.x1;
                    var slopY = line.y2 - line.y1;
                    if (left) {
                        line.x1 = line.x1 - slopX / length * left;
                        line.y1 = line.y1 - slopY / length * left;
                    }
                    if (right) {
                        line.x2 = line.x2 + slopX / length * right;
                        line.y2 = line.y2 + slopY / length * right;
                    }
                    return line;
                };
                module1.exports = Extend;
            /***/ },
            /***/ 26708: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DistanceBetweenPoints = __webpack_require__(52816);
                var GetEaseFunction = __webpack_require__(6113);
                var Point = __webpack_require__(2141);
                /**
 * Returns an array of `quantity` Points where each point is taken from the given Line,
 * spaced out according to the ease function specified.
 * 
 * ```javascript
 * const line = new Phaser.Geom.Line(100, 300, 700, 300);
 * const points = Phaser.Geom.Line.GetEasedPoints(line, 'sine.out', 32)
 * ```
 * 
 * In the above example, the `points` array will contain 32 points spread-out across
 * the length of `line`, where the position of each point is determined by the `Sine.out`
 * ease function.
 * 
 * You can optionally provide a collinear threshold. In this case, the resulting points
 * are checked against each other, and if they are `< collinearThreshold` distance apart,
 * they are dropped from the results. This can help avoid lots of clustered points at
 * far ends of the line with tightly-packed eases such as Quartic. Leave the value set
 * to zero to skip this check.
 * 
 * Note that if you provide a collinear threshold, the resulting array may not always
 * contain `quantity` points.
 *
 * @function Phaser.Geom.Line.GetEasedPoints
 * @since 3.23.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The Line object.
 * @param {(string|function)} ease - The ease to use. This can be either a string from the EaseMap, or a custom function.
 * @param {number} quantity - The number of points to return. Note that if you provide a `collinearThreshold`, the resulting array may not always contain this number of points.
 * @param {number} [collinearThreshold=0] - An optional threshold. The final array is reduced so that each point is spaced out at least this distance apart. This helps reduce clustering in noisey eases.
 * @param {number[]} [easeParams] - An optional array of ease parameters to go with the ease.
 *
 * @return {Phaser.Geom.Point[]} An array of Geom.Points containing the coordinates of the points on the line.
 */ var GetEasedPoints = function(line, ease, quantity, collinearThreshold, easeParams) {
                    if (collinearThreshold === undefined) collinearThreshold = 0;
                    if (easeParams === undefined) easeParams = [];
                    var results = [];
                    var x1 = line.x1;
                    var y1 = line.y1;
                    var spaceX = line.x2 - x1;
                    var spaceY = line.y2 - y1;
                    var easeFunc = GetEaseFunction(ease, easeParams);
                    var i;
                    var v;
                    var q = quantity - 1;
                    for(i = 0; i < q; i++){
                        v = easeFunc(i / q);
                        results.push(new Point(x1 + spaceX * v, y1 + spaceY * v));
                    }
                    //  Always include the end of the line
                    v = easeFunc(1);
                    results.push(new Point(x1 + spaceX * v, y1 + spaceY * v));
                    //  Remove collinear parts
                    if (collinearThreshold > 0) {
                        var prevPoint = results[0];
                        //  Store the new results here
                        var sortedResults = [
                            prevPoint
                        ];
                        for(i = 1; i < results.length - 1; i++){
                            var point = results[i];
                            if (DistanceBetweenPoints(prevPoint, point) >= collinearThreshold) {
                                sortedResults.push(point);
                                prevPoint = point;
                            }
                        }
                        //  Top and tail
                        var endPoint = results[results.length - 1];
                        if (DistanceBetweenPoints(prevPoint, endPoint) < collinearThreshold) sortedResults.pop();
                        sortedResults.push(endPoint);
                        return sortedResults;
                    } else return results;
                };
                module1.exports = GetEasedPoints;
            /***/ },
            /***/ 32125: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Get the midpoint of the given line.
 *
 * @function Phaser.Geom.Line.GetMidPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the midpoint of.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point object to store the midpoint in.
 *
 * @return {(Phaser.Geom.Point|object)} The midpoint of the Line.
 */ var GetMidPoint = function(line, out) {
                    if (out === undefined) out = new Point();
                    out.x = (line.x1 + line.x2) / 2;
                    out.y = (line.y1 + line.y2) / 2;
                    return out;
                };
                module1.exports = GetMidPoint;
            /***/ },
            /***/ 99569: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Florian Mertens
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Get the nearest point on a line perpendicular to the given point.
 *
 * @function Phaser.Geom.Line.GetNearestPoint
 * @since 3.16.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the nearest point on.
 * @param {(Phaser.Geom.Point|object)} point - The point to get the nearest point to.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point, or point-like object, to store the coordinates of the nearest point on the line.
 *
 * @return {(Phaser.Geom.Point|object)} The nearest point on the line.
 */ var GetNearestPoint = function(line, point, out) {
                    if (out === undefined) out = new Point();
                    var x1 = line.x1;
                    var y1 = line.y1;
                    var x2 = line.x2;
                    var y2 = line.y2;
                    var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                    if (L2 === 0) return out;
                    var r = ((point.x - x1) * (x2 - x1) + (point.y - y1) * (y2 - y1)) / L2;
                    out.x = x1 + r * (x2 - x1);
                    out.y = y1 + r * (y2 - y1);
                    return out;
                };
                module1.exports = GetNearestPoint;
            /***/ },
            /***/ 34638: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(36383);
                var Angle = __webpack_require__(91938);
                var Point = __webpack_require__(2141);
                /**
 * Calculate the normal of the given line.
 *
 * The normal of a line is a vector that points perpendicular from it.
 *
 * @function Phaser.Geom.Line.GetNormal
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the normal of.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point object to store the normal in.
 *
 * @return {(Phaser.Geom.Point|object)} The normal of the Line.
 */ var GetNormal = function(line, out) {
                    if (out === undefined) out = new Point();
                    var a = Angle(line) - MATH_CONST.TAU;
                    out.x = Math.cos(a);
                    out.y = Math.sin(a);
                    return out;
                };
                module1.exports = GetNormal;
            /***/ },
            /***/ 13151: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Get a point on a line that's a given percentage along its length.
 *
 * @function Phaser.Geom.Line.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} position - A value between 0 and 1, where 0 is the start, 0.5 is the middle and 1 is the end of the line.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point, or point-like object, to store the coordinates of the point on the line.
 *
 * @return {(Phaser.Geom.Point|object)} The point on the line.
 */ var GetPoint = function(line, position, out) {
                    if (out === undefined) out = new Point();
                    out.x = line.x1 + (line.x2 - line.x1) * position;
                    out.y = line.y1 + (line.y2 - line.y1) * position;
                    return out;
                };
                module1.exports = GetPoint;
            /***/ },
            /***/ 15258: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(35001);
                var Point = __webpack_require__(2141);
                /**
 * Get a number of points along a line's length.
 *
 * Provide a `quantity` to get an exact number of points along the line.
 *
 * Provide a `stepRate` to ensure a specific distance between each point on the line. Set `quantity` to `0` when
 * providing a `stepRate`.
 *
 * See also `GetEasedPoints` for a way to distribute the points across the line according to an ease type or input function.
 *
 * @function Phaser.Geom.Line.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} quantity - The number of points to place on the line. Set to `0` to use `stepRate` instead.
 * @param {number} [stepRate] - The distance between each point on the line. When set, `quantity` is implied and should be set to `0`.
 * @param {(array|Phaser.Geom.Point[])} [out] - An optional array of Points, or point-like objects, to store the coordinates of the points on the line.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Points, or point-like objects, containing the coordinates of the points on the line.
 */ var GetPoints = function(line, quantity, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!quantity && stepRate > 0) quantity = Length(line) / stepRate;
                    var x1 = line.x1;
                    var y1 = line.y1;
                    var x2 = line.x2;
                    var y2 = line.y2;
                    for(var i = 0; i < quantity; i++){
                        var position = i / quantity;
                        var x = x1 + (x2 - x1) * position;
                        var y = y1 + (y2 - y1) * position;
                        out.push(new Point(x, y));
                    }
                    return out;
                };
                module1.exports = GetPoints;
            /***/ },
            /***/ 26408: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Florian Mertens
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Get the shortest distance from a Line to the given Point.
 *
 * @function Phaser.Geom.Line.GetShortestDistance
 * @since 3.16.0
 *
 * @param {Phaser.Geom.Line} line - The line to get the distance from.
 * @param {Phaser.Types.Math.Vector2Like} point - The point to get the shortest distance to.
 *
 * @return {(boolean|number)} The shortest distance from the line to the point, or `false`.
 */ var GetShortestDistance = function(line, point) {
                    var x1 = line.x1;
                    var y1 = line.y1;
                    var x2 = line.x2;
                    var y2 = line.y2;
                    var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                    if (L2 === 0) return false;
                    var s = ((y1 - point.y) * (x2 - x1) - (x1 - point.x) * (y2 - y1)) / L2;
                    return Math.abs(s) * Math.sqrt(L2);
                };
                module1.exports = GetShortestDistance;
            /***/ },
            /***/ 98770: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the height of the given line.
 *
 * @function Phaser.Geom.Line.Height
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the height of.
 *
 * @return {number} The height of the line.
 */ var Height = function(line) {
                    return Math.abs(line.y1 - line.y2);
                };
                module1.exports = Height;
            /***/ },
            /***/ 35001: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the length of the given line.
 *
 * @function Phaser.Geom.Line.Length
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the length of.
 *
 * @return {number} The length of the line.
 */ var Length = function(line) {
                    return Math.sqrt((line.x2 - line.x1) * (line.x2 - line.x1) + (line.y2 - line.y1) * (line.y2 - line.y1));
                };
                module1.exports = Length;
            /***/ },
            /***/ 23031: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetPoint = __webpack_require__(13151);
                var GetPoints = __webpack_require__(15258);
                var GEOM_CONST = __webpack_require__(23777);
                var Random = __webpack_require__(65822);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * Defines a Line segment, a part of a line between two endpoints.
 *
 * @class Line
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x1=0] - The x coordinate of the lines starting point.
 * @param {number} [y1=0] - The y coordinate of the lines starting point.
 * @param {number} [x2=0] - The x coordinate of the lines ending point.
 * @param {number} [y2=0] - The y coordinate of the lines ending point.
 */ var Line = new Class({
                    initialize: function Line(x1, y1, x2, y2) {
                        if (x1 === undefined) x1 = 0;
                        if (y1 === undefined) y1 = 0;
                        if (x2 === undefined) x2 = 0;
                        if (y2 === undefined) y2 = 0;
                        /**
         * The geometry constant type of this object: `GEOM_CONST.LINE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Line#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.LINE;
                        /**
         * The x coordinate of the lines starting point.
         *
         * @name Phaser.Geom.Line#x1
         * @type {number}
         * @since 3.0.0
         */ this.x1 = x1;
                        /**
         * The y coordinate of the lines starting point.
         *
         * @name Phaser.Geom.Line#y1
         * @type {number}
         * @since 3.0.0
         */ this.y1 = y1;
                        /**
         * The x coordinate of the lines ending point.
         *
         * @name Phaser.Geom.Line#x2
         * @type {number}
         * @since 3.0.0
         */ this.x2 = x2;
                        /**
         * The y coordinate of the lines ending point.
         *
         * @name Phaser.Geom.Line#y2
         * @type {number}
         * @since 3.0.0
         */ this.y2 = y2;
                    },
                    /**
     * Get a point on a line that's a given percentage along its length.
     *
     * @method Phaser.Geom.Line#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 is the start, 0.5 is the middle and 1 is the end of the line.
     * @param {(Phaser.Geom.Point|object)} [output] - An optional point, or point-like object, to store the coordinates of the point on the line.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point on the line.
     */ getPoint: function(position, output) {
                        return GetPoint(this, position, output);
                    },
                    /**
     * Get a number of points along a line's length.
     *
     * Provide a `quantity` to get an exact number of points along the line.
     *
     * Provide a `stepRate` to ensure a specific distance between each point on the line. Set `quantity` to `0` when
     * providing a `stepRate`.
     *
     * @method Phaser.Geom.Line#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The number of points to place on the line. Set to `0` to use `stepRate` instead.
     * @param {number} [stepRate] - The distance between each point on the line. When set, `quantity` is implied and should be set to `0`.
     * @param {(array|Phaser.Geom.Point[])} [output] - An optional array of Points, or point-like objects, to store the coordinates of the points on the line.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Points, or point-like objects, containing the coordinates of the points on the line.
     */ getPoints: function(quantity, stepRate, output) {
                        return GetPoints(this, quantity, stepRate, output);
                    },
                    /**
     * Get a random Point on the Line.
     *
     * @method Phaser.Geom.Line#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - An instance of a Point to be modified.
     *
     * @return {Phaser.Geom.Point} A random Point on the Line.
     */ getRandomPoint: function(point) {
                        return Random(this, point);
                    },
                    /**
     * Set new coordinates for the line endpoints.
     *
     * @method Phaser.Geom.Line#setTo
     * @since 3.0.0
     *
     * @param {number} [x1=0] - The x coordinate of the lines starting point.
     * @param {number} [y1=0] - The y coordinate of the lines starting point.
     * @param {number} [x2=0] - The x coordinate of the lines ending point.
     * @param {number} [y2=0] - The y coordinate of the lines ending point.
     *
     * @return {this} This Line object.
     */ setTo: function(x1, y1, x2, y2) {
                        if (x1 === undefined) x1 = 0;
                        if (y1 === undefined) y1 = 0;
                        if (x2 === undefined) x2 = 0;
                        if (y2 === undefined) y2 = 0;
                        this.x1 = x1;
                        this.y1 = y1;
                        this.x2 = x2;
                        this.y2 = y2;
                        return this;
                    },
                    /**
     * Sets this Line to match the x/y coordinates of the two given Vector2Like objects.
     *
     * @method Phaser.Geom.Line#setFromObjects
     * @since 3.70.0
     *
     * @param {Phaser.Types.Math.Vector2Like} start - Any object with public `x` and `y` properties, whose values will be assigned to the x1/y1 components of this Line.
     * @param {Phaser.Types.Math.Vector2Like} end - Any object with public `x` and `y` properties, whose values will be assigned to the x2/y2 components of this Line.
     *
     * @return {this} This Line object.
     */ setFromObjects: function(start, end) {
                        this.x1 = start.x;
                        this.y1 = start.y;
                        this.x2 = end.x;
                        this.y2 = end.y;
                        return this;
                    },
                    /**
     * Returns a Vector2 object that corresponds to the start of this Line.
     *
     * @method Phaser.Geom.Line#getPointA
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
     *
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the start of this Line.
     */ getPointA: function(vec2) {
                        if (vec2 === undefined) vec2 = new Vector2();
                        vec2.set(this.x1, this.y1);
                        return vec2;
                    },
                    /**
     * Returns a Vector2 object that corresponds to the end of this Line.
     *
     * @method Phaser.Geom.Line#getPointB
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
     *
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the end of this Line.
     */ getPointB: function(vec2) {
                        if (vec2 === undefined) vec2 = new Vector2();
                        vec2.set(this.x2, this.y2);
                        return vec2;
                    },
                    /**
     * The left position of the Line.
     *
     * @name Phaser.Geom.Line#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                        get: function() {
                            return Math.min(this.x1, this.x2);
                        },
                        set: function(value) {
                            if (this.x1 <= this.x2) this.x1 = value;
                            else this.x2 = value;
                        }
                    },
                    /**
     * The right position of the Line.
     *
     * @name Phaser.Geom.Line#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                        get: function() {
                            return Math.max(this.x1, this.x2);
                        },
                        set: function(value) {
                            if (this.x1 > this.x2) this.x1 = value;
                            else this.x2 = value;
                        }
                    },
                    /**
     * The top position of the Line.
     *
     * @name Phaser.Geom.Line#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                        get: function() {
                            return Math.min(this.y1, this.y2);
                        },
                        set: function(value) {
                            if (this.y1 <= this.y2) this.y1 = value;
                            else this.y2 = value;
                        }
                    },
                    /**
     * The bottom position of the Line.
     *
     * @name Phaser.Geom.Line#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                        get: function() {
                            return Math.max(this.y1, this.y2);
                        },
                        set: function(value) {
                            if (this.y1 > this.y2) this.y1 = value;
                            else this.y2 = value;
                        }
                    }
                });
                module1.exports = Line;
            /***/ },
            /***/ 64795: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(36383);
                var Wrap = __webpack_require__(15994);
                var Angle = __webpack_require__(91938);
                /**
 * Get the angle of the normal of the given line in radians.
 *
 * @function Phaser.Geom.Line.NormalAngle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the angle of the normal of.
 *
 * @return {number} The angle of the normal of the line in radians.
 */ var NormalAngle = function(line) {
                    var angle = Angle(line) - MATH_CONST.TAU;
                    return Wrap(angle, -Math.PI, Math.PI);
                };
                module1.exports = NormalAngle;
            /***/ },
            /***/ 52616: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(36383);
                var Angle = __webpack_require__(91938);
                /**
 * Returns the x component of the normal vector of the given line.
 *
 * @function Phaser.Geom.Line.NormalX
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line object to get the normal value from.
 *
 * @return {number} The x component of the normal vector of the line.
 */ var NormalX = function(line) {
                    return Math.cos(Angle(line) - MATH_CONST.TAU);
                };
                module1.exports = NormalX;
            /***/ },
            /***/ 87231: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(36383);
                var Angle = __webpack_require__(91938);
                /**
 * The Y value of the normal of the given line.
 * The normal of a line is a vector that points perpendicular from it.
 *
 * @function Phaser.Geom.Line.NormalY
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the normal of.
 *
 * @return {number} The Y value of the normal of the Line.
 */ var NormalY = function(line) {
                    return Math.sin(Angle(line) - MATH_CONST.TAU);
                };
                module1.exports = NormalY;
            /***/ },
            /***/ 89662: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offset a line by the given amount.
 *
 * @function Phaser.Geom.Line.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to offset.
 * @param {number} x - The horizontal offset to add to the line.
 * @param {number} y - The vertical offset to add to the line.
 *
 * @return {Phaser.Geom.Line} The offset line.
 */ var Offset = function(line, x, y) {
                    line.x1 += x;
                    line.y1 += y;
                    line.x2 += x;
                    line.y2 += y;
                    return line;
                };
                module1.exports = Offset;
            /***/ },
            /***/ 71165: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the perpendicular slope of the given line.
 *
 * @function Phaser.Geom.Line.PerpSlope
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the perpendicular slope of.
 *
 * @return {number} The perpendicular slope of the line.
 */ var PerpSlope = function(line) {
                    return -((line.x2 - line.x1) / (line.y2 - line.y1));
                };
                module1.exports = PerpSlope;
            /***/ },
            /***/ 65822: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns a random point on a given Line.
 *
 * @function Phaser.Geom.Line.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The Line to calculate the random Point on.
 * @param {(Phaser.Geom.Point|object)} [out] - An instance of a Point to be modified.
 *
 * @return {(Phaser.Geom.Point|object)} A random Point on the Line.
 */ var Random = function(line, out) {
                    if (out === undefined) out = new Point();
                    var t = Math.random();
                    out.x = line.x1 + t * (line.x2 - line.x1);
                    out.y = line.y1 + t * (line.y2 - line.y1);
                    return out;
                };
                module1.exports = Random;
            /***/ },
            /***/ 69777: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Angle = __webpack_require__(91938);
                var NormalAngle = __webpack_require__(64795);
                /**
 * Calculate the reflected angle between two lines.
 *
 * This is the outgoing angle based on the angle of Line 1 and the normalAngle of Line 2.
 *
 * @function Phaser.Geom.Line.ReflectAngle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} lineA - The first line.
 * @param {Phaser.Geom.Line} lineB - The second line.
 *
 * @return {number} The reflected angle between each line.
 */ var ReflectAngle = function(lineA, lineB) {
                    return 2 * NormalAngle(lineB) - Math.PI - Angle(lineA);
                };
                module1.exports = ReflectAngle;
            /***/ },
            /***/ 39706: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(64400);
                /**
 * Rotate a line around its midpoint by the given angle in radians.
 *
 * @function Phaser.Geom.Line.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var Rotate = function(line, angle) {
                    var x = (line.x1 + line.x2) / 2;
                    var y = (line.y1 + line.y2) / 2;
                    return RotateAroundXY(line, x, y, angle);
                };
                module1.exports = Rotate;
            /***/ },
            /***/ 82585: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(64400);
                /**
 * Rotate a line around a point by the given angle in radians.
 *
 * @function Phaser.Geom.Line.RotateAroundPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {(Phaser.Geom.Point|object)} point - The point to rotate the line around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var RotateAroundPoint = function(line, point, angle) {
                    return RotateAroundXY(line, point.x, point.y, angle);
                };
                module1.exports = RotateAroundPoint;
            /***/ },
            /***/ 64400: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a line around the given coordinates by the given angle in radians.
 *
 * @function Phaser.Geom.Line.RotateAroundXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {number} x - The horizontal coordinate to rotate the line around.
 * @param {number} y - The vertical coordinate to rotate the line around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var RotateAroundXY = function(line, x, y, angle) {
                    var c = Math.cos(angle);
                    var s = Math.sin(angle);
                    var tx = line.x1 - x;
                    var ty = line.y1 - y;
                    line.x1 = tx * c - ty * s + x;
                    line.y1 = tx * s + ty * c + y;
                    tx = line.x2 - x;
                    ty = line.y2 - y;
                    line.x2 = tx * c - ty * s + x;
                    line.y2 = tx * s + ty * c + y;
                    return line;
                };
                module1.exports = RotateAroundXY;
            /***/ },
            /***/ 62377: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Set a line to a given position, angle and length.
 *
 * @function Phaser.Geom.Line.SetToAngle
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to set.
 * @param {number} x - The horizontal start position of the line.
 * @param {number} y - The vertical start position of the line.
 * @param {number} angle - The angle of the line in radians.
 * @param {number} length - The length of the line.
 *
 * @return {Phaser.Geom.Line} The updated line.
 */ var SetToAngle = function(line, x, y, angle, length) {
                    line.x1 = x;
                    line.y1 = y;
                    line.x2 = x + Math.cos(angle) * length;
                    line.y2 = y + Math.sin(angle) * length;
                    return line;
                };
                module1.exports = SetToAngle;
            /***/ },
            /***/ 71366: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the slope of the given line.
 *
 * @function Phaser.Geom.Line.Slope
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the slope of.
 *
 * @return {number} The slope of the line.
 */ var Slope = function(line) {
                    return (line.y2 - line.y1) / (line.x2 - line.x1);
                };
                module1.exports = Slope;
            /***/ },
            /***/ 10809: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the width of the given line.
 *
 * @function Phaser.Geom.Line.Width
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the width of.
 *
 * @return {number} The width of the line.
 */ var Width = function(line) {
                    return Math.abs(line.x1 - line.x2);
                };
                module1.exports = Width;
            /***/ },
            /***/ 2529: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Line = __webpack_require__(23031);
                Line.Angle = __webpack_require__(91938);
                Line.BresenhamPoints = __webpack_require__(84993);
                Line.CenterOn = __webpack_require__(36469);
                Line.Clone = __webpack_require__(31116);
                Line.CopyFrom = __webpack_require__(59944);
                Line.Equals = __webpack_require__(59220);
                Line.Extend = __webpack_require__(78177);
                Line.GetEasedPoints = __webpack_require__(26708);
                Line.GetMidPoint = __webpack_require__(32125);
                Line.GetNearestPoint = __webpack_require__(99569);
                Line.GetNormal = __webpack_require__(34638);
                Line.GetPoint = __webpack_require__(13151);
                Line.GetPoints = __webpack_require__(15258);
                Line.GetShortestDistance = __webpack_require__(26408);
                Line.Height = __webpack_require__(98770);
                Line.Length = __webpack_require__(35001);
                Line.NormalAngle = __webpack_require__(64795);
                Line.NormalX = __webpack_require__(52616);
                Line.NormalY = __webpack_require__(87231);
                Line.Offset = __webpack_require__(89662);
                Line.PerpSlope = __webpack_require__(71165);
                Line.Random = __webpack_require__(65822);
                Line.ReflectAngle = __webpack_require__(69777);
                Line.Rotate = __webpack_require__(39706);
                Line.RotateAroundPoint = __webpack_require__(82585);
                Line.RotateAroundXY = __webpack_require__(64400);
                Line.SetToAngle = __webpack_require__(62377);
                Line.Slope = __webpack_require__(71366);
                Line.Width = __webpack_require__(10809);
                module1.exports = Line;
            /***/ },
            /***/ 83997: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Rectangle = __webpack_require__(87841);
                var Vector2 = __webpack_require__(26099);
                /**
 * Returns the length of the line.
 *
 * @ignore
 * @private
 *
 * @param {number} x1 - The x1 coordinate.
 * @param {number} y1 - The y1 coordinate.
 * @param {number} x2 - The x2 coordinate.
 * @param {number} y2 - The y2 coordinate.
 *
 * @return {number} The length of the line.
 */ function GetLength(x1, y1, x2, y2) {
                    var x = x1 - x2;
                    var y = y1 - y2;
                    var magnitude = x * x + y * y;
                    return Math.sqrt(magnitude);
                }
                /**
 * @classdesc
 * A Face Geometry Object.
 *
 * A Face is used by the Mesh Game Object. A Mesh consists of one, or more, faces that are
 * used to render the Mesh Game Objects in WebGL.
 *
 * A Face consists of 3 Vertex instances, for the 3 corners of the face and methods to help
 * you modify and test them.
 *
 * @class Face
 * @memberof Phaser.Geom.Mesh
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Mesh.Vertex} vertex1 - The first vertex of the Face.
 * @param {Phaser.Geom.Mesh.Vertex} vertex2 - The second vertex of the Face.
 * @param {Phaser.Geom.Mesh.Vertex} vertex3 - The third vertex of the Face.
 */ var Face = new Class({
                    initialize: function Face(vertex1, vertex2, vertex3) {
                        /**
         * The first vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex1
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex1 = vertex1;
                        /**
         * The second vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex2
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex2 = vertex2;
                        /**
         * The third vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex3
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex3 = vertex3;
                        /**
         * The bounds of this Face.
         *
         * Be sure to call the `Face.updateBounds` method _before_ using this property.
         *
         * @name Phaser.Geom.Mesh.Face#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.50.0
         */ this.bounds = new Rectangle();
                        /**
         * The face inCenter. Do not access directly, instead use the `getInCenter` method.
         *
         * @name Phaser.Geom.Mesh.Face#_inCenter
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.50.0
         */ this._inCenter = new Vector2();
                    },
                    /**
     * Calculates and returns the in-center position of this Face.
     *
     * @method Phaser.Geom.Mesh.Face#getInCenter
     * @since 3.50.0
     *
     * @param {boolean} [local=true] Return the in center from the un-transformed vertex positions (`true`), or transformed? (`false`)
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the in center position of this Face.
     */ getInCenter: function(local) {
                        if (local === undefined) local = true;
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        var v1x;
                        var v1y;
                        var v2x;
                        var v2y;
                        var v3x;
                        var v3y;
                        if (local) {
                            v1x = v1.x;
                            v1y = v1.y;
                            v2x = v2.x;
                            v2y = v2.y;
                            v3x = v3.x;
                            v3y = v3.y;
                        } else {
                            v1x = v1.vx;
                            v1y = v1.vy;
                            v2x = v2.vx;
                            v2y = v2.vy;
                            v3x = v3.vx;
                            v3y = v3.vy;
                        }
                        var d1 = GetLength(v3x, v3y, v2x, v2y);
                        var d2 = GetLength(v1x, v1y, v3x, v3y);
                        var d3 = GetLength(v2x, v2y, v1x, v1y);
                        var p = d1 + d2 + d3;
                        return this._inCenter.set((v1x * d1 + v2x * d2 + v3x * d3) / p, (v1y * d1 + v2y * d2 + v3y * d3) / p);
                    },
                    /**
     * Checks if the given coordinates are within this Face.
     *
     * You can optionally provide a transform matrix. If given, the Face vertices
     * will be transformed first, before being checked against the coordinates.
     *
     * @method Phaser.Geom.Mesh.Face#contains
     * @since 3.50.0
     *
     * @param {number} x - The horizontal position to check.
     * @param {number} y - The vertical position to check.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [calcMatrix] - Optional transform matrix to apply to the vertices before comparison.
     *
     * @return {boolean} `true` if the coordinates lay within this Face, otherwise `false`.
     */ contains: function(x, y, calcMatrix) {
                        var vertex1 = this.vertex1;
                        var vertex2 = this.vertex2;
                        var vertex3 = this.vertex3;
                        var v1x = vertex1.vx;
                        var v1y = vertex1.vy;
                        var v2x = vertex2.vx;
                        var v2y = vertex2.vy;
                        var v3x = vertex3.vx;
                        var v3y = vertex3.vy;
                        if (calcMatrix) {
                            var a = calcMatrix.a;
                            var b = calcMatrix.b;
                            var c = calcMatrix.c;
                            var d = calcMatrix.d;
                            var e = calcMatrix.e;
                            var f = calcMatrix.f;
                            v1x = vertex1.vx * a + vertex1.vy * c + e;
                            v1y = vertex1.vx * b + vertex1.vy * d + f;
                            v2x = vertex2.vx * a + vertex2.vy * c + e;
                            v2y = vertex2.vx * b + vertex2.vy * d + f;
                            v3x = vertex3.vx * a + vertex3.vy * c + e;
                            v3y = vertex3.vx * b + vertex3.vy * d + f;
                        }
                        var t0x = v3x - v1x;
                        var t0y = v3y - v1y;
                        var t1x = v2x - v1x;
                        var t1y = v2y - v1y;
                        var t2x = x - v1x;
                        var t2y = y - v1y;
                        var dot00 = t0x * t0x + t0y * t0y;
                        var dot01 = t0x * t1x + t0y * t1y;
                        var dot02 = t0x * t2x + t0y * t2y;
                        var dot11 = t1x * t1x + t1y * t1y;
                        var dot12 = t1x * t2x + t1y * t2y;
                        //  Compute barycentric coordinates
                        var bc = dot00 * dot11 - dot01 * dot01;
                        var inv = bc === 0 ? 0 : 1 / bc;
                        var u = (dot11 * dot02 - dot01 * dot12) * inv;
                        var v = (dot00 * dot12 - dot01 * dot02) * inv;
                        return u >= 0 && v >= 0 && u + v < 1;
                    },
                    /**
     * Checks if the vertices in this Face are orientated counter-clockwise, or not.
     *
     * It checks the transformed position of the vertices, not the local one.
     *
     * @method Phaser.Geom.Mesh.Face#isCounterClockwise
     * @since 3.50.0
     *
     * @param {number} z - The z-axis value to test against. Typically the `Mesh.modelPosition.z`.
     *
     * @return {boolean} `true` if the vertices in this Face run counter-clockwise, otherwise `false`.
     */ isCounterClockwise: function(z) {
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        var d = (v2.vx - v1.vx) * (v3.vy - v1.vy) - (v2.vy - v1.vy) * (v3.vx - v1.vx);
                        return z <= 0 ? d >= 0 : d < 0;
                    },
                    /**
     * Loads the data from this Vertex into the given Typed Arrays.
     *
     * @method Phaser.Geom.Mesh.Face#load
     * @since 3.50.0
     *
     * @param {Float32Array} F32 - A Float32 Array to insert the position, UV and unit data in to.
     * @param {Uint32Array} U32 - A Uint32 Array to insert the color and alpha data in to.
     * @param {number} offset - The index of the array to insert this Vertex to.
     * @param {number} textureUnit - The texture unit currently in use.
     * @param {number} tintEffect - The tint effect to use.
     *
     * @return {number} The new vertex index array offset.
     */ load: function(F32, U32, offset, textureUnit, tintEffect) {
                        offset = this.vertex1.load(F32, U32, offset, textureUnit, tintEffect);
                        offset = this.vertex2.load(F32, U32, offset, textureUnit, tintEffect);
                        offset = this.vertex3.load(F32, U32, offset, textureUnit, tintEffect);
                        return offset;
                    },
                    /**
     * Transforms all Face vertices by the given matrix, storing the results in their `vx`, `vy` and `vz` properties.
     *
     * @method Phaser.Geom.Mesh.Face#transformCoordinatesLocal
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} transformMatrix - The transform matrix to apply to this vertex.
     * @param {number} width - The width of the parent Mesh.
     * @param {number} height - The height of the parent Mesh.
     * @param {number} cameraZ - The z position of the MeshCamera.
     *
     * @return {this} This Face instance.
     */ transformCoordinatesLocal: function(transformMatrix, width, height, cameraZ) {
                        this.vertex1.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                        this.vertex2.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                        this.vertex3.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                        return this;
                    },
                    /**
     * Updates the bounds of this Face, based on the translated values of the vertices.
     *
     * Call this method prior to accessing the `Face.bounds` property.
     *
     * @method Phaser.Geom.Mesh.Face#updateBounds
     * @since 3.50.0
     *
     * @return {this} This Face instance.
     */ updateBounds: function() {
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        var bounds = this.bounds;
                        bounds.x = Math.min(v1.vx, v2.vx, v3.vx);
                        bounds.y = Math.min(v1.vy, v2.vy, v3.vy);
                        bounds.width = Math.max(v1.vx, v2.vx, v3.vx) - bounds.x;
                        bounds.height = Math.max(v1.vy, v2.vy, v3.vy) - bounds.y;
                        return this;
                    },
                    /**
     * Checks if this Face is within the view of the given Camera.
     *
     * This method is called in the `MeshWebGLRenderer` function. It performs the following tasks:
     *
     * First, the `Vertex.update` method is called on each of the vertices. This populates them
     * with the new translated values, updating their `tx`, `ty` and `ta` properties.
     *
     * Then it tests to see if this face is visible due to the alpha values, if not, it returns.
     *
     * After this, if `hideCCW` is set, it calls `isCounterClockwise` and returns if not.
     *
     * Finally, it will update the `Face.bounds` based on the newly translated vertex values
     * and return the results of an intersection test between the bounds and the camera world view
     * rectangle.
     *
     * @method Phaser.Geom.Mesh.Face#isInView
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against.
     * @param {boolean} hideCCW - Test the counter-clockwise orientation of the verts?
     * @param {number} z - The Cameras z position, used in the CCW test.
     * @param {number} alpha - The alpha of the parent object.
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     *
     * @return {boolean} `true` if this Face can be seen by the Camera.
     */ isInView: function(camera, hideCCW, z, alpha, a, b, c, d, e, f, roundPixels) {
                        this.update(alpha, a, b, c, d, e, f, roundPixels);
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        //  Alpha check first
                        if (v1.ta <= 0 && v2.ta <= 0 && v3.ta <= 0) return false;
                        //  CCW check
                        if (hideCCW && !this.isCounterClockwise(z)) return false;
                        //  Bounds check
                        var bounds = this.bounds;
                        bounds.x = Math.min(v1.tx, v2.tx, v3.tx);
                        bounds.y = Math.min(v1.ty, v2.ty, v3.ty);
                        bounds.width = Math.max(v1.tx, v2.tx, v3.tx) - bounds.x;
                        bounds.height = Math.max(v1.ty, v2.ty, v3.ty) - bounds.y;
                        var cr = camera.x + camera.width;
                        var cb = camera.y + camera.height;
                        if (bounds.width <= 0 || bounds.height <= 0 || camera.width <= 0 || camera.height <= 0) return false;
                        return !(bounds.right < camera.x || bounds.bottom < camera.y || bounds.x > cr || bounds.y > cb);
                    },
                    /**
     * Translates the original UV positions of each vertex by the given amounts.
     *
     * The original properties `Vertex.u` and `Vertex.v`
     * remain unchanged, only the translated properties
     * `Vertex.tu` and `Vertex.tv`, as used in rendering,
     * are updated.
     *
     * @method Phaser.Geom.Mesh.Face#scrollUV
     * @since 3.60.0
     *
     * @param {number} x - The amount to scroll the UV u coordinate by.
     * @param {number} y - The amount to scroll the UV v coordinate by.
     *
     * @return {this} This Face instance.
     */ scrollUV: function(x, y) {
                        this.vertex1.scrollUV(x, y);
                        this.vertex2.scrollUV(x, y);
                        this.vertex3.scrollUV(x, y);
                        return this;
                    },
                    /**
     * Scales the original UV values of each vertex by the given amounts.
     *
     * The original properties `Vertex.u` and `Vertex.v`
     * remain unchanged, only the translated properties
     * `Vertex.tu` and `Vertex.tv`, as used in rendering,
     * are updated.
     *
     * @method Phaser.Geom.Mesh.Face#scaleUV
     * @since 3.60.0
     *
     * @param {number} x - The amount to scale the UV u coordinate by.
     * @param {number} y - The amount to scale the UV v coordinate by.
     *
     * @return {this} This Face instance.
     */ scaleUV: function(x, y) {
                        this.vertex1.scaleUV(x, y);
                        this.vertex2.scaleUV(x, y);
                        this.vertex3.scaleUV(x, y);
                        return this;
                    },
                    /**
     * Sets the color value for each Vertex in this Face.
     *
     * @method Phaser.Geom.Mesh.Face#setColor
     * @since 3.60.0
     *
     * @param {number} color - The color value for each vertex.
     *
     * @return {this} This Face instance.
     */ setColor: function(color) {
                        this.vertex1.color = color;
                        this.vertex2.color = color;
                        this.vertex3.color = color;
                        return this;
                    },
                    /**
     * Calls the `Vertex.update` method on each of the vertices. This populates them
     * with the new translated values, updating their `tx`, `ty` and `ta` properties.
     *
     * @method Phaser.Geom.Mesh.Face#update
     * @since 3.60.0
     *
     * @param {number} alpha - The alpha of the parent object.
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     *
     * @return {this} This Face instance.
     */ update: function(alpha, a, b, c, d, e, f, roundPixels) {
                        this.vertex1.update(a, b, c, d, e, f, roundPixels, alpha);
                        this.vertex2.update(a, b, c, d, e, f, roundPixels, alpha);
                        this.vertex3.update(a, b, c, d, e, f, roundPixels, alpha);
                        return this;
                    },
                    /**
     * Translates the vertices of this Face by the given amounts.
     *
     * The actual vertex positions are adjusted, not their transformed position.
     *
     * Therefore, this updates the vertex data directly.
     *
     * @method Phaser.Geom.Mesh.Face#translate
     * @since 3.50.0
     *
     * @param {number} x - The amount to horizontally translate by.
     * @param {number} [y=0] - The amount to vertically translate by.
     *
     * @return {this} This Face instance.
     */ translate: function(x, y) {
                        if (y === undefined) y = 0;
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        v1.x += x;
                        v1.y += y;
                        v2.x += x;
                        v2.y += y;
                        v3.x += x;
                        v3.y += y;
                        return this;
                    },
                    /**
     * The x coordinate of this Face, based on the in center position of the Face.
     *
     * @name Phaser.Geom.Mesh.Face#x
     * @type {number}
     * @since 3.50.0
     */ x: {
                        get: function() {
                            return this.getInCenter().x;
                        },
                        set: function(value) {
                            var current = this.getInCenter();
                            this.translate(value - current.x, 0);
                        }
                    },
                    /**
     * The y coordinate of this Face, based on the in center position of the Face.
     *
     * @name Phaser.Geom.Mesh.Face#y
     * @type {number}
     * @since 3.50.0
     */ y: {
                        get: function() {
                            return this.getInCenter().y;
                        },
                        set: function(value) {
                            var current = this.getInCenter();
                            this.translate(0, value - current.y);
                        }
                    },
                    /**
     * Set the alpha value of this Face.
     *
     * Each vertex is given the same value. If you need to adjust the alpha on a per-vertex basis
     * then use the `Vertex.alpha` property instead.
     *
     * When getting the alpha of this Face, it will return an average of the alpha
     * component of all three vertices.
     *
     * @name Phaser.Geom.Mesh.Face#alpha
     * @type {number}
     * @since 3.50.0
     */ alpha: {
                        get: function() {
                            var v1 = this.vertex1;
                            var v2 = this.vertex2;
                            var v3 = this.vertex3;
                            return (v1.alpha + v2.alpha + v3.alpha) / 3;
                        },
                        set: function(value) {
                            this.vertex1.alpha = value;
                            this.vertex2.alpha = value;
                            this.vertex3.alpha = value;
                        }
                    },
                    /**
     * The depth of this Face, which is an average of the z component of all three vertices.
     *
     * The depth is calculated based on the transformed z value, not the local one.
     *
     * @name Phaser.Geom.Mesh.Face#depth
     * @type {number}
     * @readonly
     * @since 3.50.0
     */ depth: {
                        get: function() {
                            var v1 = this.vertex1;
                            var v2 = this.vertex2;
                            var v3 = this.vertex3;
                            return (v1.vz + v2.vz + v3.vz) / 3;
                        }
                    },
                    /**
     * Destroys this Face and nulls the references to the vertices.
     *
     * @method Phaser.Geom.Mesh.Face#destroy
     * @since 3.50.0
     */ destroy: function() {
                        this.vertex1 = null;
                        this.vertex2 = null;
                        this.vertex3 = null;
                    }
                });
                module1.exports = Face;
            /***/ },
            /***/ 48803: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(83997);
                var GetFastValue = __webpack_require__(95540);
                var Matrix4 = __webpack_require__(37867);
                var Vector3 = __webpack_require__(25836);
                var Vertex = __webpack_require__(39318);
                var tempPosition = new Vector3();
                var tempRotation = new Vector3();
                var tempMatrix = new Matrix4();
                /**
 * Creates a grid of vertices based on the given configuration object and optionally adds it to a Mesh.
 *
 * The size of the grid is given in pixels. An example configuration may be:
 *
 * `{ width: 256, height: 256, widthSegments: 2, heightSegments: 2, tile: true }`
 *
 * This will create a grid 256 x 256 pixels in size, split into 2 x 2 segments, with
 * the texture tiling across the cells.
 *
 * You can split the grid into segments both vertically and horizontally. This will
 * generate two faces per grid segment as a result.
 *
 * The `tile` parameter allows you to control if the tile will repeat across the grid
 * segments, or be displayed in full.
 *
 * If adding this grid to a Mesh you can offset the grid via the `x` and `y` properties.
 *
 * UV coordinates are generated based on the given texture and frame in the config. For
 * example, no frame is given, the UVs will be in the range 0 to 1. If a frame is given,
 * such as from a texture atlas, the UVs will be generated within the range of that frame.
 *
 * @function Phaser.Geom.Mesh.GenerateGridVerts
 * @since 3.50.0
 *
 * @param {Phaser.Types.Geom.Mesh.GenerateGridConfig} config - A Grid configuration object.
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateGridVertsResult} A Grid Result object, containing the generated vertices and indicies.
 */ var GenerateGridVerts = function(config) {
                    var mesh = GetFastValue(config, 'mesh');
                    var texture = GetFastValue(config, 'texture', null);
                    var frame = GetFastValue(config, 'frame');
                    var width = GetFastValue(config, 'width', 1);
                    var height = GetFastValue(config, 'height', width);
                    var widthSegments = GetFastValue(config, 'widthSegments', 1);
                    var heightSegments = GetFastValue(config, 'heightSegments', widthSegments);
                    var posX = GetFastValue(config, 'x', 0);
                    var posY = GetFastValue(config, 'y', 0);
                    var posZ = GetFastValue(config, 'z', 0);
                    var rotateX = GetFastValue(config, 'rotateX', 0);
                    var rotateY = GetFastValue(config, 'rotateY', 0);
                    var rotateZ = GetFastValue(config, 'rotateZ', 0);
                    var zIsUp = GetFastValue(config, 'zIsUp', true);
                    var isOrtho = GetFastValue(config, 'isOrtho', mesh ? mesh.dirtyCache[11] : false);
                    var colors = GetFastValue(config, 'colors', [
                        0xffffff
                    ]);
                    var alphas = GetFastValue(config, 'alphas', [
                        1
                    ]);
                    var tile = GetFastValue(config, 'tile', false);
                    var flipY = GetFastValue(config, 'flipY', false);
                    var widthSet = GetFastValue(config, 'width', null);
                    var result = {
                        faces: [],
                        verts: []
                    };
                    tempPosition.set(posX, posY, posZ);
                    tempRotation.set(rotateX, rotateY, rotateZ);
                    tempMatrix.fromRotationXYTranslation(tempRotation, tempPosition, zIsUp);
                    var textureFrame;
                    if (!texture && mesh) {
                        texture = mesh.texture;
                        if (!frame) textureFrame = mesh.frame;
                    } else if (mesh && typeof texture === 'string') texture = mesh.scene.sys.textures.get(texture);
                    else if (!texture) //  There's nothing more we can do without a texture
                    return result;
                    if (!textureFrame) textureFrame = texture.get(frame);
                    //  If the Mesh is ortho and no width / height is given, we'll default to texture sizes (if set!)
                    if (!widthSet && isOrtho && texture && mesh) {
                        width = textureFrame.width / mesh.height;
                        height = textureFrame.height / mesh.height;
                    }
                    var halfWidth = width / 2;
                    var halfHeight = height / 2;
                    var gridX = Math.floor(widthSegments);
                    var gridY = Math.floor(heightSegments);
                    var gridX1 = gridX + 1;
                    var gridY1 = gridY + 1;
                    var segmentWidth = width / gridX;
                    var segmentHeight = height / gridY;
                    var uvs = [];
                    var vertices = [];
                    var ix;
                    var iy;
                    var frameU0 = 0;
                    var frameU1 = 1;
                    var frameV0 = 0;
                    var frameV1 = 1;
                    if (textureFrame) {
                        frameU0 = textureFrame.u0;
                        frameU1 = textureFrame.u1;
                        if (!flipY) {
                            frameV0 = textureFrame.v0;
                            frameV1 = textureFrame.v1;
                        } else {
                            frameV0 = textureFrame.v1;
                            frameV1 = textureFrame.v0;
                        }
                    }
                    var frameU = frameU1 - frameU0;
                    var frameV = frameV1 - frameV0;
                    for(iy = 0; iy < gridY1; iy++){
                        var y = iy * segmentHeight - halfHeight;
                        for(ix = 0; ix < gridX1; ix++){
                            var x = ix * segmentWidth - halfWidth;
                            vertices.push(x, -y);
                            var tu = frameU0 + frameU * (ix / gridX);
                            var tv = frameV0 + frameV * (iy / gridY);
                            uvs.push(tu, tv);
                        }
                    }
                    if (!Array.isArray(colors)) colors = [
                        colors
                    ];
                    if (!Array.isArray(alphas)) alphas = [
                        alphas
                    ];
                    var alphaIndex = 0;
                    var colorIndex = 0;
                    for(iy = 0; iy < gridY; iy++)for(ix = 0; ix < gridX; ix++){
                        var a = (ix + gridX1 * iy) * 2;
                        var b = (ix + gridX1 * (iy + 1)) * 2;
                        var c = (ix + 1 + gridX1 * (iy + 1)) * 2;
                        var d = (ix + 1 + gridX1 * iy) * 2;
                        var color = colors[colorIndex];
                        var alpha = alphas[alphaIndex];
                        var vert1 = new Vertex(vertices[a], vertices[a + 1], 0, uvs[a], uvs[a + 1], color, alpha).transformMat4(tempMatrix);
                        var vert2 = new Vertex(vertices[b], vertices[b + 1], 0, uvs[b], uvs[b + 1], color, alpha).transformMat4(tempMatrix);
                        var vert3 = new Vertex(vertices[d], vertices[d + 1], 0, uvs[d], uvs[d + 1], color, alpha).transformMat4(tempMatrix);
                        var vert4 = new Vertex(vertices[b], vertices[b + 1], 0, uvs[b], uvs[b + 1], color, alpha).transformMat4(tempMatrix);
                        var vert5 = new Vertex(vertices[c], vertices[c + 1], 0, uvs[c], uvs[c + 1], color, alpha).transformMat4(tempMatrix);
                        var vert6 = new Vertex(vertices[d], vertices[d + 1], 0, uvs[d], uvs[d + 1], color, alpha).transformMat4(tempMatrix);
                        if (tile) {
                            vert1.setUVs(frameU0, frameV1);
                            vert2.setUVs(frameU0, frameV0);
                            vert3.setUVs(frameU1, frameV1);
                            vert4.setUVs(frameU0, frameV0);
                            vert5.setUVs(frameU1, frameV0);
                            vert6.setUVs(frameU1, frameV1);
                        }
                        colorIndex++;
                        if (colorIndex === colors.length) colorIndex = 0;
                        alphaIndex++;
                        if (alphaIndex === alphas.length) alphaIndex = 0;
                        result.verts.push(vert1, vert2, vert3, vert4, vert5, vert6);
                        result.faces.push(new Face(vert1, vert2, vert3), new Face(vert4, vert5, vert6));
                    }
                    if (mesh) {
                        mesh.faces = mesh.faces.concat(result.faces);
                        mesh.vertices = mesh.vertices.concat(result.verts);
                    }
                    return result;
                };
                module1.exports = GenerateGridVerts;
            /***/ },
            /***/ 34684: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(83997);
                var Matrix4 = __webpack_require__(37867);
                var Vector3 = __webpack_require__(25836);
                var Vertex = __webpack_require__(39318);
                var tempPosition = new Vector3();
                var tempRotation = new Vector3();
                var tempMatrix = new Matrix4();
                /**
 * This method will return an object containing Face and Vertex instances, generated
 * from the parsed triangulated OBJ Model data given to this function.
 *
 * The obj data should have been parsed in advance via the ParseObj function:
 *
 * ```javascript
 * var data = Phaser.Geom.Mesh.ParseObj(rawData, flipUV);
 *
 * var results = GenerateObjVerts(data);
 * ```
 *
 * Alternatively, you can parse obj files loaded via the OBJFile loader:
 *
 * ```javascript
 * preload ()
 * {
 *   this.load.obj('alien', 'assets/3d/alien.obj);
 * }
 *
 * var results = GenerateObjVerts(this.cache.obj.get('alien));
 * ```
 *
 * Make sure your 3D package has triangulated the model data prior to exporting it.
 *
 * You can use the data returned by this function to populate the vertices of a Mesh Game Object.
 *
 * You may add multiple models to a single Mesh, although they will act as one when
 * moved or rotated. You can scale the model data, should it be too small (or large) to visualize.
 * You can also offset the model via the `x`, `y` and `z` parameters.
 *
 * @function Phaser.Geom.Mesh.GenerateObjVerts
 * @since 3.50.0
 *
 * @param {Phaser.Types.Geom.Mesh.OBJData} data - The parsed OBJ model data.
 * @param {Phaser.GameObjects.Mesh} [mesh] - An optional Mesh Game Object. If given, the generated Faces will be automatically added to this Mesh. Set to `null` to skip.
 * @param {number} [scale=1] - An amount to scale the model data by. Use this if the model has exported too small, or large, to see.
 * @param {number} [x=0] - Translate the model x position by this amount.
 * @param {number} [y=0] - Translate the model y position by this amount.
 * @param {number} [z=0] - Translate the model z position by this amount.
 * @param {number} [rotateX=0] - Rotate the model on the x axis by this amount, in radians.
 * @param {number} [rotateY=0] - Rotate the model on the y axis by this amount, in radians.
 * @param {number} [rotateZ=0] - Rotate the model on the z axis by this amount, in radians.
 * @param {boolean} [zIsUp=true] - Is the z axis up (true), or is y axis up (false)?
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateVertsResult} The parsed Face and Vertex objects.
 */ var GenerateObjVerts = function(data, mesh, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp) {
                    if (scale === undefined) scale = 1;
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (z === undefined) z = 0;
                    if (rotateX === undefined) rotateX = 0;
                    if (rotateY === undefined) rotateY = 0;
                    if (rotateZ === undefined) rotateZ = 0;
                    if (zIsUp === undefined) zIsUp = true;
                    var result = {
                        faces: [],
                        verts: []
                    };
                    var materials = data.materials;
                    tempPosition.set(x, y, z);
                    tempRotation.set(rotateX, rotateY, rotateZ);
                    tempMatrix.fromRotationXYTranslation(tempRotation, tempPosition, zIsUp);
                    for(var m = 0; m < data.models.length; m++){
                        var model = data.models[m];
                        var vertices = model.vertices;
                        var textureCoords = model.textureCoords;
                        var faces = model.faces;
                        for(var i = 0; i < faces.length; i++){
                            var face = faces[i];
                            var v1 = face.vertices[0];
                            var v2 = face.vertices[1];
                            var v3 = face.vertices[2];
                            var m1 = vertices[v1.vertexIndex];
                            var m2 = vertices[v2.vertexIndex];
                            var m3 = vertices[v3.vertexIndex];
                            var t1 = v1.textureCoordsIndex;
                            var t2 = v2.textureCoordsIndex;
                            var t3 = v3.textureCoordsIndex;
                            var uv1 = t1 === -1 ? {
                                u: 0,
                                v: 1
                            } : textureCoords[t1];
                            var uv2 = t2 === -1 ? {
                                u: 0,
                                v: 0
                            } : textureCoords[t2];
                            var uv3 = t3 === -1 ? {
                                u: 1,
                                v: 1
                            } : textureCoords[t3];
                            var color = 0xffffff;
                            if (face.material !== '' && materials[face.material]) color = materials[face.material];
                            var vert1 = new Vertex(m1.x * scale, m1.y * scale, m1.z * scale, uv1.u, uv1.v, color).transformMat4(tempMatrix);
                            var vert2 = new Vertex(m2.x * scale, m2.y * scale, m2.z * scale, uv2.u, uv2.v, color).transformMat4(tempMatrix);
                            var vert3 = new Vertex(m3.x * scale, m3.y * scale, m3.z * scale, uv3.u, uv3.v, color).transformMat4(tempMatrix);
                            result.verts.push(vert1, vert2, vert3);
                            result.faces.push(new Face(vert1, vert2, vert3));
                        }
                    }
                    if (mesh) {
                        mesh.faces = mesh.faces.concat(result.faces);
                        mesh.vertices = mesh.vertices.concat(result.verts);
                    }
                    return result;
                };
                module1.exports = GenerateObjVerts;
            /***/ },
            /***/ 92515: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(83997);
                var Vertex = __webpack_require__(39318);
                /**
 * Generates a set of Face and Vertex objects by parsing the given data.
 *
 * This method will take vertex data in one of two formats, based on the `containsZ` parameter.
 *
 * If your vertex data are `x`, `y` pairs, then `containsZ` should be `false` (this is the default)
 *
 * If your vertex data is groups of `x`, `y` and `z` values, then the `containsZ` parameter must be true.
 *
 * The `uvs` parameter is a numeric array consisting of `u` and `v` pairs.
 *
 * The `normals` parameter is a numeric array consisting of `x`, `y` vertex normal values and, if `containsZ` is true, `z` values as well.
 *
 * The `indicies` parameter is an optional array that, if given, is an indexed list of vertices to be added.
 *
 * The `colors` parameter is an optional array, or single value, that if given sets the color of each vertex created.
 *
 * The `alphas` parameter is an optional array, or single value, that if given sets the alpha of each vertex created.
 *
 * When providing indexed data it is assumed that _all_ of the arrays are indexed, not just the vertices.
 *
 * The following example will create a 256 x 256 sized quad using an index array:
 *
 * ```javascript
 * const vertices = [
 *   -128, 128,
 *   128, 128,
 *   -128, -128,
 *   128, -128
 * ];
 *
 * const uvs = [
 *   0, 1,
 *   1, 1,
 *   0, 0,
 *   1, 0
 * ];
 *
 * const indices = [ 0, 2, 1, 2, 3, 1 ];
 *
 * GenerateVerts(vertices, uvs, indicies);
 * ```
 *
 * If the data is not indexed, it's assumed that the arrays all contain sequential data.
 *
 * @function Phaser.Geom.Mesh.GenerateVerts
 * @since 3.50.0
 *
 * @param {number[]} vertices - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true`.
 * @param {number[]} uvs - The UVs pairs array.
 * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
 * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component?
 * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
 * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
 * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
 * @param {boolean} [flipUV=false] - Flip the UV coordinates?
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateVertsResult} The parsed Face and Vertex objects.
 */ var GenerateVerts = function(vertices, uvs, indicies, containsZ, normals, colors, alphas, flipUV) {
                    if (containsZ === undefined) containsZ = false;
                    if (colors === undefined) colors = 0xffffff;
                    if (alphas === undefined) alphas = 1;
                    if (flipUV === undefined) flipUV = false;
                    if (vertices.length !== uvs.length && !containsZ) {
                        console.warn('GenerateVerts: vertices and uvs count not equal');
                        return;
                    }
                    var result = {
                        faces: [],
                        vertices: []
                    };
                    var i;
                    var x;
                    var y;
                    var z;
                    var u;
                    var v;
                    var color;
                    var alpha;
                    var normalX;
                    var normalY;
                    var normalZ;
                    var iInc = containsZ ? 3 : 2;
                    var isColorArray = Array.isArray(colors);
                    var isAlphaArray = Array.isArray(alphas);
                    if (Array.isArray(indicies) && indicies.length > 0) for(i = 0; i < indicies.length; i++){
                        var index1 = indicies[i];
                        var index2 = indicies[i] * 2;
                        var index3 = indicies[i] * iInc;
                        x = vertices[index3];
                        y = vertices[index3 + 1];
                        z = containsZ ? vertices[index3 + 2] : 0;
                        u = uvs[index2];
                        v = uvs[index2 + 1];
                        if (flipUV) v = 1 - v;
                        color = isColorArray ? colors[index1] : colors;
                        alpha = isAlphaArray ? alphas[index1] : alphas;
                        normalX = 0;
                        normalY = 0;
                        normalZ = 0;
                        if (normals) {
                            normalX = normals[index3];
                            normalY = normals[index3 + 1];
                            normalZ = containsZ ? normals[index3 + 2] : 0;
                        }
                        result.vertices.push(new Vertex(x, y, z, u, v, color, alpha, normalX, normalY, normalZ));
                    }
                    else {
                        var uvIndex = 0;
                        var colorIndex = 0;
                        for(i = 0; i < vertices.length; i += iInc){
                            x = vertices[i];
                            y = vertices[i + 1];
                            z = containsZ ? vertices[i + 2] : 0;
                            u = uvs[uvIndex];
                            v = uvs[uvIndex + 1];
                            color = isColorArray ? colors[colorIndex] : colors;
                            alpha = isAlphaArray ? alphas[colorIndex] : alphas;
                            normalX = 0;
                            normalY = 0;
                            normalZ = 0;
                            if (normals) {
                                normalX = normals[i];
                                normalY = normals[i + 1];
                                normalZ = containsZ ? normals[i + 2] : 0;
                            }
                            result.vertices.push(new Vertex(x, y, z, u, v, color, alpha, normalX, normalY, normalZ));
                            uvIndex += 2;
                            colorIndex++;
                        }
                    }
                    for(i = 0; i < result.vertices.length; i += 3){
                        var vert1 = result.vertices[i];
                        var vert2 = result.vertices[i + 1];
                        var vert3 = result.vertices[i + 2];
                        result.faces.push(new Face(vert1, vert2, vert3));
                    }
                    return result;
                };
                module1.exports = GenerateVerts;
            /***/ },
            /***/ 85048: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var flip = true;
                var defaultModelName = 'untitled';
                var currentGroup = '';
                var currentMaterial = '';
                /**
 * @ignore
 */ function stripComments(line) {
                    var idx = line.indexOf('#');
                    return idx > -1 ? line.substring(0, idx) : line;
                }
                /**
 * @ignore
 */ function currentModel(result) {
                    if (result.models.length === 0) result.models.push({
                        faces: [],
                        name: defaultModelName,
                        textureCoords: [],
                        vertexNormals: [],
                        vertices: []
                    });
                    currentGroup = '';
                    return result.models[result.models.length - 1];
                }
                /**
 * @ignore
 */ function parseObject(lineItems, result) {
                    var modelName = lineItems.length >= 2 ? lineItems[1] : defaultModelName;
                    result.models.push({
                        faces: [],
                        name: modelName,
                        textureCoords: [],
                        vertexNormals: [],
                        vertices: []
                    });
                    currentGroup = '';
                }
                /**
 * @ignore
 */ function parseGroup(lineItems) {
                    if (lineItems.length === 2) currentGroup = lineItems[1];
                }
                /**
 * @ignore
 */ function parseVertexCoords(lineItems, result) {
                    var len = lineItems.length;
                    var x = len >= 2 ? parseFloat(lineItems[1]) : 0;
                    var y = len >= 3 ? parseFloat(lineItems[2]) : 0;
                    var z = len >= 4 ? parseFloat(lineItems[3]) : 0;
                    currentModel(result).vertices.push({
                        x: x,
                        y: y,
                        z: z
                    });
                }
                /**
 * @ignore
 */ function parseTextureCoords(lineItems, result) {
                    var len = lineItems.length;
                    var u = len >= 2 ? parseFloat(lineItems[1]) : 0;
                    var v = len >= 3 ? parseFloat(lineItems[2]) : 0;
                    var w = len >= 4 ? parseFloat(lineItems[3]) : 0;
                    if (isNaN(u)) u = 0;
                    if (isNaN(v)) v = 0;
                    if (isNaN(w)) w = 0;
                    if (flip) v = 1 - v;
                    currentModel(result).textureCoords.push({
                        u: u,
                        v: v,
                        w: w
                    });
                }
                /**
 * @ignore
 */ function parseVertexNormal(lineItems, result) {
                    var len = lineItems.length;
                    var x = len >= 2 ? parseFloat(lineItems[1]) : 0;
                    var y = len >= 3 ? parseFloat(lineItems[2]) : 0;
                    var z = len >= 4 ? parseFloat(lineItems[3]) : 0;
                    currentModel(result).vertexNormals.push({
                        x: x,
                        y: y,
                        z: z
                    });
                }
                /**
 * @ignore
 */ function parsePolygon(lineItems, result) {
                    var totalVertices = lineItems.length - 1;
                    if (totalVertices < 3) return;
                    var face = {
                        group: currentGroup,
                        material: currentMaterial,
                        vertices: []
                    };
                    for(var i = 0; i < totalVertices; i++){
                        var vertexString = lineItems[i + 1];
                        var vertexValues = vertexString.split('/');
                        var vvLen = vertexValues.length;
                        if (vvLen < 1 || vvLen > 3) continue;
                        var vertexIndex = 0;
                        var textureCoordsIndex = 0;
                        var vertexNormalIndex = 0;
                        vertexIndex = parseInt(vertexValues[0], 10);
                        if (vvLen > 1 && vertexValues[1] !== '') textureCoordsIndex = parseInt(vertexValues[1], 10);
                        if (vvLen > 2) vertexNormalIndex = parseInt(vertexValues[2], 10);
                        if (vertexIndex !== 0) {
                            // Negative vertex indices refer to the nth last defined vertex
                            // convert these to postive indices for simplicity
                            if (vertexIndex < 0) vertexIndex = currentModel(result).vertices.length + 1 + vertexIndex;
                            textureCoordsIndex -= 1;
                            vertexIndex -= 1;
                            vertexNormalIndex -= 1;
                            face.vertices.push({
                                textureCoordsIndex: textureCoordsIndex,
                                vertexIndex: vertexIndex,
                                vertexNormalIndex: vertexNormalIndex
                            });
                        }
                    }
                    currentModel(result).faces.push(face);
                }
                /**
 * @ignore
 */ function parseMtlLib(lineItems, result) {
                    if (lineItems.length >= 2) result.materialLibraries.push(lineItems[1]);
                }
                /**
 * @ignore
 */ function parseUseMtl(lineItems) {
                    if (lineItems.length >= 2) currentMaterial = lineItems[1];
                }
                /**
 * Parses a Wavefront OBJ File, extracting the models from it and returning them in an array.
 *
 * The model data *must* be triangulated for a Mesh Game Object to be able to render it.
 *
 * @function Phaser.Geom.Mesh.ParseObj
 * @since 3.50.0
 *
 * @param {string} data - The OBJ File data as a raw string.
 * @param {boolean} [flipUV=true] - Flip the UV coordinates?
 *
 * @return {Phaser.Types.Geom.Mesh.OBJData} The parsed model and material data.
 */ var ParseObj = function(data, flipUV) {
                    if (flipUV === undefined) flipUV = true;
                    flip = flipUV;
                    //  Store results in here
                    var result = {
                        materials: {},
                        materialLibraries: [],
                        models: []
                    };
                    currentGroup = '';
                    currentMaterial = '';
                    var lines = data.split('\n');
                    for(var i = 0; i < lines.length; i++){
                        var line = stripComments(lines[i]);
                        var lineItems = line.replace(/\s\s+/g, ' ').trim().split(' ');
                        switch(lineItems[0].toLowerCase()){
                            case 'o':
                                // Start A New Model
                                parseObject(lineItems, result);
                                break;
                            case 'g':
                                // Start a new polygon group
                                parseGroup(lineItems);
                                break;
                            case 'v':
                                // Define a vertex for the current model
                                parseVertexCoords(lineItems, result);
                                break;
                            case 'vt':
                                // Texture Coords
                                parseTextureCoords(lineItems, result);
                                break;
                            case 'vn':
                                // Define a vertex normal for the current model
                                parseVertexNormal(lineItems, result);
                                break;
                            case 'f':
                                // Define a Face/Polygon
                                parsePolygon(lineItems, result);
                                break;
                            case 'mtllib':
                                // Reference to a material library file (.mtl)
                                parseMtlLib(lineItems, result);
                                break;
                            case 'usemtl':
                                // Sets the current material to be applied to polygons defined from this point forward
                                parseUseMtl(lineItems);
                                break;
                        }
                    }
                    return result;
                };
                module1.exports = ParseObj;
            /***/ },
            /***/ 61485: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(37589);
                /**
 * Takes a Wavefront Material file and extracts the diffuse reflectivity of the named
 * materials, converts them to integer color values and returns them.
 *
 * This is used internally by the `addOBJ` and `addModel` methods, but is exposed for
 * public consumption as well.
 *
 * Note this only works with diffuse values, specified in the `Kd r g b` format, where
 * `g` and `b` are optional, but `r` is required. It does not support spectral rfl files,
 * or any other material statement (such as `Ka` or `Ks`)
 *
 * @method Phaser.Geom.Mesh.ParseObjMaterial
 * @since 3.50.0
 *
 * @param {string} mtl - The OBJ MTL file as a raw string, i.e. loaded via `this.load.text`.
 *
 * @return {object} The parsed material colors, where each property of the object matches the material name.
 */ var ParseObjMaterial = function(mtl) {
                    var output = {};
                    var lines = mtl.split('\n');
                    var currentMaterial = '';
                    for(var i = 0; i < lines.length; i++){
                        var line = lines[i].trim();
                        if (line.indexOf('#') === 0 || line === '') continue;
                        var lineItems = line.replace(/\s\s+/g, ' ').trim().split(' ');
                        switch(lineItems[0].toLowerCase()){
                            case 'newmtl':
                                currentMaterial = lineItems[1];
                                break;
                            //  The diffuse reflectivity of the current material
                            //  Support r, [g], [b] format, where g and b are optional
                            case 'kd':
                                var r = Math.floor(lineItems[1] * 255);
                                var g = lineItems.length >= 2 ? Math.floor(lineItems[2] * 255) : r;
                                var b = lineItems.length >= 3 ? Math.floor(lineItems[3] * 255) : r;
                                output[currentMaterial] = GetColor(r, g, b);
                                break;
                        }
                    }
                    return output;
                };
                module1.exports = ParseObjMaterial;
            /***/ },
            /***/ 92570: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotates the vertices of a Face to the given angle.
 *
 * The actual vertex positions are adjusted, not their transformed positions.
 *
 * Therefore, this updates the vertex data directly.
 *
 * @function Phaser.Geom.Mesh.RotateFace
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Mesh.Face} face - The Face to rotate.
 * @param {number} angle - The angle to rotate to, in radians.
 * @param {number} [cx] - An optional center of rotation. If not given, the Face in-center is used.
 * @param {number} [cy] - An optional center of rotation. If not given, the Face in-center is used.
 */ var RotateFace = function(face, angle, cx, cy) {
                    var x;
                    var y;
                    //  No point of rotation? Use the inCenter instead, then.
                    if (cx === undefined && cy === undefined) {
                        var inCenter = face.getInCenter();
                        x = inCenter.x;
                        y = inCenter.y;
                    }
                    var c = Math.cos(angle);
                    var s = Math.sin(angle);
                    var v1 = face.vertex1;
                    var v2 = face.vertex2;
                    var v3 = face.vertex3;
                    var tx = v1.x - x;
                    var ty = v1.y - y;
                    v1.set(tx * c - ty * s + x, tx * s + ty * c + y);
                    tx = v2.x - x;
                    ty = v2.y - y;
                    v2.set(tx * c - ty * s + x, tx * s + ty * c + y);
                    tx = v3.x - x;
                    ty = v3.y - y;
                    v3.set(tx * c - ty * s + x, tx * s + ty * c + y);
                };
                module1.exports = RotateFace;
            /***/ },
            /***/ 39318: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Utils = __webpack_require__(70554);
                var Vector3 = __webpack_require__(25836);
                /**
 * @classdesc
 * A Vertex Geometry Object.
 *
 * This class consists of all the information required for a single vertex within a Face Geometry Object.
 *
 * Faces, and thus Vertex objects, are used by the Mesh Game Object in order to render objects in WebGL.
 *
 * @class Vertex
 * @memberof Phaser.Geom.Mesh
 * @constructor
 * @extends Phaser.Math.Vector3
 * @since 3.50.0
 *
 * @param {number} x - The x position of the vertex.
 * @param {number} y - The y position of the vertex.
 * @param {number} z - The z position of the vertex.
 * @param {number} u - The UV u coordinate of the vertex.
 * @param {number} v - The UV v coordinate of the vertex.
 * @param {number} [color=0xffffff] - The color value of the vertex.
 * @param {number} [alpha=1] - The alpha value of the vertex.
 * @param {number} [nx=0] - The x normal value of the vertex.
 * @param {number} [ny=0] - The y normal value of the vertex.
 * @param {number} [nz=0] - The z normal value of the vertex.
 */ var Vertex = new Class({
                    Extends: Vector3,
                    initialize: function Vertex(x, y, z, u, v, color, alpha, nx, ny, nz) {
                        if (color === undefined) color = 0xffffff;
                        if (alpha === undefined) alpha = 1;
                        if (nx === undefined) nx = 0;
                        if (ny === undefined) ny = 0;
                        if (nz === undefined) nz = 0;
                        Vector3.call(this, x, y, z);
                        /**
         * The projected x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vx
         * @type {number}
         * @since 3.50.0
         */ this.vx = 0;
                        /**
         * The projected y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vy
         * @type {number}
         * @since 3.50.0
         */ this.vy = 0;
                        /**
         * The projected z coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vz
         * @type {number}
         * @since 3.50.0
         */ this.vz = 0;
                        /**
         * The normalized projected x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#nx
         * @type {number}
         * @since 3.50.0
         */ this.nx = nx;
                        /**
         * The normalized projected y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ny
         * @type {number}
         * @since 3.50.0
         */ this.ny = ny;
                        /**
         * The normalized projected z coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#nz
         * @type {number}
         * @since 3.50.0
         */ this.nz = nz;
                        /**
         * UV u coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#u
         * @type {number}
         * @since 3.50.0
         */ this.u = u;
                        /**
         * UV v coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#v
         * @type {number}
         * @since 3.50.0
         */ this.v = v;
                        /**
         * The color value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#color
         * @type {number}
         * @since 3.50.0
         */ this.color = color;
                        /**
         * The alpha value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#alpha
         * @type {number}
         * @since 3.50.0
         */ this.alpha = alpha;
                        /**
         * The translated x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#tx
         * @type {number}
         * @since 3.50.0
         */ this.tx = 0;
                        /**
         * The translated y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ty
         * @type {number}
         * @since 3.50.0
         */ this.ty = 0;
                        /**
         * The translated alpha value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ta
         * @type {number}
         * @since 3.50.0
         */ this.ta = 0;
                        /**
         * The translated uv u coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#tu
         * @type {number}
         * @since 3.60.0
         */ this.tu = u;
                        /**
         * The translated uv v coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#tv
         * @type {number}
         * @since 3.60.0
         */ this.tv = v;
                    },
                    /**
     * Sets the U and V properties.
     *
     * Also resets the translated uv properties, undoing any scale
     * or shift they may have had.
     *
     * @method Phaser.Geom.Mesh.Vertex#setUVs
     * @since 3.50.0
     *
     * @param {number} u - The UV u coordinate of the vertex.
     * @param {number} v - The UV v coordinate of the vertex.
     *
     * @return {this} This Vertex.
     */ setUVs: function(u, v) {
                        this.u = u;
                        this.v = v;
                        this.tu = u;
                        this.tv = v;
                        return this;
                    },
                    /**
     * Translates the original UV positions by the given amounts.
     *
     * The original properties `Vertex.u` and `Vertex.v`
     * remain unchanged, only the translated properties
     * `Vertex.tu` and `Vertex.tv`, as used in rendering,
     * are updated.
     *
     * @method Phaser.Geom.Mesh.Vertex#scrollUV
     * @since 3.60.0
     *
     * @param {number} x - The amount to scroll the UV u coordinate by.
     * @param {number} y - The amount to scroll the UV v coordinate by.
     *
     * @return {this} This Vertex.
     */ scrollUV: function(x, y) {
                        this.tu += x;
                        this.tv += y;
                        return this;
                    },
                    /**
     * Scales the original UV values by the given amounts.
     *
     * The original properties `Vertex.u` and `Vertex.v`
     * remain unchanged, only the translated properties
     * `Vertex.tu` and `Vertex.tv`, as used in rendering,
     * are updated.
     *
     * @method Phaser.Geom.Mesh.Vertex#scaleUV
     * @since 3.60.0
     *
     * @param {number} x - The amount to scale the UV u coordinate by.
     * @param {number} y - The amount to scale the UV v coordinate by.
     *
     * @return {this} This Vertex.
     */ scaleUV: function(x, y) {
                        this.tu = this.u * x;
                        this.tv = this.v * y;
                        return this;
                    },
                    /**
     * Transforms this vertex by the given matrix, storing the results in `vx`, `vy` and `vz`.
     *
     * @method Phaser.Geom.Mesh.Vertex#transformCoordinatesLocal
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} transformMatrix - The transform matrix to apply to this vertex.
     * @param {number} width - The width of the parent Mesh.
     * @param {number} height - The height of the parent Mesh.
     * @param {number} cameraZ - The z position of the MeshCamera.
     */ transformCoordinatesLocal: function(transformMatrix, width, height, cameraZ) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var m = transformMatrix.val;
                        var tx = x * m[0] + y * m[4] + z * m[8] + m[12];
                        var ty = x * m[1] + y * m[5] + z * m[9] + m[13];
                        var tz = x * m[2] + y * m[6] + z * m[10] + m[14];
                        var tw = x * m[3] + y * m[7] + z * m[11] + m[15];
                        this.vx = tx / tw * width;
                        this.vy = -(ty / tw) * height;
                        if (cameraZ <= 0) this.vz = tz / tw;
                        else this.vz = -(tz / tw);
                    },
                    /**
     * Resizes this Vertex by setting the x and y coordinates, then transforms this vertex
     * by an identity matrix and dimensions, storing the results in `vx`, `vy` and `vz`.
     *
     * @method Phaser.Geom.Mesh.Vertex#resize
     * @since 3.60.0
     *
     * @param {number} x - The x position of the vertex.
     * @param {number} y - The y position of the vertex.
     * @param {number} width - The width of the parent Mesh.
     * @param {number} height - The height of the parent Mesh.
     * @param {number} originX - The originX of the parent Mesh.
     * @param {number} originY - The originY of the parent Mesh.
     *
     * @return {this} This Vertex.
     */ resize: function(x, y, width, height, originX, originY) {
                        this.x = x;
                        this.y = y;
                        this.vx = this.x * width;
                        this.vy = -this.y * height;
                        this.vz = 0;
                        if (originX < 0.5) this.vx += width * (0.5 - originX);
                        else if (originX > 0.5) this.vx -= width * (originX - 0.5);
                        if (originY < 0.5) this.vy += height * (0.5 - originY);
                        else if (originY > 0.5) this.vy -= height * (originY - 0.5);
                        return this;
                    },
                    /**
     * Updates this Vertex based on the given transform.
     *
     * @method Phaser.Geom.Mesh.Vertex#update
     * @since 3.50.0
     *
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     * @param {number} alpha - The alpha of the parent object.
     *
     * @return {this} This Vertex.
     */ update: function(a, b, c, d, e, f, roundPixels, alpha) {
                        var tx = this.vx * a + this.vy * c + e;
                        var ty = this.vx * b + this.vy * d + f;
                        if (roundPixels) {
                            tx = Math.round(tx);
                            ty = Math.round(ty);
                        }
                        this.tx = tx;
                        this.ty = ty;
                        this.ta = this.alpha * alpha;
                        return this;
                    },
                    /**
     * Loads the data from this Vertex into the given Typed Arrays.
     *
     * @method Phaser.Geom.Mesh.Vertex#load
     * @since 3.50.0
     *
     * @param {Float32Array} F32 - A Float32 Array to insert the position, UV and unit data in to.
     * @param {Uint32Array} U32 - A Uint32 Array to insert the color and alpha data in to.
     * @param {number} offset - The index of the array to insert this Vertex to.
     * @param {number} textureUnit - The texture unit currently in use.
     * @param {number} tintEffect - The tint effect to use.
     *
     * @return {number} The new array offset.
     */ load: function(F32, U32, offset, textureUnit, tintEffect) {
                        F32[++offset] = this.tx;
                        F32[++offset] = this.ty;
                        F32[++offset] = this.tu;
                        F32[++offset] = this.tv;
                        F32[++offset] = textureUnit;
                        F32[++offset] = tintEffect;
                        U32[++offset] = Utils.getTintAppendFloatAlpha(this.color, this.ta);
                        return offset;
                    }
                });
                module1.exports = Vertex;
            /***/ },
            /***/ 73090: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Geom.Mesh
 */ var Mesh = {
                    Face: __webpack_require__(83997),
                    GenerateGridVerts: __webpack_require__(48803),
                    GenerateObjVerts: __webpack_require__(34684),
                    GenerateVerts: __webpack_require__(92515),
                    ParseObj: __webpack_require__(85048),
                    ParseObjMaterial: __webpack_require__(61485),
                    RotateFace: __webpack_require__(92570),
                    Vertex: __webpack_require__(39318)
                };
                module1.exports = Mesh;
            /***/ },
            /***/ 96550: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Apply `Math.ceil()` to each coordinate of the given Point.
 *
 * @function Phaser.Geom.Point.Ceil
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to ceil.
 *
 * @return {Phaser.Geom.Point} The Point with `Math.ceil()` applied to its coordinates.
 */ var Ceil = function(point) {
                    return point.setTo(Math.ceil(point.x), Math.ceil(point.y));
                };
                module1.exports = Ceil;
            /***/ },
            /***/ 99706: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Clone the given Point.
 *
 * @function Phaser.Geom.Point.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} source - The source Point to clone.
 *
 * @return {Phaser.Geom.Point} The cloned Point.
 */ var Clone = function(source) {
                    return new Point(source.x, source.y);
                };
                module1.exports = Clone;
            /***/ },
            /***/ 68010: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Point to a destination Point.
 *
 * @function Phaser.Geom.Point.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [dest,$return]
 *
 * @param {Phaser.Geom.Point} source - The source Point to copy the values from.
 * @param {Phaser.Geom.Point} dest - The destination Point to copy the values to.
 *
 * @return {Phaser.Geom.Point} The destination Point.
 */ var CopyFrom = function(source, dest) {
                    return dest.setTo(source.x, source.y);
                };
                module1.exports = CopyFrom;
            /***/ },
            /***/ 27814: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A comparison of two `Point` objects to see if they are equal.
 *
 * @function Phaser.Geom.Point.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The original `Point` to compare against.
 * @param {Phaser.Geom.Point} toCompare - The second `Point` to compare.
 *
 * @return {boolean} Returns true if the both `Point` objects are equal.
 */ var Equals = function(point, toCompare) {
                    return point.x === toCompare.x && point.y === toCompare.y;
                };
                module1.exports = Equals;
            /***/ },
            /***/ 73565: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Apply `Math.ceil()` to each coordinate of the given Point.
 *
 * @function Phaser.Geom.Point.Floor
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to floor.
 *
 * @return {Phaser.Geom.Point} The Point with `Math.floor()` applied to its coordinates.
 */ var Floor = function(point) {
                    return point.setTo(Math.floor(point.x), Math.floor(point.y));
                };
                module1.exports = Floor;
            /***/ },
            /***/ 87555: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Get the centroid or geometric center of a plane figure (the arithmetic mean position of all the points in the figure).
 * Informally, it is the point at which a cutout of the shape could be perfectly balanced on the tip of a pin.
 *
 * @function Phaser.Geom.Point.GetCentroid
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like[]} points - An array of Vector2Like objects to get the geometric center of.
 * @param {Phaser.Geom.Point} [out] - A Point object to store the output coordinates in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object representing the geometric center of the given points.
 */ var GetCentroid = function(points, out) {
                    if (out === undefined) out = new Point();
                    if (!Array.isArray(points)) throw new Error('GetCentroid points argument must be an array');
                    var len = points.length;
                    if (len < 1) throw new Error('GetCentroid points array must not be empty');
                    else if (len === 1) {
                        out.x = points[0].x;
                        out.y = points[0].y;
                    } else {
                        for(var i = 0; i < len; i++){
                            out.x += points[i].x;
                            out.y += points[i].y;
                        }
                        out.x /= len;
                        out.y /= len;
                    }
                    return out;
                };
                module1.exports = GetCentroid;
            /***/ },
            /***/ 28793: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the magnitude of the point, which equivalent to the length of the line from the origin to this point.
 *
 * @function Phaser.Geom.Point.GetMagnitude
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The point to calculate the magnitude for
 *
 * @return {number} The resulting magnitude
 */ var GetMagnitude = function(point) {
                    return Math.sqrt(point.x * point.x + point.y * point.y);
                };
                module1.exports = GetMagnitude;
            /***/ },
            /***/ 44405: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the square of magnitude of given point.(Can be used for fast magnitude calculation of point)
 *
 * @function Phaser.Geom.Point.GetMagnitudeSq
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - Returns square of the magnitude/length of given point.
 *
 * @return {number} Returns square of the magnitude of given point.
 */ var GetMagnitudeSq = function(point) {
                    return point.x * point.x + point.y * point.y;
                };
                module1.exports = GetMagnitudeSq;
            /***/ },
            /***/ 20873: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                /**
 * Calculates the Axis Aligned Bounding Box (or aabb) from an array of points.
 *
 * @function Phaser.Geom.Point.GetRectangleFromPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like[]} points - An array of Vector2Like objects to get the AABB from.
 * @param {Phaser.Geom.Rectangle} [out] - A Rectangle object to store the results in. If not given, a new Rectangle instance is created.
 *
 * @return {Phaser.Geom.Rectangle} A Rectangle object holding the AABB values for the given points.
 */ var GetRectangleFromPoints = function(points, out) {
                    if (out === undefined) out = new Rectangle();
                    var xMax = Number.NEGATIVE_INFINITY;
                    var xMin = Number.POSITIVE_INFINITY;
                    var yMax = Number.NEGATIVE_INFINITY;
                    var yMin = Number.POSITIVE_INFINITY;
                    for(var i = 0; i < points.length; i++){
                        var point = points[i];
                        if (point.x > xMax) xMax = point.x;
                        if (point.x < xMin) xMin = point.x;
                        if (point.y > yMax) yMax = point.y;
                        if (point.y < yMin) yMin = point.y;
                    }
                    out.x = xMin;
                    out.y = yMin;
                    out.width = xMax - xMin;
                    out.height = yMax - yMin;
                    return out;
                };
                module1.exports = GetRectangleFromPoints;
            /***/ },
            /***/ 26152: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns the linear interpolation point between the two given points, based on `t`.
 *
 * @function Phaser.Geom.Point.Interpolate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - The starting `Point` for the interpolation.
 * @param {Phaser.Geom.Point} pointB - The target `Point` for the interpolation.
 * @param {number} [t=0] - The amount to interpolate between the two points. Generally, a value between 0 (returns the starting `Point`) and 1 (returns the target `Point`). If omitted, 0 is used.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional `Point` object whose `x` and `y` values will be set to the result of the interpolation (can also be any object with `x` and `y` properties). If omitted, a new `Point` created and returned.
 *
 * @return {(Phaser.Geom.Point|object)} Either the object from the `out` argument with the properties `x` and `y` set to the result of the interpolation or a newly created `Point` object.
 */ var Interpolate = function(pointA, pointB, t, out) {
                    if (t === undefined) t = 0;
                    if (out === undefined) out = new Point();
                    out.x = pointA.x + (pointB.x - pointA.x) * t;
                    out.y = pointA.y + (pointB.y - pointA.y) * t;
                    return out;
                };
                module1.exports = Interpolate;
            /***/ },
            /***/ 55767: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Swaps the X and the Y coordinate of a point.
 *
 * @function Phaser.Geom.Point.Invert
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to modify.
 *
 * @return {Phaser.Geom.Point} The modified `point`.
 */ var Invert = function(point) {
                    return point.setTo(point.y, point.x);
                };
                module1.exports = Invert;
            /***/ },
            /***/ 79432: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Inverts a Point's coordinates.
 *
 * @function Phaser.Geom.Point.Negative
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to invert.
 * @param {Phaser.Geom.Point} [out] - The Point to return the inverted coordinates in.
 *
 * @return {Phaser.Geom.Point} The modified `out` Point, or a new Point if none was provided.
 */ var Negative = function(point, out) {
                    if (out === undefined) out = new Point();
                    return out.setTo(-point.x, -point.y);
                };
                module1.exports = Negative;
            /***/ },
            /***/ 2141: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GEOM_CONST = __webpack_require__(23777);
                /**
 * @classdesc
 * Defines a Point in 2D space, with an x and y component.
 *
 * @class Point
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x coordinate of this Point.
 * @param {number} [y=x] - The y coordinate of this Point.
 */ var Point = new Class({
                    initialize: function Point(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = x;
                        /**
         * The geometry constant type of this object: `GEOM_CONST.POINT`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Point#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.POINT;
                        /**
         * The x coordinate of this Point.
         *
         * @name Phaser.Geom.Point#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                        /**
         * The y coordinate of this Point.
         *
         * @name Phaser.Geom.Point#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                    },
                    /**
     * Set the x and y coordinates of the point to the given values.
     *
     * @method Phaser.Geom.Point#setTo
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x coordinate of this Point.
     * @param {number} [y=x] - The y coordinate of this Point.
     *
     * @return {this} This Point object.
     */ setTo: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = x;
                        this.x = x;
                        this.y = y;
                        return this;
                    }
                });
                module1.exports = Point;
            /***/ },
            /***/ 72930: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                var GetMagnitudeSq = __webpack_require__(44405);
                /**
 * Calculates the vector projection of `pointA` onto the nonzero `pointB`. This is the
 * orthogonal projection of `pointA` onto a straight line parallel to `pointB`.
 *
 * @function Phaser.Geom.Point.Project
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - Point A, to be projected onto Point B.
 * @param {Phaser.Geom.Point} pointB - Point B, to have Point A projected upon it.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of the vector projection of `pointA` onto `pointB`.
 */ var Project = function(pointA, pointB, out) {
                    if (out === undefined) out = new Point();
                    var dot = pointA.x * pointB.x + pointA.y * pointB.y;
                    var amt = dot / GetMagnitudeSq(pointB);
                    if (amt !== 0) {
                        out.x = amt * pointB.x;
                        out.y = amt * pointB.y;
                    }
                    return out;
                };
                module1.exports = Project;
            /***/ },
            /***/ 62880: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Calculates the vector projection of `pointA` onto the nonzero `pointB`. This is the
 * orthogonal projection of `pointA` onto a straight line paralle to `pointB`.
 *
 * @function Phaser.Geom.Point.ProjectUnit
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - Point A, to be projected onto Point B. Must be a normalized point with a magnitude of 1.
 * @param {Phaser.Geom.Point} pointB - Point B, to have Point A projected upon it.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A unit Point object holding the coordinates of the vector projection of `pointA` onto `pointB`.
 */ var ProjectUnit = function(pointA, pointB, out) {
                    if (out === undefined) out = new Point();
                    var amt = pointA.x * pointB.x + pointA.y * pointB.y;
                    if (amt !== 0) {
                        out.x = amt * pointB.x;
                        out.y = amt * pointB.y;
                    }
                    return out;
                };
                module1.exports = ProjectUnit;
            /***/ },
            /***/ 15093: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetMagnitude = __webpack_require__(28793);
                /**
 * Changes the magnitude (length) of a two-dimensional vector without changing its direction.
 *
 * @function Phaser.Geom.Point.SetMagnitude
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to treat as the end point of the vector.
 * @param {number} magnitude - The new magnitude of the vector.
 *
 * @return {Phaser.Geom.Point} The modified Point.
 */ var SetMagnitude = function(point, magnitude) {
                    if (point.x !== 0 || point.y !== 0) {
                        var m = GetMagnitude(point);
                        point.x /= m;
                        point.y /= m;
                    }
                    point.x *= magnitude;
                    point.y *= magnitude;
                    return point;
                };
                module1.exports = SetMagnitude;
            /***/ },
            /***/ 43711: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                Point.Ceil = __webpack_require__(96550);
                Point.Clone = __webpack_require__(99706);
                Point.CopyFrom = __webpack_require__(68010);
                Point.Equals = __webpack_require__(27814);
                Point.Floor = __webpack_require__(73565);
                Point.GetCentroid = __webpack_require__(87555);
                Point.GetMagnitude = __webpack_require__(28793);
                Point.GetMagnitudeSq = __webpack_require__(44405);
                Point.GetRectangleFromPoints = __webpack_require__(20873);
                Point.Interpolate = __webpack_require__(26152);
                Point.Invert = __webpack_require__(55767);
                Point.Negative = __webpack_require__(79432);
                Point.Project = __webpack_require__(72930);
                Point.ProjectUnit = __webpack_require__(62880);
                Point.SetMagnitude = __webpack_require__(15093);
                module1.exports = Point;
            /***/ },
            /***/ 12306: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Polygon = __webpack_require__(25717);
                /**
 * Create a new polygon which is a copy of the specified polygon
 *
 * @function Phaser.Geom.Polygon.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to create a clone of
 *
 * @return {Phaser.Geom.Polygon} A new separate Polygon cloned from the specified polygon, based on the same points.
 */ var Clone = function(polygon) {
                    return new Polygon(polygon.points);
                };
                module1.exports = Clone;
            /***/ },
            /***/ 63814: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Checks whether the x and y coordinates are contained within this polygon.
                //  Adapted from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html by Jonas Raoni Soares Silva
                /**
 * Checks if a point is within the bounds of a Polygon.
 *
 * @function Phaser.Geom.Polygon.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to check against.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is within the bounds of the Polygon, otherwise `false`.
 */ var Contains = function(polygon, x, y) {
                    var inside = false;
                    for(var i = -1, j = polygon.points.length - 1; ++i < polygon.points.length; j = i){
                        var ix = polygon.points[i].x;
                        var iy = polygon.points[i].y;
                        var jx = polygon.points[j].x;
                        var jy = polygon.points[j].y;
                        if ((iy <= y && y < jy || jy <= y && y < iy) && x < (jx - ix) * (y - iy) / (jy - iy) + ix) inside = !inside;
                    }
                    return inside;
                };
                module1.exports = Contains;
            /***/ },
            /***/ 99338: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(63814);
                /**
 * Checks the given Point again the Polygon to see if the Point lays within its vertices.
 *
 * @function Phaser.Geom.Polygon.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to check.
 * @param {Phaser.Geom.Point} point - The Point to check if it's within the Polygon.
 *
 * @return {boolean} `true` if the Point is within the Polygon, otherwise `false`.
 */ var ContainsPoint = function(polygon, point) {
                    return Contains(polygon, point.x, point.y);
                };
                module1.exports = ContainsPoint;
            /***/ },
            /***/ 94811: /***/ (module1)=>{
                "use strict";
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This module implements a modified ear slicing algorithm, optimized by z-order curve hashing and extended to
 * handle holes, twisted polygons, degeneracies and self-intersections in a way that doesn't guarantee correctness
 * of triangulation, but attempts to always produce acceptable results for practical data.
 *
 * Example:
 *
 * ```javascript
 * const triangles = Phaser.Geom.Polygon.Earcut([10,0, 0,50, 60,60, 70,10]); // returns [1,0,3, 3,2,1]
 * ```
 *
 * Each group of three vertex indices in the resulting array forms a triangle.
 *
 * ```javascript
 * // triangulating a polygon with a hole
 * earcut([0,0, 100,0, 100,100, 0,100,  20,20, 80,20, 80,80, 20,80], [4]);
 * // [3,0,4, 5,4,0, 3,4,7, 5,0,1, 2,3,7, 6,5,1, 2,7,6, 6,1,2]
 *
 * // triangulating a polygon with 3d coords
 * earcut([10,0,1, 0,50,2, 60,60,3, 70,10,4], null, 3);
 * // [1,0,3, 3,2,1]
 * ```
 *
 * If you pass a single vertex as a hole, Earcut treats it as a Steiner point.
 *
 * If your input is a multi-dimensional array (e.g. GeoJSON Polygon), you can convert it to the format
 * expected by Earcut with `Phaser.Geom.Polygon.Earcut.flatten`:
 *
 * ```javascript
 * var data = earcut.flatten(geojson.geometry.coordinates);
 * var triangles = earcut(data.vertices, data.holes, data.dimensions);
 * ```
 *
 * After getting a triangulation, you can verify its correctness with `Phaser.Geom.Polygon.Earcut.deviation`:
 *
 * ```javascript
 * var deviation = earcut.deviation(vertices, holes, dimensions, triangles);
 * ```
 * Returns the relative difference between the total area of triangles and the area of the input polygon.
 * 0 means the triangulation is fully correct.
 *
 * For more information see https://github.com/mapbox/earcut
 *
 * @function Phaser.Geom.Polygon.Earcut
 * @since 3.50.0
 *
 * @param {number[]} data - A flat array of vertex coordinate, like [x0,y0, x1,y1, x2,y2, ...]
 * @param {number[]} [holeIndices] - An array of hole indices if any (e.g. [5, 8] for a 12-vertex input would mean one hole with vertices 5–7 and another with 8–11).
 * @param {number} [dimensions=2] - The number of coordinates per vertex in the input array (2 by default).
 *
 * @return {number[]} An array of triangulated data.
 */ //  Earcut 2.2.4 (July 5th 2022)
                /*
 * ISC License
 *
 * Copyright (c) 2016, Mapbox
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose
 * with or without fee is hereby granted, provided that the above copyright notice
 * and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
 * OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
 * TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
 * THIS SOFTWARE.
 */ function earcut(data, holeIndices, dim) {
                    dim = dim || 2;
                    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
                    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
                    var minX, minY, maxX, maxY, x, y, invSize;
                    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
                    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
                    if (data.length > 80 * dim) {
                        minX = maxX = data[0];
                        minY = maxY = data[1];
                        for(var i = dim; i < outerLen; i += dim){
                            x = data[i];
                            y = data[i + 1];
                            if (x < minX) minX = x;
                            if (y < minY) minY = y;
                            if (x > maxX) maxX = x;
                            if (y > maxY) maxY = y;
                        }
                        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
                        invSize = Math.max(maxX - minX, maxY - minY);
                        invSize = invSize !== 0 ? 32767 / invSize : 0;
                    }
                    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
                    return triangles;
                }
                // create a circular doubly linked list from polygon points in the specified winding order
                function linkedList(data, start, end, dim, clockwise) {
                    var i, last;
                    if (clockwise === signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = insertNode(i, data[i], data[i + 1], last);
                    else for(i = end - dim; i >= start; i -= dim)last = insertNode(i, data[i], data[i + 1], last);
                    if (last && equals(last, last.next)) {
                        removeNode(last);
                        last = last.next;
                    }
                    return last;
                }
                // eliminate colinear or duplicate points
                function filterPoints(start, end) {
                    if (!start) return start;
                    if (!end) end = start;
                    var p = start, again;
                    do {
                        again = false;
                        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
                            removeNode(p);
                            p = end = p.prev;
                            if (p === p.next) break;
                            again = true;
                        } else p = p.next;
                    }while (again || p !== end);
                    return end;
                }
                // main ear slicing loop which triangulates a polygon (given as a linked list)
                function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
                    if (!ear) return;
                    // interlink polygon nodes in z-order
                    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
                    var stop = ear, prev, next;
                    // iterate through ears, slicing them one by one
                    while(ear.prev !== ear.next){
                        prev = ear.prev;
                        next = ear.next;
                        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
                            // cut off the triangle
                            triangles.push(prev.i / dim | 0);
                            triangles.push(ear.i / dim | 0);
                            triangles.push(next.i / dim | 0);
                            removeNode(ear);
                            // skipping the next vertex leads to less sliver triangles
                            ear = next.next;
                            stop = next.next;
                            continue;
                        }
                        ear = next;
                        // if we looped through the whole remaining polygon and can't find any more ears
                        if (ear === stop) {
                            // try filtering points and slicing again
                            if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
                            else if (pass === 1) {
                                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
                            // as a last resort, try splitting the remaining polygon into two
                            } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
                            break;
                        }
                    }
                }
                // check whether a polygon node forms a valid ear with adjacent nodes
                function isEar(ear) {
                    var a = ear.prev, b = ear, c = ear.next;
                    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
                    // now make sure we don't have other points inside the potential ear
                    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
                    // triangle bbox; min & max are calculated like this for speed
                    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
                    var p = c.next;
                    while(p !== a){
                        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                        p = p.next;
                    }
                    return true;
                }
                function isEarHashed(ear, minX, minY, invSize) {
                    var a = ear.prev, b = ear, c = ear.next;
                    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
                    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
                    // triangle bbox; min & max are calculated like this for speed
                    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
                    // z-order range for the current triangle bbox;
                    var minZ = zOrder(x0, y0, minX, minY, invSize), maxZ = zOrder(x1, y1, minX, minY, invSize);
                    var p = ear.prevZ, n = ear.nextZ;
                    // look for points inside the triangle in both directions
                    while(p && p.z >= minZ && n && n.z <= maxZ){
                        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                        p = p.prevZ;
                        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
                        n = n.nextZ;
                    }
                    // look for remaining points in decreasing z-order
                    while(p && p.z >= minZ){
                        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                        p = p.prevZ;
                    }
                    // look for remaining points in increasing z-order
                    while(n && n.z <= maxZ){
                        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
                        n = n.nextZ;
                    }
                    return true;
                }
                // go through all polygon nodes and cure small local self-intersections
                function cureLocalIntersections(start, triangles, dim) {
                    var p = start;
                    do {
                        var a = p.prev, b = p.next.next;
                        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
                            triangles.push(a.i / dim | 0);
                            triangles.push(p.i / dim | 0);
                            triangles.push(b.i / dim | 0);
                            // remove two nodes involved
                            removeNode(p);
                            removeNode(p.next);
                            p = start = b;
                        }
                        p = p.next;
                    }while (p !== start);
                    return filterPoints(p);
                }
                // try splitting polygon into two and triangulate them independently
                function splitEarcut(start, triangles, dim, minX, minY, invSize) {
                    // look for a valid diagonal that divides the polygon into two
                    var a = start;
                    do {
                        var b = a.next.next;
                        while(b !== a.prev){
                            if (a.i !== b.i && isValidDiagonal(a, b)) {
                                // split the polygon in two by the diagonal
                                var c = splitPolygon(a, b);
                                // filter colinear points around the cuts
                                a = filterPoints(a, a.next);
                                c = filterPoints(c, c.next);
                                // run earcut on each half
                                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                                return;
                            }
                            b = b.next;
                        }
                        a = a.next;
                    }while (a !== start);
                }
                // link every hole into the outer loop, producing a single-ring polygon without holes
                function eliminateHoles(data, holeIndices, outerNode, dim) {
                    var queue = [], i, len, start, end, list;
                    for(i = 0, len = holeIndices.length; i < len; i++){
                        start = holeIndices[i] * dim;
                        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                        list = linkedList(data, start, end, dim, false);
                        if (list === list.next) list.steiner = true;
                        queue.push(getLeftmost(list));
                    }
                    queue.sort(compareX);
                    // process holes from left to right
                    for(i = 0; i < queue.length; i++)outerNode = eliminateHole(queue[i], outerNode);
                    return outerNode;
                }
                function compareX(a, b) {
                    return a.x - b.x;
                }
                // find a bridge between vertices that connects hole with an outer ring and and link it
                function eliminateHole(hole, outerNode) {
                    var bridge = findHoleBridge(hole, outerNode);
                    if (!bridge) return outerNode;
                    var bridgeReverse = splitPolygon(bridge, hole);
                    // filter collinear points around the cuts
                    filterPoints(bridgeReverse, bridgeReverse.next);
                    return filterPoints(bridge, bridge.next);
                }
                // David Eberly's algorithm for finding a bridge between hole and outer polygon
                function findHoleBridge(hole, outerNode) {
                    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
                    // find a segment intersected by a ray from the hole's leftmost point to the left;
                    // segment's endpoint with lesser x will be potential connection point
                    do {
                        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
                            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
                            if (x <= hx && x > qx) {
                                qx = x;
                                m = p.x < p.next.x ? p : p.next;
                                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
                            }
                        }
                        p = p.next;
                    }while (p !== outerNode);
                    if (!m) return null;
                    // look for points inside the triangle of hole point, segment intersection and endpoint;
                    // if there are no points found, we have a valid connection;
                    // otherwise choose the point of the minimum angle with the ray as connection point
                    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
                    p = m;
                    do {
                        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
                            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
                            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                                m = p;
                                tanMin = tan;
                            }
                        }
                        p = p.next;
                    }while (p !== stop);
                    return m;
                }
                // whether sector in vertex m contains sector in vertex p in the same coordinates
                function sectorContainsSector(m, p) {
                    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
                }
                // interlink polygon nodes in z-order
                function indexCurve(start, minX, minY, invSize) {
                    var p = start;
                    do {
                        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
                        p.prevZ = p.prev;
                        p.nextZ = p.next;
                        p = p.next;
                    }while (p !== start);
                    p.prevZ.nextZ = null;
                    p.prevZ = null;
                    sortLinked(p);
                }
                // Simon Tatham's linked list merge sort algorithm
                // http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
                function sortLinked(list) {
                    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
                    do {
                        p = list;
                        list = null;
                        tail = null;
                        numMerges = 0;
                        while(p){
                            numMerges++;
                            q = p;
                            pSize = 0;
                            for(i = 0; i < inSize; i++){
                                pSize++;
                                q = q.nextZ;
                                if (!q) break;
                            }
                            qSize = inSize;
                            while(pSize > 0 || qSize > 0 && q){
                                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                                    e = p;
                                    p = p.nextZ;
                                    pSize--;
                                } else {
                                    e = q;
                                    q = q.nextZ;
                                    qSize--;
                                }
                                if (tail) tail.nextZ = e;
                                else list = e;
                                e.prevZ = tail;
                                tail = e;
                            }
                            p = q;
                        }
                        tail.nextZ = null;
                        inSize *= 2;
                    }while (numMerges > 1);
                    return list;
                }
                // z-order of a point given coords and inverse of the longer side of data bbox
                function zOrder(x, y, minX, minY, invSize) {
                    // coords are transformed into non-negative 15-bit integer range
                    x = (x - minX) * invSize | 0;
                    y = (y - minY) * invSize | 0;
                    x = (x | x << 8) & 0x00FF00FF;
                    x = (x | x << 4) & 0x0F0F0F0F;
                    x = (x | x << 2) & 0x33333333;
                    x = (x | x << 1) & 0x55555555;
                    y = (y | y << 8) & 0x00FF00FF;
                    y = (y | y << 4) & 0x0F0F0F0F;
                    y = (y | y << 2) & 0x33333333;
                    y = (y | y << 1) & 0x55555555;
                    return x | y << 1;
                }
                // find the leftmost node of a polygon ring
                function getLeftmost(start) {
                    var p = start, leftmost = start;
                    do {
                        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
                        p = p.next;
                    }while (p !== start);
                    return leftmost;
                }
                // check if a point lies within a convex triangle
                function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
                    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
                }
                // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
                function isValidDiagonal(a, b) {
                    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
                    (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
                    (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
                    equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
                }
                // signed area of a triangle
                function area(p, q, r) {
                    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
                }
                // check if two points are equal
                function equals(p1, p2) {
                    return p1.x === p2.x && p1.y === p2.y;
                }
                // check if two segments intersect
                function intersects(p1, q1, p2, q2) {
                    var o1 = sign(area(p1, q1, p2));
                    var o2 = sign(area(p1, q1, q2));
                    var o3 = sign(area(p2, q2, p1));
                    var o4 = sign(area(p2, q2, q1));
                    if (o1 !== o2 && o3 !== o4) return true; // general case
                    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
                    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
                    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
                    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
                    return false;
                }
                // for collinear points p, q, r, check if point q lies on segment pr
                function onSegment(p, q, r) {
                    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
                }
                function sign(num) {
                    return num > 0 ? 1 : num < 0 ? -1 : 0;
                }
                // check if a polygon diagonal intersects any polygon segments
                function intersectsPolygon(a, b) {
                    var p = a;
                    do {
                        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
                        p = p.next;
                    }while (p !== a);
                    return false;
                }
                // check if a polygon diagonal is locally inside the polygon
                function locallyInside(a, b) {
                    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
                }
                // check if the middle point of a polygon diagonal is inside the polygon
                function middleInside(a, b) {
                    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
                    do {
                        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
                        p = p.next;
                    }while (p !== a);
                    return inside;
                }
                // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
                // if one belongs to the outer ring and another to a hole, it merges it into a single ring
                function splitPolygon(a, b) {
                    var a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
                    a.next = b;
                    b.prev = a;
                    a2.next = an;
                    an.prev = a2;
                    b2.next = a2;
                    a2.prev = b2;
                    bp.next = b2;
                    b2.prev = bp;
                    return b2;
                }
                // create a node and optionally link it with previous one (in a circular doubly linked list)
                function insertNode(i, x, y, last) {
                    var p = new Node(i, x, y);
                    if (!last) {
                        p.prev = p;
                        p.next = p;
                    } else {
                        p.next = last.next;
                        p.prev = last;
                        last.next.prev = p;
                        last.next = p;
                    }
                    return p;
                }
                function removeNode(p) {
                    p.next.prev = p.prev;
                    p.prev.next = p.next;
                    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
                    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
                }
                function Node(i, x, y) {
                    // vertex index in coordinates array
                    this.i = i;
                    // vertex coordinates
                    this.x = x;
                    this.y = y;
                    // previous and next vertex nodes in a polygon ring
                    this.prev = null;
                    this.next = null;
                    // z-order curve value
                    this.z = 0;
                    // previous and next nodes in z-order
                    this.prevZ = null;
                    this.nextZ = null;
                    // indicates whether this is a steiner point
                    this.steiner = false;
                }
                // return a percentage difference between the polygon area and its triangulation area;
                // used to verify correctness of triangulation
                earcut.deviation = function(data, holeIndices, dim, triangles) {
                    var hasHoles = holeIndices && holeIndices.length;
                    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
                    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
                    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
                        var start = holeIndices[i] * dim;
                        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                        polygonArea -= Math.abs(signedArea(data, start, end, dim));
                    }
                    var trianglesArea = 0;
                    for(i = 0; i < triangles.length; i += 3){
                        var a = triangles[i] * dim;
                        var b = triangles[i + 1] * dim;
                        var c = triangles[i + 2] * dim;
                        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
                    }
                    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
                };
                function signedArea(data, start, end, dim) {
                    var sum = 0;
                    for(var i = start, j = end - dim; i < end; i += dim){
                        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
                        j = i;
                    }
                    return sum;
                }
                // turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
                earcut.flatten = function(data) {
                    var dim = data[0][0].length, result = {
                        vertices: [],
                        holes: [],
                        dimensions: dim
                    }, holeIndex = 0;
                    for(var i = 0; i < data.length; i++){
                        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
                        if (i > 0) {
                            holeIndex += data[i - 1].length;
                            result.holes.push(holeIndex);
                        }
                    }
                    return result;
                };
                module1.exports = earcut;
            /***/ },
            /***/ 13829: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                /**
 * Calculates the bounding AABB rectangle of a polygon.
 *
 * @function Phaser.Geom.Polygon.GetAABB
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon that should be calculated.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - The rectangle or object that has x, y, width, and height properties to store the result. Optional.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The resulting rectangle or object that is passed in with position and dimensions of the polygon's AABB.
 */ var GetAABB = function(polygon, out) {
                    if (out === undefined) out = new Rectangle();
                    var minX = Infinity;
                    var minY = Infinity;
                    var maxX = -minX;
                    var maxY = -minY;
                    var p;
                    for(var i = 0; i < polygon.points.length; i++){
                        p = polygon.points[i];
                        minX = Math.min(minX, p.x);
                        minY = Math.min(minY, p.y);
                        maxX = Math.max(maxX, p.x);
                        maxY = Math.max(maxY, p.y);
                    }
                    out.x = minX;
                    out.y = minY;
                    out.width = maxX - minX;
                    out.height = maxY - minY;
                    return out;
                };
                module1.exports = GetAABB;
            /***/ },
            /***/ 26173: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Export the points as an array of flat numbers, following the sequence [ x,y, x,y, x,y ]
                /**
 * Stores all of the points of a Polygon into a flat array of numbers following the sequence [ x,y, x,y, x,y ],
 * i.e. each point of the Polygon, in the order it's defined, corresponds to two elements of the resultant
 * array for the point's X and Y coordinate.
 *
 * @function Phaser.Geom.Polygon.GetNumberArray
 * @since 3.0.0
 *
 * @generic {number[]} O - [output,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon whose points to export.
 * @param {(array|number[])} [output] - An array to which the points' coordinates should be appended.
 *
 * @return {(array|number[])} The modified `output` array, or a new array if none was given.
 */ var GetNumberArray = function(polygon, output) {
                    if (output === undefined) output = [];
                    for(var i = 0; i < polygon.points.length; i++){
                        output.push(polygon.points[i].x);
                        output.push(polygon.points[i].y);
                    }
                    return output;
                };
                module1.exports = GetNumberArray;
            /***/ },
            /***/ 9564: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(35001);
                var Line = __webpack_require__(23031);
                var Perimeter = __webpack_require__(30052);
                /**
 * Returns an array of Point objects containing the coordinates of the points around the perimeter of the Polygon,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Polygon.GetPoints
 * @since 3.12.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the perimeter of the Polygon and dividing it by the stepRate.
 * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the perimeter of the Polygon.
 */ var GetPoints = function(polygon, quantity, stepRate, out) {
                    if (out === undefined) out = [];
                    var points = polygon.points;
                    var perimeter = Perimeter(polygon);
                    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!quantity && stepRate > 0) quantity = perimeter / stepRate;
                    for(var i = 0; i < quantity; i++){
                        var position = perimeter * (i / quantity);
                        var accumulatedPerimeter = 0;
                        for(var j = 0; j < points.length; j++){
                            var pointA = points[j];
                            var pointB = points[(j + 1) % points.length];
                            var line = new Line(pointA.x, pointA.y, pointB.x, pointB.y);
                            var length = Length(line);
                            if (position < accumulatedPerimeter || position > accumulatedPerimeter + length) {
                                accumulatedPerimeter += length;
                                continue;
                            }
                            var point = line.getPoint((position - accumulatedPerimeter) / length);
                            out.push(point);
                            break;
                        }
                    }
                    return out;
                };
                module1.exports = GetPoints;
            /***/ },
            /***/ 30052: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(35001);
                var Line = __webpack_require__(23031);
                /**
 * Returns the perimeter of the given Polygon.
 *
 * @function Phaser.Geom.Polygon.Perimeter
 * @since 3.12.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to get the perimeter of.
 *
 * @return {number} The perimeter of the Polygon.
 */ var Perimeter = function(polygon) {
                    var points = polygon.points;
                    var perimeter = 0;
                    for(var i = 0; i < points.length; i++){
                        var pointA = points[i];
                        var pointB = points[(i + 1) % points.length];
                        var line = new Line(pointA.x, pointA.y, pointB.x, pointB.y);
                        perimeter += Length(line);
                    }
                    return perimeter;
                };
                module1.exports = Perimeter;
            /***/ },
            /***/ 25717: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Contains = __webpack_require__(63814);
                var GetPoints = __webpack_require__(9564);
                var GEOM_CONST = __webpack_require__(23777);
                /**
 * @classdesc
 * A Polygon object
 *
 * The polygon is a closed shape consists of a series of connected straight lines defined by list of ordered points.
 * Several formats are supported to define the list of points, check the setTo method for details.
 * This is a geometry object allowing you to define and inspect the shape.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render a Polygon you should look at the capabilities of the Graphics class.
 *
 * @class Polygon
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|number[]|Phaser.Types.Math.Vector2Like[])} [points] - List of points defining the perimeter of this Polygon. Several formats are supported:
 * - A string containing paired x y values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
 * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
 * - An array of objects with public x y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 */ var Polygon = new Class({
                    initialize: function Polygon(points) {
                        /**
         * The geometry constant type of this object: `GEOM_CONST.POLYGON`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Polygon#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.POLYGON;
                        /**
         * The area of this Polygon.
         *
         * @name Phaser.Geom.Polygon#area
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.area = 0;
                        /**
         * An array of number pair objects that make up this polygon. I.e. [ {x,y}, {x,y}, {x,y} ]
         *
         * @name Phaser.Geom.Polygon#points
         * @type {Phaser.Geom.Point[]}
         * @since 3.0.0
         */ this.points = [];
                        if (points) this.setTo(points);
                    },
                    /**
     * Check to see if the Polygon contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Polygon#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the polygon.
     * @param {number} y - The y coordinate to check within the polygon.
     *
     * @return {boolean} `true` if the coordinates are within the polygon, otherwise `false`.
     */ contains: function(x, y) {
                        return Contains(this, x, y);
                    },
                    /**
     * Sets this Polygon to the given points.
     *
     * The points can be set from a variety of formats:
     *
     * - A string containing paired values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
     * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
     * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
     * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
     * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
     *
     * `setTo` may also be called without any arguments to remove all points.
     *
     * @method Phaser.Geom.Polygon#setTo
     * @since 3.0.0
     *
     * @param {(string|number[]|Phaser.Types.Math.Vector2Like[])} [points] - Points defining the perimeter of this polygon. Please check function description above for the different supported formats.
     *
     * @return {this} This Polygon object.
     */ setTo: function(points) {
                        this.area = 0;
                        this.points = [];
                        if (typeof points === 'string') points = points.split(' ');
                        if (!Array.isArray(points)) return this;
                        var p;
                        //  The points argument is an array, so iterate through it
                        for(var i = 0; i < points.length; i++){
                            p = {
                                x: 0,
                                y: 0
                            };
                            if (typeof points[i] === 'number' || typeof points[i] === 'string') {
                                p.x = parseFloat(points[i]);
                                p.y = parseFloat(points[i + 1]);
                                i++;
                            } else if (Array.isArray(points[i])) {
                                //  An array of arrays?
                                p.x = points[i][0];
                                p.y = points[i][1];
                            } else {
                                p.x = points[i].x;
                                p.y = points[i].y;
                            }
                            this.points.push(p);
                        }
                        this.calculateArea();
                        return this;
                    },
                    /**
     * Calculates the area of the Polygon. This is available in the property Polygon.area
     *
     * @method Phaser.Geom.Polygon#calculateArea
     * @since 3.0.0
     *
     * @return {number} The area of the polygon.
     */ calculateArea: function() {
                        if (this.points.length < 3) {
                            this.area = 0;
                            return this.area;
                        }
                        var sum = 0;
                        var p1;
                        var p2;
                        for(var i = 0; i < this.points.length - 1; i++){
                            p1 = this.points[i];
                            p2 = this.points[i + 1];
                            sum += (p2.x - p1.x) * (p1.y + p2.y);
                        }
                        p1 = this.points[0];
                        p2 = this.points[this.points.length - 1];
                        sum += (p1.x - p2.x) * (p2.y + p1.y);
                        this.area = -sum * 0.5;
                        return this.area;
                    },
                    /**
     * Returns an array of Point objects containing the coordinates of the points around the perimeter of the Polygon,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Polygon#getPoints
     * @since 3.12.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the perimeter of the Polygon and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the perimeter of the Polygon.
     */ getPoints: function(quantity, step, output) {
                        return GetPoints(this, quantity, step, output);
                    }
                });
                module1.exports = Polygon;
            /***/ },
            /***/ 8133: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the order of the points of a Polygon.
 *
 * @function Phaser.Geom.Polygon.Reverse
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to modify.
 *
 * @return {Phaser.Geom.Polygon} The modified Polygon.
 */ var Reverse = function(polygon) {
                    polygon.points.reverse();
                    return polygon;
                };
                module1.exports = Reverse;
            /***/ },
            /***/ 29524: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Vladimir Agafonkin
 * @see          Based on Simplify.js mourner.github.io/simplify-js
 */ /**
 * Copyright (c) 2017, Vladimir Agafonkin
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
 * TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * @ignore
 */ function getSqDist(p1, p2) {
                    var dx = p1.x - p2.x, dy = p1.y - p2.y;
                    return dx * dx + dy * dy;
                }
                /**
 * Square distance from a point to a segment
 *
 * @ignore
 */ function getSqSegDist(p, p1, p2) {
                    var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y;
                    if (dx !== 0 || dy !== 0) {
                        var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
                        if (t > 1) {
                            x = p2.x;
                            y = p2.y;
                        } else if (t > 0) {
                            x += dx * t;
                            y += dy * t;
                        }
                    }
                    dx = p.x - x;
                    dy = p.y - y;
                    return dx * dx + dy * dy;
                }
                /**
 * Basic distance-based simplification
 *
 * @ignore
 */ function simplifyRadialDist(points, sqTolerance) {
                    var prevPoint = points[0], newPoints = [
                        prevPoint
                    ], point;
                    for(var i = 1, len = points.length; i < len; i++){
                        point = points[i];
                        if (getSqDist(point, prevPoint) > sqTolerance) {
                            newPoints.push(point);
                            prevPoint = point;
                        }
                    }
                    if (prevPoint !== point) newPoints.push(point);
                    return newPoints;
                }
                /**
 * @ignore
 */ function simplifyDPStep(points, first, last, sqTolerance, simplified) {
                    var maxSqDist = sqTolerance, index;
                    for(var i = first + 1; i < last; i++){
                        var sqDist = getSqSegDist(points[i], points[first], points[last]);
                        if (sqDist > maxSqDist) {
                            index = i;
                            maxSqDist = sqDist;
                        }
                    }
                    if (maxSqDist > sqTolerance) {
                        if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
                        simplified.push(points[index]);
                        if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
                    }
                }
                /**
 * Simplification using Ramer-Douglas-Peucker algorithm
 *
 * @ignore
 */ function simplifyDouglasPeucker(points, sqTolerance) {
                    var last = points.length - 1;
                    var simplified = [
                        points[0]
                    ];
                    simplifyDPStep(points, 0, last, sqTolerance, simplified);
                    simplified.push(points[last]);
                    return simplified;
                }
                /**
 * Takes a Polygon object and simplifies the points by running them through a combination of
 * Douglas-Peucker and Radial Distance algorithms. Simplification dramatically reduces the number of
 * points in a polygon while retaining its shape, giving a huge performance boost when processing
 * it and also reducing visual noise.
 *
 * @function Phaser.Geom.Polygon.Simplify
 * @since 3.50.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to be simplified. The polygon will be modified in-place and returned.
 * @param {number} [tolerance=1] - Affects the amount of simplification (in the same metric as the point coordinates).
 * @param {boolean} [highestQuality=false] - Excludes distance-based preprocessing step which leads to highest quality simplification but runs ~10-20 times slower.
 *
 * @return {Phaser.Geom.Polygon} The input polygon.
 */ var Simplify = function(polygon, tolerance, highestQuality) {
                    if (tolerance === undefined) tolerance = 1;
                    if (highestQuality === undefined) highestQuality = false;
                    var points = polygon.points;
                    if (points.length > 2) {
                        var sqTolerance = tolerance * tolerance;
                        if (!highestQuality) points = simplifyRadialDist(points, sqTolerance);
                        polygon.setTo(simplifyDouglasPeucker(points, sqTolerance));
                    }
                    return polygon;
                };
                module1.exports = Simplify;
            /***/ },
            /***/ 5469: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Igor Ognichenko <ognichenko.igor@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ var copy = function(out, a) {
                    out[0] = a[0];
                    out[1] = a[1];
                    return out;
                };
                /**
 * Takes a Polygon object and applies Chaikin's smoothing algorithm on its points.
 *
 * @function Phaser.Geom.Polygon.Smooth
 * @since 3.13.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to be smoothed. The polygon will be modified in-place and returned.
 *
 * @return {Phaser.Geom.Polygon} The input polygon.
 */ var Smooth = function(polygon) {
                    var i;
                    var points = [];
                    var data = polygon.points;
                    for(i = 0; i < data.length; i++)points.push([
                        data[i].x,
                        data[i].y
                    ]);
                    var output = [];
                    if (points.length > 0) output.push(copy([
                        0,
                        0
                    ], points[0]));
                    for(i = 0; i < points.length - 1; i++){
                        var p0 = points[i];
                        var p1 = points[i + 1];
                        var p0x = p0[0];
                        var p0y = p0[1];
                        var p1x = p1[0];
                        var p1y = p1[1];
                        output.push([
                            0.85 * p0x + 0.15 * p1x,
                            0.85 * p0y + 0.15 * p1y
                        ]);
                        output.push([
                            0.15 * p0x + 0.85 * p1x,
                            0.15 * p0y + 0.85 * p1y
                        ]);
                    }
                    if (points.length > 1) output.push(copy([
                        0,
                        0
                    ], points[points.length - 1]));
                    return polygon.setTo(output);
                };
                module1.exports = Smooth;
            /***/ },
            /***/ 24709: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tranlates the points of the given Polygon.
 *
 * @function Phaser.Geom.Polygon.Translate
 * @since 3.50.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to modify.
 * @param {number} x - The amount to horizontally translate the points by.
 * @param {number} y - The amount to vertically translate the points by.
 *
 * @return {Phaser.Geom.Polygon} The modified Polygon.
 */ var Translate = function(polygon, x, y) {
                    var points = polygon.points;
                    for(var i = 0; i < points.length; i++){
                        points[i].x += x;
                        points[i].y += y;
                    }
                    return polygon;
                };
                module1.exports = Translate;
            /***/ },
            /***/ 58423: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Polygon = __webpack_require__(25717);
                Polygon.Clone = __webpack_require__(12306);
                Polygon.Contains = __webpack_require__(63814);
                Polygon.ContainsPoint = __webpack_require__(99338);
                Polygon.Earcut = __webpack_require__(94811);
                Polygon.GetAABB = __webpack_require__(13829);
                Polygon.GetNumberArray = __webpack_require__(26173);
                Polygon.GetPoints = __webpack_require__(9564);
                Polygon.Perimeter = __webpack_require__(30052);
                Polygon.Reverse = __webpack_require__(8133);
                Polygon.Simplify = __webpack_require__(29524);
                Polygon.Smooth = __webpack_require__(5469);
                Polygon.Translate = __webpack_require__(24709);
                module1.exports = Polygon;
            /***/ },
            /***/ 62224: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the given Rectangle object.
 *
 * @function Phaser.Geom.Rectangle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to calculate the area of.
 *
 * @return {number} The area of the Rectangle object.
 */ var Area = function(rect) {
                    return rect.width * rect.height;
                };
                module1.exports = Area;
            /***/ },
            /***/ 98615: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position up to the smallest integer greater than or equal to each current coordinate.
 *
 * @function Phaser.Geom.Rectangle.Ceil
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var Ceil = function(rect) {
                    rect.x = Math.ceil(rect.x);
                    rect.y = Math.ceil(rect.y);
                    return rect;
                };
                module1.exports = Ceil;
            /***/ },
            /***/ 31688: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position and size up to the smallest integer greater than or equal to each respective value.
 *
 * @function Phaser.Geom.Rectangle.CeilAll
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to modify.
 *
 * @return {Phaser.Geom.Rectangle} The modified Rectangle.
 */ var CeilAll = function(rect) {
                    rect.x = Math.ceil(rect.x);
                    rect.y = Math.ceil(rect.y);
                    rect.width = Math.ceil(rect.width);
                    rect.height = Math.ceil(rect.height);
                    return rect;
                };
                module1.exports = CeilAll;
            /***/ },
            /***/ 67502: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the top-left corner of a Rectangle so that its center is at the given coordinates.
 *
 * @function Phaser.Geom.Rectangle.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to be centered.
 * @param {number} x - The X coordinate of the Rectangle's center.
 * @param {number} y - The Y coordinate of the Rectangle's center.
 *
 * @return {Phaser.Geom.Rectangle} The centered rectangle.
 */ var CenterOn = function(rect, x, y) {
                    rect.x = x - rect.width / 2;
                    rect.y = y - rect.height / 2;
                    return rect;
                };
                module1.exports = CenterOn;
            /***/ },
            /***/ 65085: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                /**
 * Creates a new Rectangle which is identical to the given one.
 *
 * @function Phaser.Geom.Rectangle.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} source - The Rectangle to clone.
 *
 * @return {Phaser.Geom.Rectangle} The newly created Rectangle, which is separate from the given one.
 */ var Clone = function(source) {
                    return new Rectangle(source.x, source.y, source.width, source.height);
                };
                module1.exports = Clone;
            /***/ },
            /***/ 37303: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if a given point is inside a Rectangle's bounds.
 *
 * @function Phaser.Geom.Rectangle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to check.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is within the Rectangle's bounds, otherwise `false`.
 */ var Contains = function(rect, x, y) {
                    if (rect.width <= 0 || rect.height <= 0) return false;
                    return rect.x <= x && rect.x + rect.width >= x && rect.y <= y && rect.y + rect.height >= y;
                };
                module1.exports = Contains;
            /***/ },
            /***/ 96553: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(37303);
                /**
 * Determines whether the specified point is contained within the rectangular region defined by this Rectangle object.
 *
 * @function Phaser.Geom.Rectangle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle object.
 * @param {Phaser.Geom.Point} point - The point object to be checked. Can be a Phaser Point object or any object with x and y values.
 *
 * @return {boolean} A value of true if the Rectangle object contains the specified point, otherwise false.
 */ var ContainsPoint = function(rect, point) {
                    return Contains(rect, point.x, point.y);
                };
                module1.exports = ContainsPoint;
            /***/ },
            /***/ 70273: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests if one rectangle fully contains another.
 *
 * @function Phaser.Geom.Rectangle.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first rectangle.
 * @param {Phaser.Geom.Rectangle} rectB - The second rectangle.
 *
 * @return {boolean} True only if rectA fully contains rectB.
 */ var ContainsRect = function(rectA, rectB) {
                    //  Volume check (if rectB volume > rectA then rectA cannot contain it)
                    if (rectB.width * rectB.height > rectA.width * rectA.height) return false;
                    return rectB.x > rectA.x && rectB.x < rectA.right && rectB.right > rectA.x && rectB.right < rectA.right && rectB.y > rectA.y && rectB.y < rectA.bottom && rectB.bottom > rectA.y && rectB.bottom < rectA.bottom;
                };
                module1.exports = ContainsRect;
            /***/ },
            /***/ 43459: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Rectangle to a destination Rectangle.
 *
 * @function Phaser.Geom.Rectangle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Rectangle} source - The source Rectangle to copy the values from.
 * @param {Phaser.Geom.Rectangle} dest - The destination Rectangle to copy the values to.
 *
 * @return {Phaser.Geom.Rectangle} The destination Rectangle.
 */ var CopyFrom = function(source, dest) {
                    return dest.setTo(source.x, source.y, source.width, source.height);
                };
                module1.exports = CopyFrom;
            /***/ },
            /***/ 77493: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Create an array of points for each corner of a Rectangle
 * If an array is specified, each point object will be added to the end of the array, otherwise a new array will be created.
 *
 * @function Phaser.Geom.Rectangle.Decompose
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle object to be decomposed.
 * @param {array} [out] - If provided, each point will be added to this array.
 *
 * @return {array} Will return the array you specified or a new array containing the points of the Rectangle.
 */ var Decompose = function(rect, out) {
                    if (out === undefined) out = [];
                    out.push({
                        x: rect.x,
                        y: rect.y
                    });
                    out.push({
                        x: rect.right,
                        y: rect.y
                    });
                    out.push({
                        x: rect.right,
                        y: rect.bottom
                    });
                    out.push({
                        x: rect.x,
                        y: rect.bottom
                    });
                    return out;
                };
                module1.exports = Decompose;
            /***/ },
            /***/ 9219: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y`, `width` and `height` properties of two rectangles.
 *
 * @function Phaser.Geom.Rectangle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle A
 * @param {Phaser.Geom.Rectangle} toCompare - Rectangle B
 *
 * @return {boolean} `true` if the rectangles' properties are an exact match, otherwise `false`.
 */ var Equals = function(rect, toCompare) {
                    return rect.x === toCompare.x && rect.y === toCompare.y && rect.width === toCompare.width && rect.height === toCompare.height;
                };
                module1.exports = Equals;
            /***/ },
            /***/ 53751: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAspectRatio = __webpack_require__(8249);
                /**
 * Adjusts the target rectangle, changing its width, height and position,
 * so that it fits inside the area of the source rectangle, while maintaining its original
 * aspect ratio.
 *
 * Unlike the `FitOutside` function, there may be some space inside the source area not covered.
 *
 * @function Phaser.Geom.Rectangle.FitInside
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The target rectangle to adjust.
 * @param {Phaser.Geom.Rectangle} source - The source rectangle to envelop the target in.
 *
 * @return {Phaser.Geom.Rectangle} The modified target rectangle instance.
 */ var FitInside = function(target, source) {
                    var ratio = GetAspectRatio(target);
                    if (ratio < GetAspectRatio(source)) //  Taller than Wide
                    target.setSize(source.height * ratio, source.height);
                    else //  Wider than Tall
                    target.setSize(source.width, source.width / ratio);
                    return target.setPosition(source.centerX - target.width / 2, source.centerY - target.height / 2);
                };
                module1.exports = FitInside;
            /***/ },
            /***/ 16088: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAspectRatio = __webpack_require__(8249);
                /**
 * Adjusts the target rectangle, changing its width, height and position,
 * so that it fully covers the area of the source rectangle, while maintaining its original
 * aspect ratio.
 *
 * Unlike the `FitInside` function, the target rectangle may extend further out than the source.
 *
 * @function Phaser.Geom.Rectangle.FitOutside
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The target rectangle to adjust.
 * @param {Phaser.Geom.Rectangle} source - The source rectangle to envelope the target in.
 *
 * @return {Phaser.Geom.Rectangle} The modified target rectangle instance.
 */ var FitOutside = function(target, source) {
                    var ratio = GetAspectRatio(target);
                    if (ratio > GetAspectRatio(source)) //  Wider than Tall
                    target.setSize(source.height * ratio, source.height);
                    else //  Taller than Wide
                    target.setSize(source.width, source.width / ratio);
                    return target.setPosition(source.centerX - target.width / 2, source.centerY - target.height / 2);
                };
                module1.exports = FitOutside;
            /***/ },
            /***/ 80774: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds down (floors) the top left X and Y coordinates of the given Rectangle to the largest integer less than or equal to them
 *
 * @function Phaser.Geom.Rectangle.Floor
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to floor the top left X and Y coordinates of
 *
 * @return {Phaser.Geom.Rectangle} The rectangle that was passed to this function with its coordinates floored.
 */ var Floor = function(rect) {
                    rect.x = Math.floor(rect.x);
                    rect.y = Math.floor(rect.y);
                    return rect;
                };
                module1.exports = Floor;
            /***/ },
            /***/ 83859: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position and size down to the largest integer less than or equal to each current coordinate or dimension.
 *
 * @function Phaser.Geom.Rectangle.FloorAll
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var FloorAll = function(rect) {
                    rect.x = Math.floor(rect.x);
                    rect.y = Math.floor(rect.y);
                    rect.width = Math.floor(rect.width);
                    rect.height = Math.floor(rect.height);
                    return rect;
                };
                module1.exports = FloorAll;
            /***/ },
            /***/ 19217: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                var MATH_CONST = __webpack_require__(36383);
                /**
 * Constructs new Rectangle or repositions and resizes an existing Rectangle so that all of the given points are on or within its bounds.
 *
 * The `points` parameter is an array of Point-like objects:
 *
 * ```js
 * const points = [
 *     [100, 200],
 *     [200, 400],
 *     { x: 30, y: 60 }
 * ]
 * ```
 *
 * @function Phaser.Geom.Rectangle.FromPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {array} points - An array of points (either arrays with two elements corresponding to the X and Y coordinate or an object with public `x` and `y` properties) which should be surrounded by the Rectangle.
 * @param {Phaser.Geom.Rectangle} [out] - Optional Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted `out` Rectangle, or a new Rectangle if none was provided.
 */ var FromPoints = function(points, out) {
                    if (out === undefined) out = new Rectangle();
                    if (points.length === 0) return out;
                    var minX = Number.MAX_VALUE;
                    var minY = Number.MAX_VALUE;
                    var maxX = MATH_CONST.MIN_SAFE_INTEGER;
                    var maxY = MATH_CONST.MIN_SAFE_INTEGER;
                    var p;
                    var px;
                    var py;
                    for(var i = 0; i < points.length; i++){
                        p = points[i];
                        if (Array.isArray(p)) {
                            px = p[0];
                            py = p[1];
                        } else {
                            px = p.x;
                            py = p.y;
                        }
                        minX = Math.min(minX, px);
                        minY = Math.min(minY, py);
                        maxX = Math.max(maxX, px);
                        maxY = Math.max(maxY, py);
                    }
                    out.x = minX;
                    out.y = minY;
                    out.width = maxX - minX;
                    out.height = maxY - minY;
                    return out;
                };
                module1.exports = FromPoints;
            /***/ },
            /***/ 9477: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                /**
 * Create the smallest Rectangle containing two coordinate pairs.
 *
 * @function Phaser.Geom.Rectangle.FromXY
 * @since 3.23.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {number} x1 - The X coordinate of the first point.
 * @param {number} y1 - The Y coordinate of the first point.
 * @param {number} x2 - The X coordinate of the second point.
 * @param {number} y2 - The Y coordinate of the second point.
 * @param {Phaser.Geom.Rectangle} [out] - Optional Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted `out` Rectangle, or a new Rectangle if none was provided.
 */ var FromXY = function(x1, y1, x2, y2, out) {
                    if (out === undefined) out = new Rectangle();
                    return out.setTo(Math.min(x1, x2), Math.min(y1, y2), Math.abs(x1 - x2), Math.abs(y1 - y2));
                };
                module1.exports = FromXY;
            /***/ },
            /***/ 8249: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the width/height ratio of a rectangle.
 *
 * @function Phaser.Geom.Rectangle.GetAspectRatio
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle.
 *
 * @return {number} The width/height ratio of the rectangle.
 */ var GetAspectRatio = function(rect) {
                    return rect.height === 0 ? NaN : rect.width / rect.height;
                };
                module1.exports = GetAspectRatio;
            /***/ },
            /***/ 27165: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns the center of a Rectangle as a Point.
 *
 * @function Phaser.Geom.Rectangle.GetCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the center of.
 * @param {(Phaser.Geom.Point|object)} [out] - Optional point-like object to update with the center coordinates.
 *
 * @return {(Phaser.Geom.Point|object)} The modified `out` object, or a new Point if none was provided.
 */ var GetCenter = function(rect, out) {
                    if (out === undefined) out = new Point();
                    out.x = rect.centerX;
                    out.y = rect.centerY;
                    return out;
                };
                module1.exports = GetCenter;
            /***/ },
            /***/ 20812: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Perimeter = __webpack_require__(13019);
                var Point = __webpack_require__(2141);
                /**
 * Calculates the coordinates of a point at a certain `position` on the Rectangle's perimeter.
 *
 * The `position` is a fraction between 0 and 1 which defines how far into the perimeter the point is.
 *
 * A value of 0 or 1 returns the point at the top left corner of the rectangle, while a value of 0.5 returns the point at the bottom right corner of the rectangle. Values between 0 and 0.5 are on the top or the right side and values between 0.5 and 1 are on the bottom or the left side.
 *
 * @function Phaser.Geom.Rectangle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle to get the perimeter point from.
 * @param {number} position - The normalized distance into the Rectangle's perimeter to return.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to update with the `x` and `y` coordinates of the point.
 *
 * @return {Phaser.Geom.Point} The updated `output` object, or a new Point if no `output` object was given.
 */ var GetPoint = function(rectangle, position, out) {
                    if (out === undefined) out = new Point();
                    if (position <= 0 || position >= 1) {
                        out.x = rectangle.x;
                        out.y = rectangle.y;
                        return out;
                    }
                    var p = Perimeter(rectangle) * position;
                    if (position > 0.5) {
                        p -= rectangle.width + rectangle.height;
                        if (p <= rectangle.width) {
                            //  Face 3
                            out.x = rectangle.right - p;
                            out.y = rectangle.bottom;
                        } else {
                            //  Face 4
                            out.x = rectangle.x;
                            out.y = rectangle.bottom - (p - rectangle.width);
                        }
                    } else if (p <= rectangle.width) {
                        //  Face 1
                        out.x = rectangle.x + p;
                        out.y = rectangle.y;
                    } else {
                        //  Face 2
                        out.x = rectangle.right;
                        out.y = rectangle.y + (p - rectangle.width);
                    }
                    return out;
                };
                module1.exports = GetPoint;
            /***/ },
            /***/ 34819: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetPoint = __webpack_require__(20812);
                var Perimeter = __webpack_require__(13019);
                /**
 * Return an array of points from the perimeter of the rectangle, each spaced out based on the quantity or step required.
 *
 * @function Phaser.Geom.Rectangle.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle object to get the points from.
 * @param {number} step - Step between points. Used to calculate the number of points to return when quantity is falsey. Ignored if quantity is positive.
 * @param {number} quantity - The number of evenly spaced points from the rectangles perimeter to return. If falsey, step param will be used to calculate the number of points.
 * @param {(array|Phaser.Geom.Point[])} [out] - An optional array to store the points in.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Points from the perimeter of the rectangle.
 */ var GetPoints = function(rectangle, quantity, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!quantity && stepRate > 0) quantity = Perimeter(rectangle) / stepRate;
                    for(var i = 0; i < quantity; i++){
                        var position = i / quantity;
                        out.push(GetPoint(rectangle, position));
                    }
                    return out;
                };
                module1.exports = GetPoints;
            /***/ },
            /***/ 51313: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns the size of the Rectangle, expressed as a Point object.
 * With the value of the `width` as the `x` property and the `height` as the `y` property.
 *
 * @function Phaser.Geom.Rectangle.GetSize
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the size from.
 * @param {(Phaser.Geom.Point|object)} [out] - The Point object to store the size in. If not given, a new Point instance is created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where `x` holds the width and `y` holds the height of the Rectangle.
 */ var GetSize = function(rect, out) {
                    if (out === undefined) out = new Point();
                    out.x = rect.width;
                    out.y = rect.height;
                    return out;
                };
                module1.exports = GetSize;
            /***/ },
            /***/ 86091: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CenterOn = __webpack_require__(67502);
                /**
 * Increases the size of a Rectangle by a specified amount.
 *
 * The center of the Rectangle stays the same. The amounts are added to each side, so the actual increase in width or height is two times bigger than the respective argument.
 *
 * @function Phaser.Geom.Rectangle.Inflate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to inflate.
 * @param {number} x - How many pixels the left and the right side should be moved by horizontally.
 * @param {number} y - How many pixels the top and the bottom side should be moved by vertically.
 *
 * @return {Phaser.Geom.Rectangle} The inflated Rectangle.
 */ var Inflate = function(rect, x, y) {
                    var cx = rect.centerX;
                    var cy = rect.centerY;
                    rect.setSize(rect.width + x * 2, rect.height + y * 2);
                    return CenterOn(rect, cx, cy);
                };
                module1.exports = Inflate;
            /***/ },
            /***/ 53951: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                var Intersects = __webpack_require__(59996);
                /**
 * Takes two Rectangles and first checks to see if they intersect.
 * If they intersect it will return the area of intersection in the `out` Rectangle.
 * If they do not intersect, the `out` Rectangle will have a width and height of zero.
 *
 * @function Phaser.Geom.Rectangle.Intersection
 * @since 3.11.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to get the intersection from.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to get the intersection from.
 * @param {Phaser.Geom.Rectangle} [out] - A Rectangle to store the intersection results in.
 *
 * @return {Phaser.Geom.Rectangle} The intersection result. If the width and height are zero, no intersection occurred.
 */ var Intersection = function(rectA, rectB, out) {
                    if (out === undefined) out = new Rectangle();
                    if (Intersects(rectA, rectB)) {
                        out.x = Math.max(rectA.x, rectB.x);
                        out.y = Math.max(rectA.y, rectB.y);
                        out.width = Math.min(rectA.right, rectB.right) - out.x;
                        out.height = Math.min(rectA.bottom, rectB.bottom) - out.y;
                    } else out.setEmpty();
                    return out;
                };
                module1.exports = Intersection;
            /***/ },
            /***/ 14649: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Perimeter = __webpack_require__(13019);
                var Point = __webpack_require__(2141);
                /**
 * Returns an array of points from the perimeter of the Rectangle, where each point is spaced out based
 * on either the `step` value, or the `quantity`.
 *
 * @function Phaser.Geom.Rectangle.MarchingAnts
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the perimeter points from.
 * @param {number} [step] - The distance between each point of the perimeter. Set to `null` if you wish to use the `quantity` parameter instead.
 * @param {number} [quantity] - The total number of points to return. The step is then calculated based on the length of the Rectangle, divided by this value.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array in which the perimeter points will be stored. If not given, a new array instance is created.
 *
 * @return {(array|Phaser.Geom.Point[])} An array containing the perimeter points from the Rectangle.
 */ var MarchingAnts = function(rect, step, quantity, out) {
                    if (out === undefined) out = [];
                    if (!step && !quantity) //  Bail out
                    return out;
                    //  If step is a falsey value (false, null, 0, undefined, etc) then we calculate
                    //  it based on the quantity instead, otherwise we always use the step value
                    if (!step) step = Perimeter(rect) / quantity;
                    else quantity = Math.round(Perimeter(rect) / step);
                    var x = rect.x;
                    var y = rect.y;
                    var face = 0;
                    //  Loop across each face of the rectangle
                    for(var i = 0; i < quantity; i++){
                        out.push(new Point(x, y));
                        switch(face){
                            //  Top face
                            case 0:
                                x += step;
                                if (x >= rect.right) {
                                    face = 1;
                                    y += x - rect.right;
                                    x = rect.right;
                                }
                                break;
                            //  Right face
                            case 1:
                                y += step;
                                if (y >= rect.bottom) {
                                    face = 2;
                                    x -= y - rect.bottom;
                                    y = rect.bottom;
                                }
                                break;
                            //  Bottom face
                            case 2:
                                x -= step;
                                if (x <= rect.left) {
                                    face = 3;
                                    y -= rect.left - x;
                                    x = rect.left;
                                }
                                break;
                            //  Left face
                            case 3:
                                y -= step;
                                if (y <= rect.top) {
                                    face = 0;
                                    y = rect.top;
                                }
                                break;
                        }
                    }
                    return out;
                };
                module1.exports = MarchingAnts;
            /***/ },
            /***/ 33595: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Merges a Rectangle with a list of points by repositioning and/or resizing it such that all points are located on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.MergePoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The Rectangle which should be merged.
 * @param {Phaser.Geom.Point[]} points - An array of Points (or any object with public `x` and `y` properties) which should be merged with the Rectangle.
 *
 * @return {Phaser.Geom.Rectangle} The modified Rectangle.
 */ var MergePoints = function(target, points) {
                    var minX = target.x;
                    var maxX = target.right;
                    var minY = target.y;
                    var maxY = target.bottom;
                    for(var i = 0; i < points.length; i++){
                        minX = Math.min(minX, points[i].x);
                        maxX = Math.max(maxX, points[i].x);
                        minY = Math.min(minY, points[i].y);
                        maxY = Math.max(maxY, points[i].y);
                    }
                    target.x = minX;
                    target.y = minY;
                    target.width = maxX - minX;
                    target.height = maxY - minY;
                    return target;
                };
                module1.exports = MergePoints;
            /***/ },
            /***/ 20074: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Merges the source rectangle into the target rectangle and returns the target.
 * Neither rectangle should have a negative width or height.
 *
 * @function Phaser.Geom.Rectangle.MergeRect
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - Target rectangle. Will be modified to include source rectangle.
 * @param {Phaser.Geom.Rectangle} source - Rectangle that will be merged into target rectangle.
 *
 * @return {Phaser.Geom.Rectangle} Modified target rectangle that contains source rectangle.
 */ var MergeRect = function(target, source) {
                    var minX = Math.min(target.x, source.x);
                    var maxX = Math.max(target.right, source.right);
                    target.x = minX;
                    target.width = maxX - minX;
                    var minY = Math.min(target.y, source.y);
                    var maxY = Math.max(target.bottom, source.bottom);
                    target.y = minY;
                    target.height = maxY - minY;
                    return target;
                };
                module1.exports = MergeRect;
            /***/ },
            /***/ 92171: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Merges a Rectangle with a point by repositioning and/or resizing it so that the point is on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.MergeXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The Rectangle which should be merged and modified.
 * @param {number} x - The X coordinate of the point which should be merged.
 * @param {number} y - The Y coordinate of the point which should be merged.
 *
 * @return {Phaser.Geom.Rectangle} The modified `target` Rectangle.
 */ var MergeXY = function(target, x, y) {
                    var minX = Math.min(target.x, x);
                    var maxX = Math.max(target.right, x);
                    target.x = minX;
                    target.width = maxX - minX;
                    var minY = Math.min(target.y, y);
                    var maxY = Math.max(target.bottom, y);
                    target.y = minY;
                    target.height = maxY - minY;
                    return target;
                };
                module1.exports = MergeXY;
            /***/ },
            /***/ 42981: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Nudges (translates) the top left corner of a Rectangle by a given offset.
 *
 * @function Phaser.Geom.Rectangle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 * @param {number} x - The distance to move the Rectangle horizontally.
 * @param {number} y - The distance to move the Rectangle vertically.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var Offset = function(rect, x, y) {
                    rect.x += x;
                    rect.y += y;
                    return rect;
                };
                module1.exports = Offset;
            /***/ },
            /***/ 46907: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Nudges (translates) the top-left corner of a Rectangle by the coordinates of a point (translation vector).
 *
 * @function Phaser.Geom.Rectangle.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 * @param {(Phaser.Geom.Point|Phaser.Math.Vector2)} point - The point whose coordinates should be used as an offset.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var OffsetPoint = function(rect, point) {
                    rect.x += point.x;
                    rect.y += point.y;
                    return rect;
                };
                module1.exports = OffsetPoint;
            /***/ },
            /***/ 60170: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if two Rectangles overlap. If a Rectangle is within another Rectangle, the two will be considered overlapping. Thus, the Rectangles are treated as "solid".
 *
 * @function Phaser.Geom.Rectangle.Overlaps
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check.
 *
 * @return {boolean} `true` if the two Rectangles overlap, `false` otherwise.
 */ var Overlaps = function(rectA, rectB) {
                    return rectA.x < rectB.right && rectA.right > rectB.x && rectA.y < rectB.bottom && rectA.bottom > rectB.y;
                };
                module1.exports = Overlaps;
            /***/ },
            /***/ 13019: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the perimeter of a Rectangle.
 *
 * @function Phaser.Geom.Rectangle.Perimeter
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to use.
 *
 * @return {number} The perimeter of the Rectangle, equal to `(width * 2) + (height * 2)`.
 */ var Perimeter = function(rect) {
                    return 2 * (rect.width + rect.height);
                };
                module1.exports = Perimeter;
            /***/ },
            /***/ 85133: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                var DegToRad = __webpack_require__(39506);
                /**
 * Returns a Point from the perimeter of a Rectangle based on the given angle.
 *
 * @function Phaser.Geom.Rectangle.PerimeterPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle to get the perimeter point from.
 * @param {number} angle - The angle of the point, in degrees.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of the Rectangle perimeter.
 */ var PerimeterPoint = function(rectangle, angle, out) {
                    if (out === undefined) out = new Point();
                    angle = DegToRad(angle);
                    var s = Math.sin(angle);
                    var c = Math.cos(angle);
                    var dx = c > 0 ? rectangle.width / 2 : rectangle.width / -2;
                    var dy = s > 0 ? rectangle.height / 2 : rectangle.height / -2;
                    if (Math.abs(dx * s) < Math.abs(dy * c)) dy = dx * s / c;
                    else dx = dy * c / s;
                    out.x = dx + rectangle.centerX;
                    out.y = dy + rectangle.centerY;
                    return out;
                };
                module1.exports = PerimeterPoint;
            /***/ },
            /***/ 26597: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns a random point within a Rectangle.
 *
 * @function Phaser.Geom.Rectangle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to return a point from.
 * @param {Phaser.Geom.Point} out - The object to update with the point's coordinates.
 *
 * @return {Phaser.Geom.Point} The modified `out` object, or a new Point if none was provided.
 */ var Random = function(rect, out) {
                    if (out === undefined) out = new Point();
                    out.x = rect.x + Math.random() * rect.width;
                    out.y = rect.y + Math.random() * rect.height;
                    return out;
                };
                module1.exports = Random;
            /***/ },
            /***/ 86470: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(30976);
                var ContainsRect = __webpack_require__(70273);
                var Point = __webpack_require__(2141);
                /**
 * Calculates a random point that lies within the `outer` Rectangle, but outside of the `inner` Rectangle.
 * The inner Rectangle must be fully contained within the outer rectangle.
 *
 * @function Phaser.Geom.Rectangle.RandomOutside
 * @since 3.10.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} outer - The outer Rectangle to get the random point within.
 * @param {Phaser.Geom.Rectangle} inner - The inner Rectangle to exclude from the returned point.
 * @param {Phaser.Geom.Point} [out] - A Point, or Point-like object to store the result in. If not specified, a new Point will be created.
 *
 * @return {Phaser.Geom.Point} A Point object containing the random values in its `x` and `y` properties.
 */ var RandomOutside = function(outer, inner, out) {
                    if (out === undefined) out = new Point();
                    if (ContainsRect(outer, inner)) //  Pick a random quadrant
                    //
                    //  The quadrants don't extend the full widths / heights of the outer rect to give
                    //  us a better uniformed distribution, otherwise you get clumping in the corners where
                    //  the 4 quads would overlap
                    switch(Between(0, 3)){
                        case 0:
                            out.x = outer.x + Math.random() * (inner.right - outer.x);
                            out.y = outer.y + Math.random() * (inner.top - outer.y);
                            break;
                        case 1:
                            out.x = inner.x + Math.random() * (outer.right - inner.x);
                            out.y = inner.bottom + Math.random() * (outer.bottom - inner.bottom);
                            break;
                        case 2:
                            out.x = outer.x + Math.random() * (inner.x - outer.x);
                            out.y = inner.y + Math.random() * (outer.bottom - inner.y);
                            break;
                        case 3:
                            out.x = inner.right + Math.random() * (outer.right - inner.right);
                            out.y = outer.y + Math.random() * (inner.bottom - outer.y);
                            break;
                    }
                    return out;
                };
                module1.exports = RandomOutside;
            /***/ },
            /***/ 87841: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Contains = __webpack_require__(37303);
                var GetPoint = __webpack_require__(20812);
                var GetPoints = __webpack_require__(34819);
                var GEOM_CONST = __webpack_require__(23777);
                var Line = __webpack_require__(23031);
                var Random = __webpack_require__(26597);
                /**
 * @classdesc
 * Encapsulates a 2D rectangle defined by its corner point in the top-left and its extends in x (width) and y (height)
 *
 * @class Rectangle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The X coordinate of the top left corner of the Rectangle.
 * @param {number} [y=0] - The Y coordinate of the top left corner of the Rectangle.
 * @param {number} [width=0] - The width of the Rectangle.
 * @param {number} [height=0] - The height of the Rectangle.
 */ var Rectangle = new Class({
                    initialize: function Rectangle(x, y, width, height) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = 0;
                        if (height === undefined) height = 0;
                        /**
         * The geometry constant type of this object: `GEOM_CONST.RECTANGLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Rectangle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.RECTANGLE;
                        /**
         * The X coordinate of the top left corner of the Rectangle.
         *
         * @name Phaser.Geom.Rectangle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                        /**
         * The Y coordinate of the top left corner of the Rectangle.
         *
         * @name Phaser.Geom.Rectangle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                        /**
         * The width of the Rectangle, i.e. the distance between its left side (defined by `x`) and its right side.
         *
         * @name Phaser.Geom.Rectangle#width
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.width = width;
                        /**
         * The height of the Rectangle, i.e. the distance between its top side (defined by `y`) and its bottom side.
         *
         * @name Phaser.Geom.Rectangle#height
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.height = height;
                    },
                    /**
     * Checks if the given point is inside the Rectangle's bounds.
     *
     * @method Phaser.Geom.Rectangle#contains
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the point to check.
     * @param {number} y - The Y coordinate of the point to check.
     *
     * @return {boolean} `true` if the point is within the Rectangle's bounds, otherwise `false`.
     */ contains: function(x, y) {
                        return Contains(this, x, y);
                    },
                    /**
     * Calculates the coordinates of a point at a certain `position` on the Rectangle's perimeter.
     *
     * The `position` is a fraction between 0 and 1 which defines how far into the perimeter the point is.
     *
     * A value of 0 or 1 returns the point at the top left corner of the rectangle, while a value of 0.5 returns the point at the bottom right corner of the rectangle. Values between 0 and 0.5 are on the top or the right side and values between 0.5 and 1 are on the bottom or the left side.
     *
     * @method Phaser.Geom.Rectangle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - The normalized distance into the Rectangle's perimeter to return.
     * @param {(Phaser.Geom.Point|object)} [output] - An object to update with the `x` and `y` coordinates of the point.
     *
     * @return {(Phaser.Geom.Point|object)} The updated `output` object, or a new Point if no `output` object was given.
     */ getPoint: function(position, output) {
                        return GetPoint(this, position, output);
                    },
                    /**
     * Returns an array of points from the perimeter of the Rectangle, each spaced out based on the quantity or step required.
     *
     * @method Phaser.Geom.Rectangle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The number of points to return. Set to `false` or 0 to return an arbitrary number of points (`perimeter / stepRate`) evenly spaced around the Rectangle based on the `stepRate`.
     * @param {number} [stepRate] - If `quantity` is 0, determines the normalized distance between each returned point.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to which to append the points.
     *
     * @return {(array|Phaser.Geom.Point[])} The modified `output` array, or a new array if none was provided.
     */ getPoints: function(quantity, stepRate, output) {
                        return GetPoints(this, quantity, stepRate, output);
                    },
                    /**
     * Returns a random point within the Rectangle's bounds.
     *
     * @method Phaser.Geom.Rectangle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {Phaser.Geom.Point} [point] - The object in which to store the `x` and `y` coordinates of the point.
     *
     * @return {Phaser.Geom.Point} The updated `point`, or a new Point if none was provided.
     */ getRandomPoint: function(point) {
                        return Random(this, point);
                    },
                    /**
     * Sets the position, width, and height of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setTo
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the top left corner of the Rectangle.
     * @param {number} y - The Y coordinate of the top left corner of the Rectangle.
     * @param {number} width - The width of the Rectangle.
     * @param {number} height - The height of the Rectangle.
     *
     * @return {this} This Rectangle object.
     */ setTo: function(x, y, width, height) {
                        this.x = x;
                        this.y = y;
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Resets the position, width, and height of the Rectangle to 0.
     *
     * @method Phaser.Geom.Rectangle#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Rectangle object.
     */ setEmpty: function() {
                        return this.setTo(0, 0, 0, 0);
                    },
                    /**
     * Sets the position of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the top left corner of the Rectangle.
     * @param {number} [y=x] - The Y coordinate of the top left corner of the Rectangle.
     *
     * @return {this} This Rectangle object.
     */ setPosition: function(x, y) {
                        if (y === undefined) y = x;
                        this.x = x;
                        this.y = y;
                        return this;
                    },
                    /**
     * Sets the width and height of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width to set the Rectangle to.
     * @param {number} [height=width] - The height to set the Rectangle to.
     *
     * @return {this} This Rectangle object.
     */ setSize: function(width, height) {
                        if (height === undefined) height = width;
                        this.width = width;
                        this.height = height;
                        return this;
                    },
                    /**
     * Determines if the Rectangle is empty. A Rectangle is empty if its width or height is less than or equal to 0.
     *
     * @method Phaser.Geom.Rectangle#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Rectangle is empty. A Rectangle object is empty if its width or height is less than or equal to 0.
     */ isEmpty: function() {
                        return this.width <= 0 || this.height <= 0;
                    },
                    /**
     * Returns a Line object that corresponds to the top of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineA
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the top of this Rectangle.
     */ getLineA: function(line) {
                        if (line === undefined) line = new Line();
                        line.setTo(this.x, this.y, this.right, this.y);
                        return line;
                    },
                    /**
     * Returns a Line object that corresponds to the right of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineB
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the right of this Rectangle.
     */ getLineB: function(line) {
                        if (line === undefined) line = new Line();
                        line.setTo(this.right, this.y, this.right, this.bottom);
                        return line;
                    },
                    /**
     * Returns a Line object that corresponds to the bottom of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineC
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the bottom of this Rectangle.
     */ getLineC: function(line) {
                        if (line === undefined) line = new Line();
                        line.setTo(this.right, this.bottom, this.x, this.bottom);
                        return line;
                    },
                    /**
     * Returns a Line object that corresponds to the left of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineD
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the left of this Rectangle.
     */ getLineD: function(line) {
                        if (line === undefined) line = new Line();
                        line.setTo(this.x, this.bottom, this.x, this.y);
                        return line;
                    },
                    /**
     * The x coordinate of the left of the Rectangle.
     * Changing the left property of a Rectangle object has no effect on the y and height properties. However it does affect the width property, whereas changing the x value does not affect the width property.
     *
     * @name Phaser.Geom.Rectangle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                        get: function() {
                            return this.x;
                        },
                        set: function(value) {
                            if (value >= this.right) this.width = 0;
                            else this.width = this.right - value;
                            this.x = value;
                        }
                    },
                    /**
     * The sum of the x and width properties.
     * Changing the right property of a Rectangle object has no effect on the x, y and height properties, however it does affect the width property.
     *
     * @name Phaser.Geom.Rectangle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                        get: function() {
                            return this.x + this.width;
                        },
                        set: function(value) {
                            if (value <= this.x) this.width = 0;
                            else this.width = value - this.x;
                        }
                    },
                    /**
     * The y coordinate of the top of the Rectangle. Changing the top property of a Rectangle object has no effect on the x and width properties.
     * However it does affect the height property, whereas changing the y value does not affect the height property.
     *
     * @name Phaser.Geom.Rectangle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                        get: function() {
                            return this.y;
                        },
                        set: function(value) {
                            if (value >= this.bottom) this.height = 0;
                            else this.height = this.bottom - value;
                            this.y = value;
                        }
                    },
                    /**
     * The sum of the y and height properties.
     * Changing the bottom property of a Rectangle object has no effect on the x, y and width properties, but does change the height property.
     *
     * @name Phaser.Geom.Rectangle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                        get: function() {
                            return this.y + this.height;
                        },
                        set: function(value) {
                            if (value <= this.y) this.height = 0;
                            else this.height = value - this.y;
                        }
                    },
                    /**
     * The x coordinate of the center of the Rectangle.
     *
     * @name Phaser.Geom.Rectangle#centerX
     * @type {number}
     * @since 3.0.0
     */ centerX: {
                        get: function() {
                            return this.x + this.width / 2;
                        },
                        set: function(value) {
                            this.x = value - this.width / 2;
                        }
                    },
                    /**
     * The y coordinate of the center of the Rectangle.
     *
     * @name Phaser.Geom.Rectangle#centerY
     * @type {number}
     * @since 3.0.0
     */ centerY: {
                        get: function() {
                            return this.y + this.height / 2;
                        },
                        set: function(value) {
                            this.y = value - this.height / 2;
                        }
                    }
                });
                module1.exports = Rectangle;
            /***/ },
            /***/ 94845: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines if the two objects (either Rectangles or Rectangle-like) have the same width and height values under strict equality.
 *
 * @function Phaser.Geom.Rectangle.SameDimensions
 * @since 3.15.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The first Rectangle object.
 * @param {Phaser.Geom.Rectangle} toCompare - The second Rectangle object.
 *
 * @return {boolean} `true` if the objects have equivalent values for the `width` and `height` properties, otherwise `false`.
 */ var SameDimensions = function(rect, toCompare) {
                    return rect.width === toCompare.width && rect.height === toCompare.height;
                };
                module1.exports = SameDimensions;
            /***/ },
            /***/ 31730: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Scales the width and height of this Rectangle by the given amounts.
 *
 * @function Phaser.Geom.Rectangle.Scale
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The `Rectangle` object that will be scaled by the specified amount(s).
 * @param {number} x - The factor by which to scale the rectangle horizontally.
 * @param {number} y - The amount by which to scale the rectangle vertically. If this is not specified, the rectangle will be scaled by the factor `x` in both directions.
 *
 * @return {Phaser.Geom.Rectangle} The rectangle object with updated `width` and `height` properties as calculated from the scaling factor(s).
 */ var Scale = function(rect, x, y) {
                    if (y === undefined) y = x;
                    rect.width *= x;
                    rect.height *= y;
                    return rect;
                };
                module1.exports = Scale;
            /***/ },
            /***/ 36899: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                /**
 * Creates a new Rectangle or repositions and/or resizes an existing Rectangle so that it encompasses the two given Rectangles, i.e. calculates their union.
 *
 * @function Phaser.Geom.Rectangle.Union
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to use.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to use.
 * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the union in.
 *
 * @return {Phaser.Geom.Rectangle} The modified `out` Rectangle, or a new Rectangle if none was provided.
 */ var Union = function(rectA, rectB, out) {
                    if (out === undefined) out = new Rectangle();
                    //  Cache vars so we can use one of the input rects as the output rect
                    var x = Math.min(rectA.x, rectB.x);
                    var y = Math.min(rectA.y, rectB.y);
                    var w = Math.max(rectA.right, rectB.right) - x;
                    var h = Math.max(rectA.bottom, rectB.bottom) - y;
                    return out.setTo(x, y, w, h);
                };
                module1.exports = Union;
            /***/ },
            /***/ 93232: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                Rectangle.Area = __webpack_require__(62224);
                Rectangle.Ceil = __webpack_require__(98615);
                Rectangle.CeilAll = __webpack_require__(31688);
                Rectangle.CenterOn = __webpack_require__(67502);
                Rectangle.Clone = __webpack_require__(65085);
                Rectangle.Contains = __webpack_require__(37303);
                Rectangle.ContainsPoint = __webpack_require__(96553);
                Rectangle.ContainsRect = __webpack_require__(70273);
                Rectangle.CopyFrom = __webpack_require__(43459);
                Rectangle.Decompose = __webpack_require__(77493);
                Rectangle.Equals = __webpack_require__(9219);
                Rectangle.FitInside = __webpack_require__(53751);
                Rectangle.FitOutside = __webpack_require__(16088);
                Rectangle.Floor = __webpack_require__(80774);
                Rectangle.FloorAll = __webpack_require__(83859);
                Rectangle.FromPoints = __webpack_require__(19217);
                Rectangle.FromXY = __webpack_require__(9477);
                Rectangle.GetAspectRatio = __webpack_require__(8249);
                Rectangle.GetCenter = __webpack_require__(27165);
                Rectangle.GetPoint = __webpack_require__(20812);
                Rectangle.GetPoints = __webpack_require__(34819);
                Rectangle.GetSize = __webpack_require__(51313);
                Rectangle.Inflate = __webpack_require__(86091);
                Rectangle.Intersection = __webpack_require__(53951);
                Rectangle.MarchingAnts = __webpack_require__(14649);
                Rectangle.MergePoints = __webpack_require__(33595);
                Rectangle.MergeRect = __webpack_require__(20074);
                Rectangle.MergeXY = __webpack_require__(92171);
                Rectangle.Offset = __webpack_require__(42981);
                Rectangle.OffsetPoint = __webpack_require__(46907);
                Rectangle.Overlaps = __webpack_require__(60170);
                Rectangle.Perimeter = __webpack_require__(13019);
                Rectangle.PerimeterPoint = __webpack_require__(85133);
                Rectangle.Random = __webpack_require__(26597);
                Rectangle.RandomOutside = __webpack_require__(86470);
                Rectangle.SameDimensions = __webpack_require__(94845);
                Rectangle.Scale = __webpack_require__(31730);
                Rectangle.Union = __webpack_require__(36899);
                module1.exports = Rectangle;
            /***/ },
            /***/ 41658: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // The 2D area of a triangle. The area value is always non-negative.
                /**
 * Returns the area of a Triangle.
 *
 * @function Phaser.Geom.Triangle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use.
 *
 * @return {number} The area of the Triangle, always non-negative.
 */ var Area = function(triangle) {
                    var x1 = triangle.x1;
                    var y1 = triangle.y1;
                    var x2 = triangle.x2;
                    var y2 = triangle.y2;
                    var x3 = triangle.x3;
                    var y3 = triangle.y3;
                    return Math.abs(((x3 - x1) * (y2 - y1) - (x2 - x1) * (y3 - y1)) / 2);
                };
                module1.exports = Area;
            /***/ },
            /***/ 39208: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(16483);
                /**
 * Builds an equilateral triangle. In the equilateral triangle, all the sides are the same length (congruent) and all the angles are the same size (congruent).
 * The x/y specifies the top-middle of the triangle (x1/y1) and length is the length of each side.
 *
 * @function Phaser.Geom.Triangle.BuildEquilateral
 * @since 3.0.0
 *
 * @param {number} x - x coordinate of the top point of the triangle.
 * @param {number} y - y coordinate of the top point of the triangle.
 * @param {number} length - Length of each side of the triangle.
 *
 * @return {Phaser.Geom.Triangle} The Triangle object of the given size.
 */ var BuildEquilateral = function(x, y, length) {
                    var height = length * (Math.sqrt(3) / 2);
                    var x1 = x;
                    var y1 = y;
                    var x2 = x + length / 2;
                    var y2 = y + height;
                    var x3 = x - length / 2;
                    var y3 = y + height;
                    return new Triangle(x1, y1, x2, y2, x3, y3);
                };
                module1.exports = BuildEquilateral;
            /***/ },
            /***/ 39545: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var EarCut = __webpack_require__(94811);
                var Triangle = __webpack_require__(16483);
                /**
 * Takes an array of vertex coordinates, and optionally an array of hole indices, then returns an array
 * of Triangle instances, where the given vertices have been decomposed into a series of triangles.
 *
 * @function Phaser.Geom.Triangle.BuildFromPolygon
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle[]} O - [out,$return]
 *
 * @param {array} data - A flat array of vertex coordinates like [x0,y0, x1,y1, x2,y2, ...]
 * @param {array} [holes=null] - An array of hole indices if any (e.g. [5, 8] for a 12-vertex input would mean one hole with vertices 5–7 and another with 8–11).
 * @param {number} [scaleX=1] - Horizontal scale factor to multiply the resulting points by.
 * @param {number} [scaleY=1] - Vertical scale factor to multiply the resulting points by.
 * @param {(array|Phaser.Geom.Triangle[])} [out] - An array to store the resulting Triangle instances in. If not provided, a new array is created.
 *
 * @return {(array|Phaser.Geom.Triangle[])} An array of Triangle instances, where each triangle is based on the decomposed vertices data.
 */ var BuildFromPolygon = function(data, holes, scaleX, scaleY, out) {
                    if (holes === undefined) holes = null;
                    if (scaleX === undefined) scaleX = 1;
                    if (scaleY === undefined) scaleY = 1;
                    if (out === undefined) out = [];
                    var tris = EarCut(data, holes);
                    var a;
                    var b;
                    var c;
                    var x1;
                    var y1;
                    var x2;
                    var y2;
                    var x3;
                    var y3;
                    for(var i = 0; i < tris.length; i += 3){
                        a = tris[i];
                        b = tris[i + 1];
                        c = tris[i + 2];
                        x1 = data[a * 2] * scaleX;
                        y1 = data[a * 2 + 1] * scaleY;
                        x2 = data[b * 2] * scaleX;
                        y2 = data[b * 2 + 1] * scaleY;
                        x3 = data[c * 2] * scaleX;
                        y3 = data[c * 2 + 1] * scaleY;
                        out.push(new Triangle(x1, y1, x2, y2, x3, y3));
                    }
                    return out;
                };
                module1.exports = BuildFromPolygon;
            /***/ },
            /***/ 90301: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(16483);
                //  Builds a right triangle, with one 90 degree angle and two acute angles
                //  The x/y is the coordinate of the 90 degree angle (and will map to x1/y1 in the resulting Triangle)
                //  w/h can be positive or negative and represent the length of each side
                /**
 * Builds a right triangle, i.e. one which has a 90-degree angle and two acute angles.
 *
 * @function Phaser.Geom.Triangle.BuildRight
 * @since 3.0.0
 *
 * @param {number} x - The X coordinate of the right angle, which will also be the first X coordinate of the constructed Triangle.
 * @param {number} y - The Y coordinate of the right angle, which will also be the first Y coordinate of the constructed Triangle.
 * @param {number} width - The length of the side which is to the left or to the right of the right angle.
 * @param {number} height - The length of the side which is above or below the right angle.
 *
 * @return {Phaser.Geom.Triangle} The constructed right Triangle.
 */ var BuildRight = function(x, y, width, height) {
                    if (height === undefined) height = width;
                    //  90 degree angle
                    var x1 = x;
                    var y1 = y;
                    var x2 = x;
                    var y2 = y - height;
                    var x3 = x + width;
                    var y3 = y;
                    return new Triangle(x1, y1, x2, y2, x3, y3);
                };
                module1.exports = BuildRight;
            /***/ },
            /***/ 23707: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Centroid = __webpack_require__(97523);
                var Offset = __webpack_require__(13584);
                /**
 * @callback CenterFunction
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to return the center coordinates of.
 *
 * @return {Phaser.Math.Vector2} The center point of the Triangle according to the function.
 */ /**
 * Positions the Triangle so that it is centered on the given coordinates.
 *
 * @function Phaser.Geom.Triangle.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle to be positioned.
 * @param {number} x - The horizontal coordinate to center on.
 * @param {number} y - The vertical coordinate to center on.
 * @param {CenterFunction} [centerFunc] - The function used to center the triangle. Defaults to Centroid centering.
 *
 * @return {Phaser.Geom.Triangle} The Triangle that was centered.
 */ var CenterOn = function(triangle, x, y, centerFunc) {
                    if (centerFunc === undefined) centerFunc = Centroid;
                    //  Get the center of the triangle
                    var center = centerFunc(triangle);
                    //  Difference
                    var diffX = x - center.x;
                    var diffY = y - center.y;
                    return Offset(triangle, diffX, diffY);
                };
                module1.exports = CenterOn;
            /***/ },
            /***/ 97523: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                //  The three medians (the lines drawn from the vertices to the bisectors of the opposite sides)
                //  meet in the centroid or center of mass (center of gravity).
                //  The centroid divides each median in a ratio of 2:1
                /**
 * Calculates the position of a Triangle's centroid, which is also its center of mass (center of gravity).
 *
 * The centroid is the point in a Triangle at which its three medians (the lines drawn from the vertices to the bisectors of the opposite sides) meet. It divides each one in a 2:1 ratio.
 *
 * @function Phaser.Geom.Triangle.Centroid
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the coordinates in.
 *
 * @return {(Phaser.Geom.Point|object)} The `out` object with modified `x` and `y` properties, or a new Point if none was provided.
 */ var Centroid = function(triangle, out) {
                    if (out === undefined) out = new Point();
                    out.x = (triangle.x1 + triangle.x2 + triangle.x3) / 3;
                    out.y = (triangle.y1 + triangle.y2 + triangle.y3) / 3;
                    return out;
                };
                module1.exports = Centroid;
            /***/ },
            /***/ 24951: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                //  Adapted from http://bjornharrtell.github.io/jsts/doc/api/jsts_geom_Triangle.js.html
                /**
 * Computes the determinant of a 2x2 matrix. Uses standard double-precision arithmetic, so is susceptible to round-off error.
 *
 * @function det
 * @private
 * @since 3.0.0
 *
 * @param {number} m00 - The [0,0] entry of the matrix.
 * @param {number} m01 - The [0,1] entry of the matrix.
 * @param {number} m10 - The [1,0] entry of the matrix.
 * @param {number} m11 - The [1,1] entry of the matrix.
 *
 * @return {number} the determinant.
 */ function det(m00, m01, m10, m11) {
                    return m00 * m11 - m01 * m10;
                }
                /**
 * Computes the circumcentre of a triangle. The circumcentre is the centre of
 * the circumcircle, the smallest circle which encloses the triangle. It is also
 * the common intersection point of the perpendicular bisectors of the sides of
 * the triangle, and is the only point which has equal distance to all three
 * vertices of the triangle.
 *
 * @function Phaser.Geom.Triangle.CircumCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Math.Vector2} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the circumcenter of.
 * @param {Phaser.Math.Vector2} [out] - The Vector2 object to store the position in. If not given, a new Vector2 instance is created.
 *
 * @return {Phaser.Math.Vector2} A Vector2 object holding the coordinates of the circumcenter of the Triangle.
 */ var CircumCenter = function(triangle, out) {
                    if (out === undefined) out = new Vector2();
                    var cx = triangle.x3;
                    var cy = triangle.y3;
                    var ax = triangle.x1 - cx;
                    var ay = triangle.y1 - cy;
                    var bx = triangle.x2 - cx;
                    var by = triangle.y2 - cy;
                    var denom = 2 * det(ax, ay, bx, by);
                    var numx = det(ay, ax * ax + ay * ay, by, bx * bx + by * by);
                    var numy = det(ax, ax * ax + ay * ay, bx, bx * bx + by * by);
                    out.x = cx - numx / denom;
                    out.y = cy + numy / denom;
                    return out;
                };
                module1.exports = CircumCenter;
            /***/ },
            /***/ 85614: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(96503);
                //  Adapted from https://gist.github.com/mutoo/5617691
                /**
 * Finds the circumscribed circle (circumcircle) of a Triangle object. The circumcircle is the circle which touches all of the triangle's vertices.
 *
 * @function Phaser.Geom.Triangle.CircumCircle
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use as input.
 * @param {Phaser.Geom.Circle} [out] - An optional Circle to store the result in.
 *
 * @return {Phaser.Geom.Circle} The updated `out` Circle, or a new Circle if none was provided.
 */ var CircumCircle = function(triangle, out) {
                    if (out === undefined) out = new Circle();
                    //  A
                    var x1 = triangle.x1;
                    var y1 = triangle.y1;
                    //  B
                    var x2 = triangle.x2;
                    var y2 = triangle.y2;
                    //  C
                    var x3 = triangle.x3;
                    var y3 = triangle.y3;
                    var A = x2 - x1;
                    var B = y2 - y1;
                    var C = x3 - x1;
                    var D = y3 - y1;
                    var E = A * (x1 + x2) + B * (y1 + y2);
                    var F = C * (x1 + x3) + D * (y1 + y3);
                    var G = 2 * (A * (y3 - y2) - B * (x3 - x2));
                    var dx;
                    var dy;
                    //  If the points of the triangle are collinear, then just find the
                    //  extremes and use the midpoint as the center of the circumcircle.
                    if (Math.abs(G) < 0.000001) {
                        var minX = Math.min(x1, x2, x3);
                        var minY = Math.min(y1, y2, y3);
                        dx = (Math.max(x1, x2, x3) - minX) * 0.5;
                        dy = (Math.max(y1, y2, y3) - minY) * 0.5;
                        out.x = minX + dx;
                        out.y = minY + dy;
                        out.radius = Math.sqrt(dx * dx + dy * dy);
                    } else {
                        out.x = (D * E - B * F) / G;
                        out.y = (A * F - C * E) / G;
                        dx = out.x - x1;
                        dy = out.y - y1;
                        out.radius = Math.sqrt(dx * dx + dy * dy);
                    }
                    return out;
                };
                module1.exports = CircumCircle;
            /***/ },
            /***/ 74422: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(16483);
                /**
 * Clones a Triangle object.
 *
 * @function Phaser.Geom.Triangle.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} source - The Triangle to clone.
 *
 * @return {Phaser.Geom.Triangle} A new Triangle identical to the given one but separate from it.
 */ var Clone = function(source) {
                    return new Triangle(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
                };
                module1.exports = Clone;
            /***/ },
            /***/ 10690: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  http://www.blackpawn.com/texts/pointinpoly/
                /**
 * Checks if a point (as a pair of coordinates) is inside a Triangle's bounds.
 *
 * @function Phaser.Geom.Triangle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is inside the Triangle, otherwise `false`.
 */ var Contains = function(triangle, x, y) {
                    var v0x = triangle.x3 - triangle.x1;
                    var v0y = triangle.y3 - triangle.y1;
                    var v1x = triangle.x2 - triangle.x1;
                    var v1y = triangle.y2 - triangle.y1;
                    var v2x = x - triangle.x1;
                    var v2y = y - triangle.y1;
                    var dot00 = v0x * v0x + v0y * v0y;
                    var dot01 = v0x * v1x + v0y * v1y;
                    var dot02 = v0x * v2x + v0y * v2y;
                    var dot11 = v1x * v1x + v1y * v1y;
                    var dot12 = v1x * v2x + v1y * v2y;
                    // Compute barycentric coordinates
                    var b = dot00 * dot11 - dot01 * dot01;
                    var inv = b === 0 ? 0 : 1 / b;
                    var u = (dot11 * dot02 - dot01 * dot12) * inv;
                    var v = (dot00 * dot12 - dot01 * dot02) * inv;
                    return u >= 0 && v >= 0 && u + v < 1;
                };
                module1.exports = Contains;
            /***/ },
            /***/ 48653: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  http://www.blackpawn.com/texts/pointinpoly/
                //  points is an array of Point-like objects with public x/y properties
                //  returns an array containing all points that are within the triangle, or an empty array if none
                //  if 'returnFirst' is true it will return after the first point within the triangle is found
                /**
 * Filters an array of point-like objects to only those contained within a triangle.
 * If `returnFirst` is true, will return an array containing only the first point in the provided array that is within the triangle (or an empty array if there are no such points).
 *
 * @function Phaser.Geom.Triangle.ContainsArray
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle that the points are being checked in.
 * @param {Phaser.Geom.Point[]} points - An array of point-like objects (objects that have an `x` and `y` property)
 * @param {boolean} [returnFirst=false] - If `true`, return an array containing only the first point found that is within the triangle.
 * @param {array} [out] - If provided, the points that are within the triangle will be appended to this array instead of being added to a new array. If `returnFirst` is true, only the first point found within the triangle will be appended. This array will also be returned by this function.
 *
 * @return {Phaser.Geom.Point[]} An array containing all the points from `points` that are within the triangle, if an array was provided as `out`, points will be appended to that array and it will also be returned here.
 */ var ContainsArray = function(triangle, points, returnFirst, out) {
                    if (returnFirst === undefined) returnFirst = false;
                    if (out === undefined) out = [];
                    var v0x = triangle.x3 - triangle.x1;
                    var v0y = triangle.y3 - triangle.y1;
                    var v1x = triangle.x2 - triangle.x1;
                    var v1y = triangle.y2 - triangle.y1;
                    var dot00 = v0x * v0x + v0y * v0y;
                    var dot01 = v0x * v1x + v0y * v1y;
                    var dot11 = v1x * v1x + v1y * v1y;
                    // Compute barycentric coordinates
                    var b = dot00 * dot11 - dot01 * dot01;
                    var inv = b === 0 ? 0 : 1 / b;
                    var u;
                    var v;
                    var v2x;
                    var v2y;
                    var dot02;
                    var dot12;
                    var x1 = triangle.x1;
                    var y1 = triangle.y1;
                    for(var i = 0; i < points.length; i++){
                        v2x = points[i].x - x1;
                        v2y = points[i].y - y1;
                        dot02 = v0x * v2x + v0y * v2y;
                        dot12 = v1x * v2x + v1y * v2y;
                        u = (dot11 * dot02 - dot01 * dot12) * inv;
                        v = (dot00 * dot12 - dot01 * dot02) * inv;
                        if (u >= 0 && v >= 0 && u + v < 1) {
                            out.push({
                                x: points[i].x,
                                y: points[i].y
                            });
                            if (returnFirst) break;
                        }
                    }
                    return out;
                };
                module1.exports = ContainsArray;
            /***/ },
            /***/ 96006: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(10690);
                /**
 * Tests if a triangle contains a point.
 *
 * @function Phaser.Geom.Triangle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle.
 * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|any)} point - The point to test, or any point-like object with public `x` and `y` properties.
 *
 * @return {boolean} `true` if the point is within the triangle, otherwise `false`.
 */ var ContainsPoint = function(triangle, point) {
                    return Contains(triangle, point.x, point.y);
                };
                module1.exports = ContainsPoint;
            /***/ },
            /***/ 71326: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Triangle to a destination Triangle.
 *
 * @function Phaser.Geom.Triangle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Triangle} source - The source Triangle to copy the values from.
 * @param {Phaser.Geom.Triangle} dest - The destination Triangle to copy the values to.
 *
 * @return {Phaser.Geom.Triangle} The destination Triangle.
 */ var CopyFrom = function(source, dest) {
                    return dest.setTo(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
                };
                module1.exports = CopyFrom;
            /***/ },
            /***/ 71694: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Decomposes a Triangle into an array of its points.
 *
 * @function Phaser.Geom.Triangle.Decompose
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to decompose.
 * @param {array} [out] - An array to store the points into.
 *
 * @return {array} The provided `out` array, or a new array if none was provided, with three objects with `x` and `y` properties representing each point of the Triangle appended to it.
 */ var Decompose = function(triangle, out) {
                    if (out === undefined) out = [];
                    out.push({
                        x: triangle.x1,
                        y: triangle.y1
                    });
                    out.push({
                        x: triangle.x2,
                        y: triangle.y2
                    });
                    out.push({
                        x: triangle.x3,
                        y: triangle.y3
                    });
                    return out;
                };
                module1.exports = Decompose;
            /***/ },
            /***/ 33522: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns true if two triangles have the same coordinates.
 *
 * @function Phaser.Geom.Triangle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The first triangle to check.
 * @param {Phaser.Geom.Triangle} toCompare - The second triangle to check.
 *
 * @return {boolean} `true` if the two given triangles have the exact same coordinates, otherwise `false`.
 */ var Equals = function(triangle, toCompare) {
                    return triangle.x1 === toCompare.x1 && triangle.y1 === toCompare.y1 && triangle.x2 === toCompare.x2 && triangle.y2 === toCompare.y2 && triangle.x3 === toCompare.x3 && triangle.y3 === toCompare.y3;
                };
                module1.exports = Equals;
            /***/ },
            /***/ 20437: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                var Length = __webpack_require__(35001);
                /**
 * Returns a Point from around the perimeter of a Triangle.
 *
 * @function Phaser.Geom.Triangle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the point on its perimeter from.
 * @param {number} position - The position along the perimeter of the triangle. A value between 0 and 1.
 * @param {(Phaser.Geom.Point|object)} [out] - An option Point, or Point-like object to store the value in. If not given a new Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object containing the given position from the perimeter of the triangle.
 */ var GetPoint = function(triangle, position, out) {
                    if (out === undefined) out = new Point();
                    var line1 = triangle.getLineA();
                    var line2 = triangle.getLineB();
                    var line3 = triangle.getLineC();
                    if (position <= 0 || position >= 1) {
                        out.x = line1.x1;
                        out.y = line1.y1;
                        return out;
                    }
                    var length1 = Length(line1);
                    var length2 = Length(line2);
                    var length3 = Length(line3);
                    var perimeter = length1 + length2 + length3;
                    var p = perimeter * position;
                    var localPosition = 0;
                    //  Which line is it on?
                    if (p < length1) {
                        //  Line 1
                        localPosition = p / length1;
                        out.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
                        out.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
                    } else if (p > length1 + length2) {
                        //  Line 3
                        p -= length1 + length2;
                        localPosition = p / length3;
                        out.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
                        out.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
                    } else {
                        //  Line 2
                        p -= length1;
                        localPosition = p / length2;
                        out.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
                        out.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
                    }
                    return out;
                };
                module1.exports = GetPoint;
            /***/ },
            /***/ 80672: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(35001);
                var Point = __webpack_require__(2141);
                /**
 * Returns an array of evenly spaced points on the perimeter of a Triangle.
 *
 * @function Phaser.Geom.Triangle.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the points from.
 * @param {number} quantity - The number of evenly spaced points to return. Set to 0 to return an arbitrary number of points based on the `stepRate`.
 * @param {number} stepRate - If `quantity` is 0, the distance between each returned point.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array to which the points should be appended.
 *
 * @return {(array|Phaser.Geom.Point[])} The modified `out` array, or a new array if none was provided.
 */ var GetPoints = function(triangle, quantity, stepRate, out) {
                    if (out === undefined) out = [];
                    var line1 = triangle.getLineA();
                    var line2 = triangle.getLineB();
                    var line3 = triangle.getLineC();
                    var length1 = Length(line1);
                    var length2 = Length(line2);
                    var length3 = Length(line3);
                    var perimeter = length1 + length2 + length3;
                    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!quantity && stepRate > 0) quantity = perimeter / stepRate;
                    for(var i = 0; i < quantity; i++){
                        var p = perimeter * (i / quantity);
                        var localPosition = 0;
                        var point = new Point();
                        //  Which line is it on?
                        if (p < length1) {
                            //  Line 1
                            localPosition = p / length1;
                            point.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
                            point.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
                        } else if (p > length1 + length2) {
                            //  Line 3
                            p -= length1 + length2;
                            localPosition = p / length3;
                            point.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
                            point.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
                        } else {
                            //  Line 2
                            p -= length1;
                            localPosition = p / length2;
                            point.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
                            point.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
                        }
                        out.push(point);
                    }
                    return out;
                };
                module1.exports = GetPoints;
            /***/ },
            /***/ 39757: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                // The three angle bisectors of a triangle meet in one point called the incenter.
                // It is the center of the incircle, the circle inscribed in the triangle.
                function getLength(x1, y1, x2, y2) {
                    var x = x1 - x2;
                    var y = y1 - y2;
                    var magnitude = x * x + y * y;
                    return Math.sqrt(magnitude);
                }
                /**
 * Calculates the position of the incenter of a Triangle object. This is the point where its three angle bisectors meet and it's also the center of the incircle, which is the circle inscribed in the triangle.
 *
 * @function Phaser.Geom.Triangle.InCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to find the incenter of.
 * @param {Phaser.Geom.Point} [out] - An optional Point in which to store the coordinates.
 *
 * @return {Phaser.Geom.Point} Point (x, y) of the center pixel of the triangle.
 */ var InCenter = function(triangle, out) {
                    if (out === undefined) out = new Point();
                    var x1 = triangle.x1;
                    var y1 = triangle.y1;
                    var x2 = triangle.x2;
                    var y2 = triangle.y2;
                    var x3 = triangle.x3;
                    var y3 = triangle.y3;
                    var d1 = getLength(x3, y3, x2, y2);
                    var d2 = getLength(x1, y1, x3, y3);
                    var d3 = getLength(x2, y2, x1, y1);
                    var p = d1 + d2 + d3;
                    out.x = (x1 * d1 + x2 * d2 + x3 * d3) / p;
                    out.y = (y1 * d1 + y2 * d2 + y3 * d3) / p;
                    return out;
                };
                module1.exports = InCenter;
            /***/ },
            /***/ 13584: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves each point (vertex) of a Triangle by a given offset, thus moving the entire Triangle by that offset.
 *
 * @function Phaser.Geom.Triangle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to move.
 * @param {number} x - The horizontal offset (distance) by which to move each point. Can be positive or negative.
 * @param {number} y - The vertical offset (distance) by which to move each point. Can be positive or negative.
 *
 * @return {Phaser.Geom.Triangle} The modified Triangle.
 */ var Offset = function(triangle, x, y) {
                    triangle.x1 += x;
                    triangle.y1 += y;
                    triangle.x2 += x;
                    triangle.y2 += y;
                    triangle.x3 += x;
                    triangle.y3 += y;
                    return triangle;
                };
                module1.exports = Offset;
            /***/ },
            /***/ 1376: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(35001);
                /**
 * Gets the length of the perimeter of the given triangle.
 * Calculated by adding together the length of each of the three sides.
 *
 * @function Phaser.Geom.Triangle.Perimeter
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the length from.
 *
 * @return {number} The length of the Triangle.
 */ var Perimeter = function(triangle) {
                    var line1 = triangle.getLineA();
                    var line2 = triangle.getLineB();
                    var line3 = triangle.getLineC();
                    return Length(line1) + Length(line2) + Length(line3);
                };
                module1.exports = Perimeter;
            /***/ },
            /***/ 90260: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(2141);
                /**
 * Returns a random Point from within the area of the given Triangle.
 *
 * @function Phaser.Geom.Triangle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get a random point from.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of a random position within the Triangle.
 */ var Random = function(triangle, out) {
                    if (out === undefined) out = new Point();
                    //  Basis vectors
                    var ux = triangle.x2 - triangle.x1;
                    var uy = triangle.y2 - triangle.y1;
                    var vx = triangle.x3 - triangle.x1;
                    var vy = triangle.y3 - triangle.y1;
                    //  Random point within the unit square
                    var r = Math.random();
                    var s = Math.random();
                    //  Point outside the triangle? Remap it.
                    if (r + s >= 1) {
                        r = 1 - r;
                        s = 1 - s;
                    }
                    out.x = triangle.x1 + (ux * r + vx * s);
                    out.y = triangle.y1 + (uy * r + vy * s);
                    return out;
                };
                module1.exports = Random;
            /***/ },
            /***/ 52172: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(99614);
                var InCenter = __webpack_require__(39757);
                /**
 * Rotates a Triangle about its incenter, which is the point at which its three angle bisectors meet.
 *
 * @function Phaser.Geom.Triangle.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var Rotate = function(triangle, angle) {
                    var point = InCenter(triangle);
                    return RotateAroundXY(triangle, point.x, point.y, angle);
                };
                module1.exports = Rotate;
            /***/ },
            /***/ 49907: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(99614);
                /**
 * Rotates a Triangle at a certain angle about a given Point or object with public `x` and `y` properties.
 *
 * @function Phaser.Geom.Triangle.RotateAroundPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {Phaser.Geom.Point} point - The Point to rotate the Triangle about.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var RotateAroundPoint = function(triangle, point, angle) {
                    return RotateAroundXY(triangle, point.x, point.y, angle);
                };
                module1.exports = RotateAroundPoint;
            /***/ },
            /***/ 99614: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotates an entire Triangle at a given angle about a specific point.
 *
 * @function Phaser.Geom.Triangle.RotateAroundXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {number} x - The X coordinate of the point to rotate the Triangle about.
 * @param {number} y - The Y coordinate of the point to rotate the Triangle about.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var RotateAroundXY = function(triangle, x, y, angle) {
                    var c = Math.cos(angle);
                    var s = Math.sin(angle);
                    var tx = triangle.x1 - x;
                    var ty = triangle.y1 - y;
                    triangle.x1 = tx * c - ty * s + x;
                    triangle.y1 = tx * s + ty * c + y;
                    tx = triangle.x2 - x;
                    ty = triangle.y2 - y;
                    triangle.x2 = tx * c - ty * s + x;
                    triangle.y2 = tx * s + ty * c + y;
                    tx = triangle.x3 - x;
                    ty = triangle.y3 - y;
                    triangle.x3 = tx * c - ty * s + x;
                    triangle.y3 = tx * s + ty * c + y;
                    return triangle;
                };
                module1.exports = RotateAroundXY;
            /***/ },
            /***/ 16483: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Contains = __webpack_require__(10690);
                var GetPoint = __webpack_require__(20437);
                var GetPoints = __webpack_require__(80672);
                var GEOM_CONST = __webpack_require__(23777);
                var Line = __webpack_require__(23031);
                var Random = __webpack_require__(90260);
                /**
 * @classdesc
 * A triangle is a plane created by connecting three points.
 * The first two arguments specify the first point, the middle two arguments
 * specify the second point, and the last two arguments specify the third point.
 *
 * @class Triangle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x1=0] - `x` coordinate of the first point.
 * @param {number} [y1=0] - `y` coordinate of the first point.
 * @param {number} [x2=0] - `x` coordinate of the second point.
 * @param {number} [y2=0] - `y` coordinate of the second point.
 * @param {number} [x3=0] - `x` coordinate of the third point.
 * @param {number} [y3=0] - `y` coordinate of the third point.
 */ var Triangle = new Class({
                    initialize: function Triangle(x1, y1, x2, y2, x3, y3) {
                        if (x1 === undefined) x1 = 0;
                        if (y1 === undefined) y1 = 0;
                        if (x2 === undefined) x2 = 0;
                        if (y2 === undefined) y2 = 0;
                        if (x3 === undefined) x3 = 0;
                        if (y3 === undefined) y3 = 0;
                        /**
         * The geometry constant type of this object: `GEOM_CONST.TRIANGLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Triangle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.TRIANGLE;
                        /**
         * `x` coordinate of the first point.
         *
         * @name Phaser.Geom.Triangle#x1
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x1 = x1;
                        /**
         * `y` coordinate of the first point.
         *
         * @name Phaser.Geom.Triangle#y1
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y1 = y1;
                        /**
         * `x` coordinate of the second point.
         *
         * @name Phaser.Geom.Triangle#x2
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x2 = x2;
                        /**
         * `y` coordinate of the second point.
         *
         * @name Phaser.Geom.Triangle#y2
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y2 = y2;
                        /**
         * `x` coordinate of the third point.
         *
         * @name Phaser.Geom.Triangle#x3
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x3 = x3;
                        /**
         * `y` coordinate of the third point.
         *
         * @name Phaser.Geom.Triangle#y3
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y3 = y3;
                    },
                    /**
     * Checks whether a given points lies within the triangle.
     *
     * @method Phaser.Geom.Triangle#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point to check.
     * @param {number} y - The y coordinate of the point to check.
     *
     * @return {boolean} `true` if the coordinate pair is within the triangle, otherwise `false`.
     */ contains: function(x, y) {
                        return Contains(this, x, y);
                    },
                    /**
     * Returns a specific point  on the triangle.
     *
     * @method Phaser.Geom.Triangle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - Position as float within `0` and `1`. `0` equals the first point.
     * @param {(Phaser.Geom.Point|object)} [output] - Optional Point, or point-like object, that the calculated point will be written to.
     *
     * @return {(Phaser.Geom.Point|object)} Calculated `Point` that represents the requested position. It is the same as `output` when this parameter has been given.
     */ getPoint: function(position, output) {
                        return GetPoint(this, position, output);
                    },
                    /**
     * Calculates a list of evenly distributed points on the triangle. It is either possible to pass an amount of points to be generated (`quantity`) or the distance between two points (`stepRate`).
     *
     * @method Phaser.Geom.Triangle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - Number of points to be generated. Can be falsey when `stepRate` should be used. All points have the same distance along the triangle.
     * @param {number} [stepRate] - Distance between two points. Will only be used when `quantity` is falsey.
     * @param {(array|Phaser.Geom.Point[])} [output] - Optional Array for writing the calculated points into. Otherwise a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} Returns a list of calculated `Point` instances or the filled array passed as parameter `output`.
     */ getPoints: function(quantity, stepRate, output) {
                        return GetPoints(this, quantity, stepRate, output);
                    },
                    /**
     * Returns a random point along the triangle.
     *
     * @method Phaser.Geom.Triangle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {Phaser.Geom.Point} [point] - Optional `Point` that should be modified. Otherwise a new one will be created.
     *
     * @return {Phaser.Geom.Point} Random `Point`. When parameter `point` has been provided it will be returned.
     */ getRandomPoint: function(point) {
                        return Random(this, point);
                    },
                    /**
     * Sets all three points of the triangle. Leaving out any coordinate sets it to be `0`.
     *
     * @method Phaser.Geom.Triangle#setTo
     * @since 3.0.0
     *
     * @param {number} [x1=0] - `x` coordinate of the first point.
     * @param {number} [y1=0] - `y` coordinate of the first point.
     * @param {number} [x2=0] - `x` coordinate of the second point.
     * @param {number} [y2=0] - `y` coordinate of the second point.
     * @param {number} [x3=0] - `x` coordinate of the third point.
     * @param {number} [y3=0] - `y` coordinate of the third point.
     *
     * @return {this} This Triangle object.
     */ setTo: function(x1, y1, x2, y2, x3, y3) {
                        if (x1 === undefined) x1 = 0;
                        if (y1 === undefined) y1 = 0;
                        if (x2 === undefined) x2 = 0;
                        if (y2 === undefined) y2 = 0;
                        if (x3 === undefined) x3 = 0;
                        if (y3 === undefined) y3 = 0;
                        this.x1 = x1;
                        this.y1 = y1;
                        this.x2 = x2;
                        this.y2 = y2;
                        this.x3 = x3;
                        this.y3 = y3;
                        return this;
                    },
                    /**
     * Returns a Line object that corresponds to Line A of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineA
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line A of this Triangle.
     */ getLineA: function(line) {
                        if (line === undefined) line = new Line();
                        line.setTo(this.x1, this.y1, this.x2, this.y2);
                        return line;
                    },
                    /**
     * Returns a Line object that corresponds to Line B of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineB
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line B of this Triangle.
     */ getLineB: function(line) {
                        if (line === undefined) line = new Line();
                        line.setTo(this.x2, this.y2, this.x3, this.y3);
                        return line;
                    },
                    /**
     * Returns a Line object that corresponds to Line C of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineC
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line C of this Triangle.
     */ getLineC: function(line) {
                        if (line === undefined) line = new Line();
                        line.setTo(this.x3, this.y3, this.x1, this.y1);
                        return line;
                    },
                    /**
     * Left most X coordinate of the triangle. Setting it moves the triangle on the X axis accordingly.
     *
     * @name Phaser.Geom.Triangle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                        get: function() {
                            return Math.min(this.x1, this.x2, this.x3);
                        },
                        set: function(value) {
                            var diff = 0;
                            if (this.x1 <= this.x2 && this.x1 <= this.x3) diff = this.x1 - value;
                            else if (this.x2 <= this.x1 && this.x2 <= this.x3) diff = this.x2 - value;
                            else diff = this.x3 - value;
                            this.x1 -= diff;
                            this.x2 -= diff;
                            this.x3 -= diff;
                        }
                    },
                    /**
     * Right most X coordinate of the triangle. Setting it moves the triangle on the X axis accordingly.
     *
     * @name Phaser.Geom.Triangle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                        get: function() {
                            return Math.max(this.x1, this.x2, this.x3);
                        },
                        set: function(value) {
                            var diff = 0;
                            if (this.x1 >= this.x2 && this.x1 >= this.x3) diff = this.x1 - value;
                            else if (this.x2 >= this.x1 && this.x2 >= this.x3) diff = this.x2 - value;
                            else diff = this.x3 - value;
                            this.x1 -= diff;
                            this.x2 -= diff;
                            this.x3 -= diff;
                        }
                    },
                    /**
     * Top most Y coordinate of the triangle. Setting it moves the triangle on the Y axis accordingly.
     *
     * @name Phaser.Geom.Triangle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                        get: function() {
                            return Math.min(this.y1, this.y2, this.y3);
                        },
                        set: function(value) {
                            var diff = 0;
                            if (this.y1 <= this.y2 && this.y1 <= this.y3) diff = this.y1 - value;
                            else if (this.y2 <= this.y1 && this.y2 <= this.y3) diff = this.y2 - value;
                            else diff = this.y3 - value;
                            this.y1 -= diff;
                            this.y2 -= diff;
                            this.y3 -= diff;
                        }
                    },
                    /**
     * Bottom most Y coordinate of the triangle. Setting it moves the triangle on the Y axis accordingly.
     *
     * @name Phaser.Geom.Triangle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                        get: function() {
                            return Math.max(this.y1, this.y2, this.y3);
                        },
                        set: function(value) {
                            var diff = 0;
                            if (this.y1 >= this.y2 && this.y1 >= this.y3) diff = this.y1 - value;
                            else if (this.y2 >= this.y1 && this.y2 >= this.y3) diff = this.y2 - value;
                            else diff = this.y3 - value;
                            this.y1 -= diff;
                            this.y2 -= diff;
                            this.y3 -= diff;
                        }
                    }
                });
                module1.exports = Triangle;
            /***/ },
            /***/ 84435: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(16483);
                Triangle.Area = __webpack_require__(41658);
                Triangle.BuildEquilateral = __webpack_require__(39208);
                Triangle.BuildFromPolygon = __webpack_require__(39545);
                Triangle.BuildRight = __webpack_require__(90301);
                Triangle.CenterOn = __webpack_require__(23707);
                Triangle.Centroid = __webpack_require__(97523);
                Triangle.CircumCenter = __webpack_require__(24951);
                Triangle.CircumCircle = __webpack_require__(85614);
                Triangle.Clone = __webpack_require__(74422);
                Triangle.Contains = __webpack_require__(10690);
                Triangle.ContainsArray = __webpack_require__(48653);
                Triangle.ContainsPoint = __webpack_require__(96006);
                Triangle.CopyFrom = __webpack_require__(71326);
                Triangle.Decompose = __webpack_require__(71694);
                Triangle.Equals = __webpack_require__(33522);
                Triangle.GetPoint = __webpack_require__(20437);
                Triangle.GetPoints = __webpack_require__(80672);
                Triangle.InCenter = __webpack_require__(39757);
                Triangle.Perimeter = __webpack_require__(1376);
                Triangle.Offset = __webpack_require__(13584);
                Triangle.Random = __webpack_require__(90260);
                Triangle.Rotate = __webpack_require__(52172);
                Triangle.RotateAroundPoint = __webpack_require__(49907);
                Triangle.RotateAroundXY = __webpack_require__(99614);
                module1.exports = Triangle;
            /***/ },
            /***/ 74457: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates a new Interactive Object.
 *
 * This is called automatically by the Input Manager when you enable a Game Object for input.
 *
 * The resulting Interactive Object is mapped to the Game Object's `input` property.
 *
 * @function Phaser.Input.CreateInteractiveObject
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to which this Interactive Object is bound.
 * @param {any} hitArea - The hit area for this Interactive Object. Typically a geometry shape, like a Rectangle or Circle.
 * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - The 'contains' check callback that the hit area shape will use for all hit tests.
 *
 * @return {Phaser.Types.Input.InteractiveObject} The new Interactive Object.
 */ var CreateInteractiveObject = function(gameObject, hitArea, hitAreaCallback) {
                    return {
                        gameObject: gameObject,
                        enabled: true,
                        draggable: false,
                        dropZone: false,
                        cursor: false,
                        target: null,
                        camera: null,
                        hitArea: hitArea,
                        hitAreaCallback: hitAreaCallback,
                        hitAreaDebug: null,
                        //  Has the dev specified their own shape, or is this bound to the texture size?
                        customHitArea: false,
                        localX: 0,
                        localY: 0,
                        //  0 = Not being dragged
                        //  1 = Being checked for dragging
                        //  2 = Being dragged
                        dragState: 0,
                        dragStartX: 0,
                        dragStartY: 0,
                        dragStartXGlobal: 0,
                        dragStartYGlobal: 0,
                        dragStartCamera: null,
                        dragX: 0,
                        dragY: 0
                    };
                };
                module1.exports = CreateInteractiveObject;
            /***/ },
            /***/ 84409: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates a new Pixel Perfect Handler function.
 *
 * Access via `InputPlugin.makePixelPerfect` rather than calling it directly.
 *
 * @function Phaser.Input.CreatePixelPerfectHandler
 * @since 3.10.0
 *
 * @param {Phaser.Textures.TextureManager} textureManager - A reference to the Texture Manager.
 * @param {number} alphaTolerance - The alpha level that the pixel should be above to be included as a successful interaction.
 *
 * @return {function} The new Pixel Perfect Handler function.
 */ var CreatePixelPerfectHandler = function(textureManager, alphaTolerance) {
                    return function(hitArea, x, y, gameObject) {
                        var alpha = textureManager.getPixelAlpha(x, y, gameObject.texture.key, gameObject.frame.name);
                        return alpha && alpha >= alphaTolerance;
                    };
                };
                module1.exports = CreatePixelPerfectHandler;
            /***/ },
            /***/ 7003: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(93301);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(8214);
                var GameEvents = __webpack_require__(8443);
                var Keyboard = __webpack_require__(78970);
                var Mouse = __webpack_require__(85098);
                var Pointer = __webpack_require__(42515);
                var Touch = __webpack_require__(36210);
                var TransformMatrix = __webpack_require__(61340);
                var TransformXY = __webpack_require__(85955);
                /**
 * @classdesc
 * The Input Manager is responsible for handling the pointer related systems in a single Phaser Game instance.
 *
 * Based on the Game Config it will create handlers for mouse and touch support.
 *
 * Keyboard and Gamepad are plugins, handled directly by the InputPlugin class.
 *
 * It then manages the events, pointer creation and general hit test related operations.
 *
 * You rarely need to interact with the Input Manager directly, and as such, all of its properties and methods
 * should be considered private. Instead, you should use the Input Plugin, which is a Scene level system, responsible
 * for dealing with all input events for a Scene.
 *
 * @class InputManager
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance that owns the Input Manager.
 * @param {object} config - The Input Configuration object, as set in the Game Config.
 */ var InputManager = new Class({
                    initialize: function InputManager(game, config) {
                        /**
         * The Game instance that owns the Input Manager.
         * A Game only maintains on instance of the Input Manager at any time.
         *
         * @name Phaser.Input.InputManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                        /**
         * A reference to the global Game Scale Manager.
         * Used for all bounds checks and pointer scaling.
         *
         * @name Phaser.Input.InputManager#scaleManager
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scaleManager;
                        /**
         * The Canvas that is used for all DOM event input listeners.
         *
         * @name Phaser.Input.InputManager#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas;
                        /**
         * The Game Configuration object, as set during the game boot.
         *
         * @name Phaser.Input.InputManager#config
         * @type {Phaser.Core.Config}
         * @since 3.0.0
         */ this.config = config;
                        /**
         * If set, the Input Manager will run its update loop every frame.
         *
         * @name Phaser.Input.InputManager#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                        /**
         * The Event Emitter instance that the Input Manager uses to emit events from.
         *
         * @name Phaser.Input.InputManager#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                        /**
         * Are any mouse or touch pointers currently over the game canvas?
         * This is updated automatically by the canvas over and out handlers.
         *
         * @name Phaser.Input.InputManager#isOver
         * @type {boolean}
         * @readonly
         * @since 3.16.0
         */ this.isOver = true;
                        /**
         * The default CSS cursor to be used when interacting with your game.
         *
         * See the `setDefaultCursor` method for more details.
         *
         * @name Phaser.Input.InputManager#defaultCursor
         * @type {string}
         * @since 3.10.0
         */ this.defaultCursor = '';
                        /**
         * A reference to the Keyboard Manager class, if enabled via the `input.keyboard` Game Config property.
         *
         * @name Phaser.Input.InputManager#keyboard
         * @type {?Phaser.Input.Keyboard.KeyboardManager}
         * @since 3.16.0
         */ this.keyboard = config.inputKeyboard ? new Keyboard(this) : null;
                        /**
         * A reference to the Mouse Manager class, if enabled via the `input.mouse` Game Config property.
         *
         * @name Phaser.Input.InputManager#mouse
         * @type {?Phaser.Input.Mouse.MouseManager}
         * @since 3.0.0
         */ this.mouse = config.inputMouse ? new Mouse(this) : null;
                        /**
         * A reference to the Touch Manager class, if enabled via the `input.touch` Game Config property.
         *
         * @name Phaser.Input.InputManager#touch
         * @type {Phaser.Input.Touch.TouchManager}
         * @since 3.0.0
         */ this.touch = config.inputTouch ? new Touch(this) : null;
                        /**
         * An array of Pointers that have been added to the game.
         * The first entry is reserved for the Mouse Pointer, the rest are Touch Pointers.
         *
         * By default there is 1 touch pointer enabled. If you need more use the `addPointer` method to start them,
         * or set the `input.activePointers` property in the Game Config.
         *
         * @name Phaser.Input.InputManager#pointers
         * @type {Phaser.Input.Pointer[]}
         * @since 3.10.0
         */ this.pointers = [];
                        /**
         * The number of touch objects activated and being processed each update.
         *
         * You can change this by either calling `addPointer` at run-time, or by
         * setting the `input.activePointers` property in the Game Config.
         *
         * @name Phaser.Input.InputManager#pointersTotal
         * @type {number}
         * @readonly
         * @since 3.10.0
         */ this.pointersTotal = config.inputActivePointers;
                        for(var i = 0; i <= this.pointersTotal; i++){
                            var pointer = new Pointer(this, i);
                            pointer.smoothFactor = config.inputSmoothFactor;
                            this.pointers.push(pointer);
                        }
                        /**
         * The mouse has its own unique Pointer object, which you can reference directly if making a _desktop specific game_.
         * If you are supporting both desktop and touch devices then do not use this property, instead use `activePointer`
         * which will always map to the most recently interacted pointer.
         *
         * @name Phaser.Input.InputManager#mousePointer
         * @type {?Phaser.Input.Pointer}
         * @since 3.10.0
         */ this.mousePointer = config.inputMouse ? this.pointers[0] : null;
                        /**
         * The most recently active Pointer object.
         *
         * If you've only 1 Pointer in your game then this will accurately be either the first finger touched, or the mouse.
         *
         * If your game doesn't need to support multi-touch then you can safely use this property in all of your game
         * code and it will adapt to be either the mouse or the touch, based on device.
         *
         * @name Phaser.Input.InputManager#activePointer
         * @type {Phaser.Input.Pointer}
         * @since 3.0.0
         */ this.activePointer = this.pointers[0];
                        /**
         * If the top-most Scene in the Scene List receives an input it will stop input from
         * propagating any lower down the scene list, i.e. if you have a UI Scene at the top
         * and click something on it, that click will not then be passed down to any other
         * Scene below. Disable this to have input events passed through all Scenes, all the time.
         *
         * @name Phaser.Input.InputManager#globalTopOnly
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.globalTopOnly = true;
                        /**
         * The time this Input Manager was last updated.
         * This value is populated by the Game Step each frame.
         *
         * @name Phaser.Input.InputManager#time
         * @type {number}
         * @readonly
         * @since 3.16.2
         */ this.time = 0;
                        /**
         * A re-cycled point-like object to store hit test values in.
         *
         * @name Phaser.Input.InputManager#_tempPoint
         * @type {{x:number, y:number}}
         * @private
         * @since 3.0.0
         */ this._tempPoint = {
                            x: 0,
                            y: 0
                        };
                        /**
         * A re-cycled array to store hit results in.
         *
         * @name Phaser.Input.InputManager#_tempHitTest
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._tempHitTest = [];
                        /**
         * A re-cycled matrix used in hit test calculations.
         *
         * @name Phaser.Input.InputManager#_tempMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.4.0
         */ this._tempMatrix = new TransformMatrix();
                        /**
         * A re-cycled matrix used in hit test calculations.
         *
         * @name Phaser.Input.InputManager#_tempMatrix2
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix2 = new TransformMatrix();
                        /**
         * An internal private var that records Scenes aborting event processing.
         *
         * @name Phaser.Input.InputManager#_tempSkip
         * @type {boolean}
         * @private
         * @since 3.18.0
         */ this._tempSkip = false;
                        /**
         * An internal private array that avoids needing to create a new array on every DOM mouse event.
         *
         * @name Phaser.Input.InputManager#mousePointerContainer
         * @type {Phaser.Input.Pointer[]}
         * @private
         * @since 3.18.0
         */ this.mousePointerContainer = [
                            this.mousePointer
                        ];
                        game.events.once(GameEvents.BOOT, this.boot, this);
                    },
                    /**
     * The Boot handler is called by Phaser.Game when it first starts up.
     * The renderer is available by now.
     *
     * @method Phaser.Input.InputManager#boot
     * @protected
     * @fires Phaser.Input.Events#MANAGER_BOOT
     * @since 3.0.0
     */ boot: function() {
                        var game = this.game;
                        var events = game.events;
                        this.canvas = game.canvas;
                        this.scaleManager = game.scale;
                        this.events.emit(Events.MANAGER_BOOT);
                        events.on(GameEvents.PRE_RENDER, this.preRender, this);
                        events.once(GameEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * Internal canvas state change, called automatically by the Mouse Manager.
     *
     * @method Phaser.Input.InputManager#setCanvasOver
     * @fires Phaser.Input.Events#GAME_OVER
     * @private
     * @since 3.16.0
     *
     * @param {(MouseEvent|TouchEvent)} event - The DOM Event.
     */ setCanvasOver: function(event) {
                        this.isOver = true;
                        this.events.emit(Events.GAME_OVER, event);
                    },
                    /**
     * Internal canvas state change, called automatically by the Mouse Manager.
     *
     * @method Phaser.Input.InputManager#setCanvasOut
     * @fires Phaser.Input.Events#GAME_OUT
     * @private
     * @since 3.16.0
     *
     * @param {(MouseEvent|TouchEvent)} event - The DOM Event.
     */ setCanvasOut: function(event) {
                        this.isOver = false;
                        this.events.emit(Events.GAME_OUT, event);
                    },
                    /**
     * Internal update, called automatically by the Game Step right at the start.
     *
     * @method Phaser.Input.InputManager#preRender
     * @private
     * @since 3.18.0
     */ preRender: function() {
                        var time = this.game.loop.now;
                        var delta = this.game.loop.delta;
                        var scenes = this.game.scene.getScenes(true, true);
                        this.time = time;
                        this.events.emit(Events.MANAGER_UPDATE);
                        for(var i = 0; i < scenes.length; i++){
                            var scene = scenes[i];
                            if (scene.sys.input && scene.sys.input.updatePoll(time, delta) && this.globalTopOnly) //  If the Scene returns true, it means it captured some input that no other Scene should get, so we bail out
                            return;
                        }
                    },
                    /**
     * Tells the Input system to set a custom cursor.
     *
     * This cursor will be the default cursor used when interacting with the game canvas.
     *
     * If an Interactive Object also sets a custom cursor, this is the cursor that is reset after its use.
     *
     * Any valid CSS cursor value is allowed, including paths to image files, i.e.:
     *
     * ```javascript
     * this.input.setDefaultCursor('url(assets/cursors/sword.cur), pointer');
     * ```
     *
     * Please read about the differences between browsers when it comes to the file formats and sizes they support:
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_User_Interface/Using_URL_values_for_the_cursor_property
     *
     * It's up to you to pick a suitable cursor format that works across the range of browsers you need to support.
     *
     * @method Phaser.Input.InputManager#setDefaultCursor
     * @since 3.10.0
     *
     * @param {string} cursor - The CSS to be used when setting the default cursor.
     */ setDefaultCursor: function(cursor) {
                        this.defaultCursor = cursor;
                        if (this.canvas.style.cursor !== cursor) this.canvas.style.cursor = cursor;
                    },
                    /**
     * Called by the InputPlugin when processing over and out events.
     *
     * Tells the Input Manager to set a custom cursor during its postUpdate step.
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     *
     * @method Phaser.Input.InputManager#setCursor
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} interactiveObject - The Interactive Object that called this method.
     */ setCursor: function(interactiveObject) {
                        if (interactiveObject.cursor) this.canvas.style.cursor = interactiveObject.cursor;
                    },
                    /**
     * Called by the InputPlugin when processing over and out events.
     *
     * Tells the Input Manager to clear the hand cursor, if set, during its postUpdate step.
     *
     * @method Phaser.Input.InputManager#resetCursor
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} interactiveObject - The Interactive Object that called this method. Pass `null` if you just want to set the force value.
     * @param {boolean} [forceReset=false] - Should the reset happen regardless of the object's cursor state? Default false.
     */ resetCursor: function(interactiveObject, forceReset) {
                        if ((forceReset || interactiveObject && interactiveObject.cursor) && this.canvas) this.canvas.style.cursor = this.defaultCursor;
                    },
                    /**
     * Adds new Pointer objects to the Input Manager.
     *
     * By default Phaser creates 2 pointer objects: `mousePointer` and `pointer1`.
     *
     * You can create more either by calling this method, or by setting the `input.activePointers` property
     * in the Game Config, up to a maximum of 10 pointers.
     *
     * The first 10 pointers are available via the `InputPlugin.pointerX` properties, once they have been added
     * via this method.
     *
     * @method Phaser.Input.InputManager#addPointer
     * @since 3.10.0
     *
     * @param {number} [quantity=1] The number of new Pointers to create. A maximum of 10 is allowed in total.
     *
     * @return {Phaser.Input.Pointer[]} An array containing all of the new Pointer objects that were created.
     */ addPointer: function(quantity) {
                        if (quantity === undefined) quantity = 1;
                        var output = [];
                        if (this.pointersTotal + quantity > 10) quantity = 10 - this.pointersTotal;
                        for(var i = 0; i < quantity; i++){
                            var id = this.pointers.length;
                            var pointer = new Pointer(this, id);
                            pointer.smoothFactor = this.config.inputSmoothFactor;
                            this.pointers.push(pointer);
                            this.pointersTotal++;
                            output.push(pointer);
                        }
                        return output;
                    },
                    /**
     * Internal method that gets a list of all the active Input Plugins in the game
     * and updates each of them in turn, in reverse order (top to bottom), to allow
     * for DOM top-level event handling simulation.
     *
     * @method Phaser.Input.InputManager#updateInputPlugins
     * @since 3.16.0
     *
     * @param {number} type - The type of event to process.
     * @param {Phaser.Input.Pointer[]} pointers - An array of Pointers on which the event occurred.
     */ updateInputPlugins: function(type, pointers) {
                        var scenes = this.game.scene.getScenes(false, true);
                        this._tempSkip = false;
                        for(var i = 0; i < scenes.length; i++){
                            var scene = scenes[i];
                            if (scene.sys.input) {
                                var capture = scene.sys.input.update(type, pointers);
                                if (capture && this.globalTopOnly || this._tempSkip) //  If the Scene returns true, or called stopPropagation, it means it captured some input that no other Scene should get, so we bail out
                                return;
                            }
                        }
                    },
                    //  event.targetTouches = list of all touches on the TARGET ELEMENT (i.e. game dom element)
                    //  event.touches = list of all touches on the ENTIRE DOCUMENT, not just the target element
                    //  event.changedTouches = the touches that CHANGED in this event, not the total number of them
                    /**
     * Processes a touch start event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchStart
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchStart: function(event) {
                        var pointers = this.pointers;
                        var changed = [];
                        for(var c = 0; c < event.changedTouches.length; c++){
                            var changedTouch = event.changedTouches[c];
                            for(var i = 1; i < pointers.length; i++){
                                var pointer = pointers[i];
                                if (!pointer.active) {
                                    pointer.touchstart(changedTouch, event);
                                    this.activePointer = pointer;
                                    changed.push(pointer);
                                    break;
                                }
                            }
                        }
                        this.updateInputPlugins(CONST.TOUCH_START, changed);
                    },
                    /**
     * Processes a touch move event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchMove
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchMove: function(event) {
                        var pointers = this.pointers;
                        var changed = [];
                        for(var c = 0; c < event.changedTouches.length; c++){
                            var changedTouch = event.changedTouches[c];
                            for(var i = 1; i < pointers.length; i++){
                                var pointer = pointers[i];
                                if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                    var element = document.elementFromPoint(changedTouch.clientX, changedTouch.clientY);
                                    var overCanvas = element === this.canvas;
                                    if (!this.isOver && overCanvas) this.setCanvasOver(event);
                                    else if (this.isOver && !overCanvas) this.setCanvasOut(event);
                                    if (this.isOver) {
                                        pointer.touchmove(changedTouch, event);
                                        this.activePointer = pointer;
                                        changed.push(pointer);
                                    }
                                    break;
                                }
                            }
                        }
                        this.updateInputPlugins(CONST.TOUCH_MOVE, changed);
                    },
                    //  For touch end its a list of the touch points that have been removed from the surface
                    //  https://developer.mozilla.org/en-US/docs/DOM/TouchList
                    //  event.changedTouches = the touches that CHANGED in this event, not the total number of them
                    /**
     * Processes a touch end event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchEnd
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchEnd: function(event) {
                        var pointers = this.pointers;
                        var changed = [];
                        for(var c = 0; c < event.changedTouches.length; c++){
                            var changedTouch = event.changedTouches[c];
                            for(var i = 1; i < pointers.length; i++){
                                var pointer = pointers[i];
                                if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                    pointer.touchend(changedTouch, event);
                                    changed.push(pointer);
                                    break;
                                }
                            }
                        }
                        this.updateInputPlugins(CONST.TOUCH_END, changed);
                    },
                    /**
     * Processes a touch cancel event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchCancel
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchCancel: function(event) {
                        var pointers = this.pointers;
                        var changed = [];
                        for(var c = 0; c < event.changedTouches.length; c++){
                            var changedTouch = event.changedTouches[c];
                            for(var i = 1; i < pointers.length; i++){
                                var pointer = pointers[i];
                                if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                    pointer.touchcancel(changedTouch, event);
                                    changed.push(pointer);
                                    break;
                                }
                            }
                        }
                        this.updateInputPlugins(CONST.TOUCH_CANCEL, changed);
                    },
                    /**
     * Processes a mouse down event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseDown
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseDown: function(event) {
                        var mousePointer = this.mousePointer;
                        mousePointer.down(event);
                        mousePointer.updateMotion();
                        this.activePointer = mousePointer;
                        this.updateInputPlugins(CONST.MOUSE_DOWN, this.mousePointerContainer);
                    },
                    /**
     * Processes a mouse move event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseMove
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseMove: function(event) {
                        var mousePointer = this.mousePointer;
                        mousePointer.move(event);
                        mousePointer.updateMotion();
                        this.activePointer = mousePointer;
                        this.updateInputPlugins(CONST.MOUSE_MOVE, this.mousePointerContainer);
                    },
                    /**
     * Processes a mouse up event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseUp
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseUp: function(event) {
                        var mousePointer = this.mousePointer;
                        mousePointer.up(event);
                        mousePointer.updateMotion();
                        this.activePointer = mousePointer;
                        this.updateInputPlugins(CONST.MOUSE_UP, this.mousePointerContainer);
                    },
                    /**
     * Processes a mouse wheel event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseWheel
     * @private
     * @since 3.18.0
     *
     * @param {WheelEvent} event - The native DOM Wheel event.
     */ onMouseWheel: function(event) {
                        var mousePointer = this.mousePointer;
                        mousePointer.wheel(event);
                        this.activePointer = mousePointer;
                        this.updateInputPlugins(CONST.MOUSE_WHEEL, this.mousePointerContainer);
                    },
                    /**
     * Processes a pointer lock change event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onPointerLockChange
     * @fires Phaser.Input.Events#POINTERLOCK_CHANGE
     * @private
     * @since 3.19.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onPointerLockChange: function(event) {
                        var isLocked = this.mouse.locked;
                        this.mousePointer.locked = isLocked;
                        this.events.emit(Events.POINTERLOCK_CHANGE, event, isLocked);
                    },
                    /**
     * Checks if the given Game Object should be considered as a candidate for input or not.
     *
     * Checks if the Game Object has an input component that is enabled, that it will render,
     * and finally, if it has a parent, that the parent parent, or any ancestor, is visible or not.
     *
     * @method Phaser.Input.InputManager#inputCandidate
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to test.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     *
     * @return {boolean} `true` if the Game Object should be considered for input, otherwise `false`.
     */ inputCandidate: function(gameObject, camera) {
                        var input = gameObject.input;
                        if (!input || !input.enabled || !gameObject.willRender(camera)) return false;
                        var visible = true;
                        var parent = gameObject.parentContainer;
                        if (parent) do {
                            if (!parent.willRender(camera)) {
                                visible = false;
                                break;
                            }
                            parent = parent.parentContainer;
                        }while (parent);
                        return visible;
                    },
                    /**
     * Performs a hit test using the given Pointer and camera, against an array of interactive Game Objects.
     *
     * The Game Objects are culled against the camera, and then the coordinates are translated into the local camera space
     * and used to determine if they fall within the remaining Game Objects hit areas or not.
     *
     * If nothing is matched an empty array is returned.
     *
     * This method is called automatically by InputPlugin.hitTestPointer and doesn't usually need to be invoked directly.
     *
     * @method Phaser.Input.InputManager#hitTest
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to test against.
     * @param {array} gameObjects - An array of interactive Game Objects to check.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     * @param {array} [output] - An array to store the results in. If not given, a new empty array is created.
     *
     * @return {array} An array of the Game Objects that were hit during this hit test.
     */ hitTest: function(pointer, gameObjects, camera, output) {
                        if (output === undefined) output = this._tempHitTest;
                        var tempPoint = this._tempPoint;
                        var csx = camera.scrollX;
                        var csy = camera.scrollY;
                        output.length = 0;
                        var x = pointer.x;
                        var y = pointer.y;
                        //  Stores the world point inside of tempPoint
                        camera.getWorldPoint(x, y, tempPoint);
                        pointer.worldX = tempPoint.x;
                        pointer.worldY = tempPoint.y;
                        var point = {
                            x: 0,
                            y: 0
                        };
                        var matrix = this._tempMatrix;
                        var parentMatrix = this._tempMatrix2;
                        for(var i = 0; i < gameObjects.length; i++){
                            var gameObject = gameObjects[i];
                            //  Checks if the Game Object can receive input (isn't being ignored by the camera, invisible, etc)
                            //  and also checks all of its parents, if any
                            if (!this.inputCandidate(gameObject, camera)) continue;
                            var px = tempPoint.x + csx * gameObject.scrollFactorX - csx;
                            var py = tempPoint.y + csy * gameObject.scrollFactorY - csy;
                            if (gameObject.parentContainer) {
                                gameObject.getWorldTransformMatrix(matrix, parentMatrix);
                                matrix.applyInverse(px, py, point);
                            } else TransformXY(px, py, gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX, gameObject.scaleY, point);
                            if (this.pointWithinHitArea(gameObject, point.x, point.y)) output.push(gameObject);
                        }
                        return output;
                    },
                    /**
     * Checks if the given x and y coordinate are within the hit area of the Game Object.
     *
     * This method assumes that the coordinate values have already been translated into the space of the Game Object.
     *
     * If the coordinates are within the hit area they are set into the Game Objects Input `localX` and `localY` properties.
     *
     * @method Phaser.Input.InputManager#pointWithinHitArea
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object to check against.
     * @param {number} x - The translated x coordinate for the hit test.
     * @param {number} y - The translated y coordinate for the hit test.
     *
     * @return {boolean} `true` if the coordinates were inside the Game Objects hit area, otherwise `false`.
     */ pointWithinHitArea: function(gameObject, x, y) {
                        //  Normalize the origin
                        x += gameObject.displayOriginX;
                        y += gameObject.displayOriginY;
                        var input = gameObject.input;
                        if (input && input.hitAreaCallback(input.hitArea, x, y, gameObject)) {
                            input.localX = x;
                            input.localY = y;
                            return true;
                        } else return false;
                    },
                    /**
     * Checks if the given x and y coordinate are within the hit area of the Interactive Object.
     *
     * This method assumes that the coordinate values have already been translated into the space of the Interactive Object.
     *
     * If the coordinates are within the hit area they are set into the Interactive Objects Input `localX` and `localY` properties.
     *
     * @method Phaser.Input.InputManager#pointWithinInteractiveObject
     * @since 3.0.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} object - The Interactive Object to check against.
     * @param {number} x - The translated x coordinate for the hit test.
     * @param {number} y - The translated y coordinate for the hit test.
     *
     * @return {boolean} `true` if the coordinates were inside the Game Objects hit area, otherwise `false`.
     */ pointWithinInteractiveObject: function(object, x, y) {
                        if (!object.hitArea) return false;
                        //  Normalize the origin
                        x += object.gameObject.displayOriginX;
                        y += object.gameObject.displayOriginY;
                        object.localX = x;
                        object.localY = y;
                        return object.hitAreaCallback(object.hitArea, x, y, object);
                    },
                    /**
     * Transforms the pageX and pageY values of a Pointer into the scaled coordinate space of the Input Manager.
     *
     * @method Phaser.Input.InputManager#transformPointer
     * @since 3.10.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to transform the values for.
     * @param {number} pageX - The Page X value.
     * @param {number} pageY - The Page Y value.
     * @param {boolean} wasMove - Are we transforming the Pointer from a move event, or an up / down event?
     */ transformPointer: function(pointer, pageX, pageY, wasMove) {
                        var p0 = pointer.position;
                        var p1 = pointer.prevPosition;
                        //  Store previous position
                        p1.x = p0.x;
                        p1.y = p0.y;
                        //  Translate coordinates
                        var x = this.scaleManager.transformX(pageX);
                        var y = this.scaleManager.transformY(pageY);
                        var a = pointer.smoothFactor;
                        if (!wasMove || a === 0) {
                            //  Set immediately
                            p0.x = x;
                            p0.y = y;
                        } else {
                            //  Apply smoothing
                            p0.x = x * a + p1.x * (1 - a);
                            p0.y = y * a + p1.y * (1 - a);
                        }
                    },
                    /**
     * Destroys the Input Manager and all of its systems.
     *
     * There is no way to recover from doing this.
     *
     * @method Phaser.Input.InputManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.events.removeAllListeners();
                        this.game.events.off(GameEvents.PRE_RENDER);
                        if (this.keyboard) this.keyboard.destroy();
                        if (this.mouse) this.mouse.destroy();
                        if (this.touch) this.touch.destroy();
                        for(var i = 0; i < this.pointers.length; i++)this.pointers[i].destroy();
                        this.pointers = [];
                        this._tempHitTest = [];
                        this._tempMatrix.destroy();
                        this.canvas = null;
                        this.game = null;
                    }
                });
                module1.exports = InputManager;
            /***/ },
            /***/ 48205: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(96503);
                var CircleContains = __webpack_require__(87902);
                var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(93301);
                var CreateInteractiveObject = __webpack_require__(74457);
                var CreatePixelPerfectHandler = __webpack_require__(84409);
                var DistanceBetween = __webpack_require__(20339);
                var Ellipse = __webpack_require__(8497);
                var EllipseContains = __webpack_require__(81154);
                var Events = __webpack_require__(8214);
                var EventEmitter = __webpack_require__(50792);
                var GetFastValue = __webpack_require__(95540);
                var GEOM_CONST = __webpack_require__(23777);
                var InputPluginCache = __webpack_require__(89639);
                var IsPlainObject = __webpack_require__(41212);
                var PluginCache = __webpack_require__(37277);
                var Rectangle = __webpack_require__(87841);
                var RectangleContains = __webpack_require__(37303);
                var SceneEvents = __webpack_require__(44594);
                var Triangle = __webpack_require__(16483);
                var TriangleContains = __webpack_require__(10690);
                /**
 * @classdesc
 * The Input Plugin belongs to a Scene and handles all input related events and operations for it.
 *
 * You can access it from within a Scene using `this.input`.
 *
 * It emits events directly. For example, you can do:
 *
 * ```javascript
 * this.input.on('pointerdown', callback, context);
 * ```
 *
 * To listen for a pointer down event anywhere on the game canvas.
 *
 * Game Objects can be enabled for input by calling their `setInteractive` method. After which they
 * will directly emit input events:
 *
 * ```javascript
 * var sprite = this.add.sprite(x, y, texture);
 * sprite.setInteractive();
 * sprite.on('pointerdown', callback, context);
 * ```
 *
 * There are lots of game configuration options available relating to input.
 * See the [Input Config object]{@linkcode Phaser.Types.Core.InputConfig} for more details, including how to deal with Phaser
 * listening for input events outside of the canvas, how to set a default number of pointers, input
 * capture settings and more.
 *
 * Please also see the Input examples and tutorials for further information.
 *
 * **Incorrect input coordinates with Angular**
 *
 * If you are using Phaser within Angular, and use nglf or the router, to make the component in which the Phaser game resides
 * change state (i.e. appear or disappear) then you'll need to notify the Scale Manager about this, as Angular will mess with
 * the DOM in a way in which Phaser can't detect directly. Call `this.scale.updateBounds()` as part of your game init in order
 * to refresh the canvas DOM bounds values, which Phaser uses for input point position calculations.
 *
 * @class InputPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that this Input Plugin is responsible for.
 */ var InputPlugin = new Class({
                    Extends: EventEmitter,
                    initialize: function InputPlugin(scene) {
                        EventEmitter.call(this);
                        /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.InputPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene Systems class.
         *
         * @name Phaser.Input.InputPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.InputPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.5.0
         */ this.settings = scene.sys.settings;
                        /**
         * A reference to the Game Input Manager.
         *
         * @name Phaser.Input.InputPlugin#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = scene.sys.game.input;
                        /**
         * Internal event queue used for plugins only.
         *
         * @name Phaser.Input.InputPlugin#pluginEvents
         * @type {Phaser.Events.EventEmitter}
         * @private
         * @since 3.10.0
         */ this.pluginEvents = new EventEmitter();
                        /**
         * If `true` this Input Plugin will process DOM input events.
         *
         * @name Phaser.Input.InputPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.5.0
         */ this.enabled = true;
                        /**
         * A reference to the Scene Display List. This property is set during the `boot` method.
         *
         * @name Phaser.Input.InputPlugin#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.displayList;
                        /**
         * A reference to the Scene Cameras Manager. This property is set during the `boot` method.
         *
         * @name Phaser.Input.InputPlugin#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                        //  Inject the available input plugins into this class
                        InputPluginCache.install(this);
                        /**
         * A reference to the Mouse Manager.
         *
         * This property is only set if Mouse support has been enabled in your Game Configuration file.
         *
         * If you just wish to get access to the mouse pointer, use the `mousePointer` property instead.
         *
         * @name Phaser.Input.InputPlugin#mouse
         * @type {?Phaser.Input.Mouse.MouseManager}
         * @since 3.0.0
         */ this.mouse = this.manager.mouse;
                        /**
         * When set to `true` (the default) the Input Plugin will emulate DOM behavior by only emitting events from
         * the top-most Game Objects in the Display List.
         *
         * If set to `false` it will emit events from all Game Objects below a Pointer, not just the top one.
         *
         * @name Phaser.Input.InputPlugin#topOnly
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.topOnly = true;
                        /**
         * How often should the Pointers be checked?
         *
         * The value is a time, given in ms, and is the time that must have elapsed between game steps before
         * the Pointers will be polled again. When a pointer is polled it runs a hit test to see which Game
         * Objects are currently below it, or being interacted with it.
         *
         * Pointers will *always* be checked if they have been moved by the user, or press or released.
         *
         * This property only controls how often they will be polled if they have not been updated.
         * You should set this if you want to have Game Objects constantly check against the pointers, even
         * if the pointer didn't itself move.
         *
         * Set to 0 to poll constantly. Set to -1 to only poll on user movement.
         *
         * @name Phaser.Input.InputPlugin#pollRate
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.pollRate = -1;
                        /**
         * Internal poll timer value.
         *
         * @name Phaser.Input.InputPlugin#_pollTimer
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pollTimer = 0;
                        var _eventData = {
                            cancelled: false
                        };
                        /**
         * Internal event propagation callback container.
         *
         * @name Phaser.Input.InputPlugin#_eventContainer
         * @type {Phaser.Types.Input.EventData}
         * @private
         * @since 3.13.0
         */ this._eventContainer = {
                            stopPropagation: function() {
                                _eventData.cancelled = true;
                            }
                        };
                        /**
         * Internal event propagation data object.
         *
         * @name Phaser.Input.InputPlugin#_eventData
         * @type {object}
         * @private
         * @since 3.13.0
         */ this._eventData = _eventData;
                        /**
         * The distance, in pixels, a pointer has to move while being held down, before it thinks it is being dragged.
         *
         * @name Phaser.Input.InputPlugin#dragDistanceThreshold
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragDistanceThreshold = 0;
                        /**
         * The amount of time, in ms, a pointer has to be held down before it thinks it is dragging.
         *
         * The default polling rate is to poll only on move so once the time threshold is reached the
         * drag event will not start until you move the mouse. If you want it to start immediately
         * when the time threshold is reached, you must increase the polling rate by calling
         * [setPollAlways]{@linkcode Phaser.Input.InputPlugin#setPollAlways} or
         * [setPollRate]{@linkcode Phaser.Input.InputPlugin#setPollRate}.
         *
         * @name Phaser.Input.InputPlugin#dragTimeThreshold
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragTimeThreshold = 0;
                        /**
         * Used to temporarily store the results of the Hit Test
         *
         * @name Phaser.Input.InputPlugin#_temp
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._temp = [];
                        /**
         * Used to temporarily store the results of the Hit Test dropZones
         *
         * @name Phaser.Input.InputPlugin#_tempZones
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._tempZones = [];
                        /**
         * A list of all Game Objects that have been set to be interactive in the Scene this Input Plugin is managing.
         *
         * @name Phaser.Input.InputPlugin#_list
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._list = [];
                        /**
         * Objects waiting to be inserted to the list on the next call to 'begin'.
         *
         * @name Phaser.Input.InputPlugin#_pendingInsertion
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingInsertion = [];
                        /**
         * Objects waiting to be removed from the list on the next call to 'begin'.
         *
         * @name Phaser.Input.InputPlugin#_pendingRemoval
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingRemoval = [];
                        /**
         * A list of all Game Objects that have been enabled for dragging.
         *
         * @name Phaser.Input.InputPlugin#_draggable
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._draggable = [];
                        /**
         * A list of all Interactive Objects currently considered as being 'draggable' by any pointer, indexed by pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_drag
         * @type {{0:Array,1:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array,10:Array}}
         * @private
         * @since 3.0.0
         */ this._drag = {
                            0: [],
                            1: [],
                            2: [],
                            3: [],
                            4: [],
                            5: [],
                            6: [],
                            7: [],
                            8: [],
                            9: [],
                            10: []
                        };
                        /**
         * A array containing the dragStates, for this Scene, index by the Pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_dragState
         * @type {number[]}
         * @private
         * @since 3.16.0
         */ this._dragState = [];
                        /**
         * A list of all Interactive Objects currently considered as being 'over' by any pointer, indexed by pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_over
         * @type {{0:Array,1:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array,10:Array}}
         * @private
         * @since 3.0.0
         */ this._over = {
                            0: [],
                            1: [],
                            2: [],
                            3: [],
                            4: [],
                            5: [],
                            6: [],
                            7: [],
                            8: [],
                            9: [],
                            10: []
                        };
                        /**
         * A list of valid DOM event types.
         *
         * @name Phaser.Input.InputPlugin#_validTypes
         * @type {string[]}
         * @private
         * @since 3.0.0
         */ this._validTypes = [
                            'onDown',
                            'onUp',
                            'onOver',
                            'onOut',
                            'onMove',
                            'onDragStart',
                            'onDrag',
                            'onDragEnd',
                            'onDragEnter',
                            'onDragLeave',
                            'onDragOver',
                            'onDrop'
                        ];
                        /**
         * Internal property that tracks frame event state.
         *
         * @name Phaser.Input.InputPlugin#_updatedThisFrame
         * @type {boolean}
         * @private
         * @since 3.18.0
         */ this._updatedThisFrame = false;
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.InputPlugin#boot
     * @fires Phaser.Input.Events#BOOT
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.cameras = this.systems.cameras;
                        this.displayList = this.systems.displayList;
                        this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                        //  Registered input plugins listen for this
                        this.pluginEvents.emit(Events.BOOT);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.InputPlugin#start
     * @fires Phaser.Input.Events#START
     * @private
     * @since 3.5.0
     */ start: function() {
                        var eventEmitter = this.systems.events;
                        eventEmitter.on(SceneEvents.TRANSITION_START, this.transitionIn, this);
                        eventEmitter.on(SceneEvents.TRANSITION_OUT, this.transitionOut, this);
                        eventEmitter.on(SceneEvents.TRANSITION_COMPLETE, this.transitionComplete, this);
                        eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                        eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                        this.manager.events.on(Events.GAME_OUT, this.onGameOut, this);
                        this.manager.events.on(Events.GAME_OVER, this.onGameOver, this);
                        this.enabled = true;
                        //  Populate the pointer drag states
                        this._dragState = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ];
                        //  Registered input plugins listen for this
                        this.pluginEvents.emit(Events.START);
                    },
                    /**
     * Game Over handler.
     *
     * @method Phaser.Input.InputPlugin#onGameOver
     * @fires Phaser.Input.Events#GAME_OVER
     * @private
     * @since 3.16.2
     */ onGameOver: function(event) {
                        if (this.isActive()) this.emit(Events.GAME_OVER, event.timeStamp, event);
                    },
                    /**
     * Game Out handler.
     *
     * @method Phaser.Input.InputPlugin#onGameOut
     * @fires Phaser.Input.Events#GAME_OUT
     * @private
     * @since 3.16.2
     */ onGameOut: function(event) {
                        if (this.isActive()) this.emit(Events.GAME_OUT, event.timeStamp, event);
                    },
                    /**
     * The pre-update handler is responsible for checking the pending removal and insertion lists and
     * deleting old Game Objects.
     *
     * @method Phaser.Input.InputPlugin#preUpdate
     * @private
     * @fires Phaser.Input.Events#PRE_UPDATE
     * @since 3.0.0
     */ preUpdate: function() {
                        //  Registered input plugins listen for this
                        this.pluginEvents.emit(Events.PRE_UPDATE);
                        var removeList = this._pendingRemoval;
                        var insertList = this._pendingInsertion;
                        var toRemove = removeList.length;
                        var toInsert = insertList.length;
                        if (toRemove === 0 && toInsert === 0) //  Quick bail
                        return;
                        var current = this._list;
                        //  Delete old gameObjects
                        for(var i = 0; i < toRemove; i++){
                            var gameObject = removeList[i];
                            var index = current.indexOf(gameObject);
                            if (index > -1) {
                                current.splice(index, 1);
                                this.clear(gameObject, true);
                            }
                        }
                        //  Clear the removal list
                        this._pendingRemoval.length = 0;
                        //  Move pendingInsertion to list (also clears pendingInsertion at the same time)
                        this._list = current.concat(insertList.splice(0));
                    },
                    /**
     * Checks to see if the Input Manager, this plugin and the Scene to which it belongs are all active and input enabled.
     *
     * @method Phaser.Input.InputPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                        return this.manager && this.manager.enabled && this.enabled && this.scene.sys.canInput();
                    },
                    /**
     * Sets a custom cursor on the parent canvas element of the game, based on the `cursor`
     * setting of the given Interactive Object (i.e. a Sprite).
     * 
     * See the CSS property `cursor` for more information on MDN:
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     *
     * @method Phaser.Input.InputPlugin#setCursor
     * @since 3.85.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} interactiveObject - The Interactive Object that will set the cursor on the canvas.
     */ setCursor: function(interactiveObject) {
                        if (this.manager) this.manager.setCursor(interactiveObject);
                    },
                    /**
     * Forces the Input Manager to clear the custom or hand cursor, regardless of the
     * interactive state of any Game Objects.
     *
     * @method Phaser.Input.InputPlugin#resetCursor
     * @since 3.85.0
     */ resetCursor: function() {
                        if (this.manager) this.manager.resetCursor(null, true);
                    },
                    /**
     * This is called automatically by the Input Manager.
     * It emits events for plugins to listen to and also handles polling updates, if enabled.
     *
     * @method Phaser.Input.InputPlugin#updatePoll
     * @since 3.18.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ updatePoll: function(time, delta) {
                        if (!this.isActive()) return false;
                        //  The plugins should update every frame, regardless if there has been
                        //  any DOM input events or not (such as the Gamepad and Keyboard)
                        this.pluginEvents.emit(Events.UPDATE, time, delta);
                        //  We can leave now if we've already updated once this frame via the immediate DOM event handlers
                        if (this._updatedThisFrame) {
                            this._updatedThisFrame = false;
                            return false;
                        }
                        var i;
                        var manager = this.manager;
                        var pointers = manager.pointers;
                        for(i = 0; i < pointers.length; i++)pointers[i].updateMotion();
                        //  No point going any further if there aren't any interactive objects
                        if (this._list.length === 0) return false;
                        var rate = this.pollRate;
                        if (rate === -1) return false;
                        else if (rate > 0) {
                            this._pollTimer -= delta;
                            if (this._pollTimer < 0) //  Discard timer diff, we're ready to poll again
                            this._pollTimer = this.pollRate;
                            else //  Not enough time has elapsed since the last poll, so abort now
                            return false;
                        }
                        //  We got this far? Then we should poll for movement
                        var captured = false;
                        for(i = 0; i < pointers.length; i++){
                            var total = 0;
                            var pointer = pointers[i];
                            //  Always reset this array
                            this._tempZones = [];
                            //  _temp contains a hit tested and camera culled list of IO objects
                            this._temp = this.hitTestPointer(pointer);
                            this.sortGameObjects(this._temp, pointer);
                            this.sortDropZones(this._tempZones);
                            if (this.topOnly) {
                                //  Only the top-most one counts now, so safely ignore the rest
                                if (this._temp.length) this._temp.splice(1);
                                if (this._tempZones.length) this._tempZones.splice(1);
                            }
                            total += this.processOverOutEvents(pointer);
                            if (this.getDragState(pointer) === 2) this.processDragThresholdEvent(pointer, time);
                            if (total > 0) //  We interacted with an event in this Scene, so block any Scenes below us from doing the same this frame
                            captured = true;
                        }
                        return captured;
                    },
                    /**
     * This method is called when a DOM Event is received by the Input Manager. It handles dispatching the events
     * to relevant input enabled Game Objects in this scene.
     *
     * @method Phaser.Input.InputPlugin#update
     * @private
     * @fires Phaser.Input.Events#UPDATE
     * @since 3.0.0
     *
     * @param {number} type - The type of event to process.
     * @param {Phaser.Input.Pointer[]} pointers - An array of Pointers on which the event occurred.
     *
     * @return {boolean} `true` if this Scene has captured the input events from all other Scenes, otherwise `false`.
     */ update: function(type, pointers) {
                        if (!this.isActive()) return false;
                        var captured = false;
                        for(var i = 0; i < pointers.length; i++){
                            var total = 0;
                            var pointer = pointers[i];
                            //  Always reset this array
                            this._tempZones = [];
                            //  _temp contains a hit tested and camera culled list of IO objects
                            this._temp = this.hitTestPointer(pointer);
                            this.sortGameObjects(this._temp, pointer);
                            this.sortDropZones(this._tempZones);
                            if (this.topOnly) {
                                //  Only the top-most one counts now, so safely ignore the rest
                                if (this._temp.length) this._temp.splice(1);
                                if (this._tempZones.length) this._tempZones.splice(1);
                            }
                            switch(type){
                                case CONST.MOUSE_DOWN:
                                    total += this.processDragDownEvent(pointer);
                                    total += this.processDownEvents(pointer);
                                    total += this.processOverOutEvents(pointer);
                                    break;
                                case CONST.MOUSE_UP:
                                    total += this.processDragUpEvent(pointer);
                                    total += this.processUpEvents(pointer);
                                    total += this.processOverOutEvents(pointer);
                                    break;
                                case CONST.TOUCH_START:
                                    total += this.processDragDownEvent(pointer);
                                    total += this.processDownEvents(pointer);
                                    total += this.processOverEvents(pointer);
                                    break;
                                case CONST.TOUCH_END:
                                case CONST.TOUCH_CANCEL:
                                    total += this.processDragUpEvent(pointer);
                                    total += this.processUpEvents(pointer);
                                    total += this.processOutEvents(pointer);
                                    break;
                                case CONST.MOUSE_MOVE:
                                case CONST.TOUCH_MOVE:
                                    total += this.processDragMoveEvent(pointer);
                                    total += this.processMoveEvents(pointer);
                                    total += this.processOverOutEvents(pointer);
                                    break;
                                case CONST.MOUSE_WHEEL:
                                    total += this.processWheelEvent(pointer);
                                    break;
                            }
                            if (total > 0) //  We interacted with an event in this Scene, so block any Scenes below us from doing the same this frame
                            captured = true;
                        }
                        this._updatedThisFrame = true;
                        return captured;
                    },
                    /**
     * Clears a Game Object so it no longer has an Interactive Object associated with it.
     * The Game Object is then queued for removal from the Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#clear
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will have its Interactive Object removed.
     * @param {boolean} [skipQueue=false] - Skip adding this Game Object into the removal queue?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that had its Interactive Object removed.
     */ clear: function(gameObject, skipQueue) {
                        if (skipQueue === undefined) skipQueue = false;
                        this.disable(gameObject);
                        var input = gameObject.input;
                        // If GameObject.input already cleared from higher class
                        if (input) {
                            this.removeDebug(gameObject);
                            this.manager.resetCursor(input);
                            input.gameObject = undefined;
                            input.target = undefined;
                            input.hitArea = undefined;
                            input.hitAreaCallback = undefined;
                            input.callbackContext = undefined;
                            gameObject.input = null;
                        }
                        if (!skipQueue) this.queueForRemoval(gameObject);
                        var index = this._draggable.indexOf(gameObject);
                        if (index > -1) this._draggable.splice(index, 1);
                        return gameObject;
                    },
                    /**
     * Disables Input on a single Game Object.
     *
     * An input disabled Game Object still retains its Interactive Object component and can be re-enabled
     * at any time, by passing it to `InputPlugin.enable`.
     *
     * @method Phaser.Input.InputPlugin#disable
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its input system disabled.
     * @param {boolean} [resetCursor=false] - Reset the cursor to the default?
     *
     * @return {this} This Input Plugin.
     */ disable: function(gameObject, resetCursor) {
                        if (resetCursor === undefined) resetCursor = false;
                        var input = gameObject.input;
                        if (input) {
                            input.enabled = false;
                            input.dragState = 0;
                        }
                        // Clear from _drag and _over
                        var drag = this._drag;
                        var over = this._over;
                        var manager = this.manager;
                        for(var i = 0, index; i < manager.pointers.length; i++){
                            index = drag[i].indexOf(gameObject);
                            if (index > -1) drag[i].splice(index, 1);
                            index = over[i].indexOf(gameObject);
                            if (index > -1) over[i].splice(index, 1);
                        }
                        if (resetCursor) this.resetCursor();
                        return this;
                    },
                    /**
     * Enable a Game Object for interaction.
     *
     * If the Game Object already has an Interactive Object component, it is enabled and returned.
     *
     * Otherwise, a new Interactive Object component is created and assigned to the Game Object's `input` property.
     *
     * Input works by using hit areas, these are nearly always geometric shapes, such as rectangles or circles, that act as the hit area
     * for the Game Object. However, you can provide your own hit area shape and callback, should you wish to handle some more advanced
     * input detection.
     *
     * If no arguments are provided it will try and create a rectangle hit area based on the texture frame the Game Object is using. If
     * this isn't a texture-bound object, such as a Graphics or BitmapText object, this will fail, and you'll need to provide a specific
     * shape for it to use.
     *
     * You can also provide an Input Configuration Object as the only argument to this method.
     *
     * @method Phaser.Input.InputPlugin#enable
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to be enabled for input.
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} [hitAreaCallback] - The 'contains' function to invoke to check if the pointer is within the hit area.
     * @param {boolean} [dropZone=false] - Is this Game Object a drop zone or not?
     *
     * @return {this} This Input Plugin.
     */ enable: function(gameObject, hitArea, hitAreaCallback, dropZone) {
                        if (dropZone === undefined) dropZone = false;
                        if (gameObject.input) //  If it is already has an InteractiveObject then just enable it and return
                        gameObject.input.enabled = true;
                        else //  Create an InteractiveObject and enable it
                        this.setHitArea(gameObject, hitArea, hitAreaCallback);
                        if (gameObject.input && dropZone && !gameObject.input.dropZone) gameObject.input.dropZone = dropZone;
                        return this;
                    },
                    /**
     * Takes the given Pointer and performs a hit test against it, to see which interactive Game Objects
     * it is currently above.
     *
     * The hit test is performed against which-ever Camera the Pointer is over. If it is over multiple
     * cameras, it starts checking the camera at the top of the camera list, and if nothing is found, iterates down the list.
     *
     * @method Phaser.Input.InputPlugin#hitTestPointer
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against the Game Objects.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of all the interactive Game Objects the Pointer was above.
     */ hitTestPointer: function(pointer) {
                        var cameras = this.cameras.getCamerasBelowPointer(pointer);
                        for(var c = 0; c < cameras.length; c++){
                            var camera = cameras[c];
                            //  Get a list of all objects that can be seen by the camera below the pointer in the scene and store in 'over' array.
                            //  All objects in this array are input enabled, as checked by the hitTest method, so we don't need to check later on as well.
                            var over = this.manager.hitTest(pointer, this._list, camera);
                            //  Filter out the drop zones
                            for(var i = 0; i < over.length; i++){
                                var obj = over[i];
                                if (obj.input.dropZone) this._tempZones.push(obj);
                            }
                            if (over.length > 0) {
                                pointer.camera = camera;
                                return over;
                            }
                        }
                        //  If we got this far then there were no Game Objects below the pointer, but it was still over
                        //  a camera, so set that the top-most one into the pointer
                        pointer.camera = cameras[0];
                        return [];
                    },
                    /**
     * An internal method that handles the Pointer down event.
     *
     * @method Phaser.Input.InputPlugin#processDownEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_DOWN
     * @fires Phaser.Input.Events#GAMEOBJECT_DOWN
     * @fires Phaser.Input.Events#POINTER_DOWN
     * @fires Phaser.Input.Events#POINTER_DOWN_OUTSIDE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer being tested.
     *
     * @return {number} The total number of objects interacted with.
     */ processDownEvents: function(pointer) {
                        var total = 0;
                        var currentlyOver = this._temp;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        //  Go through all objects the pointer was over and fire their events / callbacks
                        for(var i = 0; i < currentlyOver.length; i++){
                            var gameObject = currentlyOver[i];
                            if (!gameObject.input || !gameObject.input.enabled) continue;
                            total++;
                            //  1) GAMEOBJECT_POINTER_DOWN
                            gameObject.emit(Events.GAMEOBJECT_POINTER_DOWN, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            if (_eventData.cancelled || !this.isActive()) break;
                            //  Check that the game object wasn't input disabled or destroyed as a result of its input event
                            if (gameObject.input && gameObject.input.enabled) {
                                //  2) GAMEOBJECT_DOWN
                                this.emit(Events.GAMEOBJECT_DOWN, pointer, gameObject, _eventContainer);
                                if (_eventData.cancelled || !this.isActive()) break;
                            }
                        }
                        //  If they pressed down outside the canvas, dispatch that event.
                        if (!_eventData.cancelled && this.isActive()) {
                            if (pointer.downElement === this.manager.game.canvas) //  3) POINTER_DOWN
                            this.emit(Events.POINTER_DOWN, pointer, currentlyOver);
                            else //  4) POINTER_DOWN_OUTSIDE
                            this.emit(Events.POINTER_DOWN_OUTSIDE, pointer);
                        }
                        return total;
                    },
                    /**
     * Returns the drag state of the given Pointer for this Input Plugin.
     *
     * The state will be one of the following:
     *
     * 0 = Not dragging anything
     * 1 = Primary button down and objects below, so collect a draglist
     * 2 = Pointer being checked if meets drag criteria
     * 3 = Pointer meets criteria, notify the draglist
     * 4 = Pointer actively dragging the draglist and has moved
     * 5 = Pointer actively dragging but has been released, notify draglist
     *
     * @method Phaser.Input.InputPlugin#getDragState
     * @since 3.16.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to get the drag state for.
     *
     * @return {number} The drag state of the given Pointer.
     */ getDragState: function(pointer) {
                        return this._dragState[pointer.id];
                    },
                    /**
     * Sets the drag state of the given Pointer for this Input Plugin.
     *
     * The state must be one of the following values:
     *
     * 0 = Not dragging anything
     * 1 = Primary button down and objects below, so collect a draglist
     * 2 = Pointer being checked if meets drag criteria
     * 3 = Pointer meets criteria, notify the draglist
     * 4 = Pointer actively dragging the draglist and has moved
     * 5 = Pointer actively dragging but has been released, notify draglist
     *
     * @method Phaser.Input.InputPlugin#setDragState
     * @since 3.16.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to set the drag state for.
     * @param {number} state - The drag state value. An integer between 0 and 5.
     */ setDragState: function(pointer, state) {
                        this._dragState[pointer.id] = state;
                    },
                    /**
     * Checks to see if a Pointer is ready to drag the objects below it, based on either a distance
     * or time threshold.
     *
     * @method Phaser.Input.InputPlugin#processDragThresholdEvent
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check the drag thresholds on.
     * @param {number} time - The current time.
     */ processDragThresholdEvent: function(pointer, time) {
                        var passed = false;
                        var timeThreshold = this.dragTimeThreshold;
                        var distanceThreshold = this.dragDistanceThreshold;
                        if (distanceThreshold > 0 && DistanceBetween(pointer.x, pointer.y, pointer.downX, pointer.downY) >= distanceThreshold) //  It has moved far enough to be considered a drag
                        passed = true;
                        else if (timeThreshold > 0 && time >= pointer.downTime + timeThreshold) //  It has been held down long enough to be considered a drag
                        passed = true;
                        if (passed) {
                            this.setDragState(pointer, 3);
                            return this.processDragStartList(pointer);
                        }
                    },
                    /**
     * Processes the drag list for the given pointer and dispatches the start events for each object on it.
     *
     * @method Phaser.Input.InputPlugin#processDragStartList
     * @private
     * @fires Phaser.Input.Events#DRAG_START
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_START
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that DRAG_START was called on.
     */ processDragStartList: function(pointer) {
                        //  3 = Pointer meets criteria and is freshly down, notify the draglist
                        if (this.getDragState(pointer) !== 3) return 0;
                        var list = this._drag[pointer.id];
                        if (list.length > 1) list = list.slice(0);
                        for(var i = 0; i < list.length; i++){
                            var gameObject = list[i];
                            var input = gameObject.input;
                            input.dragState = 2;
                            input.dragStartX = gameObject.x;
                            input.dragStartY = gameObject.y;
                            input.dragStartXGlobal = pointer.worldX;
                            input.dragStartYGlobal = pointer.worldY;
                            input.dragStartCamera = pointer.camera;
                            input.dragX = input.dragStartXGlobal - input.dragStartX;
                            input.dragY = input.dragStartYGlobal - input.dragStartY;
                            gameObject.emit(Events.GAMEOBJECT_DRAG_START, pointer, input.dragX, input.dragY);
                            this.emit(Events.DRAG_START, pointer, gameObject);
                        }
                        this.setDragState(pointer, 4);
                        return list.length;
                    },
                    /**
     * Processes a 'drag down' event for the given pointer. Checks the pointer state, builds-up the drag list
     * and prepares them all for interaction.
     *
     * @method Phaser.Input.InputPlugin#processDragDownEvent
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were collected on the drag list.
     */ processDragDownEvent: function(pointer) {
                        var currentlyOver = this._temp;
                        if (this._draggable.length === 0 || currentlyOver.length === 0 || !pointer.primaryDown || this.getDragState(pointer) !== 0) //  There are no draggable items, no over items or the pointer isn't down, so let's not even bother going further
                        return 0;
                        //  1 = Primary button down and objects below, so collect a draglist
                        this.setDragState(pointer, 1);
                        //  Get draggable objects, sort them, pick the top (or all) and store them somewhere
                        var draglist = [];
                        for(var i = 0; i < currentlyOver.length; i++){
                            var gameObject = currentlyOver[i];
                            if (gameObject.input.draggable && gameObject.input.dragState === 0) draglist.push(gameObject);
                        }
                        if (draglist.length === 0) {
                            this.setDragState(pointer, 0);
                            return 0;
                        } else if (draglist.length > 1) {
                            this.sortGameObjects(draglist, pointer);
                            if (this.topOnly) draglist.splice(1);
                        }
                        //  draglist now contains all potential candidates for dragging
                        this._drag[pointer.id] = draglist;
                        if (this.dragDistanceThreshold === 0 && this.dragTimeThreshold === 0) {
                            //  No drag criteria, so snap immediately to mode 3
                            this.setDragState(pointer, 3);
                            return this.processDragStartList(pointer);
                        } else {
                            //  Check the distance / time on the next event
                            this.setDragState(pointer, 2);
                            return 0;
                        }
                    },
                    /**
     * Processes a 'drag move' event for the given pointer.
     *
     * @method Phaser.Input.InputPlugin#processDragMoveEvent
     * @private
     * @fires Phaser.Input.Events#DRAG_ENTER
     * @fires Phaser.Input.Events#DRAG
     * @fires Phaser.Input.Events#DRAG_LEAVE
     * @fires Phaser.Input.Events#DRAG_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_ENTER
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_LEAVE
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_OVER
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were updated by this drag event.
     */ processDragMoveEvent: function(pointer) {
                        //  2 = Pointer being checked if meets drag criteria
                        if (this.getDragState(pointer) === 2) this.processDragThresholdEvent(pointer, this.manager.game.loop.now);
                        if (this.getDragState(pointer) !== 4) return 0;
                        //  4 = Pointer actively dragging the draglist and has moved
                        var dropZones = this._tempZones;
                        var list = this._drag[pointer.id];
                        if (list.length > 1) list = list.slice(0);
                        for(var i = 0; i < list.length; i++){
                            var gameObject = list[i];
                            var input = gameObject.input;
                            var target = input.target;
                            //  If this GO has a target then let's check it
                            if (target) {
                                var index = dropZones.indexOf(target);
                                //  Got a target, are we still over it?
                                if (index === 0) {
                                    //  We're still over it, and it's still the top of the display list, phew ...
                                    gameObject.emit(Events.GAMEOBJECT_DRAG_OVER, pointer, target);
                                    this.emit(Events.DRAG_OVER, pointer, gameObject, target);
                                } else if (index > 0) {
                                    //  Still over it but it's no longer top of the display list (targets must always be at the top)
                                    gameObject.emit(Events.GAMEOBJECT_DRAG_LEAVE, pointer, target);
                                    this.emit(Events.DRAG_LEAVE, pointer, gameObject, target);
                                    input.target = dropZones[0];
                                    target = input.target;
                                    gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                                    this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                                } else {
                                    //  Nope, we've moved on (or the target has!), leave the old target
                                    gameObject.emit(Events.GAMEOBJECT_DRAG_LEAVE, pointer, target);
                                    this.emit(Events.DRAG_LEAVE, pointer, gameObject, target);
                                    //  Anything new to replace it?
                                    //  Yup!
                                    if (dropZones[0]) {
                                        input.target = dropZones[0];
                                        target = input.target;
                                        gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                                        this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                                    } else //  Nope
                                    input.target = null;
                                }
                            } else if (!target && dropZones[0]) {
                                input.target = dropZones[0];
                                target = input.target;
                                gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                                this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                            }
                            var dragX;
                            var dragY;
                            var dragWorldXY = pointer.positionToCamera(input.dragStartCamera);
                            if (!gameObject.parentContainer) {
                                dragX = dragWorldXY.x - input.dragX;
                                dragY = dragWorldXY.y - input.dragY;
                            } else {
                                var dx = dragWorldXY.x - input.dragStartXGlobal;
                                var dy = dragWorldXY.y - input.dragStartYGlobal;
                                var rotation = gameObject.getParentRotation();
                                var dxRotated = dx * Math.cos(rotation) + dy * Math.sin(rotation);
                                var dyRotated = dy * Math.cos(rotation) - dx * Math.sin(rotation);
                                dxRotated *= 1 / gameObject.parentContainer.scaleX;
                                dyRotated *= 1 / gameObject.parentContainer.scaleY;
                                dragX = dxRotated + input.dragStartX;
                                dragY = dyRotated + input.dragStartY;
                            }
                            gameObject.emit(Events.GAMEOBJECT_DRAG, pointer, dragX, dragY);
                            this.emit(Events.DRAG, pointer, gameObject, dragX, dragY);
                        }
                        return list.length;
                    },
                    /**
     * Processes a 'drag down' event for the given pointer. Checks the pointer state, builds-up the drag list
     * and prepares them all for interaction.
     *
     * @method Phaser.Input.InputPlugin#processDragUpEvent
     * @fires Phaser.Input.Events#DRAG_END
     * @fires Phaser.Input.Events#DROP
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_END
     * @fires Phaser.Input.Events#GAMEOBJECT_DROP
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were updated by this drag event.
     */ processDragUpEvent: function(pointer) {
                        //  5 = Pointer was actively dragging but has been released, notify draglist
                        var list = this._drag[pointer.id];
                        if (list.length > 1) list = list.slice(0);
                        for(var i = 0; i < list.length; i++){
                            var gameObject = list[i];
                            var input = gameObject.input;
                            if (input && input.dragState === 2) {
                                input.dragState = 0;
                                input.dragX = input.localX - gameObject.displayOriginX;
                                input.dragY = input.localY - gameObject.displayOriginY;
                                input.dragStartCamera = null;
                                var dropped = false;
                                var target = input.target;
                                if (target) {
                                    gameObject.emit(Events.GAMEOBJECT_DROP, pointer, target);
                                    this.emit(Events.DROP, pointer, gameObject, target);
                                    input.target = null;
                                    dropped = true;
                                }
                                //  And finally the dragend event
                                if (gameObject.input && gameObject.input.enabled) {
                                    gameObject.emit(Events.GAMEOBJECT_DRAG_END, pointer, input.dragX, input.dragY, dropped);
                                    this.emit(Events.DRAG_END, pointer, gameObject, dropped);
                                }
                            }
                        }
                        this.setDragState(pointer, 0);
                        list.splice(0);
                        return 0;
                    },
                    /**
     * An internal method that handles the Pointer movement event.
     *
     * @method Phaser.Input.InputPlugin#processMoveEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_MOVE
     * @fires Phaser.Input.Events#GAMEOBJECT_MOVE
     * @fires Phaser.Input.Events#POINTER_MOVE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processMoveEvents: function(pointer) {
                        var total = 0;
                        var currentlyOver = this._temp;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        //  Go through all objects the pointer was over and fire their events / callbacks
                        for(var i = 0; i < currentlyOver.length; i++){
                            var gameObject = currentlyOver[i];
                            if (!gameObject.input || !gameObject.input.enabled) continue;
                            total++;
                            gameObject.emit(Events.GAMEOBJECT_POINTER_MOVE, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            if (_eventData.cancelled || !this.isActive()) break;
                            //  Check that the game object wasn't input disabled or destroyed as a result of its input event
                            if (gameObject.input && gameObject.input.enabled) {
                                this.emit(Events.GAMEOBJECT_MOVE, pointer, gameObject, _eventContainer);
                                if (_eventData.cancelled || !this.isActive()) break;
                                if (this.topOnly) break;
                            }
                        }
                        if (!_eventData.cancelled && this.isActive()) this.emit(Events.POINTER_MOVE, pointer, currentlyOver);
                        return total;
                    },
                    /**
     * An internal method that handles a mouse wheel event.
     *
     * @method Phaser.Input.InputPlugin#processWheelEvent
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_WHEEL
     * @fires Phaser.Input.Events#GAMEOBJECT_WHEEL
     * @fires Phaser.Input.Events#POINTER_WHEEL
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processWheelEvent: function(pointer) {
                        var total = 0;
                        var currentlyOver = this._temp;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        var dx = pointer.deltaX;
                        var dy = pointer.deltaY;
                        var dz = pointer.deltaZ;
                        //  Go through all objects the pointer was over and fire their events / callbacks
                        for(var i = 0; i < currentlyOver.length; i++){
                            var gameObject = currentlyOver[i];
                            if (!gameObject.input || !gameObject.input.enabled) continue;
                            total++;
                            gameObject.emit(Events.GAMEOBJECT_POINTER_WHEEL, pointer, dx, dy, dz, _eventContainer);
                            if (_eventData.cancelled || !this.isActive()) break;
                            //  Check that the game object wasn't input disabled or destroyed as a result of its input event
                            if (gameObject.input && gameObject.input.enabled) {
                                this.emit(Events.GAMEOBJECT_WHEEL, pointer, gameObject, dx, dy, dz, _eventContainer);
                                if (_eventData.cancelled || !this.isActive()) break;
                            }
                        }
                        if (!_eventData.cancelled && this.isActive()) this.emit(Events.POINTER_WHEEL, pointer, currentlyOver, dx, dy, dz);
                        return total;
                    },
                    /**
     * An internal method that handles the Pointer over events.
     * This is called when a touch input hits the canvas, having previously been off of it.
     *
     * @method Phaser.Input.InputPlugin#processOverEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_OVER
     * @fires Phaser.Input.Events#POINTER_OVER
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOverEvents: function(pointer) {
                        var currentlyOver = this._temp;
                        var totalInteracted = 0;
                        var total = currentlyOver.length;
                        var justOver = [];
                        if (total > 0) {
                            var manager = this.manager;
                            var _eventData = this._eventData;
                            var _eventContainer = this._eventContainer;
                            _eventData.cancelled = false;
                            for(var i = 0; i < total; i++){
                                var gameObject = currentlyOver[i];
                                if (!gameObject.input || !gameObject.input.enabled) continue;
                                justOver.push(gameObject);
                                manager.setCursor(gameObject.input);
                                gameObject.emit(Events.GAMEOBJECT_POINTER_OVER, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                                totalInteracted++;
                                if (_eventData.cancelled || !this.isActive()) break;
                                //  Check that the game object wasn't input disabled or destroyed as a result of its input event
                                if (gameObject.input && gameObject.input.enabled) {
                                    this.emit(Events.GAMEOBJECT_OVER, pointer, gameObject, _eventContainer);
                                    if (_eventData.cancelled || !this.isActive()) break;
                                }
                            }
                            if (!_eventData.cancelled && this.isActive()) this.emit(Events.POINTER_OVER, pointer, justOver);
                        }
                        //  Then sort it into display list order
                        this._over[pointer.id] = justOver;
                        return totalInteracted;
                    },
                    /**
     * An internal method that handles the Pointer out events.
     * This is called when a touch input leaves the canvas, as it can never be 'over' in this case.
     *
     * @method Phaser.Input.InputPlugin#processOutEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
     * @fires Phaser.Input.Events#GAMEOBJECT_OUT
     * @fires Phaser.Input.Events#POINTER_OUT
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOutEvents: function(pointer) {
                        var previouslyOver = this._over[pointer.id];
                        var totalInteracted = 0;
                        var total = previouslyOver.length;
                        if (total > 0) {
                            var manager = this.manager;
                            var _eventData = this._eventData;
                            var _eventContainer = this._eventContainer;
                            _eventData.cancelled = false;
                            this.sortGameObjects(previouslyOver, pointer);
                            for(var i = 0; i < total; i++){
                                var gameObject = previouslyOver[i];
                                //  Call onOut for everything in the previouslyOver array
                                gameObject = previouslyOver[i];
                                if (!gameObject.input || !gameObject.input.enabled) continue;
                                manager.resetCursor(gameObject.input);
                                gameObject.emit(Events.GAMEOBJECT_POINTER_OUT, pointer, _eventContainer);
                                totalInteracted++;
                                if (_eventData.cancelled || !this.isActive()) break;
                                if (gameObject.input && gameObject.input.enabled) {
                                    this.emit(Events.GAMEOBJECT_OUT, pointer, gameObject, _eventContainer);
                                    if (_eventData.cancelled || !this.isActive()) break;
                                }
                            }
                            if (!_eventData.cancelled && this.isActive()) this.emit(Events.POINTER_OUT, pointer, previouslyOver);
                            this._over[pointer.id] = [];
                        }
                        return totalInteracted;
                    },
                    /**
     * An internal method that handles the Pointer over and out events.
     *
     * @method Phaser.Input.InputPlugin#processOverOutEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_OVER
     * @fires Phaser.Input.Events#POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
     * @fires Phaser.Input.Events#GAMEOBJECT_OUT
     * @fires Phaser.Input.Events#POINTER_OUT
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOverOutEvents: function(pointer) {
                        var currentlyOver = this._temp;
                        var i;
                        var gameObject;
                        var justOut = [];
                        var justOver = [];
                        var stillOver = [];
                        var previouslyOver = this._over[pointer.id];
                        var currentlyDragging = this._drag[pointer.id];
                        var manager = this.manager;
                        //  Go through all objects the pointer was previously over, and see if it still is.
                        //  Splits the previouslyOver array into two parts: justOut and stillOver
                        for(i = 0; i < previouslyOver.length; i++){
                            gameObject = previouslyOver[i];
                            if (currentlyOver.indexOf(gameObject) === -1 && currentlyDragging.indexOf(gameObject) === -1) //  Not in the currentlyOver array, so must be outside of this object now
                            justOut.push(gameObject);
                            else //  In the currentlyOver array
                            stillOver.push(gameObject);
                        }
                        //  Go through all objects the pointer is currently over (the hit test results)
                        //  and if not in the previouslyOver array we know it's a new entry, so add to justOver
                        for(i = 0; i < currentlyOver.length; i++){
                            gameObject = currentlyOver[i];
                            //  Is this newly over?
                            if (previouslyOver.indexOf(gameObject) === -1) justOver.push(gameObject);
                        }
                        //  By this point the arrays are filled, so now we can process what happened...
                        //  Process the Just Out objects
                        var total = justOut.length;
                        var totalInteracted = 0;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        if (total > 0) {
                            this.sortGameObjects(justOut, pointer);
                            //  Call onOut for everything in the justOut array
                            for(i = 0; i < total; i++){
                                gameObject = justOut[i];
                                if (!gameObject.input || !gameObject.input.enabled) continue;
                                //  Reset cursor before we emit the event, in case they want to change it during the event
                                manager.resetCursor(gameObject.input);
                                gameObject.emit(Events.GAMEOBJECT_POINTER_OUT, pointer, _eventContainer);
                                totalInteracted++;
                                if (_eventData.cancelled || !this.isActive()) break;
                                //  Check that the game object wasn't input disabled or destroyed as a result of its input event
                                if (gameObject.input && gameObject.input.enabled) {
                                    this.emit(Events.GAMEOBJECT_OUT, pointer, gameObject, _eventContainer);
                                    if (_eventData.cancelled || !this.isActive()) break;
                                }
                            }
                            if (!_eventData.cancelled || this.isActive()) this.emit(Events.POINTER_OUT, pointer, justOut);
                        }
                        //  Process the Just Over objects
                        total = justOver.length;
                        _eventData.cancelled = false;
                        if (total > 0) {
                            this.sortGameObjects(justOver, pointer);
                            //  Call onOver for everything in the justOver array
                            for(i = 0; i < total; i++){
                                gameObject = justOver[i];
                                if (!gameObject.input || !gameObject.input.enabled) continue;
                                //  Set cursor before we emit the event, in case they want to change it during the event
                                manager.setCursor(gameObject.input);
                                gameObject.emit(Events.GAMEOBJECT_POINTER_OVER, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                                totalInteracted++;
                                if (_eventData.cancelled || !this.isActive()) break;
                                //  Check that the game object wasn't input disabled or destroyed as a result of its input event
                                if (gameObject.input && gameObject.input.enabled) {
                                    this.emit(Events.GAMEOBJECT_OVER, pointer, gameObject, _eventContainer);
                                    if (_eventData.cancelled || !this.isActive()) break;
                                }
                            }
                            if (!_eventData.cancelled && this.isActive()) this.emit(Events.POINTER_OVER, pointer, justOver);
                        }
                        //  Add the contents of justOver to the previously over array
                        previouslyOver = stillOver.concat(justOver);
                        //  Then sort it into display list order
                        this._over[pointer.id] = this.sortGameObjects(previouslyOver, pointer);
                        return totalInteracted;
                    },
                    /**
     * An internal method that handles the Pointer up events.
     *
     * @method Phaser.Input.InputPlugin#processUpEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_UP
     * @fires Phaser.Input.Events#GAMEOBJECT_UP
     * @fires Phaser.Input.Events#POINTER_UP
     * @fires Phaser.Input.Events#POINTER_UP_OUTSIDE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processUpEvents: function(pointer) {
                        var currentlyOver = this._temp;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        //  Go through all objects the pointer was over and fire their events / callbacks
                        for(var i = 0; i < currentlyOver.length; i++){
                            var gameObject = currentlyOver[i];
                            if (!gameObject.input || !gameObject.input.enabled) continue;
                            //  1) GAMEOBJECT_POINTER_UP
                            gameObject.emit(Events.GAMEOBJECT_POINTER_UP, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            if (_eventData.cancelled || !this.isActive()) break;
                            //  Check that the game object wasn't input disabled or destroyed as a result of its input event
                            if (gameObject.input && gameObject.input.enabled) {
                                //  2) GAMEOBJECT_UP
                                this.emit(Events.GAMEOBJECT_UP, pointer, gameObject, _eventContainer);
                                if (_eventData.cancelled || !this.isActive()) break;
                            }
                        }
                        //  If they released outside the canvas, but pressed down inside it, we'll still dispatch the event.
                        if (!_eventData.cancelled && this.isActive()) {
                            if (pointer.upElement === this.manager.game.canvas) this.emit(Events.POINTER_UP, pointer, currentlyOver);
                            else this.emit(Events.POINTER_UP_OUTSIDE, pointer);
                        }
                        return currentlyOver.length;
                    },
                    /**
     * This method will force the given Game Object into the 'down' input state.
     * 
     * This will check to see if the Game Object is enabled for input, and if so,
     * it will emit the `GAMEOBJECT_POINTER_DOWN` event for it. If that doesn't change
     * the input state, it will then emit the `GAMEOBJECT_DOWN` event.
     * 
     * The Game Object is not checked against the Pointer to see if it can enter this state,
     * that is up to you to do before calling this method.
     *
     * @method Phaser.Input.InputPlugin#forceDownState
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_DOWN
     * @fires Phaser.Input.Events#GAMEOBJECT_DOWN
     * @since 3.85.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to use when setting the state.
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its state set.
     */ forceDownState: function(pointer, gameObject) {
                        this.forceState(pointer, gameObject, Events.GAMEOBJECT_POINTER_DOWN, Events.GAMEOBJECT_DOWN, false);
                    },
                    /**
     * This method will force the given Game Object into the 'up' input state.
     * 
     * This will check to see if the Game Object is enabled for input, and if so,
     * it will emit the `GAMEOBJECT_POINTER_UP` event for it. If that doesn't change
     * the input state, it will then emit the `GAMEOBJECT_UP` event.
     * 
     * The Game Object is not checked against the Pointer to see if it can enter this state,
     * that is up to you to do before calling this method.
     *
     * @method Phaser.Input.InputPlugin#forceUpState
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_UP
     * @fires Phaser.Input.Events#GAMEOBJECT_UP
     * @since 3.85.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to use when setting the state.
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its state set.
     */ forceUpState: function(pointer, gameObject) {
                        this.forceState(pointer, gameObject, Events.GAMEOBJECT_POINTER_UP, Events.GAMEOBJECT_UP, false);
                    },
                    /**
     * This method will force the given Game Object into the 'over' input state.
     * 
     * This will check to see if the Game Object is enabled for input, and if so,
     * it will emit the `GAMEOBJECT_POINTER_OVER` event for it. If that doesn't change
     * the input state, it will then emit the `GAMEOBJECT_OVER` event.
     * 
     * The Game Object is not checked against the Pointer to see if it can enter this state,
     * that is up to you to do before calling this method.
     *
     * @method Phaser.Input.InputPlugin#forceOverState
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_OVER
     * @since 3.85.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to use when setting the state.
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its state set.
     */ forceOverState: function(pointer, gameObject) {
                        this.forceState(pointer, gameObject, Events.GAMEOBJECT_POINTER_OVER, Events.GAMEOBJECT_OVER, true);
                    },
                    /**
     * This method will force the given Game Object into the 'out' input state.
     * 
     * This will check to see if the Game Object is enabled for input, and if so,
     * it will emit the `GAMEOBJECT_POINTER_OUT` event for it. If that doesn't change
     * the input state, it will then emit the `GAMEOBJECT_OUT` event.
     * 
     * The Game Object is not checked against the Pointer to see if it can enter this state,
     * that is up to you to do before calling this method.
     *
     * @method Phaser.Input.InputPlugin#forceOutState
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
     * @fires Phaser.Input.Events#GAMEOBJECT_OUT
     * @since 3.85.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to use when setting the state.
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its state set.
     */ forceOutState: function(pointer, gameObject) {
                        this.forceState(pointer, gameObject, Events.GAMEOBJECT_POINTER_OUT, Events.GAMEOBJECT_OUT, false);
                    },
                    /**
     * This method will force the given Game Object into the given input state.
     * 
     * @method Phaser.Input.InputPlugin#forceState
     * @since 3.85.0
     * 
     * @param {Phaser.Input.Pointer} pointer - The pointer to use when setting the state.
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its state set.
     * @param {string} gameObjectEvent - The event to emit on the Game Object.
     * @param {string} inputPluginEvent - The event to emit on the Input Plugin.
     * @param {boolean} [setCursor=false] - Should the cursor be set to the Game Object's cursor?
     */ forceState: function(pointer, gameObject, gameObjectEvent, inputPluginEvent, setCursor) {
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        if (gameObject.input && gameObject.input.enabled) {
                            gameObject.emit(gameObjectEvent, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            if (setCursor) this.setCursor(gameObject.input);
                            if (!_eventData.cancelled && this.isActive() && gameObject.input && gameObject.input.enabled) this.emit(inputPluginEvent, pointer, gameObject, _eventContainer);
                        }
                    },
                    /**
     * Queues a Game Object for insertion into this Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#queueForInsertion
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
     *
     * @return {this} This InputPlugin object.
     */ queueForInsertion: function(child) {
                        if (this._pendingInsertion.indexOf(child) === -1 && this._list.indexOf(child) === -1) this._pendingInsertion.push(child);
                        return this;
                    },
                    /**
     * Queues a Game Object for removal from this Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#queueForRemoval
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
     *
     * @return {this} This InputPlugin object.
     */ queueForRemoval: function(child) {
                        this._pendingRemoval.push(child);
                        return this;
                    },
                    /**
     * Sets the draggable state of the given array of Game Objects.
     *
     * They can either be set to be draggable, or can have their draggable state removed by passing `false`.
     *
     * A Game Object will not fire drag events unless it has been specifically enabled for drag.
     *
     * @method Phaser.Input.InputPlugin#setDraggable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to change the draggable state on.
     * @param {boolean} [value=true] - Set to `true` if the Game Objects should be made draggable, `false` if they should be unset.
     *
     * @return {this} This InputPlugin object.
     */ setDraggable: function(gameObjects, value) {
                        if (value === undefined) value = true;
                        if (!Array.isArray(gameObjects)) gameObjects = [
                            gameObjects
                        ];
                        for(var i = 0; i < gameObjects.length; i++){
                            var gameObject = gameObjects[i];
                            gameObject.input.draggable = value;
                            var index = this._draggable.indexOf(gameObject);
                            if (value && index === -1) this._draggable.push(gameObject);
                            else if (!value && index > -1) this._draggable.splice(index, 1);
                        }
                        return this;
                    },
                    /**
     * Creates a function that can be passed to `setInteractive`, `enable` or `setHitArea` that will handle
     * pixel-perfect input detection on an Image or Sprite based Game Object, or any custom class that extends them.
     *
     * The following will create a sprite that is clickable on any pixel that has an alpha value >= 1.
     *
     * ```javascript
     * this.add.sprite(x, y, key).setInteractive(this.input.makePixelPerfect());
     * ```
     *
     * The following will create a sprite that is clickable on any pixel that has an alpha value >= 150.
     *
     * ```javascript
     * this.add.sprite(x, y, key).setInteractive(this.input.makePixelPerfect(150));
     * ```
     *
     * Once you have made an Interactive Object pixel perfect it impacts all input related events for it: down, up,
     * dragstart, drag, etc.
     *
     * As a pointer interacts with the Game Object it will constantly poll the texture, extracting a single pixel from
     * the given coordinates and checking its color values. This is an expensive process, so should only be enabled on
     * Game Objects that really need it.
     *
     * You cannot make non-texture based Game Objects pixel perfect. So this will not work on Graphics, BitmapText,
     * Render Textures, Text, Tilemaps, Containers or Particles.
     *
     * @method Phaser.Input.InputPlugin#makePixelPerfect
     * @since 3.10.0
     *
     * @param {number} [alphaTolerance=1] - The alpha level that the pixel should be above to be included as a successful interaction.
     *
     * @return {function} A Pixel Perfect Handler for use as a hitArea shape callback.
     */ makePixelPerfect: function(alphaTolerance) {
                        if (alphaTolerance === undefined) alphaTolerance = 1;
                        var textureManager = this.systems.textures;
                        return CreatePixelPerfectHandler(textureManager, alphaTolerance);
                    },
                    /**
     * Sets the hit area for the given array of Game Objects.
     *
     * A hit area is typically one of the geometric shapes Phaser provides, such as a `Phaser.Geom.Rectangle`
     * or `Phaser.Geom.Circle`. However, it can be any object as long as it works with the provided callback.
     *
     * If no hit area is provided a Rectangle is created based on the size of the Game Object, if possible
     * to calculate.
     *
     * The hit area callback is the function that takes an `x` and `y` coordinate and returns a boolean if
     * those values fall within the area of the shape or not. All of the Phaser geometry objects provide this,
     * such as `Phaser.Geom.Rectangle.Contains`.
     * 
     * A hit area callback can be supplied to the `hitArea` parameter without using the `hitAreaCallback` parameter.
     *
     * @method Phaser.Input.InputPlugin#setHitArea
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set the hit area on.
     * @param {(Phaser.Types.Input.InputConfiguration|Phaser.Types.Input.HitAreaCallback|any)} [hitArea] - Either an input configuration object, a geometric shape that defines the hit area or a hit area callback. If not specified a Rectangle hit area will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} [hitAreaCallback] - The 'contains' function to invoke to check if the pointer is within the hit area.
     *
     * @return {this} This InputPlugin object.
     */ setHitArea: function(gameObjects, hitArea, hitAreaCallback) {
                        if (hitArea === undefined) return this.setHitAreaFromTexture(gameObjects);
                        if (!Array.isArray(gameObjects)) gameObjects = [
                            gameObjects
                        ];
                        var draggable = false;
                        var dropZone = false;
                        var cursor = false;
                        var useHandCursor = false;
                        var pixelPerfect = false;
                        var customHitArea = true;
                        //  Config object?
                        if (IsPlainObject(hitArea) && Object.keys(hitArea).length) {
                            var config = hitArea;
                            // Check if any supplied Game Object is a Mesh based Game Object
                            var isMesh = gameObjects.some(function(gameObject) {
                                return gameObject.hasOwnProperty('faces');
                            });
                            if (!isMesh) {
                                hitArea = GetFastValue(config, 'hitArea', null);
                                hitAreaCallback = GetFastValue(config, 'hitAreaCallback', null);
                                pixelPerfect = GetFastValue(config, 'pixelPerfect', false);
                                var alphaTolerance = GetFastValue(config, 'alphaTolerance', 1);
                                if (pixelPerfect) {
                                    hitArea = {};
                                    hitAreaCallback = this.makePixelPerfect(alphaTolerance);
                                }
                            }
                            draggable = GetFastValue(config, 'draggable', false);
                            dropZone = GetFastValue(config, 'dropZone', false);
                            cursor = GetFastValue(config, 'cursor', false);
                            useHandCursor = GetFastValue(config, 'useHandCursor', false);
                            //  Still no hitArea or callback?
                            if (!hitArea || !hitAreaCallback) {
                                this.setHitAreaFromTexture(gameObjects);
                                customHitArea = false;
                            }
                        } else if (typeof hitArea === 'function' && !hitAreaCallback) {
                            hitAreaCallback = hitArea;
                            hitArea = {};
                        }
                        for(var i = 0; i < gameObjects.length; i++){
                            var gameObject = gameObjects[i];
                            if (pixelPerfect && gameObject.type === 'Container') {
                                console.warn('Cannot pixelPerfect test a Container. Use a custom callback.');
                                continue;
                            }
                            var io = !gameObject.input ? CreateInteractiveObject(gameObject, hitArea, hitAreaCallback) : gameObject.input;
                            io.customHitArea = customHitArea;
                            io.dropZone = dropZone;
                            io.cursor = useHandCursor ? 'pointer' : cursor;
                            gameObject.input = io;
                            if (draggable) this.setDraggable(gameObject);
                            this.queueForInsertion(gameObject);
                        }
                        return this;
                    },
                    /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Circle` shape, using
     * the given coordinates and radius to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaCircle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a circle hit area.
     * @param {number} x - The center of the circle.
     * @param {number} y - The center of the circle.
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Circle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaCircle: function(gameObjects, x, y, radius, callback) {
                        if (callback === undefined) callback = CircleContains;
                        var shape = new Circle(x, y, radius);
                        return this.setHitArea(gameObjects, shape, callback);
                    },
                    /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Ellipse` shape, using
     * the given coordinates and dimensions to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaEllipse
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
     * @param {number} x - The center of the ellipse.
     * @param {number} y - The center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Ellipse.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaEllipse: function(gameObjects, x, y, width, height, callback) {
                        if (callback === undefined) callback = EllipseContains;
                        var shape = new Ellipse(x, y, width, height);
                        return this.setHitArea(gameObjects, shape, callback);
                    },
                    /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Rectangle` shape, using
     * the Game Objects texture frame to define the position and size of the hit area.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaFromTexture
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaFromTexture: function(gameObjects, callback) {
                        if (callback === undefined) callback = RectangleContains;
                        if (!Array.isArray(gameObjects)) gameObjects = [
                            gameObjects
                        ];
                        for(var i = 0; i < gameObjects.length; i++){
                            var gameObject = gameObjects[i];
                            var frame = gameObject.frame;
                            var width = 0;
                            var height = 0;
                            if (gameObject.width) {
                                width = gameObject.width;
                                height = gameObject.height;
                            } else if (frame) {
                                width = frame.realWidth;
                                height = frame.realHeight;
                            }
                            if (gameObject.type === 'Container' && (width === 0 || height === 0)) {
                                console.warn('Container.setInteractive must specify a Shape or call setSize() first');
                                continue;
                            }
                            if (width !== 0 && height !== 0) {
                                gameObject.input = CreateInteractiveObject(gameObject, new Rectangle(0, 0, width, height), callback);
                                this.queueForInsertion(gameObject);
                            }
                        }
                        return this;
                    },
                    /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Rectangle` shape, using
     * the given coordinates and dimensions to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaRectangle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a rectangular hit area.
     * @param {number} x - The top-left of the rectangle.
     * @param {number} y - The top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaRectangle: function(gameObjects, x, y, width, height, callback) {
                        if (callback === undefined) callback = RectangleContains;
                        var shape = new Rectangle(x, y, width, height);
                        return this.setHitArea(gameObjects, shape, callback);
                    },
                    /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Triangle` shape, using
     * the given coordinates to control the position of its points.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaTriangle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a  triangular hit area.
     * @param {number} x1 - The x coordinate of the first point of the triangle.
     * @param {number} y1 - The y coordinate of the first point of the triangle.
     * @param {number} x2 - The x coordinate of the second point of the triangle.
     * @param {number} y2 - The y coordinate of the second point of the triangle.
     * @param {number} x3 - The x coordinate of the third point of the triangle.
     * @param {number} y3 - The y coordinate of the third point of the triangle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Triangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaTriangle: function(gameObjects, x1, y1, x2, y2, x3, y3, callback) {
                        if (callback === undefined) callback = TriangleContains;
                        var shape = new Triangle(x1, y1, x2, y2, x3, y3);
                        return this.setHitArea(gameObjects, shape, callback);
                    },
                    /**
     * Creates an Input Debug Shape for the given Game Object.
     *
     * The Game Object must have _already_ been enabled for input prior to calling this method.
     *
     * This is intended to assist you during development and debugging.
     *
     * Debug Shapes can only be created for Game Objects that are using standard Phaser Geometry for input,
     * including: Circle, Ellipse, Line, Polygon, Rectangle and Triangle.
     *
     * Game Objects that are using their automatic hit areas are using Rectangles by default, so will also work.
     *
     * The Debug Shape is created and added to the display list and is then kept in sync with the Game Object
     * it is connected with. Should you need to modify it yourself, such as to hide it, you can access it via
     * the Game Object property: `GameObject.input.hitAreaDebug`.
     *
     * Calling this method on a Game Object that already has a Debug Shape will first destroy the old shape,
     * before creating a new one. If you wish to remove the Debug Shape entirely, you should call the
     * method `InputPlugin.removeDebug`.
     *
     * Note that the debug shape will only show the outline of the input area. If the input test is using a
     * pixel perfect check, for example, then this is not displayed. If you are using a custom shape, that
     * doesn't extend one of the base Phaser Geometry objects, as your hit area, then this method will not
     * work.
     *
     * @method Phaser.Input.InputPlugin#enableDebug
     * @since 3.19.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to create the input debug shape for.
     * @param {number} [color=0x00ff00] - The outline color of the debug shape.
     *
     * @return {this} This Input Plugin.
     */ enableDebug: function(gameObject, color) {
                        if (color === undefined) color = 0x00ff00;
                        var input = gameObject.input;
                        if (!input || !input.hitArea) return this;
                        var shape = input.hitArea;
                        var shapeType = shape.type;
                        var debug = input.hitAreaDebug;
                        var factory = this.systems.add;
                        var updateList = this.systems.updateList;
                        if (debug) {
                            updateList.remove(debug);
                            debug.destroy();
                            debug = null;
                        }
                        var offsetx = 0;
                        var offsety = 0;
                        switch(shapeType){
                            case GEOM_CONST.CIRCLE:
                                debug = factory.arc(0, 0, shape.radius);
                                offsetx = shape.x - shape.radius;
                                offsety = shape.y - shape.radius;
                                break;
                            case GEOM_CONST.ELLIPSE:
                                debug = factory.ellipse(0, 0, shape.width, shape.height);
                                offsetx = shape.x - shape.width / 2;
                                offsety = shape.y - shape.height / 2;
                                break;
                            case GEOM_CONST.LINE:
                                debug = factory.line(0, 0, shape.x1, shape.y1, shape.x2, shape.y2);
                                break;
                            case GEOM_CONST.POLYGON:
                                debug = factory.polygon(0, 0, shape.points);
                                break;
                            case GEOM_CONST.RECTANGLE:
                                debug = factory.rectangle(0, 0, shape.width, shape.height);
                                offsetx = shape.x;
                                offsety = shape.y;
                                break;
                            case GEOM_CONST.TRIANGLE:
                                debug = factory.triangle(0, 0, shape.x1, shape.y1, shape.x2, shape.y2, shape.x3, shape.y3);
                                break;
                        }
                        if (debug) {
                            debug.isFilled = false;
                            debug.strokeColor = color;
                            debug.preUpdate = function() {
                                debug.setVisible(gameObject.visible);
                                debug.setStrokeStyle(1 / gameObject.scale, debug.strokeColor);
                                debug.setDisplayOrigin(gameObject.displayOriginX, gameObject.displayOriginY);
                                var x = gameObject.x;
                                var y = gameObject.y;
                                var rotation = gameObject.rotation;
                                var scaleX = gameObject.scaleX;
                                var scaleY = gameObject.scaleY;
                                if (gameObject.parentContainer) {
                                    var matrix = gameObject.getWorldTransformMatrix();
                                    x = matrix.tx;
                                    y = matrix.ty;
                                    rotation = matrix.rotation;
                                    scaleX = matrix.scaleX;
                                    scaleY = matrix.scaleY;
                                }
                                debug.setRotation(rotation);
                                debug.setScale(scaleX, scaleY);
                                debug.setPosition(x + offsetx * scaleX, y + offsety * scaleY);
                                debug.setScrollFactor(gameObject.scrollFactorX, gameObject.scrollFactorY);
                                debug.setDepth(gameObject.depth);
                            };
                            updateList.add(debug);
                            input.hitAreaDebug = debug;
                        }
                        return this;
                    },
                    /**
     * Removes an Input Debug Shape from the given Game Object.
     *
     * The shape is destroyed immediately and the `hitAreaDebug` property is set to `null`.
     *
     * @method Phaser.Input.InputPlugin#removeDebug
     * @since 3.19.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to remove the input debug shape from.
     *
     * @return {this} This Input Plugin.
     */ removeDebug: function(gameObject) {
                        var input = gameObject.input;
                        if (input && input.hitAreaDebug) {
                            var debug = input.hitAreaDebug;
                            //  This will remove it from both the display list and update list
                            debug.destroy();
                            input.hitAreaDebug = null;
                        }
                        return this;
                    },
                    /**
     * Sets the Pointers to always poll.
     *
     * When a pointer is polled it runs a hit test to see which Game Objects are currently below it,
     * or being interacted with it, regardless if the Pointer has actually moved or not.
     *
     * You should enable this if you want objects in your game to fire over / out events, and the objects
     * are constantly moving, but the pointer may not have. Polling every frame has additional computation
     * costs, especially if there are a large number of interactive objects in your game.
     *
     * @method Phaser.Input.InputPlugin#setPollAlways
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ setPollAlways: function() {
                        return this.setPollRate(0);
                    },
                    /**
     * Sets the Pointers to only poll when they are moved or updated.
     *
     * When a pointer is polled it runs a hit test to see which Game Objects are currently below it,
     * or being interacted with it.
     *
     * @method Phaser.Input.InputPlugin#setPollOnMove
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ setPollOnMove: function() {
                        return this.setPollRate(-1);
                    },
                    /**
     * Sets the poll rate value. This is the amount of time that should have elapsed before a pointer
     * will be polled again. See the `setPollAlways` and `setPollOnMove` methods.
     *
     * @method Phaser.Input.InputPlugin#setPollRate
     * @since 3.0.0
     *
     * @param {number} value - The amount of time, in ms, that should elapsed before re-polling the pointers.
     *
     * @return {this} This InputPlugin object.
     */ setPollRate: function(value) {
                        this.pollRate = value;
                        this._pollTimer = 0;
                        return this;
                    },
                    /**
     * When set to `true` the global Input Manager will emulate DOM behavior by only emitting events from
     * the top-most Scene in the Scene List. By default, if a Scene receives an input event it will then stop the event
     * from flowing down to any Scenes below it in the Scene list. To disable this behavior call this method with `false`.
     *
     * @method Phaser.Input.InputPlugin#setGlobalTopOnly
     * @since 3.0.0
     *
     * @param {boolean} value - Set to `true` to stop processing input events on the Scene that receives it, or `false` to let the event continue down the Scene list.
     *
     * @return {this} This InputPlugin object.
     */ setGlobalTopOnly: function(value) {
                        this.manager.globalTopOnly = value;
                        return this;
                    },
                    /**
     * When set to `true` this Input Plugin will emulate DOM behavior by only emitting events from
     * the top-most Game Objects in the Display List.
     *
     * If set to `false` it will emit events from all Game Objects below a Pointer, not just the top one.
     *
     * @method Phaser.Input.InputPlugin#setTopOnly
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to only include the top-most Game Object, or `false` to include all Game Objects in a hit test.
     *
     * @return {this} This InputPlugin object.
     */ setTopOnly: function(value) {
                        this.topOnly = value;
                        return this;
                    },
                    /**
     * Given an array of Game Objects and a Pointer, sort the array and return it,
     * so that the objects are in render order with the lowest at the bottom.
     *
     * @method Phaser.Input.InputPlugin#sortGameObjects
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} gameObjects - An array of Game Objects to be sorted.
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against the Game Objects.
     *
     * @return {Phaser.GameObjects.GameObject[]} The sorted array of Game Objects.
     */ sortGameObjects: function(gameObjects, pointer) {
                        if (gameObjects.length < 2 || !pointer.camera) return gameObjects;
                        var list = pointer.camera.renderList;
                        return gameObjects.sort(function(childA, childB) {
                            var indexA = Math.max(list.indexOf(childA), 0);
                            var indexB = Math.max(list.indexOf(childB), 0);
                            return indexB - indexA;
                        });
                    },
                    /**
     * Given an array of Drop Zone Game Objects, sort the array and return it,
     * so that the objects are in depth index order with the lowest at the bottom.
     *
     * @method Phaser.Input.InputPlugin#sortDropZones
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject[]} gameObjects - An array of Game Objects to be sorted.
     *
     * @return {Phaser.GameObjects.GameObject[]} The sorted array of Game Objects.
     */ sortDropZones: function(gameObjects) {
                        if (gameObjects.length < 2) return gameObjects;
                        this.scene.sys.depthSort();
                        return gameObjects.sort(this.sortDropZoneHandler.bind(this));
                    },
                    /**
     * Return the child lowest down the display list (with the smallest index)
     * Will iterate through all parent containers, if present.
     *
     * Prior to version 3.52.0 this method was called `sortHandlerGO`.
     *
     * @method Phaser.Input.InputPlugin#sortDropZoneHandler
     * @private
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object to compare.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object to compare.
     *
     * @return {number} Returns either a negative or positive integer, or zero if they match.
     */ sortDropZoneHandler: function(childA, childB) {
                        if (!childA.parentContainer && !childB.parentContainer) //  Quick bail out when neither child has a container
                        return this.displayList.getIndex(childB) - this.displayList.getIndex(childA);
                        else if (childA.parentContainer === childB.parentContainer) //  Quick bail out when both children have the same container
                        return childB.parentContainer.getIndex(childB) - childA.parentContainer.getIndex(childA);
                        else if (childA.parentContainer === childB) //  Quick bail out when childA is a child of childB
                        return -1;
                        else if (childB.parentContainer === childA) //  Quick bail out when childA is a child of childB
                        return 1;
                        else {
                            //  Container index check
                            var listA = childA.getIndexList();
                            var listB = childB.getIndexList();
                            var len = Math.min(listA.length, listB.length);
                            for(var i = 0; i < len; i++){
                                var indexA = listA[i];
                                var indexB = listB[i];
                                if (indexA === indexB) continue;
                                else //  Non-matching parents, so return
                                return indexB - indexA;
                            }
                            return listB.length - listA.length;
                        }
                        //  Technically this shouldn't happen, but ...
                        // eslint-disable-next-line no-unreachable
                        return 0;
                    },
                    /**
     * This method should be called from within an input event handler, such as `pointerdown`.
     *
     * When called, it stops the Input Manager from allowing _this specific event_ to be processed by any other Scene
     * not yet handled in the scene list.
     *
     * @method Phaser.Input.InputPlugin#stopPropagation
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ stopPropagation: function() {
                        this.manager._tempSkip = true;
                        return this;
                    },
                    /**
     * Adds new Pointer objects to the Input Manager.
     *
     * By default Phaser creates 2 pointer objects: `mousePointer` and `pointer1`.
     *
     * You can create more either by calling this method, or by setting the `input.activePointers` property
     * in the Game Config, up to a maximum of 10 pointers.
     *
     * The first 10 pointers are available via the `InputPlugin.pointerX` properties, once they have been added
     * via this method.
     *
     * @method Phaser.Input.InputPlugin#addPointer
     * @since 3.10.0
     *
     * @param {number} [quantity=1] The number of new Pointers to create. A maximum of 10 is allowed in total.
     *
     * @return {Phaser.Input.Pointer[]} An array containing all of the new Pointer objects that were created.
     */ addPointer: function(quantity) {
                        return this.manager.addPointer(quantity);
                    },
                    /**
     * Tells the Input system to set a custom cursor.
     *
     * This cursor will be the default cursor used when interacting with the game canvas.
     *
     * If an Interactive Object also sets a custom cursor, this is the cursor that is reset after its use.
     *
     * Any valid CSS cursor value is allowed, including paths to image files, i.e.:
     *
     * ```javascript
     * this.input.setDefaultCursor('url(assets/cursors/sword.cur), pointer');
     * ```
     *
     * Please read about the differences between browsers when it comes to the file formats and sizes they support:
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_User_Interface/Using_URL_values_for_the_cursor_property
     *
     * It's up to you to pick a suitable cursor format that works across the range of browsers you need to support.
     *
     * @method Phaser.Input.InputPlugin#setDefaultCursor
     * @since 3.10.0
     *
     * @param {string} cursor - The CSS to be used when setting the default cursor.
     *
     * @return {this} This Input instance.
     */ setDefaultCursor: function(cursor) {
                        this.manager.setDefaultCursor(cursor);
                        return this;
                    },
                    /**
     * The Scene that owns this plugin is transitioning in.
     *
     * @method Phaser.Input.InputPlugin#transitionIn
     * @private
     * @since 3.5.0
     */ transitionIn: function() {
                        this.enabled = this.settings.transitionAllowInput;
                    },
                    /**
     * The Scene that owns this plugin has finished transitioning in.
     *
     * @method Phaser.Input.InputPlugin#transitionComplete
     * @private
     * @since 3.5.0
     */ transitionComplete: function() {
                        if (!this.settings.transitionAllowInput) this.enabled = true;
                    },
                    /**
     * The Scene that owns this plugin is transitioning out.
     *
     * @method Phaser.Input.InputPlugin#transitionOut
     * @private
     * @since 3.5.0
     */ transitionOut: function() {
                        this.enabled = this.settings.transitionAllowInput;
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Input.InputPlugin#shutdown
     * @fires Phaser.Input.Events#SHUTDOWN
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        //  Registered input plugins listen for this
                        this.pluginEvents.emit(Events.SHUTDOWN);
                        this._temp.length = 0;
                        this._list.length = 0;
                        this._draggable.length = 0;
                        this._pendingRemoval.length = 0;
                        this._pendingInsertion.length = 0;
                        this._dragState.length = 0;
                        for(var i = 0; i < 10; i++){
                            this._drag[i] = [];
                            this._over[i] = [];
                        }
                        this.removeAllListeners();
                        var manager = this.manager;
                        manager.canvas.style.cursor = manager.defaultCursor;
                        var eventEmitter = this.systems.events;
                        eventEmitter.off(SceneEvents.TRANSITION_START, this.transitionIn, this);
                        eventEmitter.off(SceneEvents.TRANSITION_OUT, this.transitionOut, this);
                        eventEmitter.off(SceneEvents.TRANSITION_COMPLETE, this.transitionComplete, this);
                        eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                        manager.events.off(Events.GAME_OUT, this.onGameOut, this);
                        manager.events.off(Events.GAME_OVER, this.onGameOver, this);
                        eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Loops through all of the Input Manager Pointer instances and calls `reset` on them.
     *
     * Use this function if you find that input has been stolen from Phaser via a 3rd
     * party component, such as Vue, and you need to tell Phaser to reset the Pointer states.
     *
     * @method Phaser.Input.InputPlugin#resetPointers
     * @since 3.60.0
     */ resetPointers: function() {
                        var pointers = this.manager.pointers;
                        for(var i = 0; i < pointers.length; i++)pointers[i].reset();
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Input.InputPlugin#destroy
     * @fires Phaser.Input.Events#DESTROY
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        //  Registered input plugins listen for this
                        this.pluginEvents.emit(Events.DESTROY);
                        this.pluginEvents.removeAllListeners();
                        this.scene.sys.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.cameras = null;
                        this.manager = null;
                        this.events = null;
                        this.mouse = null;
                    },
                    /**
     * The x coordinates of the ActivePointer based on the first camera in the camera list.
     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
     *
     * @name Phaser.Input.InputPlugin#x
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this.manager.activePointer.x;
                        }
                    },
                    /**
     * The y coordinates of the ActivePointer based on the first camera in the camera list.
     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
     *
     * @name Phaser.Input.InputPlugin#y
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this.manager.activePointer.y;
                        }
                    },
                    /**
     * Are any mouse or touch pointers currently over the game canvas?
     *
     * @name Phaser.Input.InputPlugin#isOver
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isOver: {
                        get: function() {
                            return this.manager.isOver;
                        }
                    },
                    /**
     * The mouse has its own unique Pointer object, which you can reference directly if making a _desktop specific game_.
     * If you are supporting both desktop and touch devices then do not use this property, instead use `activePointer`
     * which will always map to the most recently interacted pointer.
     *
     * @name Phaser.Input.InputPlugin#mousePointer
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ mousePointer: {
                        get: function() {
                            return this.manager.mousePointer;
                        }
                    },
                    /**
     * The current active input Pointer.
     *
     * @name Phaser.Input.InputPlugin#activePointer
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.0.0
     */ activePointer: {
                        get: function() {
                            return this.manager.activePointer;
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer1
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer1: {
                        get: function() {
                            return this.manager.pointers[1];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer2
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer2: {
                        get: function() {
                            return this.manager.pointers[2];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer3
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer3: {
                        get: function() {
                            return this.manager.pointers[3];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer4
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer4: {
                        get: function() {
                            return this.manager.pointers[4];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer5
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer5: {
                        get: function() {
                            return this.manager.pointers[5];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer6
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer6: {
                        get: function() {
                            return this.manager.pointers[6];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer7
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer7: {
                        get: function() {
                            return this.manager.pointers[7];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer8
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer8: {
                        get: function() {
                            return this.manager.pointers[8];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer9
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer9: {
                        get: function() {
                            return this.manager.pointers[9];
                        }
                    },
                    /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer10
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer10: {
                        get: function() {
                            return this.manager.pointers[10];
                        }
                    }
                });
                PluginCache.register('InputPlugin', InputPlugin, 'input');
                module1.exports = InputPlugin;
            /***/ },
            /***/ 89639: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(35154);
                //  Contains the plugins that Phaser uses globally and locally.
                //  These are the source objects, not instantiated.
                var inputPlugins = {};
                /**
 * @namespace Phaser.Input.InputPluginCache
 */ var InputPluginCache = {};
                /**
 * Static method called directly by the Core internal Plugins.
 * Key is a reference used to get the plugin from the plugins object (i.e. InputPlugin)
 * Plugin is the object to instantiate to create the plugin
 * Mapping is what the plugin is injected into the Scene.Systems as (i.e. input)
 *
 * @function Phaser.Input.InputPluginCache.register
 * @static
 * @since 3.10.0
 *
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Input Plugin, this is the property key used.
 * @param {string} settingsKey - The key in the Scene Settings to check to see if this plugin should install or not.
 * @param {string} configKey - The key in the Game Config to check to see if this plugin should install or not.
 */ InputPluginCache.register = function(key, plugin, mapping, settingsKey, configKey) {
                    inputPlugins[key] = {
                        plugin: plugin,
                        mapping: mapping,
                        settingsKey: settingsKey,
                        configKey: configKey
                    };
                };
                /**
 * Returns the input plugin object from the cache based on the given key.
 *
 * @function Phaser.Input.InputPluginCache.getPlugin
 * @static
 * @since 3.10.0
 *
 * @param {string} key - The key of the input plugin to get.
 *
 * @return {Phaser.Types.Input.InputPluginContainer} The input plugin object.
 */ InputPluginCache.getPlugin = function(key) {
                    return inputPlugins[key];
                };
                /**
 * Installs all of the registered Input Plugins into the given target.
 *
 * @function Phaser.Input.InputPluginCache.install
 * @static
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} target - The target InputPlugin to install the plugins into.
 */ InputPluginCache.install = function(target) {
                    var sys = target.scene.sys;
                    var settings = sys.settings.input;
                    var config = sys.game.config;
                    for(var key in inputPlugins){
                        var source = inputPlugins[key].plugin;
                        var mapping = inputPlugins[key].mapping;
                        var settingsKey = inputPlugins[key].settingsKey;
                        var configKey = inputPlugins[key].configKey;
                        if (GetValue(settings, settingsKey, config[configKey])) target[mapping] = new source(target);
                    }
                };
                /**
 * Removes an input plugin based on the given key.
 *
 * @function Phaser.Input.InputPluginCache.remove
 * @static
 * @since 3.10.0
 *
 * @param {string} key - The key of the input plugin to remove.
 */ InputPluginCache.remove = function(key) {
                    if (inputPlugins.hasOwnProperty(key)) delete inputPlugins[key];
                };
                module1.exports = InputPluginCache;
            /***/ },
            /***/ 42515: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Angle = __webpack_require__(31040);
                var Class = __webpack_require__(83419);
                var Distance = __webpack_require__(20339);
                var FuzzyEqual = __webpack_require__(43855);
                var SmoothStepInterpolation = __webpack_require__(47235);
                var Vector2 = __webpack_require__(26099);
                var OS = __webpack_require__(25892);
                /**
 * @classdesc
 * A Pointer object encapsulates both mouse and touch input within Phaser.
 *
 * By default, Phaser will create 2 pointers for your game to use. If you require more, i.e. for a multi-touch
 * game, then use the `InputPlugin.addPointer` method to do so, rather than instantiating this class directly,
 * otherwise it won't be managed by the input system.
 *
 * You can reference the current active pointer via `InputPlugin.activePointer`. You can also use the properties
 * `InputPlugin.pointer1` through to `pointer10`, for each pointer you have enabled in your game.
 *
 * The properties of this object are set by the Input Plugin during processing. This object is then sent in all
 * input related events that the Input Plugin emits, so you can reference properties from it directly in your
 * callbacks.
 *
 * @class Pointer
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} manager - A reference to the Input Manager.
 * @param {number} id - The internal ID of this Pointer.
 */ var Pointer = new Class({
                    initialize: function Pointer(manager, id) {
                        /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Pointer#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = manager;
                        /**
         * The internal ID of this Pointer.
         *
         * @name Phaser.Input.Pointer#id
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.id = id;
                        /**
         * The most recent native DOM Event this Pointer has processed.
         *
         * @name Phaser.Input.Pointer#event
         * @type {(TouchEvent|MouseEvent|WheelEvent)}
         * @since 3.0.0
         */ this.event;
                        /**
         * The DOM element the Pointer was pressed down on, taken from the DOM event.
         * In a default set-up this will be the Canvas that Phaser is rendering to, or the Window element.
         *
         * @name Phaser.Input.Pointer#downElement
         * @type {any}
         * @readonly
         * @since 3.16.0
         */ this.downElement;
                        /**
         * The DOM element the Pointer was released on, taken from the DOM event.
         * In a default set-up this will be the Canvas that Phaser is rendering to, or the Window element.
         *
         * @name Phaser.Input.Pointer#upElement
         * @type {any}
         * @readonly
         * @since 3.16.0
         */ this.upElement;
                        /**
         * The camera the Pointer interacted with during its last update.
         *
         * A Pointer can only ever interact with one camera at once, which will be the top-most camera
         * in the list should multiple cameras be positioned on-top of each other.
         *
         * @name Phaser.Input.Pointer#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = null;
                        /**
         * A read-only property that indicates which button was pressed, or released, on the pointer
         * during the most recent event. It is only set during `up` and `down` events.
         *
         * On Touch devices the value is always 0.
         *
         * Users may change the configuration of buttons on their pointing device so that if an event's button property
         * is zero, it may not have been caused by the button that is physically left–most on the pointing device;
         * however, it should behave as if the left button was clicked in the standard button layout.
         *
         * @name Phaser.Input.Pointer#button
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.18.0
         */ this.button = 0;
                        /**
         * 0: No button or un-initialized
         * 1: Left button
         * 2: Right button
         * 4: Wheel button or middle button
         * 8: 4th button (typically the "Browser Back" button)
         * 16: 5th button (typically the "Browser Forward" button)
         *
         * For a mouse configured for left-handed use, the button actions are reversed.
         * In this case, the values are read from right to left.
         *
         * @name Phaser.Input.Pointer#buttons
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.buttons = 0;
                        /**
         * The position of the Pointer in screen space.
         *
         * @name Phaser.Input.Pointer#position
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.position = new Vector2();
                        /**
         * The previous position of the Pointer in screen space.
         *
         * The old x and y values are stored in here during the InputManager.transformPointer call.
         *
         * Use the properties `velocity`, `angle` and `distance` to create your own gesture recognition.
         *
         * @name Phaser.Input.Pointer#prevPosition
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.11.0
         */ this.prevPosition = new Vector2();
                        /**
         * An internal vector used for calculations of the pointer speed and angle.
         *
         * @name Phaser.Input.Pointer#midPoint
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.16.0
         */ this.midPoint = new Vector2(-1, -1);
                        /**
         * The current velocity of the Pointer, based on its current and previous positions.
         *
         * This value is smoothed out each frame, according to the `motionFactor` property.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * @name Phaser.Input.Pointer#velocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.16.0
         */ this.velocity = new Vector2();
                        /**
         * The current angle the Pointer is moving, in radians, based on its previous and current position.
         *
         * The angle is based on the old position facing to the current position.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * @name Phaser.Input.Pointer#angle
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.angle = 0;
                        /**
         * The distance the Pointer has moved, based on its previous and current position.
         *
         * This value is smoothed out each frame, according to the `motionFactor` property.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * If you need the total distance travelled since the primary buttons was pressed down,
         * then use the `Pointer.getDistance` method.
         *
         * @name Phaser.Input.Pointer#distance
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.distance = 0;
                        /**
         * The smoothing factor to apply to the Pointer position.
         *
         * Due to their nature, pointer positions are inherently noisy. While this is fine for lots of games, if you need cleaner positions
         * then you can set this value to apply an automatic smoothing to the positions as they are recorded.
         *
         * The default value of zero means 'no smoothing'.
         * Set to a small value, such as 0.2, to apply an average level of smoothing between positions. You can do this by changing this
         * value directly, or by setting the `input.smoothFactor` property in the Game Config.
         *
         * Positions are only smoothed when the pointer moves. If the primary button on this Pointer enters an Up or Down state, then the position
         * is always precise, and not smoothed.
         *
         * @name Phaser.Input.Pointer#smoothFactor
         * @type {number}
         * @default 0
         * @since 3.16.0
         */ this.smoothFactor = 0;
                        /**
         * The factor applied to the motion smoothing each frame.
         *
         * This value is passed to the Smooth Step Interpolation that is used to calculate the velocity,
         * angle and distance of the Pointer. It's applied every frame, until the midPoint reaches the current
         * position of the Pointer. 0.2 provides a good average but can be increased if you need a
         * quicker update and are working in a high performance environment. Never set this value to
         * zero.
         *
         * @name Phaser.Input.Pointer#motionFactor
         * @type {number}
         * @default 0.2
         * @since 3.16.0
         */ this.motionFactor = 0.2;
                        /**
         * The x position of this Pointer, translated into the coordinate space of the most recent Camera it interacted with.
         *
         * If you wish to use this value _outside_ of an input event handler then you should update it first by calling
         * the `Pointer.updateWorldPoint` method.
         *
         * @name Phaser.Input.Pointer#worldX
         * @type {number}
         * @default 0
         * @since 3.10.0
         */ this.worldX = 0;
                        /**
         * The y position of this Pointer, translated into the coordinate space of the most recent Camera it interacted with.
         *
         * If you wish to use this value _outside_ of an input event handler then you should update it first by calling
         * the `Pointer.updateWorldPoint` method.
         *
         * @name Phaser.Input.Pointer#worldY
         * @type {number}
         * @default 0
         * @since 3.10.0
         */ this.worldY = 0;
                        /**
         * Time when this Pointer was most recently moved (regardless of the state of its buttons, if any)
         *
         * @name Phaser.Input.Pointer#moveTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.moveTime = 0;
                        /**
         * X coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downX = 0;
                        /**
         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downY = 0;
                        /**
         * The Event timestamp when the first button, or Touch input, was pressed. Used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downTime = 0;
                        /**
         * X coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upX = 0;
                        /**
         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upY = 0;
                        /**
         * The Event timestamp when the final button, or Touch input, was released. Used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upTime = 0;
                        /**
         * Is the primary button down? (usually button 0, the left mouse button)
         *
         * @name Phaser.Input.Pointer#primaryDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.primaryDown = false;
                        /**
         * Is _any_ button on this pointer considered as being down?
         *
         * @name Phaser.Input.Pointer#isDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isDown = false;
                        /**
         * Did the previous input event come from a Touch input (true) or Mouse? (false)
         *
         * @name Phaser.Input.Pointer#wasTouch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.wasTouch = false;
                        /**
         * Did this Pointer get canceled by a touchcancel event?
         *
         * Note: "canceled" is the American-English spelling of "cancelled". Please don't submit PRs correcting it!
         *
         * @name Phaser.Input.Pointer#wasCanceled
         * @type {boolean}
         * @default false
         * @since 3.15.0
         */ this.wasCanceled = false;
                        /**
         * If the mouse is locked, the horizontal relative movement of the Pointer in pixels since last frame.
         *
         * @name Phaser.Input.Pointer#movementX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.movementX = 0;
                        /**
         * If the mouse is locked, the vertical relative movement of the Pointer in pixels since last frame.
         *
         * @name Phaser.Input.Pointer#movementY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.movementY = 0;
                        /**
         * The identifier property of the Pointer as set by the DOM event when this Pointer is started.
         *
         * @name Phaser.Input.Pointer#identifier
         * @type {number}
         * @since 3.10.0
         */ this.identifier = 0;
                        /**
         * The pointerId property of the Pointer as set by the DOM event when this Pointer is started.
         * The browser can and will recycle this value.
         *
         * @name Phaser.Input.Pointer#pointerId
         * @type {number}
         * @since 3.10.0
         */ this.pointerId = null;
                        /**
         * An active Pointer is one that is currently pressed down on the display.
         * A Mouse is always considered as active.
         *
         * @name Phaser.Input.Pointer#active
         * @type {boolean}
         * @since 3.10.0
         */ this.active = id === 0 ? true : false;
                        /**
         * Is this pointer Pointer Locked?
         *
         * Only a mouse pointer can be locked and it only becomes locked when requested via
         * the browsers Pointer Lock API.
         *
         * You can request this by calling the `this.input.mouse.requestPointerLock()` method from
         * a `pointerdown` or `pointerup` event handler.
         *
         * @name Phaser.Input.Pointer#locked
         * @readonly
         * @type {boolean}
         * @since 3.19.0
         */ this.locked = false;
                        /**
         * The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         *
         * @name Phaser.Input.Pointer#deltaX
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaX = 0;
                        /**
         * The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         * This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
         *
         * @name Phaser.Input.Pointer#deltaY
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaY = 0;
                        /**
         * The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         *
         * @name Phaser.Input.Pointer#deltaZ
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaZ = 0;
                    },
                    /**
     * Takes a Camera and updates this Pointer's `worldX` and `worldY` values so they are
     * the result of a translation through the given Camera.
     *
     * Note that the values will be automatically replaced the moment the Pointer is
     * updated by an input event, such as a mouse move, so should be used immediately.
     *
     * @method Phaser.Input.Pointer#updateWorldPoint
     * @since 3.19.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     *
     * @return {this} This Pointer object.
     */ updateWorldPoint: function(camera) {
                        //  Stores the world point inside of tempPoint
                        var temp = camera.getWorldPoint(this.x, this.y);
                        this.worldX = temp.x;
                        this.worldY = temp.y;
                        return this;
                    },
                    /**
     * Takes a Camera and returns a Vector2 containing the translated position of this Pointer
     * within that Camera. This can be used to convert this Pointers position into camera space.
     *
     * @method Phaser.Input.Pointer#positionToCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the translation.
     * @param {(Phaser.Math.Vector2|object)} [output] - A Vector2-like object in which to store the translated position.
     *
     * @return {(Phaser.Math.Vector2|object)} A Vector2 containing the translated coordinates of this Pointer, based on the given camera.
     */ positionToCamera: function(camera, output) {
                        return camera.getWorldPoint(this.x, this.y, output);
                    },
                    /**
     * Calculates the motion of this Pointer, including its velocity and angle of movement.
     * This method is called automatically each frame by the Input Manager.
     *
     * @method Phaser.Input.Pointer#updateMotion
     * @private
     * @since 3.16.0
     */ updateMotion: function() {
                        var cx = this.position.x;
                        var cy = this.position.y;
                        var mx = this.midPoint.x;
                        var my = this.midPoint.y;
                        if (cx === mx && cy === my) //  Nothing to do here
                        return;
                        //  Moving towards our goal ...
                        var vx = SmoothStepInterpolation(this.motionFactor, mx, cx);
                        var vy = SmoothStepInterpolation(this.motionFactor, my, cy);
                        if (FuzzyEqual(vx, cx, 0.1)) vx = cx;
                        if (FuzzyEqual(vy, cy, 0.1)) vy = cy;
                        this.midPoint.set(vx, vy);
                        var dx = cx - vx;
                        var dy = cy - vy;
                        this.velocity.set(dx, dy);
                        this.angle = Angle(vx, vy, cx, cy);
                        this.distance = Math.sqrt(dx * dx + dy * dy);
                    },
                    /**
     * Internal method to handle a Mouse Up Event.
     *
     * @method Phaser.Input.Pointer#up
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ up: function(event) {
                        if ('buttons' in event) this.buttons = event.buttons;
                        this.event = event;
                        this.button = event.button;
                        this.upElement = event.target;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, event.pageX, event.pageY, false);
                        //  0: Main button pressed, usually the left button or the un-initialized state
                        if (event.button === 0) {
                            this.primaryDown = false;
                            this.upX = this.x;
                            this.upY = this.y;
                        }
                        if (this.buttons === 0) {
                            //  No more buttons are still down
                            this.isDown = false;
                            this.upTime = event.timeStamp;
                            this.wasTouch = false;
                        }
                    },
                    /**
     * Internal method to handle a Mouse Down Event.
     *
     * @method Phaser.Input.Pointer#down
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ down: function(event) {
                        if ('buttons' in event) this.buttons = event.buttons;
                        this.event = event;
                        this.button = event.button;
                        this.downElement = event.target;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, event.pageX, event.pageY, false);
                        //  0: Main button pressed, usually the left button or the un-initialized state
                        if (event.button === 0) {
                            this.primaryDown = true;
                            this.downX = this.x;
                            this.downY = this.y;
                        }
                        if (OS.macOS && event.ctrlKey) {
                            //  Override button settings on macOS
                            this.buttons = 2;
                            this.primaryDown = false;
                        }
                        if (!this.isDown) {
                            this.isDown = true;
                            this.downTime = event.timeStamp;
                        }
                        this.wasTouch = false;
                    },
                    /**
     * Internal method to handle a Mouse Move Event.
     *
     * @method Phaser.Input.Pointer#move
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ move: function(event) {
                        if ('buttons' in event) this.buttons = event.buttons;
                        this.event = event;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, event.pageX, event.pageY, true);
                        if (this.locked) {
                            //  Multiple DOM events may occur within one frame, but only one Phaser event will fire
                            this.movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
                            this.movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
                        }
                        this.moveTime = event.timeStamp;
                        this.wasTouch = false;
                    },
                    /**
     * Internal method to handle a Mouse Wheel Event.
     *
     * @method Phaser.Input.Pointer#wheel
     * @private
     * @since 3.18.0
     *
     * @param {WheelEvent} event - The Wheel Event to process.
     */ wheel: function(event) {
                        if ('buttons' in event) this.buttons = event.buttons;
                        this.event = event;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, event.pageX, event.pageY, false);
                        this.deltaX = event.deltaX;
                        this.deltaY = event.deltaY;
                        this.deltaZ = event.deltaZ;
                        this.wasTouch = false;
                    },
                    /**
     * Internal method to handle a Touch Start Event.
     *
     * @method Phaser.Input.Pointer#touchstart
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchstart: function(touch, event) {
                        if (touch['pointerId']) this.pointerId = touch.pointerId;
                        this.identifier = touch.identifier;
                        this.target = touch.target;
                        this.active = true;
                        this.buttons = 1;
                        this.event = event;
                        this.downElement = touch.target;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                        this.primaryDown = true;
                        this.downX = this.x;
                        this.downY = this.y;
                        this.downTime = event.timeStamp;
                        this.isDown = true;
                        this.wasTouch = true;
                        this.wasCanceled = false;
                        this.updateMotion();
                    },
                    /**
     * Internal method to handle a Touch Move Event.
     *
     * @method Phaser.Input.Pointer#touchmove
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchmove: function(touch, event) {
                        this.event = event;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, touch.pageX, touch.pageY, true);
                        this.moveTime = event.timeStamp;
                        this.wasTouch = true;
                        this.updateMotion();
                    },
                    /**
     * Internal method to handle a Touch End Event.
     *
     * @method Phaser.Input.Pointer#touchend
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchend: function(touch, event) {
                        this.buttons = 0;
                        this.event = event;
                        this.upElement = touch.target;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                        this.primaryDown = false;
                        this.upX = this.x;
                        this.upY = this.y;
                        this.upTime = event.timeStamp;
                        this.isDown = false;
                        this.wasTouch = true;
                        this.wasCanceled = false;
                        this.active = false;
                        this.updateMotion();
                    },
                    /**
     * Internal method to handle a Touch Cancel Event.
     *
     * @method Phaser.Input.Pointer#touchcancel
     * @private
     * @since 3.15.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchcancel: function(touch, event) {
                        this.buttons = 0;
                        this.event = event;
                        this.upElement = touch.target;
                        //  Sets the local x/y properties
                        this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                        this.primaryDown = false;
                        this.upX = this.x;
                        this.upY = this.y;
                        this.upTime = event.timeStamp;
                        this.isDown = false;
                        this.wasTouch = true;
                        this.wasCanceled = true;
                        this.active = false;
                    },
                    /**
     * Checks to see if any buttons are being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#noButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if no buttons are being held down.
     */ noButtonDown: function() {
                        return this.buttons === 0;
                    },
                    /**
     * Checks to see if the left button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#leftButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the left button is being held down.
     */ leftButtonDown: function() {
                        return this.buttons & 1 ? true : false;
                    },
                    /**
     * Checks to see if the right button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#rightButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the right button is being held down.
     */ rightButtonDown: function() {
                        return this.buttons & 2 ? true : false;
                    },
                    /**
     * Checks to see if the middle button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#middleButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the middle button is being held down.
     */ middleButtonDown: function() {
                        return this.buttons & 4 ? true : false;
                    },
                    /**
     * Checks to see if the back button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#backButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the back button is being held down.
     */ backButtonDown: function() {
                        return this.buttons & 8 ? true : false;
                    },
                    /**
     * Checks to see if the forward button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#forwardButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the forward button is being held down.
     */ forwardButtonDown: function() {
                        return this.buttons & 16 ? true : false;
                    },
                    /**
     * Checks to see if the release of the left button was the most recent activity on this Pointer.
     *
     * @method Phaser.Input.Pointer#leftButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the release of the left button was the most recent activity on this Pointer.
     */ leftButtonReleased: function() {
                        return this.buttons === 0 ? this.button === 0 && !this.isDown : this.button === 0;
                    },
                    /**
     * Checks to see if the release of the right button was the most recent activity on this Pointer.
     *
     * @method Phaser.Input.Pointer#rightButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the release of the right button was the most recent activity on this Pointer.
     */ rightButtonReleased: function() {
                        return this.buttons === 0 ? this.button === 2 && !this.isDown : this.button === 2;
                    },
                    /**
     * Checks to see if the release of the middle button was the most recent activity on this Pointer.
     *
     * @method Phaser.Input.Pointer#middleButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the release of the middle button was the most recent activity on this Pointer.
     */ middleButtonReleased: function() {
                        return this.buttons === 0 ? this.button === 1 && !this.isDown : this.button === 1;
                    },
                    /**
     * Checks to see if the release of the back button was the most recent activity on this Pointer.
     *
     * @method Phaser.Input.Pointer#backButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the release of the back button was the most recent activity on this Pointer.
     */ backButtonReleased: function() {
                        return this.buttons === 0 ? this.button === 3 && !this.isDown : this.button === 3;
                    },
                    /**
     * Checks to see if the release of the forward button was the most recent activity on this Pointer.
     *
     * @method Phaser.Input.Pointer#forwardButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the release of the forward button was the most recent activity on this Pointer.
     */ forwardButtonReleased: function() {
                        return this.buttons === 0 ? this.button === 4 && !this.isDown : this.button === 4;
                    },
                    /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded distance, based on where
     * the Pointer was when the button was released.
     *
     * If you wish to get the distance being travelled currently, based on the velocity of the Pointer,
     * then see the `Pointer.distance` property.
     *
     * @method Phaser.Input.Pointer#getDistance
     * @since 3.13.0
     *
     * @return {number} The distance the Pointer moved.
     */ getDistance: function() {
                        if (this.isDown) return Distance(this.downX, this.downY, this.x, this.y);
                        else return Distance(this.downX, this.downY, this.upX, this.upY);
                    },
                    /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * horizontal distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded horizontal distance, based on where
     * the Pointer was when the button was released.
     *
     * @method Phaser.Input.Pointer#getDistanceX
     * @since 3.16.0
     *
     * @return {number} The horizontal distance the Pointer moved.
     */ getDistanceX: function() {
                        if (this.isDown) return Math.abs(this.downX - this.x);
                        else return Math.abs(this.downX - this.upX);
                    },
                    /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * vertical distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded vertical distance, based on where
     * the Pointer was when the button was released.
     *
     * @method Phaser.Input.Pointer#getDistanceY
     * @since 3.16.0
     *
     * @return {number} The vertical distance the Pointer moved.
     */ getDistanceY: function() {
                        if (this.isDown) return Math.abs(this.downY - this.y);
                        else return Math.abs(this.downY - this.upY);
                    },
                    /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * duration since the button was pressed down.
     *
     * If no button is held down, it will return the last recorded duration, based on the time
     * the last button on the Pointer was released.
     *
     * @method Phaser.Input.Pointer#getDuration
     * @since 3.16.0
     *
     * @return {number} The duration the Pointer was held down for in milliseconds.
     */ getDuration: function() {
                        if (this.isDown) return this.manager.time - this.downTime;
                        else return this.upTime - this.downTime;
                    },
                    /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * angle between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded angle, based on where
     * the Pointer was when the button was released.
     *
     * The angle is based on the old position facing to the current position.
     *
     * If you wish to get the current angle, based on the velocity of the Pointer, then
     * see the `Pointer.angle` property.
     *
     * @method Phaser.Input.Pointer#getAngle
     * @since 3.16.0
     *
     * @return {number} The angle between the Pointer's coordinates in radians.
     */ getAngle: function() {
                        if (this.isDown) return Angle(this.downX, this.downY, this.x, this.y);
                        else return Angle(this.downX, this.downY, this.upX, this.upY);
                    },
                    /**
     * Takes the previous and current Pointer positions and then generates an array of interpolated values between
     * the two. The array will be populated up to the size of the `steps` argument.
     *
     * ```javaScript
     * var points = pointer.getInterpolatedPosition(4);
     *
     * // points[0] = { x: 0, y: 0 }
     * // points[1] = { x: 2, y: 1 }
     * // points[2] = { x: 3, y: 2 }
     * // points[3] = { x: 6, y: 3 }
     * ```
     *
     * Use this if you need to get smoothed values between the previous and current pointer positions. DOM pointer
     * events can often fire faster than the main browser loop, and this will help you avoid janky movement
     * especially if you have an object following a Pointer.
     *
     * Note that if you provide an output array it will only be populated up to the number of steps provided.
     * It will not clear any previous data that may have existed beyond the range of the steps count.
     *
     * Internally it uses the Smooth Step interpolation calculation.
     *
     * @method Phaser.Input.Pointer#getInterpolatedPosition
     * @since 3.11.0
     *
     * @param {number} [steps=10] - The number of interpolation steps to use.
     * @param {array} [out] - An array to store the results in. If not provided a new one will be created.
     *
     * @return {array} An array of interpolated values.
     */ getInterpolatedPosition: function(steps, out) {
                        if (steps === undefined) steps = 10;
                        if (out === undefined) out = [];
                        var prevX = this.prevPosition.x;
                        var prevY = this.prevPosition.y;
                        var curX = this.position.x;
                        var curY = this.position.y;
                        for(var i = 0; i < steps; i++){
                            var t = 1 / steps * i;
                            out[i] = {
                                x: SmoothStepInterpolation(t, prevX, curX),
                                y: SmoothStepInterpolation(t, prevY, curY)
                            };
                        }
                        return out;
                    },
                    /**
     * Fully reset this Pointer back to its unitialized state.
     *
     * @method Phaser.Input.Pointer#reset
     * @since 3.60.0
     */ reset: function() {
                        this.event = null;
                        this.downElement = null;
                        this.upElement = null;
                        this.button = 0;
                        this.buttons = 0;
                        this.position.set(0, 0);
                        this.prevPosition.set(0, 0);
                        this.midPoint.set(-1, -1);
                        this.velocity.set(0, 0);
                        this.angle = 0;
                        this.distance = 0;
                        this.worldX = 0;
                        this.worldY = 0;
                        this.downX = 0;
                        this.downY = 0;
                        this.upX = 0;
                        this.upY = 0;
                        this.moveTime = 0;
                        this.upTime = 0;
                        this.downTime = 0;
                        this.primaryDown = false;
                        this.isDown = false;
                        this.wasTouch = false;
                        this.wasCanceled = false;
                        this.movementX = 0;
                        this.movementY = 0;
                        this.identifier = 0;
                        this.pointerId = null;
                        this.deltaX = 0;
                        this.deltaY = 0;
                        this.deltaZ = 0;
                        this.active = this.id === 0 ? true : false;
                    },
                    /**
     * Destroys this Pointer instance and resets its external references.
     *
     * @method Phaser.Input.Pointer#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.camera = null;
                        this.manager = null;
                        this.position = null;
                    },
                    /**
     * The x position of this Pointer.
     * The value is in screen space.
     * See `worldX` to get a camera converted position.
     *
     * @name Phaser.Input.Pointer#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this.position.x;
                        },
                        set: function(value) {
                            this.position.x = value;
                        }
                    },
                    /**
     * The y position of this Pointer.
     * The value is in screen space.
     * See `worldY` to get a camera converted position.
     *
     * @name Phaser.Input.Pointer#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this.position.y;
                        },
                        set: function(value) {
                            this.position.y = value;
                        }
                    },
                    /**
     * Time when this Pointer was most recently updated by a DOM Event.
     * This comes directly from the `event.timeStamp` property.
     * If no event has yet taken place, it will return zero.
     *
     * @name Phaser.Input.Pointer#time
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ time: {
                        get: function() {
                            return this.event ? this.event.timeStamp : 0;
                        }
                    }
                });
                module1.exports = Pointer;
            /***/ },
            /***/ 93301: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var INPUT_CONST = {
                    /**
     * The mouse pointer is being held down.
     *
     * @name Phaser.Input.MOUSE_DOWN
     * @type {number}
     * @since 3.10.0
     */ MOUSE_DOWN: 0,
                    /**
     * The mouse pointer is being moved.
     *
     * @name Phaser.Input.MOUSE_MOVE
     * @type {number}
     * @since 3.10.0
     */ MOUSE_MOVE: 1,
                    /**
     * The mouse pointer is released.
     *
     * @name Phaser.Input.MOUSE_UP
     * @type {number}
     * @since 3.10.0
     */ MOUSE_UP: 2,
                    /**
     * A touch pointer has been started.
     *
     * @name Phaser.Input.TOUCH_START
     * @type {number}
     * @since 3.10.0
     */ TOUCH_START: 3,
                    /**
     * A touch pointer has been started.
     *
     * @name Phaser.Input.TOUCH_MOVE
     * @type {number}
     * @since 3.10.0
     */ TOUCH_MOVE: 4,
                    /**
     * A touch pointer has been started.
     *
     * @name Phaser.Input.TOUCH_END
     * @type {number}
     * @since 3.10.0
     */ TOUCH_END: 5,
                    /**
     * The pointer lock has changed.
     *
     * @name Phaser.Input.POINTER_LOCK_CHANGE
     * @type {number}
     * @since 3.10.0
     */ POINTER_LOCK_CHANGE: 6,
                    /**
     * A touch pointer has been been cancelled by the browser.
     *
     * @name Phaser.Input.TOUCH_CANCEL
     * @type {number}
     * @since 3.15.0
     */ TOUCH_CANCEL: 7,
                    /**
     * The mouse wheel changes.
     *
     * @name Phaser.Input.MOUSE_WHEEL
     * @type {number}
     * @since 3.18.0
     */ MOUSE_WHEEL: 8
                };
                module1.exports = INPUT_CONST;
            /***/ },
            /***/ 7179: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Boot Event.
 *
 * This internal event is dispatched by the Input Plugin when it boots, signalling to all of its systems to create themselves.
 *
 * @event Phaser.Input.Events#BOOT
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'boot';
            /***/ },
            /***/ 85375: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Destroy Event.
 *
 * This internal event is dispatched by the Input Plugin when it is destroyed, signalling to all of its systems to destroy themselves.
 *
 * @event Phaser.Input.Events#DESTROY
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'destroy';
            /***/ },
            /***/ 39843: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag End Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer stops dragging a Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('dragend', listener)`.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_END]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_END} event instead.
 *
 * @event Phaser.Input.Events#DRAG_END
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer stopped dragging.
 * @param {boolean} dropped - Whether the Game Object was dropped onto a target.
 */ module1.exports = 'dragend';
            /***/ },
            /***/ 23388: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Enter Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object into a Drag Target.
 *
 * Listen to this event from within a Scene using: `this.input.on('dragenter', listener)`.
 *
 * A Pointer can only drag a single Game Object at once.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_ENTER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_ENTER} event instead.
 *
 * @event Phaser.Input.Events#DRAG_ENTER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved into.
 */ module1.exports = 'dragenter';
            /***/ },
            /***/ 16133: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves while dragging a Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('drag', listener)`.
 *
 * A Pointer can only drag a single Game Object at once.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG} event instead.
 *
 * @event Phaser.Input.Events#DRAG
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = 'drag';
            /***/ },
            /***/ 27829: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Leave Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object out of a Drag Target.
 *
 * Listen to this event from within a Scene using: `this.input.on('dragleave', listener)`.
 *
 * A Pointer can only drag a single Game Object at once.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_LEAVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_LEAVE} event instead.
 *
 * @event Phaser.Input.Events#DRAG_LEAVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has left.
 */ module1.exports = 'dragleave';
            /***/ },
            /***/ 53904: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Over Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object over a Drag Target.
 *
 * When the Game Object first enters the drag target it will emit a `dragenter` event. If it then moves while within
 * the drag target, it will emit this event instead.
 *
 * Listen to this event from within a Scene using: `this.input.on('dragover', listener)`.
 *
 * A Pointer can only drag a single Game Object at once.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_OVER} event instead.
 *
 * @event Phaser.Input.Events#DRAG_OVER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved over.
 */ module1.exports = 'dragover';
            /***/ },
            /***/ 56058: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Start Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer starts to drag any Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('dragstart', listener)`.
 *
 * A Pointer can only drag a single Game Object at once.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_START]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_START} event instead.
 *
 * @event Phaser.Input.Events#DRAG_START
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 */ module1.exports = 'dragstart';
            /***/ },
            /***/ 2642: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drop Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drops a Game Object on a Drag Target.
 *
 * Listen to this event from within a Scene using: `this.input.on('drop', listener)`.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DROP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DROP} event instead.
 *
 * @event Phaser.Input.Events#DROP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer was dragging.
 * @param {Phaser.GameObjects.GameObject} target - The Drag Target the `gameObject` has been dropped on.
 */ module1.exports = 'drop';
            /***/ },
            /***/ 88171: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Down Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down on _any_ interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameobjectdown', listener)`.
 *
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN} event instead.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DOWN
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was pressed down on.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectdown';
            /***/ },
            /***/ 36147: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag End Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer stops dragging it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('dragend', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive](Phaser.GameObjects.GameObject#setInteractive) for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_END
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer stopped dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer stopped dragging the Game Object, in world space.
 * @param {boolean} dropped - Whether the Game Object was dropped onto a target.
 */ module1.exports = 'dragend';
            /***/ },
            /***/ 71692: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Enter Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer drags it into a drag target.
 *
 * Listen to this event from a Game Object using: `gameObject.on('dragenter', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_ENTER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved into.
 */ module1.exports = 'dragenter';
            /***/ },
            /***/ 96149: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer moves while dragging it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('drag', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = 'drag';
            /***/ },
            /***/ 81285: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Leave Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer drags it out of a drag target.
 *
 * Listen to this event from a Game Object using: `gameObject.on('dragleave', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_LEAVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has left.
 */ module1.exports = 'dragleave';
            /***/ },
            /***/ 74048: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Over Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer drags it over a drag target.
 *
 * When the Game Object first enters the drag target it will emit a `dragenter` event. If it then moves while within
 * the drag target, it will emit this event instead.
 *
 * Listen to this event from a Game Object using: `gameObject.on('dragover', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_OVER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved over.
 */ module1.exports = 'dragover';
            /***/ },
            /***/ 21322: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Start Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer starts to drag it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('dragstart', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * There are lots of useful drag related properties that are set within the Game Object when dragging occurs.
 * For example, `gameObject.input.dragStartX`, `dragStartY` and so on.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_START
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = 'dragstart';
            /***/ },
            /***/ 49378: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drop Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer drops it on a Drag Target.
 *
 * Listen to this event from a Game Object using: `gameObject.on('drop', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DROP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The Drag Target the `gameObject` has been dropped on.
 */ module1.exports = 'drop';
            /***/ },
            /***/ 86754: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Move Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is moved across _any_ interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameobjectmove', listener)`.
 *
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE} event instead.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_MOVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was moved on.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectmove';
            /***/ },
            /***/ 86433: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Out Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves out of _any_ interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameobjectout', listener)`.
 *
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT} event instead.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * If the pointer leaves the game canvas itself, it will not trigger an this event. To handle those cases,
 * please listen for the [GAME_OUT]{@linkcode Phaser.Input.Events#event:GAME_OUT} event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_OUT
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer moved out of.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectout';
            /***/ },
            /***/ 60709: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Over Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves over _any_ interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameobjectover', listener)`.
 *
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER} event instead.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_OVER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer moved over.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectover';
            /***/ },
            /***/ 24081: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Down Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer is pressed down on it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('pointerdown', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_DOWN
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerdown';
            /***/ },
            /***/ 11172: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Move Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer is moved while over it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('pointermove', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_MOVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointermove';
            /***/ },
            /***/ 18907: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Out Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer moves out of it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('pointerout', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * If the pointer leaves the game canvas itself, it will not trigger an this event. To handle those cases,
 * please listen for the [GAME_OUT]{@linkcode Phaser.Input.Events#event:GAME_OUT} event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerout';
            /***/ },
            /***/ 95579: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Over Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer moves over it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('pointerover', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerover';
            /***/ },
            /***/ 35368: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Up Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer is released while over it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('pointerup', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_UP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerup';
            /***/ },
            /***/ 26972: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Wheel Event.
 *
 * This event is dispatched by an interactive Game Object if a pointer has its wheel moved while over it.
 *
 * Listen to this event from a Game Object using: `gameObject.on('wheel', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 *
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_WHEEL
 * @type {string}
 * @since 3.18.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'wheel';
            /***/ },
            /***/ 47078: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Up Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released while over _any_ interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameobjectup', listener)`.
 *
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP} event instead.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_UP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was over when released.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectup';
            /***/ },
            /***/ 73802: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Wheel Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer has its wheel moved while over _any_ interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameobjectwheel', listener)`.
 *
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL} event instead.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_WHEEL
 * @type {string}
 * @since 3.18.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was over when the wheel changed.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectwheel';
            /***/ },
            /***/ 56718: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Game Out Event.
 *
 * This event is dispatched by the Input Plugin if the active pointer leaves the game canvas and is now
 * outside of it, elsewhere on the web page.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameout', listener)`.
 *
 * @event Phaser.Input.Events#GAME_OUT
 * @type {string}
 * @since 3.16.1
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {(MouseEvent|TouchEvent)} event - The DOM Event that triggered the canvas out.
 */ module1.exports = 'gameout';
            /***/ },
            /***/ 25936: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Game Over Event.
 *
 * This event is dispatched by the Input Plugin if the active pointer enters the game canvas and is now
 * over of it, having previously been elsewhere on the web page.
 *
 * Listen to this event from within a Scene using: `this.input.on('gameover', listener)`.
 *
 * @event Phaser.Input.Events#GAME_OVER
 * @type {string}
 * @since 3.16.1
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {(MouseEvent|TouchEvent)} event - The DOM Event that triggered the canvas over.
 */ module1.exports = 'gameover';
            /***/ },
            /***/ 27503: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Boot Event.
 *
 * This internal event is dispatched by the Input Manager when it boots.
 *
 * @event Phaser.Input.Events#MANAGER_BOOT
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'boot';
            /***/ },
            /***/ 50852: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Process Event.
 *
 * This internal event is dispatched by the Input Manager when not using the legacy queue system,
 * and it wants the Input Plugins to update themselves.
 *
 * @event Phaser.Input.Events#MANAGER_PROCESS
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'process';
            /***/ },
            /***/ 96438: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Update Event.
 *
 * This internal event is dispatched by the Input Manager as part of its update step.
 *
 * @event Phaser.Input.Events#MANAGER_UPDATE
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'update';
            /***/ },
            /***/ 59152: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Pointer Lock Change Event.
 *
 * This event is dispatched by the Input Manager when it is processing a native Pointer Lock Change DOM Event.
 *
 * @event Phaser.Input.Events#POINTERLOCK_CHANGE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Event} event - The native DOM Event.
 * @param {boolean} locked - The locked state of the Mouse Pointer.
 */ module1.exports = 'pointerlockchange';
            /***/ },
            /***/ 47777: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Down Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down anywhere.
 *
 * Listen to this event from within a Scene using: `this.input.on('pointerdown', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_DOWN
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = 'pointerdown';
            /***/ },
            /***/ 27957: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Down Outside Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down anywhere outside of the game canvas.
 *
 * Listen to this event from within a Scene using: `this.input.on('pointerdownoutside', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_DOWN_OUTSIDE
 * @type {string}
 * @since 3.16.1
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 */ module1.exports = 'pointerdownoutside';
            /***/ },
            /***/ 19444: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Move Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is moved anywhere.
 *
 * Listen to this event from within a Scene using: `this.input.on('pointermove', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_MOVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = 'pointermove';
            /***/ },
            /***/ 54251: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Out Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves out of any interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('pointerout', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * If the pointer leaves the game canvas itself, it will not trigger an this event. To handle those cases,
 * please listen for the [GAME_OUT]{@linkcode Phaser.Input.Events#event:GAME_OUT} event.
 *
 * @event Phaser.Input.Events#POINTER_OUT
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} justOut - An array containing all interactive Game Objects that the pointer moved out of when the event was created.
 */ module1.exports = 'pointerout';
            /***/ },
            /***/ 18667: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Over Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves over any interactive Game Object.
 *
 * Listen to this event from within a Scene using: `this.input.on('pointerover', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_OVER
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} justOver - An array containing all interactive Game Objects that the pointer moved over when the event was created.
 */ module1.exports = 'pointerover';
            /***/ },
            /***/ 27192: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Up Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released anywhere.
 *
 * Listen to this event from within a Scene using: `this.input.on('pointerup', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_UP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = 'pointerup';
            /***/ },
            /***/ 24652: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Up Outside Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released anywhere outside of the game canvas.
 *
 * Listen to this event from within a Scene using: `this.input.on('pointerupoutside', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_UP_OUTSIDE
 * @type {string}
 * @since 3.16.1
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 */ module1.exports = 'pointerupoutside';
            /***/ },
            /***/ 45132: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Wheel Input Event.
 *
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer has its wheel updated.
 *
 * Listen to this event from within a Scene using: `this.input.on('wheel', listener)`.
 *
 * The event hierarchy is as follows:
 *
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 *
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_WHEEL
 * @type {string}
 * @since 3.18.0
 *
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 */ module1.exports = 'wheel';
            /***/ },
            /***/ 44512: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Pre-Update Event.
 *
 * This internal event is dispatched by the Input Plugin at the start of its `preUpdate` method.
 * This hook is designed specifically for input plugins, but can also be listened to from user-land code.
 *
 * @event Phaser.Input.Events#PRE_UPDATE
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'preupdate';
            /***/ },
            /***/ 15757: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Shutdown Event.
 *
 * This internal event is dispatched by the Input Plugin when it shuts down, signalling to all of its systems to shut themselves down.
 *
 * @event Phaser.Input.Events#SHUTDOWN
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'shutdown';
            /***/ },
            /***/ 41637: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Start Event.
 *
 * This internal event is dispatched by the Input Plugin when it has finished setting-up,
 * signalling to all of its internal systems to start.
 *
 * @event Phaser.Input.Events#START
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'start';
            /***/ },
            /***/ 93802: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Update Event.
 *
 * This internal event is dispatched by the Input Plugin at the start of its `update` method.
 * This hook is designed specifically for input plugins, but can also be listened to from user-land code.
 *
 * @event Phaser.Input.Events#UPDATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'update';
            /***/ },
            /***/ 8214: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Events
 */ module1.exports = {
                    BOOT: __webpack_require__(7179),
                    DESTROY: __webpack_require__(85375),
                    DRAG_END: __webpack_require__(39843),
                    DRAG_ENTER: __webpack_require__(23388),
                    DRAG: __webpack_require__(16133),
                    DRAG_LEAVE: __webpack_require__(27829),
                    DRAG_OVER: __webpack_require__(53904),
                    DRAG_START: __webpack_require__(56058),
                    DROP: __webpack_require__(2642),
                    GAME_OUT: __webpack_require__(56718),
                    GAME_OVER: __webpack_require__(25936),
                    GAMEOBJECT_DOWN: __webpack_require__(88171),
                    GAMEOBJECT_DRAG_END: __webpack_require__(36147),
                    GAMEOBJECT_DRAG_ENTER: __webpack_require__(71692),
                    GAMEOBJECT_DRAG: __webpack_require__(96149),
                    GAMEOBJECT_DRAG_LEAVE: __webpack_require__(81285),
                    GAMEOBJECT_DRAG_OVER: __webpack_require__(74048),
                    GAMEOBJECT_DRAG_START: __webpack_require__(21322),
                    GAMEOBJECT_DROP: __webpack_require__(49378),
                    GAMEOBJECT_MOVE: __webpack_require__(86754),
                    GAMEOBJECT_OUT: __webpack_require__(86433),
                    GAMEOBJECT_OVER: __webpack_require__(60709),
                    GAMEOBJECT_POINTER_DOWN: __webpack_require__(24081),
                    GAMEOBJECT_POINTER_MOVE: __webpack_require__(11172),
                    GAMEOBJECT_POINTER_OUT: __webpack_require__(18907),
                    GAMEOBJECT_POINTER_OVER: __webpack_require__(95579),
                    GAMEOBJECT_POINTER_UP: __webpack_require__(35368),
                    GAMEOBJECT_POINTER_WHEEL: __webpack_require__(26972),
                    GAMEOBJECT_UP: __webpack_require__(47078),
                    GAMEOBJECT_WHEEL: __webpack_require__(73802),
                    MANAGER_BOOT: __webpack_require__(27503),
                    MANAGER_PROCESS: __webpack_require__(50852),
                    MANAGER_UPDATE: __webpack_require__(96438),
                    POINTER_DOWN: __webpack_require__(47777),
                    POINTER_DOWN_OUTSIDE: __webpack_require__(27957),
                    POINTER_MOVE: __webpack_require__(19444),
                    POINTER_OUT: __webpack_require__(54251),
                    POINTER_OVER: __webpack_require__(18667),
                    POINTER_UP: __webpack_require__(27192),
                    POINTER_UP_OUTSIDE: __webpack_require__(24652),
                    POINTER_WHEEL: __webpack_require__(45132),
                    POINTERLOCK_CHANGE: __webpack_require__(59152),
                    PRE_UPDATE: __webpack_require__(44512),
                    SHUTDOWN: __webpack_require__(15757),
                    START: __webpack_require__(41637),
                    UPDATE: __webpack_require__(93802)
                };
            /***/ },
            /***/ 97421: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * Contains information about a specific Gamepad Axis.
 * Axis objects are created automatically by the Gamepad as they are needed.
 *
 * @class Axis
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.Gamepad} pad - A reference to the Gamepad that this Axis belongs to.
 * @param {number} index - The index of this Axis.
 */ var Axis = new Class({
                    initialize: function Axis(pad, index) {
                        /**
         * A reference to the Gamepad that this Axis belongs to.
         *
         * @name Phaser.Input.Gamepad.Axis#pad
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @since 3.0.0
         */ this.pad = pad;
                        /**
         * An event emitter to use to emit the axis events.
         *
         * @name Phaser.Input.Gamepad.Axis#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = pad.events;
                        /**
         * The index of this Axis.
         *
         * @name Phaser.Input.Gamepad.Axis#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                        /**
         * The raw axis value, between -1 and 1 with 0 being dead center.
         * Use the method `getValue` to get a normalized value with the threshold applied.
         *
         * @name Phaser.Input.Gamepad.Axis#value
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.value = 0;
                        /**
         * Movement tolerance threshold below which axis values are ignored in `getValue`.
         *
         * @name Phaser.Input.Gamepad.Axis#threshold
         * @type {number}
         * @default 0.1
         * @since 3.0.0
         */ this.threshold = 0.1;
                    },
                    /**
     * Internal update handler for this Axis.
     * Called automatically by the Gamepad as part of its update.
     *
     * @method Phaser.Input.Gamepad.Axis#update
     * @private
     * @since 3.0.0
     *
     * @param {number} value - The value of the axis movement.
     */ update: function(value) {
                        this.value = value;
                    },
                    /**
     * Applies the `threshold` value to the axis and returns it.
     *
     * @method Phaser.Input.Gamepad.Axis#getValue
     * @since 3.0.0
     *
     * @return {number} The axis value, adjusted for the movement threshold.
     */ getValue: function() {
                        return Math.abs(this.value) < this.threshold ? 0 : this.value;
                    },
                    /**
     * Destroys this Axis instance and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Axis#destroy
     * @since 3.10.0
     */ destroy: function() {
                        this.pad = null;
                        this.events = null;
                    }
                });
                module1.exports = Axis;
            /***/ },
            /***/ 28884: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Events = __webpack_require__(92734);
                /**
 * @classdesc
 * Contains information about a specific button on a Gamepad.
 * Button objects are created automatically by the Gamepad as they are needed.
 *
 * @class Button
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.Gamepad} pad - A reference to the Gamepad that this Button belongs to.
 * @param {number} index - The index of this Button.
 */ var Button = new Class({
                    initialize: function Button(pad, index) {
                        /**
         * A reference to the Gamepad that this Button belongs to.
         *
         * @name Phaser.Input.Gamepad.Button#pad
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @since 3.0.0
         */ this.pad = pad;
                        /**
         * An event emitter to use to emit the button events.
         *
         * @name Phaser.Input.Gamepad.Button#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = pad.manager;
                        /**
         * The index of this Button.
         *
         * @name Phaser.Input.Gamepad.Button#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                        /**
         * Between 0 and 1.
         *
         * @name Phaser.Input.Gamepad.Button#value
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.value = 0;
                        /**
         * Can be set for analogue buttons to enable a 'pressure' threshold,
         * before a button is considered as being 'pressed'.
         *
         * @name Phaser.Input.Gamepad.Button#threshold
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.threshold = 1;
                        /**
         * Is the Button being pressed down or not?
         *
         * @name Phaser.Input.Gamepad.Button#pressed
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pressed = false;
                    },
                    /**
     * Internal update handler for this Button.
     * Called automatically by the Gamepad as part of its update.
     *
     * @method Phaser.Input.Gamepad.Button#update
     * @fires Phaser.Input.Gamepad.Events#BUTTON_DOWN
     * @fires Phaser.Input.Gamepad.Events#BUTTON_UP
     * @fires Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_DOWN
     * @fires Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_UP
     * @private
     * @since 3.0.0
     *
     * @param {number} value - The value of the button. Between 0 and 1.
     */ update: function(value) {
                        this.value = value;
                        var pad = this.pad;
                        var index = this.index;
                        if (value >= this.threshold) {
                            if (!this.pressed) {
                                this.pressed = true;
                                this.events.emit(Events.BUTTON_DOWN, pad, this, value);
                                this.pad.emit(Events.GAMEPAD_BUTTON_DOWN, index, value, this);
                            }
                        } else if (this.pressed) {
                            this.pressed = false;
                            this.events.emit(Events.BUTTON_UP, pad, this, value);
                            this.pad.emit(Events.GAMEPAD_BUTTON_UP, index, value, this);
                        }
                    },
                    /**
     * Destroys this Button instance and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Button#destroy
     * @since 3.10.0
     */ destroy: function() {
                        this.pad = null;
                        this.events = null;
                    }
                });
                module1.exports = Button;
            /***/ },
            /***/ 99125: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Axis = __webpack_require__(97421);
                var Button = __webpack_require__(28884);
                var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A single Gamepad.
 *
 * These are created, updated and managed by the Gamepad Plugin.
 *
 * @class Gamepad
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.GamepadPlugin} manager - A reference to the Gamepad Plugin.
 * @param {Phaser.Types.Input.Gamepad.Pad} pad - The Gamepad object, as extracted from GamepadEvent.
 */ var Gamepad = new Class({
                    Extends: EventEmitter,
                    initialize: function Gamepad(manager, pad) {
                        EventEmitter.call(this);
                        /**
         * A reference to the Gamepad Plugin.
         *
         * @name Phaser.Input.Gamepad.Gamepad#manager
         * @type {Phaser.Input.Gamepad.GamepadPlugin}
         * @since 3.0.0
         */ this.manager = manager;
                        /**
         * A reference to the native Gamepad object that is connected to the browser.
         *
         * @name Phaser.Input.Gamepad.Gamepad#pad
         * @type {any}
         * @since 3.10.0
         */ this.pad = pad;
                        /**
         * A string containing some information about the controller.
         *
         * This is not strictly specified, but in Firefox it will contain three pieces of information
         * separated by dashes (-): two 4-digit hexadecimal strings containing the USB vendor and
         * product id of the controller, and the name of the controller as provided by the driver.
         * In Chrome it will contain the name of the controller as provided by the driver,
         * followed by vendor and product 4-digit hexadecimal strings.
         *
         * @name Phaser.Input.Gamepad.Gamepad#id
         * @type {string}
         * @since 3.0.0
         */ this.id = pad.id;
                        /**
         * An integer that is unique for each Gamepad currently connected to the system.
         * This can be used to distinguish multiple controllers.
         * Note that disconnecting a device and then connecting a new device may reuse the previous index.
         *
         * @name Phaser.Input.Gamepad.Gamepad#index
         * @type {number}
         * @since 3.0.0
         */ this.index = pad.index;
                        var buttons = [];
                        for(var i = 0; i < pad.buttons.length; i++)buttons.push(new Button(this, i));
                        /**
         * An array of Gamepad Button objects, corresponding to the different buttons available on the Gamepad.
         *
         * @name Phaser.Input.Gamepad.Gamepad#buttons
         * @type {Phaser.Input.Gamepad.Button[]}
         * @since 3.0.0
         */ this.buttons = buttons;
                        var axes = [];
                        for(i = 0; i < pad.axes.length; i++)axes.push(new Axis(this, i));
                        /**
         * An array of Gamepad Axis objects, corresponding to the different axes available on the Gamepad, if any.
         *
         * @name Phaser.Input.Gamepad.Gamepad#axes
         * @type {Phaser.Input.Gamepad.Axis[]}
         * @since 3.0.0
         */ this.axes = axes;
                        /**
         * The Gamepad's Haptic Actuator (Vibration / Rumble support).
         * This is highly experimental and only set if both present on the device,
         * and exposed by both the hardware and browser.
         *
         * @name Phaser.Input.Gamepad.Gamepad#vibration
         * @type {GamepadHapticActuator}
         * @since 3.10.0
         */ this.vibration = pad.vibrationActuator;
                        // https://w3c.github.io/gamepad/#remapping
                        var _noButton = {
                            value: 0,
                            pressed: false
                        };
                        /**
         * A reference to the Left Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCLeft = buttons[14] ? buttons[14] : _noButton;
                        /**
         * A reference to the Right Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCRight = buttons[15] ? buttons[15] : _noButton;
                        /**
         * A reference to the Top Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCTop = buttons[12] ? buttons[12] : _noButton;
                        /**
         * A reference to the Bottom Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCBottom = buttons[13] ? buttons[13] : _noButton;
                        /**
         * A reference to the Left Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCLeft = buttons[2] ? buttons[2] : _noButton;
                        /**
         * A reference to the Right Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCRight = buttons[1] ? buttons[1] : _noButton;
                        /**
         * A reference to the Top Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCTop = buttons[3] ? buttons[3] : _noButton;
                        /**
         * A reference to the Bottom Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCBottom = buttons[0] ? buttons[0] : _noButton;
                        /**
         * A reference to the Top Left Front Button (L1 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBLeftTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBLeftTop = buttons[4] ? buttons[4] : _noButton;
                        /**
         * A reference to the Bottom Left Front Button (L2 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBLeftBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBLeftBottom = buttons[6] ? buttons[6] : _noButton;
                        /**
         * A reference to the Top Right Front Button (R1 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBRightTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBRightTop = buttons[5] ? buttons[5] : _noButton;
                        /**
         * A reference to the Bottom Right Front Button (R2 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBRightBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBRightBottom = buttons[7] ? buttons[7] : _noButton;
                        var _noAxis = {
                            value: 0
                        };
                        /**
         * A reference to the Horizontal Axis for the Left Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_HAxisLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._HAxisLeft = axes[0] ? axes[0] : _noAxis;
                        /**
         * A reference to the Vertical Axis for the Left Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_VAxisLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._VAxisLeft = axes[1] ? axes[1] : _noAxis;
                        /**
         * A reference to the Horizontal Axis for the Right Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_HAxisRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._HAxisRight = axes[2] ? axes[2] : _noAxis;
                        /**
         * A reference to the Vertical Axis for the Right Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_VAxisRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._VAxisRight = axes[3] ? axes[3] : _noAxis;
                        /**
         * A Vector2 containing the most recent values from the Gamepad's left axis stick.
         * This is updated automatically as part of the Gamepad.update cycle.
         * The H Axis is mapped to the `Vector2.x` property, and the V Axis to the `Vector2.y` property.
         * The values are based on the Axis thresholds.
         * If the Gamepad does not have a left axis stick, the values will always be zero.
         *
         * @name Phaser.Input.Gamepad.Gamepad#leftStick
         * @type {Phaser.Math.Vector2}
         * @since 3.10.0
         */ this.leftStick = new Vector2();
                        /**
         * A Vector2 containing the most recent values from the Gamepad's right axis stick.
         * This is updated automatically as part of the Gamepad.update cycle.
         * The H Axis is mapped to the `Vector2.x` property, and the V Axis to the `Vector2.y` property.
         * The values are based on the Axis thresholds.
         * If the Gamepad does not have a right axis stick, the values will always be zero.
         *
         * @name Phaser.Input.Gamepad.Gamepad#rightStick
         * @type {Phaser.Math.Vector2}
         * @since 3.10.0
         */ this.rightStick = new Vector2();
                        /**
         * When was this Gamepad created? Used to avoid duplicate event spamming in the update loop.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_created
         * @type {number}
         * @private
         * @since 3.50.0
         */ this._created = performance.now();
                    },
                    /**
     * Gets the total number of axis this Gamepad claims to support.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getAxisTotal
     * @since 3.10.0
     *
     * @return {number} The total number of axes this Gamepad claims to support.
     */ getAxisTotal: function() {
                        return this.axes.length;
                    },
                    /**
     * Gets the value of an axis based on the given index.
     * The index must be valid within the range of axes supported by this Gamepad.
     * The return value will be a float between 0 and 1.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getAxisValue
     * @since 3.10.0
     *
     * @param {number} index - The index of the axes to get the value for.
     *
     * @return {number} The value of the axis, between 0 and 1.
     */ getAxisValue: function(index) {
                        return this.axes[index].getValue();
                    },
                    /**
     * Sets the threshold value of all axis on this Gamepad.
     * The value is a float between 0 and 1 and is the amount below which the axis is considered as not having been moved.
     *
     * @method Phaser.Input.Gamepad.Gamepad#setAxisThreshold
     * @since 3.10.0
     *
     * @param {number} value - A value between 0 and 1.
     */ setAxisThreshold: function(value) {
                        for(var i = 0; i < this.axes.length; i++)this.axes[i].threshold = value;
                    },
                    /**
     * Gets the total number of buttons this Gamepad claims to have.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getButtonTotal
     * @since 3.10.0
     *
     * @return {number} The total number of buttons this Gamepad claims to have.
     */ getButtonTotal: function() {
                        return this.buttons.length;
                    },
                    /**
     * Gets the value of a button based on the given index.
     * The index must be valid within the range of buttons supported by this Gamepad.
     *
     * The return value will be either 0 or 1 for an analogue button, or a float between 0 and 1
     * for a pressure-sensitive digital button, such as the shoulder buttons on a Dual Shock.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getButtonValue
     * @since 3.10.0
     *
     * @param {number} index - The index of the button to get the value for.
     *
     * @return {number} The value of the button, between 0 and 1.
     */ getButtonValue: function(index) {
                        return this.buttons[index].value;
                    },
                    /**
     * Returns if the button is pressed down or not.
     * The index must be valid within the range of buttons supported by this Gamepad.
     *
     * @method Phaser.Input.Gamepad.Gamepad#isButtonDown
     * @since 3.10.0
     *
     * @param {number} index - The index of the button to get the value for.
     *
     * @return {boolean} `true` if the button is considered as being pressed down, otherwise `false`.
     */ isButtonDown: function(index) {
                        return this.buttons[index].pressed;
                    },
                    /**
     * Internal update handler for this Gamepad.
     * Called automatically by the Gamepad Manager as part of its update.
     *
     * @method Phaser.Input.Gamepad.Gamepad#update
     * @private
     * @since 3.0.0
     */ update: function(pad) {
                        if (pad.timestamp < this._created) return;
                        var i;
                        //  Sync the button values
                        var localButtons = this.buttons;
                        var gamepadButtons = pad.buttons;
                        var len = localButtons.length;
                        for(i = 0; i < len; i++)localButtons[i].update(gamepadButtons[i].value);
                        //  Sync the axis values
                        var localAxes = this.axes;
                        var gamepadAxes = pad.axes;
                        len = localAxes.length;
                        for(i = 0; i < len; i++)localAxes[i].update(gamepadAxes[i]);
                        if (len >= 2) {
                            this.leftStick.set(localAxes[0].getValue(), localAxes[1].getValue());
                            if (len >= 4) this.rightStick.set(localAxes[2].getValue(), localAxes[3].getValue());
                        }
                    },
                    /**
     * Destroys this Gamepad instance, its buttons and axes, and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Gamepad#destroy
     * @since 3.10.0
     */ destroy: function() {
                        this.removeAllListeners();
                        this.manager = null;
                        this.pad = null;
                        var i;
                        for(i = 0; i < this.buttons.length; i++)this.buttons[i].destroy();
                        for(i = 0; i < this.axes.length; i++)this.axes[i].destroy();
                        this.buttons = [];
                        this.axes = [];
                    },
                    /**
     * Is this Gamepad currently connected or not?
     *
     * @name Phaser.Input.Gamepad.Gamepad#connected
     * @type {boolean}
     * @default true
     * @since 3.0.0
     */ connected: {
                        get: function() {
                            return this.pad.connected;
                        }
                    },
                    /**
     * A timestamp containing the most recent time this Gamepad was updated.
     *
     * @name Phaser.Input.Gamepad.Gamepad#timestamp
     * @type {number}
     * @since 3.0.0
     */ timestamp: {
                        get: function() {
                            return this.pad.timestamp;
                        }
                    },
                    /**
     * Is the Gamepad's Left button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad left button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#left
     * @type {boolean}
     * @since 3.10.0
     */ left: {
                        get: function() {
                            return this._LCLeft.pressed;
                        }
                    },
                    /**
     * Is the Gamepad's Right button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad right button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#right
     * @type {boolean}
     * @since 3.10.0
     */ right: {
                        get: function() {
                            return this._LCRight.pressed;
                        }
                    },
                    /**
     * Is the Gamepad's Up button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad up button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#up
     * @type {boolean}
     * @since 3.10.0
     */ up: {
                        get: function() {
                            return this._LCTop.pressed;
                        }
                    },
                    /**
     * Is the Gamepad's Down button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad down button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#down
     * @type {boolean}
     * @since 3.10.0
     */ down: {
                        get: function() {
                            return this._LCBottom.pressed;
                        }
                    },
                    /**
     * Is the Gamepad's bottom button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the X button.
     * On an XBox controller it's the A button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#A
     * @type {boolean}
     * @since 3.10.0
     */ A: {
                        get: function() {
                            return this._RCBottom.pressed;
                        }
                    },
                    /**
     * Is the Gamepad's top button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Triangle button.
     * On an XBox controller it's the Y button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#Y
     * @type {boolean}
     * @since 3.10.0
     */ Y: {
                        get: function() {
                            return this._RCTop.pressed;
                        }
                    },
                    /**
     * Is the Gamepad's left button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Square button.
     * On an XBox controller it's the X button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#X
     * @type {boolean}
     * @since 3.10.0
     */ X: {
                        get: function() {
                            return this._RCLeft.pressed;
                        }
                    },
                    /**
     * Is the Gamepad's right button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Circle button.
     * On an XBox controller it's the B button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#B
     * @type {boolean}
     * @since 3.10.0
     */ B: {
                        get: function() {
                            return this._RCRight.pressed;
                        }
                    },
                    /**
     * Returns the value of the Gamepad's top left shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the L1 button.
     * On an XBox controller it's the LB button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#L1
     * @type {number}
     * @since 3.10.0
     */ L1: {
                        get: function() {
                            return this._FBLeftTop.value;
                        }
                    },
                    /**
     * Returns the value of the Gamepad's bottom left shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the L2 button.
     * On an XBox controller it's the LT button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#L2
     * @type {number}
     * @since 3.10.0
     */ L2: {
                        get: function() {
                            return this._FBLeftBottom.value;
                        }
                    },
                    /**
     * Returns the value of the Gamepad's top right shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the R1 button.
     * On an XBox controller it's the RB button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#R1
     * @type {number}
     * @since 3.10.0
     */ R1: {
                        get: function() {
                            return this._FBRightTop.value;
                        }
                    },
                    /**
     * Returns the value of the Gamepad's bottom right shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the R2 button.
     * On an XBox controller it's the RT button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#R2
     * @type {number}
     * @since 3.10.0
     */ R2: {
                        get: function() {
                            return this._FBRightBottom.value;
                        }
                    }
                });
                module1.exports = Gamepad;
            /***/ },
            /***/ 56654: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(92734);
                var Gamepad = __webpack_require__(99125);
                var GetValue = __webpack_require__(35154);
                var InputPluginCache = __webpack_require__(89639);
                var InputEvents = __webpack_require__(8214);
                /**
 * @classdesc
 * The Gamepad Plugin is an input plugin that belongs to the Scene-owned Input system.
 *
 * Its role is to listen for native DOM Gamepad Events and then process them.
 *
 * You do not need to create this class directly, the Input system will create an instance of it automatically.
 *
 * You can access it from within a Scene using `this.input.gamepad`.
 *
 * To listen for a gamepad being connected:
 *
 * ```javascript
 * this.input.gamepad.once('connected', function (pad) {
 *     //   'pad' is a reference to the gamepad that was just connected
 * });
 * ```
 *
 * Note that the browser may require you to press a button on a gamepad before it will allow you to access it,
 * this is for security reasons. However, it may also trust the page already, in which case you won't get the
 * 'connected' event and instead should check `GamepadPlugin.total` to see if it thinks there are any gamepads
 * already connected.
 *
 * Once you have received the connected event, or polled the gamepads and found them enabled, you can access
 * them via the built-in properties `GamepadPlugin.pad1` to `pad4`, for up to 4 game pads. With a reference
 * to the gamepads you can poll its buttons and axis sticks. See the properties and methods available on
 * the `Gamepad` class for more details.
 *
 * As of September 2020 Chrome, and likely other browsers, will soon start to require that games requesting
 * access to the Gamepad API are running under SSL. They will actively block API access if they are not.
 *
 * For more information about Gamepad support in browsers see the following resources:
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API
 * https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API/Using_the_Gamepad_API
 * https://www.smashingmagazine.com/2015/11/gamepad-api-in-web-games/
 * http://html5gamepad.com/
 *
 * @class GamepadPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} sceneInputPlugin - A reference to the Scene Input Plugin that the KeyboardPlugin belongs to.
 */ var GamepadPlugin = new Class({
                    Extends: EventEmitter,
                    initialize: function GamepadPlugin(sceneInputPlugin) {
                        EventEmitter.call(this);
                        /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.10.0
         */ this.scene = sceneInputPlugin.scene;
                        /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.10.0
         */ this.settings = this.scene.sys.settings;
                        /**
         * A reference to the Scene Input Plugin that created this Keyboard Plugin.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#sceneInputPlugin
         * @type {Phaser.Input.InputPlugin}
         * @since 3.10.0
         */ this.sceneInputPlugin = sceneInputPlugin;
                        /**
         * A boolean that controls if the Gamepad Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.enabled = true;
                        /**
         * The Gamepad Event target, as defined in the Game Config.
         * Typically the browser window, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#target
         * @type {any}
         * @since 3.10.0
         */ this.target;
                        /**
         * An array of the connected Gamepads.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#gamepads
         * @type {Phaser.Input.Gamepad.Gamepad[]}
         * @default []
         * @since 3.10.0
         */ this.gamepads = [];
                        /**
         * An internal event queue.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#queue
         * @type {GamepadEvent[]}
         * @private
         * @since 3.10.0
         */ this.queue = [];
                        /**
         * Internal event handler.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#onGamepadHandler
         * @type {function}
         * @private
         * @since 3.10.0
         */ this.onGamepadHandler;
                        /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad1
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad1;
                        /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad2
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad2;
                        /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad3
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad3;
                        /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad4
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad4;
                        sceneInputPlugin.pluginEvents.once(InputEvents.BOOT, this.boot, this);
                        sceneInputPlugin.pluginEvents.on(InputEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#boot
     * @private
     * @since 3.10.0
     */ boot: function() {
                        var game = this.scene.sys.game;
                        var settings = this.settings.input;
                        var config = game.config;
                        this.enabled = GetValue(settings, 'gamepad', config.inputGamepad) && game.device.input.gamepads;
                        this.target = GetValue(settings, 'gamepad.target', config.inputGamepadEventTarget);
                        this.sceneInputPlugin.pluginEvents.once(InputEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#start
     * @private
     * @since 3.10.0
     */ start: function() {
                        if (this.enabled) {
                            this.startListeners();
                            this.refreshPads();
                        }
                        this.sceneInputPlugin.pluginEvents.once(InputEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                        return this.enabled && this.scene.sys.isActive();
                    },
                    /**
     * Starts the Gamepad Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#startListeners
     * @private
     * @since 3.10.0
     */ startListeners: function() {
                        var _this = this;
                        var target = this.target;
                        var handler = function(event) {
                            if (event.defaultPrevented || !_this.isActive()) // Do nothing if event already handled
                            return;
                            _this.refreshPads();
                            _this.queue.push(event);
                        };
                        this.onGamepadHandler = handler;
                        target.addEventListener('gamepadconnected', handler, false);
                        target.addEventListener('gamepaddisconnected', handler, false);
                        //  FF also supports gamepadbuttondown, gamepadbuttonup and gamepadaxismove but
                        //  nothing else does, and we can get those values via the gamepads anyway, so we will
                        //  until more browsers support this
                        //  Finally, listen for an update event from the Input Plugin
                        this.sceneInputPlugin.pluginEvents.on(InputEvents.UPDATE, this.update, this);
                    },
                    /**
     * Stops the Gamepad Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#stopListeners
     * @private
     * @since 3.10.0
     */ stopListeners: function() {
                        this.target.removeEventListener('gamepadconnected', this.onGamepadHandler);
                        this.target.removeEventListener('gamepaddisconnected', this.onGamepadHandler);
                        this.sceneInputPlugin.pluginEvents.off(InputEvents.UPDATE, this.update);
                        for(var i = 0; i < this.gamepads.length; i++)this.gamepads[i].removeAllListeners();
                    },
                    /**
     * Disconnects all current Gamepads.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#disconnectAll
     * @since 3.10.0
     */ disconnectAll: function() {
                        for(var i = 0; i < this.gamepads.length; i++)this.gamepads[i].pad.connected = false;
                    },
                    /**
     * Refreshes the list of connected Gamepads.
     *
     * This is called automatically when a gamepad is connected or disconnected,
     * and during the update loop.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#refreshPads
     * @private
     * @since 3.10.0
     */ refreshPads: function() {
                        var connectedPads = navigator.getGamepads();
                        if (!connectedPads) this.disconnectAll();
                        else {
                            var currentPads = this.gamepads;
                            for(var i = 0; i < connectedPads.length; i++){
                                var livePad = connectedPads[i];
                                //  Because sometimes they're null (yes, really)
                                if (!livePad) continue;
                                var id = livePad.id;
                                var index = livePad.index;
                                var currentPad = currentPads[index];
                                if (!currentPad) {
                                    //  A new Gamepad, not currently stored locally
                                    var newPad = new Gamepad(this, livePad);
                                    currentPads[index] = newPad;
                                    if (!this._pad1) this._pad1 = newPad;
                                    else if (!this._pad2) this._pad2 = newPad;
                                    else if (!this._pad3) this._pad3 = newPad;
                                    else if (!this._pad4) this._pad4 = newPad;
                                } else if (currentPad.id !== id) {
                                    //  A new Gamepad with a different vendor string, but it has got the same index as an old one
                                    currentPad.destroy();
                                    currentPads[index] = new Gamepad(this, livePad);
                                } else //  If neither of these, it's a pad we've already got, so update it
                                currentPad.update(livePad);
                            }
                        }
                    },
                    /**
     * Returns an array of all currently connected Gamepads.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#getAll
     * @since 3.10.0
     *
     * @return {Phaser.Input.Gamepad.Gamepad[]} An array of all currently connected Gamepads.
     */ getAll: function() {
                        var out = [];
                        var pads = this.gamepads;
                        for(var i = 0; i < pads.length; i++)if (pads[i]) out.push(pads[i]);
                        return out;
                    },
                    /**
     * Looks-up a single Gamepad based on the given index value.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#getPad
     * @since 3.10.0
     *
     * @param {number} index - The index of the Gamepad to get.
     *
     * @return {Phaser.Input.Gamepad.Gamepad} The Gamepad matching the given index, or undefined if none were found.
     */ getPad: function(index) {
                        var pads = this.gamepads;
                        for(var i = 0; i < pads.length; i++){
                            if (pads[i] && pads[i].index === index) return pads[i];
                        }
                    },
                    /**
     * The internal update loop. Refreshes all connected gamepads and processes their events.
     *
     * Called automatically by the Input Manager, invoked from the Game step.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#update
     * @private
     * @fires Phaser.Input.Gamepad.Events#CONNECTED
     * @fires Phaser.Input.Gamepad.Events#DISCONNECTED
     * @since 3.10.0
     */ update: function() {
                        if (!this.enabled) return;
                        this.refreshPads();
                        var len = this.queue.length;
                        if (len === 0) return;
                        var queue = this.queue.splice(0, len);
                        //  Process the event queue, dispatching all of the events that have stored up
                        for(var i = 0; i < len; i++){
                            var event = queue[i];
                            var pad = this.getPad(event.gamepad.index);
                            if (event.type === 'gamepadconnected') this.emit(Events.CONNECTED, pad, event);
                            else if (event.type === 'gamepaddisconnected') this.emit(Events.DISCONNECTED, pad, event);
                        }
                    },
                    /**
     * Shuts the Gamepad Plugin down.
     * All this does is remove any listeners bound to it.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#shutdown
     * @private
     * @since 3.10.0
     */ shutdown: function() {
                        this.stopListeners();
                        this.removeAllListeners();
                    },
                    /**
     * Destroys this Gamepad Plugin, disconnecting all Gamepads and releasing internal references.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#destroy
     * @private
     * @since 3.10.0
     */ destroy: function() {
                        this.shutdown();
                        for(var i = 0; i < this.gamepads.length; i++)if (this.gamepads[i]) this.gamepads[i].destroy();
                        this.gamepads = [];
                        this.scene = null;
                        this.settings = null;
                        this.sceneInputPlugin = null;
                        this.target = null;
                    },
                    /**
     * The total number of connected game pads.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#total
     * @type {number}
     * @since 3.10.0
     */ total: {
                        get: function() {
                            return this.gamepads.length;
                        }
                    },
                    /**
     * A reference to the first connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad1
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad1: {
                        get: function() {
                            return this._pad1;
                        }
                    },
                    /**
     * A reference to the second connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad2
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad2: {
                        get: function() {
                            return this._pad2;
                        }
                    },
                    /**
     * A reference to the third connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad3
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad3: {
                        get: function() {
                            return this._pad3;
                        }
                    },
                    /**
     * A reference to the fourth connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad4
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad4: {
                        get: function() {
                            return this._pad4;
                        }
                    }
                });
                /**
 * An instance of the Gamepad Plugin class, if enabled via the `input.gamepad` Scene or Game Config property.
 * Use this to create access Gamepads connected to the browser and respond to gamepad buttons.
 *
 * @name Phaser.Input.InputPlugin#gamepad
 * @type {?Phaser.Input.Gamepad.GamepadPlugin}
 * @since 3.10.0
 */ InputPluginCache.register('GamepadPlugin', GamepadPlugin, 'gamepad', 'gamepad', 'inputGamepad');
                module1.exports = GamepadPlugin;
            /***/ },
            /***/ 89651: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tatar SNES USB Controller Gamepad Configuration.
 * USB Gamepad  (STANDARD GAMEPAD Vendor: 0079 Product: 0011)
 *
 * @name Phaser.Input.Gamepad.Configs.SNES_USB
 * @namespace
 * @since 3.0.0
 */ module1.exports = {
                    /**
     * D-Pad up
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.UP
     * @const
     * @type {number}
     * @since 3.0.0
     */ UP: 12,
                    /**
     * D-Pad down
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.DOWN
     * @const
     * @type {number}
     * @since 3.0.0
     */ DOWN: 13,
                    /**
     * D-Pad left
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.LEFT
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT: 14,
                    /**
     * D-Pad right
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.RIGHT
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 15,
                    /**
     * Select button
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.SELECT
     * @const
     * @type {number}
     * @since 3.0.0
     */ SELECT: 8,
                    /**
     * Start button
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.START
     * @const
     * @type {number}
     * @since 3.0.0
     */ START: 9,
                    /**
     * B Button (Bottom)
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.B
     * @const
     * @type {number}
     * @since 3.0.0
     */ B: 0,
                    /**
     * A Button (Right)
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.A
     * @const
     * @type {number}
     * @since 3.0.0
     */ A: 1,
                    /**
     * Y Button (Left)
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.Y
     * @const
     * @type {number}
     * @since 3.0.0
     */ Y: 2,
                    /**
     * X Button (Top)
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.X
     * @const
     * @type {number}
     * @since 3.0.0
     */ X: 3,
                    /**
     * Left bumper
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.LEFT_SHOULDER
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT_SHOULDER: 4,
                    /**
     * Right bumper
     *
     * @name Phaser.Input.Gamepad.Configs.SNES_USB.RIGHT_SHOULDER
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT_SHOULDER: 5
                };
            /***/ },
            /***/ 65294: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * PlayStation DualShock 4 Gamepad Configuration.
 * Sony PlayStation DualShock 4 (v2) wireless controller
 *
 * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4
 * @namespace
 * @since 3.0.0
 */ module1.exports = {
                    /**
     * D-Pad up
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.UP
     * @const
     * @type {number}
     * @since 3.0.0
     */ UP: 12,
                    /**
     * D-Pad down
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.DOWN
     * @const
     * @type {number}
     * @since 3.0.0
     */ DOWN: 13,
                    /**
     * D-Pad left
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.LEFT
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT: 14,
                    /**
     * D-Pad up
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.RIGHT
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 15,
                    /**
     * Share button
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.SHARE
     * @const
     * @type {number}
     * @since 3.0.0
     */ SHARE: 8,
                    /**
     * Options button
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.OPTIONS
     * @const
     * @type {number}
     * @since 3.0.0
     */ OPTIONS: 9,
                    /**
     * PlayStation logo button
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.PS
     * @const
     * @type {number}
     * @since 3.0.0
     */ PS: 16,
                    /**
     * Touchpad click
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.TOUCHBAR
     * @const
     * @type {number}
     * @since 3.0.0
     */ TOUCHBAR: 17,
                    /**
     * Cross button (Bottom)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.X
     * @const
     * @type {number}
     * @since 3.0.0
     */ X: 0,
                    /**
     * Circle button (Right)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.CIRCLE
     * @const
     * @type {number}
     * @since 3.0.0
     */ CIRCLE: 1,
                    /**
     * Square button (Left)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.SQUARE
     * @const
     * @type {number}
     * @since 3.0.0
     */ SQUARE: 2,
                    /**
     * Triangle button (Top)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.TRIANGLE
     * @const
     * @type {number}
     * @since 3.0.0
     */ TRIANGLE: 3,
                    /**
     * Left bumper (L1)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.L1
     * @const
     * @type {number}
     * @since 3.0.0
     */ L1: 4,
                    /**
     * Right bumper (R1)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.R1
     * @const
     * @type {number}
     * @since 3.0.0
     */ R1: 5,
                    /**
     * Left trigger (L2)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.L2
     * @const
     * @type {number}
     * @since 3.0.0
     */ L2: 6,
                    /**
     * Right trigger (R2)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.R2
     * @const
     * @type {number}
     * @since 3.0.0
     */ R2: 7,
                    /**
     * Left stick click (L3)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.L3
     * @const
     * @type {number}
     * @since 3.0.0
     */ L3: 10,
                    /**
     * Right stick click (R3)
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.R3
     * @const
     * @type {number}
     * @since 3.0.0
     */ R3: 11,
                    /**
     * Left stick horizontal
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.LEFT_STICK_H
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT_STICK_H: 0,
                    /**
     * Left stick vertical
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.LEFT_STICK_V
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT_STICK_V: 1,
                    /**
     * Right stick horizontal
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.RIGHT_STICK_H
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT_STICK_H: 2,
                    /**
     * Right stick vertical
     *
     * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4.RIGHT_STICK_V
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT_STICK_V: 3
                };
            /***/ },
            /***/ 90089: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * XBox 360 Gamepad Configuration.
 *
 * @name Phaser.Input.Gamepad.Configs.XBOX_360
 * @namespace
 * @since 3.0.0
 */ module1.exports = {
                    /**
     * D-Pad up
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.UP
     * @const
     * @type {number}
     * @since 3.0.0
     */ UP: 12,
                    /**
     * D-Pad down
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.DOWN
     * @const
     * @type {number}
     * @since 3.0.0
     */ DOWN: 13,
                    /**
     * D-Pad left
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.LEFT
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT: 14,
                    /**
     * D-Pad right
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.RIGHT
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 15,
                    /**
     * XBox menu button
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.MENU
     * @const
     * @type {number}
     * @since 3.0.0
     */ MENU: 16,
                    /**
     * A button (Bottom)
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.A
     * @const
     * @type {number}
     * @since 3.0.0
     */ A: 0,
                    /**
     * B button (Right)
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.B
     * @const
     * @type {number}
     * @since 3.0.0
     */ B: 1,
                    /**
     * X button (Left)
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.X
     * @const
     * @type {number}
     * @since 3.0.0
     */ X: 2,
                    /**
     * Y button (Top)
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.Y
     * @const
     * @type {number}
     * @since 3.0.0
     */ Y: 3,
                    /**
     * Left Bumper
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.LB
     * @const
     * @type {number}
     * @since 3.0.0
     */ LB: 4,
                    /**
     * Right Bumper
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.RB
     * @const
     * @type {number}
     * @since 3.0.0
     */ RB: 5,
                    /**
     * Left Trigger
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.LT
     * @const
     * @type {number}
     * @since 3.0.0
     */ LT: 6,
                    /**
     * Right Trigger
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.RT
     * @const
     * @type {number}
     * @since 3.0.0
     */ RT: 7,
                    /**
     * Back / Change View button
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.BACK
     * @const
     * @type {number}
     * @since 3.0.0
     */ BACK: 8,
                    /**
     * Start button
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.START
     * @const
     * @type {number}
     * @since 3.0.0
     */ START: 9,
                    /**
     * Left Stick press
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.LS
     * @const
     * @type {number}
     * @since 3.0.0
     */ LS: 10,
                    /**
     * Right stick press
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.RS
     * @const
     * @type {number}
     * @since 3.0.0
     */ RS: 11,
                    /**
     * Left Stick horizontal
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.LEFT_STICK_H
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT_STICK_H: 0,
                    /**
     * Left Stick vertical
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.LEFT_STICK_V
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT_STICK_V: 1,
                    /**
     * Right Stick horizontal
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.RIGHT_STICK_H
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT_STICK_H: 2,
                    /**
     * Right Stick vertical
     *
     * @name Phaser.Input.Gamepad.Configs.XBOX_360.RIGHT_STICK_V
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT_STICK_V: 3
                };
            /***/ },
            /***/ 64894: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad.Configs
 */ module1.exports = {
                    DUALSHOCK_4: __webpack_require__(65294),
                    SNES_USB: __webpack_require__(89651),
                    XBOX_360: __webpack_require__(90089)
                };
            /***/ },
            /***/ 46008: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Down Event.
 *
 * This event is dispatched by the Gamepad Plugin when a button has been pressed on any active Gamepad.
 *
 * Listen to this event from within a Scene using: `this.input.gamepad.on('down', listener)`.
 *
 * You can also listen for a DOWN event from a Gamepad instance. See the [GAMEPAD_BUTTON_DOWN]{@linkcode Phaser.Input.Gamepad.Events#event:GAMEPAD_BUTTON_DOWN} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#BUTTON_DOWN
 * @type {string}
 * @since 3.10.0
 *
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad on which the button was pressed.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was pressed.
 * @param {number} value - The value of the button at the time it was pressed. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 */ module1.exports = 'down';
            /***/ },
            /***/ 7629: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Up Event.
 *
 * This event is dispatched by the Gamepad Plugin when a button has been released on any active Gamepad.
 *
 * Listen to this event from within a Scene using: `this.input.gamepad.on('up', listener)`.
 *
 * You can also listen for an UP event from a Gamepad instance. See the [GAMEPAD_BUTTON_UP]{@linkcode Phaser.Input.Gamepad.Events#event:GAMEPAD_BUTTON_UP} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#BUTTON_UP
 * @type {string}
 * @since 3.10.0
 *
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad on which the button was released.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was released.
 * @param {number} value - The value of the button at the time it was released. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 */ module1.exports = 'up';
            /***/ },
            /***/ 42206: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Connected Event.
 *
 * This event is dispatched by the Gamepad Plugin when a Gamepad has been connected.
 *
 * Listen to this event from within a Scene using: `this.input.gamepad.once('connected', listener)`.
 *
 * Note that the browser may require you to press a button on a gamepad before it will allow you to access it,
 * this is for security reasons. However, it may also trust the page already, in which case you won't get the
 * 'connected' event and instead should check `GamepadPlugin.total` to see if it thinks there are any gamepads
 * already connected.
 *
 * @event Phaser.Input.Gamepad.Events#CONNECTED
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad which was connected.
 * @param {Event} event - The native DOM Event that triggered the connection.
 */ module1.exports = 'connected';
            /***/ },
            /***/ 86544: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Disconnected Event.
 *
 * This event is dispatched by the Gamepad Plugin when a Gamepad has been disconnected.
 *
 * Listen to this event from within a Scene using: `this.input.gamepad.once('disconnected', listener)`.
 *
 * @event Phaser.Input.Gamepad.Events#DISCONNECTED
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad which was disconnected.
 * @param {Event} event - The native DOM Event that triggered the disconnection.
 */ module1.exports = 'disconnected';
            /***/ },
            /***/ 94784: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Down Event.
 *
 * This event is dispatched by a Gamepad instance when a button has been pressed on it.
 *
 * Listen to this event from a Gamepad instance. Once way to get this is from the `pad1`, `pad2`, etc properties on the Gamepad Plugin:
 * `this.input.gamepad.pad1.on('down', listener)`.
 *
 * Note that you will not receive any Gamepad button events until the browser considers the Gamepad as being 'connected'.
 *
 * You can also listen for a DOWN event from the Gamepad Plugin. See the [BUTTON_DOWN]{@linkcode Phaser.Input.Gamepad.Events#event:BUTTON_DOWN} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_DOWN
 * @type {string}
 * @since 3.10.0
 *
 * @param {number} index - The index of the button that was pressed.
 * @param {number} value - The value of the button at the time it was pressed. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was pressed.
 */ module1.exports = 'down';
            /***/ },
            /***/ 14325: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Up Event.
 *
 * This event is dispatched by a Gamepad instance when a button has been released on it.
 *
 * Listen to this event from a Gamepad instance. Once way to get this is from the `pad1`, `pad2`, etc properties on the Gamepad Plugin:
 * `this.input.gamepad.pad1.on('up', listener)`.
 *
 * Note that you will not receive any Gamepad button events until the browser considers the Gamepad as being 'connected'.
 *
 * You can also listen for an UP event from the Gamepad Plugin. See the [BUTTON_UP]{@linkcode Phaser.Input.Gamepad.Events#event:BUTTON_UP} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_UP
 * @type {string}
 * @since 3.10.0
 *
 * @param {number} index - The index of the button that was released.
 * @param {number} value - The value of the button at the time it was released. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was released.
 */ module1.exports = 'up';
            /***/ },
            /***/ 92734: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad.Events
 */ module1.exports = {
                    BUTTON_DOWN: __webpack_require__(46008),
                    BUTTON_UP: __webpack_require__(7629),
                    CONNECTED: __webpack_require__(42206),
                    DISCONNECTED: __webpack_require__(86544),
                    GAMEPAD_BUTTON_DOWN: __webpack_require__(94784),
                    GAMEPAD_BUTTON_UP: __webpack_require__(14325)
                };
            /***/ },
            /***/ 48646: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad
 */ module1.exports = {
                    Axis: __webpack_require__(97421),
                    Button: __webpack_require__(28884),
                    Events: __webpack_require__(92734),
                    Gamepad: __webpack_require__(99125),
                    GamepadPlugin: __webpack_require__(56654),
                    Configs: __webpack_require__(64894)
                };
            /***/ },
            /***/ 14350: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(93301);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Input
 */ var Input = {
                    CreatePixelPerfectHandler: __webpack_require__(84409),
                    CreateInteractiveObject: __webpack_require__(74457),
                    Events: __webpack_require__(8214),
                    Gamepad: __webpack_require__(48646),
                    InputManager: __webpack_require__(7003),
                    InputPlugin: __webpack_require__(48205),
                    InputPluginCache: __webpack_require__(89639),
                    Keyboard: __webpack_require__(51442),
                    Mouse: __webpack_require__(87078),
                    Pointer: __webpack_require__(42515),
                    Touch: __webpack_require__(95618)
                };
                //   Merge in the consts
                Input = Extend(false, Input, CONST);
                module1.exports = Input;
            /***/ },
            /***/ 78970: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(72905);
                var Class = __webpack_require__(83419);
                var GameEvents = __webpack_require__(8443);
                var InputEvents = __webpack_require__(8214);
                var KeyCodes = __webpack_require__(46032);
                var NOOP = __webpack_require__(29747);
                /**
 * @classdesc
 * The Keyboard Manager is a helper class that belongs to the global Input Manager.
 *
 * Its role is to listen for native DOM Keyboard Events and then store them for further processing by the Keyboard Plugin.
 *
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically if keyboard
 * input has been enabled in the Game Config.
 *
 * @class KeyboardManager
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var KeyboardManager = new Class({
                    initialize: function KeyboardManager(inputManager) {
                        /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.16.0
         */ this.manager = inputManager;
                        /**
         * An internal event queue.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#queue
         * @type {KeyboardEvent[]}
         * @private
         * @since 3.16.0
         */ this.queue = [];
                        /**
         * A flag that controls if the non-modified keys, matching those stored in the `captures` array,
         * have `preventDefault` called on them or not.
         *
         * A non-modified key is one that doesn't have a modifier key held down with it. The modifier keys are
         * shift, control, alt and the meta key (Command on a Mac, the Windows Key on Windows).
         * Therefore, if the user presses shift + r, it won't prevent this combination, because of the modifier.
         * However, if the user presses just the r key on its own, it will have its event prevented.
         *
         * If you wish to stop capturing the keys, for example switching out to a DOM based element, then
         * you can toggle this property at run-time.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#preventDefault
         * @type {boolean}
         * @since 3.16.0
         */ this.preventDefault = true;
                        /**
         * An array of Key Code values that will automatically have `preventDefault` called on them,
         * as long as the `KeyboardManager.preventDefault` boolean is set to `true`.
         *
         * By default the array is empty.
         *
         * The key must be non-modified when pressed in order to be captured.
         *
         * A non-modified key is one that doesn't have a modifier key held down with it. The modifier keys are
         * shift, control, alt and the meta key (Command on a Mac, the Windows Key on Windows).
         * Therefore, if the user presses shift + r, it won't prevent this combination, because of the modifier.
         * However, if the user presses just the r key on its own, it will have its event prevented.
         *
         * If you wish to stop capturing the keys, for example switching out to a DOM based element, then
         * you can toggle the `KeyboardManager.preventDefault` boolean at run-time.
         *
         * If you need more specific control, you can create Key objects and set the flag on each of those instead.
         *
         * This array can be populated via the Game Config by setting the `input.keyboard.capture` array, or you
         * can call the `addCapture` method. See also `removeCapture` and `clearCaptures`.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#captures
         * @type {number[]}
         * @since 3.16.0
         */ this.captures = [];
                        /**
         * A boolean that controls if the Keyboard Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.enabled = false;
                        /**
         * The Keyboard Event target, as defined in the Game Config.
         * Typically the window in which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#target
         * @type {any}
         * @since 3.16.0
         */ this.target;
                        /**
         * The Key Down Event handler.
         * This function is sent the native DOM KeyEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#onKeyDown
         * @type {function}
         * @since 3.16.00
         */ this.onKeyDown = NOOP;
                        /**
         * The Key Up Event handler.
         * This function is sent the native DOM KeyEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#onKeyUp
         * @type {function}
         * @since 3.16.00
         */ this.onKeyUp = NOOP;
                        inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                    },
                    /**
     * The Keyboard Manager boot process.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#boot
     * @private
     * @since 3.16.0
     */ boot: function() {
                        var config = this.manager.config;
                        this.enabled = config.inputKeyboard;
                        this.target = config.inputKeyboardEventTarget;
                        this.addCapture(config.inputKeyboardCapture);
                        if (!this.target && window) this.target = window;
                        if (this.enabled && this.target) this.startListeners();
                        this.manager.game.events.on(GameEvents.POST_STEP, this.postUpdate, this);
                    },
                    /**
     * Starts the Keyboard Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#startListeners
     * @since 3.16.0
     */ startListeners: function() {
                        var _this = this;
                        this.onKeyDown = function(event) {
                            if (event.defaultPrevented || !_this.enabled || !_this.manager) // Do nothing if event already handled
                            return;
                            _this.queue.push(event);
                            _this.manager.events.emit(InputEvents.MANAGER_PROCESS);
                            var modified = event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
                            if (_this.preventDefault && !modified && _this.captures.indexOf(event.keyCode) > -1) event.preventDefault();
                        };
                        this.onKeyUp = function(event) {
                            if (event.defaultPrevented || !_this.enabled || !_this.manager) // Do nothing if event already handled
                            return;
                            _this.queue.push(event);
                            _this.manager.events.emit(InputEvents.MANAGER_PROCESS);
                            var modified = event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
                            if (_this.preventDefault && !modified && _this.captures.indexOf(event.keyCode) > -1) event.preventDefault();
                        };
                        var target = this.target;
                        if (target) {
                            target.addEventListener('keydown', this.onKeyDown, false);
                            target.addEventListener('keyup', this.onKeyUp, false);
                            this.enabled = true;
                        }
                    },
                    /**
     * Stops the Key Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#stopListeners
     * @since 3.16.0
     */ stopListeners: function() {
                        var target = this.target;
                        target.removeEventListener('keydown', this.onKeyDown, false);
                        target.removeEventListener('keyup', this.onKeyUp, false);
                        this.enabled = false;
                    },
                    /**
     * Clears the event queue.
     * Called automatically by the Input Manager.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#postUpdate
     * @private
     * @since 3.16.0
     */ postUpdate: function() {
                        this.queue = [];
                    },
                    /**
     * By default when a key is pressed Phaser will not stop the event from propagating up to the browser.
     * There are some keys this can be annoying for, like the arrow keys or space bar, which make the browser window scroll.
     *
     * This `addCapture` method enables consuming keyboard event for specific keys so it doesn't bubble up to the the browser
     * and cause the default browser behavior.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to say prevent
     * the SPACE BAR from triggering a page scroll, then it will prevent it for any Scene in your game, not just the calling one.
     *
     * You can pass in a single key code value, or an array of key codes, or a string:
     *
     * ```javascript
     * this.input.keyboard.addCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.addCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or a string:
     *
     * ```javascript
     * this.input.keyboard.addCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * If there are active captures after calling this method, the `preventDefault` property is set to `true`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#addCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to enable capture for, preventing them reaching the browser.
     */ addCapture: function(keycode) {
                        if (typeof keycode === 'string') keycode = keycode.split(',');
                        if (!Array.isArray(keycode)) keycode = [
                            keycode
                        ];
                        var captures = this.captures;
                        for(var i = 0; i < keycode.length; i++){
                            var code = keycode[i];
                            if (typeof code === 'string') code = KeyCodes[code.trim().toUpperCase()];
                            if (captures.indexOf(code) === -1) captures.push(code);
                        }
                        this.preventDefault = captures.length > 0;
                    },
                    /**
     * Removes an existing key capture.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to remove
     * the capture of a key, then it will remove it for any Scene in your game, not just the calling one.
     *
     * You can pass in a single key code value, or an array of key codes, or a string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.removeCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or a string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * If there are no captures left after calling this method, the `preventDefault` property is set to `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#removeCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to disable capture for, allowing them reaching the browser again.
     */ removeCapture: function(keycode) {
                        if (typeof keycode === 'string') keycode = keycode.split(',');
                        if (!Array.isArray(keycode)) keycode = [
                            keycode
                        ];
                        var captures = this.captures;
                        for(var i = 0; i < keycode.length; i++){
                            var code = keycode[i];
                            if (typeof code === 'string') code = KeyCodes[code.toUpperCase()];
                            ArrayRemove(captures, code);
                        }
                        this.preventDefault = captures.length > 0;
                    },
                    /**
     * Removes all keyboard captures and sets the `preventDefault` property to `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#clearCaptures
     * @since 3.16.0
     */ clearCaptures: function() {
                        this.captures = [];
                        this.preventDefault = false;
                    },
                    /**
     * Destroys this Keyboard Manager instance.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#destroy
     * @since 3.16.0
     */ destroy: function() {
                        this.stopListeners();
                        this.clearCaptures();
                        this.queue = [];
                        this.manager.game.events.off(GameEvents.POST_RENDER, this.postUpdate, this);
                        this.target = null;
                        this.enabled = false;
                        this.manager = null;
                    }
                });
                module1.exports = KeyboardManager;
            /***/ },
            /***/ 28846: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(95922);
                var GameEvents = __webpack_require__(8443);
                var GetValue = __webpack_require__(35154);
                var InputEvents = __webpack_require__(8214);
                var InputPluginCache = __webpack_require__(89639);
                var Key = __webpack_require__(30472);
                var KeyCodes = __webpack_require__(46032);
                var KeyCombo = __webpack_require__(87960);
                var KeyMap = __webpack_require__(74600);
                var SceneEvents = __webpack_require__(44594);
                var SnapFloor = __webpack_require__(56583);
                /**
 * @classdesc
 * The Keyboard Plugin is an input plugin that belongs to the Scene-owned Input system.
 *
 * Its role is to listen for native DOM Keyboard Events and then process them.
 *
 * You do not need to create this class directly, the Input system will create an instance of it automatically.
 *
 * You can access it from within a Scene using `this.input.keyboard`. For example, you can do:
 *
 * ```javascript
 * this.input.keyboard.on('keydown', callback, context);
 * ```
 *
 * Or, to listen for a specific key:
 *
 * ```javascript
 * this.input.keyboard.on('keydown-A', callback, context);
 * ```
 *
 * You can also create Key objects, which you can then poll in your game loop:
 *
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 * ```
 *
 * If you have multiple parallel Scenes, each trying to get keyboard input, be sure to disable capture on them to stop them from
 * stealing input from another Scene in the list. You can do this with `this.input.keyboard.enabled = false` within the
 * Scene to stop all input, or `this.input.keyboard.preventDefault = false` to stop a Scene halting input on another Scene.
 *
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * See http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/ for more details
 * and use the site https://w3c.github.io/uievents/tools/key-event-viewer.html to test your n-key support in browser.
 *
 * Also please be aware that certain browser extensions can disable or override Phaser keyboard handling.
 * For example the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * And there are others. So, please check your extensions before opening Phaser issues about keys that don't work.
 *
 * @class KeyboardPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} sceneInputPlugin - A reference to the Scene Input Plugin that the KeyboardPlugin belongs to.
 */ var KeyboardPlugin = new Class({
                    Extends: EventEmitter,
                    initialize: function KeyboardPlugin(sceneInputPlugin) {
                        EventEmitter.call(this);
                        /**
         * A reference to the core game, so we can listen for visibility events.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#game
         * @type {Phaser.Game}
         * @since 3.16.0
         */ this.game = sceneInputPlugin.systems.game;
                        /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.10.0
         */ this.scene = sceneInputPlugin.scene;
                        /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.10.0
         */ this.settings = this.scene.sys.settings;
                        /**
         * A reference to the Scene Input Plugin that created this Keyboard Plugin.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#sceneInputPlugin
         * @type {Phaser.Input.InputPlugin}
         * @since 3.10.0
         */ this.sceneInputPlugin = sceneInputPlugin;
                        /**
         * A reference to the global Keyboard Manager.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#manager
         * @type {Phaser.Input.Keyboard.KeyboardManager}
         * @since 3.16.0
         */ this.manager = sceneInputPlugin.manager.keyboard;
                        /**
         * A boolean that controls if this Keyboard Plugin is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.enabled = true;
                        /**
         * An array of Key objects to process.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#keys
         * @type {Phaser.Input.Keyboard.Key[]}
         * @since 3.10.0
         */ this.keys = [];
                        /**
         * An array of KeyCombo objects to process.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#combos
         * @type {Phaser.Input.Keyboard.KeyCombo[]}
         * @since 3.10.0
         */ this.combos = [];
                        /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevCode
         * @type {string}
         * @private
         * @since 3.50.0
         */ this.prevCode = null;
                        /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevTime
         * @type {number}
         * @private
         * @since 3.50.0
         */ this.prevTime = 0;
                        /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevType
         * @type {string}
         * @private
         * @since 3.50.1
         */ this.prevType = null;
                        sceneInputPlugin.pluginEvents.once(InputEvents.BOOT, this.boot, this);
                        sceneInputPlugin.pluginEvents.on(InputEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#boot
     * @private
     * @since 3.10.0
     */ boot: function() {
                        var settings = this.settings.input;
                        this.enabled = GetValue(settings, 'keyboard', true);
                        var captures = GetValue(settings, 'keyboard.capture', null);
                        if (captures) this.addCaptures(captures);
                        this.sceneInputPlugin.pluginEvents.once(InputEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#start
     * @private
     * @since 3.10.0
     */ start: function() {
                        this.sceneInputPlugin.manager.events.on(InputEvents.MANAGER_PROCESS, this.update, this);
                        this.sceneInputPlugin.pluginEvents.once(InputEvents.SHUTDOWN, this.shutdown, this);
                        this.game.events.on(GameEvents.BLUR, this.resetKeys, this);
                        this.scene.sys.events.on(SceneEvents.PAUSE, this.resetKeys, this);
                        this.scene.sys.events.on(SceneEvents.SLEEP, this.resetKeys, this);
                    },
                    /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                        return this.enabled && this.scene.sys.canInput();
                    },
                    /**
     * By default when a key is pressed Phaser will not stop the event from propagating up to the browser.
     * There are some keys this can be annoying for, like the arrow keys or space bar, which make the browser window scroll.
     *
     * This `addCapture` method enables consuming keyboard events for specific keys, so they don't bubble up the browser
     * and cause the default behaviors.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to say prevent
     * the SPACE BAR from triggering a page scroll, then it will prevent it for any Scene in your game, not just the calling one.
     *
     * You can pass a single key code value:
     *
     * ```javascript
     * this.input.keyboard.addCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.addCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or, a comma-delimited string:
     *
     * ```javascript
     * this.input.keyboard.addCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to enable event capture for.
     *
     * @return {this} This KeyboardPlugin object.
     */ addCapture: function(keycode) {
                        this.manager.addCapture(keycode);
                        return this;
                    },
                    /**
     * Removes an existing key capture.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to remove
     * the capture of a key, then it will remove it for any Scene in your game, not just the calling one.
     *
     * You can pass a single key code value:
     *
     * ```javascript
     * this.input.keyboard.removeCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.removeCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or, a comma-delimited string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to disable event capture for.
     *
     * @return {this} This KeyboardPlugin object.
     */ removeCapture: function(keycode) {
                        this.manager.removeCapture(keycode);
                        return this;
                    },
                    /**
     * Returns an array that contains all of the keyboard captures currently enabled.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#getCaptures
     * @since 3.16.0
     *
     * @return {number[]} An array of all the currently capturing key codes.
     */ getCaptures: function() {
                        return this.manager.captures;
                    },
                    /**
     * Allows Phaser to prevent any key captures you may have defined from bubbling up the browser.
     * You can use this to re-enable event capturing if you had paused it via `disableGlobalCapture`.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#enableGlobalCapture
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ enableGlobalCapture: function() {
                        this.manager.preventDefault = true;
                        return this;
                    },
                    /**
     * Disables Phaser from preventing any key captures you may have defined, without actually removing them.
     * You can use this to temporarily disable event capturing if, for example, you swap to a DOM element.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#disableGlobalCapture
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ disableGlobalCapture: function() {
                        this.manager.preventDefault = false;
                        return this;
                    },
                    /**
     * Removes all keyboard captures.
     *
     * Note that this is a global change. It will clear all event captures across your game, not just for this specific Scene.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#clearCaptures
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ clearCaptures: function() {
                        this.manager.clearCaptures();
                        return this;
                    },
                    /**
     * Creates and returns an object containing 4 hotkeys for Up, Down, Left and Right, and also Space Bar and shift.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#createCursorKeys
     * @since 3.10.0
     *
     * @return {Phaser.Types.Input.Keyboard.CursorKeys} An object containing the properties: `up`, `down`, `left`, `right`, `space` and `shift`.
     */ createCursorKeys: function() {
                        return this.addKeys({
                            up: KeyCodes.UP,
                            down: KeyCodes.DOWN,
                            left: KeyCodes.LEFT,
                            right: KeyCodes.RIGHT,
                            space: KeyCodes.SPACE,
                            shift: KeyCodes.SHIFT
                        });
                    },
                    /**
     * A practical way to create an object containing user selected hotkeys.
     *
     * For example:
     *
     * ```javascript
     * this.input.keyboard.addKeys({ 'up': Phaser.Input.Keyboard.KeyCodes.W, 'down': Phaser.Input.Keyboard.KeyCodes.S });
     * ```
     *
     * would return an object containing the properties (`up` and `down`) mapped to W and S {@link Phaser.Input.Keyboard.Key} objects.
     *
     * You can also pass in a comma-separated string:
     *
     * ```javascript
     * this.input.keyboard.addKeys('W,S,A,D');
     * ```
     *
     * Which will return an object with the properties W, S, A and D mapped to the relevant Key objects.
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addKeys
     * @since 3.10.0
     *
     * @param {(object|string)} keys - An object containing Key Codes, or a comma-separated string.
     * @param {boolean} [enableCapture=true] - Automatically call `preventDefault` on the native DOM browser event for the key codes being added.
     * @param {boolean} [emitOnRepeat=false] - Controls if the Key will continuously emit a 'down' event while being held down (true), or emit the event just once (false, the default).
     *
     * @return {object} An object containing Key objects mapped to the input properties.
     */ addKeys: function(keys, enableCapture, emitOnRepeat) {
                        if (enableCapture === undefined) enableCapture = true;
                        if (emitOnRepeat === undefined) emitOnRepeat = false;
                        var output = {};
                        if (typeof keys === 'string') {
                            keys = keys.split(',');
                            for(var i = 0; i < keys.length; i++){
                                var currentKey = keys[i].trim();
                                if (currentKey) output[currentKey] = this.addKey(currentKey, enableCapture, emitOnRepeat);
                            }
                        } else for(var key in keys)output[key] = this.addKey(keys[key], enableCapture, emitOnRepeat);
                        return output;
                    },
                    /**
     * Adds a Key object to this Keyboard Plugin.
     *
     * The given argument can be either an existing Key object, a string, such as `A` or `SPACE`, or a key code value.
     *
     * If a Key object is given, and one already exists matching the same key code, the existing one is replaced with the new one.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addKey
     * @since 3.10.0
     *
     * @param {(Phaser.Input.Keyboard.Key|string|number)} key - Either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     * @param {boolean} [enableCapture=true] - Automatically call `preventDefault` on the native DOM browser event for the key codes being added.
     * @param {boolean} [emitOnRepeat=false] - Controls if the Key will continuously emit a 'down' event while being held down (true), or emit the event just once (false, the default).
     *
     * @return {Phaser.Input.Keyboard.Key} The newly created Key object, or a reference to it if it already existed in the keys array.
     */ addKey: function(key, enableCapture, emitOnRepeat) {
                        if (enableCapture === undefined) enableCapture = true;
                        if (emitOnRepeat === undefined) emitOnRepeat = false;
                        var keys = this.keys;
                        if (key instanceof Key) {
                            var idx = keys.indexOf(key);
                            if (idx > -1) keys[idx] = key;
                            else keys[key.keyCode] = key;
                            if (enableCapture) this.addCapture(key.keyCode);
                            key.setEmitOnRepeat(emitOnRepeat);
                            return key;
                        }
                        if (typeof key === 'string') key = KeyCodes[key.toUpperCase()];
                        if (!keys[key]) {
                            keys[key] = new Key(this, key);
                            if (enableCapture) this.addCapture(key);
                            keys[key].setEmitOnRepeat(emitOnRepeat);
                        }
                        return keys[key];
                    },
                    /**
     * Removes a Key object from this Keyboard Plugin.
     *
     * The given argument can be either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeKey
     * @since 3.10.0
     *
     * @param {(Phaser.Input.Keyboard.Key|string|number)} key - Either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     * @param {boolean} [destroy=false] - Call `Key.destroy` on the removed Key object?
     * @param {boolean} [removeCapture=false] - Remove this Key from being captured? Only applies if set to capture when created.
     *
     * @return {this} This KeyboardPlugin object.
     */ removeKey: function(key, destroy, removeCapture) {
                        if (destroy === undefined) destroy = false;
                        if (removeCapture === undefined) removeCapture = false;
                        var keys = this.keys;
                        var ref;
                        if (key instanceof Key) {
                            var idx = keys.indexOf(key);
                            if (idx > -1) {
                                ref = this.keys[idx];
                                this.keys[idx] = undefined;
                            }
                        } else if (typeof key === 'string') key = KeyCodes[key.toUpperCase()];
                        if (keys[key]) {
                            ref = keys[key];
                            keys[key] = undefined;
                        }
                        if (ref) {
                            ref.plugin = null;
                            if (removeCapture) this.removeCapture(ref.keyCode);
                            if (destroy) ref.destroy();
                        }
                        return this;
                    },
                    /**
     * Removes all Key objects created by _this_ Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeAllKeys
     * @since 3.24.0
     *
     * @param {boolean} [destroy=false] - Call `Key.destroy` on each removed Key object?
     * @param {boolean} [removeCapture=false] - Remove all key captures for Key objects owened by this plugin?
     *
     * @return {this} This KeyboardPlugin object.
     */ removeAllKeys: function(destroy, removeCapture) {
                        if (destroy === undefined) destroy = false;
                        if (removeCapture === undefined) removeCapture = false;
                        var keys = this.keys;
                        for(var i = 0; i < keys.length; i++){
                            var key = keys[i];
                            if (key) {
                                keys[i] = undefined;
                                if (removeCapture) this.removeCapture(key.keyCode);
                                if (destroy) key.destroy();
                            }
                        }
                        return this;
                    },
                    /**
     * Creates a new KeyCombo.
     *
     * A KeyCombo will listen for a specific string of keys from the Keyboard, and when it receives them
     * it will emit a `keycombomatch` event from this Keyboard Plugin.
     *
     * The keys to be listened for can be defined as:
     *
     * A string (i.e. 'ATARI')
     * An array of either integers (key codes) or strings, or a mixture of both
     * An array of objects (such as Key objects) with a public 'keyCode' property
     *
     * For example, to listen for the Konami code (up, up, down, down, left, right, left, right, b, a, enter)
     * you could pass the following array of key codes:
     *
     * ```javascript
     * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
     *
     * this.input.keyboard.on('keycombomatch', function (event) {
     *     console.log('Konami Code entered!');
     * });
     * ```
     *
     * Or, to listen for the user entering the word PHASER:
     *
     * ```javascript
     * this.input.keyboard.createCombo('PHASER');
     * ```
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#createCombo
     * @since 3.10.0
     *
     * @param {(string|number[]|object[])} keys - The keys that comprise this combo.
     * @param {Phaser.Types.Input.Keyboard.KeyComboConfig} [config] - A Key Combo configuration object.
     *
     * @return {Phaser.Input.Keyboard.KeyCombo} The new KeyCombo object.
     */ createCombo: function(keys, config) {
                        return new KeyCombo(this, keys, config);
                    },
                    /**
     * Checks if the given Key object is currently being held down.
     *
     * The difference between this method and checking the `Key.isDown` property directly is that you can provide
     * a duration to this method. For example, if you wanted a key press to fire a bullet, but you only wanted
     * it to be able to fire every 100ms, then you can call this method with a `duration` of 100 and it
     * will only return `true` every 100ms.
     *
     * If the Keyboard Plugin has been disabled, this method will always return `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#checkDown
     * @since 3.11.0
     *
     * @param {Phaser.Input.Keyboard.Key} key - A Key object.
     * @param {number} [duration=0] - The duration which must have elapsed before this Key is considered as being down.
     *
     * @return {boolean} `true` if the Key is down within the duration specified, otherwise `false`.
     */ checkDown: function(key, duration) {
                        if (duration === undefined) duration = 0;
                        if (this.enabled && key.isDown) {
                            var t = SnapFloor(this.time - key.timeDown, duration);
                            if (t > key._tick) {
                                key._tick = t;
                                return true;
                            }
                        }
                        return false;
                    },
                    /**
     * Internal update handler called by the Input Plugin, which is in turn invoked by the Game step.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#update
     * @private
     * @since 3.10.0
     */ update: function() {
                        var queue = this.manager.queue;
                        var len = queue.length;
                        if (!this.isActive() || len === 0) return;
                        var keys = this.keys;
                        //  Process the event queue, dispatching all of the events that have stored up
                        for(var i = 0; i < len; i++){
                            var event = queue[i];
                            var code = event.keyCode;
                            var key = keys[code];
                            var repeat = false;
                            //  Override the default functions (it's too late for the browser to use them anyway, so we may as well)
                            if (event.cancelled === undefined) {
                                //  Event allowed to flow across all handlers in this Scene, and any other Scene in the Scene list
                                event.cancelled = 0;
                                //  Won't reach any more local (Scene level) handlers
                                event.stopImmediatePropagation = function() {
                                    event.cancelled = 1;
                                };
                                //  Won't reach any more handlers in any Scene further down the Scene list
                                event.stopPropagation = function() {
                                    event.cancelled = -1;
                                };
                            }
                            if (event.cancelled === -1) continue;
                            //  Duplicate event bailout
                            if (code === this.prevCode && event.timeStamp === this.prevTime && event.type === this.prevType) continue;
                            this.prevCode = code;
                            this.prevTime = event.timeStamp;
                            this.prevType = event.type;
                            if (event.type === 'keydown') {
                                //  Key specific callback first
                                if (key) {
                                    repeat = key.isDown;
                                    key.onDown(event);
                                }
                                if (!event.cancelled && (!key || !repeat)) {
                                    if (KeyMap[code]) this.emit(Events.KEY_DOWN + KeyMap[code], event);
                                    if (!event.cancelled) this.emit(Events.ANY_KEY_DOWN, event);
                                }
                            } else {
                                //  Key specific callback first
                                if (key) key.onUp(event);
                                if (!event.cancelled) {
                                    if (KeyMap[code]) this.emit(Events.KEY_UP + KeyMap[code], event);
                                    if (!event.cancelled) this.emit(Events.ANY_KEY_UP, event);
                                }
                            }
                            //  Reset the cancel state for other Scenes to use
                            if (event.cancelled === 1) event.cancelled = 0;
                        }
                    },
                    /**
     * Resets all Key objects created by _this_ Keyboard Plugin back to their default un-pressed states.
     * This can only reset keys created via the `addKey`, `addKeys` or `createCursorKeys` methods.
     * If you have created a Key object directly you'll need to reset it yourself.
     *
     * This method is called automatically when the Keyboard Plugin shuts down, but can be
     * invoked directly at any time you require.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#resetKeys
     * @since 3.15.0
     *
     * @return {this} This KeyboardPlugin object.
     */ resetKeys: function() {
                        var keys = this.keys;
                        for(var i = 0; i < keys.length; i++)//  Because it's a sparsely populated array
                        if (keys[i]) keys[i].reset();
                        return this;
                    },
                    /**
     * Shuts this Keyboard Plugin down. This performs the following tasks:
     *
     * 1 - Removes all keys created by this Keyboard plugin.
     * 2 - Stops and removes the keyboard event listeners.
     * 3 - Clears out any pending requests in the queue, without processing them.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#shutdown
     * @private
     * @since 3.10.0
     */ shutdown: function() {
                        this.removeAllKeys(true);
                        this.removeAllListeners();
                        this.sceneInputPlugin.manager.events.off(InputEvents.MANAGER_PROCESS, this.update, this);
                        this.game.events.off(GameEvents.BLUR, this.resetKeys);
                        this.scene.sys.events.off(SceneEvents.PAUSE, this.resetKeys, this);
                        this.scene.sys.events.off(SceneEvents.SLEEP, this.resetKeys, this);
                        this.queue = [];
                    },
                    /**
     * Destroys this Keyboard Plugin instance and all references it holds, plus clears out local arrays.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#destroy
     * @private
     * @since 3.10.0
     */ destroy: function() {
                        this.shutdown();
                        var keys = this.keys;
                        for(var i = 0; i < keys.length; i++)//  Because it's a sparsely populated array
                        if (keys[i]) keys[i].destroy();
                        this.keys = [];
                        this.combos = [];
                        this.queue = [];
                        this.scene = null;
                        this.settings = null;
                        this.sceneInputPlugin = null;
                        this.manager = null;
                    },
                    /**
     * Internal time value.
     *
     * @name Phaser.Input.Keyboard.KeyboardPlugin#time
     * @type {number}
     * @private
     * @since 3.11.0
     */ time: {
                        get: function() {
                            return this.sceneInputPlugin.manager.time;
                        }
                    }
                });
                /**
 * An instance of the Keyboard Plugin class, if enabled via the `input.keyboard` Scene or Game Config property.
 * Use this to create Key objects and listen for keyboard specific events.
 *
 * @name Phaser.Input.InputPlugin#keyboard
 * @type {?Phaser.Input.Keyboard.KeyboardPlugin}
 * @since 3.10.0
 */ InputPluginCache.register('KeyboardPlugin', KeyboardPlugin, 'keyboard', 'keyboard', 'inputKeyboard');
                module1.exports = KeyboardPlugin;
            /***/ },
            /***/ 66970: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Used internally by the KeyCombo class.
 * Return `true` if it reached the end of the combo, `false` if not.
 *
 * @function Phaser.Input.Keyboard.AdvanceKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native Keyboard Event.
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo object to advance.
 *
 * @return {boolean} `true` if it reached the end of the combo, `false` if not.
 */ var AdvanceKeyCombo = function(event, combo) {
                    combo.timeLastMatched = event.timeStamp;
                    combo.index++;
                    if (combo.index === combo.size) return true;
                    else {
                        combo.current = combo.keyCodes[combo.index];
                        return false;
                    }
                };
                module1.exports = AdvanceKeyCombo;
            /***/ },
            /***/ 87960: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Events = __webpack_require__(95922);
                var GetFastValue = __webpack_require__(95540);
                var ProcessKeyCombo = __webpack_require__(68769);
                var ResetKeyCombo = __webpack_require__(92803);
                /**
 * @classdesc
 * A KeyCombo will listen for a specific string of keys from the Keyboard, and when it receives them
 * it will emit a `keycombomatch` event from the Keyboard Manager.
 *
 * The keys to be listened for can be defined as:
 *
 * A string (i.e. 'ATARI')
 * An array of either integers (key codes) or strings, or a mixture of both
 * An array of objects (such as Key objects) with a public 'keyCode' property
 *
 * For example, to listen for the Konami code (up, up, down, down, left, right, left, right, b, a, enter)
 * you could pass the following array of key codes:
 *
 * ```javascript
 * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
 *
 * this.input.keyboard.on('keycombomatch', function (event) {
 *     console.log('Konami Code entered!');
 * });
 * ```
 *
 * Or, to listen for the user entering the word PHASER:
 *
 * ```javascript
 * this.input.keyboard.createCombo('PHASER');
 * ```
 *
 * @class KeyCombo
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @listens Phaser.Input.Keyboard.Events#ANY_KEY_DOWN
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyboardPlugin} keyboardPlugin - A reference to the Keyboard Plugin.
 * @param {(string|number[]|object[])} keys - The keys that comprise this combo.
 * @param {Phaser.Types.Input.Keyboard.KeyComboConfig} [config] - A Key Combo configuration object.
 */ var KeyCombo = new Class({
                    initialize: function KeyCombo(keyboardPlugin, keys, config) {
                        if (config === undefined) config = {};
                        //  Can't have a zero or single length combo (string or array based)
                        if (keys.length < 2) return false;
                        /**
         * A reference to the Keyboard Manager
         *
         * @name Phaser.Input.Keyboard.KeyCombo#manager
         * @type {Phaser.Input.Keyboard.KeyboardPlugin}
         * @since 3.0.0
         */ this.manager = keyboardPlugin;
                        /**
         * A flag that controls if this Key Combo is actively processing keys or not.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                        /**
         * An array of the keycodes that comprise this combo.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#keyCodes
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.keyCodes = [];
                        //  if 'keys' is a string we need to get the keycode of each character in it
                        for(var i = 0; i < keys.length; i++){
                            var char = keys[i];
                            if (typeof char === 'string') this.keyCodes.push(char.toUpperCase().charCodeAt(0));
                            else if (typeof char === 'number') this.keyCodes.push(char);
                            else if (char.hasOwnProperty('keyCode')) this.keyCodes.push(char.keyCode);
                        }
                        /**
         * The current keyCode the combo is waiting for.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#current
         * @type {number}
         * @since 3.0.0
         */ this.current = this.keyCodes[0];
                        /**
         * The current index of the key being waited for in the 'keys' string.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#index
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.index = 0;
                        /**
         * The length of this combo (in keycodes)
         *
         * @name Phaser.Input.Keyboard.KeyCombo#size
         * @type {number}
         * @since 3.0.0
         */ this.size = this.keyCodes.length;
                        /**
         * The time the previous key in the combo was matched.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#timeLastMatched
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeLastMatched = 0;
                        /**
         * Has this Key Combo been matched yet?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#matched
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.matched = false;
                        /**
         * The time the entire combo was matched.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#timeMatched
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeMatched = 0;
                        /**
         * If they press the wrong key do we reset the combo?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#resetOnWrongKey
         * @type {boolean}
         * @default 0
         * @since 3.0.0
         */ this.resetOnWrongKey = GetFastValue(config, 'resetOnWrongKey', true);
                        /**
         * The max delay in ms between each key press. Above this the combo is reset. 0 means disabled.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#maxKeyDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxKeyDelay = GetFastValue(config, 'maxKeyDelay', 0);
                        /**
         * If previously matched and they press the first key of the combo again, will it reset?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#resetOnMatch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.resetOnMatch = GetFastValue(config, 'resetOnMatch', false);
                        /**
         * If the combo matches, will it delete itself?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#deleteOnMatch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.deleteOnMatch = GetFastValue(config, 'deleteOnMatch', false);
                        var _this = this;
                        var onKeyDownHandler = function(event) {
                            if (_this.matched || !_this.enabled) return;
                            var matched = ProcessKeyCombo(event, _this);
                            if (matched) {
                                _this.manager.emit(Events.COMBO_MATCH, _this, event);
                                if (_this.resetOnMatch) ResetKeyCombo(_this);
                                else if (_this.deleteOnMatch) _this.destroy();
                            }
                        };
                        /**
         * The internal Key Down handler.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#onKeyDown
         * @private
         * @type {KeyboardKeydownCallback}
         * @fires Phaser.Input.Keyboard.Events#COMBO_MATCH
         * @since 3.0.0
         */ this.onKeyDown = onKeyDownHandler;
                        this.manager.on(Events.ANY_KEY_DOWN, this.onKeyDown);
                    },
                    /**
     * How far complete is this combo? A value between 0 and 1.
     *
     * @name Phaser.Input.Keyboard.KeyCombo#progress
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ progress: {
                        get: function() {
                            return this.index / this.size;
                        }
                    },
                    /**
     * Destroys this Key Combo and all of its references.
     *
     * @method Phaser.Input.Keyboard.KeyCombo#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.enabled = false;
                        this.keyCodes = [];
                        this.manager.off(Events.ANY_KEY_DOWN, this.onKeyDown);
                        this.manager = null;
                    }
                });
                module1.exports = KeyCombo;
            /***/ },
            /***/ 68769: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AdvanceKeyCombo = __webpack_require__(66970);
                /**
 * Used internally by the KeyCombo class.
 *
 * @function Phaser.Input.Keyboard.ProcessKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native Keyboard Event.
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo object to be processed.
 *
 * @return {boolean} `true` if the combo was matched, otherwise `false`.
 */ var ProcessKeyCombo = function(event, combo) {
                    if (combo.matched) return true;
                    var comboMatched = false;
                    var keyMatched = false;
                    if (event.keyCode === combo.current) {
                        //  Key was correct
                        if (combo.index > 0 && combo.maxKeyDelay > 0) {
                            //  We have to check to see if the delay between
                            //  the new key and the old one was too long (if enabled)
                            var timeLimit = combo.timeLastMatched + combo.maxKeyDelay;
                            //  Check if they pressed it in time or not
                            if (event.timeStamp <= timeLimit) {
                                keyMatched = true;
                                comboMatched = AdvanceKeyCombo(event, combo);
                            }
                        } else {
                            keyMatched = true;
                            //  We don't check the time for the first key pressed, so just advance it
                            comboMatched = AdvanceKeyCombo(event, combo);
                        }
                    }
                    if (!keyMatched && combo.resetOnWrongKey) {
                        //  Wrong key was pressed
                        combo.index = 0;
                        combo.current = combo.keyCodes[0];
                    }
                    if (comboMatched) {
                        combo.timeLastMatched = event.timeStamp;
                        combo.matched = true;
                        combo.timeMatched = event.timeStamp;
                    }
                    return comboMatched;
                };
                module1.exports = ProcessKeyCombo;
            /***/ },
            /***/ 92803: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Used internally by the KeyCombo class.
 *
 * @function Phaser.Input.Keyboard.ResetKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo to reset.
 *
 * @return {Phaser.Input.Keyboard.KeyCombo} The KeyCombo.
 */ var ResetKeyCombo = function(combo) {
                    combo.current = combo.keyCodes[0];
                    combo.index = 0;
                    combo.timeLastMatched = 0;
                    combo.matched = false;
                    combo.timeMatched = 0;
                    return combo;
                };
                module1.exports = ResetKeyCombo;
            /***/ },
            /***/ 92612: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Global Key Down Event.
 *
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is pressed down.
 *
 * Listen to this event from within a Scene using: `this.input.keyboard.on('keydown', listener)`.
 *
 * You can also listen for a specific key being pressed. See [Keyboard.Events.KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:KEY_DOWN} for details.
 *
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:DOWN} for details.
 *
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * Read [this article on ghosting]{@link http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/} for details.
 *
 * Also, please be aware that some browser extensions can disable or override Phaser keyboard handling.
 * For example, the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * There are others. So, please check your extensions if you find you have specific keys that don't work.
 *
 * @event Phaser.Input.Keyboard.Events#ANY_KEY_DOWN
 * @type {string}
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was pressed, any modifiers, etc.
 */ module1.exports = 'keydown';
            /***/ },
            /***/ 23345: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Global Key Up Event.
 *
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is released.
 *
 * Listen to this event from within a Scene using: `this.input.keyboard.on('keyup', listener)`.
 *
 * You can also listen for a specific key being released. See [Keyboard.Events.KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:KEY_UP} for details.
 *
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.UP]{@linkcode Phaser.Input.Keyboard.Events#event:UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#ANY_KEY_UP
 * @type {string}
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was released, any modifiers, etc.
 */ module1.exports = 'keyup';
            /***/ },
            /***/ 21957: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Combo Match Event.
 *
 * This event is dispatched by the Keyboard Plugin when a [Key Combo]{@link Phaser.Input.Keyboard.KeyCombo} is matched.
 *
 * Listen for this event from the Key Plugin after a combo has been created:
 *
 * ```javascript
 * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
 *
 * this.input.keyboard.on('keycombomatch', function (event) {
 *     console.log('Konami Code entered!');
 * });
 * ```
 *
 * @event Phaser.Input.Keyboard.Events#COMBO_MATCH
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyCombo} keycombo - The Key Combo object that was matched.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event of the final key in the combo. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = 'keycombomatch';
            /***/ },
            /***/ 44743: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Down Event.
 *
 * This event is dispatched by a [Key]{@link Phaser.Input.Keyboard.Key} object when it is pressed.
 *
 * Listen for this event from the Key object instance directly:
 *
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 *
 * spaceBar.on('down', listener)
 * ```
 *
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_DOWN} for details.
 *
 * @event Phaser.Input.Keyboard.Events#DOWN
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object that was pressed.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = 'down';
            /***/ },
            /***/ 3771: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Down Event.
 *
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is pressed down.
 *
 * Unlike the `ANY_KEY_DOWN` event, this one has a special dynamic event name. For example, to listen for the `A` key being pressed
 * use the following from within a Scene: `this.input.keyboard.on('keydown-A', listener)`. You can replace the `-A` part of the event
 * name with any valid [Key Code string]{@link Phaser.Input.Keyboard.KeyCodes}. For example, this will listen for the space bar:
 * `this.input.keyboard.on('keydown-SPACE', listener)`.
 *
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_DOWN} for details.
 *
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:DOWN} for details.
 *
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * Read [this article on ghosting]{@link http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/} for details.
 *
 * Also, please be aware that some browser extensions can disable or override Phaser keyboard handling.
 * For example, the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * There are others. So, please check your extensions if you find you have specific keys that don't work.
 *
 * @event Phaser.Input.Keyboard.Events#KEY_DOWN
 * @type {string}
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was pressed, any modifiers, etc.
 */ module1.exports = 'keydown-';
            /***/ },
            /***/ 46358: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Up Event.
 *
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is released.
 *
 * Unlike the `ANY_KEY_UP` event, this one has a special dynamic event name. For example, to listen for the `A` key being released
 * use the following from within a Scene: `this.input.keyboard.on('keyup-A', listener)`. You can replace the `-A` part of the event
 * name with any valid [Key Code string]{@link Phaser.Input.Keyboard.KeyCodes}. For example, this will listen for the space bar:
 * `this.input.keyboard.on('keyup-SPACE', listener)`.
 *
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_UP} for details.
 *
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.UP]{@linkcode Phaser.Input.Keyboard.Events#event:UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#KEY_UP
 * @type {string}
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was released, any modifiers, etc.
 */ module1.exports = 'keyup-';
            /***/ },
            /***/ 75674: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Up Event.
 *
 * This event is dispatched by a [Key]{@link Phaser.Input.Keyboard.Key} object when it is released.
 *
 * Listen for this event from the Key object instance directly:
 *
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 *
 * spaceBar.on('up', listener)
 * ```
 *
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#UP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object that was released.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = 'up';
            /***/ },
            /***/ 95922: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Keyboard.Events
 */ module1.exports = {
                    ANY_KEY_DOWN: __webpack_require__(92612),
                    ANY_KEY_UP: __webpack_require__(23345),
                    COMBO_MATCH: __webpack_require__(21957),
                    DOWN: __webpack_require__(44743),
                    KEY_DOWN: __webpack_require__(3771),
                    KEY_UP: __webpack_require__(46358),
                    UP: __webpack_require__(75674)
                };
            /***/ },
            /***/ 51442: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Keyboard
 */ module1.exports = {
                    Events: __webpack_require__(95922),
                    KeyboardManager: __webpack_require__(78970),
                    KeyboardPlugin: __webpack_require__(28846),
                    Key: __webpack_require__(30472),
                    KeyCodes: __webpack_require__(46032),
                    KeyCombo: __webpack_require__(87960),
                    AdvanceKeyCombo: __webpack_require__(66970),
                    ProcessKeyCombo: __webpack_require__(68769),
                    ResetKeyCombo: __webpack_require__(92803),
                    JustDown: __webpack_require__(90229),
                    JustUp: __webpack_require__(38796),
                    DownDuration: __webpack_require__(37015),
                    UpDuration: __webpack_require__(41170)
                };
            /***/ },
            /***/ 37015: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns `true` if the Key was pressed down within the `duration` value given, based on the current
 * game clock time. Or `false` if it either isn't down, or was pressed down longer ago than the given duration.
 *
 * @function Phaser.Input.Keyboard.DownDuration
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object to test.
 * @param {number} [duration=50] - The duration, in ms, within which the key must have been pressed down.
 *
 * @return {boolean} `true` if the Key was pressed down within `duration` ms ago, otherwise `false`.
 */ var DownDuration = function(key, duration) {
                    if (duration === undefined) duration = 50;
                    var current = key.plugin.game.loop.time - key.timeDown;
                    return key.isDown && current < duration;
                };
                module1.exports = DownDuration;
            /***/ },
            /***/ 90229: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The justDown value allows you to test if this Key has just been pressed down or not.
 *
 * When you check this value it will return `true` if the Key is down, otherwise `false`.
 *
 * You can only call justDown once per key press. It will only return `true` once, until the Key is released and pressed down again.
 * This allows you to use it in situations where you want to check if this key is down without using an event, such as in a core game loop.
 *
 * @function Phaser.Input.Keyboard.JustDown
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key to check to see if it's just down or not.
 *
 * @return {boolean} `true` if the Key was just pressed, otherwise `false`.
 */ var JustDown = function(key) {
                    if (key._justDown) {
                        key._justDown = false;
                        return true;
                    } else return false;
                };
                module1.exports = JustDown;
            /***/ },
            /***/ 38796: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The justUp value allows you to test if this Key has just been released or not.
 *
 * When you check this value it will return `true` if the Key is up, otherwise `false`.
 *
 * You can only call JustUp once per key release. It will only return `true` once, until the Key is pressed down and released again.
 * This allows you to use it in situations where you want to check if this key is up without using an event, such as in a core game loop.
 *
 * @function Phaser.Input.Keyboard.JustUp
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key to check to see if it's just up or not.
 *
 * @return {boolean} `true` if the Key was just released, otherwise `false`.
 */ var JustUp = function(key) {
                    if (key._justUp) {
                        key._justUp = false;
                        return true;
                    } else return false;
                };
                module1.exports = JustUp;
            /***/ },
            /***/ 30472: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(95922);
                /**
 * @classdesc
 * A generic Key object which can be passed to the Process functions (and so on)
 * keycode must be an integer
 *
 * @class Key
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyboardPlugin} plugin - The Keyboard Plugin instance that owns this Key object.
 * @param {number} keyCode - The keycode of this key.
 */ var Key = new Class({
                    Extends: EventEmitter,
                    initialize: function Key(plugin, keyCode) {
                        EventEmitter.call(this);
                        /**
         * The Keyboard Plugin instance that owns this Key object.
         *
         * @name Phaser.Input.Keyboard.Key#plugin
         * @type {Phaser.Input.Keyboard.KeyboardPlugin}
         * @since 3.17.0
         */ this.plugin = plugin;
                        /**
         * The keycode of this key.
         *
         * @name Phaser.Input.Keyboard.Key#keyCode
         * @type {number}
         * @since 3.0.0
         */ this.keyCode = keyCode;
                        /**
         * The original DOM event.
         *
         * @name Phaser.Input.Keyboard.Key#originalEvent
         * @type {KeyboardEvent}
         * @since 3.0.0
         */ this.originalEvent = undefined;
                        /**
         * Can this Key be processed?
         *
         * @name Phaser.Input.Keyboard.Key#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                        /**
         * The "down" state of the key. This will remain `true` for as long as the keyboard thinks this key is held down.
         *
         * @name Phaser.Input.Keyboard.Key#isDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isDown = false;
                        /**
         * The "up" state of the key. This will remain `true` for as long as the keyboard thinks this key is up.
         *
         * @name Phaser.Input.Keyboard.Key#isUp
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isUp = true;
                        /**
         * The down state of the ALT key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#altKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.altKey = false;
                        /**
         * The down state of the CTRL key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#ctrlKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.ctrlKey = false;
                        /**
         * The down state of the SHIFT key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#shiftKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shiftKey = false;
                        /**
         * The down state of the Meta key, if pressed at the same time as this key.
         * On a Mac the Meta Key is the Command key. On Windows keyboards, it's the Windows key.
         *
         * @name Phaser.Input.Keyboard.Key#metaKey
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.metaKey = false;
                        /**
         * The location of the modifier key. 0 for standard (or unknown), 1 for left, 2 for right, 3 for numpad.
         *
         * @name Phaser.Input.Keyboard.Key#location
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.location = 0;
                        /**
         * The timestamp when the key was last pressed down.
         *
         * @name Phaser.Input.Keyboard.Key#timeDown
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeDown = 0;
                        /**
         * The number of milliseconds this key was held down for in the previous down - up sequence.
         * This value isn't updated every game step, only when the Key changes state.
         * To get the current duration use the `getDuration` method.
         *
         * @name Phaser.Input.Keyboard.Key#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                        /**
         * The timestamp when the key was last released.
         *
         * @name Phaser.Input.Keyboard.Key#timeUp
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeUp = 0;
                        /**
         * When a key is held down should it continuously fire the `down` event each time it repeats?
         *
         * By default it will emit the `down` event just once, but if you wish to receive the event
         * for each repeat as well, enable this property.
         *
         * @name Phaser.Input.Keyboard.Key#emitOnRepeat
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.emitOnRepeat = false;
                        /**
         * If a key is held down this holds down the number of times the key has 'repeated'.
         *
         * @name Phaser.Input.Keyboard.Key#repeats
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeats = 0;
                        /**
         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
         *
         * @name Phaser.Input.Keyboard.Key#_justDown
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._justDown = false;
                        /**
         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
         *
         * @name Phaser.Input.Keyboard.Key#_justUp
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._justUp = false;
                        /**
         * Internal tick counter.
         *
         * @name Phaser.Input.Keyboard.Key#_tick
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._tick = -1;
                    },
                    /**
     * Controls if this Key will continuously emit a `down` event while being held down (true),
     * or emit the event just once, on first press, and then skip future events (false).
     *
     * @method Phaser.Input.Keyboard.Key#setEmitOnRepeat
     * @since 3.16.0
     *
     * @param {boolean} value - Emit `down` events on repeated key down actions, or just once?
     *
     * @return {this} This Key instance.
     */ setEmitOnRepeat: function(value) {
                        this.emitOnRepeat = value;
                        return this;
                    },
                    /**
     * Processes the Key Down action for this Key.
     * Called automatically by the Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.Key#onDown
     * @fires Phaser.Input.Keyboard.Events#DOWN
     * @since 3.16.0
     *
     * @param {KeyboardEvent} event - The native DOM Keyboard event.
     */ onDown: function(event) {
                        this.originalEvent = event;
                        if (!this.enabled) return;
                        this.altKey = event.altKey;
                        this.ctrlKey = event.ctrlKey;
                        this.shiftKey = event.shiftKey;
                        this.metaKey = event.metaKey;
                        this.location = event.location;
                        this.repeats++;
                        if (!this.isDown) {
                            this.isDown = true;
                            this.isUp = false;
                            this.timeDown = event.timeStamp;
                            this.duration = 0;
                            this._justDown = true;
                            this._justUp = false;
                            this.emit(Events.DOWN, this, event);
                        } else if (this.emitOnRepeat) this.emit(Events.DOWN, this, event);
                    },
                    /**
     * Processes the Key Up action for this Key.
     * Called automatically by the Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.Key#onUp
     * @fires Phaser.Input.Keyboard.Events#UP
     * @since 3.16.0
     *
     * @param {KeyboardEvent} event - The native DOM Keyboard event.
     */ onUp: function(event) {
                        this.originalEvent = event;
                        if (!this.enabled) return;
                        this.isDown = false;
                        this.isUp = true;
                        this.timeUp = event.timeStamp;
                        this.duration = this.timeUp - this.timeDown;
                        this.repeats = 0;
                        this._justDown = false;
                        this._justUp = true;
                        this._tick = -1;
                        this.emit(Events.UP, this, event);
                    },
                    /**
     * Resets this Key object back to its default un-pressed state.
     *
     * As of version 3.60.0 it no longer resets the `enabled` or `preventDefault` flags.
     *
     * @method Phaser.Input.Keyboard.Key#reset
     * @since 3.6.0
     *
     * @return {this} This Key instance.
     */ reset: function() {
                        this.isDown = false;
                        this.isUp = true;
                        this.altKey = false;
                        this.ctrlKey = false;
                        this.shiftKey = false;
                        this.metaKey = false;
                        this.timeDown = 0;
                        this.duration = 0;
                        this.timeUp = 0;
                        this.repeats = 0;
                        this._justDown = false;
                        this._justUp = false;
                        this._tick = -1;
                        return this;
                    },
                    /**
     * Returns the duration, in ms, that the Key has been held down for.
     *
     * If the key is not currently down it will return zero.
     *
     * To get the duration the Key was held down for in the previous up-down cycle,
     * use the `Key.duration` property value instead.
     *
     * @method Phaser.Input.Keyboard.Key#getDuration
     * @since 3.17.0
     *
     * @return {number} The duration, in ms, that the Key has been held down for if currently down.
     */ getDuration: function() {
                        if (this.isDown) return this.plugin.game.loop.time - this.timeDown;
                        else return 0;
                    },
                    /**
     * Removes any bound event handlers and removes local references.
     *
     * @method Phaser.Input.Keyboard.Key#destroy
     * @since 3.16.0
     */ destroy: function() {
                        this.removeAllListeners();
                        this.originalEvent = null;
                        this.plugin = null;
                    }
                });
                module1.exports = Key;
            /***/ },
            /***/ 46032: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Keyboard Codes.
 *
 * @namespace Phaser.Input.Keyboard.KeyCodes
 * @memberof Phaser.Input.Keyboard
 * @since 3.0.0
 */ var KeyCodes = {
                    /**
     * The BACKSPACE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.BACKSPACE
     * @type {number}
     * @since 3.0.0
     */ BACKSPACE: 8,
                    /**
     * The TAB key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.TAB
     * @type {number}
     * @since 3.0.0
     */ TAB: 9,
                    /**
     * The ENTER key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.ENTER
     * @type {number}
     * @since 3.0.0
     */ ENTER: 13,
                    /**
     * The SHIFT key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.SHIFT
     * @type {number}
     * @since 3.0.0
     */ SHIFT: 16,
                    /**
     * The CTRL key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.CTRL
     * @type {number}
     * @since 3.0.0
     */ CTRL: 17,
                    /**
     * The ALT key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.ALT
     * @type {number}
     * @since 3.0.0
     */ ALT: 18,
                    /**
     * The PAUSE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.PAUSE
     * @type {number}
     * @since 3.0.0
     */ PAUSE: 19,
                    /**
     * The CAPS_LOCK key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.CAPS_LOCK
     * @type {number}
     * @since 3.0.0
     */ CAPS_LOCK: 20,
                    /**
     * The ESC key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.ESC
     * @type {number}
     * @since 3.0.0
     */ ESC: 27,
                    /**
     * The SPACE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.SPACE
     * @type {number}
     * @since 3.0.0
     */ SPACE: 32,
                    /**
     * The PAGE_UP key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_UP
     * @type {number}
     * @since 3.0.0
     */ PAGE_UP: 33,
                    /**
     * The PAGE_DOWN key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_DOWN
     * @type {number}
     * @since 3.0.0
     */ PAGE_DOWN: 34,
                    /**
     * The END key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.END
     * @type {number}
     * @since 3.0.0
     */ END: 35,
                    /**
     * The HOME key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.HOME
     * @type {number}
     * @since 3.0.0
     */ HOME: 36,
                    /**
     * The LEFT key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.LEFT
     * @type {number}
     * @since 3.0.0
     */ LEFT: 37,
                    /**
     * The UP key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.UP
     * @type {number}
     * @since 3.0.0
     */ UP: 38,
                    /**
     * The RIGHT key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.RIGHT
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 39,
                    /**
     * The DOWN key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.DOWN
     * @type {number}
     * @since 3.0.0
     */ DOWN: 40,
                    /**
     * The PRINT_SCREEN key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.PRINT_SCREEN
     * @type {number}
     * @since 3.0.0
     */ PRINT_SCREEN: 42,
                    /**
     * The INSERT key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.INSERT
     * @type {number}
     * @since 3.0.0
     */ INSERT: 45,
                    /**
     * The DELETE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.DELETE
     * @type {number}
     * @since 3.0.0
     */ DELETE: 46,
                    /**
     * The ZERO key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.ZERO
     * @type {number}
     * @since 3.0.0
     */ ZERO: 48,
                    /**
     * The ONE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.ONE
     * @type {number}
     * @since 3.0.0
     */ ONE: 49,
                    /**
     * The TWO key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.TWO
     * @type {number}
     * @since 3.0.0
     */ TWO: 50,
                    /**
     * The THREE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.THREE
     * @type {number}
     * @since 3.0.0
     */ THREE: 51,
                    /**
     * The FOUR key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.FOUR
     * @type {number}
     * @since 3.0.0
     */ FOUR: 52,
                    /**
     * The FIVE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.FIVE
     * @type {number}
     * @since 3.0.0
     */ FIVE: 53,
                    /**
     * The SIX key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.SIX
     * @type {number}
     * @since 3.0.0
     */ SIX: 54,
                    /**
     * The SEVEN key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.SEVEN
     * @type {number}
     * @since 3.0.0
     */ SEVEN: 55,
                    /**
     * The EIGHT key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.EIGHT
     * @type {number}
     * @since 3.0.0
     */ EIGHT: 56,
                    /**
     * The NINE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NINE
     * @type {number}
     * @since 3.0.0
     */ NINE: 57,
                    /**
     * The NUMPAD_ZERO key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ZERO
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_ZERO: 96,
                    /**
     * The NUMPAD_ONE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ONE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_ONE: 97,
                    /**
     * The NUMPAD_TWO key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_TWO
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_TWO: 98,
                    /**
     * The NUMPAD_THREE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_THREE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_THREE: 99,
                    /**
     * The NUMPAD_FOUR key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FOUR
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_FOUR: 100,
                    /**
     * The NUMPAD_FIVE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FIVE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_FIVE: 101,
                    /**
     * The NUMPAD_SIX key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SIX
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_SIX: 102,
                    /**
     * The NUMPAD_SEVEN key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SEVEN
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_SEVEN: 103,
                    /**
     * The NUMPAD_EIGHT key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_EIGHT
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_EIGHT: 104,
                    /**
     * The NUMPAD_NINE key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_NINE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_NINE: 105,
                    /**
     * The Numpad Addition (+) key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ADD
     * @type {number}
     * @since 3.21.0
     */ NUMPAD_ADD: 107,
                    /**
     * The Numpad Subtraction (-) key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SUBTRACT
     * @type {number}
     * @since 3.21.0
     */ NUMPAD_SUBTRACT: 109,
                    /**
     * The A key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.A
     * @type {number}
     * @since 3.0.0
     */ A: 65,
                    /**
     * The B key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.B
     * @type {number}
     * @since 3.0.0
     */ B: 66,
                    /**
     * The C key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.C
     * @type {number}
     * @since 3.0.0
     */ C: 67,
                    /**
     * The D key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.D
     * @type {number}
     * @since 3.0.0
     */ D: 68,
                    /**
     * The E key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.E
     * @type {number}
     * @since 3.0.0
     */ E: 69,
                    /**
     * The F key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F
     * @type {number}
     * @since 3.0.0
     */ F: 70,
                    /**
     * The G key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.G
     * @type {number}
     * @since 3.0.0
     */ G: 71,
                    /**
     * The H key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.H
     * @type {number}
     * @since 3.0.0
     */ H: 72,
                    /**
     * The I key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.I
     * @type {number}
     * @since 3.0.0
     */ I: 73,
                    /**
     * The J key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.J
     * @type {number}
     * @since 3.0.0
     */ J: 74,
                    /**
     * The K key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.K
     * @type {number}
     * @since 3.0.0
     */ K: 75,
                    /**
     * The L key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.L
     * @type {number}
     * @since 3.0.0
     */ L: 76,
                    /**
     * The M key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.M
     * @type {number}
     * @since 3.0.0
     */ M: 77,
                    /**
     * The N key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.N
     * @type {number}
     * @since 3.0.0
     */ N: 78,
                    /**
     * The O key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.O
     * @type {number}
     * @since 3.0.0
     */ O: 79,
                    /**
     * The P key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.P
     * @type {number}
     * @since 3.0.0
     */ P: 80,
                    /**
     * The Q key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.Q
     * @type {number}
     * @since 3.0.0
     */ Q: 81,
                    /**
     * The R key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.R
     * @type {number}
     * @since 3.0.0
     */ R: 82,
                    /**
     * The S key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.S
     * @type {number}
     * @since 3.0.0
     */ S: 83,
                    /**
     * The T key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.T
     * @type {number}
     * @since 3.0.0
     */ T: 84,
                    /**
     * The U key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.U
     * @type {number}
     * @since 3.0.0
     */ U: 85,
                    /**
     * The V key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.V
     * @type {number}
     * @since 3.0.0
     */ V: 86,
                    /**
     * The W key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.W
     * @type {number}
     * @since 3.0.0
     */ W: 87,
                    /**
     * The X key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.X
     * @type {number}
     * @since 3.0.0
     */ X: 88,
                    /**
     * The Y key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.Y
     * @type {number}
     * @since 3.0.0
     */ Y: 89,
                    /**
     * The Z key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.Z
     * @type {number}
     * @since 3.0.0
     */ Z: 90,
                    /**
     * The F1 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F1
     * @type {number}
     * @since 3.0.0
     */ F1: 112,
                    /**
     * The F2 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F2
     * @type {number}
     * @since 3.0.0
     */ F2: 113,
                    /**
     * The F3 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F3
     * @type {number}
     * @since 3.0.0
     */ F3: 114,
                    /**
     * The F4 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F4
     * @type {number}
     * @since 3.0.0
     */ F4: 115,
                    /**
     * The F5 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F5
     * @type {number}
     * @since 3.0.0
     */ F5: 116,
                    /**
     * The F6 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F6
     * @type {number}
     * @since 3.0.0
     */ F6: 117,
                    /**
     * The F7 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F7
     * @type {number}
     * @since 3.0.0
     */ F7: 118,
                    /**
     * The F8 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F8
     * @type {number}
     * @since 3.0.0
     */ F8: 119,
                    /**
     * The F9 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F9
     * @type {number}
     * @since 3.0.0
     */ F9: 120,
                    /**
     * The F10 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F10
     * @type {number}
     * @since 3.0.0
     */ F10: 121,
                    /**
     * The F11 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F11
     * @type {number}
     * @since 3.0.0
     */ F11: 122,
                    /**
     * The F12 key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.F12
     * @type {number}
     * @since 3.0.0
     */ F12: 123,
                    /**
     * The SEMICOLON key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.SEMICOLON
     * @type {number}
     * @since 3.0.0
     */ SEMICOLON: 186,
                    /**
     * The PLUS key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.PLUS
     * @type {number}
     * @since 3.0.0
     */ PLUS: 187,
                    /**
     * The COMMA key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA
     * @type {number}
     * @since 3.0.0
     */ COMMA: 188,
                    /**
     * The MINUS key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.MINUS
     * @type {number}
     * @since 3.0.0
     */ MINUS: 189,
                    /**
     * The PERIOD key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.PERIOD
     * @type {number}
     * @since 3.0.0
     */ PERIOD: 190,
                    /**
     * The FORWARD_SLASH key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.FORWARD_SLASH
     * @type {number}
     * @since 3.0.0
     */ FORWARD_SLASH: 191,
                    /**
     * The BACK_SLASH key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.BACK_SLASH
     * @type {number}
     * @since 3.0.0
     */ BACK_SLASH: 220,
                    /**
     * The QUOTES key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.QUOTES
     * @type {number}
     * @since 3.0.0
     */ QUOTES: 222,
                    /**
     * The BACKTICK key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.BACKTICK
     * @type {number}
     * @since 3.0.0
     */ BACKTICK: 192,
                    /**
     * The OPEN_BRACKET key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.OPEN_BRACKET
     * @type {number}
     * @since 3.0.0
     */ OPEN_BRACKET: 219,
                    /**
     * The CLOSED_BRACKET key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.CLOSED_BRACKET
     * @type {number}
     * @since 3.0.0
     */ CLOSED_BRACKET: 221,
                    /**
     * The SEMICOLON_FIREFOX key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.SEMICOLON_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ SEMICOLON_FIREFOX: 59,
                    /**
     * The COLON key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.COLON
     * @type {number}
     * @since 3.0.0
     */ COLON: 58,
                    /**
     * The COMMA_FIREFOX_WINDOWS key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA_FIREFOX_WINDOWS
     * @type {number}
     * @since 3.0.0
     */ COMMA_FIREFOX_WINDOWS: 60,
                    /**
     * The COMMA_FIREFOX key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ COMMA_FIREFOX: 62,
                    /**
     * The BRACKET_RIGHT_FIREFOX key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.BRACKET_RIGHT_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ BRACKET_RIGHT_FIREFOX: 174,
                    /**
     * The BRACKET_LEFT_FIREFOX key.
     *
     * @name Phaser.Input.Keyboard.KeyCodes.BRACKET_LEFT_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ BRACKET_LEFT_FIREFOX: 175
                };
                module1.exports = KeyCodes;
            /***/ },
            /***/ 74600: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var KeyCodes = __webpack_require__(46032);
                var KeyMap = {};
                for(var key in KeyCodes)KeyMap[KeyCodes[key]] = key;
                module1.exports = KeyMap;
            /***/ },
            /***/ 41170: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns `true` if the Key was released within the `duration` value given, based on the current
 * game clock time. Or returns `false` if it either isn't up, or was released longer ago than the given duration.
 *
 * @function Phaser.Input.Keyboard.UpDuration
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object to test.
 * @param {number} [duration=50] - The duration, in ms, within which the key must have been released.
 *
 * @return {boolean} `true` if the Key was released within `duration` ms ago, otherwise `false`.
 */ var UpDuration = function(key, duration) {
                    if (duration === undefined) duration = 50;
                    var current = key.plugin.game.loop.time - key.timeUp;
                    return key.isUp && current < duration;
                };
                module1.exports = UpDuration;
            /***/ },
            /***/ 85098: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Features = __webpack_require__(89357);
                var InputEvents = __webpack_require__(8214);
                var NOOP = __webpack_require__(29747);
                //  https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
                //  https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
                /**
 * @classdesc
 * The Mouse Manager is a helper class that belongs to the Input Manager.
 *
 * Its role is to listen for native DOM Mouse Events and then pass them onto the Input Manager for further processing.
 *
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically.
 *
 * @class MouseManager
 * @memberof Phaser.Input.Mouse
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var MouseManager = new Class({
                    initialize: function MouseManager(inputManager) {
                        /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Mouse.MouseManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = inputManager;
                        /**
         * If `true` the DOM `mousedown` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultDown
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultDown = true;
                        /**
         * If `true` the DOM `mouseup` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultUp
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultUp = true;
                        /**
         * If `true` the DOM `mousemove` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultMove
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultMove = true;
                        /**
         * If `true` the DOM `wheel` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultWheel
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultWheel = false;
                        /**
         * A boolean that controls if the Mouse Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Mouse.MouseManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.enabled = false;
                        /**
         * The Mouse target, as defined in the Game Config.
         * Typically the canvas to which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Mouse.MouseManager#target
         * @type {any}
         * @since 3.0.0
         */ this.target;
                        /**
         * If the mouse has been pointer locked successfully this will be set to true.
         *
         * @name Phaser.Input.Mouse.MouseManager#locked
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.locked = false;
                        /**
         * The Mouse Move Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseMove
         * @type {function}
         * @since 3.10.0
         */ this.onMouseMove = NOOP;
                        /**
         * The Mouse Down Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseDown
         * @type {function}
         * @since 3.10.0
         */ this.onMouseDown = NOOP;
                        /**
         * The Mouse Up Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseUp
         * @type {function}
         * @since 3.10.0
         */ this.onMouseUp = NOOP;
                        /**
         * The Mouse Down Event handler specifically for events on the Window.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseDownWindow
         * @type {function}
         * @since 3.17.0
         */ this.onMouseDownWindow = NOOP;
                        /**
         * The Mouse Up Event handler specifically for events on the Window.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseUpWindow
         * @type {function}
         * @since 3.17.0
         */ this.onMouseUpWindow = NOOP;
                        /**
         * The Mouse Over Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseOver
         * @type {function}
         * @since 3.16.0
         */ this.onMouseOver = NOOP;
                        /**
         * The Mouse Out Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseOut
         * @type {function}
         * @since 3.16.0
         */ this.onMouseOut = NOOP;
                        /**
         * The Mouse Wheel Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseWheel
         * @type {function}
         * @since 3.18.0
         */ this.onMouseWheel = NOOP;
                        /**
         * Internal pointerLockChange handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#pointerLockChange
         * @type {function}
         * @since 3.0.0
         */ this.pointerLockChange = NOOP;
                        /**
         * Are the event listeners hooked into `window.top` or `window`?
         *
         * This is set during the `boot` sequence. If the browser does not have access to `window.top`,
         * such as in cross-origin iframe environments, this property gets set to `false` and the events
         * are hooked into `window` instead.
         *
         * @name Phaser.Input.Mouse.MouseManager#isTop
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isTop = true;
                        inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                    },
                    /**
     * The Touch Manager boot process.
     *
     * @method Phaser.Input.Mouse.MouseManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                        var config = this.manager.config;
                        this.enabled = config.inputMouse;
                        this.target = config.inputMouseEventTarget;
                        this.passive = config.inputMousePassive;
                        this.preventDefaultDown = config.inputMousePreventDefaultDown;
                        this.preventDefaultUp = config.inputMousePreventDefaultUp;
                        this.preventDefaultMove = config.inputMousePreventDefaultMove;
                        this.preventDefaultWheel = config.inputMousePreventDefaultWheel;
                        if (!this.target) this.target = this.manager.game.canvas;
                        else if (typeof this.target === 'string') this.target = document.getElementById(this.target);
                        if (config.disableContextMenu) this.disableContextMenu();
                        if (this.enabled && this.target) this.startListeners();
                    },
                    /**
     * Attempts to disable the context menu from appearing if you right-click on the game canvas, or specified input target.
     *
     * Works by listening for the `contextmenu` event and prevent defaulting it.
     *
     * Use this if you need to enable right-button mouse support in your game, and the context
     * menu keeps getting in the way.
     *
     * @method Phaser.Input.Mouse.MouseManager#disableContextMenu
     * @since 3.0.0
     *
     * @return {this} This Mouse Manager instance.
     */ disableContextMenu: function() {
                        this.target.addEventListener('contextmenu', function(event) {
                            event.preventDefault();
                            return false;
                        });
                        return this;
                    },
                    /**
     * If the browser supports it, you can request that the pointer be locked to the browser window.
     *
     * This is classically known as 'FPS controls', where the pointer can't leave the browser until
     * the user presses an exit key.
     *
     * If the browser successfully enters a locked state, a `POINTER_LOCK_CHANGE_EVENT` will be dispatched,
     * from the games Input Manager, with an `isPointerLocked` property.
     *
     * It is important to note that pointer lock can only be enabled after an 'engagement gesture',
     * see: https://w3c.github.io/pointerlock/#dfn-engagement-gesture.
     *
     * Note for Firefox: There is a bug in certain Firefox releases that cause native DOM events like
     * `mousemove` to fire continuously when in pointer lock mode. You can get around this by setting
     * `this.preventDefaultMove` to `false` in this class. You may also need to do the same for
     * `preventDefaultDown` and/or `preventDefaultUp`. Please test combinations of these if you encounter
     * the error.
     *
     * @method Phaser.Input.Mouse.MouseManager#requestPointerLock
     * @since 3.0.0
     */ requestPointerLock: function() {
                        if (Features.pointerLock) {
                            var element = this.target;
                            element.requestPointerLock = element.requestPointerLock || element.mozRequestPointerLock || element.webkitRequestPointerLock;
                            element.requestPointerLock();
                        }
                    },
                    /**
     * If the browser supports pointer lock, this will request that the pointer lock is released. If
     * the browser successfully enters a locked state, a 'POINTER_LOCK_CHANGE_EVENT' will be
     * dispatched - from the game's input manager - with an `isPointerLocked` property.
     *
     * @method Phaser.Input.Mouse.MouseManager#releasePointerLock
     * @since 3.0.0
     */ releasePointerLock: function() {
                        if (Features.pointerLock) {
                            document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock;
                            document.exitPointerLock();
                        }
                    },
                    /**
     * Starts the Mouse Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Mouse.MouseManager#startListeners
     * @since 3.0.0
     */ startListeners: function() {
                        var target = this.target;
                        if (!target) return;
                        var _this = this;
                        var manager = this.manager;
                        var canvas = manager.canvas;
                        var autoFocus = window && window.focus && manager.game.config.autoFocus;
                        this.onMouseMove = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                                manager.onMouseMove(event);
                                if (_this.preventDefaultMove) event.preventDefault();
                            }
                        };
                        this.onMouseDown = function(event) {
                            if (autoFocus) window.focus();
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                                manager.onMouseDown(event);
                                if (_this.preventDefaultDown && event.target === canvas) event.preventDefault();
                            }
                        };
                        this.onMouseDownWindow = function(event) {
                            if (event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents) return;
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                            manager.onMouseDown(event);
                        };
                        this.onMouseUp = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                                manager.onMouseUp(event);
                                if (_this.preventDefaultUp && event.target === canvas) event.preventDefault();
                            }
                        };
                        this.onMouseUpWindow = function(event) {
                            if (event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents) return;
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                            manager.onMouseUp(event);
                        };
                        this.onMouseOver = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.setCanvasOver(event);
                        };
                        this.onMouseOut = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.setCanvasOut(event);
                        };
                        this.onMouseWheel = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.onMouseWheel(event);
                            if (_this.preventDefaultWheel && event.target === canvas) event.preventDefault();
                        };
                        var passive = {
                            passive: true
                        };
                        target.addEventListener('mousemove', this.onMouseMove);
                        target.addEventListener('mousedown', this.onMouseDown);
                        target.addEventListener('mouseup', this.onMouseUp);
                        target.addEventListener('mouseover', this.onMouseOver, passive);
                        target.addEventListener('mouseout', this.onMouseOut, passive);
                        if (this.preventDefaultWheel) target.addEventListener('wheel', this.onMouseWheel, {
                            passive: false
                        });
                        else target.addEventListener('wheel', this.onMouseWheel, passive);
                        if (window && manager.game.config.inputWindowEvents) try {
                            window.top.addEventListener('mousedown', this.onMouseDownWindow, passive);
                            window.top.addEventListener('mouseup', this.onMouseUpWindow, passive);
                        } catch (exception) {
                            window.addEventListener('mousedown', this.onMouseDownWindow, passive);
                            window.addEventListener('mouseup', this.onMouseUpWindow, passive);
                            this.isTop = false;
                        }
                        if (Features.pointerLock) {
                            this.pointerLockChange = function(event) {
                                var element = _this.target;
                                _this.locked = document.pointerLockElement === element || document.mozPointerLockElement === element || document.webkitPointerLockElement === element ? true : false;
                                manager.onPointerLockChange(event);
                            };
                            document.addEventListener('pointerlockchange', this.pointerLockChange, true);
                            document.addEventListener('mozpointerlockchange', this.pointerLockChange, true);
                            document.addEventListener('webkitpointerlockchange', this.pointerLockChange, true);
                        }
                        this.enabled = true;
                    },
                    /**
     * Stops the Mouse Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Mouse.MouseManager#stopListeners
     * @since 3.0.0
     */ stopListeners: function() {
                        var target = this.target;
                        target.removeEventListener('mousemove', this.onMouseMove);
                        target.removeEventListener('mousedown', this.onMouseDown);
                        target.removeEventListener('mouseup', this.onMouseUp);
                        target.removeEventListener('mouseover', this.onMouseOver);
                        target.removeEventListener('mouseout', this.onMouseOut);
                        if (window) {
                            target = this.isTop ? window.top : window;
                            target.removeEventListener('mousedown', this.onMouseDownWindow);
                            target.removeEventListener('mouseup', this.onMouseUpWindow);
                        }
                        if (Features.pointerLock) {
                            document.removeEventListener('pointerlockchange', this.pointerLockChange, true);
                            document.removeEventListener('mozpointerlockchange', this.pointerLockChange, true);
                            document.removeEventListener('webkitpointerlockchange', this.pointerLockChange, true);
                        }
                    },
                    /**
     * Destroys this Mouse Manager instance.
     *
     * @method Phaser.Input.Mouse.MouseManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.stopListeners();
                        this.target = null;
                        this.enabled = false;
                        this.manager = null;
                    }
                });
                module1.exports = MouseManager;
            /***/ },
            /***/ 87078: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Mouse
 */ /* eslint-disable */ module1.exports = {
                    MouseManager: __webpack_require__(85098)
                };
            /* eslint-enable */ /***/ },
            /***/ 36210: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var InputEvents = __webpack_require__(8214);
                var NOOP = __webpack_require__(29747);
                // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events
                // https://patrickhlauke.github.io/touch/tests/results/
                // https://www.html5rocks.com/en/mobile/touch/
                /**
 * @classdesc
 * The Touch Manager is a helper class that belongs to the Input Manager.
 *
 * Its role is to listen for native DOM Touch Events and then pass them onto the Input Manager for further processing.
 *
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically.
 *
 * @class TouchManager
 * @memberof Phaser.Input.Touch
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var TouchManager = new Class({
                    initialize: function TouchManager(inputManager) {
                        /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Touch.TouchManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = inputManager;
                        /**
         * If true the DOM events will have event.preventDefault applied to them, if false they will propagate fully.
         *
         * @name Phaser.Input.Touch.TouchManager#capture
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.capture = true;
                        /**
         * A boolean that controls if the Touch Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Touch.TouchManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.enabled = false;
                        /**
         * The Touch Event target, as defined in the Game Config.
         * Typically the canvas to which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Touch.TouchManager#target
         * @type {any}
         * @since 3.0.0
         */ this.target;
                        /**
         * The Touch Start event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchStart
         * @type {function}
         * @since 3.0.0
         */ this.onTouchStart = NOOP;
                        /**
         * The Touch Start event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchStartWindow
         * @type {function}
         * @since 3.17.0
         */ this.onTouchStartWindow = NOOP;
                        /**
         * The Touch Move event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchMove
         * @type {function}
         * @since 3.0.0
         */ this.onTouchMove = NOOP;
                        /**
         * The Touch End event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchEnd
         * @type {function}
         * @since 3.0.0
         */ this.onTouchEnd = NOOP;
                        /**
         * The Touch End event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchEndWindow
         * @type {function}
         * @since 3.17.0
         */ this.onTouchEndWindow = NOOP;
                        /**
         * The Touch Cancel event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchCancel
         * @type {function}
         * @since 3.15.0
         */ this.onTouchCancel = NOOP;
                        /**
         * The Touch Cancel event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchCancelWindow
         * @type {function}
         * @since 3.18.0
         */ this.onTouchCancelWindow = NOOP;
                        /**
         * Are the event listeners hooked into `window.top` or `window`?
         *
         * This is set during the `boot` sequence. If the browser does not have access to `window.top`,
         * such as in cross-origin iframe environments, this property gets set to `false` and the events
         * are hooked into `window` instead.
         *
         * @name Phaser.Input.Touch.TouchManager#isTop
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isTop = true;
                        inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                    },
                    /**
     * The Touch Manager boot process.
     *
     * @method Phaser.Input.Touch.TouchManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                        var config = this.manager.config;
                        this.enabled = config.inputTouch;
                        this.target = config.inputTouchEventTarget;
                        this.capture = config.inputTouchCapture;
                        if (!this.target) this.target = this.manager.game.canvas;
                        else if (typeof this.target === 'string') this.target = document.getElementById(this.target);
                        if (config.disableContextMenu) this.disableContextMenu();
                        if (this.enabled && this.target) this.startListeners();
                    },
                    /**
     * Attempts to disable the context menu from appearing if you touch-hold on the browser.
     *
     * Works by listening for the `contextmenu` event and prevent defaulting it.
     *
     * Use this if you need to disable the OS context menu on mobile.
     *
     * @method Phaser.Input.Touch.TouchManager#disableContextMenu
     * @since 3.20.0
     *
     * @return {this} This Touch Manager instance.
     */ disableContextMenu: function() {
                        this.target.addEventListener('contextmenu', function(event) {
                            event.preventDefault();
                            return false;
                        });
                        return this;
                    },
                    /**
     * Starts the Touch Event listeners running as long as an input target is set.
     *
     * This method is called automatically if Touch Input is enabled in the game config,
     * which it is by default. However, you can call it manually should you need to
     * delay input capturing until later in the game.
     *
     * @method Phaser.Input.Touch.TouchManager#startListeners
     * @since 3.0.0
     */ startListeners: function() {
                        var target = this.target;
                        if (!target) return;
                        var _this = this;
                        var manager = this.manager;
                        var canvas = manager.canvas;
                        var autoFocus = window && window.focus && manager.game.config.autoFocus;
                        this.onTouchMove = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                                manager.onTouchMove(event);
                                if (_this.capture && event.cancelable) event.preventDefault();
                            }
                        };
                        this.onTouchStart = function(event) {
                            if (autoFocus) window.focus();
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                                manager.onTouchStart(event);
                                if (_this.capture && event.cancelable && event.target === canvas) event.preventDefault();
                            }
                        };
                        this.onTouchStartWindow = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                            manager.onTouchStart(event);
                        };
                        this.onTouchEnd = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                                manager.onTouchEnd(event);
                                if (_this.capture && event.cancelable && event.target === canvas) event.preventDefault();
                            }
                        };
                        this.onTouchEndWindow = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                            manager.onTouchEnd(event);
                        };
                        this.onTouchCancel = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                                manager.onTouchCancel(event);
                                if (_this.capture) event.preventDefault();
                            }
                        };
                        this.onTouchCancelWindow = function(event) {
                            if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.onTouchCancel(event);
                        };
                        var capture = this.capture;
                        var passive = {
                            passive: true
                        };
                        var nonPassive = {
                            passive: false
                        };
                        target.addEventListener('touchstart', this.onTouchStart, capture ? nonPassive : passive);
                        target.addEventListener('touchmove', this.onTouchMove, capture ? nonPassive : passive);
                        target.addEventListener('touchend', this.onTouchEnd, capture ? nonPassive : passive);
                        target.addEventListener('touchcancel', this.onTouchCancel, capture ? nonPassive : passive);
                        if (window && manager.game.config.inputWindowEvents) try {
                            window.top.addEventListener('touchstart', this.onTouchStartWindow, nonPassive);
                            window.top.addEventListener('touchend', this.onTouchEndWindow, nonPassive);
                            window.top.addEventListener('touchcancel', this.onTouchCancelWindow, nonPassive);
                        } catch (exception) {
                            window.addEventListener('touchstart', this.onTouchStartWindow, nonPassive);
                            window.addEventListener('touchend', this.onTouchEndWindow, nonPassive);
                            window.addEventListener('touchcancel', this.onTouchCancelWindow, nonPassive);
                            this.isTop = false;
                        }
                        this.enabled = true;
                    },
                    /**
     * Stops the Touch Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Touch.TouchManager#stopListeners
     * @since 3.0.0
     */ stopListeners: function() {
                        var target = this.target;
                        target.removeEventListener('touchstart', this.onTouchStart);
                        target.removeEventListener('touchmove', this.onTouchMove);
                        target.removeEventListener('touchend', this.onTouchEnd);
                        target.removeEventListener('touchcancel', this.onTouchCancel);
                        if (window) {
                            target = this.isTop ? window.top : window;
                            target.removeEventListener('touchstart', this.onTouchStartWindow);
                            target.removeEventListener('touchend', this.onTouchEndWindow);
                            target.removeEventListener('touchcancel', this.onTouchCancelWindow);
                        }
                    },
                    /**
     * Destroys this Touch Manager instance.
     *
     * @method Phaser.Input.Touch.TouchManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.stopListeners();
                        this.target = null;
                        this.enabled = false;
                        this.manager = null;
                    }
                });
                module1.exports = TouchManager;
            /***/ },
            /***/ 95618: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Touch
 */ /* eslint-disable */ module1.exports = {
                    TouchManager: __webpack_require__(36210)
                };
            /* eslint-enable */ /***/ },
            /***/ 41299: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var Events = __webpack_require__(54899);
                var GetFastValue = __webpack_require__(95540);
                var GetURL = __webpack_require__(98356);
                var MergeXHRSettings = __webpack_require__(3374);
                var XHRLoader = __webpack_require__(84376);
                var XHRSettings = __webpack_require__(92638);
                /**
 * @classdesc
 * The base File class used by all File Types that the Loader can support.
 * You shouldn't create an instance of a File directly, but should extend it with your own class, setting a custom type and processing methods.
 *
 * @class File
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
 * @param {Phaser.Types.Loader.FileConfig} fileConfig - The file configuration object, as created by the file type.
 */ var File = new Class({
                    initialize: function File(loader, fileConfig) {
                        /**
         * A reference to the Loader that is going to load this file.
         *
         * @name Phaser.Loader.File#loader
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.0.0
         */ this.loader = loader;
                        /**
         * A reference to the Cache, or Texture Manager, that is going to store this file if it loads.
         *
         * @name Phaser.Loader.File#cache
         * @type {(Phaser.Cache.BaseCache|Phaser.Textures.TextureManager)}
         * @since 3.7.0
         */ this.cache = GetFastValue(fileConfig, 'cache', false);
                        /**
         * The file type string (image, json, etc) for sorting within the Loader.
         *
         * @name Phaser.Loader.File#type
         * @type {string}
         * @since 3.0.0
         */ this.type = GetFastValue(fileConfig, 'type', false);
                        if (!this.type) throw new Error('Invalid File type: ' + this.type);
                        /**
         * Unique cache key (unique within its file type)
         *
         * @name Phaser.Loader.File#key
         * @type {string}
         * @since 3.0.0
         */ this.key = GetFastValue(fileConfig, 'key', false);
                        var loadKey = this.key;
                        if (loader.prefix && loader.prefix !== '') this.key = loader.prefix + loadKey;
                        if (!this.key) throw new Error('Invalid File key: ' + this.key);
                        var url = GetFastValue(fileConfig, 'url');
                        if (url === undefined) url = loader.path + loadKey + '.' + GetFastValue(fileConfig, 'extension', '');
                        else if (typeof url === 'string' && !url.match(/^(?:blob:|data:|capacitor:\/\/|http:\/\/|https:\/\/|\/\/)/)) url = loader.path + url;
                        /**
         * The URL of the file, not including baseURL.
         *
         * Automatically has Loader.path prepended to it if a string.
         *
         * Can also be a JavaScript Object, such as the results of parsing JSON data.
         *
         * @name Phaser.Loader.File#url
         * @type {object|string}
         * @since 3.0.0
         */ this.url = url;
                        /**
         * The final URL this file will load from, including baseURL and path.
         * Set automatically when the Loader calls 'load' on this file.
         *
         * @name Phaser.Loader.File#src
         * @type {string}
         * @since 3.0.0
         */ this.src = '';
                        /**
         * The merged XHRSettings for this file.
         *
         * @name Phaser.Loader.File#xhrSettings
         * @type {Phaser.Types.Loader.XHRSettingsObject}
         * @since 3.0.0
         */ this.xhrSettings = XHRSettings(GetFastValue(fileConfig, 'responseType', undefined));
                        if (GetFastValue(fileConfig, 'xhrSettings', false)) this.xhrSettings = MergeXHRSettings(this.xhrSettings, GetFastValue(fileConfig, 'xhrSettings', {}));
                        /**
         * The XMLHttpRequest instance (as created by XHR Loader) that is loading this File.
         *
         * @name Phaser.Loader.File#xhrLoader
         * @type {?XMLHttpRequest}
         * @since 3.0.0
         */ this.xhrLoader = null;
                        /**
         * The current state of the file. One of the FILE_CONST values.
         *
         * @name Phaser.Loader.File#state
         * @type {number}
         * @since 3.0.0
         */ this.state = typeof this.url === 'function' ? CONST.FILE_POPULATED : CONST.FILE_PENDING;
                        /**
         * The total size of this file.
         * Set by onProgress and only if loading via XHR.
         *
         * @name Phaser.Loader.File#bytesTotal
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.bytesTotal = 0;
                        /**
         * Updated as the file loads.
         * Only set if loading via XHR.
         *
         * @name Phaser.Loader.File#bytesLoaded
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.bytesLoaded = -1;
                        /**
         * A percentage value between 0 and 1 indicating how much of this file has loaded.
         * Only set if loading via XHR.
         *
         * @name Phaser.Loader.File#percentComplete
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.percentComplete = -1;
                        /**
         * For CORs based loading.
         * If this is undefined then the File will check BaseLoader.crossOrigin and use that (if set)
         *
         * @name Phaser.Loader.File#crossOrigin
         * @type {(string|undefined)}
         * @since 3.0.0
         */ this.crossOrigin = undefined;
                        /**
         * The processed file data, stored here after the file has loaded.
         *
         * @name Phaser.Loader.File#data
         * @type {*}
         * @since 3.0.0
         */ this.data = undefined;
                        /**
         * A config object that can be used by file types to store transitional data.
         *
         * @name Phaser.Loader.File#config
         * @type {*}
         * @since 3.0.0
         */ this.config = GetFastValue(fileConfig, 'config', {});
                        /**
         * If this is a multipart file, i.e. an atlas and its json together, then this is a reference
         * to the parent MultiFile. Set and used internally by the Loader or specific file types.
         *
         * @name Phaser.Loader.File#multiFile
         * @type {?Phaser.Loader.MultiFile}
         * @since 3.7.0
         */ this.multiFile;
                        /**
         * Does this file have an associated linked file? Such as an image and a normal map.
         * Atlases and Bitmap Fonts use the multiFile, because those files need loading together but aren't
         * actually bound by data, where-as a linkFile is.
         *
         * @name Phaser.Loader.File#linkFile
         * @type {?Phaser.Loader.File}
         * @since 3.7.0
         */ this.linkFile;
                        /**
         * Does this File contain a data URI?
         *
         * @name Phaser.Loader.File#base64
         * @type {boolean}
         * @since 3.80.0
         */ this.base64 = typeof url === 'string' && url.indexOf('data:') === 0;
                        /**
         * The counter for the number of times to retry loading this file before it fails.
         * 
         * You can set this property value in the FileConfig object. If not present,
         * this property is read from the `LoaderPlugin.maxRetries` property when
         * this File instance is created.
         * 
         * You can set this value via the Game Config, or you can adjust the `LoaderPlugin` property
         * at any point after the Loader has started. However, it will not apply to files
         * that have already been added to the Loader, only those added after this value
         * is changed.
         *
         * @name Phaser.Loader.File#retryAttempts
         * @type {number}
         * @default 2
         * @since 3.85.0
         */ this.retryAttempts = GetFastValue(fileConfig, 'maxRetries', loader.maxRetries);
                    },
                    /**
     * Links this File with another, so they depend upon each other for loading and processing.
     *
     * @method Phaser.Loader.File#setLink
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} fileB - The file to link to this one.
     */ setLink: function(fileB) {
                        this.linkFile = fileB;
                        fileB.linkFile = this;
                    },
                    /**
     * Resets the XHRLoader instance this file is using.
     *
     * @method Phaser.Loader.File#resetXHR
     * @since 3.0.0
     */ resetXHR: function() {
                        if (this.xhrLoader) {
                            this.xhrLoader.onload = undefined;
                            this.xhrLoader.onerror = undefined;
                            this.xhrLoader.onprogress = undefined;
                        }
                    },
                    /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.File#load
     * @since 3.0.0
     */ load: function() {
                        if (this.state === CONST.FILE_POPULATED) //  Can happen for example in a JSONFile if they've provided a JSON object instead of a URL
                        this.loader.nextFile(this, true);
                        else {
                            this.state = CONST.FILE_LOADING;
                            this.src = GetURL(this, this.loader.baseURL);
                            if (!this.src) throw new Error('URL Error in File: ' + this.key + ' from: ' + this.url);
                            if (this.src.indexOf('data:') === 0) this.base64 = true;
                            this.xhrLoader = XHRLoader(this, this.loader.xhr);
                        }
                    },
                    /**
     * Called when the file finishes loading, is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onLoad
     * @since 3.0.0
     *
     * @param {XMLHttpRequest} xhr - The XMLHttpRequest that caused this onload event.
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
     */ onLoad: function(xhr, event) {
                        var isLocalFile = xhr.responseURL && this.loader.localSchemes.some(function(scheme) {
                            return xhr.responseURL.indexOf(scheme) === 0;
                        });
                        var localFileOk = isLocalFile && event.target.status === 0;
                        var success = !(event.target && event.target.status !== 200) || localFileOk;
                        //  Handle HTTP status codes of 4xx and 5xx as errors, even if xhr.onerror was not called.
                        if (xhr.readyState === 4 && xhr.status >= 400 && xhr.status <= 599) success = false;
                        this.state = CONST.FILE_LOADED;
                        this.resetXHR();
                        this.loader.nextFile(this, success);
                    },
                    /**
     * Called by the XHRLoader if it was given a File with base64 data to load.
     *
     * @method Phaser.Loader.File#onBase64Load
     * @since 3.80.0
     *
     * @param {XMLHttpRequest} xhr - The FakeXHR object containing the decoded base64 data.
     */ onBase64Load: function(xhr) {
                        this.xhrLoader = xhr;
                        this.state = CONST.FILE_LOADED;
                        this.percentComplete = 1;
                        this.loader.emit(Events.FILE_PROGRESS, this, this.percentComplete);
                        this.loader.nextFile(this, true);
                    },
                    /**
     * Called if the file errors while loading, is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onError
     * @since 3.0.0
     *
     * @param {XMLHttpRequest} xhr - The XMLHttpRequest that caused this onload event.
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this error.
     */ onError: function() {
                        this.resetXHR();
                        if (this.retryAttempts > 0) {
                            this.retryAttempts--;
                            this.load();
                        } else this.loader.nextFile(this, false);
                    },
                    /**
     * Called during the file load progress. Is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onProgress
     * @fires Phaser.Loader.Events#FILE_PROGRESS
     * @since 3.0.0
     *
     * @param {ProgressEvent} event - The DOM ProgressEvent.
     */ onProgress: function(event) {
                        if (event.lengthComputable) {
                            this.bytesLoaded = event.loaded;
                            this.bytesTotal = event.total;
                            this.percentComplete = Math.min(this.bytesLoaded / this.bytesTotal, 1);
                            this.loader.emit(Events.FILE_PROGRESS, this, this.percentComplete);
                        }
                    },
                    /**
     * Usually overridden by the FileTypes and is called by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data, for example a JSON file will parse itself during this stage.
     *
     * @method Phaser.Loader.File#onProcess
     * @since 3.0.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.onProcessComplete();
                    },
                    /**
     * Called when the File has completed processing.
     * Checks on the state of its multifile, if set.
     *
     * @method Phaser.Loader.File#onProcessComplete
     * @since 3.7.0
     */ onProcessComplete: function() {
                        this.state = CONST.FILE_COMPLETE;
                        if (this.multiFile) this.multiFile.onFileComplete(this);
                        this.loader.fileProcessComplete(this);
                    },
                    /**
     * Called when the File has completed processing but it generated an error.
     * Checks on the state of its multifile, if set.
     *
     * @method Phaser.Loader.File#onProcessError
     * @since 3.7.0
     */ onProcessError: function() {
                        // eslint-disable-next-line no-console
                        console.error('Failed to process file: %s "%s"', this.type, this.key);
                        this.state = CONST.FILE_ERRORED;
                        if (this.multiFile) this.multiFile.onFileFailed(this);
                        this.loader.fileProcessComplete(this);
                    },
                    /**
     * Checks if a key matching the one used by this file exists in the target Cache or not.
     * This is called automatically by the LoaderPlugin to decide if the file can be safely
     * loaded or will conflict.
     *
     * @method Phaser.Loader.File#hasCacheConflict
     * @since 3.7.0
     *
     * @return {boolean} `true` if adding this file will cause a conflict, otherwise `false`.
     */ hasCacheConflict: function() {
                        return this.cache && this.cache.exists(this.key);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     * This method is often overridden by specific file types.
     *
     * @method Phaser.Loader.File#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.cache && this.data) this.cache.add(this.key, this.data);
                    },
                    /**
     * Called once the file has been added to its cache and is now ready for deletion from the Loader.
     * It will emit a `filecomplete` event from the LoaderPlugin.
     *
     * @method Phaser.Loader.File#pendingDestroy
     * @fires Phaser.Loader.Events#FILE_COMPLETE
     * @fires Phaser.Loader.Events#FILE_KEY_COMPLETE
     * @since 3.7.0
     */ pendingDestroy: function(data) {
                        if (this.state === CONST.FILE_PENDING_DESTROY) return;
                        if (data === undefined) data = this.data;
                        var key = this.key;
                        var type = this.type;
                        this.loader.emit(Events.FILE_COMPLETE, key, type, data);
                        this.loader.emit(Events.FILE_KEY_COMPLETE + type + '-' + key, key, type, data);
                        this.loader.flagForRemoval(this);
                        this.state = CONST.FILE_PENDING_DESTROY;
                    },
                    /**
     * Destroy this File and any references it holds.
     *
     * @method Phaser.Loader.File#destroy
     * @since 3.7.0
     */ destroy: function() {
                        this.loader = null;
                        this.cache = null;
                        this.xhrSettings = null;
                        this.multiFile = null;
                        this.linkFile = null;
                        this.data = null;
                    }
                });
                /**
 * Static method for creating object URL using URL API and setting it as image 'src' attribute.
 * If URL API is not supported (usually on old browsers) it falls back to creating Base64 encoded url using FileReader.
 *
 * @method Phaser.Loader.File.createObjectURL
 * @static
 * @since 3.7.0
 *
 * @param {HTMLImageElement} image - Image object which 'src' attribute should be set to object URL.
 * @param {Blob} blob - A Blob object to create an object URL for.
 * @param {string} defaultType - Default mime type used if blob type is not available.
 */ File.createObjectURL = function(image, blob, defaultType) {
                    if (typeof URL === 'function') image.src = URL.createObjectURL(blob);
                    else {
                        var reader = new FileReader();
                        reader.onload = function() {
                            image.removeAttribute('crossOrigin');
                            image.src = 'data:' + (blob.type || defaultType) + ';base64,' + reader.result.split(',')[1];
                        };
                        reader.onerror = image.onerror;
                        reader.readAsDataURL(blob);
                    }
                };
                /**
 * Static method for releasing an existing object URL which was previously created
 * by calling {@link Phaser.Loader.File.createObjectURL} method.
 *
 * @method Phaser.Loader.File.revokeObjectURL
 * @static
 * @since 3.7.0
 *
 * @param {HTMLImageElement} image - Image object which 'src' attribute should be revoked.
 */ File.revokeObjectURL = function(image) {
                    if (typeof URL === 'function') URL.revokeObjectURL(image.src);
                };
                module1.exports = File;
            /***/ },
            /***/ 74099: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var types = {};
                /**
 * @namespace Phaser.Loader.FileTypesManager
 */ var FileTypesManager = {
                    /**
     * Static method called when a LoaderPlugin is created.
     *
     * Loops through the local types object and injects all of them as
     * properties into the LoaderPlugin instance.
     *
     * @method Phaser.Loader.FileTypesManager.install
     * @since 3.0.0
     *
     * @param {Phaser.Loader.LoaderPlugin} loader - The LoaderPlugin to install the types into.
     */ install: function(loader) {
                        for(var key in types)loader[key] = types[key];
                    },
                    /**
     * Static method called directly by the File Types.
     *
     * The key is a reference to the function used to load the files via the Loader, i.e. `image`.
     *
     * @method Phaser.Loader.FileTypesManager.register
     * @since 3.0.0
     *
     * @param {string} key - The key that will be used as the method name in the LoaderPlugin.
     * @param {function} factoryFunction - The function that will be called when LoaderPlugin.key is invoked.
     */ register: function(key, factoryFunction) {
                        types[key] = factoryFunction;
                    },
                    /**
     * Removed all associated file types.
     *
     * @method Phaser.Loader.FileTypesManager.destroy
     * @since 3.0.0
     */ destroy: function() {
                        types = {};
                    }
                };
                module1.exports = FileTypesManager;
            /***/ },
            /***/ 98356: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given a File and a baseURL value this returns the URL the File will use to download from.
 *
 * @function Phaser.Loader.GetURL
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - The File object.
 * @param {string} baseURL - A default base URL.
 *
 * @return {string} The URL the File will use.
 */ var GetURL = function(file, baseURL) {
                    if (!file.url) return false;
                    if (file.url.match(/^(?:blob:|data:|capacitor:\/\/|http:\/\/|https:\/\/|\/\/)/)) return file.url;
                    else return baseURL + file.url;
                };
                module1.exports = GetURL;
            /***/ },
            /***/ 74261: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var CustomSet = __webpack_require__(35072);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(54899);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var IsPlainObject = __webpack_require__(41212);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                var XHRSettings = __webpack_require__(92638);
                /**
 * @classdesc
 * The Loader handles loading all external content such as Images, Sounds, Texture Atlases and data files.
 * You typically interact with it via `this.load` in your Scene. Scenes can have a `preload` method, which is always
 * called before the Scenes `create` method, allowing you to preload assets that the Scene may need.
 *
 * If you call any `this.load` methods from outside of `Scene.preload` then you need to start the Loader going
 * yourself by calling `Loader.start()`. It's only automatically started during the Scene preload.
 *
 * The Loader uses a combination of tag loading (eg. Audio elements) and XHR and provides progress and completion events.
 * Files are loaded in parallel by default. The amount of concurrent connections can be controlled in your Game Configuration.
 *
 * Once the Loader has started loading you are still able to add files to it. These can be injected as a result of a loader
 * event, the type of file being loaded (such as a pack file) or other external events. As long as the Loader hasn't finished
 * simply adding a new file to it, while running, will ensure it's added into the current queue.
 *
 * Every Scene has its own instance of the Loader and they are bound to the Scene in which they are created. However,
 * assets loaded by the Loader are placed into global game-level caches. For example, loading an XML file will place that
 * file inside `Game.cache.xml`, which is accessible from every Scene in your game, no matter who was responsible
 * for loading it. The same is true of Textures. A texture loaded in one Scene is instantly available to all other Scenes
 * in your game.
 *
 * The Loader works by using custom File Types. These are stored in the FileTypesManager, which injects them into the Loader
 * when it's instantiated. You can create your own custom file types by extending either the File or MultiFile classes.
 * See those files for more details.
 *
 * @class LoaderPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Loader instance.
 */ var LoaderPlugin = new Class({
                    Extends: EventEmitter,
                    initialize: function LoaderPlugin(scene) {
                        EventEmitter.call(this);
                        var gameConfig = scene.sys.game.config;
                        var sceneConfig = scene.sys.settings.loader;
                        /**
         * The Scene which owns this Loader instance.
         *
         * @name Phaser.Loader.LoaderPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene Systems.
         *
         * @name Phaser.Loader.LoaderPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * A reference to the global Cache Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#cacheManager
         * @type {Phaser.Cache.CacheManager}
         * @since 3.7.0
         */ this.cacheManager = scene.sys.cache;
                        /**
         * A reference to the global Texture Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.7.0
         */ this.textureManager = scene.sys.textures;
                        /**
         * A reference to the global Scene Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#sceneManager
         * @type {Phaser.Scenes.SceneManager}
         * @protected
         * @since 3.16.0
         */ this.sceneManager = scene.sys.game.scene;
                        //  Inject the available filetypes into the Loader
                        FileTypesManager.install(this);
                        /**
         * An optional prefix that is automatically prepended to the start of every file key.
         * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
         * You can set this directly, or call `Loader.setPrefix()`. It will then affect every file added to the Loader
         * from that point on. It does _not_ change any file already in the load queue.
         *
         * @name Phaser.Loader.LoaderPlugin#prefix
         * @type {string}
         * @default ''
         * @since 3.7.0
         */ this.prefix = '';
                        /**
         * The value of `path`, if set, is placed before any _relative_ file path given. For example:
         *
         * ```javascript
         * this.load.path = "images/sprites/";
         * this.load.image("ball", "ball.png");
         * this.load.image("tree", "level1/oaktree.png");
         * this.load.image("boom", "http://server.com/explode.png");
         * ```
         *
         * Would load the `ball` file from `images/sprites/ball.png` and the tree from
         * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
         * given as it's an absolute URL.
         *
         * Please note that the path is added before the filename but *after* the baseURL (if set.)
         *
         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setPath()` and it'll do it for you.
         *
         * @name Phaser.Loader.LoaderPlugin#path
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.path = '';
                        /**
         * If you want to append a URL before the path of any asset you can set this here.
         *
         * Useful if allowing the asset base url to be configured outside of the game code.
         *
         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setBaseURL()` and it'll do it for you.
         *
         * @name Phaser.Loader.LoaderPlugin#baseURL
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.baseURL = '';
                        this.setBaseURL(GetFastValue(sceneConfig, 'baseURL', gameConfig.loaderBaseURL));
                        this.setPath(GetFastValue(sceneConfig, 'path', gameConfig.loaderPath));
                        this.setPrefix(GetFastValue(sceneConfig, 'prefix', gameConfig.loaderPrefix));
                        /**
         * The number of concurrent / parallel resources to try and fetch at once.
         *
         * Old browsers limit 6 requests per domain; modern ones, especially those with HTTP/2 don't limit it at all.
         *
         * The default is 32 but you can change this in your Game Config, or by changing this property before the Loader starts.
         *
         * @name Phaser.Loader.LoaderPlugin#maxParallelDownloads
         * @type {number}
         * @since 3.0.0
         */ this.maxParallelDownloads = GetFastValue(sceneConfig, 'maxParallelDownloads', gameConfig.loaderMaxParallelDownloads);
                        /**
         * xhr specific global settings (can be overridden on a per-file basis)
         *
         * @name Phaser.Loader.LoaderPlugin#xhr
         * @type {Phaser.Types.Loader.XHRSettingsObject}
         * @since 3.0.0
         */ this.xhr = XHRSettings(GetFastValue(sceneConfig, 'responseType', gameConfig.loaderResponseType), GetFastValue(sceneConfig, 'async', gameConfig.loaderAsync), GetFastValue(sceneConfig, 'user', gameConfig.loaderUser), GetFastValue(sceneConfig, 'password', gameConfig.loaderPassword), GetFastValue(sceneConfig, 'timeout', gameConfig.loaderTimeout), GetFastValue(sceneConfig, 'withCredentials', gameConfig.loaderWithCredentials));
                        /**
         * The crossOrigin value applied to loaded images. Very often this needs to be set to 'anonymous'.
         *
         * @name Phaser.Loader.LoaderPlugin#crossOrigin
         * @type {string}
         * @since 3.0.0
         */ this.crossOrigin = GetFastValue(sceneConfig, 'crossOrigin', gameConfig.loaderCrossOrigin);
                        /**
         * Optional load type for image files. `XHR` is the default. Set to `HTMLImageElement` to load images using the Image tag instead.
         *
         * @name Phaser.Loader.LoaderPlugin#imageLoadType
         * @type {string}
         * @since 3.60.0
         */ this.imageLoadType = GetFastValue(sceneConfig, 'imageLoadType', gameConfig.loaderImageLoadType);
                        /**
         * An array of all schemes that the Loader considers as being 'local'.
         *
         * This is populated by the `Phaser.Core.Config#loaderLocalScheme` game configuration setting and defaults to
         * `[ 'file://', 'capacitor://' ]`. Additional local schemes can be added to this array as needed.
         *
         * @name Phaser.Loader.LoaderPlugin#localSchemes
         * @type {string[]}
         * @since 3.60.0
         */ this.localSchemes = GetFastValue(sceneConfig, 'localScheme', gameConfig.loaderLocalScheme);
                        /**
         * The total number of files to load. It may not always be accurate because you may add to the Loader during the process
         * of loading, especially if you load a Pack File. Therefore this value can change, but in most cases remains static.
         *
         * @name Phaser.Loader.LoaderPlugin#totalToLoad
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalToLoad = 0;
                        /**
         * The progress of the current load queue, as a float value between 0 and 1.
         * This is updated automatically as files complete loading.
         * Note that it is possible for this value to go down again if you add content to the current load queue during a load.
         *
         * @name Phaser.Loader.LoaderPlugin#progress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.progress = 0;
                        /**
         * Files are placed in this Set when they're added to the Loader via `addFile`.
         *
         * They are moved to the `inflight` Set when they start loading, and assuming a successful
         * load, to the `queue` Set for further processing.
         *
         * By the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#list
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.list = new CustomSet();
                        /**
         * Files are stored in this Set while they're in the process of being loaded.
         *
         * Upon a successful load they are moved to the `queue` Set.
         *
         * By the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#inflight
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.inflight = new CustomSet();
                        /**
         * Files are stored in this Set while they're being processed.
         *
         * If the process is successful they are moved to their final destination, which could be
         * a Cache or the Texture Manager.
         *
         * At the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#queue
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.queue = new CustomSet();
                        /**
         * A temporary Set in which files are stored after processing,
         * awaiting destruction at the end of the load process.
         *
         * @name Phaser.Loader.LoaderPlugin#_deleteQueue
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @private
         * @since 3.7.0
         */ this._deleteQueue = new CustomSet();
                        /**
         * The total number of files that failed to load during the most recent load.
         * This value is reset when you call `Loader.start`.
         *
         * @name Phaser.Loader.LoaderPlugin#totalFailed
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.totalFailed = 0;
                        /**
         * The total number of files that successfully loaded during the most recent load.
         * This value is reset when you call `Loader.start`.
         *
         * @name Phaser.Loader.LoaderPlugin#totalComplete
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.totalComplete = 0;
                        /**
         * The current state of the Loader.
         *
         * @name Phaser.Loader.LoaderPlugin#state
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.state = CONST.LOADER_IDLE;
                        /**
         * The current index being used by multi-file loaders to avoid key clashes.
         *
         * @name Phaser.Loader.LoaderPlugin#multiKeyIndex
         * @type {number}
         * @private
         * @since 3.20.0
         */ this.multiKeyIndex = 0;
                        /**
         * The number of times to retry loading a single file before it fails.
         * 
         * This property is read by the `File` object when it is created and set to
         * the internal property of the same name. It's not used by the Loader itself.
         * 
         * You can set this value via the Game Config, or you can adjust this property
         * at any point after the Loader has started. However, it will not apply to files
         * that have already been added to the Loader, only those added after this value
         * is changed.
         *
         * @name Phaser.Loader.LoaderPlugin#maxRetries
         * @type {number}
         * @default 2
         * @since 3.85.0
         */ this.maxRetries = GetFastValue(sceneConfig, 'maxRetries', gameConfig.loaderMaxRetries);
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.pluginStart, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Loader.LoaderPlugin#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Loader.LoaderPlugin#pluginStart
     * @private
     * @since 3.5.1
     */ pluginStart: function() {
                        this.systems.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * If you want to append a URL before the path of any asset you can set this here.
     *
     * Useful if allowing the asset base url to be configured outside of the game code.
     *
     * Once a base URL is set it will affect every file loaded by the Loader from that point on. It does _not_ change any
     * file _already_ being loaded. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setBaseURL
     * @since 3.0.0
     *
     * @param {string} [url] - The URL to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setBaseURL: function(url) {
                        if (url === undefined) url = '';
                        if (url !== '' && url.substr(-1) !== '/') url = url.concat('/');
                        this.baseURL = url;
                        return this;
                    },
                    /**
     * The value of `path`, if set, is placed before any _relative_ file path given. For example:
     *
     * ```javascript
     * this.load.setPath("images/sprites/");
     * this.load.image("ball", "ball.png");
     * this.load.image("tree", "level1/oaktree.png");
     * this.load.image("boom", "http://server.com/explode.png");
     * ```
     *
     * Would load the `ball` file from `images/sprites/ball.png` and the tree from
     * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
     * given as it's an absolute URL.
     *
     * Please note that the path is added before the filename but *after* the baseURL (if set.)
     *
     * Once a path is set it will then affect every file added to the Loader from that point on. It does _not_ change any
     * file _already_ in the load queue. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setPath
     * @since 3.0.0
     *
     * @param {string} [path] - The path to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setPath: function(path) {
                        if (path === undefined) path = '';
                        if (path !== '' && path.substr(-1) !== '/') path = path.concat('/');
                        this.path = path;
                        return this;
                    },
                    /**
     * An optional prefix that is automatically prepended to the start of every file key.
     *
     * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
     *
     * Once a prefix is set it will then affect every file added to the Loader from that point on. It does _not_ change any
     * file _already_ in the load queue. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setPrefix
     * @since 3.7.0
     *
     * @param {string} [prefix] - The prefix to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setPrefix: function(prefix) {
                        if (prefix === undefined) prefix = '';
                        this.prefix = prefix;
                        return this;
                    },
                    /**
     * Sets the Cross Origin Resource Sharing value used when loading files.
     *
     * Files can override this value on a per-file basis by specifying an alternative `crossOrigin` value in their file config.
     *
     * Once CORs is set it will then affect every file loaded by the Loader from that point on, as long as they don't have
     * their own CORs setting. To reset it, call this method with no arguments.
     *
     * For more details about CORs see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
     *
     * @method Phaser.Loader.LoaderPlugin#setCORS
     * @since 3.0.0
     *
     * @param {string} [crossOrigin] - The value to use for the `crossOrigin` property in the load request.
     *
     * @return {this} This Loader object.
     */ setCORS: function(crossOrigin) {
                        this.crossOrigin = crossOrigin;
                        return this;
                    },
                    /**
     * Adds a file, or array of files, into the load queue.
     *
     * The file must be an instance of `Phaser.Loader.File`, or a class that extends it. The Loader will check that the key
     * used by the file won't conflict with any other key either in the loader, the inflight queue or the target cache.
     * If allowed it will then add the file into the pending list, read for the load to start. Or, if the load has already
     * started, ready for the next batch of files to be pulled from the list to the inflight queue.
     *
     * You should not normally call this method directly, but rather use one of the Loader methods like `image` or `atlas`,
     * however you can call this as long as the file given to it is well formed.
     *
     * @method Phaser.Loader.LoaderPlugin#addFile
     * @fires Phaser.Loader.Events#ADD
     * @since 3.0.0
     *
     * @param {(Phaser.Loader.File|Phaser.Loader.File[])} file - The file, or array of files, to be added to the load queue.
     */ addFile: function(file) {
                        if (!Array.isArray(file)) file = [
                            file
                        ];
                        for(var i = 0; i < file.length; i++){
                            var item = file[i];
                            //  Does the file already exist in the cache or texture manager?
                            //  Or will it conflict with a file already in the queue or inflight?
                            if (!this.keyExists(item)) {
                                this.list.set(item);
                                this.emit(Events.ADD, item.key, item.type, this, item);
                                if (this.isLoading()) {
                                    this.totalToLoad++;
                                    this.updateProgress();
                                }
                            }
                        }
                    },
                    /**
     * Checks the key and type of the given file to see if it will conflict with anything already
     * in a Cache, the Texture Manager, or the list or inflight queues.
     *
     * @method Phaser.Loader.LoaderPlugin#keyExists
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The file to check the key of.
     *
     * @return {boolean} `true` if adding this file will cause a cache or queue conflict, otherwise `false`.
     */ keyExists: function(file) {
                        var keyConflict = file.hasCacheConflict();
                        if (!keyConflict) this.list.iterate(function(item) {
                            if (item.type === file.type && item.key === file.key) {
                                keyConflict = true;
                                return false;
                            }
                        });
                        if (!keyConflict && this.isLoading()) {
                            this.inflight.iterate(function(item) {
                                if (item.type === file.type && item.key === file.key) {
                                    keyConflict = true;
                                    return false;
                                }
                            });
                            this.queue.iterate(function(item) {
                                if (item.type === file.type && item.key === file.key) {
                                    keyConflict = true;
                                    return false;
                                }
                            });
                        }
                        return keyConflict;
                    },
                    /**
     * Takes a well formed, fully parsed pack file object and adds its entries into the load queue. Usually you do not call
     * this method directly, but instead use `Loader.pack` and supply a path to a JSON file that holds the
     * pack data. However, if you've got the data prepared you can pass it to this method.
     *
     * You can also provide an optional key. If you do then it will only add the entries from that part of the pack into
     * to the load queue. If not specified it will add all entries it finds. For more details about the pack file format
     * see the `LoaderPlugin.pack` method.
     *
     * @method Phaser.Loader.LoaderPlugin#addPack
     * @since 3.7.0
     *
     * @param {any} pack - The Pack File data to be parsed and each entry of it to added to the load queue.
     * @param {string} [packKey] - An optional key to use from the pack file data.
     *
     * @return {boolean} `true` if any files were added to the queue, otherwise `false`.
     */ addPack: function(pack, packKey) {
                        //  if no packKey provided we'll add everything to the queue
                        if (typeof packKey === 'string') {
                            var subPack = GetValue(pack, packKey);
                            if (subPack) pack = {
                                packKey: subPack
                            };
                        }
                        var total = 0;
                        //  Store the loader settings in case this pack replaces them
                        var currentBaseURL = this.baseURL;
                        var currentPath = this.path;
                        var currentPrefix = this.prefix;
                        //  Here we go ...
                        for(var key in pack){
                            if (!Object.prototype.hasOwnProperty.call(pack, key)) continue;
                            var config = pack[key];
                            //  Any meta data to process?
                            var baseURL = GetFastValue(config, 'baseURL', currentBaseURL);
                            var path = GetFastValue(config, 'path', currentPath);
                            var prefix = GetFastValue(config, 'prefix', currentPrefix);
                            var files = GetFastValue(config, 'files', null);
                            var defaultType = GetFastValue(config, 'defaultType', 'void');
                            if (Array.isArray(files)) {
                                this.setBaseURL(baseURL);
                                this.setPath(path);
                                this.setPrefix(prefix);
                                for(var i = 0; i < files.length; i++){
                                    var file = files[i];
                                    var type = file.hasOwnProperty('type') ? file.type : defaultType;
                                    if (this[type]) {
                                        this[type](file);
                                        total++;
                                    }
                                }
                            }
                        }
                        //  Reset the loader settings
                        this.setBaseURL(currentBaseURL);
                        this.setPath(currentPath);
                        this.setPrefix(currentPrefix);
                        return total > 0;
                    },
                    /**
     * Remove the resources listed in an Asset Pack.
     *
     * This removes Animations from the Animation Manager, Textures from the Texture Manager, and all other assets from their respective caches.
     * It doesn't remove the Pack itself from the JSON cache, if it exists there.
     * If the Pack includes another Pack, its resources will be removed too.
     *
     * @method Phaser.Loader.LoaderPlugin#removePack
     * @since 3.85.0
     *
     * @param {(string|object)} packKey - The key of an Asset Pack in the JSON cache, or a Pack File data.
     * @param {string} [dataKey] - A key in the Pack data, if you want to process only a section of it.
     */ removePack: function(packKey, dataKey) {
                        var animationManager = this.systems.anims;
                        var cacheManager = this.cacheManager;
                        var textureManager = this.textureManager;
                        var cacheMap = {
                            animation: 'json',
                            aseprite: 'json',
                            audio: 'audio',
                            audioSprite: 'audio',
                            binary: 'binary',
                            bitmapFont: 'bitmapFont',
                            css: null,
                            glsl: 'shader',
                            html: 'html',
                            json: 'json',
                            obj: 'obj',
                            plugin: null,
                            scenePlugin: null,
                            script: null,
                            spine: 'json',
                            text: 'text',
                            tilemapCSV: 'tilemap',
                            tilemapImpact: 'tilemap',
                            tilemapTiledJSON: 'tilemap',
                            video: 'video',
                            xml: 'xml'
                        };
                        var pack;
                        if (IsPlainObject(packKey)) pack = packKey;
                        else {
                            pack = cacheManager.json.get(packKey);
                            if (!pack) {
                                console.warn('Asset Pack not found in JSON cache:', packKey);
                                return;
                            }
                        }
                        if (dataKey) pack = {
                            _: pack[dataKey]
                        };
                        for(var configKey in pack){
                            var config = pack[configKey];
                            var prefix = GetFastValue(config, 'prefix', '');
                            var files = GetFastValue(config, 'files');
                            var defaultType = GetFastValue(config, 'defaultType');
                            if (Array.isArray(files)) for(var i = 0; i < files.length; i++){
                                var file = files[i];
                                var type = file.hasOwnProperty('type') ? file.type : defaultType;
                                if (!type) {
                                    console.warn('No type:', file);
                                    continue;
                                }
                                var fileKey = prefix + file.key;
                                if (type === 'animation') animationManager.remove(fileKey);
                                if (type === 'aseprite' || type === 'atlas' || type === 'atlasXML' || type === 'htmlTexture' || type === 'image' || type === 'multiatlas' || type === 'spritesheet' || type === 'svg' || type === 'texture' || type === 'unityAtlas') {
                                    textureManager.remove(fileKey);
                                    if (!cacheMap[type]) continue;
                                }
                                if (type === 'pack') {
                                    this.removePack(fileKey, file.dataKey);
                                    continue;
                                }
                                if (type === 'spine') {
                                    var spineAtlas = cacheManager.custom.spine.get(fileKey);
                                    if (!spineAtlas) continue;
                                    var spinePrefix = spineAtlas.prefix === undefined ? '' : spineAtlas.prefix;
                                    cacheManager.custom.spine.remove(fileKey);
                                    var spineTexture = cacheManager.custom.spineTextures.get(fileKey);
                                    if (!spineTexture) continue;
                                    cacheManager.custom.spineTextures.remove(fileKey);
                                    for(var j = 0; j < spineTexture.pages.length; j++){
                                        var page = spineTexture.pages[j];
                                        var textureKey = spinePrefix + page.name;
                                        var altTextureKey = fileKey + ':' + textureKey;
                                        if (textureManager.exists(altTextureKey)) textureManager.remove(altTextureKey);
                                        else textureManager.remove(textureKey);
                                    }
                                }
                                var cacheName = cacheMap[type];
                                if (cacheName === null) continue;
                                if (!cacheName) {
                                    console.warn('Unknown type:', type);
                                    continue;
                                }
                                var cache = cacheManager[cacheName];
                                cache.remove(fileKey);
                            }
                        }
                    },
                    /**
     * Is the Loader actively loading, or processing loaded files?
     *
     * @method Phaser.Loader.LoaderPlugin#isLoading
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Loader is busy loading or processing, otherwise `false`.
     */ isLoading: function() {
                        return this.state === CONST.LOADER_LOADING || this.state === CONST.LOADER_PROCESSING;
                    },
                    /**
     * Is the Loader ready to start a new load?
     *
     * @method Phaser.Loader.LoaderPlugin#isReady
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Loader is ready to start a new load, otherwise `false`.
     */ isReady: function() {
                        return this.state === CONST.LOADER_IDLE || this.state === CONST.LOADER_COMPLETE;
                    },
                    /**
     * Starts the Loader running. This will reset the progress and totals and then emit a `start` event.
     * If there is nothing in the queue the Loader will immediately complete, otherwise it will start
     * loading the first batch of files.
     *
     * The Loader is started automatically if the queue is populated within your Scenes `preload` method.
     *
     * However, outside of this, you need to call this method to start it.
     *
     * If the Loader is already running this method will simply return.
     *
     * @method Phaser.Loader.LoaderPlugin#start
     * @fires Phaser.Loader.Events#START
     * @since 3.0.0
     */ start: function() {
                        if (!this.isReady()) return;
                        this.progress = 0;
                        this.totalFailed = 0;
                        this.totalComplete = 0;
                        this.totalToLoad = this.list.size;
                        this.emit(Events.START, this);
                        if (this.list.size === 0) this.loadComplete();
                        else {
                            this.state = CONST.LOADER_LOADING;
                            this.inflight.clear();
                            this.queue.clear();
                            this.updateProgress();
                            this.checkLoadQueue();
                            this.systems.events.on(SceneEvents.UPDATE, this.update, this);
                        }
                    },
                    /**
     * Called automatically during the load process.
     * It updates the `progress` value and then emits a progress event, which you can use to
     * display a loading bar in your game.
     *
     * @method Phaser.Loader.LoaderPlugin#updateProgress
     * @fires Phaser.Loader.Events#PROGRESS
     * @since 3.0.0
     */ updateProgress: function() {
                        this.progress = 1 - (this.list.size + this.inflight.size) / this.totalToLoad;
                        this.emit(Events.PROGRESS, this.progress);
                    },
                    /**
     * Called automatically during the load process.
     *
     * @method Phaser.Loader.LoaderPlugin#update
     * @since 3.10.0
     */ update: function() {
                        if (this.state === CONST.LOADER_LOADING && this.list.size > 0 && this.inflight.size < this.maxParallelDownloads) this.checkLoadQueue();
                    },
                    /**
     * An internal method called by the Loader.
     *
     * It will check to see if there are any more files in the pending list that need loading, and if so it will move
     * them from the list Set into the inflight Set, set their CORs flag and start them loading.
     *
     * It will carrying on doing this for each file in the pending list until it runs out, or hits the max allowed parallel downloads.
     *
     * @method Phaser.Loader.LoaderPlugin#checkLoadQueue
     * @private
     * @since 3.7.0
     */ checkLoadQueue: function() {
                        this.list.each(function(file) {
                            if (file.state === CONST.FILE_POPULATED || file.state === CONST.FILE_PENDING && this.inflight.size < this.maxParallelDownloads) {
                                this.inflight.set(file);
                                this.list.delete(file);
                                //  If the file doesn't have its own crossOrigin set, we'll use the Loaders (which is undefined by default)
                                if (!file.crossOrigin) file.crossOrigin = this.crossOrigin;
                                file.load();
                            }
                            if (this.inflight.size === this.maxParallelDownloads) //  Tells the Set iterator to abort
                            return false;
                        }, this);
                    },
                    /**
     * An internal method called automatically by the XHRLoader belonging to a File.
     *
     * This method will remove the given file from the inflight Set and update the load progress.
     * If the file was successful its `onProcess` method is called, otherwise it is added to the delete queue.
     *
     * @method Phaser.Loader.LoaderPlugin#nextFile
     * @fires Phaser.Loader.Events#FILE_LOAD
     * @fires Phaser.Loader.Events#FILE_LOAD_ERROR
     * @since 3.0.0
     *
     * @param {Phaser.Loader.File} file - The File that just finished loading, or errored during load.
     * @param {boolean} success - `true` if the file loaded successfully, otherwise `false`.
     */ nextFile: function(file, success) {
                        //  Has the game been destroyed during load? If so, bail out now.
                        if (!this.inflight) return;
                        this.inflight.delete(file);
                        this.updateProgress();
                        if (success) {
                            this.totalComplete++;
                            this.queue.set(file);
                            this.emit(Events.FILE_LOAD, file);
                            file.onProcess();
                        } else {
                            this.totalFailed++;
                            this._deleteQueue.set(file);
                            this.emit(Events.FILE_LOAD_ERROR, file);
                            this.fileProcessComplete(file);
                        }
                    },
                    /**
     * An internal method that is called automatically by the File when it has finished processing.
     *
     * If the process was successful, and the File isn't part of a MultiFile, its `addToCache` method is called.
     *
     * It this then removed from the queue. If there are no more files to load `loadComplete` is called.
     *
     * @method Phaser.Loader.LoaderPlugin#fileProcessComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The file that has finished processing.
     */ fileProcessComplete: function(file) {
                        //  Has the game been destroyed during load? If so, bail out now.
                        if (!this.scene || !this.systems || !this.systems.game || this.systems.game.pendingDestroy) return;
                        //  This file has failed, so move it to the failed Set
                        if (file.state === CONST.FILE_ERRORED) {
                            if (file.multiFile) file.multiFile.onFileFailed(file);
                        } else if (file.state === CONST.FILE_COMPLETE) {
                            if (file.multiFile) {
                                if (file.multiFile.isReadyToProcess()) {
                                    //  If we got here then all files the link file needs are ready to add to the cache
                                    file.multiFile.addToCache();
                                    file.multiFile.pendingDestroy();
                                }
                            } else {
                                //  If we got here, then the file processed, so let it add itself to its cache
                                file.addToCache();
                                file.pendingDestroy();
                            }
                        }
                        //  Remove it from the queue
                        this.queue.delete(file);
                        //  Nothing left to do?
                        if (this.list.size === 0 && this.inflight.size === 0 && this.queue.size === 0) this.loadComplete();
                    },
                    /**
     * Called at the end when the load queue is exhausted and all files have either loaded or errored.
     * By this point every loaded file will now be in its associated cache and ready for use.
     *
     * Also clears down the Sets, puts progress to 1 and clears the deletion queue.
     *
     * @method Phaser.Loader.LoaderPlugin#loadComplete
     * @fires Phaser.Loader.Events#COMPLETE
     * @fires Phaser.Loader.Events#POST_PROCESS
     * @since 3.7.0
     */ loadComplete: function() {
                        this.emit(Events.POST_PROCESS, this);
                        this.list.clear();
                        this.inflight.clear();
                        this.queue.clear();
                        this.progress = 1;
                        this.state = CONST.LOADER_COMPLETE;
                        this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                        //  Call 'destroy' on each file ready for deletion
                        this._deleteQueue.iterateLocal('destroy');
                        this._deleteQueue.clear();
                        this.emit(Events.COMPLETE, this, this.totalComplete, this.totalFailed);
                    },
                    /**
     * Adds a File into the pending-deletion queue.
     *
     * @method Phaser.Loader.LoaderPlugin#flagForRemoval
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File to be queued for deletion when the Loader completes.
     */ flagForRemoval: function(file) {
                        this._deleteQueue.set(file);
                    },
                    /**
     * Converts the given JSON data into a file that the browser then prompts you to download so you can save it locally.
     *
     * The data must be well formed JSON and ready-parsed, not a JavaScript object.
     *
     * @method Phaser.Loader.LoaderPlugin#saveJSON
     * @since 3.0.0
     *
     * @param {*} data - The JSON data, ready parsed.
     * @param {string} [filename=file.json] - The name to save the JSON file as.
     *
     * @return {this} This Loader plugin.
     */ saveJSON: function(data, filename) {
                        return this.save(JSON.stringify(data), filename);
                    },
                    /**
     * Causes the browser to save the given data as a file to its default Downloads folder.
     *
     * Creates a DOM level anchor link, assigns it as being a `download` anchor, sets the href
     * to be an ObjectURL based on the given data, and then invokes a click event.
     *
     * @method Phaser.Loader.LoaderPlugin#save
     * @since 3.0.0
     *
     * @param {*} data - The data to be saved. Will be passed through URL.createObjectURL.
     * @param {string} [filename=file.json] - The filename to save the file as.
     * @param {string} [filetype=application/json] - The file type to use when saving the file. Defaults to JSON.
     *
     * @return {this} This Loader plugin.
     */ save: function(data, filename, filetype) {
                        if (filename === undefined) filename = 'file.json';
                        if (filetype === undefined) filetype = 'application/json';
                        var blob = new Blob([
                            data
                        ], {
                            type: filetype
                        });
                        var url = URL.createObjectURL(blob);
                        var a = document.createElement('a');
                        a.download = filename;
                        a.textContent = 'Download ' + filename;
                        a.href = url;
                        a.click();
                        return this;
                    },
                    /**
     * Resets the Loader.
     *
     * This will clear all lists and reset the base URL, path and prefix.
     *
     * Warning: If the Loader is currently downloading files, or has files in its queue, they will be aborted.
     *
     * @method Phaser.Loader.LoaderPlugin#reset
     * @since 3.0.0
     */ reset: function() {
                        this.list.clear();
                        this.inflight.clear();
                        this.queue.clear();
                        var gameConfig = this.systems.game.config;
                        var sceneConfig = this.systems.settings.loader;
                        this.setBaseURL(GetFastValue(sceneConfig, 'baseURL', gameConfig.loaderBaseURL));
                        this.setPath(GetFastValue(sceneConfig, 'path', gameConfig.loaderPath));
                        this.setPrefix(GetFastValue(sceneConfig, 'prefix', gameConfig.loaderPrefix));
                        this.state = CONST.LOADER_IDLE;
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Loader.LoaderPlugin#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        this.reset();
                        this.state = CONST.LOADER_SHUTDOWN;
                        this.removeAllListeners();
                        this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                        this.systems.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Loader.LoaderPlugin#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.state = CONST.LOADER_DESTROYED;
                        this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                        this.systems.events.off(SceneEvents.START, this.pluginStart, this);
                        this.list = null;
                        this.inflight = null;
                        this.queue = null;
                        this.scene = null;
                        this.systems = null;
                        this.textureManager = null;
                        this.cacheManager = null;
                        this.sceneManager = null;
                    }
                });
                PluginCache.register('Loader', LoaderPlugin, 'load');
                module1.exports = LoaderPlugin;
            /***/ },
            /***/ 3374: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(79291);
                var XHRSettings = __webpack_require__(92638);
                /**
 * Takes two XHRSettings Objects and creates a new XHRSettings object from them.
 *
 * The new object is seeded by the values given in the global settings, but any setting in
 * the local object overrides the global ones.
 *
 * @function Phaser.Loader.MergeXHRSettings
 * @since 3.0.0
 *
 * @param {Phaser.Types.Loader.XHRSettingsObject} global - The global XHRSettings object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} local - The local XHRSettings object.
 *
 * @return {Phaser.Types.Loader.XHRSettingsObject} A newly formed XHRSettings object.
 */ var MergeXHRSettings = function(global, local) {
                    var output = global === undefined ? XHRSettings() : Extend({}, global);
                    if (local) {
                        for(var setting in local)if (local[setting] !== undefined) output[setting] = local[setting];
                    }
                    return output;
                };
                module1.exports = MergeXHRSettings;
            /***/ },
            /***/ 26430: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var Events = __webpack_require__(54899);
                /**
 * @classdesc
 * A MultiFile is a special kind of parent that contains two, or more, Files as children and looks after
 * the loading and processing of them all. It is commonly extended and used as a base class for file types such as AtlasJSON or BitmapFont.
 *
 * You shouldn't create an instance of a MultiFile directly, but should extend it with your own class, setting a custom type and processing methods.
 *
 * @class MultiFile
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
 * @param {string} type - The file type string for sorting within the Loader.
 * @param {string} key - The key of the file within the loader.
 * @param {Phaser.Loader.File[]} files - An array of Files that make-up this MultiFile.
 */ var MultiFile = new Class({
                    initialize: function MultiFile(loader, type, key, files) {
                        var finalFiles = [];
                        //  Clean out any potential 'null' or 'undefined' file entries
                        files.forEach(function(file) {
                            if (file) finalFiles.push(file);
                        });
                        /**
         * A reference to the Loader that is going to load this file.
         *
         * @name Phaser.Loader.MultiFile#loader
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.7.0
         */ this.loader = loader;
                        /**
         * The file type string for sorting within the Loader.
         *
         * @name Phaser.Loader.MultiFile#type
         * @type {string}
         * @since 3.7.0
         */ this.type = type;
                        /**
         * Unique cache key (unique within its file type)
         *
         * @name Phaser.Loader.MultiFile#key
         * @type {string}
         * @since 3.7.0
         */ this.key = key;
                        var loadKey = this.key;
                        if (loader.prefix && loader.prefix !== '') this.key = loader.prefix + loadKey;
                        /**
         * The current index being used by multi-file loaders to avoid key clashes.
         *
         * @name Phaser.Loader.MultiFile#multiKeyIndex
         * @type {number}
         * @private
         * @since 3.20.0
         */ this.multiKeyIndex = loader.multiKeyIndex++;
                        /**
         * Array of files that make up this MultiFile.
         *
         * @name Phaser.Loader.MultiFile#files
         * @type {Phaser.Loader.File[]}
         * @since 3.7.0
         */ this.files = finalFiles;
                        /**
         * The current state of the file. One of the FILE_CONST values.
         *
         * @name Phaser.Loader.MultiFile#state
         * @type {number}
         * @since 3.60.0
         */ this.state = CONST.FILE_PENDING;
                        /**
         * The completion status of this MultiFile.
         *
         * @name Phaser.Loader.MultiFile#complete
         * @type {boolean}
         * @default false
         * @since 3.7.0
         */ this.complete = false;
                        /**
         * The number of files to load.
         *
         * @name Phaser.Loader.MultiFile#pending
         * @type {number}
         * @since 3.7.0
         */ this.pending = finalFiles.length;
                        /**
         * The number of files that failed to load.
         *
         * @name Phaser.Loader.MultiFile#failed
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.failed = 0;
                        /**
         * A storage container for transient data that the loading files need.
         *
         * @name Phaser.Loader.MultiFile#config
         * @type {any}
         * @since 3.7.0
         */ this.config = {};
                        /**
         * A reference to the Loaders baseURL at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#baseURL
         * @type {string}
         * @since 3.20.0
         */ this.baseURL = loader.baseURL;
                        /**
         * A reference to the Loaders path at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#path
         * @type {string}
         * @since 3.20.0
         */ this.path = loader.path;
                        /**
         * A reference to the Loaders prefix at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#prefix
         * @type {string}
         * @since 3.20.0
         */ this.prefix = loader.prefix;
                        //  Link the files
                        for(var i = 0; i < finalFiles.length; i++)finalFiles[i].multiFile = this;
                    },
                    /**
     * Checks if this MultiFile is ready to process its children or not.
     *
     * @method Phaser.Loader.MultiFile#isReadyToProcess
     * @since 3.7.0
     *
     * @return {boolean} `true` if all children of this MultiFile have loaded, otherwise `false`.
     */ isReadyToProcess: function() {
                        return this.pending === 0 && this.failed === 0 && !this.complete;
                    },
                    /**
     * Adds another child to this MultiFile, increases the pending count and resets the completion status.
     *
     * @method Phaser.Loader.MultiFile#addToMultiFile
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} files - The File to add to this MultiFile.
     *
     * @return {Phaser.Loader.MultiFile} This MultiFile instance.
     */ addToMultiFile: function(file) {
                        this.files.push(file);
                        file.multiFile = this;
                        this.pending++;
                        this.complete = false;
                        return this;
                    },
                    /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.MultiFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                        var index = this.files.indexOf(file);
                        if (index !== -1) this.pending--;
                    },
                    /**
     * Called by each File that fails to load.
     *
     * @method Phaser.Loader.MultiFile#onFileFailed
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has failed to load.
     */ onFileFailed: function(file) {
                        var index = this.files.indexOf(file);
                        if (index !== -1) {
                            this.failed++;
                            // eslint-disable-next-line no-console
                            console.error('File failed: %s "%s" (via %s "%s")', this.type, this.key, file.type, file.key);
                        }
                    },
                    /**
     * Called once all children of this multi file have been added to their caches and is now
     * ready for deletion from the Loader.
     *
     * It will emit a `filecomplete` event from the LoaderPlugin.
     *
     * @method Phaser.Loader.MultiFile#pendingDestroy
     * @fires Phaser.Loader.Events#FILE_COMPLETE
     * @fires Phaser.Loader.Events#FILE_KEY_COMPLETE
     * @since 3.60.0
     */ pendingDestroy: function() {
                        if (this.state === CONST.FILE_PENDING_DESTROY) return;
                        var key = this.key;
                        var type = this.type;
                        this.loader.emit(Events.FILE_COMPLETE, key, type);
                        this.loader.emit(Events.FILE_KEY_COMPLETE + type + '-' + key, key, type);
                        this.loader.flagForRemoval(this);
                        for(var i = 0; i < this.files.length; i++)this.files[i].pendingDestroy();
                        this.state = CONST.FILE_PENDING_DESTROY;
                    },
                    /**
     * Destroy this Multi File and any references it holds.
     *
     * @method Phaser.Loader.MultiFile#destroy
     * @since 3.60.0
     */ destroy: function() {
                        this.loader = null;
                        this.files = null;
                        this.config = null;
                    }
                });
                module1.exports = MultiFile;
            /***/ },
            /***/ 84376: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MergeXHRSettings = __webpack_require__(3374);
                /**
 * Creates a new XMLHttpRequest (xhr) object based on the given File and XHRSettings
 * and starts the download of it. It uses the Files own XHRSettings and merges them
 * with the global XHRSettings object to set the xhr values before download.
 *
 * @function Phaser.Loader.XHRLoader
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - The File to download.
 * @param {Phaser.Types.Loader.XHRSettingsObject} globalXHRSettings - The global XHRSettings object.
 *
 * @return {XMLHttpRequest} The XHR object, or a FakeXHR Object in the base of base64 data.
 */ var XHRLoader = function(file, globalXHRSettings) {
                    var config = MergeXHRSettings(globalXHRSettings, file.xhrSettings);
                    if (file.base64) {
                        var base64Data = file.url.split(';base64,').pop() || file.url.split(',').pop();
                        var fakeXHR = {
                            responseText: atob(base64Data)
                        };
                        file.onBase64Load(fakeXHR);
                        return;
                    }
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', file.src, config.async, config.user, config.password);
                    xhr.responseType = file.xhrSettings.responseType;
                    xhr.timeout = config.timeout;
                    if (config.headers) for(var key in config.headers)xhr.setRequestHeader(key, config.headers[key]);
                    if (config.header && config.headerValue) xhr.setRequestHeader(config.header, config.headerValue);
                    if (config.requestedWith) xhr.setRequestHeader('X-Requested-With', config.requestedWith);
                    if (config.overrideMimeType) xhr.overrideMimeType(config.overrideMimeType);
                    if (config.withCredentials) xhr.withCredentials = true;
                    // After a successful request, the xhr.response property will contain the requested data as a DOMString, ArrayBuffer, Blob, or Document (depending on what was set for responseType.)
                    xhr.onload = file.onLoad.bind(file, xhr);
                    xhr.onerror = file.onError.bind(file, xhr);
                    xhr.onprogress = file.onProgress.bind(file);
                    xhr.ontimeout = file.onError.bind(file, xhr);
                    //  This is the only standard method, the ones above are browser additions (maybe not universal?)
                    // xhr.onreadystatechange
                    xhr.send();
                    return xhr;
                };
                module1.exports = XHRLoader;
            /***/ },
            /***/ 92638: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates an XHRSettings Object with default values.
 *
 * @function Phaser.Loader.XHRSettings
 * @since 3.0.0
 *
 * @param {XMLHttpRequestResponseType} [responseType=''] - The responseType, such as 'text'.
 * @param {boolean} [async=true] - Should the XHR request use async or not?
 * @param {string} [user=''] - Optional username for the XHR request.
 * @param {string} [password=''] - Optional password for the XHR request.
 * @param {number} [timeout=0] - Optional XHR timeout value.
 * @param {boolean} [withCredentials=false] - Optional XHR withCredentials value.
 *
 * @return {Phaser.Types.Loader.XHRSettingsObject} The XHRSettings object as used by the Loader.
 */ var XHRSettings = function(responseType, async, user, password, timeout, withCredentials) {
                    if (responseType === undefined) responseType = '';
                    if (async === undefined) async = true;
                    if (user === undefined) user = '';
                    if (password === undefined) password = '';
                    if (timeout === undefined) timeout = 0;
                    if (withCredentials === undefined) withCredentials = false;
                    // Before sending a request, set the xhr.responseType to "text",
                    // "arraybuffer", "blob", or "document", depending on your data needs.
                    // Note, setting xhr.responseType = '' (or omitting) will default the response to "text".
                    return {
                        //  Ignored by the Loader, only used by File.
                        responseType: responseType,
                        async: async,
                        //  credentials
                        user: user,
                        password: password,
                        //  timeout in ms (0 = no timeout)
                        timeout: timeout,
                        //  setRequestHeader
                        headers: undefined,
                        header: undefined,
                        headerValue: undefined,
                        requestedWith: false,
                        //  overrideMimeType
                        overrideMimeType: undefined,
                        //  withCredentials
                        withCredentials: withCredentials
                    };
                };
                module1.exports = XHRSettings;
            /***/ },
            /***/ 23906: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FILE_CONST = {
                    /**
     * The Loader is idle.
     *
     * @name Phaser.Loader.LOADER_IDLE
     * @type {number}
     * @since 3.0.0
     */ LOADER_IDLE: 0,
                    /**
     * The Loader is actively loading.
     *
     * @name Phaser.Loader.LOADER_LOADING
     * @type {number}
     * @since 3.0.0
     */ LOADER_LOADING: 1,
                    /**
     * The Loader is processing files is has loaded.
     *
     * @name Phaser.Loader.LOADER_PROCESSING
     * @type {number}
     * @since 3.0.0
     */ LOADER_PROCESSING: 2,
                    /**
     * The Loader has completed loading and processing.
     *
     * @name Phaser.Loader.LOADER_COMPLETE
     * @type {number}
     * @since 3.0.0
     */ LOADER_COMPLETE: 3,
                    /**
     * The Loader is shutting down.
     *
     * @name Phaser.Loader.LOADER_SHUTDOWN
     * @type {number}
     * @since 3.0.0
     */ LOADER_SHUTDOWN: 4,
                    /**
     * The Loader has been destroyed.
     *
     * @name Phaser.Loader.LOADER_DESTROYED
     * @type {number}
     * @since 3.0.0
     */ LOADER_DESTROYED: 5,
                    /**
     * File is in the load queue but not yet started.
     *
     * @name Phaser.Loader.FILE_PENDING
     * @type {number}
     * @since 3.0.0
     */ FILE_PENDING: 10,
                    /**
     * File has been started to load by the loader (onLoad called)
     *
     * @name Phaser.Loader.FILE_LOADING
     * @type {number}
     * @since 3.0.0
     */ FILE_LOADING: 11,
                    /**
     * File has loaded successfully, awaiting processing.
     *
     * @name Phaser.Loader.FILE_LOADED
     * @type {number}
     * @since 3.0.0
     */ FILE_LOADED: 12,
                    /**
     * File failed to load.
     *
     * @name Phaser.Loader.FILE_FAILED
     * @type {number}
     * @since 3.0.0
     */ FILE_FAILED: 13,
                    /**
     * File is being processed (onProcess callback)
     *
     * @name Phaser.Loader.FILE_PROCESSING
     * @type {number}
     * @since 3.0.0
     */ FILE_PROCESSING: 14,
                    /**
     * The File has errored somehow during processing.
     *
     * @name Phaser.Loader.FILE_ERRORED
     * @type {number}
     * @since 3.0.0
     */ FILE_ERRORED: 16,
                    /**
     * File has finished processing.
     *
     * @name Phaser.Loader.FILE_COMPLETE
     * @type {number}
     * @since 3.0.0
     */ FILE_COMPLETE: 17,
                    /**
     * File has been destroyed.
     *
     * @name Phaser.Loader.FILE_DESTROYED
     * @type {number}
     * @since 3.0.0
     */ FILE_DESTROYED: 18,
                    /**
     * File was populated from local data and doesn't need an HTTP request.
     *
     * @name Phaser.Loader.FILE_POPULATED
     * @type {number}
     * @since 3.0.0
     */ FILE_POPULATED: 19,
                    /**
     * File is pending being destroyed.
     *
     * @name Phaser.Loader.FILE_PENDING_DESTROY
     * @type {number}
     * @since 3.60.0
     */ FILE_PENDING_DESTROY: 20
                };
                module1.exports = FILE_CONST;
            /***/ },
            /***/ 42155: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Add File Event.
 *
 * This event is dispatched when a new file is successfully added to the Loader and placed into the load queue.
 *
 * Listen to it from a Scene using: `this.load.on('addfile', listener)`.
 *
 * If you add lots of files to a Loader from a `preload` method, it will dispatch this event for each one of them.
 *
 * @event Phaser.Loader.Events#ADD
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The unique key of the file that was added to the Loader.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} string of the file that was added to the Loader, i.e. `image`.
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 * @param {Phaser.Loader.File} file - A reference to the File which was added to the Loader.
 */ module1.exports = 'addfile';
            /***/ },
            /***/ 38991: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Complete Event.
 *
 * This event is dispatched when the Loader has fully processed everything in the load queue.
 * By this point every loaded file will now be in its associated cache and ready for use.
 *
 * Listen to it from a Scene using: `this.load.on('complete', listener)`.
 *
 * @event Phaser.Loader.Events#COMPLETE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 * @param {number} totalComplete - The total number of files that successfully loaded.
 * @param {number} totalFailed - The total number of files that failed to load.
 */ module1.exports = 'complete';
            /***/ },
            /***/ 27540: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Complete Event.
 *
 * This event is dispatched by the Loader Plugin when _any_ file in the queue finishes loading.
 *
 * Listen to it from a Scene using: `this.load.on('filecomplete', listener)`.
 *
 * Make sure you remove this listener when you have finished, or it will continue to fire if the Scene reloads.
 *
 * You can also listen for the completion of a specific file. See the [FILE_KEY_COMPLETE]{@linkcode Phaser.Loader.Events#event:FILE_KEY_COMPLETE} event.
 *
 * @event Phaser.Loader.Events#FILE_COMPLETE
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the file that just loaded and finished processing.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} of the file that just loaded, i.e. `image`.
 * @param {any} [data] - The raw data the file contained. If the file was a multi-file, like an atlas or bitmap font, this parameter will be undefined.
 */ module1.exports = 'filecomplete';
            /***/ },
            /***/ 87464: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Complete Event.
 *
 * This event is dispatched by the Loader Plugin when any file in the queue finishes loading.
 *
 * It uses a special dynamic event name constructed from the key and type of the file.
 *
 * For example, if you have loaded an `image` with a key of `monster`, you can listen for it
 * using the following:
 *
 * ```javascript
 * this.load.on('filecomplete-image-monster', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 *
 * Or, if you have loaded a texture `atlas` with a key of `Level1`:
 *
 * ```javascript
 * this.load.on('filecomplete-atlasjson-Level1', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 *
 * Or, if you have loaded a sprite sheet with a key of `Explosion` and a prefix of `GAMEOVER`:
 *
 * ```javascript
 * this.load.on('filecomplete-spritesheet-GAMEOVERExplosion', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 *
 * Make sure you remove your listeners when you have finished, or they will continue to fire if the Scene reloads.
 *
 * You can also listen for the generic completion of files. See the [FILE_COMPLETE]{@linkcode Phaser.Loader.Events#event:FILE_COMPLETE} event.
 *
 * @event Phaser.Loader.Events#FILE_KEY_COMPLETE
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the file that just loaded and finished processing.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} of the file that just loaded, i.e. `image`.
 * @param {any} [data] - The raw data the file contained. If the file was a multi-file, like an atlas or bitmap font, this parameter will be undefined.
 */ module1.exports = 'filecomplete-';
            /***/ },
            /***/ 94486: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Error Event.
 *
 * This event is dispatched by the Loader Plugin when a file fails to load.
 *
 * Listen to it from a Scene using: `this.load.on('loaderror', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_LOAD_ERROR
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - A reference to the File which errored during load.
 */ module1.exports = 'loaderror';
            /***/ },
            /***/ 13035: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Event.
 *
 * This event is dispatched by the Loader Plugin when a file finishes loading,
 * but _before_ it is processed and added to the internal Phaser caches.
 *
 * Listen to it from a Scene using: `this.load.on('load', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_LOAD
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - A reference to the File which just finished loading.
 */ module1.exports = 'load';
            /***/ },
            /***/ 38144: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Progress Event.
 *
 * This event is dispatched by the Loader Plugin during the load of a file, if the browser receives a DOM ProgressEvent and
 * the `lengthComputable` event property is true. Depending on the size of the file and browser in use, this may, or may not happen.
 *
 * Listen to it from a Scene using: `this.load.on('fileprogress', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_PROGRESS
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - A reference to the File which errored during load.
 * @param {number} percentComplete - A value between 0 and 1 indicating how 'complete' this file is.
 */ module1.exports = 'fileprogress';
            /***/ },
            /***/ 97520: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Post Process Event.
 *
 * This event is dispatched by the Loader Plugin when the Loader has finished loading everything in the load queue.
 * It is dispatched before the internal lists are cleared and each File is destroyed.
 *
 * Use this hook to perform any last minute processing of files that can only happen once the
 * Loader has completed, but prior to it emitting the `complete` event.
 *
 * Listen to it from a Scene using: `this.load.on('postprocess', listener)`.
 *
 * @event Phaser.Loader.Events#POST_PROCESS
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 */ module1.exports = 'postprocess';
            /***/ },
            /***/ 85595: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Progress Event.
 *
 * This event is dispatched when the Loader updates its load progress, typically as a result of a file having completed loading.
 *
 * Listen to it from a Scene using: `this.load.on('progress', listener)`.
 *
 * @event Phaser.Loader.Events#PROGRESS
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} progress - The current progress of the load. A value between 0 and 1.
 */ module1.exports = 'progress';
            /***/ },
            /***/ 55680: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Start Event.
 *
 * This event is dispatched when the Loader starts running. At this point load progress is zero.
 *
 * This event is dispatched even if there aren't any files in the load queue.
 *
 * Listen to it from a Scene using: `this.load.on('start', listener)`.
 *
 * @event Phaser.Loader.Events#START
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 */ module1.exports = 'start';
            /***/ },
            /***/ 54899: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Loader.Events
 */ module1.exports = {
                    ADD: __webpack_require__(42155),
                    COMPLETE: __webpack_require__(38991),
                    FILE_COMPLETE: __webpack_require__(27540),
                    FILE_KEY_COMPLETE: __webpack_require__(87464),
                    FILE_LOAD_ERROR: __webpack_require__(94486),
                    FILE_LOAD: __webpack_require__(13035),
                    FILE_PROGRESS: __webpack_require__(38144),
                    POST_PROCESS: __webpack_require__(97520),
                    PROGRESS: __webpack_require__(85595),
                    START: __webpack_require__(55680)
                };
            /***/ },
            /***/ 14135: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var JSONFile = __webpack_require__(518);
                var LoaderEvents = __webpack_require__(54899);
                /**
 * @classdesc
 * A single Animation JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#animation method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#animation.
 *
 * @class AnimationJSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var AnimationJSONFile = new Class({
                    Extends: JSONFile,
                    initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                    //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                    function AnimationJSONFile(loader, key, url, xhrSettings, dataKey) {
                        JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
                        this.type = 'animationJSON';
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        //  We need to hook into this event:
                        this.loader.once(LoaderEvents.POST_PROCESS, this.onLoadComplete, this);
                        //  But the rest is the same as a normal JSON file
                        JSONFile.prototype.onProcess.call(this);
                    },
                    /**
     * Called at the end of the load process, after the Loader has finished all files in its queue.
     *
     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onLoadComplete
     * @since 3.7.0
     */ onLoadComplete: function() {
                        this.loader.systems.anims.fromJSON(this.data);
                    }
                });
                /**
 * Adds an Animation JSON Data file, or array of Animation JSON files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.animation('baddieAnims', 'files/BaddieAnims.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.animation({
 *     key: 'baddieAnims',
 *     url: 'files/BaddieAnims.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.JSONFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be passed to the global Animation Managers `fromJSON` method.
 * This will parse all of the JSON data and create animation data from it. This process happens at the very end
 * of the Loader, once every other file in the load queue has finished. The reason for this is to allow you to load
 * both animation data and the images it relies upon in the same load call.
 *
 * Once the animation data has been parsed you will be able to play animations using that data.
 * Please see the Animation Manager `fromJSON` method for more details about the format and playback.
 *
 * You can also access the raw animation data from its Cache using its key:
 *
 * ```javascript
 * this.load.animation('baddieAnims', 'files/BaddieAnims.json');
 * // and later in your game ...
 * var data = this.cache.json.get('baddieAnims');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And if you only wanted to create animations from the `boss` data, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#animation
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig|Phaser.Types.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [dataKey] - When the Animation JSON file loads only this property will be stored in the Cache and used to create animation data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('animation', function(key, url, dataKey, xhrSettings) {
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.addFile(new AnimationJSONFile(this, key[i]));
                    else this.addFile(new AnimationJSONFile(this, key, url, xhrSettings, dataKey));
                    return this;
                });
                module1.exports = AnimationJSONFile;
            /***/ },
            /***/ 76272: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var ImageFile = __webpack_require__(19550);
                var IsPlainObject = __webpack_require__(41212);
                var JSONFile = __webpack_require__(518);
                var MultiFile = __webpack_require__(26430);
                /**
 * @classdesc
 * A single JSON based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlas.
 *
 * https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm
 *
 * @class AsepriteFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AsepriteFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 */ var AsepriteFile = new Class({
                    Extends: MultiFile,
                    initialize: function AsepriteFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                        var image;
                        var data;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            image = new ImageFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'textureURL'),
                                extension: GetFastValue(config, 'textureExtension', 'png'),
                                normalMap: GetFastValue(config, 'normalMap'),
                                xhrSettings: GetFastValue(config, 'textureXhrSettings')
                            });
                            data = new JSONFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'atlasURL'),
                                extension: GetFastValue(config, 'atlasExtension', 'json'),
                                xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                            });
                        } else {
                            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                            data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                        }
                        if (image.linkFile) //  Image has a normal map
                        MultiFile.call(this, loader, 'atlasjson', key, [
                            image,
                            data,
                            image.linkFile
                        ]);
                        else MultiFile.call(this, loader, 'atlasjson', key, [
                            image,
                            data
                        ]);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AsepriteFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var image = this.files[0];
                            var json = this.files[1];
                            var normalMap = this.files[2] ? this.files[2].data : null;
                            this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);
                            json.addToCache();
                            this.complete = true;
                        }
                    }
                });
                /**
 * Aseprite is a powerful animated sprite editor and pixel art tool.
 *
 * You can find more details at https://www.aseprite.org/
 *
 * Adds a JSON based Aseprite Animation, or array of animations, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.aseprite('gladiator', 'images/Gladiator.png', 'images/Gladiator.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * To export a compatible JSON file in Aseprite, please do the following:
 *
 * 1. Go to "File - Export Sprite Sheet"
 *
 * 2. On the **Layout** tab:
 * 2a. Set the "Sheet type" to "Packed"
 * 2b. Set the "Constraints" to "None"
 * 2c. Check the "Merge Duplicates" checkbox
 *
 * 3. On the **Sprite** tab:
 * 3a. Set "Layers" to "Visible layers"
 * 3b. Set "Frames" to "All frames", unless you only wish to export a sub-set of tags
 *
 * 4. On the **Borders** tab:
 * 4a. Check the "Trim Sprite" and "Trim Cells" options
 * 4b. Ensure "Border Padding", "Spacing" and "Inner Padding" are all > 0 (1 is usually enough)
 *
 * 5. On the **Output** tab:
 * 5a. Check "Output File", give your image a name and make sure you choose "png files" as the file type
 * 5b. Check "JSON Data" and give your json file a name
 * 5c. The JSON Data type can be either a Hash or Array, Phaser doesn't mind.
 * 5d. Make sure "Tags" is checked in the Meta options
 * 5e. In the "Item Filename" input box, make sure it says just "{frame}" and nothing more.
 *
 * 6. Click export
 *
 * This was tested with Aseprite 1.2.25.
 *
 * This will export a png and json file which you can load using the Aseprite Loader, i.e.:
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.aseprite({
 *     key: 'gladiator',
 *     textureURL: 'images/Gladiator.png',
 *     atlasURL: 'images/Gladiator.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AsepriteFileConfig` for more details.
 *
 * Instead of passing a URL for the JSON data you can also pass in a well formed JSON object instead.
 *
 * Once loaded, you can call this method from within a Scene with the 'atlas' key:
 *
 * ```javascript
 * this.anims.createFromAseprite('paladin');
 * ```
 *
 * Any animations defined in the JSON will now be available to use in Phaser and you play them
 * via their Tag name. For example, if you have an animation called 'War Cry' on your Aseprite timeline,
 * you can play it in Phaser using that Tag name:
 *
 * ```javascript
 * this.add.sprite(400, 300).play('War Cry');
 * ```
 *
 * When calling this method you can optionally provide an array of tag names, and only those animations
 * will be created. For example:
 *
 * ```javascript
 * this.anims.createFromAseprite('paladin', [ 'step', 'War Cry', 'Magnum Break' ]);
 * ```
 *
 * This will only create the 3 animations defined. Note that the tag names are case-sensitive.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Aseprite File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#aseprite
 * @fires Phaser.Loader.Events#ADD
 * @since 3.50.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AsepriteFileConfig|Phaser.Types.Loader.FileTypes.AsepriteFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('aseprite', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new AsepriteFile(this, key[i]);
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new AsepriteFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = AsepriteFile;
            /***/ },
            /***/ 38734: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var ImageFile = __webpack_require__(19550);
                var IsPlainObject = __webpack_require__(41212);
                var JSONFile = __webpack_require__(518);
                var MultiFile = __webpack_require__(26430);
                /**
 * @classdesc
 * A single JSON based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlas.
 *
 * https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm
 *
 * @class AtlasJSONFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 */ var AtlasJSONFile = new Class({
                    Extends: MultiFile,
                    initialize: function AtlasJSONFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                        var image;
                        var data;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            image = new ImageFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'textureURL'),
                                extension: GetFastValue(config, 'textureExtension', 'png'),
                                normalMap: GetFastValue(config, 'normalMap'),
                                xhrSettings: GetFastValue(config, 'textureXhrSettings')
                            });
                            data = new JSONFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'atlasURL'),
                                extension: GetFastValue(config, 'atlasExtension', 'json'),
                                xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                            });
                        } else {
                            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                            data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                        }
                        if (image.linkFile) //  Image has a normal map
                        MultiFile.call(this, loader, 'atlasjson', key, [
                            image,
                            data,
                            image.linkFile
                        ]);
                        else MultiFile.call(this, loader, 'atlasjson', key, [
                            image,
                            data
                        ]);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AtlasJSONFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var image = this.files[0];
                            var json = this.files[1];
                            var normalMap = this.files[2] ? this.files[2].data : null;
                            this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds a JSON based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a JSON file, using either the JSON Hash or JSON Array format.
 *
 * These files are created by software such as:
 *
 * * [Texture Packer](https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm)
 * * [Shoebox](https://renderhjs.net/shoebox/)
 * * [Gamma Texture Packer](https://gammafp.com/tool/atlas-packer/)
 * * [Adobe Flash / Animate](https://www.adobe.com/uk/products/animate.html)
 * * [Free Texture Packer](http://free-tex-packer.com/)
 * * [Leshy SpriteSheet Tool](https://www.leshylabs.com/apps/sstool/)
 *
 * If you are using Texture Packer and have enabled multi-atlas support, then please use the Phaser Multi Atlas loader
 * instead of this one.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.atlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig` for more details.
 *
 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.atlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.json');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.atlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.json'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Atlas JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#atlas
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('atlas', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new AtlasJSONFile(this, key[i]);
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new AtlasJSONFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = AtlasJSONFile;
            /***/ },
            /***/ 74599: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var ImageFile = __webpack_require__(19550);
                var IsPlainObject = __webpack_require__(41212);
                var MultiFile = __webpack_require__(26430);
                var XMLFile = __webpack_require__(57318);
                /**
 * @classdesc
 * A single XML based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlasXML method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlasXML.
 *
 * @class AtlasXMLFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
 */ var AtlasXMLFile = new Class({
                    Extends: MultiFile,
                    initialize: function AtlasXMLFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                        var image;
                        var data;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            image = new ImageFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'textureURL'),
                                extension: GetFastValue(config, 'textureExtension', 'png'),
                                normalMap: GetFastValue(config, 'normalMap'),
                                xhrSettings: GetFastValue(config, 'textureXhrSettings')
                            });
                            data = new XMLFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'atlasURL'),
                                extension: GetFastValue(config, 'atlasExtension', 'xml'),
                                xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                            });
                        } else {
                            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                            data = new XMLFile(loader, key, atlasURL, atlasXhrSettings);
                        }
                        if (image.linkFile) //  Image has a normal map
                        MultiFile.call(this, loader, 'atlasxml', key, [
                            image,
                            data,
                            image.linkFile
                        ]);
                        else MultiFile.call(this, loader, 'atlasxml', key, [
                            image,
                            data
                        ]);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AtlasXMLFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var image = this.files[0];
                            var xml = this.files[1];
                            var normalMap = this.files[2] ? this.files[2].data : null;
                            this.loader.textureManager.addAtlasXML(image.key, image.data, xml.data, normalMap);
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds an XML based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in an XML file format.
 * These files are created by software such as Shoebox and Adobe Flash / Animate.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.atlasXML({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.atlasXML('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.xml');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.atlasXML({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.xml'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Atlas XML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#atlasXML
 * @fires Phaser.Loader.Events#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('atlasXML', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new AtlasXMLFile(this, key[i]);
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new AtlasXMLFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = AtlasXMLFile;
            /***/ },
            /***/ 21097: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var HTML5AudioFile = __webpack_require__(89749);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Audio File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
 *
 * @class AudioFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {Phaser.Types.Loader.FileTypes.AudioFileURLConfig} [urlConfig] - The absolute or relative URL to load this file from in a config object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {AudioContext} [audioContext] - The AudioContext this file will use to process itself.
 */ var AudioFile = new Class({
                    Extends: File,
                    initialize: //  URL is an object created by AudioFile.findAudioURL
                    function AudioFile(loader, key, urlConfig, xhrSettings, audioContext) {
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            audioContext = GetFastValue(config, 'context', audioContext);
                        }
                        var fileConfig = {
                            type: 'audio',
                            cache: loader.cacheManager.audio,
                            extension: urlConfig.type,
                            responseType: 'arraybuffer',
                            key: key,
                            url: urlConfig.url,
                            xhrSettings: xhrSettings,
                            config: {
                                context: audioContext
                            }
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.AudioFile#onProcess
     * @since 3.0.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        var _this = this;
                        // interesting read https://github.com/WebAudio/web-audio-api/issues/1305
                        this.config.context.decodeAudioData(this.xhrLoader.response, function(audioBuffer) {
                            _this.data = audioBuffer;
                            _this.onProcessComplete();
                        }, function(e) {
                            // eslint-disable-next-line no-console
                            console.error('Error decoding audio: ' + _this.key + ' - ', e ? e.message : null);
                            _this.onProcessError();
                        });
                        this.config.context = null;
                    }
                });
                AudioFile.create = function(loader, key, urls, config, xhrSettings) {
                    var game = loader.systems.game;
                    var audioConfig = game.config.audio;
                    var deviceAudio = game.device.audio;
                    //  url may be inside key, which may be an object
                    if (IsPlainObject(key)) {
                        urls = GetFastValue(key, 'url', []);
                        config = GetFastValue(key, 'config', {});
                    }
                    var urlConfig = AudioFile.getAudioURL(game, urls);
                    if (!urlConfig) {
                        console.warn('No audio URLs for "%s" can play on this device', key);
                        return null;
                    }
                    // https://developers.google.com/web/updates/2012/02/HTML5-audio-and-the-Web-Audio-API-are-BFFs
                    // var stream = GetFastValue(config, 'stream', false);
                    if (deviceAudio.webAudio && !audioConfig.disableWebAudio) return new AudioFile(loader, key, urlConfig, xhrSettings, game.sound.context);
                    else return new HTML5AudioFile(loader, key, urlConfig, config);
                };
                AudioFile.getAudioURL = function(game, urls) {
                    if (!Array.isArray(urls)) urls = [
                        urls
                    ];
                    for(var i = 0; i < urls.length; i++){
                        var url = GetFastValue(urls[i], 'url', urls[i]);
                        if (url.indexOf('blob:') === 0 || url.indexOf('data:') === 0) return {
                            url: url,
                            type: ''
                        };
                        var audioType = url.match(/\.([a-zA-Z0-9]+)($|\?)/);
                        audioType = GetFastValue(urls[i], 'type', audioType ? audioType[1] : '').toLowerCase();
                        if (game.device.audio[audioType]) return {
                            url: url,
                            type: audioType
                        };
                    }
                    return null;
                };
                /**
 * Adds an Audio or HTML5Audio file, or array of audio files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audio('title', [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Audio Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.audio({
 *     key: 'title',
 *     url: [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AudioFileConfig` for more details.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support.
 *
 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
 *
 * Note: The ability to load this type of file will only be available if the Audio File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#audio
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig|Phaser.Types.Loader.FileTypes.AudioFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|string[]|Phaser.Types.Loader.FileTypes.AudioFileURLConfig|Phaser.Types.Loader.FileTypes.AudioFileURLConfig[])} [urls] - The absolute or relative URL to load the audio files from.
 * @param {any} [config] - An object containing an `instances` property for HTML5Audio. Defaults to 1.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('audio', function(key, urls, config, xhrSettings) {
                    var game = this.systems.game;
                    var audioConfig = game.config.audio;
                    var deviceAudio = game.device.audio;
                    if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) //  Sounds are disabled, so skip loading audio
                    return this;
                    var audioFile;
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                        audioFile = AudioFile.create(this, key[i]);
                        if (audioFile) this.addFile(audioFile);
                    }
                    else {
                        audioFile = AudioFile.create(this, key, urls, config, xhrSettings);
                        if (audioFile) this.addFile(audioFile);
                    }
                    return this;
                });
                module1.exports = AudioFile;
            /***/ },
            /***/ 89524: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AudioFile = __webpack_require__(21097);
                var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                var JSONFile = __webpack_require__(518);
                var MultiFile = __webpack_require__(26430);
                /**
 * @classdesc
 * An Audio Sprite File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audioSprite method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audioSprite.
 *
 * @class AudioSpriteFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
 * @param {{(string|string[])}} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
 * @param {any} [audioConfig] - The audio configuration options.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
 */ var AudioSpriteFile = new Class({
                    Extends: MultiFile,
                    initialize: function AudioSpriteFile(loader, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings) {
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            jsonURL = GetFastValue(config, 'jsonURL');
                            audioURL = GetFastValue(config, 'audioURL');
                            audioConfig = GetFastValue(config, 'audioConfig');
                            audioXhrSettings = GetFastValue(config, 'audioXhrSettings');
                            jsonXhrSettings = GetFastValue(config, 'jsonXhrSettings');
                        }
                        var data;
                        //  No url? then we're going to do a json load and parse it from that
                        if (!audioURL) {
                            data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
                            MultiFile.call(this, loader, 'audiosprite', key, [
                                data
                            ]);
                            this.config.resourceLoad = true;
                            this.config.audioConfig = audioConfig;
                            this.config.audioXhrSettings = audioXhrSettings;
                        } else {
                            var audio = AudioFile.create(loader, key, audioURL, audioConfig, audioXhrSettings);
                            if (audio) {
                                data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
                                MultiFile.call(this, loader, 'audiosprite', key, [
                                    audio,
                                    data
                                ]);
                                this.config.resourceLoad = false;
                            }
                        }
                    },
                    /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.FileTypes.AudioSpriteFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                        var index = this.files.indexOf(file);
                        if (index !== -1) {
                            this.pending--;
                            if (this.config.resourceLoad && file.type === 'json' && file.data.hasOwnProperty('resources')) {
                                //  Inspect the data for the files to now load
                                var urls = file.data.resources;
                                var audioConfig = GetFastValue(this.config, 'audioConfig');
                                var audioXhrSettings = GetFastValue(this.config, 'audioXhrSettings');
                                var audio = AudioFile.create(this.loader, file.key, urls, audioConfig, audioXhrSettings);
                                if (audio) {
                                    this.addToMultiFile(audio);
                                    this.loader.addFile(audio);
                                }
                            }
                        }
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AudioSpriteFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var fileA = this.files[0];
                            var fileB = this.files[1];
                            fileA.addToCache();
                            fileB.addToCache();
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds a JSON based Audio Sprite, or array of audio sprites, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audioSprite('kyobi', 'kyobi.json', [
 *         'kyobi.ogg',
 *         'kyobi.mp3',
 *         'kyobi.m4a'
 *     ]);
 * }
 * ```
 *
 * Audio Sprites are a combination of audio files and a JSON configuration.
 * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
 *
 * If the JSON file includes a 'resource' object then you can let Phaser parse it and load the audio
 * files automatically based on its content. To do this exclude the audio URLs from the load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audioSprite('kyobi', 'kyobi.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Audio Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.audioSprite({
 *     key: 'kyobi',
 *     jsonURL: 'audio/Kyobi.json',
 *     audioURL: [
 *         'audio/Kyobi.ogg',
 *         'audio/Kyobi.mp3',
 *         'audio/Kyobi.m4a'
 *     ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig` for more details.
 *
 * Instead of passing a URL for the audio JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the audio has finished loading you can use it create an Audio Sprite by referencing its key:
 *
 * ```javascript
 * this.load.audioSprite('kyobi', 'kyobi.json');
 * // and later in your game ...
 * var music = this.sound.addAudioSprite('kyobi');
 * music.play('title');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support.
 *
 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
 *
 * Note: The ability to load this type of file will only be available if the Audio Sprite File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#audioSprite
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig[])} key - The key to use for this file, or a file configuration object, or an array of objects.
 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
 * @param {(string|string[])} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
 * @param {any} [audioConfig] - The audio configuration options.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader.
 */ FileTypesManager.register('audioSprite', function(key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings) {
                    var game = this.systems.game;
                    var gameAudioConfig = game.config.audio;
                    var deviceAudio = game.device.audio;
                    if (gameAudioConfig && gameAudioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) //  Sounds are disabled, so skip loading audio
                    return this;
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new AudioSpriteFile(this, key[i]);
                        if (multifile.files) this.addFile(multifile.files);
                    }
                    else {
                        multifile = new AudioSpriteFile(this, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings);
                        if (multifile.files) this.addFile(multifile.files);
                    }
                    return this;
                });
            /***/ },
            /***/ 85722: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Binary File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#binary method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#binary.
 *
 * @class BinaryFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.BinaryFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
 */ var BinaryFile = new Class({
                    Extends: File,
                    initialize: function BinaryFile(loader, key, url, xhrSettings, dataType) {
                        var extension = 'bin';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                            dataType = GetFastValue(config, 'dataType', dataType);
                        }
                        var fileConfig = {
                            type: 'binary',
                            cache: loader.cacheManager.binary,
                            extension: extension,
                            responseType: 'arraybuffer',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings,
                            config: {
                                dataType: dataType
                            }
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.BinaryFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        var ctor = this.config.dataType;
                        this.data = ctor ? new ctor(this.xhrLoader.response) : this.xhrLoader.response;
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a Binary file, or array of Binary files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.binary('doom', 'files/Doom.wad');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Binary Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Binary Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Binary Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.binary({
 *     key: 'doom',
 *     url: 'files/Doom.wad',
 *     dataType: Uint8Array
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.BinaryFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.binary('doom', 'files/Doom.wad');
 * // and later in your game ...
 * var data = this.cache.binary.get('doom');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Data` the final key will be `LEVEL1.Data` and
 * this is what you would use to retrieve the text from the Binary Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "doom"
 * and no URL is given then the Loader will set the URL to be "doom.bin". It will always add `.bin` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Binary File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#binary
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.BinaryFileConfig|Phaser.Types.Loader.FileTypes.BinaryFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('binary', function(key, url, dataType, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new BinaryFile(this, key[i]));
                    else this.addFile(new BinaryFile(this, key, url, xhrSettings, dataType));
                    return this;
                });
                module1.exports = BinaryFile;
            /***/ },
            /***/ 97025: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var ImageFile = __webpack_require__(19550);
                var IsPlainObject = __webpack_require__(41212);
                var MultiFile = __webpack_require__(26430);
                var ParseXMLBitmapFont = __webpack_require__(21859);
                var XMLFile = __webpack_require__(57318);
                /**
 * @classdesc
 * A single Bitmap Font based File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#bitmapFont method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#bitmapFont.
 *
 * @class BitmapFontFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
 */ var BitmapFontFile = new Class({
                    Extends: MultiFile,
                    initialize: function BitmapFontFile(loader, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings) {
                        var image;
                        var data;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            image = new ImageFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'textureURL'),
                                extension: GetFastValue(config, 'textureExtension', 'png'),
                                normalMap: GetFastValue(config, 'normalMap'),
                                xhrSettings: GetFastValue(config, 'textureXhrSettings')
                            });
                            data = new XMLFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'fontDataURL'),
                                extension: GetFastValue(config, 'fontDataExtension', 'xml'),
                                xhrSettings: GetFastValue(config, 'fontDataXhrSettings')
                            });
                        } else {
                            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                            data = new XMLFile(loader, key, fontDataURL, fontDataXhrSettings);
                        }
                        if (image.linkFile) //  Image has a normal map
                        MultiFile.call(this, loader, 'bitmapfont', key, [
                            image,
                            data,
                            image.linkFile
                        ]);
                        else MultiFile.call(this, loader, 'bitmapfont', key, [
                            image,
                            data
                        ]);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.BitmapFontFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var image = this.files[0];
                            var xml = this.files[1];
                            image.addToCache();
                            var texture = image.cache.get(image.key);
                            var data = ParseXMLBitmapFont(xml.data, image.cache.getFrame(image.key), 0, 0, texture);
                            this.loader.cacheManager.bitmapFont.add(image.key, {
                                data: data,
                                texture: image.key,
                                frame: null
                            });
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds an XML based Bitmap Font, or array of fonts, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:

 * ```javascript
 * function preload ()
 * {
 *     this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the font data to be provided in an XML file format.
 * These files are created by software such as the [Angelcode Bitmap Font Generator](http://www.angelcode.com/products/bmfont/),
 * [Littera](http://kvazars.com/littera/) or [Glyph Designer](https://71squared.com/glyphdesigner)
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.bitmapFont({
 *     key: 'goldenFont',
 *     textureURL: 'images/GoldFont.png',
 *     fontDataURL: 'images/GoldFont.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.BitmapFontFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use key of it when creating a Bitmap Text Game Object:
 *
 * ```javascript
 * this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
 * // and later in your game ...
 * this.add.bitmapText(x, y, 'goldenFont', 'Hello World');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use when creating a Bitmap Text object.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.bitmapFont('goldenFont', [ 'images/GoldFont.png', 'images/GoldFont-n.png' ], 'images/GoldFont.xml');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.bitmapFont({
 *     key: 'goldenFont',
 *     textureURL: 'images/GoldFont.png',
 *     normalMap: 'images/GoldFont-n.png',
 *     fontDataURL: 'images/GoldFont.xml'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Bitmap Font File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#bitmapFont
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('bitmapFont', function(key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings) {
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new BitmapFontFile(this, key[i]);
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new BitmapFontFile(this, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = BitmapFontFile;
            /***/ },
            /***/ 16024: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single CSS File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#css method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#css.
 *
 * @class CSSFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.17.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.CSSFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var CSSFile = new Class({
                    Extends: File,
                    initialize: function CSSFile(loader, key, url, xhrSettings) {
                        var extension = 'css';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        }
                        var fileConfig = {
                            type: 'script',
                            cache: false,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.CSSFile#onProcess
     * @since 3.17.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = document.createElement('style');
                        this.data.defer = false;
                        this.data.innerHTML = this.xhrLoader.responseText;
                        document.head.appendChild(this.data);
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a CSS file, or array of CSS files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.css('headers', 'styles/headers.css');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.css({
 *     key: 'headers',
 *     url: 'styles/headers.css'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.CSSFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a style DOM element
 * via `document.createElement('style')`. It will have its `defer` property set to false and then the
 * resulting element will be appended to `document.head`. The CSS styles are then applied to the current document.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.css". It will always add `.css` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the CSS File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#css
 * @fires Phaser.Loader.Events#ADD
 * @since 3.17.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.CSSFileConfig|Phaser.Types.Loader.FileTypes.CSSFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.css`, i.e. if `key` was "alien" then the URL will be "alien.css".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('css', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new CSSFile(this, key[i]));
                    else this.addFile(new CSSFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = CSSFile;
            /***/ },
            /***/ 69559: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2021 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AtlasJSONFile = __webpack_require__(38734);
                var BinaryFile = __webpack_require__(85722);
                var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var ImageFile = __webpack_require__(19550);
                var IsPlainObject = __webpack_require__(41212);
                var JSONFile = __webpack_require__(518);
                var KTXParser = __webpack_require__(31403);
                var Merge = __webpack_require__(46975);
                var MultiAtlasFile = __webpack_require__(59327);
                var MultiFile = __webpack_require__(26430);
                var PVRParser = __webpack_require__(82038);
                var verifyCompressedTexture = __webpack_require__(55222);
                /**
 * @classdesc
 * A Compressed Texture File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#texture method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#texture.
 *
 * @class CompressedTextureFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {string} key - The key to use for this file.
 * @param {Phaser.Types.Loader.FileTypes.CompressedTextureFileEntry} entry - The compressed texture file entry to load.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var CompressedTextureFile = new Class({
                    Extends: MultiFile,
                    initialize: function CompressedTextureFile(loader, key, entry, xhrSettings) {
                        if (entry.multiAtlasURL) {
                            var multi = new JSONFile(loader, {
                                key: key,
                                url: entry.multiAtlasURL,
                                xhrSettings: xhrSettings,
                                config: entry
                            });
                            MultiFile.call(this, loader, 'texture', key, [
                                multi
                            ]);
                        } else {
                            var extension = entry.textureURL.substr(entry.textureURL.length - 3);
                            if (!entry.type) entry.type = extension.toLowerCase() === 'ktx' ? 'KTX' : 'PVR';
                            var image = new BinaryFile(loader, {
                                key: key,
                                url: entry.textureURL,
                                extension: extension,
                                xhrSettings: xhrSettings,
                                config: entry
                            });
                            if (entry.atlasURL) {
                                var data = new JSONFile(loader, {
                                    key: key,
                                    url: entry.atlasURL,
                                    xhrSettings: xhrSettings,
                                    config: entry
                                });
                                MultiFile.call(this, loader, 'texture', key, [
                                    image,
                                    data
                                ]);
                            } else MultiFile.call(this, loader, 'texture', key, [
                                image
                            ]);
                        }
                        this.config = entry;
                    },
                    /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.FileTypes.CompressedTextureFile#onFileComplete
     * @since 3.60.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                        var index = this.files.indexOf(file);
                        if (index !== -1) {
                            this.pending--;
                            if (!this.config.multiAtlasURL) return;
                            if (file.type === 'json' && file.data.hasOwnProperty('textures')) {
                                //  Inspect the data for the files to now load
                                var textures = file.data.textures;
                                var config = this.config;
                                var loader = this.loader;
                                var currentBaseURL = loader.baseURL;
                                var currentPath = loader.path;
                                var currentPrefix = loader.prefix;
                                var baseURL = GetFastValue(config, 'multiBaseURL', this.baseURL);
                                var path = GetFastValue(config, 'multiPath', this.path);
                                var prefix = GetFastValue(config, 'prefix', this.prefix);
                                var textureXhrSettings = GetFastValue(config, 'textureXhrSettings');
                                if (baseURL) loader.setBaseURL(baseURL);
                                if (path) loader.setPath(path);
                                if (prefix) loader.setPrefix(prefix);
                                for(var i = 0; i < textures.length; i++){
                                    //  "image": "texture-packer-multi-atlas-0.png",
                                    var textureURL = textures[i].image;
                                    var key = 'CMA' + this.multiKeyIndex + '_' + textureURL;
                                    var image = new BinaryFile(loader, key, textureURL, textureXhrSettings);
                                    this.addToMultiFile(image);
                                    loader.addFile(image);
                                    //  "normalMap": "texture-packer-multi-atlas-0_n.png",
                                    if (textures[i].normalMap) {
                                        var normalMap = new BinaryFile(loader, key, textures[i].normalMap, textureXhrSettings);
                                        normalMap.type = 'normalMap';
                                        image.setLink(normalMap);
                                        this.addToMultiFile(normalMap);
                                        loader.addFile(normalMap);
                                    }
                                }
                                //  Reset the loader settings
                                loader.setBaseURL(currentBaseURL);
                                loader.setPath(currentPath);
                                loader.setPrefix(currentPrefix);
                            }
                        }
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.CompressedTextureFile#addToCache
     * @since 3.60.0
     */ addToCache: function() {
                        function compressionWarning(message) {
                            console.warn('Compressed Texture Invalid: "' + image.key + '". ' + message);
                        }
                        if (this.isReadyToProcess()) {
                            var entry = this.config;
                            if (entry.multiAtlasURL) this.addMultiToCache();
                            else {
                                var renderer = this.loader.systems.renderer;
                                var textureManager = this.loader.textureManager;
                                var textureData;
                                var image = this.files[0];
                                var json = this.files[1];
                                if (entry.type === 'PVR') textureData = PVRParser(image.data);
                                else if (entry.type === 'KTX') {
                                    textureData = KTXParser(image.data);
                                    if (!textureData) compressionWarning('KTX file contains unsupported format.');
                                }
                                // Check block size.
                                if (textureData && !verifyCompressedTexture(textureData)) {
                                    compressionWarning('Texture dimensions failed verification. Check the texture format specifications for ' + entry.format + ' 0x' + textureData.internalFormat.toString(16) + '.');
                                    textureData = null;
                                }
                                // Check texture compression.
                                if (textureData && !renderer.supportsCompressedTexture(entry.format, textureData.internalFormat)) {
                                    compressionWarning('Texture format ' + entry.format + ' with internal format ' + textureData.internalFormat + ' not supported by the GPU. Texture invalid. This is often due to the texture using sRGB instead of linear RGB.');
                                    textureData = null;
                                }
                                if (textureData) {
                                    textureData.format = renderer.getCompressedTextureName(entry.format, textureData.internalFormat);
                                    var atlasData = json && json.data ? json.data : null;
                                    textureManager.addCompressedTexture(image.key, textureData, atlasData);
                                }
                            }
                            this.complete = true;
                        }
                    },
                    /**
     * Adds all of the multi-file entties to their target caches upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.CompressedTextureFile#addMultiToCache
     * @since 3.60.0
     */ addMultiToCache: function() {
                        var entry = this.config;
                        var json = this.files[0];
                        var data = [];
                        var images = [];
                        var normalMaps = [];
                        var renderer = this.loader.systems.renderer;
                        var textureManager = this.loader.textureManager;
                        var textureData;
                        for(var i = 1; i < this.files.length; i++){
                            var file = this.files[i];
                            if (file.type === 'normalMap') continue;
                            var pos = file.key.indexOf('_');
                            var key = file.key.substr(pos + 1);
                            var image = file.data;
                            //  Now we need to find out which json entry this mapped to
                            for(var t = 0; t < json.data.textures.length; t++){
                                var item = json.data.textures[t];
                                if (item.image === key) {
                                    if (entry.type === 'PVR') textureData = PVRParser(image);
                                    else if (entry.type === 'KTX') textureData = KTXParser(image);
                                    if (textureData && renderer.supportsCompressedTexture(entry.format, textureData.internalFormat)) {
                                        textureData.format = renderer.getCompressedTextureName(entry.format, textureData.internalFormat);
                                        images.push(textureData);
                                        data.push(item);
                                        if (file.linkFile) normalMaps.push(file.linkFile.data);
                                    }
                                    break;
                                }
                            }
                        }
                        if (normalMaps.length === 0) normalMaps = undefined;
                        textureManager.addAtlasJSONArray(this.key, images, data, normalMaps);
                        this.complete = true;
                    }
                });
                /**
 * Adds a Compressed Texture file to the current load queue. This feature is WebGL only.
 *
 * This method takes a key and a configuration object, which lists the different formats
 * and files associated with them.
 *
 * The texture format object should be ordered in GPU priority order, with IMG as the last entry.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * preload ()
 * {
 *     this.load.texture('yourPic', {
 *         ASTC: { type: 'PVR', textureURL: 'pic-astc-4x4.pvr' },
 *         PVRTC: { type: 'PVR', textureURL: 'pic-pvrtc-4bpp-rgba.pvr' },
 *         S3TC: { type: 'PVR', textureURL: 'pic-dxt5.pvr' },
 *         IMG: { textureURL: 'pic.png' }
 *     });
 * ```
 *
 * If you wish to load a texture atlas, provide the `atlasURL` property:
 *
 * ```javascript
 * preload ()
 * {
 *     const path = 'assets/compressed';
 *
 *     this.load.texture('yourAtlas', {
 *         'ASTC': { type: 'PVR', textureURL: `${path}/textures-astc-4x4.pvr`, atlasURL: `${path}/textures.json` },
 *         'PVRTC': { type: 'PVR', textureURL: `${path}/textures-pvrtc-4bpp-rgba.pvr`, atlasURL: `${path}/textures-pvrtc-4bpp-rgba.json` },
 *         'S3TC': { type: 'PVR', textureURL: `${path}/textures-dxt5.pvr`, atlasURL: `${path}/textures-dxt5.json` },
 *         'IMG': { textureURL: `${path}/textures.png`, atlasURL: `${path}/textures.json` }
 *     });
 * }
 * ```
 *
 * If you wish to load a Multi Atlas, as exported from Texture Packer Pro, use the `multiAtlasURL` property instead:
 *
 * ```javascript
 * preload ()
 * {
 *     const path = 'assets/compressed';
 *
 *     this.load.texture('yourAtlas', {
 *         'ASTC': { type: 'PVR', atlasURL: `${path}/textures.json` },
 *         'PVRTC': { type: 'PVR', atlasURL: `${path}/textures-pvrtc-4bpp-rgba.json` },
 *         'S3TC': { type: 'PVR', atlasURL: `${path}/textures-dxt5.json` },
 *         'IMG': { atlasURL: `${path}/textures.json` }
 *     });
 * }
 * ```
 *
 * When loading a Multi Atlas you do not need to specify the `textureURL` property as it will be read from the JSON file.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.texture({
 *     key: 'yourPic',
 *     url: {
 *         ASTC: { type: 'PVR', textureURL: 'pic-astc-4x4.pvr' },
 *         PVRTC: { type: 'PVR', textureURL: 'pic-pvrtc-4bpp-rgba.pvr' },
 *         S3TC: { type: 'PVR', textureURL: 'pic-dxt5.pvr' },
 *         IMG: { textureURL: 'pic.png' }
 *    }
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.CompressedTextureFileConfig` for more details.
 *
 * The number of formats you provide to this function is up to you, but you should ensure you
 * cover the primary platforms where appropriate.
 *
 * The 'IMG' entry is a fallback to a JPG or PNG, should the browser be unable to load any of the other
 * formats presented to this function. You should really always include this, although it is optional.
 *
 * Phaser supports loading both the PVR and KTX container formats. Within those, it can parse
 * the following texture compression formats:
 *
 * ETC
 * ETC1
 * ATC
 * ASTC
 * BPTC
 * RGTC
 * PVRTC
 * S3TC
 * S3TCSRGB
 *
 * For more information about the benefits of compressed textures please see the
 * following articles:
 *
 * Texture Compression in 2020 (https://aras-p.info/blog/2020/12/08/Texture-Compression-in-2020/)
 * Compressed GPU Texture Formats (https://themaister.net/blog/2020/08/12/compressed-gpu-texture-formats-a-review-and-compute-shader-decoders-part-1/)
 *
 * To create compressed texture files use a 3rd party application such as:
 *
 * Texture Packer (https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?utm_source=ad&utm_medium=banner&utm_campaign=phaser-2018-10-16)
 * PVRTexTool (https://developer.imaginationtech.com/pvrtextool/) - available for Windows, macOS and Linux.
 * Mali Texture Compression Tool (https://developer.arm.com/tools-and-software/graphics-and-gaming/mali-texture-compression-tool)
 * ASTC Encoder (https://github.com/ARM-software/astc-encoder)
 *
 * ASTCs must have a Channel Type of Unsigned Normalized Bytes (UNorm).
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Data` the final key will be `LEVEL1.Data` and
 * this is what you would use to retrieve the text from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * Unlike other file loaders in Phaser, the URLs must include the file extension.
 *
 * Note: The ability to load this type of file will only be available if the Compressed Texture File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#texture
 * @fires Phaser.Loader.Events#ADD
 * @since 3.60.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.CompressedTextureFileConfig|Phaser.Types.Loader.FileTypes.CompressedTextureFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {Phaser.Types.Loader.FileTypes.CompressedTextureFileConfig} [url] - The compressed texture configuration object. Not required if passing a config object as the `key` parameter.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('texture', function(key, url, xhrSettings) {
                    var renderer = this.systems.renderer;
                    var AddEntry = function(loader, key, urls, xhrSettings) {
                        var entry = {
                            format: null,
                            type: null,
                            textureURL: undefined,
                            atlasURL: undefined,
                            multiAtlasURL: undefined,
                            multiPath: undefined,
                            multiBaseURL: undefined
                        };
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            urls = GetFastValue(config, 'url'), xhrSettings = GetFastValue(config, 'xhrSettings');
                        }
                        var matched = false;
                        for(var textureBaseFormat in urls)if (renderer.supportsCompressedTexture(textureBaseFormat)) {
                            var urlEntry = urls[textureBaseFormat];
                            if (typeof urlEntry === 'string') entry.textureURL = urlEntry;
                            else entry = Merge(urlEntry, entry);
                            entry.format = textureBaseFormat.toUpperCase();
                            matched = true;
                            break;
                        }
                        if (!matched) console.warn('No supported compressed texture format or IMG fallback', key);
                        else if (entry.format === 'IMG') {
                            var file;
                            var multifile;
                            if (entry.multiAtlasURL) {
                                multifile = new MultiAtlasFile(loader, key, entry.multiAtlasURL, entry.multiPath, entry.multiBaseURL, xhrSettings);
                                file = multifile.files;
                            } else if (entry.atlasURL) {
                                multifile = new AtlasJSONFile(loader, key, entry.textureURL, entry.atlasURL, xhrSettings);
                                file = multifile.files;
                            } else file = new ImageFile(loader, key, entry.textureURL, xhrSettings);
                            loader.addFile(file);
                        } else {
                            var texture = new CompressedTextureFile(loader, key, entry, xhrSettings);
                            loader.addFile(texture.files);
                        }
                    };
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)AddEntry(this, key[i]);
                    else AddEntry(this, key, url, xhrSettings);
                    return this;
                });
                module1.exports = CompressedTextureFile;
            /***/ },
            /***/ 87674: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var GetURL = __webpack_require__(98356);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Font File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#font method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#font.
 *
 * @class FontFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.87.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.FontFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.ttf`, i.e. if `key` was "alien" then the URL will be "alien.ttf".
 * @param {string} [format='truetype'] - The font type. Should be a string, like 'truetype' or 'opentype'.
 * @param {object} [descriptors] - An optional object containing font descriptors for the Font Face. See https://developer.mozilla.org/en-US/docs/Web/API/FontFace/FontFace#descriptors for more details.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var FontFile = new Class({
                    Extends: File,
                    initialize: function FontFile(loader, key, url, format, descriptors, xhrSettings) {
                        var extension = 'ttf';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            format = GetFastValue(config, 'format', 'truetype');
                            descriptors = GetFastValue(config, 'descriptors', null);
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        } else if (format === undefined) format = 'truetype';
                        var fileConfig = {
                            type: 'font',
                            cache: false,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                        this.data = {
                            format: format,
                            descriptors: descriptors
                        };
                        this.state = CONST.FILE_POPULATED;
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.FontFile#onProcess
     * @since 3.87.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.src = GetURL(this, this.loader.baseURL);
                        var font;
                        var key = this.key;
                        var source = 'url(' + this.src + ') format("' + this.data.format + '")';
                        if (this.data.descriptors) font = new FontFace(key, source, this.data.descriptors);
                        else font = new FontFace(key, source);
                        var _this = this;
                        font.load().then(function() {
                            document.fonts.add(font);
                            document.body.classList.add("fonts-loaded");
                            _this.onProcessComplete();
                        }).catch(function() {
                            console.warn('Font failed to load', source);
                            _this.onProcessComplete();
                        });
                    }
                });
                /**
 * Adds a Font file, or array of Font files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.font('Nokia', 'assets/nokia.ttf', 'truetype');
 * }
 * ```
 *
 * If the font file is open type, you can specify the format:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.font('Nokia', 'assets/nokia.otf', 'opentype');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.font({
 *     key: 'Nokia',
 *     url: 'assets/nokia.ttf',
 *     format: 'truetype',
 *     descriptors: { style: 'normal', weight: '400' }
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.FontFileConfig` for more details.
 * 
 * See the MDN documentation at https://developer.mozilla.org/en-US/docs/Web/API/FontFace/FontFace#descriptors for details about the descriptors.
 * 
 * When this file is handled by the Loader, it will create a new Font Face DOM element for it and add it to the document.
 * 
 * You should use the same key given for the font in your Text objects, such as:
 * 
 * ```javascript
 * this.add.text(x, y, 'Hello World', { fontFamily: 'Nokia', fontSize: 48 });
 * ```
 * 
 * See https://developer.mozilla.org/en-US/docs/Web/API/FontFace for more details.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.ttf". It will always add `.ttf` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Font File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#font
 * @fires Phaser.Loader.Events#ADD
 * @since 3.87.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.FontFileConfig|Phaser.Types.Loader.FileTypes.FontFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.ttf`, i.e. if `key` was "alien" then the URL will be "alien.ttf".
 * @param {string} [format='truetype'] - The font type. Should be a string, like 'truetype' or 'opentype'.
 * @param {object} [descriptors] - An optional object containing font descriptors for the Font Face. See https://developer.mozilla.org/en-US/docs/Web/API/FontFace/FontFace#descriptors for more details.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('font', function(key, url, format, descriptors, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new FontFile(this, key[i]));
                    else this.addFile(new FontFile(this, key, url, format, descriptors, xhrSettings));
                    return this;
                });
                module1.exports = FontFile;
            /***/ },
            /***/ 47931: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                var Shader = __webpack_require__(73894);
                /**
 * @classdesc
 * A single GLSL File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#glsl method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#glsl.
 *
 * @class GLSLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.GLSLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {string} [shaderType='fragment'] - The type of shader. Either `fragment` for a fragment shader, or `vertex` for a vertex shader. This is ignored if you load a shader bundle.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var GLSLFile = new Class({
                    Extends: File,
                    initialize: function GLSLFile(loader, key, url, shaderType, xhrSettings) {
                        var extension = 'glsl';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            shaderType = GetFastValue(config, 'shaderType', 'fragment');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        } else if (shaderType === undefined) shaderType = 'fragment';
                        var fileConfig = {
                            type: 'glsl',
                            cache: loader.cacheManager.shader,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            config: {
                                shaderType: shaderType
                            },
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = this.xhrLoader.responseText;
                        this.onProcessComplete();
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#addToCache
     * @since 3.17.0
     */ addToCache: function() {
                        var data = this.data.split('\n');
                        //  Check to see if this is a shader bundle, or raw glsl file.
                        var block = this.extractBlock(data, 0);
                        if (block) while(block){
                            var key = this.getShaderName(block.header);
                            var shaderType = this.getShaderType(block.header);
                            var uniforms = this.getShaderUniforms(block.header);
                            var shaderSrc = block.shader;
                            if (this.cache.has(key)) {
                                var shader = this.cache.get(key);
                                if (shaderType === 'fragment') shader.fragmentSrc = shaderSrc;
                                else shader.vertexSrc = shaderSrc;
                                if (!shader.uniforms) shader.uniforms = uniforms;
                            } else if (shaderType === 'fragment') this.cache.add(key, new Shader(key, shaderSrc, '', uniforms));
                            else this.cache.add(key, new Shader(key, '', shaderSrc, uniforms));
                            block = this.extractBlock(data, block.offset);
                        }
                        else if (this.config.shaderType === 'fragment') //  Single shader
                        this.cache.add(this.key, new Shader(this.key, this.data));
                        else this.cache.add(this.key, new Shader(this.key, '', this.data));
                    },
                    /**
     * Returns the name of the shader from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderName
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {string} The shader name.
     */ getShaderName: function(headerSource) {
                        for(var i = 0; i < headerSource.length; i++){
                            var line = headerSource[i].trim();
                            if (line.substring(0, 5) === 'name:') return line.substring(5).trim();
                        }
                        return this.key;
                    },
                    /**
     * Returns the type of the shader from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderType
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {string} The shader type. Either 'fragment' or 'vertex'.
     */ getShaderType: function(headerSource) {
                        for(var i = 0; i < headerSource.length; i++){
                            var line = headerSource[i].trim();
                            if (line.substring(0, 5) === 'type:') return line.substring(5).trim();
                        }
                        return this.config.shaderType;
                    },
                    /**
     * Returns the shader uniforms from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderUniforms
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {any} The shader uniforms object.
     */ getShaderUniforms: function(headerSource) {
                        var uniforms = {};
                        for(var i = 0; i < headerSource.length; i++){
                            var line = headerSource[i].trim();
                            if (line.substring(0, 8) === 'uniform.') {
                                var pos = line.indexOf(':');
                                if (pos) {
                                    var key = line.substring(8, pos);
                                    try {
                                        uniforms[key] = JSON.parse(line.substring(pos + 1));
                                    } catch (e) {
                                        console.warn('Invalid uniform JSON: ' + key);
                                    }
                                }
                            }
                        }
                        return uniforms;
                    },
                    /**
     * Processes the shader file and extracts the relevant data.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#extractBlock
     * @private
     * @since 3.17.0
     *
     * @param {string[]} data - The array of shader data to process.
     * @param {number} offset - The offset to start processing from.
     *
     * @return {any} The processed shader block, or null.
     */ extractBlock: function(data, offset) {
                        var headerStart = -1;
                        var headerEnd = -1;
                        var blockEnd = -1;
                        var headerOpen = false;
                        var captureSource = false;
                        var headerSource = [];
                        var shaderSource = [];
                        for(var i = offset; i < data.length; i++){
                            var line = data[i].trim();
                            if (line === '---') {
                                if (headerStart === -1) {
                                    headerStart = i;
                                    headerOpen = true;
                                } else if (headerOpen) {
                                    headerEnd = i;
                                    headerOpen = false;
                                    captureSource = true;
                                } else {
                                    //  We've hit another --- delimiter, break out
                                    captureSource = false;
                                    break;
                                }
                            } else if (headerOpen) headerSource.push(line);
                            else if (captureSource) {
                                shaderSource.push(line);
                                blockEnd = i;
                            }
                        }
                        if (!headerOpen && headerEnd !== -1) return {
                            header: headerSource,
                            shader: shaderSource.join('\n'),
                            offset: blockEnd
                        };
                        else return null;
                    }
                });
                /**
 * Adds a GLSL file, or array of GLSL files, to the current load queue.
 * In Phaser 3 GLSL files are just plain Text files at the current moment in time.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.glsl('plasma', 'shaders/Plasma.glsl');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Shader Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Shader Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Shader Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.glsl({
 *     key: 'plasma',
 *     shaderType: 'fragment',
 *     url: 'shaders/Plasma.glsl'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.GLSLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.glsl('plasma', 'shaders/Plasma.glsl');
 * // and later in your game ...
 * var data = this.cache.shader.get('plasma');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `FX.` and the key was `Plasma` the final key will be `FX.Plasma` and
 * this is what you would use to retrieve the text from the Shader Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "plasma"
 * and no URL is given then the Loader will set the URL to be "plasma.glsl". It will always add `.glsl` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the GLSL File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#glsl
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.GLSLFileConfig|Phaser.Types.Loader.FileTypes.GLSLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.glsl`, i.e. if `key` was "alien" then the URL will be "alien.glsl".
 * @param {string} [shaderType='fragment'] - The type of shader. Either `fragment` for a fragment shader, or `vertex` for a vertex shader. This is ignored if you load a shader bundle.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('glsl', function(key, url, shaderType, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new GLSLFile(this, key[i]));
                    else this.addFile(new GLSLFile(this, key, url, shaderType, xhrSettings));
                    return this;
                });
                module1.exports = GLSLFile;
            /***/ },
            /***/ 89749: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Events = __webpack_require__(54899);
                var File = __webpack_require__(41299);
                var GetFastValue = __webpack_require__(95540);
                var GetURL = __webpack_require__(98356);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Audio File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
 *
 * @class HTML5AudioFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [urlConfig] - The absolute or relative URL to load this file from.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTML5AudioFile = new Class({
                    Extends: File,
                    initialize: function HTML5AudioFile(loader, key, urlConfig, audioConfig) {
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            audioConfig = GetFastValue(config, 'config', audioConfig);
                        }
                        var fileConfig = {
                            type: 'audio',
                            cache: loader.cacheManager.audio,
                            extension: urlConfig.type,
                            key: key,
                            url: urlConfig.url,
                            config: audioConfig
                        };
                        File.call(this, loader, fileConfig);
                        //  New properties specific to this class
                        this.locked = 'ontouchstart' in window;
                        this.loaded = false;
                        this.filesLoaded = 0;
                        this.filesTotal = 0;
                    },
                    /**
     * Called when the file finishes loading.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onLoad
     * @since 3.0.0
     */ onLoad: function() {
                        if (this.loaded) return;
                        this.loaded = true;
                        this.loader.nextFile(this, true);
                    },
                    /**
     * Called if the file errors while loading.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onError
     * @since 3.0.0
     */ onError: function() {
                        for(var i = 0; i < this.data.length; i++){
                            var audio = this.data[i];
                            audio.oncanplaythrough = null;
                            audio.onerror = null;
                        }
                        this.loader.nextFile(this, false);
                    },
                    /**
     * Called during the file load progress. Is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onProgress
     * @fires Phaser.Loader.Events#FILE_PROGRESS
     * @since 3.0.0
     */ onProgress: function(event) {
                        var audio = event.target;
                        audio.oncanplaythrough = null;
                        audio.onerror = null;
                        this.filesLoaded++;
                        this.percentComplete = Math.min(this.filesLoaded / this.filesTotal, 1);
                        this.loader.emit(Events.FILE_PROGRESS, this, this.percentComplete);
                        if (this.filesLoaded === this.filesTotal) this.onLoad();
                    },
                    /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#load
     * @since 3.0.0
     */ load: function() {
                        this.data = [];
                        var instances = this.config && this.config.instances || 1;
                        this.filesTotal = instances;
                        this.filesLoaded = 0;
                        this.percentComplete = 0;
                        for(var i = 0; i < instances; i++){
                            var audio = new Audio();
                            if (!audio.dataset) audio.dataset = {};
                            audio.dataset.name = this.key + ('0' + i).slice(-2);
                            audio.dataset.used = 'false';
                            if (this.locked) audio.dataset.locked = 'true';
                            else {
                                audio.dataset.locked = 'false';
                                audio.preload = 'auto';
                                audio.oncanplaythrough = this.onProgress.bind(this);
                                audio.onerror = this.onError.bind(this);
                            }
                            this.data.push(audio);
                        }
                        for(i = 0; i < this.data.length; i++){
                            audio = this.data[i];
                            audio.src = GetURL(this, this.loader.baseURL);
                            if (!this.locked) audio.load();
                        }
                        if (this.locked) //  This is super-dangerous but works. Race condition potential high.
                        //  Is there another way?
                        setTimeout(this.onLoad.bind(this));
                    }
                });
                module1.exports = HTML5AudioFile;
            /***/ },
            /***/ 88470: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single HTML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#html method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#html.
 *
 * @class HTMLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.12.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTMLFile = new Class({
                    Extends: File,
                    initialize: function HTMLFile(loader, key, url, xhrSettings) {
                        var extension = 'html';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        }
                        var fileConfig = {
                            type: 'text',
                            cache: loader.cacheManager.html,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.HTMLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = this.xhrLoader.responseText;
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds an HTML file, or array of HTML files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.html('story', 'files/LoginForm.html');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global HTML Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the HTML Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the HTML Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.html({
 *     key: 'login',
 *     url: 'files/LoginForm.html'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.HTMLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.html('login', 'files/LoginForm.html');
 * // and later in your game ...
 * var data = this.cache.html.get('login');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the html from the HTML Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the HTML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#html
 * @fires Phaser.Loader.Events#ADD
 * @since 3.12.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLFileConfig|Phaser.Types.Loader.FileTypes.HTMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('html', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new HTMLFile(this, key[i]));
                    else this.addFile(new HTMLFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = HTMLFile;
            /***/ },
            /***/ 14643: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single HTML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#htmlTexture method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#htmlTexture.
 *
 * @class HTMLTextureFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.12.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {number} [width] - The width of the texture the HTML will be rendered to.
 * @param {number} [height] - The height of the texture the HTML will be rendered to.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTMLTextureFile = new Class({
                    Extends: File,
                    initialize: function HTMLTextureFile(loader, key, url, width, height, xhrSettings) {
                        if (width === undefined) width = 512;
                        if (height === undefined) height = 512;
                        var extension = 'html';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                            width = GetFastValue(config, 'width', width);
                            height = GetFastValue(config, 'height', height);
                        }
                        var fileConfig = {
                            type: 'html',
                            cache: loader.textureManager,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings,
                            config: {
                                width: width,
                                height: height
                            }
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.HTMLTextureFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        var w = this.config.width;
                        var h = this.config.height;
                        var data = [];
                        data.push('<svg width="' + w + 'px" height="' + h + 'px" viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg">');
                        data.push('<foreignObject width="100%" height="100%">');
                        data.push('<body xmlns="http://www.w3.org/1999/xhtml">');
                        data.push(this.xhrLoader.responseText);
                        data.push('</body>');
                        data.push('</foreignObject>');
                        data.push('</svg>');
                        var svg = [
                            data.join('\n')
                        ];
                        var _this = this;
                        try {
                            var blob = new window.Blob(svg, {
                                type: 'image/svg+xml;charset=utf-8'
                            });
                        } catch (e) {
                            _this.state = CONST.FILE_ERRORED;
                            _this.onProcessComplete();
                            return;
                        }
                        this.data = new Image();
                        this.data.crossOrigin = this.crossOrigin;
                        this.data.onload = function() {
                            File.revokeObjectURL(_this.data);
                            _this.onProcessComplete();
                        };
                        this.data.onerror = function() {
                            File.revokeObjectURL(_this.data);
                            _this.onProcessError();
                        };
                        File.createObjectURL(this.data, blob, 'image/svg+xml');
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.HTMLTextureFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        this.cache.addImage(this.key, this.data);
                    }
                });
                /**
 * Adds an HTML File, or array of HTML Files, to the current load queue. When the files are loaded they
 * will be rendered to textures and stored in the Texture Manager.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.htmlTexture('instructions', 'content/intro.html', 256, 512);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.htmlTexture({
 *     key: 'instructions',
 *     url: 'content/intro.html',
 *     width: 256,
 *     height: 512
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.htmlTexture('instructions', 'content/intro.html', 256, 512);
 * // and later in your game ...
 * this.add.image(x, y, 'instructions');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * The width and height are the size of the texture to which the HTML will be rendered. It's not possible to determine these
 * automatically, so you will need to provide them, either as arguments or in the file config object.
 * When the HTML file has loaded a new SVG element is created with a size and viewbox set to the width and height given.
 * The SVG file has a body tag added to it, with the HTML file contents included. It then calls `window.Blob` on the SVG,
 * and if successful is added to the Texture Manager, otherwise it fails processing. The overall quality of the rendered
 * HTML depends on your browser, and some of them may not even support the svg / blob process used. Be aware that there are
 * limitations on what HTML can be inside an SVG. You can find out more details in this
 * [Mozilla MDN entry](https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Drawing_DOM_objects_into_a_canvas).
 *
 * Note: The ability to load this type of file will only be available if the HTMLTextureFile File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#htmlTexture
 * @fires Phaser.Loader.Events#ADD
 * @since 3.12.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {number} [width=512] - The width of the texture the HTML will be rendered to.
 * @param {number} [height=512] - The height of the texture the HTML will be rendered to.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('htmlTexture', function(key, url, width, height, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new HTMLTextureFile(this, key[i]));
                    else this.addFile(new HTMLTextureFile(this, key, url, width, height, xhrSettings));
                    return this;
                });
                module1.exports = HTMLTextureFile;
            /***/ },
            /***/ 19550: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                var GetURL = __webpack_require__(98356);
                /**
 * @classdesc
 * A single Image File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#image method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#image.
 *
 * @class ImageFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ImageFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. Only provided for, and used by, Sprite Sheets.
 */ var ImageFile = new Class({
                    Extends: File,
                    initialize: function ImageFile(loader, key, url, xhrSettings, frameConfig) {
                        var extension = 'png';
                        var normalMapURL;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            normalMapURL = GetFastValue(config, 'normalMap');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                            frameConfig = GetFastValue(config, 'frameConfig');
                        }
                        if (Array.isArray(url)) {
                            normalMapURL = url[1];
                            url = url[0];
                        }
                        var fileConfig = {
                            type: 'image',
                            cache: loader.textureManager,
                            extension: extension,
                            responseType: 'blob',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings,
                            config: frameConfig
                        };
                        File.call(this, loader, fileConfig);
                        //  Do we have a normal map to load as well?
                        if (normalMapURL) {
                            var normalMap = new ImageFile(loader, this.key, normalMapURL, xhrSettings, frameConfig);
                            normalMap.type = 'normalMap';
                            this.setLink(normalMap);
                            loader.addFile(normalMap);
                        }
                        this.useImageElementLoad = loader.imageLoadType === 'HTMLImageElement' || this.base64;
                        if (this.useImageElementLoad) {
                            this.load = this.loadImage;
                            this.onProcess = this.onProcessImage;
                        }
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = new Image();
                        this.data.crossOrigin = this.crossOrigin;
                        var _this = this;
                        this.data.onload = function() {
                            File.revokeObjectURL(_this.data);
                            _this.onProcessComplete();
                        };
                        this.data.onerror = function() {
                            File.revokeObjectURL(_this.data);
                            _this.onProcessError();
                        };
                        File.createObjectURL(this.data, this.xhrLoader.response, 'image/png');
                    },
                    /**
     * Handles image load processing.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#onProcessImage
     * @private
     * @since 3.60.0
     */ onProcessImage: function() {
                        var result = this.state;
                        this.state = CONST.FILE_PROCESSING;
                        if (result === CONST.FILE_LOADED) this.onProcessComplete();
                        else this.onProcessError();
                    },
                    /**
     * Loads the image using either XHR or an Image tag.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#loadImage
     * @private
     * @since 3.60.0
     */ loadImage: function() {
                        this.state = CONST.FILE_LOADING;
                        this.src = GetURL(this, this.loader.baseURL);
                        this.data = new Image();
                        this.data.crossOrigin = this.crossOrigin;
                        var _this = this;
                        this.data.onload = function() {
                            _this.state = CONST.FILE_LOADED;
                            _this.loader.nextFile(_this, true);
                        };
                        this.data.onerror = function() {
                            _this.loader.nextFile(_this, false);
                        };
                        this.data.src = this.src;
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        //  Check if we have a linked normal map
                        var linkFile = this.linkFile;
                        if (linkFile) //  We do, but has it loaded?
                        {
                            if (linkFile.state >= CONST.FILE_COMPLETE) {
                                if (linkFile.type === 'spritesheet') linkFile.addToCache();
                                else if (this.type === 'normalMap') //  linkFile.data = Image
                                //  this.data = Normal Map
                                this.cache.addImage(this.key, linkFile.data, this.data);
                                else //  linkFile.data = Normal Map
                                //  this.data = Image
                                this.cache.addImage(this.key, this.data, linkFile.data);
                            }
                        } else this.cache.addImage(this.key, this.data);
                    }
                });
                /**
 * Adds an Image, or array of Images, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.image('logo', 'images/phaserLogo.png');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
 * of animated gifs to Canvas elements.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.image({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ImageFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.image('logo', 'images/AtariLogo.png');
 * // and later in your game ...
 * this.add.image(x, y, 'logo');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.image('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ]);
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.image({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png',
 *     normalMap: 'images/AtariLogo-n.png'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * In Phaser 3.60 a new property was added that allows you to control how images are loaded. By default, images are loaded via XHR as Blobs.
 * However, you can set `loader.imageLoadType: "HTMLImageElement"` in the Game Configuration and instead, the Loader will load all images
 * via the Image tag instead.
 *
 * Note: The ability to load this type of file will only be available if the Image File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#image
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ImageFileConfig|Phaser.Types.Loader.FileTypes.ImageFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('image', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new ImageFile(this, key[i]));
                    else this.addFile(new ImageFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = ImageFile;
            /***/ },
            /***/ 518: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#json method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#json.
 *
 * @class JSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {(object|string)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, can be a fully formed JSON Object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var JSONFile = new Class({
                    Extends: File,
                    initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                    //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                    function JSONFile(loader, key, url, xhrSettings, dataKey) {
                        var extension = 'json';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                            dataKey = GetFastValue(config, 'dataKey', dataKey);
                        }
                        var fileConfig = {
                            type: 'json',
                            cache: loader.cacheManager.json,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings,
                            config: dataKey
                        };
                        File.call(this, loader, fileConfig);
                        //  A JSON object has been provided (instead of a URL), so we'll use it directly as the File.data. No need to load it.
                        if (IsPlainObject(url)) {
                            if (dataKey) this.data = GetValue(url, dataKey);
                            else this.data = url;
                            this.state = CONST.FILE_POPULATED;
                        }
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.JSONFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        if (this.state !== CONST.FILE_POPULATED) {
                            this.state = CONST.FILE_PROCESSING;
                            try {
                                var json = JSON.parse(this.xhrLoader.responseText);
                            } catch (e) {
                                this.onProcessError();
                                throw e;
                            }
                            var key = this.config;
                            if (typeof key === 'string') this.data = GetValue(json, key, json);
                            else this.data = json;
                        }
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a JSON file, or array of JSON files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.json('wavedata', 'files/AlienWaveData.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.json({
 *     key: 'wavedata',
 *     url: 'files/AlienWaveData.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.JSONFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.json('wavedata', 'files/AlienWaveData.json');
 * // and later in your game ...
 * var data = this.cache.json.get('wavedata');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#json
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig|Phaser.Types.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(object|string)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, can be a fully formed JSON Object.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('json', function(key, url, dataKey, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new JSONFile(this, key[i]));
                    else this.addFile(new JSONFile(this, key, url, xhrSettings, dataKey));
                    return this;
                });
                module1.exports = JSONFile;
            /***/ },
            /***/ 59327: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var ImageFile = __webpack_require__(19550);
                var IsPlainObject = __webpack_require__(41212);
                var JSONFile = __webpack_require__(518);
                var MultiFile = __webpack_require__(26430);
                /**
 * @classdesc
 * A single Multi Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#multiatlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#multiatlas.
 *
 * @class MultiAtlasFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig)} key - The key of the file. Must be unique within both the Loader and the Texture Manager. Or a config object.
 * @param {string} [atlasURL] - The absolute or relative URL to load the multi atlas json file from.
 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas json file.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture files.
 */ var MultiAtlasFile = new Class({
                    Extends: MultiFile,
                    initialize: function MultiAtlasFile(loader, key, atlasURL, path, baseURL, atlasXhrSettings, textureXhrSettings) {
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            if (GetFastValue(config, 'url', false)) atlasURL = GetFastValue(config, 'url');
                            else atlasURL = GetFastValue(config, 'atlasURL');
                            atlasXhrSettings = GetFastValue(config, 'xhrSettings');
                            path = GetFastValue(config, 'path');
                            baseURL = GetFastValue(config, 'baseURL');
                            textureXhrSettings = GetFastValue(config, 'textureXhrSettings');
                        }
                        var data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                        MultiFile.call(this, loader, 'multiatlas', key, [
                            data
                        ]);
                        this.config.path = path;
                        this.config.baseURL = baseURL;
                        this.config.textureXhrSettings = textureXhrSettings;
                    },
                    /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.FileTypes.MultiAtlasFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                        var index = this.files.indexOf(file);
                        if (index !== -1) {
                            this.pending--;
                            if (file.type === 'json' && file.data.hasOwnProperty('textures')) {
                                //  Inspect the data for the files to now load
                                var textures = file.data.textures;
                                var config = this.config;
                                var loader = this.loader;
                                var currentBaseURL = loader.baseURL;
                                var currentPath = loader.path;
                                var currentPrefix = loader.prefix;
                                var baseURL = GetFastValue(config, 'baseURL', this.baseURL);
                                var path = GetFastValue(config, 'path', this.path);
                                var prefix = GetFastValue(config, 'prefix', this.prefix);
                                var textureXhrSettings = GetFastValue(config, 'textureXhrSettings');
                                loader.setBaseURL(baseURL);
                                loader.setPath(path);
                                loader.setPrefix(prefix);
                                for(var i = 0; i < textures.length; i++){
                                    //  "image": "texture-packer-multi-atlas-0.png",
                                    var textureURL = textures[i].image;
                                    var key = 'MA' + this.multiKeyIndex + '_' + textureURL;
                                    var image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                                    this.addToMultiFile(image);
                                    loader.addFile(image);
                                    //  "normalMap": "texture-packer-multi-atlas-0_n.png",
                                    if (textures[i].normalMap) {
                                        var normalMap = new ImageFile(loader, key, textures[i].normalMap, textureXhrSettings);
                                        normalMap.type = 'normalMap';
                                        image.setLink(normalMap);
                                        this.addToMultiFile(normalMap);
                                        loader.addFile(normalMap);
                                    }
                                }
                                //  Reset the loader settings
                                loader.setBaseURL(currentBaseURL);
                                loader.setPath(currentPath);
                                loader.setPrefix(currentPrefix);
                            }
                        }
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.MultiAtlasFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var fileJSON = this.files[0];
                            var data = [];
                            var images = [];
                            var normalMaps = [];
                            for(var i = 1; i < this.files.length; i++){
                                var file = this.files[i];
                                if (file.type === 'normalMap') continue;
                                var pos = file.key.indexOf('_');
                                var key = file.key.substr(pos + 1);
                                var image = file.data;
                                //  Now we need to find out which json entry this mapped to
                                for(var t = 0; t < fileJSON.data.textures.length; t++){
                                    var item = fileJSON.data.textures[t];
                                    if (item.image === key) {
                                        images.push(image);
                                        data.push(item);
                                        if (file.linkFile) normalMaps.push(file.linkFile.data);
                                        break;
                                    }
                                }
                            }
                            if (normalMaps.length === 0) normalMaps = undefined;
                            this.loader.textureManager.addAtlasJSONArray(this.key, images, data, normalMaps);
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds a Multi Texture Atlas, or array of multi atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.multiatlas('level1', 'images/Level1.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a JSON file as exported from the application Texture Packer,
 * version 4.6.3 or above, where you have made sure to use the Phaser 3 Export option.
 *
 * The way it works internally is that you provide a URL to the JSON file. Phaser then loads this JSON, parses it and
 * extracts which texture files it also needs to load to complete the process. If the JSON also defines normal maps,
 * Phaser will load those as well.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.multiatlas({
 *     key: 'level1',
 *     atlasURL: 'images/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig` for more details.
 *
 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.multiatlas('level1', 'images/Level1.json');
 * // and later in your game ...
 * this.add.image(x, y, 'level1', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Multi Atlas File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#multiatlas
 * @fires Phaser.Loader.Events#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('multiatlas', function(key, atlasURL, path, baseURL, atlasXhrSettings) {
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new MultiAtlasFile(this, key[i]);
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new MultiAtlasFile(this, key, atlasURL, path, baseURL, atlasXhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = MultiAtlasFile;
            /***/ },
            /***/ 99297: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                var MultiFile = __webpack_require__(26430);
                var ScriptFile = __webpack_require__(34328);
                /**
 * @classdesc
 * A Multi Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#scripts method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#scripts.
 *
 * @class MultiScriptFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.17.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string[]} [url] - An array of absolute or relative URLs to load the script files from. They are processed in the order given in the array.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object for the script files. Used in replacement of the Loaders default XHR Settings.
 */ var MultiScriptFile = new Class({
                    Extends: MultiFile,
                    initialize: function MultiScriptFile(loader, key, url, xhrSettings) {
                        var extension = 'js';
                        var files = [];
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        }
                        if (!Array.isArray(url)) url = [
                            url
                        ];
                        for(var i = 0; i < url.length; i++){
                            var scriptFile = new ScriptFile(loader, {
                                key: key + '_' + i.toString(),
                                url: url[i],
                                extension: extension,
                                xhrSettings: xhrSettings
                            });
                            //  Override the default onProcess function
                            scriptFile.onProcess = function() {
                                this.onProcessComplete();
                            };
                            files.push(scriptFile);
                        }
                        MultiFile.call(this, loader, 'scripts', key, files);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.MultiScriptFile#addToCache
     * @since 3.17.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            for(var i = 0; i < this.files.length; i++){
                                var file = this.files[i];
                                file.data = document.createElement('script');
                                file.data.language = 'javascript';
                                file.data.type = 'text/javascript';
                                file.data.defer = false;
                                file.data.text = file.xhrLoader.responseText;
                                document.head.appendChild(file.data);
                            }
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds an array of Script files to the current load queue.
 *
 * The difference between this and the `ScriptFile` file type is that you give an array of scripts to this method,
 * and the scripts are then processed _exactly_ in that order. This allows you to load a bunch of scripts that
 * may have dependencies on each other without worrying about the async nature of traditional script loading.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.scripts('PostProcess', [
 *         'libs/shaders/CopyShader.js',
 *         'libs/postprocessing/EffectComposer.js',
 *         'libs/postprocessing/RenderPass.js',
 *         'libs/postprocessing/MaskPass.js',
 *         'libs/postprocessing/ShaderPass.js',
 *         'libs/postprocessing/AfterimagePass.js'
 *    ]);
 * }
 * ```
 *
 * In the code above the script files will all be loaded in parallel but only processed (i.e. invoked) in the exact
 * order given in the array.
 *
 * The files are **not** loaded right away. They are added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the files are queued
 * it means you cannot use the files immediately after calling this method, but must wait for the files to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.scripts({
 *     key: 'PostProcess',
 *     url: [
 *         'libs/shaders/CopyShader.js',
 *         'libs/postprocessing/EffectComposer.js',
 *         'libs/postprocessing/RenderPass.js',
 *         'libs/postprocessing/MaskPass.js',
 *         'libs/postprocessing/ShaderPass.js',
 *         'libs/postprocessing/AfterimagePass.js'
 *        ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.MultiScriptFileConfig` for more details.
 *
 * Once all the files have finished loading they will automatically be converted into a script element
 * via `document.createElement('script')`. They will have their language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. This is done in the exact order the files are specified in the url array.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Note: The ability to load this type of file will only be available if the MultiScript File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#scripts
 * @fires Phaser.Loader.Events#ADD
 * @since 3.17.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string[]} [url] - An array of absolute or relative URLs to load the script files from. They are processed in the order given in the array.
 * @param {string} [extension='js'] - The default file extension to use if no url is provided.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for these files.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('scripts', function(key, url, xhrSettings) {
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new MultiScriptFile(this, key[i]);
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new MultiScriptFile(this, key, url, xhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = MultiScriptFile;
            /***/ },
            /***/ 41846: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                var MultiFile = __webpack_require__(26430);
                var ParseObj = __webpack_require__(85048);
                var ParseObjMaterial = __webpack_require__(61485);
                var TextFile = __webpack_require__(78776);
                /**
 * @classdesc
 * A single Wavefront OBJ File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#obj method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#obj.
 *
 * @class OBJFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.OBJFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [objURL] - The absolute or relative URL to load the obj file from. If undefined or `null` it will be set to `<key>.obj`, i.e. if `key` was "alien" then the URL will be "alien.obj".
 * @param {string} [matURL] - The absolute or relative URL to load the material file from. If undefined or `null` it will be set to `<key>.mat`, i.e. if `key` was "alien" then the URL will be "alien.mat".
 * @param {boolean} [flipUV] - Flip the UV coordinates stored in the model data?
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for these files.
 */ var OBJFile = new Class({
                    Extends: MultiFile,
                    initialize: function OBJFile(loader, key, objURL, matURL, flipUV, xhrSettings) {
                        var obj;
                        var mat;
                        var cache = loader.cacheManager.obj;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            obj = new TextFile(loader, {
                                key: key,
                                type: 'obj',
                                cache: cache,
                                url: GetFastValue(config, 'url'),
                                extension: GetFastValue(config, 'extension', 'obj'),
                                xhrSettings: GetFastValue(config, 'xhrSettings'),
                                config: {
                                    flipUV: GetFastValue(config, 'flipUV', flipUV)
                                }
                            });
                            matURL = GetFastValue(config, 'matURL');
                            if (matURL) mat = new TextFile(loader, {
                                key: key,
                                type: 'mat',
                                cache: cache,
                                url: matURL,
                                extension: GetFastValue(config, 'matExtension', 'mat'),
                                xhrSettings: GetFastValue(config, 'xhrSettings')
                            });
                        } else {
                            obj = new TextFile(loader, {
                                key: key,
                                url: objURL,
                                type: 'obj',
                                cache: cache,
                                extension: 'obj',
                                xhrSettings: xhrSettings,
                                config: {
                                    flipUV: flipUV
                                }
                            });
                            if (matURL) mat = new TextFile(loader, {
                                key: key,
                                url: matURL,
                                type: 'mat',
                                cache: cache,
                                extension: 'mat',
                                xhrSettings: xhrSettings
                            });
                        }
                        MultiFile.call(this, loader, 'obj', key, [
                            obj,
                            mat
                        ]);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.OBJFile#addToCache
     * @since 3.50.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var obj = this.files[0];
                            var mat = this.files[1];
                            var objData = ParseObj(obj.data, obj.config.flipUV);
                            if (mat) objData.materials = ParseObjMaterial(mat.data);
                            obj.cache.add(obj.key, objData);
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds a Wavefront OBJ file, or array of OBJ files, to the current load queue.
 *
 * Note: You should ensure your 3D package has triangulated the OBJ file prior to export.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.obj('ufo', 'files/spaceship.obj');
 * }
 * ```
 *
 * You can optionally also load a Wavefront Material file as well, by providing the 3rd parameter:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.obj('ufo', 'files/spaceship.obj', 'files/spaceship.mtl');
 * }
 * ```
 *
 * If given, the material will be parsed and stored along with the obj data in the cache.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global OBJ Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the OBJ Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the OBJ Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.obj({
 *     key: 'ufo',
 *     url: 'files/spaceship.obj',
 *     matURL: 'files/spaceship.mtl',
 *     flipUV: true
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.OBJFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.obj('ufo', 'files/spaceship.obj');
 * // and later in your game ...
 * var data = this.cache.obj.get('ufo');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the obj from the OBJ Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.obj". It will always add `.obj` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the OBJ File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#obj
 * @fires Phaser.Loader.Events#ADD
 * @since 3.50.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.OBJFileConfig|Phaser.Types.Loader.FileTypes.OBJFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [objURL] - The absolute or relative URL to load the obj file from. If undefined or `null` it will be set to `<key>.obj`, i.e. if `key` was "alien" then the URL will be "alien.obj".
 * @param {string} [matURL] - Optional absolute or relative URL to load the obj material file from.
 * @param {boolean} [flipUV] - Flip the UV coordinates stored in the model data?
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('obj', function(key, objURL, matURL, flipUVs, xhrSettings) {
                    var multifile;
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new OBJFile(this, key[i]);
                        //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new OBJFile(this, key, objURL, matURL, flipUVs, xhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = OBJFile;
            /***/ },
            /***/ 58610: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var FileTypesManager = __webpack_require__(74099);
                var JSONFile = __webpack_require__(518);
                /**
 * @classdesc
 * A single JSON Pack File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#pack method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#pack.
 *
 * @class PackFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.PackFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {(string|any)} [url] - The absolute or relative URL to load this file from or a ready formed JSON object. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var PackFile = new Class({
                    Extends: JSONFile,
                    initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                    //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                    function PackFile(loader, key, url, xhrSettings, dataKey) {
                        JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
                        this.type = 'packfile';
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.PackFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        if (this.state !== CONST.FILE_POPULATED) {
                            this.state = CONST.FILE_PROCESSING;
                            this.data = JSON.parse(this.xhrLoader.responseText);
                        }
                        if (this.data.hasOwnProperty('files') && this.config) {
                            var newData = {};
                            newData[this.config] = this.data;
                            this.data = newData;
                        }
                        //  Let's pass the pack file data over to the Loader ...
                        this.loader.addPack(this.data, this.config);
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a JSON File Pack, or array of packs, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.pack('level1', 'data/Level1Files.json');
 * }
 * ```
 *
 * A File Pack is a JSON file (or object) that contains details about other files that should be added into the Loader.
 * Here is a small example:
 *
 * ```json
 * {
 *    "test1": {
 *        "files": [
 *            {
 *                "type": "image",
 *                "key": "taikodrummaster",
 *                "url": "assets/pics/taikodrummaster.jpg"
 *            },
 *            {
 *                "type": "image",
 *                "key": "sukasuka-chtholly",
 *                "url": "assets/pics/sukasuka-chtholly.png"
 *            }
 *        ]
 *    },
 *    "meta": {
 *        "generated": "1401380327373",
 *        "app": "Phaser 3 Asset Packer",
 *        "url": "https://phaser.io",
 *        "version": "1.0",
 *        "copyright": "Photon Storm Ltd. 2018"
 *    }
 * }
 * ```
 *
 * The pack can be split into sections. In the example above you'll see a section called `test1`. You can tell
 * the `load.pack` method to parse only a particular section of a pack. The pack is stored in the JSON Cache,
 * so you can pass it to the Loader to process additional sections as needed in your game, or you can just load
 * them all at once without specifying anything.
 *
 * The pack file can contain an entry for any type of file that Phaser can load. The object structures exactly
 * match that of the file type configs, and all properties available within the file type configs can be used
 * in the pack file too. An entry's `type` is the name of the Loader method that will load it, e.g., 'image'.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.pack({
 *     key: 'level1',
 *     url: 'data/Level1Files.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.PackFileConfig` for more details.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the Pack File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#pack
 * @fires Phaser.Loader.Events#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.PackFileConfig|Phaser.Types.Loader.FileTypes.PackFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('pack', function(key, url, dataKey, xhrSettings) {
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.addFile(new PackFile(this, key[i]));
                    else this.addFile(new PackFile(this, key, url, xhrSettings, dataKey));
                    return this;
                });
                module1.exports = PackFile;
            /***/ },
            /***/ 48988: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Plugin Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#plugin method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#plugin.
 *
 * @class PluginFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.PluginFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {boolean} [start=false] - Automatically start the plugin after loading?
 * @param {string} [mapping] - If this plugin is to be injected into the Scene, this is the property key used.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var PluginFile = new Class({
                    Extends: File,
                    initialize: function PluginFile(loader, key, url, start, mapping, xhrSettings) {
                        var extension = 'js';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                            start = GetFastValue(config, 'start');
                            mapping = GetFastValue(config, 'mapping');
                        }
                        var fileConfig = {
                            type: 'plugin',
                            cache: false,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings,
                            config: {
                                start: start,
                                mapping: mapping
                            }
                        };
                        File.call(this, loader, fileConfig);
                        // If the url variable refers to a class, add the plugin directly
                        if (typeof url === 'function') {
                            this.data = url;
                            this.state = CONST.FILE_POPULATED;
                        }
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.PluginFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        var pluginManager = this.loader.systems.plugins;
                        var config = this.config;
                        var start = GetFastValue(config, 'start', false);
                        var mapping = GetFastValue(config, 'mapping', null);
                        if (this.state === CONST.FILE_POPULATED) pluginManager.install(this.key, this.data, start, mapping);
                        else {
                            //  Plugin added via a js file
                            this.state = CONST.FILE_PROCESSING;
                            this.data = document.createElement('script');
                            this.data.language = 'javascript';
                            this.data.type = 'text/javascript';
                            this.data.defer = false;
                            this.data.text = this.xhrLoader.responseText;
                            document.head.appendChild(this.data);
                            var plugin = pluginManager.install(this.key, window[this.key], start, mapping);
                            if (start || mapping) {
                                //  Install into the current Scene Systems and Scene
                                this.loader.systems[mapping] = plugin;
                                this.loader.scene[mapping] = plugin;
                            }
                        }
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a Plugin Script file, or array of plugin files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.plugin('modplayer', 'plugins/ModPlayer.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.plugin({
 *     key: 'modplayer',
 *     url: 'plugins/ModPlayer.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.PluginFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Plugin File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#plugin
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.PluginFileConfig|Phaser.Types.Loader.FileTypes.PluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, a plugin function.
 * @param {boolean} [start] - Automatically start the plugin after loading?
 * @param {string} [mapping] - If this plugin is to be injected into the Scene, this is the property key used.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('plugin', function(key, url, start, mapping, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new PluginFile(this, key[i]));
                    else this.addFile(new PluginFile(this, key, url, start, mapping, xhrSettings));
                    return this;
                });
                module1.exports = PluginFile;
            /***/ },
            /***/ 67397: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single SVG File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#svg method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#svg.
 *
 * @class SVGFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SVGFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
 * @param {Phaser.Types.Loader.FileTypes.SVGSizeConfig} [svgConfig] - The svg size configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SVGFile = new Class({
                    Extends: File,
                    initialize: function SVGFile(loader, key, url, svgConfig, xhrSettings) {
                        var extension = 'svg';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            svgConfig = GetFastValue(config, 'svgConfig', {});
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        }
                        var fileConfig = {
                            type: 'svg',
                            cache: loader.textureManager,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings,
                            config: {
                                width: GetFastValue(svgConfig, 'width'),
                                height: GetFastValue(svgConfig, 'height'),
                                scale: GetFastValue(svgConfig, 'scale')
                            }
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.SVGFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        var text = this.xhrLoader.responseText;
                        var svg = [
                            text
                        ];
                        var width = this.config.width;
                        var height = this.config.height;
                        var scale = this.config.scale;
                        resize: if (width && height || scale) {
                            var xml = null;
                            var parser = new DOMParser();
                            xml = parser.parseFromString(text, 'text/xml');
                            var svgXML = xml.getElementsByTagName('svg')[0];
                            var hasViewBox = svgXML.hasAttribute('viewBox');
                            var svgWidth = parseFloat(svgXML.getAttribute('width'));
                            var svgHeight = parseFloat(svgXML.getAttribute('height'));
                            if (!hasViewBox && svgWidth && svgHeight) //  If there's no viewBox attribute, set one
                            svgXML.setAttribute('viewBox', '0  0 ' + svgWidth + ' ' + svgHeight);
                            else if (hasViewBox && !svgWidth && !svgHeight) {
                                //  Get the w/h from the viewbox
                                var viewBox = svgXML.getAttribute('viewBox').split(/\s+|,/);
                                svgWidth = viewBox[2];
                                svgHeight = viewBox[3];
                            }
                            if (scale) {
                                if (svgWidth && svgHeight) {
                                    width = svgWidth * scale;
                                    height = svgHeight * scale;
                                } else break resize;
                            }
                            svgXML.setAttribute('width', width.toString() + 'px');
                            svgXML.setAttribute('height', height.toString() + 'px');
                            svg = [
                                new XMLSerializer().serializeToString(svgXML)
                            ];
                        }
                        try {
                            var blob = new window.Blob(svg, {
                                type: 'image/svg+xml;charset=utf-8'
                            });
                        } catch (e) {
                            this.onProcessError();
                            return;
                        }
                        this.data = new Image();
                        this.data.crossOrigin = this.crossOrigin;
                        var _this = this;
                        var retry = false;
                        this.data.onload = function() {
                            if (!retry) File.revokeObjectURL(_this.data);
                            _this.onProcessComplete();
                        };
                        this.data.onerror = function() {
                            //  Safari 8 re-try
                            if (!retry) {
                                retry = true;
                                File.revokeObjectURL(_this.data);
                                _this.data.src = 'data:image/svg+xml,' + encodeURIComponent(svg.join(''));
                            } else _this.onProcessError();
                        };
                        File.createObjectURL(this.data, blob, 'image/svg+xml');
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SVGFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        this.cache.addImage(this.key, this.data);
                    }
                });
                /**
 * Adds an SVG File, or array of SVG Files, to the current load queue. When the files are loaded they
 * will be rendered to bitmap textures and stored in the Texture Manager.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SVGFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.svg('morty', 'images/Morty.svg');
 * // and later in your game ...
 * this.add.image(x, y, 'morty');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can optionally pass an SVG Resize Configuration object when you load an SVG file. By default the SVG will be rendered to a texture
 * at the same size defined in the SVG file attributes. However, this isn't always desirable. You may wish to resize the SVG (either down
 * or up) to improve texture clarity, or reduce texture memory consumption. You can either specify an exact width and height to resize
 * the SVG to:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg', { width: 300, height: 600 });
 * }
 * ```
 *
 * Or when using a configuration object:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg',
 *     svgConfig: {
 *         width: 300,
 *         height: 600
 *     }
 * });
 * ```
 *
 * Alternatively, you can just provide a scale factor instead:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg', { scale: 2.5 });
 * }
 * ```
 *
 * Or when using a configuration object:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg',
 *     svgConfig: {
 *         scale: 2.5
 *     }
 * });
 * ```
 *
 * If scale, width and height values are all given, the scale has priority and the width and height values are ignored.
 *
 * Note: The ability to load this type of file will only be available if the SVG File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#svg
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SVGFileConfig|Phaser.Types.Loader.FileTypes.SVGFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
 * @param {Phaser.Types.Loader.FileTypes.SVGSizeConfig} [svgConfig] - The svg size configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('svg', function(key, url, svgConfig, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new SVGFile(this, key[i]));
                    else this.addFile(new SVGFile(this, key, url, svgConfig, xhrSettings));
                    return this;
                });
                module1.exports = SVGFile;
            /***/ },
            /***/ 88423: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * An external Scene JavaScript File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#sceneFile method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#sceneFile.
 *
 * @class SceneFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SceneFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SceneFile = new Class({
                    Extends: File,
                    initialize: function SceneFile(loader, key, url, xhrSettings) {
                        var extension = 'js';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        }
                        var fileConfig = {
                            type: 'text',
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.SceneFile#onProcess
     * @since 3.16.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = this.xhrLoader.responseText;
                        this.onProcessComplete();
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SceneFile#addToCache
     * @since 3.16.0
     */ addToCache: function() {
                        var code = this.data.concat("(function(){\nreturn new " + this.key + '();\n' + '}).call(this);');
                        //  Stops rollup from freaking out during build
                        var eval2 = eval;
                        this.loader.sceneManager.add(this.key, eval2(code));
                        this.complete = true;
                    }
                });
                /**
 * Adds an external Scene file, or array of Scene files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.sceneFile('Level1', 'src/Level1.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Scene Manager upon a successful load.
 *
 * For a Scene File it's vitally important that the key matches the class name in the JavaScript file.
 *
 * For example here is the source file:
 *
 * ```javascript
 * class ExternalScene extends Phaser.Scene {
 *
 *     constructor ()
 *     {
 *         super('myScene');
 *     }
 *
 * }
 * ```
 *
 * Because the class is called `ExternalScene` that is the exact same key you must use when loading it:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.sceneFile('ExternalScene', 'src/yourScene.js');
 * }
 * ```
 *
 * The key that is used within the Scene Manager can either be set to the same, or you can override it in the Scene
 * constructor, as we've done in the example above, where the Scene key was changed to `myScene`.
 *
 * The key should be unique both in terms of files being loaded and Scenes already present in the Scene Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Scene Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.sceneFile({
 *     key: 'Level1',
 *     url: 'src/Level1.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SceneFileConfig` for more details.
 *
 * Once the file has finished loading it will be added to the Scene Manager.
 *
 * ```javascript
 * this.load.sceneFile('Level1', 'src/Level1.js');
 * // and later in your game ...
 * this.scene.start('Level1');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `WORLD1.` and the key was `Story` the final key will be `WORLD1.Story` and
 * this is what you would use to retrieve the text from the Scene Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Scene File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#sceneFile
 * @fires Phaser.Loader.Events#ADD
 * @since 3.16.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SceneFileConfig|Phaser.Types.Loader.FileTypes.SceneFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('sceneFile', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new SceneFile(this, key[i]));
                    else this.addFile(new SceneFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = SceneFile;
            /***/ },
            /***/ 56812: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Scene Plugin Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#scenePlugin method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#scenePlugin.
 *
 * @class ScenePluginFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var ScenePluginFile = new Class({
                    Extends: File,
                    initialize: function ScenePluginFile(loader, key, url, systemKey, sceneKey, xhrSettings) {
                        var extension = 'js';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                            systemKey = GetFastValue(config, 'systemKey');
                            sceneKey = GetFastValue(config, 'sceneKey');
                        }
                        var fileConfig = {
                            type: 'scenePlugin',
                            cache: false,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings,
                            config: {
                                systemKey: systemKey,
                                sceneKey: sceneKey
                            }
                        };
                        File.call(this, loader, fileConfig);
                        // If the url variable refers to a class, add the plugin directly
                        if (typeof url === 'function') {
                            this.data = url;
                            this.state = CONST.FILE_POPULATED;
                        }
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ScenePluginFile#onProcess
     * @since 3.8.0
     */ onProcess: function() {
                        var pluginManager = this.loader.systems.plugins;
                        var config = this.config;
                        var key = this.key;
                        var systemKey = GetFastValue(config, 'systemKey', key);
                        var sceneKey = GetFastValue(config, 'sceneKey', key);
                        if (this.state === CONST.FILE_POPULATED) pluginManager.installScenePlugin(systemKey, this.data, sceneKey, this.loader.scene, true);
                        else {
                            //  Plugin added via a js file
                            this.state = CONST.FILE_PROCESSING;
                            this.data = document.createElement('script');
                            this.data.language = 'javascript';
                            this.data.type = 'text/javascript';
                            this.data.defer = false;
                            this.data.text = this.xhrLoader.responseText;
                            document.head.appendChild(this.data);
                            pluginManager.installScenePlugin(systemKey, window[this.key], sceneKey, this.loader.scene, true);
                        }
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a Scene Plugin Script file, or array of plugin files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.scenePlugin('ModPlayer', 'plugins/ModPlayer.js', 'modPlayer', 'mods');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.scenePlugin({
 *     key: 'modplayer',
 *     url: 'plugins/ModPlayer.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ScenePluginFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#scenePlugin
 * @fires Phaser.Loader.Events#ADD
 * @since 3.8.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, set to a plugin function.
 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('scenePlugin', function(key, url, systemKey, sceneKey, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new ScenePluginFile(this, key[i]));
                    else this.addFile(new ScenePluginFile(this, key, url, systemKey, sceneKey, xhrSettings));
                    return this;
                });
                module1.exports = ScenePluginFile;
            /***/ },
            /***/ 34328: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#script method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#script.
 *
 * @class ScriptFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ScriptFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {string} [type='script'] - The script type. Should be either 'script' for classic JavaScript, or 'module' if the file contains an exported module.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var ScriptFile = new Class({
                    Extends: File,
                    initialize: function ScriptFile(loader, key, url, type, xhrSettings) {
                        var extension = 'js';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            type = GetFastValue(config, 'type', 'script');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        } else if (type === undefined) type = 'script';
                        var fileConfig = {
                            type: type,
                            cache: false,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ScriptFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = document.createElement('script');
                        this.data.language = 'javascript';
                        this.data.type = 'text/javascript';
                        this.data.defer = false;
                        this.data.text = this.xhrLoader.responseText;
                        document.head.appendChild(this.data);
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a Script file, or array of Script files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.script('aliens', 'lib/aliens.js');
 * }
 * ```
 *
 * If the script file contains a module, then you should specify that using the 'type' parameter:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.script('aliens', 'lib/aliens.js', 'module');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.script({
 *     key: 'aliens',
 *     url: 'lib/aliens.js',
 *     type: 'script' // or 'module'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ScriptFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#script
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ScriptFileConfig|Phaser.Types.Loader.FileTypes.ScriptFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {string} [type='script'] - The script type. Should be either 'script' for classic JavaScript, or 'module' if the file contains an exported module.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('script', function(key, url, type, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new ScriptFile(this, key[i]));
                    else this.addFile(new ScriptFile(this, key, url, type, xhrSettings));
                    return this;
                });
                module1.exports = ScriptFile;
            /***/ },
            /***/ 85035: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var FileTypesManager = __webpack_require__(74099);
                var ImageFile = __webpack_require__(19550);
                /**
 * @classdesc
 * A single Sprite Sheet Image File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#spritesheet method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#spritesheet.
 *
 * @class SpriteSheetFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SpriteSheetFile = new Class({
                    Extends: ImageFile,
                    initialize: function SpriteSheetFile(loader, key, url, frameConfig, xhrSettings) {
                        ImageFile.call(this, loader, key, url, xhrSettings, frameConfig);
                        this.type = 'spritesheet';
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SpriteSheetFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        //  Check if we have a linked normal map
                        var linkFile = this.linkFile;
                        if (linkFile) //  We do, but has it loaded?
                        {
                            if (linkFile.state >= CONST.FILE_COMPLETE) {
                                //  Both files have loaded
                                if (this.type === 'normalMap') //  linkFile.data = Image
                                //  this.data = Normal Map
                                this.cache.addSpriteSheet(this.key, linkFile.data, this.config, this.data);
                                else //  linkFile.data = Normal Map
                                //  this.data = Image
                                this.cache.addSpriteSheet(this.key, this.data, this.config, linkFile.data);
                            }
                        } else this.cache.addSpriteSheet(this.key, this.data, this.config);
                    }
                });
                /**
 * Adds a Sprite Sheet Image, or array of Sprite Sheet Images, to the current load queue.
 *
 * The term 'Sprite Sheet' in Phaser means a fixed-size sheet. Where every frame in the sheet is the exact same size,
 * and you reference those frames using numbers, not frame names. This is not the same thing as a Texture Atlas, where
 * the frames are packed in a way where they take up the least amount of space, and are referenced by their names,
 * not numbers. Some articles and software use the term 'Sprite Sheet' to mean Texture Atlas, so please be aware of
 * what sort of file you're actually trying to load.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
 * of animated gifs to Canvas elements.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.spritesheet({
 *     key: 'bot',
 *     url: 'images/robot.png',
 *     frameConfig: {
 *         frameWidth: 32,
 *         frameHeight: 38,
 *         startFrame: 0,
 *         endFrame: 8
 *     }
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
 * // and later in your game ...
 * this.add.image(x, y, 'bot', 0);
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `PLAYER.` and the key was `Running` the final key will be `PLAYER.Running` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.spritesheet('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ], { frameWidth: 256, frameHeight: 80 });
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.spritesheet({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png',
 *     normalMap: 'images/AtariLogo-n.png',
 *     frameConfig: {
 *         frameWidth: 256,
 *         frameHeight: 80
 *     }
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Sprite Sheet File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#spritesheet
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. At a minimum it should have a `frameWidth` property.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('spritesheet', function(key, url, frameConfig, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new SpriteSheetFile(this, key[i]));
                    else this.addFile(new SpriteSheetFile(this, key, url, frameConfig, xhrSettings));
                    return this;
                });
                module1.exports = SpriteSheetFile;
            /***/ },
            /***/ 78776: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Text File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#text method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#text.
 *
 * @class TextFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TextFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TextFile = new Class({
                    Extends: File,
                    initialize: function TextFile(loader, key, url, xhrSettings) {
                        var type = 'text';
                        var extension = 'txt';
                        var cache = loader.cacheManager.text;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                            type = GetFastValue(config, 'type', type);
                            cache = GetFastValue(config, 'cache', cache);
                        }
                        var fileConfig = {
                            type: type,
                            cache: cache,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.TextFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = this.xhrLoader.responseText;
                        this.onProcessComplete();
                    }
                });
                /**
 * Adds a Text file, or array of Text files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.text('story', 'files/IntroStory.txt');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Text Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Text Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.text({
 *     key: 'story',
 *     url: 'files/IntroStory.txt'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TextFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.text('story', 'files/IntroStory.txt');
 * // and later in your game ...
 * var data = this.cache.text.get('story');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Text Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.txt". It will always add `.txt` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Text File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#text
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TextFileConfig|Phaser.Types.Loader.FileTypes.TextFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('text', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new TextFile(this, key[i]));
                    else this.addFile(new TextFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = TextFile;
            /***/ },
            /***/ 49477: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                var TILEMAP_FORMATS = __webpack_require__(80341);
                /**
 * @classdesc
 * A single Tilemap CSV File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapCSV method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapCSV.
 *
 * @class TilemapCSVFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapCSVFile = new Class({
                    Extends: File,
                    initialize: function TilemapCSVFile(loader, key, url, xhrSettings) {
                        var extension = 'csv';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        }
                        var fileConfig = {
                            type: 'tilemapCSV',
                            cache: loader.cacheManager.tilemap,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                        this.tilemapFormat = TILEMAP_FORMATS.CSV;
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.TilemapCSVFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = this.xhrLoader.responseText;
                        this.onProcessComplete();
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapCSVFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        var tiledata = {
                            format: this.tilemapFormat,
                            data: this.data
                        };
                        this.cache.add(this.key, tiledata);
                    }
                });
                /**
 * Adds a CSV Tilemap file, or array of CSV files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapCSV('level1', 'maps/Level1.csv');
 * }
 * ```
 *
 * Tilemap CSV data can be created in a text editor, or a 3rd party app that exports as CSV.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapCSV({
 *     key: 'level1',
 *     url: 'maps/Level1.csv'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapCSV('level1', 'maps/Level1.csv');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.csv". It will always add `.csv` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap CSV File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapCSV
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('tilemapCSV', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new TilemapCSVFile(this, key[i]));
                    else this.addFile(new TilemapCSVFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = TilemapCSVFile;
            /***/ },
            /***/ 40807: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var JSONFile = __webpack_require__(518);
                var TILEMAP_FORMATS = __webpack_require__(80341);
                /**
 * @classdesc
 * A single Impact.js Tilemap JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapImpact method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapImpact.
 *
 * @class TilemapImpactFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapImpactFile = new Class({
                    Extends: JSONFile,
                    initialize: function TilemapImpactFile(loader, key, url, xhrSettings) {
                        JSONFile.call(this, loader, key, url, xhrSettings);
                        this.type = 'tilemapJSON';
                        this.cache = loader.cacheManager.tilemap;
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapImpactFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        var tiledata = {
                            format: TILEMAP_FORMATS.WELTMEISTER,
                            data: this.data
                        };
                        this.cache.add(this.key, tiledata);
                    }
                });
                /**
 * Adds an Impact.js Tilemap file, or array of map files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapImpact('level1', 'maps/Level1.json');
 * }
 * ```
 *
 * Impact Tilemap data is created the Impact.js Map Editor called Weltmeister.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapImpact({
 *     key: 'level1',
 *     url: 'maps/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapImpact('level1', 'maps/Level1.json');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap Impact File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapImpact
 * @fires Phaser.Loader.Events#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('tilemapImpact', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new TilemapImpactFile(this, key[i]));
                    else this.addFile(new TilemapImpactFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = TilemapImpactFile;
            /***/ },
            /***/ 56775: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var JSONFile = __webpack_require__(518);
                var TILEMAP_FORMATS = __webpack_require__(80341);
                /**
 * @classdesc
 * A single Tiled Tilemap JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapTiledJSON method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapTiledJSON.
 *
 * @class TilemapJSONFile
 * @extends Phaser.Loader.FileTypes.JSONFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {object|string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapJSONFile = new Class({
                    Extends: JSONFile,
                    initialize: function TilemapJSONFile(loader, key, url, xhrSettings) {
                        JSONFile.call(this, loader, key, url, xhrSettings);
                        this.type = 'tilemapJSON';
                        this.cache = loader.cacheManager.tilemap;
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapJSONFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        var tiledata = {
                            format: TILEMAP_FORMATS.TILED_JSON,
                            data: this.data
                        };
                        this.cache.add(this.key, tiledata);
                    }
                });
                /**
 * Adds a Tiled JSON Tilemap file, or array of map files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapTiledJSON('level1', 'maps/Level1.json');
 * }
 * ```
 *
 * The Tilemap data is created using the Tiled Map Editor and selecting JSON as the export format.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapTiledJSON({
 *     key: 'level1',
 *     url: 'maps/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapTiledJSON('level1', 'maps/Level1.json');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapTiledJSON
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {object|string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('tilemapTiledJSON', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new TilemapJSONFile(this, key[i]));
                    else this.addFile(new TilemapJSONFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = TilemapJSONFile;
            /***/ },
            /***/ 25771: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var ImageFile = __webpack_require__(19550);
                var IsPlainObject = __webpack_require__(41212);
                var MultiFile = __webpack_require__(26430);
                var TextFile = __webpack_require__(78776);
                /**
 * @classdesc
 * A single text file based Unity Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#unityAtlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#unityAtlas.
 *
 * @class UnityAtlasFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
 */ var UnityAtlasFile = new Class({
                    Extends: MultiFile,
                    initialize: function UnityAtlasFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                        var image;
                        var data;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            image = new ImageFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'textureURL'),
                                extension: GetFastValue(config, 'textureExtension', 'png'),
                                normalMap: GetFastValue(config, 'normalMap'),
                                xhrSettings: GetFastValue(config, 'textureXhrSettings')
                            });
                            data = new TextFile(loader, {
                                key: key,
                                url: GetFastValue(config, 'atlasURL'),
                                extension: GetFastValue(config, 'atlasExtension', 'txt'),
                                xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                            });
                        } else {
                            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                            data = new TextFile(loader, key, atlasURL, atlasXhrSettings);
                        }
                        if (image.linkFile) //  Image has a normal map
                        MultiFile.call(this, loader, 'unityatlas', key, [
                            image,
                            data,
                            image.linkFile
                        ]);
                        else MultiFile.call(this, loader, 'unityatlas', key, [
                            image,
                            data
                        ]);
                    },
                    /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.UnityAtlasFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                        if (this.isReadyToProcess()) {
                            var image = this.files[0];
                            var text = this.files[1];
                            var normalMap = this.files[2] ? this.files[2].data : null;
                            this.loader.textureManager.addUnityAtlas(image.key, image.data, text.data, normalMap);
                            this.complete = true;
                        }
                    }
                });
                /**
 * Adds a Unity YAML based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.txt');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a YAML formatted text file as exported from Unity.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.unityAtlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.txt'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.unityAtlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.txt');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.unityAtlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.txt'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Unity Atlas File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#unityAtlas
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('unityAtlas', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var multifile;
                    //  Supports an Object file definition in the key argument
                    //  Or an array of objects in the key argument
                    //  Or a single entry where all arguments have been defined
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                        multifile = new UnityAtlasFile(this, key[i]);
                        this.addFile(multifile.files);
                    }
                    else {
                        multifile = new UnityAtlasFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                        this.addFile(multifile.files);
                    }
                    return this;
                });
                module1.exports = UnityAtlasFile;
            /***/ },
            /***/ 33720: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetURL = __webpack_require__(98356);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * A single Video File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#video method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#video.
 *
 * @class VideoFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.20.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.VideoFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {(string|string[]|Phaser.Types.Loader.FileTypes.VideoFileURLConfig|Phaser.Types.Loader.FileTypes.VideoFileURLConfig[])} [urls] - The absolute or relative URL to load the video files from.
 * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
 */ var VideoFile = new Class({
                    Extends: File,
                    initialize: function VideoFile(loader, key, url, noAudio) {
                        if (noAudio === undefined) noAudio = false;
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url', []);
                            noAudio = GetFastValue(config, 'noAudio', false);
                        }
                        var urlConfig = loader.systems.game.device.video.getVideoURL(url);
                        if (!urlConfig) console.warn('VideoFile: No supported format for ' + key);
                        var fileConfig = {
                            type: 'video',
                            cache: loader.cacheManager.video,
                            extension: urlConfig.type,
                            key: key,
                            url: urlConfig.url,
                            config: {
                                noAudio: noAudio
                            }
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#onProcess
     * @since 3.20.0
    */ onProcess: function() {
                        this.data = {
                            url: this.src,
                            noAudio: this.config.noAudio,
                            crossOrigin: this.crossOrigin
                        };
                        this.onProcessComplete();
                    },
                    /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#load
     * @since 3.20.0
     */ load: function() {
                        //  We set these, but we don't actually load anything (the Video Game Object does that)
                        this.src = GetURL(this, this.loader.baseURL);
                        this.state = CONST.FILE_LOADED;
                        this.loader.nextFile(this, true);
                    }
                });
                /**
 * Adds a Video file, or array of video files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.video('intro', [ 'video/level1.mp4', 'video/level1.webm', 'video/level1.mov' ]);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Video Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Video Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Video Cache first, before loading a new one.
  *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.video({
 *     key: 'intro',
 *     url: [ 'video/level1.mp4', 'video/level1.webm', 'video/level1.mov' ],
 *     noAudio: true
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.VideoFileConfig` for more details.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Due to different browsers supporting different video file types you should usually provide your video files in a variety of formats.
 * mp4, mov and webm are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support, starting with the first in the array and progressing to the end.
 *
 * Unlike most asset-types, videos do not _need_ to be preloaded. You can create a Video Game Object and then call its `loadURL` method,
 * to load a video at run-time, rather than in advance.
 *
 * Note: The ability to load this type of file will only be available if the Video File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#video
 * @fires Phaser.Loader.Events#ADD
 * @since 3.20.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.VideoFileConfig|Phaser.Types.Loader.FileTypes.VideoFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|string[]|Phaser.Types.Loader.FileTypes.VideoFileURLConfig|Phaser.Types.Loader.FileTypes.VideoFileURLConfig[])} [urls] - The absolute or relative URL to load the video files from.
 * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('video', function(key, urls, noAudio) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.addFile(new VideoFile(this, key[i]));
                    else this.addFile(new VideoFile(this, key, urls, noAudio));
                    return this;
                });
                module1.exports = VideoFile;
            /***/ },
            /***/ 57318: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(23906);
                var File = __webpack_require__(41299);
                var FileTypesManager = __webpack_require__(74099);
                var GetFastValue = __webpack_require__(95540);
                var IsPlainObject = __webpack_require__(41212);
                var ParseXML = __webpack_require__(56836);
                /**
 * @classdesc
 * A single XML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#xml method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#xml.
 *
 * @class XMLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.XMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var XMLFile = new Class({
                    Extends: File,
                    initialize: function XMLFile(loader, key, url, xhrSettings) {
                        var extension = 'xml';
                        if (IsPlainObject(key)) {
                            var config = key;
                            key = GetFastValue(config, 'key');
                            url = GetFastValue(config, 'url');
                            xhrSettings = GetFastValue(config, 'xhrSettings');
                            extension = GetFastValue(config, 'extension', extension);
                        }
                        var fileConfig = {
                            type: 'xml',
                            cache: loader.cacheManager.xml,
                            extension: extension,
                            responseType: 'text',
                            key: key,
                            url: url,
                            xhrSettings: xhrSettings
                        };
                        File.call(this, loader, fileConfig);
                    },
                    /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.XMLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = ParseXML(this.xhrLoader.responseText);
                        if (this.data) this.onProcessComplete();
                        else this.onProcessError();
                    }
                });
                /**
 * Adds an XML file, or array of XML files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.xml('wavedata', 'files/AlienWaveData.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global XML Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the XML Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the XML Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.xml({
 *     key: 'wavedata',
 *     url: 'files/AlienWaveData.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.XMLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.xml('wavedata', 'files/AlienWaveData.xml');
 * // and later in your game ...
 * var data = this.cache.xml.get('wavedata');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the XML Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.xml". It will always add `.xml` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the XML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#xml
 * @fires Phaser.Loader.Events#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.XMLFileConfig|Phaser.Types.Loader.FileTypes.XMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('xml', function(key, url, xhrSettings) {
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(new XMLFile(this, key[i]));
                    else this.addFile(new XMLFile(this, key, url, xhrSettings));
                    return this;
                });
                module1.exports = XMLFile;
            /***/ },
            /***/ 64589: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Loader.FileTypes
 */ module1.exports = {
                    AnimationJSONFile: __webpack_require__(14135),
                    AsepriteFile: __webpack_require__(76272),
                    AtlasJSONFile: __webpack_require__(38734),
                    AtlasXMLFile: __webpack_require__(74599),
                    AudioFile: __webpack_require__(21097),
                    AudioSpriteFile: __webpack_require__(89524),
                    BinaryFile: __webpack_require__(85722),
                    BitmapFontFile: __webpack_require__(97025),
                    CompressedTextureFile: __webpack_require__(69559),
                    CSSFile: __webpack_require__(16024),
                    FontFile: __webpack_require__(87674),
                    GLSLFile: __webpack_require__(47931),
                    HTML5AudioFile: __webpack_require__(89749),
                    HTMLFile: __webpack_require__(88470),
                    HTMLTextureFile: __webpack_require__(14643),
                    ImageFile: __webpack_require__(19550),
                    JSONFile: __webpack_require__(518),
                    MultiAtlasFile: __webpack_require__(59327),
                    MultiScriptFile: __webpack_require__(99297),
                    OBJFile: __webpack_require__(41846),
                    PackFile: __webpack_require__(58610),
                    PluginFile: __webpack_require__(48988),
                    SceneFile: __webpack_require__(88423),
                    ScenePluginFile: __webpack_require__(56812),
                    ScriptFile: __webpack_require__(34328),
                    SpriteSheetFile: __webpack_require__(85035),
                    SVGFile: __webpack_require__(67397),
                    TextFile: __webpack_require__(78776),
                    TilemapCSVFile: __webpack_require__(49477),
                    TilemapImpactFile: __webpack_require__(40807),
                    TilemapJSONFile: __webpack_require__(56775),
                    UnityAtlasFile: __webpack_require__(25771),
                    VideoFile: __webpack_require__(33720),
                    XMLFile: __webpack_require__(57318)
                };
            /***/ },
            /***/ 57777: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(23906);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Loader
 */ var Loader = {
                    Events: __webpack_require__(54899),
                    FileTypes: __webpack_require__(64589),
                    File: __webpack_require__(41299),
                    FileTypesManager: __webpack_require__(74099),
                    GetURL: __webpack_require__(98356),
                    LoaderPlugin: __webpack_require__(74261),
                    MergeXHRSettings: __webpack_require__(3374),
                    MultiFile: __webpack_require__(26430),
                    XHRLoader: __webpack_require__(84376),
                    XHRSettings: __webpack_require__(92638)
                };
                //   Merge in the consts
                Loader = Extend(false, Loader, CONST);
                module1.exports = Loader;
            /***/ },
            /***/ 53307: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the mean average of the given values.
 *
 * @function Phaser.Math.Average
 * @since 3.0.0
 *
 * @param {number[]} values - The values to average.
 *
 * @return {number} The average value.
 */ var Average = function(values) {
                    var sum = 0;
                    for(var i = 0; i < values.length; i++)sum += +values[i];
                    return sum / values.length;
                };
                module1.exports = Average;
            /***/ },
            /***/ 85710: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Factorial = __webpack_require__(6411);
                /**
 * Calculates the Bernstein basis from the three factorial coefficients.
 *
 * @function Phaser.Math.Bernstein
 * @since 3.0.0
 *
 * @param {number} n - The first value.
 * @param {number} i - The second value.
 *
 * @return {number} The Bernstein basis of Factorial(n) / Factorial(i) / Factorial(n - i)
 */ var Bernstein = function(n, i) {
                    return Factorial(n) / Factorial(i) / Factorial(n - i);
                };
                module1.exports = Bernstein;
            /***/ },
            /***/ 30976: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random integer between the `min` and `max` values, inclusive.
 *
 * @function Phaser.Math.Between
 * @since 3.0.0
 *
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 *
 * @return {number} The random integer.
 */ var Between = function(min, max) {
                    return Math.floor(Math.random() * (max - min + 1) + min);
                };
                module1.exports = Between;
            /***/ },
            /***/ 87842: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates a Catmull-Rom value from the given points, based on an alpha of 0.5.
 *
 * @function Phaser.Math.CatmullRom
 * @since 3.0.0
 *
 * @param {number} t - The amount to interpolate by.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 *
 * @return {number} The Catmull-Rom value.
 */ var CatmullRom = function(t, p0, p1, p2, p3) {
                    var v0 = (p2 - p0) * 0.5;
                    var v1 = (p3 - p1) * 0.5;
                    var t2 = t * t;
                    var t3 = t * t2;
                    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
                };
                module1.exports = CatmullRom;
            /***/ },
            /***/ 26302: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Ceils to some place comparative to a `base`, default is 10 for decimal place.
 *
 * The `place` is represented by the power applied to `base` to get that place.
 *
 * @function Phaser.Math.CeilTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var CeilTo = function(value, place, base) {
                    if (place === undefined) place = 0;
                    if (base === undefined) base = 10;
                    var p = Math.pow(base, -place);
                    return Math.ceil(value * p) / p;
                };
                module1.exports = CeilTo;
            /***/ },
            /***/ 45319: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Force a value within the boundaries by clamping it to the range `min`, `max`.
 *
 * @function Phaser.Math.Clamp
 * @since 3.0.0
 *
 * @param {number} value - The value to be clamped.
 * @param {number} min - The minimum bounds.
 * @param {number} max - The maximum bounds.
 *
 * @return {number} The clamped value.
 */ var Clamp = function(value, min, max) {
                    return Math.max(min, Math.min(max, value));
                };
                module1.exports = Clamp;
            /***/ },
            /***/ 39506: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(36383);
                /**
 * Convert the given angle from degrees, to the equivalent angle in radians.
 *
 * @function Phaser.Math.DegToRad
 * @since 3.0.0
 *
 * @param {number} degrees - The angle (in degrees) to convert to radians.
 *
 * @return {number} The given angle converted to radians.
 */ var DegToRad = function(degrees) {
                    return degrees * CONST.DEG_TO_RAD;
                };
                module1.exports = DegToRad;
            /***/ },
            /***/ 61241: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the positive difference of two given numbers.
 *
 * @function Phaser.Math.Difference
 * @since 3.0.0
 *
 * @param {number} a - The first number in the calculation.
 * @param {number} b - The second number in the calculation.
 *
 * @return {number} The positive difference of the two given numbers.
 */ var Difference = function(a, b) {
                    return Math.abs(a - b);
                };
                module1.exports = Difference;
            /***/ },
            /***/ 38857: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Matrix4 = __webpack_require__(37867);
                var NOOP = __webpack_require__(29747);
                var tempMatrix = new Matrix4();
                /**
 * @classdesc
 *
 * @class Euler
 * @memberof Phaser.Math
 * @constructor
 * @since 3.50.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 */ var Euler = new Class({
                    initialize: function Euler(x, y, z, order) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (z === undefined) z = 0;
                        if (order === undefined) order = Euler.DefaultOrder;
                        this._x = x;
                        this._y = y;
                        this._z = z;
                        this._order = order;
                        this.onChangeCallback = NOOP;
                    },
                    x: {
                        get: function() {
                            return this._x;
                        },
                        set: function(value) {
                            this._x = value;
                            this.onChangeCallback(this);
                        }
                    },
                    y: {
                        get: function() {
                            return this._y;
                        },
                        set: function(value) {
                            this._y = value;
                            this.onChangeCallback(this);
                        }
                    },
                    z: {
                        get: function() {
                            return this._z;
                        },
                        set: function(value) {
                            this._z = value;
                            this.onChangeCallback(this);
                        }
                    },
                    order: {
                        get: function() {
                            return this._order;
                        },
                        set: function(value) {
                            this._order = value;
                            this.onChangeCallback(this);
                        }
                    },
                    set: function(x, y, z, order) {
                        if (order === undefined) order = this._order;
                        this._x = x;
                        this._y = y;
                        this._z = z;
                        this._order = order;
                        this.onChangeCallback(this);
                        return this;
                    },
                    copy: function(euler) {
                        return this.set(euler.x, euler.y, euler.z, euler.order);
                    },
                    setFromQuaternion: function(quaternion, order, update) {
                        if (order === undefined) order = this._order;
                        if (update === undefined) update = false;
                        tempMatrix.fromQuat(quaternion);
                        return this.setFromRotationMatrix(tempMatrix, order, update);
                    },
                    setFromRotationMatrix: function(matrix, order, update) {
                        if (order === undefined) order = this._order;
                        if (update === undefined) update = false;
                        var elements = matrix.val;
                        //  Upper 3x3 of matrix is un-scaled rotation matrix
                        var m11 = elements[0];
                        var m12 = elements[4];
                        var m13 = elements[8];
                        var m21 = elements[1];
                        var m22 = elements[5];
                        var m23 = elements[9];
                        var m31 = elements[2];
                        var m32 = elements[6];
                        var m33 = elements[10];
                        var x = 0;
                        var y = 0;
                        var z = 0;
                        var epsilon = 0.99999;
                        switch(order){
                            case 'XYZ':
                                y = Math.asin(Clamp(m13, -1, 1));
                                if (Math.abs(m13) < epsilon) {
                                    x = Math.atan2(-m23, m33);
                                    z = Math.atan2(-m12, m11);
                                } else x = Math.atan2(m32, m22);
                                break;
                            case 'YXZ':
                                x = Math.asin(-Clamp(m23, -1, 1));
                                if (Math.abs(m23) < epsilon) {
                                    y = Math.atan2(m13, m33);
                                    z = Math.atan2(m21, m22);
                                } else y = Math.atan2(-m31, m11);
                                break;
                            case 'ZXY':
                                x = Math.asin(Clamp(m32, -1, 1));
                                if (Math.abs(m32) < epsilon) {
                                    y = Math.atan2(-m31, m33);
                                    z = Math.atan2(-m12, m22);
                                } else z = Math.atan2(m21, m11);
                                break;
                            case 'ZYX':
                                y = Math.asin(-Clamp(m31, -1, 1));
                                if (Math.abs(m31) < epsilon) {
                                    x = Math.atan2(m32, m33);
                                    z = Math.atan2(m21, m11);
                                } else z = Math.atan2(-m12, m22);
                                break;
                            case 'YZX':
                                z = Math.asin(Clamp(m21, -1, 1));
                                if (Math.abs(m21) < epsilon) {
                                    x = Math.atan2(-m23, m22);
                                    y = Math.atan2(-m31, m11);
                                } else y = Math.atan2(m13, m33);
                                break;
                            case 'XZY':
                                z = Math.asin(-Clamp(m12, -1, 1));
                                if (Math.abs(m12) < epsilon) {
                                    x = Math.atan2(m32, m22);
                                    y = Math.atan2(m13, m11);
                                } else x = Math.atan2(-m23, m33);
                                break;
                        }
                        this._x = x;
                        this._y = y;
                        this._z = z;
                        this._order = order;
                        if (update) this.onChangeCallback(this);
                        return this;
                    }
                });
                Euler.RotationOrders = [
                    'XYZ',
                    'YXZ',
                    'ZXY',
                    'ZYX',
                    'YZX',
                    'XZY'
                ];
                Euler.DefaultOrder = 'XYZ';
                module1.exports = Euler;
            /***/ },
            /***/ 6411: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the factorial of a given number for integer values greater than 0.
 *
 * @function Phaser.Math.Factorial
 * @since 3.0.0
 *
 * @param {number} value - A positive integer to calculate the factorial of.
 *
 * @return {number} The factorial of the given number.
 */ var Factorial = function(value) {
                    if (value === 0) return 1;
                    var res = value;
                    while(--value)res *= value;
                    return res;
                };
                module1.exports = Factorial;
            /***/ },
            /***/ 99472: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate a random floating point number between the two given bounds, minimum inclusive, maximum exclusive.
 *
 * @function Phaser.Math.FloatBetween
 * @since 3.0.0
 *
 * @param {number} min - The lower bound for the float, inclusive.
 * @param {number} max - The upper bound for the float exclusive.
 *
 * @return {number} A random float within the given range.
 */ var FloatBetween = function(min, max) {
                    return Math.random() * (max - min) + min;
                };
                module1.exports = FloatBetween;
            /***/ },
            /***/ 77623: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Floors to some place comparative to a `base`, default is 10 for decimal place.
 *
 * The `place` is represented by the power applied to `base` to get that place.
 *
 * @function Phaser.Math.FloorTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var FloorTo = function(value, place, base) {
                    if (place === undefined) place = 0;
                    if (base === undefined) base = 10;
                    var p = Math.pow(base, -place);
                    return Math.floor(value * p) / p;
                };
                module1.exports = FloorTo;
            /***/ },
            /***/ 62945: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                /**
 * Return a value based on the range between `min` and `max` and the percentage given.
 *
 * @function Phaser.Math.FromPercent
 * @since 3.0.0
 *
 * @param {number} percent - A value between 0 and 1 representing the percentage.
 * @param {number} min - The minimum value.
 * @param {number} [max] - The maximum value.
 *
 * @return {number} The value that is `percent` percent between `min` and `max`.
 */ var FromPercent = function(percent, min, max) {
                    percent = Clamp(percent, 0, 1);
                    return (max - min) * percent + min;
                };
                module1.exports = FromPercent;
            /***/ },
            /***/ 38265: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a per-ms speed from a distance and time (given in seconds).
 *
 * @function Phaser.Math.GetSpeed
 * @since 3.0.0
 *
 * @param {number} distance - The distance.
 * @param {number} time - The time, in seconds.
 *
 * @return {number} The speed, in distance per ms.
 *
 * @example
 * // 400px over 1 second is 0.4 px/ms
 * Phaser.Math.GetSpeed(400, 1) // -> 0.4
 */ var GetSpeed = function(distance, time) {
                    return distance / time / 1000;
                };
                module1.exports = GetSpeed;
            /***/ },
            /***/ 78702: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if a given value is an even number.
 *
 * @function Phaser.Math.IsEven
 * @since 3.0.0
 *
 * @param {number} value - The number to perform the check with.
 *
 * @return {boolean} Whether the number is even or not.
 */ var IsEven = function(value) {
                    // Use abstract equality == for "is number" test
                    // eslint-disable-next-line eqeqeq
                    return value == parseFloat(value) ? !(value % 2) : void 0;
                };
                module1.exports = IsEven;
            /***/ },
            /***/ 94883: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if a given value is an even number using a strict type check.
 *
 * @function Phaser.Math.IsEvenStrict
 * @since 3.0.0
 *
 * @param {number} value - The number to perform the check with.
 *
 * @return {boolean} Whether the number is even or not.
 */ var IsEvenStrict = function(value) {
                    // Use strict equality === for "is number" test
                    return value === parseFloat(value) ? !(value % 2) : void 0;
                };
                module1.exports = IsEvenStrict;
            /***/ },
            /***/ 28915: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates a linear (interpolation) value over t.
 *
 * @function Phaser.Math.Linear
 * @since 3.0.0
 *
 * @param {number} p0 - The first point.
 * @param {number} p1 - The second point.
 * @param {number} t - The percentage between p0 and p1 to return, represented as a number between 0 and 1.
 *
 * @return {number} The step t% of the way between p0 and p1.
 */ var Linear = function(p0, p1, t) {
                    return (p1 - p0) * t + p0;
                };
                module1.exports = Linear;
            /***/ },
            /***/ 94908: /***/ (module1)=>{
                /**
 * @author       Greg McLean <GregDevProjects>
 * @copyright    2021 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Interpolates two given Vectors and returns a new Vector between them.
 *
 * Does not modify either of the passed Vectors.
 *
 * @function Phaser.Math.LinearXY
 * @since 3.60.0
 *
 * @param {Phaser.Math.Vector2} vector1 - Starting vector
 * @param {Phaser.Math.Vector2} vector2 - Ending vector
 * @param {number} [t=0] - The percentage between vector1 and vector2 to return, represented as a number between 0 and 1.
 *
 * @return {Phaser.Math.Vector2} The step t% of the way between vector1 and vector2.
 */ var LinearXY = function(vector1, vector2, t) {
                    if (t === undefined) t = 0;
                    return vector1.clone().lerp(vector2, t);
                };
                module1.exports = LinearXY;
            /***/ },
            /***/ 94434: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
                //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
                var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A three-dimensional matrix.
 *
 * Defaults to the identity matrix when instantiated.
 *
 * @class Matrix3
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Math.Matrix3} [m] - Optional Matrix3 to copy values from.
 */ var Matrix3 = new Class({
                    initialize: function Matrix3(m) {
                        /**
         * The matrix values.
         *
         * @name Phaser.Math.Matrix3#val
         * @type {Float32Array}
         * @since 3.0.0
         */ this.val = new Float32Array(9);
                        if (m) //  Assume Matrix3 with val:
                        this.copy(m);
                        else //  Default to identity
                        this.identity();
                    },
                    /**
     * Make a clone of this Matrix3.
     *
     * @method Phaser.Math.Matrix3#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} A clone of this Matrix3.
     */ clone: function() {
                        return new Matrix3(this);
                    },
                    /**
     * This method is an alias for `Matrix3.copy`.
     *
     * @method Phaser.Math.Matrix3#set
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to set the values of this Matrix's from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ set: function(src) {
                        return this.copy(src);
                    },
                    /**
     * Copy the values of a given Matrix into this Matrix.
     *
     * @method Phaser.Math.Matrix3#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ copy: function(src) {
                        var out = this.val;
                        var a = src.val;
                        out[0] = a[0];
                        out[1] = a[1];
                        out[2] = a[2];
                        out[3] = a[3];
                        out[4] = a[4];
                        out[5] = a[5];
                        out[6] = a[6];
                        out[7] = a[7];
                        out[8] = a[8];
                        return this;
                    },
                    /**
     * Copy the values of a given Matrix4 into this Matrix3.
     *
     * @method Phaser.Math.Matrix3#fromMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromMat4: function(m) {
                        var a = m.val;
                        var out = this.val;
                        out[0] = a[0];
                        out[1] = a[1];
                        out[2] = a[2];
                        out[3] = a[4];
                        out[4] = a[5];
                        out[5] = a[6];
                        out[6] = a[8];
                        out[7] = a[9];
                        out[8] = a[10];
                        return this;
                    },
                    /**
     * Set the values of this Matrix from the given array.
     *
     * @method Phaser.Math.Matrix3#fromArray
     * @since 3.0.0
     *
     * @param {array} a - The array to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromArray: function(a) {
                        var out = this.val;
                        out[0] = a[0];
                        out[1] = a[1];
                        out[2] = a[2];
                        out[3] = a[3];
                        out[4] = a[4];
                        out[5] = a[5];
                        out[6] = a[6];
                        out[7] = a[7];
                        out[8] = a[8];
                        return this;
                    },
                    /**
     * Reset this Matrix to an identity (default) matrix.
     *
     * @method Phaser.Math.Matrix3#identity
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ identity: function() {
                        var out = this.val;
                        out[0] = 1;
                        out[1] = 0;
                        out[2] = 0;
                        out[3] = 0;
                        out[4] = 1;
                        out[5] = 0;
                        out[6] = 0;
                        out[7] = 0;
                        out[8] = 1;
                        return this;
                    },
                    /**
     * Transpose this Matrix.
     *
     * @method Phaser.Math.Matrix3#transpose
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ transpose: function() {
                        var a = this.val;
                        var a01 = a[1];
                        var a02 = a[2];
                        var a12 = a[5];
                        a[1] = a[3];
                        a[2] = a[6];
                        a[3] = a01;
                        a[5] = a[7];
                        a[6] = a02;
                        a[7] = a12;
                        return this;
                    },
                    /**
     * Invert this Matrix.
     *
     * @method Phaser.Math.Matrix3#invert
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ invert: function() {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a10 = a[3];
                        var a11 = a[4];
                        var a12 = a[5];
                        var a20 = a[6];
                        var a21 = a[7];
                        var a22 = a[8];
                        var b01 = a22 * a11 - a12 * a21;
                        var b11 = -a22 * a10 + a12 * a20;
                        var b21 = a21 * a10 - a11 * a20;
                        // Calculate the determinant
                        var det = a00 * b01 + a01 * b11 + a02 * b21;
                        if (!det) return null;
                        det = 1 / det;
                        a[0] = b01 * det;
                        a[1] = (-a22 * a01 + a02 * a21) * det;
                        a[2] = (a12 * a01 - a02 * a11) * det;
                        a[3] = b11 * det;
                        a[4] = (a22 * a00 - a02 * a20) * det;
                        a[5] = (-a12 * a00 + a02 * a10) * det;
                        a[6] = b21 * det;
                        a[7] = (-a21 * a00 + a01 * a20) * det;
                        a[8] = (a11 * a00 - a01 * a10) * det;
                        return this;
                    },
                    /**
     * Calculate the adjoint, or adjugate, of this Matrix.
     *
     * @method Phaser.Math.Matrix3#adjoint
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ adjoint: function() {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a10 = a[3];
                        var a11 = a[4];
                        var a12 = a[5];
                        var a20 = a[6];
                        var a21 = a[7];
                        var a22 = a[8];
                        a[0] = a11 * a22 - a12 * a21;
                        a[1] = a02 * a21 - a01 * a22;
                        a[2] = a01 * a12 - a02 * a11;
                        a[3] = a12 * a20 - a10 * a22;
                        a[4] = a00 * a22 - a02 * a20;
                        a[5] = a02 * a10 - a00 * a12;
                        a[6] = a10 * a21 - a11 * a20;
                        a[7] = a01 * a20 - a00 * a21;
                        a[8] = a00 * a11 - a01 * a10;
                        return this;
                    },
                    /**
     * Calculate the determinant of this Matrix.
     *
     * @method Phaser.Math.Matrix3#determinant
     * @since 3.0.0
     *
     * @return {number} The determinant of this Matrix.
     */ determinant: function() {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a10 = a[3];
                        var a11 = a[4];
                        var a12 = a[5];
                        var a20 = a[6];
                        var a21 = a[7];
                        var a22 = a[8];
                        return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
                    },
                    /**
     * Multiply this Matrix by the given Matrix.
     *
     * @method Phaser.Math.Matrix3#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to multiply this Matrix by.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ multiply: function(src) {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a10 = a[3];
                        var a11 = a[4];
                        var a12 = a[5];
                        var a20 = a[6];
                        var a21 = a[7];
                        var a22 = a[8];
                        var b = src.val;
                        var b00 = b[0];
                        var b01 = b[1];
                        var b02 = b[2];
                        var b10 = b[3];
                        var b11 = b[4];
                        var b12 = b[5];
                        var b20 = b[6];
                        var b21 = b[7];
                        var b22 = b[8];
                        a[0] = b00 * a00 + b01 * a10 + b02 * a20;
                        a[1] = b00 * a01 + b01 * a11 + b02 * a21;
                        a[2] = b00 * a02 + b01 * a12 + b02 * a22;
                        a[3] = b10 * a00 + b11 * a10 + b12 * a20;
                        a[4] = b10 * a01 + b11 * a11 + b12 * a21;
                        a[5] = b10 * a02 + b11 * a12 + b12 * a22;
                        a[6] = b20 * a00 + b21 * a10 + b22 * a20;
                        a[7] = b20 * a01 + b21 * a11 + b22 * a21;
                        a[8] = b20 * a02 + b21 * a12 + b22 * a22;
                        return this;
                    },
                    /**
     * Translate this Matrix using the given Vector.
     *
     * @method Phaser.Math.Matrix3#translate
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to translate this Matrix with.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ translate: function(v) {
                        var a = this.val;
                        var x = v.x;
                        var y = v.y;
                        a[6] = x * a[0] + y * a[3] + a[6];
                        a[7] = x * a[1] + y * a[4] + a[7];
                        a[8] = x * a[2] + y * a[5] + a[8];
                        return this;
                    },
                    /**
     * Apply a rotation transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix3#rotate
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ rotate: function(rad) {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a10 = a[3];
                        var a11 = a[4];
                        var a12 = a[5];
                        var s = Math.sin(rad);
                        var c = Math.cos(rad);
                        a[0] = c * a00 + s * a10;
                        a[1] = c * a01 + s * a11;
                        a[2] = c * a02 + s * a12;
                        a[3] = c * a10 - s * a00;
                        a[4] = c * a11 - s * a01;
                        a[5] = c * a12 - s * a02;
                        return this;
                    },
                    /**
     * Apply a scale transformation to this Matrix.
     *
     * Uses the `x` and `y` components of the given Vector to scale the Matrix.
     *
     * @method Phaser.Math.Matrix3#scale
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to scale this Matrix with.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ scale: function(v) {
                        var a = this.val;
                        var x = v.x;
                        var y = v.y;
                        a[0] = x * a[0];
                        a[1] = x * a[1];
                        a[2] = x * a[2];
                        a[3] = y * a[3];
                        a[4] = y * a[4];
                        a[5] = y * a[5];
                        return this;
                    },
                    /**
     * Set the values of this Matrix from the given Quaternion.
     *
     * @method Phaser.Math.Matrix3#fromQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set the values of this Matrix from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromQuat: function(q) {
                        var x = q.x;
                        var y = q.y;
                        var z = q.z;
                        var w = q.w;
                        var x2 = x + x;
                        var y2 = y + y;
                        var z2 = z + z;
                        var xx = x * x2;
                        var xy = x * y2;
                        var xz = x * z2;
                        var yy = y * y2;
                        var yz = y * z2;
                        var zz = z * z2;
                        var wx = w * x2;
                        var wy = w * y2;
                        var wz = w * z2;
                        var out = this.val;
                        out[0] = 1 - (yy + zz);
                        out[3] = xy + wz;
                        out[6] = xz - wy;
                        out[1] = xy - wz;
                        out[4] = 1 - (xx + zz);
                        out[7] = yz + wx;
                        out[2] = xz + wy;
                        out[5] = yz - wx;
                        out[8] = 1 - (xx + yy);
                        return this;
                    },
                    /**
     * Set the values of this Matrix3 to be normalized from the given Matrix4.
     *
     * @method Phaser.Math.Matrix3#normalFromMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to normalize the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ normalFromMat4: function(m) {
                        var a = m.val;
                        var out = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        var a30 = a[12];
                        var a31 = a[13];
                        var a32 = a[14];
                        var a33 = a[15];
                        var b00 = a00 * a11 - a01 * a10;
                        var b01 = a00 * a12 - a02 * a10;
                        var b02 = a00 * a13 - a03 * a10;
                        var b03 = a01 * a12 - a02 * a11;
                        var b04 = a01 * a13 - a03 * a11;
                        var b05 = a02 * a13 - a03 * a12;
                        var b06 = a20 * a31 - a21 * a30;
                        var b07 = a20 * a32 - a22 * a30;
                        var b08 = a20 * a33 - a23 * a30;
                        var b09 = a21 * a32 - a22 * a31;
                        var b10 = a21 * a33 - a23 * a31;
                        var b11 = a22 * a33 - a23 * a32;
                        // Calculate the determinant
                        var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                        if (!det) return null;
                        det = 1 / det;
                        out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
                        out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
                        out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
                        out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
                        out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
                        out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
                        out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
                        out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
                        out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
                        return this;
                    }
                });
                module1.exports = Matrix3;
            /***/ },
            /***/ 37867: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Vector3 = __webpack_require__(25836);
                /**
 * @ignore
 */ var EPSILON = 0.000001;
                /**
 * @classdesc
 * A four-dimensional matrix.
 *
 * Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
 * and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
 *
 * @class Matrix4
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Math.Matrix4} [m] - Optional Matrix4 to copy values from.
 */ var Matrix4 = new Class({
                    initialize: function Matrix4(m) {
                        /**
         * The matrix values.
         *
         * @name Phaser.Math.Matrix4#val
         * @type {Float32Array}
         * @since 3.0.0
         */ this.val = new Float32Array(16);
                        if (m) //  Assume Matrix4 with val:
                        this.copy(m);
                        else //  Default to identity
                        this.identity();
                    },
                    /**
     * Make a clone of this Matrix4.
     *
     * @method Phaser.Math.Matrix4#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix4} A clone of this Matrix4.
     */ clone: function() {
                        return new Matrix4(this);
                    },
                    /**
     * This method is an alias for `Matrix4.copy`.
     *
     * @method Phaser.Math.Matrix4#set
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to set the values of this Matrix's from.
     *
     * @return {this} This Matrix4.
     */ set: function(src) {
                        return this.copy(src);
                    },
                    /**
     * Sets all values of this Matrix4.
     *
     * @method Phaser.Math.Matrix4#setValues
     * @since 3.50.0
     *
     * @param {number} m00 - The m00 value.
     * @param {number} m01 - The m01 value.
     * @param {number} m02 - The m02 value.
     * @param {number} m03 - The m03 value.
     * @param {number} m10 - The m10 value.
     * @param {number} m11 - The m11 value.
     * @param {number} m12 - The m12 value.
     * @param {number} m13 - The m13 value.
     * @param {number} m20 - The m20 value.
     * @param {number} m21 - The m21 value.
     * @param {number} m22 - The m22 value.
     * @param {number} m23 - The m23 value.
     * @param {number} m30 - The m30 value.
     * @param {number} m31 - The m31 value.
     * @param {number} m32 - The m32 value.
     * @param {number} m33 - The m33 value.
     *
     * @return {this} This Matrix4 instance.
     */ setValues: function(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
                        var out = this.val;
                        out[0] = m00;
                        out[1] = m01;
                        out[2] = m02;
                        out[3] = m03;
                        out[4] = m10;
                        out[5] = m11;
                        out[6] = m12;
                        out[7] = m13;
                        out[8] = m20;
                        out[9] = m21;
                        out[10] = m22;
                        out[11] = m23;
                        out[12] = m30;
                        out[13] = m31;
                        out[14] = m32;
                        out[15] = m33;
                        return this;
                    },
                    /**
     * Copy the values of a given Matrix into this Matrix.
     *
     * @method Phaser.Math.Matrix4#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to copy the values from.
     *
     * @return {this} This Matrix4.
     */ copy: function(src) {
                        var a = src.val;
                        return this.setValues(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
                    },
                    /**
     * Set the values of this Matrix from the given array.
     *
     * @method Phaser.Math.Matrix4#fromArray
     * @since 3.0.0
     *
     * @param {number[]} a - The array to copy the values from. Must have at least 16 elements.
     *
     * @return {this} This Matrix4.
     */ fromArray: function(a) {
                        return this.setValues(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
                    },
                    /**
     * Reset this Matrix.
     *
     * Sets all values to `0`.
     *
     * @method Phaser.Math.Matrix4#zero
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix4} This Matrix4.
     */ zero: function() {
                        return this.setValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                    },
                    /**
     * Generates a transform matrix based on the given position, scale and rotation.
     *
     * @method Phaser.Math.Matrix4#transform
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} position - The position vector.
     * @param {Phaser.Math.Vector3} scale - The scale vector.
     * @param {Phaser.Math.Quaternion} rotation - The rotation quaternion.
     *
     * @return {this} This Matrix4.
     */ transform: function(position, scale, rotation) {
                        var rotMatrix = _tempMat1.fromQuat(rotation);
                        var rm = rotMatrix.val;
                        var sx = scale.x;
                        var sy = scale.y;
                        var sz = scale.z;
                        return this.setValues(rm[0] * sx, rm[1] * sx, rm[2] * sx, 0, rm[4] * sy, rm[5] * sy, rm[6] * sy, 0, rm[8] * sz, rm[9] * sz, rm[10] * sz, 0, position.x, position.y, position.z, 1);
                    },
                    /**
     * Set the `x`, `y` and `z` values of this Matrix.
     *
     * @method Phaser.Math.Matrix4#xyz
     * @since 3.0.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {number} z - The z value.
     *
     * @return {this} This Matrix4.
     */ xyz: function(x, y, z) {
                        this.identity();
                        var out = this.val;
                        out[12] = x;
                        out[13] = y;
                        out[14] = z;
                        return this;
                    },
                    /**
     * Set the scaling values of this Matrix.
     *
     * @method Phaser.Math.Matrix4#scaling
     * @since 3.0.0
     *
     * @param {number} x - The x scaling value.
     * @param {number} y - The y scaling value.
     * @param {number} z - The z scaling value.
     *
     * @return {this} This Matrix4.
     */ scaling: function(x, y, z) {
                        this.zero();
                        var out = this.val;
                        out[0] = x;
                        out[5] = y;
                        out[10] = z;
                        out[15] = 1;
                        return this;
                    },
                    /**
     * Reset this Matrix to an identity (default) matrix.
     *
     * @method Phaser.Math.Matrix4#identity
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ identity: function() {
                        return this.setValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                    },
                    /**
     * Transpose this Matrix.
     *
     * @method Phaser.Math.Matrix4#transpose
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ transpose: function() {
                        var a = this.val;
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a23 = a[11];
                        a[1] = a[4];
                        a[2] = a[8];
                        a[3] = a[12];
                        a[4] = a01;
                        a[6] = a[9];
                        a[7] = a[13];
                        a[8] = a02;
                        a[9] = a12;
                        a[11] = a[14];
                        a[12] = a03;
                        a[13] = a13;
                        a[14] = a23;
                        return this;
                    },
                    /**
     * Copies the given Matrix4 into this Matrix and then inverses it.
     *
     * @method Phaser.Math.Matrix4#getInverse
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to invert into this Matrix4.
     *
     * @return {this} This Matrix4.
     */ getInverse: function(m) {
                        this.copy(m);
                        return this.invert();
                    },
                    /**
     * Invert this Matrix.
     *
     * @method Phaser.Math.Matrix4#invert
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ invert: function() {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        var a30 = a[12];
                        var a31 = a[13];
                        var a32 = a[14];
                        var a33 = a[15];
                        var b00 = a00 * a11 - a01 * a10;
                        var b01 = a00 * a12 - a02 * a10;
                        var b02 = a00 * a13 - a03 * a10;
                        var b03 = a01 * a12 - a02 * a11;
                        var b04 = a01 * a13 - a03 * a11;
                        var b05 = a02 * a13 - a03 * a12;
                        var b06 = a20 * a31 - a21 * a30;
                        var b07 = a20 * a32 - a22 * a30;
                        var b08 = a20 * a33 - a23 * a30;
                        var b09 = a21 * a32 - a22 * a31;
                        var b10 = a21 * a33 - a23 * a31;
                        var b11 = a22 * a33 - a23 * a32;
                        //  Calculate the determinant
                        var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                        if (!det) return this;
                        det = 1 / det;
                        return this.setValues((a11 * b11 - a12 * b10 + a13 * b09) * det, (a02 * b10 - a01 * b11 - a03 * b09) * det, (a31 * b05 - a32 * b04 + a33 * b03) * det, (a22 * b04 - a21 * b05 - a23 * b03) * det, (a12 * b08 - a10 * b11 - a13 * b07) * det, (a00 * b11 - a02 * b08 + a03 * b07) * det, (a32 * b02 - a30 * b05 - a33 * b01) * det, (a20 * b05 - a22 * b02 + a23 * b01) * det, (a10 * b10 - a11 * b08 + a13 * b06) * det, (a01 * b08 - a00 * b10 - a03 * b06) * det, (a30 * b04 - a31 * b02 + a33 * b00) * det, (a21 * b02 - a20 * b04 - a23 * b00) * det, (a11 * b07 - a10 * b09 - a12 * b06) * det, (a00 * b09 - a01 * b07 + a02 * b06) * det, (a31 * b01 - a30 * b03 - a32 * b00) * det, (a20 * b03 - a21 * b01 + a22 * b00) * det);
                    },
                    /**
     * Calculate the adjoint, or adjugate, of this Matrix.
     *
     * @method Phaser.Math.Matrix4#adjoint
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ adjoint: function() {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        var a30 = a[12];
                        var a31 = a[13];
                        var a32 = a[14];
                        var a33 = a[15];
                        return this.setValues(a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22), -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22)), a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12), -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12)), -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22)), a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22), -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12)), a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12), a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21), -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21)), a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11), -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11)), -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21)), a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21), -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11)), a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
                    },
                    /**
     * Calculate the determinant of this Matrix.
     *
     * @method Phaser.Math.Matrix4#determinant
     * @since 3.0.0
     *
     * @return {number} The determinant of this Matrix.
     */ determinant: function() {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        var a30 = a[12];
                        var a31 = a[13];
                        var a32 = a[14];
                        var a33 = a[15];
                        var b00 = a00 * a11 - a01 * a10;
                        var b01 = a00 * a12 - a02 * a10;
                        var b02 = a00 * a13 - a03 * a10;
                        var b03 = a01 * a12 - a02 * a11;
                        var b04 = a01 * a13 - a03 * a11;
                        var b05 = a02 * a13 - a03 * a12;
                        var b06 = a20 * a31 - a21 * a30;
                        var b07 = a20 * a32 - a22 * a30;
                        var b08 = a20 * a33 - a23 * a30;
                        var b09 = a21 * a32 - a22 * a31;
                        var b10 = a21 * a33 - a23 * a31;
                        var b11 = a22 * a33 - a23 * a32;
                        // Calculate the determinant
                        return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                    },
                    /**
     * Multiply this Matrix by the given Matrix.
     *
     * @method Phaser.Math.Matrix4#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to multiply this Matrix by.
     *
     * @return {this} This Matrix4.
     */ multiply: function(src) {
                        var a = this.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        var a30 = a[12];
                        var a31 = a[13];
                        var a32 = a[14];
                        var a33 = a[15];
                        var b = src.val;
                        // Cache only the current line of the second matrix
                        var b0 = b[0];
                        var b1 = b[1];
                        var b2 = b[2];
                        var b3 = b[3];
                        a[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                        a[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                        a[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                        a[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                        b0 = b[4];
                        b1 = b[5];
                        b2 = b[6];
                        b3 = b[7];
                        a[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                        a[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                        a[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                        a[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                        b0 = b[8];
                        b1 = b[9];
                        b2 = b[10];
                        b3 = b[11];
                        a[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                        a[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                        a[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                        a[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                        b0 = b[12];
                        b1 = b[13];
                        b2 = b[14];
                        b3 = b[15];
                        a[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                        a[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                        a[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                        a[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                        return this;
                    },
                    /**
     * Multiply the values of this Matrix4 by those given in the `src` argument.
     *
     * @method Phaser.Math.Matrix4#multiplyLocal
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The source Matrix4 that this Matrix4 is multiplied by.
     *
     * @return {this} This Matrix4.
     */ multiplyLocal: function(src) {
                        var a = this.val;
                        var b = src.val;
                        return this.setValues(a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12], a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13], a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14], a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15], a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12], a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13], a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14], a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15], a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12], a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13], a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14], a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15], a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12], a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13], a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14], a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15]);
                    },
                    /**
     * Multiplies the given Matrix4 object with this Matrix.
     *
     * This is the same as calling `multiplyMatrices(m, this)`.
     *
     * @method Phaser.Math.Matrix4#premultiply
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to multiply with this one.
     *
     * @return {this} This Matrix4.
     */ premultiply: function(m) {
                        return this.multiplyMatrices(m, this);
                    },
                    /**
     * Multiplies the two given Matrix4 objects and stores the results in this Matrix.
     *
     * @method Phaser.Math.Matrix4#multiplyMatrices
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} a - The first Matrix4 to multiply.
     * @param {Phaser.Math.Matrix4} b - The second Matrix4 to multiply.
     *
     * @return {this} This Matrix4.
     */ multiplyMatrices: function(a, b) {
                        var am = a.val;
                        var bm = b.val;
                        var a11 = am[0];
                        var a12 = am[4];
                        var a13 = am[8];
                        var a14 = am[12];
                        var a21 = am[1];
                        var a22 = am[5];
                        var a23 = am[9];
                        var a24 = am[13];
                        var a31 = am[2];
                        var a32 = am[6];
                        var a33 = am[10];
                        var a34 = am[14];
                        var a41 = am[3];
                        var a42 = am[7];
                        var a43 = am[11];
                        var a44 = am[15];
                        var b11 = bm[0];
                        var b12 = bm[4];
                        var b13 = bm[8];
                        var b14 = bm[12];
                        var b21 = bm[1];
                        var b22 = bm[5];
                        var b23 = bm[9];
                        var b24 = bm[13];
                        var b31 = bm[2];
                        var b32 = bm[6];
                        var b33 = bm[10];
                        var b34 = bm[14];
                        var b41 = bm[3];
                        var b42 = bm[7];
                        var b43 = bm[11];
                        var b44 = bm[15];
                        return this.setValues(a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41, a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41, a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41, a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41, a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42, a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42, a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42, a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42, a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43, a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43, a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43, a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43, a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44, a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44, a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44, a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44);
                    },
                    /**
     * Translate this Matrix using the given Vector.
     *
     * @method Phaser.Math.Matrix4#translate
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to translate this Matrix with.
     *
     * @return {this} This Matrix4.
     */ translate: function(v) {
                        return this.translateXYZ(v.x, v.y, v.z);
                    },
                    /**
     * Translate this Matrix using the given values.
     *
     * @method Phaser.Math.Matrix4#translateXYZ
     * @since 3.16.0
     *
     * @param {number} x - The x component.
     * @param {number} y - The y component.
     * @param {number} z - The z component.
     *
     * @return {this} This Matrix4.
     */ translateXYZ: function(x, y, z) {
                        var a = this.val;
                        a[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
                        a[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
                        a[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
                        a[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
                        return this;
                    },
                    /**
     * Apply a scale transformation to this Matrix.
     *
     * Uses the `x`, `y` and `z` components of the given Vector to scale the Matrix.
     *
     * @method Phaser.Math.Matrix4#scale
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to scale this Matrix with.
     *
     * @return {this} This Matrix4.
     */ scale: function(v) {
                        return this.scaleXYZ(v.x, v.y, v.z);
                    },
                    /**
     * Apply a scale transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix4#scaleXYZ
     * @since 3.16.0
     *
     * @param {number} x - The x component.
     * @param {number} y - The y component.
     * @param {number} z - The z component.
     *
     * @return {this} This Matrix4.
     */ scaleXYZ: function(x, y, z) {
                        var a = this.val;
                        a[0] = a[0] * x;
                        a[1] = a[1] * x;
                        a[2] = a[2] * x;
                        a[3] = a[3] * x;
                        a[4] = a[4] * y;
                        a[5] = a[5] * y;
                        a[6] = a[6] * y;
                        a[7] = a[7] * y;
                        a[8] = a[8] * z;
                        a[9] = a[9] * z;
                        a[10] = a[10] * z;
                        a[11] = a[11] * z;
                        return this;
                    },
                    /**
     * Derive a rotation matrix around the given axis.
     *
     * @method Phaser.Math.Matrix4#makeRotationAxis
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} axis - The rotation axis.
     * @param {number} angle - The rotation angle in radians.
     *
     * @return {this} This Matrix4.
     */ makeRotationAxis: function(axis, angle) {
                        // Based on http://www.gamedev.net/reference/articles/article1199.asp
                        var c = Math.cos(angle);
                        var s = Math.sin(angle);
                        var t = 1 - c;
                        var x = axis.x;
                        var y = axis.y;
                        var z = axis.z;
                        var tx = t * x;
                        var ty = t * y;
                        return this.setValues(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
                    },
                    /**
     * Apply a rotation transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix4#rotate
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     * @param {Phaser.Math.Vector3} axis - The axis to rotate upon.
     *
     * @return {this} This Matrix4.
     */ rotate: function(rad, axis) {
                        var a = this.val;
                        var x = axis.x;
                        var y = axis.y;
                        var z = axis.z;
                        var len = Math.sqrt(x * x + y * y + z * z);
                        if (Math.abs(len) < EPSILON) return this;
                        len = 1 / len;
                        x *= len;
                        y *= len;
                        z *= len;
                        var s = Math.sin(rad);
                        var c = Math.cos(rad);
                        var t = 1 - c;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        var a30 = a[12];
                        var a31 = a[13];
                        var a32 = a[14];
                        var a33 = a[15];
                        //  Construct the elements of the rotation matrix
                        var b00 = x * x * t + c;
                        var b01 = y * x * t + z * s;
                        var b02 = z * x * t - y * s;
                        var b10 = x * y * t - z * s;
                        var b11 = y * y * t + c;
                        var b12 = z * y * t + x * s;
                        var b20 = x * z * t + y * s;
                        var b21 = y * z * t - x * s;
                        var b22 = z * z * t + c;
                        //  Perform rotation-specific matrix multiplication
                        return this.setValues(a00 * b00 + a10 * b01 + a20 * b02, a01 * b00 + a11 * b01 + a21 * b02, a02 * b00 + a12 * b01 + a22 * b02, a03 * b00 + a13 * b01 + a23 * b02, a00 * b10 + a10 * b11 + a20 * b12, a01 * b10 + a11 * b11 + a21 * b12, a02 * b10 + a12 * b11 + a22 * b12, a03 * b10 + a13 * b11 + a23 * b12, a00 * b20 + a10 * b21 + a20 * b22, a01 * b20 + a11 * b21 + a21 * b22, a02 * b20 + a12 * b21 + a22 * b22, a03 * b20 + a13 * b21 + a23 * b22, a30, a31, a32, a33);
                    },
                    /**
     * Rotate this matrix on its X axis.
     *
     * @method Phaser.Math.Matrix4#rotateX
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     *
     * @return {this} This Matrix4.
     */ rotateX: function(rad) {
                        var a = this.val;
                        var s = Math.sin(rad);
                        var c = Math.cos(rad);
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        //  Perform axis-specific matrix multiplication
                        a[4] = a10 * c + a20 * s;
                        a[5] = a11 * c + a21 * s;
                        a[6] = a12 * c + a22 * s;
                        a[7] = a13 * c + a23 * s;
                        a[8] = a20 * c - a10 * s;
                        a[9] = a21 * c - a11 * s;
                        a[10] = a22 * c - a12 * s;
                        a[11] = a23 * c - a13 * s;
                        return this;
                    },
                    /**
     * Rotate this matrix on its Y axis.
     *
     * @method Phaser.Math.Matrix4#rotateY
     * @since 3.0.0
     *
     * @param {number} rad - The angle to rotate by, in radians.
     *
     * @return {this} This Matrix4.
     */ rotateY: function(rad) {
                        var a = this.val;
                        var s = Math.sin(rad);
                        var c = Math.cos(rad);
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        //  Perform axis-specific matrix multiplication
                        a[0] = a00 * c - a20 * s;
                        a[1] = a01 * c - a21 * s;
                        a[2] = a02 * c - a22 * s;
                        a[3] = a03 * c - a23 * s;
                        a[8] = a00 * s + a20 * c;
                        a[9] = a01 * s + a21 * c;
                        a[10] = a02 * s + a22 * c;
                        a[11] = a03 * s + a23 * c;
                        return this;
                    },
                    /**
     * Rotate this matrix on its Z axis.
     *
     * @method Phaser.Math.Matrix4#rotateZ
     * @since 3.0.0
     *
     * @param {number} rad - The angle to rotate by, in radians.
     *
     * @return {this} This Matrix4.
     */ rotateZ: function(rad) {
                        var a = this.val;
                        var s = Math.sin(rad);
                        var c = Math.cos(rad);
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        //  Perform axis-specific matrix multiplication
                        a[0] = a00 * c + a10 * s;
                        a[1] = a01 * c + a11 * s;
                        a[2] = a02 * c + a12 * s;
                        a[3] = a03 * c + a13 * s;
                        a[4] = a10 * c - a00 * s;
                        a[5] = a11 * c - a01 * s;
                        a[6] = a12 * c - a02 * s;
                        a[7] = a13 * c - a03 * s;
                        return this;
                    },
                    /**
     * Set the values of this Matrix from the given rotation Quaternion and translation Vector.
     *
     * @method Phaser.Math.Matrix4#fromRotationTranslation
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set rotation from.
     * @param {Phaser.Math.Vector3} v - The Vector to set translation from.
     *
     * @return {this} This Matrix4.
     */ fromRotationTranslation: function(q, v) {
                        //  Quaternion math
                        var x = q.x;
                        var y = q.y;
                        var z = q.z;
                        var w = q.w;
                        var x2 = x + x;
                        var y2 = y + y;
                        var z2 = z + z;
                        var xx = x * x2;
                        var xy = x * y2;
                        var xz = x * z2;
                        var yy = y * y2;
                        var yz = y * z2;
                        var zz = z * z2;
                        var wx = w * x2;
                        var wy = w * y2;
                        var wz = w * z2;
                        return this.setValues(1 - (yy + zz), xy + wz, xz - wy, 0, xy - wz, 1 - (xx + zz), yz + wx, 0, xz + wy, yz - wx, 1 - (xx + yy), 0, v.x, v.y, v.z, 1);
                    },
                    /**
     * Set the values of this Matrix from the given Quaternion.
     *
     * @method Phaser.Math.Matrix4#fromQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set the values of this Matrix from.
     *
     * @return {this} This Matrix4.
     */ fromQuat: function(q) {
                        var x = q.x;
                        var y = q.y;
                        var z = q.z;
                        var w = q.w;
                        var x2 = x + x;
                        var y2 = y + y;
                        var z2 = z + z;
                        var xx = x * x2;
                        var xy = x * y2;
                        var xz = x * z2;
                        var yy = y * y2;
                        var yz = y * z2;
                        var zz = z * z2;
                        var wx = w * x2;
                        var wy = w * y2;
                        var wz = w * z2;
                        return this.setValues(1 - (yy + zz), xy + wz, xz - wy, 0, xy - wz, 1 - (xx + zz), yz + wx, 0, xz + wy, yz - wx, 1 - (xx + yy), 0, 0, 0, 0, 1);
                    },
                    /**
     * Generate a frustum matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#frustum
     * @since 3.0.0
     *
     * @param {number} left - The left bound of the frustum.
     * @param {number} right - The right bound of the frustum.
     * @param {number} bottom - The bottom bound of the frustum.
     * @param {number} top - The top bound of the frustum.
     * @param {number} near - The near bound of the frustum.
     * @param {number} far - The far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ frustum: function(left, right, bottom, top, near, far) {
                        var rl = 1 / (right - left);
                        var tb = 1 / (top - bottom);
                        var nf = 1 / (near - far);
                        return this.setValues(near * 2 * rl, 0, 0, 0, 0, near * 2 * tb, 0, 0, (right + left) * rl, (top + bottom) * tb, (far + near) * nf, -1, 0, 0, far * near * 2 * nf, 0);
                    },
                    /**
     * Generate a perspective projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#perspective
     * @since 3.0.0
     *
     * @param {number} fovy - Vertical field of view in radians
     * @param {number} aspect - Aspect ratio. Typically viewport width  /height.
     * @param {number} near - Near bound of the frustum.
     * @param {number} far - Far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ perspective: function(fovy, aspect, near, far) {
                        var f = 1.0 / Math.tan(fovy / 2);
                        var nf = 1 / (near - far);
                        return this.setValues(f / aspect, 0, 0, 0, 0, f, 0, 0, 0, 0, (far + near) * nf, -1, 0, 0, 2 * far * near * nf, 0);
                    },
                    /**
     * Generate a perspective projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#perspectiveLH
     * @since 3.0.0
     *
     * @param {number} width - The width of the frustum.
     * @param {number} height - The height of the frustum.
     * @param {number} near - Near bound of the frustum.
     * @param {number} far - Far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ perspectiveLH: function(width, height, near, far) {
                        return this.setValues(2 * near / width, 0, 0, 0, 0, 2 * near / height, 0, 0, 0, 0, -far / (near - far), 1, 0, 0, near * far / (near - far), 0);
                    },
                    /**
     * Generate an orthogonal projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#ortho
     * @since 3.0.0
     *
     * @param {number} left - The left bound of the frustum.
     * @param {number} right - The right bound of the frustum.
     * @param {number} bottom - The bottom bound of the frustum.
     * @param {number} top - The top bound of the frustum.
     * @param {number} near - The near bound of the frustum.
     * @param {number} far - The far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ ortho: function(left, right, bottom, top, near, far) {
                        var lr = left - right;
                        var bt = bottom - top;
                        var nf = near - far;
                        //  Avoid division by zero
                        lr = lr === 0 ? lr : 1 / lr;
                        bt = bt === 0 ? bt : 1 / bt;
                        nf = nf === 0 ? nf : 1 / nf;
                        return this.setValues(-2 * lr, 0, 0, 0, 0, -2 * bt, 0, 0, 0, 0, 2 * nf, 0, (left + right) * lr, (top + bottom) * bt, (far + near) * nf, 1);
                    },
                    /**
     * Generate a right-handed look-at matrix with the given eye position, target and up axis.
     *
     * @method Phaser.Math.Matrix4#lookAtRH
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} eye - Position of the viewer.
     * @param {Phaser.Math.Vector3} target - Point the viewer is looking at.
     * @param {Phaser.Math.Vector3} up - vec3 pointing up.
     *
     * @return {this} This Matrix4.
     */ lookAtRH: function(eye, target, up) {
                        var m = this.val;
                        _z.subVectors(eye, target);
                        if (_z.lengthSq() === 0) // eye and target are in the same position
                        _z.z = 1;
                        _z.normalize();
                        _x.crossVectors(up, _z);
                        if (_x.lengthSq() === 0) {
                            // up and z are parallel
                            if (Math.abs(up.z) === 1) _z.x += 0.0001;
                            else _z.z += 0.0001;
                            _z.normalize();
                            _x.crossVectors(up, _z);
                        }
                        _x.normalize();
                        _y.crossVectors(_z, _x);
                        m[0] = _x.x;
                        m[1] = _x.y;
                        m[2] = _x.z;
                        m[4] = _y.x;
                        m[5] = _y.y;
                        m[6] = _y.z;
                        m[8] = _z.x;
                        m[9] = _z.y;
                        m[10] = _z.z;
                        return this;
                    },
                    /**
     * Generate a look-at matrix with the given eye position, focal point, and up axis.
     *
     * @method Phaser.Math.Matrix4#lookAt
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} eye - Position of the viewer
     * @param {Phaser.Math.Vector3} center - Point the viewer is looking at
     * @param {Phaser.Math.Vector3} up - vec3 pointing up.
     *
     * @return {this} This Matrix4.
     */ lookAt: function(eye, center, up) {
                        var eyex = eye.x;
                        var eyey = eye.y;
                        var eyez = eye.z;
                        var upx = up.x;
                        var upy = up.y;
                        var upz = up.z;
                        var centerx = center.x;
                        var centery = center.y;
                        var centerz = center.z;
                        if (Math.abs(eyex - centerx) < EPSILON && Math.abs(eyey - centery) < EPSILON && Math.abs(eyez - centerz) < EPSILON) return this.identity();
                        var z0 = eyex - centerx;
                        var z1 = eyey - centery;
                        var z2 = eyez - centerz;
                        var len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
                        z0 *= len;
                        z1 *= len;
                        z2 *= len;
                        var x0 = upy * z2 - upz * z1;
                        var x1 = upz * z0 - upx * z2;
                        var x2 = upx * z1 - upy * z0;
                        len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
                        if (!len) {
                            x0 = 0;
                            x1 = 0;
                            x2 = 0;
                        } else {
                            len = 1 / len;
                            x0 *= len;
                            x1 *= len;
                            x2 *= len;
                        }
                        var y0 = z1 * x2 - z2 * x1;
                        var y1 = z2 * x0 - z0 * x2;
                        var y2 = z0 * x1 - z1 * x0;
                        len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
                        if (!len) {
                            y0 = 0;
                            y1 = 0;
                            y2 = 0;
                        } else {
                            len = 1 / len;
                            y0 *= len;
                            y1 *= len;
                            y2 *= len;
                        }
                        return this.setValues(x0, y0, z0, 0, x1, y1, z1, 0, x2, y2, z2, 0, -(x0 * eyex + x1 * eyey + x2 * eyez), -(y0 * eyex + y1 * eyey + y2 * eyez), -(z0 * eyex + z1 * eyey + z2 * eyez), 1);
                    },
                    /**
     * Set the values of this matrix from the given `yaw`, `pitch` and `roll` values.
     *
     * @method Phaser.Math.Matrix4#yawPitchRoll
     * @since 3.0.0
     *
     * @param {number} yaw - The yaw value.
     * @param {number} pitch - The pitch value.
     * @param {number} roll - The roll value.
     *
     * @return {this} This Matrix4.
     */ yawPitchRoll: function(yaw, pitch, roll) {
                        this.zero();
                        _tempMat1.zero();
                        _tempMat2.zero();
                        var m0 = this.val;
                        var m1 = _tempMat1.val;
                        var m2 = _tempMat2.val;
                        //  Rotate Z
                        var s = Math.sin(roll);
                        var c = Math.cos(roll);
                        m0[10] = 1;
                        m0[15] = 1;
                        m0[0] = c;
                        m0[1] = s;
                        m0[4] = -s;
                        m0[5] = c;
                        //  Rotate X
                        s = Math.sin(pitch);
                        c = Math.cos(pitch);
                        m1[0] = 1;
                        m1[15] = 1;
                        m1[5] = c;
                        m1[10] = c;
                        m1[9] = -s;
                        m1[6] = s;
                        //  Rotate Y
                        s = Math.sin(yaw);
                        c = Math.cos(yaw);
                        m2[5] = 1;
                        m2[15] = 1;
                        m2[0] = c;
                        m2[2] = -s;
                        m2[8] = s;
                        m2[10] = c;
                        this.multiplyLocal(_tempMat1);
                        this.multiplyLocal(_tempMat2);
                        return this;
                    },
                    /**
     * Generate a world matrix from the given rotation, position, scale, view matrix and projection matrix.
     *
     * @method Phaser.Math.Matrix4#setWorldMatrix
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} rotation - The rotation of the world matrix.
     * @param {Phaser.Math.Vector3} position - The position of the world matrix.
     * @param {Phaser.Math.Vector3} scale - The scale of the world matrix.
     * @param {Phaser.Math.Matrix4} [viewMatrix] - The view matrix.
     * @param {Phaser.Math.Matrix4} [projectionMatrix] - The projection matrix.
     *
     * @return {this} This Matrix4.
     */ setWorldMatrix: function(rotation, position, scale, viewMatrix, projectionMatrix) {
                        this.yawPitchRoll(rotation.y, rotation.x, rotation.z);
                        _tempMat1.scaling(scale.x, scale.y, scale.z);
                        _tempMat2.xyz(position.x, position.y, position.z);
                        this.multiplyLocal(_tempMat1);
                        this.multiplyLocal(_tempMat2);
                        if (viewMatrix) this.multiplyLocal(viewMatrix);
                        if (projectionMatrix) this.multiplyLocal(projectionMatrix);
                        return this;
                    },
                    /**
     * Multiplies this Matrix4 by the given `src` Matrix4 and stores the results in the `out` Matrix4.
     *
     * @method Phaser.Math.Matrix4#multiplyToMat4
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix4 to multiply with this one.
     * @param {Phaser.Math.Matrix4} out - The receiving Matrix.
     *
     * @return {Phaser.Math.Matrix4} This `out` Matrix4.
     */ multiplyToMat4: function(src, out) {
                        var a = this.val;
                        var b = src.val;
                        var a00 = a[0];
                        var a01 = a[1];
                        var a02 = a[2];
                        var a03 = a[3];
                        var a10 = a[4];
                        var a11 = a[5];
                        var a12 = a[6];
                        var a13 = a[7];
                        var a20 = a[8];
                        var a21 = a[9];
                        var a22 = a[10];
                        var a23 = a[11];
                        var a30 = a[12];
                        var a31 = a[13];
                        var a32 = a[14];
                        var a33 = a[15];
                        var b00 = b[0];
                        var b01 = b[1];
                        var b02 = b[2];
                        var b03 = b[3];
                        var b10 = b[4];
                        var b11 = b[5];
                        var b12 = b[6];
                        var b13 = b[7];
                        var b20 = b[8];
                        var b21 = b[9];
                        var b22 = b[10];
                        var b23 = b[11];
                        var b30 = b[12];
                        var b31 = b[13];
                        var b32 = b[14];
                        var b33 = b[15];
                        return out.setValues(b00 * a00 + b01 * a10 + b02 * a20 + b03 * a30, b01 * a01 + b01 * a11 + b02 * a21 + b03 * a31, b02 * a02 + b01 * a12 + b02 * a22 + b03 * a32, b03 * a03 + b01 * a13 + b02 * a23 + b03 * a33, b10 * a00 + b11 * a10 + b12 * a20 + b13 * a30, b10 * a01 + b11 * a11 + b12 * a21 + b13 * a31, b10 * a02 + b11 * a12 + b12 * a22 + b13 * a32, b10 * a03 + b11 * a13 + b12 * a23 + b13 * a33, b20 * a00 + b21 * a10 + b22 * a20 + b23 * a30, b20 * a01 + b21 * a11 + b22 * a21 + b23 * a31, b20 * a02 + b21 * a12 + b22 * a22 + b23 * a32, b20 * a03 + b21 * a13 + b22 * a23 + b23 * a33, b30 * a00 + b31 * a10 + b32 * a20 + b33 * a30, b30 * a01 + b31 * a11 + b32 * a21 + b33 * a31, b30 * a02 + b31 * a12 + b32 * a22 + b33 * a32, b30 * a03 + b31 * a13 + b32 * a23 + b33 * a33);
                    },
                    /**
     * Takes the rotation and position vectors and builds this Matrix4 from them.
     *
     * @method Phaser.Math.Matrix4#fromRotationXYTranslation
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} rotation - The rotation vector.
     * @param {Phaser.Math.Vector3} position - The position vector.
     * @param {boolean} translateFirst - Should the operation translate then rotate (`true`), or rotate then translate? (`false`)
     *
     * @return {this} This Matrix4.
     */ fromRotationXYTranslation: function(rotation, position, translateFirst) {
                        var x = position.x;
                        var y = position.y;
                        var z = position.z;
                        var sx = Math.sin(rotation.x);
                        var cx = Math.cos(rotation.x);
                        var sy = Math.sin(rotation.y);
                        var cy = Math.cos(rotation.y);
                        var a30 = x;
                        var a31 = y;
                        var a32 = z;
                        //  Rotate X
                        var b21 = -sx;
                        //  Rotate Y
                        var c01 = 0 - b21 * sy;
                        var c02 = 0 - cx * sy;
                        var c21 = b21 * cy;
                        var c22 = cx * cy;
                        //  Translate
                        if (!translateFirst) {
                            // a30 = cy * x + 0 * y + sy * z;
                            a30 = cy * x + sy * z;
                            a31 = c01 * x + cx * y + c21 * z;
                            a32 = c02 * x + sx * y + c22 * z;
                        }
                        return this.setValues(cy, c01, c02, 0, 0, cx, sx, 0, sy, c21, c22, 0, a30, a31, a32, 1);
                    },
                    /**
     * Returns the maximum axis scale from this Matrix4.
     *
     * @method Phaser.Math.Matrix4#getMaxScaleOnAxis
     * @since 3.50.0
     *
     * @return {number} The maximum axis scale.
     */ getMaxScaleOnAxis: function() {
                        var m = this.val;
                        var scaleXSq = m[0] * m[0] + m[1] * m[1] + m[2] * m[2];
                        var scaleYSq = m[4] * m[4] + m[5] * m[5] + m[6] * m[6];
                        var scaleZSq = m[8] * m[8] + m[9] * m[9] + m[10] * m[10];
                        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
                    }
                });
                /**
 * @ignore
 */ var _tempMat1 = new Matrix4();
                /**
 * @ignore
 */ var _tempMat2 = new Matrix4();
                /**
 * @ignore
 */ var _x = new Vector3();
                /**
 * @ignore
 */ var _y = new Vector3();
                /**
 * @ignore
 */ var _z = new Vector3();
                module1.exports = Matrix4;
            /***/ },
            /***/ 86883: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Add an `amount` to a `value`, limiting the maximum result to `max`.
 *
 * @function Phaser.Math.MaxAdd
 * @since 3.0.0
 *
 * @param {number} value - The value to add to.
 * @param {number} amount - The amount to add.
 * @param {number} max - The maximum value to return.
 *
 * @return {number} The resulting value.
 */ var MaxAdd = function(value, amount, max) {
                    return Math.min(value + amount, max);
                };
                module1.exports = MaxAdd;
            /***/ },
            /***/ 50040: /***/ (module1)=>{
                /**
 * @author       Vladislav Forsh <vlad@robowhale.com>
 * @copyright    2021 RoboWhale
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the median of the given values. The values are sorted and the middle value is returned.
 * In case of an even number of values, the average of the two middle values is returned.
 *
 * @function Phaser.Math.Median
 * @since 3.54.0
 *
 * @param {number[]} values - The values to average.
 *
 * @return {number} The median value.
 */ var Median = function(values) {
                    var valuesNum = values.length;
                    if (valuesNum === 0) return 0;
                    values.sort(function(a, b) {
                        return a - b;
                    });
                    var halfIndex = Math.floor(valuesNum / 2);
                    return valuesNum % 2 === 0 ? (values[halfIndex] + values[halfIndex - 1]) / 2 : values[halfIndex];
                };
                module1.exports = Median;
            /***/ },
            /***/ 37204: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Subtract an `amount` from `value`, limiting the minimum result to `min`.
 *
 * @function Phaser.Math.MinSub
 * @since 3.0.0
 *
 * @param {number} value - The value to subtract from.
 * @param {number} amount - The amount to subtract.
 * @param {number} min - The minimum value to return.
 *
 * @return {number} The resulting value.
 */ var MinSub = function(value, amount, min) {
                    return Math.max(value - amount, min);
                };
                module1.exports = MinSub;
            /***/ },
            /***/ 65201: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Work out what percentage `value` is of the range between `min` and `max`.
 * If `max` isn't given then it will return the percentage of `value` to `min`.
 *
 * You can optionally specify an `upperMax` value, which is a mid-way point in the range that represents 100%, after which the % starts to go down to zero again.
 *
 * @function Phaser.Math.Percent
 * @since 3.0.0
 *
 * @param {number} value - The value to determine the percentage of.
 * @param {number} min - The minimum value.
 * @param {number} [max] - The maximum value.
 * @param {number} [upperMax] - The mid-way point in the range that represents 100%.
 *
 * @return {number} A value between 0 and 1 representing the percentage.
 */ var Percent = function(value, min, max, upperMax) {
                    if (max === undefined) max = min + 1;
                    var percentage = (value - min) / (max - min);
                    if (percentage > 1) {
                        if (upperMax !== undefined) {
                            percentage = (upperMax - value) / (upperMax - max);
                            if (percentage < 0) percentage = 0;
                        } else percentage = 1;
                    } else if (percentage < 0) percentage = 0;
                    return percentage;
                };
                module1.exports = Percent;
            /***/ },
            /***/ 15746: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
                //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
                var Class = __webpack_require__(83419);
                var Matrix3 = __webpack_require__(94434);
                var NOOP = __webpack_require__(29747);
                var Vector3 = __webpack_require__(25836);
                var EPSILON = 0.000001;
                //  Some shared 'private' arrays
                var siNext = new Int8Array([
                    1,
                    2,
                    0
                ]);
                var tmp = new Float32Array([
                    0,
                    0,
                    0
                ]);
                var xUnitVec3 = new Vector3(1, 0, 0);
                var yUnitVec3 = new Vector3(0, 1, 0);
                var tmpvec = new Vector3();
                var tmpMat3 = new Matrix3();
                /**
 * @classdesc
 * A quaternion.
 *
 * @class Quaternion
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x component.
 * @param {number} [y=0] - The y component.
 * @param {number} [z=0] - The z component.
 * @param {number} [w=1] - The w component.
 */ var Quaternion = new Class({
                    initialize: function Quaternion(x, y, z, w) {
                        /**
         * The x component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_x
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The y component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_y
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The z component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_z
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The w component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_w
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * This callback is invoked, if set, each time a value in this quaternion is changed.
         * The callback is passed one argument, a reference to this quaternion.
         *
         * @name Phaser.Math.Quaternion#onChangeCallback
         * @type {function}
         * @since 3.50.0
         */ this.onChangeCallback = NOOP;
                        this.set(x, y, z, w);
                    },
                    /**
     * The x component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#x
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this._x;
                        },
                        set: function(value) {
                            this._x = value;
                            this.onChangeCallback(this);
                        }
                    },
                    /**
     * The y component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#y
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this._y;
                        },
                        set: function(value) {
                            this._y = value;
                            this.onChangeCallback(this);
                        }
                    },
                    /**
     * The z component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#z
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ z: {
                        get: function() {
                            return this._z;
                        },
                        set: function(value) {
                            this._z = value;
                            this.onChangeCallback(this);
                        }
                    },
                    /**
     * The w component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#w
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ w: {
                        get: function() {
                            return this._w;
                        },
                        set: function(value) {
                            this._w = value;
                            this.onChangeCallback(this);
                        }
                    },
                    /**
     * Copy the components of a given Quaternion or Vector into this Quaternion.
     *
     * @method Phaser.Math.Quaternion#copy
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} src - The Quaternion or Vector to copy the components from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ copy: function(src) {
                        return this.set(src);
                    },
                    /**
     * Set the components of this Quaternion and optionally call the `onChangeCallback`.
     *
     * @method Phaser.Math.Quaternion#set
     * @since 3.0.0
     *
     * @param {(number|object)} [x=0] - The x component, or an object containing x, y, z, and w components.
     * @param {number} [y=0] - The y component.
     * @param {number} [z=0] - The z component.
     * @param {number} [w=0] - The w component.
     * @param {boolean} [update=true] - Call the `onChangeCallback`?
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ set: function(x, y, z, w, update) {
                        if (update === undefined) update = true;
                        if (typeof x === 'object') {
                            this._x = x.x || 0;
                            this._y = x.y || 0;
                            this._z = x.z || 0;
                            this._w = x.w || 0;
                        } else {
                            this._x = x || 0;
                            this._y = y || 0;
                            this._z = z || 0;
                            this._w = w || 0;
                        }
                        if (update) this.onChangeCallback(this);
                        return this;
                    },
                    /**
     * Add a given Quaternion or Vector to this Quaternion. Addition is component-wise.
     *
     * @method Phaser.Math.Quaternion#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to add to this Quaternion.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ add: function(v) {
                        this._x += v.x;
                        this._y += v.y;
                        this._z += v.z;
                        this._w += v.w;
                        this.onChangeCallback(this);
                        return this;
                    },
                    /**
     * Subtract a given Quaternion or Vector from this Quaternion. Subtraction is component-wise.
     *
     * @method Phaser.Math.Quaternion#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to subtract from this Quaternion.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ subtract: function(v) {
                        this._x -= v.x;
                        this._y -= v.y;
                        this._z -= v.z;
                        this._w -= v.w;
                        this.onChangeCallback(this);
                        return this;
                    },
                    /**
     * Scale this Quaternion by the given value.
     *
     * @method Phaser.Math.Quaternion#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Quaternion by.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ scale: function(scale) {
                        this._x *= scale;
                        this._y *= scale;
                        this._z *= scale;
                        this._w *= scale;
                        this.onChangeCallback(this);
                        return this;
                    },
                    /**
     * Calculate the length of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#length
     * @since 3.0.0
     *
     * @return {number} The length of this Quaternion.
     */ length: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var w = this.w;
                        return Math.sqrt(x * x + y * y + z * z + w * w);
                    },
                    /**
     * Calculate the length of this Quaternion squared.
     *
     * @method Phaser.Math.Quaternion#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Quaternion, squared.
     */ lengthSq: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var w = this.w;
                        return x * x + y * y + z * z + w * w;
                    },
                    /**
     * Normalize this Quaternion.
     *
     * @method Phaser.Math.Quaternion#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ normalize: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var w = this.w;
                        var len = x * x + y * y + z * z + w * w;
                        if (len > 0) {
                            len = 1 / Math.sqrt(len);
                            this._x = x * len;
                            this._y = y * len;
                            this._z = z * len;
                            this._w = w * len;
                        }
                        this.onChangeCallback(this);
                        return this;
                    },
                    /**
     * Calculate the dot product of this Quaternion and the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#dot
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to dot product with this Quaternion.
     *
     * @return {number} The dot product of this Quaternion and the given Quaternion or Vector.
     */ dot: function(v) {
                        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
                    },
                    /**
     * Linearly interpolate this Quaternion towards the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#lerp
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to interpolate towards.
     * @param {number} [t=0] - The percentage of interpolation.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ lerp: function(v, t) {
                        if (t === undefined) t = 0;
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var aw = this.w;
                        return this.set(ax + t * (v.x - ax), ay + t * (v.y - ay), az + t * (v.z - az), aw + t * (v.w - aw));
                    },
                    /**
     * Rotates this Quaternion based on the two given vectors.
     *
     * @method Phaser.Math.Quaternion#rotationTo
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} a - The transform rotation vector.
     * @param {Phaser.Math.Vector3} b - The target rotation vector.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotationTo: function(a, b) {
                        var dot = a.x * b.x + a.y * b.y + a.z * b.z;
                        if (dot < -0.999999) {
                            if (tmpvec.copy(xUnitVec3).cross(a).length() < EPSILON) tmpvec.copy(yUnitVec3).cross(a);
                            tmpvec.normalize();
                            return this.setAxisAngle(tmpvec, Math.PI);
                        } else if (dot > 0.999999) return this.set(0, 0, 0, 1);
                        else {
                            tmpvec.copy(a).cross(b);
                            this._x = tmpvec.x;
                            this._y = tmpvec.y;
                            this._z = tmpvec.z;
                            this._w = 1 + dot;
                            return this.normalize();
                        }
                    },
                    /**
     * Set the axes of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#setAxes
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} view - The view axis.
     * @param {Phaser.Math.Vector3} right - The right axis.
     * @param {Phaser.Math.Vector3} up - The upwards axis.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setAxes: function(view, right, up) {
                        var m = tmpMat3.val;
                        m[0] = right.x;
                        m[3] = right.y;
                        m[6] = right.z;
                        m[1] = up.x;
                        m[4] = up.y;
                        m[7] = up.z;
                        m[2] = -view.x;
                        m[5] = -view.y;
                        m[8] = -view.z;
                        return this.fromMat3(tmpMat3).normalize();
                    },
                    /**
     * Reset this Matrix to an identity (default) Quaternion.
     *
     * @method Phaser.Math.Quaternion#identity
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ identity: function() {
                        return this.set(0, 0, 0, 1);
                    },
                    /**
     * Set the axis angle of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#setAxisAngle
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} axis - The axis.
     * @param {number} rad - The angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setAxisAngle: function(axis, rad) {
                        rad = rad * 0.5;
                        var s = Math.sin(rad);
                        return this.set(s * axis.x, s * axis.y, s * axis.z, Math.cos(rad));
                    },
                    /**
     * Multiply this Quaternion by the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - The Quaternion or Vector to multiply this Quaternion by.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ multiply: function(b) {
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var aw = this.w;
                        var bx = b.x;
                        var by = b.y;
                        var bz = b.z;
                        var bw = b.w;
                        return this.set(ax * bw + aw * bx + ay * bz - az * by, ay * bw + aw * by + az * bx - ax * bz, az * bw + aw * bz + ax * by - ay * bx, aw * bw - ax * bx - ay * by - az * bz);
                    },
                    /**
     * Smoothly linearly interpolate this Quaternion towards the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#slerp
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - The Quaternion or Vector to interpolate towards.
     * @param {number} t - The percentage of interpolation.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ slerp: function(b, t) {
                        // benchmarks: http://jsperf.com/quaternion-slerp-implementations
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var aw = this.w;
                        var bx = b.x;
                        var by = b.y;
                        var bz = b.z;
                        var bw = b.w;
                        // calc cosine
                        var cosom = ax * bx + ay * by + az * bz + aw * bw;
                        // adjust signs (if necessary)
                        if (cosom < 0) {
                            cosom = -cosom;
                            bx = -bx;
                            by = -by;
                            bz = -bz;
                            bw = -bw;
                        }
                        // "from" and "to" quaternions are very close
                        //  ... so we can do a linear interpolation
                        var scale0 = 1 - t;
                        var scale1 = t;
                        // calculate coefficients
                        if (1 - cosom > EPSILON) {
                            // standard case (slerp)
                            var omega = Math.acos(cosom);
                            var sinom = Math.sin(omega);
                            scale0 = Math.sin((1.0 - t) * omega) / sinom;
                            scale1 = Math.sin(t * omega) / sinom;
                        }
                        // calculate final values
                        return this.set(scale0 * ax + scale1 * bx, scale0 * ay + scale1 * by, scale0 * az + scale1 * bz, scale0 * aw + scale1 * bw);
                    },
                    /**
     * Invert this Quaternion.
     *
     * @method Phaser.Math.Quaternion#invert
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ invert: function() {
                        var a0 = this.x;
                        var a1 = this.y;
                        var a2 = this.z;
                        var a3 = this.w;
                        var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
                        var invDot = dot ? 1 / dot : 0;
                        return this.set(-a0 * invDot, -a1 * invDot, -a2 * invDot, a3 * invDot);
                    },
                    /**
     * Convert this Quaternion into its conjugate.
     *
     * Sets the x, y and z components.
     *
     * @method Phaser.Math.Quaternion#conjugate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ conjugate: function() {
                        this._x = -this.x;
                        this._y = -this.y;
                        this._z = -this.z;
                        this.onChangeCallback(this);
                        return this;
                    },
                    /**
     * Rotate this Quaternion on the X axis.
     *
     * @method Phaser.Math.Quaternion#rotateX
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateX: function(rad) {
                        rad *= 0.5;
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var aw = this.w;
                        var bx = Math.sin(rad);
                        var bw = Math.cos(rad);
                        return this.set(ax * bw + aw * bx, ay * bw + az * bx, az * bw - ay * bx, aw * bw - ax * bx);
                    },
                    /**
     * Rotate this Quaternion on the Y axis.
     *
     * @method Phaser.Math.Quaternion#rotateY
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateY: function(rad) {
                        rad *= 0.5;
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var aw = this.w;
                        var by = Math.sin(rad);
                        var bw = Math.cos(rad);
                        return this.set(ax * bw - az * by, ay * bw + aw * by, az * bw + ax * by, aw * bw - ay * by);
                    },
                    /**
     * Rotate this Quaternion on the Z axis.
     *
     * @method Phaser.Math.Quaternion#rotateZ
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateZ: function(rad) {
                        rad *= 0.5;
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var aw = this.w;
                        var bz = Math.sin(rad);
                        var bw = Math.cos(rad);
                        return this.set(ax * bw + ay * bz, ay * bw - ax * bz, az * bw + aw * bz, aw * bw - az * bz);
                    },
                    /**
     * Create a unit (or rotation) Quaternion from its x, y, and z components.
     *
     * Sets the w component.
     *
     * @method Phaser.Math.Quaternion#calculateW
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ calculateW: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        this.w = -Math.sqrt(1.0 - x * x - y * y - z * z);
                        return this;
                    },
                    /**
     * Set this Quaternion from the given Euler, based on Euler order.
     *
     * @method Phaser.Math.Quaternion#setFromEuler
     * @since 3.50.0
     *
     * @param {Phaser.Math.Euler} euler - The Euler to convert from.
     * @param {boolean} [update=true] - Run the `onChangeCallback`?
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setFromEuler: function(euler, update) {
                        var x = euler.x / 2;
                        var y = euler.y / 2;
                        var z = euler.z / 2;
                        var c1 = Math.cos(x);
                        var c2 = Math.cos(y);
                        var c3 = Math.cos(z);
                        var s1 = Math.sin(x);
                        var s2 = Math.sin(y);
                        var s3 = Math.sin(z);
                        switch(euler.order){
                            case 'XYZ':
                                this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                                break;
                            case 'YXZ':
                                this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                                break;
                            case 'ZXY':
                                this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                                break;
                            case 'ZYX':
                                this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                                break;
                            case 'YZX':
                                this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                                break;
                            case 'XZY':
                                this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                                break;
                        }
                        return this;
                    },
                    /**
     * Sets the rotation of this Quaternion from the given Matrix4.
     *
     * @method Phaser.Math.Quaternion#setFromRotationMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to set the rotation from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setFromRotationMatrix: function(mat4) {
                        var m = mat4.val;
                        var m11 = m[0];
                        var m12 = m[4];
                        var m13 = m[8];
                        var m21 = m[1];
                        var m22 = m[5];
                        var m23 = m[9];
                        var m31 = m[2];
                        var m32 = m[6];
                        var m33 = m[10];
                        var trace = m11 + m22 + m33;
                        var s;
                        if (trace > 0) {
                            s = 0.5 / Math.sqrt(trace + 1.0);
                            this.set((m32 - m23) * s, (m13 - m31) * s, (m21 - m12) * s, 0.25 / s);
                        } else if (m11 > m22 && m11 > m33) {
                            s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                            this.set(0.25 * s, (m12 + m21) / s, (m13 + m31) / s, (m32 - m23) / s);
                        } else if (m22 > m33) {
                            s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                            this.set((m12 + m21) / s, 0.25 * s, (m23 + m32) / s, (m13 - m31) / s);
                        } else {
                            s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                            this.set((m13 + m31) / s, (m23 + m32) / s, 0.25 * s, (m21 - m12) / s);
                        }
                        return this;
                    },
                    /**
     * Convert the given Matrix into this Quaternion.
     *
     * @method Phaser.Math.Quaternion#fromMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix to convert from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ fromMat3: function(mat) {
                        // benchmarks:
                        //    http://jsperf.com/typed-array-access-speed
                        //    http://jsperf.com/conversion-of-3x3-matrix-to-quaternion
                        // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
                        // article "Quaternion Calculus and Fast Animation".
                        var m = mat.val;
                        var fTrace = m[0] + m[4] + m[8];
                        var fRoot;
                        if (fTrace > 0) {
                            // |w| > 1/2, may as well choose w > 1/2
                            fRoot = Math.sqrt(fTrace + 1.0); // 2w
                            this.w = 0.5 * fRoot;
                            fRoot = 0.5 / fRoot; // 1/(4w)
                            this._x = (m[7] - m[5]) * fRoot;
                            this._y = (m[2] - m[6]) * fRoot;
                            this._z = (m[3] - m[1]) * fRoot;
                        } else {
                            // |w| <= 1/2
                            var i = 0;
                            if (m[4] > m[0]) i = 1;
                            if (m[8] > m[i * 3 + i]) i = 2;
                            var j = siNext[i];
                            var k = siNext[j];
                            //  This isn't quite as clean without array access
                            fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1);
                            tmp[i] = 0.5 * fRoot;
                            fRoot = 0.5 / fRoot;
                            tmp[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
                            tmp[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
                            this._x = tmp[0];
                            this._y = tmp[1];
                            this._z = tmp[2];
                            this._w = (m[k * 3 + j] - m[j * 3 + k]) * fRoot;
                        }
                        this.onChangeCallback(this);
                        return this;
                    }
                });
                module1.exports = Quaternion;
            /***/ },
            /***/ 43396: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(36383);
                /**
 * Convert the given angle in radians, to the equivalent angle in degrees.
 *
 * @function Phaser.Math.RadToDeg
 * @since 3.0.0
 *
 * @param {number} radians - The angle in radians to convert ot degrees.
 *
 * @return {number} The given angle converted to degrees.
 */ var RadToDeg = function(radians) {
                    return radians * CONST.RAD_TO_DEG;
                };
                module1.exports = RadToDeg;
            /***/ },
            /***/ 74362: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random unit vector.
 *
 * Computes random values for the given vector between -1 and 1 that can be used to represent a direction.
 *
 * Optionally accepts a scale value to scale the resulting vector by.
 *
 * @function Phaser.Math.RandomXY
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector2} vector - The Vector to compute random values for.
 * @param {number} [scale=1] - The scale of the random values.
 *
 * @return {Phaser.Math.Vector2} The given Vector.
 */ var RandomXY = function(vector, scale) {
                    if (scale === undefined) scale = 1;
                    var r = Math.random() * 2 * Math.PI;
                    vector.x = Math.cos(r) * scale;
                    vector.y = Math.sin(r) * scale;
                    return vector;
                };
                module1.exports = RandomXY;
            /***/ },
            /***/ 60706: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random position vector in a spherical area, optionally defined by the given radius.
 *
 * @function Phaser.Math.RandomXYZ
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector3} vec3 - The Vector to compute random values for.
 * @param {number} [radius=1] - The radius.
 *
 * @return {Phaser.Math.Vector3} The given Vector.
 */ var RandomXYZ = function(vec3, radius) {
                    if (radius === undefined) radius = 1;
                    var r = Math.random() * 2 * Math.PI;
                    var z = Math.random() * 2 - 1;
                    var zScale = Math.sqrt(1 - z * z) * radius;
                    vec3.x = Math.cos(r) * zScale;
                    vec3.y = Math.sin(r) * zScale;
                    vec3.z = z * radius;
                    return vec3;
                };
                module1.exports = RandomXYZ;
            /***/ },
            /***/ 67421: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random four-dimensional vector.
 *
 * @function Phaser.Math.RandomXYZW
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector4} vec4 - The Vector to compute random values for.
 * @param {number} [scale=1] - The scale of the random values.
 *
 * @return {Phaser.Math.Vector4} The given Vector.
 */ var RandomXYZW = function(vec4, scale) {
                    if (scale === undefined) scale = 1;
                    vec4.x = (Math.random() * 2 - 1) * scale;
                    vec4.y = (Math.random() * 2 - 1) * scale;
                    vec4.z = (Math.random() * 2 - 1) * scale;
                    vec4.w = (Math.random() * 2 - 1) * scale;
                    return vec4;
                };
                module1.exports = RandomXYZW;
            /***/ },
            /***/ 36305: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a given point by a given angle around the origin (0, 0), in an anti-clockwise direction.
 *
 * @function Phaser.Math.Rotate
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} angle - The angle to be rotated by in an anticlockwise direction.
 *
 * @return {Phaser.Geom.Point} The given point, rotated by the given angle in an anticlockwise direction.
 */ var Rotate = function(point, angle) {
                    var x = point.x;
                    var y = point.y;
                    point.x = x * Math.cos(angle) - y * Math.sin(angle);
                    point.y = x * Math.sin(angle) + y * Math.cos(angle);
                    return point;
                };
                module1.exports = Rotate;
            /***/ },
            /***/ 11520: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a `point` around `x` and `y` to the given `angle`, at the same distance.
 *
 * In polar notation, this maps a point from (r, t) to (r, angle), vs. the origin (x, y).
 *
 * @function Phaser.Math.RotateAround
 * @since 3.0.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} x - The horizontal coordinate to rotate around.
 * @param {number} y - The vertical coordinate to rotate around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateAround = function(point, x, y, angle) {
                    var c = Math.cos(angle);
                    var s = Math.sin(angle);
                    var tx = point.x - x;
                    var ty = point.y - y;
                    point.x = tx * c - ty * s + x;
                    point.y = tx * s + ty * c + y;
                    return point;
                };
                module1.exports = RotateAround;
            /***/ },
            /***/ 1163: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a `point` around `x` and `y` by the given `angle` and `distance`.
 *
 * In polar notation, this maps a point from (r, t) to (distance, t + angle), vs. the origin (x, y).
 *
 * @function Phaser.Math.RotateAroundDistance
 * @since 3.0.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} x - The horizontal coordinate to rotate around.
 * @param {number} y - The vertical coordinate to rotate around.
 * @param {number} angle - The angle of rotation in radians.
 * @param {number} distance - The distance from (x, y) to place the point at.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateAroundDistance = function(point, x, y, angle, distance) {
                    var t = angle + Math.atan2(point.y - y, point.x - x);
                    point.x = x + distance * Math.cos(t);
                    point.y = y + distance * Math.sin(t);
                    return point;
                };
                module1.exports = RotateAroundDistance;
            /***/ },
            /***/ 70336: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Position a `point` at the given `angle` and `distance` to (`x`, `y`).
 *
 * @function Phaser.Math.RotateTo
 * @since 3.24.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like} point - The point to be positioned.
 * @param {number} x - The horizontal coordinate to position from.
 * @param {number} y - The vertical coordinate to position from.
 * @param {number} angle - The angle of rotation in radians.
 * @param {number} distance - The distance from (x, y) to place the point at.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateTo = function(point, x, y, angle, distance) {
                    point.x = x + distance * Math.cos(angle);
                    point.y = y + distance * Math.sin(angle);
                    return point;
                };
                module1.exports = RotateTo;
            /***/ },
            /***/ 72678: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(25836);
                var Matrix4 = __webpack_require__(37867);
                var Quaternion = __webpack_require__(15746);
                var tmpMat4 = new Matrix4();
                var tmpQuat = new Quaternion();
                var tmpVec3 = new Vector3();
                /**
 * Rotates a vector in place by axis angle.
 *
 * This is the same as transforming a point by an
 * axis-angle quaternion, but it has higher precision.
 *
 * @function Phaser.Math.RotateVec3
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector3} vec - The vector to be rotated.
 * @param {Phaser.Math.Vector3} axis - The axis to rotate around.
 * @param {number} radians - The angle of rotation in radians.
 *
 * @return {Phaser.Math.Vector3} The given vector.
 */ var RotateVec3 = function(vec, axis, radians) {
                    //  Set the quaternion to our axis angle
                    tmpQuat.setAxisAngle(axis, radians);
                    //  Create a rotation matrix from the axis angle
                    tmpMat4.fromRotationTranslation(tmpQuat, tmpVec3.set(0, 0, 0));
                    //  Multiply our vector by the rotation matrix
                    return vec.transformMat4(tmpMat4);
                };
                module1.exports = RotateVec3;
            /***/ },
            /***/ 2284: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Round a given number so it is further away from zero. That is, positive numbers are rounded up, and negative numbers are rounded down.
 *
 * @function Phaser.Math.RoundAwayFromZero
 * @since 3.0.0
 *
 * @param {number} value - The number to round.
 *
 * @return {number} The rounded number, rounded away from zero.
 */ var RoundAwayFromZero = function(value) {
                    // "Opposite" of truncate.
                    return value > 0 ? Math.ceil(value) : Math.floor(value);
                };
                module1.exports = RoundAwayFromZero;
            /***/ },
            /***/ 41013: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Round a value to the given precision.
 *
 * For example:
 *
 * ```javascript
 * RoundTo(123.456, 0) = 123
 * RoundTo(123.456, 1) = 120
 * RoundTo(123.456, 2) = 100
 * ```
 *
 * To round the decimal, i.e. to round to precision, pass in a negative `place`:
 *
 * ```javascript
 * RoundTo(123.456789, 0) = 123
 * RoundTo(123.456789, -1) = 123.5
 * RoundTo(123.456789, -2) = 123.46
 * RoundTo(123.456789, -3) = 123.457
 * ```
 *
 * @function Phaser.Math.RoundTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to. Positive to round the units, negative to round the decimal.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var RoundTo = function(value, place, base) {
                    if (place === undefined) place = 0;
                    if (base === undefined) base = 10;
                    var p = Math.pow(base, -place);
                    return Math.round(value * p) / p;
                };
                module1.exports = RoundTo;
            /***/ },
            /***/ 16922: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate a series of sine and cosine values.
 *
 * @function Phaser.Math.SinCosTableGenerator
 * @since 3.0.0
 *
 * @param {number} length - The number of values to generate.
 * @param {number} [sinAmp=1] - The sine value amplitude.
 * @param {number} [cosAmp=1] - The cosine value amplitude.
 * @param {number} [frequency=1] - The frequency of the values.
 *
 * @return {Phaser.Types.Math.SinCosTable} The generated values.
 */ var SinCosTableGenerator = function(length, sinAmp, cosAmp, frequency) {
                    if (sinAmp === undefined) sinAmp = 1;
                    if (cosAmp === undefined) cosAmp = 1;
                    if (frequency === undefined) frequency = 1;
                    frequency *= Math.PI / length;
                    var cos = [];
                    var sin = [];
                    for(var c = 0; c < length; c++){
                        cosAmp -= sinAmp * frequency;
                        sinAmp += cosAmp * frequency;
                        cos[c] = cosAmp;
                        sin[c] = sinAmp;
                    }
                    return {
                        sin: sin,
                        cos: cos,
                        length: length
                    };
                };
                module1.exports = SinCosTableGenerator;
            /***/ },
            /***/ 7602: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a smooth interpolation percentage of `x` between `min` and `max`.
 *
 * The function receives the number `x` as an argument and returns 0 if `x` is less than or equal to the left edge,
 * 1 if `x` is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial,
 * between 0 and 1 otherwise.
 *
 * @function Phaser.Math.SmoothStep
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep}
 *
 * @param {number} x - The input value.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The percentage of interpolation, between 0 and 1.
 */ var SmoothStep = function(x, min, max) {
                    if (x <= min) return 0;
                    if (x >= max) return 1;
                    x = (x - min) / (max - min);
                    return x * x * (3 - 2 * x);
                };
                module1.exports = SmoothStep;
            /***/ },
            /***/ 54261: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a smoother interpolation percentage of `x` between `min` and `max`.
 *
 * The function receives the number `x` as an argument and returns 0 if `x` is less than or equal to the left edge,
 * 1 if `x` is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial,
 * between 0 and 1 otherwise.
 *
 * Produces an even smoother interpolation than {@link Phaser.Math.SmoothStep}.
 *
 * @function Phaser.Math.SmootherStep
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 *
 * @param {number} x - The input value.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The percentage of interpolation, between 0 and 1.
 */ var SmootherStep = function(x, min, max) {
                    x = Math.max(0, Math.min(1, (x - min) / (max - min)));
                    return x * x * x * (x * (x * 6 - 15) + 10);
                };
                module1.exports = SmootherStep;
            /***/ },
            /***/ 44408: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Returns a Vector2 containing the x and y position of the given index in a `width` x `height` sized grid.
 *
 * For example, in a 6 x 4 grid, index 16 would equal x: 4 y: 2.
 *
 * If the given index is out of range an empty Vector2 is returned.
 *
 * @function Phaser.Math.ToXY
 * @since 3.19.0
 *
 * @param {number} index - The position within the grid to get the x/y value for.
 * @param {number} width - The width of the grid.
 * @param {number} height - The height of the grid.
 * @param {Phaser.Math.Vector2} [out] - An optional Vector2 to store the result in. If not given, a new Vector2 instance will be created.
 *
 * @return {Phaser.Math.Vector2} A Vector2 where the x and y properties contain the given grid index.
 */ var ToXY = function(index, width, height, out) {
                    if (out === undefined) out = new Vector2();
                    var x = 0;
                    var y = 0;
                    var total = width * height;
                    if (index > 0 && index <= total) {
                        if (index > width - 1) {
                            y = Math.floor(index / width);
                            x = index - y * width;
                        } else x = index;
                    }
                    return out.set(x, y);
                };
                module1.exports = ToXY;
            /***/ },
            /***/ 85955: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Takes the `x` and `y` coordinates and transforms them into the same space as
 * defined by the position, rotation and scale values.
 *
 * @function Phaser.Math.TransformXY
 * @since 3.0.0
 *
 * @param {number} x - The x coordinate to be transformed.
 * @param {number} y - The y coordinate to be transformed.
 * @param {number} positionX - Horizontal position of the transform point.
 * @param {number} positionY - Vertical position of the transform point.
 * @param {number} rotation - Rotation of the transform point, in radians.
 * @param {number} scaleX - Horizontal scale of the transform point.
 * @param {number} scaleY - Vertical scale of the transform point.
 * @param {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} [output] - The output vector, point or object for the translated coordinates.
 *
 * @return {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} The translated point.
 */ var TransformXY = function(x, y, positionX, positionY, rotation, scaleX, scaleY, output) {
                    if (output === undefined) output = new Vector2();
                    var radianSin = Math.sin(rotation);
                    var radianCos = Math.cos(rotation);
                    // Rotate and Scale
                    var a = radianCos * scaleX;
                    var b = radianSin * scaleX;
                    var c = -radianSin * scaleY;
                    var d = radianCos * scaleY;
                    //  Invert
                    var id = 1 / (a * d + c * -b);
                    output.x = d * id * x + -c * id * y + (positionY * c - positionX * d) * id;
                    output.y = a * id * y + -b * id * x + (-positionY * a + positionX * b) * id;
                    return output;
                };
                module1.exports = TransformXY;
            /***/ },
            /***/ 26099: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
                //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
                var Class = __webpack_require__(83419);
                var FuzzyEqual = __webpack_require__(43855);
                /**
 * @classdesc
 * A representation of a vector in 2D space.
 *
 * A two-component vector.
 *
 * @class Vector2
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number|Phaser.Types.Math.Vector2Like} [x=0] - The x component, or an object with `x` and `y` properties.
 * @param {number} [y=x] - The y component.
 */ var Vector2 = new Class({
                    initialize: function Vector2(x, y) {
                        /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector2#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                        /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector2#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                        if (typeof x === 'object') {
                            this.x = x.x || 0;
                            this.y = x.y || 0;
                        } else {
                            if (y === undefined) y = x;
                            this.x = x || 0;
                            this.y = y || 0;
                        }
                    },
                    /**
     * Make a clone of this Vector2.
     *
     * @method Phaser.Math.Vector2#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} A clone of this Vector2.
     */ clone: function() {
                        return new Vector2(this.x, this.y);
                    },
                    /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector2#copy
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ copy: function(src) {
                        this.x = src.x || 0;
                        this.y = src.y || 0;
                        return this;
                    },
                    /**
     * Set the component values of this Vector from a given Vector2Like object.
     *
     * @method Phaser.Math.Vector2#setFromObject
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} obj - The object containing the component values to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setFromObject: function(obj) {
                        this.x = obj.x || 0;
                        this.y = obj.y || 0;
                        return this;
                    },
                    /**
     * Set the `x` and `y` components of the this Vector to the given `x` and `y` values.
     *
     * @method Phaser.Math.Vector2#set
     * @since 3.0.0
     *
     * @param {number} x - The x value to set for this Vector.
     * @param {number} [y=x] - The y value to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ set: function(x, y) {
                        if (y === undefined) y = x;
                        this.x = x;
                        this.y = y;
                        return this;
                    },
                    /**
     * This method is an alias for `Vector2.set`.
     *
     * @method Phaser.Math.Vector2#setTo
     * @since 3.4.0
     *
     * @param {number} x - The x value to set for this Vector.
     * @param {number} [y=x] - The y value to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setTo: function(x, y) {
                        return this.set(x, y);
                    },
                    /**
     * Sets the `x` and `y` values of this object from a given polar coordinate.
     *
     * @method Phaser.Math.Vector2#setToPolar
     * @since 3.0.0
     *
     * @param {number} azimuth - The angular coordinate, in radians.
     * @param {number} [radius=1] - The radial coordinate (length).
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setToPolar: function(azimuth, radius) {
                        if (radius == null) radius = 1;
                        this.x = Math.cos(azimuth) * radius;
                        this.y = Math.sin(azimuth) * radius;
                        return this;
                    },
                    /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict equality check against each Vector's components.
     *
     * @method Phaser.Math.Vector2#equals
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} v - The vector to compare with this Vector.
     *
     * @return {boolean} Whether the given Vector is equal to this Vector.
     */ equals: function(v) {
                        return this.x === v.x && this.y === v.y;
                    },
                    /**
     * Check whether this Vector is approximately equal to a given Vector.
     *
     * @method Phaser.Math.Vector2#fuzzyEquals
     * @since 3.23.0
     *
     * @param {Phaser.Types.Math.Vector2Like} v - The vector to compare with this Vector.
     * @param {number} [epsilon=0.0001] - The tolerance value.
     *
     * @return {boolean} Whether both absolute differences of the x and y components are smaller than `epsilon`.
     */ fuzzyEquals: function(v, epsilon) {
                        return FuzzyEqual(this.x, v.x, epsilon) && FuzzyEqual(this.y, v.y, epsilon);
                    },
                    /**
     * Calculate the angle between this Vector and the positive x-axis, in radians.
     *
     * @method Phaser.Math.Vector2#angle
     * @since 3.0.0
     *
     * @return {number} The angle between this Vector, and the positive x-axis, given in radians.
     */ angle: function() {
                        // computes the angle in radians with respect to the positive x-axis
                        var angle = Math.atan2(this.y, this.x);
                        if (angle < 0) angle += 2 * Math.PI;
                        return angle;
                    },
                    /**
     * Set the angle of this Vector.
     *
     * @method Phaser.Math.Vector2#setAngle
     * @since 3.23.0
     *
     * @param {number} angle - The angle, in radians.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setAngle: function(angle) {
                        return this.setToPolar(angle, this.length());
                    },
                    /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector2#add
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ add: function(src) {
                        this.x += src.x;
                        this.y += src.y;
                        return this;
                    },
                    /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector2#subtract
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ subtract: function(src) {
                        this.x -= src.x;
                        this.y -= src.y;
                        return this;
                    },
                    /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector2#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ multiply: function(src) {
                        this.x *= src.x;
                        this.y *= src.y;
                        return this;
                    },
                    /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector2#scale
     * @since 3.0.0
     *
     * @param {number} value - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ scale: function(value) {
                        if (isFinite(value)) {
                            this.x *= value;
                            this.y *= value;
                        } else {
                            this.x = 0;
                            this.y = 0;
                        }
                        return this;
                    },
                    /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector2#divide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ divide: function(src) {
                        this.x /= src.x;
                        this.y /= src.y;
                        return this;
                    },
                    /**
     * Negate the `x` and `y` components of this Vector.
     *
     * @method Phaser.Math.Vector2#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ negate: function() {
                        this.x = -this.x;
                        this.y = -this.y;
                        return this;
                    },
                    /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#distance
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(src) {
                        var dx = src.x - this.x;
                        var dy = src.y - this.y;
                        return Math.sqrt(dx * dx + dy * dy);
                    },
                    /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector2#distanceSq
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(src) {
                        var dx = src.x - this.x;
                        var dy = src.y - this.y;
                        return dx * dx + dy * dy;
                    },
                    /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                        var x = this.x;
                        var y = this.y;
                        return Math.sqrt(x * x + y * y);
                    },
                    /**
     * Set the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#setLength
     * @since 3.23.0
     *
     * @param {number} length
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setLength: function(length) {
                        return this.normalize().scale(length);
                    },
                    /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector2#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                        var x = this.x;
                        var y = this.y;
                        return x * x + y * y;
                    },
                    /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector2#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalize: function() {
                        var x = this.x;
                        var y = this.y;
                        var len = x * x + y * y;
                        if (len > 0) {
                            len = 1 / Math.sqrt(len);
                            this.x = x * len;
                            this.y = y * len;
                        }
                        return this;
                    },
                    /**
     * Rotate this Vector to its perpendicular, in the positive direction.
     *
     * @method Phaser.Math.Vector2#normalizeRightHand
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalizeRightHand: function() {
                        var x = this.x;
                        this.x = this.y * -1;
                        this.y = x;
                        return this;
                    },
                    /**
     * Rotate this Vector to its perpendicular, in the negative direction.
     *
     * @method Phaser.Math.Vector2#normalizeLeftHand
     * @since 3.23.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalizeLeftHand: function() {
                        var x = this.x;
                        this.x = this.y;
                        this.y = x * -1;
                        return this;
                    },
                    /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#dot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector2 to dot product with this Vector2.
     *
     * @return {number} The dot product of this Vector and the given Vector.
     */ dot: function(src) {
                        return this.x * src.x + this.y * src.y;
                    },
                    /**
     * Calculate the cross product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#cross
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector2 to cross with this Vector2.
     *
     * @return {number} The cross product of this Vector and the given Vector.
     */ cross: function(src) {
                        return this.x * src.y - this.y * src.x;
                    },
                    /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector2#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector2 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ lerp: function(src, t) {
                        if (t === undefined) t = 0;
                        var ax = this.x;
                        var ay = this.y;
                        this.x = ax + t * (src.x - ax);
                        this.y = ay + t * (src.y - ay);
                        return this;
                    },
                    /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector2#transformMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix3 to transform this Vector2 with.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ transformMat3: function(mat) {
                        var x = this.x;
                        var y = this.y;
                        var m = mat.val;
                        this.x = m[0] * x + m[3] * y + m[6];
                        this.y = m[1] * x + m[4] * y + m[7];
                        return this;
                    },
                    /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector2#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector2 with.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ transformMat4: function(mat) {
                        var x = this.x;
                        var y = this.y;
                        var m = mat.val;
                        this.x = m[0] * x + m[4] * y + m[12];
                        this.y = m[1] * x + m[5] * y + m[13];
                        return this;
                    },
                    /**
     * Make this Vector the zero vector (0, 0).
     *
     * @method Phaser.Math.Vector2#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ reset: function() {
                        this.x = 0;
                        this.y = 0;
                        return this;
                    },
                    /**
     * Limit the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#limit
     * @since 3.23.0
     *
     * @param {number} max - The maximum length.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ limit: function(max) {
                        var len = this.length();
                        if (len && len > max) this.scale(max / len);
                        return this;
                    },
                    /**
     * Reflect this Vector off a line defined by a normal.
     *
     * @method Phaser.Math.Vector2#reflect
     * @since 3.23.0
     *
     * @param {Phaser.Math.Vector2} normal - A vector perpendicular to the line.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ reflect: function(normal) {
                        normal = normal.clone().normalize();
                        return this.subtract(normal.scale(2 * this.dot(normal)));
                    },
                    /**
     * Reflect this Vector across another.
     *
     * @method Phaser.Math.Vector2#mirror
     * @since 3.23.0
     *
     * @param {Phaser.Math.Vector2} axis - A vector to reflect across.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ mirror: function(axis) {
                        return this.reflect(axis).negate();
                    },
                    /**
     * Rotate this Vector by an angle amount.
     *
     * @method Phaser.Math.Vector2#rotate
     * @since 3.23.0
     *
     * @param {number} delta - The angle to rotate by, in radians.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ rotate: function(delta) {
                        var cos = Math.cos(delta);
                        var sin = Math.sin(delta);
                        return this.set(cos * this.x - sin * this.y, sin * this.x + cos * this.y);
                    },
                    /**
     * Project this Vector onto another.
     *
     * @method Phaser.Math.Vector2#project
     * @since 3.60.0
     *
     * @param {Phaser.Math.Vector2} src - The vector to project onto.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ project: function(src) {
                        var scalar = this.dot(src) / src.dot(src);
                        return this.copy(src).scale(scalar);
                    }
                });
                /**
 * A static zero Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.ZERO
 * @type {Phaser.Math.Vector2}
 * @since 3.1.0
 */ Vector2.ZERO = new Vector2();
                /**
 * A static right Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.RIGHT
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.RIGHT = new Vector2(1, 0);
                /**
 * A static left Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.LEFT
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.LEFT = new Vector2(-1, 0);
                /**
 * A static up Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.UP
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.UP = new Vector2(0, -1);
                /**
 * A static down Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.DOWN
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.DOWN = new Vector2(0, 1);
                /**
 * A static one Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.ONE
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.ONE = new Vector2(1, 1);
                module1.exports = Vector2;
            /***/ },
            /***/ 25836: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
                //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
                var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A representation of a vector in 3D space.
 *
 * A three-component vector.
 *
 * @class Vector3
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 */ var Vector3 = new Class({
                    initialize: function Vector3(x, y, z) {
                        /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector3#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                        /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector3#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                        /**
         * The z component of this Vector.
         *
         * @name Phaser.Math.Vector3#z
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.z = 0;
                        if (typeof x === 'object') {
                            this.x = x.x || 0;
                            this.y = x.y || 0;
                            this.z = x.z || 0;
                        } else {
                            this.x = x || 0;
                            this.y = y || 0;
                            this.z = z || 0;
                        }
                    },
                    /**
     * Set this Vector to point up.
     *
     * Sets the y component of the vector to 1, and the others to 0.
     *
     * @method Phaser.Math.Vector3#up
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ up: function() {
                        this.x = 0;
                        this.y = 1;
                        this.z = 0;
                        return this;
                    },
                    /**
     * Sets the components of this Vector to be the `Math.min` result from the given vector.
     *
     * @method Phaser.Math.Vector3#min
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to check the minimum values against.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ min: function(v) {
                        this.x = Math.min(this.x, v.x);
                        this.y = Math.min(this.y, v.y);
                        this.z = Math.min(this.z, v.z);
                        return this;
                    },
                    /**
     * Sets the components of this Vector to be the `Math.max` result from the given vector.
     *
     * @method Phaser.Math.Vector3#max
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to check the maximum values against.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ max: function(v) {
                        this.x = Math.max(this.x, v.x);
                        this.y = Math.max(this.y, v.y);
                        this.z = Math.max(this.z, v.z);
                        return this;
                    },
                    /**
     * Make a clone of this Vector3.
     *
     * @method Phaser.Math.Vector3#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} A new Vector3 object containing this Vectors values.
     */ clone: function() {
                        return new Vector3(this.x, this.y, this.z);
                    },
                    /**
     * Adds the two given Vector3s and sets the results into this Vector3.
     *
     * @method Phaser.Math.Vector3#addVectors
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} a - The first Vector to add.
     * @param {Phaser.Math.Vector3} b - The second Vector to add.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addVectors: function(a, b) {
                        this.x = a.x + b.x;
                        this.y = a.y + b.y;
                        this.z = a.z + b.z;
                        return this;
                    },
                    /**
     * Subtracts the two given Vector3s and sets the results into this Vector3.
     *
     * @method Phaser.Math.Vector3#subVectors
     * @since 3.85.0
     *
     * @param {Phaser.Math.Vector3} a - The first Vector to sub.
     * @param {Phaser.Math.Vector3} b - The second Vector to sub.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ subVectors: function(a, b) {
                        this.x = a.x - b.x;
                        this.y = a.y - b.y;
                        this.z = a.z - b.z;
                        return this;
                    },
                    /**
     * Calculate the cross (vector) product of two given Vectors.
     *
     * @method Phaser.Math.Vector3#crossVectors
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} a - The first Vector to multiply.
     * @param {Phaser.Math.Vector3} b - The second Vector to multiply.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ crossVectors: function(a, b) {
                        var ax = a.x;
                        var ay = a.y;
                        var az = a.z;
                        var bx = b.x;
                        var by = b.y;
                        var bz = b.z;
                        this.x = ay * bz - az * by;
                        this.y = az * bx - ax * bz;
                        this.z = ax * by - ay * bx;
                        return this;
                    },
                    /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict equality check against each Vector's components.
     *
     * @method Phaser.Math.Vector3#equals
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to compare against.
     *
     * @return {boolean} True if the two vectors strictly match, otherwise false.
     */ equals: function(v) {
                        return this.x === v.x && this.y === v.y && this.z === v.z;
                    },
                    /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector3#copy
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ copy: function(src) {
                        this.x = src.x;
                        this.y = src.y;
                        this.z = src.z || 0;
                        return this;
                    },
                    /**
     * Set the `x`, `y`, and `z` components of this Vector to the given `x`, `y`, and `z` values.
     *
     * @method Phaser.Math.Vector3#set
     * @since 3.0.0
     *
     * @param {(number|object)} x - The x value to set for this Vector, or an object containing x, y and z components.
     * @param {number} [y] - The y value to set for this Vector.
     * @param {number} [z] - The z value to set for this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ set: function(x, y, z) {
                        if (typeof x === 'object') {
                            this.x = x.x || 0;
                            this.y = x.y || 0;
                            this.z = x.z || 0;
                        } else {
                            this.x = x || 0;
                            this.y = y || 0;
                            this.z = z || 0;
                        }
                        return this;
                    },
                    /**
     * Sets the components of this Vector3 from the position of the given Matrix4.
     *
     * @method Phaser.Math.Vector3#setFromMatrixPosition
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to get the position from.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ setFromMatrixPosition: function(m) {
                        return this.fromArray(m.val, 12);
                    },
                    /**
     * Sets the components of this Vector3 from the Matrix4 column specified.
     *
     * @method Phaser.Math.Vector3#setFromMatrixColumn
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to get the column from.
     * @param {number} index - The column index.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ setFromMatrixColumn: function(mat4, index) {
                        return this.fromArray(mat4.val, index * 4);
                    },
                    /**
     * Sets the components of this Vector3 from the given array, based on the offset.
     *
     * Vector3.x = array[offset]
     * Vector3.y = array[offset + 1]
     * Vector3.z = array[offset + 2]
     *
     * @method Phaser.Math.Vector3#fromArray
     * @since 3.50.0
     *
     * @param {number[]} array - The array of values to get this Vector from.
     * @param {number} [offset=0] - The offset index into the array.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ fromArray: function(array, offset) {
                        if (offset === undefined) offset = 0;
                        this.x = array[offset];
                        this.y = array[offset + 1];
                        this.z = array[offset + 2];
                        return this;
                    },
                    /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector3#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ add: function(v) {
                        this.x += v.x;
                        this.y += v.y;
                        this.z += v.z || 0;
                        return this;
                    },
                    /**
     * Add the given value to each component of this Vector.
     *
     * @method Phaser.Math.Vector3#addScalar
     * @since 3.50.0
     *
     * @param {number} s - The amount to add to this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addScalar: function(s) {
                        this.x += s;
                        this.y += s;
                        this.z += s;
                        return this;
                    },
                    /**
     * Add and scale a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector3#addScale
     * @since 3.50.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to add to this Vector.
     * @param {number} scale - The amount to scale `v` by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addScale: function(v, scale) {
                        this.x += v.x * scale;
                        this.y += v.y * scale;
                        this.z += v.z * scale || 0;
                        return this;
                    },
                    /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector3#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ subtract: function(v) {
                        this.x -= v.x;
                        this.y -= v.y;
                        this.z -= v.z || 0;
                        return this;
                    },
                    /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector3#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ multiply: function(v) {
                        this.x *= v.x;
                        this.y *= v.y;
                        this.z *= v.z || 1;
                        return this;
                    },
                    /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector3#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ scale: function(scale) {
                        if (isFinite(scale)) {
                            this.x *= scale;
                            this.y *= scale;
                            this.z *= scale;
                        } else {
                            this.x = 0;
                            this.y = 0;
                            this.z = 0;
                        }
                        return this;
                    },
                    /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector3#divide
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ divide: function(v) {
                        this.x /= v.x;
                        this.y /= v.y;
                        this.z /= v.z || 1;
                        return this;
                    },
                    /**
     * Negate the `x`, `y` and `z` components of this Vector.
     *
     * @method Phaser.Math.Vector3#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ negate: function() {
                        this.x = -this.x;
                        this.y = -this.y;
                        this.z = -this.z;
                        return this;
                    },
                    /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector3#distance
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(v) {
                        var dx = v.x - this.x;
                        var dy = v.y - this.y;
                        var dz = v.z - this.z || 0;
                        return Math.sqrt(dx * dx + dy * dy + dz * dz);
                    },
                    /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector3#distanceSq
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(v) {
                        var dx = v.x - this.x;
                        var dy = v.y - this.y;
                        var dz = v.z - this.z || 0;
                        return dx * dx + dy * dy + dz * dz;
                    },
                    /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector3#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        return Math.sqrt(x * x + y * y + z * z);
                    },
                    /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector3#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        return x * x + y * y + z * z;
                    },
                    /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector3#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ normalize: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var len = x * x + y * y + z * z;
                        if (len > 0) {
                            len = 1 / Math.sqrt(len);
                            this.x = x * len;
                            this.y = y * len;
                            this.z = z * len;
                        }
                        return this;
                    },
                    /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector3#dot
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to dot product with this Vector3.
     *
     * @return {number} The dot product of this Vector and `v`.
     */ dot: function(v) {
                        return this.x * v.x + this.y * v.y + this.z * v.z;
                    },
                    /**
     * Calculate the cross (vector) product of this Vector (which will be modified) and the given Vector.
     *
     * @method Phaser.Math.Vector3#cross
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector to cross product with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ cross: function(v) {
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var bx = v.x;
                        var by = v.y;
                        var bz = v.z;
                        this.x = ay * bz - az * by;
                        this.y = az * bx - ax * bz;
                        this.z = ax * by - ay * bx;
                        return this;
                    },
                    /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector3#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ lerp: function(v, t) {
                        if (t === undefined) t = 0;
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        this.x = ax + t * (v.x - ax);
                        this.y = ay + t * (v.y - ay);
                        this.z = az + t * (v.z - az);
                        return this;
                    },
                    /**
     * Takes a Matrix3 and applies it to this Vector3.
     *
     * @method Phaser.Math.Vector3#applyMatrix3
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix3} mat3 - The Matrix3 to apply to this Vector3.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ applyMatrix3: function(mat3) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var m = mat3.val;
                        this.x = m[0] * x + m[3] * y + m[6] * z;
                        this.y = m[1] * x + m[4] * y + m[7] * z;
                        this.z = m[2] * x + m[5] * y + m[8] * z;
                        return this;
                    },
                    /**
     * Takes a Matrix4 and applies it to this Vector3.
     *
     * @method Phaser.Math.Vector3#applyMatrix4
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to apply to this Vector3.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ applyMatrix4: function(mat4) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var m = mat4.val;
                        var w = 1 / (m[3] * x + m[7] * y + m[11] * z + m[15]);
                        this.x = (m[0] * x + m[4] * y + m[8] * z + m[12]) * w;
                        this.y = (m[1] * x + m[5] * y + m[9] * z + m[13]) * w;
                        this.z = (m[2] * x + m[6] * y + m[10] * z + m[14]) * w;
                        return this;
                    },
                    /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector3#transformMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix3 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformMat3: function(mat) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var m = mat.val;
                        this.x = x * m[0] + y * m[3] + z * m[6];
                        this.y = x * m[1] + y * m[4] + z * m[7];
                        this.z = x * m[2] + y * m[5] + z * m[8];
                        return this;
                    },
                    /**
     * Transform this Vector with the given Matrix4.
     *
     * @method Phaser.Math.Vector3#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformMat4: function(mat) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var m = mat.val;
                        this.x = m[0] * x + m[4] * y + m[8] * z + m[12];
                        this.y = m[1] * x + m[5] * y + m[9] * z + m[13];
                        this.z = m[2] * x + m[6] * y + m[10] * z + m[14];
                        return this;
                    },
                    /**
     * Transforms the coordinates of this Vector3 with the given Matrix4.
     *
     * @method Phaser.Math.Vector3#transformCoordinates
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformCoordinates: function(mat) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var m = mat.val;
                        var tx = x * m[0] + y * m[4] + z * m[8] + m[12];
                        var ty = x * m[1] + y * m[5] + z * m[9] + m[13];
                        var tz = x * m[2] + y * m[6] + z * m[10] + m[14];
                        var tw = x * m[3] + y * m[7] + z * m[11] + m[15];
                        this.x = tx / tw;
                        this.y = ty / tw;
                        this.z = tz / tw;
                        return this;
                    },
                    /**
     * Transform this Vector with the given Quaternion.
     *
     * @method Phaser.Math.Vector3#transformQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to transform this Vector with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformQuat: function(q) {
                        // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var qx = q.x;
                        var qy = q.y;
                        var qz = q.z;
                        var qw = q.w;
                        // calculate quat * vec
                        var ix = qw * x + qy * z - qz * y;
                        var iy = qw * y + qz * x - qx * z;
                        var iz = qw * z + qx * y - qy * x;
                        var iw = -qx * x - qy * y - qz * z;
                        // calculate result * inverse quat
                        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                        return this;
                    },
                    /**
     * Multiplies this Vector3 by the specified matrix, applying a W divide. This is useful for projection,
     * e.g. unprojecting a 2D point into 3D space.
     *
     * @method Phaser.Math.Vector3#project
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to multiply this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ project: function(mat) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var m = mat.val;
                        var a00 = m[0];
                        var a01 = m[1];
                        var a02 = m[2];
                        var a03 = m[3];
                        var a10 = m[4];
                        var a11 = m[5];
                        var a12 = m[6];
                        var a13 = m[7];
                        var a20 = m[8];
                        var a21 = m[9];
                        var a22 = m[10];
                        var a23 = m[11];
                        var a30 = m[12];
                        var a31 = m[13];
                        var a32 = m[14];
                        var a33 = m[15];
                        var lw = 1 / (x * a03 + y * a13 + z * a23 + a33);
                        this.x = (x * a00 + y * a10 + z * a20 + a30) * lw;
                        this.y = (x * a01 + y * a11 + z * a21 + a31) * lw;
                        this.z = (x * a02 + y * a12 + z * a22 + a32) * lw;
                        return this;
                    },
                    /**
     * Multiplies this Vector3 by the given view and projection matrices.
     *
     * @method Phaser.Math.Vector3#projectViewMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} viewMatrix - A View Matrix.
     * @param {Phaser.Math.Matrix4} projectionMatrix - A Projection Matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ projectViewMatrix: function(viewMatrix, projectionMatrix) {
                        return this.applyMatrix4(viewMatrix).applyMatrix4(projectionMatrix);
                    },
                    /**
     * Multiplies this Vector3 by the given inversed projection matrix and world matrix.
     *
     * @method Phaser.Math.Vector3#unprojectViewMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} projectionMatrix - An inversed Projection Matrix.
     * @param {Phaser.Math.Matrix4} worldMatrix - A World View Matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ unprojectViewMatrix: function(projectionMatrix, worldMatrix) {
                        return this.applyMatrix4(projectionMatrix).applyMatrix4(worldMatrix);
                    },
                    /**
     * Unproject this point from 2D space to 3D space.
     * The point should have its x and y properties set to
     * 2D screen space, and the z either at 0 (near plane)
     * or 1 (far plane). The provided matrix is assumed to already
     * be combined, i.e. projection * view * model.
     *
     * After this operation, this vector's (x, y, z) components will
     * represent the unprojected 3D coordinate.
     *
     * @method Phaser.Math.Vector3#unproject
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} viewport - Screen x, y, width and height in pixels.
     * @param {Phaser.Math.Matrix4} invProjectionView - Combined projection and view matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ unproject: function(viewport, invProjectionView) {
                        var viewX = viewport.x;
                        var viewY = viewport.y;
                        var viewWidth = viewport.z;
                        var viewHeight = viewport.w;
                        var x = this.x - viewX;
                        var y = viewHeight - this.y - 1 - viewY;
                        var z = this.z;
                        this.x = 2 * x / viewWidth - 1;
                        this.y = 2 * y / viewHeight - 1;
                        this.z = 2 * z - 1;
                        return this.project(invProjectionView);
                    },
                    /**
     * Make this Vector the zero vector (0, 0, 0).
     *
     * @method Phaser.Math.Vector3#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ reset: function() {
                        this.x = 0;
                        this.y = 0;
                        this.z = 0;
                        return this;
                    }
                });
                /**
 * A static zero Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.ZERO
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.ZERO = new Vector3();
                /**
 * A static right Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.RIGHT
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.RIGHT = new Vector3(1, 0, 0);
                /**
 * A static left Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.LEFT
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.LEFT = new Vector3(-1, 0, 0);
                /**
 * A static up Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.UP
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.UP = new Vector3(0, -1, 0);
                /**
 * A static down Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.DOWN
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.DOWN = new Vector3(0, 1, 0);
                /**
 * A static forward Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.FORWARD
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.FORWARD = new Vector3(0, 0, 1);
                /**
 * A static back Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.BACK
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.BACK = new Vector3(0, 0, -1);
                /**
 * A static one Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.ONE
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.ONE = new Vector3(1, 1, 1);
                module1.exports = Vector3;
            /***/ },
            /***/ 61369: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
                //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
                var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A representation of a vector in 4D space.
 *
 * A four-component vector.
 *
 * @class Vector4
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 * @param {number} [w] - The w component.
 */ var Vector4 = new Class({
                    initialize: function Vector4(x, y, z, w) {
                        /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector4#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                        /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector4#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                        /**
         * The z component of this Vector.
         *
         * @name Phaser.Math.Vector4#z
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.z = 0;
                        /**
         * The w component of this Vector.
         *
         * @name Phaser.Math.Vector4#w
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.w = 0;
                        if (typeof x === 'object') {
                            this.x = x.x || 0;
                            this.y = x.y || 0;
                            this.z = x.z || 0;
                            this.w = x.w || 0;
                        } else {
                            this.x = x || 0;
                            this.y = y || 0;
                            this.z = z || 0;
                            this.w = w || 0;
                        }
                    },
                    /**
     * Make a clone of this Vector4.
     *
     * @method Phaser.Math.Vector4#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} A clone of this Vector4.
     */ clone: function() {
                        return new Vector4(this.x, this.y, this.z, this.w);
                    },
                    /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector4#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ copy: function(src) {
                        this.x = src.x;
                        this.y = src.y;
                        this.z = src.z || 0;
                        this.w = src.w || 0;
                        return this;
                    },
                    /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict quality check against each Vector's components.
     *
     * @method Phaser.Math.Vector4#equals
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The vector to check equality with.
     *
     * @return {boolean} A boolean indicating whether the two Vectors are equal or not.
     */ equals: function(v) {
                        return this.x === v.x && this.y === v.y && this.z === v.z && this.w === v.w;
                    },
                    /**
     * Set the `x`, `y`, `z` and `w` components of the this Vector to the given `x`, `y`, `z` and `w` values.
     *
     * @method Phaser.Math.Vector4#set
     * @since 3.0.0
     *
     * @param {(number|object)} x - The x value to set for this Vector, or an object containing x, y, z and w components.
     * @param {number} y - The y value to set for this Vector.
     * @param {number} z - The z value to set for this Vector.
     * @param {number} w - The z value to set for this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ set: function(x, y, z, w) {
                        if (typeof x === 'object') {
                            this.x = x.x || 0;
                            this.y = x.y || 0;
                            this.z = x.z || 0;
                            this.w = x.w || 0;
                        } else {
                            this.x = x || 0;
                            this.y = y || 0;
                            this.z = z || 0;
                            this.w = w || 0;
                        }
                        return this;
                    },
                    /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector4#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ add: function(v) {
                        this.x += v.x;
                        this.y += v.y;
                        this.z += v.z || 0;
                        this.w += v.w || 0;
                        return this;
                    },
                    /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector4#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ subtract: function(v) {
                        this.x -= v.x;
                        this.y -= v.y;
                        this.z -= v.z || 0;
                        this.w -= v.w || 0;
                        return this;
                    },
                    /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector4#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ scale: function(scale) {
                        this.x *= scale;
                        this.y *= scale;
                        this.z *= scale;
                        this.w *= scale;
                        return this;
                    },
                    /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector4#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var w = this.w;
                        return Math.sqrt(x * x + y * y + z * z + w * w);
                    },
                    /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector4#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var w = this.w;
                        return x * x + y * y + z * z + w * w;
                    },
                    /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector4#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ normalize: function() {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var w = this.w;
                        var len = x * x + y * y + z * z + w * w;
                        if (len > 0) {
                            len = 1 / Math.sqrt(len);
                            this.x = x * len;
                            this.y = y * len;
                            this.z = z * len;
                            this.w = w * len;
                        }
                        return this;
                    },
                    /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector4#dot
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The Vector4 to dot product with this Vector4.
     *
     * @return {number} The dot product of this Vector and the given Vector.
     */ dot: function(v) {
                        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
                    },
                    /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector4#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The Vector4 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ lerp: function(v, t) {
                        if (t === undefined) t = 0;
                        var ax = this.x;
                        var ay = this.y;
                        var az = this.z;
                        var aw = this.w;
                        this.x = ax + t * (v.x - ax);
                        this.y = ay + t * (v.y - ay);
                        this.z = az + t * (v.z - az);
                        this.w = aw + t * (v.w - aw);
                        return this;
                    },
                    /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector4#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ multiply: function(v) {
                        this.x *= v.x;
                        this.y *= v.y;
                        this.z *= v.z || 1;
                        this.w *= v.w || 1;
                        return this;
                    },
                    /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector4#divide
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ divide: function(v) {
                        this.x /= v.x;
                        this.y /= v.y;
                        this.z /= v.z || 1;
                        this.w /= v.w || 1;
                        return this;
                    },
                    /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector4#distance
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(v) {
                        var dx = v.x - this.x;
                        var dy = v.y - this.y;
                        var dz = v.z - this.z || 0;
                        var dw = v.w - this.w || 0;
                        return Math.sqrt(dx * dx + dy * dy + dz * dz + dw * dw);
                    },
                    /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector4#distanceSq
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(v) {
                        var dx = v.x - this.x;
                        var dy = v.y - this.y;
                        var dz = v.z - this.z || 0;
                        var dw = v.w - this.w || 0;
                        return dx * dx + dy * dy + dz * dz + dw * dw;
                    },
                    /**
     * Negate the `x`, `y`, `z` and `w` components of this Vector.
     *
     * @method Phaser.Math.Vector4#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ negate: function() {
                        this.x = -this.x;
                        this.y = -this.y;
                        this.z = -this.z;
                        this.w = -this.w;
                        return this;
                    },
                    /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector4#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector4 with.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ transformMat4: function(mat) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var w = this.w;
                        var m = mat.val;
                        this.x = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
                        this.y = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
                        this.z = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
                        this.w = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
                        return this;
                    },
                    /**
     * Transform this Vector with the given Quaternion.
     *
     * @method Phaser.Math.Vector4#transformQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to transform this Vector with.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ transformQuat: function(q) {
                        var x = this.x;
                        var y = this.y;
                        var z = this.z;
                        var qx = q.x;
                        var qy = q.y;
                        var qz = q.z;
                        var qw = q.w;
                        // calculate quat * vec
                        var ix = qw * x + qy * z - qz * y;
                        var iy = qw * y + qz * x - qx * z;
                        var iz = qw * z + qx * y - qy * x;
                        var iw = -qx * x - qy * y - qz * z;
                        // calculate result * inverse quat
                        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                        return this;
                    },
                    /**
     * Make this Vector the zero vector (0, 0, 0, 0).
     *
     * @method Phaser.Math.Vector4#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ reset: function() {
                        this.x = 0;
                        this.y = 0;
                        this.z = 0;
                        this.w = 0;
                        return this;
                    }
                });
                Vector4.prototype.sub = Vector4.prototype.subtract;
                Vector4.prototype.mul = Vector4.prototype.multiply;
                Vector4.prototype.div = Vector4.prototype.divide;
                Vector4.prototype.dist = Vector4.prototype.distance;
                Vector4.prototype.distSq = Vector4.prototype.distanceSq;
                Vector4.prototype.len = Vector4.prototype.length;
                Vector4.prototype.lenSq = Vector4.prototype.lengthSq;
                module1.exports = Vector4;
            /***/ },
            /***/ 60417: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the two values are within the given `tolerance` of each other.
 *
 * @function Phaser.Math.Within
 * @since 3.0.0
 *
 * @param {number} a - The first value to use in the calculation.
 * @param {number} b - The second value to use in the calculation.
 * @param {number} tolerance - The tolerance. Anything equal to or less than this value is considered as being within range.
 *
 * @return {boolean} Returns `true` if `a` is less than or equal to the tolerance of `b`.
 */ var Within = function(a, b, tolerance) {
                    return Math.abs(a - b) <= tolerance;
                };
                module1.exports = Within;
            /***/ },
            /***/ 15994: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Wrap the given `value` between `min` and `max`.
 *
 * @function Phaser.Math.Wrap
 * @since 3.0.0
 *
 * @param {number} value - The value to wrap.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 *
 * @return {number} The wrapped value.
 */ var Wrap = function(value, min, max) {
                    var range = max - min;
                    return min + ((value - min) % range + range) % range;
                };
                module1.exports = Wrap;
            /***/ },
            /***/ 31040: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (x1, y1) -> (x2, y2).
 *
 * @function Phaser.Math.Angle.Between
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The angle in radians.
 */ var Between = function(x1, y1, x2, y2) {
                    return Math.atan2(y2 - y1, x2 - x1);
                };
                module1.exports = Between;
            /***/ },
            /***/ 55495: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
 *
 * Calculates the angle of the vector from the first point to the second point.
 *
 * @function Phaser.Math.Angle.BetweenPoints
 * @since 3.0.0
 *
 * @param {Phaser.Types.Math.Vector2Like} point1 - The first point.
 * @param {Phaser.Types.Math.Vector2Like} point2 - The second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenPoints = function(point1, point2) {
                    return Math.atan2(point2.y - point1.y, point2.x - point1.x);
                };
                module1.exports = BetweenPoints;
            /***/ },
            /***/ 128: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
 *
 * The difference between this method and {@link Phaser.Math.Angle.BetweenPoints} is that this assumes the y coordinate
 * travels down the screen.
 *
 * @function Phaser.Math.Angle.BetweenPointsY
 * @since 3.0.0
 *
 * @param {Phaser.Types.Math.Vector2Like} point1 - The first point.
 * @param {Phaser.Types.Math.Vector2Like} point2 - The second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenPointsY = function(point1, point2) {
                    return Math.atan2(point2.x - point1.x, point2.y - point1.y);
                };
                module1.exports = BetweenPointsY;
            /***/ },
            /***/ 41273: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (x1, y1) -> (x2, y2).
 *
 * The difference between this method and {@link Phaser.Math.Angle.Between} is that this assumes the y coordinate
 * travels down the screen.
 *
 * @function Phaser.Math.Angle.BetweenY
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenY = function(x1, y1, x2, y2) {
                    return Math.atan2(x2 - x1, y2 - y1);
                };
                module1.exports = BetweenY;
            /***/ },
            /***/ 1432: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(36383);
                /**
 * Takes an angle in Phasers default clockwise format and converts it so that
 * 0 is North, 90 is West, 180 is South and 270 is East,
 * therefore running counter-clockwise instead of clockwise.
 * 
 * You can pass in the angle from a Game Object using:
 * 
 * ```javascript
 * var converted = CounterClockwise(gameobject.rotation);
 * ```
 * 
 * All values for this function are in radians.
 *
 * @function Phaser.Math.Angle.CounterClockwise
 * @since 3.16.0
 *
 * @param {number} angle - The angle to convert, in radians.
 *
 * @return {number} The converted angle, in radians.
 */ var CounterClockwise = function(angle) {
                    if (angle > Math.PI) angle -= CONST.PI2;
                    return Math.abs(((angle + CONST.TAU) % CONST.PI2 - CONST.PI2) % CONST.PI2);
                };
                module1.exports = CounterClockwise;
            /***/ },
            /***/ 12407: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Normalize an angle to the [0, 2pi] range.
 *
 * @function Phaser.Math.Angle.Normalize
 * @since 3.0.0
 *
 * @param {number} angle - The angle to normalize, in radians.
 *
 * @return {number} The normalized angle, in radians.
 */ var Normalize = function(angle) {
                    angle = angle % (2 * Math.PI);
                    if (angle >= 0) return angle;
                    else return angle + 2 * Math.PI;
                };
                module1.exports = Normalize;
            /***/ },
            /***/ 53993: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       @samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FloatBetween = __webpack_require__(99472);
                /**
 * Returns a random angle in the range [-pi, pi].
 *
 * @function Phaser.Math.Angle.Random
 * @since 3.23.0
 *
 * @return {number} The angle, in radians.
 */ var Random = function() {
                    return FloatBetween(-Math.PI, Math.PI);
                };
                module1.exports = Random;
            /***/ },
            /***/ 86564: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       @samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FloatBetween = __webpack_require__(99472);
                /**
 * Returns a random angle in the range [-180, 180].
 *
 * @function Phaser.Math.Angle.RandomDegrees
 * @since 3.23.0
 *
 * @return {number} The angle, in degrees.
 */ var RandomDegrees = function() {
                    return FloatBetween(-180, 180);
                };
                module1.exports = RandomDegrees;
            /***/ },
            /***/ 90154: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Normalize = __webpack_require__(12407);
                /**
 * Reverse the given angle.
 *
 * @function Phaser.Math.Angle.Reverse
 * @since 3.0.0
 *
 * @param {number} angle - The angle to reverse, in radians.
 *
 * @return {number} The reversed angle, in radians.
 */ var Reverse = function(angle) {
                    return Normalize(angle + Math.PI);
                };
                module1.exports = Reverse;
            /***/ },
            /***/ 48736: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(36383);
                /**
 * Rotates `currentAngle` towards `targetAngle`, taking the shortest rotation distance. The `lerp` argument is the amount to rotate by in this call.
 *
 * @function Phaser.Math.Angle.RotateTo
 * @since 3.0.0
 *
 * @param {number} currentAngle - The current angle, in radians.
 * @param {number} targetAngle - The target angle to rotate to, in radians.
 * @param {number} [lerp=0.05] - The lerp value to add to the current angle.
 *
 * @return {number} The adjusted angle.
 */ var RotateTo = function(currentAngle, targetAngle, lerp) {
                    if (lerp === undefined) lerp = 0.05;
                    if (currentAngle === targetAngle) return currentAngle;
                    if (Math.abs(targetAngle - currentAngle) <= lerp || Math.abs(targetAngle - currentAngle) >= MATH_CONST.PI2 - lerp) currentAngle = targetAngle;
                    else {
                        if (Math.abs(targetAngle - currentAngle) > Math.PI) {
                            if (targetAngle < currentAngle) targetAngle += MATH_CONST.PI2;
                            else targetAngle -= MATH_CONST.PI2;
                        }
                        if (targetAngle > currentAngle) currentAngle += lerp;
                        else if (targetAngle < currentAngle) currentAngle -= lerp;
                    }
                    return currentAngle;
                };
                module1.exports = RotateTo;
            /***/ },
            /***/ 61430: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Gets the shortest angle between `angle1` and `angle2`.
 *
 * Both angles must be in the range -180 to 180, which is the same clamped
 * range that `sprite.angle` uses, so you can pass in two sprite angles to
 * this method and get the shortest angle back between the two of them.
 *
 * The angle returned will be in the same range. If the returned angle is
 * greater than 0 then it's a counter-clockwise rotation, if < 0 then it's
 * a clockwise rotation.
 *
 * @function Phaser.Math.Angle.ShortestBetween
 * @since 3.0.0
 *
 * @param {number} angle1 - The first angle in the range -180 to 180.
 * @param {number} angle2 - The second angle in the range -180 to 180.
 *
 * @return {number} The shortest angle, in degrees. If greater than zero it's a counter-clockwise rotation.
 */ var ShortestBetween = function(angle1, angle2) {
                    var difference = angle2 - angle1;
                    if (difference === 0) return 0;
                    var times = Math.floor((difference - -180) / 360);
                    return difference - times * 360;
                };
                module1.exports = ShortestBetween;
            /***/ },
            /***/ 86554: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathWrap = __webpack_require__(15994);
                /**
 * Wrap an angle.
 *
 * Wraps the angle to a value in the range of -PI to PI.
 *
 * @function Phaser.Math.Angle.Wrap
 * @since 3.0.0
 *
 * @param {number} angle - The angle to wrap, in radians.
 *
 * @return {number} The wrapped angle, in radians.
 */ var Wrap = function(angle) {
                    return MathWrap(angle, -Math.PI, Math.PI);
                };
                module1.exports = Wrap;
            /***/ },
            /***/ 30954: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Wrap = __webpack_require__(15994);
                /**
 * Wrap an angle in degrees.
 *
 * Wraps the angle to a value in the range of -180 to 180.
 *
 * @function Phaser.Math.Angle.WrapDegrees
 * @since 3.0.0
 *
 * @param {number} angle - The angle to wrap, in degrees.
 *
 * @return {number} The wrapped angle, in degrees.
 */ var WrapDegrees = function(angle) {
                    return Wrap(angle, -180, 180);
                };
                module1.exports = WrapDegrees;
            /***/ },
            /***/ 25588: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Angle
 */ module1.exports = {
                    Between: __webpack_require__(31040),
                    BetweenPoints: __webpack_require__(55495),
                    BetweenPointsY: __webpack_require__(128),
                    BetweenY: __webpack_require__(41273),
                    CounterClockwise: __webpack_require__(1432),
                    Normalize: __webpack_require__(12407),
                    Random: __webpack_require__(53993),
                    RandomDegrees: __webpack_require__(86564),
                    Reverse: __webpack_require__(90154),
                    RotateTo: __webpack_require__(48736),
                    ShortestBetween: __webpack_require__(61430),
                    Wrap: __webpack_require__(86554),
                    WrapDegrees: __webpack_require__(30954)
                };
            /***/ },
            /***/ 36383: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = {
                    /**
     * The value of PI * 2.
     *
     * @name Phaser.Math.PI2
     * @type {number}
     * @since 3.0.0
     */ PI2: Math.PI * 2,
                    /**
     * The value of PI * 0.5.
     *
     * Yes, we understand that this should actually be PI * 2, but
     * it has been like this for so long we can't change it now.
     * If you need PI * 2, use the PI2 constant instead.
     *
     * @name Phaser.Math.TAU
     * @type {number}
     * @since 3.0.0
     */ TAU: Math.PI * 0.5,
                    /**
     * An epsilon value (1.0e-6)
     *
     * @name Phaser.Math.EPSILON
     * @type {number}
     * @since 3.0.0
     */ EPSILON: 1.0e-6,
                    /**
     * For converting degrees to radians (PI / 180)
     *
     * @name Phaser.Math.DEG_TO_RAD
     * @type {number}
     * @since 3.0.0
     */ DEG_TO_RAD: Math.PI / 180,
                    /**
     * For converting radians to degrees (180 / PI)
     *
     * @name Phaser.Math.RAD_TO_DEG
     * @type {number}
     * @since 3.0.0
     */ RAD_TO_DEG: 180 / Math.PI,
                    /**
     * An instance of the Random Number Generator.
     * This is not set until the Game boots.
     *
     * @name Phaser.Math.RND
     * @type {Phaser.Math.RandomDataGenerator}
     * @since 3.0.0
     */ RND: null,
                    /**
     * The minimum safe integer this browser supports.
     * We use a const for backward compatibility with Internet Explorer.
     *
     * @name Phaser.Math.MIN_SAFE_INTEGER
     * @type {number}
     * @since 3.21.0
     */ MIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER || -9007199254740991,
                    /**
     * The maximum safe integer this browser supports.
     * We use a const for backward compatibility with Internet Explorer.
     *
     * @name Phaser.Math.MAX_SAFE_INTEGER
     * @type {number}
     * @since 3.21.0
     */ MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991
                };
                module1.exports = MATH_CONST;
            /***/ },
            /***/ 20339: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points).
 *
 * @function Phaser.Math.Distance.Between
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var DistanceBetween = function(x1, y1, x2, y2) {
                    var dx = x1 - x2;
                    var dy = y1 - y2;
                    return Math.sqrt(dx * dx + dy * dy);
                };
                module1.exports = DistanceBetween;
            /***/ },
            /***/ 52816: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two points.
 *
 * @function Phaser.Math.Distance.BetweenPoints
 * @since 3.22.0
 *
 * @param {Phaser.Types.Math.Vector2Like} a - The first point.
 * @param {Phaser.Types.Math.Vector2Like} b - The second point.
 *
 * @return {number} The distance between the points.
 */ var DistanceBetweenPoints = function(a, b) {
                    var dx = a.x - b.x;
                    var dy = a.y - b.y;
                    return Math.sqrt(dx * dx + dy * dy);
                };
                module1.exports = DistanceBetweenPoints;
            /***/ },
            /***/ 64559: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the squared distance between two points.
 *
 * @function Phaser.Math.Distance.BetweenPointsSquared
 * @since 3.22.0
 *
 * @param {Phaser.Types.Math.Vector2Like} a - The first point.
 * @param {Phaser.Types.Math.Vector2Like} b - The second point.
 *
 * @return {number} The squared distance between the points.
 */ var DistanceBetweenPointsSquared = function(a, b) {
                    var dx = a.x - b.x;
                    var dy = a.y - b.y;
                    return dx * dx + dy * dy;
                };
                module1.exports = DistanceBetweenPointsSquared;
            /***/ },
            /***/ 82340: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the Chebyshev distance between two sets of coordinates (points).
 *
 * Chebyshev distance (or chessboard distance) is the maximum of the horizontal and vertical distances.
 * It's the effective distance when movement can be horizontal, vertical, or diagonal.
 *
 * @function Phaser.Math.Distance.Chebyshev
 * @since 3.22.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var ChebyshevDistance = function(x1, y1, x2, y2) {
                    return Math.max(Math.abs(x1 - x2), Math.abs(y1 - y2));
                };
                module1.exports = ChebyshevDistance;
            /***/ },
            /***/ 14390: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points) to the power of `pow`.
 *
 * @function Phaser.Math.Distance.Power
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 * @param {number} pow - The exponent.
 *
 * @return {number} The distance between each point.
 */ var DistancePower = function(x1, y1, x2, y2, pow) {
                    if (pow === undefined) pow = 2;
                    return Math.sqrt(Math.pow(x2 - x1, pow) + Math.pow(y2 - y1, pow));
                };
                module1.exports = DistancePower;
            /***/ },
            /***/ 2243: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the snake distance between two sets of coordinates (points).
 *
 * Snake distance (rectilinear distance, Manhattan distance) is the sum of the horizontal and vertical distances.
 * It's the effective distance when movement is allowed only horizontally or vertically (but not both).
 *
 * @function Phaser.Math.Distance.Snake
 * @since 3.22.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var SnakeDistance = function(x1, y1, x2, y2) {
                    return Math.abs(x1 - x2) + Math.abs(y1 - y2);
                };
                module1.exports = SnakeDistance;
            /***/ },
            /***/ 89774: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points), squared.
 *
 * @function Phaser.Math.Distance.Squared
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point, squared.
 */ var DistanceSquared = function(x1, y1, x2, y2) {
                    var dx = x1 - x2;
                    var dy = y1 - y2;
                    return dx * dx + dy * dy;
                };
                module1.exports = DistanceSquared;
            /***/ },
            /***/ 50994: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Distance
 */ module1.exports = {
                    Between: __webpack_require__(20339),
                    BetweenPoints: __webpack_require__(52816),
                    BetweenPointsSquared: __webpack_require__(64559),
                    Chebyshev: __webpack_require__(82340),
                    Power: __webpack_require__(14390),
                    Snake: __webpack_require__(2243),
                    Squared: __webpack_require__(89774)
                };
            /***/ },
            /***/ 62640: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Back = __webpack_require__(54178);
                var Bounce = __webpack_require__(41521);
                var Circular = __webpack_require__(79980);
                var Cubic = __webpack_require__(85433);
                var Elastic = __webpack_require__(99140);
                var Expo = __webpack_require__(48857);
                var Linear = __webpack_require__(81596);
                var Quadratic = __webpack_require__(59133);
                var Quartic = __webpack_require__(98516);
                var Quintic = __webpack_require__(35248);
                var Sine = __webpack_require__(82500);
                var Stepped = __webpack_require__(49752);
                //  EaseMap
                module1.exports = {
                    Power0: Linear,
                    Power1: Quadratic.Out,
                    Power2: Cubic.Out,
                    Power3: Quartic.Out,
                    Power4: Quintic.Out,
                    Linear: Linear,
                    Quad: Quadratic.Out,
                    Cubic: Cubic.Out,
                    Quart: Quartic.Out,
                    Quint: Quintic.Out,
                    Sine: Sine.Out,
                    Expo: Expo.Out,
                    Circ: Circular.Out,
                    Elastic: Elastic.Out,
                    Back: Back.Out,
                    Bounce: Bounce.Out,
                    Stepped: Stepped,
                    'Quad.easeIn': Quadratic.In,
                    'Cubic.easeIn': Cubic.In,
                    'Quart.easeIn': Quartic.In,
                    'Quint.easeIn': Quintic.In,
                    'Sine.easeIn': Sine.In,
                    'Expo.easeIn': Expo.In,
                    'Circ.easeIn': Circular.In,
                    'Elastic.easeIn': Elastic.In,
                    'Back.easeIn': Back.In,
                    'Bounce.easeIn': Bounce.In,
                    'Quad.easeOut': Quadratic.Out,
                    'Cubic.easeOut': Cubic.Out,
                    'Quart.easeOut': Quartic.Out,
                    'Quint.easeOut': Quintic.Out,
                    'Sine.easeOut': Sine.Out,
                    'Expo.easeOut': Expo.Out,
                    'Circ.easeOut': Circular.Out,
                    'Elastic.easeOut': Elastic.Out,
                    'Back.easeOut': Back.Out,
                    'Bounce.easeOut': Bounce.Out,
                    'Quad.easeInOut': Quadratic.InOut,
                    'Cubic.easeInOut': Cubic.InOut,
                    'Quart.easeInOut': Quartic.InOut,
                    'Quint.easeInOut': Quintic.InOut,
                    'Sine.easeInOut': Sine.InOut,
                    'Expo.easeInOut': Expo.InOut,
                    'Circ.easeInOut': Circular.InOut,
                    'Elastic.easeInOut': Elastic.InOut,
                    'Back.easeInOut': Back.InOut,
                    'Bounce.easeInOut': Bounce.InOut
                };
            /***/ },
            /***/ 1639: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-in.
 *
 * @function Phaser.Math.Easing.Back.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var In = function(v, overshoot) {
                    if (overshoot === undefined) overshoot = 1.70158;
                    return v * v * ((overshoot + 1) * v - overshoot);
                };
                module1.exports = In;
            /***/ },
            /***/ 50099: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-in/out.
 *
 * @function Phaser.Math.Easing.Back.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v, overshoot) {
                    if (overshoot === undefined) overshoot = 1.70158;
                    var s = overshoot * 1.525;
                    if ((v *= 2) < 1) return 0.5 * (v * v * ((s + 1) * v - s));
                    else return 0.5 * ((v -= 2) * v * ((s + 1) * v + s) + 2);
                };
                module1.exports = InOut;
            /***/ },
            /***/ 41286: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-out.
 *
 * @function Phaser.Math.Easing.Back.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var Out = function(v, overshoot) {
                    if (overshoot === undefined) overshoot = 1.70158;
                    return --v * v * ((overshoot + 1) * v + overshoot) + 1;
                };
                module1.exports = Out;
            /***/ },
            /***/ 54178: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Back
 */ module1.exports = {
                    In: __webpack_require__(1639),
                    Out: __webpack_require__(41286),
                    InOut: __webpack_require__(50099)
                };
            /***/ },
            /***/ 59590: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-in.
 *
 * @function Phaser.Math.Easing.Bounce.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    v = 1 - v;
                    if (v < 1 / 2.75) return 1 - 7.5625 * v * v;
                    else if (v < 2 / 2.75) return 1 - (7.5625 * (v -= 1.5 / 2.75) * v + 0.75);
                    else if (v < 2.5 / 2.75) return 1 - (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375);
                    else return 1 - (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375);
                };
                module1.exports = In;
            /***/ },
            /***/ 41788: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-in/out.
 *
 * @function Phaser.Math.Easing.Bounce.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    var reverse = false;
                    if (v < 0.5) {
                        v = 1 - v * 2;
                        reverse = true;
                    } else v = v * 2 - 1;
                    if (v < 1 / 2.75) v = 7.5625 * v * v;
                    else if (v < 2 / 2.75) v = 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
                    else if (v < 2.5 / 2.75) v = 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
                    else v = 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
                    if (reverse) return (1 - v) * 0.5;
                    else return v * 0.5 + 0.5;
                };
                module1.exports = InOut;
            /***/ },
            /***/ 69905: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-out.
 *
 * @function Phaser.Math.Easing.Bounce.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    if (v < 1 / 2.75) return 7.5625 * v * v;
                    else if (v < 2 / 2.75) return 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
                    else if (v < 2.5 / 2.75) return 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
                    else return 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
                };
                module1.exports = Out;
            /***/ },
            /***/ 41521: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Bounce
 */ module1.exports = {
                    In: __webpack_require__(59590),
                    Out: __webpack_require__(69905),
                    InOut: __webpack_require__(41788)
                };
            /***/ },
            /***/ 91861: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-in.
 *
 * @function Phaser.Math.Easing.Circular.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    return 1 - Math.sqrt(1 - v * v);
                };
                module1.exports = In;
            /***/ },
            /***/ 4177: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-in/out.
 *
 * @function Phaser.Math.Easing.Circular.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    if ((v *= 2) < 1) return -0.5 * (Math.sqrt(1 - v * v) - 1);
                    else return 0.5 * (Math.sqrt(1 - (v -= 2) * v) + 1);
                };
                module1.exports = InOut;
            /***/ },
            /***/ 57512: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-out.
 *
 * @function Phaser.Math.Easing.Circular.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    return Math.sqrt(1 - --v * v);
                };
                module1.exports = Out;
            /***/ },
            /***/ 79980: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Circular
 */ module1.exports = {
                    In: __webpack_require__(91861),
                    Out: __webpack_require__(57512),
                    InOut: __webpack_require__(4177)
                };
            /***/ },
            /***/ 51150: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-in.
 *
 * @function Phaser.Math.Easing.Cubic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    return v * v * v;
                };
                module1.exports = In;
            /***/ },
            /***/ 82820: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-in/out.
 *
 * @function Phaser.Math.Easing.Cubic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    if ((v *= 2) < 1) return 0.5 * v * v * v;
                    else return 0.5 * ((v -= 2) * v * v + 2);
                };
                module1.exports = InOut;
            /***/ },
            /***/ 35033: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-out.
 *
 * @function Phaser.Math.Easing.Cubic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    return --v * v * v + 1;
                };
                module1.exports = Out;
            /***/ },
            /***/ 85433: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Cubic
 */ module1.exports = {
                    In: __webpack_require__(51150),
                    Out: __webpack_require__(35033),
                    InOut: __webpack_require__(82820)
                };
            /***/ },
            /***/ 69965: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-in.
 *
 * @function Phaser.Math.Easing.Elastic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var In = function(v, amplitude, period) {
                    if (amplitude === undefined) amplitude = 0.1;
                    if (period === undefined) period = 0.1;
                    if (v === 0) return 0;
                    else if (v === 1) return 1;
                    else {
                        var s = period / 4;
                        if (amplitude < 1) amplitude = 1;
                        else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                        return -(amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
                    }
                };
                module1.exports = In;
            /***/ },
            /***/ 50665: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-in/out.
 *
 * @function Phaser.Math.Easing.Elastic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v, amplitude, period) {
                    if (amplitude === undefined) amplitude = 0.1;
                    if (period === undefined) period = 0.1;
                    if (v === 0) return 0;
                    else if (v === 1) return 1;
                    else {
                        var s = period / 4;
                        if (amplitude < 1) amplitude = 1;
                        else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                        if ((v *= 2) < 1) return -0.5 * (amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
                        else return amplitude * Math.pow(2, -10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period) * 0.5 + 1;
                    }
                };
                module1.exports = InOut;
            /***/ },
            /***/ 7744: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-out.
 *
 * @function Phaser.Math.Easing.Elastic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var Out = function(v, amplitude, period) {
                    if (amplitude === undefined) amplitude = 0.1;
                    if (period === undefined) period = 0.1;
                    if (v === 0) return 0;
                    else if (v === 1) return 1;
                    else {
                        var s = period / 4;
                        if (amplitude < 1) amplitude = 1;
                        else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                        return amplitude * Math.pow(2, -10 * v) * Math.sin((v - s) * (2 * Math.PI) / period) + 1;
                    }
                };
                module1.exports = Out;
            /***/ },
            /***/ 99140: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Elastic
 */ module1.exports = {
                    In: __webpack_require__(69965),
                    Out: __webpack_require__(7744),
                    InOut: __webpack_require__(50665)
                };
            /***/ },
            /***/ 24590: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-in.
 *
 * @function Phaser.Math.Easing.Expo.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    return Math.pow(2, 10 * (v - 1)) - 0.001;
                };
                module1.exports = In;
            /***/ },
            /***/ 87844: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-in/out.
 *
 * @function Phaser.Math.Easing.Expo.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    if ((v *= 2) < 1) return 0.5 * Math.pow(2, 10 * (v - 1));
                    else return 0.5 * (2 - Math.pow(2, -10 * (v - 1)));
                };
                module1.exports = InOut;
            /***/ },
            /***/ 89433: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-out.
 *
 * @function Phaser.Math.Easing.Expo.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    return 1 - Math.pow(2, -10 * v);
                };
                module1.exports = Out;
            /***/ },
            /***/ 48857: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Expo
 */ module1.exports = {
                    In: __webpack_require__(24590),
                    Out: __webpack_require__(89433),
                    InOut: __webpack_require__(87844)
                };
            /***/ },
            /***/ 48820: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing
 */ module1.exports = {
                    Back: __webpack_require__(54178),
                    Bounce: __webpack_require__(41521),
                    Circular: __webpack_require__(79980),
                    Cubic: __webpack_require__(85433),
                    Elastic: __webpack_require__(99140),
                    Expo: __webpack_require__(48857),
                    Linear: __webpack_require__(81596),
                    Quadratic: __webpack_require__(59133),
                    Quartic: __webpack_require__(98516),
                    Quintic: __webpack_require__(35248),
                    Sine: __webpack_require__(82500),
                    Stepped: __webpack_require__(49752)
                };
            /***/ },
            /***/ 7147: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Linear easing (no variation).
 *
 * @function Phaser.Math.Easing.Linear
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Linear = function(v) {
                    return v;
                };
                module1.exports = Linear;
            /***/ },
            /***/ 81596: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ module1.exports = __webpack_require__(7147);
            /***/ },
            /***/ 34826: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-in.
 *
 * @function Phaser.Math.Easing.Quadratic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    return v * v;
                };
                module1.exports = In;
            /***/ },
            /***/ 20544: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quadratic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    if ((v *= 2) < 1) return 0.5 * v * v;
                    else return -0.5 * (--v * (v - 2) - 1);
                };
                module1.exports = InOut;
            /***/ },
            /***/ 92029: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-out.
 *
 * @function Phaser.Math.Easing.Quadratic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    return v * (2 - v);
                };
                module1.exports = Out;
            /***/ },
            /***/ 59133: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quadratic
 */ module1.exports = {
                    In: __webpack_require__(34826),
                    Out: __webpack_require__(92029),
                    InOut: __webpack_require__(20544)
                };
            /***/ },
            /***/ 64413: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-in.
 *
 * @function Phaser.Math.Easing.Quartic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    return v * v * v * v;
                };
                module1.exports = In;
            /***/ },
            /***/ 78137: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quartic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    if ((v *= 2) < 1) return 0.5 * v * v * v * v;
                    else return -0.5 * ((v -= 2) * v * v * v - 2);
                };
                module1.exports = InOut;
            /***/ },
            /***/ 45840: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-out.
 *
 * @function Phaser.Math.Easing.Quartic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    return 1 - --v * v * v * v;
                };
                module1.exports = Out;
            /***/ },
            /***/ 98516: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quartic
 */ module1.exports = {
                    In: __webpack_require__(64413),
                    Out: __webpack_require__(45840),
                    InOut: __webpack_require__(78137)
                };
            /***/ },
            /***/ 87745: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-in.
 *
 * @function Phaser.Math.Easing.Quintic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    return v * v * v * v * v;
                };
                module1.exports = In;
            /***/ },
            /***/ 16509: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quintic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    if ((v *= 2) < 1) return 0.5 * v * v * v * v * v;
                    else return 0.5 * ((v -= 2) * v * v * v * v + 2);
                };
                module1.exports = InOut;
            /***/ },
            /***/ 17868: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-out.
 *
 * @function Phaser.Math.Easing.Quintic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    return --v * v * v * v * v + 1;
                };
                module1.exports = Out;
            /***/ },
            /***/ 35248: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quintic
 */ module1.exports = {
                    In: __webpack_require__(87745),
                    Out: __webpack_require__(17868),
                    InOut: __webpack_require__(16509)
                };
            /***/ },
            /***/ 80461: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-in.
 *
 * @function Phaser.Math.Easing.Sine.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                    if (v === 0) return 0;
                    else if (v === 1) return 1;
                    else return 1 - Math.cos(v * Math.PI / 2);
                };
                module1.exports = In;
            /***/ },
            /***/ 34025: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-in/out.
 *
 * @function Phaser.Math.Easing.Sine.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                    if (v === 0) return 0;
                    else if (v === 1) return 1;
                    else return 0.5 * (1 - Math.cos(Math.PI * v));
                };
                module1.exports = InOut;
            /***/ },
            /***/ 52768: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-out.
 *
 * @function Phaser.Math.Easing.Sine.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                    if (v === 0) return 0;
                    else if (v === 1) return 1;
                    else return Math.sin(v * Math.PI / 2);
                };
                module1.exports = Out;
            /***/ },
            /***/ 82500: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Sine
 */ module1.exports = {
                    In: __webpack_require__(80461),
                    Out: __webpack_require__(52768),
                    InOut: __webpack_require__(34025)
                };
            /***/ },
            /***/ 72251: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Stepped easing.
 *
 * @function Phaser.Math.Easing.Stepped
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [steps=1] - The number of steps in the ease.
 *
 * @return {number} The tweened value.
 */ var Stepped = function(v, steps) {
                    if (steps === undefined) steps = 1;
                    if (v <= 0) return 0;
                    else if (v >= 1) return 1;
                    else return ((steps * v | 0) + 1) * (1 / steps);
                };
                module1.exports = Stepped;
            /***/ },
            /***/ 49752: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Stepped
 */ module1.exports = __webpack_require__(72251);
            /***/ },
            /***/ 75698: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the fuzzy ceiling of the given value.
 *
 * @function Phaser.Math.Fuzzy.Ceil
 * @since 3.0.0
 *
 * @param {number} value - The value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {number} The fuzzy ceiling of the value.
 */ var Ceil = function(value, epsilon) {
                    if (epsilon === undefined) epsilon = 0.0001;
                    return Math.ceil(value - epsilon);
                };
                module1.exports = Ceil;
            /***/ },
            /***/ 43855: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether the given values are fuzzily equal.
 *
 * Two numbers are fuzzily equal if their difference is less than `epsilon`.
 *
 * @function Phaser.Math.Fuzzy.Equal
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if the values are fuzzily equal, otherwise `false`.
 */ var Equal = function(a, b, epsilon) {
                    if (epsilon === undefined) epsilon = 0.0001;
                    return Math.abs(a - b) < epsilon;
                };
                module1.exports = Equal;
            /***/ },
            /***/ 25777: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the fuzzy floor of the given value.
 *
 * @function Phaser.Math.Fuzzy.Floor
 * @since 3.0.0
 *
 * @param {number} value - The value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {number} The floor of the value.
 */ var Floor = function(value, epsilon) {
                    if (epsilon === undefined) epsilon = 0.0001;
                    return Math.floor(value + epsilon);
                };
                module1.exports = Floor;
            /***/ },
            /***/ 5470: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether `a` is fuzzily greater than `b`.
 *
 * `a` is fuzzily greater than `b` if it is more than `b - epsilon`.
 *
 * @function Phaser.Math.Fuzzy.GreaterThan
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if `a` is fuzzily greater than than `b`, otherwise `false`.
 */ var GreaterThan = function(a, b, epsilon) {
                    if (epsilon === undefined) epsilon = 0.0001;
                    return a > b - epsilon;
                };
                module1.exports = GreaterThan;
            /***/ },
            /***/ 94977: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether `a` is fuzzily less than `b`.
 *
 * `a` is fuzzily less than `b` if it is less than `b + epsilon`.
 *
 * @function Phaser.Math.Fuzzy.LessThan
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if `a` is fuzzily less than `b`, otherwise `false`.
 */ var LessThan = function(a, b, epsilon) {
                    if (epsilon === undefined) epsilon = 0.0001;
                    return a < b + epsilon;
                };
                module1.exports = LessThan;
            /***/ },
            /***/ 48379: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Fuzzy
 */ module1.exports = {
                    Ceil: __webpack_require__(75698),
                    Equal: __webpack_require__(43855),
                    Floor: __webpack_require__(25777),
                    GreaterThan: __webpack_require__(5470),
                    LessThan: __webpack_require__(94977)
                };
            /***/ },
            /***/ 75508: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(36383);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Math
 */ var PhaserMath = {
                    //  Collections of functions
                    Angle: __webpack_require__(25588),
                    Distance: __webpack_require__(50994),
                    Easing: __webpack_require__(48820),
                    Fuzzy: __webpack_require__(48379),
                    Interpolation: __webpack_require__(38289),
                    Pow2: __webpack_require__(49001),
                    Snap: __webpack_require__(73697),
                    //  Expose the RNG Class
                    RandomDataGenerator: __webpack_require__(28453),
                    //  Single functions
                    Average: __webpack_require__(53307),
                    Bernstein: __webpack_require__(85710),
                    Between: __webpack_require__(30976),
                    CatmullRom: __webpack_require__(87842),
                    CeilTo: __webpack_require__(26302),
                    Clamp: __webpack_require__(45319),
                    DegToRad: __webpack_require__(39506),
                    Difference: __webpack_require__(61241),
                    Euler: __webpack_require__(38857),
                    Factorial: __webpack_require__(6411),
                    FloatBetween: __webpack_require__(99472),
                    FloorTo: __webpack_require__(77623),
                    FromPercent: __webpack_require__(62945),
                    GetSpeed: __webpack_require__(38265),
                    IsEven: __webpack_require__(78702),
                    IsEvenStrict: __webpack_require__(94883),
                    Linear: __webpack_require__(28915),
                    LinearXY: __webpack_require__(94908),
                    MaxAdd: __webpack_require__(86883),
                    Median: __webpack_require__(50040),
                    MinSub: __webpack_require__(37204),
                    Percent: __webpack_require__(65201),
                    RadToDeg: __webpack_require__(43396),
                    RandomXY: __webpack_require__(74362),
                    RandomXYZ: __webpack_require__(60706),
                    RandomXYZW: __webpack_require__(67421),
                    Rotate: __webpack_require__(36305),
                    RotateAround: __webpack_require__(11520),
                    RotateAroundDistance: __webpack_require__(1163),
                    RotateTo: __webpack_require__(70336),
                    RoundAwayFromZero: __webpack_require__(2284),
                    RoundTo: __webpack_require__(41013),
                    SinCosTableGenerator: __webpack_require__(16922),
                    SmootherStep: __webpack_require__(54261),
                    SmoothStep: __webpack_require__(7602),
                    ToXY: __webpack_require__(44408),
                    TransformXY: __webpack_require__(85955),
                    Within: __webpack_require__(60417),
                    Wrap: __webpack_require__(15994),
                    //  Vector classes
                    Vector2: __webpack_require__(26099),
                    Vector3: __webpack_require__(25836),
                    Vector4: __webpack_require__(61369),
                    Matrix3: __webpack_require__(94434),
                    Matrix4: __webpack_require__(37867),
                    Quaternion: __webpack_require__(15746),
                    RotateVec3: __webpack_require__(72678)
                };
                //   Merge in the consts
                PhaserMath = Extend(false, PhaserMath, CONST);
                //  Export it
                module1.exports = PhaserMath;
            /***/ },
            /***/ 89318: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bernstein = __webpack_require__(85710);
                /**
 * A bezier interpolation method.
 *
 * @function Phaser.Math.Interpolation.Bezier
 * @since 3.0.0
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {number} The interpolated value.
 */ var BezierInterpolation = function(v, k) {
                    var b = 0;
                    var n = v.length - 1;
                    for(var i = 0; i <= n; i++)b += Math.pow(1 - k, n - i) * Math.pow(k, i) * v[i] * Bernstein(n, i);
                    return b;
                };
                module1.exports = BezierInterpolation;
            /***/ },
            /***/ 77259: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CatmullRom = __webpack_require__(87842);
                /**
 * A Catmull-Rom interpolation method.
 *
 * @function Phaser.Math.Interpolation.CatmullRom
 * @since 3.0.0
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {number} The interpolated value.
 */ var CatmullRomInterpolation = function(v, k) {
                    var m = v.length - 1;
                    var f = m * k;
                    var i = Math.floor(f);
                    if (v[0] === v[m]) {
                        if (k < 0) i = Math.floor(f = m * (1 + k));
                        return CatmullRom(f - i, v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m]);
                    } else {
                        if (k < 0) return v[0] - (CatmullRom(-f, v[0], v[0], v[1], v[1]) - v[0]);
                        if (k > 1) return v[m] - (CatmullRom(f - m, v[m], v[m], v[m - 1], v[m - 1]) - v[m]);
                        return CatmullRom(f - i, v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2]);
                    }
                };
                module1.exports = CatmullRomInterpolation;
            /***/ },
            /***/ 36316: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function P0(t, p) {
                    var k = 1 - t;
                    return k * k * k * p;
                }
                /**
 * @ignore
 */ function P1(t, p) {
                    var k = 1 - t;
                    return 3 * k * k * t * p;
                }
                /**
 * @ignore
 */ function P2(t, p) {
                    return 3 * (1 - t) * t * t * p;
                }
                /**
 * @ignore
 */ function P3(t, p) {
                    return t * t * t * p;
                }
                /**
 * A cubic bezier interpolation method.
 *
 * https://medium.com/@adrian_cooney/bezier-interpolation-13b68563313a
 *
 * @function Phaser.Math.Interpolation.CubicBezier
 * @since 3.0.0
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} p0 - The start point.
 * @param {number} p1 - The first control point.
 * @param {number} p2 - The second control point.
 * @param {number} p3 - The end point.
 *
 * @return {number} The interpolated value.
 */ var CubicBezierInterpolation = function(t, p0, p1, p2, p3) {
                    return P0(t, p0) + P1(t, p1) + P2(t, p2) + P3(t, p3);
                };
                module1.exports = CubicBezierInterpolation;
            /***/ },
            /***/ 28392: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Linear = __webpack_require__(28915);
                /**
 * A linear interpolation method.
 *
 * @function Phaser.Math.Interpolation.Linear
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Linear_interpolation}
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {!number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {!number} The interpolated value.
 */ var LinearInterpolation = function(v, k) {
                    var m = v.length - 1;
                    var f = m * k;
                    var i = Math.floor(f);
                    if (k < 0) return Linear(v[0], v[1], f);
                    else if (k > 1) return Linear(v[m], v[m - 1], m - f);
                    else return Linear(v[i], v[i + 1 > m ? m : i + 1], f - i);
                };
                module1.exports = LinearInterpolation;
            /***/ },
            /***/ 32112: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function P0(t, p) {
                    var k = 1 - t;
                    return k * k * p;
                }
                /**
 * @ignore
 */ function P1(t, p) {
                    return 2 * (1 - t) * t * p;
                }
                /**
 * @ignore
 */ function P2(t, p) {
                    return t * t * p;
                }
                // https://github.com/mrdoob/three.js/blob/master/src/extras/core/Interpolations.js
                /**
 * A quadratic bezier interpolation method.
 *
 * @function Phaser.Math.Interpolation.QuadraticBezier
 * @since 3.2.0
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} p0 - The start point.
 * @param {number} p1 - The control point.
 * @param {number} p2 - The end point.
 *
 * @return {number} The interpolated value.
 */ var QuadraticBezierInterpolation = function(t, p0, p1, p2) {
                    return P0(t, p0) + P1(t, p1) + P2(t, p2);
                };
                module1.exports = QuadraticBezierInterpolation;
            /***/ },
            /***/ 47235: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SmoothStep = __webpack_require__(7602);
                /**
 * A Smooth Step interpolation method.
 *
 * @function Phaser.Math.Interpolation.SmoothStep
 * @since 3.9.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep}
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The interpolated value.
 */ var SmoothStepInterpolation = function(t, min, max) {
                    return min + (max - min) * SmoothStep(t, 0, 1);
                };
                module1.exports = SmoothStepInterpolation;
            /***/ },
            /***/ 50178: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SmootherStep = __webpack_require__(54261);
                /**
 * A Smoother Step interpolation method.
 *
 * @function Phaser.Math.Interpolation.SmootherStep
 * @since 3.9.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The interpolated value.
 */ var SmootherStepInterpolation = function(t, min, max) {
                    return min + (max - min) * SmootherStep(t, 0, 1);
                };
                module1.exports = SmootherStepInterpolation;
            /***/ },
            /***/ 38289: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Interpolation
 */ module1.exports = {
                    Bezier: __webpack_require__(89318),
                    CatmullRom: __webpack_require__(77259),
                    CubicBezier: __webpack_require__(36316),
                    Linear: __webpack_require__(28392),
                    QuadraticBezier: __webpack_require__(32112),
                    SmoothStep: __webpack_require__(47235),
                    SmootherStep: __webpack_require__(50178)
                };
            /***/ },
            /***/ 98439: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the nearest power of 2 to the given `value`.
 *
 * @function Phaser.Math.Pow2.GetNext
 * @since 3.0.0
 *
 * @param {number} value - The value.
 *
 * @return {number} The nearest power of 2 to `value`.
 */ var GetPowerOfTwo = function(value) {
                    var index = Math.log(value) / 0.6931471805599453;
                    return 1 << Math.ceil(index);
                };
                module1.exports = GetPowerOfTwo;
            /***/ },
            /***/ 50030: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the given `width` and `height` are a power of two.
 * Useful for checking texture dimensions.
 *
 * @function Phaser.Math.Pow2.IsSize
 * @since 3.0.0
 *
 * @param {number} width - The width.
 * @param {number} height - The height.
 *
 * @return {boolean} `true` if `width` and `height` are a power of two, otherwise `false`.
 */ var IsSizePowerOfTwo = function(width, height) {
                    return width > 0 && (width & width - 1) === 0 && height > 0 && (height & height - 1) === 0;
                };
                module1.exports = IsSizePowerOfTwo;
            /***/ },
            /***/ 81230: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests the value and returns `true` if it is a power of two.
 *
 * @function Phaser.Math.Pow2.IsValue
 * @since 3.0.0
 *
 * @param {number} value - The value to check if it's a power of two.
 *
 * @return {boolean} Returns `true` if `value` is a power of two, otherwise `false`.
 */ var IsValuePowerOfTwo = function(value) {
                    return value > 0 && (value & value - 1) === 0;
                };
                module1.exports = IsValuePowerOfTwo;
            /***/ },
            /***/ 49001: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Pow2
 */ module1.exports = {
                    GetNext: __webpack_require__(98439),
                    IsSize: __webpack_require__(50030),
                    IsValue: __webpack_require__(81230)
                };
            /***/ },
            /***/ 28453: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A seeded Random Data Generator.
 *
 * Access via `Phaser.Math.RND` which is an instance of this class pre-defined
 * by Phaser. Or, create your own instance to use as you require.
 *
 * The `Math.RND` generator is seeded by the Game Config property value `seed`.
 * If no such config property exists, a random number is used.
 *
 * If you create your own instance of this class you should provide a seed for it.
 * If no seed is given it will use a 'random' one based on Date.now.
 *
 * @class RandomDataGenerator
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|string[])} [seeds] - The seeds to use for the random number generator.
 */ var RandomDataGenerator = new Class({
                    initialize: function RandomDataGenerator(seeds) {
                        if (seeds === undefined) seeds = [
                            (Date.now() * Math.random()).toString()
                        ];
                        /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#c
         * @type {number}
         * @default 1
         * @private
         * @since 3.0.0
         */ this.c = 1;
                        /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s0
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s0 = 0;
                        /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s1
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s1 = 0;
                        /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s2
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s2 = 0;
                        /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#n
         * @type {number}
         * @default 0
         * @private
         * @since 3.2.0
         */ this.n = 0;
                        /**
         * Signs to choose from.
         *
         * @name Phaser.Math.RandomDataGenerator#signs
         * @type {number[]}
         * @since 3.0.0
         */ this.signs = [
                            -1,
                            1
                        ];
                        if (seeds) this.init(seeds);
                    },
                    /**
     * Private random helper.
     *
     * @method Phaser.Math.RandomDataGenerator#rnd
     * @since 3.0.0
     * @private
     *
     * @return {number} A random number.
     */ rnd: function() {
                        var t = 2091639 * this.s0 + this.c * 2.3283064365386963e-10; // 2^-32
                        this.c = t | 0;
                        this.s0 = this.s1;
                        this.s1 = this.s2;
                        this.s2 = t - this.c;
                        return this.s2;
                    },
                    /**
     * Internal method that creates a seed hash.
     *
     * @method Phaser.Math.RandomDataGenerator#hash
     * @since 3.0.0
     * @private
     *
     * @param {string} data - The value to hash.
     *
     * @return {number} The hashed value.
     */ hash: function(data) {
                        var h;
                        var n = this.n;
                        data = data.toString();
                        for(var i = 0; i < data.length; i++){
                            n += data.charCodeAt(i);
                            h = 0.02519603282416938 * n;
                            n = h >>> 0;
                            h -= n;
                            h *= n;
                            n = h >>> 0;
                            h -= n;
                            n += h * 0x100000000; // 2^32
                        }
                        this.n = n;
                        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
                    },
                    /**
     * Initialize the state of the random data generator.
     *
     * @method Phaser.Math.RandomDataGenerator#init
     * @since 3.0.0
     *
     * @param {(string|string[])} seeds - The seeds to initialize the random data generator with.
     */ init: function(seeds) {
                        if (typeof seeds === 'string') this.state(seeds);
                        else this.sow(seeds);
                    },
                    /**
     * Reset the seed of the random data generator.
     *
     * _Note_: the seed array is only processed up to the first `undefined` (or `null`) value, should such be present.
     *
     * @method Phaser.Math.RandomDataGenerator#sow
     * @since 3.0.0
     *
     * @param {string[]} seeds - The array of seeds: the `toString()` of each value is used.
     */ sow: function(seeds) {
                        // Always reset to default seed
                        this.n = 0xefc8249d;
                        this.s0 = this.hash(' ');
                        this.s1 = this.hash(' ');
                        this.s2 = this.hash(' ');
                        this.c = 1;
                        if (!seeds) return;
                        // Apply any seeds
                        for(var i = 0; i < seeds.length && seeds[i] != null; i++){
                            var seed = seeds[i];
                            this.s0 -= this.hash(seed);
                            this.s0 += ~~(this.s0 < 0);
                            this.s1 -= this.hash(seed);
                            this.s1 += ~~(this.s1 < 0);
                            this.s2 -= this.hash(seed);
                            this.s2 += ~~(this.s2 < 0);
                        }
                    },
                    /**
     * Returns a random integer between 0 and 2^32.
     *
     * @method Phaser.Math.RandomDataGenerator#integer
     * @since 3.0.0
     *
     * @return {number} A random integer between 0 and 2^32.
     */ integer: function() {
                        // 2^32
                        return this.rnd() * 0x100000000;
                    },
                    /**
     * Returns a random real number between 0 and 1.
     *
     * @method Phaser.Math.RandomDataGenerator#frac
     * @since 3.0.0
     *
     * @return {number} A random real number between 0 and 1.
     */ frac: function() {
                        // 2^-53
                        return this.rnd() + (this.rnd() * 0x200000 | 0) * 1.1102230246251565e-16;
                    },
                    /**
     * Returns a random real number between 0 and 2^32.
     *
     * @method Phaser.Math.RandomDataGenerator#real
     * @since 3.0.0
     *
     * @return {number} A random real number between 0 and 2^32.
     */ real: function() {
                        return this.integer() + this.frac();
                    },
                    /**
     * Returns a random integer between and including min and max.
     *
     * @method Phaser.Math.RandomDataGenerator#integerInRange
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ integerInRange: function(min, max) {
                        return Math.floor(this.realInRange(0, max - min + 1) + min);
                    },
                    /**
     * Returns a random integer between and including min and max.
     * This method is an alias for RandomDataGenerator.integerInRange.
     *
     * @method Phaser.Math.RandomDataGenerator#between
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ between: function(min, max) {
                        return Math.floor(this.realInRange(0, max - min + 1) + min);
                    },
                    /**
     * Returns a random real number between min and max.
     *
     * @method Phaser.Math.RandomDataGenerator#realInRange
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ realInRange: function(min, max) {
                        return this.frac() * (max - min) + min;
                    },
                    /**
     * Returns a random real number between -1 and 1.
     *
     * @method Phaser.Math.RandomDataGenerator#normal
     * @since 3.0.0
     *
     * @return {number} A random real number between -1 and 1.
     */ normal: function() {
                        return 1 - 2 * this.frac();
                    },
                    /**
     * Returns a valid RFC4122 version4 ID hex string from https://gist.github.com/1308368
     *
     * @method Phaser.Math.RandomDataGenerator#uuid
     * @since 3.0.0
     *
     * @return {string} A valid RFC4122 version4 ID hex string
     */ uuid: function() {
                        var a = '';
                        var b = '';
                        for(b = a = ''; a++ < 36; b += ~a % 5 | a * 3 & 4 ? (a ^ 15 ? 8 ^ this.frac() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '-');
                        return b;
                    },
                    /**
     * Returns a random element from within the given array.
     *
     * @method Phaser.Math.RandomDataGenerator#pick
     * @since 3.0.0
     *
     * @generic T
     * @genericUse {T[]} - [array]
     * @genericUse {T} - [$return]
     *
     * @param {T[]} array - The array to pick a random element from.
     *
     * @return {T} A random member of the array.
     */ pick: function(array) {
                        return array[this.integerInRange(0, array.length - 1)];
                    },
                    /**
     * Returns a sign to be used with multiplication operator.
     *
     * @method Phaser.Math.RandomDataGenerator#sign
     * @since 3.0.0
     *
     * @return {number} -1 or +1.
     */ sign: function() {
                        return this.pick(this.signs);
                    },
                    /**
     * Returns a random element from within the given array, favoring the earlier entries.
     *
     * @method Phaser.Math.RandomDataGenerator#weightedPick
     * @since 3.0.0
     *
     * @generic T
     * @genericUse {T[]} - [array]
     * @genericUse {T} - [$return]
     *
     * @param {T[]} array - The array to pick a random element from.
     *
     * @return {T} A random member of the array.
     */ weightedPick: function(array) {
                        return array[~~(Math.pow(this.frac(), 2) * (array.length - 0.5) + 0.5)];
                    },
                    /**
     * Returns a random timestamp between min and max, or between the beginning of 2000 and the end of 2020 if min and max aren't specified.
     *
     * @method Phaser.Math.RandomDataGenerator#timestamp
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random timestamp between min and max.
     */ timestamp: function(min, max) {
                        return this.realInRange(min || 946684800000, max || 1577862000000);
                    },
                    /**
     * Returns a random angle between -180 and 180.
     *
     * @method Phaser.Math.RandomDataGenerator#angle
     * @since 3.0.0
     *
     * @return {number} A random number between -180 and 180.
     */ angle: function() {
                        return this.integerInRange(-180, 180);
                    },
                    /**
     * Returns a random rotation in radians, between -3.141 and 3.141
     *
     * @method Phaser.Math.RandomDataGenerator#rotation
     * @since 3.0.0
     *
     * @return {number} A random number between -3.141 and 3.141
     */ rotation: function() {
                        return this.realInRange(-3.1415926, 3.1415926);
                    },
                    /**
     * Gets or Sets the state of the generator. This allows you to retain the values
     * that the generator is using between games, i.e. in a game save file.
     *
     * To seed this generator with a previously saved state you can pass it as the
     * `seed` value in your game config, or call this method directly after Phaser has booted.
     *
     * Call this method with no parameters to return the current state.
     *
     * If providing a state it should match the same format that this method
     * returns, which is a string with a header `!rnd` followed by the `c`,
     * `s0`, `s1` and `s2` values respectively, each comma-delimited.
     *
     * @method Phaser.Math.RandomDataGenerator#state
     * @since 3.0.0
     *
     * @param {string} [state] - Generator state to be set.
     *
     * @return {string} The current state of the generator.
     */ state: function(state) {
                        if (typeof state === 'string' && state.match(/^!rnd/)) {
                            state = state.split(',');
                            this.c = parseFloat(state[1]);
                            this.s0 = parseFloat(state[2]);
                            this.s1 = parseFloat(state[3]);
                            this.s2 = parseFloat(state[4]);
                        }
                        return [
                            '!rnd',
                            this.c,
                            this.s0,
                            this.s1,
                            this.s2
                        ].join(',');
                    },
                    /**
     * Shuffles the given array, using the current seed.
     *
     * @method Phaser.Math.RandomDataGenerator#shuffle
     * @since 3.7.0
     *
     * @generic T
     * @genericUse {T[]} - [array,$return]
     *
     * @param {T[]} [array] - The array to be shuffled.
     *
     * @return {T[]} The shuffled array.
     */ shuffle: function(array) {
                        var len = array.length - 1;
                        for(var i = len; i > 0; i--){
                            var randomIndex = Math.floor(this.frac() * (i + 1));
                            var itemAtIndex = array[randomIndex];
                            array[randomIndex] = array[i];
                            array[i] = itemAtIndex;
                        }
                        return array;
                    }
                });
                module1.exports = RandomDataGenerator;
            /***/ },
            /***/ 63448: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using ceil.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `15`.
 * As will `14` snap to `15`... but `16` will snap to `20`.
 *
 * @function Phaser.Math.Snap.Ceil
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapCeil = function(value, gap, start, divide) {
                    if (start === undefined) start = 0;
                    if (gap === 0) return value;
                    value -= start;
                    value = gap * Math.ceil(value / gap);
                    return divide ? (start + value) / gap : start + value;
                };
                module1.exports = SnapCeil;
            /***/ },
            /***/ 56583: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using floor.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `10`.
 * As will `14` snap to `10`... but `16` will snap to `15`.
 *
 * @function Phaser.Math.Snap.Floor
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapFloor = function(value, gap, start, divide) {
                    if (start === undefined) start = 0;
                    if (gap === 0) return value;
                    value -= start;
                    value = gap * Math.floor(value / gap);
                    return divide ? (start + value) / gap : start + value;
                };
                module1.exports = SnapFloor;
            /***/ },
            /***/ 77720: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using rounding.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `10` whereas `14` will snap to `15`.
 *
 * @function Phaser.Math.Snap.To
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapTo = function(value, gap, start, divide) {
                    if (start === undefined) start = 0;
                    if (gap === 0) return value;
                    value -= start;
                    value = gap * Math.round(value / gap);
                    return divide ? (start + value) / gap : start + value;
                };
                module1.exports = SnapTo;
            /***/ },
            /***/ 73697: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Snap
 */ module1.exports = {
                    Ceil: __webpack_require__(63448),
                    Floor: __webpack_require__(56583),
                    To: __webpack_require__(77720)
                };
            /***/ },
            /***/ 85454: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ __webpack_require__(63595);
                var CONST = __webpack_require__(8054);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser
 */ var Phaser = {
                    Actions: __webpack_require__(61061),
                    Animations: __webpack_require__(60421),
                    BlendModes: __webpack_require__(10312),
                    Cache: __webpack_require__(83388),
                    Cameras: __webpack_require__(26638),
                    Core: __webpack_require__(42857),
                    Class: __webpack_require__(83419),
                    Create: __webpack_require__(15822),
                    Curves: __webpack_require__(25410),
                    Data: __webpack_require__(44965),
                    Display: __webpack_require__(27460),
                    DOM: __webpack_require__(84902),
                    Events: __webpack_require__(93055),
                    FX: __webpack_require__(66064),
                    Game: __webpack_require__(50127),
                    GameObjects: __webpack_require__(77856),
                    Geom: __webpack_require__(55738),
                    Input: __webpack_require__(14350),
                    Loader: __webpack_require__(57777),
                    Math: __webpack_require__(75508),
                    Physics: __webpack_require__(44563),
                    Plugins: __webpack_require__(18922),
                    Renderer: __webpack_require__(36909),
                    Scale: __webpack_require__(93364),
                    ScaleModes: __webpack_require__(29795),
                    Scene: __webpack_require__(97482),
                    Scenes: __webpack_require__(62194),
                    Structs: __webpack_require__(41392),
                    Textures: __webpack_require__(27458),
                    Tilemaps: __webpack_require__(62501),
                    Time: __webpack_require__(90291),
                    Tweens: __webpack_require__(43066),
                    Utils: __webpack_require__(91799)
                };
                Phaser.Sound = __webpack_require__(23717);
                //   Merge in the consts
                Phaser = Extend(false, Phaser, CONST);
                /**
 * The root types namespace.
 *
 * @namespace Phaser.Types
 * @since 3.17.0
 */ //  Export it
                module1.exports = Phaser;
                __webpack_require__.g.Phaser = Phaser;
            /*
 * "Documentation is like pizza: when it is good, it is very, very good;
 * and when it is bad, it is better than nothing."
 *  -- Dick Brandon
 */ /***/ },
            /***/ 71289: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(92209);
                var Image1 = __webpack_require__(88571);
                /**
 * @classdesc
 * An Arcade Physics Image is an Image with an Arcade Physics body and related components.
 * The body can be dynamic or static.
 *
 * The main difference between an Arcade Image and an Arcade Sprite is that you cannot animate an Arcade Image.
 *
 * @class Image
 * @extends Phaser.GameObjects.Image
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Acceleration
 * @extends Phaser.Physics.Arcade.Components.Angular
 * @extends Phaser.Physics.Arcade.Components.Bounce
 * @extends Phaser.Physics.Arcade.Components.Collision
 * @extends Phaser.Physics.Arcade.Components.Debug
 * @extends Phaser.Physics.Arcade.Components.Drag
 * @extends Phaser.Physics.Arcade.Components.Enable
 * @extends Phaser.Physics.Arcade.Components.Friction
 * @extends Phaser.Physics.Arcade.Components.Gravity
 * @extends Phaser.Physics.Arcade.Components.Immovable
 * @extends Phaser.Physics.Arcade.Components.Mass
 * @extends Phaser.Physics.Arcade.Components.Pushable
 * @extends Phaser.Physics.Arcade.Components.Size
 * @extends Phaser.Physics.Arcade.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var ArcadeImage = new Class({
                    Extends: Image1,
                    Mixins: [
                        Components.Acceleration,
                        Components.Angular,
                        Components.Bounce,
                        Components.Collision,
                        Components.Debug,
                        Components.Drag,
                        Components.Enable,
                        Components.Friction,
                        Components.Gravity,
                        Components.Immovable,
                        Components.Mass,
                        Components.Pushable,
                        Components.Size,
                        Components.Velocity
                    ],
                    initialize: function ArcadeImage(scene, x, y, texture, frame) {
                        Image1.call(this, scene, x, y, texture, frame);
                        /**
         * This Game Object's Physics Body.
         *
         * @name Phaser.Physics.Arcade.Image#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                    }
                });
                module1.exports = ArcadeImage;
            /***/ },
            /***/ 86689: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var DegToRad = __webpack_require__(39506);
                var DistanceBetween = __webpack_require__(20339);
                var DistanceSquared = __webpack_require__(89774);
                var Factory = __webpack_require__(66022);
                var GetFastValue = __webpack_require__(95540);
                var Merge = __webpack_require__(46975);
                var OverlapCirc = __webpack_require__(72441);
                var OverlapRect = __webpack_require__(47956);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                var Vector2 = __webpack_require__(26099);
                var World = __webpack_require__(82248);
                /**
 * @classdesc
 * The Arcade Physics Plugin belongs to a Scene and sets up and manages the Scene's physics simulation.
 * It also holds some useful methods for moving and rotating Arcade Physics Bodies.
 *
 * You can access it from within a Scene using `this.physics`.
 *
 * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
 * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
 * The separation that stops two objects penetrating may create a new penetration against a different object. If you
 * require a high level of stability please consider using an alternative physics system, such as Matter.js.
 *
 * @class ArcadePhysics
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Plugin belongs to.
 */ var ArcadePhysics = new Class({
                    initialize: function ArcadePhysics(scene) {
                        /**
         * The Scene that this Plugin belongs to.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * The Scene's Systems.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * A configuration object. Union of the `physics.arcade.*` properties of the GameConfig and SceneConfig objects.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#config
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldConfig}
         * @since 3.0.0
         */ this.config = this.getConfig();
                        /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world;
                        /**
         * An object holding the Arcade Physics factory methods.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#add
         * @type {Phaser.Physics.Arcade.Factory}
         * @since 3.0.0
         */ this.add;
                        /**
         * Holds the internal collision filter category.
         *
         * @name Phaser.Physics.Arcade.World#_category
         * @private
         * @type {number}
         * @since 3.70.0
         */ this._category = 0x0001;
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.world = new World(this.scene, this.config);
                        this.add = new Factory(this.world);
                        this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        if (!this.world) {
                            this.world = new World(this.scene, this.config);
                            this.add = new Factory(this.world);
                        }
                        var eventEmitter = this.systems.events;
                        if (!GetFastValue(this.config, 'customUpdate', false)) eventEmitter.on(SceneEvents.UPDATE, this.world.update, this.world);
                        eventEmitter.on(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                        eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Causes `World.update` to be automatically called each time the Scene
     * emits and `UPDATE` event. This is the default setting, so only needs
     * calling if you have specifically disabled it.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#enableUpdate
     * @since 3.50.0
     */ enableUpdate: function() {
                        this.systems.events.on(SceneEvents.UPDATE, this.world.update, this.world);
                    },
                    /**
     * Causes `World.update` to **not** be automatically called each time the Scene
     * emits and `UPDATE` event.
     *
     * If you wish to run the World update at your own rate, or from your own
     * component, then you should call this method to disable the built-in link,
     * and then call `World.update(delta, time)` accordingly.
     *
     * Note that `World.postUpdate` is always automatically called when the Scene
     * emits a `POST_UPDATE` event, regardless of this setting.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#disableUpdate
     * @since 3.50.0
     */ disableUpdate: function() {
                        this.systems.events.off(SceneEvents.UPDATE, this.world.update, this.world);
                    },
                    /**
     * Creates the physics configuration for the current Scene.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#getConfig
     * @since 3.0.0
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeWorldConfig} The physics configuration.
     */ getConfig: function() {
                        var gameConfig = this.systems.game.config.physics;
                        var sceneConfig = this.systems.settings.physics;
                        var config = Merge(GetFastValue(sceneConfig, 'arcade', {}), GetFastValue(gameConfig, 'arcade', {}));
                        return config;
                    },
                    /**
     * Returns the next available collision category.
     *
     * You can have a maximum of 32 categories.
     *
     * By default all bodies collide with all other bodies.
     *
     * Use the `Body.setCollisionCategory()` and
     * `Body.setCollidesWith()` methods to change this.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#nextCategory
     * @since 3.70.0
     *
     * @return {number} The next collision category.
     */ nextCategory: function() {
                        this._category = this._category << 1;
                        return this._category;
                    },
                    /**
     * Tests if Game Objects overlap. See {@link Phaser.Physics.Arcade.World#overlap}
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [overlapCallback] - An optional callback function that is called if the objects overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if at least one Game Object overlaps another.
     *
     * @see Phaser.Physics.Arcade.World#overlap
     */ overlap: function(object1, object2, overlapCallback, processCallback, callbackContext) {
                        if (overlapCallback === undefined) overlapCallback = null;
                        if (processCallback === undefined) processCallback = null;
                        if (callbackContext === undefined) callbackContext = overlapCallback;
                        return this.world.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
                    },
                    /**
     * Performs a collision check and separation between the two physics enabled objects given, which can be single
     * Game Objects, arrays of Game Objects, Physics Groups, arrays of Physics Groups or normal Groups.
     *
     * If you don't require separation then use {@link #overlap} instead.
     *
     * If two Groups or arrays are passed, each member of one will be tested against each member of the other.
     *
     * If **only** one Group is passed (as `object1`), each member of the Group will be collided against the other members.
     *
     * If **only** one Array is passed, the array is iterated and every element in it is tested against the others.
     *
     * Two callbacks can be provided. The `collideCallback` is invoked if a collision occurs and the two colliding
     * objects are passed to it.
     *
     * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
     * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
     * The separation that stops two objects penetrating may create a new penetration against a different object. If you
     * require a high level of stability please consider using an alternative physics system, such as Matter.js.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#collide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any overlapping Game Objects were separated, otherwise false.
     *
     * @see Phaser.Physics.Arcade.World#collide
     */ collide: function(object1, object2, collideCallback, processCallback, callbackContext) {
                        if (collideCallback === undefined) collideCallback = null;
                        if (processCallback === undefined) processCallback = null;
                        if (callbackContext === undefined) callbackContext = collideCallback;
                        return this.world.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
                    },
                    /**
     * This advanced method is specifically for testing for collision between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `collide` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for collision with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic collisions
     * on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * Important: Use of this method skips the `interesting faces` system that Tilemap Layers use. This means if you have
     * say a row or column of tiles, and you jump into, or walk over them, it's possible to get stuck on the edges of the
     * tiles as the interesting face calculations are skipped. However, for quick-fire small collision set tests on
     * dynamic maps, this method can prove very useful.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#collideTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                        return this.world.collideTiles(sprite, tiles, collideCallback, processCallback, callbackContext);
                    },
                    /**
     * This advanced method is specifically for testing for overlaps between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `overlap` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for overlaps with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic overlap
     * tests on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ overlapTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                        return this.world.overlapTiles(sprite, tiles, collideCallback, processCallback, callbackContext);
                    },
                    /**
     * Pauses the simulation.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#pause
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} The simulation.
     */ pause: function() {
                        return this.world.pause();
                    },
                    /**
     * Resumes the simulation (if paused).
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#resume
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} The simulation.
     */ resume: function() {
                        return this.world.resume();
                    },
                    /**
     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
     *
     * You must give a maximum speed value, beyond which the game object won't go any faster.
     *
     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateTo
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {number} x - The x coordinate to accelerate towards.
     * @param {number} y - The y coordinate to accelerate towards.
     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ accelerateTo: function(gameObject, x, y, speed, xSpeedMax, ySpeedMax) {
                        if (speed === undefined) speed = 60;
                        var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
                        gameObject.body.acceleration.setToPolar(angle, speed);
                        if (xSpeedMax !== undefined && ySpeedMax !== undefined) gameObject.body.maxVelocity.set(xSpeedMax, ySpeedMax);
                        return angle;
                    },
                    /**
     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
     *
     * You must give a maximum speed value, beyond which the game object won't go any faster.
     *
     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateToObject
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {Phaser.GameObjects.GameObject} destination - The Game Object to move towards. Can be any object but must have visible x/y properties.
     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ accelerateToObject: function(gameObject, destination, speed, xSpeedMax, ySpeedMax) {
                        return this.accelerateTo(gameObject, destination.x, destination.y, speed, xSpeedMax, ySpeedMax);
                    },
                    /**
     * Finds the Body or Game Object closest to a source point or object.
     *
     * If a `targets` argument is passed, this method finds the closest of those.
     * The targets can be Arcade Physics Game Objects, Dynamic Bodies, or Static Bodies.
     *
     * If no `targets` argument is passed, this method finds the closest Dynamic Body.
     *
     * If two or more targets are the exact same distance from the source point, only the first target
     * is returned.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#closest
     * @since 3.0.0
     *
     * @generic {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|Phaser.GameObjects.GameObject} Target
     * @param {Phaser.Types.Math.Vector2Like} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {Target[]} [targets] - The targets.
     *
     * @return {Target|null} The target closest to the given source point.
     */ closest: function(source, targets) {
                        if (!targets) targets = this.world.bodies.entries;
                        var min = Number.MAX_VALUE;
                        var closest = null;
                        var x = source.x;
                        var y = source.y;
                        var len = targets.length;
                        for(var i = 0; i < len; i++){
                            var target = targets[i];
                            var body = target.body || target;
                            if (source === target || source === body || source === body.gameObject || source === body.center) continue;
                            var distance = DistanceSquared(x, y, body.center.x, body.center.y);
                            if (distance < min) {
                                closest = target;
                                min = distance;
                            }
                        }
                        return closest;
                    },
                    /**
     * Finds the Body or Game Object farthest from a source point or object.
     *
     * If a `targets` argument is passed, this method finds the farthest of those.
     * The targets can be Arcade Physics Game Objects, Dynamic Bodies, or Static Bodies.
     *
     * If no `targets` argument is passed, this method finds the farthest Dynamic Body.
     *
     * If two or more targets are the exact same distance from the source point, only the first target
     * is returned.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#furthest
     * @since 3.0.0
     *
     * @param {any} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[]|Phaser.GameObjects.GameObject[])} [targets] - The targets.
     *
     * @return {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|Phaser.GameObjects.GameObject)} The target farthest from the given source point.
     */ furthest: function(source, targets) {
                        if (!targets) targets = this.world.bodies.entries;
                        var max = -1;
                        var farthest = null;
                        var x = source.x;
                        var y = source.y;
                        var len = targets.length;
                        for(var i = 0; i < len; i++){
                            var target = targets[i];
                            var body = target.body || target;
                            if (source === target || source === body || source === body.gameObject || source === body.center) continue;
                            var distance = DistanceSquared(x, y, body.center.x, body.center.y);
                            if (distance > max) {
                                farthest = target;
                                max = distance;
                            }
                        }
                        return farthest;
                    },
                    /**
     * Move the given display object towards the x/y coordinates at a steady velocity.
     * If you specify a maxTime then it will adjust the speed (over-writing what you set) so it arrives at the destination in that number of seconds.
     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#moveTo
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {number} x - The x coordinate to move towards.
     * @param {number} y - The y coordinate to move towards.
     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ moveTo: function(gameObject, x, y, speed, maxTime) {
                        if (speed === undefined) speed = 60;
                        if (maxTime === undefined) maxTime = 0;
                        var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
                        if (maxTime > 0) //  We know how many pixels we need to move, but how fast?
                        speed = DistanceBetween(gameObject.x, gameObject.y, x, y) / (maxTime / 1000);
                        gameObject.body.velocity.setToPolar(angle, speed);
                        return angle;
                    },
                    /**
     * Move the given display object towards the destination object at a steady velocity.
     * If you specify a maxTime then it will adjust the speed (overwriting what you set) so it arrives at the destination in that number of seconds.
     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#moveToObject
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {object} destination - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ moveToObject: function(gameObject, destination, speed, maxTime) {
                        return this.moveTo(gameObject, destination.x, destination.y, speed, maxTime);
                    },
                    /**
     * Given the angle (in degrees) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
     * One way to use this is: velocityFromAngle(angle, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromAngle
     * @since 3.0.0
     *
     * @param {number} angle - The angle in degrees calculated in clockwise positive direction (down = 90 degrees positive, right = 0 degrees positive, up = 90 degrees negative)
     * @param {number} [speed=60] - The speed it will move, in pixels per second squared.
     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
     *
     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
     */ velocityFromAngle: function(angle, speed, vec2) {
                        if (speed === undefined) speed = 60;
                        if (vec2 === undefined) vec2 = new Vector2();
                        return vec2.setToPolar(DegToRad(angle), speed);
                    },
                    /**
     * Given the rotation (in radians) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
     * One way to use this is: velocityFromRotation(rotation, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromRotation
     * @since 3.0.0
     *
     * @param {number} rotation - The angle in radians.
     * @param {number} [speed=60] - The speed it will move, in pixels per second squared
     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
     *
     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
     */ velocityFromRotation: function(rotation, speed, vec2) {
                        if (speed === undefined) speed = 60;
                        if (vec2 === undefined) vec2 = new Vector2();
                        return vec2.setToPolar(rotation, speed);
                    },
                    /**
     * This method will search the given rectangular area and return an array of all physics bodies that
     * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
     *
     * A body only has to intersect with the search area to be considered, it doesn't have to be fully
     * contained within it.
     *
     * If Arcade Physics is set to use the RTree (which it is by default) then the search for is extremely fast,
     * otherwise the search is O(N) for Dynamic Bodies.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapRect
     * @since 3.17.0
     *
     * @param {number} x - The top-left x coordinate of the area to search within.
     * @param {number} y - The top-left y coordinate of the area to search within.
     * @param {number} width - The width of the area to search within.
     * @param {number} height - The height of the area to search within.
     * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
     * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
     *
     * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
     */ overlapRect: function(x, y, width, height, includeDynamic, includeStatic) {
                        return OverlapRect(this.world, x, y, width, height, includeDynamic, includeStatic);
                    },
                    /**
     * This method will search the given circular area and return an array of all physics bodies that
     * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
     *
     * A body only has to intersect with the search area to be considered, it doesn't have to be fully
     * contained within it.
     *
     * If Arcade Physics is set to use the RTree (which it is by default) then the search is rather fast,
     * otherwise the search is O(N) for Dynamic Bodies.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapCirc
     * @since 3.21.0
     *
     * @param {number} x - The x coordinate of the center of the area to search within.
     * @param {number} y - The y coordinate of the center of the area to search within.
     * @param {number} radius - The radius of the area to search within.
     * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
     * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
     *
     * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
     */ overlapCirc: function(x, y, radius, includeDynamic, includeStatic) {
                        return OverlapCirc(this.world, x, y, radius, includeDynamic, includeStatic);
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        if (!this.world) //  Already destroyed
                        return;
                        var eventEmitter = this.systems.events;
                        eventEmitter.off(SceneEvents.UPDATE, this.world.update, this.world);
                        eventEmitter.off(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                        eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                        this.add.destroy();
                        this.world.destroy();
                        this.add = null;
                        this.world = null;
                        this._category = 1;
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.scene.sys.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                    }
                });
                PluginCache.register('ArcadePhysics', ArcadePhysics, 'arcadePhysics');
                module1.exports = ArcadePhysics;
            /***/ },
            /***/ 13759: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(92209);
                var Sprite = __webpack_require__(68287);
                /**
 * @classdesc
 * An Arcade Physics Sprite is a Sprite with an Arcade Physics body and related components.
 * The body can be dynamic or static.
 *
 * The main difference between an Arcade Sprite and an Arcade Image is that you cannot animate an Arcade Image.
 * If you do not require animation then you can safely use Arcade Images instead of Arcade Sprites.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Acceleration
 * @extends Phaser.Physics.Arcade.Components.Angular
 * @extends Phaser.Physics.Arcade.Components.Bounce
 * @extends Phaser.Physics.Arcade.Components.Collision
 * @extends Phaser.Physics.Arcade.Components.Debug
 * @extends Phaser.Physics.Arcade.Components.Drag
 * @extends Phaser.Physics.Arcade.Components.Enable
 * @extends Phaser.Physics.Arcade.Components.Friction
 * @extends Phaser.Physics.Arcade.Components.Gravity
 * @extends Phaser.Physics.Arcade.Components.Immovable
 * @extends Phaser.Physics.Arcade.Components.Mass
 * @extends Phaser.Physics.Arcade.Components.Pushable
 * @extends Phaser.Physics.Arcade.Components.Size
 * @extends Phaser.Physics.Arcade.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var ArcadeSprite = new Class({
                    Extends: Sprite,
                    Mixins: [
                        Components.Acceleration,
                        Components.Angular,
                        Components.Bounce,
                        Components.Collision,
                        Components.Debug,
                        Components.Drag,
                        Components.Enable,
                        Components.Friction,
                        Components.Gravity,
                        Components.Immovable,
                        Components.Mass,
                        Components.Pushable,
                        Components.Size,
                        Components.Velocity
                    ],
                    initialize: function ArcadeSprite(scene, x, y, texture, frame) {
                        Sprite.call(this, scene, x, y, texture, frame);
                        /**
         * This Game Object's Physics Body.
         *
         * @name Phaser.Physics.Arcade.Sprite#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                    }
                });
                module1.exports = ArcadeSprite;
            /***/ },
            /***/ 37742: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CollisionComponent = __webpack_require__(78389);
                var CONST = __webpack_require__(37747);
                var Events = __webpack_require__(63012);
                var RadToDeg = __webpack_require__(43396);
                var Rectangle = __webpack_require__(87841);
                var RectangleContains = __webpack_require__(37303);
                var SetCollisionObject = __webpack_require__(95829);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Dynamic Arcade Body.
 *
 * Its static counterpart is {@link Phaser.Physics.Arcade.StaticBody}.
 *
 * @class Body
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Collision
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics simulation this Body belongs to.
 * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object this Body belongs to. As of Phaser 3.60 this is now optional.
 */ var Body = new Class({
                    Mixins: [
                        CollisionComponent
                    ],
                    initialize: function Body(world, gameObject) {
                        var width = 64;
                        var height = 64;
                        var dummyGameObject = {
                            x: 0,
                            y: 0,
                            angle: 0,
                            rotation: 0,
                            scaleX: 1,
                            scaleY: 1,
                            displayOriginX: 0,
                            displayOriginY: 0
                        };
                        var hasGameObject = gameObject !== undefined;
                        if (hasGameObject && gameObject.displayWidth) {
                            width = gameObject.displayWidth;
                            height = gameObject.displayHeight;
                        }
                        if (!hasGameObject) gameObject = dummyGameObject;
                        /**
         * The Arcade Physics simulation this Body belongs to.
         *
         * @name Phaser.Physics.Arcade.Body#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * The Game Object this Body belongs to.
         *
         * As of Phaser 3.60 this is now optional and can be undefined.
         *
         * @name Phaser.Physics.Arcade.Body#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.gameObject = hasGameObject ? gameObject : undefined;
                        /**
         * A quick-test flag that signifies this is a Body, used in the World collision handler.
         *
         * @name Phaser.Physics.Arcade.Body#isBody
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isBody = true;
                        /**
         * Transformations applied to this Body.
         *
         * @name Phaser.Physics.Arcade.Body#transform
         * @type {object}
         * @since 3.4.0
         */ this.transform = {
                            x: gameObject.x,
                            y: gameObject.y,
                            rotation: gameObject.angle,
                            scaleX: gameObject.scaleX,
                            scaleY: gameObject.scaleY,
                            displayOriginX: gameObject.displayOriginX,
                            displayOriginY: gameObject.displayOriginY
                        };
                        /**
         * Whether the Body is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugShowBody
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowBody = world.defaults.debugShowBody;
                        /**
         * Whether the Body's velocity is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugShowVelocity
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowVelocity = world.defaults.debugShowVelocity;
                        /**
         * The color of this Body on the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugBodyColor
         * @type {number}
         * @since 3.0.0
         */ this.debugBodyColor = world.defaults.bodyDebugColor;
                        /**
         * Whether this Body is updated by the physics simulation.
         *
         * @name Phaser.Physics.Arcade.Body#enable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enable = true;
                        /**
         * Whether this Body is circular (true) or rectangular (false).
         *
         * @name Phaser.Physics.Arcade.Body#isCircle
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setCircle
         */ this.isCircle = false;
                        /**
         * If this Body is circular, this is the unscaled radius of the Body, as set by setCircle(), in source pixels.
         * The true radius is equal to `halfWidth`.
         *
         * @name Phaser.Physics.Arcade.Body#radius
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setCircle
         */ this.radius = 0;
                        /**
         * The offset of this Body's position from its Game Object's position, in source pixels.
         *
         * @name Phaser.Physics.Arcade.Body#offset
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setOffset
         */ this.offset = new Vector2();
                        /**
         * The position of this Body within the simulation.
         *
         * @name Phaser.Physics.Arcade.Body#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2(gameObject.x - gameObject.scaleX * gameObject.displayOriginX, gameObject.y - gameObject.scaleY * gameObject.displayOriginY);
                        /**
         * The position of this Body during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#prev
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.prev = this.position.clone();
                        /**
         * The position of this Body during the previous frame.
         *
         * @name Phaser.Physics.Arcade.Body#prevFrame
         * @type {Phaser.Math.Vector2}
         * @since 3.20.0
         */ this.prevFrame = this.position.clone();
                        /**
         * Whether this Body's `rotation` is affected by its angular acceleration and angular velocity.
         *
         * @name Phaser.Physics.Arcade.Body#allowRotation
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.allowRotation = true;
                        /**
         * This body's rotation, in degrees, based on its angular acceleration and angular velocity.
         * The Body's rotation controls the `angle` of its Game Object.
         * It doesn't rotate the Body's own geometry, which is always an axis-aligned rectangle or a circle.
         *
         * @name Phaser.Physics.Arcade.Body#rotation
         * @type {number}
         * @since 3.0.0
         */ this.rotation = gameObject.angle;
                        /**
         * The Body rotation, in degrees, during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#preRotation
         * @type {number}
         * @since 3.0.0
         */ this.preRotation = gameObject.angle;
                        /**
         * The width of the Body, in pixels.
         * If the Body is circular, this is also the diameter.
         * If you wish to change the width use the `Body.setSize` method.
         *
         * @name Phaser.Physics.Arcade.Body#width
         * @type {number}
         * @readonly
         * @default 64
         * @since 3.0.0
         */ this.width = width;
                        /**
         * The height of the Body, in pixels.
         * If the Body is circular, this is also the diameter.
         * If you wish to change the height use the `Body.setSize` method.
         *
         * @name Phaser.Physics.Arcade.Body#height
         * @type {number}
         * @readonly
         * @default 64
         * @since 3.0.0
         */ this.height = height;
                        /**
         * The unscaled width of the Body, in source pixels, as set by setSize().
         * The default is the width of the Body's Game Object's texture frame.
         *
         * @name Phaser.Physics.Arcade.Body#sourceWidth
         * @type {number}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setSize
         */ this.sourceWidth = width;
                        /**
         * The unscaled height of the Body, in source pixels, as set by setSize().
         * The default is the height of the Body's Game Object's texture frame.
         *
         * @name Phaser.Physics.Arcade.Body#sourceHeight
         * @type {number}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setSize
         */ this.sourceHeight = height;
                        if (gameObject.frame) {
                            this.sourceWidth = gameObject.frame.realWidth;
                            this.sourceHeight = gameObject.frame.realHeight;
                        }
                        /**
         * Half the Body's width, in pixels.
         *
         * @name Phaser.Physics.Arcade.Body#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth = Math.abs(width / 2);
                        /**
         * Half the Body's height, in pixels.
         *
         * @name Phaser.Physics.Arcade.Body#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight = Math.abs(height / 2);
                        /**
         * The center of the Body.
         * The midpoint of its `position` (top-left corner) and its bottom-right corner.
         *
         * @name Phaser.Physics.Arcade.Body#center
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.center = new Vector2(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                        /**
         * The Body's velocity, in pixels per second.
         *
         * @name Phaser.Physics.Arcade.Body#velocity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.velocity = new Vector2();
                        /**
         * The Body's change in position (due to velocity) at the last step, in pixels.
         *
         * The size of this value depends on the simulation's step rate.
         *
         * @name Phaser.Physics.Arcade.Body#newVelocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.newVelocity = new Vector2();
                        /**
         * The Body's absolute maximum change in position, in pixels per step.
         *
         * @name Phaser.Physics.Arcade.Body#deltaMax
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.deltaMax = new Vector2();
                        /**
         * The Body's change in velocity, in pixels per second squared.
         *
         * @name Phaser.Physics.Arcade.Body#acceleration
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.acceleration = new Vector2();
                        /**
         * Whether this Body's velocity is affected by its `drag`.
         *
         * @name Phaser.Physics.Arcade.Body#allowDrag
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.allowDrag = true;
                        /**
         * When `useDamping` is false (the default), this is absolute loss of velocity due to movement, in pixels per second squared.
         *
         * When `useDamping` is true, this is a damping multiplier between 0 and 1.
         * A value of 0 means the Body stops instantly.
         * A value of 0.01 mean the Body keeps 1% of its velocity per second, losing 99%.
         * A value of 0.1 means the Body keeps 10% of its velocity per second, losing 90%.
         * A value of 1 means the Body loses no velocity.
         * You can use very small values (e.g., 0.001) to stop the Body quickly.
         *
         * The x and y components are applied separately.
         *
         * Drag is applied only when `acceleration` is zero.
         *
         * @name Phaser.Physics.Arcade.Body#drag
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.drag = new Vector2();
                        /**
         * Whether this Body's position is affected by gravity (local or world).
         *
         * @name Phaser.Physics.Arcade.Body#allowGravity
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#gravity
         * @see Phaser.Physics.Arcade.World#gravity
         */ this.allowGravity = true;
                        /**
         * Acceleration due to gravity (specific to this Body), in pixels per second squared.
         * Total gravity is the sum of this vector and the simulation's `gravity`.
         *
         * @name Phaser.Physics.Arcade.Body#gravity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#gravity
         */ this.gravity = new Vector2();
                        /**
         * Rebound following a collision, relative to 1.
         *
         * @name Phaser.Physics.Arcade.Body#bounce
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.bounce = new Vector2();
                        /**
         * Rebound following a collision with the world boundary, relative to 1.
         * If null, `bounce` is used instead.
         *
         * @name Phaser.Physics.Arcade.Body#worldBounce
         * @type {?Phaser.Math.Vector2}
         * @default null
         * @since 3.0.0
         */ this.worldBounce = null;
                        /**
         * The rectangle used for world boundary collisions.
         *
         * By default it is set to the world boundary rectangle. Or, if this Body was
         * created by a Physics Group, then whatever rectangle that Group defined.
         *
         * You can also change it by using the `Body.setBoundsRectangle` method.
         *
         * @name Phaser.Physics.Arcade.Body#customBoundsRectangle
         * @type {Phaser.Geom.Rectangle}
         * @since 3.20
         */ this.customBoundsRectangle = world.bounds;
                        /**
         * Whether the simulation emits a `worldbounds` event when this Body collides with the world boundary
         * (and `collideWorldBounds` is also true).
         *
         * @name Phaser.Physics.Arcade.Body#onWorldBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#WORLD_BOUNDS
         */ this.onWorldBounds = false;
                        /**
         * Whether the simulation emits a `collide` event when this Body collides with another.
         *
         * @name Phaser.Physics.Arcade.Body#onCollide
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#COLLIDE
         */ this.onCollide = false;
                        /**
         * Whether the simulation emits an `overlap` event when this Body overlaps with another.
         *
         * @name Phaser.Physics.Arcade.Body#onOverlap
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#OVERLAP
         */ this.onOverlap = false;
                        /**
         * The absolute maximum velocity of this body, in pixels per second.
         * The horizontal and vertical components are applied separately.
         *
         * @name Phaser.Physics.Arcade.Body#maxVelocity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.maxVelocity = new Vector2(10000, 10000);
                        /**
         * The maximum speed this Body is allowed to reach, in pixels per second.
         *
         * If not negative it limits the scalar value of speed.
         *
         * Any negative value means no maximum is being applied (the default).
         *
         * @name Phaser.Physics.Arcade.Body#maxSpeed
         * @type {number}
         * @default -1
         * @since 3.16.0
         */ this.maxSpeed = -1;
                        /**
         * If this Body is `immovable` and in motion, `friction` is the proportion of this Body's motion received by the riding Body on each axis, relative to 1.
         * The horizontal component (x) is applied only when two colliding Bodies are separated vertically.
         * The vertical component (y) is applied only when two colliding Bodies are separated horizontally.
         * The default value (1, 0) moves the riding Body horizontally in equal proportion to this Body and vertically not at all.
         *
         * @name Phaser.Physics.Arcade.Body#friction
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.friction = new Vector2(1, 0);
                        /**
         * If this Body is using `drag` for deceleration this property controls how the drag is applied.
         * If set to `true` drag will use a damping effect rather than a linear approach. If you are
         * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
         * the game Asteroids) then you will get a far smoother and more visually correct deceleration
         * by using damping, avoiding the axis-drift that is prone with linear deceleration.
         *
         * If you enable this property then you should use far smaller `drag` values than with linear, as
         * they are used as a multiplier on the velocity. Values such as 0.05 will give a nice slow
         * deceleration.
         *
         * @name Phaser.Physics.Arcade.Body#useDamping
         * @type {boolean}
         * @default false
         * @since 3.10.0
         */ this.useDamping = false;
                        /**
         * The rate of change of this Body's `rotation`, in degrees per second.
         *
         * @name Phaser.Physics.Arcade.Body#angularVelocity
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularVelocity = 0;
                        /**
         * The Body's angular acceleration (change in angular velocity), in degrees per second squared.
         *
         * @name Phaser.Physics.Arcade.Body#angularAcceleration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularAcceleration = 0;
                        /**
         * Loss of angular velocity due to angular movement, in degrees per second.
         *
         * Angular drag is applied only when angular acceleration is zero.
         *
         * @name Phaser.Physics.Arcade.Body#angularDrag
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularDrag = 0;
                        /**
         * The Body's maximum angular velocity, in degrees per second.
         *
         * @name Phaser.Physics.Arcade.Body#maxAngular
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.maxAngular = 1000;
                        /**
         * The Body's inertia, relative to a default unit (1).
         * With `bounce`, this affects the exchange of momentum (velocities) during collisions.
         *
         * @name Phaser.Physics.Arcade.Body#mass
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.mass = 1;
                        /**
         * The calculated angle of this Body's velocity vector, in radians, during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#angle
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angle = 0;
                        /**
         * The calculated magnitude of the Body's velocity, in pixels per second, during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#speed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speed = 0;
                        /**
         * The direction of the Body's velocity, as calculated during the last step.
         * This is a numeric constant value (FACING_UP, FACING_DOWN, FACING_LEFT, FACING_RIGHT).
         * If the Body is moving on both axes, this describes motion on the vertical axis only.
         *
         * @name Phaser.Physics.Arcade.Body#facing
         * @type {number}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.FACING_UP
         * @see Phaser.Physics.Arcade.FACING_DOWN
         * @see Phaser.Physics.Arcade.FACING_LEFT
         * @see Phaser.Physics.Arcade.FACING_RIGHT
         */ this.facing = CONST.FACING_NONE;
                        /**
         * Whether this Body can be moved by collisions with another Body.
         *
         * @name Phaser.Physics.Arcade.Body#immovable
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.immovable = false;
                        /**
         * Sets if this Body can be pushed by another Body.
         *
         * A body that cannot be pushed will reflect back all of the velocity it is given to the
         * colliding body. If that body is also not pushable, then the separation will be split
         * between them evenly.
         *
         * If you want your body to never move or seperate at all, see the `setImmovable` method.
         *
         * By default, Dynamic Bodies are always pushable.
         *
         * @name Phaser.Physics.Arcade.Body#pushable
         * @type {boolean}
         * @default true
         * @since 3.50.0
         * @see Phaser.GameObjects.Components.Pushable#setPushable
         */ this.pushable = true;
                        /**
         * The Slide Factor of this Body.
         *
         * The Slide Factor controls how much velocity is preserved when
         * this Body is pushed by another Body.
         *
         * The default value is 1, which means that it will take on all
         * velocity given in the push. You can adjust this value to control
         * how much velocity is retained by this Body when the push ends.
         *
         * A value of 0, for example, will allow this Body to be pushed
         * but then remain completely still after the push ends, such as
         * you see in a game like Sokoban.
         *
         * Or you can set a mid-point, such as 0.25 which will allow it
         * to keep 25% of the original velocity when the push ends. You
         * can combine this with the `setDrag()` method to create deceleration.
         *
         * @name Phaser.Physics.Arcade.Body#slideFactor
         * @type {Phaser.Math.Vector2}
         * @since 3.70.0
         * @see Phaser.GameObjects.Components.Pushable#setSlideFactor
         */ this.slideFactor = new Vector2(1, 1);
                        /**
         * Whether the Body's position and rotation are affected by its velocity, acceleration, drag, and gravity.
         *
         * @name Phaser.Physics.Arcade.Body#moves
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.moves = true;
                        /**
         * A flag disabling the default horizontal separation of colliding bodies.
         * Pass your own `collideCallback` to the collider.
         *
         * @name Phaser.Physics.Arcade.Body#customSeparateX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateX = false;
                        /**
         * A flag disabling the default vertical separation of colliding bodies.
         * Pass your own `collideCallback` to the collider.
         *
         * @name Phaser.Physics.Arcade.Body#customSeparateY
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateY = false;
                        /**
         * The amount of horizontal overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.Body#overlapX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapX = 0;
                        /**
         * The amount of vertical overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.Body#overlapY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapY = 0;
                        /**
         * The amount of overlap (before separation), if this Body is circular and colliding with another circular body.
         *
         * @name Phaser.Physics.Arcade.Body#overlapR
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapR = 0;
                        /**
         * Whether this Body is overlapped with another and both are not moving, on at least one axis.
         *
         * @name Phaser.Physics.Arcade.Body#embedded
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.embedded = false;
                        /**
         * Whether this Body interacts with the world boundary.
         *
         * @name Phaser.Physics.Arcade.Body#collideWorldBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.collideWorldBounds = false;
                        /**
         * Whether this Body is checked for collisions and for which directions.
         * You can set `checkCollision.none = true` to disable collision checks.
         *
         * @name Phaser.Physics.Arcade.Body#checkCollision
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.checkCollision = SetCollisionObject(false);
                        /**
         * Whether this Body is colliding with a Body or Static Body and in which direction.
         * In a collision where both bodies have zero velocity, `embedded` will be set instead.
         *
         * @name Phaser.Physics.Arcade.Body#touching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#blocked
         * @see Phaser.Physics.Arcade.Body#embedded
         */ this.touching = SetCollisionObject(true);
                        /**
         * This Body's `touching` value during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#wasTouching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#touching
         */ this.wasTouching = SetCollisionObject(true);
                        /**
         * Whether this Body is colliding with a Static Body, a tile, or the world boundary.
         * In a collision with a Static Body, if this Body has zero velocity then `embedded` will be set instead.
         *
         * @name Phaser.Physics.Arcade.Body#blocked
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#embedded
         * @see Phaser.Physics.Arcade.Body#touching
         */ this.blocked = SetCollisionObject(true);
                        /**
         * Whether to automatically synchronize this Body's dimensions to the dimensions of its Game Object's visual bounds.
         *
         * @name Phaser.Physics.Arcade.Body#syncBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Components.GetBounds#getBounds
         */ this.syncBounds = false;
                        /**
         * The Body's physics type (dynamic or static).
         *
         * @name Phaser.Physics.Arcade.Body#physicsType
         * @type {number}
         * @readonly
         * @default Phaser.Physics.Arcade.DYNAMIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.DYNAMIC_BODY;
                        /**
         * The Arcade Physics Body Collision Category.
         *
         * This can be set to any valid collision bitfield value.
         *
         * See the `setCollisionCategory` method for more details.
         *
         * @name Phaser.Physics.Arcade.Body#collisionCategory
         * @type {number}
         * @since 3.70.0
         */ this.collisionCategory = 0x0001;
                        /**
         * The Arcade Physics Body Collision Mask.
         *
         * See the `setCollidesWith` method for more details.
         *
         * @name Phaser.Physics.Arcade.Body#collisionMask
         * @type {number}
         * @since 3.70.0
         */ this.collisionMask = 1;
                        /**
         * Cached horizontal scale of the Body's Game Object.
         *
         * @name Phaser.Physics.Arcade.Body#_sx
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._sx = gameObject.scaleX;
                        /**
         * Cached vertical scale of the Body's Game Object.
         *
         * @name Phaser.Physics.Arcade.Body#_sy
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._sy = gameObject.scaleY;
                        /**
         * The calculated change in the Body's horizontal position during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#_dx
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._dx = 0;
                        /**
         * The calculated change in the Body's vertical position during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#_dy
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._dy = 0;
                        /**
         * The final calculated change in the Body's horizontal position as of `postUpdate`.
         *
         * @name Phaser.Physics.Arcade.Body#_tx
         * @type {number}
         * @private
         * @default 0
         * @since 3.22.0
         */ this._tx = 0;
                        /**
         * The final calculated change in the Body's vertical position as of `postUpdate`.
         *
         * @name Phaser.Physics.Arcade.Body#_ty
         * @type {number}
         * @private
         * @default 0
         * @since 3.22.0
         */ this._ty = 0;
                        /**
         * Stores the Game Object's bounds.
         *
         * @name Phaser.Physics.Arcade.Body#_bounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.0.0
         */ this._bounds = new Rectangle();
                        /**
         * Is this Body under direct control, outside of the physics engine? For example,
         * are you trying to move it via a Tween? Or have it follow a path? If so then
         * you can enable this boolean so that the Body will calculate its velocity based
         * purely on its change in position each frame. This allows you to then tween
         * the position and still have it collide with other objects. However, setting
         * the velocity will have no impact on this Body while this is set.
         *
         * @name Phaser.Physics.Arcade.Body#directControl
         * @type {boolean}
         * @since 3.70.0
         */ this.directControl = false;
                        /**
         * Stores the previous position of the Game Object when directControl is enabled.
         *
         * @name Phaser.Physics.Arcade.Body#autoFrame
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.70.0
         */ this.autoFrame = this.position.clone();
                    },
                    /**
     * Updates the Body's `transform`, `width`, `height`, and `center` from its Game Object.
     * The Body's `position` isn't changed.
     *
     * @method Phaser.Physics.Arcade.Body#updateBounds
     * @since 3.0.0
     */ updateBounds: function() {
                        var sprite = this.gameObject;
                        //  Container?
                        var transform = this.transform;
                        if (sprite.parentContainer) {
                            var matrix = sprite.getWorldTransformMatrix(this.world._tempMatrix, this.world._tempMatrix2);
                            transform.x = matrix.tx;
                            transform.y = matrix.ty;
                            transform.rotation = RadToDeg(matrix.rotation);
                            transform.scaleX = matrix.scaleX;
                            transform.scaleY = matrix.scaleY;
                            transform.displayOriginX = sprite.displayOriginX;
                            transform.displayOriginY = sprite.displayOriginY;
                        } else {
                            transform.x = sprite.x;
                            transform.y = sprite.y;
                            transform.rotation = sprite.angle;
                            transform.scaleX = sprite.scaleX;
                            transform.scaleY = sprite.scaleY;
                            transform.displayOriginX = sprite.displayOriginX;
                            transform.displayOriginY = sprite.displayOriginY;
                        }
                        var recalc = false;
                        if (this.syncBounds) {
                            var b = sprite.getBounds(this._bounds);
                            this.width = b.width;
                            this.height = b.height;
                            recalc = true;
                        } else {
                            var asx = Math.abs(transform.scaleX);
                            var asy = Math.abs(transform.scaleY);
                            if (this._sx !== asx || this._sy !== asy) {
                                this.width = this.sourceWidth * asx;
                                this.height = this.sourceHeight * asy;
                                this._sx = asx;
                                this._sy = asy;
                                recalc = true;
                            }
                        }
                        if (recalc) {
                            this.halfWidth = Math.floor(this.width / 2);
                            this.halfHeight = Math.floor(this.height / 2);
                            this.updateCenter();
                        }
                    },
                    /**
     * Updates the Body's `center` from its `position`, `width`, and `height`.
     *
     * @method Phaser.Physics.Arcade.Body#updateCenter
     * @since 3.0.0
     */ updateCenter: function() {
                        this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    },
                    /**
     * Updates the Body's `position`, `width`, `height`, and `center` from its Game Object and `offset`.
     *
     * You don't need to call this for Dynamic Bodies, as it happens automatically during the physics step.
     * But you could use it if you have modified the Body offset or Game Object transform and need to immediately
     * read the Body's new `position` or `center`.
     *
     * To resynchronize the Body with its Game Object, use `reset()` instead.
     *
     * @method Phaser.Physics.Arcade.Body#updateFromGameObject
     * @since 3.24.0
     */ updateFromGameObject: function() {
                        this.updateBounds();
                        var transform = this.transform;
                        this.position.x = transform.x + transform.scaleX * (this.offset.x - transform.displayOriginX);
                        this.position.y = transform.y + transform.scaleY * (this.offset.y - transform.displayOriginY);
                        this.updateCenter();
                    },
                    /**
     * Prepares the Body for a physics step by resetting the `wasTouching`, `touching` and `blocked` states.
     *
     * This method is only called if the physics world is going to run a step this frame.
     *
     * @method Phaser.Physics.Arcade.Body#resetFlags
     * @since 3.18.0
     *
     * @param {boolean} [clear=false] - Set the `wasTouching` values to their defaults.
     */ resetFlags: function(clear) {
                        if (clear === undefined) clear = false;
                        //  Store and reset collision flags
                        var wasTouching = this.wasTouching;
                        var touching = this.touching;
                        var blocked = this.blocked;
                        if (clear) SetCollisionObject(true, wasTouching);
                        else {
                            wasTouching.none = touching.none;
                            wasTouching.up = touching.up;
                            wasTouching.down = touching.down;
                            wasTouching.left = touching.left;
                            wasTouching.right = touching.right;
                        }
                        SetCollisionObject(true, touching);
                        SetCollisionObject(true, blocked);
                        this.overlapR = 0;
                        this.overlapX = 0;
                        this.overlapY = 0;
                        this.embedded = false;
                    },
                    /**
     * Syncs the position body position with the parent Game Object.
     *
     * This method is called every game frame, regardless if the world steps or not.
     *
     * @method Phaser.Physics.Arcade.Body#preUpdate
     * @since 3.17.0
     *
     * @param {boolean} willStep - Will this Body run an update as well?
     * @param {number} delta - The delta time, in seconds, elapsed since the last frame.
     */ preUpdate: function(willStep, delta) {
                        if (willStep) this.resetFlags();
                        if (this.gameObject) this.updateFromGameObject();
                        this.rotation = this.transform.rotation;
                        this.preRotation = this.rotation;
                        if (this.moves) {
                            var pos = this.position;
                            this.prev.x = pos.x;
                            this.prev.y = pos.y;
                            this.prevFrame.x = pos.x;
                            this.prevFrame.y = pos.y;
                        }
                        if (willStep) this.update(delta);
                    },
                    /**
     * Performs a single physics step and updates the body velocity, angle, speed and other properties.
     *
     * This method can be called multiple times per game frame, depending on the physics step rate.
     *
     * The results are synced back to the Game Object in `postUpdate`.
     *
     * @method Phaser.Physics.Arcade.Body#update
     * @fires Phaser.Physics.Arcade.Events#WORLD_BOUNDS
     * @since 3.0.0
     *
     * @param {number} delta - The delta time, in seconds, elapsed since the last frame.
     */ update: function(delta) {
                        var prev = this.prev;
                        var pos = this.position;
                        var vel = this.velocity;
                        prev.set(pos.x, pos.y);
                        if (!this.moves) {
                            this._dx = pos.x - prev.x;
                            this._dy = pos.y - prev.y;
                            return;
                        }
                        if (this.directControl) {
                            var autoFrame = this.autoFrame;
                            vel.set((pos.x - autoFrame.x) / delta, (pos.y - autoFrame.y) / delta);
                            this.world.updateMotion(this, delta);
                            this._dx = pos.x - autoFrame.x;
                            this._dy = pos.y - autoFrame.y;
                        } else {
                            this.world.updateMotion(this, delta);
                            this.newVelocity.set(vel.x * delta, vel.y * delta);
                            pos.add(this.newVelocity);
                            this._dx = pos.x - prev.x;
                            this._dy = pos.y - prev.y;
                        }
                        var vx = vel.x;
                        var vy = vel.y;
                        this.updateCenter();
                        this.angle = Math.atan2(vy, vx);
                        this.speed = Math.sqrt(vx * vx + vy * vy);
                        //  Now the update will throw collision checks at the Body
                        //  And finally we'll integrate the new position back to the Sprite in postUpdate
                        if (this.collideWorldBounds && this.checkWorldBounds() && this.onWorldBounds) {
                            var blocked = this.blocked;
                            this.world.emit(Events.WORLD_BOUNDS, this, blocked.up, blocked.down, blocked.left, blocked.right);
                        }
                    },
                    /**
     * Feeds the Body results back into the parent Game Object.
     *
     * This method is called every game frame, regardless if the world steps or not.
     *
     * @method Phaser.Physics.Arcade.Body#postUpdate
     * @since 3.0.0
     */ postUpdate: function() {
                        var pos = this.position;
                        var dx = pos.x - this.prevFrame.x;
                        var dy = pos.y - this.prevFrame.y;
                        var gameObject = this.gameObject;
                        if (this.moves) {
                            var mx = this.deltaMax.x;
                            var my = this.deltaMax.y;
                            if (mx !== 0 && dx !== 0) {
                                if (dx < 0 && dx < -mx) dx = -mx;
                                else if (dx > 0 && dx > mx) dx = mx;
                            }
                            if (my !== 0 && dy !== 0) {
                                if (dy < 0 && dy < -my) dy = -my;
                                else if (dy > 0 && dy > my) dy = my;
                            }
                            if (gameObject) {
                                gameObject.x += dx;
                                gameObject.y += dy;
                            }
                        }
                        if (dx < 0) this.facing = CONST.FACING_LEFT;
                        else if (dx > 0) this.facing = CONST.FACING_RIGHT;
                        if (dy < 0) this.facing = CONST.FACING_UP;
                        else if (dy > 0) this.facing = CONST.FACING_DOWN;
                        if (this.allowRotation && gameObject) gameObject.angle += this.deltaZ();
                        this._tx = dx;
                        this._ty = dy;
                        this.autoFrame.set(pos.x, pos.y);
                    },
                    /**
     * Sets a custom collision boundary rectangle. Use if you want to have a custom
     * boundary instead of the world boundaries.
     *
     * @method Phaser.Physics.Arcade.Body#setBoundsRectangle
     * @since 3.20
     *
     * @param {?Phaser.Geom.Rectangle} [bounds] - The new boundary rectangle. Pass `null` to use the World bounds.
     *
     * @return {this} This Body object.
     */ setBoundsRectangle: function(bounds) {
                        this.customBoundsRectangle = !bounds ? this.world.bounds : bounds;
                        return this;
                    },
                    /**
     * Checks for collisions between this Body and the world boundary and separates them.
     *
     * @method Phaser.Physics.Arcade.Body#checkWorldBounds
     * @since 3.0.0
     *
     * @return {boolean} True if this Body is colliding with the world boundary.
     */ checkWorldBounds: function() {
                        var pos = this.position;
                        var vel = this.velocity;
                        var blocked = this.blocked;
                        var bounds = this.customBoundsRectangle;
                        var check = this.world.checkCollision;
                        var bx = this.worldBounce ? -this.worldBounce.x : -this.bounce.x;
                        var by = this.worldBounce ? -this.worldBounce.y : -this.bounce.y;
                        var wasSet = false;
                        if (pos.x < bounds.x && check.left) {
                            pos.x = bounds.x;
                            vel.x *= bx;
                            blocked.left = true;
                            wasSet = true;
                        } else if (this.right > bounds.right && check.right) {
                            pos.x = bounds.right - this.width;
                            vel.x *= bx;
                            blocked.right = true;
                            wasSet = true;
                        }
                        if (pos.y < bounds.y && check.up) {
                            pos.y = bounds.y;
                            vel.y *= by;
                            blocked.up = true;
                            wasSet = true;
                        } else if (this.bottom > bounds.bottom && check.down) {
                            pos.y = bounds.bottom - this.height;
                            vel.y *= by;
                            blocked.down = true;
                            wasSet = true;
                        }
                        if (wasSet) {
                            this.blocked.none = false;
                            this.updateCenter();
                        }
                        return wasSet;
                    },
                    /**
     * Sets the offset of the Body's position from its Game Object's position.
     * The Body's `position` isn't changed until the next `preUpdate`.
     *
     * @method Phaser.Physics.Arcade.Body#setOffset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal offset, in source pixels.
     * @param {number} [y=x] - The vertical offset, in source pixels.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setOffset: function(x, y) {
                        if (y === undefined) y = x;
                        this.offset.set(x, y);
                        return this;
                    },
                    /**
     * Assign this Body to a new Game Object.
     *
     * Removes this body from the Physics World, assigns to the new Game Object, calls `setSize` and then
     * adds this body back into the World again, setting it enabled, unless the `enable` argument is set to `false`.
     *
     * If this body already has a Game Object, then it will remove itself from that Game Object first.
     *
     * If the given `gameObject` doesn't have a `body` property, it is created and this Body is assigned to it.
     *
     * @method Phaser.Physics.Arcade.Body#setGameObject
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to assign this Body to.
     * @param {boolean} [enable=true] - Automatically enable this Body for physics.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGameObject: function(gameObject, enable) {
                        if (enable === undefined) enable = true;
                        if (!gameObject || !gameObject.hasTransformComponent) //  We need a valid Game Object to continue
                        return this;
                        var world = this.world;
                        if (this.gameObject && this.gameObject.body) {
                            world.disable(this.gameObject);
                            //  Disconnect the current Game Object
                            this.gameObject.body = null;
                        }
                        if (gameObject.body) //  Remove the body from the world, but don't disable the Game Object
                        world.disable(gameObject);
                        this.gameObject = gameObject;
                        gameObject.body = this;
                        //  This will remove the body from the tree, if it's in there and add the new one in
                        this.setSize();
                        this.enable = enable;
                        return this;
                    },
                    /**
     * Sizes and positions this Body, as a rectangle.
     * Modifies the Body `offset` if `center` is true (the default).
     * Resets the width and height to match current frame, if no width and height provided and a frame is found.
     *
     * @method Phaser.Physics.Arcade.Body#setSize
     * @since 3.0.0
     *
     * @param {number} [width] - The width of the Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame width.
     * @param {number} [height] - The height of the Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame height.
     * @param {boolean} [center=true] - Modify the Body's `offset`, placing the Body's center on its Game Object's center. Only works if the Game Object has the `getCenter` method.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setSize: function(width, height, center) {
                        if (center === undefined) center = true;
                        var gameObject = this.gameObject;
                        if (gameObject) {
                            if (!width && gameObject.frame) width = gameObject.frame.realWidth;
                            if (!height && gameObject.frame) height = gameObject.frame.realHeight;
                        }
                        this.sourceWidth = width;
                        this.sourceHeight = height;
                        this.width = this.sourceWidth * this._sx;
                        this.height = this.sourceHeight * this._sy;
                        this.halfWidth = Math.floor(this.width / 2);
                        this.halfHeight = Math.floor(this.height / 2);
                        this.updateCenter();
                        if (center && gameObject && gameObject.getCenter) {
                            var ox = (gameObject.width - width) / 2;
                            var oy = (gameObject.height - height) / 2;
                            this.offset.set(ox, oy);
                        }
                        this.isCircle = false;
                        this.radius = 0;
                        return this;
                    },
                    /**
     * Sizes and positions this Body, as a circle.
     *
     * @method Phaser.Physics.Arcade.Body#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the Body, in source pixels.
     * @param {number} [offsetX] - The horizontal offset of the Body from its Game Object, in source pixels.
     * @param {number} [offsetY] - The vertical offset of the Body from its Game Object, in source pixels.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setCircle: function(radius, offsetX, offsetY) {
                        if (offsetX === undefined) offsetX = this.offset.x;
                        if (offsetY === undefined) offsetY = this.offset.y;
                        if (radius > 0) {
                            this.isCircle = true;
                            this.radius = radius;
                            this.sourceWidth = radius * 2;
                            this.sourceHeight = radius * 2;
                            this.width = this.sourceWidth * this._sx;
                            this.height = this.sourceHeight * this._sy;
                            this.halfWidth = Math.floor(this.width / 2);
                            this.halfHeight = Math.floor(this.height / 2);
                            this.offset.set(offsetX, offsetY);
                            this.updateCenter();
                        } else this.isCircle = false;
                        return this;
                    },
                    /**
     * Sets this Body's parent Game Object to the given coordinates and resets this Body at the new coordinates.
     * If the Body had any velocity or acceleration it is lost as a result of calling this.
     *
     * @method Phaser.Physics.Arcade.Body#reset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position to place the Game Object.
     * @param {number} y - The vertical position to place the Game Object.
     */ reset: function(x, y) {
                        this.stop();
                        var gameObject = this.gameObject;
                        if (gameObject) {
                            gameObject.setPosition(x, y);
                            this.rotation = gameObject.angle;
                            this.preRotation = gameObject.angle;
                        }
                        var pos = this.position;
                        if (gameObject && gameObject.getTopLeft) gameObject.getTopLeft(pos);
                        else pos.set(x, y);
                        this.prev.copy(pos);
                        this.prevFrame.copy(pos);
                        this.autoFrame.copy(pos);
                        if (gameObject) this.updateBounds();
                        this.updateCenter();
                        if (this.collideWorldBounds) this.checkWorldBounds();
                        this.resetFlags(true);
                    },
                    /**
     * Sets acceleration, velocity, and speed to zero.
     *
     * @method Phaser.Physics.Arcade.Body#stop
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ stop: function() {
                        this.velocity.set(0);
                        this.acceleration.set(0);
                        this.speed = 0;
                        this.angularVelocity = 0;
                        this.angularAcceleration = 0;
                        return this;
                    },
                    /**
     * Copies the coordinates of this Body's edges into an object.
     *
     * @method Phaser.Physics.Arcade.Body#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} obj - An object to copy the values into.
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} - An object with {x, y, right, bottom}.
     */ getBounds: function(obj) {
                        obj.x = this.x;
                        obj.y = this.y;
                        obj.right = this.right;
                        obj.bottom = this.bottom;
                        return obj;
                    },
                    /**
     * Tests if the coordinates are within this Body.
     *
     * @method Phaser.Physics.Arcade.Body#hitTest
     * @since 3.0.0
     *
     * @param {number} x - The horizontal coordinate.
     * @param {number} y - The vertical coordinate.
     *
     * @return {boolean} True if (x, y) is within this Body.
     */ hitTest: function(x, y) {
                        if (!this.isCircle) return RectangleContains(this, x, y);
                        //  Check if x/y are within the bounds first
                        if (this.radius > 0 && x >= this.left && x <= this.right && y >= this.top && y <= this.bottom) {
                            var dx = (this.center.x - x) * (this.center.x - x);
                            var dy = (this.center.y - y) * (this.center.y - y);
                            return dx + dy <= this.radius * this.radius;
                        }
                        return false;
                    },
                    /**
     * Whether this Body is touching a tile or the world boundary while moving down.
     *
     * @method Phaser.Physics.Arcade.Body#onFloor
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onFloor: function() {
                        return this.blocked.down;
                    },
                    /**
     * Whether this Body is touching a tile or the world boundary while moving up.
     *
     * @method Phaser.Physics.Arcade.Body#onCeiling
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onCeiling: function() {
                        return this.blocked.up;
                    },
                    /**
     * Whether this Body is touching a tile or the world boundary while moving left or right.
     *
     * @method Phaser.Physics.Arcade.Body#onWall
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onWall: function() {
                        return this.blocked.left || this.blocked.right;
                    },
                    /**
     * The absolute (non-negative) change in this Body's horizontal position from the previous step.
     *
     * @method Phaser.Physics.Arcade.Body#deltaAbsX
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaAbsX: function() {
                        return this._dx > 0 ? this._dx : -this._dx;
                    },
                    /**
     * The absolute (non-negative) change in this Body's vertical position from the previous step.
     *
     * @method Phaser.Physics.Arcade.Body#deltaAbsY
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaAbsY: function() {
                        return this._dy > 0 ? this._dy : -this._dy;
                    },
                    /**
     * The change in this Body's horizontal position from the previous step.
     * This value is set during the Body's update phase.
     *
     * As a Body can update multiple times per step this may not hold the final
     * delta value for the Body. In this case, please see the `deltaXFinal` method.
     *
     * @method Phaser.Physics.Arcade.Body#deltaX
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaX: function() {
                        return this._dx;
                    },
                    /**
     * The change in this Body's vertical position from the previous step.
     * This value is set during the Body's update phase.
     *
     * As a Body can update multiple times per step this may not hold the final
     * delta value for the Body. In this case, please see the `deltaYFinal` method.
     *
     * @method Phaser.Physics.Arcade.Body#deltaY
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaY: function() {
                        return this._dy;
                    },
                    /**
     * The change in this Body's horizontal position from the previous game update.
     *
     * This value is set during the `postUpdate` phase and takes into account the
     * `deltaMax` and final position of the Body.
     *
     * Because this value is not calculated until `postUpdate`, you must listen for it
     * during a Scene `POST_UPDATE` or `RENDER` event, and not in `update`, as it will
     * not be calculated by that point. If you _do_ use these values in `update` they
     * will represent the delta from the _previous_ game frame.
     *
     * @method Phaser.Physics.Arcade.Body#deltaXFinal
     * @since 3.22.0
     *
     * @return {number} The final delta x value.
     */ deltaXFinal: function() {
                        return this._tx;
                    },
                    /**
     * The change in this Body's vertical position from the previous game update.
     *
     * This value is set during the `postUpdate` phase and takes into account the
     * `deltaMax` and final position of the Body.
     *
     * Because this value is not calculated until `postUpdate`, you must listen for it
     * during a Scene `POST_UPDATE` or `RENDER` event, and not in `update`, as it will
     * not be calculated by that point. If you _do_ use these values in `update` they
     * will represent the delta from the _previous_ game frame.
     *
     * @method Phaser.Physics.Arcade.Body#deltaYFinal
     * @since 3.22.0
     *
     * @return {number} The final delta y value.
     */ deltaYFinal: function() {
                        return this._ty;
                    },
                    /**
     * The change in this Body's rotation from the previous step, in degrees.
     *
     * @method Phaser.Physics.Arcade.Body#deltaZ
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaZ: function() {
                        return this.rotation - this.preRotation;
                    },
                    /**
     * Disables this Body and marks it for deletion by the simulation.
     *
     * @method Phaser.Physics.Arcade.Body#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.enable = false;
                        if (this.world) this.world.pendingDestroy.set(this);
                    },
                    /**
     * Draws this Body and its velocity, if enabled.
     *
     * @method Phaser.Physics.Arcade.Body#drawDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphic - The Graphics object to draw on.
     */ drawDebug: function(graphic) {
                        var pos = this.position;
                        var x = pos.x + this.halfWidth;
                        var y = pos.y + this.halfHeight;
                        if (this.debugShowBody) {
                            graphic.lineStyle(graphic.defaultStrokeWidth, this.debugBodyColor);
                            if (this.isCircle) graphic.strokeCircle(x, y, this.width / 2);
                            else {
                                //  Only draw the sides where checkCollision is true, similar to debugger in layer
                                if (this.checkCollision.up) graphic.lineBetween(pos.x, pos.y, pos.x + this.width, pos.y);
                                if (this.checkCollision.right) graphic.lineBetween(pos.x + this.width, pos.y, pos.x + this.width, pos.y + this.height);
                                if (this.checkCollision.down) graphic.lineBetween(pos.x, pos.y + this.height, pos.x + this.width, pos.y + this.height);
                                if (this.checkCollision.left) graphic.lineBetween(pos.x, pos.y, pos.x, pos.y + this.height);
                            }
                        }
                        if (this.debugShowVelocity) {
                            graphic.lineStyle(graphic.defaultStrokeWidth, this.world.defaults.velocityDebugColor, 1);
                            graphic.lineBetween(x, y, x + this.velocity.x / 2, y + this.velocity.y / 2);
                        }
                    },
                    /**
     * Whether this Body will be drawn to the debug display.
     *
     * @method Phaser.Physics.Arcade.Body#willDrawDebug
     * @since 3.0.0
     *
     * @return {boolean} True if either `debugShowBody` or `debugShowVelocity` are enabled.
     */ willDrawDebug: function() {
                        return this.debugShowBody || this.debugShowVelocity;
                    },
                    /**
     * Sets whether this Body should calculate its velocity based on its change in
     * position every frame. The default, which is to not do this, means that you
     * make this Body move by setting the velocity directly. However, if you are
     * trying to move this Body via a Tween, or have it follow a Path, then you
     * should enable this instead. This will allow it to still collide with other
     * bodies, something that isn't possible if you're just changing its position directly.
     *
     * @method Phaser.Physics.Arcade.Body#setDirectControl
     * @since 3.70.0
     *
     * @param {boolean} [value=true] - `true` if the Body calculate velocity based on changes in position, otherwise `false`.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDirectControl: function(value) {
                        if (value === undefined) value = true;
                        this.directControl = value;
                        return this;
                    },
                    /**
     * Sets whether this Body collides with the world boundary.
     *
     * Optionally also sets the World Bounce and `onWorldBounds` values.
     *
     * @method Phaser.Physics.Arcade.Body#setCollideWorldBounds
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - `true` if the Body should collide with the world bounds, otherwise `false`.
     * @param {number} [bounceX] - If given this replaces the Body's `worldBounce.x` value.
     * @param {number} [bounceY] - If given this replaces the Body's `worldBounce.y` value.
     * @param {boolean} [onWorldBounds] - If given this replaces the Body's `onWorldBounds` value.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setCollideWorldBounds: function(value, bounceX, bounceY, onWorldBounds) {
                        if (value === undefined) value = true;
                        this.collideWorldBounds = value;
                        var setBounceX = bounceX !== undefined;
                        var setBounceY = bounceY !== undefined;
                        if (setBounceX || setBounceY) {
                            if (!this.worldBounce) this.worldBounce = new Vector2();
                            if (setBounceX) this.worldBounce.x = bounceX;
                            if (setBounceY) this.worldBounce.y = bounceY;
                        }
                        if (onWorldBounds !== undefined) this.onWorldBounds = onWorldBounds;
                        return this;
                    },
                    /**
     * Sets the Body's velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity, in pixels per second.
     * @param {number} [y=x] - The vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocity: function(x, y) {
                        this.velocity.set(x, y);
                        x = this.velocity.x;
                        y = this.velocity.y;
                        this.speed = Math.sqrt(x * x + y * y);
                        return this;
                    },
                    /**
     * Sets the Body's horizontal velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocityX
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocityX: function(value) {
                        return this.setVelocity(value, this.velocity.y);
                    },
                    /**
     * Sets the Body's vertical velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocityY
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocityY: function(value) {
                        return this.setVelocity(this.velocity.x, value);
                    },
                    /**
     * Sets the Body's maximum velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocity
     * @since 3.10.0
     *
     * @param {number} x - The horizontal velocity, in pixels per second.
     * @param {number} [y=x] - The vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocity: function(x, y) {
                        this.maxVelocity.set(x, y);
                        return this;
                    },
                    /**
     * Sets the Body's maximum horizontal velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocityX
     * @since 3.50.0
     *
     * @param {number} value - The maximum horizontal velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocityX: function(value) {
                        this.maxVelocity.x = value;
                        return this;
                    },
                    /**
     * Sets the Body's maximum vertical velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocityY
     * @since 3.50.0
     *
     * @param {number} value - The maximum vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocityY: function(value) {
                        this.maxVelocity.y = value;
                        return this;
                    },
                    /**
     * Sets the maximum speed the Body can move.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxSpeed
     * @since 3.16.0
     *
     * @param {number} value - The maximum speed value, in pixels per second. Set to a negative value to disable.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxSpeed: function(value) {
                        this.maxSpeed = value;
                        return this;
                    },
                    /**
     * Sets the Slide Factor of this Body.
     *
     * The Slide Factor controls how much velocity is preserved when
     * this Body is pushed by another Body.
     *
     * The default value is 1, which means that it will take on all
     * velocity given in the push. You can adjust this value to control
     * how much velocity is retained by this Body when the push ends.
     *
     * A value of 0, for example, will allow this Body to be pushed
     * but then remain completely still after the push ends, such as
     * you see in a game like Sokoban.
     *
     * Or you can set a mid-point, such as 0.25 which will allow it
     * to keep 25% of the original velocity when the push ends. You
     * can combine this with the `setDrag()` method to create deceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setSlideFactor
     * @since 3.70.0
     *
     * @param {number} x - The horizontal slide factor. A value between 0 and 1.
     * @param {number} [y=x] - The vertical slide factor. A value between 0 and 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setSlideFactor: function(x, y) {
                        this.slideFactor.set(x, y);
                        return this;
                    },
                    /**
     * Sets the Body's bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounce
     * @since 3.0.0
     *
     * @param {number} x - The horizontal bounce, relative to 1.
     * @param {number} [y=x] - The vertical bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounce: function(x, y) {
                        this.bounce.set(x, y);
                        return this;
                    },
                    /**
     * Sets the Body's horizontal bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounceX
     * @since 3.0.0
     *
     * @param {number} value - The bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounceX: function(value) {
                        this.bounce.x = value;
                        return this;
                    },
                    /**
     * Sets the Body's vertical bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounceY
     * @since 3.0.0
     *
     * @param {number} value - The bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounceY: function(value) {
                        this.bounce.y = value;
                        return this;
                    },
                    /**
     * Sets the Body's acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAcceleration
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} [y=x] - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAcceleration: function(x, y) {
                        this.acceleration.set(x, y);
                        return this;
                    },
                    /**
     * Sets the Body's horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAccelerationX
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAccelerationX: function(value) {
                        this.acceleration.x = value;
                        return this;
                    },
                    /**
     * Sets the Body's vertical acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAccelerationY
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAccelerationY: function(value) {
                        this.acceleration.y = value;
                        return this;
                    },
                    /**
     * Enables or disables drag.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowDrag
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowDrag
     *
     * @param {boolean} [value=true] - `true` to allow drag on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowDrag: function(value) {
                        if (value === undefined) value = true;
                        this.allowDrag = value;
                        return this;
                    },
                    /**
     * Enables or disables gravity's effect on this Body.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowGravity
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowGravity
     *
     * @param {boolean} [value=true] - `true` to allow gravity on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowGravity: function(value) {
                        if (value === undefined) value = true;
                        this.allowGravity = value;
                        return this;
                    },
                    /**
     * Enables or disables rotation.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowRotation
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowRotation
     *
     * @param {boolean} [value=true] - `true` to allow rotation on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowRotation: function(value) {
                        if (value === undefined) value = true;
                        this.allowRotation = value;
                        return this;
                    },
                    /**
     * Sets the Body's drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDrag
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} [y=x] - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDrag: function(x, y) {
                        this.drag.set(x, y);
                        return this;
                    },
                    /**
     * If this Body is using `drag` for deceleration this property controls how the drag is applied.
     * If set to `true` drag will use a damping effect rather than a linear approach. If you are
     * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
     * the game Asteroids) then you will get a far smoother and more visually correct deceleration
     * by using damping, avoiding the axis-drift that is prone with linear deceleration.
     *
     * If you enable this property then you should use far smaller `drag` values than with linear, as
     * they are used as a multiplier on the velocity. Values such as 0.95 will give a nice slow
     * deceleration, where-as smaller values, such as 0.5 will stop an object almost immediately.
     *
     * @method Phaser.Physics.Arcade.Body#setDamping
     * @since 3.50.0
     *
     * @param {boolean} value - `true` to use damping, or `false` to use drag.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDamping: function(value) {
                        this.useDamping = value;
                        return this;
                    },
                    /**
     * Sets the Body's horizontal drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDragX
     * @since 3.0.0
     *
     * @param {number} value - The drag, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDragX: function(value) {
                        this.drag.x = value;
                        return this;
                    },
                    /**
     * Sets the Body's vertical drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDragY
     * @since 3.0.0
     *
     * @param {number} value - The drag, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDragY: function(value) {
                        this.drag.y = value;
                        return this;
                    },
                    /**
     * Sets the Body's gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} [y=x] - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravity: function(x, y) {
                        this.gravity.set(x, y);
                        return this;
                    },
                    /**
     * Sets the Body's horizontal gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravityX
     * @since 3.0.0
     *
     * @param {number} value - The gravity, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravityX: function(value) {
                        this.gravity.x = value;
                        return this;
                    },
                    /**
     * Sets the Body's vertical gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravityY
     * @since 3.0.0
     *
     * @param {number} value - The gravity, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravityY: function(value) {
                        this.gravity.y = value;
                        return this;
                    },
                    /**
     * Sets the Body's friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFriction
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, relative to 1.
     * @param {number} [y=x] - The vertical component, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFriction: function(x, y) {
                        this.friction.set(x, y);
                        return this;
                    },
                    /**
     * Sets the Body's horizontal friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFrictionX
     * @since 3.0.0
     *
     * @param {number} value - The friction value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFrictionX: function(value) {
                        this.friction.x = value;
                        return this;
                    },
                    /**
     * Sets the Body's vertical friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFrictionY
     * @since 3.0.0
     *
     * @param {number} value - The friction value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFrictionY: function(value) {
                        this.friction.y = value;
                        return this;
                    },
                    /**
     * Sets the Body's angular velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in degrees per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularVelocity: function(value) {
                        this.angularVelocity = value;
                        return this;
                    },
                    /**
     * Sets the Body's angular acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularAcceleration
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in degrees per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularAcceleration: function(value) {
                        this.angularAcceleration = value;
                        return this;
                    },
                    /**
     * Sets the Body's angular drag.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularDrag
     * @since 3.0.0
     *
     * @param {number} value - The drag, in degrees per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularDrag: function(value) {
                        this.angularDrag = value;
                        return this;
                    },
                    /**
     * Sets the Body's mass.
     *
     * @method Phaser.Physics.Arcade.Body#setMass
     * @since 3.0.0
     *
     * @param {number} value - The mass value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMass: function(value) {
                        this.mass = value;
                        return this;
                    },
                    /**
     * Sets the Body's `immovable` property.
     *
     * @method Phaser.Physics.Arcade.Body#setImmovable
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - The value to assign to `immovable`.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setImmovable: function(value) {
                        if (value === undefined) value = true;
                        this.immovable = value;
                        return this;
                    },
                    /**
     * Sets the Body's `enable` property.
     *
     * @method Phaser.Physics.Arcade.Body#setEnable
     * @since 3.15.0
     *
     * @param {boolean} [value=true] - The value to assign to `enable`.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setEnable: function(value) {
                        if (value === undefined) value = true;
                        this.enable = value;
                        return this;
                    },
                    /**
     * This is an internal handler, called by the `ProcessX` function as part
     * of the collision step. You should almost never call this directly.
     *
     * @method Phaser.Physics.Arcade.Body#processX
     * @since 3.50.0
     *
     * @param {number} x - The amount to add to the Body position.
     * @param {number} [vx] - The amount to add to the Body velocity.
     * @param {boolean} [left] - Set the blocked.left value?
     * @param {boolean} [right] - Set the blocked.right value?
     */ processX: function(x, vx, left, right) {
                        this.x += x;
                        this.updateCenter();
                        if (vx !== null) this.velocity.x = vx * this.slideFactor.x;
                        var blocked = this.blocked;
                        if (left) {
                            blocked.left = true;
                            blocked.none = false;
                        }
                        if (right) {
                            blocked.right = true;
                            blocked.none = false;
                        }
                    },
                    /**
     * This is an internal handler, called by the `ProcessY` function as part
     * of the collision step. You should almost never call this directly.
     *
     * @method Phaser.Physics.Arcade.Body#processY
     * @since 3.50.0
     *
     * @param {number} y - The amount to add to the Body position.
     * @param {number} [vy] - The amount to add to the Body velocity.
     * @param {boolean} [up] - Set the blocked.up value?
     * @param {boolean} [down] - Set the blocked.down value?
     */ processY: function(y, vy, up, down) {
                        this.y += y;
                        this.updateCenter();
                        if (vy !== null) this.velocity.y = vy * this.slideFactor.y;
                        var blocked = this.blocked;
                        if (up) {
                            blocked.up = true;
                            blocked.none = false;
                        }
                        if (down) {
                            blocked.down = true;
                            blocked.none = false;
                        }
                    },
                    /**
     * The Bodys horizontal position (left edge).
     *
     * @name Phaser.Physics.Arcade.Body#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this.position.x;
                        },
                        set: function(value) {
                            this.position.x = value;
                        }
                    },
                    /**
     * The Bodys vertical position (top edge).
     *
     * @name Phaser.Physics.Arcade.Body#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this.position.y;
                        },
                        set: function(value) {
                            this.position.y = value;
                        }
                    },
                    /**
     * The left edge of the Body. Identical to x.
     *
     * @name Phaser.Physics.Arcade.Body#left
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ left: {
                        get: function() {
                            return this.position.x;
                        }
                    },
                    /**
     * The right edge of the Body.
     *
     * @name Phaser.Physics.Arcade.Body#right
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ right: {
                        get: function() {
                            return this.position.x + this.width;
                        }
                    },
                    /**
     * The top edge of the Body. Identical to y.
     *
     * @name Phaser.Physics.Arcade.Body#top
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ top: {
                        get: function() {
                            return this.position.y;
                        }
                    },
                    /**
     * The bottom edge of this Body.
     *
     * @name Phaser.Physics.Arcade.Body#bottom
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ bottom: {
                        get: function() {
                            return this.position.y + this.height;
                        }
                    }
                });
                module1.exports = Body;
            /***/ },
            /***/ 79342: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * An Arcade Physics Collider will automatically check for collision, or overlaps, between two objects
 * every step. If a collision, or overlap, occurs it will invoke the given callbacks.
 * 
 * Note, if setting `overlapOnly` to `true`, and one of the objects is a `TilemapLayer`, every tile in the layer, regardless of tile ID, will be checked for collision. 
 * Even if the layer has had only a subset of tile IDs enabled for collision, all tiles will still be checked for overlap.
 *
 * @class Collider
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade physics World that will manage the collisions.
 * @param {boolean} overlapOnly - Whether to check for collisions or overlaps.
 * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
 * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for collision.
 * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
 * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
 * @param {any} callbackContext - The scope in which to call the callbacks.
 */ var Collider = new Class({
                    initialize: function Collider(world, overlapOnly, object1, object2, collideCallback, processCallback, callbackContext) {
                        /**
         * The world in which the bodies will collide.
         *
         * @name Phaser.Physics.Arcade.Collider#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * The name of the collider (unused by Phaser).
         *
         * @name Phaser.Physics.Arcade.Collider#name
         * @type {string}
         * @since 3.1.0
         */ this.name = '';
                        /**
         * Whether the collider is active.
         *
         * @name Phaser.Physics.Arcade.Collider#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                        /**
         * Whether to check for collisions or overlaps.
         *
         * @name Phaser.Physics.Arcade.Collider#overlapOnly
         * @type {boolean}
         * @since 3.0.0
         */ this.overlapOnly = overlapOnly;
                        /**
         * The first object to check for collision.
         *
         * @name Phaser.Physics.Arcade.Collider#object1
         * @type {Phaser.Types.Physics.Arcade.ArcadeColliderType}
         * @since 3.0.0
         */ this.object1 = object1;
                        /**
         * The second object to check for collision.
         *
         * @name Phaser.Physics.Arcade.Collider#object2
         * @type {Phaser.Types.Physics.Arcade.ArcadeColliderType}
         * @since 3.0.0
         */ this.object2 = object2;
                        /**
         * The callback to invoke when the two objects collide.
         *
         * @name Phaser.Physics.Arcade.Collider#collideCallback
         * @type {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback}
         * @since 3.0.0
         */ this.collideCallback = collideCallback;
                        /**
         * If a processCallback exists it must return true or collision checking will be skipped.
         *
         * @name Phaser.Physics.Arcade.Collider#processCallback
         * @type {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback}
         * @since 3.0.0
         */ this.processCallback = processCallback;
                        /**
         * The context the collideCallback and processCallback will run in.
         *
         * @name Phaser.Physics.Arcade.Collider#callbackContext
         * @type {object}
         * @since 3.0.0
         */ this.callbackContext = callbackContext;
                    },
                    /**
     * A name for the Collider.
     *
     * Phaser does not use this value, it's for your own reference.
     *
     * @method Phaser.Physics.Arcade.Collider#setName
     * @since 3.1.0
     *
     * @param {string} name - The name to assign to the Collider.
     *
     * @return {Phaser.Physics.Arcade.Collider} This Collider instance.
     */ setName: function(name) {
                        this.name = name;
                        return this;
                    },
                    /**
     * Called by World as part of its step processing, initial operation of collision checking.
     *
     * @method Phaser.Physics.Arcade.Collider#update
     * @since 3.0.0
     */ update: function() {
                        this.world.collideObjects(this.object1, this.object2, this.collideCallback, this.processCallback, this.callbackContext, this.overlapOnly);
                    },
                    /**
     * Removes Collider from World and disposes of its resources.
     *
     * @method Phaser.Physics.Arcade.Collider#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.world.removeCollider(this);
                        this.active = false;
                        this.world = null;
                        this.object1 = null;
                        this.object2 = null;
                        this.collideCallback = null;
                        this.processCallback = null;
                        this.callbackContext = null;
                    }
                });
                module1.exports = Collider;
            /***/ },
            /***/ 66022: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeImage = __webpack_require__(71289);
                var ArcadeSprite = __webpack_require__(13759);
                var Body = __webpack_require__(37742);
                var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(37747);
                var PhysicsGroup = __webpack_require__(60758);
                var StaticBody = __webpack_require__(72624);
                var StaticPhysicsGroup = __webpack_require__(71464);
                /**
 * @classdesc
 * The Arcade Physics Factory allows you to easily create Arcade Physics enabled Game Objects.
 * Objects that are created by this Factory are automatically added to the physics world.
 *
 * @class Factory
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics World instance.
 */ var Factory = new Class({
                    initialize: function Factory(world) {
                        /**
         * A reference to the Arcade Physics World.
         *
         * @name Phaser.Physics.Arcade.Factory#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * A reference to the Scene this Arcade Physics instance belongs to.
         *
         * @name Phaser.Physics.Arcade.Factory#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = world.scene;
                        /**
         * A reference to the Scene.Systems this Arcade Physics instance belongs to.
         *
         * @name Phaser.Physics.Arcade.Factory#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = world.scene.sys;
                    },
                    /**
     * Creates a new Arcade Physics Collider object.
     *
     * @method Phaser.Physics.Arcade.Factory#collider
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ collider: function(object1, object2, collideCallback, processCallback, callbackContext) {
                        return this.world.addCollider(object1, object2, collideCallback, processCallback, callbackContext);
                    },
                    /**
     * Creates a new Arcade Physics Collider Overlap object.
     *
     * @method Phaser.Physics.Arcade.Factory#overlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ overlap: function(object1, object2, collideCallback, processCallback, callbackContext) {
                        return this.world.addOverlap(object1, object2, collideCallback, processCallback, callbackContext);
                    },
                    /**
     * Adds an Arcade Physics Body to the given Game Object.
     *
     * @method Phaser.Physics.Arcade.Factory#existing
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A Game Object.
     * @param {boolean} [isStatic=false] - Create a Static body (true) or Dynamic body (false).
     *
     * @return {Phaser.Types.Physics.Arcade.GameObjectWithBody} The Game Object.
     */ existing: function(gameObject, isStatic) {
                        var type = isStatic ? CONST.STATIC_BODY : CONST.DYNAMIC_BODY;
                        this.world.enableBody(gameObject, type);
                        return gameObject;
                    },
                    /**
     * Creates a new Arcade Image object with a Static body.
     *
     * @method Phaser.Physics.Arcade.Factory#staticImage
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.ImageWithStaticBody} The Image object that was created.
     */ staticImage: function(x, y, key, frame) {
                        var image = new ArcadeImage(this.scene, x, y, key, frame);
                        this.sys.displayList.add(image);
                        this.world.enableBody(image, CONST.STATIC_BODY);
                        return image;
                    },
                    /**
     * Creates a new Arcade Image object with a Dynamic body.
     *
     * @method Phaser.Physics.Arcade.Factory#image
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.ImageWithDynamicBody} The Image object that was created.
     */ image: function(x, y, key, frame) {
                        var image = new ArcadeImage(this.scene, x, y, key, frame);
                        this.sys.displayList.add(image);
                        this.world.enableBody(image, CONST.DYNAMIC_BODY);
                        return image;
                    },
                    /**
     * Creates a new Arcade Sprite object with a Static body.
     *
     * @method Phaser.Physics.Arcade.Factory#staticSprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.SpriteWithStaticBody} The Sprite object that was created.
     */ staticSprite: function(x, y, key, frame) {
                        var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
                        this.sys.displayList.add(sprite);
                        this.sys.updateList.add(sprite);
                        this.world.enableBody(sprite, CONST.STATIC_BODY);
                        return sprite;
                    },
                    /**
     * Creates a new Arcade Sprite object with a Dynamic body.
     *
     * @method Phaser.Physics.Arcade.Factory#sprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.SpriteWithDynamicBody} The Sprite object that was created.
     */ sprite: function(x, y, key, frame) {
                        var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
                        this.sys.displayList.add(sprite);
                        this.sys.updateList.add(sprite);
                        this.world.enableBody(sprite, CONST.DYNAMIC_BODY);
                        return sprite;
                    },
                    /**
     * Creates a Static Physics Group object.
     * All Game Objects created by this Group will automatically be static Arcade Physics objects.
     *
     * @method Phaser.Physics.Arcade.Factory#staticGroup
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
     * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
     *
     * @return {Phaser.Physics.Arcade.StaticGroup} The Static Group object that was created.
     */ staticGroup: function(children, config) {
                        return this.sys.updateList.add(new StaticPhysicsGroup(this.world, this.world.scene, children, config));
                    },
                    /**
     * Creates a Physics Group object.
     * All Game Objects created by this Group will automatically be dynamic Arcade Physics objects.
     *
     * @method Phaser.Physics.Arcade.Factory#group
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
     * @param {Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
     *
     * @return {Phaser.Physics.Arcade.Group} The Group object that was created.
     */ group: function(children, config) {
                        return this.sys.updateList.add(new PhysicsGroup(this.world, this.world.scene, children, config));
                    },
                    /**
     * Creates a new physics Body with the given position and size.
     *
     * This Body is not associated with any Game Object, but still exists within the world
     * and can be tested for collision, have velocity, etc.
     *
     * @method Phaser.Physics.Arcade.Factory#body
     * @since 3.60.0
     *
     * @param {number} x - The horizontal position of this Body in the physics world.
     * @param {number} y - The vertical position of this Body in the physics world.
     * @param {number} [width=64] - The width of the Body in pixels. Cannot be negative or zero.
     * @param {number} [height=64] - The height of the Body in pixels. Cannot be negative or zero.
     *
     * @return {Phaser.Physics.Arcade.Body} The Body that was created.
     */ body: function(x, y, width, height) {
                        var body = new Body(this.world);
                        body.position.set(x, y);
                        if (width && height) body.setSize(width, height);
                        this.world.add(body, CONST.DYNAMIC_BODY);
                        return body;
                    },
                    /**
     * Creates a new static physics Body with the given position and size.
     *
     * This Body is not associated with any Game Object, but still exists within the world
     * and can be tested for collision, etc.
     *
     * @method Phaser.Physics.Arcade.Factory#staticBody
     * @since 3.60.0
     *
     * @param {number} x - The horizontal position of this Body in the physics world.
     * @param {number} y - The vertical position of this Body in the physics world.
     * @param {number} [width=64] - The width of the Body in pixels. Cannot be negative or zero.
     * @param {number} [height=64] - The height of the Body in pixels. Cannot be negative or zero.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} The Static Body that was created.
     */ staticBody: function(x, y, width, height) {
                        var body = new StaticBody(this.world);
                        body.position.set(x, y);
                        if (width && height) body.setSize(width, height);
                        this.world.add(body, CONST.STATIC_BODY);
                        return body;
                    },
                    /**
     * Destroys this Factory.
     *
     * @method Phaser.Physics.Arcade.Factory#destroy
     * @since 3.5.0
     */ destroy: function() {
                        this.world = null;
                        this.scene = null;
                        this.sys = null;
                    }
                });
                module1.exports = Factory;
            /***/ },
            /***/ 79599: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates and returns the bitmask needed to determine if the given
 * categories will collide with each other or not.
 *
 * @function Phaser.Physics.Arcade.GetCollidesWith
 * @since 3.70.0
 *
 * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
 *
 * @return {number} The collision mask.
 */ var GetCollidesWith = function(categories) {
                    var flags = 0;
                    if (!Array.isArray(categories)) flags = categories;
                    else for(var i = 0; i < categories.length; i++)flags |= categories[i];
                    return flags;
                };
                module1.exports = GetCollidesWith;
            /***/ },
            /***/ 64897: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(37747);
                /**
 * Calculates and returns the horizontal overlap between two arcade physics bodies and sets their properties
 * accordingly, including: `touching.left`, `touching.right`, `touching.none` and `overlapX'.
 *
 * @function Phaser.Physics.Arcade.GetOverlapX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
 * @param {number} bias - A value added to the delta values during collision checks. Increase it to prevent sprite tunneling(sprites passing through another instead of colliding).
 *
 * @return {number} The amount of overlap.
 */ var GetOverlapX = function(body1, body2, overlapOnly, bias) {
                    var overlap = 0;
                    var maxOverlap = body1.deltaAbsX() + body2.deltaAbsX() + bias;
                    if (body1._dx === 0 && body2._dx === 0) {
                        //  They overlap but neither of them are moving
                        body1.embedded = true;
                        body2.embedded = true;
                    } else if (body1._dx > body2._dx) {
                        //  Body1 is moving right and / or Body2 is moving left
                        overlap = body1.right - body2.x;
                        if (overlap > maxOverlap && !overlapOnly || body1.checkCollision.right === false || body2.checkCollision.left === false) overlap = 0;
                        else {
                            body1.touching.none = false;
                            body1.touching.right = true;
                            body2.touching.none = false;
                            body2.touching.left = true;
                            if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body1.blocked.none = false;
                                body1.blocked.right = true;
                            }
                            if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body2.blocked.none = false;
                                body2.blocked.left = true;
                            }
                        }
                    } else if (body1._dx < body2._dx) {
                        //  Body1 is moving left and/or Body2 is moving right
                        overlap = body1.x - body2.width - body2.x;
                        if (-overlap > maxOverlap && !overlapOnly || body1.checkCollision.left === false || body2.checkCollision.right === false) overlap = 0;
                        else {
                            body1.touching.none = false;
                            body1.touching.left = true;
                            body2.touching.none = false;
                            body2.touching.right = true;
                            if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body1.blocked.none = false;
                                body1.blocked.left = true;
                            }
                            if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body2.blocked.none = false;
                                body2.blocked.right = true;
                            }
                        }
                    }
                    //  Resets the overlapX to zero if there is no overlap, or to the actual pixel value if there is
                    body1.overlapX = overlap;
                    body2.overlapX = overlap;
                    return overlap;
                };
                module1.exports = GetOverlapX;
            /***/ },
            /***/ 45170: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(37747);
                /**
 * Calculates and returns the vertical overlap between two arcade physics bodies and sets their properties
 * accordingly, including: `touching.up`, `touching.down`, `touching.none` and `overlapY'.
 *
 * @function Phaser.Physics.Arcade.GetOverlapY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
 * @param {number} bias - A value added to the delta values during collision checks. Increase it to prevent sprite tunneling(sprites passing through another instead of colliding).
 *
 * @return {number} The amount of overlap.
 */ var GetOverlapY = function(body1, body2, overlapOnly, bias) {
                    var overlap = 0;
                    var maxOverlap = body1.deltaAbsY() + body2.deltaAbsY() + bias;
                    if (body1._dy === 0 && body2._dy === 0) {
                        //  They overlap but neither of them are moving
                        body1.embedded = true;
                        body2.embedded = true;
                    } else if (body1._dy > body2._dy) {
                        //  Body1 is moving down and/or Body2 is moving up
                        overlap = body1.bottom - body2.y;
                        if (overlap > maxOverlap && !overlapOnly || body1.checkCollision.down === false || body2.checkCollision.up === false) overlap = 0;
                        else {
                            body1.touching.none = false;
                            body1.touching.down = true;
                            body2.touching.none = false;
                            body2.touching.up = true;
                            if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body1.blocked.none = false;
                                body1.blocked.down = true;
                            }
                            if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body2.blocked.none = false;
                                body2.blocked.up = true;
                            }
                        }
                    } else if (body1._dy < body2._dy) {
                        //  Body1 is moving up and/or Body2 is moving down
                        overlap = body1.y - body2.bottom;
                        if (-overlap > maxOverlap && !overlapOnly || body1.checkCollision.up === false || body2.checkCollision.down === false) overlap = 0;
                        else {
                            body1.touching.none = false;
                            body1.touching.up = true;
                            body2.touching.none = false;
                            body2.touching.down = true;
                            if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body1.blocked.none = false;
                                body1.blocked.up = true;
                            }
                            if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                                body2.blocked.none = false;
                                body2.blocked.down = true;
                            }
                        }
                    }
                    //  Resets the overlapY to zero if there is no overlap, or to the actual pixel value if there is
                    body1.overlapY = overlap;
                    body2.overlapY = overlap;
                    return overlap;
                };
                module1.exports = GetOverlapY;
            /***/ },
            /***/ 60758: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeSprite = __webpack_require__(13759);
                var Class = __webpack_require__(83419);
                var CollisionComponent = __webpack_require__(78389);
                var CONST = __webpack_require__(37747);
                var GetFastValue = __webpack_require__(95540);
                var Group = __webpack_require__(26479);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * An Arcade Physics Group object.
 *
 * The primary use of a Physics Group is a way to collect together physics enable objects
 * that share the same intrinsic structure into a single pool. They can they be easily
 * compared against other Groups, or Game Objects.
 *
 * All Game Objects created by, or added to this Group will automatically be given **dynamic**
 * Arcade Physics bodies (if they have no body already) and the bodies will receive the
 * Groups {@link Phaser.Physics.Arcade.Group#defaults default values}.
 *
 * You should not pass objects into this Group that should not receive a body. For example,
 * do not add basic Geometry or Tilemap Layers into a Group, as they will not behave in the
 * way you may expect. Groups should all ideally have objects of the same type in them.
 *
 * If you wish to create a Group filled with Static Bodies, please see {@link Phaser.Physics.Arcade.StaticGroup}.
 *
 * @class Group
 * @extends Phaser.GameObjects.Group
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Collision
 *
 * @param {Phaser.Physics.Arcade.World} world - The physics simulation.
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
 */ var PhysicsGroup = new Class({
                    Extends: Group,
                    Mixins: [
                        CollisionComponent
                    ],
                    initialize: function PhysicsGroup(world, scene, children, config) {
                        if (!children && !config) config = {
                            internalCreateCallback: this.createCallbackHandler,
                            internalRemoveCallback: this.removeCallbackHandler
                        };
                        else if (IsPlainObject(children)) {
                            //  children is a plain object, so swizzle them:
                            config = children;
                            children = null;
                            config.internalCreateCallback = this.createCallbackHandler;
                            config.internalRemoveCallback = this.removeCallbackHandler;
                        } else if (Array.isArray(children) && IsPlainObject(children[0])) {
                            //  children is an array of plain objects (i.e., configs)
                            var _this = this;
                            children.forEach(function(singleConfig) {
                                singleConfig.internalCreateCallback = _this.createCallbackHandler;
                                singleConfig.internalRemoveCallback = _this.removeCallbackHandler;
                                singleConfig.classType = GetFastValue(singleConfig, 'classType', ArcadeSprite);
                            });
                            config = null;
                        } else // config is not defined and children is not a plain object nor an array of plain objects
                        config = {
                            internalCreateCallback: this.createCallbackHandler,
                            internalRemoveCallback: this.removeCallbackHandler
                        };
                        /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.Group#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * The class to create new Group members from.
         *
         * This should be either `Phaser.Physics.Arcade.Image`, `Phaser.Physics.Arcade.Sprite`, or a class extending one of those.
         *
         * @name Phaser.Physics.Arcade.Group#classType
         * @type {function}
         * @default ArcadeSprite
         * @since 3.0.0
         * @see Phaser.Types.GameObjects.Group.GroupClassTypeConstructor
         */ if (config) config.classType = GetFastValue(config, 'classType', ArcadeSprite);
                        /**
         * The physics type of the Group's members.
         *
         * @name Phaser.Physics.Arcade.Group#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.DYNAMIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.DYNAMIC_BODY;
                        /**
         * The Arcade Physics Group Collision Category.
         *
         * This can be set to any valid collision bitfield value.
         *
         * See the `setCollisionCategory` method for more details.
         *
         * @name Phaser.Physics.Arcade.Group#collisionCategory
         * @type {number}
         * @since 3.70.0
         */ this.collisionCategory = 0x0001;
                        /**
         * The Arcade Physics Group Collision Mask.
         *
         * See the `setCollidesWith` method for more details.
         *
         * @name Phaser.Physics.Arcade.Group#collisionMask
         * @type {number}
         * @since 3.70.0
         */ this.collisionMask = 2147483647;
                        /**
         * Default physics properties applied to Game Objects added to the Group or created by the Group. Derived from the `config` argument.
         *
         * You can remove the default values by setting this property to `{}`.
         *
         * @name Phaser.Physics.Arcade.Group#defaults
         * @type {Phaser.Types.Physics.Arcade.PhysicsGroupDefaults}
         * @since 3.0.0
         */ this.defaults = {
                            setCollideWorldBounds: GetFastValue(config, 'collideWorldBounds', false),
                            setBoundsRectangle: GetFastValue(config, 'customBoundsRectangle', null),
                            setAccelerationX: GetFastValue(config, 'accelerationX', 0),
                            setAccelerationY: GetFastValue(config, 'accelerationY', 0),
                            setAllowDrag: GetFastValue(config, 'allowDrag', true),
                            setAllowGravity: GetFastValue(config, 'allowGravity', true),
                            setAllowRotation: GetFastValue(config, 'allowRotation', true),
                            setDamping: GetFastValue(config, 'useDamping', false),
                            setBounceX: GetFastValue(config, 'bounceX', 0),
                            setBounceY: GetFastValue(config, 'bounceY', 0),
                            setDragX: GetFastValue(config, 'dragX', 0),
                            setDragY: GetFastValue(config, 'dragY', 0),
                            setEnable: GetFastValue(config, 'enable', true),
                            setGravityX: GetFastValue(config, 'gravityX', 0),
                            setGravityY: GetFastValue(config, 'gravityY', 0),
                            setFrictionX: GetFastValue(config, 'frictionX', 0),
                            setFrictionY: GetFastValue(config, 'frictionY', 0),
                            setMaxSpeed: GetFastValue(config, 'maxSpeed', -1),
                            setMaxVelocityX: GetFastValue(config, 'maxVelocityX', 10000),
                            setMaxVelocityY: GetFastValue(config, 'maxVelocityY', 10000),
                            setVelocityX: GetFastValue(config, 'velocityX', 0),
                            setVelocityY: GetFastValue(config, 'velocityY', 0),
                            setAngularVelocity: GetFastValue(config, 'angularVelocity', 0),
                            setAngularAcceleration: GetFastValue(config, 'angularAcceleration', 0),
                            setAngularDrag: GetFastValue(config, 'angularDrag', 0),
                            setMass: GetFastValue(config, 'mass', 1),
                            setImmovable: GetFastValue(config, 'immovable', false)
                        };
                        Group.call(this, scene, children, config);
                        /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.Physics.Arcade.Group#type
         * @type {string}
         * @default 'PhysicsGroup'
         * @since 3.21.0
         */ this.type = 'PhysicsGroup';
                    },
                    /**
     * Enables a Game Object's Body and assigns `defaults`. Called when a Group member is added or created.
     *
     * @method Phaser.Physics.Arcade.Group#createCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being added.
     */ createCallbackHandler: function(child) {
                        if (!child.body) this.world.enableBody(child, CONST.DYNAMIC_BODY);
                        var body = child.body;
                        for(var key in this.defaults)body[key](this.defaults[key]);
                    },
                    /**
     * Disables a Game Object's Body. Called when a Group member is removed.
     *
     * @method Phaser.Physics.Arcade.Group#removeCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being removed.
     */ removeCallbackHandler: function(child) {
                        if (child.body) this.world.disableBody(child);
                    },
                    /**
     * Sets the velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity.
     * @param {number} y - The vertical velocity.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (x, y), the second (x + step, y + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocity: function(x, y, step) {
                        if (step === undefined) step = 0;
                        var items = this.getChildren();
                        for(var i = 0; i < items.length; i++)items[i].body.velocity.set(x + i * step, y + i * step);
                        return this;
                    },
                    /**
     * Sets the horizontal velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocityX
     * @since 3.0.0
     *
     * @param {number} value - The velocity value.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (x), the second (x + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocityX: function(value, step) {
                        if (step === undefined) step = 0;
                        var items = this.getChildren();
                        for(var i = 0; i < items.length; i++)items[i].body.velocity.x = value + i * step;
                        return this;
                    },
                    /**
     * Sets the vertical velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocityY
     * @since 3.0.0
     *
     * @param {number} value - The velocity value.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (y), the second (y + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocityY: function(value, step) {
                        if (step === undefined) step = 0;
                        var items = this.getChildren();
                        for(var i = 0; i < items.length; i++)items[i].body.velocity.y = value + i * step;
                        return this;
                    }
                });
                module1.exports = PhysicsGroup;
            /***/ },
            /***/ 3017: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var body1;
                var body2;
                var body1Pushable;
                var body2Pushable;
                var body1MassImpact;
                var body2MassImpact;
                var body1FullImpact;
                var body2FullImpact;
                var body1MovingLeft;
                var body1MovingRight;
                var body1Stationary;
                var body2MovingLeft;
                var body2MovingRight;
                var body2Stationary;
                var body1OnLeft;
                var body2OnLeft;
                var overlap;
                /**
 * Sets all of the local processing values and calculates the velocity exchanges.
 *
 * Then runs `BlockCheck` and returns the value from it.
 *
 * This method is called by `Phaser.Physics.Arcade.SeparateX` and should not be
 * called directly.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Set
 * @ignore
 * @since 3.50.0
 *
 * @param {Phaser.Physics.Arcade.Body} b1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} b2 - The second Body to separate.
 * @param {number} ov - The overlap value.
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var Set = function(b1, b2, ov) {
                    body1 = b1;
                    body2 = b2;
                    var v1 = body1.velocity.x;
                    var v2 = body2.velocity.x;
                    body1Pushable = body1.pushable;
                    body1MovingLeft = body1._dx < 0;
                    body1MovingRight = body1._dx > 0;
                    body1Stationary = body1._dx === 0;
                    body1OnLeft = Math.abs(body1.right - body2.x) <= Math.abs(body2.right - body1.x);
                    body1FullImpact = v2 - v1 * body1.bounce.x;
                    body2Pushable = body2.pushable;
                    body2MovingLeft = body2._dx < 0;
                    body2MovingRight = body2._dx > 0;
                    body2Stationary = body2._dx === 0;
                    body2OnLeft = !body1OnLeft;
                    body2FullImpact = v1 - v2 * body2.bounce.x;
                    //  negative delta = up, positive delta = down (inc. gravity)
                    overlap = Math.abs(ov);
                    return BlockCheck();
                };
                /**
 * Blocked Direction checks, because it doesn't matter if an object can be pushed
 * or not, blocked is blocked.
 *
 * @function Phaser.Physics.Arcade.ProcessX.BlockCheck
 * @ignore
 * @since 3.50.0
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var BlockCheck = function() {
                    //  Body1 is moving right and Body2 is blocked from going right any further
                    if (body1MovingRight && body1OnLeft && body2.blocked.right) {
                        body1.processX(-overlap, body1FullImpact, false, true);
                        return 1;
                    }
                    //  Body1 is moving left and Body2 is blocked from going left any further
                    if (body1MovingLeft && body2OnLeft && body2.blocked.left) {
                        body1.processX(overlap, body1FullImpact, true);
                        return 1;
                    }
                    //  Body2 is moving right and Body1 is blocked from going right any further
                    if (body2MovingRight && body2OnLeft && body1.blocked.right) {
                        body2.processX(-overlap, body2FullImpact, false, true);
                        return 2;
                    }
                    //  Body2 is moving left and Body1 is blocked from going left any further
                    if (body2MovingLeft && body1OnLeft && body1.blocked.left) {
                        body2.processX(overlap, body2FullImpact, true);
                        return 2;
                    }
                    return 0;
                };
                /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Check
 * @ignore
 * @since 3.50.0
 *
 * @return {boolean} `true` if a check passed, otherwise `false`.
 */ var Check = function() {
                    var v1 = body1.velocity.x;
                    var v2 = body2.velocity.x;
                    var nv1 = Math.sqrt(v2 * v2 * body2.mass / body1.mass) * (v2 > 0 ? 1 : -1);
                    var nv2 = Math.sqrt(v1 * v1 * body1.mass / body2.mass) * (v1 > 0 ? 1 : -1);
                    var avg = (nv1 + nv2) * 0.5;
                    nv1 -= avg;
                    nv2 -= avg;
                    body1MassImpact = avg + nv1 * body1.bounce.x;
                    body2MassImpact = avg + nv2 * body2.bounce.x;
                    //  Body1 hits Body2 on the right hand side
                    if (body1MovingLeft && body2OnLeft) return Run(0);
                    //  Body2 hits Body1 on the right hand side
                    if (body2MovingLeft && body1OnLeft) return Run(1);
                    //  Body1 hits Body2 on the left hand side
                    if (body1MovingRight && body1OnLeft) return Run(2);
                    //  Body2 hits Body1 on the left hand side
                    if (body2MovingRight && body2OnLeft) return Run(3);
                    return false;
                };
                /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Run
 * @ignore
 * @since 3.50.0
 *
 * @param {number} side - The side to test. As passed in by the `Check` function.
 *
 * @return {boolean} Always returns `true`.
 */ var Run = function(side) {
                    if (body1Pushable && body2Pushable) {
                        //  Both pushable, or both moving at the same time, so equal rebound
                        overlap *= 0.5;
                        if (side === 0 || side === 3) {
                            //  body1MovingLeft && body2OnLeft
                            //  body2MovingRight && body2OnLeft
                            body1.processX(overlap, body1MassImpact);
                            body2.processX(-overlap, body2MassImpact);
                        } else {
                            //  body2MovingLeft && body1OnLeft
                            //  body1MovingRight && body1OnLeft
                            body1.processX(-overlap, body1MassImpact);
                            body2.processX(overlap, body2MassImpact);
                        }
                    } else if (body1Pushable && !body2Pushable) {
                        //  Body1 pushable, Body2 not
                        if (side === 0 || side === 3) //  body1MovingLeft && body2OnLeft
                        //  body2MovingRight && body2OnLeft
                        body1.processX(overlap, body1FullImpact, true);
                        else //  body2MovingLeft && body1OnLeft
                        //  body1MovingRight && body1OnLeft
                        body1.processX(-overlap, body1FullImpact, false, true);
                    } else if (!body1Pushable && body2Pushable) {
                        //  Body2 pushable, Body1 not
                        if (side === 0 || side === 3) //  body1MovingLeft && body2OnLeft
                        //  body2MovingRight && body2OnLeft
                        body2.processX(-overlap, body2FullImpact, false, true);
                        else //  body2MovingLeft && body1OnLeft
                        //  body1MovingRight && body1OnLeft
                        body2.processX(overlap, body2FullImpact, true);
                    } else {
                        //  Neither body is pushable, so base it on movement
                        var halfOverlap = overlap * 0.5;
                        if (side === 0) {
                            //  body1MovingLeft && body2OnLeft
                            if (body2Stationary) {
                                body1.processX(overlap, 0, true);
                                body2.processX(0, null, false, true);
                            } else if (body2MovingRight) {
                                body1.processX(halfOverlap, 0, true);
                                body2.processX(-halfOverlap, 0, false, true);
                            } else {
                                //  Body2 moving same direction as Body1
                                body1.processX(halfOverlap, body2.velocity.x, true);
                                body2.processX(-halfOverlap, null, false, true);
                            }
                        } else if (side === 1) {
                            //  body2MovingLeft && body1OnLeft
                            if (body1Stationary) {
                                body1.processX(0, null, false, true);
                                body2.processX(overlap, 0, true);
                            } else if (body1MovingRight) {
                                body1.processX(-halfOverlap, 0, false, true);
                                body2.processX(halfOverlap, 0, true);
                            } else {
                                //  Body1 moving same direction as Body2
                                body1.processX(-halfOverlap, null, false, true);
                                body2.processX(halfOverlap, body1.velocity.x, true);
                            }
                        } else if (side === 2) {
                            //  body1MovingRight && body1OnLeft
                            if (body2Stationary) {
                                body1.processX(-overlap, 0, false, true);
                                body2.processX(0, null, true);
                            } else if (body2MovingLeft) {
                                body1.processX(-halfOverlap, 0, false, true);
                                body2.processX(halfOverlap, 0, true);
                            } else {
                                //  Body2 moving same direction as Body1
                                body1.processX(-halfOverlap, body2.velocity.x, false, true);
                                body2.processX(halfOverlap, null, true);
                            }
                        } else if (side === 3) {
                            //  body2MovingRight && body2OnLeft
                            if (body1Stationary) {
                                body1.processX(0, null, true);
                                body2.processX(-overlap, 0, false, true);
                            } else if (body1MovingLeft) {
                                body1.processX(halfOverlap, 0, true);
                                body2.processX(-halfOverlap, 0, false, true);
                            } else {
                                //  Body1 moving same direction as Body2
                                body1.processX(halfOverlap, body2.velocity.y, true);
                                body2.processX(-halfOverlap, null, false, true);
                            }
                        }
                    }
                    return true;
                };
                /**
 * This function is run when Body1 is Immovable and Body2 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessX.RunImmovableBody1
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody1 = function(blockedState) {
                    if (blockedState === 1) //  But Body2 cannot go anywhere either, so we cancel out velocity
                    //  Separation happened in the block check
                    body2.velocity.x = 0;
                    else if (body1OnLeft) body2.processX(overlap, body2FullImpact, true);
                    else body2.processX(-overlap, body2FullImpact, false, true);
                    //  This is special case code that handles things like vertically moving platforms you can ride
                    if (body1.moves) {
                        var body1Distance = body1.directControl ? body1.y - body1.autoFrame.y : body1.y - body1.prev.y;
                        body2.y += body1Distance * body1.friction.y;
                        body2._dy = body2.y - body2.prev.y;
                    }
                };
                /**
 * This function is run when Body2 is Immovable and Body1 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessX.RunImmovableBody2
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody2 = function(blockedState) {
                    if (blockedState === 2) //  But Body1 cannot go anywhere either, so we cancel out velocity
                    //  Separation happened in the block check
                    body1.velocity.x = 0;
                    else if (body2OnLeft) body1.processX(overlap, body1FullImpact, true);
                    else body1.processX(-overlap, body1FullImpact, false, true);
                    //  This is special case code that handles things like vertically moving platforms you can ride
                    if (body2.moves) {
                        var body2Distance = body2.directControl ? body2.y - body2.autoFrame.y : body2.y - body2.prev.y;
                        body1.y += body2Distance * body2.friction.y;
                        body1._dy = body1.y - body1.prev.y;
                    }
                };
                /**
 * @namespace Phaser.Physics.Arcade.ProcessX
 * @ignore
 */ module1.exports = {
                    BlockCheck: BlockCheck,
                    Check: Check,
                    Set: Set,
                    Run: Run,
                    RunImmovableBody1: RunImmovableBody1,
                    RunImmovableBody2: RunImmovableBody2
                };
            /***/ },
            /***/ 47962: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var body1;
                var body2;
                var body1Pushable;
                var body2Pushable;
                var body1MassImpact;
                var body2MassImpact;
                var body1FullImpact;
                var body2FullImpact;
                var body1MovingUp;
                var body1MovingDown;
                var body1Stationary;
                var body2MovingUp;
                var body2MovingDown;
                var body2Stationary;
                var body1OnTop;
                var body2OnTop;
                var overlap;
                /**
 * Sets all of the local processing values and calculates the velocity exchanges.
 *
 * Then runs `BlockCheck` and returns the value from it.
 *
 * This method is called by `Phaser.Physics.Arcade.SeparateY` and should not be
 * called directly.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Set
 * @ignore
 * @since 3.50.0
 *
 * @param {Phaser.Physics.Arcade.Body} b1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} b2 - The second Body to separate.
 * @param {number} ov - The overlap value.
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var Set = function(b1, b2, ov) {
                    body1 = b1;
                    body2 = b2;
                    var v1 = body1.velocity.y;
                    var v2 = body2.velocity.y;
                    body1Pushable = body1.pushable;
                    body1MovingUp = body1._dy < 0;
                    body1MovingDown = body1._dy > 0;
                    body1Stationary = body1._dy === 0;
                    body1OnTop = Math.abs(body1.bottom - body2.y) <= Math.abs(body2.bottom - body1.y);
                    body1FullImpact = v2 - v1 * body1.bounce.y;
                    body2Pushable = body2.pushable;
                    body2MovingUp = body2._dy < 0;
                    body2MovingDown = body2._dy > 0;
                    body2Stationary = body2._dy === 0;
                    body2OnTop = !body1OnTop;
                    body2FullImpact = v1 - v2 * body2.bounce.y;
                    //  negative delta = up, positive delta = down (inc. gravity)
                    overlap = Math.abs(ov);
                    return BlockCheck();
                };
                /**
 * Blocked Direction checks, because it doesn't matter if an object can be pushed
 * or not, blocked is blocked.
 *
 * @function Phaser.Physics.Arcade.ProcessY.BlockCheck
 * @ignore
 * @since 3.50.0
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var BlockCheck = function() {
                    //  Body1 is moving down and Body2 is blocked from going down any further
                    if (body1MovingDown && body1OnTop && body2.blocked.down) {
                        body1.processY(-overlap, body1FullImpact, false, true);
                        return 1;
                    }
                    //  Body1 is moving up and Body2 is blocked from going up any further
                    if (body1MovingUp && body2OnTop && body2.blocked.up) {
                        body1.processY(overlap, body1FullImpact, true);
                        return 1;
                    }
                    //  Body2 is moving down and Body1 is blocked from going down any further
                    if (body2MovingDown && body2OnTop && body1.blocked.down) {
                        body2.processY(-overlap, body2FullImpact, false, true);
                        return 2;
                    }
                    //  Body2 is moving up and Body1 is blocked from going up any further
                    if (body2MovingUp && body1OnTop && body1.blocked.up) {
                        body2.processY(overlap, body2FullImpact, true);
                        return 2;
                    }
                    return 0;
                };
                /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Check
 * @ignore
 * @since 3.50.0
 *
 * @return {boolean} `true` if a check passed, otherwise `false`.
 */ var Check = function() {
                    var v1 = body1.velocity.y;
                    var v2 = body2.velocity.y;
                    var nv1 = Math.sqrt(v2 * v2 * body2.mass / body1.mass) * (v2 > 0 ? 1 : -1);
                    var nv2 = Math.sqrt(v1 * v1 * body1.mass / body2.mass) * (v1 > 0 ? 1 : -1);
                    var avg = (nv1 + nv2) * 0.5;
                    nv1 -= avg;
                    nv2 -= avg;
                    body1MassImpact = avg + nv1 * body1.bounce.y;
                    body2MassImpact = avg + nv2 * body2.bounce.y;
                    //  Body1 hits Body2 on the bottom side
                    if (body1MovingUp && body2OnTop) return Run(0);
                    //  Body2 hits Body1 on the bottom side
                    if (body2MovingUp && body1OnTop) return Run(1);
                    //  Body1 hits Body2 on the top side
                    if (body1MovingDown && body1OnTop) return Run(2);
                    //  Body2 hits Body1 on the top side
                    if (body2MovingDown && body2OnTop) return Run(3);
                    return false;
                };
                /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Run
 * @ignore
 * @since 3.50.0
 *
 * @param {number} side - The side to test. As passed in by the `Check` function.
 *
 * @return {boolean} Always returns `true`.
 */ var Run = function(side) {
                    if (body1Pushable && body2Pushable) {
                        //  Both pushable, or both moving at the same time, so equal rebound
                        overlap *= 0.5;
                        if (side === 0 || side === 3) {
                            //  body1MovingUp && body2OnTop
                            //  body2MovingDown && body2OnTop
                            body1.processY(overlap, body1MassImpact);
                            body2.processY(-overlap, body2MassImpact);
                        } else {
                            //  body2MovingUp && body1OnTop
                            //  body1MovingDown && body1OnTop
                            body1.processY(-overlap, body1MassImpact);
                            body2.processY(overlap, body2MassImpact);
                        }
                    } else if (body1Pushable && !body2Pushable) {
                        //  Body1 pushable, Body2 not
                        if (side === 0 || side === 3) //  body1MovingUp && body2OnTop
                        //  body2MovingDown && body2OnTop
                        body1.processY(overlap, body1FullImpact, true);
                        else //  body2MovingUp && body1OnTop
                        //  body1MovingDown && body1OnTop
                        body1.processY(-overlap, body1FullImpact, false, true);
                    } else if (!body1Pushable && body2Pushable) {
                        //  Body2 pushable, Body1 not
                        if (side === 0 || side === 3) //  body1MovingUp && body2OnTop
                        //  body2MovingDown && body2OnTop
                        body2.processY(-overlap, body2FullImpact, false, true);
                        else //  body2MovingUp && body1OnTop
                        //  body1MovingDown && body1OnTop
                        body2.processY(overlap, body2FullImpact, true);
                    } else {
                        //  Neither body is pushable, so base it on movement
                        var halfOverlap = overlap * 0.5;
                        if (side === 0) {
                            //  body1MovingUp && body2OnTop
                            if (body2Stationary) {
                                body1.processY(overlap, 0, true);
                                body2.processY(0, null, false, true);
                            } else if (body2MovingDown) {
                                body1.processY(halfOverlap, 0, true);
                                body2.processY(-halfOverlap, 0, false, true);
                            } else {
                                //  Body2 moving same direction as Body1
                                body1.processY(halfOverlap, body2.velocity.y, true);
                                body2.processY(-halfOverlap, null, false, true);
                            }
                        } else if (side === 1) {
                            //  body2MovingUp && body1OnTop
                            if (body1Stationary) {
                                body1.processY(0, null, false, true);
                                body2.processY(overlap, 0, true);
                            } else if (body1MovingDown) {
                                body1.processY(-halfOverlap, 0, false, true);
                                body2.processY(halfOverlap, 0, true);
                            } else {
                                //  Body1 moving same direction as Body2
                                body1.processY(-halfOverlap, null, false, true);
                                body2.processY(halfOverlap, body1.velocity.y, true);
                            }
                        } else if (side === 2) {
                            //  body1MovingDown && body1OnTop
                            if (body2Stationary) {
                                body1.processY(-overlap, 0, false, true);
                                body2.processY(0, null, true);
                            } else if (body2MovingUp) {
                                body1.processY(-halfOverlap, 0, false, true);
                                body2.processY(halfOverlap, 0, true);
                            } else {
                                //  Body2 moving same direction as Body1
                                body1.processY(-halfOverlap, body2.velocity.y, false, true);
                                body2.processY(halfOverlap, null, true);
                            }
                        } else if (side === 3) {
                            //  body2MovingDown && body2OnTop
                            if (body1Stationary) {
                                body1.processY(0, null, true);
                                body2.processY(-overlap, 0, false, true);
                            } else if (body1MovingUp) {
                                body1.processY(halfOverlap, 0, true);
                                body2.processY(-halfOverlap, 0, false, true);
                            } else {
                                //  Body1 moving same direction as Body2
                                body1.processY(halfOverlap, body2.velocity.y, true);
                                body2.processY(-halfOverlap, null, false, true);
                            }
                        }
                    }
                    return true;
                };
                /**
 * This function is run when Body1 is Immovable and Body2 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessY.RunImmovableBody1
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody1 = function(blockedState) {
                    if (blockedState === 1) //  But Body2 cannot go anywhere either, so we cancel out velocity
                    //  Separation happened in the block check
                    body2.velocity.y = 0;
                    else if (body1OnTop) body2.processY(overlap, body2FullImpact, true);
                    else body2.processY(-overlap, body2FullImpact, false, true);
                    //  This is special case code that handles things like horizontally moving platforms you can ride
                    if (body1.moves) {
                        var body1Distance = body1.directControl ? body1.x - body1.autoFrame.x : body1.x - body1.prev.x;
                        body2.x += body1Distance * body1.friction.x;
                        body2._dx = body2.x - body2.prev.x;
                    }
                };
                /**
 * This function is run when Body2 is Immovable and Body1 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessY.RunImmovableBody2
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody2 = function(blockedState) {
                    if (blockedState === 2) //  But Body1 cannot go anywhere either, so we cancel out velocity
                    //  Separation happened in the block check
                    body1.velocity.y = 0;
                    else if (body2OnTop) body1.processY(overlap, body1FullImpact, true);
                    else body1.processY(-overlap, body1FullImpact, false, true);
                    //  This is special case code that handles things like horizontally moving platforms you can ride
                    if (body2.moves) {
                        var body2Distance = body2.directControl ? body2.x - body2.autoFrame.x : body2.x - body2.prev.x;
                        body1.x += body2Distance * body2.friction.x;
                        body1._dx = body1.x - body1.prev.x;
                    }
                };
                /**
 * @namespace Phaser.Physics.Arcade.ProcessY
 * @ignore
 */ module1.exports = {
                    BlockCheck: BlockCheck,
                    Check: Check,
                    Set: Set,
                    Run: Run,
                    RunImmovableBody1: RunImmovableBody1,
                    RunImmovableBody2: RunImmovableBody2
                };
            /***/ },
            /***/ 14087: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetOverlapX = __webpack_require__(64897);
                var ProcessX = __webpack_require__(3017);
                /**
 * Separates two overlapping bodies on the X-axis (horizontally).
 *
 * Separation involves moving two overlapping bodies so they don't overlap anymore and adjusting their velocities based on their mass. This is a core part of collision detection.
 *
 * The bodies won't be separated if there is no horizontal overlap between them, if they are static, or if either one uses custom logic for its separation.
 *
 * @function Phaser.Physics.Arcade.SeparateX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - If `true`, the bodies will only have their overlap data set and no separation will take place.
 * @param {number} bias - A value to add to the delta value during overlap checking. Used to prevent sprite tunneling.
 * @param {number} [overlap] - If given then this value will be used as the overlap and no check will be run.
 *
 * @return {boolean} `true` if the two bodies overlap vertically, otherwise `false`.
 */ var SeparateX = function(body1, body2, overlapOnly, bias, overlap) {
                    if (overlap === undefined) overlap = GetOverlapX(body1, body2, overlapOnly, bias);
                    var body1Immovable = body1.immovable;
                    var body2Immovable = body2.immovable;
                    //  Can't separate two immovable bodies, or a body with its own custom separation logic
                    if (overlapOnly || overlap === 0 || body1Immovable && body2Immovable || body1.customSeparateX || body2.customSeparateX) //  return true if there was some overlap, otherwise false
                    return overlap !== 0 || body1.embedded && body2.embedded;
                    var blockedState = ProcessX.Set(body1, body2, overlap);
                    if (!body1Immovable && !body2Immovable) {
                        if (blockedState > 0) return true;
                        return ProcessX.Check();
                    } else if (body1Immovable) ProcessX.RunImmovableBody1(blockedState);
                    else if (body2Immovable) ProcessX.RunImmovableBody2(blockedState);
                    //  If we got this far then there WAS overlap, and separation is complete, so return true
                    return true;
                };
                module1.exports = SeparateX;
            /***/ },
            /***/ 89936: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetOverlapY = __webpack_require__(45170);
                var ProcessY = __webpack_require__(47962);
                /**
 * Separates two overlapping bodies on the Y-axis (vertically).
 *
 * Separation involves moving two overlapping bodies so they don't overlap anymore and adjusting their velocities based on their mass. This is a core part of collision detection.
 *
 * The bodies won't be separated if there is no vertical overlap between them, if they are static, or if either one uses custom logic for its separation.
 *
 * @function Phaser.Physics.Arcade.SeparateY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - If `true`, the bodies will only have their overlap data set and no separation will take place.
 * @param {number} bias - A value to add to the delta value during overlap checking. Used to prevent sprite tunneling.
 * @param {number} [overlap] - If given then this value will be used as the overlap and no check will be run.
 *
 * @return {boolean} `true` if the two bodies overlap vertically, otherwise `false`.
 */ var SeparateY = function(body1, body2, overlapOnly, bias, overlap) {
                    if (overlap === undefined) overlap = GetOverlapY(body1, body2, overlapOnly, bias);
                    var body1Immovable = body1.immovable;
                    var body2Immovable = body2.immovable;
                    //  Can't separate two immovable bodies, or a body with its own custom separation logic
                    if (overlapOnly || overlap === 0 || body1Immovable && body2Immovable || body1.customSeparateY || body2.customSeparateY) //  return true if there was some overlap, otherwise false
                    return overlap !== 0 || body1.embedded && body2.embedded;
                    var blockedState = ProcessY.Set(body1, body2, overlap);
                    if (!body1Immovable && !body2Immovable) {
                        if (blockedState > 0) return true;
                        return ProcessY.Check();
                    } else if (body1Immovable) ProcessY.RunImmovableBody1(blockedState);
                    else if (body2Immovable) ProcessY.RunImmovableBody2(blockedState);
                    //  If we got this far then there WAS overlap, and separation is complete, so return true
                    return true;
                };
                module1.exports = SeparateY;
            /***/ },
            /***/ 95829: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Either sets or creates the Arcade Body Collision object.
 *
 * Mostly only used internally.
 *
 * @function Phaser.Physics.Arcade.SetCollisionObject
 * @since 3.70.0
 *
 * @param {boolean} noneFlip - Is `none` true or false?
 * @param {Phaser.Types.Physics.Arcade.ArcadeBodyCollision} [data] - The collision data object to populate, or create if not given.
 *
 * @return {Phaser.Types.Physics.Arcade.ArcadeBodyCollision} The collision data.
 */ var SetCollisionObject = function(noneFlip, data) {
                    if (data === undefined) data = {};
                    data.none = noneFlip;
                    data.up = false;
                    data.down = false;
                    data.left = false;
                    data.right = false;
                    if (!noneFlip) {
                        data.up = true;
                        data.down = true;
                        data.left = true;
                        data.right = true;
                    }
                    return data;
                };
                module1.exports = SetCollisionObject;
            /***/ },
            /***/ 72624: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircleContains = __webpack_require__(87902);
                var Class = __webpack_require__(83419);
                var CollisionComponent = __webpack_require__(78389);
                var CONST = __webpack_require__(37747);
                var RectangleContains = __webpack_require__(37303);
                var SetCollisionObject = __webpack_require__(95829);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Static Arcade Physics Body.
 *
 * A Static Body never moves, and isn't automatically synchronized with its parent Game Object.
 * That means if you make any change to the parent's origin, position, or scale after creating or adding the body, you'll need to update the Static Body manually.
 *
 * A Static Body can collide with other Bodies, but is never moved by collisions.
 *
 * Its dynamic counterpart is {@link Phaser.Physics.Arcade.Body}.
 *
 * @class StaticBody
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Collision
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics simulation this Static Body belongs to.
 * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object this Body belongs to. As of Phaser 3.60 this is now optional.
 */ var StaticBody = new Class({
                    Mixins: [
                        CollisionComponent
                    ],
                    initialize: function StaticBody(world, gameObject) {
                        var width = 64;
                        var height = 64;
                        var dummyGameObject = {
                            x: 0,
                            y: 0,
                            angle: 0,
                            rotation: 0,
                            scaleX: 1,
                            scaleY: 1,
                            displayOriginX: 0,
                            displayOriginY: 0
                        };
                        var hasGameObject = gameObject !== undefined;
                        if (hasGameObject && gameObject.displayWidth) {
                            width = gameObject.displayWidth;
                            height = gameObject.displayHeight;
                        }
                        if (!hasGameObject) gameObject = dummyGameObject;
                        /**
         * The Arcade Physics simulation this Static Body belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticBody#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * The Game Object this Static Body belongs to.
         *
         * As of Phaser 3.60 this is now optional and can be undefined.
         *
         * @name Phaser.Physics.Arcade.StaticBody#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.gameObject = hasGameObject ? gameObject : undefined;
                        /**
         * A quick-test flag that signifies this is a Body, used in the World collision handler.
         *
         * @name Phaser.Physics.Arcade.StaticBody#isBody
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isBody = true;
                        /**
         * Whether the Static Body's boundary is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.StaticBody#debugShowBody
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowBody = world.defaults.debugShowStaticBody;
                        /**
         * The color of this Static Body on the debug display.
         *
         * @name Phaser.Physics.Arcade.StaticBody#debugBodyColor
         * @type {number}
         * @since 3.0.0
         */ this.debugBodyColor = world.defaults.staticBodyDebugColor;
                        /**
         * Whether this Static Body is updated by the physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#enable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enable = true;
                        /**
         * Whether this Static Body's boundary is circular (`true`) or rectangular (`false`).
         *
         * @name Phaser.Physics.Arcade.StaticBody#isCircle
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isCircle = false;
                        /**
         * If this Static Body is circular, this is the radius of the boundary, as set by {@link Phaser.Physics.Arcade.StaticBody#setCircle}, in pixels.
         * Equal to `halfWidth`.
         *
         * @name Phaser.Physics.Arcade.StaticBody#radius
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.radius = 0;
                        /**
         * The offset set by {@link Phaser.Physics.Arcade.StaticBody#setCircle} or {@link Phaser.Physics.Arcade.StaticBody#setSize}.
         *
         * This doesn't affect the Static Body's position, because a Static Body does not follow its Game Object.
         *
         * @name Phaser.Physics.Arcade.StaticBody#offset
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.offset = new Vector2();
                        /**
         * The position of this Static Body within the simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2(gameObject.x - width * gameObject.originX, gameObject.y - height * gameObject.originY);
                        /**
         * The width of the Static Body's boundary, in pixels.
         * If the Static Body is circular, this is also the Static Body's diameter.
         *
         * @name Phaser.Physics.Arcade.StaticBody#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                        /**
         * The height of the Static Body's boundary, in pixels.
         * If the Static Body is circular, this is also the Static Body's diameter.
         *
         * @name Phaser.Physics.Arcade.StaticBody#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                        /**
         * Half the Static Body's width, in pixels.
         * If the Static Body is circular, this is also the Static Body's radius.
         *
         * @name Phaser.Physics.Arcade.StaticBody#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth = Math.abs(this.width / 2);
                        /**
         * Half the Static Body's height, in pixels.
         * If the Static Body is circular, this is also the Static Body's radius.
         *
         * @name Phaser.Physics.Arcade.StaticBody#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight = Math.abs(this.height / 2);
                        /**
         * The center of the Static Body's boundary.
         * This is the midpoint of its `position` (top-left corner) and its bottom-right corner.
         *
         * @name Phaser.Physics.Arcade.StaticBody#center
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.center = new Vector2(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                        /**
         * A constant zero velocity used by the Arcade Physics simulation for calculations.
         *
         * @name Phaser.Physics.Arcade.StaticBody#velocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.velocity = Vector2.ZERO;
                        /**
         * A constant `false` value expected by the Arcade Physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#allowGravity
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.allowGravity = false;
                        /**
         * Gravitational force applied specifically to this Body. Values are in pixels per second squared. Always zero for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#gravity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.gravity = Vector2.ZERO;
                        /**
         * Rebound, or restitution, following a collision, relative to 1. Always zero for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#bounce
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.bounce = Vector2.ZERO;
                        //  If true this Body will dispatch events
                        /**
         * Whether the simulation emits a `worldbounds` event when this StaticBody collides with the world boundary.
         * Always false for a Static Body. (Static Bodies never collide with the world boundary and never trigger a `worldbounds` event.)
         *
         * @name Phaser.Physics.Arcade.StaticBody#onWorldBounds
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.onWorldBounds = false;
                        /**
         * Whether the simulation emits a `collide` event when this StaticBody collides with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#onCollide
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.onCollide = false;
                        /**
         * Whether the simulation emits an `overlap` event when this StaticBody overlaps with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#onOverlap
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.onOverlap = false;
                        /**
         * The StaticBody's inertia, relative to a default unit (1). With `bounce`, this affects the exchange of momentum (velocities) during collisions.
         *
         * @name Phaser.Physics.Arcade.StaticBody#mass
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.mass = 1;
                        /**
         * Whether this object can be moved by collisions with another body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#immovable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.immovable = true;
                        /**
         * Sets if this Body can be pushed by another Body.
         *
         * A body that cannot be pushed will reflect back all of the velocity it is given to the
         * colliding body. If that body is also not pushable, then the separation will be split
         * between them evenly.
         *
         * If you want your body to never move or seperate at all, see the `setImmovable` method.
         *
         * By default, Static Bodies are not pushable.
         *
         * @name Phaser.Physics.Arcade.StaticBody#pushable
         * @type {boolean}
         * @default false
         * @since 3.50.0
         * @see Phaser.GameObjects.Components.Pushable#setPushable
         */ this.pushable = false;
                        /**
         * A flag disabling the default horizontal separation of colliding bodies. Pass your own `collideHandler` to the collider.
         *
         * @name Phaser.Physics.Arcade.StaticBody#customSeparateX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateX = false;
                        /**
         * A flag disabling the default vertical separation of colliding bodies. Pass your own `collideHandler` to the collider.
         *
         * @name Phaser.Physics.Arcade.StaticBody#customSeparateY
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateY = false;
                        /**
         * The amount of horizontal overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapX = 0;
                        /**
         * The amount of vertical overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapY = 0;
                        /**
         * The amount of overlap (before separation), if this StaticBody is circular and colliding with another circular body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapR
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapR = 0;
                        /**
         * Whether this StaticBody has ever overlapped with another while both were not moving.
         *
         * @name Phaser.Physics.Arcade.StaticBody#embedded
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.embedded = false;
                        /**
         * Whether this StaticBody interacts with the world boundary.
         * Always false for a Static Body. (Static Bodies never collide with the world boundary.)
         *
         * @name Phaser.Physics.Arcade.StaticBody#collideWorldBounds
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.collideWorldBounds = false;
                        /**
         * Whether this StaticBody is checked for collisions and for which directions. You can set `checkCollision.none = false` to disable collision checks.
         *
         * @name Phaser.Physics.Arcade.StaticBody#checkCollision
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.checkCollision = SetCollisionObject(false);
                        /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         *
         * @name Phaser.Physics.Arcade.StaticBody#touching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.touching = SetCollisionObject(true);
                        /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         * The values are always false for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#wasTouching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.wasTouching = SetCollisionObject(true);
                        /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         *
         * @name Phaser.Physics.Arcade.StaticBody#blocked
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.blocked = SetCollisionObject(true);
                        /**
         * The StaticBody's physics type (static by default).
         *
         * @name Phaser.Physics.Arcade.StaticBody#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.STATIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.STATIC_BODY;
                        /**
         * The Arcade Physics Body Collision Category.
         *
         * This can be set to any valid collision bitfield value.
         *
         * See the `setCollisionCategory` method for more details.
         *
         * @name Phaser.Physics.Arcade.StaticBody#collisionCategory
         * @type {number}
         * @since 3.70.0
         */ this.collisionCategory = 0x0001;
                        /**
         * The Arcade Physics Body Collision Mask.
         *
         * See the `setCollidesWith` method for more details.
         *
         * @name Phaser.Physics.Arcade.StaticBody#collisionMask
         * @type {number}
         * @since 3.70.0
         */ this.collisionMask = 1;
                        /**
         * The calculated change in the Static Body's horizontal position during the current step.
         * For a static body this is always zero.
         *
         * @name Phaser.Physics.Arcade.StaticBody#_dx
         * @type {number}
         * @private
         * @default 0
         * @since 3.10.0
         */ this._dx = 0;
                        /**
         * The calculated change in the Static Body's vertical position during the current step.
         * For a static body this is always zero.
         *
         * @name Phaser.Physics.Arcade.StaticBody#_dy
         * @type {number}
         * @private
         * @default 0
         * @since 3.10.0
         */ this._dy = 0;
                    },
                    /**
     * Changes the Game Object this Body is bound to.
     * 
     * First it removes its reference from the old Game Object, then sets the new one.
     * 
     * This body will be resized to match the frame dimensions of the given Game Object, if it has a texture frame.
     * You can optionally update the position and dimensions of this Body to reflect that of the new Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setGameObject
     * @since 3.1.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to assign this Body to.
     * @param {boolean} [update=true] - Reposition and resize this Body to match the new Game Object?
     * @param {boolean} [enable=true] - Automatically enable this Body for physics.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     *
     * @see Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     */ setGameObject: function(gameObject, update, enable) {
                        if (update === undefined) update = true;
                        if (enable === undefined) enable = true;
                        if (!gameObject || !gameObject.hasTransformComponent) //  We need a valid Game Object to continue
                        return this;
                        var world = this.world;
                        if (this.gameObject && this.gameObject.body) {
                            world.disable(this.gameObject);
                            //  Disconnect the current Game Object
                            this.gameObject.body = null;
                        }
                        if (gameObject.body) //  Remove the body from the world, but don't disable the Game Object
                        world.disable(gameObject);
                        this.gameObject = gameObject;
                        gameObject.body = this;
                        //  This will remove the body from the tree, if it's in there and add the new one in
                        this.setSize();
                        if (update) this.updateFromGameObject();
                        this.enable = enable;
                        return this;
                    },
                    /**
     * Syncs the Static Body's position and size with its parent Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     * @since 3.1.0
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ updateFromGameObject: function() {
                        this.world.staticTree.remove(this);
                        var gameObject = this.gameObject;
                        gameObject.getTopLeft(this.position);
                        this.width = gameObject.displayWidth;
                        this.height = gameObject.displayHeight;
                        this.halfWidth = Math.abs(this.width / 2);
                        this.halfHeight = Math.abs(this.height / 2);
                        this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                        this.world.staticTree.insert(this);
                        return this;
                    },
                    /**
     * Positions the Static Body at an offset from its Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setOffset
     * @since 3.4.0
     *
     * @param {number} x - The horizontal offset of the Static Body from the Game Object's `x`.
     * @param {number} y - The vertical offset of the Static Body from the Game Object's `y`.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setOffset: function(x, y) {
                        if (y === undefined) y = x;
                        this.world.staticTree.remove(this);
                        this.position.x -= this.offset.x;
                        this.position.y -= this.offset.y;
                        this.offset.set(x, y);
                        this.position.x += this.offset.x;
                        this.position.y += this.offset.y;
                        this.updateCenter();
                        this.world.staticTree.insert(this);
                        return this;
                    },
                    /**
     * Sets the size of the Static Body.
     * When `center` is true, also repositions it.
     * Resets the width and height to match current frame, if no width and height provided and a frame is found.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setSize
     * @since 3.0.0
     *
     * @param {number} [width] - The width of the Static Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame width.
     * @param {number} [height] - The height of the Static Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame height.
     * @param {boolean} [center=true] - Place the Static Body's center on its Game Object's center. Only works if the Game Object has the `getCenter` method.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setSize: function(width, height, center) {
                        if (center === undefined) center = true;
                        var gameObject = this.gameObject;
                        if (gameObject && gameObject.frame) {
                            if (!width) width = gameObject.frame.realWidth;
                            if (!height) height = gameObject.frame.realHeight;
                        }
                        this.world.staticTree.remove(this);
                        this.width = width;
                        this.height = height;
                        this.halfWidth = Math.floor(width / 2);
                        this.halfHeight = Math.floor(height / 2);
                        if (center && gameObject && gameObject.getCenter) {
                            var ox = gameObject.displayWidth / 2;
                            var oy = gameObject.displayHeight / 2;
                            this.position.x -= this.offset.x;
                            this.position.y -= this.offset.y;
                            this.offset.set(ox - this.halfWidth, oy - this.halfHeight);
                            this.position.x += this.offset.x;
                            this.position.y += this.offset.y;
                        }
                        this.updateCenter();
                        this.isCircle = false;
                        this.radius = 0;
                        this.world.staticTree.insert(this);
                        return this;
                    },
                    /**
     * Sets this Static Body to have a circular body and sets its size and position.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the StaticBody, in pixels.
     * @param {number} [offsetX] - The horizontal offset of the StaticBody from its Game Object, in pixels.
     * @param {number} [offsetY] - The vertical offset of the StaticBody from its Game Object, in pixels.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setCircle: function(radius, offsetX, offsetY) {
                        if (offsetX === undefined) offsetX = this.offset.x;
                        if (offsetY === undefined) offsetY = this.offset.y;
                        if (radius > 0) {
                            this.world.staticTree.remove(this);
                            this.isCircle = true;
                            this.radius = radius;
                            this.width = radius * 2;
                            this.height = radius * 2;
                            this.halfWidth = Math.floor(this.width / 2);
                            this.halfHeight = Math.floor(this.height / 2);
                            this.offset.set(offsetX, offsetY);
                            this.updateCenter();
                            this.world.staticTree.insert(this);
                        } else this.isCircle = false;
                        return this;
                    },
                    /**
     * Updates the StaticBody's `center` from its `position` and dimensions.
     *
     * @method Phaser.Physics.Arcade.StaticBody#updateCenter
     * @since 3.0.0
     */ updateCenter: function() {
                        this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    },
                    /**
     * Resets this Static Body to its parent Game Object's position.
     *
     * If `x` and `y` are given, the parent Game Object is placed there and this Static Body is centered on it.
     * Otherwise this Static Body is centered on the Game Object's current position.
     *
     * @method Phaser.Physics.Arcade.StaticBody#reset
     * @since 3.0.0
     *
     * @param {number} [x] - The x coordinate to reset the body to. If not given will use the parent Game Object's coordinate.
     * @param {number} [y] - The y coordinate to reset the body to. If not given will use the parent Game Object's coordinate.
     */ reset: function(x, y) {
                        var gameObject = this.gameObject;
                        if (x === undefined) x = gameObject.x;
                        if (y === undefined) y = gameObject.y;
                        this.world.staticTree.remove(this);
                        gameObject.setPosition(x, y);
                        gameObject.getTopLeft(this.position);
                        this.position.x += this.offset.x;
                        this.position.y += this.offset.y;
                        this.updateCenter();
                        this.world.staticTree.insert(this);
                    },
                    /**
     * NOOP function. A Static Body cannot be stopped.
     *
     * @method Phaser.Physics.Arcade.StaticBody#stop
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ stop: function() {
                        return this;
                    },
                    /**
     * Returns the x and y coordinates of the top left and bottom right points of the StaticBody.
     *
     * @method Phaser.Physics.Arcade.StaticBody#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} obj - The object which will hold the coordinates of the bounds.
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} The same object that was passed with `x`, `y`, `right` and `bottom` values matching the respective values of the StaticBody.
     */ getBounds: function(obj) {
                        obj.x = this.x;
                        obj.y = this.y;
                        obj.right = this.right;
                        obj.bottom = this.bottom;
                        return obj;
                    },
                    /**
     * Checks to see if a given x,y coordinate is colliding with this Static Body.
     *
     * @method Phaser.Physics.Arcade.StaticBody#hitTest
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check against this body.
     * @param {number} y - The y coordinate to check against this body.
     *
     * @return {boolean} `true` if the given coordinate lies within this body, otherwise `false`.
     */ hitTest: function(x, y) {
                        return this.isCircle ? CircleContains(this, x, y) : RectangleContains(this, x, y);
                    },
                    /**
     * NOOP
     *
     * @method Phaser.Physics.Arcade.StaticBody#postUpdate
     * @since 3.12.0
     */ postUpdate: function() {},
                    /**
     * The absolute (non-negative) change in this StaticBody's horizontal position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsX
     * @since 3.0.0
     *
     * @return {number} Always zero for a Static Body.
     */ deltaAbsX: function() {
                        return 0;
                    },
                    /**
     * The absolute (non-negative) change in this StaticBody's vertical position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsY
     * @since 3.0.0
     *
     * @return {number} Always zero for a Static Body.
     */ deltaAbsY: function() {
                        return 0;
                    },
                    /**
     * The change in this StaticBody's horizontal position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaX
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's velocity from the previous step. Always zero.
     */ deltaX: function() {
                        return 0;
                    },
                    /**
     * The change in this StaticBody's vertical position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaY
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's velocity from the previous step. Always zero.
     */ deltaY: function() {
                        return 0;
                    },
                    /**
     * The change in this StaticBody's rotation from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaZ
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's rotation from the previous step. Always zero.
     */ deltaZ: function() {
                        return 0;
                    },
                    /**
     * Disables this Body and marks it for destruction during the next step.
     *
     * @method Phaser.Physics.Arcade.StaticBody#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.enable = false;
                        this.world.pendingDestroy.set(this);
                    },
                    /**
     * Draws a graphical representation of the StaticBody for visual debugging purposes.
     *
     * @method Phaser.Physics.Arcade.StaticBody#drawDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphic - The Graphics object to use for the debug drawing of the StaticBody.
     */ drawDebug: function(graphic) {
                        var pos = this.position;
                        var x = pos.x + this.halfWidth;
                        var y = pos.y + this.halfHeight;
                        if (this.debugShowBody) {
                            graphic.lineStyle(graphic.defaultStrokeWidth, this.debugBodyColor, 1);
                            if (this.isCircle) graphic.strokeCircle(x, y, this.width / 2);
                            else graphic.strokeRect(pos.x, pos.y, this.width, this.height);
                        }
                    },
                    /**
     * Indicates whether the StaticBody is going to be showing a debug visualization during postUpdate.
     *
     * @method Phaser.Physics.Arcade.StaticBody#willDrawDebug
     * @since 3.0.0
     *
     * @return {boolean} Whether or not the StaticBody is going to show the debug visualization during postUpdate.
     */ willDrawDebug: function() {
                        return this.debugShowBody;
                    },
                    /**
     * Sets the Mass of the StaticBody. Will set the Mass to 0.1 if the value passed is less than or equal to zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setMass
     * @since 3.0.0
     *
     * @param {number} value - The value to set the Mass to. Values of zero or less are changed to 0.1.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setMass: function(value) {
                        if (value <= 0) //  Causes havoc otherwise
                        value = 0.1;
                        this.mass = value;
                        return this;
                    },
                    /**
     * The x coordinate of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this.position.x;
                        },
                        set: function(value) {
                            this.world.staticTree.remove(this);
                            this.position.x = value;
                            this.world.staticTree.insert(this);
                        }
                    },
                    /**
     * The y coordinate of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this.position.y;
                        },
                        set: function(value) {
                            this.world.staticTree.remove(this);
                            this.position.y = value;
                            this.world.staticTree.insert(this);
                        }
                    },
                    /**
     * Returns the left-most x coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#left
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ left: {
                        get: function() {
                            return this.position.x;
                        }
                    },
                    /**
     * The right-most x coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#right
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ right: {
                        get: function() {
                            return this.position.x + this.width;
                        }
                    },
                    /**
     * The highest y coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#top
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ top: {
                        get: function() {
                            return this.position.y;
                        }
                    },
                    /**
     * The lowest y coordinate of the area of the StaticBody. (y + height)
     *
     * @name Phaser.Physics.Arcade.StaticBody#bottom
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ bottom: {
                        get: function() {
                            return this.position.y + this.height;
                        }
                    }
                });
                module1.exports = StaticBody;
            /***/ },
            /***/ 71464: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeSprite = __webpack_require__(13759);
                var Class = __webpack_require__(83419);
                var CollisionComponent = __webpack_require__(78389);
                var CONST = __webpack_require__(37747);
                var GetFastValue = __webpack_require__(95540);
                var Group = __webpack_require__(26479);
                var IsPlainObject = __webpack_require__(41212);
                /**
 * @classdesc
 * An Arcade Physics Static Group object.
 *
 * All Game Objects created by or added to this Group will automatically be given static Arcade Physics bodies, if they have no body.
 *
 * Its dynamic counterpart is {@link Phaser.Physics.Arcade.Group}.
 *
 * @class StaticGroup
 * @extends Phaser.GameObjects.Group
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Collision
 *
 * @param {Phaser.Physics.Arcade.World} world - The physics simulation.
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
 */ var StaticPhysicsGroup = new Class({
                    Extends: Group,
                    Mixins: [
                        CollisionComponent
                    ],
                    initialize: function StaticPhysicsGroup(world, scene, children, config) {
                        if (!children && !config) config = {
                            internalCreateCallback: this.createCallbackHandler,
                            internalRemoveCallback: this.removeCallbackHandler,
                            createMultipleCallback: this.createMultipleCallbackHandler,
                            classType: ArcadeSprite
                        };
                        else if (IsPlainObject(children)) {
                            //  children is a plain object, so swizzle them:
                            config = children;
                            children = null;
                            config.internalCreateCallback = this.createCallbackHandler;
                            config.internalRemoveCallback = this.removeCallbackHandler;
                            config.createMultipleCallback = this.createMultipleCallbackHandler;
                            config.classType = GetFastValue(config, 'classType', ArcadeSprite);
                        } else if (Array.isArray(children) && IsPlainObject(children[0])) {
                            //  children is an array of plain objects
                            config = children;
                            children = null;
                            config.forEach(function(singleConfig) {
                                singleConfig.internalCreateCallback = this.createCallbackHandler;
                                singleConfig.internalRemoveCallback = this.removeCallbackHandler;
                                singleConfig.createMultipleCallback = this.createMultipleCallbackHandler;
                                singleConfig.classType = GetFastValue(singleConfig, 'classType', ArcadeSprite);
                            });
                        } else // config is not defined and children is not a plain object nor an array of plain objects
                        config = {
                            internalCreateCallback: this.createCallbackHandler,
                            internalRemoveCallback: this.removeCallbackHandler
                        };
                        /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * The scene this group belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.STATIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.STATIC_BODY;
                        /**
         * The Arcade Physics Static Group Collision Category.
         *
         * This can be set to any valid collision bitfield value.
         *
         * See the `setCollisionCategory` method for more details.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#collisionCategory
         * @type {number}
         * @since 3.70.0
         */ this.collisionCategory = 0x0001;
                        /**
         * The Arcade Physics Static Group Collision Mask.
         *
         * See the `setCollidesWith` method for more details.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#collisionMask
         * @type {number}
         * @since 3.70.0
         */ this.collisionMask = 1;
                        Group.call(this, scene, children, config);
                        /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#type
         * @type {string}
         * @default 'StaticPhysicsGroup'
         * @since 3.21.0
         */ this.type = 'StaticPhysicsGroup';
                    },
                    /**
     * Adds a static physics body to the new group member (if it lacks one) and adds it to the simulation.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#createCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The new group member.
     *
     * @see Phaser.Physics.Arcade.World#enableBody
     */ createCallbackHandler: function(child) {
                        if (!child.body) this.world.enableBody(child, CONST.STATIC_BODY);
                    },
                    /**
     * Disables the group member's physics body, removing it from the simulation.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#removeCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The group member being removed.
     *
     * @see Phaser.Physics.Arcade.World#disableBody
     */ removeCallbackHandler: function(child) {
                        if (child.body) this.world.disableBody(child);
                    },
                    /**
     * Refreshes the group.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#createMultipleCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} entries - The newly created group members.
     *
     * @see Phaser.Physics.Arcade.StaticGroup#refresh
     */ createMultipleCallbackHandler: function() {
                        this.refresh();
                    },
                    /**
     * Resets each Body to the position of its parent Game Object.
     * Body sizes aren't changed (use {@link Phaser.Physics.Arcade.Components.Enable#refreshBody} for that).
     *
     * @method Phaser.Physics.Arcade.StaticGroup#refresh
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.StaticGroup} This group.
     *
     * @see Phaser.Physics.Arcade.StaticBody#reset
     */ refresh: function() {
                        var children = this.children.entries;
                        for(var i = 0; i < children.length; i++)children[i].body.reset();
                        return this;
                    }
                });
                module1.exports = StaticPhysicsGroup;
            /***/ },
            /***/ 82248: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AngleBetweenPoints = __webpack_require__(55495);
                var Body = __webpack_require__(37742);
                var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Collider = __webpack_require__(79342);
                var CONST = __webpack_require__(37747);
                var DistanceBetween = __webpack_require__(20339);
                var DistanceBetweenPoints = __webpack_require__(52816);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(63012);
                var FuzzyEqual = __webpack_require__(43855);
                var FuzzyGreaterThan = __webpack_require__(5470);
                var FuzzyLessThan = __webpack_require__(94977);
                var GetOverlapX = __webpack_require__(64897);
                var GetOverlapY = __webpack_require__(45170);
                var GetTilesWithinWorldXY = __webpack_require__(96523);
                var GetValue = __webpack_require__(35154);
                var MATH_CONST = __webpack_require__(36383);
                var ProcessQueue = __webpack_require__(25774);
                var ProcessTileCallbacks = __webpack_require__(96602);
                var Rectangle = __webpack_require__(87841);
                var RTree = __webpack_require__(59542);
                var SeparateTile = __webpack_require__(40012);
                var SeparateX = __webpack_require__(14087);
                var SeparateY = __webpack_require__(89936);
                var Set = __webpack_require__(35072);
                var StaticBody = __webpack_require__(72624);
                var TileIntersectsBody = __webpack_require__(2483);
                var TransformMatrix = __webpack_require__(61340);
                var Vector2 = __webpack_require__(26099);
                var Wrap = __webpack_require__(15994);
                /**
 * @classdesc
 * The Arcade Physics World.
 *
 * The World is responsible for creating, managing, colliding and updating all of the bodies within it.
 *
 * An instance of the World belongs to a Phaser.Scene and is accessed via the property `physics.world`.
 *
 * @class World
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this World instance belongs.
 * @param {Phaser.Types.Physics.Arcade.ArcadeWorldConfig} config - An Arcade Physics Configuration object.
 */ var World = new Class({
                    Extends: EventEmitter,
                    initialize: function World(scene, config) {
                        EventEmitter.call(this);
                        /**
         * The Scene this simulation belongs to.
         *
         * @name Phaser.Physics.Arcade.World#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * Dynamic Bodies in this simulation.
         *
         * @name Phaser.Physics.Arcade.World#bodies
         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.Body>}
         * @since 3.0.0
         */ this.bodies = new Set();
                        /**
         * Static Bodies in this simulation.
         *
         * @name Phaser.Physics.Arcade.World#staticBodies
         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.StaticBody>}
         * @since 3.0.0
         */ this.staticBodies = new Set();
                        /**
         * Static Bodies marked for deletion.
         *
         * @name Phaser.Physics.Arcade.World#pendingDestroy
         * @type {Phaser.Structs.Set.<(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)>}
         * @since 3.1.0
         */ this.pendingDestroy = new Set();
                        /**
         * This simulation's collision processors.
         *
         * @name Phaser.Physics.Arcade.World#colliders
         * @type {Phaser.Structs.ProcessQueue.<Phaser.Physics.Arcade.Collider>}
         * @since 3.0.0
         */ this.colliders = new ProcessQueue();
                        /**
         * Acceleration of Bodies due to gravity, in pixels per second.
         *
         * @name Phaser.Physics.Arcade.World#gravity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.gravity = new Vector2(GetValue(config, 'gravity.x', 0), GetValue(config, 'gravity.y', 0));
                        /**
         * A boundary constraining Bodies.
         *
         * @name Phaser.Physics.Arcade.World#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.0.0
         */ this.bounds = new Rectangle(GetValue(config, 'x', 0), GetValue(config, 'y', 0), GetValue(config, 'width', scene.sys.scale.width), GetValue(config, 'height', scene.sys.scale.height));
                        /**
         * The boundary edges that Bodies can collide with.
         *
         * @name Phaser.Physics.Arcade.World#checkCollision
         * @type {Phaser.Types.Physics.Arcade.CheckCollisionObject}
         * @since 3.0.0
         */ this.checkCollision = {
                            up: GetValue(config, 'checkCollision.up', true),
                            down: GetValue(config, 'checkCollision.down', true),
                            left: GetValue(config, 'checkCollision.left', true),
                            right: GetValue(config, 'checkCollision.right', true)
                        };
                        /**
         * The number of physics steps to be taken per second.
         *
         * This property is read-only. Use the `setFPS` method to modify it at run-time.
         *
         * @name Phaser.Physics.Arcade.World#fps
         * @readonly
         * @type {number}
         * @default 60
         * @since 3.10.0
         */ this.fps = GetValue(config, 'fps', 60);
                        /**
         * Should Physics use a fixed update time-step (true) or sync to the render fps (false)?.
         * False value of this property disables fps and timeScale properties.
         *
         * @name Phaser.Physics.Arcade.World#fixedStep
         * @type {boolean}
         * @default true
         * @since 3.23.0
         */ this.fixedStep = GetValue(config, 'fixedStep', true);
                        /**
         * The amount of elapsed ms since the last frame.
         *
         * @name Phaser.Physics.Arcade.World#_elapsed
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._elapsed = 0;
                        /**
         * Internal frame time value.
         *
         * @name Phaser.Physics.Arcade.World#_frameTime
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._frameTime = 1 / this.fps;
                        /**
         * Internal frame time ms value.
         *
         * @name Phaser.Physics.Arcade.World#_frameTimeMS
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._frameTimeMS = 1000 * this._frameTime;
                        /**
         * The number of steps that took place in the last frame.
         *
         * @name Phaser.Physics.Arcade.World#stepsLastFrame
         * @readonly
         * @type {number}
         * @since 3.10.0
         */ this.stepsLastFrame = 0;
                        /**
         * Scaling factor applied to the frame rate.
         *
         * - 1.0 = normal speed
         * - 2.0 = half speed
         * - 0.5 = double speed
         *
         * @name Phaser.Physics.Arcade.World#timeScale
         * @type {number}
         * @default 1
         * @since 3.10.0
         */ this.timeScale = GetValue(config, 'timeScale', 1);
                        /**
         * The maximum absolute difference of a Body's per-step velocity and its overlap with another Body that will result in separation on *each axis*.
         * Larger values favor separation.
         * Smaller values favor no separation.
         *
         * @name Phaser.Physics.Arcade.World#OVERLAP_BIAS
         * @type {number}
         * @default 4
         * @since 3.0.0
         */ this.OVERLAP_BIAS = GetValue(config, 'overlapBias', 4);
                        /**
         * The maximum absolute value of a Body's overlap with a tile that will result in separation on *each axis*.
         * Larger values favor separation.
         * Smaller values favor no separation.
         * The optimum value may be similar to the tile size.
         *
         * @name Phaser.Physics.Arcade.World#TILE_BIAS
         * @type {number}
         * @default 16
         * @since 3.0.0
         */ this.TILE_BIAS = GetValue(config, 'tileBias', 16);
                        /**
         * Always separate overlapping Bodies horizontally before vertically.
         * False (the default) means Bodies are first separated on the axis of greater gravity, or the vertical axis if neither is greater.
         *
         * @name Phaser.Physics.Arcade.World#forceX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.forceX = GetValue(config, 'forceX', false);
                        /**
         * Whether the simulation advances with the game loop.
         *
         * @name Phaser.Physics.Arcade.World#isPaused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isPaused = GetValue(config, 'isPaused', false);
                        /**
         * Temporary total of colliding Bodies.
         *
         * @name Phaser.Physics.Arcade.World#_total
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._total = 0;
                        /**
         * Enables the debug display.
         *
         * @name Phaser.Physics.Arcade.World#drawDebug
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.drawDebug = GetValue(config, 'debug', false);
                        /**
         * The graphics object drawing the debug display.
         *
         * @name Phaser.Physics.Arcade.World#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.debugGraphic;
                        /**
         * Default debug display settings for new Bodies.
         *
         * @name Phaser.Physics.Arcade.World#defaults
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldDefaults}
         * @since 3.0.0
         */ this.defaults = {
                            debugShowBody: GetValue(config, 'debugShowBody', true),
                            debugShowStaticBody: GetValue(config, 'debugShowStaticBody', true),
                            debugShowVelocity: GetValue(config, 'debugShowVelocity', true),
                            bodyDebugColor: GetValue(config, 'debugBodyColor', 0xff00ff),
                            staticBodyDebugColor: GetValue(config, 'debugStaticBodyColor', 0x0000ff),
                            velocityDebugColor: GetValue(config, 'debugVelocityColor', 0x00ff00)
                        };
                        /**
         * The maximum number of items per node on the RTree.
         *
         * This is ignored if `useTree` is `false`. If you have a large number of bodies in
         * your world then you may find search performance improves by increasing this value,
         * to allow more items per node and less node division.
         *
         * @name Phaser.Physics.Arcade.World#maxEntries
         * @type {number}
         * @default 16
         * @since 3.0.0
         */ this.maxEntries = GetValue(config, 'maxEntries', 16);
                        /**
         * Should this Arcade Physics World use an RTree for Dynamic bodies?
         *
         * An RTree is a fast way of spatially sorting of all the bodies in the world.
         * However, at certain limits, the cost of clearing and inserting the bodies into the
         * tree every frame becomes more expensive than the search speed gains it provides.
         *
         * If you have a large number of dynamic bodies in your world then it may be best to
         * disable the use of the RTree by setting this property to `false` in the physics config.
         *
         * The number it can cope with depends on browser and device, but a conservative estimate
         * of around 5,000 bodies should be considered the max before disabling it.
         *
         * This only applies to dynamic bodies. Static bodies are always kept in an RTree,
         * because they don't have to be cleared every frame, so you benefit from the
         * massive search speeds all the time.
         *
         * @name Phaser.Physics.Arcade.World#useTree
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.useTree = GetValue(config, 'useTree', true);
                        /**
         * The spatial index of Dynamic Bodies.
         *
         * @name Phaser.Physics.Arcade.World#tree
         * @type {Phaser.Structs.RTree}
         * @since 3.0.0
         */ this.tree = new RTree(this.maxEntries);
                        /**
         * The spatial index of Static Bodies.
         *
         * @name Phaser.Physics.Arcade.World#staticTree
         * @type {Phaser.Structs.RTree}
         * @since 3.0.0
         */ this.staticTree = new RTree(this.maxEntries);
                        /**
         * Recycled input for tree searches.
         *
         * @name Phaser.Physics.Arcade.World#treeMinMax
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldTreeMinMax}
         * @since 3.0.0
         */ this.treeMinMax = {
                            minX: 0,
                            minY: 0,
                            maxX: 0,
                            maxY: 0
                        };
                        /**
         * A temporary Transform Matrix used by bodies for calculations without them needing their own local copy.
         *
         * @name Phaser.Physics.Arcade.World#_tempMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix = new TransformMatrix();
                        /**
         * A temporary Transform Matrix used by bodies for calculations without them needing their own local copy.
         *
         * @name Phaser.Physics.Arcade.World#_tempMatrix2
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix2 = new TransformMatrix();
                        /**
         * The Filtering Options passed to `GetTilesWithinWorldXY` as part of the `collideSpriteVsTilemapLayer` check.
         *
         * @name Phaser.Physics.Arcade.World#tileFilterOptions
         * @type {Phaser.Types.Tilemaps.FilteringOptions}
         * @since 3.60.0
         */ this.tileFilterOptions = {
                            isColliding: true,
                            isNotEmpty: true,
                            hasInterestingFace: true
                        };
                        if (this.drawDebug) this.createDebugGraphic();
                    },
                    /**
     * Adds an Arcade Physics Body to a Game Object, an array of Game Objects, or the children of a Group.
     *
     * The difference between this and the `enableBody` method is that you can pass arrays or Groups
     * to this method.
     *
     * You can specify if the bodies are to be Dynamic or Static. A dynamic body can move via velocity and
     * acceleration. A static body remains fixed in place and as such is able to use an optimized search
     * tree, making it ideal for static elements such as level objects. You can still collide and overlap
     * with static bodies.
     *
     * Normally, rather than calling this method directly, you'd use the helper methods available in the
     * Arcade Physics Factory, such as:
     *
     * ```javascript
     * this.physics.add.image(x, y, textureKey);
     * this.physics.add.sprite(x, y, textureKey);
     * ```
     *
     * Calling factory methods encapsulates the creation of a Game Object and the creation of its
     * body at the same time. If you are creating custom classes then you can pass them to this
     * method to have their bodies created.
     *
     * @method Phaser.Physics.Arcade.World#enable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object - The object, or objects, on which to create the bodies.
     * @param {number} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
     */ enable: function(object, bodyType) {
                        if (bodyType === undefined) bodyType = CONST.DYNAMIC_BODY;
                        if (!Array.isArray(object)) object = [
                            object
                        ];
                        for(var i = 0; i < object.length; i++){
                            var entry = object[i];
                            if (entry.isParent) {
                                var children = entry.getChildren();
                                for(var c = 0; c < children.length; c++){
                                    var child = children[c];
                                    if (child.isParent) //  Handle Groups nested inside of Groups
                                    this.enable(child, bodyType);
                                    else this.enableBody(child, bodyType);
                                }
                            } else this.enableBody(entry, bodyType);
                        }
                    },
                    /**
     * Creates an Arcade Physics Body on a single Game Object.
     *
     * If the Game Object already has a body, this method will simply add it back into the simulation.
     *
     * You can specify if the body is Dynamic or Static. A dynamic body can move via velocity and
     * acceleration. A static body remains fixed in place and as such is able to use an optimized search
     * tree, making it ideal for static elements such as level objects. You can still collide and overlap
     * with static bodies.
     *
     * Normally, rather than calling this method directly, you'd use the helper methods available in the
     * Arcade Physics Factory, such as:
     *
     * ```javascript
     * this.physics.add.image(x, y, textureKey);
     * this.physics.add.sprite(x, y, textureKey);
     * ```
     *
     * Calling factory methods encapsulates the creation of a Game Object and the creation of its
     * body at the same time. If you are creating custom classes then you can pass them to this
     * method to have their bodies created.
     *
     * @method Phaser.Physics.Arcade.World#enableBody
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} object - The Game Object on which to create the body.
     * @param {number} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object on which the body was created.
     */ enableBody: function(object, bodyType) {
                        if (bodyType === undefined) bodyType = CONST.DYNAMIC_BODY;
                        if (object.hasTransformComponent) {
                            if (!object.body) {
                                if (bodyType === CONST.DYNAMIC_BODY) object.body = new Body(this, object);
                                else if (bodyType === CONST.STATIC_BODY) object.body = new StaticBody(this, object);
                            }
                            this.add(object.body);
                        }
                        return object;
                    },
                    /**
     * Adds an existing Arcade Physics Body or StaticBody to the simulation.
     *
     * The body is enabled and added to the local search trees.
     *
     * @method Phaser.Physics.Arcade.World#add
     * @since 3.10.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The Body to be added to the simulation.
     *
     * @return {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} The Body that was added to the simulation.
     */ add: function(body) {
                        if (body.physicsType === CONST.DYNAMIC_BODY) this.bodies.set(body);
                        else if (body.physicsType === CONST.STATIC_BODY) {
                            this.staticBodies.set(body);
                            this.staticTree.insert(body);
                        }
                        body.enable = true;
                        return body;
                    },
                    /**
     * Disables the Arcade Physics Body of a Game Object, an array of Game Objects, or the children of a Group.
     *
     * The difference between this and the `disableBody` method is that you can pass arrays or Groups
     * to this method.
     *
     * The body itself is not deleted, it just has its `enable` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `World.enable` or `World.add`.
     *
     * @method Phaser.Physics.Arcade.World#disable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object - The object, or objects, on which to disable the bodies.
     */ disable: function(object) {
                        if (!Array.isArray(object)) object = [
                            object
                        ];
                        for(var i = 0; i < object.length; i++){
                            var entry = object[i];
                            if (entry.isParent) {
                                var children = entry.getChildren();
                                for(var c = 0; c < children.length; c++){
                                    var child = children[c];
                                    if (child.isParent) //  Handle Groups nested inside of Groups
                                    this.disable(child);
                                    else this.disableBody(child.body);
                                }
                            } else this.disableBody(entry.body);
                        }
                    },
                    /**
     * Disables an existing Arcade Physics Body or StaticBody and removes it from the simulation.
     *
     * The body is disabled and removed from the local search trees.
     *
     * The body itself is not deleted, it just has its `enable` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `World.enable` or `World.add`.
     *
     * @method Phaser.Physics.Arcade.World#disableBody
     * @since 3.0.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The Body to be disabled.
     */ disableBody: function(body) {
                        this.remove(body);
                        body.enable = false;
                    },
                    /**
     * Removes an existing Arcade Physics Body or StaticBody from the simulation.
     *
     * The body is disabled and removed from the local search trees.
     *
     * The body itself is not deleted, it just has its `enabled` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `enable` or `add`.
     *
     * @method Phaser.Physics.Arcade.World#remove
     * @since 3.0.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The body to be removed from the simulation.
     */ remove: function(body) {
                        if (body.physicsType === CONST.DYNAMIC_BODY) {
                            this.tree.remove(body);
                            this.bodies.delete(body);
                        } else if (body.physicsType === CONST.STATIC_BODY) {
                            this.staticBodies.delete(body);
                            this.staticTree.remove(body);
                        }
                    },
                    /**
     * Creates a Graphics Game Object that the world will use to render the debug display to.
     *
     * This is called automatically when the World is instantiated if the `debug` config property
     * was set to `true`. However, you can call it at any point should you need to display the
     * debug Graphic from a fixed point.
     *
     * You can control which objects are drawn to the Graphics object, and the colors they use,
     * by setting the debug properties in the physics config.
     *
     * You should not typically use this in a production game. Use it to aid during debugging.
     *
     * @method Phaser.Physics.Arcade.World#createDebugGraphic
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object that was created for use by the World.
     */ createDebugGraphic: function() {
                        var graphic = this.scene.sys.add.graphics({
                            x: 0,
                            y: 0
                        });
                        graphic.setDepth(Number.MAX_VALUE);
                        this.debugGraphic = graphic;
                        this.drawDebug = true;
                        return graphic;
                    },
                    /**
     * Sets the position, size and properties of the World boundary.
     *
     * The World boundary is an invisible rectangle that defines the edges of the World.
     * If a Body is set to collide with the world bounds then it will automatically stop
     * when it reaches any of the edges. You can optionally set which edges of the boundary
     * should be checked against.
     *
     * @method Phaser.Physics.Arcade.World#setBounds
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the boundary.
     * @param {number} y - The top-left y coordinate of the boundary.
     * @param {number} width - The width of the boundary.
     * @param {number} height - The height of the boundary.
     * @param {boolean} [checkLeft] - Should bodies check against the left edge of the boundary?
     * @param {boolean} [checkRight] - Should bodies check against the right edge of the boundary?
     * @param {boolean} [checkUp] - Should bodies check against the top edge of the boundary?
     * @param {boolean} [checkDown] - Should bodies check against the bottom edge of the boundary?
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ setBounds: function(x, y, width, height, checkLeft, checkRight, checkUp, checkDown) {
                        this.bounds.setTo(x, y, width, height);
                        if (checkLeft !== undefined) this.setBoundsCollision(checkLeft, checkRight, checkUp, checkDown);
                        return this;
                    },
                    /**
     * Enables or disables collisions on each edge of the World boundary.
     *
     * @method Phaser.Physics.Arcade.World#setBoundsCollision
     * @since 3.0.0
     *
     * @param {boolean} [left=true] - Should bodies check against the left edge of the boundary?
     * @param {boolean} [right=true] - Should bodies check against the right edge of the boundary?
     * @param {boolean} [up=true] - Should bodies check against the top edge of the boundary?
     * @param {boolean} [down=true] - Should bodies check against the bottom edge of the boundary?
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ setBoundsCollision: function(left, right, up, down) {
                        if (left === undefined) left = true;
                        if (right === undefined) right = true;
                        if (up === undefined) up = true;
                        if (down === undefined) down = true;
                        this.checkCollision.left = left;
                        this.checkCollision.right = right;
                        this.checkCollision.up = up;
                        this.checkCollision.down = down;
                        return this;
                    },
                    /**
     * Pauses the simulation.
     *
     * A paused simulation does not update any existing bodies, or run any Colliders.
     *
     * However, you can still enable and disable bodies within it, or manually run collide or overlap
     * checks.
     *
     * @method Phaser.Physics.Arcade.World#pause
     * @fires Phaser.Physics.Arcade.Events#PAUSE
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ pause: function() {
                        this.isPaused = true;
                        this.emit(Events.PAUSE);
                        return this;
                    },
                    /**
     * Resumes the simulation, if paused.
     *
     * @method Phaser.Physics.Arcade.World#resume
     * @fires Phaser.Physics.Arcade.Events#RESUME
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ resume: function() {
                        this.isPaused = false;
                        this.emit(Events.RESUME);
                        return this;
                    },
                    /**
     * Creates a new Collider object and adds it to the simulation.
     *
     * A Collider is a way to automatically perform collision checks between two objects,
     * calling the collide and process callbacks if they occur.
     *
     * Colliders are run as part of the World update, after all of the Bodies have updated.
     *
     * By creating a Collider you don't need then call `World.collide` in your `update` loop,
     * as it will be handled for you automatically.
     *
     * @method Phaser.Physics.Arcade.World#addCollider
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.World#collide
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ addCollider: function(object1, object2, collideCallback, processCallback, callbackContext) {
                        if (collideCallback === undefined) collideCallback = null;
                        if (processCallback === undefined) processCallback = null;
                        if (callbackContext === undefined) callbackContext = collideCallback;
                        var collider = new Collider(this, false, object1, object2, collideCallback, processCallback, callbackContext);
                        this.colliders.add(collider);
                        return collider;
                    },
                    /**
     * Creates a new Overlap Collider object and adds it to the simulation.
     *
     * A Collider is a way to automatically perform overlap checks between two objects,
     * calling the collide and process callbacks if they occur.
     *
     * Colliders are run as part of the World update, after all of the Bodies have updated.
     *
     * By creating a Collider you don't need then call `World.overlap` in your `update` loop,
     * as it will be handled for you automatically.
     *
     * @method Phaser.Physics.Arcade.World#addOverlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects overlap. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ addOverlap: function(object1, object2, collideCallback, processCallback, callbackContext) {
                        if (collideCallback === undefined) collideCallback = null;
                        if (processCallback === undefined) processCallback = null;
                        if (callbackContext === undefined) callbackContext = collideCallback;
                        var collider = new Collider(this, true, object1, object2, collideCallback, processCallback, callbackContext);
                        this.colliders.add(collider);
                        return collider;
                    },
                    /**
     * Removes a Collider from the simulation so it is no longer processed.
     *
     * This method does not destroy the Collider. If you wish to add it back at a later stage you can call
     * `World.colliders.add(Collider)`.
     *
     * If you no longer need the Collider you can call the `Collider.destroy` method instead, which will
     * automatically clear all of its references and then remove it from the World. If you call destroy on
     * a Collider you _don't_ need to pass it to this method too.
     *
     * @method Phaser.Physics.Arcade.World#removeCollider
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Collider} collider - The Collider to remove from the simulation.
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ removeCollider: function(collider) {
                        this.colliders.remove(collider);
                        return this;
                    },
                    /**
     * Sets the frame rate to run the simulation at.
     *
     * The frame rate value is used to simulate a fixed update time step. This fixed
     * time step allows for a straightforward implementation of a deterministic game state.
     *
     * This frame rate is independent of the frequency at which the game is rendering. The
     * higher you set the fps, the more physics simulation steps will occur per game step.
     * Conversely, the lower you set it, the less will take place.
     *
     * You can optionally advance the simulation directly yourself by calling the `step` method.
     *
     * @method Phaser.Physics.Arcade.World#setFPS
     * @since 3.10.0
     *
     * @param {number} framerate - The frame rate to advance the simulation at.
     *
     * @return {this} This World object.
     */ setFPS: function(framerate) {
                        this.fps = framerate;
                        this._frameTime = 1 / this.fps;
                        this._frameTimeMS = 1000 * this._frameTime;
                        return this;
                    },
                    /**
     * Advances the simulation based on the elapsed time and fps rate.
     *
     * This is called automatically by your Scene and does not need to be invoked directly.
     *
     * @method Phaser.Physics.Arcade.World#update
     * @fires Phaser.Physics.Arcade.Events#WORLD_STEP
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                        if (this.isPaused || this.bodies.size === 0) return;
                        var i;
                        var fixedDelta = this._frameTime;
                        var msPerFrame = this._frameTimeMS * this.timeScale;
                        this._elapsed += delta;
                        //  Update all active bodies
                        var body;
                        var bodies = this.bodies.entries;
                        //  Will a step happen this frame?
                        var willStep = this._elapsed >= msPerFrame;
                        if (!this.fixedStep) {
                            fixedDelta = delta * 0.001;
                            willStep = true;
                            this._elapsed = 0;
                        }
                        for(i = 0; i < bodies.length; i++){
                            body = bodies[i];
                            if (body.enable) body.preUpdate(willStep, fixedDelta);
                        }
                        //  We know that a step will happen this frame, so let's bundle it all together to save branching and iteration costs
                        if (willStep) {
                            this._elapsed -= msPerFrame;
                            this.stepsLastFrame = 1;
                            //  Optionally populate our dynamic collision tree
                            if (this.useTree) {
                                this.tree.clear();
                                this.tree.load(bodies);
                            }
                            //  Process any colliders
                            var colliders = this.colliders.update();
                            for(i = 0; i < colliders.length; i++){
                                var collider = colliders[i];
                                if (collider.active) collider.update();
                            }
                            this.emit(Events.WORLD_STEP, fixedDelta);
                        }
                        //  Process any additional steps this frame
                        while(this._elapsed >= msPerFrame){
                            this._elapsed -= msPerFrame;
                            this.step(fixedDelta);
                        }
                    },
                    /**
     * Advances the simulation by a time increment.
     *
     * @method Phaser.Physics.Arcade.World#step
     * @fires Phaser.Physics.Arcade.Events#WORLD_STEP
     * @since 3.10.0
     *
     * @param {number} delta - The delta time amount, in seconds, by which to advance the simulation.
     */ step: function(delta) {
                        //  Update all active bodies
                        var i;
                        var body;
                        var bodies = this.bodies.entries;
                        var len = bodies.length;
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.enable) body.update(delta);
                        }
                        //  Optionally populate our dynamic collision tree
                        if (this.useTree) {
                            this.tree.clear();
                            this.tree.load(bodies);
                        }
                        //  Process any colliders
                        var colliders = this.colliders.update();
                        for(i = 0; i < colliders.length; i++){
                            var collider = colliders[i];
                            if (collider.active) collider.update();
                        }
                        this.emit(Events.WORLD_STEP, delta);
                        this.stepsLastFrame++;
                    },
                    /**
     * Advances the simulation by a single step.
     *
     * @method Phaser.Physics.Arcade.World#singleStep
     * @fires Phaser.Physics.Arcade.Events#WORLD_STEP
     * @since 3.70.0
     */ singleStep: function() {
                        this.update(0, this._frameTimeMS);
                        this.postUpdate();
                    },
                    /**
     * Updates bodies, draws the debug display, and handles pending queue operations.
     *
     * @method Phaser.Physics.Arcade.World#postUpdate
     * @since 3.0.0
     */ postUpdate: function() {
                        var i;
                        var body;
                        var bodies = this.bodies.entries;
                        var len = bodies.length;
                        var dynamic = this.bodies;
                        var staticBodies = this.staticBodies;
                        //  We don't need to postUpdate if there wasn't a step this frame
                        if (this.stepsLastFrame) {
                            this.stepsLastFrame = 0;
                            for(i = 0; i < len; i++){
                                body = bodies[i];
                                if (body.enable) body.postUpdate();
                            }
                        }
                        if (this.drawDebug) {
                            var graphics = this.debugGraphic;
                            graphics.clear();
                            for(i = 0; i < len; i++){
                                body = bodies[i];
                                if (body.willDrawDebug()) body.drawDebug(graphics);
                            }
                            bodies = staticBodies.entries;
                            len = bodies.length;
                            for(i = 0; i < len; i++){
                                body = bodies[i];
                                if (body.willDrawDebug()) body.drawDebug(graphics);
                            }
                        }
                        var pending = this.pendingDestroy;
                        if (pending.size > 0) {
                            var dynamicTree = this.tree;
                            var staticTree = this.staticTree;
                            bodies = pending.entries;
                            len = bodies.length;
                            for(i = 0; i < len; i++){
                                body = bodies[i];
                                if (body.physicsType === CONST.DYNAMIC_BODY) {
                                    dynamicTree.remove(body);
                                    dynamic.delete(body);
                                } else if (body.physicsType === CONST.STATIC_BODY) {
                                    staticTree.remove(body);
                                    staticBodies.delete(body);
                                }
                                body.world = undefined;
                                body.gameObject = undefined;
                            }
                            pending.clear();
                        }
                    },
                    /**
     * Calculates a Body's velocity and updates its position.
     *
     * @method Phaser.Physics.Arcade.World#updateMotion
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to be updated.
     * @param {number} delta - The delta value to be used in the motion calculations, in seconds.
     */ updateMotion: function(body, delta) {
                        if (body.allowRotation) this.computeAngularVelocity(body, delta);
                        this.computeVelocity(body, delta);
                    },
                    /**
     * Calculates a Body's angular velocity.
     *
     * @method Phaser.Physics.Arcade.World#computeAngularVelocity
     * @since 3.10.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to compute the velocity for.
     * @param {number} delta - The delta value to be used in the calculation, in seconds.
     */ computeAngularVelocity: function(body, delta) {
                        var velocity = body.angularVelocity;
                        var acceleration = body.angularAcceleration;
                        var drag = body.angularDrag;
                        var max = body.maxAngular;
                        if (acceleration) velocity += acceleration * delta;
                        else if (body.allowDrag && drag) {
                            drag *= delta;
                            if (FuzzyGreaterThan(velocity - drag, 0, 0.1)) velocity -= drag;
                            else if (FuzzyLessThan(velocity + drag, 0, 0.1)) velocity += drag;
                            else velocity = 0;
                        }
                        velocity = Clamp(velocity, -max, max);
                        var velocityDelta = velocity - body.angularVelocity;
                        body.angularVelocity += velocityDelta;
                        body.rotation += body.angularVelocity * delta;
                    },
                    /**
     * Calculates a Body's per-axis velocity.
     *
     * @method Phaser.Physics.Arcade.World#computeVelocity
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to compute the velocity for.
     * @param {number} delta - The delta value to be used in the calculation, in seconds.
     */ computeVelocity: function(body, delta) {
                        var velocityX = body.velocity.x;
                        var accelerationX = body.acceleration.x;
                        var dragX = body.drag.x;
                        var maxX = body.maxVelocity.x;
                        var velocityY = body.velocity.y;
                        var accelerationY = body.acceleration.y;
                        var dragY = body.drag.y;
                        var maxY = body.maxVelocity.y;
                        var speed = body.speed;
                        var maxSpeed = body.maxSpeed;
                        var allowDrag = body.allowDrag;
                        var useDamping = body.useDamping;
                        if (body.allowGravity) {
                            velocityX += (this.gravity.x + body.gravity.x) * delta;
                            velocityY += (this.gravity.y + body.gravity.y) * delta;
                        }
                        if (accelerationX) velocityX += accelerationX * delta;
                        else if (allowDrag && dragX) {
                            if (useDamping) {
                                //  Damping based deceleration
                                dragX = Math.pow(dragX, delta);
                                velocityX *= dragX;
                                speed = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
                                if (FuzzyEqual(speed, 0, 0.001)) velocityX = 0;
                            } else {
                                //  Linear deceleration
                                dragX *= delta;
                                if (FuzzyGreaterThan(velocityX - dragX, 0, 0.01)) velocityX -= dragX;
                                else if (FuzzyLessThan(velocityX + dragX, 0, 0.01)) velocityX += dragX;
                                else velocityX = 0;
                            }
                        }
                        if (accelerationY) velocityY += accelerationY * delta;
                        else if (allowDrag && dragY) {
                            if (useDamping) {
                                //  Damping based deceleration
                                dragY = Math.pow(dragY, delta);
                                velocityY *= dragY;
                                speed = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
                                if (FuzzyEqual(speed, 0, 0.001)) velocityY = 0;
                            } else {
                                //  Linear deceleration
                                dragY *= delta;
                                if (FuzzyGreaterThan(velocityY - dragY, 0, 0.01)) velocityY -= dragY;
                                else if (FuzzyLessThan(velocityY + dragY, 0, 0.01)) velocityY += dragY;
                                else velocityY = 0;
                            }
                        }
                        velocityX = Clamp(velocityX, -maxX, maxX);
                        velocityY = Clamp(velocityY, -maxY, maxY);
                        body.velocity.set(velocityX, velocityY);
                        if (maxSpeed > -1 && body.velocity.length() > maxSpeed) {
                            body.velocity.normalize().scale(maxSpeed);
                            speed = maxSpeed;
                        }
                        body.speed = speed;
                    },
                    /**
     * Separates two Bodies.
     *
     * @method Phaser.Physics.Arcade.World#separate
     * @fires Phaser.Physics.Arcade.Events#COLLIDE
     * @fires Phaser.Physics.Arcade.Events#OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to be separated.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to be separated.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - The process callback.
     * @param {*} [callbackContext] - The context in which to invoke the callback.
     * @param {boolean} [overlapOnly] - If this a collide or overlap check?
     *
     * @return {boolean} True if separation occurred, otherwise false.
     */ separate: function(body1, body2, processCallback, callbackContext, overlapOnly) {
                        var overlapX;
                        var overlapY;
                        var result = false;
                        var runSeparation = true;
                        if (!body1.enable || !body2.enable || body1.checkCollision.none || body2.checkCollision.none || !this.intersects(body1, body2)) return result;
                        //  They overlap. Is there a custom process callback? If it returns true then we can carry on, otherwise we should abort.
                        if (processCallback && processCallback.call(callbackContext, body1.gameObject || body1, body2.gameObject || body2) === false) return result;
                        //  Circle vs. Circle, or Circle vs. Rect
                        if (body1.isCircle || body2.isCircle) {
                            var circleResults = this.separateCircle(body1, body2, overlapOnly);
                            if (circleResults.result) {
                                //  We got a satisfactory result from the separateCircle method
                                result = true;
                                runSeparation = false;
                            } else {
                                //  Further processing required
                                overlapX = circleResults.x;
                                overlapY = circleResults.y;
                                runSeparation = true;
                            }
                        }
                        if (runSeparation) {
                            var resultX = false;
                            var resultY = false;
                            var bias = this.OVERLAP_BIAS;
                            //  Do we separate on x first or y first or both?
                            if (overlapOnly) {
                                //  No separation but we need to calculate overlapX, overlapY, etc.
                                resultX = SeparateX(body1, body2, overlapOnly, bias, overlapX);
                                resultY = SeparateY(body1, body2, overlapOnly, bias, overlapY);
                            } else if (this.forceX || Math.abs(this.gravity.y + body1.gravity.y) < Math.abs(this.gravity.x + body1.gravity.x)) {
                                resultX = SeparateX(body1, body2, overlapOnly, bias, overlapX);
                                //  Are they still intersecting? Let's do the other axis then
                                if (this.intersects(body1, body2)) resultY = SeparateY(body1, body2, overlapOnly, bias, overlapY);
                            } else {
                                resultY = SeparateY(body1, body2, overlapOnly, bias, overlapY);
                                //  Are they still intersecting? Let's do the other axis then
                                if (this.intersects(body1, body2)) resultX = SeparateX(body1, body2, overlapOnly, bias, overlapX);
                            }
                            result = resultX || resultY;
                        }
                        if (result) {
                            if (overlapOnly) {
                                if (body1.onOverlap || body2.onOverlap) this.emit(Events.OVERLAP, body1.gameObject, body2.gameObject, body1, body2);
                            } else if (body1.onCollide || body2.onCollide) this.emit(Events.COLLIDE, body1.gameObject, body2.gameObject, body1, body2);
                        }
                        return result;
                    },
                    /**
     * Separates two Bodies, when both are circular.
     *
     * @method Phaser.Physics.Arcade.World#separateCircle
     * @fires Phaser.Physics.Arcade.Events#COLLIDE
     * @fires Phaser.Physics.Arcade.Events#OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to be separated.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to be separated.
     * @param {boolean} [overlapOnly] - If this a collide or overlap check?
     *
     * @return {boolean} True if separation occurred, otherwise false.
     */ separateCircle: function(body1, body2, overlapOnly) {
                        //  Set the AABB overlap, blocked and touching values into the bodies (we don't use the return values here)
                        GetOverlapX(body1, body2, false, 0);
                        GetOverlapY(body1, body2, false, 0);
                        var body1IsCircle = body1.isCircle;
                        var body2IsCircle = body2.isCircle;
                        var body1Center = body1.center;
                        var body2Center = body2.center;
                        var body1Immovable = body1.immovable;
                        var body2Immovable = body2.immovable;
                        var body1Velocity = body1.velocity;
                        var body2Velocity = body2.velocity;
                        var overlap = 0;
                        var twoCircles = true;
                        if (body1IsCircle !== body2IsCircle) {
                            twoCircles = false;
                            var circleX = body1Center.x;
                            var circleY = body1Center.y;
                            var circleRadius = body1.halfWidth;
                            var rectX = body2.position.x;
                            var rectY = body2.position.y;
                            var rectRight = body2.right;
                            var rectBottom = body2.bottom;
                            if (body2IsCircle) {
                                circleX = body2Center.x;
                                circleY = body2Center.y;
                                circleRadius = body2.halfWidth;
                                rectX = body1.position.x;
                                rectY = body1.position.y;
                                rectRight = body1.right;
                                rectBottom = body1.bottom;
                            }
                            if (circleY < rectY) {
                                if (circleX < rectX) overlap = DistanceBetween(circleX, circleY, rectX, rectY) - circleRadius;
                                else if (circleX > rectRight) overlap = DistanceBetween(circleX, circleY, rectRight, rectY) - circleRadius;
                            } else if (circleY > rectBottom) {
                                if (circleX < rectX) overlap = DistanceBetween(circleX, circleY, rectX, rectBottom) - circleRadius;
                                else if (circleX > rectRight) overlap = DistanceBetween(circleX, circleY, rectRight, rectBottom) - circleRadius;
                            }
                            //  If a collision occurs in the corner points of the rectangle
                            //  then the bodies behave like circles
                            overlap *= -1;
                        } else overlap = body1.halfWidth + body2.halfWidth - DistanceBetweenPoints(body1Center, body2Center);
                        body1.overlapR = overlap;
                        body2.overlapR = overlap;
                        var angle = AngleBetweenPoints(body1Center, body2Center);
                        var overlapX = (overlap + MATH_CONST.EPSILON) * Math.cos(angle);
                        var overlapY = (overlap + MATH_CONST.EPSILON) * Math.sin(angle);
                        var results = {
                            overlap: overlap,
                            result: false,
                            x: overlapX,
                            y: overlapY
                        };
                        //  We know the AABBs already intersect before we enter this method
                        if (overlapOnly && (!twoCircles || twoCircles && overlap !== 0)) {
                            //  Now we know the rect vs circle overlaps, or two circles do
                            results.result = true;
                            return results;
                        }
                        //  Can't separate (in this method):
                        //  Two immovable bodies
                        //  A body with its own custom separation logic
                        //  A circle vs. a rect with a face-on collision
                        if (!twoCircles && overlap === 0 || body1Immovable && body2Immovable || body1.customSeparateX || body2.customSeparateX) {
                            //  Let SeparateX / SeparateY handle this
                            results.x = undefined;
                            results.y = undefined;
                            return results;
                        }
                        //  If we get this far we either have circle vs. circle
                        //  or circle vs. rect with corner collision
                        var deadlock = !body1.pushable && !body2.pushable;
                        if (twoCircles) {
                            var dx = body1Center.x - body2Center.x;
                            var dy = body1Center.y - body2Center.y;
                            var d = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                            var nx = (body2Center.x - body1Center.x) / d || 0;
                            var ny = (body2Center.y - body1Center.y) / d || 0;
                            var p = 2 * (body1Velocity.x * nx + body1Velocity.y * ny - body2Velocity.x * nx - body2Velocity.y * ny) / (body1.mass + body2.mass);
                            if (body1Immovable || body2Immovable || !body1.pushable || !body2.pushable) p *= 2;
                            if (!body1Immovable && body1.pushable) {
                                body1Velocity.x = body1Velocity.x - p / body1.mass * nx;
                                body1Velocity.y = body1Velocity.y - p / body1.mass * ny;
                                body1Velocity.multiply(body1.bounce);
                            }
                            if (!body2Immovable && body2.pushable) {
                                body2Velocity.x = body2Velocity.x + p / body2.mass * nx;
                                body2Velocity.y = body2Velocity.y + p / body2.mass * ny;
                                body2Velocity.multiply(body2.bounce);
                            }
                            if (!body1Immovable && !body2Immovable) {
                                overlapX *= 0.5;
                                overlapY *= 0.5;
                            }
                            if (!body1Immovable || body1.pushable || deadlock) {
                                body1.x -= overlapX;
                                body1.y -= overlapY;
                                body1.updateCenter();
                            }
                            if (!body2Immovable || body2.pushable || deadlock) {
                                body2.x += overlapX;
                                body2.y += overlapY;
                                body2.updateCenter();
                            }
                            results.result = true;
                        } else {
                            //  Circle vs. Rect
                            //  We'll only move the circle (if we can) and let
                            //  the runSeparation handle the rectangle
                            if (!body1Immovable || body1.pushable || deadlock) {
                                body1.x -= overlapX;
                                body1.y -= overlapY;
                                body1.updateCenter();
                            }
                            if (!body2Immovable || body2.pushable || deadlock) {
                                body2.x += overlapX;
                                body2.y += overlapY;
                                body2.updateCenter();
                            }
                            //  Let SeparateX / SeparateY handle this further
                            results.x = undefined;
                            results.y = undefined;
                        }
                        return results;
                    },
                    /**
     * Checks to see if two Bodies intersect at all.
     *
     * @method Phaser.Physics.Arcade.World#intersects
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first body to check.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second body to check.
     *
     * @return {boolean} True if the two bodies intersect, otherwise false.
     */ intersects: function(body1, body2) {
                        if (body1 === body2) return false;
                        if (!body1.isCircle && !body2.isCircle) //  Rect vs. Rect
                        return !(body1.right <= body2.left || body1.bottom <= body2.top || body1.left >= body2.right || body1.top >= body2.bottom);
                        else if (body1.isCircle) {
                            if (body2.isCircle) //  Circle vs. Circle
                            return DistanceBetweenPoints(body1.center, body2.center) <= body1.halfWidth + body2.halfWidth;
                            else //  Circle vs. Rect
                            return this.circleBodyIntersects(body1, body2);
                        } else //  Rect vs. Circle
                        return this.circleBodyIntersects(body2, body1);
                    },
                    /**
     * Tests if a circular Body intersects with another Body.
     *
     * @method Phaser.Physics.Arcade.World#circleBodyIntersects
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} circle - The circular body to test.
     * @param {Phaser.Physics.Arcade.Body} body - The rectangular body to test.
     *
     * @return {boolean} True if the two bodies intersect, otherwise false.
     */ circleBodyIntersects: function(circle, body) {
                        var x = Clamp(circle.center.x, body.left, body.right);
                        var y = Clamp(circle.center.y, body.top, body.bottom);
                        var dx = (circle.center.x - x) * (circle.center.x - x);
                        var dy = (circle.center.y - y) * (circle.center.y - y);
                        return dx + dy <= circle.halfWidth * circle.halfWidth;
                    },
                    /**
     * Tests if Game Objects overlap.
     *
     * See details in {@link Phaser.Physics.Arcade.World#collide}.
     *
     * @method Phaser.Physics.Arcade.World#overlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [overlapCallback] - An optional callback function that is called if the objects overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `overlapCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if at least one Game Object overlaps another.
     *
     * @see Phaser.Physics.Arcade.World#collide
     */ overlap: function(object1, object2, overlapCallback, processCallback, callbackContext) {
                        if (overlapCallback === undefined) overlapCallback = null;
                        if (processCallback === undefined) processCallback = null;
                        if (callbackContext === undefined) callbackContext = overlapCallback;
                        return this.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
                    },
                    /**
     * Performs a collision check and separation between the two physics enabled objects given, which can be single
     * Game Objects, arrays of Game Objects, Physics Groups, arrays of Physics Groups or normal Groups.
     *
     * If you don't require separation then use {@link Phaser.Physics.Arcade.World#overlap} instead.
     *
     * If two Groups or arrays are passed, each member of one will be tested against each member of the other.
     *
     * If **only** one Group is passed (as `object1`), each member of the Group will be collided against the other members.
     *
     * If **only** one Array is passed, the array is iterated and every element in it is tested against the others.
     *
     * Two callbacks can be provided; they receive the colliding game objects as arguments.
     * If an overlap is detected, the `processCallback` is called first. It can cancel the collision by returning false.
     * Next the objects are separated and `collideCallback` is invoked.
     *
     * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
     * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
     * The separation that stops two objects penetrating may create a new penetration against a different object. If you
     * require a high level of stability please consider using an alternative physics system, such as Matter.js.
     *
     * @method Phaser.Physics.Arcade.World#collide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} `true` if any overlapping Game Objects were separated, otherwise `false`.
     */ collide: function(object1, object2, collideCallback, processCallback, callbackContext) {
                        if (collideCallback === undefined) collideCallback = null;
                        if (processCallback === undefined) processCallback = null;
                        if (callbackContext === undefined) callbackContext = collideCallback;
                        return this.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
                    },
                    /**
     * Internal helper function. Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideObjects
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {any} callbackContext - The scope in which to call the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideObjects: function(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly) {
                        var i;
                        var j;
                        if (object1.isParent && (object1.physicsType === undefined || object2 === undefined || object1 === object2)) object1 = object1.children.entries;
                        if (object2 && object2.isParent && object2.physicsType === undefined) object2 = object2.children.entries;
                        var object1isArray = Array.isArray(object1);
                        var object2isArray = Array.isArray(object2);
                        this._total = 0;
                        if (!object1isArray && !object2isArray) //  Neither of them are arrays - do this first as it's the most common use-case
                        this.collideHandler(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (!object1isArray && object2isArray) //  Object 2 is an Array
                        for(i = 0; i < object2.length; i++)this.collideHandler(object1, object2[i], collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object1isArray && !object2isArray) {
                            //  Object 1 is an Array
                            if (!object2) //  Special case for array vs. self
                            for(i = 0; i < object1.length; i++){
                                var child = object1[i];
                                for(j = i + 1; j < object1.length; j++){
                                    if (i === j) continue;
                                    this.collideHandler(child, object1[j], collideCallback, processCallback, callbackContext, overlapOnly);
                                }
                            }
                            else for(i = 0; i < object1.length; i++)this.collideHandler(object1[i], object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        } else {
                            //  They're both arrays
                            for(i = 0; i < object1.length; i++)for(j = 0; j < object2.length; j++)this.collideHandler(object1[i], object2[j], collideCallback, processCallback, callbackContext, overlapOnly);
                        }
                        return this._total > 0;
                    },
                    /**
     * Internal helper function. Please use Phaser.Physics.Arcade.World#collide and Phaser.Physics.Arcade.World#overlap instead.
     *
     * @method Phaser.Physics.Arcade.World#collideHandler
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object or array of objects to check, or `undefined`.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} collideCallback - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} processCallback - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} callbackContext - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideHandler: function(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly) {
                        //  Collide Group with Self
                        //  Only collide valid objects
                        if (object2 === undefined && object1.isParent) return this.collideGroupVsGroup(object1, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                        //  If neither of the objects are set then bail out
                        if (!object1 || !object2) return false;
                        //  SPRITE
                        if (object1.body || object1.isBody) {
                            if (object2.body || object2.isBody) return this.collideSpriteVsSprite(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                            else if (object2.isParent) return this.collideSpriteVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                            else if (object2.isTilemap) return this.collideSpriteVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        } else if (object1.isParent) {
                            if (object2.body || object2.isBody) return this.collideSpriteVsGroup(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                            else if (object2.isParent) return this.collideGroupVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                            else if (object2.isTilemap) return this.collideGroupVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        } else if (object1.isTilemap) {
                            if (object2.body || object2.isBody) return this.collideSpriteVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                            else if (object2.isParent) return this.collideGroupVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                        }
                    },
                    /**
     * Checks if the two given Arcade Physics bodies will collide, or not,
     * based on their collision mask and collision categories.
     *
     * @method Phaser.Physics.Arcade.World#canCollide
     * @since 3.70.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeCollider} body1 - The first body to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeCollider} body2 - The second body to check.
     *
     * @return {boolean} True if the two bodies will collide, otherwise false.
     */ canCollide: function(body1, body2) {
                        return body1 && body2 && (body1.collisionMask & body2.collisionCategory) !== 0 && (body2.collisionMask & body1.collisionCategory) !== 0;
                    },
                    /**
     * Internal handler for Sprite vs. Sprite collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsSprite
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite1 - The first object to check for collision.
     * @param {Phaser.GameObjects.GameObject} sprite2 - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsSprite: function(sprite1, sprite2, collideCallback, processCallback, callbackContext, overlapOnly) {
                        var body1 = sprite1.isBody ? sprite1 : sprite1.body;
                        var body2 = sprite2.isBody ? sprite2 : sprite2.body;
                        if (!this.canCollide(body1, body2)) return false;
                        if (this.separate(body1, body2, processCallback, callbackContext, overlapOnly)) {
                            if (collideCallback) collideCallback.call(callbackContext, sprite1, sprite2);
                            this._total++;
                        }
                        return true;
                    },
                    /**
     * Internal handler for Sprite vs. Group collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsGroup
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.GameObjects.Group} group - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {any} callbackContext - The scope in which to call the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     */ collideSpriteVsGroup: function(sprite, group, collideCallback, processCallback, callbackContext, overlapOnly) {
                        var bodyA = sprite.isBody ? sprite : sprite.body;
                        if (group.getLength() === 0 || !bodyA || !bodyA.enable || bodyA.checkCollision.none || !this.canCollide(bodyA, group)) return;
                        //  Does sprite collide with anything?
                        var i;
                        var len;
                        var bodyB;
                        if (this.useTree || group.physicsType === CONST.STATIC_BODY) {
                            var minMax = this.treeMinMax;
                            minMax.minX = bodyA.left;
                            minMax.minY = bodyA.top;
                            minMax.maxX = bodyA.right;
                            minMax.maxY = bodyA.bottom;
                            var results = group.physicsType === CONST.DYNAMIC_BODY ? this.tree.search(minMax) : this.staticTree.search(minMax);
                            len = results.length;
                            for(i = 0; i < len; i++){
                                bodyB = results[i];
                                if (bodyA === bodyB || !bodyB.enable || bodyB.checkCollision.none || !group.contains(bodyB.gameObject)) continue;
                                if (this.separate(bodyA, bodyB, processCallback, callbackContext, overlapOnly)) {
                                    if (collideCallback) collideCallback.call(callbackContext, bodyA.gameObject, bodyB.gameObject);
                                    this._total++;
                                }
                            }
                        } else {
                            var children = group.getChildren();
                            var skipIndex = group.children.entries.indexOf(sprite);
                            len = children.length;
                            for(i = 0; i < len; i++){
                                bodyB = children[i].body;
                                if (!bodyB || i === skipIndex || !bodyB.enable) continue;
                                if (this.separate(bodyA, bodyB, processCallback, callbackContext, overlapOnly)) {
                                    if (collideCallback) collideCallback.call(callbackContext, bodyA.gameObject, bodyB.gameObject);
                                    this._total++;
                                }
                            }
                        }
                    },
                    /**
     * Internal handler for Group vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideGroupVsTilemapLayer
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Group} group - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} collideCallback - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} processCallback - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} callbackContext - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideGroupVsTilemapLayer: function(group, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly) {
                        if (!this.canCollide(group, tilemapLayer)) return false;
                        var children = group.getChildren();
                        if (children.length === 0) return false;
                        var didCollide = false;
                        for(var i = 0; i < children.length; i++){
                            if (children[i].body || children[i].isBody) {
                                if (this.collideSpriteVsTilemapLayer(children[i], tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly)) didCollide = true;
                            }
                        }
                        return didCollide;
                    },
                    /**
     * This advanced method is specifically for testing for collision between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `collide` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for collision with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic collisions
     * on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * Important: Use of this method skips the `interesting faces` system that Tilemap Layers use. This means if you have
     * say a row or column of tiles, and you jump into, or walk over them, it's possible to get stuck on the edges of the
     * tiles as the interesting face calculations are skipped. However, for quick-fire small collision set tests on
     * dynamic maps, this method can prove very useful.
     *
     * This method does not factor in the Collision Mask or Category.
     *
     * @method Phaser.Physics.Arcade.World#collideTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                        if (tiles.length === 0 || sprite.body && !sprite.body.enable || sprite.isBody && !sprite.enable) return false;
                        else return this.collideSpriteVsTilesHandler(sprite, tiles, collideCallback, processCallback, callbackContext, false, false);
                    },
                    /**
     * This advanced method is specifically for testing for overlaps between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `overlap` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for overlaps with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic overlap
     * tests on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * This method does not factor in the Collision Mask or Category.
     *
     * @method Phaser.Physics.Arcade.World#overlapTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ overlapTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                        if (tiles.length === 0 || sprite.body && !sprite.body.enable || sprite.isBody && !sprite.enable) return false;
                        else return this.collideSpriteVsTilesHandler(sprite, tiles, collideCallback, processCallback, callbackContext, true, false);
                    },
                    /**
     * Internal handler for Sprite vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsTilemapLayer
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} [overlapOnly] - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsTilemapLayer: function(sprite, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly) {
                        var body = sprite.isBody ? sprite : sprite.body;
                        if (!body.enable || body.checkCollision.none || !this.canCollide(body, tilemapLayer)) return false;
                        var layerData = tilemapLayer.layer;
                        //  Increase the hit area of the body by the size of the tiles * the scale
                        //  This will allow GetTilesWithinWorldXY to include the tiles around the body
                        var x = body.x - layerData.tileWidth * tilemapLayer.scaleX;
                        var y = body.y - layerData.tileHeight * tilemapLayer.scaleY;
                        var w = body.width + layerData.tileWidth * tilemapLayer.scaleX;
                        var h = body.height + layerData.tileHeight * tilemapLayer.scaleY;
                        var options = overlapOnly ? null : this.tileFilterOptions;
                        var mapData = GetTilesWithinWorldXY(x, y, w, h, options, tilemapLayer.scene.cameras.main, tilemapLayer.layer);
                        if (mapData.length === 0) return false;
                        else return this.collideSpriteVsTilesHandler(sprite, mapData, collideCallback, processCallback, callbackContext, overlapOnly, true);
                    },
                    /**
     * Internal handler for Sprite vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsTilesHandler
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @private
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} [overlapOnly] - Whether this is a collision or overlap check.
     * @param {boolean} [isLayer] - Is this check coming from a TilemapLayer or an array of tiles?
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsTilesHandler: function(sprite, tiles, collideCallback, processCallback, callbackContext, overlapOnly, isLayer) {
                        var body = sprite.isBody ? sprite : sprite.body;
                        var tile;
                        var tileWorldRect = {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        };
                        var tilemapLayer;
                        var collision = false;
                        for(var i = 0; i < tiles.length; i++){
                            tile = tiles[i];
                            tilemapLayer = tile.tilemapLayer;
                            var point = tilemapLayer.tileToWorldXY(tile.x, tile.y);
                            tileWorldRect.left = point.x;
                            tileWorldRect.top = point.y;
                            tileWorldRect.right = tileWorldRect.left + tile.width * tilemapLayer.scaleX;
                            tileWorldRect.bottom = tileWorldRect.top + tile.height * tilemapLayer.scaleY;
                            if (TileIntersectsBody(tileWorldRect, body) && (!processCallback || processCallback.call(callbackContext, sprite, tile)) && ProcessTileCallbacks(tile, sprite) && (overlapOnly || SeparateTile(i, body, tile, tileWorldRect, tilemapLayer, this.TILE_BIAS, isLayer))) {
                                this._total++;
                                collision = true;
                                if (collideCallback) collideCallback.call(callbackContext, sprite, tile);
                                if (overlapOnly && body.onOverlap) this.emit(Events.TILE_OVERLAP, sprite, tile, body);
                                else if (body.onCollide) this.emit(Events.TILE_COLLIDE, sprite, tile, body);
                            }
                        }
                        return collision;
                    },
                    /**
     * Internal helper for Group vs. Group collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideGroupVsGroup
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Group} group1 - The first object to check for collision.
     * @param {Phaser.GameObjects.Group} group2 - The second object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideGroupVsGroup: function(group1, group2, collideCallback, processCallback, callbackContext, overlapOnly) {
                        if (group1.getLength() === 0 || group2.getLength() === 0 || !this.canCollide(group1, group2)) return;
                        var children = group1.getChildren();
                        for(var i = 0; i < children.length; i++)this.collideSpriteVsGroup(children[i], group2, collideCallback, processCallback, callbackContext, overlapOnly);
                    },
                    /**
     * Wrap an object's coordinates (or several objects' coordinates) within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * If the object is outside any boundary edge (left, top, right, bottom), it will be moved to the same offset from the opposite edge (the interior).
     *
     * @method Phaser.Physics.Arcade.World#wrap
     * @since 3.3.0
     *
     * @param {any} object - A Game Object, a Group, an object with `x` and `y` coordinates, or an array of such objects.
     * @param {number} [padding=0] - An amount added to each boundary edge during the operation.
     */ wrap: function(object, padding) {
                        if (object.body) this.wrapObject(object, padding);
                        else if (object.getChildren) this.wrapArray(object.getChildren(), padding);
                        else if (Array.isArray(object)) this.wrapArray(object, padding);
                        else this.wrapObject(object, padding);
                    },
                    /**
     * Wrap each object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * @method Phaser.Physics.Arcade.World#wrapArray
     * @since 3.3.0
     *
     * @param {Array.<*>} objects - An array of objects to be wrapped.
     * @param {number} [padding=0] - An amount added to the boundary.
     */ wrapArray: function(objects, padding) {
                        for(var i = 0; i < objects.length; i++)this.wrapObject(objects[i], padding);
                    },
                    /**
     * Wrap an object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * @method Phaser.Physics.Arcade.World#wrapObject
     * @since 3.3.0
     *
     * @param {*} object - A Game Object, a Physics Body, or any object with `x` and `y` coordinates
     * @param {number} [padding=0] - An amount added to the boundary.
     */ wrapObject: function(object, padding) {
                        if (padding === undefined) padding = 0;
                        object.x = Wrap(object.x, this.bounds.left - padding, this.bounds.right + padding);
                        object.y = Wrap(object.y, this.bounds.top - padding, this.bounds.bottom + padding);
                    },
                    /**
     * Shuts down the simulation, clearing physics data and removing listeners.
     *
     * @method Phaser.Physics.Arcade.World#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        this.tree.clear();
                        this.staticTree.clear();
                        this.bodies.clear();
                        this.staticBodies.clear();
                        this.colliders.destroy();
                        this.removeAllListeners();
                    },
                    /**
     * Shuts down the simulation and disconnects it from the current scene.
     *
     * @method Phaser.Physics.Arcade.World#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.scene = null;
                        if (this.debugGraphic) {
                            this.debugGraphic.destroy();
                            this.debugGraphic = null;
                        }
                    }
                });
                module1.exports = World;
            /***/ },
            /***/ 1093: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the acceleration properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Acceleration
 * @since 3.0.0
 */ var Acceleration = {
                    /**
     * Sets the body's horizontal and vertical acceleration. If the vertical acceleration value is not provided, the vertical acceleration is set to the same value as the horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAcceleration
     * @since 3.0.0
     *
     * @param {number} x - The horizontal acceleration
     * @param {number} [y=x] - The vertical acceleration
     *
     * @return {this} This Game Object.
     */ setAcceleration: function(x, y) {
                        this.body.acceleration.set(x, y);
                        return this;
                    },
                    /**
     * Sets the body's horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationX
     * @since 3.0.0
     *
     * @param {number} value - The horizontal acceleration
     *
     * @return {this} This Game Object.
     */ setAccelerationX: function(value) {
                        this.body.acceleration.x = value;
                        return this;
                    },
                    /**
     * Sets the body's vertical acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationY
     * @since 3.0.0
     *
     * @param {number} value - The vertical acceleration
     *
     * @return {this} This Game Object.
     */ setAccelerationY: function(value) {
                        this.body.acceleration.y = value;
                        return this;
                    }
                };
                module1.exports = Acceleration;
            /***/ },
            /***/ 59023: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the angular acceleration properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Angular
 * @since 3.0.0
 */ var Angular = {
                    /**
     * Sets the angular velocity of the body.
     *
     * In Arcade Physics, bodies cannot rotate. They are always axis-aligned.
     * However, they can have angular motion, which is passed on to the Game Object bound to the body,
     * causing them to visually rotate, even though the body remains axis-aligned.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The amount of angular velocity.
     *
     * @return {this} This Game Object.
     */ setAngularVelocity: function(value) {
                        this.body.angularVelocity = value;
                        return this;
                    },
                    /**
     * Sets the angular acceleration of the body.
     *
     * In Arcade Physics, bodies cannot rotate. They are always axis-aligned.
     * However, they can have angular motion, which is passed on to the Game Object bound to the body,
     * causing them to visually rotate, even though the body remains axis-aligned.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularAcceleration
     * @since 3.0.0
     *
     * @param {number} value - The amount of angular acceleration.
     *
     * @return {this} This Game Object.
     */ setAngularAcceleration: function(value) {
                        this.body.angularAcceleration = value;
                        return this;
                    },
                    /**
     * Sets the angular drag of the body. Drag is applied to the current velocity, providing a form of deceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularDrag
     * @since 3.0.0
     *
     * @param {number} value - The amount of drag.
     *
     * @return {this} This Game Object.
     */ setAngularDrag: function(value) {
                        this.body.angularDrag = value;
                        return this;
                    }
                };
                module1.exports = Angular;
            /***/ },
            /***/ 62069: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the bounce properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Bounce
 * @since 3.0.0
 */ var Bounce = {
                    /**
     * Sets the bounce values of this body.
     *
     * Bounce is the amount of restitution, or elasticity, the body has when it collides with another object.
     * A value of 1 means that it will retain its full velocity after the rebound. A value of 0 means it will not rebound at all.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounce
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal bounce to apply on collision. A float, typically between 0 and 1.
     * @param {number} [y=x] - The amount of vertical bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounce: function(x, y) {
                        this.body.bounce.set(x, y);
                        return this;
                    },
                    /**
     * Sets the horizontal bounce value for this body.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceX
     * @since 3.0.0
     *
     * @param {number} value - The amount of horizontal bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounceX: function(value) {
                        this.body.bounce.x = value;
                        return this;
                    },
                    /**
     * Sets the vertical bounce value for this body.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceY
     * @since 3.0.0
     *
     * @param {number} value - The amount of vertical bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounceY: function(value) {
                        this.body.bounce.y = value;
                        return this;
                    },
                    /**
     * Sets whether this Body collides with the world boundary.
     *
     * Optionally also sets the World Bounce values. If the `Body.worldBounce` is null, it's set to a new Phaser.Math.Vector2 first.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setCollideWorldBounds
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - `true` if this body should collide with the world bounds, otherwise `false`.
     * @param {number} [bounceX] - If given this will be replace the `worldBounce.x` value.
     * @param {number} [bounceY] - If given this will be replace the `worldBounce.y` value.
     * @param {boolean} [onWorldBounds] - If given this replaces the Body's `onWorldBounds` value.
     *
     * @return {this} This Game Object.
     */ setCollideWorldBounds: function(value, bounceX, bounceY, onWorldBounds) {
                        this.body.setCollideWorldBounds(value, bounceX, bounceY, onWorldBounds);
                        return this;
                    }
                };
                module1.exports = Bounce;
            /***/ },
            /***/ 78389: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCollidesWith = __webpack_require__(79599);
                /**
 * Provides methods used for setting the collision category and mask of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Collision
 * @since 3.70.0
 */ var Collision = {
                    /**
     * Sets the Collision Category that this Arcade Physics Body
     * will use in order to determine what it can collide with.
     *
     * It can only have one single category assigned to it.
     *
     * If you wish to reset the collision category and mask, call
     * the `resetCollisionCategory` method.
     *
     * @method Phaser.Physics.Arcade.Components.Collision#setCollisionCategory
     * @since 3.70.0
     *
     * @param {number} category - The collision category.
     *
     * @return {this} This Game Object.
     */ setCollisionCategory: function(category) {
                        var target = this.body ? this.body : this;
                        target.collisionCategory = category;
                        return this;
                    },
                    /**
     * Checks to see if the given Collision Category will collide with
     * this Arcade Physics object or not.
     *
     * @method Phaser.Physics.Arcade.Components.Collision#willCollideWith
     * @since 3.70.0
     *
     * @param {number} category - Collision category value to test.
     *
     * @return {boolean} `true` if the given category will collide with this object, otherwise `false`.
     */ willCollideWith: function(category) {
                        var target = this.body ? this.body : this;
                        return (target.collisionMask & category) !== 0;
                    },
                    /**
     * Adds the given Collision Category to the list of those that this
     * Arcade Physics Body will collide with.
     *
     * @method Phaser.Physics.Arcade.Components.Collision#addCollidesWith
     * @since 3.70.0
     *
     * @param {number} category - The collision category to add.
     *
     * @return {this} This Game Object.
     */ addCollidesWith: function(category) {
                        var target = this.body ? this.body : this;
                        target.collisionMask = target.collisionMask | category;
                        return this;
                    },
                    /**
     * Removes the given Collision Category from the list of those that this
     * Arcade Physics Body will collide with.
     *
     * @method Phaser.Physics.Arcade.Components.Collision#removeCollidesWith
     * @since 3.70.0
     *
     * @param {number} category - The collision category to add.
     *
     * @return {this} This Game Object.
     */ removeCollidesWith: function(category) {
                        var target = this.body ? this.body : this;
                        target.collisionMask = target.collisionMask & ~category;
                        return this;
                    },
                    /**
     * Sets all of the Collision Categories that this Arcade Physics Body
     * will collide with. You can either pass a single category value, or
     * an array of them.
     *
     * Calling this method will reset all of the collision categories,
     * so only those passed to this method are enabled.
     *
     * If you wish to add a new category to the existing mask, call
     * the `addCollisionCategory` method.
     *
     * If you wish to reset the collision category and mask, call
     * the `resetCollisionCategory` method.
     *
     * @method Phaser.Physics.Arcade.Components.Collision#setCollidesWith
     * @since 3.70.0
     *
     * @param {(number|number[])} categories - The collision category to collide with, or an array of them.
     *
     * @return {this} This Game Object.
     */ setCollidesWith: function(categories) {
                        var target = this.body ? this.body : this;
                        target.collisionMask = GetCollidesWith(categories);
                        return this;
                    },
                    /**
     * Resets the Collision Category and Mask back to the defaults,
     * which is to collide with everything.
     *
     * @method Phaser.Physics.Arcade.Components.Collision#resetCollisionCategory
     * @since 3.70.0
     *
     * @return {this} This Game Object.
     */ resetCollisionCategory: function() {
                        var target = this.body ? this.body : this;
                        target.collisionCategory = 0x0001;
                        target.collisionMask = 2147483647;
                        return this;
                    }
                };
                module1.exports = Collision;
            /***/ },
            /***/ 87118: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the debug properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Debug
 * @since 3.0.0
 */ var Debug = {
                    /**
     * Sets the debug values of this body.
     *
     * Bodies will only draw their debug if debug has been enabled for Arcade Physics as a whole.
     * Note that there is a performance cost in drawing debug displays. It should never be used in production.
     *
     * @method Phaser.Physics.Arcade.Components.Debug#setDebug
     * @since 3.0.0
     *
     * @param {boolean} showBody - Set to `true` to have this body render its outline to the debug display.
     * @param {boolean} showVelocity - Set to `true` to have this body render a velocity marker to the debug display.
     * @param {number} bodyColor - The color of the body outline when rendered to the debug display.
     *
     * @return {this} This Game Object.
     */ setDebug: function(showBody, showVelocity, bodyColor) {
                        this.debugShowBody = showBody;
                        this.debugShowVelocity = showVelocity;
                        this.debugBodyColor = bodyColor;
                        return this;
                    },
                    /**
     * Sets the color of the body outline when it renders to the debug display.
     *
     * @method Phaser.Physics.Arcade.Components.Debug#setDebugBodyColor
     * @since 3.0.0
     *
     * @param {number} value - The color of the body outline when rendered to the debug display.
     *
     * @return {this} This Game Object.
     */ setDebugBodyColor: function(value) {
                        this.body.debugBodyColor = value;
                        return this;
                    },
                    /**
     * Set to `true` to have this body render its outline to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugShowBody
     * @type {boolean}
     * @since 3.0.0
     */ debugShowBody: {
                        get: function() {
                            return this.body.debugShowBody;
                        },
                        set: function(value) {
                            this.body.debugShowBody = value;
                        }
                    },
                    /**
     * Set to `true` to have this body render a velocity marker to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugShowVelocity
     * @type {boolean}
     * @since 3.0.0
     */ debugShowVelocity: {
                        get: function() {
                            return this.body.debugShowVelocity;
                        },
                        set: function(value) {
                            this.body.debugShowVelocity = value;
                        }
                    },
                    /**
     * The color of the body outline when it renders to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugBodyColor
     * @type {number}
     * @since 3.0.0
     */ debugBodyColor: {
                        get: function() {
                            return this.body.debugBodyColor;
                        },
                        set: function(value) {
                            this.body.debugBodyColor = value;
                        }
                    }
                };
                module1.exports = Debug;
            /***/ },
            /***/ 52819: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the drag properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Drag
 * @since 3.0.0
 */ var Drag = {
                    /**
     * Sets the body's horizontal and vertical drag. If the vertical drag value is not provided, the vertical drag is set to the same value as the horizontal drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDrag
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal drag to apply.
     * @param {number} [y=x] - The amount of vertical drag to apply.
     *
     * @return {this} This Game Object.
     */ setDrag: function(x, y) {
                        this.body.drag.set(x, y);
                        return this;
                    },
                    /**
     * Sets the body's horizontal drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDragX
     * @since 3.0.0
     *
     * @param {number} value - The amount of horizontal drag to apply.
     *
     * @return {this} This Game Object.
     */ setDragX: function(value) {
                        this.body.drag.x = value;
                        return this;
                    },
                    /**
     * Sets the body's vertical drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDragY
     * @since 3.0.0
     *
     * @param {number} value - The amount of vertical drag to apply.
     *
     * @return {this} This Game Object.
     */ setDragY: function(value) {
                        this.body.drag.y = value;
                        return this;
                    },
                    /**
     * If this Body is using `drag` for deceleration this function controls how the drag is applied.
     * If set to `true` drag will use a damping effect rather than a linear approach. If you are
     * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
     * the game Asteroids) then you will get a far smoother and more visually correct deceleration
     * by using damping, avoiding the axis-drift that is prone with linear deceleration.
     *
     * If you enable this property then you should use far smaller `drag` values than with linear, as
     * they are used as a multiplier on the velocity. Values such as 0.95 will give a nice slow
     * deceleration, where-as smaller values, such as 0.5 will stop an object almost immediately.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDamping
     * @since 3.10.0
     *
     * @param {boolean} value - `true` to use damping for deceleration, or `false` to use linear deceleration.
     *
     * @return {this} This Game Object.
     */ setDamping: function(value) {
                        this.body.useDamping = value;
                        return this;
                    }
                };
                module1.exports = Drag;
            /***/ },
            /***/ 4074: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the enable properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Enable
 * @since 3.0.0
 */ var Enable = {
                    /**
     * Sets whether this Body should calculate its velocity based on its change in
     * position every frame. The default, which is to not do this, means that you
     * make this Body move by setting the velocity directly. However, if you are
     * trying to move this Body via a Tween, or have it follow a Path, then you
     * should enable this instead. This will allow it to still collide with other
     * bodies, something that isn't possible if you're just changing its position directly.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#setDirectControl
     * @since 3.70.0
     *
     * @param {boolean} [value=true] - `true` if the Body calculate velocity based on changes in position, otherwise `false`.
     *
     * @return {this} This Game Object.
     */ setDirectControl: function(value) {
                        this.body.setDirectControl(value);
                        return this;
                    },
                    /**
     * Enables this Game Object's Body.
     * If you reset the Body you must also pass `x` and `y`.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#enableBody
     * @since 3.0.0
     *
     * @param {boolean} [reset] - Also reset the Body and place the Game Object at (x, y).
     * @param {number} [x] - The horizontal position to place the Game Object, if `reset` is true.
     * @param {number} [y] - The horizontal position to place the Game Object, if `reset` is true.
     * @param {boolean} [enableGameObject] - Also set this Game Object's `active` to true.
     * @param {boolean} [showGameObject] - Also set this Game Object's `visible` to true.
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#enable
     * @see Phaser.Physics.Arcade.StaticBody#enable
     * @see Phaser.Physics.Arcade.Body#reset
     * @see Phaser.Physics.Arcade.StaticBody#reset
     * @see Phaser.GameObjects.GameObject#active
     * @see Phaser.GameObjects.GameObject#visible
     */ enableBody: function(reset, x, y, enableGameObject, showGameObject) {
                        if (reset) this.body.reset(x, y);
                        if (enableGameObject) this.body.gameObject.active = true;
                        if (showGameObject) this.body.gameObject.visible = true;
                        this.body.enable = true;
                        return this;
                    },
                    /**
     * Stops and disables this Game Object's Body.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#disableBody
     * @since 3.0.0
     *
     * @param {boolean} [disableGameObject=false] - Also set this Game Object's `active` to false.
     * @param {boolean} [hideGameObject=false] - Also set this Game Object's `visible` to false.
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#enable
     * @see Phaser.Physics.Arcade.StaticBody#enable
     * @see Phaser.GameObjects.GameObject#active
     * @see Phaser.GameObjects.GameObject#visible
     */ disableBody: function(disableGameObject, hideGameObject) {
                        if (disableGameObject === undefined) disableGameObject = false;
                        if (hideGameObject === undefined) hideGameObject = false;
                        this.body.stop();
                        this.body.enable = false;
                        if (disableGameObject) this.body.gameObject.active = false;
                        if (hideGameObject) this.body.gameObject.visible = false;
                        return this;
                    },
                    /**
     * Syncs the Body's position and size with its parent Game Object.
     * You don't need to call this for Dynamic Bodies, as it happens automatically.
     * But for Static bodies it's a useful way of modifying the position of a Static Body
     * in the Physics World, based on its Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#refreshBody
     * @since 3.1.0
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     */ refreshBody: function() {
                        this.body.updateFromGameObject();
                        return this;
                    }
                };
                module1.exports = Enable;
            /***/ },
            /***/ 40831: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Methods for setting the friction of an Arcade Physics Body.
 *
 * In Arcade Physics, friction is a special case of motion transfer from an "immovable" body to a riding body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Friction
 * @since 3.0.0
 *
 * @see Phaser.Physics.Arcade.Body#friction
 */ var Friction = {
                    /**
     * Sets the friction of this game object's physics body.
     * In Arcade Physics, friction is a special case of motion transfer from an "immovable" body to a riding body.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFriction
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal friction to apply, [0, 1].
     * @param {number} [y=x] - The amount of vertical friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFriction: function(x, y) {
                        this.body.friction.set(x, y);
                        return this;
                    },
                    /**
     * Sets the horizontal friction of this game object's physics body.
     * This can move a riding body horizontally when it collides with this one on the vertical axis.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionX
     * @since 3.0.0
     *
     * @param {number} x - The amount of friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFrictionX: function(x) {
                        this.body.friction.x = x;
                        return this;
                    },
                    /**
     * Sets the vertical friction of this game object's physics body.
     * This can move a riding body vertically when it collides with this one on the horizontal axis.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionY
     * @since 3.0.0
     *
     * @param {number} y - The amount of friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFrictionY: function(y) {
                        this.body.friction.y = y;
                        return this;
                    }
                };
                module1.exports = Friction;
            /***/ },
            /***/ 26775: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for setting the gravity properties of an Arcade Physics Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Gravity
 * @since 3.0.0
 */ var Gravity = {
                    /**
     * Set the X and Y values of the gravitational pull to act upon this Arcade Physics Game Object. Values can be positive or negative. Larger values result in a stronger effect.
     *
     * If only one value is provided, this value will be used for both the X and Y axis.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravity
     * @since 3.0.0
     *
     * @param {number} x - The gravitational force to be applied to the X-axis.
     * @param {number} [y=x] - The gravitational force to be applied to the Y-axis. If this is not specified, the X value will be used.
     *
     * @return {this} This Game Object.
     */ setGravity: function(x, y) {
                        this.body.gravity.set(x, y);
                        return this;
                    },
                    /**
     * Set the gravitational force to be applied to the X axis. Value can be positive or negative. Larger values result in a stronger effect.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityX
     * @since 3.0.0
     *
     * @param {number} x - The gravitational force to be applied to the X-axis.
     *
     * @return {this} This Game Object.
     */ setGravityX: function(x) {
                        this.body.gravity.x = x;
                        return this;
                    },
                    /**
     * Set the gravitational force to be applied to the Y axis. Value can be positive or negative. Larger values result in a stronger effect.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityY
     * @since 3.0.0
     *
     * @param {number} y - The gravitational force to be applied to the Y-axis.
     *
     * @return {this} This Game Object.
     */ setGravityY: function(y) {
                        this.body.gravity.y = y;
                        return this;
                    }
                };
                module1.exports = Gravity;
            /***/ },
            /***/ 9437: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the immovable properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Immovable
 * @since 3.0.0
 */ var Immovable = {
                    /**
     * Sets if this Body can be separated during collisions with other bodies.
     *
     * When a body is immovable it means it won't move at all, not even to separate it from collision
     * overlap. If you just wish to prevent a body from being knocked around by other bodies, see
     * the `setPushable` method instead.
     *
     * @method Phaser.Physics.Arcade.Components.Immovable#setImmovable
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Sets if this body will be separated during collisions with other bodies.
     *
     * @return {this} This Game Object.
     */ setImmovable: function(value) {
                        if (value === undefined) value = true;
                        this.body.immovable = value;
                        return this;
                    }
                };
                module1.exports = Immovable;
            /***/ },
            /***/ 30621: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the mass properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Mass
 * @since 3.0.0
 */ var Mass = {
                    /**
     * Sets the mass of the physics body
     *
     * @method Phaser.Physics.Arcade.Components.Mass#setMass
     * @since 3.0.0
     *
     * @param {number} value - New value for the mass of the body.
     *
     * @return {this} This Game Object.
     */ setMass: function(value) {
                        this.body.mass = value;
                        return this;
                    }
                };
                module1.exports = Mass;
            /***/ },
            /***/ 72441: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var OverlapRect = __webpack_require__(47956);
                var Circle = __webpack_require__(96503);
                var CircleToCircle = __webpack_require__(2044);
                var CircleToRectangle = __webpack_require__(81491);
                /**
 * This method will search the given circular area and return an array of all physics bodies that
 * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
 *
 * A body only has to intersect with the search area to be considered, it doesn't have to be fully
 * contained within it.
 *
 * If Arcade Physics is set to use the RTree (which it is by default) then the search is rather fast,
 * otherwise the search is O(N) for Dynamic Bodies.
 *
 * @function Phaser.Physics.Arcade.Components.OverlapCirc
 * @since 3.21.0
 *
 * @param {number} x - The x coordinate of the center of the area to search within.
 * @param {number} y - The y coordinate of the center of the area to search within.
 * @param {number} radius - The radius of the area to search within.
 * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
 * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
 *
 * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
 */ var OverlapCirc = function(world, x, y, radius, includeDynamic, includeStatic) {
                    var bodiesInRect = OverlapRect(world, x - radius, y - radius, 2 * radius, 2 * radius, includeDynamic, includeStatic);
                    if (bodiesInRect.length === 0) return bodiesInRect;
                    var area = new Circle(x, y, radius);
                    var circFromBody = new Circle();
                    var bodiesInArea = [];
                    for(var i = 0; i < bodiesInRect.length; i++){
                        var body = bodiesInRect[i];
                        if (body.isCircle) {
                            circFromBody.setTo(body.center.x, body.center.y, body.halfWidth);
                            if (CircleToCircle(area, circFromBody)) bodiesInArea.push(body);
                        } else if (CircleToRectangle(area, body)) bodiesInArea.push(body);
                    }
                    return bodiesInArea;
                };
                module1.exports = OverlapCirc;
            /***/ },
            /***/ 47956: /***/ (module1)=>{
                /**
 * This method will search the given rectangular area and return an array of all physics bodies that
 * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
 * 
 * A body only has to intersect with the search area to be considered, it doesn't have to be fully
 * contained within it.
 * 
 * If Arcade Physics is set to use the RTree (which it is by default) then the search for is extremely fast,
 * otherwise the search is O(N) for Dynamic Bodies.
 *
 * @function Phaser.Physics.Arcade.Components.OverlapRect
 * @since 3.17.0
 *
 * @param {number} x - The top-left x coordinate of the area to search within.
 * @param {number} y - The top-left y coordinate of the area to search within.
 * @param {number} width - The width of the area to search within.
 * @param {number} height - The height of the area to search within.
 * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
 * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
 *
 * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
 */ var OverlapRect = function(world, x, y, width, height, includeDynamic, includeStatic) {
                    if (includeDynamic === undefined) includeDynamic = true;
                    if (includeStatic === undefined) includeStatic = false;
                    var dynamicBodies = [];
                    var staticBodies = [];
                    var minMax = world.treeMinMax;
                    minMax.minX = x;
                    minMax.minY = y;
                    minMax.maxX = x + width;
                    minMax.maxY = y + height;
                    if (includeStatic) staticBodies = world.staticTree.search(minMax);
                    if (includeDynamic && world.useTree) dynamicBodies = world.tree.search(minMax);
                    else if (includeDynamic) {
                        var bodies = world.bodies;
                        var fakeBody = {
                            position: {
                                x: x,
                                y: y
                            },
                            left: x,
                            top: y,
                            right: x + width,
                            bottom: y + height,
                            isCircle: false
                        };
                        var intersects = world.intersects;
                        bodies.iterate(function(target) {
                            if (intersects(target, fakeBody)) dynamicBodies.push(target);
                        });
                    }
                    return staticBodies.concat(dynamicBodies);
                };
                module1.exports = OverlapRect;
            /***/ },
            /***/ 62121: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the pushable property of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Pushable
 * @since 3.50.0
 */ var Pushable = {
                    /**
     * Sets if this Body can be pushed by another Body.
     *
     * A body that cannot be pushed will reflect back all of the velocity it is given to the
     * colliding body. If that body is also not pushable, then the separation will be split
     * between them evenly.
     *
     * If you want your body to never move or seperate at all, see the `setImmovable` method.
     *
     * @method Phaser.Physics.Arcade.Components.Pushable#setPushable
     * @since 3.50.0
     *
     * @param {boolean} [value=true] - Sets if this body can be pushed by collisions with another Body.
     *
     * @return {this} This Game Object.
     */ setPushable: function(value) {
                        if (value === undefined) value = true;
                        this.body.pushable = value;
                        return this;
                    }
                };
                module1.exports = Pushable;
            /***/ },
            /***/ 29384: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for setting the size of an Arcade Physics Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Size
 * @since 3.0.0
 */ var Size = {
                    /**
     * Sets the body offset. This allows you to adjust the difference between the center of the body
     * and the x and y coordinates of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setOffset
     * @since 3.0.0
     *
     * @param {number} x - The amount to offset the body from the parent Game Object along the x-axis.
     * @param {number} [y=x] - The amount to offset the body from the parent Game Object along the y-axis. Defaults to the value given for the x-axis.
     *
     * @return {this} This Game Object.
     */ setOffset: function(x, y) {
                        this.body.setOffset(x, y);
                        return this;
                    },
                    /**
     * **DEPRECATED**: Please use `setBodySize` instead.
     *
     * Sets the size of this physics body. Setting the size does not adjust the dimensions of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setSize
     * @since 3.0.0
     * @deprecated
     *
     * @param {number} width - The new width of the physics body, in pixels.
     * @param {number} height - The new height of the physics body, in pixels.
     * @param {boolean} [center=true] - Should the body be re-positioned so its center aligns with the parent Game Object?
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height, center) {
                        this.body.setSize(width, height, center);
                        return this;
                    },
                    /**
     * Sets the size of this physics body. Setting the size does not adjust the dimensions of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setBodySize
     * @since 3.24.0
     *
     * @param {number} width - The new width of the physics body, in pixels.
     * @param {number} height - The new height of the physics body, in pixels.
     * @param {boolean} [center=true] - Should the body be re-positioned so its center aligns with the parent Game Object?
     *
     * @return {this} This Game Object.
     */ setBodySize: function(width, height, center) {
                        this.body.setSize(width, height, center);
                        return this;
                    },
                    /**
     * Sets this physics body to use a circle for collision instead of a rectangle.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the physics body, in pixels.
     * @param {number} [offsetX] - The amount to offset the body from the parent Game Object along the x-axis.
     * @param {number} [offsetY] - The amount to offset the body from the parent Game Object along the y-axis.
     *
     * @return {this} This Game Object.
     */ setCircle: function(radius, offsetX, offsetY) {
                        this.body.setCircle(radius, offsetX, offsetY);
                        return this;
                    }
                };
                module1.exports = Size;
            /***/ },
            /***/ 15098: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for modifying the velocity of an Arcade Physics body.
 *
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Velocity
 * @since 3.0.0
 */ var Velocity = {
                    /**
     * Sets the velocity of the Body.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity of the body, in pixels per second. Positive values move the body to the right, while negative values move it to the left.
     * @param {number} [y=x] - The vertical velocity of the body, in pixels per second. Positive values move the body down, while negative values move it up.
     *
     * @return {this} This Game Object.
     */ setVelocity: function(x, y) {
                        this.body.setVelocity(x, y);
                        return this;
                    },
                    /**
     * Sets the horizontal component of the body's velocity.
     *
     * Positive values move the body to the right, while negative values move it to the left.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityX
     * @since 3.0.0
     *
     * @param {number} x - The new horizontal velocity, in pixels per second.
     *
     * @return {this} This Game Object.
     */ setVelocityX: function(x) {
                        this.body.setVelocityX(x);
                        return this;
                    },
                    /**
     * Sets the vertical component of the body's velocity.
     *
     * Positive values move the body down, while negative values move it up.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityY
     * @since 3.0.0
     *
     * @param {number} y - The new vertical velocity, in pixels per second.
     *
     * @return {this} This Game Object.
     */ setVelocityY: function(y) {
                        this.body.setVelocityY(y);
                        return this;
                    },
                    /**
     * Sets the maximum velocity of the body.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setMaxVelocity
     * @since 3.0.0
     *
     * @param {number} x - The new maximum horizontal velocity, in pixels per second.
     * @param {number} [y=x] - The new maximum vertical velocity, in pixels per second.
     *
     * @return {this} This Game Object.
     */ setMaxVelocity: function(x, y) {
                        this.body.maxVelocity.set(x, y);
                        return this;
                    }
                };
                module1.exports = Velocity;
            /***/ },
            /***/ 92209: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Components
 */ module1.exports = {
                    Acceleration: __webpack_require__(1093),
                    Angular: __webpack_require__(59023),
                    Bounce: __webpack_require__(62069),
                    Collision: __webpack_require__(78389),
                    Debug: __webpack_require__(87118),
                    Drag: __webpack_require__(52819),
                    Enable: __webpack_require__(4074),
                    Friction: __webpack_require__(40831),
                    Gravity: __webpack_require__(26775),
                    Immovable: __webpack_require__(9437),
                    Mass: __webpack_require__(30621),
                    OverlapCirc: __webpack_require__(72441),
                    OverlapRect: __webpack_require__(47956),
                    Pushable: __webpack_require__(62121),
                    Size: __webpack_require__(29384),
                    Velocity: __webpack_require__(15098)
                };
            /***/ },
            /***/ 37747: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Arcade Physics consts.
 *
 * @ignore
 */ var CONST = {
                    /**
     * Dynamic Body.
     *
     * @name Phaser.Physics.Arcade.DYNAMIC_BODY
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#physicsType
     * @see Phaser.Physics.Arcade.Group#physicsType
     */ DYNAMIC_BODY: 0,
                    /**
     * Static Body.
     *
     * @name Phaser.Physics.Arcade.STATIC_BODY
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#physicsType
     * @see Phaser.Physics.Arcade.StaticBody#physicsType
     */ STATIC_BODY: 1,
                    /**
     * Arcade Physics Group containing Dynamic Bodies.
     *
     * @name Phaser.Physics.Arcade.GROUP
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ GROUP: 2,
                    /**
     * A Tilemap Layer.
     *
     * @name Phaser.Physics.Arcade.TILEMAPLAYER
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ TILEMAPLAYER: 3,
                    /**
     * Facing no direction (initial value).
     *
     * @name Phaser.Physics.Arcade.FACING_NONE
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_NONE: 10,
                    /**
     * Facing up.
     *
     * @name Phaser.Physics.Arcade.FACING_UP
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_UP: 11,
                    /**
     * Facing down.
     *
     * @name Phaser.Physics.Arcade.FACING_DOWN
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_DOWN: 12,
                    /**
     * Facing left.
     *
     * @name Phaser.Physics.Arcade.FACING_LEFT
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_LEFT: 13,
                    /**
     * Facing right.
     *
     * @name Phaser.Physics.Arcade.FACING_RIGHT
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_RIGHT: 14
                };
                module1.exports = CONST;
            /***/ },
            /***/ 20009: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Collide Event.
 *
 * This event is dispatched by an Arcade Physics World instance if two bodies collide _and_ at least
 * one of them has their [onCollide]{@link Phaser.Physics.Arcade.Body#onCollide} property set to `true`.
 *
 * It provides an alternative means to handling collide events rather than using the callback approach.
 *
 * Listen to it from a Scene using: `this.physics.world.on('collide', listener)`.
 *
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#COLLIDE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject1 - The first Game Object involved in the collision. This is the parent of `body1`.
 * @param {Phaser.GameObjects.GameObject} gameObject2 - The second Game Object involved in the collision. This is the parent of `body2`.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1 - The first Physics Body involved in the collision.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2 - The second Physics Body involved in the collision.
 */ module1.exports = 'collide';
            /***/ },
            /***/ 36768: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Overlap Event.
 *
 * This event is dispatched by an Arcade Physics World instance if two bodies overlap _and_ at least
 * one of them has their [onOverlap]{@link Phaser.Physics.Arcade.Body#onOverlap} property set to `true`.
 *
 * It provides an alternative means to handling overlap events rather than using the callback approach.
 *
 * Listen to it from a Scene using: `this.physics.world.on('overlap', listener)`.
 *
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#OVERLAP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject1 - The first Game Object involved in the overlap. This is the parent of `body1`.
 * @param {Phaser.GameObjects.GameObject} gameObject2 - The second Game Object involved in the overlap. This is the parent of `body2`.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1 - The first Physics Body involved in the overlap.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2 - The second Physics Body involved in the overlap.
 */ module1.exports = 'overlap';
            /***/ },
            /***/ 60473: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Pause Event.
 *
 * This event is dispatched by an Arcade Physics World instance when it is paused.
 *
 * Listen to it from a Scene using: `this.physics.world.on('pause', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#PAUSE
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'pause';
            /***/ },
            /***/ 89954: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Resume Event.
 *
 * This event is dispatched by an Arcade Physics World instance when it resumes from a paused state.
 *
 * Listen to it from a Scene using: `this.physics.world.on('resume', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#RESUME
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'resume';
            /***/ },
            /***/ 61804: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics Tile Collide Event.
 *
 * This event is dispatched by an Arcade Physics World instance if a body collides with a Tile _and_
 * has its [onCollide]{@link Phaser.Physics.Arcade.Body#onCollide} property set to `true`.
 *
 * It provides an alternative means to handling collide events rather than using the callback approach.
 *
 * Listen to it from a Scene using: `this.physics.world.on('tilecollide', listener)`.
 *
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#TILE_COLLIDE
 * @type {string}
 * @since 3.16.1
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object involved in the collision. This is the parent of `body`.
 * @param {Phaser.Tilemaps.Tile} tile - The tile the body collided with.
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body of the Game Object involved in the collision.
 */ module1.exports = 'tilecollide';
            /***/ },
            /***/ 7161: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics Tile Overlap Event.
 *
 * This event is dispatched by an Arcade Physics World instance if a body overlaps with a Tile _and_
 * has its [onOverlap]{@link Phaser.Physics.Arcade.Body#onOverlap} property set to `true`.
 *
 * It provides an alternative means to handling overlap events rather than using the callback approach.
 *
 * Listen to it from a Scene using: `this.physics.world.on('tileoverlap', listener)`.
 *
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#TILE_OVERLAP
 * @type {string}
 * @since 3.16.1
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object involved in the overlap. This is the parent of `body`.
 * @param {Phaser.Tilemaps.Tile} tile - The tile the body overlapped.
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body of the Game Object involved in the overlap.
 */ module1.exports = 'tileoverlap';
            /***/ },
            /***/ 34689: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Bounds Event.
 *
 * This event is dispatched by an Arcade Physics World instance if a body makes contact with the world bounds _and_
 * it has its [onWorldBounds]{@link Phaser.Physics.Arcade.Body#onWorldBounds} property set to `true`.
 *
 * It provides an alternative means to handling collide events rather than using the callback approach.
 *
 * Listen to it from a Scene using: `this.physics.world.on('worldbounds', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#WORLD_BOUNDS
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body that hit the world bounds.
 * @param {boolean} up - Is the Body blocked up? I.e. collided with the top of the world bounds.
 * @param {boolean} down - Is the Body blocked down? I.e. collided with the bottom of the world bounds.
 * @param {boolean} left - Is the Body blocked left? I.e. collided with the left of the world bounds.
 * @param {boolean} right - Is the Body blocked right? I.e. collided with the right of the world bounds.
 */ module1.exports = 'worldbounds';
            /***/ },
            /***/ 16006: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Step Event.
 *
 * This event is dispatched by an Arcade Physics World instance whenever a physics step is run.
 * It is emitted _after_ the bodies and colliders have been updated.
 *
 * In high framerate settings this can be multiple times per game frame.
 *
 * Listen to it from a Scene using: `this.physics.world.on('worldstep', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#WORLD_STEP
 * @type {string}
 * @since 3.18.0
 *
 * @param {number} delta - The delta time amount of this step, in seconds.
 */ module1.exports = 'worldstep';
            /***/ },
            /***/ 63012: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Events
 */ module1.exports = {
                    COLLIDE: __webpack_require__(20009),
                    OVERLAP: __webpack_require__(36768),
                    PAUSE: __webpack_require__(60473),
                    RESUME: __webpack_require__(89954),
                    TILE_COLLIDE: __webpack_require__(61804),
                    TILE_OVERLAP: __webpack_require__(7161),
                    WORLD_BOUNDS: __webpack_require__(34689),
                    WORLD_STEP: __webpack_require__(16006)
                };
            /***/ },
            /***/ 27064: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(37747);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Physics.Arcade
 */ var Arcade = {
                    ArcadePhysics: __webpack_require__(86689),
                    Body: __webpack_require__(37742),
                    Collider: __webpack_require__(79342),
                    Components: __webpack_require__(92209),
                    Events: __webpack_require__(63012),
                    Factory: __webpack_require__(66022),
                    GetCollidesWith: __webpack_require__(79599),
                    GetOverlapX: __webpack_require__(64897),
                    GetOverlapY: __webpack_require__(45170),
                    SeparateX: __webpack_require__(14087),
                    SeparateY: __webpack_require__(89936),
                    Group: __webpack_require__(60758),
                    Image: __webpack_require__(71289),
                    Sprite: __webpack_require__(13759),
                    StaticBody: __webpack_require__(72624),
                    StaticGroup: __webpack_require__(71464),
                    Tilemap: __webpack_require__(55173),
                    World: __webpack_require__(82248)
                };
                //   Merge in the consts
                Arcade = Extend(false, Arcade, CONST);
                module1.exports = Arcade;
            /***/ },
            /***/ 96602: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A function to process the collision callbacks between a single tile and an Arcade Physics enabled Game Object.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileCallbacks
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.Tile} tile - The Tile to process.
 * @param {Phaser.GameObjects.Sprite} sprite - The Game Object to process with the Tile.
 *
 * @return {boolean} The result of the callback, `true` for further processing, or `false` to skip this pair.
 */ var ProcessTileCallbacks = function(tile, sprite) {
                    //  Tile callbacks take priority over layer level callbacks
                    if (tile.collisionCallback) return !tile.collisionCallback.call(tile.collisionCallbackContext, sprite, tile);
                    else if (tile.layer.callbacks[tile.index]) return !tile.layer.callbacks[tile.index].callback.call(tile.layer.callbacks[tile.index].callbackContext, sprite, tile);
                    return true;
                };
                module1.exports = ProcessTileCallbacks;
            /***/ },
            /***/ 36294: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function to process the separation of a physics body from a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {number} x - The x separation amount.
 */ var ProcessTileSeparationX = function(body, x) {
                    if (x < 0) {
                        body.blocked.none = false;
                        body.blocked.left = true;
                    } else if (x > 0) {
                        body.blocked.none = false;
                        body.blocked.right = true;
                    }
                    body.position.x -= x;
                    body.updateCenter();
                    if (body.bounce.x === 0) body.velocity.x = 0;
                    else body.velocity.x = -body.velocity.x * body.bounce.x;
                };
                module1.exports = ProcessTileSeparationX;
            /***/ },
            /***/ 67013: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function to process the separation of a physics body from a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {number} y - The y separation amount.
 */ var ProcessTileSeparationY = function(body, y) {
                    if (y < 0) {
                        body.blocked.none = false;
                        body.blocked.up = true;
                    } else if (y > 0) {
                        body.blocked.none = false;
                        body.blocked.down = true;
                    }
                    body.position.y -= y;
                    body.updateCenter();
                    if (body.bounce.y === 0) body.velocity.y = 0;
                    else body.velocity.y = -body.velocity.y * body.bounce.y;
                };
                module1.exports = ProcessTileSeparationY;
            /***/ },
            /***/ 40012: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileCheckX = __webpack_require__(21329);
                var TileCheckY = __webpack_require__(53442);
                var TileIntersectsBody = __webpack_require__(2483);
                /**
 * The core separation function to separate a physics body and a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.SeparateTile
 * @since 3.0.0
 *
 * @param {number} i - The index of the tile within the map data.
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to collide against.
 * @param {Phaser.Geom.Rectangle} tileWorldRect - A rectangle-like object defining the dimensions of the tile.
 * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The tilemapLayer to collide against.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {boolean} `true` if the body was separated, otherwise `false`.
 */ var SeparateTile = function(i, body, tile, tileWorldRect, tilemapLayer, tileBias, isLayer) {
                    var tileLeft = tileWorldRect.left;
                    var tileTop = tileWorldRect.top;
                    var tileRight = tileWorldRect.right;
                    var tileBottom = tileWorldRect.bottom;
                    var faceHorizontal = tile.faceLeft || tile.faceRight;
                    var faceVertical = tile.faceTop || tile.faceBottom;
                    if (!isLayer) {
                        faceHorizontal = true;
                        faceVertical = true;
                    }
                    //  We don't need to go any further if this tile doesn't actually have any colliding faces. This
                    //  could happen if the tile was meant to be collided with re: a callback, but otherwise isn't
                    //  needed for separation.
                    if (!faceHorizontal && !faceVertical) return false;
                    var ox = 0;
                    var oy = 0;
                    var minX = 0;
                    var minY = 1;
                    if (body.deltaAbsX() > body.deltaAbsY()) //  Moving faster horizontally, check X axis first
                    minX = -1;
                    else if (body.deltaAbsX() < body.deltaAbsY()) //  Moving faster vertically, check Y axis first
                    minY = -1;
                    if (body.deltaX() !== 0 && body.deltaY() !== 0 && faceHorizontal && faceVertical) {
                        //  We only need do this if both axes have colliding faces AND we're moving in both
                        //  directions
                        minX = Math.min(Math.abs(body.position.x - tileRight), Math.abs(body.right - tileLeft));
                        minY = Math.min(Math.abs(body.position.y - tileBottom), Math.abs(body.bottom - tileTop));
                    }
                    if (minX < minY) {
                        if (faceHorizontal) {
                            ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias, isLayer);
                            //  That's horizontal done, check if we still intersects? If not then we can return now
                            if (ox !== 0 && !TileIntersectsBody(tileWorldRect, body)) return true;
                        }
                        if (faceVertical) oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias, isLayer);
                    } else {
                        if (faceVertical) {
                            oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias, isLayer);
                            //  That's vertical done, check if we still intersects? If not then we can return now
                            if (oy !== 0 && !TileIntersectsBody(tileWorldRect, body)) return true;
                        }
                        if (faceHorizontal) ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias, isLayer);
                    }
                    return ox !== 0 || oy !== 0;
                };
                module1.exports = SeparateTile;
            /***/ },
            /***/ 21329: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ProcessTileSeparationX = __webpack_require__(36294);
                /**
 * Check the body against the given tile on the X axis.
 * Used internally by the SeparateTile function.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileCheckX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
 * @param {number} tileLeft - The left position of the tile within the tile world.
 * @param {number} tileRight - The right position of the tile within the tile world.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {number} The amount of separation that occurred.
 */ var TileCheckX = function(body, tile, tileLeft, tileRight, tileBias, isLayer) {
                    var ox = 0;
                    var faceLeft = tile.faceLeft;
                    var faceRight = tile.faceRight;
                    var collideLeft = tile.collideLeft;
                    var collideRight = tile.collideRight;
                    if (!isLayer) {
                        faceLeft = true;
                        faceRight = true;
                        collideLeft = true;
                        collideRight = true;
                    }
                    if (body.deltaX() < 0 && collideRight && body.checkCollision.left) //  Body is moving LEFT
                    {
                        if (faceRight && body.x < tileRight) {
                            ox = body.x - tileRight;
                            if (ox < -tileBias) ox = 0;
                        }
                    } else if (body.deltaX() > 0 && collideLeft && body.checkCollision.right) //  Body is moving RIGHT
                    {
                        if (faceLeft && body.right > tileLeft) {
                            ox = body.right - tileLeft;
                            if (ox > tileBias) ox = 0;
                        }
                    }
                    if (ox !== 0) {
                        if (body.customSeparateX) body.overlapX = ox;
                        else ProcessTileSeparationX(body, ox);
                    }
                    return ox;
                };
                module1.exports = TileCheckX;
            /***/ },
            /***/ 53442: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ProcessTileSeparationY = __webpack_require__(67013);
                /**
 * Check the body against the given tile on the Y axis.
 * Used internally by the SeparateTile function.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileCheckY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
 * @param {number} tileTop - The top position of the tile within the tile world.
 * @param {number} tileBottom - The bottom position of the tile within the tile world.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {number} The amount of separation that occurred.
 */ var TileCheckY = function(body, tile, tileTop, tileBottom, tileBias, isLayer) {
                    var oy = 0;
                    var faceTop = tile.faceTop;
                    var faceBottom = tile.faceBottom;
                    var collideUp = tile.collideUp;
                    var collideDown = tile.collideDown;
                    if (!isLayer) {
                        faceTop = true;
                        faceBottom = true;
                        collideUp = true;
                        collideDown = true;
                    }
                    if (body.deltaY() < 0 && collideDown && body.checkCollision.up) //  Body is moving UP
                    {
                        if (faceBottom && body.y < tileBottom) {
                            oy = body.y - tileBottom;
                            if (oy < -tileBias) oy = 0;
                        }
                    } else if (body.deltaY() > 0 && collideUp && body.checkCollision.down) //  Body is moving DOWN
                    {
                        if (faceTop && body.bottom > tileTop) {
                            oy = body.bottom - tileTop;
                            if (oy > tileBias) oy = 0;
                        }
                    }
                    if (oy !== 0) {
                        if (body.customSeparateY) body.overlapY = oy;
                        else ProcessTileSeparationY(body, oy);
                    }
                    return oy;
                };
                module1.exports = TileCheckY;
            /***/ },
            /***/ 2483: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between the given tile rectangle-like object and an Arcade Physics body.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileIntersectsBody
 * @since 3.0.0
 *
 * @param {{ left: number, right: number, top: number, bottom: number }} tileWorldRect - A rectangle object that defines the tile placement in the world.
 * @param {Phaser.Physics.Arcade.Body} body - The body to check for intersection against.
 *
 * @return {boolean} Returns `true` of the tile intersects with the body, otherwise `false`.
 */ var TileIntersectsBody = function(tileWorldRect, body) {
                    // Currently, all bodies are treated as rectangles when colliding with a Tile.
                    return !(body.right <= tileWorldRect.left || body.bottom <= tileWorldRect.top || body.position.x >= tileWorldRect.right || body.position.y >= tileWorldRect.bottom);
                };
                module1.exports = TileIntersectsBody;
            /***/ },
            /***/ 55173: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Tilemap
 */ var Tilemap = {
                    ProcessTileCallbacks: __webpack_require__(96602),
                    ProcessTileSeparationX: __webpack_require__(36294),
                    ProcessTileSeparationY: __webpack_require__(67013),
                    SeparateTile: __webpack_require__(40012),
                    TileCheckX: __webpack_require__(21329),
                    TileCheckY: __webpack_require__(53442),
                    TileIntersectsBody: __webpack_require__(2483)
                };
                module1.exports = Tilemap;
            /***/ },
            /***/ 44563: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics
 */ /**
 * @namespace Phaser.Types.Physics
 */ module1.exports = {
                    Arcade: __webpack_require__(27064),
                    Matter: __webpack_require__(3875)
                };
            /***/ },
            /***/ 68174: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 *
 * The Body Bounds class contains methods to help you extract the world coordinates from various points around
 * the bounds of a Matter Body. Because Matter bodies are positioned based on their center of mass, and not a
 * dimension based center, you often need to get the bounds coordinates in order to properly align them in the world.
 *
 * You can access this class via the MatterPhysics class from a Scene, i.e.:
 *
 * ```javascript
 * this.matter.bodyBounds.getTopLeft(body);
 * ```
 *
 * See also the `MatterPhysics.alignBody` method.
 *
 * @class BodyBounds
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.22.0
 */ var BodyBounds = new Class({
                    initialize: function BodyBounds() {
                        /**
         * A Vector2 that stores the temporary bounds center value during calculations by methods in this class.
         *
         * @name Phaser.Physics.Matter.BodyBounds#boundsCenter
         * @type {Phaser.Math.Vector2}
         * @since 3.22.0
         */ this.boundsCenter = new Vector2();
                        /**
         * A Vector2 that stores the temporary center diff values during calculations by methods in this class.
         *
         * @name Phaser.Physics.Matter.BodyBounds#centerDiff
         * @type {Phaser.Math.Vector2}
         * @since 3.22.0
         */ this.centerDiff = new Vector2();
                    },
                    /**
     * Parses the given body to get the bounds diff values from it.
     *
     * They're stored in this class in the temporary properties `boundsCenter` and `centerDiff`.
     *
     * This method is called automatically by all other methods in this class.
     *
     * @method Phaser.Physics.Matter.BodyBounds#parseBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the bounds position from.
     *
     * @return {boolean} `true` if it was able to get the bounds, otherwise `false`.
     */ parseBody: function(body) {
                        body = body.hasOwnProperty('body') ? body.body : body;
                        if (!body.hasOwnProperty('bounds') || !body.hasOwnProperty('centerOfMass')) return false;
                        var boundsCenter = this.boundsCenter;
                        var centerDiff = this.centerDiff;
                        var boundsWidth = body.bounds.max.x - body.bounds.min.x;
                        var boundsHeight = body.bounds.max.y - body.bounds.min.y;
                        var bodyCenterX = boundsWidth * body.centerOfMass.x;
                        var bodyCenterY = boundsHeight * body.centerOfMass.y;
                        boundsCenter.set(boundsWidth / 2, boundsHeight / 2);
                        centerDiff.set(bodyCenterX - boundsCenter.x, bodyCenterY - boundsCenter.y);
                        return true;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the top-left of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopLeft
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopLeft: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x + center.x + diff.x, y + center.y + diff.y);
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the top-center of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopCenter: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x + diff.x, y + center.y + diff.y);
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the top-right of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopRight
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopRight: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x - (center.x - diff.x), y + center.y + diff.y);
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the left-center of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getLeftCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getLeftCenter: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x + center.x + diff.x, y + diff.y);
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the center of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getCenter: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var diff = this.centerDiff;
                            return new Vector2(x + diff.x, y + diff.y);
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the right-center of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getRightCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getRightCenter: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x - (center.x - diff.x), y + diff.y);
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the bottom-left of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomLeft
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomLeft: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x + center.x + diff.x, y - (center.y - diff.y));
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the bottom-center of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomCenter: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x + diff.x, y - (center.y - diff.y));
                        }
                        return false;
                    },
                    /**
     * Takes a Body and returns the world coordinates of the bottom-right of its _bounds_.
     *
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomRight
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomRight: function(body, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (this.parseBody(body)) {
                            var center = this.boundsCenter;
                            var diff = this.centerDiff;
                            return new Vector2(x - (center.x - diff.x), y - (center.y - diff.y));
                        }
                        return false;
                    }
                });
                module1.exports = BodyBounds;
            /***/ },
            /***/ 19933: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Matter
 */ var Matter = __webpack_require__(6790);
                Matter.Body = __webpack_require__(22562);
                Matter.Composite = __webpack_require__(69351);
                Matter.World = __webpack_require__(4372);
                Matter.Collision = __webpack_require__(52284);
                Matter.Detector = __webpack_require__(81388);
                Matter.Pairs = __webpack_require__(99561);
                Matter.Pair = __webpack_require__(4506);
                Matter.Query = __webpack_require__(73296);
                Matter.Resolver = __webpack_require__(66272);
                Matter.Constraint = __webpack_require__(48140);
                Matter.Common = __webpack_require__(53402);
                Matter.Engine = __webpack_require__(48413);
                Matter.Events = __webpack_require__(35810);
                Matter.Sleeping = __webpack_require__(53614);
                Matter.Plugin = __webpack_require__(73832);
                Matter.Bodies = __webpack_require__(66280);
                Matter.Composites = __webpack_require__(74116);
                Matter.Axes = __webpack_require__(66615);
                Matter.Bounds = __webpack_require__(15647);
                Matter.Svg = __webpack_require__(74058);
                Matter.Vector = __webpack_require__(31725);
                Matter.Vertices = __webpack_require__(41598);
                // aliases
                Matter.World.add = Matter.Composite.add;
                Matter.World.remove = Matter.Composite.remove;
                Matter.World.addComposite = Matter.Composite.addComposite;
                Matter.World.addBody = Matter.Composite.addBody;
                Matter.World.addConstraint = Matter.Composite.addConstraint;
                Matter.World.clear = Matter.Composite.clear;
                module1.exports = Matter;
            /***/ },
            /***/ 28137: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(66280);
                var Class = __webpack_require__(83419);
                var Composites = __webpack_require__(74116);
                var Constraint = __webpack_require__(48140);
                var Svg = __webpack_require__(74058);
                var MatterGameObject = __webpack_require__(75803);
                var MatterImage = __webpack_require__(23181);
                var MatterSprite = __webpack_require__(34803);
                var MatterTileBody = __webpack_require__(73834);
                var PhysicsEditorParser = __webpack_require__(19496);
                var PhysicsJSONParser = __webpack_require__(85791);
                var PointerConstraint = __webpack_require__(98713);
                var Vertices = __webpack_require__(41598);
                /**
 * @classdesc
 * The Matter Factory is responsible for quickly creating a variety of different types of
 * bodies, constraints and Game Objects and adding them into the physics world.
 *
 * You access the factory from within a Scene using `add`:
 *
 * ```javascript
 * this.matter.add.rectangle(x, y, width, height);
 * ```
 *
 * Use of the Factory is optional. All of the objects it creates can also be created
 * directly via your own code or constructors. It is provided as a means to keep your
 * code concise.
 *
 * @class Factory
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter World which this Factory adds to.
 */ var Factory = new Class({
                    initialize: function Factory(world) {
                        /**
         * The Matter World which this Factory adds to.
         *
         * @name Phaser.Physics.Matter.Factory#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * The Scene which this Factory's Matter World belongs to.
         *
         * @name Phaser.Physics.Matter.Factory#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = world.scene;
                        /**
         * A reference to the Scene.Systems this Matter Physics instance belongs to.
         *
         * @name Phaser.Physics.Matter.Factory#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = world.scene.sys;
                    },
                    /**
     * Creates a new rigid rectangular Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#rectangle
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} width - The width of the Body.
     * @param {number} height - The height of the Body.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ rectangle: function(x, y, width, height, options) {
                        var body = Bodies.rectangle(x, y, width, height, options);
                        this.world.add(body);
                        return body;
                    },
                    /**
     * Creates a new rigid trapezoidal Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#trapezoid
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} width - The width of the trapezoid Body.
     * @param {number} height - The height of the trapezoid Body.
     * @param {number} slope - The slope of the trapezoid. 0 creates a rectangle, while 1 creates a triangle. Positive values make the top side shorter, while negative values make the bottom side shorter.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ trapezoid: function(x, y, width, height, slope, options) {
                        var body = Bodies.trapezoid(x, y, width, height, slope, options);
                        this.world.add(body);
                        return body;
                    },
                    /**
     * Creates a new rigid circular Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#circle
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {number} [maxSides] - The maximum amount of sides to use for the polygon which will approximate this circle.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ circle: function(x, y, radius, options, maxSides) {
                        var body = Bodies.circle(x, y, radius, options, maxSides);
                        this.world.add(body);
                        return body;
                    },
                    /**
     * Creates a new rigid polygonal Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#polygon
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} sides - The number of sides the polygon will have.
     * @param {number} radius - The "radius" of the polygon, i.e. the distance from its center to any vertex. This is also the radius of its circumcircle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ polygon: function(x, y, sides, radius, options) {
                        var body = Bodies.polygon(x, y, sides, radius, options);
                        this.world.add(body);
                        return body;
                    },
                    /**
     * Creates a body using the supplied vertices (or an array containing multiple sets of vertices) and adds it to the World.
     * If the vertices are convex, they will pass through as supplied. Otherwise, if the vertices are concave, they will be decomposed. Note that this process is not guaranteed to support complex sets of vertices, e.g. ones with holes.
     *
     * @method Phaser.Physics.Matter.Factory#fromVertices
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {(string|array)} vertexSets - The vertices data. Either a path string or an array of vertices.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [flagInternal=false] - Flag internal edges (coincident part edges)
     * @param {number} [removeCollinear=0.01] - Whether Matter.js will discard collinear edges (to improve performance).
     * @param {number} [minimumArea=10] - During decomposition discard parts that have an area less than this.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromVertices: function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea) {
                        if (typeof vertexSets === 'string') vertexSets = Vertices.fromPath(vertexSets);
                        var body = Bodies.fromVertices(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea);
                        this.world.add(body);
                        return body;
                    },
                    /**
     * Creates a body using data exported from the application PhysicsEditor (https://www.codeandweb.com/physicseditor)
     *
     * The PhysicsEditor file should be loaded as JSON:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.json('vehicles', 'assets/vehicles.json);
     * }
     *
     * create ()
     * {
     *   const vehicleShapes = this.cache.json.get('vehicles');
     *   this.matter.add.fromPhysicsEditor(400, 300, vehicleShapes.truck);
     * }
     * ```
     *
     * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
     *
     * If you pas in an `options` object, any settings in there will override those in the PhysicsEditor config object.
     *
     * @method Phaser.Physics.Matter.Factory#fromPhysicsEditor
     * @since 3.22.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {any} config - The JSON data exported from PhysicsEditor.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromPhysicsEditor: function(x, y, config, options, addToWorld) {
                        if (addToWorld === undefined) addToWorld = true;
                        var body = PhysicsEditorParser.parseBody(x, y, config, options);
                        if (addToWorld && !this.world.has(body)) this.world.add(body);
                        return body;
                    },
                    /**
     * Creates a body using the path data from an SVG file.
     *
     * SVG Parsing requires the pathseg polyfill from https://github.com/progers/pathseg
     *
     * The SVG file should be loaded as XML, as this method requires the ability to extract
     * the path data from it. I.e.:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.xml('face', 'assets/face.svg);
     * }
     *
     * create ()
     * {
     *   this.matter.add.fromSVG(400, 300, this.cache.xml.get('face'));
     * }
     * ```
     *
     * @method Phaser.Physics.Matter.Factory#fromSVG
     * @since 3.22.0
     *
     * @param {number} x - The X coordinate of the body.
     * @param {number} y - The Y coordinate of the body.
     * @param {object} xml - The SVG Path data.
     * @param {number} [scale=1] - Scale the vertices by this amount after creation.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromSVG: function(x, y, xml, scale, options, addToWorld) {
                        if (scale === undefined) scale = 1;
                        if (options === undefined) options = {};
                        if (addToWorld === undefined) addToWorld = true;
                        var path = xml.getElementsByTagName('path');
                        var vertexSets = [];
                        for(var i = 0; i < path.length; i++){
                            var points = Svg.pathToVertices(path[i], 30);
                            if (scale !== 1) Vertices.scale(points, scale, scale);
                            vertexSets.push(points);
                        }
                        var body = Bodies.fromVertices(x, y, vertexSets, options);
                        if (addToWorld) this.world.add(body);
                        return body;
                    },
                    /**
     * Creates a body using the supplied physics data, as provided by a JSON file.
     *
     * The data file should be loaded as JSON:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.json('ninjas', 'assets/ninjas.json);
     * }
     *
     * create ()
     * {
     *   const ninjaShapes = this.cache.json.get('ninjas');
     *
     *   this.matter.add.fromJSON(400, 300, ninjaShapes.shinobi);
     * }
     * ```
     *
     * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
     *
     * If you pas in an `options` object, any settings in there will override those in the config object.
     *
     * The structure of the JSON file is as follows:
     *
     * ```text
     * {
     *   'generator_info': // The name of the application that created the JSON data
     *   'shapeName': {
     *     'type': // The type of body
     *     'label': // Optional body label
     *     'vertices': // An array, or an array of arrays, containing the vertex data in x/y object pairs
     *   }
     * }
     * ```
     *
     * At the time of writing, only the Phaser Physics Tracer App exports in this format.
     *
     * @method Phaser.Physics.Matter.Factory#fromJSON
     * @since 3.22.0
     *
     * @param {number} x - The X coordinate of the body.
     * @param {number} y - The Y coordinate of the body.
     * @param {any} config - The JSON physics data.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromJSON: function(x, y, config, options, addToWorld) {
                        if (options === undefined) options = {};
                        if (addToWorld === undefined) addToWorld = true;
                        var body = PhysicsJSONParser.parseBody(x, y, config, options);
                        if (body && addToWorld) this.world.add(body);
                        return body;
                    },
                    /**
     * Create a new composite containing Matter Image objects created in a grid arrangement.
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#imageStack
     * @since 3.0.0
     *
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} frame - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the grid.
     * @param {number} rows - The number of rows in the grid.
     * @param {number} [columnGap=0] - The distance between each column.
     * @param {number} [rowGap=0] - The distance between each row.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.CompositeType} A Matter JS Composite Stack.
     */ imageStack: function(key, frame, x, y, columns, rows, columnGap, rowGap, options) {
                        if (columnGap === undefined) columnGap = 0;
                        if (rowGap === undefined) rowGap = 0;
                        if (options === undefined) options = {};
                        var world = this.world;
                        var displayList = this.sys.displayList;
                        options.addToWorld = false;
                        var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, function(x, y) {
                            var image = new MatterImage(world, x, y, key, frame, options);
                            displayList.add(image);
                            return image.body;
                        });
                        world.add(stack);
                        return stack;
                    },
                    /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     *
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#stack
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the grid.
     * @param {number} rows - The number of rows in the grid.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {function} callback - The callback that creates the stack.
     *
     * @return {MatterJS.CompositeType} A new composite containing objects created in the callback.
     */ stack: function(x, y, columns, rows, columnGap, rowGap, callback) {
                        var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, callback);
                        this.world.add(stack);
                        return stack;
                    },
                    /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#pyramid
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the pyramid.
     * @param {number} rows - The number of rows in the pyramid.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {function} callback - The callback function to be invoked.
     *
     * @return {MatterJS.CompositeType} A Matter JS Composite pyramid.
     */ pyramid: function(x, y, columns, rows, columnGap, rowGap, callback) {
                        var stack = Composites.pyramid(x, y, columns, rows, columnGap, rowGap, callback);
                        this.world.add(stack);
                        return stack;
                    },
                    /**
     * Chains all bodies in the given composite together using constraints.
     *
     * @method Phaser.Physics.Matter.Factory#chain
     * @since 3.0.0
     *
     * @param {MatterJS.CompositeType} composite - The composite in which all bodies will be chained together sequentially.
     * @param {number} xOffsetA - The horizontal offset of the BodyA constraint. This is a percentage based on the body size, not a world position.
     * @param {number} yOffsetA - The vertical offset of the BodyA constraint. This is a percentage based on the body size, not a world position.
     * @param {number} xOffsetB - The horizontal offset of the BodyB constraint. This is a percentage based on the body size, not a world position.
     * @param {number} yOffsetB - The vertical offset of the BodyB constraint. This is a percentage based on the body size, not a world position.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} The original composite that was passed to this method.
     */ chain: function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                        return Composites.chain(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options);
                    },
                    /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     *
     * @method Phaser.Physics.Matter.Factory#mesh
     * @since 3.0.0
     *
     * @param {MatterJS.CompositeType} composite - The composite in which all bodies will be chained together.
     * @param {number} columns - The number of columns in the mesh.
     * @param {number} rows - The number of rows in the mesh.
     * @param {boolean} crossBrace - Create cross braces for the mesh as well?
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} The original composite that was passed to this method.
     */ mesh: function(composite, columns, rows, crossBrace, options) {
                        return Composites.mesh(composite, columns, rows, crossBrace, options);
                    },
                    /**
     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
     *
     * @method Phaser.Physics.Matter.Factory#newtonsCradle
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the start of the cradle.
     * @param {number} y - The vertical position of the start of the cradle.
     * @param {number} number - The number of balls in the cradle.
     * @param {number} size - The radius of each ball in the cradle.
     * @param {number} length - The length of the 'string' the balls hang from.
     *
     * @return {MatterJS.CompositeType} A Newton's cradle composite.
     */ newtonsCradle: function(x, y, number, size, length) {
                        var composite = Composites.newtonsCradle(x, y, number, size, length);
                        this.world.add(composite);
                        return composite;
                    },
                    /**
     * Creates a composite with simple car setup of bodies and constraints.
     *
     * @method Phaser.Physics.Matter.Factory#car
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the car in the world.
     * @param {number} y - The vertical position of the car in the world.
     * @param {number} width - The width of the car chasis.
     * @param {number} height - The height of the car chasis.
     * @param {number} wheelSize - The radius of the car wheels.
     *
     * @return {MatterJS.CompositeType} A new composite car body.
     */ car: function(x, y, width, height, wheelSize) {
                        var composite = Composites.car(x, y, width, height, wheelSize);
                        this.world.add(composite);
                        return composite;
                    },
                    /**
     * Creates a simple soft body like object.
     *
     * @method Phaser.Physics.Matter.Factory#softBody
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the Composite.
     * @param {number} rows - The number of rows in the Composite.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {boolean} crossBrace - `true` to create cross braces between the bodies, or `false` to create just straight braces.
     * @param {number} particleRadius - The radius of this circlular composite.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [particleOptions] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [constraintOptions] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} A new composite simple soft body.
     */ softBody: function(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                        var composite = Composites.softBody(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions);
                        this.world.add(composite);
                        return composite;
                    },
                    /**
     * This method is an alias for `Factory.constraint`.
     *
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#joint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ joint: function(bodyA, bodyB, length, stiffness, options) {
                        return this.constraint(bodyA, bodyB, length, stiffness, options);
                    },
                    /**
     * This method is an alias for `Factory.constraint`.
     *
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#spring
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ spring: function(bodyA, bodyB, length, stiffness, options) {
                        return this.constraint(bodyA, bodyB, length, stiffness, options);
                    },
                    /**
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#constraint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ constraint: function(bodyA, bodyB, length, stiffness, options) {
                        if (stiffness === undefined) stiffness = 1;
                        if (options === undefined) options = {};
                        options.bodyA = bodyA.type === 'body' ? bodyA : bodyA.body;
                        options.bodyB = bodyB.type === 'body' ? bodyB : bodyB.body;
                        if (!isNaN(length)) options.length = length;
                        options.stiffness = stiffness;
                        var constraint = Constraint.create(options);
                        this.world.add(constraint);
                        return constraint;
                    },
                    /**
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * A world constraint has only one body, you should specify a `pointA` position in
     * the constraint options parameter to attach the constraint to the world.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#worldConstraint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The Matter `Body` that this constraint is attached to.
     * @param {number} [length] - A number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ worldConstraint: function(body, length, stiffness, options) {
                        if (stiffness === undefined) stiffness = 1;
                        if (options === undefined) options = {};
                        options.bodyB = body.type === 'body' ? body : body.body;
                        if (!isNaN(length)) options.length = length;
                        options.stiffness = stiffness;
                        var constraint = Constraint.create(options);
                        this.world.add(constraint);
                        return constraint;
                    },
                    /**
     * This method is an alias for `Factory.pointerConstraint`.
     *
     * A Pointer Constraint is a special type of constraint that allows you to click
     * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
     * and when one is pressed down it checks to see if that hit any part of any active
     * body in the world. If it did, and the body has input enabled, it will begin to
     * drag it until either released, or you stop it via the `stopDrag` method.
     *
     * You can adjust the stiffness, length and other properties of the constraint via
     * the `options` object on creation.
     *
     * @method Phaser.Physics.Matter.Factory#mouseSpring
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ mouseSpring: function(options) {
                        return this.pointerConstraint(options);
                    },
                    /**
     * A Pointer Constraint is a special type of constraint that allows you to click
     * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
     * and when one is pressed down it checks to see if that hit any part of any active
     * body in the world. If it did, and the body has input enabled, it will begin to
     * drag it until either released, or you stop it via the `stopDrag` method.
     *
     * You can adjust the stiffness, length and other properties of the constraint via
     * the `options` object on creation.
     *
     * @method Phaser.Physics.Matter.Factory#pointerConstraint
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ pointerConstraint: function(options) {
                        if (options === undefined) options = {};
                        if (!options.hasOwnProperty('render')) options.render = {
                            visible: false
                        };
                        var pointerConstraint = new PointerConstraint(this.scene, this.world, options);
                        this.world.add(pointerConstraint.constraint);
                        return pointerConstraint;
                    },
                    /**
     * Creates a Matter Physics Image Game Object.
     *
     * An Image is a light-weight Game Object useful for the display of static images in your game,
     * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
     * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
     * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
     *
     * @method Phaser.Physics.Matter.Factory#image
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.Physics.Matter.Image} The Matter Image Game Object.
     */ image: function(x, y, key, frame, options) {
                        var image = new MatterImage(this.world, x, y, key, frame, options);
                        this.sys.displayList.add(image);
                        return image;
                    },
                    /**
     * Creates a wrapper around a Tile that provides access to a corresponding Matter body. A tile can only
     * have one Matter body associated with it. You can either pass in an existing Matter body for
     * the tile or allow the constructor to create the corresponding body for you. If the Tile has a
     * collision group (defined in Tiled), those shapes will be used to create the body. If not, the
     * tile's rectangle bounding box will be used.
     *
     * The corresponding body will be accessible on the Tile itself via Tile.physics.matterBody.
     *
     * Note: not all Tiled collision shapes are supported. See
     * Phaser.Physics.Matter.TileBody#setFromTileCollision for more information.
     *
     * @method Phaser.Physics.Matter.Factory#tileBody
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile} tile - The target tile that should have a Matter body.
     * @param {Phaser.Types.Physics.Matter.MatterTileOptions} [options] - Options to be used when creating the Matter body.
     *
     * @return {Phaser.Physics.Matter.TileBody} The Matter Tile Body Game Object.
     */ tileBody: function(tile, options) {
                        return new MatterTileBody(this.world, tile, options);
                    },
                    /**
     * Creates a Matter Physics Sprite Game Object.
     *
     * A Sprite Game Object is used for the display of both static and animated images in your game.
     * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
     * and animated.
     *
     * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
     * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
     * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
     *
     * @method Phaser.Physics.Matter.Factory#sprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.Physics.Matter.Sprite} The Matter Sprite Game Object.
     */ sprite: function(x, y, key, frame, options) {
                        var sprite = new MatterSprite(this.world, x, y, key, frame, options);
                        this.sys.displayList.add(sprite);
                        this.sys.updateList.add(sprite);
                        return sprite;
                    },
                    /**
     * Takes an existing Game Object and injects all of the Matter Components into it.
     *
     * This enables you to use component methods such as `setVelocity` or `isSensor` directly from
     * this Game Object.
     *
     * You can also pass in either a Matter Body Configuration object, or a Matter Body instance
     * to link with this Game Object.
     *
     * @method Phaser.Physics.Matter.Factory#gameObject
     * @since 3.3.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to inject the Matter Components in to.
     * @param {(Phaser.Types.Physics.Matter.MatterBodyConfig|MatterJS.Body)} [options] - A Matter Body configuration object, or an instance of a Matter Body.
     * @param {boolean} [addToWorld=true] - Add this Matter Body to the World?
     *
     * @return {(Phaser.Physics.Matter.Image|Phaser.Physics.Matter.Sprite|Phaser.GameObjects.GameObject)} The Game Object that had the Matter Components injected into it.
     */ gameObject: function(gameObject, options, addToWorld) {
                        return MatterGameObject(this.world, gameObject, options, addToWorld);
                    },
                    /**
     * Destroys this Factory.
     *
     * @method Phaser.Physics.Matter.Factory#destroy
     * @since 3.5.0
     */ destroy: function() {
                        this.world = null;
                        this.scene = null;
                        this.sys = null;
                    }
                });
                module1.exports = Factory;
            /***/ },
            /***/ 75803: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Components = __webpack_require__(31884);
                var GetFastValue = __webpack_require__(95540);
                var Vector2 = __webpack_require__(26099);
                /**
 * Internal function to check if the object has a getter or setter.
 *
 * @function hasGetterOrSetter
 * @private
 *
 * @param {object} def - The object to check.
 *
 * @return {boolean} True if it has a getter or setter, otherwise false.
 */ function hasGetterOrSetter(def) {
                    return !!def.get && typeof def.get === 'function' || !!def.set && typeof def.set === 'function';
                }
                /**
 * A Matter Game Object is a generic object that allows you to combine any Phaser Game Object,
 * including those you have extended or created yourself, with all of the Matter Components.
 *
 * This enables you to use component methods such as `setVelocity` or `isSensor` directly from
 * this Game Object.
 *
 * @function Phaser.Physics.Matter.MatterGameObject
 * @since 3.3.0
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter world to add the body to.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will have the Matter body applied to it.
 * @param {(Phaser.Types.Physics.Matter.MatterBodyConfig|MatterJS.Body)} [options] - A Matter Body configuration object, or an instance of a Matter Body.
 * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was created with the Matter body.
 */ var MatterGameObject = function(world, gameObject, options, addToWorld) {
                    if (options === undefined) options = {};
                    if (addToWorld === undefined) addToWorld = true;
                    var x = gameObject.x;
                    var y = gameObject.y;
                    //  Temp body pos to avoid body null checks
                    gameObject.body = {
                        temp: true,
                        position: {
                            x: x,
                            y: y
                        }
                    };
                    var mixins = [
                        Components.Bounce,
                        Components.Collision,
                        Components.Force,
                        Components.Friction,
                        Components.Gravity,
                        Components.Mass,
                        Components.Sensor,
                        Components.SetBody,
                        Components.Sleep,
                        Components.Static,
                        Components.Transform,
                        Components.Velocity
                    ];
                    //  First let's inject all of the components into the Game Object
                    mixins.forEach(function(mixin) {
                        for(var key in mixin)if (hasGetterOrSetter(mixin[key])) Object.defineProperty(gameObject, key, {
                            get: mixin[key].get,
                            set: mixin[key].set
                        });
                        else Object.defineProperty(gameObject, key, {
                            value: mixin[key]
                        });
                    });
                    gameObject.world = world;
                    gameObject._tempVec2 = new Vector2(x, y);
                    if (options.hasOwnProperty('type') && options.type === 'body') gameObject.setExistingBody(options, addToWorld);
                    else {
                        var shape = GetFastValue(options, 'shape', null);
                        if (!shape) shape = 'rectangle';
                        options.addToWorld = addToWorld;
                        gameObject.setBody(shape, options);
                    }
                    return gameObject;
                };
                module1.exports = MatterGameObject;
            /***/ },
            /***/ 23181: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31884);
                var GameObject = __webpack_require__(95643);
                var GetFastValue = __webpack_require__(95540);
                var Image1 = __webpack_require__(88571);
                var Pipeline = __webpack_require__(72699);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Matter Physics Image Game Object.
 *
 * An Image is a light-weight Game Object useful for the display of static images in your game,
 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
 *
 * @class Image
 * @extends Phaser.GameObjects.Image
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Force
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.SetBody
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 * @extends Phaser.Physics.Matter.Components.Transform
 * @extends Phaser.Physics.Matter.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter.World instance that this body belongs to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
 */ var MatterImage = new Class({
                    Extends: Image1,
                    Mixins: [
                        Components.Bounce,
                        Components.Collision,
                        Components.Force,
                        Components.Friction,
                        Components.Gravity,
                        Components.Mass,
                        Components.Sensor,
                        Components.SetBody,
                        Components.Sleep,
                        Components.Static,
                        Components.Transform,
                        Components.Velocity,
                        Pipeline
                    ],
                    initialize: function MatterImage(world, x, y, texture, frame, options) {
                        GameObject.call(this, world.scene, 'Image');
                        /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.Physics.Matter.Image#_crop
         * @type {object}
         * @private
         * @since 3.24.0
         */ this._crop = this.resetCropObject();
                        this.setTexture(texture, frame);
                        this.setSizeToFrame();
                        this.setOrigin();
                        /**
         * A reference to the Matter.World instance that this body belongs to.
         *
         * @name Phaser.Physics.Matter.Image#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.Image#_tempVec2
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec2 = new Vector2(x, y);
                        var shape = GetFastValue(options, 'shape', null);
                        if (shape) this.setBody(shape, options);
                        else this.setRectangle(this.width, this.height, options);
                        this.setPosition(x, y);
                        this.initPipeline();
                        this.initPostPipeline(true);
                    }
                });
                module1.exports = MatterImage;
            /***/ },
            /***/ 42045: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(60461);
                var Axes = __webpack_require__(66615);
                var Bodies = __webpack_require__(66280);
                var Body = __webpack_require__(22562);
                var BodyBounds = __webpack_require__(68174);
                var Bounds = __webpack_require__(15647);
                var Class = __webpack_require__(83419);
                var Collision = __webpack_require__(52284);
                var Common = __webpack_require__(53402);
                var Composite = __webpack_require__(69351);
                var Composites = __webpack_require__(74116);
                var Constraint = __webpack_require__(48140);
                var Detector = __webpack_require__(81388);
                var DistanceBetween = __webpack_require__(20339);
                var Factory = __webpack_require__(28137);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var Merge = __webpack_require__(46975);
                var Pair = __webpack_require__(4506);
                var Pairs = __webpack_require__(99561);
                var PluginCache = __webpack_require__(37277);
                var Query = __webpack_require__(73296);
                var Resolver = __webpack_require__(66272);
                var SceneEvents = __webpack_require__(44594);
                var Svg = __webpack_require__(74058);
                var Vector = __webpack_require__(31725);
                var Vertices = __webpack_require__(41598);
                var World = __webpack_require__(68243);
                Common.setDecomp(__webpack_require__(55973));
                /**
 * @classdesc
 * The Phaser Matter plugin provides the ability to use the Matter JS Physics Engine within your Phaser games.
 *
 * Unlike Arcade Physics, the other physics system provided with Phaser, Matter JS is a full-body physics system.
 * It features:
 *
 * * Rigid bodies
 * * Compound bodies
 * * Composite bodies
 * * Concave and convex hulls
 * * Physical properties (mass, area, density etc.)
 * * Restitution (elastic and inelastic collisions)
 * * Collisions (broad-phase, mid-phase and narrow-phase)
 * * Stable stacking and resting
 * * Conservation of momentum
 * * Friction and resistance
 * * Constraints
 * * Gravity
 * * Sleeping and static bodies
 * * Rounded corners (chamfering)
 * * Views (translate, zoom)
 * * Collision queries (raycasting, region tests)
 * * Time scaling (slow-mo, speed-up)
 *
 * Configuration of Matter is handled via the Matter World Config object, which can be passed in either the
 * Phaser Game Config, or Phaser Scene Config. Here is a basic example:
 *
 * ```js
 * physics: {
 *     default: 'matter',
 *     matter: {
 *         enableSleeping: true,
 *         gravity: {
 *             y: 0
 *         },
 *         debug: {
 *             showBody: true,
 *             showStaticBody: true
 *         }
 *     }
 * }
 * ```
 *
 * This class acts as an interface between a Phaser Scene and a single instance of the Matter Engine.
 *
 * Use it to access the most common Matter features and helper functions.
 *
 * You can find details, documentation and examples on the Matter JS website: https://brm.io/matter-js/
 *
 * @class MatterPhysics
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Phaser Scene that owns this Matter Physics instance.
 */ var MatterPhysics = new Class({
                    initialize: function MatterPhysics(scene) {
                        /**
         * The Phaser Scene that owns this Matter Physics instance
         *
         * @name Phaser.Physics.Matter.MatterPhysics#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene Systems that belong to the Scene owning this Matter Physics instance.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * The parsed Matter Configuration object.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#config
         * @type {Phaser.Types.Physics.Matter.MatterWorldConfig}
         * @since 3.0.0
         */ this.config = this.getConfig();
                        /**
         * An instance of the Matter World class. This class is responsible for the updating of the
         * Matter Physics world, as well as handling debug drawing functions.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world;
                        /**
         * An instance of the Matter Factory. This class provides lots of functions for creating a
         * wide variety of physics objects and adds them automatically to the Matter World.
         *
         * You can use this class to cut-down on the amount of code required in your game, however,
         * use of the Factory is entirely optional and should be seen as a development aid. It's
         * perfectly possible to create and add components to the Matter world without using it.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#add
         * @type {Phaser.Physics.Matter.Factory}
         * @since 3.0.0
         */ this.add;
                        /**
         * An instance of the Body Bounds class. This class contains functions used for getting the
         * world position from various points around the bounds of a physics body.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bodyBounds
         * @type {Phaser.Physics.Matter.BodyBounds}
         * @since 3.22.0
         */ this.bodyBounds;
                        //  Body
                        /**
         * A reference to the `Matter.Body` module.
         *
         * The `Matter.Body` module contains methods for creating and manipulating body models.
         * A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
         * Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the `Bodies` module.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#body
         * @type {MatterJS.BodyFactory}
         * @since 3.18.0
         */ this.body = Body;
                        /**
         * A reference to the `Matter.Composite` module.
         *
         * The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
         * A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
         * It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
         * Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#composite
         * @type {MatterJS.CompositeFactory}
         * @since 3.22.0
         */ this.composite = Composite;
                        //  Collision:
                        /**
         * A reference to the `Matter.Collision` module.
         *
         * The `Matter.Collision` module contains methods for detecting collisions between a given pair of bodies.
         *
         * For efficient detection between a list of bodies, see `Matter.Detector` and `Matter.Query`.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#collision
         * @type {MatterJS.Collision}
         * @since 3.60.0
         */ this.collision = Collision;
                        /**
         * A reference to the `Matter.Detector` module.
         *
         * The `Matter.Detector` module contains methods for detecting collisions given a set of pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#detector
         * @type {MatterJS.DetectorFactory}
         * @since 3.22.0
         */ this.detector = Detector;
                        /**
         * A reference to the `Matter.Pair` module.
         *
         * The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#pair
         * @type {MatterJS.PairFactory}
         * @since 3.22.0
         */ this.pair = Pair;
                        /**
         * A reference to the `Matter.Pairs` module.
         *
         * The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#pairs
         * @type {MatterJS.PairsFactory}
         * @since 3.22.0
         */ this.pairs = Pairs;
                        /**
         * A reference to the `Matter.Query` module.
         *
         * The `Matter.Query` module contains methods for performing collision queries.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#query
         * @type {MatterJS.QueryFactory}
         * @since 3.22.0
         */ this.query = Query;
                        /**
         * A reference to the `Matter.Resolver` module.
         *
         * The `Matter.Resolver` module contains methods for resolving collision pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#resolver
         * @type {MatterJS.ResolverFactory}
         * @since 3.22.0
         */ this.resolver = Resolver;
                        //  Constraint
                        /**
         * A reference to the `Matter.Constraint` module.
         *
         * The `Matter.Constraint` module contains methods for creating and manipulating constraints.
         * Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
         * The stiffness of constraints can be modified to create springs or elastic.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#constraint
         * @type {MatterJS.ConstraintFactory}
         * @since 3.22.0
         */ this.constraint = Constraint;
                        //  Factory
                        /**
         * A reference to the `Matter.Bodies` module.
         *
         * The `Matter.Bodies` module contains factory methods for creating rigid bodies
         * with commonly used body configurations (such as rectangles, circles and other polygons).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bodies
         * @type {MatterJS.BodiesFactory}
         * @since 3.18.0
         */ this.bodies = Bodies;
                        /**
         * A reference to the `Matter.Composites` module.
         *
         * The `Matter.Composites` module contains factory methods for creating composite bodies
         * with commonly used configurations (such as stacks and chains).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#composites
         * @type {MatterJS.CompositesFactory}
         * @since 3.22.0
         */ this.composites = Composites;
                        //  Geometry
                        /**
         * A reference to the `Matter.Axes` module.
         *
         * The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#axes
         * @type {MatterJS.AxesFactory}
         * @since 3.22.0
         */ this.axes = Axes;
                        /**
         * A reference to the `Matter.Bounds` module.
         *
         * The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bounds
         * @type {MatterJS.BoundsFactory}
         * @since 3.22.0
         */ this.bounds = Bounds;
                        /**
         * A reference to the `Matter.Svg` module.
         *
         * The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
         *
         * To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
         *
         * @name Phaser.Physics.Matter.MatterPhysics#svg
         * @type {MatterJS.SvgFactory}
         * @since 3.22.0
         */ this.svg = Svg;
                        /**
         * A reference to the `Matter.Vector` module.
         *
         * The `Matter.Vector` module contains methods for creating and manipulating vectors.
         * Vectors are the basis of all the geometry related operations in the engine.
         * A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#vector
         * @type {MatterJS.VectorFactory}
         * @since 3.22.0
         */ this.vector = Vector;
                        /**
         * A reference to the `Matter.Vertices` module.
         *
         * The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
         * A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
         * A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#vertices
         * @type {MatterJS.VerticesFactory}
         * @since 3.22.0
         */ this.vertices = Vertices;
                        /**
         * A reference to the `Matter.Vertices` module.
         *
         * The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
         * A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
         * A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#verts
         * @type {MatterJS.VerticesFactory}
         * @since 3.14.0
         */ this.verts = Vertices;
                        /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#_tempVec2
         * @type {MatterJS.Vector}
         * @private
         * @since 3.22.0
         */ this._tempVec2 = Vector.create();
                        Resolver._restingThresh = GetValue(this.config, 'restingThresh', 4);
                        Resolver._restingThreshTangent = GetValue(this.config, 'restingThreshTangent', 6);
                        Resolver._positionDampen = GetValue(this.config, 'positionDampen', 0.9);
                        Resolver._positionWarming = GetValue(this.config, 'positionWarming', 0.8);
                        Resolver._frictionNormalMultiplier = GetValue(this.config, 'frictionNormalMultiplier', 5);
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.world = new World(this.scene, this.config);
                        this.add = new Factory(this.world);
                        this.bodyBounds = new BodyBounds();
                        this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        if (!this.world) {
                            this.world = new World(this.scene, this.config);
                            this.add = new Factory(this.world);
                        }
                        var eventEmitter = this.systems.events;
                        eventEmitter.on(SceneEvents.UPDATE, this.world.update, this.world);
                        eventEmitter.on(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                        eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * This internal method is called when this class starts and retrieves the final Matter World Config.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getConfig
     * @since 3.0.0
     *
     * @return {Phaser.Types.Physics.Matter.MatterWorldConfig} The Matter World Config.
     */ getConfig: function() {
                        var gameConfig = this.systems.game.config.physics;
                        var sceneConfig = this.systems.settings.physics;
                        var config = Merge(GetFastValue(sceneConfig, 'matter', {}), GetFastValue(gameConfig, 'matter', {}));
                        return config;
                    },
                    /**
     * Pauses the Matter World instance and sets `enabled` to `false`.
     *
     * A paused world will not run any simulations for the duration it is paused.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#pause
     * @fires Phaser.Physics.Matter.Events#PAUSE
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.World} The Matter World object.
     */ pause: function() {
                        return this.world.pause();
                    },
                    /**
     * Resumes this Matter World instance from a paused state and sets `enabled` to `true`.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#resume
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.World} The Matter World object.
     */ resume: function() {
                        return this.world.resume();
                    },
                    /**
     * Sets the Matter Engine to run at fixed timestep of 60Hz and enables `autoUpdate`.
     * If you have set a custom `getDelta` function then this will override it.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#set60Hz
     * @since 3.4.0
     *
     * @return {this} This Matter Physics instance.
     */ set60Hz: function() {
                        this.world.getDelta = this.world.update60Hz;
                        this.world.autoUpdate = true;
                        return this;
                    },
                    /**
     * Sets the Matter Engine to run at fixed timestep of 30Hz and enables `autoUpdate`.
     * If you have set a custom `getDelta` function then this will override it.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#set30Hz
     * @since 3.4.0
     *
     * @return {this} This Matter Physics instance.
     */ set30Hz: function() {
                        this.world.getDelta = this.world.update30Hz;
                        this.world.autoUpdate = true;
                        return this;
                    },
                    /**
     * Manually advances the physics simulation by one iteration.
     *
     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
     * If undefined they use the Matter defaults of 60Hz and no correction.
     *
     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
     *
     * It also ignores any custom `getDelta` functions, as you should be passing the delta
     * value in to this call.
     *
     * You can adjust the number of iterations that Engine.update performs internally.
     * Use the Scene Matter Physics config object to set the following properties:
     *
     * positionIterations (defaults to 6)
     * velocityIterations (defaults to 4)
     * constraintIterations (defaults to 2)
     *
     * Adjusting these values can help performance in certain situations, depending on the physics requirements
     * of your game.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#step
     * @since 3.4.0
     *
     * @param {number} [delta=16.666] - The delta value.
     * @param {number} [correction=1] - Optional delta correction value.
     */ step: function(delta, correction) {
                        this.world.step(delta, correction);
                    },
                    /**
     * Checks if the vertices of the given body, or an array of bodies, contains the given point, or not.
     *
     * You can pass in either a single body, or an array of bodies to be checked. This method will
     * return `true` if _any_ of the bodies in the array contain the point. See the `intersectPoint` method if you need
     * to get a list of intersecting bodies.
     *
     * The point should be transformed into the Matter World coordinate system in advance. This happens by
     * default with Input Pointers, but if you wish to use points from another system you may need to
     * transform them before passing them.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#containsPoint
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} body - The body, or an array of bodies, to check against the point.
     * @param {number} x - The horizontal coordinate of the point.
     * @param {number} y - The vertical coordinate of the point.
     *
     * @return {boolean} `true` if the point is within one of the bodies given, otherwise `false`.
     */ containsPoint: function(body, x, y) {
                        body = this.getMatterBodies(body);
                        var position = Vector.create(x, y);
                        var result = Query.point(body, position);
                        return result.length > 0 ? true : false;
                    },
                    /**
     * Checks the given coordinates to see if any vertices of the given bodies contain it.
     *
     * If no bodies are provided it will search all bodies in the Matter World, including within Composites.
     *
     * The coordinates should be transformed into the Matter World coordinate system in advance. This happens by
     * default with Input Pointers, but if you wish to use coordinates from another system you may need to
     * transform them before passing them.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#intersectPoint
     * @since 3.22.0
     *
     * @param {number} x - The horizontal coordinate of the point.
     * @param {number} y - The vertical coordinate of the point.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     *
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies which contain the given point.
     */ intersectPoint: function(x, y, bodies) {
                        bodies = this.getMatterBodies(bodies);
                        var position = Vector.create(x, y);
                        var output = [];
                        var result = Query.point(bodies, position);
                        result.forEach(function(body) {
                            if (output.indexOf(body) === -1) output.push(body);
                        });
                        return output;
                    },
                    /**
     * Checks the given rectangular area to see if any vertices of the given bodies intersect with it.
     * Or, if the `outside` parameter is set to `true`, it checks to see which bodies do not
     * intersect with it.
     *
     * If no bodies are provided it will search all bodies in the Matter World, including within Composites.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#intersectRect
     * @since 3.22.0
     *
     * @param {number} x - The horizontal coordinate of the top-left of the area.
     * @param {number} y - The vertical coordinate of the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {boolean} [outside=false] - If `false` it checks for vertices inside the area, if `true` it checks for vertices outside the area.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     *
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies that intersect with the given area.
     */ intersectRect: function(x, y, width, height, outside, bodies) {
                        if (outside === undefined) outside = false;
                        bodies = this.getMatterBodies(bodies);
                        var bounds = {
                            min: {
                                x: x,
                                y: y
                            },
                            max: {
                                x: x + width,
                                y: y + height
                            }
                        };
                        var output = [];
                        var result = Query.region(bodies, bounds, outside);
                        result.forEach(function(body) {
                            if (output.indexOf(body) === -1) output.push(body);
                        });
                        return output;
                    },
                    /**
     * Checks the given ray segment to see if any vertices of the given bodies intersect with it.
     *
     * If no bodies are provided it will search all bodies in the Matter World.
     *
     * The width of the ray can be specified via the `rayWidth` parameter.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#intersectRay
     * @since 3.22.0
     *
     * @param {number} x1 - The horizontal coordinate of the start of the ray segment.
     * @param {number} y1 - The vertical coordinate of the start of the ray segment.
     * @param {number} x2 - The horizontal coordinate of the end of the ray segment.
     * @param {number} y2 - The vertical coordinate of the end of the ray segment.
     * @param {number} [rayWidth=1] - The width of the ray segment.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     *
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies whos vertices intersect with the ray segment.
     */ intersectRay: function(x1, y1, x2, y2, rayWidth, bodies) {
                        if (rayWidth === undefined) rayWidth = 1;
                        bodies = this.getMatterBodies(bodies);
                        var result = [];
                        var collisions = Query.ray(bodies, Vector.create(x1, y1), Vector.create(x2, y2), rayWidth);
                        for(var i = 0; i < collisions.length; i++)result.push(collisions[i].body);
                        return result;
                    },
                    /**
     * Checks the given Matter Body to see if it intersects with any of the given bodies.
     *
     * If no bodies are provided it will check against all bodies in the Matter World.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#intersectBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The target body.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check the target body against. If not provided it will search all bodies in the world.
     *
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies whos vertices intersect with target body.
     */ intersectBody: function(body, bodies) {
                        bodies = this.getMatterBodies(bodies);
                        var result = [];
                        var collisions = Query.collides(body, bodies);
                        for(var i = 0; i < collisions.length; i++){
                            var pair = collisions[i];
                            if (pair.bodyA === body) result.push(pair.bodyB);
                            else result.push(pair.bodyA);
                        }
                        return result;
                    },
                    /**
     * Checks to see if the target body, or an array of target bodies, intersects with any of the given bodies.
     *
     * If intersection occurs this method will return `true` and, if provided, invoke the callbacks.
     *
     * If no bodies are provided for the second parameter the target will check against all bodies in the Matter World.
     *
     * **Note that bodies can only overlap if they are in non-colliding collision groups or categories.**
     *
     * If you provide a `processCallback` then the two bodies that overlap are sent to it. This callback
     * must return a boolean and is used to allow you to perform additional processing tests before a final
     * outcome is decided. If it returns `true` then the bodies are finally passed to the `overlapCallback`, if set.
     *
     * If you provide an `overlapCallback` then the matching pairs of overlapping bodies will be sent to it.
     *
     * Both callbacks have the following signature: `function (bodyA, bodyB, collisionInfo)` where `bodyA` is always
     * the target body. The `collisionInfo` object contains additional data, such as the angle and depth of penetration.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#overlap
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} target - The target body, or array of target bodies, to check.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - The second body, or array of bodies, to check. If falsey it will check against all bodies in the world.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [overlapCallback] - An optional callback function that is called if the bodies overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two bodies if they overlap. If this is set then `overlapCallback` will only be invoked if this callback returns `true`.
     * @param {*} [callbackContext] - The context, or scope, in which to run the callbacks.
     *
     * @return {boolean} `true` if the target body intersects with _any_ of the bodies given, otherwise `false`.
     */ overlap: function(target, bodies, overlapCallback, processCallback, callbackContext) {
                        if (overlapCallback === undefined) overlapCallback = null;
                        if (processCallback === undefined) processCallback = null;
                        if (callbackContext === undefined) callbackContext = overlapCallback;
                        if (!Array.isArray(target)) target = [
                            target
                        ];
                        target = this.getMatterBodies(target);
                        bodies = this.getMatterBodies(bodies);
                        var match = false;
                        for(var i = 0; i < target.length; i++){
                            var entry = target[i];
                            var collisions = Query.collides(entry, bodies);
                            for(var c = 0; c < collisions.length; c++){
                                var info = collisions[c];
                                var bodyB = info.bodyA.id === entry.id ? info.bodyB : info.bodyA;
                                if (!processCallback || processCallback.call(callbackContext, entry, bodyB, info)) {
                                    match = true;
                                    if (overlapCallback) overlapCallback.call(callbackContext, entry, bodyB, info);
                                    else if (!processCallback) //  If there are no callbacks we don't need to test every body, just exit when the first is found
                                    return true;
                                }
                            }
                        }
                        return match;
                    },
                    /**
     * Sets the collision filter category of all given Matter Bodies to the given value.
     *
     * This number must be a power of two between 2^0 (= 1) and 2^31.
     *
     * Bodies with different collision groups (see {@link #setCollisionGroup}) will only collide if their collision
     * categories are included in their collision masks (see {@link #setCollidesWith}).
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollisionCategory
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - Unique category bitfield.
     *
     * @return {this} This Matter Physics instance.
     */ setCollisionCategory: function(bodies, value) {
                        bodies = this.getMatterBodies(bodies);
                        bodies.forEach(function(body) {
                            body.collisionFilter.category = value;
                        });
                        return this;
                    },
                    /**
     * Sets the collision filter group of all given Matter Bodies to the given value.
     *
     * If the group value is zero, or if two Matter Bodies have different group values,
     * they will collide according to the usual collision filter rules (see {@link #setCollisionCategory} and {@link #setCollisionGroup}).
     *
     * If two Matter Bodies have the same positive group value, they will always collide;
     * if they have the same negative group value they will never collide.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollisionGroup
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - Unique group index.
     *
     * @return {this} This Matter Physics instance.
     */ setCollisionGroup: function(bodies, value) {
                        bodies = this.getMatterBodies(bodies);
                        bodies.forEach(function(body) {
                            body.collisionFilter.group = value;
                        });
                        return this;
                    },
                    /**
     * Sets the collision filter mask of all given Matter Bodies to the given value.
     *
     * Two Matter Bodies with different collision groups will only collide if each one includes the others
     * category in its mask based on a bitwise AND operation: `(categoryA & maskB) !== 0` and
     * `(categoryB & maskA) !== 0` are both true.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollidesWith
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
     *
     * @return {this} This Matter Physics instance.
     */ setCollidesWith: function(bodies, categories) {
                        bodies = this.getMatterBodies(bodies);
                        var flags = 0;
                        if (!Array.isArray(categories)) flags = categories;
                        else for(var i = 0; i < categories.length; i++)flags |= categories[i];
                        bodies.forEach(function(body) {
                            body.collisionFilter.mask = flags;
                        });
                        return this;
                    },
                    /**
     * Takes an array and returns a new array made from all of the Matter Bodies found in the original array.
     *
     * For example, passing in Matter Game Objects, such as a bunch of Matter Sprites, to this method, would
     * return an array containing all of their native Matter Body objects.
     *
     * If the `bodies` argument is falsey, it will return all bodies in the world.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getMatterBodies
     * @since 3.22.0
     *
     * @param {array} [bodies] - An array of objects to extract the bodies from. If falsey, it will return all bodies in the world.
     *
     * @return {MatterJS.BodyType[]} An array of native Matter Body objects.
     */ getMatterBodies: function(bodies) {
                        if (!bodies) return this.world.getAllBodies();
                        if (!Array.isArray(bodies)) bodies = [
                            bodies
                        ];
                        var output = [];
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i].hasOwnProperty('body') ? bodies[i].body : bodies[i];
                            output.push(body);
                        }
                        return output;
                    },
                    /**
     * Sets both the horizontal and vertical linear velocity of the physics bodies.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocity
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} x - The horizontal linear velocity value.
     * @param {number} y - The vertical linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocity: function(bodies, x, y) {
                        bodies = this.getMatterBodies(bodies);
                        var vec2 = this._tempVec2;
                        vec2.x = x;
                        vec2.y = y;
                        bodies.forEach(function(body) {
                            Body.setVelocity(body, vec2);
                        });
                        return this;
                    },
                    /**
     * Sets just the horizontal linear velocity of the physics bodies.
     * The vertical velocity of the body is unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocityX
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} x - The horizontal linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocityX: function(bodies, x) {
                        bodies = this.getMatterBodies(bodies);
                        var vec2 = this._tempVec2;
                        vec2.x = x;
                        bodies.forEach(function(body) {
                            vec2.y = body.velocity.y;
                            Body.setVelocity(body, vec2);
                        });
                        return this;
                    },
                    /**
     * Sets just the vertical linear velocity of the physics bodies.
     * The horizontal velocity of the body is unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocityY
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} y - The vertical linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocityY: function(bodies, y) {
                        bodies = this.getMatterBodies(bodies);
                        var vec2 = this._tempVec2;
                        vec2.y = y;
                        bodies.forEach(function(body) {
                            vec2.x = body.velocity.x;
                            Body.setVelocity(body, vec2);
                        });
                        return this;
                    },
                    /**
     * Sets the angular velocity of the bodies instantly.
     * Position, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setAngularVelocity
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - The angular velocity.
     *
     * @return {this} This Matter Physics instance.
     */ setAngularVelocity: function(bodies, value) {
                        bodies = this.getMatterBodies(bodies);
                        bodies.forEach(function(body) {
                            Body.setAngularVelocity(body, value);
                        });
                        return this;
                    },
                    /**
     * Applies a force to a body, at the bodies current position, including resulting torque.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForce
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {Phaser.Types.Math.Vector2Like} force - A Vector that specifies the force to apply.
     *
     * @return {this} This Matter Physics instance.
     */ applyForce: function(bodies, force) {
                        bodies = this.getMatterBodies(bodies);
                        var vec2 = this._tempVec2;
                        bodies.forEach(function(body) {
                            vec2.x = body.position.x;
                            vec2.y = body.position.y;
                            Body.applyForce(body, vec2, force);
                        });
                        return this;
                    },
                    /**
     * Applies a force to a body, from the given world position, including resulting torque.
     * If no angle is given, the current body angle is used.
     *
     * Use very small speed values, such as 0.1, depending on the mass and required velocity.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForceFromPosition
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {Phaser.Types.Math.Vector2Like} position - A Vector that specifies the world-space position to apply the force at.
     * @param {number} speed - A speed value to be applied to a directional force.
     * @param {number} [angle] - The angle, in radians, to apply the force from. Leave undefined to use the current body angle.
     *
     * @return {this} This Matter Physics instance.
     */ applyForceFromPosition: function(bodies, position, speed, angle) {
                        bodies = this.getMatterBodies(bodies);
                        var vec2 = this._tempVec2;
                        bodies.forEach(function(body) {
                            if (angle === undefined) angle = body.angle;
                            vec2.x = speed * Math.cos(angle);
                            vec2.y = speed * Math.sin(angle);
                            Body.applyForce(body, position, vec2);
                        });
                        return this;
                    },
                    /**
     * Apply a force to a body based on the given angle and speed.
     * If no angle is given, the current body angle is used.
     *
     * Use very small speed values, such as 0.1, depending on the mass and required velocity.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForceFromAngle
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} speed - A speed value to be applied to a directional force.
     * @param {number} [angle] - The angle, in radians, to apply the force from. Leave undefined to use the current body angle.
     *
     * @return {this} This Matter Physics instance.
     */ applyForceFromAngle: function(bodies, speed, angle) {
                        bodies = this.getMatterBodies(bodies);
                        var vec2 = this._tempVec2;
                        bodies.forEach(function(body) {
                            if (angle === undefined) angle = body.angle;
                            vec2.x = speed * Math.cos(angle);
                            vec2.y = speed * Math.sin(angle);
                            Body.applyForce(body, {
                                x: body.position.x,
                                y: body.position.y
                            }, vec2);
                        });
                        return this;
                    },
                    /**
     * Returns the length of the given constraint, which is the distance between the two points.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getConstraintLength
     * @since 3.22.0
     *
     * @param {MatterJS.ConstraintType} constraint - The constraint to get the length from.
     *
     * @return {number} The length of the constraint.
     */ getConstraintLength: function(constraint) {
                        var aX = constraint.pointA.x;
                        var aY = constraint.pointA.y;
                        var bX = constraint.pointB.x;
                        var bY = constraint.pointB.y;
                        if (constraint.bodyA) {
                            aX += constraint.bodyA.position.x;
                            aY += constraint.bodyA.position.y;
                        }
                        if (constraint.bodyB) {
                            bX += constraint.bodyB.position.x;
                            bY += constraint.bodyB.position.y;
                        }
                        return DistanceBetween(aX, aY, bX, bY);
                    },
                    /**
     * Aligns a Body, or Matter Game Object, against the given coordinates.
     *
     * The alignment takes place using the body bounds, which take into consideration things
     * like body scale and rotation.
     *
     * Although a Body has a `position` property, it is based on the center of mass for the body,
     * not a dimension based center. This makes aligning bodies difficult, especially if they have
     * rotated or scaled. This method will derive the correct position based on the body bounds and
     * its center of mass offset, in order to align the body with the given coordinate.
     *
     * For example, if you wanted to align a body so it sat in the bottom-center of the
     * Scene, and the world was 800 x 600 in size:
     *
     * ```javascript
     * this.matter.alignBody(body, 400, 600, Phaser.Display.Align.BOTTOM_CENTER);
     * ```
     *
     * You pass in 400 for the x coordinate, because that is the center of the world, and 600 for
     * the y coordinate, as that is the base of the world.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#alignBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to align.
     * @param {number} x - The horizontal position to align the body to.
     * @param {number} y - The vertical position to align the body to.
     * @param {number} align - One of the `Phaser.Display.Align` constants, such as `Phaser.Display.Align.TOP_LEFT`.
     *
     * @return {this} This Matter Physics instance.
     */ alignBody: function(body, x, y, align) {
                        body = body.hasOwnProperty('body') ? body.body : body;
                        var pos;
                        switch(align){
                            case ALIGN_CONST.TOP_LEFT:
                            case ALIGN_CONST.LEFT_TOP:
                                pos = this.bodyBounds.getTopLeft(body, x, y);
                                break;
                            case ALIGN_CONST.TOP_CENTER:
                                pos = this.bodyBounds.getTopCenter(body, x, y);
                                break;
                            case ALIGN_CONST.TOP_RIGHT:
                            case ALIGN_CONST.RIGHT_TOP:
                                pos = this.bodyBounds.getTopRight(body, x, y);
                                break;
                            case ALIGN_CONST.LEFT_CENTER:
                                pos = this.bodyBounds.getLeftCenter(body, x, y);
                                break;
                            case ALIGN_CONST.CENTER:
                                pos = this.bodyBounds.getCenter(body, x, y);
                                break;
                            case ALIGN_CONST.RIGHT_CENTER:
                                pos = this.bodyBounds.getRightCenter(body, x, y);
                                break;
                            case ALIGN_CONST.LEFT_BOTTOM:
                            case ALIGN_CONST.BOTTOM_LEFT:
                                pos = this.bodyBounds.getBottomLeft(body, x, y);
                                break;
                            case ALIGN_CONST.BOTTOM_CENTER:
                                pos = this.bodyBounds.getBottomCenter(body, x, y);
                                break;
                            case ALIGN_CONST.BOTTOM_RIGHT:
                            case ALIGN_CONST.RIGHT_BOTTOM:
                                pos = this.bodyBounds.getBottomRight(body, x, y);
                                break;
                        }
                        if (pos) Body.setPosition(body, pos);
                        return this;
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        var eventEmitter = this.systems.events;
                        if (this.world) {
                            eventEmitter.off(SceneEvents.UPDATE, this.world.update, this.world);
                            eventEmitter.off(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                        }
                        eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                        if (this.add) this.add.destroy();
                        if (this.world) this.world.destroy();
                        this.add = null;
                        this.world = null;
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.scene.sys.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                    }
                });
                PluginCache.register('MatterPhysics', MatterPhysics, 'matterPhysics');
                module1.exports = MatterPhysics;
            /***/ },
            /***/ 34803: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(9674);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31884);
                var GameObject = __webpack_require__(95643);
                var GetFastValue = __webpack_require__(95540);
                var Pipeline = __webpack_require__(72699);
                var Sprite = __webpack_require__(68287);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Matter Physics Sprite Game Object.
 *
 * A Sprite Game Object is used for the display of both static and animated images in your game.
 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
 * and animated.
 *
 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Force
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.SetBody
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 * @extends Phaser.Physics.Matter.Components.Transform
 * @extends Phaser.Physics.Matter.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter.World instance that this body belongs to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
 */ var MatterSprite = new Class({
                    Extends: Sprite,
                    Mixins: [
                        Components.Bounce,
                        Components.Collision,
                        Components.Force,
                        Components.Friction,
                        Components.Gravity,
                        Components.Mass,
                        Components.Sensor,
                        Components.SetBody,
                        Components.Sleep,
                        Components.Static,
                        Components.Transform,
                        Components.Velocity,
                        Pipeline
                    ],
                    initialize: function MatterSprite(world, x, y, texture, frame, options) {
                        GameObject.call(this, world.scene, 'Sprite');
                        /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.Physics.Matter.Sprite#_crop
         * @type {object}
         * @private
         * @since 3.24.0
         */ this._crop = this.resetCropObject();
                        this.anims = new AnimationState(this);
                        this.setTexture(texture, frame);
                        this.setSizeToFrame();
                        this.setOrigin();
                        /**
         * A reference to the Matter.World instance that this body belongs to.
         *
         * @name Phaser.Physics.Matter.Sprite#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.Sprite#_tempVec2
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec2 = new Vector2(x, y);
                        var shape = GetFastValue(options, 'shape', null);
                        if (shape) this.setBody(shape, options);
                        else this.setRectangle(this.width, this.height, options);
                        this.setPosition(x, y);
                        this.initPipeline();
                        this.initPostPipeline(true);
                    }
                });
                module1.exports = MatterSprite;
            /***/ },
            /***/ 73834: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(66280);
                var Body = __webpack_require__(22562);
                var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31884);
                var DeepCopy = __webpack_require__(62644);
                var EventEmitter = __webpack_require__(50792);
                var GetFastValue = __webpack_require__(95540);
                var HasValue = __webpack_require__(97022);
                var Vertices = __webpack_require__(41598);
                /**
 * @classdesc
 * A wrapper around a Tile that provides access to a corresponding Matter body. A tile can only
 * have one Matter body associated with it. You can either pass in an existing Matter body for
 * the tile or allow the constructor to create the corresponding body for you. If the Tile has a
 * collision group (defined in Tiled), those shapes will be used to create the body. If not, the
 * tile's rectangle bounding box will be used.
 *
 * The corresponding body will be accessible on the Tile itself via Tile.physics.matterBody.
 *
 * Note: not all Tiled collision shapes are supported. See
 * Phaser.Physics.Matter.TileBody#setFromTileCollision for more information.
 *
 * @class TileBody
 * @memberof Phaser.Physics.Matter
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter world instance this body belongs to.
 * @param {Phaser.Tilemaps.Tile} tile - The target tile that should have a Matter body.
 * @param {Phaser.Types.Physics.Matter.MatterTileOptions} [options] - Options to be used when creating the Matter body.
 */ var MatterTileBody = new Class({
                    Extends: EventEmitter,
                    Mixins: [
                        Components.Bounce,
                        Components.Collision,
                        Components.Friction,
                        Components.Gravity,
                        Components.Mass,
                        Components.Sensor,
                        Components.Sleep,
                        Components.Static
                    ],
                    initialize: function MatterTileBody(world, tile, options) {
                        EventEmitter.call(this);
                        /**
         * The tile object the body is associated with.
         *
         * @name Phaser.Physics.Matter.TileBody#tile
         * @type {Phaser.Tilemaps.Tile}
         * @since 3.0.0
         */ this.tile = tile;
                        /**
         * The Matter world the body exists within.
         *
         * @name Phaser.Physics.Matter.TileBody#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                        // Install a reference to 'this' on the tile and ensure there can only be one matter body
                        // associated with the tile
                        if (tile.physics.matterBody) tile.physics.matterBody.destroy();
                        tile.physics.matterBody = this;
                        // Set the body either from an existing body (if provided), the shapes in the tileset
                        // collision layer (if it exists) or a rectangle matching the tile.
                        var body = GetFastValue(options, 'body', null);
                        var addToWorld = GetFastValue(options, 'addToWorld', true);
                        if (!body) {
                            var collisionGroup = tile.getCollisionGroup();
                            var collisionObjects = GetFastValue(collisionGroup, 'objects', []);
                            if (collisionObjects.length > 0) this.setFromTileCollision(options);
                            else this.setFromTileRectangle(options);
                        } else this.setBody(body, addToWorld);
                        if (tile.flipX || tile.flipY) {
                            var rotationPoint = {
                                x: tile.getCenterX(),
                                y: tile.getCenterY()
                            };
                            var scaleX = tile.flipX ? -1 : 1;
                            var scaleY = tile.flipY ? -1 : 1;
                            Body.scale(body, scaleX, scaleY, rotationPoint);
                        }
                    },
                    /**
     * Sets the current body to a rectangle that matches the bounds of the tile.
     *
     * @method Phaser.Physics.Matter.TileBody#setFromTileRectangle
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBodyTileOptions} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setFromTileRectangle: function(options) {
                        if (options === undefined) options = {};
                        if (!HasValue(options, 'isStatic')) options.isStatic = true;
                        if (!HasValue(options, 'addToWorld')) options.addToWorld = true;
                        var bounds = this.tile.getBounds();
                        var cx = bounds.x + bounds.width / 2;
                        var cy = bounds.y + bounds.height / 2;
                        var body = Bodies.rectangle(cx, cy, bounds.width, bounds.height, options);
                        this.setBody(body, options.addToWorld);
                        return this;
                    },
                    /**
     * Sets the current body from the collision group associated with the Tile. This is typically
     * set up in Tiled's collision editor.
     *
     * Note: Matter doesn't support all shapes from Tiled. Rectangles and polygons are directly
     * supported. Ellipses are converted into circle bodies. Polylines are treated as if they are
     * closed polygons. If a tile has multiple shapes, a multi-part body will be created. Concave
     * shapes are supported if poly-decomp library is included. Decomposition is not guaranteed to
     * work for complex shapes (e.g. holes), so it's often best to manually decompose a concave
     * polygon into multiple convex polygons yourself.
     *
     * @method Phaser.Physics.Matter.TileBody#setFromTileCollision
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBodyTileOptions} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setFromTileCollision: function(options) {
                        if (options === undefined) options = {};
                        if (!HasValue(options, 'isStatic')) options.isStatic = true;
                        if (!HasValue(options, 'addToWorld')) options.addToWorld = true;
                        var sx = this.tile.tilemapLayer.scaleX;
                        var sy = this.tile.tilemapLayer.scaleY;
                        var tileX = this.tile.getLeft();
                        var tileY = this.tile.getTop();
                        var collisionGroup = this.tile.getCollisionGroup();
                        var collisionObjects = GetFastValue(collisionGroup, 'objects', []);
                        var parts = [];
                        for(var i = 0; i < collisionObjects.length; i++){
                            var object = collisionObjects[i];
                            var ox = tileX + object.x * sx;
                            var oy = tileY + object.y * sy;
                            var ow = object.width * sx;
                            var oh = object.height * sy;
                            var body = null;
                            if (object.rectangle) body = Bodies.rectangle(ox + ow / 2, oy + oh / 2, ow, oh, options);
                            else if (object.ellipse) body = Bodies.circle(ox + ow / 2, oy + oh / 2, ow / 2, options);
                            else if (object.polygon || object.polyline) {
                                // Polygons and polylines are both treated as closed polygons
                                var originalPoints = object.polygon ? object.polygon : object.polyline;
                                var points = originalPoints.map(function(p) {
                                    return {
                                        x: p.x * sx,
                                        y: p.y * sy
                                    };
                                });
                                var vertices = Vertices.create(points);
                                // Points are relative to the object's origin (first point placed in Tiled), but
                                // matter expects points to be relative to the center of mass. This only applies to
                                // convex shapes. When a concave shape is decomposed, multiple parts are created and
                                // the individual parts are positioned relative to (ox, oy).
                                //
                                //  Update: 8th January 2019 - the latest version of Matter needs the Vertices adjusted,
                                //  regardless if convex or concave.
                                var center = Vertices.centre(vertices);
                                ox += center.x;
                                oy += center.y;
                                body = Bodies.fromVertices(ox, oy, vertices, options);
                            }
                            if (body) parts.push(body);
                        }
                        if (parts.length === 1) this.setBody(parts[0], options.addToWorld);
                        else if (parts.length > 1) {
                            var tempOptions = DeepCopy(options);
                            tempOptions.parts = parts;
                            this.setBody(Body.create(tempOptions), tempOptions.addToWorld);
                        }
                        return this;
                    },
                    /**
     * Sets the current body to the given body. This will remove the previous body, if one already
     * exists.
     *
     * @method Phaser.Physics.Matter.TileBody#setBody
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The new Matter body to use.
     * @param {boolean} [addToWorld=true] - Whether or not to add the body to the Matter world.
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setBody: function(body, addToWorld) {
                        if (addToWorld === undefined) addToWorld = true;
                        if (this.body) this.removeBody();
                        this.body = body;
                        this.body.gameObject = this;
                        if (addToWorld) this.world.add(this.body);
                        return this;
                    },
                    /**
     * Removes the current body from the TileBody and from the Matter world
     *
     * @method Phaser.Physics.Matter.TileBody#removeBody
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ removeBody: function() {
                        if (this.body) {
                            this.world.remove(this.body);
                            this.body.gameObject = undefined;
                            this.body = undefined;
                        }
                        return this;
                    },
                    /**
     * Removes the current body from the tile and the world.
     *
     * @method Phaser.Physics.Matter.TileBody#destroy
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ destroy: function() {
                        this.removeBody();
                        this.tile.physics.matterBody = undefined;
                        this.removeAllListeners();
                    }
                });
                module1.exports = MatterTileBody;
            /***/ },
            /***/ 19496: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Joachim Grill <joachim@codeandweb.com>
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2018 CodeAndWeb GmbH
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(66280);
                var Body = __webpack_require__(22562);
                var Common = __webpack_require__(53402);
                var GetFastValue = __webpack_require__(95540);
                var Vertices = __webpack_require__(41598);
                /**
 * Use PhysicsEditorParser.parseBody() to build a Matter body object, based on a physics data file
 * created and exported with PhysicsEditor (https://www.codeandweb.com/physicseditor).
 *
 * @namespace Phaser.Physics.Matter.PhysicsEditorParser
 * @since 3.10.0
 */ var PhysicsEditorParser = {
                    /**
     * Parses a body element exported by PhysicsEditor.
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseBody
     * @since 3.10.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {object} config - The body configuration and fixture (child body) definitions, as exported by PhysicsEditor.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A compound Matter JS Body.
     */ parseBody: function(x, y, config, options) {
                        if (options === undefined) options = {};
                        var fixtureConfigs = GetFastValue(config, 'fixtures', []);
                        var fixtures = [];
                        for(var fc = 0; fc < fixtureConfigs.length; fc++){
                            var fixtureParts = this.parseFixture(fixtureConfigs[fc]);
                            for(var i = 0; i < fixtureParts.length; i++)fixtures.push(fixtureParts[i]);
                        }
                        var matterConfig = Common.clone(config, true);
                        Common.extend(matterConfig, options, true);
                        delete matterConfig.fixtures;
                        delete matterConfig.type;
                        var body = Body.create(matterConfig);
                        Body.setParts(body, fixtures);
                        Body.setPosition(body, {
                            x: x,
                            y: y
                        });
                        return body;
                    },
                    /**
     * Parses an element of the "fixtures" list exported by PhysicsEditor
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseFixture
     * @since 3.10.0
     *
     * @param {object} fixtureConfig - The fixture object to parse.
     *
     * @return {MatterJS.BodyType[]} - An array of Matter JS Bodies.
     */ parseFixture: function(fixtureConfig) {
                        var matterConfig = Common.extend({}, false, fixtureConfig);
                        delete matterConfig.circle;
                        delete matterConfig.vertices;
                        var fixtures;
                        if (fixtureConfig.circle) {
                            var x = GetFastValue(fixtureConfig.circle, 'x');
                            var y = GetFastValue(fixtureConfig.circle, 'y');
                            var r = GetFastValue(fixtureConfig.circle, 'radius');
                            fixtures = [
                                Bodies.circle(x, y, r, matterConfig)
                            ];
                        } else if (fixtureConfig.vertices) fixtures = this.parseVertices(fixtureConfig.vertices, matterConfig);
                        return fixtures;
                    },
                    /**
     * Parses the "vertices" lists exported by PhysicsEditor.
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseVertices
     * @since 3.10.0
     *
     * @param {array} vertexSets - The vertex lists to parse.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType[]} - An array of Matter JS Bodies.
     */ parseVertices: function(vertexSets, options) {
                        if (options === undefined) options = {};
                        var parts = [];
                        for(var v = 0; v < vertexSets.length; v++){
                            Vertices.clockwiseSort(vertexSets[v]);
                            parts.push(Body.create(Common.extend({
                                position: Vertices.centre(vertexSets[v]),
                                vertices: vertexSets[v]
                            }, options)));
                        }
                        // flag coincident part edges
                        return Bodies.flagCoincidentParts(parts);
                    }
                };
                module1.exports = PhysicsEditorParser;
            /***/ },
            /***/ 85791: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(66280);
                var Body = __webpack_require__(22562);
                /**
 * Creates a body using the supplied physics data, as provided by a JSON file.
 *
 * The data file should be loaded as JSON:
 *
 * ```javascript
 * preload ()
 * {
 *   this.load.json('ninjas', 'assets/ninjas.json);
 * }
 *
 * create ()
 * {
 *   const ninjaShapes = this.cache.json.get('ninjas');
 *
 *   this.matter.add.fromJSON(400, 300, ninjaShapes.shinobi);
 * }
 * ```
 *
 * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
 *
 * If you pas in an `options` object, any settings in there will override those in the config object.
 *
 * The structure of the JSON file is as follows:
 *
 * ```text
 * {
 *   'generator_info': // The name of the application that created the JSON data
 *   'shapeName': {
 *     'type': // The type of body
 *     'label': // Optional body label
 *     'vertices': // An array, or an array of arrays, containing the vertex data in x/y object pairs
 *   }
 * }
 * ```
 *
 * At the time of writing, only the Phaser Physics Tracer App exports in this format.
 *
 * @namespace Phaser.Physics.Matter.PhysicsJSONParser
 * @since 3.22.0
 */ var PhysicsJSONParser = {
                    /**
     * Parses a body element from the given JSON data.
     *
     * @function Phaser.Physics.Matter.PhysicsJSONParser.parseBody
     * @since 3.22.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {object} config - The body configuration data.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ parseBody: function(x, y, config, options) {
                        if (options === undefined) options = {};
                        var body;
                        var vertexSets = config.vertices;
                        if (vertexSets.length === 1) {
                            //  Just a single Body
                            options.vertices = vertexSets[0];
                            body = Body.create(options);
                            Bodies.flagCoincidentParts(body.parts);
                        } else {
                            var parts = [];
                            for(var i = 0; i < vertexSets.length; i++){
                                var part = Body.create({
                                    vertices: vertexSets[i]
                                });
                                parts.push(part);
                            }
                            Bodies.flagCoincidentParts(parts);
                            options.parts = parts;
                            body = Body.create(options);
                        }
                        body.label = config.label;
                        Body.setPosition(body, {
                            x: x,
                            y: y
                        });
                        return body;
                    }
                };
                module1.exports = PhysicsJSONParser;
            /***/ },
            /***/ 98713: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bounds = __webpack_require__(15647);
                var Class = __webpack_require__(83419);
                var Composite = __webpack_require__(69351);
                var Constraint = __webpack_require__(48140);
                var Detector = __webpack_require__(81388);
                var Events = __webpack_require__(1121);
                var InputEvents = __webpack_require__(8214);
                var Merge = __webpack_require__(46975);
                var Sleeping = __webpack_require__(53614);
                var Vector2 = __webpack_require__(26099);
                var Vertices = __webpack_require__(41598);
                /**
 * @classdesc
 * A Pointer Constraint is a special type of constraint that allows you to click
 * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
 * and when one is pressed down it checks to see if that hit any part of any active
 * body in the world. If it did, and the body has input enabled, it will begin to
 * drag it until either released, or you stop it via the `stopDrag` method.
 *
 * You can adjust the stiffness, length and other properties of the constraint via
 * the `options` object on creation.
 *
 * @class PointerConstraint
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene to which this Pointer Constraint belongs.
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter World instance to which this Constraint belongs.
 * @param {object} [options] - A Constraint configuration object.
 */ var PointerConstraint = new Class({
                    initialize: function PointerConstraint(scene, world, options) {
                        if (options === undefined) options = {};
                        //  Defaults
                        var defaults = {
                            label: 'Pointer Constraint',
                            pointA: {
                                x: 0,
                                y: 0
                            },
                            pointB: {
                                x: 0,
                                y: 0
                            },
                            length: 0.01,
                            stiffness: 0.1,
                            angularStiffness: 1,
                            collisionFilter: {
                                category: 0x0001,
                                mask: 0xFFFFFFFF,
                                group: 0
                            }
                        };
                        /**
         * A reference to the Scene to which this Pointer Constraint belongs.
         * This is the same Scene as the Matter World instance.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Matter World instance to which this Constraint belongs.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                        /**
         * The Camera the Pointer was interacting with when the input
         * down event was processed.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.0.0
         */ this.camera = null;
                        /**
         * A reference to the Input Pointer that activated this Constraint.
         * This is set in the `onDown` handler.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#pointer
         * @type {Phaser.Input.Pointer}
         * @default null
         * @since 3.0.0
         */ this.pointer = null;
                        /**
         * Is this Constraint active or not?
         *
         * An active constraint will be processed each update. An inactive one will be skipped.
         * Use this to toggle a Pointer Constraint on and off.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                        /**
         * The internal transformed position.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2();
                        /**
         * The body that is currently being dragged, if any.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#body
         * @type {?MatterJS.BodyType}
         * @since 3.16.2
         */ this.body = null;
                        /**
         * The part of the body that was clicked on to start the drag.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#part
         * @type {?MatterJS.BodyType}
         * @since 3.16.2
         */ this.part = null;
                        /**
         * The native Matter Constraint that is used to attach to bodies.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#constraint
         * @type {MatterJS.ConstraintType}
         * @since 3.0.0
         */ this.constraint = Constraint.create(Merge(options, defaults));
                        this.world.on(Events.BEFORE_UPDATE, this.update, this);
                        scene.sys.input.on(InputEvents.POINTER_DOWN, this.onDown, this);
                        scene.sys.input.on(InputEvents.POINTER_UP, this.onUp, this);
                    },
                    /**
     * A Pointer has been pressed down onto the Scene.
     *
     * If this Constraint doesn't have an active Pointer then a hit test is set to
     * run against all active bodies in the world during the _next_ call to `update`.
     * If a body is found, it is bound to this constraint and the drag begins.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#onDown
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - A reference to the Pointer that was pressed.
     */ onDown: function(pointer) {
                        if (!this.pointer) {
                            this.pointer = pointer;
                            this.camera = pointer.camera;
                        }
                    },
                    /**
     * A Pointer has been released from the Scene. If it was the one this constraint was using, it's cleared.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#onUp
     * @since 3.22.0
     *
     * @param {Phaser.Input.Pointer} pointer - A reference to the Pointer that was pressed.
     */ onUp: function(pointer) {
                        if (pointer === this.pointer) this.pointer = null;
                    },
                    /**
     * Scans all active bodies in the current Matter World to see if any of them
     * are hit by the Pointer. The _first one_ found to hit is set as the active contraint
     * body.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#getBody
     * @fires Phaser.Physics.Matter.Events#DRAG_START
     * @since 3.16.2
     *
     * @return {boolean} `true` if a body was found and set, otherwise `false`.
     */ getBody: function(pointer) {
                        var pos = this.position;
                        var constraint = this.constraint;
                        this.camera.getWorldPoint(pointer.x, pointer.y, pos);
                        var bodies = Composite.allBodies(this.world.localWorld);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            if (!body.ignorePointer && Bounds.contains(body.bounds, pos) && Detector.canCollide(body.collisionFilter, constraint.collisionFilter)) {
                                if (this.hitTestBody(body, pos)) {
                                    this.world.emit(Events.DRAG_START, body, this.part, this);
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    /**
     * Scans the current body to determine if a part of it was clicked on.
     * If a part is found the body is set as the `constraint.bodyB` property,
     * as well as the `body` property of this class. The part is also set.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#hitTestBody
     * @since 3.16.2
     *
     * @param {MatterJS.BodyType} body - The Matter Body to check.
     * @param {Phaser.Math.Vector2} position - A translated hit test position.
     *
     * @return {boolean} `true` if a part of the body was hit, otherwise `false`.
     */ hitTestBody: function(body, position) {
                        var constraint = this.constraint;
                        var partsLength = body.parts.length;
                        var start = partsLength > 1 ? 1 : 0;
                        for(var i = start; i < partsLength; i++){
                            var part = body.parts[i];
                            if (Vertices.contains(part.vertices, position)) {
                                constraint.pointA = position;
                                constraint.pointB = {
                                    x: position.x - body.position.x,
                                    y: position.y - body.position.y
                                };
                                constraint.bodyB = body;
                                constraint.angleB = body.angle;
                                Sleeping.set(body, false);
                                this.part = part;
                                this.body = body;
                                return true;
                            }
                        }
                        return false;
                    },
                    /**
     * Internal update handler. Called in the Matter BEFORE_UPDATE step.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#update
     * @fires Phaser.Physics.Matter.Events#DRAG
     * @since 3.0.0
     */ update: function() {
                        var pointer = this.pointer;
                        var body = this.body;
                        if (!this.active || !pointer) {
                            if (body) this.stopDrag();
                            return;
                        }
                        if (!pointer.isDown && body) {
                            this.stopDrag();
                            return;
                        } else if (pointer.isDown) {
                            if (!this.camera || !body && !this.getBody(pointer)) return;
                            body = this.body;
                            var pos = this.position;
                            var constraint = this.constraint;
                            this.camera.getWorldPoint(pointer.x, pointer.y, pos);
                            //  Drag update
                            constraint.pointA.x = pos.x;
                            constraint.pointA.y = pos.y;
                            Sleeping.set(body, false);
                            this.world.emit(Events.DRAG, body, this);
                        }
                    },
                    /**
     * Stops the Pointer Constraint from dragging the body any further.
     *
     * This is called automatically if the Pointer is released while actively
     * dragging a body. Or, you can call it manually to release a body from a
     * constraint without having to first release the pointer.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#stopDrag
     * @fires Phaser.Physics.Matter.Events#DRAG_END
     * @since 3.16.2
     */ stopDrag: function() {
                        var body = this.body;
                        var constraint = this.constraint;
                        constraint.bodyB = null;
                        constraint.pointB = null;
                        this.pointer = null;
                        this.body = null;
                        this.part = null;
                        if (body) this.world.emit(Events.DRAG_END, body, this);
                    },
                    /**
     * Destroys this Pointer Constraint instance and all of its references.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.world.removeConstraint(this.constraint);
                        this.pointer = null;
                        this.constraint = null;
                        this.body = null;
                        this.part = null;
                        this.world.off(Events.BEFORE_UPDATE, this.update);
                        this.scene.sys.input.off(InputEvents.POINTER_DOWN, this.onDown, this);
                        this.scene.sys.input.off(InputEvents.POINTER_UP, this.onUp, this);
                    }
                });
                module1.exports = PointerConstraint;
            /***/ },
            /***/ 68243: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(66280);
                var Body = __webpack_require__(22562);
                var Class = __webpack_require__(83419);
                var Common = __webpack_require__(53402);
                var Composite = __webpack_require__(69351);
                var Engine = __webpack_require__(48413);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(1121);
                var GetFastValue = __webpack_require__(95540);
                var GetValue = __webpack_require__(35154);
                var MatterBody = __webpack_require__(22562);
                var MatterEvents = __webpack_require__(35810);
                var MatterTileBody = __webpack_require__(73834);
                var MatterWorld = __webpack_require__(4372);
                var MatterRunner = __webpack_require__(13037);
                var Vector = __webpack_require__(31725);
                /**
 * @classdesc
 * The Matter World class is responsible for managing one single instance of a Matter Physics World for Phaser.
 *
 * Access this via `this.matter.world` from within a Scene.
 *
 * This class creates a Matter JS World Composite along with the Matter JS Engine during instantiation. It also
 * handles delta timing, bounds, body and constraint creation and debug drawing.
 *
 * If you wish to access the Matter JS World object directly, see the `localWorld` property.
 * If you wish to access the Matter Engine directly, see the `engine` property.
 *
 * This class is an Event Emitter and will proxy _all_ Matter JS events, as they are received.
 *
 * @class World
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Matter World instance belongs.
 * @param {Phaser.Types.Physics.Matter.MatterWorldConfig} config - The Matter World configuration object.
 */ var World = new Class({
                    Extends: EventEmitter,
                    initialize: function World(scene, config) {
                        EventEmitter.call(this);
                        /**
         * The Scene to which this Matter World instance belongs.
         *
         * @name Phaser.Physics.Matter.World#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * An instance of the MatterJS Engine.
         *
         * @name Phaser.Physics.Matter.World#engine
         * @type {MatterJS.Engine}
         * @since 3.0.0
         */ this.engine = Engine.create(config);
                        /**
         * A `World` composite object that will contain all simulated bodies and constraints.
         *
         * @name Phaser.Physics.Matter.World#localWorld
         * @type {MatterJS.World}
         * @since 3.0.0
         */ this.localWorld = this.engine.world;
                        var gravity = GetValue(config, 'gravity', null);
                        if (gravity) this.setGravity(gravity.x, gravity.y, gravity.scale);
                        else if (gravity === false) this.setGravity(0, 0, 0);
                        /**
         * An object containing the 4 wall bodies that bound the physics world.
         *
         * @name Phaser.Physics.Matter.World#walls
         * @type {Phaser.Types.Physics.Matter.MatterWalls}
         * @since 3.0.0
         */ this.walls = {
                            left: null,
                            right: null,
                            top: null,
                            bottom: null
                        };
                        /**
         * A flag that toggles if the world is enabled or not.
         *
         * @name Phaser.Physics.Matter.World#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = GetValue(config, 'enabled', true);
                        /**
         * This function is called every time the core game loop steps, which is bound to the
         * Request Animation Frame frequency unless otherwise modified.
         *
         * The function is passed two values: `time` and `delta`, both of which come from the game step values.
         *
         * It must return a number. This number is used as the delta value passed to Matter.Engine.update.
         *
         * You can override this function with your own to define your own timestep.
         *
         * If you need to update the Engine multiple times in a single game step then call
         * `World.update` as many times as required. Each call will trigger the `getDelta` function.
         * If you wish to have full control over when the Engine updates then see the property `autoUpdate`.
         *
         * You can also adjust the number of iterations that Engine.update performs.
         * Use the Scene Matter Physics config object to set the following properties:
         *
         * positionIterations (defaults to 6)
         * velocityIterations (defaults to 4)
         * constraintIterations (defaults to 2)
         *
         * Adjusting these values can help performance in certain situations, depending on the physics requirements
         * of your game.
         *
         * @name Phaser.Physics.Matter.World#getDelta
         * @type {function}
         * @since 3.4.0
         */ this.getDelta = GetValue(config, 'getDelta', this.update60Hz);
                        var runnerConfig = GetFastValue(config, 'runner', {});
                        var hasFPS = GetFastValue(runnerConfig, 'fps', false);
                        if (hasFPS) runnerConfig.delta = 1000 / GetFastValue(runnerConfig, 'fps', 60);
                        /**
         * The Matter JS Runner Configuration object.
         *
         * This object is populated via the Matter Configuration object's `runner` property and is
         * updated constantly during the game step.
         *
         * @name Phaser.Physics.Matter.World#runner
         * @type {Phaser.Types.Physics.Matter.MatterRunnerConfig}
         * @since 3.22.0
         */ this.runner = MatterRunner.create(runnerConfig);
                        /**
         * Automatically call Engine.update every time the game steps.
         * If you disable this then you are responsible for calling `World.step` directly from your game.
         * If you call `set60Hz` or `set30Hz` then `autoUpdate` is reset to `true`.
         *
         * @name Phaser.Physics.Matter.World#autoUpdate
         * @type {boolean}
         * @default true
         * @since 3.4.0
         */ this.autoUpdate = GetValue(config, 'autoUpdate', true);
                        var debugConfig = GetValue(config, 'debug', false);
                        /**
         * A flag that controls if the debug graphics will be drawn to or not.
         *
         * @name Phaser.Physics.Matter.World#drawDebug
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.drawDebug = typeof debugConfig === 'object' ? true : debugConfig;
                        /**
         * An instance of the Graphics object the debug bodies are drawn to, if enabled.
         *
         * @name Phaser.Physics.Matter.World#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.debugGraphic;
                        /**
         * The debug configuration object.
         *
         * The values stored in this object are read from the Matter World Config `debug` property.
         *
         * When a new Body or Constraint is _added to the World_, they are given the values stored in this object,
         * unless they have their own `render` object set that will override them.
         *
         * Note that while you can modify the values of properties in this object at run-time, it will not change
         * any of the Matter objects _already added_. It will only impact objects newly added to the world, or one
         * that is removed and then re-added at a later time.
         *
         * @name Phaser.Physics.Matter.World#debugConfig
         * @type {Phaser.Types.Physics.Matter.MatterDebugConfig}
         * @since 3.22.0
         */ this.debugConfig = {
                            showAxes: GetFastValue(debugConfig, 'showAxes', false),
                            showAngleIndicator: GetFastValue(debugConfig, 'showAngleIndicator', false),
                            angleColor: GetFastValue(debugConfig, 'angleColor', 0xe81153),
                            showBroadphase: GetFastValue(debugConfig, 'showBroadphase', false),
                            broadphaseColor: GetFastValue(debugConfig, 'broadphaseColor', 0xffb400),
                            showBounds: GetFastValue(debugConfig, 'showBounds', false),
                            boundsColor: GetFastValue(debugConfig, 'boundsColor', 0xffffff),
                            showVelocity: GetFastValue(debugConfig, 'showVelocity', false),
                            velocityColor: GetFastValue(debugConfig, 'velocityColor', 0x00aeef),
                            showCollisions: GetFastValue(debugConfig, 'showCollisions', false),
                            collisionColor: GetFastValue(debugConfig, 'collisionColor', 0xf5950c),
                            showSeparations: GetFastValue(debugConfig, 'showSeparations', false),
                            separationColor: GetFastValue(debugConfig, 'separationColor', 0xffa500),
                            showBody: GetFastValue(debugConfig, 'showBody', true),
                            showStaticBody: GetFastValue(debugConfig, 'showStaticBody', true),
                            showInternalEdges: GetFastValue(debugConfig, 'showInternalEdges', false),
                            renderFill: GetFastValue(debugConfig, 'renderFill', false),
                            renderLine: GetFastValue(debugConfig, 'renderLine', true),
                            fillColor: GetFastValue(debugConfig, 'fillColor', 0x106909),
                            fillOpacity: GetFastValue(debugConfig, 'fillOpacity', 1),
                            lineColor: GetFastValue(debugConfig, 'lineColor', 0x28de19),
                            lineOpacity: GetFastValue(debugConfig, 'lineOpacity', 1),
                            lineThickness: GetFastValue(debugConfig, 'lineThickness', 1),
                            staticFillColor: GetFastValue(debugConfig, 'staticFillColor', 0x0d177b),
                            staticLineColor: GetFastValue(debugConfig, 'staticLineColor', 0x1327e4),
                            showSleeping: GetFastValue(debugConfig, 'showSleeping', false),
                            staticBodySleepOpacity: GetFastValue(debugConfig, 'staticBodySleepOpacity', 0.7),
                            sleepFillColor: GetFastValue(debugConfig, 'sleepFillColor', 0x464646),
                            sleepLineColor: GetFastValue(debugConfig, 'sleepLineColor', 0x999a99),
                            showSensors: GetFastValue(debugConfig, 'showSensors', true),
                            sensorFillColor: GetFastValue(debugConfig, 'sensorFillColor', 0x0d177b),
                            sensorLineColor: GetFastValue(debugConfig, 'sensorLineColor', 0x1327e4),
                            showPositions: GetFastValue(debugConfig, 'showPositions', true),
                            positionSize: GetFastValue(debugConfig, 'positionSize', 4),
                            positionColor: GetFastValue(debugConfig, 'positionColor', 0xe042da),
                            showJoint: GetFastValue(debugConfig, 'showJoint', true),
                            jointColor: GetFastValue(debugConfig, 'jointColor', 0xe0e042),
                            jointLineOpacity: GetFastValue(debugConfig, 'jointLineOpacity', 1),
                            jointLineThickness: GetFastValue(debugConfig, 'jointLineThickness', 2),
                            pinSize: GetFastValue(debugConfig, 'pinSize', 4),
                            pinColor: GetFastValue(debugConfig, 'pinColor', 0x42e0e0),
                            springColor: GetFastValue(debugConfig, 'springColor', 0xe042e0),
                            anchorColor: GetFastValue(debugConfig, 'anchorColor', 0xefefef),
                            anchorSize: GetFastValue(debugConfig, 'anchorSize', 4),
                            showConvexHulls: GetFastValue(debugConfig, 'showConvexHulls', false),
                            hullColor: GetFastValue(debugConfig, 'hullColor', 0xd703d0)
                        };
                        if (this.drawDebug) this.createDebugGraphic();
                        this.setEventsProxy();
                        //  Create the walls
                        if (GetFastValue(config, 'setBounds', false)) {
                            var boundsConfig = config['setBounds'];
                            if (typeof boundsConfig === 'boolean') this.setBounds();
                            else {
                                var x = GetFastValue(boundsConfig, 'x', 0);
                                var y = GetFastValue(boundsConfig, 'y', 0);
                                var width = GetFastValue(boundsConfig, 'width', scene.sys.scale.width);
                                var height = GetFastValue(boundsConfig, 'height', scene.sys.scale.height);
                                var thickness = GetFastValue(boundsConfig, 'thickness', 64);
                                var left = GetFastValue(boundsConfig, 'left', true);
                                var right = GetFastValue(boundsConfig, 'right', true);
                                var top = GetFastValue(boundsConfig, 'top', true);
                                var bottom = GetFastValue(boundsConfig, 'bottom', true);
                                this.setBounds(x, y, width, height, thickness, left, right, top, bottom);
                            }
                        }
                    },
                    /**
     * Sets the debug render style for the children of the given Matter Composite.
     *
     * Composites themselves do not render, but they can contain bodies, constraints and other composites that may do.
     * So the children of this composite are passed to the `setBodyRenderStyle`, `setCompositeRenderStyle` and
     * `setConstraintRenderStyle` methods accordingly.
     *
     * @method Phaser.Physics.Matter.World#setCompositeRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.CompositeType} composite - The Matter Composite to set the render style on.
     *
     * @return {this} This Matter World instance for method chaining.
     */ setCompositeRenderStyle: function(composite) {
                        var bodies = composite.bodies;
                        var constraints = composite.constraints;
                        var composites = composite.composites;
                        var i;
                        var obj;
                        var render;
                        for(i = 0; i < bodies.length; i++){
                            obj = bodies[i];
                            render = obj.render;
                            this.setBodyRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.fillColor, render.fillOpacity);
                        }
                        for(i = 0; i < constraints.length; i++){
                            obj = constraints[i];
                            render = obj.render;
                            this.setConstraintRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.pinSize, render.anchorColor, render.anchorSize);
                        }
                        for(i = 0; i < composites.length; i++){
                            obj = composites[i];
                            this.setCompositeRenderStyle(obj);
                        }
                        return this;
                    },
                    /**
     * Sets the debug render style for the given Matter Body.
     *
     * If you are using this on a Phaser Game Object, such as a Matter Sprite, then pass in the body property
     * to this method, not the Game Object itself.
     *
     * If you wish to skip a parameter, so it retains its current value, pass `false` for it.
     *
     * If you wish to reset the Body render colors to the defaults found in the World Debug Config, then call
     * this method with just the `body` parameter provided and no others.
     *
     * @method Phaser.Physics.Matter.World#setBodyRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.BodyType} body - The Matter Body to set the render style on.
     * @param {number} [lineColor] - The line color. If `null` it will use the World Debug Config value.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * @param {number} [lineThickness] - The line thickness. If `null` it will use the World Debug Config value.
     * @param {number} [fillColor] - The fill color. If `null` it will use the World Debug Config value.
     * @param {number} [fillOpacity] - The fill opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     *
     * @return {this} This Matter World instance for method chaining.
     */ setBodyRenderStyle: function(body, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity) {
                        var render = body.render;
                        var config = this.debugConfig;
                        if (!render) return this;
                        if (lineColor === undefined || lineColor === null) lineColor = body.isStatic ? config.staticLineColor : config.lineColor;
                        if (lineOpacity === undefined || lineOpacity === null) lineOpacity = config.lineOpacity;
                        if (lineThickness === undefined || lineThickness === null) lineThickness = config.lineThickness;
                        if (fillColor === undefined || fillColor === null) fillColor = body.isStatic ? config.staticFillColor : config.fillColor;
                        if (fillOpacity === undefined || fillOpacity === null) fillOpacity = config.fillOpacity;
                        if (lineColor !== false) render.lineColor = lineColor;
                        if (lineOpacity !== false) render.lineOpacity = lineOpacity;
                        if (lineThickness !== false) render.lineThickness = lineThickness;
                        if (fillColor !== false) render.fillColor = fillColor;
                        if (fillOpacity !== false) render.fillOpacity = fillOpacity;
                        return this;
                    },
                    /**
     * Sets the debug render style for the given Matter Constraint.
     *
     * If you are using this on a Phaser Game Object, then pass in the body property
     * to this method, not the Game Object itself.
     *
     * If you wish to skip a parameter, so it retains its current value, pass `false` for it.
     *
     * If you wish to reset the Constraint render colors to the defaults found in the World Debug Config, then call
     * this method with just the `constraint` parameter provided and no others.
     *
     * @method Phaser.Physics.Matter.World#setConstraintRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.ConstraintType} constraint - The Matter Constraint to set the render style on.
     * @param {number} [lineColor] - The line color. If `null` it will use the World Debug Config value.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * @param {number} [lineThickness] - The line thickness. If `null` it will use the World Debug Config value.
     * @param {number} [pinSize] - If this constraint is a pin, this sets the size of the pin circle. If `null` it will use the World Debug Config value.
     * @param {number} [anchorColor] - The color used when rendering this constraints anchors.  If `null` it will use the World Debug Config value.
     * @param {number} [anchorSize] - The size of the anchor circle, if this constraint has anchors. If `null` it will use the World Debug Config value.
     *
     * @return {this} This Matter World instance for method chaining.
     */ setConstraintRenderStyle: function(constraint, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize) {
                        var render = constraint.render;
                        var config = this.debugConfig;
                        if (!render) return this;
                        //  Reset them
                        if (lineColor === undefined || lineColor === null) {
                            var type = render.type;
                            if (type === 'line') lineColor = config.jointColor;
                            else if (type === 'pin') lineColor = config.pinColor;
                            else if (type === 'spring') lineColor = config.springColor;
                        }
                        if (lineOpacity === undefined || lineOpacity === null) lineOpacity = config.jointLineOpacity;
                        if (lineThickness === undefined || lineThickness === null) lineThickness = config.jointLineThickness;
                        if (pinSize === undefined || pinSize === null) pinSize = config.pinSize;
                        if (anchorColor === undefined || anchorColor === null) anchorColor = config.anchorColor;
                        if (anchorSize === undefined || anchorSize === null) anchorSize = config.anchorSize;
                        if (lineColor !== false) render.lineColor = lineColor;
                        if (lineOpacity !== false) render.lineOpacity = lineOpacity;
                        if (lineThickness !== false) render.lineThickness = lineThickness;
                        if (pinSize !== false) render.pinSize = pinSize;
                        if (anchorColor !== false) render.anchorColor = anchorColor;
                        if (anchorSize !== false) render.anchorSize = anchorSize;
                        return this;
                    },
                    /**
     * This internal method acts as a proxy between all of the Matter JS events and then re-emits them
     * via this class.
     *
     * @method Phaser.Physics.Matter.World#setEventsProxy
     * @since 3.0.0
     */ setEventsProxy: function() {
                        var _this = this;
                        var engine = this.engine;
                        var world = this.localWorld;
                        //  Inject debug styles
                        if (this.drawDebug) {
                            MatterEvents.on(world, 'compositeModified', function(composite) {
                                _this.setCompositeRenderStyle(composite);
                            });
                            MatterEvents.on(world, 'beforeAdd', function(event) {
                                var objects = [].concat(event.object);
                                for(var i = 0; i < objects.length; i++){
                                    var obj = objects[i];
                                    var render = obj.render;
                                    if (obj.type === 'body') _this.setBodyRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.fillColor, render.fillOpacity);
                                    else if (obj.type === 'composite') _this.setCompositeRenderStyle(obj);
                                    else if (obj.type === 'constraint') _this.setConstraintRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.pinSize, render.anchorColor, render.anchorSize);
                                }
                            });
                        }
                        MatterEvents.on(world, 'beforeAdd', function(event) {
                            _this.emit(Events.BEFORE_ADD, event);
                        });
                        MatterEvents.on(world, 'afterAdd', function(event) {
                            _this.emit(Events.AFTER_ADD, event);
                        });
                        MatterEvents.on(world, 'beforeRemove', function(event) {
                            _this.emit(Events.BEFORE_REMOVE, event);
                        });
                        MatterEvents.on(world, 'afterRemove', function(event) {
                            _this.emit(Events.AFTER_REMOVE, event);
                        });
                        MatterEvents.on(engine, 'beforeUpdate', function(event) {
                            _this.emit(Events.BEFORE_UPDATE, event);
                        });
                        MatterEvents.on(engine, 'afterUpdate', function(event) {
                            _this.emit(Events.AFTER_UPDATE, event);
                        });
                        MatterEvents.on(engine, 'collisionStart', function(event) {
                            var pairs = event.pairs;
                            var bodyA;
                            var bodyB;
                            if (pairs.length > 0) pairs.map(function(pair) {
                                bodyA = pair.bodyA;
                                bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit('collide', bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit('collide', bodyB, bodyA, pair);
                                MatterEvents.trigger(bodyA, 'onCollide', {
                                    pair: pair
                                });
                                MatterEvents.trigger(bodyB, 'onCollide', {
                                    pair: pair
                                });
                                if (bodyA.onCollideCallback) bodyA.onCollideCallback(pair);
                                if (bodyB.onCollideCallback) bodyB.onCollideCallback(pair);
                                if (bodyA.onCollideWith[bodyB.id]) bodyA.onCollideWith[bodyB.id](bodyB, pair);
                                if (bodyB.onCollideWith[bodyA.id]) bodyB.onCollideWith[bodyA.id](bodyA, pair);
                            });
                            _this.emit(Events.COLLISION_START, event, bodyA, bodyB);
                        });
                        MatterEvents.on(engine, 'collisionActive', function(event) {
                            var pairs = event.pairs;
                            var bodyA;
                            var bodyB;
                            if (pairs.length > 0) pairs.map(function(pair) {
                                bodyA = pair.bodyA;
                                bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit('collideActive', bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit('collideActive', bodyB, bodyA, pair);
                                MatterEvents.trigger(bodyA, 'onCollideActive', {
                                    pair: pair
                                });
                                MatterEvents.trigger(bodyB, 'onCollideActive', {
                                    pair: pair
                                });
                                if (bodyA.onCollideActiveCallback) bodyA.onCollideActiveCallback(pair);
                                if (bodyB.onCollideActiveCallback) bodyB.onCollideActiveCallback(pair);
                            });
                            _this.emit(Events.COLLISION_ACTIVE, event, bodyA, bodyB);
                        });
                        MatterEvents.on(engine, 'collisionEnd', function(event) {
                            var pairs = event.pairs;
                            var bodyA;
                            var bodyB;
                            if (pairs.length > 0) pairs.map(function(pair) {
                                bodyA = pair.bodyA;
                                bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit('collideEnd', bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit('collideEnd', bodyB, bodyA, pair);
                                MatterEvents.trigger(bodyA, 'onCollideEnd', {
                                    pair: pair
                                });
                                MatterEvents.trigger(bodyB, 'onCollideEnd', {
                                    pair: pair
                                });
                                if (bodyA.onCollideEndCallback) bodyA.onCollideEndCallback(pair);
                                if (bodyB.onCollideEndCallback) bodyB.onCollideEndCallback(pair);
                            });
                            _this.emit(Events.COLLISION_END, event, bodyA, bodyB);
                        });
                    },
                    /**
     * Sets the bounds of the Physics world to match the given world pixel dimensions.
     *
     * You can optionally set which 'walls' to create: left, right, top or bottom.
     * If none of the walls are given it will default to use the walls settings it had previously.
     * I.e. if you previously told it to not have the left or right walls, and you then adjust the world size
     * the newly created bounds will also not have the left and right walls.
     * Explicitly state them in the parameters to override this.
     *
     * @method Phaser.Physics.Matter.World#setBounds
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left corner of the bounds.
     * @param {number} [y=0] - The y coordinate of the top-left corner of the bounds.
     * @param {number} [width] - The width of the bounds.
     * @param {number} [height] - The height of the bounds.
     * @param {number} [thickness=64] - The thickness of each wall, in pixels.
     * @param {boolean} [left=true] - If true will create the left bounds wall.
     * @param {boolean} [right=true] - If true will create the right bounds wall.
     * @param {boolean} [top=true] - If true will create the top bounds wall.
     * @param {boolean} [bottom=true] - If true will create the bottom bounds wall.
     *
     * @return {Phaser.Physics.Matter.World} This Matter World object.
     */ setBounds: function(x, y, width, height, thickness, left, right, top, bottom) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.scene.sys.scale.width;
                        if (height === undefined) height = this.scene.sys.scale.height;
                        if (thickness === undefined) thickness = 64;
                        if (left === undefined) left = true;
                        if (right === undefined) right = true;
                        if (top === undefined) top = true;
                        if (bottom === undefined) bottom = true;
                        this.updateWall(left, 'left', x - thickness, y - thickness, thickness, height + thickness * 2);
                        this.updateWall(right, 'right', x + width, y - thickness, thickness, height + thickness * 2);
                        this.updateWall(top, 'top', x, y - thickness, width, thickness);
                        this.updateWall(bottom, 'bottom', x, y + height, width, thickness);
                        return this;
                    },
                    /**
     * Updates the 4 rectangle bodies that were created, if `setBounds` was set in the Matter config, to use
     * the new positions and sizes. This method is usually only called internally via the `setBounds` method.
     *
     * @method Phaser.Physics.Matter.World#updateWall
     * @since 3.0.0
     *
     * @param {boolean} add - `true` if the walls are being added or updated, `false` to remove them from the world.
     * @param {string} [position] - Either `left`, `right`, `top` or `bottom`. Only optional if `add` is `false`.
     * @param {number} [x] - The horizontal position to place the walls at. Only optional if `add` is `false`.
     * @param {number} [y] - The vertical position to place the walls at. Only optional if `add` is `false`.
     * @param {number} [width] - The width of the walls, in pixels. Only optional if `add` is `false`.
     * @param {number} [height] - The height of the walls, in pixels. Only optional if `add` is `false`.
     */ updateWall: function(add, position, x, y, width, height) {
                        var wall = this.walls[position];
                        if (add) {
                            if (wall) MatterWorld.remove(this.localWorld, wall);
                            //  adjust center
                            x += width / 2;
                            y += height / 2;
                            this.walls[position] = this.create(x, y, width, height, {
                                isStatic: true,
                                friction: 0,
                                frictionStatic: 0
                            });
                        } else {
                            if (wall) MatterWorld.remove(this.localWorld, wall);
                            this.walls[position] = null;
                        }
                    },
                    /**
     * Creates a Phaser.GameObjects.Graphics object that is used to render all of the debug bodies and joints to.
     *
     * This method is called automatically by the constructor, if debugging has been enabled.
     *
     * The created Graphics object is automatically added to the Scene at 0x0 and given a depth of `Number.MAX_VALUE`,
     * so it renders above all else in the Scene.
     *
     * The Graphics object is assigned to the `debugGraphic` property of this class and `drawDebug` is enabled.
     *
     * @method Phaser.Physics.Matter.World#createDebugGraphic
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Graphics} The newly created Graphics object.
     */ createDebugGraphic: function() {
                        var graphic = this.scene.sys.add.graphics({
                            x: 0,
                            y: 0
                        });
                        graphic.setDepth(Number.MAX_VALUE);
                        this.debugGraphic = graphic;
                        this.drawDebug = true;
                        return graphic;
                    },
                    /**
     * Sets the world gravity and gravity scale to 0.
     *
     * @method Phaser.Physics.Matter.World#disableGravity
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ disableGravity: function() {
                        this.localWorld.gravity.x = 0;
                        this.localWorld.gravity.y = 0;
                        this.localWorld.gravity.scale = 0;
                        return this;
                    },
                    /**
     * Sets the worlds gravity to the values given.
     *
     * Gravity effects all bodies in the world, unless they have the `ignoreGravity` flag set.
     *
     * @method Phaser.Physics.Matter.World#setGravity
     * @since 3.0.0
     *
     * @param {number} [x=0] - The world gravity x component.
     * @param {number} [y=1] - The world gravity y component.
     * @param {number} [scale=0.001] - The gravity scale factor.
     *
     * @return {this} This Matter World object.
     */ setGravity: function(x, y, scale) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 1;
                        if (scale === undefined) scale = 0.001;
                        this.localWorld.gravity.x = x;
                        this.localWorld.gravity.y = y;
                        this.localWorld.gravity.scale = scale;
                        return this;
                    },
                    /**
     * Creates a rectangle Matter body and adds it to the world.
     *
     * @method Phaser.Physics.Matter.World#create
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the body in the world.
     * @param {number} y - The vertical position of the body in the world.
     * @param {number} width - The width of the body.
     * @param {number} height - The height of the body.
     * @param {object} options - Optional Matter configuration object.
     *
     * @return {MatterJS.BodyType} The Matter.js body that was created.
     */ create: function(x, y, width, height, options) {
                        var body = Bodies.rectangle(x, y, width, height, options);
                        MatterWorld.add(this.localWorld, body);
                        return body;
                    },
                    /**
     * Adds a Matter JS object, or array of objects, to the world.
     *
     * The objects should be valid Matter JS entities, such as a Body, Composite or Constraint.
     *
     * Triggers `beforeAdd` and `afterAdd` events.
     *
     * @method Phaser.Physics.Matter.World#add
     * @since 3.0.0
     *
     * @param {(object|object[])} object - Can be single object, or an array, and can be a body, composite or constraint.
     *
     * @return {this} This Matter World object.
     */ add: function(object) {
                        MatterWorld.add(this.localWorld, object);
                        return this;
                    },
                    /**
     * Removes a Matter JS object, or array of objects, from the world.
     *
     * The objects should be valid Matter JS entities, such as a Body, Composite or Constraint.
     *
     * Triggers `beforeRemove` and `afterRemove` events.
     *
     * @method Phaser.Physics.Matter.World#remove
     * @since 3.0.0
     *
     * @param {(object|object[])} object - Can be single object, or an array, and can be a body, composite or constraint.
     * @param {boolean} [deep=false] - Optionally search the objects children and recursively remove those as well.
     *
     * @return {this} This Matter World object.
     */ remove: function(object, deep) {
                        if (!Array.isArray(object)) object = [
                            object
                        ];
                        for(var i = 0; i < object.length; i++){
                            var entity = object[i];
                            var body = entity.body ? entity.body : entity;
                            Composite.remove(this.localWorld, body, deep);
                        }
                        return this;
                    },
                    /**
     * Removes a Matter JS constraint, or array of constraints, from the world.
     *
     * Triggers `beforeRemove` and `afterRemove` events.
     *
     * @method Phaser.Physics.Matter.World#removeConstraint
     * @since 3.0.0
     *
     * @param {(MatterJS.ConstraintType|MatterJS.ConstraintType[])} constraint - A Matter JS Constraint, or an array of constraints, to be removed.
     * @param {boolean} [deep=false] - Optionally search the objects children and recursively remove those as well.
     *
     * @return {this} This Matter World object.
     */ removeConstraint: function(constraint, deep) {
                        Composite.remove(this.localWorld, constraint, deep);
                        return this;
                    },
                    /**
     * Adds `MatterTileBody` instances for all the colliding tiles within the given tilemap layer.
     *
     * Set the appropriate tiles in your layer to collide before calling this method!
     *
     * If you modify the map after calling this method, i.e. via a function like `putTileAt` then
     * you should call the `Phaser.Physics.Matter.World.convertTiles` function directly, passing
     * it an array of the tiles you've added to your map.
     *
     * @method Phaser.Physics.Matter.World#convertTilemapLayer
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - An array of tiles.
     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@see Phaser.Physics.Matter.TileBody}
     *
     * @return {this} This Matter World object.
     */ convertTilemapLayer: function(tilemapLayer, options) {
                        var layerData = tilemapLayer.layer;
                        var tiles = tilemapLayer.getTilesWithin(0, 0, layerData.width, layerData.height, {
                            isColliding: true
                        });
                        this.convertTiles(tiles, options);
                        return this;
                    },
                    /**
     * Creates `MatterTileBody` instances for all of the given tiles. This creates bodies regardless of whether the
     * tiles are set to collide or not, or if they have a body already, or not.
     *
     * If you wish to pass an array of tiles that may already have bodies, you should filter the array before hand.
     *
     * @method Phaser.Physics.Matter.World#convertTiles
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of tiles.
     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@see Phaser.Physics.Matter.TileBody}
     *
     * @return {this} This Matter World object.
     */ convertTiles: function(tiles, options) {
                        if (tiles.length === 0) return this;
                        for(var i = 0; i < tiles.length; i++)new MatterTileBody(this, tiles[i], options);
                        return this;
                    },
                    /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will not collide.
     *
     * @method Phaser.Physics.Matter.World#nextGroup
     * @since 3.0.0
     *
     * @param {boolean} [isNonColliding=false] - If `true`, returns the next unique group index for which bodies will _not_ collide.
     *
     * @return {number} Unique category bitfield
     */ nextGroup: function(isNonColliding) {
                        return MatterBody.nextGroup(isNonColliding);
                    },
                    /**
     * Returns the next unique category bitfield (starting after the initial default category 0x0001).
     * There are 32 available.
     *
     * @method Phaser.Physics.Matter.World#nextCategory
     * @since 3.0.0
     *
     * @return {number} Unique category bitfield
     */ nextCategory: function() {
                        return MatterBody.nextCategory();
                    },
                    /**
     * Pauses this Matter World instance and sets `enabled` to `false`.
     *
     * A paused world will not run any simulations for the duration it is paused.
     *
     * @method Phaser.Physics.Matter.World#pause
     * @fires Phaser.Physics.Matter.Events#PAUSE
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ pause: function() {
                        this.enabled = false;
                        this.emit(Events.PAUSE);
                        return this;
                    },
                    /**
     * Resumes this Matter World instance from a paused state and sets `enabled` to `true`.
     *
     * @method Phaser.Physics.Matter.World#resume
     * @fires Phaser.Physics.Matter.Events#RESUME
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ resume: function() {
                        this.enabled = true;
                        this.runner.timeLastTick = Common.now();
                        this.emit(Events.RESUME);
                        return this;
                    },
                    /**
     * The internal update method. This is called automatically by the parent Scene.
     *
     * Moves the simulation forward in time by delta ms. Uses `World.correction` value as an optional number that
     * specifies the time correction factor to apply to the update. This can help improve the accuracy of the
     * simulation in cases where delta is changing between updates. The value of correction is defined as `delta / lastDelta`,
     * i.e. the percentage change of delta over the last step. Therefore the value is always 1 (no correction) when
     * delta is constant (or when no correction is desired, which is the default).
     * See the paper on Time Corrected Verlet for more information.
     *
     * Triggers `beforeUpdate` and `afterUpdate` events. Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     *
     * If the World is paused, `update` is still run, but exits early and does not update the Matter Engine.
     *
     * @method Phaser.Physics.Matter.World#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(time) {
                        if (!this.enabled || !this.autoUpdate) return;
                        var engine = this.engine;
                        var runner = this.runner;
                        var tickStartTime = Common.now(), engineDelta = runner.delta, updateCount = 0;
                        // find frame delta time since last call
                        var frameDelta = time - runner.timeLastTick;
                        // fallback for unusable frame delta values (e.g. 0, NaN, on first frame or long pauses)
                        if (!frameDelta || !runner.timeLastTick || frameDelta > Math.max(MatterRunner._maxFrameDelta, runner.maxFrameTime)) // reuse last accepted frame delta else fallback
                        frameDelta = runner.frameDelta || MatterRunner._frameDeltaFallback;
                        if (runner.frameDeltaSmoothing) {
                            // record frame delta over a number of frames
                            runner.frameDeltaHistory.push(frameDelta);
                            runner.frameDeltaHistory = runner.frameDeltaHistory.slice(-runner.frameDeltaHistorySize);
                            // sort frame delta history
                            var deltaHistorySorted = runner.frameDeltaHistory.slice(0).sort();
                            // sample a central window to limit outliers
                            var deltaHistoryWindow = runner.frameDeltaHistory.slice(deltaHistorySorted.length * MatterRunner._smoothingLowerBound, deltaHistorySorted.length * MatterRunner._smoothingUpperBound);
                            // take the mean of the central window
                            var frameDeltaSmoothed = MatterRunner._mean(deltaHistoryWindow);
                            frameDelta = frameDeltaSmoothed || frameDelta;
                        }
                        if (runner.frameDeltaSnapping) // snap frame delta to the nearest 1 Hz
                        frameDelta = 1000 / Math.round(1000 / frameDelta);
                        // update runner values for next call
                        runner.frameDelta = frameDelta;
                        runner.timeLastTick = time;
                        // accumulate elapsed time
                        runner.timeBuffer += runner.frameDelta;
                        // limit time buffer size to a single frame of updates
                        runner.timeBuffer = Common.clamp(runner.timeBuffer, 0, runner.frameDelta + engineDelta * MatterRunner._timeBufferMargin);
                        // reset count of over budget updates
                        runner.lastUpdatesDeferred = 0;
                        // get max updates per frame
                        var maxUpdates = runner.maxUpdates || Math.ceil(runner.maxFrameTime / engineDelta);
                        var updateStartTime = Common.now();
                        // simulate time elapsed between calls
                        while(engineDelta > 0 && runner.timeBuffer >= engineDelta * MatterRunner._timeBufferMargin){
                            // update the engine
                            Engine.update(engine, engineDelta);
                            // consume time simulated from buffer
                            runner.timeBuffer -= engineDelta;
                            updateCount += 1;
                            // find elapsed time during this tick
                            var elapsedTimeTotal = Common.now() - tickStartTime, elapsedTimeUpdates = Common.now() - updateStartTime, elapsedNextEstimate = elapsedTimeTotal + MatterRunner._elapsedNextEstimate * elapsedTimeUpdates / updateCount;
                            // defer updates if over performance budgets for this frame
                            if (updateCount >= maxUpdates || elapsedNextEstimate > runner.maxFrameTime) {
                                runner.lastUpdatesDeferred = Math.round(Math.max(0, runner.timeBuffer / engineDelta - MatterRunner._timeBufferMargin));
                                break;
                            }
                        }
                    },
                    /**
     * Manually advances the physics simulation by one iteration.
     *
     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
     * If undefined they use the Matter defaults of 60Hz and no correction.
     *
     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
     *
     * It also ignores any custom `getDelta` functions, as you should be passing the delta
     * value in to this call.
     *
     * You can adjust the number of iterations that Engine.update performs internally.
     * Use the Scene Matter Physics config object to set the following properties:
     *
     * positionIterations (defaults to 6)
     * velocityIterations (defaults to 4)
     * constraintIterations (defaults to 2)
     *
     * Adjusting these values can help performance in certain situations, depending on the physics requirements
     * of your game.
     *
     * @method Phaser.Physics.Matter.World#step
     * @since 3.4.0
     *
     * @param {number} [delta=16.666] - The delta value.
     */ step: function(delta) {
                        Engine.update(this.engine, delta);
                    },
                    /**
     * Runs the Matter Engine.update at a fixed timestep of 60Hz.
     *
     * @method Phaser.Physics.Matter.World#update60Hz
     * @since 3.4.0
     *
     * @return {number} The delta value to be passed to Engine.update.
     */ update60Hz: function() {
                        return 1000 / 60;
                    },
                    /**
     * Runs the Matter Engine.update at a fixed timestep of 30Hz.
     *
     * @method Phaser.Physics.Matter.World#update30Hz
     * @since 3.4.0
     *
     * @return {number} The delta value to be passed to Engine.update.
     */ update30Hz: function() {
                        return 1000 / 30;
                    },
                    /**
     * Returns `true` if the given body can be found within the World.
     *
     * @method Phaser.Physics.Matter.World#has
     * @since 3.22.0
     *
     * @param {(MatterJS.Body|Phaser.GameObjects.GameObject)} body - The Matter Body, or Game Object, to search for within the world.
     *
     * @return {MatterJS.BodyType[]} An array of all the Matter JS Bodies in this World.
     */ has: function(body) {
                        var src = body.hasOwnProperty('body') ? body.body : body;
                        return Composite.get(this.localWorld, src.id, src.type) !== null;
                    },
                    /**
     * Returns all the bodies in the Matter World, including all bodies in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllBodies
     * @since 3.22.0
     *
     * @return {MatterJS.BodyType[]} An array of all the Matter JS Bodies in this World.
     */ getAllBodies: function() {
                        return Composite.allBodies(this.localWorld);
                    },
                    /**
     * Returns all the constraints in the Matter World, including all constraints in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllConstraints
     * @since 3.22.0
     *
     * @return {MatterJS.ConstraintType[]} An array of all the Matter JS Constraints in this World.
     */ getAllConstraints: function() {
                        return Composite.allConstraints(this.localWorld);
                    },
                    /**
     * Returns all the composites in the Matter World, including all composites in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllComposites
     * @since 3.22.0
     *
     * @return {MatterJS.CompositeType[]} An array of all the Matter JS Composites in this World.
     */ getAllComposites: function() {
                        return Composite.allComposites(this.localWorld);
                    },
                    /**
     * Handles the rendering of bodies and debug information to the debug Graphics object, if enabled.
     *
     * This method is called automatically by the Scene after all processing has taken place.
     *
     * @method Phaser.Physics.Matter.World#postUpdate
     * @private
     * @since 3.0.0
     */ postUpdate: function() {
                        if (!this.drawDebug) return;
                        var config = this.debugConfig;
                        var engine = this.engine;
                        var graphics = this.debugGraphic;
                        var bodies = Composite.allBodies(this.localWorld);
                        this.debugGraphic.clear();
                        if (config.showBroadphase && engine.broadphase.controller) this.renderGrid(engine.broadphase, graphics, config.broadphaseColor, 0.5);
                        if (config.showBounds) this.renderBodyBounds(bodies, graphics, config.boundsColor, 0.5);
                        if (config.showBody || config.showStaticBody) this.renderBodies(bodies);
                        if (config.showJoint) this.renderJoints();
                        if (config.showAxes || config.showAngleIndicator) this.renderBodyAxes(bodies, graphics, config.showAxes, config.angleColor, 0.5);
                        if (config.showVelocity) this.renderBodyVelocity(bodies, graphics, config.velocityColor, 1, 2);
                        if (config.showSeparations) this.renderSeparations(engine.pairs.list, graphics, config.separationColor);
                        if (config.showCollisions) this.renderCollisions(engine.pairs.list, graphics, config.collisionColor);
                    },
                    /**
     * Renders the Engine Broadphase Controller Grid to the given Graphics instance.
     *
     * The debug renderer calls this method if the `showBroadphase` config value is set.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderGrid
     * @since 3.22.0
     *
     * @param {MatterJS.Grid} grid - The Matter Grid to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     *
     * @return {this} This Matter World instance for method chaining.
     */ renderGrid: function(grid, graphics, lineColor, lineOpacity) {
                        graphics.lineStyle(1, lineColor, lineOpacity);
                        var bucketKeys = Common.keys(grid.buckets);
                        for(var i = 0; i < bucketKeys.length; i++){
                            var bucketId = bucketKeys[i];
                            if (grid.buckets[bucketId].length < 2) continue;
                            var region = bucketId.split(/C|R/);
                            graphics.strokeRect(parseInt(region[1], 10) * grid.bucketWidth, parseInt(region[2], 10) * grid.bucketHeight, grid.bucketWidth, grid.bucketHeight);
                        }
                        return this;
                    },
                    /**
     * Renders the list of Pair separations to the given Graphics instance.
     *
     * The debug renderer calls this method if the `showSeparations` config value is set.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderSeparations
     * @since 3.22.0
     *
     * @param {MatterJS.Pair[]} pairs - An array of Matter Pairs to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     *
     * @return {this} This Matter World instance for method chaining.
     */ renderSeparations: function(pairs, graphics, lineColor) {
                        graphics.lineStyle(1, lineColor, 1);
                        for(var i = 0; i < pairs.length; i++){
                            var pair = pairs[i];
                            if (!pair.isActive) continue;
                            var collision = pair.collision;
                            var bodyA = collision.bodyA;
                            var bodyB = collision.bodyB;
                            var posA = bodyA.position;
                            var posB = bodyB.position;
                            var penetration = collision.penetration;
                            var k = !bodyA.isStatic && !bodyB.isStatic ? 4 : 1;
                            if (bodyB.isStatic) k = 0;
                            graphics.lineBetween(posB.x, posB.y, posB.x - penetration.x * k, posB.y - penetration.y * k);
                            k = !bodyA.isStatic && !bodyB.isStatic ? 4 : 1;
                            if (bodyA.isStatic) k = 0;
                            graphics.lineBetween(posA.x, posA.y, posA.x - penetration.x * k, posA.y - penetration.y * k);
                        }
                        return this;
                    },
                    /**
     * Renders the list of collision points and normals to the given Graphics instance.
     *
     * The debug renderer calls this method if the `showCollisions` config value is set.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderCollisions
     * @since 3.22.0
     *
     * @param {MatterJS.Pair[]} pairs - An array of Matter Pairs to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     *
     * @return {this} This Matter World instance for method chaining.
     */ renderCollisions: function(pairs, graphics, lineColor) {
                        graphics.lineStyle(1, lineColor, 0.5);
                        graphics.fillStyle(lineColor, 1);
                        var i;
                        var pair;
                        //  Collision Positions
                        for(i = 0; i < pairs.length; i++){
                            pair = pairs[i];
                            if (!pair.isActive) continue;
                            for(var j = 0; j < pair.contactCount; j++){
                                var contact = pair.contacts[j];
                                var vertex = contact.vertex;
                                if (vertex) graphics.fillRect(vertex.x - 2, vertex.y - 2, 5, 5);
                            }
                        }
                        //  Collision Normals
                        for(i = 0; i < pairs.length; i++){
                            pair = pairs[i];
                            if (!pair.isActive) continue;
                            var collision = pair.collision;
                            var contacts = pair.contacts;
                            if (pair.contactCount > 0) {
                                var normalPosX = contacts[0].vertex.x;
                                var normalPosY = contacts[0].vertex.y;
                                if (pair.contactCount === 2) {
                                    normalPosX = (contacts[0].vertex.x + contacts[1].vertex.x) / 2;
                                    normalPosY = (contacts[0].vertex.y + contacts[1].vertex.y) / 2;
                                }
                                if (collision.bodyB === collision.supports[0].body || collision.bodyA.isStatic) graphics.lineBetween(normalPosX - collision.normal.x * 8, normalPosY - collision.normal.y * 8, normalPosX, normalPosY);
                                else graphics.lineBetween(normalPosX + collision.normal.x * 8, normalPosY + collision.normal.y * 8, normalPosX, normalPosY);
                            }
                        }
                        return this;
                    },
                    /**
     * Renders the bounds of an array of Bodies to the given Graphics instance.
     *
     * If the body is a compound body, it will render the bounds for the parent compound.
     *
     * The debug renderer calls this method if the `showBounds` config value is set.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyBounds
     * @since 3.22.0
     *
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     */ renderBodyBounds: function(bodies, graphics, lineColor, lineOpacity) {
                        graphics.lineStyle(1, lineColor, lineOpacity);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            //  1) Don't show invisible bodies
                            if (!body.render.visible) continue;
                            var bounds = body.bounds;
                            if (bounds) graphics.strokeRect(bounds.min.x, bounds.min.y, bounds.max.x - bounds.min.x, bounds.max.y - bounds.min.y);
                            else {
                                var parts = body.parts;
                                for(var j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                                    var part = parts[j];
                                    graphics.strokeRect(part.bounds.min.x, part.bounds.min.y, part.bounds.max.x - part.bounds.min.x, part.bounds.max.y - part.bounds.min.y);
                                }
                            }
                        }
                        return this;
                    },
                    /**
     * Renders either all axes, or a single axis indicator, for an array of Bodies, to the given Graphics instance.
     *
     * The debug renderer calls this method if the `showAxes` or `showAngleIndicator` config values are set.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyAxes
     * @since 3.22.0
     *
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {boolean} showAxes - If `true` it will render all body axes. If `false` it will render a single axis indicator.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     */ renderBodyAxes: function(bodies, graphics, showAxes, lineColor, lineOpacity) {
                        graphics.lineStyle(1, lineColor, lineOpacity);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            var parts = body.parts;
                            //  1) Don't show invisible bodies
                            if (!body.render.visible) continue;
                            var part;
                            var j;
                            var k;
                            if (showAxes) for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                                part = parts[j];
                                for(k = 0; k < part.axes.length; k++){
                                    var axis = part.axes[k];
                                    graphics.lineBetween(part.position.x, part.position.y, part.position.x + axis.x * 20, part.position.y + axis.y * 20);
                                }
                            }
                            else for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                                part = parts[j];
                                for(k = 0; k < part.axes.length; k++)graphics.lineBetween(part.position.x, part.position.y, (part.vertices[0].x + part.vertices[part.vertices.length - 1].x) / 2, (part.vertices[0].y + part.vertices[part.vertices.length - 1].y) / 2);
                            }
                        }
                        return this;
                    },
                    /**
     * Renders a velocity indicator for an array of Bodies, to the given Graphics instance.
     *
     * The debug renderer calls this method if the `showVelocity` config value is set.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyVelocity
     * @since 3.22.0
     *
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * @param {number} lineThickness - The line thickness.
     */ renderBodyVelocity: function(bodies, graphics, lineColor, lineOpacity, lineThickness) {
                        graphics.lineStyle(lineThickness, lineColor, lineOpacity);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            //  1) Don't show invisible bodies
                            if (!body.render.visible) continue;
                            graphics.lineBetween(body.position.x, body.position.y, body.position.x + (body.position.x - body.positionPrev.x) * 2, body.position.y + (body.position.y - body.positionPrev.y) * 2);
                        }
                        return this;
                    },
                    /**
     * Renders the given array of Bodies to the debug graphics instance.
     *
     * Called automatically by the `postUpdate` method.
     *
     * @method Phaser.Physics.Matter.World#renderBodies
     * @private
     * @since 3.14.0
     *
     * @param {array} bodies - An array of bodies from the localWorld.
     */ renderBodies: function(bodies) {
                        var graphics = this.debugGraphic;
                        var config = this.debugConfig;
                        var showBody = config.showBody;
                        var showStaticBody = config.showStaticBody;
                        var showSleeping = config.showSleeping;
                        var showInternalEdges = config.showInternalEdges;
                        var showConvexHulls = config.showConvexHulls;
                        var renderFill = config.renderFill;
                        var renderLine = config.renderLine;
                        var staticBodySleepOpacity = config.staticBodySleepOpacity;
                        var sleepFillColor = config.sleepFillColor;
                        var sleepLineColor = config.sleepLineColor;
                        var hullColor = config.hullColor;
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            //  1) Don't show invisible bodies
                            if (!body.render.visible) continue;
                            //  2) Don't show static bodies, OR
                            //  3) Don't show dynamic bodies
                            if (!showStaticBody && body.isStatic || !showBody && !body.isStatic) continue;
                            var lineColor = body.render.lineColor;
                            var lineOpacity = body.render.lineOpacity;
                            var lineThickness = body.render.lineThickness;
                            var fillColor = body.render.fillColor;
                            var fillOpacity = body.render.fillOpacity;
                            if (showSleeping && body.isSleeping) {
                                if (body.isStatic) {
                                    lineOpacity *= staticBodySleepOpacity;
                                    fillOpacity *= staticBodySleepOpacity;
                                } else {
                                    lineColor = sleepLineColor;
                                    fillColor = sleepFillColor;
                                }
                            }
                            if (!renderFill) fillColor = null;
                            if (!renderLine) lineColor = null;
                            this.renderBody(body, graphics, showInternalEdges, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity);
                            var partsLength = body.parts.length;
                            if (showConvexHulls && partsLength > 1) this.renderConvexHull(body, graphics, hullColor, lineThickness);
                        }
                    },
                    /**
     * Renders a single Matter Body to the given Phaser Graphics Game Object.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Body to your own Graphics instance.
     *
     * If you don't wish to render a line around the body, set the `lineColor` parameter to `null`.
     * Equally, if you don't wish to render a fill, set the `fillColor` parameter to `null`.
     *
     * @method Phaser.Physics.Matter.World#renderBody
     * @since 3.22.0
     *
     * @param {MatterJS.BodyType} body - The Matter Body to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {boolean} showInternalEdges - Render internal edges of the polygon?
     * @param {number} [lineColor] - The line color.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1.
     * @param {number} [lineThickness=1] - The line thickness.
     * @param {number} [fillColor] - The fill color.
     * @param {number} [fillOpacity] - The fill opacity, between 0 and 1.
     *
     * @return {this} This Matter World instance for method chaining.
     */ renderBody: function(body, graphics, showInternalEdges, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity) {
                        if (lineColor === undefined) lineColor = null;
                        if (lineOpacity === undefined) lineOpacity = null;
                        if (lineThickness === undefined) lineThickness = 1;
                        if (fillColor === undefined) fillColor = null;
                        if (fillOpacity === undefined) fillOpacity = null;
                        var config = this.debugConfig;
                        var sensorFillColor = config.sensorFillColor;
                        var sensorLineColor = config.sensorLineColor;
                        //  Handle compound parts
                        var parts = body.parts;
                        var partsLength = parts.length;
                        for(var k = partsLength > 1 ? 1 : 0; k < partsLength; k++){
                            var part = parts[k];
                            var render = part.render;
                            var opacity = render.opacity;
                            if (!render.visible || opacity === 0 || part.isSensor && !config.showSensors) continue;
                            //  Part polygon
                            var circleRadius = part.circleRadius;
                            graphics.beginPath();
                            if (part.isSensor) {
                                if (fillColor !== null) graphics.fillStyle(sensorFillColor, fillOpacity * opacity);
                                if (lineColor !== null) graphics.lineStyle(lineThickness, sensorLineColor, lineOpacity * opacity);
                            } else {
                                if (fillColor !== null) graphics.fillStyle(fillColor, fillOpacity * opacity);
                                if (lineColor !== null) graphics.lineStyle(lineThickness, lineColor, lineOpacity * opacity);
                            }
                            if (circleRadius) graphics.arc(part.position.x, part.position.y, circleRadius, 0, 2 * Math.PI);
                            else {
                                var vertices = part.vertices;
                                var vertLength = vertices.length;
                                graphics.moveTo(vertices[0].x, vertices[0].y);
                                for(var j = 1; j < vertLength; j++){
                                    var vert = vertices[j];
                                    if (!vertices[j - 1].isInternal || showInternalEdges) graphics.lineTo(vert.x, vert.y);
                                    else graphics.moveTo(vert.x, vert.y);
                                    if (j < vertLength && vert.isInternal && !showInternalEdges) {
                                        var nextIndex = (j + 1) % vertLength;
                                        graphics.moveTo(vertices[nextIndex].x, vertices[nextIndex].y);
                                    }
                                }
                                graphics.closePath();
                            }
                            if (fillColor !== null) graphics.fillPath();
                            if (lineColor !== null) graphics.strokePath();
                        }
                        if (config.showPositions && !body.isStatic) {
                            var px = body.position.x;
                            var py = body.position.y;
                            var hs = Math.ceil(config.positionSize / 2);
                            graphics.fillStyle(config.positionColor, 1);
                            graphics.fillRect(px - hs, py - hs, config.positionSize, config.positionSize);
                        }
                        return this;
                    },
                    /**
     * Renders the Convex Hull for a single Matter Body to the given Phaser Graphics Game Object.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Body hull to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderConvexHull
     * @since 3.22.0
     *
     * @param {MatterJS.BodyType} body - The Matter Body to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} hullColor - The color used to render the hull.
     * @param {number} [lineThickness=1] - The hull line thickness.
     *
     * @return {this} This Matter World instance for method chaining.
     */ renderConvexHull: function(body, graphics, hullColor, lineThickness) {
                        if (lineThickness === undefined) lineThickness = 1;
                        var parts = body.parts;
                        var partsLength = parts.length;
                        //  Render Convex Hulls
                        if (partsLength > 1) {
                            var verts = body.vertices;
                            graphics.lineStyle(lineThickness, hullColor);
                            graphics.beginPath();
                            graphics.moveTo(verts[0].x, verts[0].y);
                            for(var v = 1; v < verts.length; v++)graphics.lineTo(verts[v].x, verts[v].y);
                            graphics.lineTo(verts[0].x, verts[0].y);
                            graphics.strokePath();
                        }
                        return this;
                    },
                    /**
     * Renders all of the constraints in the world (unless they are specifically set to invisible).
     *
     * Called automatically by the `postUpdate` method.
     *
     * @method Phaser.Physics.Matter.World#renderJoints
     * @private
     * @since 3.14.0
     */ renderJoints: function() {
                        var graphics = this.debugGraphic;
                        // Render constraints
                        var constraints = Composite.allConstraints(this.localWorld);
                        for(var i = 0; i < constraints.length; i++){
                            var config = constraints[i].render;
                            var lineColor = config.lineColor;
                            var lineOpacity = config.lineOpacity;
                            var lineThickness = config.lineThickness;
                            var pinSize = config.pinSize;
                            var anchorColor = config.anchorColor;
                            var anchorSize = config.anchorSize;
                            this.renderConstraint(constraints[i], graphics, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize);
                        }
                    },
                    /**
     * Renders a single Matter Constraint, such as a Pin or a Spring, to the given Phaser Graphics Game Object.
     *
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Constraint to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderConstraint
     * @since 3.22.0
     *
     * @param {MatterJS.ConstraintType} constraint - The Matter Constraint to render.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * @param {number} lineThickness - The line thickness.
     * @param {number} pinSize - If this constraint is a pin, this sets the size of the pin circle.
     * @param {number} anchorColor - The color used when rendering this constraints anchors. Set to `null` to not render anchors.
     * @param {number} anchorSize - The size of the anchor circle, if this constraint has anchors and is rendering them.
     *
     * @return {this} This Matter World instance for method chaining.
     */ renderConstraint: function(constraint, graphics, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize) {
                        var render = constraint.render;
                        if (!render.visible || !constraint.pointA || !constraint.pointB) return this;
                        graphics.lineStyle(lineThickness, lineColor, lineOpacity);
                        var bodyA = constraint.bodyA;
                        var bodyB = constraint.bodyB;
                        var start;
                        var end;
                        if (bodyA) start = Vector.add(bodyA.position, constraint.pointA);
                        else start = constraint.pointA;
                        if (render.type === 'pin') graphics.strokeCircle(start.x, start.y, pinSize);
                        else {
                            if (bodyB) end = Vector.add(bodyB.position, constraint.pointB);
                            else end = constraint.pointB;
                            graphics.beginPath();
                            graphics.moveTo(start.x, start.y);
                            if (render.type === 'spring') {
                                var delta = Vector.sub(end, start);
                                var normal = Vector.perp(Vector.normalise(delta));
                                var coils = Math.ceil(Common.clamp(constraint.length / 5, 12, 20));
                                var offset;
                                for(var j = 1; j < coils; j += 1){
                                    offset = j % 2 === 0 ? 1 : -1;
                                    graphics.lineTo(start.x + delta.x * (j / coils) + normal.x * offset * 4, start.y + delta.y * (j / coils) + normal.y * offset * 4);
                                }
                            }
                            graphics.lineTo(end.x, end.y);
                        }
                        graphics.strokePath();
                        if (render.anchors && anchorSize > 0) {
                            graphics.fillStyle(anchorColor);
                            graphics.fillCircle(start.x, start.y, anchorSize);
                            graphics.fillCircle(end.x, end.y, anchorSize);
                        }
                        return this;
                    },
                    /**
     * Resets the internal collision IDs that Matter.JS uses for Body collision groups.
     *
     * You should call this before destroying your game if you need to restart the game
     * again on the same page, without first reloading the page. Or, if you wish to
     * consistently destroy a Scene that contains Matter.js and then run it again
     * later in the same game.
     *
     * @method Phaser.Physics.Matter.World#resetCollisionIDs
     * @since 3.17.0
     */ resetCollisionIDs: function() {
                        Body._nextCollidingGroupId = 1;
                        Body._nextNonCollidingGroupId = -1;
                        Body._nextCategory = 0x0001;
                        return this;
                    },
                    /**
     * Will remove all Matter physics event listeners and clear the matter physics world,
     * engine and any debug graphics, if any.
     *
     * @method Phaser.Physics.Matter.World#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        MatterEvents.off(this.engine);
                        this.removeAllListeners();
                        MatterWorld.clear(this.localWorld, false);
                        Engine.clear(this.engine);
                        if (this.drawDebug) this.debugGraphic.destroy();
                    },
                    /**
     * Will remove all Matter physics event listeners and clear the matter physics world,
     * engine and any debug graphics, if any.
     *
     * After destroying the world it cannot be re-used again.
     *
     * @method Phaser.Physics.Matter.World#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                    }
                });
                module1.exports = World;
            /***/ },
            /***/ 70410: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A component to set restitution on objects.
 *
 * @namespace Phaser.Physics.Matter.Components.Bounce
 * @since 3.0.0
 */ var Bounce = {
                    /**
     * Sets the restitution on the physics object.
     *
     * @method Phaser.Physics.Matter.Components.Bounce#setBounce
     * @since 3.0.0
     *
     * @param {number} value - A Number that defines the restitution (elasticity) of the body. The value is always positive and is in the range (0, 1). A value of 0 means collisions may be perfectly inelastic and no bouncing may occur. A value of 0.8 means the body may bounce back with approximately 80% of its kinetic energy. Note that collision response is based on pairs of bodies, and that restitution values are combined with the following formula: `Math.max(bodyA.restitution, bodyB.restitution)`
     *
     * @return {this} This Game Object instance.
     */ setBounce: function(value) {
                        this.body.restitution = value;
                        return this;
                    }
                };
                module1.exports = Bounce;
            /***/ },
            /***/ 66968: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Contains methods for changing the collision filter of a Matter Body. Should be used as a mixin and not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Collision
 * @since 3.0.0
 */ var Collision = {
                    /**
     * Sets the collision category of this Game Object's Matter Body. This number must be a power of two between 2^0 (= 1) and 2^31.
     * Two bodies with different collision groups (see {@link #setCollisionGroup}) will only collide if their collision
     * categories are included in their collision masks (see {@link #setCollidesWith}).
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollisionCategory
     * @since 3.0.0
     *
     * @param {number} value - Unique category bitfield.
     *
     * @return {this} This Game Object instance.
     */ setCollisionCategory: function(value) {
                        this.body.collisionFilter.category = value;
                        return this;
                    },
                    /**
     * Sets the collision group of this Game Object's Matter Body. If this is zero or two Matter Bodies have different values,
     * they will collide according to the usual rules (see {@link #setCollisionCategory} and {@link #setCollisionGroup}).
     * If two Matter Bodies have the same positive value, they will always collide; if they have the same negative value,
     * they will never collide.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollisionGroup
     * @since 3.0.0
     *
     * @param {number} value - Unique group index.
     *
     * @return {this} This Game Object instance.
     */ setCollisionGroup: function(value) {
                        this.body.collisionFilter.group = value;
                        return this;
                    },
                    /**
     * Sets the collision mask for this Game Object's Matter Body. Two Matter Bodies with different collision groups will only
     * collide if each one includes the other's category in its mask based on a bitwise AND, i.e. `(categoryA & maskB) !== 0`
     * and `(categoryB & maskA) !== 0` are both true.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollidesWith
     * @since 3.0.0
     *
     * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
     *
     * @return {this} This Game Object instance.
     */ setCollidesWith: function(categories) {
                        var flags = 0;
                        if (!Array.isArray(categories)) flags = categories;
                        else for(var i = 0; i < categories.length; i++)flags |= categories[i];
                        this.body.collisionFilter.mask = flags;
                        return this;
                    },
                    /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     *
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollide
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke when this body starts colliding with another.
     *
     * @return {this} This Game Object instance.
     */ setOnCollide: function(callback) {
                        this.body.onCollideCallback = callback;
                        return this;
                    },
                    /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     *
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideEnd
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke when this body stops colliding with another.
     *
     * @return {this} This Game Object instance.
     */ setOnCollideEnd: function(callback) {
                        this.body.onCollideEndCallback = callback;
                        return this;
                    },
                    /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     *
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideActive
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke for the duration of this body colliding with another.
     *
     * @return {this} This Game Object instance.
     */ setOnCollideActive: function(callback) {
                        this.body.onCollideActiveCallback = callback;
                        return this;
                    },
                    /**
     * The callback is sent a reference to the other body, along with a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     *
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideWith
     * @since 3.22.0
     *
     * @param {(MatterJS.Body|MatterJS.Body[])} body - The body, or an array of bodies, to test for collisions with.
     * @param {function} callback - The callback to invoke when this body collides with the given body or bodies.
     *
     * @return {this} This Game Object instance.
     */ setOnCollideWith: function(body, callback) {
                        if (!Array.isArray(body)) body = [
                            body
                        ];
                        for(var i = 0; i < body.length; i++){
                            var src = body[i].hasOwnProperty('body') ? body[i].body : body[i];
                            this.body.setOnCollideWith(src, callback);
                        }
                        return this;
                    }
                };
                module1.exports = Collision;
            /***/ },
            /***/ 51607: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(22562);
                /**
 * A component to apply force to Matter.js bodies.
 *
 * @namespace Phaser.Physics.Matter.Components.Force
 * @since 3.0.0
 */ var Force = {
                    //  force = vec2 / point
                    /**
     * Applies a force to a body.
     *
     * @method Phaser.Physics.Matter.Components.Force#applyForce
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} force - A Vector that specifies the force to apply.
     *
     * @return {this} This Game Object instance.
     */ applyForce: function(force) {
                        this._tempVec2.set(this.body.position.x, this.body.position.y);
                        Body.applyForce(this.body, this._tempVec2, force);
                        return this;
                    },
                    /**
     * Applies a force to a body from a given position.
     *
     * @method Phaser.Physics.Matter.Components.Force#applyForceFrom
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} position - The position in which the force comes from.
     * @param {Phaser.Math.Vector2} force - A Vector that specifies the force to apply.
     *
     * @return {this} This Game Object instance.
     */ applyForceFrom: function(position, force) {
                        Body.applyForce(this.body, position, force);
                        return this;
                    },
                    /**
     * Apply thrust to the forward position of the body.
     *
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrust
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {this} This Game Object instance.
     */ thrust: function(speed) {
                        var angle = this.body.angle;
                        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                        Body.applyForce(this.body, {
                            x: this.body.position.x,
                            y: this.body.position.y
                        }, this._tempVec2);
                        return this;
                    },
                    /**
     * Apply thrust to the left position of the body.
     *
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustLeft
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {this} This Game Object instance.
     */ thrustLeft: function(speed) {
                        var angle = this.body.angle - Math.PI / 2;
                        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                        Body.applyForce(this.body, {
                            x: this.body.position.x,
                            y: this.body.position.y
                        }, this._tempVec2);
                        return this;
                    },
                    /**
     * Apply thrust to the right position of the body.
     *
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustRight
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {this} This Game Object instance.
     */ thrustRight: function(speed) {
                        var angle = this.body.angle + Math.PI / 2;
                        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                        Body.applyForce(this.body, {
                            x: this.body.position.x,
                            y: this.body.position.y
                        }, this._tempVec2);
                        return this;
                    },
                    /**
     * Apply thrust to the back position of the body.
     *
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustBack
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {this} This Game Object instance.
     */ thrustBack: function(speed) {
                        var angle = this.body.angle - Math.PI;
                        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                        Body.applyForce(this.body, {
                            x: this.body.position.x,
                            y: this.body.position.y
                        }, this._tempVec2);
                        return this;
                    }
                };
                module1.exports = Force;
            /***/ },
            /***/ 5436: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Contains methods for changing the friction of a Game Object's Matter Body. Should be used a mixin, not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Friction
 * @since 3.0.0
 */ var Friction = {
                    /**
     * Sets new friction values for this Game Object's Matter Body.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFriction
     * @since 3.0.0
     *
     * @param {number} value - The new friction of the body, between 0 and 1, where 0 allows the Body to slide indefinitely, while 1 allows it to stop almost immediately after a force is applied.
     * @param {number} [air] - If provided, the new air resistance of the Body. The higher the value, the faster the Body will slow as it moves through space. 0 means the body has no air resistance.
     * @param {number} [fstatic] - If provided, the new static friction of the Body. The higher the value (e.g. 10), the more force it will take to initially get the Body moving when it is nearly stationary. 0 means the body will never "stick" when it is nearly stationary.
     *
     * @return {this} This Game Object instance.
     */ setFriction: function(value, air, fstatic) {
                        this.body.friction = value;
                        if (air !== undefined) this.body.frictionAir = air;
                        if (fstatic !== undefined) this.body.frictionStatic = fstatic;
                        return this;
                    },
                    /**
     * Sets a new air resistance for this Game Object's Matter Body.
     * A value of 0 means the Body will never slow as it moves through space.
     * The higher the value, the faster a Body slows when moving through space.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFrictionAir
     * @since 3.0.0
     *
     * @param {number} value - The new air resistance for the Body.
     *
     * @return {this} This Game Object instance.
     */ setFrictionAir: function(value) {
                        this.body.frictionAir = value;
                        return this;
                    },
                    /**
     * Sets a new static friction for this Game Object's Matter Body.
     * A value of 0 means the Body will never "stick" when it is nearly stationary.
     * The higher the value (e.g. 10), the more force it will take to initially get the Body moving when it is nearly stationary.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFrictionStatic
     * @since 3.0.0
     *
     * @param {number} value - The new static friction for the Body.
     *
     * @return {this} This Game Object instance.
     */ setFrictionStatic: function(value) {
                        this.body.frictionStatic = value;
                        return this;
                    }
                };
                module1.exports = Friction;
            /***/ },
            /***/ 39858: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A component to manipulate world gravity for Matter.js bodies.
 *
 * @namespace Phaser.Physics.Matter.Components.Gravity
 * @since 3.0.0
 */ var Gravity = {
                    /**
     * A togglable function for ignoring world gravity in real-time on the current body.
     *
     * @method Phaser.Physics.Matter.Components.Gravity#setIgnoreGravity
     * @since 3.0.0
     *
     * @param {boolean} value - Set to true to ignore the effect of world gravity, or false to not ignore it.
     *
     * @return {this} This Game Object instance.
     */ setIgnoreGravity: function(value) {
                        this.body.ignoreGravity = value;
                        return this;
                    }
                };
                module1.exports = Gravity;
            /***/ },
            /***/ 37302: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(22562);
                var Vector2 = __webpack_require__(26099);
                /**
 * Allows accessing the mass, density, and center of mass of a Matter-enabled Game Object. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Mass
 * @since 3.0.0
 */ var Mass = {
                    /**
     * Sets the mass of the Game Object's Matter Body.
     *
     * @method Phaser.Physics.Matter.Components.Mass#setMass
     * @since 3.0.0
     *
     * @param {number} value - The new mass of the body.
     *
     * @return {this} This Game Object instance.
     */ setMass: function(value) {
                        Body.setMass(this.body, value);
                        return this;
                    },
                    /**
     * Sets density of the body.
     *
     * @method Phaser.Physics.Matter.Components.Mass#setDensity
     * @since 3.0.0
     *
     * @param {number} value - The new density of the body.
     *
     * @return {this} This Game Object instance.
     */ setDensity: function(value) {
                        Body.setDensity(this.body, value);
                        return this;
                    },
                    /**
     * The body's center of mass.
     *
     * Calling this creates a new `Vector2 each time to avoid mutation.
     *
     * If you only need to read the value and won't change it, you can get it from `GameObject.body.centerOfMass`.
     *
     * @name Phaser.Physics.Matter.Components.Mass#centerOfMass
     * @type {Phaser.Math.Vector2}
     * @readonly
     * @since 3.10.0
     *
     * @return {Phaser.Math.Vector2} The center of mass.
     */ centerOfMass: {
                        get: function() {
                            return new Vector2(this.body.centerOfMass.x, this.body.centerOfMass.y);
                        }
                    }
                };
                module1.exports = Mass;
            /***/ },
            /***/ 39132: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Enables a Matter-enabled Game Object to be a sensor. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Sensor
 * @since 3.0.0
 */ var Sensor = {
                    /**
     * Set the body belonging to this Game Object to be a sensor.
     * Sensors trigger collision events, but don't react with colliding body physically.
     *
     * @method Phaser.Physics.Matter.Components.Sensor#setSensor
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to set the body as a sensor, or `false` to disable it.
     *
     * @return {this} This Game Object instance.
     */ setSensor: function(value) {
                        this.body.isSensor = value;
                        return this;
                    },
                    /**
     * Is the body belonging to this Game Object a sensor or not?
     *
     * @method Phaser.Physics.Matter.Components.Sensor#isSensor
     * @since 3.0.0
     *
     * @return {boolean} `true` if the body is a sensor, otherwise `false`.
     */ isSensor: function() {
                        return this.body.isSensor;
                    }
                };
                module1.exports = Sensor;
            /***/ },
            /***/ 57772: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(66280);
                var Body = __webpack_require__(22562);
                var FuzzyEquals = __webpack_require__(43855);
                var GetFastValue = __webpack_require__(95540);
                var PhysicsEditorParser = __webpack_require__(19496);
                var PhysicsJSONParser = __webpack_require__(85791);
                var Vertices = __webpack_require__(41598);
                /**
 * Enables a Matter-enabled Game Object to set its Body. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.SetBody
 * @since 3.0.0
 */ var SetBody = {
                    /**
     * Set this Game Objects Matter physics body to be a rectangle shape.
     *
     * Calling this methods resets all previous properties you may have set on the body, including
     * plugins, mass, friction, collision categories, etc. So be sure to re-apply these as needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setRectangle
     * @since 3.0.0
     *
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {this} This Game Object instance.
     */ setRectangle: function(width, height, options) {
                        return this.setBody({
                            type: 'rectangle',
                            width: width,
                            height: height
                        }, options);
                    },
                    /**
     * Set this Game Objects Matter physics body to be a circle shape.
     *
     * Calling this methods resets all previous properties you may have set on the body, including
     * plugins, mass, friction, collision categories, etc. So be sure to re-apply these as needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {this} This Game Object instance.
     */ setCircle: function(radius, options) {
                        return this.setBody({
                            type: 'circle',
                            radius: radius
                        }, options);
                    },
                    /**
     * Set this Game Objects Matter physics body to be a polygon shape.
     *
     * Calling this methods resets all previous properties you may have set on the body, including
     * plugins, mass, friction, collision categories, etc. So be sure to re-apply these as needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setPolygon
     * @since 3.0.0
     *
     * @param {number} radius - The "radius" of the polygon, i.e. the distance from its center to any vertex. This is also the radius of its circumcircle.
     * @param {number} sides - The number of sides the polygon will have.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {this} This Game Object instance.
     */ setPolygon: function(radius, sides, options) {
                        return this.setBody({
                            type: 'polygon',
                            sides: sides,
                            radius: radius
                        }, options);
                    },
                    /**
     * Set this Game Objects Matter physics body to be a trapezoid shape.
     *
     * Calling this methods resets all previous properties you may have set on the body, including
     * plugins, mass, friction, collision categories, etc. So be sure to re-apply these as needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setTrapezoid
     * @since 3.0.0
     *
     * @param {number} width - The width of the trapezoid Body.
     * @param {number} height - The height of the trapezoid Body.
     * @param {number} slope - The slope of the trapezoid. 0 creates a rectangle, while 1 creates a triangle. Positive values make the top side shorter, while negative values make the bottom side shorter.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {this} This Game Object instance.
     */ setTrapezoid: function(width, height, slope, options) {
                        return this.setBody({
                            type: 'trapezoid',
                            width: width,
                            height: height,
                            slope: slope
                        }, options);
                    },
                    /**
     * Set this Game Object to use the given existing Matter Body.
     *
     * The body is first removed from the world before being added to this Game Object.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setExistingBody
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The Body this Game Object should use.
     * @param {boolean} [addToWorld=true] - Should the body be immediately added to the World?
     *
     * @return {this} This Game Object instance.
     */ setExistingBody: function(body, addToWorld) {
                        if (addToWorld === undefined) addToWorld = true;
                        if (this.body) this.world.remove(this.body, true);
                        this.body = body;
                        for(var i = 0; i < body.parts.length; i++)body.parts[i].gameObject = this;
                        var _this = this;
                        body.destroy = function destroy() {
                            _this.world.remove(_this.body, true);
                            _this.body.gameObject = null;
                        };
                        if (addToWorld) {
                            if (this.world.has(body)) //  Because it could be part of another Composite
                            this.world.remove(body, true);
                            this.world.add(body);
                        }
                        if (this._originComponent) {
                            var rx = body.render.sprite.xOffset;
                            var ry = body.render.sprite.yOffset;
                            var comx = body.centerOfMass.x;
                            var comy = body.centerOfMass.y;
                            if (FuzzyEquals(comx, 0.5) && FuzzyEquals(comy, 0.5)) this.setOrigin(rx + 0.5, ry + 0.5);
                            else {
                                var cx = body.centerOffset.x;
                                var cy = body.centerOffset.y;
                                this.setOrigin(rx + cx / this.displayWidth, ry + cy / this.displayHeight);
                            }
                        }
                        return this;
                    },
                    /**
     * Set this Game Object to create and use a new Body based on the configuration object given.
     *
     * Calling this methods resets all previous properties you may have set on the body, including
     * plugins, mass, friction, collision categories, etc. So be sure to re-apply these as needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setBody
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Physics.Matter.MatterSetBodyConfig)} config - Either a string, such as `circle`, or a Matter Set Body Configuration object.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {this} This Game Object instance.
     */ setBody: function(config, options) {
                        if (!config) return this;
                        var body;
                        //  Allow them to do: shape: 'circle' instead of shape: { type: 'circle' }
                        if (typeof config === 'string') //  Using defaults
                        config = {
                            type: config
                        };
                        var shapeType = GetFastValue(config, 'type', 'rectangle');
                        var bodyX = GetFastValue(config, 'x', this._tempVec2.x);
                        var bodyY = GetFastValue(config, 'y', this._tempVec2.y);
                        var bodyWidth = GetFastValue(config, 'width', this.width);
                        var bodyHeight = GetFastValue(config, 'height', this.height);
                        switch(shapeType){
                            case 'rectangle':
                                body = Bodies.rectangle(bodyX, bodyY, bodyWidth, bodyHeight, options);
                                break;
                            case 'circle':
                                var radius = GetFastValue(config, 'radius', Math.max(bodyWidth, bodyHeight) / 2);
                                var maxSides = GetFastValue(config, 'maxSides', 25);
                                body = Bodies.circle(bodyX, bodyY, radius, options, maxSides);
                                break;
                            case 'trapezoid':
                                var slope = GetFastValue(config, 'slope', 0.5);
                                body = Bodies.trapezoid(bodyX, bodyY, bodyWidth, bodyHeight, slope, options);
                                break;
                            case 'polygon':
                                var sides = GetFastValue(config, 'sides', 5);
                                var pRadius = GetFastValue(config, 'radius', Math.max(bodyWidth, bodyHeight) / 2);
                                body = Bodies.polygon(bodyX, bodyY, sides, pRadius, options);
                                break;
                            case 'fromVertices':
                            case 'fromVerts':
                                var verts = GetFastValue(config, 'verts', null);
                                if (verts) {
                                    //  Has the verts array come from Vertices.fromPath, or is it raw?
                                    if (typeof verts === 'string') verts = Vertices.fromPath(verts);
                                    if (this.body && !this.body.hasOwnProperty('temp')) {
                                        Body.setVertices(this.body, verts);
                                        body = this.body;
                                    } else {
                                        var flagInternal = GetFastValue(config, 'flagInternal', false);
                                        var removeCollinear = GetFastValue(config, 'removeCollinear', 0.01);
                                        var minimumArea = GetFastValue(config, 'minimumArea', 10);
                                        body = Bodies.fromVertices(bodyX, bodyY, verts, options, flagInternal, removeCollinear, minimumArea);
                                    }
                                }
                                break;
                            case 'fromPhysicsEditor':
                                body = PhysicsEditorParser.parseBody(bodyX, bodyY, config, options);
                                break;
                            case 'fromPhysicsTracer':
                                body = PhysicsJSONParser.parseBody(bodyX, bodyY, config, options);
                                break;
                        }
                        if (body) this.setExistingBody(body, config.addToWorld);
                        return this;
                    }
                };
                module1.exports = SetBody;
            /***/ },
            /***/ 38083: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Events = __webpack_require__(1121);
                var Sleeping = __webpack_require__(53614);
                var MatterEvents = __webpack_require__(35810);
                /**
 * Enables a Matter-enabled Game Object to be able to go to sleep. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Sleep
 * @since 3.0.0
 */ var Sleep = {
                    /**
     * Sets this Body to sleep.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setToSleep
     * @since 3.22.0
     *
     * @return {this} This Game Object instance.
     */ setToSleep: function() {
                        Sleeping.set(this.body, true);
                        return this;
                    },
                    /**
     * Wakes this Body if asleep.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setAwake
     * @since 3.22.0
     *
     * @return {this} This Game Object instance.
     */ setAwake: function() {
                        Sleeping.set(this.body, false);
                        return this;
                    },
                    /**
     * Sets the number of updates in which this body must have near-zero velocity before it is set as sleeping (if sleeping is enabled by the engine).
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepThreshold
     * @since 3.0.0
     *
     * @param {number} [value=60] - A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping.
     *
     * @return {this} This Game Object instance.
     */ setSleepThreshold: function(value) {
                        if (value === undefined) value = 60;
                        this.body.sleepThreshold = value;
                        return this;
                    },
                    /**
     * Enable sleep and wake events for this body.
     *
     * By default when a body goes to sleep, or wakes up, it will not emit any events.
     *
     * The events are emitted by the Matter World instance and can be listened to via
     * the `SLEEP_START` and `SLEEP_END` events.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEvents
     * @since 3.0.0
     *
     * @param {boolean} start - `true` if you want the sleep start event to be emitted for this body.
     * @param {boolean} end - `true` if you want the sleep end event to be emitted for this body.
     *
     * @return {this} This Game Object instance.
     */ setSleepEvents: function(start, end) {
                        this.setSleepStartEvent(start);
                        this.setSleepEndEvent(end);
                        return this;
                    },
                    /**
     * Enables or disables the Sleep Start event for this body.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepStartEvent
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to enable the sleep event, or `false` to disable it.
     *
     * @return {this} This Game Object instance.
     */ setSleepStartEvent: function(value) {
                        if (value) {
                            var world = this.world;
                            MatterEvents.on(this.body, 'sleepStart', function(event) {
                                world.emit(Events.SLEEP_START, event, this);
                            });
                        } else MatterEvents.off(this.body, 'sleepStart');
                        return this;
                    },
                    /**
     * Enables or disables the Sleep End event for this body.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEndEvent
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to enable the sleep event, or `false` to disable it.
     *
     * @return {this} This Game Object instance.
     */ setSleepEndEvent: function(value) {
                        if (value) {
                            var world = this.world;
                            MatterEvents.on(this.body, 'sleepEnd', function(event) {
                                world.emit(Events.SLEEP_END, event, this);
                            });
                        } else MatterEvents.off(this.body, 'sleepEnd');
                        return this;
                    }
                };
                module1.exports = Sleep;
            /***/ },
            /***/ 90556: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(22562);
                /**
 * Provides methods used for getting and setting the static state of a physics body.
 *
 * @namespace Phaser.Physics.Matter.Components.Static
 * @since 3.0.0
 */ var Static = {
                    /**
     * Changes the physics body to be either static `true` or dynamic `false`.
     *
     * @method Phaser.Physics.Matter.Components.Static#setStatic
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to set the body as being static, or `false` to make it dynamic.
     *
     * @return {this} This Game Object instance.
     */ setStatic: function(value) {
                        Body.setStatic(this.body, value);
                        return this;
                    },
                    /**
     * Returns `true` if the body is static, otherwise `false` for a dynamic body.
     *
     * @method Phaser.Physics.Matter.Components.Static#isStatic
     * @since 3.0.0
     *
     * @return {boolean} `true` if the body is static, otherwise `false`.
     */ isStatic: function() {
                        return this.body.isStatic;
                    }
                };
                module1.exports = Static;
            /***/ },
            /***/ 85436: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(22562);
                var MATH_CONST = __webpack_require__(36383);
                var WrapAngle = __webpack_require__(86554);
                var WrapAngleDegrees = __webpack_require__(30954);
                //  global bitmask flag for GameObject.renderMask (used by Scale)
                var _FLAG = 4; // 0100
                //  Transform Component
                /**
 * Provides methods used for getting and setting the position, scale and rotation of a Game Object.
 *
 * @namespace Phaser.Physics.Matter.Components.Transform
 * @since 3.0.0
 */ var Transform = {
                    /**
     * The x position of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                        get: function() {
                            return this.body.position.x;
                        },
                        set: function(value) {
                            this._tempVec2.set(value, this.y);
                            Body.setPosition(this.body, this._tempVec2);
                        }
                    },
                    /**
     * The y position of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                        get: function() {
                            return this.body.position.y;
                        },
                        set: function(value) {
                            this._tempVec2.set(this.x, value);
                            Body.setPosition(this.body, this._tempVec2);
                        }
                    },
                    /**
     * This is a special setter that allows you to set both the horizontal and vertical scale of this Game Object
     * to the same value, at the same time. When reading this value the result returned is `(scaleX + scaleY) / 2`.
     *
     * Use of this property implies you wish the horizontal and vertical scales to be equal to each other. If this
     * isn't the case, use the `scaleX` or `scaleY` properties instead.
     *
     * @name Phaser.Physics.Matter.Components.Transform#scale
     * @type {number}
     * @since 3.88.0
     */ scale: {
                        get: function() {
                            return (this._scaleX + this._scaleY) / 2;
                        },
                        set: function(value) {
                            this.setScale(value, value);
                        }
                    },
                    /**
     * The horizontal scale of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#scaleX
     * @type {number}
     * @since 3.0.0
     */ scaleX: {
                        get: function() {
                            return this._scaleX;
                        },
                        set: function(value) {
                            var factorX = 1 / this._scaleX;
                            var factorY = 1 / this._scaleY;
                            this._scaleX = value;
                            if (this._scaleX === 0) this.renderFlags &= ~_FLAG;
                            else this.renderFlags |= _FLAG;
                            //  Reset Matter scale back to 1 (sigh)
                            Body.scale(this.body, factorX, factorY);
                            Body.scale(this.body, value, this._scaleY);
                        }
                    },
                    /**
     * The vertical scale of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#scaleY
     * @type {number}
     * @since 3.0.0
     */ scaleY: {
                        get: function() {
                            return this._scaleY;
                        },
                        set: function(value) {
                            var factorX = 1 / this._scaleX;
                            var factorY = 1 / this._scaleY;
                            this._scaleY = value;
                            if (this._scaleY === 0) this.renderFlags &= ~_FLAG;
                            else this.renderFlags |= _FLAG;
                            Body.scale(this.body, factorX, factorY);
                            Body.scale(this.body, this._scaleX, value);
                        }
                    },
                    /**
     * Use `angle` to set or get rotation of the physics body associated to this GameObject.
     * Unlike rotation, when using set the value can be in degrees, which will be converted to radians internally.
     *
     * @name Phaser.Physics.Matter.Components.Transform#angle
     * @type {number}
     * @since 3.0.0
     */ angle: {
                        get: function() {
                            return WrapAngleDegrees(this.body.angle * MATH_CONST.RAD_TO_DEG);
                        },
                        set: function(value) {
                            //  value is in degrees
                            this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
                        }
                    },
                    /**
     * Use `rotation` to set or get the rotation of the physics body associated with this GameObject.
     * The value when set must be in radians.
     *
     * @name Phaser.Physics.Matter.Components.Transform#rotation
     * @type {number}
     * @since 3.0.0
     */ rotation: {
                        get: function() {
                            return this.body.angle;
                        },
                        set: function(value) {
                            //  value is in radians
                            this._rotation = WrapAngle(value);
                            Body.setAngle(this.body, this._rotation);
                        }
                    },
                    /**
     * Sets the position of the physics body along x and y axes.
     * Both the parameters to this function are optional and if not passed any they default to 0.
     * Velocity, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the body.
     * @param {number} [y=x] - The vertical position of the body.
     *
     * @return {this} This Game Object instance.
     */ setPosition: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = x;
                        this._tempVec2.set(x, y);
                        Body.setPosition(this.body, this._tempVec2);
                        return this;
                    },
                    /**
     * Immediately sets the angle of the Body.
     * Angular velocity, position, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setRotation
     * @since 3.0.0
     *
     * @param {number} [radians=0] - The angle of the body, in radians.
     *
     * @return {this} This Game Object instance.
     */ setRotation: function(radians) {
                        if (radians === undefined) radians = 0;
                        this._rotation = WrapAngle(radians);
                        Body.setAngle(this.body, radians);
                        return this;
                    },
                    /**
     * Setting fixed rotation sets the Body inertia to Infinity, which stops it
     * from being able to rotate when forces are applied to it.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setFixedRotation
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ setFixedRotation: function() {
                        Body.setInertia(this.body, Infinity);
                        return this;
                    },
                    /**
     * Immediately sets the angle of the Body.
     * Angular velocity, position, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setAngle
     * @since 3.0.0
     *
     * @param {number} [degrees=0] - The angle to set, in degrees.
     *
     * @return {this} This Game Object instance.
     */ setAngle: function(degrees) {
                        if (degrees === undefined) degrees = 0;
                        this.angle = degrees;
                        Body.setAngle(this.body, this.rotation);
                        return this;
                    },
                    /**
     * Sets the scale of this Game Object.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setScale
     * @since 3.0.0
     *
     * @param {number} [x=1] - The horizontal scale of this Game Object.
     * @param {number} [y=x] - The vertical scale of this Game Object. If not set it will use the x value.
     * @param {Phaser.Math.Vector2} [point] - The point (Vector2) from which scaling will occur.
     *
     * @return {this} This Game Object instance.
     */ setScale: function(x, y, point) {
                        if (x === undefined) x = 1;
                        if (y === undefined) y = x;
                        var factorX = 1 / this._scaleX;
                        var factorY = 1 / this._scaleY;
                        this._scaleX = x;
                        this._scaleY = y;
                        Body.scale(this.body, factorX, factorY, point);
                        Body.scale(this.body, x, y, point);
                        return this;
                    }
                };
                module1.exports = Transform;
            /***/ },
            /***/ 42081: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(22562);
                /**
 * Contains methods for changing the velocity of a Matter Body. Should be used as a mixin and not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Velocity
 * @since 3.0.0
 */ var Velocity = {
                    /**
     * Sets the horizontal velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityX
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity value.
     *
     * @return {this} This Game Object instance.
     */ setVelocityX: function(x) {
                        this._tempVec2.set(x, this.body.velocity.y);
                        Body.setVelocity(this.body, this._tempVec2);
                        return this;
                    },
                    /**
     * Sets vertical velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityY
     * @since 3.0.0
     *
     * @param {number} y - The vertical velocity value.
     *
     * @return {this} This Game Object instance.
     */ setVelocityY: function(y) {
                        this._tempVec2.set(this.body.velocity.x, y);
                        Body.setVelocity(this.body, this._tempVec2);
                        return this;
                    },
                    /**
     * Sets both the horizontal and vertical velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity value.
     * @param {number} [y=x] - The vertical velocity value, it can be either positive or negative. If not given, it will be the same as the `x` value.
     *
     * @return {this} This Game Object instance.
     */ setVelocity: function(x, y) {
                        this._tempVec2.set(x, y);
                        Body.setVelocity(this.body, this._tempVec2);
                        return this;
                    },
                    /**
     * Gets the current linear velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#getVelocity
     * @since 3.60.0
     *
     * @return {Phaser.Types.Math.Vector2Like} The current linear velocity of the body.
     */ getVelocity: function() {
                        return Body.getVelocity(this.body);
                    },
                    /**
     * Sets the angular velocity of the body instantly.
     * Position, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} velocity - The angular velocity.
     *
     * @return {this} This Game Object instance.
     */ setAngularVelocity: function(velocity) {
                        Body.setAngularVelocity(this.body, velocity);
                        return this;
                    },
                    /**
     * Gets the current rotational velocity of the body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#getAngularVelocity
     * @since 3.60.0
     *
     * @return {number} The current angular velocity of the body.
     */ getAngularVelocity: function() {
                        return Body.getAngularVelocity(this.body);
                    },
                    /**
     * Sets the current rotational speed of the body.
     * Direction is maintained. Affects body angular velocity.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setAngularSpeed
     * @since 3.60.0
     *
     * @param {number} speed - The angular speed.
     *
     * @return {this} This Game Object instance.
     */ setAngularSpeed: function(speed) {
                        Body.setAngularSpeed(this.body, speed);
                        return this;
                    },
                    /**
     * Gets the current rotational speed of the body.
     * Equivalent to the magnitude of its angular velocity.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#getAngularSpeed
     * @since 3.60.0
     *
     * @return {number} The current angular velocity of the body.
     */ getAngularSpeed: function() {
                        return Body.getAngularSpeed(this.body);
                    }
                };
                module1.exports = Velocity;
            /***/ },
            /***/ 31884: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Components
 */ module1.exports = {
                    Bounce: __webpack_require__(70410),
                    Collision: __webpack_require__(66968),
                    Force: __webpack_require__(51607),
                    Friction: __webpack_require__(5436),
                    Gravity: __webpack_require__(39858),
                    Mass: __webpack_require__(37302),
                    Sensor: __webpack_require__(39132),
                    SetBody: __webpack_require__(57772),
                    Sleep: __webpack_require__(38083),
                    Static: __webpack_require__(90556),
                    Transform: __webpack_require__(85436),
                    Velocity: __webpack_require__(42081)
                };
            /***/ },
            /***/ 85608: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterAddEvent
 *
 * @property {any[]} object - An array of the object(s) that have been added. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Add Event.
 *
 * This event is dispatched by a Matter Physics World instance at the end of the process when a new Body
 * or Constraint has just been added to the world.
 *
 * Listen to it from a Scene using: `this.matter.world.on('afteradd', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_ADD
 * @type {string}
 * @since 3.22.0
 *
 * @param {Phaser.Physics.Matter.Events.AfterAddEvent} event - The Add Event object.
 */ module1.exports = 'afteradd';
            /***/ },
            /***/ 1213: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterRemoveEvent
 *
 * @property {any[]} object - An array of the object(s) that were removed. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Remove Event.
 *
 * This event is dispatched by a Matter Physics World instance at the end of the process when a
 * Body or Constraint was removed from the world.
 *
 * Listen to it from a Scene using: `this.matter.world.on('afterremove', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_REMOVE
 * @type {string}
 * @since 3.22.0
 *
 * @param {Phaser.Physics.Matter.Events.AfterRemoveEvent} event - The Remove Event object.
 */ module1.exports = 'afterremove';
            /***/ },
            /***/ 25968: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterUpdateEvent
 *
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Update Event.
 *
 * This event is dispatched by a Matter Physics World instance after the engine has updated and all collision events have resolved.
 *
 * Listen to it from a Scene using: `this.matter.world.on('afterupdate', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_UPDATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.Events.AfterUpdateEvent} event - The Update Event object.
 */ module1.exports = 'afterupdate';
            /***/ },
            /***/ 67205: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeAddEvent
 *
 * @property {any[]} object - An array of the object(s) to be added. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Add Event.
 *
 * This event is dispatched by a Matter Physics World instance at the start of the process when a new Body
 * or Constraint is being added to the world.
 *
 * Listen to it from a Scene using: `this.matter.world.on('beforeadd', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_ADD
 * @type {string}
 * @since 3.22.0
 *
 * @param {Phaser.Physics.Matter.Events.BeforeAddEvent} event - The Add Event object.
 */ module1.exports = 'beforeadd';
            /***/ },
            /***/ 39438: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeRemoveEvent
 *
 * @property {any[]} object - An array of the object(s) to be removed. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Remove Event.
 *
 * This event is dispatched by a Matter Physics World instance at the start of the process when a
 * Body or Constraint is being removed from the world.
 *
 * Listen to it from a Scene using: `this.matter.world.on('beforeremove', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_REMOVE
 * @type {string}
 * @since 3.22.0
 *
 * @param {Phaser.Physics.Matter.Events.BeforeRemoveEvent} event - The Remove Event object.
 */ module1.exports = 'beforeremove';
            /***/ },
            /***/ 44823: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeUpdateEvent
 *
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Update Event.
 *
 * This event is dispatched by a Matter Physics World instance right before all the collision processing takes place.
 *
 * Listen to it from a Scene using: `this.matter.world.on('beforeupdate', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_UPDATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.Events.BeforeUpdateEvent} event - The Update Event object.
 */ module1.exports = 'beforeupdate';
            /***/ },
            /***/ 92593: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionActiveEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionPair[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision Active Event.
 *
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that are colliding in the current tick (if any).
 *
 * Listen to it from a Scene using: `this.matter.world.on('collisionactive', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_ACTIVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.Events.CollisionActiveEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = 'collisionactive';
            /***/ },
            /***/ 60128: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionEndEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionPair[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision End Event.
 *
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that have finished colliding in the current tick (if any).
 *
 * Listen to it from a Scene using: `this.matter.world.on('collisionend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_END
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.Events.CollisionEndEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = 'collisionend';
            /***/ },
            /***/ 76861: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionStartEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionPair[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision Start Event.
 *
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that have started to collide in the current tick (if any).
 *
 * Listen to it from a Scene using: `this.matter.world.on('collisionstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_START
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.Events.CollisionStartEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = 'collisionstart';
            /***/ },
            /***/ 92362: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag End Event.
 *
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * stops dragging a body.
 *
 * Listen to it from a Scene using: `this.matter.world.on('dragend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG_END
 * @type {string}
 * @since 3.16.2
 *
 * @param {MatterJS.BodyType} body - The Body that has stopped being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that was dragging the body.
 */ module1.exports = 'dragend';
            /***/ },
            /***/ 76408: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag Event.
 *
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * is actively dragging a body. It is emitted each time the pointer moves.
 *
 * Listen to it from a Scene using: `this.matter.world.on('drag', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG
 * @type {string}
 * @since 3.16.2
 *
 * @param {MatterJS.BodyType} body - The Body that is being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that is dragging the body.
 */ module1.exports = 'drag';
            /***/ },
            /***/ 93971: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag Start Event.
 *
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * starts dragging a body.
 *
 * Listen to it from a Scene using: `this.matter.world.on('dragstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG_START
 * @type {string}
 * @since 3.16.2
 *
 * @param {MatterJS.BodyType} body - The Body that has started being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {MatterJS.BodyType} part - The part of the body that was clicked on.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that is dragging the body.
 */ module1.exports = 'dragstart';
            /***/ },
            /***/ 5656: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics World Pause Event.
 *
 * This event is dispatched by an Matter Physics World instance when it is paused.
 *
 * Listen to it from a Scene using: `this.matter.world.on('pause', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#PAUSE
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'pause';
            /***/ },
            /***/ 47861: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics World Resume Event.
 *
 * This event is dispatched by an Matter Physics World instance when it resumes from a paused state.
 *
 * Listen to it from a Scene using: `this.matter.world.on('resume', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#RESUME
 * @type {string}
 * @since 3.0.0
 */ module1.exports = 'resume';
            /***/ },
            /***/ 79099: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.SleepEndEvent
 *
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Sleep End Event.
 *
 * This event is dispatched by a Matter Physics World instance when a Body stop sleeping.
 *
 * Listen to it from a Scene using: `this.matter.world.on('sleepend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#SLEEP_END
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.Events.SleepEndEvent} event - The Sleep Event object.
 * @param {MatterJS.BodyType} body - The body that has stopped sleeping.
 */ module1.exports = 'sleepend';
            /***/ },
            /***/ 35906: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.SleepStartEvent
 *
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Sleep Start Event.
 *
 * This event is dispatched by a Matter Physics World instance when a Body goes to sleep.
 *
 * Listen to it from a Scene using: `this.matter.world.on('sleepstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#SLEEP_START
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.Events.SleepStartEvent} event - The Sleep Event object.
 * @param {MatterJS.BodyType} body - The body that has gone to sleep.
 */ module1.exports = 'sleepstart';
            /***/ },
            /***/ 1121: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Events
 */ module1.exports = {
                    AFTER_ADD: __webpack_require__(85608),
                    AFTER_REMOVE: __webpack_require__(1213),
                    AFTER_UPDATE: __webpack_require__(25968),
                    BEFORE_ADD: __webpack_require__(67205),
                    BEFORE_REMOVE: __webpack_require__(39438),
                    BEFORE_UPDATE: __webpack_require__(44823),
                    COLLISION_ACTIVE: __webpack_require__(92593),
                    COLLISION_END: __webpack_require__(60128),
                    COLLISION_START: __webpack_require__(76861),
                    DRAG_END: __webpack_require__(92362),
                    DRAG: __webpack_require__(76408),
                    DRAG_START: __webpack_require__(93971),
                    PAUSE: __webpack_require__(5656),
                    RESUME: __webpack_require__(47861),
                    SLEEP_END: __webpack_require__(79099),
                    SLEEP_START: __webpack_require__(35906)
                };
            /***/ },
            /***/ 3875: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter
 */ module1.exports = {
                    BodyBounds: __webpack_require__(68174),
                    Components: __webpack_require__(31884),
                    Events: __webpack_require__(1121),
                    Factory: __webpack_require__(28137),
                    MatterGameObject: __webpack_require__(75803),
                    Image: __webpack_require__(23181),
                    Matter: __webpack_require__(19933),
                    MatterPhysics: __webpack_require__(42045),
                    PolyDecomp: __webpack_require__(55973),
                    Sprite: __webpack_require__(34803),
                    TileBody: __webpack_require__(73834),
                    PhysicsEditorParser: __webpack_require__(19496),
                    PhysicsJSONParser: __webpack_require__(85791),
                    PointerConstraint: __webpack_require__(98713),
                    World: __webpack_require__(68243)
                };
            /***/ },
            /***/ 22562: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * The `Matter.Body` module contains methods for creating and manipulating body models.
 * A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
 * Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the module `Matter.Bodies`.
 *
 * See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
 * @class Body
 */ var Body = {};
                module1.exports = Body;
                var Vertices = __webpack_require__(41598);
                var Vector = __webpack_require__(31725);
                var Sleeping = __webpack_require__(53614);
                var Common = __webpack_require__(53402);
                var Bounds = __webpack_require__(15647);
                var Axes = __webpack_require__(66615);
                (function() {
                    Body._timeCorrection = true;
                    Body._inertiaScale = 4;
                    Body._nextCollidingGroupId = 1;
                    Body._nextNonCollidingGroupId = -1;
                    Body._nextCategory = 0x0001;
                    Body._baseDelta = 1000 / 60;
                    /**
     * Creates a new rigid body model. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * Vertices must be specified in clockwise order.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {body} body
     */ Body.create = function(options) {
                        var defaults = {
                            id: Common.nextId(),
                            type: 'body',
                            label: 'Body',
                            parts: [],
                            plugin: {},
                            attractors: options.attractors || [],
                            wrapBounds: null,
                            angle: 0,
                            vertices: null,
                            position: {
                                x: 0,
                                y: 0
                            },
                            force: {
                                x: 0,
                                y: 0
                            },
                            torque: 0,
                            positionImpulse: {
                                x: 0,
                                y: 0
                            },
                            constraintImpulse: {
                                x: 0,
                                y: 0,
                                angle: 0
                            },
                            totalContacts: 0,
                            speed: 0,
                            angularSpeed: 0,
                            velocity: {
                                x: 0,
                                y: 0
                            },
                            angularVelocity: 0,
                            isSensor: false,
                            isStatic: false,
                            isSleeping: false,
                            motion: 0,
                            sleepThreshold: 60,
                            density: 0.001,
                            restitution: 0,
                            friction: 0.1,
                            frictionStatic: 0.5,
                            frictionAir: 0.01,
                            collisionFilter: {
                                category: 0x0001,
                                mask: 0xFFFFFFFF,
                                group: 0
                            },
                            slop: 0.05,
                            timeScale: 1,
                            events: null,
                            bounds: null,
                            chamfer: null,
                            circleRadius: 0,
                            positionPrev: null,
                            anglePrev: 0,
                            parent: null,
                            axes: null,
                            area: 0,
                            mass: 0,
                            inverseMass: 0,
                            inertia: 0,
                            deltaTime: 1000 / 60,
                            inverseInertia: 0,
                            _original: null,
                            render: {
                                visible: true,
                                opacity: 1,
                                sprite: {
                                    xOffset: 0,
                                    yOffset: 0
                                },
                                fillColor: null,
                                fillOpacity: null,
                                lineColor: null,
                                lineOpacity: null,
                                lineThickness: null // custom Phaser property
                            },
                            gameObject: null,
                            scale: {
                                x: 1,
                                y: 1
                            },
                            centerOfMass: {
                                x: 0,
                                y: 0
                            },
                            centerOffset: {
                                x: 0,
                                y: 0
                            },
                            gravityScale: {
                                x: 1,
                                y: 1
                            },
                            ignoreGravity: false,
                            ignorePointer: false,
                            onCollideCallback: null,
                            onCollideEndCallback: null,
                            onCollideActiveCallback: null,
                            onCollideWith: {} // custom Phaser property
                        };
                        if (!options.hasOwnProperty('position') && options.hasOwnProperty('vertices')) options.position = Vertices.centre(options.vertices);
                        else if (!options.hasOwnProperty('vertices')) defaults.vertices = Vertices.fromPath('L 0 0 L 40 0 L 40 40 L 0 40');
                        var body = Common.extend(defaults, options);
                        _initProperties(body, options);
                        //  Helper function
                        body.setOnCollideWith = function(body, callback) {
                            if (callback) this.onCollideWith[body.id] = callback;
                            else delete this.onCollideWith[body.id];
                            return this;
                        };
                        return body;
                    };
                    /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will _not_ collide.
     * See `body.collisionFilter` for more information.
     * @method nextGroup
     * @param {bool} [isNonColliding=false]
     * @return {Number} Unique group index
     */ Body.nextGroup = function(isNonColliding) {
                        if (isNonColliding) return Body._nextNonCollidingGroupId--;
                        return Body._nextCollidingGroupId++;
                    };
                    /**
     * Returns the next unique category bitfield (starting after the initial default category `0x0001`).
     * There are 32 available. See `body.collisionFilter` for more information.
     * @method nextCategory
     * @return {Number} Unique category bitfield
     */ Body.nextCategory = function() {
                        Body._nextCategory = Body._nextCategory << 1;
                        return Body._nextCategory;
                    };
                    /**
     * Initialises body properties.
     * @method _initProperties
     * @private
     * @param {body} body
     * @param {} [options]
     */ var _initProperties = function(body, options) {
                        options = options || {};
                        // init required properties (order is important)
                        Body.set(body, {
                            bounds: body.bounds || Bounds.create(body.vertices),
                            positionPrev: body.positionPrev || Vector.clone(body.position),
                            anglePrev: body.anglePrev || body.angle,
                            vertices: body.vertices,
                            parts: body.parts || [
                                body
                            ],
                            isStatic: body.isStatic,
                            isSleeping: body.isSleeping,
                            parent: body.parent || body
                        });
                        Vertices.rotate(body.vertices, body.angle, body.position);
                        Axes.rotate(body.axes, body.angle);
                        Bounds.update(body.bounds, body.vertices, body.velocity);
                        // allow options to override the automatically calculated properties
                        Body.set(body, {
                            axes: options.axes || body.axes,
                            area: options.area || body.area,
                            mass: options.mass || body.mass,
                            inertia: options.inertia || body.inertia
                        });
                        if (body.parts.length === 1) {
                            var bounds = body.bounds;
                            var centerOfMass = body.centerOfMass;
                            var centerOffset = body.centerOffset;
                            var bodyWidth = bounds.max.x - bounds.min.x;
                            var bodyHeight = bounds.max.y - bounds.min.y;
                            centerOfMass.x = -(bounds.min.x - body.position.x) / bodyWidth;
                            centerOfMass.y = -(bounds.min.y - body.position.y) / bodyHeight;
                            centerOffset.x = bodyWidth * centerOfMass.x;
                            centerOffset.y = bodyHeight * centerOfMass.y;
                        }
                    //  From Matter render code:
                    // body.render.sprite.xOffset += -(body.bounds.min.x - body.position.x) / (body.bounds.max.x - body.bounds.min.x);
                    // body.render.sprite.yOffset += -(body.bounds.min.y - body.position.y) / (body.bounds.max.y - body.bounds.min.y);
                    };
                    /**
     * Given a property and a value (or map of), sets the property(s) on the body, using the appropriate setter functions if they exist.
     * Prefer to use the actual setter functions in performance critical situations.
     * @method set
     * @param {body} body
     * @param {} settings A property name (or map of properties and values) to set on the body.
     * @param {} value The value to set if `settings` is a single property name.
     */ Body.set = function(body, settings, value) {
                        var property;
                        if (typeof settings === 'string') {
                            property = settings;
                            settings = {};
                            settings[property] = value;
                        }
                        for(property in settings){
                            if (!Object.prototype.hasOwnProperty.call(settings, property)) continue;
                            value = settings[property];
                            switch(property){
                                case 'isStatic':
                                    Body.setStatic(body, value);
                                    break;
                                case 'isSleeping':
                                    Sleeping.set(body, value);
                                    break;
                                case 'mass':
                                    Body.setMass(body, value);
                                    break;
                                case 'density':
                                    Body.setDensity(body, value);
                                    break;
                                case 'inertia':
                                    Body.setInertia(body, value);
                                    break;
                                case 'vertices':
                                    Body.setVertices(body, value);
                                    break;
                                case 'position':
                                    Body.setPosition(body, value);
                                    break;
                                case 'angle':
                                    Body.setAngle(body, value);
                                    break;
                                case 'velocity':
                                    Body.setVelocity(body, value);
                                    break;
                                case 'angularVelocity':
                                    Body.setAngularVelocity(body, value);
                                    break;
                                case 'speed':
                                    Body.setSpeed(body, value);
                                    break;
                                case 'angularSpeed':
                                    Body.setAngularSpeed(body, value);
                                    break;
                                case 'parts':
                                    Body.setParts(body, value);
                                    break;
                                case 'centre':
                                    Body.setCentre(body, value);
                                    break;
                                default:
                                    body[property] = value;
                            }
                        }
                    };
                    /**
     * Sets the body as static, including isStatic flag and setting mass and inertia to Infinity.
     * @method setStatic
     * @param {body} body
     * @param {bool} isStatic
     */ Body.setStatic = function(body, isStatic) {
                        for(var i = 0; i < body.parts.length; i++){
                            var part = body.parts[i];
                            if (isStatic) {
                                if (!part.isStatic) part._original = {
                                    restitution: part.restitution,
                                    friction: part.friction,
                                    mass: part.mass,
                                    inertia: part.inertia,
                                    density: part.density,
                                    inverseMass: part.inverseMass,
                                    inverseInertia: part.inverseInertia
                                };
                                part.restitution = 0;
                                part.friction = 1;
                                part.mass = part.inertia = part.density = Infinity;
                                part.inverseMass = part.inverseInertia = 0;
                                part.positionPrev.x = part.position.x;
                                part.positionPrev.y = part.position.y;
                                part.anglePrev = part.angle;
                                part.angularVelocity = 0;
                                part.speed = 0;
                                part.angularSpeed = 0;
                                part.motion = 0;
                            } else if (part._original) {
                                part.restitution = part._original.restitution;
                                part.friction = part._original.friction;
                                part.mass = part._original.mass;
                                part.inertia = part._original.inertia;
                                part.density = part._original.density;
                                part.inverseMass = part._original.inverseMass;
                                part.inverseInertia = part._original.inverseInertia;
                                part._original = null;
                            }
                            part.isStatic = isStatic;
                        }
                    };
                    /**
     * Sets the mass of the body. Inverse mass, density and inertia are automatically updated to reflect the change.
     * @method setMass
     * @param {body} body
     * @param {number} mass
     */ Body.setMass = function(body, mass) {
                        var moment = body.inertia / (body.mass / 6);
                        body.inertia = moment * (mass / 6);
                        body.inverseInertia = 1 / body.inertia;
                        body.mass = mass;
                        body.inverseMass = 1 / body.mass;
                        body.density = body.mass / body.area;
                    };
                    /**
     * Sets the density of the body. Mass and inertia are automatically updated to reflect the change.
     * @method setDensity
     * @param {body} body
     * @param {number} density
     */ Body.setDensity = function(body, density) {
                        Body.setMass(body, density * body.area);
                        body.density = density;
                    };
                    /**
     * Sets the moment of inertia (i.e. second moment of area) of the body.
     * Inverse inertia is automatically updated to reflect the change. Mass is not changed.
     * @method setInertia
     * @param {body} body
     * @param {number} inertia
     */ Body.setInertia = function(body, inertia) {
                        body.inertia = inertia;
                        body.inverseInertia = 1 / body.inertia;
                    };
                    /**
     * Sets the body's vertices and updates body properties accordingly, including inertia, area and mass (with respect to `body.density`).
     * Vertices will be automatically transformed to be orientated around their centre of mass as the origin.
     * They are then automatically translated to world space based on `body.position`.
     *
     * The `vertices` argument should be passed as an array of `Matter.Vector` points (or a `Matter.Vertices` array).
     * Vertices must form a convex hull, concave hulls are not supported.
     *
     * @method setVertices
     * @param {body} body
     * @param {vector[]} vertices
     */ Body.setVertices = function(body, vertices) {
                        // change vertices
                        if (vertices[0].body === body) body.vertices = vertices;
                        else body.vertices = Vertices.create(vertices, body);
                        // update properties
                        body.axes = Axes.fromVertices(body.vertices);
                        body.area = Vertices.area(body.vertices);
                        Body.setMass(body, body.density * body.area);
                        // orient vertices around the centre of mass at origin (0, 0)
                        var centre = Vertices.centre(body.vertices);
                        Vertices.translate(body.vertices, centre, -1);
                        // update inertia while vertices are at origin (0, 0)
                        Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass));
                        // update geometry
                        Vertices.translate(body.vertices, body.position);
                        Bounds.update(body.bounds, body.vertices, body.velocity);
                    };
                    /**
     * Sets the parts of the `body` and updates mass, inertia and centroid.
     * Each part will have its parent set to `body`.
     * By default the convex hull will be automatically computed and set on `body`, unless `autoHull` is set to `false.`
     * Note that this method will ensure that the first part in `body.parts` will always be the `body`.
     * @method setParts
     * @param {body} body
     * @param [body] parts
     * @param {bool} [autoHull=true]
     */ Body.setParts = function(body, parts, autoHull) {
                        var i;
                        // add all the parts, ensuring that the first part is always the parent body
                        parts = parts.slice(0);
                        body.parts.length = 0;
                        body.parts.push(body);
                        body.parent = body;
                        for(i = 0; i < parts.length; i++){
                            var part = parts[i];
                            if (part !== body) {
                                part.parent = body;
                                body.parts.push(part);
                            }
                        }
                        if (body.parts.length === 1) return;
                        autoHull = typeof autoHull !== 'undefined' ? autoHull : true;
                        // find the convex hull of all parts to set on the parent body
                        if (autoHull) {
                            var vertices = [];
                            for(i = 0; i < parts.length; i++)vertices = vertices.concat(parts[i].vertices);
                            Vertices.clockwiseSort(vertices);
                            var hull = Vertices.hull(vertices), hullCentre = Vertices.centre(hull);
                            Body.setVertices(body, hull);
                            Vertices.translate(body.vertices, hullCentre);
                        }
                        // sum the properties of all compound parts of the parent body
                        var total = Body._totalProperties(body);
                        //  Phaser addition
                        var cx = total.centre.x;
                        var cy = total.centre.y;
                        var bounds = body.bounds;
                        var centerOfMass = body.centerOfMass;
                        var centerOffset = body.centerOffset;
                        Bounds.update(bounds, body.vertices, body.velocity);
                        centerOfMass.x = -(bounds.min.x - cx) / (bounds.max.x - bounds.min.x);
                        centerOfMass.y = -(bounds.min.y - cy) / (bounds.max.y - bounds.min.y);
                        centerOffset.x = cx;
                        centerOffset.y = cy;
                        body.area = total.area;
                        body.parent = body;
                        body.position.x = cx;
                        body.position.y = cy;
                        body.positionPrev.x = cx;
                        body.positionPrev.y = cy;
                        //  Matter.js original
                        // body.position.x = total.centre.x;
                        // body.position.y = total.centre.y;
                        // body.positionPrev.x = total.centre.x;
                        // body.positionPrev.y = total.centre.y;
                        Body.setMass(body, total.mass);
                        Body.setInertia(body, total.inertia);
                        Body.setPosition(body, total.centre);
                    };
                    /**
     * Set the centre of mass of the body.
     * The `centre` is a vector in world-space unless `relative` is set, in which case it is a translation.
     * The centre of mass is the point the body rotates about and can be used to simulate non-uniform density.
     * This is equal to moving `body.position` but not the `body.vertices`.
     * Invalid if the `centre` falls outside the body's convex hull.
     * @method setCentre
     * @param {body} body
     * @param {vector} centre
     * @param {bool} relative
     */ Body.setCentre = function(body, centre, relative) {
                        if (!relative) {
                            body.positionPrev.x = centre.x - (body.position.x - body.positionPrev.x);
                            body.positionPrev.y = centre.y - (body.position.y - body.positionPrev.y);
                            body.position.x = centre.x;
                            body.position.y = centre.y;
                        } else {
                            body.positionPrev.x += centre.x;
                            body.positionPrev.y += centre.y;
                            body.position.x += centre.x;
                            body.position.y += centre.y;
                        }
                    };
                    /**
     * Sets the position of the body instantly. Velocity, angle, force etc. are unchanged.
     * @method setPosition
     * @param {body} body
     * @param {vector} position
     * @param {boolean} [updateVelocity=false]
     */ Body.setPosition = function(body, position, updateVelocity) {
                        var delta = Vector.sub(position, body.position);
                        if (updateVelocity) {
                            body.positionPrev.x = body.position.x;
                            body.positionPrev.y = body.position.y;
                            body.velocity.x = delta.x;
                            body.velocity.y = delta.y;
                            body.speed = Vector.magnitude(delta);
                        } else {
                            body.positionPrev.x += delta.x;
                            body.positionPrev.y += delta.y;
                        }
                        for(var i = 0; i < body.parts.length; i++){
                            var part = body.parts[i];
                            part.position.x += delta.x;
                            part.position.y += delta.y;
                            Vertices.translate(part.vertices, delta);
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                        }
                    };
                    /**
     * Sets the angle of the body instantly. Angular velocity, position, force etc. are unchanged.
     * @method setAngle
     * @param {body} body
     * @param {number} angle
     * @param {boolean} [updateVelocity=false]
     */ Body.setAngle = function(body, angle, updateVelocity) {
                        var delta = angle - body.angle;
                        if (updateVelocity) {
                            body.anglePrev = body.angle;
                            body.angularVelocity = delta;
                            body.angularSpeed = Math.abs(delta);
                        } else body.anglePrev += delta;
                        for(var i = 0; i < body.parts.length; i++){
                            var part = body.parts[i];
                            part.angle += delta;
                            Vertices.rotate(part.vertices, delta, body.position);
                            Axes.rotate(part.axes, delta);
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                            if (i > 0) Vector.rotateAbout(part.position, delta, body.position, part.position);
                        }
                    };
                    /**
     * Sets the linear velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setVelocity
     * @param {body} body
     * @param {vector} velocity
     */ Body.setVelocity = function(body, velocity) {
                        var timeScale = body.deltaTime / Body._baseDelta;
                        body.positionPrev.x = body.position.x - velocity.x * timeScale;
                        body.positionPrev.y = body.position.y - velocity.y * timeScale;
                        body.velocity.x = (body.position.x - body.positionPrev.x) / timeScale;
                        body.velocity.y = (body.position.y - body.positionPrev.y) / timeScale;
                        body.speed = Vector.magnitude(body.velocity);
                    };
                    /**
     * Gets the current linear velocity of the body.
     * @method getVelocity
     * @param {body} body
     * @return {vector} velocity
     */ Body.getVelocity = function(body) {
                        var timeScale = Body._baseDelta / body.deltaTime;
                        return {
                            x: (body.position.x - body.positionPrev.x) * timeScale,
                            y: (body.position.y - body.positionPrev.y) * timeScale
                        };
                    };
                    /**
     * Gets the current linear speed of the body.
     * Equivalent to the magnitude of its velocity.
     * @method getSpeed
     * @param {body} body
     * @return {number} speed
     */ Body.getSpeed = function(body) {
                        return Vector.magnitude(Body.getVelocity(body));
                    };
                    /**
     * Sets the current linear speed of the body.
     * Direction is maintained. Affects body velocity.
     * @method setSpeed
     * @param {body} body
     * @param {number} speed
     */ Body.setSpeed = function(body, speed) {
                        Body.setVelocity(body, Vector.mult(Vector.normalise(Body.getVelocity(body)), speed));
                    };
                    /**
     * Sets the angular velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setAngularVelocity
     * @param {body} body
     * @param {number} velocity
     */ Body.setAngularVelocity = function(body, velocity) {
                        var timeScale = body.deltaTime / Body._baseDelta;
                        body.anglePrev = body.angle - velocity * timeScale;
                        body.angularVelocity = (body.angle - body.anglePrev) / timeScale;
                        body.angularSpeed = Math.abs(body.angularVelocity);
                    };
                    /**
     * Gets the current rotational velocity of the body.
     * @method getAngularVelocity
     * @param {body} body
     * @return {number} angular velocity
     */ Body.getAngularVelocity = function(body) {
                        return (body.angle - body.anglePrev) * Body._baseDelta / body.deltaTime;
                    };
                    /**
     * Gets the current rotational speed of the body.
     * Equivalent to the magnitude of its angular velocity.
     * @method getAngularSpeed
     * @param {body} body
     * @return {number} angular speed
     */ Body.getAngularSpeed = function(body) {
                        return Math.abs(Body.getAngularVelocity(body));
                    };
                    /**
     * Sets the current rotational speed of the body.
     * Direction is maintained. Affects body angular velocity.
     * @method setAngularSpeed
     * @param {body} body
     * @param {number} speed
     */ Body.setAngularSpeed = function(body, speed) {
                        Body.setAngularVelocity(body, Common.sign(Body.getAngularVelocity(body)) * speed);
                    };
                    /**
     * Moves a body by a given vector relative to its current position, without imparting any velocity.
     * @method translate
     * @param {body} body
     * @param {vector} translation
     * @param {boolean} [updateVelocity=false]
     */ Body.translate = function(body, translation, updateVelocity) {
                        Body.setPosition(body, Vector.add(body.position, translation), updateVelocity);
                    };
                    /**
     * Rotates a body by a given angle relative to its current angle, without imparting any angular velocity.
     * @method rotate
     * @param {body} body
     * @param {number} rotation
     * @param {vector} [point]
     * @param {boolean} [updateVelocity=false]
     */ Body.rotate = function(body, rotation, point, updateVelocity) {
                        if (!point) Body.setAngle(body, body.angle + rotation, updateVelocity);
                        else {
                            var cos = Math.cos(rotation), sin = Math.sin(rotation), dx = body.position.x - point.x, dy = body.position.y - point.y;
                            Body.setPosition(body, {
                                x: point.x + (dx * cos - dy * sin),
                                y: point.y + (dx * sin + dy * cos)
                            }, updateVelocity);
                            Body.setAngle(body, body.angle + rotation, updateVelocity);
                        }
                    };
                    /**
     * Scales the body, including updating physical properties (mass, area, axes, inertia), from a world-space point (default is body centre).
     * @method scale
     * @param {body} body
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} [point]
     */ Body.scale = function(body, scaleX, scaleY, point) {
                        var totalArea = 0, totalInertia = 0;
                        point = point || body.position;
                        var wasFixedRotation = body.inertia === Infinity ? true : false;
                        for(var i = 0; i < body.parts.length; i++){
                            var part = body.parts[i];
                            part.scale.x = scaleX;
                            part.scale.y = scaleY;
                            // scale vertices
                            Vertices.scale(part.vertices, scaleX, scaleY, point);
                            // update properties
                            part.axes = Axes.fromVertices(part.vertices);
                            part.area = Vertices.area(part.vertices);
                            Body.setMass(part, body.density * part.area);
                            // update inertia (requires vertices to be at origin)
                            Vertices.translate(part.vertices, {
                                x: -part.position.x,
                                y: -part.position.y
                            });
                            Body.setInertia(part, Body._inertiaScale * Vertices.inertia(part.vertices, part.mass));
                            Vertices.translate(part.vertices, {
                                x: part.position.x,
                                y: part.position.y
                            });
                            if (i > 0) {
                                totalArea += part.area;
                                totalInertia += part.inertia;
                            }
                            // scale position
                            part.position.x = point.x + (part.position.x - point.x) * scaleX;
                            part.position.y = point.y + (part.position.y - point.y) * scaleY;
                            // update bounds
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                        }
                        // handle parent body
                        if (body.parts.length > 1) {
                            body.area = totalArea;
                            if (!body.isStatic) {
                                Body.setMass(body, body.density * totalArea);
                                Body.setInertia(body, totalInertia);
                            }
                        }
                        // handle circles
                        if (body.circleRadius) {
                            if (scaleX === scaleY) body.circleRadius *= scaleX;
                            else // body is no longer a circle
                            body.circleRadius = null;
                        }
                        if (wasFixedRotation) Body.setInertia(body, Infinity);
                    };
                    /**
     * Performs a simulation step for the given `body`, including updating position and angle using Verlet integration.
     * @method update
     * @param {body} body
     * @param {number} deltaTime
     */ Body.update = function(body, deltaTime) {
                        deltaTime = (typeof deltaTime !== 'undefined' ? deltaTime : 1000 / 60) * body.timeScale;
                        var deltaTimeSquared = deltaTime * deltaTime, correction = Body._timeCorrection ? deltaTime / (body.deltaTime || deltaTime) : 1;
                        // from the previous step
                        var frictionAir = 1 - body.frictionAir * (deltaTime / Common._baseDelta), velocityPrevX = (body.position.x - body.positionPrev.x) * correction, velocityPrevY = (body.position.y - body.positionPrev.y) * correction;
                        // update velocity with Verlet integration
                        body.velocity.x = velocityPrevX * frictionAir + body.force.x / body.mass * deltaTimeSquared;
                        body.velocity.y = velocityPrevY * frictionAir + body.force.y / body.mass * deltaTimeSquared;
                        body.positionPrev.x = body.position.x;
                        body.positionPrev.y = body.position.y;
                        body.position.x += body.velocity.x;
                        body.position.y += body.velocity.y;
                        body.deltaTime = deltaTime;
                        // update angular velocity with Verlet integration
                        body.angularVelocity = (body.angle - body.anglePrev) * frictionAir * correction + body.torque / body.inertia * deltaTimeSquared;
                        body.anglePrev = body.angle;
                        body.angle += body.angularVelocity;
                        // track speed and acceleration
                        body.speed = Vector.magnitude(body.velocity);
                        body.angularSpeed = Math.abs(body.angularVelocity);
                        // transform the body geometry
                        for(var i = 0; i < body.parts.length; i++){
                            var part = body.parts[i];
                            Vertices.translate(part.vertices, body.velocity);
                            if (i > 0) {
                                part.position.x += body.velocity.x;
                                part.position.y += body.velocity.y;
                            }
                            if (body.angularVelocity !== 0) {
                                Vertices.rotate(part.vertices, body.angularVelocity, body.position);
                                Axes.rotate(part.axes, body.angularVelocity);
                                if (i > 0) Vector.rotateAbout(part.position, body.angularVelocity, body.position, part.position);
                            }
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                        }
                    };
                    /**
     * Updates properties `body.velocity`, `body.speed`, `body.angularVelocity` and `body.angularSpeed` which are normalised in relation to `Body._baseDelta`.
     * @method updateVelocities
     * @param {body} body
     */ Body.updateVelocities = function(body) {
                        var timeScale = Body._baseDelta / body.deltaTime, bodyVelocity = body.velocity;
                        bodyVelocity.x = (body.position.x - body.positionPrev.x) * timeScale;
                        bodyVelocity.y = (body.position.y - body.positionPrev.y) * timeScale;
                        body.speed = Math.sqrt(bodyVelocity.x * bodyVelocity.x + bodyVelocity.y * bodyVelocity.y);
                        body.angularVelocity = (body.angle - body.anglePrev) * timeScale;
                        body.angularSpeed = Math.abs(body.angularVelocity);
                    };
                    /**
     * Applies a force to a body from a given world-space position, including resulting torque.
     * @method applyForce
     * @param {body} body
     * @param {vector} position
     * @param {vector} force
     */ Body.applyForce = function(body, position, force) {
                        var offset = {
                            x: position.x - body.position.x,
                            y: position.y - body.position.y
                        };
                        body.force.x += force.x;
                        body.force.y += force.y;
                        body.torque += offset.x * force.y - offset.y * force.x;
                    };
                    /**
     * Returns the sums of the properties of all compound parts of the parent body.
     * @method _totalProperties
     * @private
     * @param {body} body
     * @return {}
     */ Body._totalProperties = function(body) {
                        // from equations at:
                        // https://ecourses.ou.edu/cgi-bin/ebook.cgi?doc=&topic=st&chap_sec=07.2&page=theory
                        // http://output.to/sideway/default.asp?qno=121100087
                        var properties = {
                            mass: 0,
                            area: 0,
                            inertia: 0,
                            centre: {
                                x: 0,
                                y: 0
                            }
                        };
                        // sum the properties of all compound parts of the parent body
                        for(var i = body.parts.length === 1 ? 0 : 1; i < body.parts.length; i++){
                            var part = body.parts[i], mass = part.mass !== Infinity ? part.mass : 1;
                            properties.mass += mass;
                            properties.area += part.area;
                            properties.inertia += part.inertia;
                            properties.centre = Vector.add(properties.centre, Vector.mult(part.position, mass));
                        }
                        properties.centre = Vector.div(properties.centre, properties.mass);
                        return properties;
                    };
                    /**
     * Wraps the `body` position such that it always stays within the given bounds.
     * Upon crossing a boundary the body will appear on the opposite side of the bounds,
     * while maintaining its velocity.
     * @function wrap
     * @param {body} body The body to wrap.
     * @param {Matter.Bounds} bounds The bounds to wrap the body inside.
     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
     */ Body.wrap = function(body, bounds) {
                        var translation = Bounds.wrap(body.bounds, bounds);
                        if (translation) Body.translate(body, translation);
                        return translation;
                    };
                /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a body starts sleeping (where `this` is the body).
    *
    * @event sleepStart
    * @this {body} The body that has started sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a body ends sleeping (where `this` is the body).
    *
    * @event sleepEnd
    * @this {body} The body that has ended sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Body.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "body"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Body"
     */ /**
     * An array of bodies that make up this body.
     * The first body in the array must always be a self reference to the current body instance.
     * All bodies in the `parts` array together form a single rigid compound body.
     * Parts are allowed to overlap, have gaps or holes or even form concave bodies.
     * Parts themselves should never be added to a `World`, only the parent body should be.
     * Use `Body.setParts` when setting parts to ensure correct updates of all properties.
     *
     * @property parts
     * @type body[]
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * A self reference if the body is _not_ a part of another body.
     * Otherwise this is a reference to the body that this is a part of.
     * See `body.parts`.
     *
     * @property parent
     * @type body
     */ /**
     * An object storing axis-aligned bounding boxes (AABB).
     *
     * @property wrapBounds
     * @type {}
     */ /**
     * An array of callback functions that will be called automatically
     * for every pair of bodies, on every engine update.
     *
     * @property attractors
     * @type Function[]
     */ /**
     * A `Number` specifying the angle of the body, in radians.
     *
     * @property angle
     * @type number
     * @default 0
     */ /**
     * An array of `Vector` objects that specify the convex hull of the rigid body.
     * These should be provided about the origin `(0, 0)`. E.g.
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * When passed via `Body.create`, the vertices are translated relative to `body.position` (i.e. world-space, and constantly updated by `Body.update` during simulation).
     * The `Vector` objects are also augmented with additional properties required for efficient collision detection.
     *
     * Other properties such as `inertia` and `bounds` are automatically calculated from the passed vertices (unless provided via `options`).
     * Concave hulls are not currently supported. The module `Matter.Vertices` contains useful methods for working with vertices.
     *
     * @property vertices
     * @type vector[]
     */ /**
     * A `Vector` that specifies the current world-space position of the body.
     *
     * @property position
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that holds the current scale values as set by `Body.setScale`.
     *
     * @property scale
     * @type vector
     * @default { x: 1, y: 1 }
     */ /**
     * A `Vector` that specifies the force to apply in the current step. It is zeroed after every `Body.update`. See also `Body.applyForce`.
     *
     * @property force
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the torque (turning force) to apply in the current step. It is zeroed after every `Body.update`.
     *
     * @property torque
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.velocity`).
     *
     * @readOnly
     * @property speed
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current angular speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.angularVelocity`).
     *
     * @readOnly
     * @property angularSpeed
     * @type number
     * @default 0
     */ /**
     * A `Vector` that _measures_ the current velocity of the body after the last `Body.update`. It is read-only.
     * If you need to modify a body's velocity directly, you should either apply a force or simply change the body's `position` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property velocity
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that _measures_ the current angular velocity of the body after the last `Body.update`. It is read-only.
     * If you need to modify a body's angular velocity directly, you should apply a torque or simply change the body's `angle` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property angularVelocity
     * @type number
     * @default 0
     */ /**
     * A flag that indicates whether a body is considered static. A static body can never change position or angle and is completely fixed.
     * If you need to set a body as static after its creation, you should use `Body.setStatic` as this requires more than just setting this flag.
     *
     * @property isStatic
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether a body is a sensor. Sensor triggers collision events, but doesn't react with colliding body physically.
     *
     * @property isSensor
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether the body is considered sleeping. A sleeping body acts similar to a static body, except it is only temporary and can be awoken.
     * If you need to set a body as sleeping, you should use `Sleeping.set` as this requires more than just setting this flag.
     *
     * @property isSleeping
     * @type boolean
     * @default false
     */ /**
     * A `Number` that _measures_ the amount of movement a body currently has (a combination of `speed` and `angularSpeed`). It is read-only and always positive.
     * It is used and updated by the `Matter.Sleeping` module during simulation to decide if a body has come to rest.
     *
     * @readOnly
     * @property motion
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping by the `Matter.Sleeping` module (if sleeping is enabled by the engine).
     *
     * @property sleepThreshold
     * @type number
     * @default 60
     */ /**
     * A `Number` that defines the density of the body, that is its mass per unit area.
     * If you pass the density via `Body.create` the `mass` property is automatically calculated for you based on the size (area) of the object.
     * This is generally preferable to simply setting mass and allows for more intuitive definition of materials (e.g. rock has a higher density than wood).
     *
     * @property density
     * @type number
     * @default 0.001
     */ /**
     * A `Number` that defines the mass of the body, although it may be more appropriate to specify the `density` property instead.
     * If you modify this value, you must also modify the `body.inverseMass` property (`1 / mass`).
     *
     * @property mass
     * @type number
     */ /**
     * A `Number` that defines the inverse mass of the body (`1 / mass`).
     * If you modify this value, you must also modify the `body.mass` property.
     *
     * @property inverseMass
     * @type number
     */ /**
     * A `Number` that defines the moment of inertia (i.e. second moment of area) of the body.
     * It is automatically calculated from the given convex hull (`vertices` array) and density in `Body.create`.
     * If you modify this value, you must also modify the `body.inverseInertia` property (`1 / inertia`).
     *
     * @property inertia
     * @type number
     */ /**
     * A `Number` that defines the inverse moment of inertia of the body (`1 / inertia`).
     * If you modify this value, you must also modify the `body.inertia` property.
     *
     * @property inverseInertia
     * @type number
     */ /**
     * A `Number` that defines the restitution (elasticity) of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means collisions may be perfectly inelastic and no bouncing may occur.
     * A value of `0.8` means the body may bounce back with approximately 80% of its kinetic energy.
     * Note that collision response is based on _pairs_ of bodies, and that `restitution` values are _combined_ with the following formula:
     *
     *     Math.max(bodyA.restitution, bodyB.restitution)
     *
     * @property restitution
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the friction of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means that the body may slide indefinitely.
     * A value of `1` means the body may come to a stop almost instantly after a force is applied.
     *
     * The effects of the value may be non-linear.
     * High values may be unstable depending on the body.
     * The engine uses a Coulomb friction model including static and kinetic friction.
     * Note that collision response is based on _pairs_ of bodies, and that `friction` values are _combined_ with the following formula:
     *
     *     Math.min(bodyA.friction, bodyB.friction)
     *
     * @property friction
     * @type number
     * @default 0.1
     */ /**
     * A `Number` that defines the static friction of the body (in the Coulomb friction model).
     * A value of `0` means the body will never 'stick' when it is nearly stationary and only dynamic `friction` is used.
     * The higher the value (e.g. `10`), the more force it will take to initially get the body moving when nearly stationary.
     * This value is multiplied with the `friction` property to make it easier to change `friction` and maintain an appropriate amount of static friction.
     *
     * @property frictionStatic
     * @type number
     * @default 0.5
     */ /**
     * A `Number` that defines the air friction of the body (air resistance).
     * A value of `0` means the body will never slow as it moves through space.
     * The higher the value, the faster a body slows when moving through space.
     * The effects of the value are non-linear.
     *
     * @property frictionAir
     * @type number
     * @default 0.01
     */ /**
     * An `Object` that specifies the collision filtering properties of this body.
     *
     * Collisions between two bodies will obey the following rules:
     * - If the two bodies have the same non-zero value of `collisionFilter.group`,
     *   they will always collide if the value is positive, and they will never collide
     *   if the value is negative.
     * - If the two bodies have different values of `collisionFilter.group` or if one
     *   (or both) of the bodies has a value of 0, then the category/mask rules apply as follows:
     *
     * Each body belongs to a collision category, given by `collisionFilter.category`. This
     * value is used as a bit field and the category should have only one bit set, meaning that
     * the value of this property is a power of two in the range [1, 2^31]. Thus, there are 32
     * different collision categories available.
     *
     * Each body also defines a collision bitmask, given by `collisionFilter.mask` which specifies
     * the categories it collides with (the value is the bitwise AND value of all these categories).
     *
     * Using the category/mask rules, two bodies `A` and `B` collide if each includes the other's
     * category in its mask, i.e. `(categoryA & maskB) !== 0` and `(categoryB & maskA) !== 0`
     * are both true.
     *
     * @property collisionFilter
     * @type object
     */ /**
     * An Integer `Number`, that specifies the collision group this body belongs to.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.group
     * @type object
     * @default 0
     */ /**
     * A bit field that specifies the collision category this body belongs to.
     * The category value should have only one bit set, for example `0x0001`.
     * This means there are up to 32 unique collision categories available.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.category
     * @type object
     * @default 1
     */ /**
     * A bit mask that specifies the collision categories this body may collide with.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.mask
     * @type object
     * @default -1
     */ /**
     * A `Number` that specifies a tolerance on how far a body is allowed to 'sink' or rotate into other bodies.
     * Avoid changing this value unless you understand the purpose of `slop` in physics engines.
     * The default should generally suffice, although very large bodies may require larger values for stable stacking.
     *
     * @property slop
     * @type number
     * @default 0.05
     */ /**
     * A `Number` that allows per-body time scaling, e.g. a force-field where bodies inside are in slow-motion, while others are at full speed.
     *
     * @property timeScale
     * @type number
     * @default 1
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the body should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * Sets the opacity to use when rendering.
     *
     * @property render.opacity
     * @type number
     * @default 1
    */ /**
     * An `Object` that defines the sprite properties to use when rendering, if any.
     *
     * @property render.sprite
     * @type object
     */ /**
      * A `Number` that defines the offset in the x-axis for the sprite (normalised by texture width).
      *
      * @property render.sprite.xOffset
      * @type number
      * @default 0
      */ /**
      * A `Number` that defines the offset in the y-axis for the sprite (normalised by texture height).
      *
      * @property render.sprite.yOffset
      * @type number
      * @default 0
      */ /**
     * A hex color value that defines the fill color to use when rendering the body.
     *
     * @property render.fillColor
     * @type number
     */ /**
     * A value that defines the fill opacity to use when rendering the body.
     *
     * @property render.fillOpacity
     * @type number
     */ /**
     * A hex color value that defines the line color to use when rendering the body.
     *
     * @property render.lineColor
     * @type number
     */ /**
     * A value that defines the line opacity to use when rendering the body.
     *
     * @property render.lineOpacity
     * @type number
     */ /**
     * A `Number` that defines the line width to use when rendering the body outline.
     *
     * @property render.lineThickness
     * @type number
     */ /**
     * An array of unique axis vectors (edge normals) used for collision detection.
     * These are automatically calculated from the given convex hull (`vertices` array) in `Body.create`.
     * They are constantly updated by `Body.update` during the simulation.
     *
     * @property axes
     * @type vector[]
     */ /**
     * A `Number` that _measures_ the area of the body's convex hull, calculated at creation by `Body.create`.
     *
     * @property area
     * @type string
     * @default
     */ /**
     * A `Bounds` object that defines the AABB region for the body.
     * It is automatically calculated from the given convex hull (`vertices` array) in `Body.create` and constantly updated by `Body.update` during simulation.
     *
     * @property bounds
     * @type bounds
     */ /**
     * A reference to the Phaser Game Object this body belongs to, if any.
     *
     * @property gameObject
     * @type Phaser.GameObjects.GameObject
     */ /**
     * The center of mass of the Body.
     *
     * @property centerOfMass
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * The center of the body in pixel values.
     * Used by Phaser for texture aligment.
     *
     * @property centerOffset
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * Will this Body ignore World gravity during the Engine update?
     *
     * @property ignoreGravity
     * @type boolean
     * @default false
     */ /**
     * Scale the influence of World gravity when applied to this body.
     *
     * @property gravityScale
     * @type vector
     * @default { x: 1, y: 1 }
     */ /**
     * Will this Body ignore Phaser Pointer input events?
     *
     * @property ignorePointer
     * @type boolean
     * @default false
     */ /**
     * A callback that is invoked when this Body starts colliding with any other Body.
     *
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideCallback
     * @type function
     * @default null
     */ /**
     * A callback that is invoked when this Body stops colliding with any other Body.
     *
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideEndCallback
     * @type function
     * @default null
     */ /**
     * A callback that is invoked for the duration that this Body is colliding with any other Body.
     *
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideActiveCallback
     * @type function
     * @default null
     */ /**
     * A collision callback dictionary used by the `Body.setOnCollideWith` function.
     *
     * @property onCollideWith
     * @type object
     * @default null
     */ })();
            /***/ },
            /***/ 69351: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
* A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
* It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
* Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composite
*/ var Composite = {};
                module1.exports = Composite;
                var Events = __webpack_require__(35810);
                var Common = __webpack_require__(53402);
                var Bounds = __webpack_require__(15647);
                var Body = __webpack_require__(22562);
                (function() {
                    /**
     * Creates a new composite. The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properites section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} [options]
     * @return {composite} A new composite
     */ Composite.create = function(options) {
                        return Common.extend({
                            id: Common.nextId(),
                            type: 'composite',
                            parent: null,
                            isModified: false,
                            bodies: [],
                            constraints: [],
                            composites: [],
                            label: 'Composite',
                            plugin: {},
                            wrapBounds: null,
                            cache: {
                                allBodies: null,
                                allConstraints: null,
                                allComposites: null
                            }
                        }, options);
                    };
                    /**
     * Sets the composite's `isModified` flag. 
     * If `updateParents` is true, all parents will be set (default: false).
     * If `updateChildren` is true, all children will be set (default: false).
     * @method setModified
     * @param {composite} composite
     * @param {boolean} isModified
     * @param {boolean} [updateParents=false]
     * @param {boolean} [updateChildren=false]
     */ Composite.setModified = function(composite, isModified, updateParents, updateChildren) {
                        Events.trigger(composite, 'compositeModified', composite);
                        composite.isModified = isModified;
                        if (isModified && composite.cache) {
                            composite.cache.allBodies = null;
                            composite.cache.allConstraints = null;
                            composite.cache.allComposites = null;
                        }
                        if (updateParents && composite.parent) Composite.setModified(composite.parent, isModified, updateParents, updateChildren);
                        if (updateChildren) for(var i = 0; i < composite.composites.length; i++){
                            var childComposite = composite.composites[i];
                            Composite.setModified(childComposite, isModified, updateParents, updateChildren);
                        }
                    };
                    /**
     * Generic single or multi-add function. Adds a single or an array of body(s), constraint(s) or composite(s) to the given composite.
     * Triggers `beforeAdd` and `afterAdd` events on the `composite`.
     * @method add
     * @param {composite} composite
     * @param {object|array} object A single or an array of body(s), constraint(s) or composite(s)
     * @return {composite} The original composite with the objects added
     */ Composite.add = function(composite, object) {
                        var objects = [].concat(object);
                        Events.trigger(composite, 'beforeAdd', {
                            object: object
                        });
                        for(var i = 0; i < objects.length; i++){
                            var obj = objects[i];
                            switch(obj.type){
                                case 'body':
                                    // skip adding compound parts
                                    if (obj.parent !== obj) {
                                        Common.warn('Composite.add: skipped adding a compound body part (you must add its parent instead)');
                                        break;
                                    }
                                    Composite.addBody(composite, obj);
                                    break;
                                case 'constraint':
                                    Composite.addConstraint(composite, obj);
                                    break;
                                case 'composite':
                                    Composite.addComposite(composite, obj);
                                    break;
                                case 'mouseConstraint':
                                    Composite.addConstraint(composite, obj.constraint);
                                    break;
                            }
                        }
                        Events.trigger(composite, 'afterAdd', {
                            object: object
                        });
                        return composite;
                    };
                    /**
     * Generic remove function. Removes one or many body(s), constraint(s) or a composite(s) to the given composite.
     * Optionally searching its children recursively.
     * Triggers `beforeRemove` and `afterRemove` events on the `composite`.
     * @method remove
     * @param {composite} composite
     * @param {object|array} object
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the objects removed
     */ Composite.remove = function(composite, object, deep) {
                        var objects = [].concat(object);
                        Events.trigger(composite, 'beforeRemove', {
                            object: object
                        });
                        for(var i = 0; i < objects.length; i++){
                            var obj = objects[i];
                            switch(obj.type){
                                case 'body':
                                    Composite.removeBody(composite, obj, deep);
                                    break;
                                case 'constraint':
                                    Composite.removeConstraint(composite, obj, deep);
                                    break;
                                case 'composite':
                                    Composite.removeComposite(composite, obj, deep);
                                    break;
                                case 'mouseConstraint':
                                    Composite.removeConstraint(composite, obj.constraint);
                                    break;
                            }
                        }
                        Events.trigger(composite, 'afterRemove', {
                            object: object
                        });
                        return composite;
                    };
                    /**
     * Adds a composite to the given composite.
     * @private
     * @method addComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @return {composite} The original compositeA with the objects from compositeB added
     */ Composite.addComposite = function(compositeA, compositeB) {
                        compositeA.composites.push(compositeB);
                        compositeB.parent = compositeA;
                        Composite.setModified(compositeA, true, true, false);
                        return compositeA;
                    };
                    /**
     * Removes a composite from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @param {boolean} [deep=false]
     * @return {composite} The original compositeA with the composite removed
     */ Composite.removeComposite = function(compositeA, compositeB, deep) {
                        var position = Common.indexOf(compositeA.composites, compositeB);
                        if (position !== -1) {
                            var bodies = Composite.allBodies(compositeB);
                            Composite.removeCompositeAt(compositeA, position);
                            for(var i = 0; i < bodies.length; i++)bodies[i].sleepCounter = 0;
                        }
                        if (deep) for(var i = 0; i < compositeA.composites.length; i++)Composite.removeComposite(compositeA.composites[i], compositeB, true);
                        return compositeA;
                    };
                    /**
     * Removes a composite from the given composite.
     * @private
     * @method removeCompositeAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the composite removed
     */ Composite.removeCompositeAt = function(composite, position) {
                        composite.composites.splice(position, 1);
                        Composite.setModified(composite, true, true, false);
                        return composite;
                    };
                    /**
     * Adds a body to the given composite.
     * @private
     * @method addBody
     * @param {composite} composite
     * @param {body} body
     * @return {composite} The original composite with the body added
     */ Composite.addBody = function(composite, body) {
                        composite.bodies.push(body);
                        Composite.setModified(composite, true, true, false);
                        return composite;
                    };
                    /**
     * Removes a body from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeBody
     * @param {composite} composite
     * @param {body} body
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the body removed
     */ Composite.removeBody = function(composite, body, deep) {
                        var position = Common.indexOf(composite.bodies, body);
                        if (position !== -1) {
                            Composite.removeBodyAt(composite, position);
                            body.sleepCounter = 0;
                        }
                        if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeBody(composite.composites[i], body, true);
                        return composite;
                    };
                    /**
     * Removes a body from the given composite.
     * @private
     * @method removeBodyAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the body removed
     */ Composite.removeBodyAt = function(composite, position) {
                        composite.bodies.splice(position, 1);
                        Composite.setModified(composite, true, true, false);
                        return composite;
                    };
                    /**
     * Adds a constraint to the given composite.
     * @private
     * @method addConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @return {composite} The original composite with the constraint added
     */ Composite.addConstraint = function(composite, constraint) {
                        composite.constraints.push(constraint);
                        Composite.setModified(composite, true, true, false);
                        return composite;
                    };
                    /**
     * Removes a constraint from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraint = function(composite, constraint, deep) {
                        var position = Common.indexOf(composite.constraints, constraint);
                        if (position !== -1) Composite.removeConstraintAt(composite, position);
                        if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeConstraint(composite.composites[i], constraint, true);
                        return composite;
                    };
                    /**
     * Removes a body from the given composite.
     * @private
     * @method removeConstraintAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraintAt = function(composite, position) {
                        composite.constraints.splice(position, 1);
                        Composite.setModified(composite, true, true, false);
                        return composite;
                    };
                    /**
     * Removes all bodies, constraints and composites from the given composite.
     * Optionally clearing its children recursively.
     * @method clear
     * @param {composite} composite
     * @param {boolean} keepStatic
     * @param {boolean} [deep=false]
     */ Composite.clear = function(composite, keepStatic, deep) {
                        if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.clear(composite.composites[i], keepStatic, true);
                        if (keepStatic) composite.bodies = composite.bodies.filter(function(body) {
                            return body.isStatic;
                        });
                        else composite.bodies.length = 0;
                        composite.constraints.length = 0;
                        composite.composites.length = 0;
                        Composite.setModified(composite, true, true, false);
                        return composite;
                    };
                    /**
     * Returns all bodies in the given composite, including all bodies in its children, recursively.
     * @method allBodies
     * @param {composite} composite
     * @return {body[]} All the bodies
     */ Composite.allBodies = function(composite) {
                        if (composite.cache && composite.cache.allBodies) return composite.cache.allBodies;
                        var bodies = [].concat(composite.bodies);
                        for(var i = 0; i < composite.composites.length; i++)bodies = bodies.concat(Composite.allBodies(composite.composites[i]));
                        if (composite.cache) composite.cache.allBodies = bodies;
                        return bodies;
                    };
                    /**
     * Returns all constraints in the given composite, including all constraints in its children, recursively.
     * @method allConstraints
     * @param {composite} composite
     * @return {constraint[]} All the constraints
     */ Composite.allConstraints = function(composite) {
                        if (composite.cache && composite.cache.allConstraints) return composite.cache.allConstraints;
                        var constraints = [].concat(composite.constraints);
                        for(var i = 0; i < composite.composites.length; i++)constraints = constraints.concat(Composite.allConstraints(composite.composites[i]));
                        if (composite.cache) composite.cache.allConstraints = constraints;
                        return constraints;
                    };
                    /**
     * Returns all composites in the given composite, including all composites in its children, recursively.
     * @method allComposites
     * @param {composite} composite
     * @return {composite[]} All the composites
     */ Composite.allComposites = function(composite) {
                        if (composite.cache && composite.cache.allComposites) return composite.cache.allComposites;
                        var composites = [].concat(composite.composites);
                        for(var i = 0; i < composite.composites.length; i++)composites = composites.concat(Composite.allComposites(composite.composites[i]));
                        if (composite.cache) composite.cache.allComposites = composites;
                        return composites;
                    };
                    /**
     * Searches the composite recursively for an object matching the type and id supplied, null if not found.
     * @method get
     * @param {composite} composite
     * @param {number} id
     * @param {string} type
     * @return {object} The requested object, if found
     */ Composite.get = function(composite, id, type) {
                        var objects, object;
                        switch(type){
                            case 'body':
                                objects = Composite.allBodies(composite);
                                break;
                            case 'constraint':
                                objects = Composite.allConstraints(composite);
                                break;
                            case 'composite':
                                objects = Composite.allComposites(composite).concat(composite);
                                break;
                        }
                        if (!objects) return null;
                        object = objects.filter(function(object) {
                            return object.id.toString() === id.toString();
                        });
                        return object.length === 0 ? null : object[0];
                    };
                    /**
     * Moves the given object(s) from compositeA to compositeB (equal to a remove followed by an add).
     * @method move
     * @param {compositeA} compositeA
     * @param {object[]} objects
     * @param {compositeB} compositeB
     * @return {composite} Returns compositeA
     */ Composite.move = function(compositeA, objects, compositeB) {
                        Composite.remove(compositeA, objects);
                        Composite.add(compositeB, objects);
                        return compositeA;
                    };
                    /**
     * Assigns new ids for all objects in the composite, recursively.
     * @method rebase
     * @param {composite} composite
     * @return {composite} Returns composite
     */ Composite.rebase = function(composite) {
                        var objects = Composite.allBodies(composite).concat(Composite.allConstraints(composite)).concat(Composite.allComposites(composite));
                        for(var i = 0; i < objects.length; i++)objects[i].id = Common.nextId();
                        return composite;
                    };
                    /**
     * Translates all children in the composite by a given vector relative to their current positions, 
     * without imparting any velocity.
     * @method translate
     * @param {composite} composite
     * @param {vector} translation
     * @param {bool} [recursive=true]
     */ Composite.translate = function(composite, translation, recursive) {
                        var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                        for(var i = 0; i < bodies.length; i++)Body.translate(bodies[i], translation);
                        return composite;
                    };
                    /**
     * Rotates all children in the composite by a given angle about the given point, without imparting any angular velocity.
     * @method rotate
     * @param {composite} composite
     * @param {number} rotation
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.rotate = function(composite, rotation, point, recursive) {
                        var cos = Math.cos(rotation), sin = Math.sin(rotation), bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                            Body.setPosition(body, {
                                x: point.x + (dx * cos - dy * sin),
                                y: point.y + (dx * sin + dy * cos)
                            });
                            Body.rotate(body, rotation);
                        }
                        return composite;
                    };
                    /**
     * Scales all children in the composite, including updating physical properties (mass, area, axes, inertia), from a world-space point.
     * @method scale
     * @param {composite} composite
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.scale = function(composite, scaleX, scaleY, point, recursive) {
                        var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                            Body.setPosition(body, {
                                x: point.x + dx * scaleX,
                                y: point.y + dy * scaleY
                            });
                            Body.scale(body, scaleX, scaleY);
                        }
                        return composite;
                    };
                    /**
     * Returns the union of the bounds of all of the composite's bodies.
     * @method bounds
     * @param {composite} composite The composite.
     * @returns {bounds} The composite bounds.
     */ Composite.bounds = function(composite) {
                        var bodies = Composite.allBodies(composite), vertices = [];
                        for(var i = 0; i < bodies.length; i += 1){
                            var body = bodies[i];
                            vertices.push(body.bounds.min, body.bounds.max);
                        }
                        return Bounds.create(vertices);
                    };
                    /**
     * Wraps the `composite` position such that it always stays within the given bounds.
     * Upon crossing a boundary the composite will appear on the opposite side of the bounds,
     * while maintaining its velocity.
     * This is called automatically by the plugin.
     * @function wrap
     * @param {composite} composite The composite to wrap.
     * @param {bounds} bounds The bounds to wrap the composite inside.
     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
     */ Composite.wrap = function(composite, bounds) {
                        var translation = Bounds.wrap(Composite.bounds(composite), bounds);
                        if (translation) Composite.translate(composite, translation);
                        return translation;
                    };
                /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a call to `Composite.add` is made, before objects have been added.
    *
    * @event beforeAdd
    * @param {} event An event object
    * @param {} event.object The object(s) to be added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.add` is made, after objects have been added.
    *
    * @event afterAdd
    * @param {} event An event object
    * @param {} event.object The object(s) that have been added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, before objects have been removed.
    *
    * @event beforeRemove
    * @param {} event An event object
    * @param {} event.object The object(s) to be removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, after objects have been removed.
    *
    * @event afterRemove
    * @param {} event An event object
    * @param {} event.object The object(s) that have been removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "composite"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage composites.
     *
     * @property label
     * @type string
     * @default "Composite"
     */ /**
     * A flag that specifies whether the composite has been modified during the current step.
     * Most `Matter.Composite` methods will automatically set this flag to `true` to inform the engine of changes to be handled.
     * If you need to change it manually, you should use the `Composite.setModified` method.
     *
     * @property isModified
     * @type boolean
     * @default false
     */ /**
     * The `Composite` that is the parent of this composite. It is automatically managed by the `Matter.Composite` methods.
     *
     * @property parent
     * @type composite
     * @default null
     */ /**
     * An array of `Body` that are _direct_ children of this composite.
     * To add or remove bodies you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allBodies` method.
     *
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * An array of `Constraint` that are _direct_ children of this composite.
     * To add or remove constraints you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allConstraints` method.
     *
     * @property constraints
     * @type constraint[]
     * @default []
     */ /**
     * An array of `Composite` that are _direct_ children of this composite.
     * To add or remove composites you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allComposites` method.
     *
     * @property composites
     * @type composite[]
     * @default []
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * An object storing axis-aligned bounding boxes (AABB).
     *
     * @property wrapBounds
     * @type {}
     */ /**
     * An object used for storing cached results for performance reasons.
     * This is used internally only and is automatically managed.
     *
     * @private
     * @property cache
     * @type {}
     */ })();
            /***/ },
            /***/ 4372: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* This module has now been replaced by `Matter.Composite`.
*
* All usage should be migrated to the equivalent functions found on `Matter.Composite`.
* For example `World.add(world, body)` now becomes `Composite.add(world, body)`.
*
* The property `world.gravity` has been moved to `engine.gravity`.
*
* For back-compatibility purposes this module will remain as a direct alias to `Matter.Composite` in the short term during migration.
* Eventually this alias module will be marked as deprecated and then later removed in a future release.
*
* @class World
* @extends Composite
*/ var World = {};
                module1.exports = World;
                var Composite = __webpack_require__(69351);
                (function() {
                    /**
     * See above, aliases for back compatibility only
     */ World.create = Composite.create;
                    World.add = Composite.add;
                    World.remove = Composite.remove;
                    World.clear = Composite.clear;
                    World.addComposite = Composite.addComposite;
                    World.addBody = Composite.addBody;
                    World.addConstraint = Composite.addConstraint;
                /*
    *
    *  Properties Documentation
    *
    */ /**
     * The gravity to apply on the world.
     *
     * @property gravity
     * @type object
     */ /**
     * The gravity x component.
     *
     * @property gravity.x
     * @type object
     * @default 0
     */ /**
     * The gravity y component.
     *
     * @property gravity.y
     * @type object
     * @default 1
     */ /**
     * The gravity scale factor.
     *
     * @property gravity.scale
     * @type object
     * @default 0.001
     */ /**
     * A `Bounds` object that defines the world bounds for collision detection.
     *
     * @property bounds
     * @type bounds
     * @default { min: { x: -Infinity, y: -Infinity }, max: { x: Infinity, y: Infinity } }
     */ // World is a Composite body
                // see src/module/Outro.js for these aliases:
                /**
     * An alias for Composite.add
     * @method add
     * @param {world} world
     * @param {} object
     * @return {composite} The original world with the objects added
     */ /**
     * An alias for Composite.remove
     * @method remove
     * @param {world} world
     * @param {} object
     * @param {boolean} [deep=false]
     * @return {composite} The original world with the objects removed
     */ /**
     * An alias for Composite.clear
     * @method clear
     * @param {world} world
     * @param {boolean} keepStatic
     */ /**
     * An alias for Composite.addComposite
     * @method addComposite
     * @param {world} world
     * @param {composite} composite
     * @return {world} The original world with the objects from composite added
     */ /**
      * An alias for Composite.addBody
      * @method addBody
      * @param {world} world
      * @param {body} body
      * @return {world} The original world with the body added
      */ /**
      * An alias for Composite.addConstraint
      * @method addConstraint
      * @param {world} world
      * @param {constraint} constraint
      * @return {world} The original world with the constraint added
      */ })();
            /***/ },
            /***/ 52284: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Collision` module contains methods for detecting collisions between a given pair of bodies.
*
* For efficient detection between a list of bodies, see `Matter.Detector` and `Matter.Query`.
*
* See `Matter.Engine` for collision events.
*
* @class Collision
*/ var Collision = {};
                module1.exports = Collision;
                var Vertices = __webpack_require__(41598);
                var Pair = __webpack_require__(4506);
                (function() {
                    var _supports = [];
                    var _overlapAB = {
                        overlap: 0,
                        axis: null
                    };
                    var _overlapBA = {
                        overlap: 0,
                        axis: null
                    };
                    /**
     * Creates a new collision record.
     * @method create
     * @param {body} bodyA The first body part represented by the collision record
     * @param {body} bodyB The second body part represented by the collision record
     * @return {collision} A new collision record
     */ Collision.create = function(bodyA, bodyB) {
                        return {
                            pair: null,
                            collided: false,
                            bodyA: bodyA,
                            bodyB: bodyB,
                            parentA: bodyA.parent,
                            parentB: bodyB.parent,
                            depth: 0,
                            normal: {
                                x: 0,
                                y: 0
                            },
                            tangent: {
                                x: 0,
                                y: 0
                            },
                            penetration: {
                                x: 0,
                                y: 0
                            },
                            supports: [
                                null,
                                null
                            ],
                            supportCount: 0
                        };
                    };
                    /**
     * Detect collision between two bodies.
     * @method collides
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {pairs} [pairs] Optionally reuse collision records from existing pairs.
     * @return {collision|null} A collision record if detected, otherwise null
     */ Collision.collides = function(bodyA, bodyB, pairs) {
                        Collision._overlapAxes(_overlapAB, bodyA.vertices, bodyB.vertices, bodyA.axes);
                        if (_overlapAB.overlap <= 0) return null;
                        Collision._overlapAxes(_overlapBA, bodyB.vertices, bodyA.vertices, bodyB.axes);
                        if (_overlapBA.overlap <= 0) return null;
                        // reuse collision records for gc efficiency
                        var pair = pairs && pairs.table[Pair.id(bodyA, bodyB)], collision;
                        if (!pair) {
                            collision = Collision.create(bodyA, bodyB);
                            collision.collided = true;
                            collision.bodyA = bodyA.id < bodyB.id ? bodyA : bodyB;
                            collision.bodyB = bodyA.id < bodyB.id ? bodyB : bodyA;
                            collision.parentA = collision.bodyA.parent;
                            collision.parentB = collision.bodyB.parent;
                        } else collision = pair.collision;
                        bodyA = collision.bodyA;
                        bodyB = collision.bodyB;
                        var minOverlap;
                        if (_overlapAB.overlap < _overlapBA.overlap) minOverlap = _overlapAB;
                        else minOverlap = _overlapBA;
                        var normal = collision.normal, tangent = collision.tangent, penetration = collision.penetration, supports = collision.supports, depth = minOverlap.overlap, minAxis = minOverlap.axis, normalX = minAxis.x, normalY = minAxis.y, deltaX = bodyB.position.x - bodyA.position.x, deltaY = bodyB.position.y - bodyA.position.y;
                        // ensure normal is facing away from bodyA
                        if (normalX * deltaX + normalY * deltaY >= 0) {
                            normalX = -normalX;
                            normalY = -normalY;
                        }
                        normal.x = normalX;
                        normal.y = normalY;
                        tangent.x = -normalY;
                        tangent.y = normalX;
                        penetration.x = normalX * depth;
                        penetration.y = normalY * depth;
                        collision.depth = depth;
                        // find support points, there is always either exactly one or two
                        var supportsB = Collision._findSupports(bodyA, bodyB, normal, 1), supportCount = 0;
                        // find the supports from bodyB that are inside bodyA
                        if (Vertices.contains(bodyA.vertices, supportsB[0])) supports[supportCount++] = supportsB[0];
                        if (Vertices.contains(bodyA.vertices, supportsB[1])) supports[supportCount++] = supportsB[1];
                        // find the supports from bodyA that are inside bodyB
                        if (supportCount < 2) {
                            var supportsA = Collision._findSupports(bodyB, bodyA, normal, -1);
                            if (Vertices.contains(bodyB.vertices, supportsA[0])) supports[supportCount++] = supportsA[0];
                            if (supportCount < 2 && Vertices.contains(bodyB.vertices, supportsA[1])) supports[supportCount++] = supportsA[1];
                        }
                        // account for the edge case of overlapping but no vertex containment
                        if (supportCount === 0) supports[supportCount++] = supportsB[0];
                        // update supports array size
                        collision.supportCount = supportCount;
                        return collision;
                    };
                    /**
     * Find the overlap between two sets of vertices.
     * @method _overlapAxes
     * @private
     * @param {object} result
     * @param {vertices} verticesA
     * @param {vertices} verticesB
     * @param {axes} axes
     */ Collision._overlapAxes = function(result, verticesA, verticesB, axes) {
                        var verticesALength = verticesA.length, verticesBLength = verticesB.length, verticesAX = verticesA[0].x, verticesAY = verticesA[0].y, verticesBX = verticesB[0].x, verticesBY = verticesB[0].y, axesLength = axes.length, overlapMin = Number.MAX_VALUE, overlapAxisNumber = 0, overlap, overlapAB, overlapBA, dot, i, j;
                        for(i = 0; i < axesLength; i++){
                            var axis = axes[i], axisX = axis.x, axisY = axis.y, minA = verticesAX * axisX + verticesAY * axisY, minB = verticesBX * axisX + verticesBY * axisY, maxA = minA, maxB = minB;
                            for(j = 1; j < verticesALength; j += 1){
                                dot = verticesA[j].x * axisX + verticesA[j].y * axisY;
                                if (dot > maxA) maxA = dot;
                                else if (dot < minA) minA = dot;
                            }
                            for(j = 1; j < verticesBLength; j += 1){
                                dot = verticesB[j].x * axisX + verticesB[j].y * axisY;
                                if (dot > maxB) maxB = dot;
                                else if (dot < minB) minB = dot;
                            }
                            overlapAB = maxA - minB;
                            overlapBA = maxB - minA;
                            overlap = overlapAB < overlapBA ? overlapAB : overlapBA;
                            if (overlap < overlapMin) {
                                overlapMin = overlap;
                                overlapAxisNumber = i;
                                if (overlap <= 0) break;
                            }
                        }
                        result.axis = axes[overlapAxisNumber];
                        result.overlap = overlapMin;
                    };
                    /**
     * Finds supporting vertices given two bodies along a given direction using hill-climbing.
     * @method _findSupports
     * @private
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {vector} normal
     * @param {number} direction
     * @return [vector]
     */ Collision._findSupports = function(bodyA, bodyB, normal, direction) {
                        var vertices = bodyB.vertices, verticesLength = vertices.length, bodyAPositionX = bodyA.position.x, bodyAPositionY = bodyA.position.y, normalX = normal.x * direction, normalY = normal.y * direction, vertexA = vertices[0], vertexB = vertexA, nearestDistance = normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y), vertexC, distance, j;
                        // find deepest vertex relative to the axis
                        for(j = 1; j < verticesLength; j += 1){
                            vertexB = vertices[j];
                            distance = normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y);
                            // convex hill-climbing
                            if (distance < nearestDistance) {
                                nearestDistance = distance;
                                vertexA = vertexB;
                            }
                        }
                        // measure next vertex
                        vertexC = vertices[(verticesLength + vertexA.index - 1) % verticesLength];
                        nearestDistance = normalX * (bodyAPositionX - vertexC.x) + normalY * (bodyAPositionY - vertexC.y);
                        // compare with previous vertex
                        vertexB = vertices[(vertexA.index + 1) % verticesLength];
                        if (normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y) < nearestDistance) {
                            _supports[0] = vertexA;
                            _supports[1] = vertexB;
                            return _supports;
                        }
                        _supports[0] = vertexA;
                        _supports[1] = vertexC;
                        return _supports;
                    };
                /*
    *
    *  Properties Documentation
    *
    */ /**
     * A reference to the pair using this collision record, if there is one.
     *
     * @property pair
     * @type {pair|null}
     * @default null
     */ /**
     * A flag that indicates if the bodies were colliding when the collision was last updated.
     * 
     * @property collided
     * @type boolean
     * @default false
     */ /**
     * The first body part represented by the collision (see also `collision.parentA`).
     * 
     * @property bodyA
     * @type body
     */ /**
     * The second body part represented by the collision (see also `collision.parentB`).
     * 
     * @property bodyB
     * @type body
     */ /**
     * The first body represented by the collision (i.e. `collision.bodyA.parent`).
     * 
     * @property parentA
     * @type body
     */ /**
     * The second body represented by the collision (i.e. `collision.bodyB.parent`).
     * 
     * @property parentB
     * @type body
     */ /**
     * A `Number` that represents the minimum separating distance between the bodies along the collision normal.
     *
     * @readOnly
     * @property depth
     * @type number
     * @default 0
     */ /**
     * A normalised `Vector` that represents the direction between the bodies that provides the minimum separating distance.
     *
     * @property normal
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A normalised `Vector` that is the tangent direction to the collision normal.
     *
     * @property tangent
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that represents the direction and depth of the collision.
     *
     * @property penetration
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * An array of body vertices that represent the support points in the collision.
     * These are the deepest vertices (along the collision normal) of each body that are contained by the other body's vertices.
     *
     * @property supports
     * @type vector[]
     * @default []
     */ })();
            /***/ },
            /***/ 43424: /***/ (module1)=>{
                /**
* The `Matter.Contact` module contains methods for creating and manipulating collision contacts.
*
* @class Contact
*/ var Contact = {};
                module1.exports = Contact;
                (function() {
                    /**
     * Creates a new contact.
     * @method create
     * @param {vertex} vertex
     * @return {contact} A new contact
     */ Contact.create = function(vertex) {
                        return {
                            vertex: vertex,
                            normalImpulse: 0,
                            tangentImpulse: 0
                        };
                    };
                })();
            /***/ },
            /***/ 81388: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Detector` module contains methods for efficiently detecting collisions between a list of bodies using a broadphase algorithm.
*
* @class Detector
*/ var Detector = {};
                module1.exports = Detector;
                var Common = __webpack_require__(53402);
                var Collision = __webpack_require__(52284);
                (function() {
                    /**
     * Creates a new collision detector.
     * @method create
     * @param {} options
     * @return {detector} A new collision detector
     */ Detector.create = function(options) {
                        var defaults = {
                            bodies: [],
                            collisions: [],
                            pairs: null
                        };
                        return Common.extend(defaults, options);
                    };
                    /**
     * Sets the list of bodies in the detector.
     * @method setBodies
     * @param {detector} detector
     * @param {body[]} bodies
     */ Detector.setBodies = function(detector, bodies) {
                        detector.bodies = bodies.slice(0);
                    };
                    /**
     * Clears the detector including its list of bodies.
     * @method clear
     * @param {detector} detector
     */ Detector.clear = function(detector) {
                        detector.bodies = [];
                        detector.collisions = [];
                    };
                    /**
     * Efficiently finds all collisions among all the bodies in `detector.bodies` using a broadphase algorithm.
     * 
     * _Note:_ The specific ordering of collisions returned is not guaranteed between releases and may change for performance reasons.
     * If a specific ordering is required then apply a sort to the resulting array.
     * @method collisions
     * @param {detector} detector
     * @return {collision[]} collisions
     */ Detector.collisions = function(detector) {
                        var pairs = detector.pairs, bodies = detector.bodies, bodiesLength = bodies.length, canCollide = Detector.canCollide, collides = Collision.collides, collisions = detector.collisions, collisionIndex = 0, i, j;
                        bodies.sort(Detector._compareBoundsX);
                        for(i = 0; i < bodiesLength; i++){
                            var bodyA = bodies[i], boundsA = bodyA.bounds, boundXMax = bodyA.bounds.max.x, boundYMax = bodyA.bounds.max.y, boundYMin = bodyA.bounds.min.y, bodyAStatic = bodyA.isStatic || bodyA.isSleeping, partsALength = bodyA.parts.length, partsASingle = partsALength === 1;
                            for(j = i + 1; j < bodiesLength; j++){
                                var bodyB = bodies[j], boundsB = bodyB.bounds;
                                if (boundsB.min.x > boundXMax) break;
                                if (boundYMax < boundsB.min.y || boundYMin > boundsB.max.y) continue;
                                if (bodyAStatic && (bodyB.isStatic || bodyB.isSleeping)) continue;
                                if (!canCollide(bodyA.collisionFilter, bodyB.collisionFilter)) continue;
                                var partsBLength = bodyB.parts.length;
                                if (partsASingle && partsBLength === 1) {
                                    var collision = collides(bodyA, bodyB, pairs);
                                    if (collision) collisions[collisionIndex++] = collision;
                                } else {
                                    var partsAStart = partsALength > 1 ? 1 : 0, partsBStart = partsBLength > 1 ? 1 : 0;
                                    for(var k = partsAStart; k < partsALength; k++){
                                        var partA = bodyA.parts[k], boundsA = partA.bounds;
                                        for(var z = partsBStart; z < partsBLength; z++){
                                            var partB = bodyB.parts[z], boundsB = partB.bounds;
                                            if (boundsA.min.x > boundsB.max.x || boundsA.max.x < boundsB.min.x || boundsA.max.y < boundsB.min.y || boundsA.min.y > boundsB.max.y) continue;
                                            var collision = collides(partA, partB, pairs);
                                            if (collision) collisions[collisionIndex++] = collision;
                                        }
                                    }
                                }
                            }
                        }
                        if (collisions.length !== collisionIndex) collisions.length = collisionIndex;
                        return collisions;
                    };
                    /**
     * Returns `true` if both supplied collision filters will allow a collision to occur.
     * See `body.collisionFilter` for more information.
     * @method canCollide
     * @param {} filterA
     * @param {} filterB
     * @return {bool} `true` if collision can occur
     */ Detector.canCollide = function(filterA, filterB) {
                        if (filterA.group === filterB.group && filterA.group !== 0) return filterA.group > 0;
                        return (filterA.mask & filterB.category) !== 0 && (filterB.mask & filterA.category) !== 0;
                    };
                    /**
     * The comparison function used in the broadphase algorithm.
     * Returns the signed delta of the bodies bounds on the x-axis.
     * @private
     * @method _sortCompare
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {number} The signed delta used for sorting
     */ Detector._compareBoundsX = function(bodyA, bodyB) {
                        return bodyA.bounds.min.x - bodyB.bounds.min.x;
                    };
                /*
    *
    *  Properties Documentation
    *
    */ /**
     * The array of `Matter.Body` between which the detector finds collisions.
     * 
     * _Note:_ The order of bodies in this array _is not fixed_ and will be continually managed by the detector.
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * The array of `Matter.Collision` found in the last call to `Detector.collisions` on this detector.
     * @property collisions
     * @type collision[]
     * @default []
     */ /**
     * Optional. A `Matter.Pairs` object from which previous collision objects may be reused. Intended for internal `Matter.Engine` usage.
     * @property pairs
     * @type {pairs|null}
     * @default null
     */ })();
            /***/ },
            /***/ 4506: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
*
* @class Pair
*/ var Pair = {};
                module1.exports = Pair;
                var Contact = __webpack_require__(43424);
                (function() {
                    /**
     * Creates a pair.
     * @method create
     * @param {collision} collision
     * @param {number} timestamp
     * @return {pair} A new pair
     */ Pair.create = function(collision, timestamp) {
                        var bodyA = collision.bodyA, bodyB = collision.bodyB;
                        var pair = {
                            id: Pair.id(bodyA, bodyB),
                            bodyA: bodyA,
                            bodyB: bodyB,
                            collision: collision,
                            contacts: [
                                Contact.create(),
                                Contact.create()
                            ],
                            contactCount: 0,
                            separation: 0,
                            isActive: true,
                            isSensor: bodyA.isSensor || bodyB.isSensor,
                            timeCreated: timestamp,
                            timeUpdated: timestamp,
                            inverseMass: 0,
                            friction: 0,
                            frictionStatic: 0,
                            restitution: 0,
                            slop: 0
                        };
                        Pair.update(pair, collision, timestamp);
                        return pair;
                    };
                    /**
     * Updates a pair given a collision.
     * @method update
     * @param {pair} pair
     * @param {collision} collision
     * @param {number} timestamp
     */ Pair.update = function(pair, collision, timestamp) {
                        var supports = collision.supports, supportCount = collision.supportCount, contacts = pair.contacts, parentA = collision.parentA, parentB = collision.parentB;
                        pair.isActive = true;
                        pair.timeUpdated = timestamp;
                        pair.collision = collision;
                        pair.separation = collision.depth;
                        pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
                        pair.friction = parentA.friction < parentB.friction ? parentA.friction : parentB.friction;
                        pair.frictionStatic = parentA.frictionStatic > parentB.frictionStatic ? parentA.frictionStatic : parentB.frictionStatic;
                        pair.restitution = parentA.restitution > parentB.restitution ? parentA.restitution : parentB.restitution;
                        pair.slop = parentA.slop > parentB.slop ? parentA.slop : parentB.slop;
                        pair.contactCount = supportCount;
                        collision.pair = pair;
                        var supportA = supports[0], contactA = contacts[0], supportB = supports[1], contactB = contacts[1];
                        if (contactB.vertex === supportA || contactA.vertex === supportB) {
                            contacts[1] = contactA;
                            contacts[0] = contactA = contactB;
                            contactB = contacts[1];
                        }
                        contactA.vertex = supportA;
                        contactB.vertex = supportB;
                    };
                    /**
     * Set a pair as active or inactive.
     * @method setActive
     * @param {pair} pair
     * @param {bool} isActive
     * @param {number} timestamp
     */ Pair.setActive = function(pair, isActive, timestamp) {
                        if (isActive) {
                            pair.isActive = true;
                            pair.timeUpdated = timestamp;
                        } else {
                            pair.isActive = false;
                            pair.contactCount = 0;
                        }
                    };
                    /**
     * Get the id for the given pair.
     * @method id
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {string} Unique pairId
     */ Pair.id = function(bodyA, bodyB) {
                        return bodyA.id < bodyB.id ? bodyA.id.toString(36) + ':' + bodyB.id.toString(36) : bodyB.id.toString(36) + ':' + bodyA.id.toString(36);
                    };
                })();
            /***/ },
            /***/ 99561: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
*
* @class Pairs
*/ var Pairs = {};
                module1.exports = Pairs;
                var Pair = __webpack_require__(4506);
                var Common = __webpack_require__(53402);
                (function() {
                    /**
     * Creates a new pairs structure.
     * @method create
     * @param {object} options
     * @return {pairs} A new pairs structure
     */ Pairs.create = function(options) {
                        return Common.extend({
                            table: {},
                            list: [],
                            collisionStart: [],
                            collisionActive: [],
                            collisionEnd: []
                        }, options);
                    };
                    /**
     * Updates pairs given a list of collisions.
     * @method update
     * @param {object} pairs
     * @param {collision[]} collisions
     * @param {number} timestamp
     */ Pairs.update = function(pairs, collisions, timestamp) {
                        var pairUpdate = Pair.update, pairCreate = Pair.create, pairSetActive = Pair.setActive, pairsTable = pairs.table, pairsList = pairs.list, pairsListLength = pairsList.length, pairsListIndex = pairsListLength, collisionStart = pairs.collisionStart, collisionEnd = pairs.collisionEnd, collisionActive = pairs.collisionActive, collisionsLength = collisions.length, collisionStartIndex = 0, collisionEndIndex = 0, collisionActiveIndex = 0, collision, pair, i;
                        // clear collision state arrays, but maintain old reference
                        for(i = 0; i < collisionsLength; i++){
                            collision = collisions[i];
                            pair = collision.pair;
                            if (pair) {
                                // pair already exists (but may or may not be active)
                                if (pair.isActive) // pair exists and is active
                                collisionActive[collisionActiveIndex++] = pair;
                                // update the pair
                                pairUpdate(pair, collision, timestamp);
                            } else {
                                // pair did not exist, create a new pair
                                pair = pairCreate(collision, timestamp);
                                pairsTable[pair.id] = pair;
                                // push the new pair
                                collisionStart[collisionStartIndex++] = pair;
                                pairsList[pairsListIndex++] = pair;
                            }
                        }
                        // find pairs that are no longer active
                        pairsListIndex = 0;
                        pairsListLength = pairsList.length;
                        for(i = 0; i < pairsListLength; i++){
                            pair = pairsList[i];
                            if (pair.timeUpdated >= timestamp) pairsList[pairsListIndex++] = pair;
                            else {
                                pairSetActive(pair, false, timestamp);
                                if (pair.collision.bodyA.sleepCounter > 0 && pair.collision.bodyB.sleepCounter > 0) pairsList[pairsListIndex++] = pair;
                                else {
                                    collisionEnd[collisionEndIndex++] = pair;
                                    delete pairsTable[pair.id];
                                }
                            }
                        }
                        // remove inactive pairs
                        if (pairsList.length !== pairsListIndex) pairsList.length = pairsListIndex;
                        if (collisionStart.length !== collisionStartIndex) collisionStart.length = collisionStartIndex;
                        if (collisionEnd.length !== collisionEndIndex) collisionEnd.length = collisionEndIndex;
                        if (collisionActive.length !== collisionActiveIndex) collisionActive.length = collisionActiveIndex;
                    };
                    /**
     * Clears the given pairs structure.
     * @method clear
     * @param {pairs} pairs
     * @return {pairs} pairs
     */ Pairs.clear = function(pairs) {
                        pairs.table = {};
                        pairs.list.length = 0;
                        pairs.collisionStart.length = 0;
                        pairs.collisionActive.length = 0;
                        pairs.collisionEnd.length = 0;
                        return pairs;
                    };
                })();
            /***/ },
            /***/ 73296: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Query` module contains methods for performing collision queries.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Query
*/ var Query = {};
                module1.exports = Query;
                var Vector = __webpack_require__(31725);
                var Collision = __webpack_require__(52284);
                var Bounds = __webpack_require__(15647);
                var Bodies = __webpack_require__(66280);
                var Vertices = __webpack_require__(41598);
                (function() {
                    /**
     * Returns a list of collisions between `body` and `bodies`.
     * @method collides
     * @param {body} body
     * @param {body[]} bodies
     * @return {collision[]} Collisions
     */ Query.collides = function(body, bodies) {
                        var collisions = [], bodiesLength = bodies.length, bounds = body.bounds, collides = Collision.collides, overlaps = Bounds.overlaps;
                        for(var i = 0; i < bodiesLength; i++){
                            var bodyA = bodies[i], partsALength = bodyA.parts.length, partsAStart = partsALength === 1 ? 0 : 1;
                            //  Phaser addition - skip same body checks
                            if (body === bodyA) continue;
                            if (overlaps(bodyA.bounds, bounds)) for(var j = partsAStart; j < partsALength; j++){
                                var part = bodyA.parts[j];
                                if (overlaps(part.bounds, bounds)) {
                                    var collision = collides(part, body);
                                    if (collision) {
                                        collisions.push(collision);
                                        break;
                                    }
                                }
                            }
                        }
                        return collisions;
                    };
                    /**
     * Casts a ray segment against a set of bodies and returns all collisions, ray width is optional. Intersection points are not provided.
     * @method ray
     * @param {body[]} bodies
     * @param {vector} startPoint
     * @param {vector} endPoint
     * @param {number} [rayWidth]
     * @return {collision[]} Collisions
     */ Query.ray = function(bodies, startPoint, endPoint, rayWidth) {
                        rayWidth = rayWidth || 1e-100;
                        var rayAngle = Vector.angle(startPoint, endPoint), rayLength = Vector.magnitude(Vector.sub(startPoint, endPoint)), rayX = (endPoint.x + startPoint.x) * 0.5, rayY = (endPoint.y + startPoint.y) * 0.5, ray = Bodies.rectangle(rayX, rayY, rayLength, rayWidth, {
                            angle: rayAngle
                        }), collisions = Query.collides(ray, bodies);
                        for(var i = 0; i < collisions.length; i += 1){
                            var collision = collisions[i];
                            collision.body = collision.bodyB = collision.bodyA;
                        }
                        return collisions;
                    };
                    /**
     * Returns all bodies whose bounds are inside (or outside if set) the given set of bounds, from the given set of bodies.
     * @method region
     * @param {body[]} bodies
     * @param {bounds} bounds
     * @param {bool} [outside=false]
     * @return {body[]} The bodies matching the query
     */ Query.region = function(bodies, bounds, outside) {
                        var result = [];
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i], overlaps = Bounds.overlaps(body.bounds, bounds);
                            if (overlaps && !outside || !overlaps && outside) result.push(body);
                        }
                        return result;
                    };
                    /**
     * Returns all bodies whose vertices contain the given point, from the given set of bodies.
     * @method point
     * @param {body[]} bodies
     * @param {vector} point
     * @return {body[]} The bodies matching the query
     */ Query.point = function(bodies, point) {
                        var result = [];
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            if (Bounds.contains(body.bounds, point)) for(var j = body.parts.length === 1 ? 0 : 1; j < body.parts.length; j++){
                                var part = body.parts[j];
                                if (Bounds.contains(part.bounds, point) && Vertices.contains(part.vertices, point)) {
                                    result.push(body);
                                    break;
                                }
                            }
                        }
                        return result;
                    };
                })();
            /***/ },
            /***/ 66272: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Resolver` module contains methods for resolving collision pairs.
*
* @class Resolver
*/ var Resolver = {};
                module1.exports = Resolver;
                var Vertices = __webpack_require__(41598);
                var Common = __webpack_require__(53402);
                var Bounds = __webpack_require__(15647);
                (function() {
                    Resolver._restingThresh = 2;
                    Resolver._restingThreshTangent = Math.sqrt(6);
                    Resolver._positionDampen = 0.9;
                    Resolver._positionWarming = 0.8;
                    Resolver._frictionNormalMultiplier = 5;
                    Resolver._frictionMaxStatic = Number.MAX_VALUE;
                    /**
     * Prepare pairs for position solving.
     * @method preSolvePosition
     * @param {pair[]} pairs
     */ Resolver.preSolvePosition = function(pairs) {
                        var i, pair, contactCount, pairsLength = pairs.length;
                        // find total contacts on each body
                        for(i = 0; i < pairsLength; i++){
                            pair = pairs[i];
                            if (!pair.isActive) continue;
                            contactCount = pair.contactCount;
                            pair.collision.parentA.totalContacts += contactCount;
                            pair.collision.parentB.totalContacts += contactCount;
                        }
                    };
                    /**
     * Find a solution for pair positions.
     * @method solvePosition
     * @param {pair[]} pairs
     * @param {number} delta
     * @param {number} [damping=1]
     */ Resolver.solvePosition = function(pairs, delta, damping) {
                        var i, pair, collision, bodyA, bodyB, normal, contactShare, positionImpulse, positionDampen = Resolver._positionDampen * (damping || 1), slopDampen = Common.clamp(delta / Common._baseDelta, 0, 1), pairsLength = pairs.length;
                        // find impulses required to resolve penetration
                        for(i = 0; i < pairsLength; i++){
                            pair = pairs[i];
                            if (!pair.isActive || pair.isSensor) continue;
                            collision = pair.collision;
                            bodyA = collision.parentA;
                            bodyB = collision.parentB;
                            normal = collision.normal;
                            // get current separation between body edges involved in collision
                            pair.separation = collision.depth + normal.x * (bodyB.positionImpulse.x - bodyA.positionImpulse.x) + normal.y * (bodyB.positionImpulse.y - bodyA.positionImpulse.y);
                        }
                        for(i = 0; i < pairsLength; i++){
                            pair = pairs[i];
                            if (!pair.isActive || pair.isSensor) continue;
                            collision = pair.collision;
                            bodyA = collision.parentA;
                            bodyB = collision.parentB;
                            normal = collision.normal;
                            positionImpulse = pair.separation - pair.slop * slopDampen;
                            if (bodyA.isStatic || bodyB.isStatic) positionImpulse *= 2;
                            if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                contactShare = positionDampen / bodyA.totalContacts;
                                bodyA.positionImpulse.x += normal.x * positionImpulse * contactShare;
                                bodyA.positionImpulse.y += normal.y * positionImpulse * contactShare;
                            }
                            if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                contactShare = positionDampen / bodyB.totalContacts;
                                bodyB.positionImpulse.x -= normal.x * positionImpulse * contactShare;
                                bodyB.positionImpulse.y -= normal.y * positionImpulse * contactShare;
                            }
                        }
                    };
                    /**
     * Apply position resolution.
     * @method postSolvePosition
     * @param {body[]} bodies
     */ Resolver.postSolvePosition = function(bodies) {
                        var positionWarming = Resolver._positionWarming, bodiesLength = bodies.length, verticesTranslate = Vertices.translate, boundsUpdate = Bounds.update;
                        for(var i = 0; i < bodiesLength; i++){
                            var body = bodies[i], positionImpulse = body.positionImpulse, positionImpulseX = positionImpulse.x, positionImpulseY = positionImpulse.y, velocity = body.velocity;
                            // reset contact count
                            body.totalContacts = 0;
                            if (positionImpulseX !== 0 || positionImpulseY !== 0) {
                                // update body geometry
                                for(var j = 0; j < body.parts.length; j++){
                                    var part = body.parts[j];
                                    verticesTranslate(part.vertices, positionImpulse);
                                    boundsUpdate(part.bounds, part.vertices, velocity);
                                    part.position.x += positionImpulseX;
                                    part.position.y += positionImpulseY;
                                }
                                // move the body without changing velocity
                                body.positionPrev.x += positionImpulseX;
                                body.positionPrev.y += positionImpulseY;
                                if (positionImpulseX * velocity.x + positionImpulseY * velocity.y < 0) {
                                    // reset cached impulse if the body has velocity along it
                                    positionImpulse.x = 0;
                                    positionImpulse.y = 0;
                                } else {
                                    // warm the next iteration
                                    positionImpulse.x *= positionWarming;
                                    positionImpulse.y *= positionWarming;
                                }
                            }
                        }
                    };
                    /**
     * Prepare pairs for velocity solving.
     * @method preSolveVelocity
     * @param {pair[]} pairs
     */ Resolver.preSolveVelocity = function(pairs) {
                        var pairsLength = pairs.length, i, j;
                        for(i = 0; i < pairsLength; i++){
                            var pair = pairs[i];
                            if (!pair.isActive || pair.isSensor) continue;
                            var contacts = pair.contacts, contactCount = pair.contactCount, collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, normal = collision.normal, tangent = collision.tangent;
                            // resolve each contact
                            for(j = 0; j < contactCount; j++){
                                var contact = contacts[j], contactVertex = contact.vertex, normalImpulse = contact.normalImpulse, tangentImpulse = contact.tangentImpulse;
                                if (normalImpulse !== 0 || tangentImpulse !== 0) {
                                    // total impulse from contact
                                    var impulseX = normal.x * normalImpulse + tangent.x * tangentImpulse, impulseY = normal.y * normalImpulse + tangent.y * tangentImpulse;
                                    // apply impulse from contact
                                    if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                        bodyA.positionPrev.x += impulseX * bodyA.inverseMass;
                                        bodyA.positionPrev.y += impulseY * bodyA.inverseMass;
                                        bodyA.anglePrev += bodyA.inverseInertia * ((contactVertex.x - bodyA.position.x) * impulseY - (contactVertex.y - bodyA.position.y) * impulseX);
                                    }
                                    if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                        bodyB.positionPrev.x -= impulseX * bodyB.inverseMass;
                                        bodyB.positionPrev.y -= impulseY * bodyB.inverseMass;
                                        bodyB.anglePrev -= bodyB.inverseInertia * ((contactVertex.x - bodyB.position.x) * impulseY - (contactVertex.y - bodyB.position.y) * impulseX);
                                    }
                                }
                            }
                        }
                    };
                    /**
     * Find a solution for pair velocities.
     * @method solveVelocity
     * @param {pair[]} pairs
     * @param {number} delta
     */ Resolver.solveVelocity = function(pairs, delta) {
                        var timeScale = delta / Common._baseDelta, timeScaleSquared = timeScale * timeScale, timeScaleCubed = timeScaleSquared * timeScale, restingThresh = -Resolver._restingThresh * timeScale, restingThreshTangent = Resolver._restingThreshTangent, frictionNormalMultiplier = Resolver._frictionNormalMultiplier * timeScale, frictionMaxStatic = Resolver._frictionMaxStatic, pairsLength = pairs.length, tangentImpulse, maxFriction, i, j;
                        for(i = 0; i < pairsLength; i++){
                            var pair = pairs[i];
                            if (!pair.isActive || pair.isSensor) continue;
                            var collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, normalX = collision.normal.x, normalY = collision.normal.y, tangentX = collision.tangent.x, tangentY = collision.tangent.y, inverseMassTotal = pair.inverseMass, friction = pair.friction * pair.frictionStatic * frictionNormalMultiplier, contacts = pair.contacts, contactCount = pair.contactCount, contactShare = 1 / contactCount;
                            // update body velocities
                            var bodyAVelocityX = bodyA.position.x - bodyA.positionPrev.x, bodyAVelocityY = bodyA.position.y - bodyA.positionPrev.y, bodyAAngularVelocity = bodyA.angle - bodyA.anglePrev, bodyBVelocityX = bodyB.position.x - bodyB.positionPrev.x, bodyBVelocityY = bodyB.position.y - bodyB.positionPrev.y, bodyBAngularVelocity = bodyB.angle - bodyB.anglePrev;
                            // resolve each contact
                            for(j = 0; j < contactCount; j++){
                                var contact = contacts[j], contactVertex = contact.vertex;
                                var offsetAX = contactVertex.x - bodyA.position.x, offsetAY = contactVertex.y - bodyA.position.y, offsetBX = contactVertex.x - bodyB.position.x, offsetBY = contactVertex.y - bodyB.position.y;
                                var velocityPointAX = bodyAVelocityX - offsetAY * bodyAAngularVelocity, velocityPointAY = bodyAVelocityY + offsetAX * bodyAAngularVelocity, velocityPointBX = bodyBVelocityX - offsetBY * bodyBAngularVelocity, velocityPointBY = bodyBVelocityY + offsetBX * bodyBAngularVelocity;
                                var relativeVelocityX = velocityPointAX - velocityPointBX, relativeVelocityY = velocityPointAY - velocityPointBY;
                                var normalVelocity = normalX * relativeVelocityX + normalY * relativeVelocityY, tangentVelocity = tangentX * relativeVelocityX + tangentY * relativeVelocityY;
                                // coulomb friction
                                var normalOverlap = pair.separation + normalVelocity;
                                var normalForce = Math.min(normalOverlap, 1);
                                normalForce = normalOverlap < 0 ? 0 : normalForce;
                                var frictionLimit = normalForce * friction;
                                if (tangentVelocity < -frictionLimit || tangentVelocity > frictionLimit) {
                                    maxFriction = tangentVelocity > 0 ? tangentVelocity : -tangentVelocity;
                                    tangentImpulse = pair.friction * (tangentVelocity > 0 ? 1 : -1) * timeScaleCubed;
                                    if (tangentImpulse < -maxFriction) tangentImpulse = -maxFriction;
                                    else if (tangentImpulse > maxFriction) tangentImpulse = maxFriction;
                                } else {
                                    tangentImpulse = tangentVelocity;
                                    maxFriction = frictionMaxStatic;
                                }
                                // account for mass, inertia and contact offset
                                var oAcN = offsetAX * normalY - offsetAY * normalX, oBcN = offsetBX * normalY - offsetBY * normalX, share = contactShare / (inverseMassTotal + bodyA.inverseInertia * oAcN * oAcN + bodyB.inverseInertia * oBcN * oBcN);
                                // raw impulses
                                var normalImpulse = (1 + pair.restitution) * normalVelocity * share;
                                tangentImpulse *= share;
                                // handle high velocity and resting collisions separately
                                if (normalVelocity < restingThresh) // high normal velocity so clear cached contact normal impulse
                                contact.normalImpulse = 0;
                                else {
                                    // solve resting collision constraints using Erin Catto's method (GDC08)
                                    // impulse constraint tends to 0
                                    var contactNormalImpulse = contact.normalImpulse;
                                    contact.normalImpulse += normalImpulse;
                                    if (contact.normalImpulse > 0) contact.normalImpulse = 0;
                                    normalImpulse = contact.normalImpulse - contactNormalImpulse;
                                }
                                // handle high velocity and resting collisions separately
                                if (tangentVelocity < -restingThreshTangent || tangentVelocity > restingThreshTangent) // high tangent velocity so clear cached contact tangent impulse
                                contact.tangentImpulse = 0;
                                else {
                                    // solve resting collision constraints using Erin Catto's method (GDC08)
                                    // tangent impulse tends to -tangentSpeed or +tangentSpeed
                                    var contactTangentImpulse = contact.tangentImpulse;
                                    contact.tangentImpulse += tangentImpulse;
                                    if (contact.tangentImpulse < -maxFriction) contact.tangentImpulse = -maxFriction;
                                    if (contact.tangentImpulse > maxFriction) contact.tangentImpulse = maxFriction;
                                    tangentImpulse = contact.tangentImpulse - contactTangentImpulse;
                                }
                                // total impulse from contact
                                var impulseX = normalX * normalImpulse + tangentX * tangentImpulse, impulseY = normalY * normalImpulse + tangentY * tangentImpulse;
                                // apply impulse from contact
                                if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                    bodyA.positionPrev.x += impulseX * bodyA.inverseMass;
                                    bodyA.positionPrev.y += impulseY * bodyA.inverseMass;
                                    bodyA.anglePrev += (offsetAX * impulseY - offsetAY * impulseX) * bodyA.inverseInertia;
                                }
                                if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                    bodyB.positionPrev.x -= impulseX * bodyB.inverseMass;
                                    bodyB.positionPrev.y -= impulseY * bodyB.inverseMass;
                                    bodyB.anglePrev -= (offsetBX * impulseY - offsetBY * impulseX) * bodyB.inverseInertia;
                                }
                            }
                        }
                    };
                })();
            /***/ },
            /***/ 48140: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Constraint` module contains methods for creating and manipulating constraints.
* Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
* The stiffness of constraints can be modified to create springs or elastic.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Constraint
*/ var Constraint = {};
                module1.exports = Constraint;
                var Vertices = __webpack_require__(41598);
                var Vector = __webpack_require__(31725);
                var Sleeping = __webpack_require__(53614);
                var Bounds = __webpack_require__(15647);
                var Axes = __webpack_require__(66615);
                var Common = __webpack_require__(53402);
                (function() {
                    Constraint._warming = 0.4;
                    Constraint._torqueDampen = 1;
                    Constraint._minLength = 0.000001;
                    /**
     * Creates a new constraint.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness` value (e.g. `0.7` or above).
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing `engine.constraintIterations`.
     * For compound bodies, constraints must be applied to the parent body (not one of its parts).
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {constraint} constraint
     */ Constraint.create = function(options) {
                        var constraint = options;
                        // if bodies defined but no points, use body centre
                        if (constraint.bodyA && !constraint.pointA) constraint.pointA = {
                            x: 0,
                            y: 0
                        };
                        if (constraint.bodyB && !constraint.pointB) constraint.pointB = {
                            x: 0,
                            y: 0
                        };
                        // calculate static length using initial world space points
                        var initialPointA = constraint.bodyA ? Vector.add(constraint.bodyA.position, constraint.pointA) : constraint.pointA, initialPointB = constraint.bodyB ? Vector.add(constraint.bodyB.position, constraint.pointB) : constraint.pointB, length = Vector.magnitude(Vector.sub(initialPointA, initialPointB));
                        constraint.length = typeof constraint.length !== 'undefined' ? constraint.length : length;
                        // option defaults
                        constraint.id = constraint.id || Common.nextId();
                        constraint.label = constraint.label || 'Constraint';
                        constraint.type = 'constraint';
                        constraint.stiffness = constraint.stiffness || (constraint.length > 0 ? 1 : 0.7);
                        constraint.damping = constraint.damping || 0;
                        constraint.angularStiffness = constraint.angularStiffness || 0;
                        constraint.angleA = constraint.bodyA ? constraint.bodyA.angle : constraint.angleA;
                        constraint.angleB = constraint.bodyB ? constraint.bodyB.angle : constraint.angleB;
                        constraint.plugin = {};
                        // render
                        var render = {
                            visible: true,
                            type: 'line',
                            anchors: true,
                            lineColor: null,
                            lineOpacity: null,
                            lineThickness: null,
                            pinSize: null,
                            anchorColor: null,
                            anchorSize: null // custom Phaser property
                        };
                        if (constraint.length === 0 && constraint.stiffness > 0.1) {
                            render.type = 'pin';
                            render.anchors = false;
                        } else if (constraint.stiffness < 0.9) render.type = 'spring';
                        constraint.render = Common.extend(render, constraint.render);
                        return constraint;
                    };
                    /**
     * Prepares for solving by constraint warming.
     * @private
     * @method preSolveAll
     * @param {body[]} bodies
     */ Constraint.preSolveAll = function(bodies) {
                        for(var i = 0; i < bodies.length; i += 1){
                            var body = bodies[i], impulse = body.constraintImpulse;
                            if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                            body.position.x += impulse.x;
                            body.position.y += impulse.y;
                            body.angle += impulse.angle;
                        }
                    };
                    /**
     * Solves all constraints in a list of collisions.
     * @private
     * @method solveAll
     * @param {constraint[]} constraints
     * @param {number} delta
     */ Constraint.solveAll = function(constraints, delta) {
                        var timeScale = Common.clamp(delta / Common._baseDelta, 0, 1);
                        // Solve fixed constraints first.
                        for(var i = 0; i < constraints.length; i += 1){
                            var constraint = constraints[i], fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic, fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                            if (fixedA || fixedB) Constraint.solve(constraints[i], timeScale);
                        }
                        // Solve free constraints last.
                        for(i = 0; i < constraints.length; i += 1){
                            constraint = constraints[i];
                            fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic;
                            fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                            if (!fixedA && !fixedB) Constraint.solve(constraints[i], timeScale);
                        }
                    };
                    /**
     * Solves a distance constraint with Gauss-Siedel method.
     * @private
     * @method solve
     * @param {constraint} constraint
     * @param {number} timeScale
     */ Constraint.solve = function(constraint, timeScale) {
                        var bodyA = constraint.bodyA, bodyB = constraint.bodyB, pointA = constraint.pointA, pointB = constraint.pointB;
                        if (!bodyA && !bodyB) return;
                        // update reference angle
                        if (bodyA && !bodyA.isStatic) {
                            Vector.rotate(pointA, bodyA.angle - constraint.angleA, pointA);
                            constraint.angleA = bodyA.angle;
                        }
                        // update reference angle
                        if (bodyB && !bodyB.isStatic) {
                            Vector.rotate(pointB, bodyB.angle - constraint.angleB, pointB);
                            constraint.angleB = bodyB.angle;
                        }
                        var pointAWorld = pointA, pointBWorld = pointB;
                        if (bodyA) pointAWorld = Vector.add(bodyA.position, pointA);
                        if (bodyB) pointBWorld = Vector.add(bodyB.position, pointB);
                        if (!pointAWorld || !pointBWorld) return;
                        var delta = Vector.sub(pointAWorld, pointBWorld), currentLength = Vector.magnitude(delta);
                        // prevent singularity
                        if (currentLength < Constraint._minLength) currentLength = Constraint._minLength;
                        // solve distance constraint with Gauss-Siedel method
                        var difference = (currentLength - constraint.length) / currentLength, isRigid = constraint.stiffness >= 1 || constraint.length === 0, stiffness = isRigid ? constraint.stiffness * timeScale : constraint.stiffness * timeScale * timeScale, damping = constraint.damping * timeScale, force = Vector.mult(delta, difference * stiffness), massTotal = (bodyA ? bodyA.inverseMass : 0) + (bodyB ? bodyB.inverseMass : 0), inertiaTotal = (bodyA ? bodyA.inverseInertia : 0) + (bodyB ? bodyB.inverseInertia : 0), resistanceTotal = massTotal + inertiaTotal, torque, share, normal, normalVelocity, relativeVelocity;
                        if (damping > 0) {
                            var zero = Vector.create();
                            normal = Vector.div(delta, currentLength);
                            relativeVelocity = Vector.sub(bodyB && Vector.sub(bodyB.position, bodyB.positionPrev) || zero, bodyA && Vector.sub(bodyA.position, bodyA.positionPrev) || zero);
                            normalVelocity = Vector.dot(normal, relativeVelocity);
                        }
                        if (bodyA && !bodyA.isStatic) {
                            share = bodyA.inverseMass / massTotal;
                            // keep track of applied impulses for post solving
                            bodyA.constraintImpulse.x -= force.x * share;
                            bodyA.constraintImpulse.y -= force.y * share;
                            // apply forces
                            bodyA.position.x -= force.x * share;
                            bodyA.position.y -= force.y * share;
                            // apply damping
                            if (damping > 0) {
                                bodyA.positionPrev.x -= damping * normal.x * normalVelocity * share;
                                bodyA.positionPrev.y -= damping * normal.y * normalVelocity * share;
                            }
                            // apply torque
                            torque = Vector.cross(pointA, force) / resistanceTotal * Constraint._torqueDampen * bodyA.inverseInertia * (1 - constraint.angularStiffness);
                            bodyA.constraintImpulse.angle -= torque;
                            bodyA.angle -= torque;
                        }
                        if (bodyB && !bodyB.isStatic) {
                            share = bodyB.inverseMass / massTotal;
                            // keep track of applied impulses for post solving
                            bodyB.constraintImpulse.x += force.x * share;
                            bodyB.constraintImpulse.y += force.y * share;
                            // apply forces
                            bodyB.position.x += force.x * share;
                            bodyB.position.y += force.y * share;
                            // apply damping
                            if (damping > 0) {
                                bodyB.positionPrev.x += damping * normal.x * normalVelocity * share;
                                bodyB.positionPrev.y += damping * normal.y * normalVelocity * share;
                            }
                            // apply torque
                            torque = Vector.cross(pointB, force) / resistanceTotal * Constraint._torqueDampen * bodyB.inverseInertia * (1 - constraint.angularStiffness);
                            bodyB.constraintImpulse.angle += torque;
                            bodyB.angle += torque;
                        }
                    };
                    /**
     * Performs body updates required after solving constraints.
     * @private
     * @method postSolveAll
     * @param {body[]} bodies
     */ Constraint.postSolveAll = function(bodies) {
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i], impulse = body.constraintImpulse;
                            if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                            Sleeping.set(body, false);
                            // update geometry and reset
                            for(var j = 0; j < body.parts.length; j++){
                                var part = body.parts[j];
                                Vertices.translate(part.vertices, impulse);
                                if (j > 0) {
                                    part.position.x += impulse.x;
                                    part.position.y += impulse.y;
                                }
                                if (impulse.angle !== 0) {
                                    Vertices.rotate(part.vertices, impulse.angle, body.position);
                                    Axes.rotate(part.axes, impulse.angle);
                                    if (j > 0) Vector.rotateAbout(part.position, impulse.angle, body.position, part.position);
                                }
                                Bounds.update(part.bounds, part.vertices, body.velocity);
                            }
                            // dampen the cached impulse for warming next step
                            impulse.angle *= Constraint._warming;
                            impulse.x *= Constraint._warming;
                            impulse.y *= Constraint._warming;
                        }
                    };
                    /**
     * Returns the world-space position of `constraint.pointA`, accounting for `constraint.bodyA`.
     * @method pointAWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointAWorld = function(constraint) {
                        return {
                            x: (constraint.bodyA ? constraint.bodyA.position.x : 0) + (constraint.pointA ? constraint.pointA.x : 0),
                            y: (constraint.bodyA ? constraint.bodyA.position.y : 0) + (constraint.pointA ? constraint.pointA.y : 0)
                        };
                    };
                    /**
     * Returns the world-space position of `constraint.pointB`, accounting for `constraint.bodyB`.
     * @method pointBWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointBWorld = function(constraint) {
                        return {
                            x: (constraint.bodyB ? constraint.bodyB.position.x : 0) + (constraint.pointB ? constraint.pointB.x : 0),
                            y: (constraint.bodyB ? constraint.bodyB.position.y : 0) + (constraint.pointB ? constraint.pointB.y : 0)
                        };
                    };
                    /**
     * Returns the current length of the constraint. 
     * This is the distance between both of the constraint's end points.
     * See `constraint.length` for the target rest length.
     * @method currentLength
     * @param {constraint} constraint
     * @returns {number} the current length
     */ Constraint.currentLength = function(constraint) {
                        var pointAX = (constraint.bodyA ? constraint.bodyA.position.x : 0) + (constraint.pointA ? constraint.pointA.x : 0);
                        var pointAY = (constraint.bodyA ? constraint.bodyA.position.y : 0) + (constraint.pointA ? constraint.pointA.y : 0);
                        var pointBX = (constraint.bodyB ? constraint.bodyB.position.x : 0) + (constraint.pointB ? constraint.pointB.x : 0);
                        var pointBY = (constraint.bodyB ? constraint.bodyB.position.y : 0) + (constraint.pointB ? constraint.pointB.y : 0);
                        var deltaX = pointAX - pointBX;
                        var deltaY = pointAY - pointBY;
                        return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                    };
                /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "constraint"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Constraint"
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the constraint should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * A `Number` that defines the line width to use when rendering the constraint outline.
     * A value of `0` means no outline will be rendered.
     *
     * @property render.lineWidth
     * @type number
     * @default 2
     */ /**
     * A `String` that defines the stroke style to use when rendering the constraint outline.
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.strokeStyle
     * @type string
     * @default a random colour
     */ /**
     * A `String` that defines the constraint rendering type. 
     * The possible values are 'line', 'pin', 'spring'.
     * An appropriate render type will be automatically chosen unless one is given in options.
     *
     * @property render.type
     * @type string
     * @default 'line'
     */ /**
     * A `Boolean` that defines if the constraint's anchor points should be rendered.
     *
     * @property render.anchors
     * @type boolean
     * @default true
     */ /**
     * The first possible `Body` that this constraint is attached to.
     *
     * @property bodyA
     * @type body
     * @default null
     */ /**
     * The second possible `Body` that this constraint is attached to.
     *
     * @property bodyB
     * @type body
     * @default null
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
     *
     * @property pointA
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyB` if defined, otherwise a world-space position.
     *
     * @property pointB
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`.
     * A value of `1` means the constraint should be very stiff.
     * A value of `0.2` means the constraint acts like a soft spring.
     *
     * @property stiffness
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the damping of the constraint, 
     * i.e. the amount of resistance applied to each body based on their velocities to limit the amount of oscillation.
     * Damping will only be apparent when the constraint also has a very low `stiffness`.
     * A value of `0.1` means the constraint will apply heavy damping, resulting in little to no oscillation.
     * A value of `0` means the constraint will apply no damping.
     *
     * @property damping
     * @type number
     * @default 0
     */ /**
     * A `Number` that specifies the target resting length of the constraint. 
     * It is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     *
     * @property length
     * @type number
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
            /***/ },
            /***/ 53402: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Common` module contains utility functions that are common to all modules.
*
* @class Common
*/ var Common = {};
                module1.exports = Common;
                (function() {
                    Common._baseDelta = 1000 / 60;
                    Common._nextId = 0;
                    Common._seed = 0;
                    Common._nowStartTime = +new Date();
                    Common._warnedOnce = {};
                    Common._decomp = null;
                    /**
     * Extends the object in the first argument using the object in the second argument.
     * @method extend
     * @param {} obj
     * @param {boolean} deep
     * @return {} obj extended
     */ Common.extend = function(obj, deep) {
                        var argsStart, args, deepClone;
                        if (typeof deep === 'boolean') {
                            argsStart = 2;
                            deepClone = deep;
                        } else {
                            argsStart = 1;
                            deepClone = true;
                        }
                        for(var i = argsStart; i < arguments.length; i++){
                            var source = arguments[i];
                            if (source) {
                                for(var prop in source)if (deepClone && source[prop] && source[prop].constructor === Object) {
                                    if (!obj[prop] || obj[prop].constructor === Object) {
                                        obj[prop] = obj[prop] || {};
                                        Common.extend(obj[prop], deepClone, source[prop]);
                                    } else obj[prop] = source[prop];
                                } else obj[prop] = source[prop];
                            }
                        }
                        return obj;
                    };
                    /**
     * Creates a new clone of the object, if deep is true references will also be cloned.
     * @method clone
     * @param {} obj
     * @param {bool} deep
     * @return {} obj cloned
     */ Common.clone = function(obj, deep) {
                        return Common.extend({}, deep, obj);
                    };
                    /**
     * Returns the list of keys for the given object.
     * @method keys
     * @param {} obj
     * @return {string[]} keys
     */ Common.keys = function(obj) {
                        if (Object.keys) return Object.keys(obj);
                        // avoid hasOwnProperty for performance
                        var keys = [];
                        for(var key in obj)keys.push(key);
                        return keys;
                    };
                    /**
     * Returns the list of values for the given object.
     * @method values
     * @param {} obj
     * @return {array} Array of the objects property values
     */ Common.values = function(obj) {
                        var values = [];
                        if (Object.keys) {
                            var keys = Object.keys(obj);
                            for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                            return values;
                        }
                        // avoid hasOwnProperty for performance
                        for(var key in obj)values.push(obj[key]);
                        return values;
                    };
                    /**
     * Gets a value from `base` relative to the `path` string.
     * @method get
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} The object at the given path
     */ Common.get = function(obj, path, begin, end) {
                        path = path.split('.').slice(begin, end);
                        for(var i = 0; i < path.length; i += 1)obj = obj[path[i]];
                        return obj;
                    };
                    /**
     * Sets a value on `base` relative to the given `path` string.
     * @method set
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {} val The value to set
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} Pass through `val` for chaining
     */ Common.set = function(obj, path, val, begin, end) {
                        var parts = path.split('.').slice(begin, end);
                        Common.get(obj, path, 0, -1)[parts[parts.length - 1]] = val;
                        return val;
                    };
                    /**
     * Shuffles the given array in-place.
     * The function uses a seeded random generator.
     * @method shuffle
     * @param {array} array
     * @return {array} array shuffled randomly
     */ Common.shuffle = function(array) {
                        for(var i = array.length - 1; i > 0; i--){
                            var j = Math.floor(Common.random() * (i + 1));
                            var temp = array[i];
                            array[i] = array[j];
                            array[j] = temp;
                        }
                        return array;
                    };
                    /**
     * Randomly chooses a value from a list with equal probability.
     * The function uses a seeded random generator.
     * @method choose
     * @param {array} choices
     * @return {object} A random choice object from the array
     */ Common.choose = function(choices) {
                        return choices[Math.floor(Common.random() * choices.length)];
                    };
                    /**
     * Returns true if the object is a HTMLElement, otherwise false.
     * @method isElement
     * @param {object} obj
     * @return {boolean} True if the object is a HTMLElement, otherwise false
     */ Common.isElement = function(obj) {
                        if (typeof HTMLElement !== 'undefined') return obj instanceof HTMLElement;
                        return !!(obj && obj.nodeType && obj.nodeName);
                    };
                    /**
     * Returns true if the object is an array.
     * @method isArray
     * @param {object} obj
     * @return {boolean} True if the object is an array, otherwise false
     */ Common.isArray = function(obj) {
                        return Object.prototype.toString.call(obj) === '[object Array]';
                    };
                    /**
     * Returns true if the object is a function.
     * @method isFunction
     * @param {object} obj
     * @return {boolean} True if the object is a function, otherwise false
     */ Common.isFunction = function(obj) {
                        return typeof obj === "function";
                    };
                    /**
     * Returns true if the object is a plain object.
     * @method isPlainObject
     * @param {object} obj
     * @return {boolean} True if the object is a plain object, otherwise false
     */ Common.isPlainObject = function(obj) {
                        return typeof obj === 'object' && obj.constructor === Object;
                    };
                    /**
     * Returns true if the object is a string.
     * @method isString
     * @param {object} obj
     * @return {boolean} True if the object is a string, otherwise false
     */ Common.isString = function(obj) {
                        return toString.call(obj) === '[object String]';
                    };
                    /**
     * Returns the given value clamped between a minimum and maximum value.
     * @method clamp
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @return {number} The value clamped between min and max inclusive
     */ Common.clamp = function(value, min, max) {
                        if (value < min) return min;
                        if (value > max) return max;
                        return value;
                    };
                    /**
     * Returns the sign of the given value.
     * @method sign
     * @param {number} value
     * @return {number} -1 if negative, +1 if 0 or positive
     */ Common.sign = function(value) {
                        return value < 0 ? -1 : 1;
                    };
                    /**
     * Returns the current timestamp since the time origin (e.g. from page load).
     * The result is in milliseconds and will use high-resolution timing if available.
     * @method now
     * @return {number} the current timestamp in milliseconds
     */ Common.now = function() {
                        if (typeof window !== 'undefined' && window.performance) {
                            if (window.performance.now) return window.performance.now();
                            else if (window.performance.webkitNow) return window.performance.webkitNow();
                        }
                        if (Date.now) return Date.now();
                        return new Date() - Common._nowStartTime;
                    };
                    /**
     * Returns a random value between a minimum and a maximum value inclusive.
     * The function uses a seeded random generator.
     * @method random
     * @param {number} min
     * @param {number} max
     * @return {number} A random number between min and max inclusive
     */ Common.random = function(min, max) {
                        min = typeof min !== "undefined" ? min : 0;
                        max = typeof max !== "undefined" ? max : 1;
                        return min + _seededRandom() * (max - min);
                    };
                    var _seededRandom = function() {
                        // https://en.wikipedia.org/wiki/Linear_congruential_generator
                        Common._seed = (Common._seed * 9301 + 49297) % 233280;
                        return Common._seed / 233280;
                    };
                    /**
     * Converts a CSS hex colour string into an integer.
     * @method colorToNumber
     * @param {string} colorString
     * @return {number} An integer representing the CSS hex string
     */ Common.colorToNumber = function(colorString) {
                        colorString = colorString.replace('#', '');
                        if (colorString.length == 3) colorString = colorString.charAt(0) + colorString.charAt(0) + colorString.charAt(1) + colorString.charAt(1) + colorString.charAt(2) + colorString.charAt(2);
                        return parseInt(colorString, 16);
                    };
                    /**
     * The console logging level to use, where each level includes all levels above and excludes the levels below.
     * The default level is 'debug' which shows all console messages.  
     *
     * Possible level values are:
     * - 0 = None
     * - 1 = Debug
     * - 2 = Info
     * - 3 = Warn
     * - 4 = Error
     * @property Common.logLevel
     * @type {Number}
     * @default 1
     */ Common.logLevel = 1;
                    /**
     * Shows a `console.log` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method log
     * @param ...objs {} The objects to log.
     */ Common.log = function() {
                        if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.log.apply(console, [
                            'matter-js:'
                        ].concat(Array.prototype.slice.call(arguments)));
                    };
                    /**
     * Shows a `console.info` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method info
     * @param ...objs {} The objects to log.
     */ Common.info = function() {
                        if (console && Common.logLevel > 0 && Common.logLevel <= 2) console.info.apply(console, [
                            'matter-js:'
                        ].concat(Array.prototype.slice.call(arguments)));
                    };
                    /**
     * Shows a `console.warn` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method warn
     * @param ...objs {} The objects to log.
     */ Common.warn = function() {
                        if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.warn.apply(console, [
                            'matter-js:'
                        ].concat(Array.prototype.slice.call(arguments)));
                    };
                    /**
     * Uses `Common.warn` to log the given message one time only.
     * @method warnOnce
     * @param ...objs {} The objects to log.
     */ Common.warnOnce = function() {
                        var message = Array.prototype.slice.call(arguments).join(' ');
                        if (!Common._warnedOnce[message]) {
                            Common.warn(message);
                            Common._warnedOnce[message] = true;
                        }
                    };
                    /**
     * Shows a deprecated console warning when the function on the given object is called.
     * The target function will be replaced with a new function that first shows the warning
     * and then calls the original function.
     * @method deprecated
     * @param {object} obj The object or module
     * @param {string} name The property name of the function on obj
     * @param {string} warning The one-time message to show if the function is called
     */ Common.deprecated = function(obj, prop, warning) {
                        obj[prop] = Common.chain(function() {
                            Common.warnOnce("\uD83D\uDD05 deprecated \uD83D\uDD05", warning);
                        }, obj[prop]);
                    };
                    /**
     * Returns the next unique sequential ID.
     * @method nextId
     * @return {Number} Unique sequential ID
     */ Common.nextId = function() {
                        return Common._nextId++;
                    };
                    /**
     * A cross browser compatible indexOf implementation.
     * @method indexOf
     * @param {array} haystack
     * @param {object} needle
     * @return {number} The position of needle in haystack, otherwise -1.
     */ Common.indexOf = function(haystack, needle) {
                        if (haystack.indexOf) return haystack.indexOf(needle);
                        for(var i = 0; i < haystack.length; i++){
                            if (haystack[i] === needle) return i;
                        }
                        return -1;
                    };
                    /**
     * A cross browser compatible array map implementation.
     * @method map
     * @param {array} list
     * @param {function} func
     * @return {array} Values from list transformed by func.
     */ Common.map = function(list, func) {
                        if (list.map) return list.map(func);
                        var mapped = [];
                        for(var i = 0; i < list.length; i += 1)mapped.push(func(list[i]));
                        return mapped;
                    };
                    /**
     * Takes a directed graph and returns the partially ordered set of vertices in topological order.
     * Circular dependencies are allowed.
     * @method topologicalSort
     * @param {object} graph
     * @return {array} Partially ordered set of vertices in topological order.
     */ Common.topologicalSort = function(graph) {
                        // https://github.com/mgechev/javascript-algorithms
                        // Copyright (c) Minko Gechev (MIT license)
                        // Modifications: tidy formatting and naming
                        var result = [], visited = [], temp = [];
                        for(var node in graph)if (!visited[node] && !temp[node]) Common._topologicalSort(node, visited, temp, graph, result);
                        return result;
                    };
                    Common._topologicalSort = function(node, visited, temp, graph, result) {
                        var neighbors = graph[node] || [];
                        temp[node] = true;
                        for(var i = 0; i < neighbors.length; i += 1){
                            var neighbor = neighbors[i];
                            if (temp[neighbor]) continue;
                            if (!visited[neighbor]) Common._topologicalSort(neighbor, visited, temp, graph, result);
                        }
                        temp[node] = false;
                        visited[node] = true;
                        result.push(node);
                    };
                    /**
     * Takes _n_ functions as arguments and returns a new function that calls them in order.
     * The arguments applied when calling the new function will also be applied to every function passed.
     * The value of `this` refers to the last value returned in the chain that was not `undefined`.
     * Therefore if a passed function does not return a value, the previously returned value is maintained.
     * After all passed functions have been called the new function returns the last returned value (if any).
     * If any of the passed functions are a chain, then the chain will be flattened.
     * @method chain
     * @param ...funcs {function} The functions to chain.
     * @return {function} A new function that calls the passed functions in order.
     */ Common.chain = function() {
                        var funcs = [];
                        for(var i = 0; i < arguments.length; i += 1){
                            var func = arguments[i];
                            if (func._chained) // flatten already chained functions
                            funcs.push.apply(funcs, func._chained);
                            else funcs.push(func);
                        }
                        var chain = function() {
                            // https://github.com/GoogleChrome/devtools-docs/issues/53#issuecomment-51941358
                            var lastResult, args = new Array(arguments.length);
                            for(var i = 0, l = arguments.length; i < l; i++)args[i] = arguments[i];
                            for(i = 0; i < funcs.length; i += 1){
                                var result = funcs[i].apply(lastResult, args);
                                if (typeof result !== 'undefined') lastResult = result;
                            }
                            return lastResult;
                        };
                        chain._chained = funcs;
                        return chain;
                    };
                    /**
     * Chains a function to excute before the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathBefore
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathBefore = function(base, path, func) {
                        return Common.set(base, path, Common.chain(func, Common.get(base, path)));
                    };
                    /**
     * Chains a function to excute after the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathAfter
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathAfter = function(base, path, func) {
                        return Common.set(base, path, Common.chain(Common.get(base, path), func));
                    };
                    /**
     * Provide the [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module to enable
     * concave vertex decomposition support when using `Bodies.fromVertices` e.g. `Common.setDecomp(require('poly-decomp'))`.
     * @method setDecomp
     * @param {} decomp The [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module.
     */ Common.setDecomp = function(decomp) {
                        Common._decomp = decomp;
                    };
                    /**
     * Returns the [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module provided through `Common.setDecomp`,
     * otherwise returns the global `decomp` if set.
     * @method getDecomp
     * @return {} The [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module if provided.
     */ Common.getDecomp = function() {
                        // get user provided decomp if set
                        var decomp = Common._decomp;
                        try {
                            // otherwise from window global
                            if (!decomp && typeof window !== 'undefined') decomp = window.decomp;
                            // otherwise from node global
                            if (!decomp && typeof __webpack_require__.g !== 'undefined') decomp = __webpack_require__.g.decomp;
                        } catch (e) {
                            // decomp not available
                            decomp = null;
                        }
                        return decomp;
                    };
                })();
            /***/ },
            /***/ 48413: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Engine` module contains methods for creating and manipulating engines.
* An engine is a controller that manages updating the simulation of the world.
* See `Matter.Runner` for an optional game loop utility.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Engine
*/ var Engine = {};
                module1.exports = Engine;
                var Sleeping = __webpack_require__(53614);
                var Resolver = __webpack_require__(66272);
                var Detector = __webpack_require__(81388);
                var Pairs = __webpack_require__(99561);
                var Events = __webpack_require__(35810);
                var Composite = __webpack_require__(69351);
                var Constraint = __webpack_require__(48140);
                var Common = __webpack_require__(53402);
                var Body = __webpack_require__(22562);
                (function() {
                    Engine._deltaMax = 1000 / 60;
                    /**
     * Creates a new engine. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {object} [options]
     * @return {engine} engine
     */ Engine.create = function(options) {
                        options = options || {};
                        var defaults = {
                            positionIterations: 6,
                            velocityIterations: 4,
                            constraintIterations: 2,
                            enableSleeping: false,
                            events: [],
                            plugin: {},
                            gravity: {
                                x: 0,
                                y: 1,
                                scale: 0.001
                            },
                            timing: {
                                timestamp: 0,
                                timeScale: 1,
                                lastDelta: 0,
                                lastElapsed: 0,
                                lastUpdatesPerFrame: 0
                            }
                        };
                        var engine = Common.extend(defaults, options);
                        engine.world = options.world || Composite.create({
                            label: 'World'
                        });
                        engine.pairs = options.pairs || Pairs.create();
                        engine.detector = options.detector || Detector.create();
                        engine.detector.pairs = engine.pairs;
                        // for temporary back compatibility only
                        engine.grid = {
                            buckets: []
                        };
                        engine.world.gravity = engine.gravity;
                        engine.broadphase = engine.grid;
                        engine.metrics = {};
                        return engine;
                    };
                    /**
     * Moves the simulation forward in time by `delta` ms.
     * Triggers `beforeUpdate` and `afterUpdate` events.
     * Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     * @method update
     * @param {engine} engine
     * @param {number} [delta=16.666]
     */ Engine.update = function(engine, delta) {
                        var startTime = Common.now();
                        var world = engine.world, detector = engine.detector, pairs = engine.pairs, timing = engine.timing, timestamp = timing.timestamp, i;
                        if (delta > Engine._deltaMax) Common.warnOnce('Matter.Engine.update: delta argument is recommended to be less than or equal to', Engine._deltaMax.toFixed(3), 'ms.');
                        delta = typeof delta !== 'undefined' ? delta : Common._baseDelta;
                        delta *= timing.timeScale;
                        // increment timestamp
                        timing.timestamp += delta;
                        timing.lastDelta = delta;
                        // create an event object
                        var event = {
                            timestamp: timing.timestamp,
                            delta: delta
                        };
                        Events.trigger(engine, 'beforeUpdate', event);
                        // get all bodies and all constraints in the world
                        var allBodies = Composite.allBodies(world), allConstraints = Composite.allConstraints(world), allComposites = Composite.allComposites(world);
                        // if the world has changed
                        if (world.isModified) {
                            // update the detector bodies
                            Detector.setBodies(detector, allBodies);
                            // reset all composite modified flags
                            Composite.setModified(world, false, false, true);
                        }
                        // update sleeping if enabled
                        if (engine.enableSleeping) Sleeping.update(allBodies, delta);
                        // apply gravity to all bodies
                        Engine._bodiesApplyGravity(allBodies, engine.gravity);
                        Engine.wrap(allBodies, allComposites);
                        Engine.attractors(allBodies);
                        // update all body position and rotation by integration
                        if (delta > 0) Engine._bodiesUpdate(allBodies, delta);
                        Events.trigger(engine, 'beforeSolve', event);
                        // update all constraints (first pass)
                        Constraint.preSolveAll(allBodies);
                        for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, delta);
                        Constraint.postSolveAll(allBodies);
                        // find all collisions
                        var collisions = Detector.collisions(detector);
                        // update collision pairs
                        Pairs.update(pairs, collisions, timestamp);
                        // wake up bodies involved in collisions
                        if (engine.enableSleeping) Sleeping.afterCollisions(pairs.list);
                        // trigger collision events
                        if (pairs.collisionStart.length > 0) Events.trigger(engine, 'collisionStart', {
                            pairs: pairs.collisionStart,
                            timestamp: timing.timestamp,
                            delta: delta
                        });
                        // iteratively resolve position between collisions
                        var positionDamping = Common.clamp(20 / engine.positionIterations, 0, 1);
                        Resolver.preSolvePosition(pairs.list);
                        for(i = 0; i < engine.positionIterations; i++)Resolver.solvePosition(pairs.list, delta, positionDamping);
                        Resolver.postSolvePosition(allBodies);
                        // update all constraints (second pass)
                        Constraint.preSolveAll(allBodies);
                        for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, delta);
                        Constraint.postSolveAll(allBodies);
                        // iteratively resolve velocity between collisions
                        Resolver.preSolveVelocity(pairs.list);
                        for(i = 0; i < engine.velocityIterations; i++)Resolver.solveVelocity(pairs.list, delta);
                        // update body speed and velocity properties
                        Engine._bodiesUpdateVelocities(allBodies);
                        // trigger collision events
                        if (pairs.collisionActive.length > 0) Events.trigger(engine, 'collisionActive', {
                            pairs: pairs.collisionActive,
                            timestamp: timing.timestamp,
                            delta: delta
                        });
                        if (pairs.collisionEnd.length > 0) Events.trigger(engine, 'collisionEnd', {
                            pairs: pairs.collisionEnd,
                            timestamp: timing.timestamp,
                            delta: delta
                        });
                        // clear force buffers
                        Engine._bodiesClearForces(allBodies);
                        Events.trigger(engine, 'afterUpdate', event);
                        // log the time elapsed computing this update
                        engine.timing.lastElapsed = Common.now() - startTime;
                        return engine;
                    };
                    /**
     * Merges two engines by keeping the configuration of `engineA` but replacing the world with the one from `engineB`.
     * @method merge
     * @param {engine} engineA
     * @param {engine} engineB
     */ Engine.merge = function(engineA, engineB) {
                        Common.extend(engineA, engineB);
                        if (engineB.world) {
                            engineA.world = engineB.world;
                            Engine.clear(engineA);
                            var bodies = Composite.allBodies(engineA.world);
                            for(var i = 0; i < bodies.length; i++){
                                var body = bodies[i];
                                Sleeping.set(body, false);
                                body.id = Common.nextId();
                            }
                        }
                    };
                    /**
     * Clears the engine pairs and detector.
     * @method clear
     * @param {engine} engine
     */ Engine.clear = function(engine) {
                        Pairs.clear(engine.pairs);
                        Detector.clear(engine.detector);
                    };
                    /**
     * Zeroes the `body.force` and `body.torque` force buffers.
     * @method _bodiesClearForces
     * @private
     * @param {body[]} bodies
     */ Engine._bodiesClearForces = function(bodies) {
                        var bodiesLength = bodies.length;
                        for(var i = 0; i < bodiesLength; i++){
                            var body = bodies[i];
                            // reset force buffers
                            body.force.x = 0;
                            body.force.y = 0;
                            body.torque = 0;
                        }
                    };
                    /**
     * Applys a mass dependant force to all given bodies.
     * @method _bodiesApplyGravity
     * @private
     * @param {body[]} bodies
     * @param {vector} gravity
     */ Engine._bodiesApplyGravity = function(bodies, gravity) {
                        var gravityScale = typeof gravity.scale !== 'undefined' ? gravity.scale : 0.001, bodiesLength = bodies.length;
                        if (gravity.x === 0 && gravity.y === 0 || gravityScale === 0) return;
                        for(var i = 0; i < bodiesLength; i++){
                            var body = bodies[i];
                            if (body.ignoreGravity || body.isStatic || body.isSleeping) continue;
                            // add the resultant force of gravity
                            body.force.y += body.mass * gravity.y * gravityScale;
                            body.force.x += body.mass * gravity.x * gravityScale;
                        }
                    };
                    /**
     * Applies `Body.update` to all given `bodies`.
     * @method _bodiesUpdate
     * @private
     * @param {body[]} bodies
     * @param {number} delta The amount of time elapsed between updates
     */ Engine._bodiesUpdate = function(bodies, delta) {
                        var bodiesLength = bodies.length;
                        for(var i = 0; i < bodiesLength; i++){
                            var body = bodies[i];
                            if (body.isStatic || body.isSleeping) continue;
                            Body.update(body, delta);
                        }
                    };
                    /**
     * Applies `Body.updateVelocities` to all given `bodies`.
     * @method _bodiesUpdateVelocities
     * @private
     * @param {body[]} bodies
     */ Engine._bodiesUpdateVelocities = function(bodies) {
                        var bodiesLength = bodies.length;
                        for(var i = 0; i < bodiesLength; i++)Body.updateVelocities(bodies[i]);
                    };
                    /**
     * Applies `Body.wrap` and `Composite.wrap` and to all given `bodies`.
     * @method wrap
     * @private
     * @param {body[]} bodies
     */ Engine.wrap = function(bodies, composites) {
                        // wrap bodies within the wrapBounds parameters
                        for(var i = 0; i < bodies.length; i += 1){
                            var body = bodies[i];
                            if (body.wrapBounds !== null) Body.wrap(body, body.wrapBounds);
                        }
                        // wrap composites within the wrapBounds parameters
                        for(i = 0; i < composites.length; i += 1){
                            var composite = composites[i];
                            if (composite.wrapBounds !== null) Composite.wrap(composite, composite.wrapBounds);
                        }
                    };
                    /**
     * Applies all attractors for all bodies in the `engine`.
     * This is called automatically.
     * @method attractors
     * @private
     * @param {body[]} bodies
     */ Engine.attractors = function(bodies) {
                        for(var i = 0; i < bodies.length; i++){
                            var bodyA = bodies[i];
                            var attractors = bodyA.attractors;
                            if (attractors && attractors.length > 0) for(var j = 0; j < bodies.length; j++){
                                var bodyB = bodies[j];
                                if (i !== j) for(var k = 0; k < attractors.length; k++){
                                    var attractor = attractors[k];
                                    var forceVector = attractor;
                                    if (Common.isFunction(attractor)) forceVector = attractor(bodyA, bodyB);
                                    if (forceVector) Body.applyForce(bodyB, bodyB.position, forceVector);
                                }
                            }
                        }
                    };
                /**
     * A deprecated alias for `Runner.run`, use `Matter.Runner.run(engine)` instead and see `Matter.Runner` for more information.
     * @deprecated use Matter.Runner.run(engine) instead
     * @method run
     * @param {engine} engine
     */ /**
    * Fired just before an update
    *
    * @event beforeUpdate
    * @param {object} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update and all collision events
    *
    * @event afterUpdate
    * @param {object} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have started to collide in the current tick (if any)
    *
    * @event collisionStart
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that are colliding in the current tick (if any)
    *
    * @event collisionActive
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have ended collision in the current tick (if any)
    *
    * @event collisionEnd
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` that specifies the number of position iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property positionIterations
     * @type number
     * @default 6
     */ /**
     * An integer `Number` that specifies the number of velocity iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property velocityIterations
     * @type number
     * @default 4
     */ /**
     * An integer `Number` that specifies the number of constraint iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     * The default value of `2` is usually very adequate.
     *
     * @property constraintIterations
     * @type number
     * @default 2
     */ /**
     * A flag that specifies whether the engine should allow sleeping via the `Matter.Sleeping` module.
     * Sleeping can improve stability and performance, but often at the expense of accuracy.
     *
     * @property enableSleeping
     * @type boolean
     * @default false
     */ /**
     * An `Object` containing properties regarding the timing systems of the engine.
     *
     * @property timing
     * @type object
     */ /**
     * A `Number` that specifies the global scaling factor of time for all bodies.
     * A value of `0` freezes the simulation.
     * A value of `0.1` gives a slow-motion effect.
     * A value of `1.2` gives a speed-up effect.
     *
     * @property timing.timeScale
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the current simulation-time in milliseconds starting from `0`.
     * It is incremented on every `Engine.update` by the given `delta` argument.
     *
     * @property timing.timestamp
     * @type number
     * @default 0
     */ /**
     * A `Number` that represents the total execution time elapsed during the last `Engine.update` in milliseconds.
     * It is updated by timing from the start of the last `Engine.update` call until it ends.
     *
     * This value will also include the total execution time of all event handlers directly or indirectly triggered by the engine update.
     *
     * @property timing.lastElapsed
     * @type number
     * @default 0
     */ /**
     * A `Number` that represents the `delta` value used in the last engine update.
     *
     * @property timing.lastDelta
     * @type number
     * @default 0
     */ /**
     * A `Matter.Detector` instance.
     *
     * @property detector
     * @type detector
     * @default a Matter.Detector instance
     */ /**
     * A `Matter.Grid` instance.
     *
     * @deprecated replaced by `engine.detector`
     * @property grid
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * Replaced by and now alias for `engine.grid`.
     *
     * @deprecated replaced by `engine.detector`
     * @property broadphase
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * The root `Matter.Composite` instance that will contain all bodies, constraints and other composites to be simulated by this engine.
     *
     * @property world
     * @type composite
     * @default a Matter.Composite instance
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * The gravity to apply on all bodies in `engine.world`.
     *
     * @property gravity
     * @type object
     */ /**
     * The gravity x component.
     *
     * @property gravity.x
     * @type object
     * @default 0
     */ /**
     * The gravity y component.
     *
     * @property gravity.y
     * @type object
     * @default 1
     */ /**
     * The gravity scale factor.
     *
     * @property gravity.scale
     * @type object
     * @default 0.001
     */ })();
            /***/ },
            /***/ 35810: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Events` module contains methods to fire and listen to events on other objects.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Events
*/ var Events = {};
                module1.exports = Events;
                var Common = __webpack_require__(53402);
                (function() {
                    /**
     * Subscribes a callback function to the given object's `eventName`.
     * @method on
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.on = function(object, eventNames, callback) {
                        var names = eventNames.split(' '), name;
                        for(var i = 0; i < names.length; i++){
                            name = names[i];
                            object.events = object.events || {};
                            object.events[name] = object.events[name] || [];
                            object.events[name].push(callback);
                        }
                        return callback;
                    };
                    /**
     * Removes the given event callback. If no callback, clears all callbacks in `eventNames`. If no `eventNames`, clears all events.
     * @method off
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.off = function(object, eventNames, callback) {
                        if (!eventNames) {
                            object.events = {};
                            return;
                        }
                        // handle Events.off(object, callback)
                        if (typeof eventNames === 'function') {
                            callback = eventNames;
                            eventNames = Common.keys(object.events).join(' ');
                        }
                        var names = eventNames.split(' ');
                        for(var i = 0; i < names.length; i++){
                            var callbacks = object.events[names[i]], newCallbacks = [];
                            if (callback && callbacks) {
                                for(var j = 0; j < callbacks.length; j++)if (callbacks[j] !== callback) newCallbacks.push(callbacks[j]);
                            }
                            object.events[names[i]] = newCallbacks;
                        }
                    };
                    /**
     * Fires all the callbacks subscribed to the given object's `eventName`, in the order they subscribed, if any.
     * @method trigger
     * @param {} object
     * @param {string} eventNames
     * @param {} event
     */ Events.trigger = function(object, eventNames, event) {
                        var names, name, callbacks, eventClone;
                        var events = object.events;
                        if (events && Common.keys(events).length > 0) {
                            if (!event) event = {};
                            names = eventNames.split(' ');
                            for(var i = 0; i < names.length; i++){
                                name = names[i];
                                callbacks = events[name];
                                if (callbacks) {
                                    eventClone = Common.clone(event, false);
                                    eventClone.name = name;
                                    eventClone.source = object;
                                    for(var j = 0; j < callbacks.length; j++)callbacks[j].apply(object, [
                                        eventClone
                                    ]);
                                }
                            }
                        }
                    };
                })();
            /***/ },
            /***/ 6790: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter` module is the top level namespace. It also includes a function for installing plugins on top of the library.
*
* @class Matter
*/ var Matter = {};
                module1.exports = Matter;
                var Plugin = __webpack_require__(73832);
                var Common = __webpack_require__(53402);
                (function() {
                    /**
     * The library name.
     * @property name
     * @readOnly
     * @type {String}
     */ Matter.name = 'matter-js';
                    /**
     * The library version.
     * @property version
     * @readOnly
     * @type {String}
     */ Matter.version = '0.20.0';
                    /**
     * A list of plugin dependencies to be installed. These are normally set and installed through `Matter.use`.
     * Alternatively you may set `Matter.uses` manually and install them by calling `Plugin.use(Matter)`.
     * @property uses
     * @type {Array}
     */ Matter.uses = [];
                    /**
     * The plugins that have been installed through `Matter.Plugin.install`. Read only.
     * @property used
     * @readOnly
     * @type {Array}
     */ Matter.used = [];
                    /**
     * Installs the given plugins on the `Matter` namespace.
     * This is a short-hand for `Plugin.use`, see it for more information.
     * Call this function once at the start of your code, with all of the plugins you wish to install as arguments.
     * Avoid calling this function multiple times unless you intend to manually control installation order.
     * @method use
     * @param ...plugin {Function} The plugin(s) to install on `base` (multi-argument).
     */ Matter.use = function() {
                        Plugin.use(Matter, Array.prototype.slice.call(arguments));
                    };
                    /**
     * Chains a function to excute before the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method before
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Matter.before = function(path, func) {
                        path = path.replace(/^Matter./, '');
                        return Common.chainPathBefore(Matter, path, func);
                    };
                    /**
     * Chains a function to excute after the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method after
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Matter.after = function(path, func) {
                        path = path.replace(/^Matter./, '');
                        return Common.chainPathAfter(Matter, path, func);
                    };
                })();
            /***/ },
            /***/ 73832: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Plugin` module contains functions for registering and installing plugins on modules.
*
* @class Plugin
*/ var Plugin = {};
                module1.exports = Plugin;
                var Common = __webpack_require__(53402);
                (function() {
                    Plugin._registry = {};
                    /**
     * Registers a plugin object so it can be resolved later by name.
     * @method register
     * @param plugin {} The plugin to register.
     * @return {object} The plugin.
     */ Plugin.register = function(plugin) {
                        if (!Plugin.isPlugin(plugin)) Common.warn('Plugin.register:', Plugin.toString(plugin), 'does not implement all required fields.');
                        if (plugin.name in Plugin._registry) {
                            var registered = Plugin._registry[plugin.name], pluginVersion = Plugin.versionParse(plugin.version).number, registeredVersion = Plugin.versionParse(registered.version).number;
                            if (pluginVersion > registeredVersion) {
                                Common.warn('Plugin.register:', Plugin.toString(registered), 'was upgraded to', Plugin.toString(plugin));
                                Plugin._registry[plugin.name] = plugin;
                            } else if (pluginVersion < registeredVersion) Common.warn('Plugin.register:', Plugin.toString(registered), 'can not be downgraded to', Plugin.toString(plugin));
                            else if (plugin !== registered) Common.warn('Plugin.register:', Plugin.toString(plugin), 'is already registered to different plugin object');
                        } else Plugin._registry[plugin.name] = plugin;
                        return plugin;
                    };
                    /**
     * Resolves a dependency to a plugin object from the registry if it exists.
     * The `dependency` may contain a version, but only the name matters when resolving.
     * @method resolve
     * @param dependency {string} The dependency.
     * @return {object} The plugin if resolved, otherwise `undefined`.
     */ Plugin.resolve = function(dependency) {
                        return Plugin._registry[Plugin.dependencyParse(dependency).name];
                    };
                    /**
     * Returns a pretty printed plugin name and version.
     * @method toString
     * @param plugin {} The plugin.
     * @return {string} Pretty printed plugin name and version.
     */ Plugin.toString = function(plugin) {
                        return typeof plugin === 'string' ? plugin : (plugin.name || 'anonymous') + '@' + (plugin.version || plugin.range || '0.0.0');
                    };
                    /**
     * Returns `true` if the object meets the minimum standard to be considered a plugin.
     * This means it must define the following properties:
     * - `name`
     * - `version`
     * - `install`
     * @method isPlugin
     * @param obj {} The obj to test.
     * @return {boolean} `true` if the object can be considered a plugin otherwise `false`.
     */ Plugin.isPlugin = function(obj) {
                        return obj && obj.name && obj.version && obj.install;
                    };
                    /**
     * Returns `true` if a plugin with the given `name` been installed on `module`.
     * @method isUsed
     * @param module {} The module.
     * @param name {string} The plugin name.
     * @return {boolean} `true` if a plugin with the given `name` been installed on `module`, otherwise `false`.
     */ Plugin.isUsed = function(module1, name) {
                        return module1.used.indexOf(name) > -1;
                    };
                    /**
     * Returns `true` if `plugin.for` is applicable to `module` by comparing against `module.name` and `module.version`.
     * If `plugin.for` is not specified then it is assumed to be applicable.
     * The value of `plugin.for` is a string of the format `'module-name'` or `'module-name@version'`.
     * @method isFor
     * @param plugin {} The plugin.
     * @param module {} The module.
     * @return {boolean} `true` if `plugin.for` is applicable to `module`, otherwise `false`.
     */ Plugin.isFor = function(plugin, module1) {
                        var parsed = plugin.for && Plugin.dependencyParse(plugin.for);
                        return !plugin.for || module1.name === parsed.name && Plugin.versionSatisfies(module1.version, parsed.range);
                    };
                    /**
     * Installs the plugins by calling `plugin.install` on each plugin specified in `plugins` if passed, otherwise `module.uses`.
     * For installing plugins on `Matter` see the convenience function `Matter.use`.
     * Plugins may be specified either by their name or a reference to the plugin object.
     * Plugins themselves may specify further dependencies, but each plugin is installed only once.
     * Order is important, a topological sort is performed to find the best resulting order of installation.
     * This sorting attempts to satisfy every dependency's requested ordering, but may not be exact in all cases.
     * This function logs the resulting status of each dependency in the console, along with any warnings.
     * - A green tick ✅ indicates a dependency was resolved and installed.
     * - An orange diamond 🔶 indicates a dependency was resolved but a warning was thrown for it or one if its dependencies.
     * - A red cross ❌ indicates a dependency could not be resolved.
     * Avoid calling this function multiple times on the same module unless you intend to manually control installation order.
     * @method use
     * @param module {} The module install plugins on.
     * @param [plugins=module.uses] {} The plugins to install on module (optional, defaults to `module.uses`).
     */ Plugin.use = function(module1, plugins) {
                        module1.uses = (module1.uses || []).concat(plugins || []);
                        if (module1.uses.length === 0) {
                            Common.warn('Plugin.use:', Plugin.toString(module1), 'does not specify any dependencies to install.');
                            return;
                        }
                        var dependencies = Plugin.dependencies(module1), sortedDependencies = Common.topologicalSort(dependencies), status = [];
                        for(var i = 0; i < sortedDependencies.length; i += 1){
                            if (sortedDependencies[i] === module1.name) continue;
                            var plugin = Plugin.resolve(sortedDependencies[i]);
                            if (!plugin) {
                                status.push("\u274C " + sortedDependencies[i]);
                                continue;
                            }
                            if (Plugin.isUsed(module1, plugin.name)) continue;
                            if (!Plugin.isFor(plugin, module1)) {
                                Common.warn('Plugin.use:', Plugin.toString(plugin), 'is for', plugin.for, 'but installed on', Plugin.toString(module1) + '.');
                                plugin._warned = true;
                            }
                            if (plugin.install) plugin.install(module1);
                            else {
                                Common.warn('Plugin.use:', Plugin.toString(plugin), 'does not specify an install function.');
                                plugin._warned = true;
                            }
                            if (plugin._warned) {
                                status.push("\uD83D\uDD36 " + Plugin.toString(plugin));
                                delete plugin._warned;
                            } else status.push("\u2705 " + Plugin.toString(plugin));
                            module1.used.push(plugin.name);
                        }
                        if (status.length > 0 && !plugin.silent) Common.info(status.join('  '));
                    };
                    /**
     * Recursively finds all of a module's dependencies and returns a flat dependency graph.
     * @method dependencies
     * @param module {} The module.
     * @return {object} A dependency graph.
     */ Plugin.dependencies = function(module1, tracked) {
                        var parsedBase = Plugin.dependencyParse(module1), name = parsedBase.name;
                        tracked = tracked || {};
                        if (name in tracked) return;
                        module1 = Plugin.resolve(module1) || module1;
                        tracked[name] = Common.map(module1.uses || [], function(dependency) {
                            if (Plugin.isPlugin(dependency)) Plugin.register(dependency);
                            var parsed = Plugin.dependencyParse(dependency), resolved = Plugin.resolve(dependency);
                            if (resolved && !Plugin.versionSatisfies(resolved.version, parsed.range)) {
                                Common.warn('Plugin.dependencies:', Plugin.toString(resolved), 'does not satisfy', Plugin.toString(parsed), 'used by', Plugin.toString(parsedBase) + '.');
                                resolved._warned = true;
                                module1._warned = true;
                            } else if (!resolved) {
                                Common.warn('Plugin.dependencies:', Plugin.toString(dependency), 'used by', Plugin.toString(parsedBase), 'could not be resolved.');
                                module1._warned = true;
                            }
                            return parsed.name;
                        });
                        for(var i = 0; i < tracked[name].length; i += 1)Plugin.dependencies(tracked[name][i], tracked);
                        return tracked;
                    };
                    /**
     * Parses a dependency string into its components.
     * The `dependency` is a string of the format `'module-name'` or `'module-name@version'`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * This function can also handle dependencies that are already resolved (e.g. a module object).
     * @method dependencyParse
     * @param dependency {string} The dependency of the format `'module-name'` or `'module-name@version'`.
     * @return {object} The dependency parsed into its components.
     */ Plugin.dependencyParse = function(dependency) {
                        if (Common.isString(dependency)) {
                            var pattern = /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-+]+)?))?$/;
                            if (!pattern.test(dependency)) Common.warn('Plugin.dependencyParse:', dependency, 'is not a valid dependency string.');
                            return {
                                name: dependency.split('@')[0],
                                range: dependency.split('@')[1] || '*'
                            };
                        }
                        return {
                            name: dependency.name,
                            range: dependency.range || dependency.version
                        };
                    };
                    /**
     * Parses a version string into its components.
     * Versions are strictly of the format `x.y.z` (as in [semver](http://semver.org/)).
     * Versions may optionally have a prerelease tag in the format `x.y.z-alpha`.
     * Ranges are a strict subset of [npm ranges](https://docs.npmjs.com/misc/semver#advanced-range-syntax).
     * Only the following range types are supported:
     * - Tilde ranges e.g. `~1.2.3`
     * - Caret ranges e.g. `^1.2.3`
     * - Greater than ranges e.g. `>1.2.3`
     * - Greater than or equal ranges e.g. `>=1.2.3`
     * - Exact version e.g. `1.2.3`
     * - Any version `*`
     * @method versionParse
     * @param range {string} The version string.
     * @return {object} The version range parsed into its components.
     */ Plugin.versionParse = function(range) {
                        var pattern = /^(\*)|(\^|~|>=|>)?\s*((\d+)\.(\d+)\.(\d+))(-[0-9A-Za-z-+]+)?$/;
                        if (!pattern.test(range)) Common.warn('Plugin.versionParse:', range, 'is not a valid version or range.');
                        var parts = pattern.exec(range);
                        var major = Number(parts[4]);
                        var minor = Number(parts[5]);
                        var patch = Number(parts[6]);
                        return {
                            isRange: Boolean(parts[1] || parts[2]),
                            version: parts[3],
                            range: range,
                            operator: parts[1] || parts[2] || '',
                            major: major,
                            minor: minor,
                            patch: patch,
                            parts: [
                                major,
                                minor,
                                patch
                            ],
                            prerelease: parts[7],
                            number: major * 1e8 + minor * 1e4 + patch
                        };
                    };
                    /**
     * Returns `true` if `version` satisfies the given `range`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * If a version or range is not specified, then any version (`*`) is assumed to satisfy.
     * @method versionSatisfies
     * @param version {string} The version string.
     * @param range {string} The range string.
     * @return {boolean} `true` if `version` satisfies `range`, otherwise `false`.
     */ Plugin.versionSatisfies = function(version, range) {
                        range = range || '*';
                        var r = Plugin.versionParse(range), v = Plugin.versionParse(version);
                        if (r.isRange) {
                            if (r.operator === '*' || version === '*') return true;
                            if (r.operator === '>') return v.number > r.number;
                            if (r.operator === '>=') return v.number >= r.number;
                            if (r.operator === '~') return v.major === r.major && v.minor === r.minor && v.patch >= r.patch;
                            if (r.operator === '^') {
                                if (r.major > 0) return v.major === r.major && v.number >= r.number;
                                if (r.minor > 0) return v.minor === r.minor && v.patch >= r.patch;
                                return v.patch === r.patch;
                            }
                        }
                        return version === range || version === '*';
                    };
                })();
            /***/ },
            /***/ 13037: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Runner` module is an optional utility which provides a game loop,
* that handles continuously updating a `Matter.Engine` for you within a browser.
* It is intended for development and debugging purposes, but may also be suitable for simple games.
* If you are using your own game loop instead, then you do not need the `Matter.Runner` module.
* Instead just call `Engine.update(engine, delta)` in your own loop.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Runner
*/ var Runner = {};
                module1.exports = Runner;
                var Events = __webpack_require__(35810);
                var Engine = __webpack_require__(48413);
                var Common = __webpack_require__(53402);
                (function() {
                    Runner._maxFrameDelta = 1000 / 15;
                    Runner._frameDeltaFallback = 1000 / 60;
                    Runner._timeBufferMargin = 1.5;
                    Runner._elapsedNextEstimate = 1;
                    Runner._smoothingLowerBound = 0.1;
                    Runner._smoothingUpperBound = 0.9;
                    /**
     * Creates a new Runner. The options parameter is an object that specifies any properties you wish to override the defaults.
     * @method create
     * @param {} options
     */ Runner.create = function(options) {
                        var defaults = {
                            delta: 1000 / 60,
                            frameDelta: null,
                            frameDeltaSmoothing: true,
                            frameDeltaSnapping: true,
                            frameDeltaHistory: [],
                            frameDeltaHistorySize: 100,
                            frameRequestId: null,
                            timeBuffer: 0,
                            timeLastTick: null,
                            maxUpdates: null,
                            maxFrameTime: 1000 / 30,
                            lastUpdatesDeferred: 0,
                            enabled: true
                        };
                        var runner = Common.extend(defaults, options);
                        // for temporary back compatibility only
                        runner.fps = 0;
                        return runner;
                    };
                    /**
     * Continuously ticks a `Matter.Engine` by calling `Runner.tick` on the `requestAnimationFrame` event.
     * @method run
     * @param {engine} engine
     */ Runner.run = function(runner, engine) {
                        // create runner if engine is first argument
                        runner.timeBuffer = Runner._frameDeltaFallback;
                        (function onFrame(time) {
                            runner.frameRequestId = Runner._onNextFrame(runner, onFrame);
                            if (time && runner.enabled) Runner.tick(runner, engine, time);
                        })();
                        return runner;
                    };
                    /**
     * A game loop utility that updates the engine and renderer by one step (a 'tick').
     * Features delta smoothing, time correction and fixed or dynamic timing.
     * Consider just `Engine.update(engine, delta)` if you're using your own loop.
     * @method tick
     * @param {runner} runner
     * @param {engine} engine
     * @param {number} time
     */ Runner.tick = function(runner, engine, time) {
                        var tickStartTime = Common.now(), engineDelta = runner.delta, updateCount = 0;
                        // fixed timestep
                        var frameDelta = time - runner.timeLastTick;
                        if (!frameDelta || !runner.timeLastTick || frameDelta > Math.max(Runner._maxFrameDelta, runner.maxFrameTime)) // dynamic timestep based on wall clock between calls
                        frameDelta = runner.frameDelta || Runner._frameDeltaFallback;
                        if (runner.frameDeltaSmoothing) {
                            // optimistically filter delta over a few frames, to improve stability
                            runner.frameDeltaHistory.push(frameDelta);
                            runner.frameDeltaHistory = runner.frameDeltaHistory.slice(-runner.frameDeltaHistorySize);
                            var deltaHistorySorted = runner.frameDeltaHistory.slice(0).sort();
                            // limit delta
                            var deltaHistoryWindow = runner.frameDeltaHistory.slice(deltaHistorySorted.length * Runner._smoothingLowerBound, deltaHistorySorted.length * Runner._smoothingUpperBound);
                            // update engine timing object
                            var frameDeltaSmoothed = _mean(deltaHistoryWindow);
                            frameDelta = frameDeltaSmoothed || frameDelta;
                        }
                        if (runner.frameDeltaSnapping) frameDelta = 1000 / Math.round(1000 / frameDelta);
                        runner.frameDelta = frameDelta;
                        runner.timeLastTick = time;
                        runner.timeBuffer += runner.frameDelta;
                        runner.timeBuffer = Common.clamp(runner.timeBuffer, 0, runner.frameDelta + engineDelta * Runner._timeBufferMargin);
                        runner.lastUpdatesDeferred = 0;
                        var maxUpdates = runner.maxUpdates || Math.ceil(runner.maxFrameTime / engineDelta);
                        // create an event object
                        var event = {
                            timestamp: engine.timing.timestamp
                        };
                        Events.trigger(runner, 'beforeTick', event);
                        // fps counter
                        Events.trigger(runner, 'tick', event);
                        var updateStartTime = Common.now();
                        while(engineDelta > 0 && runner.timeBuffer >= engineDelta * Runner._timeBufferMargin){
                            // update
                            Events.trigger(runner, 'beforeUpdate', event);
                            Engine.update(engine, engineDelta);
                            Events.trigger(runner, 'afterUpdate', event);
                            runner.timeBuffer -= engineDelta;
                            updateCount += 1;
                            var elapsedTimeTotal = Common.now() - tickStartTime, elapsedTimeUpdates = Common.now() - updateStartTime, elapsedNextEstimate = elapsedTimeTotal + Runner._elapsedNextEstimate * elapsedTimeUpdates / updateCount;
                            if (updateCount >= maxUpdates || elapsedNextEstimate > runner.maxFrameTime) {
                                runner.lastUpdatesDeferred = Math.round(Math.max(0, runner.timeBuffer / engineDelta - Runner._timeBufferMargin));
                                break;
                            }
                        }
                        engine.timing.lastUpdatesPerFrame = updateCount;
                        Events.trigger(runner, 'afterTick', event);
                        if (runner.frameDeltaHistory.length >= 100) {
                            if (runner.lastUpdatesDeferred && Math.round(runner.frameDelta / engineDelta) > maxUpdates) Common.warnOnce('Matter.Runner: runner reached runner.maxUpdates, see docs.');
                            else if (runner.lastUpdatesDeferred) Common.warnOnce('Matter.Runner: runner reached runner.maxFrameTime, see docs.');
                            if (typeof runner.isFixed !== 'undefined') Common.warnOnce('Matter.Runner: runner.isFixed is now redundant, see docs.');
                            if (runner.deltaMin || runner.deltaMax) Common.warnOnce('Matter.Runner: runner.deltaMin and runner.deltaMax were removed, see docs.');
                            if (runner.fps !== 0) Common.warnOnce('Matter.Runner: runner.fps was replaced by runner.delta, see docs.');
                        }
                    };
                    /**
     * Ends execution of `Runner.run` on the given `runner`, by canceling the animation frame request event loop.
     * If you wish to only temporarily pause the engine, see `engine.enabled` instead.
     * @method stop
     * @param {runner} runner
     */ Runner.stop = function(runner) {
                        Runner._cancelNextFrame(runner);
                    };
                    /**
     * Alias for `Runner.run`.
     * @method start
     * @param {runner} runner
     * @param {engine} engine
     */ Runner._onNextFrame = function(runner, callback) {
                        if (typeof window !== 'undefined' && window.requestAnimationFrame) runner.frameRequestId = window.requestAnimationFrame(callback);
                        else throw new Error('Matter.Runner: missing required global window.requestAnimationFrame.');
                        return runner.frameRequestId;
                    };
                    Runner._cancelNextFrame = function(runner) {
                        if (typeof window !== 'undefined' && window.cancelAnimationFrame) window.cancelAnimationFrame(runner.frameRequestId);
                        else throw new Error('Matter.Runner: missing required global window.cancelAnimationFrame.');
                    };
                    var _mean = function(values) {
                        var result = 0, valuesLength = values.length;
                        for(var i = 0; i < valuesLength; i += 1)result += values[i];
                        return result / valuesLength || 0;
                    };
                    Runner._mean = _mean;
                /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired at the start of a tick, before any updates to the engine or timing
    *
    * @event beforeTick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine timing updated, but just before update
    *
    * @event tick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired at the end of a tick, after engine update and after rendering
    *
    * @event afterTick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired before update
    *
    * @event beforeUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after update
    *
    * @event afterUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * A flag that specifies whether the runner is running or not.
     *
     * @property enabled
     * @type boolean
     * @default true
     */ /**
     * A `Number` that specifies the time step between updates in milliseconds.
     *
     * @property delta
     * @type number
     * @default 1000 / 60
     */ })();
            /***/ },
            /***/ 53614: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Sleeping` module contains methods to manage the sleeping state of bodies.
*
* @class Sleeping
*/ var Sleeping = {};
                module1.exports = Sleeping;
                var Body = __webpack_require__(22562);
                var Events = __webpack_require__(35810);
                var Common = __webpack_require__(53402);
                (function() {
                    Sleeping._motionWakeThreshold = 0.18;
                    Sleeping._motionSleepThreshold = 0.08;
                    Sleeping._minBias = 0.9;
                    /**
     * Puts bodies to sleep or wakes them up depending on their motion.
     * @method update
     * @param {body[]} bodies
     * @param {number} delta
     */ Sleeping.update = function(bodies, delta) {
                        var timeScale = delta / Common._baseDelta, motionSleepThreshold = Sleeping._motionSleepThreshold;
                        // update bodies sleeping status
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i], speed = Body.getSpeed(body), angularSpeed = Body.getAngularSpeed(body), motion = speed * speed + angularSpeed * angularSpeed;
                            // wake up bodies if they have a force applied
                            if (body.force.x !== 0 || body.force.y !== 0) {
                                Sleeping.set(body, false);
                                continue;
                            }
                            var minMotion = Math.min(body.motion, motion), maxMotion = Math.max(body.motion, motion);
                            // biased average motion estimation between frames
                            body.motion = Sleeping._minBias * minMotion + (1 - Sleeping._minBias) * maxMotion;
                            if (body.sleepThreshold > 0 && body.motion < motionSleepThreshold) {
                                body.sleepCounter += 1;
                                if (body.sleepCounter >= body.sleepThreshold / timeScale) Sleeping.set(body, true);
                            } else if (body.sleepCounter > 0) body.sleepCounter -= 1;
                        }
                    };
                    /**
     * Given a set of colliding pairs, wakes the sleeping bodies involved.
     * @method afterCollisions
     * @param {pair[]} pairs
     */ Sleeping.afterCollisions = function(pairs) {
                        var motionSleepThreshold = Sleeping._motionSleepThreshold;
                        // wake up bodies involved in collisions
                        for(var i = 0; i < pairs.length; i++){
                            var pair = pairs[i];
                            // don't wake inactive pairs
                            if (!pair.isActive) continue;
                            var collision = pair.collision, bodyA = collision.bodyA.parent, bodyB = collision.bodyB.parent;
                            // don't wake if at least one body is static
                            if (bodyA.isSleeping && bodyB.isSleeping || bodyA.isStatic || bodyB.isStatic) continue;
                            if (bodyA.isSleeping || bodyB.isSleeping) {
                                var sleepingBody = bodyA.isSleeping && !bodyA.isStatic ? bodyA : bodyB, movingBody = sleepingBody === bodyA ? bodyB : bodyA;
                                if (!sleepingBody.isStatic && movingBody.motion > motionSleepThreshold) Sleeping.set(sleepingBody, false);
                            }
                        }
                    };
                    /**
     * Set a body as sleeping or awake.
     * @method set
     * @param {body} body
     * @param {boolean} isSleeping
     */ Sleeping.set = function(body, isSleeping) {
                        var wasSleeping = body.isSleeping;
                        if (isSleeping) {
                            body.isSleeping = true;
                            body.sleepCounter = body.sleepThreshold;
                            body.positionImpulse.x = 0;
                            body.positionImpulse.y = 0;
                            body.positionPrev.x = body.position.x;
                            body.positionPrev.y = body.position.y;
                            body.anglePrev = body.angle;
                            body.speed = 0;
                            body.angularSpeed = 0;
                            body.motion = 0;
                            if (!wasSleeping) Events.trigger(body, 'sleepStart');
                        } else {
                            body.isSleeping = false;
                            body.sleepCounter = 0;
                            if (wasSleeping) Events.trigger(body, 'sleepEnd');
                        }
                    };
                })();
            /***/ },
            /***/ 66280: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Bodies` module contains factory methods for creating rigid body models
* with commonly used body configurations (such as rectangles, circles and other polygons).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Bodies
*/ // TODO: true circle bodies
                var Bodies = {};
                module1.exports = Bodies;
                var Vertices = __webpack_require__(41598);
                var Common = __webpack_require__(53402);
                var Body = __webpack_require__(22562);
                var Bounds = __webpack_require__(15647);
                var Vector = __webpack_require__(31725);
                (function() {
                    /**
     * Creates a new rigid body model with a rectangle hull.
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method rectangle
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {object} [options]
     * @return {body} A new rectangle body
     */ Bodies.rectangle = function(x, y, width, height, options) {
                        options = options || {};
                        var rectangle = {
                            label: 'Rectangle Body',
                            position: {
                                x: x,
                                y: y
                            },
                            vertices: Vertices.fromPath('L 0 0 L ' + width + ' 0 L ' + width + ' ' + height + ' L 0 ' + height)
                        };
                        if (options.chamfer) {
                            var chamfer = options.chamfer;
                            rectangle.vertices = Vertices.chamfer(rectangle.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                            delete options.chamfer;
                        }
                        return Body.create(Common.extend({}, rectangle, options));
                    };
                    /**
     * Creates a new rigid body model with a trapezoid hull.
     * The `slope` is parameterised as a fraction of `width` and must be < 1 to form a valid trapezoid.
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method trapezoid
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {number} slope Must be a number < 1.
     * @param {object} [options]
     * @return {body} A new trapezoid body
     */ Bodies.trapezoid = function(x, y, width, height, slope, options) {
                        options = options || {};
                        if (slope >= 1) Common.warn('Bodies.trapezoid: slope parameter must be < 1.');
                        slope *= 0.5;
                        var roof = (1 - slope * 2) * width;
                        var x1 = width * slope, x2 = x1 + roof, x3 = x2 + x1, verticesPath;
                        if (slope < 0.5) verticesPath = 'L 0 0 L ' + x1 + ' ' + -height + ' L ' + x2 + ' ' + -height + ' L ' + x3 + ' 0';
                        else verticesPath = 'L 0 0 L ' + x2 + ' ' + -height + ' L ' + x3 + ' 0';
                        var trapezoid = {
                            label: 'Trapezoid Body',
                            position: {
                                x: x,
                                y: y
                            },
                            vertices: Vertices.fromPath(verticesPath)
                        };
                        if (options.chamfer) {
                            var chamfer = options.chamfer;
                            trapezoid.vertices = Vertices.chamfer(trapezoid.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                            delete options.chamfer;
                        }
                        return Body.create(Common.extend({}, trapezoid, options));
                    };
                    /**
     * Creates a new rigid body model with a circle hull.
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method circle
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @param {object} [options]
     * @param {number} [maxSides]
     * @return {body} A new circle body
     */ Bodies.circle = function(x, y, radius, options, maxSides) {
                        options = options || {};
                        var circle = {
                            label: 'Circle Body',
                            circleRadius: radius
                        };
                        // approximate circles with polygons until true circles implemented in SAT
                        maxSides = maxSides || 25;
                        var sides = Math.ceil(Math.max(10, Math.min(maxSides, radius)));
                        // optimisation: always use even number of sides (half the number of unique axes)
                        if (sides % 2 === 1) sides += 1;
                        return Bodies.polygon(x, y, sides, radius, Common.extend({}, circle, options));
                    };
                    /**
     * Creates a new rigid body model with a regular polygon hull with the given number of sides.
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method polygon
     * @param {number} x
     * @param {number} y
     * @param {number} sides
     * @param {number} radius
     * @param {object} [options]
     * @return {body} A new regular polygon body
     */ Bodies.polygon = function(x, y, sides, radius, options) {
                        options = options || {};
                        if (sides < 3) return Bodies.circle(x, y, radius, options);
                        var theta = 2 * Math.PI / sides, path = '', offset = theta * 0.5;
                        for(var i = 0; i < sides; i += 1){
                            var angle = offset + i * theta, xx = Math.cos(angle) * radius, yy = Math.sin(angle) * radius;
                            path += 'L ' + xx.toFixed(3) + ' ' + yy.toFixed(3) + ' ';
                        }
                        var polygon = {
                            label: 'Polygon Body',
                            position: {
                                x: x,
                                y: y
                            },
                            vertices: Vertices.fromPath(path)
                        };
                        if (options.chamfer) {
                            var chamfer = options.chamfer;
                            polygon.vertices = Vertices.chamfer(polygon.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                            delete options.chamfer;
                        }
                        return Body.create(Common.extend({}, polygon, options));
                    };
                    /**
     * Utility to create a compound body based on set(s) of vertices.
     *
     * _Note:_ To optionally enable automatic concave vertices decomposition the [poly-decomp](https://github.com/schteppe/poly-decomp.js)
     * package must be first installed and provided see `Common.setDecomp`, otherwise the convex hull of each vertex set will be used.
     *
     * The resulting vertices are reorientated about their centre of mass,
     * and offset such that `body.position` corresponds to this point.
     *
     * The resulting offset may be found if needed by subtracting `body.bounds` from the original input bounds.
     * To later move the centre of mass see `Body.setCentre`.
     *
     * Note that automatic conconcave decomposition results are not always optimal.
     * For best results, simplify the input vertices as much as possible first.
     * By default this function applies some addtional simplification to help.
     *
     * Some outputs may also require further manual processing afterwards to be robust.
     * In particular some parts may need to be overlapped to avoid collision gaps.
     * Thin parts and sharp points should be avoided or removed where possible.
     *
     * The options parameter object specifies any `Matter.Body` properties you wish to override the defaults.
     *
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method fromVertices
     * @param {number} x
     * @param {number} y
     * @param {array} vertexSets One or more arrays of vertex points e.g. `[[{ x: 0, y: 0 }...], ...]`.
     * @param {object} [options] The body options.
     * @param {bool} [flagInternal=false] Optionally marks internal edges with `isInternal`.
     * @param {number} [removeCollinear=0.01] Threshold when simplifying vertices along the same edge.
     * @param {number} [minimumArea=10] Threshold when removing small parts.
     * @param {number} [removeDuplicatePoints=0.01] Threshold when simplifying nearby vertices.
     * @return {body}
     */ Bodies.fromVertices = function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea, removeDuplicatePoints) {
                        var decomp = Common.getDecomp(), canDecomp, body, parts, isConvex, isConcave, vertices, i, j, k, v, z;
                        // check decomp is as expected
                        canDecomp = Boolean(decomp && decomp.quickDecomp);
                        options = options || {};
                        parts = [];
                        flagInternal = typeof flagInternal !== 'undefined' ? flagInternal : false;
                        removeCollinear = typeof removeCollinear !== 'undefined' ? removeCollinear : 0.01;
                        minimumArea = typeof minimumArea !== 'undefined' ? minimumArea : 10;
                        removeDuplicatePoints = typeof removeDuplicatePoints !== 'undefined' ? removeDuplicatePoints : 0.01;
                        // ensure vertexSets is an array of arrays
                        if (!Common.isArray(vertexSets[0])) vertexSets = [
                            vertexSets
                        ];
                        for(v = 0; v < vertexSets.length; v += 1){
                            vertices = vertexSets[v];
                            isConvex = Vertices.isConvex(vertices);
                            isConcave = !isConvex;
                            if (isConcave && !canDecomp) Common.warnOnce('Bodies.fromVertices: Install the \'poly-decomp\' library and use Common.setDecomp or provide \'decomp\' as a global to decompose concave vertices.');
                            if (isConvex || !canDecomp) {
                                if (isConvex) vertices = Vertices.clockwiseSort(vertices);
                                else // fallback to convex hull when decomposition is not possible
                                vertices = Vertices.hull(vertices);
                                parts.push({
                                    position: {
                                        x: x,
                                        y: y
                                    },
                                    vertices: vertices
                                });
                            } else {
                                // initialise a decomposition
                                var concave = vertices.map(function(vertex) {
                                    return [
                                        vertex.x,
                                        vertex.y
                                    ];
                                });
                                // vertices are concave and simple, we can decompose into parts
                                decomp.makeCCW(concave);
                                if (removeCollinear !== false) decomp.removeCollinearPoints(concave, removeCollinear);
                                if (removeDuplicatePoints !== false && decomp.removeDuplicatePoints) decomp.removeDuplicatePoints(concave, removeDuplicatePoints);
                                // use the quick decomposition algorithm (Bayazit)
                                var decomposed = decomp.quickDecomp(concave);
                                // for each decomposed chunk
                                for(i = 0; i < decomposed.length; i++){
                                    var chunk = decomposed[i];
                                    // convert vertices into the correct structure
                                    var chunkVertices = chunk.map(function(vertices) {
                                        return {
                                            x: vertices[0],
                                            y: vertices[1]
                                        };
                                    });
                                    // skip small chunks
                                    if (minimumArea > 0 && Vertices.area(chunkVertices) < minimumArea) continue;
                                    // create a compound part
                                    parts.push({
                                        position: Vertices.centre(chunkVertices),
                                        vertices: chunkVertices
                                    });
                                }
                            }
                        }
                        // create body parts
                        for(i = 0; i < parts.length; i++)parts[i] = Body.create(Common.extend(parts[i], options));
                        // flag internal edges (coincident part edges)
                        if (flagInternal) {
                            var coincident_max_dist = 5;
                            for(i = 0; i < parts.length; i++){
                                var partA = parts[i];
                                for(j = i + 1; j < parts.length; j++){
                                    var partB = parts[j];
                                    if (Bounds.overlaps(partA.bounds, partB.bounds)) {
                                        var pav = partA.vertices, pbv = partB.vertices;
                                        // iterate vertices of both parts
                                        for(k = 0; k < partA.vertices.length; k++)for(z = 0; z < partB.vertices.length; z++){
                                            // find distances between the vertices
                                            var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z])), db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
                                            // if both vertices are very close, consider the edge concident (internal)
                                            if (da < coincident_max_dist && db < coincident_max_dist) {
                                                pav[k].isInternal = true;
                                                pbv[z].isInternal = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (parts.length > 1) {
                            // create the parent body to be returned, that contains generated compound parts
                            body = Body.create(Common.extend({
                                parts: parts.slice(0)
                            }, options));
                            // offset such that body.position is at the centre off mass
                            Body.setPosition(body, {
                                x: x,
                                y: y
                            });
                            return body;
                        } else return parts[0];
                    };
                    /**
     * Takes an array of Body objects and flags all internal edges (coincident parts) based on the maxDistance
     * value. The array is changed in-place and returned, so you can pass this function a `Body.parts` property.
     *
     * @method flagCoincidentParts
     * @param {body[]} parts - The Body parts, or array of bodies, to flag.
     * @param {number} [maxDistance=5]
     * @return {body[]} The modified `parts` parameter.
     */ Bodies.flagCoincidentParts = function(parts, maxDistance) {
                        if (maxDistance === undefined) maxDistance = 5;
                        for(var i = 0; i < parts.length; i++){
                            var partA = parts[i];
                            for(var j = i + 1; j < parts.length; j++){
                                var partB = parts[j];
                                if (Bounds.overlaps(partA.bounds, partB.bounds)) {
                                    var pav = partA.vertices;
                                    var pbv = partB.vertices;
                                    // iterate vertices of both parts
                                    for(var k = 0; k < partA.vertices.length; k++)for(var z = 0; z < partB.vertices.length; z++){
                                        // find distances between the vertices
                                        var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z]));
                                        var db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
                                        // if both vertices are very close, consider the edge concident (internal)
                                        if (da < maxDistance && db < maxDistance) {
                                            pav[k].isInternal = true;
                                            pbv[z].isInternal = true;
                                        }
                                    }
                                }
                            }
                        }
                        return parts;
                    };
                })();
            /***/ },
            /***/ 74116: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Composites` module contains factory methods for creating composite bodies
* with commonly used configurations (such as stacks and chains).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composites
*/ var Composites = {};
                module1.exports = Composites;
                var Composite = __webpack_require__(69351);
                var Constraint = __webpack_require__(48140);
                var Common = __webpack_require__(53402);
                var Body = __webpack_require__(22562);
                var Bodies = __webpack_require__(66280);
                (function() {
                    /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method stack
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.stack = function(x, y, columns, rows, columnGap, rowGap, callback) {
                        var stack = Composite.create({
                            label: 'Stack'
                        }), currentX = x, currentY = y, lastBody, i = 0;
                        for(var row = 0; row < rows; row++){
                            var maxHeight = 0;
                            for(var column = 0; column < columns; column++){
                                var body = callback(currentX, currentY, column, row, lastBody, i);
                                if (body) {
                                    var bodyHeight = body.bounds.max.y - body.bounds.min.y, bodyWidth = body.bounds.max.x - body.bounds.min.x;
                                    if (bodyHeight > maxHeight) maxHeight = bodyHeight;
                                    Body.translate(body, {
                                        x: bodyWidth * 0.5,
                                        y: bodyHeight * 0.5
                                    });
                                    currentX = body.bounds.max.x + columnGap;
                                    Composite.addBody(stack, body);
                                    lastBody = body;
                                    i += 1;
                                } else currentX += columnGap;
                            }
                            currentY += maxHeight + rowGap;
                            currentX = x;
                        }
                        return stack;
                    };
                    /**
     * Chains all bodies in the given composite together using constraints.
     * @method chain
     * @param {composite} composite
     * @param {number} xOffsetA
     * @param {number} yOffsetA
     * @param {number} xOffsetB
     * @param {number} yOffsetB
     * @param {object} options
     * @return {composite} A new composite containing objects chained together with constraints
     */ Composites.chain = function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                        var bodies = composite.bodies;
                        for(var i = 1; i < bodies.length; i++){
                            var bodyA = bodies[i - 1], bodyB = bodies[i], bodyAHeight = bodyA.bounds.max.y - bodyA.bounds.min.y, bodyAWidth = bodyA.bounds.max.x - bodyA.bounds.min.x, bodyBHeight = bodyB.bounds.max.y - bodyB.bounds.min.y, bodyBWidth = bodyB.bounds.max.x - bodyB.bounds.min.x;
                            var defaults = {
                                bodyA: bodyA,
                                pointA: {
                                    x: bodyAWidth * xOffsetA,
                                    y: bodyAHeight * yOffsetA
                                },
                                bodyB: bodyB,
                                pointB: {
                                    x: bodyBWidth * xOffsetB,
                                    y: bodyBHeight * yOffsetB
                                }
                            };
                            var constraint = Common.extend(defaults, options);
                            Composite.addConstraint(composite, Constraint.create(constraint));
                        }
                        composite.label += ' Chain';
                        return composite;
                    };
                    /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     * @method mesh
     * @param {composite} composite
     * @param {number} columns
     * @param {number} rows
     * @param {boolean} crossBrace
     * @param {object} options
     * @return {composite} The composite containing objects meshed together with constraints
     */ Composites.mesh = function(composite, columns, rows, crossBrace, options) {
                        var bodies = composite.bodies, row, col, bodyA, bodyB, bodyC;
                        for(row = 0; row < rows; row++){
                            for(col = 1; col < columns; col++){
                                bodyA = bodies[col - 1 + row * columns];
                                bodyB = bodies[col + row * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyA,
                                    bodyB: bodyB
                                }, options)));
                            }
                            if (row > 0) for(col = 0; col < columns; col++){
                                bodyA = bodies[col + (row - 1) * columns];
                                bodyB = bodies[col + row * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyA,
                                    bodyB: bodyB
                                }, options)));
                                if (crossBrace && col > 0) {
                                    bodyC = bodies[col - 1 + (row - 1) * columns];
                                    Composite.addConstraint(composite, Constraint.create(Common.extend({
                                        bodyA: bodyC,
                                        bodyB: bodyB
                                    }, options)));
                                }
                                if (crossBrace && col < columns - 1) {
                                    bodyC = bodies[col + 1 + (row - 1) * columns];
                                    Composite.addConstraint(composite, Constraint.create(Common.extend({
                                        bodyA: bodyC,
                                        bodyB: bodyB
                                    }, options)));
                                }
                            }
                        }
                        composite.label += ' Mesh';
                        return composite;
                    };
                    /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method pyramid
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.pyramid = function(x, y, columns, rows, columnGap, rowGap, callback) {
                        return Composites.stack(x, y, columns, rows, columnGap, rowGap, function(stackX, stackY, column, row, lastBody, i) {
                            var actualRows = Math.min(rows, Math.ceil(columns / 2)), lastBodyWidth = lastBody ? lastBody.bounds.max.x - lastBody.bounds.min.x : 0;
                            if (row > actualRows) return;
                            // reverse row order
                            row = actualRows - row;
                            var start = row, end = columns - 1 - row;
                            if (column < start || column > end) return;
                            // retroactively fix the first body's position, since width was unknown
                            if (i === 1) Body.translate(lastBody, {
                                x: (column + (columns % 2 === 1 ? 1 : -1)) * lastBodyWidth,
                                y: 0
                            });
                            var xOffset = lastBody ? column * lastBodyWidth : 0;
                            return callback(x + xOffset + column * columnGap, stackY, column, row, lastBody, i);
                        });
                    };
                    /**
     * This has now moved to the [newtonsCradle example](https://github.com/liabru/matter-js/blob/master/examples/newtonsCradle.js), follow that instead as this function is deprecated here.
     * @deprecated moved to newtonsCradle example
     * @method newtonsCradle
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} number
     * @param {number} size
     * @param {number} length
     * @return {composite} A new composite newtonsCradle body
     */ Composites.newtonsCradle = function(x, y, number, size, length) {
                        var newtonsCradle = Composite.create({
                            label: 'Newtons Cradle'
                        });
                        for(var i = 0; i < number; i++){
                            var separation = 1.9, circle = Bodies.circle(x + i * (size * separation), y + length, size, {
                                inertia: Infinity,
                                restitution: 1,
                                friction: 0,
                                frictionAir: 0.0001,
                                slop: 1
                            }), constraint = Constraint.create({
                                pointA: {
                                    x: x + i * (size * separation),
                                    y: y
                                },
                                bodyB: circle
                            });
                            Composite.addBody(newtonsCradle, circle);
                            Composite.addConstraint(newtonsCradle, constraint);
                        }
                        return newtonsCradle;
                    };
                    /**
     * This has now moved to the [car example](https://github.com/liabru/matter-js/blob/master/examples/car.js), follow that instead as this function is deprecated here.
     * @deprecated moved to car example
     * @method car
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} width
     * @param {number} height
     * @param {number} wheelSize
     * @return {composite} A new composite car body
     */ Composites.car = function(x, y, width, height, wheelSize) {
                        var group = Body.nextGroup(true), wheelBase = 20, wheelAOffset = -width * 0.5 + wheelBase, wheelBOffset = width * 0.5 - wheelBase, wheelYOffset = 0;
                        var car = Composite.create({
                            label: 'Car'
                        }), body = Bodies.rectangle(x, y, width, height, {
                            collisionFilter: {
                                group: group
                            },
                            chamfer: {
                                radius: height * 0.5
                            },
                            density: 0.0002
                        });
                        var wheelA = Bodies.circle(x + wheelAOffset, y + wheelYOffset, wheelSize, {
                            collisionFilter: {
                                group: group
                            },
                            friction: 0.8
                        });
                        var wheelB = Bodies.circle(x + wheelBOffset, y + wheelYOffset, wheelSize, {
                            collisionFilter: {
                                group: group
                            },
                            friction: 0.8
                        });
                        var axelA = Constraint.create({
                            bodyB: body,
                            pointB: {
                                x: wheelAOffset,
                                y: wheelYOffset
                            },
                            bodyA: wheelA,
                            stiffness: 1,
                            length: 0
                        });
                        var axelB = Constraint.create({
                            bodyB: body,
                            pointB: {
                                x: wheelBOffset,
                                y: wheelYOffset
                            },
                            bodyA: wheelB,
                            stiffness: 1,
                            length: 0
                        });
                        Composite.addBody(car, body);
                        Composite.addBody(car, wheelA);
                        Composite.addBody(car, wheelB);
                        Composite.addConstraint(car, axelA);
                        Composite.addConstraint(car, axelB);
                        return car;
                    };
                    /**
     * This has now moved to the [softBody example](https://github.com/liabru/matter-js/blob/master/examples/softBody.js)
     * and the [cloth example](https://github.com/liabru/matter-js/blob/master/examples/cloth.js), follow those instead as this function is deprecated here.
     * @deprecated moved to softBody and cloth examples
     * @method softBody
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {boolean} crossBrace
     * @param {number} particleRadius
     * @param {} particleOptions
     * @param {} constraintOptions
     * @return {composite} A new composite softBody
     */ Composites.softBody = function(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                        particleOptions = Common.extend({
                            inertia: Infinity
                        }, particleOptions);
                        constraintOptions = Common.extend({
                            stiffness: 0.2,
                            render: {
                                type: 'line',
                                anchors: false
                            }
                        }, constraintOptions);
                        var softBody = Composites.stack(x, y, columns, rows, columnGap, rowGap, function(stackX, stackY) {
                            return Bodies.circle(stackX, stackY, particleRadius, particleOptions);
                        });
                        Composites.mesh(softBody, columns, rows, crossBrace, constraintOptions);
                        softBody.label = 'Soft Body';
                        return softBody;
                    };
                })();
            /***/ },
            /***/ 66615: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
*
* @class Axes
*/ var Axes = {};
                module1.exports = Axes;
                var Vector = __webpack_require__(31725);
                var Common = __webpack_require__(53402);
                (function() {
                    /**
     * Creates a new set of axes from the given vertices.
     * @method fromVertices
     * @param {vertices} vertices
     * @return {axes} A new axes from the given vertices
     */ Axes.fromVertices = function(vertices) {
                        var axes = {};
                        // find the unique axes, using edge normal gradients
                        for(var i = 0; i < vertices.length; i++){
                            var j = (i + 1) % vertices.length, normal = Vector.normalise({
                                x: vertices[j].y - vertices[i].y,
                                y: vertices[i].x - vertices[j].x
                            }), gradient = normal.y === 0 ? Infinity : normal.x / normal.y;
                            // limit precision
                            gradient = gradient.toFixed(3).toString();
                            axes[gradient] = normal;
                        }
                        return Common.values(axes);
                    };
                    /**
     * Rotates a set of axes by the given angle.
     * @method rotate
     * @param {axes} axes
     * @param {number} angle
     */ Axes.rotate = function(axes, angle) {
                        if (angle === 0) return;
                        var cos = Math.cos(angle), sin = Math.sin(angle);
                        for(var i = 0; i < axes.length; i++){
                            var axis = axes[i], xx;
                            xx = axis.x * cos - axis.y * sin;
                            axis.y = axis.x * sin + axis.y * cos;
                            axis.x = xx;
                        }
                    };
                })();
            /***/ },
            /***/ 15647: /***/ (module1)=>{
                /**
* The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
*
* @class Bounds
*/ var Bounds = {};
                module1.exports = Bounds;
                (function() {
                    /**
     * Creates a new axis-aligned bounding box (AABB) for the given vertices.
     * @method create
     * @param {vertices} vertices
     * @return {bounds} A new bounds object
     */ Bounds.create = function(vertices) {
                        var bounds = {
                            min: {
                                x: 0,
                                y: 0
                            },
                            max: {
                                x: 0,
                                y: 0
                            }
                        };
                        if (vertices) Bounds.update(bounds, vertices);
                        return bounds;
                    };
                    /**
     * Updates bounds using the given vertices and extends the bounds given a velocity.
     * @method update
     * @param {bounds} bounds
     * @param {vertices} vertices
     * @param {vector} velocity
     */ Bounds.update = function(bounds, vertices, velocity) {
                        bounds.min.x = Infinity;
                        bounds.max.x = -Infinity;
                        bounds.min.y = Infinity;
                        bounds.max.y = -Infinity;
                        for(var i = 0; i < vertices.length; i++){
                            var vertex = vertices[i];
                            if (vertex.x > bounds.max.x) bounds.max.x = vertex.x;
                            if (vertex.x < bounds.min.x) bounds.min.x = vertex.x;
                            if (vertex.y > bounds.max.y) bounds.max.y = vertex.y;
                            if (vertex.y < bounds.min.y) bounds.min.y = vertex.y;
                        }
                        if (velocity) {
                            if (velocity.x > 0) bounds.max.x += velocity.x;
                            else bounds.min.x += velocity.x;
                            if (velocity.y > 0) bounds.max.y += velocity.y;
                            else bounds.min.y += velocity.y;
                        }
                    };
                    /**
     * Returns true if the bounds contains the given point.
     * @method contains
     * @param {bounds} bounds
     * @param {vector} point
     * @return {boolean} True if the bounds contain the point, otherwise false
     */ Bounds.contains = function(bounds, point) {
                        return point.x >= bounds.min.x && point.x <= bounds.max.x && point.y >= bounds.min.y && point.y <= bounds.max.y;
                    };
                    /**
     * Returns true if the two bounds intersect.
     * @method overlaps
     * @param {bounds} boundsA
     * @param {bounds} boundsB
     * @return {boolean} True if the bounds overlap, otherwise false
     */ Bounds.overlaps = function(boundsA, boundsB) {
                        return boundsA.min.x <= boundsB.max.x && boundsA.max.x >= boundsB.min.x && boundsA.max.y >= boundsB.min.y && boundsA.min.y <= boundsB.max.y;
                    };
                    /**
     * Translates the bounds by the given vector.
     * @method translate
     * @param {bounds} bounds
     * @param {vector} vector
     */ Bounds.translate = function(bounds, vector) {
                        bounds.min.x += vector.x;
                        bounds.max.x += vector.x;
                        bounds.min.y += vector.y;
                        bounds.max.y += vector.y;
                    };
                    /**
     * Shifts the bounds to the given position.
     * @method shift
     * @param {bounds} bounds
     * @param {vector} position
     */ Bounds.shift = function(bounds, position) {
                        var deltaX = bounds.max.x - bounds.min.x, deltaY = bounds.max.y - bounds.min.y;
                        bounds.min.x = position.x;
                        bounds.max.x = position.x + deltaX;
                        bounds.min.y = position.y;
                        bounds.max.y = position.y + deltaY;
                    };
                    /**
     * Returns a translation vector that wraps the `objectBounds` inside the `bounds`.
     * @method wrap
     * @param {bounds} objectBounds The bounds of the object to wrap inside the bounds.
     * @param {bounds} bounds The bounds to wrap the body inside.
     * @param {number} [padding=0] - An amount added to the boundary.
     * @returns {?Matter.Vector} A translation vector (only if wrapping is required).
     */ Bounds.wrap = function(objectBounds, bounds, padding) {
                        var x = null, y = null;
                        if (typeof bounds.min.x !== 'undefined' && typeof bounds.max.x !== 'undefined') {
                            if (objectBounds.min.x > bounds.max.x) x = bounds.min.x - objectBounds.max.x;
                            else if (objectBounds.max.x < bounds.min.x) x = bounds.max.x - objectBounds.min.x;
                        }
                        if (typeof bounds.min.y !== 'undefined' && typeof bounds.max.y !== 'undefined') {
                            if (objectBounds.min.y > bounds.max.y) y = bounds.min.y - objectBounds.max.y;
                            else if (objectBounds.max.y < bounds.min.y) y = bounds.max.y - objectBounds.min.y;
                        }
                        if (x !== null || y !== null) return {
                            x: x || 0,
                            y: y || 0
                        };
                    };
                })();
            /***/ },
            /***/ 74058: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
*
* To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Svg
*/ var Svg = {};
                module1.exports = Svg;
                var Bounds = __webpack_require__(15647);
                var Common = __webpack_require__(53402);
                (function() {
                    /**
     * Converts an SVG path into an array of vector points.
     * If the input path forms a concave shape, you must decompose the result into convex parts before use.
     * See `Bodies.fromVertices` which provides support for this.
     * Note that this function is not guaranteed to support complex paths (such as those with holes).
     * You must load the `pathseg.js` polyfill on newer browsers.
     * @method pathToVertices
     * @param {SVGPathElement} path
     * @param {Number} [sampleLength=15]
     * @return {Vector[]} points
     */ Svg.pathToVertices = function(path, sampleLength) {
                        if (typeof window !== 'undefined' && !('SVGPathSeg' in window)) Common.warn('Svg.pathToVertices: SVGPathSeg not defined, a polyfill is required.');
                        // https://github.com/wout/svg.topoly.js/blob/master/svg.topoly.js
                        var i, il, total, point, segment, segments, segmentsQueue, lastSegment, lastPoint, segmentIndex, points = [], lx, ly, length = 0, x = 0, y = 0;
                        sampleLength = sampleLength || 15;
                        var addPoint = function(px, py, pathSegType) {
                            // all odd-numbered path types are relative except PATHSEG_CLOSEPATH (1)
                            var isRelative = pathSegType % 2 === 1 && pathSegType > 1;
                            // when the last point doesn't equal the current point add the current point
                            if (!lastPoint || px != lastPoint.x || py != lastPoint.y) {
                                if (lastPoint && isRelative) {
                                    lx = lastPoint.x;
                                    ly = lastPoint.y;
                                } else {
                                    lx = 0;
                                    ly = 0;
                                }
                                var point = {
                                    x: lx + px,
                                    y: ly + py
                                };
                                // set last point
                                if (isRelative || !lastPoint) lastPoint = point;
                                points.push(point);
                                x = lx + px;
                                y = ly + py;
                            }
                        };
                        var addSegmentPoint = function(segment) {
                            var segType = segment.pathSegTypeAsLetter.toUpperCase();
                            // skip path ends
                            if (segType === 'Z') return;
                            // map segment to x and y
                            switch(segType){
                                case 'M':
                                case 'L':
                                case 'T':
                                case 'C':
                                case 'S':
                                case 'Q':
                                    x = segment.x;
                                    y = segment.y;
                                    break;
                                case 'H':
                                    x = segment.x;
                                    break;
                                case 'V':
                                    y = segment.y;
                                    break;
                            }
                            addPoint(x, y, segment.pathSegType);
                        };
                        // ensure path is absolute
                        Svg._svgPathToAbsolute(path);
                        // get total length
                        total = path.getTotalLength();
                        // queue segments
                        segments = [];
                        for(i = 0; i < path.pathSegList.numberOfItems; i += 1)segments.push(path.pathSegList.getItem(i));
                        segmentsQueue = segments.concat();
                        // sample through path
                        while(length < total){
                            // get segment at position
                            segmentIndex = path.getPathSegAtLength(length);
                            segment = segments[segmentIndex];
                            // new segment
                            if (segment != lastSegment) {
                                while(segmentsQueue.length && segmentsQueue[0] != segment)addSegmentPoint(segmentsQueue.shift());
                                lastSegment = segment;
                            }
                            // add points in between when curving
                            // TODO: adaptive sampling
                            switch(segment.pathSegTypeAsLetter.toUpperCase()){
                                case 'C':
                                case 'T':
                                case 'S':
                                case 'Q':
                                case 'A':
                                    point = path.getPointAtLength(length);
                                    addPoint(point.x, point.y, 0);
                                    break;
                            }
                            // increment by sample value
                            length += sampleLength;
                        }
                        // add remaining segments not passed by sampling
                        for(i = 0, il = segmentsQueue.length; i < il; ++i)addSegmentPoint(segmentsQueue[i]);
                        return points;
                    };
                    Svg._svgPathToAbsolute = function(path) {
                        // http://phrogz.net/convert-svg-path-to-all-absolute-commands
                        // Copyright (c) Gavin Kistner
                        // http://phrogz.net/js/_ReuseLicense.txt
                        // Modifications: tidy formatting and naming
                        var x0, y0, x1, y1, x2, y2, segs = path.pathSegList, x = 0, y = 0, len = segs.numberOfItems;
                        for(var i = 0; i < len; ++i){
                            var seg = segs.getItem(i), segType = seg.pathSegTypeAsLetter;
                            if (/[MLHVCSQTA]/.test(segType)) {
                                if ('x' in seg) x = seg.x;
                                if ('y' in seg) y = seg.y;
                            } else {
                                if ('x1' in seg) x1 = x + seg.x1;
                                if ('x2' in seg) x2 = x + seg.x2;
                                if ('y1' in seg) y1 = y + seg.y1;
                                if ('y2' in seg) y2 = y + seg.y2;
                                if ('x' in seg) x += seg.x;
                                if ('y' in seg) y += seg.y;
                                switch(segType){
                                    case 'm':
                                        segs.replaceItem(path.createSVGPathSegMovetoAbs(x, y), i);
                                        break;
                                    case 'l':
                                        segs.replaceItem(path.createSVGPathSegLinetoAbs(x, y), i);
                                        break;
                                    case 'h':
                                        segs.replaceItem(path.createSVGPathSegLinetoHorizontalAbs(x), i);
                                        break;
                                    case 'v':
                                        segs.replaceItem(path.createSVGPathSegLinetoVerticalAbs(y), i);
                                        break;
                                    case 'c':
                                        segs.replaceItem(path.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2, y2), i);
                                        break;
                                    case 's':
                                        segs.replaceItem(path.createSVGPathSegCurvetoCubicSmoothAbs(x, y, x2, y2), i);
                                        break;
                                    case 'q':
                                        segs.replaceItem(path.createSVGPathSegCurvetoQuadraticAbs(x, y, x1, y1), i);
                                        break;
                                    case 't':
                                        segs.replaceItem(path.createSVGPathSegCurvetoQuadraticSmoothAbs(x, y), i);
                                        break;
                                    case 'a':
                                        segs.replaceItem(path.createSVGPathSegArcAbs(x, y, seg.r1, seg.r2, seg.angle, seg.largeArcFlag, seg.sweepFlag), i);
                                        break;
                                    case 'z':
                                    case 'Z':
                                        x = x0;
                                        y = y0;
                                        break;
                                }
                            }
                            if (segType == 'M' || segType == 'm') {
                                x0 = x;
                                y0 = y;
                            }
                        }
                    };
                })();
            /***/ },
            /***/ 31725: /***/ (module1)=>{
                /**
* The `Matter.Vector` module contains methods for creating and manipulating vectors.
* Vectors are the basis of all the geometry related operations in the engine.
* A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vector
*/ // TODO: consider params for reusing vector objects
                var Vector = {};
                module1.exports = Vector;
                (function() {
                    /**
     * Creates a new vector.
     * @method create
     * @param {number} x
     * @param {number} y
     * @return {vector} A new vector
     */ Vector.create = function(x, y) {
                        return {
                            x: x || 0,
                            y: y || 0
                        };
                    };
                    /**
     * Returns a new vector with `x` and `y` copied from the given `vector`.
     * @method clone
     * @param {vector} vector
     * @return {vector} A new cloned vector
     */ Vector.clone = function(vector) {
                        return {
                            x: vector.x,
                            y: vector.y
                        };
                    };
                    /**
     * Returns the magnitude (length) of a vector.
     * @method magnitude
     * @param {vector} vector
     * @return {number} The magnitude of the vector
     */ Vector.magnitude = function(vector) {
                        return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
                    };
                    /**
     * Returns the magnitude (length) of a vector (therefore saving a `sqrt` operation).
     * @method magnitudeSquared
     * @param {vector} vector
     * @return {number} The squared magnitude of the vector
     */ Vector.magnitudeSquared = function(vector) {
                        return vector.x * vector.x + vector.y * vector.y;
                    };
                    /**
     * Rotates the vector about (0, 0) by specified angle.
     * @method rotate
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} [output]
     * @return {vector} The vector rotated about (0, 0)
     */ Vector.rotate = function(vector, angle, output) {
                        var cos = Math.cos(angle), sin = Math.sin(angle);
                        if (!output) output = {};
                        var x = vector.x * cos - vector.y * sin;
                        output.y = vector.x * sin + vector.y * cos;
                        output.x = x;
                        return output;
                    };
                    /**
     * Rotates the vector about a specified point by specified angle.
     * @method rotateAbout
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} point
     * @param {vector} [output]
     * @return {vector} A new vector rotated about the point
     */ Vector.rotateAbout = function(vector, angle, point, output) {
                        var cos = Math.cos(angle), sin = Math.sin(angle);
                        if (!output) output = {};
                        var x = point.x + ((vector.x - point.x) * cos - (vector.y - point.y) * sin);
                        output.y = point.y + ((vector.x - point.x) * sin + (vector.y - point.y) * cos);
                        output.x = x;
                        return output;
                    };
                    /**
     * Normalises a vector (such that its magnitude is `1`).
     * @method normalise
     * @param {vector} vector
     * @return {vector} A new vector normalised
     */ Vector.normalise = function(vector) {
                        var magnitude = Vector.magnitude(vector);
                        if (magnitude === 0) return {
                            x: 0,
                            y: 0
                        };
                        return {
                            x: vector.x / magnitude,
                            y: vector.y / magnitude
                        };
                    };
                    /**
     * Returns the dot-product of two vectors.
     * @method dot
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The dot product of the two vectors
     */ Vector.dot = function(vectorA, vectorB) {
                        return vectorA.x * vectorB.x + vectorA.y * vectorB.y;
                    };
                    /**
     * Returns the cross-product of two vectors.
     * @method cross
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The cross product of the two vectors
     */ Vector.cross = function(vectorA, vectorB) {
                        return vectorA.x * vectorB.y - vectorA.y * vectorB.x;
                    };
                    /**
     * Returns the cross-product of three vectors.
     * @method cross3
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} vectorC
     * @return {number} The cross product of the three vectors
     */ Vector.cross3 = function(vectorA, vectorB, vectorC) {
                        return (vectorB.x - vectorA.x) * (vectorC.y - vectorA.y) - (vectorB.y - vectorA.y) * (vectorC.x - vectorA.x);
                    };
                    /**
     * Adds the two vectors.
     * @method add
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB added
     */ Vector.add = function(vectorA, vectorB, output) {
                        if (!output) output = {};
                        output.x = vectorA.x + vectorB.x;
                        output.y = vectorA.y + vectorB.y;
                        return output;
                    };
                    /**
     * Subtracts the two vectors.
     * @method sub
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB subtracted
     */ Vector.sub = function(vectorA, vectorB, output) {
                        if (!output) output = {};
                        output.x = vectorA.x - vectorB.x;
                        output.y = vectorA.y - vectorB.y;
                        return output;
                    };
                    /**
     * Multiplies a vector and a scalar.
     * @method mult
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector multiplied by scalar
     */ Vector.mult = function(vector, scalar) {
                        return {
                            x: vector.x * scalar,
                            y: vector.y * scalar
                        };
                    };
                    /**
     * Divides a vector and a scalar.
     * @method div
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector divided by scalar
     */ Vector.div = function(vector, scalar) {
                        return {
                            x: vector.x / scalar,
                            y: vector.y / scalar
                        };
                    };
                    /**
     * Returns the perpendicular vector. Set `negate` to true for the perpendicular in the opposite direction.
     * @method perp
     * @param {vector} vector
     * @param {bool} [negate=false]
     * @return {vector} The perpendicular vector
     */ Vector.perp = function(vector, negate) {
                        negate = negate === true ? -1 : 1;
                        return {
                            x: negate * -vector.y,
                            y: negate * vector.x
                        };
                    };
                    /**
     * Negates both components of a vector such that it points in the opposite direction.
     * @method neg
     * @param {vector} vector
     * @return {vector} The negated vector
     */ Vector.neg = function(vector) {
                        return {
                            x: -vector.x,
                            y: -vector.y
                        };
                    };
                    /**
     * Returns the angle between the vector `vectorB - vectorA` and the x-axis in radians.
     * @method angle
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The angle in radians
     */ Vector.angle = function(vectorA, vectorB) {
                        return Math.atan2(vectorB.y - vectorA.y, vectorB.x - vectorA.x);
                    };
                    /**
     * Temporary vector pool (not thread-safe).
     * @property _temp
     * @type {vector[]}
     * @private
     */ Vector._temp = [
                        Vector.create(),
                        Vector.create(),
                        Vector.create(),
                        Vector.create(),
                        Vector.create(),
                        Vector.create()
                    ];
                })();
            /***/ },
            /***/ 41598: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
* A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
* A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vertices
*/ var Vertices = {};
                module1.exports = Vertices;
                var Vector = __webpack_require__(31725);
                var Common = __webpack_require__(53402);
                (function() {
                    /**
     * Creates a new set of `Matter.Body` compatible vertices.
     * The `points` argument accepts an array of `Matter.Vector` points orientated around the origin `(0, 0)`, for example:
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * The `Vertices.create` method returns a new array of vertices, which are similar to Matter.Vector objects,
     * but with some additional references required for efficient collision detection routines.
     *
     * Vertices must be specified in clockwise order.
     *
     * Note that the `body` argument is not optional, a `Matter.Body` reference must be provided.
     *
     * @method create
     * @param {vector[]} points
     * @param {body} body
     */ Vertices.create = function(points, body) {
                        var vertices = [];
                        for(var i = 0; i < points.length; i++){
                            var point = points[i], vertex = {
                                x: point.x,
                                y: point.y,
                                index: i,
                                body: body,
                                isInternal: false
                            };
                            vertices.push(vertex);
                        }
                        return vertices;
                    };
                    /**
     * Parses a string containing ordered x y pairs separated by spaces (and optionally commas), 
     * into a `Matter.Vertices` object for the given `Matter.Body`.
     * For parsing SVG paths, see `Svg.pathToVertices`.
     * @method fromPath
     * @param {string} path
     * @param {body} body
     * @return {vertices} vertices
     */ Vertices.fromPath = function(path, body) {
                        var pathPattern = /L?\s*([-\d.e]+)[\s,]*([-\d.e]+)*/ig, points = [];
                        path.replace(pathPattern, function(match, x, y) {
                            points.push({
                                x: parseFloat(x),
                                y: parseFloat(y)
                            });
                        });
                        return Vertices.create(points, body);
                    };
                    /**
     * Returns the centre (centroid) of the set of vertices.
     * @method centre
     * @param {vertices} vertices
     * @return {vector} The centre point
     */ Vertices.centre = function(vertices) {
                        var area = Vertices.area(vertices, true), centre = {
                            x: 0,
                            y: 0
                        }, cross, temp, j;
                        for(var i = 0; i < vertices.length; i++){
                            j = (i + 1) % vertices.length;
                            cross = Vector.cross(vertices[i], vertices[j]);
                            temp = Vector.mult(Vector.add(vertices[i], vertices[j]), cross);
                            centre = Vector.add(centre, temp);
                        }
                        return Vector.div(centre, 6 * area);
                    };
                    /**
     * Returns the average (mean) of the set of vertices.
     * @method mean
     * @param {vertices} vertices
     * @return {vector} The average point
     */ Vertices.mean = function(vertices) {
                        var average = {
                            x: 0,
                            y: 0
                        };
                        for(var i = 0; i < vertices.length; i++){
                            average.x += vertices[i].x;
                            average.y += vertices[i].y;
                        }
                        return Vector.div(average, vertices.length);
                    };
                    /**
     * Returns the area of the set of vertices.
     * @method area
     * @param {vertices} vertices
     * @param {bool} signed
     * @return {number} The area
     */ Vertices.area = function(vertices, signed) {
                        var area = 0, j = vertices.length - 1;
                        for(var i = 0; i < vertices.length; i++){
                            area += (vertices[j].x - vertices[i].x) * (vertices[j].y + vertices[i].y);
                            j = i;
                        }
                        if (signed) return area / 2;
                        return Math.abs(area) / 2;
                    };
                    /**
     * Returns the moment of inertia (second moment of area) of the set of vertices given the total mass.
     * @method inertia
     * @param {vertices} vertices
     * @param {number} mass
     * @return {number} The polygon's moment of inertia
     */ Vertices.inertia = function(vertices, mass) {
                        var numerator = 0, denominator = 0, v = vertices, cross, j;
                        // find the polygon's moment of inertia, using second moment of area
                        // from equations at http://www.physicsforums.com/showthread.php?t=25293
                        for(var n = 0; n < v.length; n++){
                            j = (n + 1) % v.length;
                            cross = Math.abs(Vector.cross(v[j], v[n]));
                            numerator += cross * (Vector.dot(v[j], v[j]) + Vector.dot(v[j], v[n]) + Vector.dot(v[n], v[n]));
                            denominator += cross;
                        }
                        return mass / 6 * (numerator / denominator);
                    };
                    /**
     * Translates the set of vertices in-place.
     * @method translate
     * @param {vertices} vertices
     * @param {vector} vector
     * @param {number} scalar
     */ Vertices.translate = function(vertices, vector, scalar) {
                        scalar = typeof scalar !== 'undefined' ? scalar : 1;
                        var verticesLength = vertices.length, translateX = vector.x * scalar, translateY = vector.y * scalar, i;
                        for(i = 0; i < verticesLength; i++){
                            vertices[i].x += translateX;
                            vertices[i].y += translateY;
                        }
                        return vertices;
                    };
                    /**
     * Rotates the set of vertices in-place.
     * @method rotate
     * @param {vertices} vertices
     * @param {number} angle
     * @param {vector} point
     */ Vertices.rotate = function(vertices, angle, point) {
                        if (angle === 0) return;
                        var cos = Math.cos(angle), sin = Math.sin(angle), pointX = point.x, pointY = point.y, verticesLength = vertices.length, vertex, dx, dy, i;
                        for(i = 0; i < verticesLength; i++){
                            vertex = vertices[i];
                            dx = vertex.x - pointX;
                            dy = vertex.y - pointY;
                            vertex.x = pointX + (dx * cos - dy * sin);
                            vertex.y = pointY + (dx * sin + dy * cos);
                        }
                        return vertices;
                    };
                    /**
     * Returns `true` if the `point` is inside the set of `vertices`.
     * @method contains
     * @param {vertices} vertices
     * @param {vector} point
     * @return {boolean} True if the vertices contains point, otherwise false
     */ Vertices.contains = function(vertices, point) {
                        var pointX = point.x, pointY = point.y, verticesLength = vertices.length, vertex = vertices[verticesLength - 1], nextVertex;
                        for(var i = 0; i < verticesLength; i++){
                            nextVertex = vertices[i];
                            if ((pointX - vertex.x) * (nextVertex.y - vertex.y) + (pointY - vertex.y) * (vertex.x - nextVertex.x) > 0) return false;
                            vertex = nextVertex;
                        }
                        return true;
                    };
                    /**
     * Scales the vertices from a point (default is centre) in-place.
     * @method scale
     * @param {vertices} vertices
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     */ Vertices.scale = function(vertices, scaleX, scaleY, point) {
                        if (scaleX === 1 && scaleY === 1) return vertices;
                        point = point || Vertices.centre(vertices);
                        var vertex, delta;
                        for(var i = 0; i < vertices.length; i++){
                            vertex = vertices[i];
                            delta = Vector.sub(vertex, point);
                            vertices[i].x = point.x + delta.x * scaleX;
                            vertices[i].y = point.y + delta.y * scaleY;
                        }
                        return vertices;
                    };
                    /**
     * Chamfers a set of vertices by giving them rounded corners, returns a new set of vertices.
     * The radius parameter is a single number or an array to specify the radius for each vertex.
     * @method chamfer
     * @param {vertices} vertices
     * @param {number[]} radius
     * @param {number} quality
     * @param {number} qualityMin
     * @param {number} qualityMax
     */ Vertices.chamfer = function(vertices, radius, quality, qualityMin, qualityMax) {
                        if (typeof radius === 'number') radius = [
                            radius
                        ];
                        else radius = radius || [
                            8
                        ];
                        // quality defaults to -1, which is auto
                        quality = typeof quality !== 'undefined' ? quality : -1;
                        qualityMin = qualityMin || 2;
                        qualityMax = qualityMax || 14;
                        var newVertices = [];
                        for(var i = 0; i < vertices.length; i++){
                            var prevVertex = vertices[i - 1 >= 0 ? i - 1 : vertices.length - 1], vertex = vertices[i], nextVertex = vertices[(i + 1) % vertices.length], currentRadius = radius[i < radius.length ? i : radius.length - 1];
                            if (currentRadius === 0) {
                                newVertices.push(vertex);
                                continue;
                            }
                            var prevNormal = Vector.normalise({
                                x: vertex.y - prevVertex.y,
                                y: prevVertex.x - vertex.x
                            });
                            var nextNormal = Vector.normalise({
                                x: nextVertex.y - vertex.y,
                                y: vertex.x - nextVertex.x
                            });
                            var diagonalRadius = Math.sqrt(2 * Math.pow(currentRadius, 2)), radiusVector = Vector.mult(Common.clone(prevNormal), currentRadius), midNormal = Vector.normalise(Vector.mult(Vector.add(prevNormal, nextNormal), 0.5)), scaledVertex = Vector.sub(vertex, Vector.mult(midNormal, diagonalRadius));
                            var precision = quality;
                            if (quality === -1) // automatically decide precision
                            precision = Math.pow(currentRadius, 0.32) * 1.75;
                            precision = Common.clamp(precision, qualityMin, qualityMax);
                            // use an even value for precision, more likely to reduce axes by using symmetry
                            if (precision % 2 === 1) precision += 1;
                            var alpha = Math.acos(Vector.dot(prevNormal, nextNormal)), theta = alpha / precision;
                            for(var j = 0; j < precision; j++)newVertices.push(Vector.add(Vector.rotate(radiusVector, theta * j), scaledVertex));
                        }
                        return newVertices;
                    };
                    /**
     * Sorts the input vertices into clockwise order in place.
     * @method clockwiseSort
     * @param {vertices} vertices
     * @return {vertices} vertices
     */ Vertices.clockwiseSort = function(vertices) {
                        var centre = Vertices.mean(vertices);
                        vertices.sort(function(vertexA, vertexB) {
                            return Vector.angle(centre, vertexA) - Vector.angle(centre, vertexB);
                        });
                        return vertices;
                    };
                    /**
     * Returns true if the vertices form a convex shape (vertices must be in clockwise order).
     * @method isConvex
     * @param {vertices} vertices
     * @return {bool} `true` if the `vertices` are convex, `false` if not (or `null` if not computable).
     */ Vertices.isConvex = function(vertices) {
                        // http://paulbourke.net/geometry/polygonmesh/
                        // Copyright (c) Paul Bourke (use permitted)
                        var flag = 0, n = vertices.length, i, j, k, z;
                        if (n < 3) return null;
                        for(i = 0; i < n; i++){
                            j = (i + 1) % n;
                            k = (i + 2) % n;
                            z = (vertices[j].x - vertices[i].x) * (vertices[k].y - vertices[j].y);
                            z -= (vertices[j].y - vertices[i].y) * (vertices[k].x - vertices[j].x);
                            if (z < 0) flag |= 1;
                            else if (z > 0) flag |= 2;
                            if (flag === 3) return false;
                        }
                        if (flag !== 0) return true;
                        else return null;
                    };
                    /**
     * Returns the convex hull of the input vertices as a new array of points.
     * @method hull
     * @param {vertices} vertices
     * @return [vertex] vertices
     */ Vertices.hull = function(vertices) {
                        // http://geomalgorithms.com/a10-_hull-1.html
                        var upper = [], lower = [], vertex, i;
                        // sort vertices on x-axis (y-axis for ties)
                        vertices = vertices.slice(0);
                        vertices.sort(function(vertexA, vertexB) {
                            var dx = vertexA.x - vertexB.x;
                            return dx !== 0 ? dx : vertexA.y - vertexB.y;
                        });
                        // build lower hull
                        for(i = 0; i < vertices.length; i += 1){
                            vertex = vertices[i];
                            while(lower.length >= 2 && Vector.cross3(lower[lower.length - 2], lower[lower.length - 1], vertex) <= 0)lower.pop();
                            lower.push(vertex);
                        }
                        // build upper hull
                        for(i = vertices.length - 1; i >= 0; i -= 1){
                            vertex = vertices[i];
                            while(upper.length >= 2 && Vector.cross3(upper[upper.length - 2], upper[upper.length - 1], vertex) <= 0)upper.pop();
                            upper.push(vertex);
                        }
                        // concatenation of the lower and upper hulls gives the convex hull
                        // omit last points because they are repeated at the beginning of the other list
                        upper.pop();
                        lower.pop();
                        return upper.concat(lower);
                    };
                })();
            /***/ },
            /***/ 55973: /***/ (module1)=>{
                /**
 * @author       Stefan Hedman <schteppe@gmail.com> (http://steffe.se)
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  v0.3.0
                module1.exports = {
                    decomp: polygonDecomp,
                    quickDecomp: polygonQuickDecomp,
                    isSimple: polygonIsSimple,
                    removeCollinearPoints: polygonRemoveCollinearPoints,
                    removeDuplicatePoints: polygonRemoveDuplicatePoints,
                    makeCCW: polygonMakeCCW
                };
                /**
 * Compute the intersection between two lines.
 * @static
 * @method lineInt
 * @param  {Array}  l1          Line vector 1
 * @param  {Array}  l2          Line vector 2
 * @param  {Number} precision   Precision to use when checking if the lines are parallel
 * @return {Array}              The intersection point.
 */ function lineInt(l1, l2, precision) {
                    precision = precision || 0;
                    var i = [
                        0,
                        0
                    ]; // point
                    var a1, b1, c1, a2, b2, c2, det; // scalars
                    a1 = l1[1][1] - l1[0][1];
                    b1 = l1[0][0] - l1[1][0];
                    c1 = a1 * l1[0][0] + b1 * l1[0][1];
                    a2 = l2[1][1] - l2[0][1];
                    b2 = l2[0][0] - l2[1][0];
                    c2 = a2 * l2[0][0] + b2 * l2[0][1];
                    det = a1 * b2 - a2 * b1;
                    if (!scalar_eq(det, 0, precision)) {
                        i[0] = (b2 * c1 - b1 * c2) / det;
                        i[1] = (a1 * c2 - a2 * c1) / det;
                    }
                    return i;
                }
                /**
 * Checks if two line segments intersects.
 * @method segmentsIntersect
 * @param {Array} p1 The start vertex of the first line segment.
 * @param {Array} p2 The end vertex of the first line segment.
 * @param {Array} q1 The start vertex of the second line segment.
 * @param {Array} q2 The end vertex of the second line segment.
 * @return {Boolean} True if the two line segments intersect
 */ function lineSegmentsIntersect(p1, p2, q1, q2) {
                    var dx = p2[0] - p1[0];
                    var dy = p2[1] - p1[1];
                    var da = q2[0] - q1[0];
                    var db = q2[1] - q1[1];
                    // segments are parallel
                    if (da * dy - db * dx === 0) return false;
                    var s = (dx * (q1[1] - p1[1]) + dy * (p1[0] - q1[0])) / (da * dy - db * dx);
                    var t = (da * (p1[1] - q1[1]) + db * (q1[0] - p1[0])) / (db * dx - da * dy);
                    return s >= 0 && s <= 1 && t >= 0 && t <= 1;
                }
                /**
 * Get the area of a triangle spanned by the three given points. Note that the area will be negative if the points are not given in counter-clockwise order.
 * @static
 * @method area
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return {Number}
 */ function triangleArea(a, b, c) {
                    return (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
                }
                function isLeft(a, b, c) {
                    return triangleArea(a, b, c) > 0;
                }
                function isLeftOn(a, b, c) {
                    return triangleArea(a, b, c) >= 0;
                }
                function isRight(a, b, c) {
                    return triangleArea(a, b, c) < 0;
                }
                function isRightOn(a, b, c) {
                    return triangleArea(a, b, c) <= 0;
                }
                var tmpPoint1 = [], tmpPoint2 = [];
                /**
 * Check if three points are collinear
 * @method collinear
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @param  {Number} [thresholdAngle=0] Threshold angle to use when comparing the vectors. The function will return true if the angle between the resulting vectors is less than this value. Use zero for max precision.
 * @return {Boolean}
 */ function collinear(a, b, c, thresholdAngle) {
                    if (!thresholdAngle) return triangleArea(a, b, c) === 0;
                    else {
                        var ab = tmpPoint1, bc = tmpPoint2;
                        ab[0] = b[0] - a[0];
                        ab[1] = b[1] - a[1];
                        bc[0] = c[0] - b[0];
                        bc[1] = c[1] - b[1];
                        var dot = ab[0] * bc[0] + ab[1] * bc[1], magA = Math.sqrt(ab[0] * ab[0] + ab[1] * ab[1]), magB = Math.sqrt(bc[0] * bc[0] + bc[1] * bc[1]), angle = Math.acos(dot / (magA * magB));
                        return angle < thresholdAngle;
                    }
                }
                function sqdist(a, b) {
                    var dx = b[0] - a[0];
                    var dy = b[1] - a[1];
                    return dx * dx + dy * dy;
                }
                /**
 * Get a vertex at position i. It does not matter if i is out of bounds, this function will just cycle.
 * @method at
 * @param  {Number} i
 * @return {Array}
 */ function polygonAt(polygon, i) {
                    var s = polygon.length;
                    return polygon[i < 0 ? i % s + s : i % s];
                }
                /**
 * Clear the polygon data
 * @method clear
 * @return {Array}
 */ function polygonClear(polygon) {
                    polygon.length = 0;
                }
                /**
 * Append points "from" to "to"-1 from an other polygon "poly" onto this one.
 * @method append
 * @param {Polygon} poly The polygon to get points from.
 * @param {Number}  from The vertex index in "poly".
 * @param {Number}  to The end vertex index in "poly". Note that this vertex is NOT included when appending.
 * @return {Array}
 */ function polygonAppend(polygon, poly, from, to) {
                    for(var i = from; i < to; i++)polygon.push(poly[i]);
                }
                /**
 * Make sure that the polygon vertices are ordered counter-clockwise.
 * @method makeCCW
 */ function polygonMakeCCW(polygon) {
                    var br = 0, v = polygon;
                    // find bottom right point
                    for(var i = 1; i < polygon.length; ++i)if (v[i][1] < v[br][1] || v[i][1] === v[br][1] && v[i][0] > v[br][0]) br = i;
                    // reverse poly if clockwise
                    if (!isLeft(polygonAt(polygon, br - 1), polygonAt(polygon, br), polygonAt(polygon, br + 1))) {
                        polygonReverse(polygon);
                        return true;
                    } else return false;
                }
                /**
 * Reverse the vertices in the polygon
 * @method reverse
 */ function polygonReverse(polygon) {
                    var tmp = [];
                    var N = polygon.length;
                    for(var i = 0; i !== N; i++)tmp.push(polygon.pop());
                    for(var i = 0; i !== N; i++)polygon[i] = tmp[i];
                }
                /**
 * Check if a point in the polygon is a reflex point
 * @method isReflex
 * @param  {Number}  i
 * @return {Boolean}
 */ function polygonIsReflex(polygon, i) {
                    return isRight(polygonAt(polygon, i - 1), polygonAt(polygon, i), polygonAt(polygon, i + 1));
                }
                var tmpLine1 = [], tmpLine2 = [];
                /**
 * Check if two vertices in the polygon can see each other
 * @method canSee
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ function polygonCanSee(polygon, a, b) {
                    var p, dist, l1 = tmpLine1, l2 = tmpLine2;
                    if (isLeftOn(polygonAt(polygon, a + 1), polygonAt(polygon, a), polygonAt(polygon, b)) && isRightOn(polygonAt(polygon, a - 1), polygonAt(polygon, a), polygonAt(polygon, b))) return false;
                    dist = sqdist(polygonAt(polygon, a), polygonAt(polygon, b));
                    for(var i = 0; i !== polygon.length; ++i){
                        if ((i + 1) % polygon.length === a || i === a) continue;
                        if (isLeftOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i + 1)) && isRightOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i))) {
                            l1[0] = polygonAt(polygon, a);
                            l1[1] = polygonAt(polygon, b);
                            l2[0] = polygonAt(polygon, i);
                            l2[1] = polygonAt(polygon, i + 1);
                            p = lineInt(l1, l2);
                            if (sqdist(polygonAt(polygon, a), p) < dist) return false;
                        }
                    }
                    return true;
                }
                /**
 * Check if two vertices in the polygon can see each other
 * @method canSee2
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ function polygonCanSee2(polygon, a, b) {
                    // for each edge
                    for(var i = 0; i !== polygon.length; ++i){
                        // ignore incident edges
                        if (i === a || i === b || (i + 1) % polygon.length === a || (i + 1) % polygon.length === b) continue;
                        if (lineSegmentsIntersect(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i), polygonAt(polygon, i + 1))) return false;
                    }
                    return true;
                }
                /**
 * Copy the polygon from vertex i to vertex j.
 * @method copy
 * @param  {Number} i
 * @param  {Number} j
 * @param  {Polygon} [targetPoly]   Optional target polygon to save in.
 * @return {Polygon}                The resulting copy.
 */ function polygonCopy(polygon, i, j, targetPoly) {
                    var p = targetPoly || [];
                    polygonClear(p);
                    if (i < j) // Insert all vertices from i to j
                    for(var k = i; k <= j; k++)p.push(polygon[k]);
                    else {
                        // Insert vertices 0 to j
                        for(var k = 0; k <= j; k++)p.push(polygon[k]);
                        // Insert vertices i to end
                        for(var k = i; k < polygon.length; k++)p.push(polygon[k]);
                    }
                    return p;
                }
                /**
 * Decomposes the polygon into convex pieces. Returns a list of edges [[p1,p2],[p2,p3],...] that cuts the polygon.
 * Note that this algorithm has complexity O(N^4) and will be very slow for polygons with many vertices.
 * @method getCutEdges
 * @return {Array}
 */ function polygonGetCutEdges(polygon) {
                    var min = [], tmp1 = [], tmp2 = [], tmpPoly = [];
                    var nDiags = Number.MAX_VALUE;
                    for(var i = 0; i < polygon.length; ++i)if (polygonIsReflex(polygon, i)) {
                        for(var j = 0; j < polygon.length; ++j)if (polygonCanSee(polygon, i, j)) {
                            tmp1 = polygonGetCutEdges(polygonCopy(polygon, i, j, tmpPoly));
                            tmp2 = polygonGetCutEdges(polygonCopy(polygon, j, i, tmpPoly));
                            for(var k = 0; k < tmp2.length; k++)tmp1.push(tmp2[k]);
                            if (tmp1.length < nDiags) {
                                min = tmp1;
                                nDiags = tmp1.length;
                                min.push([
                                    polygonAt(polygon, i),
                                    polygonAt(polygon, j)
                                ]);
                            }
                        }
                    }
                    return min;
                }
                /**
 * Decomposes the polygon into one or more convex sub-Polygons.
 * @method decomp
 * @return {Array} An array or Polygon objects.
 */ function polygonDecomp(polygon) {
                    var edges = polygonGetCutEdges(polygon);
                    if (edges.length > 0) return polygonSlice(polygon, edges);
                    else return [
                        polygon
                    ];
                }
                /**
 * Slices the polygon given one or more cut edges. If given one, this function will return two polygons (false on failure). If many, an array of polygons.
 * @method slice
 * @param {Array} cutEdges A list of edges, as returned by .getCutEdges()
 * @return {Array}
 */ function polygonSlice(polygon, cutEdges) {
                    if (cutEdges.length === 0) return [
                        polygon
                    ];
                    if (cutEdges instanceof Array && cutEdges.length && cutEdges[0] instanceof Array && cutEdges[0].length === 2 && cutEdges[0][0] instanceof Array) {
                        var polys = [
                            polygon
                        ];
                        for(var i = 0; i < cutEdges.length; i++){
                            var cutEdge = cutEdges[i];
                            // Cut all polys
                            for(var j = 0; j < polys.length; j++){
                                var poly = polys[j];
                                var result = polygonSlice(poly, cutEdge);
                                if (result) {
                                    // Found poly! Cut and quit
                                    polys.splice(j, 1);
                                    polys.push(result[0], result[1]);
                                    break;
                                }
                            }
                        }
                        return polys;
                    } else {
                        // Was given one edge
                        var cutEdge = cutEdges;
                        var i = polygon.indexOf(cutEdge[0]);
                        var j = polygon.indexOf(cutEdge[1]);
                        if (i !== -1 && j !== -1) return [
                            polygonCopy(polygon, i, j),
                            polygonCopy(polygon, j, i)
                        ];
                        else return false;
                    }
                }
                /**
 * Checks that the line segments of this polygon do not intersect each other.
 * @method isSimple
 * @param  {Array} path An array of vertices e.g. [[0,0],[0,1],...]
 * @return {Boolean}
 * @todo Should it check all segments with all others?
 */ function polygonIsSimple(polygon) {
                    var path = polygon, i;
                    // Check
                    for(i = 0; i < path.length - 1; i++)for(var j = 0; j < i - 1; j++){
                        if (lineSegmentsIntersect(path[i], path[i + 1], path[j], path[j + 1])) return false;
                    }
                    // Check the segment between the last and the first point to all others
                    for(i = 1; i < path.length - 2; i++){
                        if (lineSegmentsIntersect(path[0], path[path.length - 1], path[i], path[i + 1])) return false;
                    }
                    return true;
                }
                function getIntersectionPoint(p1, p2, q1, q2, delta) {
                    delta = delta || 0;
                    var a1 = p2[1] - p1[1];
                    var b1 = p1[0] - p2[0];
                    var c1 = a1 * p1[0] + b1 * p1[1];
                    var a2 = q2[1] - q1[1];
                    var b2 = q1[0] - q2[0];
                    var c2 = a2 * q1[0] + b2 * q1[1];
                    var det = a1 * b2 - a2 * b1;
                    if (!scalar_eq(det, 0, delta)) return [
                        (b2 * c1 - b1 * c2) / det,
                        (a1 * c2 - a2 * c1) / det
                    ];
                    else return [
                        0,
                        0
                    ];
                }
                /**
 * Quickly decompose the Polygon into convex sub-polygons.
 * @method quickDecomp
 * @param  {Array} result
 * @param  {Array} [reflexVertices]
 * @param  {Array} [steinerPoints]
 * @param  {Number} [delta]
 * @param  {Number} [maxlevel]
 * @param  {Number} [level]
 * @return {Array}
 */ function polygonQuickDecomp(polygon, result, reflexVertices, steinerPoints, delta, maxlevel, level) {
                    maxlevel = maxlevel || 100;
                    level = level || 0;
                    delta = delta || 25;
                    result = typeof result !== "undefined" ? result : [];
                    reflexVertices = reflexVertices || [];
                    steinerPoints = steinerPoints || [];
                    var upperInt = [
                        0,
                        0
                    ], lowerInt = [
                        0,
                        0
                    ], p = [
                        0,
                        0
                    ]; // Points
                    var upperDist = 0, lowerDist = 0, d = 0, closestDist = 0; // scalars
                    var upperIndex = 0, lowerIndex = 0, closestIndex = 0; // Integers
                    var lowerPoly = [], upperPoly = []; // polygons
                    var poly = polygon, v = polygon;
                    if (v.length < 3) return result;
                    level++;
                    if (level > maxlevel) {
                        console.warn("quickDecomp: max level (" + maxlevel + ") reached.");
                        return result;
                    }
                    for(var i = 0; i < polygon.length; ++i)if (polygonIsReflex(poly, i)) {
                        reflexVertices.push(poly[i]);
                        upperDist = lowerDist = Number.MAX_VALUE;
                        for(var j = 0; j < polygon.length; ++j){
                            if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j - 1))) {
                                p = getIntersectionPoint(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j - 1)); // find the point of intersection
                                if (isRight(polygonAt(poly, i + 1), polygonAt(poly, i), p)) {
                                    d = sqdist(poly[i], p);
                                    if (d < lowerDist) {
                                        lowerDist = d;
                                        lowerInt = p;
                                        lowerIndex = j;
                                    }
                                }
                            }
                            if (isLeft(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j + 1)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
                                p = getIntersectionPoint(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j + 1));
                                if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), p)) {
                                    d = sqdist(poly[i], p);
                                    if (d < upperDist) {
                                        upperDist = d;
                                        upperInt = p;
                                        upperIndex = j;
                                    }
                                }
                            }
                        }
                        // if there are no vertices to connect to, choose a point in the middle
                        if (lowerIndex === (upperIndex + 1) % polygon.length) {
                            //console.log("Case 1: Vertex("+i+"), lowerIndex("+lowerIndex+"), upperIndex("+upperIndex+"), poly.size("+polygon.length+")");
                            p[0] = (lowerInt[0] + upperInt[0]) / 2;
                            p[1] = (lowerInt[1] + upperInt[1]) / 2;
                            steinerPoints.push(p);
                            if (i < upperIndex) {
                                //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.begin() + upperIndex + 1);
                                polygonAppend(lowerPoly, poly, i, upperIndex + 1);
                                lowerPoly.push(p);
                                upperPoly.push(p);
                                if (lowerIndex !== 0) //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.end());
                                polygonAppend(upperPoly, poly, lowerIndex, poly.length);
                                //upperPoly.insert(upperPoly.end(), poly.begin(), poly.begin() + i + 1);
                                polygonAppend(upperPoly, poly, 0, i + 1);
                            } else {
                                if (i !== 0) //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.end());
                                polygonAppend(lowerPoly, poly, i, poly.length);
                                //lowerPoly.insert(lowerPoly.end(), poly.begin(), poly.begin() + upperIndex + 1);
                                polygonAppend(lowerPoly, poly, 0, upperIndex + 1);
                                lowerPoly.push(p);
                                upperPoly.push(p);
                                //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.begin() + i + 1);
                                polygonAppend(upperPoly, poly, lowerIndex, i + 1);
                            }
                        } else {
                            // connect to the closest point within the triangle
                            //console.log("Case 2: Vertex("+i+"), closestIndex("+closestIndex+"), poly.size("+polygon.length+")\n");
                            if (lowerIndex > upperIndex) upperIndex += polygon.length;
                            closestDist = Number.MAX_VALUE;
                            if (upperIndex < lowerIndex) return result;
                            for(var j = lowerIndex; j <= upperIndex; ++j)if (isLeftOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
                                d = sqdist(polygonAt(poly, i), polygonAt(poly, j));
                                if (d < closestDist && polygonCanSee2(poly, i, j)) {
                                    closestDist = d;
                                    closestIndex = j % polygon.length;
                                }
                            }
                            if (i < closestIndex) {
                                polygonAppend(lowerPoly, poly, i, closestIndex + 1);
                                if (closestIndex !== 0) polygonAppend(upperPoly, poly, closestIndex, v.length);
                                polygonAppend(upperPoly, poly, 0, i + 1);
                            } else {
                                if (i !== 0) polygonAppend(lowerPoly, poly, i, v.length);
                                polygonAppend(lowerPoly, poly, 0, closestIndex + 1);
                                polygonAppend(upperPoly, poly, closestIndex, i + 1);
                            }
                        }
                        // solve smallest poly first
                        if (lowerPoly.length < upperPoly.length) {
                            polygonQuickDecomp(lowerPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                            polygonQuickDecomp(upperPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                        } else {
                            polygonQuickDecomp(upperPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                            polygonQuickDecomp(lowerPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                        }
                        return result;
                    }
                    result.push(polygon);
                    return result;
                }
                /**
 * Remove collinear points in the polygon.
 * @method removeCollinearPoints
 * @param  {Number} [precision] The threshold angle to use when determining whether two edges are collinear. Use zero for finest precision.
 * @return {Number}           The number of points removed
 */ function polygonRemoveCollinearPoints(polygon, precision) {
                    var num = 0;
                    for(var i = polygon.length - 1; polygon.length > 3 && i >= 0; --i)if (collinear(polygonAt(polygon, i - 1), polygonAt(polygon, i), polygonAt(polygon, i + 1), precision)) {
                        // Remove the middle point
                        polygon.splice(i % polygon.length, 1);
                        num++;
                    }
                    return num;
                }
                /**
 * Remove duplicate points in the polygon.
 * @method removeDuplicatePoints
 * @param  {Number} [precision] The threshold to use when determining whether two points are the same. Use zero for best precision.
 */ function polygonRemoveDuplicatePoints(polygon, precision) {
                    for(var i = polygon.length - 1; i >= 1; --i){
                        var pi = polygon[i];
                        for(var j = i - 1; j >= 0; --j)if (points_eq(pi, polygon[j], precision)) {
                            polygon.splice(i, 1);
                            continue;
                        }
                    }
                }
                /**
 * Check if two scalars are equal
 * @static
 * @method eq
 * @param  {Number} a
 * @param  {Number} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ function scalar_eq(a, b, precision) {
                    precision = precision || 0;
                    return Math.abs(a - b) <= precision;
                }
                /**
 * Check if two points are equal
 * @static
 * @method points_eq
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ function points_eq(a, b, precision) {
                    return scalar_eq(a[0], b[0], precision) && scalar_eq(a[1], b[1], precision);
                }
            /***/ },
            /***/ 52018: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* @author       Richard Davey <rich@phaser.io>
* @copyright    2013-2025 Phaser Studio Inc.
* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
*/ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * A Global Plugin is installed just once into the Game owned Plugin Manager.
 * It can listen for Game events and respond to them.
 *
 * @class BasePlugin
 * @memberof Phaser.Plugins
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Plugins.PluginManager} pluginManager - A reference to the Plugin Manager.
 */ var BasePlugin = new Class({
                    initialize: function BasePlugin(pluginManager) {
                        /**
         * A handy reference to the Plugin Manager that is responsible for this plugin.
         * Can be used as a route to gain access to game systems and  events.
         *
         * @name Phaser.Plugins.BasePlugin#pluginManager
         * @type {Phaser.Plugins.PluginManager}
         * @protected
         * @since 3.8.0
         */ this.pluginManager = pluginManager;
                        /**
         * A reference to the Game instance this plugin is running under.
         *
         * @name Phaser.Plugins.BasePlugin#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.8.0
         */ this.game = pluginManager.game;
                    },
                    /**
     * The PluginManager calls this method on a Global Plugin when the plugin is first instantiated.
     * It will never be called again on this instance.
     * In here you can set-up whatever you need for this plugin to run.
     * If a plugin is set to automatically start then `BasePlugin.start` will be called immediately after this.
     * On a Scene Plugin, this method is never called. Use {@link Phaser.Plugins.ScenePlugin#boot} instead.
     *
     * @method Phaser.Plugins.BasePlugin#init
     * @since 3.8.0
     *
     * @param {?any} [data] - A value specified by the user, if any, from the `data` property of the plugin's configuration object (if started at game boot) or passed in the PluginManager's `install` method (if started manually).
     */ init: function() {},
                    /**
     * The PluginManager calls this method on a Global Plugin when the plugin is started.
     * If a plugin is stopped, and then started again, this will get called again.
     * Typically called immediately after `BasePlugin.init`.
     * On a Scene Plugin, this method is never called.
     *
     * @method Phaser.Plugins.BasePlugin#start
     * @since 3.8.0
     */ start: function() {
                    //  Here are the game-level events you can listen to.
                    //  At the very least you should offer a destroy handler for when the game closes down.
                    // var eventEmitter = this.game.events;
                    // eventEmitter.once('destroy', this.gameDestroy, this);
                    // eventEmitter.on('pause', this.gamePause, this);
                    // eventEmitter.on('resume', this.gameResume, this);
                    // eventEmitter.on('resize', this.gameResize, this);
                    // eventEmitter.on('prestep', this.gamePreStep, this);
                    // eventEmitter.on('step', this.gameStep, this);
                    // eventEmitter.on('poststep', this.gamePostStep, this);
                    // eventEmitter.on('prerender', this.gamePreRender, this);
                    // eventEmitter.on('postrender', this.gamePostRender, this);
                    },
                    /**
     * The PluginManager calls this method on a Global Plugin when the plugin is stopped.
     * The game code has requested that your plugin stop doing whatever it does.
     * It is now considered as 'inactive' by the PluginManager.
     * Handle that process here (i.e. stop listening for events, etc)
     * If the plugin is started again then `BasePlugin.start` will be called again.
     * On a Scene Plugin, this method is never called.
     *
     * @method Phaser.Plugins.BasePlugin#stop
     * @since 3.8.0
     */ stop: function() {},
                    /**
     * Game instance has been destroyed.
     * You must release everything in here, all references, all objects, free it all up.
     *
     * @method Phaser.Plugins.BasePlugin#destroy
     * @since 3.8.0
     */ destroy: function() {
                        this.pluginManager = null;
                        this.game = null;
                        this.scene = null;
                        this.systems = null;
                    }
                });
                module1.exports = BasePlugin;
            /***/ },
            /***/ 42363: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Default Plugins.
 *
 * @namespace Phaser.Plugins.DefaultPlugins
 * @memberof Phaser.Plugins
 * @since 3.0.0
 */ var DefaultPlugins = {
                    /**
     * These are the Global Managers that are created by the Phaser.Game instance.
     * They are referenced from Scene.Systems so that plugins can use them.
     *
     * @name Phaser.Plugins.DefaultPlugins.Global
     * @type {array}
     * @since 3.0.0
     */ Global: [
                        'game',
                        'anims',
                        'cache',
                        'plugins',
                        'registry',
                        'scale',
                        'sound',
                        'textures',
                        'renderer'
                    ],
                    /**
     * These are the core plugins that are installed into every Scene.Systems instance, no matter what.
     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
     *
     * They are created in the order in which they appear in this array and EventEmitter is always first.
     *
     * @name Phaser.Plugins.DefaultPlugins.CoreScene
     * @type {array}
     * @since 3.0.0
     */ CoreScene: [
                        'EventEmitter',
                        'CameraManager',
                        'GameObjectCreator',
                        'GameObjectFactory',
                        'ScenePlugin',
                        'DisplayList',
                        'UpdateList'
                    ],
                    /**
     * These plugins are created in Scene.Systems in addition to the CoreScenePlugins.
     *
     * You can elect not to have these plugins by either creating a DefaultPlugins object as part
     * of the Game Config, by creating a Plugins object as part of a Scene Config, or by modifying this array
     * and building your own bundle.
     *
     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
     *
     * They are always created in the order in which they appear in the array.
     *
     * @name Phaser.Plugins.DefaultPlugins.DefaultScene
     * @type {array}
     * @since 3.0.0
     */ DefaultScene: [
                        'Clock',
                        'DataManagerPlugin',
                        'InputPlugin',
                        'Loader',
                        'TweenManager',
                        'LightsPlugin'
                    ]
                };
                module1.exports = DefaultPlugins;
            /***/ },
            /***/ 37277: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Contains the plugins that Phaser uses globally and locally.
                //  These are the source objects, not instantiated.
                var corePlugins = {};
                //  Contains the plugins that the dev has loaded into their game
                //  These are the source objects, not instantiated.
                var customPlugins = {};
                var PluginCache = {};
                /**
 * @namespace Phaser.Plugins.PluginCache
 */ /**
 * Static method called directly by the Core internal Plugins.
 * Key is a reference used to get the plugin from the plugins object (i.e. InputPlugin)
 * Plugin is the object to instantiate to create the plugin
 * Mapping is what the plugin is injected into the Scene.Systems as (i.e. input)
 *
 * @method Phaser.Plugins.PluginCache.register
 * @since 3.8.0
 *
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
 * @param {boolean} [custom=false] - Core Scene plugin or a Custom Scene plugin?
 */ PluginCache.register = function(key, plugin, mapping, custom) {
                    if (custom === undefined) custom = false;
                    corePlugins[key] = {
                        plugin: plugin,
                        mapping: mapping,
                        custom: custom
                    };
                };
                /**
 * Stores a custom plugin in the global plugin cache.
 * The key must be unique, within the scope of the cache.
 *
 * @method Phaser.Plugins.PluginCache.registerCustom
 * @since 3.8.0
 *
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
 * @param {?any} data - A value to be passed to the plugin's `init` method.
 */ PluginCache.registerCustom = function(key, plugin, mapping, data) {
                    customPlugins[key] = {
                        plugin: plugin,
                        mapping: mapping,
                        data: data
                    };
                };
                /**
 * Checks if the given key is already being used in the core plugin cache.
 *
 * @method Phaser.Plugins.PluginCache.hasCore
 * @since 3.8.0
 *
 * @param {string} key - The key to check for.
 *
 * @return {boolean} `true` if the key is already in use in the core cache, otherwise `false`.
 */ PluginCache.hasCore = function(key) {
                    return corePlugins.hasOwnProperty(key);
                };
                /**
 * Checks if the given key is already being used in the custom plugin cache.
 *
 * @method Phaser.Plugins.PluginCache.hasCustom
 * @since 3.8.0
 *
 * @param {string} key - The key to check for.
 *
 * @return {boolean} `true` if the key is already in use in the custom cache, otherwise `false`.
 */ PluginCache.hasCustom = function(key) {
                    return customPlugins.hasOwnProperty(key);
                };
                /**
 * Returns the core plugin object from the cache based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.getCore
 * @since 3.8.0
 *
 * @param {string} key - The key of the core plugin to get.
 *
 * @return {Phaser.Types.Plugins.CorePluginContainer} The core plugin object.
 */ PluginCache.getCore = function(key) {
                    return corePlugins[key];
                };
                /**
 * Returns the custom plugin object from the cache based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.getCustom
 * @since 3.8.0
 *
 * @param {string} key - The key of the custom plugin to get.
 *
 * @return {Phaser.Types.Plugins.CustomPluginContainer} The custom plugin object.
 */ PluginCache.getCustom = function(key) {
                    return customPlugins[key];
                };
                /**
 * Returns an object from the custom cache based on the given key that can be instantiated.
 *
 * @method Phaser.Plugins.PluginCache.getCustomClass
 * @since 3.8.0
 *
 * @param {string} key - The key of the custom plugin to get.
 *
 * @return {function} The custom plugin object.
 */ PluginCache.getCustomClass = function(key) {
                    return customPlugins.hasOwnProperty(key) ? customPlugins[key].plugin : null;
                };
                /**
 * Removes a core plugin based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.remove
 * @since 3.8.0
 *
 * @param {string} key - The key of the core plugin to remove.
 */ PluginCache.remove = function(key) {
                    if (corePlugins.hasOwnProperty(key)) delete corePlugins[key];
                };
                /**
 * Removes a custom plugin based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.removeCustom
 * @since 3.8.0
 *
 * @param {string} key - The key of the custom plugin to remove.
 */ PluginCache.removeCustom = function(key) {
                    if (customPlugins.hasOwnProperty(key)) delete customPlugins[key];
                };
                /**
 * Removes all Core Plugins.
 *
 * This includes all of the internal system plugins that Phaser needs, like the Input Plugin and Loader Plugin.
 * So be sure you only call this if you do not wish to run Phaser again.
 *
 * @method Phaser.Plugins.PluginCache.destroyCorePlugins
 * @since 3.12.0
 */ PluginCache.destroyCorePlugins = function() {
                    for(var key in corePlugins)if (corePlugins.hasOwnProperty(key)) delete corePlugins[key];
                };
                /**
 * Removes all Custom Plugins.
 *
 * @method Phaser.Plugins.PluginCache.destroyCustomPlugins
 * @since 3.12.0
 */ PluginCache.destroyCustomPlugins = function() {
                    for(var key in customPlugins)if (customPlugins.hasOwnProperty(key)) delete customPlugins[key];
                };
                module1.exports = PluginCache;
            /***/ },
            /***/ 77332: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GameEvents = __webpack_require__(8443);
                var EventEmitter = __webpack_require__(50792);
                var FileTypesManager = __webpack_require__(74099);
                var GameObjectCreator = __webpack_require__(44603);
                var GameObjectFactory = __webpack_require__(39429);
                var GetFastValue = __webpack_require__(95540);
                var PluginCache = __webpack_require__(37277);
                var Remove = __webpack_require__(72905);
                var CONST = __webpack_require__(8054);
                /**
 * @classdesc
 * The PluginManager is responsible for installing and adding plugins to Phaser.
 *
 * It is a global system and therefore belongs to the Game instance, not a specific Scene.
 *
 * It works in conjunction with the PluginCache. Core internal plugins automatically register themselves
 * with the Cache, but it's the Plugin Manager that is responsible for injecting them into the Scenes.
 *
 * There are two types of plugin:
 *
 * 1. A Global Plugin
 * 2. A Scene Plugin
 *
 * A Global Plugin is a plugin that lives within the Plugin Manager rather than a Scene. You can get
 * access to it by calling `PluginManager.get` and providing a key. Any Scene that requests a plugin in
 * this way will get access to the same plugin instance, allowing you to use a single plugin across
 * multiple Scenes.
 *
 * A Scene Plugin is a plugin dedicated to running within a Scene. These are different to Global Plugins
 * in that their instances do not live within the Plugin Manager, but within the Scene Systems class instead.
 * Also, every Scene created is given its own unique instance of a Scene Plugin. Examples of core Scene
 * Plugins include the Input Plugin, the Tween Plugin and the physics Plugins.
 *
 * You can add a plugin to Phaser in three different ways:
 *
 * 1. Preload it
 * 2. Include it in your source code and install it via the Game Config
 * 3. Include it in your source code and install it within a Scene
 *
 * For examples of all of these approaches please see the Phaser 3 Examples Repo `plugins` folder.
 *
 * For information on creating your own plugin please see the Phaser 3 Plugin Template.
 *
 * @class PluginManager
 * @memberof Phaser.Plugins
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The game instance that owns this Plugin Manager.
 */ var PluginManager = new Class({
                    Extends: EventEmitter,
                    initialize: function PluginManager(game) {
                        EventEmitter.call(this);
                        /**
         * The game instance that owns this Plugin Manager.
         *
         * @name Phaser.Plugins.PluginManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                        /**
         * The global plugins currently running and managed by this Plugin Manager.
         * A plugin must have been started at least once in order to appear in this list.
         *
         * @name Phaser.Plugins.PluginManager#plugins
         * @type {Phaser.Types.Plugins.GlobalPlugin[]}
         * @since 3.8.0
         */ this.plugins = [];
                        /**
         * A list of plugin keys that should be installed into Scenes as well as the Core Plugins.
         *
         * @name Phaser.Plugins.PluginManager#scenePlugins
         * @type {string[]}
         * @since 3.8.0
         */ this.scenePlugins = [];
                        /**
         * A temporary list of plugins to install when the game has booted.
         *
         * @name Phaser.Plugins.PluginManager#_pendingGlobal
         * @private
         * @type {array}
         * @since 3.8.0
         */ this._pendingGlobal = [];
                        /**
         * A temporary list of scene plugins to install when the game has booted.
         *
         * @name Phaser.Plugins.PluginManager#_pendingScene
         * @private
         * @type {array}
         * @since 3.8.0
         */ this._pendingScene = [];
                        if (game.isBooted || game.config.renderType === CONST.HEADLESS) this.boot();
                        else game.events.once(GameEvents.BOOT, this.boot, this);
                    },
                    /**
     * Runs once the game has booted and installs all of the plugins configured in the Game Config.
     *
     * @method Phaser.Plugins.PluginManager#boot
     * @protected
     * @since 3.0.0
     */ boot: function() {
                        var i;
                        var entry;
                        var key;
                        var plugin;
                        var start;
                        var mapping;
                        var data;
                        var config = this.game.config;
                        //  Any plugins to install?
                        var list = config.installGlobalPlugins;
                        //  Any plugins added outside of the game config, but before the game booted?
                        list = list.concat(this._pendingGlobal);
                        for(i = 0; i < list.length; i++){
                            entry = list[i];
                            // { key: 'TestPlugin', plugin: TestPlugin, start: true, mapping: 'test', data: { msg: 'The plugin is alive' } }
                            key = GetFastValue(entry, 'key', null);
                            plugin = GetFastValue(entry, 'plugin', null);
                            start = GetFastValue(entry, 'start', false);
                            mapping = GetFastValue(entry, 'mapping', null);
                            data = GetFastValue(entry, 'data', null);
                            if (key) {
                                if (plugin) this.install(key, plugin, start, mapping, data);
                                else console.warn('Missing `plugin` for key: ' + key);
                            }
                        }
                        //  Any scene plugins to install?
                        list = config.installScenePlugins;
                        //  Any plugins added outside of the game config, but before the game booted?
                        list = list.concat(this._pendingScene);
                        for(i = 0; i < list.length; i++){
                            entry = list[i];
                            // { key: 'moveSpritePlugin', plugin: MoveSpritePlugin, , mapping: 'move' }
                            key = GetFastValue(entry, 'key', null);
                            plugin = GetFastValue(entry, 'plugin', null);
                            mapping = GetFastValue(entry, 'mapping', null);
                            if (key) {
                                if (plugin) this.installScenePlugin(key, plugin, mapping);
                                else console.warn('Missing `plugin` for key: ' + key);
                            }
                        }
                        this._pendingGlobal = [];
                        this._pendingScene = [];
                        this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * Called by the Scene Systems class. Tells the plugin manager to install all Scene plugins into it.
     *
     * First it will install global references, i.e. references from the Game systems into the Scene Systems (and Scene if mapped.)
     * Then it will install Core Scene Plugins followed by Scene Plugins registered with the PluginManager.
     * Finally it will install any references to Global Plugins that have a Scene mapping property into the Scene itself.
     *
     * @method Phaser.Plugins.PluginManager#addToScene
     * @protected
     * @since 3.8.0
     *
     * @param {Phaser.Scenes.Systems} sys - The Scene Systems class to install all the plugins in to.
     * @param {array} globalPlugins - An array of global plugins to install.
     * @param {array} scenePlugins - An array of scene plugins to install.
     */ addToScene: function(sys, globalPlugins, scenePlugins) {
                        var i;
                        var pluginKey;
                        var pluginList;
                        var game = this.game;
                        var scene = sys.scene;
                        var map = sys.settings.map;
                        var isBooted = sys.settings.isBooted;
                        //  Reference the GlobalPlugins from Game into Scene.Systems
                        for(i = 0; i < globalPlugins.length; i++){
                            pluginKey = globalPlugins[i];
                            if (game[pluginKey]) {
                                sys[pluginKey] = game[pluginKey];
                                //  Scene level injection
                                if (map.hasOwnProperty(pluginKey)) scene[map[pluginKey]] = sys[pluginKey];
                            } else if (pluginKey === 'game' && map.hasOwnProperty(pluginKey)) scene[map[pluginKey]] = game;
                        }
                        for(var s = 0; s < scenePlugins.length; s++){
                            pluginList = scenePlugins[s];
                            for(i = 0; i < pluginList.length; i++){
                                pluginKey = pluginList[i];
                                if (!PluginCache.hasCore(pluginKey)) continue;
                                var source = PluginCache.getCore(pluginKey);
                                var mapKey = source.mapping;
                                var plugin = new source.plugin(scene, this, mapKey);
                                sys[mapKey] = plugin;
                                //  Scene level injection
                                if (source.custom) scene[mapKey] = plugin;
                                else if (map.hasOwnProperty(mapKey)) scene[map[mapKey]] = plugin;
                                //  Scene is already booted, usually because this method is being called at run-time, so boot the plugin
                                if (isBooted) plugin.boot();
                            }
                        }
                        //  And finally, inject any 'global scene plugins'
                        pluginList = this.plugins;
                        for(i = 0; i < pluginList.length; i++){
                            var entry = pluginList[i];
                            if (entry.mapping) scene[entry.mapping] = entry.plugin;
                        }
                    },
                    /**
     * Called by the Scene Systems class. Returns a list of plugins to be installed.
     *
     * @method Phaser.Plugins.PluginManager#getDefaultScenePlugins
     * @protected
     * @since 3.8.0
     *
     * @return {string[]} A list keys of all the Scene Plugins to install.
     */ getDefaultScenePlugins: function() {
                        var list = this.game.config.defaultPlugins;
                        //  Merge in custom Scene plugins
                        list = list.concat(this.scenePlugins);
                        return list;
                    },
                    /**
     * Installs a new Scene Plugin into the Plugin Manager and optionally adds it
     * to the given Scene as well. A Scene Plugin added to the manager in this way
     * will be automatically installed into all new Scenes using the key and mapping given.
     *
     * The `key` property is what the plugin is injected into Scene.Systems as.
     * The `mapping` property is optional, and if specified is what the plugin is installed into
     * the Scene as. For example:
     *
     * ```javascript
     * this.plugins.installScenePlugin('powerupsPlugin', pluginCode, 'powerups');
     *
     * // and from within the scene:
     * this.sys.powerupsPlugin; // key value
     * this.powerups; // mapping value
     * ```
     *
     * This method is called automatically by Phaser if you install your plugins using either the
     * Game Configuration object, or by preloading them via the Loader.
     *
     * @method Phaser.Plugins.PluginManager#installScenePlugin
     * @since 3.8.0
     *
     * @param {string} key - The property key that will be used to add this plugin to Scene.Systems.
     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
     * @param {string} [mapping] - If this plugin is injected into the Phaser.Scene class, this is the property key to use.
     * @param {Phaser.Scene} [addToScene] - Optionally automatically add this plugin to the given Scene.
     * @param {boolean} [fromLoader=false] - Is this being called by the Loader?
     */ installScenePlugin: function(key, plugin, mapping, addToScene, fromLoader) {
                        if (fromLoader === undefined) fromLoader = false;
                        if (typeof plugin !== 'function') {
                            console.warn('Invalid Scene Plugin: ' + key);
                            return;
                        }
                        if (!PluginCache.hasCore(key)) //  Plugin is freshly loaded
                        PluginCache.register(key, plugin, mapping, true);
                        if (this.scenePlugins.indexOf(key) === -1) this.scenePlugins.push(key);
                        else if (!fromLoader && PluginCache.hasCore(key)) {
                            //  Plugin wasn't from the loader but already exists
                            console.warn('Scene Plugin key in use: ' + key);
                            return;
                        }
                        if (addToScene) {
                            var instance = new plugin(addToScene, this, key);
                            addToScene.sys[key] = instance;
                            if (mapping && mapping !== '') addToScene[mapping] = instance;
                            instance.boot();
                        }
                    },
                    /**
     * Installs a new Global Plugin into the Plugin Manager and optionally starts it running.
     * A global plugin belongs to the Plugin Manager, rather than a specific Scene, and can be accessed
     * and used by all Scenes in your game.
     *
     * The `key` property is what you use to access this plugin from the Plugin Manager.
     *
     * ```javascript
     * this.plugins.install('powerupsPlugin', pluginCode);
     *
     * // and from within the scene:
     * this.plugins.get('powerupsPlugin');
     * ```
     *
     * This method is called automatically by Phaser if you install your plugins using either the
     * Game Configuration object, or by preloading them via the Loader.
     *
     * The same plugin can be installed multiple times into the Plugin Manager by simply giving each
     * instance its own unique key.
     *
     * @method Phaser.Plugins.PluginManager#install
     * @since 3.8.0
     *
     * @param {string} key - The unique handle given to this plugin within the Plugin Manager.
     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
     * @param {boolean} [start=false] - Automatically start the plugin running? This is always `true` if you provide a mapping value.
     * @param {string} [mapping] - If this plugin is injected into the Phaser.Scene class, this is the property key to use.
     * @param {any} [data] - A value passed to the plugin's `init` method.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if `start` was false, or game isn't yet booted.
     */ install: function(key, plugin, start, mapping, data) {
                        if (start === undefined) start = false;
                        if (mapping === undefined) mapping = null;
                        if (data === undefined) data = null;
                        if (typeof plugin !== 'function') {
                            console.warn('Invalid Plugin: ' + key);
                            return null;
                        }
                        if (PluginCache.hasCustom(key)) {
                            console.warn('Plugin key in use: ' + key);
                            return null;
                        }
                        if (mapping !== null) start = true;
                        if (!this.game.isBooted) this._pendingGlobal.push({
                            key: key,
                            plugin: plugin,
                            start: start,
                            mapping: mapping,
                            data: data
                        });
                        else {
                            //  Add it to the plugin store
                            PluginCache.registerCustom(key, plugin, mapping, data);
                            if (start) return this.start(key);
                        }
                        return null;
                    },
                    /**
     * Gets an index of a global plugin based on the given key.
     *
     * @method Phaser.Plugins.PluginManager#getIndex
     * @protected
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {number} The index of the plugin within the plugins array.
     */ getIndex: function(key) {
                        var list = this.plugins;
                        for(var i = 0; i < list.length; i++){
                            var entry = list[i];
                            if (entry.key === key) return i;
                        }
                        return -1;
                    },
                    /**
     * Gets a global plugin based on the given key.
     *
     * @method Phaser.Plugins.PluginManager#getEntry
     * @protected
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {Phaser.Types.Plugins.GlobalPlugin} The plugin entry.
     */ getEntry: function(key) {
                        var idx = this.getIndex(key);
                        if (idx !== -1) return this.plugins[idx];
                    },
                    /**
     * Checks if the given global plugin, based on its key, is active or not.
     *
     * @method Phaser.Plugins.PluginManager#isActive
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {boolean} `true` if the plugin is active, otherwise `false`.
     */ isActive: function(key) {
                        var entry = this.getEntry(key);
                        return entry && entry.active;
                    },
                    /**
     * Starts a global plugin running.
     *
     * If the plugin was previously active then calling `start` will reset it to an active state and then
     * call its `start` method.
     *
     * If the plugin has never been run before a new instance of it will be created within the Plugin Manager,
     * its active state set and then both of its `init` and `start` methods called, in that order.
     *
     * If the plugin is already running under the given key then nothing happens.
     *
     * @method Phaser.Plugins.PluginManager#start
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to start.
     * @param {string} [runAs] - Run the plugin under a new key. This allows you to run one plugin multiple times.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if invalid key given or plugin is already stopped.
     */ start: function(key, runAs) {
                        if (runAs === undefined) runAs = key;
                        var entry = this.getEntry(runAs);
                        //  Plugin already running under this key?
                        if (entry && !entry.active) {
                            //  It exists, we just need to start it up again
                            entry.active = true;
                            entry.plugin.start();
                        } else if (!entry) entry = this.createEntry(key, runAs);
                        return entry ? entry.plugin : null;
                    },
                    /**
     * Creates a new instance of a global plugin, adds an entry into the plugins array and returns it.
     *
     * @method Phaser.Plugins.PluginManager#createEntry
     * @private
     * @since 3.9.0
     *
     * @param {string} key - The key of the plugin to create an instance of.
     * @param {string} [runAs] - Run the plugin under a new key. This allows you to run one plugin multiple times.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if invalid key given.
     */ createEntry: function(key, runAs) {
                        var entry = PluginCache.getCustom(key);
                        if (entry) {
                            var instance = new entry.plugin(this);
                            entry = {
                                key: runAs,
                                plugin: instance,
                                active: true,
                                mapping: entry.mapping,
                                data: entry.data
                            };
                            this.plugins.push(entry);
                            instance.init(entry.data);
                            instance.start();
                        }
                        return entry;
                    },
                    /**
     * Stops a global plugin from running.
     *
     * If the plugin is active then its active state will be set to false and the plugins `stop` method
     * will be called.
     *
     * If the plugin is not already running, nothing will happen.
     *
     * @method Phaser.Plugins.PluginManager#stop
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to stop.
     *
     * @return {this} The Plugin Manager.
     */ stop: function(key) {
                        var entry = this.getEntry(key);
                        if (entry && entry.active) {
                            entry.active = false;
                            entry.plugin.stop();
                        }
                        return this;
                    },
                    /**
     * Gets a global plugin from the Plugin Manager based on the given key and returns it.
     *
     * If it cannot find an active plugin based on the key, but there is one in the Plugin Cache with the same key,
     * then it will create a new instance of the cached plugin and return that.
     *
     * @method Phaser.Plugins.PluginManager#get
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to get.
     * @param {boolean} [autoStart=true] - Automatically start a new instance of the plugin if found in the cache, but not actively running.
     *
     * @return {?(Phaser.Plugins.BasePlugin|function)} The plugin, or `null` if no plugin was found matching the key.
     */ get: function(key, autoStart) {
                        if (autoStart === undefined) autoStart = true;
                        var entry = this.getEntry(key);
                        if (entry) return entry.plugin;
                        else {
                            var plugin = this.getClass(key);
                            if (plugin && autoStart) {
                                entry = this.createEntry(key, key);
                                return entry ? entry.plugin : null;
                            } else if (plugin) return plugin;
                        }
                        return null;
                    },
                    /**
     * Returns the plugin class from the cache.
     * Used internally by the Plugin Manager.
     *
     * @method Phaser.Plugins.PluginManager#getClass
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to get.
     *
     * @return {Phaser.Plugins.BasePlugin} A Plugin object
     */ getClass: function(key) {
                        return PluginCache.getCustomClass(key);
                    },
                    /**
     * Removes a global plugin from the Plugin Manager and Plugin Cache.
     *
     * It is up to you to remove all references to this plugin that you may hold within your game code.
     *
     * @method Phaser.Plugins.PluginManager#removeGlobalPlugin
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to remove.
     */ removeGlobalPlugin: function(key) {
                        var entry = this.getEntry(key);
                        if (entry) Remove(this.plugins, entry);
                        PluginCache.removeCustom(key);
                    },
                    /**
     * Removes a scene plugin from the Plugin Manager and Plugin Cache.
     *
     * This will not remove the plugin from any active Scenes that are already using it.
     *
     * It is up to you to remove all references to this plugin that you may hold within your game code.
     *
     * @method Phaser.Plugins.PluginManager#removeScenePlugin
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to remove.
     */ removeScenePlugin: function(key) {
                        Remove(this.scenePlugins, key);
                        PluginCache.remove(key);
                    },
                    /**
     * Registers a new type of Game Object with the global Game Object Factory and / or Creator.
     * This is usually called from within your Plugin code and is a helpful short-cut for creating
     * new Game Objects.
     *
     * The key is the property that will be injected into the factories and used to create the
     * Game Object. For example:
     *
     * ```javascript
     * this.plugins.registerGameObject('clown', clownFactoryCallback, clownCreatorCallback);
     * // later in your game code:
     * this.add.clown();
     * this.make.clown();
     * ```
     *
     * The callbacks are what are called when the factories try to create a Game Object
     * matching the given key. It's important to understand that the callbacks are invoked within
     * the context of the GameObjectFactory. In this context there are several properties available
     * to use:
     *
     * this.scene - A reference to the Scene that owns the GameObjectFactory.
     * this.displayList - A reference to the Display List the Scene owns.
     * this.updateList - A reference to the Update List the Scene owns.
     *
     * See the GameObjectFactory and GameObjectCreator classes for more details.
     * Any public property or method listed is available from your callbacks under `this`.
     *
     * @method Phaser.Plugins.PluginManager#registerGameObject
     * @since 3.8.0
     *
     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
     * @param {function} [factoryCallback] - The callback to invoke when the Game Object Factory is called.
     * @param {function} [creatorCallback] - The callback to invoke when the Game Object Creator is called.
     */ registerGameObject: function(key, factoryCallback, creatorCallback) {
                        if (factoryCallback) GameObjectFactory.register(key, factoryCallback);
                        if (creatorCallback) GameObjectCreator.register(key, creatorCallback);
                        return this;
                    },
                    /**
     * Removes a previously registered Game Object from the global Game Object Factory and / or Creator.
     * This is usually called from within your Plugin destruction code to help clean-up after your plugin has been removed.
     *
     * @method Phaser.Plugins.PluginManager#removeGameObject
     * @since 3.19.0
     *
     * @param {string} key - The key of the Game Object to be removed from the factories.
     * @param {boolean} [removeFromFactory=true] - Should the Game Object be removed from the Game Object Factory?
     * @param {boolean} [removeFromCreator=true] - Should the Game Object be removed from the Game Object Creator?
     */ removeGameObject: function(key, removeFromFactory, removeFromCreator) {
                        if (removeFromFactory === undefined) removeFromFactory = true;
                        if (removeFromCreator === undefined) removeFromCreator = true;
                        if (removeFromFactory) GameObjectFactory.remove(key);
                        if (removeFromCreator) GameObjectCreator.remove(key);
                        return this;
                    },
                    /**
     * Registers a new file type with the global File Types Manager, making it available to all Loader
     * Plugins created after this.
     *
     * This is usually called from within your Plugin code and is a helpful short-cut for creating
     * new loader file types.
     *
     * The key is the property that will be injected into the Loader Plugin and used to load the
     * files. For example:
     *
     * ```javascript
     * this.plugins.registerFileType('wad', doomWadLoaderCallback);
     * // later in your preload code:
     * this.load.wad();
     * ```
     *
     * The callback is what is called when the loader tries to load a file  matching the given key.
     * It's important to understand that the callback is invoked within
     * the context of the LoaderPlugin. In this context there are several properties / methods available
     * to use:
     *
     * this.addFile - A method to add the new file to the load queue.
     * this.scene - The Scene that owns the Loader Plugin instance.
     *
     * See the LoaderPlugin class for more details. Any public property or method listed is available from
     * your callback under `this`.
     *
     * @method Phaser.Plugins.PluginManager#registerFileType
     * @since 3.8.0
     *
     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
     * @param {function} callback - The callback to invoke when the Game Object Factory is called.
     * @param {Phaser.Scene} [addToScene] - Optionally add this file type into the Loader Plugin owned by the given Scene.
     */ registerFileType: function(key, callback, addToScene) {
                        FileTypesManager.register(key, callback);
                        if (addToScene && addToScene.sys.load) addToScene.sys.load[key] = callback;
                    },
                    /**
     * Destroys this Plugin Manager and all associated plugins.
     * It will iterate all plugins found and call their `destroy` methods.
     *
     * The PluginCache will remove all custom plugins.
     *
     * @method Phaser.Plugins.PluginManager#destroy
     * @since 3.8.0
     */ destroy: function() {
                        for(var i = 0; i < this.plugins.length; i++)this.plugins[i].plugin.destroy();
                        PluginCache.destroyCustomPlugins();
                        if (this.game.noReturn) PluginCache.destroyCorePlugins();
                        this.game = null;
                        this.plugins = [];
                        this.scenePlugins = [];
                    }
                });
                /*
 * "Sometimes, the elegant implementation is just a function.
 * Not a method. Not a class. Not a framework. Just a function."
 *  -- John Carmack
 */ module1.exports = PluginManager;
            /***/ },
            /***/ 45145: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
* @author       Richard Davey <rich@phaser.io>
* @copyright    2013-2025 Phaser Studio Inc.
* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
*/ var BasePlugin = __webpack_require__(52018);
                var Class = __webpack_require__(83419);
                var SceneEvents = __webpack_require__(44594);
                /**
 * @classdesc
 * A Scene Level Plugin is installed into every Scene and belongs to that Scene.
 * It can listen for Scene events and respond to them.
 * It can map itself to a Scene property, or into the Scene Systems, or both.
 *
 * @class ScenePlugin
 * @memberof Phaser.Plugins
 * @extends Phaser.Plugins.BasePlugin
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that has installed this plugin.
 * @param {Phaser.Plugins.PluginManager} pluginManager - A reference to the Plugin Manager.
 * @param {string} pluginKey - The key under which this plugin has been installed into the Scene Systems.
 */ var ScenePlugin = new Class({
                    Extends: BasePlugin,
                    initialize: function ScenePlugin(scene, pluginManager, pluginKey) {
                        BasePlugin.call(this, pluginManager);
                        /**
         * A reference to the Scene that has installed this plugin.
         * Only set if it's a Scene Plugin, otherwise `null`.
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#scene
         * @type {?Phaser.Scene}
         * @protected
         * @since 3.8.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene Systems of the Scene that has installed this plugin.
         * Only set if it's a Scene Plugin, otherwise `null`.
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#systems
         * @type {?Phaser.Scenes.Systems}
         * @protected
         * @since 3.8.0
         */ this.systems = scene.sys;
                        /**
         * The key under which this plugin was installed into the Scene Systems.
         *
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#pluginKey
         * @type {string}
         * @readonly
         * @since 3.54.0
         */ this.pluginKey = pluginKey;
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    },
                    /**
     * This method is called when the Scene boots. It is only ever called once.
     *
     * By this point the plugin properties `scene` and `systems` will have already been set.
     *
     * In here you can listen for {@link Phaser.Scenes.Events Scene events} and set-up whatever you need for this plugin to run.
     * Here are the Scene events you can listen to:
     *
     * - start
     * - ready
     * - preupdate
     * - update
     * - postupdate
     * - resize
     * - pause
     * - resume
     * - sleep
     * - wake
     * - transitioninit
     * - transitionstart
     * - transitioncomplete
     * - transitionout
     * - shutdown
     * - destroy
     *
     * At the very least you should offer a destroy handler for when the Scene closes down, i.e:
     *
     * ```javascript
     * var eventEmitter = this.systems.events;
     * eventEmitter.once('destroy', this.sceneDestroy, this);
     * ```
     *
     * @method Phaser.Plugins.ScenePlugin#boot
     * @since 3.8.0
     */ boot: function() {},
                    /**
     * Game instance has been destroyed.
     *
     * You must release everything in here, all references, all objects, free it all up.
     *
     * @method Phaser.Plugins.ScenePlugin#destroy
     * @since 3.8.0
     */ destroy: function() {
                        this.pluginManager = null;
                        this.game = null;
                        this.scene = null;
                        this.systems = null;
                    }
                });
                module1.exports = ScenePlugin;
            /***/ },
            /***/ 18922: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Plugins
 */ module1.exports = {
                    BasePlugin: __webpack_require__(52018),
                    DefaultPlugins: __webpack_require__(42363),
                    PluginCache: __webpack_require__(37277),
                    PluginManager: __webpack_require__(77332),
                    ScenePlugin: __webpack_require__(45145)
                };
            /***/ },
            /***/ 63595: /***/ ()=>{
                //  From https://github.com/ThaUnknown/rvfc-polyfill
                if (typeof HTMLVideoElement !== 'undefined' && !('requestVideoFrameCallback' in HTMLVideoElement.prototype) && 'getVideoPlaybackQuality' in HTMLVideoElement.prototype) {
                    HTMLVideoElement.prototype._rvfcpolyfillmap = {};
                    HTMLVideoElement.prototype.requestVideoFrameCallback = function(callback) {
                        const handle = performance.now();
                        const quality = this.getVideoPlaybackQuality();
                        const baseline = this.mozPresentedFrames || this.mozPaintedFrames || quality.totalVideoFrames - quality.droppedVideoFrames;
                        const check = (old, now)=>{
                            const newquality = this.getVideoPlaybackQuality();
                            const presentedFrames = this.mozPresentedFrames || this.mozPaintedFrames || newquality.totalVideoFrames - newquality.droppedVideoFrames;
                            if (presentedFrames > baseline) {
                                const processingDuration = this.mozFrameDelay || newquality.totalFrameDelay - quality.totalFrameDelay || 0;
                                const timediff = now - old // HighRes diff
                                ;
                                callback(now, {
                                    presentationTime: now + processingDuration * 1000,
                                    expectedDisplayTime: now + timediff,
                                    width: this.videoWidth,
                                    height: this.videoHeight,
                                    mediaTime: Math.max(0, this.currentTime || 0) + timediff / 1000,
                                    presentedFrames: presentedFrames,
                                    processingDuration: processingDuration
                                });
                                delete this._rvfcpolyfillmap[handle];
                            } else this._rvfcpolyfillmap[handle] = requestAnimationFrame((newer)=>check(now, newer));
                        };
                        this._rvfcpolyfillmap[handle] = requestAnimationFrame((newer)=>check(handle, newer));
                        return handle;
                    };
                    HTMLVideoElement.prototype.cancelVideoFrameCallback = function(handle) {
                        cancelAnimationFrame(this._rvfcpolyfillmap[handle]);
                        delete this._rvfcpolyfillmap[handle];
                    };
                }
            /***/ },
            /***/ 10312: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Blend Modes.
 *
 * @namespace Phaser.BlendModes
 * @since 3.0.0
 */ module1.exports = {
                    /**
     * Skips the Blend Mode check in the renderer.
     *
     * @name Phaser.BlendModes.SKIP_CHECK
     * @type {number}
     * @const
     * @since 3.0.0
     */ SKIP_CHECK: -1,
                    /**
     * Normal blend mode. For Canvas and WebGL.
     * This is the default setting and draws new shapes on top of the existing canvas content.
     *
     * @name Phaser.BlendModes.NORMAL
     * @type {number}
     * @const
     * @since 3.0.0
     */ NORMAL: 0,
                    /**
     * Add blend mode. For Canvas and WebGL.
     * Where both shapes overlap the color is determined by adding color values.
     *
     * @name Phaser.BlendModes.ADD
     * @type {number}
     * @const
     * @since 3.0.0
     */ ADD: 1,
                    /**
     * Multiply blend mode. For Canvas and WebGL.
     * The pixels are of the top layer are multiplied with the corresponding pixel of the bottom layer. A darker picture is the result.
     *
     * @name Phaser.BlendModes.MULTIPLY
     * @type {number}
     * @const
     * @since 3.0.0
     */ MULTIPLY: 2,
                    /**
     * Screen blend mode. For Canvas and WebGL.
     * The pixels are inverted, multiplied, and inverted again. A lighter picture is the result (opposite of multiply)
     *
     * @name Phaser.BlendModes.SCREEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ SCREEN: 3,
                    /**
     * Overlay blend mode. For Canvas only.
     * A combination of multiply and screen. Dark parts on the base layer become darker, and light parts become lighter.
     *
     * @name Phaser.BlendModes.OVERLAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ OVERLAY: 4,
                    /**
     * Darken blend mode. For Canvas only.
     * Retains the darkest pixels of both layers.
     *
     * @name Phaser.BlendModes.DARKEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ DARKEN: 5,
                    /**
     * Lighten blend mode. For Canvas only.
     * Retains the lightest pixels of both layers.
     *
     * @name Phaser.BlendModes.LIGHTEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ LIGHTEN: 6,
                    /**
     * Color Dodge blend mode. For Canvas only.
     * Divides the bottom layer by the inverted top layer.
     *
     * @name Phaser.BlendModes.COLOR_DODGE
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR_DODGE: 7,
                    /**
     * Color Burn blend mode. For Canvas only.
     * Divides the inverted bottom layer by the top layer, and then inverts the result.
     *
     * @name Phaser.BlendModes.COLOR_BURN
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR_BURN: 8,
                    /**
     * Hard Light blend mode. For Canvas only.
     * A combination of multiply and screen like overlay, but with top and bottom layer swapped.
     *
     * @name Phaser.BlendModes.HARD_LIGHT
     * @type {number}
     * @const
     * @since 3.0.0
     */ HARD_LIGHT: 9,
                    /**
     * Soft Light blend mode. For Canvas only.
     * A softer version of hard-light. Pure black or white does not result in pure black or white.
     *
     * @name Phaser.BlendModes.SOFT_LIGHT
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOFT_LIGHT: 10,
                    /**
     * Difference blend mode. For Canvas only.
     * Subtracts the bottom layer from the top layer or the other way round to always get a positive value.
     *
     * @name Phaser.BlendModes.DIFFERENCE
     * @type {number}
     * @const
     * @since 3.0.0
     */ DIFFERENCE: 11,
                    /**
     * Exclusion blend mode. For Canvas only.
     * Like difference, but with lower contrast.
     *
     * @name Phaser.BlendModes.EXCLUSION
     * @type {number}
     * @const
     * @since 3.0.0
     */ EXCLUSION: 12,
                    /**
     * Hue blend mode. For Canvas only.
     * Preserves the luma and chroma of the bottom layer, while adopting the hue of the top layer.
     *
     * @name Phaser.BlendModes.HUE
     * @type {number}
     * @const
     * @since 3.0.0
     */ HUE: 13,
                    /**
     * Saturation blend mode. For Canvas only.
     * Preserves the luma and hue of the bottom layer, while adopting the chroma of the top layer.
     *
     * @name Phaser.BlendModes.SATURATION
     * @type {number}
     * @const
     * @since 3.0.0
     */ SATURATION: 14,
                    /**
     * Color blend mode. For Canvas only.
     * Preserves the luma of the bottom layer, while adopting the hue and chroma of the top layer.
     *
     * @name Phaser.BlendModes.COLOR
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR: 15,
                    /**
     * Luminosity blend mode. For Canvas only.
     * Preserves the hue and chroma of the bottom layer, while adopting the luma of the top layer.
     *
     * @name Phaser.BlendModes.LUMINOSITY
     * @type {number}
     * @const
     * @since 3.0.0
     */ LUMINOSITY: 16,
                    /**
     * Alpha erase blend mode. For Canvas and WebGL.
     *
     * @name Phaser.BlendModes.ERASE
     * @type {number}
     * @const
     * @since 3.0.0
     */ ERASE: 17,
                    /**
     * Source-in blend mode. For Canvas only.
     * The new shape is drawn only where both the new shape and the destination canvas overlap. Everything else is made transparent.
     *
     * @name Phaser.BlendModes.SOURCE_IN
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_IN: 18,
                    /**
     * Source-out blend mode. For Canvas only.
     * The new shape is drawn where it doesn't overlap the existing canvas content.
     *
     * @name Phaser.BlendModes.SOURCE_OUT
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_OUT: 19,
                    /**
     * Source-out blend mode. For Canvas only.
     * The new shape is only drawn where it overlaps the existing canvas content.
     *
     * @name Phaser.BlendModes.SOURCE_ATOP
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_ATOP: 20,
                    /**
     * Destination-over blend mode. For Canvas only.
     * New shapes are drawn behind the existing canvas content.
     *
     * @name Phaser.BlendModes.DESTINATION_OVER
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_OVER: 21,
                    /**
     * Destination-in blend mode. For Canvas only.
     * The existing canvas content is kept where both the new shape and existing canvas content overlap. Everything else is made transparent.
     *
     * @name Phaser.BlendModes.DESTINATION_IN
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_IN: 22,
                    /**
     * Destination-out blend mode. For Canvas only.
     * The existing content is kept where it doesn't overlap the new shape.
     *
     * @name Phaser.BlendModes.DESTINATION_OUT
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_OUT: 23,
                    /**
     * Destination-out blend mode. For Canvas only.
     * The existing canvas is only kept where it overlaps the new shape. The new shape is drawn behind the canvas content.
     *
     * @name Phaser.BlendModes.DESTINATION_ATOP
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_ATOP: 24,
                    /**
     * Lighten blend mode. For Canvas only.
     * Where both shapes overlap the color is determined by adding color values.
     *
     * @name Phaser.BlendModes.LIGHTER
     * @type {number}
     * @const
     * @since 3.0.0
     */ LIGHTER: 25,
                    /**
     * Copy blend mode. For Canvas only.
     * Only the new shape is shown.
     *
     * @name Phaser.BlendModes.COPY
     * @type {number}
     * @const
     * @since 3.0.0
     */ COPY: 26,
                    /**
     * Xor blend mode. For Canvas only.
     * Shapes are made transparent where both overlap and drawn normal everywhere else.
     *
     * @name Phaser.BlendModes.XOR
     * @type {number}
     * @const
     * @since 3.0.0
     */ XOR: 27
                };
            /***/ },
            /***/ 29795: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Modes.
 *
 * @namespace Phaser.ScaleModes
 * @since 3.0.0
 */ var ScaleModes = {
                    /**
     * Default Scale Mode (Linear).
     *
     * @name Phaser.ScaleModes.DEFAULT
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ DEFAULT: 0,
                    /**
     * Linear Scale Mode.
     *
     * @name Phaser.ScaleModes.LINEAR
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ LINEAR: 0,
                    /**
     * Nearest Scale Mode.
     *
     * @name Phaser.ScaleModes.NEAREST
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ NEAREST: 1
                };
                module1.exports = ScaleModes;
            /***/ },
            /***/ 68627: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CameraEvents = __webpack_require__(19715);
                var CanvasSnapshot = __webpack_require__(32880);
                var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(8054);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(92503);
                var GetBlendModes = __webpack_require__(56373);
                var ScaleEvents = __webpack_require__(97480);
                var TextureEvents = __webpack_require__(69442);
                var GameEvents = __webpack_require__(8443);
                var TransformMatrix = __webpack_require__(61340);
                /**
 * @classdesc
 * The Canvas Renderer is responsible for managing 2D canvas rendering contexts,
 * including the one used by the Games canvas. It tracks the internal state of a
 * given context and can renderer textured Game Objects to it, taking into
 * account alpha, blending, and scaling.
 *
 * @class CanvasRenderer
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.Canvas
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser Game instance that owns this renderer.
 */ var CanvasRenderer = new Class({
                    Extends: EventEmitter,
                    initialize: function CanvasRenderer(game) {
                        EventEmitter.call(this);
                        var gameConfig = game.config;
                        /**
         * The local configuration settings of the CanvasRenderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#config
         * @type {object}
         * @since 3.0.0
         */ this.config = {
                            clearBeforeRender: gameConfig.clearBeforeRender,
                            backgroundColor: gameConfig.backgroundColor,
                            antialias: gameConfig.antialias,
                            roundPixels: gameConfig.roundPixels,
                            transparent: gameConfig.transparent
                        };
                        /**
         * The Phaser Game instance that owns this renderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                        /**
         * A constant which allows the renderer to be easily identified as a Canvas Renderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#type
         * @type {number}
         * @since 3.0.0
         */ this.type = CONST.CANVAS;
                        /**
         * The total number of Game Objects which were rendered in a frame.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#drawCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.drawCount = 0;
                        /**
         * The width of the canvas being rendered to.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                        /**
         * The height of the canvas being rendered to.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                        /**
         * The canvas element which the Game uses.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameCanvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.gameCanvas = game.canvas;
                        var contextOptions = {
                            alpha: gameConfig.transparent,
                            desynchronized: gameConfig.desynchronized,
                            willReadFrequently: false
                        };
                        /**
         * The canvas context used to render all Cameras in all Scenes during the game loop.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameContext
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.gameContext = gameConfig.context ? gameConfig.context : this.gameCanvas.getContext('2d', contextOptions);
                        /**
         * The canvas context currently used by the CanvasRenderer for all rendering operations.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#currentContext
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.currentContext = this.gameContext;
                        /**
         * Should the Canvas use Image Smoothing or not when drawing Sprites?
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#antialias
         * @type {boolean}
         * @since 3.20.0
         */ this.antialias = gameConfig.antialias;
                        /**
         * The blend modes supported by the Canvas Renderer.
         *
         * This object maps the {@link Phaser.BlendModes} to canvas compositing operations.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#blendModes
         * @type {array}
         * @since 3.0.0
         */ this.blendModes = GetBlendModes();
                        /**
         * Details about the currently scheduled snapshot.
         *
         * If a non-null `callback` is set in this object, a snapshot of the canvas will be taken after the current frame is fully rendered.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#snapshotState
         * @type {Phaser.Types.Renderer.Snapshot.SnapshotState}
         * @since 3.16.0
         */ this.snapshotState = {
                            x: 0,
                            y: 0,
                            width: 1,
                            height: 1,
                            getPixel: false,
                            callback: null,
                            type: 'image/png',
                            encoder: 0.92
                        };
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix1 = new TransformMatrix();
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix2 = new TransformMatrix();
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix3 = new TransformMatrix();
                        /**
         * Has this renderer fully booted yet?
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#isBooted
         * @type {boolean}
         * @since 3.50.0
         */ this.isBooted = false;
                        this.init();
                    },
                    /**
     * Prepares the game canvas for rendering.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#init
     * @since 3.0.0
     */ init: function() {
                        var game = this.game;
                        game.events.once(GameEvents.BOOT, function() {
                            var config = this.config;
                            if (!config.transparent) {
                                var ctx = this.gameContext;
                                var gameCanvas = this.gameCanvas;
                                ctx.fillStyle = config.backgroundColor.rgba;
                                ctx.fillRect(0, 0, gameCanvas.width, gameCanvas.height);
                            }
                        }, this);
                        game.textures.once(TextureEvents.READY, this.boot, this);
                    },
                    /**
     * Internal boot handler.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#boot
     * @private
     * @since 3.50.0
     */ boot: function() {
                        var game = this.game;
                        var baseSize = game.scale.baseSize;
                        this.width = baseSize.width;
                        this.height = baseSize.height;
                        this.isBooted = true;
                        game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                        this.resize(baseSize.width, baseSize.height);
                    },
                    /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#onResize
     * @since 3.16.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions multiplied by the resolution. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize) {
                        //  Has the underlying canvas size changed?
                        if (baseSize.width !== this.width || baseSize.height !== this.height) this.resize(baseSize.width, baseSize.height);
                    },
                    /**
     * Resize the main game canvas.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#resize
     * @fires Phaser.Renderer.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} [width] - The new width of the renderer.
     * @param {number} [height] - The new height of the renderer.
     */ resize: function(width, height) {
                        this.width = width;
                        this.height = height;
                        this.emit(Events.RESIZE, width, height);
                    },
                    /**
     * Resets the transformation matrix of the current context to the identity matrix, thus resetting any transformation.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#resetTransform
     * @since 3.0.0
     */ resetTransform: function() {
                        this.currentContext.setTransform(1, 0, 0, 1, 0, 0);
                    },
                    /**
     * Sets the blend mode (compositing operation) of the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setBlendMode
     * @since 3.0.0
     *
     * @param {string} blendMode - The new blend mode which should be used.
     *
     * @return {this} This CanvasRenderer object.
     */ setBlendMode: function(blendMode) {
                        this.currentContext.globalCompositeOperation = blendMode;
                        return this;
                    },
                    /**
     * Changes the Canvas Rendering Context that all draw operations are performed against.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setContext
     * @since 3.12.0
     *
     * @param {?CanvasRenderingContext2D} [ctx] - The new Canvas Rendering Context to draw everything to. Leave empty to reset to the Game Canvas.
     *
     * @return {this} The Canvas Renderer instance.
     */ setContext: function(ctx) {
                        this.currentContext = ctx ? ctx : this.gameContext;
                        return this;
                    },
                    /**
     * Sets the global alpha of the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setAlpha
     * @since 3.0.0
     *
     * @param {number} alpha - The new alpha to use, where 0 is fully transparent and 1 is fully opaque.
     *
     * @return {this} This CanvasRenderer object.
     */ setAlpha: function(alpha) {
                        this.currentContext.globalAlpha = alpha;
                        return this;
                    },
                    /**
     * Called at the start of the render loop.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#preRender
     * @fires Phaser.Renderer.Events#PRE_RENDER_CLEAR
     * @fires Phaser.Renderer.Events#PRE_RENDER
     * @since 3.0.0
     */ preRender: function() {
                        var ctx = this.gameContext;
                        var config = this.config;
                        var width = this.width;
                        var height = this.height;
                        ctx.globalAlpha = 1;
                        ctx.globalCompositeOperation = 'source-over';
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.emit(Events.PRE_RENDER_CLEAR);
                        if (config.clearBeforeRender) {
                            ctx.clearRect(0, 0, width, height);
                            if (!config.transparent) {
                                ctx.fillStyle = config.backgroundColor.rgba;
                                ctx.fillRect(0, 0, width, height);
                            }
                        }
                        ctx.save();
                        this.drawCount = 0;
                        this.emit(Events.PRE_RENDER);
                    },
                    /**
     * The core render step for a Scene Camera.
     *
     * Iterates through the given array of Game Objects and renders them with the given Camera.
     *
     * This is called by the `CameraManager.render` method. The Camera Manager instance belongs to a Scene, and is invoked
     * by the Scene Systems.render method.
     *
     * This method is not called if `Camera.visible` is `false`, or `Camera.alpha` is zero.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#render
     * @fires Phaser.Renderer.Events#RENDER
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to render.
     * @param {Phaser.GameObjects.GameObject[]} children - An array of filtered Game Objects that can be rendered by the given Camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera to render with.
     */ render: function(scene, children, camera) {
                        var childCount = children.length;
                        this.emit(Events.RENDER, scene, camera);
                        var cx = camera.x;
                        var cy = camera.y;
                        var cw = camera.width;
                        var ch = camera.height;
                        var ctx = camera.renderToTexture ? camera.context : scene.sys.context;
                        //  Save context pre-clip
                        ctx.save();
                        if (this.game.scene.customViewports) {
                            ctx.beginPath();
                            ctx.rect(cx, cy, cw, ch);
                            ctx.clip();
                        }
                        camera.emit(CameraEvents.PRE_RENDER, camera);
                        this.currentContext = ctx;
                        var mask = camera.mask;
                        if (mask) mask.preRenderCanvas(this, null, camera._maskCamera);
                        if (!camera.transparent) {
                            ctx.fillStyle = camera.backgroundColor.rgba;
                            ctx.fillRect(cx, cy, cw, ch);
                        }
                        ctx.globalAlpha = camera.alpha;
                        ctx.globalCompositeOperation = 'source-over';
                        this.drawCount += childCount;
                        if (camera.renderToTexture) camera.emit(CameraEvents.PRE_RENDER, camera);
                        camera.matrix.copyToContext(ctx);
                        for(var i = 0; i < childCount; i++){
                            var child = children[i];
                            if (child.mask) child.mask.preRenderCanvas(this, child, camera);
                            child.renderCanvas(this, child, camera);
                            if (child.mask) child.mask.postRenderCanvas(this, child, camera);
                        }
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.globalCompositeOperation = 'source-over';
                        ctx.globalAlpha = 1;
                        camera.flashEffect.postRenderCanvas(ctx);
                        camera.fadeEffect.postRenderCanvas(ctx);
                        camera.dirty = false;
                        if (mask) mask.postRenderCanvas(this);
                        //  Restore pre-clip context
                        ctx.restore();
                        if (camera.renderToTexture) {
                            camera.emit(CameraEvents.POST_RENDER, camera);
                            if (camera.renderToGame) scene.sys.context.drawImage(camera.canvas, cx, cy);
                        }
                        camera.emit(CameraEvents.POST_RENDER, camera);
                    },
                    /**
     * Restores the game context's global settings and takes a snapshot if one is scheduled.
     *
     * The post-render step happens after all Cameras in all Scenes have been rendered.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#postRender
     * @fires Phaser.Renderer.Events#POST_RENDER
     * @since 3.0.0
     */ postRender: function() {
                        var ctx = this.gameContext;
                        ctx.restore();
                        this.emit(Events.POST_RENDER);
                        var state = this.snapshotState;
                        if (state.callback) {
                            CanvasSnapshot(this.gameCanvas, state);
                            state.callback = null;
                        }
                    },
                    /**
     * Takes a snapshot of the given area of the given canvas.
     *
     * Unlike the other snapshot methods, this one is processed immediately and doesn't wait for the next render.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotCanvas
     * @since 3.19.0
     *
     * @param {HTMLCanvasElement} canvas - The canvas to grab from.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {boolean} [getPixel=false] - Grab a single pixel as a Color object, or an area as an Image object?
     * @param {number} [x=0] - The x coordinate to grab from.
     * @param {number} [y=0] - The y coordinate to grab from.
     * @param {number} [width=canvas.width] - The width of the area to grab.
     * @param {number} [height=canvas.height] - The height of the area to grab.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Canvas Renderer.
     */ snapshotCanvas: function(canvas, callback, getPixel, x, y, width, height, type, encoderOptions) {
                        if (getPixel === undefined) getPixel = false;
                        this.snapshotArea(x, y, width, height, callback, type, encoderOptions);
                        var state = this.snapshotState;
                        state.getPixel = getPixel;
                        CanvasSnapshot(canvas, state);
                        state.callback = null;
                        return this;
                    },
                    /**
     * Schedules a snapshot of the entire game viewport to be taken after the current frame is rendered.
     *
     * To capture a specific area see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshot: function(callback, type, encoderOptions) {
                        return this.snapshotArea(0, 0, this.gameCanvas.width, this.gameCanvas.height, callback, type, encoderOptions);
                    },
                    /**
     * Schedules a snapshot of the given area of the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotArea
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                        var state = this.snapshotState;
                        state.callback = callback;
                        state.type = type;
                        state.encoder = encoderOptions;
                        state.getPixel = false;
                        state.x = x;
                        state.y = y;
                        state.width = Math.min(width, this.gameCanvas.width);
                        state.height = Math.min(height, this.gameCanvas.height);
                        return this;
                    },
                    /**
     * Schedules a snapshot of the given pixel from the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific area, see `snapshotArea`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotArea`, for example, then
     * calling this method will override it.
     *
     * Unlike the other two snapshot methods, this one will return a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotPixel: function(x, y, callback) {
                        this.snapshotArea(x, y, 1, 1, callback);
                        this.snapshotState.getPixel = true;
                        return this;
                    },
                    /**
     * Takes a Sprite Game Object, or any object that extends it, and draws it to the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#batchSprite
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The texture based Game Object to draw.
     * @param {Phaser.Textures.Frame} frame - The frame to draw, doesn't have to be that owned by the Game Object.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(sprite, frame, camera, parentTransformMatrix) {
                        var alpha = camera.alpha * sprite.alpha;
                        if (alpha === 0) //  Nothing to see, so abort early
                        return;
                        var ctx = this.currentContext;
                        var camMatrix = this._tempMatrix1;
                        var spriteMatrix = this._tempMatrix2;
                        var cd = frame.canvasData;
                        var frameX = cd.x;
                        var frameY = cd.y;
                        var frameWidth = frame.cutWidth;
                        var frameHeight = frame.cutHeight;
                        var customPivot = frame.customPivot;
                        var res = frame.source.resolution;
                        var displayOriginX = sprite.displayOriginX;
                        var displayOriginY = sprite.displayOriginY;
                        var x = -displayOriginX + frame.x;
                        var y = -displayOriginY + frame.y;
                        if (sprite.isCropped) {
                            var crop = sprite._crop;
                            if (crop.flipX !== sprite.flipX || crop.flipY !== sprite.flipY) frame.updateCropUVs(crop, sprite.flipX, sprite.flipY);
                            frameWidth = crop.cw;
                            frameHeight = crop.ch;
                            frameX = crop.cx;
                            frameY = crop.cy;
                            x = -displayOriginX + crop.x;
                            y = -displayOriginY + crop.y;
                            if (sprite.flipX) {
                                if (x >= 0) x = -(x + frameWidth);
                                else if (x < 0) x = Math.abs(x) - frameWidth;
                            }
                            if (sprite.flipY) {
                                if (y >= 0) y = -(y + frameHeight);
                                else if (y < 0) y = Math.abs(y) - frameHeight;
                            }
                        }
                        var flipX = 1;
                        var flipY = 1;
                        if (sprite.flipX) {
                            if (!customPivot) x += -frame.realWidth + displayOriginX * 2;
                            flipX = -1;
                        }
                        //  Auto-invert the flipY if this is coming from a GLTexture
                        if (sprite.flipY) {
                            if (!customPivot) y += -frame.realHeight + displayOriginY * 2;
                            flipY = -1;
                        }
                        var gx = sprite.x;
                        var gy = sprite.y;
                        if (camera.roundPixels) {
                            gx = Math.floor(gx);
                            gy = Math.floor(gy);
                        }
                        spriteMatrix.applyITRS(gx, gy, sprite.rotation, sprite.scaleX * flipX, sprite.scaleY * flipY);
                        camMatrix.copyFrom(camera.matrix);
                        if (parentTransformMatrix) {
                            //  Multiply the camera by the parent matrix
                            camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * sprite.scrollFactorX, -camera.scrollY * sprite.scrollFactorY);
                            //  Undo the camera scroll
                            spriteMatrix.e = gx;
                            spriteMatrix.f = gy;
                        } else {
                            spriteMatrix.e -= camera.scrollX * sprite.scrollFactorX;
                            spriteMatrix.f -= camera.scrollY * sprite.scrollFactorY;
                        }
                        //  Multiply by the Sprite matrix
                        camMatrix.multiply(spriteMatrix);
                        if (camera.renderRoundPixels) {
                            camMatrix.e = Math.floor(camMatrix.e + 0.5);
                            camMatrix.f = Math.floor(camMatrix.f + 0.5);
                        }
                        ctx.save();
                        camMatrix.setToContext(ctx);
                        ctx.globalCompositeOperation = this.blendModes[sprite.blendMode];
                        ctx.globalAlpha = alpha;
                        ctx.imageSmoothingEnabled = !frame.source.scaleMode;
                        if (sprite.mask) sprite.mask.preRenderCanvas(this, sprite, camera);
                        if (frameWidth > 0 && frameHeight > 0) {
                            var fw = frameWidth / res;
                            var fh = frameHeight / res;
                            if (camera.roundPixels) {
                                x = Math.floor(x + 0.5);
                                y = Math.floor(y + 0.5);
                                fw += 0.5;
                                fh += 0.5;
                            }
                            ctx.drawImage(frame.source.image, frameX, frameY, frameWidth, frameHeight, x, y, fw, fh);
                        }
                        if (sprite.mask) sprite.mask.postRenderCanvas(this, sprite, camera);
                        ctx.restore();
                    },
                    /**
     * Destroys all object references in the Canvas Renderer.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.removeAllListeners();
                        this.game = null;
                        this.gameCanvas = null;
                        this.gameContext = null;
                    }
                });
                module1.exports = CanvasRenderer;
            /***/ },
            /***/ 55830: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Canvas
 */ module1.exports = {
                    CanvasRenderer: __webpack_require__(68627),
                    GetBlendModes: __webpack_require__(56373),
                    SetTransform: __webpack_require__(20926)
                };
            /***/ },
            /***/ 56373: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var modes = __webpack_require__(10312);
                var CanvasFeatures = __webpack_require__(89289);
                /**
 * Returns an array which maps the default blend modes to supported Canvas blend modes.
 *
 * If the browser doesn't support a blend mode, it will default to the normal `source-over` blend mode.
 *
 * @function Phaser.Renderer.Canvas.GetBlendModes
 * @since 3.0.0
 *
 * @return {array} Which Canvas blend mode corresponds to which default Phaser blend mode.
 */ var GetBlendModes = function() {
                    var output = [];
                    var useNew = CanvasFeatures.supportNewBlendModes;
                    var so = 'source-over';
                    output[modes.NORMAL] = so;
                    output[modes.ADD] = 'lighter';
                    output[modes.MULTIPLY] = useNew ? 'multiply' : so;
                    output[modes.SCREEN] = useNew ? 'screen' : so;
                    output[modes.OVERLAY] = useNew ? 'overlay' : so;
                    output[modes.DARKEN] = useNew ? 'darken' : so;
                    output[modes.LIGHTEN] = useNew ? 'lighten' : so;
                    output[modes.COLOR_DODGE] = useNew ? 'color-dodge' : so;
                    output[modes.COLOR_BURN] = useNew ? 'color-burn' : so;
                    output[modes.HARD_LIGHT] = useNew ? 'hard-light' : so;
                    output[modes.SOFT_LIGHT] = useNew ? 'soft-light' : so;
                    output[modes.DIFFERENCE] = useNew ? 'difference' : so;
                    output[modes.EXCLUSION] = useNew ? 'exclusion' : so;
                    output[modes.HUE] = useNew ? 'hue' : so;
                    output[modes.SATURATION] = useNew ? 'saturation' : so;
                    output[modes.COLOR] = useNew ? 'color' : so;
                    output[modes.LUMINOSITY] = useNew ? 'luminosity' : so;
                    output[modes.ERASE] = 'destination-out';
                    output[modes.SOURCE_IN] = 'source-in';
                    output[modes.SOURCE_OUT] = 'source-out';
                    output[modes.SOURCE_ATOP] = 'source-atop';
                    output[modes.DESTINATION_OVER] = 'destination-over';
                    output[modes.DESTINATION_IN] = 'destination-in';
                    output[modes.DESTINATION_OUT] = 'destination-out';
                    output[modes.DESTINATION_ATOP] = 'destination-atop';
                    output[modes.LIGHTER] = 'lighter';
                    output[modes.COPY] = 'copy';
                    output[modes.XOR] = 'xor';
                    return output;
                };
                module1.exports = GetBlendModes;
            /***/ },
            /***/ 20926: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(91296);
                /**
 * Takes a reference to the Canvas Renderer, a Canvas Rendering Context, a Game Object, a Camera and a parent matrix
 * and then performs the following steps:
 *
 * 1. Checks the alpha of the source combined with the Camera alpha. If 0 or less it aborts.
 * 2. Takes the Camera and Game Object matrix and multiplies them, combined with the parent matrix if given.
 * 3. Sets the blend mode of the context to be that used by the Game Object.
 * 4. Sets the alpha value of the context to be that used by the Game Object combined with the Camera.
 * 5. Saves the context state.
 * 6. Sets the final matrix values into the context via setTransform.
 * 7. If the Game Object has a texture frame, imageSmoothingEnabled is set based on frame.source.scaleMode.
 * 8. If the Game Object does not have a texture frame, imageSmoothingEnabled is set based on Renderer.antialias.
 *
 * This function is only meant to be used internally. Most of the Canvas Renderer classes use it.
 *
 * @function Phaser.Renderer.Canvas.SetTransform
 * @since 3.12.0
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {CanvasRenderingContext2D} ctx - The canvas context to set the transform on.
 * @param {Phaser.GameObjects.GameObject} src - The Game Object being rendered. Can be any type that extends the base class.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - A parent transform matrix to apply to the Game Object before rendering.
 *
 * @return {boolean} `true` if the Game Object context was set, otherwise `false`.
 */ var SetTransform = function(renderer, ctx, src, camera, parentMatrix) {
                    var alpha = camera.alpha * src.alpha;
                    if (alpha <= 0) //  Nothing to see, so don't waste time calculating stuff
                    return false;
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    //  Blend Mode
                    ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
                    //  Alpha
                    ctx.globalAlpha = alpha;
                    ctx.save();
                    calcMatrix.setToContext(ctx);
                    ctx.imageSmoothingEnabled = src.frame ? !src.frame.source.scaleMode : renderer.antialias;
                    return true;
                };
                module1.exports = SetTransform;
            /***/ },
            /***/ 63899: /***/ (module1)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Lose WebGL Event.
 *
 * This event is dispatched by the WebGLRenderer when the WebGL context
 * is lost.
 *
 * Context can be lost for a variety of reasons, like leaving the browser tab.
 * The game canvas DOM object will dispatch `webglcontextlost`.
 * All WebGL resources get wiped, and the context is reset.
 *
 * While WebGL is lost, the game will continue to run, but all WebGL resources
 * are lost, and new ones cannot be created.
 *
 * Once the context is restored and the renderer has automatically restored
 * the state, the renderer will emit a `RESTORE_WEBGL` event. At that point,
 * it is safe to continue.
 *
 * @event Phaser.Renderer.Events#LOSE_WEBGL
 * @type {string}
 * @since 3.80.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - the renderer that owns the WebGL context
 */ module1.exports = 'losewebgl';
            /***/ },
            /***/ 6119: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Post-Render Event.
 *
 * This event is dispatched by the Renderer when all rendering, for all cameras in all Scenes,
 * has completed, but before any pending snap shots have been taken.
 *
 * @event Phaser.Renderer.Events#POST_RENDER
 * @type {string}
 * @since 3.50.0
 */ module1.exports = 'postrender';
            /***/ },
            /***/ 48070: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pre-Render Event.
 *
 * This event is dispatched by the Phaser Renderer. This happens right at the start of the render
 * process, after the context has been cleared, the scissors enabled (WebGL only) and everything has been
 * reset ready for the render.
 *
 * @event Phaser.Renderer.Events#PRE_RENDER
 * @type {string}
 * @since 3.50.0
 */ module1.exports = 'prerender';
            /***/ },
            /***/ 15640: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Render Event.
 *
 * This event is dispatched by the Phaser Renderer for every camera in every Scene.
 *
 * It is dispatched before any of the children in the Scene have been rendered.
 *
 * @event Phaser.Renderer.Events#RENDER
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.Scene} scene - The Scene being rendered.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered.
 */ module1.exports = 'render';
            /***/ },
            /***/ 8912: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Renderer Resize Event.
 *
 * This event is dispatched by the Phaser Renderer when it is resized, usually as a result
 * of the Scale Manager resizing.
 *
 * @event Phaser.Renderer.Events#RESIZE
 * @type {string}
 * @since 3.50.0
 *
 * @param {number} width - The new width of the renderer.
 * @param {number} height - The new height of the renderer.
 */ module1.exports = 'resize';
            /***/ },
            /***/ 87124: /***/ (module1)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Restore WebGL Event.
 *
 * This event is dispatched by the WebGLRenderer when the WebGL context
 * is restored.
 *
 * It is dispatched after all WebGL resources have been recreated.
 * Most resources should come back automatically, but you will need to redraw
 * dynamic textures that were GPU bound.
 * Listen to this event to know when you can safely do that.
 *
 * Context can be lost for a variety of reasons, like leaving the browser tab.
 * The game canvas DOM object will dispatch `webglcontextlost`.
 * All WebGL resources get wiped, and the context is reset.
 *
 * Once the context is restored, the canvas will dispatch
 * `webglcontextrestored`. Phaser uses this to re-create necessary resources.
 * Please wait for Phaser to dispatch the `RESTORE_WEBGL` event before
 * re-creating any resources of your own.
 *
 * @event Phaser.Renderer.Events#RESTORE_WEBGL
 * @type {string}
 * @since 3.80.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - the renderer that owns the WebGL context
 */ module1.exports = 'restorewebgl';
            /***/ },
            /***/ 92503: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Events
 */ module1.exports = {
                    LOSE_WEBGL: __webpack_require__(63899),
                    POST_RENDER: __webpack_require__(6119),
                    PRE_RENDER: __webpack_require__(48070),
                    RENDER: __webpack_require__(15640),
                    RESIZE: __webpack_require__(8912),
                    RESTORE_WEBGL: __webpack_require__(87124)
                };
            /***/ },
            /***/ 36909: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer
 */ /**
 * @namespace Phaser.Types.Renderer
 */ module1.exports = {
                    Events: __webpack_require__(92503),
                    Snapshot: __webpack_require__(89966)
                };
                module1.exports.Canvas = __webpack_require__(55830);
                module1.exports.WebGL = __webpack_require__(4159);
            /***/ },
            /***/ 32880: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(27919);
                var Color = __webpack_require__(40987);
                var GetFastValue = __webpack_require__(95540);
                /**
 * Takes a snapshot of an area from the current frame displayed by a canvas.
 *
 * This is then copied to an Image object. When this loads, the results are sent
 * to the callback provided in the Snapshot Configuration object.
 *
 * @function Phaser.Renderer.Snapshot.Canvas
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} sourceCanvas - The canvas to take a snapshot of.
 * @param {Phaser.Types.Renderer.Snapshot.SnapshotState} config - The snapshot configuration object.
 */ var CanvasSnapshot = function(canvas, config) {
                    var callback = GetFastValue(config, 'callback');
                    var type = GetFastValue(config, 'type', 'image/png');
                    var encoderOptions = GetFastValue(config, 'encoder', 0.92);
                    var x = Math.abs(Math.round(GetFastValue(config, 'x', 0)));
                    var y = Math.abs(Math.round(GetFastValue(config, 'y', 0)));
                    var width = Math.floor(GetFastValue(config, 'width', canvas.width));
                    var height = Math.floor(GetFastValue(config, 'height', canvas.height));
                    var getPixel = GetFastValue(config, 'getPixel', false);
                    if (getPixel) {
                        var context = canvas.getContext('2d', {
                            willReadFrequently: false
                        });
                        var imageData = context.getImageData(x, y, 1, 1);
                        var data = imageData.data;
                        callback.call(null, new Color(data[0], data[1], data[2], data[3]));
                    } else if (x !== 0 || y !== 0 || width !== canvas.width || height !== canvas.height) {
                        //  Area Grab
                        var copyCanvas = CanvasPool.createWebGL(this, width, height);
                        var ctx = copyCanvas.getContext('2d', {
                            willReadFrequently: true
                        });
                        if (width > 0 && height > 0) ctx.drawImage(canvas, x, y, width, height, 0, 0, width, height);
                        var image1 = new Image();
                        image1.onerror = function() {
                            callback.call(null);
                            CanvasPool.remove(copyCanvas);
                        };
                        image1.onload = function() {
                            callback.call(null, image1);
                            CanvasPool.remove(copyCanvas);
                        };
                        image1.src = copyCanvas.toDataURL(type, encoderOptions);
                    } else {
                        //  Full Grab
                        var image2 = new Image();
                        image2.onerror = function() {
                            callback.call(null);
                        };
                        image2.onload = function() {
                            callback.call(null, image2);
                        };
                        image2.src = canvas.toDataURL(type, encoderOptions);
                    }
                };
                module1.exports = CanvasSnapshot;
            /***/ },
            /***/ 88815: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(27919);
                var Color = __webpack_require__(40987);
                var GetFastValue = __webpack_require__(95540);
                /**
 * Takes a snapshot of an area from the current frame displayed by a WebGL canvas.
 *
 * This is then copied to an Image object. When this loads, the results are sent
 * to the callback provided in the Snapshot Configuration object.
 *
 * @function Phaser.Renderer.Snapshot.WebGL
 * @since 3.0.0
 *
 * @param {WebGLRenderingContext} sourceContext - The WebGL context to take a snapshot of.
 * @param {Phaser.Types.Renderer.Snapshot.SnapshotState} config - The snapshot configuration object.
 */ var WebGLSnapshot = function(sourceContext, config) {
                    var gl = sourceContext;
                    var callback = GetFastValue(config, 'callback');
                    var type = GetFastValue(config, 'type', 'image/png');
                    var encoderOptions = GetFastValue(config, 'encoder', 0.92);
                    var x = Math.abs(Math.round(GetFastValue(config, 'x', 0)));
                    var y = Math.abs(Math.round(GetFastValue(config, 'y', 0)));
                    var getPixel = GetFastValue(config, 'getPixel', false);
                    var isFramebuffer = GetFastValue(config, 'isFramebuffer', false);
                    var bufferWidth = isFramebuffer ? GetFastValue(config, 'bufferWidth', 1) : gl.drawingBufferWidth;
                    var bufferHeight = isFramebuffer ? GetFastValue(config, 'bufferHeight', 1) : gl.drawingBufferHeight;
                    if (getPixel) {
                        var pixel = new Uint8Array(4);
                        var destY = isFramebuffer ? y : bufferHeight - y;
                        gl.readPixels(x, destY, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
                        callback.call(null, new Color(pixel[0], pixel[1], pixel[2], pixel[3]));
                    } else {
                        var width = Math.floor(GetFastValue(config, 'width', bufferWidth));
                        var height = Math.floor(GetFastValue(config, 'height', bufferHeight));
                        var total = width * height * 4;
                        var pixels = new Uint8Array(total);
                        gl.readPixels(x, bufferHeight - y - height, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
                        var canvas = CanvasPool.createWebGL(this, width, height);
                        var ctx = canvas.getContext('2d', {
                            willReadFrequently: true
                        });
                        var imageData = ctx.getImageData(0, 0, width, height);
                        var data = imageData.data;
                        for(var py = 0; py < height; py++)for(var px = 0; px < width; px++){
                            var sourceIndex = ((height - py - 1) * width + px) * 4;
                            var destIndex = isFramebuffer ? total - (py * width + (width - px)) * 4 : (py * width + px) * 4;
                            data[destIndex + 0] = pixels[sourceIndex + 0];
                            data[destIndex + 1] = pixels[sourceIndex + 1];
                            data[destIndex + 2] = pixels[sourceIndex + 2];
                            data[destIndex + 3] = pixels[sourceIndex + 3];
                        }
                        ctx.putImageData(imageData, 0, 0);
                        var image = new Image();
                        image.onerror = function() {
                            callback.call(null);
                            CanvasPool.remove(canvas);
                        };
                        image.onload = function() {
                            callback.call(null, image);
                            CanvasPool.remove(canvas);
                        };
                        image.src = canvas.toDataURL(type, encoderOptions);
                    }
                };
                module1.exports = WebGLSnapshot;
            /***/ },
            /***/ 89966: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Snapshot
 */ module1.exports = {
                    Canvas: __webpack_require__(32880),
                    WebGL: __webpack_require__(88815)
                };
            /***/ },
            /***/ 7530: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(36060);
                var CustomMap = __webpack_require__(90330);
                var Device = __webpack_require__(82264);
                var GetFastValue = __webpack_require__(95540);
                var RenderTarget = __webpack_require__(32302);
                var SnapCeil = __webpack_require__(63448);
                //  Default Phaser 3 Pipelines
                var BitmapMaskPipeline = __webpack_require__(31302);
                var FX = __webpack_require__(58918);
                var FX_CONST = __webpack_require__(14811);
                var FXPipeline = __webpack_require__(92651);
                var LightPipeline = __webpack_require__(96569);
                var MobilePipeline = __webpack_require__(56527);
                var MultiPipeline = __webpack_require__(57516);
                var PointLightPipeline = __webpack_require__(43439);
                var RopePipeline = __webpack_require__(81041);
                var SinglePipeline = __webpack_require__(12385);
                var UtilityPipeline = __webpack_require__(7589);
                var ArrayEach = __webpack_require__(95428);
                var ArrayRemove = __webpack_require__(72905);
                /**
 * @classdesc
 * The Pipeline Manager is responsible for the creation, activation, running and destruction
 * of WebGL Pipelines and Post FX Pipelines in Phaser 3.
 *
 * The `WebGLRenderer` owns a single instance of the Pipeline Manager, which you can access
 * via the `WebGLRenderer.pipelines` property.
 *
 * By default, there are 9 pipelines installed into the Pipeline Manager when Phaser boots:
 *
 * 1. The Multi Pipeline. Responsible for all multi-texture rendering, i.e. Sprites and Tilemaps.
 * 2. The Rope Pipeline. Responsible for rendering the Rope Game Object.
 * 3. The Light Pipeline. Responsible for rendering the Light Game Object.
 * 4. The Point Light Pipeline. Responsible for rendering the Point Light Game Object.
 * 5. The Single Pipeline. Responsible for rendering Game Objects that explicitly require one bound texture.
 * 6. The Bitmap Mask Pipeline. Responsible for Bitmap Mask rendering.
 * 7. The Utility Pipeline. Responsible for providing lots of handy texture manipulation functions.
 * 8. The Mobile Pipeline. Responsible for rendering on mobile with single-bound textures.
 * 9. The FX Pipeline. Responsible for rendering Game Objects with special FX applied to them.
 *
 * You can add your own custom pipeline via the `PipelineManager.add` method. Pipelines are
 * identified by unique string-based keys.
 *
 * @class PipelineManager
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the WebGL Renderer that owns this Pipeline Manager.
 */ var PipelineManager = new Class({
                    initialize: function PipelineManager(renderer) {
                        /**
         * A reference to the Game instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#game
         * @type {Phaser.Game}
         * @since 3.50.0
         */ this.game = renderer.game;
                        /**
         * A reference to the WebGL Renderer instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = renderer;
                        /**
         * This map stores all pipeline classes available in this manager.
         *
         * The Utility Class must always come first.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#classes
         * @type {Phaser.Structs.Map.<string, Class>}
         * @since 3.50.0
         */ this.classes = new CustomMap([
                            [
                                CONST.UTILITY_PIPELINE,
                                UtilityPipeline
                            ],
                            [
                                CONST.MULTI_PIPELINE,
                                MultiPipeline
                            ],
                            [
                                CONST.BITMAPMASK_PIPELINE,
                                BitmapMaskPipeline
                            ],
                            [
                                CONST.SINGLE_PIPELINE,
                                SinglePipeline
                            ],
                            [
                                CONST.ROPE_PIPELINE,
                                RopePipeline
                            ],
                            [
                                CONST.LIGHT_PIPELINE,
                                LightPipeline
                            ],
                            [
                                CONST.POINTLIGHT_PIPELINE,
                                PointLightPipeline
                            ],
                            [
                                CONST.MOBILE_PIPELINE,
                                MobilePipeline
                            ]
                        ]);
                        /**
         * This map stores all Post FX Pipeline classes available in this manager.
         *
         * As of v3.60 this is now populated by default with the following
         * Post FX Pipelines:
         *
         * * Barrel
         * * Bloom
         * * Blur
         * * Bokeh / TiltShift
         * * Circle
         * * ColorMatrix
         * * Displacement
         * * Glow
         * * Gradient
         * * Pixelate
         * * Shadow
         * * Shine
         * * Vignette
         * * Wipe
         *
         * These are added as part of the boot process.
         *
         * If you do not wish to add them, specify `disableFX: true` in your game config.
         *
         * See the FX Controller class for more details about each FX.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#postPipelineClasses
         * @type {Phaser.Structs.Map.<string, Class>}
         * @since 3.50.0
         */ this.postPipelineClasses = new CustomMap();
                        /**
         * This map stores all pipeline instances in this manager.
         *
         * This is populated with the default pipelines in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#pipelines
         * @type {Phaser.Structs.Map.<string, Phaser.Renderer.WebGL.WebGLPipeline>}
         * @since 3.50.0
         */ this.pipelines = new CustomMap();
                        /**
         * An array of all post-pipelines that are created by this manager.
         * 
         * @name Phaser.Renderer.WebGL.PipelineManager#postPipelineInstances
         * @type {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[]}
         */ this.postPipelineInstances = [];
                        /**
         * The default Game Object pipeline.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#default
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @default null
         * @since 3.60.0
         */ this.default = null;
                        /**
         * Current pipeline in use by the WebGLRenderer.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#current
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @default null
         * @since 3.50.0
         */ this.current = null;
                        /**
         * The previous WebGLPipeline that was in use.
         *
         * This is set when `clearPipeline` is called and restored in `rebindPipeline` if none is given.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#previous
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @default null
         * @since 3.50.0
         */ this.previous = null;
                        /**
         * A constant-style reference to the Multi Pipeline Instance.
         *
         * This is the default Phaser 3 pipeline and is used by the WebGL Renderer to manage
         * camera effects and more. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#MULTI_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.MultiPipeline}
         * @default null
         * @since 3.50.0
         */ this.MULTI_PIPELINE = null;
                        /**
         * A constant-style reference to the Bitmap Mask Pipeline Instance.
         *
         * This is the default Phaser 3 mask pipeline and is used Game Objects using
         * a Bitmap Mask. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#BITMAPMASK_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline}
         * @default null
         * @since 3.50.0
         */ this.BITMAPMASK_PIPELINE = null;
                        /**
         * A constant-style reference to the Utility Pipeline Instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#UTILITY_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.UtilityPipeline}
         * @default null
         * @since 3.50.0
         */ this.UTILITY_PIPELINE = null;
                        /**
         * A constant-style reference to the Mobile Pipeline Instance.
         *
         * This is the default Phaser 3 mobile pipeline and is used by the WebGL Renderer to manage
         * camera effects and more on mobile devices. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#MOBILE_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.MobilePipeline}
         * @default null
         * @since 3.60.0
         */ this.MOBILE_PIPELINE = null;
                        /**
         * A constant-style reference to the FX Pipeline Instance.
         *
         * This is the default Phaser 3 FX pipeline and is used by the WebGL Renderer to manage
         * Game Objects with special effects enabled. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#FX_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.FXPipeline}
         * @default null
         * @since 3.60.0
         */ this.FX_PIPELINE = null;
                        /**
         * A reference to the Full Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame1;
                        /**
         * A reference to the Full Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame2;
                        /**
         * A reference to the Half Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame1;
                        /**
         * A reference to the Half Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame2;
                        /**
         * An array of RenderTarget instances that belong to this pipeline.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#renderTargets
         * @type {Phaser.Renderer.WebGL.RenderTarget[]}
         * @since 3.60.0
         */ this.renderTargets = [];
                        /**
         * The largest render target dimension before we just use a full-screen target.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#maxDimension
         * @type {number}
         * @since 3.60.0
         */ this.maxDimension = 0;
                        /**
         * The amount in which each target frame will increase.
         *
         * Defaults to 32px but can be overridden in the config.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#frameInc
         * @type {number}
         * @since 3.60.0
         */ this.frameInc = 32;
                        /**
         * The Render Target index. Used internally by the methods
         * in this class. Do not modify directly.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#targetIndex
         * @type {number}
         * @since 3.60.0
         */ this.targetIndex = 0;
                    },
                    /**
     * Internal boot handler, called by the WebGLRenderer durings its boot process.
     *
     * Adds all of the default pipelines, based on the game config, and then calls
     * the `boot` method on each one of them.
     *
     * Finally, the default pipeline is set.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#boot
     * @since 3.50.0
     *
     * @param {Phaser.Types.Core.PipelineConfig} pipelineConfig - The pipeline configuration object as set in the Game Config.
     * @param {string} defaultPipeline - The name of the default Game Object pipeline, as set in the Game Config
     * @param {boolean} autoMobilePipeline - Automatically set the default pipeline to mobile if non-desktop detected?
     */ boot: function(pipelineConfig, defaultPipeline, autoMobilePipeline) {
                        //  Create the default RenderTextures
                        var renderer = this.renderer;
                        var targets = this.renderTargets;
                        this.frameInc = Math.floor(GetFastValue(pipelineConfig, 'frameInc', 32));
                        var renderWidth = renderer.width;
                        var renderHeight = renderer.height;
                        var disablePreFX = this.game.config.disablePreFX;
                        var disablePostFX = this.game.config.disablePostFX;
                        if (!disablePostFX) this.postPipelineClasses.setAll([
                            [
                                String(FX_CONST.BARREL),
                                FX.Barrel
                            ],
                            [
                                String(FX_CONST.BLOOM),
                                FX.Bloom
                            ],
                            [
                                String(FX_CONST.BLUR),
                                FX.Blur
                            ],
                            [
                                String(FX_CONST.BOKEH),
                                FX.Bokeh
                            ],
                            [
                                String(FX_CONST.CIRCLE),
                                FX.Circle
                            ],
                            [
                                String(FX_CONST.COLOR_MATRIX),
                                FX.ColorMatrix
                            ],
                            [
                                String(FX_CONST.DISPLACEMENT),
                                FX.Displacement
                            ],
                            [
                                String(FX_CONST.GLOW),
                                FX.Glow
                            ],
                            [
                                String(FX_CONST.GRADIENT),
                                FX.Gradient
                            ],
                            [
                                String(FX_CONST.PIXELATE),
                                FX.Pixelate
                            ],
                            [
                                String(FX_CONST.SHADOW),
                                FX.Shadow
                            ],
                            [
                                String(FX_CONST.SHINE),
                                FX.Shine
                            ],
                            [
                                String(FX_CONST.VIGNETTE),
                                FX.Vignette
                            ],
                            [
                                String(FX_CONST.WIPE),
                                FX.Wipe
                            ]
                        ]);
                        if (!disablePreFX) {
                            this.classes.set(CONST.FX_PIPELINE, FXPipeline);
                            var minDimension = Math.min(renderWidth, renderHeight);
                            var qty = Math.ceil(minDimension / this.frameInc);
                            //  These RenderTargets are all shared by the PreFXPipelines
                            for(var i = 1; i < qty; i++){
                                var targetWidth = i * this.frameInc;
                                targets.push(new RenderTarget(renderer, targetWidth, targetWidth));
                                //  Duplicate RT for swap frame
                                targets.push(new RenderTarget(renderer, targetWidth, targetWidth));
                                //  Duplicate RT for alt swap frame
                                targets.push(new RenderTarget(renderer, targetWidth, targetWidth));
                                this.maxDimension = targetWidth;
                            }
                            //  Full-screen RTs
                            targets.push(new RenderTarget(renderer, renderWidth, renderHeight, 1, 0, true, true));
                            targets.push(new RenderTarget(renderer, renderWidth, renderHeight, 1, 0, true, true));
                            targets.push(new RenderTarget(renderer, renderWidth, renderHeight, 1, 0, true, true));
                        }
                        //  Install each of the default pipelines
                        var instance;
                        var pipelineName;
                        var _this = this;
                        var game = this.game;
                        this.classes.each(function(pipelineName, pipeline) {
                            instance = _this.add(pipelineName, new pipeline({
                                game: game
                            }));
                            if (pipelineName === CONST.UTILITY_PIPELINE) {
                                _this.UTILITY_PIPELINE = instance;
                                //  FBO references
                                _this.fullFrame1 = instance.fullFrame1;
                                _this.fullFrame2 = instance.fullFrame2;
                                _this.halfFrame1 = instance.halfFrame1;
                                _this.halfFrame2 = instance.halfFrame2;
                            }
                        });
                        //  Our const-like references
                        this.MULTI_PIPELINE = this.get(CONST.MULTI_PIPELINE);
                        this.BITMAPMASK_PIPELINE = this.get(CONST.BITMAPMASK_PIPELINE);
                        this.MOBILE_PIPELINE = this.get(CONST.MOBILE_PIPELINE);
                        if (!disablePreFX) this.FX_PIPELINE = this.get(CONST.FX_PIPELINE);
                        //  And now the ones in the config, if any
                        if (pipelineConfig) for(pipelineName in pipelineConfig){
                            var pipelineClass = pipelineConfig[pipelineName];
                            instance = new pipelineClass(game);
                            instance.name = pipelineName;
                            if (instance.isPostFX) this.postPipelineClasses.set(pipelineName, pipelineClass);
                            else if (!this.has(pipelineName)) {
                                this.classes.set(pipelineName, pipelineClass);
                                this.add(pipelineName, instance);
                            }
                        }
                        //  Finally, set the Default Game Object pipeline
                        this.default = this.get(defaultPipeline);
                        if (autoMobilePipeline && !Device.os.desktop) this.default = this.MOBILE_PIPELINE;
                    },
                    /**
     * Sets the default pipeline being used by Game Objects.
     *
     * If no instance, or matching name, exists in this manager, it returns `undefined`.
     *
     * You can use this to override the default pipeline, for example by forcing
     * the Mobile or Multi Tint Pipelines, which is especially useful for development
     * testing.
     *
     * Make sure you call this method _before_ creating any Game Objects, as it will
     * only impact Game Objects created after you call it.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setDefaultPipeline
     * @since 3.60.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance to look-up.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline instance that was set as default, or `undefined` if not found.
     */ setDefaultPipeline: function(pipeline) {
                        var instance = this.get(pipeline);
                        if (instance) this.default = instance;
                        return instance;
                    },
                    /**
     * Adds a pipeline instance to this Pipeline Manager.
     *
     * The name of the instance must be unique within this manager.
     *
     * Make sure to pass an instance to this method, not a base class.
     *
     * For example, you should pass it like this:
     *
     * ```javascript
     * this.add('yourName', new CustomPipeline(game));`
     * ```
     *
     * and **not** like this:
     *
     * ```javascript
     * this.add('yourName', CustomPipeline);`
     * ```
     *
     * To add a **Post Pipeline**, see `addPostPipeline` instead.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#add
     * @since 3.50.0
     *
     * @param {string} name - A unique string-based key for the pipeline within the manager.
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - A pipeline _instance_ which must extend `WebGLPipeline`.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline instance that was passed.
     */ add: function(name, pipeline) {
                        if (pipeline.isPostFX) {
                            console.warn(name + ' is a Post Pipeline. Use `addPostPipeline` instead');
                            return;
                        }
                        var pipelines = this.pipelines;
                        var renderer = this.renderer;
                        if (!pipelines.has(name)) {
                            pipeline.name = name;
                            pipeline.manager = this;
                            pipelines.set(name, pipeline);
                        } else console.warn('Pipeline exists: ' + name);
                        if (!pipeline.hasBooted) pipeline.boot();
                        if (renderer.width !== 0 && renderer.height !== 0 && !pipeline.isPreFX) pipeline.resize(renderer.width, renderer.height);
                        return pipeline;
                    },
                    /**
     * Adds a Post Pipeline to this Pipeline Manager.
     *
     * Make sure to pass a base class to this method, not an instance.
     *
     * For example, you should pass it like this:
     *
     * ```javascript
     * this.addPostPipeline('yourName', CustomPipeline);`
     * ```
     *
     * and **not** like this:
     *
     * ```javascript
     * this.addPostPipeline('yourName', new CustomPipeline());`
     * ```
     *
     * To add a regular pipeline, see the `add` method instead.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#addPostPipeline
     * @since 3.50.0
     *
     * @param {string} name - A unique string-based key for the pipeline within the manager.
     * @param {function} pipeline - A pipeline class which must extend `PostFXPipeline`.
     *
     * @return {this} This Pipeline Manager.
     */ addPostPipeline: function(name, pipeline) {
                        if (!this.postPipelineClasses.has(name)) this.postPipelineClasses.set(name, pipeline);
                    },
                    /**
     * Flushes the current pipeline, if one is bound.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#flush
     * @since 3.50.0
     */ flush: function() {
                        if (this.current) this.current.flush();
                    },
                    /**
     * Checks if a pipeline is present in this Pipeline Manager.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#has
     * @since 3.50.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance to look-up.
     *
     * @return {boolean} `true` if the given pipeline is loaded, otherwise `false`.
     */ has: function(pipeline) {
                        var pipelines = this.pipelines;
                        if (typeof pipeline === 'string') return pipelines.has(pipeline);
                        else if (pipelines.contains(pipeline)) return true;
                        return false;
                    },
                    /**
     * Returns the pipeline instance based on the given name, or instance.
     *
     * If no instance, or matching name, exists in this manager, it returns `undefined`.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#get
     * @since 3.50.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance to look-up.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline instance, or `undefined` if not found.
     */ get: function(pipeline) {
                        var pipelines = this.pipelines;
                        if (typeof pipeline === 'string') return pipelines.get(pipeline);
                        else if (pipelines.contains(pipeline)) return pipeline;
                    },
                    /**
     * Returns a _new instance_ of the post pipeline based on the given name, or class.
     *
     * If no instance, or matching name, exists in this manager, it returns `undefined`.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#getPostPipeline
     * @since 3.50.0
     *
     * @param {(string|function|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance, or class to look-up.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - If this post pipeline is being installed into a Game Object or Camera, this is a reference to it.
     * @param {object} [config] - Optional pipeline data object that is set in to the `postPipelineData` property of this Game Object.
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} The pipeline instance, or `undefined` if not found.
     */ getPostPipeline: function(pipeline, gameObject, config) {
                        var pipelineClasses = this.postPipelineClasses;
                        var instance;
                        var pipelineName = '';
                        var pipetype = typeof pipeline;
                        if (pipetype === 'string' || pipetype === 'number') {
                            instance = pipelineClasses.get(pipeline);
                            pipelineName = pipeline;
                        } else if (pipetype === 'function') {
                            //  A class
                            if (pipelineClasses.contains(pipeline)) instance = pipeline;
                            pipelineName = pipeline.name;
                        } else if (pipetype === 'object') {
                            //  Instance
                            instance = pipelineClasses.get(pipeline.name);
                            pipelineName = pipeline.name;
                        }
                        if (instance) {
                            var newPipeline = new instance(this.game, config);
                            newPipeline.name = pipelineName;
                            if (gameObject) newPipeline.gameObject = gameObject;
                            this.postPipelineInstances.push(newPipeline);
                            return newPipeline;
                        }
                    },
                    /**
     * Removes a PostFXPipeline instance from this Pipeline Manager.
     *
     * Note that the pipeline will not be flushed or destroyed, it's simply removed from
     * this manager.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#removePostPipeline
     * @since 3.80.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} pipeline - The pipeline instance to be removed.
     */ removePostPipeline: function(pipeline) {
                        ArrayRemove(this.postPipelineInstances, pipeline);
                    },
                    /**
     * Removes a pipeline instance based on the given name.
     *
     * If no pipeline matches the name, this method does nothing.
     *
     * Note that the pipeline will not be flushed or destroyed, it's simply removed from
     * this manager.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#remove
     * @since 3.50.0
     *
     * @param {string} name - The name of the pipeline to be removed.
     * @param {boolean} [removeClass=true] - Remove the pipeline class as well as the instance?
     * @param {boolean} [removePostPipelineClass=true] - Remove the post pipeline class as well as the instance?
     */ remove: function(name, removeClass, removePostPipelineClass) {
                        if (removeClass === undefined) removeClass = true;
                        if (removePostPipelineClass === undefined) removePostPipelineClass = true;
                        this.pipelines.delete(name);
                        if (removeClass) this.classes.delete(name);
                        if (removePostPipelineClass) this.postPipelineClasses.delete(name);
                    },
                    /**
     * Sets the current pipeline to be used by the `WebGLRenderer`.
     *
     * This method accepts a pipeline instance as its parameter, not the name.
     *
     * If the pipeline isn't already the current one it will call `WebGLPipeline.bind` and then `onBind`.
     *
     * You cannot set Post FX Pipelines using this method. To use a Post FX Pipeline, you should
     * apply it to either a Camera, Container or other supporting Game Object.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#set
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline instance to be set as current.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline that was set, or undefined if it couldn't be set.
     */ set: function(pipeline, gameObject, currentShader) {
                        if (pipeline.isPostFX) return;
                        if (!this.isCurrent(pipeline, currentShader)) {
                            this.flush();
                            if (this.current) this.current.unbind();
                            this.current = pipeline;
                            pipeline.bind(currentShader);
                        }
                        pipeline.updateProjectionMatrix();
                        pipeline.onBind(gameObject);
                        return pipeline;
                    },
                    /**
     * This method is called by the `WebGLPipeline.batchQuad` method, right before a quad
     * belonging to a Game Object is about to be added to the batch.
     *
     * It is also called directly bu custom Game Objects, such as Nine Slice or Mesh,
     * from their render methods.
     *
     * It causes a batch flush, then calls the `preBatch` method on the Post FX Pipelines
     * belonging to the Game Object.
     *
     * It should be followed by a call to `postBatch` to complete the process.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#preBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object about to be batched.
     */ preBatch: function(gameObject) {
                        if (gameObject.hasPostPipeline) {
                            this.flush();
                            var pipelines = gameObject.postPipelines;
                            //  Iterate in reverse because we need them stacked in the order they're in the array
                            for(var i = pipelines.length - 1; i >= 0; i--){
                                var pipeline = pipelines[i];
                                if (pipeline.active) pipeline.preBatch(gameObject);
                            }
                        }
                    },
                    /**
     * This method is called by the `WebGLPipeline.batchQuad` method, right after a quad
     * belonging to a Game Object has been added to the batch.
     *
     * It is also called directly bu custom Game Objects, such as Nine Slice or Mesh,
     * from their render methods.
     *
     * It causes a batch flush, then calls the `postBatch` method on the Post FX Pipelines
     * belonging to the Game Object.
     *
     * It should be preceeded by a call to `preBatch` to start the process.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#postBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just added to the batch.
     */ postBatch: function(gameObject) {
                        if (gameObject.hasPostPipeline) {
                            this.flush();
                            var pipelines = gameObject.postPipelines;
                            for(var i = 0; i < pipelines.length; i++){
                                var pipeline = pipelines[i];
                                if (pipeline.active) pipeline.postBatch(gameObject);
                            }
                        }
                    },
                    /**
     * Called at the start of the `WebGLRenderer.preRenderCamera` method.
     *
     * If the Camera has post pipelines set, it will flush the batch and then call the
     * `preBatch` method on the post-fx pipelines belonging to the Camera.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#preBatchCamera
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera about to be rendered.
     */ preBatchCamera: function(camera) {
                        if (camera.hasPostPipeline) {
                            this.flush();
                            var pipelines = camera.postPipelines;
                            //  Iterate in reverse because we need them stacked in the order they're in the array
                            for(var i = pipelines.length - 1; i >= 0; i--){
                                var pipeline = pipelines[i];
                                if (pipeline.active) pipeline.preBatch(camera);
                            }
                        }
                    },
                    /**
     * Called at the end of the `WebGLRenderer.postRenderCamera` method.
     *
     * If the Camera has post pipelines set, it will flush the batch and then call the
     * `postBatch` method on the post-fx pipelines belonging to the Camera.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#postBatchCamera
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that was just rendered.
     */ postBatchCamera: function(camera) {
                        if (camera.hasPostPipeline) {
                            this.flush();
                            var pipelines = camera.postPipelines;
                            for(var i = 0; i < pipelines.length; i++){
                                var pipeline = pipelines[i];
                                if (pipeline.active) pipeline.postBatch(camera);
                            }
                        }
                    },
                    /**
     * Checks to see if the given pipeline is already the active pipeline, both within this
     * Pipeline Manager and also has the same shader set in the Renderer.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#isCurrent
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline instance to be checked.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {boolean} `true` if the given pipeline is already the current pipeline, otherwise `false`.
     */ isCurrent: function(pipeline, currentShader) {
                        var renderer = this.renderer;
                        var current = this.current;
                        if (current && !currentShader) currentShader = current.currentShader;
                        return !(current !== pipeline || currentShader.program !== renderer.currentProgram);
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * The copy itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                        this.setUtility(this.UTILITY_PIPELINE.copyShader).copyFrame(source, target, brightness, clear, clearAlpha);
                        return this;
                    },
                    /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                        this.setUtility(this.UTILITY_PIPELINE.copyShader).copyToGame(source);
                        return this;
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * The copy itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Display.ColorMatrix} [colorMatrix] - The Color Matrix to use when performing the draw.
     *
     * @return {this} This Pipeline Manager instance.
     */ drawFrame: function(source, target, clearAlpha, colorMatrix) {
                        this.setUtility(this.UTILITY_PIPELINE.colorMatrixShader).drawFrame(source, target, clearAlpha, colorMatrix);
                        return this;
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * The draw itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ blendFrames: function(source1, source2, target, strength, clearAlpha) {
                        this.setUtility(this.UTILITY_PIPELINE.linearShader).blendFrames(source1, source2, target, strength, clearAlpha);
                        return this;
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * The draw itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                        this.setUtility(this.UTILITY_PIPELINE.addShader).blendFramesAdditive(source1, source2, target, strength, clearAlpha);
                        return this;
                    },
                    /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ clearFrame: function(target, clearAlpha) {
                        this.UTILITY_PIPELINE.clearFrame(target, clearAlpha);
                        return this;
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     *
     * @return {this} This Pipeline Manager instance.
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                        this.setUtility(this.UTILITY_PIPELINE.copyShader).blitFrame(source, target, brightness, clear, clearAlpha, eraseMode);
                        return this;
                    },
                    /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                        this.UTILITY_PIPELINE.copyFrameRect(source, target, x, y, width, height, clear, clearAlpha);
                        return this;
                    },
                    /**
     * Returns `true` if the current pipeline is forced to use texture unit zero.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#forceZero
     * @since 3.50.0
     *
     * @return {boolean} `true` if the current pipeline is forced to use texture unit zero.
     */ forceZero: function() {
                        return this.current && this.current.forceZero;
                    },
                    /**
     * Sets the Multi Pipeline to be the currently bound pipeline.
     *
     * This is the default Phaser 3 rendering pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setMulti
     * @since 3.50.0
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} The Multi Pipeline instance.
     */ setMulti: function() {
                        return this.set(this.MULTI_PIPELINE);
                    },
                    /**
     * Sets the Utility Pipeline to be the currently bound pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setUtility
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.UtilityPipeline} The Utility Pipeline instance.
     */ setUtility: function(currentShader) {
                        return this.UTILITY_PIPELINE.bind(currentShader);
                    },
                    /**
     * Sets the FX Pipeline to be the currently bound pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setFX
     * @since 3.60.0
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.FXPipeline} The FX Pipeline instance.
     */ setFX: function() {
                        return this.set(this.FX_PIPELINE);
                    },
                    /**
     * Restore WebGL resources after context was lost.
     * 
     * Calls `rebind` on this Pipeline Manager.
     * Then calls `restoreContext` on each pipeline in turn.
     * 
     * @method Phaser.Renderer.WebGL.PipelineManager#restoreContext
     * @since 3.80.0
     */ restoreContext: function() {
                        this.rebind();
                        this.pipelines.each(function(_, pipeline) {
                            pipeline.restoreContext();
                        });
                        ArrayEach(this.postPipelineInstances, function(pipeline) {
                            pipeline.restoreContext();
                        });
                    },
                    /**
     * Use this to reset the gl context to the state that Phaser requires to continue rendering.
     *
     * Calling this will:
     *
     * * Disable `DEPTH_TEST`, `CULL_FACE` and `STENCIL_TEST`.
     * * Clear the depth buffer and stencil buffers.
     * * Reset the viewport size.
     * * Reset the blend mode.
     * * Bind a blank texture as the active texture on texture unit zero.
     * * Rebinds the given pipeline instance.
     *
     * You should call this if you have previously called `clear`, and then wish to return
     * rendering control to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#rebind
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} [pipeline] - The pipeline instance to be rebound. If not given, the previous pipeline will be bound.
     */ rebind: function(pipeline) {
                        if (pipeline === undefined && this.previous) pipeline = this.previous;
                        var renderer = this.renderer;
                        var gl = renderer.gl;
                        gl.disable(gl.DEPTH_TEST);
                        gl.disable(gl.CULL_FACE);
                        if (renderer.hasActiveStencilMask()) gl.clear(gl.DEPTH_BUFFER_BIT);
                        else {
                            //  If there wasn't a stencil mask set before this call, we can disable it safely
                            gl.disable(gl.STENCIL_TEST);
                            gl.clear(gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
                        }
                        gl.viewport(0, 0, renderer.width, renderer.height);
                        renderer.currentProgram = null;
                        renderer.setBlendMode(0, true);
                        var vao = renderer.vaoExtension;
                        if (vao) vao.bindVertexArrayOES(null);
                        var entries = this.pipelines.entries;
                        for(var key in entries)entries[key].glReset = true;
                        if (pipeline) {
                            this.current = pipeline;
                            pipeline.rebind();
                        }
                    },
                    /**
     * Flushes the current pipeline being used and then clears it, along with the
     * the current shader program and vertex buffer from the `WebGLRenderer`.
     *
     * Then resets the blend mode to NORMAL.
     *
     * Call this before jumping to your own gl context handler, and then call `rebind` when
     * you wish to return control to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#clear
     * @since 3.50.0
     */ clear: function() {
                        var renderer = this.renderer;
                        this.flush();
                        if (this.current) {
                            this.current.unbind();
                            this.previous = this.current;
                            this.current = null;
                        } else this.previous = null;
                        renderer.currentProgram = null;
                        renderer.setBlendMode(0, true);
                        var vao = renderer.vaoExtension;
                        if (vao) vao.bindVertexArrayOES(null);
                    },
                    /**
     * Gets a Render Target the right size to render the Sprite on.
     *
     * If the Sprite exceeds the size of the renderer, the Render Target will only ever be the maximum
     * size of the renderer.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#getRenderTarget
     * @since 3.60.0
     *
     * @param {number} size - The maximum dimension required.
     *
     * @return {Phaser.Renderer.WebGL.RenderTarget} A Render Target large enough to fit the sprite.
     */ getRenderTarget: function(size) {
                        var targets = this.renderTargets;
                        //  2 for just swap
                        //  3 for swap + alt swap
                        var offset = 3;
                        if (size > this.maxDimension) {
                            this.targetIndex = targets.length - offset;
                            return targets[this.targetIndex];
                        } else {
                            var index = (SnapCeil(size, this.frameInc, 0, true) - 1) * offset;
                            this.targetIndex = index;
                            return targets[index];
                        }
                    },
                    /**
     * Gets a matching Render Target, the same size as the one the Sprite was drawn to,
     * useful for double-buffer style effects such as blurs.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#getSwapRenderTarget
     * @since 3.60.0
     *
     * @return {Phaser.Renderer.WebGL.RenderTarget} The Render Target swap frame.
     */ getSwapRenderTarget: function() {
                        return this.renderTargets[this.targetIndex + 1];
                    },
                    /**
     * Gets a matching Render Target, the same size as the one the Sprite was drawn to,
     * useful for double-buffer style effects such as blurs.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#getAltSwapRenderTarget
     * @since 3.60.0
     *
     * @return {Phaser.Renderer.WebGL.RenderTarget} The Render Target swap frame.
     */ getAltSwapRenderTarget: function() {
                        return this.renderTargets[this.targetIndex + 2];
                    },
                    /**
     * Destroy the Pipeline Manager, cleaning up all related resources and references.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#destroy
     * @since 3.50.0
     */ destroy: function() {
                        this.flush();
                        this.classes.clear();
                        this.postPipelineClasses.clear();
                        this.pipelines.clear();
                        this.renderer = null;
                        this.game = null;
                        this.classes = null;
                        this.postPipelineClasses = null;
                        this.pipelines = null;
                        this.default = null;
                        this.current = null;
                        this.previous = null;
                    }
                });
                module1.exports = PipelineManager;
            /***/ },
            /***/ 32302: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Events = __webpack_require__(92503);
                /**
 * @classdesc
 * A Render Target encapsulates a WebGL framebuffer and the WebGL Texture that displays it.
 *
 * Instances of this class are typically created by, and belong to WebGL Pipelines, however
 * other Game Objects and classes can take advantage of Render Targets as well.
 *
 * @class RenderTarget
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the WebGLRenderer.
 * @param {number} width - The width of this Render Target.
 * @param {number} height - The height of this Render Target.
 * @param {number} [scale=1] - A value between 0 and 1. Controls the size of this Render Target in relation to the Renderer.
 * @param {number} [minFilter=0] - The minFilter mode of the texture when created. 0 is `LINEAR`, 1 is `NEAREST`.
 * @param {boolean} [autoClear=true] - Automatically clear this framebuffer when bound?
 * @param {boolean} [autoResize=false] - Automatically resize this Render Target if the WebGL Renderer resizes?
 * @param {boolean} [addDepthBuffer=true] - Add a DEPTH_STENCIL and attachment to this Render Target?
 * @param {boolean} [forceClamp=true] - Force the texture to use the CLAMP_TO_EDGE wrap mode, even if a power of two?
 */ var RenderTarget = new Class({
                    initialize: function RenderTarget(renderer, width, height, scale, minFilter, autoClear, autoResize, addDepthBuffer, forceClamp) {
                        if (scale === undefined) scale = 1;
                        if (minFilter === undefined) minFilter = 0;
                        if (autoClear === undefined) autoClear = true;
                        if (autoResize === undefined) autoResize = false;
                        if (addDepthBuffer === undefined) addDepthBuffer = true;
                        if (forceClamp === undefined) forceClamp = true;
                        /**
         * A reference to the WebGLRenderer instance.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = renderer;
                        /**
         * The Framebuffer of this Render Target.
         *
         * This is created in the `RenderTarget.resize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#framebuffer
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper}
         * @since 3.50.0
         */ this.framebuffer = null;
                        /**
         * The WebGLTextureWrapper of this Render Target.
         *
         * This is created in the `RenderTarget.resize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#texture
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @since 3.50.0
         */ this.texture = null;
                        /**
         * The width of the texture.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#width
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.width = 0;
                        /**
         * The height of the texture.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#height
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.height = 0;
                        /**
         * A value between 0 and 1. Controls the size of this Render Target in relation to the Renderer.
         *
         * A value of 1 matches it. 0.5 makes the Render Target half the size of the renderer, etc.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#scale
         * @type {number}
         * @since 3.50.0
         */ this.scale = scale;
                        /**
         * The minFilter mode of the texture. 0 is `LINEAR`, 1 is `NEAREST`.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#minFilter
         * @type {number}
         * @since 3.50.0
         */ this.minFilter = minFilter;
                        /**
         * Controls if this Render Target is automatically cleared (via `gl.COLOR_BUFFER_BIT`)
         * during the `RenderTarget.bind` method.
         *
         * If you need more control over how, or if, the target is cleared, you can disable
         * this via the config on creation, or even toggle it directly at runtime.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#autoClear
         * @type {boolean}
         * @since 3.50.0
         */ this.autoClear = autoClear;
                        /**
         * Does this Render Target automatically resize when the WebGL Renderer does?
         *
         * Modify this property via the `setAutoResize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#autoResize
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.autoResize = true;
                        /**
         * Does this Render Target have a Depth Buffer?
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#hasDepthBuffer
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.hasDepthBuffer = addDepthBuffer;
                        /**
         * Force the WebGL Texture to use the CLAMP_TO_EDGE wrap mode, even if a power of two?
         *
         * If `false` it will use `gl.REPEAT` instead, which may be required for some effects, such
         * as using this Render Target as a texture for a Shader.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#forceClamp
         * @type {boolean}
         * @since 3.60.0
         */ this.forceClamp = forceClamp;
                        this.init(width, height);
                        if (autoResize) this.renderer.on(Events.RESIZE, this.resize, this);
                        else //  Block resizing unless this RT allows it
                        this.autoResize = false;
                    },
                    /**
     * Sets up this Render Target to the given width and height, creating a new
     * frame buffer and texture. This method is called automatically by the constructor
     * and at no other time.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#init
     * @since 3.86.0
     *
     * @param {number} width - The new width of this Render Target.
     * @param {number} height - The new height of this Render Target.
     */ init: function(width, height) {
                        var renderer = this.renderer;
                        this.texture = renderer.createTextureFromSource(null, width, height, this.minFilter, this.forceClamp);
                        this.framebuffer = renderer.createFramebuffer(width, height, this.texture, this.hasDepthBuffer);
                        this.width = width;
                        this.height = height;
                    },
                    /**
     * Sets if this Render Target should automatically resize when the WebGL Renderer
     * emits a resize event.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#setAutoResize
     * @since 3.50.0
     *
     * @param {boolean} autoResize - Automatically resize this Render Target when the WebGL Renderer resizes?
     *
     * @return {this} This RenderTarget instance.
     */ setAutoResize: function(autoResize) {
                        if (autoResize && !this.autoResize) {
                            this.renderer.on(Events.RESIZE, this.resize, this);
                            this.autoResize = true;
                        } else if (!autoResize && this.autoResize) {
                            this.renderer.off(Events.RESIZE, this.resize, this);
                            this.autoResize = false;
                        }
                        return this;
                    },
                    /**
     * Resizes this Render Target as long as the given width and height are different
     * to the current width and height.
     *
     * Deletes both the frame buffer and texture, if they exist and then re-creates
     * them using the new sizes.
     *
     * This method is called automatically by the pipeline during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#resize
     * @since 3.50.0
     *
     * @param {number} width - The new width of this Render Target.
     * @param {number} height - The new height of this Render Target.
     *
     * @return {this} This RenderTarget instance.
     */ resize: function(width, height) {
                        if (this.autoResize && this.willResize(width, height)) {
                            var renderer = this.renderer;
                            renderer.deleteFramebuffer(this.framebuffer);
                            renderer.deleteTexture(this.texture);
                            this.texture = renderer.createTextureFromSource(null, width, height, this.minFilter, this.forceClamp);
                            this.framebuffer = renderer.createFramebuffer(width, height, this.texture, this.hasDepthBuffer);
                            this.width = width;
                            this.height = height;
                        }
                        return this;
                    },
                    /**
     * Checks if this Render Target will resize, or not, if given the new
     * width and height values.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#willResize
     * @since 3.70.0
     *
     * @param {number} width - The new width of this Render Target.
     * @param {number} height - The new height of this Render Target.
     *
     * @return {boolean} `true` if the Render Target will resize, otherwise `false`.
     */ willResize: function(width, height) {
                        if (typeof width !== 'number' || typeof height !== 'number') return false;
                        width = Math.round(width * this.scale);
                        height = Math.round(height * this.scale);
                        width = Math.max(width, 1);
                        height = Math.max(height, 1);
                        return width !== this.width || height !== this.height;
                    },
                    /**
     * Pushes this Render Target as the current frame buffer of the renderer.
     *
     * If `autoClear` is set, then clears the texture.
     *
     * If `adjustViewport` is `true` then it will flush the renderer and then adjust the GL viewport.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#bind
     * @since 3.50.0
     *
     * @param {boolean} [adjustViewport=false] - Adjust the GL viewport by calling `RenderTarget.adjustViewport` ?
     * @param {number} [width] - Optional new width of this Render Target.
     * @param {number} [height] - Optional new height of this Render Target.
     */ bind: function(adjustViewport, width, height) {
                        if (adjustViewport === undefined) adjustViewport = false;
                        var renderer = this.renderer;
                        if (adjustViewport) renderer.flush();
                        if (width && height) this.resize(width, height);
                        renderer.pushFramebuffer(this.framebuffer, false, false);
                        if (adjustViewport) this.adjustViewport();
                        if (this.autoClear) {
                            var gl = this.renderer.gl;
                            gl.clearColor(0, 0, 0, 0);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                        renderer.clearStencilMask();
                    },
                    /**
     * Adjusts the GL viewport to match the width and height of this Render Target.
     *
     * Also disables `SCISSOR_TEST`.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#adjustViewport
     * @since 3.50.0
     */ adjustViewport: function() {
                        var gl = this.renderer.gl;
                        gl.viewport(0, 0, this.width, this.height);
                        gl.disable(gl.SCISSOR_TEST);
                    },
                    /**
     * Clears a portion or everything from this Render Target. To clear an area,
     * specify the `x`, `y`, `width` and `height`.
     * 
     * @param {number} [x=0] - The left coordinate of the fill rectangle.
     * @param {number} [y=0] - The top coordinate of the fill rectangle.
     * @param {number} [width=this.width] - The width of the fill rectangle.
     * @param {number} [height=this.height] - The height of the fill rectangle.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#clear
     * @since 3.50.0
     */ clear: function(x, y, width, height) {
                        var renderer = this.renderer;
                        var gl = renderer.gl;
                        renderer.pushFramebuffer(this.framebuffer);
                        if (x !== undefined && y !== undefined && width !== undefined && height !== undefined) {
                            gl.enable(gl.SCISSOR_TEST);
                            gl.scissor(x, y, width, height);
                        } else gl.disable(gl.SCISSOR_TEST);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        renderer.popFramebuffer();
                        renderer.resetScissor();
                    },
                    /**
     * Unbinds this Render Target and optionally flushes the WebGL Renderer first.
     *
     * @name Phaser.Renderer.WebGL.RenderTarget#unbind
     * @since 3.50.0
     *
     * @param {boolean} [flush=false] - Flush the WebGL Renderer before unbinding?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper} The Framebuffer that was set, or `null` if there aren't any more in the stack.
     */ unbind: function(flush) {
                        if (flush === undefined) flush = false;
                        var renderer = this.renderer;
                        if (flush) renderer.flush();
                        return renderer.popFramebuffer();
                    },
                    /**
     * Removes all external references from this class and deletes the
     * WebGL framebuffer and texture instances.
     *
     * Does not remove this Render Target from the parent pipeline.
     *
     * @name Phaser.Renderer.WebGL.RenderTarget#destroy
     * @since 3.50.0
     */ destroy: function() {
                        var renderer = this.renderer;
                        renderer.off(Events.RESIZE, this.resize, this);
                        renderer.deleteFramebuffer(this.framebuffer);
                        renderer.deleteTexture(this.texture);
                        this.renderer = null;
                        this.framebuffer = null;
                        this.texture = null;
                    }
                });
                module1.exports = RenderTarget;
            /***/ },
            /***/ 70554: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @author       Matthew Groves <@doormat>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.WebGL.Utils
 * @since 3.0.0
 */ module1.exports = {
                    /**
     * Packs four floats on a range from 0.0 to 1.0 into a single Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintFromFloats
     * @since 3.0.0
     *
     * @param {number} r - Red component in a range from 0.0 to 1.0
     * @param {number} g - Green component in a range from 0.0 to 1.0
     * @param {number} b - Blue component in a range from 0.0 to 1.0
     * @param {number} a - Alpha component in a range from 0.0 to 1.0
     *
     * @return {number} The packed RGBA values as a Uint32.
     */ getTintFromFloats: function(r, g, b, a) {
                        var ur = (r * 255 | 0) & 0xff;
                        var ug = (g * 255 | 0) & 0xff;
                        var ub = (b * 255 | 0) & 0xff;
                        var ua = (a * 255 | 0) & 0xff;
                        return (ua << 24 | ur << 16 | ug << 8 | ub) >>> 0;
                    },
                    /**
     * Packs a Uint24, representing RGB components, with a Float32, representing
     * the alpha component, with a range between 0.0 and 1.0 and return a Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlpha
     * @since 3.0.0
     *
     * @param {number} rgb - Uint24 representing RGB components
     * @param {number} a - Float32 representing Alpha component
     *
     * @return {number} Packed RGBA as Uint32
     */ getTintAppendFloatAlpha: function(rgb, a) {
                        var ua = (a * 255 | 0) & 0xff;
                        return (ua << 24 | rgb) >>> 0;
                    },
                    /**
     * Packs a Uint24, representing RGB components, with a Float32, representing
     * the alpha component, with a range between 0.0 and 1.0 and return a
     * swizzled Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlphaAndSwap
     * @since 3.0.0
     *
     * @param {number} rgb - Uint24 representing RGB components
     * @param {number} a - Float32 representing Alpha component
     *
     * @return {number} Packed RGBA as Uint32
     */ getTintAppendFloatAlphaAndSwap: function(rgb, a) {
                        var ur = (rgb >> 16 | 0) & 0xff;
                        var ug = (rgb >> 8 | 0) & 0xff;
                        var ub = (rgb | 0) & 0xff;
                        var ua = (a * 255 | 0) & 0xff;
                        return (ua << 24 | ub << 16 | ug << 8 | ur) >>> 0;
                    },
                    /**
     * Unpacks a Uint24 RGB into an array of floats of ranges of 0.0 and 1.0
     *
     * @function Phaser.Renderer.WebGL.Utils.getFloatsFromUintRGB
     * @since 3.0.0
     *
     * @param {number} rgb - RGB packed as a Uint24
     *
     * @return {array} Array of floats representing each component as a float
     */ getFloatsFromUintRGB: function(rgb) {
                        var ur = (rgb >> 16 | 0) & 0xff;
                        var ug = (rgb >> 8 | 0) & 0xff;
                        var ub = (rgb | 0) & 0xff;
                        return [
                            ur / 255,
                            ug / 255,
                            ub / 255
                        ];
                    },
                    /**
     * Check to see how many texture units the GPU supports in a fragment shader
     * and if the value specific in the game config is allowed.
     *
     * This value is hard-clamped to 16 for performance reasons on Android devices.
     *
     * @function Phaser.Renderer.WebGL.Utils.checkShaderMax
     * @since 3.50.0
     *
     * @param {WebGLRenderingContext} gl - The WebGLContext used to create the shaders.
     * @param {number} maxTextures - The Game Config maxTextures value.
     *
     * @return {number} The number of texture units that is supported by this browser and GPU.
     */ checkShaderMax: function(gl, maxTextures) {
                        //  Note: This is the maximum number of TIUs that a _fragment_ shader supports
                        //  https://www.khronos.org/opengl/wiki/Common_Mistakes#Texture_Unit
                        //  Hard-clamp this to 16 to avoid run-away texture counts such as on Android
                        var gpuMax = Math.min(16, gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
                        if (!maxTextures || maxTextures === -1) return gpuMax;
                        else return Math.min(gpuMax, maxTextures);
                    },
                    /**
     * Checks the given Fragment Shader Source for `%count%` and `%forloop%` declarations and
     * replaces those with GLSL code for setting `texture = texture2D(uMainSampler[i], outTexCoord)`.
     *
     * @function Phaser.Renderer.WebGL.Utils.parseFragmentShaderMaxTextures
     * @since 3.50.0
     *
     * @param {string} fragmentShaderSource - The Fragment Shader source code to operate on.
     * @param {number} maxTextures - The number of maxTextures value.
     *
     * @return {string} The modified Fragment Shader source.
     */ parseFragmentShaderMaxTextures: function(fragmentShaderSource, maxTextures) {
                        if (!fragmentShaderSource) return '';
                        var src = '';
                        for(var i = 0; i < maxTextures; i++){
                            if (i > 0) src += '\n\telse ';
                            if (i < maxTextures - 1) src += 'if (outTexId < ' + i + '.5)';
                            src += '\n\t{';
                            src += '\n\t\ttexture = texture2D(uMainSampler[' + i + '], outTexCoord);';
                            src += '\n\t}';
                        }
                        fragmentShaderSource = fragmentShaderSource.replace(/%count%/gi, maxTextures.toString());
                        return fragmentShaderSource.replace(/%forloop%/gi, src);
                    },
                    /**
     * Takes the Glow FX Shader source and parses out the __SIZE__ and __DIST__
     * consts with the configuration values.
     *
     * @function Phaser.Renderer.WebGL.Utils.setGlowQuality
     * @since 3.60.0
     *
     * @param {string} shader - The Fragment Shader source code to operate on.
     * @param {Phaser.Game} game - The Phaser Game instance.
     * @param {number} [quality] - The quality of the glow (defaults to 0.1)
     * @param {number} [distance] - The distance of the glow (defaults to 10)
     *
     * @return {string} The modified Fragment Shader source.
     */ setGlowQuality: function(shader, game, quality, distance) {
                        if (quality === undefined) quality = game.config.glowFXQuality;
                        if (distance === undefined) distance = game.config.glowFXDistance;
                        shader = shader.replace(/__SIZE__/gi, (1 / quality / distance).toFixed(7));
                        shader = shader.replace(/__DIST__/gi, distance.toFixed(0) + '.0');
                        return shader;
                    }
                };
            /***/ },
            /***/ 29100: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var DeepCopy = __webpack_require__(62644);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(77085);
                var GetFastValue = __webpack_require__(95540);
                var Matrix4 = __webpack_require__(37867);
                var RendererEvents = __webpack_require__(92503);
                var RenderTarget = __webpack_require__(32302);
                var Utils = __webpack_require__(70554);
                var WebGLShader = __webpack_require__(38683);
                /**
 * @classdesc
 * The `WebGLPipeline` is a base class used by all of the core Phaser pipelines.
 *
 * It describes the way elements will be rendered in WebGL. Internally, it handles
 * compiling the shaders, creating vertex buffers, assigning primitive topology and
 * binding vertex attributes, all based on the given configuration data.
 *
 * The pipeline is configured by passing in a `WebGLPipelineConfig` object. Please
 * see the documentation for this type to fully understand the configuration options
 * available to you.
 *
 * Usually, you would not extend from this class directly, but would instead extend
 * from one of the core pipelines, such as the Multi Pipeline.
 *
 * The pipeline flow per render-step is as follows:
 *
 * 1) onPreRender - called once at the start of the render step
 * 2) onRender - call for each Scene Camera that needs to render (so can be multiple times per render step)
 * 3) Internal flow:
 * 3a)   bind (only called if a Game Object is using this pipeline and it's not currently active)
 * 3b)   onBind (called for every Game Object that uses this pipeline)
 * 3c)   flush (can be called by a Game Object, internal method or from outside by changing pipeline)
 * 4) onPostRender - called once at the end of the render step
 *
 * @class WebGLPipeline
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration object for this WebGL Pipeline.
 */ var WebGLPipeline = new Class({
                    Extends: EventEmitter,
                    initialize: function WebGLPipeline(config) {
                        EventEmitter.call(this);
                        var game = config.game;
                        var renderer = game.renderer;
                        var gl = renderer.gl;
                        /**
         * Name of the pipeline. Used for identification and setting from Game Objects.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'WebGLPipeline');
                        /**
         * The Phaser Game instance to which this pipeline is bound.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                        /**
         * The WebGL Renderer instance to which this pipeline is bound.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.0.0
         */ this.renderer = renderer;
                        /**
         * A reference to the WebGL Pipeline Manager.
         *
         * This is initially undefined and only set when this pipeline is added
         * to the manager.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#manager
         * @type {?Phaser.Renderer.WebGL.PipelineManager}
         * @since 3.50.0
         */ this.manager;
                        /**
         * The WebGL context this WebGL Pipeline uses.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#gl
         * @type {WebGLRenderingContext}
         * @since 3.0.0
         */ this.gl = gl;
                        /**
         * The canvas which this WebGL Pipeline renders to.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#view
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.view = game.canvas;
                        /**
         * Width of the current viewport.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                        /**
         * Height of the current viewport.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                        /**
         * The current number of vertices that have been added to the pipeline batch.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.vertexCount = 0;
                        /**
         * The total number of vertices that this pipeline batch can hold before it will flush.
         *
         * This defaults to `renderer batchSize * 6`, where `batchSize` is defined in the Renderer Game Config.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCapacity
         * @type {number}
         * @since 3.0.0
         */ this.vertexCapacity = 0;
                        /**
         * Raw byte buffer of vertices.
         *
         * Either set via the config object `vertices` property, or generates a new Array Buffer of
         * size `vertexCapacity * vertexSize`.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexData
         * @type {ArrayBuffer}
         * @readonly
         * @since 3.0.0
         */ this.vertexData;
                        /**
         * The WebGLBuffer that holds the vertex data.
         *
         * Created from the `vertexData` ArrayBuffer. If `vertices` are set in the config, a `STATIC_DRAW` buffer
         * is created. If not, a `DYNAMIC_DRAW` buffer is created.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexBuffer
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper}
         * @readonly
         * @since 3.0.0
         */ this.vertexBuffer;
                        /**
         * The currently active WebGLBuffer.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#activeBuffer
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper}
         * @since 3.60.0
         */ this.activeBuffer;
                        /**
         * The primitive topology which the pipeline will use to submit draw calls.
         *
         * Defaults to GL_TRIANGLES if not otherwise set in the config.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#topology
         * @type {GLenum}
         * @since 3.0.0
         */ this.topology = GetFastValue(config, 'topology', gl.TRIANGLES);
                        /**
         * Uint8 view to the `vertexData` ArrayBuffer. Used for uploading vertex buffer resources to the GPU.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#bytes
         * @type {Uint8Array}
         * @since 3.0.0
         */ this.bytes;
                        /**
         * Float32 view of the array buffer containing the pipeline's vertices.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexViewF32
         * @type {Float32Array}
         * @since 3.0.0
         */ this.vertexViewF32;
                        /**
         * Uint32 view of the array buffer containing the pipeline's vertices.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexViewU32
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.vertexViewU32;
                        /**
         * Indicates if the current pipeline is active, or not.
         *
         * Toggle this property to enable or disable a pipeline from rendering anything.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#active
         * @type {boolean}
         * @since 3.10.0
         */ this.active = true;
                        /**
         * Some pipelines require the forced use of texture zero (like the light pipeline).
         *
         * This property should be set when that is the case.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#forceZero
         * @type {boolean}
         * @since 3.50.0
         */ this.forceZero = GetFastValue(config, 'forceZero', false);
                        /**
         * Indicates if this pipeline has booted or not.
         *
         * A pipeline boots only when the Game instance itself, and all associated systems, is
         * fully ready.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#hasBooted
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.hasBooted = false;
                        /**
         * Indicates if this is a Post FX Pipeline, or not.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#isPostFX
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isPostFX = false;
                        /**
         * Indicates if this is a Pre FX Pipeline, or not.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#isPreFX
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isPreFX = false;
                        /**
         * An array of RenderTarget instances that belong to this pipeline.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#renderTargets
         * @type {Phaser.Renderer.WebGL.RenderTarget[]}
         * @since 3.50.0
         */ this.renderTargets = [];
                        /**
         * A reference to the currently bound Render Target instance from the `WebGLPipeline.renderTargets` array.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentRenderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.currentRenderTarget;
                        /**
         * An array of all the WebGLShader instances that belong to this pipeline.
         *
         * Shaders manage their own attributes and uniforms, but share the same vertex data buffer,
         * which belongs to this pipeline.
         *
         * Shaders are set in a call to the `setShadersFromConfig` method, which happens automatically,
         * but can also be called at any point in your game. See the method documentation for details.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#shaders
         * @type {Phaser.Renderer.WebGL.WebGLShader[]}
         * @since 3.50.0
         */ this.shaders = [];
                        /**
         * A reference to the currently bound WebGLShader instance from the `WebGLPipeline.shaders` array.
         *
         * For lots of pipelines, this is the only shader, so it is a quick way to reference it without
         * an array look-up.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.currentShader;
                        /**
         * The Projection matrix, used by shaders as 'uProjectionMatrix' uniform.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix;
                        /**
         * The cached width of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionWidth
         * @type {number}
         * @since 3.50.0
         */ this.projectionWidth = 0;
                        /**
         * The cached height of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionHeight
         * @type {number}
         * @since 3.50.0
         */ this.projectionHeight = 0;
                        /**
         * The configuration object that was used to create this pipeline.
         *
         * Treat this object as 'read only', because changing it post-creation will not
         * impact this pipeline in any way. However, it is used internally for cloning
         * and post-boot set-up.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#config
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig}
         * @since 3.50.0
         */ this.config = config;
                        /**
         * Has the GL Context been reset to the Phaser defaults since the last time
         * this pipeline was bound? This is set automatically when the Pipeline Manager
         * resets itself, usually after handing off to a 3rd party renderer like Spine.
         *
         * You should treat this property as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#glReset
         * @type {boolean}
         * @since 3.53.0
         */ this.glReset = false;
                        /**
         * The temporary Pipeline batch. This array contains the batch entries for
         * the current frame, which is a package of textures and vertex offsets used
         * for drawing. This package is built dynamically as the frame is built
         * and cleared during the flush method.
         *
         * Treat this array and all of its contents as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#batch
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineBatchEntry[]}
         * @since 3.60.0
         */ this.batch = [];
                        /**
         * The most recently created Pipeline batch entry.
         *
         * Reset to null as part of the flush method.
         *
         * Treat this value as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentBatch
         * @type {?Phaser.Types.Renderer.WebGL.WebGLPipelineBatchEntry}
         * @since 3.60.0
         */ this.currentBatch = null;
                        /**
         * The most recently bound texture, used as part of the batch process.
         *
         * Reset to null as part of the flush method.
         *
         * Treat this value as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentTexture
         * @type {?Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @since 3.60.0
         */ this.currentTexture = null;
                        /**
         * Holds the most recently assigned texture unit.
         *
         * Treat this value as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentUnit
         * @type {number}
         * @since 3.50.0
         */ this.currentUnit = 0;
                        /**
         * The currently active WebGLTextures, used as part of the batch process.
         *
         * Reset to empty as part of the bind method.
         *
         * Treat this array as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#activeTextures
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper[]}
         * @since 3.60.0
         */ this.activeTextures = [];
                        /**
         * If the WebGL Renderer changes size, this uniform will be set with the new width and height values
         * as part of the pipeline resize method. Various built-in pipelines, such as the MultiPipeline, set
         * this property automatically to `uResolution`.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#resizeUniform
         * @type {string}
         * @since 3.80.0
         */ this.resizeUniform = GetFastValue(config, 'resizeUniform', '');
                    },
                    /**
     * Called when the Game has fully booted and the Renderer has finished setting up.
     *
     * By this stage all Game level systems are now in place. You can perform any final tasks that the
     * pipeline may need, that relies on game systems such as the Texture Manager being ready.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#boot
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BOOT
     * @since 3.11.0
     */ boot: function() {
                        var i;
                        var gl = this.gl;
                        var config = this.config;
                        var renderer = this.renderer;
                        if (!this.isPostFX) this.projectionMatrix = new Matrix4().identity();
                        //  Create the Render Targets
                        var renderTargets = this.renderTargets;
                        var targets = GetFastValue(config, 'renderTarget', false);
                        //  If boolean, set to number = 1
                        if (typeof targets === 'boolean' && targets) targets = 1;
                        var width = renderer.width;
                        var height = renderer.height;
                        if (typeof targets === 'number') //  Create this many default RTs
                        for(i = 0; i < targets; i++)renderTargets.push(new RenderTarget(renderer, width, height, 1, 0, true));
                        else if (Array.isArray(targets)) for(i = 0; i < targets.length; i++){
                            var scale = GetFastValue(targets[i], 'scale', 1);
                            var minFilter = GetFastValue(targets[i], 'minFilter', 0);
                            var autoClear = GetFastValue(targets[i], 'autoClear', 1);
                            var autoResize = GetFastValue(targets[i], 'autoResize', false);
                            var targetWidth = GetFastValue(targets[i], 'width', null);
                            var targetHeight = GetFastValue(targets[i], 'height', targetWidth);
                            if (targetWidth) renderTargets.push(new RenderTarget(renderer, targetWidth, targetHeight, 1, minFilter, autoClear, autoResize));
                            else renderTargets.push(new RenderTarget(renderer, width, height, scale, minFilter, autoClear, autoResize));
                        }
                        if (renderTargets.length) //  Default to the first one in the array
                        this.currentRenderTarget = renderTargets[0];
                        //  Create the Shaders
                        this.setShadersFromConfig(config);
                        //  Which shader has the largest vertex size?
                        var shaders = this.shaders;
                        var vertexSize = 0;
                        for(i = 0; i < shaders.length; i++)if (shaders[i].vertexSize > vertexSize) vertexSize = shaders[i].vertexSize;
                        var batchSize = GetFastValue(config, 'batchSize', renderer.config.batchSize);
                        //  * 6 because there are 6 vertices in a quad and 'batchSize' represents the quantity of quads in the batch
                        this.vertexCapacity = batchSize * 6;
                        var data = new ArrayBuffer(this.vertexCapacity * vertexSize);
                        this.vertexData = data;
                        this.bytes = new Uint8Array(data);
                        this.vertexViewF32 = new Float32Array(data);
                        this.vertexViewU32 = new Uint32Array(data);
                        var configVerts = GetFastValue(config, 'vertices', null);
                        if (configVerts) {
                            this.vertexViewF32.set(configVerts);
                            this.vertexBuffer = renderer.createVertexBuffer(data, gl.STATIC_DRAW);
                        } else this.vertexBuffer = renderer.createVertexBuffer(data.byteLength, gl.DYNAMIC_DRAW);
                        //  Set-up shaders
                        this.setVertexBuffer();
                        for(i = shaders.length - 1; i >= 0; i--)shaders[i].rebind();
                        this.hasBooted = true;
                        renderer.on(RendererEvents.RESIZE, this.resize, this);
                        renderer.on(RendererEvents.PRE_RENDER, this.onPreRender, this);
                        renderer.on(RendererEvents.RENDER, this.onRender, this);
                        renderer.on(RendererEvents.POST_RENDER, this.onPostRender, this);
                        this.emit(Events.BOOT, this);
                        this.onBoot();
                    },
                    /**
     * This method is called once when this pipeline has finished being set-up
     * at the end of the boot process. By the time this method is called, all
     * of the shaders are ready and configured.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBoot
     * @since 3.50.0
     */ onBoot: function() {},
                    /**
     * This method is called once when this pipeline has finished being set-up
     * at the end of the boot process. By the time this method is called, all
     * of the shaders are ready and configured. It's also called if the renderer
     * changes size.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onResize
     * @since 3.50.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     */ onResize: function() {},
                    /**
     * Sets the currently active shader within this pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setShader
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} shader - The shader to set as being current.
     * @param {boolean} [setAttributes=false] - Should the vertex attribute pointers be set?
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper} [vertexBuffer] - The vertex buffer to be set before the shader is bound. Defaults to the one owned by this pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ setShader: function(shader, setAttributes, vertexBuffer) {
                        var renderer = this.renderer;
                        if (shader !== this.currentShader || renderer.currentProgram !== this.currentShader.program) {
                            this.flush();
                            var wasBound = this.setVertexBuffer(vertexBuffer);
                            if (wasBound && !setAttributes) setAttributes = true;
                            shader.bind(setAttributes, false);
                            this.currentShader = shader;
                        }
                        return this;
                    },
                    /**
     * Searches all shaders in this pipeline for one matching the given name, then returns it.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#getShaderByName
     * @since 3.50.0
     *
     * @param {string} name - The index of the shader to set.
     *
     * @return {Phaser.Renderer.WebGL.WebGLShader} The WebGLShader instance, if found.
     */ getShaderByName: function(name) {
                        var shaders = this.shaders;
                        for(var i = 0; i < shaders.length; i++){
                            if (shaders[i].name === name) return shaders[i];
                        }
                    },
                    /**
     * Destroys all shaders currently set in the `WebGLPipeline.shaders` array and then parses the given
     * `config` object, extracting the shaders from it, creating `WebGLShader` instances and finally
     * setting them into the `shaders` array of this pipeline.
     *
     * This is a destructive process. Be very careful when you call it, should you need to.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setShadersFromConfig
     * @since 3.50.0
     *
     * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration object for this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ setShadersFromConfig: function(config) {
                        var i;
                        var shaders = this.shaders;
                        var renderer = this.renderer;
                        for(i = 0; i < shaders.length; i++)shaders[i].destroy();
                        var vName = 'vertShader';
                        var fName = 'fragShader';
                        var aName = 'attributes';
                        var defaultVertShader = GetFastValue(config, vName, null);
                        var defaultFragShader = Utils.parseFragmentShaderMaxTextures(GetFastValue(config, fName, null), renderer.maxTextures);
                        var defaultAttribs = GetFastValue(config, aName, null);
                        var configShaders = GetFastValue(config, 'shaders', []);
                        var len = configShaders.length;
                        if (len === 0) {
                            if (defaultVertShader && defaultFragShader) this.shaders = [
                                new WebGLShader(this, 'default', defaultVertShader, defaultFragShader, DeepCopy(defaultAttribs))
                            ];
                        } else {
                            var newShaders = [];
                            for(i = 0; i < len; i++){
                                var shaderEntry = configShaders[i];
                                var name;
                                var vertShader;
                                var fragShader;
                                var attributes;
                                if (typeof shaderEntry === 'string') {
                                    name = 'default';
                                    vertShader = defaultVertShader;
                                    fragShader = Utils.parseFragmentShaderMaxTextures(shaderEntry, renderer.maxTextures);
                                    attributes = defaultAttribs;
                                } else {
                                    name = GetFastValue(shaderEntry, 'name', 'default');
                                    vertShader = GetFastValue(shaderEntry, vName, defaultVertShader);
                                    fragShader = Utils.parseFragmentShaderMaxTextures(GetFastValue(shaderEntry, fName, defaultFragShader), renderer.maxTextures);
                                    attributes = GetFastValue(shaderEntry, aName, defaultAttribs);
                                }
                                if (name === 'default') {
                                    var lines = fragShader.split('\n');
                                    var test = lines[0].trim();
                                    if (test.indexOf('#define SHADER_NAME') > -1) name = test.substring(20);
                                }
                                if (vertShader && fragShader) newShaders.push(new WebGLShader(this, name, vertShader, fragShader, DeepCopy(attributes)));
                            }
                            this.shaders = newShaders;
                        }
                        if (this.shaders.length === 0) console.warn('Pipeline: ' + this.name + ' - Invalid shader config');
                        else this.currentShader = this.shaders[0];
                        return this;
                    },
                    /**
     * Creates a new WebGL Pipeline Batch Entry, sets the texture unit as zero
     * and pushes the entry into the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#createBatch
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - The texture assigned to this batch entry.
     *
     * @return {number} The texture unit that was bound.
     */ createBatch: function(texture) {
                        this.currentBatch = {
                            start: this.vertexCount,
                            count: 0,
                            texture: [
                                texture
                            ],
                            unit: 0,
                            maxUnit: 0
                        };
                        this.currentUnit = 0;
                        this.currentTexture = texture;
                        this.batch.push(this.currentBatch);
                        return 0;
                    },
                    /**
     * Adds the given texture to the current WebGL Pipeline Batch Entry and
     * increases the batch entry unit and maxUnit values by 1.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#addTextureToBatch
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - The texture assigned to this batch entry.
     */ addTextureToBatch: function(texture) {
                        var batch = this.currentBatch;
                        if (batch) {
                            batch.texture.push(texture);
                            batch.unit++;
                            batch.maxUnit++;
                        }
                    },
                    /**
     * Takes the given WebGLTextureWrapper and determines what to do with it.
     *
     * If there is no current batch (i.e. after a flush) it will create a new
     * batch from it.
     *
     * If the texture is already bound, it will return the current texture unit.
     *
     * If the texture already exists in the current batch, the unit gets reset
     * to match it.
     *
     * If the texture cannot be found in the current batch, and it supports
     * multiple textures, it's added into the batch and the unit indexes are
     * advanced.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#pushBatch
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - The texture assigned to this batch entry.
     *
     * @return {number} The texture unit that was bound.
     */ pushBatch: function(texture) {
                        //  No current batch? Create one and return
                        if (!this.currentBatch || this.forceZero && texture !== this.currentTexture) return this.createBatch(texture);
                        //  Otherwise, check if the texture is in the current batch
                        if (texture === this.currentTexture) return this.currentUnit;
                        else {
                            var current = this.currentBatch;
                            var idx = current.texture.indexOf(texture);
                            if (idx === -1) {
                                //  This is a brand new texture, not in the current batch
                                //  Have we exceed our limit?
                                if (current.texture.length === this.renderer.maxTextures) return this.createBatch(texture);
                                else {
                                    //  We're good, push it in
                                    current.unit++;
                                    current.maxUnit++;
                                    current.texture.push(texture);
                                    this.currentUnit = current.unit;
                                    this.currentTexture = texture;
                                    return current.unit;
                                }
                            } else {
                                this.currentUnit = idx;
                                this.currentTexture = texture;
                                return idx;
                            }
                        }
                    },
                    /**
     * Custom pipelines can use this method in order to perform any required pre-batch tasks
     * for the given Game Object. It must return the texture unit the Game Object was assigned.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setGameObject
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object being rendered or added to the batch.
     * @param {Phaser.Textures.Frame} [frame] - Optional frame to use. Can override that of the Game Object.
     *
     * @return {number} The texture unit the Game Object has been assigned.
     */ setGameObject: function(gameObject, frame) {
                        if (frame === undefined) frame = gameObject.frame;
                        return this.pushBatch(frame.source.glTexture);
                    },
                    /**
     * Check if the current batch of vertices is full.
     *
     * You can optionally provide an `amount` parameter. If given, it will check if the batch
     * needs to flush _if_ the `amount` is added to it. This allows you to test if you should
     * flush before populating the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#shouldFlush
     * @since 3.0.0
     *
     * @param {number} [amount=0] - Will the batch need to flush if this many vertices are added to it?
     *
     * @return {boolean} `true` if the current batch should be flushed, otherwise `false`.
     */ shouldFlush: function(amount) {
                        if (amount === undefined) amount = 0;
                        return this.vertexCount + amount > this.vertexCapacity;
                    },
                    /**
     * Returns the number of vertices that can be added to the current batch before
     * it will trigger a flush to happen.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#vertexAvailable
     * @since 3.60.0
     *
     * @return {number} The number of vertices that can still be added to the current batch before it will flush.
     */ vertexAvailable: function() {
                        return this.vertexCapacity - this.vertexCount;
                    },
                    /**
     * Resizes the properties used to describe the viewport.
     *
     * This method is called automatically by the renderer during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#resize
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ resize: function(width, height) {
                        if (width !== this.width || height !== this.height) this.flush();
                        this.width = width;
                        this.height = height;
                        var targets = this.renderTargets;
                        for(var i = 0; i < targets.length; i++)targets[i].resize(width, height);
                        this.setProjectionMatrix(width, height);
                        if (this.resizeUniform) this.set2f(this.resizeUniform, width, height);
                        this.emit(Events.RESIZE, width, height, this);
                        this.onResize(width, height);
                        return this;
                    },
                    /**
     * Adjusts this pipelines ortho Projection Matrix to use the given dimensions
     * and resets the `uProjectionMatrix` uniform on all bound shaders.
     *
     * This method is called automatically by the renderer during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setProjectionMatrix
     * @since 3.50.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ setProjectionMatrix: function(width, height) {
                        var projectionMatrix = this.projectionMatrix;
                        //  Because not all pipelines have them
                        if (!projectionMatrix) return this;
                        this.projectionWidth = width;
                        this.projectionHeight = height;
                        projectionMatrix.ortho(0, width, height, 0, -1000, 1000);
                        var shaders = this.shaders;
                        var name = 'uProjectionMatrix';
                        for(var i = 0; i < shaders.length; i++){
                            var shader = shaders[i];
                            if (shader.hasUniform(name)) {
                                shader.resetUniform(name);
                                shader.setMatrix4fv(name, false, projectionMatrix.val, shader);
                            }
                        }
                        return this;
                    },
                    /**
     * Adjusts this pipelines ortho Projection Matrix to flip the y
     * and bottom values. Call with 'false' as the parameter to flip
     * them back again.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#flipProjectionMatrix
     * @since 3.60.0
     *
     * @param {boolean} [flipY=true] - Flip the y and bottom values?
     */ flipProjectionMatrix: function(flipY) {
                        if (flipY === undefined) flipY = true;
                        var projectionMatrix = this.projectionMatrix;
                        //  Because not all pipelines have them
                        if (!projectionMatrix) return this;
                        var width = this.projectionWidth;
                        var height = this.projectionHeight;
                        if (flipY) projectionMatrix.ortho(0, width, 0, height, -1000, 1000);
                        else projectionMatrix.ortho(0, width, height, 0, -1000, 1000);
                        this.setMatrix4fv('uProjectionMatrix', false, projectionMatrix.val);
                    },
                    /**
     * Adjusts this pipelines ortho Projection Matrix to match that of the global
     * WebGL Renderer Projection Matrix.
     *
     * This method is called automatically by the Pipeline Manager when this
     * pipeline is set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#updateProjectionMatrix
     * @since 3.50.0
     */ updateProjectionMatrix: function() {
                        if (this.projectionMatrix) {
                            var globalWidth = this.renderer.projectionWidth;
                            var globalHeight = this.renderer.projectionHeight;
                            if (this.projectionWidth !== globalWidth || this.projectionHeight !== globalHeight) this.setProjectionMatrix(globalWidth, globalHeight);
                        }
                    },
                    /**
     * This method is called every time the Pipeline Manager makes this pipeline the currently active one.
     *
     * It binds the resources and shader needed for this pipeline, including setting the vertex buffer
     * and attribute pointers.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bind
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BIND
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {this} This WebGLPipeline instance.
     */ bind: function(currentShader) {
                        if (currentShader === undefined) currentShader = this.currentShader;
                        if (this.glReset) return this.rebind(currentShader);
                        var wasBound = false;
                        var gl = this.gl;
                        if (gl.getParameter(gl.ARRAY_BUFFER_BINDING) !== this.vertexBuffer) {
                            gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer.webGLBuffer);
                            this.activeBuffer = this.vertexBuffer;
                            wasBound = true;
                        }
                        currentShader.bind(wasBound);
                        this.currentShader = currentShader;
                        this.activeTextures.length = 0;
                        this.emit(Events.BIND, this, currentShader);
                        this.onActive(currentShader);
                        return this;
                    },
                    /**
     * This method is called every time the Pipeline Manager rebinds this pipeline.
     *
     * It resets all shaders this pipeline uses, setting their attributes again.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#rebind
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#REBIND
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {this} This WebGLPipeline instance.
     */ rebind: function(currentShader) {
                        this.activeBuffer = null;
                        this.setVertexBuffer();
                        var shaders = this.shaders;
                        //  Loop in reverse, so the first shader in the array is left as being bound
                        for(var i = shaders.length - 1; i >= 0; i--){
                            var shader = shaders[i].rebind();
                            if (!currentShader || shader === currentShader) this.currentShader = shader;
                        }
                        this.activeTextures.length = 0;
                        this.emit(Events.REBIND, this.currentShader);
                        this.onActive(this.currentShader);
                        this.onRebind();
                        this.glReset = false;
                        return this;
                    },
                    /**
     * This method is called if the WebGL context is lost and restored.
     * It ensures that uniforms are synced back to the GPU
     * for all shaders in this pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#restoreContext
     * @since 3.80.0
     */ restoreContext: function() {
                        var shaders = this.shaders;
                        var hasVertexBuffer = !!this.vertexBuffer;
                        // Deactivate all invalidated state.
                        this.activeBuffer = null;
                        this.activeTextures.length = 0;
                        this.batch.length = 0;
                        this.currentBatch = null;
                        this.currentTexture = null;
                        this.currentUnit = 0;
                        if (hasVertexBuffer) this.setVertexBuffer();
                        for(var i = 0; i < shaders.length; i++){
                            var shader = shaders[i];
                            shader.syncUniforms();
                            if (hasVertexBuffer) shader.rebind();
                        }
                    },
                    /**
     * Binds the vertex buffer to be the active ARRAY_BUFFER on the WebGL context.
     *
     * It first checks to see if it's already set as the active buffer and only
     * binds itself if not.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setVertexBuffer
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper} [buffer] - The Vertex Buffer to be bound. Defaults to the one owned by this pipeline.
     *
     * @return {boolean} `true` if the vertex buffer was bound, or `false` if it was already bound.
     */ setVertexBuffer: function(buffer) {
                        if (buffer === undefined) buffer = this.vertexBuffer;
                        if (buffer !== this.activeBuffer) {
                            var gl = this.gl;
                            this.gl.bindBuffer(gl.ARRAY_BUFFER, buffer.webGLBuffer);
                            this.activeBuffer = buffer;
                            return true;
                        }
                        return false;
                    },
                    /**
     * This method is called as a result of the `WebGLPipeline.batchQuad` method, right before a quad
     * belonging to a Game Object is about to be added to the batch. When this is called, the
     * renderer has just performed a flush. It will bind the current render target, if any are set
     * and finally call the `onPreBatch` hook.
     *
     * It is also called as part of the `PipelineManager.preBatch` method when processing Post FX Pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#preBatch
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)} [gameObject] - The Game Object or Camera that invoked this pipeline, if any.
     *
     * @return {this} This WebGLPipeline instance.
     */ preBatch: function(gameObject) {
                        if (this.currentRenderTarget) this.currentRenderTarget.bind();
                        this.onPreBatch(gameObject);
                        return this;
                    },
                    /**
     * This method is called as a result of the `WebGLPipeline.batchQuad` method, right after a quad
     * belonging to a Game Object has been added to the batch. When this is called, the
     * renderer has just performed a flush.
     *
     * It calls the `onDraw` hook followed by the `onPostBatch` hook, which can be used to perform
     * additional Post FX Pipeline processing.
     *
     * It is also called as part of the `PipelineManager.postBatch` method when processing Post FX Pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#postBatch
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)} [gameObject] - The Game Object or Camera that invoked this pipeline, if any.
     *
     * @return {this} This WebGLPipeline instance.
     */ postBatch: function(gameObject) {
                        this.onDraw(this.currentRenderTarget);
                        this.onPostBatch(gameObject);
                        return this;
                    },
                    /**
     * This method is only used by Sprite FX and Post FX Pipelines and those that extend from them.
     *
     * This method is called every time the `postBatch` method is called and is passed a
     * reference to the current render target.
     *
     * At the very least a Post FX Pipeline should call `this.bindAndDraw(renderTarget)`,
     * however, you can do as much additional processing as you like in this method if
     * you override it from within your own pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onDraw
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} renderTarget - The Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [swapTarget] - A Swap Render Target, useful for double-buffer effects. Only set by SpriteFX Pipelines.
     */ onDraw: function() {},
                    /**
     * This method is called every time the Pipeline Manager deactivates this pipeline, swapping from
     * it to another one. This happens after a call to `flush` and before the new pipeline is bound.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#unbind
     * @since 3.50.0
     */ unbind: function() {
                        if (this.currentRenderTarget) this.currentRenderTarget.unbind();
                    },
                    /**
     * Uploads the vertex data and emits a draw call for the current batch of vertices.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#flush
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BEFORE_FLUSH
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#AFTER_FLUSH
     * @since 3.0.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     *
     * @return {this} This WebGLPipeline instance.
     */ flush: function(isPostFlush) {
                        if (isPostFlush === undefined) isPostFlush = false;
                        if (this.vertexCount > 0) {
                            this.emit(Events.BEFORE_FLUSH, this, isPostFlush);
                            this.onBeforeFlush(isPostFlush);
                            var gl = this.gl;
                            var vertexCount = this.vertexCount;
                            var vertexSize = this.currentShader.vertexSize;
                            var topology = this.topology;
                            if (this.active) {
                                this.setVertexBuffer();
                                if (vertexCount === this.vertexCapacity) gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.DYNAMIC_DRAW);
                                else gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
                                var i;
                                var entry;
                                var texture;
                                var batch = this.batch;
                                var activeTextures = this.activeTextures;
                                if (this.forceZero) {
                                    //  Single Texture Pipeline
                                    if (!activeTextures[0]) gl.activeTexture(gl.TEXTURE0);
                                    for(i = 0; i < batch.length; i++){
                                        entry = batch[i];
                                        texture = entry.texture[0];
                                        if (activeTextures[0] !== texture) {
                                            gl.bindTexture(gl.TEXTURE_2D, texture.webGLTexture);
                                            activeTextures[0] = texture;
                                        }
                                        gl.drawArrays(topology, entry.start, entry.count);
                                    }
                                } else for(i = 0; i < batch.length; i++){
                                    entry = batch[i];
                                    for(var t = 0; t <= entry.maxUnit; t++){
                                        texture = entry.texture[t];
                                        if (activeTextures[t] !== texture) {
                                            gl.activeTexture(gl.TEXTURE0 + t);
                                            gl.bindTexture(gl.TEXTURE_2D, texture.webGLTexture);
                                            activeTextures[t] = texture;
                                        }
                                    }
                                    gl.drawArrays(topology, entry.start, entry.count);
                                }
                            }
                            this.vertexCount = 0;
                            this.batch.length = 0;
                            this.currentBatch = null;
                            this.currentTexture = null;
                            this.currentUnit = 0;
                            this.emit(Events.AFTER_FLUSH, this, isPostFlush);
                            this.onAfterFlush(isPostFlush);
                        }
                        return this;
                    },
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time the Pipeline Manager makes this the active pipeline. It is called
     * at the end of the `WebGLPipeline.bind` method, after the current shader has been set. The current
     * shader is passed to this hook.
     *
     * For example, if a display list has 3 Sprites in it that all use the same pipeline, this hook will
     * only be called for the first one, as the 2nd and 3rd Sprites do not cause the pipeline to be changed.
     *
     * If you need to listen for that event instead, use the `onBind` hook.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onActive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as current.
     */ onActive: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time a **Game Object** asks the Pipeline Manager to use this pipeline,
     * even if the pipeline is already active.
     *
     * Unlike the `onActive` method, which is only called when the Pipeline Manager makes this pipeline
     * active, this hook is called for every Game Object that requests use of this pipeline, allowing you to
     * perform per-object set-up, such as loading shader uniform data.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBind
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onBind: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called when the Pipeline Manager needs to rebind this pipeline. This happens after a
     * pipeline has been cleared, usually when passing control over to a 3rd party WebGL library, like Spine,
     * and then returing to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onRebind
     * @since 3.50.0
     */ onRebind: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time the `batchQuad` or `batchTri` methods are called. If this was
     * as a result of a Game Object, then the Game Object reference is passed to this hook too.
     *
     * This hook is called _after_ the quad (or tri) has been added to the batch, so you can safely
     * call 'flush' from within this.
     *
     * Note that Game Objects may call `batchQuad` or `batchTri` multiple times for a single draw,
     * for example the Graphics Game Object.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onBatch: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately before a **Game Object** is about to add itself to the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPreBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onPreBatch: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately after a **Game Object** has been added to the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPostBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onPostBatch: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called once per frame, right before anything has been rendered, but after the canvas
     * has been cleared. If this pipeline has a render target, it will also have been cleared by this point.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPreRender
     * @since 3.50.0
     */ onPreRender: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called _once per frame_, by every Camera in a Scene that wants to render.
     *
     * It is called at the start of the rendering process, before anything has been drawn to the Camera.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onRender
     * @since 3.50.0
     *
     * @param {Phaser.Scene} scene - The Scene being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered with.
     */ onRender: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called _once per frame_, after all rendering has happened and snapshots have been taken.
     *
     * It is called at the very end of the rendering process, once all Cameras, for all Scenes, have
     * been rendered.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPostRender
     * @since 3.50.0
     */ onPostRender: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time this pipeline is asked to flush its batch.
     *
     * It is called immediately before the `gl.bufferData` and `gl.drawArrays` calls are made, so you can
     * perform any final pre-render modifications. To apply changes post-render, see `onAfterFlush`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBeforeFlush
     * @since 3.50.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     */ onBeforeFlush: function() {},
                    /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately after this pipeline has finished flushing its batch.
     *
     * It is called after the `gl.drawArrays` call.
     *
     * You can perform additional post-render effects, but be careful not to call `flush`
     * on this pipeline from within this method, or you'll cause an infinite loop.
     *
     * To apply changes pre-render, see `onBeforeFlush`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onAfterFlush
     * @since 3.50.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     */ onAfterFlush: function() {},
                    /**
     * Adds a single vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchTri` and `batchQuad`.
     *
     * It does not perform any batch limit checking itself, so if you need to call
     * this method directly, do so in the same way that `batchQuad` does, for example.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} u - UV u value.
     * @param {number} v - UV v value.
     * @param {number} unit - Texture unit to which the texture needs to be bound.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {number} tint - The tint color value.
     */ batchVert: function(x, y, u, v, unit, tintEffect, tint) {
                        var vertexViewF32 = this.vertexViewF32;
                        var vertexViewU32 = this.vertexViewU32;
                        var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                        vertexViewF32[++vertexOffset] = x;
                        vertexViewF32[++vertexOffset] = y;
                        vertexViewF32[++vertexOffset] = u;
                        vertexViewF32[++vertexOffset] = v;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tint;
                        this.vertexCount++;
                        this.currentBatch.count = this.vertexCount - this.currentBatch.start;
                    },
                    /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 6 vertices in the following arrangement:
     *
     * ```
     * 0----3
     * |\  B|
     * | \  |
     * |  \ |
     * | A \|
     * |    \
     * 1----2
     * ```
     *
     * Where tx0/ty0 = 0, tx1/ty1 = 1, tx2/ty2 = 2 and tx3/ty3 = 3
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchQuad
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|null)} gameObject - The Game Object, if any, drawing this quad.
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {number} tintBR - The bottom-right tint color value.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture] - Texture that will be assigned to the current batch if a flush occurs.
     * @param {number} [unit=0] - Texture unit to which the texture needs to be bound.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchQuad: function(gameObject, x0, y0, x1, y1, x2, y2, x3, y3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, unit) {
                        if (unit === undefined) unit = this.currentUnit;
                        var hasFlushed = false;
                        if (this.shouldFlush(6)) {
                            this.flush();
                            hasFlushed = true;
                        }
                        if (!this.currentBatch) unit = this.setTexture2D(texture);
                        var vertexViewF32 = this.vertexViewF32;
                        var vertexViewU32 = this.vertexViewU32;
                        var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                        vertexViewF32[++vertexOffset] = x0;
                        vertexViewF32[++vertexOffset] = y0;
                        vertexViewF32[++vertexOffset] = u0;
                        vertexViewF32[++vertexOffset] = v0;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintTL;
                        vertexViewF32[++vertexOffset] = x1;
                        vertexViewF32[++vertexOffset] = y1;
                        vertexViewF32[++vertexOffset] = u0;
                        vertexViewF32[++vertexOffset] = v1;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintBL;
                        vertexViewF32[++vertexOffset] = x2;
                        vertexViewF32[++vertexOffset] = y2;
                        vertexViewF32[++vertexOffset] = u1;
                        vertexViewF32[++vertexOffset] = v1;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintBR;
                        vertexViewF32[++vertexOffset] = x0;
                        vertexViewF32[++vertexOffset] = y0;
                        vertexViewF32[++vertexOffset] = u0;
                        vertexViewF32[++vertexOffset] = v0;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintTL;
                        vertexViewF32[++vertexOffset] = x2;
                        vertexViewF32[++vertexOffset] = y2;
                        vertexViewF32[++vertexOffset] = u1;
                        vertexViewF32[++vertexOffset] = v1;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintBR;
                        vertexViewF32[++vertexOffset] = x3;
                        vertexViewF32[++vertexOffset] = y3;
                        vertexViewF32[++vertexOffset] = u1;
                        vertexViewF32[++vertexOffset] = v0;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintTR;
                        this.vertexCount += 6;
                        this.currentBatch.count = this.vertexCount - this.currentBatch.start;
                        this.onBatch(gameObject);
                        return hasFlushed;
                    },
                    /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 3 vertices in the following arrangement:
     *
     * ```
     * 0
     * |\
     * | \
     * |  \
     * |   \
     * |    \
     * 1-----2
     * ```
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchTri
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|null)} gameObject - The Game Object, if any, drawing this quad.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture] - Texture that will be assigned to the current batch if a flush occurs.
     * @param {number} [unit=0] - Texture unit to which the texture needs to be bound.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchTri: function(gameObject, x0, y0, x1, y1, x2, y2, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintEffect, texture, unit) {
                        if (unit === undefined) unit = this.currentUnit;
                        var hasFlushed = false;
                        if (this.shouldFlush(3)) {
                            this.flush();
                            hasFlushed = true;
                        }
                        if (!this.currentBatch) unit = this.setTexture2D(texture);
                        var vertexViewF32 = this.vertexViewF32;
                        var vertexViewU32 = this.vertexViewU32;
                        var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                        vertexViewF32[++vertexOffset] = x0;
                        vertexViewF32[++vertexOffset] = y0;
                        vertexViewF32[++vertexOffset] = u0;
                        vertexViewF32[++vertexOffset] = v0;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintTL;
                        vertexViewF32[++vertexOffset] = x1;
                        vertexViewF32[++vertexOffset] = y1;
                        vertexViewF32[++vertexOffset] = u0;
                        vertexViewF32[++vertexOffset] = v1;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintTR;
                        vertexViewF32[++vertexOffset] = x2;
                        vertexViewF32[++vertexOffset] = y2;
                        vertexViewF32[++vertexOffset] = u1;
                        vertexViewF32[++vertexOffset] = v1;
                        vertexViewF32[++vertexOffset] = unit;
                        vertexViewF32[++vertexOffset] = tintEffect;
                        vertexViewU32[++vertexOffset] = tintBL;
                        this.vertexCount += 3;
                        this.currentBatch.count = this.vertexCount - this.currentBatch.start;
                        this.onBatch(gameObject);
                        return hasFlushed;
                    },
                    /**
     * Pushes a filled rectangle into the vertex batch.
     *
     * The dimensions are run through `Math.floor` before the quad is generated.
     *
     * Rectangle has no transform values and isn't transformed into the local space.
     *
     * Used for directly batching untransformed rectangles, such as Camera background colors.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#drawFillRect
     * @since 3.50.0
     *
     * @param {number} x - Horizontal top left coordinate of the rectangle.
     * @param {number} y - Vertical top left coordinate of the rectangle.
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {number} color - Color of the rectangle to draw.
     * @param {number} alpha - Alpha value of the rectangle to draw.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture] - texture that will be assigned to the current batch if a flush occurs.
     * @param {boolean} [flipUV=true] - Flip the vertical UV coordinates of the texture before rendering?
     */ drawFillRect: function(x, y, width, height, color, alpha, texture, flipUV) {
                        if (texture === undefined) texture = this.renderer.whiteTexture;
                        if (flipUV === undefined) flipUV = true;
                        x = Math.floor(x);
                        y = Math.floor(y);
                        var xw = Math.floor(x + width);
                        var yh = Math.floor(y + height);
                        var unit = this.setTexture2D(texture);
                        var tint = Utils.getTintAppendFloatAlphaAndSwap(color, alpha);
                        var u0 = 0;
                        var v0 = 0;
                        var u1 = 1;
                        var v1 = 1;
                        if (flipUV) {
                            v0 = 1;
                            v1 = 0;
                        }
                        this.batchQuad(null, x, y, x, yh, xw, yh, xw, y, u0, v0, u1, v1, tint, tint, tint, tint, 0, texture, unit);
                    },
                    /**
     * Sets the texture to be bound to the next available texture unit and returns
     * the unit id.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setTexture2D
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture] - Texture that will be assigned to the current batch. If not given uses `whiteTexture`.
     *
     * @return {number} The assigned texture unit.
     */ setTexture2D: function(texture) {
                        if (texture === undefined) texture = this.renderer.whiteTexture;
                        return this.pushBatch(texture);
                    },
                    /**
     * Activates the given WebGL Texture and binds it to the requested texture slot.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bindTexture
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [target] - Texture to activate and bind.
     * @param {number} [unit=0] - The WebGL texture ID to activate. Defaults to `gl.TEXTURE0`.
     *
     * @return {this} This WebGL Pipeline instance.
     */ bindTexture: function(texture, unit) {
                        if (unit === undefined) unit = 0;
                        var gl = this.gl;
                        gl.activeTexture(gl.TEXTURE0 + unit);
                        gl.bindTexture(gl.TEXTURE_2D, texture.webGLTexture);
                        return this;
                    },
                    /**
     * Activates the given Render Target texture and binds it to the
     * requested WebGL texture slot.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bindRenderTarget
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The Render Target to activate and bind.
     * @param {number} [unit=0] - The WebGL texture ID to activate. Defaults to `gl.TEXTURE0`.
     *
     * @return {this} This WebGL Pipeline instance.
     */ bindRenderTarget: function(target, unit) {
                        return this.bindTexture(target.texture, unit);
                    },
                    /**
     * Sets the current duration into a 1f uniform value based on the given name.
     *
     * This can be used for mapping time uniform values, such as `iTime`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setTime
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setTime: function(name, shader) {
                        this.set1f(name, this.game.loop.getDuration(), shader);
                        return this;
                    },
                    /**
     * Sets a boolean uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setBoolean
     * @since 3.60.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} value - The new value of the `boolean` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setBoolean: function(name, value, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.setBoolean(name, value);
                        return this;
                    },
                    /**
     * Sets a 1f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `float` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1f: function(name, x, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set1f(name, x);
                        return this;
                    },
                    /**
     * Sets a 2f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec2` uniform.
     * @param {number} y - The new Y component of the `vec2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2f: function(name, x, y, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set2f(name, x, y);
                        return this;
                    },
                    /**
     * Sets a 3f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec3` uniform.
     * @param {number} y - The new Y component of the `vec3` uniform.
     * @param {number} z - The new Z component of the `vec3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3f: function(name, x, y, z, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set3f(name, x, y, z);
                        return this;
                    },
                    /**
     * Sets a 4f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4f: function(name, x, y, z, w, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set4f(name, x, y, z, w);
                        return this;
                    },
                    /**
     * Sets a 1fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1fv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set1fv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 2fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2fv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set2fv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 3fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3fv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set3fv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 4fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4fv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set4fv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 1iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1iv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set1iv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 2iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2iv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set2iv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 3iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3iv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set3iv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 4iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4iv: function(name, arr, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set4iv(name, arr);
                        return this;
                    },
                    /**
     * Sets a 1i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `int` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1i: function(name, x, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set1i(name, x);
                        return this;
                    },
                    /**
     * Sets a 2i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec2` uniform.
     * @param {number} y - The new Y component of the `ivec2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2i: function(name, x, y, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set2i(name, x, y);
                        return this;
                    },
                    /**
     * Sets a 3i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec3` uniform.
     * @param {number} y - The new Y component of the `ivec3` uniform.
     * @param {number} z - The new Z component of the `ivec3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3i: function(name, x, y, z, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set3i(name, x, y, z);
                        return this;
                    },
                    /**
     * Sets a 4i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform.
     * @param {number} y - Y component of the uniform.
     * @param {number} z - Z component of the uniform.
     * @param {number} w - W component of the uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4i: function(name, x, y, z, w, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.set4i(name, x, y, z, w);
                        return this;
                    },
                    /**
     * Sets a matrix 2fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {number[]|Float32Array} matrix - The new values for the `mat2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix2fv: function(name, transpose, matrix, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.setMatrix2fv(name, transpose, matrix);
                        return this;
                    },
                    /**
     * Sets a matrix 3fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {Float32Array} matrix - The new values for the `mat3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix3fv: function(name, transpose, matrix, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.setMatrix3fv(name, transpose, matrix);
                        return this;
                    },
                    /**
     * Sets a matrix 4fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {Float32Array} matrix - The matrix data. If using a Matrix4 this should be the `Matrix4.val` property.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix4fv: function(name, transpose, matrix, shader) {
                        if (shader === undefined) shader = this.currentShader;
                        shader.setMatrix4fv(name, transpose, matrix);
                        return this;
                    },
                    /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#destroy
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
     * @since 3.0.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                        this.emit(Events.DESTROY, this);
                        var i;
                        var shaders = this.shaders;
                        for(i = 0; i < shaders.length; i++)shaders[i].destroy();
                        var targets = this.renderTargets;
                        for(i = 0; i < targets.length; i++)targets[i].destroy();
                        var renderer = this.renderer;
                        renderer.deleteBuffer(this.vertexBuffer);
                        renderer.off(RendererEvents.RESIZE, this.resize, this);
                        renderer.off(RendererEvents.PRE_RENDER, this.onPreRender, this);
                        renderer.off(RendererEvents.RENDER, this.onRender, this);
                        renderer.off(RendererEvents.POST_RENDER, this.onPostRender, this);
                        this.removeAllListeners();
                        this.game = null;
                        this.renderer = null;
                        this.manager = null;
                        this.gl = null;
                        this.view = null;
                        this.shaders = null;
                        this.renderTargets = null;
                        this.bytes = null;
                        this.vertexViewF32 = null;
                        this.vertexViewU32 = null;
                        this.vertexData = null;
                        this.vertexBuffer = null;
                        this.currentShader = null;
                        this.currentRenderTarget = null;
                        this.activeTextures = null;
                        return this;
                    }
                });
                module1.exports = WebGLPipeline;
            /***/ },
            /***/ 74797: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayEach = __webpack_require__(95428);
                var ArrayRemove = __webpack_require__(72905);
                var CameraEvents = __webpack_require__(19715);
                var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(8054);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(92503);
                var IsSizePowerOfTwo = __webpack_require__(50030);
                var Matrix4 = __webpack_require__(37867);
                var NOOP = __webpack_require__(29747);
                var PipelineManager = __webpack_require__(7530);
                var RenderTarget = __webpack_require__(32302);
                var ScaleEvents = __webpack_require__(97480);
                var TextureEvents = __webpack_require__(69442);
                var Utils = __webpack_require__(70554);
                var WebGLSnapshot = __webpack_require__(88815);
                var WebGLBufferWrapper = __webpack_require__(26128);
                var WebGLProgramWrapper = __webpack_require__(1482);
                var WebGLTextureWrapper = __webpack_require__(82751);
                var WebGLFramebufferWrapper = __webpack_require__(84387);
                var WebGLAttribLocationWrapper = __webpack_require__(93567);
                var WebGLUniformLocationWrapper = __webpack_require__(57183);
                var DEBUG = false;
                var SPECTOR;
                /**
 * @callback WebGLContextCallback
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer which owns the context.
 */ /**
 * @classdesc
 * WebGLRenderer is a class that contains the needed functionality to keep the
 * WebGLRenderingContext state clean. The main idea of the WebGLRenderer is to keep track of
 * any context change that happens for WebGL rendering inside of Phaser. This means
 * if raw webgl functions are called outside the WebGLRenderer of the Phaser WebGL
 * rendering ecosystem they might pollute the current WebGLRenderingContext state producing
 * unexpected behavior. It's recommended that WebGL interaction is done through
 * WebGLRenderer and/or WebGLPipeline.
 *
 * @class WebGLRenderer
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance which owns this WebGL Renderer.
 */ var WebGLRenderer = new Class({
                    Extends: EventEmitter,
                    initialize: function WebGLRenderer(game) {
                        EventEmitter.call(this);
                        var gameConfig = game.config;
                        var contextCreationConfig = {
                            alpha: gameConfig.transparent,
                            desynchronized: gameConfig.desynchronized,
                            depth: true,
                            antialias: gameConfig.antialiasGL,
                            premultipliedAlpha: gameConfig.premultipliedAlpha,
                            stencil: true,
                            failIfMajorPerformanceCaveat: gameConfig.failIfMajorPerformanceCaveat,
                            powerPreference: gameConfig.powerPreference,
                            preserveDrawingBuffer: gameConfig.preserveDrawingBuffer,
                            willReadFrequently: false
                        };
                        /**
         * The local configuration settings of this WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#config
         * @type {object}
         * @since 3.0.0
         */ this.config = {
                            clearBeforeRender: gameConfig.clearBeforeRender,
                            antialias: gameConfig.antialias,
                            backgroundColor: gameConfig.backgroundColor,
                            contextCreation: contextCreationConfig,
                            roundPixels: gameConfig.roundPixels,
                            maxTextures: gameConfig.maxTextures,
                            maxTextureSize: gameConfig.maxTextureSize,
                            batchSize: gameConfig.batchSize,
                            maxLights: gameConfig.maxLights,
                            mipmapFilter: gameConfig.mipmapFilter
                        };
                        /**
         * The Game instance which owns this WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                        /**
         * A constant which allows the renderer to be easily identified as a WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#type
         * @type {number}
         * @since 3.0.0
         */ this.type = CONST.WEBGL;
                        /**
         * An instance of the Pipeline Manager class, that handles all WebGL Pipelines.
         *
         * Use this to manage all of your interactions with pipelines, such as adding, getting,
         * setting and rendering them.
         *
         * The Pipeline Manager class is created in the `init` method and then populated
         * with pipelines during the `boot` method.
         *
         * Prior to Phaser v3.50.0 this was just a plain JavaScript object, not a class.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#pipelines
         * @type {Phaser.Renderer.WebGL.PipelineManager}
         * @since 3.50.0
         */ this.pipelines = null;
                        /**
         * The width of the canvas being rendered to.
         * This is populated in the onResize event handler.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                        /**
         * The height of the canvas being rendered to.
         * This is populated in the onResize event handler.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                        /**
         * The canvas which this WebGL Renderer draws to.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = game.canvas;
                        /**
         * An array of blend modes supported by the WebGL Renderer.
         *
         * This array includes the default blend modes as well as any custom blend modes added through {@link #addBlendMode}.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#blendModes
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.blendModes = [];
                        /**
         * This property is set to `true` if the WebGL context of the renderer is lost.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextLost
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.contextLost = false;
                        /**
         * Details about the currently scheduled snapshot.
         *
         * If a non-null `callback` is set in this object, a snapshot of the canvas will be taken after the current frame is fully rendered.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#snapshotState
         * @type {Phaser.Types.Renderer.Snapshot.SnapshotState}
         * @since 3.0.0
         */ this.snapshotState = {
                            x: 0,
                            y: 0,
                            width: 1,
                            height: 1,
                            getPixel: false,
                            callback: null,
                            type: 'image/png',
                            encoder: 0.92,
                            isFramebuffer: false,
                            bufferWidth: 0,
                            bufferHeight: 0
                        };
                        /**
         * The maximum number of textures the GPU can handle. The minimum under the WebGL1 spec is 8.
         * This is set via the Game Config `maxTextures` property and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maxTextures
         * @type {number}
         * @since 3.50.0
         */ this.maxTextures = 0;
                        /**
         * An array of the available WebGL texture units, used to populate the uSampler uniforms.
         *
         * This array is populated during the init phase and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#textureIndexes
         * @type {array}
         * @since 3.50.0
         */ this.textureIndexes;
                        /**
         * A list of all WebGLBufferWrappers that have been created by this renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glBufferWrappers
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper[]}
         * @since 3.80.0
         */ this.glBufferWrappers = [];
                        /**
         * A list of all WebGLProgramWrappers that have been created by this renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glProgramWrappers
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper[]}
         * @since 3.80.0
         */ this.glProgramWrappers = [];
                        /**
         * A list of all WebGLTextureWrappers that have been created by this renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glTextureWrappers
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper[]}
         * @since 3.80.0
         */ this.glTextureWrappers = [];
                        /**
         * A list of all WebGLFramebufferWrappers that have been created by this renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFramebufferWrappers
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper[]}
         * @since 3.80.0
         */ this.glFramebufferWrappers = [];
                        /**
         * A list of all WebGLAttribLocationWrappers that have been created by this renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glAttribLocationWrappers
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper[]}
         * @since 3.80.0
         */ this.glAttribLocationWrappers = [];
                        /**
         * A list of all WebGLUniformLocationWrappers that have been created by this renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glUniformLocationWrappers
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper[]}
         * @since 3.80.0
         */ this.glUniformLocationWrappers = [];
                        /**
         * The currently bound framebuffer in use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentFramebuffer
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper}
         * @default null
         * @since 3.0.0
         */ this.currentFramebuffer = null;
                        /**
         * A stack into which the frame buffer objects are pushed and popped.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#fboStack
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper[]}
         * @since 3.50.0
         */ this.fboStack = [];
                        /**
         * Current WebGLProgram in use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentProgram
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper}
         * @default null
         * @since 3.0.0
         */ this.currentProgram = null;
                        /**
         * Current blend mode in use
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentBlendMode
         * @type {number}
         * @since 3.0.0
         */ this.currentBlendMode = Infinity;
                        /**
         * Indicates if the the scissor state is enabled in WebGLRenderingContext
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissorEnabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.currentScissorEnabled = false;
                        /**
         * Stores the current scissor data
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissor
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.currentScissor = null;
                        /**
         * Stack of scissor data
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#scissorStack
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.scissorStack = [];
                        /**
         * The handler to invoke when the context is lost.
         * This should not be changed and is set in the init method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextLostHandler
         * @type {function}
         * @since 3.19.0
         */ this.contextLostHandler = NOOP;
                        /**
         * The handler to invoke when the context is restored.
         * This should not be changed and is set in the init method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextRestoredHandler
         * @type {function}
         * @since 3.19.0
         */ this.contextRestoredHandler = NOOP;
                        /**
         * The previous contextLostHandler that was in use.
         * This is set when `setContextHandlers` is called.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#previousContextLostHandler
         * @type {function}
         * @since 3.19.0
         */ this.previousContextLostHandler = NOOP;
                        /**
         * The previous contextRestoredHandler that was in use.
         * This is set when `setContextHandlers` is called.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#previousContextRestoredHandler
         * @type {function}
         * @since 3.19.0
         */ this.previousContextRestoredHandler = NOOP;
                        /**
         * The underlying WebGL context of the renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#gl
         * @type {WebGLRenderingContext}
         * @default null
         * @since 3.0.0
         */ this.gl = null;
                        /**
         * Array of strings that indicate which WebGL extensions are supported by the browser.
         * This is populated in the `setExtensions` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#supportedExtensions
         * @type {string[]}
         * @default null
         * @since 3.0.0
         */ this.supportedExtensions = null;
                        /**
         * If the browser supports the `ANGLE_instanced_arrays` extension, this property will hold
         * a reference to the glExtension for it.
         *
         * This is populated in the `setExtensions` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#instancedArraysExtension
         * @type {ANGLE_instanced_arrays}
         * @default null
         * @since 3.50.0
         */ this.instancedArraysExtension = null;
                        /**
         * If the browser supports the `OES_vertex_array_object` extension, this property will hold
         * a reference to the glExtension for it.
         *
         * This is populated in the `setExtensions` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#vaoExtension
         * @type {OES_vertex_array_object}
         * @default null
         * @since 3.50.0
         */ this.vaoExtension = null;
                        /**
         * The WebGL Extensions loaded into the current context.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#extensions
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.extensions = {};
                        /**
         * Stores the current WebGL component formats for further use.
         *
         * This array is populated in the `init` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFormats
         * @type {array}
         * @since 3.2.0
         */ this.glFormats;
                        /**
         * Stores the WebGL texture compression formats that this device and browser supports.
         *
         * Support for using compressed texture formats was added in Phaser version 3.60.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#compression
         * @type {Phaser.Types.Renderer.WebGL.WebGLTextureCompression}
         * @since 3.8.0
         */ this.compression;
                        /**
         * Cached drawing buffer height to reduce gl calls.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#drawingBufferHeight
         * @type {number}
         * @readonly
         * @since 3.11.0
         */ this.drawingBufferHeight = 0;
                        /**
         * A blank 32x32 transparent texture, as used by the Graphics system where needed.
         * This is set in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#blankTexture
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @readonly
         * @since 3.12.0
         */ this.blankTexture = null;
                        /**
         * A blank 1x1 #7f7fff texture, a flat normal map,
         * as used by the Graphics system where needed.
         * This is set in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#normalTexture
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @readonly
         * @since 3.80.0
         */ this.normalTexture = null;
                        /**
         * A pure white 4x4 texture, as used by the Graphics system where needed.
         * This is set in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#whiteTexture
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @readonly
         * @since 3.50.0
         */ this.whiteTexture = null;
                        /**
         * The total number of masks currently stacked.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskCount
         * @type {number}
         * @since 3.17.0
         */ this.maskCount = 0;
                        /**
         * The mask stack.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskStack
         * @type {Phaser.Display.Masks.GeometryMask[]}
         * @since 3.17.0
         */ this.maskStack = [];
                        /**
         * Internal property that tracks the currently set mask.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentMask
         * @type {any}
         * @since 3.17.0
         */ this.currentMask = {
                            mask: null,
                            camera: null
                        };
                        /**
         * Internal property that tracks the currently set camera mask.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentCameraMask
         * @type {any}
         * @since 3.17.0
         */ this.currentCameraMask = {
                            mask: null,
                            camera: null
                        };
                        /**
         * Internal gl function mapping for uniform look-up.
         * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/uniform
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFuncMap
         * @type {any}
         * @since 3.17.0
         */ this.glFuncMap = null;
                        /**
         * The `type` of the Game Object being currently rendered.
         * This can be used by advanced render functions for batching look-ahead.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentType
         * @type {string}
         * @since 3.19.0
         */ this.currentType = '';
                        /**
         * Is the `type` of the Game Object being currently rendered different than the
         * type of the object before it in the display list? I.e. it's a 'new' type.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#newType
         * @type {boolean}
         * @since 3.19.0
         */ this.newType = false;
                        /**
         * Does the `type` of the next Game Object in the display list match that
         * of the object being currently rendered?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#nextTypeMatch
         * @type {boolean}
         * @since 3.19.0
         */ this.nextTypeMatch = false;
                        /**
         * Is the Game Object being currently rendered the final one in the list?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#finalType
         * @type {boolean}
         * @since 3.50.0
         */ this.finalType = false;
                        /**
         * The mipmap magFilter to be used when creating textures.
         *
         * You can specify this as a string in the game config, i.e.:
         *
         * `render: { mipmapFilter: 'NEAREST_MIPMAP_LINEAR' }`
         *
         * The 6 options for WebGL1 are, in order from least to most computationally expensive:
         *
         * NEAREST (for pixel art)
         * LINEAR (the default)
         * NEAREST_MIPMAP_NEAREST
         * LINEAR_MIPMAP_NEAREST
         * NEAREST_MIPMAP_LINEAR
         * LINEAR_MIPMAP_LINEAR
         *
         * Mipmaps only work with textures that are fully power-of-two in size.
         *
         * For more details see https://webglfundamentals.org/webgl/lessons/webgl-3d-textures.html
         *
         * As of v3.60 no mipmaps will be generated unless a string is given in
         * the game config. This saves on VRAM use when it may not be required.
         * To obtain the previous result set the property to `LINEAR` in the config.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#mipmapFilter
         * @type {GLenum}
         * @since 3.21.0
         */ this.mipmapFilter = null;
                        /**
         * The default scissor, set during `preRender` and modified during `resize`.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#defaultScissor
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.defaultScissor = [
                            0,
                            0,
                            0,
                            0
                        ];
                        /**
         * Has this renderer fully booted yet?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#isBooted
         * @type {boolean}
         * @since 3.50.0
         */ this.isBooted = false;
                        /**
         * A Render Target you can use to capture the current state of the Renderer.
         *
         * A Render Target encapsulates a framebuffer and texture for the WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#renderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.renderTarget = null;
                        /**
         * The global game Projection matrix, used by shaders as 'uProjectionMatrix' uniform.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix;
                        /**
         * The cached width of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionWidth
         * @type {number}
         * @since 3.50.0
         */ this.projectionWidth = 0;
                        /**
         * The cached height of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionHeight
         * @type {number}
         * @since 3.50.0
         */ this.projectionHeight = 0;
                        /**
         * A RenderTarget used by the BitmapMask Pipeline.
         *
         * This is the source, i.e. the masked Game Object itself.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskSource
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.60.0
         */ this.maskSource = null;
                        /**
         * A RenderTarget used by the BitmapMask Pipeline.
         *
         * This is the target, i.e. the framebuffer the masked objects are drawn to.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.60.0
         */ this.maskTarget = null;
                        /**
         * An instance of SpectorJS used for WebGL Debugging.
         *
         * Only available in the Phaser Debug build.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#spector
         * @type {function}
         * @since 3.60.0
         */ this.spector = null;
                        /**
         * Is Spector currently capturing a WebGL frame?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#_debugCapture
         * @type {boolean}
         * @private
         * @since 3.60.0
         */ this._debugCapture = false;
                        this.init(this.config);
                    },
                    /**
     * Creates a new WebGLRenderingContext and initializes all internal state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#init
     * @since 3.0.0
     *
     * @param {object} config - The configuration object for the renderer.
     *
     * @return {this} This WebGLRenderer instance.
     */ init: function(config) {
                        var gl;
                        var game = this.game;
                        var canvas = this.canvas;
                        var clearColor = config.backgroundColor;
                        if (DEBUG) {
                            this.spector = new SPECTOR.Spector();
                            this.spector.onCapture.add(this.onCapture.bind(this));
                        }
                        //  Did they provide their own context?
                        if (game.config.context) gl = game.config.context;
                        else gl = canvas.getContext('webgl', config.contextCreation) || canvas.getContext('experimental-webgl', config.contextCreation);
                        if (!gl || gl.isContextLost()) {
                            this.contextLost = true;
                            throw new Error('WebGL unsupported');
                        }
                        this.gl = gl;
                        this.setExtensions();
                        this.setContextHandlers();
                        //  Set it back into the Game, so developers can access it from there too
                        game.context = gl;
                        for(var i = 0; i <= 27; i++)this.blendModes.push({
                            func: [
                                gl.ONE,
                                gl.ONE_MINUS_SRC_ALPHA
                            ],
                            equation: gl.FUNC_ADD
                        });
                        //  ADD
                        this.blendModes[1].func = [
                            gl.ONE,
                            gl.DST_ALPHA
                        ];
                        //  MULTIPLY
                        this.blendModes[2].func = [
                            gl.DST_COLOR,
                            gl.ONE_MINUS_SRC_ALPHA
                        ];
                        //  SCREEN
                        this.blendModes[3].func = [
                            gl.ONE,
                            gl.ONE_MINUS_SRC_COLOR
                        ];
                        //  ERASE
                        this.blendModes[17] = {
                            func: [
                                gl.ZERO,
                                gl.ONE_MINUS_SRC_ALPHA
                            ],
                            equation: gl.FUNC_REVERSE_SUBTRACT
                        };
                        this.glFormats = [
                            gl.BYTE,
                            gl.SHORT,
                            gl.UNSIGNED_BYTE,
                            gl.UNSIGNED_SHORT,
                            gl.FLOAT
                        ];
                        //  Set the gl function map
                        this.glFuncMap = {
                            mat2: {
                                func: gl.uniformMatrix2fv,
                                length: 1,
                                matrix: true
                            },
                            mat3: {
                                func: gl.uniformMatrix3fv,
                                length: 1,
                                matrix: true
                            },
                            mat4: {
                                func: gl.uniformMatrix4fv,
                                length: 1,
                                matrix: true
                            },
                            '1f': {
                                func: gl.uniform1f,
                                length: 1
                            },
                            '1fv': {
                                func: gl.uniform1fv,
                                length: 1
                            },
                            '1i': {
                                func: gl.uniform1i,
                                length: 1
                            },
                            '1iv': {
                                func: gl.uniform1iv,
                                length: 1
                            },
                            '2f': {
                                func: gl.uniform2f,
                                length: 2
                            },
                            '2fv': {
                                func: gl.uniform2fv,
                                length: 1
                            },
                            '2i': {
                                func: gl.uniform2i,
                                length: 2
                            },
                            '2iv': {
                                func: gl.uniform2iv,
                                length: 1
                            },
                            '3f': {
                                func: gl.uniform3f,
                                length: 3
                            },
                            '3fv': {
                                func: gl.uniform3fv,
                                length: 1
                            },
                            '3i': {
                                func: gl.uniform3i,
                                length: 3
                            },
                            '3iv': {
                                func: gl.uniform3iv,
                                length: 1
                            },
                            '4f': {
                                func: gl.uniform4f,
                                length: 4
                            },
                            '4fv': {
                                func: gl.uniform4fv,
                                length: 1
                            },
                            '4i': {
                                func: gl.uniform4i,
                                length: 4
                            },
                            '4iv': {
                                func: gl.uniform4iv,
                                length: 1
                            }
                        };
                        if (!config.maxTextures || config.maxTextures === -1) config.maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
                        if (!config.maxTextureSize) config.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
                        this.compression = this.getCompressedTextures();
                        //  Setup initial WebGL state
                        gl.disable(gl.DEPTH_TEST);
                        gl.disable(gl.CULL_FACE);
                        gl.enable(gl.BLEND);
                        gl.clearColor(clearColor.redGL, clearColor.greenGL, clearColor.blueGL, clearColor.alphaGL);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        //  Mipmaps
                        var validMipMaps = [
                            'NEAREST',
                            'LINEAR',
                            'NEAREST_MIPMAP_NEAREST',
                            'LINEAR_MIPMAP_NEAREST',
                            'NEAREST_MIPMAP_LINEAR',
                            'LINEAR_MIPMAP_LINEAR'
                        ];
                        if (validMipMaps.indexOf(config.mipmapFilter) !== -1) this.mipmapFilter = gl[config.mipmapFilter];
                        //  Check maximum supported textures
                        this.maxTextures = Utils.checkShaderMax(gl, config.maxTextures);
                        this.textureIndexes = [];
                        this.createTemporaryTextures();
                        this.pipelines = new PipelineManager(this);
                        this.setBlendMode(CONST.BlendModes.NORMAL);
                        this.projectionMatrix = new Matrix4().identity();
                        game.textures.once(TextureEvents.READY, this.boot, this);
                        return this;
                    },
                    /**
     * Internal boot handler. Calls 'boot' on each pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#boot
     * @private
     * @since 3.11.0
     */ boot: function() {
                        var game = this.game;
                        var pipelineManager = this.pipelines;
                        var baseSize = game.scale.baseSize;
                        var width = baseSize.width;
                        var height = baseSize.height;
                        this.width = width;
                        this.height = height;
                        this.isBooted = true;
                        this.renderTarget = new RenderTarget(this, width, height, 1, 0, true, true);
                        this.maskTarget = new RenderTarget(this, width, height, 1, 0, true, true);
                        this.maskSource = new RenderTarget(this, width, height, 1, 0, true, true);
                        //  Set-up pipelines
                        var config = game.config;
                        pipelineManager.boot(config.pipeline, config.defaultPipeline, config.autoMobilePipeline);
                        //  Set-up default textures, fbo and scissor
                        this.blankTexture = game.textures.getFrame('__DEFAULT').glTexture;
                        this.normalTexture = game.textures.getFrame('__NORMAL').glTexture;
                        this.whiteTexture = game.textures.getFrame('__WHITE').glTexture;
                        var gl = this.gl;
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.enable(gl.SCISSOR_TEST);
                        game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                        this.resize(width, height);
                    },
                    /**
     * Queries the GL context to get the supported extensions.
     *
     * Then sets them into the `supportedExtensions`, `instancedArraysExtension` and `vaoExtension` properties.
     *
     * Called automatically during the `init` method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setExtensions
     * @since 3.85.2
     */ setExtensions: function() {
                        var gl = this.gl;
                        var exts = gl.getSupportedExtensions();
                        this.supportedExtensions = exts;
                        var angleString = 'ANGLE_instanced_arrays';
                        this.instancedArraysExtension = exts.indexOf(angleString) > -1 ? gl.getExtension(angleString) : null;
                        var vaoString = 'OES_vertex_array_object';
                        this.vaoExtension = exts.indexOf(vaoString) > -1 ? gl.getExtension(vaoString) : null;
                    },
                    /**
     * Sets the handlers that are called when WebGL context is lost or restored by the browser.
     *
     * The default handlers are referenced via the properties `WebGLRenderer.contextLostHandler` and `WebGLRenderer.contextRestoredHandler`.
     * By default, these map to the methods `WebGLRenderer.dispatchContextLost` and `WebGLRenderer.dispatchContextRestored`.
     *
     * You can override these handlers with your own via this method.
     *
     * If you do override them, make sure that your handlers invoke the methods `WebGLRenderer.dispatchContextLost` and `WebGLRenderer.dispatchContextRestored` in due course, otherwise the renderer will not be able to restore itself fully.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setContextHandlers
     * @since 3.85.0
     *
     * @param {function} [contextLost] - Custom handler for responding to the WebGL context lost event. Set as `undefined` to use the default handler.
     * @param {function} [contextRestored] - Custom handler for responding to the WebGL context restored event. Set as `undefined` to use the default handler.
     */ setContextHandlers: function(contextLost, contextRestored) {
                        if (this.previousContextLostHandler) this.canvas.removeEventListener('webglcontextlost', this.previousContextLostHandler, false);
                        if (this.previousContextRestoredHandler) this.canvas.removeEventListener('webglcontextlost', this.previousContextRestoredHandler, false);
                        if (typeof contextLost === 'function') this.contextLostHandler = contextLost.bind(this);
                        else this.contextLostHandler = this.dispatchContextLost.bind(this);
                        if (typeof contextRestored === 'function') this.contextRestoredHandler = contextRestored.bind(this);
                        else this.contextRestoredHandler = this.dispatchContextRestored.bind(this);
                        this.canvas.addEventListener('webglcontextlost', this.contextLostHandler, false);
                        this.canvas.addEventListener('webglcontextrestored', this.contextRestoredHandler, false);
                        this.previousContextLostHandler = this.contextLostHandler;
                        this.previousContextRestoredHandler = this.contextRestoredHandler;
                    },
                    /**
     * This method is called when the WebGL context is lost. By default this is bound to the property `WebGLRenderer.contextLostHandler`.
     * If you override the context loss handler via the `setContextHandlers` method then be sure to invoke this method in due course.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#dispatchContextLost
     * @since 3.85.0
     *
     * @param {WebGLContextEvent } event - The WebGL context lost Event.
     */ dispatchContextLost: function(event) {
                        this.contextLost = true;
                        if (console) console.warn('WebGL Context lost. Renderer disabled');
                        this.emit(Events.LOSE_WEBGL, this);
                        event.preventDefault();
                    },
                    /**
     * This method is called when the WebGL context is restored. By default this is bound to the property `WebGLRenderer.contextRestoredHandler`.
     * If you override the context restored handler via the `setContextHandlers` method then be sure to invoke this method in due course.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#dispatchContextRestored
     * @since 3.85.0
     *
     * @param {WebGLContextEvent } event - The WebGL context restored Event.
     */ dispatchContextRestored: function(event) {
                        var gl = this.gl;
                        if (gl.isContextLost()) {
                            if (console) console.log('WebGL Context restored, but context is still lost');
                            return;
                        }
                        // Clear "current" settings so they can be set again.
                        this.currentProgram = null;
                        this.currentFramebuffer = null;
                        this.setBlendMode(CONST.BlendModes.NORMAL);
                        // Settings we DON'T need to reset:
                        // Scissor is set during preRender.
                        // Mask is set during preRender.
                        // Camera mask is set during preRenderCamera.
                        // Restore GL flags.
                        gl.disable(gl.BLEND);
                        gl.disable(gl.DEPTH_TEST);
                        gl.enable(gl.CULL_FACE);
                        // Re-enable compressed texture formats.
                        this.compression = this.getCompressedTextures();
                        // Restore wrapped GL objects.
                        // Order matters, as some wrappers depend on others.
                        var wrapperCreateResource = function(wrapper) {
                            wrapper.createResource();
                        };
                        ArrayEach(this.glTextureWrappers, wrapperCreateResource);
                        ArrayEach(this.glBufferWrappers, wrapperCreateResource);
                        ArrayEach(this.glFramebufferWrappers, wrapperCreateResource);
                        ArrayEach(this.glProgramWrappers, wrapperCreateResource);
                        ArrayEach(this.glAttribLocationWrappers, wrapperCreateResource);
                        ArrayEach(this.glUniformLocationWrappers, wrapperCreateResource);
                        // Create temporary textures.
                        this.createTemporaryTextures();
                        // Restore pipelines.
                        this.pipelines.restoreContext();
                        // Apply resize.
                        this.resize(this.game.scale.baseSize.width, this.game.scale.baseSize.height);
                        // Restore GL extensions.
                        this.setExtensions();
                        // Context has been restored.
                        this.contextLost = false;
                        if (console) console.warn('WebGL Context restored. Renderer running again.');
                        this.emit(Events.RESTORE_WEBGL, this);
                        event.preventDefault();
                    },
                    /**
     * Create temporary WebGL textures to stop WebGL errors on macOS.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTemporaryTextures
     * @since 3.60.0
     */ createTemporaryTextures: function() {
                        var gl = this.gl;
                        for(var index = 0; index < this.maxTextures; index++){
                            var tempTexture = gl.createTexture();
                            gl.activeTexture(gl.TEXTURE0 + index);
                            gl.bindTexture(gl.TEXTURE_2D, tempTexture);
                            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([
                                0,
                                0,
                                255,
                                255
                            ]));
                            this.textureIndexes.push(index);
                        }
                    },
                    /**
     * This method is only available in the Debug Build of Phaser, or a build with the
     * `WEBGL_DEBUG` flag set in the Webpack Config.
     *
     * Phaser v3.60 Debug has a build of Spector.js embedded in it, which is a WebGL inspector
     * that allows for live inspection of your WebGL calls. Although it's easy to add the Spector
     * extension to a desktop browsr, by embedding it in Phaser we can make it available in mobile
     * browsers too, making it a powerful tool for debugging WebGL games on mobile devices where
     * extensions are not permitted.
     *
     * See https://github.com/BabylonJS/Spector.js for more details.
     *
     * This method will capture the current WebGL frame and send it to the Spector.js tool for inspection.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#captureFrame
     * @since 3.60.0
     *
     * @param {boolean} [quickCapture=false] - If `true` thumbnails are not captured in order to speed up the capture.
     * @param {boolean} [fullCapture=false] - If `true` all details are captured.
     */ captureFrame: function(quickCapture, fullCapture) {
                        if (quickCapture === undefined) quickCapture = false;
                        if (fullCapture === undefined) fullCapture = false;
                        if (DEBUG && this.spector && !this._debugCapture) {
                            this.spector.captureCanvas(this.canvas, 0, quickCapture, fullCapture);
                            this._debugCapture = true;
                        }
                    },
                    /**
     * This method is only available in the Debug Build of Phaser, or a build with the
     * `WEBGL_DEBUG` flag set in the Webpack Config.
     *
     * Phaser v3.60 Debug has a build of Spector.js embedded in it, which is a WebGL inspector
     * that allows for live inspection of your WebGL calls. Although it's easy to add the Spector
     * extension to a desktop browsr, by embedding it in Phaser we can make it available in mobile
     * browsers too, making it a powerful tool for debugging WebGL games on mobile devices where
     * extensions are not permitted.
     *
     * See https://github.com/BabylonJS/Spector.js for more details.
     *
     * This method will capture the next WebGL frame and send it to the Spector.js tool for inspection.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#captureNextFrame
     * @since 3.60.0
     */ captureNextFrame: function() {
                        if (DEBUG && this.spector && !this._debugCapture) {
                            this._debugCapture = true;
                            this.spector.captureNextFrame(this.canvas);
                        }
                    },
                    /**
     * This method is only available in the Debug Build of Phaser, or a build with the
     * `WEBGL_DEBUG` flag set in the Webpack Config.
     *
     * Phaser v3.60 Debug has a build of Spector.js embedded in it, which is a WebGL inspector
     * that allows for live inspection of your WebGL calls. Although it's easy to add the Spector
     * extension to a desktop browsr, by embedding it in Phaser we can make it available in mobile
     * browsers too, making it a powerful tool for debugging WebGL games on mobile devices where
     * extensions are not permitted.
     *
     * See https://github.com/BabylonJS/Spector.js for more details.
     *
     * This method will return the current FPS of the WebGL canvas.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getFps
     * @since 3.60.0
     *
     * @return {number} The current FPS of the WebGL canvas.
     */ getFps: function() {
                        if (DEBUG && this.spector) return this.spector.getFps();
                    },
                    /**
     * This method is only available in the Debug Build of Phaser, or a build with the
     * `WEBGL_DEBUG` flag set in the Webpack Config.
     *
     * Phaser v3.60 Debug has a build of Spector.js embedded in it, which is a WebGL inspector
     * that allows for live inspection of your WebGL calls. Although it's easy to add the Spector
     * extension to a desktop browsr, by embedding it in Phaser we can make it available in mobile
     * browsers too, making it a powerful tool for debugging WebGL games on mobile devices where
     * extensions are not permitted.
     *
     * See https://github.com/BabylonJS/Spector.js for more details.
     *
     * This method adds a command with the name value in the list. This can be filtered in the search.
     * All logs can be filtered searching for "LOG".
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#log
     * @since 3.60.0
     *
     * @param {...*} arguments - The arguments to log to Spector.
     *
     * @return {string} The current log.
     */ log: function() {
                        if (DEBUG && this.spector) {
                            var t = Array.prototype.slice.call(arguments).join(' ');
                            return this.spector.log(t);
                        }
                    },
                    /**
     * This method is only available in the Debug Build of Phaser, or a build with the
     * `WEBGL_DEBUG` flag set in the Webpack Config.
     *
     * Phaser v3.60 Debug has a build of Spector.js embedded in it, which is a WebGL inspector
     * that allows for live inspection of your WebGL calls. Although it's easy to add the Spector
     * extension to a desktop browsr, by embedding it in Phaser we can make it available in mobile
     * browsers too, making it a powerful tool for debugging WebGL games on mobile devices where
     * extensions are not permitted.
     *
     * See https://github.com/BabylonJS/Spector.js for more details.
     *
     * This method will start a capture on the Phaser canvas. The capture will stop once it reaches
     * the number of commands specified as a parameter, or after 10 seconds. If quick capture is true,
     * the thumbnails are not captured in order to speed up the capture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#startCapture
     * @since 3.60.0
     *
     * @param {number} [commandCount=0] - The number of commands to capture. If zero it will capture for 10 seconds.
     * @param {boolean} [quickCapture=false] - If `true` thumbnails are not captured in order to speed up the capture.
     * @param {boolean} [fullCapture=false] - If `true` all details are captured.
     */ startCapture: function(commandCount, quickCapture, fullCapture) {
                        if (commandCount === undefined) commandCount = 0;
                        if (quickCapture === undefined) quickCapture = false;
                        if (fullCapture === undefined) fullCapture = false;
                        if (DEBUG && this.spector && !this._debugCapture) {
                            this.spector.startCapture(this.canvas, commandCount, quickCapture, fullCapture);
                            this._debugCapture = true;
                        }
                    },
                    /**
     * This method is only available in the Debug Build of Phaser, or a build with the
     * `WEBGL_DEBUG` flag set in the Webpack Config.
     *
     * Phaser v3.60 Debug has a build of Spector.js embedded in it, which is a WebGL inspector
     * that allows for live inspection of your WebGL calls. Although it's easy to add the Spector
     * extension to a desktop browsr, by embedding it in Phaser we can make it available in mobile
     * browsers too, making it a powerful tool for debugging WebGL games on mobile devices where
     * extensions are not permitted.
     *
     * See https://github.com/BabylonJS/Spector.js for more details.
     *
     * This method will stop the current capture and returns the result in JSON. It displays the
     * result if the UI has been displayed. This returns undefined if the capture has not been completed
     * or did not find any commands.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#stopCapture
     * @since 3.60.0
     *
     * @return {object} The current capture.
     */ stopCapture: function() {
                        if (DEBUG && this.spector && this._debugCapture) return this.spector.stopCapture();
                    },
                    /**
     * This method is only available in the Debug Build of Phaser, or a build with the
     * `WEBGL_DEBUG` flag set in the Webpack Config.
     *
     * Internal onCapture handler.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#onCapture
     * @private
     * @since 3.60.0
     *
     * @param {object} capture - The capture data.
     */ onCapture: function(capture) {
                        if (DEBUG) {
                            var view = this.spector.getResultUI();
                            view.display(capture);
                            this._debugCapture = false;
                        }
                    },
                    /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#onResize
     * @since 3.16.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize) {
                        //  Has the underlying canvas size changed?
                        if (baseSize.width !== this.width || baseSize.height !== this.height) this.resize(baseSize.width, baseSize.height);
                    },
                    /**
     * Binds the WebGL Renderers Render Target, so all drawn content is now redirected to it.
     *
     * Make sure to call `endCapture` when you are finished.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#beginCapture
     * @since 3.50.0
     *
     * @param {number} [width] - Optional new width of the Render Target.
     * @param {number} [height] - Optional new height of the Render Target.
     */ beginCapture: function(width, height) {
                        if (width === undefined) width = this.width;
                        if (height === undefined) height = this.height;
                        this.renderTarget.bind(true, width, height);
                        this.setProjectionMatrix(width, height);
                    },
                    /**
     * Unbinds the WebGL Renderers Render Target and returns it, stopping any further content being drawn to it.
     *
     * If the viewport or scissors were modified during the capture, you should reset them by calling
     * `resetViewport` and `resetScissor` accordingly.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#endCapture
     * @since 3.50.0
     *
     * @return {Phaser.Renderer.WebGL.RenderTarget} A reference to the WebGL Renderer Render Target.
     */ endCapture: function() {
                        this.renderTarget.unbind(true);
                        this.resetProjectionMatrix();
                        return this.renderTarget;
                    },
                    /**
     * Resizes the drawing buffer to match that required by the Scale Manager.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resize
     * @fires Phaser.Renderer.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} [width] - The new width of the renderer.
     * @param {number} [height] - The new height of the renderer.
     *
     * @return {this} This WebGLRenderer instance.
     */ resize: function(width, height) {
                        var gl = this.gl;
                        this.width = width;
                        this.height = height;
                        this.setProjectionMatrix(width, height);
                        gl.viewport(0, 0, width, height);
                        this.drawingBufferHeight = gl.drawingBufferHeight;
                        gl.scissor(0, gl.drawingBufferHeight - height, width, height);
                        this.defaultScissor[2] = width;
                        this.defaultScissor[3] = height;
                        this.emit(Events.RESIZE, width, height);
                        return this;
                    },
                    /**
     * Determines which compressed texture formats this browser and device supports.
     *
     * Called automatically as part of the WebGL Renderer init process. If you need to investigate
     * which formats it supports, see the `Phaser.Renderer.WebGL.WebGLRenderer#compression` property instead.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getCompressedTextures
     * @since 3.60.0
     *
     * @return {Phaser.Types.Renderer.WebGL.WebGLTextureCompression} The compression object.
     */ getCompressedTextures: function() {
                        var extString = 'WEBGL_compressed_texture_';
                        var wkExtString = 'WEBKIT_' + extString;
                        var extEXTString = 'EXT_texture_compression_';
                        var hasExt = function(gl, format) {
                            var results = gl.getExtension(extString + format) || gl.getExtension(wkExtString + format) || gl.getExtension(extEXTString + format);
                            if (results) {
                                var glEnums = {};
                                for(var key in results)glEnums[results[key]] = key;
                                return glEnums;
                            }
                        };
                        var gl = this.gl;
                        return {
                            ETC: hasExt(gl, 'etc'),
                            ETC1: hasExt(gl, 'etc1'),
                            ATC: hasExt(gl, 'atc'),
                            ASTC: hasExt(gl, 'astc'),
                            BPTC: hasExt(gl, 'bptc'),
                            RGTC: hasExt(gl, 'rgtc'),
                            PVRTC: hasExt(gl, 'pvrtc'),
                            S3TC: hasExt(gl, 's3tc'),
                            S3TCSRGB: hasExt(gl, 's3tc_srgb'),
                            IMG: true
                        };
                    },
                    /**
     * Returns a compressed texture format GLenum name based on the given format.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getCompressedTextureName
     * @since 3.60.0
     *
     * @param {string} baseFormat - The Base Format to check.
     * @param {GLenum} [format] - An optional GLenum format to check within the base format.
     *
     * @return {string} The compressed texture format name, as a string.
     */ getCompressedTextureName: function(baseFormat, format) {
                        var supportedFormats = this.compression[baseFormat.toUpperCase()];
                        if (format in supportedFormats) return supportedFormats[format];
                    },
                    /**
     * Checks if the given compressed texture format is supported, or not.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#supportsCompressedTexture
     * @since 3.60.0
     *
     * @param {string} baseFormat - The Base Format to check.
     * @param {GLenum} [format] - An optional GLenum format to check within the base format.
     *
     * @return {boolean} True if the format is supported, otherwise false.
     */ supportsCompressedTexture: function(baseFormat, format) {
                        var supportedFormats = this.compression[baseFormat.toUpperCase()];
                        if (supportedFormats) {
                            if (format) return format in supportedFormats;
                            else return true;
                        }
                        return false;
                    },
                    /**
     * Gets the aspect ratio of the WebGLRenderer dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getAspectRatio
     * @since 3.50.0
     *
     * @return {number} The aspect ratio of the WebGLRenderer dimensions.
     */ getAspectRatio: function() {
                        return this.width / this.height;
                    },
                    /**
     * Sets the Projection Matrix of this renderer to the given dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setProjectionMatrix
     * @since 3.50.0
     *
     * @param {number} width - The new width of the Projection Matrix.
     * @param {number} height - The new height of the Projection Matrix.
     *
     * @return {this} This WebGLRenderer instance.
     */ setProjectionMatrix: function(width, height) {
                        if (width !== this.projectionWidth || height !== this.projectionHeight) {
                            this.projectionWidth = width;
                            this.projectionHeight = height;
                            this.projectionMatrix.ortho(0, width, height, 0, -1000, 1000);
                        }
                        return this;
                    },
                    /**
     * Resets the Projection Matrix back to this renderers width and height.
     *
     * This is called during `endCapture`, should the matrix have been changed
     * as a result of the capture process.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetProjectionMatrix
     * @since 3.50.0
     *
     * @return {this} This WebGLRenderer instance.
     */ resetProjectionMatrix: function() {
                        return this.setProjectionMatrix(this.width, this.height);
                    },
                    /**
     * Checks if a WebGL extension is supported
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasExtension
     * @since 3.0.0
     *
     * @param {string} extensionName - Name of the WebGL extension
     *
     * @return {boolean} `true` if the extension is supported, otherwise `false`.
     */ hasExtension: function(extensionName) {
                        return this.supportedExtensions ? this.supportedExtensions.indexOf(extensionName) : false;
                    },
                    /**
     * Loads a WebGL extension
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getExtension
     * @since 3.0.0
     *
     * @param {string} extensionName - The name of the extension to load.
     *
     * @return {object} WebGL extension if the extension is supported
     */ getExtension: function(extensionName) {
                        if (!this.hasExtension(extensionName)) return null;
                        if (!(extensionName in this.extensions)) this.extensions[extensionName] = this.gl.getExtension(extensionName);
                        return this.extensions[extensionName];
                    },
                    /**
     * Flushes the current pipeline if the pipeline is bound
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#flush
     * @since 3.0.0
     */ flush: function() {
                        this.pipelines.flush();
                    },
                    /**
     * Pushes a new scissor state. This is used to set nested scissor states.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#pushScissor
     * @since 3.0.0
     *
     * @param {number} x - The x position of the scissor.
     * @param {number} y - The y position of the scissor.
     * @param {number} width - The width of the scissor.
     * @param {number} height - The height of the scissor.
     * @param {number} [drawingBufferHeight] - Optional drawingBufferHeight override value.
     *
     * @return {number[]} An array containing the scissor values.
     */ pushScissor: function(x, y, width, height, drawingBufferHeight) {
                        if (drawingBufferHeight === undefined) drawingBufferHeight = this.drawingBufferHeight;
                        var scissorStack = this.scissorStack;
                        var scissor = [
                            x,
                            y,
                            width,
                            height
                        ];
                        scissorStack.push(scissor);
                        this.setScissor(x, y, width, height, drawingBufferHeight);
                        this.currentScissor = scissor;
                        return scissor;
                    },
                    /**
     * Sets the current scissor state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setScissor
     * @since 3.0.0
     *
     * @param {number} x - The x position of the scissor.
     * @param {number} y - The y position of the scissor.
     * @param {number} width - The width of the scissor.
     * @param {number} height - The height of the scissor.
     * @param {number} [drawingBufferHeight] - Optional drawingBufferHeight override value.
     */ setScissor: function(x, y, width, height, drawingBufferHeight) {
                        if (drawingBufferHeight === undefined) drawingBufferHeight = this.drawingBufferHeight;
                        var gl = this.gl;
                        var current = this.currentScissor;
                        var setScissor = width > 0 && height > 0;
                        if (current && setScissor) {
                            var cx = current[0];
                            var cy = current[1];
                            var cw = current[2];
                            var ch = current[3];
                            setScissor = cx !== x || cy !== y || cw !== width || ch !== height;
                        }
                        if (setScissor) {
                            this.flush();
                            // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/scissor
                            gl.scissor(x, drawingBufferHeight - y - height, width, height);
                        }
                    },
                    /**
     * Resets the gl scissor state to be whatever the current scissor is, if there is one, without
     * modifying the scissor stack.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetScissor
     * @since 3.50.0
     */ resetScissor: function() {
                        var gl = this.gl;
                        gl.enable(gl.SCISSOR_TEST);
                        var current = this.currentScissor;
                        if (current) {
                            var x = current[0];
                            var y = current[1];
                            var width = current[2];
                            var height = current[3];
                            if (width > 0 && height > 0) gl.scissor(x, this.drawingBufferHeight - y - height, width, height);
                        }
                    },
                    /**
     * Pops the last scissor state and sets it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#popScissor
     * @since 3.0.0
     */ popScissor: function() {
                        var scissorStack = this.scissorStack;
                        //  Remove the current scissor
                        scissorStack.pop();
                        //  Reset the previous scissor
                        var scissor = scissorStack[scissorStack.length - 1];
                        if (scissor) this.setScissor(scissor[0], scissor[1], scissor[2], scissor[3]);
                        this.currentScissor = scissor;
                    },
                    /**
     * Is there an active stencil mask?
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasActiveStencilMask
     * @since 3.17.0
     *
     * @return {boolean} `true` if there is an active stencil mask, otherwise `false`.
     */ hasActiveStencilMask: function() {
                        var mask = this.currentMask.mask;
                        var camMask = this.currentCameraMask.mask;
                        return mask && mask.isStencil || camMask && camMask.isStencil;
                    },
                    /**
     * Resets the gl viewport to the current renderer dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetViewport
     * @since 3.50.0
     */ resetViewport: function() {
                        var gl = this.gl;
                        gl.viewport(0, 0, this.width, this.height);
                        this.drawingBufferHeight = gl.drawingBufferHeight;
                    },
                    /**
     * Sets the blend mode to the value given.
     *
     * If the current blend mode is different from the one given, the pipeline is flushed and the new
     * blend mode is enabled.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setBlendMode
     * @since 3.0.0
     *
     * @param {number} blendModeId - The blend mode to be set. Can be a `BlendModes` const or an integer value.
     * @param {boolean} [force=false] - Force the blend mode to be set, regardless of the currently set blend mode.
     *
     * @return {boolean} `true` if the blend mode was changed as a result of this call, forcing a flush, otherwise `false`.
     */ setBlendMode: function(blendModeId, force) {
                        if (force === undefined) force = false;
                        var gl = this.gl;
                        var blendMode = this.blendModes[blendModeId];
                        if (force || blendModeId !== CONST.BlendModes.SKIP_CHECK && this.currentBlendMode !== blendModeId) {
                            this.flush();
                            gl.enable(gl.BLEND);
                            gl.blendEquation(blendMode.equation);
                            if (blendMode.func.length > 2) gl.blendFuncSeparate(blendMode.func[0], blendMode.func[1], blendMode.func[2], blendMode.func[3]);
                            else gl.blendFunc(blendMode.func[0], blendMode.func[1]);
                            this.currentBlendMode = blendModeId;
                            return true;
                        }
                        return false;
                    },
                    /**
     * Creates a new custom blend mode for the renderer.
     *
     * See https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants#Blending_modes
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#addBlendMode
     * @since 3.0.0
     *
     * @param {GLenum[]} func - An array containing the WebGL functions to use for the source and the destination blending factors, respectively. See the possible constants for {@link WebGLRenderingContext#blendFunc()}.
     * @param {GLenum} equation - The equation to use for combining the RGB and alpha components of a new pixel with a rendered one. See the possible constants for {@link WebGLRenderingContext#blendEquation()}.
     *
     * @return {number} The index of the new blend mode, used for referencing it in the future.
     */ addBlendMode: function(func, equation) {
                        var index = this.blendModes.push({
                            func: func,
                            equation: equation
                        });
                        return index - 1;
                    },
                    /**
     * Updates the function bound to a given custom blend mode.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateBlendMode
     * @since 3.0.0
     *
     * @param {number} index - The index of the custom blend mode.
     * @param {function} func - The function to use for the blend mode.
     * @param {function} equation - The equation to use for the blend mode.
     *
     * @return {this} This WebGLRenderer instance.
     */ updateBlendMode: function(index, func, equation) {
                        if (this.blendModes[index]) {
                            this.blendModes[index].func = func;
                            if (equation) this.blendModes[index].equation = equation;
                        }
                        return this;
                    },
                    /**
     * Removes a custom blend mode from the renderer.
     * Any Game Objects still using this blend mode will error, so be sure to clear them first.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#removeBlendMode
     * @since 3.0.0
     *
     * @param {number} index - The index of the custom blend mode to be removed.
     *
     * @return {this} This WebGLRenderer instance.
     */ removeBlendMode: function(index) {
                        if (index > 17 && this.blendModes[index]) this.blendModes.splice(index, 1);
                        return this;
                    },
                    /**
     * Pushes a new framebuffer onto the FBO stack and makes it the currently bound framebuffer.
     *
     * If there was another framebuffer already bound it will force a pipeline flush.
     *
     * Call `popFramebuffer` to remove it again.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#pushFramebuffer
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper} framebuffer - The framebuffer that needs to be bound.
     * @param {boolean} [updateScissor=false] - Set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture=null] - Bind the given frame buffer texture?
     * @param {boolean} [clear=false] - Clear the frame buffer after binding?
     *
     * @return {this} This WebGLRenderer instance.
     */ pushFramebuffer: function(framebuffer, updateScissor, setViewport, texture, clear) {
                        if (framebuffer === this.currentFramebuffer) return this;
                        this.fboStack.push(framebuffer);
                        return this.setFramebuffer(framebuffer, updateScissor, setViewport, texture, clear);
                    },
                    /**
     * Sets the given framebuffer as the active and currently bound framebuffer.
     *
     * If there was another framebuffer already bound it will force a pipeline flush.
     *
     * Typically, you should call `pushFramebuffer` instead of this method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFramebuffer
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper|null)} framebuffer - The framebuffer that needs to be bound, or `null` to bind back to the default framebuffer.
     * @param {boolean} [updateScissor=false] - If a framebuffer is given, set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture=null] - Bind the given frame buffer texture?
     * @param {boolean} [clear=false] - Clear the frame buffer after binding?
     *
     * @return {this} This WebGLRenderer instance.
     */ setFramebuffer: function(framebuffer, updateScissor, setViewport, texture, clear) {
                        if (updateScissor === undefined) updateScissor = false;
                        if (setViewport === undefined) setViewport = true;
                        if (texture === undefined) texture = null;
                        if (clear === undefined) clear = false;
                        if (framebuffer === this.currentFramebuffer) return this;
                        var gl = this.gl;
                        var width = this.width;
                        var height = this.height;
                        if (framebuffer && framebuffer.renderTexture && setViewport) {
                            width = framebuffer.renderTexture.width;
                            height = framebuffer.renderTexture.height;
                        } else this.flush();
                        if (framebuffer) gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer.webGLFramebuffer);
                        else gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        if (setViewport) gl.viewport(0, 0, width, height);
                        if (texture) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture.webGLTexture, 0);
                        if (clear) {
                            gl.clearColor(0, 0, 0, 0);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                        if (updateScissor) {
                            if (framebuffer) {
                                this.drawingBufferHeight = height;
                                this.pushScissor(0, 0, width, height);
                            } else {
                                this.drawingBufferHeight = this.height;
                                this.popScissor();
                            }
                        }
                        this.currentFramebuffer = framebuffer;
                        return this;
                    },
                    /**
     * Pops the previous framebuffer from the fbo stack and sets it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#popFramebuffer
     * @since 3.50.0
     *
     * @param {boolean} [updateScissor=false] - If a framebuffer is given, set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper} The Framebuffer that was set, or `null` if there aren't any more in the stack.
     */ popFramebuffer: function(updateScissor, setViewport) {
                        if (updateScissor === undefined) updateScissor = false;
                        if (setViewport === undefined) setViewport = true;
                        var fboStack = this.fboStack;
                        //  Remove the current fbo
                        fboStack.pop();
                        //  Reset the previous framebuffer
                        var framebuffer = fboStack[fboStack.length - 1];
                        if (!framebuffer) framebuffer = null;
                        this.setFramebuffer(framebuffer, updateScissor, setViewport);
                        return framebuffer;
                    },
                    /**
     * Restores the previous framebuffer from the fbo stack and sets it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#restoreFramebuffer
     * @since 3.60.0
     *
     * @param {boolean} [updateScissor=false] - If a framebuffer is given, set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     */ restoreFramebuffer: function(updateScissor, setViewport) {
                        if (updateScissor === undefined) updateScissor = false;
                        if (setViewport === undefined) setViewport = true;
                        var fboStack = this.fboStack;
                        var framebuffer = fboStack[fboStack.length - 1];
                        if (!framebuffer) framebuffer = null;
                        this.currentFramebuffer = null;
                        this.setFramebuffer(framebuffer, updateScissor, setViewport);
                    },
                    /**
     * Binds a shader program.
     *
     * If there was a different program already bound it will force a pipeline flush first.
     *
     * If the same program given to this method is already set as the current program, no change
     * will take place and this method will return `false`.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setProgram
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper} program - The program that needs to be bound.
     *
     * @return {boolean} `true` if the given program was bound, otherwise `false`.
     */ setProgram: function(program) {
                        if (program !== this.currentProgram) {
                            this.flush();
                            this.gl.useProgram(program.webGLProgram);
                            this.currentProgram = program;
                            return true;
                        }
                        return false;
                    },
                    /**
     * Rebinds whatever program `WebGLRenderer.currentProgram` is set as, without
     * changing anything, or flushing.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetProgram
     * @since 3.50.0
     *
     * @return {this} This WebGLRenderer instance.
     */ resetProgram: function() {
                        this.gl.useProgram(this.currentProgram.webGLProgramWrapper);
                        return this;
                    },
                    /**
     * Creates a texture from an image source. If the source is not valid it creates an empty texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTextureFromSource
     * @since 3.0.0
     *
     * @param {object} source - The source of the texture.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {number} scaleMode - The scale mode to be used by the texture.
     * @param {boolean} [forceClamp=false] - Force the texture to use the CLAMP_TO_EDGE wrap mode, even if a power of two?
     *
     * @return {?Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The WebGLTextureWrapper that was created, or `null` if it couldn't be created.
     */ createTextureFromSource: function(source, width, height, scaleMode, forceClamp) {
                        if (forceClamp === undefined) forceClamp = false;
                        var gl = this.gl;
                        var minFilter = gl.NEAREST;
                        var magFilter = gl.NEAREST;
                        var wrap = gl.CLAMP_TO_EDGE;
                        var texture = null;
                        width = source ? source.width : width;
                        height = source ? source.height : height;
                        var pow = IsSizePowerOfTwo(width, height);
                        if (pow && !forceClamp) wrap = gl.REPEAT;
                        if (scaleMode === CONST.ScaleModes.LINEAR && this.config.antialias) {
                            var isCompressed = source && source.compressed;
                            var isMip = !isCompressed && pow || isCompressed && source.mipmaps.length > 1;
                            // Filters above LINEAR only work with MIPmaps.
                            // These are only generated for power of two (POT) textures.
                            // Compressed textures with mipmaps are always POT,
                            // but POT compressed textures might not have mipmaps.
                            minFilter = this.mipmapFilter && isMip ? this.mipmapFilter : gl.LINEAR;
                            magFilter = gl.LINEAR;
                        }
                        if (!source && typeof width === 'number' && typeof height === 'number') texture = this.createTexture2D(0, minFilter, magFilter, wrap, wrap, gl.RGBA, null, width, height);
                        else texture = this.createTexture2D(0, minFilter, magFilter, wrap, wrap, gl.RGBA, source);
                        return texture;
                    },
                    /**
     * A wrapper for creating a WebGLTextureWrapper. If no pixel data is passed it will create an empty texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTexture2D
     * @since 3.0.0
     *
     * @param {number} mipLevel - Mip level of the texture.
     * @param {number} minFilter - Filtering of the texture.
     * @param {number} magFilter - Filtering of the texture.
     * @param {number} wrapT - Wrapping mode of the texture.
     * @param {number} wrapS - Wrapping mode of the texture.
     * @param {number} format - Which format does the texture use.
     * @param {?object} pixels - pixel data.
     * @param {?number} width - Width of the texture in pixels. If not supplied, it must be derived from `pixels`.
     * @param {?number} height - Height of the texture in pixels. If not supplied, it must be derived from `pixels`.
     * @param {boolean} [pma=true] - Does the texture have premultiplied alpha?
     * @param {boolean} [forceSize=false] - If `true` it will use the width and height passed to this method, regardless of the pixels dimension.
     * @param {boolean} [flipY=false] - Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The WebGLTextureWrapper that was created.
     */ createTexture2D: function(mipLevel, minFilter, magFilter, wrapT, wrapS, format, pixels, width, height, pma, forceSize, flipY) {
                        if (typeof width !== 'number') width = pixels ? pixels.width : 1;
                        if (typeof height !== 'number') height = pixels ? pixels.height : 1;
                        var texture = new WebGLTextureWrapper(this.gl, mipLevel, minFilter, magFilter, wrapT, wrapS, format, pixels, width, height, pma, forceSize, flipY);
                        this.glTextureWrappers.push(texture);
                        return texture;
                    },
                    /**
     * Creates a WebGL Framebuffer object and optionally binds a depth stencil render buffer.
     *
     * This will unbind any currently bound framebuffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createFramebuffer
     * @since 3.0.0
     *
     * @param {number} width - If `addDepthStencilBuffer` is true, this controls the width of the depth stencil.
     * @param {number} height - If `addDepthStencilBuffer` is true, this controls the height of the depth stencil.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} renderTexture - The color texture where the color pixels are written.
     * @param {boolean} [addDepthStencilBuffer=false] - Create a Renderbuffer for the depth stencil?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper} Wrapped framebuffer which is safe to use with the renderer.
     */ createFramebuffer: function(width, height, renderTexture, addDepthStencilBuffer) {
                        this.currentFramebuffer = null;
                        var framebuffer = new WebGLFramebufferWrapper(this.gl, width, height, renderTexture, addDepthStencilBuffer);
                        this.glFramebufferWrappers.push(framebuffer);
                        return framebuffer;
                    },
                    /**
     * Binds necessary resources and renders the mask to a separated framebuffer.
     * The framebuffer for the masked object is also bound for further use.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#beginBitmapMask
     * @since 3.60.0
     *
     * @param {Phaser.Display.Masks.BitmapMask} mask - The BitmapMask instance that called beginMask.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the current mask.
     */ beginBitmapMask: function(bitmapMask, camera) {
                        var gl = this.gl;
                        if (gl) {
                            this.flush();
                            this.maskTarget.bind(true);
                            if (this.currentCameraMask.mask !== bitmapMask) {
                                this.currentMask.mask = bitmapMask;
                                this.currentMask.camera = camera;
                            }
                        }
                    },
                    /**
     * Binds necessary resources and renders the mask to a separated framebuffer.
     * The framebuffer for the masked object is also bound for further use.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#drawBitmapMask
     * @since 3.60.0
     *
     * @param {Phaser.Display.Masks.BitmapMask} mask - The BitmapMask instance that called beginMask.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the current mask.
     * @param {Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline} bitmapMaskPipeline - The BitmapMask Pipeline instance that is requesting the draw.
     */ drawBitmapMask: function(bitmapMask, camera, bitmapMaskPipeline) {
                        //  mask.mainFramebuffer should now contain all the Game Objects we want masked
                        this.flush();
                        this.maskSource.bind();
                        this.setBlendMode(0, true);
                        bitmapMask.renderWebGL(this, bitmapMask, camera);
                        this.maskSource.unbind(true);
                        this.maskTarget.unbind();
                        //  Is there a stencil further up the stack?
                        var gl = this.gl;
                        var prev = this.getCurrentStencilMask();
                        if (prev) {
                            gl.enable(gl.STENCIL_TEST);
                            prev.mask.applyStencil(this, prev.camera, true);
                        } else this.currentMask.mask = null;
                        //  Bind this pipeline and draw
                        this.pipelines.set(bitmapMaskPipeline);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, this.maskTarget.texture.webGLTexture);
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, this.maskSource.texture.webGLTexture);
                    },
                    /**
     * Creates a WebGLProgram instance based on the given vertex and fragment shader source.
     *
     * Then compiles, attaches and links the program before wrapping and returning it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createProgram
     * @since 3.0.0
     *
     * @param {string} vertexShader - The vertex shader source code as a single string.
     * @param {string} fragmentShader - The fragment shader source code as a single string.
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper} The wrapped, linked WebGLProgram created from the given shader source.
     */ createProgram: function(vertexShader, fragmentShader) {
                        var wrapper = new WebGLProgramWrapper(this.gl, vertexShader, fragmentShader);
                        this.glProgramWrappers.push(wrapper);
                        return wrapper;
                    },
                    /**
     * Wrapper for creating a vertex buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createVertexBuffer
     * @since 3.0.0
     *
     * @param {ArrayBuffer} initialDataOrSize - It's either ArrayBuffer or an integer indicating the size of the vbo
     * @param {number} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper} Wrapped vertex buffer
     */ createVertexBuffer: function(initialDataOrSize, bufferUsage) {
                        var gl = this.gl;
                        var vertexBuffer = new WebGLBufferWrapper(gl, initialDataOrSize, gl.ARRAY_BUFFER, bufferUsage);
                        this.glBufferWrappers.push(vertexBuffer);
                        return vertexBuffer;
                    },
                    /**
     * Creates a WebGLAttribLocationWrapper instance based on the given WebGLProgramWrapper and attribute name.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createAttribLocation
     * @since 3.80.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper} program - The WebGLProgramWrapper instance.
     * @param {string} name - The name of the attribute.
     */ createAttribLocation: function(program, name) {
                        var attrib = new WebGLAttribLocationWrapper(this.gl, program, name);
                        this.glAttribLocationWrappers.push(attrib);
                        return attrib;
                    },
                    /**
     * Creates a WebGLUniformLocationWrapper instance based on the given WebGLProgramWrapper and uniform name.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createUniformLocation
     * @since 3.80.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper} program - The WebGLProgramWrapper instance.
     * @param {string} name - The name of the uniform.
     */ createUniformLocation: function(program, name) {
                        var uniform = new WebGLUniformLocationWrapper(this.gl, program, name);
                        this.glUniformLocationWrappers.push(uniform);
                        return uniform;
                    },
                    /**
     * Wrapper for creating a vertex buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createIndexBuffer
     * @since 3.0.0
     *
     * @param {ArrayBuffer} initialDataOrSize - Either ArrayBuffer or an integer indicating the size of the vbo.
     * @param {number} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW.
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper} Wrapped index buffer
     */ createIndexBuffer: function(initialDataOrSize, bufferUsage) {
                        var gl = this.gl;
                        var indexBuffer = new WebGLBufferWrapper(gl, initialDataOrSize, gl.ELEMENT_ARRAY_BUFFER, bufferUsage);
                        this.glBufferWrappers.push(indexBuffer);
                        return indexBuffer;
                    },
                    /**
     * Removes a texture from the GPU.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteTexture
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - The WebGL Texture to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteTexture: function(texture) {
                        if (!texture) return;
                        ArrayRemove(this.glTextureWrappers, texture);
                        texture.destroy();
                        return this;
                    },
                    /**
     * Deletes a Framebuffer from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteFramebuffer
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper|null)} framebuffer - The Framebuffer to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteFramebuffer: function(framebuffer) {
                        if (!framebuffer) return this;
                        ArrayRemove(this.fboStack, framebuffer);
                        ArrayRemove(this.glFramebufferWrappers, framebuffer);
                        framebuffer.destroy();
                        return this;
                    },
                    /**
     * Deletes a WebGLProgram from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteProgram
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper} program - The shader program to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteProgram: function(program) {
                        if (program) {
                            ArrayRemove(this.glProgramWrappers, program);
                            program.destroy();
                        }
                        return this;
                    },
                    /**
     * Deletes a WebGLAttribLocation from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteAttribLocation
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper} attrib - The attrib location to be deleted.
     * @since 3.80.0
     */ deleteAttribLocation: function(attrib) {
                        if (attrib) {
                            ArrayRemove(this.glAttribLocationWrappers, attrib);
                            attrib.destroy();
                        }
                        return this;
                    },
                    /**
     * Deletes a WebGLUniformLocation from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteUniformLocation
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper} uniform - The uniform location to be deleted.
     * @since 3.80.0
     */ deleteUniformLocation: function(uniform) {
                        if (uniform) {
                            ArrayRemove(this.glUniformLocationWrappers, uniform);
                            uniform.destroy();
                        }
                        return this;
                    },
                    /**
     * Deletes a WebGLBuffer from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteBuffer
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper} vertexBuffer - The WebGLBuffer to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteBuffer: function(buffer) {
                        if (!buffer) return this;
                        ArrayRemove(this.glBufferWrappers, buffer);
                        buffer.destroy();
                        return this;
                    },
                    /**
     * Controls the pre-render operations for the given camera.
     * Handles any clipping needed by the camera and renders the background color if a color is visible.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRenderCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to pre-render.
     */ preRenderCamera: function(camera) {
                        var cx = camera.x;
                        var cy = camera.y;
                        var cw = camera.width;
                        var ch = camera.height;
                        var color = camera.backgroundColor;
                        camera.emit(CameraEvents.PRE_RENDER, camera);
                        this.pipelines.preBatchCamera(camera);
                        this.pushScissor(cx, cy, cw, ch);
                        if (camera.mask) {
                            this.currentCameraMask.mask = camera.mask;
                            this.currentCameraMask.camera = camera._maskCamera;
                            camera.mask.preRenderWebGL(this, camera, camera._maskCamera);
                        }
                        if (color.alphaGL > 0) {
                            var pipeline = this.pipelines.setMulti();
                            pipeline.drawFillRect(cx, cy, cw, ch, Utils.getTintFromFloats(color.blueGL, color.greenGL, color.redGL, 1), color.alphaGL);
                        }
                    },
                    /**
     * Return the current stencil mask.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getCurrentStencilMask
     * @private
     * @since 3.50.0
     */ getCurrentStencilMask: function() {
                        var prev = null;
                        var stack = this.maskStack;
                        var cameraMask = this.currentCameraMask;
                        if (stack.length > 0) prev = stack[stack.length - 1];
                        else if (cameraMask.mask && cameraMask.mask.isStencil) prev = cameraMask;
                        return prev;
                    },
                    /**
     * Controls the post-render operations for the given camera.
     *
     * Renders the foreground camera effects like flash and fading, then resets the current scissor state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRenderCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to post-render.
     */ postRenderCamera: function(camera) {
                        var flashEffect = camera.flashEffect;
                        var fadeEffect = camera.fadeEffect;
                        if (flashEffect.isRunning || fadeEffect.isRunning || fadeEffect.isComplete) {
                            var pipeline = this.pipelines.setMulti();
                            flashEffect.postRenderWebGL(pipeline, Utils.getTintFromFloats);
                            fadeEffect.postRenderWebGL(pipeline, Utils.getTintFromFloats);
                        }
                        camera.dirty = false;
                        this.popScissor();
                        if (camera.mask) {
                            this.currentCameraMask.mask = null;
                            camera.mask.postRenderWebGL(this, camera._maskCamera);
                        }
                        this.pipelines.postBatchCamera(camera);
                        camera.emit(CameraEvents.POST_RENDER, camera);
                    },
                    /**
     * Clears the current vertex buffer and updates pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRender
     * @fires Phaser.Renderer.Events#PRE_RENDER_CLEAR
     * @fires Phaser.Renderer.Events#PRE_RENDER
     * @since 3.0.0
     */ preRender: function() {
                        if (this.contextLost) return;
                        var gl = this.gl;
                        //  Make sure we are bound to the main frame buffer
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        this.emit(Events.PRE_RENDER_CLEAR);
                        if (this.config.clearBeforeRender) {
                            var clearColor = this.config.backgroundColor;
                            gl.clearColor(clearColor.redGL, clearColor.greenGL, clearColor.blueGL, clearColor.alphaGL);
                            gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
                        }
                        gl.enable(gl.SCISSOR_TEST);
                        this.currentScissor = this.defaultScissor;
                        this.scissorStack.length = 0;
                        this.scissorStack.push(this.currentScissor);
                        if (this.game.scene.customViewports) gl.scissor(0, this.drawingBufferHeight - this.height, this.width, this.height);
                        this.currentMask.mask = null;
                        this.currentCameraMask.mask = null;
                        this.maskStack.length = 0;
                        this.emit(Events.PRE_RENDER);
                    },
                    /**
     * The core render step for a Scene Camera.
     *
     * Iterates through the given array of Game Objects and renders them with the given Camera.
     *
     * This is called by the `CameraManager.render` method. The Camera Manager instance belongs to a Scene, and is invoked
     * by the Scene Systems.render method.
     *
     * This method is not called if `Camera.visible` is `false`, or `Camera.alpha` is zero.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#render
     * @fires Phaser.Renderer.Events#RENDER
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to render.
     * @param {Phaser.GameObjects.GameObject[]} children - An array of filtered Game Objects that can be rendered by the given Camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera to render with.
     */ render: function(scene, children, camera) {
                        if (this.contextLost) return;
                        var childCount = children.length;
                        this.emit(Events.RENDER, scene, camera);
                        //   Apply scissor for cam region + render background color, if not transparent
                        this.preRenderCamera(camera);
                        //  Nothing to render, so bail out
                        if (childCount === 0) {
                            this.setBlendMode(CONST.BlendModes.NORMAL);
                            //  Applies camera effects and pops the scissor, if set
                            this.postRenderCamera(camera);
                            return;
                        }
                        //  Reset the current type
                        this.currentType = '';
                        var current = this.currentMask;
                        for(var i = 0; i < childCount; i++){
                            this.finalType = i === childCount - 1;
                            var child = children[i];
                            var mask = child.mask;
                            current = this.currentMask;
                            if (current.mask && current.mask !== mask) //  Render out the previously set mask
                            current.mask.postRenderWebGL(this, current.camera);
                            if (mask && current.mask !== mask) mask.preRenderWebGL(this, child, camera);
                            if (child.blendMode !== this.currentBlendMode) this.setBlendMode(child.blendMode);
                            var type = child.type;
                            if (type !== this.currentType) {
                                this.newType = true;
                                this.currentType = type;
                            }
                            if (!this.finalType) this.nextTypeMatch = children[i + 1].type === this.currentType;
                            else this.nextTypeMatch = false;
                            child.renderWebGL(this, child, camera);
                            this.newType = false;
                        }
                        current = this.currentMask;
                        if (current.mask) //  Render out the previously set mask, if it was the last item in the display list
                        current.mask.postRenderWebGL(this, current.camera);
                        this.setBlendMode(CONST.BlendModes.NORMAL);
                        //  Applies camera effects and pops the scissor, if set
                        this.postRenderCamera(camera);
                    },
                    /**
     * The post-render step happens after all Cameras in all Scenes have been rendered.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRender
     * @fires Phaser.Renderer.Events#POST_RENDER
     * @since 3.0.0
     */ postRender: function() {
                        if (this.contextLost) return;
                        this.flush();
                        this.emit(Events.POST_RENDER);
                        var state = this.snapshotState;
                        if (state.callback) {
                            WebGLSnapshot(this.gl, state);
                            state.callback = null;
                        }
                    },
                    /**
     * Disables the STENCIL_TEST but does not change the status
     * of the current stencil mask.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#clearStencilMask
     * @since 3.60.0
     */ clearStencilMask: function() {
                        this.gl.disable(this.gl.STENCIL_TEST);
                    },
                    /**
     * Restores the current stencil function to the one that was in place
     * before `clearStencilMask` was called.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#restoreStencilMask
     * @since 3.60.0
     */ restoreStencilMask: function() {
                        var gl = this.gl;
                        var current = this.getCurrentStencilMask();
                        if (current) {
                            var mask = current.mask;
                            gl.enable(gl.STENCIL_TEST);
                            //  colorMask + stencilOp(KEEP)
                            if (mask.invertAlpha) gl.stencilFunc(gl.NOTEQUAL, mask.level, 0xff);
                            else gl.stencilFunc(gl.EQUAL, mask.level, 0xff);
                        }
                    },
                    /**
     * Schedules a snapshot of the entire game viewport to be taken after the current frame is rendered.
     *
     * To capture a specific area see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshot: function(callback, type, encoderOptions) {
                        return this.snapshotArea(0, 0, this.gl.drawingBufferWidth, this.gl.drawingBufferHeight, callback, type, encoderOptions);
                    },
                    /**
     * Schedules a snapshot of the given area of the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotArea
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate to grab from. This is based on the game viewport, not the world.
     * @param {number} y - The y coordinate to grab from. This is based on the game viewport, not the world.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                        var state = this.snapshotState;
                        state.callback = callback;
                        state.type = type;
                        state.encoder = encoderOptions;
                        state.getPixel = false;
                        state.x = x;
                        state.y = y;
                        state.width = width;
                        state.height = height;
                        return this;
                    },
                    /**
     * Schedules a snapshot of the given pixel from the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific area, see `snapshotArea`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotArea`, for example, then
     * calling this method will override it.
     *
     * Unlike the other two snapshot methods, this one will return a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get. This is based on the game viewport, not the world.
     * @param {number} y - The y coordinate of the pixel to get. This is based on the game viewport, not the world.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotPixel: function(x, y, callback) {
                        this.snapshotArea(x, y, 1, 1, callback);
                        this.snapshotState.getPixel = true;
                        return this;
                    },
                    /**
     * Takes a snapshot of the given area of the given frame buffer.
     *
     * Unlike the other snapshot methods, this one is processed immediately and doesn't wait for the next render.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotFramebuffer
     * @since 3.19.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper} framebuffer - The framebuffer to grab from.
     * @param {number} bufferWidth - The width of the framebuffer.
     * @param {number} bufferHeight - The height of the framebuffer.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {boolean} [getPixel=false] - Grab a single pixel as a Color object, or an area as an Image object?
     * @param {number} [x=0] - The x coordinate to grab from. This is based on the framebuffer, not the world.
     * @param {number} [y=0] - The y coordinate to grab from. This is based on the framebuffer, not the world.
     * @param {number} [width=bufferWidth] - The width of the area to grab.
     * @param {number} [height=bufferHeight] - The height of the area to grab.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotFramebuffer: function(framebuffer, bufferWidth, bufferHeight, callback, getPixel, x, y, width, height, type, encoderOptions) {
                        if (getPixel === undefined) getPixel = false;
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = bufferWidth;
                        if (height === undefined) height = bufferHeight;
                        if (type === 'pixel') {
                            getPixel = true;
                            type = 'image/png';
                        }
                        var currentFramebuffer = this.currentFramebuffer;
                        this.snapshotArea(x, y, width, height, callback, type, encoderOptions);
                        var state = this.snapshotState;
                        state.getPixel = getPixel;
                        state.isFramebuffer = true;
                        state.bufferWidth = bufferWidth;
                        state.bufferHeight = bufferHeight;
                        //  Ensure they're not trying to grab an area larger than the framebuffer
                        state.width = Math.min(state.width, bufferWidth);
                        state.height = Math.min(state.height, bufferHeight);
                        this.setFramebuffer(framebuffer);
                        WebGLSnapshot(this.gl, state);
                        this.setFramebuffer(currentFramebuffer);
                        state.callback = null;
                        state.isFramebuffer = false;
                        return this;
                    },
                    /**
     * Creates a new WebGL Texture based on the given Canvas Element.
     *
     * If the `dstTexture` parameter is given, the WebGL Texture is updated, rather than created fresh.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#canvasToTexture
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to create the WebGL Texture from
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [dstTexture] - The destination WebGLTextureWrapper to set.
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT` (such as for Text objects?)
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The newly created, or updated, WebGLTextureWrapper.
     */ canvasToTexture: function(srcCanvas, dstTexture, noRepeat, flipY) {
                        if (noRepeat === undefined) noRepeat = false;
                        if (flipY === undefined) flipY = false;
                        var gl = this.gl;
                        var minFilter = gl.NEAREST;
                        var magFilter = gl.NEAREST;
                        var width = srcCanvas.width;
                        var height = srcCanvas.height;
                        var wrapping = gl.CLAMP_TO_EDGE;
                        var pow = IsSizePowerOfTwo(width, height);
                        if (!noRepeat && pow) wrapping = gl.REPEAT;
                        if (this.config.antialias) {
                            minFilter = pow && this.mipmapFilter ? this.mipmapFilter : gl.LINEAR;
                            magFilter = gl.LINEAR;
                        }
                        if (!dstTexture) return this.createTexture2D(0, minFilter, magFilter, wrapping, wrapping, gl.RGBA, srcCanvas, width, height, true, false, flipY);
                        else {
                            dstTexture.update(srcCanvas, width, height, flipY, wrapping, wrapping, minFilter, magFilter, dstTexture.format);
                            return dstTexture;
                        }
                    },
                    /**
     * Creates a new WebGL Texture based on the given Canvas Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createCanvasTexture
     * @since 3.20.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to create the WebGL Texture from.
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT` (such as for Text objects?)
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The newly created WebGLTextureWrapper.
     */ createCanvasTexture: function(srcCanvas, noRepeat, flipY) {
                        if (noRepeat === undefined) noRepeat = false;
                        if (flipY === undefined) flipY = false;
                        return this.canvasToTexture(srcCanvas, null, noRepeat, flipY);
                    },
                    /**
     * Updates a WebGL Texture based on the given Canvas Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateCanvasTexture
     * @since 3.20.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to update the WebGL Texture from.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} dstTexture - The destination WebGLTextureWrapper to update.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT` (such as for Text objects?)
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The updated WebGLTextureWrapper. This is the same wrapper object as `dstTexture`.
     */ updateCanvasTexture: function(srcCanvas, dstTexture, flipY, noRepeat) {
                        if (flipY === undefined) flipY = false;
                        if (noRepeat === undefined) noRepeat = false;
                        return this.canvasToTexture(srcCanvas, dstTexture, noRepeat, flipY);
                    },
                    /**
     * Creates or updates a WebGL Texture based on the given HTML Video Element.
     *
     * If the `dstTexture` parameter is given, the WebGL Texture is updated, rather than created fresh.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#videoToTexture
     * @since 3.85.0
     *
     * @param {HTMLVideoElement} srcVideo - The Video to create the WebGL Texture from
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [dstTexture] - The destination WebGLTextureWrapper to set.
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT`?
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The newly created, or updated, WebGLTextureWrapper.
     */ videoToTexture: function(srcVideo, dstTexture, noRepeat, flipY) {
                        if (noRepeat === undefined) noRepeat = false;
                        if (flipY === undefined) flipY = false;
                        var gl = this.gl;
                        var minFilter = gl.NEAREST;
                        var magFilter = gl.NEAREST;
                        var width = srcVideo.videoWidth;
                        var height = srcVideo.videoHeight;
                        var wrapping = gl.CLAMP_TO_EDGE;
                        var pow = IsSizePowerOfTwo(width, height);
                        if (!noRepeat && pow) wrapping = gl.REPEAT;
                        if (this.config.antialias) {
                            minFilter = pow && this.mipmapFilter ? this.mipmapFilter : gl.LINEAR;
                            magFilter = gl.LINEAR;
                        }
                        if (!dstTexture) return this.createTexture2D(0, minFilter, magFilter, wrapping, wrapping, gl.RGBA, srcVideo, width, height, true, true, flipY);
                        else {
                            dstTexture.update(srcVideo, width, height, flipY, wrapping, wrapping, minFilter, magFilter, dstTexture.format);
                            return dstTexture;
                        }
                    },
                    /**
     * Creates a new WebGL Texture based on the given HTML Video Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createVideoTexture
     * @since 3.20.0
     *
     * @param {HTMLVideoElement} srcVideo - The Video to create the WebGL Texture from
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT`?
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The newly created WebGLTextureWrapper.
     */ createVideoTexture: function(srcVideo, noRepeat, flipY) {
                        if (noRepeat === undefined) noRepeat = false;
                        if (flipY === undefined) flipY = false;
                        return this.videoToTexture(srcVideo, null, noRepeat, flipY);
                    },
                    /**
     * Updates a WebGL Texture based on the given HTML Video Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateVideoTexture
     * @since 3.20.0
     *
     * @param {HTMLVideoElement} srcVideo - The Video to update the WebGL Texture with.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} dstTexture - The destination WebGLTextureWrapper to update.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT`?
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The updated WebGLTextureWrapper. This is the same wrapper object as `dstTexture`.
     */ updateVideoTexture: function(srcVideo, dstTexture, flipY, noRepeat) {
                        if (flipY === undefined) flipY = false;
                        if (noRepeat === undefined) noRepeat = false;
                        return this.videoToTexture(srcVideo, dstTexture, noRepeat, flipY);
                    },
                    /**
     * Create a WebGLTexture from a Uint8Array.
     *
     * The Uint8Array is assumed to be RGBA values, one byte per color component.
     *
     * The texture will be filtered with `gl.NEAREST` and will not be mipped.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createUint8ArrayTexture
     * @since 3.80.0
     * @param {Uint8Array} data - The Uint8Array to create the texture from.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The newly created WebGLTextureWrapper.
     */ createUint8ArrayTexture: function(data, width, height) {
                        var gl = this.gl;
                        var minFilter = gl.NEAREST;
                        var magFilter = gl.NEAREST;
                        var wrap = gl.CLAMP_TO_EDGE;
                        var pow = IsSizePowerOfTwo(width, height);
                        if (pow) wrap = gl.REPEAT;
                        return this.createTexture2D(0, minFilter, magFilter, wrap, wrap, gl.RGBA, data, width, height);
                    },
                    /**
     * Sets the minification and magnification filter for a texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureFilter
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - The texture to set the filter for.
     * @param {number} filter - The filter to set. 0 for linear filtering, 1 for nearest neighbor (blocky) filtering.
     *
     * @return {this} This WebGL Renderer instance.
     */ setTextureFilter: function(texture, filter) {
                        var gl = this.gl;
                        var glFilter = filter === 0 ? gl.LINEAR : gl.NEAREST;
                        gl.activeTexture(gl.TEXTURE0);
                        var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                        gl.bindTexture(gl.TEXTURE_2D, texture.webGLTexture);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, glFilter);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, glFilter);
                        // Update wrapper.
                        texture.minFilter = glFilter;
                        texture.magFilter = glFilter;
                        if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                        return this;
                    },
                    /**
     * Returns the largest texture size (either width or height) that can be created.
     * Note that VRAM may not allow a texture of any given size, it just expresses
     * hardware / driver support for a given size.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getMaxTextureSize
     * @since 3.8.0
     *
     * @return {number} The maximum supported texture size.
     */ getMaxTextureSize: function() {
                        return this.config.maxTextureSize;
                    },
                    /**
     * Destroy this WebGLRenderer, cleaning up all related resources such as pipelines, native textures, etc.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.canvas.removeEventListener('webglcontextlost', this.contextLostHandler, false);
                        this.canvas.removeEventListener('webglcontextrestored', this.contextRestoredHandler, false);
                        var wrapperDestroy = function(wrapper) {
                            wrapper.destroy();
                        };
                        ArrayEach(this.glAttribLocationWrappers, wrapperDestroy);
                        ArrayEach(this.glBufferWrappers, wrapperDestroy);
                        ArrayEach(this.glFramebufferWrappers, wrapperDestroy);
                        ArrayEach(this.glProgramWrappers, wrapperDestroy);
                        ArrayEach(this.glTextureWrappers, wrapperDestroy);
                        ArrayEach(this.glUniformLocationWrappers, wrapperDestroy);
                        this.maskTarget.destroy();
                        this.maskSource.destroy();
                        this.pipelines.destroy();
                        this.removeAllListeners();
                        this.fboStack = [];
                        this.maskStack = [];
                        this.extensions = {};
                        this.textureIndexes = [];
                        this.gl = null;
                        this.game = null;
                        this.canvas = null;
                        this.contextLost = true;
                        this.currentMask = null;
                        this.currentCameraMask = null;
                        if (DEBUG) this.spector = null;
                    }
                });
                module1.exports = WebGLRenderer;
            /***/ },
            /***/ 38683: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var ArrayEach = __webpack_require__(95428);
                var GetFastValue = __webpack_require__(95540);
                var WEBGL_CONST = __webpack_require__(14500);
                /**
 * @classdesc
 * Instances of the WebGLShader class belong to the WebGL Pipeline classes. When the pipeline is
 * created it will create an instance of this class for each one of its shaders, as defined in
 * the pipeline configuration.
 *
 * This class encapsulates everything needed to manage a shader in a pipeline, including the
 * shader attributes and uniforms, as well as lots of handy methods such as `set2f`, for setting
 * uniform values on this shader.
 *
 * Typically, you do not create an instance of this class directly, as it works in unison with
 * the pipeline to which it belongs. You can gain access to this class via a pipeline's `shaders`
 * array, post-creation.
 *
 * @class WebGLShader
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGLPipeline to which this Shader belongs.
 * @param {string} name - The name of this Shader.
 * @param {string} vertexShader - The vertex shader source code as a single string.
 * @param {string} fragmentShader - The fragment shader source code as a single string.
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineAttributeConfig[]} attributes - An array of attributes.
 */ var WebGLShader = new Class({
                    initialize: function WebGLShader(pipeline, name, vertexShader, fragmentShader, attributes) {
                        /**
         * A reference to the WebGLPipeline that owns this Shader.
         *
         * A Shader class can only belong to a single pipeline.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#pipeline
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @since 3.50.0
         */ this.pipeline = pipeline;
                        /**
         * The name of this shader.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#name
         * @type {string}
         * @since 3.50.0
         */ this.name = name;
                        /**
         * A reference to the WebGLRenderer instance.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = pipeline.renderer;
                        /**
         * A reference to the WebGL Rendering Context the WebGL Renderer is using.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#gl
         * @type {WebGLRenderingContext}
         * @since 3.50.0
         */ this.gl = this.renderer.gl;
                        /**
         * The fragment shader source code.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#fragSrc
         * @type {string}
         * @since 3.60.0
         */ this.fragSrc = fragmentShader;
                        /**
         * The vertex shader source code.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#vertSrc
         * @type {string}
         * @since 3.60.0
         */ this.vertSrc = vertexShader;
                        /**
         * The WebGLProgram created from the vertex and fragment shaders.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#program
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper}
         * @since 3.50.0
         */ this.program = this.renderer.createProgram(vertexShader, fragmentShader);
                        /**
         * Array of objects that describe the vertex attributes.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#attributes
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineAttribute[]}
         * @since 3.50.0
         */ this.attributes;
                        /**
         * The amount of vertex attribute components of 32 bit length.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#vertexComponentCount
         * @type {number}
         * @since 3.50.0
         */ this.vertexComponentCount = 0;
                        /**
         * The size, in bytes, of a single vertex.
         *
         * This is derived by adding together all of the vertex attributes.
         *
         * For example, the Multi Pipeline has the following attributes:
         *
         * inPosition - (size 2 x gl.FLOAT) = 8
         * inTexCoord - (size 2 x gl.FLOAT) = 8
         * inTexId - (size 1 x gl.FLOAT) = 4
         * inTintEffect - (size 1 x gl.FLOAT) = 4
         * inTint - (size 4 x gl.UNSIGNED_BYTE) = 4
         *
         * The total, in this case, is 8 + 8 + 4 + 4 + 4 = 28.
         *
         * This is calculated automatically during the `createAttributes` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#vertexSize
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.vertexSize = 0;
                        /**
         * The active uniforms that this shader has.
         *
         * This is an object that maps the uniform names to their WebGL location and cached values.
         *
         * It is populated automatically via the `createUniforms` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#uniforms
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineUniformsConfig}
         * @since 3.50.0
         */ this.uniforms = {};
                        this.createAttributes(attributes);
                        this.createUniforms();
                    },
                    /**
     * Takes the vertex attributes config and parses it, creating the resulting array that is stored
     * in this shaders `attributes` property, calculating the offset, normalization and location
     * in the process.
     *
     * Calling this method resets `WebGLShader.attributes`, `WebGLShader.vertexSize` and
     * `WebGLShader.vertexComponentCount`.
     *
     * It is called automatically when this class is created, but can be called manually if required.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#createAttributes
     * @since 3.50.0
     *
     * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineAttributeConfig[]} attributes - An array of attributes configs.
     */ createAttributes: function(attributes) {
                        var count = 0;
                        var offset = 0;
                        var result = [];
                        this.vertexComponentCount = 0;
                        for(var i = 0; i < attributes.length; i++){
                            var element = attributes[i];
                            var name = element.name;
                            var size = GetFastValue(element, 'size', 1); // i.e. 1 for a float, 2 for a vec2, 4 for a vec4, etc
                            var glType = GetFastValue(element, 'type', WEBGL_CONST.FLOAT);
                            var type = glType.enum; // The GLenum
                            var typeSize = glType.size; // The size in bytes of the type
                            var normalized = element.normalized ? true : false;
                            result.push({
                                name: name,
                                size: size,
                                type: type,
                                normalized: normalized,
                                offset: offset,
                                enabled: false,
                                location: -1
                            });
                            if (typeSize === 4) count += size;
                            else count++;
                            offset += size * typeSize;
                        }
                        this.vertexSize = offset;
                        this.vertexComponentCount = count;
                        this.attributes = result;
                    },
                    /**
     * Sets the program this shader uses as being the active shader in the WebGL Renderer.
     *
     * This method is called every time the parent pipeline is made the current active pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#bind
     * @since 3.50.0
     *
     * @param {boolean} [setAttributes=false] - Should the vertex attribute pointers be set?
     * @param {boolean} [flush=false] - Flush the pipeline before binding this shader?
     *
     * @return {this} This WebGLShader instance.
     */ bind: function(setAttributes, flush) {
                        if (setAttributes === undefined) setAttributes = false;
                        if (flush === undefined) flush = false;
                        if (flush) this.pipeline.flush();
                        this.renderer.setProgram(this.program);
                        if (setAttributes) this.setAttribPointers();
                        return this;
                    },
                    /**
     * Sets the program this shader uses as being the active shader in the WebGL Renderer.
     *
     * Then resets all of the attribute pointers.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#rebind
     * @since 3.50.0
     *
     * @return {this} This WebGLShader instance.
     */ rebind: function() {
                        this.renderer.setProgram(this.program);
                        this.setAttribPointers(true);
                        return this;
                    },
                    /**
     * Sets the vertex attribute pointers.
     *
     * This should only be called after the vertex buffer has been bound.
     *
     * It is called automatically during the `bind` method.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setAttribPointers
     * @since 3.50.0
     *
     * @param {boolean} [reset=false] - Reset the vertex attribute locations?
     *
     * @return {this} This WebGLShader instance.
     */ setAttribPointers: function(reset) {
                        if (reset === undefined) reset = false;
                        var gl = this.gl;
                        var renderer = this.renderer;
                        var vertexSize = this.vertexSize;
                        var attributes = this.attributes;
                        var program = this.program;
                        for(var i = 0; i < attributes.length; i++){
                            var element = attributes[i];
                            var size = element.size;
                            var type = element.type;
                            var offset = element.offset;
                            var enabled = element.enabled;
                            var location = element.location;
                            var normalized = element.normalized ? true : false;
                            if (reset) {
                                if (location !== -1) renderer.deleteAttribLocation(location);
                                var attribLocation = this.renderer.createAttribLocation(program, element.name);
                                if (attribLocation.webGLAttribLocation >= 0) {
                                    gl.enableVertexAttribArray(attribLocation.webGLAttribLocation);
                                    gl.vertexAttribPointer(attribLocation.webGLAttribLocation, size, type, normalized, vertexSize, offset);
                                    element.enabled = true;
                                    element.location = attribLocation;
                                } else if (attribLocation.webGLAttribLocation !== -1) gl.disableVertexAttribArray(attribLocation.webGLAttribLocation);
                            } else if (enabled) gl.vertexAttribPointer(location.webGLAttribLocation, size, type, normalized, vertexSize, offset);
                            else if (!enabled && location !== -1 && location.webGLAttribLocation > -1) {
                                gl.disableVertexAttribArray(location.webGLAttribLocation);
                                element.location = -1;
                            }
                        }
                        return this;
                    },
                    /**
     * Sets up the `WebGLShader.uniforms` object, populating it with the names
     * and locations of the shader uniforms this shader requires.
     *
     * It works by first calling `gl.getProgramParameter(program.webGLProgram, gl.ACTIVE_UNIFORMS)` to
     * find out how many active uniforms this shader has. It then iterates through them,
     * calling `gl.getActiveUniform` to get the WebGL Active Info from each one. Finally,
     * the name and location are stored in the local array.
     *
     * This method is called automatically when this class is created.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#createUniforms
     * @since 3.50.0
     *
     * @return {this} This WebGLShader instance.
     */ createUniforms: function() {
                        var gl = this.gl;
                        var program = this.program;
                        var uniforms = this.uniforms;
                        var i;
                        var name;
                        var location;
                        //  Look-up all active uniforms
                        var totalUniforms = gl.getProgramParameter(program.webGLProgram, gl.ACTIVE_UNIFORMS);
                        for(i = 0; i < totalUniforms; i++){
                            var info = gl.getActiveUniform(program.webGLProgram, i);
                            if (info) {
                                name = info.name;
                                location = this.renderer.createUniformLocation(program, name);
                                if (location !== null) uniforms[name] = {
                                    name: name,
                                    location: location,
                                    setter: null,
                                    value1: null,
                                    value2: null,
                                    value3: null,
                                    value4: null
                                };
                                //  If the uniform name contains [] for an array struct,
                                //  we'll add an entry for the non-struct name as well.
                                //  Such as uMainSampler[12] = uMainSampler
                                var struct = name.indexOf('[');
                                if (struct > 0) {
                                    name = name.substr(0, struct);
                                    if (!uniforms.hasOwnProperty(name)) {
                                        location = this.renderer.createUniformLocation(program, name);
                                        if (location !== null) uniforms[name] = {
                                            name: name,
                                            location: location,
                                            setter: null,
                                            value1: null,
                                            value2: null,
                                            value3: null,
                                            value4: null
                                        };
                                    }
                                }
                            }
                        }
                        return this;
                    },
                    /**
     * Repopulate uniforms on the GPU.
     * 
     * This is called automatically by the pipeline when the context is
     * lost and then recovered. By the time this method is called,
     * the WebGL resources are already recreated, so we just need to
     * re-populate them.
     * 
     * @method Phaser.Renderer.WebGL.WebGLShader#syncUniforms
     * @since 3.80.0
     */ syncUniforms: function() {
                        var gl = this.gl;
                        this.renderer.setProgram(this.program);
                        for(var name in this.uniforms){
                            var uniform = this.uniforms[name];
                            // A uniform that hasn't been set doesn't need to be synced.
                            if (uniform.setter) uniform.setter.call(gl, uniform.location.webGLUniformLocation, uniform.value1, uniform.value2, uniform.value3, uniform.value4);
                        }
                    },
                    /**
     * Checks to see if the given uniform name exists and is active in this shader.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#hasUniform
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to check for.
     *
     * @return {boolean} `true` if the uniform exists, otherwise `false`.
     */ hasUniform: function(name) {
                        return this.uniforms.hasOwnProperty(name);
                    },
                    /**
     * Resets the cached values of the given uniform.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#resetUniform
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to reset.
     *
     * @return {this} This WebGLShader instance.
     */ resetUniform: function(name) {
                        var uniform = this.uniforms[name];
                        if (uniform) {
                            uniform.value1 = null;
                            uniform.value2 = null;
                            uniform.value3 = null;
                            uniform.value4 = null;
                        }
                        return this;
                    },
                    /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform1
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform1: function(setter, name, value1, skipCheck) {
                        var uniform = this.uniforms[name];
                        if (!uniform) return this;
                        if (skipCheck || uniform.value1 !== value1) {
                            if (!uniform.setter) uniform.setter = setter;
                            uniform.value1 = value1;
                            this.renderer.setProgram(this.program);
                            setter.call(this.gl, uniform.location.webGLUniformLocation, value1);
                            this.pipeline.currentShader = this;
                        }
                        return this;
                    },
                    /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform2
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform2: function(setter, name, value1, value2, skipCheck) {
                        var uniform = this.uniforms[name];
                        if (!uniform) return this;
                        if (skipCheck || uniform.value1 !== value1 || uniform.value2 !== value2) {
                            if (!uniform.setter) uniform.setter = setter;
                            uniform.value1 = value1;
                            uniform.value2 = value2;
                            this.renderer.setProgram(this.program);
                            setter.call(this.gl, uniform.location.webGLUniformLocation, value1, value2);
                            this.pipeline.currentShader = this;
                        }
                        return this;
                    },
                    /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform3
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value3 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform3: function(setter, name, value1, value2, value3, skipCheck) {
                        var uniform = this.uniforms[name];
                        if (!uniform) return this;
                        if (skipCheck || uniform.value1 !== value1 || uniform.value2 !== value2 || uniform.value3 !== value3) {
                            if (!uniform.setter) uniform.setter = setter;
                            uniform.value1 = value1;
                            uniform.value2 = value2;
                            uniform.value3 = value3;
                            this.renderer.setProgram(this.program);
                            setter.call(this.gl, uniform.location.webGLUniformLocation, value1, value2, value3);
                            this.pipeline.currentShader = this;
                        }
                        return this;
                    },
                    /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform4
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value3 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value4 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform4: function(setter, name, value1, value2, value3, value4, skipCheck) {
                        var uniform = this.uniforms[name];
                        if (!uniform) return this;
                        if (skipCheck || uniform.value1 !== value1 || uniform.value2 !== value2 || uniform.value3 !== value3 || uniform.value4 !== value4) {
                            if (!uniform.setter) uniform.setter = setter;
                            uniform.value1 = value1;
                            uniform.value2 = value2;
                            uniform.value3 = value3;
                            uniform.value4 = value4;
                            this.renderer.setProgram(this.program);
                            setter.call(this.gl, uniform.location.webGLUniformLocation, value1, value2, value3, value4);
                            this.pipeline.currentShader = this;
                        }
                        return this;
                    },
                    /**
     * Sets a boolean uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setBoolean
     * @since 3.60.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} value - The new value of the `boolean` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setBoolean: function(name, value) {
                        return this.setUniform1(this.gl.uniform1i, name, Number(value));
                    },
                    /**
     * Sets a 1f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `float` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set1f: function(name, x) {
                        return this.setUniform1(this.gl.uniform1f, name, x);
                    },
                    /**
     * Sets a 2f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec2` uniform.
     * @param {number} y - The new Y component of the `vec2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set2f: function(name, x, y) {
                        return this.setUniform2(this.gl.uniform2f, name, x, y);
                    },
                    /**
     * Sets a 3f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec3` uniform.
     * @param {number} y - The new Y component of the `vec3` uniform.
     * @param {number} z - The new Z component of the `vec3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set3f: function(name, x, y, z) {
                        return this.setUniform3(this.gl.uniform3f, name, x, y, z);
                    },
                    /**
     * Sets a 4f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     *
     * @return {this} This WebGLShader instance.
     */ set4f: function(name, x, y, z, w) {
                        return this.setUniform4(this.gl.uniform4f, name, x, y, z, w);
                    },
                    /**
     * Sets a 1fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set1fv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform1fv, name, arr, true);
                    },
                    /**
     * Sets a 2fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set2fv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform2fv, name, arr, true);
                    },
                    /**
     * Sets a 3fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set3fv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform3fv, name, arr, true);
                    },
                    /**
     * Sets a 4fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set4fv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform4fv, name, arr, true);
                    },
                    /**
     * Sets a 1iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set1iv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform1iv, name, arr, true);
                    },
                    /**
     * Sets a 2iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set2iv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform2iv, name, arr, true);
                    },
                    /**
     * Sets a 3iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set3iv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform3iv, name, arr, true);
                    },
                    /**
     * Sets a 4iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set4iv: function(name, arr) {
                        return this.setUniform1(this.gl.uniform4iv, name, arr, true);
                    },
                    /**
     * Sets a 1i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `int` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set1i: function(name, x) {
                        return this.setUniform1(this.gl.uniform1i, name, x);
                    },
                    /**
     * Sets a 2i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec2` uniform.
     * @param {number} y - The new Y component of the `ivec2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set2i: function(name, x, y) {
                        return this.setUniform2(this.gl.uniform2i, name, x, y);
                    },
                    /**
     * Sets a 3i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec3` uniform.
     * @param {number} y - The new Y component of the `ivec3` uniform.
     * @param {number} z - The new Z component of the `ivec3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set3i: function(name, x, y, z) {
                        return this.setUniform3(this.gl.uniform3i, name, x, y, z);
                    },
                    /**
     * Sets a 4i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     *
     * @return {this} This WebGLShader instance.
     */ set4i: function(name, x, y, z, w) {
                        return this.setUniform4(this.gl.uniform4i, name, x, y, z, w);
                    },
                    /**
     * Sets a matrix 2fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {number[]|Float32Array} matrix - The new values for the `mat2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix2fv: function(name, transpose, matrix) {
                        return this.setUniform2(this.gl.uniformMatrix2fv, name, transpose, matrix, true);
                    },
                    /**
     * Sets a matrix 3fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {Float32Array} matrix - The new values for the `mat3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix3fv: function(name, transpose, matrix) {
                        return this.setUniform2(this.gl.uniformMatrix3fv, name, transpose, matrix, true);
                    },
                    /**
     * Sets a matrix 4fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Should the matrix be transpose
     * @param {Float32Array} matrix - Matrix data
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix4fv: function(name, transpose, matrix) {
                        return this.setUniform2(this.gl.uniformMatrix4fv, name, transpose, matrix, true);
                    },
                    /**
     * This method will create the Shader Program on the current GL context.
     *
     * If a program already exists, it will be destroyed and the new one will take its place.
     *
     * After the program is created the uniforms will be reset and
     * this shader will be rebound.
     *
     * This is a very expensive process and if your shader is referenced elsewhere in
     * your game those references may then be lost, so be sure to use this carefully.
     *
     * However, if you need to update say the fragment shader source, then you can pass
     * the new source into this method and it'll rebuild the program using it. If you
     * don't want to change the vertex shader src, pass `undefined` as the parameter.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#createProgram
     * @since 3.60.0
     *
     * @param {string} [vertSrc] - The source code of the vertex shader. If not given, uses the source already defined in this Shader.
     * @param {string} [fragSrc] - The source code of the fragment shader. If not given, uses the source already defined in this Shader.
     *
     * @return {this} This WebGLShader instance.
     */ createProgram: function(vertSrc, fragSrc) {
                        if (vertSrc === undefined) vertSrc = this.vertSrc;
                        if (fragSrc === undefined) fragSrc = this.fragSrc;
                        if (this.program) this.renderer.deleteProgram(this.program);
                        this.vertSrc = vertSrc;
                        this.fragSrc = fragSrc;
                        this.program = this.renderer.createProgram(vertSrc, fragSrc);
                        this.createUniforms();
                        return this.rebind();
                    },
                    /**
     * Removes all external references from this class and deletes the WebGL program from the WebGL context.
     *
     * Does not remove this shader from the parent pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#destroy
     * @since 3.50.0
     */ destroy: function() {
                        var renderer = this.renderer;
                        ArrayEach(this.uniforms, function(uniform) {
                            renderer.deleteUniformLocation(uniform.location);
                        });
                        this.uniforms = null;
                        ArrayEach(this.attributes, function(attrib) {
                            renderer.deleteAttribLocation(attrib.location);
                        });
                        this.attributes = null;
                        renderer.deleteProgram(this.program);
                        this.pipeline = null;
                        this.renderer = null;
                        this.gl = null;
                        this.program = null;
                    }
                });
                module1.exports = WebGLShader;
            /***/ },
            /***/ 14500: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WEBGL_CONST = {
                    /**
     * 	8-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.BYTE
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ BYTE: {
                        enum: 0x1400,
                        size: 1
                    },
                    /**
     * 8-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_BYTE
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_BYTE: {
                        enum: 0x1401,
                        size: 1
                    },
                    /**
     * 16-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.SHORT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ SHORT: {
                        enum: 0x1402,
                        size: 2
                    },
                    /**
     * 16-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_SHORT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_SHORT: {
                        enum: 0x1403,
                        size: 2
                    },
                    /**
     * 32-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.INT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ INT: {
                        enum: 0x1404,
                        size: 4
                    },
                    /**
     * 32-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_INT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_INT: {
                        enum: 0x1405,
                        size: 4
                    },
                    /**
     * 32-bit IEEE floating point number.
     *
     * @name Phaser.Renderer.WebGL.FLOAT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ FLOAT: {
                        enum: 0x1406,
                        size: 4
                    }
                };
                module1.exports = WEBGL_CONST;
            /***/ },
            /***/ 4159: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WEBGL_CONST = __webpack_require__(14500);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Renderer.WebGL
 */ var WebGL = {
                    PipelineManager: __webpack_require__(7530),
                    Pipelines: __webpack_require__(96615),
                    RenderTarget: __webpack_require__(32302),
                    Utils: __webpack_require__(70554),
                    WebGLPipeline: __webpack_require__(29100),
                    WebGLRenderer: __webpack_require__(74797),
                    WebGLShader: __webpack_require__(38683),
                    Wrappers: __webpack_require__(9503)
                };
                //   Merge in the consts
                WebGL = Extend(false, WebGL, WEBGL_CONST);
                //  Export it
                module1.exports = WebGL;
            /***/ },
            /***/ 31302: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var ShaderSourceFS = __webpack_require__(78908);
                var ShaderSourceVS = __webpack_require__(85191);
                var WEBGL_CONST = __webpack_require__(14500);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Bitmap Mask Pipeline handles all of the bitmap mask rendering in WebGL for applying
 * alpha masks to Game Objects. It works by sampling two texture on the fragment shader and
 * using the fragments alpha to clip the region.
 *
 * The fragment shader it uses can be found in `shaders/src/BitmapMask.frag`.
 * The vertex shader it uses can be found in `shaders/src/BitmapMask.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uResolution` (vec2)
 * `uMainSampler` (sampler2D)
 * `uMaskSampler` (sampler2D)
 * `uInvertMaskAlpha` (bool)
 *
 * @class BitmapMaskPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var BitmapMaskPipeline = new Class({
                    Extends: WebGLPipeline,
                    initialize: function BitmapMaskPipeline(config) {
                        config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS), config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS), config.batchSize = GetFastValue(config, 'batchSize', 1), config.vertices = GetFastValue(config, 'vertices', [
                            -1,
                            1,
                            -1,
                            -7,
                            7,
                            1
                        ]), config.attributes = GetFastValue(config, 'attributes', [
                            {
                                name: 'inPosition',
                                size: 2,
                                type: WEBGL_CONST.FLOAT
                            }
                        ]);
                        WebGLPipeline.call(this, config);
                    },
                    boot: function() {
                        WebGLPipeline.prototype.boot.call(this);
                        this.set1i('uMainSampler', 0);
                        this.set1i('uMaskSampler', 1);
                    },
                    resize: function(width, height) {
                        WebGLPipeline.prototype.resize.call(this, width, height);
                        this.set2f('uResolution', width, height);
                    },
                    /**
     * Binds necessary resources and renders the mask to a separated framebuffer.
     * The framebuffer for the masked object is also bound for further use.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#beginMask
     * @since 3.0.0
     *
     * @param {Phaser.Display.Masks.BitmapMask} mask - The BitmapMask instance that called beginMask.
     * @param {Phaser.GameObjects.GameObject} maskedObject - GameObject masked by the mask GameObject.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the current mask.
     */ beginMask: function(mask, maskedObject, camera) {
                        this.renderer.beginBitmapMask(mask, camera);
                    },
                    /**
     * The masked game objects framebuffer is unbound and its texture
     * is bound together with the mask texture and the mask shader and
     * a draw call with a single quad is processed. Here is where the
     * masking effect is applied.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#endMask
     * @since 3.0.0
     *
     * @param {Phaser.Display.Masks.BitmapMask} mask - The BitmapMask instance that called endMask.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [renderTarget] - Optional WebGL RenderTarget.
     */ endMask: function(mask, camera, renderTarget) {
                        var gl = this.gl;
                        var renderer = this.renderer;
                        //  The renderable Game Object that is being used for the bitmap mask
                        var bitmapMask = mask.bitmapMask;
                        if (bitmapMask && gl) {
                            renderer.drawBitmapMask(bitmapMask, camera, this);
                            if (renderTarget) this.set2f('uResolution', renderTarget.width, renderTarget.height);
                            this.set1i('uInvertMaskAlpha', mask.invertAlpha);
                            //  Finally, draw a triangle filling the whole screen
                            gl.drawArrays(this.topology, 0, 3);
                            if (renderTarget) this.set2f('uResolution', this.width, this.height);
                            //  Clear gl.TEXTURE1
                            gl.bindTexture(gl.TEXTURE_2D, null);
                        }
                    }
                });
                module1.exports = BitmapMaskPipeline;
            /***/ },
            /***/ 92651: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var FX = __webpack_require__(58918);
                var FX_CONST = __webpack_require__(14811);
                var GetFastValue = __webpack_require__(95540);
                var PreFXPipeline = __webpack_require__(43558);
                var Shaders = __webpack_require__(89350);
                var Utils = __webpack_require__(70554);
                /**
 * @classdesc
 * The FXPipeline is a built-in pipeline that controls the application of FX Controllers during
 * the rendering process. It maintains all of the FX shaders, instances of Post FX Pipelines and
 * is responsible for rendering.
 *
 * You should rarely interact with this pipeline directly. Instead, use the FX Controllers that
 * is part of the Game Object class in order to manage the effects.
 *
 * @class FXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PreFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser game instance.
 */ var FXPipeline = new Class({
                    Extends: PreFXPipeline,
                    initialize: function FXPipeline(config) {
                        //  This order is fixed to match with the FX_CONST. Do not adjust.
                        config.shaders = [
                            Utils.setGlowQuality(Shaders.FXGlowFrag, config.game),
                            Shaders.FXShadowFrag,
                            Shaders.FXPixelateFrag,
                            Shaders.FXVignetteFrag,
                            Shaders.FXShineFrag,
                            Shaders.FXBlurLowFrag,
                            Shaders.FXBlurMedFrag,
                            Shaders.FXBlurHighFrag,
                            Shaders.FXGradientFrag,
                            Shaders.FXBloomFrag,
                            Shaders.ColorMatrixFrag,
                            Shaders.FXCircleFrag,
                            Shaders.FXBarrelFrag,
                            Shaders.FXDisplacementFrag,
                            Shaders.FXWipeFrag,
                            Shaders.FXBokehFrag
                        ];
                        PreFXPipeline.call(this, config);
                        var game = this.game;
                        /**
         * An instance of the Glow Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#glow
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.GlowFXPipeline}
         * @since 3.60.0
         */ this.glow = new FX.Glow(game);
                        /**
         * An instance of the Shadow Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#shadow
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline}
         * @since 3.60.0
         */ this.shadow = new FX.Shadow(game);
                        /**
         * An instance of the Pixelate Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#pixelate
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.PixelateFXPipeline}
         * @since 3.60.0
         */ this.pixelate = new FX.Pixelate(game);
                        /**
         * An instance of the Vignette Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#vignette
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.VignetteFXPipeline}
         * @since 3.60.0
         */ this.vignette = new FX.Vignette(game);
                        /**
         * An instance of the Shine Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#shine
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.ShineFXPipeline}
         * @since 3.60.0
         */ this.shine = new FX.Shine(game);
                        /**
         * An instance of the Gradient Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#gradient
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline}
         * @since 3.60.0
         */ this.gradient = new FX.Gradient(game);
                        /**
         * An instance of the Circle Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#circle
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.CircleFXPipeline}
         * @since 3.60.0
         */ this.circle = new FX.Circle(game);
                        /**
         * An instance of the Barrel Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#barrel
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.BarrelFXPipeline}
         * @since 3.60.0
         */ this.barrel = new FX.Barrel(game);
                        /**
         * An instance of the Wipe Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#wipe
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.WipeFXPipeline}
         * @since 3.60.0
         */ this.wipe = new FX.Wipe(game);
                        /**
         * An instance of the Bokeh Post FX Pipeline.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#bokeh
         * @type {Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline}
         * @since 3.60.0
         */ this.bokeh = new FX.Bokeh(game);
                        //  This array is intentionally sparse. Do not adjust.
                        var fxHandlers = [];
                        fxHandlers[FX_CONST.GLOW] = this.onGlow;
                        fxHandlers[FX_CONST.SHADOW] = this.onShadow;
                        fxHandlers[FX_CONST.PIXELATE] = this.onPixelate;
                        fxHandlers[FX_CONST.VIGNETTE] = this.onVignette;
                        fxHandlers[FX_CONST.SHINE] = this.onShine;
                        fxHandlers[FX_CONST.BLUR] = this.onBlur;
                        fxHandlers[FX_CONST.GRADIENT] = this.onGradient;
                        fxHandlers[FX_CONST.BLOOM] = this.onBloom;
                        fxHandlers[FX_CONST.COLOR_MATRIX] = this.onColorMatrix;
                        fxHandlers[FX_CONST.CIRCLE] = this.onCircle;
                        fxHandlers[FX_CONST.BARREL] = this.onBarrel;
                        fxHandlers[FX_CONST.DISPLACEMENT] = this.onDisplacement;
                        fxHandlers[FX_CONST.WIPE] = this.onWipe;
                        fxHandlers[FX_CONST.BOKEH] = this.onBokeh;
                        /**
         * An array containing references to the methods that map to the FX CONSTs.
         *
         * This array is intentionally sparse. Do not adjust.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#fxHandlers
         * @type {function[]}
         * @since 3.60.0
         */ this.fxHandlers = fxHandlers;
                        /**
         * The source Render Target.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#source
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.60.0
         */ this.source;
                        /**
         * The target Render Target.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#target
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.60.0
         */ this.target;
                        /**
         * The swap Render Target.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FXPipeline#swap
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.60.0
         */ this.swap;
                    },
                    /**
     * Takes the currently bound Game Object and runs all of its pre-render effects,
     * using the given Render Target as the source.
     *
     * Finally calls `drawToGame` to copy the result to the Game Canvas.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onDraw
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target1 - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target2 - The target Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target3 - The swap Render Target.
     */ onDraw: function(target1, target2, target3) {
                        this.source = target1;
                        this.target = target2;
                        this.swap = target3;
                        var width = target1.width;
                        var height = target1.height;
                        var sprite = this.tempSprite;
                        var handlers = this.fxHandlers;
                        if (sprite && sprite.preFX) {
                            var fx = sprite.preFX.list;
                            for(var i = 0; i < fx.length; i++){
                                var controller = fx[i];
                                if (controller.active) handlers[controller.type].call(this, controller, width, height);
                            }
                        }
                        this.drawToGame(this.source);
                    },
                    /**
     * Takes the source and target and runs a copy from source to target.
     *
     * This will use the current shader and pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#runDraw
     * @since 3.60.0
     */ runDraw: function() {
                        var source = this.source;
                        var target = this.target;
                        this.copy(source, target);
                        this.source = target;
                        this.target = source;
                    },
                    /**
     * Runs the Glow FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onGlow
     * @since 3.60.0
     *
     * @param {Phaser.FX.Glow} config - The Glow FX controller.
     * @param {number} width - The width of the target.
     * @param {number} height - The height of the target.
     */ onGlow: function(config, width, height) {
                        var shader = this.shaders[FX_CONST.GLOW];
                        this.setShader(shader);
                        this.glow.onPreRender(config, shader, width, height);
                        this.runDraw();
                    },
                    /**
     * Runs the Shadow FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onShadow
     * @since 3.60.0
     *
     * @param {Phaser.FX.Shadow} config - The Shadow FX controller.
     */ onShadow: function(config) {
                        var shader = this.shaders[FX_CONST.SHADOW];
                        this.setShader(shader);
                        this.shadow.onPreRender(config, shader);
                        this.runDraw();
                    },
                    /**
     * Runs the Pixelate FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onPixelate
     * @since 3.60.0
     *
     * @param {Phaser.FX.Pixelate} config - The Pixelate FX controller.
     * @param {number} width - The width of the target.
     * @param {number} height - The height of the target.
     */ onPixelate: function(config, width, height) {
                        var shader = this.shaders[FX_CONST.PIXELATE];
                        this.setShader(shader);
                        this.pixelate.onPreRender(config, shader, width, height);
                        this.runDraw();
                    },
                    /**
     * Runs the Vignette FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onVignette
     * @since 3.60.0
     *
     * @param {Phaser.FX.Vignette} config - The Vignette FX controller.
     */ onVignette: function(config) {
                        var shader = this.shaders[FX_CONST.VIGNETTE];
                        this.setShader(shader);
                        this.vignette.onPreRender(config, shader);
                        this.runDraw();
                    },
                    /**
     * Runs the Shine FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onShine
     * @since 3.60.0
     *
     * @param {Phaser.FX.Shine} config - The Shine FX controller.
     * @param {number} width - The width of the target.
     * @param {number} height - The height of the target.
     */ onShine: function(config, width, height) {
                        var shader = this.shaders[FX_CONST.SHINE];
                        this.setShader(shader);
                        this.shine.onPreRender(config, shader, width, height);
                        this.runDraw();
                    },
                    /**
     * Runs the Blur FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onBlur
     * @since 3.60.0
     *
     * @param {Phaser.FX.Blur} config - The Blur FX controller.
     * @param {number} width - The width of the target.
     * @param {number} height - The height of the target.
     */ onBlur: function(config, width, height) {
                        var quality = GetFastValue(config, 'quality');
                        var shader = this.shaders[FX_CONST.BLUR + quality];
                        this.setShader(shader);
                        this.set1i('uMainSampler', 0);
                        this.set2f('resolution', width, height);
                        this.set1f('strength', GetFastValue(config, 'strength'));
                        this.set3fv('color', GetFastValue(config, 'glcolor'));
                        var x = GetFastValue(config, 'x');
                        var y = GetFastValue(config, 'y');
                        var steps = GetFastValue(config, 'steps');
                        for(var i = 0; i < steps; i++){
                            this.set2f('offset', x, 0);
                            this.runDraw();
                            this.set2f('offset', 0, y);
                            this.runDraw();
                        }
                    },
                    /**
     * Runs the Gradient FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onGradient
     * @since 3.60.0
     *
     * @param {Phaser.FX.Gradient} config - The Gradient FX controller.
     */ onGradient: function(config) {
                        var shader = this.shaders[FX_CONST.GRADIENT];
                        this.setShader(shader);
                        this.gradient.onPreRender(config, shader);
                        this.runDraw();
                    },
                    /**
     * Runs the Bloom FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onBloom
     * @since 3.60.0
     *
     * @param {Phaser.FX.Bloom} config - The Bloom FX controller.
     * @param {number} width - The width of the target.
     * @param {number} height - The height of the target.
     */ onBloom: function(config, width, height) {
                        var shader = this.shaders[FX_CONST.BLOOM];
                        this.copySprite(this.source, this.swap);
                        this.setShader(shader);
                        this.set1i('uMainSampler', 0);
                        this.set1f('strength', GetFastValue(config, 'blurStrength'));
                        this.set3fv('color', GetFastValue(config, 'glcolor'));
                        var x = 2 / width * GetFastValue(config, 'offsetX');
                        var y = 2 / height * GetFastValue(config, 'offsetY');
                        var steps = GetFastValue(config, 'steps');
                        for(var i = 0; i < steps; i++){
                            this.set2f('offset', x, 0);
                            this.runDraw();
                            this.set2f('offset', 0, y);
                            this.runDraw();
                        }
                        this.blendFrames(this.swap, this.source, this.target, GetFastValue(config, 'strength'));
                        this.copySprite(this.target, this.source);
                    },
                    /**
     * Runs the ColorMatrix FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onColorMatrix
     * @since 3.60.0
     *
     * @param {Phaser.FX.ColorMatrix} config - The ColorMatrix FX controller.
     */ onColorMatrix: function(config) {
                        this.setShader(this.colorMatrixShader);
                        this.set1fv('uColorMatrix', config.getData());
                        this.set1f('uAlpha', config.alpha);
                        this.runDraw();
                    },
                    /**
     * Runs the Circle FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onCircle
     * @since 3.60.0
     *
     * @param {Phaser.FX.Circle} config - The Circle FX controller.
     * @param {number} width - The width of the target.
     * @param {number} height - The height of the target.
     */ onCircle: function(config, width, height) {
                        var shader = this.shaders[FX_CONST.CIRCLE];
                        this.setShader(shader);
                        this.circle.onPreRender(config, shader, width, height);
                        this.runDraw();
                    },
                    /**
     * Runs the Barrel FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onBarrel
     * @since 3.60.0
     *
     * @param {Phaser.FX.Barrel} config - The Barrel FX controller.
     */ onBarrel: function(config) {
                        var shader = this.shaders[FX_CONST.BARREL];
                        this.setShader(shader);
                        this.barrel.onPreRender(config, shader);
                        this.runDraw();
                    },
                    /**
     * Runs the Displacement FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onDisplacement
     * @since 3.60.0
     *
     * @param {Phaser.FX.Displacement} config - The Displacement FX controller.
     */ onDisplacement: function(config) {
                        this.setShader(this.shaders[FX_CONST.DISPLACEMENT]);
                        this.set1i('uDisplacementSampler', 1);
                        this.set2f('amount', config.x, config.y);
                        this.bindTexture(config.glTexture, 1);
                        this.runDraw();
                    },
                    /**
     * Runs the Wipe FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onWipe
     * @since 3.60.0
     *
     * @param {Phaser.FX.Wipe} config - The Wipe FX controller.
     */ onWipe: function(config) {
                        var shader = this.shaders[FX_CONST.WIPE];
                        this.setShader(shader);
                        this.wipe.onPreRender(config, shader);
                        this.runDraw();
                    },
                    /**
     * Runs the Bokeh FX controller.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#onBokeh
     * @since 3.60.0
     *
     * @param {Phaser.FX.Bokeh} config - The Bokeh FX controller.
     */ onBokeh: function(config, width, height) {
                        var shader = this.shaders[FX_CONST.BOKEH];
                        this.setShader(shader);
                        this.bokeh.onPreRender(config, shader, width, height);
                        this.runDraw();
                    },
                    /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FXPipeline#destroy
     * @since 3.60.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                        this.glow.destroy();
                        this.shadow.destroy();
                        this.pixelate.destroy();
                        this.vignette.destroy();
                        this.shine.destroy();
                        this.gradient.destroy();
                        this.circle.destroy();
                        this.barrel.destroy();
                        this.wipe.destroy();
                        this.bokeh.destroy();
                        this.fxHandlers = null;
                        this.source = null;
                        this.target = null;
                        this.swap = null;
                        PreFXPipeline.prototype.destroy.call(this);
                        return this;
                    }
                });
                module1.exports = FXPipeline;
            /***/ },
            /***/ 96569: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var LightShaderSourceFS = __webpack_require__(31063);
                var MultiPipeline = __webpack_require__(57516);
                var TransformMatrix = __webpack_require__(61340);
                var Vec2 = __webpack_require__(26099);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Light Pipeline is an extension of the Multi Pipeline and uses a custom shader
 * designed to handle forward diffused rendering of 2D lights in a Scene.
 *
 * The shader works in tandem with Light Game Objects, and optionally texture normal maps,
 * to provide an ambient illumination effect.
 *
 * If you wish to provide your own shader, you can use the `%LIGHT_COUNT%` declaration in the source,
 * and it will be automatically replaced at run-time with the total number of configured lights.
 *
 * The maximum number of lights can be set in the Render Config `maxLights` property and defaults to 10.
 *
 * Prior to Phaser v3.50 this pipeline was called the `ForwardDiffuseLightPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Light.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are those from the Multi Pipeline, plus:
 *
 * `uMainSampler` (sampler2D)
 * `uNormSampler` (sampler2D)
 * `uCamera` (vec4)
 * `uResolution` (vec2)
 * `uAmbientLightColor` (vec3)
 * `uInverseRotationMatrix` (mat3)
 * `uLights` (Light struct)
 *
 * @class LightPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var LightPipeline = new Class({
                    Extends: MultiPipeline,
                    initialize: function LightPipeline(config) {
                        var fragShader = GetFastValue(config, 'fragShader', LightShaderSourceFS);
                        config.fragShader = fragShader.replace('%LIGHT_COUNT%', config.game.renderer.config.maxLights);
                        MultiPipeline.call(this, config);
                        /**
         * Inverse rotation matrix for normal map rotations.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#inverseRotationMatrix
         * @type {Float32Array}
         * @private
         * @since 3.16.0
         */ this.inverseRotationMatrix = new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ]);
                        /**
         * The currently bound normal map texture at texture unit one, if any.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#currentNormalMap;
         * @type {?Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @since 3.60.0
         */ this.currentNormalMap;
                        /**
         * A boolean that is set automatically during `onRender` that determines
         * if the Scene LightManager is active, or not.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#lightsActive
         * @type {boolean}
         * @readonly
         * @since 3.53.0
         */ this.lightsActive = true;
                        /**
         * A persistent calculation vector used when processing the lights.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#tempVec2
         * @type {Phaser.Math.Vector2}
         * @since 3.60.0
         */ this.tempVec2 = new Vec2();
                        /**
         * A temporary Transform Matrix used for parent Container calculations without them needing their own local copy.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#_tempMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.60.0
         */ this._tempMatrix = new TransformMatrix();
                        /**
         * A temporary Transform Matrix used for parent Container calculations without them needing their own local copy.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#_tempMatrix2
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.60.0
         */ this._tempMatrix2 = new TransformMatrix();
                    },
                    /**
     * Called when the Game has fully booted and the Renderer has finished setting up.
     *
     * By this stage all Game level systems are now in place and you can perform any final
     * tasks that the pipeline may need that relied on game systems such as the Texture Manager.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#boot
     * @since 3.11.0
     */ boot: function() {
                        WebGLPipeline.prototype.boot.call(this);
                    },
                    /**
     * This function sets all the needed resources for each camera pass.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#onRender
     * @ignore
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered with.
     */ onRender: function(scene, camera) {
                        var lightManager = scene.sys.lights;
                        this.lightsActive = false;
                        if (!lightManager || !lightManager.active) return;
                        var lights = lightManager.getLights(camera);
                        var lightsCount = lights.length;
                        //  Ok, we're good to go ...
                        this.lightsActive = true;
                        var i;
                        var renderer = this.renderer;
                        var height = renderer.height;
                        var cameraMatrix = camera.matrix;
                        var tempVec2 = this.tempVec2;
                        this.set1i('uMainSampler', 0);
                        this.set1i('uNormSampler', 1);
                        this.set2f('uResolution', this.width / 2, this.height / 2);
                        this.set4f('uCamera', camera.x, camera.y, camera.rotation, camera.zoom);
                        this.set3f('uAmbientLightColor', lightManager.ambientColor.r, lightManager.ambientColor.g, lightManager.ambientColor.b);
                        this.set1i('uLightCount', lightsCount);
                        for(i = 0; i < lightsCount; i++){
                            var light = lights[i].light;
                            var color = light.color;
                            var lightName = 'uLights[' + i + '].';
                            cameraMatrix.transformPoint(light.x, light.y, tempVec2);
                            this.set2f(lightName + 'position', tempVec2.x - camera.scrollX * light.scrollFactorX * camera.zoom, height - (tempVec2.y - camera.scrollY * light.scrollFactorY * camera.zoom));
                            this.set3f(lightName + 'color', color.r, color.g, color.b);
                            this.set1f(lightName + 'intensity', light.intensity);
                            this.set1f(lightName + 'radius', light.radius);
                        }
                        this.currentNormalMapRotation = null;
                    },
                    /**
     * Rotates the normal map vectors inversely by the given angle.
     * Only works in 2D space.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setNormalMapRotation
     * @since 3.16.0
     *
     * @param {number} rotation - The angle of rotation in radians.
     */ setNormalMapRotation: function(rotation) {
                        if (rotation !== this.currentNormalMapRotation || this.vertexCount === 0) {
                            if (this.vertexCount > 0) this.flush();
                            var inverseRotationMatrix = this.inverseRotationMatrix;
                            if (rotation) {
                                var rot = -rotation;
                                var c = Math.cos(rot);
                                var s = Math.sin(rot);
                                inverseRotationMatrix[1] = s;
                                inverseRotationMatrix[3] = -s;
                                inverseRotationMatrix[0] = inverseRotationMatrix[4] = c;
                            } else {
                                inverseRotationMatrix[0] = inverseRotationMatrix[4] = 1;
                                inverseRotationMatrix[1] = inverseRotationMatrix[3] = 0;
                            }
                            this.setMatrix3fv('uInverseRotationMatrix', false, inverseRotationMatrix);
                            this.currentNormalMapRotation = rotation;
                        }
                    },
                    /**
     * Assigns a texture to the current batch. If a different texture is already set it creates a new batch object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setTexture2D
     * @ignore
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture] - Texture that will be assigned to the current batch. If not given uses blankTexture.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object being rendered or added to the batch.
     */ setTexture2D: function(texture, gameObject) {
                        var renderer = this.renderer;
                        if (texture === undefined) texture = renderer.whiteTexture;
                        var normalMap = this.getNormalMap(gameObject);
                        if (this.isNewNormalMap(texture, normalMap)) {
                            this.flush();
                            this.createBatch(texture);
                            this.addTextureToBatch(normalMap);
                            this.currentNormalMap = normalMap;
                        }
                        var rotation = 0;
                        if (gameObject && gameObject.parentContainer) {
                            var matrix = gameObject.getWorldTransformMatrix(this._tempMatrix, this._tempMatrix2);
                            rotation = matrix.rotationNormalized;
                        } else if (gameObject) rotation = gameObject.rotation;
                        if (this.currentBatch === null) {
                            this.createBatch(texture);
                            this.addTextureToBatch(normalMap);
                        }
                        this.setNormalMapRotation(rotation);
                        return 0;
                    },
                    /**
     * Custom pipelines can use this method in order to perform any required pre-batch tasks
     * for the given Game Object. It must return the texture unit the Game Object was assigned.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setGameObject
     * @ignore
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object being rendered or added to the batch.
     * @param {Phaser.Textures.Frame} [frame] - Optional frame to use. Can override that of the Game Object.
     *
     * @return {number} The texture unit the Game Object has been assigned.
     */ setGameObject: function(gameObject, frame) {
                        if (frame === undefined) frame = gameObject.frame;
                        var texture = frame.glTexture;
                        var normalMap = this.getNormalMap(gameObject);
                        if (this.isNewNormalMap(texture, normalMap)) {
                            this.flush();
                            this.createBatch(texture);
                            this.addTextureToBatch(normalMap);
                            this.currentNormalMap = normalMap;
                        }
                        if (gameObject.parentContainer) {
                            var matrix = gameObject.getWorldTransformMatrix(this._tempMatrix, this._tempMatrix2);
                            this.setNormalMapRotation(matrix.rotationNormalized);
                        } else this.setNormalMapRotation(gameObject.rotation);
                        if (this.currentBatch === null) {
                            this.createBatch(texture);
                            this.addTextureToBatch(normalMap);
                        }
                        return 0;
                    },
                    /**
     * Checks to see if the given diffuse and normal map textures are already bound, or not.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#isNewNormalMap
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - The diffuse texture.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} normalMap - The normal map texture.
     *
     * @return {boolean} Returns `false` if this combination is already set, or `true` if it's a new combination.
     */ isNewNormalMap: function(texture, normalMap) {
                        return this.currentTexture !== texture || this.currentNormalMap !== normalMap;
                    },
                    /**
     * Returns the normal map WebGLTextureWrapper from the given Game Object.
     * If the Game Object doesn't have one, it returns the default normal map from this pipeline instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#getNormalMap
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object to get the normal map from.
     *
     * @return {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The normal map texture.
     */ getNormalMap: function(gameObject) {
                        var normalMap;
                        if (!gameObject) return this.renderer.normalTexture;
                        else if (gameObject.displayTexture) normalMap = gameObject.displayTexture.dataSource[gameObject.displayFrame.sourceIndex];
                        else if (gameObject.texture) normalMap = gameObject.texture.dataSource[gameObject.frame.sourceIndex];
                        else if (gameObject.tileset) {
                            if (Array.isArray(gameObject.tileset)) normalMap = gameObject.tileset[0].image.dataSource[0];
                            else normalMap = gameObject.tileset.image.dataSource[0];
                        }
                        if (!normalMap) return this.renderer.normalTexture;
                        return normalMap.glTexture;
                    },
                    /**
     * Takes a Sprite Game Object, or any object that extends it, and adds it to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#batchSprite
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.Image|Phaser.GameObjects.Sprite)} gameObject - The texture based Game Object to add to the batch.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(gameObject, camera, parentTransformMatrix) {
                        if (this.lightsActive) MultiPipeline.prototype.batchSprite.call(this, gameObject, camera, parentTransformMatrix);
                    },
                    /**
     * Generic function for batching a textured quad using argument values instead of a Game Object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#batchTexture
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Source GameObject.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - Texture associated with the quad.
     * @param {number} textureWidth - Real texture width.
     * @param {number} textureHeight - Real texture height.
     * @param {number} srcX - X coordinate of the quad.
     * @param {number} srcY - Y coordinate of the quad.
     * @param {number} srcWidth - Width of the quad.
     * @param {number} srcHeight - Height of the quad.
     * @param {number} scaleX - X component of scale.
     * @param {number} scaleY - Y component of scale.
     * @param {number} rotation - Rotation of the quad.
     * @param {boolean} flipX - Indicates if the quad is horizontally flipped.
     * @param {boolean} flipY - Indicates if the quad is vertically flipped.
     * @param {number} scrollFactorX - By which factor is the quad affected by the camera horizontal scroll.
     * @param {number} scrollFactorY - By which factor is the quad effected by the camera vertical scroll.
     * @param {number} displayOriginX - Horizontal origin in pixels.
     * @param {number} displayOriginY - Vertical origin in pixels.
     * @param {number} frameX - X coordinate of the texture frame.
     * @param {number} frameY - Y coordinate of the texture frame.
     * @param {number} frameWidth - Width of the texture frame.
     * @param {number} frameHeight - Height of the texture frame.
     * @param {number} tintTL - Tint for top left.
     * @param {number} tintTR - Tint for top right.
     * @param {number} tintBL - Tint for bottom left.
     * @param {number} tintBR - Tint for bottom right.
     * @param {number} tintEffect - The tint effect.
     * @param {number} uOffset - Horizontal offset on texture coordinate.
     * @param {number} vOffset - Vertical offset on texture coordinate.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - Current used camera.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - Parent container.
     * @param {boolean} [skipFlip=false] - Skip the renderTexture check.
     * @param {number} [textureUnit] - Use the currently bound texture unit?
     */ batchTexture: function(gameObject, texture, textureWidth, textureHeight, srcX, srcY, srcWidth, srcHeight, scaleX, scaleY, rotation, flipX, flipY, scrollFactorX, scrollFactorY, displayOriginX, displayOriginY, frameX, frameY, frameWidth, frameHeight, tintTL, tintTR, tintBL, tintBR, tintEffect, uOffset, vOffset, camera, parentTransformMatrix, skipFlip, textureUnit) {
                        if (this.lightsActive) MultiPipeline.prototype.batchTexture.call(this, gameObject, texture, textureWidth, textureHeight, srcX, srcY, srcWidth, srcHeight, scaleX, scaleY, rotation, flipX, flipY, scrollFactorX, scrollFactorY, displayOriginX, displayOriginY, frameX, frameY, frameWidth, frameHeight, tintTL, tintTR, tintBL, tintBR, tintEffect, uOffset, vOffset, camera, parentTransformMatrix, skipFlip, textureUnit);
                    },
                    /**
     * Adds a Texture Frame into the batch for rendering.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#batchTextureFrame
     * @since 3.50.0
     *
     * @param {Phaser.Textures.Frame} frame - The Texture Frame to be rendered.
     * @param {number} x - The horizontal position to render the texture at.
     * @param {number} y - The vertical position to render the texture at.
     * @param {number} tint - The tint color.
     * @param {number} alpha - The alpha value.
     * @param {Phaser.GameObjects.Components.TransformMatrix} transformMatrix - The Transform Matrix to use for the texture.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - A parent Transform Matrix.
     */ batchTextureFrame: function(frame, x, y, tint, alpha, transformMatrix, parentTransformMatrix) {
                        if (this.lightsActive) MultiPipeline.prototype.batchTextureFrame.call(this, frame, x, y, tint, alpha, transformMatrix, parentTransformMatrix);
                    }
                });
                module1.exports = LightPipeline;
            /***/ },
            /***/ 56527: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var MultiPipeline = __webpack_require__(57516);
                var ShaderSourceFS = __webpack_require__(45561);
                var ShaderSourceVS = __webpack_require__(60722);
                var WEBGL_CONST = __webpack_require__(14500);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Mobile Pipeline is the core 2D texture rendering pipeline used by Phaser in WebGL
 * when the device running the game is detected to be a mobile.
 *
 * You can control the use of this pipeline by setting the Game Configuration
 * property `autoMobilePipeline`. If set to `false` then all devices will use
 * the Multi Tint Pipeline. You can also call the `PipelineManager.setDefaultPipeline`
 * method at run-time, rather than boot-time, to modify the default Game Object
 * pipeline.
 *
 * Virtually all Game Objects use this pipeline by default, including Sprites, Graphics
 * and Tilemaps. It handles the batching of quads and tris, as well as methods for
 * drawing and batching geometry data.
 *
 * The fragment shader it uses can be found in `shaders/src/Mobile.frag`.
 * The vertex shader it uses can be found in `shaders/src/Mobile.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * Note that `inTexId` isn't used in the shader, it's just kept to allow us
 * to piggy-back on the Multi Tint Pipeline functions.
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uResolution` (vec2)
 * `uMainSampler` (sampler2D, or sampler2D array)
 *
 * @class MobilePipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var MobilePipeline = new Class({
                    Extends: MultiPipeline,
                    initialize: function MobilePipeline(config) {
                        config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS);
                        config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS);
                        config.attributes = GetFastValue(config, 'attributes', [
                            {
                                name: 'inPosition',
                                size: 2
                            },
                            {
                                name: 'inTexCoord',
                                size: 2
                            },
                            {
                                name: 'inTexId'
                            },
                            {
                                name: 'inTintEffect'
                            },
                            {
                                name: 'inTint',
                                size: 4,
                                type: WEBGL_CONST.UNSIGNED_BYTE,
                                normalized: true
                            }
                        ]);
                        config.forceZero = true;
                        config.resizeUniform = 'uResolution';
                        MultiPipeline.call(this, config);
                    },
                    /**
     * Called when the Game has fully booted and the Renderer has finished setting up.
     *
     * By this stage all Game level systems are now in place and you can perform any final
     * tasks that the pipeline may need that relied on game systems such as the Texture Manager.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MobilePipeline#boot
     * @since 3.60.0
     */ boot: function() {
                        WebGLPipeline.prototype.boot.call(this);
                        var renderer = this.renderer;
                        this.set1i('uMainSampler', 0);
                        this.set2f('uResolution', renderer.width, renderer.height);
                    }
                });
                module1.exports = MobilePipeline;
            /***/ },
            /***/ 57516: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Earcut = __webpack_require__(94811);
                var GetFastValue = __webpack_require__(95540);
                var ShaderSourceFS = __webpack_require__(98840);
                var ShaderSourceVS = __webpack_require__(44667);
                var TransformMatrix = __webpack_require__(61340);
                var Utils = __webpack_require__(70554);
                var WEBGL_CONST = __webpack_require__(14500);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Multi Pipeline is the core 2D texture rendering pipeline used by Phaser in WebGL.
 * Virtually all Game Objects use this pipeline by default, including Sprites, Graphics
 * and Tilemaps. It handles the batching of quads and tris, as well as methods for
 * drawing and batching geometry data.
 *
 * Prior to Phaser v3.50 this pipeline was called the `TextureTintPipeline`.
 *
 * In previous versions of Phaser only one single texture unit was supported at any one time.
 * The Multi Pipeline is an evolution of the old Texture Tint Pipeline, updated to support
 * multi-textures for increased performance.
 *
 * The fragment shader it uses can be found in `shaders/src/Multi.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uResolution` (vec2)
 * `uMainSampler` (sampler2D, or sampler2D array)
 *
 * If you wish to create a custom pipeline extending from this one, you can use two string
 * declarations in your fragment shader source: `%count%` and `%forloop%`, where `count` is
 * used to set the number of `sampler2Ds` available, and `forloop` is a block of GLSL code
 * that will get the currently bound texture unit.
 *
 * This pipeline will automatically inject that code for you, should those values exist
 * in your shader source. If you wish to handle this yourself, you can also use the
 * function `Utils.parseFragmentShaderMaxTextures`.
 *
 * The following fragment shader shows how to use the two variables:
 *
 * ```glsl
 * #define SHADER_NAME PHASER_MULTI_FS
 *
 * #ifdef GL_FRAGMENT_PRECISION_HIGH
 * precision highp float;
 * #else
 * precision mediump float;
 * #endif
 *
 * uniform sampler2D uMainSampler[%count%];
 *
 * varying vec2 outTexCoord;
 * varying float outTexId;
 * varying float outTintEffect;
 * varying vec4 outTint;
 *
 * void main ()
 * {
 *     vec4 texture;
 *
 *     %forloop%
 *
 *     vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);
 *
 *     //  Multiply texture tint
 *     vec4 color = texture * texel;
 *
 *     if (outTintEffect == 1.0)
 *     {
 *         //  Solid color + texture alpha
 *         color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);
 *     }
 *     else if (outTintEffect == 2.0)
 *     {
 *         //  Solid color, no texture
 *         color = texel;
 *     }
 *
 *     gl_FragColor = color;
 * }
 * ```
 *
 * If you wish to create a pipeline that works from a single texture, or that doesn't have
 * internal texture iteration, please see the `SinglePipeline` instead. If you wish to create
 * a special effect, especially one that can impact the pixels around a texture (i.e. such as
 * a glitch effect) then you should use the PreFX and PostFX Pipelines for this task.
 *
 * @class MultiPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var MultiPipeline = new Class({
                    Extends: WebGLPipeline,
                    initialize: function MultiPipeline(config) {
                        var renderer = config.game.renderer;
                        var fragmentShaderSource = GetFastValue(config, 'fragShader', ShaderSourceFS);
                        config.fragShader = Utils.parseFragmentShaderMaxTextures(fragmentShaderSource, renderer.maxTextures);
                        config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS);
                        config.attributes = GetFastValue(config, 'attributes', [
                            {
                                name: 'inPosition',
                                size: 2
                            },
                            {
                                name: 'inTexCoord',
                                size: 2
                            },
                            {
                                name: 'inTexId'
                            },
                            {
                                name: 'inTintEffect'
                            },
                            {
                                name: 'inTint',
                                size: 4,
                                type: WEBGL_CONST.UNSIGNED_BYTE,
                                normalized: true
                            }
                        ]);
                        config.resizeUniform = 'uResolution';
                        WebGLPipeline.call(this, config);
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix1 = new TransformMatrix();
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix2 = new TransformMatrix();
                        /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix3 = new TransformMatrix();
                        /**
         * A temporary Transform Matrix, re-used internally during batching by the
         * Shape Game Objects.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#calcMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.55.0
         */ this.calcMatrix = new TransformMatrix();
                        /**
         * Used internally to draw stroked triangles.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#tempTriangle
         * @type {array}
         * @private
         * @since 3.55.0
         */ this.tempTriangle = [
                            {
                                x: 0,
                                y: 0,
                                width: 0
                            },
                            {
                                x: 0,
                                y: 0,
                                width: 0
                            },
                            {
                                x: 0,
                                y: 0,
                                width: 0
                            },
                            {
                                x: 0,
                                y: 0,
                                width: 0
                            }
                        ];
                        /**
         * Cached stroke tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#strokeTint
         * @type {object}
         * @private
         * @since 3.55.0
         */ this.strokeTint = {
                            TL: 0,
                            TR: 0,
                            BL: 0,
                            BR: 0
                        };
                        /**
         * Cached fill tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#fillTint
         * @type {object}
         * @private
         * @since 3.55.0
         */ this.fillTint = {
                            TL: 0,
                            TR: 0,
                            BL: 0,
                            BR: 0
                        };
                        /**
         * Internal texture frame reference.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#currentFrame
         * @type {Phaser.Textures.Frame}
         * @private
         * @since 3.55.0
         */ this.currentFrame = {
                            u0: 0,
                            v0: 0,
                            u1: 1,
                            v1: 1
                        };
                        /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#firstQuad
         * @type {number[]}
         * @private
         * @since 3.55.0
         */ this.firstQuad = [
                            0,
                            0,
                            0,
                            0,
                            0
                        ];
                        /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#prevQuad
         * @type {number[]}
         * @private
         * @since 3.55.0
         */ this.prevQuad = [
                            0,
                            0,
                            0,
                            0,
                            0
                        ];
                        /**
         * Used internally for triangulating a polygon.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#polygonCache
         * @type {array}
         * @private
         * @since 3.55.0
         */ this.polygonCache = [];
                    },
                    /**
     * Called every time the pipeline is bound by the renderer.
     * Sets the shader program, vertex buffer and other resources.
     * Should only be called when changing pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#boot
     * @since 3.50.0
     */ boot: function() {
                        WebGLPipeline.prototype.boot.call(this);
                        var renderer = this.renderer;
                        this.set1iv('uMainSampler', renderer.textureIndexes);
                        this.set2f('uResolution', renderer.width, renderer.height);
                    },
                    /**
     * Takes a Sprite Game Object, or any object that extends it, and adds it to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchSprite
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.Image|Phaser.GameObjects.Sprite)} gameObject - The texture based Game Object to add to the batch.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(gameObject, camera, parentTransformMatrix) {
                        this.manager.set(this, gameObject);
                        var camMatrix = this._tempMatrix1;
                        var spriteMatrix = this._tempMatrix2;
                        var calcMatrix = this._tempMatrix3;
                        var frame = gameObject.frame;
                        var texture = frame.glTexture;
                        var u0 = frame.u0;
                        var v0 = frame.v0;
                        var u1 = frame.u1;
                        var v1 = frame.v1;
                        var frameX = frame.x;
                        var frameY = frame.y;
                        var frameWidth = frame.cutWidth;
                        var frameHeight = frame.cutHeight;
                        var customPivot = frame.customPivot;
                        var displayOriginX = gameObject.displayOriginX;
                        var displayOriginY = gameObject.displayOriginY;
                        var x = -displayOriginX + frameX;
                        var y = -displayOriginY + frameY;
                        if (gameObject.isCropped) {
                            var crop = gameObject._crop;
                            if (crop.flipX !== gameObject.flipX || crop.flipY !== gameObject.flipY) frame.updateCropUVs(crop, gameObject.flipX, gameObject.flipY);
                            u0 = crop.u0;
                            v0 = crop.v0;
                            u1 = crop.u1;
                            v1 = crop.v1;
                            frameWidth = crop.width;
                            frameHeight = crop.height;
                            frameX = crop.x;
                            frameY = crop.y;
                            x = -displayOriginX + frameX;
                            y = -displayOriginY + frameY;
                        }
                        var flipX = 1;
                        var flipY = 1;
                        if (gameObject.flipX) {
                            if (!customPivot) x += -frame.realWidth + displayOriginX * 2;
                            flipX = -1;
                        }
                        if (gameObject.flipY) {
                            if (!customPivot) y += -frame.realHeight + displayOriginY * 2;
                            flipY = -1;
                        }
                        var gx = gameObject.x;
                        var gy = gameObject.y;
                        if (camera.roundPixels) {
                            gx = Math.floor(gx);
                            gy = Math.floor(gy);
                        }
                        spriteMatrix.applyITRS(gx, gy, gameObject.rotation, gameObject.scaleX * flipX, gameObject.scaleY * flipY);
                        camMatrix.copyFrom(camera.matrix);
                        if (parentTransformMatrix) {
                            //  Multiply the camera by the parent matrix
                            camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * gameObject.scrollFactorX, -camera.scrollY * gameObject.scrollFactorY);
                            //  Undo the camera scroll
                            spriteMatrix.e = gx;
                            spriteMatrix.f = gy;
                        } else {
                            spriteMatrix.e -= camera.scrollX * gameObject.scrollFactorX;
                            spriteMatrix.f -= camera.scrollY * gameObject.scrollFactorY;
                        }
                        //  Multiply by the Sprite matrix, store result in calcMatrix
                        camMatrix.multiply(spriteMatrix, calcMatrix);
                        var quad = calcMatrix.setQuad(x, y, x + frameWidth, y + frameHeight, camera.renderRoundPixels);
                        var getTint = Utils.getTintAppendFloatAlpha;
                        var cameraAlpha = camera.alpha;
                        var tintTL = getTint(gameObject.tintTopLeft, cameraAlpha * gameObject._alphaTL);
                        var tintTR = getTint(gameObject.tintTopRight, cameraAlpha * gameObject._alphaTR);
                        var tintBL = getTint(gameObject.tintBottomLeft, cameraAlpha * gameObject._alphaBL);
                        var tintBR = getTint(gameObject.tintBottomRight, cameraAlpha * gameObject._alphaBR);
                        if (this.shouldFlush(6)) this.flush();
                        var unit = this.setGameObject(gameObject, frame);
                        this.manager.preBatch(gameObject);
                        this.batchQuad(gameObject, quad[0], quad[1], quad[2], quad[3], quad[4], quad[5], quad[6], quad[7], u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, gameObject.tintFill, texture, unit);
                        this.manager.postBatch(gameObject);
                    },
                    /**
     * Generic function for batching a textured quad using argument values instead of a Game Object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchTexture
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Source GameObject.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} texture - Texture associated with the quad.
     * @param {number} textureWidth - Real texture width.
     * @param {number} textureHeight - Real texture height.
     * @param {number} srcX - X coordinate of the quad.
     * @param {number} srcY - Y coordinate of the quad.
     * @param {number} srcWidth - Width of the quad.
     * @param {number} srcHeight - Height of the quad.
     * @param {number} scaleX - X component of scale.
     * @param {number} scaleY - Y component of scale.
     * @param {number} rotation - Rotation of the quad.
     * @param {boolean} flipX - Indicates if the quad is horizontally flipped.
     * @param {boolean} flipY - Indicates if the quad is vertically flipped.
     * @param {number} scrollFactorX - By which factor is the quad affected by the camera horizontal scroll.
     * @param {number} scrollFactorY - By which factor is the quad effected by the camera vertical scroll.
     * @param {number} displayOriginX - Horizontal origin in pixels.
     * @param {number} displayOriginY - Vertical origin in pixels.
     * @param {number} frameX - X coordinate of the texture frame.
     * @param {number} frameY - Y coordinate of the texture frame.
     * @param {number} frameWidth - Width of the texture frame.
     * @param {number} frameHeight - Height of the texture frame.
     * @param {number} tintTL - Tint for top left.
     * @param {number} tintTR - Tint for top right.
     * @param {number} tintBL - Tint for bottom left.
     * @param {number} tintBR - Tint for bottom right.
     * @param {number} tintEffect - The tint effect.
     * @param {number} uOffset - Horizontal offset on texture coordinate.
     * @param {number} vOffset - Vertical offset on texture coordinate.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - Current used camera.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - Parent container.
     * @param {boolean} [skipFlip=false] - Skip the renderTexture check.
     * @param {number} [textureUnit] - The texture unit to set (defaults to currently bound if undefined or null)
     * @param {boolean} [skipPrePost=false] - Skip the pre and post manager calls?
     */ batchTexture: function(gameObject, texture, textureWidth, textureHeight, srcX, srcY, srcWidth, srcHeight, scaleX, scaleY, rotation, flipX, flipY, scrollFactorX, scrollFactorY, displayOriginX, displayOriginY, frameX, frameY, frameWidth, frameHeight, tintTL, tintTR, tintBL, tintBR, tintEffect, uOffset, vOffset, camera, parentTransformMatrix, skipFlip, textureUnit, skipPrePost) {
                        if (skipPrePost === undefined) skipPrePost = false;
                        this.manager.set(this, gameObject);
                        var camMatrix = this._tempMatrix1;
                        var spriteMatrix = this._tempMatrix2;
                        var calcMatrix = this._tempMatrix3;
                        var u0 = frameX / textureWidth + uOffset;
                        var v0 = frameY / textureHeight + vOffset;
                        var u1 = (frameX + frameWidth) / textureWidth + uOffset;
                        var v1 = (frameY + frameHeight) / textureHeight + vOffset;
                        var width = srcWidth;
                        var height = srcHeight;
                        var x = -displayOriginX;
                        var y = -displayOriginY;
                        if (gameObject.isCropped) {
                            var crop = gameObject._crop;
                            var cropWidth = crop.width;
                            var cropHeight = crop.height;
                            width = cropWidth;
                            height = cropHeight;
                            srcWidth = cropWidth;
                            srcHeight = cropHeight;
                            frameX = crop.x;
                            frameY = crop.y;
                            var ox = frameX;
                            var oy = frameY;
                            if (flipX) ox = frameWidth - crop.x - cropWidth;
                            if (flipY) oy = frameHeight - crop.y - cropHeight;
                            u0 = ox / textureWidth + uOffset;
                            v0 = oy / textureHeight + vOffset;
                            u1 = (ox + cropWidth) / textureWidth + uOffset;
                            v1 = (oy + cropHeight) / textureHeight + vOffset;
                            x = -displayOriginX + frameX;
                            y = -displayOriginY + frameY;
                        }
                        //  Invert the flipY if this is a RenderTexture
                        flipY = flipY ^ (!skipFlip && texture.isRenderTexture ? 1 : 0);
                        if (flipX) {
                            width *= -1;
                            x += srcWidth;
                        }
                        if (flipY) {
                            height *= -1;
                            y += srcHeight;
                        }
                        if (camera.roundPixels) {
                            srcX = Math.floor(srcX);
                            srcY = Math.floor(srcY);
                        }
                        spriteMatrix.applyITRS(srcX, srcY, rotation, scaleX, scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        if (parentTransformMatrix) {
                            //  Multiply the camera by the parent matrix
                            camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * scrollFactorX, -camera.scrollY * scrollFactorY);
                            //  Undo the camera scroll
                            spriteMatrix.e = srcX;
                            spriteMatrix.f = srcY;
                        } else {
                            spriteMatrix.e -= camera.scrollX * scrollFactorX;
                            spriteMatrix.f -= camera.scrollY * scrollFactorY;
                        }
                        //  Multiply by the Sprite matrix, store result in calcMatrix
                        camMatrix.multiply(spriteMatrix, calcMatrix);
                        var quad = calcMatrix.setQuad(x, y, x + width, y + height, camera.renderRoundPixels);
                        if (textureUnit === undefined || textureUnit === null) textureUnit = this.setTexture2D(texture);
                        if (gameObject && !skipPrePost) this.manager.preBatch(gameObject);
                        this.batchQuad(gameObject, quad[0], quad[1], quad[2], quad[3], quad[4], quad[5], quad[6], quad[7], u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                        if (gameObject && !skipPrePost) this.manager.postBatch(gameObject);
                    },
                    /**
     * Adds a Texture Frame into the batch for rendering.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchTextureFrame
     * @since 3.12.0
     *
     * @param {Phaser.Textures.Frame} frame - The Texture Frame to be rendered.
     * @param {number} x - The horizontal position to render the texture at.
     * @param {number} y - The vertical position to render the texture at.
     * @param {number} tint - The tint color.
     * @param {number} alpha - The alpha value.
     * @param {Phaser.GameObjects.Components.TransformMatrix} transformMatrix - The Transform Matrix to use for the texture.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - A parent Transform Matrix.
     */ batchTextureFrame: function(frame, x, y, tint, alpha, transformMatrix, parentTransformMatrix) {
                        this.manager.set(this);
                        var spriteMatrix = this._tempMatrix1.copyFrom(transformMatrix);
                        var calcMatrix = this._tempMatrix2;
                        if (parentTransformMatrix) spriteMatrix.multiply(parentTransformMatrix, calcMatrix);
                        else calcMatrix = spriteMatrix;
                        var quad = calcMatrix.setQuad(x, y, x + frame.width, y + frame.height);
                        var unit = this.setTexture2D(frame.source.glTexture);
                        tint = Utils.getTintAppendFloatAlpha(tint, alpha);
                        this.batchQuad(null, quad[0], quad[1], quad[2], quad[3], quad[4], quad[5], quad[6], quad[7], frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, 0, frame.glTexture, unit);
                    },
                    /**
     * Pushes a filled rectangle into the vertex batch.
     *
     * Rectangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchFillRect
     * @since 3.55.0
     *
     * @param {number} x - Horizontal top left coordinate of the rectangle.
     * @param {number} y - Vertical top left coordinate of the rectangle.
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillRect: function(x, y, width, height, currentMatrix, parentMatrix) {
                        this.renderer.pipelines.set(this);
                        var calcMatrix = this.calcMatrix;
                        //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                        if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                        var quad = calcMatrix.setQuad(x, y, x + width, y + height);
                        var tint = this.fillTint;
                        this.batchQuad(null, quad[0], quad[1], quad[2], quad[3], quad[4], quad[5], quad[6], quad[7], 0, 0, 1, 1, tint.TL, tint.TR, tint.BL, tint.BR, 2);
                    },
                    /**
     * Pushes a filled triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchFillTriangle
     * @since 3.55.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillTriangle: function(x0, y0, x1, y1, x2, y2, currentMatrix, parentMatrix) {
                        this.renderer.pipelines.set(this);
                        var calcMatrix = this.calcMatrix;
                        //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                        if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                        var tx0 = calcMatrix.getX(x0, y0);
                        var ty0 = calcMatrix.getY(x0, y0);
                        var tx1 = calcMatrix.getX(x1, y1);
                        var ty1 = calcMatrix.getY(x1, y1);
                        var tx2 = calcMatrix.getX(x2, y2);
                        var ty2 = calcMatrix.getY(x2, y2);
                        var tint = this.fillTint;
                        this.batchTri(null, tx0, ty0, tx1, ty1, tx2, ty2, 0, 0, 1, 1, tint.TL, tint.TR, tint.BL, 2);
                    },
                    /**
     * Pushes a stroked triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * The triangle is created from 3 lines and drawn using the `batchStrokePath` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchStrokeTriangle
     * @since 3.55.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {number} lineWidth - The width of the line in pixels.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokeTriangle: function(x0, y0, x1, y1, x2, y2, lineWidth, currentMatrix, parentMatrix) {
                        var tempTriangle = this.tempTriangle;
                        tempTriangle[0].x = x0;
                        tempTriangle[0].y = y0;
                        tempTriangle[0].width = lineWidth;
                        tempTriangle[1].x = x1;
                        tempTriangle[1].y = y1;
                        tempTriangle[1].width = lineWidth;
                        tempTriangle[2].x = x2;
                        tempTriangle[2].y = y2;
                        tempTriangle[2].width = lineWidth;
                        tempTriangle[3].x = x0;
                        tempTriangle[3].y = y0;
                        tempTriangle[3].width = lineWidth;
                        this.batchStrokePath(tempTriangle, lineWidth, false, currentMatrix, parentMatrix);
                    },
                    /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and then passing it through Earcut, which
     * creates a list of polygons. Each polygon is then added to the batch.
     *
     * The path is always automatically closed because it's filled.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchFillPath
     * @since 3.55.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillPath: function(path, currentMatrix, parentMatrix) {
                        this.renderer.pipelines.set(this);
                        var calcMatrix = this.calcMatrix;
                        //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                        if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                        var length = path.length;
                        var polygonCache = this.polygonCache;
                        var polygonIndexArray;
                        var point;
                        var tintTL = this.fillTint.TL;
                        var tintTR = this.fillTint.TR;
                        var tintBL = this.fillTint.BL;
                        for(var pathIndex = 0; pathIndex < length; ++pathIndex){
                            point = path[pathIndex];
                            polygonCache.push(point.x, point.y);
                        }
                        polygonIndexArray = Earcut(polygonCache);
                        length = polygonIndexArray.length;
                        for(var index = 0; index < length; index += 3){
                            var p0 = polygonIndexArray[index + 0] * 2;
                            var p1 = polygonIndexArray[index + 1] * 2;
                            var p2 = polygonIndexArray[index + 2] * 2;
                            var x0 = polygonCache[p0 + 0];
                            var y0 = polygonCache[p0 + 1];
                            var x1 = polygonCache[p1 + 0];
                            var y1 = polygonCache[p1 + 1];
                            var x2 = polygonCache[p2 + 0];
                            var y2 = polygonCache[p2 + 1];
                            var tx0 = calcMatrix.getX(x0, y0);
                            var ty0 = calcMatrix.getY(x0, y0);
                            var tx1 = calcMatrix.getX(x1, y1);
                            var ty1 = calcMatrix.getY(x1, y1);
                            var tx2 = calcMatrix.getX(x2, y2);
                            var ty2 = calcMatrix.getY(x2, y2);
                            this.batchTri(null, tx0, ty0, tx1, ty1, tx2, ty2, 0, 0, 1, 1, tintTL, tintTR, tintBL, 2);
                        }
                        polygonCache.length = 0;
                    },
                    /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and calling `batchLine` for each section
     * of the path.
     *
     * The path is optionally closed at the end.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchStrokePath
     * @since 3.55.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {number} lineWidth - The width of the line segments in pixels.
     * @param {boolean} pathOpen - Indicates if the path should be closed or left open.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokePath: function(path, lineWidth, pathOpen, currentMatrix, parentMatrix) {
                        this.renderer.pipelines.set(this);
                        //  Reset the closePath booleans
                        this.prevQuad[4] = 0;
                        this.firstQuad[4] = 0;
                        var pathLength = path.length - 1;
                        for(var pathIndex = 0; pathIndex < pathLength; pathIndex++){
                            var point0 = path[pathIndex];
                            var point1 = path[pathIndex + 1];
                            this.batchLine(point0.x, point0.y, point1.x, point1.y, point0.width / 2, point1.width / 2, lineWidth, pathIndex, !pathOpen && pathIndex === pathLength - 1, currentMatrix, parentMatrix);
                        }
                    },
                    /**
     * Creates a line out of 4 quads and adds it to the vertex batch based on the given line values.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchLine
     * @since 3.55.0
     *
     * @param {number} ax - x coordinate of the start of the line.
     * @param {number} ay - y coordinate of the start of the line.
     * @param {number} bx - x coordinate of the end of the line.
     * @param {number} by - y coordinate of the end of the line.
     * @param {number} aLineWidth - Width of the start of the line.
     * @param {number} bLineWidth - Width of the end of the line.
     * @param {number} index - If this line is part of a multi-line draw, the index of the line in the draw.
     * @param {boolean} closePath - Does this line close a multi-line path?
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchLine: function(ax, ay, bx, by, aLineWidth, bLineWidth, lineWidth, index, closePath, currentMatrix, parentMatrix) {
                        this.renderer.pipelines.set(this);
                        var calcMatrix = this.calcMatrix;
                        //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                        if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                        var dx = bx - ax;
                        var dy = by - ay;
                        var len = Math.sqrt(dx * dx + dy * dy);
                        if (len === 0) //  Because we cannot (and should not) divide by zero!
                        return;
                        var al0 = aLineWidth * (by - ay) / len;
                        var al1 = aLineWidth * (ax - bx) / len;
                        var bl0 = bLineWidth * (by - ay) / len;
                        var bl1 = bLineWidth * (ax - bx) / len;
                        var lx0 = bx - bl0;
                        var ly0 = by - bl1;
                        var lx1 = ax - al0;
                        var ly1 = ay - al1;
                        var lx2 = bx + bl0;
                        var ly2 = by + bl1;
                        var lx3 = ax + al0;
                        var ly3 = ay + al1;
                        //  tx0 = bottom right
                        var brX = calcMatrix.getX(lx0, ly0);
                        var brY = calcMatrix.getY(lx0, ly0);
                        //  tx1 = bottom left
                        var blX = calcMatrix.getX(lx1, ly1);
                        var blY = calcMatrix.getY(lx1, ly1);
                        //  tx2 = top right
                        var trX = calcMatrix.getX(lx2, ly2);
                        var trY = calcMatrix.getY(lx2, ly2);
                        //  tx3 = top left
                        var tlX = calcMatrix.getX(lx3, ly3);
                        var tlY = calcMatrix.getY(lx3, ly3);
                        var tint = this.strokeTint;
                        var tintTL = tint.TL;
                        var tintTR = tint.TR;
                        var tintBL = tint.BL;
                        var tintBR = tint.BR;
                        //  TL, BL, BR, TR
                        this.batchQuad(null, tlX, tlY, blX, blY, brX, brY, trX, trY, 0, 0, 1, 1, tintTL, tintTR, tintBL, tintBR, 2);
                        if (lineWidth <= 2) //  No point doing a linejoin if the line isn't thick enough
                        return;
                        var prev = this.prevQuad;
                        var first = this.firstQuad;
                        if (index > 0 && prev[4]) this.batchQuad(null, tlX, tlY, blX, blY, prev[0], prev[1], prev[2], prev[3], 0, 0, 1, 1, tintTL, tintTR, tintBL, tintBR, 2);
                        else {
                            first[0] = tlX;
                            first[1] = tlY;
                            first[2] = blX;
                            first[3] = blY;
                            first[4] = 1;
                        }
                        if (closePath && first[4]) //  Add a join for the final path segment
                        this.batchQuad(null, brX, brY, trX, trY, first[0], first[1], first[2], first[3], 0, 0, 1, 1, tintTL, tintTR, tintBL, tintBR, 2);
                        else {
                            //  Store it
                            prev[0] = brX;
                            prev[1] = brY;
                            prev[2] = trX;
                            prev[3] = trY;
                            prev[4] = 1;
                        }
                    },
                    /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#destroy
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
     * @since 3.60.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                        this._tempMatrix1.destroy();
                        this._tempMatrix2.destroy();
                        this._tempMatrix3.destroy();
                        this._tempMatrix1 = null;
                        this._tempMatrix1 = null;
                        this._tempMatrix1 = null;
                        WebGLPipeline.prototype.destroy.call(this);
                        return this;
                    }
                });
                module1.exports = MultiPipeline;
            /***/ },
            /***/ 43439: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var PointLightShaderSourceFS = __webpack_require__(4127);
                var PointLightShaderSourceVS = __webpack_require__(89924);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Point Light Pipeline handles rendering the Point Light Game Objects in WebGL.
 *
 * The fragment shader it uses can be found in `shaders/src/PointLight.frag`.
 * The vertex shader it uses can be found in `shaders/src/PointLight.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2)
 * `inLightPosition` (vec2)
 * `inLightRadius` (float)
 * `inLightAttenuation` (float)
 * `inLightColor` (vec4)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uResolution` (vec2)
 * `uCameraZoom` (sampler2D)
 *
 * @class PointLightPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var PointLightPipeline = new Class({
                    Extends: WebGLPipeline,
                    initialize: function PointLightPipeline(config) {
                        config.vertShader = GetFastValue(config, 'vertShader', PointLightShaderSourceVS);
                        config.fragShader = GetFastValue(config, 'fragShader', PointLightShaderSourceFS);
                        config.attributes = GetFastValue(config, 'attributes', [
                            {
                                name: 'inPosition',
                                size: 2
                            },
                            {
                                name: 'inLightPosition',
                                size: 2
                            },
                            {
                                name: 'inLightRadius'
                            },
                            {
                                name: 'inLightAttenuation'
                            },
                            {
                                name: 'inLightColor',
                                size: 4
                            }
                        ]);
                        WebGLPipeline.call(this, config);
                    },
                    onRender: function(scene, camera) {
                        this.set2f('uResolution', this.width, this.height);
                        this.set1f('uCameraZoom', camera.zoom);
                    },
                    /**
     * Adds a Point Light Game Object to the batch, flushing if required.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PointLightPipeline#batchPointLight
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.PointLight} light - The Point Light Game Object.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the Point Light.
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} lightX - The horizontal center of the light.
     * @param {number} lightY - The vertical center of the light.
     */ batchPointLight: function(light, camera, x0, y0, x1, y1, x2, y2, x3, y3, lightX, lightY) {
                        var color = light.color;
                        var intensity = light.intensity;
                        var radius = light.radius;
                        var attenuation = light.attenuation;
                        var r = color.r * intensity;
                        var g = color.g * intensity;
                        var b = color.b * intensity;
                        var a = camera.alpha * light.alpha;
                        if (this.shouldFlush(6)) this.flush();
                        if (!this.currentBatch) this.setTexture2D();
                        this.batchLightVert(x0, y0, lightX, lightY, radius, attenuation, r, g, b, a);
                        this.batchLightVert(x1, y1, lightX, lightY, radius, attenuation, r, g, b, a);
                        this.batchLightVert(x2, y2, lightX, lightY, radius, attenuation, r, g, b, a);
                        this.batchLightVert(x0, y0, lightX, lightY, radius, attenuation, r, g, b, a);
                        this.batchLightVert(x2, y2, lightX, lightY, radius, attenuation, r, g, b, a);
                        this.batchLightVert(x3, y3, lightX, lightY, radius, attenuation, r, g, b, a);
                        this.currentBatch.count = this.vertexCount - this.currentBatch.start;
                    },
                    /**
     * Adds a single Point Light vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchPointLight`.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PointLightPipeline#batchLightVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} lightX - The horizontal center of the light.
     * @param {number} lightY - The vertical center of the light.
     * @param {number} radius - The radius of the light.
     * @param {number} attenuation - The attenuation of the light.
     * @param {number} r - The red color channel of the light.
     * @param {number} g - The green color channel of the light.
     * @param {number} b - The blue color channel of the light.
     * @param {number} a - The alpha color channel of the light.
     */ batchLightVert: function(x, y, lightX, lightY, radius, attenuation, r, g, b, a) {
                        var vertexViewF32 = this.vertexViewF32;
                        var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                        vertexViewF32[++vertexOffset] = x;
                        vertexViewF32[++vertexOffset] = y;
                        vertexViewF32[++vertexOffset] = lightX;
                        vertexViewF32[++vertexOffset] = lightY;
                        vertexViewF32[++vertexOffset] = radius;
                        vertexViewF32[++vertexOffset] = attenuation;
                        vertexViewF32[++vertexOffset] = r;
                        vertexViewF32[++vertexOffset] = g;
                        vertexViewF32[++vertexOffset] = b;
                        vertexViewF32[++vertexOffset] = a;
                        this.vertexCount++;
                    }
                });
                module1.exports = PointLightPipeline;
            /***/ },
            /***/ 84057: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var ColorMatrix = __webpack_require__(89422);
                var GetFastValue = __webpack_require__(95540);
                var ShaderSourceFS = __webpack_require__(27681);
                var ShaderSourceVS = __webpack_require__(49627);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Post FX Pipeline is a special kind of pipeline specifically for handling post
 * processing effects. Where-as a standard Pipeline allows you to control the process
 * of rendering Game Objects by configuring the shaders and attributes used to draw them,
 * a Post FX Pipeline is designed to allow you to apply processing _after_ the Game Object/s
 * have been rendered. Typical examples of post processing effects are bloom filters,
 * blurs, light effects and color manipulation.
 *
 * The pipeline works by creating a tiny vertex buffer with just one single hard-coded quad
 * in it. Game Objects can have a Post Pipeline set on them. Those objects are then rendered
 * using their standard pipeline, but are redirected to the Render Targets owned by the
 * post pipeline, which can then apply their own shaders and effects, before passing them
 * back to the main renderer.
 *
 * Please see the Phaser 3 examples for further details on this extensive subject.
 *
 * The default fragment shader it uses can be found in `shaders/src/PostFX.frag`.
 * The default vertex shader it uses can be found in `shaders/src/Quad.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 *
 * The vertices array layout is:
 *
 * -1,  1   B----C   1,  1
 *  0,  1   |   /|   1,  1
 *          |  / |
 *          | /  |
 *          |/   |
 * -1, -1   A----D   1, -1
 *  0,  0            1,  0
 *
 * A = -1, -1 (pos) and 0, 0 (uv)
 * B = -1,  1 (pos) and 0, 1 (uv)
 * C =  1,  1 (pos) and 1, 1 (uv)
 * D =  1, -1 (pos) and 1, 0 (uv)
 *
 * First tri: A, B, C
 * Second tri: A, C, D
 *
 * Array index:
 *
 * 0  = Tri 1 - Vert A - x pos
 * 1  = Tri 1 - Vert A - y pos
 * 2  = Tri 1 - Vert A - uv u
 * 3  = Tri 1 - Vert A - uv v
 *
 * 4  = Tri 1 - Vert B - x pos
 * 5  = Tri 1 - Vert B - y pos
 * 6  = Tri 1 - Vert B - uv u
 * 7  = Tri 1 - Vert B - uv v
 *
 * 8  = Tri 1 - Vert C - x pos
 * 9  = Tri 1 - Vert C - y pos
 * 10 = Tri 1 - Vert C - uv u
 * 11 = Tri 1 - Vert C - uv v
 *
 * 12 = Tri 2 - Vert A - x pos
 * 13 = Tri 2 - Vert A - y pos
 * 14 = Tri 2 - Vert A - uv u
 * 15 = Tri 2 - Vert A - uv v
 *
 * 16 = Tri 2 - Vert C - x pos
 * 17 = Tri 2 - Vert C - y pos
 * 18 = Tri 2 - Vert C - uv u
 * 19 = Tri 2 - Vert C - uv v
 *
 * 20 = Tri 2 - Vert D - x pos
 * 21 = Tri 2 - Vert D - y pos
 * 22 = Tri 2 - Vert D - uv u
 * 23 = Tri 2 - Vert D - uv v
 *
 * @class PostFXPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var PostFXPipeline = new Class({
                    Extends: WebGLPipeline,
                    initialize: function PostFXPipeline(config) {
                        config.renderTarget = GetFastValue(config, 'renderTarget', 1);
                        config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS);
                        config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS);
                        config.attributes = GetFastValue(config, 'attributes', [
                            {
                                name: 'inPosition',
                                size: 2
                            },
                            {
                                name: 'inTexCoord',
                                size: 2
                            }
                        ]);
                        config.batchSize = 1;
                        config.vertices = [
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            1,
                            0,
                            1,
                            1,
                            1,
                            1,
                            1,
                            -1,
                            -1,
                            0,
                            0,
                            1,
                            1,
                            1,
                            1,
                            1,
                            -1,
                            1,
                            0
                        ];
                        WebGLPipeline.call(this, config);
                        this.isPostFX = true;
                        /**
         * If this Post Pipeline belongs to a Game Object or Camera,
         * this property contains a reference to it.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#gameObject
         * @type {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)}
         * @since 3.50.0
         */ this.gameObject;
                        /**
         * If this Post Pipeline belongs to an FX Controller, this is a
         * reference to it.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#controller
         * @type {Phaser.FX.Controller}
         * @since 3.60.0
         */ this.controller;
                        /**
         * A Color Matrix instance belonging to this pipeline.
         *
         * Used during calls to the `drawFrame` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#colorMatrix
         * @type {Phaser.Display.ColorMatrix}
         * @since 3.50.0
         */ this.colorMatrix = new ColorMatrix();
                        /**
         * A reference to the Full Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame1;
                        /**
         * A reference to the Full Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame2;
                        /**
         * A reference to the Half Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame1;
                        /**
         * A reference to the Half Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame2;
                        if (this.renderer.isBooted) this.manager = this.renderer.pipelines;
                    },
                    /**
     * This method is called once, when this Post FX Pipeline needs to be used.
     *
     * Normally, pipelines will boot automatically, ready for instant-use, but Post FX
     * Pipelines create quite a lot of internal resources, such as Render Targets, so
     * they don't boot until they are told to do so by the Pipeline Manager, when an
     * actual Game Object needs to use them.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#bootFX
     * @since 3.70.0
     */ bootFX: function() {
                        WebGLPipeline.prototype.boot.call(this);
                        var utility = this.manager.UTILITY_PIPELINE;
                        this.fullFrame1 = utility.fullFrame1;
                        this.fullFrame2 = utility.fullFrame2;
                        this.halfFrame1 = utility.halfFrame1;
                        this.halfFrame2 = utility.halfFrame2;
                        var renderer = this.renderer;
                        this.set1i('uMainSampler', 0);
                        this.set2f('uResolution', renderer.width, renderer.height);
                        var targets = this.renderTargets;
                        for(var i = 0; i < targets.length; i++)targets[i].autoResize = true;
                    },
                    /**
     * This method is called as a result of the `WebGLPipeline.batchQuad` method, right after a quad
     * belonging to a Game Object has been added to the batch. When this is called, the
     * renderer has just performed a flush.
     *
     * It calls the `onDraw` hook followed by the `onPostBatch` hook, which can be used to perform
     * additional Post FX Pipeline processing.
     *
     * It is also called as part of the `PipelineManager.postBatch` method when processing Post FX Pipelines.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#postBatch
     * @since 3.70.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)} [gameObject] - The Game Object or Camera that invoked this pipeline, if any.
     *
     * @return {this} This WebGLPipeline instance.
     */ postBatch: function(gameObject) {
                        if (!this.hasBooted) {
                            this.bootFX();
                            if (this.currentRenderTarget) this.currentRenderTarget.bind();
                        }
                        this.onDraw(this.currentRenderTarget);
                        this.onPostBatch(gameObject);
                        return this;
                    },
                    onDraw: function(renderTarget) {
                        this.bindAndDraw(renderTarget);
                    },
                    /**
     * Returns the FX Controller for this Post FX Pipeline.
     *
     * This is called internally and not typically required outside.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#getController
     * @since 3.60.0
     *
     * @param {Phaser.FX.Controller} [controller] - An FX Controller, or undefined.
     *
     * @return {Phaser.FX.Controller|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} The FX Controller responsible, or this Pipeline.
     */ getController: function(controller) {
                        if (controller !== undefined) return controller;
                        else if (this.controller) return this.controller;
                        else return this;
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * This method does _not_ bind a shader. It uses whatever shader
     * is currently bound in this pipeline. It also does _not_ clear
     * the frame buffers after use. You should take care of both of
     * these things if you call this method directly.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copySprite
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     */ copySprite: function(source, target, reset) {
                        if (reset === undefined) reset = false;
                        var gl = this.gl;
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        var currentFBO = gl.getParameter(gl.FRAMEBUFFER_BINDING);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        if (reset) {
                            gl.bindTexture(gl.TEXTURE_2D, null);
                            gl.bindFramebuffer(gl.FRAMEBUFFER, currentFBO);
                        }
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                        this.manager.copyFrame(source, target, brightness, clear, clearAlpha);
                    },
                    /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                        this.manager.copyToGame(source);
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target, using this pipelines
     * Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ drawFrame: function(source, target, clearAlpha) {
                        this.manager.drawFrame(source, target, clearAlpha, this.colorMatrix);
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFrames: function(source1, source2, target, strength, clearAlpha) {
                        this.manager.blendFrames(source1, source2, target, strength, clearAlpha);
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                        this.manager.blendFramesAdditive(source1, source2, target, strength, clearAlpha);
                    },
                    /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ clearFrame: function(target, clearAlpha) {
                        this.manager.clearFrame(target, clearAlpha);
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                        this.manager.blitFrame(source, target, brightness, clear, clearAlpha, eraseMode);
                    },
                    /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                        this.manager.copyFrameRect(source, target, x, y, width, height, clear, clearAlpha);
                    },
                    /**
     * Binds this pipeline and draws the `source` Render Target to the `target` Render Target.
     *
     * If no `target` is specified, it will pop the framebuffer from the Renderers FBO stack
     * and use that instead, which should be done when you need to draw the final results of
     * this pipeline to the game canvas.
     *
     * You can optionally set the shader to be used for the draw here, if this is a multi-shader
     * pipeline. By default `currentShader` will be used. If you need to set a shader but not
     * a target, just pass `null` as the `target` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#bindAndDraw
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The Render Target to draw to. If not set, it will pop the fbo from the stack.
     * @param {boolean} [clear=true] - Clear the target before copying? Only used if `target` parameter is set.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to use during the draw.
     */ bindAndDraw: function(source, target, clear, clearAlpha, currentShader) {
                        if (clear === undefined) clear = true;
                        if (clearAlpha === undefined) clearAlpha = true;
                        var gl = this.gl;
                        var renderer = this.renderer;
                        this.bind(currentShader);
                        this.set1i('uMainSampler', 0);
                        if (target) {
                            gl.viewport(0, 0, target.width, target.height);
                            gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                            if (clear) {
                                if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                                else gl.clearColor(0, 0, 0, 1);
                                gl.clear(gl.COLOR_BUFFER_BIT);
                            }
                        } else {
                            renderer.popFramebuffer(false, false);
                            if (!renderer.currentFramebuffer) gl.viewport(0, 0, renderer.width, renderer.height);
                        }
                        renderer.restoreStencilMask();
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        if (target) {
                            gl.bindTexture(gl.TEXTURE_2D, null);
                            gl.bindFramebuffer(gl.FRAMEBUFFER, renderer.currentFramebuffer.webGLFramebuffer);
                        }
                    },
                    /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#destroy
     * @since 3.60.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                        if (this.controller) this.controller.destroy();
                        this.gameObject = null;
                        this.controller = null;
                        this.colorMatrix = null;
                        this.fullFrame1 = null;
                        this.fullFrame2 = null;
                        this.halfFrame1 = null;
                        this.halfFrame2 = null;
                        this.manager.removePostPipeline(this);
                        WebGLPipeline.prototype.destroy.call(this);
                        return this;
                    }
                });
                module1.exports = PostFXPipeline;
            /***/ },
            /***/ 43558: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(10312);
                var CenterOn = __webpack_require__(67502);
                var Class = __webpack_require__(83419);
                var ColorMatrixFS = __webpack_require__(96293);
                var GetFastValue = __webpack_require__(95540);
                var MultiPipeline = __webpack_require__(57516);
                var PostFXFS = __webpack_require__(27681);
                var Rectangle = __webpack_require__(87841);
                var RenderTarget = __webpack_require__(32302);
                var SingleQuadFS = __webpack_require__(45561);
                var SingleQuadVS = __webpack_require__(60722);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Pre FX Pipeline is a special kind of pipeline designed specifically for applying
 * special effects to Game Objects before they are rendered. Where-as the Post FX Pipeline applies an effect _after_ the
 * object has been rendered, the Pre FX Pipeline allows you to control the rendering of
 * the object itself - passing it off to its own texture, where multi-buffer compositing
 * can take place.
 *
 * You can only use the PreFX Pipeline on the following types of Game Objects, or those
 * that extend from them:
 *
 * Sprite
 * Image
 * Text
 * TileSprite
 * RenderTexture
 * Video
 *
 * @class PreFXPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var PreFXPipeline = new Class({
                    Extends: MultiPipeline,
                    initialize: function PreFXPipeline(config) {
                        var fragShader = GetFastValue(config, 'fragShader', PostFXFS);
                        var vertShader = GetFastValue(config, 'vertShader', SingleQuadVS);
                        var drawShader = GetFastValue(config, 'drawShader', PostFXFS);
                        var defaultShaders = [
                            {
                                name: 'DrawSprite',
                                fragShader: SingleQuadFS,
                                vertShader: SingleQuadVS
                            },
                            {
                                name: 'CopySprite',
                                fragShader: fragShader,
                                vertShader: vertShader
                            },
                            {
                                name: 'DrawGame',
                                fragShader: drawShader,
                                vertShader: SingleQuadVS
                            },
                            {
                                name: 'ColorMatrix',
                                fragShader: ColorMatrixFS
                            }
                        ];
                        var configShaders = GetFastValue(config, 'shaders', []);
                        config.shaders = defaultShaders.concat(configShaders);
                        if (!config.vertShader) config.vertShader = vertShader;
                        config.batchSize = 1;
                        MultiPipeline.call(this, config);
                        this.isPreFX = true;
                        this.customMainSampler = null;
                        /**
         * A reference to the Draw Sprite Shader belonging to this Pipeline.
         *
         * This shader is used when the sprite is drawn to this fbo (or to the game if drawToFrame is false)
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#drawSpriteShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @default null
         * @since 3.60.0
         */ this.drawSpriteShader;
                        /**
         * A reference to the Copy Shader belonging to this Pipeline.
         *
         * This shader is used when you call the `copySprite` method.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#copyShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @default null
         * @since 3.60.0
         */ this.copyShader;
                        /**
         * A reference to the Game Draw Shader belonging to this Pipeline.
         *
         * This shader draws the fbo to the game.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#gameShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @default null
         * @since 3.60.0
         */ this.gameShader;
                        /**
         * A reference to the Color Matrix Shader belonging to this Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#colorMatrixShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.60.0
         */ this.colorMatrixShader;
                        /**
         * Raw byte buffer of vertices used specifically during the copySprite method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#quadVertexData
         * @type {ArrayBuffer}
         * @readonly
         * @since 3.60.0
         */ this.quadVertexData;
                        /**
         * The WebGLBuffer that holds the quadVertexData.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#quadVertexBuffer
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper}
         * @readonly
         * @since 3.60.0
         */ this.quadVertexBuffer;
                        /**
         * Float32 view of the quad array buffer.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#quadVertexViewF32
         * @type {Float32Array}
         * @since 3.60.0
         */ this.quadVertexViewF32;
                        /**
         * A temporary Rectangle object re-used internally during sprite drawing.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#spriteBounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.60.0
         */ this.spriteBounds = new Rectangle();
                        /**
         * A temporary Rectangle object re-used internally during sprite drawing.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#targetBounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.60.0
         */ this.targetBounds = new Rectangle();
                        /**
         * The full-screen Render Target that the sprite is first drawn to.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#fsTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.60.0
         */ this.fsTarget;
                        /**
         * The most recent Game Object drawn.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#tempSprite
         * @type {Phaser.GameObjects.Sprite}
         * @private
         * @since 3.60.0
         */ this.tempSprite;
                        if (this.renderer.isBooted) {
                            this.manager = this.renderer.pipelines;
                            this.boot();
                        }
                    },
                    boot: function() {
                        WebGLPipeline.prototype.boot.call(this);
                        var shaders = this.shaders;
                        var renderer = this.renderer;
                        this.drawSpriteShader = shaders[0];
                        this.copyShader = shaders[1];
                        this.gameShader = shaders[2];
                        this.colorMatrixShader = shaders[3];
                        //  Our full-screen target (exclusive to this pipeline)
                        this.fsTarget = new RenderTarget(renderer, renderer.width, renderer.height, 1, 0, true, true);
                        //  Copy by reference the RTs in the PipelineManager, plus add our fsTarget
                        this.renderTargets = this.manager.renderTargets.concat(this.fsTarget);
                        // 6 verts * 28 bytes
                        var data = new ArrayBuffer(168);
                        this.quadVertexData = data;
                        this.quadVertexViewF32 = new Float32Array(data);
                        this.quadVertexBuffer = renderer.createVertexBuffer(data, this.gl.STATIC_DRAW);
                        this.onResize(renderer.width, renderer.height);
                        //  So calls to set uniforms in onPreRender target the right shader:
                        this.currentShader = this.copyShader;
                        this.set2f('uResolution', renderer.width, renderer.height);
                    },
                    /**
     * Handles the resizing of the quad vertex data.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#onResize
     * @since 3.60.0
     *
     * @param {number} width - The new width of the quad.
     * @param {number} height - The new height of the quad.
     */ onResize: function(width, height) {
                        var vertexViewF32 = this.quadVertexViewF32;
                        //  vertexBuffer indexes:
                        //  Each vert: [ x, y, u, v, unit, mode, tint ]
                        //  0 - 6     - vert 1 - x0/y0
                        //  7 - 13    - vert 2 - x1/y1
                        //  14 - 20   - vert 3 - x2/y2
                        //  21 - 27   - vert 4 - x0/y0
                        //  28 - 34   - vert 5 - x2/y2
                        //  35 - 41   - vert 6 - x3/y3
                        //  Verts
                        vertexViewF32[1] = height; // y0
                        vertexViewF32[22] = height; // y0
                        vertexViewF32[14] = width; // x2
                        vertexViewF32[28] = width; // x2
                        vertexViewF32[35] = width; // x3
                        vertexViewF32[36] = height; // y3
                    },
                    /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 6 vertices in the following arrangement:
     *
     * ```
     * 0----3
     * |\  B|
     * | \  |
     * |  \ |
     * | A \|
     * |    \
     * 1----2
     * ```
     *
     * Where x0 / y0 = 0, x1 / y1 = 1, x2 / y2 = 2 and x3 / y3 = 3
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#batchQuad
     * @since 3.60.0
     *
     * @param {(Phaser.GameObjects.GameObject|null)} gameObject - The Game Object, if any, drawing this quad.
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {number} tintBR - The bottom-right tint color value.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} [texture] - Texture that will be assigned to the current batch if a flush occurs.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchQuad: function(gameObject, x0, y0, x1, y1, x2, y2, x3, y3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture) {
                        var bx = Math.min(x0, x1, x2, x3);
                        var by = Math.min(y0, y1, y2, y3);
                        var br = Math.max(x0, x1, x2, x3);
                        var bb = Math.max(y0, y1, y2, y3);
                        var bw = br - bx;
                        var bh = bb - by;
                        var bounds = this.spriteBounds.setTo(bx, by, bw, bh);
                        var padding = gameObject ? gameObject.preFX.padding : 0;
                        var width = bw + padding * 2;
                        var height = bh + padding * 2;
                        var maxDimension = Math.abs(Math.max(width, height));
                        var target = this.manager.getRenderTarget(maxDimension);
                        var targetBounds = this.targetBounds.setTo(0, 0, target.width, target.height);
                        //  targetBounds is the same size as the fbo and centered on the spriteBounds
                        //  so we can use it when we re-render this back to the game
                        CenterOn(targetBounds, Math.round(bounds.centerX), Math.round(bounds.centerY));
                        this.tempSprite = gameObject;
                        //  Now draw the quad
                        var gl = this.gl;
                        var renderer = this.renderer;
                        renderer.clearStencilMask();
                        this.setShader(this.drawSpriteShader);
                        this.set1i('uMainSampler', 0);
                        this.set2f('uResolution', renderer.width, renderer.height);
                        this.flipProjectionMatrix(true);
                        if (gameObject) {
                            this.onDrawSprite(gameObject, target);
                            gameObject.preFX.onFX(this);
                        }
                        var fsTarget = this.fsTarget;
                        this.flush();
                        gl.viewport(0, 0, renderer.width, renderer.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, fsTarget.framebuffer.webGLFramebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, fsTarget.texture.webGLTexture, 0);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        this.setTexture2D(texture);
                        this.batchVert(x0, y0, u0, v0, 0, tintEffect, tintTL);
                        this.batchVert(x1, y1, u0, v1, 0, tintEffect, tintBL);
                        this.batchVert(x2, y2, u1, v1, 0, tintEffect, tintBR);
                        this.batchVert(x0, y0, u0, v0, 0, tintEffect, tintTL);
                        this.batchVert(x2, y2, u1, v1, 0, tintEffect, tintBR);
                        this.batchVert(x3, y3, u1, v0, 0, tintEffect, tintTR);
                        this.flush();
                        this.flipProjectionMatrix(false);
                        //  Now we've got the sprite drawn to our screen-sized fbo, copy the rect we need to our target
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, target.texture.webGLTexture);
                        gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, targetBounds.x, targetBounds.y, targetBounds.width, targetBounds.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                        //  We've drawn the sprite to the target (using our pipeline shader)
                        //  we can pass it to the pipeline in case they want to do further
                        //  manipulations with it, post-fx style, then we need to draw the
                        //  results back to the game in the correct position
                        this.onBatch(gameObject);
                        //  Set this here, so we can immediately call the set uniform functions and it'll work on the correct shader
                        this.currentShader = this.copyShader;
                        this.onDraw(target, this.manager.getSwapRenderTarget(), this.manager.getAltSwapRenderTarget());
                        return true;
                    },
                    /**
     * This callback is invoked when a sprite is drawn by this pipeline.
     *
     * It will fire after the shader has been set, but before the sprite has been drawn,
     * so use it to set any additional uniforms you may need.
     *
     * Note: Manipulating the Sprite during this callback will _not_ change how it is drawn to the Render Target.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#onDrawSprite
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.Sprite} gameObject - The Sprite being drawn.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target the Sprite will be drawn to.
     */ onDrawSprite: function() {},
                    /**
     * This callback is invoked when you call the `copySprite` method.
     *
     * It will fire after the shader has been set, but before the source target has been copied,
     * so use it to set any additional uniforms you may need.
     *
     * Note: Manipulating the Sprite during this callback will _not_ change the Render Targets.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#onCopySprite
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target being copied from.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target that will be copied to.
     * @param {Phaser.GameObjects.Sprite} gameObject - The Sprite being copied.
     */ onCopySprite: function() {},
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * No target resizing takes place. If the `source` Render Target is larger than the `target`,
     * then only a portion the same size as the `target` dimensions is copied across.
     *
     * Calling this method will invoke the `onCopySprite` handler and will also call
     * the `onFXCopy` callback on the Sprite. Both of these happen prior to the copy, allowing you
     * to use them to set shader uniforms and other values.
     *
     * You can optionally pass in a ColorMatrix. If so, it will use the ColorMatrix shader
     * during the copy, allowing you to manipulate the colors to a fine degree.
     * See the `ColorMatrix` class for more details.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#copySprite
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target being copied from.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target that will be copied to.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     * @param {Phaser.Display.ColorMatrix} [colorMatrix] - Optional ColorMatrix to use when copying the Sprite.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to use to copy the target. Defaults to the `copyShader`.
     */ copySprite: function(source, target, clear, clearAlpha, eraseMode, colorMatrix, shader) {
                        if (clear === undefined) clear = true;
                        if (clearAlpha === undefined) clearAlpha = true;
                        if (eraseMode === undefined) eraseMode = false;
                        if (shader === undefined) shader = this.copyShader;
                        var gl = this.gl;
                        var sprite = this.tempSprite;
                        if (colorMatrix) shader = this.colorMatrixShader;
                        this.currentShader = shader;
                        var wasBound = this.setVertexBuffer(this.quadVertexBuffer);
                        shader.bind(wasBound, false);
                        var renderer = this.renderer;
                        this.set1i('uMainSampler', 0);
                        this.set2f('uResolution', renderer.width, renderer.height);
                        sprite.preFX.onFXCopy(this);
                        this.onCopySprite(source, target, sprite);
                        if (colorMatrix) {
                            this.set1fv('uColorMatrix', colorMatrix.getData());
                            this.set1f('uAlpha', colorMatrix.alpha);
                        }
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        if (source.height > target.height) {
                            gl.viewport(0, 0, source.width, source.height);
                            this.setTargetUVs(source, target);
                        } else {
                            var diff = target.height - source.height;
                            gl.viewport(0, diff, source.width, source.height);
                            this.resetUVs();
                        }
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                        if (clear) {
                            gl.clearColor(0, 0, 0, Number(!clearAlpha));
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                        if (eraseMode) {
                            var blendMode = this.renderer.currentBlendMode;
                            this.renderer.setBlendMode(BlendModes.ERASE);
                        }
                        gl.bufferData(gl.ARRAY_BUFFER, this.quadVertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        if (eraseMode) this.renderer.setBlendMode(blendMode);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    },
                    /**
     * Draws the `source` Render Target to the `target` Render Target.
     *
     * This is done using whatever the currently bound shader is. This method does
     * not set a shader. All it does is bind the source texture, set the viewport and UVs
     * then bind the target framebuffer, clears it and draws the source to it.
     *
     * At the end a null framebuffer is bound. No other clearing-up takes place, so
     * use this method carefully.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#copy
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     */ copy: function(source, target) {
                        var gl = this.gl;
                        this.set1i('uMainSampler', 0);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        //  source and target must always be the same size
                        gl.viewport(0, 0, source.width, source.height);
                        this.setUVs(0, 0, 0, 1, 1, 1, 1, 0);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        gl.bufferData(gl.ARRAY_BUFFER, this.quadVertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#blendFrames
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFrames: function(source1, source2, target, strength, clearAlpha) {
                        this.manager.blendFrames(source1, source2, target, strength, clearAlpha);
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#blendFramesAdditive
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                        this.manager.blendFramesAdditive(source1, source2, target, strength, clearAlpha);
                    },
                    /**
     * This method will copy the given Render Target to the game canvas using the `copyShader`.
     *
     * This applies the results of the copy shader during the draw.
     *
     * If you wish to copy the target without any effects see the `copyToGame` method instead.
     *
     * This method should be the final thing called in your pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#drawToGame
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw to the game.
     */ drawToGame: function(source) {
                        this.currentShader = null;
                        this.setShader(this.copyShader);
                        this.bindAndDraw(source);
                    },
                    /**
     * This method will copy the given Render Target to the game canvas using the `gameShader`.
     *
     * Unless you've changed it, the `gameShader` copies the target without modifying it, just
     * ensuring it is placed in the correct location on the canvas.
     *
     * If you wish to draw the target with and apply the fragment shader at the same time,
     * see the `drawToGame` method instead.
     *
     * This method should be the final thing called in your pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#copyToGame
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to copy to the game.
     */ copyToGame: function(source) {
                        this.currentShader = null;
                        this.setShader(this.gameShader);
                        this.bindAndDraw(source);
                    },
                    /**
     * This method is called by `drawToGame` and `copyToGame`. It takes the source Render Target
     * and copies it back to the game canvas, or the next frame buffer in the stack, and should
     * be considered the very last thing this pipeline does.
     *
     * You don't normally need to call this method, or override it, however it is left public
     * should you wish to do so.
     *
     * Note that it does _not_ set a shader. You should do this yourself if invoking this.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#bindAndDraw
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw to the game.
     */ bindAndDraw: function(source) {
                        var gl = this.gl;
                        var renderer = this.renderer;
                        this.set1i('uMainSampler', 0);
                        if (this.customMainSampler) this.setTexture2D(this.customMainSampler);
                        else this.setTexture2D(source.texture);
                        var matrix = this._tempMatrix1.loadIdentity();
                        var x = this.targetBounds.x;
                        var y = this.targetBounds.y;
                        var xw = x + source.width;
                        var yh = y + source.height;
                        var x0 = matrix.getX(x, y);
                        var x1 = matrix.getX(x, yh);
                        var x2 = matrix.getX(xw, yh);
                        var x3 = matrix.getX(xw, y);
                        //  Regular verts
                        var y0 = matrix.getY(x, y);
                        var y1 = matrix.getY(x, yh);
                        var y2 = matrix.getY(xw, yh);
                        var y3 = matrix.getY(xw, y);
                        //  Flip verts:
                        // var y0 = matrix.getY(x, yh);
                        // var y1 = matrix.getY(x, y);
                        // var y2 = matrix.getY(xw, y);
                        // var y3 = matrix.getY(xw, yh);
                        var white = 0xffffff;
                        this.batchVert(x0, y0, 0, 0, 0, 0, white);
                        this.batchVert(x1, y1, 0, 1, 0, 0, white);
                        this.batchVert(x2, y2, 1, 1, 0, 0, white);
                        this.batchVert(x0, y0, 0, 0, 0, 0, white);
                        this.batchVert(x2, y2, 1, 1, 0, 0, white);
                        this.batchVert(x3, y3, 1, 0, 0, 0, white);
                        renderer.restoreFramebuffer(false, true);
                        if (!renderer.currentFramebuffer) gl.viewport(0, 0, renderer.width, renderer.height);
                        renderer.restoreStencilMask();
                        this.flush();
                        //  Clear the source framebuffer out, ready for the next pass
                        // gl.clearColor(0, 0, 0, 0);
                        // gl.bindFramebuffer(gl.FRAMEBUFFER, source.framebuffer.webGLFramebuffer);
                        // gl.clear(gl.COLOR_BUFFER_BIT);
                        // gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        //  No hanging references
                        this.tempSprite = null;
                    },
                    /**
     * This method is called every time the `batchSprite` method is called and is passed a
     * reference to the current render target.
     *
     * If you override this method, then it should make sure it calls either the
     * `drawToGame` or `copyToGame` methods as the final thing it does. However, you can do as
     * much additional processing as you like prior to this.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#onDraw
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to draw to the game.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [swapTarget] - The Swap Render Target, useful for double-buffer effects.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [altSwapTarget] - The Swap Render Target, useful for double-buffer effects.
     */ onDraw: function(target) {
                        this.drawToGame(target);
                    },
                    /**
     * Set the UV values for the 6 vertices that make up the quad used by the copy shader.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#setUVs
     * @since 3.60.0
     *
     * @param {number} uA - The u value of vertex A.
     * @param {number} vA - The v value of vertex A.
     * @param {number} uB - The u value of vertex B.
     * @param {number} vB - The v value of vertex B.
     * @param {number} uC - The u value of vertex C.
     * @param {number} vC - The v value of vertex C.
     * @param {number} uD - The u value of vertex D.
     * @param {number} vD - The v value of vertex D.
     */ setUVs: function(uA, vA, uB, vB, uC, vC, uD, vD) {
                        var vertexViewF32 = this.quadVertexViewF32;
                        vertexViewF32[2] = uA;
                        vertexViewF32[3] = vA;
                        vertexViewF32[9] = uB;
                        vertexViewF32[10] = vB;
                        vertexViewF32[16] = uC;
                        vertexViewF32[17] = vC;
                        vertexViewF32[23] = uA;
                        vertexViewF32[24] = vA;
                        vertexViewF32[30] = uC;
                        vertexViewF32[31] = vC;
                        vertexViewF32[37] = uD;
                        vertexViewF32[38] = vD;
                    },
                    /**
     * Sets the vertex UV coordinates of the quad used by the copy shaders
     * so that they correctly adjust the texture coordinates for a blit frame effect.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#setTargetUVs
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     */ setTargetUVs: function(source, target) {
                        var diff = target.height / source.height;
                        if (diff > 0.5) diff = 0.5 - (diff - 0.5);
                        else diff = 0.5 + (0.5 - diff);
                        this.setUVs(0, diff, 0, 1 + diff, 1, 1 + diff, 1, diff);
                    },
                    /**
     * Resets the quad vertice UV values to their default settings.
     *
     * The quad is used by the copy shader in this pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#resetUVs
     * @since 3.60.0
     */ resetUVs: function() {
                        this.setUVs(0, 0, 0, 1, 1, 1, 1, 0);
                    },
                    /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PreFXPipeline#destroy
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
     * @since 3.60.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                        this.renderer.deleteBuffer(this.quadVertexBuffer);
                        this.drawSpriteShader = null;
                        this.copyShader = null;
                        this.gameShader = null;
                        this.colorMatrixShader = null;
                        this.quadVertexData = null;
                        this.quadVertexBuffer = null;
                        this.quadVertexViewF32 = null;
                        this.fsTarget = null;
                        this.tempSprite = null;
                        MultiPipeline.prototype.destroy.call(this);
                        return this;
                    }
                });
                module1.exports = PreFXPipeline;
            /***/ },
            /***/ 81041: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var MultiPipeline = __webpack_require__(57516);
                /**
 * @classdesc
 * The Rope Pipeline is a variation of the Multi Pipeline that uses a `TRIANGLE_STRIP` for
 * its topology, instead of TRIANGLES. This is primarily used by the Rope Game Object,
 * or anything that extends it.
 *
 * Prior to Phaser v3.50 this pipeline was called the `TextureTintStripPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Multi.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uResolution` (vec2)
 * `uMainSampler` (sampler2D, or sampler2D array)
 *
 * The pipeline is structurally identical to the Multi Pipeline and should be treated as such.
 *
 * @class RopePipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var RopePipeline = new Class({
                    Extends: MultiPipeline,
                    initialize: function RopePipeline(config) {
                        //  GLenum 5 = TRIANGLE_STRIP
                        config.topology = 5;
                        config.batchSize = GetFastValue(config, 'batchSize', 256);
                        MultiPipeline.call(this, config);
                    }
                });
                module1.exports = RopePipeline;
            /***/ },
            /***/ 12385: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var MultiPipeline = __webpack_require__(57516);
                var ShaderSourceFS = __webpack_require__(45561);
                var ShaderSourceVS = __webpack_require__(60722);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Single Pipeline is a special version of the Multi Pipeline that only ever
 * uses one texture, bound to texture unit zero. Although not as efficient as the
 * Multi Pipeline, it provides an easier way to create custom pipelines that only require
 * a single bound texture.
 *
 * Prior to Phaser v3.50 this pipeline didn't exist, but could be compared to the old `TextureTintPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Single.frag`.
 * The vertex shader it uses can be found in `shaders/src/Single.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16) - this value is always zero in the Single Pipeline
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uResolution` (vec2)
 * `uMainSampler` (sampler2D, or sampler2D array)
 *
 * @class SinglePipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var SinglePipeline = new Class({
                    Extends: MultiPipeline,
                    initialize: function SinglePipeline(config) {
                        config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS), config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS), config.forceZero = true;
                        MultiPipeline.call(this, config);
                    },
                    boot: function() {
                        WebGLPipeline.prototype.boot.call(this);
                        var renderer = this.renderer;
                        this.set1i('uMainSampler', 0);
                        this.set2f('uResolution', renderer.width, renderer.height);
                    }
                });
                module1.exports = SinglePipeline;
            /***/ },
            /***/ 7589: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddBlendFS = __webpack_require__(35407);
                var BlendModes = __webpack_require__(10312);
                var Class = __webpack_require__(83419);
                var ColorMatrix = __webpack_require__(89422);
                var ColorMatrixFS = __webpack_require__(96293);
                var CopyFS = __webpack_require__(36682);
                var GetFastValue = __webpack_require__(95540);
                var LinearBlendFS = __webpack_require__(48247);
                var QuadVS = __webpack_require__(49627);
                var WebGLPipeline = __webpack_require__(29100);
                /**
 * @classdesc
 * The Utility Pipeline is a special-use pipeline that belongs to the Pipeline Manager.
 *
 * It provides 4 shaders and handy associated methods:
 *
 * 1) Copy Shader. A fast texture to texture copy shader with optional brightness setting.
 * 2) Additive Blend Mode Shader. Blends two textures using an additive blend mode.
 * 3) Linear Blend Mode Shader. Blends two textures using a linear blend mode.
 * 4) Color Matrix Copy Shader. Draws a texture to a target using a Color Matrix.
 *
 * You do not extend this pipeline, but instead get a reference to it from the Pipeline
 * Manager via the `setUtility` method. You can also access methods such as `copyFrame`
 * directly from the Pipeline Manager.
 *
 * This pipeline provides methods for manipulating framebuffer backed textures, such as
 * copying or blending one texture to another, copying a portion of a texture, additively
 * blending two textures, flipping textures and more.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 *
 * This pipeline has a hard-coded batch size of 1 and a hard coded set of vertices.
 *
 * @class UtilityPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var UtilityPipeline = new Class({
                    Extends: WebGLPipeline,
                    initialize: function UtilityPipeline(config) {
                        config.renderTarget = GetFastValue(config, 'renderTarget', [
                            {
                                scale: 1,
                                autoResize: true
                            },
                            {
                                scale: 1,
                                autoResize: true
                            },
                            {
                                scale: 0.5,
                                autoResize: true
                            },
                            {
                                scale: 0.5,
                                autoResize: true
                            }
                        ]);
                        config.vertShader = GetFastValue(config, 'vertShader', QuadVS);
                        config.shaders = GetFastValue(config, 'shaders', [
                            {
                                name: 'Copy',
                                fragShader: CopyFS
                            },
                            {
                                name: 'AddBlend',
                                fragShader: AddBlendFS
                            },
                            {
                                name: 'LinearBlend',
                                fragShader: LinearBlendFS
                            },
                            {
                                name: 'ColorMatrix',
                                fragShader: ColorMatrixFS
                            }
                        ]);
                        config.attributes = GetFastValue(config, 'attributes', [
                            {
                                name: 'inPosition',
                                size: 2
                            },
                            {
                                name: 'inTexCoord',
                                size: 2
                            }
                        ]);
                        config.vertices = [
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            1,
                            0,
                            1,
                            1,
                            1,
                            1,
                            1,
                            -1,
                            -1,
                            0,
                            0,
                            1,
                            1,
                            1,
                            1,
                            1,
                            -1,
                            1,
                            0
                        ];
                        config.batchSize = 1;
                        WebGLPipeline.call(this, config);
                        /**
         * A default Color Matrix, used by the Color Matrix Shader when one
         * isn't provided.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#colorMatrix
         * @type {Phaser.Display.ColorMatrix}
         * @since 3.50.0
         */ this.colorMatrix = new ColorMatrix();
                        /**
         * A reference to the Copy Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @default null
         * @since 3.50.0
         */ this.copyShader;
                        /**
         * A reference to the Additive Blend Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#addShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.addShader;
                        /**
         * A reference to the Linear Blend Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#linearShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.linearShader;
                        /**
         * A reference to the Color Matrix Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#colorMatrixShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.colorMatrixShader;
                        /**
         * A reference to the Full Frame 1 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.fullFrame1;
                        /**
         * A reference to the Full Frame 2 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.fullFrame2;
                        /**
         * A reference to the Half Frame 1 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.halfFrame1;
                        /**
         * A reference to the Half Frame 2 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.halfFrame2;
                    },
                    boot: function() {
                        WebGLPipeline.prototype.boot.call(this);
                        var shaders = this.shaders;
                        var targets = this.renderTargets;
                        this.copyShader = shaders[0];
                        this.addShader = shaders[1];
                        this.linearShader = shaders[2];
                        this.colorMatrixShader = shaders[3];
                        this.fullFrame1 = targets[0];
                        this.fullFrame2 = targets[1];
                        this.halfFrame1 = targets[2];
                        this.halfFrame2 = targets[3];
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                        if (brightness === undefined) brightness = 1;
                        if (clear === undefined) clear = true;
                        if (clearAlpha === undefined) clearAlpha = true;
                        var gl = this.gl;
                        this.setShader(this.copyShader);
                        this.set1i('uMainSampler', 0);
                        this.set1f('uBrightness', brightness);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        if (target) {
                            gl.viewport(0, 0, target.width, target.height);
                            gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                        } else gl.viewport(0, 0, source.width, source.height);
                        if (clear) {
                            if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                            else gl.clearColor(0, 0, 0, 1);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                        gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     * @param {boolean} [flipY=false] - Flip the UV on the Y axis before drawing?
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode, flipY) {
                        if (brightness === undefined) brightness = 1;
                        if (clear === undefined) clear = true;
                        if (clearAlpha === undefined) clearAlpha = true;
                        if (eraseMode === undefined) eraseMode = false;
                        if (flipY === undefined) flipY = false;
                        var gl = this.gl;
                        this.setShader(this.copyShader);
                        this.set1i('uMainSampler', 0);
                        this.set1f('uBrightness', brightness);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        if (source.height > target.height) {
                            gl.viewport(0, 0, source.width, source.height);
                            this.setTargetUVs(source, target);
                        } else {
                            var diff = target.height - source.height;
                            gl.viewport(0, diff, source.width, source.height);
                        }
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                        if (clear) {
                            if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                            else gl.clearColor(0, 0, 0, 1);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                        if (eraseMode) {
                            var blendMode = this.renderer.currentBlendMode;
                            this.renderer.setBlendMode(BlendModes.ERASE);
                        }
                        if (flipY) this.flipY();
                        gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        if (eraseMode) this.renderer.setBlendMode(blendMode);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                        this.resetUVs();
                    },
                    /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                        if (clear === undefined) clear = true;
                        if (clearAlpha === undefined) clearAlpha = true;
                        var gl = this.gl;
                        gl.bindFramebuffer(gl.FRAMEBUFFER, source.framebuffer.webGLFramebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, source.texture.webGLTexture, 0);
                        if (clear) {
                            if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                            else gl.clearColor(0, 0, 0, 1);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, target.texture.webGLTexture);
                        gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, y, width, height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                    },
                    /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                        var gl = this.gl;
                        this.setShader(this.copyShader);
                        this.set1i('uMainSampler', 0);
                        this.set1f('uBrightness', 1);
                        this.renderer.popFramebuffer();
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                    },
                    /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Display.ColorMatrix} [colorMatrix] - The Color Matrix to use when performing the draw.
     */ drawFrame: function(source, target, clearAlpha, colorMatrix) {
                        if (clearAlpha === undefined) clearAlpha = true;
                        if (colorMatrix === undefined) colorMatrix = this.colorMatrix;
                        var gl = this.gl;
                        this.setShader(this.colorMatrixShader);
                        this.set1i('uMainSampler', 0);
                        this.set1fv('uColorMatrix', colorMatrix.getData());
                        this.set1f('uAlpha', colorMatrix.alpha);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source.texture.webGLTexture);
                        if (target) {
                            gl.viewport(0, 0, target.width, target.height);
                            gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                        } else gl.viewport(0, 0, source.width, source.height);
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Renderer.WebGL.WebGLShader} [blendShader] - The shader to use during the blend copy.
     */ blendFrames: function(source1, source2, target, strength, clearAlpha, blendShader) {
                        if (strength === undefined) strength = 1;
                        if (clearAlpha === undefined) clearAlpha = true;
                        if (blendShader === undefined) blendShader = this.linearShader;
                        var gl = this.gl;
                        this.setShader(blendShader);
                        this.set1i('uMainSampler1', 0);
                        this.set1i('uMainSampler2', 1);
                        this.set1f('uStrength', strength);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, source1.texture.webGLTexture);
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, source2.texture.webGLTexture);
                        if (target) {
                            gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture.webGLTexture, 0);
                            gl.viewport(0, 0, target.width, target.height);
                        } else gl.viewport(0, 0, source1.width, source1.height);
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                    },
                    /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                        this.blendFrames(source1, source2, target, strength, clearAlpha, this.addShader);
                    },
                    /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ clearFrame: function(target, clearAlpha) {
                        if (clearAlpha === undefined) clearAlpha = true;
                        var gl = this.gl;
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer.webGLFramebuffer);
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        var fbo = this.renderer.currentFramebuffer;
                        gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.webGLFramebuffer);
                    },
                    /**
     * Set the UV values for the 6 vertices that make up the quad used by the shaders
     * in the Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#setUVs
     * @since 3.50.0
     *
     * @param {number} uA - The u value of vertex A.
     * @param {number} vA - The v value of vertex A.
     * @param {number} uB - The u value of vertex B.
     * @param {number} vB - The v value of vertex B.
     * @param {number} uC - The u value of vertex C.
     * @param {number} vC - The v value of vertex C.
     * @param {number} uD - The u value of vertex D.
     * @param {number} vD - The v value of vertex D.
     */ setUVs: function(uA, vA, uB, vB, uC, vC, uD, vD) {
                        var vertexViewF32 = this.vertexViewF32;
                        vertexViewF32[2] = uA;
                        vertexViewF32[3] = vA;
                        vertexViewF32[6] = uB;
                        vertexViewF32[7] = vB;
                        vertexViewF32[10] = uC;
                        vertexViewF32[11] = vC;
                        vertexViewF32[14] = uA;
                        vertexViewF32[15] = vA;
                        vertexViewF32[18] = uC;
                        vertexViewF32[19] = vC;
                        vertexViewF32[22] = uD;
                        vertexViewF32[23] = vD;
                    },
                    /**
     * Sets the vertex UV coordinates of the quad used by the shaders in the Utility Pipeline
     * so that they correctly adjust the texture coordinates for a blit frame effect.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#setTargetUVs
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     */ setTargetUVs: function(source, target) {
                        var diff = target.height / source.height;
                        if (diff > 0.5) diff = 0.5 - (diff - 0.5);
                        else diff = 0.5 + (0.5 - diff);
                        this.setUVs(0, diff, 0, 1 + diff, 1, 1 + diff, 1, diff);
                    },
                    /**
     * Horizontally flips the UV coordinates of the quad used by the shaders in this
     * Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#flipX
     * @since 3.50.0
     */ flipX: function() {
                        this.setUVs(1, 0, 1, 1, 0, 1, 0, 0);
                    },
                    /**
     * Vertically flips the UV coordinates of the quad used by the shaders in this
     * Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#flipY
     * @since 3.50.0
     */ flipY: function() {
                        this.setUVs(0, 1, 0, 0, 1, 0, 1, 1);
                    },
                    /**
     * Resets the quad vertice UV values to their default settings.
     *
     * The quad is used by all shaders of the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#resetUVs
     * @since 3.50.0
     */ resetUVs: function() {
                        this.setUVs(0, 0, 0, 1, 1, 1, 1, 0);
                    }
                });
                module1.exports = UtilityPipeline;
            /***/ },
            /***/ 36060: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PIPELINE_CONST = {
                    /**
     * The Bitmap Mask Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.BITMAPMASK_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ BITMAPMASK_PIPELINE: 'BitmapMaskPipeline',
                    /**
     * The Light 2D Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.LIGHT_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ LIGHT_PIPELINE: 'Light2D',
                    /**
     * The Point Light Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.POINTLIGHT_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ POINTLIGHT_PIPELINE: 'PointLightPipeline',
                    /**
     * The Single Texture Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.SINGLE_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ SINGLE_PIPELINE: 'SinglePipeline',
                    /**
     * The Multi Texture Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.MULTI_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ MULTI_PIPELINE: 'MultiPipeline',
                    /**
     * The Rope Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.ROPE_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ ROPE_PIPELINE: 'RopePipeline',
                    /**
     * The Graphics and Shapes Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.GRAPHICS_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ GRAPHICS_PIPELINE: 'GraphicsPipeline',
                    /**
     * The Post FX Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.POSTFX_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ POSTFX_PIPELINE: 'PostFXPipeline',
                    /**
     * The Utility Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.UTILITY_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ UTILITY_PIPELINE: 'UtilityPipeline',
                    /**
     * The Mobile Texture Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.MOBILE_PIPELINE
     * @type {string}
     * @const
     * @since 3.60.0
     */ MOBILE_PIPELINE: 'MobilePipeline',
                    /**
     * The Special FX Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.FX_PIPELINE
     * @type {string}
     * @const
     * @since 3.60.0
     */ FX_PIPELINE: 'FxPipeline'
                };
                module1.exports = PIPELINE_CONST;
            /***/ },
            /***/ 84817: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline After Flush Event.
 *
 * This event is dispatched by a WebGLPipeline right after it has issued a drawArrays command
 * and cleared its vertex count.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#AFTER_FLUSH
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that has flushed.
 * @param {boolean} isPostFlush - Was this flush invoked as part of a post-process, or not?
 */ module1.exports = 'pipelineafterflush';
            /***/ },
            /***/ 36712: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Before Flush Event.
 *
 * This event is dispatched by a WebGLPipeline right before it is about to
 * flush and issue a bufferData and drawArrays command.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BEFORE_FLUSH
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that is about to flush.
 * @param {boolean} isPostFlush - Was this flush invoked as part of a post-process, or not?
 */ module1.exports = 'pipelinebeforeflush';
            /***/ },
            /***/ 40285: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Bind Event.
 *
 * This event is dispatched by a WebGLPipeline when it is bound by the Pipeline Manager.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BIND
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was bound.
 * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as being current.
 */ module1.exports = 'pipelinebind';
            /***/ },
            /***/ 65918: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Boot Event.
 *
 * This event is dispatched by a WebGLPipeline when it has completed its `boot` phase.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BOOT
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that booted.
 */ module1.exports = 'pipelineboot';
            /***/ },
            /***/ 92852: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Destroy Event.
 *
 * This event is dispatched by a WebGLPipeline when it is starting its destroy process.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that has flushed.
 */ module1.exports = 'pipelinedestroy';
            /***/ },
            /***/ 56072: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline ReBind Event.
 *
 * This event is dispatched by a WebGLPipeline when it is re-bound by the Pipeline Manager.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#REBIND
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was rebound.
 * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as being current.
 */ module1.exports = 'pipelinerebind';
            /***/ },
            /***/ 57566: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Resize Event.
 *
 * This event is dispatched by a WebGLPipeline when it is resized, usually as a result
 * of the Renderer resizing.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#RESIZE
 * @since 3.50.0
 *
 * @param {number} width - The new width of the pipeline.
 * @param {number} height - The new height of the pipeline.
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was resized.
 */ module1.exports = 'pipelineresize';
            /***/ },
            /***/ 77085: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.WebGL.Pipelines.Events
 */ module1.exports = {
                    AFTER_FLUSH: __webpack_require__(84817),
                    BEFORE_FLUSH: __webpack_require__(36712),
                    BIND: __webpack_require__(40285),
                    BOOT: __webpack_require__(65918),
                    DESTROY: __webpack_require__(92852),
                    REBIND: __webpack_require__(56072),
                    RESIZE: __webpack_require__(57566)
                };
            /***/ },
            /***/ 54812: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var BarrelFrag = __webpack_require__(99155);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Barrel FX Pipeline.
 *
 * A barrel effect allows you to apply either a 'pinch' or 'expand' distortion to
 * a Game Object. The amount of the effect can be modified in real-time.
 *
 * A Barrel effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addBarrel();
 * ```
 *
 * @class BarrelFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var BarrelFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function BarrelFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: BarrelFrag
                        });
                        /**
         * The amount of distortion applied to the barrel effect.
         *
         * Typically keep this within the range 1 (no distortion) to +- 1.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BarrelFXPipeline#amount
         * @type {number}
         * @since 3.60.0
         */ this.amount = 1;
                    },
                    onPreRender: function(controller, shader) {
                        controller = this.getController(controller);
                        this.set1f('amount', controller.amount, shader);
                    }
                });
                module1.exports = BarrelFXPipeline;
            /***/ },
            /***/ 67329: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var BloomFrag = __webpack_require__(24400);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Bloom FX Pipeline.
 *
 * Bloom is an effect used to reproduce an imaging artifact of real-world cameras.
 * The effect produces fringes of light extending from the borders of bright areas in an image,
 * contributing to the illusion of an extremely bright light overwhelming the
 * camera or eye capturing the scene.
 *
 * A Bloom effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addBloom();
 * ```
 *
 * @class BloomFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var BloomFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function BloomFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: BloomFrag
                        });
                        /**
         * The number of steps to run the Bloom effect for.
         *
         * This value should always be an integer.
         *
         * It defaults to 4. The higher the value, the smoother the Bloom,
         * but at the cost of exponentially more gl operations.
         *
         * Keep this to the lowest possible number you can have it, while
         * still looking correct for your game.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BloomFXPipeline#steps
         * @type {number}
         * @since 3.60.0
         */ this.steps = 4;
                        /**
         * The horizontal offset of the bloom effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BloomFXPipeline#offsetX
         * @type {number}
         * @since 3.60.0
         */ this.offsetX = 1;
                        /**
         * The vertical offset of the bloom effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BloomFXPipeline#offsetY
         * @type {number}
         * @since 3.60.0
         */ this.offsetY = 1;
                        /**
         * The strength of the blur process of the bloom effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BloomFXPipeline#blurStrength
         * @type {number}
         * @since 3.60.0
         */ this.blurStrength = 1;
                        /**
         * The strength of the blend process of the bloom effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BloomFXPipeline#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = 1;
                        /**
         * The internal gl color array.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BloomFXPipeline#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            1,
                            1
                        ];
                    },
                    onPreRender: function(controller) {
                        controller = this.getController(controller);
                        this.set1f('strength', controller.blurStrength);
                        this.set3fv('color', controller.glcolor);
                    },
                    onDraw: function(target1) {
                        var controller = this.getController();
                        var target2 = this.fullFrame1;
                        var target3 = this.fullFrame2;
                        this.copyFrame(target1, target3);
                        var x = 2 / target1.width * controller.offsetX;
                        var y = 2 / target1.height * controller.offsetY;
                        for(var i = 0; i < controller.steps; i++){
                            this.set2f('offset', x, 0);
                            this.copySprite(target1, target2);
                            this.set2f('offset', 0, y);
                            this.copySprite(target2, target1);
                        }
                        this.blendFrames(target3, target1, target2, controller.strength);
                        this.copyToGame(target2);
                    }
                });
                module1.exports = BloomFXPipeline;
            /***/ },
            /***/ 8861: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var BlurLowFrag = __webpack_require__(41514);
                var BlurMedFrag = __webpack_require__(51078);
                var BlurHighFrag = __webpack_require__(94328);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Blur FX Pipeline.
 *
 * A Gaussian blur is the result of blurring an image by a Gaussian function. It is a widely used effect,
 * typically to reduce image noise and reduce detail. The visual effect of this blurring technique is a
 * smooth blur resembling that of viewing the image through a translucent screen, distinctly different
 * from the bokeh effect produced by an out-of-focus lens or the shadow of an object under usual illumination.
 *
 * A Blur effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addBlur();
 * ```
 *
 * @class BlurFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var BlurFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function BlurFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            shaders: [
                                {
                                    name: 'Gaussian5',
                                    fragShader: BlurLowFrag
                                },
                                {
                                    name: 'Gaussian9',
                                    fragShader: BlurMedFrag
                                },
                                {
                                    name: 'Gaussian13',
                                    fragShader: BlurHighFrag
                                }
                            ]
                        });
                        this.activeShader = this.shaders[0];
                        /**
         * The horizontal offset of the blur effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#x
         * @type {number}
         * @since 3.60.0
         */ this.x = 2;
                        /**
         * The vertical offset of the blur effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#y
         * @type {number}
         * @since 3.60.0
         */ this.y = 2;
                        /**
         * The number of steps to run the Blur effect for.
         *
         * This value should always be an integer.
         *
         * It defaults to 4. The higher the value, the smoother the blur,
         * but at the cost of exponentially more gl operations.
         *
         * Keep this to the lowest possible number you can have it, while
         * still looking correct for your game.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#steps
         * @type {number}
         * @since 3.60.0
         */ this.steps = 4;
                        /**
         * The strength of the blur effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = 1;
                        /**
         * The internal gl color array.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            1,
                            1
                        ];
                    },
                    /**
     * Sets the quality of the blur effect to low.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#setQualityLow
     * @since 3.60.0
     *
     * @return {this} This FX Pipeline.
     */ setQualityLow: function() {
                        this.activeShader = this.shaders[0];
                        return this;
                    },
                    /**
     * Sets the quality of the blur effect to medium.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#setQualityMedium
     * @since 3.60.0
     *
     * @return {this} This FX Pipeline.
     */ setQualityMedium: function() {
                        this.activeShader = this.shaders[1];
                        return this;
                    },
                    /**
     * Sets the quality of the blur effect to high.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.FX.BlurFXPipeline#setQualityHigh
     * @since 3.60.0
     *
     * @return {this} This FX Pipeline.
     */ setQualityHigh: function() {
                        this.activeShader = this.shaders[2];
                        return this;
                    },
                    onDraw: function(target1) {
                        var controller = this.getController();
                        var gl = this.gl;
                        var target2 = this.fullFrame1;
                        var currentFBO = gl.getParameter(gl.FRAMEBUFFER_BINDING);
                        this.bind(this.shaders[controller.quality]);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.viewport(0, 0, target1.width, target1.height);
                        this.set1i('uMainSampler', 0);
                        this.set2f('resolution', target1.width, target1.height);
                        this.set1f('strength', controller.strength);
                        this.set3fv('color', controller.glcolor);
                        for(var i = 0; i < controller.steps; i++){
                            this.set2f('offset', controller.x, 0);
                            this.copySprite(target1, target2);
                            this.set2f('offset', 0, controller.y);
                            this.copySprite(target2, target1);
                        }
                        gl.bindFramebuffer(gl.FRAMEBUFFER, currentFBO);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                        this.copyToGame(target1);
                    }
                });
                module1.exports = BlurFXPipeline;
            /***/ },
            /***/ 51051: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var BokehFrag = __webpack_require__(90610);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Bokeh FX Pipeline.
 *
 * Bokeh refers to a visual effect that mimics the photographic technique of creating a shallow depth of field.
 * This effect is used to emphasize the game's main subject or action, by blurring the background or foreground
 * elements, resulting in a more immersive and visually appealing experience. It is achieved through rendering
 * techniques that simulate the out-of-focus areas, giving a sense of depth and realism to the game's graphics.
 *
 * This effect can also be used to generate a Tilt Shift effect, which is a technique used to create a miniature
 * effect by blurring everything except a small area of the image. This effect is achieved by blurring the
 * top and bottom elements, while keeping the center area in focus.
 *
 * A Bokeh effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addBokeh();
 * ```
 *
 * @class BokehFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var BokehFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function BokehFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: BokehFrag
                        });
                        /**
         * Is this a Tilt Shift effect or a standard bokeh effect?
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline#isTiltShift
         * @type {boolean}
         * @since 3.60.0
         */ this.isTiltShift = false;
                        /**
         * If a Tilt Shift effect this controls the strength of the blur.
         *
         * Setting this value on a non-Tilt Shift effect will have no effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = 1;
                        /**
         * If a Tilt Shift effect this controls the amount of horizontal blur.
         *
         * Setting this value on a non-Tilt Shift effect will have no effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline#blurX
         * @type {number}
         * @since 3.60.0
         */ this.blurX = 1;
                        /**
         * If a Tilt Shift effect this controls the amount of vertical blur.
         *
         * Setting this value on a non-Tilt Shift effect will have no effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline#blurY
         * @type {number}
         * @since 3.60.0
         */ this.blurY = 1;
                        /**
         * The radius of the bokeh effect.
         *
         * This is a float value, where a radius of 0 will result in no effect being applied,
         * and a radius of 1 will result in a strong bokeh. However, you can exceed this value
         * for even stronger effects.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline#radius
         * @type {number}
         * @since 3.60.0
         */ this.radius = 0.5;
                        /**
         * The amount, or strength, of the bokeh effect. Defaults to 1.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline#amount
         * @type {number}
         * @since 3.60.0
         */ this.amount = 1;
                        /**
         * The color contrast, or brightness, of the bokeh effect. Defaults to 0.2.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.BokehFXPipeline#contrast
         * @type {number}
         * @since 3.60.0
         */ this.contrast = 0.2;
                    },
                    onPreRender: function(controller, shader, width, height) {
                        controller = this.getController(controller);
                        this.set1f('radius', controller.radius, shader);
                        this.set1f('amount', controller.amount, shader);
                        this.set1f('contrast', controller.contrast, shader);
                        this.set1f('strength', controller.strength, shader);
                        this.set2f('blur', controller.blurX, controller.blurY, shader);
                        this.setBoolean('isTiltShift', controller.isTiltShift, shader);
                        if (width && height) this.set2f('resolution', width, height, shader);
                    },
                    onDraw: function(target) {
                        this.set2f('resolution', target.width, target.height);
                        this.bindAndDraw(target);
                    }
                });
                module1.exports = BokehFXPipeline;
            /***/ },
            /***/ 89428: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CircleFrag = __webpack_require__(91899);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Circle FX Pipeline.
 *
 * This effect will draw a circle around the texture of the Game Object, effectively masking off
 * any area outside of the circle without the need for an actual mask. You can control the thickness
 * of the circle, the color of the circle and the color of the background, should the texture be
 * transparent. You can also control the feathering applied to the circle, allowing for a harsh or soft edge.
 *
 * Please note that adding this effect to a Game Object will not change the input area or physics body of
 * the Game Object, should it have one.
 *
 * A Circle effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addCircle();
 * ```
 *
 * @class CircleFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var CircleFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function CircleFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: CircleFrag
                        });
                        /**
         * The scale of the circle. The default scale is 1, which is a circle
         * the full size of the underlying texture. Reduce this value to create
         * a smaller circle, or increase it to create a circle that extends off
         * the edges of the texture.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.CircleFXPipeline#scale
         * @type {number}
         * @since 3.60.0
         */ this.scale = 1;
                        /**
         * The amount of feathering to apply to the circle from the ring,
         * extending into the middle of the circle. The default is 0.005,
         * which is a very low amount of feathering just making sure the ring
         * has a smooth edge. Increase this amount to a value such as 0.5
         * or 0.025 for larger amounts of feathering.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.CircleFXPipeline#feather
         * @type {number}
         * @since 3.60.0
         */ this.feather = 0.005;
                        /**
         * The width of the circle around the texture, in pixels. This value
         * doesn't factor in the feather, which can extend the thickness
         * internally depending on its value.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.CircleFXPipeline#thickness
         * @type {number}
         * @since 3.60.0
         */ this.thickness = 8;
                        /**
         * The internal gl color array for the ring color.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.CircleFXPipeline#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            0.2,
                            0.7
                        ];
                        /**
         * The internal gl color array for the background color.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.CircleFXPipeline#glcolor2
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor2 = [
                            1,
                            0,
                            0,
                            0.4
                        ];
                    },
                    onPreRender: function(controller, shader, width, height) {
                        controller = this.getController(controller);
                        this.set1f('scale', controller.scale, shader);
                        this.set1f('feather', controller.feather, shader);
                        this.set1f('thickness', controller.thickness, shader);
                        this.set3fv('color', controller.glcolor, shader);
                        this.set4fv('backgroundColor', controller.glcolor2, shader);
                        if (width && height) this.set2f('resolution', width, height, shader);
                    },
                    onDraw: function(target) {
                        this.set2f('resolution', target.width, target.height);
                        this.bindAndDraw(target);
                    }
                });
                module1.exports = CircleFXPipeline;
            /***/ },
            /***/ 88904: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The ColorMatrix FX Pipeline.
 *
 * The color matrix effect is a visual technique that involves manipulating the colors of an image
 * or scene using a mathematical matrix. This process can adjust hue, saturation, brightness, and contrast,
 * allowing developers to create various stylistic appearances or mood settings within the game.
 * Common applications include simulating different lighting conditions, applying color filters,
 * or achieving a specific visual style.
 *
 * A ColorMatrix effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addColorMatrix();
 * ```
 *
 * @class ColorMatrixFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var ColorMatrixFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function ColorMatrixFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game
                        });
                    },
                    onDraw: function(source) {
                        var target = this.fullFrame1;
                        if (this.controller) this.manager.drawFrame(source, target, true, this.controller);
                        else this.drawFrame(source, target);
                        this.copyToGame(target);
                    }
                });
                module1.exports = ColorMatrixFXPipeline;
            /***/ },
            /***/ 63563: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var DisplacementFrag = __webpack_require__(47838);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Displacement FX Pipeline.
 *
 * The displacement effect is a visual technique that alters the position of pixels in an image
 * or texture based on the values of a displacement map. This effect is used to create the illusion
 * of depth, surface irregularities, or distortion in otherwise flat elements. It can be applied to
 * characters, objects, or backgrounds to enhance realism, convey movement, or achieve various
 * stylistic appearances.
 *
 * A Displacement effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addDisplacement();
 * ```
 *
 * @class DisplacementFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var DisplacementFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function DisplacementFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: DisplacementFrag
                        });
                        /**
         * The amount of horizontal displacement to apply.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.DisplacementFXPipeline#x
         * @type {number}
         * @since 3.60.0
         */ this.x = 0.005;
                        /**
         * The amount of vertical displacement to apply.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.DisplacementFXPipeline#y
         * @type {number}
         * @since 3.60.0
         */ this.y = 0.005;
                        /**
         * The underlying texture used for displacement.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.DisplacementFXPipeline#glTexture
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @since 3.60.0
         */ this.glTexture;
                    },
                    onBoot: function() {
                        this.setTexture('__WHITE');
                    },
                    setTexture: function(texture) {
                        var phaserTexture = this.game.textures.getFrame(texture);
                        if (phaserTexture) this.glTexture = phaserTexture.glTexture;
                    },
                    onDraw: function(source) {
                        var controller = this.getController();
                        var target = this.fullFrame1;
                        this.bind();
                        this.set1i('uMainSampler', 0);
                        this.set1i('uDisplacementSampler', 1);
                        this.set2f('amount', controller.x, controller.y);
                        this.bindTexture(controller.glTexture, 1);
                        this.copySprite(source, target);
                        this.copyToGame(target);
                    }
                });
                module1.exports = DisplacementFXPipeline;
            /***/ },
            /***/ 94045: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                var GlowFrag = __webpack_require__(98656);
                var PostFXPipeline = __webpack_require__(84057);
                var Utils = __webpack_require__(70554);
                /**
 * @classdesc
 * The Glow FX Pipeline.
 *
 * The glow effect is a visual technique that creates a soft, luminous halo around game objects,
 * characters, or UI elements. This effect is used to emphasize importance, enhance visual appeal,
 * or convey a sense of energy, magic, or otherworldly presence. The effect can also be set on
 * the inside of the Game Object. The color and strength of the glow can be modified.
 *
 * A Glow effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addGlow();
 * ```
 *
 * @class GlowFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 * @param {object} config - The configuration options for this pipeline.
 */ var GlowFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function GlowFXPipeline(game, config) {
                        var quality = GetFastValue(config, 'quality', 0.1);
                        var distance = GetFastValue(config, 'distance', 10);
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: Utils.setGlowQuality(GlowFrag, game, quality, distance)
                        });
                        /**
         * The strength of the glow outward from the edge of the Sprite.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GlowFXPipeline#outerStrength
         * @type {number}
         * @since 3.60.0
         */ this.outerStrength = 4;
                        /**
         * The strength of the glow inward from the edge of the Sprite.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GlowFXPipeline#innerStrength
         * @type {number}
         * @since 3.60.0
         */ this.innerStrength = 0;
                        /**
         * If `true` only the glow is drawn, not the texture itself.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GlowFXPipeline#knockout
         * @type {number}
         * @since 3.60.0
         */ this.knockout = false;
                        /**
         * A 4 element array of gl color values.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GlowFXPipeline#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            1,
                            1,
                            1,
                            1
                        ];
                    },
                    onPreRender: function(controller, shader, width, height) {
                        controller = this.getController(controller);
                        this.set1f('outerStrength', controller.outerStrength, shader);
                        this.set1f('innerStrength', controller.innerStrength, shader);
                        this.set4fv('glowColor', controller.glcolor, shader);
                        this.setBoolean('knockout', controller.knockout, shader);
                        if (width && height) this.set2f('resolution', width, height, shader);
                    },
                    onDraw: function(target) {
                        this.set2f('resolution', target.width, target.height);
                        this.bindAndDraw(target);
                    }
                });
                module1.exports = GlowFXPipeline;
            /***/ },
            /***/ 74088: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GradientFrag = __webpack_require__(70463);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Gradient FX Pipeline.
 *
 * The gradient overlay effect is a visual technique where a smooth color transition is applied over Game Objects,
 * such as sprites or UI components. This effect is used to enhance visual appeal, emphasize depth, or create
 * stylistic and atmospheric variations. It can also be utilized to convey information, such as representing
 * progress or health status through color changes.
 *
 * A Gradient effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addGradient();
 * ```
 *
 * @class GradientFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var GradientFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function GradientFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: GradientFrag
                        });
                        /**
         * The alpha value of the gradient effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#alpha
         * @type {number}
         * @since 3.60.0
         */ this.alpha = 0.2;
                        /**
         * Sets how many 'chunks' the gradient is divided in to, as spread over the
         * entire height of the texture. Leave this at zero for a smooth gradient,
         * or set to a higher number to split the gradient into that many sections, giving
         * a more banded 'retro' effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#size
         * @type {number}
         * @since 3.60.0
         */ this.size = 0;
                        /**
         * The horizontal position the gradient will start from. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#fromX
         * @type {number}
         * @since 3.60.0
         */ this.fromX = 0;
                        /**
         * The vertical position the gradient will start from. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#fromY
         * @type {number}
         * @since 3.60.0
         */ this.fromY = 0;
                        /**
         * The horizontal position the gradient will end. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#toX
         * @type {number}
         * @since 3.60.0
         */ this.toX = 0;
                        /**
         * The vertical position the gradient will end. This value is normalized, between 0 and 1 and is not in pixels.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#toY
         * @type {number}
         * @since 3.60.0
         */ this.toY = 1;
                        /**
         * The internal gl color array for the starting color.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#glcolor1
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor1 = [
                            255,
                            0,
                            0
                        ];
                        /**
         * The internal gl color array for the ending color.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.GradientFXPipeline#glcolor2
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor2 = [
                            0,
                            255,
                            0
                        ];
                    },
                    onPreRender: function(controller, shader) {
                        controller = this.getController(controller);
                        this.set1f('alpha', controller.alpha, shader);
                        this.set1i('size', controller.size, shader);
                        this.set3fv('color1', controller.glcolor1, shader);
                        this.set3fv('color2', controller.glcolor2, shader);
                        this.set2f('positionFrom', controller.fromX, controller.fromY, shader);
                        this.set2f('positionTo', controller.toX, controller.toY, shader);
                    }
                });
                module1.exports = GradientFXPipeline;
            /***/ },
            /***/ 99636: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var PixelateFrag = __webpack_require__(50831);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Pixelate FX Pipeline.
 *
 * The pixelate effect is a visual technique that deliberately reduces the resolution or detail of an image,
 * creating a blocky or mosaic appearance composed of large, visible pixels. This effect can be used for stylistic
 * purposes, as a homage to retro gaming, or as a means to obscure certain elements within the game, such as
 * during a transition or to censor specific content.
 *
 * A Pixelate effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addPixelate();
 * ```
 *
 * @class PixelateFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var PixelateFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function PixelateFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: PixelateFrag
                        });
                        /**
         * The amount of pixelation to apply.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.PixelateFXPipeline#amount
         * @type {number}
         * @since 3.60.0
         */ this.amount = 1;
                    },
                    onPreRender: function(controller, shader, width, height) {
                        controller = this.getController(controller);
                        this.set1f('amount', controller.amount, shader);
                        if (width && height) this.set2f('resolution', width, height, shader);
                    },
                    onDraw: function(target) {
                        this.set2f('resolution', target.width, target.height);
                        this.bindAndDraw(target);
                    }
                });
                module1.exports = PixelateFXPipeline;
            /***/ },
            /***/ 34700: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var ShadowFrag = __webpack_require__(92595);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Shadow FX Pipeline.
 *
 * The shadow effect is a visual technique used to create the illusion of depth and realism by adding darker,
 * offset silhouettes or shapes beneath game objects, characters, or environments. These simulated shadows
 * help to enhance the visual appeal and immersion, making the 2D game world appear more dynamic and three-dimensional.
 *
 * A Shadow effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addShadow();
 * ```
 *
 * @class ShadowFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var ShadowFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function ShadowFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: ShadowFrag
                        });
                        /**
         * The horizontal offset of the shadow effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline#x
         * @type {number}
         * @since 3.60.0
         */ this.x = 0;
                        /**
         * The vertical offset of the shadow effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline#y
         * @type {number}
         * @since 3.60.0
         */ this.y = 0;
                        /**
         * The amount of decay for the shadow effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline#decay
         * @type {number}
         * @since 3.60.0
         */ this.decay = 0.1;
                        /**
         * The power of the shadow effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline#power
         * @type {number}
         * @since 3.60.0
         */ this.power = 1;
                        /**
         * The internal gl color array.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline#glcolor
         * @type {number[]}
         * @since 3.60.0
         */ this.glcolor = [
                            0,
                            0,
                            0,
                            1
                        ];
                        /**
         * The number of samples that the shadow effect will run for.
         *
         * This should be an integer with a minimum value of 1 and a maximum of 12.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline#samples
         * @type {number}
         * @since 3.60.0
         */ this.samples = 6;
                        /**
         * The intensity of the shadow effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShadowFXPipeline#intensity
         * @type {number}
         * @since 3.60.0
         */ this.intensity = 1;
                    },
                    onPreRender: function(controller, shader) {
                        controller = this.getController(controller);
                        var samples = controller.samples;
                        this.set1i('samples', samples, shader);
                        this.set1f('intensity', controller.intensity, shader);
                        this.set1f('decay', controller.decay, shader);
                        this.set1f('power', controller.power / samples, shader);
                        this.set2f('lightPosition', controller.x, controller.y, shader);
                        this.set4fv('color', controller.glcolor, shader);
                    }
                });
                module1.exports = ShadowFXPipeline;
            /***/ },
            /***/ 91157: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var ShineFrag = __webpack_require__(72464);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Shine FX Pipeline.
 *
 * The shine effect is a visual technique that simulates the appearance of reflective
 * or glossy surfaces by passing a light beam across a Game Object. This effect is used to
 * enhance visual appeal, emphasize certain features, and create a sense of depth or
 * material properties.
 *
 * A Shine effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addShine();
 * ```
 *
 * @class ShineFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var ShineFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function ShineFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: ShineFrag
                        });
                        /**
         * The speed of the Shine effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShineFXPipeline#speed
         * @type {number}
         * @since 3.60.0
         */ this.speed = 0.5;
                        /**
         * The line width of the Shine effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShineFXPipeline#lineWidth
         * @type {number}
         * @since 3.60.0
         */ this.lineWidth = 0.5;
                        /**
         * The gradient of the Shine effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShineFXPipeline#gradient
         * @type {number}
         * @since 3.60.0
         */ this.gradient = 3;
                        /**
         * Does this Shine effect reveal or get added to its target?
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.ShineFXPipeline#reveal
         * @type {boolean}
         * @since 3.60.0
         */ this.reveal = false;
                    },
                    onPreRender: function(controller, shader, width, height) {
                        controller = this.getController(controller);
                        this.setTime('time', shader);
                        this.set1f('speed', controller.speed, shader);
                        this.set1f('lineWidth', controller.lineWidth, shader);
                        this.set1f('gradient', controller.gradient, shader);
                        this.setBoolean('reveal', controller.reveal, shader);
                        if (width && height) this.set2f('resolution', width, height, shader);
                    },
                    onDraw: function(target) {
                        this.set2f('resolution', target.width, target.height);
                        this.bindAndDraw(target);
                    }
                });
                module1.exports = ShineFXPipeline;
            /***/ },
            /***/ 27797: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var VignetteFrag = __webpack_require__(39249);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Vignette FX Pipeline.
 *
 * The vignette effect is a visual technique where the edges of the screen, or a Game Object, gradually darken or blur,
 * creating a frame-like appearance. This effect is used to draw the player's focus towards the central action or subject,
 * enhance immersion, and provide a cinematic or artistic quality to the game's visuals.
 *
 * A Vignette effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addVignette();
 * ```
 *
 * @class VignetteFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var VignetteFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function VignetteFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: VignetteFrag
                        });
                        /**
         * The horizontal offset of the vignette effect. This value is normalized to the range 0 to 1.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.VignetteFXPipeline#x
         * @type {number}
         * @since 3.60.0
         */ this.x = 0.5;
                        /**
         * The vertical offset of the vignette effect. This value is normalized to the range 0 to 1.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.VignetteFXPipeline#y
         * @type {number}
         * @since 3.60.0
         */ this.y = 0.5;
                        /**
         * The radius of the vignette effect. This value is normalized to the range 0 to 1.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.VignetteFXPipeline#radius
         * @type {number}
         * @since 3.60.0
         */ this.radius = 0.5;
                        /**
         * The strength of the vignette effect.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.VignetteFXPipeline#strength
         * @type {number}
         * @since 3.60.0
         */ this.strength = 0.5;
                    },
                    onPreRender: function(controller, shader) {
                        controller = this.getController(controller);
                        this.set1f('radius', controller.radius, shader);
                        this.set1f('strength', controller.strength, shader);
                        this.set2f('position', controller.x, controller.y, shader);
                    }
                });
                module1.exports = VignetteFXPipeline;
            /***/ },
            /***/ 67603: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var WipeFrag = __webpack_require__(2878);
                var PostFXPipeline = __webpack_require__(84057);
                /**
 * @classdesc
 * The Wipe FX Pipeline.
 *
 * The wipe or reveal effect is a visual technique that gradually uncovers or conceals elements
 * in the game, such as images, text, or scene transitions. This effect is often used to create
 * a sense of progression, reveal hidden content, or provide a smooth and visually appealing transition
 * between game states.
 *
 * You can set both the direction and the axis of the wipe effect. The following combinations are possible:
 *
 * * left to right: direction 0, axis 0
 * * right to left: direction 1, axis 0
 * * top to bottom: direction 1, axis 1
 * * bottom to top: direction 1, axis 0
 *
 * It is up to you to set the `progress` value yourself, i.e. via a Tween, in order to transition the effect.
 *
 * A Wipe effect is added to a Game Object via the FX component:
 *
 * ```js
 * const sprite = this.add.sprite();
 *
 * sprite.postFX.addWipe();
 * sprite.postFX.addReveal();
 * ```
 *
 * @class WipeFXPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines.FX
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser Game instance.
 */ var WipeFXPipeline = new Class({
                    Extends: PostFXPipeline,
                    initialize: function WipeFXPipeline(game) {
                        PostFXPipeline.call(this, {
                            game: game,
                            fragShader: WipeFrag
                        });
                        /**
         * The progress of the Wipe effect. This value is normalized to the range 0 to 1.
         *
         * Adjust this value to make the wipe transition (i.e. via a Tween)
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.WipeFXPipeline#progress
         * @type {number}
         * @since 3.60.0
         */ this.progress = 0;
                        /**
         * The width of the wipe effect. This value is normalized in the range 0 to 1.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.WipeFXPipeline#wipeWidth
         * @type {number}
         * @since 3.60.0
         */ this.wipeWidth = 0.1;
                        /**
         * The direction of the wipe effect. Either 0 or 1. Set in conjunction with the axis property.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.WipeFXPipeline#direction
         * @type {number}
         * @since 3.60.0
         */ this.direction = 0;
                        /**
         * The axis of the wipe effect. Either 0 or 1. Set in conjunction with the direction property.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.WipeFXPipeline#axis
         * @type {number}
         * @since 3.60.0
         */ this.axis = 0;
                        /**
         * Is this a reveal (true) or a fade (false) effect?
         *
         * @name Phaser.Renderer.WebGL.Pipelines.FX.WipeFXPipeline#reveal
         * @type {boolean}
         * @since 3.60.0
         */ this.reveal = false;
                    },
                    onPreRender: function(controller, shader) {
                        controller = this.getController(controller);
                        var progress = controller.progress;
                        var wipeWidth = controller.wipeWidth;
                        var direction = controller.direction;
                        var axis = controller.axis;
                        this.set4f('config', progress, wipeWidth, direction, axis, shader);
                        this.setBoolean('reveal', controller.reveal, shader);
                    }
                });
                module1.exports = WipeFXPipeline;
            /***/ },
            /***/ 58918: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.WebGL.Pipelines.FX
 */ var FX = {
                    Barrel: __webpack_require__(54812),
                    Bloom: __webpack_require__(67329),
                    Blur: __webpack_require__(8861),
                    Bokeh: __webpack_require__(51051),
                    Circle: __webpack_require__(89428),
                    ColorMatrix: __webpack_require__(88904),
                    Displacement: __webpack_require__(63563),
                    Glow: __webpack_require__(94045),
                    Gradient: __webpack_require__(74088),
                    Pixelate: __webpack_require__(99636),
                    Shadow: __webpack_require__(34700),
                    Shine: __webpack_require__(91157),
                    Vignette: __webpack_require__(27797),
                    Wipe: __webpack_require__(67603)
                };
                //  Export it
                module1.exports = FX;
            /***/ },
            /***/ 96615: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(36060);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Renderer.WebGL.Pipelines
 */ var Pipelines = {
                    FX: __webpack_require__(58918),
                    BitmapMaskPipeline: __webpack_require__(31302),
                    Events: __webpack_require__(77085),
                    FXPipeline: __webpack_require__(92651),
                    LightPipeline: __webpack_require__(96569),
                    MobilePipeline: __webpack_require__(56527),
                    MultiPipeline: __webpack_require__(57516),
                    PointLightPipeline: __webpack_require__(43439),
                    PostFXPipeline: __webpack_require__(84057),
                    PreFXPipeline: __webpack_require__(43558),
                    RopePipeline: __webpack_require__(81041),
                    SinglePipeline: __webpack_require__(12385),
                    UtilityPipeline: __webpack_require__(7589)
                };
                //   Merge in the consts
                Pipelines = Extend(false, Pipelines, CONST);
                //  Export it
                module1.exports = Pipelines;
            /***/ },
            /***/ 35407: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_ADD_BLEND_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler1;',
                    'uniform sampler2D uMainSampler2;',
                    'uniform float uStrength;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);',
                    '    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);',
                    '    gl_FragColor = frame1 + frame2 * uStrength;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 78908: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_BITMAP_MASK_FS',
                    'precision mediump float;',
                    'uniform vec2 uResolution;',
                    'uniform sampler2D uMainSampler;',
                    'uniform sampler2D uMaskSampler;',
                    'uniform bool uInvertMaskAlpha;',
                    'void main ()',
                    '{',
                    '    vec2 uv = gl_FragCoord.xy / uResolution;',
                    '    vec4 mainColor = texture2D(uMainSampler, uv);',
                    '    vec4 maskColor = texture2D(uMaskSampler, uv);',
                    '    if (!uInvertMaskAlpha)',
                    '    {',
                    '        mainColor *= maskColor.a;',
                    '    }',
                    '    else',
                    '    {',
                    '        mainColor *= (1.0 - maskColor.a);',
                    '    }',
                    '    gl_FragColor = mainColor;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 85191: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_BITMAP_MASK_VS',
                    'precision mediump float;',
                    'attribute vec2 inPosition;',
                    'void main ()',
                    '{',
                    '    gl_Position = vec4(inPosition, 0.0, 1.0);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 96293: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_COLORMATRIX_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform float uColorMatrix[20];',
                    'uniform float uAlpha;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec4 c = texture2D(uMainSampler, outTexCoord);',
                    '    if (uAlpha == 0.0)',
                    '    {',
                    '        gl_FragColor = c;',
                    '        return;',
                    '    }',
                    '    if (c.a > 0.0)',
                    '    {',
                    '        c.rgb /= c.a;',
                    '    }',
                    '    vec4 result;',
                    '    result.r = (uColorMatrix[0] * c.r) + (uColorMatrix[1] * c.g) + (uColorMatrix[2] * c.b) + (uColorMatrix[3] * c.a) + uColorMatrix[4];',
                    '    result.g = (uColorMatrix[5] * c.r) + (uColorMatrix[6] * c.g) + (uColorMatrix[7] * c.b) + (uColorMatrix[8] * c.a) + uColorMatrix[9];',
                    '    result.b = (uColorMatrix[10] * c.r) + (uColorMatrix[11] * c.g) + (uColorMatrix[12] * c.b) + (uColorMatrix[13] * c.a) + uColorMatrix[14];',
                    '    result.a = (uColorMatrix[15] * c.r) + (uColorMatrix[16] * c.g) + (uColorMatrix[17] * c.b) + (uColorMatrix[18] * c.a) + uColorMatrix[19];',
                    '    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);',
                    '    rgb *= result.a;',
                    '    gl_FragColor = vec4(rgb, result.a);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 36682: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_COPY_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform float uBrightness;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    gl_FragColor = texture2D(uMainSampler, outTexCoord) * uBrightness;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 99155: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME BARREL_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform float amount;',
                    'varying vec2 outTexCoord;',
                    'vec2 Distort(vec2 p)',
                    '{',
                    '    float theta  = atan(p.y, p.x);',
                    '    float radius = length(p);',
                    '    radius = pow(radius, amount);',
                    '    p.x = radius * cos(theta);',
                    '    p.y = radius * sin(theta);',
                    '    return 0.5 * (p + 1.0);',
                    '}',
                    'void main()',
                    '{',
                    '    vec2 xy = 2.0 * outTexCoord - 1.0;',
                    '    vec2 texCoord = outTexCoord;',
                    '    if (length(xy) < 1.0)',
                    '    {',
                    '        texCoord = Distort(xy);',
                    '    }',
                    '    gl_FragColor = texture2D(uMainSampler, texCoord);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 24400: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME BLOOM_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 offset;',
                    'uniform float strength;',
                    'uniform vec3 color;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec4 sum = texture2D(uMainSampler, outTexCoord) * 0.204164 * strength;',
                    '    sum = sum + texture2D(uMainSampler, outTexCoord + offset * 1.407333) * 0.304005;',
                    '    sum = sum + texture2D(uMainSampler, outTexCoord - offset * 1.407333) * 0.304005;',
                    '    sum = sum + texture2D(uMainSampler, outTexCoord + offset * 3.294215) * 0.093913;',
                    '    gl_FragColor = (sum + texture2D(uMainSampler, outTexCoord - offset * 3.294215) * 0.093913) * vec4(color, 1);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 94328: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME BLUR_HIGH_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 resolution;',
                    'uniform vec2 offset;',
                    'uniform float strength;',
                    'uniform vec3 color;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec2 uv = outTexCoord;',
                    '    vec4 col = vec4(0.0);',
                    '    vec2 off1 = vec2(1.411764705882353) * offset * strength;',
                    '    vec2 off2 = vec2(3.2941176470588234) * offset * strength;',
                    '    vec2 off3 = vec2(5.176470588235294) * offset * strength;',
                    '    col += texture2D(uMainSampler, uv) * 0.1964825501511404;',
                    '    col += texture2D(uMainSampler, uv + (off1 / resolution)) * 0.2969069646728344;',
                    '    col += texture2D(uMainSampler, uv - (off1 / resolution)) * 0.2969069646728344;',
                    '    col += texture2D(uMainSampler, uv + (off2 / resolution)) * 0.09447039785044732;',
                    '    col += texture2D(uMainSampler, uv - (off2 / resolution)) * 0.09447039785044732;',
                    '    col += texture2D(uMainSampler, uv + (off3 / resolution)) * 0.010381362401148057;',
                    '    col += texture2D(uMainSampler, uv - (off3 / resolution)) * 0.010381362401148057;',
                    '    gl_FragColor = col * vec4(color, 1.0);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 41514: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME BLUR_LOW_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 resolution;',
                    'uniform vec2 offset;',
                    'uniform float strength;',
                    'uniform vec3 color;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec2 uv = outTexCoord;',
                    '    vec4 col = vec4(0.0);',
                    '    vec2 offset = vec2(1.333) * offset * strength;',
                    '    col += texture2D(uMainSampler, uv) * 0.29411764705882354;',
                    '    col += texture2D(uMainSampler, uv + (offset / resolution)) * 0.35294117647058826;',
                    '    col += texture2D(uMainSampler, uv - (offset / resolution)) * 0.35294117647058826;',
                    '    gl_FragColor = col * vec4(color, 1.0);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 51078: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME BLUR_MED_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 resolution;',
                    'uniform vec2 offset;',
                    'uniform float strength;',
                    'uniform vec3 color;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec2 uv = outTexCoord;',
                    '    vec4 col = vec4(0.0);',
                    '    vec2 off1 = vec2(1.3846153846) * offset * strength;',
                    '    vec2 off2 = vec2(3.2307692308) * offset * strength;',
                    '    col += texture2D(uMainSampler, uv) * 0.2270270270;',
                    '    col += texture2D(uMainSampler, uv + (off1 / resolution)) * 0.3162162162;',
                    '    col += texture2D(uMainSampler, uv - (off1 / resolution)) * 0.3162162162;',
                    '    col += texture2D(uMainSampler, uv + (off2 / resolution)) * 0.0702702703;',
                    '    col += texture2D(uMainSampler, uv - (off2 / resolution)) * 0.0702702703;',
                    '    gl_FragColor = col * vec4(color, 1.0);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 90610: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME BOKEH_FS',
                    'precision mediump float;',
                    '#define ITERATIONS 100.0',
                    '#define ONEOVER_ITR 1.0 / ITERATIONS',
                    '#define PI 3.141596',
                    '#define GOLDEN_ANGLE 2.39996323',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 resolution;',
                    'uniform float radius;',
                    'uniform float amount;',
                    'uniform float contrast;',
                    'uniform bool isTiltShift;',
                    'uniform float strength;',
                    'uniform vec2 blur;',
                    'varying vec2 outTexCoord;',
                    'vec2 Sample (in float theta, inout float r)',
                    '{',
                    '    r += 1.0 / r;',
                    '    return (r - 1.0) * vec2(cos(theta), sin(theta)) * 0.06;',
                    '}',
                    'vec3 Bokeh (sampler2D tex, vec2 uv, float radius)',
                    '{',
                    '    vec3 acc = vec3(0.0);',
                    '    vec3 div = vec3(0.0);',
                    '    vec2 pixel = vec2(resolution.y / resolution.x, 1.0) * radius * .025;',
                    '    float r = 1.0;',
                    '    for (float j = 0.0; j < GOLDEN_ANGLE * ITERATIONS; j += GOLDEN_ANGLE)',
                    '    {',
                    '        vec3 col = texture2D(tex, uv + pixel * Sample(j, r)).xyz;',
                    '        col = contrast > 0.0 ? col * col * (1.0 + contrast) : col;',
                    '        vec3 bokeh = vec3(0.5) + pow(col, vec3(10.0)) * amount;',
                    '        acc += col * bokeh;',
                    '        div += bokeh;',
                    '    }',
                    '    return acc / div;',
                    '}',
                    'void main ()',
                    '{',
                    '    float shift = 1.0;',
                    '    if (isTiltShift)',
                    '    {',
                    '        vec2 uv = vec2(gl_FragCoord.xy / resolution + vec2(-0.5, -0.5)) * 2.0;',
                    '        float centerStrength = 1.0;',
                    '        shift = length(uv * blur * strength) * centerStrength;',
                    '    }',
                    '    gl_FragColor = vec4(Bokeh(uMainSampler, outTexCoord * vec2(1.0, 1.0), radius * shift), 0.0);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 91899: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME CIRCLE_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 resolution;',
                    'uniform vec3 color;',
                    'uniform vec4 backgroundColor;',
                    'uniform float thickness;',
                    'uniform float scale;',
                    'uniform float feather;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                    '    vec2 position = (gl_FragCoord.xy / resolution.xy) * 2.0 - 1.0;',
                    '    float aspectRatio = resolution.x / resolution.y;',
                    '    position.x *= aspectRatio;',
                    '    float grad = length(position);',
                    '    float outer = aspectRatio;',
                    '    float inner = outer - (thickness * 2.0 / resolution.y);',
                    '    if (aspectRatio >= 1.0)',
                    '    {',
                    '        float f = 2.0 + (resolution.y / resolution.x);',
                    '        outer = 1.0;',
                    '        inner = 1.0 - (thickness * f / resolution.x);',
                    '    }',
                    '    outer *= scale;',
                    '    inner *= scale;',
                    '    float circle = smoothstep(outer, outer - 0.01, grad);',
                    '    float ring = circle - smoothstep(inner, inner - feather, grad);',
                    '    texture = mix(backgroundColor * backgroundColor.a, texture, texture.a);',
                    '    texture = (texture * (circle - ring));',
                    '    gl_FragColor = vec4(texture.rgb + (ring * color), texture.a);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 47838: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME DISPLACEMENT_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform sampler2D uDisplacementSampler;',
                    'uniform vec2 amount;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec2 disp = (-vec2(0.5, 0.5) + texture2D(uDisplacementSampler, outTexCoord).rr) * amount;',
                    '    gl_FragColor = texture2D(uMainSampler, outTexCoord + disp).rgba;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 98656: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME GLOW_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'varying vec2 outTexCoord;',
                    'uniform float outerStrength;',
                    'uniform float innerStrength;',
                    'uniform vec2 resolution;',
                    'uniform vec4 glowColor;',
                    'uniform bool knockout;',
                    'const float PI = 3.14159265358979323846264;',
                    'const float DIST = __DIST__;',
                    'const float SIZE = min(__SIZE__, PI * 2.0);',
                    'const float STEP = ceil(PI * 2.0 / SIZE);',
                    'const float MAX_ALPHA = STEP * DIST * (DIST + 1.0) / 2.0;',
                    'void main ()',
                    '{',
                    '    vec2 px = vec2(1.0 / resolution.x, 1.0 / resolution.y);',
                    '    float totalAlpha = 0.0;',
                    '    vec2 direction;',
                    '    vec2 displaced;',
                    '    vec4 color;',
                    '    for (float angle = 0.0; angle < PI * 2.0; angle += SIZE)',
                    '    {',
                    '        direction = vec2(cos(angle), sin(angle)) * px;',
                    '        for (float curDistance = 0.0; curDistance < DIST; curDistance++)',
                    '        {',
                    '            displaced = outTexCoord + direction * (curDistance + 1.0);',
                    '            color = texture2D(uMainSampler, displaced);',
                    '            totalAlpha += (DIST - curDistance) * color.a;',
                    '        }',
                    '    }',
                    '    color = texture2D(uMainSampler, outTexCoord);',
                    '    float alphaRatio = (totalAlpha / MAX_ALPHA);',
                    '    float innerGlowAlpha = (1.0 - alphaRatio) * innerStrength * color.a;',
                    '    float innerGlowStrength = min(1.0, innerGlowAlpha);',
                    '    vec4 innerColor = mix(color, glowColor, innerGlowStrength);',
                    '    float outerGlowAlpha = alphaRatio * outerStrength * (1.0 - color.a);',
                    '    float outerGlowStrength = min(1.0 - innerColor.a, outerGlowAlpha);',
                    '    vec4 outerGlowColor = outerGlowStrength * glowColor.rgba;',
                    '    if (knockout)',
                    '    {',
                    '        float resultAlpha = outerGlowAlpha + innerGlowAlpha;',
                    '        gl_FragColor = vec4(glowColor.rgb * resultAlpha, resultAlpha);',
                    '    }',
                    '    else',
                    '    {',
                    '        gl_FragColor = innerColor + outerGlowColor;',
                    '    }',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 70463: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME GRADIENT_FS',
                    '#define SRGB_TO_LINEAR(c) pow((c), vec3(2.2))',
                    '#define LINEAR_TO_SRGB(c) pow((c), vec3(1.0 / 2.2))',
                    '#define SRGB(r, g, b) SRGB_TO_LINEAR(vec3(float(r), float(g), float(b)) / 255.0)',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 positionFrom;',
                    'uniform vec2 positionTo;',
                    'uniform vec3 color1;',
                    'uniform vec3 color2;',
                    'uniform float alpha;',
                    'uniform int size;',
                    'varying vec2 outTexCoord;',
                    'float gradientNoise(in vec2 uv)',
                    '{',
                    '    const vec3 magic = vec3(0.06711056, 0.00583715, 52.9829189);',
                    '    return fract(magic.z * fract(dot(uv, magic.xy)));',
                    '}',
                    'float stepped (in float s, in float scale, in int steps)',
                    '{',
                    '    return steps > 0 ? floor( s / ((1.0 * scale) / float(steps))) * 1.0 / float(steps - 1) : s;',
                    '}',
                    'void main ()',
                    '{',
                    '    vec2 a = positionFrom;',
                    '    vec2 b = positionTo;',
                    '    vec2 ba = b - a;',
                    '    float d = dot(outTexCoord - a, ba) / dot(ba, ba);',
                    '    float t = size > 0 ? stepped(d, 1.0, size) : d;',
                    '    t = smoothstep(0.0, 1.0, clamp(t, 0.0, 1.0));',
                    '    vec3 color = mix(SRGB(color1.r, color1.g, color1.b), SRGB(color2.r, color2.g, color2.b), t);',
                    '    color = LINEAR_TO_SRGB(color);',
                    '    color += (1.0 / 255.0) * gradientNoise(outTexCoord) - (0.5 / 255.0);',
                    '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                    '    gl_FragColor = vec4(mix(color.rgb, texture.rgb, alpha), 1.0) * texture.a;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 50831: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PIXELATE_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 resolution;',
                    'uniform float amount;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    float pixelSize = floor(2.0 + amount);',
                    '    vec2 center = pixelSize * floor(outTexCoord * resolution / pixelSize) + pixelSize * vec2(0.5, 0.5);',
                    '    vec2 corner1 = center + pixelSize * vec2(-0.5, -0.5);',
                    '    vec2 corner2 = center + pixelSize * vec2(+0.5, -0.5);',
                    '    vec2 corner3 = center + pixelSize * vec2(+0.5, +0.5);',
                    '    vec2 corner4 = center + pixelSize * vec2(-0.5, +0.5);',
                    '    vec4 pixel = 0.4 * texture2D(uMainSampler, center / resolution);',
                    '    pixel += 0.15 * texture2D(uMainSampler, corner1 / resolution);',
                    '    pixel += 0.15 * texture2D(uMainSampler, corner2 / resolution);',
                    '    pixel += 0.15 * texture2D(uMainSampler, corner3 / resolution);',
                    '    pixel += 0.15 * texture2D(uMainSampler, corner4 / resolution);',
                    '    gl_FragColor = pixel;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 92595: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME SHADOW_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'varying vec2 outTexCoord;',
                    'uniform vec2 lightPosition;',
                    'uniform vec4 color;',
                    'uniform float decay;',
                    'uniform float power;',
                    'uniform float intensity;',
                    'uniform int samples;',
                    'const int MAX = 12;',
                    'void main ()',
                    '{',
                    '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                    '    vec2 pc = (lightPosition - outTexCoord) * intensity;',
                    '    float shadow = 0.0;',
                    '    float limit = max(float(MAX), float(samples));',
                    '    for (int i = 0; i < MAX; ++i)',
                    '    {',
                    '        if (i >= samples)',
                    '        {',
                    '            break;',
                    '        }',
                    '        shadow += texture2D(uMainSampler, outTexCoord + float(i) * decay / limit * pc).a * power;',
                    '    }',
                    '    float mask = 1.0 - texture.a;',
                    '    gl_FragColor = mix(texture, color, shadow * mask);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 72464: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME SHINE_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec2 resolution;',
                    'uniform bool reveal;',
                    'uniform float speed;',
                    'uniform float time;',
                    'uniform float lineWidth;',
                    'uniform float gradient;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '	vec2 uv = gl_FragCoord.xy / resolution.xy;',
                    '    vec4 tex = texture2D(uMainSampler, outTexCoord);',
                    '    vec4 col1 = vec4(0.3, 0.0, 0.0, 1.0);',
                    '    vec4 col2 = vec4(0.85, 0.85, 0.85, 1.0);',
                    '    uv.x = uv.x - mod(time * speed, 2.0) + 0.5;',
                    '    float y = uv.x * gradient;',
                    '    float s = smoothstep(y - lineWidth, y, uv.y) - smoothstep(y, y + lineWidth, uv.y);',
                    '    gl_FragColor = (((s * col1) + (s * col2)) * tex);',
                    '    if (!reveal)',
                    '    {',
                    '        gl_FragColor += tex;',
                    '    }',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 39249: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME VIGNETTE_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform float radius;',
                    'uniform float strength;',
                    'uniform vec2 position;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec4 col = vec4(1.0);',
                    '    float d = length(outTexCoord - position);',
                    '    if (d <= radius)',
                    '    {',
                    '        float g = d / radius;',
                    '        g = sin(g * 3.14 * strength);',
                    '    	col = vec4(g * g * g);',
                    '    }',
                    '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                    '    gl_FragColor = texture * (1.0 - col);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 2878: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME WIPE_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'uniform vec4 config;',
                    'uniform bool reveal;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec2 uv = outTexCoord;',
                    '    vec4 color0;',
                    '    vec4 color1;',
                    '    if (reveal)',
                    '    {',
                    '        color0 = vec4(0);',
                    '        color1 = texture2D(uMainSampler, uv);',
                    '    }',
                    '    else',
                    '    {',
                    '        color0 = texture2D(uMainSampler, uv);',
                    '        color1 = vec4(0);',
                    '    }',
                    '    float distance = config.x;',
                    '    float width = config.y;',
                    '    float direction = config.z;',
                    '    float axis = uv.x;',
                    '    if (config.w == 1.0)',
                    '    {',
                    '        axis = uv.y;',
                    '    }',
                    '    float adjust = mix(width, -width, distance);',
                    '    float value = smoothstep(distance - width, distance + width, abs(direction - axis) + adjust);',
                    '    gl_FragColor = mix(color1, color0, value);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 31063: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_LIGHT_FS',
                    'precision mediump float;',
                    'struct Light',
                    '{',
                    '    vec2 position;',
                    '    vec3 color;',
                    '    float intensity;',
                    '    float radius;',
                    '};',
                    'const int kMaxLights = %LIGHT_COUNT%;',
                    'uniform vec4 uCamera; /* x, y, rotation, zoom */',
                    'uniform vec2 uResolution;',
                    'uniform sampler2D uMainSampler;',
                    'uniform sampler2D uNormSampler;',
                    'uniform vec3 uAmbientLightColor;',
                    'uniform Light uLights[kMaxLights];',
                    'uniform mat3 uInverseRotationMatrix;',
                    'uniform int uLightCount;',
                    'varying vec2 outTexCoord;',
                    'varying float outTexId;',
                    'varying float outTintEffect;',
                    'varying vec4 outTint;',
                    'void main ()',
                    '{',
                    '    vec3 finalColor = vec3(0.0, 0.0, 0.0);',
                    '    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);',
                    '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                    '    vec4 color = texture * texel;',
                    '    if (outTintEffect == 1.0)',
                    '    {',
                    '        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);',
                    '    }',
                    '    else if (outTintEffect == 2.0)',
                    '    {',
                    '        color = texel;',
                    '    }',
                    '    vec3 normalMap = texture2D(uNormSampler, outTexCoord).rgb;',
                    '    vec3 normal = normalize(uInverseRotationMatrix * vec3(normalMap * 2.0 - 1.0));',
                    '    vec2 res = vec2(min(uResolution.x, uResolution.y)) * uCamera.w;',
                    '    for (int index = 0; index < kMaxLights; ++index)',
                    '    {',
                    '        if (index < uLightCount)',
                    '        {',
                    '            Light light = uLights[index];',
                    '            vec3 lightDir = vec3((light.position.xy / res) - (gl_FragCoord.xy / res), 0.1);',
                    '            vec3 lightNormal = normalize(lightDir);',
                    '            float distToSurf = length(lightDir) * uCamera.w;',
                    '            float diffuseFactor = max(dot(normal, lightNormal), 0.0);',
                    '            float radius = (light.radius / res.x * uCamera.w) * uCamera.w;',
                    '            float attenuation = clamp(1.0 - distToSurf * distToSurf / (radius * radius), 0.0, 1.0);',
                    '            vec3 diffuse = light.color * diffuseFactor;',
                    '            finalColor += (attenuation * diffuse) * light.intensity;',
                    '        }',
                    '    }',
                    '    vec4 colorOutput = vec4(uAmbientLightColor + finalColor, 1.0);',
                    '    gl_FragColor = color * vec4(colorOutput.rgb * colorOutput.a, colorOutput.a);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 48247: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_LINEAR_BLEND_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler1;',
                    'uniform sampler2D uMainSampler2;',
                    'uniform float uStrength;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);',
                    '    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);',
                    '    gl_FragColor = mix(frame1, frame2 * uStrength, 0.5);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 41214: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_MESH_FS',
                    'precision mediump float;',
                    'uniform vec3 uLightPosition;',
                    'uniform vec3 uLightAmbient;',
                    'uniform vec3 uLightDiffuse;',
                    'uniform vec3 uLightSpecular;',
                    'uniform vec3 uFogColor;',
                    'uniform float uFogNear;',
                    'uniform float uFogFar;',
                    'uniform vec3 uMaterialAmbient;',
                    'uniform vec3 uMaterialDiffuse;',
                    'uniform vec3 uMaterialSpecular;',
                    'uniform float uMaterialShine;',
                    'uniform vec3 uCameraPosition;',
                    'uniform sampler2D uTexture;',
                    'varying vec2 vTextureCoord;',
                    'varying vec3 vNormal;',
                    'varying vec3 vPosition;',
                    'void main (void)',
                    '{',
                    '    vec4 color = texture2D(uTexture, vTextureCoord);',
                    '    vec3 ambient = uLightAmbient * uMaterialAmbient;',
                    '    vec3 norm = normalize(vNormal);',
                    '    vec3 lightDir = normalize(uLightPosition - vPosition);',
                    '    float diff = max(dot(norm, lightDir), 0.0);',
                    '    vec3 diffuse = uLightDiffuse * (diff * uMaterialDiffuse);',
                    '    vec3 viewDir = normalize(uCameraPosition - vPosition);',
                    '    vec3 reflectDir = reflect(-lightDir, norm);',
                    '    float spec = pow(max(dot(viewDir, reflectDir), 0.0), uMaterialShine);',
                    '    vec3 specular = uLightSpecular * (spec * uMaterialSpecular);',
                    '    vec3 result = (ambient + diffuse + specular) * color.rgb;',
                    '    float depth = gl_FragCoord.z / gl_FragCoord.w;',
                    '    float fogFactor = smoothstep(uFogNear, uFogFar, depth);',
                    '    gl_FragColor.rgb = mix(result.rgb, uFogColor, fogFactor);',
                    '    gl_FragColor.a = color.a;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 39653: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_MESH_VS',
                    'precision mediump float;',
                    'attribute vec3 aVertexPosition;',
                    'attribute vec3 aVertexNormal;',
                    'attribute vec2 aTextureCoord;',
                    'uniform mat4 uViewProjectionMatrix;',
                    'uniform mat4 uModelMatrix;',
                    'uniform mat4 uNormalMatrix;',
                    'varying vec2 vTextureCoord;',
                    'varying vec3 vNormal;',
                    'varying vec3 vPosition;',
                    'void main ()',
                    '{',
                    '    vTextureCoord = aTextureCoord;',
                    '    vPosition = vec3(uModelMatrix * vec4(aVertexPosition, 1.0));',
                    '    vNormal = vec3(uNormalMatrix * vec4(aVertexNormal, 1.0));',
                    '    gl_Position = uViewProjectionMatrix * uModelMatrix * vec4(aVertexPosition, 1.0);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 62143: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_MOBILE_FS',
                    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
                    'precision highp float;',
                    '#else',
                    'precision mediump float;',
                    '#endif',
                    'uniform sampler2D uMainSampler;',
                    'varying vec2 outTexCoord;',
                    'varying float outTintEffect;',
                    'varying vec4 outTint;',
                    'void main ()',
                    '{',
                    '    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);',
                    '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                    '    vec4 color = texture * texel;',
                    '    if (outTintEffect == 1.0)',
                    '    {',
                    '        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);',
                    '    }',
                    '    else if (outTintEffect == 2.0)',
                    '    {',
                    '        color = texel;',
                    '    }',
                    '    gl_FragColor = color;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 47940: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_MOBILE_VS',
                    'precision mediump float;',
                    'uniform mat4 uProjectionMatrix;',
                    'uniform vec2 uResolution;',
                    'attribute vec2 inPosition;',
                    'attribute vec2 inTexCoord;',
                    'attribute float inTexId;',
                    'attribute float inTintEffect;',
                    'attribute vec4 inTint;',
                    'varying vec2 outTexCoord;',
                    'varying float outTintEffect;',
                    'varying vec4 outTint;',
                    'void main ()',
                    '{',
                    '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                    '    outTexCoord = inTexCoord;',
                    '    outTint = inTint;',
                    '    outTintEffect = inTintEffect;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 98840: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_MULTI_FS',
                    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
                    'precision highp float;',
                    '#else',
                    'precision mediump float;',
                    '#endif',
                    'uniform sampler2D uMainSampler[%count%];',
                    'varying vec2 outTexCoord;',
                    'varying float outTexId;',
                    'varying float outTintEffect;',
                    'varying vec4 outTint;',
                    'void main ()',
                    '{',
                    '    vec4 texture;',
                    '    %forloop%',
                    '    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);',
                    '    vec4 color = texture * texel;',
                    '    if (outTintEffect == 1.0)',
                    '    {',
                    '        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);',
                    '    }',
                    '    else if (outTintEffect == 2.0)',
                    '    {',
                    '        color = texel;',
                    '    }',
                    '    gl_FragColor = color;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 44667: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_MULTI_VS',
                    'precision mediump float;',
                    'uniform mat4 uProjectionMatrix;',
                    'uniform vec2 uResolution;',
                    'attribute vec2 inPosition;',
                    'attribute vec2 inTexCoord;',
                    'attribute float inTexId;',
                    'attribute float inTintEffect;',
                    'attribute vec4 inTint;',
                    'varying vec2 outTexCoord;',
                    'varying float outTexId;',
                    'varying float outTintEffect;',
                    'varying vec4 outTint;',
                    'void main ()',
                    '{',
                    '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                    '    outTexCoord = inTexCoord;',
                    '    outTexId = inTexId;',
                    '    outTint = inTint;',
                    '    outTintEffect = inTintEffect;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 4127: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_POINTLIGHT_FS',
                    'precision mediump float;',
                    'uniform vec2 uResolution;',
                    'uniform float uCameraZoom;',
                    'varying vec4 lightPosition;',
                    'varying vec4 lightColor;',
                    'varying float lightRadius;',
                    'varying float lightAttenuation;',
                    'void main ()',
                    '{',
                    '    vec2 center = (lightPosition.xy + 1.0) * (uResolution.xy * 0.5);',
                    '    float distToSurf = length(center - gl_FragCoord.xy);',
                    '    float radius = 1.0 - distToSurf / (lightRadius * uCameraZoom);',
                    '    float intensity = smoothstep(0.0, 1.0, radius * lightAttenuation);',
                    '    vec4 color = vec4(intensity, intensity, intensity, 0.0) * lightColor;',
                    '    gl_FragColor = vec4(color.rgb * lightColor.a, color.a);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 89924: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_POINTLIGHT_VS',
                    'precision mediump float;',
                    'uniform mat4 uProjectionMatrix;',
                    'attribute vec2 inPosition;',
                    'attribute vec2 inLightPosition;',
                    'attribute vec4 inLightColor;',
                    'attribute float inLightRadius;',
                    'attribute float inLightAttenuation;',
                    'varying vec4 lightPosition;',
                    'varying vec4 lightColor;',
                    'varying float lightRadius;',
                    'varying float lightAttenuation;',
                    'void main ()',
                    '{',
                    '    lightColor = inLightColor;',
                    '    lightRadius = inLightRadius;',
                    '    lightAttenuation = inLightAttenuation;',
                    '    lightPosition = uProjectionMatrix * vec4(inLightPosition, 1.0, 1.0);',
                    '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 27681: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_POSTFX_FS',
                    'precision mediump float;',
                    'uniform sampler2D uMainSampler;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    gl_FragColor = texture2D(uMainSampler, outTexCoord);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 49627: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_QUAD_VS',
                    'precision mediump float;',
                    'attribute vec2 inPosition;',
                    'attribute vec2 inTexCoord;',
                    'varying vec2 outFragCoord;',
                    'varying vec2 outTexCoord;',
                    'void main ()',
                    '{',
                    '    outFragCoord = inPosition.xy * 0.5 + 0.5;',
                    '    outTexCoord = inTexCoord;',
                    '    gl_Position = vec4(inPosition, 0, 1);',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 45561: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_SINGLE_FS',
                    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
                    'precision highp float;',
                    '#else',
                    'precision mediump float;',
                    '#endif',
                    'uniform sampler2D uMainSampler;',
                    'varying vec2 outTexCoord;',
                    'varying float outTintEffect;',
                    'varying vec4 outTint;',
                    'void main ()',
                    '{',
                    '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                    '    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);',
                    '    vec4 color = texture * texel;',
                    '    if (outTintEffect == 1.0)',
                    '    {',
                    '        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);',
                    '    }',
                    '    else if (outTintEffect == 2.0)',
                    '    {',
                    '        color = texel;',
                    '    }',
                    '    gl_FragColor = color;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 60722: /***/ (module1)=>{
                module1.exports = [
                    '#define SHADER_NAME PHASER_SINGLE_VS',
                    'precision mediump float;',
                    'uniform mat4 uProjectionMatrix;',
                    'uniform vec2 uResolution;',
                    'attribute vec2 inPosition;',
                    'attribute vec2 inTexCoord;',
                    'attribute float inTexId;',
                    'attribute float inTintEffect;',
                    'attribute vec4 inTint;',
                    'varying vec2 outTexCoord;',
                    'varying float outTintEffect;',
                    'varying vec4 outTint;',
                    'void main ()',
                    '{',
                    '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                    '    outTexCoord = inTexCoord;',
                    '    outTint = inTint;',
                    '    outTintEffect = inTintEffect;',
                    '}'
                ].join('\n');
            /***/ },
            /***/ 89350: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2013-2023 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.WebGL.Shaders
 */ module1.exports = {
                    AddBlendFrag: __webpack_require__(35407),
                    BitmapMaskFrag: __webpack_require__(78908),
                    BitmapMaskVert: __webpack_require__(85191),
                    ColorMatrixFrag: __webpack_require__(96293),
                    CopyFrag: __webpack_require__(36682),
                    FXBarrelFrag: __webpack_require__(99155),
                    FXBloomFrag: __webpack_require__(24400),
                    FXBlurHighFrag: __webpack_require__(94328),
                    FXBlurLowFrag: __webpack_require__(41514),
                    FXBlurMedFrag: __webpack_require__(51078),
                    FXBokehFrag: __webpack_require__(90610),
                    FXCircleFrag: __webpack_require__(91899),
                    FXDisplacementFrag: __webpack_require__(47838),
                    FXGlowFrag: __webpack_require__(98656),
                    FXGradientFrag: __webpack_require__(70463),
                    FXPixelateFrag: __webpack_require__(50831),
                    FXShadowFrag: __webpack_require__(92595),
                    FXShineFrag: __webpack_require__(72464),
                    FXVignetteFrag: __webpack_require__(39249),
                    FXWipeFrag: __webpack_require__(2878),
                    LightFrag: __webpack_require__(31063),
                    LinearBlendFrag: __webpack_require__(48247),
                    MeshFrag: __webpack_require__(41214),
                    MeshVert: __webpack_require__(39653),
                    MobileFrag: __webpack_require__(62143),
                    MobileVert: __webpack_require__(47940),
                    MultiFrag: __webpack_require__(98840),
                    MultiVert: __webpack_require__(44667),
                    PointLightFrag: __webpack_require__(4127),
                    PointLightVert: __webpack_require__(89924),
                    PostFXFrag: __webpack_require__(27681),
                    QuadVert: __webpack_require__(49627),
                    SingleFrag: __webpack_require__(45561),
                    SingleVert: __webpack_require__(60722)
                };
            /***/ },
            /***/ 93567: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * Wrapper for a WebGL attribute location, containing all the information that was used to create it.
 *
 * A WebGLAttribLocation should never be exposed outside the WebGLRenderer,
 * so the WebGLRenderer can handle context loss and other events without other systems having to be aware of it.
 * Always use WebGLAttribLocationWrapper instead.
 *
 * @class WebGLAttribLocationWrapper
 * @memberof Phaser.Renderer.WebGL.Wrappers
 * @constructor
 * @since 3.80.0
 *
 * @param {WebGLRenderingContext} gl - The WebGLRenderingContext to create the WebGLAttribLocation for.
 * @param {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper} program - The WebGLProgram that this location refers to. This must be created first.
 * @param {string} name - The name of this location, as defined in the shader source code.
 */ var WebGLAttribLocationWrapper = new Class({
                    initialize: function WebGLAttribLocationWrapper(gl, program, name) {
                        /**
         * The WebGLAttribLocation being wrapped by this class.
         *
         * This property could change at any time.
         * Therefore, you should never store a reference to this value.
         * It should only be passed directly to the WebGL API for drawing.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper#webGLAttribLocation
         * @type {GLint}
         * @default -1
         * @since 3.80.0
         */ this.webGLAttribLocation = -1;
                        /**
         * The WebGLRenderingContext that owns this location.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper#gl
         * @type {WebGLRenderingContext}
         * @since 3.80.0
         */ this.gl = gl;
                        /**
         * The WebGLProgram that this location refers to.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper#program
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper}
         * @since 3.80.0
         */ this.program = program;
                        /**
         * The name of this location, as defined in the shader source code.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper#name
         * @type {string}
         * @since 3.80.0
         */ this.name = name;
                        this.createResource();
                    },
                    /**
     * Creates the WebGLAttribLocation.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper#createResource
     * @since 3.80.0
     */ createResource: function() {
                        if (this.program.webGLProgram === null) {
                            this.webGLAttribLocation = -1;
                            return;
                        }
                        var gl = this.gl;
                        if (gl.isContextLost()) // GL state can't be updated right now.
                        // `createResource` will run when the context is restored.
                        return;
                        this.webGLAttribLocation = gl.getAttribLocation(this.program.webGLProgram, this.name);
                    },
                    /**
     * Destroys this WebGLAttribLocationWrapper.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLAttribLocationWrapper#destroy
     * @since 3.80.0
     */ destroy: function() {
                        this.gl = null;
                        this.program = null;
                        this.name = null;
                        this.webGLAttribLocation = -1;
                    }
                });
                module1.exports = WebGLAttribLocationWrapper;
            /***/ },
            /***/ 26128: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * Wrapper for a WebGL buffer, containing all the information that was used
 * to create it. This can be a VertexBuffer or IndexBuffer.
 *
 * A WebGLBuffer should never be exposed outside the WebGLRenderer, so the
 * WebGLRenderer can handle context loss and other events without other
 * systems having to be aware of it. Always use WebGLBufferWrapper instead.
 *
 * @class WebGLBufferWrapper
 * @memberof Phaser.Renderer.WebGL.Wrappers
 * @constructor
 * @since 3.80.0
 *
 * @param {WebGLRenderingContext} gl - The WebGLRenderingContext to create the WebGLBuffer for.
 * @param {ArrayBuffer|number} initialDataOrSize - Either an ArrayBuffer of data, or the size of the buffer to create.
 * @param {GLenum} bufferType - The type of the buffer being created.
 * @param {GLenum} bufferUsage - The usage of the buffer being created. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW.
 */ var WebGLBufferWrapper = new Class({
                    initialize: function WebGLBufferWrapper(gl, initialDataOrSize, bufferType, bufferUsage) {
                        /**
         * The WebGLBuffer being wrapped by this class.
         *
         * This property could change at any time.
         * Therefore, you should never store a reference to this value.
         * It should only be passed directly to the WebGL API for drawing.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper#webGLBuffer
         * @type {?WebGLBuffer}
         * @default null
         * @since 3.80.0
         */ this.webGLBuffer = null;
                        /**
         * The WebGLRenderingContext that owns this WebGLBuffer.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper#gl
         * @type {WebGLRenderingContext}
         * @since 3.80.0
         */ this.gl = gl;
                        /**
         * The initial data or size of the buffer.
         *
         * Note that this will be used to recreate the buffer if the WebGL context is lost.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper#initialDataOrSize
         * @type {ArrayBuffer|number}
         * @since 3.80.0
         */ this.initialDataOrSize = initialDataOrSize;
                        /**
         * The type of the buffer.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper#bufferType
         * @type {GLenum}
         * @since 3.80.0
         */ this.bufferType = bufferType;
                        /**
         * The usage of the buffer. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper#bufferUsage
         * @type {GLenum}
         * @since 3.80.0
         */ this.bufferUsage = bufferUsage;
                        this.createResource();
                    },
                    /**
     * Creates a WebGLBuffer for this WebGLBufferWrapper.
     *
     * This is called automatically by the constructor. It may also be
     * called again if the WebGLBuffer needs re-creating.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper#createResource
     * @since 3.80.0
     */ createResource: function() {
                        if (this.initialDataOrSize === null) return;
                        var gl = this.gl;
                        if (gl.isContextLost()) // GL state can't be updated right now.
                        // `createResource` will run when the context is restored.
                        return;
                        var bufferType = this.bufferType;
                        var webGLBuffer = gl.createBuffer();
                        this.webGLBuffer = webGLBuffer;
                        gl.bindBuffer(bufferType, this.webGLBuffer);
                        gl.bufferData(bufferType, this.initialDataOrSize, this.bufferUsage);
                        gl.bindBuffer(bufferType, null);
                    },
                    /**
     * Remove this WebGLBufferWrapper from the GL context.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLBufferWrapper#destroy
     * @since 3.80.0
     */ destroy: function() {
                        var gl = this.gl;
                        if (!gl.isContextLost()) gl.deleteBuffer(this.webGLBuffer);
                        this.webGLBuffer = null;
                        this.initialDataOrSize = null;
                        this.gl = null;
                    }
                });
                module1.exports = WebGLBufferWrapper;
            /***/ },
            /***/ 84387: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                // Possible errors that can be thrown by `gl.checkFramebufferStatus()`.
                /**
 * @ignore 
 */ var errors = {
                    36054: 'Incomplete Attachment',
                    36055: 'Missing Attachment',
                    36057: 'Incomplete Dimensions',
                    36061: 'Framebuffer Unsupported'
                };
                /**
 * @classdesc
 * Wrapper for a WebGL frame buffer,
 * containing all the information that was used to create it.
 *
 * A WebGLFramebuffer should never be exposed outside the WebGLRenderer,
 * so the WebGLRenderer can handle context loss and other events
 * without other systems having to be aware of it.
 * Always use WebGLFramebufferWrapper instead.
 *
 * @class WebGLFramebufferWrapper
 * @memberof Phaser.Renderer.WebGL.Wrappers
 * @constructor
 * @since 3.80.0
 *
 * @param {WebGLRenderingContext} gl - The WebGLRenderingContext to create the WebGLFramebuffer for.
 * @param {number} width - If `addDepthStencilBuffer` is true, this controls the width of the depth stencil.
 * @param {number} height - If `addDepthStencilBuffer` is true, this controls the height of the depth stencil.
 * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} renderTexture - The color texture where the color pixels are written.
 * @param {boolean} [addDepthStencilBuffer=false] - Create a Renderbuffer for the depth stencil?
 */ var WebGLFramebufferWrapper = new Class({
                    initialize: function WebGLFramebufferWrapper(gl, width, height, renderTexture, addDepthStencilBuffer) {
                        /**
         * The WebGLFramebuffer being wrapped by this class.
         *
         * This property could change at any time.
         * Therefore, you should never store a reference to this value.
         * It should only be passed directly to the WebGL API for drawing.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#webGLFramebuffer
         * @type {?WebGLFramebuffer}
         * @default null
         * @since 3.80.0
         */ this.webGLFramebuffer = null;
                        /**
         * The WebGL context this WebGLFramebuffer belongs to.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#gl
         * @type {WebGLRenderingContext}
         * @since 3.80.0
         */ this.gl = gl;
                        /**
         * Width of the depth stencil.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#width
         * @type {number}
         * @since 3.80.0
         */ this.width = width;
                        /**
         * Height of the depth stencil.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#height
         * @type {number}
         * @since 3.80.0
         */ this.height = height;
                        /**
         * The color texture where the color pixels are written.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#renderTexture
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @since 3.80.0
         */ this.renderTexture = renderTexture;
                        /**
         * Create a Renderbuffer for the depth stencil?
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#addDepthStencilBuffer
         * @type {boolean}
         * @default false
         * @since 3.80.0
         */ this.addDepthStencilBuffer = !!addDepthStencilBuffer;
                        this.createResource();
                    },
                    /**
     * Creates a WebGLFramebuffer from the given parameters.
     *
     * This is called automatically by the constructor. It may also be
     * called again if the WebGLFramebuffer needs re-creating.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#createResource
     * @since 3.80.0
     */ createResource: function() {
                        var gl = this.gl;
                        if (gl.isContextLost()) // GL state can't be updated right now.
                        // `createResource` will run when the context is restored.
                        return;
                        var renderTexture = this.renderTexture;
                        var complete = 0;
                        var framebuffer = gl.createFramebuffer();
                        this.webGLFramebuffer = framebuffer;
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                        renderTexture.isRenderTexture = true;
                        renderTexture.isAlphaPremultiplied = false;
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, renderTexture.webGLTexture, 0);
                        complete = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
                        if (complete !== gl.FRAMEBUFFER_COMPLETE) throw new Error('Framebuffer status: ' + (errors[complete] || complete));
                        if (this.addDepthStencilBuffer) {
                            var depthStencilBuffer = gl.createRenderbuffer();
                            gl.bindRenderbuffer(gl.RENDERBUFFER, depthStencilBuffer);
                            gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, this.width, this.height);
                            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, depthStencilBuffer);
                        }
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    },
                    /**
     * Destroys this WebGLFramebufferWrapper.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLFramebufferWrapper#destroy
     * @since 3.80.0
     */ destroy: function() {
                        if (this.webGLFramebuffer === null) return;
                        var gl = this.gl;
                        if (!gl.isContextLost()) {
                            gl.bindFramebuffer(gl.FRAMEBUFFER, this.webGLFramebuffer);
                            // Check for a color attachment and remove it
                            var colorAttachment = gl.getFramebufferAttachmentParameter(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.FRAMEBUFFER_ATTACHMENT_OBJECT_NAME);
                            if (colorAttachment !== null) {
                                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0);
                                gl.deleteTexture(colorAttachment);
                            }
                            // Check for a depth-stencil attachment and remove it
                            var depthStencilAttachment = gl.getFramebufferAttachmentParameter(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.FRAMEBUFFER_ATTACHMENT_OBJECT_NAME);
                            if (depthStencilAttachment !== null) gl.deleteRenderbuffer(depthStencilAttachment);
                            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                            gl.deleteFramebuffer(this.webGLFramebuffer);
                        }
                        this.renderTexture = null;
                        this.webGLFramebuffer = null;
                        this.gl = null;
                    }
                });
                module1.exports = WebGLFramebufferWrapper;
            /***/ },
            /***/ 1482: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * Wrapper for a WebGL program, containing all the information that was used to create it.
 *
 * A WebGLProgram should never be exposed outside the WebGLRenderer, so the WebGLRenderer
 * can handle context loss and other events without other systems having to be aware of it.
 * Always use WebGLProgramWrapper instead.
 *
 * @class WebGLProgramWrapper
 * @memberof Phaser.Renderer.WebGL.Wrappers
 * @constructor
 * @since 3.80.0
 *
 * @param {WebGLRenderingContext} gl - The WebGLRenderingContext to create the WebGLProgram for.
 * @param {string} vertexSource - The vertex shader source code as a string.
 * @param {string} fragmentShader - The fragment shader source code as a string.
 */ var WebGLProgramWrapper = new Class({
                    initialize: function WebGLProgramWrapper(gl, vertexSource, fragmentSource) {
                        /**
         * The WebGLProgram being wrapped by this class.
         *
         * This property could change at any time.
         * Therefore, you should never store a reference to this value.
         * It should only be passed directly to the WebGL API for drawing.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper#webGLProgram
         * @type {?WebGLProgram}
         * @default null
         * @since 3.80.0
         */ this.webGLProgram = null;
                        /**
         * The WebGLRenderingContext that owns this WebGLProgram.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper#gl
         * @type {WebGLRenderingContext}
         * @since 3.80.0
         */ this.gl = gl;
                        /**
         * The vertex shader source code as a string.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper#vertexSource
         * @type {string}
         * @since 3.80.0
         */ this.vertexSource = vertexSource;
                        /**
         * The fragment shader source code as a string.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper#fragmentSource
         * @type {string}
         * @since 3.80.0
         */ this.fragmentSource = fragmentSource;
                        this.createResource();
                    },
                    /**
     * Creates a WebGLProgram from the given vertex and fragment shaders.
     *
     * This is called automatically by the constructor. It may also be
     * called again if the WebGLProgram needs re-creating.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper#createResource
     * @throws {Error} If the shaders failed to compile or link.
     * @since 3.80.0
     */ createResource: function() {
                        var gl = this.gl;
                        if (gl.isContextLost()) // GL state can't be updated right now.
                        // `createResource` will run when the context is restored.
                        return;
                        var program = gl.createProgram();
                        var vs = gl.createShader(gl.VERTEX_SHADER);
                        var fs = gl.createShader(gl.FRAGMENT_SHADER);
                        gl.shaderSource(vs, this.vertexSource);
                        gl.shaderSource(fs, this.fragmentSource);
                        gl.compileShader(vs);
                        gl.compileShader(fs);
                        var failed = 'Shader failed:\n';
                        if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) throw new Error('Vertex ' + failed + gl.getShaderInfoLog(vs));
                        if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) throw new Error('Fragment ' + failed + gl.getShaderInfoLog(fs));
                        gl.attachShader(program, vs);
                        gl.attachShader(program, fs);
                        gl.linkProgram(program);
                        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Link ' + failed + gl.getProgramInfoLog(program));
                        gl.useProgram(program);
                        this.webGLProgram = program;
                    },
                    /**
     * Remove this WebGLProgram from the GL context.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper#destroy
     * @since 3.80.0
     */ destroy: function() {
                        if (!this.webGLProgram) return;
                        if (!this.gl.isContextLost()) this.gl.deleteProgram(this.webGLProgram);
                        this.webGLProgram = null;
                        this.gl = null;
                    }
                });
                module1.exports = WebGLProgramWrapper;
            /***/ },
            /***/ 82751: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var IsSizePowerOfTwo = __webpack_require__(50030);
                /**
 * @classdesc
 * Wrapper for a WebGL texture, containing all the information that was used
 * to create it.
 *
 * A WebGLTexture should never be exposed outside the WebGLRenderer,
 * so the WebGLRenderer can handle context loss and other events
 * without other systems having to be aware of it.
 * Always use WebGLTextureWrapper instead.
 *
 * @class WebGLTextureWrapper
 * @memberof Phaser.Renderer.WebGL.Wrappers
 * @constructor
 * @since 3.80.0
 *
 * @param {WebGLRenderingContext} gl - WebGL context the texture belongs to.
 * @param {number} mipLevel - Mip level of the texture.
 * @param {number} minFilter - Filtering of the texture.
 * @param {number} magFilter - Filtering of the texture.
 * @param {number} wrapT - Wrapping mode of the texture.
 * @param {number} wrapS - Wrapping mode of the texture.
 * @param {number} format - Which format does the texture use.
 * @param {?object} pixels - pixel data.
 * @param {number} width - Width of the texture in pixels.
 * @param {number} height - Height of the texture in pixels.
 * @param {boolean} [pma=true] - Does the texture have premultiplied alpha?
 * @param {boolean} [forceSize=false] - If `true` it will use the width and height passed to this method, regardless of the pixels dimension.
 * @param {boolean} [flipY=false] - Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
 */ var WebGLTextureWrapper = new Class({
                    initialize: function WebGLTextureWrapper(gl, mipLevel, minFilter, magFilter, wrapT, wrapS, format, pixels, width, height, pma, forceSize, flipY) {
                        /**
         * The WebGLTexture that this wrapper is wrapping.
         *
         * This property could change at any time.
         * Therefore, you should never store a reference to this value.
         * It should only be passed directly to the WebGL API for drawing.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#webGLTexture
         * @type {?WebGLTexture}
         * @default null
         * @since 3.80.0
         */ this.webGLTexture = null;
                        /**
         * Whether this is used as a RenderTexture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#isRenderTexture
         * @type {boolean}
         * @default false
         * @since 3.80.0
         */ this.isRenderTexture = false;
                        /**
         * The WebGL context this WebGLTexture belongs to.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#gl
         * @type {WebGLRenderingContext}
         * @since 3.80.0
         */ this.gl = gl;
                        /**
         * Mip level of the texture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#mipLevel
         * @type {number}
         * @since 3.80.0
         */ this.mipLevel = mipLevel;
                        /**
         * Filtering of the texture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#minFilter
         * @type {number}
         * @since 3.80.0
         */ this.minFilter = minFilter;
                        /**
         * Filtering of the texture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#magFilter
         * @type {number}
         * @since 3.80.0
         */ this.magFilter = magFilter;
                        /**
         * Wrapping mode of the texture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#wrapT
         * @type {number}
         * @since 3.80.0
         */ this.wrapT = wrapT;
                        /**
         * Wrapping mode of the texture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#wrapS
         * @type {number}
         * @since 3.80.0
         */ this.wrapS = wrapS;
                        /**
         * Which format does the texture use.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#format
         * @type {number}
         * @since 3.80.0
         */ this.format = format;
                        /**
         * Pixel data. This is the source data used to create the WebGLTexture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#pixels
         * @type {?object}
         * @since 3.80.0
         */ this.pixels = pixels;
                        /**
         * Width of the texture in pixels.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#width
         * @type {number}
         * @since 3.80.0
         */ this.width = width;
                        /**
         * Height of the texture in pixels.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#height
         * @type {number}
         * @since 3.80.0
         */ this.height = height;
                        /**
         * Does the texture have premultiplied alpha?
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#pma
         * @type {boolean}
         * @since 3.80.0
         */ this.pma = pma === undefined || pma === null ? true : pma;
                        /**
         * Whether to use the width and height properties, regardless of pixel dimensions.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#forceSize
         * @type {boolean}
         * @since 3.80.0
         */ this.forceSize = !!forceSize;
                        /**
         * Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#flipY
         * @type {boolean}
         * @since 3.80.0
         */ this.flipY = !!flipY;
                        /**
         * Metadata for the SpectorJS tool, set if debug is enabled.
         * You should set this via the `spectorMetadata` property,
         * which will update the `__SPECTOR_Metadata` property on the WebGLTexture.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#__SPECTOR_Metadata
         * @type {object}
         * @private
         * @since 3.80.0
         */ // eslint-disable-next-line camelcase
                        this.__SPECTOR_Metadata = {};
                        this.createResource();
                    },
                    /**
     * Creates a WebGLTexture from the given parameters.
     *
     * This is called automatically by the constructor. It may also be
     * called again if the WebGLTexture needs re-creating.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#createResource
     * @since 3.80.0
     */ createResource: function() {
                        var gl = this.gl;
                        if (gl.isContextLost()) // GL state can't be updated right now.
                        // `createResource` will run when the context is restored.
                        return;
                        if (this.pixels instanceof WebGLTextureWrapper) {
                            // Use the source texture directly.
                            this.webGLTexture = this.pixels.webGLTexture;
                            return;
                        }
                        var texture = gl.createTexture();
                        // Set Spector metadata.
                        // eslint-disable-next-line camelcase
                        texture.__SPECTOR_Metadata = this.__SPECTOR_Metadata;
                        // Assign the texture to our wrapper.
                        this.webGLTexture = texture;
                        this._processTexture();
                    },
                    /**
     * Updates the WebGLTexture from an updated source.
     *
     * This should only be used when the source is a Canvas or Video element.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#update
     * @since 3.80.0
     *
     * @param {?object} source - The source to update the WebGLTexture with.
     * @param {number} width - The new width of the WebGLTexture.
     * @param {number} height - The new height of the WebGLTexture.
     * @param {boolean} flipY - Should the WebGLTexture set `UNPACK_MULTIPLY_FLIP_Y`?
     * @param {number} wrapS - The new wrapping mode for the WebGLTexture.
     * @param {number} wrapT - The new wrapping mode for the WebGLTexture.
     * @param {number} minFilter - The new minification filter for the WebGLTexture.
     * @param {number} magFilter - The new magnification filter for the WebGLTexture.
     * @param {number} format - The new format for the WebGLTexture.
     */ update: function(source, width, height, flipY, wrapS, wrapT, minFilter, magFilter, format) {
                        if (width === 0 || height === 0) return;
                        // Assume that the source might change.
                        this.pixels = source;
                        this.width = width;
                        this.height = height;
                        this.flipY = flipY;
                        this.wrapS = wrapS;
                        this.wrapT = wrapT;
                        this.minFilter = minFilter;
                        this.magFilter = magFilter;
                        this.format = format;
                        var gl = this.gl;
                        if (gl.isContextLost()) // GL state can't be updated right now.
                        // `createResource` will run when the context is restored.
                        return;
                        this._processTexture();
                    },
                    /**
     * Set all parameters of this WebGLTexture per the stored values.
     *
     * @function Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#_processTexture
     * @protected
     * @since 3.85.0
     * @ignore
     */ _processTexture: function() {
                        var gl = this.gl;
                        gl.activeTexture(gl.TEXTURE0);
                        var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                        gl.bindTexture(gl.TEXTURE_2D, this.webGLTexture);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, this.minFilter);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, this.magFilter);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, this.wrapS);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, this.wrapT);
                        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.pma);
                        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
                        var pixels = this.pixels;
                        var mipLevel = this.mipLevel;
                        var width = this.width;
                        var height = this.height;
                        var format = this.format;
                        var generateMipmap = false;
                        if (pixels === null || pixels === undefined) {
                            gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, width, height, 0, format, gl.UNSIGNED_BYTE, null);
                            generateMipmap = IsSizePowerOfTwo(width, height);
                        } else if (pixels.compressed) {
                            width = pixels.width;
                            height = pixels.height;
                            generateMipmap = pixels.generateMipmap;
                            for(var i = 0; i < pixels.mipmaps.length; i++)gl.compressedTexImage2D(gl.TEXTURE_2D, i, pixels.internalFormat, pixels.mipmaps[i].width, pixels.mipmaps[i].height, 0, pixels.mipmaps[i].data);
                        } else if (pixels instanceof Uint8Array) {
                            gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, width, height, 0, format, gl.UNSIGNED_BYTE, pixels);
                            generateMipmap = IsSizePowerOfTwo(width, height);
                        } else {
                            if (!this.forceSize) {
                                width = pixels.width;
                                height = pixels.height;
                            }
                            gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, format, gl.UNSIGNED_BYTE, pixels);
                            generateMipmap = IsSizePowerOfTwo(width, height);
                        }
                        if (generateMipmap) gl.generateMipmap(gl.TEXTURE_2D);
                        // Restore previous texture bind.
                        if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                        else gl.bindTexture(gl.TEXTURE_2D, null);
                    },
                    /**
     * The `__SPECTOR_Metadata` property of the `WebGLTexture`,
     * used to add extra data to the debug SpectorJS integration.
     *
     * @name Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#spectorMetadata
     * @type {object}
     * @since 3.80.0
     */ spectorMetadata: {
                        get: function() {
                            return this.__SPECTOR_Metadata;
                        },
                        set: function(value) {
                            // eslint-disable-next-line camelcase
                            this.__SPECTOR_Metadata = value;
                            if (!this.gl.isContextLost()) // eslint-disable-next-line camelcase
                            this.webGLTexture.__SPECTOR_Metadata = value;
                        }
                    },
                    /**
     * Deletes the WebGLTexture from the GPU, if it has not been already.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper#destroy
     * @since 3.80.0
     */ destroy: function() {
                        if (this.webGLTexture === null) return;
                        if (!this.gl.isContextLost()) {
                            if (!(this.pixels instanceof WebGLTextureWrapper)) // Do not delete a texture that belongs to another wrapper.
                            this.gl.deleteTexture(this.webGLTexture);
                        }
                        this.pixels = null;
                        this.webGLTexture = null;
                        this.gl = null;
                    }
                });
                module1.exports = WebGLTextureWrapper;
            /***/ },
            /***/ 57183: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * Wrapper for a WebGL uniform location, containing all the information that was used to create it.
 *
 * A WebGLUniformLocation should never be exposed outside the WebGLRenderer,
 * so the WebGLRenderer can handle context loss and other events without other systems having to be aware of it.
 * Always use WebGLUniformLocationWrapper instead.
 *
 * @class WebGLUniformLocationWrapper
 * @memberof Phaser.Renderer.WebGL.Wrappers
 * @constructor
 * @since 3.80.0
 *
 * @param {WebGLRenderingContext} gl - The WebGLRenderingContext to create the WebGLUniformLocation for.
 * @param {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper} program - The WebGLProgram that this location refers to. This must be created first.
 * @param {string} name - The name of this location, as defined in the shader source code.
 */ var WebGLUniformLocationWrapper = new Class({
                    initialize: function WebGLUniformLocationWrapper(gl, program, name) {
                        /**
         * The WebGLUniformLocation being wrapped by this class.
         *
         * This property could change at any time.
         * Therefore, you should never store a reference to this value.
         * It should only be passed directly to the WebGL API for drawing.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper#webGLUniformLocation
         * @type {?WebGLUniformLocation}
         * @default null
         * @since 3.80.0
         */ this.webGLUniformLocation = null;
                        /**
         * The WebGLRenderingContext that owns this location.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper#gl
         * @type {WebGLRenderingContext}
         * @since 3.80.0
         */ this.gl = gl;
                        /**
         * The WebGLProgram that this location refers to.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper#program
         * @type {Phaser.Renderer.WebGL.Wrappers.WebGLProgramWrapper}
         * @since 3.80.0
         */ this.program = program;
                        /**
         * The name of this location, as defined in the shader source code.
         *
         * @name Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper#name
         * @type {string}
         * @since 3.80.0
         */ this.name = name;
                        this.createResource();
                    },
                    /**
     * Creates the WebGLUniformLocation.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper#createResource
     * @since 3.80.0
     */ createResource: function() {
                        if (this.program.webGLProgram === null) {
                            this.webGLUniformLocation = null;
                            return;
                        }
                        var gl = this.gl;
                        if (gl.isContextLost()) // GL state can't be updated right now.
                        // `createResource` will run when the context is restored.
                        return;
                        this.webGLUniformLocation = gl.getUniformLocation(this.program.webGLProgram, this.name);
                    },
                    /**
     * Destroys this WebGLUniformLocationWrapper.
     *
     * @method Phaser.Renderer.WebGL.Wrappers.WebGLUniformLocationWrapper#destroy
     * @since 3.80.0
     */ destroy: function() {
                        this.gl = null;
                        this.program = null;
                        this.name = null;
                        this.webGLUniformLocation = null;
                    }
                });
                module1.exports = WebGLUniformLocationWrapper;
            /***/ },
            /***/ 9503: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.WebGL.Wrappers
 */ var Wrappers = {
                    WebGLAttribLocationWrapper: __webpack_require__(93567),
                    WebGLBufferWrapper: __webpack_require__(26128),
                    WebGLProgramWrapper: __webpack_require__(1482),
                    WebGLTextureWrapper: __webpack_require__(82751),
                    WebGLFramebufferWrapper: __webpack_require__(84387),
                    WebGLUniformLocationWrapper: __webpack_require__(57183)
                };
                module1.exports = Wrappers;
            /***/ },
            /***/ 76531: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(13560);
                var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(97480);
                var GameEvents = __webpack_require__(8443);
                var GetInnerHeight = __webpack_require__(57811);
                var GetTarget = __webpack_require__(74403);
                var GetScreenOrientation = __webpack_require__(45818);
                var NOOP = __webpack_require__(29747);
                var Rectangle = __webpack_require__(87841);
                var Size = __webpack_require__(86555);
                var SnapFloor = __webpack_require__(56583);
                var Vector2 = __webpack_require__(26099);
                var Camera = __webpack_require__(38058);
                /**
 * @classdesc
 * The Scale Manager handles the scaling, resizing and alignment of the game canvas.
 *
 * The way scaling is handled is by setting the game canvas to a fixed size, which is defined in the
 * game configuration. You also define the parent container in the game config. If no parent is given,
 * it will default to using the document body. The Scale Manager will then look at the available space
 * within the _parent_ and scale the canvas accordingly. Scaling is handled by setting the canvas CSS
 * width and height properties, leaving the width and height of the canvas element itself untouched.
 * Scaling is therefore achieved by keeping the core canvas the same size and 'stretching'
 * it via its CSS properties. This gives the same result and speed as using the `transform-scale` CSS
 * property, without the need for browser prefix handling.
 *
 * The calculations for the scale are heavily influenced by the bounding parent size, which is the computed
 * dimensions of the canvas's parent. The CSS rules of the parent element play an important role in the
 * operation of the Scale Manager. For example, if the parent has no defined width or height, then actions
 * like auto-centering will fail to achieve the required result. The Scale Manager works in tandem with the
 * CSS you set-up on the page hosting your game, rather than taking control of it.
 *
 * #### Parent and Display canvas containment guidelines:
 *
 * - Style the Parent element (of the game canvas) to control the Parent size and thus the games size and layout.
 *
 * - The Parent element's CSS styles should _effectively_ apply maximum (and minimum) bounding behavior.
 *
 * - The Parent element should _not_ apply a padding as this is not accounted for.
 *   If a padding is required apply it to the Parent's parent or apply a margin to the Parent.
 *   If you need to add a border, margin or any other CSS around your game container, then use a parent element and
 *   apply the CSS to this instead, otherwise you'll be constantly resizing the shape of the game container.
 *
 * - The Display canvas layout CSS styles (i.e. margins, size) should not be altered / specified as
 *   they may be updated by the Scale Manager.
 *
 * #### Scale Modes
 *
 * The way the scaling is handled is determined by the `scaleMode` property. The default is `NONE`,
 * which prevents Phaser from scaling or touching the canvas, or its parent, at all. In this mode, you are
 * responsible for all scaling. The other scaling modes afford you automatic scaling.
 *
 * If you wish to scale your game so that it always fits into the available space within the parent, you
 * should use the scale mode `FIT`. Look at the documentation for other scale modes to see what options are
 * available. Here is a basic config showing how to set this scale mode:
 *
 * ```javascript
 * scale: {
 *     parent: 'yourgamediv',
 *     mode: Phaser.Scale.FIT,
 *     width: 800,
 *     height: 600
 * }
 * ```
 *
 * Place the `scale` config object within your game config.
 *
 * If you wish for the canvas to be resized directly, so that the canvas itself fills the available space
 * (i.e. it isn't scaled, it's resized) then use the `RESIZE` scale mode. This will give you a 1:1 mapping
 * of canvas pixels to game size. In this mode CSS isn't used to scale the canvas, it's literally adjusted
 * to fill all available space within the parent. You should be extremely careful about the size of the
 * canvas you're creating when doing this, as the larger the area, the more work the GPU has to do and it's
 * very easy to hit fill-rate limits quickly.
 *
 * For complex, custom-scaling requirements, you should probably consider using the `RESIZE` scale mode,
 * with your own limitations in place re: canvas dimensions and managing the scaling with the game scenes
 * yourself. For the vast majority of games, however, the `FIT` mode is likely to be the most used.
 *
 * Please appreciate that the Scale Manager cannot perform miracles. All it does is scale your game canvas
 * as best it can, based on what it can infer from its surrounding area. There are all kinds of environments
 * where it's up to you to guide and help the canvas position itself, especially when built into rendering
 * frameworks like React and Vue. If your page requires meta tags to prevent user scaling gestures, or such
 * like, then it's up to you to ensure they are present in the html.
 *
 * #### Centering
 *
 * You can also have the game canvas automatically centered. Again, this relies heavily on the parent being
 * properly configured and styled, as the centering offsets are based entirely on the available space
 * within the parent element. Centering is disabled by default, or can be applied horizontally, vertically,
 * or both. Here's an example:
 *
 * ```javascript
 * scale: {
 *     parent: 'yourgamediv',
 *     autoCenter: Phaser.Scale.CENTER_BOTH,
 *     width: 800,
 *     height: 600
 * }
 * ```
 *
 * #### Fullscreen API
 *
 * If the browser supports it, you can send your game into fullscreen mode. In this mode, the game will fill
 * the entire display, removing all browser UI and anything else present on the screen. It will remain in this
 * mode until your game either disables it, or until the user tabs out or presses ESCape if on desktop. It's a
 * great way to achieve a desktop-game like experience from the browser, but it does require a modern browser
 * to handle it. Some mobile browsers also support this.
 *
 * @class ScaleManager
 * @memberof Phaser.Scale
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance.
 */ var ScaleManager = new Class({
                    Extends: EventEmitter,
                    initialize: function ScaleManager(game) {
                        EventEmitter.call(this);
                        /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Scale.ScaleManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.15.0
         */ this.game = game;
                        /**
         * A reference to the HTML Canvas Element that Phaser uses to render the game.
         *
         * @name Phaser.Scale.ScaleManager#canvas
         * @type {HTMLCanvasElement}
         * @since 3.16.0
         */ this.canvas;
                        /**
         * The DOM bounds of the canvas element.
         *
         * @name Phaser.Scale.ScaleManager#canvasBounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.16.0
         */ this.canvasBounds = new Rectangle();
                        /**
         * The parent object of the Canvas. Often a div, or the browser window, or nothing in non-browser environments.
         *
         * This is set in the Game Config as the `parent` property. If undefined (or just not present), it will default
         * to use the document body. If specifically set to `null` Phaser will ignore all parent operations.
         *
         * @name Phaser.Scale.ScaleManager#parent
         * @type {?any}
         * @since 3.16.0
         */ this.parent = null;
                        /**
         * Is the parent element the browser window?
         *
         * @name Phaser.Scale.ScaleManager#parentIsWindow
         * @type {boolean}
         * @since 3.16.0
         */ this.parentIsWindow = false;
                        /**
         * The Parent Size component.
         *
         * @name Phaser.Scale.ScaleManager#parentSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.parentSize = new Size();
                        /**
         * The Game Size component.
         *
         * The un-modified game size, as requested in the game config (the raw width / height),
         * as used for world bounds, cameras, etc
         *
         * @name Phaser.Scale.ScaleManager#gameSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.gameSize = new Size();
                        /**
         * The Base Size component.
         *
         * The modified game size, which is the auto-rounded gameSize, used to set the canvas width and height
         * (but not the CSS style)
         *
         * @name Phaser.Scale.ScaleManager#baseSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.baseSize = new Size();
                        /**
         * The Display Size component.
         *
         * The size used for the canvas style, factoring in the scale mode, parent and other values.
         *
         * @name Phaser.Scale.ScaleManager#displaySize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.displaySize = new Size();
                        /**
         * The game scale mode.
         *
         * @name Phaser.Scale.ScaleManager#scaleMode
         * @type {Phaser.Scale.ScaleModeType}
         * @since 3.16.0
         */ this.scaleMode = CONST.SCALE_MODE.NONE;
                        /**
         * The game zoom factor.
         *
         * This value allows you to multiply your games base size by the given zoom factor.
         * This is then used when calculating the display size, even in `NONE` situations.
         * If you don't want Phaser to touch the canvas style at all, this value should be 1.
         *
         * Can also be set to `MAX_ZOOM` in which case the zoom value will be derived based
         * on the game size and available space within the parent.
         *
         * @name Phaser.Scale.ScaleManager#zoom
         * @type {number}
         * @since 3.16.0
         */ this.zoom = 1;
                        /**
         * Internal flag set when the game zoom factor is modified.
         *
         * @name Phaser.Scale.ScaleManager#_resetZoom
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this._resetZoom = false;
                        /**
         * The scale factor between the baseSize and the canvasBounds.
         *
         * @name Phaser.Scale.ScaleManager#displayScale
         * @type {Phaser.Math.Vector2}
         * @since 3.16.0
         */ this.displayScale = new Vector2(1, 1);
                        /**
         * If set, the canvas sizes will be automatically passed through Math.floor.
         * This results in rounded pixel display values, which is important for performance on legacy
         * and low powered devices, but at the cost of not achieving a 'perfect' fit in some browser windows.
         *
         * @name Phaser.Scale.ScaleManager#autoRound
         * @type {boolean}
         * @since 3.16.0
         */ this.autoRound = false;
                        /**
         * Automatically center the canvas within the parent? The different centering modes are:
         *
         * 1. No centering.
         * 2. Center both horizontally and vertically.
         * 3. Center horizontally.
         * 4. Center vertically.
         *
         * Please be aware that in order to center the game canvas, you must have specified a parent
         * that has a size set, or the canvas parent is the document.body.
         *
         * @name Phaser.Scale.ScaleManager#autoCenter
         * @type {Phaser.Scale.CenterType}
         * @since 3.16.0
         */ this.autoCenter = CONST.CENTER.NO_CENTER;
                        /**
         * The current device orientation.
         *
         * Orientation events are dispatched via the Device Orientation API, typically only on mobile browsers.
         *
         * @name Phaser.Scale.ScaleManager#orientation
         * @type {Phaser.Scale.OrientationType}
         * @since 3.16.0
         */ this.orientation = CONST.ORIENTATION.LANDSCAPE;
                        /**
         * A reference to the Device.Fullscreen object.
         *
         * @name Phaser.Scale.ScaleManager#fullscreen
         * @type {Phaser.Device.Fullscreen}
         * @since 3.16.0
         */ this.fullscreen;
                        /**
         * The DOM Element which is sent into fullscreen mode.
         *
         * @name Phaser.Scale.ScaleManager#fullscreenTarget
         * @type {?any}
         * @since 3.16.0
         */ this.fullscreenTarget = null;
                        /**
         * Did Phaser create the fullscreen target div, or was it provided in the game config?
         *
         * @name Phaser.Scale.ScaleManager#_createdFullscreenTarget
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._createdFullscreenTarget = false;
                        /**
         * The dirty state of the Scale Manager.
         * Set if there is a change between the parent size and the current size.
         *
         * @name Phaser.Scale.ScaleManager#dirty
         * @type {boolean}
         * @since 3.16.0
         */ this.dirty = false;
                        /**
         * How many milliseconds should elapse before checking if the browser size has changed?
         *
         * Most modern browsers dispatch a 'resize' event, which the Scale Manager will listen for.
         * However, older browsers fail to do this, or do it consistently, so we fall back to a
         * more traditional 'size check' based on a time interval. You can control how often it is
         * checked here.
         *
         * @name Phaser.Scale.ScaleManager#resizeInterval
         * @type {number}
         * @since 3.16.0
         */ this.resizeInterval = 500;
                        /**
         * Internal size interval tracker.
         *
         * @name Phaser.Scale.ScaleManager#_lastCheck
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._lastCheck = 0;
                        /**
         * Internal flag to check orientation state.
         *
         * @name Phaser.Scale.ScaleManager#_checkOrientation
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._checkOrientation = false;
                        /**
         * Internal object containing our defined event listeners.
         *
         * @name Phaser.Scale.ScaleManager#domlisteners
         * @type {object}
         * @private
         * @since 3.16.0
         */ this.domlisteners = {
                            orientationChange: NOOP,
                            windowResize: NOOP,
                            fullScreenChange: NOOP,
                            fullScreenError: NOOP
                        };
                    },
                    /**
     * Called _before_ the canvas object is created and added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#preBoot
     * @protected
     * @listens Phaser.Core.Events#BOOT
     * @since 3.16.0
     */ preBoot: function() {
                        //  Parse the config to get the scaling values we need
                        this.parseConfig(this.game.config);
                        this.game.events.once(GameEvents.BOOT, this.boot, this);
                    },
                    /**
     * The Boot handler is called by Phaser.Game when it first starts up.
     * The renderer is available by now and the canvas has been added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#boot
     * @protected
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     */ boot: function() {
                        var game = this.game;
                        this.canvas = game.canvas;
                        this.fullscreen = game.device.fullscreen;
                        var scaleMode = this.scaleMode;
                        if (scaleMode !== CONST.SCALE_MODE.RESIZE && scaleMode !== CONST.SCALE_MODE.EXPAND) this.displaySize.setAspectMode(scaleMode);
                        if (scaleMode === CONST.SCALE_MODE.NONE) this.resize(this.width, this.height);
                        else {
                            this.getParentBounds();
                            //  Only set the parent bounds if the parent has an actual size
                            if (this.parentSize.width > 0 && this.parentSize.height > 0) this.displaySize.setParent(this.parentSize);
                            this.refresh();
                        }
                        game.events.on(GameEvents.PRE_STEP, this.step, this);
                        game.events.once(GameEvents.READY, this.refresh, this);
                        game.events.once(GameEvents.DESTROY, this.destroy, this);
                        this.startListeners();
                    },
                    /**
     * Parses the game configuration to set-up the scale defaults.
     *
     * @method Phaser.Scale.ScaleManager#parseConfig
     * @protected
     * @since 3.16.0
     *
     * @param {Phaser.Types.Core.GameConfig} config - The Game configuration object.
     */ parseConfig: function(config) {
                        //  Get the parent element, if any
                        this.getParent(config);
                        //  Get the size of the parent element
                        //  This can often set a height of zero (especially for un-styled divs)
                        this.getParentBounds();
                        var width = config.width;
                        var height = config.height;
                        var scaleMode = config.scaleMode;
                        var zoom = config.zoom;
                        var autoRound = config.autoRound;
                        //  If width = '100%', or similar value
                        if (typeof width === 'string') {
                            //  Does width have a % character at the end? If not, we use it as a numeric value.
                            if (width.substr(-1) !== '%') width = parseInt(width, 10);
                            else {
                                //  If we have a parent with a width, we'll work it out from that
                                var parentWidth = this.parentSize.width;
                                if (parentWidth === 0) parentWidth = window.innerWidth;
                                var parentScaleX = parseInt(width, 10) / 100;
                                width = Math.floor(parentWidth * parentScaleX);
                            }
                        }
                        //  If height = '100%', or similar value
                        if (typeof height === 'string') {
                            //  Does height have a % character at the end? If not, we use it as a numeric value.
                            if (height.substr(-1) !== '%') height = parseInt(height, 10);
                            else {
                                //  If we have a parent with a height, we'll work it out from that
                                var parentHeight = this.parentSize.height;
                                if (parentHeight === 0) parentHeight = window.innerHeight;
                                var parentScaleY = parseInt(height, 10) / 100;
                                height = Math.floor(parentHeight * parentScaleY);
                            }
                        }
                        this.scaleMode = scaleMode;
                        this.autoRound = autoRound;
                        this.autoCenter = config.autoCenter;
                        this.resizeInterval = config.resizeInterval;
                        if (autoRound) {
                            width = Math.floor(width);
                            height = Math.floor(height);
                        }
                        //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                        this.gameSize.setSize(width, height);
                        if (zoom === CONST.ZOOM.MAX_ZOOM) zoom = this.getMaxZoom();
                        this.zoom = zoom;
                        if (zoom !== 1) this._resetZoom = true;
                        //  The modified game size
                        this.baseSize.setSize(width, height);
                        if (autoRound) {
                            this.baseSize.width = Math.floor(this.baseSize.width);
                            this.baseSize.height = Math.floor(this.baseSize.height);
                        }
                        if (config.minWidth > 0) this.displaySize.setMin(config.minWidth * zoom, config.minHeight * zoom);
                        if (config.maxWidth > 0) this.displaySize.setMax(config.maxWidth * zoom, config.maxHeight * zoom);
                        //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                        //  We just use the w/h here as this is what sets the aspect ratio (which doesn't then change)
                        this.displaySize.setSize(width, height);
                        if (config.snapWidth > 0 || config.snapHeight > 0) this.displaySize.setSnap(config.snapWidth, config.snapHeight);
                        this.orientation = GetScreenOrientation(width, height);
                    },
                    /**
     * Determines the parent element of the game canvas, if any, based on the game configuration.
     *
     * @method Phaser.Scale.ScaleManager#getParent
     * @since 3.16.0
     *
     * @param {Phaser.Types.Core.GameConfig} config - The Game configuration object.
     */ getParent: function(config) {
                        var parent = config.parent;
                        if (parent === null) //  User is responsible for managing the parent
                        return;
                        this.parent = GetTarget(parent);
                        this.parentIsWindow = this.parent === document.body;
                        if (config.expandParent && config.scaleMode !== CONST.SCALE_MODE.NONE) {
                            var DOMRect = this.parent.getBoundingClientRect();
                            if (this.parentIsWindow || DOMRect.height === 0) {
                                document.documentElement.style.height = '100%';
                                document.body.style.height = '100%';
                                DOMRect = this.parent.getBoundingClientRect();
                                //  The parent STILL has no height, clearly no CSS
                                //  has been set on it even though we fixed the body :(
                                if (!this.parentIsWindow && DOMRect.height === 0) {
                                    this.parent.style.overflow = 'hidden';
                                    this.parent.style.width = '100%';
                                    this.parent.style.height = '100%';
                                }
                            }
                        }
                        //  And now get the fullscreenTarget
                        if (config.fullscreenTarget && !this.fullscreenTarget) this.fullscreenTarget = GetTarget(config.fullscreenTarget);
                    },
                    /**
     * Calculates the size of the parent bounds and updates the `parentSize`
     * properties, only if the canvas has a dom parent.
     *
     * @method Phaser.Scale.ScaleManager#getParentBounds
     * @since 3.16.0
     *
     * @return {boolean} `true` if the parent bounds have changed size or position, otherwise `false`.
     */ getParentBounds: function() {
                        if (!this.parent) return false;
                        var parentSize = this.parentSize;
                        // Ref. http://msdn.microsoft.com/en-us/library/hh781509(v=vs.85).aspx for getBoundingClientRect
                        // The returned value is a DOMRect object which is the smallest rectangle which contains the entire element,
                        // including its padding and border-width. The left, top, right, bottom, x, y, width, and height properties
                        // describe the position and size of the overall rectangle in pixels. Properties other than width and height
                        // are relative to the top-left of the viewport.
                        var DOMRect = this.parent.getBoundingClientRect();
                        if (this.parentIsWindow && this.game.device.os.iOS) DOMRect.height = GetInnerHeight(true);
                        var newWidth = DOMRect.width;
                        var newHeight = DOMRect.height;
                        if (parentSize.width !== newWidth || parentSize.height !== newHeight) {
                            parentSize.setSize(newWidth, newHeight);
                            return true;
                        } else if (this.canvas) {
                            var canvasBounds = this.canvasBounds;
                            var canvasRect = this.canvas.getBoundingClientRect();
                            if (canvasRect.x !== canvasBounds.x || canvasRect.y !== canvasBounds.y) return true;
                        }
                        return false;
                    },
                    /**
     * Attempts to lock the orientation of the web browser using the Screen Orientation API.
     *
     * This API is only available on modern mobile browsers.
     * See https://developer.mozilla.org/en-US/docs/Web/API/Screen/lockOrientation for details.
     *
     * @method Phaser.Scale.ScaleManager#lockOrientation
     * @since 3.16.0
     *
     * @param {string} orientation - The orientation you'd like to lock the browser in. Should be an API string such as 'landscape', 'landscape-primary', 'portrait', etc.
     *
     * @return {boolean} `true` if the orientation was successfully locked, otherwise `false`.
     */ lockOrientation: function(orientation) {
                        var lock = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation;
                        if (lock) return lock.call(screen, orientation);
                        return false;
                    },
                    /**
     * This method will set the size of the Parent Size component, which is used in scaling
     * and centering calculations. You only need to call this method if you have explicitly
     * disabled the use of a parent in your game config, but still wish to take advantage of
     * other Scale Manager features.
     *
     * @method Phaser.Scale.ScaleManager#setParentSize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the parent.
     * @param {number} height - The new height of the parent.
     *
     * @return {this} The Scale Manager instance.
     */ setParentSize: function(width, height) {
                        this.parentSize.setSize(width, height);
                        return this.refresh();
                    },
                    /**
     * This method will set a new size for your game.
     *
     * It should only be used if you're looking to change the base size of your game and are using
     * one of the Scale Manager scaling modes, i.e. `FIT`. If you're using `NONE` and wish to
     * change the game and canvas size directly, then please use the `resize` method instead.
     *
     * @method Phaser.Scale.ScaleManager#setGameSize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the game.
     * @param {number} height - The new height of the game.
     *
     * @return {this} The Scale Manager instance.
     */ setGameSize: function(width, height) {
                        var autoRound = this.autoRound;
                        if (autoRound) {
                            width = Math.floor(width);
                            height = Math.floor(height);
                        }
                        var previousWidth = this.width;
                        var previousHeight = this.height;
                        //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                        this.gameSize.resize(width, height);
                        //  The modified game size
                        this.baseSize.resize(width, height);
                        if (autoRound) {
                            this.baseSize.width = Math.floor(this.baseSize.width);
                            this.baseSize.height = Math.floor(this.baseSize.height);
                        }
                        //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                        //  Update the aspect ratio
                        this.displaySize.setAspectRatio(width / height);
                        this.canvas.width = this.baseSize.width;
                        this.canvas.height = this.baseSize.height;
                        return this.refresh(previousWidth, previousHeight);
                    },
                    /**
     * Call this to modify the size of the Phaser canvas element directly.
     * You should only use this if you are using the `NONE` scale mode,
     * it will update all internal components completely.
     *
     * If all you want to do is change the size of the parent, see the `setParentSize` method.
     *
     * If all you want is to change the base size of the game, but still have the Scale Manager
     * manage all the scaling (i.e. you're **not** using `NONE`), then see the `setGameSize` method.
     *
     * This method will set the `gameSize`, `baseSize` and `displaySize` components to the given
     * dimensions. It will then resize the canvas width and height to the values given, by
     * directly setting the properties. Finally, if you have set the Scale Manager zoom value
     * to anything other than 1 (the default), it will set the canvas CSS width and height to
     * be the given size multiplied by the zoom factor (the canvas pixel size remains untouched).
     *
     * If you have enabled `autoCenter`, it is then passed to the `updateCenter` method and
     * the margins are set, allowing the canvas to be centered based on its parent element
     * alone. Finally, the `displayScale` is adjusted and the RESIZE event dispatched.
     *
     * @method Phaser.Scale.ScaleManager#resize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the game.
     * @param {number} height - The new height of the game.
     *
     * @return {this} The Scale Manager instance.
     */ resize: function(width, height) {
                        var zoom = this.zoom;
                        var autoRound = this.autoRound;
                        if (autoRound) {
                            width = Math.floor(width);
                            height = Math.floor(height);
                        }
                        var previousWidth = this.width;
                        var previousHeight = this.height;
                        //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                        this.gameSize.resize(width, height);
                        //  The modified game size
                        this.baseSize.resize(width, height);
                        if (autoRound) {
                            this.baseSize.width = Math.floor(this.baseSize.width);
                            this.baseSize.height = Math.floor(this.baseSize.height);
                        }
                        //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                        //  We just use the w/h here as this is what sets the aspect ratio (which doesn't then change)
                        this.displaySize.setSize(width * zoom, height * zoom);
                        this.canvas.width = this.baseSize.width;
                        this.canvas.height = this.baseSize.height;
                        var style = this.canvas.style;
                        var styleWidth = width * zoom;
                        var styleHeight = height * zoom;
                        if (autoRound) {
                            styleWidth = Math.floor(styleWidth);
                            styleHeight = Math.floor(styleHeight);
                        }
                        if (styleWidth !== width || styleHeight !== height) {
                            style.width = styleWidth + 'px';
                            style.height = styleHeight + 'px';
                        }
                        return this.refresh(previousWidth, previousHeight);
                    },
                    /**
     * Sets the zoom value of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#setZoom
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} value - The new zoom value of the game.
     *
     * @return {this} The Scale Manager instance.
     */ setZoom: function(value) {
                        this.zoom = value;
                        this._resetZoom = true;
                        return this.refresh();
                    },
                    /**
     * Sets the zoom to be the maximum possible based on the _current_ parent size.
     *
     * @method Phaser.Scale.ScaleManager#setMaxZoom
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @return {this} The Scale Manager instance.
     */ setMaxZoom: function() {
                        this.zoom = this.getMaxZoom();
                        this._resetZoom = true;
                        return this.refresh();
                    },
                    /**
     * By setting a Snap value, when the browser size is modified, its dimensions will automatically
     * be snapped to the nearest grid slice, using floor. For example, if you have snap value of 16,
     * and the width changes to 68, then it will snap down to 64 (the closest multiple of 16 when floored)
     *
     * This mode is best used with the `FIT` scale mode.
     *
     * Call this method with no arguments to reset the snap values.
     *
     * Calling this method automatically invokes `ScaleManager.refresh` which emits a `RESIZE` event.
     *
     * @method Phaser.Scale.ScaleManager#setSnap
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.80.0
     *
     * @param {number} [snapWidth=0] - The amount to snap the width to. If you don't want to snap the width, pass a value of zero.
     * @param {number} [snapHeight=snapWidth] - The amount to snap the height to. If not provided it will use the `snapWidth` value. If you don't want to snap the height, pass a value of zero.
     *
     * @return {this} The Scale Manager instance.
     */ setSnap: function(snapWidth, snapHeight) {
                        if (snapWidth === undefined) snapWidth = 0;
                        if (snapHeight === undefined) snapHeight = snapWidth;
                        this.displaySize.setSnap(snapWidth, snapHeight);
                        return this.refresh();
                    },
                    /**
     * Refreshes the internal scale values, bounds sizes and orientation checks.
     *
     * Once finished, dispatches the resize event.
     *
     * This is called automatically by the Scale Manager when the browser window size changes,
     * as long as it is using a Scale Mode other than 'NONE'.
     *
     * @method Phaser.Scale.ScaleManager#refresh
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} [previousWidth] - The previous width of the game. Only set if the gameSize has changed.
     * @param {number} [previousHeight] - The previous height of the game. Only set if the gameSize has changed.
     *
     * @return {this} The Scale Manager instance.
     */ refresh: function(previousWidth, previousHeight) {
                        if (previousWidth === undefined) previousWidth = this.width;
                        if (previousHeight === undefined) previousHeight = this.height;
                        this.updateScale();
                        this.updateBounds();
                        this.updateOrientation();
                        this.displayScale.set(this.baseSize.width / this.canvasBounds.width, this.baseSize.height / this.canvasBounds.height);
                        var domContainer = this.game.domContainer;
                        if (domContainer) {
                            this.baseSize.setCSS(domContainer);
                            var canvasStyle = this.canvas.style;
                            var domStyle = domContainer.style;
                            domStyle.transform = 'scale(' + this.displaySize.width / this.baseSize.width + ',' + this.displaySize.height / this.baseSize.height + ')';
                            domStyle.marginLeft = canvasStyle.marginLeft;
                            domStyle.marginTop = canvasStyle.marginTop;
                        }
                        this.emit(Events.RESIZE, this.gameSize, this.baseSize, this.displaySize, previousWidth, previousHeight);
                        return this;
                    },
                    /**
     * Internal method that checks the current screen orientation, only if the internal check flag is set.
     *
     * If the orientation has changed it updates the orientation property and then dispatches the orientation change event.
     *
     * @method Phaser.Scale.ScaleManager#updateOrientation
     * @fires Phaser.Scale.Events#ORIENTATION_CHANGE
     * @since 3.16.0
     */ updateOrientation: function() {
                        if (this._checkOrientation) {
                            this._checkOrientation = false;
                            var newOrientation = GetScreenOrientation(this.width, this.height);
                            if (newOrientation !== this.orientation) {
                                this.orientation = newOrientation;
                                this.emit(Events.ORIENTATION_CHANGE, newOrientation);
                            }
                        }
                    },
                    /**
     * Internal method that manages updating the size components based on the scale mode.
     *
     * @method Phaser.Scale.ScaleManager#updateScale
     * @since 3.16.0
     */ updateScale: function() {
                        var style = this.canvas.style;
                        var width = this.gameSize.width;
                        var height = this.gameSize.height;
                        var styleWidth;
                        var styleHeight;
                        var zoom = this.zoom;
                        var autoRound = this.autoRound;
                        if (this.scaleMode === CONST.SCALE_MODE.NONE) {
                            //  No scale
                            this.displaySize.setSize(width * zoom, height * zoom);
                            styleWidth = this.displaySize.width;
                            styleHeight = this.displaySize.height;
                            if (autoRound) {
                                styleWidth = Math.floor(styleWidth);
                                styleHeight = Math.floor(styleHeight);
                            }
                            if (this._resetZoom) {
                                style.width = styleWidth + 'px';
                                style.height = styleHeight + 'px';
                                this._resetZoom = false;
                            }
                        } else if (this.scaleMode === CONST.SCALE_MODE.RESIZE) {
                            //  Resize to match parent
                            //  This will constrain using min/max
                            this.displaySize.setSize(this.parentSize.width, this.parentSize.height);
                            this.gameSize.setSize(this.displaySize.width, this.displaySize.height);
                            this.baseSize.setSize(this.displaySize.width, this.displaySize.height);
                            styleWidth = this.displaySize.width;
                            styleHeight = this.displaySize.height;
                            if (autoRound) {
                                styleWidth = Math.floor(styleWidth);
                                styleHeight = Math.floor(styleHeight);
                            }
                            this.canvas.width = styleWidth;
                            this.canvas.height = styleHeight;
                        } else if (this.scaleMode === CONST.SCALE_MODE.EXPAND) {
                            var baseWidth = this.game.config.width;
                            var baseHeight = this.game.config.height;
                            //  Resize to match parent, like RESIZE mode
                            //  This will constrain using min/max
                            this.displaySize.setSize(this.parentSize.width, this.parentSize.height);
                            styleWidth = this.displaySize.width;
                            styleHeight = this.displaySize.height;
                            if (autoRound) {
                                styleWidth = Math.floor(styleWidth);
                                styleHeight = Math.floor(styleHeight);
                            }
                            style.width = styleWidth + 'px';
                            style.height = styleHeight + 'px';
                            // Expand canvas size to fit game size's width or height
                            var scaleX = this.parentSize.width / baseWidth;
                            var scaleY = this.parentSize.height / baseHeight;
                            if (scaleX < scaleY && scaleX !== 0) this.baseSize.setSize(baseWidth, this.parentSize.height / scaleX);
                            else if (scaleY !== 0) this.baseSize.setSize(this.displaySize.width / scaleY, baseHeight);
                            this.gameSize.setSize(this.baseSize.width, this.baseSize.height);
                            styleWidth = this.baseSize.width;
                            styleHeight = this.baseSize.height;
                            if (autoRound) {
                                styleWidth = Math.floor(styleWidth);
                                styleHeight = Math.floor(styleHeight);
                            }
                            this.canvas.width = styleWidth;
                            this.canvas.height = styleHeight;
                        } else {
                            //  All other scale modes
                            this.displaySize.setSize(this.parentSize.width, this.parentSize.height);
                            styleWidth = this.displaySize.width;
                            styleHeight = this.displaySize.height;
                            if (autoRound) {
                                styleWidth = Math.floor(styleWidth);
                                styleHeight = Math.floor(styleHeight);
                            }
                            style.width = styleWidth + 'px';
                            style.height = styleHeight + 'px';
                        }
                        //  Update the parentSize in case the canvas / style change modified it
                        this.getParentBounds();
                        //  Finally, update the centering
                        this.updateCenter();
                    },
                    /**
     * Calculates and returns the largest possible zoom factor, based on the current
     * parent and game sizes. If the parent has no dimensions (i.e. an unstyled div),
     * or is smaller than the un-zoomed game, then this will return a value of 1 (no zoom)
     *
     * @method Phaser.Scale.ScaleManager#getMaxZoom
     * @since 3.16.0
     *
     * @return {number} The maximum possible zoom factor. At a minimum this value is always at least 1.
     */ getMaxZoom: function() {
                        var zoomH = SnapFloor(this.parentSize.width, this.gameSize.width, 0, true);
                        var zoomV = SnapFloor(this.parentSize.height, this.gameSize.height, 0, true);
                        return Math.max(Math.min(zoomH, zoomV), 1);
                    },
                    /**
     * Calculates and updates the canvas CSS style in order to center it within the
     * bounds of its parent. If you have explicitly set parent to be `null` in your
     * game config then this method will likely give incorrect results unless you have called the
     * `setParentSize` method first.
     *
     * It works by modifying the canvas CSS `marginLeft` and `marginTop` properties.
     *
     * If they have already been set by your own style sheet, or code, this will overwrite them.
     *
     * To prevent the Scale Manager from centering the canvas, either do not set the
     * `autoCenter` property in your game config, or make sure it is set to `NO_CENTER`.
     *
     * @method Phaser.Scale.ScaleManager#updateCenter
     * @since 3.16.0
     */ updateCenter: function() {
                        var autoCenter = this.autoCenter;
                        if (autoCenter === CONST.CENTER.NO_CENTER) return;
                        var canvas = this.canvas;
                        var style = canvas.style;
                        var bounds = canvas.getBoundingClientRect();
                        var width = bounds.width;
                        var height = bounds.height;
                        var offsetX = Math.floor((this.parentSize.width - width) / 2);
                        var offsetY = Math.floor((this.parentSize.height - height) / 2);
                        if (autoCenter === CONST.CENTER.CENTER_HORIZONTALLY) offsetY = 0;
                        else if (autoCenter === CONST.CENTER.CENTER_VERTICALLY) offsetX = 0;
                        style.marginLeft = offsetX + 'px';
                        style.marginTop = offsetY + 'px';
                    },
                    /**
     * Updates the `canvasBounds` rectangle to match the bounding client rectangle of the
     * canvas element being used to track input events.
     *
     * @method Phaser.Scale.ScaleManager#updateBounds
     * @since 3.16.0
     */ updateBounds: function() {
                        var bounds = this.canvasBounds;
                        var clientRect = this.canvas.getBoundingClientRect();
                        bounds.x = clientRect.left + (window.pageXOffset || 0) - (document.documentElement.clientLeft || 0);
                        bounds.y = clientRect.top + (window.pageYOffset || 0) - (document.documentElement.clientTop || 0);
                        bounds.width = clientRect.width;
                        bounds.height = clientRect.height;
                    },
                    /**
     * Transforms the pageX value into the scaled coordinate space of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#transformX
     * @since 3.16.0
     *
     * @param {number} pageX - The DOM pageX value.
     *
     * @return {number} The translated value.
     */ transformX: function(pageX) {
                        return (pageX - this.canvasBounds.left) * this.displayScale.x;
                    },
                    /**
     * Transforms the pageY value into the scaled coordinate space of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#transformY
     * @since 3.16.0
     *
     * @param {number} pageY - The DOM pageY value.
     *
     * @return {number} The translated value.
     */ transformY: function(pageY) {
                        return (pageY - this.canvasBounds.top) * this.displayScale.y;
                    },
                    /**
     * Sends a request to the browser to ask it to go in to full screen mode, using the {@link https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API Fullscreen API}.
     *
     * If the browser does not support this, a `FULLSCREEN_UNSUPPORTED` event will be emitted.
     *
     * This method _must_ be called from a `pointerup` user-input gesture (**not** `pointerdown`). You cannot launch
     * games fullscreen without this, as most browsers block it. Games within an iframe will also be blocked
     * from fullscreen unless the iframe has the `allowfullscreen` attribute.
     *
     * On touch devices, such as Android and iOS Safari, you should always use `pointerup` and NOT `pointerdown`,
     * otherwise the request will fail unless the document in which your game is embedded has already received
     * some form of touch input, which you cannot guarantee. Activating fullscreen via `pointerup` circumvents
     * this issue.
     *
     * Performing an action that navigates to another page, or opens another tab, will automatically cancel
     * fullscreen mode, as will the user pressing the ESC key. To cancel fullscreen mode directly from your game,
     * i.e. by clicking an icon, call the `stopFullscreen` method.
     *
     * A browser can only send one DOM element into fullscreen. You can control which element this is by
     * setting the `fullscreenTarget` property in your game config, or changing the property in the Scale Manager.
     * Note that the game canvas _must_ be a child of the target. If you do not give a target, Phaser will
     * automatically create a blank `<div>` element and move the canvas into it, before going fullscreen.
     * When it leaves fullscreen, the div will be removed.
     *
     * @method Phaser.Scale.ScaleManager#startFullscreen
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_FAILED
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {object} [fullscreenOptions] - The FullscreenOptions dictionary is used to provide configuration options when entering full screen.
     */ startFullscreen: function(fullscreenOptions) {
                        if (fullscreenOptions === undefined) fullscreenOptions = {
                            navigationUI: 'hide'
                        };
                        var fullscreen = this.fullscreen;
                        if (!fullscreen.available) {
                            this.emit(Events.FULLSCREEN_UNSUPPORTED);
                            return;
                        }
                        if (!fullscreen.active) {
                            var fsTarget = this.getFullscreenTarget();
                            if (fullscreen.keyboard) fsTarget[fullscreen.request](Element.ALLOW_KEYBOARD_INPUT);
                            else fsTarget[fullscreen.request](fullscreenOptions);
                        }
                    },
                    /**
     * The browser has successfully entered fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#fullscreenSuccessHandler
     * @private
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.17.0
     */ fullscreenSuccessHandler: function() {
                        this.getParentBounds();
                        this.refresh();
                        this.emit(Events.ENTER_FULLSCREEN);
                    },
                    /**
     * The browser failed to enter fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#fullscreenErrorHandler
     * @private
     * @fires Phaser.Scale.Events#FULLSCREEN_FAILED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.17.0
     *
     * @param {any} error - The DOM error event.
     */ fullscreenErrorHandler: function(error) {
                        this.removeFullscreenTarget();
                        this.emit(Events.FULLSCREEN_FAILED, error);
                    },
                    /**
     * An internal method that gets the target element that is used when entering fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#getFullscreenTarget
     * @since 3.16.0
     *
     * @return {object} The fullscreen target element.
     */ getFullscreenTarget: function() {
                        if (!this.fullscreenTarget) {
                            var fsTarget = document.createElement('div');
                            fsTarget.style.margin = '0';
                            fsTarget.style.padding = '0';
                            fsTarget.style.width = '100%';
                            fsTarget.style.height = '100%';
                            this.fullscreenTarget = fsTarget;
                            this._createdFullscreenTarget = true;
                        }
                        if (this._createdFullscreenTarget) {
                            var canvasParent = this.canvas.parentNode;
                            canvasParent.insertBefore(this.fullscreenTarget, this.canvas);
                            this.fullscreenTarget.appendChild(this.canvas);
                        }
                        return this.fullscreenTarget;
                    },
                    /**
     * Removes the fullscreen target that was added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#removeFullscreenTarget
     * @since 3.17.0
     */ removeFullscreenTarget: function() {
                        if (this._createdFullscreenTarget) {
                            var fsTarget = this.fullscreenTarget;
                            if (fsTarget && fsTarget.parentNode) {
                                var parent = fsTarget.parentNode;
                                parent.insertBefore(this.canvas, fsTarget);
                                parent.removeChild(fsTarget);
                            }
                        }
                    },
                    /**
     * Calling this method will cancel fullscreen mode, if the browser has entered it.
     *
     * @method Phaser.Scale.ScaleManager#stopFullscreen
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @since 3.16.0
     */ stopFullscreen: function() {
                        var fullscreen = this.fullscreen;
                        if (!fullscreen.available) {
                            this.emit(Events.FULLSCREEN_UNSUPPORTED);
                            return false;
                        }
                        if (fullscreen.active) document[fullscreen.cancel]();
                        this.removeFullscreenTarget();
                    },
                    /**
     * The browser has successfully left fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#leaveFullScreenSuccessHandler
     * @fires Phaser.Scale.Events#LEAVE_FULLSCREEN
     * @since 3.85.0
     */ leaveFullScreenSuccessHandler: function() {
                        //  Get the parent size again as it will have changed
                        this.getParentBounds();
                        this.emit(Events.LEAVE_FULLSCREEN);
                        this.refresh();
                    },
                    /**
     * Toggles the fullscreen mode. If already in fullscreen, calling this will cancel it.
     * If not in fullscreen, this will request the browser to enter fullscreen mode.
     *
     * If the browser does not support this, a `FULLSCREEN_UNSUPPORTED` event will be emitted.
     *
     * This method _must_ be called from a user-input gesture, such as `pointerdown`. You cannot launch
     * games fullscreen without this, as most browsers block it. Games within an iframe will also be blocked
     * from fullscreen unless the iframe has the `allowfullscreen` attribute.
     *
     * @method Phaser.Scale.ScaleManager#toggleFullscreen
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#LEAVE_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {object} [fullscreenOptions] - The FullscreenOptions dictionary is used to provide configuration options when entering full screen.
     */ toggleFullscreen: function(fullscreenOptions) {
                        if (this.fullscreen.active) this.stopFullscreen();
                        else this.startFullscreen(fullscreenOptions);
                    },
                    /**
     * An internal method that starts the different DOM event listeners running.
     *
     * @method Phaser.Scale.ScaleManager#startListeners
     * @since 3.16.0
     */ startListeners: function() {
                        var _this = this;
                        var listeners = this.domlisteners;
                        listeners.orientationChange = function() {
                            _this.updateBounds();
                            _this._checkOrientation = true;
                            _this.dirty = true;
                            _this.refresh();
                        };
                        listeners.windowResize = function() {
                            _this.updateBounds();
                            _this.dirty = true;
                        };
                        //  Only dispatched on mobile devices
                        if (screen.orientation && screen.orientation.addEventListener) screen.orientation.addEventListener('change', listeners.orientationChange, false);
                        else window.addEventListener('orientationchange', listeners.orientationChange, false);
                        window.addEventListener('resize', listeners.windowResize, false);
                        if (this.fullscreen.available) {
                            listeners.fullScreenChange = function(event) {
                                return _this.onFullScreenChange(event);
                            };
                            listeners.fullScreenError = function(event) {
                                return _this.onFullScreenError(event);
                            };
                            var vendors = [
                                'webkit',
                                'moz',
                                ''
                            ];
                            vendors.forEach(function(prefix) {
                                document.addEventListener(prefix + 'fullscreenchange', listeners.fullScreenChange, false);
                                document.addEventListener(prefix + 'fullscreenerror', listeners.fullScreenError, false);
                            });
                            //  MS Specific
                            document.addEventListener('MSFullscreenChange', listeners.fullScreenChange, false);
                            document.addEventListener('MSFullscreenError', listeners.fullScreenError, false);
                        }
                    },
                    /**
     * Triggered when a fullscreenchange event is dispatched by the DOM.
     *
     * @method Phaser.Scale.ScaleManager#onFullScreenChange
     * @protected
     * @since 3.16.0
     */ onFullScreenChange: function() {
                        if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.mozFullScreenElement) this.fullscreenSuccessHandler();
                        else {
                            //  They pressed ESC while in fullscreen mode
                            this.stopFullscreen();
                            this.leaveFullScreenSuccessHandler();
                        }
                    },
                    /**
     * Triggered when a fullscreenerror event is dispatched by the DOM.
     *
     * @method Phaser.Scale.ScaleManager#onFullScreenError
     * @since 3.16.0
     */ onFullScreenError: function() {
                        this.removeFullscreenTarget();
                    },
                    /**
     * Get Rectange of visible area.
     *
     * @method Phaser.Scale.ScaleManager#getViewPort
     * @since 3.60.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The camera this viewport is respond upon.
     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle of visible area.
     *
     * @return {Phaser.Geom.Rectangle} The Rectangle of visible area.
     */ getViewPort: function(camera, out) {
                        if (!(camera instanceof Camera)) {
                            out = camera;
                            camera = undefined;
                        }
                        if (out === undefined) out = new Rectangle();
                        var baseSize = this.baseSize;
                        var parentSize = this.parentSize;
                        var canvasBounds = this.canvasBounds;
                        var displayScale = this.displayScale;
                        var x = canvasBounds.x >= 0 ? 0 : -(canvasBounds.x * displayScale.x);
                        var y = canvasBounds.y >= 0 ? 0 : -(canvasBounds.y * displayScale.y);
                        var width;
                        if (parentSize.width >= canvasBounds.width) width = baseSize.width;
                        else width = baseSize.width - (canvasBounds.width - parentSize.width) * displayScale.x;
                        var height;
                        if (parentSize.height >= canvasBounds.height) height = baseSize.height;
                        else height = baseSize.height - (canvasBounds.height - parentSize.height) * displayScale.y;
                        out.setTo(x, y, width, height);
                        if (camera) {
                            out.width /= camera.zoomX;
                            out.height /= camera.zoomY;
                            out.centerX = camera.centerX + camera.scrollX;
                            out.centerY = camera.centerY + camera.scrollY;
                        }
                        return out;
                    },
                    /**
     * Internal method, called automatically by the game step.
     * Monitors the elapsed time and resize interval to see if a parent bounds check needs to take place.
     *
     * @method Phaser.Scale.ScaleManager#step
     * @since 3.16.0
     *
     * @param {number} time - The time value from the most recent Game step. Typically a high-resolution timer value, or Date.now().
     * @param {number} delta - The delta value since the last frame. This is smoothed to avoid delta spikes by the TimeStep class.
     */ step: function(time, delta) {
                        if (!this.parent) return;
                        this._lastCheck += delta;
                        if (this.dirty || this._lastCheck > this.resizeInterval) {
                            //  Returns true if the parent bounds have changed size
                            if (this.getParentBounds()) this.refresh();
                            this.dirty = false;
                            this._lastCheck = 0;
                        }
                    },
                    /**
     * Stops all DOM event listeners.
     *
     * @method Phaser.Scale.ScaleManager#stopListeners
     * @since 3.16.0
     */ stopListeners: function() {
                        var listeners = this.domlisteners;
                        if (screen.orientation && screen.orientation.addEventListener) screen.orientation.removeEventListener('change', listeners.orientationChange, false);
                        else window.removeEventListener('orientationchange', listeners.orientationChange, false);
                        window.removeEventListener('resize', listeners.windowResize, false);
                        var vendors = [
                            'webkit',
                            'moz',
                            ''
                        ];
                        vendors.forEach(function(prefix) {
                            document.removeEventListener(prefix + 'fullscreenchange', listeners.fullScreenChange, false);
                            document.removeEventListener(prefix + 'fullscreenerror', listeners.fullScreenError, false);
                        });
                        //  MS Specific
                        document.removeEventListener('MSFullscreenChange', listeners.fullScreenChange, false);
                        document.removeEventListener('MSFullscreenError', listeners.fullScreenError, false);
                    },
                    /**
     * Destroys this Scale Manager, releasing all references to external resources.
     * Once destroyed, the Scale Manager cannot be used again.
     *
     * @method Phaser.Scale.ScaleManager#destroy
     * @since 3.16.0
     */ destroy: function() {
                        this.removeAllListeners();
                        this.stopListeners();
                        this.game = null;
                        this.canvas = null;
                        this.canvasBounds = null;
                        this.parent = null;
                        this.fullscreenTarget = null;
                        this.parentSize.destroy();
                        this.gameSize.destroy();
                        this.baseSize.destroy();
                        this.displaySize.destroy();
                    },
                    /**
     * Is the browser currently in fullscreen mode or not?
     *
     * @name Phaser.Scale.ScaleManager#isFullscreen
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isFullscreen: {
                        get: function() {
                            return this.fullscreen.active;
                        }
                    },
                    /**
     * The game width.
     *
     * This is typically the size given in the game configuration.
     *
     * @name Phaser.Scale.ScaleManager#width
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ width: {
                        get: function() {
                            return this.gameSize.width;
                        }
                    },
                    /**
     * The game height.
     *
     * This is typically the size given in the game configuration.
     *
     * @name Phaser.Scale.ScaleManager#height
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ height: {
                        get: function() {
                            return this.gameSize.height;
                        }
                    },
                    /**
     * Is the device in a portrait orientation as reported by the Orientation API?
     * This value is usually only available on mobile devices.
     *
     * @name Phaser.Scale.ScaleManager#isPortrait
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isPortrait: {
                        get: function() {
                            return this.orientation === CONST.ORIENTATION.PORTRAIT;
                        }
                    },
                    /**
     * Is the device in a landscape orientation as reported by the Orientation API?
     * This value is usually only available on mobile devices.
     *
     * @name Phaser.Scale.ScaleManager#isLandscape
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isLandscape: {
                        get: function() {
                            return this.orientation === CONST.ORIENTATION.LANDSCAPE;
                        }
                    },
                    /**
     * Are the game dimensions portrait? (i.e. taller than they are wide)
     *
     * This is different to the device itself being in a portrait orientation.
     *
     * @name Phaser.Scale.ScaleManager#isGamePortrait
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isGamePortrait: {
                        get: function() {
                            return this.height > this.width;
                        }
                    },
                    /**
     * Are the game dimensions landscape? (i.e. wider than they are tall)
     *
     * This is different to the device itself being in a landscape orientation.
     *
     * @name Phaser.Scale.ScaleManager#isGameLandscape
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isGameLandscape: {
                        get: function() {
                            return this.width > this.height;
                        }
                    }
                });
                module1.exports = ScaleManager;
            /***/ },
            /***/ 64743: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for centering the game canvas.
 *
 * @namespace Phaser.Scale.Center
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for centering the game canvas.
 *
 * To find out what each mode does please see [Phaser.Scale.Center]{@link Phaser.Scale.Center}.
 *
 * @typedef {Phaser.Scale.Center} Phaser.Scale.CenterType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                    /**
     * The game canvas is not centered within the parent by Phaser.
     * You can still center it yourself via CSS.
     *
     * @name Phaser.Scale.Center.NO_CENTER
     * @type {number}
     * @const
     * @since 3.16.0
     */ NO_CENTER: 0,
                    /**
     * The game canvas is centered both horizontally and vertically within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     *
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     *
     * @name Phaser.Scale.Center.CENTER_BOTH
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_BOTH: 1,
                    /**
     * The game canvas is centered horizontally within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     *
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     *
     * @name Phaser.Scale.Center.CENTER_HORIZONTALLY
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_HORIZONTALLY: 2,
                    /**
     * The game canvas is centered both vertically within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     *
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     *
     * @name Phaser.Scale.Center.CENTER_VERTICALLY
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_VERTICALLY: 3
                };
            /***/ },
            /***/ 39218: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for orientation.
 *
 * @namespace Phaser.Scale.Orientation
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for orientation.
 *
 * To find out what each mode does please see [Phaser.Scale.Orientation]{@link Phaser.Scale.Orientation}.
 *
 * @typedef {Phaser.Scale.Orientation} Phaser.Scale.OrientationType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                    /**
     * The primary landscape orientation.
     *
     * @name Phaser.Scale.Orientation.LANDSCAPE
     * @type {string}
     * @const
     * @since 3.16.0
     */ LANDSCAPE: 'landscape-primary',
                    /**
     * The secondary landscape orientation.
     *
     * @name Phaser.Scale.Orientation.LANDSCAPE_SECONDARY
     * @type {string}
     * @const
     * @since 3.85.0
     */ LANDSCAPE_SECONDARY: 'landscape-secondary',
                    /**
     * The primary portrait orientation.
     *
     * @name Phaser.Scale.Orientation.PORTRAIT
     * @type {string}
     * @const
     * @since 3.16.0
     */ PORTRAIT: 'portrait-primary',
                    /**
     * The secondary portrait orientation.
     *
     * @name Phaser.Scale.Orientation.PORTRAIT_SECONDARY
     * @type {string}
     * @const
     * @since 3.16.0
     */ PORTRAIT_SECONDARY: 'portrait-secondary'
                };
            /***/ },
            /***/ 81050: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for the different scale modes available.
 *
 * @namespace Phaser.Scale.ScaleModes
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for the different scale modes available.
 *
 * To find out what each mode does please see [Phaser.Scale.ScaleModes]{@link Phaser.Scale.ScaleModes}.
 *
 * @typedef {Phaser.Scale.ScaleModes} Phaser.Scale.ScaleModeType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                    /**
     * No scaling happens at all. The canvas is set to the size given in the game config and Phaser doesn't change it
     * again from that point on. If you change the canvas size, either via CSS, or directly via code, then you need
     * to call the Scale Managers `resize` method to give the new dimensions, or input events will stop working.
     *
     * @name Phaser.Scale.ScaleModes.NONE
     * @type {number}
     * @const
     * @since 3.16.0
     */ NONE: 0,
                    /**
     * The height is automatically adjusted based on the width.
     *
     * @name Phaser.Scale.ScaleModes.WIDTH_CONTROLS_HEIGHT
     * @type {number}
     * @const
     * @since 3.16.0
     */ WIDTH_CONTROLS_HEIGHT: 1,
                    /**
     * The width is automatically adjusted based on the height.
     *
     * @name Phaser.Scale.ScaleModes.HEIGHT_CONTROLS_WIDTH
     * @type {number}
     * @const
     * @since 3.16.0
     */ HEIGHT_CONTROLS_WIDTH: 2,
                    /**
     * The width and height are automatically adjusted to fit inside the given target area,
     * while keeping the aspect ratio. Depending on the aspect ratio there may be some space
     * inside the area which is not covered.
     *
     * @name Phaser.Scale.ScaleModes.FIT
     * @type {number}
     * @const
     * @since 3.16.0
     */ FIT: 3,
                    /**
     * The width and height are automatically adjusted to make the size cover the entire target
     * area while keeping the aspect ratio. This may extend further out than the target size.
     *
     * @name Phaser.Scale.ScaleModes.ENVELOP
     * @type {number}
     * @const
     * @since 3.16.0
     */ ENVELOP: 4,
                    /**
     * The Canvas is resized to fit all available _parent_ space, regardless of aspect ratio.
     *
     * @name Phaser.Scale.ScaleModes.RESIZE
     * @type {number}
     * @const
     * @since 3.16.0
     */ RESIZE: 5,
                    /**
     * The Canvas's visible area is resized to fit all available _parent_ space like RESIZE mode,
     * and scale canvas size to fit inside the visible area like FIT mode.
     *
     * @name Phaser.Scale.ScaleModes.EXPAND
     * @type {number}
     * @const
     * @since 3.80.0
     */ EXPAND: 6
                };
            /***/ },
            /***/ 80805: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for zoom modes.
 *
 * @namespace Phaser.Scale.Zoom
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for zoom modes.
 *
 * To find out what each mode does please see [Phaser.Scale.Zoom]{@link Phaser.Scale.Zoom}.
 *
 * @typedef {Phaser.Scale.Zoom} Phaser.Scale.ZoomType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                    /**
     * The game canvas will not be zoomed by Phaser.
     *
     * @name Phaser.Scale.Zoom.NO_ZOOM
     * @type {number}
     * @const
     * @since 3.16.0
     */ NO_ZOOM: 1,
                    /**
     * The game canvas will be 2x zoomed by Phaser.
     *
     * @name Phaser.Scale.Zoom.ZOOM_2X
     * @type {number}
     * @const
     * @since 3.16.0
     */ ZOOM_2X: 2,
                    /**
     * The game canvas will be 4x zoomed by Phaser.
     *
     * @name Phaser.Scale.Zoom.ZOOM_4X
     * @type {number}
     * @const
     * @since 3.16.0
     */ ZOOM_4X: 4,
                    /**
     * Calculate the zoom value based on the maximum multiplied game size that will
     * fit into the parent, or browser window if no parent is set.
     *
     * @name Phaser.Scale.Zoom.MAX_ZOOM
     * @type {number}
     * @const
     * @since 3.16.0
     */ MAX_ZOOM: -1
                };
            /***/ },
            /***/ 13560: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = {
                    CENTER: __webpack_require__(64743),
                    ORIENTATION: __webpack_require__(39218),
                    SCALE_MODE: __webpack_require__(81050),
                    ZOOM: __webpack_require__(80805)
                };
                module1.exports = CONST;
            /***/ },
            /***/ 56139: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager has successfully entered fullscreen mode.
 *
 * @event Phaser.Scale.Events#ENTER_FULLSCREEN
 * @type {string}
 * @since 3.16.1
 */ module1.exports = 'enterfullscreen';
            /***/ },
            /***/ 2336: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager tried to enter fullscreen mode but failed.
 *
 * @event Phaser.Scale.Events#FULLSCREEN_FAILED
 * @type {string}
 * @since 3.17.0
 */ module1.exports = 'fullscreenfailed';
            /***/ },
            /***/ 47412: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager tried to enter fullscreen mode, but it is unsupported by the browser.
 *
 * @event Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
 * @type {string}
 * @since 3.16.1
 */ module1.exports = 'fullscreenunsupported';
            /***/ },
            /***/ 51452: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager was in fullscreen mode, but has since left, either directly via game code,
 * or via a user gestured, such as pressing the ESC key.
 *
 * @event Phaser.Scale.Events#LEAVE_FULLSCREEN
 * @type {string}
 * @since 3.16.1
 */ module1.exports = 'leavefullscreen';
            /***/ },
            /***/ 20666: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager Orientation Change Event.
 *
 * This event is dispatched whenever the Scale Manager detects an orientation change event from the browser.
 *
 * @event Phaser.Scale.Events#ORIENTATION_CHANGE
 * @type {string}
 * @since 3.16.1
 *
 * @param {string} orientation - The new orientation value. Either `Phaser.Scale.Orientation.LANDSCAPE` or `Phaser.Scale.Orientation.PORTRAIT`.
 */ module1.exports = 'orientationchange';
            /***/ },
            /***/ 47945: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager Resize Event.
 *
 * This event is dispatched whenever the Scale Manager detects a resize event from the browser.
 * It sends three parameters to the callback, each of them being Size components. You can read
 * the `width`, `height`, `aspectRatio` and other properties of these components to help with
 * scaling your own game content.
 *
 * @event Phaser.Scale.Events#RESIZE
 * @type {string}
 * @since 3.16.1
 *
 * @param {Phaser.Structs.Size} gameSize - A reference to the Game Size component. This is the un-scaled size of your game canvas.
 * @param {Phaser.Structs.Size} baseSize - A reference to the Base Size component. This is the game size.
 * @param {Phaser.Structs.Size} displaySize - A reference to the Display Size component. This is the scaled canvas size, after applying zoom and scale mode.
 * @param {number} previousWidth - If the `gameSize` has changed, this value contains its previous width, otherwise it contains the current width.
 * @param {number} previousHeight - If the `gameSize` has changed, this value contains its previous height, otherwise it contains the current height.
 */ module1.exports = 'resize';
            /***/ },
            /***/ 97480: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Scale.Events
 */ module1.exports = {
                    ENTER_FULLSCREEN: __webpack_require__(56139),
                    FULLSCREEN_FAILED: __webpack_require__(2336),
                    FULLSCREEN_UNSUPPORTED: __webpack_require__(47412),
                    LEAVE_FULLSCREEN: __webpack_require__(51452),
                    ORIENTATION_CHANGE: __webpack_require__(20666),
                    RESIZE: __webpack_require__(47945)
                };
            /***/ },
            /***/ 93364: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(79291);
                var CONST = __webpack_require__(13560);
                /**
 * @namespace Phaser.Scale
 *
 * @borrows Phaser.Scale.Center.NO_CENTER as NO_CENTER
 * @borrows Phaser.Scale.Center.CENTER_BOTH as CENTER_BOTH
 * @borrows Phaser.Scale.Center.CENTER_HORIZONTALLY as CENTER_HORIZONTALLY
 * @borrows Phaser.Scale.Center.CENTER_VERTICALLY as CENTER_VERTICALLY
 *
 * @borrows Phaser.Scale.Orientation.LANDSCAPE as LANDSCAPE
 * @borrows Phaser.Scale.Orientation.PORTRAIT as PORTRAIT
 *
 * @borrows Phaser.Scale.ScaleModes.NONE as NONE
 * @borrows Phaser.Scale.ScaleModes.WIDTH_CONTROLS_HEIGHT as WIDTH_CONTROLS_HEIGHT
 * @borrows Phaser.Scale.ScaleModes.HEIGHT_CONTROLS_WIDTH as HEIGHT_CONTROLS_WIDTH
 * @borrows Phaser.Scale.ScaleModes.FIT as FIT
 * @borrows Phaser.Scale.ScaleModes.ENVELOP as ENVELOP
 * @borrows Phaser.Scale.ScaleModes.RESIZE as RESIZE
 * @borrows Phaser.Scale.ScaleModes.EXPAND as EXPAND 
 *
 * @borrows Phaser.Scale.Zoom.NO_ZOOM as NO_ZOOM
 * @borrows Phaser.Scale.Zoom.ZOOM_2X as ZOOM_2X
 * @borrows Phaser.Scale.Zoom.ZOOM_4X as ZOOM_4X
 * @borrows Phaser.Scale.Zoom.MAX_ZOOM as MAX_ZOOM
 */ var Scale = {
                    Center: __webpack_require__(64743),
                    Events: __webpack_require__(97480),
                    Orientation: __webpack_require__(39218),
                    ScaleManager: __webpack_require__(76531),
                    ScaleModes: __webpack_require__(81050),
                    Zoom: __webpack_require__(80805)
                };
                Scale = Extend(false, Scale, CONST.CENTER);
                Scale = Extend(false, Scale, CONST.ORIENTATION);
                Scale = Extend(false, Scale, CONST.SCALE_MODE);
                Scale = Extend(false, Scale, CONST.ZOOM);
                module1.exports = Scale;
            /***/ },
            /***/ 27397: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                var UppercaseFirst = __webpack_require__(35355);
                /**
 * Builds an array of which physics plugins should be activated for the given Scene.
 *
 * @function Phaser.Scenes.GetPhysicsPlugins
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - The scene system to get the physics systems of.
 *
 * @return {array} An array of Physics systems to start for this Scene.
 */ var GetPhysicsPlugins = function(sys) {
                    var defaultSystem = sys.game.config.defaultPhysicsSystem;
                    var sceneSystems = GetFastValue(sys.settings, 'physics', false);
                    if (!defaultSystem && !sceneSystems) //  No default physics system or systems in this scene
                    return;
                    //  Let's build the systems array
                    var output = [];
                    if (defaultSystem) output.push(UppercaseFirst(defaultSystem + 'Physics'));
                    if (sceneSystems) for(var key in sceneSystems){
                        key = UppercaseFirst(key.concat('Physics'));
                        if (output.indexOf(key) === -1) output.push(key);
                    }
                    //  An array of Physics systems to start for this Scene
                    return output;
                };
                module1.exports = GetPhysicsPlugins;
            /***/ },
            /***/ 52106: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                /**
 * Builds an array of which plugins (not including physics plugins) should be activated for the given Scene.
 *
 * @function Phaser.Scenes.GetScenePlugins
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - The Scene Systems object to check for plugins.
 *
 * @return {array} An array of all plugins which should be activated, either the default ones or the ones configured in the Scene Systems object.
 */ var GetScenePlugins = function(sys) {
                    var defaultPlugins = sys.plugins.getDefaultScenePlugins();
                    var scenePlugins = GetFastValue(sys.settings, 'plugins', false);
                    //  Scene Plugins always override Default Plugins
                    if (Array.isArray(scenePlugins)) return scenePlugins;
                    else if (defaultPlugins) return defaultPlugins;
                    else //  No default plugins or plugins in this scene
                    return [];
                };
                module1.exports = GetScenePlugins;
            /***/ },
            /***/ 87033: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  These properties get injected into the Scene and map to local systems
                //  The map value is the property that is injected into the Scene, the key is the Scene.Systems reference.
                //  These defaults can be modified via the Scene config object
                //          var config = {
                //            map: {
                //                add: 'makeStuff',
                //                load: 'loader'
                //            }
                //        };
                var InjectionMap = {
                    game: 'game',
                    renderer: 'renderer',
                    anims: 'anims',
                    cache: 'cache',
                    plugins: 'plugins',
                    registry: 'registry',
                    scale: 'scale',
                    sound: 'sound',
                    textures: 'textures',
                    events: 'events',
                    cameras: 'cameras',
                    add: 'add',
                    make: 'make',
                    scenePlugin: 'scene',
                    displayList: 'children',
                    lights: 'lights',
                    data: 'data',
                    input: 'input',
                    load: 'load',
                    time: 'time',
                    tweens: 'tweens',
                    arcadePhysics: 'physics',
                    impactPhysics: 'impact',
                    matterPhysics: 'matter'
                };
                module1.exports = InjectionMap;
            /***/ },
            /***/ 97482: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Systems = __webpack_require__(2368);
                /**
 * @classdesc
 * A base Phaser.Scene class which can be extended for your own use.
 *
 * You can also define the optional methods {@link Phaser.Types.Scenes.SceneInitCallback init()}, {@link Phaser.Types.Scenes.ScenePreloadCallback preload()}, and {@link Phaser.Types.Scenes.SceneCreateCallback create()}.
 *
 * @class Scene
 * @memberof Phaser
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Scenes.SettingsConfig)} [config] - The scene key or scene specific configuration settings.
 */ var Scene = new Class({
                    initialize: function Scene(config) {
                        /**
         * The Scene Systems. You must never overwrite this property, or all hell will break loose.
         *
         * @name Phaser.Scene#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = new Systems(this, config);
                        /**
         * A reference to the Phaser.Game instance.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game;
                        /**
         * A reference to the global Animation Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims;
                        /**
         * A reference to the global Cache.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache;
                        /**
         * A reference to the global Data Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry;
                        /**
         * A reference to the Sound Manager.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound;
                        /**
         * A reference to the Texture Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures;
                        /**
         * A Scene specific Event Emitter.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events;
                        /**
         * The Scene Camera Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                        /**
         * The Scene Game Object Factory.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#add
         * @type {Phaser.GameObjects.GameObjectFactory}
         * @since 3.0.0
         */ this.add;
                        /**
         * The Scene Game Object Creator.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#make
         * @type {Phaser.GameObjects.GameObjectCreator}
         * @since 3.0.0
         */ this.make;
                        /**
         * A reference to the Scene Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#scene
         * @type {Phaser.Scenes.ScenePlugin}
         * @since 3.0.0
         */ this.scene;
                        /**
         * The Game Object Display List belonging to this Scene.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#children
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.children;
                        /**
         * The Scene Lights Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#lights
         * @type {Phaser.GameObjects.LightsManager}
         * @since 3.0.0
         */ this.lights;
                        /**
         * A Scene specific Data Manager Plugin.
         *
         * See the `registry` property for the global Data Manager.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#data
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.data;
                        /**
         * The Scene Input Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#input
         * @type {Phaser.Input.InputPlugin}
         * @since 3.0.0
         */ this.input;
                        /**
         * The Scene Loader Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#load
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.0.0
         */ this.load;
                        /**
         * The Scene Time and Clock Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#time
         * @type {Phaser.Time.Clock}
         * @since 3.0.0
         */ this.time;
                        /**
         * The Scene Tween Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#tweens
         * @type {Phaser.Tweens.TweenManager}
         * @since 3.0.0
         */ this.tweens;
                        /**
         * The Scene Arcade Physics Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
         *
         * @name Phaser.Scene#physics
         * @type {Phaser.Physics.Arcade.ArcadePhysics}
         * @since 3.0.0
         */ this.physics;
                        /**
         * The Scene Matter Physics Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
         *
         * @name Phaser.Scene#matter
         * @type {Phaser.Physics.Matter.MatterPhysics}
         * @since 3.0.0
         */ this.matter;
                        /**
         * A reference to the global Scale Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.2
         */ this.scale;
                        /**
         * A reference to the global Plugin Manager.
         *
         * The Plugin Manager is a global system that allows plugins to register themselves with it, and can then install
         * those plugins into Scenes as required.
         *
         * @name Phaser.Scene#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins;
                        /**
         * A reference to the renderer instance Phaser is using, either Canvas Renderer or WebGL Renderer.
         *
         * @name Phaser.Scene#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.50.0
         */ this.renderer;
                    },
                    /**
     * This method should be overridden by your own Scenes.
     *
     * This method is called once per game step while the scene is running.
     *
     * @method Phaser.Scene#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function() {}
                });
                module1.exports = Scene;
            /***/ },
            /***/ 60903: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(89993);
                var Events = __webpack_require__(44594);
                var GameEvents = __webpack_require__(8443);
                var GetValue = __webpack_require__(35154);
                var LoaderEvents = __webpack_require__(54899);
                var NOOP = __webpack_require__(29747);
                var Scene = __webpack_require__(97482);
                var Systems = __webpack_require__(2368);
                /**
 * @classdesc
 * The Scene Manager.
 *
 * The Scene Manager is a Game level system, responsible for creating, processing and updating all of the
 * Scenes in a Game instance.
 *
 * You should not usually interact directly with the Scene Manager at all. Instead, you should use
 * the Scene Plugin, which is available from every Scene in your game via the `this.scene` property.
 *
 * Using methods in this Scene Manager directly will break queued operations and can cause runtime
 * errors. Instead, go via the Scene Plugin. Every feature this Scene Manager provides is also
 * available via the Scene Plugin.
 *
 * @class SceneManager
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance this Scene Manager belongs to.
 * @param {object} sceneConfig - Scene specific configuration settings.
 */ var SceneManager = new Class({
                    initialize: function SceneManager(game, sceneConfig) {
                        /**
         * The Game that this SceneManager belongs to.
         *
         * @name Phaser.Scenes.SceneManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                        /**
         * An object that maps the keys to the scene so we can quickly get a scene from a key without iteration.
         *
         * @name Phaser.Scenes.SceneManager#keys
         * @type {Record<string, Phaser.Scene>}
         * @since 3.0.0
         */ this.keys = {};
                        /**
         * The array in which all of the scenes are kept.
         *
         * @name Phaser.Scenes.SceneManager#scenes
         * @type {Phaser.Scene[]}
         * @since 3.0.0
         */ this.scenes = [];
                        /**
         * Scenes pending to be added are stored in here until the manager has time to add it.
         *
         * @name Phaser.Scenes.SceneManager#_pending
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._pending = [];
                        /**
         * An array of scenes waiting to be started once the game has booted.
         *
         * @name Phaser.Scenes.SceneManager#_start
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._start = [];
                        /**
         * An operations queue, because we don't manipulate the scenes array during processing.
         *
         * @name Phaser.Scenes.SceneManager#_queue
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._queue = [];
                        /**
         * Boot time data to merge.
         *
         * @name Phaser.Scenes.SceneManager#_data
         * @type {object}
         * @private
         * @since 3.4.0
         */ this._data = {};
                        /**
         * Is the Scene Manager actively processing the Scenes list?
         *
         * @name Phaser.Scenes.SceneManager#isProcessing
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isProcessing = false;
                        /**
         * Has the Scene Manager properly started?
         *
         * @name Phaser.Scenes.SceneManager#isBooted
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.4.0
         */ this.isBooted = false;
                        /**
         * Do any of the Cameras in any of the Scenes require a custom viewport?
         * If not we can skip scissor tests.
         *
         * @name Phaser.Scenes.SceneManager#customViewports
         * @type {number}
         * @default 0
         * @since 3.12.0
         */ this.customViewports = 0;
                        /**
         * This system Scene is created during `bootQueue` and is a default
         * empty Scene that lives outside of the Scene list, but can be used
         * by plugins and managers that need access to a live Scene, without
         * being tied to one.
         *
         * @name Phaser.Scenes.SceneManager#systemScene
         * @type {Phaser.Scene}
         * @since 3.60.0
         */ this.systemScene;
                        if (sceneConfig) {
                            if (!Array.isArray(sceneConfig)) sceneConfig = [
                                sceneConfig
                            ];
                            for(var i = 0; i < sceneConfig.length; i++)//  The i === 0 part just autostarts the first Scene given (unless it says otherwise in its config)
                            this._pending.push({
                                key: 'default',
                                scene: sceneConfig[i],
                                autoStart: i === 0,
                                data: {}
                            });
                        }
                        game.events.once(GameEvents.READY, this.bootQueue, this);
                    },
                    /**
     * Internal first-time Scene boot handler.
     *
     * @method Phaser.Scenes.SceneManager#bootQueue
     * @private
     * @fires Phaser.Core.Events#SYSTEM_READY
     * @since 3.2.0
     */ bootQueue: function() {
                        if (this.isBooted) return;
                        //  Create the system Scene
                        this.systemScene = this.createSceneFromInstance('__SYSTEM', new Scene());
                        this.game.events.emit(GameEvents.SYSTEM_READY, this.systemScene, this);
                        var i;
                        var entry;
                        var key;
                        var sceneConfig;
                        for(i = 0; i < this._pending.length; i++){
                            entry = this._pending[i];
                            key = entry.key;
                            sceneConfig = entry.scene;
                            var newScene;
                            if (sceneConfig instanceof Scene) newScene = this.createSceneFromInstance(key, sceneConfig);
                            else if (typeof sceneConfig === 'object') newScene = this.createSceneFromObject(key, sceneConfig);
                            else if (typeof sceneConfig === 'function') newScene = this.createSceneFromFunction(key, sceneConfig);
                            //  Replace key in case the scene changed it
                            key = newScene.sys.settings.key;
                            this.keys[key] = newScene;
                            this.scenes.push(newScene);
                            //  Any data to inject?
                            if (this._data[key]) {
                                newScene.sys.settings.data = this._data[key].data;
                                if (this._data[key].autoStart) entry.autoStart = true;
                            }
                            if (entry.autoStart || newScene.sys.settings.active) this._start.push(key);
                        }
                        //  Clear the pending lists
                        this._pending.length = 0;
                        this._data = {};
                        this.isBooted = true;
                        //  _start might have been populated by the above
                        for(i = 0; i < this._start.length; i++){
                            entry = this._start[i];
                            this.start(entry);
                        }
                        this._start.length = 0;
                    },
                    /**
     * Process the Scene operations queue.
     *
     * @method Phaser.Scenes.SceneManager#processQueue
     * @since 3.0.0
     */ processQueue: function() {
                        var pendingLength = this._pending.length;
                        var queueLength = this._queue.length;
                        if (pendingLength === 0 && queueLength === 0) return;
                        var i;
                        var entry;
                        if (pendingLength) {
                            for(i = 0; i < pendingLength; i++){
                                entry = this._pending[i];
                                this.add(entry.key, entry.scene, entry.autoStart, entry.data);
                            }
                            //  _start might have been populated by this.add
                            for(i = 0; i < this._start.length; i++){
                                entry = this._start[i];
                                this.start(entry);
                            }
                            //  Clear the pending lists
                            this._start.length = 0;
                            this._pending.length = 0;
                        }
                        for(i = 0; i < this._queue.length; i++){
                            entry = this._queue[i];
                            this[entry.op](entry.keyA, entry.keyB, entry.data);
                        }
                        this._queue.length = 0;
                    },
                    /**
     * Adds a new Scene into the SceneManager.
     * You must give each Scene a unique key by which you'll identify it.
     *
     * The `sceneConfig` can be:
     *
     * * A `Phaser.Scene` object, or an object that extends it.
     * * A plain JavaScript object
     * * A JavaScript ES6 Class that extends `Phaser.Scene`
     * * A JavaScript ES5 prototype based Class
     * * A JavaScript function
     *
     * If a function is given then a new Scene will be created by calling it.
     *
     * @method Phaser.Scenes.SceneManager#add
     * @since 3.0.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     * @param {(Phaser.Types.Scenes.SceneType)} sceneConfig - The config for the Scene
     * @param {boolean} [autoStart=false] - If `true` the Scene will be started immediately after being added.
     * @param {object} [data] - Optional data object. This will be set as `Scene.settings.data` and passed to `Scene.init`, and `Scene.create`.
     *
     * @return {?Phaser.Scene} The added Scene, if it was added immediately, otherwise `null`.
     */ add: function(key, sceneConfig, autoStart, data) {
                        if (autoStart === undefined) autoStart = false;
                        if (data === undefined) data = {};
                        //  If processing or not booted then put scene into a holding pattern
                        if (this.isProcessing || !this.isBooted) {
                            this._pending.push({
                                key: key,
                                scene: sceneConfig,
                                autoStart: autoStart,
                                data: data
                            });
                            if (!this.isBooted) this._data[key] = {
                                data: data
                            };
                            return null;
                        }
                        key = this.getKey(key, sceneConfig);
                        var newScene;
                        if (sceneConfig instanceof Scene) newScene = this.createSceneFromInstance(key, sceneConfig);
                        else if (typeof sceneConfig === 'object') {
                            sceneConfig.key = key;
                            newScene = this.createSceneFromObject(key, sceneConfig);
                        } else if (typeof sceneConfig === 'function') newScene = this.createSceneFromFunction(key, sceneConfig);
                        //  Any data to inject?
                        newScene.sys.settings.data = data;
                        //  Replace key in case the scene changed it
                        key = newScene.sys.settings.key;
                        this.keys[key] = newScene;
                        this.scenes.push(newScene);
                        if (autoStart || newScene.sys.settings.active) {
                            if (this._pending.length) this._start.push(key);
                            else this.start(key);
                        }
                        return newScene;
                    },
                    /**
     * Removes a Scene from the SceneManager.
     *
     * The Scene is removed from the local scenes array, it's key is cleared from the keys
     * cache and Scene.Systems.destroy is then called on it.
     *
     * If the SceneManager is processing the Scenes when this method is called it will
     * queue the operation for the next update sequence.
     *
     * @method Phaser.Scenes.SceneManager#remove
     * @since 3.2.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     *
     * @return {this} This Scene Manager instance.
     */ remove: function(key) {
                        if (this.isProcessing) return this.queueOp('remove', key);
                        var sceneToRemove = this.getScene(key);
                        if (!sceneToRemove || sceneToRemove.sys.isTransitioning()) return this;
                        var index = this.scenes.indexOf(sceneToRemove);
                        var sceneKey = sceneToRemove.sys.settings.key;
                        if (index > -1) {
                            delete this.keys[sceneKey];
                            this.scenes.splice(index, 1);
                            if (this._start.indexOf(sceneKey) > -1) {
                                index = this._start.indexOf(sceneKey);
                                this._start.splice(index, 1);
                            }
                            sceneToRemove.sys.destroy();
                        }
                        return this;
                    },
                    /**
     * Boot the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#bootScene
     * @private
     * @fires Phaser.Scenes.Events#TRANSITION_INIT
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to boot.
     */ bootScene: function(scene) {
                        var sys = scene.sys;
                        var settings = sys.settings;
                        sys.sceneUpdate = NOOP;
                        if (scene.init) {
                            scene.init.call(scene, settings.data);
                            settings.status = CONST.INIT;
                            if (settings.isTransition) sys.events.emit(Events.TRANSITION_INIT, settings.transitionFrom, settings.transitionDuration);
                        }
                        var loader;
                        if (sys.load) {
                            loader = sys.load;
                            loader.reset();
                        }
                        if (loader && scene.preload) {
                            scene.preload.call(scene);
                            settings.status = CONST.LOADING;
                            //  Start the loader going as we have something in the queue
                            loader.once(LoaderEvents.COMPLETE, this.loadComplete, this);
                            loader.start();
                        } else //  No preload? Then there was nothing to load either
                        this.create(scene);
                    },
                    /**
     * Handles load completion for a Scene's Loader.
     *
     * Starts the Scene that the Loader belongs to.
     *
     * @method Phaser.Scenes.SceneManager#loadComplete
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading.
     */ loadComplete: function(loader) {
                        this.create(loader.scene);
                    },
                    /**
     * Handle payload completion for a Scene.
     *
     * @method Phaser.Scenes.SceneManager#payloadComplete
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading its Scene's payload.
     */ payloadComplete: function(loader) {
                        this.bootScene(loader.scene);
                    },
                    /**
     * Updates the Scenes.
     *
     * @method Phaser.Scenes.SceneManager#update
     * @since 3.0.0
     *
     * @param {number} time - Time elapsed.
     * @param {number} delta - Delta time from the last update.
     */ update: function(time, delta) {
                        this.processQueue();
                        this.isProcessing = true;
                        //  Loop through the active scenes in reverse order
                        for(var i = this.scenes.length - 1; i >= 0; i--){
                            var sys = this.scenes[i].sys;
                            if (sys.settings.status > CONST.START && sys.settings.status <= CONST.RUNNING) sys.step(time, delta);
                            if (sys.scenePlugin && sys.scenePlugin._target) sys.scenePlugin.step(time, delta);
                        }
                    },
                    /**
     * Renders the Scenes.
     *
     * @method Phaser.Scenes.SceneManager#render
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer to use.
     */ render: function(renderer) {
                        //  Loop through the scenes in forward order
                        for(var i = 0; i < this.scenes.length; i++){
                            var sys = this.scenes[i].sys;
                            if (sys.settings.visible && sys.settings.status >= CONST.LOADING && sys.settings.status < CONST.SLEEPING) sys.render(renderer);
                        }
                        this.isProcessing = false;
                    },
                    /**
     * Calls the given Scene's {@link Phaser.Scene#create} method and updates its status.
     *
     * @method Phaser.Scenes.SceneManager#create
     * @private
     * @fires Phaser.Scenes.Events#CREATE
     * @fires Phaser.Scenes.Events#TRANSITION_INIT
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to create.
     */ create: function(scene) {
                        var sys = scene.sys;
                        var settings = sys.settings;
                        if (scene.create) {
                            settings.status = CONST.CREATING;
                            scene.create.call(scene, settings.data);
                            if (settings.status === CONST.DESTROYED) return;
                        }
                        if (settings.isTransition) sys.events.emit(Events.TRANSITION_START, settings.transitionFrom, settings.transitionDuration);
                        //  If the Scene has an update function we'll set it now, otherwise it'll remain as NOOP
                        if (scene.update) sys.sceneUpdate = scene.update;
                        settings.status = CONST.RUNNING;
                        sys.events.emit(Events.CREATE, scene);
                    },
                    /**
     * Creates and initializes a Scene from a function.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromFunction
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {function} scene - The function to create the Scene from.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromFunction: function(key, scene) {
                        var newScene = new scene();
                        if (newScene instanceof Scene) {
                            var configKey = newScene.sys.settings.key;
                            if (configKey !== '') key = configKey;
                            if (this.keys.hasOwnProperty(key)) throw new Error('Cannot add Scene with duplicate key: ' + key);
                            return this.createSceneFromInstance(key, newScene);
                        } else {
                            newScene.sys = new Systems(newScene);
                            newScene.sys.settings.key = key;
                            newScene.sys.init(this.game);
                            return newScene;
                        }
                    },
                    /**
     * Creates and initializes a Scene instance.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromInstance
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {Phaser.Scene} newScene - The Scene instance.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromInstance: function(key, newScene) {
                        var configKey = newScene.sys.settings.key;
                        if (configKey === '') newScene.sys.settings.key = key;
                        newScene.sys.init(this.game);
                        return newScene;
                    },
                    /**
     * Creates and initializes a Scene from an Object definition.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromObject
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {(string|Phaser.Types.Scenes.SettingsConfig|Phaser.Types.Scenes.CreateSceneFromObjectConfig)} sceneConfig - The Scene config.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromObject: function(key, sceneConfig) {
                        var newScene = new Scene(sceneConfig);
                        var configKey = newScene.sys.settings.key;
                        if (configKey !== '') key = configKey;
                        else newScene.sys.settings.key = key;
                        newScene.sys.init(this.game);
                        //  Extract callbacks
                        var defaults = [
                            'init',
                            'preload',
                            'create',
                            'update',
                            'render'
                        ];
                        for(var i = 0; i < defaults.length; i++){
                            var sceneCallback = GetValue(sceneConfig, defaults[i], null);
                            if (sceneCallback) newScene[defaults[i]] = sceneCallback;
                        }
                        //  Now let's move across any other functions or properties that may exist in the extend object:
                        /*
        scene: {
            preload: preload,
            create: create,
            extend: {
                hello: 1,
                test: 'atari',
                addImage: addImage
            }
        }
        */ if (sceneConfig.hasOwnProperty('extend')) for(var propertyKey in sceneConfig.extend){
                            if (!sceneConfig.extend.hasOwnProperty(propertyKey)) continue;
                            var value = sceneConfig.extend[propertyKey];
                            if (propertyKey === 'data' && newScene.hasOwnProperty('data') && typeof value === 'object') //  Populate the DataManager
                            newScene.data.merge(value);
                            else if (propertyKey !== 'sys') newScene[propertyKey] = value;
                        }
                        return newScene;
                    },
                    /**
     * Retrieves the key of a Scene from a Scene config.
     *
     * @method Phaser.Scenes.SceneManager#getKey
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key to check in the Scene config.
     * @param {(Phaser.Scene|Phaser.Types.Scenes.SettingsConfig|function)} sceneConfig - The Scene config.
     *
     * @return {string} The Scene key.
     */ getKey: function(key, sceneConfig) {
                        if (!key) key = 'default';
                        if (typeof sceneConfig === 'function') return key;
                        else if (sceneConfig instanceof Scene) key = sceneConfig.sys.settings.key;
                        else if (typeof sceneConfig === 'object' && sceneConfig.hasOwnProperty('key')) key = sceneConfig.key;
                        //  By this point it's either 'default' or extracted from the Scene
                        if (this.keys.hasOwnProperty(key)) throw new Error('Cannot add Scene with duplicate key: ' + key);
                        else return key;
                    },
                    /**
     * Returns an array of all the current Scenes being managed by this Scene Manager.
     *
     * You can filter the output by the active state of the Scene and choose to have
     * the array returned in normal or reversed order.
     *
     * @method Phaser.Scenes.SceneManager#getScenes
     * @since 3.16.0
     *
     * @generic {Phaser.Scene[]} T - [$return]
     * @genericUse {T} - [$return]
     *
     * @param {boolean} [isActive=true] - Only include Scene's that are currently active?
     * @param {boolean} [inReverse=false] - Return the array of Scenes in reverse?
     *
     * @return {Phaser.Scene[]} An array containing all of the Scenes in the Scene Manager.
     */ getScenes: function(isActive, inReverse) {
                        if (isActive === undefined) isActive = true;
                        if (inReverse === undefined) inReverse = false;
                        var out = [];
                        var scenes = this.scenes;
                        for(var i = 0; i < scenes.length; i++){
                            var scene = scenes[i];
                            if (scene && (!isActive || isActive && scene.sys.isActive())) out.push(scene);
                        }
                        return inReverse ? out.reverse() : out;
                    },
                    /**
     * Retrieves a Scene based on the given key.
     *
     * If an actual Scene is passed to this method, it can be used to check if
     * its currently within the Scene Manager, or not.
     *
     * @method Phaser.Scenes.SceneManager#getScene
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     * @genericUse {T} - [$return]
     *
     * @param {(string|Phaser.Scene)} key - The key of the Scene to retrieve.
     *
     * @return {?Phaser.Scene} The Scene, or `null` if no matching Scene was found.
     */ getScene: function(key) {
                        if (typeof key === 'string') {
                            if (this.keys[key]) return this.keys[key];
                        } else for(var i = 0; i < this.scenes.length; i++){
                            if (key === this.scenes[i]) return key;
                        }
                        return null;
                    },
                    /**
     * Determines whether a Scene is running.
     *
     * @method Phaser.Scenes.SceneManager#isActive
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is running, or `null` if no matching Scene was found.
     */ isActive: function(key) {
                        var scene = this.getScene(key);
                        if (scene) return scene.sys.isActive();
                        return null;
                    },
                    /**
     * Determines whether a Scene is paused.
     *
     * @method Phaser.Scenes.SceneManager#isPaused
     * @since 3.17.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is paused, or `null` if no matching Scene was found.
     */ isPaused: function(key) {
                        var scene = this.getScene(key);
                        if (scene) return scene.sys.isPaused();
                        return null;
                    },
                    /**
     * Determines whether a Scene is visible.
     *
     * @method Phaser.Scenes.SceneManager#isVisible
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is visible, or `null` if no matching Scene was found.
     */ isVisible: function(key) {
                        var scene = this.getScene(key);
                        if (scene) return scene.sys.isVisible();
                        return null;
                    },
                    /**
     * Determines whether a Scene is sleeping.
     *
     * @method Phaser.Scenes.SceneManager#isSleeping
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is sleeping, or `null` if no matching Scene was found.
     */ isSleeping: function(key) {
                        var scene = this.getScene(key);
                        if (scene) return scene.sys.isSleeping();
                        return null;
                    },
                    /**
     * Pauses the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#pause
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to pause.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its pause event.
     *
     * @return {this} This Scene Manager instance.
     */ pause: function(key, data) {
                        var scene = this.getScene(key);
                        if (scene) scene.sys.pause(data);
                        return this;
                    },
                    /**
     * Resumes the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#resume
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to resume.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its resume event.
     *
     * @return {this} This Scene Manager instance.
     */ resume: function(key, data) {
                        var scene = this.getScene(key);
                        if (scene) scene.sys.resume(data);
                        return this;
                    },
                    /**
     * Puts the given Scene to sleep.
     *
     * @method Phaser.Scenes.SceneManager#sleep
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to put to sleep.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its sleep event.
     *
     * @return {this} This Scene Manager instance.
     */ sleep: function(key, data) {
                        var scene = this.getScene(key);
                        if (scene && !scene.sys.isTransitioning()) scene.sys.sleep(data);
                        return this;
                    },
                    /**
     * Awakens the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#wake
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to wake up.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its wake event.
     *
     * @return {this} This Scene Manager instance.
     */ wake: function(key, data) {
                        var scene = this.getScene(key);
                        if (scene) scene.sys.wake(data);
                        return this;
                    },
                    /**
     * Runs the given Scene.
     *
     * If the given Scene is paused, it will resume it. If sleeping, it will wake it.
     * If not running at all, it will be started.
     *
     * Use this if you wish to open a modal Scene by calling `pause` on the current
     * Scene, then `run` on the modal Scene.
     *
     * @method Phaser.Scenes.SceneManager#run
     * @since 3.10.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to run.
     * @param {object} [data] - A data object that will be passed to the Scene on start, wake, or resume.
     *
     * @return {this} This Scene Manager instance.
     */ run: function(key, data) {
                        var scene = this.getScene(key);
                        if (!scene) {
                            for(var i = 0; i < this._pending.length; i++)if (this._pending[i].key === key) {
                                this.queueOp('start', key, data);
                                break;
                            }
                            return this;
                        }
                        if (scene.sys.isSleeping()) //  Sleeping?
                        scene.sys.wake(data);
                        else if (scene.sys.isPaused()) //  Paused?
                        scene.sys.resume(data);
                        else //  Not actually running?
                        this.start(key, data);
                    },
                    /**
     * Starts the given Scene, if it is not starting, loading, or creating.
     *
     * If the Scene is running, paused, or sleeping, it will be shutdown and then started.
     *
     * @method Phaser.Scenes.SceneManager#start
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to start.
     * @param {object} [data] - Optional data object to pass to `Scene.Settings` and `Scene.init`, and `Scene.create`.
     *
     * @return {this} This Scene Manager instance.
     */ start: function(key, data) {
                        //  If the Scene Manager is not running, then put the Scene into a holding pattern
                        if (!this.isBooted) {
                            this._data[key] = {
                                autoStart: true,
                                data: data
                            };
                            return this;
                        }
                        var scene = this.getScene(key);
                        if (!scene) {
                            console.warn('Scene key not found: ' + key);
                            return this;
                        }
                        var sys = scene.sys;
                        var status = sys.settings.status;
                        //  If the scene is already started but not yet running,
                        //  let it continue.
                        if (status >= CONST.START && status <= CONST.CREATING) return this;
                        else if (status >= CONST.RUNNING && status <= CONST.SLEEPING) {
                            sys.shutdown();
                            sys.sceneUpdate = NOOP;
                            sys.start(data);
                        } else {
                            sys.sceneUpdate = NOOP;
                            sys.start(data);
                            var loader;
                            if (sys.load) loader = sys.load;
                            //  Files payload?
                            if (loader && sys.settings.hasOwnProperty('pack')) {
                                loader.reset();
                                if (loader.addPack({
                                    payload: sys.settings.pack
                                })) {
                                    sys.settings.status = CONST.LOADING;
                                    loader.once(LoaderEvents.COMPLETE, this.payloadComplete, this);
                                    loader.start();
                                    return this;
                                }
                            }
                        }
                        this.bootScene(scene);
                        return this;
                    },
                    /**
     * Stops the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#stop
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to stop.
     * @param {object} [data] - Optional data object to pass to Scene.shutdown.
     *
     * @return {this} This Scene Manager instance.
     */ stop: function(key, data) {
                        var scene = this.getScene(key);
                        if (scene && !scene.sys.isTransitioning() && scene.sys.settings.status !== CONST.SHUTDOWN) {
                            var loader = scene.sys.load;
                            if (loader) {
                                loader.off(LoaderEvents.COMPLETE, this.loadComplete, this);
                                loader.off(LoaderEvents.COMPLETE, this.payloadComplete, this);
                            }
                            scene.sys.shutdown(data);
                        }
                        return this;
                    },
                    /**
     * Sleeps one one Scene and starts the other.
     *
     * @method Phaser.Scenes.SceneManager#switch
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [from,to]
     *
     * @param {(string|Phaser.Scene)} from - The Scene to sleep.
     * @param {(string|Phaser.Scene)} to - The Scene to start.
     * @param {object} [data] - Optional data object to pass to `Scene.Settings` and `Scene.init`, and `Scene.create`. It is only passed when the scene starts for the first time.
     *
     * @return {this} This Scene Manager instance.
     */ switch: function(from, to, data) {
                        var sceneA = this.getScene(from);
                        var sceneB = this.getScene(to);
                        if (sceneA && sceneB && sceneA !== sceneB) {
                            this.sleep(from);
                            if (this.isSleeping(to)) this.wake(to, data);
                            else this.start(to, data);
                        }
                        return this;
                    },
                    /**
     * Retrieves a Scene by numeric index.
     *
     * @method Phaser.Scenes.SceneManager#getAt
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The index of the Scene to retrieve.
     *
     * @return {(Phaser.Scene|undefined)} The Scene.
     */ getAt: function(index) {
                        return this.scenes[index];
                    },
                    /**
     * Retrieves the numeric index of a Scene.
     *
     * @method Phaser.Scenes.SceneManager#getIndex
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The key of the Scene.
     *
     * @return {number} The index of the Scene.
     */ getIndex: function(key) {
                        var scene = this.getScene(key);
                        return this.scenes.indexOf(scene);
                    },
                    /**
     * Brings a Scene to the top of the Scenes list.
     *
     * This means it will render above all other Scenes.
     *
     * @method Phaser.Scenes.SceneManager#bringToTop
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ bringToTop: function(key) {
                        if (this.isProcessing) return this.queueOp('bringToTop', key);
                        var index = this.getIndex(key);
                        var scenes = this.scenes;
                        if (index !== -1 && index < scenes.length) {
                            var scene = this.getScene(key);
                            scenes.splice(index, 1);
                            scenes.push(scene);
                        }
                        return this;
                    },
                    /**
     * Sends a Scene to the back of the Scenes list.
     *
     * This means it will render below all other Scenes.
     *
     * @method Phaser.Scenes.SceneManager#sendToBack
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ sendToBack: function(key) {
                        if (this.isProcessing) return this.queueOp('sendToBack', key);
                        var index = this.getIndex(key);
                        if (index !== -1 && index > 0) {
                            var scene = this.getScene(key);
                            this.scenes.splice(index, 1);
                            this.scenes.unshift(scene);
                        }
                        return this;
                    },
                    /**
     * Moves a Scene down one position in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#moveDown
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ moveDown: function(key) {
                        if (this.isProcessing) return this.queueOp('moveDown', key);
                        var indexA = this.getIndex(key);
                        if (indexA > 0) {
                            var indexB = indexA - 1;
                            var sceneA = this.getScene(key);
                            var sceneB = this.getAt(indexB);
                            this.scenes[indexA] = sceneB;
                            this.scenes[indexB] = sceneA;
                        }
                        return this;
                    },
                    /**
     * Moves a Scene up one position in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#moveUp
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ moveUp: function(key) {
                        if (this.isProcessing) return this.queueOp('moveUp', key);
                        var indexA = this.getIndex(key);
                        if (indexA < this.scenes.length - 1) {
                            var indexB = indexA + 1;
                            var sceneA = this.getScene(key);
                            var sceneB = this.getAt(indexB);
                            this.scenes[indexA] = sceneB;
                            this.scenes[indexB] = sceneA;
                        }
                        return this;
                    },
                    /**
     * Moves a Scene so it is immediately above another Scene in the Scenes list.
     * If the Scene is already above the other, it isn't moved.
     *
     * This means it will render over the top of the other Scene.
     *
     * @method Phaser.Scenes.SceneManager#moveAbove
     * @since 3.2.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [keyA,keyB]
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved above.
     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
     *
     * @return {this} This Scene Manager instance.
     */ moveAbove: function(keyA, keyB) {
                        if (keyA === keyB) return this;
                        if (this.isProcessing) return this.queueOp('moveAbove', keyA, keyB);
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== -1 && indexB !== -1 && indexB < indexA) {
                            var tempScene = this.getAt(indexB);
                            //  Remove
                            this.scenes.splice(indexB, 1);
                            //  Add in new location
                            this.scenes.splice(indexA + (indexB > indexA), 0, tempScene);
                        }
                        return this;
                    },
                    /**
     * Moves a Scene so it is immediately below another Scene in the Scenes list.
     * If the Scene is already below the other, it isn't moved.
     *
     * This means it will render behind the other Scene.
     *
     * @method Phaser.Scenes.SceneManager#moveBelow
     * @since 3.2.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [keyA,keyB]
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved below.
     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
     *
     * @return {this} This Scene Manager instance.
     */ moveBelow: function(keyA, keyB) {
                        if (keyA === keyB) return this;
                        if (this.isProcessing) return this.queueOp('moveBelow', keyA, keyB);
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== -1 && indexB !== -1 && indexB > indexA) {
                            var tempScene = this.getAt(indexB);
                            //  Remove
                            this.scenes.splice(indexB, 1);
                            if (indexA === 0) this.scenes.unshift(tempScene);
                            else //  Add in new location
                            this.scenes.splice(indexA - (indexB < indexA), 0, tempScene);
                        }
                        return this;
                    },
                    /**
     * Queue a Scene operation for the next update.
     *
     * @method Phaser.Scenes.SceneManager#queueOp
     * @private
     * @since 3.0.0
     *
     * @param {string} op - The operation to perform.
     * @param {(string|Phaser.Scene)} keyA - Scene A.
     * @param {(any|string|Phaser.Scene)} [keyB] - Scene B, or a data object.
     * @param {any} [data] - Optional data object to pass.
     *
     * @return {this} This Scene Manager instance.
     */ queueOp: function(op, keyA, keyB, data) {
                        this._queue.push({
                            op: op,
                            keyA: keyA,
                            keyB: keyB,
                            data: data
                        });
                        return this;
                    },
                    /**
     * Swaps the positions of two Scenes in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#swapPosition
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [keyA,keyB]
     *
     * @param {(string|Phaser.Scene)} keyA - The first Scene to swap.
     * @param {(string|Phaser.Scene)} keyB - The second Scene to swap.
     *
     * @return {this} This Scene Manager instance.
     */ swapPosition: function(keyA, keyB) {
                        if (keyA === keyB) return this;
                        if (this.isProcessing) return this.queueOp('swapPosition', keyA, keyB);
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== indexB && indexA !== -1 && indexB !== -1) {
                            var tempScene = this.getAt(indexA);
                            this.scenes[indexA] = this.scenes[indexB];
                            this.scenes[indexB] = tempScene;
                        }
                        return this;
                    },
                    /**
     * Dumps debug information about each Scene to the developer console.
     *
     * @method Phaser.Scenes.SceneManager#dump
     * @since 3.2.0
     */ dump: function() {
                        var out = [];
                        var map = [
                            'pending',
                            'init',
                            'start',
                            'loading',
                            'creating',
                            'running',
                            'paused',
                            'sleeping',
                            'shutdown',
                            'destroyed'
                        ];
                        for(var i = 0; i < this.scenes.length; i++){
                            var sys = this.scenes[i].sys;
                            var key = sys.settings.visible && (sys.settings.status === CONST.RUNNING || sys.settings.status === CONST.PAUSED) ? '[*] ' : '[-] ';
                            key += sys.settings.key + ' (' + map[sys.settings.status] + ')';
                            out.push(key);
                        }
                        console.log(out.join('\n'));
                    },
                    /**
     * Destroy this Scene Manager and all of its systems.
     *
     * This process cannot be reversed.
     *
     * This method is called automatically when a Phaser Game instance is destroyed.
     *
     * @method Phaser.Scenes.SceneManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        for(var i = 0; i < this.scenes.length; i++){
                            var sys = this.scenes[i].sys;
                            sys.destroy();
                        }
                        this.systemScene.sys.destroy();
                        this.update = NOOP;
                        this.scenes = [];
                        this._pending = [];
                        this._start = [];
                        this._queue = [];
                        this.game = null;
                        this.systemScene = null;
                    }
                });
                module1.exports = SceneManager;
            /***/ },
            /***/ 52209: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(44594);
                var GetFastValue = __webpack_require__(95540);
                var PluginCache = __webpack_require__(37277);
                /**
 * @classdesc
 * The Scene Plugin is the main interface to the Scene Manager and allows you to control
 * any Scene running in your game. You should always use this plugin. By default, it is
 * mapped to the Scene property `this.scene`. Meaning, from within a Scene, you can call
 * methods such as `this.scene.start()`.
 *
 * Note that nearly all methods in this class are run on a queue-basis and not
 * immediately. For example, calling `this.scene.launch('SceneB')` will try to
 * launch SceneB when the Scene Manager next updates, which is at the start of the game
 * step. All operations are queued and run in the order in which they are invoked here.
 *
 * @class ScenePlugin
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this ScenePlugin belongs to.
 */ var ScenePlugin = new Class({
                    initialize: function ScenePlugin(scene) {
                        /**
         * The Scene that this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * The Scene Systems instance of the Scene that this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * The settings of the Scene this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.0.0
         */ this.settings = scene.sys.settings;
                        /**
         * The key of the Scene this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#key
         * @type {string}
         * @since 3.0.0
         */ this.key = scene.sys.settings.key;
                        /**
         * The Game's SceneManager.
         *
         * @name Phaser.Scenes.ScenePlugin#manager
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.0.0
         */ this.manager = scene.sys.game.scene;
                        /**
         * If this Scene is currently transitioning to another, this holds
         * the current percentage of the transition progress, between 0 and 1.
         *
         * @name Phaser.Scenes.ScenePlugin#transitionProgress
         * @type {number}
         * @since 3.5.0
         */ this.transitionProgress = 0;
                        /**
         * Transition elapsed timer.
         *
         * @name Phaser.Scenes.ScenePlugin#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                        /**
         * Transition elapsed timer.
         *
         * @name Phaser.Scenes.ScenePlugin#_target
         * @type {?Phaser.Scene}
         * @private
         * @since 3.5.0
         */ this._target = null;
                        /**
         * Transition duration.
         *
         * @name Phaser.Scenes.ScenePlugin#_duration
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._duration = 0;
                        /**
         * Transition callback.
         *
         * @name Phaser.Scenes.ScenePlugin#_onUpdate
         * @type {function}
         * @private
         * @since 3.5.0
         */ this._onUpdate;
                        /**
         * Transition callback scope.
         *
         * @name Phaser.Scenes.ScenePlugin#_onUpdateScope
         * @type {object}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                        /**
         * Will this Scene sleep (true) after the transition, or stop (false)
         *
         * @name Phaser.Scenes.ScenePlugin#_willSleep
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this._willSleep = false;
                        /**
         * Will this Scene be removed from the Scene Manager after the transition completes?
         *
         * @name Phaser.Scenes.ScenePlugin#_willRemove
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this._willRemove = false;
                        scene.sys.events.once(Events.BOOT, this.boot, this);
                        scene.sys.events.on(Events.START, this.pluginStart, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Scenes.ScenePlugin#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                        this.systems.events.once(Events.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Scenes.ScenePlugin#pluginStart
     * @private
     * @since 3.5.0
     */ pluginStart: function() {
                        this._target = null;
                        this.systems.events.once(Events.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Shutdown this Scene and run the given one.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#start
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to start.
     * @param {object} [data] - The Scene data. If no value is given it will not overwrite any previous data that may exist.
     *
     * @return {this} This Scene Plugin instance.
     */ start: function(key, data) {
                        if (key === undefined) key = this.key;
                        this.manager.queueOp('stop', this.key);
                        this.manager.queueOp('start', key, data);
                        return this;
                    },
                    /**
     * Restarts this Scene.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#restart
     * @since 3.4.0
     *
     * @param {object} [data] - The Scene data. If no value is given it will not overwrite any previous data that may exist.
     *
     * @return {this} This Scene Plugin instance.
     */ restart: function(data) {
                        var key = this.key;
                        this.manager.queueOp('stop', key);
                        this.manager.queueOp('start', key, data);
                        return this;
                    },
                    /**
     * This will start a transition from the current Scene to the target Scene given.
     *
     * The target Scene cannot be the same as the current Scene.
     *
     * The transition will last for the duration specified in milliseconds.
     *
     * You can have the target Scene moved above or below this one in the display list.
     *
     * You can specify an update callback. This callback will be invoked _every frame_ for the duration
     * of the transition.
     *
     * This Scene can either be sent to sleep at the end of the transition, or stopped. The default is to stop.
     *
     * There are also 5 transition related events: This scene will emit the event `transitionout` when
     * the transition begins, which is typically the frame after calling this method.
     *
     * The target Scene will emit the event `transitioninit` when that Scene's `init` method is called.
     * It will then emit the event `transitionstart` when its `create` method is called.
     * If the Scene was sleeping and has been woken up, it will emit the event `transitionwake` instead of these two,
     * as the Scenes `init` and `create` methods are not invoked when a Scene wakes up.
     *
     * When the duration of the transition has elapsed it will emit the event `transitioncomplete`.
     * These events are cleared of all listeners when the Scene shuts down, but not if it is sent to sleep.
     *
     * It's important to understand that the duration of the transition begins the moment you call this method.
     * If the Scene you are transitioning to includes delayed processes, such as waiting for files to load, the
     * time still counts down even while that is happening. If the game itself pauses, or something else causes
     * this Scenes update loop to stop, then the transition will also pause for that duration. There are
     * checks in place to prevent you accidentally stopping a transitioning Scene but if you've got code to
     * override this understand that until the target Scene completes it might never be unlocked for input events.
     *
     * @method Phaser.Scenes.ScenePlugin#transition
     * @fires Phaser.Scenes.Events#TRANSITION_OUT
     * @since 3.5.0
     *
     * @param {Phaser.Types.Scenes.SceneTransitionConfig} config - The transition configuration object.
     *
     * @return {boolean} `true` is the transition was started, otherwise `false`.
     */ transition: function(config) {
                        if (config === undefined) config = {};
                        var key = GetFastValue(config, 'target', false);
                        var target = this.manager.getScene(key);
                        if (!key || !this.checkValidTransition(target)) return false;
                        var duration = GetFastValue(config, 'duration', 1000);
                        this._elapsed = 0;
                        this._target = target;
                        this._duration = duration;
                        this._willSleep = GetFastValue(config, 'sleep', false);
                        this._willRemove = GetFastValue(config, 'remove', false);
                        var callback = GetFastValue(config, 'onUpdate', null);
                        if (callback) {
                            this._onUpdate = callback;
                            this._onUpdateScope = GetFastValue(config, 'onUpdateScope', this.scene);
                        }
                        var allowInput = GetFastValue(config, 'allowInput', false);
                        this.settings.transitionAllowInput = allowInput;
                        var targetSettings = target.sys.settings;
                        targetSettings.isTransition = true;
                        targetSettings.transitionFrom = this.scene;
                        targetSettings.transitionDuration = duration;
                        targetSettings.transitionAllowInput = allowInput;
                        if (GetFastValue(config, 'moveAbove', false)) this.manager.moveAbove(this.key, key);
                        else if (GetFastValue(config, 'moveBelow', false)) this.manager.moveBelow(this.key, key);
                        if (target.sys.isSleeping()) target.sys.wake(GetFastValue(config, 'data'));
                        else this.manager.start(key, GetFastValue(config, 'data'));
                        var onStartCallback = GetFastValue(config, 'onStart', null);
                        var onStartScope = GetFastValue(config, 'onStartScope', this.scene);
                        if (onStartCallback) onStartCallback.call(onStartScope, this.scene, target, duration);
                        this.systems.events.emit(Events.TRANSITION_OUT, target, duration);
                        return true;
                    },
                    /**
     * Checks to see if this Scene can transition to the target Scene or not.
     *
     * @method Phaser.Scenes.ScenePlugin#checkValidTransition
     * @private
     * @since 3.5.0
     *
     * @param {Phaser.Scene} target - The Scene to test against.
     *
     * @return {boolean} `true` if this Scene can transition, otherwise `false`.
     */ checkValidTransition: function(target) {
                        //  Not a valid target if it doesn't exist, isn't active or is already transitioning in or out
                        if (!target || target.sys.isActive() || target.sys.isTransitioning() || target === this.scene || this.systems.isTransitioning()) return false;
                        return true;
                    },
                    /**
     * A single game step. This is only called if the parent Scene is transitioning
     * out to another Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#step
     * @private
     * @since 3.5.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ step: function(time, delta) {
                        this._elapsed += delta;
                        this.transitionProgress = Clamp(this._elapsed / this._duration, 0, 1);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.transitionProgress);
                        if (this._elapsed >= this._duration) this.transitionComplete();
                    },
                    /**
     * Called by `step` when the transition out of this scene to another is over.
     *
     * @method Phaser.Scenes.ScenePlugin#transitionComplete
     * @private
     * @fires Phaser.Scenes.Events#TRANSITION_COMPLETE
     * @since 3.5.0
     */ transitionComplete: function() {
                        var targetSys = this._target.sys;
                        var targetSettings = this._target.sys.settings;
                        //  Notify target scene
                        targetSys.events.emit(Events.TRANSITION_COMPLETE, this.scene);
                        //  Clear target scene settings
                        targetSettings.isTransition = false;
                        targetSettings.transitionFrom = null;
                        //  Clear local settings
                        this._duration = 0;
                        this._target = null;
                        this._onUpdate = null;
                        this._onUpdateScope = null;
                        //  Now everything is clear we can handle what happens to this Scene
                        if (this._willRemove) this.manager.remove(this.key);
                        else if (this._willSleep) this.systems.sleep();
                        else this.manager.stop(this.key);
                    },
                    /**
     * Add the Scene into the Scene Manager and start it if 'autoStart' is true or the Scene config 'active' property is set.
     *
     * @method Phaser.Scenes.ScenePlugin#add
     * @since 3.0.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     * @param {(Phaser.Types.Scenes.SceneType)} sceneConfig - The config for the Scene
     * @param {boolean} [autoStart=false] - If `true` the Scene will be started immediately after being added.
     * @param {object} [data] - Optional data object. This will be set as `Scene.settings.data` and passed to `Scene.init`, and `Scene.create`.
     *
     * @return {?Phaser.Scene} The added Scene, if it was added immediately, otherwise `null`.
     */ add: function(key, sceneConfig, autoStart, data) {
                        return this.manager.add(key, sceneConfig, autoStart, data);
                    },
                    /**
     * Launch the given Scene and run it in parallel with this one.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#launch
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to launch.
     * @param {object} [data] - The Scene data.
     *
     * @return {this} This Scene Plugin instance.
     */ launch: function(key, data) {
                        if (key && key !== this.key) this.manager.queueOp('start', key, data);
                        return this;
                    },
                    /**
     * Runs the given Scene, but does not change the state of this Scene.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * If the given Scene is paused, it will resume it. If sleeping, it will wake it.
     * If not running at all, it will be started.
     *
     * Use this if you wish to open a modal Scene by calling `pause` on the current
     * Scene, then `run` on the modal Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#run
     * @since 3.10.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to run.
     * @param {object} [data] - A data object that will be passed to the Scene and emitted in its ready, wake, or resume events.
     *
     * @return {this} This Scene Plugin instance.
     */ run: function(key, data) {
                        if (key && key !== this.key) this.manager.queueOp('run', key, data);
                        return this;
                    },
                    /**
     * Pause the Scene - this stops the update step from happening but it still renders.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#pause
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to pause.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its pause event.
     *
     * @return {this} This Scene Plugin instance.
     */ pause: function(key, data) {
                        if (key === undefined) key = this.key;
                        this.manager.queueOp('pause', key, data);
                        return this;
                    },
                    /**
     * Resume the Scene - starts the update loop again.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#resume
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to resume.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its resume event.
     *
     * @return {this} This Scene Plugin instance.
     */ resume: function(key, data) {
                        if (key === undefined) key = this.key;
                        this.manager.queueOp('resume', key, data);
                        return this;
                    },
                    /**
     * Makes the Scene sleep (no update, no render) but doesn't shutdown.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#sleep
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to put to sleep.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its sleep event.
     *
     * @return {this} This Scene Plugin instance.
     */ sleep: function(key, data) {
                        if (key === undefined) key = this.key;
                        this.manager.queueOp('sleep', key, data);
                        return this;
                    },
                    /**
     * Makes the Scene wake-up (starts update and render)
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#wake
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to wake up.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its wake event.
     *
     * @return {this} This Scene Plugin instance.
     */ wake: function(key, data) {
                        if (key === undefined) key = this.key;
                        this.manager.queueOp('wake', key, data);
                        return this;
                    },
                    /**
     * Makes this Scene sleep then starts the Scene given.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#switch
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to start.
     * @param {any} [data] - Optional data object to pass to either the Scene `wake` or `start` method.
     *
     * @return {this} This Scene Plugin instance.
     */ switch: function(key, data) {
                        if (key !== this.key) this.manager.queueOp('switch', this.key, key, data);
                        return this;
                    },
                    /**
     * Shutdown the Scene, clearing display list, timers, etc.
     *
     * This happens at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#stop
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to stop.
     * @param {any} [data] - Optional data object to pass to Scene.Systems.shutdown.
     *
     * @return {this} This Scene Plugin instance.
     */ stop: function(key, data) {
                        if (key === undefined) key = this.key;
                        this.manager.queueOp('stop', key, data);
                        return this;
                    },
                    /**
     * Sets the active state of the given Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#setActive
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {boolean} value - If `true` the Scene will be resumed. If `false` it will be paused.
     * @param {(string|Phaser.Scene)} [key] - The Scene to set the active state of.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted with its events.
     *
     * @return {this} This Scene Plugin instance.
     */ setActive: function(value, key, data) {
                        if (key === undefined) key = this.key;
                        var scene = this.manager.getScene(key);
                        if (scene) scene.sys.setActive(value, data);
                        return this;
                    },
                    /**
     * Sets the visible state of the given Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#setVisible
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {boolean} value - The visible value.
     * @param {(string|Phaser.Scene)} [key] - The Scene to set the visible state for.
     *
     * @return {this} This Scene Plugin instance.
     */ setVisible: function(value, key) {
                        if (key === undefined) key = this.key;
                        var scene = this.manager.getScene(key);
                        if (scene) scene.sys.setVisible(value);
                        return this;
                    },
                    /**
     * Checks if the given Scene is sleeping or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isSleeping
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is sleeping, or `null` if no matching Scene was found.
     */ isSleeping: function(key) {
                        if (key === undefined) key = this.key;
                        return this.manager.isSleeping(key);
                    },
                    /**
     * Checks if the given Scene is running or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isActive
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is running, or `null` if no matching Scene was found.
     */ isActive: function(key) {
                        if (key === undefined) key = this.key;
                        return this.manager.isActive(key);
                    },
                    /**
     * Checks if the given Scene is paused or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isPaused
     * @since 3.17.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is paused, or `null` if no matching Scene was found.
     */ isPaused: function(key) {
                        if (key === undefined) key = this.key;
                        return this.manager.isPaused(key);
                    },
                    /**
     * Checks if the given Scene is visible or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isVisible
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is visible, or `null` if no matching Scene was found.
     */ isVisible: function(key) {
                        if (key === undefined) key = this.key;
                        return this.manager.isVisible(key);
                    },
                    /**
     * Swaps the position of two scenes in the Scenes list.
     *
     * This controls the order in which they are rendered and updated.
     *
     * @method Phaser.Scenes.ScenePlugin#swapPosition
     * @since 3.2.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [keyA,keyB]
     *
     * @param {(string|Phaser.Scene)} keyA - The first Scene to swap.
     * @param {(string|Phaser.Scene)} [keyB] - The second Scene to swap. If none is given it defaults to this Scene.
     *
     * @return {this} This Scene Plugin instance.
     */ swapPosition: function(keyA, keyB) {
                        if (keyB === undefined) keyB = this.key;
                        if (keyA !== keyB) this.manager.swapPosition(keyA, keyB);
                        return this;
                    },
                    /**
     * Moves a Scene so it is immediately above another Scene in the Scenes list.
     * If the Scene is already above the other, it isn't moved.
     *
     * This means it will render over the top of the other Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#moveAbove
     * @since 3.2.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [keyA,keyB]
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved to be above.
     * @param {(string|Phaser.Scene)} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
     *
     * @return {this} This Scene Plugin instance.
     */ moveAbove: function(keyA, keyB) {
                        if (keyB === undefined) keyB = this.key;
                        if (keyA !== keyB) this.manager.moveAbove(keyA, keyB);
                        return this;
                    },
                    /**
     * Moves a Scene so it is immediately below another Scene in the Scenes list.
     * If the Scene is already below the other, it isn't moved.
     *
     * This means it will render behind the other Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#moveBelow
     * @since 3.2.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [keyA,keyB]
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved to be below.
     * @param {(string|Phaser.Scene)} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
     *
     * @return {this} This Scene Plugin instance.
     */ moveBelow: function(keyA, keyB) {
                        if (keyB === undefined) keyB = this.key;
                        if (keyA !== keyB) this.manager.moveBelow(keyA, keyB);
                        return this;
                    },
                    /**
     * Removes a Scene from the SceneManager.
     *
     * The Scene is removed from the local scenes array, it's key is cleared from the keys
     * cache and Scene.Systems.destroy is then called on it.
     *
     * If the SceneManager is processing the Scenes when this method is called it will
     * queue the operation for the next update sequence.
     *
     * @method Phaser.Scenes.ScenePlugin#remove
     * @since 3.2.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to be removed.
     *
     * @return {this} This Scene Plugin instance.
     */ remove: function(key) {
                        if (key === undefined) key = this.key;
                        this.manager.remove(key);
                        return this;
                    },
                    /**
     * Moves a Scene up one position in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#moveUp
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ moveUp: function(key) {
                        if (key === undefined) key = this.key;
                        this.manager.moveUp(key);
                        return this;
                    },
                    /**
     * Moves a Scene down one position in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#moveDown
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ moveDown: function(key) {
                        if (key === undefined) key = this.key;
                        this.manager.moveDown(key);
                        return this;
                    },
                    /**
     * Brings a Scene to the top of the Scenes list.
     *
     * This means it will render above all other Scenes.
     *
     * @method Phaser.Scenes.ScenePlugin#bringToTop
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ bringToTop: function(key) {
                        if (key === undefined) key = this.key;
                        this.manager.bringToTop(key);
                        return this;
                    },
                    /**
     * Sends a Scene to the back of the Scenes list.
     *
     * This means it will render below all other Scenes.
     *
     * @method Phaser.Scenes.ScenePlugin#sendToBack
     * @since 3.0.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ sendToBack: function(key) {
                        if (key === undefined) key = this.key;
                        this.manager.sendToBack(key);
                        return this;
                    },
                    /**
     * Retrieves a Scene based on the given key.
     *
     * If an actual Scene is passed to this method, it can be used to check if
     * its currently within the Scene Manager, or not.
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     * @genericUse {T} - [$return]
     *
     * @method Phaser.Scenes.ScenePlugin#get
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to retrieve.
     *
     * @return {Phaser.Scene} The Scene.
     */ get: function(key) {
                        return this.manager.getScene(key);
                    },
                    /**
     * Return the status of the Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#getStatus
     * @since 3.60.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} key - The Scene to get the status from.
     *
     * @return {number} The Scene status. This maps to the `Phaser.Scene` constants, such as `Phaser.Scene.LOADING`.
     */ getStatus: function(key) {
                        var scene = this.manager.getScene(key);
                        if (scene) return scene.sys.getStatus();
                    },
                    /**
     * Retrieves the numeric index of a Scene in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#getIndex
     * @since 3.7.0
     *
     * @generic {Phaser.Scene} T
     * @genericUse {(T|string)} - [key]
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to get the index of.
     *
     * @return {number} The index of the Scene.
     */ getIndex: function(key) {
                        if (key === undefined) key = this.key;
                        return this.manager.getIndex(key);
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Scenes.ScenePlugin#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        var eventEmitter = this.systems.events;
                        eventEmitter.off(Events.SHUTDOWN, this.shutdown, this);
                        eventEmitter.off(Events.TRANSITION_OUT);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     *
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Scenes.ScenePlugin#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.scene.sys.events.off(Events.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                        this.settings = null;
                        this.manager = null;
                    }
                });
                PluginCache.register('ScenePlugin', ScenePlugin, 'scenePlugin');
                module1.exports = ScenePlugin;
            /***/ },
            /***/ 55681: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(89993);
                var GetValue = __webpack_require__(35154);
                var Merge = __webpack_require__(46975);
                var InjectionMap = __webpack_require__(87033);
                /**
 * @namespace Phaser.Scenes.Settings
 */ var Settings = {
                    /**
     * Takes a Scene configuration object and returns a fully formed System Settings object.
     *
     * @function Phaser.Scenes.Settings.create
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - The Scene configuration object used to create this Scene Settings.
     *
     * @return {Phaser.Types.Scenes.SettingsObject} The Scene Settings object created as a result of the config and default settings.
     */ create: function(config) {
                        if (typeof config === 'string') config = {
                            key: config
                        };
                        else if (config === undefined) //  Pass the 'hasOwnProperty' checks
                        config = {};
                        return {
                            status: CONST.PENDING,
                            key: GetValue(config, 'key', ''),
                            active: GetValue(config, 'active', false),
                            visible: GetValue(config, 'visible', true),
                            isBooted: false,
                            isTransition: false,
                            transitionFrom: null,
                            transitionDuration: 0,
                            transitionAllowInput: true,
                            //  Loader payload array
                            data: {},
                            pack: GetValue(config, 'pack', false),
                            //  Cameras
                            cameras: GetValue(config, 'cameras', null),
                            //  Scene Property Injection Map
                            map: GetValue(config, 'map', Merge(InjectionMap, GetValue(config, 'mapAdd', {}))),
                            //  Physics
                            physics: GetValue(config, 'physics', {}),
                            //  Loader
                            loader: GetValue(config, 'loader', {}),
                            //  Plugins
                            plugins: GetValue(config, 'plugins', false),
                            //  Input
                            input: GetValue(config, 'input', {})
                        };
                    }
                };
                module1.exports = Settings;
            /***/ },
            /***/ 2368: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(89993);
                var DefaultPlugins = __webpack_require__(42363);
                var Events = __webpack_require__(44594);
                var GetPhysicsPlugins = __webpack_require__(27397);
                var GetScenePlugins = __webpack_require__(52106);
                var NOOP = __webpack_require__(29747);
                var Settings = __webpack_require__(55681);
                /**
 * @classdesc
 * The Scene Systems class.
 *
 * This class is available from within a Scene under the property `sys`.
 * It is responsible for managing all of the plugins a Scene has running, including the display list, and
 * handling the update step and renderer. It also contains references to global systems belonging to Game.
 *
 * @class Systems
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that owns this Systems instance.
 * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - Scene specific configuration settings.
 */ var Systems = new Class({
                    initialize: function Systems(scene, config) {
                        /**
         * A reference to the Scene that these Systems belong to.
         *
         * @name Phaser.Scenes.Systems#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * A reference to the Phaser Game instance.
         *
         * @name Phaser.Scenes.Systems#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game;
                        /**
         * A reference to either the Canvas or WebGL Renderer that this Game is using.
         *
         * @name Phaser.Scenes.Systems#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.17.0
         */ this.renderer;
                        /**
         * The Scene Configuration object, as passed in when creating the Scene.
         *
         * @name Phaser.Scenes.Systems#config
         * @type {(string|Phaser.Types.Scenes.SettingsConfig)}
         * @since 3.0.0
         */ this.config = config;
                        /**
         * The Scene Settings. This is the parsed output based on the Scene configuration.
         *
         * @name Phaser.Scenes.Systems#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.0.0
         */ this.settings = Settings.create(config);
                        /**
         * A handy reference to the Scene canvas / context.
         *
         * @name Phaser.Scenes.Systems#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas;
                        /**
         * A reference to the Canvas Rendering Context being used by the renderer.
         *
         * @name Phaser.Scenes.Systems#context
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.context;
                        //  Global Systems - these are single-instance global managers that belong to Game
                        /**
         * A reference to the global Animations Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.anims` property.
         *
         * @name Phaser.Scenes.Systems#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims;
                        /**
         * A reference to the global Cache. The Cache stores all files brought in to Phaser via
         * the Loader, with the exception of images. Images are stored in the Texture Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.cache` property.
         *
         * @name Phaser.Scenes.Systems#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache;
                        /**
         * A reference to the global Plugins Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.plugins` property.
         *
         * @name Phaser.Scenes.Systems#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins;
                        /**
         * A reference to the global registry. This is a game-wide instance of the Data Manager, allowing
         * you to exchange data between Scenes via a universal and shared point.
         *
         * In the default set-up you can access this from within a Scene via the `this.registry` property.
         *
         * @name Phaser.Scenes.Systems#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry;
                        /**
         * A reference to the global Scale Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.scale` property.
         *
         * @name Phaser.Scenes.Systems#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.15.0
         */ this.scale;
                        /**
         * A reference to the global Sound Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.sound` property.
         *
         * @name Phaser.Scenes.Systems#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound;
                        /**
         * A reference to the global Texture Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.textures` property.
         *
         * @name Phaser.Scenes.Systems#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures;
                        //  Core Plugins - these are non-optional Scene plugins, needed by lots of the other systems
                        /**
         * A reference to the Scene's Game Object Factory.
         *
         * Use this to quickly and easily create new Game Objects.
         *
         * In the default set-up you can access this from within a Scene via the `this.add` property.
         *
         * @name Phaser.Scenes.Systems#add
         * @type {Phaser.GameObjects.GameObjectFactory}
         * @since 3.0.0
         */ this.add;
                        /**
         * A reference to the Scene's Camera Manager.
         *
         * Use this to manipulate and create Cameras for this specific Scene.
         *
         * In the default set-up you can access this from within a Scene via the `this.cameras` property.
         *
         * @name Phaser.Scenes.Systems#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                        /**
         * A reference to the Scene's Display List.
         *
         * Use this to organize the children contained in the display list.
         *
         * In the default set-up you can access this from within a Scene via the `this.children` property.
         *
         * @name Phaser.Scenes.Systems#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.displayList;
                        /**
         * A reference to the Scene's Event Manager.
         *
         * Use this to listen for Scene specific events, such as `pause` and `shutdown`.
         *
         * In the default set-up you can access this from within a Scene via the `this.events` property.
         *
         * @name Phaser.Scenes.Systems#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events;
                        /**
         * A reference to the Scene's Game Object Creator.
         *
         * Use this to quickly and easily create new Game Objects. The difference between this and the
         * Game Object Factory, is that the Creator just creates and returns Game Object instances, it
         * doesn't then add them to the Display List or Update List.
         *
         * In the default set-up you can access this from within a Scene via the `this.make` property.
         *
         * @name Phaser.Scenes.Systems#make
         * @type {Phaser.GameObjects.GameObjectCreator}
         * @since 3.0.0
         */ this.make;
                        /**
         * A reference to the Scene Manager Plugin.
         *
         * Use this to manipulate both this and other Scenes in your game. For example, to launch a parallel Scene,
         * or pause or resume a Scene, or switch from this Scene to another.
         *
         * In the default set-up you can access this from within a Scene via the `this.scene` property.
         *
         * @name Phaser.Scenes.Systems#scenePlugin
         * @type {Phaser.Scenes.ScenePlugin}
         * @since 3.0.0
         */ this.scenePlugin;
                        /**
         * A reference to the Scene's Update List.
         *
         * Use this to organize the children contained in the update list.
         *
         * The Update List is responsible for managing children that need their `preUpdate` methods called,
         * in order to process internal components - such as Sprites with Animations.
         *
         * In the default set-up there is no reference to this from within the Scene itself.
         *
         * @name Phaser.Scenes.Systems#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @since 3.0.0
         */ this.updateList;
                        /**
         * The Scene Update function.
         *
         * This starts out as NOOP during init, preload and create, and at the end of create
         * it swaps to be whatever the Scene.update function is.
         *
         * @name Phaser.Scenes.Systems#sceneUpdate
         * @type {function}
         * @private
         * @since 3.10.0
         */ this.sceneUpdate = NOOP;
                    },
                    /**
     * This method is called only once by the Scene Manager when the Scene is instantiated.
     * It is responsible for setting up all of the Scene plugins and references.
     * It should never be called directly.
     *
     * @method Phaser.Scenes.Systems#init
     * @protected
     * @fires Phaser.Scenes.Events#BOOT
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
     */ init: function(game) {
                        this.settings.status = CONST.INIT;
                        //  This will get replaced by the SceneManager with the actual update function, if it exists, once create is over.
                        this.sceneUpdate = NOOP;
                        this.game = game;
                        this.renderer = game.renderer;
                        this.canvas = game.canvas;
                        this.context = game.context;
                        var pluginManager = game.plugins;
                        this.plugins = pluginManager;
                        pluginManager.addToScene(this, DefaultPlugins.Global, [
                            DefaultPlugins.CoreScene,
                            GetScenePlugins(this),
                            GetPhysicsPlugins(this)
                        ]);
                        this.events.emit(Events.BOOT, this);
                        this.settings.isBooted = true;
                    },
                    /**
     * A single game step. Called automatically by the Scene Manager as a result of a Request Animation
     * Frame or Set Timeout call to the main Game instance.
     *
     * @method Phaser.Scenes.Systems#step
     * @fires Phaser.Scenes.Events#PRE_UPDATE
     * @fires Phaser.Scenes.Events#UPDATE
     * @fires Phaser.Scenes.Events#POST_UPDATE
     * @since 3.0.0
     *
     * @param {number} time - The time value from the most recent Game step. Typically a high-resolution timer value, or Date.now().
     * @param {number} delta - The delta value since the last frame. This is smoothed to avoid delta spikes by the TimeStep class.
     */ step: function(time, delta) {
                        var events = this.events;
                        events.emit(Events.PRE_UPDATE, time, delta);
                        events.emit(Events.UPDATE, time, delta);
                        this.sceneUpdate.call(this.scene, time, delta);
                        events.emit(Events.POST_UPDATE, time, delta);
                    },
                    /**
     * Called automatically by the Scene Manager.
     * Instructs the Scene to render itself via its Camera Manager to the renderer given.
     *
     * @method Phaser.Scenes.Systems#render
     * @fires Phaser.Scenes.Events#PRE_RENDER
     * @fires Phaser.Scenes.Events#RENDER
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that invoked the render call.
     */ render: function(renderer) {
                        var displayList = this.displayList;
                        displayList.depthSort();
                        this.events.emit(Events.PRE_RENDER, renderer);
                        this.cameras.render(renderer, displayList);
                        this.events.emit(Events.RENDER, renderer);
                    },
                    /**
     * Force a sort of the display list on the next render.
     *
     * @method Phaser.Scenes.Systems#queueDepthSort
     * @since 3.0.0
     */ queueDepthSort: function() {
                        this.displayList.queueDepthSort();
                    },
                    /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.Scenes.Systems#depthSort
     * @since 3.0.0
     */ depthSort: function() {
                        this.displayList.depthSort();
                    },
                    /**
     * Pause this Scene.
     *
     * A paused Scene still renders, it just doesn't run any of its update handlers or systems.
     *
     * @method Phaser.Scenes.Systems#pause
     * @fires Phaser.Scenes.Events#PAUSE
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'pause' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ pause: function(data) {
                        var settings = this.settings;
                        var status = this.getStatus();
                        if (status !== CONST.CREATING && status !== CONST.RUNNING) console.warn('Cannot pause non-running Scene', settings.key);
                        else if (this.settings.active) {
                            settings.status = CONST.PAUSED;
                            settings.active = false;
                            this.events.emit(Events.PAUSE, this, data);
                        }
                        return this;
                    },
                    /**
     * Resume this Scene from a paused state.
     *
     * @method Phaser.Scenes.Systems#resume
     * @fires Phaser.Scenes.Events#RESUME
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'resume' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ resume: function(data) {
                        var events = this.events;
                        var settings = this.settings;
                        if (!this.settings.active) {
                            settings.status = CONST.RUNNING;
                            settings.active = true;
                            events.emit(Events.RESUME, this, data);
                        }
                        return this;
                    },
                    /**
     * Send this Scene to sleep.
     *
     * A sleeping Scene doesn't run its update step or render anything, but it also isn't shut down
     * or has any of its systems or children removed, meaning it can be re-activated at any point and
     * will carry on from where it left off. It also keeps everything in memory and events and callbacks
     * from other Scenes may still invoke changes within it, so be careful what is left active.
     *
     * @method Phaser.Scenes.Systems#sleep
     * @fires Phaser.Scenes.Events#SLEEP
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'sleep' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ sleep: function(data) {
                        var settings = this.settings;
                        var status = this.getStatus();
                        if (status !== CONST.CREATING && status !== CONST.RUNNING) console.warn('Cannot sleep non-running Scene', settings.key);
                        else {
                            settings.status = CONST.SLEEPING;
                            settings.active = false;
                            settings.visible = false;
                            this.events.emit(Events.SLEEP, this, data);
                        }
                        return this;
                    },
                    /**
     * Wake-up this Scene if it was previously asleep.
     *
     * @method Phaser.Scenes.Systems#wake
     * @fires Phaser.Scenes.Events#WAKE
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'wake' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ wake: function(data) {
                        var events = this.events;
                        var settings = this.settings;
                        settings.status = CONST.RUNNING;
                        settings.active = true;
                        settings.visible = true;
                        events.emit(Events.WAKE, this, data);
                        if (settings.isTransition) events.emit(Events.TRANSITION_WAKE, settings.transitionFrom, settings.transitionDuration);
                        return this;
                    },
                    /**
     * Returns any data that was sent to this Scene by another Scene.
     *
     * The data is also passed to `Scene.init` and in various Scene events, but
     * you can access it at any point via this method.
     *
     * @method Phaser.Scenes.Systems#getData
     * @since 3.22.0
     *
     * @return {any} The Scene Data.
     */ getData: function() {
                        return this.settings.data;
                    },
                    /**
     * Returns the current status of this Scene.
     *
     * @method Phaser.Scenes.Systems#getStatus
     * @since 3.60.0
     *
     * @return {number} The status of this Scene. One of the `Phaser.Scene` constants.
     */ getStatus: function() {
                        return this.settings.status;
                    },
                    /**
     * Can this Scene receive Input events?
     *
     * @method Phaser.Scenes.Systems#canInput
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Scene can receive Input events.
     */ canInput: function() {
                        var status = this.settings.status;
                        return status > CONST.PENDING && status <= CONST.RUNNING;
                    },
                    /**
     * Is this Scene sleeping?
     *
     * @method Phaser.Scenes.Systems#isSleeping
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is asleep, otherwise `false`.
     */ isSleeping: function() {
                        return this.settings.status === CONST.SLEEPING;
                    },
                    /**
     * Is this Scene running?
     *
     * @method Phaser.Scenes.Systems#isActive
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is running, otherwise `false`.
     */ isActive: function() {
                        return this.settings.status === CONST.RUNNING;
                    },
                    /**
     * Is this Scene paused?
     *
     * @method Phaser.Scenes.Systems#isPaused
     * @since 3.13.0
     *
     * @return {boolean} `true` if this Scene is paused, otherwise `false`.
     */ isPaused: function() {
                        return this.settings.status === CONST.PAUSED;
                    },
                    /**
     * Is this Scene currently transitioning out to, or in from another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitioning
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is currently transitioning, otherwise `false`.
     */ isTransitioning: function() {
                        return this.settings.isTransition || this.scenePlugin._target !== null;
                    },
                    /**
     * Is this Scene currently transitioning out from itself to another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitionOut
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is in transition to another Scene, otherwise `false`.
     */ isTransitionOut: function() {
                        return this.scenePlugin._target !== null && this.scenePlugin._duration > 0;
                    },
                    /**
     * Is this Scene currently transitioning in from another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitionIn
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is transitioning in from another Scene, otherwise `false`.
     */ isTransitionIn: function() {
                        return this.settings.isTransition;
                    },
                    /**
     * Is this Scene visible and rendering?
     *
     * @method Phaser.Scenes.Systems#isVisible
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is visible, otherwise `false`.
     */ isVisible: function() {
                        return this.settings.visible;
                    },
                    /**
     * Sets the visible state of this Scene.
     * An invisible Scene will not render, but will still process updates.
     *
     * @method Phaser.Scenes.Systems#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to render this Scene, otherwise `false`.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ setVisible: function(value) {
                        this.settings.visible = value;
                        return this;
                    },
                    /**
     * Set the active state of this Scene.
     *
     * An active Scene will run its core update loop.
     *
     * @method Phaser.Scenes.Systems#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - If `true` the Scene will be resumed, if previously paused. If `false` it will be paused.
     * @param {object} [data] - A data object that will be passed in the 'resume' or 'pause' events.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ setActive: function(value, data) {
                        if (value) return this.resume(data);
                        else return this.pause(data);
                    },
                    /**
     * Start this Scene running and rendering.
     * Called automatically by the SceneManager.
     *
     * @method Phaser.Scenes.Systems#start
     * @fires Phaser.Scenes.Events#START
     * @fires Phaser.Scenes.Events#READY
     * @since 3.0.0
     *
     * @param {object} data - Optional data object that may have been passed to this Scene from another.
     */ start: function(data) {
                        var events = this.events;
                        var settings = this.settings;
                        if (data) settings.data = data;
                        settings.status = CONST.START;
                        settings.active = true;
                        settings.visible = true;
                        //  For plugins to listen out for
                        events.emit(Events.START, this);
                        //  For user-land code to listen out for
                        events.emit(Events.READY, this, data);
                    },
                    /**
     * Shutdown this Scene and send a shutdown event to all of its systems.
     * A Scene that has been shutdown will not run its update loop or render, but it does
     * not destroy any of its plugins or references. It is put into hibernation for later use.
     * If you don't ever plan to use this Scene again, then it should be destroyed instead
     * to free-up resources.
     *
     * @method Phaser.Scenes.Systems#shutdown
     * @fires Phaser.Scenes.Events#SHUTDOWN
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'shutdown' event.
     */ shutdown: function(data) {
                        var events = this.events;
                        var settings = this.settings;
                        events.off(Events.TRANSITION_INIT);
                        events.off(Events.TRANSITION_START);
                        events.off(Events.TRANSITION_COMPLETE);
                        events.off(Events.TRANSITION_OUT);
                        settings.status = CONST.SHUTDOWN;
                        settings.active = false;
                        settings.visible = false;
                        events.emit(Events.SHUTDOWN, this, data);
                    },
                    /**
     * Destroy this Scene and send a destroy event to all of its systems.
     * A destroyed Scene cannot be restarted.
     * You should not call this directly, instead use `SceneManager.remove`.
     *
     * @method Phaser.Scenes.Systems#destroy
     * @private
     * @fires Phaser.Scenes.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                        var events = this.events;
                        var settings = this.settings;
                        settings.status = CONST.DESTROYED;
                        settings.active = false;
                        settings.visible = false;
                        events.emit(Events.DESTROY, this);
                        events.removeAllListeners();
                        var props = [
                            'scene',
                            'game',
                            'anims',
                            'cache',
                            'plugins',
                            'registry',
                            'sound',
                            'textures',
                            'add',
                            'camera',
                            'displayList',
                            'events',
                            'make',
                            'scenePlugin',
                            'updateList'
                        ];
                        for(var i = 0; i < props.length; i++)this[props[i]] = null;
                    }
                });
                module1.exports = Systems;
            /***/ },
            /***/ 89993: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Scene consts.
 *
 * @ignore
 */ var CONST = {
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.PENDING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ PENDING: 0,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.INIT
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ INIT: 1,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.START
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ START: 2,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.LOADING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ LOADING: 3,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.CREATING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ CREATING: 4,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.RUNNING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ RUNNING: 5,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.PAUSED
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ PAUSED: 6,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.SLEEPING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ SLEEPING: 7,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.SHUTDOWN
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ SHUTDOWN: 8,
                    /**
     * Scene state.
     *
     * @name Phaser.Scenes.DESTROYED
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ DESTROYED: 9
                };
                module1.exports = CONST;
            /***/ },
            /***/ 69830: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Added to Scene Event.
 *
 * This event is dispatched when a Game Object is added to a Scene.
 *
 * Listen for it from a Scene using `this.events.on('addedtoscene', listener)`.
 *
 * @event Phaser.Scenes.Events#ADDED_TO_SCENE
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the Scene.
 * @param {Phaser.Scene} scene - The Scene to which the Game Object was added.
 */ module1.exports = 'addedtoscene';
            /***/ },
            /***/ 7919: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Boot Event.
 *
 * This event is dispatched by a Scene during the Scene Systems boot process. Primarily used by Scene Plugins.
 *
 * Listen to it from a Scene using `this.events.on('boot', listener)`.
 *
 * @event Phaser.Scenes.Events#BOOT
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = 'boot';
            /***/ },
            /***/ 46763: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Create Event.
 *
 * This event is dispatched by a Scene after it has been created by the Scene Manager.
 *
 * If a Scene has a `create` method then this event is emitted _after_ that has run.
 *
 * If there is a transition, this event will be fired after the `TRANSITION_START` event.
 *
 * Listen to it from a Scene using `this.events.on('create', listener)`.
 *
 * @event Phaser.Scenes.Events#CREATE
 * @type {string}
 * @since 3.17.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that emitted this event.
 */ module1.exports = 'create';
            /***/ },
            /***/ 11763: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Destroy Event.
 *
 * This event is dispatched by a Scene during the Scene Systems destroy process.
 *
 * Listen to it from a Scene using `this.events.on('destroy', listener)`.
 *
 * You should destroy any resources that may be in use by your Scene in this event handler.
 *
 * @event Phaser.Scenes.Events#DESTROY
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = 'destroy';
            /***/ },
            /***/ 71555: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pause Event.
 *
 * This event is dispatched by a Scene when it is paused, either directly via the `pause` method, or as an
 * action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('pause', listener)`.
 *
 * @event Phaser.Scenes.Events#PAUSE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was paused.
 */ module1.exports = 'pause';
            /***/ },
            /***/ 36735: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Post Update Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('postupdate', listener)`.
 *
 * A Scene will only run its step if it is active.
 *
 * @event Phaser.Scenes.Events#POST_UPDATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'postupdate';
            /***/ },
            /***/ 3809: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2021 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pre-Render Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to this event from a Scene using `this.events.on('prerender', listener)`.
 *
 * A Scene will only render if it is visible.
 *
 * This event is dispatched after the Scene Display List is sorted and before the Scene is rendered.
 *
 * @event Phaser.Scenes.Events#PRE_RENDER
 * @type {string}
 * @since 3.53.0
 *
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that rendered the Scene.
 */ module1.exports = 'prerender';
            /***/ },
            /***/ 90716: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pre Update Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('preupdate', listener)`.
 *
 * A Scene will only run its step if it is active.
 *
 * @event Phaser.Scenes.Events#PRE_UPDATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'preupdate';
            /***/ },
            /***/ 58262: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Ready Event.
 *
 * This event is dispatched by a Scene during the Scene Systems start process.
 * By this point in the process the Scene is now fully active and rendering.
 * This event is meant for your game code to use, as all plugins have responded to the earlier 'start' event.
 *
 * Listen to it from a Scene using `this.events.on('ready', listener)`.
 *
 * @event Phaser.Scenes.Events#READY
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was started.
 */ module1.exports = 'ready';
            /***/ },
            /***/ 91633: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Removed from Scene Event.
 *
 * This event is dispatched when a Game Object is removed from a Scene.
 *
 * Listen for it from a Scene using `this.events.on('removedfromscene', listener)`.
 *
 * @event Phaser.Scenes.Events#REMOVED_FROM_SCENE
 * @type {string}
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the Scene.
 * @param {Phaser.Scene} scene - The Scene from which the Game Object was removed.
 */ module1.exports = 'removedfromscene';
            /***/ },
            /***/ 10319: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Render Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('render', listener)`.
 *
 * A Scene will only render if it is visible.
 *
 * By the time this event is dispatched, the Scene will have already been rendered.
 *
 * @event Phaser.Scenes.Events#RENDER
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that rendered the Scene.
 */ module1.exports = 'render';
            /***/ },
            /***/ 87132: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Resume Event.
 *
 * This event is dispatched by a Scene when it is resumed from a paused state, either directly via the `resume` method,
 * or as an action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('resume', listener)`.
 *
 * @event Phaser.Scenes.Events#RESUME
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was resumed.
 */ module1.exports = 'resume';
            /***/ },
            /***/ 81961: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Shutdown Event.
 *
 * This event is dispatched by a Scene during the Scene Systems shutdown process.
 *
 * Listen to it from a Scene using `this.events.on('shutdown', listener)`.
 *
 * You should free-up any resources that may be in use by your Scene in this event handler, on the understanding
 * that the Scene may, at any time, become active again. A shutdown Scene is not 'destroyed', it's simply not
 * currently active. Use the [DESTROY]{@linkcode Phaser.Scenes.Events#event:DESTROY} event to completely clear resources.
 *
 * @event Phaser.Scenes.Events#SHUTDOWN
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was shutdown.
 */ module1.exports = 'shutdown';
            /***/ },
            /***/ 90194: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Sleep Event.
 *
 * This event is dispatched by a Scene when it is sent to sleep, either directly via the `sleep` method,
 * or as an action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('sleep', listener)`.
 *
 * @event Phaser.Scenes.Events#SLEEP
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was sent to sleep.
 */ module1.exports = 'sleep';
            /***/ },
            /***/ 6265: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Start Event.
 *
 * This event is dispatched by a Scene during the Scene Systems start process. Primarily used by Scene Plugins.
 *
 * Listen to it from a Scene using `this.events.on('start', listener)`.
 *
 * @event Phaser.Scenes.Events#START
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = 'start';
            /***/ },
            /***/ 33178: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Complete Event.
 *
 * This event is dispatched by the Target Scene of a transition.
 *
 * It happens when the transition process has completed. This occurs when the duration timer equals or exceeds the duration
 * of the transition.
 *
 * Listen to it from a Scene using `this.events.on('transitioncomplete', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_COMPLETE
 * @type {string}
 * @since 3.5.0
 *
 * @param {Phaser.Scene} scene -The Scene on which the transitioned completed.
 */ module1.exports = 'transitioncomplete';
            /***/ },
            /***/ 43063: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Init Event.
 *
 * This event is dispatched by the Target Scene of a transition.
 *
 * It happens immediately after the `Scene.init` method is called. If the Scene does not have an `init` method,
 * this event is not dispatched.
 *
 * Listen to it from a Scene using `this.events.on('transitioninit', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_INIT
 * @type {string}
 * @since 3.5.0
 *
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitioninit';
            /***/ },
            /***/ 11259: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Out Event.
 *
 * This event is dispatched by a Scene when it initiates a transition to another Scene.
 *
 * Listen to it from a Scene using `this.events.on('transitionout', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_OUT
 * @type {string}
 * @since 3.5.0
 *
 * @param {Phaser.Scene} target - A reference to the Scene that is being transitioned to.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitionout';
            /***/ },
            /***/ 61611: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Start Event.
 *
 * This event is dispatched by the Target Scene of a transition, only if that Scene was not asleep.
 *
 * It happens immediately after the `Scene.create` method is called. If the Scene does not have a `create` method,
 * this event is dispatched anyway.
 *
 * If the Target Scene was sleeping then the [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} event is
 * dispatched instead of this event.
 *
 * Listen to it from a Scene using `this.events.on('transitionstart', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_START
 * @type {string}
 * @since 3.5.0
 *
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitionstart';
            /***/ },
            /***/ 45209: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Wake Event.
 *
 * This event is dispatched by the Target Scene of a transition, only if that Scene was asleep before
 * the transition began. If the Scene was not asleep the [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} event is dispatched instead.
 *
 * Listen to it from a Scene using `this.events.on('transitionwake', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_WAKE
 * @type {string}
 * @since 3.5.0
 *
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitionwake';
            /***/ },
            /***/ 22966: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Update Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists and the Scene is in a Running state, otherwise this is skipped.
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('update', listener)`.
 *
 * A Scene will only run its step if it is active.
 *
 * @event Phaser.Scenes.Events#UPDATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'update';
            /***/ },
            /***/ 21747: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Wake Event.
 *
 * This event is dispatched by a Scene when it is woken from sleep, either directly via the `wake` method,
 * or as an action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('wake', listener)`.
 *
 * @event Phaser.Scenes.Events#WAKE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was woken up.
 */ module1.exports = 'wake';
            /***/ },
            /***/ 44594: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Scenes.Events
 */ module1.exports = {
                    ADDED_TO_SCENE: __webpack_require__(69830),
                    BOOT: __webpack_require__(7919),
                    CREATE: __webpack_require__(46763),
                    DESTROY: __webpack_require__(11763),
                    PAUSE: __webpack_require__(71555),
                    POST_UPDATE: __webpack_require__(36735),
                    PRE_RENDER: __webpack_require__(3809),
                    PRE_UPDATE: __webpack_require__(90716),
                    READY: __webpack_require__(58262),
                    REMOVED_FROM_SCENE: __webpack_require__(91633),
                    RENDER: __webpack_require__(10319),
                    RESUME: __webpack_require__(87132),
                    SHUTDOWN: __webpack_require__(81961),
                    SLEEP: __webpack_require__(90194),
                    START: __webpack_require__(6265),
                    TRANSITION_COMPLETE: __webpack_require__(33178),
                    TRANSITION_INIT: __webpack_require__(43063),
                    TRANSITION_OUT: __webpack_require__(11259),
                    TRANSITION_START: __webpack_require__(61611),
                    TRANSITION_WAKE: __webpack_require__(45209),
                    UPDATE: __webpack_require__(22966),
                    WAKE: __webpack_require__(21747)
                };
            /***/ },
            /***/ 62194: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(89993);
                var Extend = __webpack_require__(79291);
                /**
 * @namespace Phaser.Scenes
 */ var Scene = {
                    Events: __webpack_require__(44594),
                    GetPhysicsPlugins: __webpack_require__(27397),
                    GetScenePlugins: __webpack_require__(52106),
                    SceneManager: __webpack_require__(60903),
                    ScenePlugin: __webpack_require__(52209),
                    Settings: __webpack_require__(55681),
                    Systems: __webpack_require__(2368)
                };
                //   Merge in the consts
                Scene = Extend(false, Scene, CONST);
                module1.exports = Scene;
            /***/ },
            /***/ 30341: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(14463);
                var Extend = __webpack_require__(79291);
                var NOOP = __webpack_require__(29747);
                /**
 * @classdesc
 * Class containing all the shared state and behavior of a sound object, independent of the implementation.
 *
 * @class BaseSound
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
 */ var BaseSound = new Class({
                    Extends: EventEmitter,
                    initialize: function BaseSound(manager, key, config) {
                        EventEmitter.call(this);
                        /**
         * Local reference to the sound manager.
         *
         * @name Phaser.Sound.BaseSound#manager
         * @type {Phaser.Sound.BaseSoundManager}
         * @since 3.0.0
         */ this.manager = manager;
                        /**
         * Asset key for the sound.
         *
         * @name Phaser.Sound.BaseSound#key
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.key = key;
                        /**
         * Flag indicating if sound is currently playing.
         *
         * @name Phaser.Sound.BaseSound#isPlaying
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPlaying = false;
                        /**
         * Flag indicating if sound is currently paused.
         *
         * @name Phaser.Sound.BaseSound#isPaused
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPaused = false;
                        /**
         * A property that holds the value of sound's actual playback rate,
         * after its rate and detune values has been combined with global
         * rate and detune values.
         *
         * @name Phaser.Sound.BaseSound#totalRate
         * @type {number}
         * @default 1
         * @readonly
         * @since 3.0.0
         */ this.totalRate = 1;
                        /**
         * A value representing the duration, in seconds.
         * It could be total sound duration or a marker duration.
         *
         * @name Phaser.Sound.BaseSound#duration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.duration = this.duration || 0;
                        /**
         * The total duration of the sound in seconds.
         *
         * @name Phaser.Sound.BaseSound#totalDuration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.totalDuration = this.totalDuration || 0;
                        /**
         * A config object used to store default sound settings' values.
         * Default values will be set by properties' setters.
         *
         * @name Phaser.Sound.BaseSound#config
         * @type {Phaser.Types.Sound.SoundConfig}
         * @private
         * @since 3.0.0
         */ this.config = {
                            mute: false,
                            volume: 1,
                            rate: 1,
                            detune: 0,
                            seek: 0,
                            loop: false,
                            delay: 0,
                            pan: 0
                        };
                        /**
         * Reference to the currently used config.
         * It could be default config or marker config.
         *
         * @name Phaser.Sound.BaseSound#currentConfig
         * @type {Phaser.Types.Sound.SoundConfig}
         * @private
         * @since 3.0.0
         */ this.currentConfig = this.config;
                        this.config = Extend(this.config, config);
                        /**
         * Object containing markers definitions.
         *
         * @name Phaser.Sound.BaseSound#markers
         * @type {Object.<string, Phaser.Types.Sound.SoundMarker>}
         * @default {}
         * @readonly
         * @since 3.0.0
         */ this.markers = {};
                        /**
         * Currently playing marker.
         * 'null' if whole sound is playing.
         *
         * @name Phaser.Sound.BaseSound#currentMarker
         * @type {Phaser.Types.Sound.SoundMarker}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.currentMarker = null;
                        /**
         * Flag indicating if destroy method was called on this sound.
         *
         * @name Phaser.Sound.BaseSound#pendingRemove
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pendingRemove = false;
                    },
                    /**
     * Adds a marker into the current sound. A marker is represented by name, start time, duration, and optionally config object.
     * This allows you to bundle multiple sounds together into a single audio file and use markers to jump between them for playback.
     *
     * @method Phaser.Sound.BaseSound#addMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object.
     *
     * @return {boolean} Whether the marker was added successfully.
     */ addMarker: function(marker) {
                        if (!marker || !marker.name || typeof marker.name !== 'string') return false;
                        if (this.markers[marker.name]) {
                            // eslint-disable-next-line no-console
                            console.error('addMarker ' + marker.name + ' already exists in Sound');
                            return false;
                        }
                        marker = Extend(true, {
                            name: '',
                            start: 0,
                            duration: this.totalDuration - (marker.start || 0),
                            config: {
                                mute: false,
                                volume: 1,
                                rate: 1,
                                detune: 0,
                                seek: 0,
                                loop: false,
                                delay: 0,
                                pan: 0
                            }
                        }, marker);
                        this.markers[marker.name] = marker;
                        return true;
                    },
                    /**
     * Updates previously added marker.
     *
     * @method Phaser.Sound.BaseSound#updateMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object with updated values.
     *
     * @return {boolean} Whether the marker was updated successfully.
     */ updateMarker: function(marker) {
                        if (!marker || !marker.name || typeof marker.name !== 'string') return false;
                        if (!this.markers[marker.name]) {
                            // eslint-disable-next-line no-console
                            console.warn('Audio Marker: ' + marker.name + ' missing in Sound: ' + this.key);
                            return false;
                        }
                        this.markers[marker.name] = Extend(true, this.markers[marker.name], marker);
                        return true;
                    },
                    /**
     * Removes a marker from the sound.
     *
     * @method Phaser.Sound.BaseSound#removeMarker
     * @since 3.0.0
     *
     * @param {string} markerName - The name of the marker to remove.
     *
     * @return {?Phaser.Types.Sound.SoundMarker} Removed marker object or 'null' if there was no marker with provided name.
     */ removeMarker: function(markerName) {
                        var marker = this.markers[markerName];
                        if (!marker) return null;
                        this.markers[markerName] = null;
                        return marker;
                    },
                    /**
     * Play this sound, or a marked section of it.
     *
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * @method Phaser.Sound.BaseSound#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                        if (markerName === undefined) markerName = '';
                        if (typeof markerName === 'object') {
                            config = markerName;
                            markerName = '';
                        }
                        if (typeof markerName !== 'string') return false;
                        if (!markerName) {
                            this.currentMarker = null;
                            this.currentConfig = this.config;
                            this.duration = this.totalDuration;
                        } else {
                            if (!this.markers[markerName]) {
                                // eslint-disable-next-line no-console
                                console.warn('Marker: ' + markerName + ' missing in Sound: ' + this.key);
                                return false;
                            }
                            this.currentMarker = this.markers[markerName];
                            this.currentConfig = this.currentMarker.config;
                            this.duration = this.currentMarker.duration;
                        }
                        this.resetConfig();
                        this.currentConfig = Extend(this.currentConfig, config);
                        this.isPlaying = true;
                        this.isPaused = false;
                        return true;
                    },
                    /**
     * Pauses the sound. This only works if the sound is currently playing.
     *
     * You can inspect the `isPlaying` and `isPaused` properties to check the state.
     *
     * @method Phaser.Sound.BaseSound#pause
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                        if (this.isPaused || !this.isPlaying) return false;
                        this.isPlaying = false;
                        this.isPaused = true;
                        return true;
                    },
                    /**
     * Resumes the sound. This only works if the sound is paused and not already playing.
     *
     * You can inspect the `isPlaying` and `isPaused` properties to check the state.
     *
     * @method Phaser.Sound.BaseSound#resume
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                        if (!this.isPaused || this.isPlaying) return false;
                        this.isPlaying = true;
                        this.isPaused = false;
                        return true;
                    },
                    /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.BaseSound#stop
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                        if (!this.isPaused && !this.isPlaying) return false;
                        this.isPlaying = false;
                        this.isPaused = false;
                        this.resetConfig();
                        return true;
                    },
                    /**
     * Method used internally for applying config values to some of the sound properties.
     *
     * @method Phaser.Sound.BaseSound#applyConfig
     * @since 3.0.0
     */ applyConfig: function() {
                        this.mute = this.currentConfig.mute;
                        this.volume = this.currentConfig.volume;
                        this.rate = this.currentConfig.rate;
                        this.detune = this.currentConfig.detune;
                        this.loop = this.currentConfig.loop;
                        this.pan = this.currentConfig.pan;
                    },
                    /**
     * Method used internally for resetting values of some of the config properties.
     *
     * @method Phaser.Sound.BaseSound#resetConfig
     * @since 3.0.0
     */ resetConfig: function() {
                        this.currentConfig.seek = 0;
                        this.currentConfig.delay = 0;
                    },
                    /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.BaseSound#update
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: NOOP,
                    /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.BaseSound#calculateRate
     * @since 3.0.0
     */ calculateRate: function() {
                        var cent = 1.0005777895065548; // Math.pow(2, 1/1200);
                        var totalDetune = this.currentConfig.detune + this.manager.detune;
                        var detuneRate = Math.pow(cent, totalDetune);
                        this.totalRate = this.currentConfig.rate * this.manager.rate * detuneRate;
                    },
                    /**
     * Destroys this sound and all associated events and marks it for removal from the sound manager.
     *
     * @method Phaser.Sound.BaseSound#destroy
     * @fires Phaser.Sound.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                        if (this.pendingRemove) return;
                        this.stop();
                        this.emit(Events.DESTROY, this);
                        this.removeAllListeners();
                        this.pendingRemove = true;
                        this.manager = null;
                        this.config = null;
                        this.currentConfig = null;
                        this.markers = null;
                        this.currentMarker = null;
                    }
                });
                module1.exports = BaseSound;
            /***/ },
            /***/ 85034: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Clone = __webpack_require__(41786);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(14463);
                var GameEvents = __webpack_require__(8443);
                var GetAll = __webpack_require__(46710);
                var GetFirst = __webpack_require__(58731);
                var NOOP = __webpack_require__(29747);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * Base class for other Sound Manager classes.
 *
 * @class BaseSoundManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 *
 * @see Phaser.Sound.HTML5AudioSoundManager
 * @see Phaser.Sound.NoAudioSoundManager
 * @see Phaser.Sound.WebAudioSoundManager
 */ var BaseSoundManager = new Class({
                    Extends: EventEmitter,
                    initialize: function BaseSoundManager(game) {
                        EventEmitter.call(this);
                        /**
         * Local reference to game.
         *
         * @name Phaser.Sound.BaseSoundManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                        /**
         * Local reference to the JSON Cache, as used by Audio Sprites.
         *
         * @name Phaser.Sound.BaseSoundManager#jsonCache
         * @type {Phaser.Cache.BaseCache}
         * @readonly
         * @since 3.7.0
         */ this.jsonCache = game.cache.json;
                        /**
         * An array containing all added sounds.
         *
         * @name Phaser.Sound.BaseSoundManager#sounds
         * @type {Phaser.Sound.BaseSound[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.sounds = [];
                        /**
         * Global mute setting.
         *
         * @name Phaser.Sound.BaseSoundManager#mute
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.mute = false;
                        /**
         * Global volume setting.
         *
         * @name Phaser.Sound.BaseSoundManager#volume
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.volume = 1;
                        /**
         * Flag indicating if sounds should be paused when game looses focus,
         * for instance when user switches to another tab/program/app.
         *
         * @name Phaser.Sound.BaseSoundManager#pauseOnBlur
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.pauseOnBlur = true;
                        /**
         * Property that actually holds the value of global playback rate.
         *
         * @name Phaser.Sound.BaseSoundManager#_rate
         * @type {number}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._rate = 1;
                        /**
         * Property that actually holds the value of global detune.
         *
         * @name Phaser.Sound.BaseSoundManager#_detune
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._detune = 0;
                        /**
         * Mobile devices require sounds to be triggered from an explicit user action,
         * such as a tap, before any sound can be loaded/played on a web page.
         * Set to true if the audio system is currently locked awaiting user interaction.
         *
         * @name Phaser.Sound.BaseSoundManager#locked
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.locked = this.locked || false;
                        /**
         * Flag used internally for handling when the audio system
         * has been unlocked, if there ever was a need for it.
         *
         * @name Phaser.Sound.BaseSoundManager#unlocked
         * @type {boolean}
         * @default false
         * @private
         * @since 3.0.0
         */ this.unlocked = false;
                        /**
         * Flag used to track if the game has lost focus.
         *
         * @name Phaser.Sound.BaseSoundManager#gameLostFocus
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.gameLostFocus = false;
                        /**
         * The Spatial Audio listener position.
         *
         * Only available with WebAudio.
         *
         * You can modify the x/y properties of this Vec2 directly to
         * adjust the listener position within the game world.
         *
         * @name Phaser.Sound.BaseSoundManager#listenerPosition
         * @type {Phaser.Math.Vector2}
         * @since 3.60.0
         */ this.listenerPosition = new Vector2();
                        var ee = game.events;
                        ee.on(GameEvents.BLUR, this.onGameBlur, this);
                        ee.on(GameEvents.FOCUS, this.onGameFocus, this);
                        ee.on(GameEvents.PRE_STEP, this.update, this);
                        ee.once(GameEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.BaseSoundManager#add
     * @override
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.BaseSound} The new sound instance.
     */ add: NOOP,
                    /**
     * Adds a new audio sprite sound into the sound manager.
     * Audio Sprites are a combination of audio files and a JSON configuration.
     * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
     *
     * @method Phaser.Sound.BaseSoundManager#addAudioSprite
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {(Phaser.Sound.NoAudioSound|Phaser.Sound.HTML5AudioSound|Phaser.Sound.WebAudioSound)} The new audio sprite sound instance.
     */ addAudioSprite: function(key, config) {
                        if (config === undefined) config = {};
                        var sound = this.add(key, config);
                        sound.spritemap = this.jsonCache.get(key).spritemap;
                        for(var markerName in sound.spritemap){
                            if (!sound.spritemap.hasOwnProperty(markerName)) continue;
                            var markerConfig = Clone(config);
                            var marker = sound.spritemap[markerName];
                            markerConfig.loop = marker.hasOwnProperty('loop') ? marker.loop : false;
                            sound.addMarker({
                                name: markerName,
                                start: marker.start,
                                duration: marker.end - marker.start,
                                config: markerConfig
                            });
                        }
                        return sound;
                    },
                    /**
     * Gets the first sound in this Sound Manager that matches the given key.
     * If none can be found it returns `null`.
     *
     * @method Phaser.Sound.BaseSoundManager#get
     * @since 3.23.0
     *
     * @generic {Phaser.Sound.BaseSound} T
     * @genericUse {T} - [$return]
     *
     * @param {string} key - Sound asset key.
     *
     * @return {?Phaser.Sound.BaseSound} - The sound, or null.
     */ get: function(key) {
                        return GetFirst(this.sounds, 'key', key);
                    },
                    /**
     * Gets all sounds in this Sound Manager.
     *
     * You can optionally specify a key, in which case only Sound instances that match the given key
     * will be returned.
     *
     * @method Phaser.Sound.BaseSoundManager#getAll
     * @since 3.23.0
     *
     * @generic {Phaser.Sound.BaseSound} T
     * @genericUse {T[]} - [$return]
     *
     * @param {string} [key] - Optional asset key. If given, only Sound instances with this key will be returned.
     *
     * @return {Phaser.Sound.BaseSound[]} - The sounds, or an empty array.
     */ getAll: function(key) {
                        if (key) return GetAll(this.sounds, 'key', key);
                        else return GetAll(this.sounds);
                    },
                    /**
     * Returns all sounds from this Sound Manager that are currently
     * playing. That is, Sound instances that have their `isPlaying`
     * property set to `true`.
     *
     * @method Phaser.Sound.BaseSoundManager#getAllPlaying
     * @since 3.60.0
     *
     * @generic {Phaser.Sound.BaseSound} T
     * @genericUse {T[]} - [$return]
     *
     * @return {Phaser.Sound.BaseSound[]} - All currently playing sounds, or an empty array.
     */ getAllPlaying: function() {
                        return GetAll(this.sounds, 'isPlaying', true);
                    },
                    /**
     * Adds a new sound to the sound manager and plays it.
     *
     * The sound will be automatically removed (destroyed) once playback ends.
     *
     * This lets you play a new sound on the fly without the need to keep a reference to it.
     *
     * @method Phaser.Sound.BaseSoundManager#play
     * @listens Phaser.Sound.Events#COMPLETE
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {(Phaser.Types.Sound.SoundConfig|Phaser.Types.Sound.SoundMarker)} [extra] - An optional additional object containing settings to be applied to the sound. It could be either config or marker object.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(key, extra) {
                        var sound = this.add(key);
                        sound.once(Events.COMPLETE, sound.destroy, sound);
                        if (extra) {
                            if (extra.name) {
                                sound.addMarker(extra);
                                return sound.play(extra.name);
                            } else return sound.play(extra);
                        } else return sound.play();
                    },
                    /**
     * Adds a new audio sprite sound to the sound manager and plays it.
     * The sprite will be automatically removed (destroyed) once playback ends.
     * This lets you play a new sound on the fly without the need to keep a reference to it.
     *
     * @method Phaser.Sound.BaseSoundManager#playAudioSprite
     * @listens Phaser.Sound.Events#COMPLETE
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {string} spriteName - The name of the sound sprite to play.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {boolean} Whether the audio sprite sound started playing successfully.
     */ playAudioSprite: function(key, spriteName, config) {
                        var sound = this.addAudioSprite(key);
                        sound.once(Events.COMPLETE, sound.destroy, sound);
                        return sound.play(spriteName, config);
                    },
                    /**
     * Removes a sound from the sound manager.
     * The removed sound is destroyed before removal.
     *
     * @method Phaser.Sound.BaseSoundManager#remove
     * @since 3.0.0
     *
     * @param {Phaser.Sound.BaseSound} sound - The sound object to remove.
     *
     * @return {boolean} True if the sound was removed successfully, otherwise false.
     */ remove: function(sound) {
                        var index = this.sounds.indexOf(sound);
                        if (index !== -1) {
                            sound.destroy();
                            this.sounds.splice(index, 1);
                            return true;
                        }
                        return false;
                    },
                    /**
     * Removes all sounds from the manager, destroying the sounds.
     *
     * @method Phaser.Sound.BaseSoundManager#removeAll
     * @since 3.23.0
     */ removeAll: function() {
                        this.sounds.forEach(function(sound) {
                            sound.destroy();
                        });
                        this.sounds.length = 0;
                    },
                    /**
     * Removes all sounds from the sound manager that have an asset key matching the given value.
     * The removed sounds are destroyed before removal.
     *
     * @method Phaser.Sound.BaseSoundManager#removeByKey
     * @since 3.0.0
     *
     * @param {string} key - The key to match when removing sound objects.
     *
     * @return {number} The number of matching sound objects that were removed.
     */ removeByKey: function(key) {
                        var removed = 0;
                        for(var i = this.sounds.length - 1; i >= 0; i--){
                            var sound = this.sounds[i];
                            if (sound.key === key) {
                                sound.destroy();
                                this.sounds.splice(i, 1);
                                removed++;
                            }
                        }
                        return removed;
                    },
                    /**
     * Pauses all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#pauseAll
     * @fires Phaser.Sound.Events#PAUSE_ALL
     * @since 3.0.0
     */ pauseAll: function() {
                        this.forEachActiveSound(function(sound) {
                            sound.pause();
                        });
                        this.emit(Events.PAUSE_ALL, this);
                    },
                    /**
     * Resumes all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#resumeAll
     * @fires Phaser.Sound.Events#RESUME_ALL
     * @since 3.0.0
     */ resumeAll: function() {
                        this.forEachActiveSound(function(sound) {
                            sound.resume();
                        });
                        this.emit(Events.RESUME_ALL, this);
                    },
                    /**
     * Sets the X and Y position of the Spatial Audio listener on this Web Audios context.
     *
     * If you call this method with no parameters it will default to the center-point of
     * the game canvas. Depending on the type of game you're making, you may need to call
     * this method constantly to reset the listener position as the camera scrolls.
     *
     * Calling this method does nothing on HTML5Audio.
     *
     * @method Phaser.Sound.BaseSoundManager#setListenerPosition
     * @since 3.60.0
     *
     * @param {number} [x] - The x position of the Spatial Audio listener.
     * @param {number} [y] - The y position of the Spatial Audio listener.
     */ setListenerPosition: NOOP,
                    /**
     * Stops all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#stopAll
     * @fires Phaser.Sound.Events#STOP_ALL
     * @since 3.0.0
     */ stopAll: function() {
                        this.forEachActiveSound(function(sound) {
                            sound.stop();
                        });
                        this.emit(Events.STOP_ALL, this);
                    },
                    /**
     * Stops any sounds matching the given key.
     *
     * @method Phaser.Sound.BaseSoundManager#stopByKey
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {number} - How many sounds were stopped.
     */ stopByKey: function(key) {
                        var stopped = 0;
                        this.getAll(key).forEach(function(sound) {
                            if (sound.stop()) stopped++;
                        });
                        return stopped;
                    },
                    /**
     * When a key is given, returns true if any sound with that key is playing.
     *
     * When no key is given, returns true if any sound is playing.
     *
     * @method Phaser.Sound.BaseSoundManager#isPlaying
     * @since 3.85.0
     *
     * @param {?string} key - Sound asset key.
     *
     * @return {boolean} - Per the key argument, true if any matching sound is playing, otherwise false.
     */ isPlaying: function(key) {
                        var sounds = this.sounds;
                        var i = sounds.length - 1;
                        var sound;
                        if (key === undefined) for(; i >= 0; i--){
                            sound = this.sounds[i];
                            if (sound.isPlaying) return true;
                        }
                        else for(; i >= 0; i--){
                            sound = this.sounds[i];
                            if (sound.key === key && sound.isPlaying) return true;
                        }
                        return false;
                    },
                    /**
     * Method used internally for unlocking audio playback on devices that
     * require user interaction before any sound can be played on a web page.
     *
     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
     *
     * @method Phaser.Sound.BaseSoundManager#unlock
     * @override
     * @protected
     * @since 3.0.0
     */ unlock: NOOP,
                    /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.BaseSoundManager#onBlur
     * @override
     * @protected
     * @since 3.0.0
     */ onBlur: NOOP,
                    /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.BaseSoundManager#onFocus
     * @override
     * @protected
     * @since 3.0.0
     */ onFocus: NOOP,
                    /**
     * Internal handler for Phaser.Core.Events#BLUR.
     *
     * @method Phaser.Sound.BaseSoundManager#onGameBlur
     * @private
     * @since 3.23.0
     */ onGameBlur: function() {
                        this.gameLostFocus = true;
                        if (this.pauseOnBlur) this.onBlur();
                    },
                    /**
     * Internal handler for Phaser.Core.Events#FOCUS.
     *
     * @method Phaser.Sound.BaseSoundManager#onGameFocus
     * @private
     * @since 3.23.0
     */ onGameFocus: function() {
                        this.gameLostFocus = false;
                        if (this.pauseOnBlur) this.onFocus();
                    },
                    /**
     * Update method called on every game step.
     * Removes destroyed sounds and updates every active sound in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#update
     * @protected
     * @fires Phaser.Sound.Events#UNLOCKED
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: function(time, delta) {
                        if (this.unlocked) {
                            this.unlocked = false;
                            this.locked = false;
                            this.emit(Events.UNLOCKED, this);
                        }
                        for(var i = this.sounds.length - 1; i >= 0; i--)if (this.sounds[i].pendingRemove) this.sounds.splice(i, 1);
                        this.sounds.forEach(function(sound) {
                            sound.update(time, delta);
                        });
                    },
                    /**
     * Destroys all the sounds in the game and all associated events.
     *
     * @method Phaser.Sound.BaseSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.game.events.off(GameEvents.BLUR, this.onGameBlur, this);
                        this.game.events.off(GameEvents.FOCUS, this.onGameFocus, this);
                        this.game.events.off(GameEvents.PRE_STEP, this.update, this);
                        this.removeAllListeners();
                        this.removeAll();
                        this.sounds.length = 0;
                        this.sounds = null;
                        this.listenerPosition = null;
                        this.game = null;
                    },
                    /**
     * Method used internally for iterating only over active sounds and skipping sounds that are marked for removal.
     *
     * @method Phaser.Sound.BaseSoundManager#forEachActiveSound
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.EachActiveSoundCallback} callback - Callback function. (manager: Phaser.Sound.BaseSoundManager, sound: Phaser.Sound.BaseSound, index: number, sounds: Phaser.Manager.BaseSound[]) => void
     * @param {*} [scope] - Callback context.
     */ forEachActiveSound: function(callback, scope) {
                        var _this = this;
                        this.sounds.forEach(function(sound, index) {
                            if (sound && !sound.pendingRemove) callback.call(scope || _this, sound, index, _this.sounds);
                        });
                    },
                    /**
     * Sets the global playback rate at which all the sounds will be played.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.BaseSoundManager#setRate
     * @fires Phaser.Sound.Events#GLOBAL_RATE
     * @since 3.3.0
     *
     * @param {number} value - Global playback rate at which all the sounds will be played.
     *
     * @return {this} This Sound Manager.
     */ setRate: function(value) {
                        this.rate = value;
                        return this;
                    },
                    /**
     * Global playback rate at which all the sounds will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audio's playback speed.
     *
     * @name Phaser.Sound.BaseSoundManager#rate
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ rate: {
                        get: function() {
                            return this._rate;
                        },
                        set: function(value) {
                            this._rate = value;
                            this.forEachActiveSound(function(sound) {
                                sound.calculateRate();
                            });
                            this.emit(Events.GLOBAL_RATE, this, value);
                        }
                    },
                    /**
     * Sets the global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.BaseSoundManager#setDetune
     * @fires Phaser.Sound.Events#GLOBAL_DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound Manager.
     */ setDetune: function(value) {
                        this.detune = value;
                        return this;
                    },
                    /**
     * Global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.BaseSoundManager#detune
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ detune: {
                        get: function() {
                            return this._detune;
                        },
                        set: function(value) {
                            this._detune = value;
                            this.forEachActiveSound(function(sound) {
                                sound.calculateRate();
                            });
                            this.emit(Events.GLOBAL_DETUNE, this, value);
                        }
                    }
                });
                module1.exports = BaseSoundManager;
            /***/ },
            /***/ 14747: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HTML5AudioSoundManager = __webpack_require__(33684);
                var NoAudioSoundManager = __webpack_require__(25960);
                var WebAudioSoundManager = __webpack_require__(57490);
                /**
 * Creates a Web Audio, HTML5 Audio or No Audio Sound Manager based on config and device settings.
 *
 * Be aware of https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
 *
 * @function Phaser.Sound.SoundManagerCreator
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 *
 * @return {(Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager|Phaser.Sound.NoAudioSoundManager)} The Sound Manager instance that was created.
 */ var SoundManagerCreator = {
                    create: function(game) {
                        var audioConfig = game.config.audio;
                        var deviceAudio = game.device.audio;
                        if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) return new NoAudioSoundManager(game);
                        if (deviceAudio.webAudio && !audioConfig.disableWebAudio) return new WebAudioSoundManager(game);
                        return new HTML5AudioSoundManager(game);
                    }
                };
                module1.exports = SoundManagerCreator;
            /***/ },
            /***/ 19723: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Complete Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they complete playback.
 *
 * Listen to it from a Sound instance using `Sound.on('complete', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('complete', listener);
 * music.play();
 * ```
 *
 * @event Phaser.Sound.Events#COMPLETE
 * @type {string}
 * @since 3.16.1
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'complete';
            /***/ },
            /***/ 98882: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Audio Data Decoded All Event.
 *
 * This event is dispatched by the Web Audio Sound Manager as a result of calling the `decodeAudio` method,
 * once all files passed to the method have been decoded (or errored).
 *
 * Use `Phaser.Sound.Events#DECODED` to listen for single sounds being decoded, and `DECODED_ALL` to
 * listen for them all completing.
 *
 * Listen to it from the Sound Manager in a Scene using `this.sound.on('decodedall', listener)`, i.e.:
 *
 * ```javascript
 * this.sound.once('decodedall', handler);
 * this.sound.decodeAudio([ audioFiles ]);
 * ```
 *
 * @event Phaser.Sound.Events#DECODED_ALL
 * @type {string}
 * @since 3.18.0
 */ module1.exports = 'decodedall';
            /***/ },
            /***/ 57506: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Audio Data Decoded Event.
 *
 * This event is dispatched by the Web Audio Sound Manager as a result of calling the `decodeAudio` method.
 *
 * Listen to it from the Sound Manager in a Scene using `this.sound.on('decoded', listener)`, i.e.:
 *
 * ```javascript
 * this.sound.on('decoded', handler);
 * this.sound.decodeAudio(key, audioData);
 * ```
 *
 * @event Phaser.Sound.Events#DECODED
 * @type {string}
 * @since 3.18.0
 *
 * @param {string} key - The key of the audio file that was decoded and added to the audio cache.
 */ module1.exports = 'decoded';
            /***/ },
            /***/ 73146: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Destroy Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are destroyed, either
 * directly or via a Sound Manager.
 *
 * Listen to it from a Sound instance using `Sound.on('destroy', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('destroy', listener);
 * music.destroy();
 * ```
 *
 * @event Phaser.Sound.Events#DESTROY
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'destroy';
            /***/ },
            /***/ 11305: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Detune Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their detune value changes.
 *
 * Listen to it from a Sound instance using `Sound.on('detune', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('detune', listener);
 * music.play();
 * music.setDetune(200);
 * ```
 *
 * @event Phaser.Sound.Events#DETUNE
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} detune - The new detune value of the Sound.
 */ module1.exports = 'detune';
            /***/ },
            /***/ 40577: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Detune Event.
 *
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `detune` property of the Sound Manager is changed, which globally
 * adjusts the detuning of all active sounds.
 *
 * Listen to it from a Scene using: `this.sound.on('rate', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_DETUNE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} detune - The updated detune value.
 */ module1.exports = 'detune';
            /***/ },
            /***/ 30333: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Mute Event.
 *
 * This event is dispatched by the Sound Manager when its `mute` property is changed, either directly
 * or via the `setMute` method. This changes the mute state of all active sounds.
 *
 * Listen to it from a Scene using: `this.sound.on('mute', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_MUTE
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the Sound Manager that emitted the event.
 * @param {boolean} mute - The mute value. `true` if the Sound Manager is now muted, otherwise `false`.
 */ module1.exports = 'mute';
            /***/ },
            /***/ 20394: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Rate Event.
 *
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `rate` property of the Sound Manager is changed, which globally
 * adjusts the playback rate of all active sounds.
 *
 * Listen to it from a Scene using: `this.sound.on('rate', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_RATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} rate - The updated rate value.
 */ module1.exports = 'rate';
            /***/ },
            /***/ 21802: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Volume Event.
 *
 * This event is dispatched by the Sound Manager when its `volume` property is changed, either directly
 * or via the `setVolume` method. This changes the volume of all active sounds.
 *
 * Listen to it from a Scene using: `this.sound.on('volume', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_VOLUME
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} volume - The new global volume of the Sound Manager.
 */ module1.exports = 'volume';
            /***/ },
            /***/ 1299: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Looped Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they loop during playback.
 *
 * Listen to it from a Sound instance using `Sound.on('looped', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('looped', listener);
 * music.setLoop(true);
 * music.play();
 * ```
 *
 * This is not to be confused with the [LOOP]{@linkcode Phaser.Sound.Events#event:LOOP} event, which only emits when the loop state of a Sound is changed.
 *
 * @event Phaser.Sound.Events#LOOPED
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'looped';
            /***/ },
            /***/ 99190: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Loop Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their loop state is changed.
 *
 * Listen to it from a Sound instance using `Sound.on('loop', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('loop', listener);
 * music.setLoop(true);
 * ```
 *
 * This is not to be confused with the [LOOPED]{@linkcode Phaser.Sound.Events#event:LOOPED} event, which emits each time a Sound loops during playback.
 *
 * @event Phaser.Sound.Events#LOOP
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {boolean} loop - The new loop value. `true` if the Sound will loop, otherwise `false`.
 */ module1.exports = 'loop';
            /***/ },
            /***/ 97125: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Mute Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their mute state changes.
 *
 * Listen to it from a Sound instance using `Sound.on('mute', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('mute', listener);
 * music.play();
 * music.setMute(true);
 * ```
 *
 * @event Phaser.Sound.Events#MUTE
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {boolean} mute - The mute value. `true` if the Sound is now muted, otherwise `false`.
 */ module1.exports = 'mute';
            /***/ },
            /***/ 89259: /***/ (module1)=>{
                /**
 * @author       pi-kei
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Pan Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their pan changes.
 *
 * Listen to it from a Sound instance using `Sound.on('pan', listener)`, i.e.:
 *
 * ```javascript
 * var sound = this.sound.add('key');
 * sound.on('pan', listener);
 * sound.play();
 * sound.setPan(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#PAN
 * @type {string}
 * @since 3.50.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} pan - The new pan of the Sound.
 */ module1.exports = 'pan';
            /***/ },
            /***/ 79986: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pause All Sounds Event.
 *
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `pauseAll` method is invoked and after all current Sounds
 * have been paused.
 *
 * Listen to it from a Scene using: `this.sound.on('pauseall', listener)`.
 *
 * @event Phaser.Sound.Events#PAUSE_ALL
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'pauseall';
            /***/ },
            /***/ 17586: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Pause Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are paused.
 *
 * Listen to it from a Sound instance using `Sound.on('pause', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('pause', listener);
 * music.play();
 * music.pause();
 * ```
 *
 * @event Phaser.Sound.Events#PAUSE
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'pause';
            /***/ },
            /***/ 19618: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Play Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are played.
 *
 * Listen to it from a Sound instance using `Sound.on('play', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('play', listener);
 * music.play();
 * ```
 *
 * @event Phaser.Sound.Events#PLAY
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'play';
            /***/ },
            /***/ 42306: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Rate Change Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their rate changes.
 *
 * Listen to it from a Sound instance using `Sound.on('rate', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('rate', listener);
 * music.play();
 * music.setRate(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#RATE
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} rate - The new rate of the Sound.
 */ module1.exports = 'rate';
            /***/ },
            /***/ 10387: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Resume All Sounds Event.
 *
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `resumeAll` method is invoked and after all current Sounds
 * have been resumed.
 *
 * Listen to it from a Scene using: `this.sound.on('resumeall', listener)`.
 *
 * @event Phaser.Sound.Events#RESUME_ALL
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'resumeall';
            /***/ },
            /***/ 48959: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Resume Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are resumed from a paused state.
 *
 * Listen to it from a Sound instance using `Sound.on('resume', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('resume', listener);
 * music.play();
 * music.pause();
 * music.resume();
 * ```
 *
 * @event Phaser.Sound.Events#RESUME
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'resume';
            /***/ },
            /***/ 9960: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Seek Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are seeked to a new position.
 *
 * Listen to it from a Sound instance using `Sound.on('seek', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('seek', listener);
 * music.play();
 * music.setSeek(5000);
 * ```
 *
 * @event Phaser.Sound.Events#SEEK
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} detune - The new detune value of the Sound.
 */ module1.exports = 'seek';
            /***/ },
            /***/ 19180: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Stop All Sounds Event.
 *
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `stopAll` method is invoked and after all current Sounds
 * have been stopped.
 *
 * Listen to it from a Scene using: `this.sound.on('stopall', listener)`.
 *
 * @event Phaser.Sound.Events#STOP_ALL
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'stopall';
            /***/ },
            /***/ 98328: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Stop Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are stopped.
 *
 * Listen to it from a Sound instance using `Sound.on('stop', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('stop', listener);
 * music.play();
 * music.stop();
 * ```
 *
 * @event Phaser.Sound.Events#STOP
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'stop';
            /***/ },
            /***/ 50401: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Unlocked Event.
 *
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched during the update loop when the Sound Manager becomes unlocked. For
 * Web Audio this is on the first user gesture on the page.
 *
 * Listen to it from a Scene using: `this.sound.on('unlocked', listener)`.
 *
 * @event Phaser.Sound.Events#UNLOCKED
 * @type {string}
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'unlocked';
            /***/ },
            /***/ 52498: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Volume Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their volume changes.
 *
 * Listen to it from a Sound instance using `Sound.on('volume', listener)`, i.e.:
 *
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('volume', listener);
 * music.play();
 * music.setVolume(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#VOLUME
 * @type {string}
 * @since 3.0.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} volume - The new volume of the Sound.
 */ module1.exports = 'volume';
            /***/ },
            /***/ 14463: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Sound.Events
 */ module1.exports = {
                    COMPLETE: __webpack_require__(19723),
                    DECODED: __webpack_require__(57506),
                    DECODED_ALL: __webpack_require__(98882),
                    DESTROY: __webpack_require__(73146),
                    DETUNE: __webpack_require__(11305),
                    GLOBAL_DETUNE: __webpack_require__(40577),
                    GLOBAL_MUTE: __webpack_require__(30333),
                    GLOBAL_RATE: __webpack_require__(20394),
                    GLOBAL_VOLUME: __webpack_require__(21802),
                    LOOP: __webpack_require__(99190),
                    LOOPED: __webpack_require__(1299),
                    MUTE: __webpack_require__(97125),
                    PAN: __webpack_require__(89259),
                    PAUSE_ALL: __webpack_require__(79986),
                    PAUSE: __webpack_require__(17586),
                    PLAY: __webpack_require__(19618),
                    RATE: __webpack_require__(42306),
                    RESUME_ALL: __webpack_require__(10387),
                    RESUME: __webpack_require__(48959),
                    SEEK: __webpack_require__(9960),
                    STOP_ALL: __webpack_require__(19180),
                    STOP: __webpack_require__(98328),
                    UNLOCKED: __webpack_require__(50401),
                    VOLUME: __webpack_require__(52498)
                };
            /***/ },
            /***/ 64895: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(30341);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(14463);
                var Clamp = __webpack_require__(45319);
                /**
 * @classdesc
 * HTML5 Audio implementation of the sound.
 *
 * @class HTML5AudioSound
 * @extends Phaser.Sound.BaseSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.HTML5AudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var HTML5AudioSound = new Class({
                    Extends: BaseSound,
                    initialize: function HTML5AudioSound(manager, key, config) {
                        if (config === undefined) config = {};
                        /**
         * An array containing all HTML5 Audio tags that could be used for individual
         * sound playback. Number of instances depends on the config value passed
         * to the `Loader#audio` method call, default is 1.
         *
         * @name Phaser.Sound.HTML5AudioSound#tags
         * @type {HTMLAudioElement[]}
         * @since 3.0.0
         */ this.tags = manager.game.cache.audio.get(key);
                        if (!this.tags) throw new Error('No cached audio asset with key "' + key);
                        /**
         * Reference to an HTML5 Audio tag used for playing sound.
         *
         * @name Phaser.Sound.HTML5AudioSound#audio
         * @type {HTMLAudioElement}
         * @default null
         * @since 3.0.0
         */ this.audio = null;
                        /**
         * Timestamp as generated by the Request Animation Frame or SetTimeout
         * representing the time at which the delayed sound playback should start.
         * Set to 0 if sound playback is not delayed.
         *
         * @name Phaser.Sound.HTML5AudioSound#startTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                        /**
         * Audio tag's playback position recorded on previous
         * update method call. Set to 0 if sound is not playing.
         *
         * @name Phaser.Sound.HTML5AudioSound#previousTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.previousTime = 0;
                        this.duration = this.tags[0].duration;
                        this.totalDuration = this.tags[0].duration;
                        BaseSound.call(this, manager, key, config);
                    },
                    /**
     * Play this sound, or a marked section of it.
     *
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * If you want to play the same sound simultaneously, then you need to create another instance
     * of it and play that Sound. For HTML5 Audio this also requires creating multiple audio instances
     * when loading the audio files.
     *
     * @method Phaser.Sound.HTML5AudioSound#play
     * @fires Phaser.Sound.Events#PLAY
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                        if (this.manager.isLocked(this, 'play', [
                            markerName,
                            config
                        ])) return false;
                        if (!BaseSound.prototype.play.call(this, markerName, config)) return false;
                        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                        if (!this.pickAndPlayAudioTag()) return false;
                        this.emit(Events.PLAY, this);
                        return true;
                    },
                    /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#pause
     * @fires Phaser.Sound.Events#PAUSE
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                        if (this.manager.isLocked(this, 'pause')) return false;
                        if (this.startTime > 0) return false;
                        if (!BaseSound.prototype.pause.call(this)) return false;
                        //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
                        this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                        this.stopAndReleaseAudioTag();
                        this.emit(Events.PAUSE, this);
                        return true;
                    },
                    /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#resume
     * @fires Phaser.Sound.Events#RESUME
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                        if (this.manager.isLocked(this, 'resume')) return false;
                        if (this.startTime > 0) return false;
                        if (!BaseSound.prototype.resume.call(this)) return false;
                        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                        if (!this.pickAndPlayAudioTag()) return false;
                        this.emit(Events.RESUME, this);
                        return true;
                    },
                    /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#stop
     * @fires Phaser.Sound.Events#STOP
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                        if (this.manager.isLocked(this, 'stop')) return false;
                        if (!BaseSound.prototype.stop.call(this)) return false;
                        //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
                        this.stopAndReleaseAudioTag();
                        this.emit(Events.STOP, this);
                        return true;
                    },
                    /**
     * This method is used internally to pick and play the next available audio tag.
     *
     * @method Phaser.Sound.HTML5AudioSound#pickAndPlayAudioTag
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was assigned an audio tag successfully.
     */ pickAndPlayAudioTag: function() {
                        if (!this.pickAudioTag()) {
                            this.reset();
                            return false;
                        }
                        var seek = this.currentConfig.seek;
                        var delay = this.currentConfig.delay;
                        var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
                        this.previousTime = offset;
                        this.audio.currentTime = offset;
                        this.applyConfig();
                        if (delay === 0) {
                            this.startTime = 0;
                            if (this.audio.paused) this.playCatchPromise();
                        } else {
                            this.startTime = window.performance.now() + delay * 1000;
                            if (!this.audio.paused) this.audio.pause();
                        }
                        this.resetConfig();
                        return true;
                    },
                    /**
     * This method performs the audio tag pooling logic. It first looks for
     * unused audio tag to assign to this sound object. If there are no unused
     * audio tags, based on HTML5AudioSoundManager#override property value, it
     * looks for sound with most advanced playback and hijacks its audio tag or
     * does nothing.
     *
     * @method Phaser.Sound.HTML5AudioSound#pickAudioTag
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was assigned an audio tag successfully.
     */ pickAudioTag: function() {
                        if (this.audio) return true;
                        for(var i = 0; i < this.tags.length; i++){
                            var audio = this.tags[i];
                            if (audio.dataset.used === 'false') {
                                audio.dataset.used = 'true';
                                this.audio = audio;
                                return true;
                            }
                        }
                        if (!this.manager.override) return false;
                        var otherSounds = [];
                        this.manager.forEachActiveSound(function(sound) {
                            if (sound.key === this.key && sound.audio) otherSounds.push(sound);
                        }, this);
                        otherSounds.sort(function(a1, a2) {
                            if (a1.loop === a2.loop) // sort by progress
                            return a2.seek / a2.duration - a1.seek / a1.duration;
                            return a1.loop ? 1 : -1;
                        });
                        var selectedSound = otherSounds[0];
                        this.audio = selectedSound.audio;
                        selectedSound.reset();
                        selectedSound.audio = null;
                        selectedSound.startTime = 0;
                        selectedSound.previousTime = 0;
                        return true;
                    },
                    /**
     * Method used for playing audio tag and catching possible exceptions
     * thrown from rejected Promise returned from play method call.
     *
     * @method Phaser.Sound.HTML5AudioSound#playCatchPromise
     * @since 3.0.0
     */ playCatchPromise: function() {
                        var playPromise = this.audio.play();
                        if (playPromise) // eslint-disable-next-line no-unused-vars
                        playPromise.catch(function(reason) {
                            console.warn(reason);
                        });
                    },
                    /**
     * This method is used internally to stop and release the current audio tag.
     *
     * @method Phaser.Sound.HTML5AudioSound#stopAndReleaseAudioTag
     * @since 3.0.0
     */ stopAndReleaseAudioTag: function() {
                        this.startTime = 0;
                        this.previousTime = 0;
                        if (this.audio) {
                            this.audio.pause();
                            this.audio.dataset.used = 'false';
                            this.audio = null;
                        }
                    },
                    /**
     * Method used internally to reset sound state, usually when stopping sound
     * or when hijacking audio tag from another sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#reset
     * @since 3.0.0
     */ reset: function() {
                        BaseSound.prototype.stop.call(this);
                    },
                    /**
     * Method used internally by sound manager for pausing sound if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSound#onBlur
     * @since 3.0.0
     */ onBlur: function() {
                        this.isPlaying = false;
                        this.isPaused = true;
                        this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                        this.currentConfig.delay = Math.max(0, (this.startTime - window.performance.now()) / 1000);
                        this.stopAndReleaseAudioTag();
                    },
                    /**
     * Method used internally by sound manager for resuming sound if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSound#onFocus
     * @since 3.0.0
     */ onFocus: function() {
                        this.isPlaying = true;
                        this.isPaused = false;
                        this.pickAndPlayAudioTag();
                    },
                    /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.HTML5AudioSound#update
     * @fires Phaser.Sound.Events#COMPLETE
     * @fires Phaser.Sound.Events#LOOPED
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     */ update: function(time) {
                        if (!this.isPlaying) return;
                        // handling delayed playback
                        if (this.startTime > 0) {
                            if (this.startTime < time - this.manager.audioPlayDelay) {
                                this.audio.currentTime += Math.max(0, time - this.startTime) / 1000;
                                this.startTime = 0;
                                this.previousTime = this.audio.currentTime;
                                this.playCatchPromise();
                            }
                            return;
                        }
                        // handle looping and ending
                        var startTime = this.currentMarker ? this.currentMarker.start : 0;
                        var endTime = startTime + this.duration;
                        var currentTime = this.audio.currentTime;
                        if (this.currentConfig.loop) {
                            if (currentTime >= endTime - this.manager.loopEndOffset) {
                                this.audio.currentTime = startTime + Math.max(0, currentTime - endTime);
                                currentTime = this.audio.currentTime;
                            } else if (currentTime < startTime) {
                                this.audio.currentTime += startTime;
                                currentTime = this.audio.currentTime;
                            }
                            if (currentTime < this.previousTime) this.emit(Events.LOOPED, this);
                        } else if (currentTime >= endTime) {
                            this.reset();
                            this.stopAndReleaseAudioTag();
                            this.emit(Events.COMPLETE, this);
                            return;
                        }
                        this.previousTime = currentTime;
                    },
                    /**
     * Calls Phaser.Sound.BaseSound#destroy method
     * and cleans up all HTML5 Audio related stuff.
     *
     * @method Phaser.Sound.HTML5AudioSound#destroy
     * @since 3.0.0
     */ destroy: function() {
                        BaseSound.prototype.destroy.call(this);
                        this.tags = null;
                        if (this.audio) this.stopAndReleaseAudioTag();
                    },
                    /**
     * This method is used internally to update the mute setting of this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#updateMute
     * @since 3.0.0
     */ updateMute: function() {
                        if (this.audio) this.audio.muted = this.currentConfig.mute || this.manager.mute;
                    },
                    /**
     * This method is used internally to update the volume of this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#updateVolume
     * @since 3.0.0
     */ updateVolume: function() {
                        if (this.audio) this.audio.volume = Clamp(this.currentConfig.volume * this.manager.volume, 0, 1);
                    },
                    /**
     * This method is used internally to update the playback rate of this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#calculateRate
     * @since 3.0.0
     */ calculateRate: function() {
                        BaseSound.prototype.calculateRate.call(this);
                        if (this.audio) this.audio.playbackRate = this.totalRate;
                    },
                    /**
     * Boolean indicating whether the sound is muted or not.
     * Gets or sets the muted state of this sound.
     *
     * @name Phaser.Sound.HTML5AudioSound#mute
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.0.0
     */ mute: {
                        get: function() {
                            return this.currentConfig.mute;
                        },
                        set: function(value) {
                            this.currentConfig.mute = value;
                            if (this.manager.isLocked(this, 'mute', value)) return;
                            this.updateMute();
                            this.emit(Events.MUTE, this, value);
                        }
                    },
                    /**
     * Sets the muted state of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setMute
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
     *
     * @return {this} This Sound instance.
     */ setMute: function(value) {
                        this.mute = value;
                        return this;
                    },
                    /**
     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
     *
     * @name Phaser.Sound.HTML5AudioSound#volume
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.0.0
     */ volume: {
                        get: function() {
                            return this.currentConfig.volume;
                        },
                        set: function(value) {
                            this.currentConfig.volume = value;
                            if (this.manager.isLocked(this, 'volume', value)) return;
                            this.updateVolume();
                            this.emit(Events.VOLUME, this, value);
                        }
                    },
                    /**
     * Sets the volume of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setVolume
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.4.0
     *
     * @param {number} value - The volume of the sound.
     *
     * @return {this} This Sound instance.
     */ setVolume: function(value) {
                        this.volume = value;
                        return this;
                    },
                    /**
     * Rate at which this Sound will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @name Phaser.Sound.HTML5AudioSound#rate
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#RATE
     * @since 3.0.0
     */ rate: {
                        get: function() {
                            return this.currentConfig.rate;
                        },
                        set: function(value) {
                            this.currentConfig.rate = value;
                            if (this.manager.isLocked(this, Events.RATE, value)) return;
                            else {
                                this.calculateRate();
                                this.emit(Events.RATE, this, value);
                            }
                        }
                    },
                    /**
     * Sets the playback rate of this Sound.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.HTML5AudioSound#setRate
     * @fires Phaser.Sound.Events#RATE
     * @since 3.3.0
     *
     * @param {number} value - The playback rate at of this Sound.
     *
     * @return {this} This Sound instance.
     */ setRate: function(value) {
                        this.rate = value;
                        return this;
                    },
                    /**
     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.HTML5AudioSound#detune
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.0.0
     */ detune: {
                        get: function() {
                            return this.currentConfig.detune;
                        },
                        set: function(value) {
                            this.currentConfig.detune = value;
                            if (this.manager.isLocked(this, Events.DETUNE, value)) return;
                            else {
                                this.calculateRate();
                                this.emit(Events.DETUNE, this, value);
                            }
                        }
                    },
                    /**
     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.HTML5AudioSound#setDetune
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound instance.
     */ setDetune: function(value) {
                        this.detune = value;
                        return this;
                    },
                    /**
     * Property representing the position of playback for this sound, in seconds.
     * Setting it to a specific value moves current playback to that position.
     * The value given is clamped to the range 0 to current marker duration.
     * Setting seek of a stopped sound has no effect.
     *
     * @name Phaser.Sound.HTML5AudioSound#seek
     * @type {number}
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.0.0
     */ seek: {
                        get: function() {
                            if (this.isPlaying) return this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                            else if (this.isPaused) return this.currentConfig.seek;
                            else return 0;
                        },
                        set: function(value) {
                            if (this.manager.isLocked(this, 'seek', value)) return;
                            if (this.startTime > 0) return;
                            if (this.isPlaying || this.isPaused) {
                                value = Math.min(Math.max(0, value), this.duration);
                                if (this.isPlaying) {
                                    this.previousTime = value;
                                    this.audio.currentTime = value;
                                } else if (this.isPaused) this.currentConfig.seek = value;
                                this.emit(Events.SEEK, this, value);
                            }
                        }
                    },
                    /**
     * Seeks to a specific point in this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setSeek
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.4.0
     *
     * @param {number} value - The point in the sound to seek to.
     *
     * @return {this} This Sound instance.
     */ setSeek: function(value) {
                        this.seek = value;
                        return this;
                    },
                    /**
     * Flag indicating whether or not the sound or current sound marker will loop.
     *
     * @name Phaser.Sound.HTML5AudioSound#loop
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.0.0
     */ loop: {
                        get: function() {
                            return this.currentConfig.loop;
                        },
                        set: function(value) {
                            this.currentConfig.loop = value;
                            if (this.manager.isLocked(this, 'loop', value)) return;
                            if (this.audio) this.audio.loop = value;
                            this.emit(Events.LOOP, this, value);
                        }
                    },
                    /**
     * Sets the loop state of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setLoop
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
     *
     * @return {Phaser.Sound.HTML5AudioSound} This Sound instance.
     */ setLoop: function(value) {
                        this.loop = value;
                        return this;
                    },
                    /**
     * Gets or sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Has no audible effect on HTML5 Audio Sound, but still generates the PAN Event.
     *
     * @name Phaser.Sound.HTML5AudioSound#pan
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     */ pan: {
                        get: function() {
                            return this.currentConfig.pan;
                        },
                        set: function(value) {
                            this.currentConfig.pan = value;
                            this.emit(Events.PAN, this, value);
                        }
                    },
                    /**
     * Sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Has no audible effect on HTML5 Audio Sound, but still generates the PAN Event.
     *
     * @method Phaser.Sound.HTML5AudioSound#setPan
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     *
     * @param {number} value - The pan of the sound. A value between -1 (full left pan) and 1 (full right pan).
     *
     * @return {this} This Sound instance.
     */ setPan: function(value) {
                        this.pan = value;
                        return this;
                    }
                });
                module1.exports = HTML5AudioSound;
            /***/ },
            /***/ 33684: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSoundManager = __webpack_require__(85034);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(14463);
                var HTML5AudioSound = __webpack_require__(64895);
                /**
 * HTML5 Audio implementation of the Sound Manager.
 *
 * To play multiple instances of the same HTML5 Audio sound, you need to provide an `instances` value when
 * loading the sound with the Loader:
 *
 * ```javascript
 * this.load.audio('explosion', 'explosion.mp3', {
 *     instances: 2
 * });
 * ```
 *
 * Not all browsers can play all audio formats.
 *
 * There is a good guide to what's supported: [Cross-browser audio basics: Audio codec support](https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/Cross-browser_audio_basics#Audio_Codec_Support).
 *
 * @class HTML5AudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var HTML5AudioSoundManager = new Class({
                    Extends: BaseSoundManager,
                    initialize: function HTML5AudioSoundManager(game) {
                        /**
         * Flag indicating whether if there are no idle instances of HTML5 Audio tag,
         * for any particular sound, if one of the used tags should be hijacked and used
         * for succeeding playback or if succeeding Phaser.Sound.HTML5AudioSound#play
         * call should be ignored.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#override
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.override = true;
                        /**
         * Value representing time difference, in seconds, between calling
         * play method on an audio tag and when it actually starts playing.
         * It is used to achieve more accurate delayed sound playback.
         *
         * You might need to tweak this value to get the desired results
         * since audio play delay varies depending on the browser/platform.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#audioPlayDelay
         * @type {number}
         * @default 0.1
         * @since 3.0.0
         */ this.audioPlayDelay = 0.1;
                        /**
         * A value by which we should offset the loop end marker of the
         * looping sound to compensate for lag, caused by changing audio
         * tag playback position, in order to achieve gapless looping.
         *
         * You might need to tweak this value to get the desired results
         * since loop lag varies depending on the browser/platform.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#loopEndOffset
         * @type {number}
         * @default 0.05
         * @since 3.0.0
         */ this.loopEndOffset = 0.05;
                        /**
         * An array for keeping track of all the sounds
         * that were paused when game lost focus.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#onBlurPausedSounds
         * @type {Phaser.Sound.HTML5AudioSound[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this.onBlurPausedSounds = [];
                        this.locked = 'ontouchstart' in window;
                        /**
         * A queue of all actions performed on sound objects while audio was locked.
         * Once the audio gets unlocked, after an explicit user interaction,
         * all actions will be performed in chronological order.
         * Array of object types: { sound: Phaser.Sound.HTML5AudioSound, name: string, value?: * }
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#lockedActionsQueue
         * @type {array}
         * @private
         * @since 3.0.0
         */ this.lockedActionsQueue = this.locked ? [] : null;
                        /**
         * Property that actually holds the value of global mute
         * for HTML5 Audio sound manager implementation.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#_mute
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._mute = false;
                        /**
         * Property that actually holds the value of global volume
         * for HTML5 Audio sound manager implementation.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#_volume
         * @type {boolean}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._volume = 1;
                        BaseSoundManager.call(this, game);
                    },
                    /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#add
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.HTML5AudioSound} The new sound instance.
     */ add: function(key, config) {
                        var sound = new HTML5AudioSound(this, key, config);
                        this.sounds.push(sound);
                        return sound;
                    },
                    /**
     * Unlocks HTML5 Audio loading and playback on mobile
     * devices on the initial explicit user interaction.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#unlock
     * @since 3.0.0
     */ unlock: function() {
                        this.locked = false;
                        var _this = this;
                        this.game.cache.audio.entries.each(function(key, tags) {
                            for(var i = 0; i < tags.length; i++)if (tags[i].dataset.locked === 'true') {
                                _this.locked = true;
                                return false;
                            }
                            return true;
                        });
                        if (!this.locked) return;
                        var moved = false;
                        var detectMove = function() {
                            moved = true;
                        };
                        var unlock = function() {
                            if (moved) {
                                moved = false;
                                return;
                            }
                            document.body.removeEventListener('touchmove', detectMove);
                            document.body.removeEventListener('touchend', unlock);
                            var lockedTags = [];
                            _this.game.cache.audio.entries.each(function(key, tags) {
                                for(var i = 0; i < tags.length; i++){
                                    var tag = tags[i];
                                    if (tag.dataset.locked === 'true') lockedTags.push(tag);
                                }
                                return true;
                            });
                            if (lockedTags.length === 0) return;
                            var lastTag = lockedTags[lockedTags.length - 1];
                            lastTag.oncanplaythrough = function() {
                                lastTag.oncanplaythrough = null;
                                lockedTags.forEach(function(tag) {
                                    tag.dataset.locked = 'false';
                                });
                                _this.unlocked = true;
                            };
                            lockedTags.forEach(function(tag) {
                                tag.load();
                            });
                        };
                        this.once(Events.UNLOCKED, function() {
                            this.forEachActiveSound(function(sound) {
                                if (sound.currentMarker === null && sound.duration === 0) sound.duration = sound.tags[0].duration;
                                sound.totalDuration = sound.tags[0].duration;
                            });
                            while(this.lockedActionsQueue.length){
                                var lockedAction = this.lockedActionsQueue.shift();
                                if (lockedAction.sound[lockedAction.prop].apply) lockedAction.sound[lockedAction.prop].apply(lockedAction.sound, lockedAction.value || []);
                                else lockedAction.sound[lockedAction.prop] = lockedAction.value;
                            }
                        }, this);
                        document.body.addEventListener('touchmove', detectMove, false);
                        document.body.addEventListener('touchend', unlock, false);
                    },
                    /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                        this.forEachActiveSound(function(sound) {
                            if (sound.isPlaying) {
                                this.onBlurPausedSounds.push(sound);
                                sound.onBlur();
                            }
                        });
                    },
                    /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                        this.onBlurPausedSounds.forEach(function(sound) {
                            sound.onFocus();
                        });
                        this.onBlurPausedSounds.length = 0;
                    },
                    /**
     * Calls Phaser.Sound.BaseSoundManager#destroy method
     * and cleans up all HTML5 Audio related stuff.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        BaseSoundManager.prototype.destroy.call(this);
                        this.onBlurPausedSounds.length = 0;
                        this.onBlurPausedSounds = null;
                    },
                    /**
     * Method used internally by Phaser.Sound.HTML5AudioSound class methods and property setters
     * to check if sound manager is locked and then either perform action immediately or queue it
     * to be performed once the sound manager gets unlocked.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#isLocked
     * @protected
     * @since 3.0.0
     *
     * @param {Phaser.Sound.HTML5AudioSound} sound - Sound object on which to perform queued action.
     * @param {string} prop - Name of the method to be called or property to be assigned a value to.
     * @param {*} [value] - An optional parameter that either holds an array of arguments to be passed to the method call or value to be set to the property.
     *
     * @return {boolean} Whether the sound manager is locked.
     */ isLocked: function(sound, prop, value) {
                        if (sound.tags[0].dataset.locked === 'true') {
                            this.lockedActionsQueue.push({
                                sound: sound,
                                prop: prop,
                                value: value
                            });
                            return true;
                        }
                        return false;
                    },
                    /**
     * Sets the muted state of all this Sound Manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#setMute
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.3.0
     *
     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
     *
     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
     */ setMute: function(value) {
                        this.mute = value;
                        return this;
                    },
                    /**
     * @name Phaser.Sound.HTML5AudioSoundManager#mute
     * @type {boolean}
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.0.0
     */ mute: {
                        get: function() {
                            return this._mute;
                        },
                        set: function(value) {
                            this._mute = value;
                            this.forEachActiveSound(function(sound) {
                                sound.updateMute();
                            });
                            this.emit(Events.GLOBAL_MUTE, this, value);
                        }
                    },
                    /**
     * Sets the volume of this Sound Manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#setVolume
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.3.0
     *
     * @param {number} value - The global volume of this Sound Manager.
     *
     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
     */ setVolume: function(value) {
                        this.volume = value;
                        return this;
                    },
                    /**
     * @name Phaser.Sound.HTML5AudioSoundManager#volume
     * @type {number}
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.0.0
     */ volume: {
                        get: function() {
                            return this._volume;
                        },
                        set: function(value) {
                            this._volume = value;
                            this.forEachActiveSound(function(sound) {
                                sound.updateVolume();
                            });
                            this.emit(Events.GLOBAL_VOLUME, this, value);
                        }
                    }
                });
                module1.exports = HTML5AudioSoundManager;
            /***/ },
            /***/ 23717: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Sound
 */ module1.exports = {
                    SoundManagerCreator: __webpack_require__(14747),
                    Events: __webpack_require__(14463),
                    BaseSound: __webpack_require__(30341),
                    BaseSoundManager: __webpack_require__(85034),
                    WebAudioSound: __webpack_require__(71741),
                    WebAudioSoundManager: __webpack_require__(57490),
                    HTML5AudioSound: __webpack_require__(64895),
                    HTML5AudioSoundManager: __webpack_require__(33684),
                    NoAudioSound: __webpack_require__(4603),
                    NoAudioSoundManager: __webpack_require__(25960)
                };
            /***/ },
            /***/ 4603: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(30341);
                var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Extend = __webpack_require__(79291);
                var NOOP = __webpack_require__(29747);
                var returnFalse = function() {
                    return false;
                };
                var returnNull = function() {
                    return null;
                };
                var returnThis = function() {
                    return this;
                };
                /**
 * @classdesc
 * No audio implementation of the sound. It is used if audio has been
 * disabled in the game config or the device doesn't support any audio.
 *
 * It represents a graceful degradation of sound logic that provides
 * minimal functionality and prevents Phaser projects that use audio from
 * breaking on devices that don't support any audio playback technologies.
 *
 * @class NoAudioSound
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.NoAudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var NoAudioSound = new Class({
                    Extends: EventEmitter,
                    initialize: function NoAudioSound(manager, key, config) {
                        if (config === void 0) config = {};
                        EventEmitter.call(this);
                        /**
         * Local reference to the sound manager.
         *
         * @name Phaser.Sound.NoAudioSound#manager
         * @type {Phaser.Sound.BaseSoundManager}
         * @since 3.0.0
         */ this.manager = manager;
                        /**
         * Asset key for the sound.
         *
         * @name Phaser.Sound.NoAudioSound#key
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.key = key;
                        /**
         * Flag indicating if sound is currently playing.
         *
         * @name Phaser.Sound.NoAudioSound#isPlaying
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPlaying = false;
                        /**
         * Flag indicating if sound is currently paused.
         *
         * @name Phaser.Sound.NoAudioSound#isPaused
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPaused = false;
                        /**
         * A property that holds the value of sound's actual playback rate,
         * after its rate and detune values has been combined with global
         * rate and detune values.
         *
         * @name Phaser.Sound.NoAudioSound#totalRate
         * @type {number}
         * @default 1
         * @readonly
         * @since 3.0.0
         */ this.totalRate = 1;
                        /**
         * A value representing the duration, in seconds.
         * It could be total sound duration or a marker duration.
         *
         * @name Phaser.Sound.NoAudioSound#duration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.duration = 0;
                        /**
         * The total duration of the sound in seconds.
         *
         * @name Phaser.Sound.NoAudioSound#totalDuration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.totalDuration = 0;
                        /**
         * A config object used to store default sound settings' values.
         * Default values will be set by properties' setters.
         *
         * @name Phaser.Sound.NoAudioSound#config
         * @type {Phaser.Types.Sound.SoundConfig}
         * @since 3.0.0
         */ this.config = Extend({
                            mute: false,
                            volume: 1,
                            rate: 1,
                            detune: 0,
                            seek: 0,
                            loop: false,
                            delay: 0,
                            pan: 0
                        }, config);
                        /**
         * Reference to the currently used config.
         * It could be default config or marker config.
         *
         * @name Phaser.Sound.NoAudioSound#currentConfig
         * @type {Phaser.Types.Sound.SoundConfig}
         * @since 3.0.0
         */ this.currentConfig = this.config;
                        /**
         * Boolean indicating whether the sound is muted or not.
         * Gets or sets the muted state of this sound.
         *
         * @name Phaser.Sound.NoAudioSound#mute
         * @type {boolean}
         * @default false
         * @fires Phaser.Sound.Events#MUTE
         * @since 3.0.0
         */ this.mute = false;
                        /**
         * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
         *
         * @name Phaser.Sound.NoAudioSound#volume
         * @type {number}
         * @default 1
         * @fires Phaser.Sound.Events#VOLUME
         * @since 3.0.0
         */ this.volume = 1;
                        /**
         * Rate at which this Sound will be played.
         * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
         * and 2.0 doubles the audios playback speed.
         *
         * @name Phaser.Sound.NoAudioSound#rate
         * @type {number}
         * @default 1
         * @fires Phaser.Sound.Events#RATE
         * @since 3.0.0
         */ this.rate = 1;
                        /**
         * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
         * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
         *
         * @name Phaser.Sound.NoAudioSound#detune
         * @type {number}
         * @default 0
         * @fires Phaser.Sound.Events#DETUNE
         * @since 3.0.0
         */ this.detune = 0;
                        /**
         * Property representing the position of playback for this sound, in seconds.
         * Setting it to a specific value moves current playback to that position.
         * The value given is clamped to the range 0 to current marker duration.
         * Setting seek of a stopped sound has no effect.
         *
         * @name Phaser.Sound.NoAudioSound#seek
         * @type {number}
         * @fires Phaser.Sound.Events#SEEK
         * @since 3.0.0
         */ this.seek = 0;
                        /**
         * Flag indicating whether or not the sound or current sound marker will loop.
         *
         * @name Phaser.Sound.NoAudioSound#loop
         * @type {boolean}
         * @default false
         * @fires Phaser.Sound.Events#LOOP
         * @since 3.0.0
         */ this.loop = false;
                        /**
         * Gets or sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
         *
         * Always returns zero on iOS / Safari as it doesn't support the stereo panner node.
         *
         * @name Phaser.Sound.NoAudioSound#pan
         * @type {number}
         * @default 0
         * @fires Phaser.Sound.Events#PAN
         * @since 3.50.0
         */ this.pan = 0;
                        /**
         * Object containing markers definitions.
         *
         * @name Phaser.Sound.NoAudioSound#markers
         * @type {Object.<string, Phaser.Types.Sound.SoundMarker>}
         * @default {}
         * @readonly
         * @since 3.0.0
         */ this.markers = {};
                        /**
         * Currently playing marker.
         * 'null' if whole sound is playing.
         *
         * @name Phaser.Sound.NoAudioSound#currentMarker
         * @type {Phaser.Types.Sound.SoundMarker}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.currentMarker = null;
                        /**
         * Flag indicating if destroy method was called on this sound.
         *
         * @name Phaser.Sound.NoAudioSound#pendingRemove
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pendingRemove = false;
                    },
                    /**
     * @method Phaser.Sound.NoAudioSound#addMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object.
     *
     * @return {boolean} false
     */ addMarker: returnFalse,
                    /**
     * @method Phaser.Sound.NoAudioSound#updateMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object with updated values.
     *
     * @return {boolean} false
     */ updateMarker: returnFalse,
                    /**
     * @method Phaser.Sound.NoAudioSound#removeMarker
     * @since 3.0.0
     *
     * @param {string} markerName - The name of the marker to remove.
     *
     * @return {null} null
     */ removeMarker: returnNull,
                    /**
     * @method Phaser.Sound.NoAudioSound#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} false
     */ play: returnFalse,
                    /**
     * @method Phaser.Sound.NoAudioSound#pause
     * @since 3.0.0
     *
     * @return {boolean} false
     */ pause: returnFalse,
                    /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.NoAudioSound#resume
     * @since 3.0.0
     *
     * @return {boolean} false
     */ resume: returnFalse,
                    /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.NoAudioSound#stop
     * @since 3.0.0
     *
     * @return {boolean} false
     */ stop: returnFalse,
                    /**
     * Sets the muted state of this Sound.
     *
     * @method Phaser.Sound.NoAudioSound#setMute
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
     *
     * @return {this} This Sound instance.
     */ setMute: returnThis,
                    /**
     * Sets the volume of this Sound.
     *
     * @method Phaser.Sound.NoAudioSound#setVolume
     * @since 3.4.0
     *
     * @param {number} value - The volume of the sound.
     *
     * @return {this} This Sound instance.
     */ setVolume: returnThis,
                    /**
     * Sets the playback rate of this Sound.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.NoAudioSound#setRate
     * @since 3.3.0
     *
     * @param {number} value - The playback rate at of this Sound.
     *
     * @return {this} This Sound instance.
     */ setRate: returnThis,
                    /**
     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.NoAudioSound#setDetune
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound instance.
     */ setDetune: returnThis,
                    /**
     * Seeks to a specific point in this sound.
     *
     * @method Phaser.Sound.NoAudioSound#setSeek
     * @since 3.4.0
     *
     * @param {number} value - The point in the sound to seek to.
     *
     * @return {this} This Sound instance.
     */ setSeek: returnThis,
                    /**
     * Sets the loop state of this Sound.
     *
     * @method Phaser.Sound.NoAudioSound#setLoop
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
     *
     * @return {this} This Sound instance.
     */ setLoop: returnThis,
                    /**
     * Sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Note: iOS / Safari doesn't support the stereo panner node.
     *
     * @method Phaser.Sound.NoAudioSound#setPan
     * @since 3.50.0
     *
     * @param {number} value - The pan of the sound. A value between -1 (full left pan) and 1 (full right pan).
     *
     * @return {this} This Sound instance.
     */ setPan: returnThis,
                    /**
     * Method used internally for applying config values to some of the sound properties.
     *
     * @method Phaser.Sound.NoAudioSound#applyConfig
     * @since 3.0.0
     */ applyConfig: returnNull,
                    /**
     * Method used internally for resetting values of some of the config properties.
     *
     * @method Phaser.Sound.NoAudioSound#resetConfig
     * @since 3.0.0
     */ resetConfig: returnNull,
                    /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.NoAudioSound#update
     * @override
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: NOOP,
                    /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.NoAudioSound#calculateRate
     * @since 3.0.0
     */ calculateRate: returnNull,
                    /**
     * Destroys this sound and all associated events and marks it for removal from the sound manager.
     *
     * @method Phaser.Sound.NoAudioSound#destroy
     * @fires Phaser.Sound.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                        BaseSound.prototype.destroy.call(this);
                    }
                });
                module1.exports = NoAudioSound;
            /***/ },
            /***/ 25960: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSoundManager = __webpack_require__(85034);
                var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var NoAudioSound = __webpack_require__(4603);
                var NOOP = __webpack_require__(29747);
                /**
 * @classdesc
 * No-audio implementation of the Sound Manager. It is used if audio has been
 * disabled in the game config or the device doesn't support any audio.
 *
 * It represents a graceful degradation of Sound Manager logic that provides
 * minimal functionality and prevents Phaser projects that use audio from
 * breaking on devices that don't support any audio playback technologies.
 *
 * @class NoAudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var NoAudioSoundManager = new Class({
                    Extends: EventEmitter,
                    initialize: function NoAudioSoundManager(game) {
                        EventEmitter.call(this);
                        this.game = game;
                        this.sounds = [];
                        this.mute = false;
                        this.volume = 1;
                        this.rate = 1;
                        this.detune = 0;
                        this.pauseOnBlur = true;
                        this.locked = false;
                    },
                    /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#add
     * @since 3.60.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.NoAudioSound} The new sound instance.
     */ add: function(key, config) {
                        var sound = new NoAudioSound(this, key, config);
                        this.sounds.push(sound);
                        return sound;
                    },
                    /**
     * Adds a new audio sprite sound into the sound manager.
     * Audio Sprites are a combination of audio files and a JSON configuration.
     * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
     *
     * @method Phaser.Sound.NoAudioSoundManager#addAudioSprite
     * @since 3.60.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.NoAudioSound} The new audio sprite sound instance.
     */ addAudioSprite: function(key, config) {
                        var sound = this.add(key, config);
                        sound.spritemap = {};
                        return sound;
                    },
                    /**
     * Gets the first sound in the manager matching the given key, if any.
     *
     * @method Phaser.Sound.NoAudioSoundManager#get
     * @since 3.23.0
     *
     * @generic {Phaser.Sound.BaseSound} T
     * @genericUse {T} - [$return]
     *
     * @param {string} key - Sound asset key.
     *
     * @return {?Phaser.Sound.BaseSound} - The sound, or null.
     */ get: function(key) {
                        return BaseSoundManager.prototype.get.call(this, key);
                    },
                    /**
     * Gets any sounds in the manager matching the given key.
     *
     * @method Phaser.Sound.NoAudioSoundManager#getAll
     * @since 3.23.0
     *
     * @generic {Phaser.Sound.BaseSound} T
     * @genericUse {T[]} - [$return]
     *
     * @param {string} key - Sound asset key.
     *
     * @return {Phaser.Sound.BaseSound[]} - The sounds, or an empty array.
     */ getAll: function(key) {
                        return BaseSoundManager.prototype.getAll.call(this, key);
                    },
                    /**
     * This method does nothing but return 'false' for the No Audio Sound Manager, to maintain
     * compatibility with the other Sound Managers.
     *
     * @method Phaser.Sound.NoAudioSoundManager#play
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {(Phaser.Types.Sound.SoundConfig|Phaser.Types.Sound.SoundMarker)} [extra] - An optional additional object containing settings to be applied to the sound. It could be either config or marker object.
     *
     * @return {boolean} Always 'false' for the No Audio Sound Manager.
     */ // eslint-disable-next-line no-unused-vars
                    play: function(key, extra) {
                        return false;
                    },
                    /**
     * This method does nothing but return 'false' for the No Audio Sound Manager, to maintain
     * compatibility with the other Sound Managers.
     *
     * @method Phaser.Sound.NoAudioSoundManager#playAudioSprite
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {string} spriteName - The name of the sound sprite to play.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {boolean} Always 'false' for the No Audio Sound Manager.
     */ // eslint-disable-next-line no-unused-vars
                    playAudioSprite: function(key, spriteName, config) {
                        return false;
                    },
                    /**
     * Removes a sound from the sound manager.
     * The removed sound is destroyed before removal.
     *
     * @method Phaser.Sound.NoAudioSoundManager#remove
     * @since 3.0.0
     *
     * @param {Phaser.Sound.BaseSound} sound - The sound object to remove.
     *
     * @return {boolean} True if the sound was removed successfully, otherwise false.
     */ remove: function(sound) {
                        return BaseSoundManager.prototype.remove.call(this, sound);
                    },
                    /**
     * Removes all sounds from the manager, destroying the sounds.
     *
     * @method Phaser.Sound.NoAudioSoundManager#removeAll
     * @since 3.23.0
     */ removeAll: function() {
                        return BaseSoundManager.prototype.removeAll.call(this);
                    },
                    /**
     * Removes all sounds from the sound manager that have an asset key matching the given value.
     * The removed sounds are destroyed before removal.
     *
     * @method Phaser.Sound.NoAudioSoundManager#removeByKey
     * @since 3.0.0
     *
     * @param {string} key - The key to match when removing sound objects.
     *
     * @return {number} The number of matching sound objects that were removed.
     */ removeByKey: function(key) {
                        return BaseSoundManager.prototype.removeByKey.call(this, key);
                    },
                    /**
     * Stops any sounds matching the given key.
     *
     * @method Phaser.Sound.NoAudioSoundManager#stopByKey
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {number} - How many sounds were stopped.
     */ stopByKey: function(key) {
                        return BaseSoundManager.prototype.stopByKey.call(this, key);
                    },
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#onBlur
     * @since 3.0.0
     */ onBlur: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#onFocus
     * @since 3.0.0
     */ onFocus: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#onGameBlur
     * @since 3.0.0
     */ onGameBlur: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#onGameFocus
     * @since 3.0.0
     */ onGameFocus: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#pauseAll
     * @since 3.0.0
     */ pauseAll: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#resumeAll
     * @since 3.0.0
     */ resumeAll: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#stopAll
     * @since 3.0.0
     */ stopAll: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#update
     * @since 3.0.0
     */ update: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#setRate
     * @since 3.0.0
     *
     * @return {this} This Sound Manager.
     */ setRate: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#setDetune
     * @since 3.0.0
     *
     * @return {this} This Sound Manager.
     */ setDetune: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#setMute
     * @since 3.0.0
     */ setMute: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#setVolume
     * @since 3.0.0
     */ setVolume: NOOP,
                    /**
     * Empty function for the No Audio Sound Manager.
     *
     * @method Phaser.Sound.NoAudioSoundManager#unlock
     * @since 3.0.0
     */ unlock: NOOP,
                    /**
     * Method used internally for iterating only over active sounds and skipping sounds that are marked for removal.
     *
     * @method Phaser.Sound.NoAudioSoundManager#forEachActiveSound
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.EachActiveSoundCallback} callback - Callback function. (manager: Phaser.Sound.BaseSoundManager, sound: Phaser.Sound.BaseSound, index: number, sounds: Phaser.Manager.BaseSound[]) => void
     * @param {*} [scope] - Callback context.
     */ forEachActiveSound: function(callbackfn, scope) {
                        BaseSoundManager.prototype.forEachActiveSound.call(this, callbackfn, scope);
                    },
                    /**
     * Destroys all the sounds in the game and all associated events.
     *
     * @method Phaser.Sound.NoAudioSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        BaseSoundManager.prototype.destroy.call(this);
                    }
                });
                module1.exports = NoAudioSoundManager;
            /***/ },
            /***/ 71741: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(30341);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(14463);
                var GetFastValue = __webpack_require__(95540);
                /**
 * @classdesc
 * Web Audio API implementation of the sound.
 *
 * @class WebAudioSound
 * @extends Phaser.Sound.BaseSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.WebAudioSoundManager} manager - Reference to the WebAudio Sound Manager that owns this Sound instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var WebAudioSound = new Class({
                    Extends: BaseSound,
                    initialize: function WebAudioSound(manager, key, config) {
                        if (config === undefined) config = {};
                        /**
         * Audio buffer containing decoded data of the audio asset to be played.
         *
         * @name Phaser.Sound.WebAudioSound#audioBuffer
         * @type {AudioBuffer}
         * @since 3.0.0
         */ this.audioBuffer = manager.game.cache.audio.get(key);
                        if (!this.audioBuffer) throw new Error('Audio key "' + key + '" not found in cache');
                        /**
         * A reference to an audio source node used for playing back audio from
         * audio data stored in Phaser.Sound.WebAudioSound#audioBuffer.
         *
         * @name Phaser.Sound.WebAudioSound#source
         * @type {AudioBufferSourceNode}
         * @default null
         * @since 3.0.0
         */ this.source = null;
                        /**
         * A reference to a second audio source used for gapless looped playback.
         *
         * @name Phaser.Sound.WebAudioSound#loopSource
         * @type {AudioBufferSourceNode}
         * @default null
         * @since 3.0.0
         */ this.loopSource = null;
                        /**
         * Gain node responsible for controlling this sound's muting.
         *
         * @name Phaser.Sound.WebAudioSound#muteNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.muteNode = manager.context.createGain();
                        /**
         * Gain node responsible for controlling this sound's volume.
         *
         * @name Phaser.Sound.WebAudioSound#volumeNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.volumeNode = manager.context.createGain();
                        /**
         * Panner node responsible for controlling this sound's pan.
         *
         * Doesn't work on iOS / Safari.
         *
         * @name Phaser.Sound.WebAudioSound#pannerNode
         * @type {StereoPannerNode}
         * @since 3.50.0
         */ this.pannerNode = null;
                        /**
         * The Stereo Spatial Panner node.
         *
         * @name Phaser.Sound.WebAudioSound#spatialNode
         * @type {PannerNode}
         * @since 3.60.0
         */ this.spatialNode = null;
                        /**
         * If the Spatial Panner node has been set to track a vector or
         * Game Object, this retains a reference to it.
         *
         * @name Phaser.Sound.WebAudioSound#spatialSource
         * @type {Phaser.Types.Math.Vector2Like}
         * @since 3.60.0
         */ this.spatialSource = null;
                        /**
         * The time at which the sound should have started playback from the beginning.
         *
         * Treat this property as read-only.
         *
         * Based on `BaseAudioContext.currentTime` value.
         *
         * @name Phaser.Sound.WebAudioSound#playTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.playTime = 0;
                        /**
         * The time at which the sound source should have actually started playback.
         *
         * Treat this property as read-only.
         *
         * Based on `BaseAudioContext.currentTime` value.
         *
         * @name Phaser.Sound.WebAudioSound#startTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                        /**
         * The time at which the sound loop source should actually start playback.
         *
         * Based on `BaseAudioContext.currentTime` value.
         *
         * @name Phaser.Sound.WebAudioSound#loopTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopTime = 0;
                        /**
         * An array where we keep track of all rate updates during playback.
         *
         * Treat this property as read-only.
         *
         * Array of object types: `{ time: number, rate: number }`
         *
         * @name Phaser.Sound.WebAudioSound#rateUpdates
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.rateUpdates = [];
                        /**
         * Used for keeping track when sound source playback has ended
         * so its state can be updated accordingly.
         *
         * @name Phaser.Sound.WebAudioSound#hasEnded
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.hasEnded = false;
                        /**
         * Used for keeping track when sound source has looped
         * so its state can be updated accordingly.
         *
         * @name Phaser.Sound.WebAudioSound#hasLooped
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.hasLooped = false;
                        this.muteNode.connect(this.volumeNode);
                        if (manager.context.createPanner) {
                            this.spatialNode = manager.context.createPanner();
                            this.volumeNode.connect(this.spatialNode);
                        }
                        if (manager.context.createStereoPanner) {
                            this.pannerNode = manager.context.createStereoPanner();
                            if (manager.context.createPanner) this.spatialNode.connect(this.pannerNode);
                            else this.volumeNode.connect(this.pannerNode);
                            this.pannerNode.connect(manager.destination);
                        } else if (manager.context.createPanner) this.spatialNode.connect(manager.destination);
                        else this.volumeNode.connect(manager.destination);
                        this.duration = this.audioBuffer.duration;
                        this.totalDuration = this.audioBuffer.duration;
                        BaseSound.call(this, manager, key, config);
                    },
                    /**
     * Play this sound, or a marked section of it.
     *
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * If you want to play the same sound simultaneously, then you need to create another instance
     * of it and play that Sound.
     *
     * @method Phaser.Sound.WebAudioSound#play
     * @fires Phaser.Sound.Events#PLAY
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                        if (!BaseSound.prototype.play.call(this, markerName, config)) return false;
                        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                        this.stopAndRemoveBufferSource();
                        this.createAndStartBufferSource();
                        this.emit(Events.PLAY, this);
                        return true;
                    },
                    /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.WebAudioSound#pause
     * @fires Phaser.Sound.Events#PAUSE
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                        if (this.manager.context.currentTime < this.startTime) return false;
                        if (!BaseSound.prototype.pause.call(this)) return false;
                        //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
                        this.currentConfig.seek = this.getCurrentTime(); // Equivalent to setting paused time
                        this.stopAndRemoveBufferSource();
                        this.emit(Events.PAUSE, this);
                        return true;
                    },
                    /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.WebAudioSound#resume
     * @fires Phaser.Sound.Events#RESUME
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                        if (this.manager.context.currentTime < this.startTime) return false;
                        if (!BaseSound.prototype.resume.call(this)) return false;
                        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                        this.createAndStartBufferSource();
                        this.emit(Events.RESUME, this);
                        return true;
                    },
                    /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.WebAudioSound#stop
     * @fires Phaser.Sound.Events#STOP
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                        if (!BaseSound.prototype.stop.call(this)) return false;
                        //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
                        this.stopAndRemoveBufferSource();
                        this.emit(Events.STOP, this);
                        return true;
                    },
                    /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#createAndStartBufferSource
     * @private
     * @since 3.0.0
     */ createAndStartBufferSource: function() {
                        var seek = this.currentConfig.seek;
                        var delay = this.currentConfig.delay;
                        var when = this.manager.context.currentTime + delay;
                        var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
                        var duration = this.duration - seek;
                        this.playTime = when - seek;
                        this.startTime = when;
                        this.source = this.createBufferSource();
                        this.applyConfig();
                        this.source.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
                        this.resetConfig();
                    },
                    /**
     * This method is only used internally and it creates a looping buffer source.
     *
     * @method Phaser.Sound.WebAudioSound#createAndStartLoopBufferSource
     * @since 3.0.0
     */ createAndStartLoopBufferSource: function() {
                        var when = this.getLoopTime();
                        var offset = this.currentMarker ? this.currentMarker.start : 0;
                        var duration = this.duration;
                        this.loopTime = when;
                        this.loopSource = this.createBufferSource();
                        this.loopSource.playbackRate.setValueAtTime(this.totalRate, 0);
                        this.loopSource.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
                    },
                    /**
     * This method is only used internally and it creates a buffer source.
     *
     * @method Phaser.Sound.WebAudioSound#createBufferSource
     * @since 3.0.0
     *
     * @return {AudioBufferSourceNode}
     */ createBufferSource: function() {
                        var _this = this;
                        var source = this.manager.context.createBufferSource();
                        source.buffer = this.audioBuffer;
                        source.connect(this.muteNode);
                        source.onended = function(ev) {
                            var target = ev.target;
                            if (target === _this.source || target === _this.loopSource) {
                                // sound ended
                                if (_this.currentConfig.loop) _this.hasLooped = true;
                                else _this.hasEnded = true;
                            }
                        // else was stopped
                        };
                        return source;
                    },
                    /**
     * This method is only used internally and it stops and removes a buffer source.
     *
     * @method Phaser.Sound.WebAudioSound#stopAndRemoveBufferSource
     * @since 3.0.0
     */ stopAndRemoveBufferSource: function() {
                        if (this.source) {
                            var tempSource = this.source;
                            this.source = null;
                            tempSource.stop();
                            tempSource.disconnect();
                        }
                        this.playTime = 0;
                        this.startTime = 0;
                        this.hasEnded = false;
                        this.stopAndRemoveLoopBufferSource();
                    },
                    /**
     * This method is only used internally and it stops and removes a looping buffer source.
     *
     * @method Phaser.Sound.WebAudioSound#stopAndRemoveLoopBufferSource
     * @since 3.0.0
     */ stopAndRemoveLoopBufferSource: function() {
                        if (this.loopSource) {
                            this.loopSource.stop();
                            this.loopSource.disconnect();
                            this.loopSource = null;
                        }
                        this.loopTime = 0;
                    },
                    /**
     * Method used internally for applying config values to some of the sound properties.
     *
     * @method Phaser.Sound.WebAudioSound#applyConfig
     * @since 3.0.0
     */ applyConfig: function() {
                        this.rateUpdates.length = 0;
                        this.rateUpdates.push({
                            time: 0,
                            rate: 1
                        });
                        var source = this.currentConfig.source;
                        if (source && this.manager.context.createPanner) {
                            var node = this.spatialNode;
                            node.panningModel = GetFastValue(source, 'panningModel', 'equalpower');
                            node.distanceModel = GetFastValue(source, 'distanceModel', 'inverse');
                            node.orientationX.value = GetFastValue(source, 'orientationX', 0);
                            node.orientationY.value = GetFastValue(source, 'orientationY', 0);
                            node.orientationZ.value = GetFastValue(source, 'orientationZ', -1);
                            node.refDistance = GetFastValue(source, 'refDistance', 1);
                            node.maxDistance = GetFastValue(source, 'maxDistance', 10000);
                            node.rolloffFactor = GetFastValue(source, 'rolloffFactor', 1);
                            node.coneInnerAngle = GetFastValue(source, 'coneInnerAngle', 360);
                            node.coneOuterAngle = GetFastValue(source, 'coneOuterAngle', 0);
                            node.coneOuterGain = GetFastValue(source, 'coneOuterGain', 0);
                            this.spatialSource = GetFastValue(source, 'follow', null);
                            if (!this.spatialSource) {
                                node.positionX.value = GetFastValue(source, 'x', 0);
                                node.positionY.value = GetFastValue(source, 'y', 0);
                                node.positionZ.value = GetFastValue(source, 'z', 0);
                            }
                        }
                        BaseSound.prototype.applyConfig.call(this);
                    },
                    /**
     * Sets the x position of this Sound in Spatial Audio space.
     *
     * This only has any effect if the sound was created with a SpatialSoundConfig object.
     *
     * Also see the `WebAudioSoundManager.setListenerPosition` method.
     *
     * If you find that the sound becomes too quiet, too quickly, as it moves away from
     * the listener, then try different `refDistance` property values when configuring
     * the spatial sound.
     *
     * @name Phaser.Sound.WebAudioSound#x
     * @type {number}
     * @since 3.60.0
     */ x: {
                        get: function() {
                            if (this.spatialNode) return this.spatialNode.positionX;
                            else return 0;
                        },
                        set: function(value) {
                            if (this.spatialNode) this.spatialNode.positionX.value = value;
                        }
                    },
                    /**
     * Sets the y position of this Sound in Spatial Audio space.
     *
     * This only has any effect if the sound was created with a SpatialSoundConfig object.
     *
     * Also see the `WebAudioSoundManager.setListenerPosition` method.
     *
     * If you find that the sound becomes too quiet, too quickly, as it moves away from
     * the listener, then try different `refDistance` property values when configuring
     * the spatial sound.
     *
     * @name Phaser.Sound.WebAudioSound#y
     * @type {number}
     * @since 3.60.0
     */ y: {
                        get: function() {
                            if (this.spatialNode) return this.spatialNode.positionY;
                            else return 0;
                        },
                        set: function(value) {
                            if (this.spatialNode) this.spatialNode.positionY.value = value;
                        }
                    },
                    /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.WebAudioSound#update
     * @fires Phaser.Sound.Events#COMPLETE
     * @fires Phaser.Sound.Events#LOOPED
     * @since 3.0.0
     */ update: function() {
                        if (this.isPlaying && this.spatialSource) {
                            var x = GetFastValue(this.spatialSource, 'x', null);
                            var y = GetFastValue(this.spatialSource, 'y', null);
                            if (x && x !== this._spatialx) this._spatialx = this.spatialNode.positionX.value = x;
                            if (y && y !== this._spatialy) this._spatialy = this.spatialNode.positionY.value = y;
                        }
                        if (this.hasEnded) {
                            BaseSound.prototype.stop.call(this);
                            this.stopAndRemoveBufferSource();
                            this.emit(Events.COMPLETE, this);
                        } else if (this.hasLooped) {
                            this.hasLooped = false;
                            this.source = this.loopSource;
                            this.loopSource = null;
                            this.playTime = this.startTime = this.loopTime;
                            this.rateUpdates.length = 0;
                            this.rateUpdates.push({
                                time: 0,
                                rate: this.totalRate
                            });
                            this.createAndStartLoopBufferSource();
                            this.emit(Events.LOOPED, this);
                        }
                    },
                    /**
     * Calls Phaser.Sound.BaseSound#destroy method
     * and cleans up all Web Audio API related stuff.
     *
     * @method Phaser.Sound.WebAudioSound#destroy
     * @since 3.0.0
     */ destroy: function() {
                        if (this.pendingRemove) return;
                        BaseSound.prototype.destroy.call(this);
                        this.audioBuffer = null;
                        this.stopAndRemoveBufferSource();
                        this.muteNode.disconnect();
                        this.muteNode = null;
                        this.volumeNode.disconnect();
                        this.volumeNode = null;
                        if (this.pannerNode) {
                            this.pannerNode.disconnect();
                            this.pannerNode = null;
                        }
                        if (this.spatialNode) {
                            this.spatialNode.disconnect();
                            this.spatialNode = null;
                            this.spatialSource = null;
                        }
                        this.rateUpdates.length = 0;
                        this.rateUpdates = null;
                    },
                    /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.WebAudioSound#calculateRate
     * @since 3.0.0
     */ calculateRate: function() {
                        BaseSound.prototype.calculateRate.call(this);
                        var now = this.manager.context.currentTime;
                        if (this.source && typeof this.totalRate === 'number') this.source.playbackRate.setValueAtTime(this.totalRate, now);
                        if (this.isPlaying) {
                            this.rateUpdates.push({
                                time: Math.max(this.startTime, now) - this.playTime,
                                rate: this.totalRate
                            });
                            if (this.loopSource) {
                                this.stopAndRemoveLoopBufferSource();
                                this.createAndStartLoopBufferSource();
                            }
                        }
                    },
                    /**
     * Method used internally for calculating current playback time of a playing sound.
     *
     * @method Phaser.Sound.WebAudioSound#getCurrentTime
     * @since 3.0.0
     */ getCurrentTime: function() {
                        var currentTime = 0;
                        for(var i = 0; i < this.rateUpdates.length; i++){
                            var nextTime = 0;
                            if (i < this.rateUpdates.length - 1) nextTime = this.rateUpdates[i + 1].time;
                            else nextTime = this.manager.context.currentTime - this.playTime;
                            currentTime += (nextTime - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
                        }
                        return currentTime;
                    },
                    /**
     * Method used internally for calculating the time
     * at witch the loop source should start playing.
     *
     * @method Phaser.Sound.WebAudioSound#getLoopTime
     * @since 3.0.0
     */ getLoopTime: function() {
                        var lastRateUpdateCurrentTime = 0;
                        for(var i = 0; i < this.rateUpdates.length - 1; i++)lastRateUpdateCurrentTime += (this.rateUpdates[i + 1].time - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
                        var lastRateUpdate = this.rateUpdates[this.rateUpdates.length - 1];
                        return this.playTime + lastRateUpdate.time + (this.duration - lastRateUpdateCurrentTime) / lastRateUpdate.rate;
                    },
                    /**
     * Rate at which this Sound will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @name Phaser.Sound.WebAudioSound#rate
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#RATE
     * @since 3.0.0
     */ rate: {
                        get: function() {
                            return this.currentConfig.rate;
                        },
                        set: function(value) {
                            this.currentConfig.rate = value;
                            this.calculateRate();
                            this.emit(Events.RATE, this, value);
                        }
                    },
                    /**
     * Sets the playback rate of this Sound.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.WebAudioSound#setRate
     * @fires Phaser.Sound.Events#RATE
     * @since 3.3.0
     *
     * @param {number} value - The playback rate at of this Sound.
     *
     * @return {this} This Sound instance.
     */ setRate: function(value) {
                        this.rate = value;
                        return this;
                    },
                    /**
     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.WebAudioSound#detune
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.0.0
     */ detune: {
                        get: function() {
                            return this.currentConfig.detune;
                        },
                        set: function(value) {
                            this.currentConfig.detune = value;
                            this.calculateRate();
                            this.emit(Events.DETUNE, this, value);
                        }
                    },
                    /**
     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.WebAudioSound#setDetune
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound instance.
     */ setDetune: function(value) {
                        this.detune = value;
                        return this;
                    },
                    /**
     * Boolean indicating whether the sound is muted or not.
     * Gets or sets the muted state of this sound.
     *
     * @name Phaser.Sound.WebAudioSound#mute
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.0.0
     */ mute: {
                        get: function() {
                            return this.muteNode.gain.value === 0;
                        },
                        set: function(value) {
                            this.currentConfig.mute = value;
                            this.muteNode.gain.setValueAtTime(value ? 0 : 1, 0);
                            this.emit(Events.MUTE, this, value);
                        }
                    },
                    /**
     * Sets the muted state of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setMute
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
     *
     * @return {this} This Sound instance.
     */ setMute: function(value) {
                        this.mute = value;
                        return this;
                    },
                    /**
     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
     *
     * @name Phaser.Sound.WebAudioSound#volume
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.0.0
     */ volume: {
                        get: function() {
                            return this.volumeNode.gain.value;
                        },
                        set: function(value) {
                            this.currentConfig.volume = value;
                            this.volumeNode.gain.setValueAtTime(value, 0);
                            this.emit(Events.VOLUME, this, value);
                        }
                    },
                    /**
     * Sets the volume of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setVolume
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.4.0
     *
     * @param {number} value - The volume of the sound.
     *
     * @return {this} This Sound instance.
     */ setVolume: function(value) {
                        this.volume = value;
                        return this;
                    },
                    /**
     * Property representing the position of playback for this sound, in seconds.
     * Setting it to a specific value moves current playback to that position.
     * The value given is clamped to the range 0 to current marker duration.
     * Setting seek of a stopped sound has no effect.
     *
     * @name Phaser.Sound.WebAudioSound#seek
     * @type {number}
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.0.0
     */ seek: {
                        get: function() {
                            if (this.isPlaying) {
                                if (this.manager.context.currentTime < this.startTime) return this.startTime - this.playTime;
                                return this.getCurrentTime();
                            } else if (this.isPaused) return this.currentConfig.seek;
                            else return 0;
                        },
                        set: function(value) {
                            if (this.manager.context.currentTime < this.startTime) return;
                            if (this.isPlaying || this.isPaused) {
                                value = Math.min(Math.max(0, value), this.duration);
                                this.currentConfig.seek = value;
                                if (this.isPlaying) {
                                    this.stopAndRemoveBufferSource();
                                    this.createAndStartBufferSource();
                                }
                                this.emit(Events.SEEK, this, value);
                            }
                        }
                    },
                    /**
     * Seeks to a specific point in this sound.
     *
     * @method Phaser.Sound.WebAudioSound#setSeek
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.4.0
     *
     * @param {number} value - The point in the sound to seek to.
     *
     * @return {this} This Sound instance.
     */ setSeek: function(value) {
                        this.seek = value;
                        return this;
                    },
                    /**
     * Flag indicating whether or not the sound or current sound marker will loop.
     *
     * @name Phaser.Sound.WebAudioSound#loop
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.0.0
     */ loop: {
                        get: function() {
                            return this.currentConfig.loop;
                        },
                        set: function(value) {
                            this.currentConfig.loop = value;
                            if (this.isPlaying) {
                                this.stopAndRemoveLoopBufferSource();
                                if (value) this.createAndStartLoopBufferSource();
                            }
                            this.emit(Events.LOOP, this, value);
                        }
                    },
                    /**
     * Sets the loop state of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setLoop
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
     *
     * @return {this} This Sound instance.
     */ setLoop: function(value) {
                        this.loop = value;
                        return this;
                    },
                    /**
     * Gets or sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Always returns zero on iOS / Safari as it doesn't support the stereo panner node.
     *
     * @name Phaser.Sound.WebAudioSound#pan
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     */ pan: {
                        get: function() {
                            if (this.pannerNode) return this.pannerNode.pan.value;
                            else return 0;
                        },
                        set: function(value) {
                            this.currentConfig.pan = value;
                            if (this.pannerNode) this.pannerNode.pan.setValueAtTime(value, this.manager.context.currentTime);
                            this.emit(Events.PAN, this, value);
                        }
                    },
                    /**
     * Sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Note: iOS / Safari doesn't support the stereo panner node.
     *
     * @method Phaser.Sound.WebAudioSound#setPan
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     *
     * @param {number} value - The pan of the sound. A value between -1 (full left pan) and 1 (full right pan).
     *
     * @return {this} This Sound instance.
     */ setPan: function(value) {
                        this.pan = value;
                        return this;
                    }
                });
                module1.exports = WebAudioSound;
            /***/ },
            /***/ 57490: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Base64ToArrayBuffer = __webpack_require__(53134);
                var BaseSoundManager = __webpack_require__(85034);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(14463);
                var GameEvents = __webpack_require__(8443);
                var WebAudioSound = __webpack_require__(71741);
                var GetFastValue = __webpack_require__(95540);
                /**
 * @classdesc
 * Web Audio API implementation of the Sound Manager.
 *
 * Not all browsers can play all audio formats.
 *
 * There is a good guide to what's supported: [Cross-browser audio basics: Audio codec support](https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/Cross-browser_audio_basics#Audio_Codec_Support).
 *
 * @class WebAudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var WebAudioSoundManager = new Class({
                    Extends: BaseSoundManager,
                    initialize: function WebAudioSoundManager(game) {
                        /**
         * The AudioContext being used for playback.
         *
         * @name Phaser.Sound.WebAudioSoundManager#context
         * @type {AudioContext}
         * @since 3.0.0
         */ this.context = this.createAudioContext(game);
                        /**
         * Gain node responsible for controlling global muting.
         *
         * @name Phaser.Sound.WebAudioSoundManager#masterMuteNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.masterMuteNode = this.context.createGain();
                        /**
         * Gain node responsible for controlling global volume.
         *
         * @name Phaser.Sound.WebAudioSoundManager#masterVolumeNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.masterVolumeNode = this.context.createGain();
                        this.masterMuteNode.connect(this.masterVolumeNode);
                        this.masterVolumeNode.connect(this.context.destination);
                        /**
         * Destination node for connecting individual sounds to.
         *
         * @name Phaser.Sound.WebAudioSoundManager#destination
         * @type {AudioNode}
         * @since 3.0.0
         */ this.destination = this.masterMuteNode;
                        this.locked = this.context.state === 'suspended';
                        BaseSoundManager.call(this, game);
                        if (this.locked) {
                            if (game.isBooted) this.unlock();
                            else game.events.once(GameEvents.BOOT, this.unlock, this);
                        }
                        game.events.on(GameEvents.VISIBLE, this.onGameVisible, this);
                    },
                    /**
     * Internal handler for Phaser.Core.Events#VISIBLE.
     * 
     * Needed to handle resuming audio on iOS17/iOS18+ if you hide the browser, press
     * the home button, etc. See https://github.com/phaserjs/phaser/issues/6829
     *
     * @method Phaser.Sound.WebAudioSoundManager#onGameVisible
     * @private
     * @since 3.88.0
     */ onGameVisible: function() {
                        var context = this.context;
                        //  setTimeout to avoid weird audio artifacts (thanks Apple)
                        window.setTimeout(function() {
                            if (context) {
                                context.suspend();
                                context.resume();
                            }
                        }, 100);
                    },
                    /**
     * Method responsible for instantiating and returning AudioContext instance.
     * If an instance of an AudioContext class was provided through the game config,
     * that instance will be returned instead. This can come in handy if you are reloading
     * a Phaser game on a page that never properly refreshes (such as in an SPA project)
     * and you want to reuse already instantiated AudioContext.
     *
     * @method Phaser.Sound.WebAudioSoundManager#createAudioContext
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - Reference to the current game instance.
     *
     * @return {AudioContext} The AudioContext instance to be used for playback.
     */ createAudioContext: function(game) {
                        var audioConfig = game.config.audio;
                        if (audioConfig.context) {
                            audioConfig.context.resume();
                            return audioConfig.context;
                        }
                        if (window.hasOwnProperty('AudioContext')) return new AudioContext();
                        else if (window.hasOwnProperty('webkitAudioContext')) return new window.webkitAudioContext();
                    },
                    /**
     * This method takes a new AudioContext reference and then sets
     * this Sound Manager to use that context for all playback.
     *
     * As part of this call it also disconnects the master mute and volume
     * nodes and then re-creates them on the new given context.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setAudioContext
     * @since 3.21.0
     *
     * @param {AudioContext} context - Reference to an already created AudioContext instance.
     *
     * @return {this} The WebAudioSoundManager instance.
     */ setAudioContext: function(context) {
                        if (this.context) this.context.close();
                        if (this.masterMuteNode) this.masterMuteNode.disconnect();
                        if (this.masterVolumeNode) this.masterVolumeNode.disconnect();
                        this.context = context;
                        this.masterMuteNode = context.createGain();
                        this.masterVolumeNode = context.createGain();
                        this.masterMuteNode.connect(this.masterVolumeNode);
                        this.masterVolumeNode.connect(context.destination);
                        this.destination = this.masterMuteNode;
                        return this;
                    },
                    /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#add
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.WebAudioSound} The new sound instance.
     */ add: function(key, config) {
                        var sound = new WebAudioSound(this, key, config);
                        this.sounds.push(sound);
                        return sound;
                    },
                    /**
     * Decode audio data into a format ready for playback via Web Audio.
     *
     * The audio data can be a base64 encoded string, an audio media-type data uri, or an ArrayBuffer instance.
     *
     * The `audioKey` is the key that will be used to save the decoded audio to the audio cache.
     *
     * Instead of passing a single entry you can instead pass an array of `Phaser.Types.Sound.DecodeAudioConfig`
     * objects as the first and only argument.
     *
     * Decoding is an async process, so be sure to listen for the events to know when decoding has completed.
     *
     * Once the audio has decoded it can be added to the Sound Manager or played via its key.
     *
     * @method Phaser.Sound.WebAudioSoundManager#decodeAudio
     * @fires Phaser.Sound.Events#DECODED
     * @fires Phaser.Sound.Events#DECODED_ALL
     * @since 3.18.0
     *
     * @param {(Phaser.Types.Sound.DecodeAudioConfig[]|string)} [audioKey] - The string-based key to be used to reference the decoded audio in the audio cache, or an array of audio config objects.
     * @param {(ArrayBuffer|string)} [audioData] - The audio data, either a base64 encoded string, an audio media-type data uri, or an ArrayBuffer instance.
     */ decodeAudio: function(audioKey, audioData) {
                        var audioFiles;
                        if (!Array.isArray(audioKey)) audioFiles = [
                            {
                                key: audioKey,
                                data: audioData
                            }
                        ];
                        else audioFiles = audioKey;
                        var cache = this.game.cache.audio;
                        var remaining = audioFiles.length;
                        for(var i = 0; i < audioFiles.length; i++){
                            var entry = audioFiles[i];
                            var key = entry.key;
                            var data = entry.data;
                            if (typeof data === 'string') data = Base64ToArrayBuffer(data);
                            var success = (function(key, audioBuffer) {
                                cache.add(key, audioBuffer);
                                this.emit(Events.DECODED, key);
                                remaining--;
                                if (remaining === 0) this.emit(Events.DECODED_ALL);
                            }).bind(this, key);
                            var failure = (function(key, error) {
                                //  eslint-disable-next-line no-console
                                console.error('Error decoding audio: ' + key + ' - ', error ? error.message : '');
                                remaining--;
                                if (remaining === 0) this.emit(Events.DECODED_ALL);
                            }).bind(this, key);
                            this.context.decodeAudioData(data, success, failure);
                        }
                    },
                    /**
     * Sets the X and Y position of the Spatial Audio listener on this Web Audios context.
     *
     * If you call this method with no parameters it will default to the center-point of
     * the game canvas. Depending on the type of game you're making, you may need to call
     * this method constantly to reset the listener position as the camera scrolls.
     *
     * Calling this method does nothing on HTML5Audio.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setListenerPosition
     * @since 3.60.0
     *
     * @param {number} [x] - The x position of the Spatial Audio listener.
     * @param {number} [y] - The y position of the Spatial Audio listener.
     */ setListenerPosition: function(x, y) {
                        if (x === undefined) x = this.game.scale.width / 2;
                        if (y === undefined) y = this.game.scale.height / 2;
                        this.listenerPosition.set(x, y);
                        return this;
                    },
                    /**
     * Unlocks Web Audio API on the initial input event.
     *
     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
     *
     * @method Phaser.Sound.WebAudioSoundManager#unlock
     * @since 3.0.0
     */ unlock: function() {
                        var _this = this;
                        var body = document.body;
                        var unlockHandler = function unlockHandler() {
                            if (_this.context && body) {
                                var bodyRemove = body.removeEventListener.bind(body);
                                _this.context.resume().then(function() {
                                    bodyRemove('touchstart', unlockHandler);
                                    bodyRemove('touchend', unlockHandler);
                                    bodyRemove('mousedown', unlockHandler);
                                    bodyRemove('mouseup', unlockHandler);
                                    bodyRemove('keydown', unlockHandler);
                                    _this.unlocked = true;
                                }, function() {
                                    bodyRemove('touchstart', unlockHandler);
                                    bodyRemove('touchend', unlockHandler);
                                    bodyRemove('mousedown', unlockHandler);
                                    bodyRemove('mouseup', unlockHandler);
                                    bodyRemove('keydown', unlockHandler);
                                });
                            }
                        };
                        if (body) {
                            body.addEventListener('touchstart', unlockHandler, false);
                            body.addEventListener('touchend', unlockHandler, false);
                            body.addEventListener('mousedown', unlockHandler, false);
                            body.addEventListener('mouseup', unlockHandler, false);
                            body.addEventListener('keydown', unlockHandler, false);
                        }
                    },
                    /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.WebAudioSoundManager#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                        if (!this.locked) this.context.suspend();
                    },
                    /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.WebAudioSoundManager#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                        var context = this.context;
                        if (context && !this.locked && (context.state === 'suspended' || context.state === 'interrupted')) context.resume();
                    },
                    /**
     * Update method called on every game step.
     *
     * Removes destroyed sounds and updates every active sound in the game.
     *
     * @method Phaser.Sound.WebAudioSoundManager#update
     * @protected
     * @fires Phaser.Sound.Events#UNLOCKED
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: function(time, delta) {
                        var listener = this.context.listener;
                        if (listener && listener.positionX !== undefined) {
                            var x = GetFastValue(this.listenerPosition, 'x', null);
                            var y = GetFastValue(this.listenerPosition, 'y', null);
                            if (x && x !== this._spatialx) this._spatialx = listener.positionX.value = x;
                            if (y && y !== this._spatialy) this._spatialy = listener.positionY.value = y;
                        }
                        BaseSoundManager.prototype.update.call(this, time, delta);
                        //  Resume interrupted audio on iOS only if the game has focus
                        if (!this.gameLostFocus) this.onFocus();
                    },
                    /**
     * Calls Phaser.Sound.BaseSoundManager#destroy method
     * and cleans up all Web Audio API related stuff.
     *
     * @method Phaser.Sound.WebAudioSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.destination = null;
                        this.masterVolumeNode.disconnect();
                        this.masterVolumeNode = null;
                        this.masterMuteNode.disconnect();
                        this.masterMuteNode = null;
                        if (this.game.config.audio.context) this.context.suspend();
                        else {
                            var _this = this;
                            this.context.close().then(function() {
                                _this.context = null;
                            });
                        }
                        this.game.events.off(GameEvents.VISIBLE, this.onGameVisible, this);
                        BaseSoundManager.prototype.destroy.call(this);
                    },
                    /**
     * Sets the muted state of all this Sound Manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setMute
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.3.0
     *
     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
     *
     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
     */ setMute: function(value) {
                        this.mute = value;
                        return this;
                    },
                    /**
     * @name Phaser.Sound.WebAudioSoundManager#mute
     * @type {boolean}
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.0.0
     */ mute: {
                        get: function() {
                            return this.masterMuteNode.gain.value === 0;
                        },
                        set: function(value) {
                            this.masterMuteNode.gain.setValueAtTime(value ? 0 : 1, 0);
                            this.emit(Events.GLOBAL_MUTE, this, value);
                        }
                    },
                    /**
     * Sets the volume of this Sound Manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setVolume
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.3.0
     *
     * @param {number} value - The global volume of this Sound Manager.
     *
     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
     */ setVolume: function(value) {
                        this.volume = value;
                        return this;
                    },
                    /**
     * @name Phaser.Sound.WebAudioSoundManager#volume
     * @type {number}
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.0.0
     */ volume: {
                        get: function() {
                            return this.masterVolumeNode.gain.value;
                        },
                        set: function(value) {
                            this.masterVolumeNode.gain.setValueAtTime(value, 0);
                            this.emit(Events.GLOBAL_VOLUME, this, value);
                        }
                    }
                });
                module1.exports = WebAudioSoundManager;
            /***/ },
            /***/ 73162: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayUtils = __webpack_require__(37105);
                var Class = __webpack_require__(83419);
                var NOOP = __webpack_require__(29747);
                var StableSort = __webpack_require__(19186);
                /**
 * @callback EachListCallback<I>
 *
 * @param {I} item - The item which is currently being processed.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 */ /**
 * @classdesc
 * List is a generic implementation of an ordered list which contains utility methods for retrieving, manipulating, and iterating items.
 *
 * @class List
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 *
 * @param {*} parent - The parent of this list.
 */ var List = new Class({
                    initialize: function List(parent) {
                        /**
         * The parent of this list.
         *
         * @name Phaser.Structs.List#parent
         * @type {*}
         * @since 3.0.0
         */ this.parent = parent;
                        /**
         * The objects that belong to this collection.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.List#list
         * @type {Array.<*>}
         * @default []
         * @since 3.0.0
         */ this.list = [];
                        /**
         * The index of the current element.
         *
         * This is used internally when iterating through the list with the {@link #first}, {@link #last}, {@link #get}, and {@link #previous} properties.
         *
         * @name Phaser.Structs.List#position
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.position = 0;
                        /**
         * A callback that is invoked every time a child is added to this list.
         *
         * @name Phaser.Structs.List#addCallback
         * @type {function}
         * @since 3.4.0
         */ this.addCallback = NOOP;
                        /**
         * A callback that is invoked every time a child is removed from this list.
         *
         * @name Phaser.Structs.List#removeCallback
         * @type {function}
         * @since 3.4.0
         */ this.removeCallback = NOOP;
                        /**
         * The property key to sort by.
         *
         * @name Phaser.Structs.List#_sortKey
         * @type {string}
         * @since 3.4.0
         */ this._sortKey = '';
                    },
                    /**
     * Adds the given item to the end of the list. Each item must be unique.
     *
     * @method Phaser.Structs.List#add
     * @since 3.0.0
     *
     * @param {*|Array.<*>} child - The item, or array of items, to add to the list.
     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
     *
     * @return {*} The list's underlying array.
     */ add: function(child, skipCallback) {
                        if (skipCallback) return ArrayUtils.Add(this.list, child);
                        else return ArrayUtils.Add(this.list, child, 0, this.addCallback, this);
                    },
                    /**
     * Adds an item to list, starting at a specified index. Each item must be unique within the list.
     *
     * @method Phaser.Structs.List#addAt
     * @since 3.0.0
     *
     * @genericUse {(T|T[])} - [child,$return]
     *
     * @param {*} child - The item, or array of items, to add to the list.
     * @param {number} [index=0] - The index in the list at which the element(s) will be inserted.
     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
     *
     * @return {*} The List's underlying array.
     */ addAt: function(child, index, skipCallback) {
                        if (skipCallback) return ArrayUtils.AddAt(this.list, child, index);
                        else return ArrayUtils.AddAt(this.list, child, index, 0, this.addCallback, this);
                    },
                    /**
     * Retrieves the item at a given position inside the List.
     *
     * @method Phaser.Structs.List#getAt
     * @since 3.0.0
     *
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The index of the item.
     *
     * @return {*} The retrieved item, or `undefined` if it's outside the List's bounds.
     */ getAt: function(index) {
                        return this.list[index];
                    },
                    /**
     * Locates an item within the List and returns its index.
     *
     * @method Phaser.Structs.List#getIndex
     * @since 3.0.0
     *
     * @genericUse {T} - [child]
     *
     * @param {*} child - The item to locate.
     *
     * @return {number} The index of the item within the List, or -1 if it's not in the List.
     */ getIndex: function(child) {
                        //  Return -1 if given child isn't a child of this display list
                        return this.list.indexOf(child);
                    },
                    /**
     * Sort the contents of this List so the items are in order based on the given property.
     * For example, `sort('alpha')` would sort the List contents based on the value of their `alpha` property.
     *
     * @method Phaser.Structs.List#sort
     * @since 3.0.0
     *
     * @genericUse {T[]} - [children,$return]
     *
     * @param {string} property - The property to lexically sort by.
     * @param {function} [handler] - Provide your own custom handler function. Will receive 2 children which it should compare and return a boolean.
     *
     * @return {Phaser.Structs.List} This List object.
     */ sort: function(property, handler) {
                        if (!property) return this;
                        if (handler === undefined) handler = function(childA, childB) {
                            return childA[property] - childB[property];
                        };
                        StableSort(this.list, handler);
                        return this;
                    },
                    /**
     * Searches for the first instance of a child with its `name`
     * property matching the given argument. Should more than one child have
     * the same name only the first is returned.
     *
     * @method Phaser.Structs.List#getByName
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {string} name - The name to search for.
     *
     * @return {?*} The first child with a matching name, or null if none were found.
     */ getByName: function(name) {
                        return ArrayUtils.GetFirst(this.list, 'name', name);
                    },
                    /**
     * Returns a random child from the group.
     *
     * @method Phaser.Structs.List#getRandom
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {number} [startIndex=0] - Offset from the front of the group (lowest child).
     * @param {number} [length=(to top)] - Restriction on the number of values you want to randomly select from.
     *
     * @return {?*} A random child of this Group.
     */ getRandom: function(startIndex, length) {
                        return ArrayUtils.GetRandom(this.list, startIndex, length);
                    },
                    /**
     * Returns the first element in a given part of the List which matches a specific criterion.
     *
     * @method Phaser.Structs.List#getFirst
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {string} property - The name of the property to test or a falsey value to have no criterion.
     * @param {*} value - The value to test the `property` against, or `undefined` to allow any value and only check for existence.
     * @param {number} [startIndex=0] - The position in the List to start the search at.
     * @param {number} [endIndex] - The position in the List to optionally stop the search at. It won't be checked.
     *
     * @return {?*} The first item which matches the given criterion, or `null` if no such item exists.
     */ getFirst: function(property, value, startIndex, endIndex) {
                        return ArrayUtils.GetFirst(this.list, property, value, startIndex, endIndex);
                    },
                    /**
     * Returns all children in this List.
     *
     * You can optionally specify a matching criteria using the `property` and `value` arguments.
     *
     * For example: `getAll('parent')` would return only children that have a property called `parent`.
     *
     * You can also specify a value to compare the property to:
     *
     * `getAll('visible', true)` would return only children that have their visible property set to `true`.
     *
     * Optionally you can specify a start and end index. For example if this List had 100 children,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 children in the List.
     *
     * @method Phaser.Structs.List#getAll
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @param {string} [property] - An optional property to test against the value argument.
     * @param {any} [value] - If property is set then Child.property must strictly equal this value to be included in the results.
     * @param {number} [startIndex] - The first child index to start the search from.
     * @param {number} [endIndex] - The last child index to search up until.
     *
     * @return {Array.<*>} All items of the List which match the given criterion, if any.
     */ getAll: function(property, value, startIndex, endIndex) {
                        return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
                    },
                    /**
     * Returns the total number of items in the List which have a property matching the given value.
     *
     * @method Phaser.Structs.List#count
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {string} property - The property to test on each item.
     * @param {*} value - The value to test the property against.
     *
     * @return {number} The total number of matching elements.
     */ count: function(property, value) {
                        return ArrayUtils.CountAllMatching(this.list, property, value);
                    },
                    /**
     * Swaps the positions of two items in the list.
     *
     * @method Phaser.Structs.List#swap
     * @since 3.0.0
     *
     * @genericUse {T} - [child1,child2]
     *
     * @param {*} child1 - The first item to swap.
     * @param {*} child2 - The second item to swap.
     */ swap: function(child1, child2) {
                        ArrayUtils.Swap(this.list, child1, child2);
                    },
                    /**
     * Moves an item in the List to a new position.
     *
     * @method Phaser.Structs.List#moveTo
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move.
     * @param {number} index - Moves an item in the List to a new position.
     *
     * @return {*} The item that was moved.
     */ moveTo: function(child, index) {
                        return ArrayUtils.MoveTo(this.list, child, index);
                    },
                    /**
     * Moves an item above another one in the List.
     * If the given item is already above the other, it isn't moved.
     * Above means toward the end of the List.
     *
     * @method Phaser.Structs.List#moveAbove
     * @since 3.55.0
     *
     * @genericUse {T} - [child1,child2]
     *
     * @param {*} child1 - The element to move above base element.
     * @param {*} child2 - The base element.
     */ moveAbove: function(child1, child2) {
                        return ArrayUtils.MoveAbove(this.list, child1, child2);
                    },
                    /**
     * Moves an item below another one in the List.
     * If the given item is already below the other, it isn't moved.
     * Below means toward the start of the List.
     *
     * @method Phaser.Structs.List#moveBelow
     * @since 3.55.0
     *
     * @genericUse {T} - [child1,child2]
     *
     * @param {*} child1 - The element to move below base element.
     * @param {*} child2 - The base element.
     */ moveBelow: function(child1, child2) {
                        return ArrayUtils.MoveBelow(this.list, child1, child2);
                    },
                    /**
     * Removes one or many items from the List.
     *
     * @method Phaser.Structs.List#remove
     * @since 3.0.0
     *
     * @param {*} child - The item, or array of items, to remove.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {*} The item, or array of items, which were successfully removed from the List.
     */ remove: function(child, skipCallback) {
                        if (skipCallback) return ArrayUtils.Remove(this.list, child);
                        else return ArrayUtils.Remove(this.list, child, this.removeCallback, this);
                    },
                    /**
     * Removes the item at the given position in the List.
     *
     * @method Phaser.Structs.List#removeAt
     * @since 3.0.0
     *
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The position to remove the item from.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {*} The item that was removed.
     */ removeAt: function(index, skipCallback) {
                        if (skipCallback) return ArrayUtils.RemoveAt(this.list, index);
                        else return ArrayUtils.RemoveAt(this.list, index, this.removeCallback, this);
                    },
                    /**
     * Removes the items within the given range in the List.
     *
     * @method Phaser.Structs.List#removeBetween
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @param {number} [startIndex=0] - The index to start removing from.
     * @param {number} [endIndex] - The position to stop removing at. The item at this position won't be removed.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {Array.<*>} An array of the items which were removed.
     */ removeBetween: function(startIndex, endIndex, skipCallback) {
                        if (skipCallback) return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex);
                        else return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeCallback, this);
                    },
                    /**
     * Removes all the items.
     *
     * @method Phaser.Structs.List#removeAll
     * @since 3.0.0
     *
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {this} This List object.
     */ removeAll: function(skipCallback) {
                        var i = this.list.length;
                        while(i--)this.remove(this.list[i], skipCallback);
                        return this;
                    },
                    /**
     * Brings the given child to the top of this List.
     *
     * @method Phaser.Structs.List#bringToTop
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to bring to the top of the List.
     *
     * @return {*} The item which was moved.
     */ bringToTop: function(child) {
                        return ArrayUtils.BringToTop(this.list, child);
                    },
                    /**
     * Sends the given child to the bottom of this List.
     *
     * @method Phaser.Structs.List#sendToBack
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to send to the back of the list.
     *
     * @return {*} The item which was moved.
     */ sendToBack: function(child) {
                        return ArrayUtils.SendToBack(this.list, child);
                    },
                    /**
     * Moves the given child up one place in this group unless it's already at the top.
     *
     * @method Phaser.Structs.List#moveUp
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move up.
     *
     * @return {*} The item which was moved.
     */ moveUp: function(child) {
                        ArrayUtils.MoveUp(this.list, child);
                        return child;
                    },
                    /**
     * Moves the given child down one place in this group unless it's already at the bottom.
     *
     * @method Phaser.Structs.List#moveDown
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move down.
     *
     * @return {*} The item which was moved.
     */ moveDown: function(child) {
                        ArrayUtils.MoveDown(this.list, child);
                        return child;
                    },
                    /**
     * Reverses the order of all children in this List.
     *
     * @method Phaser.Structs.List#reverse
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @return {Phaser.Structs.List} This List object.
     */ reverse: function() {
                        this.list.reverse();
                        return this;
                    },
                    /**
     * Shuffles the items in the list.
     *
     * @method Phaser.Structs.List#shuffle
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @return {Phaser.Structs.List} This List object.
     */ shuffle: function() {
                        ArrayUtils.Shuffle(this.list);
                        return this;
                    },
                    /**
     * Replaces a child of this List with the given newChild. The newChild cannot be a member of this List.
     *
     * @method Phaser.Structs.List#replace
     * @since 3.0.0
     *
     * @genericUse {T} - [oldChild,newChild,$return]
     *
     * @param {*} oldChild - The child in this List that will be replaced.
     * @param {*} newChild - The child to be inserted into this List.
     *
     * @return {*} Returns the oldChild that was replaced within this group.
     */ replace: function(oldChild, newChild) {
                        return ArrayUtils.Replace(this.list, oldChild, newChild);
                    },
                    /**
     * Checks if an item exists within the List.
     *
     * @method Phaser.Structs.List#exists
     * @since 3.0.0
     *
     * @genericUse {T} - [child]
     *
     * @param {*} child - The item to check for the existence of.
     *
     * @return {boolean} `true` if the item is found in the list, otherwise `false`.
     */ exists: function(child) {
                        return this.list.indexOf(child) > -1;
                    },
                    /**
     * Sets the property `key` to the given value on all members of this List.
     *
     * @method Phaser.Structs.List#setAll
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {string} property - The name of the property to set.
     * @param {*} value - The value to set the property to.
     * @param {number} [startIndex] - The first child index to start the search from.
     * @param {number} [endIndex] - The last child index to search up until.
     */ setAll: function(property, value, startIndex, endIndex) {
                        ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
                        return this;
                    },
                    /**
     * Passes all children to the given callback.
     *
     * @method Phaser.Structs.List#each
     * @since 3.0.0
     *
     * @genericUse {EachListCallback.<T>} - [callback]
     *
     * @param {EachListCallback} callback - The function to call.
     * @param {*} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ each: function(callback, context) {
                        var args = [
                            null
                        ];
                        for(var i = 2; i < arguments.length; i++)args.push(arguments[i]);
                        for(i = 0; i < this.list.length; i++){
                            args[0] = this.list[i];
                            callback.apply(context, args);
                        }
                    },
                    /**
     * Clears the List and recreates its internal array.
     *
     * @method Phaser.Structs.List#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        this.removeAll();
                        this.list = [];
                    },
                    /**
     * Destroys this List.
     *
     * @method Phaser.Structs.List#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.removeAll();
                        this.parent = null;
                        this.addCallback = null;
                        this.removeCallback = null;
                    },
                    /**
     * The number of items inside the List.
     *
     * @name Phaser.Structs.List#length
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ length: {
                        get: function() {
                            return this.list.length;
                        }
                    },
                    /**
     * The first item in the List or `null` for an empty List.
     *
     * @name Phaser.Structs.List#first
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ first: {
                        get: function() {
                            this.position = 0;
                            if (this.list.length > 0) return this.list[0];
                            else return null;
                        }
                    },
                    /**
     * The last item in the List, or `null` for an empty List.
     *
     * @name Phaser.Structs.List#last
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ last: {
                        get: function() {
                            if (this.list.length > 0) {
                                this.position = this.list.length - 1;
                                return this.list[this.position];
                            } else return null;
                        }
                    },
                    /**
     * The next item in the List, or `null` if the entire List has been traversed.
     *
     * This property can be read successively after reading {@link #first} or manually setting the {@link #position} to iterate the List.
     *
     * @name Phaser.Structs.List#next
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ next: {
                        get: function() {
                            if (this.position < this.list.length) {
                                this.position++;
                                return this.list[this.position];
                            } else return null;
                        }
                    },
                    /**
     * The previous item in the List, or `null` if the entire List has been traversed.
     *
     * This property can be read successively after reading {@link #last} or manually setting the {@link #position} to iterate the List backwards.
     *
     * @name Phaser.Structs.List#previous
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ previous: {
                        get: function() {
                            if (this.position > 0) {
                                this.position--;
                                return this.list[this.position];
                            } else return null;
                        }
                    }
                });
                module1.exports = List;
            /***/ },
            /***/ 90330: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @callback EachMapCallback<E>
 *
 * @param {string} key - The key of the Map entry.
 * @param {E} entry - The value of the Map entry.
 *
 * @return {?boolean} The callback result.
 */ /**
 * @classdesc
 * The keys of a Map can be arbitrary values.
 *
 * ```javascript
 * var map = new Map([
 *    [ 1, 'one' ],
 *    [ 2, 'two' ],
 *    [ 3, 'three' ]
 * ]);
 * ```
 *
 * @class Map
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic K
 * @generic V
 * @genericUse {V[]} - [elements]
 *
 * @param {Array.<*>} elements - An optional array of key-value pairs to populate this Map with.
 */ var Map = new Class({
                    initialize: function Map(elements) {
                        /**
         * The entries in this Map.
         *
         * @genericUse {Object.<string, V>} - [$type]
         *
         * @name Phaser.Structs.Map#entries
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.0.0
         */ this.entries = {};
                        /**
         * The number of key / value pairs in this Map.
         *
         * @name Phaser.Structs.Map#size
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.size = 0;
                        this.setAll(elements);
                    },
                    /**
     * Adds all the elements in the given array to this Map.
     *
     * If the element already exists, the value will be skipped.
     *
     * @method Phaser.Structs.Map#setAll
     * @since 3.70.0
     *
     * @generic K
     * @generic V
     * @genericUse {V[]} - [elements]
     *
     * @param {Array.<*>} elements - An array of key-value pairs to populate this Map with.
     *
     * @return {this} This Map object.
     */ setAll: function(elements) {
                        if (Array.isArray(elements)) for(var i = 0; i < elements.length; i++)this.set(elements[i][0], elements[i][1]);
                        return this;
                    },
                    /**
     * Adds an element with a specified `key` and `value` to this Map.
     *
     * If the `key` already exists, the value will be replaced.
     *
     * If you wish to add multiple elements in a single call, use the `setAll` method instead.
     *
     * @method Phaser.Structs.Map#set
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {V} - [value]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {string} key - The key of the element to be added to this Map.
     * @param {*} value - The value of the element to be added to this Map.
     *
     * @return {this} This Map object.
     */ set: function(key, value) {
                        if (!this.has(key)) this.size++;
                        this.entries[key] = value;
                        return this;
                    },
                    /**
     * Returns the value associated to the `key`, or `undefined` if there is none.
     *
     * @method Phaser.Structs.Map#get
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {V} - [$return]
     *
     * @param {string} key - The key of the element to return from the `Map` object.
     *
     * @return {*} The element associated with the specified key or `undefined` if the key can't be found in this Map object.
     */ get: function(key) {
                        if (this.has(key)) return this.entries[key];
                    },
                    /**
     * Returns an `Array` of all the values stored in this Map.
     *
     * @method Phaser.Structs.Map#getArray
     * @since 3.0.0
     *
     * @genericUse {V[]} - [$return]
     *
     * @return {Array.<*>} An array of the values stored in this Map.
     */ getArray: function() {
                        var output = [];
                        var entries = this.entries;
                        for(var key in entries)output.push(entries[key]);
                        return output;
                    },
                    /**
     * Returns a boolean indicating whether an element with the specified key exists or not.
     *
     * @method Phaser.Structs.Map#has
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     *
     * @param {string} key - The key of the element to test for presence of in this Map.
     *
     * @return {boolean} Returns `true` if an element with the specified key exists in this Map, otherwise `false`.
     */ has: function(key) {
                        return this.entries.hasOwnProperty(key);
                    },
                    /**
     * Delete the specified element from this Map.
     *
     * @method Phaser.Structs.Map#delete
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {string} key - The key of the element to delete from this Map.
     *
     * @return {this} This Map object.
     */ delete: function(key) {
                        if (this.has(key)) {
                            delete this.entries[key];
                            this.size--;
                        }
                        return this;
                    },
                    /**
     * Delete all entries from this Map.
     *
     * @method Phaser.Structs.Map#clear
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @return {this} This Map object.
     */ clear: function() {
                        Object.keys(this.entries).forEach(function(prop) {
                            delete this.entries[prop];
                        }, this);
                        this.size = 0;
                        return this;
                    },
                    /**
     * Returns all entries keys in this Map.
     *
     * @method Phaser.Structs.Map#keys
     * @since 3.0.0
     *
     * @genericUse {K[]} - [$return]
     *
     * @return {string[]} Array containing entries' keys.
     */ keys: function() {
                        return Object.keys(this.entries);
                    },
                    /**
     * Returns an `Array` of all entries.
     *
     * @method Phaser.Structs.Map#values
     * @since 3.0.0
     *
     * @genericUse {V[]} - [$return]
     *
     * @return {Array.<*>} An `Array` of entries.
     */ values: function() {
                        var output = [];
                        var entries = this.entries;
                        for(var key in entries)output.push(entries[key]);
                        return output;
                    },
                    /**
     * Dumps the contents of this Map to the console via `console.group`.
     *
     * @method Phaser.Structs.Map#dump
     * @since 3.0.0
     */ dump: function() {
                        var entries = this.entries;
                        // eslint-disable-next-line no-console
                        console.group('Map');
                        for(var key in entries)console.log(key, entries[key]);
                        // eslint-disable-next-line no-console
                        console.groupEnd();
                    },
                    /**
     * Iterates through all entries in this Map, passing each one to the given callback.
     *
     * If the callback returns `false`, the iteration will break.
     *
     * @method Phaser.Structs.Map#each
     * @since 3.0.0
     *
     * @genericUse {EachMapCallback.<V>} - [callback]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {EachMapCallback} callback - The callback which will receive the keys and entries held in this Map.
     *
     * @return {this} This Map object.
     */ each: function(callback) {
                        var entries = this.entries;
                        for(var key in entries){
                            if (callback(key, entries[key]) === false) break;
                        }
                        return this;
                    },
                    /**
     * Returns `true` if the value exists within this Map. Otherwise, returns `false`.
     *
     * @method Phaser.Structs.Map#contains
     * @since 3.0.0
     *
     * @genericUse {V} - [value]
     *
     * @param {*} value - The value to search for.
     *
     * @return {boolean} `true` if the value is found, otherwise `false`.
     */ contains: function(value) {
                        var entries = this.entries;
                        for(var key in entries){
                            if (entries[key] === value) return true;
                        }
                        return false;
                    },
                    /**
     * Merges all new keys from the given Map into this one.
     * If it encounters a key that already exists it will be skipped unless override is set to `true`.
     *
     * @method Phaser.Structs.Map#merge
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Map.<K, V>} - [map,$return]
     *
     * @param {Phaser.Structs.Map} map - The Map to merge in to this Map.
     * @param {boolean} [override=false] - Set to `true` to replace values in this Map with those from the source map, or `false` to skip them.
     *
     * @return {this} This Map object.
     */ merge: function(map, override) {
                        if (override === undefined) override = false;
                        var local = this.entries;
                        var source = map.entries;
                        for(var key in source)if (local.hasOwnProperty(key) && override) local[key] = source[key];
                        else this.set(key, source[key]);
                        return this;
                    }
                });
                module1.exports = Map;
            /***/ },
            /***/ 25774: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(82348);
                /**
 * @classdesc
 * A Process Queue maintains three internal lists.
 *
 * The `pending` list is a selection of items which are due to be made 'active' in the next update.
 * The `active` list is a selection of items which are considered active and should be updated.
 * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
 *
 * When new items are added to a Process Queue they are put in the pending list, rather than being added
 * immediately the active list. Equally, items that are removed are put into the destroy list, rather than
 * being destroyed immediately. This allows the Process Queue to carefully process each item at a specific, fixed
 * time, rather than at the time of the request from the API.
 *
 * @class ProcessQueue
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 */ var ProcessQueue = new Class({
                    Extends: EventEmitter,
                    initialize: function ProcessQueue() {
                        EventEmitter.call(this);
                        /**
         * The `pending` list is a selection of items which are due to be made 'active' in the next update.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_pending
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pending = [];
                        /**
         * The `active` list is a selection of items which are considered active and should be updated.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_active
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._active = [];
                        /**
         * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_destroy
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._destroy = [];
                        /**
         * The total number of items awaiting processing.
         *
         * @name Phaser.Structs.ProcessQueue#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._toProcess = 0;
                        /**
         * If `true` only unique objects will be allowed in the queue.
         *
         * @name Phaser.Structs.ProcessQueue#checkQueue
         * @type {boolean}
         * @since 3.50.0
         */ this.checkQueue = false;
                    },
                    /**
     * Checks the given item to see if it is already active within this Process Queue.
     *
     * @method Phaser.Structs.ProcessQueue#isActive
     * @since 3.60.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to check.
     *
     * @return {boolean} `true` if the item is active, otherwise `false`.
     */ isActive: function(item) {
                        return this._active.indexOf(item) > -1;
                    },
                    /**
     * Checks the given item to see if it is already pending addition to this Process Queue.
     *
     * @method Phaser.Structs.ProcessQueue#isPending
     * @since 3.60.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to check.
     *
     * @return {boolean} `true` if the item is pending insertion, otherwise `false`.
     */ isPending: function(item) {
                        return this._toProcess > 0 && this._pending.indexOf(item) > -1;
                    },
                    /**
     * Checks the given item to see if it is already pending destruction from this Process Queue.
     *
     * @method Phaser.Structs.ProcessQueue#isDestroying
     * @since 3.60.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to check.
     *
     * @return {boolean} `true` if the item is pending destruction, otherwise `false`.
     */ isDestroying: function(item) {
                        return this._destroy.indexOf(item) > -1;
                    },
                    /**
     * Adds a new item to the Process Queue.
     *
     * The item is added to the pending list and made active in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#add
     * @since 3.0.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to add to the queue.
     *
     * @return {*} The item that was added.
     */ add: function(item) {
                        //  Don't add if already active or pending, but DO add if active AND in the destroy list
                        if (this.checkQueue && this.isActive(item) && !this.isDestroying(item) || this.isPending(item)) return item;
                        this._pending.push(item);
                        this._toProcess++;
                        return item;
                    },
                    /**
     * Removes an item from the Process Queue.
     *
     * The item is added to the 'destroy' list and is fully removed in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#remove
     * @since 3.0.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to be removed from the queue.
     *
     * @return {*} The item that was removed.
     */ remove: function(item) {
                        //  Check if it's in the _pending list
                        if (this.isPending(item)) {
                            var pending = this._pending;
                            var idx = pending.indexOf(item);
                            if (idx !== -1) //  Remove directly, no need to wait for an update loop
                            pending.splice(idx, 1);
                        } else if (this.isActive(item)) {
                            //  Item is actively running? Queue it for deletion
                            this._destroy.push(item);
                            this._toProcess++;
                        }
                        //  If neither of the above conditions pass, then the item is either already in the destroy list,
                        //  or isn't pending or active, so cannot be removed anyway
                        return item;
                    },
                    /**
     * Removes all active items from this Process Queue.
     *
     * All the items are marked as 'pending destroy' and fully removed in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#removeAll
     * @since 3.20.0
     *
     * @return {this} This Process Queue object.
     */ removeAll: function() {
                        var list = this._active;
                        var destroy = this._destroy;
                        var i = list.length;
                        while(i--){
                            destroy.push(list[i]);
                            this._toProcess++;
                        }
                        return this;
                    },
                    /**
     * Update this queue. First it will process any items awaiting destruction, and remove them.
     *
     * Then it will check to see if there are any items pending insertion, and move them to an
     * active state. Finally, it will return a list of active items for further processing.
     *
     * @method Phaser.Structs.ProcessQueue#update
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} A list of active items.
     */ update: function() {
                        if (this._toProcess === 0) //  Quick bail
                        return this._active;
                        var list = this._destroy;
                        var active = this._active;
                        var i;
                        var item;
                        //  Clear the 'destroy' list
                        for(i = 0; i < list.length; i++){
                            item = list[i];
                            //  Remove from the 'active' array
                            var idx = active.indexOf(item);
                            if (idx !== -1) {
                                active.splice(idx, 1);
                                this.emit(Events.PROCESS_QUEUE_REMOVE, item);
                            }
                        }
                        list.length = 0;
                        //  Process the pending addition list
                        //  This stops callbacks and out of sync events from populating the active array mid-way during an update
                        list = this._pending;
                        for(i = 0; i < list.length; i++){
                            item = list[i];
                            if (!this.checkQueue || this.checkQueue && active.indexOf(item) === -1) {
                                active.push(item);
                                this.emit(Events.PROCESS_QUEUE_ADD, item);
                            }
                        }
                        list.length = 0;
                        this._toProcess = 0;
                        //  The owner of this queue can now safely do whatever it needs to with the active list
                        return active;
                    },
                    /**
     * Returns the current list of active items.
     *
     * This method returns a reference to the active list array, not a copy of it.
     * Therefore, be careful to not modify this array outside of the ProcessQueue.
     *
     * @method Phaser.Structs.ProcessQueue#getActive
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} A list of active items.
     */ getActive: function() {
                        return this._active;
                    },
                    /**
     * The number of entries in the active list.
     *
     * @name Phaser.Structs.ProcessQueue#length
     * @type {number}
     * @readonly
     * @since 3.20.0
     */ length: {
                        get: function() {
                            return this._active.length;
                        }
                    },
                    /**
     * Immediately destroys this process queue, clearing all of its internal arrays and resetting the process totals.
     *
     * @method Phaser.Structs.ProcessQueue#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this._toProcess = 0;
                        this._pending = [];
                        this._active = [];
                        this._destroy = [];
                    }
                });
                module1.exports = ProcessQueue;
            /***/ },
            /***/ 59542: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Vladimir Agafonkin
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var quickselect = __webpack_require__(43886);
                /**
 * @classdesc
 * RBush is a high-performance JavaScript library for 2D spatial indexing of points and rectangles.
 * It's based on an optimized R-tree data structure with bulk insertion support.
 *
 * Spatial index is a special data structure for points and rectangles that allows you to perform queries like
 * "all items within this bounding box" very efficiently (e.g. hundreds of times faster than looping over all items).
 *
 * This version of RBush uses a fixed min/max accessor structure of `[ '.left', '.top', '.right', '.bottom' ]`.
 * This is to avoid the eval like function creation that the original library used, which caused CSP policy violations.
 *
 * rbush is forked from https://github.com/mourner/rbush by Vladimir Agafonkin
 *
 * @class RTree
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 */ function rbush(maxEntries) {
                    var format = [
                        '.left',
                        '.top',
                        '.right',
                        '.bottom'
                    ];
                    if (!(this instanceof rbush)) return new rbush(maxEntries, format);
                    // max entries in a node is 9 by default; min node fill is 40% for best performance
                    this._maxEntries = Math.max(4, maxEntries || 9);
                    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
                    this.clear();
                }
                rbush.prototype = {
                    all: function() {
                        return this._all(this.data, []);
                    },
                    search: function(bbox) {
                        var node = this.data, result = [], toBBox = this.toBBox;
                        if (!intersects(bbox, node)) return result;
                        var nodesToSearch = [], i, len, child, childBBox;
                        while(node){
                            for(i = 0, len = node.children.length; i < len; i++){
                                child = node.children[i];
                                childBBox = node.leaf ? toBBox(child) : child;
                                if (intersects(bbox, childBBox)) {
                                    if (node.leaf) result.push(child);
                                    else if (contains(bbox, childBBox)) this._all(child, result);
                                    else nodesToSearch.push(child);
                                }
                            }
                            node = nodesToSearch.pop();
                        }
                        return result;
                    },
                    collides: function(bbox) {
                        var node = this.data, toBBox = this.toBBox;
                        if (!intersects(bbox, node)) return false;
                        var nodesToSearch = [], i, len, child, childBBox;
                        while(node){
                            for(i = 0, len = node.children.length; i < len; i++){
                                child = node.children[i];
                                childBBox = node.leaf ? toBBox(child) : child;
                                if (intersects(bbox, childBBox)) {
                                    if (node.leaf || contains(bbox, childBBox)) return true;
                                    nodesToSearch.push(child);
                                }
                            }
                            node = nodesToSearch.pop();
                        }
                        return false;
                    },
                    load: function(data) {
                        if (!(data && data.length)) return this;
                        if (data.length < this._minEntries) {
                            for(var i = 0, len = data.length; i < len; i++)this.insert(data[i]);
                            return this;
                        }
                        // recursively build the tree with the given data from scratch using OMT algorithm
                        var node = this._build(data.slice(), 0, data.length - 1, 0);
                        if (!this.data.children.length) // save as is if tree is empty
                        this.data = node;
                        else if (this.data.height === node.height) // split root if trees have the same height
                        this._splitRoot(this.data, node);
                        else {
                            if (this.data.height < node.height) {
                                // swap trees if inserted one is bigger
                                var tmpNode = this.data;
                                this.data = node;
                                node = tmpNode;
                            }
                            // insert the small tree into the large tree at appropriate level
                            this._insert(node, this.data.height - node.height - 1, true);
                        }
                        return this;
                    },
                    insert: function(item) {
                        if (item) this._insert(item, this.data.height - 1);
                        return this;
                    },
                    clear: function() {
                        this.data = createNode([]);
                        return this;
                    },
                    remove: function(item, equalsFn) {
                        if (!item) return this;
                        var node = this.data, bbox = this.toBBox(item), path = [], indexes = [], i, parent, index, goingUp;
                        // depth-first iterative tree traversal
                        while(node || path.length){
                            if (!node) {
                                node = path.pop();
                                parent = path[path.length - 1];
                                i = indexes.pop();
                                goingUp = true;
                            }
                            if (node.leaf) {
                                index = findItem(item, node.children, equalsFn);
                                if (index !== -1) {
                                    // item found, remove the item and condense tree upwards
                                    node.children.splice(index, 1);
                                    path.push(node);
                                    this._condense(path);
                                    return this;
                                }
                            }
                            if (!goingUp && !node.leaf && contains(node, bbox)) {
                                path.push(node);
                                indexes.push(i);
                                i = 0;
                                parent = node;
                                node = node.children[0];
                            } else if (parent) {
                                i++;
                                node = parent.children[i];
                                goingUp = false;
                            } else node = null; // nothing found
                        }
                        return this;
                    },
                    toBBox: function(item) {
                        return item;
                    },
                    compareMinX: compareNodeMinX,
                    compareMinY: compareNodeMinY,
                    toJSON: function() {
                        return this.data;
                    },
                    fromJSON: function(data) {
                        this.data = data;
                        return this;
                    },
                    _all: function(node, result) {
                        var nodesToSearch = [];
                        while(node){
                            if (node.leaf) result.push.apply(result, node.children);
                            else nodesToSearch.push.apply(nodesToSearch, node.children);
                            node = nodesToSearch.pop();
                        }
                        return result;
                    },
                    _build: function(items, left, right, height) {
                        var N = right - left + 1, M = this._maxEntries, node;
                        if (N <= M) {
                            // reached leaf level; return leaf
                            node = createNode(items.slice(left, right + 1));
                            calcBBox(node, this.toBBox);
                            return node;
                        }
                        if (!height) {
                            // target height of the bulk-loaded tree
                            height = Math.ceil(Math.log(N) / Math.log(M));
                            // target number of root entries to maximize storage utilization
                            M = Math.ceil(N / Math.pow(M, height - 1));
                        }
                        node = createNode([]);
                        node.leaf = false;
                        node.height = height;
                        // split the items into M mostly square tiles
                        var N2 = Math.ceil(N / M), N1 = N2 * Math.ceil(Math.sqrt(M)), i, j, right2, right3;
                        multiSelect(items, left, right, N1, this.compareMinX);
                        for(i = left; i <= right; i += N1){
                            right2 = Math.min(i + N1 - 1, right);
                            multiSelect(items, i, right2, N2, this.compareMinY);
                            for(j = i; j <= right2; j += N2){
                                right3 = Math.min(j + N2 - 1, right2);
                                // pack each entry recursively
                                node.children.push(this._build(items, j, right3, height - 1));
                            }
                        }
                        calcBBox(node, this.toBBox);
                        return node;
                    },
                    _chooseSubtree: function(bbox, node, level, path) {
                        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
                        while(true){
                            path.push(node);
                            if (node.leaf || path.length - 1 === level) break;
                            minArea = minEnlargement = Infinity;
                            for(i = 0, len = node.children.length; i < len; i++){
                                child = node.children[i];
                                area = bboxArea(child);
                                enlargement = enlargedArea(bbox, child) - area;
                                // choose entry with the least area enlargement
                                if (enlargement < minEnlargement) {
                                    minEnlargement = enlargement;
                                    minArea = area < minArea ? area : minArea;
                                    targetNode = child;
                                } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                                {
                                    if (area < minArea) {
                                        minArea = area;
                                        targetNode = child;
                                    }
                                }
                            }
                            node = targetNode || node.children[0];
                        }
                        return node;
                    },
                    _insert: function(item, level, isNode) {
                        var toBBox = this.toBBox, bbox = isNode ? item : toBBox(item), insertPath = [];
                        // find the best node for accommodating the item, saving all nodes along the path too
                        var node = this._chooseSubtree(bbox, this.data, level, insertPath);
                        // put the item into the node
                        node.children.push(item);
                        extend(node, bbox);
                        // split on node overflow; propagate upwards if necessary
                        while(level >= 0){
                            if (insertPath[level].children.length > this._maxEntries) {
                                this._split(insertPath, level);
                                level--;
                            } else break;
                        }
                        // adjust bboxes along the insertion path
                        this._adjustParentBBoxes(bbox, insertPath, level);
                    },
                    // split overflowed node into two
                    _split: function(insertPath, level) {
                        var node = insertPath[level], M = node.children.length, m = this._minEntries;
                        this._chooseSplitAxis(node, m, M);
                        var splitIndex = this._chooseSplitIndex(node, m, M);
                        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
                        newNode.height = node.height;
                        newNode.leaf = node.leaf;
                        calcBBox(node, this.toBBox);
                        calcBBox(newNode, this.toBBox);
                        if (level) insertPath[level - 1].children.push(newNode);
                        else this._splitRoot(node, newNode);
                    },
                    _splitRoot: function(node, newNode) {
                        // split root node
                        this.data = createNode([
                            node,
                            newNode
                        ]);
                        this.data.height = node.height + 1;
                        this.data.leaf = false;
                        calcBBox(this.data, this.toBBox);
                    },
                    _chooseSplitIndex: function(node, m, M) {
                        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
                        minOverlap = minArea = Infinity;
                        for(i = m; i <= M - m; i++){
                            bbox1 = distBBox(node, 0, i, this.toBBox);
                            bbox2 = distBBox(node, i, M, this.toBBox);
                            overlap = intersectionArea(bbox1, bbox2);
                            area = bboxArea(bbox1) + bboxArea(bbox2);
                            // choose distribution with minimum overlap
                            if (overlap < minOverlap) {
                                minOverlap = overlap;
                                index = i;
                                minArea = area < minArea ? area : minArea;
                            } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
                            {
                                if (area < minArea) {
                                    minArea = area;
                                    index = i;
                                }
                            }
                        }
                        return index;
                    },
                    // sorts node children by the best axis for split
                    _chooseSplitAxis: function(node, m, M) {
                        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX, compareMinY = node.leaf ? this.compareMinY : compareNodeMinY, xMargin = this._allDistMargin(node, m, M, compareMinX), yMargin = this._allDistMargin(node, m, M, compareMinY);
                        // if total distributions margin value is minimal for x, sort by minX,
                        // otherwise it's already sorted by minY
                        if (xMargin < yMargin) node.children.sort(compareMinX);
                    },
                    // total margin of all possible split distributions where each node is at least m full
                    _allDistMargin: function(node, m, M, compare) {
                        node.children.sort(compare);
                        var toBBox = this.toBBox, leftBBox = distBBox(node, 0, m, toBBox), rightBBox = distBBox(node, M - m, M, toBBox), margin = bboxMargin(leftBBox) + bboxMargin(rightBBox), i, child;
                        for(i = m; i < M - m; i++){
                            child = node.children[i];
                            extend(leftBBox, node.leaf ? toBBox(child) : child);
                            margin += bboxMargin(leftBBox);
                        }
                        for(i = M - m - 1; i >= m; i--){
                            child = node.children[i];
                            extend(rightBBox, node.leaf ? toBBox(child) : child);
                            margin += bboxMargin(rightBBox);
                        }
                        return margin;
                    },
                    _adjustParentBBoxes: function(bbox, path, level) {
                        // adjust bboxes along the given tree path
                        for(var i = level; i >= 0; i--)extend(path[i], bbox);
                    },
                    _condense: function(path) {
                        // go through the path, removing empty nodes and updating bboxes
                        for(var i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
                            if (i > 0) {
                                siblings = path[i - 1].children;
                                siblings.splice(siblings.indexOf(path[i]), 1);
                            } else this.clear();
                        } else calcBBox(path[i], this.toBBox);
                    },
                    compareMinX: function(a, b) {
                        return a.left - b.left;
                    },
                    compareMinY: function(a, b) {
                        return a.top - b.top;
                    },
                    toBBox: function(a) {
                        return {
                            minX: a.left,
                            minY: a.top,
                            maxX: a.right,
                            maxY: a.bottom
                        };
                    }
                };
                function findItem(item, items, equalsFn) {
                    if (!equalsFn) return items.indexOf(item);
                    for(var i = 0; i < items.length; i++){
                        if (equalsFn(item, items[i])) return i;
                    }
                    return -1;
                }
                // calculate node's bbox from bboxes of its children
                function calcBBox(node, toBBox) {
                    distBBox(node, 0, node.children.length, toBBox, node);
                }
                // min bounding rectangle of node children from k to p-1
                function distBBox(node, k, p, toBBox, destNode) {
                    if (!destNode) destNode = createNode(null);
                    destNode.minX = Infinity;
                    destNode.minY = Infinity;
                    destNode.maxX = -Infinity;
                    destNode.maxY = -Infinity;
                    for(var i = k, child; i < p; i++){
                        child = node.children[i];
                        extend(destNode, node.leaf ? toBBox(child) : child);
                    }
                    return destNode;
                }
                function extend(a, b) {
                    a.minX = Math.min(a.minX, b.minX);
                    a.minY = Math.min(a.minY, b.minY);
                    a.maxX = Math.max(a.maxX, b.maxX);
                    a.maxY = Math.max(a.maxY, b.maxY);
                    return a;
                }
                function compareNodeMinX(a, b) {
                    return a.minX - b.minX;
                }
                function compareNodeMinY(a, b) {
                    return a.minY - b.minY;
                }
                function bboxArea(a) {
                    return (a.maxX - a.minX) * (a.maxY - a.minY);
                }
                function bboxMargin(a) {
                    return a.maxX - a.minX + (a.maxY - a.minY);
                }
                function enlargedArea(a, b) {
                    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
                }
                function intersectionArea(a, b) {
                    var minX = Math.max(a.minX, b.minX), minY = Math.max(a.minY, b.minY), maxX = Math.min(a.maxX, b.maxX), maxY = Math.min(a.maxY, b.maxY);
                    return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
                }
                function contains(a, b) {
                    return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
                }
                function intersects(a, b) {
                    return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
                }
                function createNode(children) {
                    return {
                        children: children,
                        height: 1,
                        leaf: true,
                        minX: Infinity,
                        minY: Infinity,
                        maxX: -Infinity,
                        maxY: -Infinity
                    };
                }
                // sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
                // combines selection algorithm with binary divide & conquer approach
                function multiSelect(arr, left, right, n, compare) {
                    var stack = [
                        left,
                        right
                    ], mid;
                    while(stack.length){
                        right = stack.pop();
                        left = stack.pop();
                        if (right - left <= n) continue;
                        mid = left + Math.ceil((right - left) / n / 2) * n;
                        quickselect(arr, mid, left, right, compare);
                        stack.push(left, mid, mid, right);
                    }
                }
                module1.exports = rbush;
            /***/ },
            /***/ 35072: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @callback EachSetCallback<E>
 *
 * @param {E} entry - The Set entry.
 * @param {number} index - The index of the entry within the Set.
 *
 * @return {?boolean} The callback result.
 */ /**
 * @classdesc
 * A Set is a collection of unique elements.
 *
 * @class Set
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[]} - [elements]
 *
 * @param {Array.<*>} [elements] - An optional array of elements to insert into this Set.
 */ var Set = new Class({
                    initialize: function Set(elements) {
                        /**
         * The entries of this Set. Stored internally as an array.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.Set#entries
         * @type {Array.<*>}
         * @default []
         * @since 3.0.0
         */ this.entries = [];
                        if (Array.isArray(elements)) for(var i = 0; i < elements.length; i++)this.set(elements[i]);
                    },
                    /**
     * Inserts the provided value into this Set. If the value is already contained in this Set this method will have no effect.
     *
     * @method Phaser.Structs.Set#set
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {*} value - The value to insert into this Set.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ set: function(value) {
                        if (this.entries.indexOf(value) === -1) this.entries.push(value);
                        return this;
                    },
                    /**
     * Get an element of this Set which has a property of the specified name, if that property is equal to the specified value.
     * If no elements of this Set satisfy the condition then this method will return `null`.
     *
     * @method Phaser.Structs.Set#get
     * @since 3.0.0
     *
     * @genericUse {T} - [value,$return]
     *
     * @param {string} property - The property name to check on the elements of this Set.
     * @param {*} value - The value to check for.
     *
     * @return {*} The first element of this Set that meets the required condition, or `null` if this Set contains no elements that meet the condition.
     */ get: function(property, value) {
                        for(var i = 0; i < this.entries.length; i++){
                            var entry = this.entries[i];
                            if (entry[property] === value) return entry;
                        }
                    },
                    /**
     * Returns an array containing all the values in this Set.
     *
     * @method Phaser.Structs.Set#getArray
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} An array containing all the values in this Set.
     */ getArray: function() {
                        return this.entries.slice(0);
                    },
                    /**
     * Removes the given value from this Set if this Set contains that value.
     *
     * @method Phaser.Structs.Set#delete
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {*} value - The value to remove from the Set.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ delete: function(value) {
                        var index = this.entries.indexOf(value);
                        if (index > -1) this.entries.splice(index, 1);
                        return this;
                    },
                    /**
     * Dumps the contents of this Set to the console via `console.group`.
     *
     * @method Phaser.Structs.Set#dump
     * @since 3.0.0
     */ dump: function() {
                        // eslint-disable-next-line no-console
                        console.group('Set');
                        for(var i = 0; i < this.entries.length; i++){
                            var entry = this.entries[i];
                            console.log(entry);
                        }
                        // eslint-disable-next-line no-console
                        console.groupEnd();
                    },
                    /**
     * Passes each value in this Set to the given callback.
     * Use this function when you know this Set will be modified during the iteration, otherwise use `iterate`.
     *
     * @method Phaser.Structs.Set#each
     * @since 3.0.0
     *
     * @genericUse {EachSetCallback.<T>} - [callback]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {EachSetCallback} callback - The callback to be invoked and passed each value this Set contains.
     * @param {*} [callbackScope] - The scope of the callback.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ each: function(callback, callbackScope) {
                        var i;
                        var temp = this.entries.slice();
                        var len = temp.length;
                        if (callbackScope) for(i = 0; i < len; i++){
                            if (callback.call(callbackScope, temp[i], i) === false) break;
                        }
                        else for(i = 0; i < len; i++){
                            if (callback(temp[i], i) === false) break;
                        }
                        return this;
                    },
                    /**
     * Passes each value in this Set to the given callback.
     *
     * For when you absolutely know this Set won't be modified during the iteration.
     *
     * The callback must return a boolean. If it returns `false` then it will abort
     * the Set iteration immediately. If it returns `true`, it will carry on
     * iterating the next child in the Set.
     *
     * @method Phaser.Structs.Set#iterate
     * @since 3.0.0
     *
     * @genericUse {EachSetCallback.<T>} - [callback]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {EachSetCallback} callback - The callback to be invoked and passed each value this Set contains.
     * @param {*} [callbackScope] - The scope of the callback.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ iterate: function(callback, callbackScope) {
                        var i;
                        var len = this.entries.length;
                        if (callbackScope) for(i = 0; i < len; i++){
                            if (callback.call(callbackScope, this.entries[i], i) === false) break;
                        }
                        else for(i = 0; i < len; i++){
                            if (callback(this.entries[i], i) === false) break;
                        }
                        return this;
                    },
                    /**
     * Goes through each entry in this Set and invokes the given function on them, passing in the arguments.
     *
     * @method Phaser.Structs.Set#iterateLocal
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {string} callbackKey - The key of the function to be invoked on each Set entry.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ iterateLocal: function(callbackKey) {
                        var i;
                        var args = [];
                        for(i = 1; i < arguments.length; i++)args.push(arguments[i]);
                        var len = this.entries.length;
                        for(i = 0; i < len; i++){
                            var entry = this.entries[i];
                            entry[callbackKey].apply(entry, args);
                        }
                        return this;
                    },
                    /**
     * Clears this Set so that it no longer contains any values.
     *
     * @method Phaser.Structs.Set#clear
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ clear: function() {
                        this.entries.length = 0;
                        return this;
                    },
                    /**
     * Returns `true` if this Set contains the given value, otherwise returns `false`.
     *
     * @method Phaser.Structs.Set#contains
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {*} value - The value to check for in this Set.
     *
     * @return {boolean} `true` if the given value was found in this Set, otherwise `false`.
     */ contains: function(value) {
                        return this.entries.indexOf(value) > -1;
                    },
                    /**
     * Returns a new Set containing all values that are either in this Set or in the Set provided as an argument.
     *
     * @method Phaser.Structs.Set#union
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to perform the union with.
     *
     * @return {Phaser.Structs.Set} A new Set containing all the values in this Set and the Set provided as an argument.
     */ union: function(set) {
                        var newSet = new Set();
                        set.entries.forEach(function(value) {
                            newSet.set(value);
                        });
                        this.entries.forEach(function(value) {
                            newSet.set(value);
                        });
                        return newSet;
                    },
                    /**
     * Returns a new Set that contains only the values which are in this Set and that are also in the given Set.
     *
     * @method Phaser.Structs.Set#intersect
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to intersect this set with.
     *
     * @return {Phaser.Structs.Set} The result of the intersection, as a new Set.
     */ intersect: function(set) {
                        var newSet = new Set();
                        this.entries.forEach(function(value) {
                            if (set.contains(value)) newSet.set(value);
                        });
                        return newSet;
                    },
                    /**
     * Returns a new Set containing all the values in this Set which are *not* also in the given Set.
     *
     * @method Phaser.Structs.Set#difference
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to perform the difference with.
     *
     * @return {Phaser.Structs.Set} A new Set containing all the values in this Set that are not also in the Set provided as an argument to this method.
     */ difference: function(set) {
                        var newSet = new Set();
                        this.entries.forEach(function(value) {
                            if (!set.contains(value)) newSet.set(value);
                        });
                        return newSet;
                    },
                    /**
     * The size of this Set. This is the number of entries within it.
     * Changing the size will truncate the Set if the given value is smaller than the current size.
     * Increasing the size larger than the current size has no effect.
     *
     * @name Phaser.Structs.Set#size
     * @type {number}
     * @since 3.0.0
     */ size: {
                        get: function() {
                            return this.entries.length;
                        },
                        set: function(value) {
                            if (value < this.entries.length) return this.entries.length = value;
                            else return this.entries.length;
                        }
                    }
                });
                module1.exports = Set;
            /***/ },
            /***/ 86555: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var SnapFloor = __webpack_require__(56583);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * The Size component allows you to set `width` and `height` properties and define the relationship between them.
 *
 * The component can automatically maintain the aspect ratios between the two values, and clamp them
 * to a defined min-max range. You can also control the dominant axis. When dimensions are given to the Size component
 * that would cause it to exceed its min-max range, the dimensions are adjusted based on the dominant axis.
 *
 * @class Size
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.16.0
 *
 * @param {number} [width=0] - The width of the Size component.
 * @param {number} [height=width] - The height of the Size component. If not given, it will use the `width`.
 * @param {number} [aspectMode=0] - The aspect mode of the Size component. Defaults to 0, no mode.
 * @param {any} [parent=null] - The parent of this Size component. Can be any object with public `width` and `height` properties. Dimensions are clamped to keep them within the parent bounds where possible.
 */ var Size = new Class({
                    initialize: function Size(width, height, aspectMode, parent) {
                        if (width === undefined) width = 0;
                        if (height === undefined) height = width;
                        if (aspectMode === undefined) aspectMode = 0;
                        if (parent === undefined) parent = null;
                        /**
         * Internal width value.
         *
         * @name Phaser.Structs.Size#_width
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._width = width;
                        /**
         * Internal height value.
         *
         * @name Phaser.Structs.Size#_height
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._height = height;
                        /**
         * Internal parent reference.
         *
         * @name Phaser.Structs.Size#_parent
         * @type {any}
         * @private
         * @since 3.16.0
         */ this._parent = parent;
                        /**
         * The aspect mode this Size component will use when calculating its dimensions.
         * This property is read-only. To change it use the `setAspectMode` method.
         *
         * @name Phaser.Structs.Size#aspectMode
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.aspectMode = aspectMode;
                        /**
         * The proportional relationship between the width and height.
         *
         * This property is read-only and is updated automatically when either the `width` or `height` properties are changed,
         * depending on the aspect mode.
         *
         * @name Phaser.Structs.Size#aspectRatio
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.aspectRatio = height === 0 ? 1 : width / height;
                        /**
         * The minimum allowed width.
         * Cannot be less than zero.
         * This value is read-only. To change it see the `setMin` method.
         *
         * @name Phaser.Structs.Size#minWidth
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.minWidth = 0;
                        /**
         * The minimum allowed height.
         * Cannot be less than zero.
         * This value is read-only. To change it see the `setMin` method.
         *
         * @name Phaser.Structs.Size#minHeight
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.minHeight = 0;
                        /**
         * The maximum allowed width.
         * This value is read-only. To change it see the `setMax` method.
         *
         * @name Phaser.Structs.Size#maxWidth
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.maxWidth = Number.MAX_VALUE;
                        /**
         * The maximum allowed height.
         * This value is read-only. To change it see the `setMax` method.
         *
         * @name Phaser.Structs.Size#maxHeight
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.maxHeight = Number.MAX_VALUE;
                        /**
         * A Vector2 containing the horizontal and vertical snap values, which the width and height are snapped to during resizing.
         *
         * By default this is disabled.
         *
         * This property is read-only. To change it see the `setSnap` method.
         *
         * @name Phaser.Structs.Size#snapTo
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.16.0
         */ this.snapTo = new Vector2();
                    },
                    /**
     * Sets the aspect mode of this Size component.
     *
     * The aspect mode controls what happens when you modify the `width` or `height` properties, or call `setSize`.
     *
     * It can be a number from 0 to 4, or a Size constant:
     *
     * 0. NONE = Do not make the size fit the aspect ratio. Change the ratio when the size changes.
     * 1. WIDTH_CONTROLS_HEIGHT = The height is automatically adjusted based on the width.
     * 2. HEIGHT_CONTROLS_WIDTH = The width is automatically adjusted based on the height.
     * 3. FIT = The width and height are automatically adjusted to fit inside the given target area, while keeping the aspect ratio. Depending on the aspect ratio there may be some space inside the area which is not covered.
     * 4. ENVELOP = The width and height are automatically adjusted to make the size cover the entire target area while keeping the aspect ratio. This may extend further out than the target size.
     *
     * Calling this method automatically recalculates the `width` and the `height`, if required.
     *
     * @method Phaser.Structs.Size#setAspectMode
     * @since 3.16.0
     *
     * @param {number} [value=0] - The aspect mode value.
     *
     * @return {this} This Size component instance.
     */ setAspectMode: function(value) {
                        if (value === undefined) value = 0;
                        this.aspectMode = value;
                        return this.setSize(this._width, this._height);
                    },
                    /**
     * By setting snap values, when this Size component is modified its dimensions will automatically
     * be snapped to the nearest grid slice, using floor. For example, if you have snap value of 16,
     * and the width changes to 68, then it will snap down to 64 (the closest multiple of 16 when floored)
     *
     * Note that snapping takes place before adjustments by the parent, or the min / max settings. If these
     * values are not multiples of the given snap values, then this can result in un-snapped dimensions.
     *
     * Call this method with no arguments to reset the snap values.
     *
     * Calling this method automatically recalculates the `width` and the `height`, if required.
     *
     * @method Phaser.Structs.Size#setSnap
     * @since 3.16.0
     *
     * @param {number} [snapWidth=0] - The amount to snap the width to. If you don't want to snap the width, pass a value of zero.
     * @param {number} [snapHeight=snapWidth] - The amount to snap the height to. If not provided it will use the `snapWidth` value. If you don't want to snap the height, pass a value of zero.
     *
     * @return {this} This Size component instance.
     */ setSnap: function(snapWidth, snapHeight) {
                        if (snapWidth === undefined) snapWidth = 0;
                        if (snapHeight === undefined) snapHeight = snapWidth;
                        this.snapTo.set(snapWidth, snapHeight);
                        return this.setSize(this._width, this._height);
                    },
                    /**
     * Sets, or clears, the parent of this Size component.
     *
     * To clear the parent call this method with no arguments.
     *
     * The parent influences the maximum extents to which this Size component can expand,
     * based on the aspect mode:
     *
     * NONE - The parent clamps both the width and height.
     * WIDTH_CONTROLS_HEIGHT - The parent clamps just the width.
     * HEIGHT_CONTROLS_WIDTH - The parent clamps just the height.
     * FIT - The parent clamps whichever axis is required to ensure the size fits within it.
     * ENVELOP - The parent is used to ensure the size fully envelops the parent.
     *
     * Calling this method automatically calls `setSize`.
     *
     * @method Phaser.Structs.Size#setParent
     * @since 3.16.0
     *
     * @param {any} [parent] - Sets the parent of this Size component. Don't provide a value to clear an existing parent.
     *
     * @return {this} This Size component instance.
     */ setParent: function(parent) {
                        this._parent = parent;
                        return this.setSize(this._width, this._height);
                    },
                    /**
     * Set the minimum width and height values this Size component will allow.
     *
     * The minimum values can never be below zero, or greater than the maximum values.
     *
     * Setting this will automatically adjust both the `width` and `height` properties to ensure they are within range.
     *
     * Note that based on the aspect mode, and if this Size component has a parent set or not, the minimums set here
     * _can_ be exceed in some situations.
     *
     * @method Phaser.Structs.Size#setMin
     * @since 3.16.0
     *
     * @param {number} [width=0] - The minimum allowed width of the Size component.
     * @param {number} [height=width] - The minimum allowed height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setMin: function(width, height) {
                        if (width === undefined) width = 0;
                        if (height === undefined) height = width;
                        this.minWidth = Clamp(width, 0, this.maxWidth);
                        this.minHeight = Clamp(height, 0, this.maxHeight);
                        return this.setSize(this._width, this._height);
                    },
                    /**
     * Set the maximum width and height values this Size component will allow.
     *
     * Setting this will automatically adjust both the `width` and `height` properties to ensure they are within range.
     *
     * Note that based on the aspect mode, and if this Size component has a parent set or not, the maximums set here
     * _can_ be exceed in some situations.
     *
     * @method Phaser.Structs.Size#setMax
     * @since 3.16.0
     *
     * @param {number} [width=Number.MAX_VALUE] - The maximum allowed width of the Size component.
     * @param {number} [height=width] - The maximum allowed height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setMax: function(width, height) {
                        if (width === undefined) width = Number.MAX_VALUE;
                        if (height === undefined) height = width;
                        this.maxWidth = Clamp(width, this.minWidth, Number.MAX_VALUE);
                        this.maxHeight = Clamp(height, this.minHeight, Number.MAX_VALUE);
                        return this.setSize(this._width, this._height);
                    },
                    /**
     * Sets the width and height of this Size component based on the aspect mode.
     *
     * If the aspect mode is 'none' then calling this method will change the aspect ratio, otherwise the current
     * aspect ratio is honored across all other modes.
     *
     * If snapTo values have been set then the given width and height are snapped first, prior to any further
     * adjustment via min/max values, or a parent.
     *
     * If minimum and/or maximum dimensions have been specified, the values given to this method will be clamped into
     * that range prior to adjustment, but may still exceed them depending on the aspect mode.
     *
     * If this Size component has a parent set, and the aspect mode is `fit` or `envelop`, then the given sizes will
     * be clamped to the range specified by the parent.
     *
     * @method Phaser.Structs.Size#setSize
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height=width] - The new height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setSize: function(width, height) {
                        if (width === undefined) width = 0;
                        if (height === undefined) height = width;
                        switch(this.aspectMode){
                            case Size.NONE:
                                this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                                this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                                this.aspectRatio = this._height === 0 ? 1 : this._width / this._height;
                                break;
                            case Size.WIDTH_CONTROLS_HEIGHT:
                                this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                                this._height = this.getNewHeight(this._width * (1 / this.aspectRatio), false);
                                break;
                            case Size.HEIGHT_CONTROLS_WIDTH:
                                this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                                this._width = this.getNewWidth(this._height * this.aspectRatio, false);
                                break;
                            case Size.FIT:
                                this.constrain(width, height, true);
                                break;
                            case Size.ENVELOP:
                                this.constrain(width, height, false);
                                break;
                        }
                        return this;
                    },
                    /**
     * Sets a new aspect ratio, overriding what was there previously.
     *
     * It then calls `setSize` immediately using the current dimensions.
     *
     * @method Phaser.Structs.Size#setAspectRatio
     * @since 3.16.0
     *
     * @param {number} ratio - The new aspect ratio.
     *
     * @return {this} This Size component instance.
     */ setAspectRatio: function(ratio) {
                        this.aspectRatio = ratio;
                        return this.setSize(this._width, this._height);
                    },
                    /**
     * Sets a new width and height for this Size component and updates the aspect ratio based on them.
     *
     * It _doesn't_ change the `aspectMode` and still factors in size limits such as the min max and parent bounds.
     *
     * @method Phaser.Structs.Size#resize
     * @since 3.16.0
     *
     * @param {number} width - The new width of the Size component.
     * @param {number} [height=width] - The new height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ resize: function(width, height) {
                        this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                        this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                        this.aspectRatio = this._height === 0 ? 1 : this._width / this._height;
                        return this;
                    },
                    /**
     * Takes a new width and passes it through the min/max clamp and then checks it doesn't exceed the parent width.
     *
     * @method Phaser.Structs.Size#getNewWidth
     * @since 3.16.0
     *
     * @param {number} value - The value to clamp and check.
     * @param {boolean} [checkParent=true] - Check the given value against the parent, if set.
     *
     * @return {number} The modified width value.
     */ getNewWidth: function(value, checkParent) {
                        if (checkParent === undefined) checkParent = true;
                        value = Clamp(value, this.minWidth, this.maxWidth);
                        if (checkParent && this._parent && value > this._parent.width) value = Math.max(this.minWidth, this._parent.width);
                        return value;
                    },
                    /**
     * Takes a new height and passes it through the min/max clamp and then checks it doesn't exceed the parent height.
     *
     * @method Phaser.Structs.Size#getNewHeight
     * @since 3.16.0
     *
     * @param {number} value - The value to clamp and check.
     * @param {boolean} [checkParent=true] - Check the given value against the parent, if set.
     *
     * @return {number} The modified height value.
     */ getNewHeight: function(value, checkParent) {
                        if (checkParent === undefined) checkParent = true;
                        value = Clamp(value, this.minHeight, this.maxHeight);
                        if (checkParent && this._parent && value > this._parent.height) value = Math.max(this.minHeight, this._parent.height);
                        return value;
                    },
                    /**
     * The current `width` and `height` are adjusted to fit inside the given dimensions, while keeping the aspect ratio.
     *
     * If `fit` is true there may be some space inside the target area which is not covered if its aspect ratio differs.
     * If `fit` is false the size may extend further out than the target area if the aspect ratios differ.
     *
     * If this Size component has a parent set, then the width and height passed to this method will be clamped so
     * it cannot exceed that of the parent.
     *
     * @method Phaser.Structs.Size#constrain
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     * @param {boolean} [fit=true] - Perform a `fit` (true) constraint, or an `envelop` (false) constraint.
     *
     * @return {this} This Size component instance.
     */ constrain: function(width, height, fit) {
                        if (width === undefined) width = 0;
                        if (height === undefined) height = width;
                        if (fit === undefined) fit = true;
                        width = this.getNewWidth(width);
                        height = this.getNewHeight(height);
                        var snap = this.snapTo;
                        var newRatio = height === 0 ? 1 : width / height;
                        if (fit && this.aspectRatio > newRatio || !fit && this.aspectRatio < newRatio) {
                            //  We need to change the height to fit the width
                            width = SnapFloor(width, snap.x);
                            height = width / this.aspectRatio;
                            if (snap.y > 0) {
                                height = SnapFloor(height, snap.y);
                                //  Reduce the width accordingly
                                width = height * this.aspectRatio;
                            }
                        } else if (fit && this.aspectRatio < newRatio || !fit && this.aspectRatio > newRatio) {
                            //  We need to change the width to fit the height
                            height = SnapFloor(height, snap.y);
                            width = height * this.aspectRatio;
                            if (snap.x > 0) {
                                width = SnapFloor(width, snap.x);
                                //  Reduce the height accordingly
                                height = width * (1 / this.aspectRatio);
                            }
                        }
                        this._width = width;
                        this._height = height;
                        return this;
                    },
                    /**
     * The current `width` and `height` are adjusted to fit inside the given dimensions, while keeping the aspect ratio.
     *
     * There may be some space inside the target area which is not covered if its aspect ratio differs.
     *
     * If this Size component has a parent set, then the width and height passed to this method will be clamped so
     * it cannot exceed that of the parent.
     *
     * @method Phaser.Structs.Size#fitTo
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     *
     * @return {this} This Size component instance.
     */ fitTo: function(width, height) {
                        return this.constrain(width, height, true);
                    },
                    /**
     * The current `width` and `height` are adjusted so that they fully envelope the given dimensions, while keeping the aspect ratio.
     *
     * The size may extend further out than the target area if the aspect ratios differ.
     *
     * If this Size component has a parent set, then the values are clamped so that it never exceeds the parent
     * on the longest axis.
     *
     * @method Phaser.Structs.Size#envelop
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     *
     * @return {this} This Size component instance.
     */ envelop: function(width, height) {
                        return this.constrain(width, height, false);
                    },
                    /**
     * Sets the width of this Size component.
     *
     * Depending on the aspect mode, changing the width may also update the height and aspect ratio.
     *
     * @method Phaser.Structs.Size#setWidth
     * @since 3.16.0
     *
     * @param {number} width - The new width of the Size component.
     *
     * @return {this} This Size component instance.
     */ setWidth: function(value) {
                        return this.setSize(value, this._height);
                    },
                    /**
     * Sets the height of this Size component.
     *
     * Depending on the aspect mode, changing the height may also update the width and aspect ratio.
     *
     * @method Phaser.Structs.Size#setHeight
     * @since 3.16.0
     *
     * @param {number} height - The new height of the Size component.
     *
     * @return {this} This Size component instance.
     */ setHeight: function(value) {
                        return this.setSize(this._width, value);
                    },
                    /**
     * Returns a string representation of this Size component.
     *
     * @method Phaser.Structs.Size#toString
     * @since 3.16.0
     *
     * @return {string} A string representation of this Size component.
     */ toString: function() {
                        return '[{ Size (width=' + this._width + ' height=' + this._height + ' aspectRatio=' + this.aspectRatio + ' aspectMode=' + this.aspectMode + ') }]';
                    },
                    /**
     * Sets the values of this Size component to the `element.style.width` and `height`
     * properties of the given DOM Element. The properties are set as `px` values.
     *
     * @method Phaser.Structs.Size#setCSS
     * @since 3.17.0
     *
     * @param {HTMLElement} element - The DOM Element to set the CSS style on.
     */ setCSS: function(element) {
                        if (element && element.style) {
                            element.style.width = this._width + 'px';
                            element.style.height = this._height + 'px';
                        }
                    },
                    /**
     * Copies the aspect mode, aspect ratio, width and height from this Size component
     * to the given Size component. Note that the parent, if set, is not copied across.
     *
     * @method Phaser.Structs.Size#copy
     * @since 3.16.0
     *
     * @param {Phaser.Structs.Size} destination - The Size component to copy the values to.
     *
     * @return {Phaser.Structs.Size} The updated destination Size component.
     */ copy: function(destination) {
                        destination.setAspectMode(this.aspectMode);
                        destination.aspectRatio = this.aspectRatio;
                        return destination.setSize(this.width, this.height);
                    },
                    /**
     * Destroys this Size component.
     *
     * This clears the local properties and any parent object, if set.
     *
     * A destroyed Size component cannot be re-used.
     *
     * @method Phaser.Structs.Size#destroy
     * @since 3.16.0
     */ destroy: function() {
                        this._parent = null;
                        this.snapTo = null;
                    },
                    /**
     * The width of this Size component.
     *
     * This value is clamped to the range specified by `minWidth` and `maxWidth`, if enabled.
     *
     * A width can never be less than zero.
     *
     * Changing this value will automatically update the `height` if the aspect ratio lock is enabled.
     * You can also use the `setWidth` and `getWidth` methods.
     *
     * @name Phaser.Structs.Size#width
     * @type {number}
     * @since 3.16.0
     */ width: {
                        get: function() {
                            return this._width;
                        },
                        set: function(value) {
                            this.setSize(value, this._height);
                        }
                    },
                    /**
     * The height of this Size component.
     *
     * This value is clamped to the range specified by `minHeight` and `maxHeight`, if enabled.
     *
     * A height can never be less than zero.
     *
     * Changing this value will automatically update the `width` if the aspect ratio lock is enabled.
     * You can also use the `setHeight` and `getHeight` methods.
     *
     * @name Phaser.Structs.Size#height
     * @type {number}
     * @since 3.16.0
     */ height: {
                        get: function() {
                            return this._height;
                        },
                        set: function(value) {
                            this.setSize(this._width, value);
                        }
                    }
                });
                /**
 * Do not make the size fit the aspect ratio. Change the ratio when the size changes.
 *
 * @name Phaser.Structs.Size.NONE
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.NONE = 0;
                /**
 * The height is automatically adjusted based on the width.
 *
 * @name Phaser.Structs.Size.WIDTH_CONTROLS_HEIGHT
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.WIDTH_CONTROLS_HEIGHT = 1;
                /**
 * The width is automatically adjusted based on the height.
 *
 * @name Phaser.Structs.Size.HEIGHT_CONTROLS_WIDTH
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.HEIGHT_CONTROLS_WIDTH = 2;
                /**
 * The width and height are automatically adjusted to fit inside the given target area, while keeping the aspect ratio. Depending on the aspect ratio there may be some space inside the area which is not covered.
 *
 * @name Phaser.Structs.Size.FIT
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.FIT = 3;
                /**
 * The width and height are automatically adjusted to make the size cover the entire target area while keeping the aspect ratio. This may extend further out than the target size.
 *
 * @name Phaser.Structs.Size.ENVELOP
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.ENVELOP = 4;
                module1.exports = Size;
            /***/ },
            /***/ 15238: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Process Queue Add Event.
 *
 * This event is dispatched by a Process Queue when a new item is successfully moved to its active list.
 *
 * You will most commonly see this used by a Scene's Update List when a new Game Object has been added.
 *
 * In that instance, listen to this event from within a Scene using: `this.sys.updateList.on('add', listener)`.
 *
 * @event Phaser.Structs.Events#PROCESS_QUEUE_ADD
 * @type {string}
 * @since 3.20.0
 *
 * @param {*} item - The item that was added to the Process Queue.
 */ module1.exports = 'add';
            /***/ },
            /***/ 56187: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Process Queue Remove Event.
 *
 * This event is dispatched by a Process Queue when a new item is successfully removed from its active list.
 *
 * You will most commonly see this used by a Scene's Update List when a Game Object has been removed.
 *
 * In that instance, listen to this event from within a Scene using: `this.sys.updateList.on('remove', listener)`.
 *
 * @event Phaser.Structs.Events#PROCESS_QUEUE_REMOVE
 * @type {string}
 * @since 3.20.0
 *
 * @param {*} item - The item that was removed from the Process Queue.
 */ module1.exports = 'remove';
            /***/ },
            /***/ 82348: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Structs.Events
 */ module1.exports = {
                    PROCESS_QUEUE_ADD: __webpack_require__(15238),
                    PROCESS_QUEUE_REMOVE: __webpack_require__(56187)
                };
            /***/ },
            /***/ 41392: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Structs
 */ module1.exports = {
                    Events: __webpack_require__(82348),
                    List: __webpack_require__(73162),
                    Map: __webpack_require__(90330),
                    ProcessQueue: __webpack_require__(25774),
                    RTree: __webpack_require__(59542),
                    Set: __webpack_require__(35072),
                    Size: __webpack_require__(86555)
                };
            /***/ },
            /***/ 57382: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Clamp = __webpack_require__(45319);
                var Color = __webpack_require__(40987);
                var CONST = __webpack_require__(8054);
                var IsSizePowerOfTwo = __webpack_require__(50030);
                var Texture = __webpack_require__(79237);
                /**
 * @classdesc
 * A Canvas Texture is a special kind of Texture that is backed by an HTML Canvas Element as its source.
 *
 * You can use the properties of this texture to draw to the canvas element directly, using all of the standard
 * canvas operations available in the browser. Any Game Object can be given this texture and will render with it.
 *
 * Note: When running under WebGL the Canvas Texture needs to re-generate its base WebGLTexture and reupload it to
 * the GPU every time you modify it, otherwise the changes you make to this texture will not be visible. To do this
 * you should call `CanvasTexture.refresh()` once you are finished with your changes to the canvas. Try and keep
 * this to a minimum, especially on large canvas sizes, or you may inadvertently thrash the GPU by constantly uploading
 * texture data to it. This restriction does not apply if using the Canvas Renderer.
 *
 * It starts with only one frame that covers the whole of the canvas. You can add further frames, that specify
 * sections of the canvas using the `add` method.
 *
 * Should you need to resize the canvas use the `setSize` method so that it accurately updates all of the underlying
 * texture data as well. Forgetting to do this (i.e. by changing the canvas size directly from your code) could cause
 * graphical errors.
 *
 * @class CanvasTexture
 * @extends Phaser.Textures.Texture
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
 * @param {string} key - The unique string-based key of this Texture.
 * @param {HTMLCanvasElement} source - The canvas element that is used as the base of this texture.
 * @param {number} width - The width of the canvas.
 * @param {number} height - The height of the canvas.
 */ var CanvasTexture = new Class({
                    Extends: Texture,
                    initialize: function CanvasTexture(manager, key, source, width, height) {
                        Texture.call(this, manager, key, source, width, height);
                        this.add('__BASE', 0, 0, 0, width, height);
                        /**
         * A reference to the Texture Source of this Canvas.
         *
         * @name Phaser.Textures.CanvasTexture#_source
         * @type {Phaser.Textures.TextureSource}
         * @private
         * @since 3.7.0
         */ this._source = this.frames['__BASE'].source;
                        /**
         * The source Canvas Element.
         *
         * @name Phaser.Textures.CanvasTexture#canvas
         * @readonly
         * @type {HTMLCanvasElement}
         * @since 3.7.0
         */ this.canvas = this._source.image;
                        /**
         * The 2D Canvas Rendering Context.
         *
         * @name Phaser.Textures.CanvasTexture#context
         * @readonly
         * @type {CanvasRenderingContext2D}
         * @since 3.7.0
         */ this.context = this.canvas.getContext('2d', {
                            willReadFrequently: true
                        });
                        /**
         * The width of the Canvas.
         * This property is read-only, if you wish to change it use the `setSize` method.
         *
         * @name Phaser.Textures.CanvasTexture#width
         * @readonly
         * @type {number}
         * @since 3.7.0
         */ this.width = width;
                        /**
         * The height of the Canvas.
         * This property is read-only, if you wish to change it use the `setSize` method.
         *
         * @name Phaser.Textures.CanvasTexture#height
         * @readonly
         * @type {number}
         * @since 3.7.0
         */ this.height = height;
                        /**
         * The context image data.
         * Use the `update` method to populate this when the canvas changes.
         *
         * @name Phaser.Textures.CanvasTexture#imageData
         * @type {ImageData}
         * @since 3.13.0
         */ this.imageData = this.context.getImageData(0, 0, width, height);
                        /**
         * A Uint8ClampedArray view into the `buffer`.
         * Use the `update` method to populate this when the canvas changes.
         * Note that this is unavailable in some browsers, such as Epic Browser, due to their security restrictions.
         *
         * @name Phaser.Textures.CanvasTexture#data
         * @type {Uint8ClampedArray}
         * @since 3.13.0
         */ this.data = null;
                        if (this.imageData) this.data = this.imageData.data;
                        /**
         * An Uint32Array view into the `buffer`.
         *
         * @name Phaser.Textures.CanvasTexture#pixels
         * @type {Uint32Array}
         * @since 3.13.0
         */ this.pixels = null;
                        /**
         * An ArrayBuffer the same size as the context ImageData.
         *
         * @name Phaser.Textures.CanvasTexture#buffer
         * @type {ArrayBuffer}
         * @since 3.13.0
         */ this.buffer;
                        if (this.data) {
                            if (this.imageData.data.buffer) {
                                this.buffer = this.imageData.data.buffer;
                                this.pixels = new Uint32Array(this.buffer);
                            } else if (window.ArrayBuffer) {
                                this.buffer = new ArrayBuffer(this.imageData.data.length);
                                this.pixels = new Uint32Array(this.buffer);
                            } else this.pixels = this.imageData.data;
                        }
                    },
                    /**
     * This re-creates the `imageData` from the current context.
     * It then re-builds the ArrayBuffer, the `data` Uint8ClampedArray reference and the `pixels` Int32Array.
     *
     * Warning: This is a very expensive operation, so use it sparingly.
     *
     * @method Phaser.Textures.CanvasTexture#update
     * @since 3.13.0
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ update: function() {
                        this.imageData = this.context.getImageData(0, 0, this.width, this.height);
                        this.data = this.imageData.data;
                        if (this.imageData.data.buffer) {
                            this.buffer = this.imageData.data.buffer;
                            this.pixels = new Uint32Array(this.buffer);
                        } else if (window.ArrayBuffer) {
                            this.buffer = new ArrayBuffer(this.imageData.data.length);
                            this.pixels = new Uint32Array(this.buffer);
                        } else this.pixels = this.imageData.data;
                        if (this.manager.game.config.renderType === CONST.WEBGL) this.refresh();
                        return this;
                    },
                    /**
     * Draws the given Image or Canvas element to this CanvasTexture, then updates the internal
     * ImageData buffer and arrays.
     *
     * @method Phaser.Textures.CanvasTexture#draw
     * @since 3.13.0
     *
     * @param {number} x - The x coordinate to draw the source at.
     * @param {number} y - The y coordinate to draw the source at.
     * @param {(HTMLImageElement|HTMLCanvasElement)} source - The element to draw to this canvas.
     * @param {boolean} [update=true] - Update the internal ImageData buffer and arrays.
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ draw: function(x, y, source, update) {
                        if (update === undefined) update = true;
                        this.context.drawImage(source, x, y);
                        if (update) this.update();
                        return this;
                    },
                    /**
     * Draws the given texture frame to this CanvasTexture, then updates the internal
     * ImageData buffer and arrays.
     *
     * @method Phaser.Textures.CanvasTexture#drawFrame
     * @since 3.16.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     * @param {number} [x=0] - The x coordinate to draw the source at.
     * @param {number} [y=0] - The y coordinate to draw the source at.
     * @param {boolean} [update=true] - Update the internal ImageData buffer and arrays.
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ drawFrame: function(key, frame, x, y, update) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (update === undefined) update = true;
                        var textureFrame = this.manager.getFrame(key, frame);
                        if (textureFrame) {
                            var cd = textureFrame.canvasData;
                            var width = textureFrame.cutWidth;
                            var height = textureFrame.cutHeight;
                            var res = textureFrame.source.resolution;
                            this.context.drawImage(textureFrame.source.image, cd.x, cd.y, width, height, x, y, width / res, height / res);
                            if (update) this.update();
                        }
                        return this;
                    },
                    /**
     * Sets a pixel in the CanvasTexture to the given color and alpha values.
     *
     * This is an expensive operation to run in large quantities, so use sparingly.
     *
     * @method Phaser.Textures.CanvasTexture#setPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} red - The red color value. A number between 0 and 255.
     * @param {number} green - The green color value. A number between 0 and 255.
     * @param {number} blue - The blue color value. A number between 0 and 255.
     * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
     *
     * @return {this} This CanvasTexture.
     */ setPixel: function(x, y, red, green, blue, alpha) {
                        if (alpha === undefined) alpha = 255;
                        x = Math.abs(Math.floor(x));
                        y = Math.abs(Math.floor(y));
                        var index = this.getIndex(x, y);
                        if (index > -1) {
                            var imageData = this.context.getImageData(x, y, 1, 1);
                            imageData.data[0] = red;
                            imageData.data[1] = green;
                            imageData.data[2] = blue;
                            imageData.data[3] = alpha;
                            this.context.putImageData(imageData, x, y);
                        }
                        return this;
                    },
                    /**
     * Puts the ImageData into the context of this CanvasTexture at the given coordinates.
     *
     * @method Phaser.Textures.CanvasTexture#putData
     * @since 3.16.0
     *
     * @param {ImageData} imageData - The ImageData to put at the given location.
     * @param {number} x - The x coordinate to put the imageData. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate to put the imageData. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [dirtyX=0] - Horizontal position (x coordinate) of the top-left corner from which the image data will be extracted.
     * @param {number} [dirtyY=0] - Vertical position (x coordinate) of the top-left corner from which the image data will be extracted.
     * @param {number} [dirtyWidth] - Width of the rectangle to be painted. Defaults to the width of the image data.
     * @param {number} [dirtyHeight] - Height of the rectangle to be painted. Defaults to the height of the image data.
     *
     * @return {this} This CanvasTexture.
     */ putData: function(imageData, x, y, dirtyX, dirtyY, dirtyWidth, dirtyHeight) {
                        if (dirtyX === undefined) dirtyX = 0;
                        if (dirtyY === undefined) dirtyY = 0;
                        if (dirtyWidth === undefined) dirtyWidth = imageData.width;
                        if (dirtyHeight === undefined) dirtyHeight = imageData.height;
                        this.context.putImageData(imageData, x, y, dirtyX, dirtyY, dirtyWidth, dirtyHeight);
                        return this;
                    },
                    /**
     * Gets an ImageData region from this CanvasTexture from the position and size specified.
     * You can write this back using `CanvasTexture.putData`, or manipulate it.
     *
     * @method Phaser.Textures.CanvasTexture#getData
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the top-left of the area to get the ImageData from. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the top-left of the area to get the ImageData from. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} width - The width of the rectangle from which the ImageData will be extracted. Positive values are to the right, and negative to the left.
     * @param {number} height - The height of the rectangle from which the ImageData will be extracted. Positive values are down, and negative are up.
     *
     * @return {ImageData} The ImageData extracted from this CanvasTexture.
     */ getData: function(x, y, width, height) {
                        x = Clamp(Math.floor(x), 0, this.width - 1);
                        y = Clamp(Math.floor(y), 0, this.height - 1);
                        width = Clamp(width, 1, this.width - x);
                        height = Clamp(height, 1, this.height - y);
                        var imageData = this.context.getImageData(x, y, width, height);
                        return imageData;
                    },
                    /**
     * Get the color of a specific pixel from this texture and store it in a Color object.
     *
     * If you have drawn anything to this CanvasTexture since it was created you must call `CanvasTexture.update` to refresh the array buffer,
     * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
     *
     * @method Phaser.Textures.CanvasTexture#getPixel
     * @since 3.13.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {Phaser.Display.Color} [out] - A Color object to store the pixel values in. If not provided a new Color object will be created.
     *
     * @return {Phaser.Display.Color} An object with the red, green, blue and alpha values set in the r, g, b and a properties.
     */ getPixel: function(x, y, out) {
                        if (!out) out = new Color();
                        var index = this.getIndex(x, y);
                        if (index > -1) {
                            var data = this.data;
                            var r = data[index + 0];
                            var g = data[index + 1];
                            var b = data[index + 2];
                            var a = data[index + 3];
                            out.setTo(r, g, b, a);
                        }
                        return out;
                    },
                    /**
     * Returns an array containing all of the pixels in the given region.
     *
     * If the requested region extends outside the bounds of this CanvasTexture,
     * the region is truncated to fit.
     *
     * If you have drawn anything to this CanvasTexture since it was created you must call `CanvasTexture.update` to refresh the array buffer,
     * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
     *
     * @method Phaser.Textures.CanvasTexture#getPixels
     * @since 3.16.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left of the region. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [y=0] - The y coordinate of the top-left of the region. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [width] - The width of the region to get. Must be an integer. Defaults to the canvas width if not given.
     * @param {number} [height] - The height of the region to get. Must be an integer. If not given will be set to the `width`.
     *
     * @return {Phaser.Types.Textures.PixelConfig[][]} A 2d array of Pixel objects.
     */ getPixels: function(x, y, width, height) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.width;
                        if (height === undefined) height = width;
                        x = Math.abs(Math.round(x));
                        y = Math.abs(Math.round(y));
                        var left = Clamp(x, 0, this.width);
                        var right = Clamp(x + width, 0, this.width);
                        var top = Clamp(y, 0, this.height);
                        var bottom = Clamp(y + height, 0, this.height);
                        var pixel = new Color();
                        var out = [];
                        for(var py = top; py < bottom; py++){
                            var row = [];
                            for(var px = left; px < right; px++){
                                pixel = this.getPixel(px, py, pixel);
                                row.push({
                                    x: px,
                                    y: py,
                                    color: pixel.color,
                                    alpha: pixel.alphaGL
                                });
                            }
                            out.push(row);
                        }
                        return out;
                    },
                    /**
     * Returns the Image Data index for the given pixel in this CanvasTexture.
     *
     * The index can be used to read directly from the `this.data` array.
     *
     * The index points to the red value in the array. The subsequent 3 indexes
     * point to green, blue and alpha respectively.
     *
     * @method Phaser.Textures.CanvasTexture#getIndex
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     *
     * @return {number}
     */ getIndex: function(x, y) {
                        x = Math.abs(Math.round(x));
                        y = Math.abs(Math.round(y));
                        if (x < this.width && y < this.height) return (x + y * this.width) * 4;
                        else return -1;
                    },
                    /**
     * This should be called manually if you are running under WebGL.
     * It will refresh the WebGLTexture from the Canvas source. Only call this if you know that the
     * canvas has changed, as there is a significant GPU texture allocation cost involved in doing so.
     *
     * @method Phaser.Textures.CanvasTexture#refresh
     * @since 3.7.0
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ refresh: function() {
                        this._source.update();
                        return this;
                    },
                    /**
     * Gets the Canvas Element.
     *
     * @method Phaser.Textures.CanvasTexture#getCanvas
     * @since 3.7.0
     *
     * @return {HTMLCanvasElement} The Canvas DOM element this texture is using.
     */ getCanvas: function() {
                        return this.canvas;
                    },
                    /**
     * Gets the 2D Canvas Rendering Context.
     *
     * @method Phaser.Textures.CanvasTexture#getContext
     * @since 3.7.0
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context this texture is using.
     */ getContext: function() {
                        return this.context;
                    },
                    /**
     * Clears the given region of this Canvas Texture, resetting it back to transparent.
     * If no region is given, the whole Canvas Texture is cleared.
     *
     * @method Phaser.Textures.CanvasTexture#clear
     * @since 3.7.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left of the region to clear.
     * @param {number} [y=0] - The y coordinate of the top-left of the region to clear.
     * @param {number} [width] - The width of the region.
     * @param {number} [height] - The height of the region.
     * @param {boolean} [update=true] - Update the internal ImageData buffer and arrays.
     *
     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
     */ clear: function(x, y, width, height, update) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.width;
                        if (height === undefined) height = this.height;
                        if (update === undefined) update = true;
                        this.context.clearRect(x, y, width, height);
                        if (update) this.update();
                        return this;
                    },
                    /**
     * Changes the size of this Canvas Texture.
     *
     * @method Phaser.Textures.CanvasTexture#setSize
     * @since 3.7.0
     *
     * @param {number} width - The new width of the Canvas.
     * @param {number} [height] - The new height of the Canvas. If not given it will use the width as the height.
     *
     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
     */ setSize: function(width, height) {
                        if (height === undefined) height = width;
                        if (width !== this.width || height !== this.height) {
                            //  Update the Canvas
                            this.canvas.width = width;
                            this.canvas.height = height;
                            //  Update the Texture Source
                            this._source.width = width;
                            this._source.height = height;
                            this._source.isPowerOf2 = IsSizePowerOfTwo(width, height);
                            //  Update the Frame
                            this.frames['__BASE'].setSize(width, height, 0, 0);
                            //  Update this
                            this.width = width;
                            this.height = height;
                            this.refresh();
                        }
                        return this;
                    },
                    /**
     * Destroys this Texture and releases references to its sources and frames.
     *
     * @method Phaser.Textures.CanvasTexture#destroy
     * @since 3.16.0
     */ destroy: function() {
                        Texture.prototype.destroy.call(this);
                        this._source = null;
                        this.canvas = null;
                        this.context = null;
                        this.imageData = null;
                        this.data = null;
                        this.pixels = null;
                        this.buffer = null;
                    }
                });
                module1.exports = CanvasTexture;
            /***/ },
            /***/ 81320: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(10312);
                var Camera = __webpack_require__(38058);
                var CanvasPool = __webpack_require__(27919);
                var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(8054);
                var Frame = __webpack_require__(4327);
                var GetFastValue = __webpack_require__(95540);
                var PIPELINES = __webpack_require__(36060);
                var RenderTarget = __webpack_require__(32302);
                var Texture = __webpack_require__(79237);
                var Utils = __webpack_require__(70554);
                /**
 * @classdesc
 * A Dynamic Texture is a special texture that allows you to draw textures, frames and most kind of
 * Game Objects directly to it.
 *
 * You can take many complex objects and draw them to this one texture, which can then be used as the
 * base texture for other Game Objects, such as Sprites. Should you then update this texture, all
 * Game Objects using it will instantly be updated as well, reflecting the changes immediately.
 *
 * It's a powerful way to generate dynamic textures at run-time that are WebGL friendly and don't invoke
 * expensive GPU uploads on each change.
 *
 * ```js
 * const t = this.textures.addDynamicTexture('player', 64, 128);
 * // draw objects to t
 * this.add.sprite(x, y, 'player');
 * ```
 *
 * Because this is a standard Texture within Phaser, you can add frames to it, meaning you can use it
 * to generate sprite sheets, texture atlases or tile sets.
 *
 * Under WebGL1, a FrameBuffer, which is what this Dynamic Texture uses internally, cannot be anti-aliased.
 * This means that when drawing objects such as Shapes or Graphics instances to this texture, they may appear
 * to be drawn with no aliasing around the edges. This is a technical limitation of WebGL1. To get around it,
 * create your shape as a texture in an art package, then draw that to this texture.
 *
 * Based on the assumption that you will be using this Dynamic Texture as a source for Sprites, it will
 * automatically invert any drawing done to it on the y axis. If you do not require this, please call the
 * `setIsSpriteTexture()` method and pass it `false` as its parameter. Do this before you start drawing
 * to this texture, otherwise you will get vertically inverted frames under WebGL. This isn't required
 * for Canvas.
 *
 * @class DynamicTexture
 * @extends Phaser.Textures.Texture
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
 * @param {string} key - The unique string-based key of this Texture.
 * @param {number} [width=256] - The width of this Dymamic Texture in pixels. Defaults to 256 x 256.
 * @param {number} [height=256] - The height of this Dymamic Texture in pixels. Defaults to 256 x 256.
 * @param {boolean} [forceEven=true] - Force the given width and height to be rounded to even values. This significantly improves the rendering quality. Set to false if you know you need an odd sized texture.
 */ var DynamicTexture = new Class({
                    Extends: Texture,
                    initialize: function DynamicTexture(manager, key, width, height, forceEven) {
                        if (width === undefined) width = 256;
                        if (height === undefined) height = 256;
                        if (forceEven === undefined) forceEven = true;
                        /**
         * The internal data type of this object.
         *
         * @name Phaser.Textures.DynamicTexture#type
         * @type {string}
         * @readonly
         * @since 3.60.0
         */ this.type = 'DynamicTexture';
                        var renderer = manager.game.renderer;
                        var isCanvas = renderer && renderer.type === CONST.CANVAS;
                        var source = isCanvas ? CanvasPool.create2D(this, width, height) : [
                            this
                        ];
                        Texture.call(this, manager, key, source, width, height);
                        this.add('__BASE', 0, 0, 0, width, height);
                        /**
         * A reference to either the Canvas or WebGL Renderer that the Game instance is using.
         *
         * @name Phaser.Textures.DynamicTexture#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.2.0
         */ this.renderer = renderer;
                        /**
         * The width of this Dynamic Texture.
         *
         * Treat this property as read-only. Use the `setSize` method to change the size.
         *
         * @name Phaser.Textures.DynamicTexture#width
         * @type {number}
         * @since 3.60.0
         */ this.width = -1;
                        /**
         * The height of this Dynamic Texture.
         *
         * Treat this property as read-only. Use the `setSize` method to change the size.
         *
         * @name Phaser.Textures.DynamicTexture#height
         * @type {number}
         * @since 3.60.0
         */ this.height = -1;
                        /**
         * This flag is set to 'true' during `beginDraw` and reset to 'false` in `endDraw`,
         * allowing you to determine if this Dynamic Texture is batch drawing, or not.
         *
         * @name Phaser.Textures.DynamicTexture#isDrawing
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isDrawing = false;
                        /**
         * A reference to the Rendering Context belonging to the Canvas Element this Dynamic Texture is drawing to.
         *
         * @name Phaser.Textures.DynamicTexture#canvas
         * @type {HTMLCanvasElement}
         * @since 3.2.0
         */ this.canvas = isCanvas ? source : null;
                        /**
         * The 2D Canvas Rendering Context.
         *
         * @name Phaser.Textures.DynamicTexture#context
         * @readonly
         * @type {CanvasRenderingContext2D}
         * @since 3.7.0
         */ this.context = isCanvas ? source.getContext('2d', {
                            willReadFrequently: true
                        }) : null;
                        /**
         * Is this Dynamic Texture dirty or not? If not it won't spend time clearing or filling itself.
         *
         * @name Phaser.Textures.DynamicTexture#dirty
         * @type {boolean}
         * @since 3.12.0
         */ this.dirty = false;
                        /**
         * Is this Dynamic Texture being used as the base texture for a Sprite Game Object?
         *
         * This is enabled by default, as we expect that will be the core use for Dynamic Textures.
         *
         * However, to disable it, call `RenderTexture.setIsSpriteTexture(false)`.
         *
         * You should do this _before_ drawing to this texture, so that it correctly
         * inverses the frames for WebGL rendering. Not doing so will result in vertically flipped frames.
         *
         * This property is used in the `endDraw` method.
         *
         * @name Phaser.Textures.DynamicTexture#isSpriteTexture
         * @type {boolean}
         * @since 3.60.0
         */ this.isSpriteTexture = true;
                        /**
         * Internal erase mode flag.
         *
         * @name Phaser.Textures.DynamicTexture#_eraseMode
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._eraseMode = false;
                        /**
         * An internal Camera that can be used to move around this Dynamic Texture.
         *
         * Control it just like you would any Scene Camera. The difference is that it only impacts
         * the placement of **Game Objects** (not textures) that you then draw to this texture.
         *
         * You can scroll, zoom and rotate this Camera.
         *
         * @name Phaser.Textures.DynamicTexture#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.12.0
         */ this.camera = new Camera(0, 0, width, height).setScene(manager.game.scene.systemScene, false);
                        /**
         * The Render Target that belongs to this Dynamic Texture.
         *
         * A Render Target encapsulates a framebuffer and texture for the WebGL Renderer.
         *
         * This property remains `null` under Canvas.
         *
         * @name Phaser.Textures.DynamicTexture#renderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.60.0
         */ this.renderTarget = !isCanvas ? new RenderTarget(renderer, width, height, 1, 0, false, false, true, false) : null;
                        /**
         * A reference to the WebGL Single Pipeline.
         *
         * This property remains `null` under Canvas.
         *
         * @name Phaser.Textures.DynamicTexture#pipeline
         * @type {Phaser.Renderer.WebGL.Pipelines.SinglePipeline}
         * @since 3.60.0
         */ this.pipeline = !isCanvas ? renderer.pipelines.get(PIPELINES.SINGLE_PIPELINE) : null;
                        this.setSize(width, height, forceEven);
                    },
                    /**
     * Resizes this Dynamic Texture to the new dimensions given.
     *
     * In WebGL it will destroy and then re-create the frame buffer being used by this Dynamic Texture.
     * In Canvas it will resize the underlying canvas DOM element.
     *
     * Both approaches will erase everything currently drawn to this texture.
     *
     * If the dimensions given are the same as those already being used, calling this method will do nothing.
     *
     * @method Phaser.Textures.DynamicTexture#setSize
     * @since 3.10.0
     *
     * @param {number} width - The new width of this Dynamic Texture.
     * @param {number} [height=width] - The new height of this Dynamic Texture. If not specified, will be set the same as the `width`.
     * @param {boolean} [forceEven=true] - Force the given width and height to be rounded to even values. This significantly improves the rendering quality. Set to false if you know you need an odd sized texture.
     *
     * @return {this} This Dynamic Texture.
     */ setSize: function(width, height, forceEven) {
                        if (height === undefined) height = width;
                        if (forceEven === undefined) forceEven = true;
                        if (forceEven) {
                            width = Math.floor(width);
                            height = Math.floor(height);
                            if (width % 2 !== 0) width++;
                            if (height % 2 !== 0) height++;
                        }
                        var frame = this.get();
                        var source = frame.source;
                        if (width !== this.width || height !== this.height) {
                            if (this.canvas) {
                                this.canvas.width = width;
                                this.canvas.height = height;
                            }
                            var renderTarget = this.renderTarget;
                            if (renderTarget) {
                                if (renderTarget.willResize(width, height)) renderTarget.resize(width, height);
                                if (renderTarget.texture !== source.glTexture) //  The texture has been resized, so is new, so we need to delete the old one
                                this.renderer.deleteTexture(source.glTexture);
                                this.setFromRenderTarget();
                            }
                            this.camera.setSize(width, height);
                            source.width = width;
                            source.height = height;
                            frame.setSize(width, height);
                            this.width = width;
                            this.height = height;
                        } else {
                            //  Resize the frame
                            var baseFrame = this.getSourceImage();
                            if (frame.cutX + width > baseFrame.width) width = baseFrame.width - frame.cutX;
                            if (frame.cutY + height > baseFrame.height) height = baseFrame.height - frame.cutY;
                            frame.setSize(width, height, frame.cutX, frame.cutY);
                        }
                        return this;
                    },
                    /**
     * Links the WebGL Textures used by this Dynamic Texture to its Render Target.
     *
     * This method is called internally by the Dynamic Texture when it is first created,
     * or if you change its size.
     *
     * @method Phaser.Textures.DynamicTexture#setFromRenderTarget
     * @since 3.70.0
     *
     * @return {this} This Dynamic Texture instance.
     */ setFromRenderTarget: function() {
                        var frame = this.get();
                        var source = frame.source;
                        var renderTarget = this.renderTarget;
                        source.isRenderTexture = true;
                        source.isGLTexture = true;
                        source.glTexture = renderTarget.texture;
                        return this;
                    },
                    /**
     * If you are planning on using this Render Texture as a base texture for Sprite
     * Game Objects, then you should call this method with a value of `true` before
     * drawing anything to it, otherwise you will get inverted frames in WebGL.
     *
     * @method Phaser.Textures.DynamicTexture#setIsSpriteTexture
     * @since 3.60.0
     *
     * @param {boolean} value - Is this Render Target being used as a Sprite Texture, or not?
     *
     * @return {this} This Dynamic Texture instance.
     */ setIsSpriteTexture: function(value) {
                        this.isSpriteTexture = value;
                        return this;
                    },
                    /**
     * Fills this Dynamic Texture with the given color.
     *
     * By default it will fill the entire texture, however you can set it to fill a specific
     * rectangular area by using the x, y, width and height arguments.
     *
     * The color should be given in hex format, i.e. 0xff0000 for red, 0x00ff00 for green, etc.
     *
     * @method Phaser.Textures.DynamicTexture#fill
     * @since 3.2.0
     *
     * @param {number} rgb - The color to fill this Dynamic Texture with, such as 0xff0000 for red.
     * @param {number} [alpha=1] - The alpha value used by the fill.
     * @param {number} [x=0] - The left coordinate of the fill rectangle.
     * @param {number} [y=0] - The top coordinate of the fill rectangle.
     * @param {number} [width=this.width] - The width of the fill rectangle.
     * @param {number} [height=this.height] - The height of the fill rectangle.
     *
     * @return {this} This Dynamic Texture instance.
     */ fill: function(rgb, alpha, x, y, width, height) {
                        var camera = this.camera;
                        var renderer = this.renderer;
                        if (alpha === undefined) alpha = 1;
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.width;
                        if (height === undefined) height = this.height;
                        var r = rgb >> 16 & 0xFF;
                        var g = rgb >> 8 & 0xFF;
                        var b = rgb & 0xFF;
                        var renderTarget = this.renderTarget;
                        camera.preRender();
                        if (renderTarget) {
                            renderTarget.bind(true);
                            var pipeline = this.pipeline.manager.set(this.pipeline);
                            var sx = renderer.width / renderTarget.width;
                            var sy = renderer.height / renderTarget.height;
                            var ty = renderTarget.height - (y + height);
                            pipeline.drawFillRect(x * sx, ty * sy, width * sx, height * sy, Utils.getTintFromFloats(b / 255, g / 255, r / 255, 1), alpha);
                            renderTarget.unbind(true);
                        } else {
                            var ctx = this.context;
                            renderer.setContext(ctx);
                            ctx.globalCompositeOperation = 'source-over';
                            ctx.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
                            ctx.fillRect(x, y, width, height);
                            renderer.setContext();
                        }
                        this.dirty = true;
                        return this;
                    },
                    /**
     * Clears a portion or everything from this Dynamic Texture by erasing it and resetting it back to
     * a blank, transparent, texture. To clear an area, specify the `x`, `y`, `width` and `height`.
     * @method Phaser.Textures.DynamicTexture#clear
     * @since 3.2.0
     *
     * @param {number} [x=0] - The left coordinate of the fill rectangle.
     * @param {number} [y=0] - The top coordinate of the fill rectangle.
     * @param {number} [width=this.width] - The width of the fill rectangle.
     * @param {number} [height=this.height] - The height of the fill rectangle.
     * 
     * @return {this} This Dynamic Texture instance.
     */ clear: function(x, y, width, height) {
                        if (this.dirty) {
                            var ctx = this.context;
                            var renderTarget = this.renderTarget;
                            if (renderTarget) renderTarget.clear(x, y, width, height);
                            else if (ctx) {
                                if (x !== undefined && y !== undefined && width !== undefined && height !== undefined) ctx.clearRect(x, y, width, height);
                                else {
                                    ctx.save();
                                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                                    ctx.clearRect(0, 0, this.width, this.height);
                                    ctx.restore();
                                }
                            }
                            this.dirty = false;
                        }
                        return this;
                    },
                    /**
     * Takes the given texture key and frame and then stamps it at the given
     * x and y coordinates. You can use the optional 'config' argument to provide
     * lots more options about how the stamp is applied, including the alpha,
     * tint, angle, scale and origin.
     *
     * By default, the frame will stamp on the x/y coordinates based on its center.
     *
     * If you wish to stamp from the top-left, set the config `originX` and
     * `originY` properties both to zero.
     *
     * @method Phaser.Textures.DynamicTexture#stamp
     * @since 3.60.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture. Set to `null` to skip this argument if not required.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {Phaser.Types.Textures.StampConfig} [config] - The stamp configuration object, allowing you to set the alpha, tint, angle, scale and origin of the stamp.
     *
     * @return {this} This Dynamic Texture instance.
     */ stamp: function(key, frame, x, y, config) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        var alpha = GetFastValue(config, 'alpha', 1);
                        var tint = GetFastValue(config, 'tint', 0xffffff);
                        var angle = GetFastValue(config, 'angle', 0);
                        var rotation = GetFastValue(config, 'rotation', 0);
                        var scale = GetFastValue(config, 'scale', 1);
                        var scaleX = GetFastValue(config, 'scaleX', scale);
                        var scaleY = GetFastValue(config, 'scaleY', scale);
                        var originX = GetFastValue(config, 'originX', 0.5);
                        var originY = GetFastValue(config, 'originY', 0.5);
                        var blendMode = GetFastValue(config, 'blendMode', 0);
                        var erase = GetFastValue(config, 'erase', false);
                        var skipBatch = GetFastValue(config, 'skipBatch', false);
                        var stamp = this.manager.resetStamp(alpha, tint);
                        stamp.setAngle(0);
                        if (angle !== 0) stamp.setAngle(angle);
                        else if (rotation !== 0) stamp.setRotation(rotation);
                        stamp.setScale(scaleX, scaleY);
                        stamp.setTexture(key, frame);
                        stamp.setOrigin(originX, originY);
                        stamp.setBlendMode(blendMode);
                        if (erase) this._eraseMode = true;
                        if (!skipBatch) this.draw(stamp, x, y);
                        else this.batchGameObject(stamp, x, y);
                        if (erase) this._eraseMode = false;
                        return this;
                    },
                    /**
     * Draws the given object, or an array of objects, to this Dynamic Texture using a blend mode of ERASE.
     * This has the effect of erasing any filled pixels present in the objects from this texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Dynamic Texture, or a Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up the texture from the Texture Manager.
     *
     * Note: You cannot erase a Dynamic Texture from itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * If you are not planning on using this Dynamic Texture as a base texture for Sprite
     * Game Objects, then you should set `DynamicTexture.isSpriteTexture = false` before
     * calling this method, otherwise you will get vertically inverted frames in WebGL.
     *
     * @method Phaser.Textures.DynamicTexture#erase
     * @since 3.16.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, Render Texture, Texture Frame, or an array of any of these.
     * @param {number} [x=0] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y=0] - The y position to draw the Frame at, or the offset applied to the object.
     *
     * @return {this} This Dynamic Texture instance.
     */ erase: function(entries, x, y) {
                        this._eraseMode = true;
                        this.draw(entries, x, y);
                        this._eraseMode = false;
                        return this;
                    },
                    /**
     * Draws the given object, or an array of objects, to this Dynamic Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Dynamic Texture, or a Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up the texture from the Texture Manager.
     *
     * Note 1: You cannot draw a Dynamic Texture to itself.
     *
     * Note 2: For Game Objects that have Post FX Pipelines, the pipeline _cannot_ be
     * used when drawn to this texture.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * If you are not planning on using this Dynamic Texture as a base texture for Sprite
     * Game Objects, then you should set `DynamicTexture.isSpriteTexture = false` before
     * calling this method, otherwise you will get vertically inverted frames in WebGL.
     *
     * @method Phaser.Textures.DynamicTexture#draw
     * @since 3.2.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x=0] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y=0] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     *
     * @return {this} This Dynamic Texture instance.
     */ draw: function(entries, x, y, alpha, tint) {
                        this.beginDraw();
                        this.batchDraw(entries, x, y, alpha, tint);
                        this.endDraw();
                        return this;
                    },
                    /**
     * Draws the Texture Frame to the Render Texture at the given position.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 800, 600);
     * rt.drawFrame(key, frame);
     * ```
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * Calling this method will cause a batch flush, so if you've got a stack of things to draw
     * in a tight loop, try using the `draw` method instead.
     *
     * If you need to draw a Sprite to this Render Texture, use the `draw` method instead.
     *
     * If you are not planning on using this Dynamic Texture as a base texture for Sprite
     * Game Objects, then you should set `DynamicTexture.isSpriteTexture = false` before
     * calling this method, otherwise you will get vertically inverted frames in WebGL.
     *
     * @method Phaser.Textures.DynamicTexture#drawFrame
     * @since 3.12.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture. Set to `null` to skip this argument if not required.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. WebGL only.
     *
     * @return {this} This Dynamic Texture instance.
     */ drawFrame: function(key, frame, x, y, alpha, tint) {
                        this.beginDraw();
                        this.batchDrawFrame(key, frame, x, y, alpha, tint);
                        this.endDraw();
                        return this;
                    },
                    /**
     * Takes the given Texture Frame and draws it to this Dynamic Texture as a fill pattern,
     * i.e. in a grid-layout based on the frame dimensions.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * You can optionally provide a position, width, height, alpha and tint value to apply to
     * the frames before they are drawn. The position controls the top-left where the repeating
     * fill will start from. The width and height control the size of the filled area.
     *
     * The position can be negative if required, but the dimensions cannot.
     *
     * Calling this method will cause a batch flush by default. Use the `skipBatch` argument
     * to disable this if this call is part of a larger batch draw.
     *
     * If you are not planning on using this Dynamic Texture as a base texture for Sprite
     * Game Objects, then you should set `DynamicTexture.isSpriteTexture = false` before
     * calling this method, otherwise you will get vertically inverted frames in WebGL.
     *
     * @method Phaser.Textures.DynamicTexture#repeat
     * @since 3.60.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture. Set to `null` to skip this argument if not required.
     * @param {number} [x=0] - The x position to start drawing the frames from (can be negative to offset).
     * @param {number} [y=0] - The y position to start drawing the frames from (can be negative to offset).
     * @param {number} [width=this.width] - The width of the area to repeat the frame within. Defaults to the width of this Dynamic Texture.
     * @param {number} [height=this.height] - The height of the area to repeat the frame within. Defaults to the height of this Dynamic Texture.
     * @param {number} [alpha=1] - The alpha to use. Defaults to 1, no alpha.
     * @param {number} [tint=0xffffff] - WebGL only. The tint color to use. Leave as undefined, or 0xffffff to have no tint.
     * @param {boolean} [skipBatch=false] - Skip beginning and ending a batch with this call. Use if this is part of a bigger batched draw.
     *
     * @return {this} This Dynamic Texture instance.
     */ repeat: function(key, frame, x, y, width, height, alpha, tint, skipBatch) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.width;
                        if (height === undefined) height = this.height;
                        if (alpha === undefined) alpha = 1;
                        if (tint === undefined) tint = 0xffffff;
                        if (skipBatch === undefined) skipBatch = false;
                        if (key instanceof Frame) frame = key;
                        else frame = this.manager.getFrame(key, frame);
                        if (!frame) return this;
                        var stamp = this.manager.resetStamp(alpha, tint);
                        stamp.setFrame(frame);
                        stamp.setOrigin(0);
                        var frameWidth = frame.width;
                        var frameHeight = frame.height;
                        //  Clamp to integer
                        width = Math.floor(width);
                        height = Math.floor(height);
                        //  How many stamps can we fit in horizontally and vertically?
                        //  We round this number up to allow for excess overflow
                        var hmax = Math.ceil(width / frameWidth);
                        var vmax = Math.ceil(height / frameHeight);
                        //  How much extra horizontal and vertical space do we have on the right/bottom?
                        var hdiff = hmax * frameWidth - width;
                        var vdiff = vmax * frameHeight - height;
                        if (hdiff > 0) hdiff = frameWidth - hdiff;
                        if (vdiff > 0) vdiff = frameHeight - vdiff;
                        //  x/y may be negative
                        if (x < 0) hmax += Math.ceil(Math.abs(x) / frameWidth);
                        if (y < 0) vmax += Math.ceil(Math.abs(y) / frameHeight);
                        var dx = x;
                        var dy = y;
                        var useCrop = false;
                        var cropRect = this.manager.stampCrop.setTo(0, 0, frameWidth, frameHeight);
                        if (!skipBatch) this.beginDraw();
                        for(var ty = 0; ty < vmax; ty++){
                            //  Negative offset?
                            if (dy + frameHeight < 0) {
                                //  We can't see it, as it's off the top
                                dy += frameHeight;
                                continue;
                            }
                            for(var tx = 0; tx < hmax; tx++){
                                useCrop = false;
                                //  Negative offset?
                                if (dx + frameWidth < 0) {
                                    //  We can't see it, as it's fully off the left
                                    dx += frameWidth;
                                    continue;
                                } else if (dx < 0) {
                                    //  Partially off the left
                                    useCrop = true;
                                    cropRect.width = frameWidth + dx;
                                    cropRect.x = frameWidth - cropRect.width;
                                }
                                //  Negative vertical offset
                                if (dy < 0) {
                                    //  Partially off the top
                                    useCrop = true;
                                    cropRect.height = frameHeight + dy;
                                    cropRect.y = frameHeight - cropRect.height;
                                }
                                if (hdiff > 0 && tx === hmax - 1) {
                                    useCrop = true;
                                    cropRect.width = hdiff;
                                }
                                if (vdiff > 0 && ty === vmax - 1) {
                                    useCrop = true;
                                    cropRect.height = vdiff;
                                }
                                if (useCrop) stamp.setCrop(cropRect);
                                this.batchGameObject(stamp, dx, dy);
                                //  Reset crop
                                stamp.isCropped = false;
                                cropRect.setTo(0, 0, frameWidth, frameHeight);
                                dx += frameWidth;
                            }
                            dx = x;
                            dy += frameHeight;
                        }
                        if (!skipBatch) this.endDraw();
                        return this;
                    },
                    /**
     * Use this method if you need to batch draw a large number of Game Objects to
     * this Dynamic Texture in a single pass, or on a frequent basis. This is especially
     * useful under WebGL, however, if your game is using Canvas only, it will not make
     * any speed difference in that situation.
     *
     * This method starts the beginning of a batched draw, unless one is already open.
     *
     * Batched drawing is faster than calling `draw` in loop, but you must be careful
     * to manage the flow of code and remember to call `endDraw()` when you're finished.
     *
     * If you don't need to draw large numbers of objects it's much safer and easier
     * to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * DynamicTexture.beginDraw();
     *
     * // repeat n times:
     * DynamicTexture.batchDraw();
     * // or
     * DynamicTexture.batchDrawFrame();
     *
     * // Call once:
     * DynamicTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Dynamic Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `DynamicTexture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * @method Phaser.Textures.DynamicTexture#beginDraw
     * @since 3.50.0
     *
     * @return {this} This Dynamic Texture instance.
     */ beginDraw: function() {
                        if (!this.isDrawing) {
                            var camera = this.camera;
                            var renderer = this.renderer;
                            var renderTarget = this.renderTarget;
                            camera.preRender();
                            if (renderTarget) renderer.beginCapture(renderTarget.width, renderTarget.height);
                            else renderer.setContext(this.context);
                            this.isDrawing = true;
                        }
                        return this;
                    },
                    /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of objects to this Dynamic Texture.
     *
     * This method batches the drawing of the given objects to this texture,
     * without causing a WebGL bind or batch flush for each one.
     *
     * It is faster than calling `draw`, but you must be careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * DynamicTexture.beginDraw();
     *
     * // repeat n times:
     * DynamicTexture.batchDraw();
     * // or
     * DynamicTexture.batchDrawFrame();
     *
     * // Call once:
     * DynamicTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Dynamic Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `DynamicTexture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * This method can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Dynamic Texture or Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot draw a Dynamic Texture to itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * @method Phaser.Textures.DynamicTexture#batchDraw
     * @since 3.50.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Dynamic or Texture, Texture Frame or an array of any of these.
     * @param {number} [x=0] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y=0] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     *
     * @return {this} This Dynamic Texture instance.
     */ batchDraw: function(entries, x, y, alpha, tint) {
                        if (!Array.isArray(entries)) entries = [
                            entries
                        ];
                        this.batchList(entries, x, y, alpha, tint);
                        return this;
                    },
                    /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of texture frames to this Dynamic Texture.
     *
     * This method batches the drawing of the given frames to this Dynamic Texture,
     * without causing a WebGL bind or batch flush for each one.
     *
     * It is faster than calling `drawFrame`, but you must be careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of frames it's much safer and easier to use the `drawFrame` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * DynamicTexture.beginDraw();
     *
     * // repeat n times:
     * DynamicTexture.batchDraw();
     * // or
     * DynamicTexture.batchDrawFrame();
     *
     * // Call once:
     * DynamicTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Dynamic Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `DynamicTexture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * @method Phaser.Textures.DynamicTexture#batchDrawFrame
     * @since 3.50.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     *
     * @return {this} This Dynamic Texture instance.
     */ batchDrawFrame: function(key, frame, x, y, alpha, tint) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (alpha === undefined) alpha = 1;
                        if (tint === undefined) tint = 0xffffff;
                        var textureFrame = this.manager.getFrame(key, frame);
                        if (textureFrame) {
                            if (this.renderTarget) this.pipeline.batchTextureFrame(textureFrame, x, y, tint, alpha, this.camera.matrix, null);
                            else this.batchTextureFrame(textureFrame, x, y, alpha, tint);
                        }
                        return this;
                    },
                    /**
     * Use this method to finish batch drawing to this Dynamic Texture.
     *
     * Doing so will stop the WebGL Renderer from capturing draws and then blit the
     * framebuffer to the Render Target owned by this texture.
     *
     * Calling this method without first calling `beginDraw` will have no effect.
     *
     * Batch drawing is faster than calling `draw`, but you must be careful to manage the
     * flow of code and remember to call `endDraw()` when you're finished.
     *
     * If you don't need to draw large numbers of objects it's much safer and easier
     * to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * DynamicTexture.beginDraw();
     *
     * // repeat n times:
     * DynamicTexture.batchDraw();
     * // or
     * DynamicTexture.batchDrawFrame();
     *
     * // Call once:
     * DynamicTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Dynamic Texture while the
     * batch is still open. Doing so will cause a run-time error in the WebGL Renderer.
     *
     * You can use the `DynamicTexture.isDrawing` boolean property to tell if a batch is
     * currently open, or not.
     *
     * @method Phaser.Textures.DynamicTexture#endDraw
     * @since 3.50.0
     *
     * @param {boolean} [erase=false] - Draws all objects in this batch using a blend mode of ERASE. This has the effect of erasing any filled pixels in the objects being drawn.
     *
     * @return {this} This Dynamic Texture instance.
     */ endDraw: function(erase) {
                        if (erase === undefined) erase = this._eraseMode;
                        if (this.isDrawing) {
                            var renderer = this.renderer;
                            var renderTarget = this.renderTarget;
                            if (renderTarget) {
                                var canvasTarget = renderer.endCapture();
                                var util = renderer.pipelines.setUtility();
                                util.blitFrame(canvasTarget, renderTarget, 1, false, false, erase, this.isSpriteTexture);
                                renderer.resetScissor();
                                renderer.resetViewport();
                            } else renderer.setContext();
                            this.dirty = true;
                            this.isDrawing = false;
                        }
                        return this;
                    },
                    /**
     * Internal method that handles the drawing of an array of children.
     *
     * @method Phaser.Textures.DynamicTexture#batchList
     * @private
     * @since 3.12.0
     *
     * @param {array} children - The array of Game Objects, Textures or Frames to draw.
     * @param {number} [x=0] - The x position to offset the Game Object by.
     * @param {number} [y=0] - The y position to offset the Game Object by.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     */ batchList: function(children, x, y, alpha, tint) {
                        var len = children.length;
                        if (len === 0) return;
                        for(var i = 0; i < len; i++){
                            var entry = children[i];
                            if (!entry || entry === this) continue;
                            if (entry.renderWebGL || entry.renderCanvas) //  Game Objects
                            this.batchGameObject(entry, x, y);
                            else if (entry.isParent || entry.list) //  Groups / Display Lists
                            this.batchGroup(entry.getChildren(), x, y);
                            else if (typeof entry === 'string') //  Texture key
                            this.batchTextureFrameKey(entry, null, x, y, alpha, tint);
                            else if (entry instanceof Frame) //  Texture Frame instance
                            this.batchTextureFrame(entry, x, y, alpha, tint);
                            else if (Array.isArray(entry)) //  Another Array
                            this.batchList(entry, x, y, alpha, tint);
                        }
                    },
                    /**
     * Internal method that handles drawing the contents of a Phaser Group to this Dynamic Texture.
     *
     * @method Phaser.Textures.DynamicTexture#batchGroup
     * @private
     * @since 3.12.0
     *
     * @param {array} children - The array of Game Objects to draw.
     * @param {number} [x=0] - The x position to offset the Game Objects by.
     * @param {number} [y=0] - The y position to offset the Game Objects by.
     */ batchGroup: function(children, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        for(var i = 0; i < children.length; i++){
                            var entry = children[i];
                            if (entry.willRender(this.camera)) this.batchGameObject(entry, entry.x + x, entry.y + y);
                        }
                    },
                    /**
     * Internal method that handles drawing a single Phaser Game Object to this Dynamic Texture.
     *
     * @method Phaser.Textures.DynamicTexture#batchGameObject
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to draw.
     * @param {number} [x=0] - The x position to draw the Game Object at.
     * @param {number} [y=0] - The y position to draw the Game Object at.
     */ batchGameObject: function(gameObject, x, y) {
                        if (x === undefined) x = gameObject.x;
                        if (y === undefined) y = gameObject.y;
                        var prevX = gameObject.x;
                        var prevY = gameObject.y;
                        var camera = this.camera;
                        var renderer = this.renderer;
                        var eraseMode = this._eraseMode;
                        var mask = gameObject.mask;
                        gameObject.setPosition(x, y);
                        if (this.canvas) {
                            if (eraseMode) {
                                var blendMode = gameObject.blendMode;
                                gameObject.blendMode = BlendModes.ERASE;
                            }
                            if (mask) mask.preRenderCanvas(renderer, gameObject, camera);
                            gameObject.renderCanvas(renderer, gameObject, camera, null);
                            if (mask) mask.postRenderCanvas(renderer, gameObject, camera);
                            if (eraseMode) gameObject.blendMode = blendMode;
                        } else if (renderer) {
                            if (mask) mask.preRenderWebGL(renderer, gameObject, camera);
                            if (!eraseMode) renderer.setBlendMode(gameObject.blendMode);
                            gameObject.renderWebGL(renderer, gameObject, camera);
                            if (mask) mask.postRenderWebGL(renderer, camera, this.renderTarget);
                        }
                        gameObject.setPosition(prevX, prevY);
                    },
                    /**
     * Internal method that handles the drawing a Texture Frame based on its key.
     *
     * @method Phaser.Textures.DynamicTexture#batchTextureFrameKey
     * @private
     * @since 3.12.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to offset the Game Object by.
     * @param {number} [y=0] - The y position to offset the Game Object by.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     */ batchTextureFrameKey: function(key, frame, x, y, alpha, tint) {
                        var textureFrame = this.manager.getFrame(key, frame);
                        if (textureFrame) this.batchTextureFrame(textureFrame, x, y, alpha, tint);
                    },
                    /**
     * Internal method that handles the drawing of a Texture Frame to this Dynamic Texture.
     *
     * @method Phaser.Textures.DynamicTexture#batchTextureFrame
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Textures.Frame} textureFrame - The Texture Frame to draw.
     * @param {number} [x=0] - The x position to draw the Frame at.
     * @param {number} [y=0] - The y position to draw the Frame at.
     * @param {number} [alpha=1] -  The alpha value. Only used when drawing Texture Frames to this texture. Game Objects use their own alpha.
     * @param {number} [tint=0xffffff] -  The tint color value. Only used when drawing Texture Frames to this texture. Game Objects use their own tint. WebGL only.
     */ batchTextureFrame: function(textureFrame, x, y, alpha, tint) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (alpha === undefined) alpha = 1;
                        if (tint === undefined) tint = 0xffffff;
                        var matrix = this.camera.matrix;
                        var renderTarget = this.renderTarget;
                        if (renderTarget) this.pipeline.batchTextureFrame(textureFrame, x, y, tint, alpha, matrix, null);
                        else {
                            var ctx = this.context;
                            var cd = textureFrame.canvasData;
                            var source = textureFrame.source.image;
                            ctx.save();
                            ctx.globalCompositeOperation = this._eraseMode ? 'destination-out' : 'source-over';
                            ctx.globalAlpha = alpha;
                            matrix.setToContext(ctx);
                            if (cd.width > 0 && cd.height > 0) ctx.drawImage(source, cd.x, cd.y, cd.width, cd.height, x, y, cd.width, cd.height);
                            ctx.restore();
                        }
                    },
                    /**
     * Takes a snapshot of the given area of this Dynamic Texture.
     *
     * The snapshot is taken immediately, but the results are returned via the given callback.
     *
     * To capture the whole Dynamic Texture see the `snapshot` method.
     * To capture just a specific pixel, see the `snapshotPixel` method.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer
     * into an ArrayBufferView. It then parses this, copying the contents to a temporary Canvas and finally
     * creating an Image object from it, which is the image returned to the callback provided.
     *
     * All in all, this is a computationally expensive and blocking process, which gets more expensive
     * the larger the resolution this Dynamic Texture has, so please be careful how you employ this in your game.
     *
     * @method Phaser.Textures.DynamicTexture#snapshotArea
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Dynamic Texture instance.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                        if (this.renderTarget) this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, callback, false, x, y, width, height, type, encoderOptions);
                        else this.renderer.snapshotCanvas(this.canvas, callback, false, x, y, width, height, type, encoderOptions);
                        return this;
                    },
                    /**
     * Takes a snapshot of the whole of this Dynamic Texture.
     *
     * The snapshot is taken immediately, but the results are returned via the given callback.
     *
     * To capture a portion of this Dynamic Texture see the `snapshotArea` method.
     * To capture just a specific pixel, see the `snapshotPixel` method.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer
     * into an ArrayBufferView. It then parses this, copying the contents to a temporary Canvas and finally
     * creating an Image object from it, which is the image returned to the callback provided.
     *
     * All in all, this is a computationally expensive and blocking process, which gets more expensive
     * the larger the resolution this Dynamic Texture has, so please be careful how you employ this in your game.
     *
     * @method Phaser.Textures.DynamicTexture#snapshot
     * @since 3.19.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Dynamic Texture instance.
     */ snapshot: function(callback, type, encoderOptions) {
                        return this.snapshotArea(0, 0, this.width, this.height, callback, type, encoderOptions);
                    },
                    /**
     * Takes a snapshot of the given pixel from this Dynamic Texture.
     *
     * The snapshot is taken immediately, but the results are returned via the given callback.
     *
     * To capture the whole Dynamic Texture see the `snapshot` method.
     * To capture a portion of this Dynamic Texture see the `snapshotArea` method.
     *
     * Unlike the two other snapshot methods, this one will send your callback a `Color` object
     * containing the color data for the requested pixel. It doesn't need to create an internal
     * Canvas or Image object, so is a lot faster to execute, using less memory than the other snapshot methods.
     *
     * @method Phaser.Textures.DynamicTexture#snapshotPixel
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This Dynamic Texture instance.
     */ snapshotPixel: function(x, y, callback) {
                        return this.snapshotArea(x, y, 1, 1, callback, 'pixel');
                    },
                    /**
     * Returns the underlying WebGLTextureWrapper, if not running in Canvas mode.
     *
     * @method Phaser.Textures.DynamicTexture#getWebGLTexture
     * @since 3.60.0
     *
     * @return {?Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} The underlying WebGLTextureWrapper, if not running in Canvas mode.
     */ getWebGLTexture: function() {
                        if (this.renderTarget) return this.renderTarget.texture;
                    },
                    /**
     * Renders this Dynamic Texture onto the Stamp Game Object as a BitmapMask.
     *
     * @method Phaser.Textures.DynamicTexture#renderWebGL
     * @since 3.60.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
     * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
     */ renderWebGL: function(renderer, src, camera, parentMatrix) {
                        var stamp = this.manager.resetStamp();
                        stamp.setTexture(this);
                        stamp.setOrigin(0);
                        stamp.renderWebGL(renderer, stamp, camera, parentMatrix);
                    },
                    /**
     * This is a NOOP method. Bitmap Masks are not supported by the Canvas Renderer.
     *
     * @method Phaser.Textures.DynamicTexture#renderCanvas
     * @since 3.60.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Canvas Renderer which would be rendered to.
     * @param {Phaser.GameObjects.GameObject} mask - The masked Game Object which would be rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     */ renderCanvas: function() {
                    // NOOP
                    },
                    /**
     * Destroys this Texture and releases references to its sources and frames.
     *
     * @method Phaser.Textures.DynamicTexture#destroy
     * @since 3.60.0
     */ destroy: function() {
                        var stamp = this.manager.stamp;
                        if (stamp && stamp.texture === this) this.manager.resetStamp();
                        Texture.prototype.destroy.call(this);
                        CanvasPool.remove(this.canvas);
                        if (this.renderTarget) this.renderTarget.destroy();
                        this.camera.destroy();
                        this.canvas = null;
                        this.context = null;
                        this.renderer = null;
                    }
                });
                module1.exports = DynamicTexture;
            /***/ },
            /***/ 4327: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Clamp = __webpack_require__(45319);
                var Extend = __webpack_require__(79291);
                /**
 * @classdesc
 * A Frame is a section of a Texture.
 *
 * @class Frame
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture this Frame is a part of.
 * @param {(number|string)} name - The name of this Frame. The name is unique within the Texture.
 * @param {number} sourceIndex - The index of the TextureSource that this Frame is a part of.
 * @param {number} x - The x coordinate of the top-left of this Frame.
 * @param {number} y - The y coordinate of the top-left of this Frame.
 * @param {number} width - The width of this Frame.
 * @param {number} height - The height of this Frame.
 */ var Frame = new Class({
                    initialize: function Frame(texture, name, sourceIndex, x, y, width, height) {
                        /**
         * The Texture this Frame is a part of.
         *
         * @name Phaser.Textures.Frame#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = texture;
                        /**
         * The name of this Frame.
         * The name is unique within the Texture.
         *
         * @name Phaser.Textures.Frame#name
         * @type {string}
         * @since 3.0.0
         */ this.name = name;
                        /**
         * The TextureSource this Frame is part of.
         *
         * @name Phaser.Textures.Frame#source
         * @type {Phaser.Textures.TextureSource}
         * @since 3.0.0
         */ this.source = texture.source[sourceIndex];
                        /**
         * The index of the TextureSource in the Texture sources array.
         *
         * @name Phaser.Textures.Frame#sourceIndex
         * @type {number}
         * @since 3.0.0
         */ this.sourceIndex = sourceIndex;
                        /**
         * X position within the source image to cut from.
         *
         * @name Phaser.Textures.Frame#cutX
         * @type {number}
         * @since 3.0.0
         */ this.cutX;
                        /**
         * Y position within the source image to cut from.
         *
         * @name Phaser.Textures.Frame#cutY
         * @type {number}
         * @since 3.0.0
         */ this.cutY;
                        /**
         * The width of the area in the source image to cut.
         *
         * @name Phaser.Textures.Frame#cutWidth
         * @type {number}
         * @since 3.0.0
         */ this.cutWidth;
                        /**
         * The height of the area in the source image to cut.
         *
         * @name Phaser.Textures.Frame#cutHeight
         * @type {number}
         * @since 3.0.0
         */ this.cutHeight;
                        /**
         * The X rendering offset of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                        /**
         * The Y rendering offset of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                        /**
         * The rendering width of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#width
         * @type {number}
         * @since 3.0.0
         */ this.width;
                        /**
         * The rendering height of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#height
         * @type {number}
         * @since 3.0.0
         */ this.height;
                        /**
         * Half the width, floored.
         * Precalculated for the renderer.
         *
         * @name Phaser.Textures.Frame#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth;
                        /**
         * Half the height, floored.
         * Precalculated for the renderer.
         *
         * @name Phaser.Textures.Frame#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight;
                        /**
         * The x center of this frame, floored.
         *
         * @name Phaser.Textures.Frame#centerX
         * @type {number}
         * @since 3.0.0
         */ this.centerX;
                        /**
         * The y center of this frame, floored.
         *
         * @name Phaser.Textures.Frame#centerY
         * @type {number}
         * @since 3.0.0
         */ this.centerY;
                        /**
         * The horizontal pivot point of this Frame.
         *
         * @name Phaser.Textures.Frame#pivotX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.pivotX = 0;
                        /**
         * The vertical pivot point of this Frame.
         *
         * @name Phaser.Textures.Frame#pivotY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.pivotY = 0;
                        /**
         * Does this Frame have a custom pivot point?
         *
         * @name Phaser.Textures.Frame#customPivot
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customPivot = false;
                        /**
         * **CURRENTLY UNSUPPORTED**
         *
         * Is this frame is rotated or not in the Texture?
         * Rotation allows you to use rotated frames in texture atlas packing.
         * It has nothing to do with Sprite rotation.
         *
         * @name Phaser.Textures.Frame#rotated
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.rotated = false;
                        /**
         * Over-rides the Renderer setting.
         * -1 = use Renderer Setting
         * 0 = No rounding
         * 1 = Round
         *
         * @name Phaser.Textures.Frame#autoRound
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.autoRound = -1;
                        /**
         * Any Frame specific custom data can be stored here.
         *
         * @name Phaser.Textures.Frame#customData
         * @type {object}
         * @since 3.0.0
         */ this.customData = {};
                        /**
         * WebGL UV u0 value.
         *
         * @name Phaser.Textures.Frame#u0
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.u0 = 0;
                        /**
         * WebGL UV v0 value.
         *
         * @name Phaser.Textures.Frame#v0
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.v0 = 0;
                        /**
         * WebGL UV u1 value.
         *
         * @name Phaser.Textures.Frame#u1
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.u1 = 0;
                        /**
         * WebGL UV v1 value.
         *
         * @name Phaser.Textures.Frame#v1
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.v1 = 0;
                        /**
         * The un-modified source frame, trim and UV data.
         *
         * @name Phaser.Textures.Frame#data
         * @type {object}
         * @private
         * @since 3.0.0
         */ this.data = {
                            cut: {
                                x: 0,
                                y: 0,
                                w: 0,
                                h: 0,
                                r: 0,
                                b: 0
                            },
                            trim: false,
                            sourceSize: {
                                w: 0,
                                h: 0
                            },
                            spriteSourceSize: {
                                x: 0,
                                y: 0,
                                w: 0,
                                h: 0,
                                r: 0,
                                b: 0
                            },
                            radius: 0,
                            drawImage: {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            },
                            is3Slice: false,
                            scale9: false,
                            scale9Borders: {
                                x: 0,
                                y: 0,
                                w: 0,
                                h: 0
                            }
                        };
                        this.setSize(width, height, x, y);
                    },
                    /**
     * Sets the x and y position within the source image to cut from.
     *
     * @method Phaser.Textures.Frame#setCutPosition
     * @since 3.85.0
     *
     * @param {number} [x=0] - X position within the source image to cut from.
     * @param {number} [y=0] - Y position within the source image to cut from.
     *
     * @return {this} This Frame object.
     */ setCutPosition: function(x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        this.cutX = x;
                        this.cutY = y;
                        return this.updateUVs();
                    },
                    /**
     * Sets the width, and height of the area in the source image to cut.
     *
     * @method Phaser.Textures.Frame#setCutSize
     * @since 3.85.0
     *
     * @param {number} width - The width of the area in the source image to cut.
     * @param {number} height - The height of the area in the source image to cut.
     *
     * @return {this} This Frame object.
     */ setCutSize: function(width, height) {
                        this.cutWidth = width;
                        this.cutHeight = height;
                        return this.updateUVs();
                    },
                    /**
     * Sets the width, height, x and y of this Frame.
     *
     * This is called automatically by the constructor
     * and should rarely be changed on-the-fly.
     *
     * @method Phaser.Textures.Frame#setSize
     * @since 3.7.0
     *
     * @param {number} width - The width of the frame before being trimmed.
     * @param {number} height - The height of the frame before being trimmed.
     * @param {number} [x=0] - The x coordinate of the top-left of this Frame.
     * @param {number} [y=0] - The y coordinate of the top-left of this Frame.
     *
     * @return {this} This Frame object.
     */ setSize: function(width, height, x, y) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        this.setCutPosition(x, y);
                        this.setCutSize(width, height);
                        this.width = width;
                        this.height = height;
                        this.halfWidth = Math.floor(width * 0.5);
                        this.halfHeight = Math.floor(height * 0.5);
                        this.centerX = Math.floor(width / 2);
                        this.centerY = Math.floor(height / 2);
                        var data = this.data;
                        var cut = data.cut;
                        cut.x = x;
                        cut.y = y;
                        cut.w = width;
                        cut.h = height;
                        cut.r = x + width;
                        cut.b = y + height;
                        data.sourceSize.w = width;
                        data.sourceSize.h = height;
                        data.spriteSourceSize.w = width;
                        data.spriteSourceSize.h = height;
                        data.radius = 0.5 * Math.sqrt(width * width + height * height);
                        var drawImage = data.drawImage;
                        drawImage.x = x;
                        drawImage.y = y;
                        drawImage.width = width;
                        drawImage.height = height;
                        return this.updateUVs();
                    },
                    /**
     * If the frame was trimmed when added to the Texture Atlas, this records the trim and source data.
     *
     * @method Phaser.Textures.Frame#setTrim
     * @since 3.0.0
     *
     * @param {number} actualWidth - The width of the frame before being trimmed.
     * @param {number} actualHeight - The height of the frame before being trimmed.
     * @param {number} destX - The destination X position of the trimmed frame for display.
     * @param {number} destY - The destination Y position of the trimmed frame for display.
     * @param {number} destWidth - The destination width of the trimmed frame for display.
     * @param {number} destHeight - The destination height of the trimmed frame for display.
     *
     * @return {this} This Frame object.
     */ setTrim: function(actualWidth, actualHeight, destX, destY, destWidth, destHeight) {
                        var data = this.data;
                        var ss = data.spriteSourceSize;
                        //  Store actual values
                        data.trim = true;
                        data.sourceSize.w = actualWidth;
                        data.sourceSize.h = actualHeight;
                        ss.x = destX;
                        ss.y = destY;
                        ss.w = destWidth;
                        ss.h = destHeight;
                        ss.r = destX + destWidth;
                        ss.b = destY + destHeight;
                        //  Adjust properties
                        this.x = destX;
                        this.y = destY;
                        this.width = destWidth;
                        this.height = destHeight;
                        this.halfWidth = destWidth * 0.5;
                        this.halfHeight = destHeight * 0.5;
                        this.centerX = Math.floor(destWidth / 2);
                        this.centerY = Math.floor(destHeight / 2);
                        return this.updateUVs();
                    },
                    /**
     * Sets the scale9 center rectangle values.
     *
     * Scale9 is a feature of Texture Packer, allowing you to define a nine-slice scaling grid.
     *
     * This is set automatically by the JSONArray and JSONHash parsers.
     *
     * @method Phaser.Textures.Frame#setScale9
     * @since 3.70.0
     *
     * @param {number} x - The left coordinate of the center scale9 rectangle.
     * @param {number} y - The top coordinate of the center scale9 rectangle.
     * @param {number} width - The width of the center scale9 rectangle.
     * @param {number} height - The height coordinate of the center scale9 rectangle.
     *
     * @return {this} This Frame object.
     */ setScale9: function(x, y, width, height) {
                        var data = this.data;
                        data.scale9 = true;
                        data.is3Slice = y === 0 && height === this.height;
                        data.scale9Borders.x = x;
                        data.scale9Borders.y = y;
                        data.scale9Borders.w = width;
                        data.scale9Borders.h = height;
                        return this;
                    },
                    /**
     * Takes a crop data object and, based on the rectangular region given, calculates the
     * required UV coordinates in order to crop this Frame for WebGL and Canvas rendering.
     *
     * The crop size as well as coordinates can not exceed the the size of the frame.
     * 
     * This is called directly by the Game Object Texture Components `setCrop` method.
     * Please use that method to crop a Game Object.
     *
     * @method Phaser.Textures.Frame#setCropUVs
     * @since 3.11.0
     *
     * @param {object} crop - The crop data object. This is the `GameObject._crop` property.
     * @param {number} x - The x coordinate to start the crop from. Cannot be negative or exceed the Frame width.
     * @param {number} y - The y coordinate to start the crop from. Cannot be negative or exceed the Frame height.
     * @param {number} width - The width of the crop rectangle. Cannot exceed the Frame width.
     * @param {number} height - The height of the crop rectangle. Cannot exceed the Frame height.
     * @param {boolean} flipX - Does the parent Game Object have flipX set?
     * @param {boolean} flipY - Does the parent Game Object have flipY set?
     *
     * @return {object} The updated crop data object.
     */ setCropUVs: function(crop, x, y, width, height, flipX, flipY) {
                        //  Clamp the input values
                        var cx = this.cutX;
                        var cy = this.cutY;
                        var cw = this.cutWidth;
                        var ch = this.cutHeight;
                        var rw = this.realWidth;
                        var rh = this.realHeight;
                        x = Clamp(x, 0, rw);
                        y = Clamp(y, 0, rh);
                        width = Clamp(width, 0, rw - x);
                        height = Clamp(height, 0, rh - y);
                        var ox = cx + x;
                        var oy = cy + y;
                        var ow = width;
                        var oh = height;
                        var data = this.data;
                        if (data.trim) {
                            var ss = data.spriteSourceSize;
                            //  Need to check for intersection between the cut area and the crop area
                            //  If there is none, we set UV to be empty, otherwise set it to be the intersection area
                            width = Clamp(width, 0, ss.x + cw - x);
                            height = Clamp(height, 0, ss.y + ch - y);
                            var cropRight = x + width;
                            var cropBottom = y + height;
                            var intersects = !(ss.r < x || ss.b < y || ss.x > cropRight || ss.y > cropBottom);
                            if (intersects) {
                                var ix = Math.max(ss.x, x);
                                var iy = Math.max(ss.y, y);
                                var iw = Math.min(ss.r, cropRight) - ix;
                                var ih = Math.min(ss.b, cropBottom) - iy;
                                ow = iw;
                                oh = ih;
                                if (flipX) ox = cx + (cw - (ix - ss.x) - iw);
                                else ox = cx + (ix - ss.x);
                                if (flipY) oy = cy + (ch - (iy - ss.y) - ih);
                                else oy = cy + (iy - ss.y);
                                x = ix;
                                y = iy;
                                width = iw;
                                height = ih;
                            } else {
                                ox = 0;
                                oy = 0;
                                ow = 0;
                                oh = 0;
                            }
                        } else {
                            if (flipX) ox = cx + (cw - x - width);
                            if (flipY) oy = cy + (ch - y - height);
                        }
                        var tw = this.source.width;
                        var th = this.source.height;
                        //  Map the given coordinates into UV space, clamping to the 0-1 range.
                        crop.u0 = Math.max(0, ox / tw);
                        crop.v0 = Math.max(0, oy / th);
                        crop.u1 = Math.min(1, (ox + ow) / tw);
                        crop.v1 = Math.min(1, (oy + oh) / th);
                        crop.x = x;
                        crop.y = y;
                        crop.cx = ox;
                        crop.cy = oy;
                        crop.cw = ow;
                        crop.ch = oh;
                        crop.width = width;
                        crop.height = height;
                        crop.flipX = flipX;
                        crop.flipY = flipY;
                        return crop;
                    },
                    /**
     * Takes a crop data object and recalculates the UVs based on the dimensions inside the crop object.
     * Called automatically by `setFrame`.
     *
     * @method Phaser.Textures.Frame#updateCropUVs
     * @since 3.11.0
     *
     * @param {object} crop - The crop data object. This is the `GameObject._crop` property.
     * @param {boolean} flipX - Does the parent Game Object have flipX set?
     * @param {boolean} flipY - Does the parent Game Object have flipY set?
     *
     * @return {object} The updated crop data object.
     */ updateCropUVs: function(crop, flipX, flipY) {
                        return this.setCropUVs(crop, crop.x, crop.y, crop.width, crop.height, flipX, flipY);
                    },
                    /**
     * Directly sets the canvas and WebGL UV data for this frame.
     *
     * Use this if you need to override the values that are generated automatically
     * when the Frame is created.
     *
     * @method Phaser.Textures.Frame#setUVs
     * @since 3.50.0
     *
     * @param {number} width - Width of this frame for the Canvas data.
     * @param {number} height - Height of this frame for the Canvas data.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     *
     * @return {this} This Frame object.
     */ setUVs: function(width, height, u0, v0, u1, v1) {
                        //  Canvas data
                        var cd = this.data.drawImage;
                        cd.width = width;
                        cd.height = height;
                        //  WebGL data
                        this.u0 = u0;
                        this.v0 = v0;
                        this.u1 = u1;
                        this.v1 = v1;
                        return this;
                    },
                    /**
     * Updates the internal WebGL UV cache and the drawImage cache.
     *
     * @method Phaser.Textures.Frame#updateUVs
     * @since 3.0.0
     *
     * @return {this} This Frame object.
     */ updateUVs: function() {
                        var cx = this.cutX;
                        var cy = this.cutY;
                        var cw = this.cutWidth;
                        var ch = this.cutHeight;
                        //  Canvas data
                        var cd = this.data.drawImage;
                        cd.width = cw;
                        cd.height = ch;
                        //  WebGL data
                        var tw = this.source.width;
                        var th = this.source.height;
                        this.u0 = cx / tw;
                        this.v0 = cy / th;
                        this.u1 = (cx + cw) / tw;
                        this.v1 = (cy + ch) / th;
                        return this;
                    },
                    /**
     * Updates the internal WebGL UV cache.
     *
     * @method Phaser.Textures.Frame#updateUVsInverted
     * @since 3.0.0
     *
     * @return {this} This Frame object.
     */ updateUVsInverted: function() {
                        var tw = this.source.width;
                        var th = this.source.height;
                        this.u0 = (this.cutX + this.cutHeight) / tw;
                        this.v0 = this.cutY / th;
                        this.u1 = this.cutX / tw;
                        this.v1 = (this.cutY + this.cutWidth) / th;
                        return this;
                    },
                    /**
     * Clones this Frame into a new Frame object.
     *
     * @method Phaser.Textures.Frame#clone
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} A clone of this Frame.
     */ clone: function() {
                        var clone = new Frame(this.texture, this.name, this.sourceIndex);
                        clone.cutX = this.cutX;
                        clone.cutY = this.cutY;
                        clone.cutWidth = this.cutWidth;
                        clone.cutHeight = this.cutHeight;
                        clone.x = this.x;
                        clone.y = this.y;
                        clone.width = this.width;
                        clone.height = this.height;
                        clone.halfWidth = this.halfWidth;
                        clone.halfHeight = this.halfHeight;
                        clone.centerX = this.centerX;
                        clone.centerY = this.centerY;
                        clone.rotated = this.rotated;
                        clone.data = Extend(true, clone.data, this.data);
                        clone.updateUVs();
                        return clone;
                    },
                    /**
     * Destroys this Frame by nulling its reference to the parent Texture and and data objects.
     *
     * @method Phaser.Textures.Frame#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.texture = null;
                        this.source = null;
                        this.customData = null;
                        this.data = null;
                    },
                    /**
     * A reference to the Texture Source WebGL Texture that this Frame is using.
     * 
     * @name Phaser.Textures.Frame#glTexture
     * @type {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
     * @readonly
     * @since 3.11.0
     */ glTexture: {
                        get: function() {
                            return this.source.glTexture;
                        }
                    },
                    /**
     * The width of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
     * before being packed.
     *
     * @name Phaser.Textures.Frame#realWidth
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ realWidth: {
                        get: function() {
                            return this.data.sourceSize.w;
                        }
                    },
                    /**
     * The height of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
     * before being packed.
     *
     * @name Phaser.Textures.Frame#realHeight
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ realHeight: {
                        get: function() {
                            return this.data.sourceSize.h;
                        }
                    },
                    /**
     * The radius of the Frame (derived from sqrt(w * w + h * h) / 2)
     *
     * @name Phaser.Textures.Frame#radius
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ radius: {
                        get: function() {
                            return this.data.radius;
                        }
                    },
                    /**
     * Is the Frame trimmed or not?
     *
     * @name Phaser.Textures.Frame#trimmed
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ trimmed: {
                        get: function() {
                            return this.data.trim;
                        }
                    },
                    /**
     * Does the Frame have scale9 border data?
     *
     * @name Phaser.Textures.Frame#scale9
     * @type {boolean}
     * @readonly
     * @since 3.70.0
     */ scale9: {
                        get: function() {
                            return this.data.scale9;
                        }
                    },
                    /**
     * If the Frame has scale9 border data, is it 3-slice or 9-slice data?
     *
     * @name Phaser.Textures.Frame#is3Slice
     * @type {boolean}
     * @readonly
     * @since 3.70.0
     */ is3Slice: {
                        get: function() {
                            return this.data.is3Slice;
                        }
                    },
                    /**
     * The Canvas drawImage data object.
     *
     * @name Phaser.Textures.Frame#canvasData
     * @type {object}
     * @readonly
     * @since 3.0.0
     */ canvasData: {
                        get: function() {
                            return this.data.drawImage;
                        }
                    }
                });
                module1.exports = Frame;
            /***/ },
            /***/ 79237: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Frame = __webpack_require__(4327);
                var TextureSource = __webpack_require__(11876);
                var TEXTURE_MISSING_ERROR = 'Texture "%s" has no frame "%s"';
                /**
 * @classdesc
 * A Texture consists of a source, usually an Image from the Cache, and a collection of Frames.
 * The Frames represent the different areas of the Texture. For example a texture atlas
 * may have many Frames, one for each element within the atlas. Where-as a single image would have
 * just one frame, that encompasses the whole image.
 *
 * Every Texture, no matter where it comes from, always has at least 1 frame called the `__BASE` frame.
 * This frame represents the entirety of the source image.
 *
 * Textures are managed by the global TextureManager. This is a singleton class that is
 * responsible for creating and delivering Textures and their corresponding Frames to Game Objects.
 *
 * Sprites and other Game Objects get the texture data they need from the TextureManager.
 *
 * @class Texture
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
 * @param {string} key - The unique string-based key of this Texture.
 * @param {(HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]|Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper)} source - An array of sources that are used to create the texture. Usually Images, but can also be a Canvas.
 * @param {number} [width] - The width of the Texture. This is optional and automatically derived from the source images.
 * @param {number} [height] - The height of the Texture. This is optional and automatically derived from the source images.
 */ var Texture = new Class({
                    initialize: function Texture(manager, key, source, width, height) {
                        if (!Array.isArray(source)) source = [
                            source
                        ];
                        /**
         * A reference to the Texture Manager this Texture belongs to.
         *
         * @name Phaser.Textures.Texture#manager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.manager = manager;
                        /**
         * The unique string-based key of this Texture.
         *
         * @name Phaser.Textures.Texture#key
         * @type {string}
         * @since 3.0.0
         */ this.key = key;
                        /**
         * An array of TextureSource instances.
         * These are unique to this Texture and contain the actual Image (or Canvas) data.
         *
         * @name Phaser.Textures.Texture#source
         * @type {Phaser.Textures.TextureSource[]}
         * @since 3.0.0
         */ this.source = [];
                        /**
         * An array of TextureSource data instances.
         * Used to store additional data images, such as normal maps or specular maps.
         *
         * @name Phaser.Textures.Texture#dataSource
         * @type {array}
         * @since 3.0.0
         */ this.dataSource = [];
                        /**
         * A key-value object pair associating the unique Frame keys with the Frames objects.
         *
         * @name Phaser.Textures.Texture#frames
         * @type {object}
         * @since 3.0.0
         */ this.frames = {};
                        /**
         * Any additional data that was set in the source JSON (if any),
         * or any extra data you'd like to store relating to this texture
         *
         * @name Phaser.Textures.Texture#customData
         * @type {object}
         * @since 3.0.0
         */ this.customData = {};
                        /**
         * The name of the first frame of the Texture.
         *
         * @name Phaser.Textures.Texture#firstFrame
         * @type {string}
         * @since 3.0.0
         */ this.firstFrame = '__BASE';
                        /**
         * The total number of Frames in this Texture, including the `__BASE` frame.
         *
         * A Texture will always contain at least 1 frame because every Texture contains a `__BASE` frame by default,
         * in addition to any extra frames that have been added to it, such as when parsing a Sprite Sheet or Texture Atlas.
         *
         * @name Phaser.Textures.Texture#frameTotal
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.frameTotal = 0;
                        //  Load the Sources
                        for(var i = 0; i < source.length; i++)this.source.push(new TextureSource(this, source[i], width, height));
                    },
                    /**
     * Adds a new Frame to this Texture.
     *
     * A Frame is a rectangular region of a TextureSource with a unique index or string-based key.
     *
     * The name given must be unique within this Texture. If it already exists, this method will return `null`.
     *
     * @method Phaser.Textures.Texture#add
     * @since 3.0.0
     *
     * @param {(number|string)} name - The name of this Frame. The name is unique within the Texture.
     * @param {number} sourceIndex - The index of the TextureSource that this Frame is a part of.
     * @param {number} x - The x coordinate of the top-left of this Frame.
     * @param {number} y - The y coordinate of the top-left of this Frame.
     * @param {number} width - The width of this Frame.
     * @param {number} height - The height of this Frame.
     *
     * @return {?Phaser.Textures.Frame} The Frame that was added to this Texture, or `null` if the given name already exists.
     */ add: function(name, sourceIndex, x, y, width, height) {
                        if (this.has(name)) return null;
                        var frame = new Frame(this, name, sourceIndex, x, y, width, height);
                        this.frames[name] = frame;
                        //  Set the first frame of the Texture (other than __BASE)
                        //  This is used to ensure we don't spam the display with entire
                        //  atlases of sprite sheets, but instead just the first frame of them
                        //  should the dev incorrectly specify the frame index
                        if (this.firstFrame === '__BASE') this.firstFrame = name;
                        this.frameTotal++;
                        return frame;
                    },
                    /**
     * Removes the given Frame from this Texture. The Frame is destroyed immediately.
     *
     * Any Game Objects using this Frame should stop using it _before_ you remove it,
     * as it does not happen automatically.
     *
     * @method Phaser.Textures.Texture#remove
     * @since 3.19.0
     *
     * @param {string} name - The key of the Frame to remove.
     *
     * @return {boolean} True if a Frame with the matching key was removed from this Texture.
     */ remove: function(name) {
                        if (this.has(name)) {
                            var frame = this.get(name);
                            frame.destroy();
                            delete this.frames[name];
                            return true;
                        }
                        return false;
                    },
                    /**
     * Checks to see if a Frame matching the given key exists within this Texture.
     *
     * @method Phaser.Textures.Texture#has
     * @since 3.0.0
     *
     * @param {string} name - The key of the Frame to check for.
     *
     * @return {boolean} True if a Frame with the matching key exists in this Texture.
     */ has: function(name) {
                        return this.frames.hasOwnProperty(name);
                    },
                    /**
     * Gets a Frame from this Texture based on either the key or the index of the Frame.
     *
     * In a Texture Atlas Frames are typically referenced by a key.
     * In a Sprite Sheet Frames are referenced by an index.
     * Passing no value for the name returns the base texture.
     *
     * @method Phaser.Textures.Texture#get
     * @since 3.0.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {Phaser.Textures.Frame} The Texture Frame.
     */ get: function(name) {
                        //  null, undefined, empty string, zero
                        if (!name) name = this.firstFrame;
                        var frame = this.frames[name];
                        if (!frame) {
                            console.warn(TEXTURE_MISSING_ERROR, this.key, name);
                            frame = this.frames[this.firstFrame];
                        }
                        return frame;
                    },
                    /**
     * Takes the given TextureSource and returns the index of it within this Texture.
     * If it's not in this Texture, it returns -1.
     * Unless this Texture has multiple TextureSources, such as with a multi-atlas, this
     * method will always return zero or -1.
     *
     * @method Phaser.Textures.Texture#getTextureSourceIndex
     * @since 3.0.0
     *
     * @param {Phaser.Textures.TextureSource} source - The TextureSource to check.
     *
     * @return {number} The index of the TextureSource within this Texture, or -1 if not in this Texture.
     */ getTextureSourceIndex: function(source) {
                        for(var i = 0; i < this.source.length; i++){
                            if (this.source[i] === source) return i;
                        }
                        return -1;
                    },
                    /**
     * Returns an array of all the Frames in the given TextureSource.
     *
     * @method Phaser.Textures.Texture#getFramesFromTextureSource
     * @since 3.0.0
     *
     * @param {number} sourceIndex - The index of the TextureSource to get the Frames from.
     * @param {boolean} [includeBase=false] - Include the `__BASE` Frame in the output array?
     *
     * @return {Phaser.Textures.Frame[]} An array of Texture Frames.
     */ getFramesFromTextureSource: function(sourceIndex, includeBase) {
                        if (includeBase === undefined) includeBase = false;
                        var out = [];
                        for(var frameName in this.frames){
                            if (frameName === '__BASE' && !includeBase) continue;
                            var frame = this.frames[frameName];
                            if (frame.sourceIndex === sourceIndex) out.push(frame);
                        }
                        return out;
                    },
                    /**
     * Based on the given Texture Source Index, this method will get all of the Frames using
     * that source and then work out the bounds that they encompass, returning them in an object.
     *
     * This is useful if this Texture is, for example, a sprite sheet within an Atlas, and you
     * need to know the total bounds of the sprite sheet.
     *
     * @method Phaser.Textures.Texture#getFrameBounds
     * @since 3.80.0
     *
     * @param {number} [sourceIndex=0] - The index of the TextureSource to get the Frame bounds from.
     *
     * @return {Phaser.Types.Math.RectangleLike} An object containing the bounds of the Frames using the given Texture Source Index.
     */ getFrameBounds: function(sourceIndex) {
                        if (sourceIndex === undefined) sourceIndex = 0;
                        var frames = this.getFramesFromTextureSource(sourceIndex, true);
                        var baseFrame = frames[0];
                        var minX = baseFrame.cutX;
                        var minY = baseFrame.cutY;
                        var maxX = baseFrame.cutX + baseFrame.cutWidth;
                        var maxY = baseFrame.cutY + baseFrame.cutHeight;
                        for(var i = 1; i < frames.length; i++){
                            var frame = frames[i];
                            if (frame.cutX < minX) minX = frame.cutX;
                            if (frame.cutY < minY) minY = frame.cutY;
                            if (frame.cutX + frame.cutWidth > maxX) maxX = frame.cutX + frame.cutWidth;
                            if (frame.cutY + frame.cutHeight > maxY) maxY = frame.cutY + frame.cutHeight;
                        }
                        return {
                            x: minX,
                            y: minY,
                            width: maxX - minX,
                            height: maxY - minY
                        };
                    },
                    /**
     * Returns an array with all of the names of the Frames in this Texture.
     *
     * Useful if you want to randomly assign a Frame to a Game Object, as you can
     * pick a random element from the returned array.
     *
     * @method Phaser.Textures.Texture#getFrameNames
     * @since 3.0.0
     *
     * @param {boolean} [includeBase=false] - Include the `__BASE` Frame in the output array?
     *
     * @return {string[]} An array of all Frame names in this Texture.
     */ getFrameNames: function(includeBase) {
                        if (includeBase === undefined) includeBase = false;
                        var out = Object.keys(this.frames);
                        if (!includeBase) {
                            var idx = out.indexOf('__BASE');
                            if (idx !== -1) out.splice(idx, 1);
                        }
                        return out;
                    },
                    /**
     * Given a Frame name, return the source image it uses to render with.
     *
     * This will return the actual DOM Image or Canvas element.
     *
     * @method Phaser.Textures.Texture#getSourceImage
     * @since 3.0.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {(HTMLImageElement|HTMLCanvasElement|Phaser.GameObjects.RenderTexture)} The DOM Image, Canvas Element or Render Texture.
     */ getSourceImage: function(name) {
                        if (name === undefined || name === null || this.frameTotal === 1) name = '__BASE';
                        var frame = this.frames[name];
                        if (frame) return frame.source.image;
                        else {
                            console.warn(TEXTURE_MISSING_ERROR, this.key, name);
                            return this.frames['__BASE'].source.image;
                        }
                    },
                    /**
     * Given a Frame name, return the data source image it uses to render with.
     * You can use this to get the normal map for an image for example.
     *
     * This will return the actual DOM Image.
     *
     * @method Phaser.Textures.Texture#getDataSourceImage
     * @since 3.7.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {(HTMLImageElement|HTMLCanvasElement)} The DOM Image or Canvas Element.
     */ getDataSourceImage: function(name) {
                        if (name === undefined || name === null || this.frameTotal === 1) name = '__BASE';
                        var frame = this.frames[name];
                        var idx;
                        if (!frame) {
                            console.warn(TEXTURE_MISSING_ERROR, this.key, name);
                            idx = this.frames['__BASE'].sourceIndex;
                        } else idx = frame.sourceIndex;
                        return this.dataSource[idx].image;
                    },
                    /**
     * Adds a data source image to this Texture.
     *
     * An example of a data source image would be a normal map, where all of the Frames for this Texture
     * equally apply to the normal map.
     *
     * @method Phaser.Textures.Texture#setDataSource
     * @since 3.0.0
     *
     * @param {(HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[])} data - The source image.
     */ setDataSource: function(data) {
                        if (!Array.isArray(data)) data = [
                            data
                        ];
                        for(var i = 0; i < data.length; i++){
                            var source = this.source[i];
                            this.dataSource.push(new TextureSource(this, data[i], source.width, source.height));
                        }
                    },
                    /**
     * Sets the Filter Mode for this Texture.
     *
     * The mode can be either Linear, the default, or Nearest.
     *
     * For pixel-art you should use Nearest.
     *
     * The mode applies to the entire Texture, not just a specific Frame of it.
     *
     * @method Phaser.Textures.Texture#setFilter
     * @since 3.0.0
     *
     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
     */ setFilter: function(filterMode) {
                        var i;
                        for(i = 0; i < this.source.length; i++)this.source[i].setFilter(filterMode);
                        for(i = 0; i < this.dataSource.length; i++)this.dataSource[i].setFilter(filterMode);
                    },
                    /**
     * Destroys this Texture and releases references to its sources and frames.
     *
     * @method Phaser.Textures.Texture#destroy
     * @since 3.0.0
     */ destroy: function() {
                        var i;
                        var source = this.source;
                        var dataSource = this.dataSource;
                        for(i = 0; i < source.length; i++)if (source[i]) source[i].destroy();
                        for(i = 0; i < dataSource.length; i++)if (dataSource[i]) dataSource[i].destroy();
                        for(var frameName in this.frames){
                            var frame = this.frames[frameName];
                            if (frame) frame.destroy();
                        }
                        this.source = [];
                        this.dataSource = [];
                        this.frames = {};
                        this.manager.removeKey(this.key);
                        this.manager = null;
                    }
                });
                module1.exports = Texture;
            /***/ },
            /***/ 17130: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(27919);
                var CanvasTexture = __webpack_require__(57382);
                var Class = __webpack_require__(83419);
                var Color = __webpack_require__(40987);
                var CONST = __webpack_require__(8054);
                var DynamicTexture = __webpack_require__(81320);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(69442);
                var Frame = __webpack_require__(4327);
                var GameEvents = __webpack_require__(8443);
                var GenerateTexture = __webpack_require__(99584);
                var GetValue = __webpack_require__(35154);
                var ImageGameObject = __webpack_require__(88571);
                var IsPlainObject = __webpack_require__(41212);
                var Parser = __webpack_require__(61309);
                var Rectangle = __webpack_require__(87841);
                var Texture = __webpack_require__(79237);
                /**
 * @callback EachTextureCallback
 *
 * @param {Phaser.Textures.Texture} texture - Each texture in Texture Manager.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 */ /**
 * @classdesc
 * When Phaser boots it will create an instance of this Texture Manager class.
 *
 * It is a global manager that handles all textures in your game. You can access it from within
 * a Scene via the `this.textures` property.
 *
 * Its role is as a manager for all textures that your game uses. It can create, update and remove
 * textures globally, as well as parse texture data from external files, such as sprite sheets
 * and texture atlases.
 *
 * Sprites and other texture-based Game Objects get their texture data directly from this class.
 *
 * @class TextureManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance this Texture Manager belongs to.
 */ var TextureManager = new Class({
                    Extends: EventEmitter,
                    initialize: function TextureManager(game) {
                        EventEmitter.call(this);
                        /**
         * The Game that the Texture Manager belongs to.
         *
         * A game will only ever have one instance of a Texture Manager.
         *
         * @name Phaser.Textures.TextureManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                        /**
         * The internal name of this manager.
         *
         * @name Phaser.Textures.TextureManager#name
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.name = 'TextureManager';
                        /**
         * This object contains all Textures that belong to this Texture Manager.
         *
         * Textures are identified by string-based keys, which are used as the property
         * within this object. Therefore, you can access any texture directly from this
         * object without any iteration.
         *
         * You should not typically modify this object directly, but instead use the
         * methods provided by the Texture Manager to add and remove entries from it.
         *
         * @name Phaser.Textures.TextureManager#list
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.list = {};
                        /**
         * The temporary canvas element used to save the pixel data of an arbitrary texture
         * during the `TextureManager.getPixel` and `getPixelAlpha` methods.
         *
         * @name Phaser.Textures.TextureManager#_tempCanvas
         * @type {HTMLCanvasElement}
         * @private
         * @since 3.0.0
         */ this._tempCanvas = CanvasPool.create2D(this);
                        /**
         * The 2d context of the `_tempCanvas` element.
         *
         * @name Phaser.Textures.TextureManager#_tempContext
         * @type {CanvasRenderingContext2D}
         * @private
         * @since 3.0.0
         */ this._tempContext = this._tempCanvas.getContext('2d', {
                            willReadFrequently: true
                        });
                        /**
         * An internal tracking value used for emitting the 'READY' event after all of
         * the managers in the game have booted.
         *
         * @name Phaser.Textures.TextureManager#_pending
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pending = 0;
                        /**
         * An Image Game Object that belongs to this Texture Manager.
         *
         * Used as a drawing stamp within Dynamic Textures.
         *
         * This is not part of the display list and doesn't render.
         *
         * @name Phaser.Textures.TextureManager#stamp
         * @type {Phaser.GameObjects.Image}
         * @readonly
         * @since 3.60.0
         */ this.stamp;
                        /**
         * The crop Rectangle as used by the Stamp when it needs to crop itself.
         *
         * @name Phaser.Textures.TextureManager#stampCrop
         * @type {Phaser.Geom.Rectangle}
         * @since 3.60.0
         */ this.stampCrop = new Rectangle();
                        /**
         * If this flag is `true` then the Texture Manager will never emit any
         * warnings to the console log that report missing textures.
         *
         * @name Phaser.Textures.TextureManager#silentWarnings
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.silentWarnings = false;
                        game.events.once(GameEvents.BOOT, this.boot, this);
                    },
                    /**
     * The Boot Handler called by Phaser.Game when it first starts up.
     *
     * @method Phaser.Textures.TextureManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                        this._pending = 3;
                        this.on(Events.LOAD, this.updatePending, this);
                        this.on(Events.ERROR, this.updatePending, this);
                        var config = this.game.config;
                        if (config.defaultImage !== null) this.addBase64('__DEFAULT', config.defaultImage);
                        if (config.missingImage !== null) this.addBase64('__MISSING', config.missingImage);
                        if (config.whiteImage !== null) this.addBase64('__WHITE', config.whiteImage);
                        if (this.game.renderer && this.game.renderer.gl) this.addUint8Array('__NORMAL', new Uint8Array([
                            127,
                            127,
                            255,
                            255
                        ]), 1, 1);
                        this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                        this.game.events.once(GameEvents.SYSTEM_READY, function(scene) {
                            this.stamp = new ImageGameObject(scene).setOrigin(0);
                        }, this);
                    },
                    /**
     * After 'onload' or 'onerror' invoked twice, emit 'ready' event.
     *
     * @method Phaser.Textures.TextureManager#updatePending
     * @private
     * @since 3.0.0
     */ updatePending: function() {
                        this._pending--;
                        if (this._pending === 0) {
                            this.off(Events.LOAD);
                            this.off(Events.ERROR);
                            this.emit(Events.READY);
                        }
                    },
                    /**
     * Checks the given texture key and throws a console.warn if the key is already in use, then returns false.
     *
     * If you wish to avoid the console.warn then use `TextureManager.exists` instead.
     *
     * @method Phaser.Textures.TextureManager#checkKey
     * @since 3.7.0
     *
     * @param {string} key - The texture key to check.
     *
     * @return {boolean} `true` if it's safe to use the texture key, otherwise `false`.
     */ checkKey: function(key) {
                        if (!key || typeof key !== 'string' || this.exists(key)) {
                            if (!this.silentWarnings) // eslint-disable-next-line no-console
                            console.error('Texture key already in use: ' + key);
                            return false;
                        }
                        return true;
                    },
                    /**
     * Removes a Texture from the Texture Manager and destroys it. This will immediately
     * clear all references to it from the Texture Manager, and if it has one, destroy its
     * WebGLTexture. This will emit a `removetexture` event.
     *
     * Note: If you have any Game Objects still using this texture they will start throwing
     * errors the next time they try to render. Make sure that removing the texture is the final
     * step when clearing down to avoid this.
     *
     * @method Phaser.Textures.TextureManager#remove
     * @fires Phaser.Textures.Events#REMOVE
     * @since 3.7.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The key of the Texture to remove, or a reference to it.
     *
     * @return {Phaser.Textures.TextureManager} The Texture Manager.
     */ remove: function(key) {
                        if (typeof key === 'string') {
                            if (this.exists(key)) key = this.get(key);
                            else {
                                if (!this.silentWarnings) console.warn('No texture found matching key: ' + key);
                                return this;
                            }
                        }
                        //  By this point key should be a Texture, if not, the following fails anyway
                        var textureKey = key.key;
                        if (this.list.hasOwnProperty(textureKey)) {
                            key.destroy();
                            this.emit(Events.REMOVE, textureKey);
                            this.emit(Events.REMOVE_KEY + textureKey);
                        }
                        return this;
                    },
                    /**
     * Removes a key from the Texture Manager but does not destroy the Texture that was using the key.
     *
     * @method Phaser.Textures.TextureManager#removeKey
     * @since 3.17.0
     *
     * @param {string} key - The key to remove from the texture list.
     *
     * @return {Phaser.Textures.TextureManager} The Texture Manager.
     */ removeKey: function(key) {
                        if (this.list.hasOwnProperty(key)) delete this.list[key];
                        return this;
                    },
                    /**
     * Adds a new Texture to the Texture Manager created from the given Base64 encoded data.
     *
     * It works by creating an `Image` DOM object, then setting the `src` attribute to
     * the given base64 encoded data. As a result, the process is asynchronous by its nature,
     * so be sure to listen for the events this method dispatches before using the texture.
     *
     * @method Phaser.Textures.TextureManager#addBase64
     * @fires Phaser.Textures.Events#ADD
     * @fires Phaser.Textures.Events#ERROR
     * @fires Phaser.Textures.Events#LOAD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {*} data - The Base64 encoded data.
     *
     * @return {this} This Texture Manager instance.
     */ addBase64: function(key, data) {
                        if (this.checkKey(key)) {
                            var _this = this;
                            var image = new Image();
                            image.onerror = function() {
                                _this.emit(Events.ERROR, key);
                            };
                            image.onload = function() {
                                var texture = _this.create(key, image);
                                if (!texture) return;
                                Parser.Image(texture, 0);
                                _this.emit(Events.ADD, key, texture);
                                _this.emit(Events.ADD_KEY + key, texture);
                                _this.emit(Events.LOAD, key, texture);
                            };
                            image.src = data;
                        }
                        return this;
                    },
                    /**
     * Gets an existing texture frame and converts it into a base64 encoded image and returns the base64 data.
     *
     * You can also provide the image type and encoder options.
     *
     * This will only work with bitmap based texture frames, such as those created from Texture Atlases.
     * It will not work with GL Texture objects, such as Shaders, or Render Textures. For those please
     * see the WebGL Snapshot function instead.
     *
     * @method Phaser.Textures.TextureManager#getBase64
     * @since 3.12.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     * @param {string} [type='image/png'] - A DOMString indicating the image format. The default format type is image/png.
     * @param {number} [encoderOptions=0.92] - A Number between 0 and 1 indicating the image quality to use for image formats that use lossy compression such as image/jpeg and image/webp. If this argument is anything else, the default value for image quality is used. The default value is 0.92. Other arguments are ignored.
     *
     * @return {string} The base64 encoded data, or an empty string if the texture frame could not be found.
     */ getBase64: function(key, frame, type, encoderOptions) {
                        if (type === undefined) type = 'image/png';
                        if (encoderOptions === undefined) encoderOptions = 0.92;
                        var data = '';
                        var textureFrame = this.getFrame(key, frame);
                        if (textureFrame && (textureFrame.source.isRenderTexture || textureFrame.source.isGLTexture)) {
                            if (!this.silentWarnings) console.warn('Cannot getBase64 from WebGL Texture');
                        } else if (textureFrame) {
                            var cd = textureFrame.canvasData;
                            var canvas = CanvasPool.create2D(this, cd.width, cd.height);
                            var ctx = canvas.getContext('2d', {
                                willReadFrequently: true
                            });
                            if (cd.width > 0 && cd.height > 0) ctx.drawImage(textureFrame.source.image, cd.x, cd.y, cd.width, cd.height, 0, 0, cd.width, cd.height);
                            data = canvas.toDataURL(type, encoderOptions);
                            CanvasPool.remove(canvas);
                        }
                        return data;
                    },
                    /**
     * Adds a new Texture to the Texture Manager created from the given Image element.
     *
     * @method Phaser.Textures.TextureManager#addImage
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {HTMLImageElement|HTMLCanvasElement} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addImage: function(key, source, dataSource) {
                        var texture = null;
                        if (this.checkKey(key)) {
                            texture = this.create(key, source);
                            Parser.Image(texture, 0);
                            if (dataSource) texture.setDataSource(dataSource);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Takes a WebGLTextureWrapper and creates a Phaser Texture from it, which is added to the Texture Manager using the given key.
     *
     * This allows you to then use the Texture as a normal texture for texture based Game Objects like Sprites.
     *
     * This is a WebGL only feature.
     *
     * Prior to Phaser 3.80.0, this method took a bare `WebGLTexture`
     * as the `glTexture` parameter. You must now wrap the `WebGLTexture` in a
     * `WebGLTextureWrapper` instance before passing it to this method.
     *
     * @method Phaser.Textures.TextureManager#addGLTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.19.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper} glTexture - The source Render Texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addGLTexture: function(key, glTexture) {
                        var texture = null;
                        if (this.checkKey(key)) {
                            var width = glTexture.width;
                            var height = glTexture.height;
                            texture = this.create(key, glTexture, width, height);
                            texture.add('__BASE', 0, 0, 0, width, height);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Adds a Compressed Texture to this Texture Manager.
     *
     * The texture should typically have been loaded via the `CompressedTextureFile` loader,
     * in order to prepare the correct data object this method requires.
     *
     * You can optionally also pass atlas data to this method, in which case a texture atlas
     * will be generated from the given compressed texture, combined with the atlas data.
     *
     * @method Phaser.Textures.TextureManager#addCompressedTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.60.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Types.Textures.CompressedTextureData} textureData - The Compressed Texture data object.
     * @param {object} [atlasData] - Optional Texture Atlas data.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addCompressedTexture: function(key, textureData, atlasData) {
                        var texture = null;
                        if (this.checkKey(key)) {
                            texture = this.create(key, textureData);
                            texture.add('__BASE', 0, 0, 0, textureData.width, textureData.height);
                            if (atlasData) {
                                var parse = function(texture, sourceIndex, atlasData) {
                                    if (Array.isArray(atlasData.textures) || Array.isArray(atlasData.frames)) Parser.JSONArray(texture, sourceIndex, atlasData);
                                    else Parser.JSONHash(texture, sourceIndex, atlasData);
                                };
                                if (Array.isArray(atlasData)) for(var i = 0; i < atlasData.length; i++)parse(texture, i, atlasData[i]);
                                else parse(texture, 0, atlasData);
                            }
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Adds a Render Texture to the Texture Manager using the given key.
     * This allows you to then use the Render Texture as a normal texture for texture based Game Objects like Sprites.
     *
     * @method Phaser.Textures.TextureManager#addRenderTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.12.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.GameObjects.RenderTexture} renderTexture - The source Render Texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addRenderTexture: function(key, renderTexture) {
                        var texture = null;
                        if (this.checkKey(key)) {
                            texture = this.create(key, renderTexture);
                            texture.add('__BASE', 0, 0, 0, renderTexture.width, renderTexture.height);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Creates a new Texture using the given config values.
     *
     * Generated textures consist of a Canvas element to which the texture data is drawn.
     *
     * Generates a texture based on the given Create configuration object.
     *
     * The texture is drawn using a fixed-size indexed palette of 16 colors, where the hex value in the
     * data cells map to a single color. For example, if the texture config looked like this:
     *
     * ```javascript
     * var star = [
     *   '.....828.....',
     *   '....72227....',
     *   '....82228....',
     *   '...7222227...',
     *   '2222222222222',
     *   '8222222222228',
     *   '.72222222227.',
     *   '..787777787..',
     *   '..877777778..',
     *   '.78778887787.',
     *   '.27887.78872.',
     *   '.787.....787.'
     * ];
     *
     * this.textures.generate('star', { data: star, pixelWidth: 4 });
     * ```
     *
     * Then it would generate a texture that is 52 x 48 pixels in size, because each cell of the data array
     * represents 1 pixel multiplied by the `pixelWidth` value. The cell values, such as `8`, maps to color
     * number 8 in the palette. If a cell contains a period character `.` then it is transparent.
     *
     * The default palette is Arne16, but you can specify your own using the `palette` property.
     *
     * @method Phaser.Textures.TextureManager#generate
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Types.Create.GenerateTextureConfig} config - The configuration object needed to generate the texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ generate: function(key, config) {
                        if (this.checkKey(key)) {
                            var canvas = CanvasPool.create(this, 1, 1);
                            config.canvas = canvas;
                            GenerateTexture(config);
                            return this.addCanvas(key, canvas);
                        } else return null;
                    },
                    /**
     * Creates a new Texture using a blank Canvas element of the size given.
     *
     * Canvas elements are automatically pooled and calling this method will
     * extract a free canvas from the CanvasPool, or create one if none are available.
     *
     * @method Phaser.Textures.TextureManager#createCanvas
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {number} [width=256] - The width of the Canvas element.
     * @param {number} [height=256] - The height of the Canvas element.
     *
     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
     */ createCanvas: function(key, width, height) {
                        if (width === undefined) width = 256;
                        if (height === undefined) height = 256;
                        if (this.checkKey(key)) {
                            var canvas = CanvasPool.create(this, width, height, CONST.CANVAS, true);
                            return this.addCanvas(key, canvas);
                        }
                        return null;
                    },
                    /**
     * Creates a new Canvas Texture object from an existing Canvas element
     * and adds it to this Texture Manager, unless `skipCache` is true.
     *
     * @method Phaser.Textures.TextureManager#addCanvas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLCanvasElement} source - The Canvas element to form the base of the new Texture.
     * @param {boolean} [skipCache=false] - Skip adding this Texture into the Cache?
     *
     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
     */ addCanvas: function(key, source, skipCache) {
                        if (skipCache === undefined) skipCache = false;
                        var texture = null;
                        if (skipCache) texture = new CanvasTexture(this, key, source, source.width, source.height);
                        else if (this.checkKey(key)) {
                            texture = new CanvasTexture(this, key, source, source.width, source.height);
                            this.list[key] = texture;
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Creates a Dynamic Texture instance and adds itself to this Texture Manager.
     *
     * A Dynamic Texture is a special texture that allows you to draw textures, frames and most kind of
     * Game Objects directly to it.
     *
     * You can take many complex objects and draw them to this one texture, which can then be used as the
     * base texture for other Game Objects, such as Sprites. Should you then update this texture, all
     * Game Objects using it will instantly be updated as well, reflecting the changes immediately.
     *
     * It's a powerful way to generate dynamic textures at run-time that are WebGL friendly and don't invoke
     * expensive GPU uploads on each change.
     *
     * See the methods available on the `DynamicTexture` class for more details.
     *
     * Optionally, you can also pass a Dynamic Texture instance to this method to have
     * it added to the Texture Manager.
     *
     * @method Phaser.Textures.TextureManager#addDynamicTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.60.0
     *
     * @param {(string|Phaser.Textures.DynamicTexture)} key - The string-based key of this Texture. Must be unique within the Texture Manager. Or, a DynamicTexture instance.
     * @param {number} [width=256] - The width of this Dynamic Texture in pixels. Defaults to 256 x 256. Ignored if an instance is passed as the key.
     * @param {number} [height=256] - The height of this Dynamic Texture in pixels. Defaults to 256 x 256. Ignored if an instance is passed as the key.
     *
     * @return {?Phaser.Textures.DynamicTexture} The Dynamic Texture that was created, or `null` if the key is already in use.
     */ addDynamicTexture: function(key, width, height) {
                        var texture = null;
                        if (typeof key === 'string' && !this.exists(key)) texture = new DynamicTexture(this, key, width, height);
                        else {
                            texture = key;
                            key = texture.key;
                        }
                        if (this.checkKey(key)) {
                            this.list[key] = texture;
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        } else texture = null;
                        return texture;
                    },
                    /**
     * Adds a Texture Atlas to this Texture Manager.
     *
     * In Phaser terminology, a Texture Atlas is a combination of an atlas image and a JSON data file,
     * such as those exported by applications like Texture Packer.
     *
     * It can accept either JSON Array or JSON Hash formats, as exported by Texture Packer and similar software.
     *
     * As of Phaser 3.60 you can use this method to add a atlas data to an existing Phaser Texture.
     *
     * @method Phaser.Textures.TextureManager#addAtlas
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(HTMLImageElement|HTMLImageElement[]|Phaser.Textures.Texture)} source - The source Image element/s, or a Phaser Texture.
     * @param {(object|object[])} data - The Texture Atlas data/s.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlas: function(key, source, data, dataSource) {
                        //  New Texture Packer format?
                        if (Array.isArray(data.textures) || Array.isArray(data.frames)) return this.addAtlasJSONArray(key, source, data, dataSource);
                        else return this.addAtlasJSONHash(key, source, data, dataSource);
                    },
                    /**
     * Adds a Texture Atlas to this Texture Manager.
     *
     * In Phaser terminology, a Texture Atlas is a combination of an atlas image and a JSON data file,
     * such as those exported by applications like Texture Packer.
     *
     * The frame data of the atlas must be stored in an Array within the JSON.
     *
     * This is known as a JSON Array in software such as Texture Packer.
     *
     * As of Phaser 3.60 you can use this method to add a atlas data to an existing Phaser Texture.
     *
     * @method Phaser.Textures.TextureManager#addAtlasJSONArray
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(HTMLImageElement|HTMLImageElement[]|Phaser.Textures.Texture)} source - The source Image element/s, or a Phaser Texture.
     * @param {(object|object[])} data - The Texture Atlas data/s.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasJSONArray: function(key, source, data, dataSource) {
                        var texture = null;
                        if (source instanceof Texture) {
                            key = source.key;
                            texture = source;
                        } else if (this.checkKey(key)) texture = this.create(key, source);
                        if (texture) {
                            //  Multi-Atlas?
                            if (Array.isArray(data)) {
                                var singleAtlasFile = data.length === 1; // multi-pack with one atlas file for all images
                                //  !! Assumes the textures are in the same order in the source array as in the json data !!
                                for(var i = 0; i < texture.source.length; i++){
                                    var atlasData = singleAtlasFile ? data[0] : data[i];
                                    Parser.JSONArray(texture, i, atlasData);
                                }
                            } else Parser.JSONArray(texture, 0, data);
                            if (dataSource) texture.setDataSource(dataSource);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Adds a Texture Atlas to this Texture Manager.
     *
     * In Phaser terminology, a Texture Atlas is a combination of an atlas image and a JSON data file,
     * such as those exported by applications like Texture Packer.
     *
     * The frame data of the atlas must be stored in an Object within the JSON.
     *
     * This is known as a JSON Hash in software such as Texture Packer.
     *
     * As of Phaser 3.60 you can use this method to add a atlas data to an existing Phaser Texture.
     *
     * @method Phaser.Textures.TextureManager#addAtlasJSONHash
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(HTMLImageElement|HTMLImageElement[]|Phaser.Textures.Texture)} source - The source Image element/s, or a Phaser Texture.
     * @param {(object|object[])} data - The Texture Atlas data/s.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasJSONHash: function(key, source, data, dataSource) {
                        var texture = null;
                        if (source instanceof Texture) {
                            key = source.key;
                            texture = source;
                        } else if (this.checkKey(key)) texture = this.create(key, source);
                        if (texture) {
                            if (Array.isArray(data)) for(var i = 0; i < data.length; i++)Parser.JSONHash(texture, i, data[i]);
                            else Parser.JSONHash(texture, 0, data);
                            if (dataSource) texture.setDataSource(dataSource);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Adds a Texture Atlas to this Texture Manager.
     *
     * In Phaser terminology, a Texture Atlas is a combination of an atlas image and a data file,
     * such as those exported by applications like Texture Packer.
     *
     * The frame data of the atlas must be stored in an XML file.
     *
     * As of Phaser 3.60 you can use this method to add a atlas data to an existing Phaser Texture.
     *
     * @method Phaser.Textures.TextureManager#addAtlasXML
     * @fires Phaser.Textures.Events#ADD
     * @since 3.7.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(HTMLImageElement|Phaser.Textures.Texture)} source - The source Image element, or a Phaser Texture.
     * @param {object} data - The Texture Atlas XML data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasXML: function(key, source, data, dataSource) {
                        var texture = null;
                        if (source instanceof Texture) {
                            key = source.key;
                            texture = source;
                        } else if (this.checkKey(key)) texture = this.create(key, source);
                        if (texture) {
                            Parser.AtlasXML(texture, 0, data);
                            if (dataSource) texture.setDataSource(dataSource);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Adds a Unity Texture Atlas to this Texture Manager.
     *
     * In Phaser terminology, a Texture Atlas is a combination of an atlas image and a data file,
     * such as those exported by applications like Texture Packer or Unity.
     *
     * The frame data of the atlas must be stored in a Unity YAML file.
     *
     * As of Phaser 3.60 you can use this method to add a atlas data to an existing Phaser Texture.
     *
     * @method Phaser.Textures.TextureManager#addUnityAtlas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addUnityAtlas: function(key, source, data, dataSource) {
                        var texture = null;
                        if (source instanceof Texture) {
                            key = source.key;
                            texture = source;
                        } else if (this.checkKey(key)) texture = this.create(key, source);
                        if (texture) {
                            Parser.UnityYAML(texture, 0, data);
                            if (dataSource) texture.setDataSource(dataSource);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Adds a Sprite Sheet to this Texture Manager.
     *
     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
     * same size and cannot be trimmed or rotated. This is different to a Texture Atlas, created by tools such as
     * Texture Packer, and more akin with the fixed-frame exports you get from apps like Aseprite or old arcade
     * games.
     *
     * As of Phaser 3.60 you can use this method to add a sprite sheet to an existing Phaser Texture.
     *
     * @method Phaser.Textures.TextureManager#addSpriteSheet
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture. Give an empty string if you provide a Phaser Texture as the 2nd argument.
     * @param {(HTMLImageElement|Phaser.Textures.Texture)} source - The source Image element, or a Phaser Texture.
     * @param {Phaser.Types.Textures.SpriteSheetConfig} config - The configuration object for this Sprite Sheet.
     * @param {HTMLImageElement|HTMLCanvasElement} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created or updated, or `null` if the key is already in use.
     */ addSpriteSheet: function(key, source, config, dataSource) {
                        var texture = null;
                        if (source instanceof Texture) {
                            key = source.key;
                            texture = source;
                        } else if (this.checkKey(key)) texture = this.create(key, source);
                        if (texture) {
                            var width = texture.source[0].width;
                            var height = texture.source[0].height;
                            Parser.SpriteSheet(texture, 0, 0, 0, width, height, config);
                            if (dataSource) texture.setDataSource(dataSource);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                        }
                        return texture;
                    },
                    /**
     * Adds a Sprite Sheet to this Texture Manager, where the Sprite Sheet exists as a Frame within a Texture Atlas.
     *
     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
     * same size and cannot be trimmed or rotated.
     *
     * @method Phaser.Textures.TextureManager#addSpriteSheetFromAtlas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Types.Textures.SpriteSheetFromAtlasConfig} config - The configuration object for this Sprite Sheet.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addSpriteSheetFromAtlas: function(key, config) {
                        if (!this.checkKey(key)) return null;
                        var atlasKey = GetValue(config, 'atlas', null);
                        var atlasFrame = GetValue(config, 'frame', null);
                        if (!atlasKey || !atlasFrame) return;
                        var atlas = this.get(atlasKey);
                        var sheet = atlas.get(atlasFrame);
                        if (sheet) {
                            var source = sheet.source.image;
                            if (!source) source = sheet.source.glTexture;
                            var texture = this.create(key, source);
                            if (sheet.trimmed) //  If trimmed we need to help the parser adjust
                            Parser.SpriteSheetFromAtlas(texture, sheet, config);
                            else Parser.SpriteSheet(texture, 0, sheet.cutX, sheet.cutY, sheet.cutWidth, sheet.cutHeight, config);
                            this.emit(Events.ADD, key, texture);
                            this.emit(Events.ADD_KEY + key, texture);
                            return texture;
                        }
                    },
                    /**
     * Creates a texture from an array of colour data.
     *
     * This is only available in WebGL mode.
     *
     * If the dimensions provided are powers of two, the resulting texture
     * will be automatically set to wrap by the WebGL Renderer.
     *
     * @method Phaser.Textures.TextureManager#addUint8Array
     * @fires Phaser.Textures.Events#ADD
     * @since 3.80.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Uint8Array} data - The color data for the texture.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addUint8Array: function(key, data, width, height) {
                        if (!this.checkKey(key) || data.length / 4 !== width * height) return null;
                        var texture = this.create(key, data, width, height);
                        texture.add('__BASE', 0, 0, 0, width, height);
                        this.emit(Events.ADD, key, texture);
                        this.emit(Events.ADD_KEY + key, texture);
                        return texture;
                    },
                    /**
     * Creates a new Texture using the given source and dimensions.
     *
     * @method Phaser.Textures.TextureManager#create
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]|Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper)} source - An array of sources that are used to create the texture. Usually Images, but can also be a Canvas.
     * @param {number} [width] - The width of the Texture. This is optional and automatically derived from the source images.
     * @param {number} [height] - The height of the Texture. This is optional and automatically derived from the source images.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ create: function(key, source, width, height) {
                        var texture = null;
                        if (this.checkKey(key)) {
                            texture = new Texture(this, key, source, width, height);
                            this.list[key] = texture;
                        }
                        return texture;
                    },
                    /**
     * Checks the given key to see if a Texture using it exists within this Texture Manager.
     *
     * @method Phaser.Textures.TextureManager#exists
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     *
     * @return {boolean} Returns `true` if a Texture matching the given key exists in this Texture Manager.
     */ exists: function(key) {
                        return this.list.hasOwnProperty(key);
                    },
                    /**
     * Returns a Texture from the Texture Manager that matches the given key.
     *
     * If the key is `undefined` it will return the `__DEFAULT` Texture.
     *
     * If the key is an instance of a Texture, it will return the instance.
     *
     * If the key is an instance of a Frame, it will return the frames parent Texture instance.
     *
     * Finally, if the key is given, but not found, and not a Texture or Frame instance, it will return the `__MISSING` Texture.
     *
     * @method Phaser.Textures.TextureManager#get
     * @since 3.0.0
     *
     * @param {(string|Phaser.Textures.Texture|Phaser.Textures.Frame)} key - The unique string-based key of the Texture, or a Texture, or Frame instance.
     *
     * @return {Phaser.Textures.Texture} The Texture matching the given key.
     */ get: function(key) {
                        if (key === undefined) key = '__DEFAULT';
                        if (this.list[key]) return this.list[key];
                        else if (key instanceof Texture) return key;
                        else if (key instanceof Frame) return key.texture;
                        else return this.list['__MISSING'];
                    },
                    /**
     * Takes a Texture key and Frame name and returns a clone of that Frame if found.
     *
     * @method Phaser.Textures.TextureManager#cloneFrame
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} frame - The string or index of the Frame to be cloned.
     *
     * @return {Phaser.Textures.Frame} A Clone of the given Frame.
     */ cloneFrame: function(key, frame) {
                        if (this.list[key]) return this.list[key].get(frame).clone();
                    },
                    /**
     * Takes a Texture key and Frame name and returns a reference to that Frame, if found.
     *
     * @method Phaser.Textures.TextureManager#getFrame
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     *
     * @return {Phaser.Textures.Frame} A Texture Frame object.
     */ getFrame: function(key, frame) {
                        if (this.list[key]) return this.list[key].get(frame);
                    },
                    /**
     * Parses the 'key' parameter and returns a Texture Frame instance.
     *
     * It can accept the following formats:
     *
     * 1) A string
     * 2) An array where the elements are: [ key, [frame] ]
     * 3) An object with the properties: { key, [frame] }
     * 4) A Texture instance - which returns the default frame from the Texture
     * 5) A Frame instance - returns itself
     *
     * @method Phaser.Textures.TextureManager#parseFrame
     * @since 3.60.0
     *
     * @param {(string|array|object|Phaser.Textures.Texture|Phaser.Textures.Frame)} key - The key to be parsed.
     *
     * @return {Phaser.Textures.Frame} A Texture Frame object, if found, or undefined if not.
     */ parseFrame: function(key) {
                        if (!key) return undefined;
                        else if (typeof key === 'string') return this.getFrame(key);
                        else if (Array.isArray(key) && key.length === 2) return this.getFrame(key[0], key[1]);
                        else if (IsPlainObject(key)) return this.getFrame(key.key, key.frame);
                        else if (key instanceof Texture) return key.get();
                        else if (key instanceof Frame) return key;
                    },
                    /**
     * Returns an array with all of the keys of all Textures in this Texture Manager.
     * The output array will exclude the `__DEFAULT`, `__MISSING`, `__WHITE`, and `__NORMAL` keys.
     *
     * @method Phaser.Textures.TextureManager#getTextureKeys
     * @since 3.0.0
     *
     * @return {string[]} An array containing all of the Texture keys stored in this Texture Manager.
     */ getTextureKeys: function() {
                        var output = [];
                        for(var key in this.list)if (key !== '__DEFAULT' && key !== '__MISSING' && key !== '__WHITE' && key !== '__NORMAL') output.push(key);
                        return output;
                    },
                    /**
     * Given a Texture and an `x` and `y` coordinate this method will return a new
     * Color object that has been populated with the color and alpha values of the pixel
     * at that location in the Texture.
     *
     * @method Phaser.Textures.TextureManager#getPixel
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the pixel within the Texture.
     * @param {number} y - The y coordinate of the pixel within the Texture.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {?Phaser.Display.Color} A Color object populated with the color values of the requested pixel,
     * or `null` if the coordinates were out of bounds.
     */ getPixel: function(x, y, key, frame) {
                        var textureFrame = this.getFrame(key, frame);
                        if (textureFrame) {
                            //  Adjust for trim (if not trimmed x and y are just zero)
                            x -= textureFrame.x;
                            y -= textureFrame.y;
                            var data = textureFrame.data.cut;
                            x += data.x;
                            y += data.y;
                            if (x >= data.x && x < data.r && y >= data.y && y < data.b) {
                                var ctx = this._tempContext;
                                ctx.clearRect(0, 0, 1, 1);
                                ctx.drawImage(textureFrame.source.image, x, y, 1, 1, 0, 0, 1, 1);
                                var rgb = ctx.getImageData(0, 0, 1, 1);
                                return new Color(rgb.data[0], rgb.data[1], rgb.data[2], rgb.data[3]);
                            }
                        }
                        return null;
                    },
                    /**
     * Given a Texture and an `x` and `y` coordinate this method will return a value between 0 and 255
     * corresponding to the alpha value of the pixel at that location in the Texture. If the coordinate
     * is out of bounds it will return null.
     *
     * @method Phaser.Textures.TextureManager#getPixelAlpha
     * @since 3.10.0
     *
     * @param {number} x - The x coordinate of the pixel within the Texture.
     * @param {number} y - The y coordinate of the pixel within the Texture.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {number} A value between 0 and 255, or `null` if the coordinates were out of bounds.
     */ getPixelAlpha: function(x, y, key, frame) {
                        var textureFrame = this.getFrame(key, frame);
                        if (textureFrame) {
                            //  Adjust for trim (if not trimmed x and y are just zero)
                            x -= textureFrame.x;
                            y -= textureFrame.y;
                            var data = textureFrame.data.cut;
                            x += data.x;
                            y += data.y;
                            if (x >= data.x && x < data.r && y >= data.y && y < data.b) {
                                var ctx = this._tempContext;
                                ctx.clearRect(0, 0, 1, 1);
                                ctx.drawImage(textureFrame.source.image, x, y, 1, 1, 0, 0, 1, 1);
                                var rgb = ctx.getImageData(0, 0, 1, 1);
                                return rgb.data[3];
                            }
                        }
                        return null;
                    },
                    /**
     * Sets the given Game Objects `texture` and `frame` properties so that it uses
     * the Texture and Frame specified in the `key` and `frame` arguments to this method.
     *
     * @method Phaser.Textures.TextureManager#setTexture
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the texture would be set on.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object the texture was set on.
     */ setTexture: function(gameObject, key, frame) {
                        if (this.list[key]) {
                            gameObject.texture = this.list[key];
                            gameObject.frame = gameObject.texture.get(frame);
                        }
                        return gameObject;
                    },
                    /**
     * Changes the key being used by a Texture to the new key provided.
     *
     * The old key is removed, allowing it to be re-used.
     *
     * Game Objects are linked to Textures by a reference to the Texture object, so
     * all existing references will be retained.
     *
     * @method Phaser.Textures.TextureManager#renameTexture
     * @since 3.12.0
     *
     * @param {string} currentKey - The current string-based key of the Texture you wish to rename.
     * @param {string} newKey - The new unique string-based key to use for the Texture.
     *
     * @return {boolean} `true` if the Texture key was successfully renamed, otherwise `false`.
     */ renameTexture: function(currentKey, newKey) {
                        var texture = this.get(currentKey);
                        if (texture && currentKey !== newKey) {
                            texture.key = newKey;
                            this.list[newKey] = texture;
                            delete this.list[currentKey];
                            return true;
                        }
                        return false;
                    },
                    /**
     * Passes all Textures to the given callback.
     *
     * @method Phaser.Textures.TextureManager#each
     * @since 3.0.0
     *
     * @param {EachTextureCallback} callback - The callback function to be sent the Textures.
     * @param {object} scope - The value to use as `this` when executing the callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ each: function(callback, scope) {
                        var args = [
                            null
                        ];
                        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                        for(var texture in this.list){
                            args[0] = this.list[texture];
                            callback.apply(scope, args);
                        }
                    },
                    /**
     * Resets the internal Stamp object, ready for drawing and returns it.
     *
     * @method Phaser.Textures.TextureManager#resetStamp
     * @since 3.60.0
     *
     * @param {number} [alpha=1] - The alpha to use.
     * @param {number} [tint=0xffffff] - WebGL only. The tint color to use.
     *
     * @return {Phaser.GameObjects.Image} A reference to the Stamp Game Object.
     */ resetStamp: function(alpha, tint) {
                        if (alpha === undefined) alpha = 1;
                        if (tint === undefined) tint = 0xffffff;
                        var stamp = this.stamp;
                        stamp.setCrop();
                        stamp.setPosition(0);
                        stamp.setAngle(0);
                        stamp.setScale(1);
                        stamp.setAlpha(alpha);
                        stamp.setTint(tint);
                        stamp.setTexture('__WHITE');
                        return stamp;
                    },
                    /**
     * Destroys the Texture Manager and all Textures stored within it.
     *
     * @method Phaser.Textures.TextureManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        for(var texture in this.list)this.list[texture].destroy();
                        this.list = {};
                        this.stamp.destroy();
                        this.game = null;
                        this.stamp = null;
                        CanvasPool.remove(this._tempCanvas);
                    }
                });
                module1.exports = TextureManager;
            /***/ },
            /***/ 11876: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(27919);
                var Class = __webpack_require__(83419);
                var IsSizePowerOfTwo = __webpack_require__(50030);
                var ScaleModes = __webpack_require__(29795);
                var WebGLTextureWrapper = __webpack_require__(82751);
                /**
 * @classdesc
 * A Texture Source is the encapsulation of the actual source data for a Texture.
 *
 * This is typically an Image Element, loaded from the file system or network, a Canvas Element or a Video Element.
 *
 * A Texture can contain multiple Texture Sources, which only happens when a multi-atlas is loaded.
 *
 * @class TextureSource
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture this TextureSource belongs to.
 * @param {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|Phaser.GameObjects.RenderTexture|Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper|Phaser.Types.Textures.CompressedTextureData|Phaser.Textures.DynamicTexture)} source - The source image data.
 * @param {number} [width] - Optional width of the source image. If not given it's derived from the source itself.
 * @param {number} [height] - Optional height of the source image. If not given it's derived from the source itself.
 * @param {boolean} [flipY=false] - Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
 */ var TextureSource = new Class({
                    initialize: function TextureSource(texture, source, width, height, flipY) {
                        if (flipY === undefined) flipY = false;
                        var game = texture.manager.game;
                        /**
         * A reference to the Canvas or WebGL Renderer.
         *
         * @name Phaser.Textures.TextureSource#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.7.0
         */ this.renderer = game.renderer;
                        /**
         * The Texture this TextureSource instance belongs to.
         *
         * @name Phaser.Textures.TextureSource#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = texture;
                        /**
         * The source of the image data.
         *
         * This is either an Image Element, a Canvas Element, a Video Element, a RenderTexture or a WebGLTextureWrapper.
         *
         * In Phaser 3.60 and above it can also be a Compressed Texture data object.
         *
         * @name Phaser.Textures.TextureSource#source
         * @type {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|Phaser.GameObjects.RenderTexture|Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper|Phaser.Types.Textures.CompressedTextureData|Phaser.Textures.DynamicTexture)}
         * @since 3.12.0
         */ this.source = source;
                        /**
         * The image data.
         *
         * This is either an Image element, Canvas element, Video Element, or Uint8Array.
         *
         * @name Phaser.Textures.TextureSource#image
         * @type {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|Uint8Array)}
         * @since 3.0.0
         */ this.image = source.compressed ? null : source;
                        /**
         * Holds the compressed textured algorithm, or `null` if it's not a compressed texture.
         *
         * Prior to Phaser 3.60 this value always held `null`.
         *
         * @name Phaser.Textures.TextureSource#compressionAlgorithm
         * @type {number}
         * @default null
         * @since 3.0.0
         */ this.compressionAlgorithm = source.compressed ? source.format : null;
                        /**
         * The resolution of the source image.
         *
         * @name Phaser.Textures.TextureSource#resolution
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.resolution = 1;
                        /**
         * The width of the source image. If not specified in the constructor it will check
         * the `naturalWidth` and then `width` properties of the source image.
         *
         * @name Phaser.Textures.TextureSource#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width || source.naturalWidth || source.videoWidth || source.width || 0;
                        /**
         * The height of the source image. If not specified in the constructor it will check
         * the `naturalHeight` and then `height` properties of the source image.
         *
         * @name Phaser.Textures.TextureSource#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height || source.naturalHeight || source.videoHeight || source.height || 0;
                        /**
         * The Scale Mode the image will use when rendering.
         * Either Linear or Nearest.
         *
         * @name Phaser.Textures.TextureSource#scaleMode
         * @type {number}
         * @since 3.0.0
         */ this.scaleMode = ScaleModes.DEFAULT;
                        /**
         * Is the source image a Canvas Element?
         *
         * @name Phaser.Textures.TextureSource#isCanvas
         * @type {boolean}
         * @since 3.0.0
         */ this.isCanvas = source instanceof HTMLCanvasElement;
                        /**
         * Is the source image a Video Element?
         *
         * @name Phaser.Textures.TextureSource#isVideo
         * @type {boolean}
         * @since 3.20.0
         */ this.isVideo = window.hasOwnProperty('HTMLVideoElement') && source instanceof HTMLVideoElement;
                        /**
         * Is the source image a Render Texture?
         *
         * @name Phaser.Textures.TextureSource#isRenderTexture
         * @type {boolean}
         * @since 3.12.0
         */ this.isRenderTexture = source.type === 'RenderTexture' || source.type === 'DynamicTexture';
                        /**
         * Is the source image a WebGLTextureWrapper?
         *
         * @name Phaser.Textures.TextureSource#isGLTexture
         * @type {boolean}
         * @since 3.19.0
         */ this.isGLTexture = source instanceof WebGLTextureWrapper;
                        /**
         * Are the source image dimensions a power of two?
         *
         * @name Phaser.Textures.TextureSource#isPowerOf2
         * @type {boolean}
         * @since 3.0.0
         */ this.isPowerOf2 = IsSizePowerOfTwo(this.width, this.height);
                        /**
         * The wrapped WebGL Texture of the source image.
         * If this TextureSource is driven from a WebGLTexture already,
         * then this wrapper contains a reference to that WebGLTexture.
         *
         * @name Phaser.Textures.TextureSource#glTexture
         * @type {?Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @default null
         * @since 3.0.0
         */ this.glTexture = null;
                        /**
         * Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
         *
         * @name Phaser.Textures.TextureSource#flipY
         * @type {boolean}
         * @since 3.20.0
         */ this.flipY = flipY;
                        this.init(game);
                    },
                    /**
     * Creates a WebGL Texture, if required, and sets the Texture filter mode.
     *
     * @method Phaser.Textures.TextureSource#init
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
     */ init: function(game) {
                        var renderer = this.renderer;
                        if (renderer) {
                            var source = this.source;
                            if (renderer.gl) {
                                var image = this.image;
                                var flipY = this.flipY;
                                var width = this.width;
                                var height = this.height;
                                var scaleMode = this.scaleMode;
                                if (this.isCanvas) this.glTexture = renderer.createCanvasTexture(image, false, flipY);
                                else if (this.isVideo) this.glTexture = renderer.createVideoTexture(image, false, flipY);
                                else if (this.isRenderTexture) this.glTexture = renderer.createTextureFromSource(null, width, height, scaleMode);
                                else if (this.isGLTexture) this.glTexture = source;
                                else if (this.compressionAlgorithm) this.glTexture = renderer.createTextureFromSource(source, undefined, undefined, scaleMode);
                                else if (source instanceof Uint8Array) this.glTexture = renderer.createUint8ArrayTexture(source, width, height, scaleMode);
                                else this.glTexture = renderer.createTextureFromSource(image, width, height, scaleMode);
                            } else if (this.isRenderTexture) this.image = source.canvas;
                        }
                        if (!game.config.antialias) this.setFilter(1);
                    },
                    /**
     * Sets the Filter Mode for this Texture.
     *
     * The mode can be either Linear, the default, or Nearest.
     *
     * For pixel-art you should use Nearest.
     *
     * @method Phaser.Textures.TextureSource#setFilter
     * @since 3.0.0
     *
     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
     */ setFilter: function(filterMode) {
                        if (this.renderer && this.renderer.gl) this.renderer.setTextureFilter(this.glTexture, filterMode);
                        this.scaleMode = filterMode;
                    },
                    /**
     * Sets the `UNPACK_FLIP_Y_WEBGL` flag for the WebGL Texture during texture upload.
     *
     * @method Phaser.Textures.TextureSource#setFlipY
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - Should the WebGL Texture be flipped on the Y axis on texture upload or not?
     */ setFlipY: function(value) {
                        if (value === undefined) value = true;
                        if (value === this.flipY) return this;
                        this.flipY = value;
                        this.update();
                        return this;
                    },
                    /**
     * If this TextureSource is backed by a Canvas and is running under WebGL,
     * it updates the WebGLTexture using the canvas data.
     *
     * @method Phaser.Textures.TextureSource#update
     * @since 3.7.0
     */ update: function() {
                        var renderer = this.renderer;
                        var image = this.image;
                        var flipY = this.flipY;
                        var gl = renderer.gl;
                        if (gl && this.isCanvas) renderer.updateCanvasTexture(image, this.glTexture, flipY);
                        else if (gl && this.isVideo) renderer.updateVideoTexture(image, this.glTexture, flipY);
                    },
                    /**
     * Destroys this Texture Source and nulls the references.
     *
     * @method Phaser.Textures.TextureSource#destroy
     * @since 3.0.0
     */ destroy: function() {
                        if (this.glTexture) this.renderer.deleteTexture(this.glTexture);
                        if (this.isCanvas) CanvasPool.remove(this.image);
                        this.renderer = null;
                        this.texture = null;
                        this.source = null;
                        this.image = null;
                        this.glTexture = null;
                    }
                });
                module1.exports = TextureSource;
            /***/ },
            /***/ 19673: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Filter Types.
 *
 * @namespace Phaser.Textures.FilterMode
 * @memberof Phaser.Textures
 * @since 3.0.0
 */ var CONST = {
                    /**
     * Linear filter type.
     *
     * @name Phaser.Textures.FilterMode.LINEAR
     * @type {number}
     * @const
     * @since 3.0.0
     */ LINEAR: 0,
                    /**
     * Nearest neighbor filter type.
     *
     * @name Phaser.Textures.FilterMode.NEAREST
     * @type {number}
     * @const
     * @since 3.0.0
     */ NEAREST: 1
                };
                module1.exports = CONST;
            /***/ },
            /***/ 44538: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Add Event.
 *
 * This event is dispatched by the Texture Manager when a texture is added to it.
 *
 * Listen to this event from within a Scene using: `this.textures.on('addtexture', listener)`.
 *
 * @event Phaser.Textures.Events#ADD
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the Texture that was added to the Texture Manager.
 * @param {Phaser.Textures.Texture} texture - A reference to the Texture that was added to the Texture Manager.
 */ module1.exports = 'addtexture';
            /***/ },
            /***/ 63486: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Add Key Event.
 *
 * This event is dispatched by the Texture Manager when a texture with the given key is added to it.
 *
 * Listen to this event from within a Scene using: `this.textures.on('addtexture-key', listener)`.
 *
 * @event Phaser.Textures.Events#ADD_KEY
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.Textures.Texture} texture - A reference to the Texture that was added to the Texture Manager.
 */ module1.exports = 'addtexture-';
            /***/ },
            /***/ 94851: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Load Error Event.
 *
 * This event is dispatched by the Texture Manager when a texture it requested to load failed.
 * This only happens when base64 encoded textures fail. All other texture types are loaded via the Loader Plugin.
 *
 * Listen to this event from within a Scene using: `this.textures.on('onerror', listener)`.
 *
 * @event Phaser.Textures.Events#ERROR
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the Texture that failed to load into the Texture Manager.
 */ module1.exports = 'onerror';
            /***/ },
            /***/ 29099: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Load Event.
 *
 * This event is dispatched by the Texture Manager when a texture has finished loading on it.
 * This only happens for base64 encoded textures. All other texture types are loaded via the Loader Plugin.
 *
 * Listen to this event from within a Scene using: `this.textures.on('onload', listener)`.
 *
 * This event is dispatched after the [ADD]{@linkcode Phaser.Textures.Events#event:ADD} event.
 *
 * @event Phaser.Textures.Events#LOAD
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the Texture that was loaded by the Texture Manager.
 * @param {Phaser.Textures.Texture} texture - A reference to the Texture that was loaded by the Texture Manager.
 */ module1.exports = 'onload';
            /***/ },
            /***/ 8678: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This internal event signifies that the Texture Manager is now ready and the Game can continue booting.
 *
 * When a Phaser Game instance is booting for the first time, the Texture Manager has to wait on a couple of non-blocking
 * async events before it's fully ready to carry on. When those complete the Texture Manager emits this event via the Game
 * instance, which tells the Game to carry on booting.
 *
 * @event Phaser.Textures.Events#READY
 * @type {string}
 * @since 3.16.1
 */ module1.exports = 'ready';
            /***/ },
            /***/ 86415: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Remove Event.
 *
 * This event is dispatched by the Texture Manager when a texture is removed from it.
 *
 * Listen to this event from within a Scene using: `this.textures.on('removetexture', listener)`.
 *
 * If you have any Game Objects still using the removed texture, they will start throwing
 * errors the next time they try to render. Be sure to clear all use of the texture in this event handler.
 *
 * @event Phaser.Textures.Events#REMOVE
 * @type {string}
 * @since 3.0.0
 *
 * @param {string} key - The key of the Texture that was removed from the Texture Manager.
 */ module1.exports = 'removetexture';
            /***/ },
            /***/ 30879: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Remove Key Event.
 *
 * This event is dispatched by the Texture Manager when a texture with the given key is removed from it.
 *
 * Listen to this event from within a Scene using: `this.textures.on('removetexture-key', listener)`.
 *
 * If you have any Game Objects still using the removed texture, they will start throwing
 * errors the next time they try to render. Be sure to clear all use of the texture in this event handler.
 *
 * @event Phaser.Textures.Events#REMOVE_KEY
 * @type {string}
 * @since 3.60.0
 */ module1.exports = 'removetexture-';
            /***/ },
            /***/ 69442: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Textures.Events
 */ module1.exports = {
                    ADD: __webpack_require__(44538),
                    ADD_KEY: __webpack_require__(63486),
                    ERROR: __webpack_require__(94851),
                    LOAD: __webpack_require__(29099),
                    READY: __webpack_require__(8678),
                    REMOVE: __webpack_require__(86415),
                    REMOVE_KEY: __webpack_require__(30879)
                };
            /***/ },
            /***/ 27458: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(79291);
                var FilterMode = __webpack_require__(19673);
                /**
 * @namespace Phaser.Textures
 */ /**
 * Linear filter type.
 *
 * @name Phaser.Textures.LINEAR
 * @type {number}
 * @const
 * @since 3.0.0
 */ /**
 * Nearest Neighbor filter type.
 *
 * @name Phaser.Textures.NEAREST
 * @type {number}
 * @const
 * @since 3.0.0
 */ var Textures = {
                    CanvasTexture: __webpack_require__(57382),
                    DynamicTexture: __webpack_require__(81320),
                    Events: __webpack_require__(69442),
                    FilterMode: FilterMode,
                    Frame: __webpack_require__(4327),
                    Parsers: __webpack_require__(61309),
                    Texture: __webpack_require__(79237),
                    TextureManager: __webpack_require__(17130),
                    TextureSource: __webpack_require__(11876)
                };
                Textures = Extend(false, Textures, FilterMode);
                module1.exports = Textures;
            /***/ },
            /***/ 89905: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Parses an XML Texture Atlas object and adds all the Frames into a Texture.
 *
 * @function Phaser.Textures.Parsers.AtlasXML
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.7.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {*} xml - The XML data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var AtlasXML = function(texture, sourceIndex, xml) {
                    //  Malformed?
                    if (!xml.getElementsByTagName('TextureAtlas')) {
                        console.warn('Invalid Texture Atlas XML given');
                        return;
                    }
                    //  Add in a __BASE entry (for the entire atlas)
                    var source = texture.source[sourceIndex];
                    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                    //  By this stage frames is a fully parsed array
                    var frames = xml.getElementsByTagName('SubTexture');
                    var newFrame;
                    for(var i = 0; i < frames.length; i++){
                        var frame = frames[i].attributes;
                        var name = frame.name.value;
                        var x = parseInt(frame.x.value, 10);
                        var y = parseInt(frame.y.value, 10);
                        var width = parseInt(frame.width.value, 10);
                        var height = parseInt(frame.height.value, 10);
                        //  The frame values are the exact coordinates to cut the frame out of the atlas from
                        newFrame = texture.add(name, sourceIndex, x, y, width, height);
                        //  These are the original (non-trimmed) sprite values
                        if (frame.frameX) {
                            var frameX = Math.abs(parseInt(frame.frameX.value, 10));
                            var frameY = Math.abs(parseInt(frame.frameY.value, 10));
                            var frameWidth = parseInt(frame.frameWidth.value, 10);
                            var frameHeight = parseInt(frame.frameHeight.value, 10);
                            newFrame.setTrim(width, height, frameX, frameY, frameWidth, frameHeight);
                        }
                    }
                    return texture;
                };
                module1.exports = AtlasXML;
            /***/ },
            /***/ 72893: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds a Canvas Element to a Texture.
 *
 * @function Phaser.Textures.Parsers.Canvas
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var Canvas = function(texture, sourceIndex) {
                    var source = texture.source[sourceIndex];
                    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                    return texture;
                };
                module1.exports = Canvas;
            /***/ },
            /***/ 4832: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds an Image Element to a Texture.
 *
 * @function Phaser.Textures.Parsers.Image
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var Image1 = function(texture, sourceIndex) {
                    var source = texture.source[sourceIndex];
                    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                    return texture;
                };
                module1.exports = Image1;
            /***/ },
            /***/ 78566: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(41786);
                /**
 * Parses a Texture Atlas JSON Array and adds the Frames to the Texture.
 * JSON format expected to match that defined by Texture Packer, with the frames property containing an array of Frames.
 *
 * @function Phaser.Textures.Parsers.JSONArray
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} json - The JSON data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var JSONArray = function(texture, sourceIndex, json) {
                    //  Malformed?
                    if (!json['frames'] && !json['textures']) {
                        console.warn('Invalid Texture Atlas JSON Array');
                        return;
                    }
                    //  Add in a __BASE entry (for the entire atlas)
                    var source = texture.source[sourceIndex];
                    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                    //  By this stage frames is a fully parsed array
                    var frames = Array.isArray(json.textures) ? json.textures[sourceIndex].frames : json.frames;
                    var newFrame;
                    for(var i = 0; i < frames.length; i++){
                        var src = frames[i];
                        //  The frame values are the exact coordinates to cut the frame out of the atlas from
                        newFrame = texture.add(src.filename, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
                        if (!newFrame) {
                            console.warn('Invalid atlas json, frame already exists: ' + src.filename);
                            continue;
                        }
                        //  These are the original (non-trimmed) sprite values
                        if (src.trimmed) newFrame.setTrim(src.sourceSize.w, src.sourceSize.h, src.spriteSourceSize.x, src.spriteSourceSize.y, src.spriteSourceSize.w, src.spriteSourceSize.h);
                        if (src.rotated) {
                            newFrame.rotated = true;
                            newFrame.updateUVsInverted();
                        }
                        var pivot = src.anchor || src.pivot;
                        if (pivot) {
                            newFrame.customPivot = true;
                            newFrame.pivotX = pivot.x;
                            newFrame.pivotY = pivot.y;
                        }
                        if (src.scale9Borders) newFrame.setScale9(src.scale9Borders.x, src.scale9Borders.y, src.scale9Borders.w, src.scale9Borders.h);
                        //  Copy over any extra data
                        newFrame.customData = Clone(src);
                    }
                    //  Copy over any additional data that was in the JSON to Texture.customData
                    for(var dataKey in json){
                        if (dataKey === 'frames') continue;
                        if (Array.isArray(json[dataKey])) texture.customData[dataKey] = json[dataKey].slice(0);
                        else texture.customData[dataKey] = json[dataKey];
                    }
                    return texture;
                };
                module1.exports = JSONArray;
            /***/ },
            /***/ 39711: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(41786);
                /**
 * Parses a Texture Atlas JSON Hash and adds the Frames to the Texture.
 * JSON format expected to match that defined by Texture Packer, with the frames property containing an object of Frames.
 *
 * @function Phaser.Textures.Parsers.JSONHash
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} json - The JSON data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var JSONHash = function(texture, sourceIndex, json) {
                    //  Malformed?
                    if (!json['frames']) {
                        console.warn('Invalid Texture Atlas JSON Hash given, missing \'frames\' Object');
                        return;
                    }
                    //  Add in a __BASE entry (for the entire atlas)
                    var source = texture.source[sourceIndex];
                    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                    //  By this stage frames is a fully parsed Object
                    var frames = json.frames;
                    var newFrame;
                    for(var key in frames){
                        if (!frames.hasOwnProperty(key)) continue;
                        var src = frames[key];
                        //  The frame values are the exact coordinates to cut the frame out of the atlas from
                        newFrame = texture.add(key, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
                        if (!newFrame) {
                            console.warn('Invalid atlas json, frame already exists: ' + key);
                            continue;
                        }
                        //  These are the original (non-trimmed) sprite values
                        if (src.trimmed) newFrame.setTrim(src.sourceSize.w, src.sourceSize.h, src.spriteSourceSize.x, src.spriteSourceSize.y, src.spriteSourceSize.w, src.spriteSourceSize.h);
                        if (src.rotated) {
                            newFrame.rotated = true;
                            newFrame.updateUVsInverted();
                        }
                        var pivot = src.anchor || src.pivot;
                        if (pivot) {
                            newFrame.customPivot = true;
                            newFrame.pivotX = pivot.x;
                            newFrame.pivotY = pivot.y;
                        }
                        if (src.scale9Borders) newFrame.setScale9(src.scale9Borders.x, src.scale9Borders.y, src.scale9Borders.w, src.scale9Borders.h);
                        //  Copy over any extra data
                        newFrame.customData = Clone(src);
                    }
                    //  Copy over any additional data that was in the JSON to Texture.customData
                    for(var dataKey in json){
                        if (dataKey === 'frames') continue;
                        if (Array.isArray(json[dataKey])) texture.customData[dataKey] = json[dataKey].slice(0);
                        else texture.customData[dataKey] = json[dataKey];
                    }
                    return texture;
                };
                module1.exports = JSONHash;
            /***/ },
            /***/ 31403: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2021 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Parses a KTX format Compressed Texture file and generates texture data suitable for WebGL from it.
 *
 * @function Phaser.Textures.Parsers.KTXParser
 * @memberof Phaser.Textures.Parsers
 * @since 3.60.0
 *
 * @param {ArrayBuffer} data - The data object created by the Compressed Texture File Loader.
 *
 * @return {Phaser.Types.Textures.CompressedTextureData} The Compressed Texture data.
 */ var KTXParser = function(data) {
                    var idCheck = [
                        0xab,
                        0x4b,
                        0x54,
                        0x58,
                        0x20,
                        0x31,
                        0x31,
                        0xbb,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ];
                    var i;
                    var id = new Uint8Array(data, 0, 12);
                    for(i = 0; i < id.length; i++)if (id[i] !== idCheck[i]) {
                        console.warn('KTXParser - Invalid file format');
                        return;
                    }
                    var size = Uint32Array.BYTES_PER_ELEMENT;
                    var head = new DataView(data, 12, 13 * size);
                    var littleEndian = head.getUint32(0, true) === 0x04030201;
                    var glType = head.getUint32(1 * size, littleEndian);
                    if (glType !== 0) {
                        console.warn('KTXParser - Only compressed formats supported');
                        return;
                    }
                    var internalFormat = head.getUint32(4 * size, littleEndian);
                    var width = head.getUint32(6 * size, littleEndian);
                    var height = head.getUint32(7 * size, littleEndian);
                    var mipmapLevels = Math.max(1, head.getUint32(11 * size, littleEndian));
                    var bytesOfKeyValueData = head.getUint32(12 * size, littleEndian);
                    var mipmaps = new Array(mipmapLevels);
                    var offset = 64 + bytesOfKeyValueData;
                    var levelWidth = width;
                    var levelHeight = height;
                    for(i = 0; i < mipmapLevels; i++){
                        var levelSize = new Int32Array(data, offset, 1)[0];
                        // levelSize field
                        offset += 4;
                        mipmaps[i] = {
                            data: new Uint8Array(data, offset, levelSize),
                            width: levelWidth,
                            height: levelHeight
                        };
                        // add padding for odd sized image
                        // offset += 3 - ((levelSize + 3) % 4);
                        levelWidth = Math.max(1, levelWidth >> 1);
                        levelHeight = Math.max(1, levelHeight >> 1);
                        offset += levelSize;
                    }
                    return {
                        mipmaps: mipmaps,
                        width: width,
                        height: height,
                        internalFormat: internalFormat,
                        compressed: true,
                        generateMipmap: false
                    };
                };
                module1.exports = KTXParser;
            /***/ },
            /***/ 82038: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2021 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function GetSize(width, height, x, y, dx, dy, mult) {
                    if (mult === undefined) mult = 16;
                    return Math.floor((width + x) / dx) * Math.floor((height + y) / dy) * mult;
                }
                /**
 * @ignore
 */ function PVRTC2bppSize(width, height) {
                    width = Math.max(width, 16);
                    height = Math.max(height, 8);
                    return width * height / 4;
                }
                /**
 * @ignore
 */ function PVRTC4bppSize(width, height) {
                    width = Math.max(width, 8);
                    height = Math.max(height, 8);
                    return width * height / 2;
                }
                /**
 * @ignore
 */ function BPTCSize(width, height) {
                    return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
                }
                /**
 * @ignore
 */ function DXTEtcSmallSize(width, height) {
                    return GetSize(width, height, 3, 3, 4, 4, 8);
                }
                /**
 * @ignore
 */ function DXTEtcAstcBigSize(width, height) {
                    return GetSize(width, height, 3, 3, 4, 4);
                }
                /**
 * @ignore
 */ function ATC5x4Size(width, height) {
                    return GetSize(width, height, 4, 3, 5, 4);
                }
                /**
 * @ignore
 */ function ATC5x5Size(width, height) {
                    return GetSize(width, height, 4, 4, 5, 5);
                }
                /**
 * @ignore
 */ function ATC6x5Size(width, height) {
                    return GetSize(width, height, 5, 4, 6, 5);
                }
                /**
 * @ignore
 */ function ATC6x6Size(width, height) {
                    return GetSize(width, height, 5, 5, 6, 6);
                }
                /**
 * @ignore
 */ function ATC8x5Size(width, height) {
                    return GetSize(width, height, 7, 4, 8, 5);
                }
                /**
 * @ignore
 */ function ATC8x6Size(width, height) {
                    return GetSize(width, height, 7, 5, 8, 6);
                }
                /**
 * @ignore
 */ function ATC8x8Size(width, height) {
                    return GetSize(width, height, 7, 7, 8, 8);
                }
                /**
 * @ignore
 */ function ATC10x5Size(width, height) {
                    return GetSize(width, height, 9, 4, 10, 5);
                }
                /**
 * @ignore
 */ function ATC10x6Size(width, height) {
                    return GetSize(width, height, 9, 5, 10, 6);
                }
                /**
 * @ignore
 */ function ATC10x8Size(width, height) {
                    return GetSize(width, height, 9, 7, 10, 8);
                }
                /**
 * @ignore
 */ function ATC10x10Size(width, height) {
                    return GetSize(width, height, 9, 9, 10, 10);
                }
                /**
 * @ignore
 */ function ATC12x10Size(width, height) {
                    return GetSize(width, height, 11, 9, 12, 10);
                }
                /**
 * @ignore
 */ function ATC12x12Size(width, height) {
                    return GetSize(width, height, 11, 11, 12, 12);
                }
                /*
 * 0: COMPRESSED_RGB_PVRTC_2BPPV1_IMG
 * 1: COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
 * 2: COMPRESSED_RGB_PVRTC_4BPPV1_IMG
 * 3: COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
 * 6: COMPRESSED_RGB_ETC1
 * 7: COMPRESSED_RGB_S3TC_DXT1_EXT or COMPRESSED_SRGB_S3TC_DXT1_EXT
 * 8: COMPRESSED_RGBA_S3TC_DXT1_EXT or COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT
 * 9: COMPRESSED_RGBA_S3TC_DXT3_EXT or COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT
 * 11: COMPRESSED_RGBA_S3TC_DXT5_EXT or COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
 * 14: COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT or COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT
 * 15: COMPRESSED_RGBA_BPTC_UNORM_EXT or COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
 * 22: COMPRESSED_RGB8_ETC2 or COMPRESSED_SRGB8_ETC2
 * 23: COMPRESSED_RGBA8_ETC2_EAC or COMPRESSED_SRGB8_ALPHA8_ETC2_EAC
 * 24: COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 or COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2
 * 25: COMPRESSED_R11_EAC
 * 26: COMPRESSED_RG11_EAC
 * 27: COMPRESSED_RGBA_ASTC_4x4_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_4X4_KHR
 * 28: COMPRESSED_RGBA_ASTC_5x4_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_5X4_KHR
 * 29: COMPRESSED_RGBA_ASTC_5x5_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_5X5_KHR
 * 30: COMPRESSED_RGBA_ASTC_6x5_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_6X5_KHR
 * 31: COMPRESSED_RGBA_ASTC_6x6_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_6X6_KHR
 * 32: COMPRESSED_RGBA_ASTC_8x5_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_8X5_KHR
 * 33: COMPRESSED_RGBA_ASTC_8x6_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_8X6_KHR
 * 34: COMPRESSED_RGBA_ASTC_8x8_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_8X8_KHR
 * 35: COMPRESSED_RGBA_ASTC_10x5_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_10X5_KHR
 * 36: COMPRESSED_RGBA_ASTC_10x6_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_10X6_KHR
 * 37: COMPRESSED_RGBA_ASTC_10x8_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_10X8_KHR
 * 38: COMPRESSED_RGBA_ASTC_10x10_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_10X10_KHR
 * 39: COMPRESSED_RGBA_ASTC_12x10_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_12X10_KHR
 * 40: COMPRESSED_RGBA_ASTC_12x12_KHR or COMPRESSED_SRGB8_ALPHA8_ASTC_12X12_KHR
 */ /**
 * @ignore
 */ var FORMATS = {
                    0: {
                        sizeFunc: PVRTC2bppSize,
                        glFormat: [
                            0x8C01
                        ]
                    },
                    1: {
                        sizeFunc: PVRTC2bppSize,
                        glFormat: [
                            0x8C03
                        ]
                    },
                    2: {
                        sizeFunc: PVRTC4bppSize,
                        glFormat: [
                            0x8C00
                        ]
                    },
                    3: {
                        sizeFunc: PVRTC4bppSize,
                        glFormat: [
                            0x8C02
                        ]
                    },
                    6: {
                        sizeFunc: DXTEtcSmallSize,
                        glFormat: [
                            0x8D64
                        ]
                    },
                    7: {
                        sizeFunc: DXTEtcSmallSize,
                        glFormat: [
                            0x83F0,
                            0x8C4C
                        ]
                    },
                    8: {
                        sizeFunc: DXTEtcAstcBigSize,
                        glFormat: [
                            0x83F1,
                            0x8C4D
                        ]
                    },
                    9: {
                        sizeFunc: DXTEtcAstcBigSize,
                        glFormat: [
                            0x83F2,
                            0x8C4E
                        ]
                    },
                    11: {
                        sizeFunc: DXTEtcAstcBigSize,
                        glFormat: [
                            0x83F3,
                            0x8C4F
                        ]
                    },
                    14: {
                        sizeFunc: BPTCSize,
                        glFormat: [
                            0x8E8E,
                            0x8E8F
                        ]
                    },
                    15: {
                        sizeFunc: BPTCSize,
                        glFormat: [
                            0x8E8C,
                            0x8E8D
                        ]
                    },
                    22: {
                        sizeFunc: DXTEtcSmallSize,
                        glFormat: [
                            0x9274,
                            0x9275
                        ]
                    },
                    23: {
                        sizeFunc: DXTEtcAstcBigSize,
                        glFormat: [
                            0x9278,
                            0x9279
                        ]
                    },
                    24: {
                        sizeFunc: DXTEtcSmallSize,
                        glFormat: [
                            0x9276,
                            0x9277
                        ]
                    },
                    25: {
                        sizeFunc: DXTEtcSmallSize,
                        glFormat: [
                            0x9270
                        ]
                    },
                    26: {
                        sizeFunc: DXTEtcAstcBigSize,
                        glFormat: [
                            0x9272
                        ]
                    },
                    27: {
                        sizeFunc: DXTEtcAstcBigSize,
                        glFormat: [
                            0x93B0,
                            0x93D0
                        ]
                    },
                    28: {
                        sizeFunc: ATC5x4Size,
                        glFormat: [
                            0x93B1,
                            0x93D1
                        ]
                    },
                    29: {
                        sizeFunc: ATC5x5Size,
                        glFormat: [
                            0x93B2,
                            0x93D2
                        ]
                    },
                    30: {
                        sizeFunc: ATC6x5Size,
                        glFormat: [
                            0x93B3,
                            0x93D3
                        ]
                    },
                    31: {
                        sizeFunc: ATC6x6Size,
                        glFormat: [
                            0x93B4,
                            0x93D4
                        ]
                    },
                    32: {
                        sizeFunc: ATC8x5Size,
                        glFormat: [
                            0x93B5,
                            0x93D5
                        ]
                    },
                    33: {
                        sizeFunc: ATC8x6Size,
                        glFormat: [
                            0x93B6,
                            0x93D6
                        ]
                    },
                    34: {
                        sizeFunc: ATC8x8Size,
                        glFormat: [
                            0x93B7,
                            0x93D7
                        ]
                    },
                    35: {
                        sizeFunc: ATC10x5Size,
                        glFormat: [
                            0x93B8,
                            0x93D8
                        ]
                    },
                    36: {
                        sizeFunc: ATC10x6Size,
                        glFormat: [
                            0x93B9,
                            0x93D9
                        ]
                    },
                    37: {
                        sizeFunc: ATC10x8Size,
                        glFormat: [
                            0x93BA,
                            0x93DA
                        ]
                    },
                    38: {
                        sizeFunc: ATC10x10Size,
                        glFormat: [
                            0x93BB,
                            0x93DB
                        ]
                    },
                    39: {
                        sizeFunc: ATC12x10Size,
                        glFormat: [
                            0x93BC,
                            0x93DC
                        ]
                    },
                    40: {
                        sizeFunc: ATC12x12Size,
                        glFormat: [
                            0x93BD,
                            0x93DD
                        ]
                    }
                };
                /**
 * Parses a PVR format Compressed Texture file and generates texture data suitable for WebGL from it.
 *
 * @function Phaser.Textures.Parsers.PVRParser
 * @memberof Phaser.Textures.Parsers
 * @since 3.60.0
 *
 * @param {ArrayBuffer} data - The data object created by the Compressed Texture File Loader.
 *
 * @return {Phaser.Types.Textures.CompressedTextureData} The Compressed Texture data.
 */ var PVRParser = function(data) {
                    var header = new Uint32Array(data, 0, 13);
                    // VERSION
                    var version = header[0];
                    var versionMatch = version === 0x03525650;
                    //  PIXEL_FORMAT_INDEX
                    var pvrFormat = versionMatch ? header[2] : header[3];
                    // Colour Space
                    var colorSpace = header[4];
                    var internalFormat = FORMATS[pvrFormat].glFormat[colorSpace];
                    var sizeFunction = FORMATS[pvrFormat].sizeFunc;
                    //  MIPMAPCOUNT_INDEX
                    var mipmapLevels = header[11];
                    //  WIDTH_INDEX
                    var width = header[7];
                    //  HEIGHT_INDEX
                    var height = header[6];
                    //  HEADER_SIZE + METADATA_SIZE_INDEX
                    var dataOffset = 52 + header[12];
                    var image = new Uint8Array(data, dataOffset);
                    var mipmaps = new Array(mipmapLevels);
                    var offset = 0;
                    var levelWidth = width;
                    var levelHeight = height;
                    for(var i = 0; i < mipmapLevels; i++){
                        var levelSize = sizeFunction(levelWidth, levelHeight);
                        mipmaps[i] = {
                            data: new Uint8Array(image.buffer, image.byteOffset + offset, levelSize),
                            width: levelWidth,
                            height: levelHeight
                        };
                        levelWidth = Math.max(1, levelWidth >> 1);
                        levelHeight = Math.max(1, levelHeight >> 1);
                        offset += levelSize;
                    }
                    return {
                        mipmaps: mipmaps,
                        width: width,
                        height: height,
                        internalFormat: internalFormat,
                        compressed: true,
                        generateMipmap: false
                    };
                };
                module1.exports = PVRParser;
            /***/ },
            /***/ 75549: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                /**
 * Parses a Sprite Sheet and adds the Frames to the Texture.
 *
 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
 * same size and cannot be trimmed or rotated.
 *
 * @function Phaser.Textures.Parsers.SpriteSheet
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {number} x - The top-left coordinate of the Sprite Sheet. Defaults to zero. Used when extracting sheets from atlases.
 * @param {number} y - The top-left coordinate of the Sprite Sheet. Defaults to zero. Used when extracting sheets from atlases.
 * @param {number} width - The width of the source image.
 * @param {number} height - The height of the source image.
 * @param {object} config - An object describing how to parse the Sprite Sheet.
 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
 * @param {number} [config.startFrame=0] - The frame to start extracting from. Defaults to zero.
 * @param {number} [config.endFrame=-1] - The frame to finish extracting at. Defaults to -1, which means 'all frames'.
 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var SpriteSheet = function(texture, sourceIndex, x, y, width, height, config) {
                    var frameWidth = GetFastValue(config, 'frameWidth', null);
                    var frameHeight = GetFastValue(config, 'frameHeight', frameWidth);
                    //  If missing we can't proceed
                    if (frameWidth === null) throw new Error('TextureManager.SpriteSheet: Invalid frameWidth given.');
                    //  Add in a __BASE entry (for the entire atlas)
                    var source = texture.source[sourceIndex];
                    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                    var startFrame = GetFastValue(config, 'startFrame', 0);
                    var endFrame = GetFastValue(config, 'endFrame', -1);
                    var margin = GetFastValue(config, 'margin', 0);
                    var spacing = GetFastValue(config, 'spacing', 0);
                    var row = Math.floor((width - margin + spacing) / (frameWidth + spacing));
                    var column = Math.floor((height - margin + spacing) / (frameHeight + spacing));
                    var total = row * column;
                    if (total === 0) console.warn('SpriteSheet frame dimensions will result in zero frames for texture:', texture.key);
                    if (startFrame > total || startFrame < -total) startFrame = 0;
                    if (startFrame < 0) //  Allow negative skipframes.
                    startFrame = total + startFrame;
                    if (endFrame === -1 || endFrame > total || endFrame < startFrame) endFrame = total;
                    var fx = margin;
                    var fy = margin;
                    var ax = 0;
                    var ay = 0;
                    var c = 0;
                    for(var i = 0; i < total; i++){
                        ax = 0;
                        ay = 0;
                        var w = fx + frameWidth;
                        var h = fy + frameHeight;
                        if (w > width) ax = w - width;
                        if (h > height) ay = h - height;
                        if (i >= startFrame && i <= endFrame) {
                            texture.add(c, sourceIndex, x + fx, y + fy, frameWidth - ax, frameHeight - ay);
                            c++;
                        }
                        fx += frameWidth + spacing;
                        if (fx + frameWidth > width) {
                            fx = margin;
                            fy += frameHeight + spacing;
                        }
                    }
                    return texture;
                };
                module1.exports = SpriteSheet;
            /***/ },
            /***/ 47534: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                /**
 * Parses a Sprite Sheet and adds the Frames to the Texture, where the Sprite Sheet is stored as a frame within an Atlas.
 *
 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
 * same size and cannot be trimmed or rotated.
 *
 * @function Phaser.Textures.Parsers.SpriteSheetFromAtlas
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {Phaser.Textures.Frame} frame - The Frame that contains the Sprite Sheet.
 * @param {object} config - An object describing how to parse the Sprite Sheet.
 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
 * @param {number} [config.startFrame=0] - Index of the start frame in the sprite sheet
 * @param {number} [config.endFrame=-1] - Index of the end frame in the sprite sheet. -1 mean all the rest of the frames
 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var SpriteSheetFromAtlas = function(texture, frame, config) {
                    var frameWidth = GetFastValue(config, 'frameWidth', null);
                    var frameHeight = GetFastValue(config, 'frameHeight', frameWidth);
                    //  If missing we can't proceed
                    if (!frameWidth) throw new Error('TextureManager.SpriteSheetFromAtlas: Invalid frameWidth given.');
                    //  Add in a __BASE entry (for the entire atlas frame)
                    var source = texture.source[0];
                    texture.add('__BASE', 0, 0, 0, source.width, source.height);
                    var startFrame = GetFastValue(config, 'startFrame', 0);
                    var endFrame = GetFastValue(config, 'endFrame', -1);
                    var margin = GetFastValue(config, 'margin', 0);
                    var spacing = GetFastValue(config, 'spacing', 0);
                    var x = frame.cutX;
                    var y = frame.cutY;
                    var cutWidth = frame.cutWidth;
                    var cutHeight = frame.cutHeight;
                    var sheetWidth = frame.realWidth;
                    var sheetHeight = frame.realHeight;
                    var row = Math.floor((sheetWidth - margin + spacing) / (frameWidth + spacing));
                    var column = Math.floor((sheetHeight - margin + spacing) / (frameHeight + spacing));
                    var total = row * column;
                    //  trim offsets
                    var leftPad = frame.x;
                    var leftWidth = frameWidth - leftPad;
                    var rightWidth = frameWidth - (sheetWidth - cutWidth - leftPad);
                    var topPad = frame.y;
                    var topHeight = frameHeight - topPad;
                    var bottomHeight = frameHeight - (sheetHeight - cutHeight - topPad);
                    if (startFrame > total || startFrame < -total) startFrame = 0;
                    if (startFrame < 0) //  Allow negative skipframes.
                    startFrame = total + startFrame;
                    if (endFrame !== -1) total = startFrame + (endFrame + 1);
                    var sheetFrame;
                    var frameX = margin;
                    var frameY = margin;
                    var frameIndex = 0;
                    var sourceIndex = 0;
                    for(var sheetY = 0; sheetY < column; sheetY++){
                        var topRow = sheetY === 0;
                        var bottomRow = sheetY === column - 1;
                        for(var sheetX = 0; sheetX < row; sheetX++){
                            var leftRow = sheetX === 0;
                            var rightRow = sheetX === row - 1;
                            sheetFrame = texture.add(frameIndex, sourceIndex, x + frameX, y + frameY, frameWidth, frameHeight);
                            if (leftRow || topRow || rightRow || bottomRow) {
                                var destX = leftRow ? leftPad : 0;
                                var destY = topRow ? topPad : 0;
                                var trimWidth = 0;
                                var trimHeight = 0;
                                if (leftRow) trimWidth += frameWidth - leftWidth;
                                if (rightRow) trimWidth += frameWidth - rightWidth;
                                if (topRow) trimHeight += frameHeight - topHeight;
                                if (bottomRow) trimHeight += frameHeight - bottomHeight;
                                var destWidth = frameWidth - trimWidth;
                                var destHeight = frameHeight - trimHeight;
                                sheetFrame.cutWidth = destWidth;
                                sheetFrame.cutHeight = destHeight;
                                sheetFrame.setTrim(frameWidth, frameHeight, destX, destY, destWidth, destHeight);
                            }
                            frameX += spacing;
                            if (leftRow) frameX += leftWidth;
                            else if (rightRow) frameX += rightWidth;
                            else frameX += frameWidth;
                            frameIndex++;
                        }
                        frameX = margin;
                        frameY += spacing;
                        if (topRow) frameY += topHeight;
                        else if (bottomRow) frameY += bottomHeight;
                        else frameY += frameHeight;
                    }
                    return texture;
                };
                module1.exports = SpriteSheetFromAtlas;
            /***/ },
            /***/ 86147: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var imageHeight = 0;
                /**
 * @function addFrame
 * @private
 * @since 3.0.0
 */ var addFrame = function(texture, sourceIndex, name, frame) {
                    //  The frame values are the exact coordinates to cut the frame out of the atlas from
                    var y = imageHeight - frame.y - frame.height;
                    texture.add(name, sourceIndex, frame.x, y, frame.width, frame.height);
                //  These are the original (non-trimmed) sprite values
                /*
    if (src.trimmed)
    {
        newFrame.setTrim(
            src.sourceSize.w,
            src.sourceSize.h,
            src.spriteSourceSize.x,
            src.spriteSourceSize.y,
            src.spriteSourceSize.w,
            src.spriteSourceSize.h
        );
    }
    */ };
                /**
 * Parses a Unity YAML File and creates Frames in the Texture.
 * For more details about Sprite Meta Data see https://docs.unity3d.com/ScriptReference/SpriteMetaData.html
 *
 * @function Phaser.Textures.Parsers.UnityYAML
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} yaml - The YAML data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var UnityYAML = function(texture, sourceIndex, yaml) {
                    //  Add in a __BASE entry (for the entire atlas)
                    var source = texture.source[sourceIndex];
                    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                    imageHeight = source.height;
                    var data = yaml.split('\n');
                    var lineRegExp = /^[ ]*(- )*(\w+)+[: ]+(.*)/;
                    var prevSprite = '';
                    var currentSprite = '';
                    var rect = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                    // var pivot = { x: 0, y: 0 };
                    // var border = { x: 0, y: 0, z: 0, w: 0 };
                    for(var i = 0; i < data.length; i++){
                        var results = data[i].match(lineRegExp);
                        if (!results) continue;
                        var isList = results[1] === '- ';
                        var key = results[2];
                        var value = results[3];
                        if (isList) {
                            if (currentSprite !== prevSprite) {
                                addFrame(texture, sourceIndex, currentSprite, rect);
                                prevSprite = currentSprite;
                            }
                            rect = {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            };
                        }
                        if (key === 'name') {
                            //  Start new list
                            currentSprite = value;
                            continue;
                        }
                        switch(key){
                            case 'x':
                            case 'y':
                            case 'width':
                            case 'height':
                                rect[key] = parseInt(value, 10);
                                break;
                        }
                    }
                    if (currentSprite !== prevSprite) addFrame(texture, sourceIndex, currentSprite, rect);
                    return texture;
                };
                module1.exports = UnityYAML;
            /*
Example data:

TextureImporter:
  spritePivot: {x: .5, y: .5}
  spriteBorder: {x: 0, y: 0, z: 0, w: 0}
  spritePixelsToUnits: 100
  spriteSheet:
    sprites:
    - name: asteroids_0
      rect:
        serializedVersion: 2
        x: 5
        y: 328
        width: 65
        height: 82
      alignment: 0
      pivot: {x: 0, y: 0}
      border: {x: 0, y: 0, z: 0, w: 0}
    - name: asteroids_1
      rect:
        serializedVersion: 2
        x: 80
        y: 322
        width: 53
        height: 88
      alignment: 0
      pivot: {x: 0, y: 0}
      border: {x: 0, y: 0, z: 0, w: 0}
  spritePackingTag: Asteroids
*/ /***/ },
            /***/ 55222: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Ben Richards <benjamindrichards@gmail.com>
 * @copyright    2024 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsSizePowerOfTwo = __webpack_require__(50030);
                /**
 * Verify whether the given compressed texture data is valid.
 *
 * Compare the dimensions of each mip layer to the rules for that
 * specific format.
 *
 * Mip layer size is assumed to have been calculated correctly during parsing.
 *
 * @function Phaser.Textures.Parsers.verifyCompressedTexture
 * @param {Phaser.Types.Textures.CompressedTextureData} data - The compressed texture data to verify.
 * @since 3.80.0
 * @returns {boolean} Whether the compressed texture data is valid.
 */ var verifyCompressedTexture = function(data) {
                    // Check that mipmaps are power-of-two sized.
                    // WebGL does not allow non-power-of-two textures for mip levels above 0.
                    var mipmaps = data.mipmaps;
                    for(var level = 1; level < mipmaps.length; level++){
                        var width = mipmaps[level].width;
                        var height = mipmaps[level].height;
                        if (!IsSizePowerOfTwo(width, height)) {
                            console.warn('Mip level ' + level + ' is not a power-of-two size: ' + width + 'x' + height);
                            return false;
                        }
                    }
                    // Check specific format requirements.
                    var checker = formatCheckers[data.internalFormat];
                    if (!checker) {
                        console.warn('No format checker found for internal format ' + data.internalFormat + '. Assuming valid.');
                        return true;
                    }
                    return checker(data);
                };
                /**
 * @ignore
 */ function check4x4(data) {
                    var mipmaps = data.mipmaps;
                    for(var level = 0; level < mipmaps.length; level++){
                        var width = mipmaps[level].width;
                        var height = mipmaps[level].height;
                        if ((width << level) % 4 !== 0 || (height << level) % 4 !== 0) {
                            console.warn('BPTC, RGTC, and S3TC dimensions must be a multiple of 4 pixels, and each successive mip level must be half the size of the previous level, rounded down. Mip level ' + level + ' is ' + width + 'x' + height);
                            return false;
                        }
                    }
                    return true;
                }
                /**
 * @ignore
 */ function checkAlways() {
                    // WEBGL_compressed_texture_astc
                    // WEBGL_compressed_texture_etc
                    // WEBGL_compressed_texture_etc1
                    // ASTC, ETC, and ETC1
                    // only require data be provided in arrays of specific size,
                    // which are already set by the parser.
                    return true;
                }
                function checkPVRTC(data) {
                    // WEBGL_compressed_texture_pvrtc
                    var mipmaps = data.mipmaps;
                    var baseLevel = mipmaps[0];
                    if (!IsSizePowerOfTwo(baseLevel.width, baseLevel.height)) {
                        console.warn('PVRTC base dimensions must be power of two. Base level is ' + baseLevel.width + 'x' + baseLevel.height);
                        return false;
                    }
                    // Other mip levels have already been checked for power-of-two size.
                    return true;
                }
                /**
 * @ignore
 */ function checkS3TCSRGB(data) {
                    // WEBGL_compressed_texture_s3tc_srgb
                    var mipmaps = data.mipmaps;
                    var baseLevel = mipmaps[0];
                    if (baseLevel.width % 4 !== 0 || baseLevel.height % 4 !== 0) {
                        console.warn('S3TC SRGB base dimensions must be a multiple of 4 pixels. Base level is ' + baseLevel.width + 'x' + baseLevel.height + ' pixels');
                        return false;
                    }
                    // Mip levels above 0 must be 0, 1, 2, or a multiple of 4 pixels.
                    // However, as WebGL mip levels must all be power-of-two sized,
                    // this is already covered by the power-of-two check.
                    return true;
                }
                var formatCheckers = {
                    // ETC internal formats:
                    // COMPRESSED_R11_EAC
                    0x9270: checkAlways,
                    // COMPRESSED_SIGNED_R11_EAC
                    0x9271: checkAlways,
                    // COMPRESSED_RG11_EAC
                    0x9272: checkAlways,
                    // COMPRESSED_SIGNED_RG11_EAC
                    0x9273: checkAlways,
                    // COMPRESSED_RGB8_ETC2
                    0x9274: checkAlways,
                    // COMPRESSED_SRGB8_ETC2
                    0x9275: checkAlways,
                    // COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2
                    0x9276: checkAlways,
                    // COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2
                    0x9277: checkAlways,
                    // COMPRESSED_RGBA8_ETC2_EAC
                    0x9278: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ETC2_EAC
                    0x9279: checkAlways,
                    // ETC1 internal formats:
                    // COMPRESSED_RGB_ETC1_WEBGL
                    0x8D64: checkAlways,
                    // ATC internal formats:
                    // COMPRESSED_RGB_ATC_WEBGL
                    // COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL
                    // COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL
                    // These formats are no longer supported in WebGL.
                    // They have no special restrictions on size, so if they were decoded,
                    // they are already valid.
                    // We'll show a warning for no format checker found.
                    // ASTC internal formats:
                    // COMPRESSED_RGBA_ASTC_4x4_KHR
                    0x93B0: checkAlways,
                    // COMPRESSED_RGBA_ASTC_5x4_KHR
                    0x93B1: checkAlways,
                    // COMPRESSED_RGBA_ASTC_5x5_KHR
                    0x93B2: checkAlways,
                    // COMPRESSED_RGBA_ASTC_6x5_KHR
                    0x93B3: checkAlways,
                    // COMPRESSED_RGBA_ASTC_6x6_KHR
                    0x93B4: checkAlways,
                    // COMPRESSED_RGBA_ASTC_8x5_KHR
                    0x93B5: checkAlways,
                    // COMPRESSED_RGBA_ASTC_8x6_KHR
                    0x93B6: checkAlways,
                    // COMPRESSED_RGBA_ASTC_8x8_KHR
                    0x93B7: checkAlways,
                    // COMPRESSED_RGBA_ASTC_10x5_KHR
                    0x93B8: checkAlways,
                    // COMPRESSED_RGBA_ASTC_10x6_KHR
                    0x93B9: checkAlways,
                    // COMPRESSED_RGBA_ASTC_10x8_KHR
                    0x93BA: checkAlways,
                    // COMPRESSED_RGBA_ASTC_10x10_KHR
                    0x93BB: checkAlways,
                    // COMPRESSED_RGBA_ASTC_12x10_KHR
                    0x93BC: checkAlways,
                    // COMPRESSED_RGBA_ASTC_12x12_KHR
                    0x93BD: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_4X4_KHR
                    0x93D0: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_5X4_KHR
                    0x93D1: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_5X5_KHR
                    0x93D2: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_6X5_KHR
                    0x93D3: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_6X6_KHR
                    0x93D4: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_8X5_KHR
                    0x93D5: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_8X6_KHR
                    0x93D6: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_8X8_KHR
                    0x93D7: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_10X5_KHR
                    0x93D8: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_10X6_KHR
                    0x93D9: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_10X8_KHR
                    0x93DA: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_10X10_KHR
                    0x93DB: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_12X10_KHR
                    0x93DC: checkAlways,
                    // COMPRESSED_SRGB8_ALPHA8_ASTC_12X12_KHR
                    0x93DD: checkAlways,
                    // BPTC internal formats:
                    // COMPRESSED_RGBA_BPTC_UNORM_EXT
                    0x8E8C: check4x4,
                    // COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
                    0x8E8D: check4x4,
                    // COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT
                    0x8E8E: check4x4,
                    // COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT
                    0x8E8F: check4x4,
                    // RGTC internal formats:
                    // COMPRESSED_RED_RGTC1
                    0x8DBB: check4x4,
                    // COMPRESSED_SIGNED_RED_RGTC1
                    0x8DBC: check4x4,
                    // COMPRESSED_RG_RGTC2
                    0x8DBD: check4x4,
                    // COMPRESSED_SIGNED_RG_RGTC2
                    0x8DBE: check4x4,
                    // PVRTC internal formats:
                    // COMPRESSED_RGB_PVRTC_4BPPV1_IMG
                    0x8C00: checkPVRTC,
                    // COMPRESSED_RGB_PVRTC_2BPPV1_IMG
                    0x8C01: checkPVRTC,
                    // COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
                    0x8C02: checkPVRTC,
                    // COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
                    0x8C03: checkPVRTC,
                    // S3TC internal formats:
                    // COMPRESSED_RGB_S3TC_DXT1_EXT
                    0x83F0: check4x4,
                    // COMPRESSED_RGBA_S3TC_DXT1_EXT
                    0x83F1: check4x4,
                    // COMPRESSED_RGBA_S3TC_DXT3_EXT
                    0x83F2: check4x4,
                    // COMPRESSED_RGBA_S3TC_DXT5_EXT
                    0x83F3: check4x4,
                    // S3TCSRGB internal formats:
                    // COMPRESSED_SRGB_S3TC_DXT1_EXT
                    0x8C4C: checkS3TCSRGB,
                    // COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT
                    0x8C4D: checkS3TCSRGB,
                    // COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT
                    0x8C4E: checkS3TCSRGB,
                    // COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
                    0x8C4F: checkS3TCSRGB
                };
                module1.exports = verifyCompressedTexture;
            /***/ },
            /***/ 61309: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Textures.Parsers
 */ module1.exports = {
                    AtlasXML: __webpack_require__(89905),
                    Canvas: __webpack_require__(72893),
                    Image: __webpack_require__(4832),
                    JSONArray: __webpack_require__(78566),
                    JSONHash: __webpack_require__(39711),
                    KTXParser: __webpack_require__(31403),
                    PVRParser: __webpack_require__(82038),
                    SpriteSheet: __webpack_require__(75549),
                    SpriteSheetFromAtlas: __webpack_require__(47534),
                    UnityYAML: __webpack_require__(86147)
                };
            /***/ },
            /***/ 80341: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Formats
 */ module1.exports = {
                    /**
     * CSV Map Type
     *
     * @name Phaser.Tilemaps.Formats.CSV
     * @type {number}
     * @since 3.0.0
     */ CSV: 0,
                    /**
     * Tiled JSON Map Type
     *
     * @name Phaser.Tilemaps.Formats.TILED_JSON
     * @type {number}
     * @since 3.0.0
     */ TILED_JSON: 1,
                    /**
     * 2D Array Map Type
     *
     * @name Phaser.Tilemaps.Formats.ARRAY_2D
     * @type {number}
     * @since 3.0.0
     */ ARRAY_2D: 2,
                    /**
     * Weltmeister (Impact.js) Map Type
     *
     * @name Phaser.Tilemaps.Formats.WELTMEISTER
     * @type {number}
     * @since 3.0.0
     */ WELTMEISTER: 3
                };
            /***/ },
            /***/ 16536: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * An Image Collection is a special Tile Set containing multiple images, with no slicing into each image.
 *
 * Image Collections are normally created automatically when Tiled data is loaded.
 *
 * @class ImageCollection
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {string} name - The name of the image collection in the map data.
 * @param {number} firstgid - The first image index this image collection contains.
 * @param {number} [width=32] - Width of widest image (in pixels).
 * @param {number} [height=32] - Height of tallest image (in pixels).
 * @param {number} [margin=0] - The margin around all images in the collection (in pixels).
 * @param {number} [spacing=0] - The spacing between each image in the collection (in pixels).
 * @param {object} [properties={}] - Custom Image Collection properties.
 */ var ImageCollection = new Class({
                    initialize: function ImageCollection(name, firstgid, width, height, margin, spacing, properties) {
                        if (width === undefined || width <= 0) width = 32;
                        if (height === undefined || height <= 0) height = 32;
                        if (margin === undefined) margin = 0;
                        if (spacing === undefined) spacing = 0;
                        /**
         * The name of the Image Collection.
         *
         * @name Phaser.Tilemaps.ImageCollection#name
         * @type {string}
         * @since 3.0.0
        */ this.name = name;
                        /**
         * The Tiled firstgid value.
         * This is the starting index of the first image index this Image Collection contains.
         *
         * @name Phaser.Tilemaps.ImageCollection#firstgid
         * @type {number}
         * @since 3.0.0
         */ this.firstgid = firstgid | 0;
                        /**
         * The width of the widest image (in pixels).
         *
         * @name Phaser.Tilemaps.ImageCollection#imageWidth
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageWidth = width | 0;
                        /**
         * The height of the tallest image (in pixels).
         *
         * @name Phaser.Tilemaps.ImageCollection#imageHeight
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageHeight = height | 0;
                        /**
         * The margin around the images in the collection (in pixels).
         * Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.ImageCollection#imageMarge
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageMargin = margin | 0;
                        /**
         * The spacing between each image in the collection (in pixels).
         * Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.ImageCollection#imageSpacing
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageSpacing = spacing | 0;
                        /**
         * Image Collection-specific properties that are typically defined in the Tiled editor.
         *
         * @name Phaser.Tilemaps.ImageCollection#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = properties || {};
                        /**
         * The cached images that are a part of this collection.
         *
         * @name Phaser.Tilemaps.ImageCollection#images
         * @type {array}
         * @readonly
         * @since 3.0.0
         */ this.images = [];
                        /**
         * The total number of images in the image collection.
         *
         * @name Phaser.Tilemaps.ImageCollection#total
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.total = 0;
                    },
                    /**
     * Returns true if and only if this image collection contains the given image index.
     *
     * @method Phaser.Tilemaps.ImageCollection#containsImageIndex
     * @since 3.0.0
     *
     * @param {number} imageIndex - The image index to search for.
     *
     * @return {boolean} True if this Image Collection contains the given index.
     */ containsImageIndex: function(imageIndex) {
                        return imageIndex >= this.firstgid && imageIndex < this.firstgid + this.total;
                    },
                    /**
     * Add an image to this Image Collection.
     *
     * @method Phaser.Tilemaps.ImageCollection#addImage
     * @since 3.0.0
     *
     * @param {number} gid - The gid of the image in the Image Collection.
     * @param {string} image - The the key of the image in the Image Collection and in the cache.
     * @param {number} width - The width of the image in the Image Collection.
     * @param {number} height - The height of the image in the Image Collection.
     *
     * @return {Phaser.Tilemaps.ImageCollection} This ImageCollection object.
     */ addImage: function(gid, image, width, height) {
                        this.images.push({
                            gid: gid,
                            image: image,
                            width: width,
                            height: height
                        });
                        this.total++;
                        return this;
                    }
                });
                module1.exports = ImageCollection;
            /***/ },
            /***/ 27462: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2021 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                /**
 * @classdesc
 * The ObjectHelper helps tie objects with `gids` into the tileset
 * that sits behind them.
 *
 * @class ObjectHelper
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Tilemaps.Tileset[]} tilesets - The backing tileset data.
 */ var ObjectHelper = new Class({
                    initialize: function ObjectHelper(tilesets) {
                        /**
         * The Tile GIDs array.
         *
         * @name Phaser.Tilemaps.ObjectHelper#gids
         * @type {array}
         * @since 3.60.0
         */ this.gids = [];
                        if (tilesets !== undefined) for(var t = 0; t < tilesets.length; ++t){
                            var tileset = tilesets[t];
                            for(var i = 0; i < tileset.total; ++i)this.gids[tileset.firstgid + i] = tileset;
                        }
                        /**
         * The Tile GIDs array.
         *
         * @name Phaser.Tilemaps.ObjectHelper#_gids
         * @type {array}
         * @private
         * @since 3.60.0
         */ this._gids = this.gids;
                    },
                    /**
     * Enabled if the object helper reaches in to tilesets for data.
     * Disabled if it only uses data directly on a gid object.
     *
     * @name Phaser.Tilemaps.ObjectHelper#enabled
     * @type {boolean}
     * @since 3.60.0
     */ enabled: {
                        get: function() {
                            return !!this.gids;
                        },
                        set: function(v) {
                            this.gids = v ? this._gids : undefined;
                        }
                    },
                    /**
     * Gets the Tiled `type` field value from the object or the `gid` behind it.
     *
     * @method Phaser.Tilemaps.ObjectHelper#getTypeIncludingTile
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tilemaps.TiledObject} obj - The Tiled object to investigate.
     *
     * @return {?string} The `type` of the object, the tile behind the `gid` of the object, or `undefined`.
     */ getTypeIncludingTile: function(obj) {
                        if (obj.type !== undefined && obj.type !== '') return obj.type;
                        if (!this.gids || obj.gid === undefined) return undefined;
                        var tileset = this.gids[obj.gid];
                        if (!tileset) return undefined;
                        var tileData = tileset.getTileData(obj.gid);
                        if (!tileData) return undefined;
                        return tileData.type;
                    },
                    /**
     * Sets the sprite texture data as specified (usually in a config) or, failing that,
     * as specified in the `gid` of the object being loaded (if any).
     *
     * This fallback will only work if the tileset was loaded as a spritesheet matching
     * the geometry of sprites fed into tiled, so that, for example: "tile id #`3`"" within
     * the tileset is the same as texture frame `3` from the image of the tileset.
     *
     * @method Phaser.Tilemaps.ObjectHelper#setTextureAndFrame
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The Game Object to modify.
     * @param {string|Phaser.Textures.Texture} [key] - The texture key to set (or else the `obj.gid`'s tile is used if available).
     * @param {string|number|Phaser.Textures.Frame} [frame] - The frames key to set (or else the `obj.gid`'s tile is used if available).
     * @param {Phaser.Types.Tilemaps.TiledObject} [obj] - The Tiled object for fallback.
     */ setTextureAndFrame: function(sprite, key, frame, obj) {
                        if (key === null && this.gids && obj.gid !== undefined) {
                            var tileset = this.gids[obj.gid];
                            if (tileset) {
                                if (key === null && tileset.image !== undefined) key = tileset.image.key;
                                if (frame === null) // This relies on the tileset texture *also* having been loaded as a spritesheet. This isn't guaranteed!
                                frame = obj.gid - tileset.firstgid;
                                // If we can't satisfy the request, probably best to null it out rather than set a whole spritesheet or something.
                                if (!sprite.scene.textures.getFrame(key, frame)) {
                                    key = null;
                                    frame = null;
                                }
                            }
                        }
                        sprite.setTexture(key, frame);
                    },
                    /**
     * Sets the `sprite.data` field from the tiled properties on the object and its tile (if any).
     *
     * @method Phaser.Tilemaps.ObjectHelper#setPropertiesFromTiledObject
     * @since 3.60.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite
     * @param {Phaser.Types.Tilemaps.TiledObject} obj
     */ setPropertiesFromTiledObject: function(sprite, obj) {
                        if (this.gids !== undefined && obj.gid !== undefined) {
                            var tileset = this.gids[obj.gid];
                            if (tileset !== undefined) this.setFromJSON(sprite, tileset.getTileProperties(obj.gid));
                        }
                        this.setFromJSON(sprite, obj.properties);
                    },
                    /**
     * Sets the sprite data from the JSON object.
     *
     * @method Phaser.Tilemaps.ObjectHelper#setFromJSON
     * @since 3.60.0
     * @private
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The object for which to populate `data`.
     * @param {(Object.<string, *>|Object[])} properties - The properties to set in either JSON object format or else a list of objects with `name` and `value` fields.
     */ setFromJSON: function(sprite, properties) {
                        if (!properties) return;
                        if (Array.isArray(properties)) {
                            for(var i = 0; i < properties.length; i++){
                                var prop = properties[i];
                                if (sprite[prop.name] !== undefined) sprite[prop.name] = prop.value;
                                else sprite.setData(prop.name, prop.value);
                            }
                            return;
                        }
                        for(var key in properties)if (sprite[key] !== undefined) sprite[key] = properties[key];
                        else sprite.setData(key, properties[key]);
                    }
                });
                module1.exports = ObjectHelper;
            /***/ },
            /***/ 31989: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(80341);
                var MapData = __webpack_require__(87010);
                var Parse = __webpack_require__(46177);
                var Tilemap = __webpack_require__(49075);
                /**
 * Create a Tilemap from the given key or data. If neither is given, make a blank Tilemap. When
 * loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing from
 * a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map data. For
 * an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @function Phaser.Tilemaps.ParseToTilemap
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
 * @param {number} [tileWidth=32] - The width of a tile in pixels.
 * @param {number} [tileHeight=32] - The height of a tile in pixels.
 * @param {number} [width=10] - The width of the map in tiles.
 * @param {number} [height=10] - The height of the map in tiles.
 * @param {number[][]} [data] - Instead of loading from the cache, you can also load directly from
 * a 2D array of tile indexes.
 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.Tilemap}
 */ var ParseToTilemap = function(scene, key, tileWidth, tileHeight, width, height, data, insertNull) {
                    if (tileWidth === undefined) tileWidth = 32;
                    if (tileHeight === undefined) tileHeight = 32;
                    if (width === undefined) width = 10;
                    if (height === undefined) height = 10;
                    if (insertNull === undefined) insertNull = false;
                    var mapData = null;
                    if (Array.isArray(data)) {
                        var name = key !== undefined ? key : 'map';
                        mapData = Parse(name, Formats.ARRAY_2D, data, tileWidth, tileHeight, insertNull);
                    } else if (key !== undefined) {
                        var tilemapData = scene.cache.tilemap.get(key);
                        if (!tilemapData) console.warn('No map data found for key ' + key);
                        else mapData = Parse(key, tilemapData.format, tilemapData.data, tileWidth, tileHeight, insertNull);
                    }
                    if (mapData === null) mapData = new MapData({
                        tileWidth: tileWidth,
                        tileHeight: tileHeight,
                        width: width,
                        height: height
                    });
                    return new Tilemap(scene, mapData);
                };
                module1.exports = ParseToTilemap;
            /***/ },
            /***/ 23029: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Components = __webpack_require__(31401);
                var CONST = __webpack_require__(91907);
                var DeepCopy = __webpack_require__(62644);
                var Rectangle = __webpack_require__(93232);
                /**
 * @classdesc
 * A Tile is a representation of a single tile within the Tilemap. This is a lightweight data
 * representation, so its position information is stored without factoring in scroll, layer
 * scale or layer position.
 *
 * @class Tile
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The LayerData object in the Tilemap that this tile belongs to.
 * @param {number} index - The unique index of this tile within the map.
 * @param {number} x - The x coordinate of this tile in tile coordinates.
 * @param {number} y - The y coordinate of this tile in tile coordinates.
 * @param {number} width - Width of the tile in pixels.
 * @param {number} height - Height of the tile in pixels.
 * @param {number} baseWidth - The base width a tile in the map (in pixels). Tiled maps support
 * multiple tileset sizes within one map, but they are still placed at intervals of the base
 * tile width.
 * @param {number} baseHeight - The base height of the tile in pixels (in pixels). Tiled maps
 * support multiple tileset sizes within one map, but they are still placed at intervals of the
 * base tile height.
 */ var Tile = new Class({
                    Mixins: [
                        Components.AlphaSingle,
                        Components.Flip,
                        Components.Visible
                    ],
                    initialize: function Tile(layer, index, x, y, width, height, baseWidth, baseHeight) {
                        /**
         * The LayerData in the Tilemap data that this tile belongs to.
         *
         * @name Phaser.Tilemaps.Tile#layer
         * @type {Phaser.Tilemaps.LayerData}
         * @since 3.0.0
         */ this.layer = layer;
                        /**
         * The index of this tile within the map data corresponding to the tileset, or -1 if this
         * represents a blank tile.
         *
         * @name Phaser.Tilemaps.Tile#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                        /**
         * The x map coordinate of this tile in tile units.
         *
         * @name Phaser.Tilemaps.Tile#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                        /**
         * The y map coordinate of this tile in tile units.
         *
         * @name Phaser.Tilemaps.Tile#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                        /**
         * The width of the tile in pixels.
         *
         * @name Phaser.Tilemaps.Tile#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                        /**
         * The height of the tile in pixels.
         *
         * @name Phaser.Tilemaps.Tile#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                        /**
         * The right of the tile in pixels.
         *
         * Set in the `updatePixelXY` method.
         *
         * @name Phaser.Tilemaps.Tile#right
         * @type {number}
         * @since 3.50.0
         */ this.right;
                        /**
         * The bottom of the tile in pixels.
         *
         * Set in the `updatePixelXY` method.
         *
         * @name Phaser.Tilemaps.Tile#bottom
         * @type {number}
         * @since 3.50.0
         */ this.bottom;
                        /**
         * The maps base width of a tile in pixels. Tiled maps support multiple tileset sizes
         * within one map, but they are still placed at intervals of the base tile size.
         *
         * @name Phaser.Tilemaps.Tile#baseWidth
         * @type {number}
         * @since 3.0.0
         */ this.baseWidth = baseWidth !== undefined ? baseWidth : width;
                        /**
         * The maps base height of a tile in pixels. Tiled maps support multiple tileset sizes
         * within one map, but they are still placed at intervals of the base tile size.
         *
         * @name Phaser.Tilemaps.Tile#baseHeight
         * @type {number}
         * @since 3.0.0
         */ this.baseHeight = baseHeight !== undefined ? baseHeight : height;
                        /**
         * The x coordinate of the top left of this tile in pixels. This is relative to the top left
         * of the layer this tile is being rendered within. This property does NOT factor in camera
         * scroll, layer scale or layer position.
         *
         * @name Phaser.Tilemaps.Tile#pixelX
         * @type {number}
         * @since 3.0.0
         */ this.pixelX = 0;
                        /**
         * The y coordinate of the top left of this tile in pixels. This is relative to the top left
         * of the layer this tile is being rendered within. This property does NOT factor in camera
         * scroll, layer scale or layer position.
         *
         * @name Phaser.Tilemaps.Tile#pixelY
         * @type {number}
         * @since 3.0.0
         */ this.pixelY = 0;
                        this.updatePixelXY();
                        /**
         * Tile specific properties. These usually come from Tiled.
         *
         * @name Phaser.Tilemaps.Tile#properties
         * @type {any}
         * @since 3.0.0
         */ this.properties = {};
                        /**
         * The rotation angle of this tile.
         *
         * @name Phaser.Tilemaps.Tile#rotation
         * @type {number}
         * @since 3.0.0
         */ this.rotation = 0;
                        /**
         * Whether the tile should collide with any object on the left side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideLeft
         * @type {boolean}
         * @since 3.0.0
         */ this.collideLeft = false;
                        /**
         * Whether the tile should collide with any object on the right side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideRight
         * @type {boolean}
         * @since 3.0.0
         */ this.collideRight = false;
                        /**
         * Whether the tile should collide with any object on the top side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideUp
         * @type {boolean}
         * @since 3.0.0
         */ this.collideUp = false;
                        /**
         * Whether the tile should collide with any object on the bottom side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideDown
         * @type {boolean}
         * @since 3.0.0
         */ this.collideDown = false;
                        /**
         * Whether the tiles left edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceLeft
         * @type {boolean}
         * @since 3.0.0
         */ this.faceLeft = false;
                        /**
         * Whether the tiles right edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceRight
         * @type {boolean}
         * @since 3.0.0
         */ this.faceRight = false;
                        /**
         * Whether the tiles top edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceTop
         * @type {boolean}
         * @since 3.0.0
         */ this.faceTop = false;
                        /**
         * Whether the tiles bottom edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceBottom
         * @type {boolean}
         * @since 3.0.0
         */ this.faceBottom = false;
                        /**
         * Tile collision callback.
         *
         * @name Phaser.Tilemaps.Tile#collisionCallback
         * @type {function}
         * @since 3.0.0
         */ this.collisionCallback = undefined;
                        /**
         * The context in which the collision callback will be called.
         *
         * @name Phaser.Tilemaps.Tile#collisionCallbackContext
         * @type {object}
         * @since 3.0.0
         */ this.collisionCallbackContext = this;
                        /**
         * The tint to apply to this tile. Note: tint is currently a single color value instead of
         * the 4 corner tint component on other GameObjects.
         *
         * @name Phaser.Tilemaps.Tile#tint
         * @type {number}
         * @default
         * @since 3.0.0
         */ this.tint = 0xffffff;
                        /**
         * The tint fill mode.
         *
         * `false` = An additive tint (the default), where vertices colors are blended with the texture.
         * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.Tilemaps.Tile#tintFill
         * @type {boolean}
         * @default
         * @since 3.70.0
         */ this.tintFill = false;
                        /**
         * An empty object where physics-engine specific information (e.g. bodies) may be stored.
         *
         * @name Phaser.Tilemaps.Tile#physics
         * @type {object}
         * @since 3.0.0
         */ this.physics = {};
                    },
                    /**
     * Check if the given x and y world coordinates are within this Tile. This does not factor in
     * camera scroll, layer scale or layer position.
     *
     * @method Phaser.Tilemaps.Tile#containsPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to test.
     * @param {number} y - The y coordinate to test.
     *
     * @return {boolean} True if the coordinates are within this Tile, otherwise false.
     */ containsPoint: function(x, y) {
                        return !(x < this.pixelX || y < this.pixelY || x > this.right || y > this.bottom);
                    },
                    /**
     * Copies the tile data and properties from the given Tile to this Tile. This copies everything
     * except for position and interesting face calculations.
     *
     * @method Phaser.Tilemaps.Tile#copy
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile} tile - The tile to copy from.
     *
     * @return {this} This Tile object instance.
     */ copy: function(tile) {
                        this.index = tile.index;
                        this.alpha = tile.alpha;
                        this.properties = DeepCopy(tile.properties);
                        this.visible = tile.visible;
                        this.setFlip(tile.flipX, tile.flipY);
                        this.tint = tile.tint;
                        this.rotation = tile.rotation;
                        this.collideUp = tile.collideUp;
                        this.collideDown = tile.collideDown;
                        this.collideLeft = tile.collideLeft;
                        this.collideRight = tile.collideRight;
                        this.collisionCallback = tile.collisionCallback;
                        this.collisionCallbackContext = tile.collisionCallbackContext;
                        return this;
                    },
                    /**
     * The collision group for this Tile, defined within the Tileset. This returns a reference to
     * the collision group stored within the Tileset, so any modification of the returned object
     * will impact all tiles that have the same index as this tile.
     *
     * @method Phaser.Tilemaps.Tile#getCollisionGroup
     * @since 3.0.0
     *
     * @return {?object} The collision group for this Tile, as defined in the Tileset, or `null` if no group was defined.
     */ getCollisionGroup: function() {
                        return this.tileset ? this.tileset.getTileCollisionGroup(this.index) : null;
                    },
                    /**
     * The tile data for this Tile, defined within the Tileset. This typically contains Tiled
     * collision data, tile animations and terrain information. This returns a reference to the tile
     * data stored within the Tileset, so any modification of the returned object will impact all
     * tiles that have the same index as this tile.
     *
     * @method Phaser.Tilemaps.Tile#getTileData
     * @since 3.0.0
     *
     * @return {?object} The tile data for this Tile, as defined in the Tileset, or `null` if no data was defined.
     */ getTileData: function() {
                        return this.tileset ? this.tileset.getTileData(this.index) : null;
                    },
                    /**
     * Gets the world X position of the left side of the tile, factoring in the layers position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getLeft
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The left (x) value of this tile.
     */ getLeft: function(camera) {
                        var tilemapLayer = this.tilemapLayer;
                        if (tilemapLayer) {
                            var point = tilemapLayer.tileToWorldXY(this.x, this.y, undefined, camera);
                            return point.x;
                        }
                        return this.x * this.baseWidth;
                    },
                    /**
     * Gets the world X position of the right side of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getRight
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The right (x) value of this tile.
     */ getRight: function(camera) {
                        var tilemapLayer = this.tilemapLayer;
                        return tilemapLayer ? this.getLeft(camera) + this.width * tilemapLayer.scaleX : this.getLeft(camera) + this.width;
                    },
                    /**
     * Gets the world Y position of the top side of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getTop
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The top (y) value of this tile.
     */ getTop: function(camera) {
                        var tilemapLayer = this.tilemapLayer;
                        // Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile in grid
                        // units is the bottom left, so the y coordinate needs to be adjusted by the difference
                        // between the base size and this tile's size.
                        if (tilemapLayer) {
                            var point = tilemapLayer.tileToWorldXY(this.x, this.y, undefined, camera);
                            return point.y;
                        }
                        return this.y * this.baseWidth - (this.height - this.baseHeight);
                    },
                    /**
     * Gets the world Y position of the bottom side of the tile, factoring in the layer's position,
     * scale and scroll.

     * @method Phaser.Tilemaps.Tile#getBottom
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The bottom (y) value of this tile.
     */ getBottom: function(camera) {
                        var tilemapLayer = this.tilemapLayer;
                        return tilemapLayer ? this.getTop(camera) + this.height * tilemapLayer.scaleY : this.getTop(camera) + this.height;
                    },
                    /**
     * Gets the world rectangle bounding box for the tile, factoring in the layers position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     * @param {Phaser.Geom.Rectangle} [output] - Optional Rectangle object to store the results in.
     *
     * @return {(Phaser.Geom.Rectangle|object)} The bounds of this Tile.
     */ getBounds: function(camera, output) {
                        if (output === undefined) output = new Rectangle();
                        output.x = this.getLeft(camera);
                        output.y = this.getTop(camera);
                        output.width = this.getRight(camera) - output.x;
                        output.height = this.getBottom(camera) - output.y;
                        return output;
                    },
                    /**
     * Gets the world X position of the center of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getCenterX
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The center x position of this Tile.
     */ getCenterX: function(camera) {
                        return (this.getLeft(camera) + this.getRight(camera)) / 2;
                    },
                    /**
     * Gets the world Y position of the center of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getCenterY
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The center y position of this Tile.
     */ getCenterY: function(camera) {
                        return (this.getTop(camera) + this.getBottom(camera)) / 2;
                    },
                    /**
     * Check for intersection with this tile. This does not factor in camera scroll, layer scale or
     * layer position.
     *
     * @method Phaser.Tilemaps.Tile#intersects
     * @since 3.0.0
     *
     * @param {number} x - The x axis in pixels.
     * @param {number} y - The y axis in pixels.
     * @param {number} right - The right point.
     * @param {number} bottom - The bottom point.
     *
     * @return {boolean} `true` if the Tile intersects with the given dimensions, otherwise `false`.
     */ intersects: function(x, y, right, bottom) {
                        return !(right <= this.pixelX || bottom <= this.pixelY || x >= this.right || y >= this.bottom);
                    },
                    /**
     * Checks if the tile is interesting.
     *
     * @method Phaser.Tilemaps.Tile#isInteresting
     * @since 3.0.0
     *
     * @param {boolean} collides - If true, will consider the tile interesting if it collides on any side.
     * @param {boolean} faces - If true, will consider the tile interesting if it has an interesting face.
     *
     * @return {boolean} True if the Tile is interesting, otherwise false.
     */ isInteresting: function(collides, faces) {
                        if (collides && faces) return this.canCollide || this.hasInterestingFace;
                        else if (collides) return this.collides;
                        else if (faces) return this.hasInterestingFace;
                        return false;
                    },
                    /**
     * Reset collision status flags.
     *
     * @method Phaser.Tilemaps.Tile#resetCollision
     * @since 3.0.0
     *
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces for this tile and its neighbors.
     *
     * @return {this} This Tile object instance.
     */ resetCollision: function(recalculateFaces) {
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        this.collideLeft = false;
                        this.collideRight = false;
                        this.collideUp = false;
                        this.collideDown = false;
                        this.faceTop = false;
                        this.faceBottom = false;
                        this.faceLeft = false;
                        this.faceRight = false;
                        if (recalculateFaces) {
                            var tilemapLayer = this.tilemapLayer;
                            if (tilemapLayer) this.tilemapLayer.calculateFacesAt(this.x, this.y);
                        }
                        return this;
                    },
                    /**
     * Reset faces.
     *
     * @method Phaser.Tilemaps.Tile#resetFaces
     * @since 3.0.0
     *
     * @return {this} This Tile object instance.
     */ resetFaces: function() {
                        this.faceTop = false;
                        this.faceBottom = false;
                        this.faceLeft = false;
                        this.faceRight = false;
                        return this;
                    },
                    /**
     * Sets the collision flags for each side of this tile and updates the interesting faces list.
     *
     * @method Phaser.Tilemaps.Tile#setCollision
     * @since 3.0.0
     *
     * @param {boolean} left - Indicating collide with any object on the left.
     * @param {boolean} [right] - Indicating collide with any object on the right.
     * @param {boolean} [up] - Indicating collide with any object on the top.
     * @param {boolean} [down] - Indicating collide with any object on the bottom.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces for this tile and its neighbors.
     *
     * @return {this} This Tile object instance.
     */ setCollision: function(left, right, up, down, recalculateFaces) {
                        if (right === undefined) right = left;
                        if (up === undefined) up = left;
                        if (down === undefined) down = left;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        this.collideLeft = left;
                        this.collideRight = right;
                        this.collideUp = up;
                        this.collideDown = down;
                        this.faceLeft = left;
                        this.faceRight = right;
                        this.faceTop = up;
                        this.faceBottom = down;
                        if (recalculateFaces) {
                            var tilemapLayer = this.tilemapLayer;
                            if (tilemapLayer) this.tilemapLayer.calculateFacesAt(this.x, this.y);
                        }
                        return this;
                    },
                    /**
     * Set a callback to be called when this tile is hit by an object. The callback must true for
     * collision processing to take place.
     *
     * @method Phaser.Tilemaps.Tile#setCollisionCallback
     * @since 3.0.0
     *
     * @param {function} callback - Callback function.
     * @param {object} context - Callback will be called within this context.
     *
     * @return {this} This Tile object instance.
     */ setCollisionCallback: function(callback, context) {
                        if (callback === null) {
                            this.collisionCallback = undefined;
                            this.collisionCallbackContext = undefined;
                        } else {
                            this.collisionCallback = callback;
                            this.collisionCallbackContext = context;
                        }
                        return this;
                    },
                    /**
     * Sets the size of the tile and updates its pixelX and pixelY.
     *
     * @method Phaser.Tilemaps.Tile#setSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tile in pixels.
     * @param {number} tileHeight - The height of the tile in pixels.
     * @param {number} baseWidth - The base width a tile in the map (in pixels).
     * @param {number} baseHeight - The base height of the tile in pixels (in pixels).
     *
     * @return {this} This Tile object instance.
     */ setSize: function(tileWidth, tileHeight, baseWidth, baseHeight) {
                        if (tileWidth !== undefined) this.width = tileWidth;
                        if (tileHeight !== undefined) this.height = tileHeight;
                        if (baseWidth !== undefined) this.baseWidth = baseWidth;
                        if (baseHeight !== undefined) this.baseHeight = baseHeight;
                        this.updatePixelXY();
                        return this;
                    },
                    /**
     * Used internally. Updates the tiles world XY position based on the current tile size.
     *
     * @method Phaser.Tilemaps.Tile#updatePixelXY
     * @since 3.0.0
     *
     * @return {this} This Tile object instance.
     */ updatePixelXY: function() {
                        var orientation = this.layer.orientation;
                        if (orientation === CONST.ORTHOGONAL) {
                            //  In orthogonal mode, Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile is the
                            //  bottom left, while the Phaser renderer assumes the origin is the top left. The y
                            //  coordinate needs to be adjusted by the difference.
                            this.pixelX = this.x * this.baseWidth;
                            this.pixelY = this.y * this.baseHeight;
                        } else if (orientation === CONST.ISOMETRIC) {
                            //  Reminder: For the tilemap to be centered we have to move the image to the right with the camera!
                            //  This is crucial for wordtotile, tiletoworld to work.
                            this.pixelX = (this.x - this.y) * this.baseWidth * 0.5;
                            this.pixelY = (this.x + this.y) * this.baseHeight * 0.5;
                        } else if (orientation === CONST.STAGGERED) {
                            this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2);
                            this.pixelY = this.y * (this.baseHeight / 2);
                        } else if (orientation === CONST.HEXAGONAL) {
                            var staggerAxis = this.layer.staggerAxis;
                            var staggerIndex = this.layer.staggerIndex;
                            var len = this.layer.hexSideLength;
                            var rowWidth;
                            var rowHeight;
                            if (staggerAxis === 'y') {
                                rowHeight = (this.baseHeight - len) / 2 + len;
                                if (staggerIndex === 'odd') this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2);
                                else this.pixelX = this.x * this.baseWidth - this.y % 2 * (this.baseWidth / 2);
                                this.pixelY = this.y * rowHeight;
                            } else if (staggerAxis === 'x') {
                                rowWidth = (this.baseWidth - len) / 2 + len;
                                this.pixelX = this.x * rowWidth;
                                if (staggerIndex === 'odd') this.pixelY = this.y * this.baseHeight + this.x % 2 * (this.baseHeight / 2);
                                else this.pixelY = this.y * this.baseHeight - this.x % 2 * (this.baseHeight / 2);
                            }
                        }
                        this.right = this.pixelX + this.baseWidth;
                        this.bottom = this.pixelY + this.baseHeight;
                        return this;
                    },
                    /**
     * Clean up memory.
     *
     * @method Phaser.Tilemaps.Tile#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.collisionCallback = undefined;
                        this.collisionCallbackContext = undefined;
                        this.properties = undefined;
                    },
                    /**
     * True if this tile can collide on any of its faces or has a collision callback set.
     *
     * @name Phaser.Tilemaps.Tile#canCollide
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ canCollide: {
                        get: function() {
                            return this.collideLeft || this.collideRight || this.collideUp || this.collideDown || this.collisionCallback !== undefined;
                        }
                    },
                    /**
     * True if this tile can collide on any of its faces.
     *
     * @name Phaser.Tilemaps.Tile#collides
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ collides: {
                        get: function() {
                            return this.collideLeft || this.collideRight || this.collideUp || this.collideDown;
                        }
                    },
                    /**
     * True if this tile has any interesting faces.
     *
     * @name Phaser.Tilemaps.Tile#hasInterestingFace
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ hasInterestingFace: {
                        get: function() {
                            return this.faceTop || this.faceBottom || this.faceLeft || this.faceRight;
                        }
                    },
                    /**
     * The tileset that contains this Tile. This is null if accessed from a LayerData instance
     * before the tile is placed in a TilemapLayer, or if the tile has an index that doesn't correspond
     * to any of the maps tilesets.
     *
     * @name Phaser.Tilemaps.Tile#tileset
     * @type {?Phaser.Tilemaps.Tileset}
     * @readonly
     * @since 3.0.0
     */ tileset: {
                        get: function() {
                            var tilemapLayer = this.layer.tilemapLayer;
                            if (tilemapLayer) {
                                var tileset = tilemapLayer.gidMap[this.index];
                                if (tileset) return tileset;
                            }
                            return null;
                        }
                    },
                    /**
     * The tilemap layer that contains this Tile. This will only return null if accessed from a
     * LayerData instance before the tile is placed within a TilemapLayer.
     *
     * @name Phaser.Tilemaps.Tile#tilemapLayer
     * @type {?Phaser.Tilemaps.TilemapLayer}
     * @readonly
     * @since 3.0.0
     */ tilemapLayer: {
                        get: function() {
                            return this.layer.tilemapLayer;
                        }
                    },
                    /**
     * The tilemap that contains this Tile. This will only return null if accessed from a LayerData
     * instance before the tile is placed within a TilemapLayer.
     *
     * @name Phaser.Tilemaps.Tile#tilemap
     * @type {?Phaser.Tilemaps.Tilemap}
     * @readonly
     * @since 3.0.0
     */ tilemap: {
                        get: function() {
                            var tilemapLayer = this.tilemapLayer;
                            return tilemapLayer ? tilemapLayer.tilemap : null;
                        }
                    }
                });
                module1.exports = Tile;
            /***/ },
            /***/ 49075: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildTilesetIndex = __webpack_require__(84101);
                var Class = __webpack_require__(83419);
                var DegToRad = __webpack_require__(39506);
                var Formats = __webpack_require__(80341);
                var GetFastValue = __webpack_require__(95540);
                var LayerData = __webpack_require__(14977);
                var ObjectHelper = __webpack_require__(27462);
                var ORIENTATION = __webpack_require__(91907);
                var Rotate = __webpack_require__(36305);
                var SpliceOne = __webpack_require__(19133);
                var Sprite = __webpack_require__(68287);
                var Tile = __webpack_require__(23029);
                var TilemapComponents = __webpack_require__(81086);
                var TilemapLayer = __webpack_require__(20442);
                var Tileset = __webpack_require__(33629);
                /**
 * A predicate, to test each element of the array.
 *
 * @callback TilemapFilterCallback
 *
 * @param {Phaser.GameObjects.GameObject} value - An object found in the filtered area.
 * @param {number} index - The index of the object within the array.
 * @param {Phaser.GameObjects.GameObject[]} array - An array of all the objects found.
 *
 * @return {boolean} A value that coerces to `true` to keep the element, or to `false` otherwise.
 */ /**
 * @callback TilemapFindCallback
 *
 * @param {Phaser.GameObjects.GameObject} value - An object found.
 * @param {number} index - The index of the object within the array.
 * @param {Phaser.GameObjects.GameObject[]} array - An array of all the objects found.
 *
 * @return {boolean} `true` if the callback should be invoked, otherwise `false`.
 */ /**
 * @classdesc
 * A Tilemap is a container for Tilemap data. This isn't a display object, rather, it holds data
 * about the map and allows you to add tilesets and tilemap layers to it. A map can have one or
 * more tilemap layers, which are the display objects that actually render the tiles.
 *
 * The Tilemap data can be parsed from a Tiled JSON file, a CSV file or a 2D array. Tiled is a free
 * software package specifically for creating tile maps, and is available from:
 * http://www.mapeditor.org
 *
 * As of Phaser 3.50.0 the Tilemap API now supports the following types of map:
 *
 * 1) Orthogonal
 * 2) Isometric
 * 3) Hexagonal
 * 4) Staggered
 *
 * Prior to this release, only orthogonal maps were supported.
 *
 * Another large change in 3.50 was the consolidation of Tilemap Layers. Previously, you created
 * either a Static or Dynamic Tilemap Layer. However, as of 3.50 the features of both have been
 * merged and the API simplified, so now there is just the single `TilemapLayer` class.
 *
 * A Tilemap has handy methods for getting and manipulating the tiles within a layer, allowing
 * you to build or modify the tilemap data at runtime.
 *
 * Note that all Tilemaps use a base tile size to calculate dimensions from, but that a
 * TilemapLayer may have its own unique tile size that overrides this.
 *
 * As of Phaser 3.21.0, if your tilemap includes layer groups (a feature of Tiled 1.2.0+) these
 * will be traversed and the following properties will impact children:
 *
 * - Opacity (blended with parent) and visibility (parent overrides child)
 * - Vertical and horizontal offset
 *
 * The grouping hierarchy is not preserved and all layers will be flattened into a single array.
 *
 * Group layers are parsed during Tilemap construction but are discarded after parsing so dynamic
 * layers will NOT continue to be affected by a parent.
 *
 * To avoid duplicate layer names, a layer that is a child of a group layer will have its parent
 * group name prepended with a '/'.  For example, consider a group called 'ParentGroup' with a
 * child called 'Layer 1'. In the Tilemap object, 'Layer 1' will have the name
 * 'ParentGroup/Layer 1'.
 *
 * The Phaser Tiled Parser does **not** support the 'Collection of Images' feature for a Tileset.
 * You must ensure all of your tiles are contained in a single tileset image file (per layer)
 * and have this 'embedded' in the exported Tiled JSON map data.
 *
 * @class Tilemap
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
 * @param {Phaser.Tilemaps.MapData} mapData - A MapData instance containing Tilemap data.
 */ var Tilemap = new Class({
                    initialize: function Tilemap(scene, mapData) {
                        /**
             * @name Phaser.Tilemaps.Tilemap#scene
             * @type {Phaser.Scene}
             * @since 3.0.0
             */ this.scene = scene;
                        /**
             * The base width of a tile in pixels. Note that individual layers may have a different tile
             * width.
             *
             * @name Phaser.Tilemaps.Tilemap#tileWidth
             * @type {number}
             * @since 3.0.0
             */ this.tileWidth = mapData.tileWidth;
                        /**
             * The base height of a tile in pixels. Note that individual layers may have a different
             * tile height.
             *
             * @name Phaser.Tilemaps.Tilemap#tileHeight
             * @type {number}
             * @since 3.0.0
             */ this.tileHeight = mapData.tileHeight;
                        /**
             * The width of the map (in tiles).
             *
             * @name Phaser.Tilemaps.Tilemap#width
             * @type {number}
             * @since 3.0.0
             */ this.width = mapData.width;
                        /**
             * The height of the map (in tiles).
             *
             * @name Phaser.Tilemaps.Tilemap#height
             * @type {number}
             * @since 3.0.0
             */ this.height = mapData.height;
                        /**
             * The orientation of the map data (as specified in Tiled), usually 'orthogonal'.
             *
             * @name Phaser.Tilemaps.Tilemap#orientation
             * @type {string}
             * @since 3.0.0
             */ this.orientation = mapData.orientation;
                        /**
             * The render (draw) order of the map data (as specified in Tiled), usually 'right-down'.
             *
             * The draw orders are:
             *
             * right-down
             * left-down
             * right-up
             * left-up
             *
             * This can be changed via the `setRenderOrder` method.
             *
             * @name Phaser.Tilemaps.Tilemap#renderOrder
             * @type {string}
             * @since 3.12.0
             */ this.renderOrder = mapData.renderOrder;
                        /**
             * The format of the map data.
             *
             * @name Phaser.Tilemaps.Tilemap#format
             * @type {number}
             * @since 3.0.0
             */ this.format = mapData.format;
                        /**
             * The version of the map data (as specified in Tiled, usually 1).
             *
             * @name Phaser.Tilemaps.Tilemap#version
             * @type {number}
             * @since 3.0.0
             */ this.version = mapData.version;
                        /**
             * Map specific properties as specified in Tiled.
             *
             * Depending on the version of Tiled and the JSON export used, this will be either
             * an object or an array of objects. For Tiled 1.2.0+ maps, it will be an array.
             *
             * @name Phaser.Tilemaps.Tilemap#properties
             * @type {object|object[]}
             * @since 3.0.0
             */ this.properties = mapData.properties;
                        /**
             * The width of the map in pixels based on width * tileWidth.
             *
             * @name Phaser.Tilemaps.Tilemap#widthInPixels
             * @type {number}
             * @since 3.0.0
             */ this.widthInPixels = mapData.widthInPixels;
                        /**
             * The height of the map in pixels based on height * tileHeight.
             *
             * @name Phaser.Tilemaps.Tilemap#heightInPixels
             * @type {number}
             * @since 3.0.0
             */ this.heightInPixels = mapData.heightInPixels;
                        /**
             * A collection of Images, as parsed from Tiled map data.
             *
             * @name Phaser.Tilemaps.Tilemap#imageCollections
             * @type {Phaser.Tilemaps.ImageCollection[]}
             * @since 3.0.0
             */ this.imageCollections = mapData.imageCollections;
                        /**
             * An array of Tiled Image Layers.
             *
             * @name Phaser.Tilemaps.Tilemap#images
             * @type {array}
             * @since 3.0.0
             */ this.images = mapData.images;
                        /**
             * An array of Tilemap layer data.
             *
             * @name Phaser.Tilemaps.Tilemap#layers
             * @type {Phaser.Tilemaps.LayerData[]}
             * @since 3.0.0
             */ this.layers = mapData.layers;
                        /**
             * Master list of tiles -> x, y, index in tileset.
             *
             * @name Phaser.Tilemaps.Tilemap#tiles
             * @type {array}
             * @since 3.60.0
             * @see Phaser.Tilemaps.Parsers.Tiled.BuildTilesetIndex
             */ this.tiles = mapData.tiles;
                        /**
             * An array of Tilesets used in the map.
             *
             * @name Phaser.Tilemaps.Tilemap#tilesets
             * @type {Phaser.Tilemaps.Tileset[]}
             * @since 3.0.0
             */ this.tilesets = mapData.tilesets;
                        /**
             * An array of ObjectLayer instances parsed from Tiled object layers.
             *
             * @name Phaser.Tilemaps.Tilemap#objects
             * @type {Phaser.Tilemaps.ObjectLayer[]}
             * @since 3.0.0
             */ this.objects = mapData.objects;
                        /**
             * The index of the currently selected LayerData object.
             *
             * @name Phaser.Tilemaps.Tilemap#currentLayerIndex
             * @type {number}
             * @since 3.0.0
             */ this.currentLayerIndex = 0;
                        /**
             * The length of the horizontal sides of the hexagon.
             * Only used for hexagonal orientation Tilemaps.
             *
             * @name Phaser.Tilemaps.Tilemap#hexSideLength
             * @type {number}
             * @since 3.50.0
             */ this.hexSideLength = mapData.hexSideLength;
                        var orientation = this.orientation;
                        /**
             * Functions used to handle world to tile, and tile to world, conversion.
             * Cached here for internal use by public methods such as `worldToTileXY`, etc.
             *
             * @name Phaser.Tilemaps.Tilemap#_convert
             * @private
             * @type {object}
             * @since 3.50.0
             */ this._convert = {
                            WorldToTileXY: TilemapComponents.GetWorldToTileXYFunction(orientation),
                            WorldToTileX: TilemapComponents.GetWorldToTileXFunction(orientation),
                            WorldToTileY: TilemapComponents.GetWorldToTileYFunction(orientation),
                            TileToWorldXY: TilemapComponents.GetTileToWorldXYFunction(orientation),
                            TileToWorldX: TilemapComponents.GetTileToWorldXFunction(orientation),
                            TileToWorldY: TilemapComponents.GetTileToWorldYFunction(orientation),
                            GetTileCorners: TilemapComponents.GetTileCornersFunction(orientation)
                        };
                    },
                    /**
     * Sets the rendering (draw) order of the tiles in this map.
     *
     * The default is 'right-down', meaning it will order the tiles starting from the top-left,
     * drawing to the right and then moving down to the next row.
     *
     * The draw orders are:
     *
     * 0 = right-down
     * 1 = left-down
     * 2 = right-up
     * 3 = left-up
     *
     * Setting the render order does not change the tiles or how they are stored in the layer,
     * it purely impacts the order in which they are rendered.
     *
     * You can provide either an integer (0 to 3), or the string version of the order.
     *
     * Calling this method _after_ creating Tilemap Layers will **not** automatically
     * update them to use the new render order. If you call this method after creating layers, use their
     * own `setRenderOrder` methods to change them as needed.
     *
     * @method Phaser.Tilemaps.Tilemap#setRenderOrder
     * @since 3.12.0
     *
     * @param {(number|string)} renderOrder - The render (draw) order value. Either an integer between 0 and 3, or a string: 'right-down', 'left-down', 'right-up' or 'left-up'.
     *
     * @return {this} This Tilemap object.
     */ setRenderOrder: function(renderOrder) {
                        var orders = [
                            'right-down',
                            'left-down',
                            'right-up',
                            'left-up'
                        ];
                        if (typeof renderOrder === 'number') renderOrder = orders[renderOrder];
                        if (orders.indexOf(renderOrder) > -1) this.renderOrder = renderOrder;
                        return this;
                    },
                    /**
     * Adds an image to the map to be used as a tileset. A single map may use multiple tilesets.
     * Note that the tileset name can be found in the JSON file exported from Tiled, or in the Tiled
     * editor.
     *
     * @method Phaser.Tilemaps.Tilemap#addTilesetImage
     * @since 3.0.0
     *
     * @param {string} tilesetName - The name of the tileset as specified in the map data.
     * @param {string} [key] - The key of the Phaser.Cache image used for this tileset. If
     * `undefined` or `null` it will look for an image with a key matching the tilesetName parameter.
     * @param {number} [tileWidth] - The width of the tile (in pixels) in the Tileset Image. If not
     * given it will default to the map's tileWidth value, or the tileWidth specified in the Tiled
     * JSON file.
     * @param {number} [tileHeight] - The height of the tiles (in pixels) in the Tileset Image. If
     * not given it will default to the map's tileHeight value, or the tileHeight specified in the
     * Tiled JSON file.
     * @param {number} [tileMargin] - The margin around the tiles in the sheet (in pixels). If not
     * specified, it will default to 0 or the value specified in the Tiled JSON file.
     * @param {number} [tileSpacing] - The spacing between each the tile in the sheet (in pixels).
     * If not specified, it will default to 0 or the value specified in the Tiled JSON file.
     * @param {number} [gid=0] - If adding multiple tilesets to a blank map, specify the starting
     * GID this set will use here.
     * @param {object} [tileOffset={x: 0, y: 0}] - Tile texture drawing offset.
     * If not specified, it will default to {0, 0}
     *
     * @return {?Phaser.Tilemaps.Tileset} Returns the Tileset object that was created or updated, or null if it
     * failed.
     */ addTilesetImage: function(tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid, tileOffset) {
                        if (tilesetName === undefined) return null;
                        if (key === undefined || key === null) key = tilesetName;
                        var textureManager = this.scene.sys.textures;
                        if (!textureManager.exists(key)) {
                            console.warn('Texture key "%s" not found', key);
                            return null;
                        }
                        var texture = textureManager.get(key);
                        var index = this.getTilesetIndex(tilesetName);
                        if (index === null && this.format === Formats.TILED_JSON) {
                            console.warn('Tilemap has no tileset "%s". Its tilesets are %o', tilesetName, this.tilesets);
                            return null;
                        }
                        var tileset = this.tilesets[index];
                        if (tileset) {
                            if (tileWidth || tileHeight) tileset.setTileSize(tileWidth, tileHeight);
                            if (tileMargin || tileSpacing) tileset.setSpacing(tileMargin, tileSpacing);
                            tileset.setImage(texture);
                            return tileset;
                        }
                        if (tileWidth === undefined) tileWidth = this.tileWidth;
                        if (tileHeight === undefined) tileHeight = this.tileHeight;
                        if (tileMargin === undefined) tileMargin = 0;
                        if (tileSpacing === undefined) tileSpacing = 0;
                        if (gid === undefined) gid = 0;
                        if (tileOffset === undefined) tileOffset = {
                            x: 0,
                            y: 0
                        };
                        tileset = new Tileset(tilesetName, gid, tileWidth, tileHeight, tileMargin, tileSpacing, undefined, undefined, tileOffset);
                        tileset.setImage(texture);
                        this.tilesets.push(tileset);
                        this.tiles = BuildTilesetIndex(this);
                        return tileset;
                    },
                    /**
     * Copies the tiles in the source rectangular area to a new destination (all specified in tile
     * coordinates) within the layer. This copies all tile properties & recalculates collision
     * information in the destination region.
     *
     * If no layer specified, the map's current layer is used. This cannot be applied to StaticTilemapLayers.
     *
     * @method Phaser.Tilemaps.Tilemap#copy
     * @since 3.0.0
     *
     * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} width - The width of the area to copy, in tiles, not pixels.
     * @param {number} height - The height of the area to copy, in tiles, not pixels.
     * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
     * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ copy: function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer) {
                        layer = this.getLayer(layer);
                        if (layer !== null) {
                            TilemapComponents.Copy(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer);
                            return this;
                        } else return null;
                    },
                    /**
     * Creates a new and empty Tilemap Layer. The currently selected layer in the map is set to this new layer.
     *
     * Prior to v3.50.0 this method was called `createBlankDynamicLayer`.
     *
     * @method Phaser.Tilemaps.Tilemap#createBlankLayer
     * @since 3.0.0
     *
     * @param {string} name - The name of this layer. Must be unique within the map.
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
     * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
     * @param {number} [width] - The width of the layer in tiles. If not specified, it will default to the map's width.
     * @param {number} [height] - The height of the layer in tiles. If not specified, it will default to the map's height.
     * @param {number} [tileWidth] - The width of the tiles the layer uses for calculations. If not specified, it will default to the map's tileWidth.
     * @param {number} [tileHeight] - The height of the tiles the layer uses for calculations. If not specified, it will default to the map's tileHeight.
     *
     * @return {?Phaser.Tilemaps.TilemapLayer} Returns the new layer that was created, or `null` if it failed.
     */ createBlankLayer: function(name, tileset, x, y, width, height, tileWidth, tileHeight) {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (width === undefined) width = this.width;
                        if (height === undefined) height = this.height;
                        if (tileWidth === undefined) tileWidth = this.tileWidth;
                        if (tileHeight === undefined) tileHeight = this.tileHeight;
                        var index = this.getLayerIndex(name);
                        if (index !== null) {
                            console.warn('Invalid Tilemap Layer ID: ' + name);
                            return null;
                        }
                        var layerData = new LayerData({
                            name: name,
                            tileWidth: tileWidth,
                            tileHeight: tileHeight,
                            width: width,
                            height: height,
                            orientation: this.orientation,
                            hexSideLength: this.hexSideLength
                        });
                        var row;
                        for(var tileY = 0; tileY < height; tileY++){
                            row = [];
                            for(var tileX = 0; tileX < width; tileX++)row.push(new Tile(layerData, -1, tileX, tileY, tileWidth, tileHeight, this.tileWidth, this.tileHeight));
                            layerData.data.push(row);
                        }
                        this.layers.push(layerData);
                        this.currentLayerIndex = this.layers.length - 1;
                        var layer = new TilemapLayer(this.scene, this, this.currentLayerIndex, tileset, x, y);
                        layer.setRenderOrder(this.renderOrder);
                        this.scene.sys.displayList.add(layer);
                        return layer;
                    },
                    /**
     * Creates a new Tilemap Layer that renders the LayerData associated with the given
     * `layerID`. The currently selected layer in the map is set to this new layer.
     *
     * The `layerID` is important. If you've created your map in Tiled then you can get this by
     * looking in Tiled and looking at the layer name. Or you can open the JSON file it exports and
     * look at the layers[].name value. Either way it must match.
     *
     * Prior to v3.50.0 this method was called `createDynamicLayer`.
     *
     * @method Phaser.Tilemaps.Tilemap#createLayer
     * @since 3.0.0
     *
     * @param {(number|string)} layerID - The layer array index value, or if a string is given, the layer name from Tiled.
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     * @param {number} [x=0] - The x position to place the layer in the world. If not specified, it will default to the layer offset from Tiled or 0.
     * @param {number} [y=0] - The y position to place the layer in the world. If not specified, it will default to the layer offset from Tiled or 0.
     *
     * @return {?Phaser.Tilemaps.TilemapLayer} Returns the new layer was created, or null if it failed.
     */ createLayer: function(layerID, tileset, x, y) {
                        var index = this.getLayerIndex(layerID);
                        if (index === null) {
                            console.warn('Invalid Tilemap Layer ID: ' + layerID);
                            if (typeof layerID === 'string') console.warn('Valid tilelayer names: %o', this.getTileLayerNames());
                            return null;
                        }
                        var layerData = this.layers[index];
                        // Check for an associated tilemap layer
                        if (layerData.tilemapLayer) {
                            console.warn('Tilemap Layer ID already exists:' + layerID);
                            return null;
                        }
                        this.currentLayerIndex = index;
                        //  Default the x/y position to match Tiled layer offset, if it exists.
                        if (x === undefined) x = layerData.x;
                        if (y === undefined) y = layerData.y;
                        var layer = new TilemapLayer(this.scene, this, index, tileset, x, y);
                        layer.setRenderOrder(this.renderOrder);
                        this.scene.sys.displayList.add(layer);
                        return layer;
                    },
                    /**
     * This method will iterate through all of the objects defined in a Tiled Object Layer and then
     * convert the matching results into Phaser Game Objects (by default, Sprites)
     *
     * Objects are matched on one of 4 criteria: The Object ID, the Object GID, the Object Name, or the Object Type.
     *
     * Within Tiled, Object IDs are unique per Object. Object GIDs, however, are shared by all objects
     * using the same image. Finally, Object Names and Types are strings and the same name can be used on multiple
     * Objects in Tiled, they do not have to be unique; Names are specific to Objects while Types can be inherited
     * from Object GIDs using the same image.
     *
     * You set the configuration parameter accordingly, based on which type of criteria you wish
     * to match against. For example, to convert all items on an Object Layer with a `gid` of 26:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   gid: 26
     * });
     * ```
     *
     * Or, to convert objects with the name 'bonus':
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   name: 'bonus'
     * });
     * ```
     *
     * Or, to convert an object with a specific id:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   id: 9
     * });
     * ```
     *
     * You should only specify either `id`, `gid`, `name`, `type`, or none of them. Do not add more than
     * one criteria to your config. If you do not specify any criteria, then _all_ objects in the
     * Object Layer will be converted.
     *
     * By default this method will convert Objects into {@link Phaser.GameObjects.Sprite} instances, but you can override
     * this by providing your own class type:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   gid: 26,
     *   classType: Coin
     * });
     * ```
     *
     * This will convert all Objects with a gid of 26 into your custom `Coin` class. You can pass
     * any class type here, but it _must_ extend {@link Phaser.GameObjects.GameObject} as its base class.
     * Your class will always be passed 1 parameter: `scene`, which is a reference to either the Scene
     * specified in the config object or, if not given, the Scene to which this Tilemap belongs. The
     * class must have {@link Phaser.GameObjects.Components.Transform#setPosition setPosition} and
     * {@link Phaser.GameObjects.Components.Texture#setTexture setTexture} methods.
     *
     * This method will set the following Tiled Object properties on the new Game Object:
     *
     * - `flippedHorizontal` as `flipX`
     * - `flippedVertical` as `flipY`
     * - `height` as `displayHeight`
     * - `name`
     * - `rotation`
     * - `visible`
     * - `width` as `displayWidth`
     * - `x`, adjusted for origin
     * - `y`, adjusted for origin
     *
     * Additionally, this method will set Tiled Object custom properties
     *
     * - on the Game Object, if it has the same property name and a value that isn't `undefined`; or
     * - on the Game Object's {@link Phaser.GameObjects.GameObject#data data store} otherwise.
     *
     * For example, a Tiled Object with custom properties `{ alpha: 0.5, gold: 1 }` will be created as a Game
     * Object with an `alpha` value of 0.5 and a `data.values.gold` value of 1.
     *
     * When `useTileset` is `true` (the default), Tile Objects will inherit the texture and any tile properties
     * from the tileset, and the local tile ID will be used as the texture frame. For the frame selection to work
     * you need to load the tileset texture as a spritesheet so its frame names match the local tile IDs.
     *
     * For instance, a tileset tile
     *
     * ```
     * { id: 3, type: 'treadmill', speed: 4 }
     * ```
     *
     * with gid 19 and an object
     *
     * ```
     * { id: 7, gid: 19, speed: 5, rotation: 90 }
     * ```
     *
     * will be interpreted as
     *
     * ```
     * { id: 7, gid: 19, speed: 5, rotation: 90, type: 'treadmill', texture: '[the tileset texture]', frame: 3 }
     * ```
     *
     * You can suppress this behavior by setting the boolean `ignoreTileset` for each `config` that should ignore
     * object gid tilesets.
     *
     * You can set a `container` property in the config. If given, the new Game Object will be added to
     * the Container or Layer instance instead of the Scene.
     *
     * You can set named texture-`key` and texture-`frame` properties, which will be set on the new Game Object.
     *
     * Finally, you can provide an array of config objects, to convert multiple types of object in
     * a single call:
     *
     * ```javascript
     * createFromObjects(layerName, [
     *   {
     *     gid: 26,
     *     classType: Coin
     *   },
     *   {
     *     id: 9,
     *     classType: BossMonster
     *   },
     *   {
     *     name: 'lava',
     *     classType: LavaTile
     *   },
     *   {
     *     type: 'endzone',
     *     classType: Phaser.GameObjects.Zone
     *   }
     * ]);
     * ```
     *
     * The signature of this method changed significantly in v3.60.0. Prior to this, it did not take config objects.
     *
     * @method Phaser.Tilemaps.Tilemap#createFromObjects
     * @since 3.0.0
     *
     * @param {string} objectLayerName - The name of the Tiled object layer to create the Game Objects from.
     * @param {Phaser.Types.Tilemaps.CreateFromObjectLayerConfig|Phaser.Types.Tilemaps.CreateFromObjectLayerConfig[]} config - A CreateFromObjects configuration object, or an array of them.
     * @param {boolean} [useTileset=true] - True if objects that set gids should also search the underlying tile for properties and data.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array containing the Game Objects that were created. Empty if invalid object layer, or no matching id/gid/name was found.
     */ createFromObjects: function(objectLayerName, config, useTileset) {
                        if (useTileset === undefined) useTileset = true;
                        var results = [];
                        var objectLayer = this.getObjectLayer(objectLayerName);
                        if (!objectLayer) {
                            console.warn('createFromObjects: Invalid objectLayerName given: ' + objectLayerName);
                            return results;
                        }
                        var objectHelper = new ObjectHelper(useTileset ? this.tilesets : undefined);
                        if (!Array.isArray(config)) config = [
                            config
                        ];
                        var objects = objectLayer.objects;
                        for(var c = 0; c < config.length; c++){
                            var singleConfig = config[c];
                            var id = GetFastValue(singleConfig, 'id', null);
                            var gid = GetFastValue(singleConfig, 'gid', null);
                            var name = GetFastValue(singleConfig, 'name', null);
                            var type = GetFastValue(singleConfig, 'type', null);
                            objectHelper.enabled = !GetFastValue(singleConfig, 'ignoreTileset', null);
                            var obj;
                            var toConvert = [];
                            //  Sweep to get all the objects we want to convert in this pass
                            for(var s = 0; s < objects.length; s++){
                                obj = objects[s];
                                if (id === null && gid === null && name === null && type === null || id !== null && obj.id === id || gid !== null && obj.gid === gid || name !== null && obj.name === name || type !== null && objectHelper.getTypeIncludingTile(obj) === type) toConvert.push(obj);
                            }
                            //  Now let's convert them ...
                            var classType = GetFastValue(singleConfig, 'classType', Sprite);
                            var scene = GetFastValue(singleConfig, 'scene', this.scene);
                            var container = GetFastValue(singleConfig, 'container', null);
                            var texture = GetFastValue(singleConfig, 'key', null);
                            var frame = GetFastValue(singleConfig, 'frame', null);
                            for(var i = 0; i < toConvert.length; i++){
                                obj = toConvert[i];
                                var sprite = new classType(scene);
                                sprite.setName(obj.name);
                                sprite.setPosition(obj.x, obj.y);
                                objectHelper.setTextureAndFrame(sprite, texture, frame, obj);
                                if (obj.width) sprite.displayWidth = obj.width;
                                if (obj.height) sprite.displayHeight = obj.height;
                                if (this.orientation === ORIENTATION.ISOMETRIC) {
                                    var isometricRatio = this.tileWidth / this.tileHeight;
                                    var isometricPosition = {
                                        x: sprite.x - sprite.y,
                                        y: (sprite.x + sprite.y) / isometricRatio
                                    };
                                    sprite.x = isometricPosition.x;
                                    sprite.y = isometricPosition.y;
                                }
                                //  Origin is (0, 1) for tile objects or (0, 0) for other objects in Tiled, so find the offset that matches the Sprites origin.
                                //  Do not offset objects with zero dimensions (e.g. points).
                                var offset = {
                                    x: sprite.originX * obj.width,
                                    y: (sprite.originY - (obj.gid ? 1 : 0)) * obj.height
                                };
                                //  If the object is rotated, then the origin offset also needs to be rotated.
                                if (obj.rotation) {
                                    var angle = DegToRad(obj.rotation);
                                    Rotate(offset, angle);
                                    sprite.rotation = angle;
                                }
                                sprite.x += offset.x;
                                sprite.y += offset.y;
                                if (obj.flippedHorizontal !== undefined || obj.flippedVertical !== undefined) sprite.setFlip(obj.flippedHorizontal, obj.flippedVertical);
                                if (!obj.visible) sprite.visible = false;
                                objectHelper.setPropertiesFromTiledObject(sprite, obj);
                                if (container) container.add(sprite);
                                else scene.add.existing(sprite);
                                results.push(sprite);
                            }
                        }
                        return results;
                    },
                    /**
     * Creates a Sprite for every tile matching the given tile indexes in the layer. You can
     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
     * created. Set this value to -1 if you want to just remove the tile after conversion.
     *
     * This is useful if you want to lay down special tiles in a level that are converted to
     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
     *
     * The following features were added in Phaser v3.80:
     *
     * By default, Phaser Sprites have their origin set to 0.5 x 0.5. If you don't specify a new
     * origin in the spriteConfig, then it will adjust the sprite positions by half the tile size,
     * to position them accurately on the map.
     *
     * When the Sprite is created it will copy the following properties from the tile:
     *
     * 'rotation', 'flipX', 'flipY', 'alpha', 'visible' and 'tint'.
     *
     * The spriteConfig also has a special property called `useSpriteSheet`. If this is set to
     * `true` and you have loaded the tileset as a sprite sheet (not an image), then it will
     * set the Sprite key and frame to match the sprite texture and tile index.
     *
     * @method Phaser.Tilemaps.Tilemap#createFromTiles
     * @since 3.0.0
     *
     * @param {(number|array)} indexes - The tile index, or array of indexes, to create Sprites from.
     * @param {?(number|array)} replacements - The tile index, or array of indexes, to change a converted
     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
     * one-to-one mapping with the indexes array.
     * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} [spriteConfig] - The config object to pass into the Sprite creator (i.e. scene.make.sprite).
     * @param {Phaser.Scene} [scene] - The Scene to create the Sprites within.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.GameObjects.Sprite[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ createFromTiles: function(indexes, replacements, spriteConfig, scene, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, layer);
                    },
                    /**
     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
     * specified index. Tiles will be set to collide if the given index is a colliding index.
     * Collision information in the region will be recalculated.
     *
     * If no layer specified, the map's current layer is used.
     * This cannot be applied to StaticTilemapLayers.
     *
     * @method Phaser.Tilemaps.Tilemap#fill
     * @since 3.0.0
     *
     * @param {number} index - The tile index to fill the area with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ fill: function(index, tileX, tileY, width, height, recalculateFaces, layer) {
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, layer);
                        return this;
                    },
                    /**
     * For each object in the given object layer, run the given filter callback function. Any
     * objects that pass the filter test (i.e. where the callback returns true) will be returned in a
     * new array. Similar to Array.prototype.Filter in vanilla JS.
     *
     * @method Phaser.Tilemaps.Tilemap#filterObjects
     * @since 3.0.0
     *
     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
     * @param {TilemapFilterCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     *
     * @return {?Phaser.Types.Tilemaps.TiledObject[]} An array of object that match the search, or null if the objectLayer given was invalid.
     */ filterObjects: function(objectLayer, callback, context) {
                        if (typeof objectLayer === 'string') {
                            var name = objectLayer;
                            objectLayer = this.getObjectLayer(objectLayer);
                            if (!objectLayer) {
                                console.warn('No object layer found with the name: ' + name);
                                return null;
                            }
                        }
                        return objectLayer.objects.filter(callback, context);
                    },
                    /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#filterTiles
     * @since 3.0.0
     *
     * @param {function} callback - The callback. Each tile in the given area will be passed to this
     * callback as the first and only parameter. The callback should return true for tiles that pass the
     * filter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ filterTiles: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                    },
                    /**
     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
     * object. If no match is found, it returns null. The search starts from the top-left tile and
     * continues horizontally until it hits the end of the row, then it drops down to the next column.
     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
     * the top-left.
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#findByIndex
     * @since 3.0.0
     *
     * @param {number} index - The tile index value to search for.
     * @param {number} [skip=0] - The number of times to skip a matching tile before returning.
     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
     */ findByIndex: function(findIndex, skip, reverse, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.FindByIndex(findIndex, skip, reverse, layer);
                    },
                    /**
     * Find the first object in the given object layer that satisfies the provided testing function.
     * I.e. finds the first object for which `callback` returns true. Similar to
     * Array.prototype.find in vanilla JS.
     *
     * @method Phaser.Tilemaps.Tilemap#findObject
     * @since 3.0.0
     *
     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
     * @param {TilemapFindCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     *
     * @return {?Phaser.Types.Tilemaps.TiledObject} An object that matches the search, or null if no object found.
     */ findObject: function(objectLayer, callback, context) {
                        if (typeof objectLayer === 'string') {
                            var name = objectLayer;
                            objectLayer = this.getObjectLayer(objectLayer);
                            if (!objectLayer) {
                                console.warn('No object layer found with the name: ' + name);
                                return null;
                            }
                        }
                        return objectLayer.objects.find(callback, context) || null;
                    },
                    /**
     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
     * true. Similar to Array.prototype.find in vanilla JS.
     * If no layer specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#findTile
     * @since 3.0.0
     *
     * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The Tile layer to run the search on. If not provided will use the current layer.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
     */ findTile: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                    },
                    /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * callback. Similar to Array.prototype.forEach in vanilla JS.
     *
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#forEachTile
     * @since 3.0.0
     *
     * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The Tile layer to run the search on. If not provided will use the current layer.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ forEachTile: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                        return this;
                    },
                    /**
     * Gets the image layer index based on its name.
     *
     * @method Phaser.Tilemaps.Tilemap#getImageIndex
     * @since 3.0.0
     *
     * @param {string} name - The name of the image to get.
     *
     * @return {number} The index of the image in this tilemap, or null if not found.
     */ getImageIndex: function(name) {
                        return this.getIndex(this.images, name);
                    },
                    /**
     * Return a list of all valid imagelayer names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getImageLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid imagelayer names / IDs loaded into this Tilemap.
     */ getImageLayerNames: function() {
                        if (!this.images || !Array.isArray(this.images)) return [];
                        return this.images.map(function(image) {
                            return image.name;
                        });
                    },
                    /**
     * Internally used. Returns the index of the object in one of the Tilemaps arrays whose name
     * property matches the given `name`.
     *
     * @method Phaser.Tilemaps.Tilemap#getIndex
     * @since 3.0.0
     *
     * @param {array} location - The Tilemap array to search.
     * @param {string} name - The name of the array element to get.
     *
     * @return {number} The index of the element in the array, or null if not found.
     */ getIndex: function(location, name) {
                        for(var i = 0; i < location.length; i++){
                            if (location[i].name === name) return i;
                        }
                        return null;
                    },
                    /**
     * Gets the LayerData from `this.layers` that is associated with the given `layer`, or null if the layer is invalid.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayer
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or Tilemap Layer. If not given will default to the maps current layer index.
     *
     * @return {?Phaser.Tilemaps.LayerData} The corresponding `LayerData` within `this.layers`, or null.
     */ getLayer: function(layer) {
                        var index = this.getLayerIndex(layer);
                        return index !== null ? this.layers[index] : null;
                    },
                    /**
     * Gets the ObjectLayer from `this.objects` that has the given `name`, or null if no ObjectLayer is found with that name.
     *
     * @method Phaser.Tilemaps.Tilemap#getObjectLayer
     * @since 3.0.0
     *
     * @param {string} [name] - The name of the object layer from Tiled.
     *
     * @return {?Phaser.Tilemaps.ObjectLayer} The corresponding `ObjectLayer` within `this.objects`, or null.
     */ getObjectLayer: function(name) {
                        var index = this.getIndex(this.objects, name);
                        return index !== null ? this.objects[index] : null;
                    },
                    /**
     * Return a list of all valid objectgroup names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getObjectLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid objectgroup names / IDs loaded into this Tilemap.
     */ getObjectLayerNames: function() {
                        if (!this.objects || !Array.isArray(this.objects)) return [];
                        return this.objects.map(function(object) {
                            return object.name;
                        });
                    },
                    /**
     * Gets the LayerData index of the given `layer` within this.layers, or null if an invalid
     * `layer` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayerIndex
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a Tilemap Layer. If not given will default to the map's current layer index.
     *
     * @return {number} The LayerData index within this.layers.
     */ getLayerIndex: function(layer) {
                        if (layer === undefined) return this.currentLayerIndex;
                        else if (typeof layer === 'string') return this.getLayerIndexByName(layer);
                        else if (typeof layer === 'number' && layer < this.layers.length) return layer;
                        else if (layer instanceof TilemapLayer && layer.tilemap === this) return layer.layerIndex;
                        else return null;
                    },
                    /**
     * Gets the index of the LayerData within this.layers that has the given `name`, or null if an
     * invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayerIndexByName
     * @since 3.0.0
     *
     * @param {string} name - The name of the layer to get.
     *
     * @return {number} The LayerData index within this.layers.
     */ getLayerIndexByName: function(name) {
                        return this.getIndex(this.layers, name);
                    },
                    /**
     * Gets a tile at the given tile coordinates from the given layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
     * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
     * @param {boolean} [nonNull=false] - For empty tiles, return a Tile object with an index of -1 instead of null.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ getTileAt: function(tileX, tileY, nonNull, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.GetTileAt(tileX, tileY, nonNull, layer);
                    },
                    /**
     * Gets a tile at the given world coordinates from the given layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - X position to get the tile from (given in pixels)
     * @param {number} worldY - Y position to get the tile from (given in pixels)
     * @param {boolean} [nonNull=false] - For empty tiles, return a Tile object with an index of -1 instead of null.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ getTileAtWorldXY: function(worldX, worldY, nonNull, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, layer);
                    },
                    /**
     * Return a list of all valid tilelayer names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid tilelayer names / IDs loaded into this Tilemap.
     */ getTileLayerNames: function() {
                        if (!this.layers || !Array.isArray(this.layers)) return [];
                        return this.layers.map(function(layer) {
                            return layer.name;
                        });
                    },
                    /**
     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithin
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithin: function(tileX, tileY, width, height, filteringOptions, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                    },
                    /**
     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
     * Line, Rectangle or Triangle. The shape should be in world coordinates.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithinShape
     * @since 3.0.0
     *
     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithinShape: function(shape, filteringOptions, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, layer);
                    },
                    /**
     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithinWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The world x coordinate for the top-left of the area.
     * @param {number} worldY - The world y coordinate for the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithinWorldXY: function(worldX, worldY, width, height, filteringOptions, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, layer);
                    },
                    /**
     * Gets the Tileset that has the given `name`, or null if an invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileset
     * @since 3.14.0
     *
     * @param {string} name - The name of the Tileset to get.
     *
     * @return {?Phaser.Tilemaps.Tileset} The Tileset, or `null` if no matching named tileset was found.
     */ getTileset: function(name) {
                        var index = this.getIndex(this.tilesets, name);
                        return index !== null ? this.tilesets[index] : null;
                    },
                    /**
     * Gets the index of the Tileset within this.tilesets that has the given `name`, or null if an
     * invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesetIndex
     * @since 3.0.0
     *
     * @param {string} name - The name of the Tileset to get.
     *
     * @return {number} The Tileset index within this.tilesets.
     */ getTilesetIndex: function(name) {
                        return this.getIndex(this.tilesets, name);
                    },
                    /**
     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#hasTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
     */ hasTileAt: function(tileX, tileY, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.HasTileAt(tileX, tileY, layer);
                    },
                    /**
     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#hasTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
     */ hasTileAtWorldXY: function(worldX, worldY, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, layer);
                    },
                    /**
     * The LayerData object that is currently selected in the map. You can set this property using
     * any type supported by setLayer.
     *
     * @name Phaser.Tilemaps.Tilemap#layer
     * @type {Phaser.Tilemaps.LayerData}
     * @since 3.0.0
     */ layer: {
                        get: function() {
                            return this.layers[this.currentLayerIndex];
                        },
                        set: function(layer) {
                            this.setLayer(layer);
                        }
                    },
                    /**
     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
     * location. If you pass in an index, only the index at the specified location will be changed.
     * Collision information will be recalculated at the specified location.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTileAt
     * @since 3.0.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid or the coordinates were out of bounds.
     */ putTileAt: function(tile, tileX, tileY, recalculateFaces, layer) {
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, layer);
                    },
                    /**
     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
     * specified location. If you pass in an index, only the index at the specified location will be
     * changed. Collision information will be recalculated at the specified location.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTileAtWorldXY
     * @since 3.0.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ putTileAtWorldXY: function(tile, worldX, worldY, recalculateFaces, camera, layer) {
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, layer);
                    },
                    /**
     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
     * all attributes will be copied over to the specified location. If you pass in an index, only the
     * index at the specified location will be changed. Collision information will be recalculated
     * within the region tiles were changed.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTilesAt
     * @since 3.0.0
     *
     * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ putTilesAt: function(tilesArray, tileX, tileY, recalculateFaces, layer) {
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, layer);
                        return this;
                    },
                    /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
     * indexes. This method only modifies tile indexes and does not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#randomize
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {number[]} [indexes] - An array of indexes to randomly draw from during randomization.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ randomize: function(tileX, tileY, width, height, indexes, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.Randomize(tileX, tileY, width, height, indexes, layer);
                        return this;
                    },
                    /**
     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
     * faces are used internally for optimizing collisions against tiles. This method is mostly used
     * internally to optimize recalculating faces when only one tile has been changed.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#calculateFacesAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ calculateFacesAt: function(tileX, tileY, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.CalculateFacesAt(tileX, tileY, layer);
                        return this;
                    },
                    /**
     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
     * is mostly used internally.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#calculateFacesWithin
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ calculateFacesWithin: function(tileX, tileY, width, height, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, layer);
                        return this;
                    },
                    /**
     * Removes the given TilemapLayer from this Tilemap without destroying it.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeLayer
     * @since 3.17.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to be removed.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ removeLayer: function(layer) {
                        var index = this.getLayerIndex(layer);
                        if (index !== null) {
                            SpliceOne(this.layers, index);
                            for(var i = index; i < this.layers.length; i++)if (this.layers[i].tilemapLayer) this.layers[i].tilemapLayer.layerIndex--;
                            if (this.currentLayerIndex === index) this.currentLayerIndex = 0;
                            return this;
                        } else return null;
                    },
                    /**
     * Destroys the given TilemapLayer and removes it from this Tilemap.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#destroyLayer
     * @since 3.17.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to be destroyed.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ destroyLayer: function(layer) {
                        var index = this.getLayerIndex(layer);
                        if (index !== null) {
                            layer = this.layers[index];
                            layer.tilemapLayer.destroy();
                            SpliceOne(this.layers, index);
                            if (this.currentLayerIndex === index) this.currentLayerIndex = 0;
                            return this;
                        } else return null;
                    },
                    /**
     * Removes all Tilemap Layers from this Tilemap and calls `destroy` on each of them.
     *
     * @method Phaser.Tilemaps.Tilemap#removeAllLayers
     * @since 3.0.0
     *
     * @return {this} This Tilemap object.
     */ removeAllLayers: function() {
                        var layers = this.layers;
                        for(var i = 0; i < layers.length; i++)if (layers[i].tilemapLayer) layers[i].tilemapLayer.destroy(false);
                        layers.length = 0;
                        this.currentLayerIndex = 0;
                        return this;
                    },
                    /**
     * Removes the given Tile, or an array of Tiles, from the layer to which they belong,
     * and optionally recalculates the collision information.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTile
     * @since 3.17.0
     *
     * @param {(Phaser.Tilemaps.Tile|Phaser.Tilemaps.Tile[])} tiles - The Tile to remove, or an array of Tiles.
     * @param {number} [replaceIndex=-1] - After removing the Tile, insert a brand new Tile into its location with the given index. Leave as -1 to just remove the tile.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile[]} Returns an array of Tiles that were removed.
     */ removeTile: function(tiles, replaceIndex, recalculateFaces) {
                        if (replaceIndex === undefined) replaceIndex = -1;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        var removed = [];
                        if (!Array.isArray(tiles)) tiles = [
                            tiles
                        ];
                        for(var i = 0; i < tiles.length; i++){
                            var tile = tiles[i];
                            removed.push(this.removeTileAt(tile.x, tile.y, true, recalculateFaces, tile.tilemapLayer));
                            if (replaceIndex > -1) this.putTileAt(replaceIndex, tile.x, tile.y, recalculateFaces, tile.tilemapLayer);
                        }
                        return removed;
                    },
                    /**
     * Removes the tile at the given tile coordinates in the specified layer and updates the layers collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [replaceWithNull] - If `true` (the default), this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces] - If `true` (the default), the faces data will be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns the Tile that was removed, or null if the layer given was invalid.
     */ removeTileAt: function(tileX, tileY, replaceWithNull, recalculateFaces, layer) {
                        if (replaceWithNull === undefined) replaceWithNull = true;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, layer);
                    },
                    /**
     * Removes the tile at the given world coordinates in the specified layer and updates the layers collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [replaceWithNull] - If `true` (the default), this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces] - If `true` (the default), the faces data will be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ removeTileAtWorldXY: function(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer) {
                        if (replaceWithNull === undefined) replaceWithNull = true;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer);
                    },
                    /**
     * Draws a debug representation of the layer to the given Graphics object. This is helpful when you want to
     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
     * wherever you want on the screen.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * **Note:** This method currently only works with orthogonal tilemap layers.
     *
     * @method Phaser.Tilemaps.Tilemap#renderDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ renderDebug: function(graphics, styleConfig, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        if (this.orientation === ORIENTATION.ORTHOGONAL) TilemapComponents.RenderDebug(graphics, styleConfig, layer);
                        return this;
                    },
                    /**
     * Draws a debug representation of all layers within this Tilemap to the given Graphics object.
     *
     * This is helpful when you want to get a quick idea of which of your tiles are colliding and which
     * have interesting faces. The tiles are drawn starting at (0, 0) in the Graphics, allowing you to
     * place the debug representation wherever you want on the screen.
     *
     * @method Phaser.Tilemaps.Tilemap#renderDebugFull
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     *
     * @return {this} This Tilemap instance.
     */ renderDebugFull: function(graphics, styleConfig) {
                        var layers = this.layers;
                        for(var i = 0; i < layers.length; i++)TilemapComponents.RenderDebug(graphics, styleConfig, layers[i]);
                        return this;
                    },
                    /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
     * not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#replaceByIndex
     * @since 3.0.0
     *
     * @param {number} findIndex - The index of the tile to search for.
     * @param {number} newIndex - The index of the tile to replace it with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ replaceByIndex: function(findIndex, newIndex, tileX, tileY, width, height, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, layer);
                        return this;
                    },
                    /**
     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
     * collision will be enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollision
     * @since 3.0.0
     *
     * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollision: function(indexes, collides, recalculateFaces, layer, updateLayer) {
                        if (collides === undefined) collides = true;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        if (updateLayer === undefined) updateLayer = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SetCollision(indexes, collides, recalculateFaces, layer, updateLayer);
                        return this;
                    },
                    /**
     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
     * enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionBetween
     * @since 3.0.0
     *
     * @param {number} start - The first index of the tile to be set for collision.
     * @param {number} stop - The last index of the tile to be set for collision.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionBetween: function(start, stop, collides, recalculateFaces, layer) {
                        if (collides === undefined) collides = true;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, layer);
                        return this;
                    },
                    /**
     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
     * that matches the given properties object, its collision flag will be set. The `collides`
     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
     * "types" property that matches any of those values, its collision flag will be updated.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionByProperty
     * @since 3.0.0
     *
     * @param {object} properties - An object with tile properties and corresponding values that should be checked.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionByProperty: function(properties, collides, recalculateFaces, layer) {
                        if (collides === undefined) collides = true;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, layer);
                        return this;
                    },
                    /**
     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
     * the given array. The `collides` parameter controls if collision will be enabled (true) or
     * disabled (false). Tile indexes not currently in the layer are not affected.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionByExclusion
     * @since 3.0.0
     *
     * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionByExclusion: function(indexes, collides, recalculateFaces, layer) {
                        if (collides === undefined) collides = true;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, layer);
                        return this;
                    },
                    /**
     * Sets collision on the tiles within a layer by checking each tiles collision group data
     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
     * a tiles collision group, the tiles colliding information will be set. The `collides` parameter
     * controls if collision will be enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionFromCollisionGroup
     * @since 3.0.0
     *
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionFromCollisionGroup: function(collides, recalculateFaces, layer) {
                        if (collides === undefined) collides = true;
                        if (recalculateFaces === undefined) recalculateFaces = true;
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, layer);
                        return this;
                    },
                    /**
     * Sets a global collision callback for the given tile index within the layer. This will affect all
     * tiles on this layer that have the same index. If a callback is already set for the tile index it
     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
     * at a specific location on the map then see `setTileLocationCallback`.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setTileIndexCallback
     * @since 3.0.0
     *
     * @param {(number|number[])} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for. All values should be integers.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} callbackContext - The context under which the callback is called.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setTileIndexCallback: function(indexes, callback, callbackContext, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, layer);
                        return this;
                    },
                    /**
     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
     * remove it.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setTileLocationCallback
     * @since 3.0.0
     *
     * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} width - How many tiles wide from the `tileX` index the area will be.
     * @param {number} height - How many tiles tall from the `tileY` index the area will be.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} [callbackContext] - The context under which the callback is called.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setTileLocationCallback: function(tileX, tileY, width, height, callback, callbackContext, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, layer);
                        return this;
                    },
                    /**
     * Sets the current layer to the LayerData associated with `layer`.
     *
     * @method Phaser.Tilemaps.Tilemap#setLayer
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a TilemapLayer. If not given will default to the maps current layer index.
     *
     * @return {this} This Tilemap object.
     */ setLayer: function(layer) {
                        var index = this.getLayerIndex(layer);
                        if (index !== null) this.currentLayerIndex = index;
                        return this;
                    },
                    /**
     * Sets the base tile size for the map. Note: this does not necessarily match the tileWidth and
     * tileHeight for all layers. This also updates the base size on all tiles across all layers.
     *
     * @method Phaser.Tilemaps.Tilemap#setBaseTileSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tiles the map uses for calculations.
     * @param {number} tileHeight - The height of the tiles the map uses for calculations.
     *
     * @return {this} This Tilemap object.
     */ setBaseTileSize: function(tileWidth, tileHeight) {
                        this.tileWidth = tileWidth;
                        this.tileHeight = tileHeight;
                        this.widthInPixels = this.width * tileWidth;
                        this.heightInPixels = this.height * tileHeight;
                        //  Update the base tile size on all layers & tiles
                        for(var i = 0; i < this.layers.length; i++){
                            this.layers[i].baseTileWidth = tileWidth;
                            this.layers[i].baseTileHeight = tileHeight;
                            var mapData = this.layers[i].data;
                            var mapWidth = this.layers[i].width;
                            var mapHeight = this.layers[i].height;
                            for(var row = 0; row < mapHeight; row++)for(var col = 0; col < mapWidth; col++){
                                var tile = mapData[row][col];
                                if (tile !== null) tile.setSize(undefined, undefined, tileWidth, tileHeight);
                            }
                        }
                        return this;
                    },
                    /**
     * Sets the tile size for a specific `layer`. Note: this does not necessarily match the maps
     * tileWidth and tileHeight for all layers. This will set the tile size for the layer and any
     * tiles the layer has.
     *
     * @method Phaser.Tilemaps.Tilemap#setLayerTileSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tiles (in pixels) in the layer.
     * @param {number} tileHeight - The height of the tiles (in pixels) in the layer.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a TilemapLayer. If not given will default to the maps current layer index.
     *
     * @return {this} This Tilemap object.
     */ setLayerTileSize: function(tileWidth, tileHeight, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return this;
                        layer.tileWidth = tileWidth;
                        layer.tileHeight = tileHeight;
                        var mapData = layer.data;
                        var mapWidth = layer.width;
                        var mapHeight = layer.height;
                        for(var row = 0; row < mapHeight; row++)for(var col = 0; col < mapWidth; col++){
                            var tile = mapData[row][col];
                            if (tile !== null) tile.setSize(tileWidth, tileHeight);
                        }
                        return this;
                    },
                    /**
     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
     * appear to have changed! This method only modifies tile indexes and does not change collision
     * information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#shuffle
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ shuffle: function(tileX, tileY, width, height, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.Shuffle(tileX, tileY, width, height, layer);
                        return this;
                    },
                    /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
     * information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#swapByIndex
     * @since 3.0.0
     *
     * @param {number} tileA - First tile index.
     * @param {number} tileB - Second tile index.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ swapByIndex: function(indexA, indexB, tileX, tileY, width, height, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, layer);
                        return this;
                    },
                    /**
     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldX
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ tileToWorldX: function(tileX, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return this._convert.TileToWorldX(tileX, camera, layer);
                    },
                    /**
     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldY
     * @since 3.0.0
     *
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ tileToWorldY: function(tileY, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return this._convert.TileToWorldY(tileY, camera, layer);
                    },
                    /**
     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldXY
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Math.Vector2} Returns a Vector2, or null if the layer given was invalid.
     */ tileToWorldXY: function(tileX, tileY, vec2, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return this._convert.TileToWorldXY(tileX, tileY, vec2, camera, layer);
                    },
                    /**
     * Returns an array of Vector2s where each entry corresponds to the corner of the requested tile.
     *
     * The `tileX` and `tileY` parameters are in tile coordinates, not world coordinates.
     *
     * The corner coordinates are in world space, having factored in TilemapLayer scale, position
     * and the camera, if given.
     *
     * The size of the array will vary based on the orientation of the map. For example an
     * orthographic map will return an array of 4 vectors, where-as a hexagonal map will,
     * of course, return an array of 6 corner vectors.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileCorners
     * @since 3.60.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Math.Vector2[]} Returns an array of Vector2s, or null if the layer given was invalid.
     */ getTileCorners: function(tileX, tileY, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return this._convert.GetTileCorners(tileX, tileY, camera, layer);
                    },
                    /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. New indexes are drawn from the given
     * weightedIndexes array. An example weighted array:
     *
     * [
     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
     * ]
     *
     * The probability of any index being picked is (the indexs weight) / (sum of all weights). This
     * method only modifies tile indexes and does not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#weightedRandomize
     * @since 3.0.0
     *
     * @param {object[]} weightedIndexes - An array of objects to randomly draw from during randomization. They should be in the form: { index: 0, weight: 4 } or { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ weightedRandomize: function(weightedIndexes, tileX, tileY, width, height, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, layer);
                        return this;
                    },
                    /**
     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * You cannot call this method for Isometric or Hexagonal tilemaps as they require
     * both `worldX` and `worldY` values to determine the correct tile, instead you
     * should use the `worldToTileXY` method.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileX
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ worldToTileX: function(worldX, snapToFloor, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return this._convert.WorldToTileX(worldX, snapToFloor, camera, layer);
                    },
                    /**
     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * You cannot call this method for Isometric or Hexagonal tilemaps as they require
     * both `worldX` and `worldY` values to determine the correct tile, instead you
     * should use the `worldToTileXY` method.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileY
     * @since 3.0.0
     *
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ worldToTileY: function(worldY, snapToFloor, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return this._convert.WorldToTileY(worldY, snapToFloor, camera, layer);
                    },
                    /**
     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Math.Vector2} Returns a vec2, or null if the layer given was invalid.
     */ worldToTileXY: function(worldX, worldY, snapToFloor, vec2, camera, layer) {
                        layer = this.getLayer(layer);
                        if (layer === null) return null;
                        return this._convert.WorldToTileXY(worldX, worldY, snapToFloor, vec2, camera, layer);
                    },
                    /**
     * Removes all layer data from this Tilemap and nulls the scene reference. This will destroy any
     * TilemapLayers that have been created.
     *
     * @method Phaser.Tilemaps.Tilemap#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.removeAllLayers();
                        this.tiles.length = 0;
                        this.tilesets.length = 0;
                        this.objects.length = 0;
                        this.scene = null;
                    }
                });
                module1.exports = Tilemap;
            /***/ },
            /***/ 45939: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(44603);
                var ParseToTilemap = __webpack_require__(31989);
                /**
 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tilemap
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.TilemapConfig} [config] - The config options for the Tilemap.
 *
 * @return {Phaser.Tilemaps.Tilemap}
 */ GameObjectCreator.register('tilemap', function(config) {
                    // Defaults are applied in ParseToTilemap
                    var c = config !== undefined ? config : {};
                    return ParseToTilemap(this.scene, c.key, c.tileWidth, c.tileHeight, c.width, c.height, c.data, c.insertNull);
                });
            /***/ },
            /***/ 46029: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(39429);
                var ParseToTilemap = __webpack_require__(31989);
                /**
 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tilemap
 * @since 3.0.0
 *
 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
 * @param {number} [tileWidth=32] - The width of a tile in pixels. Pass in `null` to leave as the
 * default.
 * @param {number} [tileHeight=32] - The height of a tile in pixels. Pass in `null` to leave as the
 * default.
 * @param {number} [width=10] - The width of the map in tiles. Pass in `null` to leave as the
 * default.
 * @param {number} [height=10] - The height of the map in tiles. Pass in `null` to leave as the
 * default.
 * @param {number[][]} [data] - Instead of loading from the cache, you can also load directly from
 * a 2D array of tile indexes. Pass in `null` for no data.
 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.Tilemap}
 */ GameObjectFactory.register('tilemap', function(key, tileWidth, tileHeight, width, height, data, insertNull) {
                    // Allow users to specify null to indicate that they want the default value, since null is
                    // shorter & more legible than undefined. Convert null to undefined to allow ParseToTilemap
                    // defaults to take effect.
                    if (key === null) key = undefined;
                    if (tileWidth === null) tileWidth = undefined;
                    if (tileHeight === null) tileHeight = undefined;
                    if (width === null) width = undefined;
                    if (height === null) height = undefined;
                    return ParseToTilemap(this.scene, key, tileWidth, tileHeight, width, height, data, insertNull);
                });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /***/ },
            /***/ 20442: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CollisionComponent = __webpack_require__(78389);
                var Components = __webpack_require__(31401);
                var GameObject = __webpack_require__(95643);
                var TilemapComponents = __webpack_require__(81086);
                var TilemapLayerRender = __webpack_require__(19218);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Tilemap Layer is a Game Object that renders LayerData from a Tilemap when used in combination
 * with one, or more, Tilesets.
 * 
 * Do not add TilemapLayers to Containers, they are stand-alone display objects.
 *
 * @class TilemapLayer
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.PostPipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.Physics.Arcade.Components.Collision
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {Phaser.Tilemaps.Tilemap} tilemap - The Tilemap this layer is a part of.
 * @param {number} layerIndex - The index of the LayerData associated with this layer.
 * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
 * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
 * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
 */ var TilemapLayer = new Class({
                    Extends: GameObject,
                    Mixins: [
                        Components.Alpha,
                        Components.BlendMode,
                        Components.ComputedSize,
                        Components.Depth,
                        Components.Flip,
                        Components.GetBounds,
                        Components.Mask,
                        Components.Origin,
                        Components.Pipeline,
                        Components.PostPipeline,
                        Components.Transform,
                        Components.Visible,
                        Components.ScrollFactor,
                        CollisionComponent,
                        TilemapLayerRender
                    ],
                    initialize: function TilemapLayer(scene, tilemap, layerIndex, tileset, x, y) {
                        GameObject.call(this, scene, 'TilemapLayer');
                        /**
         * Used internally by physics system to perform fast type checks.
         *
         * @name Phaser.Tilemaps.TilemapLayer#isTilemap
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isTilemap = true;
                        /**
         * The Tilemap that this layer is a part of.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilemap
         * @type {Phaser.Tilemaps.Tilemap}
         * @since 3.50.0
         */ this.tilemap = tilemap;
                        /**
         * The index of the LayerData associated with this layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#layerIndex
         * @type {number}
         * @since 3.50.0
         */ this.layerIndex = layerIndex;
                        /**
         * The LayerData associated with this layer. LayerData can only be associated with one
         * tilemap layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#layer
         * @type {Phaser.Tilemaps.LayerData}
         * @since 3.50.0
         */ this.layer = tilemap.layers[layerIndex];
                        // Link the LayerData with this static tilemap layer
                        this.layer.tilemapLayer = this;
                        /**
         * An array of `Tileset` objects associated with this layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tileset
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.50.0
         */ this.tileset = [];
                        /**
         * The total number of tiles drawn by the renderer in the last frame.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilesDrawn
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.tilesDrawn = 0;
                        /**
         * The total number of tiles in this layer. Updated every frame.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilesTotal
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.tilesTotal = this.layer.width * this.layer.height;
                        /**
         * Used internally during rendering. This holds the tiles that are visible within the Camera.
         *
         * @name Phaser.Tilemaps.TilemapLayer#culledTiles
         * @type {Phaser.Tilemaps.Tile[]}
         * @since 3.50.0
         */ this.culledTiles = [];
                        /**
         * You can control if the camera should cull tiles on this layer before rendering them or not.
         *
         * By default the camera will try to cull the tiles in this layer, to avoid over-drawing to the renderer.
         *
         * However, there are some instances when you may wish to disable this, and toggling this flag allows
         * you to do so. Also see `setSkipCull` for a chainable method that does the same thing.
         *
         * @name Phaser.Tilemaps.TilemapLayer#skipCull
         * @type {boolean}
         * @since 3.50.0
         */ this.skipCull = false;
                        /**
         * The amount of extra tiles to add into the cull rectangle when calculating its horizontal size.
         *
         * See the method `setCullPadding` for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullPaddingX
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.cullPaddingX = 1;
                        /**
         * The amount of extra tiles to add into the cull rectangle when calculating its vertical size.
         *
         * See the method `setCullPadding` for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullPaddingY
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.cullPaddingY = 1;
                        /**
         * The callback that is invoked when the tiles are culled.
         *
         * It will call a different function based on the map orientation:
         *
         * Orthogonal (the default) is `TilemapComponents.CullTiles`
         * Isometric is `TilemapComponents.IsometricCullTiles`
         * Hexagonal is `TilemapComponents.HexagonalCullTiles`
         * Staggered is `TilemapComponents.StaggeredCullTiles`
         *
         * However, you can override this to call any function you like.
         *
         * It will be sent 4 arguments:
         *
         * 1. The Phaser.Tilemaps.LayerData object for this Layer
         * 2. The Camera that is culling the layer. You can check its `dirty` property to see if it has changed since the last cull.
         * 3. A reference to the `culledTiles` array, which should be used to store the tiles you want rendered.
         * 4. The Render Order constant.
         *
         * See the `TilemapComponents.CullTiles` source code for details on implementing your own culling system.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullCallback
         * @type {function}
         * @since 3.50.0
         */ this.cullCallback = TilemapComponents.GetCullTilesFunction(this.layer.orientation);
                        /**
         * The rendering (draw) order of the tiles in this layer.
         *
         * The default is 0 which is 'right-down', meaning it will draw the tiles starting from the top-left,
         * drawing to the right and then moving down to the next row.
         *
         * The draw orders are:
         *
         * 0 = right-down
         * 1 = left-down
         * 2 = right-up
         * 3 = left-up
         *
         * This can be changed via the `setRenderOrder` method.
         *
         * @name Phaser.Tilemaps.TilemapLayer#_renderOrder
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ this._renderOrder = 0;
                        /**
         * An array holding the mapping between the tile indexes and the tileset they belong to.
         *
         * @name Phaser.Tilemaps.TilemapLayer#gidMap
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.50.0
         */ this.gidMap = [];
                        /**
         * A temporary Vector2 used in the tile coordinate methods.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tempVec
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.60.0
         */ this.tempVec = new Vector2();
                        /**
         * The Tilemap Layer Collision Category.
         *
         * This is exclusively used by the Arcade Physics system.
         *
         * This can be set to any valid collision bitfield value.
         *
         * See the `setCollisionCategory` method for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#collisionCategory
         * @type {number}
         * @since 3.70.0
         */ this.collisionCategory = 0x0001;
                        /**
         * The Tilemap Layer Collision Mask.
         *
         * This is exclusively used by the Arcade Physics system.
         *
         * See the `setCollidesWith` method for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#collisionMask
         * @type {number}
         * @since 3.70.0
         */ this.collisionMask = 1;
                        /**
         * The horizontal origin of this Tilemap Layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#originX
         * @type {number}
         * @default 0
         * @readOnly
         * @since 3.0.0
         */ /**
         * The vertical origin of this Tilemap Layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#originY
         * @type {number}
         * @default 0
         * @readOnly
         * @since 3.0.0
         */ /**
         * The horizontal display origin of this Tilemap Layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#displayOriginX
         * @type {number}
         * @default 0
         * @readOnly
         * @since 3.0.0
         */ /**
         * The vertical display origin of this Tilemap Layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#displayOriginY
         * @type {number}
         * @default 0
         * @readOnly
         * @since 3.0.0
         */ this.setTilesets(tileset);
                        this.setAlpha(this.layer.alpha);
                        this.setPosition(x, y);
                        this.setOrigin(0, 0);
                        this.setSize(tilemap.tileWidth * this.layer.width, tilemap.tileHeight * this.layer.height);
                        this.initPipeline();
                        this.initPostPipeline(false);
                    },
                    /**
     * Populates the internal `tileset` array with the Tileset references this Layer requires for rendering.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTilesets
     * @private
     * @since 3.50.0
     *
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     */ setTilesets: function(tilesets) {
                        var gidMap = [];
                        var setList = [];
                        var map = this.tilemap;
                        if (!Array.isArray(tilesets)) tilesets = [
                            tilesets
                        ];
                        for(var i = 0; i < tilesets.length; i++){
                            var tileset = tilesets[i];
                            if (typeof tileset === 'string') tileset = map.getTileset(tileset);
                            if (tileset) {
                                setList.push(tileset);
                                var s = tileset.firstgid;
                                for(var t = 0; t < tileset.total; t++)gidMap[s + t] = tileset;
                            }
                        }
                        this.gidMap = gidMap;
                        this.tileset = setList;
                    },
                    /**
     * Sets the rendering (draw) order of the tiles in this layer.
     *
     * The default is 'right-down', meaning it will order the tiles starting from the top-left,
     * drawing to the right and then moving down to the next row.
     *
     * The draw orders are:
     *
     * 0 = right-down
     * 1 = left-down
     * 2 = right-up
     * 3 = left-up
     *
     * Setting the render order does not change the tiles or how they are stored in the layer,
     * it purely impacts the order in which they are rendered.
     *
     * You can provide either an integer (0 to 3), or the string version of the order.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setRenderOrder
     * @since 3.50.0
     *
     * @param {(number|string)} renderOrder - The render (draw) order value. Either an integer between 0 and 3, or a string: 'right-down', 'left-down', 'right-up' or 'left-up'.
     *
     * @return {this} This Tilemap Layer object.
     */ setRenderOrder: function(renderOrder) {
                        var orders = [
                            'right-down',
                            'left-down',
                            'right-up',
                            'left-up'
                        ];
                        if (typeof renderOrder === 'string') renderOrder = orders.indexOf(renderOrder);
                        if (renderOrder >= 0 && renderOrder < 4) this._renderOrder = renderOrder;
                        return this;
                    },
                    /**
     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
     * faces are used internally for optimizing collisions against tiles. This method is mostly used
     * internally to optimize recalculating faces when only one tile has been changed.
     *
     * @method Phaser.Tilemaps.TilemapLayer#calculateFacesAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate.
     * @param {number} tileY - The y coordinate.
     *
     * @return {this} This Tilemap Layer object.
     */ calculateFacesAt: function(tileX, tileY) {
                        TilemapComponents.CalculateFacesAt(tileX, tileY, this.layer);
                        return this;
                    },
                    /**
     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
     * is mostly used internally.
     *
     * @method Phaser.Tilemaps.TilemapLayer#calculateFacesWithin
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ calculateFacesWithin: function(tileX, tileY, width, height) {
                        TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, this.layer);
                        return this;
                    },
                    /**
     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
     * created. This is useful if you want to lay down special tiles in a level that are converted to
     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
     *
     * @method Phaser.Tilemaps.TilemapLayer#createFromTiles
     * @since 3.50.0
     *
     * @param {(number|array)} indexes - The tile index, or array of indexes, to create Sprites from.
     * @param {?(number|array)} replacements - The tile index, or array of indexes, to change a converted
     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
     * one-to-one mapping with the indexes array.
     * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} [spriteConfig] - The config object to pass into the Sprite creator (i.e.
     * scene.make.sprite).
     * @param {Phaser.Scene} [scene] - The Scene to create the Sprites within.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when determining the world XY
     *
     * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
     */ createFromTiles: function(indexes, replacements, spriteConfig, scene, camera) {
                        return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, this.layer);
                    },
                    /**
     * Returns the tiles in the given layer that are within the cameras viewport.
     * This is used internally during rendering.
     *
     * @method Phaser.Tilemaps.TilemapLayer#cull
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects to render.
     */ cull: function(camera) {
                        return this.cullCallback(this.layer, camera, this.culledTiles, this._renderOrder);
                    },
                    /**
     * Copies the tiles in the source rectangular area to a new destination (all specified in tile
     * coordinates) within the layer. This copies all tile properties & recalculates collision
     * information in the destination region.
     *
     * @method Phaser.Tilemaps.TilemapLayer#copy
     * @since 3.50.0
     *
     * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} width - The width of the area to copy, in tiles, not pixels.
     * @param {number} height - The height of the area to copy, in tiles, not pixels.
     * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
     * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ copy: function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces) {
                        TilemapComponents.Copy(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, this.layer);
                        return this;
                    },
                    /**
     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
     * specified index. Tiles will be set to collide if the given index is a colliding index.
     * Collision information in the region will be recalculated.
     *
     * @method Phaser.Tilemaps.TilemapLayer#fill
     * @since 3.50.0
     *
     * @param {number} index - The tile index to fill the area with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ fill: function(index, tileX, tileY, width, height, recalculateFaces) {
                        TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, this.layer);
                        return this;
                    },
                    /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#filterTiles
     * @since 3.50.0
     *
     * @param {function} callback - The callback. Each tile in the given area will be passed to this
     * callback as the first and only parameter. The callback should return true for tiles that pass the
     * filter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
     */ filterTiles: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                        return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                    },
                    /**
     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
     * object. If no match is found, it returns null. The search starts from the top-left tile and
     * continues horizontally until it hits the end of the row, then it drops down to the next column.
     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
     * the top-left.
     *
     * @method Phaser.Tilemaps.TilemapLayer#findByIndex
     * @since 3.50.0
     *
     * @param {number} index - The tile index value to search for.
     * @param {number} [skip=0] - The number of times to skip a matching tile before returning.
     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
     *
     * @return {Phaser.Tilemaps.Tile} The first matching Tile object.
     */ findByIndex: function(findIndex, skip, reverse) {
                        return TilemapComponents.FindByIndex(findIndex, skip, reverse, this.layer);
                    },
                    /**
     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
     * true. Similar to Array.prototype.find in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#findTile
     * @since 3.50.0
     *
     * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {?Phaser.Tilemaps.Tile} The first Tile found at the given location.
     */ findTile: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                        return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                    },
                    /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * callback. Similar to Array.prototype.forEach in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#forEachTile
     * @since 3.50.0
     *
     * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context, or scope, under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {this} This Tilemap Layer object.
     */ forEachTile: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                        TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                        return this;
                    },
                    /**
     * Sets an additive tint on each Tile within the given area.
     *
     * The tint works by taking the pixel color values from the tileset texture, and then
     * multiplying it by the color value of the tint.
     *
     * If no area values are given then all tiles will be tinted to the given color.
     *
     * To remove a tint call this method with either no parameters, or by passing white `0xffffff` as the tint color.
     *
     * If a tile already has a tint set then calling this method will override that.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTint
     * @webglOnly
     * @since 3.60.0
     *
     * @param {number} [tint=0xffffff] - The tint color being applied to each tile within the region. Given as a hex value, i.e. `0xff0000` for red. Set to white (`0xffffff`) to reset the tint.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {this} This Tilemap Layer object.
     */ setTint: function(tint, tileX, tileY, width, height, filteringOptions) {
                        if (tint === undefined) tint = 0xffffff;
                        var tintTile = function(tile) {
                            tile.tint = tint;
                            tile.tintFill = false;
                        };
                        return this.forEachTile(tintTile, this, tileX, tileY, width, height, filteringOptions);
                    },
                    /**
     * Sets a fill-based tint on each Tile within the given area.
     *
     * Unlike an additive tint, a fill-tint literally replaces the pixel colors from the texture
     * with those in the tint.
     *
     * If no area values are given then all tiles will be tinted to the given color.
     *
     * To remove a tint call this method with either no parameters, or by passing white `0xffffff` as the tint color.
     *
     * If a tile already has a tint set then calling this method will override that.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTintFill
     * @webglOnly
     * @since 3.70.0
     *
     * @param {number} [tint=0xffffff] - The tint color being applied to each tile within the region. Given as a hex value, i.e. `0xff0000` for red. Set to white (`0xffffff`) to reset the tint.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {this} This Tilemap Layer object.
     */ setTintFill: function(tint, tileX, tileY, width, height, filteringOptions) {
                        if (tint === undefined) tint = 0xffffff;
                        var tintTile = function(tile) {
                            tile.tint = tint;
                            tile.tintFill = true;
                        };
                        return this.forEachTile(tintTile, this, tileX, tileY, width, height, filteringOptions);
                    },
                    /**
     * Gets a tile at the given tile coordinates from the given layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
     * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
     * @param {boolean} [nonNull=false] - For empty tiles, return a Tile object with an index of -1 instead of null.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile at the given coordinates or null if no tile was found or the coordinates were invalid.
     */ getTileAt: function(tileX, tileY, nonNull) {
                        return TilemapComponents.GetTileAt(tileX, tileY, nonNull, this.layer);
                    },
                    /**
     * Gets a tile at the given world coordinates from the given layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - X position to get the tile from (given in pixels)
     * @param {number} worldY - Y position to get the tile from (given in pixels)
     * @param {boolean} [nonNull=false] - For empty tiles, return a Tile object with an index of -1 instead of null.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
     */ getTileAtWorldXY: function(worldX, worldY, nonNull, camera) {
                        return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, this.layer);
                    },
                    /**
     * Gets a tile at the given world coordinates from the given isometric layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getIsoTileAtWorldXY
     * @since 3.60.0
     *
     * @param {number} worldX - X position to get the tile from (given in pixels)
     * @param {number} worldY - Y position to get the tile from (given in pixels)
     * @param {boolean} [originTop=true] - Which is the active face of the isometric tile? The top (default, true), or the base? (false)
     * @param {boolean} [nonNull=false] - For empty tiles, return a Tile object with an index of -1 instead of null.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
     */ getIsoTileAtWorldXY: function(worldX, worldY, originTop, nonNull, camera) {
                        if (originTop === undefined) originTop = true;
                        var point = this.tempVec;
                        TilemapComponents.IsometricWorldToTileXY(worldX, worldY, true, point, camera, this.layer, originTop);
                        return this.getTileAt(point.x, point.y, nonNull);
                    },
                    /**
     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithin
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the area.
     */ getTilesWithin: function(tileX, tileY, width, height, filteringOptions) {
                        return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, this.layer);
                    },
                    /**
     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
     * Line, Rectangle or Triangle. The shape should be in world coordinates.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithinShape
     * @since 3.50.0
     *
     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the shape.
     */ getTilesWithinShape: function(shape, filteringOptions, camera) {
                        return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, this.layer);
                    },
                    /**
     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithinWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The world x coordinate for the top-left of the area.
     * @param {number} worldY - The world y coordinate for the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the area.
     */ getTilesWithinWorldXY: function(worldX, worldY, width, height, filteringOptions, camera) {
                        return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, this.layer);
                    },
                    /**
     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * @method Phaser.Tilemaps.TilemapLayer#hasTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     *
     * @return {boolean} `true` if a tile was found at the given location, otherwise `false`.
     */ hasTileAt: function(tileX, tileY) {
                        return TilemapComponents.HasTileAt(tileX, tileY, this.layer);
                    },
                    /**
     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * @method Phaser.Tilemaps.TilemapLayer#hasTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {boolean} `true` if a tile was found at the given location, otherwise `false`.
     */ hasTileAtWorldXY: function(worldX, worldY, camera) {
                        return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, this.layer);
                    },
                    /**
     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
     * location. If you pass in an index, only the index at the specified location will be changed.
     * Collision information will be recalculated at the specified location.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTileAt
     * @since 3.50.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was inserted at the given coordinates.
     */ putTileAt: function(tile, tileX, tileY, recalculateFaces) {
                        return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, this.layer);
                    },
                    /**
     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
     * specified location. If you pass in an index, only the index at the specified location will be
     * changed. Collision information will be recalculated at the specified location.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTileAtWorldXY
     * @since 3.50.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was inserted at the given coordinates.
     */ putTileAtWorldXY: function(tile, worldX, worldY, recalculateFaces, camera) {
                        return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, this.layer);
                    },
                    /**
     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
     * all attributes will be copied over to the specified location. If you pass in an index, only the
     * index at the specified location will be changed. Collision information will be recalculated
     * within the region tiles were changed.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTilesAt
     * @since 3.50.0
     *
     * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ putTilesAt: function(tilesArray, tileX, tileY, recalculateFaces) {
                        TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, this.layer);
                        return this;
                    },
                    /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
     * indexes. This method only modifies tile indexes and does not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#randomize
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {number[]} [indexes] - An array of indexes to randomly draw from during randomization.
     *
     * @return {this} This Tilemap Layer object.
     */ randomize: function(tileX, tileY, width, height, indexes) {
                        TilemapComponents.Randomize(tileX, tileY, width, height, indexes, this.layer);
                        return this;
                    },
                    /**
     * Removes the tile at the given tile coordinates in the specified layer and updates the layers
     * collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#removeTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile} A Tile object.
     */ removeTileAt: function(tileX, tileY, replaceWithNull, recalculateFaces) {
                        return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, this.layer);
                    },
                    /**
     * Removes the tile at the given world coordinates in the specified layer and updates the layers
     * collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#removeTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was removed from the given location.
     */ removeTileAtWorldXY: function(worldX, worldY, replaceWithNull, recalculateFaces, camera) {
                        return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, this.layer);
                    },
                    /**
     * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
     * wherever you want on the screen.
     *
     * @method Phaser.Tilemaps.TilemapLayer#renderDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     *
     * @return {this} This Tilemap Layer object.
     */ renderDebug: function(graphics, styleConfig) {
                        TilemapComponents.RenderDebug(graphics, styleConfig, this.layer);
                        return this;
                    },
                    /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
     * not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#replaceByIndex
     * @since 3.50.0
     *
     * @param {number} findIndex - The index of the tile to search for.
     * @param {number} newIndex - The index of the tile to replace it with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ replaceByIndex: function(findIndex, newIndex, tileX, tileY, width, height) {
                        TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, this.layer);
                        return this;
                    },
                    /**
     * You can control if the Cameras should cull tiles before rendering them or not.
     *
     * By default the camera will try to cull the tiles in this layer, to avoid over-drawing to the renderer.
     *
     * However, there are some instances when you may wish to disable this.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setSkipCull
     * @since 3.50.0
     *
     * @param {boolean} [value=true] - Set to `true` to stop culling tiles. Set to `false` to enable culling again.
     *
     * @return {this} This Tilemap Layer object.
     */ setSkipCull: function(value) {
                        if (value === undefined) value = true;
                        this.skipCull = value;
                        return this;
                    },
                    /**
     * When a Camera culls the tiles in this layer it does so using its view into the world, building up a
     * rectangle inside which the tiles must exist or they will be culled. Sometimes you may need to expand the size
     * of this 'cull rectangle', especially if you plan on rotating the Camera viewing the layer. Do so
     * by providing the padding values. The values given are in tiles, not pixels. So if the tile width was 32px
     * and you set `paddingX` to be 4, it would add 32px x 4 to the cull rectangle (adjusted for scale)
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCullPadding
     * @since 3.50.0
     *
     * @param {number} [paddingX=1] - The amount of extra horizontal tiles to add to the cull check padding.
     * @param {number} [paddingY=1] - The amount of extra vertical tiles to add to the cull check padding.
     *
     * @return {this} This Tilemap Layer object.
     */ setCullPadding: function(paddingX, paddingY) {
                        if (paddingX === undefined) paddingX = 1;
                        if (paddingY === undefined) paddingY = 1;
                        this.cullPaddingX = paddingX;
                        this.cullPaddingY = paddingY;
                        return this;
                    },
                    /**
     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
     * collision will be enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollision
     * @since 3.50.0
     *
     * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollision: function(indexes, collides, recalculateFaces, updateLayer) {
                        TilemapComponents.SetCollision(indexes, collides, recalculateFaces, this.layer, updateLayer);
                        return this;
                    },
                    /**
     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
     * enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionBetween
     * @since 3.50.0
     *
     * @param {number} start - The first index of the tile to be set for collision.
     * @param {number} stop - The last index of the tile to be set for collision.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionBetween: function(start, stop, collides, recalculateFaces) {
                        TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, this.layer);
                        return this;
                    },
                    /**
     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
     * that matches the given properties object, its collision flag will be set. The `collides`
     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
     * "types" property that matches any of those values, its collision flag will be updated.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionByProperty
     * @since 3.50.0
     *
     * @param {object} properties - An object with tile properties and corresponding values that should be checked.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionByProperty: function(properties, collides, recalculateFaces) {
                        TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, this.layer);
                        return this;
                    },
                    /**
     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
     * the given array. The `collides` parameter controls if collision will be enabled (true) or
     * disabled (false). Tile indexes not currently in the layer are not affected.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionByExclusion
     * @since 3.50.0
     *
     * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionByExclusion: function(indexes, collides, recalculateFaces) {
                        TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, this.layer);
                        return this;
                    },
                    /**
     * Sets collision on the tiles within a layer by checking each tiles collision group data
     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
     * a tiles collision group, the tile's colliding information will be set. The `collides` parameter
     * controls if collision will be enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionFromCollisionGroup
     * @since 3.50.0
     *
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionFromCollisionGroup: function(collides, recalculateFaces) {
                        TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, this.layer);
                        return this;
                    },
                    /**
     * Sets a global collision callback for the given tile index within the layer. This will affect all
     * tiles on this layer that have the same index. If a callback is already set for the tile index it
     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
     * at a specific location on the map then see setTileLocationCallback.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTileIndexCallback
     * @since 3.50.0
     *
     * @param {(number|number[])} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} callbackContext - The context under which the callback is called.
     *
     * @return {this} This Tilemap Layer object.
     */ setTileIndexCallback: function(indexes, callback, callbackContext) {
                        TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, this.layer);
                        return this;
                    },
                    /**
     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
     * remove it.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTileLocationCallback
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {function} [callback] - The callback that will be invoked when the tile is collided with.
     * @param {object} [callbackContext] - The context, or scope, under which the callback is invoked.
     *
     * @return {this} This Tilemap Layer object.
     */ setTileLocationCallback: function(tileX, tileY, width, height, callback, callbackContext) {
                        TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, this.layer);
                        return this;
                    },
                    /**
     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
     * appear to have changed! This method only modifies tile indexes and does not change collision
     * information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#shuffle
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ shuffle: function(tileX, tileY, width, height) {
                        TilemapComponents.Shuffle(tileX, tileY, width, height, this.layer);
                        return this;
                    },
                    /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
     * information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#swapByIndex
     * @since 3.50.0
     *
     * @param {number} tileA - First tile index.
     * @param {number} tileB - Second tile index.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ swapByIndex: function(indexA, indexB, tileX, tileY, width, height) {
                        TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, this.layer);
                        return this;
                    },
                    /**
     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldX
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The Tile X coordinate converted to pixels.
     */ tileToWorldX: function(tileX, camera) {
                        return this.tilemap.tileToWorldX(tileX, camera, this);
                    },
                    /**
     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldY
     * @since 3.50.0
     *
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The Tile Y coordinate converted to pixels.
     */ tileToWorldY: function(tileY, camera) {
                        return this.tilemap.tileToWorldY(tileY, camera, this);
                    },
                    /**
     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldXY
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Math.Vector2} [point] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the world coordinates of the Tile.
     */ tileToWorldXY: function(tileX, tileY, point, camera) {
                        return this.tilemap.tileToWorldXY(tileX, tileY, point, camera, this);
                    },
                    /**
     * Returns an array of Vector2s where each entry corresponds to the corner of the requested tile.
     *
     * The `tileX` and `tileY` parameters are in tile coordinates, not world coordinates.
     *
     * The corner coordinates are in world space, having factored in TilemapLayer scale, position
     * and the camera, if given.
     *
     * The size of the array will vary based on the orientation of the map. For example an
     * orthographic map will return an array of 4 vectors, where-as a hexagonal map will,
     * of course, return an array of 6 corner vectors.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTileCorners
     * @since 3.60.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {?Phaser.Math.Vector2[]} Returns an array of Vector2s, or null if the layer given was invalid.
     */ getTileCorners: function(tileX, tileY, camera) {
                        return this.tilemap.getTileCorners(tileX, tileY, camera, this);
                    },
                    /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. New indexes are drawn from the given
     * weightedIndexes array. An example weighted array:
     *
     * [
     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
     * ]
     *
     * The probability of any index being choose is (the index's weight) / (sum of all weights). This
     * method only modifies tile indexes and does not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#weightedRandomize
     * @since 3.50.0
     *
     * @param {object[]} weightedIndexes - An array of objects to randomly draw from during randomization. They should be in the form: { index: 0, weight: 4 } or { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ weightedRandomize: function(weightedIndexes, tileX, tileY, width, height) {
                        TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, this.layer);
                        return this;
                    },
                    /**
     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * You cannot call this method for Isometric or Hexagonal tilemaps as they require
     * both `worldX` and `worldY` values to determine the correct tile, instead you
     * should use the `worldToTileXY` method.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileX
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The tile X coordinate based on the world value.
     */ worldToTileX: function(worldX, snapToFloor, camera) {
                        return this.tilemap.worldToTileX(worldX, snapToFloor, camera, this);
                    },
                    /**
     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * You cannot call this method for Isometric or Hexagonal tilemaps as they require
     * both `worldX` and `worldY` values to determine the correct tile, instead you
     * should use the `worldToTileXY` method.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileY
     * @since 3.50.0
     *
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The tile Y coordinate based on the world value.
     */ worldToTileY: function(worldY, snapToFloor, camera) {
                        return this.tilemap.worldToTileY(worldY, snapToFloor, camera, this);
                    },
                    /**
     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Math.Vector2} [point] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the tile coordinates of the world values.
     */ worldToTileXY: function(worldX, worldY, snapToFloor, point, camera) {
                        return this.tilemap.worldToTileXY(worldX, worldY, snapToFloor, point, camera, this);
                    },
                    /**
     * Destroys this TilemapLayer and removes its link to the associated LayerData.
     *
     * @method Phaser.Tilemaps.TilemapLayer#destroy
     * @since 3.50.0
     *
     * @param {boolean} [removeFromTilemap=true] - Remove this layer from the parent Tilemap?
     */ destroy: function(removeFromTilemap) {
                        if (removeFromTilemap === undefined) removeFromTilemap = true;
                        if (!this.tilemap) //  Abort, we've already been destroyed
                        return;
                        //  Uninstall this layer only if it is still installed on the LayerData object
                        if (this.layer.tilemapLayer === this) this.layer.tilemapLayer = undefined;
                        if (removeFromTilemap) this.tilemap.removeLayer(this);
                        this.tilemap = undefined;
                        this.layer = undefined;
                        this.culledTiles.length = 0;
                        this.cullCallback = null;
                        this.gidMap = [];
                        this.tileset = [];
                        GameObject.prototype.destroy.call(this);
                    }
                });
                module1.exports = TilemapLayer;
            /***/ },
            /***/ 16153: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(61340);
                var tempMatrix1 = new TransformMatrix();
                var tempMatrix2 = new TransformMatrix();
                var tempMatrix3 = new TransformMatrix();
                /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.Tilemaps.TilemapLayer#renderCanvas
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.Tilemaps.TilemapLayer} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TilemapLayerCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                    var renderTiles = src.cull(camera);
                    var tileCount = renderTiles.length;
                    var alpha = camera.alpha * src.alpha;
                    if (tileCount === 0 || alpha <= 0) return;
                    var camMatrix = tempMatrix1;
                    var layerMatrix = tempMatrix2;
                    var calcMatrix = tempMatrix3;
                    layerMatrix.applyITRS(src.x, src.y, src.rotation, src.scaleX, src.scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    var ctx = renderer.currentContext;
                    var gidMap = src.gidMap;
                    ctx.save();
                    if (parentMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                        //  Undo the camera scroll
                        layerMatrix.e = src.x;
                        layerMatrix.f = src.y;
                        //  Multiply by the Sprite matrix, store result in calcMatrix
                        camMatrix.multiply(layerMatrix, calcMatrix);
                        calcMatrix.copyToContext(ctx);
                    } else {
                        layerMatrix.e -= camera.scrollX * src.scrollFactorX;
                        layerMatrix.f -= camera.scrollY * src.scrollFactorY;
                        layerMatrix.copyToContext(ctx);
                    }
                    if (!renderer.antialias || src.scaleX > 1 || src.scaleY > 1) ctx.imageSmoothingEnabled = false;
                    for(var i = 0; i < tileCount; i++){
                        var tile = renderTiles[i];
                        var tileset = gidMap[tile.index];
                        if (!tileset) continue;
                        var image = tileset.image.getSourceImage();
                        var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
                        var tileWidth = tileset.tileWidth;
                        var tileHeight = tileset.tileHeight;
                        if (tileTexCoords === null || tileWidth === 0 || tileHeight === 0) continue;
                        var halfWidth = tileWidth * 0.5;
                        var halfHeight = tileHeight * 0.5;
                        tileTexCoords.x += tileset.tileOffset.x;
                        tileTexCoords.y += tileset.tileOffset.y;
                        ctx.save();
                        ctx.translate(tile.pixelX + halfWidth, tile.pixelY + halfHeight);
                        if (tile.rotation !== 0) ctx.rotate(tile.rotation);
                        if (tile.flipX || tile.flipY) ctx.scale(tile.flipX ? -1 : 1, tile.flipY ? -1 : 1);
                        ctx.globalAlpha = alpha * tile.alpha;
                        ctx.drawImage(image, tileTexCoords.x, tileTexCoords.y, tileWidth, tileHeight, -halfWidth, -halfHeight, tileWidth, tileHeight);
                        ctx.restore();
                    }
                    ctx.restore();
                };
                module1.exports = TilemapLayerCanvasRenderer;
            /***/ },
            /***/ 19218: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var NOOP = __webpack_require__(29747);
                var renderWebGL = NOOP;
                var renderCanvas = NOOP;
                renderWebGL = __webpack_require__(99558);
                renderCanvas = __webpack_require__(16153);
                module1.exports = {
                    renderWebGL: renderWebGL,
                    renderCanvas: renderCanvas
                };
            /***/ },
            /***/ 99558: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(70554);
                /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.Tilemaps.TilemapLayer#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.Tilemaps.TilemapLayer} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var TilemapLayerWebGLRenderer = function(renderer, src, camera) {
                    var renderTiles = src.cull(camera);
                    var tileCount = renderTiles.length;
                    var alpha = camera.alpha * src.alpha;
                    if (tileCount === 0 || alpha <= 0) return;
                    var gidMap = src.gidMap;
                    var pipeline = renderer.pipelines.set(src.pipeline, src);
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var scrollFactorX = src.scrollFactorX;
                    var scrollFactorY = src.scrollFactorY;
                    var x = src.x;
                    var y = src.y;
                    var sx = src.scaleX;
                    var sy = src.scaleY;
                    renderer.pipelines.preBatch(src);
                    for(var i = 0; i < tileCount; i++){
                        var tile = renderTiles[i];
                        var tileset = gidMap[tile.index];
                        if (!tileset) continue;
                        var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
                        var tileWidth = tileset.tileWidth;
                        var tileHeight = tileset.tileHeight;
                        if (!tileTexCoords || tileWidth === 0 || tileHeight === 0) continue;
                        var halfWidth = tileWidth * 0.5;
                        var halfHeight = tileHeight * 0.5;
                        var texture = tileset.glTexture;
                        var textureUnit = pipeline.setTexture2D(texture, src);
                        var frameWidth = tileWidth;
                        var frameHeight = tileHeight;
                        var frameX = tileTexCoords.x;
                        var frameY = tileTexCoords.y;
                        var tOffsetX = tileset.tileOffset.x;
                        var tOffsetY = tileset.tileOffset.y;
                        var tint = getTint(tile.tint, alpha * tile.alpha);
                        pipeline.batchTexture(src, texture, texture.width, texture.height, x + tile.pixelX * sx + (halfWidth * sx - tOffsetX), y + tile.pixelY * sy + (halfHeight * sy - tOffsetY), tileWidth, tileHeight, sx, sy, tile.rotation, tile.flipX, tile.flipY, scrollFactorX, scrollFactorY, halfWidth, halfHeight, frameX, frameY, frameWidth, frameHeight, tint, tint, tint, tint, tile.tintFill, 0, 0, camera, null, true, textureUnit, true);
                    }
                    renderer.pipelines.postBatch(src);
                };
                module1.exports = TilemapLayerWebGLRenderer;
            /***/ },
            /***/ 33629: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Vector2 = __webpack_require__(26099);
                /**
 * @classdesc
 * A Tileset is a combination of a single image containing the tiles and a container for data about
 * each tile.
 *
 * @class Tileset
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {string} name - The name of the tileset in the map data.
 * @param {number} firstgid - The first tile index this tileset contains.
 * @param {number} [tileWidth=32] - Width of each tile (in pixels).
 * @param {number} [tileHeight=32] - Height of each tile (in pixels).
 * @param {number} [tileMargin=0] - The margin around all tiles in the sheet (in pixels).
 * @param {number} [tileSpacing=0] - The spacing between each tile in the sheet (in pixels).
 * @param {object} [tileProperties={}] - Custom properties defined per tile in the Tileset.
 * These typically are custom properties created in Tiled when editing a tileset.
 * @param {object} [tileData={}] - Data stored per tile. These typically are created in Tiled when editing a tileset, e.g. from Tiled's tile collision editor or terrain editor.
 * @param {object} [tileOffset={x: 0, y: 0}] - Tile texture drawing offset.
 */ var Tileset = new Class({
                    initialize: function Tileset(name, firstgid, tileWidth, tileHeight, tileMargin, tileSpacing, tileProperties, tileData, tileOffset) {
                        if (tileWidth === undefined || tileWidth <= 0) tileWidth = 32;
                        if (tileHeight === undefined || tileHeight <= 0) tileHeight = 32;
                        if (tileMargin === undefined) tileMargin = 0;
                        if (tileSpacing === undefined) tileSpacing = 0;
                        if (tileProperties === undefined) tileProperties = {};
                        if (tileData === undefined) tileData = {};
                        /**
         * The name of the Tileset.
         *
         * @name Phaser.Tilemaps.Tileset#name
         * @type {string}
         * @since 3.0.0
         */ this.name = name;
                        /**
         * The starting index of the first tile index this Tileset contains.
         *
         * @name Phaser.Tilemaps.Tileset#firstgid
         * @type {number}
         * @since 3.0.0
         */ this.firstgid = firstgid;
                        /**
         * The width of each tile (in pixels). Use setTileSize to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileWidth
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileWidth = tileWidth;
                        /**
         * The height of each tile (in pixels). Use setTileSize to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileHeight
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileHeight = tileHeight;
                        /**
         * The margin around the tiles in the sheet (in pixels). Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileMargin
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileMargin = tileMargin;
                        /**
         * The spacing between each the tile in the sheet (in pixels). Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileSpacing
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileSpacing = tileSpacing;
                        /**
         * Tileset-specific properties per tile that are typically defined in the Tiled editor in the
         * Tileset editor.
         *
         * @name Phaser.Tilemaps.Tileset#tileProperties
         * @type {object}
         * @since 3.0.0
         */ this.tileProperties = tileProperties;
                        /**
         * Tileset-specific data per tile that are typically defined in the Tiled editor, e.g. within
         * the Tileset collision editor. This is where collision objects and terrain are stored.
         *
         * @name Phaser.Tilemaps.Tileset#tileData
         * @type {object}
         * @since 3.0.0
         */ this.tileData = tileData;
                        /**
         * Controls the drawing offset from the tile origin.
         * Defaults to 0x0, no offset.
         *
         * @name Phaser.Tilemaps.Tileset#tileOffset
         * @type {Phaser.Math.Vector2}
         * @since 3.60.0
         */ this.tileOffset = new Vector2();
                        if (tileOffset !== undefined) this.tileOffset.set(tileOffset.x, tileOffset.y);
                        /**
         * The cached image that contains the individual tiles. Use setImage to set.
         *
         * @name Phaser.Tilemaps.Tileset#image
         * @type {?Phaser.Textures.Texture}
         * @readonly
         * @since 3.0.0
         */ this.image = null;
                        /**
         * The gl texture used by the WebGL renderer.
         *
         * @name Phaser.Tilemaps.Tileset#glTexture
         * @type {?Phaser.Renderer.WebGL.Wrappers.WebGLTextureWrapper}
         * @readonly
         * @since 3.11.0
         */ this.glTexture = null;
                        /**
         * The number of tile rows in the the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#rows
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.rows = 0;
                        /**
         * The number of tile columns in the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#columns
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.columns = 0;
                        /**
         * The total number of tiles in the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#total
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.total = 0;
                        /**
         * The look-up table to specific tile image texture coordinates (UV in pixels). Each element
         * contains the coordinates for a tile in an object of the form {x, y}.
         *
         * @name Phaser.Tilemaps.Tileset#texCoordinates
         * @type {object[]}
         * @readonly
         * @since 3.0.0
        */ this.texCoordinates = [];
                    },
                    /**
     * Get a tiles properties that are stored in the Tileset. Returns null if tile index is not
     * contained in this Tileset. This is typically defined in Tiled under the Tileset editor.
     *
     * @method Phaser.Tilemaps.Tileset#getTileProperties
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?(object|undefined)}
     */ getTileProperties: function(tileIndex) {
                        if (!this.containsTileIndex(tileIndex)) return null;
                        return this.tileProperties[tileIndex - this.firstgid];
                    },
                    /**
     * Get a tile's data that is stored in the Tileset. Returns null if tile index is not contained
     * in this Tileset. This is typically defined in Tiled and will contain both Tileset collision
     * info and terrain mapping.
     *
     * @method Phaser.Tilemaps.Tileset#getTileData
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object|undefined}
     */ getTileData: function(tileIndex) {
                        if (!this.containsTileIndex(tileIndex)) return null;
                        return this.tileData[tileIndex - this.firstgid];
                    },
                    /**
     * Get a tile's collision group that is stored in the Tileset. Returns null if tile index is not
     * contained in this Tileset. This is typically defined within Tiled's tileset collision editor.
     *
     * @method Phaser.Tilemaps.Tileset#getTileCollisionGroup
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object}
     */ getTileCollisionGroup: function(tileIndex) {
                        var data = this.getTileData(tileIndex);
                        return data && data.objectgroup ? data.objectgroup : null;
                    },
                    /**
     * Returns true if and only if this Tileset contains the given tile index.
     *
     * @method Phaser.Tilemaps.Tileset#containsTileIndex
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {boolean}
     */ containsTileIndex: function(tileIndex) {
                        return tileIndex >= this.firstgid && tileIndex < this.firstgid + this.total;
                    },
                    /**
     * Returns the texture coordinates (UV in pixels) in the Tileset image for the given tile index.
     * Returns null if tile index is not contained in this Tileset.
     *
     * @method Phaser.Tilemaps.Tileset#getTileTextureCoordinates
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object} Object in the form { x, y } representing the top-left UV coordinate
     * within the Tileset image.
     */ getTileTextureCoordinates: function(tileIndex) {
                        if (!this.containsTileIndex(tileIndex)) return null;
                        return this.texCoordinates[tileIndex - this.firstgid];
                    },
                    /**
     * Sets the image associated with this Tileset and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setImage
     * @since 3.0.0
     *
     * @param {Phaser.Textures.Texture} texture - The image that contains the tiles.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setImage: function(texture) {
                        this.image = texture;
                        var frame = texture.get();
                        var bounds = texture.getFrameBounds();
                        this.glTexture = frame.source.glTexture;
                        if (frame.width > bounds.width || frame.height > bounds.height) this.updateTileData(frame.width, frame.height);
                        else this.updateTileData(bounds.width, bounds.height, bounds.x, bounds.y);
                        return this;
                    },
                    /**
     * Sets the tile width & height and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setTileSize
     * @since 3.0.0
     *
     * @param {number} [tileWidth] - The width of a tile in pixels.
     * @param {number} [tileHeight] - The height of a tile in pixels.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setTileSize: function(tileWidth, tileHeight) {
                        if (tileWidth !== undefined) this.tileWidth = tileWidth;
                        if (tileHeight !== undefined) this.tileHeight = tileHeight;
                        if (this.image) this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                        return this;
                    },
                    /**
     * Sets the tile margin and spacing and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setSpacing
     * @since 3.0.0
     *
     * @param {number} [margin] - The margin around the tiles in the sheet (in pixels).
     * @param {number} [spacing] - The spacing between the tiles in the sheet (in pixels).
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setSpacing: function(margin, spacing) {
                        if (margin !== undefined) this.tileMargin = margin;
                        if (spacing !== undefined) this.tileSpacing = spacing;
                        if (this.image) this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                        return this;
                    },
                    /**
     * Updates tile texture coordinates and tileset data.
     *
     * @method Phaser.Tilemaps.Tileset#updateTileData
     * @since 3.0.0
     *
     * @param {number} imageWidth - The (expected) width of the image to slice.
     * @param {number} imageHeight - The (expected) height of the image to slice.
     * @param {number} [offsetX=0] - The x offset in the source texture where the tileset starts.
     * @param {number} [offsetY=0] - The y offset in the source texture where the tileset starts.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ updateTileData: function(imageWidth, imageHeight, offsetX, offsetY) {
                        if (offsetX === undefined) offsetX = 0;
                        if (offsetY === undefined) offsetY = 0;
                        var rowCount = (imageHeight - this.tileMargin * 2 + this.tileSpacing) / (this.tileHeight + this.tileSpacing);
                        var colCount = (imageWidth - this.tileMargin * 2 + this.tileSpacing) / (this.tileWidth + this.tileSpacing);
                        if (rowCount % 1 !== 0 || colCount % 1 !== 0) console.warn('Image tile area not tile size multiple in: ' + this.name);
                        // In Tiled a tileset image that is not an even multiple of the tile dimensions is truncated
                        // - hence the floor when calculating the rows/columns.
                        rowCount = Math.floor(rowCount);
                        colCount = Math.floor(colCount);
                        this.rows = rowCount;
                        this.columns = colCount;
                        // In Tiled, "empty" spaces in a tileset count as tiles and hence count towards the gid
                        this.total = rowCount * colCount;
                        this.texCoordinates.length = 0;
                        var tx = this.tileMargin + offsetX;
                        var ty = this.tileMargin + offsetY;
                        for(var y = 0; y < this.rows; y++){
                            for(var x = 0; x < this.columns; x++){
                                this.texCoordinates.push({
                                    x: tx,
                                    y: ty
                                });
                                tx += this.tileWidth + this.tileSpacing;
                            }
                            tx = this.tileMargin + offsetX;
                            ty += this.tileHeight + this.tileSpacing;
                        }
                        return this;
                    }
                });
                module1.exports = Tileset;
            /***/ },
            /***/ 72023: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(7423);
                /**
 * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
 * faces are used internally for optimizing collisions against tiles. This method is mostly used
 * internally to optimize recalculating faces when only one tile has been changed.
 *
 * @function Phaser.Tilemaps.Components.CalculateFacesAt
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate.
 * @param {number} tileY - The y coordinate.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var CalculateFacesAt = function(tileX, tileY, layer) {
                    var tile = GetTileAt(tileX, tileY, true, layer);
                    var above = GetTileAt(tileX, tileY - 1, true, layer);
                    var below = GetTileAt(tileX, tileY + 1, true, layer);
                    var left = GetTileAt(tileX - 1, tileY, true, layer);
                    var right = GetTileAt(tileX + 1, tileY, true, layer);
                    var tileCollides = tile && tile.collides;
                    // Assume the changed tile has all interesting edges
                    if (tileCollides) {
                        tile.faceTop = true;
                        tile.faceBottom = true;
                        tile.faceLeft = true;
                        tile.faceRight = true;
                    }
                    // Reset edges that are shared between tile and its neighbors
                    if (above && above.collides) {
                        if (tileCollides) tile.faceTop = false;
                        above.faceBottom = !tileCollides;
                    }
                    if (below && below.collides) {
                        if (tileCollides) tile.faceBottom = false;
                        below.faceTop = !tileCollides;
                    }
                    if (left && left.collides) {
                        if (tileCollides) tile.faceLeft = false;
                        left.faceRight = !tileCollides;
                    }
                    if (right && right.collides) {
                        if (tileCollides) tile.faceRight = false;
                        right.faceLeft = !tileCollides;
                    }
                    if (tile && !tile.collides) tile.resetFaces();
                    return tile;
                };
                module1.exports = CalculateFacesAt;
            /***/ },
            /***/ 42573: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(7423);
                var GetTilesWithin = __webpack_require__(7386);
                /**
 * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
 * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
 * is mostly used internally.
 *
 * @function Phaser.Tilemaps.Components.CalculateFacesWithin
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var CalculateFacesWithin = function(tileX, tileY, width, height, layer) {
                    var above = null;
                    var below = null;
                    var left = null;
                    var right = null;
                    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                    for(var i = 0; i < tiles.length; i++){
                        var tile = tiles[i];
                        if (tile) {
                            if (tile.collides) {
                                above = GetTileAt(tile.x, tile.y - 1, true, layer);
                                below = GetTileAt(tile.x, tile.y + 1, true, layer);
                                left = GetTileAt(tile.x - 1, tile.y, true, layer);
                                right = GetTileAt(tile.x + 1, tile.y, true, layer);
                                tile.faceTop = above && above.collides ? false : true;
                                tile.faceBottom = below && below.collides ? false : true;
                                tile.faceLeft = left && left.collides ? false : true;
                                tile.faceRight = right && right.collides ? false : true;
                            } else tile.resetFaces();
                        }
                    }
                };
                module1.exports = CalculateFacesWithin;
            /***/ },
            /***/ 33528: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                var point = new Vector2();
                /**
 * Checks if the given tile coordinate is within the isometric layer bounds, or not.
 *
 * @function Phaser.Tilemaps.Components.CheckIsoBounds
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to check against.
 * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
 *
 * @return {boolean} Returns `true` if the coordinates are within the iso bounds.
 */ var CheckIsoBounds = function(tileX, tileY, layer, camera) {
                    var tilemapLayer = layer.tilemapLayer;
                    var cullPaddingX = tilemapLayer.cullPaddingX;
                    var cullPaddingY = tilemapLayer.cullPaddingY;
                    var pos = tilemapLayer.tilemap.tileToWorldXY(tileX, tileY, point, camera, tilemapLayer);
                    // we always subtract 1/2 of the tile's height/width to make the culling distance start from the center of the tiles.
                    return pos.x > camera.worldView.x + tilemapLayer.scaleX * layer.tileWidth * (-cullPaddingX - 0.5) && pos.x < camera.worldView.right + tilemapLayer.scaleX * layer.tileWidth * (cullPaddingX - 0.5) && pos.y > camera.worldView.y + tilemapLayer.scaleY * layer.tileHeight * (-cullPaddingY - 1.0) && pos.y < camera.worldView.bottom + tilemapLayer.scaleY * layer.tileHeight * (cullPaddingY - 0.5);
                };
                module1.exports = CheckIsoBounds;
            /***/ },
            /***/ 1785: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CalculateFacesWithin = __webpack_require__(42573);
                var GetTilesWithin = __webpack_require__(7386);
                var IsInLayerBounds = __webpack_require__(62991);
                var Tile = __webpack_require__(23029);
                /**
 * Copies the tiles in the source rectangular area to a new destination (all specified in tile
 * coordinates) within the layer. This copies all tile properties and recalculates collision
 * information in the destination region.
 *
 * @function Phaser.Tilemaps.Components.Copy
 * @since 3.0.0
 *
 * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
 * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
 * @param {number} width - The width of the area to copy, in tiles, not pixels.
 * @param {number} height - The height of the area to copy, in tiles, not pixels.
 * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
 * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Copy = function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    //  Returns an array of Tile references
                    var srcTiles = GetTilesWithin(srcTileX, srcTileY, width, height, null, layer);
                    //  Create a new array of fresh Tile objects
                    var copyTiles = [];
                    srcTiles.forEach(function(tile) {
                        var newTile = new Tile(tile.layer, tile.index, tile.x, tile.y, tile.width, tile.height, tile.baseWidth, tile.baseHeight);
                        newTile.copy(tile);
                        copyTiles.push(newTile);
                    });
                    var offsetX = destTileX - srcTileX;
                    var offsetY = destTileY - srcTileY;
                    for(var i = 0; i < copyTiles.length; i++){
                        var copy = copyTiles[i];
                        var tileX = copy.x + offsetX;
                        var tileY = copy.y + offsetY;
                        if (IsInLayerBounds(tileX, tileY, layer)) {
                            if (layer.data[tileY][tileX]) {
                                copy.x = tileX;
                                copy.y = tileY;
                                copy.updatePixelXY();
                                layer.data[tileY][tileX] = copy;
                            }
                        }
                    }
                    if (recalculateFaces) // Recalculate the faces within the destination area and neighboring tiles
                    CalculateFacesWithin(destTileX - 1, destTileY - 1, width + 2, height + 2, layer);
                    srcTiles.length = 0;
                    copyTiles.length = 0;
                };
                module1.exports = Copy;
            /***/ },
            /***/ 78419: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DeepCopy = __webpack_require__(62644);
                var GetTilesWithin = __webpack_require__(7386);
                var ReplaceByIndex = __webpack_require__(27987);
                /**
 * Creates a Sprite for every object matching the given tile indexes in the layer. You can
 * optionally specify if each tile will be replaced with a new tile after the Sprite has been
 * created. This is useful if you want to lay down special tiles in a level that are converted to
 * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
 *
 * @function Phaser.Tilemaps.Components.CreateFromTiles
 * @since 3.0.0
 *
 * @param {(number|number[])} indexes - The tile index, or array of indexes, to create Sprites from.
 * @param {?(number|number[])} replacements - The tile index, or array of indexes, to change a converted tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a one-to-one mapping with the indexes array.
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} spriteConfig - The config object to pass into the Sprite creator (i.e. scene.make.sprite).
 * @param {Phaser.Scene} scene - The Scene to create the Sprites within.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when determining the world XY
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
 */ var CreateFromTiles = function(indexes, replacements, spriteConfig, scene, camera, layer) {
                    if (!spriteConfig) spriteConfig = {};
                    if (!Array.isArray(indexes)) indexes = [
                        indexes
                    ];
                    var tilemapLayer = layer.tilemapLayer;
                    if (!scene) scene = tilemapLayer.scene;
                    if (!camera) camera = scene.cameras.main;
                    var layerWidth = layer.width;
                    var layerHeight = layer.height;
                    var tiles = GetTilesWithin(0, 0, layerWidth, layerHeight, null, layer);
                    var sprites = [];
                    var i;
                    var mergeExtras = function(config, tile, properties) {
                        for(var i = 0; i < properties.length; i++){
                            var property = properties[i];
                            if (!config.hasOwnProperty(property)) config[property] = tile[property];
                        }
                    };
                    for(i = 0; i < tiles.length; i++){
                        var tile = tiles[i];
                        var config = DeepCopy(spriteConfig);
                        if (indexes.indexOf(tile.index) !== -1) {
                            var point = tilemapLayer.tileToWorldXY(tile.x, tile.y, undefined, camera, layer);
                            config.x = point.x;
                            config.y = point.y;
                            mergeExtras(config, tile, [
                                'rotation',
                                'flipX',
                                'flipY',
                                'alpha',
                                'visible',
                                'tint'
                            ]);
                            if (!config.hasOwnProperty('origin')) {
                                config.x += tile.width * 0.5;
                                config.y += tile.height * 0.5;
                            }
                            if (config.hasOwnProperty('useSpriteSheet')) {
                                config.key = tile.tileset.image;
                                config.frame = tile.index - 1;
                            }
                            sprites.push(scene.make.sprite(config));
                        }
                    }
                    if (Array.isArray(replacements)) //  Assume 1 to 1 mapping with indexes array
                    for(i = 0; i < indexes.length; i++)ReplaceByIndex(indexes[i], replacements[i], 0, 0, layerWidth, layerHeight, layer);
                    else if (replacements !== null) //  Assume 1 replacement for all types of tile given
                    for(i = 0; i < indexes.length; i++)ReplaceByIndex(indexes[i], replacements, 0, 0, layerWidth, layerHeight, layer);
                    return sprites;
                };
                module1.exports = CreateFromTiles;
            /***/ },
            /***/ 19545: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(87841);
                var SnapCeil = __webpack_require__(63448);
                var SnapFloor = __webpack_require__(56583);
                var bounds = new Rectangle();
                /**
 * Returns the bounds in the given orthogonal layer that are within the cameras viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.CullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {Phaser.Geom.Rectangle} A rectangle containing the culled bounds. If you wish to retain this object, clone it, as it's recycled internally.
 */ var CullBounds = function(layer, camera) {
                    var tilemap = layer.tilemapLayer.tilemap;
                    var tilemapLayer = layer.tilemapLayer;
                    //  We need to use the tile sizes defined for the map as a whole, not the layer,
                    //  in order to calculate the bounds correctly. As different sized tiles may be
                    //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                    var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                    var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                    var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                    var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                    var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, tileH, 0, true) - tilemapLayer.cullPaddingY;
                    var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, tileH, 0, true) + tilemapLayer.cullPaddingY;
                    return bounds.setTo(boundsLeft, boundsTop, boundsRight - boundsLeft, boundsBottom - boundsTop);
                };
                module1.exports = CullBounds;
            /***/ },
            /***/ 30003: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(19545);
                var RunCull = __webpack_require__(32483);
                /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.CullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var CullTiles = function(layer, camera, outputArray, renderOrder) {
                    if (outputArray === undefined) outputArray = [];
                    if (renderOrder === undefined) renderOrder = 0;
                    outputArray.length = 0;
                    var tilemapLayer = layer.tilemapLayer;
                    //  Camera world view bounds, snapped for scaled tile size
                    //  Cull Padding values are given in tiles, not pixels
                    var bounds = CullBounds(layer, camera);
                    if (tilemapLayer.skipCull || tilemapLayer.scrollFactorX !== 1 || tilemapLayer.scrollFactorY !== 1) {
                        bounds.left = 0;
                        bounds.right = layer.width;
                        bounds.top = 0;
                        bounds.bottom = layer.height;
                    }
                    RunCull(layer, bounds, renderOrder, outputArray);
                    return outputArray;
                };
                module1.exports = CullTiles;
            /***/ },
            /***/ 35137: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                var CalculateFacesWithin = __webpack_require__(42573);
                var SetTileCollision = __webpack_require__(20576);
                /**
 * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
 * specified index. Tiles will be set to collide if the given index is a colliding index.
 * Collision information in the region will be recalculated.
 *
 * @function Phaser.Tilemaps.Components.Fill
 * @since 3.0.0
 *
 * @param {number} index - The tile index to fill the area with.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The tile layer to use. If not given the current layer is used.
 */ var Fill = function(index, tileX, tileY, width, height, recalculateFaces, layer) {
                    var doesIndexCollide = layer.collideIndexes.indexOf(index) !== -1;
                    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                    for(var i = 0; i < tiles.length; i++){
                        tiles[i].index = index;
                        SetTileCollision(tiles[i], doesIndexCollide);
                    }
                    if (recalculateFaces) // Recalculate the faces within the area and neighboring tiles
                    CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
                };
                module1.exports = Fill;
            /***/ },
            /***/ 40253: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                /**
 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
 * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
 * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.FilterTiles
 * @since 3.0.0
 *
 * @param {function} callback - The callback. Each tile in the given area will be passed to this
 * callback as the first and only parameter. The callback should return true for tiles that pass the
 * filter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} The filtered array of Tiles.
 */ var FilterTiles = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                    return tiles.filter(callback, context);
                };
                module1.exports = FilterTiles;
            /***/ },
            /***/ 52692: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Searches the entire map layer for the first tile matching the given index, then returns that Tile
 * object. If no match is found, it returns null. The search starts from the top-left tile and
 * continues horizontally until it hits the end of the row, then it drops down to the next column.
 * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
 * the top-left.
 *
 * @function Phaser.Tilemaps.Components.FindByIndex
 * @since 3.0.0
 *
 * @param {number} index - The tile index value to search for.
 * @param {number} skip - The number of times to skip a matching tile before returning.
 * @param {boolean} reverse - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?Phaser.Tilemaps.Tile} The first (or n skipped) tile with the matching index.
 */ var FindByIndex = function(findIndex, skip, reverse, layer) {
                    if (skip === undefined) skip = 0;
                    if (reverse === undefined) reverse = false;
                    var count = 0;
                    var tx;
                    var ty;
                    var tile;
                    if (reverse) {
                        for(ty = layer.height - 1; ty >= 0; ty--)for(tx = layer.width - 1; tx >= 0; tx--){
                            tile = layer.data[ty][tx];
                            if (tile && tile.index === findIndex) {
                                if (count === skip) return tile;
                                else count += 1;
                            }
                        }
                    } else {
                        for(ty = 0; ty < layer.height; ty++)for(tx = 0; tx < layer.width; tx++){
                            tile = layer.data[ty][tx];
                            if (tile && tile.index === findIndex) {
                                if (count === skip) return tile;
                                else count += 1;
                            }
                        }
                    }
                    return null;
                };
                module1.exports = FindByIndex;
            /***/ },
            /***/ 66151: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                /**
 * @callback FindTileCallback
 *
 * @param {Phaser.Tilemaps.Tile} value - The Tile.
 * @param {number} index - The index of the tile.
 * @param {Phaser.Tilemaps.Tile[]} array - An array of Tile objects.
 *
 * @return {boolean} Return `true` if the callback should run, otherwise `false`.
 */ /**
 * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
 * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
 * true. Similar to Array.prototype.find in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.FindTile
 * @since 3.0.0
 *
 * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?Phaser.Tilemaps.Tile} A Tile that matches the search, or null if no Tile found
 */ var FindTile = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                    return tiles.find(callback, context) || null;
                };
                module1.exports = FindTile;
            /***/ },
            /***/ 97560: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                /**
 * @callback EachTileCallback
 *
 * @param {Phaser.Tilemaps.Tile} value - The Tile.
 * @param {number} index - The index of the tile.
 * @param {Phaser.Tilemaps.Tile[]} array - An array of Tile objects.
 */ /**
 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
 * callback. Similar to Array.prototype.forEach in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.ForEachTile
 * @since 3.0.0
 *
 * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var ForEachTile = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                    tiles.forEach(callback, context);
                };
                module1.exports = ForEachTile;
            /***/ },
            /***/ 43305: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var CullTiles = __webpack_require__(30003);
                var HexagonalCullTiles = __webpack_require__(9474);
                var IsometricCullTiles = __webpack_require__(14018);
                var NOOP = __webpack_require__(29747);
                var StaggeredCullTiles = __webpack_require__(54503);
                /**
 * Gets the correct function to use to cull tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetCullTilesFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to cull tiles for the given map type.
 */ var GetCullTilesFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return CullTiles;
                    else if (orientation === CONST.HEXAGONAL) return HexagonalCullTiles;
                    else if (orientation === CONST.STAGGERED) return StaggeredCullTiles;
                    else if (orientation === CONST.ISOMETRIC) return IsometricCullTiles;
                    else return NOOP;
                };
                module1.exports = GetCullTilesFunction;
            /***/ },
            /***/ 7423: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsInLayerBounds = __webpack_require__(62991);
                /**
 * Gets a tile at the given tile coordinates from the given layer.
 *
 * @function Phaser.Tilemaps.Components.GetTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
 * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
 * @param {boolean} nonNull - For empty tiles, return a Tile object with an index of -1 instead of null.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
 */ var GetTileAt = function(tileX, tileY, nonNull, layer) {
                    if (IsInLayerBounds(tileX, tileY, layer)) {
                        var tile = layer.data[tileY][tileX] || null;
                        if (!tile) return null;
                        else if (tile.index === -1) return nonNull ? tile : null;
                        else return tile;
                    } else return null;
                };
                module1.exports = GetTileAt;
            /***/ },
            /***/ 60540: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(7423);
                var Vector2 = __webpack_require__(26099);
                var point = new Vector2();
                /**
 * Gets a tile at the given world coordinates from the given layer.
 *
 * @function Phaser.Tilemaps.Components.GetTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - X position to get the tile from (given in pixels)
 * @param {number} worldY - Y position to get the tile from (given in pixels)
 * @param {boolean} nonNull - For empty tiles, return a Tile object with an index of -1 instead of null.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
 */ var GetTileAtWorldXY = function(worldX, worldY, nonNull, camera, layer) {
                    layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera);
                    return GetTileAt(point.x, point.y, nonNull, layer);
                };
                module1.exports = GetTileAtWorldXY;
            /***/ },
            /***/ 55826: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Gets the corners of the Tile as an array of Vector2s.
 *
 * @function Phaser.Tilemaps.Components.GetTileCorners
 * @since 3.60.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2[]} An array of Vector2s corresponding to the world XY location of each tile corner.
 */ var GetTileCorners = function(tileX, tileY, camera, layer) {
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    var worldX = 0;
                    var worldY = 0;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        worldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                        worldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                        tileWidth *= tilemapLayer.scaleX;
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    var x = worldX + tileX * tileWidth;
                    var y = worldY + tileY * tileHeight;
                    //  Top Left
                    //  Top Right
                    //  Bottom Right
                    //  Bottom Left
                    return [
                        new Vector2(x, y),
                        new Vector2(x + tileWidth, y),
                        new Vector2(x + tileWidth, y + tileHeight),
                        new Vector2(x, y + tileHeight)
                    ];
                };
                module1.exports = GetTileCorners;
            /***/ },
            /***/ 11758: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var HexagonalGetTileCorners = __webpack_require__(27229);
                var NOOP = __webpack_require__(29747);
                var GetTileCorners = __webpack_require__(55826);
                /**
 * Gets the correct function to use to get the tile corners, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileCornersFunction
 * @since 3.60.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileCornersFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return GetTileCorners;
                    else if (orientation === CONST.ISOMETRIC) return NOOP;
                    else if (orientation === CONST.HEXAGONAL) return HexagonalGetTileCorners;
                    else if (orientation === CONST.STAGGERED) return NOOP;
                    else return NOOP;
                };
                module1.exports = GetTileCornersFunction;
            /***/ },
            /***/ 39167: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var NOOP = __webpack_require__(29747);
                var TileToWorldX = __webpack_require__(97281);
                /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldXFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldXFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return TileToWorldX;
                    else return NOOP;
                };
                module1.exports = GetTileToWorldXFunction;
            /***/ },
            /***/ 62000: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var HexagonalTileToWorldXY = __webpack_require__(19951);
                var IsometricTileToWorldXY = __webpack_require__(14127);
                var NOOP = __webpack_require__(29747);
                var StaggeredTileToWorldXY = __webpack_require__(97202);
                var TileToWorldXY = __webpack_require__(70326);
                /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldXYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldXYFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return TileToWorldXY;
                    else if (orientation === CONST.ISOMETRIC) return IsometricTileToWorldXY;
                    else if (orientation === CONST.HEXAGONAL) return HexagonalTileToWorldXY;
                    else if (orientation === CONST.STAGGERED) return StaggeredTileToWorldXY;
                    else return NOOP;
                };
                module1.exports = GetTileToWorldXYFunction;
            /***/ },
            /***/ 5984: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var NOOP = __webpack_require__(29747);
                var StaggeredTileToWorldY = __webpack_require__(28054);
                var TileToWorldY = __webpack_require__(29650);
                /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldYFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return TileToWorldY;
                    else if (orientation === CONST.STAGGERED) return StaggeredTileToWorldY;
                    else return NOOP;
                };
                module1.exports = GetTileToWorldYFunction;
            /***/ },
            /***/ 7386: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                /**
 * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
 *
 * This returns an array with references to the Tile instances in, so be aware of
 * modifying them directly.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithin
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithin = function(tileX, tileY, width, height, filteringOptions, layer) {
                    if (tileX === undefined) tileX = 0;
                    if (tileY === undefined) tileY = 0;
                    if (width === undefined) width = layer.width;
                    if (height === undefined) height = layer.height;
                    if (!filteringOptions) filteringOptions = {};
                    var isNotEmpty = GetFastValue(filteringOptions, 'isNotEmpty', false);
                    var isColliding = GetFastValue(filteringOptions, 'isColliding', false);
                    var hasInterestingFace = GetFastValue(filteringOptions, 'hasInterestingFace', false);
                    // Clip x, y to top left of map, while shrinking width/height to match.
                    if (tileX < 0) {
                        width += tileX;
                        tileX = 0;
                    }
                    if (tileY < 0) {
                        height += tileY;
                        tileY = 0;
                    }
                    // Clip width and height to bottom right of map.
                    if (tileX + width > layer.width) width = Math.max(layer.width - tileX, 0);
                    if (tileY + height > layer.height) height = Math.max(layer.height - tileY, 0);
                    var results = [];
                    for(var ty = tileY; ty < tileY + height; ty++)for(var tx = tileX; tx < tileX + width; tx++){
                        var tile = layer.data[ty][tx];
                        if (tile !== null) {
                            if (isNotEmpty && tile.index === -1) continue;
                            if (isColliding && !tile.collides) continue;
                            if (hasInterestingFace && !tile.hasInterestingFace) continue;
                            results.push(tile);
                        }
                    }
                    return results;
                };
                module1.exports = GetTilesWithin;
            /***/ },
            /***/ 91141: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Geom = __webpack_require__(55738);
                var GetTilesWithin = __webpack_require__(7386);
                var Intersects = __webpack_require__(91865);
                var NOOP = __webpack_require__(29747);
                var Vector2 = __webpack_require__(26099);
                var CONST = __webpack_require__(91907);
                var TriangleToRectangle = function(triangle, rect) {
                    return Intersects.RectangleToTriangle(rect, triangle);
                };
                var point = new Vector2();
                var pointStart = new Vector2();
                var pointEnd = new Vector2();
                /**
 * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
 * Line, Rectangle or Triangle. The shape should be in world coordinates.
 * 
 * **Note:** This method currently only works with orthogonal tilemap layers.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithinShape
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithinShape = function(shape, filteringOptions, camera, layer) {
                    if (layer.orientation !== CONST.ORTHOGONAL) {
                        console.warn('GetTilesWithinShape only works with orthogonal tilemaps');
                        return [];
                    }
                    if (shape === undefined) return [];
                    // intersectTest is a function with parameters: shape, rect
                    var intersectTest = NOOP;
                    if (shape instanceof Geom.Circle) intersectTest = Intersects.CircleToRectangle;
                    else if (shape instanceof Geom.Rectangle) intersectTest = Intersects.RectangleToRectangle;
                    else if (shape instanceof Geom.Triangle) intersectTest = TriangleToRectangle;
                    else if (shape instanceof Geom.Line) intersectTest = Intersects.LineToRectangle;
                    // Top left corner of the shapes's bounding box, rounded down to include partial tiles
                    layer.tilemapLayer.worldToTileXY(shape.left, shape.top, true, pointStart, camera);
                    var xStart = pointStart.x;
                    var yStart = pointStart.y;
                    // Bottom right corner of the shapes's bounding box, rounded up to include partial tiles
                    layer.tilemapLayer.worldToTileXY(shape.right, shape.bottom, false, pointEnd, camera);
                    var xEnd = Math.ceil(pointEnd.x);
                    var yEnd = Math.ceil(pointEnd.y);
                    // Tiles within bounding rectangle of shape. Bounds are forced to be at least 1 x 1 tile in size
                    // to grab tiles for shapes that don't have a height or width (e.g. a horizontal line).
                    var width = Math.max(xEnd - xStart, 1);
                    var height = Math.max(yEnd - yStart, 1);
                    var tiles = GetTilesWithin(xStart, yStart, width, height, filteringOptions, layer);
                    var tileWidth = layer.tileWidth;
                    var tileHeight = layer.tileHeight;
                    if (layer.tilemapLayer) {
                        tileWidth *= layer.tilemapLayer.scaleX;
                        tileHeight *= layer.tilemapLayer.scaleY;
                    }
                    var results = [];
                    var tileRect = new Geom.Rectangle(0, 0, tileWidth, tileHeight);
                    for(var i = 0; i < tiles.length; i++){
                        var tile = tiles[i];
                        layer.tilemapLayer.tileToWorldXY(tile.x, tile.y, point, camera);
                        tileRect.x = point.x;
                        tileRect.y = point.y;
                        if (intersectTest(shape, tileRect)) results.push(tile);
                    }
                    return results;
                };
                module1.exports = GetTilesWithinShape;
            /***/ },
            /***/ 96523: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                var Vector2 = __webpack_require__(26099);
                var pointStart = new Vector2();
                var pointEnd = new Vector2();
                /**
 * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithinWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The world x coordinate for the top-left of the area.
 * @param {number} worldY - The world y coordinate for the top-left of the area.
 * @param {number} width - The width of the area.
 * @param {number} height - The height of the area.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when factoring in which tiles to return.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithinWorldXY = function(worldX, worldY, width, height, filteringOptions, camera, layer) {
                    var worldToTileXY = layer.tilemapLayer.tilemap._convert.WorldToTileXY;
                    //  Top left corner of the rect, rounded down to include partial tiles
                    worldToTileXY(worldX, worldY, true, pointStart, camera, layer);
                    var xStart = pointStart.x;
                    var yStart = pointStart.y;
                    //  Bottom right corner of the rect, rounded up to include partial tiles
                    worldToTileXY(worldX + width, worldY + height, false, pointEnd, camera, layer);
                    var xEnd = Math.ceil(pointEnd.x);
                    var yEnd = Math.ceil(pointEnd.y);
                    return GetTilesWithin(xStart, yStart, xEnd - xStart, yEnd - yStart, filteringOptions, layer);
                };
                module1.exports = GetTilesWithinWorldXY;
            /***/ },
            /***/ 96113: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var NULL = __webpack_require__(20242);
                var WorldToTileX = __webpack_require__(10095);
                /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * Only orthogonal maps support this feature.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileXFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileXFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return WorldToTileX;
                    else return NULL;
                };
                module1.exports = GetWorldToTileXFunction;
            /***/ },
            /***/ 16926: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var HexagonalWorldToTileXY = __webpack_require__(86625);
                var IsometricWorldToTileXY = __webpack_require__(96897);
                var NOOP = __webpack_require__(29747);
                var StaggeredWorldToTileXY = __webpack_require__(15108);
                var WorldToTileXY = __webpack_require__(85896);
                /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileXYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileXYFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return WorldToTileXY;
                    else if (orientation === CONST.ISOMETRIC) return IsometricWorldToTileXY;
                    else if (orientation === CONST.HEXAGONAL) return HexagonalWorldToTileXY;
                    else if (orientation === CONST.STAGGERED) return StaggeredWorldToTileXY;
                    else return NOOP;
                };
                module1.exports = GetWorldToTileXYFunction;
            /***/ },
            /***/ 55762: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                var NULL = __webpack_require__(20242);
                var StaggeredWorldToTileY = __webpack_require__(51900);
                var WorldToTileY = __webpack_require__(63288);
                /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileYFunction = function(orientation) {
                    if (orientation === CONST.ORTHOGONAL) return WorldToTileY;
                    else if (orientation === CONST.STAGGERED) return StaggeredWorldToTileY;
                    else return NULL;
                };
                module1.exports = GetWorldToTileYFunction;
            /***/ },
            /***/ 45091: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsInLayerBounds = __webpack_require__(62991);
                /**
 * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
 * false if there is no tile or if the tile at that location has an index of -1.
 *
 * @function Phaser.Tilemaps.Components.HasTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
 * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
 */ var HasTileAt = function(tileX, tileY, layer) {
                    if (IsInLayerBounds(tileX, tileY, layer)) {
                        var tile = layer.data[tileY][tileX];
                        return tile !== null && tile.index > -1;
                    } else return false;
                };
                module1.exports = HasTileAt;
            /***/ },
            /***/ 24152: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HasTileAt = __webpack_require__(45091);
                var Vector2 = __webpack_require__(26099);
                var point = new Vector2();
                /**
 * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
 * false if there is no tile or if the tile at that location has an index of -1.
 *
 * @function Phaser.Tilemaps.Components.HasTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The X coordinate of the world position.
 * @param {number} worldY - The Y coordinate of the world position.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when factoring in which tiles to return.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
 */ var HasTileAtWorldXY = function(worldX, worldY, camera, layer) {
                    layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera);
                    var tileX = point.x;
                    var tileY = point.y;
                    return HasTileAt(tileX, tileY, layer);
                };
                module1.exports = HasTileAtWorldXY;
            /***/ },
            /***/ 90454: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SnapCeil = __webpack_require__(63448);
                var SnapFloor = __webpack_require__(56583);
                /**
 * Returns the bounds in the given layer that are within the camera's viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.HexagonalCullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {object} An object containing the `left`, `right`, `top` and `bottom` bounds.
 */ var HexagonalCullBounds = function(layer, camera) {
                    var tilemap = layer.tilemapLayer.tilemap;
                    var tilemapLayer = layer.tilemapLayer;
                    //  We need to use the tile sizes defined for the map as a whole, not the layer,
                    //  in order to calculate the bounds correctly. As different sized tiles may be
                    //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                    var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                    var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                    var len = layer.hexSideLength;
                    var boundsLeft;
                    var boundsRight;
                    var boundsTop;
                    var boundsBottom;
                    if (layer.staggerAxis === 'y') {
                        var rowH = (tileH - len) / 2 + len;
                        boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                        boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                        boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, rowH, 0, true) - tilemapLayer.cullPaddingY;
                        boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, rowH, 0, true) + tilemapLayer.cullPaddingY;
                    } else {
                        var rowW = (tileW - len) / 2 + len;
                        boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, rowW, 0, true) - tilemapLayer.cullPaddingX;
                        boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, rowW, 0, true) + tilemapLayer.cullPaddingX;
                        boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, tileH, 0, true) - tilemapLayer.cullPaddingY;
                        boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, tileH, 0, true) + tilemapLayer.cullPaddingY;
                    }
                    return {
                        left: boundsLeft,
                        right: boundsRight,
                        top: boundsTop,
                        bottom: boundsBottom
                    };
                };
                module1.exports = HexagonalCullBounds;
            /***/ },
            /***/ 9474: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(90454);
                var RunCull = __webpack_require__(32483);
                /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.HexagonalCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var HexagonalCullTiles = function(layer, camera, outputArray, renderOrder) {
                    if (outputArray === undefined) outputArray = [];
                    if (renderOrder === undefined) renderOrder = 0;
                    outputArray.length = 0;
                    var tilemapLayer = layer.tilemapLayer;
                    //  Camera world view bounds, snapped for scaled tile size
                    //  Cull Padding values are given in tiles, not pixels
                    var bounds = CullBounds(layer, camera);
                    if (tilemapLayer.skipCull && tilemapLayer.scrollFactorX === 1 && tilemapLayer.scrollFactorY === 1) {
                        bounds.left = 0;
                        bounds.right = layer.width;
                        bounds.top = 0;
                        bounds.bottom = layer.height;
                    }
                    RunCull(layer, bounds, renderOrder, outputArray);
                    return outputArray;
                };
                module1.exports = HexagonalCullTiles;
            /***/ },
            /***/ 27229: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HexagonalTileToWorldXY = __webpack_require__(19951);
                var Vector2 = __webpack_require__(26099);
                var tempVec = new Vector2();
                /**
 * Gets the corners of the Hexagonal Tile as an array of Vector2s.
 *
 * @function Phaser.Tilemaps.Components.HexagonalGetTileCorners
 * @since 3.60.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2[]} An array of Vector2s corresponding to the world XY location of each tile corner.
 */ var HexagonalGetTileCorners = function(tileX, tileY, camera, layer) {
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    if (tilemapLayer) {
                        tileWidth *= tilemapLayer.scaleX;
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    //  Sets the center of the tile into tempVec
                    var center = HexagonalTileToWorldXY(tileX, tileY, tempVec, camera, layer);
                    var corners = [];
                    //  Hard-coded orientation values for Pointy-Top Hexagons only
                    var b0 = 0.5773502691896257; // Math.sqrt(3) / 3
                    var hexWidth;
                    var hexHeight;
                    if (layer.staggerAxis === 'y') {
                        hexWidth = b0 * tileWidth;
                        hexHeight = tileHeight / 2;
                    } else {
                        hexWidth = tileWidth / 2;
                        hexHeight = b0 * tileHeight;
                    }
                    for(var i = 0; i < 6; i++){
                        var angle = 2 * Math.PI * (0.5 - i) / 6;
                        corners.push(new Vector2(center.x + hexWidth * Math.cos(angle), center.y + hexHeight * Math.sin(angle)));
                    }
                    return corners;
                };
                module1.exports = HexagonalGetTileCorners;
            /***/ },
            /***/ 19951: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Converts from hexagonal tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.HexagonalTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var HexagonalTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                    if (!point) point = new Vector2();
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    var worldX = 0;
                    var worldY = 0;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        worldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                        worldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                        tileWidth *= tilemapLayer.scaleX;
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    //  Hard-coded orientation values for Pointy-Top Hexagons only
                    //  origin
                    var tileWidthHalf = tileWidth / 2;
                    var tileHeightHalf = tileHeight / 2;
                    var x;
                    var y;
                    var staggerAxis = layer.staggerAxis;
                    var staggerIndex = layer.staggerIndex;
                    if (staggerAxis === 'y') {
                        x = worldX + tileWidth * tileX + tileWidth;
                        y = worldY + 1.5 * tileY * tileHeightHalf + tileHeightHalf;
                        if (tileY % 2 === 0) {
                            if (staggerIndex === 'odd') x -= tileWidthHalf;
                            else x += tileWidthHalf;
                        }
                    } else if (staggerAxis === 'x' && staggerIndex === 'odd') {
                        x = worldX + 1.5 * tileX * tileWidthHalf + tileWidthHalf;
                        y = worldY + tileHeight * tileX + tileHeight;
                        if (tileX % 2 === 0) {
                            if (staggerIndex === 'odd') y -= tileHeightHalf;
                            else y += tileHeightHalf;
                        }
                    }
                    return point.set(x, y);
                };
                module1.exports = HexagonalTileToWorldXY;
            /***/ },
            /***/ 86625: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Converts from world XY coordinates (pixels) to hexagonal tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.HexagonalWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinates down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var HexagonalWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                    if (!point) point = new Vector2();
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        // Find the world position relative to the static or dynamic layer's top left origin,
                        // factoring in the camera's vertical scroll
                        worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                        worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                        tileWidth *= tilemapLayer.scaleX;
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    //  Hard-coded orientation values for Pointy-Top Hexagons only
                    var b0 = 0.5773502691896257; // Math.sqrt(3) / 3
                    var b1 = -0.3333333333333333; // -1 / 3
                    var b2 = 0;
                    var b3 = 0.6666666666666666; // 2 / 3
                    //  origin
                    var tileWidthHalf = tileWidth / 2;
                    var tileHeightHalf = tileHeight / 2;
                    var px;
                    var py;
                    var q;
                    var r;
                    var s;
                    //  size
                    if (layer.staggerAxis === 'y') {
                        //  x = b0 * tileWidth
                        //  y = tileHeightHalf
                        px = (worldX - tileWidthHalf) / (b0 * tileWidth);
                        py = (worldY - tileHeightHalf) / tileHeightHalf;
                        q = b0 * px + b1 * py;
                        r = b2 * px + b3 * py;
                    } else {
                        //  x = tileWidthHalf
                        //  y = b0 * tileHeight
                        px = (worldX - tileWidthHalf) / tileWidthHalf;
                        py = (worldY - tileHeightHalf) / (b0 * tileHeight);
                        q = b1 * px + b0 * py;
                        r = b3 * px + b2 * py;
                    }
                    s = -q - r;
                    var qi = Math.round(q);
                    var ri = Math.round(r);
                    var si = Math.round(s);
                    var qDiff = Math.abs(qi - q);
                    var rDiff = Math.abs(ri - r);
                    var sDiff = Math.abs(si - s);
                    if (qDiff > rDiff && qDiff > sDiff) qi = -ri - si;
                    else if (rDiff > sDiff) ri = -qi - si;
                    var x;
                    var y = ri;
                    if (layer.staggerIndex === 'odd') x = y % 2 === 0 ? ri / 2 + qi : ri / 2 + qi - 0.5;
                    else x = y % 2 === 0 ? ri / 2 + qi : ri / 2 + qi + 0.5;
                    return point.set(x, y);
                };
                module1.exports = HexagonalWorldToTileXY;
            /***/ },
            /***/ 62991: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the given tile coordinates are within the bounds of the layer.
 *
 * @function Phaser.Tilemaps.Components.IsInLayerBounds
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {boolean} `true` if the tile coordinates are within the bounds of the layer, otherwise `false`.
 */ var IsInLayerBounds = function(tileX, tileY, layer) {
                    return tileX >= 0 && tileX < layer.width && tileY >= 0 && tileY < layer.height;
                };
                module1.exports = IsInLayerBounds;
            /***/ },
            /***/ 14018: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CheckIsoBounds = __webpack_require__(33528);
                /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.IsometricCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var IsometricCullTiles = function(layer, camera, outputArray, renderOrder) {
                    if (outputArray === undefined) outputArray = [];
                    if (renderOrder === undefined) renderOrder = 0;
                    outputArray.length = 0;
                    var tilemapLayer = layer.tilemapLayer;
                    var mapData = layer.data;
                    var mapWidth = layer.width;
                    var mapHeight = layer.height;
                    var skipCull = tilemapLayer.skipCull;
                    var drawLeft = 0;
                    var drawRight = mapWidth;
                    var drawTop = 0;
                    var drawBottom = mapHeight;
                    var x;
                    var y;
                    var tile;
                    if (renderOrder === 0) {
                        //  right-down
                        for(y = drawTop; y < drawBottom; y++)for(x = drawLeft; x < drawRight; x++){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            if (!skipCull && !CheckIsoBounds(x, y, layer, camera)) continue;
                            outputArray.push(tile);
                        }
                    } else if (renderOrder === 1) {
                        //  left-down
                        for(y = drawTop; y < drawBottom; y++)for(x = drawRight; x >= drawLeft; x--){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            if (!skipCull && !CheckIsoBounds(x, y, layer, camera)) continue;
                            outputArray.push(tile);
                        }
                    } else if (renderOrder === 2) {
                        //  right-up
                        for(y = drawBottom; y >= drawTop; y--)for(x = drawLeft; x < drawRight; x++){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            if (!skipCull && !CheckIsoBounds(x, y, layer, camera)) continue;
                            outputArray.push(tile);
                        }
                    } else if (renderOrder === 3) {
                        //  left-up
                        for(y = drawBottom; y >= drawTop; y--)for(x = drawRight; x >= drawLeft; x--){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            if (!skipCull && !CheckIsoBounds(x, y, layer, camera)) continue;
                            outputArray.push(tile);
                        }
                    }
                    tilemapLayer.tilesDrawn = outputArray.length;
                    tilemapLayer.tilesTotal = mapWidth * mapHeight;
                    return outputArray;
                };
                module1.exports = IsometricCullTiles;
            /***/ },
            /***/ 14127: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Converts from isometric tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.IsometricTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var IsometricTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                    if (!point) point = new Vector2();
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    var layerWorldX = 0;
                    var layerWorldY = 0;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                        tileWidth *= tilemapLayer.scaleX;
                        layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    var x = layerWorldX + (tileX - tileY) * (tileWidth / 2);
                    var y = layerWorldY + (tileX + tileY) * (tileHeight / 2);
                    return point.set(x, y);
                };
                module1.exports = IsometricTileToWorldXY;
            /***/ },
            /***/ 96897: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Converts from world XY coordinates (pixels) to isometric tile XY coordinates (tile units), factoring in the
 * layers position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.IsometricWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {boolean} [originTop=true] - Which is the active face of the isometric tile? The top (default, true), or the base? (false)
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var IsometricWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer, originTop) {
                    if (!point) point = new Vector2();
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        // Find the world position relative to the static or dynamic layer's top left origin,
                        // factoring in the camera's vertical scroll
                        worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                        tileHeight *= tilemapLayer.scaleY;
                        // Find the world position relative to the static or dynamic layer's top left origin,
                        // factoring in the camera's horizontal scroll
                        worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                        tileWidth *= tilemapLayer.scaleX;
                    }
                    var tileWidthHalf = tileWidth / 2;
                    var tileHeightHalf = tileHeight / 2;
                    worldX = worldX - tileWidthHalf;
                    if (!originTop) worldY = worldY - tileHeight;
                    var x = 0.5 * (worldX / tileWidthHalf + worldY / tileHeightHalf);
                    var y = 0.5 * (-worldX / tileWidthHalf + worldY / tileHeightHalf);
                    if (snapToFloor) {
                        x = Math.floor(x);
                        y = Math.floor(y);
                    }
                    return point.set(x, y);
                };
                module1.exports = IsometricWorldToTileXY;
            /***/ },
            /***/ 71558: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tile = __webpack_require__(23029);
                var IsInLayerBounds = __webpack_require__(62991);
                var CalculateFacesAt = __webpack_require__(72023);
                var SetTileCollision = __webpack_require__(20576);
                /**
 * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
 * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
 * location. If you pass in an index, only the index at the specified location will be changed.
 * Collision information will be recalculated at the specified location.
 *
 * @function Phaser.Tilemaps.Components.PutTileAt
 * @since 3.0.0
 *
 * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
 */ var PutTileAt = function(tile, tileX, tileY, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (!IsInLayerBounds(tileX, tileY, layer)) return null;
                    var index;
                    var oldTile = layer.data[tileY][tileX];
                    var oldTileCollides = oldTile && oldTile.collides;
                    if (tile instanceof Tile) {
                        if (layer.data[tileY][tileX] === null) layer.data[tileY][tileX] = new Tile(layer, tile.index, tileX, tileY, layer.tileWidth, layer.tileHeight);
                        layer.data[tileY][tileX].copy(tile);
                    } else {
                        index = tile;
                        if (layer.data[tileY][tileX] === null) layer.data[tileY][tileX] = new Tile(layer, index, tileX, tileY, layer.tileWidth, layer.tileHeight);
                        else layer.data[tileY][tileX].index = index;
                    }
                    // Updating colliding flag on the new tile
                    var newTile = layer.data[tileY][tileX];
                    var collides = layer.collideIndexes.indexOf(newTile.index) !== -1;
                    index = tile instanceof Tile ? tile.index : tile;
                    if (index === -1) {
                        newTile.width = layer.tileWidth;
                        newTile.height = layer.tileHeight;
                    } else {
                        var tilemap = layer.tilemapLayer.tilemap;
                        var tiles = tilemap.tiles;
                        var sid = tiles[index][2];
                        var set = tilemap.tilesets[sid];
                        newTile.width = set.tileWidth;
                        newTile.height = set.tileHeight;
                    }
                    SetTileCollision(newTile, collides);
                    // Recalculate faces only if the colliding flag at (tileX, tileY) has changed
                    if (recalculateFaces && oldTileCollides !== newTile.collides) CalculateFacesAt(tileX, tileY, layer);
                    return newTile;
                };
                module1.exports = PutTileAt;
            /***/ },
            /***/ 26303: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PutTileAt = __webpack_require__(71558);
                var Vector2 = __webpack_require__(26099);
                var point = new Vector2();
                /**
 * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
 * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
 * specified location. If you pass in an index, only the index at the specified location will be
 * changed. Collision information will be recalculated at the specified location.
 *
 * @function Phaser.Tilemaps.Components.PutTileAtWorldXY
 * @since 3.0.0
 *
 * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
 * @param {number} worldX - The x coordinate, in pixels.
 * @param {number} worldY - The y coordinate, in pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
 */ var PutTileAtWorldXY = function(tile, worldX, worldY, recalculateFaces, camera, layer) {
                    layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera, layer);
                    return PutTileAt(tile, point.x, point.y, recalculateFaces, layer);
                };
                module1.exports = PutTileAtWorldXY;
            /***/ },
            /***/ 14051: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CalculateFacesWithin = __webpack_require__(42573);
                var PutTileAt = __webpack_require__(71558);
                /**
 * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
 * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
 * all attributes will be copied over to the specified location. If you pass in an index, only the
 * index at the specified location will be changed. Collision information will be recalculated
 * within the region tiles were changed.
 *
 * @function Phaser.Tilemaps.Components.PutTilesAt
 * @since 3.0.0
 *
 * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var PutTilesAt = function(tilesArray, tileX, tileY, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (!Array.isArray(tilesArray)) return null;
                    // Force the input array to be a 2D array
                    if (!Array.isArray(tilesArray[0])) tilesArray = [
                        tilesArray
                    ];
                    var height = tilesArray.length;
                    var width = tilesArray[0].length;
                    for(var ty = 0; ty < height; ty++)for(var tx = 0; tx < width; tx++){
                        var tile = tilesArray[ty][tx];
                        PutTileAt(tile, tileX + tx, tileY + ty, false, layer);
                    }
                    if (recalculateFaces) // Recalculate the faces within the destination area and neighboring tiles
                    CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
                };
                module1.exports = PutTilesAt;
            /***/ },
            /***/ 77389: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                var GetRandom = __webpack_require__(26546);
                /**
 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
 * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
 * those will be used for randomly assigning new tile indexes. If an array is not provided, the
 * indexes found within the region (excluding -1) will be used for randomly assigning new tile
 * indexes. This method only modifies tile indexes and does not change collision information.
 *
 * @function Phaser.Tilemaps.Components.Randomize
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {number[]} indexes - An array of indexes to randomly draw from during randomization.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Randomize = function(tileX, tileY, width, height, indexes, layer) {
                    var i;
                    var tiles = GetTilesWithin(tileX, tileY, width, height, {}, layer);
                    // If no indices are given, then find all the unique indexes within the specified region
                    if (!indexes) {
                        indexes = [];
                        for(i = 0; i < tiles.length; i++)if (indexes.indexOf(tiles[i].index) === -1) indexes.push(tiles[i].index);
                    }
                    for(i = 0; i < tiles.length; i++)tiles[i].index = GetRandom(indexes);
                };
                module1.exports = Randomize;
            /***/ },
            /***/ 63557: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tile = __webpack_require__(23029);
                var IsInLayerBounds = __webpack_require__(62991);
                var CalculateFacesAt = __webpack_require__(72023);
                /**
 * Removes the tile at the given tile coordinates in the specified layer and updates the layer's
 * collision information.
 *
 * @function Phaser.Tilemaps.Components.RemoveTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate.
 * @param {number} tileY - The y coordinate.
 * @param {boolean} replaceWithNull - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
 */ var RemoveTileAt = function(tileX, tileY, replaceWithNull, recalculateFaces, layer) {
                    if (replaceWithNull === undefined) replaceWithNull = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (!IsInLayerBounds(tileX, tileY, layer)) return null;
                    var tile = layer.data[tileY][tileX];
                    if (!tile) return null;
                    else layer.data[tileY][tileX] = replaceWithNull ? null : new Tile(layer, -1, tileX, tileY, layer.tileWidth, layer.tileHeight);
                    //  Recalculate faces only if the removed tile was a colliding tile
                    if (recalculateFaces && tile && tile.collides) CalculateFacesAt(tileX, tileY, layer);
                    return tile;
                };
                module1.exports = RemoveTileAt;
            /***/ },
            /***/ 94178: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RemoveTileAt = __webpack_require__(63557);
                var Vector2 = __webpack_require__(26099);
                var point = new Vector2();
                /**
 * Removes the tile at the given world coordinates in the specified layer and updates the layer's
 * collision information.
 *
 * @function Phaser.Tilemaps.Components.RemoveTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate, in pixels.
 * @param {number} worldY - The y coordinate, in pixels.
 * @param {boolean} replaceWithNull - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
 */ var RemoveTileAtWorldXY = function(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer) {
                    layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera, layer);
                    return RemoveTileAt(point.x, point.y, replaceWithNull, recalculateFaces, layer);
                };
                module1.exports = RemoveTileAtWorldXY;
            /***/ },
            /***/ 15533: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                var Color = __webpack_require__(3956);
                var defaultTileColor = new Color(105, 210, 231, 150);
                var defaultCollidingTileColor = new Color(243, 134, 48, 200);
                var defaultFaceColor = new Color(40, 39, 37, 150);
                /**
 * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
 * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
 * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
 * wherever you want on the screen.
 *
 * @function Phaser.Tilemaps.Components.RenderDebug
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
 * @param {Phaser.Types.Tilemaps.DebugStyleOptions} styleConfig - An object specifying the colors to use for the debug drawing.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var RenderDebug = function(graphics, styleConfig, layer) {
                    if (styleConfig === undefined) styleConfig = {};
                    // Default colors without needlessly creating Color objects
                    var tileColor = styleConfig.tileColor !== undefined ? styleConfig.tileColor : defaultTileColor;
                    var collidingTileColor = styleConfig.collidingTileColor !== undefined ? styleConfig.collidingTileColor : defaultCollidingTileColor;
                    var faceColor = styleConfig.faceColor !== undefined ? styleConfig.faceColor : defaultFaceColor;
                    var tiles = GetTilesWithin(0, 0, layer.width, layer.height, null, layer);
                    graphics.translateCanvas(layer.tilemapLayer.x, layer.tilemapLayer.y);
                    graphics.scaleCanvas(layer.tilemapLayer.scaleX, layer.tilemapLayer.scaleY);
                    for(var i = 0; i < tiles.length; i++){
                        var tile = tiles[i];
                        var offset = tile.tileset ? tile.tileset.tileOffset : {
                            x: 0,
                            y: 0
                        };
                        var tw = tile.width;
                        var th = tile.height;
                        var x = tile.pixelX - offset.x;
                        var y = tile.pixelY - offset.y;
                        var color = tile.collides ? collidingTileColor : tileColor;
                        if (color !== null) {
                            graphics.fillStyle(color.color, color.alpha / 255);
                            graphics.fillRect(x, y, tw, th);
                        }
                        // Inset the face line to prevent neighboring tile's lines from overlapping
                        x += 1;
                        y += 1;
                        tw -= 2;
                        th -= 2;
                        if (faceColor !== null) {
                            graphics.lineStyle(1, faceColor.color, faceColor.alpha / 255);
                            if (tile.faceTop) graphics.lineBetween(x, y, x + tw, y);
                            if (tile.faceRight) graphics.lineBetween(x + tw, y, x + tw, y + th);
                            if (tile.faceBottom) graphics.lineBetween(x, y + th, x + tw, y + th);
                            if (tile.faceLeft) graphics.lineBetween(x, y, x, y + th);
                        }
                    }
                };
                module1.exports = RenderDebug;
            /**

function Orientation(f0, f1, f2, f3, b0, b1, b2, b3, start_angle) {
    return {f0: f0, f1: f1, f2: f2, f3: f3, b0: b0, b1: b1, b2: b2, b3: b3, start_angle: start_angle};
}

function Layout(orientation, size, origin) {
    return {orientation: orientation, size: size, origin: origin};
}

function Hex(q, r, s) {
    return {q: q, r: r, s: s};
}

function hex_round(h)
{
    var qi = Math.round(h.q);
    var ri = Math.round(h.r);
    var si = Math.round(h.s);
    var q_diff = Math.abs(qi - h.q);
    var r_diff = Math.abs(ri - h.r);
    var s_diff = Math.abs(si - h.s);
    if (q_diff > r_diff && q_diff > s_diff)
    {
        qi = -ri - si;
    }
    else
        if (r_diff > s_diff)
        {
            ri = -qi - si;
        }
        else
        {
            si = -qi - ri;
        }
    return Hex(qi, ri, si);
}

var layout_pointy = Orientation(Math.sqrt(3.0), Math.sqrt(3.0) / 2.0, 0.0, 3.0 / 2.0, Math.sqrt(3.0) / 3.0, -1.0 / 3.0, 0.0, 2.0 / 3.0, 0.5);

function OffsetCoord(col, row) {
    return {col: col, row: row};
}

var EVEN = 1;
var ODD = -1;

function roffset_from_cube(offset, h)
{
    var col = h.q + (h.r + offset * (h.r & 1)) / 2;
    var row = h.r;
    return OffsetCoord(col, row);
}

function roffset_to_cube(offset, h)
{
    var q = h.col - (h.row + offset * (h.row & 1)) / 2;
    var r = h.row;
    var s = -q - r;
    return Hex(q, r, s);
}

function hex_to_pixel(layout, h)
{
    var M = layout.orientation;
    var size = layout.size;
    var origin = layout.origin;
    var x = (M.f0 * h.q + M.f1 * h.r) * size.x;
    var y = (M.f2 * h.q + M.f3 * h.r) * size.y;
    return new Vector2(x + origin.x, y + origin.y);
}

function hex_corner_offset(layout, corner)
{
    var M = layout.orientation;
    var size = layout.size;
    var angle = 2.0 * Math.PI * (M.start_angle - corner) / 6.0;
    return new Vector2(size.x * Math.cos(angle), size.y * Math.sin(angle));
}

function polygon_corners(layout, h)
{
    var corners = [];
    var center = hex_to_pixel(layout, h);
    for (var i = 0; i < 6; i++)
    {
        var offset = hex_corner_offset(layout, i);
        corners.push(new Vector2(center.x + offset.x, center.y + offset.y));
    }
    return corners;
}

var layout = Layout(layout_pointy, new Vector2(tileHeight/2, tileWidth/2), new Vector2(tileWidth/2, tileWidth/2));

for (var q = 0; q <= 9; q++)
{
    for (var r = 0; r <= 9; r++)
    {
        var h = Hex(q, r, -q - r); // cubed
        // var hr = hex_round(h);
        // var o = roffset_from_cube(ODD, hr);
        // var b = roffset_to_cube(ODD, o);

        var c = polygon_corners(layout, h);

        if (q === 0 && r === 0)
        {
            console.log(c);
        }

        g.beginPath();
        g.moveTo(Math.floor(c[0].x), Math.floor(c[0].y));

        for (var i = 1; i < c.length; i++)
        {
            g.lineTo(Math.floor(c[i].x), Math.floor(c[i].y));
        }

        g.closePath();
        g.strokePath();
    }
}

            var c = polygon_corners(layout, hr);

            g.beginPath();
            g.moveTo(Math.floor(c[0].x), Math.floor(c[0].y));

            for (var i = 1; i < c.length; i++)
            {
                g.lineTo(Math.floor(c[i].x), Math.floor(c[i].y));
            }

            g.closePath();
            g.fillPath();

            // g.scene.add.text(c[3].x + 2, c[3].y + 6, `${hr.q} x ${hr.r}`);
            g.scene.add.text(c[3].x + 2, c[3].y + 6, `${x} x ${y}`);


*/ /***/ },
            /***/ 27987: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                /**
 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
 * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
 * not change collision information.
 *
 * @function Phaser.Tilemaps.Components.ReplaceByIndex
 * @since 3.0.0
 *
 * @param {number} findIndex - The index of the tile to search for.
 * @param {number} newIndex - The index of the tile to replace it with.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var ReplaceByIndex = function(findIndex, newIndex, tileX, tileY, width, height, layer) {
                    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                    for(var i = 0; i < tiles.length; i++)if (tiles[i] && tiles[i].index === findIndex) tiles[i].index = newIndex;
                };
                module1.exports = ReplaceByIndex;
            /***/ },
            /***/ 32483: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.RunCull
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {object} bounds - An object containing the `left`, `right`, `top` and `bottom` bounds.
 * @param {number} renderOrder - The rendering order constant.
 * @param {array} outputArray - The array to store the Tile objects within.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var RunCull = function(layer, bounds, renderOrder, outputArray) {
                    var mapData = layer.data;
                    var mapWidth = layer.width;
                    var mapHeight = layer.height;
                    var tilemapLayer = layer.tilemapLayer;
                    var drawLeft = Math.max(0, bounds.left);
                    var drawRight = Math.min(mapWidth, bounds.right);
                    var drawTop = Math.max(0, bounds.top);
                    var drawBottom = Math.min(mapHeight, bounds.bottom);
                    var x;
                    var y;
                    var tile;
                    if (renderOrder === 0) {
                        //  right-down
                        for(y = drawTop; y < drawBottom; y++)for(x = drawLeft; mapData[y] && x < drawRight; x++){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    } else if (renderOrder === 1) {
                        //  left-down
                        for(y = drawTop; y < drawBottom; y++)for(x = drawRight; mapData[y] && x >= drawLeft; x--){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    } else if (renderOrder === 2) {
                        //  right-up
                        for(y = drawBottom; y >= drawTop; y--)for(x = drawLeft; mapData[y] && x < drawRight; x++){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    } else if (renderOrder === 3) {
                        //  left-up
                        for(y = drawBottom; y >= drawTop; y--)for(x = drawRight; mapData[y] && x >= drawLeft; x--){
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                    tilemapLayer.tilesDrawn = outputArray.length;
                    tilemapLayer.tilesTotal = mapWidth * mapHeight;
                    return outputArray;
                };
                module1.exports = RunCull;
            /***/ },
            /***/ 57068: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(20576);
                var CalculateFacesWithin = __webpack_require__(42573);
                var SetLayerCollisionIndex = __webpack_require__(9589);
                /**
 * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
 * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
 * collision will be enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollision
 * @since 3.0.0
 *
 * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
 */ var SetCollision = function(indexes, collides, recalculateFaces, layer, updateLayer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (updateLayer === undefined) updateLayer = true;
                    if (!Array.isArray(indexes)) indexes = [
                        indexes
                    ];
                    // Update the array of colliding indexes
                    for(var i = 0; i < indexes.length; i++)SetLayerCollisionIndex(indexes[i], collides, layer);
                    // Update the tiles
                    if (updateLayer) {
                        for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                            var tile = layer.data[ty][tx];
                            if (tile && indexes.indexOf(tile.index) !== -1) SetTileCollision(tile, collides);
                        }
                    }
                    if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
                };
                module1.exports = SetCollision;
            /***/ },
            /***/ 37266: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(20576);
                var CalculateFacesWithin = __webpack_require__(42573);
                var SetLayerCollisionIndex = __webpack_require__(9589);
                /**
 * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
 * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
 * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
 * enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollisionBetween
 * @since 3.0.0
 *
 * @param {number} start - The first index of the tile to be set for collision.
 * @param {number} stop - The last index of the tile to be set for collision.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
 */ var SetCollisionBetween = function(start, stop, collides, recalculateFaces, layer, updateLayer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (updateLayer === undefined) updateLayer = true;
                    if (start > stop) return;
                    //  Update the array of colliding indexes
                    for(var index = start; index <= stop; index++)SetLayerCollisionIndex(index, collides, layer);
                    //  Update the tiles
                    if (updateLayer) {
                        for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                            var tile = layer.data[ty][tx];
                            if (tile) {
                                if (tile.index >= start && tile.index <= stop) SetTileCollision(tile, collides);
                            }
                        }
                    }
                    if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
                };
                module1.exports = SetCollisionBetween;
            /***/ },
            /***/ 75661: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(20576);
                var CalculateFacesWithin = __webpack_require__(42573);
                var SetLayerCollisionIndex = __webpack_require__(9589);
                /**
 * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
 * the given array. The `collides` parameter controls if collision will be enabled (true) or
 * disabled (false). Tile indexes not currently in the layer are not affected.
 *
 * @function Phaser.Tilemaps.Components.SetCollisionByExclusion
 * @since 3.0.0
 *
 * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionByExclusion = function(indexes, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (!Array.isArray(indexes)) indexes = [
                        indexes
                    ];
                    // Note: this only updates layer.collideIndexes for tile indexes found currently in the layer
                    for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                        var tile = layer.data[ty][tx];
                        if (tile && indexes.indexOf(tile.index) === -1) {
                            SetTileCollision(tile, collides);
                            SetLayerCollisionIndex(tile.index, collides, layer);
                        }
                    }
                    if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
                };
                module1.exports = SetCollisionByExclusion;
            /***/ },
            /***/ 64740: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(20576);
                var CalculateFacesWithin = __webpack_require__(42573);
                var HasValue = __webpack_require__(97022);
                /**
 * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
 * that matches the given properties object, its collision flag will be set. The `collides`
 * parameter controls if collision will be enabled (true) or disabled (false). Passing in
 * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
 * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
 * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
 * "types" property that matches any of those values, its collision flag will be updated.
 *
 * @function Phaser.Tilemaps.Components.SetCollisionByProperty
 * @since 3.0.0
 *
 * @param {object} properties - An object with tile properties and corresponding values that should be checked.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionByProperty = function(properties, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                        var tile = layer.data[ty][tx];
                        if (!tile) continue;
                        for(var property in properties){
                            if (!HasValue(tile.properties, property)) continue;
                            var values = properties[property];
                            if (!Array.isArray(values)) values = [
                                values
                            ];
                            for(var i = 0; i < values.length; i++)if (tile.properties[property] === values[i]) SetTileCollision(tile, collides);
                        }
                    }
                    if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
                };
                module1.exports = SetCollisionByProperty;
            /***/ },
            /***/ 63307: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(20576);
                var CalculateFacesWithin = __webpack_require__(42573);
                /**
 * Sets collision on the tiles within a layer by checking each tile's collision group data
 * (typically defined in Tiled within the tileset collision editor). If any objects are found within
 * a tile's collision group, the tile's colliding information will be set. The `collides` parameter
 * controls if collision will be enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollisionFromCollisionGroup
 * @since 3.0.0
 *
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionFromCollisionGroup = function(collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                        var tile = layer.data[ty][tx];
                        if (!tile) continue;
                        var collisionGroup = tile.getCollisionGroup();
                        // It's possible in Tiled to have a collision group without any shapes, e.g. create a
                        // shape and then delete the shape.
                        if (collisionGroup && collisionGroup.objects && collisionGroup.objects.length > 0) SetTileCollision(tile, collides);
                    }
                    if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
                };
                module1.exports = SetCollisionFromCollisionGroup;
            /***/ },
            /***/ 9589: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internally used method to keep track of the tile indexes that collide within a layer. This
 * updates LayerData.collideIndexes to either contain or not contain the given `tileIndex`.
 *
 * @function Phaser.Tilemaps.Components.SetLayerCollisionIndex
 * @since 3.0.0
 *
 * @param {number} tileIndex - The tile index to set the collision boolean for.
 * @param {boolean} collides - Should the tile index collide or not?
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetLayerCollisionIndex = function(tileIndex, collides, layer) {
                    var loc = layer.collideIndexes.indexOf(tileIndex);
                    if (collides && loc === -1) layer.collideIndexes.push(tileIndex);
                    else if (!collides && loc !== -1) layer.collideIndexes.splice(loc, 1);
                };
                module1.exports = SetLayerCollisionIndex;
            /***/ },
            /***/ 20576: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internally used method to set the colliding state of a tile. This does not recalculate
 * interesting faces.
 *
 * @function Phaser.Tilemaps.Components.SetTileCollision
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.Tile} tile - The Tile to set the collision on.
 * @param {boolean} [collides=true] - Should the tile index collide or not?
 */ var SetTileCollision = function(tile, collides) {
                    if (collides) tile.setCollision(true, true, true, true, false);
                    else tile.resetCollision(false);
                };
                module1.exports = SetTileCollision;
            /***/ },
            /***/ 79583: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets a global collision callback for the given tile index within the layer. This will affect all
 * tiles on this layer that have the same index. If a callback is already set for the tile index it
 * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
 * at a specific location on the map then see setTileLocationCallback.
 *
 * @function Phaser.Tilemaps.Components.SetTileIndexCallback
 * @since 3.0.0
 *
 * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for.
 * @param {function} callback - The callback that will be invoked when the tile is collided with.
 * @param {object} callbackContext - The context under which the callback is called.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetTileIndexCallback = function(indexes, callback, callbackContext, layer) {
                    if (typeof indexes === 'number') layer.callbacks[indexes] = callback !== null ? {
                        callback: callback,
                        callbackContext: callbackContext
                    } : undefined;
                    else for(var i = 0, len = indexes.length; i < len; i++)layer.callbacks[indexes[i]] = callback !== null ? {
                        callback: callback,
                        callbackContext: callbackContext
                    } : undefined;
                };
                module1.exports = SetTileIndexCallback;
            /***/ },
            /***/ 93254: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                /**
 * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
 * If a callback is already set for the tile index it will be replaced. Set the callback to null to
 * remove it.
 *
 * @function Phaser.Tilemaps.Components.SetTileLocationCallback
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {function} callback - The callback that will be invoked when the tile is collided with.
 * @param {object} callbackContext - The context under which the callback is called.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetTileLocationCallback = function(tileX, tileY, width, height, callback, callbackContext, layer) {
                    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                    for(var i = 0; i < tiles.length; i++)tiles[i].setCollisionCallback(callback, callbackContext);
                };
                module1.exports = SetTileLocationCallback;
            /***/ },
            /***/ 32903: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                var ShuffleArray = __webpack_require__(33680);
                /**
 * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
 * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
 * appear to have changed! This method only modifies tile indexes and does not change collision
 * information.
 *
 * @function Phaser.Tilemaps.Components.Shuffle
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Shuffle = function(tileX, tileY, width, height, layer) {
                    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                    var indexes = tiles.map(function(tile) {
                        return tile.index;
                    });
                    ShuffleArray(indexes);
                    for(var i = 0; i < tiles.length; i++)tiles[i].index = indexes[i];
                };
                module1.exports = Shuffle;
            /***/ },
            /***/ 61325: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SnapCeil = __webpack_require__(63448);
                var SnapFloor = __webpack_require__(56583);
                /**
 * Returns the bounds in the given layer that are within the camera's viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.StaggeredCullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {object} An object containing the `left`, `right`, `top` and `bottom` bounds.
 */ var StaggeredCullBounds = function(layer, camera) {
                    var tilemap = layer.tilemapLayer.tilemap;
                    var tilemapLayer = layer.tilemapLayer;
                    //  We need to use the tile sizes defined for the map as a whole, not the layer,
                    //  in order to calculate the bounds correctly. As different sized tiles may be
                    //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                    var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                    var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                    var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                    var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                    var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, tileH / 2, 0, true) - tilemapLayer.cullPaddingY;
                    var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, tileH / 2, 0, true) + tilemapLayer.cullPaddingY;
                    return {
                        left: boundsLeft,
                        right: boundsRight,
                        top: boundsTop,
                        bottom: boundsBottom
                    };
                };
                module1.exports = StaggeredCullBounds;
            /***/ },
            /***/ 54503: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(61325);
                var RunCull = __webpack_require__(32483);
                /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.StaggeredCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var StaggeredCullTiles = function(layer, camera, outputArray, renderOrder) {
                    if (outputArray === undefined) outputArray = [];
                    if (renderOrder === undefined) renderOrder = 0;
                    outputArray.length = 0;
                    var tilemapLayer = layer.tilemapLayer;
                    //  Camera world view bounds, snapped for scaled tile size
                    //  Cull Padding values are given in tiles, not pixels
                    var bounds = CullBounds(layer, camera);
                    if (tilemapLayer.skipCull && tilemapLayer.scrollFactorX === 1 && tilemapLayer.scrollFactorY === 1) {
                        bounds.left = 0;
                        bounds.right = layer.width;
                        bounds.top = 0;
                        bounds.bottom = layer.height;
                    }
                    RunCull(layer, bounds, renderOrder, outputArray);
                    return outputArray;
                };
                module1.exports = StaggeredCullTiles;
            /***/ },
            /***/ 97202: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Converts from staggered tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.StaggeredTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var StaggeredTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                    if (!point) point = new Vector2();
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    var layerWorldX = 0;
                    var layerWorldY = 0;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                        tileWidth *= tilemapLayer.scaleX;
                        layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    var x = layerWorldX + tileX * tileWidth + tileY % 2 * (tileWidth / 2);
                    var y = layerWorldY + tileY * (tileHeight / 2);
                    return point.set(x, y);
                };
                module1.exports = StaggeredTileToWorldXY;
            /***/ },
            /***/ 28054: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from staggered tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.StaggeredTileToWorldY
 * @since 3.50.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var StaggeredTileToWorldY = function(tileY, camera, layer) {
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    var layerWorldY = 0;
                    if (tilemapLayer) {
                        if (camera === undefined) camera = tilemapLayer.scene.cameras.main;
                        layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    return layerWorldY + tileY * (tileHeight / 2) + tileHeight;
                };
                module1.exports = StaggeredTileToWorldY;
            /***/ },
            /***/ 15108: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Converts from world XY coordinates (pixels) to staggered tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.StaggeredWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var StaggeredWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                    if (!point) point = new Vector2();
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        // Find the world position relative to the static or dynamic layer's top left origin,
                        // factoring in the camera's vertical scroll
                        worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                        tileHeight *= tilemapLayer.scaleY;
                        // Find the world position relative to the static or dynamic layer's top left origin,
                        // factoring in the camera's horizontal scroll
                        worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                        tileWidth *= tilemapLayer.scaleX;
                    }
                    var y = snapToFloor ? Math.floor(worldY / (tileHeight / 2)) : worldY / (tileHeight / 2);
                    var x = snapToFloor ? Math.floor((worldX + y % 2 * 0.5 * tileWidth) / tileWidth) : (worldX + y % 2 * 0.5 * tileWidth) / tileWidth;
                    return point.set(x, y);
                };
                module1.exports = StaggeredWorldToTileXY;
            /***/ },
            /***/ 51900: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world Y coordinates (pixels) to staggered tile Y coordinates (tile units), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.StaggeredWorldToTileY
 * @since 3.50.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var StaggeredWorldToTileY = function(worldY, snapToFloor, camera, layer) {
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        //  Find the world position relative to the static or dynamic layer's top left origin,
                        //  factoring in the camera's vertical scroll
                        worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    return snapToFloor ? Math.floor(worldY / (tileHeight / 2)) : worldY / (tileHeight / 2);
                };
                module1.exports = StaggeredWorldToTileY;
            /***/ },
            /***/ 86560: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                /**
 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
 * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
 * information.
 *
 * @function Phaser.Tilemaps.Components.SwapByIndex
 * @since 3.0.0
 *
 * @param {number} tileA - First tile index.
 * @param {number} tileB - Second tile index.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SwapByIndex = function(indexA, indexB, tileX, tileY, width, height, layer) {
                    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                    for(var i = 0; i < tiles.length; i++)if (tiles[i]) {
                        if (tiles[i].index === indexA) tiles[i].index = indexB;
                        else if (tiles[i].index === indexB) tiles[i].index = indexA;
                    }
                };
                module1.exports = SwapByIndex;
            /***/ },
            /***/ 97281: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldX
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number}
 */ var TileToWorldX = function(tileX, camera, layer) {
                    var tileWidth = layer.baseTileWidth;
                    var tilemapLayer = layer.tilemapLayer;
                    var layerWorldX = 0;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                        tileWidth *= tilemapLayer.scaleX;
                    }
                    return layerWorldX + tileX * tileWidth;
                };
                module1.exports = TileToWorldX;
            /***/ },
            /***/ 70326: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileToWorldX = __webpack_require__(97281);
                var TileToWorldY = __webpack_require__(29650);
                var Vector2 = __webpack_require__(26099);
                /**
 * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldXY
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var TileToWorldXY = function(tileX, tileY, point, camera, layer) {
                    if (!point) point = new Vector2(0, 0);
                    point.x = TileToWorldX(tileX, camera, layer);
                    point.y = TileToWorldY(tileY, camera, layer);
                    return point;
                };
                module1.exports = TileToWorldXY;
            /***/ },
            /***/ 29650: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldY
 * @since 3.0.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var TileToWorldY = function(tileY, camera, layer) {
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    var layerWorldY = 0;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    return layerWorldY + tileY * tileHeight;
                };
                module1.exports = TileToWorldY;
            /***/ },
            /***/ 77366: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(7386);
                var MATH = __webpack_require__(75508);
                /**
 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
 * specified layer. Each tile will receive a new index. New indexes are drawn from the given
 * weightedIndexes array. An example weighted array:
 *
 * [
 *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
 *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
 *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
 *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
 * ]
 *
 * The probability of any index being choose is (the index's weight) / (sum of all weights). This
 * method only modifies tile indexes and does not change collision information.
 *
 * @function Phaser.Tilemaps.Components.WeightedRandomize
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {object[]} weightedIndexes - An array of objects to randomly draw from during
 * randomization. They should be in the form: { index: 0, weight: 4 } or
 * { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var WeightedRandomize = function(tileX, tileY, width, height, weightedIndexes, layer) {
                    if (!weightedIndexes) return;
                    var i;
                    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                    var weightTotal = 0;
                    for(i = 0; i < weightedIndexes.length; i++)weightTotal += weightedIndexes[i].weight;
                    if (weightTotal <= 0) return;
                    for(i = 0; i < tiles.length; i++){
                        var rand = MATH.RND.frac() * weightTotal;
                        var sum = 0;
                        var randomIndex = -1;
                        for(var j = 0; j < weightedIndexes.length; j++){
                            sum += weightedIndexes[j].weight;
                            if (rand <= sum) {
                                var chosen = weightedIndexes[j].index;
                                randomIndex = Array.isArray(chosen) ? chosen[Math.floor(MATH.RND.frac() * chosen.length)] : chosen;
                                break;
                            }
                        }
                        tiles[i].index = randomIndex;
                    }
                };
                module1.exports = WeightedRandomize;
            /***/ },
            /***/ 10095: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WorldToTileXY = __webpack_require__(85896);
                var Vector2 = __webpack_require__(26099);
                var tempVec = new Vector2();
                /**
 * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileX
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {?Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The X location in tile units.
 */ var WorldToTileX = function(worldX, snapToFloor, camera, layer) {
                    WorldToTileXY(worldX, 0, snapToFloor, tempVec, camera, layer);
                    return tempVec.x;
                };
                module1.exports = WorldToTileX;
            /***/ },
            /***/ 85896: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(26099);
                /**
 * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileXY
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var WorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                    if (snapToFloor === undefined) snapToFloor = true;
                    if (!point) point = new Vector2();
                    var tileWidth = layer.baseTileWidth;
                    var tileHeight = layer.baseTileHeight;
                    var tilemapLayer = layer.tilemapLayer;
                    if (tilemapLayer) {
                        if (!camera) camera = tilemapLayer.scene.cameras.main;
                        // Find the world position relative to the static or dynamic layer's top left origin,
                        // factoring in the camera's horizontal scroll
                        worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                        worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                        tileWidth *= tilemapLayer.scaleX;
                        tileHeight *= tilemapLayer.scaleY;
                    }
                    var x = worldX / tileWidth;
                    var y = worldY / tileHeight;
                    if (snapToFloor) {
                        x = Math.floor(x);
                        y = Math.floor(y);
                    }
                    return point.set(x, y);
                };
                module1.exports = WorldToTileXY;
            /***/ },
            /***/ 63288: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WorldToTileXY = __webpack_require__(85896);
                var Vector2 = __webpack_require__(26099);
                var tempVec = new Vector2();
                /**
 * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileY
 * @since 3.0.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {?Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var WorldToTileY = function(worldY, snapToFloor, camera, layer) {
                    WorldToTileXY(0, worldY, snapToFloor, tempVec, camera, layer);
                    return tempVec.y;
                };
                module1.exports = WorldToTileY;
            /***/ },
            /***/ 81086: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Components
 */ module1.exports = {
                    CalculateFacesAt: __webpack_require__(72023),
                    CalculateFacesWithin: __webpack_require__(42573),
                    CheckIsoBounds: __webpack_require__(33528),
                    Copy: __webpack_require__(1785),
                    CreateFromTiles: __webpack_require__(78419),
                    CullBounds: __webpack_require__(19545),
                    CullTiles: __webpack_require__(30003),
                    Fill: __webpack_require__(35137),
                    FilterTiles: __webpack_require__(40253),
                    FindByIndex: __webpack_require__(52692),
                    FindTile: __webpack_require__(66151),
                    ForEachTile: __webpack_require__(97560),
                    GetCullTilesFunction: __webpack_require__(43305),
                    GetTileAt: __webpack_require__(7423),
                    GetTileAtWorldXY: __webpack_require__(60540),
                    GetTileCorners: __webpack_require__(55826),
                    GetTileCornersFunction: __webpack_require__(11758),
                    GetTilesWithin: __webpack_require__(7386),
                    GetTilesWithinShape: __webpack_require__(91141),
                    GetTilesWithinWorldXY: __webpack_require__(96523),
                    GetTileToWorldXFunction: __webpack_require__(39167),
                    GetTileToWorldXYFunction: __webpack_require__(62000),
                    GetTileToWorldYFunction: __webpack_require__(5984),
                    GetWorldToTileXFunction: __webpack_require__(96113),
                    GetWorldToTileXYFunction: __webpack_require__(16926),
                    GetWorldToTileYFunction: __webpack_require__(55762),
                    HasTileAt: __webpack_require__(45091),
                    HasTileAtWorldXY: __webpack_require__(24152),
                    HexagonalCullBounds: __webpack_require__(90454),
                    HexagonalCullTiles: __webpack_require__(9474),
                    HexagonalGetTileCorners: __webpack_require__(27229),
                    HexagonalTileToWorldXY: __webpack_require__(19951),
                    HexagonalWorldToTileXY: __webpack_require__(86625),
                    IsInLayerBounds: __webpack_require__(62991),
                    IsometricCullTiles: __webpack_require__(14018),
                    IsometricTileToWorldXY: __webpack_require__(14127),
                    IsometricWorldToTileXY: __webpack_require__(96897),
                    PutTileAt: __webpack_require__(71558),
                    PutTileAtWorldXY: __webpack_require__(26303),
                    PutTilesAt: __webpack_require__(14051),
                    Randomize: __webpack_require__(77389),
                    RemoveTileAt: __webpack_require__(63557),
                    RemoveTileAtWorldXY: __webpack_require__(94178),
                    RenderDebug: __webpack_require__(15533),
                    ReplaceByIndex: __webpack_require__(27987),
                    RunCull: __webpack_require__(32483),
                    SetCollision: __webpack_require__(57068),
                    SetCollisionBetween: __webpack_require__(37266),
                    SetCollisionByExclusion: __webpack_require__(75661),
                    SetCollisionByProperty: __webpack_require__(64740),
                    SetCollisionFromCollisionGroup: __webpack_require__(63307),
                    SetLayerCollisionIndex: __webpack_require__(9589),
                    SetTileCollision: __webpack_require__(20576),
                    SetTileIndexCallback: __webpack_require__(79583),
                    SetTileLocationCallback: __webpack_require__(93254),
                    Shuffle: __webpack_require__(32903),
                    StaggeredCullBounds: __webpack_require__(61325),
                    StaggeredCullTiles: __webpack_require__(54503),
                    StaggeredTileToWorldXY: __webpack_require__(97202),
                    StaggeredTileToWorldY: __webpack_require__(28054),
                    StaggeredWorldToTileXY: __webpack_require__(15108),
                    StaggeredWorldToTileY: __webpack_require__(51900),
                    SwapByIndex: __webpack_require__(86560),
                    TileToWorldX: __webpack_require__(97281),
                    TileToWorldXY: __webpack_require__(70326),
                    TileToWorldY: __webpack_require__(29650),
                    WeightedRandomize: __webpack_require__(77366),
                    WorldToTileX: __webpack_require__(10095),
                    WorldToTileXY: __webpack_require__(85896),
                    WorldToTileY: __webpack_require__(63288)
                };
            /***/ },
            /***/ 91907: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Tilemap constants for orientation.
 *
 * @namespace Phaser.Tilemaps.Orientation
 * @memberof Phaser.Tilemaps
 * @since 3.50.0
 */ /**
 * Phaser Tilemap constants for orientation.
 *
 * To find out what each mode does please see [Phaser.Tilemaps.Orientation]{@link Phaser.Tilemaps.Orientation}.
 *
 * @typedef {Phaser.Tilemaps.Orientation} Phaser.Tilemaps.OrientationType
 * @memberof Phaser.Tilemaps
 * @since 3.50.0
 */ module1.exports = {
                    /**
     * Orthogonal Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.ORTHOGONAL
     * @type {number}
     * @const
     * @since 3.50.0
     */ ORTHOGONAL: 0,
                    /**
     * Isometric Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.ISOMETRIC
     * @type {number}
     * @const
     * @since 3.50.0
     */ ISOMETRIC: 1,
                    /**
     * Staggered Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.STAGGERED
     * @type {number}
     * @const
     * @since 3.50.0
     */ STAGGERED: 2,
                    /**
     * Hexagonal Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.HEXAGONAL
     * @type {number}
     * @const
     * @since 3.50.0
     */ HEXAGONAL: 3
                };
            /***/ },
            /***/ 21829: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = {
                    ORIENTATION: __webpack_require__(91907)
                };
                module1.exports = CONST;
            /***/ },
            /***/ 62501: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(79291);
                var CONST = __webpack_require__(21829);
                /**
 * @namespace Phaser.Tilemaps
 *
 * @borrows Phaser.Tilemaps.Orientation.ORTHOGONAL as ORTHOGONAL
 * @borrows Phaser.Tilemaps.Orientation.ISOMETRIC as ISOMETRIC
 * @borrows Phaser.Tilemaps.Orientation.STAGGERED as STAGGERED
 * @borrows Phaser.Tilemaps.Orientation.HEXAGONAL as HEXAGONAL
 */ var Tilemaps = {
                    Components: __webpack_require__(81086),
                    Parsers: __webpack_require__(57442),
                    Formats: __webpack_require__(80341),
                    ImageCollection: __webpack_require__(16536),
                    ParseToTilemap: __webpack_require__(31989),
                    Tile: __webpack_require__(23029),
                    Tilemap: __webpack_require__(49075),
                    TilemapCreator: __webpack_require__(45939),
                    TilemapFactory: __webpack_require__(46029),
                    Tileset: __webpack_require__(33629),
                    TilemapLayer: __webpack_require__(20442),
                    Orientation: __webpack_require__(91907),
                    LayerData: __webpack_require__(14977),
                    MapData: __webpack_require__(87010),
                    ObjectLayer: __webpack_require__(48700)
                };
                Tilemaps = Extend(false, Tilemaps, CONST.ORIENTATION);
                module1.exports = Tilemaps;
            /***/ },
            /***/ 14977: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(91907);
                var GetFastValue = __webpack_require__(95540);
                /**
 * @classdesc
 * A class for representing data about about a layer in a map. Maps are parsed from CSV, Tiled,
 * etc. into this format. Tilemap and TilemapLayer objects have a reference
 * to this data and use it to look up and perform operations on tiles.
 *
 * @class LayerData
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.LayerDataConfig} [config] - The Layer Data configuration object.
 */ var LayerData = new Class({
                    initialize: function LayerData(config) {
                        if (config === undefined) config = {};
                        /**
         * The name of the layer, if specified in Tiled.
         *
         * @name Phaser.Tilemaps.LayerData#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'layer');
                        /**
         * The id of the layer, as specified in the map data.
         *
         * Note: This is not the index of the layer in the map data, but its actual ID in Tiled.
         *
         * @name Phaser.Tilemaps.LayerData#id
         * @type {number}
         * @since 3.70.0
         */ this.id = GetFastValue(config, 'id', 0);
                        /**
         * The x offset of where to draw from the top left.
         *
         * @name Phaser.Tilemaps.LayerData#x
         * @type {number}
         * @since 3.0.0
         */ this.x = GetFastValue(config, 'x', 0);
                        /**
         * The y offset of where to draw from the top left.
         *
         * @name Phaser.Tilemaps.LayerData#y
         * @type {number}
         * @since 3.0.0
         */ this.y = GetFastValue(config, 'y', 0);
                        /**
         * The width of the layer in tiles.
         *
         * @name Phaser.Tilemaps.LayerData#width
         * @type {number}
         * @since 3.0.0
         */ this.width = GetFastValue(config, 'width', 0);
                        /**
         * The height of the layer in tiles.
         *
         * @name Phaser.Tilemaps.LayerData#height
         * @type {number}
         * @since 3.0.0
         */ this.height = GetFastValue(config, 'height', 0);
                        /**
         * The pixel width of the tiles.
         *
         * @name Phaser.Tilemaps.LayerData#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = GetFastValue(config, 'tileWidth', 0);
                        /**
         * The pixel height of the tiles.
         *
         * @name Phaser.Tilemaps.LayerData#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = GetFastValue(config, 'tileHeight', 0);
                        /**
         * The base tile width.
         *
         * @name Phaser.Tilemaps.LayerData#baseTileWidth
         * @type {number}
         * @since 3.0.0
         */ this.baseTileWidth = GetFastValue(config, 'baseTileWidth', this.tileWidth);
                        /**
         * The base tile height.
         *
         * @name Phaser.Tilemaps.LayerData#baseTileHeight
         * @type {number}
         * @since 3.0.0
         */ this.baseTileHeight = GetFastValue(config, 'baseTileHeight', this.tileHeight);
                        /**
         * The layers orientation, necessary to be able to determine a tiles pixelX and pixelY as well as the layers width and height.
         *
         * @name Phaser.Tilemaps.LayerData#orientation
         * @type {Phaser.Tilemaps.OrientationType}
         * @since 3.50.0
         */ this.orientation = GetFastValue(config, 'orientation', CONST.ORTHOGONAL);
                        /**
         * The width in pixels of the entire layer.
         *
         * @name Phaser.Tilemaps.LayerData#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = GetFastValue(config, 'widthInPixels', this.width * this.baseTileWidth);
                        /**
         * The height in pixels of the entire layer.
         *
         * @name Phaser.Tilemaps.LayerData#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = GetFastValue(config, 'heightInPixels', this.height * this.baseTileHeight);
                        /**
         * The alpha value of the layer.
         *
         * @name Phaser.Tilemaps.LayerData#alpha
         * @type {number}
         * @since 3.0.0
         */ this.alpha = GetFastValue(config, 'alpha', 1);
                        /**
         * Is the layer visible or not?
         *
         * @name Phaser.Tilemaps.LayerData#visible
         * @type {boolean}
         * @since 3.0.0
         */ this.visible = GetFastValue(config, 'visible', true);
                        /**
         * Layer specific properties (can be specified in Tiled)
         *
         * @name Phaser.Tilemaps.LayerData#properties
         * @type {object[]}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, 'properties', []);
                        /**
         * Tile ID index map.
         *
         * @name Phaser.Tilemaps.LayerData#indexes
         * @type {array}
         * @since 3.0.0
         */ this.indexes = GetFastValue(config, 'indexes', []);
                        /**
         * Tile Collision ID index map.
         *
         * @name Phaser.Tilemaps.LayerData#collideIndexes
         * @type {array}
         * @since 3.0.0
         */ this.collideIndexes = GetFastValue(config, 'collideIndexes', []);
                        /**
         * An array of callbacks.
         *
         * @name Phaser.Tilemaps.LayerData#callbacks
         * @type {array}
         * @since 3.0.0
         */ this.callbacks = GetFastValue(config, 'callbacks', []);
                        /**
         * An array of physics bodies.
         *
         * @name Phaser.Tilemaps.LayerData#bodies
         * @type {array}
         * @since 3.0.0
         */ this.bodies = GetFastValue(config, 'bodies', []);
                        /**
         * An array of the tile data indexes.
         *
         * @name Phaser.Tilemaps.LayerData#data
         * @type {Phaser.Tilemaps.Tile[][]}
         * @since 3.0.0
         */ this.data = GetFastValue(config, 'data', []);
                        /**
         * A reference to the Tilemap layer that owns this data.
         *
         * @name Phaser.Tilemaps.LayerData#tilemapLayer
         * @type {Phaser.Tilemaps.TilemapLayer}
         * @since 3.0.0
         */ this.tilemapLayer = GetFastValue(config, 'tilemapLayer', null);
                        /**
         * The length of the horizontal sides of the hexagon.
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.LayerData#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = GetFastValue(config, 'hexSideLength', 0);
                        /**
         * The Stagger Axis as defined in Tiled.
         *
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.LayerData#staggerAxis
         * @type {string}
         * @since 3.60.0
         */ this.staggerAxis = GetFastValue(config, 'staggerAxis', 'y');
                        /**
         * The Stagger Index as defined in Tiled.
         *
         * Either 'odd' or 'even'.
         *
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.LayerData#staggerIndex
         * @type {string}
         * @since 3.60.0
         */ this.staggerIndex = GetFastValue(config, 'staggerIndex', 'odd');
                    }
                });
                module1.exports = LayerData;
            /***/ },
            /***/ 87010: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var CONST = __webpack_require__(91907);
                var GetFastValue = __webpack_require__(95540);
                /**
 * @classdesc
 * A class for representing data about a map. Maps are parsed from CSV, Tiled, etc. into this
 * format. A Tilemap object get a copy of this data and then unpacks the needed properties into
 * itself.
 *
 * @class MapData
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.MapDataConfig} [config] - The Map configuration object.
 */ var MapData = new Class({
                    initialize: function MapData(config) {
                        if (config === undefined) config = {};
                        /**
         * The key in the Phaser cache that corresponds to the loaded tilemap data.
         *
         * @name Phaser.Tilemaps.MapData#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'map');
                        /**
         * The width of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#width
         * @type {number}
         * @since 3.0.0
         */ this.width = GetFastValue(config, 'width', 0);
                        /**
         * The height of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#height
         * @type {number}
         * @since 3.0.0
         */ this.height = GetFastValue(config, 'height', 0);
                        /**
         * If the map is infinite or not.
         *
         * @name Phaser.Tilemaps.MapData#infinite
         * @type {boolean}
         * @since 3.17.0
         */ this.infinite = GetFastValue(config, 'infinite', false);
                        /**
         * The width of the tiles.
         *
         * @name Phaser.Tilemaps.MapData#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = GetFastValue(config, 'tileWidth', 0);
                        /**
         * The height of the tiles.
         *
         * @name Phaser.Tilemaps.MapData#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = GetFastValue(config, 'tileHeight', 0);
                        /**
         * The width in pixels of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = GetFastValue(config, 'widthInPixels', this.width * this.tileWidth);
                        /**
         * The height in pixels of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = GetFastValue(config, 'heightInPixels', this.height * this.tileHeight);
                        /**
         * The format of the map data.
         *
         * @name Phaser.Tilemaps.MapData#format
         * @type {number}
         * @since 3.0.0
         */ this.format = GetFastValue(config, 'format', null);
                        /**
         * The orientation of the map data (i.e. orthogonal, isometric, hexagonal), default 'orthogonal'.
         *
         * @name Phaser.Tilemaps.MapData#orientation
         * @type {Phaser.Tilemaps.OrientationType}
         * @since 3.50.0
         */ this.orientation = GetFastValue(config, 'orientation', CONST.ORTHOGONAL);
                        /**
         * Determines the draw order of tilemap. Default is right-down
         *
         * 0, or 'right-down'
         * 1, or 'left-down'
         * 2, or 'right-up'
         * 3, or 'left-up'
         *
         * @name Phaser.Tilemaps.MapData#renderOrder
         * @type {string}
         * @since 3.12.0
         */ this.renderOrder = GetFastValue(config, 'renderOrder', 'right-down');
                        /**
         * The version of the map data (as specified in Tiled).
         *
         * @name Phaser.Tilemaps.MapData#version
         * @type {string}
         * @since 3.0.0
         */ this.version = GetFastValue(config, 'version', '1');
                        /**
         * Map specific properties (can be specified in Tiled)
         *
         * @name Phaser.Tilemaps.MapData#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, 'properties', {});
                        /**
         * An array with all the layers configured to the MapData.
         *
         * @name Phaser.Tilemaps.MapData#layers
         * @type {(Phaser.Tilemaps.LayerData[]|Phaser.Tilemaps.ObjectLayer)}
         * @since 3.0.0
         */ this.layers = GetFastValue(config, 'layers', []);
                        /**
         * An array of Tiled Image Layers.
         *
         * @name Phaser.Tilemaps.MapData#images
         * @type {array}
         * @since 3.0.0
         */ this.images = GetFastValue(config, 'images', []);
                        /**
         * An object of Tiled Object Layers.
         *
         * @name Phaser.Tilemaps.MapData#objects
         * @type {Phaser.Types.Tilemaps.ObjectLayerConfig[]}
         * @since 3.0.0
         */ this.objects = GetFastValue(config, 'objects', []);
                        //  Because Tiled can sometimes create an empty object if you don't populate it, not an empty array
                        if (!Array.isArray(this.objects)) this.objects = [];
                        /**
         * An object of collision data. Must be created as physics object or will return undefined.
         *
         * @name Phaser.Tilemaps.MapData#collision
         * @type {object}
         * @since 3.0.0
         */ this.collision = GetFastValue(config, 'collision', {});
                        /**
         * An array of Tilesets.
         *
         * @name Phaser.Tilemaps.MapData#tilesets
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.0.0
         */ this.tilesets = GetFastValue(config, 'tilesets', []);
                        /**
         * The collection of images the map uses(specified in Tiled)
         *
         * @name Phaser.Tilemaps.MapData#imageCollections
         * @type {array}
         * @since 3.0.0
         */ this.imageCollections = GetFastValue(config, 'imageCollections', []);
                        /**
         * An array of tile instances.
         *
         * @name Phaser.Tilemaps.MapData#tiles
         * @type {array}
         * @since 3.0.0
         */ this.tiles = GetFastValue(config, 'tiles', []);
                        /**
         * The length of the horizontal sides of the hexagon.
         *
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.MapData#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = GetFastValue(config, 'hexSideLength', 0);
                        /**
         * The Stagger Axis as defined in Tiled.
         *
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.MapData#staggerAxis
         * @type {string}
         * @since 3.60.0
         */ this.staggerAxis = GetFastValue(config, 'staggerAxis', 'y');
                        /**
         * The Stagger Index as defined in Tiled.
         *
         * Either 'odd' or 'even'.
         *
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.MapData#staggerIndex
         * @type {string}
         * @since 3.60.0
         */ this.staggerIndex = GetFastValue(config, 'staggerIndex', 'odd');
                    }
                });
                module1.exports = MapData;
            /***/ },
            /***/ 48700: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                /**
 * @classdesc
 * A class for representing a Tiled object layer in a map. This mirrors the structure of a Tiled
 * object layer, except:
 *  - "x" & "y" properties are ignored since these cannot be changed in Tiled.
 *  - "offsetx" & "offsety" are applied to the individual object coordinates directly, so they
 *    are ignored as well.
 *  - "draworder" is ignored.
 *
 * @class ObjectLayer
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.ObjectLayerConfig} [config] - The data for the layer from the Tiled JSON object.
 */ var ObjectLayer = new Class({
                    initialize: function ObjectLayer(config) {
                        if (config === undefined) config = {};
                        /**
         * The name of the Object Layer.
         *
         * @name Phaser.Tilemaps.ObjectLayer#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'object layer');
                        /**
         * The id of the object layer, as specified in the map data.
         *
         * @name Phaser.Tilemaps.ObjectLayer#id
         * @type {number}
         * @since 3.70.0
         */ this.id = GetFastValue(config, 'id', 0);
                        /**
         * The opacity of the layer, between 0 and 1.
         *
         * @name Phaser.Tilemaps.ObjectLayer#opacity
         * @type {number}
         * @since 3.0.0
         */ this.opacity = GetFastValue(config, 'opacity', 1);
                        /**
         * The custom properties defined on the Object Layer, keyed by their name.
         *
         * @name Phaser.Tilemaps.ObjectLayer#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, 'properties', {});
                        /**
         * The type of each custom property defined on the Object Layer, keyed by its name.
         *
         * @name Phaser.Tilemaps.ObjectLayer#propertyTypes
         * @type {object}
         * @since 3.0.0
         */ this.propertyTypes = GetFastValue(config, 'propertytypes', {});
                        /**
         * The type of the layer, which should be `objectgroup`.
         *
         * @name Phaser.Tilemaps.ObjectLayer#type
         * @type {string}
         * @since 3.0.0
         */ this.type = GetFastValue(config, 'type', 'objectgroup');
                        /**
         * Whether the layer is shown (`true`) or hidden (`false`).
         *
         * @name Phaser.Tilemaps.ObjectLayer#visible
         * @type {boolean}
         * @since 3.0.0
         */ this.visible = GetFastValue(config, 'visible', true);
                        /**
         * An array of all objects on this Object Layer.
         *
         * Each Tiled object corresponds to a JavaScript object in this array. It has an `id` (unique),
         * `name` (as assigned in Tiled), `type` (as assigned in Tiled), `rotation` (in clockwise degrees),
         * `properties` (if any), `visible` state (`true` if visible, `false` otherwise),
         * `x` and `y` coordinates (in pixels, relative to the tilemap), and a `width` and `height` (in pixels).
         *
         * An object tile has a `gid` property (GID of the represented tile), a `flippedHorizontal` property,
         * a `flippedVertical` property, and `flippedAntiDiagonal` property.
         * The {@link http://docs.mapeditor.org/en/latest/reference/tmx-map-format/|Tiled documentation} contains
         * information on flipping and rotation.
         *
         * Polylines have a `polyline` property, which is an array of objects corresponding to points,
         * where each point has an `x` property and a `y` property. Polygons have an identically structured
         * array in their `polygon` property. Text objects have a `text` property with the text's properties.
         *
         * Rectangles and ellipses have a `rectangle` or `ellipse` property set to `true`.
         *
         * @name Phaser.Tilemaps.ObjectLayer#objects
         * @type {Phaser.Types.Tilemaps.TiledObject[]}
         * @since 3.0.0
         */ this.objects = GetFastValue(config, 'objects', []);
                        //  Because Tiled can sometimes create an empty object if you don't populate it, not an empty array
                        if (!Array.isArray(this.objects)) this.objects = [];
                    }
                });
                module1.exports = ObjectLayer;
            /***/ },
            /***/ 6641: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(91907);
                /**
 * Get the Tilemap orientation from the given string.
 *
 * @function Phaser.Tilemaps.Parsers.FromOrientationString
 * @since 3.50.0
 *
 * @param {string} [orientation] - The orientation type as a string.
 *
 * @return {Phaser.Tilemaps.OrientationType} The Tilemap Orientation type.
 */ var FromOrientationString = function(orientation) {
                    orientation = orientation.toLowerCase();
                    if (orientation === 'isometric') return CONST.ISOMETRIC;
                    else if (orientation === 'staggered') return CONST.STAGGERED;
                    else if (orientation === 'hexagonal') return CONST.HEXAGONAL;
                    else return CONST.ORTHOGONAL;
                };
                module1.exports = FromOrientationString;
            /***/ },
            /***/ 46177: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(80341);
                var Parse2DArray = __webpack_require__(2342);
                var ParseCSV = __webpack_require__(82593);
                var ParseJSONTiled = __webpack_require__(46594);
                var ParseWeltmeister = __webpack_require__(87021);
                /**
 * Parses raw data of a given Tilemap format into a new MapData object. If no recognized data format
 * is found, returns `null`. When loading from CSV or a 2D array, you should specify the tileWidth &
 * tileHeight. When parsing from a map from Tiled, the tileWidth & tileHeight will be pulled from
 * the map data.
 *
 * @function Phaser.Tilemaps.Parsers.Parse
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {number} mapFormat - See ../Formats.js.
 * @param {(number[][]|string|object)} data - 2D array, CSV string or Tiled JSON object.
 * @param {number} tileWidth - The width of a tile in pixels. Required for 2D array and CSV, but
 * ignored for Tiled JSON.
 * @param {number} tileHeight - The height of a tile in pixels. Required for 2D array and CSV, but
 * ignored for Tiled JSON.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The created `MapData` object.
 */ var Parse = function(name, mapFormat, data, tileWidth, tileHeight, insertNull) {
                    var newMap;
                    switch(mapFormat){
                        case Formats.ARRAY_2D:
                            newMap = Parse2DArray(name, data, tileWidth, tileHeight, insertNull);
                            break;
                        case Formats.CSV:
                            newMap = ParseCSV(name, data, tileWidth, tileHeight, insertNull);
                            break;
                        case Formats.TILED_JSON:
                            newMap = ParseJSONTiled(name, data, insertNull);
                            break;
                        case Formats.WELTMEISTER:
                            newMap = ParseWeltmeister(name, data, insertNull);
                            break;
                        default:
                            console.warn('Unrecognized tilemap data format: ' + mapFormat);
                            newMap = null;
                    }
                    return newMap;
                };
                module1.exports = Parse;
            /***/ },
            /***/ 2342: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(80341);
                var LayerData = __webpack_require__(14977);
                var MapData = __webpack_require__(87010);
                var Tile = __webpack_require__(23029);
                /**
 * Parses a 2D array of tile indexes into a new MapData object with a single layer.
 *
 * @function Phaser.Tilemaps.Parsers.Parse2DArray
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {number[][]} data - 2D array, CSV string or Tiled JSON object.
 * @param {number} tileWidth - The width of a tile in pixels.
 * @param {number} tileHeight - The height of a tile in pixels.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The MapData object.
 */ var Parse2DArray = function(name, data, tileWidth, tileHeight, insertNull) {
                    var layerData = new LayerData({
                        tileWidth: tileWidth,
                        tileHeight: tileHeight
                    });
                    var mapData = new MapData({
                        name: name,
                        tileWidth: tileWidth,
                        tileHeight: tileHeight,
                        format: Formats.ARRAY_2D,
                        layers: [
                            layerData
                        ]
                    });
                    var tiles = [];
                    var height = data.length;
                    var width = 0;
                    for(var y = 0; y < data.length; y++){
                        tiles[y] = [];
                        var row = data[y];
                        for(var x = 0; x < row.length; x++){
                            var tileIndex = parseInt(row[x], 10);
                            if (isNaN(tileIndex) || tileIndex === -1) tiles[y][x] = insertNull ? null : new Tile(layerData, -1, x, y, tileWidth, tileHeight);
                            else tiles[y][x] = new Tile(layerData, tileIndex, x, y, tileWidth, tileHeight);
                        }
                        if (width === 0) width = row.length;
                    }
                    mapData.width = layerData.width = width;
                    mapData.height = layerData.height = height;
                    mapData.widthInPixels = layerData.widthInPixels = width * tileWidth;
                    mapData.heightInPixels = layerData.heightInPixels = height * tileHeight;
                    layerData.data = tiles;
                    return mapData;
                };
                module1.exports = Parse2DArray;
            /***/ },
            /***/ 82593: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(80341);
                var Parse2DArray = __webpack_require__(2342);
                /**
 * Parses a CSV string of tile indexes into a new MapData object with a single layer.
 *
 * @function Phaser.Tilemaps.Parsers.ParseCSV
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {string} data - CSV string of tile indexes.
 * @param {number} tileWidth - The width of a tile in pixels.
 * @param {number} tileHeight - The height of a tile in pixels.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The resulting MapData object.
 */ var ParseCSV = function(name, data, tileWidth, tileHeight, insertNull) {
                    var array2D = data.trim().split('\n').map(function(row) {
                        return row.split(',');
                    });
                    var map = Parse2DArray(name, array2D, tileWidth, tileHeight, insertNull);
                    map.format = Formats.CSV;
                    return map;
                };
                module1.exports = ParseCSV;
            /***/ },
            /***/ 6656: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LayerData = __webpack_require__(14977);
                var Tile = __webpack_require__(23029);
                /**
 * Parses all tilemap layers in an Impact JSON object into new LayerData objects.
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseTileLayers
 * @since 3.0.0
 *
 * @param {object} json - The Impact JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled (see {@link Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled}).
 *
 * @return {Phaser.Tilemaps.LayerData[]} - An array of LayerData objects, one for each entry in
 * json.layers with the type 'tilelayer'.
 */ var ParseTileLayers = function(json, insertNull) {
                    var tileLayers = [];
                    for(var i = 0; i < json.layer.length; i++){
                        var layer = json.layer[i];
                        var layerData = new LayerData({
                            name: layer.name,
                            width: layer.width,
                            height: layer.height,
                            tileWidth: layer.tilesize,
                            tileHeight: layer.tilesize,
                            visible: layer.visible === 1
                        });
                        var row = [];
                        var tileGrid = [];
                        //  Loop through the data field in the JSON. This is a 2D array containing the tile indexes,
                        //  one after the other. The indexes are relative to the tileset that contains the tile.
                        for(var y = 0; y < layer.data.length; y++){
                            for(var x = 0; x < layer.data[y].length; x++){
                                // In Weltmeister, 0 = no tile, but the Tilemap API expects -1 = no tile.
                                var index = layer.data[y][x] - 1;
                                var tile;
                                if (index > -1) tile = new Tile(layerData, index, x, y, layer.tilesize, layer.tilesize);
                                else tile = insertNull ? null : new Tile(layerData, -1, x, y, layer.tilesize, layer.tilesize);
                                row.push(tile);
                            }
                            tileGrid.push(row);
                            row = [];
                        }
                        layerData.data = tileGrid;
                        tileLayers.push(layerData);
                    }
                    return tileLayers;
                };
                module1.exports = ParseTileLayers;
            /***/ },
            /***/ 96483: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(33629);
                /**
 * Tilesets and Image Collections
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseTilesets
 * @since 3.0.0
 *
 * @param {object} json - The Impact JSON data.
 *
 * @return {array} An array of Tilesets.
 */ var ParseTilesets = function(json) {
                    var tilesets = [];
                    var tilesetsNames = [];
                    for(var i = 0; i < json.layer.length; i++){
                        var layer = json.layer[i];
                        // A relative filepath to the source image (within Weltmeister) is used for the name
                        var tilesetName = layer.tilesetName;
                        // Only add unique tilesets that have a valid name. Collision layers will have a blank name.
                        if (tilesetName !== '' && tilesetsNames.indexOf(tilesetName) === -1) {
                            tilesetsNames.push(tilesetName);
                            // Tiles are stored with an ID relative to the tileset, rather than a globally unique ID
                            // across all tilesets. Also, tilesets in Weltmeister have no margin or padding.
                            tilesets.push(new Tileset(tilesetName, 0, layer.tilesize, layer.tilesize, 0, 0));
                        }
                    }
                    return tilesets;
                };
                module1.exports = ParseTilesets;
            /***/ },
            /***/ 87021: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(80341);
                var MapData = __webpack_require__(87010);
                var ParseTileLayers = __webpack_require__(6656);
                var ParseTilesets = __webpack_require__(96483);
                /**
 * Parses a Weltmeister JSON object into a new MapData object.
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseWeltmeister
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {object} json - The Weltmeister JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {?Phaser.Tilemaps.MapData} The created MapData object, or `null` if the data can't be parsed.
 */ var ParseWeltmeister = function(name, json, insertNull) {
                    if (json.layer.length === 0) {
                        console.warn('No layers found in the Weltmeister map: ' + name);
                        return null;
                    }
                    var width = 0;
                    var height = 0;
                    for(var i = 0; i < json.layer.length; i++){
                        if (json.layer[i].width > width) width = json.layer[i].width;
                        if (json.layer[i].height > height) height = json.layer[i].height;
                    }
                    var mapData = new MapData({
                        width: width,
                        height: height,
                        name: name,
                        tileWidth: json.layer[0].tilesize,
                        tileHeight: json.layer[0].tilesize,
                        format: Formats.WELTMEISTER
                    });
                    mapData.layers = ParseTileLayers(json, insertNull);
                    mapData.tilesets = ParseTilesets(json);
                    return mapData;
                };
                module1.exports = ParseWeltmeister;
            /***/ },
            /***/ 52833: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers.Impact
 */ module1.exports = {
                    ParseTileLayers: __webpack_require__(6656),
                    ParseTilesets: __webpack_require__(96483),
                    ParseWeltmeister: __webpack_require__(87021)
                };
            /***/ },
            /***/ 57442: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers
 */ module1.exports = {
                    FromOrientationString: __webpack_require__(6641),
                    Parse: __webpack_require__(46177),
                    Parse2DArray: __webpack_require__(2342),
                    ParseCSV: __webpack_require__(82593),
                    Impact: __webpack_require__(52833),
                    Tiled: __webpack_require__(96761)
                };
            /***/ },
            /***/ 51233: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(79291);
                /**
 * Copy properties from tileset to tiles.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.AssignTileProperties
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.MapData} mapData - The Map Data object.
 */ var AssignTileProperties = function(mapData) {
                    var layerData;
                    var tile;
                    var sid;
                    var set;
                    var row;
                    // go through each of the map data layers
                    for(var i = 0; i < mapData.layers.length; i++){
                        layerData = mapData.layers[i];
                        set = null;
                        // rows of tiles
                        for(var j = 0; j < layerData.data.length; j++){
                            row = layerData.data[j];
                            // individual tiles
                            for(var k = 0; k < row.length; k++){
                                tile = row[k];
                                if (tile === null || tile.index < 0) continue;
                                // find the relevant tileset
                                sid = mapData.tiles[tile.index][2];
                                set = mapData.tilesets[sid];
                                // Ensure that a tile's size matches its tileset
                                tile.width = set.tileWidth;
                                tile.height = set.tileHeight;
                                // if that tile type has any properties, add them to the tile object
                                if (set.tileProperties && set.tileProperties[tile.index - set.firstgid]) tile.properties = Extend(tile.properties, set.tileProperties[tile.index - set.firstgid]);
                            }
                        }
                    }
                };
                module1.exports = AssignTileProperties;
            /***/ },
            /***/ 41868: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Decode base-64 encoded data, for example as exported by Tiled.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.Base64Decode
 * @since 3.0.0
 *
 * @param {object} data - Base-64 encoded data to decode.
 *
 * @return {array} Array containing the decoded bytes.
 */ var Base64Decode = function(data) {
                    var binaryString = window.atob(data);
                    var len = binaryString.length;
                    var bytes = new Array(len / 4);
                    // Interpret binaryString as an array of bytes representing little-endian encoded uint32 values.
                    for(var i = 0; i < len; i += 4)bytes[i / 4] = (binaryString.charCodeAt(i) | binaryString.charCodeAt(i + 1) << 8 | binaryString.charCodeAt(i + 2) << 16 | binaryString.charCodeAt(i + 3) << 24) >>> 0;
                    return bytes;
                };
                module1.exports = Base64Decode;
            /***/ },
            /***/ 84101: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(33629);
                /**
 * Master list of tiles -> x, y, index in tileset.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.BuildTilesetIndex
 * @since 3.0.0
 *
 * @param {(Phaser.Tilemaps.MapData|Phaser.Tilemaps.Tilemap)} mapData - The Map Data object.
 *
 * @return {array} An array of Tileset objects.
 */ var BuildTilesetIndex = function(mapData) {
                    var i;
                    var set;
                    var tiles = [];
                    for(i = 0; i < mapData.imageCollections.length; i++){
                        var collection = mapData.imageCollections[i];
                        var images = collection.images;
                        for(var j = 0; j < images.length; j++){
                            var image = images[j];
                            var offset = {
                                x: 0,
                                y: image.height - mapData.tileHeight
                            };
                            set = new Tileset(image.image, image.gid, image.width, image.height, 0, 0, null, null, offset);
                            set.updateTileData(image.width, image.height);
                            mapData.tilesets.push(set);
                        }
                    }
                    for(i = 0; i < mapData.tilesets.length; i++){
                        set = mapData.tilesets[i];
                        var x = set.tileMargin;
                        var y = set.tileMargin;
                        var count = 0;
                        var countX = 0;
                        var countY = 0;
                        for(var t = set.firstgid; t < set.firstgid + set.total; t++){
                            //  Can add extra properties here as needed
                            tiles[t] = [
                                x,
                                y,
                                i
                            ];
                            x += set.tileWidth + set.tileSpacing;
                            count++;
                            if (count === set.total) break;
                            countX++;
                            if (countX === set.columns) {
                                x = set.tileMargin;
                                y += set.tileHeight + set.tileSpacing;
                                countX = 0;
                                countY++;
                                if (countY === set.rows) break;
                            }
                        }
                    }
                    return tiles;
                };
                module1.exports = BuildTilesetIndex;
            /***/ },
            /***/ 79677: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Seth Berrier <berriers@uwstout.edu>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                /**
 * Parse a Tiled group layer and create a state object for inheriting.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.CreateGroupLayer
 * @since 3.21.0
 *
 * @param {object} json - The Tiled JSON object.
 * @param {object} [group] - The current group layer from the Tiled JSON file.
 * @param {object} [parentState] - The state of the parent group (if any).
 *
 * @return {object} A group state object with proper values for updating children layers.
 */ var CreateGroupLayer = function(json, group, parentState) {
                    if (!group) // Return a default group state object
                    return {
                        i: 0,
                        layers: json.layers,
                        // Values inherited from parent group
                        name: '',
                        opacity: 1,
                        visible: true,
                        x: 0,
                        y: 0
                    };
                    // Compute group layer x, y
                    var layerX = group.x + GetFastValue(group, 'startx', 0) * json.tilewidth + GetFastValue(group, 'offsetx', 0);
                    var layerY = group.y + GetFastValue(group, 'starty', 0) * json.tileheight + GetFastValue(group, 'offsety', 0);
                    // Compute next state inherited from group
                    return {
                        i: 0,
                        layers: group.layers,
                        name: parentState.name + group.name + '/',
                        opacity: parentState.opacity * group.opacity,
                        visible: parentState.visible && group.visible,
                        x: parentState.x + layerX,
                        y: parentState.y + layerY
                    };
                };
                module1.exports = CreateGroupLayer;
            /***/ },
            /***/ 29920: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FLIPPED_HORIZONTAL = 0x80000000;
                var FLIPPED_VERTICAL = 0x40000000;
                var FLIPPED_ANTI_DIAGONAL = 0x20000000; // Top-right is swapped with bottom-left corners
                /**
 * See Tiled documentation on tile flipping:
 * http://docs.mapeditor.org/en/latest/reference/tmx-map-format/
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseGID
 * @since 3.0.0
 *
 * @param {number} gid - A Tiled GID.
 *
 * @return {Phaser.Types.Tilemaps.GIDData} The GID Data.
 */ var ParseGID = function(gid) {
                    var flippedHorizontal = Boolean(gid & FLIPPED_HORIZONTAL);
                    var flippedVertical = Boolean(gid & FLIPPED_VERTICAL);
                    var flippedAntiDiagonal = Boolean(gid & FLIPPED_ANTI_DIAGONAL);
                    gid = gid & ~(FLIPPED_HORIZONTAL | FLIPPED_VERTICAL | FLIPPED_ANTI_DIAGONAL);
                    // Parse the flip flags into something Phaser can use
                    var rotation = 0;
                    var flipped = false;
                    if (flippedHorizontal && flippedVertical && flippedAntiDiagonal) {
                        rotation = Math.PI / 2;
                        flipped = true;
                    } else if (flippedHorizontal && flippedVertical && !flippedAntiDiagonal) {
                        rotation = Math.PI;
                        flipped = false;
                    } else if (flippedHorizontal && !flippedVertical && flippedAntiDiagonal) {
                        rotation = Math.PI / 2;
                        flipped = false;
                    } else if (flippedHorizontal && !flippedVertical && !flippedAntiDiagonal) {
                        rotation = 0;
                        flipped = true;
                    } else if (!flippedHorizontal && flippedVertical && flippedAntiDiagonal) {
                        rotation = 3 * Math.PI / 2;
                        flipped = false;
                    } else if (!flippedHorizontal && flippedVertical && !flippedAntiDiagonal) {
                        rotation = Math.PI;
                        flipped = true;
                    } else if (!flippedHorizontal && !flippedVertical && flippedAntiDiagonal) {
                        rotation = 3 * Math.PI / 2;
                        flipped = true;
                    } else if (!flippedHorizontal && !flippedVertical && !flippedAntiDiagonal) {
                        rotation = 0;
                        flipped = false;
                    }
                    return {
                        gid: gid,
                        flippedHorizontal: flippedHorizontal,
                        flippedVertical: flippedVertical,
                        flippedAntiDiagonal: flippedAntiDiagonal,
                        rotation: rotation,
                        flipped: flipped
                    };
                };
                module1.exports = ParseGID;
            /***/ },
            /***/ 12635: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                var CreateGroupLayer = __webpack_require__(79677);
                /**
 * Parses a Tiled JSON object into an array of objects with details about the image layers.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseImageLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 *
 * @return {array} Array of objects that include critical info about the map's image layers
 */ var ParseImageLayers = function(json) {
                    var images = [];
                    // State inherited from a parent group
                    var groupStack = [];
                    var curGroupState = CreateGroupLayer(json);
                    while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                        if (curGroupState.i >= curGroupState.layers.length) {
                            // Ensure recursion stack is not empty first
                            if (groupStack.length < 1) {
                                console.warn('TilemapParser.parseTiledJSON - Invalid layer group hierarchy');
                                break;
                            }
                            // Return to previous recursive state
                            curGroupState = groupStack.pop();
                            continue;
                        }
                        // Get current layer and advance iterator
                        var curi = curGroupState.layers[curGroupState.i];
                        curGroupState.i++;
                        if (curi.type !== 'imagelayer') {
                            if (curi.type === 'group') {
                                // Compute next state inherited from group
                                var nextGroupState = CreateGroupLayer(json, curi, curGroupState);
                                // Preserve current state before recursing
                                groupStack.push(curGroupState);
                                curGroupState = nextGroupState;
                            }
                            continue;
                        }
                        var layerOffsetX = GetFastValue(curi, 'offsetx', 0) + GetFastValue(curi, 'startx', 0);
                        var layerOffsetY = GetFastValue(curi, 'offsety', 0) + GetFastValue(curi, 'starty', 0);
                        images.push({
                            name: curGroupState.name + curi.name,
                            image: curi.image,
                            x: curGroupState.x + layerOffsetX + curi.x,
                            y: curGroupState.y + layerOffsetY + curi.y,
                            alpha: curGroupState.opacity * curi.opacity,
                            visible: curGroupState.visible && curi.visible,
                            properties: GetFastValue(curi, 'properties', {})
                        });
                    }
                    return images;
                };
                module1.exports = ParseImageLayers;
            /***/ },
            /***/ 46594: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AssignTileProperties = __webpack_require__(51233);
                var BuildTilesetIndex = __webpack_require__(84101);
                var CONST = __webpack_require__(91907);
                var DeepCopy = __webpack_require__(62644);
                var Formats = __webpack_require__(80341);
                var FromOrientationString = __webpack_require__(6641);
                var MapData = __webpack_require__(87010);
                var ParseImageLayers = __webpack_require__(12635);
                var ParseObjectLayers = __webpack_require__(22611);
                var ParseTileLayers = __webpack_require__(28200);
                var ParseTilesets = __webpack_require__(24619);
                /**
 * Parses a Tiled JSON object into a new MapData object.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {object} source - The original Tiled JSON object. This is deep copied by this function.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {?Phaser.Tilemaps.MapData} The created MapData object, or `null` if the data can't be parsed.
 */ var ParseJSONTiled = function(name, source, insertNull) {
                    var json = DeepCopy(source);
                    //  Map data will consist of: layers, objects, images, tilesets, sizes
                    var mapData = new MapData({
                        width: json.width,
                        height: json.height,
                        name: name,
                        tileWidth: json.tilewidth,
                        tileHeight: json.tileheight,
                        orientation: FromOrientationString(json.orientation),
                        format: Formats.TILED_JSON,
                        version: json.version,
                        properties: json.properties,
                        renderOrder: json.renderorder,
                        infinite: json.infinite
                    });
                    if (mapData.orientation === CONST.HEXAGONAL) {
                        mapData.hexSideLength = json.hexsidelength;
                        mapData.staggerAxis = json.staggeraxis;
                        mapData.staggerIndex = json.staggerindex;
                        if (mapData.staggerAxis === 'y') {
                            var triangleHeight = (mapData.tileHeight - mapData.hexSideLength) / 2;
                            mapData.widthInPixels = mapData.tileWidth * (mapData.width + 0.5);
                            mapData.heightInPixels = mapData.height * (mapData.hexSideLength + triangleHeight) + triangleHeight;
                        } else {
                            var triangleWidth = (mapData.tileWidth - mapData.hexSideLength) / 2;
                            mapData.widthInPixels = mapData.width * (mapData.hexSideLength + triangleWidth) + triangleWidth;
                            mapData.heightInPixels = mapData.tileHeight * (mapData.height + 0.5);
                        }
                    }
                    mapData.layers = ParseTileLayers(json, insertNull);
                    mapData.images = ParseImageLayers(json);
                    var sets = ParseTilesets(json);
                    mapData.tilesets = sets.tilesets;
                    mapData.imageCollections = sets.imageCollections;
                    mapData.objects = ParseObjectLayers(json);
                    mapData.tiles = BuildTilesetIndex(mapData);
                    AssignTileProperties(mapData);
                    return mapData;
                };
                module1.exports = ParseJSONTiled;
            /***/ },
            /***/ 52205: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Pick = __webpack_require__(18254);
                var ParseGID = __webpack_require__(29920);
                var copyPoints = function(p) {
                    return {
                        x: p.x,
                        y: p.y
                    };
                };
                var commonObjectProps = [
                    'id',
                    'name',
                    'type',
                    'rotation',
                    'properties',
                    'visible',
                    'x',
                    'y',
                    'width',
                    'height'
                ];
                /**
 * Convert a Tiled object to an internal parsed object normalising and copying properties over, while applying optional x and y offsets. The parsed object will always have the properties `id`, `name`, `type`, `rotation`, `properties`, `visible`, `x`, `y`, `width` and `height`. Other properties will be added according to the object type (such as text, polyline, gid etc.)
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObject
 * @since 3.0.0
 *
 * @param {object} tiledObject - Tiled object to convert to an internal parsed object normalising and copying properties over.
 * @param {number} [offsetX=0] - Optional additional offset to apply to the object's x property. Defaults to 0.
 * @param {number} [offsetY=0] - Optional additional offset to apply to the object's y property. Defaults to 0.
 *
 * @return {object} The parsed object containing properties read from the Tiled object according to it's type with x and y values updated according to the given offsets.
 */ var ParseObject = function(tiledObject, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    var parsedObject = Pick(tiledObject, commonObjectProps);
                    parsedObject.x += offsetX;
                    parsedObject.y += offsetY;
                    if (tiledObject.gid) {
                        //  Object tiles
                        var gidInfo = ParseGID(tiledObject.gid);
                        parsedObject.gid = gidInfo.gid;
                        parsedObject.flippedHorizontal = gidInfo.flippedHorizontal;
                        parsedObject.flippedVertical = gidInfo.flippedVertical;
                        parsedObject.flippedAntiDiagonal = gidInfo.flippedAntiDiagonal;
                    } else if (tiledObject.polyline) parsedObject.polyline = tiledObject.polyline.map(copyPoints);
                    else if (tiledObject.polygon) parsedObject.polygon = tiledObject.polygon.map(copyPoints);
                    else if (tiledObject.ellipse) parsedObject.ellipse = tiledObject.ellipse;
                    else if (tiledObject.text) parsedObject.text = tiledObject.text;
                    else if (tiledObject.point) parsedObject.point = true;
                    else // Otherwise, assume it is a rectangle
                    parsedObject.rectangle = true;
                    return parsedObject;
                };
                module1.exports = ParseObject;
            /***/ },
            /***/ 22611: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(95540);
                var ParseObject = __webpack_require__(52205);
                var ObjectLayer = __webpack_require__(48700);
                var CreateGroupLayer = __webpack_require__(79677);
                /**
 * Parses a Tiled JSON object into an array of ObjectLayer objects.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObjectLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 *
 * @return {array} An array of all object layers in the tilemap as `ObjectLayer`s.
 */ var ParseObjectLayers = function(json) {
                    var objectLayers = [];
                    // State inherited from a parent group
                    var groupStack = [];
                    var curGroupState = CreateGroupLayer(json);
                    while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                        if (curGroupState.i >= curGroupState.layers.length) {
                            // Ensure recursion stack is not empty first
                            if (groupStack.length < 1) {
                                console.warn('TilemapParser.parseTiledJSON - Invalid layer group hierarchy');
                                break;
                            }
                            // Return to previous recursive state
                            curGroupState = groupStack.pop();
                            continue;
                        }
                        // Get current layer and advance iterator
                        var curo = curGroupState.layers[curGroupState.i];
                        curGroupState.i++;
                        // Modify inherited properties
                        curo.opacity *= curGroupState.opacity;
                        curo.visible = curGroupState.visible && curo.visible;
                        if (curo.type !== 'objectgroup') {
                            if (curo.type === 'group') {
                                // Compute next state inherited from group
                                var nextGroupState = CreateGroupLayer(json, curo, curGroupState);
                                // Preserve current state before recursing
                                groupStack.push(curGroupState);
                                curGroupState = nextGroupState;
                            }
                            continue;
                        }
                        curo.name = curGroupState.name + curo.name;
                        var offsetX = curGroupState.x + GetFastValue(curo, 'startx', 0) + GetFastValue(curo, 'offsetx', 0);
                        var offsetY = curGroupState.y + GetFastValue(curo, 'starty', 0) + GetFastValue(curo, 'offsety', 0);
                        var objects = [];
                        for(var j = 0; j < curo.objects.length; j++){
                            var parsedObject = ParseObject(curo.objects[j], offsetX, offsetY);
                            objects.push(parsedObject);
                        }
                        var objectLayer = new ObjectLayer(curo);
                        objectLayer.objects = objects;
                        objectLayers.push(objectLayer);
                    }
                    return objectLayers;
                };
                module1.exports = ParseObjectLayers;
            /***/ },
            /***/ 28200: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Base64Decode = __webpack_require__(41868);
                var CONST = __webpack_require__(91907);
                var CreateGroupLayer = __webpack_require__(79677);
                var FromOrientationString = __webpack_require__(6641);
                var GetFastValue = __webpack_require__(95540);
                var LayerData = __webpack_require__(14977);
                var ParseGID = __webpack_require__(29920);
                var Tile = __webpack_require__(23029);
                /**
 * Parses all tilemap layers in a Tiled JSON object into new LayerData objects.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTileLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled (see {@link Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled}).
 *
 * @return {Phaser.Tilemaps.LayerData[]} - An array of LayerData objects, one for each entry in
 * json.layers with the type 'tilelayer'.
 */ var ParseTileLayers = function(json, insertNull) {
                    var infiniteMap = GetFastValue(json, 'infinite', false);
                    var tileLayers = [];
                    // State inherited from a parent group
                    var groupStack = [];
                    var curGroupState = CreateGroupLayer(json);
                    while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                        if (curGroupState.i >= curGroupState.layers.length) {
                            // Ensure recursion stack is not empty first
                            if (groupStack.length < 1) {
                                console.warn('TilemapParser.parseTiledJSON - Invalid layer group hierarchy');
                                break;
                            }
                            // Return to previous recursive state
                            curGroupState = groupStack.pop();
                            continue;
                        }
                        var curl = curGroupState.layers[curGroupState.i];
                        curGroupState.i++;
                        if (curl.type !== 'tilelayer') {
                            if (curl.type === 'group') {
                                // Compute next state inherited from group
                                var nextGroupState = CreateGroupLayer(json, curl, curGroupState);
                                // Preserve current state before recursing
                                groupStack.push(curGroupState);
                                curGroupState = nextGroupState;
                            }
                            continue;
                        }
                        // Base64 decode data if necessary. NOTE: uncompressed base64 only.
                        if (curl.compression) {
                            console.warn('TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer \'' + curl.name + '\'');
                            continue;
                        } else if (curl.encoding && curl.encoding === 'base64') {
                            // Chunks for an infinite map
                            if (curl.chunks) for(var i = 0; i < curl.chunks.length; i++)curl.chunks[i].data = Base64Decode(curl.chunks[i].data);
                            // Non-infinite map data
                            if (curl.data) curl.data = Base64Decode(curl.data);
                            delete curl.encoding; // Allow the same map to be parsed multiple times
                        }
                        //  This is an array containing the tile indexes, one after the other. -1 = no tile,
                        //  everything else = the tile index (starting at 1 for Tiled, 0 for CSV) If the map
                        //  contains multiple tilesets then the indexes are relative to that which the set starts
                        //  from. Need to set which tileset in the cache = which tileset in the JSON, if you do this
                        //  manually it means you can use the same map data but a new tileset.
                        var layerData;
                        var gidInfo;
                        var tile;
                        var blankTile;
                        var triangleHeight;
                        var triangleWidth;
                        var output = [];
                        var x = 0;
                        if (infiniteMap) {
                            var layerOffsetX = GetFastValue(curl, 'startx', 0) + curl.x;
                            var layerOffsetY = GetFastValue(curl, 'starty', 0) + curl.y;
                            layerData = new LayerData({
                                name: curGroupState.name + curl.name,
                                id: curl.id,
                                x: curGroupState.x + GetFastValue(curl, 'offsetx', 0) + layerOffsetX * json.tilewidth,
                                y: curGroupState.y + GetFastValue(curl, 'offsety', 0) + layerOffsetY * json.tileheight,
                                width: curl.width,
                                height: curl.height,
                                tileWidth: json.tilewidth,
                                tileHeight: json.tileheight,
                                alpha: curGroupState.opacity * curl.opacity,
                                visible: curGroupState.visible && curl.visible,
                                properties: GetFastValue(curl, 'properties', []),
                                orientation: FromOrientationString(json.orientation)
                            });
                            if (layerData.orientation === CONST.HEXAGONAL) {
                                layerData.hexSideLength = json.hexsidelength;
                                layerData.staggerAxis = json.staggeraxis;
                                layerData.staggerIndex = json.staggerindex;
                                if (layerData.staggerAxis === 'y') {
                                    triangleHeight = (layerData.tileHeight - layerData.hexSideLength) / 2;
                                    layerData.widthInPixels = layerData.tileWidth * (layerData.width + 0.5);
                                    layerData.heightInPixels = layerData.height * (layerData.hexSideLength + triangleHeight) + triangleHeight;
                                } else {
                                    triangleWidth = (layerData.tileWidth - layerData.hexSideLength) / 2;
                                    layerData.widthInPixels = layerData.width * (layerData.hexSideLength + triangleWidth) + triangleWidth;
                                    layerData.heightInPixels = layerData.tileHeight * (layerData.height + 0.5);
                                }
                            }
                            for(var c = 0; c < curl.height; c++){
                                output[c] = [
                                    null
                                ];
                                for(var j = 0; j < curl.width; j++)output[c][j] = null;
                            }
                            for(c = 0, len = curl.chunks.length; c < len; c++){
                                var chunk = curl.chunks[c];
                                var offsetX = chunk.x - layerOffsetX;
                                var offsetY = chunk.y - layerOffsetY;
                                var y = 0;
                                for(var t = 0, len2 = chunk.data.length; t < len2; t++){
                                    var newOffsetX = x + offsetX;
                                    var newOffsetY = y + offsetY;
                                    gidInfo = ParseGID(chunk.data[t]);
                                    //  index, x, y, width, height
                                    if (gidInfo.gid > 0) {
                                        tile = new Tile(layerData, gidInfo.gid, newOffsetX, newOffsetY, json.tilewidth, json.tileheight);
                                        // Turning Tiled's FlippedHorizontal, FlippedVertical and FlippedAntiDiagonal
                                        // propeties into flipX, flipY and rotation
                                        tile.rotation = gidInfo.rotation;
                                        tile.flipX = gidInfo.flipped;
                                        output[newOffsetY][newOffsetX] = tile;
                                    } else {
                                        blankTile = insertNull ? null : new Tile(layerData, -1, newOffsetX, newOffsetY, json.tilewidth, json.tileheight);
                                        output[newOffsetY][newOffsetX] = blankTile;
                                    }
                                    x++;
                                    if (x === chunk.width) {
                                        y++;
                                        x = 0;
                                    }
                                }
                            }
                        } else {
                            layerData = new LayerData({
                                name: curGroupState.name + curl.name,
                                id: curl.id,
                                x: curGroupState.x + GetFastValue(curl, 'offsetx', 0) + curl.x,
                                y: curGroupState.y + GetFastValue(curl, 'offsety', 0) + curl.y,
                                width: curl.width,
                                height: curl.height,
                                tileWidth: json.tilewidth,
                                tileHeight: json.tileheight,
                                alpha: curGroupState.opacity * curl.opacity,
                                visible: curGroupState.visible && curl.visible,
                                properties: GetFastValue(curl, 'properties', []),
                                orientation: FromOrientationString(json.orientation)
                            });
                            if (layerData.orientation === CONST.HEXAGONAL) {
                                layerData.hexSideLength = json.hexsidelength;
                                layerData.staggerAxis = json.staggeraxis;
                                layerData.staggerIndex = json.staggerindex;
                                if (layerData.staggerAxis === 'y') {
                                    triangleHeight = (layerData.tileHeight - layerData.hexSideLength) / 2;
                                    layerData.widthInPixels = layerData.tileWidth * (layerData.width + 0.5);
                                    layerData.heightInPixels = layerData.height * (layerData.hexSideLength + triangleHeight) + triangleHeight;
                                } else {
                                    triangleWidth = (layerData.tileWidth - layerData.hexSideLength) / 2;
                                    layerData.widthInPixels = layerData.width * (layerData.hexSideLength + triangleWidth) + triangleWidth;
                                    layerData.heightInPixels = layerData.tileHeight * (layerData.height + 0.5);
                                }
                            }
                            var row = [];
                            //  Loop through the data field in the JSON.
                            for(var k = 0, len = curl.data.length; k < len; k++){
                                gidInfo = ParseGID(curl.data[k]);
                                //  index, x, y, width, height
                                if (gidInfo.gid > 0) {
                                    tile = new Tile(layerData, gidInfo.gid, x, output.length, json.tilewidth, json.tileheight);
                                    // Turning Tiled's FlippedHorizontal, FlippedVertical and FlippedAntiDiagonal
                                    // propeties into flipX, flipY and rotation
                                    tile.rotation = gidInfo.rotation;
                                    tile.flipX = gidInfo.flipped;
                                    row.push(tile);
                                } else {
                                    blankTile = insertNull ? null : new Tile(layerData, -1, x, output.length, json.tilewidth, json.tileheight);
                                    row.push(blankTile);
                                }
                                x++;
                                if (x === curl.width) {
                                    output.push(row);
                                    x = 0;
                                    row = [];
                                }
                            }
                        }
                        layerData.data = output;
                        tileLayers.push(layerData);
                    }
                    return tileLayers;
                };
                module1.exports = ParseTileLayers;
            /***/ },
            /***/ 24619: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(33629);
                var ImageCollection = __webpack_require__(16536);
                var ParseObject = __webpack_require__(52205);
                var ParseWangsets = __webpack_require__(57880);
                /**
 * Tilesets and Image Collections.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTilesets
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON data.
 *
 * @return {object} An object containing the tileset and image collection data.
 */ var ParseTilesets = function(json) {
                    var tilesets = [];
                    var imageCollections = [];
                    var lastSet = null;
                    var stringID;
                    for(var i = 0; i < json.tilesets.length; i++){
                        //  name, firstgid, width, height, margin, spacing, properties
                        var set = json.tilesets[i];
                        if (set.source) console.warn('External tilesets unsupported. Use Embed Tileset and re-export');
                        else if (set.image) {
                            var newSet = new Tileset(set.name, set.firstgid, set.tilewidth, set.tileheight, set.margin, set.spacing, undefined, undefined, set.tileoffset);
                            if (json.version > 1) {
                                var datas = undefined;
                                var props = undefined;
                                if (Array.isArray(set.tiles)) {
                                    datas = datas || {};
                                    props = props || {};
                                    // Tiled 1.2+
                                    for(var t = 0; t < set.tiles.length; t++){
                                        var tile = set.tiles[t];
                                        //  Convert tileproperties.
                                        if (tile.properties) {
                                            var newPropData = {};
                                            tile.properties.forEach(function(propData) {
                                                newPropData[propData['name']] = propData['value'];
                                            });
                                            props[tile.id] = newPropData;
                                        }
                                        //  Convert objectgroup
                                        if (tile.objectgroup) {
                                            (datas[tile.id] || (datas[tile.id] = {})).objectgroup = tile.objectgroup;
                                            if (tile.objectgroup.objects) {
                                                var parsedObjects2 = tile.objectgroup.objects.map(function(obj) {
                                                    return ParseObject(obj);
                                                });
                                                datas[tile.id].objectgroup.objects = parsedObjects2;
                                            }
                                        }
                                        // Copy animation data
                                        if (tile.animation) (datas[tile.id] || (datas[tile.id] = {})).animation = tile.animation;
                                        // Copy tile `type` field
                                        // (see https://doc.mapeditor.org/en/latest/manual/custom-properties/#typed-tiles).
                                        if (tile.type) (datas[tile.id] || (datas[tile.id] = {})).type = tile.type;
                                    }
                                }
                                if (Array.isArray(set.wangsets)) {
                                    datas = datas || {};
                                    props = props || {};
                                    ParseWangsets(set.wangsets, datas);
                                }
                                if (datas) {
                                    newSet.tileData = datas;
                                    newSet.tileProperties = props;
                                }
                            } else {
                                // Tiled 1
                                // Properties stored per-tile in object with string indexes starting at "0"
                                if (set.tileproperties) newSet.tileProperties = set.tileproperties;
                                // Object & terrain shapes stored per-tile in object with string indexes starting at "0"
                                if (set.tiles) {
                                    newSet.tileData = set.tiles;
                                    // Parse the objects into Phaser format to match handling of other Tiled objects
                                    for(stringID in newSet.tileData){
                                        var objectGroup = newSet.tileData[stringID].objectgroup;
                                        if (objectGroup && objectGroup.objects) {
                                            var parsedObjects1 = objectGroup.objects.map(function(obj) {
                                                return ParseObject(obj);
                                            });
                                            newSet.tileData[stringID].objectgroup.objects = parsedObjects1;
                                        }
                                    }
                                }
                            }
                            // For a normal sliced tileset the row/count/size information is computed when updated.
                            // This is done (again) after the image is set.
                            newSet.updateTileData(set.imagewidth, set.imageheight);
                            tilesets.push(newSet);
                        } else {
                            var newCollection = new ImageCollection(set.name, set.firstgid, set.tilewidth, set.tileheight, set.margin, set.spacing, set.properties);
                            var maxId = 0;
                            for(t = 0; t < set.tiles.length; t++){
                                tile = set.tiles[t];
                                var image = tile.image;
                                var tileId = parseInt(tile.id, 10);
                                var gid = set.firstgid + tileId;
                                var width = tile.imagewidth;
                                var height = tile.imageheight;
                                newCollection.addImage(gid, image, width, height);
                                maxId = Math.max(tileId, maxId);
                            }
                            newCollection.maxId = maxId;
                            imageCollections.push(newCollection);
                        }
                        //  We've got a new Tileset, so set the lastgid into the previous one
                        if (lastSet) lastSet.lastgid = set.firstgid - 1;
                        lastSet = set;
                    }
                    return {
                        tilesets: tilesets,
                        imageCollections: imageCollections
                    };
                };
                module1.exports = ParseTilesets;
            /***/ },
            /***/ 57880: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Parses out the Wangset information from Tiled 1.1.5+ map data, if present.
 *
 * Since a given tile can be in more than one wangset, the resulting properties
 * are nested. `tile.data.wangid[someWangsetName]` will return the array-based wang id in
 * this implementation.
 *
 * Note that we're not guaranteed that there will be any 'normal' tiles if the only
 * thing in the tilset are wangtile definitions, so this has to be parsed separately.
 *
 * See https://doc.mapeditor.org/en/latest/manual/using-wang-tiles/ for more information.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseWangsets
 * @since 3.53.0
 *
 * @param {Array.<object>} wangsets - The array of wangset objects (parsed from JSON)
 * @param {object} datas - The field into which to put wangset data from Tiled.
 *
 * @return {object} An object containing the tileset and image collection data.
 */ var ParseWangsets = function(wangsets, datas) {
                    for(var w = 0; w < wangsets.length; w++){
                        var wangset = wangsets[w];
                        var identifier = w;
                        if (wangset.name && wangset.name !== '') identifier = wangset.name;
                        if (Array.isArray(wangset.wangtiles) && wangset.wangtiles.length > 0) {
                            var edgeColors = {};
                            var cornerColors = {};
                            var c;
                            var color;
                            var colorIndex;
                            // Tiled before v2020.09.09
                            if (Array.isArray(wangset.edgecolors)) for(c = 0; c < wangset.edgecolors.length; c++){
                                colorIndex = 1 + c;
                                color = wangset.edgecolors[c];
                                if (color.name !== '') edgeColors[colorIndex] = color.name;
                            }
                            if (Array.isArray(wangset.cornercolors)) for(c = 0; c < wangset.cornercolors.length; c++){
                                colorIndex = 1 + c;
                                color = wangset.cornercolors[c];
                                if (color.name !== '') cornerColors[colorIndex] = color.name;
                            }
                            // Tiled after v2020.09.09
                            if (Array.isArray(wangset.colors)) for(c = 0; c < wangset.colors.length; c++){
                                color = wangset.colors[c];
                                colorIndex = 1 + c;
                                if (color.name !== '') edgeColors[colorIndex] = cornerColors[colorIndex] = color.name;
                            }
                            // The wangid layout is north, northeast, east, southeast, etc.
                            var idLayout = [
                                edgeColors,
                                cornerColors,
                                edgeColors,
                                cornerColors,
                                edgeColors,
                                cornerColors,
                                edgeColors,
                                cornerColors
                            ];
                            for(var t = 0; t < wangset.wangtiles.length; t++){
                                var wangtile = wangset.wangtiles[t];
                                var obj = datas[wangtile.tileid] || (datas[wangtile.tileid] = {});
                                obj = obj.wangid || (obj.wangid = {});
                                var wangid = [];
                                for(var i = 0; i < Math.min(idLayout.length, wangtile.wangid.length); i++){
                                    color = wangtile.wangid[i];
                                    if (color === 0) {
                                        wangid.push(undefined);
                                        continue;
                                    }
                                    var renamed = idLayout[i][color];
                                    if (renamed !== undefined) {
                                        wangid.push(renamed);
                                        continue;
                                    }
                                    wangid.push(color);
                                }
                                obj[identifier] = wangid;
                            }
                        }
                    }
                };
                module1.exports = ParseWangsets;
            /***/ },
            /***/ 96761: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers.Tiled
 */ module1.exports = {
                    AssignTileProperties: __webpack_require__(51233),
                    Base64Decode: __webpack_require__(41868),
                    BuildTilesetIndex: __webpack_require__(84101),
                    CreateGroupLayer: __webpack_require__(79677),
                    ParseGID: __webpack_require__(29920),
                    ParseImageLayers: __webpack_require__(12635),
                    ParseJSONTiled: __webpack_require__(46594),
                    ParseObject: __webpack_require__(52205),
                    ParseObjectLayers: __webpack_require__(22611),
                    ParseTileLayers: __webpack_require__(28200),
                    ParseTilesets: __webpack_require__(24619)
                };
            /***/ },
            /***/ 33385: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                var TimerEvent = __webpack_require__(94880);
                var Remove = __webpack_require__(72905);
                /**
 * @classdesc
 * The Clock is a Scene plugin which creates and updates Timer Events for its Scene.
 *
 * @class Clock
 * @memberof Phaser.Time
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Clock.
 */ var Clock = new Class({
                    initialize: function Clock(scene) {
                        /**
         * The Scene which owns this Clock.
         *
         * @name Phaser.Time.Clock#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * The Scene Systems object of the Scene which owns this Clock.
         *
         * @name Phaser.Time.Clock#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                        /**
         * The current time of the Clock, in milliseconds.
         *
         * If accessed externally, this is equivalent to the `time` parameter normally passed to a Scene's `update` method.
         *
         * @name Phaser.Time.Clock#now
         * @type {number}
         * @since 3.0.0
         */ this.now = 0;
                        /**
         * The time the Clock (and Scene) started, in milliseconds.
         *
         * This can be compared to the `time` parameter passed to a Scene's `update` method.
         *
         * @name Phaser.Time.Clock#startTime
         * @type {number}
         * @since 3.60.0
         */ this.startTime = 0;
                        /**
         * The scale of the Clock's time delta.
         *
         * The time delta is the time elapsed between two consecutive frames and influences the speed of time for this Clock and anything which uses it, such as its Timer Events. Values higher than 1 increase the speed of time, while values smaller than 1 decrease it. A value of 0 freezes time and is effectively equivalent to pausing the Clock.
         *
         * @name Phaser.Time.Clock#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                        /**
         * Whether the Clock is paused (`true`) or active (`false`).
         *
         * When paused, the Clock will not update any of its Timer Events, thus freezing time.
         *
         * @name Phaser.Time.Clock#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                        /**
         * An array of all Timer Events whose delays haven't expired - these are actively updating Timer Events.
         *
         * @name Phaser.Time.Clock#_active
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._active = [];
                        /**
         * An array of all Timer Events which will be added to the Clock at the start of the next frame.
         *
         * @name Phaser.Time.Clock#_pendingInsertion
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingInsertion = [];
                        /**
         * An array of all Timer Events which will be removed from the Clock at the start of the next frame.
         *
         * @name Phaser.Time.Clock#_pendingRemoval
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingRemoval = [];
                        scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                        scene.sys.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Time.Clock#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        //  Sync with the TimeStep
                        this.now = this.systems.game.loop.time;
                        this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Time.Clock#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        this.startTime = this.systems.game.loop.time;
                        var eventEmitter = this.systems.events;
                        eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                        eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                        eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Creates a Timer Event and adds it to this Clock at the start of the next frame.
     *
     * You can pass in either a `TimerEventConfig` object, from with a new `TimerEvent` will
     * be created, or you can pass in a `TimerEvent` instance.
     *
     * If passing an instance please make sure that this instance hasn't been used before.
     * If it has ever entered a 'completed' state then it will no longer be suitable to
     * run again.
     *
     * Also, if the `TimerEvent` instance is being used by _another_ Clock (in another Scene)
     * it will still be updated by that Clock as well, so be careful when using this feature.
     *
     * @method Phaser.Time.Clock#addEvent
     * @since 3.0.0
     *
     * @param {(Phaser.Time.TimerEvent | Phaser.Types.Time.TimerEventConfig)} config - The configuration for the Timer Event, or an existing Timer Event object.
     *
     * @return {Phaser.Time.TimerEvent} The Timer Event which was created, or passed in.
     */ addEvent: function(config) {
                        var event;
                        if (config instanceof TimerEvent) {
                            event = config;
                            this.removeEvent(event);
                            event.elapsed = event.startAt;
                            event.hasDispatched = false;
                            event.repeatCount = event.repeat === -1 || event.loop ? 999999999999 : event.repeat;
                            if (event.delay <= 0 && event.repeatCount > 0) throw new Error('TimerEvent infinite loop created via zero delay');
                        } else event = new TimerEvent(config);
                        this._pendingInsertion.push(event);
                        return event;
                    },
                    /**
     * Creates a Timer Event and adds it to the Clock at the start of the frame.
     *
     * This is a shortcut for {@link #addEvent} which can be shorter and is compatible with the syntax of the GreenSock Animation Platform (GSAP).
     *
     * @method Phaser.Time.Clock#delayedCall
     * @since 3.0.0
     *
     * @param {number} delay - The delay of the function call, in milliseconds.
     * @param {function} callback - The function to call after the delay expires.
     * @param {Array.<*>} [args] - The arguments to call the function with.
     * @param {*} [callbackScope] - The scope (`this` object) to call the function with.
     *
     * @return {Phaser.Time.TimerEvent} The Timer Event which was created.
     */ delayedCall: function(delay, callback, args, callbackScope) {
                        return this.addEvent({
                            delay: delay,
                            callback: callback,
                            args: args,
                            callbackScope: callbackScope
                        });
                    },
                    /**
     * Clears and recreates the array of pending Timer Events.
     *
     * @method Phaser.Time.Clock#clearPendingEvents
     * @since 3.0.0
     *
     * @return {this} - This Clock instance.
     */ clearPendingEvents: function() {
                        this._pendingInsertion = [];
                        return this;
                    },
                    /**
     * Removes the given Timer Event, or an array of Timer Events, from this Clock.
     *
     * The events are removed from all internal lists (active, pending and removal),
     * freeing the event up to be re-used.
     *
     * @method Phaser.Time.Clock#removeEvent
     * @since 3.50.0
     *
     * @param {(Phaser.Time.TimerEvent | Phaser.Time.TimerEvent[])} events - The Timer Event, or an array of Timer Events, to remove from this Clock.
     *
     * @return {this} - This Clock instance.
     */ removeEvent: function(events) {
                        if (!Array.isArray(events)) events = [
                            events
                        ];
                        for(var i = 0; i < events.length; i++){
                            var event = events[i];
                            Remove(this._pendingRemoval, event);
                            Remove(this._pendingInsertion, event);
                            Remove(this._active, event);
                        }
                        return this;
                    },
                    /**
     * Schedules all active Timer Events for removal at the start of the frame.
     *
     * @method Phaser.Time.Clock#removeAllEvents
     * @since 3.0.0
     *
     * @return {this} - This Clock instance.
     */ removeAllEvents: function() {
                        this._pendingRemoval = this._pendingRemoval.concat(this._active);
                        return this;
                    },
                    /**
     * Updates the arrays of active and pending Timer Events. Called at the start of the frame.
     *
     * @method Phaser.Time.Clock#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ preUpdate: function() {
                        var toRemove = this._pendingRemoval.length;
                        var toInsert = this._pendingInsertion.length;
                        if (toRemove === 0 && toInsert === 0) //  Quick bail
                        return;
                        var i;
                        var event;
                        //  Delete old events
                        for(i = 0; i < toRemove; i++){
                            event = this._pendingRemoval[i];
                            var index = this._active.indexOf(event);
                            if (index > -1) this._active.splice(index, 1);
                            //  Pool them?
                            event.destroy();
                        }
                        for(i = 0; i < toInsert; i++){
                            event = this._pendingInsertion[i];
                            this._active.push(event);
                        }
                        //  Clear the lists
                        this._pendingRemoval.length = 0;
                        this._pendingInsertion.length = 0;
                    },
                    /**
     * Updates the Clock's internal time and all of its Timer Events.
     *
     * @method Phaser.Time.Clock#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(time, delta) {
                        this.now = time;
                        if (this.paused) return;
                        delta *= this.timeScale;
                        for(var i = 0; i < this._active.length; i++){
                            var event = this._active[i];
                            if (event.paused) continue;
                            //  Use delta time to increase elapsed.
                            //  Avoids needing to adjust for pause / resume.
                            //  Automatically smoothed by TimeStep class.
                            //  In testing accurate to +- 1ms!
                            event.elapsed += delta * event.timeScale;
                            if (event.elapsed >= event.delay) {
                                var remainder = event.elapsed - event.delay;
                                //  Limit it, in case it's checked in the callback
                                event.elapsed = event.delay;
                                //  Process the event
                                if (!event.hasDispatched && event.callback) {
                                    event.hasDispatched = true;
                                    event.callback.apply(event.callbackScope, event.args);
                                }
                                if (event.repeatCount > 0) {
                                    event.repeatCount--;
                                    // Very short delay
                                    if (remainder >= event.delay) while(remainder >= event.delay && event.repeatCount > 0){
                                        if (event.callback) event.callback.apply(event.callbackScope, event.args);
                                        remainder -= event.delay;
                                        event.repeatCount--;
                                    }
                                    event.elapsed = remainder;
                                    event.hasDispatched = false;
                                } else if (event.hasDispatched) this._pendingRemoval.push(event);
                            }
                        }
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Time.Clock#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                        var i;
                        for(i = 0; i < this._pendingInsertion.length; i++)this._pendingInsertion[i].destroy();
                        for(i = 0; i < this._active.length; i++)this._active[i].destroy();
                        for(i = 0; i < this._pendingRemoval.length; i++)this._pendingRemoval[i].destroy();
                        this._active.length = 0;
                        this._pendingRemoval.length = 0;
                        this._pendingInsertion.length = 0;
                        var eventEmitter = this.systems.events;
                        eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                        eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                        eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Time.Clock#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.scene.sys.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.systems = null;
                    }
                });
                PluginCache.register('Clock', Clock, 'time');
                module1.exports = Clock;
            /***/ },
            /***/ 96120: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var GameObjectFactory = __webpack_require__(39429);
                var GetFastValue = __webpack_require__(95540);
                var SceneEvents = __webpack_require__(44594);
                var Events = __webpack_require__(89809);
                /**
 * @classdesc
 * A Timeline is a way to schedule events to happen at specific times in the future.
 *
 * You can think of it as an event sequencer for your game, allowing you to schedule the
 * running of callbacks, events and other actions at specific times in the future.
 *
 * A Timeline is a Scene level system, meaning you can have as many Timelines as you like, each
 * belonging to a different Scene. You can also have multiple Timelines running at the same time.
 *
 * If the Scene is paused, the Timeline will also pause. If the Scene is destroyed, the Timeline
 * will be automatically destroyed. However, you can control the Timeline directly, pausing,
 * resuming and stopping it at any time.
 *
 * Create an instance of a Timeline via the Game Object Factory:
 *
 * ```js
 * const timeline = this.add.timeline();
 * ```
 *
 * The Timeline always starts paused. You must call `play` on it to start it running.
 *
 * You can also pass in a configuration object on creation, or an array of them:
 *
 * ```js
 * const timeline = this.add.timeline({
 *     at: 1000,
 *     run: () => {
 *         this.add.sprite(400, 300, 'logo');
 *     }
 * });
 *
 * timeline.play();
 * ```
 *
 * In this example we sequence a few different events:
 *
 * ```js
 * const timeline = this.add.timeline([
 *     {
 *         at: 1000,
 *         run: () => { this.logo = this.add.sprite(400, 300, 'logo'); },
 *         sound: 'TitleMusic'
 *     },
 *     {
 *         at: 2500,
 *         tween: {
 *             targets: this.logo,
 *             y: 600,
 *             yoyo: true
 *         },
 *         sound: 'Explode'
 *     },
 *     {
 *         at: 8000,
 *         event: 'HURRY_PLAYER',
 *         target: this.background,
 *         set: {
 *             tint: 0xff0000
 *         }
 *     }
 * ]);
 *
 * timeline.play();
 * ```
 *
 * The Timeline can also be looped with the repeat method:
 * ```js
 * timeline.repeat().play();
 * ```
 * 
 * There are lots of options available to you via the configuration object. See the
 * {@link Phaser.Types.Time.TimelineEventConfig} typedef for more details.
 *
 * @class Timeline
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Time
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Timeline.
 * @param {Phaser.Types.Time.TimelineEventConfig|Phaser.Types.Time.TimelineEventConfig[]} [config] - The configuration object for this Timeline Event, or an array of them.
 */ var Timeline = new Class({
                    Extends: EventEmitter,
                    initialize: function Timeline(scene, config) {
                        EventEmitter.call(this);
                        /**
         * The Scene to which this Timeline belongs.
         *
         * @name Phaser.Time.Timeline#scene
         * @type {Phaser.Scene}
         * @since 3.60.0
         */ this.scene = scene;
                        /**
         * A reference to the Scene Systems.
         *
         * @name Phaser.Time.Timeline#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.60.0
         */ this.systems = scene.sys;
                        /**
         * The elapsed time counter.
         *
         * Treat this as read-only.
         *
         * @name Phaser.Time.Timeline#elapsed
         * @type {number}
         * @since 3.60.0
         */ this.elapsed = 0;
                        /**
         * The Timeline's delta time scale.
         *
         * Values higher than 1 increase the speed of time, while values smaller than 1 decrease it.
         * A value of 0 freezes time and is effectively equivalent to pausing the Timeline.
         *
         * This doesn't affect the delta time scale of any Tweens created by the Timeline.
         * You will have to set the `timeScale` of each Tween or the Tween Manager if you want them to match.
         *
         * @name Phaser.Time.Timeline#timeScale
         * @type {number}
         * @default
         * @since 3.85.0
         */ this.timeScale = 1;
                        /**
         * Whether the Timeline is running (`true`) or active (`false`).
         *
         * When paused, the Timeline will not run any of its actions.
         *
         * By default a Timeline is always paused and should be started by
         * calling the `Timeline.play` method.
         *
         * You can use the `Timeline.pause` and `Timeline.resume` methods to control
         * this value in a chainable way.
         *
         * @name Phaser.Time.Timeline#paused
         * @type {boolean}
         * @default true
         * @since 3.60.0
         */ this.paused = true;
                        /**
         * Whether the Timeline is complete (`true`) or not (`false`).
         *
         * A Timeline is considered complete when all of its events have been run.
         *
         * If you wish to reset a Timeline after it has completed, you can do so
         * by calling the `Timeline.reset` method.
         *
         * You can also use the `Timeline.stop` method to stop a running Timeline,
         * at any point, without resetting it.
         *
         * @name Phaser.Time.Timeline#complete
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.complete = false;
                        /**
         * The total number of events that have been run.
         *
         * This value is reset to zero if the Timeline is restarted.
         *
         * Treat this as read-only.
         *
         * @name Phaser.Time.Timeline#totalComplete
         * @type {number}
         * @since 3.60.0
         */ this.totalComplete = 0;
                        /**
         * The number of times this timeline should loop.
         *
         * If this value is -1 or any negative number this Timeline will not stop. 
         *
         * @name Phaser.Time.Timeline#loop
         * @type {number}
         * @since 3.80.0
         */ this.loop = 0;
                        /**
         * The number of times this Timeline has looped.
         *
         * This value is incremented each loop if looping is enabled.
         *
         * @name Phaser.Time.Timeline#iteration
         * @type {number}
         * @since 3.80.0
         */ this.iteration = 0;
                        /**
         * An array of all the Timeline Events.
         *
         * @name Phaser.Time.Timeline#events
         * @type {Phaser.Types.Time.TimelineEvent[]}
         * @since 3.60.0
         */ this.events = [];
                        var eventEmitter = this.systems.events;
                        eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                        eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                        eventEmitter.once(SceneEvents.SHUTDOWN, this.destroy, this);
                        if (config) this.add(config);
                    },
                    /**
     * Updates the elapsed time counter, if this Timeline is not paused.
     *
     * @method Phaser.Time.Timeline#preUpdate
     * @since 3.60.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ preUpdate: function(time, delta) {
                        if (this.paused) return;
                        this.elapsed += delta * this.timeScale;
                    },
                    /**
     * Called automatically by the Scene update step.
     *
     * Iterates through all of the Timeline Events and checks to see if they should be run.
     *
     * If they should be run, then the `TimelineEvent.action` callback is invoked.
     *
     * If the `TimelineEvent.once` property is `true` then the event is removed from the Timeline.
     *
     * If the `TimelineEvent.event` property is set then the Timeline emits that event.
     *
     * If the `TimelineEvent.run` property is set then the Timeline invokes that method.
     * 
     * If the `TimelineEvent.loop` property is set then the Timeline invokes that method when repeated.
     *
     * If the `TimelineEvent.target` property is set then the Timeline invokes the `run` method on that target.
     *
     * @method Phaser.Time.Timeline#update
     * @fires Phaser.Time.Events#COMPLETE
     * @since 3.60.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function() {
                        if (this.paused || this.complete) return;
                        var i;
                        var events = this.events;
                        var removeSweep = false;
                        var sys = this.systems;
                        var target;
                        for(i = 0; i < events.length; i++){
                            var event = events[i];
                            if (!event.complete && event.time <= this.elapsed) {
                                event.complete = true;
                                this.totalComplete++;
                                target = event.target ? event.target : this;
                                if (event.if) {
                                    if (!event.if.call(target, event)) continue;
                                }
                                if (event.once) removeSweep = true;
                                if (event.set && event.target) //  set is an object of key value pairs, apply them to target
                                for(var key in event.set)event.target[key] = event.set[key];
                                if (this.iteration) event.repeat++;
                                if (event.loop && event.repeat) event.loop.call(target);
                                if (event.tween) event.tweenInstance = sys.tweens.add(event.tween);
                                if (event.sound) {
                                    if (typeof event.sound === 'string') sys.sound.play(event.sound);
                                    else sys.sound.play(event.sound.key, event.sound.config);
                                }
                                if (event.event) this.emit(event.event, target);
                                if (event.run) event.run.call(target);
                                if (event.stop) this.stop();
                            }
                        }
                        if (removeSweep) {
                            for(i = 0; i < events.length; i++)if (events[i].complete && events[i].once) {
                                events.splice(i, 1);
                                i--;
                            }
                        }
                        //  It may be greater than the length if events have been removed
                        if (this.totalComplete >= events.length) {
                            if (this.loop !== 0 && (this.loop === -1 || this.loop > this.iteration)) {
                                this.iteration++;
                                this.reset(true);
                            } else this.complete = true;
                        }
                        if (this.complete) this.emit(Events.COMPLETE, this);
                    },
                    /**
     * Starts this Timeline running.
     *
     * If the Timeline is already running and the `fromStart` parameter is `true`,
     * then calling this method will reset the Timeline events as incomplete.
     *
     * If you wish to resume a paused Timeline, then use the `Timeline.resume` method instead.
     *
     * @method Phaser.Time.Timeline#play
     * @since 3.60.0
     *
     * @param {boolean} [fromStart=true] - Reset this Timeline back to the start before playing.
     *
     * @return {this} This Timeline instance.
     */ play: function(fromStart) {
                        if (fromStart === undefined) fromStart = true;
                        this.paused = false;
                        this.complete = false;
                        this.totalComplete = 0;
                        if (fromStart) this.reset();
                        return this;
                    },
                    /**
     * Pauses this Timeline.
     *
     * To resume it again, call the `Timeline.resume` method or set the `Timeline.paused` property to `false`.
     *
     * If the Timeline is paused while processing the current game step, then it
     * will carry on with all events that are due to run during that step and pause
     * from the next game step.
     *
     * Note that if any Tweens have been started prior to calling this method, they will **not** be paused as well.
     *
     * @method Phaser.Time.Timeline#pause
     * @since 3.60.0
     *
     * @return {this} This Timeline instance.
     */ pause: function() {
                        this.paused = true;
                        var events = this.events;
                        for(var i = 0; i < events.length; i++){
                            var event = events[i];
                            if (event.tweenInstance) event.tweenInstance.paused = true;
                        }
                        return this;
                    },
                    /**
     * Repeats this Timeline.
     *
     * If the value for `amount` is positive, the Timeline will repeat that many additional times.
     * For example a value of 1 will actually run this Timeline twice.
     * 
     * Depending on the value given, `false` is 0 and `true`, undefined and negative numbers are infinite.
     * 
     * If this Timeline had any events set to `once` that have already been removed,
     * they will **not** be repeated each loop.
     *
     * @method Phaser.Time.Timeline#repeat
     * @since 3.80.0
     * 
     * @param {number|boolean} [amount=-1] - Amount of times to repeat, if `true` or negative it will be infinite.
     *
     * @return {this} This Timeline instance.
     */ repeat: function(amount) {
                        if (amount === undefined || amount === true) amount = -1;
                        if (amount === false) amount = 0;
                        this.loop = amount;
                        return this;
                    },
                    /**
     * Resumes this Timeline from a paused state.
     *
     * The Timeline will carry on from where it left off.
     *
     * If you need to reset the Timeline to the start, then call the `Timeline.reset` method.
     *
     * @method Phaser.Time.Timeline#resume
     * @since 3.60.0
     *
     * @return {this} This Timeline instance.
     */ resume: function() {
                        this.paused = false;
                        var events = this.events;
                        for(var i = 0; i < events.length; i++){
                            var event = events[i];
                            if (event.tweenInstance) event.tweenInstance.paused = false;
                        }
                        return this;
                    },
                    /**
     * Stops this Timeline.
     *
     * This will set the `paused` and `complete` properties to `true`.
     *
     * If you wish to reset the Timeline to the start, then call the `Timeline.reset` method.
     *
     * @method Phaser.Time.Timeline#stop
     * @since 3.60.0
     *
     * @return {this} This Timeline instance.
     */ stop: function() {
                        this.paused = true;
                        this.complete = true;
                        return this;
                    },
                    /**
     * Resets this Timeline back to the start.
     *
     * This will set the elapsed time to zero and set all events to be incomplete.
     *
     * If the Timeline had any events that were set to `once` that have already
     * been removed, they will **not** be present again after calling this method.
     *
     * If the Timeline isn't currently running (i.e. it's paused or complete) then
     * calling this method resets those states, the same as calling `Timeline.play(true)`.
     * 
     * Any Tweens that were currently running by this Timeline will be stopped.
     *
     * @method Phaser.Time.Timeline#reset
     * @since 3.60.0
     * 
     * @param {boolean} [loop=false] - Set to true if you do not want to reset the loop counters.
     * 
     * @return {this} This Timeline instance.
     */ reset: function(loop) {
                        if (loop === undefined) loop = false;
                        this.elapsed = 0;
                        if (!loop) this.iteration = 0;
                        var events = this.events;
                        for(var i = 0; i < events.length; i++){
                            var event = events[i];
                            event.complete = false;
                            if (!loop) event.repeat = 0;
                            if (event.tweenInstance) event.tweenInstance.stop();
                        }
                        return this.play(false);
                    },
                    /**
     * Adds one or more events to this Timeline.
     *
     * You can pass in a single configuration object, or an array of them:
     *
     * ```js
     * const timeline = this.add.timeline({
     *     at: 1000,
     *     run: () => {
     *         this.add.sprite(400, 300, 'logo');
     *     }
     * });
     * ```
     *
     * @method Phaser.Time.Timeline#add
     * @since 3.60.0
     *
     * @param {Phaser.Types.Time.TimelineEventConfig|Phaser.Types.Time.TimelineEventConfig[]} config - The configuration object for this Timeline Event, or an array of them.
     *
     * @return {this} This Timeline instance.
     */ add: function(config) {
                        if (!Array.isArray(config)) config = [
                            config
                        ];
                        var events = this.events;
                        var prevTime = 0;
                        if (events.length > 0) prevTime = events[events.length - 1].time;
                        for(var i = 0; i < config.length; i++){
                            var entry = config[i];
                            //  Start at the exact time given, based on elapsed time (i.e. x ms from the start of the Timeline)
                            var startTime = GetFastValue(entry, 'at', 0);
                            //  Start in x ms from whatever the current elapsed time is (i.e. x ms from now)
                            var offsetTime = GetFastValue(entry, 'in', null);
                            if (offsetTime !== null) startTime = this.elapsed + offsetTime;
                            //  Start in x ms from whatever the previous event's start time was (i.e. x ms after the previous event)
                            var fromTime = GetFastValue(entry, 'from', null);
                            if (fromTime !== null) startTime = prevTime + fromTime;
                            events.push({
                                complete: false,
                                time: startTime,
                                repeat: 0,
                                if: GetFastValue(entry, 'if', null),
                                run: GetFastValue(entry, 'run', null),
                                loop: GetFastValue(entry, 'loop', null),
                                event: GetFastValue(entry, 'event', null),
                                target: GetFastValue(entry, 'target', null),
                                set: GetFastValue(entry, 'set', null),
                                tween: GetFastValue(entry, 'tween', null),
                                sound: GetFastValue(entry, 'sound', null),
                                once: GetFastValue(entry, 'once', false),
                                stop: GetFastValue(entry, 'stop', false)
                            });
                            prevTime = startTime;
                        }
                        this.complete = false;
                        return this;
                    },
                    /**
     * Removes all events from this Timeline, resets the elapsed time to zero
     * and pauses the Timeline.
     * 
     * Any Tweens that were currently running as a result of this Timeline will be stopped.
     *
     * @method Phaser.Time.Timeline#clear
     * @since 3.60.0
     *
     * @return {this} This Timeline instance.
     */ clear: function() {
                        var events = this.events;
                        for(var i = 0; i < events.length; i++){
                            var event = events[i];
                            if (event.tweenInstance) event.tweenInstance.stop();
                        }
                        events = [];
                        this.elapsed = 0;
                        this.paused = true;
                        return this;
                    },
                    /**
     * Returns `true` if this Timeline is currently playing.
     *
     * A Timeline is playing if it is not paused or not complete.
     *
     * @method Phaser.Time.Timeline#isPlaying
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Timeline is playing, otherwise `false`.
     */ isPlaying: function() {
                        return !this.paused && !this.complete;
                    },
                    /**
     * Returns a number between 0 and 1 representing the progress of this Timeline.
     *
     * A value of 0 means the Timeline has just started, 0.5 means it's half way through,
     * and 1 means it's complete.
     *
     * If the Timeline has no events, or all events have been removed, this will return 1.
     *
     * If the Timeline is paused, this will return the progress value at the time it was paused.
     *
     * Note that the value returned is based on the number of events that have been completed,
     * not the 'duration' of the events (as this is unknown to the Timeline).
     *
     * @method Phaser.Time.Timeline#getProgress
     * @since 3.60.0
     *
     * @return {number} A number between 0 and 1 representing the progress of this Timeline.
     */ getProgress: function() {
                        var total = Math.min(this.totalComplete, this.events.length);
                        return total / this.events.length;
                    },
                    /**
     * Destroys this Timeline.
     *
     * This will remove all events from the Timeline and stop it from processing.
     * 
     * Any Tweens that were currently running as a result of this Timeline will be stopped.
     *
     * This method is called automatically when the Scene shuts down, but you may
     * also call it directly should you need to destroy the Timeline earlier.
     *
     * @method Phaser.Time.Timeline#destroy
     * @since 3.60.0
     */ destroy: function() {
                        var eventEmitter = this.systems.events;
                        eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                        eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                        eventEmitter.off(SceneEvents.SHUTDOWN, this.destroy, this);
                        this.clear();
                        this.scene = null;
                        this.systems = null;
                    }
                });
                /**
 * A Timeline is a way to schedule events to happen at specific times in the future.
 *
 * You can think of it as an event sequencer for your game, allowing you to schedule the
 * running of callbacks, events and other actions at specific times in the future.
 *
 * A Timeline is a Scene level system, meaning you can have as many Timelines as you like, each
 * belonging to a different Scene. You can also have multiple Timelines running at the same time.
 *
 * If the Scene is paused, the Timeline will also pause. If the Scene is destroyed, the Timeline
 * will be automatically destroyed. However, you can control the Timeline directly, pausing,
 * resuming and stopping it at any time.
 *
 * Create an instance of a Timeline via the Game Object Factory:
 *
 * ```js
 * const timeline = this.add.timeline();
 * ```
 *
 * The Timeline always starts paused. You must call `play` on it to start it running.
 *
 * You can also pass in a configuration object on creation, or an array of them:
 *
 * ```js
 * const timeline = this.add.timeline({
 *     at: 1000,
 *     run: () => {
 *         this.add.sprite(400, 300, 'logo');
 *     }
 * });
 *
 * timeline.play();
 * ```
 *
 * In this example we sequence a few different events:
 *
 * ```js
 * const timeline = this.add.timeline([
 *     {
 *         at: 1000,
 *         run: () => { this.logo = this.add.sprite(400, 300, 'logo'); },
 *         sound: 'TitleMusic'
 *     },
 *     {
 *         at: 2500,
 *         tween: {
 *             targets: this.logo,
 *             y: 600,
 *             yoyo: true
 *         },
 *         sound: 'Explode'
 *     },
 *     {
 *         at: 8000,
 *         event: 'HURRY_PLAYER',
 *         target: this.background,
 *         set: {
 *             tint: 0xff0000
 *         }
 *     }
 * ]);
 *
 * timeline.play();
 * ```
 *
 * The Timeline can also be looped with the repeat method:
 * ```js
 * timeline.repeat().play();
 * ```
 * 
 * There are lots of options available to you via the configuration object. See the
 * {@link Phaser.Types.Time.TimelineEventConfig} typedef for more details.
 *
 * @method Phaser.GameObjects.GameObjectFactory#timeline
 * @since 3.60.0
 *
 * @param {Phaser.Types.Time.TimelineEventConfig|Phaser.Types.Time.TimelineEventConfig[]} config - The configuration object for this Timeline Event, or an array of them.
 *
 * @return {Phaser.Time.Timeline} The Timeline that was created.
 */ GameObjectFactory.register('timeline', function(config) {
                    return new Timeline(this.scene, config);
                });
                module1.exports = Timeline;
            /***/ },
            /***/ 94880: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var GetFastValue = __webpack_require__(95540);
                /**
 * @classdesc
 * A Timer Event represents a delayed function call. It's managed by a Scene's {@link Clock} and will call its function after a set amount of time has passed. The Timer Event can optionally repeat - i.e. call its function multiple times before finishing, or loop indefinitely.
 *
 * Because it's managed by a Clock, a Timer Event is based on game time, will be affected by its Clock's time scale, and will pause if its Clock pauses.
 *
 * @class TimerEvent
 * @memberof Phaser.Time
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Time.TimerEventConfig} config - The configuration for the Timer Event, including its delay and callback.
 */ var TimerEvent = new Class({
                    initialize: function TimerEvent(config) {
                        /**
         * The delay in ms at which this TimerEvent fires.
         *
         * @name Phaser.Time.TimerEvent#delay
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.delay = 0;
                        /**
         * The total number of times this TimerEvent will repeat before finishing.
         *
         * @name Phaser.Time.TimerEvent#repeat
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.repeat = 0;
                        /**
         * If repeating this contains the current repeat count.
         *
         * @name Phaser.Time.TimerEvent#repeatCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatCount = 0;
                        /**
         * True if this TimerEvent loops, otherwise false.
         *
         * @name Phaser.Time.TimerEvent#loop
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.loop = false;
                        /**
         * The callback that will be called when the TimerEvent occurs.
         *
         * @name Phaser.Time.TimerEvent#callback
         * @type {function}
         * @since 3.0.0
         */ this.callback;
                        /**
         * The scope in which the callback will be called.
         *
         * @name Phaser.Time.TimerEvent#callbackScope
         * @type {object}
         * @since 3.0.0
         */ this.callbackScope;
                        /**
         * Additional arguments to be passed to the callback.
         *
         * @name Phaser.Time.TimerEvent#args
         * @type {array}
         * @since 3.0.0
         */ this.args;
                        /**
         * Scale the time causing this TimerEvent to update.
         *
         * @name Phaser.Time.TimerEvent#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                        /**
         * Start this many MS into the elapsed (useful if you want a long duration with repeat, but for the first loop to fire quickly)
         *
         * @name Phaser.Time.TimerEvent#startAt
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startAt = 0;
                        /**
         * The time in milliseconds which has elapsed since the Timer Event's creation.
         *
         * This value is local for the Timer Event and is relative to its Clock. As such, it's influenced by the Clock's time scale and paused state, the Timer Event's initial {@link #startAt} property, and the Timer Event's {@link #timeScale} and {@link #paused} state.
         *
         * @name Phaser.Time.TimerEvent#elapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.elapsed = 0;
                        /**
         * Whether or not this timer is paused.
         *
         * @name Phaser.Time.TimerEvent#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                        /**
         * Whether the Timer Event's function has been called.
         *
         * When the Timer Event fires, this property will be set to `true` before the callback function is invoked and will be reset immediately afterward if the Timer Event should repeat. The value of this property does not directly influence whether the Timer Event will be removed from its Clock, but can prevent it from firing.
         *
         * @name Phaser.Time.TimerEvent#hasDispatched
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.hasDispatched = false;
                        this.reset(config);
                    },
                    /**
     * Completely reinitializes the Timer Event, regardless of its current state, according to a configuration object.
     *
     * @method Phaser.Time.TimerEvent#reset
     * @since 3.0.0
     *
     * @param {Phaser.Types.Time.TimerEventConfig} config - The new state for the Timer Event.
     *
     * @return {Phaser.Time.TimerEvent} This TimerEvent object.
     */ reset: function(config) {
                        this.delay = GetFastValue(config, 'delay', 0);
                        //  Can also be set to -1 for an infinite loop (same as setting loop: true)
                        this.repeat = GetFastValue(config, 'repeat', 0);
                        this.loop = GetFastValue(config, 'loop', false);
                        this.callback = GetFastValue(config, 'callback', undefined);
                        this.callbackScope = GetFastValue(config, 'callbackScope', this);
                        this.args = GetFastValue(config, 'args', []);
                        this.timeScale = GetFastValue(config, 'timeScale', 1);
                        this.startAt = GetFastValue(config, 'startAt', 0);
                        this.paused = GetFastValue(config, 'paused', false);
                        this.elapsed = this.startAt;
                        this.hasDispatched = false;
                        this.repeatCount = this.repeat === -1 || this.loop ? 999999999999 : this.repeat;
                        if (this.delay <= 0 && this.repeatCount > 0) throw new Error('TimerEvent infinite loop created via zero delay');
                        return this;
                    },
                    /**
     * Gets the progress of the current iteration, not factoring in repeats.
     *
     * @method Phaser.Time.TimerEvent#getProgress
     * @since 3.0.0
     *
     * @return {number} A number between 0 and 1 representing the current progress.
     */ getProgress: function() {
                        return this.elapsed / this.delay;
                    },
                    /**
     * Gets the progress of the timer overall, factoring in repeats.
     *
     * @method Phaser.Time.TimerEvent#getOverallProgress
     * @since 3.0.0
     *
     * @return {number} The overall progress of the Timer Event, between 0 and 1.
     */ getOverallProgress: function() {
                        if (this.repeat > 0) {
                            var totalDuration = this.delay + this.delay * this.repeat;
                            var totalElapsed = this.elapsed + this.delay * (this.repeat - this.repeatCount);
                            return totalElapsed / totalDuration;
                        } else return this.getProgress();
                    },
                    /**
     * Returns the number of times this Timer Event will repeat before finishing.
     *
     * This should not be confused with the number of times the Timer Event will fire before finishing. A return value of 0 doesn't indicate that the Timer Event has finished running - it indicates that it will not repeat after the next time it fires.
     *
     * @method Phaser.Time.TimerEvent#getRepeatCount
     * @since 3.0.0
     *
     * @return {number} How many times the Timer Event will repeat.
     */ getRepeatCount: function() {
                        return this.repeatCount;
                    },
                    /**
     * Returns the local elapsed time for the current iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getElapsed
     * @since 3.0.0
     *
     * @return {number} The local elapsed time in milliseconds.
     */ getElapsed: function() {
                        return this.elapsed;
                    },
                    /**
     * Returns the local elapsed time for the current iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getElapsedSeconds
     * @since 3.0.0
     *
     * @return {number} The local elapsed time in seconds.
     */ getElapsedSeconds: function() {
                        return this.elapsed * 0.001;
                    },
                    /**
     * Returns the time interval until the next iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getRemaining
     * @since 3.50.0
     *
     * @return {number} The time interval in milliseconds.
     */ getRemaining: function() {
                        return this.delay - this.elapsed;
                    },
                    /**
     * Returns the time interval until the next iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getRemainingSeconds
     * @since 3.50.0
     *
     * @return {number} The time interval in seconds.
     */ getRemainingSeconds: function() {
                        return this.getRemaining() * 0.001;
                    },
                    /**
     * Returns the time interval until the last iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getOverallRemaining
     * @since 3.50.0
     *
     * @return {number} The time interval in milliseconds.
     */ getOverallRemaining: function() {
                        return this.delay * (1 + this.repeatCount) - this.elapsed;
                    },
                    /**
     * Returns the time interval until the last iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getOverallRemainingSeconds
     * @since 3.50.0
     *
     * @return {number} The time interval in seconds.
     */ getOverallRemainingSeconds: function() {
                        return this.getOverallRemaining() * 0.001;
                    },
                    /**
     * Forces the Timer Event to immediately expire, thus scheduling its removal in the next frame.
     *
     * @method Phaser.Time.TimerEvent#remove
     * @since 3.0.0
     *
     * @param {boolean} [dispatchCallback=false] - If `true`, the function of the Timer Event will be called before its removal.
     */ remove: function(dispatchCallback) {
                        if (dispatchCallback === undefined) dispatchCallback = false;
                        this.elapsed = this.delay;
                        this.hasDispatched = !dispatchCallback;
                        this.repeatCount = 0;
                    },
                    /**
     * Destroys all object references in the Timer Event, i.e. its callback, scope, and arguments.
     *
     * Normally, this method is only called by the Clock when it shuts down. As such, it doesn't stop the Timer Event. If called manually, the Timer Event will still be updated by the Clock, but it won't do anything when it fires.
     *
     * @method Phaser.Time.TimerEvent#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.callback = undefined;
                        this.callbackScope = undefined;
                        this.args = [];
                    }
                });
                module1.exports = TimerEvent;
            /***/ },
            /***/ 35945: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Complete Event.
 *
 * This event is dispatched by timeline when all timeline events complete.
 *
 * Listen to it from a Timeline instance using `Timeline.on('complete', listener)`, i.e.:
 *
 * ```javascript
 * const timeline = this.add.timeline();
 * timeline.on('complete', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Time.Events#COMPLETE
 * @type {string}
 * @since 3.70.0
 *
 * @param {Phaser.Time.Timeline} timeline - A reference to the Timeline that emitted the event.
 */ module1.exports = 'complete';
            /***/ },
            /***/ 89809: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Time.Events
 */ module1.exports = {
                    COMPLETE: __webpack_require__(35945)
                };
            /***/ },
            /***/ 90291: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Time
 */ module1.exports = {
                    Clock: __webpack_require__(33385),
                    Events: __webpack_require__(89809),
                    Timeline: __webpack_require__(96120),
                    TimerEvent: __webpack_require__(94880)
                };
            /***/ },
            /***/ 40382: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(72905);
                var Class = __webpack_require__(83419);
                var Flatten = __webpack_require__(43491);
                var NumberTweenBuilder = __webpack_require__(88032);
                var PluginCache = __webpack_require__(37277);
                var SceneEvents = __webpack_require__(44594);
                var StaggerBuilder = __webpack_require__(93109);
                var Tween = __webpack_require__(86081);
                var TweenBuilder = __webpack_require__(8357);
                var TweenChain = __webpack_require__(43960);
                var TweenChainBuilder = __webpack_require__(26012);
                /**
 * @classdesc
 * The Tween Manager is a default Scene Plugin which controls and updates Tweens.
 *
 * A tween is a way to alter one or more properties of a target object over a defined period of time.
 *
 * Tweens are created by calling the `add` method and passing in the configuration object.
 *
 * ```js
 * const logo = this.add.image(100, 100, 'logo');
 *
 * this.tweens.add({
 *   targets: logo,
 *   x: 600,
 *   ease: 'Power1',
 *   duration: 2000
 * });
 * ```
 *
 * See the `TweenBuilderConfig` for all of the options you have available.
 *
 * Playback will start immediately unless the tween has been configured to be paused.
 *
 * Please note that a Tween will not manipulate any target property that begins with an underscore.
 *
 * Tweens are designed to be 'fire-and-forget'. They automatically destroy themselves once playback
 * is complete, to free-up memory and resources. If you wish to keep a tween after playback, i.e. to
 * play it again at a later time, then you should set the `persist` property to `true` in the config.
 * However, doing so means it's entirely up to _you_ to destroy the tween when you're finished with it,
 * otherwise it will linger in memory forever.
 *
 * If you wish to chain Tweens together for sequential playback, see the `TweenManager.chain` method.
 *
 * @class TweenManager
 * @memberof Phaser.Tweens
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Tween Manager.
 */ var TweenManager = new Class({
                    initialize: function TweenManager(scene) {
                        /**
         * The Scene which owns this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                        /**
         * The Scene Systems Event Emitter.
         *
         * @name Phaser.Tweens.TweenManager#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.60.0
         */ this.events = scene.sys.events;
                        /**
         * The time scale of the Tween Manager.
         *
         * This value scales the time delta between two frames, thus influencing the speed of time for all Tweens owned by this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                        /**
         * This toggles the updating state of this Tween Manager.
         *
         * Setting `paused` to `true` (or calling the `pauseAll` method) will
         * stop this Tween Manager from updating any of its tweens, including
         * newly created ones. Set back to `false` to resume playback.
         *
         * @name Phaser.Tweens.TweenManager#paused
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.paused = false;
                        /**
         * Is this Tween Manager currently processing the tweens as part of
         * its 'update' loop? This is set to 'true' at the start of 'update'
         * and reset to 'false' at the end of the function. Allows you to trap
         * Tween Manager status during tween callbacks.
         *
         * @name Phaser.Tweens.TweenManager#processing
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.processing = false;
                        /**
         * An array of Tweens which are actively being processed by the Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#tweens
         * @type {Phaser.Tweens.Tween[]}
         * @since 3.60.0
         */ this.tweens = [];
                        /**
         * The time the Tween Manager was updated.
         *
         * @name Phaser.Tweens.TweenManager#time
         * @type {number}
         * @since 3.60.0
         */ this.time = 0;
                        /**
         * The time the Tween Manager was started.
         *
         * @name Phaser.Tweens.TweenManager#startTime
         * @type {number}
         * @since 3.60.0
         */ this.startTime = 0;
                        /**
         * The time the Tween Manager should next update.
         *
         * @name Phaser.Tweens.TweenManager#nextTime
         * @type {number}
         * @since 3.60.0
         */ this.nextTime = 0;
                        /**
         * The time the Tween Manager previously updated.
         *
         * @name Phaser.Tweens.TweenManager#prevTime
         * @type {number}
         * @since 3.60.0
         */ this.prevTime = 0;
                        /**
         * The maximum amount of time, in milliseconds, the browser can
         * lag for, before lag smoothing is applied.
         *
         * See the `TweenManager.setLagSmooth` method for further details.
         *
         * @name Phaser.Tweens.TweenManager#maxLag
         * @type {number}
         * @default 500
         * @since 3.60.0
         */ this.maxLag = 500;
                        /**
         * The amount of time, in milliseconds, that is used to set the
         * delta when lag smoothing is applied.
         *
         * See the `TweenManager.setLagSmooth` method for further details.
         *
         * @name Phaser.Tweens.TweenManager#lagSkip
         * @type {number}
         * @default 33
         * @since 3.60.0
         */ this.lagSkip = 33;
                        /**
         * An internal value that holds the fps rate.
         *
         * @name Phaser.Tweens.TweenManager#gap
         * @type {number}
         * @since 3.60.0
         */ this.gap = 1000 / 240;
                        this.events.once(SceneEvents.BOOT, this.boot, this);
                        this.events.on(SceneEvents.START, this.start, this);
                    },
                    /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Tweens.TweenManager#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                        this.events.once(SceneEvents.DESTROY, this.destroy, this);
                    },
                    /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Tweens.TweenManager#start
     * @private
     * @since 3.5.0
     */ start: function() {
                        this.timeScale = 1;
                        this.paused = false;
                        this.startTime = Date.now();
                        this.prevTime = this.startTime;
                        this.nextTime = this.gap;
                        this.events.on(SceneEvents.UPDATE, this.update, this);
                        this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * Create a Tween and return it, but does not add it to this Tween Manager.
     *
     * Please note that a Tween will not manipulate any target property that begins with an underscore.
     *
     * In order to play this tween, you'll need to add it to a Tween Manager via
     * the `TweenManager.existing` method.
     *
     * You can optionally pass an **array** of Tween Configuration objects to this method and it will create
     * one Tween per entry in the array. If an array is given, an array of tweens is returned.
     *
     * @method Phaser.Tweens.TweenManager#create
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig|Phaser.Types.Tweens.TweenBuilderConfig[]|object|object[]} config - A Tween Configuration object. Or an array of Tween Configuration objects.
     *
     * @return {Phaser.Tweens.Tween|Phaser.Tweens.Tween[]} The created Tween, or an array of Tweens if an array of tween configs was provided.
     */ create: function(config) {
                        if (!Array.isArray(config)) config = [
                            config
                        ];
                        var result = [];
                        for(var i = 0; i < config.length; i++){
                            var tween = config[i];
                            if (tween instanceof Tween || tween instanceof TweenChain) //  Allow them to send an array of mixed instances and configs
                            result.push(tween);
                            else if (Array.isArray(tween.tweens)) result.push(TweenChainBuilder(this, tween));
                            else result.push(TweenBuilder(this, tween));
                        }
                        return result.length === 1 ? result[0] : result;
                    },
                    /**
     * Create a Tween and add it to this Tween Manager by passing a Tween Configuration object.
     *
     * Example, run from within a Scene:
     *
     * ```js
     * const logo = this.add.image(100, 100, 'logo');
     *
     * this.tweens.add({
     *   targets: logo,
     *   x: 600,
     *   ease: 'Power1',
     *   duration: 2000
     * });
     * ```
     *
     * See the `TweenBuilderConfig` for all of the options you have available.
     *
     * Playback will start immediately unless the tween has been configured to be paused.
     *
     * Please note that a Tween will not manipulate any target property that begins with an underscore.
     *
     * Tweens are designed to be 'fire-and-forget'. They automatically destroy themselves once playback
     * is complete, to free-up memory and resources. If you wish to keep a tween after playback, i.e. to
     * play it again at a later time, then you should set the `persist` property to `true` in the config.
     * However, doing so means it's entirely up to _you_ to destroy the tween when you're finished with it,
     * otherwise it will linger in memory forever.
     *
     * If you wish to chain Tweens together for sequential playback, see the `TweenManager.chain` method.
     *
     * @method Phaser.Tweens.TweenManager#add
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig|Phaser.Types.Tweens.TweenChainBuilderConfig|Phaser.Tweens.Tween|Phaser.Tweens.TweenChain} config - A Tween Configuration object, or a Tween or TweenChain instance.
     *
     * @return {Phaser.Tweens.Tween} The created Tween.
     */ add: function(config) {
                        var tween = config;
                        var tweens = this.tweens;
                        if (tween instanceof Tween || tween instanceof TweenChain) tweens.push(tween.reset());
                        else {
                            if (Array.isArray(tween.tweens)) tween = TweenChainBuilder(this, tween);
                            else tween = TweenBuilder(this, tween);
                            tweens.push(tween.reset());
                        }
                        return tween;
                    },
                    /**
     * Create multiple Tweens and add them all to this Tween Manager, by passing an array of Tween Configuration objects.
     *
     * See the `TweenBuilderConfig` for all of the options you have available.
     *
     * Playback will start immediately unless the tweens have been configured to be paused.
     *
     * Please note that a Tween will not manipulate any target property that begins with an underscore.
     *
     * Tweens are designed to be 'fire-and-forget'. They automatically destroy themselves once playback
     * is complete, to free-up memory and resources. If you wish to keep a tween after playback, i.e. to
     * play it again at a later time, then you should set the `persist` property to `true` in the config.
     * However, doing so means it's entirely up to _you_ to destroy the tween when you're finished with it,
     * otherwise it will linger in memory forever.
     *
     * If you wish to chain Tweens together for sequential playback, see the `TweenManager.chain` method.
     *
     * @method Phaser.Tweens.TweenManager#addMultiple
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig[]|object[]} configs - An array of Tween Configuration objects.
     *
     * @return {Phaser.Tweens.Tween[]} An array of created Tweens.
     */ addMultiple: function(configs) {
                        var tween;
                        var result = [];
                        var tweens = this.tweens;
                        for(var i = 0; i < configs.length; i++){
                            tween = configs[i];
                            if (tween instanceof Tween || tween instanceof TweenChain) tweens.push(tween.reset());
                            else {
                                if (Array.isArray(tween.tweens)) tween = TweenChainBuilder(this, tween);
                                else tween = TweenBuilder(this, tween);
                                tweens.push(tween.reset());
                            }
                            result.push(tween);
                        }
                        return result;
                    },
                    /**
     * Create a sequence of Tweens, chained to one-another, and add them to this Tween Manager.
     *
     * The tweens are played in order, from start to finish. You can optionally set the chain
     * to repeat as many times as you like. Once the chain has finished playing, or repeating if set,
     * all tweens in the chain will be destroyed automatically. To override this, set the `persist`
     * argument to 'true'.
     *
     * Playback will start immediately unless the _first_ Tween has been configured to be paused.
     *
     * Please note that Tweens will not manipulate any target property that begins with an underscore.
     *
     * @method Phaser.Tweens.TweenManager#chain
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.TweenChainBuilderConfig|object} tweens - A Tween Chain configuration object.
     *
     * @return {Phaser.Tweens.TweenChain} The Tween Chain instance.
     */ chain: function(config) {
                        var chain = TweenChainBuilder(this, config);
                        this.tweens.push(chain.init());
                        return chain;
                    },
                    /**
     * Returns an array containing this Tween and all Tweens chained to it,
     * in the order in which they will be played.
     *
     * If there are no chained Tweens an empty array is returned.
     *
     * @method Phaser.Tweens.TweenManager#getChainedTweens
     * @since 3.60.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to return the chain from.
     *
     * @return {Phaser.Tweens.Tween[]} An array of the chained tweens, or an empty array if there aren't any.
     */ getChainedTweens: function(tween) {
                        return tween.getChainedTweens();
                    },
                    /**
     * Check to see if the given Tween instance exists within this Tween Manager.
     *
     * Will return `true` as long as the Tween is being processed by this Tween Manager.
     *
     * Will return `false` if not present, or has a state of `REMOVED` or `DESTROYED`.
     *
     * @method Phaser.Tweens.TweenManager#has
     * @since 3.60.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween instance to check.
     *
     * @return {boolean} `true` if the Tween exists within this Tween Manager, otherwise `false`.
     */ has: function(tween) {
                        return this.tweens.indexOf(tween) > -1;
                    },
                    /**
     * Add an existing Tween to this Tween Manager.
     *
     * Playback will start immediately unless the tween has been configured to be paused.
     *
     * @method Phaser.Tweens.TweenManager#existing
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to add.
     *
     * @return {this} This Tween Manager instance.
     */ existing: function(tween) {
                        if (!this.has(tween)) this.tweens.push(tween.reset());
                        return this;
                    },
                    /**
     * Create a Number Tween and add it to the active Tween list.
     *
     * A Number Tween is a special kind of tween that doesn't have a target. Instead,
     * it allows you to tween between 2 numeric values. The default values are
     * `0` and `1`, but you can change them via the `from` and `to` properties.
     *
     * You can get the current tweened value via the `Tween.getValue()` method.
     *
     * Playback will start immediately unless the tween has been configured to be paused.
     *
     * Please note that a Tween will not manipulate any target property that begins with an underscore.
     *
     * @method Phaser.Tweens.TweenManager#addCounter
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.NumberTweenBuilderConfig} config - The configuration object for the Number Tween.
     *
     * @return {Phaser.Tweens.Tween} The created Number Tween.
     */ addCounter: function(config) {
                        var tween = NumberTweenBuilder(this, config);
                        this.tweens.push(tween.reset());
                        return tween;
                    },
                    /**
     * Creates a Stagger function to be used by a Tween property.
     *
     * The stagger function will allow you to stagger changes to the value of the property across all targets of the tween.
     *
     * This is only worth using if the tween has multiple targets.
     *
     * The following will stagger the delay by 100ms across all targets of the tween, causing them to scale down to 0.2
     * over the duration specified:
     *
     * ```javascript
     * this.tweens.add({
     *     targets: [ ... ],
     *     scale: 0.2,
     *     ease: 'linear',
     *     duration: 1000,
     *     delay: this.tweens.stagger(100)
     * });
     * ```
     *
     * The following will stagger the delay by 500ms across all targets of the tween using a 10 x 6 grid, staggering
     * from the center out, using a cubic ease.
     *
     * ```javascript
     * this.tweens.add({
     *     targets: [ ... ],
     *     scale: 0.2,
     *     ease: 'linear',
     *     duration: 1000,
     *     delay: this.tweens.stagger(500, { grid: [ 10, 6 ], from: 'center', ease: 'cubic.out' })
     * });
     * ```
     *
     * @method Phaser.Tweens.TweenManager#stagger
     * @since 3.19.0
     *
     * @param {(number|number[])} value - The amount to stagger by, or an array containing two elements representing the min and max values to stagger between.
     * @param {Phaser.Types.Tweens.StaggerConfig} config - The configuration object for the Stagger function.
     *
     * @return {function} The stagger function.
     */ stagger: function(value, options) {
                        return StaggerBuilder(value, options);
                    },
                    /**
     * Set the limits that are used when a browser encounters lag, or delays that cause the elapsed
     * time between two frames to exceed the expected amount. If this occurs, the Tween Manager will
     * act as if the 'skip' amount of times has passed, in order to maintain strict tween sequencing.
     *
     * This is enabled by default with the values 500ms for the lag limit and 33ms for the skip.
     *
     * You should not set these to low values, as it won't give time for the browser to ever
     * catch-up with itself and reclaim sync.
     *
     * Call this method with no arguments to disable smoothing.
     *
     * Call it with the arguments `500` and `33` to reset to the defaults.
     *
     * @method Phaser.Tweens.TweenManager#setLagSmooth
     * @since 3.60.0
     *
     * @param {number} [limit=0] - If the browser exceeds this amount, in milliseconds, it will act as if the 'skip' amount has elapsed instead.
     * @param {number} [skip=0] - The amount, in milliseconds, to use as the step delta should the browser lag beyond the 'limit'.
     *
     * @return {this} This Tween Manager instance.
     */ setLagSmooth: function(limit, skip) {
                        if (limit === undefined) limit = 1 / 1e-8;
                        if (skip === undefined) skip = 0;
                        this.maxLag = limit;
                        this.lagSkip = Math.min(skip, this.maxLag);
                        return this;
                    },
                    /**
     * Limits the Tween system to run at a particular frame rate.
     *
     * You should not set this _above_ the frequency of the browser,
     * but instead can use it to throttle the frame rate lower, should
     * you need to in certain situations.
     *
     * @method Phaser.Tweens.TweenManager#setFps
     * @since 3.60.0
     *
     * @param {number} [fps=240] - The frame rate to tick at.
     *
     * @return {this} This Tween Manager instance.
     */ setFps: function(fps) {
                        if (fps === undefined) fps = 240;
                        this.gap = 1000 / fps;
                        this.nextTime = this.time * 1000 + this.gap;
                        return this;
                    },
                    /**
     * Internal method that calculates the delta value, along with the other timing values,
     * and returns the new delta.
     *
     * You should not typically call this method directly.
     *
     * @method Phaser.Tweens.TweenManager#getDelta
     * @since 3.60.0
     *
     * @param {boolean} [tick=false] - Is this a manual tick, or an automated tick?
     *
     * @return {number} The new delta value.
     */ getDelta: function(tick) {
                        var elapsed = Date.now() - this.prevTime;
                        if (elapsed > this.maxLag) this.startTime += elapsed - this.lagSkip;
                        this.prevTime += elapsed;
                        var time = this.prevTime - this.startTime;
                        var overlap = time - this.nextTime;
                        var delta = time - this.time * 1000;
                        if (overlap > 0 || tick) {
                            time /= 1000;
                            this.time = time;
                            this.nextTime += overlap + (overlap >= this.gap ? 4 : this.gap - overlap);
                        } else delta = 0;
                        return delta;
                    },
                    /**
     * Manually advance the Tween system by one step.
     *
     * This will update all Tweens even if the Tween Manager is currently
     * paused.
     *
     * @method Phaser.Tweens.TweenManager#tick
     * @since 3.60.0
     *
     * @return {this} This Tween Manager instance.
     */ tick: function() {
                        this.step(true);
                        return this;
                    },
                    /**
     * Internal update handler.
     *
     * Calls `TweenManager.step` as long as the Tween Manager has not
     * been paused.
     *
     * @method Phaser.Tweens.TweenManager#update
     * @since 3.0.0
     */ update: function() {
                        if (!this.paused) this.step(false);
                    },
                    /**
     * Updates all Tweens belonging to this Tween Manager.
     *
     * Called automatically by `update` and `tick`.
     *
     * @method Phaser.Tweens.TweenManager#step
     * @since 3.60.0
     *
     * @param {boolean} [tick=false] - Is this a manual tick, or an automated tick?
     */ step: function(tick) {
                        if (tick === undefined) tick = false;
                        var delta = this.getDelta(tick);
                        if (delta <= 0) //  If we've got a negative delta, skip this step
                        return;
                        this.processing = true;
                        var i;
                        var tween;
                        var toDestroy = [];
                        var list = this.tweens;
                        //  By not caching the length we can immediately update tweens added
                        //  this frame (such as chained tweens)
                        for(i = 0; i < list.length; i++){
                            tween = list[i];
                            //  If Tween.update returns 'true' then it means it has completed,
                            //  so move it to the destroy list
                            if (tween.update(delta)) toDestroy.push(tween);
                        }
                        //  Clean-up the 'toDestroy' list
                        var count = toDestroy.length;
                        if (count && list.length > 0) {
                            for(i = 0; i < count; i++){
                                tween = toDestroy[i];
                                var idx = list.indexOf(tween);
                                if (idx > -1 && (tween.isPendingRemove() || tween.isDestroyed())) {
                                    list.splice(idx, 1);
                                    tween.destroy();
                                }
                            }
                            toDestroy.length = 0;
                        }
                        this.processing = false;
                    },
                    /**
     * Removes the given Tween from this Tween Manager, even if it hasn't started
     * playback yet. If this method is called while the Tween Manager is processing
     * an update loop, then the tween will be flagged for removal at the start of
     * the next frame. Otherwise, it is removed immediately.
     *
     * The removed tween is _not_ destroyed. It is just removed from this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#remove
     * @since 3.17.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be removed.
     *
     * @return {this} This Tween Manager instance.
     */ remove: function(tween) {
                        if (this.processing) //  Remove it on the next frame
                        tween.setPendingRemoveState();
                        else {
                            //  Remove it immediately
                            ArrayRemove(this.tweens, tween);
                            tween.setRemovedState();
                        }
                        return this;
                    },
                    /**
     * Resets the given Tween.
     *
     * If the Tween does not belong to this Tween Manager, it will first be added.
     *
     * Then it will seek to position 0 and playback will start on the next frame.
     *
     * @method Phaser.Tweens.TweenManager#reset
     * @since 3.60.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be reset.
     *
     * @return {this} This Tween Manager instance.
     */ reset: function(tween) {
                        this.existing(tween);
                        tween.seek();
                        tween.setActiveState();
                        return this;
                    },
                    /**
     * Checks if a Tween is active and adds it to the Tween Manager at the start of the frame if it isn't.
     *
     * @method Phaser.Tweens.TweenManager#makeActive
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to check.
     *
     * @return {this} This Tween Manager instance.
     */ makeActive: function(tween) {
                        this.existing(tween);
                        tween.setActiveState();
                        return this;
                    },
                    /**
     * Passes all Tweens to the given callback.
     *
     * @method Phaser.Tweens.TweenManager#each
     * @since 3.0.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [scope] - The scope (`this` object) to call the function with.
     * @param {...*} [args] - The arguments to pass into the function. Its first argument will always be the Tween currently being iterated.
     *
     * @return {this} This Tween Manager instance.
     */ each: function(callback, scope) {
                        var i;
                        var args = [
                            null
                        ];
                        for(i = 1; i < arguments.length; i++)args.push(arguments[i]);
                        this.tweens.forEach(function(tween) {
                            args[0] = tween;
                            callback.apply(scope, args);
                        });
                        return this;
                    },
                    /**
     * Returns an array containing references to all Tweens in this Tween Manager.
     *
     * It is safe to mutate the returned array. However, acting upon any of the Tweens
     * within it, will adjust those stored in this Tween Manager, as they are passed
     * by reference and not cloned.
     *
     * If you wish to get tweens for a specific target, see `getTweensOf`.
     *
     * @method Phaser.Tweens.TweenManager#getTweens
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.Tween[]} A new array containing references to all Tweens.
     */ getTweens: function() {
                        return this.tweens.slice();
                    },
                    /**
     * Returns an array of all Tweens in the Tween Manager which affect the given target, or array of targets.
     *
     * It's possible for this method to return tweens that are about to be removed from
     * the Tween Manager. You should check the state of the returned tween before acting
     * upon it.
     *
     * @method Phaser.Tweens.TweenManager#getTweensOf
     * @since 3.0.0
     *
     * @param {(object|object[])} target - The target to look for. Provide an array to look for multiple targets.
     *
     * @return {Phaser.Tweens.Tween[]} A new array containing all Tweens which affect the given target(s).
     */ getTweensOf: function(target) {
                        var output = [];
                        var list = this.tweens;
                        if (!Array.isArray(target)) target = [
                            target
                        ];
                        else target = Flatten(target);
                        var targetLen = target.length;
                        for(var i = 0; i < list.length; i++){
                            var tween = list[i];
                            for(var t = 0; t < targetLen; t++)if (!tween.isDestroyed() && tween.hasTarget(target[t])) output.push(tween);
                        }
                        return output;
                    },
                    /**
     * Returns the scale of the time delta for all Tweens owned by this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#getGlobalTimeScale
     * @since 3.0.0
     *
     * @return {number} The scale of the time delta, usually 1.
     */ getGlobalTimeScale: function() {
                        return this.timeScale;
                    },
                    /**
     * Sets a new scale of the time delta for this Tween Manager.
     *
     * The time delta is the time elapsed between two consecutive frames and influences the speed of time for this Tween Manager and all Tweens it owns. Values higher than 1 increase the speed of time, while values smaller than 1 decrease it. A value of 0 freezes time and is effectively equivalent to pausing all Tweens.
     *
     * @method Phaser.Tweens.TweenManager#setGlobalTimeScale
     * @since 3.0.0
     *
     * @param {number} value - The new scale of the time delta, where 1 is the normal speed.
     *
     * @return {this} This Tween Manager instance.
     */ setGlobalTimeScale: function(value) {
                        this.timeScale = value;
                        return this;
                    },
                    /**
     * Checks if the given object is being affected by a _playing_ Tween.
     *
     * If the Tween is paused, this method will return false.
     *
     * @method Phaser.Tweens.TweenManager#isTweening
     * @since 3.0.0
     *
     * @param {object} target - The object to check if a tween is active for it, or not.
     *
     * @return {boolean} Returns `true` if a tween is active on the given target, otherwise `false`.
     */ isTweening: function(target) {
                        var list = this.tweens;
                        var tween;
                        for(var i = 0; i < list.length; i++){
                            tween = list[i];
                            if (tween.isPlaying() && tween.hasTarget(target)) return true;
                        }
                        return false;
                    },
                    /**
     * Destroys all Tweens in this Tween Manager.
     *
     * The tweens will erase all references to any targets they hold
     * and be stopped immediately.
     *
     * If this method is called while the Tween Manager is running its
     * update process, then the tweens will be removed at the start of
     * the next frame. Outside of this, they are removed immediately.
     *
     * @method Phaser.Tweens.TweenManager#killAll
     * @since 3.0.0
     *
     * @return {this} This Tween Manager instance.
     */ killAll: function() {
                        var tweens = this.processing ? this.getTweens() : this.tweens;
                        for(var i = 0; i < tweens.length; i++)tweens[i].destroy();
                        if (!this.processing) tweens.length = 0;
                        return this;
                    },
                    /**
     * Stops all Tweens which affect the given target or array of targets.
     *
     * The tweens will erase all references to any targets they hold
     * and be stopped immediately.
     *
     * If this method is called while the Tween Manager is running its
     * update process, then the tweens will be removed at the start of
     * the next frame. Outside of this, they are removed immediately.
     *
     * @see {@link #getTweensOf}
     *
     * @method Phaser.Tweens.TweenManager#killTweensOf
     * @since 3.0.0
     *
     * @param {(object|array)} target - The target to kill the tweens of. Provide an array to use multiple targets.
     *
     * @return {this} This Tween Manager instance.
     */ killTweensOf: function(target) {
                        var tweens = this.getTweensOf(target);
                        for(var i = 0; i < tweens.length; i++)tweens[i].destroy();
                        return this;
                    },
                    /**
     * Pauses this Tween Manager. No Tweens will update while paused.
     *
     * This includes tweens created after this method was called.
     *
     * See `TweenManager#resumeAll` to resume the playback.
     *
     * As of Phaser 3.60 you can also toggle the boolean property `TweenManager.paused`.
     *
     * @method Phaser.Tweens.TweenManager#pauseAll
     * @since 3.0.0
     *
     * @return {this} This Tween Manager instance.
     */ pauseAll: function() {
                        this.paused = true;
                        return this;
                    },
                    /**
     * Resumes playback of this Tween Manager.
     *
     * All active Tweens will continue updating.
     *
     * See `TweenManager#pauseAll` to pause the playback.
     *
     * As of Phaser 3.60 you can also toggle the boolean property `TweenManager.paused`.
     *
     * @method Phaser.Tweens.TweenManager#resumeAll
     * @since 3.0.0
     *
     * @return {this} This Tween Manager instance.
     */ resumeAll: function() {
                        this.paused = false;
                        return this;
                    },
                    /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Tweens.TweenManager#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                        this.killAll();
                        this.tweens = [];
                        this.events.off(SceneEvents.UPDATE, this.update, this);
                        this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    },
                    /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Tweens.TweenManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                        this.shutdown();
                        this.events.off(SceneEvents.START, this.start, this);
                        this.scene = null;
                        this.events = null;
                    }
                });
                PluginCache.register('TweenManager', TweenManager, 'tweens');
                module1.exports = TweenManager;
            /***/ },
            /***/ 57355: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Retrieves the value of the given key from an object.
 *
 * @function Phaser.Tweens.Builders.GetBoolean
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The key to look for in the `source` object.
 * @param {boolean} defaultValue - The default value to return if the `key` doesn't exist or if no `source` object is provided.
 *
 * @return {boolean} The retrieved value.
 */ var GetBoolean = function(source, key, defaultValue) {
                    if (!source) return defaultValue;
                    else if (source.hasOwnProperty(key)) return source[key];
                    else return defaultValue;
                };
                module1.exports = GetBoolean;
            /***/ },
            /***/ 6113: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var EaseMap = __webpack_require__(62640);
                var UppercaseFirst = __webpack_require__(35355);
                /**
 * This internal function is used to return the correct ease function for a Tween.
 *
 * It can take a variety of input, including an EaseMap based string, or a custom function.
 *
 * @function Phaser.Tweens.Builders.GetEaseFunction
 * @since 3.0.0
 *
 * @param {(string|function)} ease - The ease to find. This can be either a string from the EaseMap, or a custom function.
 * @param {number[]} [easeParams] - An optional array of ease parameters to go with the ease.
 *
 * @return {function} The ease function.
 */ var GetEaseFunction = function(ease, easeParams) {
                    //  Default ease function
                    var easeFunction = EaseMap.Power0;
                    //  Prepare ease function
                    if (typeof ease === 'string') {
                        //  String based look-up
                        //  1) They specified it correctly
                        if (EaseMap.hasOwnProperty(ease)) easeFunction = EaseMap[ease];
                        else {
                            //  Do some string manipulation to try and find it
                            var direction = '';
                            if (ease.indexOf('.')) {
                                //  quad.in = Quad.easeIn
                                //  quad.out = Quad.easeOut
                                //  quad.inout = Quad.easeInOut
                                direction = ease.substring(ease.indexOf('.') + 1);
                                var directionLower = direction.toLowerCase();
                                if (directionLower === 'in') direction = 'easeIn';
                                else if (directionLower === 'out') direction = 'easeOut';
                                else if (directionLower === 'inout') direction = 'easeInOut';
                            }
                            ease = UppercaseFirst(ease.substring(0, ease.indexOf('.') + 1) + direction);
                            if (EaseMap.hasOwnProperty(ease)) easeFunction = EaseMap[ease];
                        }
                    } else if (typeof ease === 'function') //  Custom function
                    easeFunction = ease;
                    //  No custom ease parameters?
                    if (!easeParams) //  Return ease function
                    return easeFunction;
                    var cloneParams = easeParams.slice(0);
                    cloneParams.unshift(0);
                    //  Return ease function with custom ease parameters
                    return function(v) {
                        cloneParams[0] = v;
                        return easeFunction.apply(this, cloneParams);
                    };
                };
                module1.exports = GetEaseFunction;
            /***/ },
            /***/ 91389: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bezier = __webpack_require__(89318);
                var CatmullRom = __webpack_require__(77259);
                var Linear = __webpack_require__(28392);
                var FuncMap = {
                    bezier: Bezier,
                    catmull: CatmullRom,
                    catmullrom: CatmullRom,
                    linear: Linear
                };
                /**
 * This internal function is used to return the correct interpolation function for a Tween.
 *
 * It can take a variety of input, including a string, or a custom function.
 *
 * @function Phaser.Tweens.Builders.GetInterpolationFunction
 * @since 3.60.0
 *
 * @param {(string|function|null)} interpolation - The interpolation function to find. This can be either a string, or a custom function, or null.
 *
 * @return {?function} The interpolation function to use, or `null`.
 */ var GetInterpolationFunction = function(interpolation) {
                    if (interpolation === null) return null;
                    //  Default interpolation function
                    var interpolationFunction = FuncMap.linear;
                    //  Prepare interpolation function
                    if (typeof interpolation === 'string') //  String based look-up
                    //  1) They specified it correctly
                    {
                        if (FuncMap.hasOwnProperty(interpolation)) interpolationFunction = FuncMap[interpolation];
                    } else if (typeof interpolation === 'function') //  Custom function
                    interpolationFunction = interpolation;
                    //  Return interpolation function
                    return interpolationFunction;
                };
                module1.exports = GetInterpolationFunction;
            /***/ },
            /***/ 55292: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function used by the Tween Builder to create a function that will return
 * the given value from the source.
 *
 * @function Phaser.Tweens.Builders.GetNewValue
 * @since 3.0.0
 *
 * @param {any} source - The source object to get the value from.
 * @param {string} key - The property to get from the source.
 * @param {any} defaultValue - A default value to return should the source not have the property set.
 *
 * @return {function} A function which, when called, will return the property value from the source.
 */ var GetNewValue = function(source, key, defaultValue) {
                    var valueCallback;
                    if (source.hasOwnProperty(key)) {
                        var t = typeof source[key];
                        if (t === 'function') valueCallback = function(target, targetKey, value, targetIndex, totalTargets, tween) {
                            return source[key](target, targetKey, value, targetIndex, totalTargets, tween);
                        };
                        else valueCallback = function() {
                            return source[key];
                        };
                    } else if (typeof defaultValue === 'function') valueCallback = defaultValue;
                    else valueCallback = function() {
                        return defaultValue;
                    };
                    return valueCallback;
                };
                module1.exports = GetNewValue;
            /***/ },
            /***/ 82985: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RESERVED = __webpack_require__(81076);
                /**
 * Internal function used by the Tween Builder to return an array of properties
 * that the Tween will be operating on. It takes a tween configuration object
 * and then checks that none of the `props` entries start with an underscore, or that
 * none of the direct properties are on the Reserved list.
 *
 * @function Phaser.Tweens.Builders.GetProps
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig} config - The configuration object of the Tween to get the properties from.
 *
 * @return {string[]} An array of all the properties the tween will operate on.
 */ var GetProps = function(config) {
                    var key;
                    var keys = [];
                    //  First see if we have a props object
                    if (config.hasOwnProperty('props')) {
                        for(key in config.props)//  Skip any property that starts with an underscore
                        if (key.substring(0, 1) !== '_') keys.push({
                            key: key,
                            value: config.props[key]
                        });
                    } else {
                        for(key in config)//  Skip any property that is in the ReservedProps list or that starts with an underscore
                        if (RESERVED.indexOf(key) === -1 && key.substring(0, 1) !== '_') keys.push({
                            key: key,
                            value: config[key]
                        });
                    }
                    return keys;
                };
                module1.exports = GetProps;
            /***/ },
            /***/ 62329: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(35154);
                /**
 * Extracts an array of targets from a Tween configuration object.
 *
 * The targets will be looked for in a `targets` property. If it's a function, its return value will be used as the result.
 *
 * @function Phaser.Tweens.Builders.GetTargets
 * @since 3.0.0
 *
 * @param {object} config - The configuration object to use.
 *
 * @return {array} An array of targets (may contain only one element), or `null` if no targets were specified.
 */ var GetTargets = function(config) {
                    var targets = GetValue(config, 'targets', null);
                    if (targets === null) return targets;
                    if (typeof targets === 'function') targets = targets.call();
                    if (!Array.isArray(targets)) targets = [
                        targets
                    ];
                    return targets;
                };
                module1.exports = GetTargets;
            /***/ },
            /***/ 17777: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(30976);
                var FloatBetween = __webpack_require__(99472);
                /**
 * @ignore
 */ function hasGetActive(def) {
                    return !!def.getActive && typeof def.getActive === 'function';
                }
                /**
 * @ignore
 */ function hasGetStart(def) {
                    return !!def.getStart && typeof def.getStart === 'function';
                }
                /**
 * @ignore
 */ function hasGetEnd(def) {
                    return !!def.getEnd && typeof def.getEnd === 'function';
                }
                /**
 * @ignore
 */ function hasGetters(def) {
                    return hasGetStart(def) || hasGetEnd(def) || hasGetActive(def);
                }
                /**
 * Returns `getActive`, `getStart` and `getEnd` functions for a TweenData based on a target property and end value.
 *
 * `getActive` if not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
 * `getEnd` is invoked once any start delays have expired and returns what the value should tween to.
 * `getStart` is invoked when the tween reaches the end and needs to either repeat or yoyo, it returns the value to go back to.
 *
 * If the end value is a number, it will be treated as an absolute value and the property will be tweened to it.
 * A string can be provided to specify a relative end value which consists of an operation
 * (`+=` to add to the current value, `-=` to subtract from the current value, `*=` to multiply the current
 * value, or `/=` to divide the current value) followed by its operand.
 *
 * A function can be provided to allow greater control over the end value; it will receive the target
 * object being tweened, the name of the property being tweened, and the current value of the property
 * as its arguments and must return a value.
 *
 * If both the starting and the ending values need to be controlled, an object with `getStart` and `getEnd`
 * callbacks, which will receive the same arguments, can be provided instead. If an object with a `value`
 * property is provided, the property will be used as the effective value under the same rules described here.
 *
 * @function Phaser.Tweens.Builders.GetValueOp
 * @since 3.0.0
 *
 * @param {string} key - The name of the property to modify.
 * @param {*} propertyValue - The ending value of the property, as described above.
 *
 * @return {function} An array of functions, `getActive`, `getStart` and `getEnd`, which return the starting and the ending value of the property based on the provided value.
 */ var GetValueOp = function(key, propertyValue) {
                    var callbacks;
                    //  The returned value sets what the property will be at the END of the Tween (usually called at the start of the Tween)
                    var getEnd = function(target, key, value) {
                        return value;
                    };
                    //  The returned value sets what the property will be at the START of the Tween (usually called at the end of the Tween)
                    var getStart = function(target, key, value) {
                        return value;
                    };
                    //  What to set the property to the moment the TweenData is invoked
                    var getActive = null;
                    var t = typeof propertyValue;
                    if (t === 'number') // props: {
                    //     x: 400,
                    //     y: 300
                    // }
                    getEnd = function() {
                        return propertyValue;
                    };
                    else if (Array.isArray(propertyValue)) {
                        // props: {
                        //     x: [ 400, 300, 200 ],
                        //     y: [ 10, 500, 10 ]
                        // }
                        getStart = function() {
                            return propertyValue[0];
                        };
                        getEnd = function() {
                            return propertyValue[propertyValue.length - 1];
                        };
                    } else if (t === 'string') {
                        // props: {
                        //     x: '+=400',
                        //     y: '-=300',
                        //     z: '*=2',
                        //     w: '/=2',
                        //     p: 'random(10, 100)' - random float
                        //     p: 'int(10, 100)' - random int
                        // }
                        var op = propertyValue.toLowerCase();
                        var isRandom = op.substring(0, 6) === 'random';
                        var isInt = op.substring(0, 3) === 'int';
                        if (isRandom || isInt) {
                            //  random(0.5, 3.45)
                            //  int(10, 100)
                            var brace1 = op.indexOf('(');
                            var brace2 = op.indexOf(')');
                            var comma = op.indexOf(',');
                            if (brace1 && brace2 && comma) {
                                var value1 = parseFloat(op.substring(brace1 + 1, comma));
                                var value2 = parseFloat(op.substring(comma + 1, brace2));
                                if (isRandom) getEnd = function() {
                                    return FloatBetween(value1, value2);
                                };
                                else getEnd = function() {
                                    return Between(value1, value2);
                                };
                            } else throw new Error('invalid random() format');
                        } else {
                            op = op[0];
                            var num = parseFloat(propertyValue.substr(2));
                            switch(op){
                                case '+':
                                    getEnd = function(target, key, value) {
                                        return value + num;
                                    };
                                    break;
                                case '-':
                                    getEnd = function(target, key, value) {
                                        return value - num;
                                    };
                                    break;
                                case '*':
                                    getEnd = function(target, key, value) {
                                        return value * num;
                                    };
                                    break;
                                case '/':
                                    getEnd = function(target, key, value) {
                                        return value / num;
                                    };
                                    break;
                                default:
                                    getEnd = function() {
                                        return parseFloat(propertyValue);
                                    };
                            }
                        }
                    } else if (t === 'function') //  The same as setting just the getEnd function and no getStart
                    // props: {
                    //     x: function (target, key, value, targetIndex, totalTargets, tween, tweenData) { return value + 50); },
                    // }
                    getEnd = propertyValue;
                    else if (t === 'object') {
                        if (hasGetters(propertyValue)) {
                            /*
            x: {
                //  Called the moment Tween is active. The returned value sets the property on the target immediately.
                getActive: function (target, key, value, targetIndex, totalTargets, tween, tweenData)
                {
                    return value;
                },

                //  Called at the start of the Tween. The returned value sets what the property will be at the END of the Tween.
                getEnd: function (target, key, value, targetIndex, totalTargets, tween, tweenData)
                {
                    return value;
                },

                //  Called at the end of the Tween. The returned value sets what the property will be at the START of the Tween.
                getStart: function (target, key, value, targetIndex, totalTargets, tween, tweenData)
                {
                    return value;
                }
            }
            */ if (hasGetActive(propertyValue)) getActive = propertyValue.getActive;
                            if (hasGetEnd(propertyValue)) getEnd = propertyValue.getEnd;
                            if (hasGetStart(propertyValue)) getStart = propertyValue.getStart;
                        } else if (propertyValue.hasOwnProperty('value')) //  'value' may still be a string, function or a number
                        // props: {
                        //     x: { value: 400, ... },
                        //     y: { value: 300, ... }
                        // }
                        callbacks = GetValueOp(key, propertyValue.value);
                        else {
                            //  'from' and 'to' may still be a string, function or a number
                            // props: {
                            //     x: { from: 400, to: 600 },
                            //     y: { from: 300, to: 500 }
                            // }
                            //  Same as above, but the 'start' value is set immediately on the target
                            // props: {
                            //     x: { start: 400, to: 600 },
                            //     y: { start: 300, to: 500 }
                            // }
                            //  'start' value is set immediately, then it goes 'from' to 'to' during the tween
                            // props: {
                            //     x: { start: 200, from: 400, to: 600 },
                            //     y: { start: 300, from: 300, to: 500 }
                            // }
                            var hasTo = propertyValue.hasOwnProperty('to');
                            var hasFrom = propertyValue.hasOwnProperty('from');
                            var hasStart = propertyValue.hasOwnProperty('start');
                            if (hasTo && (hasFrom || hasStart)) {
                                callbacks = GetValueOp(key, propertyValue.to);
                                if (hasStart) {
                                    var startCallbacks = GetValueOp(key, propertyValue.start);
                                    callbacks.getActive = startCallbacks.getEnd;
                                }
                                if (hasFrom) {
                                    var fromCallbacks = GetValueOp(key, propertyValue.from);
                                    callbacks.getStart = fromCallbacks.getEnd;
                                }
                            }
                        }
                    }
                    //  If callback not set by the else if block above then set it here and return it
                    if (!callbacks) callbacks = {
                        getActive: getActive,
                        getEnd: getEnd,
                        getStart: getStart
                    };
                    return callbacks;
                };
                module1.exports = GetValueOp;
            /***/ },
            /***/ 88032: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseTween = __webpack_require__(70402);
                var Defaults = __webpack_require__(69902);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetBoolean = __webpack_require__(57355);
                var GetEaseFunction = __webpack_require__(6113);
                var GetFastValue = __webpack_require__(95540);
                var GetNewValue = __webpack_require__(55292);
                var GetValue = __webpack_require__(35154);
                var GetValueOp = __webpack_require__(17777);
                var MergeRight = __webpack_require__(269);
                var Tween = __webpack_require__(86081);
                /**
 * Creates a new Number Tween.
 *
 * @function Phaser.Tweens.Builders.NumberTweenBuilder
 * @since 3.0.0
 *
 * @param {Phaser.Tweens.TweenManager} parent - The owner of the new Tween.
 * @param {Phaser.Types.Tweens.NumberTweenBuilderConfig} config - Configuration for the new Tween.
 * @param {Phaser.Types.Tweens.TweenConfigDefaults} defaults - Tween configuration defaults.
 *
 * @return {Phaser.Tweens.Tween} The new tween.
 */ var NumberTweenBuilder = function(parent, config, defaults) {
                    if (config instanceof Tween) {
                        config.parent = parent;
                        return config;
                    }
                    if (defaults === undefined) defaults = Defaults;
                    else defaults = MergeRight(Defaults, defaults);
                    //  var tween = this.tweens.addCounter({
                    //      from: 100,
                    //      to: 200,
                    //      ... (normal tween properties)
                    //  })
                    //
                    //  Then use it in your game via:
                    //
                    //  tween.getValue()
                    var from = GetFastValue(config, 'from', 0);
                    var to = GetFastValue(config, 'to', 1);
                    var targets = [
                        {
                            value: from
                        }
                    ];
                    var delay = GetFastValue(config, 'delay', defaults.delay);
                    var easeParams = GetFastValue(config, 'easeParams', defaults.easeParams);
                    var ease = GetFastValue(config, 'ease', defaults.ease);
                    var ops = GetValueOp('value', to);
                    var tween = new Tween(parent, targets);
                    var tweenData = tween.add(0, 'value', ops.getEnd, ops.getStart, ops.getActive, GetEaseFunction(GetFastValue(config, 'ease', ease), GetFastValue(config, 'easeParams', easeParams)), GetNewValue(config, 'delay', delay), GetFastValue(config, 'duration', defaults.duration), GetBoolean(config, 'yoyo', defaults.yoyo), GetFastValue(config, 'hold', defaults.hold), GetFastValue(config, 'repeat', defaults.repeat), GetFastValue(config, 'repeatDelay', defaults.repeatDelay), false, false);
                    tweenData.start = from;
                    tweenData.current = from;
                    tween.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
                    tween.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
                    tween.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
                    tween.paused = GetBoolean(config, 'paused', false);
                    tween.persist = GetBoolean(config, 'persist', false);
                    tween.isNumberTween = true;
                    //  Set the Callbacks
                    tween.callbackScope = GetValue(config, 'callbackScope', tween);
                    var callbacks = BaseTween.TYPES;
                    for(var i = 0; i < callbacks.length; i++){
                        var type = callbacks[i];
                        var callback = GetValue(config, type, false);
                        if (callback) {
                            var callbackParams = GetValue(config, type + 'Params', []);
                            tween.setCallback(type, callback, callbackParams);
                        }
                    }
                    return tween;
                };
                module1.exports = NumberTweenBuilder;
            /***/ },
            /***/ 93109: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetEaseFunction = __webpack_require__(6113);
                var GetValue = __webpack_require__(35154);
                var MATH_CONST = __webpack_require__(36383);
                /**
 * Creates a Stagger function to be used by a Tween property.
 *
 * The stagger function will allow you to stagger changes to the value of the property across all targets of the tween.
 *
 * This is only worth using if the tween has multiple targets.
 *
 * The following will stagger the delay by 100ms across all targets of the tween, causing them to scale down to 0.2
 * over the duration specified:
 *
 * ```javascript
 * this.tweens.add({
 *     targets: [ ... ],
 *     scale: 0.2,
 *     ease: 'linear',
 *     duration: 1000,
 *     delay: this.tweens.stagger(100)
 * });
 * ```
 *
 * The following will stagger the delay by 500ms across all targets of the tween using a 10 x 6 grid, staggering
 * from the center out, using a cubic ease.
 *
 * ```javascript
 * this.tweens.add({
 *     targets: [ ... ],
 *     scale: 0.2,
 *     ease: 'linear',
 *     duration: 1000,
 *     delay: this.tweens.stagger(500, { grid: [ 10, 6 ], from: 'center', ease: 'cubic.out' })
 * });
 * ```
 *
 * @function Phaser.Tweens.Builders.StaggerBuilder
 * @since 3.19.0
 *
 * @param {(number|number[])} value - The amount to stagger by, or an array containing two elements representing the min and max values to stagger between.
 * @param {Phaser.Types.Tweens.StaggerConfig} [config] - A Stagger Configuration object.
 *
 * @return {function} The stagger function.
 */ var StaggerBuilder = function(value, options) {
                    if (options === undefined) options = {};
                    var result;
                    var start = GetValue(options, 'start', 0);
                    var ease = GetValue(options, 'ease', null);
                    var grid = GetValue(options, 'grid', null);
                    var from = GetValue(options, 'from', 0);
                    var fromFirst = from === 'first';
                    var fromCenter = from === 'center';
                    var fromLast = from === 'last';
                    var fromValue = typeof from === 'number';
                    var isRange = Array.isArray(value);
                    var value1 = isRange ? parseFloat(value[0]) : parseFloat(value);
                    var value2 = isRange ? parseFloat(value[1]) : 0;
                    var maxValue = Math.max(value1, value2);
                    if (isRange) start += value1;
                    if (grid) {
                        //  Pre-calc the grid to save doing it for every TweenData update
                        var gridWidth = grid[0];
                        var gridHeight = grid[1];
                        var fromX = 0;
                        var fromY = 0;
                        var distanceX = 0;
                        var distanceY = 0;
                        var gridValues = [];
                        if (fromLast) {
                            fromX = gridWidth - 1;
                            fromY = gridHeight - 1;
                        } else if (fromValue) {
                            fromX = from % gridWidth;
                            fromY = Math.floor(from / gridWidth);
                        } else if (fromCenter) {
                            fromX = (gridWidth - 1) / 2;
                            fromY = (gridHeight - 1) / 2;
                        }
                        var gridMax = MATH_CONST.MIN_SAFE_INTEGER;
                        for(var toY = 0; toY < gridHeight; toY++){
                            gridValues[toY] = [];
                            for(var toX = 0; toX < gridWidth; toX++){
                                distanceX = fromX - toX;
                                distanceY = fromY - toY;
                                var dist = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                                if (dist > gridMax) gridMax = dist;
                                gridValues[toY][toX] = dist;
                            }
                        }
                    }
                    var easeFunction = ease ? GetEaseFunction(ease) : null;
                    if (grid) result = function(target, key, value, index) {
                        var gridSpace = 0;
                        var toX = index % gridWidth;
                        var toY = Math.floor(index / gridWidth);
                        if (toX >= 0 && toX < gridWidth && toY >= 0 && toY < gridHeight) gridSpace = gridValues[toY][toX];
                        var output;
                        if (isRange) {
                            var diff = value2 - value1;
                            if (easeFunction) output = gridSpace / gridMax * diff * easeFunction(gridSpace / gridMax);
                            else output = gridSpace / gridMax * diff;
                        } else if (easeFunction) output = gridSpace * value1 * easeFunction(gridSpace / gridMax);
                        else output = gridSpace * value1;
                        return output + start;
                    };
                    else result = function(target, key, value, index, total) {
                        //  zero offset
                        total--;
                        var fromIndex;
                        if (fromFirst) fromIndex = index;
                        else if (fromCenter) fromIndex = Math.abs(total / 2 - index);
                        else if (fromLast) fromIndex = total - index;
                        else if (fromValue) fromIndex = Math.abs(from - index);
                        var output;
                        if (isRange) {
                            var spacing;
                            if (fromCenter) spacing = (value2 - value1) / total * (fromIndex * 2);
                            else spacing = (value2 - value1) / total * fromIndex;
                            if (easeFunction) output = spacing * easeFunction(fromIndex / total);
                            else output = spacing;
                        } else if (easeFunction) output = total * maxValue * easeFunction(fromIndex / total);
                        else output = fromIndex * value1;
                        return output + start;
                    };
                    return result;
                };
                module1.exports = StaggerBuilder;
            /***/ },
            /***/ 8357: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseTween = __webpack_require__(70402);
                var Defaults = __webpack_require__(69902);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetBoolean = __webpack_require__(57355);
                var GetEaseFunction = __webpack_require__(6113);
                var GetFastValue = __webpack_require__(95540);
                var GetInterpolationFunction = __webpack_require__(91389);
                var GetNewValue = __webpack_require__(55292);
                var GetProps = __webpack_require__(82985);
                var GetTargets = __webpack_require__(62329);
                var GetValue = __webpack_require__(35154);
                var GetValueOp = __webpack_require__(17777);
                var MergeRight = __webpack_require__(269);
                var Tween = __webpack_require__(86081);
                /**
 * Creates a new Tween.
 *
 * @function Phaser.Tweens.Builders.TweenBuilder
 * @since 3.0.0
 *
 * @param {Phaser.Tweens.TweenManager} parent - The owner of the new Tween.
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - Configuration for the new Tween.
 * @param {Phaser.Types.Tweens.TweenConfigDefaults} defaults - Tween configuration defaults.
 *
 * @return {Phaser.Tweens.Tween} The new tween.
 */ var TweenBuilder = function(parent, config, defaults) {
                    if (config instanceof Tween) {
                        config.parent = parent;
                        return config;
                    }
                    if (defaults === undefined) defaults = Defaults;
                    else defaults = MergeRight(Defaults, defaults);
                    //  Create arrays of the Targets and the Properties. This Targets array should not be manipulated outside of this Tween.
                    var targets = GetTargets(config);
                    if (!targets && defaults.targets) targets = defaults.targets;
                    var props = GetProps(config);
                    //  Default Tween values
                    var delay = GetFastValue(config, 'delay', defaults.delay);
                    var duration = GetFastValue(config, 'duration', defaults.duration);
                    var easeParams = GetFastValue(config, 'easeParams', defaults.easeParams);
                    var ease = GetFastValue(config, 'ease', defaults.ease);
                    var hold = GetFastValue(config, 'hold', defaults.hold);
                    var repeat = GetFastValue(config, 'repeat', defaults.repeat);
                    var repeatDelay = GetFastValue(config, 'repeatDelay', defaults.repeatDelay);
                    var yoyo = GetBoolean(config, 'yoyo', defaults.yoyo);
                    var flipX = GetBoolean(config, 'flipX', defaults.flipX);
                    var flipY = GetBoolean(config, 'flipY', defaults.flipY);
                    var interpolation = GetFastValue(config, 'interpolation', defaults.interpolation);
                    var addTarget = function(tween, targetIndex, key, value) {
                        if (key === 'texture') {
                            var texture = value;
                            var frame = undefined;
                            if (Array.isArray(value)) {
                                texture = value[0];
                                frame = value[1];
                            } else if (value.hasOwnProperty('value')) {
                                texture = value.value;
                                if (Array.isArray(value.value)) {
                                    texture = value.value[0];
                                    frame = value.value[1];
                                } else if (typeof value.value === 'string') texture = value.value;
                            } else if (typeof value === 'string') texture = value;
                            tween.addFrame(targetIndex, texture, frame, GetNewValue(value, 'delay', delay), GetFastValue(value, 'duration', duration), GetFastValue(value, 'hold', hold), GetFastValue(value, 'repeat', repeat), GetFastValue(value, 'repeatDelay', repeatDelay), GetBoolean(value, 'flipX', flipX), GetBoolean(value, 'flipY', flipY));
                        } else {
                            var ops = GetValueOp(key, value);
                            var interpolationFunc = GetInterpolationFunction(GetFastValue(value, 'interpolation', interpolation));
                            tween.add(targetIndex, key, ops.getEnd, ops.getStart, ops.getActive, GetEaseFunction(GetFastValue(value, 'ease', ease), GetFastValue(value, 'easeParams', easeParams)), GetNewValue(value, 'delay', delay), GetFastValue(value, 'duration', duration), GetBoolean(value, 'yoyo', yoyo), GetFastValue(value, 'hold', hold), GetFastValue(value, 'repeat', repeat), GetFastValue(value, 'repeatDelay', repeatDelay), GetBoolean(value, 'flipX', flipX), GetBoolean(value, 'flipY', flipY), interpolationFunc, interpolationFunc ? value : null);
                        }
                    };
                    var tween = new Tween(parent, targets);
                    //  Loop through every property defined in the Tween, i.e.: props { x, y, alpha }
                    for(var p = 0; p < props.length; p++){
                        var key = props[p].key;
                        var value = props[p].value;
                        //  Create 1 TweenData per target, per property
                        for(var targetIndex = 0; targetIndex < targets.length; targetIndex++)//  Special-case for scale short-cut:
                        if (key === 'scale' && !targets[targetIndex].hasOwnProperty('scale')) {
                            addTarget(tween, targetIndex, 'scaleX', value);
                            addTarget(tween, targetIndex, 'scaleY', value);
                        } else addTarget(tween, targetIndex, key, value);
                    }
                    tween.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
                    tween.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
                    tween.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
                    tween.paused = GetBoolean(config, 'paused', false);
                    tween.persist = GetBoolean(config, 'persist', false);
                    //  Set the Callbacks
                    tween.callbackScope = GetFastValue(config, 'callbackScope', tween);
                    var callbacks = BaseTween.TYPES;
                    for(var i = 0; i < callbacks.length; i++){
                        var type = callbacks[i];
                        var callback = GetValue(config, type, false);
                        if (callback) {
                            var callbackParams = GetValue(config, type + 'Params', []);
                            tween.setCallback(type, callback, callbackParams);
                        }
                    }
                    return tween;
                };
                module1.exports = TweenBuilder;
            /***/ },
            /***/ 26012: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseTween = __webpack_require__(70402);
                var GetAdvancedValue = __webpack_require__(23568);
                var GetBoolean = __webpack_require__(57355);
                var GetTargets = __webpack_require__(62329);
                var GetValue = __webpack_require__(35154);
                var TweenBuilder = __webpack_require__(8357);
                var TweenChain = __webpack_require__(43960);
                /**
 * Creates a new Tween Chain instance.
 *
 * @function Phaser.Tweens.Builders.TweenChainBuilder
 * @since 3.60.0
 *
 * @param {Phaser.Tweens.TweenManager} parent - The owner of the new Tween.
 * @param {Phaser.Types.Tweens.TweenChainBuilderConfig|object} config - Configuration for the new Tween.
 *
 * @return {Phaser.Tweens.TweenChain} The new Tween Chain.
 */ var TweenChainBuilder = function(parent, config) {
                    if (config instanceof TweenChain) {
                        config.parent = parent;
                        return config;
                    }
                    //  Default TweenChain values
                    var chain = new TweenChain(parent);
                    chain.startDelay = GetValue(config, 'delay', 0);
                    chain.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
                    chain.loop = Math.round(GetAdvancedValue(config, 'loop', GetValue(config, 'repeat', 0)));
                    chain.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', GetValue(config, 'repeatDelay', 0)));
                    chain.paused = GetBoolean(config, 'paused', false);
                    chain.persist = GetBoolean(config, 'persist', false);
                    //  Set the Callbacks
                    chain.callbackScope = GetValue(config, 'callbackScope', chain);
                    var i;
                    var callbacks = BaseTween.TYPES;
                    for(i = 0; i < callbacks.length; i++){
                        var type = callbacks[i];
                        var callback = GetValue(config, type, false);
                        if (callback) {
                            var callbackParams = GetValue(config, type + 'Params', []);
                            chain.setCallback(type, callback, callbackParams);
                        }
                    }
                    //  Add in the Tweens
                    var tweens = GetValue(config, 'tweens', null);
                    if (Array.isArray(tweens)) {
                        var chainedTweens = [];
                        var targets = GetTargets(config);
                        var defaults = undefined;
                        if (targets) defaults = {
                            targets: targets
                        };
                        for(i = 0; i < tweens.length; i++)chainedTweens.push(TweenBuilder(chain, tweens[i], defaults));
                        chain.add(chainedTweens);
                    }
                    return chain;
                };
                module1.exports = TweenChainBuilder;
            /***/ },
            /***/ 30231: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tweens.Builders
 */ module1.exports = {
                    GetBoolean: __webpack_require__(57355),
                    GetEaseFunction: __webpack_require__(6113),
                    GetInterpolationFunction: __webpack_require__(91389),
                    GetNewValue: __webpack_require__(55292),
                    GetProps: __webpack_require__(82985),
                    GetTargets: __webpack_require__(62329),
                    GetValueOp: __webpack_require__(17777),
                    NumberTweenBuilder: __webpack_require__(88032),
                    StaggerBuilder: __webpack_require__(93109),
                    TweenBuilder: __webpack_require__(8357)
                };
            /***/ },
            /***/ 73685: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Active Event.
 *
 * This event is dispatched by a Tween when it becomes active within the Tween Manager.
 *
 * An 'active' Tween is one that is now progressing, although it may not yet be updating
 * any target properties, due to settings such as `delay`. If you need an event for when
 * the Tween starts actually updating its first property, see `TWEEN_START`.
 *
 * Listen to it from a Tween instance using `Tween.on('active', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.create({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('active', listener);
 * this.tweens.existing(tween);
 * ```
 *
 * Note that this event is usually dispatched already by the time you call `this.tweens.add()`, and is
 * meant for use with `tweens.create()` and/or `tweens.existing()`.
 *
 * @event Phaser.Tweens.Events#TWEEN_ACTIVE
 * @type {string}
 * @since 3.19.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {(any|any[])} targets - The targets of the Tween. If this Tween has multiple targets this will be an array of the targets.
 */ module1.exports = 'active';
            /***/ },
            /***/ 98540: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Complete Event.
 *
 * This event is dispatched by a Tween when it completes playback entirely, factoring in repeats and loops.
 *
 * If the Tween has been set to loop or repeat infinitely, this event will not be dispatched
 * unless the `Tween.stop` method is called.
 *
 * If a Tween has a `completeDelay` set, this event will fire after that delay expires.
 *
 * Listen to it from a Tween instance using `Tween.on('complete', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('complete', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_COMPLETE
 * @type {string}
 * @since 3.19.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {(any|any[])} targets - The targets of the Tween. If this Tween has multiple targets this will be an array of the targets.
 */ module1.exports = 'complete';
            /***/ },
            /***/ 67233: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Loop Event.
 *
 * This event is dispatched by a Tween when it loops.
 *
 * This event will only be dispatched if the Tween has a loop count set.
 *
 * If a Tween has a `loopDelay` set, this event will fire after that delay expires.
 *
 * The difference between `loop` and `repeat` is that `repeat` is a property setting,
 * where-as `loop` applies to the entire Tween.
 *
 * Listen to it from a Tween instance using `Tween.on('loop', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     loop: 6
 * });
 * tween.on('loop', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_LOOP
 * @type {string}
 * @since 3.19.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {(any|any[])} targets - The targets of the Tween. If this Tween has multiple targets this will be an array of the targets.
 */ module1.exports = 'loop';
            /***/ },
            /***/ 2859: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Pause Event.
 *
 * This event is dispatched by a Tween when it is paused.
 *
 * Listen to it from a Tween instance using `Tween.on('pause', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     x: 600
 * });
 * tween.on('pause', listener);
 * // At some point later ...
 * tween.pause();
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_PAUSE
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 */ module1.exports = 'pause';
            /***/ },
            /***/ 98336: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Repeat Event.
 *
 * This event is dispatched by a Tween when one of the properties it is tweening repeats.
 *
 * This event will only be dispatched if the Tween has a property with a repeat count set.
 *
 * If a Tween has a `repeatDelay` set, this event will fire after that delay expires.
 *
 * The difference between `loop` and `repeat` is that `repeat` is a property setting,
 * where-as `loop` applies to the entire Tween.
 *
 * Listen to it from a Tween instance using `Tween.on('repeat', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     repeat: 4
 * });
 * tween.on('repeat', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_REPEAT
 * @type {string}
 * @since 3.19.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The property on the target that has just repeated, i.e. `x` or `scaleY`, or whatever property you are tweening.
 * @param {any} target - The target object that was repeated. Usually a Game Object, but can be of any type.
 * @param {number} current - The current value of the property being set on the target.
 * @param {number} previous - The previous value of the property being set on the target.
 */ module1.exports = 'repeat';
            /***/ },
            /***/ 25764: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Resume Event.
 *
 * This event is dispatched by a Tween when it is resumed from a paused state.
 *
 * Listen to it from a Tween instance using `Tween.on('resume', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     x: 600
 * });
 * tween.on('resume', listener);
 * // At some point later ...
 * tween.resume();
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_RESUME
 * @type {string}
 * @since 3.60.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 */ module1.exports = 'resume';
            /***/ },
            /***/ 32193: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Start Event.
 *
 * This event is dispatched by a Tween when it starts tweening its first property.
 *
 * A Tween will only emit this event once, as it can only start once.
 *
 * If a Tween has a `delay` set, this event will fire after that delay expires.
 *
 * Listen to it from a Tween instance using `Tween.on('start', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('start', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_START
 * @type {string}
 * @since 3.19.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {(any|any[])} targets - The targets of the Tween. If this Tween has multiple targets this will be an array of the targets.
 */ module1.exports = 'start';
            /***/ },
            /***/ 84371: /***/ (module1)=>{
                /**
 * @author       samme
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Stop Event.
 *
 * This event is dispatched by a Tween when it is stopped.
 *
 * Listen to it from a Tween instance using `Tween.on('stop', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('stop', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_STOP
 * @type {string}
 * @since 3.24.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {(any|any[])} targets - The targets of the Tween. If this Tween has multiple targets this will be an array of the targets.
 */ module1.exports = 'stop';
            /***/ },
            /***/ 70766: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Update Event.
 *
 * This event is dispatched by a Tween every time it updates _any_ of the properties it is tweening.
 *
 * A Tween that is changing 3 properties of a target will emit this event 3 times per change, once per property.
 *
 * **Note:** This is a very high frequency event and may be dispatched multiple times, every single frame.
 *
 * Listen to it from a Tween instance using `Tween.on('update', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 * });
 * tween.on('update', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_UPDATE
 * @type {string}
 * @since 3.19.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The property on the target that has just updated, i.e. `x` or `scaleY`, or whatever property you are tweening.
 * @param {any} target - The target object that was updated. Usually a Game Object, but can be of any type.
 * @param {number} current - The current value of the property that was tweened.
 * @param {number} previous - The previous value of the property that was tweened, prior to this update.
 */ module1.exports = 'update';
            /***/ },
            /***/ 55659: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Yoyo Event.
 *
 * This event is dispatched by a Tween whenever a property it is tweening yoyos.
 *
 * This event will only be dispatched if the Tween has a property with `yoyo` set.
 *
 * If the Tween has a `hold` value, this event is dispatched when the hold expires.
 *
 * This event is dispatched for every property, and for every target, that yoyos.
 * For example, if a Tween was updating 2 properties and had 10 targets, this event
 * would be dispatched 20 times (twice per target). So be careful how you use it!
 *
 * Listen to it from a Tween instance using `Tween.on('yoyo', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     yoyo: true
 * });
 * tween.on('yoyo', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_YOYO
 * @type {string}
 * @since 3.19.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The property on the target that has just yoyo'd, i.e. `x` or `scaleY`, or whatever property you are tweening.
 * @param {any} target - The target object that was yoyo'd. Usually a Game Object, but can be of any type.
 * @param {number} current - The current value of the property being set on the target.
 * @param {number} previous - The previous value of the property being set on the target.
 */ module1.exports = 'yoyo';
            /***/ },
            /***/ 842: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tweens.Events
 */ module1.exports = {
                    TWEEN_ACTIVE: __webpack_require__(73685),
                    TWEEN_COMPLETE: __webpack_require__(98540),
                    TWEEN_LOOP: __webpack_require__(67233),
                    TWEEN_PAUSE: __webpack_require__(2859),
                    TWEEN_RESUME: __webpack_require__(25764),
                    TWEEN_REPEAT: __webpack_require__(98336),
                    TWEEN_START: __webpack_require__(32193),
                    TWEEN_STOP: __webpack_require__(84371),
                    TWEEN_UPDATE: __webpack_require__(70766),
                    TWEEN_YOYO: __webpack_require__(55659)
                };
            /***/ },
            /***/ 43066: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tweens
 */ var Tweens = {
                    States: __webpack_require__(86353),
                    Builders: __webpack_require__(30231),
                    Events: __webpack_require__(842),
                    TweenManager: __webpack_require__(40382),
                    Tween: __webpack_require__(86081),
                    TweenData: __webpack_require__(48177),
                    TweenFrameData: __webpack_require__(42220),
                    BaseTween: __webpack_require__(70402),
                    TweenChain: __webpack_require__(43960)
                };
                module1.exports = Tweens;
            /***/ },
            /***/ 70402: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var EventEmitter = __webpack_require__(50792);
                var Events = __webpack_require__(842);
                var TWEEN_CONST = __webpack_require__(86353);
                /**
 * @classdesc
 * As the name implies, this is the base Tween class that both the Tween and TweenChain
 * inherit from. It contains shared properties and methods common to both types of Tween.
 *
 * Typically you would never instantiate this class directly, although you could certainly
 * use it to create your own variation of Tweens from.
 *
 * @class BaseTween
 * @memberof Phaser.Tweens
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.60.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.TweenChain)} parent - A reference to the Tween Manager, or Tween Chain, that owns this Tween.
 */ var BaseTween = new Class({
                    Extends: EventEmitter,
                    initialize: function BaseTween(parent) {
                        EventEmitter.call(this);
                        /**
         * A reference to the Tween Manager, or Tween Chain, that owns this Tween.
         *
         * @name Phaser.Tweens.BaseTween#parent
         * @type {(Phaser.Tweens.TweenManager|Phaser.Tweens.TweenChain)}
         * @since 3.60.0
         */ this.parent = parent;
                        /**
         * The main data array. For a Tween, this contains all of the `TweenData` objects, each
         * containing a unique property and target that is being tweened.
         *
         * For a TweenChain, this contains an array of `Tween` instances, which are being played
         * through in sequence.
         *
         * @name Phaser.Tweens.BaseTween#data
         * @type {(Phaser.Tweens.TweenData[]|Phaser.Tweens.Tween[])}
         * @since 3.60.0
         */ this.data = [];
                        /**
         * The cached size of the data array.
         *
         * @name Phaser.Tweens.BaseTween#totalData
         * @type {number}
         * @since 3.60.0
         */ this.totalData = 0;
                        /**
         * The time in milliseconds before the 'onStart' event fires.
         *
         * For a Tween, this is the shortest `delay` value across all of the TweenDatas it owns.
         * For a TweenChain, it is whatever delay value was given in the configuration.
         *
         * @name Phaser.Tweens.BaseTween#startDelay
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.startDelay = 0;
                        /**
         * Has this Tween started playback yet?
         *
         * This boolean is toggled when the Tween leaves the 'start delayed' state and begins running.
         *
         * @name Phaser.Tweens.BaseTween#hasStarted
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.hasStarted = false;
                        /**
         * Scales the time applied to this Tween. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
         *
         * The value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
         *
         * This value is multiplied by the `TweenManager.timeScale`.
         *
         * @name Phaser.Tweens.BaseTween#timeScale
         * @type {number}
         * @default 1
         * @since 3.60.0
         */ this.timeScale = 1;
                        /**
         * The number of times this Tween will loop.
         *
         * Can be -1 for an infinite loop, zero for none, or a positive integer.
         *
         * Typically this is set in the configuration object, but can also be set directly
         * as long as this Tween is paused and hasn't started playback.
         *
         * When enabled it will play through ALL Tweens again.
         *
         * Use TweenData.repeat to loop a single element.
         *
         * @name Phaser.Tweens.BaseTween#loop
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.loop = 0;
                        /**
         * The time in milliseconds before the Tween loops.
         *
         * Only used if `loop` is > 0.
         *
         * @name Phaser.Tweens.BaseTween#loopDelay
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.loopDelay = 0;
                        /**
         * Internal counter recording how many loops are left to run.
         *
         * @name Phaser.Tweens.BaseTween#loopCounter
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.loopCounter = 0;
                        /**
         * The time in milliseconds before the 'onComplete' event fires.
         *
         * This never fires if `loop = -1` as it never completes because it has been
         * set to loop forever.
         *
         * @name Phaser.Tweens.BaseTween#completeDelay
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.completeDelay = 0;
                        /**
         * An internal countdown timer (used by loopDelay and completeDelay)
         *
         * @name Phaser.Tweens.BaseTween#countdown
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.countdown = 0;
                        /**
         * The current state of the Tween.
         *
         * @name Phaser.Tweens.BaseTween#state
         * @type {Phaser.Tweens.StateType}
         * @since 3.60.0
         */ this.state = TWEEN_CONST.PENDING;
                        /**
         * Is the Tween currently paused?
         *
         * A paused Tween needs to be started with the `play` method, or resumed with the `resume` method.
         *
         * This property can be toggled at runtime if required.
         *
         * @name Phaser.Tweens.BaseTween#paused
         * @type {boolean}
         * @default false
         * @since 3.60.0
         */ this.paused = false;
                        /**
         * An object containing the different Tween callback functions.
         *
         * You can either set these in the Tween config, or by calling the `Tween.setCallback` method.
         *
         * The types available are:
         *
         * `onActive` - When the Tween is first created it moves to an 'active' state when added to the Tween Manager. 'Active' does not mean 'playing'.
         * `onStart` - When the Tween starts playing after a delayed or paused state. This will happen at the same time as `onActive` if the tween has no delay and isn't paused.
         * `onLoop` - When a Tween loops, if it has been set to do so. This happens _after_ the `loopDelay` expires, if set.
         * `onComplete` - When the Tween finishes playback fully. Never invoked if the Tween is set to repeat infinitely.
         * `onStop` - Invoked only if the `Tween.stop` method is called.
         * `onPause` - Invoked only if the `Tween.pause` method is called. Not invoked if the Tween Manager is paused.
         * `onResume` - Invoked only if the `Tween.resume` method is called. Not invoked if the Tween Manager is resumed.
         *
         * The following types are also available and are invoked on a `TweenData` level - that is per-object, per-property, being tweened.
         *
         * `onYoyo` - When a TweenData starts a yoyo. This happens _after_ the `hold` delay expires, if set.
         * `onRepeat` - When a TweenData repeats playback. This happens _after_ the `repeatDelay` expires, if set.
         * `onUpdate` - When a TweenData updates a property on a source target during playback.
         *
         * @name Phaser.Tweens.BaseTween#callbacks
         * @type {Phaser.Types.Tweens.TweenCallbacks}
         * @since 3.60.0
         */ this.callbacks = {
                            onActive: null,
                            onComplete: null,
                            onLoop: null,
                            onPause: null,
                            onRepeat: null,
                            onResume: null,
                            onStart: null,
                            onStop: null,
                            onUpdate: null,
                            onYoyo: null
                        };
                        /**
         * The scope (or context) in which all of the callbacks are invoked.
         *
         * This defaults to be this Tween, but you can override this property
         * to set it to whatever object you require.
         *
         * @name Phaser.Tweens.BaseTween#callbackScope
         * @type {any}
         * @since 3.60.0
         */ this.callbackScope;
                        /**
         * Will this Tween persist after playback? A Tween that persists will _not_ be destroyed by the
         * Tween Manager, or when calling `Tween.stop`, and can be re-played as required. You can either
         * set this property when creating the tween in the tween config, or set it _prior_ to playback.
         *
         * However, it's up to you to ensure you destroy persistent tweens when you are finished with them,
         * or they will retain references you may no longer require and waste memory.
         *
         * By default, `Tweens` are set to _not_ persist, so they are automatically cleaned-up by
         * the Tween Manager.
         *
         * @name Phaser.Tweens.BaseTween#persist
         * @type {boolean}
         * @since 3.60.0
         */ this.persist = false;
                    },
                    /**
     * Sets the value of the time scale applied to this Tween. A value of 1 runs in real-time.
     * A value of 0.5 runs 50% slower, and so on.
     *
     * The value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
     *
     * This value is multiplied by the `TweenManager.timeScale`.
     *
     * @method Phaser.Tweens.BaseTween#setTimeScale
     * @since 3.60.0
     *
     * @param {number} value - The time scale value to set.
     *
     * @return {this} This Tween instance.
     */ setTimeScale: function(value) {
                        this.timeScale = value;
                        return this;
                    },
                    /**
     * Gets the value of the time scale applied to this Tween. A value of 1 runs in real-time.
     * A value of 0.5 runs 50% slower, and so on.
     *
     * @method Phaser.Tweens.BaseTween#getTimeScale
     * @since 3.60.0
     *
     * @return {number} The value of the time scale applied to this Tween.
     */ getTimeScale: function() {
                        return this.timeScale;
                    },
                    /**
     * Checks if this Tween is currently playing.
     *
     * If this Tween is paused, or not active, this method will return false.
     *
     * @method Phaser.Tweens.BaseTween#isPlaying
     * @since 3.60.0
     *
     * @return {boolean} `true` if the Tween is playing, otherwise `false`.
     */ isPlaying: function() {
                        return !this.paused && this.isActive();
                    },
                    /**
     * Checks if the Tween is currently paused.
     *
     * This is the same as inspecting the `BaseTween.paused` property directly.
     *
     * @method Phaser.Tweens.BaseTween#isPaused
     * @since 3.60.0
     *
     * @return {boolean} `true` if the Tween is paused, otherwise `false`.
     */ isPaused: function() {
                        return this.paused;
                    },
                    /**
     * Pauses the Tween immediately. Use `resume` to continue playback.
     *
     * You can also toggle the `Tween.paused` boolean property, but doing so will not trigger the PAUSE event.
     *
     * @method Phaser.Tweens.BaseTween#pause
     * @fires Phaser.Tweens.Events#TWEEN_PAUSE
     * @since 3.60.0
     *
     * @return {this} This Tween instance.
     */ pause: function() {
                        if (!this.paused) {
                            this.paused = true;
                            this.dispatchEvent(Events.TWEEN_PAUSE, 'onPause');
                        }
                        return this;
                    },
                    /**
     * Resumes the playback of a previously paused Tween.
     *
     * You can also toggle the `Tween.paused` boolean property, but doing so will not trigger the RESUME event.
     *
     * @method Phaser.Tweens.BaseTween#resume
     * @fires Phaser.Tweens.Events#TWEEN_RESUME
     * @since 3.60.0
     *
     * @return {this} This Tween instance.
     */ resume: function() {
                        if (this.paused) {
                            this.paused = false;
                            this.dispatchEvent(Events.TWEEN_RESUME, 'onResume');
                        }
                        return this;
                    },
                    /**
     * Internal method that makes this Tween active within the TweenManager
     * and emits the onActive event and callback.
     *
     * @method Phaser.Tweens.BaseTween#makeActive
     * @fires Phaser.Tweens.Events#TWEEN_ACTIVE
     * @since 3.60.0
     */ makeActive: function() {
                        this.parent.makeActive(this);
                        this.dispatchEvent(Events.TWEEN_ACTIVE, 'onActive');
                    },
                    /**
     * Internal method that handles this tween completing and emitting the onComplete event
     * and callback.
     *
     * @method Phaser.Tweens.BaseTween#onCompleteHandler
     * @since 3.60.0
     */ onCompleteHandler: function() {
                        this.setPendingRemoveState();
                        this.dispatchEvent(Events.TWEEN_COMPLETE, 'onComplete');
                    },
                    /**
     * Flags the Tween as being complete, whatever stage of progress it is at.
     *
     * If an `onComplete` callback has been defined it will automatically invoke it, unless a `delay`
     * argument is provided, in which case the Tween will delay for that period of time before calling the callback.
     *
     * If you don't need a delay or don't have an `onComplete` callback then call `Tween.stop` instead.
     *
     * @method Phaser.Tweens.BaseTween#complete
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @since 3.2.0
     *
     * @param {number} [delay=0] - The time to wait before invoking the complete callback. If zero it will fire immediately.
     *
     * @return {this} This Tween instance.
     */ complete: function(delay) {
                        if (delay === undefined) delay = 0;
                        if (delay) {
                            this.setCompleteDelayState();
                            this.countdown = delay;
                        } else this.onCompleteHandler();
                        return this;
                    },
                    /**
     * Flags the Tween as being complete only once the current loop has finished.
     *
     * This is a useful way to stop an infinitely looping tween once a complete cycle is over,
     * rather than abruptly.
     *
     * If you don't have a loop then call `Tween.stop` instead.
     *
     * @method Phaser.Tweens.BaseTween#completeAfterLoop
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @since 3.60.0
     *
     * @param {number} [loops=0] - The number of loops that should finish before this tween completes. Zero means complete just the current loop.
     *
     * @return {this} This Tween instance.
     */ completeAfterLoop: function(loops) {
                        if (loops === undefined) loops = 0;
                        if (this.loopCounter > loops) this.loopCounter = loops;
                        return this;
                    },
                    /**
     * Immediately removes this Tween from the TweenManager and all of its internal arrays,
     * no matter what stage it is at. Then sets the tween state to `REMOVED`.
     *
     * You should dispose of your reference to this tween after calling this method, to
     * free it from memory. If you no longer require it, call `Tween.destroy()` on it.
     *
     * @method Phaser.Tweens.BaseTween#remove
     * @since 3.60.0
     *
     * @return {this} This Tween instance.
     */ remove: function() {
                        if (this.parent) this.parent.remove(this);
                        return this;
                    },
                    /**
     * Stops the Tween immediately, whatever stage of progress it is at.
     *
     * If not a part of a Tween Chain it is also flagged for removal by the Tween Manager.
     *
     * If an `onStop` callback has been defined it will automatically invoke it.
     *
     * The Tween will be removed during the next game frame, but should be considered 'destroyed' from this point on.
     *
     * Typically, you cannot play a Tween that has been stopped. If you just wish to pause the tween, not destroy it,
     * then call the `pause` method instead and use `resume` to continue playback. If you wish to restart the Tween,
     * use the `restart` or `seek` methods.
     *
     * @method Phaser.Tweens.BaseTween#stop
     * @fires Phaser.Tweens.Events#TWEEN_STOP
     * @since 3.60.0
     *
     * @return {this} This Tween instance.
     */ stop: function() {
                        if (this.parent && !this.isRemoved() && !this.isPendingRemove() && !this.isDestroyed()) {
                            this.dispatchEvent(Events.TWEEN_STOP, 'onStop');
                            this.setPendingRemoveState();
                        }
                        return this;
                    },
                    /**
     * Internal method that handles the processing of the loop delay countdown timer and
     * the dispatch of related events. Called automatically by `Tween.update`.
     *
     * @method Phaser.Tweens.BaseTween#updateLoopCountdown
     * @since 3.60.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ updateLoopCountdown: function(delta) {
                        this.countdown -= delta;
                        if (this.countdown <= 0) {
                            this.setActiveState();
                            this.dispatchEvent(Events.TWEEN_LOOP, 'onLoop');
                        }
                    },
                    /**
     * Internal method that handles the processing of the start delay countdown timer and
     * the dispatch of related events. Called automatically by `Tween.update`.
     *
     * @method Phaser.Tweens.BaseTween#updateStartCountdown
     * @since 3.60.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ updateStartCountdown: function(delta) {
                        this.countdown -= delta;
                        if (this.countdown <= 0) {
                            this.hasStarted = true;
                            this.setActiveState();
                            this.dispatchEvent(Events.TWEEN_START, 'onStart');
                            //  Reset the delta so we always start progress from zero
                            delta = 0;
                        }
                        return delta;
                    },
                    /**
     * Internal method that handles the processing of the complete delay countdown timer and
     * the dispatch of related events. Called automatically by `Tween.update`.
     *
     * @method Phaser.Tweens.BaseTween#updateCompleteDelay
     * @since 3.60.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ updateCompleteDelay: function(delta) {
                        this.countdown -= delta;
                        if (this.countdown <= 0) this.onCompleteHandler();
                    },
                    /**
     * Sets an event based callback to be invoked during playback.
     *
     * Calling this method will replace a previously set callback for the given type, if any exists.
     *
     * The types available are:
     *
     * `onActive` - When the Tween is first created it moves to an 'active' state when added to the Tween Manager. 'Active' does not mean 'playing'.
     * `onStart` - When the Tween starts playing after a delayed or paused state. This will happen at the same time as `onActive` if the tween has no delay and isn't paused.
     * `onLoop` - When a Tween loops, if it has been set to do so. This happens _after_ the `loopDelay` expires, if set.
     * `onComplete` - When the Tween finishes playback fully. Never invoked if the Tween is set to repeat infinitely.
     * `onStop` - Invoked only if the `Tween.stop` method is called.
     * `onPause` - Invoked only if the `Tween.pause` method is called. Not invoked if the Tween Manager is paused.
     * `onResume` - Invoked only if the `Tween.resume` method is called. Not invoked if the Tween Manager is resumed.
     *
         * The following types are also available and are invoked on a `TweenData` level - that is per-object, per-property, being tweened.
     *
     * `onYoyo` - When a TweenData starts a yoyo. This happens _after_ the `hold` delay expires, if set.
     * `onRepeat` - When a TweenData repeats playback. This happens _after_ the `repeatDelay` expires, if set.
     * `onUpdate` - When a TweenData updates a property on a source target during playback.
     *
     * @method Phaser.Tweens.BaseTween#setCallback
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.TweenCallbackTypes} type - The type of callback to set. One of: `onActive`, `onComplete`, `onLoop`, `onPause`, `onRepeat`, `onResume`, `onStart`, `onStop`, `onUpdate` or `onYoyo`.
     * @param {function} callback - Your callback that will be invoked.
     * @param {array} [params] - The parameters to pass to the callback. Pass an empty array if you don't want to define any, but do wish to set the scope.
     *
     * @return {this} This Tween instance.
     */ setCallback: function(type, callback, params) {
                        if (params === undefined) params = [];
                        if (this.callbacks.hasOwnProperty(type)) this.callbacks[type] = {
                            func: callback,
                            params: params
                        };
                        return this;
                    },
                    /**
     * Sets this Tween state to PENDING.
     *
     * @method Phaser.Tweens.BaseTween#setPendingState
     * @since 3.60.0
     */ setPendingState: function() {
                        this.state = TWEEN_CONST.PENDING;
                    },
                    /**
     * Sets this Tween state to ACTIVE.
     *
     * @method Phaser.Tweens.BaseTween#setActiveState
     * @since 3.60.0
     */ setActiveState: function() {
                        this.state = TWEEN_CONST.ACTIVE;
                        this.hasStarted = false;
                    },
                    /**
     * Sets this Tween state to LOOP_DELAY.
     *
     * @method Phaser.Tweens.BaseTween#setLoopDelayState
     * @since 3.60.0
     */ setLoopDelayState: function() {
                        this.state = TWEEN_CONST.LOOP_DELAY;
                    },
                    /**
     * Sets this Tween state to COMPLETE_DELAY.
     *
     * @method Phaser.Tweens.BaseTween#setCompleteDelayState
     * @since 3.60.0
     */ setCompleteDelayState: function() {
                        this.state = TWEEN_CONST.COMPLETE_DELAY;
                    },
                    /**
     * Sets this Tween state to START_DELAY.
     *
     * @method Phaser.Tweens.BaseTween#setStartDelayState
     * @since 3.60.0
     */ setStartDelayState: function() {
                        this.state = TWEEN_CONST.START_DELAY;
                        this.countdown = this.startDelay;
                        this.hasStarted = false;
                    },
                    /**
     * Sets this Tween state to PENDING_REMOVE.
     *
     * @method Phaser.Tweens.BaseTween#setPendingRemoveState
     * @since 3.60.0
     */ setPendingRemoveState: function() {
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                    },
                    /**
     * Sets this Tween state to REMOVED.
     *
     * @method Phaser.Tweens.BaseTween#setRemovedState
     * @since 3.60.0
     */ setRemovedState: function() {
                        this.state = TWEEN_CONST.REMOVED;
                    },
                    /**
     * Sets this Tween state to FINISHED.
     *
     * @method Phaser.Tweens.BaseTween#setFinishedState
     * @since 3.60.0
     */ setFinishedState: function() {
                        this.state = TWEEN_CONST.FINISHED;
                    },
                    /**
     * Sets this Tween state to DESTROYED.
     *
     * @method Phaser.Tweens.BaseTween#setDestroyedState
     * @since 3.60.0
     */ setDestroyedState: function() {
                        this.state = TWEEN_CONST.DESTROYED;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of PENDING, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isPending
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of PENDING, otherwise `false`.
     */ isPending: function() {
                        return this.state === TWEEN_CONST.PENDING;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of ACTIVE, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isActive
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of ACTIVE, otherwise `false`.
     */ isActive: function() {
                        return this.state === TWEEN_CONST.ACTIVE;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of LOOP_DELAY, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isLoopDelayed
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of LOOP_DELAY, otherwise `false`.
     */ isLoopDelayed: function() {
                        return this.state === TWEEN_CONST.LOOP_DELAY;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of COMPLETE_DELAY, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isCompleteDelayed
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of COMPLETE_DELAY, otherwise `false`.
     */ isCompleteDelayed: function() {
                        return this.state === TWEEN_CONST.COMPLETE_DELAY;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of START_DELAY, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isStartDelayed
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of START_DELAY, otherwise `false`.
     */ isStartDelayed: function() {
                        return this.state === TWEEN_CONST.START_DELAY;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of PENDING_REMOVE, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isPendingRemove
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of PENDING_REMOVE, otherwise `false`.
     */ isPendingRemove: function() {
                        return this.state === TWEEN_CONST.PENDING_REMOVE;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of REMOVED, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isRemoved
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of REMOVED, otherwise `false`.
     */ isRemoved: function() {
                        return this.state === TWEEN_CONST.REMOVED;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of FINISHED, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isFinished
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of FINISHED, otherwise `false`.
     */ isFinished: function() {
                        return this.state === TWEEN_CONST.FINISHED;
                    },
                    /**
     * Returns `true` if this Tween has a _current_ state of DESTROYED, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTween#isDestroyed
     * @since 3.60.0
     *
     * @return {boolean} `true` if this Tween has a _current_ state of DESTROYED, otherwise `false`.
     */ isDestroyed: function() {
                        return this.state === TWEEN_CONST.DESTROYED;
                    },
                    /**
     * Handles the destroy process of this Tween, clearing out the
     * Tween Data and resetting the targets. A Tween that has been
     * destroyed cannot ever be played or used again.
     *
     * @method Phaser.Tweens.BaseTween#destroy
     * @since 3.60.0
     */ destroy: function() {
                        if (this.data) this.data.forEach(function(tweenData) {
                            tweenData.destroy();
                        });
                        this.removeAllListeners();
                        this.callbacks = null;
                        this.data = null;
                        this.parent = null;
                        this.setDestroyedState();
                    }
                });
                BaseTween.TYPES = [
                    'onActive',
                    'onComplete',
                    'onLoop',
                    'onPause',
                    'onRepeat',
                    'onResume',
                    'onStart',
                    'onStop',
                    'onUpdate',
                    'onYoyo'
                ];
                module1.exports = BaseTween;
            /***/ },
            /***/ 95042: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(83419);
                var Events = __webpack_require__(842);
                var TWEEN_CONST = __webpack_require__(86353);
                /**
 * @classdesc
 * BaseTweenData is the class that the TweenData and TweenFrameData classes
 * extend from. You should not typically instantiate this class directly, but instead
 * use it to form your own tween data classes from, should you require it.
 *
 * Prior to Phaser 3.60 the TweenData was just an object, but was refactored to a class,
 * to make it responsible for its own state and updating.
 *
 * @class BaseTweenData
 * @memberof Phaser.Tweens
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Tweens.Tween} tween - The tween this TweenData instance belongs to.
 * @param {number} targetIndex - The target index within the Tween targets array.
 * @param {string} key - The property of the target to tween.
 * @param {Phaser.Types.Tweens.GetEndCallback} getEnd - What the property will be at the END of the Tween.
 * @param {Phaser.Types.Tweens.GetStartCallback} getStart - What the property will be at the START of the Tween.
 * @param {?Phaser.Types.Tweens.GetActiveCallback} getActive - If not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
 * @param {function} ease - The ease function this tween uses.
 * @param {function} delay - Function that returns the time in milliseconds before tween will start.
 * @param {number} duration - The duration of the tween in milliseconds.
 * @param {boolean} yoyo - Determines whether the tween should return back to its start value after hold has expired.
 * @param {number} hold - Function that returns the time in milliseconds the tween will pause before repeating or returning to its starting value if yoyo is set to true.
 * @param {number} repeat - Function that returns the number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
 * @param {number} repeatDelay - Function that returns the time in milliseconds before the repeat will start.
 * @param {boolean} flipX - Should toggleFlipX be called when yoyo or repeat happens?
 * @param {boolean} flipY - Should toggleFlipY be called when yoyo or repeat happens?
 * @param {?function} interpolation - The interpolation function to be used for arrays of data. Defaults to 'null'.
 * @param {?number[]} interpolationData - The array of interpolation data to be set. Defaults to 'null'.
 */ var BaseTweenData = new Class({
                    initialize: function BaseTweenData(tween, targetIndex, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY) {
                        /**
         * A reference to the Tween that this TweenData instance belongs to.
         *
         * @name Phaser.Tweens.BaseTweenData#tween
         * @type {Phaser.Tweens.Tween}
         * @since 3.60.0
         */ this.tween = tween;
                        /**
         * The index of the target within the Tween `targets` array.
         *
         * @name Phaser.Tweens.BaseTweenData#targetIndex
         * @type {number}
         * @since 3.60.0
         */ this.targetIndex = targetIndex;
                        /**
         * The duration of the tween in milliseconds, excluding any time required
         * for yoyo or repeats. A tween can never have a duration of zero, so this
         * will be set to 0.01 if the value is incorrectly less than or equal to zero.
         *
         * @name Phaser.Tweens.BaseTweenData#duration
         * @type {number}
         * @since 3.60.0
         */ this.duration = duration <= 0 ? 0.01 : duration;
                        /**
         * The total calculated duration, in milliseconds, of this TweenData.
         * Factoring in the duration, repeats, delays and yoyos.
         *
         * @name Phaser.Tweens.BaseTweenData#totalDuration
         * @type {number}
         * @since 3.60.0
         */ this.totalDuration = 0;
                        /**
         * The time, in milliseconds, before this tween will start playing.
         *
         * This value is generated by the `getDelay` function.
         *
         * @name Phaser.Tweens.BaseTweenData#delay
         * @type {number}
         * @since 3.60.0
         */ this.delay = 0;
                        /**
         * This function returns the value to be used for `TweenData.delay`.
         *
         * @name Phaser.Tweens.BaseTweenData#getDelay
         * @type {function}
         * @since 3.60.0
         */ this.getDelay = delay;
                        /**
         * Will the Tween ease back to its starting values, after reaching the end
         * and any `hold` value that may be set?
         *
         * @name Phaser.Tweens.BaseTweenData#yoyo
         * @type {boolean}
         * @since 3.60.0
         */ this.yoyo = yoyo;
                        /**
         * The time, in milliseconds, before this tween will start a yoyo to repeat.
         *
         * @name Phaser.Tweens.BaseTweenData#hold
         * @type {number}
         * @since 3.60.0
         */ this.hold = hold;
                        /**
         * The number of times this tween will repeat.
         *
         * The tween will always run once regardless of this value,
         * so a repeat value of '1' will play the tween twice: I.e. the original
         * play-through and then it repeats that once (1).
         *
         * If this value is set to -1 this tween will repeat forever.
         *
         * @name Phaser.Tweens.BaseTweenData#repeat
         * @type {number}
         * @since 3.60.0
         */ this.repeat = repeat;
                        /**
         * The time, in milliseconds, before the repeat will start.
         *
         * @name Phaser.Tweens.BaseTweenData#repeatDelay
         * @type {number}
         * @since 3.60.0
         */ this.repeatDelay = repeatDelay;
                        /**
         * How many repeats are left to run?
         *
         * @name Phaser.Tweens.BaseTweenData#repeatCounter
         * @type {number}
         * @since 3.60.0
         */ this.repeatCounter = 0;
                        /**
         * If `true` this Tween will call `toggleFlipX` on the Tween target
         * whenever it yoyo's or repeats. It will only be called if the target
         * has a function matching this name, like most Phaser GameObjects do.
         *
         * @name Phaser.Tweens.BaseTweenData#flipX
         * @type {boolean}
         * @since 3.60.0
         */ this.flipX = flipX;
                        /**
         * If `true` this Tween will call `toggleFlipY` on the Tween target
         * whenever it yoyo's or repeats. It will only be called if the target
         * has a function matching this name, like most Phaser GameObjects do.
         *
         * @name Phaser.Tweens.BaseTweenData#flipY
         * @type {boolean}
         * @since 3.60.0
         */ this.flipY = flipY;
                        /**
         * A value between 0 and 1 holding the progress of this TweenData.
         *
         * @name Phaser.Tweens.BaseTweenData#progress
         * @type {number}
         * @since 3.60.0
         */ this.progress = 0;
                        /**
         * The amount of time, in milliseconds, that has elapsed since this
         * TweenData was made active.
         *
         * @name Phaser.Tweens.BaseTweenData#elapsed
         * @type {number}
         * @since 3.60.0
         */ this.elapsed = 0;
                        /**
         * The state of this TweenData.
         *
         * @name Phaser.Tweens.BaseTweenData#state
         * @type {Phaser.Tweens.StateType}
         * @since 3.60.0
         */ this.state = 0;
                        /**
         * Is this Tween Data currently waiting for a countdown to elapse, or not?
         *
         * @name Phaser.Tweens.BaseTweenData#isCountdown
         * @type {boolean}
         * @since 3.60.0
         */ this.isCountdown = false;
                    },
                    /**
     * Returns a reference to the target object belonging to this TweenData.
     *
     * @method Phaser.Tweens.BaseTweenData#getTarget
     * @since 3.60.0
     *
     * @return {object} The target object. Can be any JavaScript object, but is typically a Game Object.
     */ getTarget: function() {
                        return this.tween.targets[this.targetIndex];
                    },
                    /**
     * Sets this TweenData's target object property to be the given value.
     *
     * @method Phaser.Tweens.BaseTweenData#setTargetValue
     * @since 3.60.0
     *
     * @param {number} [value] - The value to set on the target. If not given, sets it to the last `current` value.
     */ setTargetValue: function(value) {
                        if (value === undefined) value = this.current;
                        this.tween.targets[this.targetIndex][this.key] = value;
                    },
                    /**
     * Sets this TweenData state to CREATED.
     *
     * @method Phaser.Tweens.BaseTweenData#setCreatedState
     * @since 3.60.0
     */ setCreatedState: function() {
                        this.state = TWEEN_CONST.CREATED;
                        this.isCountdown = false;
                    },
                    /**
     * Sets this TweenData state to DELAY.
     *
     * @method Phaser.Tweens.BaseTweenData#setDelayState
     * @since 3.60.0
     */ setDelayState: function() {
                        this.state = TWEEN_CONST.DELAY;
                        this.isCountdown = true;
                    },
                    /**
     * Sets this TweenData state to PENDING_RENDER.
     *
     * @method Phaser.Tweens.BaseTweenData#setPendingRenderState
     * @since 3.60.0
     */ setPendingRenderState: function() {
                        this.state = TWEEN_CONST.PENDING_RENDER;
                        this.isCountdown = false;
                    },
                    /**
     * Sets this TweenData state to PLAYING_FORWARD.
     *
     * @method Phaser.Tweens.BaseTweenData#setPlayingForwardState
     * @since 3.60.0
     */ setPlayingForwardState: function() {
                        this.state = TWEEN_CONST.PLAYING_FORWARD;
                        this.isCountdown = false;
                    },
                    /**
     * Sets this TweenData state to PLAYING_BACKWARD.
     *
     * @method Phaser.Tweens.BaseTweenData#setPlayingBackwardState
     * @since 3.60.0
     */ setPlayingBackwardState: function() {
                        this.state = TWEEN_CONST.PLAYING_BACKWARD;
                        this.isCountdown = false;
                    },
                    /**
     * Sets this TweenData state to HOLD_DELAY.
     *
     * @method Phaser.Tweens.BaseTweenData#setHoldState
     * @since 3.60.0
     */ setHoldState: function() {
                        this.state = TWEEN_CONST.HOLD_DELAY;
                        this.isCountdown = true;
                    },
                    /**
     * Sets this TweenData state to REPEAT_DELAY.
     *
     * @method Phaser.Tweens.BaseTweenData#setRepeatState
     * @since 3.60.0
     */ setRepeatState: function() {
                        this.state = TWEEN_CONST.REPEAT_DELAY;
                        this.isCountdown = true;
                    },
                    /**
     * Sets this TweenData state to COMPLETE.
     *
     * @method Phaser.Tweens.BaseTweenData#setCompleteState
     * @since 3.60.0
     */ setCompleteState: function() {
                        this.state = TWEEN_CONST.COMPLETE;
                        this.isCountdown = false;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of CREATED, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isCreated
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of CREATED, otherwise `false`.
     */ isCreated: function() {
                        return this.state === TWEEN_CONST.CREATED;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of DELAY, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isDelayed
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of DELAY, otherwise `false`.
     */ isDelayed: function() {
                        return this.state === TWEEN_CONST.DELAY;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of PENDING_RENDER, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isPendingRender
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of PENDING_RENDER, otherwise `false`.
     */ isPendingRender: function() {
                        return this.state === TWEEN_CONST.PENDING_RENDER;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of PLAYING_FORWARD, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isPlayingForward
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of PLAYING_FORWARD, otherwise `false`.
     */ isPlayingForward: function() {
                        return this.state === TWEEN_CONST.PLAYING_FORWARD;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of PLAYING_BACKWARD, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isPlayingBackward
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of PLAYING_BACKWARD, otherwise `false`.
     */ isPlayingBackward: function() {
                        return this.state === TWEEN_CONST.PLAYING_BACKWARD;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of HOLD_DELAY, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isHolding
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of HOLD_DELAY, otherwise `false`.
     */ isHolding: function() {
                        return this.state === TWEEN_CONST.HOLD_DELAY;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of REPEAT_DELAY, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isRepeating
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of REPEAT_DELAY, otherwise `false`.
     */ isRepeating: function() {
                        return this.state === TWEEN_CONST.REPEAT_DELAY;
                    },
                    /**
     * Returns `true` if this TweenData has a _current_ state of COMPLETE, otherwise `false`.
     *
     * @method Phaser.Tweens.BaseTweenData#isComplete
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenData has a _current_ state of COMPLETE, otherwise `false`.
     */ isComplete: function() {
                        return this.state === TWEEN_CONST.COMPLETE;
                    },
                    /**
     * Internal method used as part of the playback process that checks if this
     * TweenData should yoyo, repeat, or has completed.
     *
     * @method Phaser.Tweens.BaseTweenData#setStateFromEnd
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @fires Phaser.Tweens.Events#TWEEN_YOYO
     * @since 3.60.0
     *
     * @param {number} diff - Any extra time that needs to be accounted for in the elapsed and progress values.
     */ setStateFromEnd: function(diff) {
                        if (this.yoyo) this.onRepeat(diff, true, true);
                        else if (this.repeatCounter > 0) this.onRepeat(diff, true, false);
                        else this.setCompleteState();
                    },
                    /**
     * Internal method used as part of the playback process that checks if this
     * TweenData should repeat or has completed.
     *
     * @method Phaser.Tweens.BaseTweenData#setStateFromStart
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @since 3.60.0
     *
     * @param {number} diff - Any extra time that needs to be accounted for in the elapsed and progress values.
     */ setStateFromStart: function(diff) {
                        if (this.repeatCounter > 0) this.onRepeat(diff, false);
                        else this.setCompleteState();
                    },
                    /**
     * Internal method that resets this Tween Data entirely, including the progress and elapsed values.
     *
     * Called automatically by the parent Tween. Should not be called directly.
     *
     * @method Phaser.Tweens.BaseTweenData#reset
     * @since 3.60.0
     */ reset: function() {
                        var tween = this.tween;
                        var totalTargets = tween.totalTargets;
                        var targetIndex = this.targetIndex;
                        var target = tween.targets[targetIndex];
                        var key = this.key;
                        this.progress = 0;
                        this.elapsed = 0;
                        //  Function signature: target, key, value, index, total, tween
                        this.delay = this.getDelay(target, key, 0, targetIndex, totalTargets, tween);
                        this.repeatCounter = this.repeat === -1 ? TWEEN_CONST.MAX : this.repeat;
                        this.setPendingRenderState();
                        //  calcDuration:
                        //  Set t1 (duration + hold + yoyo)
                        var t1 = this.duration + this.hold;
                        if (this.yoyo) t1 += this.duration;
                        //  Set t2 (repeatDelay + duration + hold + yoyo)
                        var t2 = t1 + this.repeatDelay;
                        //  Total Duration
                        this.totalDuration = this.delay + t1;
                        if (this.repeat === -1) {
                            this.totalDuration += t2 * TWEEN_CONST.MAX;
                            tween.isInfinite = true;
                        } else if (this.repeat > 0) this.totalDuration += t2 * this.repeat;
                        if (this.totalDuration > tween.duration) //  Set the longest duration in the parent Tween
                        tween.duration = this.totalDuration;
                        if (this.delay < tween.startDelay) tween.startDelay = this.delay;
                        if (this.delay > 0) {
                            this.elapsed = this.delay;
                            this.setDelayState();
                        }
                    },
                    /**
     * Internal method that handles repeating or yoyo'ing this TweenData.
     *
     * Called automatically by `setStateFromStart` and `setStateFromEnd`.
     *
     * @method Phaser.Tweens.BaseTweenData#onRepeat
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @fires Phaser.Tweens.Events#TWEEN_YOYO
     * @since 3.60.0
     *
     * @param {number} diff - Any extra time that needs to be accounted for in the elapsed and progress values.
     * @param {boolean} setStart - Set the TweenData start values?
     * @param {boolean} isYoyo - Is this call a Yoyo check?
     */ onRepeat: function(diff, setStart, isYoyo) {
                        var tween = this.tween;
                        var totalTargets = tween.totalTargets;
                        var targetIndex = this.targetIndex;
                        var target = tween.targets[targetIndex];
                        var key = this.key;
                        var isTweenData = key !== 'texture';
                        //  Account for any extra time we got from the previous frame
                        this.elapsed = diff;
                        this.progress = diff / this.duration;
                        if (this.flipX) target.toggleFlipX();
                        if (this.flipY) target.toggleFlipY();
                        if (isTweenData && (setStart || isYoyo)) this.start = this.getStartValue(target, key, this.start, targetIndex, totalTargets, tween);
                        if (isYoyo) {
                            this.setPlayingBackwardState();
                            this.dispatchEvent(Events.TWEEN_YOYO, 'onYoyo');
                            return;
                        }
                        this.repeatCounter--;
                        //  Custom
                        if (isTweenData) this.end = this.getEndValue(target, key, this.start, targetIndex, totalTargets, tween);
                        //  Delay?
                        if (this.repeatDelay > 0) {
                            this.elapsed = this.repeatDelay - diff;
                            if (isTweenData) {
                                this.current = this.start;
                                target[key] = this.current;
                            }
                            this.setRepeatState();
                        } else {
                            this.setPlayingForwardState();
                            this.dispatchEvent(Events.TWEEN_REPEAT, 'onRepeat');
                        }
                    },
                    /**
     * Immediately destroys this TweenData, nulling of all its references.
     *
     * @method Phaser.Tweens.BaseTweenData#destroy
     * @since 3.60.0
     */ destroy: function() {
                        this.tween = null;
                        this.getDelay = null;
                        this.setCompleteState();
                    }
                });
                module1.exports = BaseTweenData;
            /***/ },
            /***/ 69902: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Types.Tweens.TweenConfigDefaults
 * @since 3.0.0
 *
 * @property {(object|object[])} targets - The object, or an array of objects, to run the tween on.
 * @property {number} [delay=0] - The number of milliseconds to delay before the tween will start.
 * @property {number} [duration=1000] - The duration of the tween in milliseconds.
 * @property {string} [ease='Power0'] - The easing equation to use for the tween.
 * @property {array} [easeParams] - Optional easing parameters.
 * @property {number} [hold=0] - The number of milliseconds to hold the tween for before yoyo'ing.
 * @property {number} [repeat=0] - The number of times to repeat the tween.
 * @property {number} [repeatDelay=0] - The number of milliseconds to pause before a tween will repeat.
 * @property {boolean} [yoyo=false] - Should the tween complete, then reverse the values incrementally to get back to the starting tween values? The reverse tweening will also take `duration` milliseconds to complete.
 * @property {boolean} [flipX=false] - Horizontally flip the target of the Tween when it completes (before it yoyos, if set to do so). Only works for targets that support the `flipX` property.
 * @property {boolean} [flipY=false] - Vertically flip the target of the Tween when it completes (before it yoyos, if set to do so). Only works for targets that support the `flipY` property.
 * @property {boolean} [persist=false] - Retain the tween within the Tween Manager, even after playback completes?
 * @property {function} [interpolation=null] - The interpolation function to use for array-based tween values.
 */ var TWEEN_DEFAULTS = {
                    targets: null,
                    delay: 0,
                    duration: 1000,
                    ease: 'Power0',
                    easeParams: null,
                    hold: 0,
                    repeat: 0,
                    repeatDelay: 0,
                    yoyo: false,
                    flipX: false,
                    flipY: false,
                    persist: false,
                    interpolation: null
                };
                module1.exports = TWEEN_DEFAULTS;
            /***/ },
            /***/ 81076: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  RESERVED properties that a Tween config object uses
                //  completeDelay: The time the tween will wait before the onComplete event is dispatched once it has completed
                //  delay: The time the tween will wait before it first starts
                //  duration: The duration of the tween
                //  ease: The ease function used by the tween
                //  easeParams: The parameters to go with the ease function (if any)
                //  flipX: flip X the GameObject on tween end
                //  flipY: flip Y the GameObject on tween end
                //  hold: The time the tween will pause before running a yoyo
                //  loop: The time the tween will pause before starting either a yoyo or returning to the start for a repeat
                //  loopDelay:
                //  paused: Does the tween start in a paused state, or playing?
                //  props: The properties being tweened by the tween
                //  repeat: The number of times the tween will repeat itself (a value of 1 means the tween will play twice, as it repeated once)
                //  repeatDelay: The time the tween will pause for before starting a repeat. The tween holds in the start state.
                //  targets: The targets the tween is updating.
                //  yoyo: boolean - Does the tween reverse itself (yoyo) when it reaches the end?
                module1.exports = [
                    'callbackScope',
                    'completeDelay',
                    'delay',
                    'duration',
                    'ease',
                    'easeParams',
                    'flipX',
                    'flipY',
                    'hold',
                    'interpolation',
                    'loop',
                    'loopDelay',
                    'onActive',
                    'onActiveParams',
                    'onComplete',
                    'onCompleteParams',
                    'onLoop',
                    'onLoopParams',
                    'onPause',
                    'onPauseParams',
                    'onRepeat',
                    'onRepeatParams',
                    'onResume',
                    'onResumeParams',
                    'onStart',
                    'onStartParams',
                    'onStop',
                    'onStopParams',
                    'onUpdate',
                    'onUpdateParams',
                    'onYoyo',
                    'onYoyoParams',
                    'paused',
                    'persist',
                    'props',
                    'repeat',
                    'repeatDelay',
                    'targets',
                    'yoyo'
                ];
            /***/ },
            /***/ 86081: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseTween = __webpack_require__(70402);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(842);
                var GameObjectCreator = __webpack_require__(44603);
                var GameObjectFactory = __webpack_require__(39429);
                var MATH_CONST = __webpack_require__(36383);
                var TWEEN_CONST = __webpack_require__(86353);
                var TweenData = __webpack_require__(48177);
                var TweenFrameData = __webpack_require__(42220);
                /**
 * @classdesc
 * A Tween is able to manipulate the properties of one or more objects to any given value, based
 * on a duration and type of ease. They are rarely instantiated directly and instead should be
 * created via the TweenManager.
 *
 * Please note that a Tween will not manipulate any property that begins with an underscore.
 *
 * @class Tween
 * @memberof Phaser.Tweens
 * @extends Phaser.Tweens.BaseTween
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Tweens.TweenManager} parent - A reference to the Tween Manager that owns this Tween.
 * @param {object[]} targets - An array of targets to be tweened. This array should not be manipulated outside of this Tween.
 */ var Tween = new Class({
                    Extends: BaseTween,
                    initialize: function Tween(parent, targets) {
                        BaseTween.call(this, parent);
                        /**
         * An array of references to the target/s this Tween is operating on.
         *
         * This array should not be manipulated outside of this Tween.
         *
         * @name Phaser.Tweens.Tween#targets
         * @type {object[]}
         * @since 3.0.0
         */ this.targets = targets;
                        /**
         * Cached target total.
         *
         * Used internally and should be treated as read-only.
         *
         * This is not necessarily the same as the data total.
         *
         * @name Phaser.Tweens.Tween#totalTargets
         * @type {number}
         * @since 3.0.0
         */ this.totalTargets = targets.length;
                        /**
         * Is this Tween currently seeking?
         *
         * This boolean is toggled in the `Tween.seek` method.
         *
         * When a tween is seeking, by default it will not dispatch any events or callbacks.
         *
         * @name Phaser.Tweens.Tween#isSeeking
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.isSeeking = false;
                        /**
         * Does this Tween loop or repeat infinitely?
         *
         * @name Phaser.Tweens.Tween#isInfinite
         * @type {boolean}
         * @readonly
         * @since 3.60.0
         */ this.isInfinite = false;
                        /**
         * Elapsed time in milliseconds of this run through of the Tween.
         *
         * @name Phaser.Tweens.Tween#elapsed
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.elapsed = 0;
                        /**
         * Total elapsed time in milliseconds of the entire Tween, including looping.
         *
         * @name Phaser.Tweens.Tween#totalElapsed
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.totalElapsed = 0;
                        /**
         * Time in milliseconds for the whole Tween to play through once, excluding loop amounts and loop delays.
         *
         * This value is set in the `Tween.initTweenData` method and is zero before that point.
         *
         * @name Phaser.Tweens.Tween#duration
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.duration = 0;
                        /**
         * Value between 0 and 1. The amount of progress through the Tween, excluding loops.
         *
         * @name Phaser.Tweens.Tween#progress
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.progress = 0;
                        /**
         * Time in milliseconds it takes for the Tween to complete a full playthrough (including looping)
         *
         * For an infinite Tween, this value is a very large integer.
         *
         * @name Phaser.Tweens.Tween#totalDuration
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.totalDuration = 0;
                        /**
         * The amount of progress that has been made through the entire Tween, including looping.
         *
         * A value between 0 and 1.
         *
         * @name Phaser.Tweens.Tween#totalProgress
         * @type {number}
         * @default 0
         * @since 3.60.0
         */ this.totalProgress = 0;
                        /**
         * Is this Tween a Number Tween? Number Tweens are a special kind of tween that don't have a target.
         *
         * @name Phaser.Tweens.Tween#isNumberTween
         * @type {boolean}
         * @default false
         * @since 3.88.0
         */ this.isNumberTween = false;
                    },
                    /**
     * Adds a new TweenData to this Tween. Typically, this method is called
     * automatically by the TweenBuilder, however you can also invoke it
     * yourself.
     *
     * @method Phaser.Tweens.Tween#add
     * @since 3.60.0
     *
     * @param {number} targetIndex - The target index within the Tween targets array.
     * @param {string} key - The property of the target to tween.
     * @param {Phaser.Types.Tweens.GetEndCallback} getEnd - What the property will be at the END of the Tween.
     * @param {Phaser.Types.Tweens.GetStartCallback} getStart - What the property will be at the START of the Tween.
     * @param {?Phaser.Types.Tweens.GetActiveCallback} getActive - If not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
     * @param {function} ease - The ease function this tween uses.
     * @param {function} delay - Function that returns the time in milliseconds before tween will start.
     * @param {number} duration - The duration of the tween in milliseconds.
     * @param {boolean} yoyo - Determines whether the tween should return back to its start value after hold has expired.
     * @param {number} hold - Function that returns the time in milliseconds the tween will pause before repeating or returning to its starting value if yoyo is set to true.
     * @param {number} repeat - Function that returns the number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
     * @param {number} repeatDelay - Function that returns the time in milliseconds before the repeat will start.
     * @param {boolean} flipX - Should toggleFlipX be called when yoyo or repeat happens?
     * @param {boolean} flipY - Should toggleFlipY be called when yoyo or repeat happens?
     * @param {?function} interpolation - The interpolation function to be used for arrays of data. Defaults to 'null'.
     * @param {?number[]} interpolationData - The array of interpolation data to be set. Defaults to 'null'.
     *
     * @return {Phaser.Tweens.TweenData} The TweenData instance that was added.
     */ add: function(targetIndex, key, getEnd, getStart, getActive, ease, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY, interpolation, interpolationData) {
                        var tweenData = new TweenData(this, targetIndex, key, getEnd, getStart, getActive, ease, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY, interpolation, interpolationData);
                        this.totalData = this.data.push(tweenData);
                        return tweenData;
                    },
                    /**
     * Adds a new TweenFrameData to this Tween. Typically, this method is called
     * automatically by the TweenBuilder, however you can also invoke it
     * yourself.
     *
     * @method Phaser.Tweens.Tween#addFrame
     * @since 3.60.0
     *
     * @param {number} targetIndex - The target index within the Tween targets array.
     * @param {string} texture - The texture to set on the target at the end of the tween.
     * @param {string|number} frame - The texture frame to set on the target at the end of the tween.
     * @param {function} delay - Function that returns the time in milliseconds before tween will start.
     * @param {number} duration - The duration of the tween in milliseconds.
     * @param {number} hold - Function that returns the time in milliseconds the tween will pause before repeating or returning to its starting value if yoyo is set to true.
     * @param {number} repeat - Function that returns the number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
     * @param {number} repeatDelay - Function that returns the time in milliseconds before the repeat will start.
     * @param {boolean} flipX - Should toggleFlipX be called when yoyo or repeat happens?
     * @param {boolean} flipY - Should toggleFlipY be called when yoyo or repeat happens?
     *
     * @return {Phaser.Tweens.TweenFrameData} The TweenFrameData instance that was added.
     */ addFrame: function(targetIndex, texture, frame, delay, duration, hold, repeat, repeatDelay, flipX, flipY) {
                        var tweenData = new TweenFrameData(this, targetIndex, texture, frame, delay, duration, hold, repeat, repeatDelay, flipX, flipY);
                        this.totalData = this.data.push(tweenData);
                        return tweenData;
                    },
                    /**
     * Returns the current value of the specified Tween Data.
     *
     * If this Tween has been destroyed, it will return `null`.
     *
     * @method Phaser.Tweens.Tween#getValue
     * @since 3.0.0
     *
     * @param {number} [index=0] - The Tween Data to return the value from.
     *
     * @return {number} The value of the requested Tween Data, or `null` if this Tween has been destroyed.
     */ getValue: function(index) {
                        if (index === undefined) index = 0;
                        var value = null;
                        if (this.data) value = this.data[index].current;
                        return value;
                    },
                    /**
     * See if this Tween is currently acting upon the given target.
     *
     * @method Phaser.Tweens.Tween#hasTarget
     * @since 3.0.0
     *
     * @param {object} target - The target to check against this Tween.
     *
     * @return {boolean} `true` if the given target is a target of this Tween, otherwise `false`.
     */ hasTarget: function(target) {
                        return this.targets && this.targets.indexOf(target) !== -1;
                    },
                    /**
     * Updates the 'end' value of the given property across all matching targets, as long
     * as this Tween is currently playing (either forwards or backwards).
     *
     * Calling this does not adjust the duration of the Tween, or the current progress.
     *
     * You can optionally tell it to set the 'start' value to be the current value.
     *
     * If this Tween is in any other state other than playing then calling this method has no effect.
     *
     * Additionally, if the Tween repeats, is reset, or is seeked, it will revert to the original
     * starting and ending values.
     *
     * @method Phaser.Tweens.Tween#updateTo
     * @since 3.0.0
     *
     * @param {string} key - The property to set the new value for. You cannot update the 'texture' property via this method.
     * @param {number} value - The new value of the property.
     * @param {boolean} [startToCurrent=false] - Should this change set the start value to be the current value?
     *
     * @return {this} This Tween instance.
     */ updateTo: function(key, value, startToCurrent) {
                        if (startToCurrent === undefined) startToCurrent = false;
                        if (key !== 'texture') for(var i = 0; i < this.totalData; i++){
                            var tweenData = this.data[i];
                            if (tweenData.key === key && (tweenData.isPlayingForward() || tweenData.isPlayingBackward())) {
                                tweenData.end = value;
                                if (startToCurrent) tweenData.start = tweenData.current;
                            }
                        }
                        return this;
                    },
                    /**
     * Restarts the Tween from the beginning.
     *
     * If the Tween has already finished and been destroyed, restarting it will throw an error.
     *
     * If you wish to restart the Tween from a specific point, use the `Tween.seek` method instead.
     *
     * @method Phaser.Tweens.Tween#restart
     * @since 3.0.0
     *
     * @return {this} This Tween instance.
     */ restart: function() {
                        switch(this.state){
                            case TWEEN_CONST.REMOVED:
                            case TWEEN_CONST.FINISHED:
                                this.seek();
                                this.parent.makeActive(this);
                                break;
                            case TWEEN_CONST.PENDING:
                            case TWEEN_CONST.PENDING_REMOVE:
                                this.parent.reset(this);
                                break;
                            case TWEEN_CONST.DESTROYED:
                                console.warn('Cannot restart destroyed Tween', this);
                                break;
                            default:
                                this.seek();
                                break;
                        }
                        this.paused = false;
                        this.hasStarted = false;
                        return this;
                    },
                    /**
     * Internal method that advances to the next state of the Tween during playback.
     *
     * @method Phaser.Tweens.Tween#nextState
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Tween has completed, otherwise `false`.
     */ nextState: function() {
                        if (this.loopCounter > 0) {
                            this.elapsed = 0;
                            this.progress = 0;
                            this.loopCounter--;
                            this.initTweenData(true);
                            if (this.loopDelay > 0) {
                                this.countdown = this.loopDelay;
                                this.setLoopDelayState();
                            } else {
                                this.setActiveState();
                                this.dispatchEvent(Events.TWEEN_LOOP, 'onLoop');
                            }
                        } else if (this.completeDelay > 0) {
                            this.countdown = this.completeDelay;
                            this.setCompleteDelayState();
                        } else {
                            this.onCompleteHandler();
                            return true;
                        }
                        return false;
                    },
                    /**
     * Internal method that handles this tween completing and starting
     * the next tween in the chain, if any.
     *
     * @method Phaser.Tweens.Tween#onCompleteHandler
     * @since 3.60.0
     */ onCompleteHandler: function() {
                        this.progress = 1;
                        this.totalProgress = 1;
                        BaseTween.prototype.onCompleteHandler.call(this);
                    },
                    /**
     * Starts a Tween playing.
     *
     * You only need to call this method if you have configured the tween to be paused on creation.
     *
     * If the Tween is already playing, calling this method again will have no effect. If you wish to
     * restart the Tween, use `Tween.restart` instead.
     *
     * Calling this method after the Tween has completed will start the Tween playing again from the beginning.
     * This is the same as calling `Tween.seek(0)` and then `Tween.play()`.
     *
     * @method Phaser.Tweens.Tween#play
     * @since 3.0.0
     *
     * @return {this} This Tween instance.
     */ play: function() {
                        if (this.isDestroyed()) {
                            console.warn('Cannot play destroyed Tween', this);
                            return this;
                        }
                        if (this.isPendingRemove() || this.isFinished()) this.seek();
                        this.paused = false;
                        this.setActiveState();
                        return this;
                    },
                    /**
     * Seeks to a specific point in the Tween.
     *
     * The given amount is a value in milliseconds that represents how far into the Tween
     * you wish to seek, based on the start of the Tween.
     *
     * Note that the seek amount takes the entire duration of the Tween into account, including delays, loops and repeats.
     * For example, a Tween that lasts for 2 seconds, but that loops 3 times, would have a total duration of 6 seconds,
     * so seeking to 3000 ms would seek to the Tweens half-way point based on its _entire_ duration.
     *
     * Prior to Phaser 3.60 this value was given as a number between 0 and 1 and didn't
     * work for Tweens had an infinite repeat. This new method works for all Tweens.
     *
     * Seeking works by resetting the Tween to its initial values and then iterating through the Tween at `delta`
     * jumps per step. The longer the Tween, the longer this can take. If you need more precision you can
     * reduce the delta value. If you need a faster seek, you can increase it. When the Tween is
     * reset it will refresh the starting and ending values. If these are coming from a dynamic function,
     * or a random array, it will be called for each seek.
     *
     * While seeking the Tween will _not_ emit any of its events or callbacks unless
     * the 3rd parameter is set to `true`.
     *
     * If this Tween is paused, seeking will not change this fact. It will advance the Tween
     * to the desired point and then pause it again.
     *
     * @method Phaser.Tweens.Tween#seek
     * @since 3.0.0
     *
     * @param {number} [amount=0] - The number of milliseconds to seek into the Tween from the beginning.
     * @param {number} [delta=16.6] - The size of each step when seeking through the Tween. A higher value completes faster but at the cost of less precision.
     * @param {boolean} [emit=false] - While seeking, should the Tween emit any of its events or callbacks? The default is 'false', i.e. to seek silently.
     *
     * @return {this} This Tween instance.
     */ seek: function(amount, delta, emit) {
                        if (amount === undefined) amount = 0;
                        if (delta === undefined) delta = 16.6;
                        if (emit === undefined) emit = false;
                        if (this.isDestroyed()) {
                            console.warn('Cannot seek destroyed Tween', this);
                            return this;
                        }
                        if (!emit) this.isSeeking = true;
                        this.reset(true);
                        this.initTweenData(true);
                        this.setActiveState();
                        this.dispatchEvent(Events.TWEEN_ACTIVE, 'onActive');
                        var isPaused = this.paused;
                        this.paused = false;
                        if (amount > 0) {
                            var iterations = Math.floor(amount / delta);
                            var remainder = amount - iterations * delta;
                            for(var i = 0; i < iterations; i++)this.update(delta);
                            if (remainder > 0) this.update(remainder);
                        }
                        this.paused = isPaused;
                        this.isSeeking = false;
                        return this;
                    },
                    /**
     * Initialises all of the Tween Data and Tween values.
     *
     * This is called automatically and should not typically be invoked directly.
     *
     * @method Phaser.Tweens.Tween#initTweenData
     * @since 3.60.0
     *
     * @param {boolean} [isSeeking=false] - Is the Tween Data being reset as part of a seek?
     */ initTweenData: function(isSeeking) {
                        if (isSeeking === undefined) isSeeking = false;
                        //  These two values are updated directly during TweenData.reset:
                        this.duration = 0;
                        this.startDelay = MATH_CONST.MAX_SAFE_INTEGER;
                        var data = this.data;
                        for(var i = 0; i < this.totalData; i++)data[i].reset(isSeeking);
                        //  Clamp duration to ensure we never divide by zero
                        this.duration = Math.max(this.duration, 0.01);
                        var duration = this.duration;
                        var completeDelay = this.completeDelay;
                        var loopCounter = this.loopCounter;
                        var loopDelay = this.loopDelay;
                        if (loopCounter > 0) this.totalDuration = duration + completeDelay + (duration + loopDelay) * loopCounter;
                        else this.totalDuration = duration + completeDelay;
                    },
                    /**
     * Resets this Tween ready for another play-through.
     *
     * This is called automatically from the Tween Manager, or from the parent TweenChain,
     * and should not typically be invoked directly.
     *
     * If you wish to restart this Tween, use the `Tween.restart` or `Tween.seek` methods instead.
     *
     * @method Phaser.Tweens.Tween#reset
     * @fires Phaser.Tweens.Events#TWEEN_ACTIVE
     * @since 3.60.0
     *
     * @param {boolean} [skipInit=false] - Skip resetting the TweenData and Active State?
     *
     * @return {this} This Tween instance.
     */ reset: function(skipInit) {
                        if (skipInit === undefined) skipInit = false;
                        this.elapsed = 0;
                        this.totalElapsed = 0;
                        this.progress = 0;
                        this.totalProgress = 0;
                        this.loopCounter = this.loop;
                        if (this.loop === -1) {
                            this.isInfinite = true;
                            this.loopCounter = TWEEN_CONST.MAX;
                        }
                        if (!skipInit) {
                            this.initTweenData();
                            this.setActiveState();
                            this.dispatchEvent(Events.TWEEN_ACTIVE, 'onActive');
                        }
                        return this;
                    },
                    /**
     * Internal method that advances the Tween based on the time values.
     *
     * @method Phaser.Tweens.Tween#update
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @fires Phaser.Tweens.Events#TWEEN_START
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} Returns `true` if this Tween has finished and should be removed from the Tween Manager, otherwise returns `false`.
     */ update: function(delta) {
                        if (this.isPendingRemove() || this.isDestroyed()) {
                            if (this.persist) {
                                this.setFinishedState();
                                return false;
                            }
                            return true;
                        } else if (this.paused || this.isFinished()) return false;
                        delta *= this.timeScale * this.parent.timeScale;
                        if (this.isLoopDelayed()) {
                            this.updateLoopCountdown(delta);
                            return false;
                        } else if (this.isCompleteDelayed()) {
                            this.updateCompleteDelay(delta);
                            return false;
                        } else if (!this.hasStarted) {
                            this.startDelay -= delta;
                            if (this.startDelay <= 0) {
                                this.hasStarted = true;
                                this.dispatchEvent(Events.TWEEN_START, 'onStart');
                                //  Reset the delta so we always start progress from zero
                                delta = 0;
                            }
                        }
                        var stillRunning = false;
                        if (this.isActive()) {
                            var data = this.data;
                            for(var i = 0; i < this.totalData; i++)if (data[i].update(delta)) stillRunning = true;
                        }
                        this.elapsed += delta;
                        this.progress = Math.min(this.elapsed / this.duration, 1);
                        this.totalElapsed += delta;
                        this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1);
                        //  Anything still running? If not, we're done
                        if (!stillRunning) //  This calls onCompleteHandler if this tween is over
                        this.nextState();
                        //  if nextState called onCompleteHandler then we're ready to be removed, unless we persist
                        var remove = this.isPendingRemove();
                        if (remove && this.persist) {
                            this.setFinishedState();
                            remove = false;
                        }
                        return remove;
                    },
                    /**
     * Moves this Tween forward by the given amount of milliseconds.
     *
     * It will only advance through the current loop of the Tween. For example, if the
     * Tween is set to repeat or yoyo, it can only fast forward through a single
     * section of the sequence. Use `Tween.seek` for more complex playhead control.
     *
     * If the Tween is paused or has already finished, calling this will have no effect.
     *
     * @method Phaser.Tweens.Tween#forward
     * @since 3.60.0
     *
     * @param {number} ms - The number of milliseconds to advance this Tween by.
     *
     * @return {this} This Tween instance.
     */ forward: function(ms) {
                        this.update(ms);
                        return this;
                    },
                    /**
     * Moves this Tween backward by the given amount of milliseconds.
     *
     * It will only rewind through the current loop of the Tween. For example, if the
     * Tween is set to repeat or yoyo, it can only fast forward through a single
     * section of the sequence. Use `Tween.seek` for more complex playhead control.
     *
     * If the Tween is paused or has already finished, calling this will have no effect.
     *
     * @method Phaser.Tweens.Tween#rewind
     * @since 3.60.0
     *
     * @param {number} ms - The number of milliseconds to rewind this Tween by.
     *
     * @return {this} This Tween instance.
     */ rewind: function(ms) {
                        this.update(-ms);
                        return this;
                    },
                    /**
     * Internal method that will emit a Tween based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.Tween#dispatchEvent
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {Phaser.Types.Tweens.TweenCallbackTypes} [callback] - The name of the callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchEvent: function(event, callback) {
                        if (!this.isSeeking) {
                            this.emit(event, this, this.targets);
                            if (!this.callbacks) return;
                            var handler = this.callbacks[callback];
                            if (handler) handler.func.apply(this.callbackScope, [
                                this,
                                this.targets
                            ].concat(handler.params));
                        }
                    },
                    /**
     * Handles the destroy process of this Tween, clearing out the
     * Tween Data and resetting the targets. A Tween that has been
     * destroyed cannot ever be played or used again.
     *
     * @method Phaser.Tweens.Tween#destroy
     * @since 3.60.0
     */ destroy: function() {
                        BaseTween.prototype.destroy.call(this);
                        this.targets = null;
                    }
                });
                /**
 * Creates a new Tween object.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tween
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|Phaser.Types.Tweens.TweenChainBuilderConfig|Phaser.Tweens.Tween|Phaser.Tweens.TweenChain} config - A Tween Configuration object, or a Tween or TweenChain instance.
 *
 * @return {Phaser.Tweens.Tween} The Tween that was created.
 */ GameObjectFactory.register('tween', function(config) {
                    return this.scene.sys.tweens.add(config);
                });
                /**
 * Creates a new Tween object and returns it.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tween
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|Phaser.Types.Tweens.TweenChainBuilderConfig|Phaser.Tweens.Tween|Phaser.Tweens.TweenChain} config - A Tween Configuration object, or a Tween or TweenChain instance.
 *
 * @return {Phaser.Tweens.Tween} The Tween that was created.
 */ GameObjectCreator.register('tween', function(config) {
                    return this.scene.sys.tweens.create(config);
                });
                module1.exports = Tween;
            /***/ },
            /***/ 43960: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(72905);
                var BaseTween = __webpack_require__(70402);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(842);
                var GameObjectCreator = __webpack_require__(44603);
                var GameObjectFactory = __webpack_require__(39429);
                var TWEEN_CONST = __webpack_require__(86353);
                /**
 * @classdesc
 * A TweenChain is a special type of Tween that allows you to create a sequence of Tweens, chained to one-another,
 * and add them to the Tween Manager.
 *
 * The tweens are played in order, from start to finish. You can optionally set the chain
 * to repeat as many times as you like. Once the chain has finished playing, or repeating if set,
 * all tweens in the chain will be destroyed automatically. To override this, set the 'persist'
 * argument to 'true'.
 *
 * Playback will start immediately unless the _first_ Tween has been configured to be paused.
 *
 * Please note that Tweens will not manipulate any target property that begins with an underscore.
 *
 * @class TweenChain
 * @memberof Phaser.Tweens
 * @extends Phaser.Tweens.BaseTween
 * @constructor
 * @since 3.60.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.TweenChain)} parent - A reference to the Tween Manager, or TweenChain, that owns this TweenChain.
 */ var TweenChain = new Class({
                    Extends: BaseTween,
                    initialize: function TweenChain(parent) {
                        BaseTween.call(this, parent);
                        /**
         * A reference to the Tween that this TweenChain is currently playing.
         *
         * @name Phaser.Tweens.TweenChain#currentTween
         * @type {Phaser.Tweens.Tween}
         * @since 3.60.0
         */ this.currentTween = null;
                        /**
         * A reference to the data array index of the currently playing tween.
         *
         * @name Phaser.Tweens.TweenChain#currentIndex
         * @type {number}
         * @since 3.60.0
         */ this.currentIndex = 0;
                    },
                    /**
     * Prepares this TweenChain for playback.
     *
     * Called automatically by the TweenManager. Should not be called directly.
     *
     * @method Phaser.Tweens.TweenChain#init
     * @fires Phaser.Tweens.Events#TWEEN_ACTIVE
     * @since 3.60.0
     *
     * @return {this} This TweenChain instance.
     */ init: function() {
                        this.loopCounter = this.loop === -1 ? TWEEN_CONST.MAX : this.loop;
                        this.setCurrentTween(0);
                        if (this.startDelay > 0 && !this.isStartDelayed()) this.setStartDelayState();
                        else this.setActiveState();
                        return this;
                    },
                    /**
     * Create a sequence of Tweens, chained to one-another, and add them to this Tween Manager.
     *
     * The tweens are played in order, from start to finish. You can optionally set the chain
     * to repeat as many times as you like. Once the chain has finished playing, or repeating if set,
     * all tweens in the chain will be destroyed automatically. To override this, set the 'persist'
     * argument to 'true'.
     *
     * Playback will start immediately unless the _first_ Tween has been configured to be paused.
     *
     * Please note that Tweens will not manipulate any target property that begins with an underscore.
     *
     * @method Phaser.Tweens.TweenChain#add
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig[]|object[]} tweens - An array of Tween configuration objects for the Tweens in this chain.
     *
     * @return {this} This TweenChain instance.
     */ add: function(tweens) {
                        var newTweens = this.parent.create(tweens);
                        if (!Array.isArray(newTweens)) newTweens = [
                            newTweens
                        ];
                        var data = this.data;
                        for(var i = 0; i < newTweens.length; i++){
                            var tween = newTweens[i];
                            tween.parent = this;
                            data.push(tween.reset());
                        }
                        this.totalData = data.length;
                        return this;
                    },
                    /**
     * Removes the given Tween from this Tween Chain.
     *
     * The removed tween is _not_ destroyed. It is just removed from this Tween Chain.
     *
     * If the given Tween is currently playing then the chain will automatically move
     * to the next tween in the chain. If there are no more tweens, this chain will complete.
     *
     * @method Phaser.Tweens.TweenChain#remove
     * @since 3.60.0
     * @override
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be removed.
     *
     * @return {this} This Tween Chain instance.
     */ remove: function(tween) {
                        //  Remove it immediately
                        ArrayRemove(this.data, tween);
                        tween.setRemovedState();
                        if (tween === this.currentTween) this.nextTween();
                        this.totalData = this.data.length;
                        return this;
                    },
                    /**
     * See if any of the tweens in this Tween Chain is currently acting upon the given target.
     *
     * @method Phaser.Tweens.TweenChain#hasTarget
     * @since 3.60.0
     *
     * @param {object} target - The target to check against this TweenChain.
     *
     * @return {boolean} `true` if the given target is a target of this TweenChain, otherwise `false`.
     */ hasTarget: function(target) {
                        var data = this.data;
                        for(var i = 0; i < this.totalData; i++){
                            if (data[i].hasTarget(target)) return true;
                        }
                        return false;
                    },
                    /**
     * Restarts the TweenChain from the beginning.
     *
     * If this TweenChain was configured to have a loop, or start delay, those
     * are reset to their initial values as well. It will also dispatch the
     * `onActive` callback and event again.
     *
     * @method Phaser.Tweens.TweenChain#restart
     * @since 3.60.0
     *
     * @return {this} This TweenChain instance.
     */ restart: function() {
                        if (this.isDestroyed()) {
                            console.warn('Cannot restart destroyed TweenChain', this);
                            return this;
                        }
                        if (this.isRemoved()) this.parent.makeActive(this);
                        this.resetTweens();
                        this.paused = false;
                        return this.init();
                    },
                    /**
     * Resets the given Tween.
     *
     * It will seek to position 0 and playback will start on the next frame.
     *
     * @method Phaser.Tweens.TweenChain#reset
     * @since 3.60.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be reset.
     *
     * @return {this} This TweenChain instance.
     */ reset: function(tween) {
                        tween.seek();
                        tween.setActiveState();
                        return this;
                    },
                    /**
     * Re-initialises the given Tween and sets it to the Active state.
     *
     * @method Phaser.Tweens.TweenChain#makeActive
     * @since 3.60.0
     * @override
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to check.
     *
     * @return {this} This TweenChain instance.
     */ makeActive: function(tween) {
                        tween.reset();
                        tween.setActiveState();
                        return this;
                    },
                    /**
     * Internal method that advances to the next state of the TweenChain playback.
     *
     * @method Phaser.Tweens.TweenChain#nextState
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @since 3.60.0
     *
     * @return {boolean} `true` if this TweenChain has completed, otherwise `false`.
     */ nextState: function() {
                        if (this.loopCounter > 0) {
                            this.loopCounter--;
                            this.resetTweens();
                            if (this.loopDelay > 0) {
                                this.countdown = this.loopDelay;
                                this.setLoopDelayState();
                            } else {
                                this.setActiveState();
                                this.dispatchEvent(Events.TWEEN_LOOP, 'onLoop');
                            }
                        } else if (this.completeDelay > 0) {
                            this.countdown = this.completeDelay;
                            this.setCompleteDelayState();
                        } else {
                            this.onCompleteHandler();
                            return true;
                        }
                        return false;
                    },
                    /**
     * Starts this TweenChain playing.
     *
     * You only need to call this method if you have configured this TweenChain to be paused on creation.
     *
     * If the TweenChain is already playing, calling this method again will have no effect. If you wish to
     * restart the chain, use `TweenChain.restart` instead.
     *
     * Calling this method after the TweenChain has completed will start the chain playing again from the beginning.
     *
     * @method Phaser.Tweens.TweenChain#play
     * @since 3.60.0
     *
     * @return {this} This TweenChain instance.
     */ play: function() {
                        if (this.isDestroyed()) {
                            console.warn('Cannot play destroyed TweenChain', this);
                            return this;
                        }
                        if (this.isPendingRemove() || this.isPending()) this.resetTweens();
                        this.paused = false;
                        if (this.startDelay > 0 && !this.isStartDelayed()) this.setStartDelayState();
                        else this.setActiveState();
                        return this;
                    },
                    /**
     * Internal method that resets all of the Tweens and the current index pointer.
     *
     * @method Phaser.Tweens.TweenChain#resetTweens
     * @since 3.60.0
     */ resetTweens: function() {
                        var data = this.data;
                        var total = this.totalData;
                        for(var i = 0; i < total; i++)data[i].reset(false);
                        this.setCurrentTween(0);
                    },
                    /**
     * Internal method that advances the TweenChain based on the time values.
     *
     * @method Phaser.Tweens.TweenChain#update
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @fires Phaser.Tweens.Events#TWEEN_START
     * @since 3.60.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} Returns `true` if this TweenChain has finished and should be removed from the Tween Manager, otherwise returns `false`.
     */ update: function(delta) {
                        if (this.isPendingRemove() || this.isDestroyed()) return true;
                        else if (this.isFinished() || this.paused) return false;
                        //  The TweenChain.timeScale is applied within Tween.update, so doesn't need including here
                        delta *= this.parent.timeScale;
                        if (this.isLoopDelayed()) {
                            this.updateLoopCountdown(delta);
                            return false;
                        } else if (this.isCompleteDelayed()) {
                            this.updateCompleteDelay(delta);
                            return false;
                        } else if (!this.hasStarted) {
                            this.startDelay -= delta;
                            if (this.startDelay <= 0) {
                                this.hasStarted = true;
                                this.dispatchEvent(Events.TWEEN_START, 'onStart');
                                //  Reset the delta so we always start progress from zero
                                delta = 0;
                            }
                        }
                        var remove = false;
                        if (this.isActive() && this.currentTween) {
                            if (this.currentTween.update(delta)) //  This tween has finished playback, so move to the next one
                            {
                                if (this.nextTween()) this.nextState();
                            }
                            //  If nextState called onCompleteHandler then it is ready to be removed, unless persist is set to true
                            remove = this.isPendingRemove();
                            if (remove && this.persist) {
                                this.setFinishedState();
                                remove = false;
                            }
                        }
                        return remove;
                    },
                    /**
     * Immediately advances to the next Tween in the chain.
     *
     * This is typically called internally, but can be used if you need to
     * advance playback for some reason.
     *
     * @method Phaser.Tweens.TweenChain#nextTween
     * @since 3.60.0
     *
     * @return {boolean} `true` if there are no more Tweens in the chain, otherwise `false`.
     */ nextTween: function() {
                        this.currentIndex++;
                        if (this.currentIndex === this.totalData) return true;
                        else this.setCurrentTween(this.currentIndex);
                        return false;
                    },
                    /**
     * Sets the current active Tween to the given index, based on its
     * entry in the TweenChain data array.
     *
     * @method Phaser.Tweens.TweenChain#setCurrentTween
     * @since 3.60.0
     *
     * @param {number} index - The index of the Tween to be made current.
     */ setCurrentTween: function(index) {
                        this.currentIndex = index;
                        this.currentTween = this.data[index];
                        this.currentTween.setActiveState();
                    },
                    /**
     * Internal method that will emit a TweenChain based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.TweenChain#dispatchEvent
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {Phaser.Types.Tweens.TweenCallbackTypes} [callback] - The name of the callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchEvent: function(event, callback) {
                        this.emit(event, this);
                        var handler = this.callbacks[callback];
                        if (handler) handler.func.apply(this.callbackScope, [
                            this
                        ].concat(handler.params));
                    },
                    /**
     * Immediately destroys this TweenChain, nulling of all its references.
     *
     * @method Phaser.Tweens.TweenChain#destroy
     * @since 3.60.0
     */ destroy: function() {
                        BaseTween.prototype.destroy.call(this);
                        this.currentTween = null;
                    }
                });
                /**
 * Creates a new TweenChain object and adds it to the Tween Manager.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tweenchain
 * @since 3.60.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The TweenChain configuration.
 *
 * @return {Phaser.Tweens.TweenChain} The TweenChain that was created.
 */ GameObjectFactory.register('tweenchain', function(config) {
                    return this.scene.sys.tweens.chain(config);
                });
                /**
 * Creates a new TweenChain object and returns it, without adding it to the Tween Manager.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tweenchain
 * @since 3.60.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The TweenChain configuration.
 *
 * @return {Phaser.Tweens.TweenChain} The TweenChain that was created.
 */ GameObjectCreator.register('tweenchain', function(config) {
                    return this.scene.sys.tweens.create(config);
                });
                module1.exports = TweenChain;
            /***/ },
            /***/ 48177: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseTweenData = __webpack_require__(95042);
                var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(842);
                /**
 * @classdesc
 * The TweenData is a class that contains a single target and property that is being tweened.
 *
 * Tweens create TweenData instances when they are created, with one TweenData instance per
 * target, per property. A Tween can own multiple TweenData instances, but a TweenData only
 * ever belongs to a single Tween.
 *
 * You should not typically create these yourself, but rather use the TweenBuilder,
 * or the `Tween.add` method.
 *
 * Prior to Phaser 3.60 the TweenData was just an object, but was refactored to a class,
 * to make it responsible for its own state and updating.
 *
 * @class TweenData
 * @memberof Phaser.Tweens
 * @extends Phaser.Tweens.BaseTweenData
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Tweens.Tween} tween - The tween this TweenData instance belongs to.
 * @param {number} targetIndex - The target index within the Tween targets array.
 * @param {string} key - The property of the target to tween.
 * @param {Phaser.Types.Tweens.GetEndCallback} getEnd - What the property will be at the END of the Tween.
 * @param {Phaser.Types.Tweens.GetStartCallback} getStart - What the property will be at the START of the Tween.
 * @param {?Phaser.Types.Tweens.GetActiveCallback} getActive - If not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
 * @param {function} ease - The ease function this tween uses.
 * @param {function} delay - Function that returns the time in milliseconds before tween will start.
 * @param {number} duration - The duration of the tween in milliseconds.
 * @param {boolean} yoyo - Determines whether the tween should return back to its start value after hold has expired.
 * @param {number} hold - Function that returns the time in milliseconds the tween will pause before repeating or returning to its starting value if yoyo is set to true.
 * @param {number} repeat - Function that returns the number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
 * @param {number} repeatDelay - Function that returns the time in milliseconds before the repeat will start.
 * @param {boolean} flipX - Should toggleFlipX be called when yoyo or repeat happens?
 * @param {boolean} flipY - Should toggleFlipY be called when yoyo or repeat happens?
 * @param {?function} interpolation - The interpolation function to be used for arrays of data. Defaults to 'null'.
 * @param {?number[]} interpolationData - The array of interpolation data to be set. Defaults to 'null'.
 */ var TweenData = new Class({
                    Extends: BaseTweenData,
                    initialize: function TweenData(tween, targetIndex, key, getEnd, getStart, getActive, ease, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY, interpolation, interpolationData) {
                        BaseTweenData.call(this, tween, targetIndex, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY);
                        /**
         * The property of the target to be tweened.
         *
         * @name Phaser.Tweens.TweenData#key
         * @type {string}
         * @readonly
         * @since 3.60.0
         */ this.key = key;
                        /**
         * A function that returns what to set the target property to,
         * the moment the TweenData is invoked.
         *
         * This is called when this TweenData is initialised or reset.
         *
         * @name Phaser.Tweens.TweenData#getActiveValue
         * @type {?Phaser.Types.Tweens.GetActiveCallback}
         * @since 3.60.0
         */ this.getActiveValue = getActive;
                        /**
         * A function that returns what to set the target property to
         * at the end of the tween.
         *
         * This is called when the tween starts playing, after any initial
         * start delay, or if the tween is reset, or is set to repeat.
         *
         * @name Phaser.Tweens.TweenData#getEndValue
         * @type {Phaser.Types.Tweens.GetEndCallback}
         * @since 3.60.0
         */ this.getEndValue = getEnd;
                        /**
         * A function that returns what to set the target property to
         * at the start of the tween.
         *
         * This is called when the tween starts playing, after any initial
         * start delay, or if the tween is reset, or is set to repeat.
         *
         * @name Phaser.Tweens.TweenData#getStartValue
         * @type {Phaser.Types.Tweens.GetStartCallback}
         * @since 3.60.0
         */ this.getStartValue = getStart;
                        /**
         * The ease function this Tween uses to calculate the target value.
         *
         * @name Phaser.Tweens.TweenData#ease
         * @type {function}
         * @since 3.60.0
         */ this.ease = ease;
                        /**
         * The targets starting value, as returned by `getStartValue`.
         *
         * @name Phaser.Tweens.TweenData#start
         * @type {number}
         * @since 3.60.0
         */ this.start = 0;
                        /**
         * The target value from the previous step.
         *
         * @name Phaser.Tweens.TweenData#previous
         * @type {number}
         * @since 3.60.0
         */ this.previous = 0;
                        /**
         * The targets current value, as recorded in the most recent step.
         *
         * @name Phaser.Tweens.TweenData#current
         * @type {number}
         * @since 3.60.0
         */ this.current = 0;
                        /**
         * The targets ending value, as returned by `getEndValue`.
         *
         * @name Phaser.Tweens.TweenData#end
         * @type {number}
         * @since 3.60.0
         */ this.end = 0;
                        /**
         * The interpolation function to be used for arrays of data.
         *
         * @name Phaser.Tweens.TweenData#interpolation
         * @type {?function}
         * @default null
         * @since 3.60.0
         */ this.interpolation = interpolation;
                        /**
         * The array of data to interpolate, if interpolation is being used.
         *
         * @name Phaser.Tweens.TweenData#interpolationData
         * @type {?number[]}
         * @since 3.60.0
         */ this.interpolationData = interpolationData;
                    },
                    /**
     * Internal method that resets this Tween Data entirely, including the progress and elapsed values.
     *
     * Called automatically by the parent Tween. Should not be called directly.
     *
     * @method Phaser.Tweens.TweenData#reset
     * @since 3.60.0
     *
     * @param {boolean} [isSeeking=false] - Is the Tween Data being reset as part of a Tween seek?
     */ reset: function(isSeeking) {
                        BaseTweenData.prototype.reset.call(this);
                        var target = this.tween.targets[this.targetIndex];
                        var key = this.key;
                        if (isSeeking) target[key] = this.start;
                        this.start = 0;
                        this.previous = 0;
                        this.current = 0;
                        this.end = 0;
                        if (this.getActiveValue) target[key] = this.getActiveValue(target, key, 0);
                    },
                    /**
     * Internal method that advances this TweenData based on the delta value given.
     *
     * @method Phaser.Tweens.TweenData#update
     * @fires Phaser.Tweens.Events#TWEEN_UPDATE
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @since 3.60.0
     *
     * @param {number} delta - The elapsed delta time in ms.
     *
     * @return {boolean} `true` if this TweenData is still playing, or `false` if it has finished entirely.
     */ update: function(delta) {
                        var tween = this.tween;
                        var totalTargets = tween.totalTargets;
                        var targetIndex = this.targetIndex;
                        var target = tween.targets[targetIndex];
                        var key = this.key;
                        //  Bail out if we don't have a target to act upon
                        if (!target) {
                            this.setCompleteState();
                            return false;
                        }
                        if (this.isCountdown) {
                            this.elapsed -= delta;
                            if (this.elapsed <= 0) {
                                this.elapsed = 0;
                                delta = 0;
                                if (this.isDelayed()) this.setPendingRenderState();
                                else if (this.isRepeating()) {
                                    this.setPlayingForwardState();
                                    this.dispatchEvent(Events.TWEEN_REPEAT, 'onRepeat');
                                } else if (this.isHolding()) this.setStateFromEnd(0);
                            }
                        }
                        //  All of the above have the ability to change the state, so put this in its own check
                        if (this.isPendingRender()) {
                            this.start = this.getStartValue(target, key, target[key], targetIndex, totalTargets, tween);
                            this.end = this.getEndValue(target, key, this.start, targetIndex, totalTargets, tween);
                            this.current = this.start;
                            target[key] = this.start;
                            this.setPlayingForwardState();
                            return true;
                        }
                        var forward = this.isPlayingForward();
                        var backward = this.isPlayingBackward();
                        if (forward || backward) {
                            var elapsed = this.elapsed;
                            var duration = this.duration;
                            var diff = 0;
                            var complete = false;
                            elapsed += delta;
                            if (elapsed >= duration) {
                                diff = elapsed - duration;
                                elapsed = duration;
                                complete = true;
                            } else if (elapsed < 0) elapsed = 0;
                            var progress = Clamp(elapsed / duration, 0, 1);
                            this.elapsed = elapsed;
                            this.progress = progress;
                            this.previous = this.current;
                            if (!forward) progress = 1 - progress;
                            var v = this.ease(progress);
                            if (this.interpolation) this.current = this.interpolation(this.interpolationData, v);
                            else this.current = this.start + (this.end - this.start) * v;
                            target[key] = this.current;
                            if (complete) {
                                if (forward) {
                                    if (tween.isNumberTween) {
                                        this.current = this.end;
                                        target[key] = this.current;
                                    }
                                    if (this.hold > 0) {
                                        this.elapsed = this.hold;
                                        this.setHoldState();
                                    } else this.setStateFromEnd(diff);
                                } else {
                                    if (tween.isNumberTween) {
                                        this.current = this.start;
                                        target[key] = this.current;
                                    }
                                    this.setStateFromStart(diff);
                                }
                            }
                            this.dispatchEvent(Events.TWEEN_UPDATE, 'onUpdate');
                        }
                        //  Return TRUE if this TweenData still playing, otherwise FALSE
                        return !this.isComplete();
                    },
                    /**
     * Internal method that will emit a TweenData based Event on the
     * parent Tween and also invoke the given callback, if provided.
     *
     * @method Phaser.Tweens.TweenData#dispatchEvent
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {Phaser.Types.Tweens.TweenCallbackTypes} [callback] - The name of the callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchEvent: function(event, callback) {
                        var tween = this.tween;
                        if (!tween.isSeeking) {
                            var target = tween.targets[this.targetIndex];
                            var key = this.key;
                            var current = this.current;
                            var previous = this.previous;
                            tween.emit(event, tween, key, target, current, previous);
                            var handler = tween.callbacks[callback];
                            if (handler) handler.func.apply(tween.callbackScope, [
                                tween,
                                target,
                                key,
                                current,
                                previous
                            ].concat(handler.params));
                        }
                    },
                    /**
     * Immediately destroys this TweenData, nulling of all its references.
     *
     * @method Phaser.Tweens.TweenData#destroy
     * @since 3.60.0
     */ destroy: function() {
                        BaseTweenData.prototype.destroy.call(this);
                        this.getActiveValue = null;
                        this.getEndValue = null;
                        this.getStartValue = null;
                        this.ease = null;
                    }
                });
                module1.exports = TweenData;
            /***/ },
            /***/ 42220: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseTweenData = __webpack_require__(95042);
                var Clamp = __webpack_require__(45319);
                var Class = __webpack_require__(83419);
                var Events = __webpack_require__(842);
                /**
 * @classdesc
 * The TweenFrameData is a class that contains a single target that will change the texture frame
 * at the conclusion of the Tween.
 *
 * TweenFrameData instances are typically created by the TweenBuilder automatically, when it
 * detects the presence of a 'texture' property as the key being tweened.
 *
 * A Tween can own multiple TweenFrameData instances, but a TweenFrameData only
 * ever belongs to a single Tween.
 *
 * You should not typically create these yourself, but rather use the TweenBuilder,
 * or the `Tween.addFrame` method.
 *
 * @class TweenFrameData
 * @memberof Phaser.Tweens
 * @extends Phaser.Tweens.BaseTweenData
 * @constructor
 * @since 3.60.0
 *
 * @param {Phaser.Tweens.Tween} tween - The tween this TweenData instance belongs to.
 * @param {number} targetIndex - The target index within the Tween targets array.
 * @param {string} texture - The texture key to set at the end of this tween.
 * @param {(string|number)} frame - The texture frame to set at the end of this tween.
 * @param {function} delay - Function that returns the time in milliseconds before tween will start.
 * @param {number} duration - The duration of the tween in milliseconds.
 * @param {number} hold - Function that returns the time in milliseconds the tween will pause before repeating or returning to its starting value if yoyo is set to true.
 * @param {number} repeat - Function that returns the number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
 * @param {number} repeatDelay - Function that returns the time in milliseconds before the repeat will start.
 * @param {boolean} flipX - Should toggleFlipX be called when yoyo or repeat happens?
 * @param {boolean} flipY - Should toggleFlipY be called when yoyo or repeat happens?
 */ var TweenFrameData = new Class({
                    Extends: BaseTweenData,
                    initialize: function TweenFrameData(tween, targetIndex, texture, frame, delay, duration, hold, repeat, repeatDelay, flipX, flipY) {
                        BaseTweenData.call(this, tween, targetIndex, delay, duration, false, hold, repeat, repeatDelay, flipX, flipY);
                        /**
         * The property of the target to be tweened.
         *
         * Always 'texture' for a TweenFrameData object.
         *
         * @name Phaser.Tweens.TweenFrameData#key
         * @type {string}
         * @readonly
         * @since 3.60.0
         */ this.key = 'texture';
                        /**
         * The texture to be set at the start of the tween.
         *
         * @name Phaser.Tweens.TweenFrameData#startTexture
         * @type {string}
         * @since 3.60.0
         */ this.startTexture = null;
                        /**
         * The texture to be set at the end of the tween.
         *
         * @name Phaser.Tweens.TweenFrameData#endTexture
         * @type {string}
         * @since 3.60.0
         */ this.endTexture = texture;
                        /**
         * The frame to be set at the start of the tween.
         *
         * @name Phaser.Tweens.TweenFrameData#startFrame
         * @type {(string|number)}
         * @since 3.60.0
         */ this.startFrame = null;
                        /**
         * The frame to be set at the end of the tween.
         *
         * @name Phaser.Tweens.TweenFrameData#endFrame
         * @type {(string|number)}
         * @since 3.60.0
         */ this.endFrame = frame;
                        /**
         * Will the Tween ease back to its starting values, after reaching the end
         * and any `hold` value that may be set?
         *
         * @name Phaser.Tweens.TweenFrameData#yoyo
         * @type {boolean}
         * @since 3.60.0
         */ this.yoyo = repeat !== 0 ? true : false;
                    },
                    /**
     * Internal method that resets this Tween Data entirely, including the progress and elapsed values.
     *
     * Called automatically by the parent Tween. Should not be called directly.
     *
     * @method Phaser.Tweens.TweenFrameData#reset
     * @since 3.60.0
     *
     * @param {boolean} [isSeeking=false] - Is the Tween Data being reset as part of a Tween seek?
     */ reset: function(isSeeking) {
                        BaseTweenData.prototype.reset.call(this);
                        var target = this.tween.targets[this.targetIndex];
                        if (!this.startTexture) {
                            this.startTexture = target.texture.key;
                            this.startFrame = target.frame.name;
                        }
                        if (isSeeking) target.setTexture(this.startTexture, this.startFrame);
                    },
                    /**
     * Internal method that advances this TweenData based on the delta value given.
     *
     * @method Phaser.Tweens.TweenFrameData#update
     * @fires Phaser.Tweens.Events#TWEEN_UPDATE
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @since 3.60.0
     *
     * @param {number} delta - The elapsed delta time in ms.
     *
     * @return {boolean} `true` if this TweenData is still playing, or `false` if it has finished entirely.
     */ update: function(delta) {
                        var tween = this.tween;
                        var targetIndex = this.targetIndex;
                        var target = tween.targets[targetIndex];
                        //  Bail out if we don't have a target to act upon
                        if (!target) {
                            this.setCompleteState();
                            return false;
                        }
                        if (this.isCountdown) {
                            this.elapsed -= delta;
                            if (this.elapsed <= 0) {
                                this.elapsed = 0;
                                delta = 0;
                                if (this.isDelayed()) this.setPendingRenderState();
                                else if (this.isRepeating()) {
                                    this.setPlayingForwardState();
                                    this.dispatchEvent(Events.TWEEN_REPEAT, 'onRepeat');
                                } else if (this.isHolding()) this.setStateFromEnd(0);
                            }
                        }
                        //  All of the above have the ability to change the state, so put this in its own check
                        if (this.isPendingRender()) {
                            if (this.startTexture) target.setTexture(this.startTexture, this.startFrame);
                            this.setPlayingForwardState();
                            return true;
                        }
                        var forward = this.isPlayingForward();
                        var backward = this.isPlayingBackward();
                        if (forward || backward) {
                            var elapsed = this.elapsed;
                            var duration = this.duration;
                            var diff = 0;
                            var complete = false;
                            elapsed += delta;
                            if (elapsed >= duration) {
                                diff = elapsed - duration;
                                elapsed = duration;
                                complete = true;
                            } else if (elapsed < 0) elapsed = 0;
                            var progress = Clamp(elapsed / duration, 0, 1);
                            this.elapsed = elapsed;
                            this.progress = progress;
                            if (complete) {
                                if (forward) {
                                    target.setTexture(this.endTexture, this.endFrame);
                                    if (this.hold > 0) {
                                        this.elapsed = this.hold;
                                        this.setHoldState();
                                    } else this.setStateFromEnd(diff);
                                } else {
                                    target.setTexture(this.startTexture, this.startFrame);
                                    this.setStateFromStart(diff);
                                }
                            }
                            this.dispatchEvent(Events.TWEEN_UPDATE, 'onUpdate');
                        }
                        //  Return TRUE if this TweenData still playing, otherwise FALSE
                        return !this.isComplete();
                    },
                    /**
     * Internal method that will emit a TweenData based Event on the
     * parent Tween and also invoke the given callback, if provided.
     *
     * @method Phaser.Tweens.TweenFrameData#dispatchEvent
     * @since 3.60.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {Phaser.Types.Tweens.TweenCallbackTypes} [callback] - The name of the callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchEvent: function(event, callback) {
                        var tween = this.tween;
                        if (!tween.isSeeking) {
                            var target = tween.targets[this.targetIndex];
                            var key = this.key;
                            tween.emit(event, tween, key, target);
                            var handler = tween.callbacks[callback];
                            if (handler) handler.func.apply(tween.callbackScope, [
                                tween,
                                target,
                                key
                            ].concat(handler.params));
                        }
                    },
                    /**
     * Immediately destroys this TweenData, nulling of all its references.
     *
     * @method Phaser.Tweens.TweenFrameData#destroy
     * @since 3.60.0
     */ destroy: function() {
                        BaseTweenData.prototype.destroy.call(this);
                        this.startTexture = null;
                        this.endTexture = null;
                        this.startFrame = null;
                        this.endFrame = null;
                    }
                });
                module1.exports = TweenFrameData;
            /***/ },
            /***/ 86353: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Tween States.
 *
 * @namespace Phaser.Tweens.States
 * @memberof Phaser.Tweens
 * @since 3.60.0
 */ /**
 * Phaser Tween state constants.
 *
 * @typedef {Phaser.Tweens.States} Phaser.Tweens.StateType
 * @memberof Phaser.Tweens
 * @since 3.60.0
 */ var TWEEN_CONST = {
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.CREATED
     * @type {number}
     * @const
     * @since 3.0.0
     */ CREATED: 0,
                    //  1 used to be INIT prior to 3.60
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.DELAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ DELAY: 2,
                    //  3 used to be OFFSET_DELAY prior to 3.60
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.PENDING_RENDER
     * @type {number}
     * @const
     * @since 3.0.0
     */ PENDING_RENDER: 4,
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.PLAYING_FORWARD
     * @type {number}
     * @const
     * @since 3.0.0
     */ PLAYING_FORWARD: 5,
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.PLAYING_BACKWARD
     * @type {number}
     * @const
     * @since 3.0.0
     */ PLAYING_BACKWARD: 6,
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.HOLD_DELAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ HOLD_DELAY: 7,
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.REPEAT_DELAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ REPEAT_DELAY: 8,
                    /**
     * TweenData state.
     *
     * @name Phaser.Tweens.States.COMPLETE
     * @type {number}
     * @const
     * @since 3.0.0
     */ COMPLETE: 9,
                    //  Tween specific (starts from 20 to cleanly allow extra TweenData consts in the future)
                    /**
     * Tween state. The Tween has been created but has not yet been added to the Tween Manager.
     *
     * @name Phaser.Tweens.States.PENDING
     * @type {number}
     * @const
     * @since 3.0.0
     */ PENDING: 20,
                    /**
     * Tween state. The Tween is active within the Tween Manager. This means it is either playing,
     * or was playing and is currently paused, but in both cases it's still being processed by
     * the Tween Manager, so is considered 'active'.
     *
     * @name Phaser.Tweens.States.ACTIVE
     * @type {number}
     * @const
     * @since 3.0.0
     */ ACTIVE: 21,
                    /**
     * Tween state. The Tween is waiting for a loop countdown to elapse.
     *
     * @name Phaser.Tweens.States.LOOP_DELAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ LOOP_DELAY: 22,
                    /**
     * Tween state. The Tween is waiting for a complete delay to elapse.
     *
     * @name Phaser.Tweens.States.COMPLETE_DELAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ COMPLETE_DELAY: 23,
                    /**
     * Tween state. The Tween is waiting for a starting delay to elapse.
     *
     * @name Phaser.Tweens.States.START_DELAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ START_DELAY: 24,
                    /**
     * Tween state. The Tween has finished playback and is waiting to be removed from the Tween Manager.
     *
     * @name Phaser.Tweens.States.PENDING_REMOVE
     * @type {number}
     * @const
     * @since 3.0.0
     */ PENDING_REMOVE: 25,
                    /**
     * Tween state. The Tween has been removed from the Tween Manager.
     *
     * @name Phaser.Tweens.States.REMOVED
     * @type {number}
     * @const
     * @since 3.0.0
     */ REMOVED: 26,
                    /**
     * Tween state. The Tween has finished playback but was flagged as 'persistent' during creation,
     * so will not be automatically removed by the Tween Manager.
     *
     * @name Phaser.Tweens.States.FINISHED
     * @type {number}
     * @const
     * @since 3.60.0
     */ FINISHED: 27,
                    /**
     * Tween state. The Tween has been destroyed and can no longer be played by a Tween Manager.
     *
     * @name Phaser.Tweens.States.DESTROYED
     * @type {number}
     * @const
     * @since 3.60.0
     */ DESTROYED: 28,
                    /**
     * A large integer value used for 'infinite' style countdowns.
     *
     * Similar use-case to Number.MAX_SAFE_INTEGER but we cannot use that because it's not
     * supported on IE.
     *
     * @name Phaser.Tweens.States.MAX
     * @type {number}
     * @const
     * @since 3.60.0
     */ MAX: 999999999999
                };
                module1.exports = TWEEN_CONST;
            /***/ },
            /***/ 83419: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Taken from klasse by mattdesl https://github.com/mattdesl/klasse
                function hasGetterOrSetter(def) {
                    return !!def.get && typeof def.get === 'function' || !!def.set && typeof def.set === 'function';
                }
                function getProperty(definition, k, isClassDescriptor) {
                    //  This may be a lightweight object, OR it might be a property that was defined previously.
                    //  For simple class descriptors we can just assume its NOT previously defined.
                    var def = isClassDescriptor ? definition[k] : Object.getOwnPropertyDescriptor(definition, k);
                    if (!isClassDescriptor && def.value && typeof def.value === 'object') def = def.value;
                    //  This might be a regular property, or it may be a getter/setter the user defined in a class.
                    if (def && hasGetterOrSetter(def)) {
                        if (typeof def.enumerable === 'undefined') def.enumerable = true;
                        if (typeof def.configurable === 'undefined') def.configurable = true;
                        return def;
                    } else return false;
                }
                function hasNonConfigurable(obj, k) {
                    var prop = Object.getOwnPropertyDescriptor(obj, k);
                    if (!prop) return false;
                    if (prop.value && typeof prop.value === 'object') prop = prop.value;
                    if (prop.configurable === false) return true;
                    return false;
                }
                /**
 * Extends the given `myClass` object's prototype with the properties of `definition`.
 *
 * @function extend
 * @ignore
 * @param {Object} ctor The constructor object to mix into.
 * @param {Object} definition A dictionary of functions for the class.
 * @param {boolean} isClassDescriptor Is the definition a class descriptor?
 * @param {Object} [extend] The parent constructor object.
 */ function extend(ctor, definition, isClassDescriptor, extend) {
                    for(var k in definition){
                        if (!definition.hasOwnProperty(k)) continue;
                        var def = getProperty(definition, k, isClassDescriptor);
                        if (def !== false) {
                            //  If Extends is used, we will check its prototype to see if the final variable exists.
                            var parent = extend || ctor;
                            if (hasNonConfigurable(parent.prototype, k)) {
                                //  Just skip the final property
                                if (Class.ignoreFinals) continue;
                                //  We cannot re-define a property that is configurable=false.
                                //  So we will consider them final and throw an error. This is by
                                //  default so it is clear to the developer what is happening.
                                //  You can set ignoreFinals to true if you need to extend a class
                                //  which has configurable=false; it will simply not re-define final properties.
                                throw new Error('cannot override final property \'' + k + '\', set Class.ignoreFinals = true to skip');
                            }
                            Object.defineProperty(ctor.prototype, k, def);
                        } else ctor.prototype[k] = definition[k];
                    }
                }
                /**
 * Applies the given `mixins` to the prototype of `myClass`.
 *
 * @function mixin
 * @ignore
 * @param {Object} myClass The constructor object to mix into.
 * @param {Object|Array<Object>} mixins The mixins to apply to the constructor.
 */ function mixin(myClass, mixins) {
                    if (!mixins) return;
                    if (!Array.isArray(mixins)) mixins = [
                        mixins
                    ];
                    for(var i = 0; i < mixins.length; i++)extend(myClass, mixins[i].prototype || mixins[i]);
                }
                /**
 * Creates a new class with the given descriptor.
 * The constructor, defined by the name `initialize`,
 * is an optional function. If unspecified, an anonymous
 * function will be used which calls the parent class (if
 * one exists).
 *
 * You can also use `Extends` and `Mixins` to provide subclassing
 * and inheritance.
 *
 * @class Phaser.Class
 * @constructor
 * @param {Object} definition a dictionary of functions for the class
 * @example
 *
 *      var MyClass = new Phaser.Class({
 *
 *          initialize: function() {
 *              this.foo = 2.0;
 *          },
 *
 *          bar: function() {
 *              return this.foo + 5;
 *          }
 *      });
 */ function Class(definition) {
                    if (!definition) definition = {};
                    //  The variable name here dictates what we see in Chrome debugger
                    var initialize;
                    var Extends;
                    if (definition.initialize) {
                        if (typeof definition.initialize !== 'function') throw new Error('initialize must be a function');
                        initialize = definition.initialize;
                        //  Usually we should avoid 'delete' in V8 at all costs.
                        //  However, its unlikely to make any performance difference
                        //  here since we only call this on class creation (i.e. not object creation).
                        delete definition.initialize;
                    } else if (definition.Extends) {
                        var base = definition.Extends;
                        initialize = function() {
                            base.apply(this, arguments);
                        };
                    } else initialize = function() {};
                    if (definition.Extends) {
                        initialize.prototype = Object.create(definition.Extends.prototype);
                        initialize.prototype.constructor = initialize;
                        //  For getOwnPropertyDescriptor to work, we need to act directly on the Extends (or Mixin)
                        Extends = definition.Extends;
                        delete definition.Extends;
                    } else initialize.prototype.constructor = initialize;
                    //  Grab the mixins, if they are specified...
                    var mixins = null;
                    if (definition.Mixins) {
                        mixins = definition.Mixins;
                        delete definition.Mixins;
                    }
                    //  First, mixin if we can.
                    mixin(initialize, mixins);
                    //  Now we grab the actual definition which defines the overrides.
                    extend(initialize, definition, true, Extends);
                    return initialize;
                }
                Class.extend = extend;
                Class.mixin = mixin;
                Class.ignoreFinals = false;
                module1.exports = Class;
            /***/ },
            /***/ 29747: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A NOOP (No Operation) callback function.
 *
 * Used internally by Phaser when it's more expensive to determine if a callback exists
 * than it is to just invoke an empty function.
 *
 * @function Phaser.Utils.NOOP
 * @since 3.0.0
 */ var NOOP = function() {
                //  NOOP
                };
                module1.exports = NOOP;
            /***/ },
            /***/ 20242: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A NULL OP callback function.
 *
 * This function always returns `null`.
 *
 * Used internally by Phaser when it's more expensive to determine if a callback exists
 * than it is to just invoke an empty function.
 *
 * @function Phaser.Utils.NULL
 * @since 3.60.0
 */ var NULL = function() {
                    return null;
                };
                module1.exports = NULL;
            /***/ },
            /***/ 71146: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given item, or array of items, to the array.
 *
 * Each item must be unique within the array.
 *
 * The array is modified in-place and returned.
 *
 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
 * added will take the array length over this limit, it will stop adding once the limit is reached.
 *
 * You can optionally specify a callback to be invoked for each item successfully added to the array.
 *
 * @function Phaser.Utils.Array.Add
 * @since 3.4.0
 *
 * @param {array} array - The array to be added to.
 * @param {any|any[]} item - The item, or array of items, to add to the array. Each item must be unique within the array.
 * @param {number} [limit] - Optional limit which caps the size of the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {array} The input array.
 */ var Add = function(array, item, limit, callback, context) {
                    if (context === undefined) context = array;
                    if (limit > 0) {
                        var remaining = limit - array.length;
                        //  There's nothing more we can do here, the array is full
                        if (remaining <= 0) return null;
                    }
                    //  Fast path to avoid array mutation and iteration
                    if (!Array.isArray(item)) {
                        if (array.indexOf(item) === -1) {
                            array.push(item);
                            if (callback) callback.call(context, item);
                            return item;
                        } else return null;
                    }
                    //  If we got this far, we have an array of items to insert
                    //  Ensure all the items are unique
                    var itemLength = item.length - 1;
                    while(itemLength >= 0){
                        if (array.indexOf(item[itemLength]) !== -1) //  Already exists in array, so remove it
                        item.splice(itemLength, 1);
                        itemLength--;
                    }
                    //  Anything left?
                    itemLength = item.length;
                    if (itemLength === 0) return null;
                    if (limit > 0 && itemLength > remaining) {
                        item.splice(remaining);
                        itemLength = remaining;
                    }
                    for(var i = 0; i < itemLength; i++){
                        var entry = item[i];
                        array.push(entry);
                        if (callback) callback.call(context, entry);
                    }
                    return item;
                };
                module1.exports = Add;
            /***/ },
            /***/ 51067: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given item, or array of items, to the array starting at the index specified.
 *
 * Each item must be unique within the array.
 *
 * Existing elements in the array are shifted up.
 *
 * The array is modified in-place and returned.
 *
 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
 * added will take the array length over this limit, it will stop adding once the limit is reached.
 *
 * You can optionally specify a callback to be invoked for each item successfully added to the array.
 *
 * @function Phaser.Utils.Array.AddAt
 * @since 3.4.0
 *
 * @param {array} array - The array to be added to.
 * @param {any|any[]} item - The item, or array of items, to add to the array.
 * @param {number} [index=0] - The index in the array where the item will be inserted.
 * @param {number} [limit] - Optional limit which caps the size of the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {array} The input array.
 */ var AddAt = function(array, item, index, limit, callback, context) {
                    if (index === undefined) index = 0;
                    if (context === undefined) context = array;
                    if (limit > 0) {
                        var remaining = limit - array.length;
                        //  There's nothing more we can do here, the array is full
                        if (remaining <= 0) return null;
                    }
                    //  Fast path to avoid array mutation and iteration
                    if (!Array.isArray(item)) {
                        if (array.indexOf(item) === -1) {
                            array.splice(index, 0, item);
                            if (callback) callback.call(context, item);
                            return item;
                        } else return null;
                    }
                    //  If we got this far, we have an array of items to insert
                    //  Ensure all the items are unique
                    var itemLength = item.length - 1;
                    while(itemLength >= 0){
                        if (array.indexOf(item[itemLength]) !== -1) //  Already exists in array, so remove it
                        item.pop();
                        itemLength--;
                    }
                    //  Anything left?
                    itemLength = item.length;
                    if (itemLength === 0) return null;
                    //  Truncate to the limit
                    if (limit > 0 && itemLength > remaining) {
                        item.splice(remaining);
                        itemLength = remaining;
                    }
                    for(var i = itemLength - 1; i >= 0; i--){
                        var entry = item[i];
                        array.splice(index, 0, entry);
                        if (callback) callback.call(context, entry);
                    }
                    return item;
                };
                module1.exports = AddAt;
            /***/ },
            /***/ 66905: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given element to the top of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.BringToTop
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 *
 * @return {*} The element that was moved.
 */ var BringToTop = function(array, item) {
                    var currentIndex = array.indexOf(item);
                    if (currentIndex !== -1 && currentIndex < array.length) {
                        array.splice(currentIndex, 1);
                        array.push(item);
                    }
                    return item;
                };
                module1.exports = BringToTop;
            /***/ },
            /***/ 21612: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(82011);
                /**
 * Returns the total number of elements in the array which have a property matching the given value.
 *
 * @function Phaser.Utils.Array.CountAllMatching
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} property - The property to test on each array element.
 * @param {*} value - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {number} The total number of elements with properties matching the given value.
 */ var CountAllMatching = function(array, property, value, startIndex, endIndex) {
                    if (startIndex === undefined) startIndex = 0;
                    if (endIndex === undefined) endIndex = array.length;
                    var total = 0;
                    if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                        var child = array[i];
                        if (child[property] === value) total++;
                    }
                    return total;
                };
                module1.exports = CountAllMatching;
            /***/ },
            /***/ 95428: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Passes each element in the array to the given callback.
 *
 * @function Phaser.Utils.Array.Each
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {function} callback - A callback to be invoked for each item in the array.
 * @param {object} context - The context in which the callback is invoked.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the current array item.
 *
 * @return {array} The input array.
 */ var Each = function(array, callback, context) {
                    var i;
                    var args = [
                        null
                    ];
                    for(i = 3; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = 0; i < array.length; i++){
                        args[0] = array[i];
                        callback.apply(context, args);
                    }
                    return array;
                };
                module1.exports = Each;
            /***/ },
            /***/ 36914: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(82011);
                /**
 * Passes each element in the array, between the start and end indexes, to the given callback.
 *
 * @function Phaser.Utils.Array.EachInRange
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {function} callback - A callback to be invoked for each item in the array.
 * @param {object} context - The context in which the callback is invoked.
 * @param {number} startIndex - The start index to search from.
 * @param {number} endIndex - The end index to search to.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 *
 * @return {array} The input array.
 */ var EachInRange = function(array, callback, context, startIndex, endIndex) {
                    if (startIndex === undefined) startIndex = 0;
                    if (endIndex === undefined) endIndex = array.length;
                    if (SafeRange(array, startIndex, endIndex)) {
                        var i;
                        var args = [
                            null
                        ];
                        for(i = 5; i < arguments.length; i++)args.push(arguments[i]);
                        for(i = startIndex; i < endIndex; i++){
                            args[0] = array[i];
                            callback.apply(context, args);
                        }
                    }
                    return array;
                };
                module1.exports = EachInRange;
            /***/ },
            /***/ 81957: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Searches a pre-sorted array for the closet value to the given number.
 *
 * If the `key` argument is given it will assume the array contains objects that all have the required `key` property name,
 * and will check for the closest value of those to the given number.
 *
 * @function Phaser.Utils.Array.FindClosestInSorted
 * @since 3.0.0
 *
 * @param {number} value - The value to search for in the array.
 * @param {array} array - The array to search, which must be sorted.
 * @param {string} [key] - An optional property key. If specified the array elements property will be checked against value.
 *
 * @return {(number|any)} The nearest value found in the array, or if a `key` was given, the nearest object with the matching property value.
 */ var FindClosestInSorted = function(value, array, key) {
                    if (!array.length) return NaN;
                    else if (array.length === 1) return array[0];
                    var i = 1;
                    var low;
                    var high;
                    if (key) {
                        if (value < array[0][key]) return array[0];
                        while(array[i][key] < value)i++;
                    } else while(array[i] < value)i++;
                    if (i > array.length) i = array.length;
                    if (key) {
                        low = array[i - 1][key];
                        high = array[i][key];
                        return high - value <= value - low ? array[i] : array[i - 1];
                    } else {
                        low = array[i - 1];
                        high = array[i];
                        return high - value <= value - low ? high : low;
                    }
                };
                module1.exports = FindClosestInSorted;
            /***/ },
            /***/ 43491: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array and flattens it, returning a shallow-copy flattened array.
 *
 * @function Phaser.Utils.Array.Flatten
 * @since 3.60.0
 *
 * @param {array} array - The array to flatten.
 * @param {array} [output] - An array to hold the results in.
 *
 * @return {array} The flattened output array.
 */ var Flatten = function(array, output) {
                    if (output === undefined) output = [];
                    for(var i = 0; i < array.length; i++)if (Array.isArray(array[i])) Flatten(array[i], output);
                    else output.push(array[i]);
                    return output;
                };
                module1.exports = Flatten;
            /***/ },
            /***/ 46710: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(82011);
                /**
 * Returns all elements in the array.
 *
 * You can optionally specify a matching criteria using the `property` and `value` arguments.
 *
 * For example: `getAll('visible', true)` would return only elements that have their visible property set.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
 * the first 50 elements.
 *
 * @function Phaser.Utils.Array.GetAll
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} [property] - The property to test on each array element.
 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {array} All matching elements from the array.
 */ var GetAll = function(array, property, value, startIndex, endIndex) {
                    if (startIndex === undefined) startIndex = 0;
                    if (endIndex === undefined) endIndex = array.length;
                    var output = [];
                    if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                        var child = array[i];
                        if (!property || property && value === undefined && child.hasOwnProperty(property) || property && value !== undefined && child[property] === value) output.push(child);
                    }
                    return output;
                };
                module1.exports = GetAll;
            /***/ },
            /***/ 58731: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(82011);
                /**
 * Returns the first element in the array.
 *
 * You can optionally specify a matching criteria using the `property` and `value` arguments.
 *
 * For example: `getAll('visible', true)` would return the first element that had its `visible` property set.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would search only the first 50 elements.
 * 
 * You can also specify a negative `startIndex`, such as `-1`, which would start the search at the end of the array
 *
 * @function Phaser.Utils.Array.GetFirst
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} [property] - The property to test on each array element.
 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex=0] - An optional start index to search from. You can also set `startIndex` to -1 to start the search from the end of the array.
 * @param {number} [endIndex=array.length] - An optional end index to search up to (but not included)
 *
 * @return {?object} The first matching element from the array, or `null` if no element could be found in the range given.
 */ var GetFirst = function(array, property, value, startIndex, endIndex) {
                    if (startIndex === undefined) startIndex = 0;
                    if (endIndex === undefined) endIndex = array.length;
                    if (startIndex !== -1) {
                        if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                            var child = array[i];
                            if (!property || property && value === undefined && child.hasOwnProperty(property) || property && value !== undefined && child[property] === value) return child;
                        }
                    } else {
                        if (SafeRange(array, 0, endIndex)) for(var i = endIndex; i >= 0; i--){
                            var child = array[i];
                            if (!property || property && value === undefined && child.hasOwnProperty(property) || property && value !== undefined && child[property] === value) return child;
                        }
                    }
                    return null;
                };
                module1.exports = GetFirst;
            /***/ },
            /***/ 26546: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a Random element from the array.
 *
 * @function Phaser.Utils.Array.GetRandom
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[]} - [array]
 * @genericUse {T} - [$return]
 *
 * @param {T[]} array - The array to select the random entry from.
 * @param {number} [startIndex=0] - An optional start index.
 * @param {number} [length=array.length] - An optional length, the total number of elements (from the startIndex) to choose from.
 *
 * @return {T} A random element from the array, or `null` if no element could be found in the range given.
 */ var GetRandom = function(array, startIndex, length) {
                    if (startIndex === undefined) startIndex = 0;
                    if (length === undefined) length = array.length;
                    var randomIndex = startIndex + Math.floor(Math.random() * length);
                    return array[randomIndex] === undefined ? null : array[randomIndex];
                };
                module1.exports = GetRandom;
            /***/ },
            /***/ 85835: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element above another one in the array.
 * If the given element is already above the other, it isn't moved.
 * Above means toward the end of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveAbove
 * @since 3.55.0
 *
 * @param {array} array - The input array.
 * @param {*} item1 - The element to move above base element.
 * @param {*} item2 - The base element.
 *
 *
 * @return {array} The input array.
 */ var MoveAbove = function(array, item1, item2) {
                    if (item1 === item2) return array;
                    var currentIndex = array.indexOf(item1);
                    var baseIndex = array.indexOf(item2);
                    if (currentIndex < 0 || baseIndex < 0) throw new Error('Supplied items must be elements of the same array');
                    if (currentIndex > baseIndex) // item1 is already above item2
                    return array;
                    // Remove item1 from its current position
                    array.splice(currentIndex, 1);
                    // Recalculate baseIndex after removal
                    baseIndex = array.indexOf(item2);
                    // Insert item1 immediately after item2
                    array.splice(baseIndex + 1, 0, item1);
                    return array;
                };
                module1.exports = MoveAbove;
            /***/ },
            /***/ 83371: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element below another one in the array.
 * If the given element is already below the other, it isn't moved.
 * Below means toward the start of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveBelow
 * @since 3.55.0
 *
 * @param {array} array - The input array.
 * @param {*} item1 - The element to move below base element.
 * @param {*} item2 - The base element.
 *
 *
 * @return {array} The input array.
 */ var MoveBelow = function(array, item1, item2) {
                    if (item1 === item2) return array;
                    var currentIndex = array.indexOf(item1);
                    var baseIndex = array.indexOf(item2);
                    if (currentIndex < 0 || baseIndex < 0) throw new Error('Supplied items must be elements of the same array');
                    if (currentIndex < baseIndex) // item1 is already below item2
                    return array;
                    //  Remove
                    array.splice(currentIndex, 1);
                    //  Add in new location
                    if (baseIndex === 0) array.unshift(item1);
                    else array.splice(baseIndex, 0, item1);
                    return array;
                };
                module1.exports = MoveBelow;
            /***/ },
            /***/ 70864: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element down one place in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveDown
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item - The element to move down the array.
 *
 * @return {array} The input array.
 */ var MoveDown = function(array, item) {
                    var currentIndex = array.indexOf(item);
                    if (currentIndex > 0) {
                        var item2 = array[currentIndex - 1];
                        var index2 = array.indexOf(item2);
                        array[currentIndex] = item2;
                        array[index2] = item;
                    }
                    return array;
                };
                module1.exports = MoveDown;
            /***/ },
            /***/ 69693: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves an element in an array to a new position within the same array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveTo
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 * @param {number} index - The new index that the element will be moved to.
 *
 * @return {*} The element that was moved.
 */ var MoveTo = function(array, item, index) {
                    var currentIndex = array.indexOf(item);
                    if (currentIndex === -1 || index < 0 || index >= array.length) throw new Error('Supplied index out of bounds');
                    if (currentIndex !== index) {
                        //  Remove
                        array.splice(currentIndex, 1);
                        //  Add in new location
                        array.splice(index, 0, item);
                    }
                    return item;
                };
                module1.exports = MoveTo;
            /***/ },
            /***/ 40853: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element up one place in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveUp
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item - The element to move up the array.
 *
 * @return {array} The input array.
 */ var MoveUp = function(array, item) {
                    var currentIndex = array.indexOf(item);
                    if (currentIndex !== -1 && currentIndex < array.length - 1) {
                        //  The element one above `item` in the array
                        var item2 = array[currentIndex + 1];
                        var index2 = array.indexOf(item2);
                        array[currentIndex] = item2;
                        array[index2] = item;
                    }
                    return array;
                };
                module1.exports = MoveUp;
            /***/ },
            /***/ 20283: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Create an array representing the range of numbers (usually integers), between, and inclusive of,
 * the given `start` and `end` arguments. For example:
 *
 * `var array = Phaser.Utils.Array.NumberArray(2, 4); // array = [2, 3, 4]`
 * `var array = Phaser.Utils.Array.NumberArray(0, 9); // array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]`
 * `var array = Phaser.Utils.Array.NumberArray(8, 2); // array = [8, 7, 6, 5, 4, 3, 2]`
 *
 * This is equivalent to `Phaser.Utils.Array.NumberArrayStep(start, end, 1)`.
 *
 * You can optionally provide a prefix and / or suffix string. If given the array will contain
 * strings, not integers. For example:
 *
 * `var array = Phaser.Utils.Array.NumberArray(1, 4, 'Level '); // array = ["Level 1", "Level 2", "Level 3", "Level 4"]`
 * `var array = Phaser.Utils.Array.NumberArray(5, 7, 'HD-', '.png'); // array = ["HD-5.png", "HD-6.png", "HD-7.png"]`
 *
 * @function Phaser.Utils.Array.NumberArray
 * @since 3.0.0
 *
 * @param {number} start - The minimum value the array starts with.
 * @param {number} end - The maximum value the array contains.
 * @param {string} [prefix] - Optional prefix to place before the number. If provided the array will contain strings, not integers.
 * @param {string} [suffix] - Optional suffix to place after the number. If provided the array will contain strings, not integers.
 *
 * @return {(number[]|string[])} The array of number values, or strings if a prefix or suffix was provided.
 */ var NumberArray = function(start, end, prefix, suffix) {
                    var result = [];
                    var i;
                    var asString = false;
                    if (prefix || suffix) {
                        asString = true;
                        if (!prefix) prefix = '';
                        if (!suffix) suffix = '';
                    }
                    if (end < start) {
                        for(i = start; i >= end; i--)if (asString) result.push(prefix + i.toString() + suffix);
                        else result.push(i);
                    } else {
                        for(i = start; i <= end; i++)if (asString) result.push(prefix + i.toString() + suffix);
                        else result.push(i);
                    }
                    return result;
                };
                module1.exports = NumberArray;
            /***/ },
            /***/ 593: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RoundAwayFromZero = __webpack_require__(2284);
                /**
 * Create an array of numbers (positive and/or negative) progressing from `start`
 * up to but not including `end` by advancing by `step`.
 *
 * If `start` is less than `end` a zero-length range is created unless a negative `step` is specified.
 *
 * Certain values for `start` and `end` (eg. NaN/undefined/null) are currently coerced to 0;
 * for forward compatibility make sure to pass in actual numbers.
 *
 * @example
 * NumberArrayStep(4);
 * // => [0, 1, 2, 3]
 *
 * NumberArrayStep(1, 5);
 * // => [1, 2, 3, 4]
 *
 * NumberArrayStep(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * NumberArrayStep(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * NumberArrayStep(1, 4, 0);
 * // => [1, 1, 1]
 *
 * NumberArrayStep(0);
 * // => []
 *
 * @function Phaser.Utils.Array.NumberArrayStep
 * @since 3.0.0
 *
 * @param {number} [start=0] - The start of the range.
 * @param {number} [end=null] - The end of the range.
 * @param {number} [step=1] - The value to increment or decrement by.
 *
 * @return {number[]} The array of number values.
 */ var NumberArrayStep = function(start, end, step) {
                    if (start === undefined) start = 0;
                    if (end === undefined) end = null;
                    if (step === undefined) step = 1;
                    if (end === null) {
                        end = start;
                        start = 0;
                    }
                    var result = [];
                    var total = Math.max(RoundAwayFromZero((end - start) / (step || 1)), 0);
                    for(var i = 0; i < total; i++){
                        result.push(start);
                        start += step;
                    }
                    return result;
                };
                module1.exports = NumberArrayStep;
            /***/ },
            /***/ 43886: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function swap(arr, i, j) {
                    var tmp = arr[i];
                    arr[i] = arr[j];
                    arr[j] = tmp;
                }
                /**
 * @ignore
 */ function defaultCompare(a, b) {
                    return a < b ? -1 : a > b ? 1 : 0;
                }
                /**
 * A [Floyd-Rivest](https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm) quick selection algorithm.
 *
 * Rearranges the array items so that all items in the [left, k] range are smaller than all items in [k, right];
 * The k-th element will have the (k - left + 1)th smallest value in [left, right].
 *
 * The array is modified in-place.
 *
 * Based on code by [Vladimir Agafonkin](https://www.npmjs.com/~mourner)
 *
 * @function Phaser.Utils.Array.QuickSelect
 * @since 3.0.0
 *
 * @param {array} arr - The array to sort.
 * @param {number} k - The k-th element index.
 * @param {number} [left=0] - The index of the left part of the range.
 * @param {number} [right] - The index of the right part of the range.
 * @param {function} [compare] - An optional comparison function. Is passed two elements and should return 0, 1 or -1.
 */ var QuickSelect = function(arr, k, left, right, compare) {
                    if (left === undefined) left = 0;
                    if (right === undefined) right = arr.length - 1;
                    if (compare === undefined) compare = defaultCompare;
                    while(right > left){
                        if (right - left > 600) {
                            var n = right - left + 1;
                            var m = k - left + 1;
                            var z = Math.log(n);
                            var s = 0.5 * Math.exp(2 * z / 3);
                            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                            QuickSelect(arr, k, newLeft, newRight, compare);
                        }
                        var t = arr[k];
                        var i = left;
                        var j = right;
                        swap(arr, left, k);
                        if (compare(arr[right], t) > 0) swap(arr, left, right);
                        while(i < j){
                            swap(arr, i, j);
                            i++;
                            j--;
                            while(compare(arr[i], t) < 0)i++;
                            while(compare(arr[j], t) > 0)j--;
                        }
                        if (compare(arr[left], t) === 0) swap(arr, left, j);
                        else {
                            j++;
                            swap(arr, j, right);
                        }
                        if (j <= k) left = j + 1;
                        if (k <= j) right = j - 1;
                    }
                };
                module1.exports = QuickSelect;
            /***/ },
            /***/ 88492: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(35154);
                var Shuffle = __webpack_require__(33680);
                var BuildChunk = function(a, b, qty) {
                    var out = [];
                    for(var aIndex = 0; aIndex < a.length; aIndex++){
                        for(var bIndex = 0; bIndex < b.length; bIndex++)for(var i = 0; i < qty; i++)out.push({
                            a: a[aIndex],
                            b: b[bIndex]
                        });
                    }
                    return out;
                };
                /**
 * Creates an array populated with a range of values, based on the given arguments and configuration object.
 *
 * Range ([a,b,c], [1,2,3]) =
 * a1, a2, a3, b1, b2, b3, c1, c2, c3
 *
 * Range ([a,b], [1,2,3], qty = 3) =
 * a1, a1, a1, a2, a2, a2, a3, a3, a3, b1, b1, b1, b2, b2, b2, b3, b3, b3
 *
 * Range ([a,b,c], [1,2,3], repeat x1) =
 * a1, a2, a3, b1, b2, b3, c1, c2, c3, a1, a2, a3, b1, b2, b3, c1, c2, c3
 *
 * Range ([a,b], [1,2], repeat -1 = endless, max = 14) =
 * Maybe if max is set then repeat goes to -1 automatically?
 * a1, a2, b1, b2, a1, a2, b1, b2, a1, a2, b1, b2, a1, a2 (capped at 14 elements)
 *
 * Range ([a], [1,2,3,4,5], random = true) =
 * a4, a1, a5, a2, a3
 *
 * Range ([a, b], [1,2,3], random = true) =
 * b3, a2, a1, b1, a3, b2
 *
 * Range ([a, b, c], [1,2,3], randomB = true) =
 * a3, a1, a2, b2, b3, b1, c1, c3, c2
 *
 * Range ([a], [1,2,3,4,5], yoyo = true) =
 * a1, a2, a3, a4, a5, a5, a4, a3, a2, a1
 *
 * Range ([a, b], [1,2,3], yoyo = true) =
 * a1, a2, a3, b1, b2, b3, b3, b2, b1, a3, a2, a1
 *
 * @function Phaser.Utils.Array.Range
 * @since 3.0.0
 *
 * @param {array} a - The first array of range elements.
 * @param {array} b - The second array of range elements.
 * @param {object} [options] - A range configuration object. Can contain: repeat, random, randomB, yoyo, max, qty.
 *
 * @return {array} An array of arranged elements.
 */ var Range = function(a, b, options) {
                    var max = GetValue(options, 'max', 0);
                    var qty = GetValue(options, 'qty', 1);
                    var random = GetValue(options, 'random', false);
                    var randomB = GetValue(options, 'randomB', false);
                    var repeat = GetValue(options, 'repeat', 0);
                    var yoyo = GetValue(options, 'yoyo', false);
                    var out = [];
                    if (randomB) Shuffle(b);
                    //  Endless repeat, so limit by max
                    if (repeat === -1) {
                        if (max === 0) repeat = 0;
                        else {
                            //  Work out how many repeats we need
                            var total = a.length * b.length * qty;
                            if (yoyo) total *= 2;
                            repeat = Math.ceil(max / total);
                        }
                    }
                    for(var i = 0; i <= repeat; i++){
                        var chunk = BuildChunk(a, b, qty);
                        if (random) Shuffle(chunk);
                        out = out.concat(chunk);
                        if (yoyo) {
                            chunk.reverse();
                            out = out.concat(chunk);
                        }
                    }
                    if (max) out.splice(max);
                    return out;
                };
                module1.exports = Range;
            /***/ },
            /***/ 72905: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(19133);
                /**
 * Removes the given item, or array of items, from the array.
 *
 * The array is modified in-place.
 *
 * You can optionally specify a callback to be invoked for each item successfully removed from the array.
 *
 * @function Phaser.Utils.Array.Remove
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {*|Array.<*>} item - The item, or array of items, to be removed from the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {*|Array.<*>} The item, or array of items, that were successfully removed from the array.
 */ var Remove = function(array, item, callback, context) {
                    if (context === undefined) context = array;
                    var index;
                    //  Fast path to avoid array mutation and iteration
                    if (!Array.isArray(item)) {
                        index = array.indexOf(item);
                        if (index !== -1) {
                            SpliceOne(array, index);
                            if (callback) callback.call(context, item);
                            return item;
                        } else return null;
                    }
                    //  If we got this far, we have an array of items to remove
                    var itemLength = item.length - 1;
                    var removed = [];
                    while(itemLength >= 0){
                        var entry = item[itemLength];
                        index = array.indexOf(entry);
                        if (index !== -1) {
                            SpliceOne(array, index);
                            removed.push(entry);
                            if (callback) callback.call(context, entry);
                        }
                        itemLength--;
                    }
                    return removed;
                };
                module1.exports = Remove;
            /***/ },
            /***/ 60248: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(19133);
                /**
 * Removes the item from the given position in the array.
 *
 * The array is modified in-place.
 *
 * You can optionally specify a callback to be invoked for the item if it is successfully removed from the array.
 *
 * @function Phaser.Utils.Array.RemoveAt
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {number} index - The array index to remove the item from. The index must be in bounds or it will throw an error.
 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {*} The item that was removed.
 */ var RemoveAt = function(array, index, callback, context) {
                    if (context === undefined) context = array;
                    if (index < 0 || index > array.length - 1) throw new Error('Index out of bounds');
                    var item = SpliceOne(array, index);
                    if (callback) callback.call(context, item);
                    return item;
                };
                module1.exports = RemoveAt;
            /***/ },
            /***/ 81409: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(82011);
                /**
 * Removes the item within the given range in the array.
 *
 * The array is modified in-place.
 *
 * You can optionally specify a callback to be invoked for the item/s successfully removed from the array.
 *
 * @function Phaser.Utils.Array.RemoveBetween
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {number} startIndex - The start index to remove from.
 * @param {number} endIndex - The end index to remove to.
 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {Array.<*>} An array of items that were removed.
 */ var RemoveBetween = function(array, startIndex, endIndex, callback, context) {
                    if (startIndex === undefined) startIndex = 0;
                    if (endIndex === undefined) endIndex = array.length;
                    if (context === undefined) context = array;
                    if (SafeRange(array, startIndex, endIndex)) {
                        var size = endIndex - startIndex;
                        var removed = array.splice(startIndex, size);
                        if (callback) for(var i = 0; i < removed.length; i++){
                            var entry = removed[i];
                            callback.call(context, entry);
                        }
                        return removed;
                    } else return [];
                };
                module1.exports = RemoveBetween;
            /***/ },
            /***/ 31856: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(19133);
                /**
 * Removes a random object from the given array and returns it.
 * Will return null if there are no array items that fall within the specified range or if there is no item for the randomly chosen index.
 *
 * @function Phaser.Utils.Array.RemoveRandomElement
 * @since 3.0.0
 *
 * @param {array} array - The array to removed a random element from.
 * @param {number} [start=0] - The array index to start the search from.
 * @param {number} [length=array.length] - Optional restriction on the number of elements to randomly select from.
 *
 * @return {object} The random element that was removed, or `null` if there were no array elements that fell within the given range.
 */ var RemoveRandomElement = function(array, start, length) {
                    if (start === undefined) start = 0;
                    if (length === undefined) length = array.length;
                    var randomIndex = start + Math.floor(Math.random() * length);
                    return SpliceOne(array, randomIndex);
                };
                module1.exports = RemoveRandomElement;
            /***/ },
            /***/ 42169: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Replaces an element of the array with the new element.
 * The new element cannot already be a member of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.Replace
 * @since 3.4.0
 *
 * @param {array} array - The array to search within.
 * @param {*} oldChild - The element in the array that will be replaced.
 * @param {*} newChild - The element to be inserted into the array at the position of `oldChild`.
 *
 * @return {boolean} Returns true if the oldChild was successfully replaced, otherwise returns false.
 */ var Replace = function(array, oldChild, newChild) {
                    var index1 = array.indexOf(oldChild);
                    var index2 = array.indexOf(newChild);
                    if (index1 !== -1 && index2 === -1) {
                        array[index1] = newChild;
                        return true;
                    } else return false;
                };
                module1.exports = Replace;
            /***/ },
            /***/ 86003: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the element at the start of the array to the end, shifting all items in the process.
 * The "rotation" happens to the left.
 *
 * @function Phaser.Utils.Array.RotateLeft
 * @since 3.0.0
 *
 * @param {array} array - The array to shift to the left. This array is modified in place.
 * @param {number} [total=1] - The number of times to shift the array.
 *
 * @return {*} The most recently shifted element.
 */ var RotateLeft = function(array, total) {
                    if (total === undefined) total = 1;
                    var element = null;
                    for(var i = 0; i < total; i++){
                        element = array.shift();
                        array.push(element);
                    }
                    return element;
                };
                module1.exports = RotateLeft;
            /***/ },
            /***/ 49498: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the element at the end of the array to the start, shifting all items in the process.
 * The "rotation" happens to the right.
 *
 * @function Phaser.Utils.Array.RotateRight
 * @since 3.0.0
 *
 * @param {array} array - The array to shift to the right. This array is modified in place.
 * @param {number} [total=1] - The number of times to shift the array.
 *
 * @return {*} The most recently shifted element.
 */ var RotateRight = function(array, total) {
                    if (total === undefined) total = 1;
                    var element = null;
                    for(var i = 0; i < total; i++){
                        element = array.pop();
                        array.unshift(element);
                    }
                    return element;
                };
                module1.exports = RotateRight;
            /***/ },
            /***/ 82011: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests if the start and end indexes are a safe range for the given array.
 *
 * @function Phaser.Utils.Array.SafeRange
 * @since 3.4.0
 *
 * @param {array} array - The array to check.
 * @param {number} startIndex - The start index.
 * @param {number} endIndex - The end index.
 * @param {boolean} [throwError=false] - Throw an error if the range is out of bounds.
 *
 * @return {boolean} True if the range is safe, otherwise false.
 */ var SafeRange = function(array, startIndex, endIndex, throwError) {
                    var len = array.length;
                    if (startIndex < 0 || startIndex >= len || startIndex >= endIndex || endIndex > len) {
                        if (throwError) throw new Error('Range Error: Values outside acceptable range');
                        return false;
                    } else return true;
                };
                module1.exports = SafeRange;
            /***/ },
            /***/ 89545: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given element to the bottom of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.SendToBack
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 *
 * @return {*} The element that was moved.
 */ var SendToBack = function(array, item) {
                    var currentIndex = array.indexOf(item);
                    if (currentIndex !== -1 && currentIndex > 0) {
                        array.splice(currentIndex, 1);
                        array.unshift(item);
                    }
                    return item;
                };
                module1.exports = SendToBack;
            /***/ },
            /***/ 17810: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(82011);
                /**
 * Scans the array for elements with the given property. If found, the property is set to the `value`.
 *
 * For example: `SetAll('visible', true)` would set all elements that have a `visible` property to `false`.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would update only the first 50 elements.
 *
 * @function Phaser.Utils.Array.SetAll
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} property - The property to test for on each array element.
 * @param {*} value - The value to set the property to.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {array} The input array.
 */ var SetAll = function(array, property, value, startIndex, endIndex) {
                    if (startIndex === undefined) startIndex = 0;
                    if (endIndex === undefined) endIndex = array.length;
                    if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                        var entry = array[i];
                        if (entry.hasOwnProperty(property)) entry[property] = value;
                    }
                    return array;
                };
                module1.exports = SetAll;
            /***/ },
            /***/ 33680: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Shuffles the contents of the given array using the Fisher-Yates implementation.
 *
 * The original array is modified directly and returned.
 *
 * @function Phaser.Utils.Array.Shuffle
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[]} - [array,$return]
 *
 * @param {T[]} array - The array to shuffle. This array is modified in place.
 *
 * @return {T[]} The shuffled array.
 */ var Shuffle = function(array) {
                    for(var i = array.length - 1; i > 0; i--){
                        var j = Math.floor(Math.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                };
                module1.exports = Shuffle;
            /***/ },
            /***/ 90126: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given array and runs a numeric sort on it, ignoring any non-digits that
 * may be in the entries.
 *
 * You should only run this on arrays containing strings.
 *
 * @function Phaser.Utils.Array.SortByDigits
 * @since 3.50.0
 *
 * @param {string[]} array - The input array of strings.
 *
 * @return {string[]} The sorted input array.
 */ var SortByDigits = function(array) {
                    var re = /\D/g;
                    array.sort(function(a, b) {
                        return parseInt(a.replace(re, ''), 10) - parseInt(b.replace(re, ''), 10);
                    });
                    return array;
                };
                module1.exports = SortByDigits;
            /***/ },
            /***/ 19133: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Removes a single item from an array and returns it without creating gc, like the native splice does.
 * Based on code by Mike Reinstein.
 *
 * @function Phaser.Utils.Array.SpliceOne
 * @since 3.0.0
 *
 * @param {array} array - The array to splice from.
 * @param {number} index - The index of the item which should be spliced.
 *
 * @return {*} The item which was spliced (removed).
 */ var SpliceOne = function(array, index) {
                    if (index >= array.length) return;
                    var len = array.length - 1;
                    var item = array[index];
                    for(var i = index; i < len; i++)array[i] = array[i + 1];
                    array.length = len;
                    return item;
                };
                module1.exports = SpliceOne;
            /***/ },
            /***/ 19186: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @author       Angry Bytes (and contributors)
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Device = __webpack_require__(82264);
                /**
 * The comparator function.
 *
 * @ignore
 *
 * @param {*} a - The first item to test.
 * @param {*} b - The second itemt to test.
 *
 * @return {boolean} True if they localCompare, otherwise false.
 */ function Compare(a, b) {
                    return String(a).localeCompare(b);
                }
                /**
 * Process the array contents.
 *
 * @ignore
 *
 * @param {array} array - The array to process.
 * @param {function} compare - The comparison function.
 *
 * @return {array} - The processed array.
 */ function Process(array, compare) {
                    // Short-circuit when there's nothing to sort.
                    var len = array.length;
                    if (len <= 1) return array;
                    // Rather than dividing input, simply iterate chunks of 1, 2, 4, 8, etc.
                    // Chunks are the size of the left or right hand in merge sort.
                    // Stop when the left-hand covers all of the array.
                    var buffer = new Array(len);
                    for(var chk = 1; chk < len; chk *= 2){
                        RunPass(array, compare, chk, buffer);
                        var tmp = array;
                        array = buffer;
                        buffer = tmp;
                    }
                    return array;
                }
                /**
 * Run a single pass with the given chunk size.
 *
 * @ignore
 *
 * @param {array} arr - The array to run the pass on.
 * @param {function} comp - The comparison function.
 * @param {number} chk - The number of iterations.
 * @param {array} result - The array to store the result in.
 */ function RunPass(arr, comp, chk, result) {
                    var len = arr.length;
                    var i = 0;
                    // Step size / double chunk size.
                    var dbl = chk * 2;
                    // Bounds of the left and right chunks.
                    var l, r, e;
                    // Iterators over the left and right chunk.
                    var li, ri;
                    // Iterate over pairs of chunks.
                    for(l = 0; l < len; l += dbl){
                        r = l + chk;
                        e = r + chk;
                        if (r > len) r = len;
                        if (e > len) e = len;
                        // Iterate both chunks in parallel.
                        li = l;
                        ri = r;
                        while(true){
                            // Compare the chunks.
                            if (li < r && ri < e) {
                                // This works for a regular `sort()` compatible comparator,
                                // but also for a simple comparator like: `a > b`
                                if (comp(arr[li], arr[ri]) <= 0) result[i++] = arr[li++];
                                else result[i++] = arr[ri++];
                            } else if (li < r) // Nothing to compare, just flush what's left.
                            result[i++] = arr[li++];
                            else if (ri < e) result[i++] = arr[ri++];
                            else break;
                        }
                    }
                }
                /**
 * An in-place stable array sort, because `Array#sort()` is not guaranteed stable.
 *
 * This is an implementation of merge sort, without recursion.
 *
 * Function based on the Two-Screen/stable sort 0.1.8 from https://github.com/Two-Screen/stable
 *
 * @function Phaser.Utils.Array.StableSort
 * @since 3.0.0
 *
 * @param {array} array - The input array to be sorted.
 * @param {function} [compare] - The comparison function.
 *
 * @return {array} The sorted result.
 */ var StableSort = function(array, compare) {
                    if (compare === undefined) compare = Compare;
                    // Short-circuit when there's nothing to sort.
                    if (!array || array.length < 2) return array;
                    if (Device.features.stableSort) return array.sort(compare);
                    var result = Process(array, compare);
                    // This simply copies back if the result isn't in the original array, which happens on an odd number of passes.
                    if (result !== array) RunPass(result, null, array.length, array);
                    return array;
                };
                module1.exports = StableSort;
            /***/ },
            /***/ 25630: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Swaps the position of two elements in the given array.
 * The elements must exist in the same array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.Swap
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item1 - The first element to swap.
 * @param {*} item2 - The second element to swap.
 *
 * @return {array} The input array.
 */ var Swap = function(array, item1, item2) {
                    if (item1 === item2) return array;
                    var index1 = array.indexOf(item1);
                    var index2 = array.indexOf(item2);
                    if (index1 < 0 || index2 < 0) throw new Error('Supplied items must be elements of the same array');
                    array[index1] = item2;
                    array[index2] = item1;
                    return array;
                };
                module1.exports = Swap;
            /***/ },
            /***/ 37105: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Array
 */ module1.exports = {
                    Matrix: __webpack_require__(54915),
                    Add: __webpack_require__(71146),
                    AddAt: __webpack_require__(51067),
                    BringToTop: __webpack_require__(66905),
                    CountAllMatching: __webpack_require__(21612),
                    Each: __webpack_require__(95428),
                    EachInRange: __webpack_require__(36914),
                    FindClosestInSorted: __webpack_require__(81957),
                    Flatten: __webpack_require__(43491),
                    GetAll: __webpack_require__(46710),
                    GetFirst: __webpack_require__(58731),
                    GetRandom: __webpack_require__(26546),
                    MoveDown: __webpack_require__(70864),
                    MoveTo: __webpack_require__(69693),
                    MoveUp: __webpack_require__(40853),
                    MoveAbove: __webpack_require__(85835),
                    MoveBelow: __webpack_require__(83371),
                    NumberArray: __webpack_require__(20283),
                    NumberArrayStep: __webpack_require__(593),
                    QuickSelect: __webpack_require__(43886),
                    Range: __webpack_require__(88492),
                    Remove: __webpack_require__(72905),
                    RemoveAt: __webpack_require__(60248),
                    RemoveBetween: __webpack_require__(81409),
                    RemoveRandomElement: __webpack_require__(31856),
                    Replace: __webpack_require__(42169),
                    RotateLeft: __webpack_require__(86003),
                    RotateRight: __webpack_require__(49498),
                    SafeRange: __webpack_require__(82011),
                    SendToBack: __webpack_require__(89545),
                    SetAll: __webpack_require__(17810),
                    Shuffle: __webpack_require__(33680),
                    SortByDigits: __webpack_require__(90126),
                    SpliceOne: __webpack_require__(19133),
                    StableSort: __webpack_require__(19186),
                    Swap: __webpack_require__(25630)
                };
            /***/ },
            /***/ 86922: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if an array can be used as a matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.CheckMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix]
 *
 * @param {T[][]} [matrix] - The array to check.
 *
 * @return {boolean} `true` if the given `matrix` array is a valid matrix.
 */ var CheckMatrix = function(matrix) {
                    if (!Array.isArray(matrix) || !Array.isArray(matrix[0])) return false;
                    //  How long is the first row?
                    var size = matrix[0].length;
                    //  Validate the rest of the rows are the same length
                    for(var i = 1; i < matrix.length; i++){
                        if (matrix[i].length !== size) return false;
                    }
                    return true;
                };
                module1.exports = CheckMatrix;
            /***/ },
            /***/ 63362: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Pad = __webpack_require__(41836);
                var CheckMatrix = __webpack_require__(86922);
                /**
 * Generates a string (which you can pass to console.log) from the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.MatrixToString
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix]
 *
 * @param {T[][]} [matrix] - A 2-dimensional array.
 *
 * @return {string} A string representing the matrix.
 */ var MatrixToString = function(matrix) {
                    var str = '';
                    if (!CheckMatrix(matrix)) return str;
                    for(var r = 0; r < matrix.length; r++){
                        for(var c = 0; c < matrix[r].length; c++){
                            var cell = matrix[r][c].toString();
                            if (cell !== 'undefined') str += Pad(cell, 2);
                            else str += '?';
                            if (c < matrix[r].length - 1) str += ' |';
                        }
                        if (r < matrix.length - 1) {
                            str += '\n';
                            for(var i = 0; i < matrix[r].length; i++){
                                str += '---';
                                if (i < matrix[r].length - 1) str += '+';
                            }
                            str += '\n';
                        }
                    }
                    return str;
                };
                module1.exports = MatrixToString;
            /***/ },
            /***/ 92598: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the columns in the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.ReverseColumns
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to reverse the columns for.
 *
 * @return {T[][]} The column reversed matrix.
 */ var ReverseColumns = function(matrix) {
                    return matrix.reverse();
                };
                module1.exports = ReverseColumns;
            /***/ },
            /***/ 21224: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the rows in the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.ReverseRows
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to reverse the rows for.
 *
 * @return {T[][]} The column reversed matrix.
 */ var ReverseRows = function(matrix) {
                    for(var i = 0; i < matrix.length; i++)matrix[i].reverse();
                    return matrix;
                };
                module1.exports = ReverseRows;
            /***/ },
            /***/ 98717: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(37829);
                /**
 * Rotates the array matrix 180 degrees.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.Rotate180
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var Rotate180 = function(matrix) {
                    return RotateMatrix(matrix, 180);
                };
                module1.exports = Rotate180;
            /***/ },
            /***/ 44657: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(37829);
                /**
 * Rotates the array matrix to the left (or 90 degrees)
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateLeft
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 * @param {number} [amount=1] - The number of times to rotate the matrix.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateLeft = function(matrix, amount) {
                    if (amount === undefined) amount = 1;
                    for(var i = 0; i < amount; i++)matrix = RotateMatrix(matrix, 90);
                    return matrix;
                };
                module1.exports = RotateLeft;
            /***/ },
            /***/ 37829: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CheckMatrix = __webpack_require__(86922);
                var TransposeMatrix = __webpack_require__(2429);
                /**
 * Rotates the array matrix based on the given rotation value.
 *
 * The value can be given in degrees: 90, -90, 270, -270 or 180,
 * or a string command: `rotateLeft`, `rotateRight` or `rotate180`.
 *
 * Based on the routine from {@link http://jsfiddle.net/MrPolywhirl/NH42z/}.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 * @param {(number|string)} [direction=90] - The amount to rotate the matrix by.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateMatrix = function(matrix, direction) {
                    if (direction === undefined) direction = 90;
                    if (!CheckMatrix(matrix)) return null;
                    if (typeof direction !== 'string') direction = (direction % 360 + 360) % 360;
                    if (direction === 90 || direction === -270 || direction === 'rotateLeft') {
                        matrix = TransposeMatrix(matrix);
                        matrix.reverse();
                    } else if (direction === -90 || direction === 270 || direction === 'rotateRight') {
                        matrix.reverse();
                        matrix = TransposeMatrix(matrix);
                    } else if (Math.abs(direction) === 180 || direction === 'rotate180') {
                        for(var i = 0; i < matrix.length; i++)matrix[i].reverse();
                        matrix.reverse();
                    }
                    return matrix;
                };
                module1.exports = RotateMatrix;
            /***/ },
            /***/ 92632: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(37829);
                /**
 * Rotates the array matrix to the left (or -90 degrees)
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateRight
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 * @param {number} [amount=1] - The number of times to rotate the matrix.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateRight = function(matrix, amount) {
                    if (amount === undefined) amount = 1;
                    for(var i = 0; i < amount; i++)matrix = RotateMatrix(matrix, -90);
                    return matrix;
                };
                module1.exports = RotateRight;
            /***/ },
            /***/ 69512: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateLeft = __webpack_require__(86003);
                var RotateRight = __webpack_require__(49498);
                /**
 * Translates the given Array Matrix by shifting each column and row the
 * amount specified.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.Translate
 * @since 3.50.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to translate.
 * @param {number} [x=0] - The amount to horizontally translate the matrix by.
 * @param {number} [y=0] - The amount to vertically translate the matrix by.
 *
 * @return {T[][]} The translated matrix.
 */ var TranslateMatrix = function(matrix, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    //  Vertical translation
                    if (y !== 0) {
                        if (y < 0) //  Shift Up
                        RotateLeft(matrix, Math.abs(y));
                        else //  Shift Down
                        RotateRight(matrix, y);
                    }
                    //  Horizontal translation
                    if (x !== 0) for(var i = 0; i < matrix.length; i++){
                        var row = matrix[i];
                        if (x < 0) RotateLeft(row, Math.abs(x));
                        else RotateRight(row, x);
                    }
                    return matrix;
                };
                module1.exports = TranslateMatrix;
            /***/ },
            /***/ 2429: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Transposes the elements of the given matrix (array of arrays).
 *
 * The transpose of a matrix is a new matrix whose rows are the columns of the original.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.TransposeMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [array,$return]
 *
 * @param {T[][]} [array] - The array matrix to transpose.
 *
 * @return {T[][]} A new array matrix which is a transposed version of the given array.
 */ var TransposeMatrix = function(array) {
                    var sourceRowCount = array.length;
                    var sourceColCount = array[0].length;
                    var result = new Array(sourceColCount);
                    for(var i = 0; i < sourceColCount; i++){
                        result[i] = new Array(sourceRowCount);
                        for(var j = sourceRowCount - 1; j > -1; j--)result[i][j] = array[j][i];
                    }
                    return result;
                };
                module1.exports = TransposeMatrix;
            /***/ },
            /***/ 54915: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Array.Matrix
 */ module1.exports = {
                    CheckMatrix: __webpack_require__(86922),
                    MatrixToString: __webpack_require__(63362),
                    ReverseColumns: __webpack_require__(92598),
                    ReverseRows: __webpack_require__(21224),
                    Rotate180: __webpack_require__(98717),
                    RotateLeft: __webpack_require__(44657),
                    RotateMatrix: __webpack_require__(37829),
                    RotateRight: __webpack_require__(92632),
                    Translate: __webpack_require__(69512),
                    TransposeMatrix: __webpack_require__(2429)
                };
            /***/ },
            /***/ 71334: /***/ (module1)=>{
                /**
 * @author       Niklas von Hertzen (https://github.com/niklasvh/base64-arraybuffer)
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                /**
 * Converts an ArrayBuffer into a base64 string.
 *
 * The resulting string can optionally be a data uri if the `mediaType` argument is provided.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs for more details.
 *
 * @function Phaser.Utils.Base64.ArrayBufferToBase64
 * @since 3.18.0
 *
 * @param {ArrayBuffer} arrayBuffer - The Array Buffer to encode.
 * @param {string} [mediaType] - An optional media type, i.e. `audio/ogg` or `image/jpeg`. If included the resulting string will be a data URI.
 *
 * @return {string} The base64 encoded Array Buffer.
 */ var ArrayBufferToBase64 = function(arrayBuffer, mediaType) {
                    var bytes = new Uint8Array(arrayBuffer);
                    var len = bytes.length;
                    var base64 = mediaType ? 'data:' + mediaType + ';base64,' : '';
                    for(var i = 0; i < len; i += 3){
                        base64 += chars[bytes[i] >> 2];
                        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64 += chars[bytes[i + 2] & 63];
                    }
                    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
                    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
                    return base64;
                };
                module1.exports = ArrayBufferToBase64;
            /***/ },
            /***/ 53134: /***/ (module1)=>{
                /**
 * @author       Niklas von Hertzen (https://github.com/niklasvh/base64-arraybuffer)
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                //  Use a lookup table to find the index.
                var lookup = new Uint8Array(256);
                for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
                /**
 * Converts a base64 string, either with or without a data uri, into an Array Buffer.
 *
 * @function Phaser.Utils.Base64.Base64ToArrayBuffer
 * @since 3.18.0
 *
 * @param {string} base64 - The base64 string to be decoded. Can optionally contain a data URI header, which will be stripped out prior to decoding.
 *
 * @return {ArrayBuffer} An ArrayBuffer decoded from the base64 data.
 */ var Base64ToArrayBuffer = function(base64) {
                    //  Is it a data uri? if so, strip the header away
                    base64 = base64.substr(base64.indexOf(',') + 1);
                    var len = base64.length;
                    var bufferLength = len * 0.75;
                    var p = 0;
                    var encoded1;
                    var encoded2;
                    var encoded3;
                    var encoded4;
                    if (base64[len - 1] === '=') {
                        bufferLength--;
                        if (base64[len - 2] === '=') bufferLength--;
                    }
                    var arrayBuffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(arrayBuffer);
                    for(var i = 0; i < len; i += 4){
                        encoded1 = lookup[base64.charCodeAt(i)];
                        encoded2 = lookup[base64.charCodeAt(i + 1)];
                        encoded3 = lookup[base64.charCodeAt(i + 2)];
                        encoded4 = lookup[base64.charCodeAt(i + 3)];
                        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return arrayBuffer;
                };
                module1.exports = Base64ToArrayBuffer;
            /***/ },
            /***/ 65839: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Base64
 */ module1.exports = {
                    ArrayBufferToBase64: __webpack_require__(71334),
                    Base64ToArrayBuffer: __webpack_require__(53134)
                };
            /***/ },
            /***/ 91799: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils
 */ module1.exports = {
                    Array: __webpack_require__(37105),
                    Base64: __webpack_require__(65839),
                    Objects: __webpack_require__(1183),
                    String: __webpack_require__(31749),
                    NOOP: __webpack_require__(29747),
                    NULL: __webpack_require__(20242)
                };
            /***/ },
            /***/ 41786: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Shallow Object Clone. Will not clone nested objects.
 *
 * @function Phaser.Utils.Objects.Clone
 * @since 3.0.0
 *
 * @param {object} obj - The object to clone.
 *
 * @return {object} A new object with the same properties as the input object.
 */ var Clone = function(obj) {
                    var clone = {};
                    for(var key in obj)if (Array.isArray(obj[key])) clone[key] = obj[key].slice(0);
                    else clone[key] = obj[key];
                    return clone;
                };
                module1.exports = Clone;
            /***/ },
            /***/ 62644: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Deep Copy the given object or array.
 *
 * @function Phaser.Utils.Objects.DeepCopy
 * @since 3.50.0
 *
 * @param {object} obj - The object to deep copy.
 *
 * @return {object} A deep copy of the original object.
 */ var DeepCopy = function(inObject) {
                    var outObject;
                    var value;
                    var key;
                    if (typeof inObject !== 'object' || inObject === null) //  inObject is not an object
                    return inObject;
                    //  Create an array or object to hold the values
                    outObject = Array.isArray(inObject) ? [] : {};
                    for(key in inObject){
                        value = inObject[key];
                        //  Recursively (deep) copy for nested objects, including arrays
                        outObject[key] = DeepCopy(value);
                    }
                    return outObject;
                };
                module1.exports = DeepCopy;
            /***/ },
            /***/ 79291: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsPlainObject = __webpack_require__(41212);
                // @param {boolean} deep - Perform a deep copy?
                // @param {object} target - The target object to copy to.
                // @return {object} The extended object.
                /**
 * This is a slightly modified version of http://api.jquery.com/jQuery.extend/
 *
 * @function Phaser.Utils.Objects.Extend
 * @since 3.0.0
 *
 * @param {...*} [args] - The objects that will be mixed.
 *
 * @return {object} The extended object.
 */ var Extend = function() {
                    var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
                    // Handle a deep copy situation
                    if (typeof target === 'boolean') {
                        deep = target;
                        target = arguments[1] || {};
                        // skip the boolean and the target
                        i = 2;
                    }
                    // extend Phaser if only one argument is passed
                    if (length === i) {
                        target = this;
                        --i;
                    }
                    for(; i < length; i++){
                        // Only deal with non-null/undefined values
                        if ((options = arguments[i]) != null) // Extend the base object
                        for(name in options){
                            src = target[name];
                            copy = options[name];
                            // Prevent never-ending loop
                            if (target === copy) continue;
                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (IsPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && Array.isArray(src) ? src : [];
                                } else clone = src && IsPlainObject(src) ? src : {};
                                // Never move original objects, clone them
                                target[name] = Extend(deep, clone, copy);
                            // Don't bring in undefined values
                            } else if (copy !== undefined) target[name] = copy;
                        }
                    }
                    // Return the modified object
                    return target;
                };
                module1.exports = Extend;
            /***/ },
            /***/ 23568: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH = __webpack_require__(75508);
                var GetValue = __webpack_require__(35154);
                /**
 * Retrieves a value from an object. Allows for more advanced selection options, including:
 *
 * Allowed types:
 *
 * Explicit:
 * {
 *     x: 4
 * }
 *
 * From function
 * {
 *     x: function ()
 * }
 *
 * Randomly pick one element from the array
 * {
 *     x: [a, b, c, d, e, f]
 * }
 *
 * Random integer between min and max:
 * {
 *     x: { randInt: [min, max] }
 * }
 *
 * Random float between min and max:
 * {
 *     x: { randFloat: [min, max] }
 * }
 *
 *
 * @function Phaser.Utils.Objects.GetAdvancedValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`) - `banner.hideBanner` would return the value of the `hideBanner` property from the object stored in the `banner` property of the `source` object.
 * @param {*} defaultValue - The value to return if the `key` isn't found in the `source` object.
 *
 * @return {*} The value of the requested key.
 */ var GetAdvancedValue = function(source, key, defaultValue) {
                    var value = GetValue(source, key, null);
                    if (value === null) return defaultValue;
                    else if (Array.isArray(value)) return MATH.RND.pick(value);
                    else if (typeof value === 'object') {
                        if (value.hasOwnProperty('randInt')) return MATH.RND.integerInRange(value.randInt[0], value.randInt[1]);
                        else if (value.hasOwnProperty('randFloat')) return MATH.RND.realInRange(value.randFloat[0], value.randFloat[1]);
                    } else if (typeof value === 'function') return value(key);
                    return value;
                };
                module1.exports = GetAdvancedValue;
            /***/ },
            /***/ 95540: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Finds the key within the top level of the {@link source} object, or returns {@link defaultValue}
 *
 * @function Phaser.Utils.Objects.GetFastValue
 * @since 3.0.0
 *
 * @param {object} source - The object to search
 * @param {string} key - The key for the property on source. Must exist at the top level of the source object (no periods)
 * @param {*} [defaultValue] - The default value to use if the key does not exist.
 *
 * @return {*} The value if found; otherwise, defaultValue (null if none provided)
 */ var GetFastValue = function(source, key, defaultValue) {
                    var t = typeof source;
                    if (!source || t === 'number' || t === 'string') return defaultValue;
                    else if (source.hasOwnProperty(key) && source[key] !== undefined) return source[key];
                    else return defaultValue;
                };
                module1.exports = GetFastValue;
            /***/ },
            /***/ 82840: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(35154);
                var Clamp = __webpack_require__(45319);
                /**
 * Retrieves and clamps a numerical value from an object.
 *
 * @function Phaser.Utils.Objects.GetMinMaxValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`).
 * @param {number} min - The minimum value which can be returned.
 * @param {number} max - The maximum value which can be returned.
 * @param {number} defaultValue - The value to return if the property doesn't exist. It's also constrained to the given bounds.
 *
 * @return {number} The clamped value from the `source` object.
 */ var GetMinMaxValue = function(source, key, min, max, defaultValue) {
                    if (defaultValue === undefined) defaultValue = min;
                    var value = GetValue(source, key, defaultValue);
                    return Clamp(value, min, max);
                };
                module1.exports = GetMinMaxValue;
            /***/ },
            /***/ 35154: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Retrieves a value from an object, or an alternative object, falling to a back-up default value if not found.
 *
 * The key is a string, which can be split based on the use of the period character.
 *
 * For example:
 *
 * ```javascript
 * const source = {
 *   lives: 3,
 *   render: {
 *     screen: {
 *       width: 1024
 *     }
 *   }
 * }
 *
 * const lives = GetValue(source, 'lives', 1);
 * const width = GetValue(source, 'render.screen.width', 800);
 * const height = GetValue(source, 'render.screen.height', 600);
 * ```
 *
 * In the code above, `lives` will be 3 because it's defined at the top level of `source`.
 * The `width` value will be 1024 because it can be found inside the `render.screen` object.
 * The `height` value will be 600, the default value, because it is missing from the `render.screen` object.
 *
 * @function Phaser.Utils.Objects.GetValue
 * @since 3.0.0
 *
 * @param {object} source - The primary object to try to retrieve the value from. If not found in here, `altSource` is checked.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`) - `banner.hideBanner` would return the value of the `hideBanner` property from the object stored in the `banner` property of the `source` object.
 * @param {*} defaultValue - The value to return if the `key` isn't found in the `source` object.
 * @param {object} [altSource] - An alternative object to retrieve the value from. If the property exists in `source` then `altSource` will not be used.
 *
 * @return {*} The value of the requested key.
 */ var GetValue = function(source, key, defaultValue, altSource) {
                    if (!source && !altSource || typeof source === 'number') return defaultValue;
                    else if (source && source.hasOwnProperty(key)) return source[key];
                    else if (altSource && altSource.hasOwnProperty(key)) return altSource[key];
                    else if (key.indexOf('.') !== -1) {
                        var keys = key.split('.');
                        var parentA = source;
                        var parentB = altSource;
                        var valueA = defaultValue;
                        var valueB = defaultValue;
                        var valueAFound = true;
                        var valueBFound = true;
                        //  Use for loop here so we can break early
                        for(var i = 0; i < keys.length; i++){
                            if (parentA && parentA.hasOwnProperty(keys[i])) {
                                //  Yes parentA has a key property, let's carry on down
                                valueA = parentA[keys[i]];
                                parentA = parentA[keys[i]];
                            } else valueAFound = false;
                            if (parentB && parentB.hasOwnProperty(keys[i])) {
                                //  Yes parentB has a key property, let's carry on down
                                valueB = parentB[keys[i]];
                                parentB = parentB[keys[i]];
                            } else valueBFound = false;
                        }
                        if (valueAFound) return valueA;
                        else if (valueBFound) return valueB;
                        else return defaultValue;
                    } else return defaultValue;
                };
                module1.exports = GetValue;
            /***/ },
            /***/ 69036: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Verifies that an object contains all requested keys
 *
 * @function Phaser.Utils.Objects.HasAll
 * @since 3.0.0
 *
 * @param {object} source - an object on which to check for key existence
 * @param {string[]} keys - an array of keys to ensure the source object contains
 *
 * @return {boolean} true if the source object contains all keys, false otherwise.
 */ var HasAll = function(source, keys) {
                    for(var i = 0; i < keys.length; i++){
                        if (!source.hasOwnProperty(keys[i])) return false;
                    }
                    return true;
                };
                module1.exports = HasAll;
            /***/ },
            /***/ 1985: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Verifies that an object contains at least one of the requested keys
 *
 * @function Phaser.Utils.Objects.HasAny
 * @since 3.0.0
 *
 * @param {object} source - an object on which to check for key existence
 * @param {string[]} keys - an array of keys to search the object for
 *
 * @return {boolean} true if the source object contains at least one of the keys, false otherwise
 */ var HasAny = function(source, keys) {
                    for(var i = 0; i < keys.length; i++){
                        if (source.hasOwnProperty(keys[i])) return true;
                    }
                    return false;
                };
                module1.exports = HasAny;
            /***/ },
            /***/ 97022: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determine whether the source object has a property with the specified key.
 *
 * @function Phaser.Utils.Objects.HasValue
 * @since 3.0.0
 *
 * @param {object} source - The source object to be checked.
 * @param {string} key - The property to check for within the object
 *
 * @return {boolean} `true` if the provided `key` exists on the `source` object, otherwise `false`.
 */ var HasValue = function(source, key) {
                    return source.hasOwnProperty(key);
                };
                module1.exports = HasValue;
            /***/ },
            /***/ 41212: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a slightly modified version of jQuery.isPlainObject.
 * A plain object is an object whose internal class property is [object Object].
 *
 * @function Phaser.Utils.Objects.IsPlainObject
 * @since 3.0.0
 *
 * @param {object} obj - The object to inspect.
 *
 * @return {boolean} `true` if the object is plain, otherwise `false`.
 */ var IsPlainObject = function(obj) {
                    // Not plain objects:
                    // - Any object or value whose internal [[Class]] property is not "[object Object]"
                    // - DOM nodes
                    // - window
                    if (!obj || typeof obj !== 'object' || obj.nodeType || obj === obj.window) return false;
                    // Support: Firefox <20
                    // The try/catch suppresses exceptions thrown when attempting to access
                    // the "constructor" property of certain host objects, ie. |window.location|
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=814622
                    try {
                        if (obj.constructor && !({}).hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf')) return false;
                    } catch (e) {
                        return false;
                    }
                    // If the function hasn't returned already, we're confident that
                    // |obj| is a plain object, created by {} or constructed with new Object
                    return true;
                };
                module1.exports = IsPlainObject;
            /***/ },
            /***/ 46975: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(41786);
                /**
 * Creates a new Object using all values from obj1 and obj2.
 * If a value exists in both obj1 and obj2, the value in obj1 is used.
 *
 * This is only a shallow copy. Deeply nested objects are not cloned, so be sure to only use this
 * function on shallow objects.
 *
 * @function Phaser.Utils.Objects.Merge
 * @since 3.0.0
 *
 * @param {object} obj1 - The first object.
 * @param {object} obj2 - The second object.
 *
 * @return {object} A new object containing the union of obj1's and obj2's properties.
 */ var Merge = function(obj1, obj2) {
                    var clone = Clone(obj1);
                    for(var key in obj2)if (!clone.hasOwnProperty(key)) clone[key] = obj2[key];
                    return clone;
                };
                module1.exports = Merge;
            /***/ },
            /***/ 269: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(41786);
                /**
 * Creates a new Object using all values from obj1.
 *
 * Then scans obj2. If a property is found in obj2 that *also* exists in obj1, the value from obj2 is used, otherwise the property is skipped.
 *
 * @function Phaser.Utils.Objects.MergeRight
 * @since 3.0.0
 *
 * @param {object} obj1 - The first object to merge.
 * @param {object} obj2 - The second object to merge. Keys from this object which also exist in `obj1` will be copied to `obj1`.
 *
 * @return {object} The merged object. `obj1` and `obj2` are not modified.
 */ var MergeRight = function(obj1, obj2) {
                    var clone = Clone(obj1);
                    for(var key in obj2)if (clone.hasOwnProperty(key)) clone[key] = obj2[key];
                    return clone;
                };
                module1.exports = MergeRight;
            /***/ },
            /***/ 18254: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HasValue = __webpack_require__(97022);
                /**
 * Returns a new object that only contains the `keys` that were found on the object provided.
 * If no `keys` are found, an empty object is returned.
 *
 * @function Phaser.Utils.Objects.Pick
 * @since 3.18.0
 *
 * @param {object} object - The object to pick the provided keys from.
 * @param {array} keys - An array of properties to retrieve from the provided object.
 *
 * @return {object} A new object that only contains the `keys` that were found on the provided object. If no `keys` were found, an empty object will be returned.
 */ var Pick = function(object, keys) {
                    var obj = {};
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (HasValue(object, key)) obj[key] = object[key];
                    }
                    return obj;
                };
                module1.exports = Pick;
            /***/ },
            /***/ 61622: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets a value in an object, allowing for dot notation to control the depth of the property.
 *
 * For example:
 *
 * ```javascript
 * var data = {
 *   world: {
 *     position: {
 *       x: 200,
 *       y: 100
 *     }
 *   }
 * };
 *
 * SetValue(data, 'world.position.y', 300);
 *
 * console.log(data.world.position.y); // 300
 * ```
 *
 * @function Phaser.Utils.Objects.SetValue
 * @since 3.17.0
 *
 * @param {object} source - The object to set the value in.
 * @param {string} key - The name of the property in the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`)
 * @param {any} value - The value to set into the property, if found in the source object.
 *
 * @return {boolean} `true` if the property key was valid and the value was set, otherwise `false`.
 */ var SetValue = function(source, key, value) {
                    if (!source || typeof source === 'number') return false;
                    else if (source.hasOwnProperty(key)) {
                        source[key] = value;
                        return true;
                    } else if (key.indexOf('.') !== -1) {
                        var keys = key.split('.');
                        var parent = source;
                        var prev = source;
                        //  Use for loop here so we can break early
                        for(var i = 0; i < keys.length; i++){
                            if (parent.hasOwnProperty(keys[i])) {
                                //  Yes it has a key property, let's carry on down
                                prev = parent;
                                parent = parent[keys[i]];
                            } else return false;
                        }
                        prev[keys[keys.length - 1]] = value;
                        return true;
                    }
                    return false;
                };
                module1.exports = SetValue;
            /***/ },
            /***/ 1183: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Objects
 */ module1.exports = {
                    Clone: __webpack_require__(41786),
                    DeepCopy: __webpack_require__(62644),
                    Extend: __webpack_require__(79291),
                    GetAdvancedValue: __webpack_require__(23568),
                    GetFastValue: __webpack_require__(95540),
                    GetMinMaxValue: __webpack_require__(82840),
                    GetValue: __webpack_require__(35154),
                    HasAll: __webpack_require__(69036),
                    HasAny: __webpack_require__(1985),
                    HasValue: __webpack_require__(97022),
                    IsPlainObject: __webpack_require__(41212),
                    Merge: __webpack_require__(46975),
                    MergeRight: __webpack_require__(269),
                    Pick: __webpack_require__(18254),
                    SetValue: __webpack_require__(61622)
                };
            /***/ },
            /***/ 27902: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes a string and replaces instances of markers with values in the given array.
 * The markers take the form of `%1`, `%2`, etc. I.e.:
 *
 * `Format("The %1 is worth %2 gold", [ 'Sword', 500 ])`
 *
 * @function Phaser.Utils.String.Format
 * @since 3.0.0
 *
 * @param {string} string - The string containing the replacement markers.
 * @param {array} values - An array containing values that will replace the markers. If no value exists an empty string is inserted instead.
 *
 * @return {string} The string containing replaced values.
 */ var Format = function(string, values) {
                    return string.replace(/%([0-9]+)/g, function(s, n) {
                        return values[Number(n) - 1];
                    });
                };
                module1.exports = Format;
            /***/ },
            /***/ 41836: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given string and pads it out, to the length required, using the character
 * specified. For example if you need a string to be 6 characters long, you can call:
 *
 * `pad('bob', 6, '-', 2)`
 *
 * This would return: `bob---` as it has padded it out to 6 characters, using the `-` on the right.
 *
 * You can also use it to pad numbers (they are always returned as strings):
 *
 * `pad(512, 6, '0', 1)`
 *
 * Would return: `000512` with the string padded to the left.
 *
 * If you don't specify a direction it'll pad to both sides:
 *
 * `pad('c64', 7, '*')`
 *
 * Would return: `**c64**`
 *
 * @function Phaser.Utils.String.Pad
 * @since 3.0.0
 *
 * @param {string|number|object} str - The target string. `toString()` will be called on the string, which means you can also pass in common data types like numbers.
 * @param {number} [len=0] - The number of characters to be added.
 * @param {string} [pad=" "] - The string to pad it out with (defaults to a space).
 * @param {number} [dir=3] - The direction dir = 1 (left), 2 (right), 3 (both).
 *
 * @return {string} The padded string.
 */ var Pad = function(str, len, pad, dir) {
                    if (len === undefined) len = 0;
                    if (pad === undefined) pad = ' ';
                    if (dir === undefined) dir = 3;
                    str = str.toString();
                    var padlen = 0;
                    if (len + 1 >= str.length) switch(dir){
                        case 1:
                            str = new Array(len + 1 - str.length).join(pad) + str;
                            break;
                        case 3:
                            var right = Math.ceil((padlen = len - str.length) / 2);
                            var left = padlen - right;
                            str = new Array(left + 1).join(pad) + str + new Array(right + 1).join(pad);
                            break;
                        default:
                            str = str + new Array(len + 1 - str.length).join(pad);
                            break;
                    }
                    return str;
                };
                module1.exports = Pad;
            /***/ },
            /***/ 33628: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes a string and removes the character at the given index.
 * 
 * The index is zero based.
 *
 * @function Phaser.Utils.String.RemoveAt
 * @since 3.50.0
 *
 * @param {string} string - The string to be worked on.
 * @param {number} index - The index of the character to be removed. This value is zero-based.
 *
 * @return {string} The modified string.
 */ var RemoveAt = function(string, index) {
                    if (index === 0) return string.slice(1);
                    else return string.slice(0, index) + string.slice(index + 1);
                };
                module1.exports = RemoveAt;
            /***/ },
            /***/ 27671: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given string and reverses it, returning the reversed string.
 * For example if given the string `Atari 520ST` it would return `TS025 iratA`.
 *
 * @function Phaser.Utils.String.Reverse
 * @since 3.0.0
 *
 * @param {string} string - The string to be reversed.
 *
 * @return {string} The reversed string.
 */ var Reverse = function(string) {
                    return string.split('').reverse().join('');
                };
                module1.exports = Reverse;
            /***/ },
            /***/ 45650: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates and returns an RFC4122 version 4 compliant UUID.
 *
 * The string is in the form: `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx` where each `x` is replaced with a random
 * hexadecimal digit from 0 to f, and `y` is replaced with a random hexadecimal digit from 8 to b.
 *
 * @function Phaser.Utils.String.UUID
 * @since 3.12.0
 *
 * @return {string} The UUID string.
 */ var UUID = function() {
                    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                        var r = Math.random() * 16 | 0;
                        var v = c === 'x' ? r : r & 0x3 | 0x8;
                        return v.toString(16);
                    });
                };
                module1.exports = UUID;
            /***/ },
            /***/ 35355: /***/ (module1)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Capitalizes the first letter of a string if there is one.
 * @example
 * UppercaseFirst('abc');
 * // returns 'Abc'
 * @example
 * UppercaseFirst('the happy family');
 * // returns 'The happy family'
 * @example
 * UppercaseFirst('');
 * // returns ''
 *
 * @function Phaser.Utils.String.UppercaseFirst
 * @since 3.0.0
 *
 * @param {string} str - The string to capitalize.
 *
 * @return {string} A new string, same as the first, but with the first letter capitalized.
 */ var UppercaseFirst = function(str) {
                    return str && str[0].toUpperCase() + str.slice(1);
                };
                module1.exports = UppercaseFirst;
            /***/ },
            /***/ 31749: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * @author       Richard Davey <rich@phaser.io>
 * @copyright    2013-2025 Phaser Studio Inc.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.String
 */ module1.exports = {
                    Format: __webpack_require__(27902),
                    Pad: __webpack_require__(41836),
                    RemoveAt: __webpack_require__(33628),
                    Reverse: __webpack_require__(27671),
                    UppercaseFirst: __webpack_require__(35355),
                    UUID: __webpack_require__(45650)
                };
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/global */ /******/ (()=>{
            /******/ __webpack_require__.g = function() {
                /******/ if (typeof globalThis === 'object') return globalThis;
                /******/ try {
                    /******/ return this || new Function('return this')();
                /******/ } catch (e) {
                    /******/ if (typeof window === 'object') return window;
                /******/ }
            /******/ }();
        /******/ })();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(85454);
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});


class $35da740d59af89ba$var$MainScene extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: 'MainScene'
        });
        this.initializeGameState();
    }
    initializeGameState() {
        this.balls = [];
        this.queens = [];
        this.isDragging = false;
        this.ballsInHole = 0;
        this.queensHit = 0;
        this.totalQueens = 5; // Will be calculated based on screen size
        // Set larger margins for mobile devices
        this.marginMultiplier = $35da740d59af89ba$var$game.device.os.android || $35da740d59af89ba$var$game.device.os.iOS ? 0.075 : 0.05;
        this.flingCount = 0;
        this.activeBall = null;
        this.currentBallIndex = 0;
        this.maxDragDistance = 150;
        this.highScores = JSON.parse(localStorage.getItem('colorFlingerScores')) || [];
        this.gameEnded = false;
        this.scoreTexts = [];
        this.queensHitThisFling = 0;
        this.gameWidth = window.innerWidth;
        this.gameHeight = window.innerHeight;
        this.ballColors = [
            0xff2d55,
            0xff8c00,
            0xffd60a,
            0x2ecc71,
            0x007aff
        ]; // Rainbow order
        this.waitingForBallsToSettle = false;
        this.ballSettleTimeout = null;
        this.lastStateCheck = 0;
        this.soundEnabled = true;
        this.currentOscillator = null;
        this.currentGain = null;
        // Initialize audio context
        try {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            this.masterGain = this.audioContext.createGain();
            this.masterGain.connect(this.audioContext.destination);
            this.masterGain.gain.value = 0.3; // Default volume
        } catch (error) {
            console.warn('Web Audio API not supported');
            this.soundEnabled = false;
        }
    }
    preload() {
        // Create loading text
        const loadingText = this.add.text(this.game.config.width / 2, this.game.config.height / 2, 'Loading...', {
            fontSize: '32px',
            fill: '#fff',
            fontFamily: 'Arial'
        }).setOrigin(0.5);
        // Create particle texture
        const particles = this.add.graphics({
            x: 0,
            y: 0,
            add: false
        });
        particles.fillStyle(0xffffff, 1);
        particles.fillCircle(4, 4, 4);
        particles.generateTexture('particle', 8, 8);
        // Remove loading text when all assets are loaded
        this.load.once('complete', ()=>{
            loadingText.destroy();
        });
    }
    create() {
        // Clean up any existing input handlers
        this.input.removeAllListeners();
        // Reset game state
        this.initializeGameState();
        // Calculate play area and number of queens
        this.calculatePlayAreaAndQueens();
        // Add debug key
        this.input.keyboard.on('keydown-D', ()=>{
            this.debugBallStates();
        });
        // Add reset key
        this.input.keyboard.on('keydown-R', ()=>{
            console.log('Manual recovery triggered');
            this.validateAndFixGameState();
        });
        // Handle resize events
        this.scale.on('resize', (gameSize)=>{
            // Only resize if not in the middle of a fling
            if (!this.isDragging && !this.waitingForBallsToSettle) this.resize(gameSize);
        });
        // Initial setup
        this.resize(this.scale.gameSize);
        // Modern dark background that covers entire game area
        const bg = this.add.rectangle(this.gameWidth / 2, this.gameHeight / 2, this.gameWidth, this.gameHeight, 0x1a1a2e);
        bg.setDepth(-1);
        // Calculate margin once for use throughout
        this.margin = Math.min(this.gameWidth, this.gameHeight) * this.marginMultiplier;
        // Playfield with neon effect
        this.playfield = this.add.graphics();
        this.playfield.lineStyle(4, 0x2ecc71);
        this.playfield.strokeRect(this.margin, this.margin, this.gameWidth - this.margin * 2, this.gameHeight - this.margin * 2);
        // Set physics bounds
        this.matter.world.setBounds(this.margin, this.margin, this.gameWidth - this.margin * 2, this.gameHeight - this.margin * 2, 32, {
            restitution: 0.8,
            friction: 0.05
        });
        this.matter.world.setGravity(0, 0);
        // Setup game objects
        this.setupGameObjects();
        try {
            // Add mute button
            const muteButton = this.add.text(this.gameWidth - 100, 16, "\uD83D\uDD0A", {
                fontSize: '32px',
                padding: {
                    x: 10,
                    y: 5
                },
                backgroundColor: '#00000066'
            }).setInteractive().setDepth(1000);
            muteButton.on('pointerdown', ()=>{
                this.soundEnabled = !this.soundEnabled;
                if (this.soundEnabled) {
                    muteButton.setText("\uD83D\uDD0A");
                    this.masterGain.gain.value = 0.3;
                    this.playSound('bgMusic');
                } else {
                    muteButton.setText("\uD83D\uDD08");
                    this.masterGain.gain.value = 0;
                }
            });
            // Start background music
            if (this.soundEnabled) this.playSound('bgMusic');
        } catch (error) {
            console.warn('Audio setup failed:', error);
        // Game can continue without audio
        }
        // Setup input handlers
        this.setupInputHandlers();
    }
    setupGameObjects() {
        // Black hole with silver glow
        const holeY = this.margin + (this.gameHeight - this.margin * 2) * 0.2;
        this.hole = this.add.circle(this.gameWidth / 2, holeY, 25, 0x000000);
        this.holeGlow = this.add.circle(this.gameWidth / 2, holeY, 30, 0xC0C0C0, 0.4);
        this.holeGlow2 = this.add.circle(this.gameWidth / 2, holeY, 35, 0xC0C0C0, 0.2);
        this.holeRim = this.add.circle(this.gameWidth / 2, holeY, 25, 0xC0C0C0);
        this.holeRim.setStrokeStyle(2, 0xFFFFFF, 0.8);
        // Add physics to the hole with collision filtering
        this.holeBody = this.matter.add.circle(this.gameWidth / 2, holeY, 25, {
            label: 'hole',
            restitution: 0.8,
            friction: 0.005,
            frictionAir: 0.001,
            density: 0.01,
            collisionFilter: {
                category: 0x0002,
                mask: 0x0001 // Only collide with walls
            }
        });
        // Set up collision categories for walls by recreating the bounds
        const margin = Math.min(this.gameWidth, this.gameHeight) * this.marginMultiplier;
        this.matter.world.remove(this.matter.world.walls);
        this.matter.world.setBounds(margin, margin, this.gameWidth - margin * 2, this.gameHeight - margin * 2, 32, {
            label: 'wall',
            isStatic: true,
            collisionFilter: {
                category: 0x0001,
                mask: 0xFFFF // Collide with everything
            }
        });
        // Set up collision handling
        this.matter.world.on('collisionstart', (event)=>{
            event.pairs.forEach((pair)=>{
                const bodyA = pair.bodyA;
                const bodyB = pair.bodyB;
                // Ball-to-queen collision
                if (bodyA.label === 'Circle Body' && bodyB.label === 'queen' || bodyA.label === 'queen' && bodyB.label === 'Circle Body') {
                    const ball = bodyA.label === 'Circle Body' ? bodyA : bodyB;
                    const queen = bodyA.label === 'queen' ? bodyA : bodyB;
                    // Apply bounce effect
                    const velocity = ball.velocity;
                    const speed = Math.sqrt(velocity.x * velocity.x + velocity.y * velocity.y);
                    if (speed > 0.5) {
                        // Find the queen object
                        const queenObj = this.queens.find((q)=>q.body === queen);
                        if (queenObj && !queenObj.hit) {
                            queenObj.hit = true;
                            this.queensHit++;
                            this.queensHitThisFling++;
                            this.playSound('queenHit');
                            // Animate the queen
                            this.tweens.add({
                                targets: [
                                    queenObj.graphics,
                                    queenObj.glow
                                ],
                                alpha: 0,
                                scale: 1.5,
                                duration: 500,
                                onComplete: ()=>{
                                    if (queenObj.body) {
                                        this.matter.world.remove(queenObj.body);
                                        queenObj.body = null;
                                    }
                                    queenObj.graphics.destroy();
                                    queenObj.glow.destroy();
                                }
                            });
                        }
                    }
                }
                // Ball-to-ball collision
                if (bodyA.label === 'Circle Body' && bodyB.label === 'Circle Body') {
                    const velocity = Math.sqrt(Math.pow(bodyA.velocity.x - bodyB.velocity.x, 2) + Math.pow(bodyA.velocity.y - bodyB.velocity.y, 2));
                    const currentTime = Date.now();
                    if (velocity > 1 && currentTime - this.lastBallHitTime > 100) {
                        this.playSound('ballHit');
                        this.lastBallHitTime = currentTime;
                    }
                }
            });
        });
        // Create queens
        this.createQueens();
        // Create balls
        const colors = [
            0xff2d55,
            0x2ecc71,
            0x007aff,
            0xaf52de,
            0xffd60a
        ];
        this.resetBalls(colors);
        // Create UI elements
        this.createUI();
    }
    createUI() {
        // Modern UI
        this.scoreText = this.add.text(16, 16, 'Balls: 0/5', {
            fontSize: '24px',
            fill: '#fff',
            fontFamily: 'Arial',
            padding: {
                x: 10,
                y: 5
            },
            backgroundColor: '#00000066'
        });
        this.queensText = this.add.text(16, 56, `Queens hit: 0/${this.totalQueens}`, {
            fontSize: '24px',
            fill: '#fff',
            fontFamily: 'Arial',
            padding: {
                x: 10,
                y: 5
            },
            backgroundColor: '#00000066'
        });
        this.flingText = this.add.text(16, 96, 'Flings: 0', {
            fontSize: '24px',
            fill: '#fff',
            fontFamily: 'Arial',
            padding: {
                x: 10,
                y: 5
            },
            backgroundColor: '#00000066'
        });
        // High scores button with neon effect
        const scoresButton = this.add.text(650, 16, 'High Scores', {
            fontSize: '20px',
            fill: '#fff',
            backgroundColor: '#00000066',
            padding: {
                x: 10,
                y: 5
            }
        }).setInteractive();
        // Add hover effect
        scoresButton.on('pointerover', ()=>{
            scoresButton.setScale(1.1);
        });
        scoresButton.on('pointerout', ()=>{
            scoresButton.setScale(1);
        });
        scoresButton.on('pointerdown', ()=>{
            this.showHighScores();
        });
        this.rubberBand = this.add.graphics();
    }
    calculatePlayAreaAndQueens() {
        const margin = Math.min(this.gameWidth, this.gameHeight) * 0.05;
        const playArea = (this.gameWidth - margin * 2) * (this.gameHeight - margin * 2);
        const baseArea = 480000; // Original base area
        const baseQueens = 10; // Doubled from 5 to 10 minimum queens
        // Calculate queens based on play area ratio, with min 14 and max 134 (doubled from 7 and 67)
        this.totalQueens = Math.min(134, Math.max(14, Math.round(2.66 * baseQueens * Math.sqrt(playArea / baseArea)) // Doubled multiplier from 1.33 to 2.66
        ));
        // Adjust maxDragDistance based on screen size
        this.maxDragDistance = Math.min(200, Math.max(150, Math.sqrt(playArea) * 0.15));
    }
    createQueens() {
        // Generate colors for all queens
        const queenColors = [];
        for(let i = 0; i < this.totalQueens; i++){
            const hue = i / this.totalQueens * 360;
            const color = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Display.Color.HSLToColor(hue / 360, 1, 0.7).color;
            queenColors.push(color);
        }
        const margin = Math.min(this.gameWidth, this.gameHeight) * (this.marginMultiplier * 2); // Double the base margin for queens
        const safeMargin = margin + 25; // Additional safety margin for queen size
        const minX = safeMargin;
        const maxX = this.gameWidth - safeMargin;
        const minY = safeMargin;
        const maxY = Math.min(this.gameHeight * 0.7, this.gameHeight - safeMargin * 2); // Keep queens in upper area with safe margin
        const positions = [];
        const minDistance = Math.min(100, Math.sqrt((maxX - minX) * (maxY - minY) / this.totalQueens) * 0.8);
        // Generate positions for all queens
        for(let i = 0; i < this.totalQueens; i++){
            let newPos;
            let validPosition = false;
            let attempts = 0;
            while(!validPosition && attempts < 100){
                attempts++;
                newPos = {
                    x: (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(minX, maxX),
                    y: (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(minY, maxY)
                };
                // Check distance from hole
                const holeDistance = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(newPos.x, newPos.y, this.hole.x, this.hole.y);
                // Check distance from ball spawn area
                const ballSpawnDistance = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(newPos.x, newPos.y, this.gameWidth / 2, this.gameHeight * 0.8);
                // Check distance from other queens
                let tooClose = false;
                for (const pos of positions){
                    const distance = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(newPos.x, newPos.y, pos.x, pos.y);
                    if (distance < minDistance) {
                        tooClose = true;
                        break;
                    }
                }
                if (holeDistance > minDistance * 1.5 && ballSpawnDistance > minDistance * 1.5 && !tooClose) {
                    validPosition = true;
                    positions.push(newPos);
                }
            }
            if (!validPosition) {
                // Fallback position using grid layout
                const cols = Math.ceil(Math.sqrt(this.totalQueens));
                const rows = Math.ceil(this.totalQueens / cols);
                const col = i % cols;
                const row = Math.floor(i / cols);
                positions.push({
                    x: minX + (col + 0.5) * (maxX - minX) / cols,
                    y: minY + (row + 0.5) * (maxY - minY) / rows
                });
            }
        }
        // Create queens at calculated positions
        positions.forEach((pos, i)=>{
            // Create container for queen graphics
            const container = this.add.container(pos.x, pos.y);
            // Scale crown size based on screen size
            const crownSize = Math.min(20, Math.max(15, Math.sqrt(this.gameWidth * this.gameHeight) * 0.02));
            // Create queen crown graphics
            const queen = this.add.graphics();
            queen.lineStyle(3, queenColors[i]);
            queen.fillStyle(queenColors[i], 0.8);
            queen.beginPath();
            queen.moveTo(-crownSize, 0);
            queen.lineTo(-crownSize * 0.75, -crownSize * 0.75);
            queen.lineTo(-crownSize * 0.25, -crownSize * 0.25);
            queen.lineTo(crownSize * 0.25, -crownSize * 0.75);
            queen.lineTo(crownSize * 0.75, -crownSize * 0.25);
            queen.lineTo(crownSize, 0);
            queen.closePath();
            queen.strokePath();
            queen.fillPath();
            // Create glow effect
            const queenGlow = this.add.circle(0, 0, crownSize * 1.25, queenColors[i], 0.3);
            // Add graphics to container
            container.add([
                queenGlow,
                queen
            ]);
            // Create physics body with collision filtering
            const physicsBody = this.matter.add.circle(pos.x, pos.y, crownSize, {
                isStatic: true,
                label: 'queen',
                restitution: 0.8,
                friction: 0.05,
                collisionFilter: {
                    category: 0x0004,
                    mask: 0x0004 // Only collide with balls
                }
            });
            this.queens.push({
                container: container,
                graphics: queen,
                glow: queenGlow,
                body: physicsBody,
                hit: false,
                color: queenColors[i],
                position: pos
            });
        });
    }
    resetBalls(colors) {
        this.balls.forEach((ball)=>{
            if (ball.graphics) ball.graphics.destroy();
            if (ball.glow) ball.glow.destroy();
            if (ball.highlight) ball.highlight.destroy();
            if (ball.body) this.matter.world.remove(ball.body);
        });
        this.balls = [];
        const margin = Math.min(this.gameWidth, this.gameHeight) * 0.05;
        const startX = this.gameWidth / 2;
        const startY = this.gameHeight - margin - 50; // 50px above bottom margin
        colors.forEach((color, i)=>{
            // Ensure balls don't spawn beyond margins
            const ballX = Math.min(Math.max(startX + (i - 2) * 40, margin + 20), this.gameWidth - margin - 20);
            const ball = this.add.circle(ballX, startY, 15, color);
            const glow = this.add.circle(ballX, startY, 18, color, 0.3);
            const highlight = this.add.circle(ballX, startY, 20, color, 0);
            highlight.setStrokeStyle(3, color);
            highlight.setVisible(false);
            const physicsBody = this.matter.add.circle(startX + (i - 2) * 40, startY, 15, {
                label: 'Circle Body',
                restitution: 0.8,
                friction: 0.05,
                density: 0.005,
                frictionAir: 0.003,
                collisionFilter: {
                    category: 0x0004,
                    mask: 0x0005 // Collide with walls (0x0001) and other balls/queens (0x0004)
                }
            });
            this.balls.push({
                graphics: ball,
                glow: glow,
                highlight: highlight,
                body: physicsBody,
                color: color,
                moving: false,
                used: false
            });
        });
        // Set initial active ball
        this.setActiveBall(0);
    }
    setActiveBall(index) {
        // Hide highlight on all balls
        this.balls.forEach((ball)=>{
            if (ball.highlight) {
                ball.highlight.setVisible(false);
                this.tweens.killTweensOf(ball.highlight);
            }
        });
        // Find next valid ball starting from the given index
        let nextIndex = index;
        let loopCount = 0;
        let foundBall = null;
        while(loopCount < this.balls.length){
            if (nextIndex >= this.balls.length) nextIndex = 0;
            const ball = this.balls[nextIndex];
            if (ball && !ball.used && !ball.inHole && ball.body && !ball.moving) {
                foundBall = ball;
                break;
            }
            nextIndex++;
            loopCount++;
        }
        // If we found a valid ball, make it active
        if (foundBall) {
            this.currentBallIndex = nextIndex;
            if (foundBall.highlight) {
                this.tweens.killTweensOf(foundBall.highlight);
                foundBall.highlight.setVisible(true);
                foundBall.highlight.setScale(1);
                foundBall.highlight.setAlpha(1);
                this.tweens.add({
                    targets: foundBall.highlight,
                    scaleX: 1.2,
                    scaleY: 1.2,
                    alpha: 0.8,
                    duration: 600,
                    yoyo: true,
                    repeat: -1,
                    ease: 'Sine.easeInOut'
                });
            }
        } else this.currentBallIndex = -1;
    }
    findClosestBall(pointer) {
        // Only allow interaction with the current active ball
        const ball = this.balls[this.currentBallIndex];
        if (ball && !ball.used && !ball.moving) {
            const distance = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(ball.graphics.x, ball.graphics.y, pointer.x, pointer.y);
            if (distance < 30) return ball;
        }
        return null;
    }
    constrainDragPoint(pointer, ballPos) {
        const angle = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Angle.Between(ballPos.x, ballPos.y, pointer.x, pointer.y);
        const distance = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(ballPos.x, ballPos.y, pointer.x, pointer.y);
        const constrainedDistance = Math.min(distance, this.maxDragDistance);
        return {
            x: ballPos.x + Math.cos(angle) * constrainedDistance,
            y: ballPos.y + Math.sin(angle) * constrainedDistance
        };
    }
    setupInputHandlers() {
        // Remove any existing listeners first
        this.input.removeAllListeners('pointerdown');
        this.input.removeAllListeners('pointermove');
        this.input.removeAllListeners('pointerup');
        this.input.removeAllListeners('pointerout');
        // Handle both mouse and touch input
        const startDrag = (pointer)=>{
            if (this.gameEnded || this.waitingForBallsToSettle) return;
            const closestBall = this.findClosestBall(pointer);
            if (closestBall) {
                this.isDragging = true;
                this.activeBall = closestBall;
                this.matter.body.setStatic(this.activeBall.body, true);
            }
        };
        const moveDrag = (pointer)=>{
            if (!this.isDragging || !this.activeBall) return;
            const ballPos = {
                x: this.activeBall.graphics.x,
                y: this.activeBall.graphics.y
            };
            const constrainedPoint = this.constrainDragPoint(pointer, ballPos);
            this.rubberBand.clear();
            this.rubberBand.lineStyle(2, 0xffffff);
            this.rubberBand.beginPath();
            this.rubberBand.moveTo(ballPos.x, ballPos.y);
            this.rubberBand.lineTo(constrainedPoint.x, constrainedPoint.y);
            this.rubberBand.strokePath();
        };
        const endDrag = (pointer)=>{
            if (!this.isDragging || !this.activeBall) return;
            const ballPos = {
                x: this.activeBall.graphics.x,
                y: this.activeBall.graphics.y
            };
            const constrainedPoint = this.constrainDragPoint(pointer, ballPos);
            const angle = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Angle.Between(constrainedPoint.x, constrainedPoint.y, ballPos.x, ballPos.y);
            const power = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(ballPos.x, ballPos.y, constrainedPoint.x, constrainedPoint.y) / this.maxDragDistance;
            const force = {
                x: Math.cos(angle) * power * 25,
                y: Math.sin(angle) * power * 25
            };
            // Store the sling direction for hole movement
            this.lastSlingAngle = angle;
            this.lastSlingPower = power;
            this.matter.body.setStatic(this.activeBall.body, false);
            this.matter.body.setVelocity(this.activeBall.body, force);
            this.activeBall.moving = true;
            this.activeBall.used = true;
            // Stop the highlight animation and hide it
            if (this.activeBall.highlight) {
                this.tweens.killTweensOf(this.activeBall.highlight);
                this.activeBall.highlight.setVisible(false);
            }
            this.rubberBand.clear();
            this.isDragging = false;
            this.activeBall = null;
            // Reset queens hit counter for new fling
            this.queensHitThisFling = 0;
            // Increment fling counter
            this.flingCount++;
            this.flingText.setText(`Flings: ${this.flingCount}`);
            // Start waiting for balls to settle
            this.waitingForBallsToSettle = true;
        };
        // Add new input handlers
        this.input.on('pointerdown', startDrag);
        this.input.on('pointermove', moveDrag);
        this.input.on('pointerup', endDrag);
        this.input.on('pointerout', endDrag);
    }
    showHighScores() {
        // Clear any existing score texts
        this.scoreTexts.forEach((text)=>text.destroy());
        this.scoreTexts = [];
        // Create modern semi-transparent backdrop with gradient
        const bgGradient = this.add.graphics();
        bgGradient.fillGradientStyle(0x000000, 0x000000, 0x162447, 0x162447, 0.9);
        bgGradient.fillRect(200, 100, 400, 400);
        this.scoreTexts.push(bgGradient);
        // Add neon border
        const border = this.add.graphics();
        border.lineStyle(4, 0x2ecc71, 0.8);
        border.strokeRect(200, 100, 400, 400);
        this.scoreTexts.push(border);
        // Title with neon effect
        const titleGlow = this.add.text(400, 150, 'High Scores', {
            fontSize: '36px',
            fontFamily: 'Arial',
            fill: '#fff',
            stroke: '#2ecc71',
            strokeThickness: 8
        }).setOrigin(0.5).setAlpha(0.4);
        const title = this.add.text(400, 150, 'High Scores', {
            fontSize: '36px',
            fontFamily: 'Arial',
            fill: '#fff'
        }).setOrigin(0.5);
        this.scoreTexts.push(titleGlow, title);
        // Sort scores by flings (lower is better)
        const sortedScores = [
            ...this.highScores
        ].sort((a, b)=>a.flings - b.flings);
        sortedScores.slice(0, 5).forEach((score, i)=>{
            const y = 220 + i * 45;
            // Score background
            const scoreBg = this.add.rectangle(400, y, 300, 35, 0x2ecc71, 0.1);
            this.scoreTexts.push(scoreBg);
            // Score text with glow
            const scoreGlow = this.add.text(400, y, `${i + 1}. ${score.name}: ${score.flings} flings`, {
                fontSize: '24px',
                fontFamily: 'Arial',
                fill: '#fff',
                stroke: '#2ecc71',
                strokeThickness: 4
            }).setOrigin(0.5).setAlpha(0.4);
            const scoreText = this.add.text(400, y, `${i + 1}. ${score.name}: ${score.flings} flings`, {
                fontSize: '24px',
                fontFamily: 'Arial',
                fill: '#fff'
            }).setOrigin(0.5);
            this.scoreTexts.push(scoreGlow, scoreText);
        });
        // Modern close button with neon effect
        const closeBtn = this.add.container(400, 450);
        const closeBtnBg = this.add.rectangle(0, 0, 100, 40, 0x2ecc71, 0.2);
        const closeBtnGlow = this.add.text(0, 0, 'Close', {
            fontSize: '24px',
            fontFamily: 'Arial',
            fill: '#fff',
            stroke: '#2ecc71',
            strokeThickness: 4
        }).setOrigin(0.5).setAlpha(0.4);
        const closeBtnText = this.add.text(0, 0, 'Close', {
            fontSize: '24px',
            fontFamily: 'Arial',
            fill: '#fff'
        }).setOrigin(0.5);
        closeBtn.add([
            closeBtnBg,
            closeBtnGlow,
            closeBtnText
        ]);
        closeBtn.setSize(100, 40);
        closeBtn.setInteractive();
        // Hover effects
        closeBtn.on('pointerover', ()=>{
            closeBtnBg.setFillStyle(0x2ecc71, 0.3);
            closeBtn.setScale(1.05);
        });
        closeBtn.on('pointerout', ()=>{
            closeBtnBg.setFillStyle(0x2ecc71, 0.2);
            closeBtn.setScale(1);
        });
        closeBtn.on('pointerdown', ()=>{
            this.scoreTexts.forEach((text)=>text.destroy());
            this.scoreTexts = [];
        });
        this.scoreTexts.push(closeBtn);
    }
    promptForName() {
        // Create input element
        const nameInput = document.createElement('input');
        nameInput.type = 'text';
        nameInput.placeholder = 'Enter your name';
        nameInput.style.position = 'absolute';
        nameInput.style.left = '50%';
        nameInput.style.top = '50%';
        nameInput.style.transform = 'translate(-50%, -50%)';
        nameInput.style.fontSize = '24px';
        nameInput.style.padding = '10px';
        nameInput.style.width = '200px';
        nameInput.style.textAlign = 'center';
        nameInput.maxLength = 15;
        document.body.appendChild(nameInput);
        nameInput.focus();
        nameInput.addEventListener('keypress', (e)=>{
            if (e.key === 'Enter') {
                const name = nameInput.value.trim() || 'Anonymous';
                this.saveScore(name);
                nameInput.remove();
                this.showHighScores();
            }
        });
    }
    saveScore(name) {
        this.highScores.push({
            name: name,
            flings: this.flingCount,
            date: new Date().toISOString()
        });
        // Keep only top 100 scores
        this.highScores.sort((a, b)=>a.flings - b.flings);
        if (this.highScores.length > 100) this.highScores.pop();
        localStorage.setItem('colorFlingerScores', JSON.stringify(this.highScores));
    }
    showSlayMessage(count) {
        let message = '';
        let color = '';
        let scale = 1;
        switch(count){
            case 2:
                message = "DOUBLE COLLECT! \uD83D\uDC85";
                color = '#ff69b4';
                scale = 0.9;
                break;
            case 3:
                message = "TRIPLE COLLECT! \uD83D\uDC51";
                color = '#ff1493';
                scale = 1.0;
                break;
            case 4:
                message = "QUADRA COLLECT! \u2728";
                color = '#ff00ff';
                scale = 1.1;
                break;
            case 5:
                message = "PENTA COLLECT!!! \uD83C\uDF1F";
                color = '#ff00ff';
                scale = 1.2;
                break;
        }
        if (message) {
            this.playSound('multiSlay');
            // Create flash effect
            const flash = this.add.rectangle(0, 0, this.gameWidth, this.gameHeight, 0xffffff);
            flash.setAlpha(0.3);
            flash.setDepth(999);
            this.tweens.add({
                targets: flash,
                alpha: 0,
                duration: 200,
                ease: 'Power2',
                onComplete: ()=>flash.destroy()
            });
            // Calculate center position
            const centerX = this.gameWidth / 2;
            const centerY = this.gameHeight / 2;
            // Adjust font size based on screen width
            const baseFontSize = Math.min(48, Math.max(24, this.gameWidth * 0.08));
            // Create outer glow
            const outerGlow = this.add.text(centerX, centerY, message, {
                fontSize: `${baseFontSize}px`,
                fontFamily: 'Arial',
                fill: '#fff',
                stroke: color,
                strokeThickness: 16,
                shadow: {
                    blur: 8,
                    color: color,
                    fill: true
                },
                align: 'center'
            }).setOrigin(0.5).setAlpha(0.4).setScale(scale).setDepth(1000);
            // Create inner glow
            const glow = this.add.text(centerX, centerY, message, {
                fontSize: `${baseFontSize}px`,
                fontFamily: 'Arial',
                fill: '#fff',
                stroke: color,
                strokeThickness: 12,
                shadow: {
                    blur: 6,
                    color: color,
                    fill: true
                },
                align: 'center'
            }).setOrigin(0.5).setAlpha(0.6).setScale(scale);
            // Create main text
            const text = this.add.text(centerX, centerY, message, {
                fontSize: `${baseFontSize}px`,
                fontFamily: 'Arial',
                fill: color,
                stroke: '#000',
                strokeThickness: 3,
                align: 'center'
            }).setOrigin(0.5).setScale(scale);
            // Add blend effects
            text.setBlendMode((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).BlendModes.ADD);
            glow.setBlendMode((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).BlendModes.SCREEN);
            outerGlow.setBlendMode((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).BlendModes.SCREEN);
            // Create a smoother animation
            this.tweens.add({
                targets: [
                    text,
                    glow,
                    outerGlow
                ],
                scaleX: scale * 1.2,
                scaleY: scale * 1.2,
                y: centerY - 20,
                alpha: {
                    from: 1,
                    to: 0
                },
                duration: 1500,
                ease: 'Cubic.easeOut',
                onComplete: ()=>{
                    text.destroy();
                    glow.destroy();
                    outerGlow.destroy();
                }
            });
        }
    }
    moveHoleRandomly() {
        const margin = Math.min(this.gameWidth, this.gameHeight) * 0.05;
        const minX = margin;
        const maxX = this.gameWidth - margin;
        const minY = margin;
        const maxY = this.gameHeight * 0.7;
        let validPosition = false;
        let newX, newY;
        let attempts = 0;
        // If we have a sling direction, use it to determine hole velocity
        if (this.lastSlingAngle !== undefined && this.lastSlingPower !== undefined) {
            // Calculate velocity based on power and screen size
            const baseSpeed = Math.min(this.gameWidth, this.gameHeight) * 0.015 * this.lastSlingPower;
            const velocityX = Math.cos(this.lastSlingAngle) * baseSpeed;
            const velocityY = Math.sin(this.lastSlingAngle) * baseSpeed;
            // Apply velocity to hole
            this.matter.body.setVelocity(this.holeBody, {
                x: velocityX,
                y: velocityY
            });
            // Clear the sling direction after use
            this.lastSlingAngle = undefined;
            this.lastSlingPower = undefined;
            // Add flash effect
            const flash = this.add.circle(this.hole.x, this.hole.y, 40, 0xC0C0C0, 0.5);
            this.tweens.add({
                targets: flash,
                alpha: 0,
                scale: 2,
                duration: 500,
                onComplete: ()=>flash.destroy()
            });
        }
    }
    showGameOver(isWin = false) {
        this.gameEnded = true;
        if (isWin) this.playSound('multiSlay');
        else // Play a sad trombone sound for losing
        this.playSound('gameOver');
        // Stop any ongoing physics and animations
        this.matter.world.enabled = false;
        this.tweens.killAll();
        // Clean up any existing input handlers
        this.input.removeAllListeners();
        // Clean up all balls
        this.balls.forEach((ball)=>{
            if (ball.graphics) ball.graphics.destroy();
            if (ball.glow) ball.graphics.destroy();
            if (ball.highlight) ball.highlight.destroy();
            if (ball.body) this.matter.world.remove(ball.body);
        });
        this.balls = [];
        // Clean up all queens
        this.queens.forEach((queen)=>{
            if (queen.container) queen.container.destroy();
            if (queen.body) this.matter.world.remove(queen.body);
        });
        this.queens = [];
        // Create backdrop with gradient
        const backdrop = this.add.graphics();
        backdrop.fillGradientStyle(0x000000, 0x000000, 0x162447, 0x162447, 0.95);
        backdrop.fillRect(0, 0, this.gameWidth, this.gameHeight);
        let message, color;
        if (isWin) {
            message = "YASSS QUEEN! \uD83D\uDC51\nAll Queens Collected!";
            color = '#ff1493';
            // Create particle effect for win using new Phaser 3.60+ API
            const particles = this.add.particles(0, 0, 'particle', {
                x: this.gameWidth / 2,
                y: this.gameHeight / 2,
                speed: {
                    min: 100,
                    max: 200
                },
                angle: {
                    min: 0,
                    max: 360
                },
                scale: {
                    start: 0.5,
                    end: 0
                },
                blendMode: 'ADD',
                lifespan: 1000,
                gravityY: 50,
                frequency: 50,
                quantity: 2,
                emitting: true
            });
            // Stop emitting after 3 seconds
            this.time.delayedCall(3000, ()=>{
                particles.stop();
            });
        } else {
            message = "GAME OVER\nYou dropped the ball(s)! \uD83E\uDD21";
            color = '#ff0000';
            // Create funny "womp womp" particle effects for losing
            const failParticles = this.add.particles(0, 0, 'particle', {
                x: {
                    min: 0,
                    max: this.gameWidth
                },
                y: -50,
                speedY: {
                    min: 200,
                    max: 300
                },
                speedX: {
                    min: -50,
                    max: 50
                },
                angle: 90,
                scale: {
                    start: 0.7,
                    end: 0
                },
                tint: [
                    0xff0000,
                    0xff6666,
                    0xff9999
                ],
                blendMode: 'ADD',
                lifespan: 2000,
                gravityY: 300,
                frequency: 100,
                quantity: 1,
                emitting: true
            });
            // Add some bouncing sad emojis
            const emojis = [
                "\uD83D\uDE2D",
                "\uD83D\uDE22",
                "\uD83D\uDE2A",
                "\uD83E\uDD26\u200D\u2642\uFE0F",
                "\uD83E\uDD26\u200D\u2640\uFE0F"
            ];
            emojis.forEach((emoji, i)=>{
                const x = this.gameWidth * (0.3 + i * 0.1);
                const y = this.gameHeight * 0.3;
                const emojiText = this.add.text(x, y, emoji, {
                    fontSize: '40px'
                }).setOrigin(0.5);
                // Make emojis bounce sadly
                this.tweens.add({
                    targets: emojiText,
                    y: y + 30,
                    duration: 1000 + i * 200,
                    yoyo: true,
                    repeat: -1,
                    ease: 'Bounce.easeOut'
                });
            });
            // Stop particles after 3 seconds
            this.time.delayedCall(3000, ()=>{
                failParticles.stop();
            });
        }
        // Create text with glow effect
        const textGlow = this.add.text(this.gameWidth / 2, this.gameHeight / 2 - 50, message, {
            fontSize: '48px',
            fontFamily: 'Arial',
            align: 'center',
            fill: '#fff',
            stroke: color,
            strokeThickness: 16,
            shadow: {
                blur: 8,
                color: color,
                fill: true
            }
        }).setOrigin(0.5).setAlpha(0.4);
        const text = this.add.text(this.gameWidth / 2, this.gameHeight / 2 - 50, message, {
            fontSize: '48px',
            fontFamily: 'Arial',
            align: 'center',
            fill: color,
            stroke: '#000',
            strokeThickness: 3
        }).setOrigin(0.5);
        // Create restart button with neon effect
        const buttonWidth = 200;
        const buttonHeight = 60;
        const buttonX = this.gameWidth / 2;
        const buttonY = this.gameHeight / 2 + 50;
        const buttonContainer = this.add.container(buttonX, buttonY);
        const buttonBg = this.add.rectangle(0, 0, buttonWidth, buttonHeight, 0x2ecc71, 0.2);
        const buttonGlow = this.add.rectangle(0, 0, buttonWidth + 10, buttonHeight + 10, 0x2ecc71, 0.1);
        const buttonTextGlow = this.add.text(0, 0, 'Try Again', {
            fontSize: '32px',
            fontFamily: 'Arial',
            fill: '#fff',
            stroke: '#2ecc71',
            strokeThickness: 8
        }).setOrigin(0.5).setAlpha(0.4);
        const buttonText = this.add.text(0, 0, 'Try Again', {
            fontSize: '32px',
            fontFamily: 'Arial',
            fill: '#fff'
        }).setOrigin(0.5);
        buttonContainer.add([
            buttonGlow,
            buttonBg,
            buttonTextGlow,
            buttonText
        ]);
        buttonContainer.setSize(buttonWidth, buttonHeight);
        buttonContainer.setInteractive();
        // Add hover effects
        buttonContainer.on('pointerover', ()=>{
            buttonBg.setFillStyle(0x2ecc71, 0.3);
            buttonContainer.setScale(1.05);
        });
        buttonContainer.on('pointerout', ()=>{
            buttonBg.setFillStyle(0x2ecc71, 0.2);
            buttonContainer.setScale(1);
        });
        // Add click handler
        buttonContainer.on('pointerdown', ()=>{
            // Clean up game over elements
            backdrop.destroy();
            text.destroy();
            textGlow.destroy();
            buttonContainer.destroy();
            // Re-enable physics for the new game
            this.matter.world.enabled = true;
            // Reset all game state variables
            this.gameEnded = false;
            this.waitingForBallsToSettle = false;
            if (this.ballSettleTimeout) {
                clearTimeout(this.ballSettleTimeout);
                this.ballSettleTimeout = null;
            }
            // Reset game state and restart scene
            this.scene.restart();
        });
        // Add animation
        this.tweens.add({
            targets: [
                text,
                textGlow
            ],
            y: text.y - 10,
            duration: 1500,
            yoyo: true,
            repeat: -1,
            ease: 'Sine.inOut'
        });
    }
    checkBallsSettled() {
        let allSettled = true;
        let anyMoving = false;
        this.balls.forEach((ball)=>{
            if (!ball.body) return;
            const velocity = ball.body.velocity;
            const speed = Math.sqrt(velocity.x * velocity.x + velocity.y * velocity.y);
            if (speed > 0.1) {
                allSettled = false;
                anyMoving = true;
                ball.moving = true;
            } else ball.moving = false;
        });
        if (allSettled && this.waitingForBallsToSettle) {
            this.waitingForBallsToSettle = false;
            // Clear any existing timeout
            if (this.ballSettleTimeout) {
                clearTimeout(this.ballSettleTimeout);
                this.ballSettleTimeout = null;
            }
            // Only switch to next ball if current ball was used
            if (this.currentBallIndex !== -1 && this.balls[this.currentBallIndex] && this.balls[this.currentBallIndex].used) {
                let nextIndex = this.currentBallIndex + 1;
                this.setActiveBall(nextIndex);
            }
        } else if (anyMoving && this.waitingForBallsToSettle) {
            // Reset the timeout if any ball is still moving
            if (this.ballSettleTimeout) clearTimeout(this.ballSettleTimeout);
            this.ballSettleTimeout = setTimeout(()=>{
                this.checkBallsSettled();
            }, 500);
        }
    }
    validateAndFixGameState() {
        // Check if we have any balls left but no active ball
        const remainingBalls = this.balls.filter((ball)=>ball.body !== null);
        const validBalls = this.balls.filter((ball)=>!ball.used && !ball.inHole && ball.body);
        const hasActiveBall = this.currentBallIndex >= 0 && this.currentBallIndex < this.balls.length && this.balls[this.currentBallIndex] && !this.balls[this.currentBallIndex].inHole && !this.balls[this.currentBallIndex].used;
        console.log('Game State Validation:', {
            remainingBalls: remainingBalls.length,
            validBalls: validBalls.length,
            currentIndex: this.currentBallIndex,
            waitingForSettle: this.waitingForBallsToSettle,
            hasActiveBall: hasActiveBall,
            queensHit: this.queensHit,
            totalQueens: this.totalQueens
        });
        // Check for win condition first
        if (!this.gameEnded && this.queensHit === this.totalQueens) {
            this.showGameOver(true);
            return;
        }
        // Only check for lose condition if no balls remain at all
        if (!this.gameEnded && remainingBalls.length === 0 && validBalls.length === 0) {
            const remainingQueens = this.queens.filter((queen)=>!queen.hit).length;
            if (remainingQueens > 0) {
                this.showGameOver(false);
                return;
            }
        }
        if (remainingBalls.length > 0) {
            // If we have balls but none are valid, reset their states
            if (validBalls.length === 0) {
                console.log('Rescuing game state - resetting ball states');
                remainingBalls.forEach((ball)=>{
                    if (!ball.inHole) {
                        ball.used = false;
                        ball.moving = false;
                    }
                });
                // Force settle state to false
                this.waitingForBallsToSettle = false;
                if (this.ballSettleTimeout) {
                    clearTimeout(this.ballSettleTimeout);
                    this.ballSettleTimeout = null;
                }
                // Try to set active ball again
                this.setActiveBall(0);
            } else if (!hasActiveBall) {
                console.log('Rescuing game state - setting active ball');
                this.setActiveBall(0);
            }
        }
    }
    update() {
        // Periodically validate game state (every 2 seconds)
        const currentTime = Date.now();
        if (currentTime - this.lastStateCheck > 2000) {
            this.validateAndFixGameState();
            this.lastStateCheck = currentTime;
        }
        // Check for game over condition
        if (!this.gameEnded) {
            const unusedBalls = this.balls.filter((ball)=>!ball.used && !ball.inHole && ball.body);
            const movingBalls = this.balls.filter((ball)=>ball.body && ball.moving);
            const remainingQueens = this.queens.filter((queen)=>!queen.hit).length;
            // Win condition: All queens are slayed
            if (this.queensHit === this.totalQueens && !this.gameEnded) {
                this.showGameOver(true); // Won - all queens hit
                return;
            }
            // Lose condition: No balls left to use AND queens still remain
            if (unusedBalls.length === 0 && movingBalls.length === 0 && remainingQueens > 0) {
                const remainingBalls = this.balls.filter((ball)=>ball.body !== null);
                if (remainingBalls.length === 0) this.showGameOver(false); // Lost - queens remain and no balls left
            }
        }
        // Update hole position based on physics body
        if (this.holeBody && this.hole) {
            this.hole.setPosition(this.holeBody.position.x, this.holeBody.position.y);
            this.holeGlow.setPosition(this.holeBody.position.x, this.holeBody.position.y);
            this.holeGlow2.setPosition(this.holeBody.position.x, this.holeBody.position.y);
            this.holeRim.setPosition(this.holeBody.position.x, this.holeBody.position.y);
            // Check if active ball is eaten by hole
            if (this.currentBallIndex !== -1 && this.balls[this.currentBallIndex]) {
                const ball = this.balls[this.currentBallIndex];
                if (ball.body && !ball.inHole) {
                    const distanceToHole = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(ball.graphics.x, ball.graphics.y, this.hole.x, this.hole.y);
                    if (distanceToHole < 25) {
                        // Play nom nom sound
                        this.playSound('nomNom');
                        // Mark ball as in hole
                        ball.inHole = true;
                        this.ballsInHole++;
                        this.scoreText.setText(`Balls: ${this.ballsInHole}/5`);
                        // Add hole consumption effect
                        const consumeEffect = this.add.circle(ball.graphics.x, ball.graphics.y, 15, ball.color);
                        this.tweens.add({
                            targets: consumeEffect,
                            x: this.hole.x,
                            y: this.hole.y,
                            scale: 0.1,
                            alpha: 0,
                            duration: 300,
                            ease: 'Power2',
                            onComplete: ()=>{
                                consumeEffect.destroy();
                            }
                        });
                        // Remove the ball
                        this.tweens.add({
                            targets: [
                                ball.graphics,
                                ball.glow
                            ],
                            alpha: 0,
                            scale: 0.1,
                            duration: 300,
                            onComplete: ()=>{
                                ball.graphics.destroy();
                                ball.glow.destroy();
                                if (ball.highlight) ball.highlight.destroy();
                                this.matter.world.remove(ball.body);
                                ball.body = null;
                                // Find next available ball
                                let nextBallFound = false;
                                for(let i = 0; i < this.balls.length; i++)if (!this.balls[i].inHole && !this.balls[i].used && this.balls[i].body) {
                                    this.setActiveBall(i);
                                    nextBallFound = true;
                                    break;
                                }
                                // If no balls available and queens still on field, game over
                                if (!nextBallFound) {
                                    const remainingQueens = this.queens.filter((queen)=>!queen.hit).length;
                                    if (remainingQueens > 0) this.showGameOver(false);
                                }
                            }
                        });
                        // Add silver flash effect to the hole
                        const flash = this.add.circle(this.hole.x, this.hole.y, 30, 0xC0C0C0, 0.6);
                        this.tweens.add({
                            targets: flash,
                            alpha: 0,
                            scale: 1.5,
                            duration: 400,
                            onComplete: ()=>flash.destroy()
                        });
                    }
                }
            }
        }
        // Update ball positions and check for stopping
        this.balls.forEach((ball)=>{
            if (!ball.body) return;
            ball.graphics.x = ball.body.position.x;
            ball.graphics.y = ball.body.position.y;
            ball.glow.x = ball.body.position.x;
            ball.glow.y = ball.body.position.y;
            if (ball.highlight) {
                ball.highlight.x = ball.body.position.x;
                ball.highlight.y = ball.body.position.y;
            }
            // Add velocity damping
            const velocity = ball.body.velocity;
            const speed = Math.sqrt(velocity.x * velocity.x + velocity.y * velocity.y);
            if (speed < 0.5) {
                // Stop the ball completely if it's moving very slowly
                this.matter.body.setVelocity(ball.body, {
                    x: 0,
                    y: 0
                });
                this.matter.body.setAngularVelocity(ball.body, 0);
                ball.moving = false;
            } else {
                // Ball is moving if it has any significant speed
                ball.moving = true;
                if (speed < 5) {
                    // Apply extra damping when ball is moving slowly
                    const damping = 0.95;
                    this.matter.body.setVelocity(ball.body, {
                        x: velocity.x * damping,
                        y: velocity.y * damping
                    });
                }
            }
            // Check if ball is in hole
            const distanceToHole = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(ball.graphics.x, ball.graphics.y, this.hole.x, this.hole.y);
            if (distanceToHole < 25 && !ball.inHole) {
                ball.inHole = true;
                this.ballsInHole++;
                this.scoreText.setText(`Balls: ${this.ballsInHole}/5`);
                // Add hole consumption effect with silver color
                const consumeEffect = this.add.circle(ball.graphics.x, ball.graphics.y, 15, ball.color);
                this.tweens.add({
                    targets: consumeEffect,
                    x: this.hole.x,
                    y: this.hole.y,
                    scale: 0.1,
                    alpha: 0,
                    duration: 300,
                    ease: 'Power2',
                    onComplete: ()=>{
                        consumeEffect.destroy();
                    }
                });
                // Remove the ball with fade out effect
                this.tweens.add({
                    targets: [
                        ball.graphics,
                        ball.glow
                    ],
                    alpha: 0,
                    scale: 0.1,
                    duration: 300,
                    onComplete: ()=>{
                        ball.graphics.destroy();
                        ball.glow.destroy();
                        this.matter.world.remove(ball.body);
                        ball.body = null;
                    }
                });
                // Add a silver flash effect to the hole
                const flash = this.add.circle(this.hole.x, this.hole.y, 30, 0xC0C0C0, 0.6);
                this.tweens.add({
                    targets: flash,
                    alpha: 0,
                    scale: 1.5,
                    duration: 400,
                    onComplete: ()=>flash.destroy()
                });
            }
        });
        // Update hole position based on physics body
        if (this.holeBody && this.hole) {
            this.hole.setPosition(this.holeBody.position.x, this.holeBody.position.y);
            this.holeGlow.setPosition(this.holeBody.position.x, this.holeBody.position.y);
            this.holeGlow2.setPosition(this.holeBody.position.x, this.holeBody.position.y);
            this.holeRim.setPosition(this.holeBody.position.x, this.holeBody.position.y);
        }
        // Check for queen hits from balls
        let queensHitThisFrame = [];
        this.queens.forEach((queen)=>{
            if (!queen.body) return; // Only skip if physics body is gone
            this.balls.forEach((ball)=>{
                if (!ball.body) return;
                // Get ball speed
                const velocity = ball.body.velocity;
                const speed = Math.sqrt(velocity.x * velocity.x + velocity.y * velocity.y);
                // Only check for hits if the ball is moving with enough speed
                if (speed > 0.5) {
                    const distance = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(ball.graphics.x, ball.graphics.y, queen.body.position.x, queen.body.position.y);
                    if (distance < 35 && !queen.hit) {
                        queen.hit = true;
                        queensHitThisFrame.push(queen);
                        this.playSound('queenHit');
                    }
                }
            });
        });
        // Process queen hits if any occurred
        if (queensHitThisFrame.length > 0) {
            // Update counters
            this.queensHit += queensHitThisFrame.length;
            this.queensHitThisFling += queensHitThisFrame.length;
            // Remove queens and check for color matches
            let shouldMoveHole = true;
            queensHitThisFrame.forEach((queen)=>{
                // Find the ball that hit this queen
                const hittingBall = this.balls.find((ball)=>{
                    if (!ball.body) return false;
                    const distance = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(ball.graphics.x, ball.graphics.y, queen.body.position.x, queen.body.position.y);
                    return distance < 35;
                });
                // Check if colors match
                if (hittingBall && hittingBall.color === queen.color) shouldMoveHole = false;
                // Keep physics body during animation but mark as hit
                queen.hit = true;
                // Animate the visuals
                this.tweens.add({
                    targets: [
                        queen.graphics,
                        queen.glow
                    ],
                    alpha: 0,
                    scale: 1.5,
                    duration: 500,
                    onComplete: ()=>{
                        // Remove physics body after animation completes
                        if (queen.body) {
                            this.matter.world.remove(queen.body);
                            queen.body = null;
                        }
                        queen.graphics.destroy();
                        queen.glow.destroy();
                    }
                });
            });
            // Move hole only if no color matches occurred
            if (shouldMoveHole) this.moveHoleRandomly();
            // Update the counter
            this.queensText.setText(`Queens hit: ${this.queensHit}/${this.totalQueens}`);
            // Show multi-slay message if we hit multiple queens in this fling
            if (this.queensHitThisFling >= 2) this.showSlayMessage(this.queensHitThisFling);
        }
        // Update queen positions and check for hole collisions
        this.queens.forEach((queen)=>{
            if (queen.body) {
                queen.container.setPosition(queen.body.position.x, queen.body.position.y);
                // Check if queen is touching the hole
                const distanceToHole = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Distance.Between(queen.body.position.x, queen.body.position.y, this.hole.x, this.hole.y);
                if (distanceToHole < 35 && !queen.hit) {
                    // Mark queen as hit
                    queen.hit = true;
                    this.queensHit++;
                    this.queensHitThisFling++;
                    this.queensText.setText(`Queens hit: ${this.queensHit}/${this.totalQueens}`);
                    // Add hole consumption effect
                    const consumeEffect = this.add.circle(queen.container.x, queen.container.y, 20, queen.color);
                    this.tweens.add({
                        targets: consumeEffect,
                        x: this.hole.x,
                        y: this.hole.y,
                        scale: 0.1,
                        alpha: 0,
                        duration: 300,
                        ease: 'Power2',
                        onComplete: ()=>{
                            consumeEffect.destroy();
                        }
                    });
                    // Add silver flash effect to the hole
                    const flash = this.add.circle(this.hole.x, this.hole.y, 35, 0xC0C0C0, 0.6);
                    this.tweens.add({
                        targets: flash,
                        alpha: 0,
                        scale: 1.5,
                        duration: 400,
                        onComplete: ()=>flash.destroy()
                    });
                    // Animate queen disappearing
                    this.tweens.add({
                        targets: queen.container,
                        alpha: 0,
                        scale: 0.1,
                        duration: 300,
                        onComplete: ()=>{
                            // Remove physics body after animation completes
                            if (queen.body) {
                                this.matter.world.remove(queen.body);
                                queen.body = null;
                            }
                            queen.container.destroy();
                        }
                    });
                    // Play sound effect
                    this.playSound('queenHit');
                    // Check if any active ball matches the queen's color
                    const matchingBall = this.balls.find((ball)=>ball.body && !ball.inHole && ball.color === queen.color);
                    // Only move hole if there's no color match
                    if (!matchingBall) {
                        // Apply a small impulse to the hole after consuming queen
                        const randomAngle = Math.random() * Math.PI * 2;
                        const impulseStrength = 5;
                        this.matter.body.setVelocity(this.holeBody, {
                            x: Math.cos(randomAngle) * impulseStrength,
                            y: Math.sin(randomAngle) * impulseStrength
                        });
                    }
                    // Show multi-slay message if applicable
                    if (this.queensHitThisFling >= 2) this.showSlayMessage(this.queensHitThisFling);
                    // Check for game win condition
                    if (this.queensHit === this.totalQueens) this.showGameOver(true);
                }
            }
        });
        // Check for game over condition - all balls gone and no queens hit
        const activeBallsCount = this.balls.filter((ball)=>ball.body !== null).length;
        if (!this.gameEnded && activeBallsCount === 0) {
            if (this.queensHit === 0) this.showGameOver(false); // Game Over - Lost
            else if (this.queensHit === this.totalQueens) this.showGameOver(true); // Game Over - Won
        }
        // Update rubber band if dragging
        if (this.isDragging && this.activeBall) {
            this.rubberBand.clear();
            this.rubberBand.lineStyle(2, 0xffffff);
            this.rubberBand.beginPath();
            this.rubberBand.moveTo(this.activeBall.graphics.x, this.activeBall.graphics.y);
            const dragPoint = this.constrainDragPoint(this.input.activePointer, {
                x: this.activeBall.graphics.x,
                y: this.activeBall.graphics.y
            });
            this.rubberBand.lineTo(dragPoint.x, dragPoint.y);
            this.rubberBand.strokePath();
        }
        // Check if balls have settled
        if (this.waitingForBallsToSettle) this.checkBallsSettled();
        // Check for ball collisions
        if (!this.lastBallHitTime) this.lastBallHitTime = 0;
        this.matter.world.on('collisionstart', (event)=>{
            event.pairs.forEach((pair)=>{
                const bodyA = pair.bodyA;
                const bodyB = pair.bodyB;
                // Ball-to-ball collision
                if (bodyA.label === 'Circle Body' && bodyB.label === 'Circle Body') {
                    const velocity = Math.sqrt(Math.pow(bodyA.velocity.x - bodyB.velocity.x, 2) + Math.pow(bodyA.velocity.y - bodyB.velocity.y, 2));
                    // Only play sound if enough time has passed since last hit (100ms minimum)
                    const currentTime = Date.now();
                    if (velocity > 1 && currentTime - this.lastBallHitTime > 100) {
                        this.playSound('ballHit');
                        this.lastBallHitTime = currentTime;
                    }
                }
            });
        });
    }
    resize(gameSize) {
        const oldWidth = this.gameWidth;
        const oldHeight = this.gameHeight;
        // Update game dimensions
        this.gameWidth = gameSize.width;
        this.gameHeight = gameSize.height;
        // Recalculate margins and play area
        const margin = Math.min(this.gameWidth, this.gameHeight) * 0.05;
        // Store existing game objects' positions relative to play area
        const gameObjects = [];
        if (this.matter && this.matter.world) {
            this.matter.world.localWorld.bodies.forEach((body)=>{
                if (body.label !== 'Rectangle Body') {
                    const relativeX = (body.position.x - margin) / (oldWidth - margin * 2);
                    const relativeY = (body.position.y - margin) / (oldHeight - margin * 2);
                    gameObjects.push({
                        body: body,
                        relativeX: relativeX,
                        relativeY: relativeY,
                        velocity: {
                            x: body.velocity.x,
                            y: body.velocity.y
                        },
                        isStatic: body.isStatic
                    });
                }
            });
            // Clear only the boundary bodies
            this.matter.world.localWorld.bodies = this.matter.world.localWorld.bodies.filter((body)=>body.label !== 'Rectangle Body');
            // Add new bounds with proper dimensions
            this.matter.world.setBounds(margin, margin, this.gameWidth - margin * 2, this.gameHeight - margin * 2, 32, {
                restitution: 0.8,
                friction: 0.05
            });
            // Reposition game objects in new play area
            gameObjects.forEach((obj)=>{
                const newX = margin + (this.gameWidth - margin * 2) * obj.relativeX;
                const newY = margin + (this.gameHeight - margin * 2) * obj.relativeY;
                this.matter.body.setPosition(obj.body, {
                    x: newX,
                    y: newY
                });
                // Restore velocity and static state
                if (!obj.isStatic) this.matter.body.setVelocity(obj.body, obj.velocity);
            });
        }
        // Update playfield graphics if they exist
        if (this.playfield) {
            this.playfield.clear();
            this.playfield.lineStyle(4, 0x2ecc71);
            this.playfield.strokeRect(margin, margin, this.gameWidth - margin * 2, this.gameHeight - margin * 2);
        }
        // Update hole position
        if (this.hole) {
            const holeY = margin + (this.gameHeight - margin * 2) * 0.2; // 20% from top
            this.hole.setPosition(this.gameWidth / 2, holeY);
            this.holeGlow.setPosition(this.gameWidth / 2, holeY);
            this.holeGlow2.setPosition(this.gameWidth / 2, holeY);
            this.holeRim.setPosition(this.gameWidth / 2, holeY);
        }
        // Update visual elements for balls
        this.balls.forEach((ball)=>{
            if (ball.body) {
                ball.graphics.setPosition(ball.body.position.x, ball.body.position.y);
                ball.glow.setPosition(ball.body.position.x, ball.body.position.y);
                if (ball.highlight) ball.highlight.setPosition(ball.body.position.x, ball.body.position.y);
            }
        });
        // Update visual elements for queens
        this.queens.forEach((queen)=>{
            if (queen.body && !queen.hit) queen.container.setPosition(queen.body.position.x, queen.body.position.y);
        });
        // Recalculate number of queens and play area
        this.calculatePlayAreaAndQueens();
        // Update UI positions
        if (this.scoreText) {
            this.scoreText.setPosition(16, 16);
            this.queensText.setPosition(16, 56);
            this.flingText.setPosition(16, 96);
        }
    }
    debugBallStates() {
        console.log('=== Ball States ===');
        this.balls.forEach((ball, index)=>{
            console.log(`Ball ${index}:`, {
                exists: !!ball.body,
                used: ball.used,
                inHole: ball.inHole,
                moving: ball.moving
            });
        });
        console.log('Current ball index:', this.currentBallIndex);
        console.log('Waiting for settle:', this.waitingForBallsToSettle);
    }
    playSound(type) {
        if (!this.soundEnabled || !this.audioContext) return;
        // Ensure audio context is running (needed for Chrome)
        if (this.audioContext.state === 'suspended') this.audioContext.resume();
        // Clean up any existing nodes
        if (this.currentGain) this.currentGain.disconnect();
        const now = this.audioContext.currentTime;
        const oscillator = this.audioContext.createOscillator();
        const gainNode = this.audioContext.createGain();
        // Store current nodes for cleanup
        this.currentOscillator = oscillator;
        this.currentGain = gainNode;
        gainNode.connect(this.masterGain);
        oscillator.connect(gainNode);
        switch(type){
            case 'nomNom':
                // Create a fun "nom nom" sound
                oscillator.type = 'sine';
                const nomDuration = 0.15;
                // First "nom"
                oscillator.frequency.setValueAtTime(300, now);
                oscillator.frequency.linearRampToValueAtTime(200, now + nomDuration * 0.5);
                gainNode.gain.setValueAtTime(0.3, now);
                gainNode.gain.linearRampToValueAtTime(0.01, now + nomDuration);
                // Second "nom"
                oscillator.frequency.setValueAtTime(250, now + nomDuration);
                oscillator.frequency.linearRampToValueAtTime(150, now + nomDuration * 1.5);
                gainNode.gain.setValueAtTime(0.3, now + nomDuration);
                gainNode.gain.linearRampToValueAtTime(0.01, now + nomDuration * 2);
                oscillator.start(now);
                oscillator.stop(now + nomDuration * 2);
                break;
            case 'gameOver':
                // Sad trombone sound
                oscillator.type = 'sawtooth';
                oscillator.frequency.setValueAtTime(440, now);
                oscillator.frequency.linearRampToValueAtTime(220, now + 0.3);
                oscillator.frequency.setValueAtTime(196, now + 0.4);
                oscillator.frequency.setValueAtTime(165, now + 0.6);
                gainNode.gain.setValueAtTime(0.3, now);
                gainNode.gain.linearRampToValueAtTime(0.01, now + 0.8);
                oscillator.start(now);
                oscillator.stop(now + 0.8);
                break;
            case 'multiSlay':
                // Achievement sound with ascending notes
                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(440, now);
                oscillator.frequency.setValueAtTime(880, now + 0.1);
                oscillator.frequency.setValueAtTime(1320, now + 0.2);
                gainNode.gain.setValueAtTime(0.3, now);
                gainNode.gain.linearRampToValueAtTime(0.01, now + 0.3);
                oscillator.start(now);
                oscillator.stop(now + 0.3);
                break;
            case 'queenHit':
                // Explosion-like sound
                oscillator.type = 'sawtooth';
                oscillator.frequency.setValueAtTime(440, now);
                oscillator.frequency.exponentialRampToValueAtTime(44, now + 0.3);
                gainNode.gain.setValueAtTime(0.3, now);
                gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.3);
                oscillator.start(now);
                oscillator.stop(now + 0.3);
                break;
            case 'ballHit':
                // Short click sound (previously ballHit sound)
                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(220, now);
                oscillator.frequency.exponentialRampToValueAtTime(880, now + 0.1);
                gainNode.gain.setValueAtTime(0.3, now);
                gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.1);
                oscillator.start(now);
                oscillator.stop(now + 0.1);
                break;
            case 'holeScore':
                // Score sound
                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(880, now);
                oscillator.frequency.exponentialRampToValueAtTime(1760, now + 0.1);
                gainNode.gain.setValueAtTime(0.2, now);
                gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.1);
                oscillator.start(now);
                oscillator.stop(now + 0.1);
                break;
            case 'bgMusic':
                // Simple background pattern
                const pattern = [
                    440,
                    554,
                    659,
                    554
                ];
                const duration = 0.2;
                pattern.forEach((freq, i)=>{
                    const noteOsc = this.audioContext.createOscillator();
                    const noteGain = this.audioContext.createGain();
                    noteOsc.connect(noteGain);
                    noteGain.connect(this.masterGain);
                    noteOsc.type = 'sine';
                    noteOsc.frequency.setValueAtTime(freq, now + i * duration);
                    noteGain.gain.setValueAtTime(0.1, now + i * duration);
                    noteGain.gain.exponentialRampToValueAtTime(0.01, now + (i + 1) * duration);
                    noteOsc.start(now + i * duration);
                    noteOsc.stop(now + (i + 1) * duration);
                });
                // Loop the pattern
                setTimeout(()=>{
                    if (!this.gameEnded) this.playSound('bgMusic');
                }, pattern.length * duration * 1000);
                break;
        }
        // Add cleanup handler for all non-bgMusic sounds
        if (type !== 'bgMusic') oscillator.onended = ()=>{
            oscillator.disconnect();
            gainNode.disconnect();
            this.currentOscillator = null;
            this.currentGain = null;
        };
    }
}
const $35da740d59af89ba$var$config = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).AUTO,
    scale: {
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scale.RESIZE,
        parent: 'game',
        width: '100%',
        height: '100%',
        autoCenter: (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scale.CENTER_BOTH,
        fullscreenTarget: 'game'
    },
    backgroundColor: '#000000',
    physics: {
        default: 'matter',
        matter: {
            gravity: {
                y: 0
            },
            debug: false,
            enableSleeping: false,
            positionIterations: 10,
            velocityIterations: 8,
            constraintIterations: 4
        }
    },
    input: {
        activePointers: 2,
        touch: {
            capture: true,
            dragDistanceThreshold: 2
        }
    },
    scene: $35da740d59af89ba$var$MainScene
};
const $35da740d59af89ba$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Game($35da740d59af89ba$var$config);
// Handle mobile touch events
if ($35da740d59af89ba$var$game.device.os.android || $35da740d59af89ba$var$game.device.os.iOS) {
    // Handle orientation changes
    window.addEventListener('orientationchange', ()=>{
        setTimeout(()=>{
            $35da740d59af89ba$var$game.scale.refresh();
        }, 100);
    });
    // Prevent default touch behaviors
    document.addEventListener('touchmove', (e)=>{
        e.preventDefault();
    }, {
        passive: false
    });
    // Prevent double tap zoom
    let lastTap = 0;
    document.addEventListener('touchend', (e)=>{
        const currentTime = new Date().getTime();
        const tapLength = currentTime - lastTap;
        if (tapLength < 500 && tapLength > 0) e.preventDefault();
        lastTap = currentTime;
    });
}


//# sourceMappingURL=repo.b0b837ca.js.map
